webpackJsonp([462],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAcNJREFUeNrElc0rRFEYxu+MYSwIC9MoJR8jNSEs2LBQmrKQbK0sECVLZWUjfwIrZacIkfI1C2Wn2GChlBqlIQsyPhrmeN56j063c+6cmZKnfvfjfPTc97zvOdcnhHCgGnAEEsDn5K4MqAVTYFftCPA9BG5Bn5O/VkC1u9Hv/LFkBEFQbhhj+gjBSNH8EpMBqdDDQJeXb5dBQDdOGqRBysPAb0isqjfwbgr/y8PAVmTw+W9J9tIYiLrWmz5sDcTzNaBNcw8+wBY4dBlQMh9cc6hICmwNqOQ6wSroB02aCMj4WGk7A9e2Buegi3d4nCe7I0go7z2c5GAuOdgG3Rx6i8aAzpwkmAezSt8yGP0tYzrsQAc44GeVYVChaZdEhV69cky2MqU1jnn0Nxrao7b74I53+aCh/9K1dGoOrTdaGGyCCU0fVc0keOL3FzAHTnRJzhgM9sErWAA7HJVUKSjmhKe5IOheCR7VJIfABqgHEaaB28vANCdvnceHwTi4UBKbVp5vQCuN9eHSBp9mMGQ4lmmNF3kpBsApiHj8P6Ron7TT1yyJ7EqCGHjm95Sw0wxFQD/8Kosz6wrUgSKOdsSiQPZ+BBgAOt5ReFfc88UAAAAASUVORK5CYII="

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAWlJREFUeNqU1D0vBFEUxvF711KRCKGQTQhRCIloUOrQKLbQ0AghkUj4ACs6lW00GtEgUSlU+wFEp9lCZCXeGi9RaBAbxv/GQ+7G7Iw5yW+zszNz7rlnzqwNgsBYa/PGmClYUz0C3GAbWxUnXA4leuZ4BmchNxst0IwCUtjDnJ/o+8OYR3Sa6GjELUZxjZ2wRA/oCbk5h03UoUXX1aMB58j/JErFVDGAshJ9oknb2sA9VjBmtN+oeEI3XmQdd7qvqKqy7sJ0TKJTTKqaV23VD/cEM/+p6F0V1VY577b8EZfIVTuOC6zFLBiZKKt+jGBI22pHL/pQ481ZZI+WsY9Zzc0E5tWvoobzLSyR9fa9qhXdoy/hSDPUpYHM6In1V7wnushNdgcOddxq4mPXLeIPpFu5DQcYxIKSxcWfHln9eIJjVZUo0l5fLtXgJFFWLyuavYSrhImGNf2//0fTfF9UZUnCDWuOHKUvAQYAMhlsNGYHe4UAAAAASUVORK5CYII="

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABA9JREFUeNqsVttvFFUc/s5lbntvu/TKokUpkCpKtCQlFjE+iIgPYKIx+i/4Ynzzr9AXE33ykZh4iQYJhoQ+iFGUGtIa46WUQLvd3kt3ZnZ3Zs7xN7PbjSDYVjnJXHbOOd/3/a5n2StvvnUjaAQAY3hQI0aSlolAWu9J03T2OE6GPmk8yNEIQqhQ9ctjx0bw6ukTyUch+P8kYggI2PNq+OCjs/j1t2lXGlLCNCW+v3IN1aqXLNOaJXZypndEFwYRHtlbwp5SH4llyV4ZT0RRhE+/uIjp6zcpFAK5TIQwZHBrHIJvn6Lq+njjtZcw+NBAKxItgnhYpglh2Hj5qI8zYxuo+hwfflXA5HULlrE9kihSMAx5xzfenlRALqUwdshHMa8wONDAyIEaDMESNYxt77p7tAk4vfnkkoVVAUZuURGjd5kQ3yuDKTzgSifPfxtteziBEBY+Pp/H5IyFqscx8bsNKf+JwGnhWl5irt/Cvj88mIFGxLcgSNKUFq0T8MWf0i2rNKRS0MSuW2aIiIKZEZgazmA9L1C3GYanXFh1tTXBJslmLbBIo9qTgr3WgKAUjN3hOwKTj2WwkRUwSHml20JEm4Ynq+Cevn8M7vSvBg81locKmH6+hLkj3YkVDYMReBqrBUmW6JZFGotdBiYOkUVpkbiPgd3fAqaaGytPdKH8ZBFKciwN5RPCFdfFUqfRBk+yj14ZzXlFA38+lcV6JgblbRJ5N7iyBcqHi1g82NmyJJGEpf0FqFUD1oaLQDS3x+BZQjhYAHZZVPXdacxYt3CpfAWKUewa+m9ZRPkYpiTKo31Y2ZtLFLf7hG7eZD6NjjiDXA++AIo28FwPI/DmEkUtJtQruFAZh35UoJgptAhI+UIKmHxmF9zdDni9fu/8jvtTziQxAaTvY3TAQJHAaySuw85jtPcwzs1cStaxAYVCv/NOk4BSsO/ZYYw5EaXlFg013lzg0G4FeatC4BG8sI68zqKU7oUfNcU51HYo4ikZl7eTsvHu08ehScl2jh1TmPhm/lucn72Jh7O7MdL9OBxpoyfVhdf3nUKgAozP/gA39CGvTvyChYVlaLX9rskUx+3+dfCSIPU1zFYrKNg5lDJ9mPcWiSBEg9wYp4Isl5c/n51d3NGxoqnAuo5nXiwMpq3V+jouVybQn+7G/vwgLs9PJC6WXDSPTs7ZaU4/dnLgRjXKqKw4STifkMqU5BI1isPVpamkAjjfrF92ge/0UIxcUv+Cid5T/Fx6KChTh4xi0I3Aw3dzP0JqlajQXG2EsvG13CmBDgGji8HqBOo1fYAITlIbeVvoyLlt544obszl/bVrZN0ZzXRd/pf/JDpqZTLVJt2/pOtnqYLirY7SZ64svH/0xvjZmjD9eMlfAgwAmJmkQeE47RkAAAAASUVORK5CYII="

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAaFJREFUeNrMlE8oBGEUwGe23fXfQf5Eqzg4uBCllIP8uSgHNzdydXFbZ+XguMpBnFBqXVwUOYhVDo4OK0oruXBQRNi1O35veqNRs5ndvXj1a9438+Z9773vvc+0LMvwkttwUwuPDegFMdqBubb0Q8bLPmjkl3UwoQfqYQ/uYMnL2JSI2H0EfRxqIAvlMAX7cK3vxqAdNnWDADzCFlFemqlQo/ywBifwogaSyqs6DOmm75CDKl2L8wh0wKg4SqJs43XRKELI5pDHfUDDNI3ixfYhEU2jrMBRgU6zWtNuOzUtdlRPY1UN/nImNWyASRikLAnn+G8EXswWUJtWiQRSTn4iYdH5GCygNtUaedjtqGQJeOQuYcdhWPUYzKgehQU/I+IM3gAcqN4HH6p3Qa2fiByRH79U/wRnUNO69u2o5Br9X0eVroOocHoFKdMbIe+p2VcHnZ3T9S5cqS6nl1Q94bpGMr9mU2aNwR2CN4jI2g/YTsAz1MnaiegMTuGchrtw9ZPpoVuaaj8sk8XTz1WrXdvMYx46fdRWSnAMMRzZffUtwABQJKDSMP7IjQAAAABJRU5ErkJggg=="

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(0)(module)))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAABJlBMVEUAAAAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwBIvth5AAAAYnRSTlMAEzEzO/rg2vMmokAtu8HLszato2iU0kU8P0IeS8eY9tz5d5nFDCzXeAIBMufIGGL/8jTpzRkFCRQEeu1cmn8H8esWcfh0iNgDV/z+h1Aq26sQe1jKRwvG5d6XsT01gjp1jSv24csAAADzSURBVHicY2AgFzAyMWMAiAwLKxs7GuCAyHBycfOgAV6QOB8/BhAQFALJcAiLoAFRMXEhBglJSXEpSVQgLSMLlJGTV0Czm01RCSyjrKKK5gU1dQ24jKYWDhltHV097DL6Boba2GWMjE1McdhjpgkRMxexQJNhYLAESZhZWdugy5jb2tkzMGg4GDg6ock4u8i7MogbGhgYuKlCZETcQTIenl4GBt4+bEAJA0NfiIyGCkjGzx8k5u0NIg0CAtXUg4JDQsOAMnrhEUgg0llbPSo6JIYBKCMtgwJijdTj4qWAzldmC0pABYnGGmDf2ShjglD86QkAWNE8LUllN50AAAAASUVORK5CYII="

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABA9JREFUeNqsVttvFFUc/s5lbntvu/TKokUpkCpKtCQlFjE+iIgPYKIx+i/4Ynzzr9AXE33ykZh4iQYJhoQ+iFGUGtIa46WUQLvd3kt3ZnZ3Zs7xN7PbjSDYVjnJXHbOOd/3/a5n2StvvnUjaAQAY3hQI0aSlolAWu9J03T2OE6GPmk8yNEIQqhQ9ctjx0bw6ukTyUch+P8kYggI2PNq+OCjs/j1t2lXGlLCNCW+v3IN1aqXLNOaJXZypndEFwYRHtlbwp5SH4llyV4ZT0RRhE+/uIjp6zcpFAK5TIQwZHBrHIJvn6Lq+njjtZcw+NBAKxItgnhYpglh2Hj5qI8zYxuo+hwfflXA5HULlrE9kihSMAx5xzfenlRALqUwdshHMa8wONDAyIEaDMESNYxt77p7tAk4vfnkkoVVAUZuURGjd5kQ3yuDKTzgSifPfxtteziBEBY+Pp/H5IyFqscx8bsNKf+JwGnhWl5irt/Cvj88mIFGxLcgSNKUFq0T8MWf0i2rNKRS0MSuW2aIiIKZEZgazmA9L1C3GYanXFh1tTXBJslmLbBIo9qTgr3WgKAUjN3hOwKTj2WwkRUwSHml20JEm4Ynq+Cevn8M7vSvBg81locKmH6+hLkj3YkVDYMReBqrBUmW6JZFGotdBiYOkUVpkbiPgd3fAqaaGytPdKH8ZBFKciwN5RPCFdfFUqfRBk+yj14ZzXlFA38+lcV6JgblbRJ5N7iyBcqHi1g82NmyJJGEpf0FqFUD1oaLQDS3x+BZQjhYAHZZVPXdacxYt3CpfAWKUewa+m9ZRPkYpiTKo31Y2ZtLFLf7hG7eZD6NjjiDXA++AIo28FwPI/DmEkUtJtQruFAZh35UoJgptAhI+UIKmHxmF9zdDni9fu/8jvtTziQxAaTvY3TAQJHAaySuw85jtPcwzs1cStaxAYVCv/NOk4BSsO/ZYYw5EaXlFg013lzg0G4FeatC4BG8sI68zqKU7oUfNcU51HYo4ikZl7eTsvHu08ehScl2jh1TmPhm/lucn72Jh7O7MdL9OBxpoyfVhdf3nUKgAozP/gA39CGvTvyChYVlaLX9rskUx+3+dfCSIPU1zFYrKNg5lDJ9mPcWiSBEg9wYp4Isl5c/n51d3NGxoqnAuo5nXiwMpq3V+jouVybQn+7G/vwgLs9PJC6WXDSPTs7ZaU4/dnLgRjXKqKw4STifkMqU5BI1isPVpamkAjjfrF92ge/0UIxcUv+Cid5T/Fx6KChTh4xi0I3Aw3dzP0JqlajQXG2EsvG13CmBDgGji8HqBOo1fYAITlIbeVvoyLlt544obszl/bVrZN0ZzXRd/pf/JDpqZTLVJt2/pOtnqYLirY7SZ64svH/0xvjZmjD9eMlfAgwAmJmkQeE47RkAAAAASUVORK5CYII="

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.cs-popup{min-width:80%}.image-container{padding:10px;margin:5px}.image-container img{padding:3px;border:1px solid #021a40}.image-view{height:100px;width:130px;margin-right:12px}</style> <md-dialog class=cs-popup layout=column flex aria-label=\"CSV Upload\" ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>{{title}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancelDialog()> <i class=\"fas fa-times\"></i> </md-button> </div> </md-toolbar> <md-dialog-content layout-padding> <div layout=row ng-if=\"imageArray.length > 0\" layout-wrap> <div ng-repeat=\"img in imageArray track by $index\" flex=20 class=image-container layout=row> <img flex class=image-view ng-src=\"{{fileUrl + img}}\"> <div flex=5 layout=row layout-align=\"end start\" ng-hide=isPassage> <img src=" + __webpack_require__(174) + " ng-click=deleteImage($index) style=position:relative;left:4px> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = "<style>.cs-popup{min-width:80%}.image-container{padding:10px;margin:5px}.image-container img{padding:3px;border:1px solid #021a40}.image-view{height:100px;width:130px;margin-right:12px}</style> <md-dialog class=cs-popup layout=column flex aria-label=\"CSV Upload\" ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <span>Passage</span> <span flex></span> <md-button class=md-icon-button ng-click=cancelPassage()> <i class=\"fas fa-times\" style=color:#fff></i> </md-button> </div> </md-toolbar> <md-dialog-content layout-padding> <div layout=column class=md-whiteframe-3dp ng-repeat=\"passage in passages\" layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{passage.passage_title}}</div> <md-checkbox ng-model=passage.isSelected ng-change=selectPassage(passage._id) aria-label=\"select passage\" flex=5 style=margin:0></md-checkbox> </div> <div class=\"passage-desc composed_dom\" ng-bind-html=passage.passage_desc flex></div> <div ng-if=\"passage.passage_image && !isArray(passage.passage_image)\" class=image-container> <img src=\"{{fileUrl + passage.passage_image}}\" class=image-view> </div> <div ng-if=\"passage.passage_image && isArray(passage.passage_image)\" layout=row layout-wrap> <div ng-repeat=\"qnImage in passage.passage_image track by $index\" flex=20 class=image-container layout=row> <img src=\"{{fileUrl + qnImage}}\" class=image-view> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAMAAADzN3VRAAABJlBMVEUAAAAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwAsjwBIvth5AAAAYnRSTlMAEzEzO/rg2vMmokAtu8HLszato2iU0kU8P0IeS8eY9tz5d5nFDCzXeAIBMufIGGL/8jTpzRkFCRQEeu1cmn8H8esWcfh0iNgDV/z+h1Aq26sQe1jKRwvG5d6XsT01gjp1jSv24csAAADzSURBVHicY2AgFzAyMWMAiAwLKxs7GuCAyHBycfOgAV6QOB8/BhAQFALJcAiLoAFRMXEhBglJSXEpSVQgLSMLlJGTV0Czm01RCSyjrKKK5gU1dQ24jKYWDhltHV097DL6Boba2GWMjE1McdhjpgkRMxexQJNhYLAESZhZWdugy5jb2tkzMGg4GDg6ock4u8i7MogbGhgYuKlCZETcQTIenl4GBt4+bEAJA0NfiIyGCkjGzx8k5u0NIg0CAtXUg4JDQsOAMnrhEUgg0llbPSo6JIYBKCMtgwJijdTj4qWAzldmC0pABYnGGmDf2ShjglD86QkAWNE8LUllN50AAAAASUVORK5CYII="

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAVCAMAAACXIvXeAAABI1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9FvXt4AAAAYXRSTlMASOH/QRr3mEOb8BIBXKChxqiUxFSG0s/LwM1z+4GZ/fqRBwKm+XHk6+Niknx/9nSJ4GaLzgXiaUcIRgQNTT4JPSElOiJEQEJJI0WNzDc7IPwzaoTcJCZnLMFvY2vHK66iTZN2MwAAAOdJREFUeJxjYAADRiZmJhYGJMDKxs7BycUN4fDw8vHzCzALCgkyC/Pz84kwMIgyi4mLS0hKiUtJSoiLizFLM8jIImtnkJNnUFBUUkYAJRVVBjUFdQ0E0GTTYmDQ1tCBA109faBOAwkkYwyNgISxCULA1MwcIqJkYWppZW1ja2oNE7GTsXdgdnRidmaAiTCyKbEwu7gwu8JFrPSU3EAi7iSJeKgCzfF0YfaCiHj7MPhyWfox+zsGBDIwBQFFgkMYGBwZGEIZGMIYrDXCgSIRAZFR0TFBWkFBWlGxAXEgp3uoxMNAghcDAwCOqCuM4iaedwAAAABJRU5ErkJggg=="

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var keys = __webpack_require__(874);
var hasBinary = __webpack_require__(229);
var sliceBuffer = __webpack_require__(876);
var after = __webpack_require__(877);
var utf8 = __webpack_require__(878);

var base64encoder;
if (typeof ArrayBuffer !== 'undefined') {
  base64encoder = __webpack_require__(879);
}

/**
 * Check if we are running an android browser. That requires us to use
 * ArrayBuffer with polling transports...
 *
 * http://ghinda.net/jpeg-blob-ajax-android/
 */

var isAndroid = typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);

/**
 * Check if we are running in PhantomJS.
 * Uploading a Blob with PhantomJS does not work correctly, as reported here:
 * https://github.com/ariya/phantomjs/issues/11395
 * @type boolean
 */
var isPhantomJS = typeof navigator !== 'undefined' && /PhantomJS/i.test(navigator.userAgent);

/**
 * When true, avoids using Blobs to encode payloads.
 * @type boolean
 */
var dontSendBlobs = isAndroid || isPhantomJS;

/**
 * Current protocol version.
 */

exports.protocol = 3;

/**
 * Packet types.
 */

var packets = exports.packets = {
    open:     0    // non-ws
  , close:    1    // non-ws
  , ping:     2
  , pong:     3
  , message:  4
  , upgrade:  5
  , noop:     6
};

var packetslist = keys(packets);

/**
 * Premade error packet.
 */

var err = { type: 'error', data: 'parser error' };

/**
 * Create a blob api even for blob builder when vendor prefixes exist
 */

var Blob = __webpack_require__(880);

/**
 * Encodes a packet.
 *
 *     <packet type id> [ <data> ]
 *
 * Example:
 *
 *     5hello world
 *     3
 *     4
 *
 * Binary is encoded in an identical principle
 *
 * @api private
 */

exports.encodePacket = function (packet, supportsBinary, utf8encode, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = false;
  }

  if (typeof utf8encode === 'function') {
    callback = utf8encode;
    utf8encode = null;
  }

  var data = (packet.data === undefined)
    ? undefined
    : packet.data.buffer || packet.data;

  if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) {
    return encodeArrayBuffer(packet, supportsBinary, callback);
  } else if (typeof Blob !== 'undefined' && data instanceof Blob) {
    return encodeBlob(packet, supportsBinary, callback);
  }

  // might be an object with { base64: true, data: dataAsBase64String }
  if (data && data.base64) {
    return encodeBase64Object(packet, callback);
  }

  // Sending data as a utf-8 string
  var encoded = packets[packet.type];

  // data fragment is optional
  if (undefined !== packet.data) {
    encoded += utf8encode ? utf8.encode(String(packet.data), { strict: false }) : String(packet.data);
  }

  return callback('' + encoded);

};

function encodeBase64Object(packet, callback) {
  // packet data is an object { base64: true, data: dataAsBase64String }
  var message = 'b' + exports.packets[packet.type] + packet.data.data;
  return callback(message);
}

/**
 * Encode packet helpers for binary types
 */

function encodeArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var data = packet.data;
  var contentArray = new Uint8Array(data);
  var resultBuffer = new Uint8Array(1 + data.byteLength);

  resultBuffer[0] = packets[packet.type];
  for (var i = 0; i < contentArray.length; i++) {
    resultBuffer[i+1] = contentArray[i];
  }

  return callback(resultBuffer.buffer);
}

function encodeBlobAsArrayBuffer(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  var fr = new FileReader();
  fr.onload = function() {
    exports.encodePacket({ type: packet.type, data: fr.result }, supportsBinary, true, callback);
  };
  return fr.readAsArrayBuffer(packet.data);
}

function encodeBlob(packet, supportsBinary, callback) {
  if (!supportsBinary) {
    return exports.encodeBase64Packet(packet, callback);
  }

  if (dontSendBlobs) {
    return encodeBlobAsArrayBuffer(packet, supportsBinary, callback);
  }

  var length = new Uint8Array(1);
  length[0] = packets[packet.type];
  var blob = new Blob([length.buffer, packet.data]);

  return callback(blob);
}

/**
 * Encodes a packet with binary data in a base64 string
 *
 * @param {Object} packet, has `type` and `data`
 * @return {String} base64 encoded message
 */

exports.encodeBase64Packet = function(packet, callback) {
  var message = 'b' + exports.packets[packet.type];
  if (typeof Blob !== 'undefined' && packet.data instanceof Blob) {
    var fr = new FileReader();
    fr.onload = function() {
      var b64 = fr.result.split(',')[1];
      callback(message + b64);
    };
    return fr.readAsDataURL(packet.data);
  }

  var b64data;
  try {
    b64data = String.fromCharCode.apply(null, new Uint8Array(packet.data));
  } catch (e) {
    // iPhone Safari doesn't let you apply with typed arrays
    var typed = new Uint8Array(packet.data);
    var basic = new Array(typed.length);
    for (var i = 0; i < typed.length; i++) {
      basic[i] = typed[i];
    }
    b64data = String.fromCharCode.apply(null, basic);
  }
  message += btoa(b64data);
  return callback(message);
};

/**
 * Decodes a packet. Changes format to Blob if requested.
 *
 * @return {Object} with `type` and `data` (if any)
 * @api private
 */

exports.decodePacket = function (data, binaryType, utf8decode) {
  if (data === undefined) {
    return err;
  }
  // String data
  if (typeof data === 'string') {
    if (data.charAt(0) === 'b') {
      return exports.decodeBase64Packet(data.substr(1), binaryType);
    }

    if (utf8decode) {
      data = tryDecode(data);
      if (data === false) {
        return err;
      }
    }
    var type = data.charAt(0);

    if (Number(type) != type || !packetslist[type]) {
      return err;
    }

    if (data.length > 1) {
      return { type: packetslist[type], data: data.substring(1) };
    } else {
      return { type: packetslist[type] };
    }
  }

  var asArray = new Uint8Array(data);
  var type = asArray[0];
  var rest = sliceBuffer(data, 1);
  if (Blob && binaryType === 'blob') {
    rest = new Blob([rest]);
  }
  return { type: packetslist[type], data: rest };
};

function tryDecode(data) {
  try {
    data = utf8.decode(data, { strict: false });
  } catch (e) {
    return false;
  }
  return data;
}

/**
 * Decodes a packet encoded in a base64 string
 *
 * @param {String} base64 encoded message
 * @return {Object} with `type` and `data` (if any)
 */

exports.decodeBase64Packet = function(msg, binaryType) {
  var type = packetslist[msg.charAt(0)];
  if (!base64encoder) {
    return { type: type, data: { base64: true, data: msg.substr(1) } };
  }

  var data = base64encoder.decode(msg.substr(1));

  if (binaryType === 'blob' && Blob) {
    data = new Blob([data]);
  }

  return { type: type, data: data };
};

/**
 * Encodes multiple messages (payload).
 *
 *     <length>:data
 *
 * Example:
 *
 *     11:hello world2:hi
 *
 * If any contents are binary, they will be encoded as base64 strings. Base64
 * encoded strings are marked with a b before the length specifier
 *
 * @param {Array} packets
 * @api private
 */

exports.encodePayload = function (packets, supportsBinary, callback) {
  if (typeof supportsBinary === 'function') {
    callback = supportsBinary;
    supportsBinary = null;
  }

  var isBinary = hasBinary(packets);

  if (supportsBinary && isBinary) {
    if (Blob && !dontSendBlobs) {
      return exports.encodePayloadAsBlob(packets, callback);
    }

    return exports.encodePayloadAsArrayBuffer(packets, callback);
  }

  if (!packets.length) {
    return callback('0:');
  }

  function setLengthHeader(message) {
    return message.length + ':' + message;
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, !isBinary ? false : supportsBinary, false, function(message) {
      doneCallback(null, setLengthHeader(message));
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(results.join(''));
  });
};

/**
 * Async array map using after
 */

function map(ary, each, done) {
  var result = new Array(ary.length);
  var next = after(ary.length, done);

  var eachWithIndex = function(i, el, cb) {
    each(el, function(error, msg) {
      result[i] = msg;
      cb(error, result);
    });
  };

  for (var i = 0; i < ary.length; i++) {
    eachWithIndex(i, ary[i], next);
  }
}

/*
 * Decodes data when a payload is maybe expected. Possible binary contents are
 * decoded from their base64 representation
 *
 * @param {String} data, callback method
 * @api public
 */

exports.decodePayload = function (data, binaryType, callback) {
  if (typeof data !== 'string') {
    return exports.decodePayloadAsBinary(data, binaryType, callback);
  }

  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var packet;
  if (data === '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

  var length = '', n, msg;

  for (var i = 0, l = data.length; i < l; i++) {
    var chr = data.charAt(i);

    if (chr !== ':') {
      length += chr;
      continue;
    }

    if (length === '' || (length != (n = Number(length)))) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    msg = data.substr(i + 1, n);

    if (length != msg.length) {
      // parser error - ignoring payload
      return callback(err, 0, 1);
    }

    if (msg.length) {
      packet = exports.decodePacket(msg, binaryType, false);

      if (err.type === packet.type && err.data === packet.data) {
        // parser error in individual packet - ignoring payload
        return callback(err, 0, 1);
      }

      var ret = callback(packet, i + n, l);
      if (false === ret) return;
    }

    // advance cursor
    i += n;
    length = '';
  }

  if (length !== '') {
    // parser error - ignoring payload
    return callback(err, 0, 1);
  }

};

/**
 * Encodes multiple messages (payload) as binary.
 *
 * <1 = binary, 0 = string><number from 0-9><number from 0-9>[...]<number
 * 255><data>
 *
 * Example:
 * 1 3 255 1 2 3, if the binary contents are interpreted as 8 bit integers
 *
 * @param {Array} packets
 * @return {ArrayBuffer} encoded payload
 * @api private
 */

exports.encodePayloadAsArrayBuffer = function(packets, callback) {
  if (!packets.length) {
    return callback(new ArrayBuffer(0));
  }

  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(data) {
      return doneCallback(null, data);
    });
  }

  map(packets, encodeOne, function(err, encodedPackets) {
    var totalLength = encodedPackets.reduce(function(acc, p) {
      var len;
      if (typeof p === 'string'){
        len = p.length;
      } else {
        len = p.byteLength;
      }
      return acc + len.toString().length + len + 2; // string/binary identifier + separator = 2
    }, 0);

    var resultArray = new Uint8Array(totalLength);

    var bufferIndex = 0;
    encodedPackets.forEach(function(p) {
      var isString = typeof p === 'string';
      var ab = p;
      if (isString) {
        var view = new Uint8Array(p.length);
        for (var i = 0; i < p.length; i++) {
          view[i] = p.charCodeAt(i);
        }
        ab = view.buffer;
      }

      if (isString) { // not true binary
        resultArray[bufferIndex++] = 0;
      } else { // true binary
        resultArray[bufferIndex++] = 1;
      }

      var lenStr = ab.byteLength.toString();
      for (var i = 0; i < lenStr.length; i++) {
        resultArray[bufferIndex++] = parseInt(lenStr[i]);
      }
      resultArray[bufferIndex++] = 255;

      var view = new Uint8Array(ab);
      for (var i = 0; i < view.length; i++) {
        resultArray[bufferIndex++] = view[i];
      }
    });

    return callback(resultArray.buffer);
  });
};

/**
 * Encode as Blob
 */

exports.encodePayloadAsBlob = function(packets, callback) {
  function encodeOne(packet, doneCallback) {
    exports.encodePacket(packet, true, true, function(encoded) {
      var binaryIdentifier = new Uint8Array(1);
      binaryIdentifier[0] = 1;
      if (typeof encoded === 'string') {
        var view = new Uint8Array(encoded.length);
        for (var i = 0; i < encoded.length; i++) {
          view[i] = encoded.charCodeAt(i);
        }
        encoded = view.buffer;
        binaryIdentifier[0] = 0;
      }

      var len = (encoded instanceof ArrayBuffer)
        ? encoded.byteLength
        : encoded.size;

      var lenStr = len.toString();
      var lengthAry = new Uint8Array(lenStr.length + 1);
      for (var i = 0; i < lenStr.length; i++) {
        lengthAry[i] = parseInt(lenStr[i]);
      }
      lengthAry[lenStr.length] = 255;

      if (Blob) {
        var blob = new Blob([binaryIdentifier.buffer, lengthAry.buffer, encoded]);
        doneCallback(null, blob);
      }
    });
  }

  map(packets, encodeOne, function(err, results) {
    return callback(new Blob(results));
  });
};

/*
 * Decodes data when a payload is maybe expected. Strings are decoded by
 * interpreting each byte as a key code for entries marked to start with 0. See
 * description of encodePayloadAsBinary
 *
 * @param {ArrayBuffer} data, callback method
 * @api public
 */

exports.decodePayloadAsBinary = function (data, binaryType, callback) {
  if (typeof binaryType === 'function') {
    callback = binaryType;
    binaryType = null;
  }

  var bufferTail = data;
  var buffers = [];

  while (bufferTail.byteLength > 0) {
    var tailArray = new Uint8Array(bufferTail);
    var isString = tailArray[0] === 0;
    var msgLength = '';

    for (var i = 1; ; i++) {
      if (tailArray[i] === 255) break;

      // 310 = char length of Number.MAX_VALUE
      if (msgLength.length > 310) {
        return callback(err, 0, 1);
      }

      msgLength += tailArray[i];
    }

    bufferTail = sliceBuffer(bufferTail, 2 + msgLength.length);
    msgLength = parseInt(msgLength);

    var msg = sliceBuffer(bufferTail, 0, msgLength);
    if (isString) {
      try {
        msg = String.fromCharCode.apply(null, new Uint8Array(msg));
      } catch (e) {
        // iPhone Safari doesn't let you apply to typed arrays
        var typed = new Uint8Array(msg);
        msg = '';
        for (var i = 0; i < typed.length; i++) {
          msg += String.fromCharCode(typed[i]);
        }
      }
    }

    buffers.push(msg);
    bufferTail = sliceBuffer(bufferTail, msgLength);
  }

  var total = buffers.length;
  buffers.forEach(function(buffer, i) {
    callback(exports.decodePacket(buffer, binaryType, true), i, total);
  });
};


/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAXZJREFUeNrk1L8rxHEcx3Ff1HGKK3IkkmSwsB2Dy2AzSIqBTCdsNiWTZPAXuLqRkMXgx4jNYmOldFISEcOhO8+3Xl+d+tyd4QblU4++fT/3fb+/n+/n/f6cl8lkSoo5SkuKPP5+wvICv0cwixTeUI89XGIUtUjg+DvCipJDJzYwDU9zPdjEmO4nsIOIH5f9yTGx4aEfScTtvZo/xTb6UIN1nCGqmB8JW8VGUAF3jm2wuVc06P5G1wp/D21VbVqRjRVc4QktjoR1euGt7hv1Bal8VbYHDtCEGZRlFWkSJ3jGOHpwiLS/woQeXtZ1UfODWuE9qvGIZoSU5AJhVXoA118vyapqTAKYxxaijuqHsIBddUI71hBH2HOc5REMYRXneXp0Cr2Y0/4t2dW1h104KpDMxr6q3a2E1vCluYry/otTZp/2oor7MQ+uoxdAlQqT62h+KFFQnWJNXWlxroCkqtjhd79jpJUsoMa2bRq23vX+3x/spwADAF46xIv19AvhAAAAAElFTkSuQmCC"

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.btn,.btn-large{color:#424242!important;background-color:#d6dff5!important;height:30px;width:46px;margin:0 2px}.popup-header-color{background:#00b6f2!important;color:#fff;padding:5px}.dialog-content{width:100%}.ta-scroll-window.form-control{border:1px solid #ccc;border-radius:4px}</style> <md-dialog class=dialog-content> <md-toolbar> <div class=\"md-toolbar-tools popup-header-color\"> <h2 class=popup-head>Add detail</h2> <span flex></span> <div style=cursor:pointer;outline:0 flex=5 ng-click=\"saveContent( 'editor.desc')\"> <i class=\"far fa-save\"></i> </div> <div style=cursor:pointer;outline:0 flex=5 ng-click=closeEditor()> <i class=\"fas fa-times\"></i> </div> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content style=\"border:1px solid #ccc\"> <textarea id=editor ng-model=editor.desc value=editor.desc autofocus></textarea> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(863);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 72 */
/***/ (function(module, exports) {

/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */

exports.encode = function (obj) {
  var str = '';

  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (str.length) str += '&';
      str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
  }

  return str;
};

/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */

exports.decode = function(qs){
  var qry = {};
  var pairs = qs.split('&');
  for (var i = 0, l = pairs.length; i < l; i++) {
    var pair = pairs[i].split('=');
    qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return qry;
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {


module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(881);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMVJREFUeNpi/P//PwM6kDh2XwtILQLif0Cc8sJK8RIDFsDEgB3oA7ExEJsCcSUONTg1I4sbA13CTIrmKCT2N6Cz/xKlGWhLEJDyQhK6hMvZjMgBBtSoAKROArEYkponUMwI5cM0LGYBaugFMpRAoQrEdWgaQUAGitHBaxYgkQvErEAMMkSEgXjwHeTnr0jO+UOCZpyhTZReSjS/IFfzFyCexgQNLAZoVLAQqbkDmHCugxS/BGIBIP4BZb8joPE+NGYYAAIMACjqL9d66VQvAAAAAElFTkSuQmCC"

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<div class=loading-progress> <md-progress-linear ng-show=isLoading md-mode=indeterminate></md-progress-linear> <span flex ng-if=isLoading>{{loadingMsg}}</span> </div> <div layout-padding class=activity style=background:#fff ng-hide=isHideCreateSection> <div class=md-whiteframe-2dp layout=column> <div class=questionTitle layout=row layout-align=space-between ng-if=!isTpActivityQuestion> <div flex=45 ng-if=isTActivityQuestion> <b>Question Paper Title: </b>{{qp_title}} </div> <div flex=45 ng-if=isArchiveQuestion> <b>Question</b> </div> </div> <div class=quesBox layout=row layout-align=\"space-between center\"> <md-input-container class=quesType flex=40 ng-show=\"isTActivityQuestion || isTpActivityQuestion\"> <label>Select Question Type</label> <md-select flex ng-model=question_type placeholder=\"Select Question Type\" ng-disabled=isEditQuestion> <md-option ng-repeat=\"quesType in questionTypeList\" value={{quesType._id}} ng-show=\"!isPractice || (isPractice && quesType.isPractice)\"> {{quesType.name}} </md-option> </md-select> </md-input-container> <md-input-container flex> <mcq-bulk-upload ng-if=\"question_type=='MCQ' && !isEditQuestion\" flex=100 layout=row></mcq-bulk-upload> <tf-bulk-upload ng-if=\"question_type=='TF' && !isEditQuestion\" flex=100 layout=row></tf-bulk-upload> <fib-bulk-upload ng-if=\"question_type=='FIB' && !isEditQuestion\" flex=100 layout=row></fib-bulk-upload> <match-bulk-upload ng-if=\"question_type=='MTF' && !isEditQuestion\" flex=100 layout=row></match-bulk-upload> <owq-bulk-upload ng-if=\"question_type=='OWQ' && !isEditQuestion\" flex=100 layout=row></owq-bulk-upload> <short-bulk-upload ng-if=\"question_type=='SA' && !isEditQuestion\" flex=100 layout=row></short-bulk-upload> <long-bulk-upload ng-if=\"question_type=='LA' && !isEditQuestion\" flex=100 layout=row></long-bulk-upload> </md-input-container> </div> <mcq ng-if=\"question_type=='MCQ'\"></mcq> <draw ng-if=\"question_type=='DRAW'\"></draw> <fib ng-if=\"question_type=='FIB'\"></fib> <match ng-if=\"question_type=='MTF'\"></match> <owq ng-if=\"question_type=='OWQ'\"></owq> <tf ng-if=\"question_type=='TF'\"></tf> <short ng-if=\"question_type=='SA'\"></short> <long ng-if=\"question_type=='LA'\"></long> <passage ng-if=\"question_type=='passage'\"></passage> <asl-listen ng-if=\"question_type=='ASLLISTEN'\"></asl-listen> <asl-speak ng-if=\"question_type=='ASLSPEAK'\"></asl-speak> <div class=contentBox ng-show=\"(isTActivityQuestion || isTpActivityQuestion )&&question_type==='passage'\"> <md-input-container flex=40> <label>Select Theme</label> <md-select ng-model=theme.det placeholder=\"Select Theme\"> <md-option ng-repeat=\"themes in themesArray | orderBy:'theme_name' track by themes.theme_id\" ng-value={{themes}}>{{themes.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors['theme']}}</div> </md-input-container> </div> <div class=contentBox ng-show=\"question_type!=='passage'\"> <md-tabs md-dynamic-height md-no-ink md-no-ink-bar class=tabBgColor md-selected=selectedIndex> <md-tab label=Theme* ng-if=\"isTActivityQuestion || isTpActivityQuestion\"> <md-content class=md-padding layout=column flex=100> <div layout=row flex> <md-input-container flex=40> <label>Select Theme</label> <md-select ng-model=theme.det placeholder=\"Select Theme\" ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"themes in themesArray | orderBy:'theme_name' track by themes.theme_id\" ng-value={{themes}}>{{themes.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors['theme']}}</div> </md-input-container> </div> </md-content> </md-tab> <md-tab label=\"Strand, Skills, Wave & Level*\"> <md-content class=md-padding layout=column flex=100> <div layout=row flex style=padding-left:36px> <div flex=50> <md-chips ng-model=strand md-require-match=false> <md-autocomplete md-selected-item=selectedItem md-search-text=searchText md-items=\"item in querySearch(searchText)\" md-item-text=item.name placeholder=\"Enter Strand\"> <span md-highlight-text=searchText>{{item}}</span> </md-autocomplete> <md-chip-template> <span>{{$chip}}</span> </md-chip-template> </md-chips> <div class=errorMessage>{{errors['strand']}}</div> </div> <md-input-container flex=50> <label>Select Cognitive Skills</label> <md-select ng-model=cognitive_skill placeholder=\"Select  Cognitive Skills\" multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}> {{skill}} </md-option> </md-select> <div class=errorMessage>{{errors['cognitive_skill']}}</div> </md-input-container> </div> <div flex layout=row layout-align=\"space-around center\"> <md-input-container flex=45> <label>Select Wave</label> <md-select ng-model=wave placeholder=\"Select Wave\" multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors['wave']}}</div> </md-input-container> <md-input-container flex=45> <label>Select Level</label> <md-select ng-model=level placeholder=\"Select Level\" multiple=multiple> <md-option value=1>1</md-option> <md-option value=2>2</md-option> <md-option value=3>3</md-option> </md-select> <div class=errorMessage>{{errors['level']}}</div> </md-input-container> </div> </md-content> </md-tab> <md-tab label=\"Link Subject\"> <md-content class=md-padding layout=row flex layout-align=\"space-around center\"> <md-input-container flex=45> <label>Select Subject</label> <md-select ng-model=link_subject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors['link_subject']}}</div> </md-input-container> <md-input-container flex=45> <label>Select Theme/Topic</label> <md-select ng-model=link_theme ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in link_subject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors['link_theme']}}</div> </md-input-container> </md-content> </md-tab> <md-tab label=\"Additional Tags \"> <div flex=\"80 \" class=md-padding> <md-chips required ng-model=\"tag \" name=\"tagName \" speakonly=false md-removable=true md-max-chips=\"5 \" placeholder=\"Enter tags and press enter \" secondary-placeholder=\"Enter tags and press enter \" md-enable-chip-edit=\"true \">{{$chip}} </md-chips> <div class=\"errorMessage field-error-space\">{{errors['tag']}}</div> </div> </md-tab> </md-tabs> </div> </div> <div layout=\"row \"> <div flex=\"80 \" layout=\"row \"> <md-button md-no-ink class=\"questionButton md-ink-ripple\" layout=\"row \" ng-click=\"addQuestion() \" ng-show=\"!isEditQuestion&&question_type!==undefined&&!isSaveClicked\">Save Question <span class=plusSymbol> <i class=\"fas fa-save\"></i> </span> </md-button> <md-button md-no-ink class=\"questionButton md-ink-ripple\" layout=\"row \" ng-click=\"addQuestion() \" ng-show=\"isEditQuestion&&question_type!==undefined&&!isSaveClicked\">Update Question <span class=plusSymbol> <i class=\"fas fa-save\"></i> </span> </md-button> <md-button md-no-ink class=\"questionButton md-ink-ripple\" ng-click=\"goToArchive() \" layout=\"row \" ng-show=\"(isTActivityQuestion || isTpActivityQuestion)&&!isEditQuestion&&question_type!==undefined&&question_type!=='passage'\">Select Question <span class=plusSymbol> <i class=\"fas fa-plus\"></i> </span> </md-button> <md-button md-no-ink class=\"questionButton md-ink-ripple\" ng-if=\"isTActivityQuestion || isTpActivityQuestion\" ng-click=\"redirectToPreviousPage() \" layout=\"row \"> Cancel <span class=plusSymbol> <i class=\"fas fa-times\"></i> </span> </md-button> </div> </div> </div>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.image_div_font_size{font-size:small;color:#541953}.image_div_content{border:1px solid #ff9efd}.font_roboto{font-family:Roboto Condensed}.image_download_icon{color:#fff;padding:4px;background:#541953}.border_radius5{border-radius:5px}.image_card_border{border:1px solid #ffe1fef0}.hand_mouse{cursor:pointer}.zoom{transition:transform .2s;width:200px;margin:0 auto}.zoom:hover{transform:scale(1.5)}*{box-sizing:border-box}.img-zoom-container{position:relative}.img-zoom-lens{position:absolute;border:1px solid #d4d4d4;width:40px;height:40px}.img-zoom-result{border:1px solid #d4d4d4;width:300px;height:242px}.font_majentha{color:#6c246c}.textcenter{text-align:center}.padding10{padding:10px}.dateDiv{font-size:13px;font-weight:900;color:grey}.timeDiv{font-weight:900;color:#3265c0;font-size:14px}.btn_download{min-width:50px!important;margin-left:22px}.btn_cancel{background-color:#2e2d2d!important;color:#fcfcfc!important}.dialogHead{background-color:#52b0f5!important}.large-Modal .modal-dialog{height:400px;width:400px;margin:auto;position:absolute;top:0;right:0;bottom:0;left:0}.btn_proceed{background-color:#129218!important;color:#fcfcfc!important}.btn_stop{background-color:#c04332!important;color:#fcfcfc!important}.btn_warning{background-color:#fc0!important;color:#2e2d2d!important}.btn_click{background-color:#3265c0!important;color:#fcfcfc!important}.md-fab{margin:0 0 0 6px!important}.md-cancel-button{background-color:#2e2d2d!important}.md-confirm-button{background-color:#3265c0!important}</style> <script></script> <md-dialog flex=90 class=proctoring_modal> <md-toolbar> <div class=\"md-toolbar-tools dialogHead\"> <h2>Student:&nbsp;</h2> <div><b>{{studList.name}}</b></div> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content layout=column> <div layout=column> <div layout=row style=padding:10px;background:#3265c0;color:#fffF class=border_radius5 layout-align=\"space-between center\" flex=100> <div flex=70 layout=row> <div style=padding:5px> <i class=\"fas fa-image\"></i> </div> <div style=padding:5px>Proctored images</div> </div> <div ng-if=proctured_data.textShots flex=30 style=text-align:right>No. of tab Changes : {{proctured_data.textShots}}</div> <div ng-if=!proctured_data.textShots flex=30 style=text-align:right>No. of tab Changes : 0 </div> </div> <div layout=row flex=100 style=padding-top:5px class=font_roboto> <div flex=50 layout=row layout-wrap style=height:421px;overflow:scroll> <md-card class=image_card_border flex=40 ng-repeat=\"one_image in proctured_data.cameraShots\" style=background-color:#dff2ff;height:100px layout=row> <div flex=50 class=\"padding10 hand_mouse zoom\" ng-click=imageDetails(one_image)> <img style=\"height:80px;width:80px;border:5px solid #9bd5ff\" ng-src={{one_image.path}}> </div> <div flex=50 class=padding10> <div flex=100 class=\"textcenter dateDiv\"> Date:&nbsp;{{one_image.datetime| date: 'd-M-yy'}}</div> <div flex=100 class=\"textcenter timeDiv\"> Time:&nbsp;{{one_image.datetime| date: 'h:mm a'}}</div> <md-button style=background-color:#3265c0 flex=100 ng-click=download(one_image) class=\"md-raised md-button md-accent btn_download\"><i style=font-size:12px class=\"fas fa-download\"></i></md-button> </div> </md-card> </div> <div flex=50> <div layout=row style=padding:10px;background:#56b2f5;color:#fffF;margin-top:7px class=border_radius5> <div style=padding:5px> <i class=\"fas fa-image\"></i> </div> <div style=padding:5px>Preview</div> </div> <div layout=column style=text-align:right> <div style=padding:10px layout=row class=img-zoom-container> <img id=myimage ng-src={{one_image.path}} width=300 height=240 flex=50> <div id=myresult class=img-zoom-result flex=50></div> </div> </div> </div> </div> </div> <div layout=column> <div layout=row style=padding:10px;background:#3265c0;color:#fffF class=border_radius5> <div style=padding:5px> <i class=\"fas fa-file-audio\"></i> </div> <div style=padding:5px>Proctored Audio <br>&nbsp; <i style=font-size:10px>Max.duration : 20s</i></div> </div> <div layout=row flex=100 style=padding-top:5px layout-align=\"space-between center\" class=font_roboto> <div flex=100 layout=row> <div layout=row layout-wrap flex=100> <md-card class=image_card_border flex=30 ng-click=audioDetails(one_audio) ng-repeat=\"one_audio in proctured_data.activityShots\" style=padding:10px;background:#dff2ff> <md-card-title-text> <span class=\"md-subhead font_majentha dateDiv\">Date:&nbsp;{{one_audio.datetime| date: 'd-M-yy'}}</span> <span class=\"md-subhead font_majentha timeDiv\"><b>Time:&nbsp;{{one_audio.datetime| date: 'h:mm a'}}</b></span> </md-card-title-text> <md-card-title-media> <div class=\"md-media-sm card-media\"> <audio controls ng-src={{one_audio.path}}></audio> </div> </md-card-title-media> </md-card> </div> </div> </div> </div> <md-divider></md-divider> </div> </md-dialog-content> <md-dialog-actions layout=row style=margin:auto> <span flex></span> <md-button ng-if=\"proctured_data.examOutStatus==true && proctured_data.examStudentStatus=='attending'\" ng-click=\"showConfirm($event,'proceedExam')\" class=\"md-raised btn_proceed md-fab md-primary\" style=width:40px;height:40px> <md-tooltip md-direction=left>Unlock</md-tooltip> <i class=\"fa fa-unlock-alt\" aria-hidden=true></i> </md-button> <md-button ng-if=\"proctured_data.examStudentStatus=='attending'\" ng-click=\"showConfirm($event,'stopExam')\" class=\"md-raised btn_stop md-fab md-primary\" style=width:40px;height:40px> <md-tooltip md-direction=left>Stop</md-tooltip> <i class=\"fas fa-ban\"></i> </md-button> <md-button ng-if=\"proctured_data.examStudentStatus=='attending'\" ng-click=\"showConfirm($event,'sendWarning')\" class=\"md-raised btn_warning md-fab md-primary\" style=width:40px;height:40px> <md-tooltip md-direction=left>Send Warning</md-tooltip> <i class=\"fas fa-exclamation-triangle\"></i> </md-button> <md-button ng-if=\"proctured_data.examStudentStatus=='attending'\" ng-click=\"showConfirm($event,'takePhoto')\" class=\"md-raised btn_click md-fab md-primary\" aria-label=\"Use Android\" style=width:40px;height:40px> <md-tooltip md-direction=left>take Photo</md-tooltip> <i class=\"fas fa-camera\"></i> </md-button> <md-button ng-click=cancel() class=\"md-raised btn_cancel md-fab md-primary\" style=width:40px;height:40px> <i class=\"fas fa-times-circle\"></i> </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.not-attended{color:red}.attended{color:green}.q_index_attended{min-width:32px;width:40px;height:34px;line-height:32px;border:1px solid;border-color:#fff;color:#fff;font-weight:400;background-color:#4caf50;border-radius:50%}.q_index_notattended{min-width:32px;width:40px;height:34px;line-height:32px;border:1px solid;border-color:#fff;color:#fff;font-weight:400;background-color:#ff0000cc;border-radius:50%}</style> <md-backdrop style=z-index:60!important ng-if=isLoadingPreview class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading preview, please wait ...</span> </md-backdrop> <div class=question-directive ng-cloak ng-if=!isLoadingPreview> <div> <div> <div class=pass-con> <div class=pass-sub-con layout=column> <div> <div ng-repeat=\"question in array track by $index\"> <div ng-switch=question.type> <div ng-switch-when=MCQ|IBT_MCQ ng-switch-when-separator=| layout=column> <div ng-switch=question.pattern> <div flex ng-switch-when=single> <div flex layout=row> <div flex=90 layout=column> <p ng-if=question.passage class=composed_dom style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}}) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-model=question.my_answer[0] flex> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=\"question-outline question_desc\" ng-if=question.isLatex>{{choice.tag}} ) {{choice.desc}} </div> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=question-outline ng-if=!question.isLatex> {{choice.tag}} ) {{choice.desc}}</div> <div layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> </div> </div> </div> </div> <div ng-switch-when=multiple layout=column> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count> {{$index+1}}</button> <p class=question_desc ng-if=question.isLatex> {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex> <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span> &nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\"> ({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i> </p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <md-divider ng-if=\"question.questionImg && question.questionImg.length>0\"> </md-divider> <div layout=row flex layout-align=\"space-between center\" ng-repeat=\"choice in question.my_answer\" style=\"background:#e4f0ff;padding:10px;border:1px solid #ccc;margin:5px;padding-left:10px;padding-right:10px;padding-top:10px\"> <div>{{choice}} </div> </div> <div layout=row flex layout-align=\"space-between center\" ng-repeat=\"choice in question.choice\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=TF layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p class=question_desc ng-if=question.isLatex> {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex><span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div flex layout=column> <div layout=row layout-align=\"space-between center\" style=\"background:#e4f0ff;padding:10px;border:1px solid #ccc;margin:5px;padding-left:10px;padding-right:10px;padding-top:10px\"> <div flex> {{question.my_answer[0]}} </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=OWQ layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p class=question_desc ng-if=question.isLatex> {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex> <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\"> ({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div ng-repeat=\"choice in question.answer\"> <div layout=row layout-align=\"space-between center\" style=\"background:#e4f0ff;border:1px solid #ccc;margin:5px;padding:10px\" ng-if=choice.desc> <label> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc style=padding-right:20px ng-if=question.isLatex>{{question.my_answer[$index]}}</b> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex style=padding-right:20px>{{question.my_answer[$index]}}</b> </label> </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label> <p><b style=color:red>Teacher Comment</b></p> </label> <div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=FIB|IBT_FIB ng-switch-when-separator=| layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p ng-if=!question.isLatex> <span class=composed_dom ng-bind-html=beautifyFIBPreview(question.qn_desc)|safeHtml></span>&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div layout=row ng-repeat=\"choice in question.my_answer\" style=\"background:#e4f0ff;padding:10px;border:1px solid #ccc;margin:5px;padding-left:10px;padding-right:10px;padding-top:10px\"> <div>{{choice}} </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=MTF layout=column> <div layout=column flex> <div layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p> Match the following questions and answers &nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div flex layout=row> <div flex=50 layout=column> Question: <div ng-if=!quest.no_question class=md-whiteframe-2dp ng-repeat=\"quest in question.option\" layout=row style=margin:5px;height:70px> <label style=padding:15px;background:#00bcd4;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:15px;background:#fff;overflow-y:auto;margin:0;font-size:14px!important class=question_desc ng-if=question.isLatex>{{quest.question.desc}}</label> <label flex style=padding:15px;background:#fff;overflow-y:auto;margin:0;font-size:14px!important ng-if=!question.isLatex><span class=composed_dom ng-bind-html=quest.question.desc|safeHtml></span></label> <img flex ng-src={{setFilePathPreview(quest.question.questionImg)}} ng-if=quest.question.questionImg class=mtf-question-img /> </div> </div> <div flex=50 layout=column ng-if=\"question.ans_key.length>0\">Student Answer: <div ng-if=answer.needed ng-repeat=\"answer in question.ans_key\" class=md-whiteframe-2dp layout=row style=margin:5px;height:70px> <label style=padding:15px;width:25px;background:#009688;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label style=padding:15px;overflow-y:auto flex class=\"mtf_answer question_desc\" ng-if=question.isLatex>{{answer.desc}}</label> <label style=padding:15px;overflow-y:auto;float:left flex class=mtf_answer ng-if=!question.isLatex>{{answer.desc}}</label> <img flex style=max-height:47px ng-src={{setFilePathPreview(answer.optImage)}} ng-if=answer.optImage class=mtf-question-img /> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=SA layout=column> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p class=question_desc ng-if=question.isLatex>{{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex><span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span> &nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer style=\"background:#e4f0ff;padding:10px;border:1px solid #ccc\"> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img flex ng-src={{setFilePathPreview(question.answerImg)}} style=max-width:600px;max-height:400px> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=LA layout=column> <div flex layout=row> <div flex=90 layout=column> <p ng-if=question.passage class=composed_dom style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePathPreview(img)}} ng-click=showImage(setFilePathPreview(img)) style=max-width:400px> </div> </div> </div> </div> <div layout=row> <button title=\"Click here to attend again\" ng-click=clickQuestion($index) style=margin:3px ng-class=\"{'q_index_attended' : question.is_attended,'q_index_notattended':!question.is_attended}\" class=\"md-whiteframe-2dp q_index\" aria-label=questionCount.count>{{$index+1}}</button> <p class=question_desc ng-if=question.isLatex>{{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex> <span class=composed_dom ng-bind-html=\"data=conertToHtml(question.qn_desc)\"></span>&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\"> ({{question.attendedStatus}}) <i title=\"Click here to attend again\" ng-click=clickQuestion($index) class=\"far fa-edit\" style=cursor:pointer;margin:auto></i></p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer style=\"background:#e4f0ff;padding:10px;border:1px solid #ccc\"> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img flex ng-src={{setFilePathPreview(question.answerImg)}} style=max-width:600px;max-height:400px> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=DRAW layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> </p> </div> </div> <div layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePathPreview(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.answerImg> <img flex src={{setFilePathPreview(question.answerImg)}} style=max-width:600px;max-height:400px> </div> </div> <div flex> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLLISTEN layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> </p> <div ng-if=question.audio_url class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePathPreview(question.audio_url)}}></audio> </div> </div> </div> <img flex ng-src={{setFilePathPreview(question.questionImg)}} class=question-img ng-if=question.questionImg /> <div ng-repeat=\"answer in question.questions\" flex> <div ng-switch=answer.type> <div ng-switch-when=mcq> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img flex ng-src={{setFilePathPreview(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-value=choice ng-disabled=false class=question_desc ng-if=question.isLatex>{{choice.tag}}){{ choice.desc }} <img flex ng-src={{setFilePathPreview(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> <div ng-value=choice ng-disabled=false ng-if=!question.isLatex>{{choice.tag}}){{ choice.desc }} <img flex ng-src={{setFilePathPreview(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> </div> </div> </div> <div ng-switch-when=tf layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img flex ng-src={{setFilePathPreview(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} class=question_desc ng-if=question.isLatex>{{choice.tag}} </div> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} ng-if=!question.isLatex> {{choice.tag}} </div> </div> </div> </div> </div> <div ng-switch-when=fib layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p>{{$index+1}} ) {{beautifyFIBPreview(answer.qn_desc)}}</p> </div> </div> <img flex ng-src={{setFilePathPreview(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div ng-repeat=\"choice in answer.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer {{$index+1}} - <b class=question_desc ng-if=question.isLatex>{{answer.my_answer[$index]}}</b> <b ng-if=!question.isLatex>{{answer.my_answer[$index]}}</b> </label> <label ng-if=choice.wrong> {{$index+1}} - <b class=question_desc ng-class=\"{'correct-ans-mcq_off' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px ng-if=question.isLatex>{{answer.my_answer[$index]}}</b> <b ng-if=!question.isLatex ng-class=\"{'correct-ans-mcq_off' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{answer.my_answer[$index]}}</b> </label> </div> </div> </div> </div> <div ng-switch-when=audio layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <div> <div flex ng-if=answer.answer> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"answer.showHint = answer.showHint?false:true;\"> <b style=color:green>{{answer.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=answer.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePathPreview(answer.answer)}}></audio> </div> </div> <div flex layout-align=\"start center\" ng-if=answer.my_answer> <div class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePathPreview(answer.my_answer)}}></audio> </div> </div> </div> </div> </div> <div ng-switch-when=text layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <img flex ng-src={{setFilePathPreview(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <label ng-if=answer.correct>Answer - <b ng-class=\"{'correct-ans-mcq_off' : answer.correct,'selected-wrong-mcq' : answer.wrong}\">{{answer.my_answer}}</b></label> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLSPEAK layout=column> <div flex layout=row> <div flex=90> <p>{{$index+1}} ) {{question.qn_desc}}</p> </div> </div> <div layout=column flex> <div flex ng-if=question.ans_audio_url> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=question.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePathPreview(question.answer)}}></audio> </div> </div> </div> </div> </div> <md-divider style=\"padding:5px 0;margin:5px 0\"></md-divider> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIxOHB4IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxNCAxOCIgd2lkdGg9IjE0cHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUvPjxkZXNjLz48ZGVmcy8+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSI+PGcgZmlsbD0iIzAwMDAwMCIgaWQ9IkNvcmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yOTkuMDAwMDAwLCAtMTI5LjAwMDAwMCkiPjxnIGlkPSJkZWxldGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI5OS4wMDAwMDAsIDEyOS4wMDAwMDApIj48cGF0aCBkPSJNMSwxNiBDMSwxNy4xIDEuOSwxOCAzLDE4IEwxMSwxOCBDMTIuMSwxOCAxMywxNy4xIDEzLDE2IEwxMyw0IEwxLDQgTDEsMTYgTDEsMTYgWiBNMTQsMSBMMTAuNSwxIEw5LjUsMCBMNC41LDAgTDMuNSwxIEwwLDEgTDAsMyBMMTQsMyBMMTQsMSBMMTQsMSBaIiBpZD0iU2hhcGUiLz48L2c+PC9nPjwvZz48L3N2Zz4="

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(867)
var ieee754 = __webpack_require__(868)
var isArray = __webpack_require__(869)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAACRElEQVQ4T63UXejecxjH8dfHQwrlaQfEkZIIc7CMmihFlNLkocRaS9S2OPBUmo0T8lA7k8eccSgHyokaa8NsrWmIlKfMYw0RQ5eu9fut2919//c/cB3+ft/r/b2uz+e6vnGYqKpzcR0uwIn4BG/j1SR/zUrPQsyq2oBH8De24TecjTOxG7ck+XCaMRdaVY/iATyBzUm+6eSqOgKX4xkch8uSfDoJ/g+0qi7CDTgDN2NTkodndVNVp2EnPkty6UxoVa3Gi+iKvsDHuD3JP/Mkqqqr8TouTvLueO5gpVV1Ar7CFtyU5PfDGTjkdfvf4w3cP8owQrv8t7A0yZ7FAMczVXUv7sNJuCfJ5hG6Ci9heZL35mh4Fd5P8tP0/6o6BRuxHjemqpYNbffs3ZrkhxlJnbAJW3Ftkv1zLn7tYGFV9Q76pvOS/DkD+BAmJ2A7rpkFrqqleLOhB7A2yXOTwKo6Gg8ObT09jFo7vRKt+8ok303ldHHbGvoHrkzSRh2Kqjofu/D4UOkvuA2fD3JtSPLkVM6pI7Rb3pjksakDR+GsJB8NI9dar0vybFX1mv48bVpVXY+Xu9JXsAIXJvlxjgEn49sROufMErTevzb0dOzFl7gLO6aSWvMe8tZvLZ7HsRhX/EhcgafQ4BXjnF6CF3BOtzUFbXPWoMeo57kvaMAYDT0ePd93J9l+6EGpqmMGGdrByei34AO0pncMJvVsT8bX3XqS6o8LvqcTq9gX7euNSdJP3oKxWGgb1Zq2+/8rtHf+zsVA/wVlmerWmfoNeQAAAABJRU5ErkJggg=="

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 85 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAUklEQVQ4jWNgGAW4wH8t0pSH/P/9v4E05f+J1jB0lP9n/b/qfyAJpv+PAEr++h9EgmP+NwAV/IZoIdLtUC3BJHgVqoWkkAFpIV45VAspykcGAABTWXAj14Pc+wAAAABJRU5ErkJggg=="

/***/ }),
/* 87 */,
/* 88 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 89 */,
/* 90 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAAPVJREFUeNqMkrFKQ0EQRc8LfkG4+yUhECzS2hgsX2HaIIjdayxemcI+YpUuWMRO/Ac7PyQM+AMaJs0ENnGfycDCcufc3b3DVpJa4NvMXjijUkr3QL8HbIBFSqk5w9QAC2CDuyNpJmkrqXF3SktSE8zM3ckbU0m/ktqCqY3edK8dA3WcOs+0eWh1zlbufpyjBl6Bp5AegVszWx+AHXkmcctW0qTE9DoGeAV4tv9TF4WRPwN3wHVIHyklzOyh86mSlpJ+JI0zbRzaMmdz0yqAUSHzKHqrA+N/pi5zJekNuAEuzezrxJcbAJ/A+36qw1MmgGCGALsBADdl+AcrppEhAAAAAElFTkSuQmCC"

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div id=first class=profileViewCtrls ng-cloak md-theme=makeMeWhite> <md-content class=\"md-padding firstDiv bgColor md-whiteframe-3dp\"> <md-content class=\"md-padding secondDiv bgColor md-whiteframe-3dp profileView\" ng-if=profileViewCtrls.profileData> <div layout=row flex> <div layout=row flex=50 layout-align=\"start end\" class=txtclr> <h4>BASIC INFO </h4> </div> </div> <div layout=row flex> <div layout=row layout-align=\"start start\"> <img class=imgClsd ng-show=!profileViewCtrls.eachPerson.image.original src=" + __webpack_require__(547) + "> <img class=imgClsd ng-show=profileViewCtrls.eachPerson.image.original ng-src={{profileViewCtrls.tempImg}}> </div> <div class=md-padding layout-align=\"space-between start\" layout=column> <div layout=row> <div layout=column layout-align=\"space-around start\"> <div class=uname ng-if=profileViewCtrls.eachPerson.name>{{profileViewCtrls.eachPerson.name}} <span class=role>({{assignedRoleNames}})</span> </div> <div class=spaceAdjKey></div> <div class=txtLbl ng-if=profileViewCtrls.eachPerson.username>Email </div> <div class=txtLbl ng-if=profileViewCtrls.eachPerson.addrLine1>Address </div> <div class=txtLbl ng-if=profileViewCtrls.eachPerson.city>City </div> <div class=txtLbl ng-if=profileViewCtrls.eachPerson.country>Country </div> </div> <div layout=column layout-align=\"space-around start\"> <div></div> <div class=spaceAdjVal></div> <div class=txtLblsixe ng-if=profileViewCtrls.eachPerson.username>: {{profileViewCtrls.eachPerson.username}}</div> <div class=txtLblsixe ng-if=profileViewCtrls.eachPerson.addrLine1>: {{profileViewCtrls.eachPerson.addrLine1}}</div> <div class=txtLblsixe ng-if=profileViewCtrls.eachPerson.city>: {{profileViewCtrls.eachPerson.city}}</div> <div class=txtLblsixe ng-if=profileViewCtrls.eachPerson.country> : {{profileViewCtrls.eachPerson.country}}</div> </div> </div> </div> </div> </md-content> <md-content class=\"md-padding secondDiv bgColor md-whiteframe-3dp profileEditSection\" ng-if=profileViewCtrls.profileDataEdit> <div flex layout=row> <div flex=20> <h4 class=txtclr>BASIC INFO</h4> <img class=imgClsd ng-hide=basciImg src={{profileViewCtrls.tempImg}}> <div ng-hide=!basciImg ngf-drop ng-model=basciImg ngf-pattern=image/* accept=image/* class=\"cropArea imgClsd\"> <img-crop image=\"basciImg  | ngfDataUrl\" result-image=croppedDataUrl ng-init=\"croppedDataUrl=''\"> </img-crop> </div> <div class=btn2 flex=10> <md-button class=\"md-raised md-primary\" ngf-select ng-model=basciImg ngf-pattern=\"'image/*'\" accept=image/*> Browse </md-button> </div> </div> <div layout=column flex> <div layout=row layout-align=\"end center\"> <img src=" + __webpack_require__(222) + " class=\"result-icon-button hand updateIconProfileSettings\" alt=profileEdit ng-click=\"profileViewCtrls.updateUser(croppedDataUrl, basciImg)\"> <img src=" + __webpack_require__(861) + " class=\"result-icon-button mar_left_15 hand updateIconProfileSettings\" ng-click=profileViewCtrls.close()> </div> <div layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label>Name</label> <input ng-disabled=profileViewCtrls.modeStatus maxlength=50 ng-model=profileViewCtrls.eachPerson.name type=text ng-required=true value=\"\"> <error-msg msg=errors.name class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Email ID</label> <input ng-model=profileViewCtrls.eachPerson.username ng-disabled=true ng-required=true> <error-msg msg=errors.email class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Phone Number</label> <input ng-disabled=profileViewCtrls.modeStatus name=phone ng-model=profileViewCtrls.eachPerson.phone ng-required=true /> <error-msg msg=errors.phone class=redAlert></error-msg> </md-input-container> </div> <div layout-gt-sm=row flex> <md-input-container class=md-block flex-gt-sm> <label>Address 1</label> <textarea ng-disabled=profileViewCtrls.modeStatus ng-required=true ng-model=profileViewCtrls.eachPerson.addrLine1 rows=5 md-select-on-focus></textarea> <error-msg msg=errors.addrLine1 class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Address 2</label> <textarea ng-disabled=profileViewCtrls.modeStatus ng-required=true ng-model=profileViewCtrls.eachPerson.addrLine2 rows=5 md-select-on-focus></textarea> <error-msg msg=errors.addrLine2 class=redAlert></error-msg> </md-input-container> </div> <div layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label>City</label> <input ng-disabled=profileViewCtrls.modeStatus name=phone ng-model=profileViewCtrls.eachPerson.city ng-required=true /> <error-msg msg=errors.city class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Country</label> <input ng-disabled=profileViewCtrls.modeStatus name=phone ng-model=profileViewCtrls.eachPerson.country ng-required=true /> <error-msg msg=errors.country class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Pincode</label> <input ng-disabled=profileViewCtrls.modeStatus name=phone ng-model=profileViewCtrls.eachPerson.pincode postal-validate ng-required=true /> <error-msg msg=errors.pincode class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Blood Group</label> <input ng-disabled=profileViewCtrls.modeStatus name=blood_group ng-model=profileViewCtrls.eachPerson.blood_group ng-required=true /> <error-msg msg=errors.blood_group class=redAlert></error-msg> </md-input-container> </div> </div> </div> </md-content> <md-content ng-if=\"roleHOD || roleHOS || rolePARENT || roleTeacher || roleSupervisor\" class=\"md-padding secondDiv bgColor md-whiteframe-3dp assignSection\"> <h4 class=txtclr>ASSIGN</h4> <md-content class=senform md-theme=makeMeWhite ng-cloak> <md-tabs md-dynamic-height md-border-bottom> <md-tab ng-if=roleHOD> <md-tab-label class=header_weight>HOD</md-tab-label> <md-tab-body> <hod-view></hod-view> </md-tab-body> </md-tab> <md-tab ng-if=roleHOS> <md-tab-label class=header_weight>HOS</md-tab-label> <md-tab-body> <hos-view></hos-view> </md-tab-body> </md-tab> <md-tab ng-if=rolePARENT> <md-tab-label class=header_weight>Parent</md-tab-label> <md-tab-body> <parent-view></parent-view> </md-tab-body> </md-tab> <md-tab ng-if=roleTeacher> <md-tab-label class=header_weight>Teacher</md-tab-label> <md-tab-body> <teacher-view></teacher-view> </md-tab-body> </md-tab> <md-tab ng-if=roleSupervisor> <md-tab-label class=header_weight>Supervisor</md-tab-label> <md-tab-body> <supervisor-view></supervisor-view> </md-tab-body> </md-tab> </md-tabs> </md-content> </md-content> </md-content> </div>";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var debug = __webpack_require__(864)('socket.io-parser');
var Emitter = __webpack_require__(44);
var binary = __webpack_require__(866);
var isArray = __webpack_require__(224);
var isBuf = __webpack_require__(225);

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = 4;

/**
 * Packet types.
 *
 * @api public
 */

exports.types = [
  'CONNECT',
  'DISCONNECT',
  'EVENT',
  'ACK',
  'ERROR',
  'BINARY_EVENT',
  'BINARY_ACK'
];

/**
 * Packet type `connect`.
 *
 * @api public
 */

exports.CONNECT = 0;

/**
 * Packet type `disconnect`.
 *
 * @api public
 */

exports.DISCONNECT = 1;

/**
 * Packet type `event`.
 *
 * @api public
 */

exports.EVENT = 2;

/**
 * Packet type `ack`.
 *
 * @api public
 */

exports.ACK = 3;

/**
 * Packet type `error`.
 *
 * @api public
 */

exports.ERROR = 4;

/**
 * Packet type 'binary event'
 *
 * @api public
 */

exports.BINARY_EVENT = 5;

/**
 * Packet type `binary ack`. For acks with binary arguments.
 *
 * @api public
 */

exports.BINARY_ACK = 6;

/**
 * Encoder constructor.
 *
 * @api public
 */

exports.Encoder = Encoder;

/**
 * Decoder constructor.
 *
 * @api public
 */

exports.Decoder = Decoder;

/**
 * A socket.io Encoder instance
 *
 * @api public
 */

function Encoder() {}

var ERROR_PACKET = exports.ERROR + '"encode error"';

/**
 * Encode a packet as a single string if non-binary, or as a
 * buffer sequence, depending on packet type.
 *
 * @param {Object} obj - packet object
 * @param {Function} callback - function to handle encodings (likely engine.write)
 * @return Calls callback with Array of encodings
 * @api public
 */

Encoder.prototype.encode = function(obj, callback){
  debug('encoding packet %j', obj);

  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    encodeAsBinary(obj, callback);
  } else {
    var encoding = encodeAsString(obj);
    callback([encoding]);
  }
};

/**
 * Encode packet as string.
 *
 * @param {Object} packet
 * @return {String} encoded
 * @api private
 */

function encodeAsString(obj) {

  // first is type
  var str = '' + obj.type;

  // attachments if we have them
  if (exports.BINARY_EVENT === obj.type || exports.BINARY_ACK === obj.type) {
    str += obj.attachments + '-';
  }

  // if we have a namespace other than `/`
  // we append it followed by a comma `,`
  if (obj.nsp && '/' !== obj.nsp) {
    str += obj.nsp + ',';
  }

  // immediately followed by the id
  if (null != obj.id) {
    str += obj.id;
  }

  // json data
  if (null != obj.data) {
    var payload = tryStringify(obj.data);
    if (payload !== false) {
      str += payload;
    } else {
      return ERROR_PACKET;
    }
  }

  debug('encoded %j as %s', obj, str);
  return str;
}

function tryStringify(str) {
  try {
    return JSON.stringify(str);
  } catch(e){
    return false;
  }
}

/**
 * Encode packet as 'buffer sequence' by removing blobs, and
 * deconstructing packet into object with placeholders and
 * a list of buffers.
 *
 * @param {Object} packet
 * @return {Buffer} encoded
 * @api private
 */

function encodeAsBinary(obj, callback) {

  function writeEncoding(bloblessData) {
    var deconstruction = binary.deconstructPacket(bloblessData);
    var pack = encodeAsString(deconstruction.packet);
    var buffers = deconstruction.buffers;

    buffers.unshift(pack); // add packet info to beginning of data list
    callback(buffers); // write all the buffers
  }

  binary.removeBlobs(obj, writeEncoding);
}

/**
 * A socket.io Decoder instance
 *
 * @return {Object} decoder
 * @api public
 */

function Decoder() {
  this.reconstructor = null;
}

/**
 * Mix in `Emitter` with Decoder.
 */

Emitter(Decoder.prototype);

/**
 * Decodes an encoded packet string into packet JSON.
 *
 * @param {String} obj - encoded packet
 * @return {Object} packet
 * @api public
 */

Decoder.prototype.add = function(obj) {
  var packet;
  if (typeof obj === 'string') {
    packet = decodeString(obj);
    if (exports.BINARY_EVENT === packet.type || exports.BINARY_ACK === packet.type) { // binary packet's json
      this.reconstructor = new BinaryReconstructor(packet);

      // no attachments, labeled binary but no binary data to follow
      if (this.reconstructor.reconPack.attachments === 0) {
        this.emit('decoded', packet);
      }
    } else { // non-binary full packet
      this.emit('decoded', packet);
    }
  } else if (isBuf(obj) || obj.base64) { // raw binary data
    if (!this.reconstructor) {
      throw new Error('got binary data when not reconstructing a packet');
    } else {
      packet = this.reconstructor.takeBinaryData(obj);
      if (packet) { // received final buffer
        this.reconstructor = null;
        this.emit('decoded', packet);
      }
    }
  } else {
    throw new Error('Unknown type: ' + obj);
  }
};

/**
 * Decode a packet String (JSON data)
 *
 * @param {String} str
 * @return {Object} packet
 * @api private
 */

function decodeString(str) {
  var i = 0;
  // look up type
  var p = {
    type: Number(str.charAt(0))
  };

  if (null == exports.types[p.type]) {
    return error('unknown packet type ' + p.type);
  }

  // look up attachments if type binary
  if (exports.BINARY_EVENT === p.type || exports.BINARY_ACK === p.type) {
    var buf = '';
    while (str.charAt(++i) !== '-') {
      buf += str.charAt(i);
      if (i == str.length) break;
    }
    if (buf != Number(buf) || str.charAt(i) !== '-') {
      throw new Error('Illegal attachments');
    }
    p.attachments = Number(buf);
  }

  // look up namespace (if any)
  if ('/' === str.charAt(i + 1)) {
    p.nsp = '';
    while (++i) {
      var c = str.charAt(i);
      if (',' === c) break;
      p.nsp += c;
      if (i === str.length) break;
    }
  } else {
    p.nsp = '/';
  }

  // look up id
  var next = str.charAt(i + 1);
  if ('' !== next && Number(next) == next) {
    p.id = '';
    while (++i) {
      var c = str.charAt(i);
      if (null == c || Number(c) != c) {
        --i;
        break;
      }
      p.id += str.charAt(i);
      if (i === str.length) break;
    }
    p.id = Number(p.id);
  }

  // look up json data
  if (str.charAt(++i)) {
    var payload = tryParse(str.substr(i));
    var isPayloadValid = payload !== false && (p.type === exports.ERROR || isArray(payload));
    if (isPayloadValid) {
      p.data = payload;
    } else {
      return error('invalid payload');
    }
  }

  debug('decoded %s as %j', str, p);
  return p;
}

function tryParse(str) {
  try {
    return JSON.parse(str);
  } catch(e){
    return false;
  }
}

/**
 * Deallocates a parser's resources
 *
 * @api public
 */

Decoder.prototype.destroy = function() {
  if (this.reconstructor) {
    this.reconstructor.finishedReconstruction();
  }
};

/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 * @api private
 */

function BinaryReconstructor(packet) {
  this.reconPack = packet;
  this.buffers = [];
}

/**
 * Method to be called when binary data received from connection
 * after a BINARY_EVENT packet.
 *
 * @param {Buffer | ArrayBuffer} binData - the raw binary data received
 * @return {null | Object} returns null if more binary data is expected or
 *   a reconstructed packet object if all buffers have been received.
 * @api private
 */

BinaryReconstructor.prototype.takeBinaryData = function(binData) {
  this.buffers.push(binData);
  if (this.buffers.length === this.reconPack.attachments) { // done with buffer list
    var packet = binary.reconstructPacket(this.reconPack, this.buffers);
    this.finishedReconstruction();
    return packet;
  }
  return null;
};

/**
 * Cleans up binary packet reconstruction variables.
 *
 * @api private
 */

BinaryReconstructor.prototype.finishedReconstruction = function() {
  this.reconPack = null;
  this.buffers = [];
};

function error(msg) {
  return {
    type: exports.ERROR,
    data: 'parser error: ' + msg
  };
}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// browser shim for xmlhttprequest module

var hasCORS = __webpack_require__(872);

module.exports = function (opts) {
  var xdomain = opts.xdomain;

  // scheme must be same when usign XDomainRequest
  // http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
  var xscheme = opts.xscheme;

  // XDomainRequest has a flow of not sending cookie, therefore it should be disabled as a default.
  // https://github.com/Automattic/engine.io-client/pull/217
  var enablesXDR = opts.enablesXDR;

  // XMLHttpRequest can be disabled on IE
  try {
    if ('undefined' !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
      return new XMLHttpRequest();
    }
  } catch (e) { }

  // Use XDomainRequest for IE8 if enablesXDR is true
  // because loading bar keeps flashing when using jsonp-polling
  // https://github.com/yujiosaka/socke.io-ie8-loading-example
  try {
    if ('undefined' !== typeof XDomainRequest && !xscheme && enablesXDR) {
      return new XDomainRequest();
    }
  } catch (e) { }

  if (!xdomain) {
    try {
      return new self[['Active'].concat('Object').join('X')]('Microsoft.XMLHTTP');
    } catch (e) { }
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var parser = __webpack_require__(45);
var Emitter = __webpack_require__(44);

/**
 * Module exports.
 */

module.exports = Transport;

/**
 * Transport abstract constructor.
 *
 * @param {Object} options.
 * @api private
 */

function Transport (opts) {
  this.path = opts.path;
  this.hostname = opts.hostname;
  this.port = opts.port;
  this.secure = opts.secure;
  this.query = opts.query;
  this.timestampParam = opts.timestampParam;
  this.timestampRequests = opts.timestampRequests;
  this.readyState = '';
  this.agent = opts.agent || false;
  this.socket = opts.socket;
  this.enablesXDR = opts.enablesXDR;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;
  this.forceNode = opts.forceNode;

  // results of ReactNative environment detection
  this.isReactNative = opts.isReactNative;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;
  this.localAddress = opts.localAddress;
}

/**
 * Mix in `Emitter`.
 */

Emitter(Transport.prototype);

/**
 * Emits an error.
 *
 * @param {String} str
 * @return {Transport} for chaining
 * @api public
 */

Transport.prototype.onError = function (msg, desc) {
  var err = new Error(msg);
  err.type = 'TransportError';
  err.description = desc;
  this.emit('error', err);
  return this;
};

/**
 * Opens the transport.
 *
 * @api public
 */

Transport.prototype.open = function () {
  if ('closed' === this.readyState || '' === this.readyState) {
    this.readyState = 'opening';
    this.doOpen();
  }

  return this;
};

/**
 * Closes the transport.
 *
 * @api private
 */

Transport.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.doClose();
    this.onClose();
  }

  return this;
};

/**
 * Sends multiple packets.
 *
 * @param {Array} packets
 * @api private
 */

Transport.prototype.send = function (packets) {
  if ('open' === this.readyState) {
    this.write(packets);
  } else {
    throw new Error('Transport not open');
  }
};

/**
 * Called upon open
 *
 * @api private
 */

Transport.prototype.onOpen = function () {
  this.readyState = 'open';
  this.writable = true;
  this.emit('open');
};

/**
 * Called with data.
 *
 * @param {String} data
 * @api private
 */

Transport.prototype.onData = function (data) {
  var packet = parser.decodePacket(data, this.socket.binaryType);
  this.onPacket(packet);
};

/**
 * Called with a decoded packet.
 */

Transport.prototype.onPacket = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon close.
 *
 * @api private
 */

Transport.prototype.onClose = function () {
  this.readyState = 'closed';
  this.emit('close');
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.md-datepicker-input-mask{display:none}.mar-lr{margin:0 20px!important}.button-style{border-radius:25px;padding-left:20px;padding-right:20px}.maindiv .manage-width{width:10px}.viewStatus{padding:10px;text-transform:capitalize}.text-content{padding:20px}</style> <md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=\"md-whiteframe-5dp maindiv md-margin\" style=margin-top:16px flex> <div class=approvalBtnDiv flex layout=row layout-align=\"end start\" ng-show=!isAssignUsers> <md-button ng-if=\"newPlan && classroomDetails\" md-no-ink class=\"md-primary action-btn-clr button-style\" ng-click=getClassroomTopics()>Import from Google Classroom</md-button> <md-button ng-show=newPlan md-no-ink class=\"md-primary action-btn-clr button-style\" ng-click=selectFromArchive()>Select from Archive</md-button> </div> <div> <div layout=column layout-padding layout-wrap class=subDiv> <div layout=row class=\"theme-title mar-lr top_mar_20\" style=\"margin:0 8px\"> <div flex=90 class=theme-font>{{themeName}}</div> </div> <div layout=row layout-xs=column class=\"mar-lr md-whiteframe-5dp mar-lr div-margin\" style=\"margin:0 8px 8px 8px\"> <md-input-container flex=45 class=spaceClass> <label>Enter teaching plan </label> <input type=text txt-maxlength=100 required ng-model=teachingPlan.title /> <div class=errorMessage>{{errors['title']}}</div> </md-input-container> <md-input-container flex-gt-sm flex=25> <input mdc-datetime-picker=\"\" date=true time=false type=text placeholder=\"Start Date\" ng-model=teachingPlan.start_date ng-change=\"teachingPlan.end_date=undefined\" class=md-input required min-date=serverDate id=input_0> <div class=\"errorMessage date-error-space\">{{errors['start_date']}}</div> </md-input-container> <md-input-container flex-gt-sm flex=25> <input mdc-datetime-picker=\"\" date=true time=false type=text placeholder=\"End Date\" ng-model=teachingPlan.end_date class=md-input required min-date=teachingPlan.start_date id=input_0> <div class=\"errorMessage date-error-space\">{{errors['end_date']}}</div> </md-input-container> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=objectives> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>OBJECTIVES</b><i style=color:red>*</i></label> <md-button md-no-ink class=\"md-whiteframe-3dp button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('objectives', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.objectives></div> <div class=\"errorMessage field-error-space\">{{errors['objectives']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-disabled=true ng-model=teachingPlan.objectives_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=reqKwldge> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED KNOWLEDGE</b><i style=color:red>*</i></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('knowledge_required', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.knowledge_required></div> <div class=\"errorMessage field-error-space\">{{errors['knowledge_required']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-disabled=true ng-model=teachingPlan.knowledge_required_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=learnMat> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED LEARNING MATERIALS</b><i style=color:red>*</i></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('learning_materials', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.learning_materials></div> <div class=\"errorMessage field-error-space\">{{errors['learning_materials']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-disabled=true ng-model=teachingPlan.learning_materials_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=teachMeth> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED TEACHING METHODOLOGY</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('teaching_methodology', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.teaching_methodology></div> <div class=errorMessage>{{errors['teaching_methodology']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.teaching_methodology_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=lifeSkill> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED LIFE SKILLS</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('life_skills', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.life_skills></div> <div class=errorMessage>{{errors['life_skills']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.life_skills_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=reqConclusion> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED CONCLUSION</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('conclusion', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.conclusion></div> <div class=errorMessage>{{errors['conclusion']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.conclusion_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=forAssmnt> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED FORMATIVE ASSESSMENT</b></label> <div> <md-button md-no-ink class=\"md-whiteframe-3dp button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('formative_assessment', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.formative_assessment></div> <div class=errorMessage>{{errors['formative_assessment']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.formative_assessment_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=ict> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REQUIRED RESOURCES INCLUDING ICT</b></label> </div> </div> <div flex> <md-chips md-enable-chip-edit=true ng-model=teachingPlan.resources_including_ICT txt-maxlength=100 name=objectives readonly=teachingPlan.resources_including_ICT.readonly class=chip placeholder=\"Enter url and press enter\" secondary-placeholder=\"Enter url and press enter\" md-transform-chip=transformChip($chip,teachingPlan.resources_including_ICT)></md-chips> <div ng-if=\"errors['resources_including_ICT'] !== undefined\" class=errorMessage>{{errors['resources_including_ICT']}}</div> <div ng-repeat=\"item in teachingPlan.resources_including_ICT track by $index\" class=errorMessage>{{errors['resources_including_ICT.'+$index]}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.resources_including_ICT_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=flowTp> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>FLOW OF TEACHING PLAN</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('flow_of_tp', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.flow_of_tp></div> <div class=errorMessage>{{errors['flow_of_tp']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.flow_of_tp_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=remTp> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>REMEDIAL TEACHING PLAN</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('remedial_tp', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.remedial_tp></div> <div class=errorMessage>{{errors['remedial_tp']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.remedial_tp_status>visible to student</md-checkbox> </div> </div> <div layout=row ng-if=createResource style=margin-bottom:40px> <div class=\"teching-plan-scroll md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=forAssmnt> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>OTHER DETAILS</b></label> <div> <md-button md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=\"viewTextAngular('other_details', teachingPlan)\"> <div>Compose</div> </md-button> </div> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.other_details></div> <div class=errorMessage>{{errors['other_details']}}</div> </div> <md-checkbox ng-if=visibleToStudent ng-model=teachingPlan.other_details_status>visible to student</md-checkbox> </div> </div> <div layout=row class=create-resource ng-if=createResource> <div class=\"md-whiteframe-5dp align-margin\" flex=100> <div layout=row> <div flex=3 class=reqResource> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label flex class=lblHead><b>RESOURCES REQUIRED</b></label> <div class=\"btnPlus md-whiteframe-3dp my-icon-button\" tooltip=\"Add Resources\" tooltip-position=down> <i class=\"minusIcon color-white fas fa-plus\" ng-click=addNewResource()></i> </div> </div> </div> <div flex style=max-height:490px;overflow-y:scroll> <div ng-repeat=\"item in resource.file\"> <div layout=row class=chip> <div flex=25 class=res> <md-input-container class=md-block class=type> <label>Resource Type</label> <md-select ng-model=item.type ng-change=setDefaultTitle(item,$index,item.isPractice) ng-disabled=\"item.status==='approved'||item.status==='conducted'\"> <md-option ng-repeat=\"(key, value) in resourceTypes\" value={{key}}>{{value}}</md-option> </md-select> <div class=errorMessage>{{errors.resources[$index].type}}</div> </md-input-container> </div> <div flex=55 ng-if=\"item.type !== 'activityForm'\"> <md-input-container class=md-block layout-align=\"end end\"> <input mdinput placeholder=Title txt-maxlength=50 ng-model=item.title ng-disabled=\"item.status==='approved'||item.status==='conducted'\"> <div class=errorMessage>{{errors.resources[$index].title}}</div> <div class=errorMessage>{{errors.resourcefile[$index]}}</div> </md-input-container> </div> <div flex=40 ng-if=\"item.type === 'activityForm'\"> <md-input-container class=md-block layout-align=\"end end\"> <label>Title</label> <input type=text txt-maxlength=50 ng-model=item.title ng-disabled=\"item.status==='approved'||item.status==='conducted'\"/> <div class=errorMessage>{{errors.resources[$index].title}}</div> <div class=errorMessage>{{errors.resourcefile[$index]}}</div> </md-input-container> </div> <div ng-if=\"item.type === 'activityForm'\" flex=15 class=practice> <md-checkbox class=\"marginTop15 checkPractice\" ng-model=item.isPractice ng-disabled=\"item.status==='approved'||item.status==='conducted'\" ng-change=setDefaultTitle(item,$index,item.isPractice)> Practice Activity </md-checkbox> </div> <div flex> <div class=\"color-white btnMinus md-whiteframe-3dp my-icon-button\" tooltip=Remove tooltip-position=down ng-hide=\"item.status==='approved'||item.status==='conducted'\"> <i class=\"fas fa-minus\" ng-click=deleteResource($index) style=\"padding:3px 6px\"></i> </div> </div> <div flex=10 class=viewStatus ng-if=\"item.status != 'sent_for_approval'\" ng-model=item.status>{{item.status}}</div> <div flex=10 class=viewStatus ng-if=\"item.status === 'sent_for_approval'\">Sent for approval</div> </div> </div> </div> </div> </div> </div> </div> </div> <footer class=footer style=background:#1665c1> <div layout=row layout-align=\"center center\"> <div layout=row layout-align=space-between-center> <md-button ng-show=\"(isDraft && (!resource.file||resource.file.length===0))|| (newPlan&&!isAssignUsers&&(!resource.file||resource.file.length===0))\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('created')\">save <i class=\"far fa-save\"></i> </md-button> <md-button ng-show=\"(newPlan || isEdit) &&!isAssignUsers&&(!resource.file||resource.file.length===0)\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('draft')\">save as draft <i class=\"far fa-save\"></i> </md-button> <md-button ng-show=!isAssignUsers ng-click=gotoOverviewPage() class=tpFooter aria-label=Add style=background:#1665c1;padding-right:10px!important;padding-left:10px!important>cancel <i class=\"fas fa-times\"></i> </md-button> <md-button ng-show=\"(isDraft && resource.file.length>0)|| (newPlan&&!isAssignUsers&&resource.file.length>0)\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('created')\">save & next <i class=\"fas fa-chevron-right\"></i> </md-button> <md-button ng-show=\"newPlan&&!isAssignUsers&&resource.file.length>0\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('draft')\">save draft & next <i class=\"fas fa-chevron-right\"></i> </md-button> <md-button ng-show=\"isEdit&&!isDraft&&!isAssignUsers&&(!resource.file||resource.file.length===0)\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('created')\">update <i class=\"far fa-save\"></i> </md-button> <md-button ng-show=\"isEdit && !isDraft &&!isAssignUsers&&resource.file.length>0\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('created')\">update and next <i class=\"fas fa-chevron-right\"></i> </md-button> <md-button ng-show=\"isEdit && isDraft&&!isAssignUsers&&resource.file.length>0\" class=tpFooter aria-label=Add style=background:#1665c1 ng-click=\"save('draft')\">Save Draft and next <i class=\"fas fa-chevron-right\"></i> </md-button> </div> </div> </footer>";

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.viewTP .manage-width{width:10px}.md-select-menu-container{top:70px!important}.viewTP .fixed-width{width:275px}.text-content{padding:20px}</style> <script src=https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.0.272/jspdf.debug.js></script> <script src=https://cdnjs.cloudflare.com/ajax/libs/html2canvas/0.4.1/html2canvas.js></script> <md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=\"md-whiteframe-5dp viewTP md-margin\" flex> <div layout=row> <div layout=row class=complete-div-copy ng-show=\"editStatus&& isCreator\"> <div ng-show=\"isSetComplete && approvedResources.length>0 \"> <md-button class=\"md-primary addToQues action-btn-clr\" ng-click=showComplete()>Complete &nbsp;</md-button> </div> <div flex=70 style=max-width:280 ng-show=isShowApprovedResources&&isCreator> <md-input-container class=\"md-block fixed-width\" ng-show=\"approvedResources.length>0\" class=type> <label>Select Resources to set Complete</label> <md-select ng-model=selectedApprovedResources multiple=multiple ng-change=\"changeResources('complete')\"> <md-input-container class=align-checkbox><md-checkbox class=select-all-opt ng-if=\"selectedApprovedResources.length!==approvedResourcesIds.length\" ng-model=selectAllStudent.check ng-change=\"selectAllResources('complete')\">Select All</md-checkbox></md-input-container> <md-option ng-repeat=\"resource in approvedResources\" ng-value=resource._id>{{resourceTypes[resource.type]}}-{{resource.title}}</md-option> </md-select> </md-input-container> </div> <div ng-show=isShowComplete&&isCreator&&!isCompleted> <md-button class=\"md-primary addToQues action-btn-clr\" ng-click=setCompleteStatus()>Complete &nbsp;&nbsp;&nbsp;</md-button> <md-button ng-show=\"!isShowComplete && isCreator && !isCompleted\" class=tp-complete-btn ng-click=setCompleteStatus()>Complete &nbsp;&nbsp;&nbsp;</md-button> </div> <div ng-show=isShowTpComplete&&isCreator> <md-button ng-show=\"!isShowComplete && isCreator && !isCompleted\" class=\"md-primary addToQues action-btn-clr\" ng-click=setCompleteStatus()>Complete &nbsp;&nbsp;&nbsp;</md-button> </div> <div class=\"tp-status tp-completed-status md-whiteframe-2dp\" ng-show=isCompleted&&isCreator>Completed</div> </div> <div class=\"approvalBtnDiv complete-div-copy\" flex layout=row layout-align=\"end start\"> <md-button ng-if=!isCreated&&!isSentforApproval&&isStatusAdded&&((tpUserPrivilege.approveTeachingPlan&&tpUserPrivilege.approveTeachingPlan.create)||(tpUserPrivilege.newTeachingPlan&&tpUserPrivilege.newTeachingPlan.create))&&classroomDetails md-no-ink class=\"md-primary action-btn-clr button-style\" ng-click=exportToClassroom()>Export to Google Classroom</md-button> <md-button ng-show=isCreator&&!isUserAssigned&&!isSubmitApproval class=\"button-style addToQues md-primary action-btn-clr\" ng-click=showAssignUser()>Assign Students</md-button> <md-button ng-show=isUserAssigned&&!isSubmitApproval&&!isCompleted&&isCreator class=\"btn-fixd-siz md-primary addToQues action-btn-clr\" ng-click=showAssignUser()>Reassign Students</md-button> <md-button ng-show=isCreator&&isCreated&&!isSubmitApproval&&!isSentforApproval class=\"button-style md-primary addToQues action-btn-clr\" ng-click=submitforApprovalClick()>Submit for Approval</md-button> <md-button ng-show=!isCreated&&editStatus&&!isSubmitApproval&&isSentforApproval&&isCreator&&!isCompleted class=\"tp-re-assign-btn addToQues action-btn-clr\" ng-click=submitforApprovalClick()>Resubmit for Approval</md-button> <div class=\"tp-status tp-sent-status md-whiteframe-2dp\" ng-show=!isCreated&&!isSentforApproval&&isStatusAdded&&((tpUserPrivilege.approveTeachingPlan&&tpUserPrivilege.approveTeachingPlan.create)||(tpUserPrivilege.newTeachingPlan&&tpUserPrivilege.newTeachingPlan.create)) ng-class=\"isApproved?'tp-approve-status':'tp-reject-status'\">{{preetyStatus}}</div> <md-input-container class=md-block ng-show=\"approveResources.length>0&&tpUserPrivilege.approveTeachingPlan.create&&isApprover\" class=type flex=20> <label>Select Resources to Approve</label> <md-select ng-model=selectedResourcesforApproval multiple=multiple ng-change=\"changeResources('approve')\"> <md-input-container class=align-checkbox><md-checkbox class=select-all-opt ng-model=selectAllStudent.check ng-change=\"selectAllResources('approve')\">Select All</md-checkbox></md-input-container> <md-option ng-repeat=\"resource in approveResources\" ng-value=resource._id>{{resourceTypes[resource.type]}}-{{resource.title}}</md-option> </md-select> </md-input-container> <md-button ng-show=\"tpUserPrivilege.approveTeachingPlan.create&&isApprover && !isApproved\" class=\"tp-re-assign-btn md-primary addToQues action-btn-clr\" ng-click=approve()>Approve</md-button> <md-button ng-show=\"tpUserPrivilege.approveTeachingPlan.create&&isApprover && !isApproved\" class=\"md-primary tp-re-assign-btn addToQues action-btn-clr\" ng-click=reject()>Reject</md-button> </div> </div> <div ng-show=isSubmitApproval layout-margin layout=row layout-align=\"start start\"> <md-input-container class=md-block class=type flex=20> <label>Select Approver Role</label> <md-select ng-model=approverRole ng-change=filterPerson(role.users)> <md-option ng-repeat=\"role in approverRoles\" ng-value=role._id>{{role.name}}</md-option> </md-select> <div class=errorMessage>{{approverRoleError}}</div> </md-input-container> <md-input-container class=md-block class=type flex=20> <label>Select Approver</label> <md-select ng-model=approverPerson> <md-option ng-repeat=\"person in approverRolePersons\" ng-value=person._id>{{person.name}}</md-option> </md-select> <div class=errorMessage>{{approverPersonError}}</div> </md-input-container> <md-input-container class=md-block ng-show=\"contentCreatedResources.length>0\" class=type flex=20> <label>Select Resources to submit for approval</label> <md-select ng-model=selectedResources multiple=multiple ng-change=\"changeResources('submit')\"> <md-input-container class=align-checkbox><md-checkbox class=select-all-opt ng-model=selectAllStudent.check ng-change=\"selectAllResources('submit')\">Select All</md-checkbox></md-input-container> <md-option ng-repeat=\"resource in contentCreatedResources\" ng-value=resource._id>{{resourceTypes[resource.type]}}-{{resource.title}}</md-option> </md-select> </md-input-container> <md-button class=\"action-btn-clr tp-re-assign-btn addToQues tp-complete-btn\" flex=5 ng-click=submitforApproval()>Submit</md-button> <md-button class=\"action-btn-clr tp-re-assign-btn addToQues tp-complete-btn\" flex=5 ng-click=cancelApproval()>Cancel <i class=\"fas fa-times\"></i> </md-button> </div> <div layout-padding layout-wrap class=subDiv id=myCanvas style=margin-bottom:45px> <div layout=row class=theme-title> <div flex=50 class=\"titleHead spaceClass\" layout-align=\"start center\"> <h4 class=\"mar_left_15 top_pad_10\" style=\"font-size:16px;font-weight:700;margin:8px 10px\">Theme : {{teachingPlan.theme_title}}</h4> </div> <div flex=50 class=\"titleHead spaceClass\" layout-align=\"start center\"> <h4 class=top_pad_10 style=\"font-size:16px;font-weight:700;margin:8px 10px\">Teaching Plan : {{teachingPlan.title}}</h4> </div> <div flex=10 layout=row layout-align=\"end start\" ng-if=editStatus&&isCreator&&!isCompleted> <md-tooltip>Edit Page</md-tooltip> <div class=marTop ng-click=gotoEdit()> <div class=\"editIcon md-whiteframe-2dp\"><i class=\"far fa-edit\" style=padding-top:7px></i></div> </div> </div> </div> <div layout=row class=tp-details> <div class=spaceClass><b>Start Date :{{teachingPlan.start_date| date: \"dd.MM.y\"}}</b></div> <div class=\"\"><b>End Date :{{teachingPlan.end_date| date: \"dd.MM.y\"}}</b></div> </div> <div layout=column layout-sm=column layout-xs=column layout-wrap> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=teachingPlan.objectives> <div layout=row> <div class=objectives flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>OBJECTIVES</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.objectives></div> </div> </div> <div class=\"md-whiteframe-5dp borderaround\" ng-show=teachingPlan.knowledge_required> <div layout=row> <div class=reqKwldge flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED KNOWLEDGE</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.knowledge_required></div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=teachingPlan.learning_materials> <div layout=row> <div class=learnMat flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED LEARNING MATERIALS</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.learning_materials></div> </div> </div> <div class=\"md-whiteframe-5dp borderaround\" ng-show=\"((tpUserPrivilege.visibleToStudent.read && teachingPlan.teaching_methodology_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))&&teachingPlan.teaching_methodology \"> <div layout=row> <div class=teachMeth flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED TEACHING METHODOLOGY</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.teaching_methodology></div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=\"((tpUserPrivilege.visibleToStudent.read && teachingPlan.life_skills_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))&&teachingPlan.life_skills\"> <div layout=row> <div class=lifeSkill flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED LIFE SKILLS</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.life_skills></div> </div> </div> <div class=\"md-whiteframe-5dp borderaround\" ng-show=\"teachingPlan.conclusion&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.conclusion_status) || (tpUserPrivilege.visibleToStudent.create) ||(tpUserPrivilege.approveTeachingPlan.create))\"> <div layout=row> <div class=reqConclusion flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED CONCLUSION</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.conclusion></div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=\"teachingPlan.formative_assessment&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.formative_assessment_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))\"> <div layout=row> <div class=forAssmnt flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED FORMATIVE ASSESSMENT</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.formative_assessment></div> </div> </div> <div class=\"md-whiteframe-5dp borderaround\" ng-if=\"teachingPlan.resources_including_ICT.length!=0&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.resources_including_ICT_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))\"> <div> <div layout=row> <div class=ict flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REQUIRED RESOURCES INCLUDING ICT</b></label> </div> </div> <div flex> <div ng-repeat=\"resICT in teachingPlan.resources_including_ICT\"> <div class=md-padding layout=row> <div><i class=\"fas fa-angle-right\"></i></div> <div> <label class=linkContent flex ng-click=gotoSite(resICT)>{{resICT}}</label> </div> </div> <md-divider class=dividerMargin></md-divider> </div> </div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=\"teachingPlan.flow_of_tp&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.flow_of_tp_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))\"> <div layout=row> <div class=forAssmnt flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>FLOW OF TEACHING PLAN</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.flow_of_tp></div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=\"teachingPlan.remedial_tp&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.remedial_tp_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))\"> <div> <div layout=row> <div class=forAssmnt flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>REMEDIAL TEACHING PLAN</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.remedial_tp></div> </div> </div> </div> <div class=\"md-whiteframe-5dp spaceClass borderaround\" ng-show=\"teachingPlan.other_details&&((tpUserPrivilege.visibleToStudent.read && teachingPlan.other_details_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create))\"> <div> <div layout=row> <div class=ict flex=3><img src=" + __webpack_require__(6) + "></div> <div class=divColor flex layout=row> <label class=lblHead><b>OTHER DETAILS</b></label> </div> </div> <div flex> <div class=text-content ng-bind-html=teachingPlan.other_details></div> </div> </div> </div> </div> <div layout=row flex=100 class=tpDiv ng-if=\"!teachingPlan.flow_of_tp && ( teachingPlan.flow_of_lesson.engage || teachingPlan.flow_of_lesson.explore || teachingPlan.flow_of_lesson.explain || teachingPlan.flow_of_lesson.elaborate ||  teachingPlan.flow_of_lesson.evaluate)\"> <div style=margin-right:20px class=md-whiteframe-5dp flex=100 ng-if=\"(tpUserPrivilege.visibleToStudent.read && teachingPlan.flow_of_lesson_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create) \"> <div layout=row> <div flex=3 class=flowTp> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label class=lblHead><b>FLOW OF TEACHING PLAN</b></label> </div> </div> <div layout=row layout-wrap> <div flex=100 class=md-padding ng-if=teachingPlan.flow_of_lesson.engage> <label class=lblData><b>Engage</b> </label> <br> <span class=lblContent> {{teachingPlan.flow_of_lesson.engage}}</span> </div> <div flex=100 class=md-padding ng-if=teachingPlan.flow_of_lesson.explore> <label class=lblData><b>Explore </b></label> <br> <span class=lblContent> {{teachingPlan.flow_of_lesson.explore}}</span> </div> <div flex=100 class=md-padding ng-if=teachingPlan.flow_of_lesson.explain> <label class=lblData><b>Explain </b></label> <br> <span class=lblContent> {{teachingPlan.flow_of_lesson.explain}}</span> </div> <div flex=100 class=md-padding ng-if=teachingPlan.flow_of_lesson.elaborate> <label class=lblData><b>Elaborate</b> </label> <br> <span class=lblContent> {{teachingPlan.flow_of_lesson.elaborate}}</span> </div> <div flex=100 class=md-padding ng-if=teachingPlan.flow_of_lesson.evaluate> <label class=lblData><b>Evaluate</b> </label> <br> <span class=lblContent> {{teachingPlan.flow_of_lesson.evaluate}}</span> </div> </div> </div> </div> <div layout=row flex=100 class=tpDiv ng-if=\"!teachingPlan.remedial_tp && (teachingPlan.remedial_teaching_plan.problem_identify || teachingPlan.remedial_teaching_plan.messure_to_taken || teachingPlan.remedial_teaching_plan.resources_need || teachingPlan.remedial_teaching_plan.feedback)\"> <div style=margin-right:20px class=md-whiteframe-5dp flex=100 ng-if=\"(tpUserPrivilege.visibleToStudent.read && teachingPlan.remedial_teaching_plan_status) || (tpUserPrivilege.visibleToStudent.create) || (tpUserPrivilege.approveTeachingPlan.create) \"> <div layout=row> <div flex=3 class=remTp> <div class=manage-width><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label class=lblHead><b>REMEDIAL TEACHING PLAN</b></label> </div> </div> <div layout=row layout-wrap> <div flex=50 class=md-padding ng-if=teachingPlan.remedial_teaching_plan.problem_identify> <label class=lblData><b>Problem identify</b> </label> <br> <span class=lblContent> {{teachingPlan.remedial_teaching_plan.problem_identify}}</span> </div> <div flex=50 class=md-padding ng-if=teachingPlan.remedial_teaching_plan.messure_to_taken> <label class=lblData><b>Messure to taken</b> </label> <br> <span class=lblContent> {{teachingPlan.remedial_teaching_plan.messure_to_taken}}</span> </div> <div flex=50 class=md-padding ng-if=teachingPlan.remedial_teaching_plan.resources_need> <label class=lblData><b>Resources need </b></label> <br> <span class=lblContent> {{teachingPlan.remedial_teaching_plan.resources_need}}</span> </div> <div flex=50 class=md-padding ng-if=teachingPlan.remedial_teaching_plan.feedback> <label class=lblData><b>Feedback</b> </label> <br> <span class=lblContent> {{teachingPlan.remedial_teaching_plan.feedback}}</span> </div> </div> </div> </div> <div layout=row flex=100 ng-if=\"teachingPlan.resources.length > 0 && editStatus&&isCreator\"> <div class=md-whiteframe-5dp flex=100> <div layout=row> <div flex=5 class=reqResource> <div><img src=" + __webpack_require__(6) + "></div> </div> <div class=divColor flex layout=row> <label class=lblHead><b>RESOURCES REQUIRED</b></label> </div> </div> <div class=md-margin layout=row ng-repeat=\"resources in teachingPlan.resources\" style=\"margin-left:20px!important;margin-right:20px!important;border-bottom:1px solid #e1e1e1\"> <div flex=15 class=\"md-padding left-pad-nill\" style=padding-left:0!important> <label class=lblData><b>{{resourceTypes[resources.type]}} </b></label> </div> <div flex=70 class=md-padding> <span class=lblContent>{{resources.title}}</span> </div> </div> </div> </div> </div> </div> <footer class=footer style=background:#1665c1> <div layout=row layout-align=\"center center\"> <div layout=row layout-align=space-between-center> <md-button ng-click=gotoauthoringtool() data-tooltip-direction=w class=tp-footer aria-label=Add style=background:#1665c1;color:#fff>Cancel <i class=\"fas fa-lg fa-times\"></i> </md-button> <md-button ng-show=\"teachingPlan.resources.length>0 && (editStatus ||   approveMode  || isStudent )\" ng-click=viewWizard() class=tp-footer aria-label=Add style=background:#1665c1>Next <i class=\"fas fa-lg fa-chevron-right\"></i> </md-button> </div> </div></footer> ";

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style></style> <md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=wizard title=\"Add Notes\" ng-show=noteUserPrivilege.note&&noteUserPrivilege.note.create> <img src=" + __webpack_require__(888) + " class=\"md-whiteframe-3dp img_note\" ng-click=addNote() /> </div> <div class=\"md-whiteframe-3dp wizard aroundMargin\" flex> <div class=approvalBtnDiv flex layout=row layout-align=\"end start\"> <md-button ng-show=\"!isSubmitApproval&&!isUserAssigned&&wizardUserPrivilege.assignUsers&&wizardUserPrivilege.assignUsers.create && !isCompleted&&isCreator&& !isReport &&!isActivityConducted\" class=\"md-primary addToQues addToQues action-btn-clr\" ng-click=showAssignUser()>Assign Students</md-button> <div class=\"tp-status tp-completed-status md-whiteframe-2dp\" ng-show=\"isCompleted && wizardUserPrivilege.enableToggleView&&wizardUserPrivilege.enableToggleView.edit&&isCreator\">Completed</div> <md-button class=\"md-primary addToQues action-btn-clr\" ng-show=\"isShowComplete && wizardUserPrivilege.assignUsers&&wizardUserPrivilege.assignUsers.edit&&isCreator\" ng-click=setCompleteStatus()>Complete &nbsp;&nbsp;</md-button> <md-button ng-show=\"!isSubmitApproval&&isUserAssigned&&wizardUserPrivilege.enableToggleView&&wizardUserPrivilege.enableToggleView.edit && !isCompleted&&isCreator&& !isReport &&!isActivityConducted\" class=\"md-primary addToQues auto-btn action-btn-clr\" ng-click=showAssignUser()>Reassign Students</md-button> <md-button ng-show=\"!isDraft&&!isSubmitApproval&&isCreated && wizardUserPrivilege.enableToggleView&&wizardUserPrivilege.enableToggleView.edit&&!isSentforApproval&&isCreator&& !isReport &&!isActivityConducted\" class=\"md-primary addToQues auto-btn action-btn-clr\" aria-label=Submit style=background:#1665c1 ng-click=submitforApprovalClick()>Submit for approval</md-button> <md-button ng-show=\"!isDraft&&!isSubmitApproval&& wizardUserPrivilege.enableToggleView&&wizardUserPrivilege.enableToggleView.edit&&isSentforApproval&&isCreator&& !isReport &&!isActivityConducted\" class=\"md-primary addToQues action-btn-clr\" aria-label=Submit style=background:#1665c1 ng-click=submitforApprovalClick()>Resubmit for approval</md-button> <md-button ng-show=isSentforApproval&&wizardUserPrivilege.approveResource&&wizardUserPrivilege.approveResource.create&&isApprover class=\"md-primary addToQues action-btn-clr\" ng-click=\"setResourceStatus('approved')\">Approve</md-button> <md-button ng-show=isSentforApproval&&wizardUserPrivilege.approveResource&&wizardUserPrivilege.approveResource.create&&isApprover class=\"md-primary addToQues action-btn-clr\" ng-click=\"setResourceStatus('rejected')\">Reject</md-button> <div class=\"tp-status md-whiteframe-2dp\" ng-class=\"isApproved?'tp-approve-status':'tp-reject-status'\" ng-show=!isCreated&&!isSubmitApproval&&!isSentforApproval&&isStatusAdded&&(wizardUserPrivilege.viewStatus&&wizardUserPrivilege.viewStatus.read)&&!isCompleted>{{preetyStatus}}</div> </div> <div ng-show=isSubmitApproval layout-margin layout=row layout-align=start-start class=\"md-whiteframe-2dp manage-approve\"> <md-input-container class=md-block class=type flex=20> <label>Select Approver Role</label> <md-select ng-model=approverRole ng-change=filterPerson(role.users)> <md-option ng-repeat=\"role in approverRoles\" ng-value=role._id>{{role.name}}</md-option> </md-select> <div class=errorMessage>{{approverRoleError}}</div> </md-input-container> <md-input-container class=md-block class=type flex=20> <label>Select Approver</label> <md-select ng-model=approverPerson> <md-option ng-repeat=\"person in approverRolePersons\" ng-value=person._id>{{person.name}}</md-option> </md-select> <div class=errorMessage>{{approverPersonError}}</div> </md-input-container> <md-button class=\"md-primary addToQues action-btn-clr\" flex=5 ng-click=submitforApproval()>Submit</md-button> <md-button class=\"md-primary addToQues action-btn-clr\" flex=5 ng-click=cancelApproval()>Cancel</md-button> </div> <div layout=row class=wizard-menu flex> <div class=wrapper layout=column flex=10 flex-md=15 flex-sm=20 flex-xs=30> <div style=top:0 data-reactid=3 flex> <div> <div class=tutorialNav id=style-4 layout-align=center> <div class=editViewToggle layout=row ng-if=wizardUserPrivilege.enableToggleView.edit&&isCreator> <div class=\"editButton center-txt\" ng-click=gotoEditMode() ng-class=\"isViewMode?'toggleActive':'toggleInactive'\" flex=50 style=padding-bottom:3px> <i class=\"fas fa-pen\"></i> </div> <div class=\"viewButton center-txt\" ng-click=gotoViewMode() ng-class=\"!isViewMode?'toggleActive':'toggleInactive'\" flex=50> <img src=" + __webpack_require__(889) + " style=height:24px;width:24px ng-if=!isViewMode /> <img src=" + __webpack_require__(890) + " ng-if=isViewMode /> </div> </div> <div class=containerSubway ng-repeat=\"arr in wizardItems\"> <div class=item_3iz title={{arr.caption}} ng-class=\"{inactive_background :arr.active==false,active_background:arr.active==true}\"> <a class=link_1uv ng-click=clicked(arr)> <div> <div class=container_3v> <div ng-if=!$first class=topTrack ng-class=\"{on_visit : arr.visited==true&&arr.active==false, not_visit : arr.visited==false&&arr.active==false,active:arr.active==true}\"></div> <div class=circle ng-class=\"{on_visit : arr.visited==true&&arr.active==false, not_visit : arr.visited==false&&arr.active==false,active:arr.active==true}\"> <div class=hvr-bounce-in> <span aria-label=Video style=margin:2px;margin-top:0 class=iconWrap_1qbyypy> <img ng-src={{arr.imgUrl}} width=20></span><span aria-label=started> </span> </div> </div> <div ng-if=!$last class=bottomTrack ng-class=\"{on_visit : arr.visited==true&&arr.active==false, not_visit : arr.visited==false&&arr.active==false,active:arr.active==true}\"></div> </div> </div> </a> </div> </div> </div> </div> </div> </div> <div class=\"layout-padding contentArea border-radius: 4px;\" style=background-color:#fff;padding:0!important layout=column flex> <div class=resourcesArea style=padding:0!important flex layout=column> <div class=\"heading md-whiteframe-2dp\" style=margin-top:0!important layout=row> <div layout=row flex=50>Theme : {{themeTitle}}</div> <div layout=row flex=50> Teaching Plan : {{planTilte}}</div> </div> <div ui-view=tpWizardView flex></div> </div> </div> <div class=note_ctrl flex=80 flex-gt-xs=80 flex-lg=83 flex-md=83 layout-align=\"end end\" ng-show=writeNote> <div class=\"md-whiteframe-5dp addNote\"> <div class=note-bar layout=row flex=100 layout-align=\"space-between center\"> <div flex=90> <md-checkbox ng-model=toArchive ng-show=noteUserPrivilege.addArchive&&noteUserPrivilege.addArchive.create>Add to Archive</md-checkbox> </div> <div flex=10 style=margin-left:40px> <img style=margin-left:-18px class=close src=" + __webpack_require__(90) + " ng-click=closeNote()> </div> </div> <md-input-container class=\"md-block note-content\" flex-gt-sm> <label>Enter Notes</label> <textarea focus-it=true name=notes ng-model=userNotes> </textarea> </md-input-container> </div> </div> </div> </div>";

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.rcHead{background-color:#00ba9c;padding:10px!important;border-radius:10px}.icon-button{position:relative}.icon-button:hover{cursor:pointer}.icon-button:active{background:#ccc}.icon-button__badge{position:absolute;top:-10px;right:-10px;width:102px;height:25px;background:#ff0;color:#439e88;display:flex;justify-content:center;align-items:center;border-radius:22%}#manage_reports{font-family:Roboto Condensed}.mb{margin-bottom:42px}.accDiv{background:#e3fbe8;padding:5px;border-radius:5px}#manage_reports md-tabs md-tabs-canvas{background-color:#bde0fd}#manage_reports md-tabs md-tab-item{border-right:1px solid #fff;font-weight:700;outline:0}#manage_reports md-tabs .md-tab.md-active{color:#5173bb;background-color:#fff}</style> <div ng-if=!pdfData id=manage_reports> <md-backdrop style=position:fixed!important;z-index:59!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div ng-if=!pdfData layout-padding=\"\" class=\"md-whiteframe-3dp report margin_20 layout-padding _md flex\" flex=\"\" style=background:#fff;padding:10px;overflow:auto> <md-content class=\"formatQuestion padding-lr-que\"> <md-tabs md-dynamic-height md-border-bottom=true md-selected=manageReportCardsCtrl.selected_tab> <md-tab label=\"Available formats\" md-on-select=reset(false)> <md-content class=md-padding> <div ng-if=pdfClicked layout=row layout-align=\"end end\"> <iframe flex=75 ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:75%;height:600px allowfullscreen></iframe> <div flex=15> <md-button class=\"mb md-raised md-primary\" ng-click=closepdf();>Close</md-button> </div> </div> <div layout=row layout-align=\"end end\"> <md-button ng-disabled=!rc_selection.selected_any flex=15 class=\"mb md-raised md-primary\" ng-click=confirmToArchive()>Move to archives </md-button> <md-checkbox ng-model=rc_selection.all_selected ng-change=selectAllRcs(rc_selection) aria-label=\"Checkbox 1\" class=mb> {{rc_selection.txt}} </md-checkbox> </div> <div> <div layout=column flex=100 layout-wrap=\"\" class=\"mainFilter layout-wrap layout-column flex-100\"> <div class=no_data ng-show=\"!manageReportCardsCtrl.availableFormats || !manageReportCardsCtrl.availableFormats.length\"> No reports </div> <div layout=row flex=100 layout-align=\"space-between center\" layout-wrap class=\"questionsContent notification-badges\" ng-model=manageReportCardsCtrl.availableFormats ng-if=\"manageReportCardsCtrl.availableFormats && manageReportCardsCtrl.availableFormats.length\"> <div flex=45 class=\"md-accordion eachQues\" ng-repeat=\"format in manageReportCardsCtrl.availableFormats track by $index\"> <div ng-init=\"format.expanded = false\" layout-align=\"space-between center\" class=\"accordianHeading rcHead icon-button\" style=background-color:#397fb9 layout=row> <div class=\"plusMinus qp_sections\" layout=row> <div layout=row> <i class=\"fas fa-bars icons-drag hand\" style=margin-right:5px></i> <md-checkbox ng-change=selectOneRcToArchive(format) ng-model=format.to_archive aria-label=\"Checkbox 1\"> </md-checkbox> <span class=sectionFontOriginalOriginal>{{$index+1}}.&nbsp;{{format.name}}</span> </div> </div> <div flex=15 ng-click=toggleExpansion(manageReportCardsCtrl.availableFormats,format,$index) layout=row layout-align=\"space-around center\" title=\"Drop down\"> <span ng-if=format.code>Code:{{format.code}}&nbsp;&nbsp;</span> <i class=\"fas fa-angle-down icons-margin hand\" ng-if=\"format.expanded==false\"></i> <i class=\"fas fa-angle-up icons-margin hand\" ng-if=\"format.expanded==true\" style=padding-right:5px></i> </div> <span ng-show=!format.isassigned class=icon-button__badge>Not assigned</span> </div> <div class=\"accordianContent accDiv\"> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:format.expanded}\" layout=column> <div layout=row> <div style=padding:10px layout=column flex=80 layout-align=\"space-around strech\"> <div style=color:grey;font-size:15px class=md-subhead><label>Report name</label></div> <div class=hundred_percent_width>{{format.name}}</div> </div> <div flex=20> <img title=\"Click to view preview\" class=hand ng-click=showPrev(format) style=width:100% src=/img/images/pdfsample.jpg> </div> </div> <md-divider></md-divider> <div style=padding:10px layout=column flex=100 layout-align=\"space-around strech\"> <div style=color:grey;font-size:15px class=md-subhead><label>Report description</label></div> <div style=margin-top:2px ng-if=format.description class=hundred_percent_width>{{format.description}}</div> <div style=margin-top:2px class=hundred_percent_width ng-if=!format.description>Not Added</div> </div> <md-divider></md-divider> <div layout=row layout-align=\"space-between center\"> <div ng-show=format.total_classes style=padding:10px;background:#bde0fd;color:#397fb9;border-radius:5px class=icons-margin>No. Of Classes Assigned : {{format.total_classes}}</div> <md-button ng-click=\"manageReportCardsCtrl.OneRcController(format, \n                                                    $index)\" flex=25 class=\"md-raised md-primary\">View and edit </md-button> </div> </div> </div> </div> </div> </div> </div></md-content> </md-tab> <md-tab label=\"Archived formats\" md-on-select=reset(true)> <md-content class=md-padding> <div layout=row layout-align=\"end end\" style=height:30px> <md-button ng-disabled=true flex=15 class=\"md-raised md-primary\" ng-click=confirmToArchive(true)>Restore</md-button> <md-checkbox ng-model=rc_selection.all_selected ng-change=\"selectAllRcs(rc_selection, true)\" aria-label=\"Checkbox 1\"> {{rc_selection.txt}} </md-checkbox> </div> <div> <div layout=column flex=100 layout-wrap=\"\" class=\"mainFilter layout-wrap layout-column flex-100\"> <div class=no_data ng-show=\"!manageReportCardsCtrl.archived_templates || !manageReportCardsCtrl.archived_templates.length\"> No reports </div> <div layout=row flex=100 layout-align=\"space-between center\" layout-wrap class=\"questionsContent notification-badges\" ng-model=manageReportCardsCtrl.archived_templates> <div flex=45 class=\"md-accordion eachQues\" ng-repeat=\"format in manageReportCardsCtrl.archived_templates track by $index\"> <div ng-init=\"format.expanded = false\" layout-align=\"space-between center\" class=\"accordianHeading rcHead icon-button\" style=background-color:#397fb9 layout=row> <div class=\"plusMinus qp_sections\" layout=row> <div layout=row> <i class=\"fas fa-bars icons-drag hand\" style=margin-right:5px></i> <md-checkbox ng-change=\"selectOneRcToArchive(format, true)\" ng-model=format.to_archive aria-label=\"Checkbox 1\"> </md-checkbox> <span class=sectionFontOriginalOriginal>{{$index+1}}.&nbsp;{{format.name}}</span> </div> </div> <div flex=15 layout=row layout-align=\"space-around center\" ng-click=toggleExpansion(manageReportCardsCtrl.archived_templates,format,$index)> <span ng-if=format.code>Code:{{format.code}}&nbsp;&nbsp;</span> <i class=\"fas fa-angle-down icons-margin hand\" ng-if=\"format.expanded==false\" title=\"Drop down\"></i> <i class=\"fas fa-angle-up icons-margin hand\" ng-if=\"format.expanded==true\" style=padding-right:5px></i> </div> </div> <div class=\"accordianContent accDiv\"> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:format.expanded}\" layout=column> <div layout=row> <div style=padding:10px layout=column flex=80 layout-align=\"space-around strech\"> <div style=color:grey;font-size:15px class=md-subhead><label>Report name</label></div> <div class=hundred_percent_width>{{format.name}}</div> </div> <div flex=20> <img style=width:100% src=/img/images/pdfsample.jpg> </div> </div> <md-divider></md-divider> <div style=padding:10px layout=column flex=100 layout-align=\"space-around strech\"> <div style=color:grey;font-size:15px class=md-subhead><label>Report description</label></div> <div class=hundred_percent_width ng-if=format.description>{{format.description}}</div> <div style=margin-top:2px class=hundred_percent_width ng-if=!format.description>Not Added</div> </div> <md-divider></md-divider> </div> </div> </div> </div> </div> </div></md-content> </md-tab> <md-tab label=\"Assign reports\" md-on-select=reset(false)> <md-content class=md-padding> <div flex=\"\" layout=row layout-xs=column layout-sm=column flex-xs=\"\" flex-sm=\"\" layout-padding=\"\" style=background:#fff class=\"layout-padding layout-xs-column layout-sm-column layout-row flex-xs flex-sm flex\"> <md-input-container style=margin-left:10px flex=\"\" class=\"flex md-input-has-value\"> <label for=select_4 class=\"\">Session</label> <md-select ng-model=\"filterObj['session']\" ng-change=\"setSessionFilters(filterObj['session'])\"> <md-option value={{sesName._id}} ng-click=\"manageReportCardsCtrl.setSessionFilters(sesName._id);setFilterObj(sesName._id,'Session')\" ng-repeat=\"sesName in manageReportCardsCtrl.sessionArray  | orderBy:'name'\"> {{sesName.name}} </md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_6 class=\"\">Curriculum</label> <md-select ng-model=\"filterObj['curriculum']\"> <md-option value={{curName._id}} ng-click=\"manageReportCardsCtrl.getClass(curName._id);setFilterObj(curName._id,'Curriculum')\" ng-repeat=\"curName in manageReportCardsCtrl.curriculumArray | orderBy:'name'\"> {{curName.name}} </md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_8 class=\"\">Class</label> <md-select ng-change=\"selectClasses(filterObj['xclass']);\" ng-model=\"filterObj['xclass']\" multiple=multiple> <md-checkbox ng-if=isClass ng-change=\"selectClasses('all');\" aria-label=\"Checkbox 1\" style=margin-bottom:0;margin-left:10px> All </md-checkbox> <md-option value={{clsName._id}} ng-repeat=\"clsName in manageReportCardsCtrl.classArray \"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_10 class=\"\">Select Reports</label> <md-select ng-model=\"filterObj['templates']\" multiple=multiple> <md-option value={{clsName._id}} ng-repeat=\"clsName in manageReportCardsCtrl.availableFormats\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <button class=\"md-raised md-primary md-button md-ink-ripple rep-btn\" type=button ng-click=searchValuesBasedOnFilter($event) ng-disabled=true> ASSIGN REPORT <div class=md-ripple-container style=\"\"></div> </button> </div> </md-content> </md-tab> </md-tabs> </md-content> </div> </div> <md-content ng-cloak ng-if=!pdfData class=\"controls space-around md-whiteframe-3dp margin_20 bgColor pages\"> </md-content> <div ng-if=pdfData> <div class=main_bg><small> <iframe ng-src={{item.path}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe></small> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <div class=\"md-button md-ink-ripple\" style=\"border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px\" ng-if=pdfData ng-click=backToHtml()> <span class=\"\"> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;padding-top:5px;float:left>Back to html</span> <span style=border:none;padding-top:8px class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(365) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:8px> </span> </span> </div> </div> </div> </div> </div>";

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.disable_mode{opacity:.4}.pull-right{float:right!important}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.head-capitalize{text-transform:capitalize}.child_key{font-weight:600}.table-content{height:74vh}.pagination ul>.active>a,.pagination ul>.active>span{color:#999;cursor:default}.pagination ul>.active>a,.pagination ul>.active>span,.pagination ul>li>a:hover{background-color:#f5f5f5}.pagination ul>li>a,.pagination ul>li>span{float:left;padding:0 14px;line-height:38px;text-decoration:none;background-color:#fff;border:1px solid #ddd}.pagination ul>li{display:inline}a{color:#08c;text-decoration:none}.inner-table{border-bottom:1px solid #dadada}.inner-last-table{border:none}.report_table th{padding-top:15px;padding-bottom:15px;background:#dbecff;text-align:center;cursor:pointer}.report_table th,td{border:1px solid #dadada}.selectdemoSelectHeader .demo-header-searchbox{border:none;outline:0;height:100%;width:100%;padding:0}.selectdemoSelectHeader .demo-select-header{padding-left:10.667px;height:48px;cursor:pointer;position:relative;display:flex;align-items:center;width:auto}.selectdemoSelectHeader md-content._md{max-height:240px}.btn-line{line-height:0!important}.nav-icon-selected{font-size:20px;padding:0;color:#000;height:7px!important}.nav-icon{font-size:20px;padding:0;color:grey;height:7px!important}.main-content{overflow-x:auto!important}.custom-label{font-style:oblique;font-size:larger;min-width:182px;font-weight:700!important}.publish-report-filter{background:#d76974!important;text-transform:uppercase;width:100%;color:#fff!important;border:none}.pull-right{float:right!important}</style> <md-content layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <div layout=row flex=100 layout-wrap class=mainFilter> <md-input-container style=margin-left:10px flex=\"\" class=\"flex md-input-has-value\"> <label for=select_4 class=\"\">Select Academic Year</label> <md-select ng-model=publishReportCtrl.selected_year> <md-option ng-value=oneAcd.year ng-click=publishReportCtrl.listRcWithSelectedYear(oneAcd.year) ng-repeat=\"oneAcd in publishReportCtrl.scData\">{{oneAcd.year}}</md-option> </md-select> </md-input-container> </div> </md-content> <md-backdrop style=z-index:59!important;position:fixed!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column flex class=md-padding> <div layout=column flex style=z-index:0> <div flex layout=row layout-align=\"center center\"> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-if=isLoaded ng-click=showFilters() tooltip=\"Show Filter\" tooltip-position=up> <i class=\"fas fa-filter\"></i> <md-tooltip md-direction=left>Filter reports</md-tooltip> </md-button> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-if=\"isLoaded && publishReportCtrl.noAction && publishReportCtrl.permissions.Create\" ng-click=publishReport() tooltip=\"Publish report\" tooltip-position=up> <i class=\"fas fa-upload\"></i> <md-tooltip md-direction=left>Publish reports</md-tooltip> </md-button> </div> <div flex layout=column ng-show=isViewFilter class=md-whiteframe-3dp layout-wrap layout-align=\"start center\" layout-margin style=background:#fff;outline:0 ng-click=keyDownHandler($event)> <label style=font-size:larger;font-weight:700>Filter </label> <div flex layout=row layout-wrap layout-align=\"start center\" layout-margin> <div flex=8 ng-repeat=\"demo in values\" layout=row layout-wrap style=padding-left:10px;padding-right:10px> <div flex layout-align=space-between style=min-width:150px;max-width:200px layout=column> <div class=\"multiselect-parent btn-group dropdown-multiselect\"> <button ng-disabled=disabled id=btnSelect tooltip={{demo.label}} tooltip-position=up type=button class=\"publish-report-filter btn btn-primary dropdown-toggle btn-custom\" ng-click=toggleDropdown(demo);> {{demo.selected_text}} - {{ demo.label | limitTo: 10 }}{{demo.label.length > 10 ? '...' : ''}}&nbsp;<span class=caret style=position:relative;top:-8px></span></button> <ul id=lstItem class=\"custom-dropdown dropdown-menu dropdown-menu-form\" ng-show=demo.open style=display:block;min-height:100px;max-height:200px;overflow-y:auto;line-height:30px!important> <li style=cursor:pointer> <a ng-click=setAllData(demo.value,demo.key) style=font-weight:700> <i class=\"filter_selection fas fa-check\" ng-style=\"{'font-size': '20px','color':'green','vertical-align': 'middle'}\"></i> Select All </a> </li> <li style=cursor:pointer> <a ng-click=unSetAllData(demo.value,demo.key); style=font-weight:700> <i class=\"filter_selection fas fa-times\" ng-style=\"{'font-size': '20px','color':'red','vertical-align': 'middle'}\"></i> Unselect All </a> </li> <li ng-repeat=\"option in demo.value track by $index\" ng-click=columnFilterResult(true) id=lstItems> <a class=option ng-click=\"option.is_selected=!option.is_selected;setFilterObj(option,demo.key)\" ng-disabled=option.disabled> <i class=\"filter_selection fas fa-check\" ng-style=\"{'font-size': '20px','color':'green','vertical-align': 'middle'}\" ng-if=option.is_selected></i> <i class=\"filter_selection fas fa-times\" ng-style=\"{'font-size': '20px','color':'red','vertical-align': 'middle'}\" ng-if=!option.is_selected></i> <span mf-dropdown-static-include={{settings.template}}> <span>{{option.name}}</span> </span>  </a> </li> </ul> </div> </div> </div> <md-input-container class=\"md-block nt_margin\" ng-show=isViewFilter> <label>Choose Filter</label> <md-select ng-model=selectedFilter ng-change=displaySavedFilterResult(selectedFilter)> <md-option value=None><em>None</em></md-option> <md-option ng-repeat=\"filter in savedFilterArr\" value={{filter}}>{{filter.title}}</md-option> </md-select> </md-input-container> <md-input-container class=\"md-block nt_margin\" style=height:35px ng-show=isViewFilter> <label>Create New list</label> <input ng-model=templateName required> </md-input-container> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=saveFilter() tooltip=\"Save filter details\" tooltip-position=up ng-show=isViewFilter> <md-tooltip md-direction=left>Save filter details</md-tooltip> <i class=\"far hvr-push fa-save fa-lg\"></i> </md-button> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=\"refreshFilter();selectedFilter='None';\" tooltip=\"Reset filter\" tooltip-position=up ng-show=isViewFilter> <md-tooltip md-direction=left>Reset filter</md-tooltip> <i class=\"fas fa-redo\"></i> </md-button> </div> </div> <div flex layout=row ng-show=isViewFilter class=md-whiteframe-3dp layout-wrap layout-align=\"start center\" layout-margin style=background:#fff> <md-chips ng-model=selectedFilterToShow md-on-remove=chipRemoveHandler($chip) md-on-add=chipAddHandler($chip) md-autocomplete-snap md-require-match=true md-transform-chip=transformChip($chip)> <md-autocomplete md-selected-item=selectedItem md-search-text=searchText md-items=\"item in querySearch(searchText)\" md-item-text=item.label placeholder=\"Enter Report Column Name\"> <span md-highlight-text=searchText>{{item.label}} </span> </md-autocomplete> <md-chip-template> <span> <strong>{{$chip.label}}</strong> </span> </md-chip-template> </md-chips> </div> <md-content class=\"md-padding md-whiteframe-3dp main-content table-content\" id=customers> <table id=table class=\"table table-striped table-hover report_table\" style=width:100%> <thead> <tr> <th class=\"endorse_bold head-capitalize\" ng-repeat=\"key in header\" style=cursor:default> <span layout=row> <ng-container ng-if=\"key !== 'generated_date' && key !== 'sent_for_approval_date' && key !== 'approved_date'\"> <div flex=100>{{key}}</div> </ng-container> <ng-container ng-if=\"key == 'generated_date' || key == 'sent_for_approval_date' || key == 'approved_date'\"> <div flex=100 ng-if=\"key == 'generated_date'\">Gen: Date</div> </ng-container> </span> </th> <th> <div class=head-capitalize ng-if=isLoaded>View/Edit</div> <div ng-if=!isLoaded>Sorry, None of the Teacher has generated any reports</div> </th> </tr> </thead> <tr ng-repeat=\"data in pagedItems[currentPage] | orderBy:sort.column:sort.descending\"> <td ng-repeat=\"key in keys track by $index\"> <div class=head-capitalize>{{data[key]}}</div> </td> <td> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=\"viewReport(data['_id'])\" tooltip=\"View Report\" tooltip-position=up ng-if=\"(publishReportCtrl.selected_year == '2026-2027' || publishReportCtrl.selected_year == '2025-2026') \n                                && publishReportCtrl.permissions && publishReportCtrl.permissions.Create && data.status == 'published' \"> <i title=View/Edit class=\"fas fa-edit\"></i> </md-button> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=\"viewReport(data['_id'])\" tooltip=\"View Report\" tooltip-position=up ng-if=\"(publishReportCtrl.selected_year == '2026-2027' || publishReportCtrl.selected_year == '2025-2026') \n                                && publishReportCtrl.permissions && publishReportCtrl.permissions.Create && data.status == 'approved' \"> <i title=View class=\"fa fa-eye\"></i> </md-button> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=\"viewReport(data['_id'])\" tooltip=\"View Report\" tooltip-position=up ng-if=\"publishReportCtrl.selected_year == '2024-2025' && publishReportCtrl.permissions && publishReportCtrl.permissions.Create && (data.status == 'published' || data.status == 'approved' )\"> <i title=View/Edit class=\"fas fa-edit\"></i> </md-button> <md-button class=\"md-fab md-mini btn-line\" aria-label=Add ng-click=\"viewReport(data['_id'])\" tooltip=\"View Report\" tooltip-position=up ng-if=\"publishReportCtrl.isOtherOldYear(publishReportCtrl.selected_year) && \n                                   publishReportCtrl.permissions && publishReportCtrl.permissions.Create && \n                                   (data.status == 'published' || data.status == 'approved')\"> <i title=View class=\"fa fa-eye\"></i> </md-button> </td> </tr> </table> <tfoot> <td colspan=6> <div flex layout=row layout-align=\"end center\" class=\"pagination pull-right\" ng-if=isLoaded> <ul> <li ng-class=\"{disabled: currentPage == 0}\" ng-disabled=\"currentPage == 0\"> <a href ng-click=setPage(0)>First</a> </li> <li ng-class=\"{disabled: currentPage == 0}\" ng-disabled=\"currentPage == 0\"> <a href ng-click=prevPage()>« Prev</a> </li> <li ng-repeat=\"n in range(totalItems, currentPage, currentPage + gap) \" ng-class=\"{active: n == currentPage}\" ng-click=setPage(n)> <a href ng-bind=\"n + 1\">1</a> </li> <li ng-class=\"{disabled: (currentPage) == limit-1}\" ng-disabled=\"currentPage == (limit-1)\"> <a href ng-click=nextPage()>Next »</a> </li> <li ng-class=\"{disabled: currentPage == limit-1}\" ng-disabled=\"currentPage == (limit-1)\"> <a href ng-click=setPage(limit-1)>Last</a> </li> </ul> </div> </td> </tfoot> </md-content> </div> </div> ";

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <style>.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.small_button{min-height:0;min-width:0}.have_margin{margin-top:10px!important}.subHeader_color{color:#00bcd4}.fixed_height{height:100px;overflow:scroll}.nopadding{padding:0!important}.imageAllignment{padding-left:150px;padding-bottom:10px}</style> <link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <link href=\"https://fonts.googleapis.com/css?family=Poppins\" rel=stylesheet> <style>.main{background-color:#f6f9fb;padding:30px;overflow-y:auto}.p10{padding:10px}.one_student{background-color:#fffF;border:solid 1px #f9e4e2;color:#3367c1;font-size:15px;margin:3px;padding:5px;border-radius:25px}.name_div{height:50px;color:#0a44ab;font-weight:600;background:#e1eeff}.div_requested_to{border-radius:5px;background:#346ac5;color:#fffF;font-weight:600}.div_crrentcls{border-radius:5px;background:#2bc48a!important;color:#fffF}.viewReportBtn{border-radius:5px;color:#0075ff;height:40px;border:solid 1px #0075ff}.viewReportBtnCom{border-radius:5px;color:#2bc48a;height:40px;border:solid 1px #2bc48a}.viewReportBtnPub{border-radius:5px;color:#f99417;height:40px;border:solid 1px #f99417}.div_req{background:#f3f8ff}.div_acd{background:#eef1f5}.div_requested_approved{border-radius:5px;background:#0075ff;color:#fffF;font-weight:600;text-transform:uppercase}.div_requested_rejected{border-radius:5px;background:#f99417!important;color:#fffF;font-weight:600}.head_div{padding:5px;background:#2c92ff;color:#fffF;font-weight:600}.one_radio{padding:10px;background:#ddf0ff;color:#3265c1;font-weight:600;border-radius:5px}.bmcb md-radio-button .md-container{margin-left:3px!important}.topicDiv{height:50px;overflow:auto}table{border-collapse:collapse;width:100%;padding:16px;border-color:#fff}td,th{border:1px solid #546077;padding:8px}.rating_star{color:#f48c06;font-size:10px}.teacher_img{width:30px;border-radius:5px;border:solid 1px #dcc9f3}element.style{padding:10}.grade{text-transform:capitalize}th{background-color:#5a7cc0!important;color:#c2daf7;font-size:16px;font-weight:700}.bg{background-color:#ffff;border-radius:5px;border-color:#5a7cc0;margin-bottom:-3px}style{background-color:#cdb6dd}td{font-size:14px;font-weight:500;color:#0b3a98}.result-analysis td{text-align:center;padding:8px;border:1px solid #c2d1ee}.add_count_btn{padding:10px 20px;background-color:#3f51b5;border-radius:20px;color:#fff;box-shadow:0 35px 68px 0 rgb(9 21 90 / 42%),inset 0 -6px 20px 0 rgb(8 32 171);margin-left:20px}.align{background:#5a7cc0;margin-right:30px;padding:5px;color:#fffF;border-radius:8px;width:76px;text-align:center;margin-right:14px;margin-left:16px}.alignicon{margin-left:68px;margin-top:-22px}.result-analysis th{text-align:center;padding:8px;border:2px solid #c2d1ee}.padding{padding:10px;align-content:inherit;border-color:#4169e1}.blue{margin-left:12}.dtp table{color:#9bf7f7;text-align:center;font-weight:700;padding:2px 3px;width:38px;height:28px}.dtp table.dtp-picker-days tr>th{color:#fbf4f4;text-align:center;font-weight:700;padding:2px 3px;width:38px;height:28px}.filterRefresh{font-size:8px;padding:5px;color:#dc5757;font-weight:900;float:right}.filterInput{border-radius:7px;border:solid 1px #dfe0e3;width:70%}.md-calendar{width:15px}div.scrollmenu{overflow:auto;white-space:nowrap}div.scrollmenu div{display:inline-block;text-decoration:none}.one_student .scrollmenu:hover{background-color:#777;color:#fff}.statuTxt{text-transform:capitalize}.filterTextDiv{padding:10px;background:#119bdd;color:#fff;font-weight:600}.greyColor{color:grey}.iconWidth{width:14px}.valCol{color:#013c74}#afllistctrl{font-family:Poppins;background-color:#edeff5}.mt5{margin-top:5px}.mR5{margin-right:5px}.iconW20{width:20px}.mL5{margin-left:5px}.iconW17{width:17px}.emphasized{font-style:italic}.themeProp{color:#013c74;font-style:italic;font-size:11px}.notification{text-decoration:none;padding:15px 26px;position:relative;display:inline-block}.notification .badge{position:absolute;top:-6px;padding:5px 10px;border-radius:23px 25px 26px 26px;background-color:#1587bd;color:#fff;font-size:10px;font-weight:600}.clearIcon{border:solid 1px #dc5757;width:12px;height:15px}.searchIcon{width:12px;height:15px}.colorRed{color:#dc5757}</style> <md-backdrop style=z-index:70!important;position:fixed ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img class=loader id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <form flex=100 name=controlForm style=\"margin:0 0 0 33px\" layout=column layout-align=end> <div layout-align=center> <div flex=90 class=\"md md-whiteframe-3dp\" layout=row style=margin-top:20px;border-radius:20px;max-width:98%> <div flex=10> <div style=\"margin:30px 0;text-align:center\"> <img src=" + __webpack_require__(455) + " alt=\"\"> <span class=gray>Filter</span> </div> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Academic Year</label> <md-select class=inpt ng-change=reportCardApprovalCtrl.listRcWithSelectedYear(_selected_year) ng-model=_selected_year name=academic> <md-option ng-value=oneAcd.year ng-repeat=\"oneAcd in reportCardApprovalCtrl.scData track by $index\">{{oneAcd.year }}</md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Session</label> <md-select multiple=multiple class=inpt ng-model=model_sessions name=session> <md-option ng-disabled=disable_filters ng-repeat=\"item in session_array| orderBy: 'name'\" ng-value=item._id> {{item.name}} </md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Curriculum</label> <md-select multiple=multiple class=inpt ng-model=model_curriculums name=curriculum> <md-option ng-disabled=disable_filters ng-repeat=\"item in curriculum_array| orderBy: 'name'\" ng-value=item._id> {{item.name}} </md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=10> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Class</label> <md-select multiple=multiple class=inpt ng-model=model_classes name=class> <md-option ng-disabled=disable_filters ng-repeat=\"item in class_array | orderBy: 'name'\" ng-value=item._id> {{item.name}} </md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=10> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Batch</label> <md-select multiple=multiple class=inpt ng-model=model_batches name=batch> <md-option ng-disabled=disable_filters ng-repeat=\"item in batch_array | orderBy: 'name'\" ng-value=item._id> {{item.name}} </md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Subject</label> <md-select multiple=multiple class=inpt ng-model=model_subjects name=subject> <md-option ng-value=subject._id ng-repeat=\"subject in subject_array | orderBy:'name' track by $index\">{{ subject.name }}</md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Reports</label> <md-select multiple=multiple class=inpt ng-model=model_reports name=report> <md-option ng-value=item._id ng-repeat=\"item in report_array | orderBy:'name'\">{{ item.name }}</md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" flex=15> <md-input-container class=col-md-12 style=width:90% flex=100> <label for=\"\">Status</label> <md-select multiple=multiple class=inpt ng-model=model_statuses name=status> <md-option ng-value=item._id ng-repeat=\"item in status_array | orderBy:'name'\">{{ item.name }}</md-option> </md-select> </md-input-container> </div> <div class=\"col-md-3 col-sm-3\" layout=row> <md-button ng-click=search(true)><img src=" + __webpack_require__(456) + " alt=\"\"> Search</md-button> <md-button ng-click=\"clearAllFilters('html')\" class=md-warn><img src=" + __webpack_require__(454) + " alt=\"\"> Clear All</md-button> </div> </div> </div> </form> <div layout=row layout-align=\"end end\" flex=100 style=padding-right:20px> <div class=add_count_btn style=margin-top:10px ng-show=\"reportCardApprovalCtrl.reportCardListArray && reportCardApprovalCtrl.reportCardListArray.length\"> {{ reportCardApprovalCtrl.reportCardListArray.length}}/{{total_count}} </div> </div> <md-content layout-padding class=\"md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px> <p ng-if=\"reportCardApprovalCtrl.reportCardListArray.length==0\">No Report cards to show</p> <div layout=row flex=100 layout-wrap class=mainFilter ng-if=\"reportCardApprovalCtrl.reportCardListArray.length>0\"> <div layout=row flex=100 layout-wrap layout-align=\"start center\"> <md-card flex=30 flex-xs=30 flex-sm=45 flex-gt-xs=30 layout=column ng-repeat=\"card in reportCardApprovalCtrl.reportCardListArray track by $index\"> <div style=outline:0 layout=column layout-padding layout-align=space-around flex> <p flex class=\"searchBold md-body-1\" style=color:#2196f3!important;padding:0!important> {{card.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\"?\"Annual Report\":card.report_card_header.report_card_name}}</p> <p style=padding:0!important class=\"md-primary md-body-1\"> {{card.academic_details.session}}/ {{card.academic_details.curriculum}}/ {{card.academic_details.class}}{{card.academic_details.batch}}/ {{card.academic_details.subject}}</p> <div flex layout=row layout-align=\"space-between center\" style=padding:0!important> <p style=padding:0!important;color:#da1237!important class=\"md-primary md-body-1\" ng-if=\"card.current_status.status =='sent_for_approval'\">Not Approved</p> <p style=padding:0!important;color:#1565c0!important class=\"md-primary md-body-1\" ng-if=\"card.current_status.status !='sent_for_approval'\"> {{card.current_status.status}}</p> <div class=md-margin> </div> <md-button ng-if=\"card.current_status.status =='sent_for_approval' && card.is_active\" class=\"md-primary md-raised btn-xs small_button\" ng-click=reportCardApprovalCtrl.viewTemplate(card) ng-if=card.create style=\"padding:5px 6px\">Approve / Reject</md-button> <md-button ng-if=\"card.current_status.status !='sent_for_approval'\" class=\"md-primary md-raised btn-xs small_button\" ng-click=reportCardApprovalCtrl.viewTemplate(card) ng-if=card.create style=\"padding:5px 6px\">View</md-button> </div> </div> </md-card> </div> </div> <div ng-if=\"reportCardApprovalCtrl.reportCardListArray && reportCardApprovalCtrl.reportCardListArray.length && morePage\" style=\"float:right;background:0 0;position:fixed;bottom:95;right:20px\"> <md-button ng-show=!isLoading ng-disabled=disable_filters class=\"md-raised md-accent\" ng-click=loadMore()>Load More </md-button> </div> </md-content> ";

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.ghj:hover{border:1px solid #88ccec}.reports .menuhd{color:#2d6095;font-weight:500;margin-left:10px;margin-top:5px}.reports .margin{margin-left:10px}.reports .rightborder{border-right:1px solid #dfddde;margin-left:10px}.reports .topborder{border-bottom:1px solid #dfddde}.reports .hand{outline:0;cursor:pointer}.reports .emptydiv{height:40px}.reports .selectedtext{color:#fff}.reports .heding{height:40px;background-color:#2ab4bf;color:#fff;font-size:16px;text-transform:uppercase;font-weight:600;padding-left:15px}#style-4::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3);background-color:#f5f5f5}#style-4::-webkit-scrollbar{width:5px;background-color:#f5f5f5}#style-4::-webkit-scrollbar-thumb{background-color:grey}.reports .background{background-color:#fff}.reports .dragditem{height:auto;background-color:#e1edfb;border:1px solid #c8ddf7;margin:8px}.reports .dragitem{height:40px;background-color:#e1edfb;border:1px solid #c8ddf7;margin:8px}.reports .drageditem{height:53px;border:1px solid #c8ddf7;margin:8px;margin-bottom:0}.reports .floatright{float:right}.reports .roundspan{width:20px;background-color:#f5c503;float:left;height:20px;text-align:center;vertical-align:middle;border-radius:15px}.reports .roundicon{float:left;background:#e1edfb;border-radius:15px;font-size:20px;margin-top:2px;width:20px;height:20px}.reports .rmargin{margin-right:2px}.reports .selected{background-color:#e6505b}.reports .radiogrp{border:1px solid #c8ddf7;margin-top:0;border-top:none;height:30px;background-color:#e1edfb}.reports .datastyle{background-color:#dedcdd;height:30px;text-transform:uppercase;color:#3a6262;padding-left:10px;padding-top:2px}.reports .databorder{border:1px solid #dedcdd}.reports .pagesize{height:70vh;margin-bottom:65px;overflow-y:scroll}.reports .leftborder{border-left:1px solid #dfddde}.rep-ctrl{border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px;outline:0}.txt-manage{color:#fff;color:#fff;padding-top:5px;float:left}</style> <div layout=column flex=100 class=reports> <md-backdrop style=z-index:59!important;position:fixed ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Generating the report, please wait ...</span> </md-backdrop> <div flex=100 layout=row layout-align=\"space-around start\" style=margin-top:30px> <div flex=45 layout=row class=\"md-whiteframe-3dp background md-margin pagesize\" id=style-4> <div layout=column flex=25 class=rightborder> <div class=\"topborder emptydiv\"></div> <div ng-click=reportCardGenConsoleCtrl.showItem(item) class=\"topborder hand leftborder\" ng-class=\"item.showItem?'selected':''\" ng-repeat=\"item in activities\" layout=row layout-align=\"start center\"> <p class=menuhd ng-class=\"item.showItem?'selectedtext':''\"> {{item.name}}</p> </div> </div> <div flex=75> <div ng-repeat=\"item in activities\"> <div flex=100 layout=row layout-align=\"start center\" class=heding ng-if=item.showItem>{{item.name}}</div> <div ng-if=item.showItem layout=row style=min-height:100px flex as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=item.list layout-padding layout-wrap> <div class=dragitem flex=45 ng-repeat=\"data in item.list\" as-sortable-item> <div as-sortable-item-handle flex title={{data.activity_name}}-{{data.created_by}}> <md-tooltip md-direction=left>{{data.activity_name}}-{{data.created_by}}</md-tooltip> {{data.activity_name | limitTo: 10}} {{data.activity_name.length > 10 ? '...' : ''}} <i class=\"floatright fas fa-arrows-alt hand\"></i> </div> </div> <div ng-if=\"item.list.length==0\" layout=row layout-align=\"center center\"> No items found </div> </div> </div> </div> </div> <div flex=45 layout=row class=\"md-whiteframe-3dp background md-margin pagesize\" ng-if=\"have_sub_skill && !skill_only\"> <div layout=column flex=25 class=rightborder> <div class=\"topborder emptydiv\"></div> <div ng-click=reportCardGenConsoleCtrl.showSelectedItem(activity) ng-repeat=\"activity in selectedactivities\" ng-class=\"activity.showItem?'selected':''\" class=\"topborder hand leftborder\" layout=row layout-align=\"start center\"> <p class=menuhd ng-class=\"activity.showItem?'selectedtext':''\"> {{activity.name}}</p> </div> </div> <div flex=75 ng-init=flagdata() ng-if=have_sub_skill> <div ng-repeat=\"activity in selectedactivities\"> <div flex=100 layout=row layout-align=\"start center\" class=heding ng-if=activity.showItem>{{activity.name}}</div> <div layout=row layout-pdding layout-wrap layout-fll> <div ng-repeat=\"item in activity.sub_skills\" flex=45 layout=column> <div layout=row as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=item.list layout-align=\"space-between center\" ng-if=activity.showItem ng-click=reportCardGenConsoleCtrl.showMore(activity,item) class=\"md-margin drageditem hand\"> <div flex layout-align=\"start center\" class=\"subhead md-margin\"> {{item.name | limitTo: 10}} {{item.name.length > 10 ? '...' : ''}} </div> <div class=rmargin flex=10> <span class=\"roundspan hand\"> {{item.list.length}} </span> <md-menu ng-disabled=\"item.list.length<1\"> <span class=roundicon ng-click=\"reportCardGenConsoleCtrl.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-angle-down\" style=font-size:17px;position:relative;bottom:-1px;left:4px></i> </span> <md-menu-content width=4> <md-menu-item ng-if=\"item.list.length>1&&activity.showItem\"> <md-radio-group ng-model=item.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> </md-radio-group> </md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> </div> </div> <div ng-repeat=\"activity in selectedactivities\" class=md-margin ng-if=!activity.showItem> <div ng-repeat=\"item in activity.sub_skills\" ng-if=item.isdisplay> <div flex=100 layout=row layout-align=\"start center\" class=heding>{{activity.name}}</div> <div layout=column class=databorder style=margin-top:8px> <div class=datastyle layout=row> <div flex=90>{{item.name | limitTo: 10}} {{item.name.length > 10 ? '...' : ''}}</div> <div flex=10> <i ng-click=reportCardGenConsoleCtrl.close(activity,item) class=\"hand fas fa-times\"></i> </div> </div> <div layout=row ng-model=item.list layout-padding layout-wrap as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1> <div ng-repeat=\"data in item.list\" class=dragditem flex=45 layout=row> <div flex=90 title={{data.activity_name}}-{{data.created_by}}>{{data.activity_name}}</div> <div flex=10 class=hand ng-click=reportCardGenConsoleCtrl.deleteSession(item,data)><i class=\"fas fa-times\"></i></div> </div> </div> <div class=md-margin ng-if=\"item.list.length>1\" layout=row layout-align=\"end end\"> <md-radio-group ng-model=item.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> </md-radio-group> </div> </div> </div> </div> </div> </div> <div flex=45 layout=row class=\"md-whiteframe-3dp background md-margin pagesize\" id=style-4 ng-if=skill_only> <div ng-init=reportCardGenConsoleCtrl.flagNoSkill() flex=100> <div layout=row layout-pdding layout-wrap layout-fll ng-if=showItem> <div ng-repeat=\"activity in selectedactivities\" flex=45 layout=column> <div layout=row as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=activity.list layout-align=\"space-between center\" ng-click=reportCardGenConsoleCtrl.showNoSkill(activity) class=\"md-margin drageditem hand\"> <div flex layout-align=\"start center\" class=\"subhead md-margin\"> {{activity.name}} </div> <div class=rmargin flex=10> <span class=\"roundspan hand\"> {{activity.list.length}} </span> <md-menu> <span class=roundicon ng-disabled=\"activity.list.length<1\" ng-click=\"reportCardGenConsoleCtrl.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-angle-down\" style=font-size:17px;position:relative;bottom:4px;left:4px></i></span> <md-menu-content width=4> <md-menu-item ng-if=\"activity.list.length>1\"> <md-radio-group ng-model=activity.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> </md-radio-group> </md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> </div> <div ng-repeat=\"activity in selectedactivities\" ng-if=!showItem&&activity.showItem flex=100 layout=column> <div layout=column class=\"databorder md-margin\" flex=100> <div class=datastyle layout=row> <div flex=90>{{activity.name}}</div> <div flex=10> <i style=font-size:18px;float:right ng-click=reportCardGenConsoleCtrl.closed(activity) class=\"fas fa-times\"></i> </div> </div> <div layout=row as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=activity.list layout-padding layout-wrap> <div ng-repeat=\"data in activity.list\" class=dragitem flex=45 layout=row> <md-tooltip md-direction=left>{{data.activity_name}}-{{data.created_by}}</md-tooltip> <div flex=90 title={{data.activity_name}}-{{data.created_by}}>{{data.activity_name | limitTo: 10}} {{data.activity_name.length > 10 ? '...' : ''}}</div> <div flex=10 class=hand ng-click=reportCardGenConsoleCtrl.deleteSessions(activity,data)><i class=\"fas fa-times\"></i></div> </div> <div ng-if=\"activity.list.length==0\" layout=row layout-align=\"center center\"> <div>No items founds</div> </div> </div> <div class=md-margin ng-if=\"activity.list.length>1\" layout=row layout-align=\"end end\"> <md-radio-group ng-model=activity.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> </md-radio-group> </div> </div> </div> </div> </div> <div flex=45 layout=row class=\"md-whiteframe-3dp background md-margin pagesize\" id=style-4 ng-if=\"!have_sub_skill && !skill_only\"> <div ng-init=reportCardGenConsoleCtrl.flagNoSkill() flex=100> <div layout=row layout-pdding layout-wrap layout-fll ng-if=showItem> <div ng-repeat=\"activity in selectedactivities\" flex=45 layout=column> <div layout=row as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=activity.list layout-align=\"space-between center\" ng-click=reportCardGenConsoleCtrl.showNoSkill(activity) class=\"md-margin drageditem hand\"> <div flex layout-align=\"start center\" class=\"subhead md-margin\" {{activity.name}}-{{activity.created_by}}> {{activity.name}} </div> <div class=rmargin flex=10> <span class=\"roundspan hand\"> {{activity.list.length}} </span> <md-menu> <span class=roundicon ng-disabled=\"activity.list.length<1\" ng-click=\"reportCardGenConsoleCtrl.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-angle-down\" style=font-size:17px;position:relative;bottom:4px;left:4px></i></span> <md-menu-content width=4> <md-menu-item ng-if=\"activity.list.length>1\"> <md-radio-group ng-model=activity.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> </md-radio-group> </md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> </div> <div ng-repeat=\"activity in selectedactivities\" ng-if=!showItem&&activity.showItem flex=100 layout=column> <div layout=column class=\"databorder md-margin\" flex=100> <div class=datastyle layout=row> <div flex=90>{{activity.name}}</div> <div flex=10> <i style=\"font-size:18px;float:right;padding:3px 10px\" ng-click=reportCardGenConsoleCtrl.closed(activity) class=\"fas fa-times\"></i> </div> </div> <div layout=row as-sortable=reportCardGenConsoleCtrl.sortableCloneOptions1 ng-model=activity.list layout-padding layout-wrap> <div ng-repeat=\"data in activity.list\" class=dragitem flex=45 layout=row> <md-tooltip md-direction=left>{{data.activity_name}}-{{data.created_by}}</md-tooltip> <div title={{data.activity_name}}-{{data.created_by}} flex=90>{{data.activity_name | limitTo: 10}} {{data.activity_name.length > 10 ? '...' : ''}}</div> <div flex=10 class=hand ng-click=reportCardGenConsoleCtrl.deleteSessions(activity,data)><i class=\"fas fa-times\"></i></div> </div> <div ng-if=\"activity.list.length==0\" layout=row layout-align=\"center center\"> <div>No items founds</div> </div> </div> <div class=md-margin ng-if=\"activity.list.length>1\" layout=row layout-align=\"end end\"> <md-radio-group ng-model=activity.selection layout=row layout-align=\"center center\"> <md-radio-button value=best class=md-primary>Best</md-radio-button> <md-radio-button value=avg> Average </md-radio-button> <md-radio-button value=avg_best> Average Of Best 2</md-radio-button> </md-radio-group> </div> </div> </div> </div> </div> </div> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row class=\"theme-color md-whiteframe-3dp footer\" layout-align=center-center> <div class=\"bottom_ctrl-btn md-raised md-button md-ink-ripple md-whiteframe-3dp\" ng-click=reportCardGenConsoleCtrl.makeReportCard($event)> <span class=hand> <span class=\"font_wight controlsbtn user hand\">Generate </span> <span class=\"theme-color rep-no-border right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(533) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin-top:3px;padding-top:0;float:right> </span> </span> </div> </div> </div> </div> ";

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.greenlabels{background-color:#d5e5f8;margin-right:25px!important;color:#232322;font-size:15px;cursor:pointer;padding:18px}.border-box{border:1px solid #ccc;background-color:#fff;padding:2px;margin-right:2px}.box-class{font-weight:600;font-size:16px!important}.assignHeader{font-weight:600;font-size:16px!important;color:#3365c1}.assignHeaderNull{font-weight:600;font-size:16px!important;float:right}p.make_caps_p_tag{text-transform:capitalize}.box-class-report{font-size:14px!important;font-weight:400}.border-box-rep{border:1px solid #ccc;background-color:#fff;padding:2px 8px 1px 7px;margin-right:2px;margin-top:10px}.report-icon{cursor:pointer;font-size:17px;padding-left:2px;padding-top:1px}.rep-btn{height:20px;padding:0 15px 0 15px;margin-top:20px;margin-top:20px}.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.small_button{min-height:0;min-width:0}.have_margin{margin-top:10px!important}.subHeader_color{color:#00bcd4}.fixed_height{height:100px;overflow:scroll}.nopadding{padding:0!important}.imageAllignment{padding-left:150px;padding-bottom:10px}.text_style{background:#1665c1;padding:1px 8px 4px 7px;border-radius:4px;color:#dff;float:right}.report-head{background:#b1d4fe;margin-bottom:0;color:#265ca2!important;font-weight:600;padding:7px 4px!important;color:#265ca2}.toBeHighLighted{background:#b1d4fe}</style> <div> <md-backdrop style=position:fixed!important;z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <md-content layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <div layout=row flex=100 layout-wrap class=mainFilter> <md-input-container style=margin-left:10px flex=\"\" class=\"flex md-input-has-value\"> <label for=select_4 class=\"\">Select Academic Year</label> <md-select ng-model=reportCardClassTeacherCtrl.selected_year> <md-option ng-value=oneAcd.year ng-click=reportCardClassTeacherCtrl.listRcWithSelectedYear(oneAcd.year) ng-repeat=\"oneAcd in reportCardClassTeacherCtrl.scData\">{{oneAcd.year}}</md-option> </md-select> </md-input-container> </div> <div layout-gt-sm=row> <md-button ng-disabled=is_doc_uploading class=\"md-raised md-primary\" ng-click=navigateToDownload()> <img style=margin-top:8px;width:20px class=center src=" + __webpack_require__(630) + "> <span>Download reports to drive</span> </md-button> </div> </md-content> <md-content layout-padding=\"\" class=\"md-whiteframe-3dp report margin_20 layout-padding _md flex\" flex=\"\" style=background:#fff;padding:10px;overflow:auto> <div> <div layout=column flex=100 layout-wrap=\"\" class=\"mainFilter layout-wrap layout-column flex-100\"> <div> <span class=assignHeader>REPORTCARD GENERATED SUBJECTS</span> </div><br> <p ng-if=\"!reportCardClassTeacherCtrl.subjects || !reportCardClassTeacherCtrl.subjects.length\"> Report cards are not generated for any of the subjects</p> <div> <div flex=\"\" layout-wrap=\"\" layout=row class=\"layout-wrap layout-row flex\"> <md-card flex=30 flex-xs=100 flex-sm=45 flex-gt-xs=30 layout=column ng-repeat=\"subject in reportCardClassTeacherCtrl.subjects\" class=\"ng-scope _md layout-column flex-xs-100 flex-sm-45 flex-gt-xs-30 flex-30\" style=\"\"> <div ng-class=\"{'toBeHighLighted':subject.toBeHighLighted}\" style=outline:0 layout=row layout-wrap=\"\" layout-padding=\"\" layout-align=space-around flex=\"\" class=\"layout-padding layout-wrap layout-align-space-around-stretch layout-row flex\"> <div flex=70 class=ng-binding>{{subject.name}}</div> <div flex=20 ng-if=!subject.toBeHighLighted> <img src=" + __webpack_require__(170) + " ng-click=\"goToSubjectRcs(subject._id, subject.name)\"> </div> </div> </md-card> <div> </div> </div> </div> </div> </div> </md-content></div>  <div layout=column flex> <md-content layout-padding class=\"md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <span class=assignHeader>REPORT CARDS - TEACHER SIDE</span> <p ng-if=\"!reportCardClassTeacherCtrl.generatedData || reportCardClassTeacherCtrl.generatedData.length==0\">No Report cards to show</p> <div layout=row flex=100 class=mainFilter ng-if=\"reportCardClassTeacherCtrl.generatedData.length>0\"> <div layout=column flex=100> <div flex layout=row> <div flex=100 layout=row layout-wrap=\"\" class=\"layout-wrap layout-row\"> <md-card flex=30 flex-xs=100 flex-sm=45 flex-gt-xs=30 layout=column ng-repeat=\"card in reportCardClassTeacherCtrl.generatedData track by $index\"> <div style=outline:0 layout=column layout-align=space-around flex> <p flex class=\"searchBold report-head md-body-1\" style=display:flex;justify-content:space-between;align-items:center> <span> {{card.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\"?\"Annual Report\":card.report_card_header.report_card_name}} </span> <span> Code : {{card.code ? card.code : '0000'}} </span> </p> <p style=\"padding:10px 10px!important\" class=\"md-primary md-body-1\">{{card.academic_details.class}}/ {{card.academic_details.batch}}/ {{card.academic_details.subject}}</p> <div flex layout=row layout-align=\"space-between center\" style=padding:0!important> <div class=\"md-margin text_style\" style=cursor:pointer;margin-left:auto> <span style=width:auto title=View ng-click=reportCardClassTeacherCtrl.viewTemplate(card._id)> View</span> </div> <div class=\"no_bg md-margin\" ng-if=\"reportCardClassTeacherCtrl.noAction && view_only\"> </div> </div> </div> </md-card> </div> </div> </div> </div> </md-content> <md-content layout-padding=\"\" class=\"md-whiteframe-3dp report margin_20 layout-padding _md flex\" flex=\"\" style=background:#fff;padding:10px;overflow:auto> <div> <div layout=column flex=100 layout-wrap=\"\" class=\"mainFilter layout-wrap layout-column flex-100\"> <div> <span class=assignHeader>VIEW PUBLISHED REPORTS - STUDENT SIDE</span> <div> <div flex=100 layout-wrap=\"\" layout=row layout-wrap layout-align=\"start start\"> <md-card flex=30 layout=column ng-repeat=\"student in reportCardClassTeacherCtrl.userList\" class=\"ng-scope _md\"> <div ng-class=\"{'toBeHighLighted':student.toBeHighLighted}\" style=outline:0 layout=row layout-wrap=\"\" layout-padding=\"\" layout-align=\"start start\" flex=\"\" class=\"student-report-list noPadding layout-padding layout-wrap layout-row flex\"> <div flex=80 class=ng-binding>{{student.user_name}}</div> <div flex=20> <img src=" + __webpack_require__(170) + " ng-click=\"goToStudentReports(student.user_id, student.user_name)\"> </div> </div> </md-card> <div> </div> </div> </div> </div> </div> </div> </md-content> </div> ";

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <style>.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.small_button{min-height:0;min-width:0}.have_margin{margin-top:10px!important}.subHeader_color{color:#00bcd4}.fixed_height{height:100px;overflow:scroll}.head{color:#2196f3!important;font-size:16px;padding:0!important}.regular{padding:0!important}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column flex> <md-content layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <div layout=row flex=100 layout-wrap class=mainFilter> <md-input-container style=margin-left:10px flex=\"\" class=\"flex md-input-has-value\"> <label for=select_4 class=\"\">Select Academic Year</label> <md-select ng-model=publishedReportsListCtrl.selected_year> <md-option ng-value=oneAcd.year ng-click=publishedReportsListCtrl.listRcWithSelectedYear(oneAcd.year) ng-repeat=\"oneAcd in publishedReportsListCtrl.scData\">{{oneAcd.year}}</md-option> </md-select> </md-input-container> </div> </md-content> <md-content layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p ng-if=\"publishedReportsListCtrl.publishedReports.length==0 && fee_status_label\">Results not published yet.</p> <p ng-if=!fee_status_label>Fee not paid </p> <div layout=row flex=100 layout-wrap class=mainFilter ng-if=\"publishedReportsListCtrl.publishedReports.length>0 && fee_status_label\"> <div flex=100 layout=row layout-padding layout-wrap> <md-card flex=30 flex-xs=100 flex-sm=45 flex-gt-xs=30 layout=column ng-repeat=\"card in publishedReportsListCtrl.publishedReports track by $index\" class=\"cardfilter textWrap\"> <div layout-padding> <p flex class=\"md-body-1 head\"> {{card.name}}</p> <p flex class=\"md-body-1 regular\"> {{card.academics}}</p> </div> <div layout=row layout-align=\"end end\"> <md-button class=\"md-primary padding5 md-raised btn-xs small_button\" ng-click=\"showReportCard(card.report_console_id, card.type, card.asset_format, card)\"> {{ card.is_hpc ? 'Download Hpc Report' : 'View' }}</md-button> <md-button ng-if=card.educore_format class=\"md-primary padding5 md-raised btn-xs small_button\" ng-click=\"showEducoreReportCard(card.report_console_id, card.type,\n                            card.asset_format, card)\">Educore View</md-button> </div> </md-card> </div> </div> </md-content> </div> <footer> <div style=\"background:0 0;position:fixed;bottom:20px;right:10px\"> <md-button class=\"md-fab md-accent md-hue-2\" ng-if=\"currentRole ==='teacher'\" aria-label=Add style=background:#1565c0 ng-click=showCreatePanel()> <md-icon md-svg-src=/icons/ic_add_white.svg></md-icon> </md-button> </div> </footer>";

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.mapping-filter .usermgmBtn{float:right}.mapping-filter .lists{margin-top:70px}.mapping-filter .sbjend{height:0;margin-top:20px}.mapping-filter .chkBox{float:right}.mapping-filter .name{font-weight:700}.mapping-filter .iconsize{font-size:18px!important}.mapping-filter .details{margin-top:10px}.mapping-filter .rightBtns{padding-bottom:50px;padding-top:0}.mapping-filter .selectAll{margin-right:10px}.mapping-filter .checkbxinput{float:right}.mapping-filter .userImg{width:100px;height:100px;margin-right:10px}.mapping-filter .card{height:80px}.mapping-filter .imgs{margin-right:10px}.mapping-filter .details{margin-left:120px}.mapping-filter .name_child{font-size:12px}.mapping-filter .list{margin-right:20px;min-width:30%;margin-bottom:20px;border-top:1px solid #e6e6e6;height:115px}.mapping-filter .listes{margin-right:20px;min-width:30%;margin-bottom:20px;border-top:1px solid #e6e6e6}.mapping-filter .delSubject{margin-right:50%}.mapping-filter .delexam{margin-right:50%}.mapping-filter .userChkBk{padding-top:20px;margin-left:80px}.footerSection .round{width:40px;height:40px;border-radius:100px;display:block;position:relative;border-style:solid;z-index:5;border-color:#696969}.footerSection .imgClass2{margin-left:10px;margin-top:7px}.footerSection .doneRnd{float:right;margin-top:-7px;margin-left:30px}.font_wight{font-weight:700;outline:0}.footerSection .btn1{margin-left:10%}.footerSection .btn2{margin-left:20%}.footerSection .doneRnd3{margin-left:120px;margin-top:-25px}.footerSection .txt{font-weight:700;font-size:15px;color:#434343}.footerSection .doneRnd4{margin-top:-25px;margin-left:140px}.footerSection .footer{margin-left:-16px;margin-right:-16px}.footerSection{overflow:hidden}/ .mapping-filter .basicBx{float:left;margin-top:-30px;margin-left:125px}span.txtTeacher{float:right}.mapping-filter .delSbj{outline:0}.mapping-filter .divfixedList{height:490px;overflow-y:scroll}.mapping-filter .divfixedheight{max-height:210px;height:350px;overflow-y:scroll}.mapping-filter md-dialog{width:100%!important}.subjPOP{width:100%!important}.mapping-filter md-tabs.md-dynamic-height md-tabs-content-wrapper{height:100%;min-height:100%}.topIconMargin{margin-top:28px}.borderBottom{border-bottom:1px solid #2ce0e1;padding-left:3%}.redAlert{color:red}</style> <md-backdrop style=z-index:59!important ng-if=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <md-content flex layout-padding class=\"md-whiteframe-3dp margin_20 mapping-filter bgColor\" md-theme=makeMeWhite> <div layout=column flex ng-cloak> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm> <md-input-container flex ng-if=\"studentParentMapping.selectedIndex != 'parents'\"> <label>Session</label> <md-select ng-change=studentParentMapping.getCuriculum() ng-model=studentParentMapping.userMgt.sessionId> <md-option ng-value=sesName._id ng-repeat=\"sesName in studentParentMapping.sessions | orderBy:'name'\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"studentParentMapping.selectedIndex != 'parents'\"> <label>Curriculum</label> <md-select ng-change=studentParentMapping.getClass() ng-model=studentParentMapping.userMgt.curriculumId> <md-option ng-value=curName._id ng-repeat=\"curName in studentParentMapping.curricula | orderBy:'name'\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"studentParentMapping.selectedIndex != 'parents'\"> <label>Class</label> <md-select ng-change=studentParentMapping.getBatch() ng-model=studentParentMapping.userMgt.classId> <md-option ng-value=clsName._id ng-repeat=\"clsName in studentParentMapping.xclasses \"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"studentParentMapping.selectedIndex != 'parents'\"> <label>Batch</label> <md-select ng-model=studentParentMapping.userMgt.batchId> <md-option ng-value=batch._id ng-repeat=\"batch in studentParentMapping.batches | orderBy:'name'\"> {{batch.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"studentParentMapping.selectedIndex == 'parents'\"> <label>Parents</label> <md-select ng-model=studentParentMapping.userMgt.mapping ng-change=\"studentParentMapping.searchParentMappedOrNot( studentParentMapping.userMgt.mapping )\"> <md-option value=0>Mapped</md-option> <md-option value=1>Not Mapped</md-option> </md-select> </md-input-container> <md-button ng-if=\"studentParentMapping.selectedIndex == 'userNamesEndorsed' && studentParentMapping.selectedIndex != 'parents'\" class=\"md-fab md-primary search_animation\" aria-label=\"Map Parents\" title=\"Map Parents\" md-no-ink ng-click=studentParentMapping.getUsersListsforMap()> <img src=" + __webpack_require__(531) + " /> </md-button> <md-button ng-if=\"studentParentMapping.selectedIndex != 'userNamesEndorsed' && studentParentMapping.selectedIndex != 'parents'\" class=\"md-fab md-primary md-hue-2 md-mini search_animation\" aria-label=Search ng-click=studentParentMapping.searchMappedStudents()> <img src=" + __webpack_require__(84) + "> </md-button> </div> <md-tabs md-selected=selectedTab md-dynamic-height md-border-bottom ng-if=showList> <md-tab label=\"MAPPED STUDENTS\" ng-click=studentParentMapping.clearSelection() md-on-select=\"studentParentMapping.selectedIndex = 'userNames'\"> <md-content class=md-padding> <div layout=row layout-align=\"space-between center\"> <div ng-if=\"studentParentMapping.userNames.length>=1\"> <md-input-container class=\"noMargin md-block\" flex-gt-sm> <label style=padding-left:40px>Search</label> <i class=\"ng-isolate-scope fas fa-search\" style=margin-left:15px;top:10px;position:relative></i> <input style=margin-left:15px name=searchUser characters-only ng-model=studentParentMapping.searchUser /> </md-input-container> </div> </div> <p ng-if=\"fileFiltered.length==0\" class=redAlert>No Results found</p> <div class=\"studLists divfixedList\"> <div layout=row layout-padding layout-wrap ng-cloak layout-xs=column> <md-whiteframe ng-repeat=\"personList in studentParentMapping.userNames | filter : studentParentMapping.searchUser | orderBy : 'name'\" class=\"md-whiteframe-3dp listes\" layout=row flex layout-xs=column> <div layout=row flex> <div class=imgs> <span ng-if=personList.image> <img class=userImg src={{personList.image}} onerror='this.src=\"../../../../img/icons/ic_person_black.svg\"'/> </span> <span ng-if=\"! personList.image\"> <img class=userImg src=" + __webpack_require__(81) + " alt={{personList.name}}> </span> </div> <div> <p class=noMargin> {{personList.name}}</p> <div layout=column layout-align=\"space-between start\"> <p class=\"\">{{personList.parent_name}}</p> </div> </div> </div> </md-whiteframe> </div> </div> </md-content> </md-tab> <md-tab label=\"NOT MAPPED STUDENTS\" ng-click=studentParentMapping.clearSelection() md-on-select=\"studentParentMapping.selectedIndex = 'userNamesEndorsed'\"> <md-content class=md-padding> <div layout=row layout-align=\"space-between center\"> <div ng-if=\"studentParentMapping.userNamesEndorsed.length>=1\"> <md-input-container class=\"md-block noMargin\" flex-gt-sm> <label style=padding-left:40px>Search</label> <i class=\"ng-isolate-scope fas fa-search\" style=margin-left:15px;top:10px;position:relative></i> <input style=margin-left:15px name=searchUser characters-only ng-model=studentParentMapping.searchUser /> </md-input-container> </div> <md-button class=\"md-raised md-primary\" ng-click=studentParentMapping.viewNotMappedStatus()> View Status</md-button> </div> <p ng-if=\"fileFilteredNotMapped.length==0\" class=redAlert>No Results found</p> <div class=\"studLists divfixedList\"> <div layout=row layout-padding layout-wrap ng-cloak layout-align=\"start start\" layout-xs=column> <md-whiteframe ng-repeat=\"personList in studentParentMapping.userNamesEndorsed | filter : studentParentMapping.searchUser | orderBy : 'name'\" class=\"md-whiteframe-3dp listes\" layout=row flex layout-xs=column> <div layout=row> <div class=imgs> <span ng-if=personList.image> <img class=userImg src={{personList.image}} onerror='this.src=\"../../../../img/icons/ic_person_black.svg\"'/> </span> <span ng-if=\"! personList.image\"> <img class=userImg src=" + __webpack_require__(81) + " alt={{personList.name}}> </span> </div> <div></div> <div> {{personList.name}} </div> </div> </md-whiteframe> </div> </div> </md-content> </md-tab> <md-tab label=PARENTS md-on-select=\"studentParentMapping.selectedIndex = 'parents'\"> <md-content class=md-padding> <div layout=row layout-align=\"space-between center\"> <div ng-if=studentParentMapping.userMgt.mapping layout=row> <md-input-container class=md-block flex-gt-sm> <input type=search style=margin-left:15px;width:140px name=searchUser characters-only ng-model=studentParentMapping.searchMappedParent /> <i ng-if=studentParentMapping.searchMappedParent ng-click=studentParentMapping.clearParent(studentParentMapping.userMgt.mapping) class=\"fas fa-times\" style=margin-left:20px;float:right></i> <i ng-click=studentParentMapping.searchParentMappedOrNotByName(studentParentMapping.userMgt.mapping) class=\"fas fa-search\"></i> </md-input-container> </div> <tfoot ng-if=studentParentMapping.showPagination> <td colspan=6 ng-if=studentParentMapping.showPagination> <div flex=row layout-align=\"space-between center\"> <div flex=70 layout=row layout-align=\"start center\" class=\"pagination pull-right\" style=\"margin:0 10px 5px 10px!important\"> <label ng-if=studentParentMapping.showPagination style=padding:10px;color:#2196f3;position:relative;bottom:12px flex>Displaying {{ paginatedParentCount }} of {{parentCount}} users</label> <label ng-if=studentParentMapping.showNameSearch style=padding:10px;color:#2196f3;position:relative;bottom:12px flex>Displaying {{studentParentMapping.parentOnlyList.length}} users</label> <ul class=pagination> <li ng-if=\"studentParentMapping.showPagination && callCount == 2\" ng-class=\"{disabled: callCount == 2}\"> <a href=#>« Prev</a> </li> <li ng-if=\"studentParentMapping.showPagination && callCount != 2\" ng-class=\"{disabled: callCount == 2}\"> <a href ng-click=\"studentParentMapping.searchParentMappedOrNot(\n                                                    studentParentMapping.userMgt.mapping, true, 'pre')\">« Prev</a> </li> <li ng-class=\"{disabled: disableNext}\" ng-if=\"studentParentMapping.showPagination && disableNext\"> <a href=#>Next »</a> </li> <li ng-if=\"studentParentMapping.showPagination && !disableNext\"> <a href ng-click=\"studentParentMapping.searchParentMappedOrNot(\n                                                    studentParentMapping.userMgt.mapping, true, 'next')\">Next »</a> </li> </ul> </div> </div> </td> </tfoot> </div> <p ng-if=\"studentParentMapping.parentOnlyList.length==0\" class=redAlert>No Results found</p> <div class=\"studLists divfixedList\"> <div layout=row layout-padding layout-wrap ng-cloak layout-align=space-between layout-xs=column> <md-whiteframe ng-repeat=\"personList in studentParentMapping.parentOnlyList | orderBy : 'name'\" class=\"md-whiteframe-3dp hand list\" layout=row flex layout-xs=column ng-click=studentParentMapping.redirectToProfileView(personList._id)> <div layout=row layout-align=\"start start\"> <div class=imgs> <span ng-if=personList.image> <img class=userImg src={{personList.image}} alt={{personList.name}} /> </span> <span ng-if=\"! personList.image\"> <img class=userImg src=" + __webpack_require__(81) + " alt={{personList.name}}> </span> </div> <div> <p>{{personList.name}}</p> </div> </div> </md-whiteframe> </div> </div> </md-content> </md-tab> </md-tabs> </div> </md-content> ";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.advanced-filter-search{height:30px;margin-top:16px;margin-left:25px;background-color:#103a92!important;color:#fff!important}.faculty-user-name{padding-left:10px;margin-bottom:0!important}.peopleSearchCtrl .pagination{display:inline-block;margin:20px 0;border-radius:4px}.people-lookup .pull-right{float:right!important}.peopleSearchCtrl .pagination ul>.active>a,.peopleSearchCtrl .pagination ul>.active>span{color:#999;cursor:default}.peopleSearchCtrl .pagination ul>.active>a,.peopleSearchCtrl .pagination ul>.active>span,.peopleSearchCtrl .pagination ul>li>a:hover{background-color:#f5f5f5}.peopleSearchCtrl .pagination ul>li>a,.peopleSearchCtrl .pagination ul>li>span{float:right;padding:0 14px;line-height:38px;text-decoration:none;background-color:#fff;border:1px solid #ddd}.peopleSearchCtrl .pagination ul>li{display:inline}a{color:#08c;text-decoration:none}.peopleSearchCtrl .pagination ul>.disabled>a,.peopleSearchCtrl .pagination ul>.disabled>span{color:#999;cursor:default}.peopleSearchCtrl .user-role{padding-left:10px}</style> <md-backdrop style=z-index:60!important ng-if=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <md-content md-theme=makeMeWhite flex layout=column layout-margin=3px layout-padding=10px class=\"margin_20 peopleSearchCtrl md-whiteframe-3dp containerArea\" ng-click=keyDownHandler($event) ng-show=searchPrivilege> <div layout=row layout-align=\"space-between start\"> <div flex flex-sm flex-xs> <md-input-container class=studentSearch style=width:250px ng-if=showSearchUserSheet> <label>Search User</label> <md-icon class=\"material-icons search-icon\" ng-style=\"{'color': '#717171','font-size': '28px'}\">search</md-icon> <input style=margin-left:25px type=text ng-model=peopleSearchCtrl.searchUser autocomplete=off> </md-input-container> <div layout=column flex ng-cloak ng-keydown=keyDownHandler($event) style=outline:0 class=fpi-eval-filter> <div layout=column ng-init=\"outerIndex=$index\" flex ng-click=keyDownHandler($event) style=outline:0> <div flex layout=row> <md-input-container flex=60 class=\"bottom_margin_nill md-block\" flex-gt-sm> <label>Filter People</label> <input ng-model=facultyName> </md-input-container> <md-button class=\"md-raised advanced-filter-search\" ng-click=enableFilter()> {{buttonLabel}} </md-button> </div> <div layout=column layout-align=\"start center\" ng-click=keyDownHandler($event) ng-if=\"buttonLabel == 'Hide Filter'\"> <div flex layout=row layout-wrap layout-align=\"start center\" class=noMargin layout-margin style=width:100%> <div ng-repeat=\"demo in values\" layout=row class=noMargin style=padding-left:5px;padding-right:5px> <div flex layout-align=space-between style=min-width:150px layout=column ng-if=\"demo.label != 'Name'\"> <div class=\"multiselect-parent btn-group dropdown-multiselect\" flex> <button ng-disabled=disabled id=btnSelect tooltip={{demo.label}} tooltip-position=up type=button class=\"btn btn-primary dropdown-toggle btn-custom\" style=background:#d76974!important;text-transform:uppercase;width:100%;color:#fff!important;border:none ng-click=toggleDropdown(demo);>{{demo.selected_text}} - {{ demo.label | limitTo: 10 }}{{demo.label.length > 10 ? '...' : ''}}&nbsp;<span class=caret style=margin-top:8px!important></span></button> <ul id=lstItem class=\"custom-dropdown dropdown-menu dropdown-menu-form\" ng-show=demo.open style=display:block;min-height:100px;max-height:200px;overflow-y:auto;line-height:30px!important> <li style=cursor:pointer> <a ng-click=setAllData(demo.value,demo.key) style=font-weight:700> <i class=\"filter_selection fas fa-check\" ng-style=\"{'font-size': '20px','color':'green','vertical-align': 'middle'}\"></i> Select All </a> </li> <li style=cursor:pointer> <a ng-click=unSetAllData(demo.value,demo.key); style=font-weight:700> <i class=\"filter_selection fas fa-times\" ng-style=\"{'font-size': '20px','color':'red','vertical-align': 'middle'}\"></i> Unselect All </a> </li> <li class=divider></li> <li ng-repeat=\"option in demo.value track by $index\" ng-click=columnFilterResult(true) id=lstItems> <a class=option ng-click=\"option.is_selected=!option.is_selected;setFilterObj(option,demo.key)\" ng-disabled=option.disabled> <i class=\"filter_selection fas fa-check\" ng-style=\"{'font-size': '20px','color':'green','vertical-align': 'middle'}\" ng-if=option.is_selected></i> <i class=\"filter_selection fas fa-times\" ng-style=\"{'font-size': '20px','color':'red','vertical-align': 'middle'}\" ng-if=!option.is_selected></i> <span mf-dropdown-static-include={{settings.template}}> <span>{{option.name}}</span> </span> </a> </li> </ul> </div> </div> </div> </div> </div> </div> </div> <div layout=column flex> <div layout=row layout-align=\"space-between center\"> <label style=\"padding:10px;color:#2196f3;border:1px solid #ddd\" flex>{{paginationMsg}}</label> <div flex layout=row layout-align=\"start center\" class=\"pagination pull-right\" ng-if=\"filteredItems!=undefined && filteredItems.length>10\"> <ul> <li ng-click=nextPage() ng-if=hasValue> <a href>Next »</a> </li> <li ng-if=!hasValue ng-class=\"{disabled: !hasValue}\" ng-disabled=!hasValue> <a href=#>Next »</a> </li> <li> <a href>{{pager.page_no}}</a> </li> <li ng-if=\"pager.page_no != 1\" ng-click=prevPage()> <a href>« Prev</a> </li> <li ng-if=\"pager.page_no == 1\" ng-class=\"{disabled: pager.page_no == 1}\"> <a href=#>« Prev</a> </li> </ul> </div> </div> </div> <div layout=column flex layout-padding style=background:rgba(128,128,128,.21)> <md-grid-list md-cols-xs=1 md-cols-sm=2 md-cols-md=2 md-cols-gt-md=3 md-row-height=80px md-gutter=10px style=overflow:auto flex> <md-grid-tile ng-repeat=\"user in pagedItems[pager.page_no -1]| orderBy : 'name' | filter : facultyName\" class=md-whiteframe-3dp md-rowspan=1 md-colspan=1 ng-click=navigatePeopleLookUp(user)> <div layout=row flex layout-align=\"start center\"> <div flex=20 layout=column style=outline:0> <div class=userAvatarLeft layout-align=\"center center\"> <img ng-src={{user.image}} class=user-image-filter onerror='this.src=\"../../../../img/icons/ic_person_black.svg\"'> </div> <div flex class=faculty-div layout=row layout-align=\"start center\"> <p class=user-role>{{user.role}}</p> </div> </div> <div layout=column flex=70> <p flex class=faculty-user-name style=margin-top:4px>{{keyReplaceCase(user.name)}}</p> <p flex class=faculty-user-name style=margin-top:4px>{{user.username| limitTo: 25 }}{{user.username.length > 25 ? '...' : ''}}</p> <p flex class=faculty-user-name ng-if=user.empNo style=margin-top:4px>Employee No:{{user.empNo}}</p> <p flex class=faculty-user-name ng-if=user.admissionNo style=margin-top:4px>Admission No:{{user.admissionNo}}</p> </div> </div> </md-grid-tile> </md-grid-list> </div> </div> </div>  </md-content> <md-content md-theme=makeMeWhite flex layout=column layout-margin=3px layout-padding=10px class=\"peopleSearchCtrl md-whiteframe-3dp containerArea\" ng-show=!searchPrivilege> <p>You don't have privilege. Please contact admin.</p> </md-content>";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.5}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report span{font-size:12px}.perfomance-report td{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h4,h1,h2,h3,h4,h6{color:#000;font-size:16px;text-align:center}.perfomance-report .main_bg{padding:10px;background-color:#fff;padding-bottom:65px}.perfomance-report .main_con_head{padding:20px;margin-left:20px;margin-right:20px;margin-top:20px;background:#fff;display:flex}.perfomance-report .main_con{padding:20px;margin-left:20px;margin-right:20px;background:#fff;display:flex}.perfomance-report .full_width{width:100%}.perfomance-report .full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.perfomance-report .left_width{float:left;padding:10px;border-right:1px solid #d8d8d8}.perfomance-report .right_width{float:left}.perfomance-report .emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.perfomance-report .tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.perfomance-report .tick img{padding:6px 26px}.perfomance-report .left_margin{padding-left:20px}.perfomance-report .profile_img img{width:120px;margin:0 auto;float:left;display:block}.perfomance-report .annexure_con{width:790px;float:left;display:block}.perfomance-report .annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.perfomance-report .annexure h3{text-align:center;margin-top:7px;margin-left:5px}.perfomance-report .school_logo{width:450px;display:block;float:left}.perfomance-report .school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.perfomance-report .main_img{width:200px}.perfomance-report .profile_detail{width:460px;float:left}.perfomance-report .profile_left{width:120px;float:left}.perfomance-report .profile_right{width:290px;float:left}.perfomance-report .margin_nill{margin:5px 0!important}.perfomance-report .activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.perfomance-report .activity_con span.left_title{background-color:#e1e1e1}.perfomance-report .activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.perfomance-report .profile_con{width:100%;margin-bottom:20px}.perfomance-report .batch{width:300px}.perfomance-report .heading_mid{width:1000px;float:left}.perfomance-report .date_right{width:200}.perfomance-report .pdftable{width:100%;max-width:100%;margin-bottom:1rem}.perfomance-report .pdftable{border-collapse:collapse;background-color:transparent}.perfomance-report .pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.perfomance-report .pdftable td,.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.perfomance-report .pdftable-bordered{border:1px solid #5e6161}.perfomance-report .pdftable-bordered td,.perfomance-report .pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.perfomance-report .border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.perfomance-report .remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.perfomance-report .remarks_con span.remarks{float:left;display:block}.perfomance-report .remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.perfomance-report .profile_img{float:left}.perfomance-report .date_area{float:left;display:block;width:300px;margin-top:50px}.perfomance-report .date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.perfomance-report .date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.perfomance-report .teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.perfomance-report .Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.perfomance-report .grading_con{float:left;display:block;width:100%;margin-bottom:20px}.perfomance-report .grading_con span.grade_head{float:left;display:block;font-weight:700}.perfomance-report .grading_con span.grade_content{float:left;display:block}.perfomance-report .border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.perfomance-report .no_border{border-right-color:#fff}.perfomance-report .mark_range{float:left;display:block;margin-left:300px}.perfomance-report .sign_con{float:left;display:block;margin-bottom:5px}.perfomance-report #table-example-1{border:0 solid;border-collapse:collapse}.perfomance-report #table-example-1 caption{padding-bottom:.5em}.perfomance-report #table-example-1 td,.perfomance-report #table-example-1 th{padding:.2rem .2rem}.perfomance-report #table-example-1 td{white-space:normal!important}.perfomance-report #table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}.perfomance-report #table-example-1 th{font-weight:400}.perfomance-report #table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}.perfomance-report #table-example-1 tr{text-align:left}.perfomance-report #table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.perfomance-report .space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.perfomance-report .color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.perfomance-report .table-color-con{padding:10px}.perfomance-report .e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.perfomance-report .start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.perfomance-report .end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-color{position:relative;left:18px;font-size:12px}.perfomance-report .each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.perfomance-report .each-grade-txt{font-size:12px;width:88%;float:left}.perfomance-report .grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.perfomance-report .e2{width:40px;float:left;text-align:center;color:#fff}.perfomance-report .end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-new{position:relative;left:9px;font-size:12px}.perfomance-report .scholastic_areas{width:100%}.perfomance-report .scholastic_areas_1{float:left;width:49%;margin-right:13px}.perfomance-report .scholastic_areas_2{float:left;width:49%}.perfomance-report .grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.perfomance-report .w100{width:100%;float:left}.perfomance-report .fair{width:33%;float:left}.perfomance-report .very-good{width:30%;float:left}.perfomance-report .outstanding{width:30%;float:left}.perfomance-report .perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.perfomance-report .fair-head{float:left;font-size:12px}.perfomance-report .perfomance-class{width:25%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-report .perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.perfomance-report .themes{text-transform:uppercase}.perfomance-report .theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.perfomance-report .td-style{font-size:20px;font-weight:700}.perfomance-report .text-left{text-align:left!important}.perfomance-report .td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .td1-color{color:#000;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .schoolName{color:#004980;font-size:38px;font-family:cursive;text-align:center}.perfomance-report .report{color:#21a59a;font-size:20px;font-family:cursive;text-align:center}.perfomance-report .school-logo{margin-left:5px;margin-top:5px;margin-bottom:5px}.perfomance-report .report-category{font-size:18px;font-family:cursive;text-align:center}.acd-per{margin:0 auto!important;background-color:#fff}.footer-report-button{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:10px;padding-right:10px;padding-bottom:2px;padding-top:5px;background-color:#1665c1;color:#fff!important;min-height:30px;line-height:30px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.bottom-txt{color:#fff;padding-top:3px;float:left;padding-right:8px}.perfomance-report .gen-det{margin:20px;padding:10px}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.curriculum> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> <div layout=row flex class=top-border ng-if=\"rc_combinations && rc_combinations.length\"> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.rc_combination placeholder=\"Select Combination\"> <md-option ng-value=day ng-selected=day.year ng-click=getReportFromCombination(day) ng-repeat=\"day in rc_combinations\">{{ day.name}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <div class=\"main_bg perfomance-report md-whiteframe-5dp acd-per\" ng-if=\"dataExists && !isPdfData\" style=\"margin:0 20px!important\"> <div class=\"marLR_0 main_con_head\"> <div layout=row flex=100 style=\"font-family:'Roboto Condensed'!important\"> <div flex=10> <div class=school-logo><img src={{schoolLogo}} width=100></div> </div> <div layout=column flex=80 style=\"font-family:'Roboto Condensed'!important\"> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{schoolName}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Average Marks scored (%) </h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{academicYear}} / {{curriculumName}}/{{sessionName}}</h3> </div> <div class=profile_img ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div class=\"marLR_0 main_con\"> <div class=full_width> <span style=width:20% class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>80%) </span> <span style=width:22% class=perfomance-class> <span style=background-color:#109618 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#e2b60c class=perfomance-excellent></span> REQUIRES ATTENTION (31-60%) </span> <span style=width:30% class=perfomance-class> <span style=background-color:red class=perfomance-excellent></span> NEEDS IMMEDIATE ATTENTION (&#60;30%) </span> </div> </div> <div layout=column ng-repeat=\"report_console in reportCardConsoleDetails\" class=\"marLR_0 main_con\" style=padding-top:0;padding-bottom:3px;margin-bottom:6px> <span style=padding:10px;background-color:#dde4ff><b style=font-size:14px;padding:10px> {{report_console.report_name}}</b></span> <br/> <div style=padding-top:0;padding-bottom:3px;color:red ng-if=!retval[report_console._id].is_report_present>There is no report available</div> <div style=padding-top:0;padding-bottom:3px ng-if=retval[report_console._id].is_report_present> <div class=full_width> <div class=table-color-con style=overflow-x:scroll> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3></th> <th class=\"td-style text-left\" ng-repeat=\"class in classArray\" colspan=1>Standard {{class.name}}</th> </tr> </thead> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Overall Total</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span ng-style=\"{background: retval[report_console._id][class._id].total_class_color}\" class=td-color> {{retval[report_console._id][class._id].total_class_score}} </span> </td> </tr> <tr style=font-size:12px ng-repeat=\"subject in settSubject\"> <td colspan=3 class=\"td-style text-left\">{{subject.name}}</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span ng-style=\"{background: retval[report_console._id][class._id][subject._id +'color']}\" class=td-color>{{retval[report_console._id][class._id][subject._id]}} </span> </td> </tr> </table> </div> </div> </div> </div> <div style=margin-bottom:60px></div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <footer class=footer style=background:#1665c1;padding:10px> <div layout=row layout-align=\"center center\"> <div layout=row layout-align=space-between-center> <span ng-if=!isPdfData ng-click=exportpdf() style=outline:0> <span class=\"md-whiteframe-3dp common-filter-add font_wight controlsbtn user hand\">Export as pdf <i class=\"far fa-file-pdf\" style=\"padding:0 10px\"></i> </span> </span> <span style=outline:0 ng-if=isPdfData ng-click=backToHtml()> <span class=\"md-whiteframe-3dp common-filter-add font_wight controlsbtn user hand\">Back to Report <i class=\"fas fa-chevron-left footer_icon_allign\"></i> </span> </span> </div> </div></footer>";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-report td{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h4,h1,h2,h3,h4,h6{color:#000;font-size:16px;text-align:center}.perfomance-report .main_bg{margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.perfomance-report .main_con_head{padding:20px;margin-left:20px;margin-right:20px;margin-top:20px;background:#fff;display:flex}.perfomance-report .main_con{padding:20px;margin-left:20px;margin-right:20px;background:#fff;display:flex}.perfomance-report .full_width{width:100%}.perfomance-report .full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.perfomance-report .left_width{float:left;padding:10px;border-right:1px solid #d8d8d8}.perfomance-report .right_width{float:left}.perfomance-report .emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.perfomance-report .tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.perfomance-report .tick img{padding:6px 26px}.perfomance-report .left_margin{padding-left:20px}.perfomance-report .profile_img img{width:120px;margin:0 auto;float:left;display:block}.perfomance-report .annexure_con{width:790px;float:left;display:block}.perfomance-report .annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.perfomance-report .annexure h3{text-align:center;margin-top:7px;margin-left:5px}.perfomance-report .school_logo{width:450px;display:block;float:left}.perfomance-report .school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.perfomance-report .main_img{width:200px}.perfomance-report .profile_detail{width:460px;float:left}.perfomance-report .profile_left{width:120px;float:left}.perfomance-report .profile_right{width:290px;float:left}.perfomance-report .margin_nill{margin:5px 0!important}.perfomance-report .activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.perfomance-report .activity_con span.left_title{background-color:#e1e1e1}.perfomance-report .activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.perfomance-report .profile_con{width:100%;margin-bottom:20px}.perfomance-report .batch{width:300px}.perfomance-report .heading_mid{width:1000px;float:left}.perfomance-report .date_right{width:200}.perfomance-report .pdftable{width:100%;max-width:100%;margin-bottom:1rem}.perfomance-report .pdftable{border-collapse:collapse;background-color:transparent}.perfomance-report .pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.perfomance-report .pdftable td,.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.perfomance-report .pdftable-bordered{border:1px solid #5e6161}.perfomance-report .pdftable-bordered td,.perfomance-report .pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.perfomance-report .border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.perfomance-report .remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.perfomance-report .remarks_con span.remarks{float:left;display:block}.perfomance-report .remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.perfomance-report .profile_img{float:left}.perfomance-report .date_area{float:left;display:block;width:300px;margin-top:50px}.perfomance-report .date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.perfomance-report .date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.perfomance-report .teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.perfomance-report .Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.perfomance-report .grading_con{float:left;display:block;width:100%;margin-bottom:20px}.perfomance-report .grading_con span.grade_head{float:left;display:block;font-weight:700}.perfomance-report .grading_con span.grade_content{float:left;display:block}.perfomance-report .border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.perfomance-report .no_border{border-right-color:#fff}.perfomance-report .mark_range{float:left;display:block;margin-left:300px}.perfomance-report .sign_con{float:left;display:block;margin-bottom:5px}.perfomance-report #table-example-1{border:0 solid;border-collapse:collapse}.perfomance-report #table-example-1 caption{padding-bottom:.5em}.perfomance-report #table-example-1 td,.perfomance-report #table-example-1 th{padding:.2rem .2rem}.perfomance-report #table-example-1 td{white-space:normal!important}.perfomance-report #table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}.perfomance-report #table-example-1 th{font-weight:400}.perfomance-report #table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}.perfomance-report #table-example-1 tr{text-align:left}.perfomance-report #table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.perfomance-report .space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.perfomance-report .color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.perfomance-report .table-color-con{padding:10px}.perfomance-report .e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.perfomance-report .start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.perfomance-report .end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-color{position:relative;left:18px;font-size:12px}.perfomance-report .each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.perfomance-report .each-grade-txt{font-size:12px;width:88%;float:left}.perfomance-report .grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.perfomance-report .e2{width:40px;float:left;text-align:center;color:#fff}.perfomance-report .end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-new{position:relative;left:9px;font-size:12px}.perfomance-report .scholastic_areas{width:100%}.perfomance-report .scholastic_areas_1{float:left;width:49%;margin-right:13px}.perfomance-report .scholastic_areas_2{float:left;width:49%}.perfomance-report .grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.perfomance-report .w100{width:100%;float:left}.perfomance-report .fair{width:33%;float:left}.perfomance-report .very-good{width:30%;float:left}.perfomance-report .outstanding{width:30%;float:left}.perfomance-report .perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.perfomance-report .fair-head{float:left;font-size:12px}.perfomance-report .perfomance-class{font-weight:700;font-size:11px;float:left;padding-bottom:6px;width:32%}.perfomance-report .perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.perfomance-report .themes{text-transform:uppercase}.perfomance-report .theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.perfomance-report .td-style{font-size:20px;font-weight:700}.perfomance-report .text-left{text-align:left!important}.perfomance-report .td-color{color:#000;border-radius:50px;text-align:center;width:33px;height:33px;font-size:12px;padding-top:8px;float:left}.perfomance-report .high-box{height:20px;width:30px;background-color:green;color:#fff;padding:2px;margin:1px}.perfomance-report .low-box{height:20px;width:30px;background-color:red;color:#fff;padding:2px;margin:1px}.perfomance-report .avg-box{height:40px;width:30px;padding:10px}.perfomance-report .schoolName{color:#004980;font-size:38px;font-family:cursive;text-align:center}.perfomance-report .report{color:#21a59a;font-size:20px;font-family:cursive;text-align:center}.perfomance-report .school-logo{margin-left:5px;margin-top:5px;margin-bottom:5px}.perfomance-report .report-category{font-size:18px;font-family:cursive;text-align:center}.acd-per{margin:0 auto!important;background-color:#fff}.footer-report-button{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:10px;padding-right:10px;padding-bottom:2px;padding-top:5px;background-color:#1665c1;color:#fff!important;min-height:30px;line-height:30px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.bottom-txt{color:#fff;padding-top:3px;float:left;padding-right:8px}.perfomance-report .gen-det{margin:20px;padding:10px}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.curriculum> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> <div layout=row flex class=top-border ng-if=\"rc_combinations && rc_combinations.length\"> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.rc_combination placeholder=\"Select Combination\"> <md-option ng-value=day ng-selected=day.year ng-click=getReportFromCombination(day) ng-repeat=\"day in rc_combinations\">{{ day.name}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <div class=\"md-whiteframe-3dp main_bg perfomance-report acd-per\" ng-if=\"dataExists && !isPdfData\" style=\"margin:0 20px 0 20px!important\"> <div class=\"marLR_0 main_con_head\" style=\"font-family:'Roboto Condensed'!important\"> <div layout=row flex=100> <div flex=10> <div class=school-logo><img src={{schoolLogo}} width=100></div> </div> <div layout=column flex=80 class=heading_mid style=width:507px> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{schoolName}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Difference in Class Average</h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{academicYear}} / {{curriculumName}}/{{sessionName}}</h3> </div> <div class=\"\" ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div class=\"marLR_0 main_con\"> <div class=full_width> <span class=perfomance-class> <span style=background-color:red class=perfomance-excellent></span> Performance Down : Avg(Half Yearly -Annual) </span> <span class=perfomance-class> <span style=background-color:#42ac48 class=perfomance-excellent></span>Performance Up : Avg(Annual - Half Yearly) </span> <span class=perfomance-class> <span style=background-color:#e2b60c class=perfomance-excellent></span>Performance No Change : Avg(Annual= Half Yearly) </span> </div> </div> <div layout=column class=\"marLR_0 main_con\" style=padding-top:0;padding-bottom:3px;margin-bottom:6px> <span style=padding:10px;background-color:#dde4ff><b style=font-size:14px;padding:10px>Half Yearly Vs Annual</b></span> <br/> <div style=padding-top:0;padding-bottom:3px;color:red ng-if=!diffYear.is_report_present> The exam is not generated or not published</div> <div style=padding-top:0;padding-bottom:3px ng-if=diffYear.is_report_present> <div class=full_width> <div class=table-color-con style=overflow-x:scroll> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3></th> <th class=\"td-style text-left\" ng-repeat=\"class in classArray\" colspan=1>Class {{class.name}}</th> </tr> </thead> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Overall Total</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span ng-if=diffYear[class._id].total_class_score class=td-color ng-style=\"{color: diffYear[class._id].total_class_color}\"> <div layout=row> {{diffYear[class._id].total_class_score}} </div> </span> <span ng-if=!diffYear[class._id].total_class_score class=td-color> - </span> </td> </tr> <tr style=font-size:12px ng-repeat=\"subject in settSubject\"> <td colspan=3 class=\"td-style text-left\">{{subject.name | limitTo:4}} </td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span ng-if=diffYear[class._id][subject._id] class=td-color ng-style=\"{color: diffYear[class._id][subject._id +'color']}\"> <div layout=row> {{diffYear[class._id][subject._id]}} </div> </span> <span ng-if=!diffYear[class._id][subject._id] class=td-color>-</span> </td> </tr> </table> <br> <br> <br> </div> </div> </div> </div> <div style=margin:20px;background:#edf2ff;padding:10px> <span style=margin-right:5px ng-repeat=\"sub in settSubject\">{{sub.name|limitTo:4}} - {{sub.name}}, </span> </div> <div layout=column class=gen-det> <span>Genereated By: {{generatedBy}}</span> <span> Generated Date : {{generatedDate}}</span> </div> <div style=margin-bottom:60px></div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <footer class=footer style=background:#1665c1;padding:10px> <div layout=row layout-align=\"center center\"> <div class=\"bottom_ctrl-btn md-whiteframe-3dp\" layout=row layout-align=space-between-center> <span ng-if=!isPdfData ng-click=exportpdf() style=outline:0> <span style=color:#fff class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span><i class=\"far fa-file-pdf footer_icon_allign\"></i></span> </span> <span style=outline:0 ng-if=isPdfData ng-click=backToHtml()> <span style=color:#fff class=\"font_wight controlsbtn user hand\">Back to Report</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\"></i> </span> </span> </div> </div></footer>";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-report td{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h4,h1,h2,h3,h4,h6{color:#000;font-size:16px;text-align:center}.perfomance-report .main_bg{margin:0 auto;padding:10 px;background-color:#fff;padding-bottom:65px}.perfomance-report .main_con_head{padding:20px;margin-left:20px;margin-right:20px;margin-top:20px;background:#fff;display:flex}.perfomance-report .main_con{padding:20px;margin-left:20px;margin-right:20px;background:#fff;display:flex}.perfomance-report .full_width{width:100%}.perfomance-report .full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.perfomance-report .left_width{float:left;padding:10px;border-right:1px solid #d8d8d8}.perfomance-report .right_width{float:left}.perfomance-report .emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.perfomance-report .tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.perfomance-report .tick img{padding:6px 26px}.perfomance-report .left_margin{padding-left:20px}.perfomance-report .profile_img img{width:120px;margin:0 auto;float:left;display:block}.perfomance-report .annexure_con{width:790px;float:left;display:block}.perfomance-report .annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.perfomance-report .annexure h3{text-align:center;margin-top:7px;margin-left:5px}.perfomance-report .school_logo{width:450px;display:block;float:left}.perfomance-report .school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.perfomance-report .main_img{width:200px}.perfomance-report .profile_detail{width:460px;float:left}.perfomance-report .profile_left{width:120px;float:left}.perfomance-report .profile_right{width:290px;float:left}.perfomance-report .margin_nill{margin:5px 0!important}.perfomance-report .activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.perfomance-report .activity_con span.left_title{background-color:#e1e1e1}.perfomance-report .activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.perfomance-report .profile_con{width:100%;margin-bottom:20px}.perfomance-report .batch{width:300px}.perfomance-report .heading_mid{width:1000px;float:left}.perfomance-report .date_right{width:200}.perfomance-report .pdftable{width:100%;max-width:100%;margin-bottom:1rem}.perfomance-report .pdftable{border-collapse:collapse;background-color:transparent}.perfomance-report .pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.perfomance-report .pdftable td,.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.perfomance-report .pdftable-bordered{border:1px solid #5e6161}.perfomance-report .pdftable-bordered td,.perfomance-report .pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.perfomance-report .border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.perfomance-report .remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.perfomance-report .remarks_con span.remarks{float:left;display:block}.perfomance-report .remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.perfomance-report .profile_img{float:left}.perfomance-report .date_area{float:left;display:block;width:300px;margin-top:50px}.perfomance-report .date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.perfomance-report .date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.perfomance-report .teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.perfomance-report .Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.perfomance-report .grading_con{float:left;display:block;width:100%;margin-bottom:20px}.perfomance-report .grading_con span.grade_head{float:left;display:block;font-weight:700}.perfomance-report .grading_con span.grade_content{float:left;display:block}.perfomance-report .border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.perfomance-report .no_border{border-right-color:#fff}.perfomance-report .mark_range{float:left;display:block;margin-left:300px}.perfomance-report .sign_con{float:left;display:block;margin-bottom:5px}.perfomance-report #table-example-1{border:0 solid;border-collapse:collapse}.perfomance-report #table-example-1 caption{padding-bottom:.5em}.perfomance-report #table-example-1 td,.perfomance-report #table-example-1 th{padding:.2rem .2rem}.perfomance-report #table-example-1 td{white-space:normal!important}.perfomance-report #table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}.perfomance-report #table-example-1 th{font-weight:400}.perfomance-report #table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}.perfomance-report #table-example-1 tr{text-align:left}.perfomance-report #table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.perfomance-report .space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.perfomance-report .color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.perfomance-report .table-color-con{padding:10px}.perfomance-report .e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.perfomance-report .start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.perfomance-report .end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-color{position:relative;left:18px;font-size:12px}.perfomance-report .each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.perfomance-report .each-grade-txt{font-size:12px;width:88%;float:left}.perfomance-report .grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.perfomance-report .e2{width:40px;float:left;text-align:center;color:#fff}.perfomance-report .end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-new{position:relative;left:9px;font-size:12px}.perfomance-report .scholastic_areas{width:100%}.perfomance-report .scholastic_areas_1{float:left;width:49%;margin-right:13px}.perfomance-report .scholastic_areas_2{float:left;width:49%}.perfomance-report .grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.perfomance-report .w100{width:100%;float:left}.perfomance-report .fair{width:33%;float:left}.perfomance-report .very-good{width:30%;float:left}.perfomance-report .outstanding{width:30%;float:left}.perfomance-report .perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.perfomance-report .fair-head{float:left;font-size:12px}.perfomance-report .perfomance-class{width:25%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-report .perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.perfomance-report .themes{text-transform:uppercase}.perfomance-report .theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.perfomance-report .td-style{font-size:20px;font-weight:700}.perfomance-report .text-left{text-align:left!important}.perfomance-report .td-color{color:#000;border-radius:50px;text-align:center;width:33px;height:33px;font-size:12px;padding-top:8px;float:left}.perfomance-report .high-box{height:20px;width:30px;background-color:green;color:#fff;padding:2px;margin:1px}.perfomance-report .low-box{height:20px;width:30px;background-color:red;color:#fff;padding:2px;margin:1px}.perfomance-report .avg-box{height:40px;width:30px;padding:10px}.perfomance-report .schoolName{color:#004980;font-size:38px;font-family:cursive;text-align:center}.perfomance-report .report{color:#21a59a;font-size:20px;font-family:cursive;text-align:center}.perfomance-report .school-logo{margin-left:5px;margin-top:5px;margin-bottom:5px}.perfomance-report .report-category{font-size:18px;font-family:cursive;text-align:center}.acd-per{margin:0 auto!important;background-color:#fff}.footer-report-button{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:10px;padding-right:10px;padding-bottom:2px;padding-top:5px;background-color:#1665c1;color:#fff!important;min-height:30px;line-height:30px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.bottom-txt{color:#fff;padding-top:3px;float:left;padding-right:8px}.perfomance-report .gen-det{margin:20px;padding:10px}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.curriculum> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> <div layout=row flex class=top-border ng-if=\"rc_combinations && rc_combinations.length\"> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.rc_combination placeholder=\"Select Combination\"> <md-option ng-value=day ng-selected=day.year ng-click=getReportFromCombination(day) ng-repeat=\"day in rc_combinations\">{{ day.name}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <div class=\"md-whiteframe-3dp main_bg perfomance-report acd-per\" ng-if=\"dataExists && !isPdfData\" style=\"margin:0 20px!important\"> <div class=\"marLR_0 main_con_head\"> <div layout=row flex=100> <div flex=10> <div class=school-logo><img src={{schoolLogo}} width=100></div> </div> <div layout=column flex=80 style=\"font-family:'Roboto Condensed'!important\"> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{schoolName}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Percentage of Students Needing Attention (score Less than 60%)</h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{academicYear}} / {{curriculumName}}/{{sessionName}}</h3> </div> <div class=profile_img ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div class=main_con> <div class=full_width> <span class=perfomance-class> <span style=background-color:#42ac48 class=perfomance-excellent></span> Less than 10% </span> <span class=perfomance-class> <span style=background-color:#f90 class=perfomance-excellent></span> 10-25% </span> <span class=perfomance-class> <span style=background-color:red class=perfomance-excellent></span> Greater than 25%</span> </div> </div> <div layout=column ng-repeat=\"report_console in reportCardConsoleDetails\" class=\"marLR_0 main_con\" style=padding-top:0;padding-bottom:3px;margin-bottom:6px> <span style=padding:10px;background-color:#dde4ff> <b style=font-size:14px;padding:10px>{{report_console.report_name}}</b></span> <br/> <div style=padding-top:0;padding-bottom:3px;color:red ng-if=!retval[report_console._id].is_report_present>There is no report available</div> <div style=padding-top:0;padding-bottom:3px ng-if=retval[report_console._id].is_report_present> <div class=full_width> <div class=table-color-con style=overflow-x:scroll> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3></th> <th class=\"td-style text-left\" ng-repeat=\"class in classArray\" colspan=1>Class {{class.name}}</th> </tr> </thead> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Total Students</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span class=td-color>{{retval[report_console._id][class._id].class_stud_count}} </span> </td> </tr> <tr style=font-size:12px ng-repeat=\"subject in settSubject\"> <td colspan=3 class=\"td-style text-left\">{{subject.name | limitTo:4}}</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <span ng-if=retval[report_console._id][class._id][subject._id] ng-style=\"{color: retval[report_console._id][class._id][subject._id +'color']}\" class=td-color>{{retval[report_console._id][class._id][subject._id]}}</span> <span ng-if=!retval[report_console._id][class._id][subject._id] class=td-color>-</span> </td> </tr> </table> </div> </div> </div> </div> <div style=margin:20px;background:#edf2ff;padding:10px> <span style=margin-right:5px ng-repeat=\"sub in settSubject\">{{sub.name|limitTo:4}} - {{sub.name}}, </span> </div> <div layout=column class=gen-det> <span>Genereated By: {{generatedBy}}</span> <span> Generated Date : {{generatedDate}}</span> </div> <div style=margin-bottom:60px></div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <footer class=footer style=background:#1665c1;padding:10px> <div layout=row layout-align=\"center center\"> <div class=\"bottom_ctrl-btn md-whiteframe-3dp\" layout=row layout-align=space-between-center> <span ng-if=!isPdfData ng-click=exportpdf() style=outline:0> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span><i class=\"far fa-file-pdf footer_icon_allign\"></i></span> </span> <span style=outline:0 ng-if=isPdfData ng-click=backToHtml()> <span style=color:#fff class=\"font_wight controlsbtn user hand\">Back to Report</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\"></i> </span> </span> </div> </div> </footer>";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-report td{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h4,h1,h2,h3,h4,h6{color:#000;font-size:16px;text-align:center}.perfomance-report .main_bg{margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.perfomance-report .main_con_head{padding:20px;margin-left:20px;margin-right:20px;margin-top:20px;background:#fff;display:flex}.perfomance-report .main_con{padding:20px;margin-left:20px;margin-right:20px;background:#fff;display:flex}.perfomance-report .full_width{width:100%}.perfomance-report .full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.perfomance-report .left_width{float:left;padding:10px;border-right:1px solid #d8d8d8}.perfomance-report .right_width{float:left}.perfomance-report .emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.perfomance-report .tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.perfomance-report .tick img{padding:6px 26px}.perfomance-report .left_margin{padding-left:20px}.perfomance-report .profile_img img{width:120px;margin:0 auto;float:left;display:block}.perfomance-report .annexure_con{width:790px;float:left;display:block}.perfomance-report .annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.perfomance-report .annexure h3{text-align:center;margin-top:7px;margin-left:5px}.perfomance-report .school_logo{width:450px;display:block;float:left}.perfomance-report .school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.perfomance-report .main_img{width:200px}.perfomance-report .profile_detail{width:460px;float:left}.perfomance-report .profile_left{width:120px;float:left}.perfomance-report .profile_right{width:290px;float:left}.perfomance-report .margin_nill{margin:5px 0!important}.perfomance-report .activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.perfomance-report .activity_con span.left_title{background-color:#e1e1e1}.perfomance-report .activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.perfomance-report .profile_con{width:100%;margin-bottom:20px}.perfomance-report .batch{width:300px}.perfomance-report .heading_mid{width:1000px;float:left}.perfomance-report .date_right{width:200}.perfomance-report .pdftable{width:100%;max-width:100%;margin-bottom:1rem}.perfomance-report .pdftable{border-collapse:collapse;background-color:transparent}.perfomance-report .pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.perfomance-report .pdftable td,.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.perfomance-report .pdftable-bordered{border:1px solid #5e6161}.perfomance-report .pdftable-bordered td,.perfomance-report .pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.perfomance-report .border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.perfomance-report .remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.perfomance-report .remarks_con span.remarks{float:left;display:block}.perfomance-report .remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.perfomance-report .profile_img{float:left}.perfomance-report .date_area{float:left;display:block;width:300px;margin-top:50px}.perfomance-report .date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.perfomance-report .date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.perfomance-report .teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.perfomance-report .Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.perfomance-report .grading_con{float:left;display:block;width:100%;margin-bottom:20px}.perfomance-report .grading_con span.grade_head{float:left;display:block;font-weight:700}.perfomance-report .grading_con span.grade_content{float:left;display:block}.perfomance-report .border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.perfomance-report .no_border{border-right-color:#fff}.perfomance-report .mark_range{float:left;display:block;margin-left:300px}.perfomance-report .sign_con{float:left;display:block;margin-bottom:5px}.perfomance-report #table-example-1{border:0 solid;border-collapse:collapse}.perfomance-report #table-example-1 caption{padding-bottom:.5em}.perfomance-report #table-example-1 td,.perfomance-report #table-example-1 th{padding:.2rem .2rem}.perfomance-report #table-example-1 td{white-space:normal!important}.perfomance-report #table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}.perfomance-report #table-example-1 th{font-weight:400}.perfomance-report #table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}.perfomance-report #table-example-1 tr{text-align:left}.perfomance-report #table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.perfomance-report .space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.perfomance-report .color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.perfomance-report .table-color-con{padding:10px}.perfomance-report .e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.perfomance-report .start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.perfomance-report .end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-color{position:relative;left:18px;font-size:12px}.perfomance-report .each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.perfomance-report .each-grade-txt{font-size:12px;width:88%;float:left}.perfomance-report .grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.perfomance-report .e2{width:40px;float:left;text-align:center;color:#fff}.perfomance-report .end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-new{position:relative;left:9px;font-size:12px}.perfomance-report .scholastic_areas{width:100%}.perfomance-report .scholastic_areas_1{float:left;width:49%;margin-right:13px}.perfomance-report .scholastic_areas_2{float:left;width:49%}.perfomance-report .grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.perfomance-report .w100{width:100%;float:left}.perfomance-report .fair{width:33%;float:left}.perfomance-report .very-good{width:30%;float:left}.perfomance-report .outstanding{width:30%;float:left}.perfomance-report .perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.perfomance-report .fair-head{float:left;font-size:12px}.perfomance-report .perfomance-class{width:25%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-report .perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.perfomance-report .themes{text-transform:uppercase}.perfomance-report .theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.perfomance-report .td-style{font-size:20px;font-weight:700}.perfomance-report .text-left{text-align:left!important}.perfomance-report .td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .td1-color{color:#000;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .high-box{height:20px;width:30px;background-color:green;color:#fff;padding:2px;margin:1px}.perfomance-report .low-box{height:20px;width:30px;background-color:red;color:#fff;padding:2px;margin:1px}.perfomance-report .avg-box{height:40px;width:30px;padding:10px}.perfomance-report .schoolName{color:#004980;font-size:38px;font-family:cursive;text-align:center}.perfomance-report .report{color:#21a59a;font-size:20px;font-family:cursive;text-align:center}.perfomance-report .school-logo{margin-left:5px;margin-top:5px;margin-bottom:5px}.perfomance-report .report-category{font-size:18px;font-family:cursive;text-align:center}.acd-per{margin:0 auto!important;background-color:#fff}.perfomance-report .gen-det{margin:20px;padding:10px}.footer-report-button{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:10px;padding-right:10px;padding-bottom:2px;padding-top:5px;background-color:#1665c1;color:#fff!important;min-height:30px;line-height:30px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.bottom-txt{color:#fff;padding-top:3px;float:left;padding-right:8px}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.curriculum> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> <div layout=row flex class=top-border ng-if=\"rc_combinations && rc_combinations.length\"> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.rc_combination placeholder=\"Select Combination\"> <md-option ng-value=day ng-selected=day.year ng-click=getReportFromCombination(day) ng-repeat=\"day in rc_combinations\">{{ day.name}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <div class=\"md-whiteframe-3dp main_bg perfomance-report acd-per\" ng-if=\"dataExists && !isPdfData\" style=\"margin:0 20px!important\"> <div class=\"marLR_0 main_con_head\"> <div layout=row flex=100 style=\"font-family:'Roboto Condensed'!important\"> <div flex=10> <div class=school-logo><img src={{schoolLogo}} width=100></div> </div> <div layout=column flex=80 style=\"font-family:'Roboto Condensed'!important\"> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{schoolName}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Performing Section </h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{academicYear}} / {{curriculumName}}/{{sessionName}}</h3> </div> <div class=profile_img ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div class=\"marLR_0 main_con\"> <div class=full_width> <span class=perfomance-class> <span style=background-color:green class=perfomance-excellent></span>Highest Performing Section </span> <span class=perfomance-class> <span style=background-color:red class=perfomance-excellent></span>Lowest Performing Section</span> </div> </div> <div layout=column ng-repeat=\"report_console in reportCardConsoleDetails\" class=\"marLR_0 main_con\" style=padding-top:0;padding-bottom:3px;margin-bottom:6px> <span style=padding:10px;background-color:#dde4ff;margin-top:20px><b style=font-size:14px;padding:10px>{{report_console.report_name}}</b></span> <br/> <div style=padding-top:0;padding-bottom:3px;color:red ng-if=!retval[report_console._id].is_report_present>There is no report available</div> <div style=padding-top:0;padding-bottom:3px ng-if=retval[report_console._id].is_report_present> <div class=full_width> <div class=table-color-con style=overflow-x:scroll> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3></th> <th class=\"td-style text-left\" ng-repeat=\"class in classArray\" colspan=1>Class {{class.name}}</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"subject in settSubject\"> <td colspan=3 class=\"td-style text-left\">{{subject.name|limitTo:4}}</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <div layout=column> <span ng-if=\"retval[report_console._id][class._id][subject._id]['highest'].batchName\" class=high-box>{{retval[report_console._id][class._id][subject._id]['highest'].batchName}} </span> <span ng-if=\"retval[report_console._id][class._id][subject._id]['lowest'].batchName && retval[report_console._id][class._id][subject._id]['highest'].batchName!=retval[report_console._id][class._id][subject._id]['lowest'].batchName\" class=low-box>{{retval[report_console._id][class._id][subject._id]['lowest'].batchName}} </span> <span ng-if=\"retval[report_console._id][class._id][subject._id]['lowest'].batchName && retval[report_console._id][class._id][subject._id]['highest'].batchName == retval[report_console._id][class._id][subject._id]['lowest'].batchName\" class=low-box>-</span> <span ng-if=\"!retval[report_console._id][class._id][subject._id]['highest'].batchName\" class=avg-box></span> </div> </td> </tr> </table> </div> </div> </div> </div> <div style=margin:20px;background:#edf2ff;padding:10px> <span style=margin-right:5px ng-repeat=\"sub in settSubject\">{{sub.name|limitTo:4}} - {{sub.name}}, </span> </div> <div layout=column class=gen-det> <span>Genereated By: {{generatedBy}}</span> <span> Generated Date : {{generatedDate}}</span> </div> <div style=margin-bottom:60px></div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <footer class=footer style=background:#1665c1;padding:10px> <div layout=row layout-align=\"center center\"> <div class=\"bottom_ctrl-btn md-whiteframe-3dp\" layout=row layout-align=space-between-center> <span ng-if=!isPdfData ng-click=exportpdf() style=outline:0> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span> <i class=\"far fa-file-pdf footer_icon_allign\"></i></span> </span> <span style=outline:0 ng-if=isPdfData ng-click=backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to Report</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\"></i> </span> </span> </div> </div></footer>";

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-report td{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h4,h1,h2,h3,h4,h6{color:#000;font-size:16px;text-align:center}.perfomance-report .main_bg{margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.perfomance-report .main_con_head{padding:20px;margin-left:20px;margin-right:20px;margin-top:20px;background:#fff;display:flex}.perfomance-report .main_con{padding:20px;margin-left:20px;margin-right:20px;background:#fff;display:flex}.perfomance-report .full_width{width:100%}.perfomance-report .full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.perfomance-report .left_width{float:left;padding:10px;border-right:1px solid #d8d8d8}.perfomance-report .right_width{float:left}.perfomance-report .emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.perfomance-report .tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.perfomance-report .tick img{padding:6px 26px}.perfomance-report .left_margin{padding-left:20px}.perfomance-report .profile_img img{width:120px;margin:0 auto;float:left;display:block}.perfomance-report .annexure_con{width:790px;float:left;display:block}.perfomance-report .annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.perfomance-report .annexure h3{text-align:center;margin-top:7px;margin-left:5px}.perfomance-report .school_logo{width:450px;display:block;float:left}.perfomance-report .school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.perfomance-report .main_img{width:200px}.perfomance-report .profile_detail{width:460px;float:left}.perfomance-report .profile_left{width:120px;float:left}.perfomance-report .profile_right{width:290px;float:left}.perfomance-report .margin_nill{margin:5px 0!important}.perfomance-report .activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.perfomance-report .activity_con span.left_title{background-color:#e1e1e1}.perfomance-report .activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.perfomance-report .profile_con{width:100%;margin-bottom:20px}.perfomance-report .batch{width:300px}.perfomance-report .heading_mid{width:1000px;float:left}.perfomance-report .date_right{width:200}.perfomance-report .pdftable{width:100%;max-width:100%;margin-bottom:1rem}.perfomance-report .pdftable{border-collapse:collapse;background-color:transparent}.perfomance-report .pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.perfomance-report .pdftable td,.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.perfomance-report .pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.perfomance-report .pdftable-bordered{border:1px solid #5e6161}.perfomance-report .pdftable-bordered td,.perfomance-report .pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.perfomance-report .border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.perfomance-report .remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.perfomance-report .remarks_con span.remarks{float:left;display:block}.perfomance-report .remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.perfomance-report .profile_img{float:left}.perfomance-report .date_area{float:left;display:block;width:300px;margin-top:50px}.perfomance-report .date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.perfomance-report .date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.perfomance-report .teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.perfomance-report .Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.perfomance-report .grading_con{float:left;display:block;width:100%;margin-bottom:20px}.perfomance-report .grading_con span.grade_head{float:left;display:block;font-weight:700}.perfomance-report .grading_con span.grade_content{float:left;display:block}.perfomance-report .border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.perfomance-report .no_border{border-right-color:#fff}.perfomance-report .mark_range{float:left;display:block;margin-left:300px}.perfomance-report .sign_con{float:left;display:block;margin-bottom:5px}.perfomance-report #table-example-1{border:0 solid;border-collapse:collapse}.perfomance-report #table-example-1 caption{padding-bottom:.5em}.perfomance-report #table-example-1 td,.perfomance-report #table-example-1 th{padding:.2rem .2rem}.perfomance-report #table-example-1 td{white-space:normal!important}.perfomance-report #table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}.perfomance-report #table-example-1 th{font-weight:400}.perfomance-report #table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}.perfomance-report #table-example-1 tr{text-align:left}.perfomance-report #table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.perfomance-report .space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.perfomance-report .color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.perfomance-report .table-color-con{padding:10px}.perfomance-report .e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.perfomance-report .start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.perfomance-report .end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-color{position:relative;left:18px;font-size:12px}.perfomance-report .each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.perfomance-report .each-grade-txt{font-size:12px;width:88%;float:left}.perfomance-report .grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.perfomance-report .e2{width:40px;float:left;text-align:center;color:#fff}.perfomance-report .end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.perfomance-report .range-new{position:relative;left:9px;font-size:12px}.perfomance-report .scholastic_areas{width:100%}.perfomance-report .scholastic_areas_1{float:left;width:49%;margin-right:13px}.perfomance-report .scholastic_areas_2{float:left;width:49%}.perfomance-report .grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.perfomance-report .w100{width:100%;float:left}.perfomance-report .fair{width:33%;float:left}.perfomance-report .very-good{width:30%;float:left}.perfomance-report .outstanding{width:30%;float:left}.perfomance-report .perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.perfomance-report .fair-head{float:left;font-size:12px}.perfomance-report .perfomance-class{width:25%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-report .perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.perfomance-report .themes{text-transform:uppercase}.perfomance-report .theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.perfomance-report .td-style{font-size:20px;font-weight:700}.perfomance-report .text-left{text-align:left!important}.perfomance-report .td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .td1-color{color:#000;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.perfomance-report .high-box{height:20px;width:30px;background-color:green;color:#fff;padding:2px;margin:1px}.perfomance-report .low-box{height:20px;width:30px;background-color:red;color:#fff;padding:2px;margin:1px}.perfomance-report .avg-box{height:40px;width:30px;padding:10px}.perfomance-report .schoolName{color:#004980;font-size:38px;font-family:cursive;text-align:center}.perfomance-report .report{color:#21a59a;font-size:20px;font-family:cursive;text-align:center}.perfomance-report .school-logo{margin-left:5px;margin-top:5px;margin-bottom:5px}.perfomance-report .report-category{font-size:18px;font-family:cursive;text-align:center}.perfomance-report .academic-detail{text-align:center}.acd-per{margin:0 auto!important;background-color:#fff}.footer-report-button{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:10px;padding-right:10px;padding-bottom:2px;padding-top:5px;background-color:#1665c1;color:#fff!important;min-height:30px;line-height:30px;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)}.bottom-txt{color:#fff;padding-top:3px;float:left;padding-right:8px}.perfomance-report .gen-det{margin:20px;padding:10px}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.curriculum> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> <div layout=row flex class=top-border ng-if=\"rc_combinations && rc_combinations.length\"> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.rc_combination placeholder=\"Select Combination\"> <md-option ng-value=day ng-selected=day.year ng-click=getReportFromCombination(day) ng-repeat=\"day in rc_combinations\">{{ day.name}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <div class=\"main_bg md-whiteframe-3dp perfomance-report acd-per\" ng-if=\"dataExists && !isPdfData\" style=\"margin:0 20px!important\"> <div class=\"marLR_0 main_con_head\"> <div layout=row flex=100> <div flex=10> <div class=school-logo><img src={{schoolLogo}} width=100></div> </div> <div layout=column flex=80 style=\"font-family:'Roboto Condensed'!important\"> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{schoolName}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Section Wise Attention Needing Students</h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{academicYear}} / {{curriculumName}}/{{sessionName}}</h3> </div> <div class=profile_img ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div class=\"marLR_0 main_con\"> <div class=full_width> <span class=perfomance-class> <span style=background-color:green class=perfomance-excellent></span>Highest Performing Section </span> <span class=perfomance-class> <span style=background-color:red class=perfomance-excellent></span>Lowest Performing Section</span> </div> </div> <div layout=column ng-repeat=\"report_console in reportCardConsoleDetails\" class=\"marLR_0 main_con\" style=padding-top:0;padding-bottom:3px;margin-bottom:6px> <span style=padding:10px;background-color:#dde4ff;margin-top:20px><b style=font-size:14px;padding:10px>{{report_console.report_name}}</b></span> <br/> <div style=padding-top:0;padding-bottom:3px;color:red ng-if=!retval[report_console._id].is_report_present>There is no report available</div> <div style=padding-top:0;padding-bottom:3px ng-if=retval[report_console._id].is_report_present> <div class=full_width> <div class=table-color-con style=overflow-x:scroll> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3></th> <th class=\"td-style text-left\" ng-repeat=\"class in classArray\" colspan=1>Class {{class.name}}</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"subject in settSubject\"> <td colspan=3 class=\"td-style text-left\">{{subject.name | limitTo:4}}</td> <td colspan=1 class=td-style ng-repeat=\"class in classArray\"> <div layout=column> <span ng-if=\"retval[report_console._id][class._id][subject._id]['highest'].batchName\" class=high-box>{{retval[report_console._id][class._id][subject._id]['highest'].batchName}} </span> <span ng-if=\"retval[report_console._id][class._id][subject._id]['lowest'].batchName && retval[report_console._id][class._id][subject._id]['highest'].batchName!=retval[report_console._id][class._id][subject._id]['lowest'].batchName\" class=low-box>{{retval[report_console._id][class._id][subject._id]['lowest'].batchName}} </span> <span ng-if=\"retval[report_console._id][class._id][subject._id]['lowest'].batchName && retval[report_console._id][class._id][subject._id]['highest'].batchName == retval[report_console._id][class._id][subject._id]['lowest'].batchName\" class=low-box>-</span> <span ng-if=\"!retval[report_console._id][class._id][subject._id]['highest'].batchName\" class=avg-box></span> </div> </td> </tr> </table> </div> </div> </div> </div> <div style=margin:20px;background:#edf2ff;padding:10px> <span style=margin-right:5px ng-repeat=\"sub in settSubject\">{{sub.name|limitTo:4}} - {{sub.name}}, </span> </div> <div layout=column class=gen-det> <span>Genereated By: {{generatedBy}}</span> <span> Generated Date : {{generatedDate}}</span> </div> <div style=margin-bottom:60px></div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <footer class=footer style=background:#1665c1;padding:10px> <div layout=row layout-align=\"center center\"> <div class=\"bottom_ctrl-btn md-whiteframe-3dp\" layout=row layout-align=space-between-center> <span ng-if=!isPdfData ng-click=exportpdf() style=outline:0> <span style=color:#fff class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span><i class=\"far fa-file-pdf footer_icon_allign\"></i></span> </span> <span style=outline:0 ng-if=isPdfData ng-click=backToHtml()> <span style=color:#fff class=\"font_wight controlsbtn user hand\">Back to Report</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\"></i> </span> </span> </div> </div></footer>";

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.greenlabels{background-color:#d5e5f8;margin-right:25px!important;color:#232322;font-size:15px;cursor:pointer;padding:18px}.border-box{border:1px solid #ccc;background-color:#fff;padding:2px;margin-right:2px}.box-class{font-weight:600;font-size:16px!important}.assignHeader{font-weight:600;font-size:16px!important;color:#3365c1}p.make_caps_p_tag{text-transform:capitalize}.box-class-report{font-size:14px!important;font-weight:400}.border-box-rep{border:1px solid #ccc;background-color:#fff;padding:2px 8px 1px 7px;margin-right:2px;margin-top:10px}.report-icon{cursor:pointer;font-size:17px;padding-left:2px;padding-top:1px}.rep-btn{height:20px;padding:0 15px 0 15px;margin-top:20px;margin-top:20px}.excell{color:#cd9de4;background-color:#cd9de4}.competetant{color:#93ca16;background-color:#93ca16}.req_attn{color:#ff6b14;background-color:#ff6b14}table,td,th{border:1px solid #000}</style> <link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important;font-family:Roboto Condensed!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-reporttd{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h1,.perfomance-report h3,.perfomance-report h4,.perfomance-report h6,h2{color:#000;font-size:16px;text-align:center}.main_bg{width:770px;margin:0 auto;padding:10 px;background-color:#fff;padding-bottom:65px}.main_con{width:770px;margin:0 auto;background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:100px;margin:0 auto;float:left;display:block}.annexure_con{width:731px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:770px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:12px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{width:33%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}.perfomance-class{width:33%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.themes{text-transform:uppercase}.theme-selection{font-size:11px;padding-right:14px;font-weight:700;padding-bottom:4px;line-height:23px}.td-style{font-size:10px;font-weight:700}.text-left{text-align:left!important}.td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px!important;padding-top:8px;float:left}.full_w2idth{width:700px}.na-td-color{border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.h1_font_size2{font-size:10px}.analysis_con{float:left;width:100%}.report-btn-new{border-radius:0;margin-left:64px;padding:6px 0 0 2px;width:149px;margin-bottom:12px;border-radius:4px;background:#16b6c1;padding:5px 10px;color:#fff;float:left}.backdrop-fixed{position:fixed}.find-btn{background:#3c83d8;width:51px;border-radius:75px;padding:19px;height:49px;margin:7px;color:#fff;cursor:pointer}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=\"backdrop-fixed loading-opacity\" layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=selectAcademics.subject> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-disabled=true ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> <div ng-if=toSearchObj.academic_year class=find-btn ng-click=findReport()> <i class=\"fas fa-search\" title=\"click here\"></i> </div> </div> </md-content> </div> <md-content ng-if=activityReportCardCtrl.noData layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p ng-if=activityReportCardCtrl.noData>Sorry! No activities has been published for this subject</p> </md-content> <div class=\"main_bg md-whiteframe-3dp perfomance-report\" ng-if=\"!activityReportCardCtrl.noData && !pdfData\"> <div style=\"font-family:Roboto Condensed!important\"> <div class=main_con> <div class=full_w2idth> <div class=annexure_con> <div class=main_con style=width:709px> <div class=profile_img> <img src={{activityReportCardCtrl.header.school_logo}}> </div> <div class=new-head style=margin-left:17px> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{activityReportCardCtrl.header.school_name}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>CLASS REPORT {{activityReportCardCtrl.header.academic_year}}</h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{activityReportCardCtrl.header.academics}}</h3> <h3 class=h1_font_size style=margin-left:1px!important;font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{activityReportCardCtrl.header.student_name}}</h3> </div> <div class=profile_img style=padding-top:9px;margin-left:39px ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> </div> <div style=width:100%;padding-left:10px> <div style=margin-left:1px;margin-right:65px;padding:10px;padding-left:0!important> <span class=h1_font_size2>One line intimation*</span> </div> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=full_width> <div class=table-color-con style=overflow-x:auto> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3> Type</th> <th colspan=1 ng-repeat=\"qp_type in activityReportCardCtrl.typeArray\">{{qp_type}}*</th> <th>Type Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in activityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"qp_type in activityReportCardCtrl.typeArray\"> <span ng-if=\"activityReportCardCtrl.data[theme._id][qp_type]['score'] && (activityReportCardCtrl.data[theme._id][qp_type] == '0' || activityReportCardCtrl.data[theme._id][qp_type])\" ng-style=\"{{activityReportCardCtrl.data[theme._id][qp_type]['color']}}\" class=td-color> {{activityReportCardCtrl.data[theme._id][qp_type]['score']}}</span> <span class=na-td-color ng-if=\"!activityReportCardCtrl.data[theme._id][qp_type]['score']\"> - </span> </td> <td colspan=1 class=td-style> <span ng-style={{activityReportCardCtrl.avgPerTheme[theme._id].color}} class=td-color> {{activityReportCardCtrl.avgPerTheme[theme._id].score}}</span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td ng-repeat=\"qp_type in activityReportCardCtrl.typeArray\"> <span ng-style=\"{{activityReportCardCtrl.typeOver[qp_type]['color']}}\" class=td-color>{{activityReportCardCtrl.typeOver[qp_type].score}}</span> </td> <td class=td-style class=\"td-style text-left\" ng-bind-html=\"data=uCanTrust(activityReportCardCtrl.allThemeTotal)\"> </td></tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th style=text-align:left colspan=3> DIFFICULTY LEVEL </th> <th colspan=1 ng-repeat=\"level in activityReportCardCtrl.levels\">{{level.alias}}*</th> <th>Level Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in activityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"level in activityReportCardCtrl.levels\"> <span ng-if=\"activityReportCardCtrl.level[theme._id][level.alias]['score'] == '0' || activityReportCardCtrl.level[theme._id][level.alias]['score']\" ng-style=\"{{activityReportCardCtrl.level[theme._id][level.alias]['color']}}\" class=td-color>{{activityReportCardCtrl.level[theme._id][level.alias]['score']}} </span> <span class=na-td-color ng-if=\"activityReportCardCtrl.level[theme._id][level.alias]['score'] != '0' && !activityReportCardCtrl.level[theme._id][level.alias]['score']\">-</span> </td> <td colspan=1 class=td-style> <span ng-style=\"{{activityReportCardCtrl.avgLevelPerTheme[theme._id]['color']}}\" class=td-color> {{activityReportCardCtrl.avgLevelPerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td ng-repeat=\"level in activityReportCardCtrl.levels\"> <span ng-style=\"{{activityReportCardCtrl.levelOver[level.alias]['color']}}\" class=td-color>{{activityReportCardCtrl.levelOver[level.alias]['score']}}</span> </td> <td class=td-style class=\"td-style text-left\" ng-bind-html=\"data=uCanTrust(activityReportCardCtrl.allThemeLevelObj)\"> </td></tr> </table> </div> </div> </div> </div> <div class=div-height> <div class=main_con> <div class=full_w2idth> <div style=\"\" class=annexure_con> <div clas=heading_mid> <div style=margin-bottom:0> <h1 class=h1_font_size style=margin-bottom:0;font-size:14px>STUDENT REPORT {{activityReportCardCtrl.academic_year}}</h1> </div> </div> </div> <h3 class=h1_font_size style=\"border-bottom:2px solid #efc5c5;margin-bottom:0;font-style:italic;font-weight:700;margin-left:0;padding-bottom:13px;text-align:right;font-size:14px\"> Student: {{activityReportCardCtrl.header.student_name}}</h3> <div style=width:100%;padding-left:10px> <div style=margin-left:1px;margin-right:65px;padding:10px;padding-left:0!important> <span class=h1_font_size2>One line intimation*</span> </div> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=full_width> <div class=table-color-con style=overflow-x:auto> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3>COGNITIVE</th> <th colspan=1 ng-repeat=\"tag in activityReportCardCtrl.tagArray\">{{tag}}</th> <th>Tag Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in activityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"tag in activityReportCardCtrl.tagArray\"> <span ng-if=\"activityReportCardCtrl.tag[theme._id][tag]['score'] == '0' || activityReportCardCtrl.tag[theme._id][tag]['score']\" ng-style=\"{{activityReportCardCtrl.tag[theme._id][tag]['color']}}\" class=td-color> {{activityReportCardCtrl.tag[theme._id][tag]['score']}}</span> <span class=na-td-color ng-if=\"activityReportCardCtrl.tag[theme._id][tag]['score'] != '0' && !activityReportCardCtrl.tag[theme._id][tag]['score']\">-</span> </td> <td colspan=1 class=td-style> <span ng-style={{activityReportCardCtrl.avgTagPerTheme[theme._id].color}} class=td-color> {{activityReportCardCtrl.avgTagPerTheme[theme._id].score}}</span> </td> </tr> <tr style=font-size:12px;background:#e6f1ff> <td colspan=3 class=\"td-style text-left\">Over All</td> <td ng-repeat=\"tag in activityReportCardCtrl.tagArray\"> <span ng-style=\"{{activityReportCardCtrl.tagOver[tag]['color']}}\" class=td-color>{{activityReportCardCtrl.tagOver[tag]['score']}}</span> </td> <td class=td-style class=\"td-style text-left\" ng-bind-html=\"data=uCanTrust(activityReportCardCtrl.allThemeTagObj)\"> </td></tr> <tr> </tr> <thead> <tr> <th style=\"text-align:left;border-top:1px solid #4c4c4c\" colspan=5> OverAll Summary </th> </tr> </thead> <tbody> <tr> <td colspan=12> <span style=float:left;width:180px;padding-top:10px> Class Average </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-19px;margin-bottom:5px;margin-top:5px class=td-color>{{activityReportCardCtrl.classMethod.allThemeTotal.score}}</span> <span style=float:left;width:150px;padding-top:10px> Student Average </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-13px;margin-bottom:5px;margin-top:5px class=td-color>{{activityReportCardCtrl.allThemeTotal.score}}</span> <span style=float:left;width:194px;padding-top:10px> Best Scored Theme </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-29px;margin-bottom:5px;margin-top:5px class=td-color>{{activityReportCardCtrl.highest.alias}}</span> </td> </tr> </tbody> </table> </div> </div> </div> <div style=margin-left:65px;width:83%;margin-right:65px;background:#edf2ff;padding:10px> <span class=theme-selection ng-repeat=\"theme in activityReportCardCtrl.themeArray\"> {{theme.alias}} - {{theme.name}} </span> </div> </div> <div style=margin:35px> <div style=float:left;margin-left:30px> <span style=font-size:12px> Generated By : {{activityReportCardCtrl.generator.generated_by}} </span> <br> <span style=font-size:12px> Generated Date : {{activityReportCardCtrl.generator.generated_date}} </span> </div> </div> </div> <div class=main_bg ng-if=pdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp theme-color footer\" layout-align=center-center> <div class=\"md-button md-ink-ripple bottom_ctrl-btn\" ng-if=\"!pdfData && !activityReportCardCtrl.noData\" class=md-whiteframe-3dp ng-click=activityReportCardCtrl.export()> <span> <span class=\"font_wight controlsbtn user hand\" style=color:#fff>Export As Pdf</span> <span class=\"hand footer-circle-button\" style=border:none;padding-top:8px> <i class=\"footer_icon_allign far fa-file-pdf ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false></i> </span> </span> </div> <div class=\"md-whiteframe-3dp md-button md-ink-ripple bottom_ctrl-btn\" ng-if=pdfData ng-click=activityReportCardCtrl.backToHtml()> <span class=\"\"> <span> Back to html</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\" role=button tabindex=0 aria-invalid=false></i> </span> </span> </div> </div> </div> </div>";

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important;font-family:Roboto Condensed!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-reporttd{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h1,.perfomance-report h3,.perfomance-report h4,.perfomance-report h6,h2{color:#000;font-size:16px;text-align:center}.main_bg{width:770px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{margin:0 auto;background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:100px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.right_profile img{width:80px;margin:0 auto;float:left;display:block}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-2{border:0 solid;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{padding:.2rem .2rem}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-2 th{font-weight:400}#table-example-2 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-2 tr{text-align:left}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:12px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{width:33%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}.perfomance-class{width:33%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.themes{text-transform:uppercase}.theme-selection{font-size:11px;padding-right:14px;font-weight:700;padding-bottom:4px}.td-style{font-size:10px;font-weight:700}.text-left{text-align:left!important}.td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.na-td-color{border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.h1_font_size1{font-size:15px;text-align:center}.h1_font_size2{font-size:10px;padding-left:10px}.analysis_con{float:left;width:100%}.report-btn-new{border-radius:0;margin-left:31px;padding:6px 0 0 2px;width:149px;margin-bottom:12px;border-radius:4px;background:#16b6c1;padding:5px 10px;color:#fff;float:left}.backdrop-fixed{position:fixed}.report-table-scrolling{overflow-x:auto}.find-btn{background:#3c83d8;width:51px;border-radius:75px;padding:19px;height:49px;margin:7px;color:#fff;cursor:pointer}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=\"backdrop-fixed loading-opacity\" layout=column layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=selectAcademics.subject> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> <div ng-if=toSearchObj.academic_year class=find-btn ng-click=findReport()> <i class=\"fas fa-search\" title=\"click here\"></i> </div> </div> </md-content> </div> <md-content ng-if=classActivityReportCardCtrl.noData layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p ng-if=\"!classActivityReportCardCtrl.noAcademics && classActivityReportCardCtrl.noData\">Sorry! No activities has been published for this subject</p> <p ng-if=classActivityReportCardCtrl.noAcademics>Please select the academics and search</p> </md-content> <div style=\"font-family:Roboto Condensed!important;margin-bottom:30px\" class=\"md-whiteframe-3dp main_bg\" ng-if=\"!isPdfData && !classActivityReportCardCtrl.noData\" perfomance-report> <div class=div-height> <div class=main_con> <div class=profile_img> <img src={{classActivityReportCardCtrl.header.school_logo}}> </div> <div class=annexure_con> <div class=heading_mid style=width:507px> <h1 class=logo_name style=text-align:center;font-family:Sansation-Bold;font-weight:Regular;margin-bottom:0;margin-top:0>{{classActivityReportCardCtrl.header.school_name}}</h1> <h4 class=h1_font_size style=text-align:center>CLASS REPORT {{classActivityReportCardCtrl.header.academic_year}}</h4> <h5 class=h1_font_size style=margin-left:184px>{{classActivityReportCardCtrl.header.academics}}</h5> </div> </div> <div class=\"\" ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> <div class=annexure_con> <div style=margin-left:66px;margin-right:65px> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> <div style=margin-left:66px;margin-right:65px> <span class=h1_font_size2>One line intimation*</span> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=full_width> <div class=table-color-con style=overflow-x:auto> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3>Type</th> <th colspan=1 ng-repeat=\"qp_type in classActivityReportCardCtrl.typeArray\">{{qp_type}}</th> <th>Type Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in classActivityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"qp_type in classActivityReportCardCtrl.typeArray\"> <span ng-if=classActivityReportCardCtrl.data_set[theme._id][qp_type].score ng-style={{classActivityReportCardCtrl.data_set[theme._id][qp_type].color}} class=td-color> {{classActivityReportCardCtrl.data_set[theme._id][qp_type].score}} </span> <span class=na-td-color ng-if=!classActivityReportCardCtrl.data_set[theme._id][qp_type].score>-</span> </td> <td colspan=1 class=td-style> <span ng-style=\"{{classActivityReportCardCtrl.allScorePerTheme[theme._id]['color']}}\" class=td-color> {{classActivityReportCardCtrl.allScorePerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td colspan=1 class=td-style ng-repeat=\"qp_type in classActivityReportCardCtrl.typeArray\"> <span ng-style={{classActivityReportCardCtrl.perTypeObj[qp_type].color}} class=td-color> {{classActivityReportCardCtrl.perTypeObj[qp_type].score}} </span> </td> <td ng-bind-html=\"data=uCanTrust(classActivityReportCardCtrl.allThemeTotal)\"> </td> </tr> <tr> <td> &nbsp; </td> </tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <th colspan=3>DIFFICULTY LEVEL</th> <th colspan=1 ng-repeat=\"level in classActivityReportCardCtrl.levelArray\">{{level.alias}}</th> <th>Level Avg</th> </thead> <tr style=font-size:12px ng-repeat=\"theme in classActivityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"level in classActivityReportCardCtrl.levelArray\"> <span ng-if=classActivityReportCardCtrl.level_set[theme._id][level.alias].score ng-style={{classActivityReportCardCtrl.level_set[theme._id][level.alias].color}} class=td-color> {{classActivityReportCardCtrl.level_set[theme._id][level.alias].score}} </span> <span class=na-td-color ng-if=!classActivityReportCardCtrl.level_set[theme._id][level.alias].score>-</span> </td> <td colspan=1 class=td-style> <span ng-style=\"{{classActivityReportCardCtrl.levelAveragesPerTheme[theme._id]['color']}}\" class=td-color> {{classActivityReportCardCtrl.levelAveragesPerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px;background:#e6f1ff> <td colspan=3 class=\"td-style text-left\"> <span>Over All</span> </td> <td class=td-style class=\"td-style text-left\" ng-repeat=\"level in classActivityReportCardCtrl.levelArray\"> <span ng-style={{classActivityReportCardCtrl.perLevelObj[level.alias].color}} class=td-color> {{classActivityReportCardCtrl.perLevelObj[level.alias].score}}</span> </td> <td class=td-style class=\"td-style text-left\"> <span ng-style={{classActivityReportCardCtrl.totalLevelObj.color}} class=td-color> {{classActivityReportCardCtrl.totalLevelObj.score}}</span> </td> </tr> </table> </div> </div> </div> </div> <div class=div-height> <div class=main_con> <div class=annexure_con> <div class=full_width> <div class=h1_font_size1>CLASS REPORT {{classActivityReportCardCtrl.header.academic_year}} </div> <span class=h1_font_size2>One line intimation*</span> </div> </div> </div> <div class=annexure_con> <div style=margin-left:66px;margin-right:65px> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=full_width> <div class=\"table-color-con report-table-scrolling\"> <table id=table-example-2 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3>COGNITIVE</th> <th colspan=1 ng-repeat=\"tag in classActivityReportCardCtrl.tagArr\">{{tag}}</th> <th>Tag Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in classActivityReportCardCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"tag in classActivityReportCardCtrl.tagArr\"> <span ng-if=classActivityReportCardCtrl.tag_set[theme._id][tag].score ng-style={{classActivityReportCardCtrl.tag_set[theme._id][tag].color}} class=td-color> {{classActivityReportCardCtrl.tag_set[theme._id][tag].score}} </span> <span class=na-td-color ng-if=!classActivityReportCardCtrl.tag_set[theme._id][tag].score class=td-color>-</span> </td> <td colspan=1 class=td-style> <span ng-style=\"{{classActivityReportCardCtrl.tagAveragesPerTheme[theme._id]['color']}}\" class=td-color> {{classActivityReportCardCtrl.tagAveragesPerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td class=td-style class=\"td-style text-left\" ng-repeat=\"tag in classActivityReportCardCtrl.tagArr\"> <span ng-style={{classActivityReportCardCtrl.perTagObj[tag].color}} class=td-color> {{classActivityReportCardCtrl.perTagObj[tag].score}}</span> </td> <td class=td-style class=\"td-style text-left\"> <span ng-style={{classActivityReportCardCtrl.totalTagObj.color}} class=td-color> {{classActivityReportCardCtrl.totalTagObj.score}}</span> </td> </tr> <thead> <tr> <th style=\"text-align:left;border-bottom:1px solid #4c4c4c;border-top:1px solid #4c4c4c\" colspan=10> OverAll Summary </th> </tr> </thead> <tbody> <tr> <td colspan=12> <span style=float:left;width:180px> Class Performance </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-19px;margin-bottom:10px class=td-color>{{classActivityReportCardCtrl.allThemeTotal.score}}</span> <span style=float:left;width:150px> No: of Students </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-13px class=td-color>{{classActivityReportCardCtrl.no_of_students}}</span> <span style=float:left;width:210px> Best Scored Theme </span> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-29px class=td-color>{{classActivityReportCardCtrl.highest.alias}}</span> </td> </tr> </tbody> <thead> <tr> <th style=\"text-align:left;border-bottom:1px solid #4c4c4c;border-top:1px solid #4c4c4c\" colspan=10> </th> </tr> </thead> </table> </div> </div> </div> <div style=margin-left:30px;width:93%;margin-right:30px;background:#edf2ff;padding:10px> <span class=theme-selection ng-repeat=\"theme in classActivityReportCardCtrl.themeArray\"> {{theme.alias}} - {{theme.name}} </span> </div> </div> <div> <div style=float:left;margin-left:30px> <span style=font-size:12px> Generated By : {{classActivityReportCardCtrl.generated_by}} </span> <br> <span style=font-size:12px> Generated Date : {{classActivityReportCardCtrl.generated_date}} </span> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"theme-color md-whiteframe-3dp footer\" layout-align=center-center> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=\"!isPdfData && !classActivityReportCardCtrl.noData\" class=md-whiteframe-3dp ng-click=classActivityReportCardCtrl.export()> <span> <span>Export As Pdf</span> <i class=\"far fa-file-pdf fa-lg footer_icon_allign\" role=button tabindex=0 aria-invalid=false></i> </span> </div> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=isPdfData ng-click=classActivityReportCardCtrl.backToHtml()> <span> <span>Back to html</span> <i class=\"fas fa-chevron-left fa-lg footer_icon_allign\" role=button tabindex=0 aria-invalid=false></i> </span> </div> </div> </div> </div>";

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-reporttd{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h1,.perfomance-report h3,.perfomance-report h4,.perfomance-report h6,h2{color:#000;font-size:16px;text-align:center}.perfomance-report h5{text-align:left;font-size:16px}.main_bg{margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;vertical-align:middle;font-size:12px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:12px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{width:33%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}.perfomance-class{width:33%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.themes{text-transform:uppercase}.theme-selection{font-size:11px;padding-right:14px;font-weight:700;padding-bottom:4px}.td-style{font-size:10px;font-weight:700}.text-left{text-align:left!important;width:100px}.td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px!important;padding-top:8px;float:left}.na-td-color{border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.st_report h4{text-align:left}.h1_font_size1{font-size:15px;text-align:center}.h1_font_size2{font-size:10px}.bordertopnill{border-top:0!important}.analysis_con{float:left;width:100%}.report-btn-new{border-radius:0;margin-left:31px;padding:6px 0 0 2px;width:149px;margin-bottom:12px;border-radius:4px;background:#16b6c1;padding:5px 10px;color:#fff;float:left}.backdrop-fixed{position:fixed}.report-table-scrolling{overflow-x:auto}</style> <md-backdrop style=z-index:59!important;position:fixed ng-show=loading class=\"backdrop-fixed loading-opacity\" layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> </md-content> </div> <md-content ng-if=standardreportCtrl.noselection layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p>Please select the all the academic selections and search</p> </md-content> <md-content ng-if=\"!standardreportCtrl.noselection && !standardreportCtrl.hasResult\" layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p>Sorry! No activities has been published for this subject</p> </md-content> <div class=\"md-whiteframe-3dp perfomance-report main_bg\" ng-if=\"!isPdfData && !standardreportCtrl.noselection && standardreportCtrl.hasResult\" style=\"margin:0 20px\"> <div class=div-height> <div style=\"width:770px;margin:0 auto\"> <div class=profile_img> <img src={{standardreportCtrl.header.school_logo}}> </div> <div class=full_w2idth> <div class=annexure_con style=width:569px;padding:15px> <div clas=heading_mid> <h1 class=logo_name style=text-align:center;font-size:2em;font-family:Sansation-Bold;font-weight:Bold;margin-bottom:0;margin-top:0>{{standardreportCtrl.header.school_name}}</h1> <h3>[Affiliated to Central Board of Secondary Education, Delhi]</h3> <h1 class=h1_font_size style=margin-bottom:20px>STANDARD REPORT - {{standardreportCtrl.header.class_name}} - {{standardreportCtrl.header.academic_year}}</h1> </div> </div> </div> </div> <div flex style=float:left;width:100%> <div style=padding-bottom:5px;margin-left:30px;margin-right:40px class=h1_font_size2>One line intimation*</div> <div style=margin-left:30px;margin-right:40px> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=\"full_width report-table-scrolling\"> <div class=table-color-con> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3>Type </th> <th colspan=1 ng-repeat=\"qp_type in standardreportCtrl.typeArray\">{{qp_type}}</th> <th colspan=1>Type Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in standardreportCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"qp_type in standardreportCtrl.typeArray\"> <div style=width:59px> <span style=font-size:10px ng-if=standardreportCtrl.data_set[theme._id].types[qp_type].no_of_questions ng-style={{standardreportCtrl.data_set[theme._id].types[qp_type].color}} class=td-color> {{standardreportCtrl.data_set[theme._id].types[qp_type].score}}</span> <span ng-if=standardreportCtrl.data_set[theme._id].types[qp_type].no_of_questions>({{standardreportCtrl.data_set[theme._id].types[qp_type].no_of_questions}})</span> <span class=na-td-color ng-if=!standardreportCtrl.data_set[theme._id].types[qp_type].no_of_questions>-</span> </div> </td> <td colspan=1 class=td-style> <span ng-style=\"{{standardreportCtrl.typeAveragesPerTheme[theme._id]['color']}}\" class=td-color> {{standardreportCtrl.typeAveragesPerTheme[theme._id]['score']}} </span> </td> </tr> <tr> <td colspan=3 class=\"td-style text-left\">Over All</td> <td ng-repeat=\"qp_type in standardreportCtrl.typeArray\"> <span ng-style={{standardreportCtrl.type_all_theme[qp_type].color}} class=td-color> {{standardreportCtrl.type_all_theme[qp_type].total_score}} </span> </td> <td class=td-style class=\"td-style text-left\"> <span ng-style={{standardreportCtrl.totalTypeObj.color}} class=td-color> {{standardreportCtrl.totalTypeObj.score}} </span> </td> </tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <th colspan=3>DIFFICULTY LEVEL</th> <th colspan=1 ng-repeat=\"level in standardreportCtrl.levelArray\">{{level.alias}}</th> <th colspan=1>Level Avg</th> </thead> <tr style=font-size:12px ng-repeat=\"theme in standardreportCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"level in standardreportCtrl.levelArray\"> <div style=width:59px> <span ng-if=standardreportCtrl.data_set[theme._id].levels[level.alias].no_of_questions style=font-size:10px ng-style={{standardreportCtrl.data_set[theme._id].levels[level.alias].color}} class=td-color> {{standardreportCtrl.data_set[theme._id].levels[level.alias].score}}</span> <span ng-if=standardreportCtrl.data_set[theme._id].levels[level.alias].no_of_questions>({{standardreportCtrl.data_set[theme._id].levels[level.alias].no_of_questions}})</span> <span class=na-td-color ng-if=!standardreportCtrl.data_set[theme._id].levels[level.alias].no_of_questions>-</span> </div> </td> <td colspan=1 class=td-style> <span ng-style=\"{{standardreportCtrl.levelAveragesPerTheme[theme._id]['color']}}\" class=td-color> {{standardreportCtrl.levelAveragesPerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td class=td-style class=\"td-style text-left\" ng-repeat=\"level in standardreportCtrl.levelArray\"> <span ng-style={{standardreportCtrl.level_all_theme[level.alias].color}} class=td-color> {{standardreportCtrl.level_all_theme[level.alias].total_score}}</span> </td> <td class=td-style class=\"td-style text-left\"> <span ng-style={{standardreportCtrl.totalLevelObj.color}} class=td-color> {{standardreportCtrl.totalLevelObj.score}} </span> </td> </tr> </table> </div> </div> </div> </div> <div class=div-height> <div class=dssad> <div class=full_w2idth> <div class=annexure_con style=padding:15px> <div class=full_width> <div class=h1_font_size1>STANDARD REPORT {{standardreportCtrl.header.academic_year}}</div> <div class=h1_font_size2>One line intimation*</div> </div> </div> </div> </div> <div class=annexure_con style=float:left;width:100%> <div style=margin-left:66px;margin-right:65px> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=\"full_width report-table-scrolling\"> <div class=table-color-con> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=3>COGNITIVE</th> <th colspan=1 ng-repeat=\"tag in standardreportCtrl.tagArr\">{{tag}}</th> <th>Tag Avg</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in standardreportCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"tag in standardreportCtrl.tagArr\"> <div style=width:59px> <span ng-if=standardreportCtrl.data_set[theme._id].tags[tag].no_of_questions style=font-size:10px ng-style={{standardreportCtrl.data_set[theme._id].tags[tag].color}} class=td-color> {{standardreportCtrl.data_set[theme._id].tags[tag].score}}</span> <span ng-if=standardreportCtrl.data_set[theme._id].tags[tag].no_of_questions>({{standardreportCtrl.data_set[theme._id].tags[tag].no_of_questions}})</span> <span class=na-td-color ng-if=!standardreportCtrl.data_set[theme._id].tags[tag].no_of_questions>-</span> </div> </td> <td colspan=1 class=td-style> <span ng-style=\"{{standardreportCtrl.tagAveragesPerTheme[theme._id]['color']}}\" class=td-color> {{standardreportCtrl.tagAveragesPerTheme[theme._id]['score']}} </span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td class=td-style class=\"td-style text-left\" ng-repeat=\"tag in standardreportCtrl.tagArr\"> <span ng-style={{standardreportCtrl.tag_all_theme[tag].color}} class=td-color> {{standardreportCtrl.tag_all_theme[tag].total_score}} </span> </td> <td class=td-style class=\"td-style text-left\"> <span ng-style={{standardreportCtrl.totalTagObj.color}} class=td-color> {{standardreportCtrl.totalTagObj.score}} </span> </td> </tr> <thead> <tr> <th colspan=3 style=text-align:left>Batch Averages</th> <th colspan=1 ng-repeat=\"oneBatch in standardreportCtrl.batchArray\">{{oneBatch.name}}</th> </tr> </thead> <tr style=font-size:12px ng-repeat=\"theme in standardreportCtrl.themeArray\"> <td colspan=3 class=\"td-style text-left\">{{theme.alias}}*</td> <td colspan=1 class=td-style ng-repeat=\"oneBatch in standardreportCtrl.batchArray\"> <span ng-if=standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].no_of_questions style=font-size:10px ng-style={{standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].color}} class=td-color> {{standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].score}}</span> <span style=float:left ng-if=standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].no_of_questions>({{standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].no_of_questions}})</span> <span class=na-td-color ng-if=!standardreportCtrl.scorePerBatch[oneBatch._id][theme._id].no_of_questions>-</span> </td> </tr> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\">Over All</td> <td class=td-style class=\"td-style text-left\" ng-repeat=\"oneBatch in standardreportCtrl.batchArray\"> <span ng-style={{standardreportCtrl.total_score_per_batch[oneBatch._id].color}} class=td-color> {{standardreportCtrl.total_score_per_batch[oneBatch._id].score}}</span> </td> </tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th class=bordertopnill colspan=3>No : of students</th> <th class=bordertopnill colspan=1 ng-repeat=\"oneBatch in standardreportCtrl.batchArray\"> {{oneBatch.name}} </th> </tr> </thead> <tr style=font-size:12px> <td colspan=3 class=\"td-style text-left\"> </td> <td colspan=1 class=td-style ng-repeat=\"oneBatch in standardreportCtrl.batchArray\"> <span style=background-color:#1665c1 class=td-color>{{standardreportCtrl.batchObjArray[oneBatch._id]}}</span> </td> </tr> <thead> <tr> <th style=\"text-align:left;border-bottom:1px solid #4c4c4c;border-top:1px solid #4c4c4c\" colspan=10> OverAll Summary </th> </tr> </thead> <td colspan=2 class=\"td-style text-left\"> Best Performed section </td> <td colspan=1 class=td-style> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-29px class=td-color>{{standardreportCtrl.bestSection}}</span> </td> <td colspan=2 class=\"td-style text-left\"> Best Performed Theme </td> <td colspan=1 class=td-style> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-35px class=td-color>{{standardreportCtrl.bestTheme}}</span> </td> <td colspan=2 class=\"td-style text-left\"> Need Attention Theme </td> <td colspan=1 class=td-style> <span style=background-color:#1665c1;border-radius:0;position:relative;left:-37px class=td-color>{{standardreportCtrl.lowestTheme}}</span> </td> </table> </div> </div> </div> <div style=margin-left:30px;width:93%;margin-right:30px;background:#edf2ff;padding:10px> <span class=theme-selection ng-repeat=\"theme in standardreportCtrl.themeArray\"> {{theme.alias}} - {{theme.name}} </span> </div> </div> <div> <div style=float:left;margin-left:30px;margin-top:14px> <span style=font-size:12px;margin-bottom:30px> Generated By : {{standardreportCtrl.generated_by}} </span> <br> <span style=font-size:12px> Generated Date : {{standardreportCtrl.generated_date}} </span> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection style=margin-bottom:50px> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"theme-color md-whiteframe-3dp footer\" layout-align=center-center> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=!isPdfData class=md-whiteframe-3dp ng-click=standardreportCtrl.export()> <span> <span>Export As Pdf</span> <span> <i class=\"far fa-file-pdf footer_icon_allign\"></i> </span> </span> </div> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=isPdfData ng-click=standardreportCtrl.backToHtml()> <span> <span>Back to html</span> <span> <i class=\"fas fa-angle-left footer_icon_allign\"></i> </span> </span> </div> </div> </div> </div>";

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.perfomance-report html{zoom:.9}.perfomance-report body{box-sizing:border-box;font-size:12px!important}.perfomance-report table{font-size:12px!important}.perfomance-report div{font-size:12px}.perfomance-report span{font-size:12px}.perfomance-reporttd{font-size:12px!important}.perfomance-report strong{font-size:12px}.perfomance-report h1,.perfomance-report h3,.perfomance-report h4,.perfomance-report h6,h2{color:#000;font-size:16px;text-align:center}.main_bg{width:770px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{width:700px;margin:0 auto;background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:12px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:114px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:12px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;vertical-align:middle;font-size:10px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-top:0;border-radius:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:12px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{background-color:#93ca16;padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{width:33%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:12px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}.perfomance-class{width:33%;font-weight:700;font-size:11px;float:left;padding-bottom:6px}.perfomance-excellent{width:15px;height:15px;float:left;margin-right:9px;border-radius:9px}.themes{text-transform:uppercase}.theme-selection{font-size:11px;text-transform:uppercase;padding-right:14px;font-weight:700;padding-bottom:4px}.td-style{font-size:10px;font-weight:700}.text-left{text-align:left!important}.td-color{color:#fff;border-radius:50px;text-align:center;width:33px;height:33px;font-size:10px;padding-top:8px;float:left}.school-heading{text-align:center;float:left}.h1_font_size{text-align:center}.div-height{height:943px}.div-heigh-850{height:850px}.perfomance-report .icon-md{float:right}#barcode{float:left;height:76px}#barcode .bc_line{float:left;background:#000;height:70px}#barcode_num{text-align:center;font-size:10px;font-weight:700;clear:left}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=toSearchObj.class> <md-input-container flex=40 class=\"margin_15 md-block\"> <md-select ng-model=toSearchObj.academic_year placeholder=\"Select Year\"> <md-option ng-value=day ng-selected=day.year ng-click=getReport(day.year) ng-repeat=\"day in allAcademic_year\">{{ day.year}}</md-option> </md-select> </md-input-container> </div> </md-content> </div> <md-content ng-if=\"!educorePerformanceAnalysisCtrl.noselection && !educorePerformanceAnalysisCtrl.hasResult\" layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p>Sorry! No Report Cards has been published for this subject</p> </md-content> <div style=height:1000px;margin-bottom:30px class=\"md-whiteframe-3dp main_bg\" perfomance-report ng-if=\"!isPdfData && !educorePerformanceAnalysisCtrl.noselection && educorePerformanceAnalysisCtrl.hasResult\"> <div class=div-height> <div class=main_con style=\"font-family:Roboto Condensed!important\"> <div class=profile_img> <img src={{educorePerformanceAnalysisCtrl.header.school_logo}}> </div> <div class=new-head style=margin-left:90px> <h1 class=logo_name style=text-align:center;font-size:30px;font-weight:Regular;margin-bottom:0;margin-top:0> {{educorePerformanceAnalysisCtrl.header.school_name}}</h1> <h2 class=h1_font_size style=font-size:21px;color:#072dba;text-align:center;font-weight:400;padding-top:5px;margin-top:0;margin-bottom:0>Performance Analysis Report {{educorePerformanceAnalysisCtrl.header.academic_year}}</h2> <h3 class=h1_font_size style=font-size:18px;font-weight:400;text-align:center;padding-top:5px;margin-top:0> {{educorePerformanceAnalysisCtrl.header.academics}}</h3> </div> <div class=\"\" style=padding-top:9px;margin-left:39px ng-bind-html=\"data=barcodeToHtml()\"> </div> </div> <div class=main_con> <div style=width:700px class=full_w2idth> <span class=perfomance-class> <span style=background-color:#cd9de4 class=perfomance-excellent></span> EXCELLENT (>81%) </span> <span class=perfomance-class> <span style=background-color:#93ca16 class=perfomance-excellent></span> COMPETENT (61-80%) </span> <span class=perfomance-class> <span style=background-color:#ff6b14 class=perfomance-excellent></span> REQUIRES ATTENTION (&#60;=60%) </span> </div> </div> <div ng-repeat=\"report_console in educorePerformanceAnalysisCtrl.reportCardConsoleDetails\" class=main_con style=\"padding-top:0;padding-bottom:3px;border:2px solid #ccc;margin-bottom:6px\"> <div class=full_width> <div class=table-color-con> <table id=table-example-1 style=width:100%;border-bottom:none!important> <span><b style=font-size:14px> Average Marks Scored for {{report_console.report_name}}</b></span> <thead> <tr> <th ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\"> {{subject.alias}}* </th> </tr> </thead> <tr style=font-size:12px> <td ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\" class=\"td-style text-left\"> <span ng-if=educorePerformanceAnalysisCtrl.average_per_term_color[report_console._id][subject._id] ng-style=educorePerformanceAnalysisCtrl.average_per_term_color[report_console._id][subject._id] style=width:30px;height:30px;padding-top:10px;text-align:center;float:left;font-size:9px;border-radius:50px;color:#fff;background-color:#01a528>{{educorePerformanceAnalysisCtrl.average_per_term[report_console._id][subject._id]}} </span> <span ng-if=!educorePerformanceAnalysisCtrl.average_per_term_color[report_console._id][subject._id] ng-style=educorePerformanceAnalysisCtrl.average_per_term_color[report_console._id][subject._id] style=width:30px;height:30px;padding-top:10px;text-align:center;float:left;font-size:9px;border-radius:50px;color:#fff;background-color:#ff6b14>--</span> </td> </tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <span><b>Section Performance {{report_console.report_name}}</b></span> <thead> <tr> <th ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\"> {{subject.alias}}* </th> </tr> </thead> <tr style=font-size:12px> <td ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\" class=\"td-style text-left\"> <span style=width:30px;float:left> <span ng-if=\"educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest && educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest != educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].highest\" style=\"border-radius:17px 17px 0 0;font-size:9px;width:28px;float:left;color:#fff;text-align:center;height:14px;background-color:#ff6b14;color:#fff;margin-bottom:1px\"> {{educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest}}</span> <span ng-if=\"educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest && educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest == educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].highest\" style=\"border-radius:17px 17px 0 0;font-size:9px;width:28px;float:left;color:#fff;text-align:center;height:14px;background-color:#ff6b14;color:#fff;margin-bottom:1px\">--</span> <span ng-if=!educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].lowest style=\"border-radius:17px 17px 0 0;font-size:9px;width:28px;float:left;color:#fff;text-align:center;height:14px;background-color:#ff6b14;color:#fff;margin-bottom:1px\">--</span> <span style=position:relative> <span style=position:absolute;width:20px;right:26px;top:3px;height:23px;background-color:#fff> </span> </span> <span style=position:relative> <span style=position:absolute;width:20px;left:-2px;top:3px;height:23px;background-color:#fff> </span> </span> <span ng-if=educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].highest style=\"border-radius:0 0 17px 17px;font-size:9px;width:28px;float:left;color:#fff;text-align:center;height:14px;background-color:#93ca16;color:#fff\"> {{educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].highest}}</span> <span ng-if=!educorePerformanceAnalysisCtrl.section_performance[report_console._id][subject._id].highest style=\"border-radius:0 0 17px 17px;font-size:9px;width:28px;float:left;color:#fff;text-align:center;height:14px;background-color:#93ca16;color:#fff\">--</span> </span> </td> </tr> </table> <table id=table-example-1 style=width:100%;border-bottom:none!important> <span><b style=font-size:14px>Percentage of Students less than 60 {{report_console.report_name}}</b></span> <thead> <tr> <th ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\"> {{subject.alias}}* </th> </tr> </thead> <tr style=font-size:12px> <td ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\" class=\"td-style text-left\"> <span ng-if=educorePerformanceAnalysisCtrl.needing_attention[report_console._id][subject._id].score ng-style=educorePerformanceAnalysisCtrl.needing_attention[report_console._id][subject._id].color style=width:30px;height:30px;padding-top:10px;text-align:center;float:left;font-size:9px;border-radius:50px;color:#fff;background-color:#ff6b14>{{educorePerformanceAnalysisCtrl.needing_attention[report_console._id][subject._id].score}} </span> <span ng-if=!educorePerformanceAnalysisCtrl.needing_attention[report_console._id][subject._id].score ng-style=educorePerformanceAnalysisCtrl.needing_attention[report_console._id][subject._id].color style=width:30px;height:30px;padding-top:10px;text-align:center;float:left;font-size:9px;border-radius:50px;color:#fff;background-color:#ff6b14>--</span> </td></tr> </table> </div> </div> </div> <div style=\"font-family:Roboto Condensed!important;margin:20px;background:#b3c3ec;padding:10px\"> <span style=margin-right:5px ng-repeat=\"sub in educorePerformanceAnalysisCtrl.settSubject\">{{sub.alias}} - {{sub.name}}, </span> </div> </div> </div> <div class=\"main_bg md-whiteframe-3dp\" perfomance-report ng-if=\"!isPdfData && !educorePerformanceAnalysisCtrl.noselection && educorePerformanceAnalysisCtrl.hasResult\"> <div> <div ng-click=educorePerformanceAnalysisCtrl.showHideSubjectr(subject) style=\"background:#e6f1ff;padding-top:0;padding-bottom:3px;border:2px solid #ccc;margin-bottom:6px\" class=main_con style=padding-top:0;padding-bottom:3px ng-repeat=\"subject in educorePerformanceAnalysisCtrl.settSubject\"> <div style=width:700px class=full_width> <div class=table-color-con> <table ng-if=subject.is_active id=table-example-1 style=width:100%;border-bottom:none!important> <span><b>{{educorePerformanceAnalysisCtrl.less_than_sixty[subject._id].students.length}}-Students scored less than 60 in {{subject.name}}</b></span> <i ng-if=!subject.is_active class=\"fas fa-plus\" style=float:right></i> <i ng-if=subject.is_active class=\"fas fa-minus\" style=float:right></i> <thead> <tr> <th> Student Name</th> <th> Class</th> <th ng-repeat=\"report_console in educorePerformanceAnalysisCtrl.reportCardConsoleDetails\">{{report_console.report_name}}</th> <th> Total</th> </tr> </thead> <tr ng-repeat=\"student in educorePerformanceAnalysisCtrl.less_than_sixty[subject._id].students\" style=font-size:12px> <td><span>{{student.name}} </span></td> <td><span>{{student.batch}} </span></td> <td ng-repeat=\"report_console in educorePerformanceAnalysisCtrl.reportCardConsoleDetails\"> <span> {{student[report_console._id]}} </span> </td> <td><span>{{student.total_scored}} </span></td> </tr> </table> </div> </div> </div> </div> <div style=float:left;margin-left:30px;margin-top:14px;margin-bottom:30px> <span style=font-size:12px> Generated By : {{educorePerformanceAnalysisCtrl.generator.generated_by}} </span> <br> <span style=font-size:12px> Generated Date : {{educorePerformanceAnalysisCtrl.generator.generated_date}} </span> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer action-btn-clr\" layout-align=center-center> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=\"!isPdfData && !educorePerformanceAnalysisCtrl.noData\" ng-click=educorePerformanceAnalysisCtrl.export()> <span> <span class=\"font_wight controlsbtn user hand\">Export As Pdf</span> <span style=border:none> <i class=\"far fa-file-pdf footer_icon_allign\" role=button tabindex=0 aria-invalid=false></i> </span> </span> </div> <div class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" ng-if=isPdfData ng-click=educorePerformanceAnalysisCtrl.backToHtml()> <span> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span> <i class=\"fas fa-chevron-left footer_icon_allign\" role=button tabindex=0 aria-invalid=false></i> </span> </span> </div> </div> </div> </div>";

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>table{font-size:13px!important}td{font-size:13px!important}strong{font-size:13px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:700px;margin:0 auto;background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block;border-bottom:2px solid #efc5c5}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:13px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:left;vertical-align:middle;font-size:13px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:left;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-radius:10px;margin-bottom:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:13px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{padding:2px;width:40%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:13px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}.cumulative-color{background-color:#45a4de;border-radius:0;padding:8px 20px}.extra-subject{border-radius:24px;padding:0 13px;color:#fff;font-size:13px}.report-table-scrolling{overflow-x:scroll}</style> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt style=color:#fff>Loading, please wait ...</span> </md-backdrop> <div layout=column ng-click=keyDownHandler($event) style=cursor:default;outline:0;display:flex> <div class=\"result-analysis filter-show\" ng-click=\"isFilter = !isFilter\"> <i class=\"fa fa-caret-down filter-show-icon\" ng-if=isFilter></i> <i class=\"fa fa-caret-up filter-show-icon\" ng-if=!isFilter></i> </div> <md-content class=\"md-whiteframe-3dp margin_20 result-analysis\" ng-show=isFilter> <div layout=row flex ng-if=sessions.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Session & Curriculum</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row flex=80 class=\"filter-values odd\"> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-session> <div class=filter-each ng-repeat=\"session in sessions\" ng-click=getCuriculum(session) ng-class=\"{ 'filter-selected-label': selectAcademics.session._id === session._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.session._id === session._id }\">{{session.name}}</p> </div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=none class=fiter-curriculum> <div class=filter-each ng-repeat=\"curriculum in curriculums\" ng-click=getClass(curriculum) ng-class=\"{ 'filter-selected-label': selectAcademics.curriculum._id === curriculum._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.curriculum._id === curriculum._id }\">{{curriculum.name}}</p> </div> </div> </div> </div> <div layout=row flex class=top-border ng-if=classes.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Class</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values even\"> <div class=filter-each ng-repeat=\"class in classes\" ng-click=getBatch(class) ng-class=\"{ 'filter-selected-label': selectAcademics.class._id === class._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.class._id === class._id }\">{{class.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=batches.length> <div layout=column flex=20 class=\"filter-label odd\"> <p>Batch</p> </div> <div class=\"analysis-filter-arrow-content odd\"> <div class=\"analysis-filter-arrow odd\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-values odd\"> <div class=filter-each ng-repeat=\"batch in batches\" ng-click=getSubject(batch) ng-class=\"{ 'filter-selected-label': selectAcademics.batch._id === batch._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.batch._id === batch._id }\">{{batch.name}}</p> </div> </div> </div> <div layout=row flex class=top-border ng-if=subjects.length> <div layout=column flex=20 class=\"filter-label even\"> <p>Subject</p> </div> <div class=\"analysis-filter-arrow-content even\"> <div class=\"analysis-filter-arrow even\"></div> </div> <div layout=row layout-align=\"start center\" layout-wrap flex=80 class=\"filter-subject-values even\"> <div class=filter-subject-each ng-repeat=\"subject in subjects\" ng-click=fetchReport(subject) ng-class=\"{ 'filter-selected-label': selectAcademics.subject._id === subject._id }\"> <p ng-class=\"{ 'filter-selected-text': selectAcademics.subject._id === subject._id }\">{{subject.name}}</p> </div> </div> </div> </md-content> </div> <md-content ng-if=myCumulativeReportCtrl.noData layout-padding class=\"reports md-whiteframe-3dp margin_20\" flex style=background:#fff;padding:10px;overflow:auto> <p ng-if=myCumulativeReportCtrl.noData>Sorry! No Data to show</p> </md-content> <div ng-if=\"!myCumulativeReportCtrl.noData && !isPdfData\" class=\"main_con md-whiteframe-3dp\" style=padding-top:0;padding-bottom:3px;margin-bottom:89px> <div class=full_width> <div class=main_con style=width:679px> <div class=annexure_con> <div style=float:left clas=heading_mid> <div class=profile_img> <img style=width:100px src={{myCumulativeReportCtrl.header.school_logo}}> </div> <div style=\"width:429px;float:left;PADDING:0PX 10PX\"> <h1 class=logo_name style=\"text-align:center;font-family:Century Gothic;font-weight:Regular;margin-bottom:0;margin-top:0;font-size:33px\">{{myCumulativeReportCtrl.header.school_name}}</h1> <h3 style=margin-top:9px>[Affiliated to Central Board of Secondary Education, Delhi]</h3> </div> <div class=profile_img> <img style=width:100px src={{myCumulativeReportCtrl.header.student_img}}> </div> </div> <div style=float:left;width:100% flex> <h1 class=h1_font_size style=margin-bottom:10px;font-weight:700>STUDENT CUMULATIVE PROGRESS REPORT {{myCumulativeReportCtrl.header.academic_year}}</h1> <h3 class=h1_font_size style=margin-bottom:10px;font-weight:700;margin-top:10px>{{myCumulativeReportCtrl.header.academics}} </h3> </div> <div> <span class=md-subhead style=float:right> <b>Student Name: </b> {{myCumulativeReportCtrl.header.student_name}}</span> </div> </div> </div> <div class=space-around-color> <div flex style=margin:10px> <span style=\"margin-bottom:5px;background-color:#1665c1;border-radius:24px;padding:0 13px;color:#fff;font-size:13px\" class=theme-selection ng-repeat=\"subject in myCumulativeReportCtrl.scholasticSubjects\">{{subject.alias}} - {{subject.name}} </span> </div> <div class=color-top-bar> <span> ACADEMIC PERFORMANCE </span> </div> <div class=table-color-con> <div style=float:left;width:100%;margin-bottom:30px> <span class=e1> <span class=range-color> E2 </span> <span class=start-0> 0 </span> <span class=end-32>20</span> </span> <span style=background-color:#e2b60c class=e2> <span class=range-new> E1 </span> <span class=end-new>32</span> </span> <span style=background-color:#d6aa00 class=e2> <span class=range-new> D </span> <span class=end-new>40</span> </span> <span style=background-color:#e6c95a class=e2> <span class=range-new> C2 </span> <span class=end-new>50</span> </span> <span style=background-color:#b7b6b1 class=e2> <span class=range-new> C1 </span> <span class=end-new>60</span> </span> <span style=background-color:#93ca16 class=e2> <span class=range-new> B2 </span> <span class=end-new>70</span> </span> <span style=background-color:#56bbec class=e2> <span class=range-new> B1 </span> <span class=end-new>80</span> </span> <span style=background-color:#d0a1f3 class=e2> <span class=range-new> A2 </span> <span class=end-new>90</span> </span> <span style=background-color:#d0a1f3 class=e2> <span class=range-new> A1 </span> <span class=end-new>100</span> </span></div> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=1>Subjects</th> <th ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" colspan=1>{{console.report_name}}</th> </tr> </thead> <thead> <tr style=font-size:12px ng-repeat=\"subject in myCumulativeReportCtrl.scholasticSubjects\"> <td style=font-size:20px;font-weight:700 colspan=1>{{subject.name}} </td> <td ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" style=font-size:20px;font-weight:700 colspan=1> <span ng-if=myCumulativeReportCtrl.subject_report[subject._id][console._id]>{{myCumulativeReportCtrl.subject_report[subject._id][console._id].grade}}</span> <span ng-if=!myCumulativeReportCtrl.subject_report[subject._id][console._id]>-</span> </td> </tr> </thead> </table> </div> <div class=\"color-top-bar cumulative-color\"> <span> RELATIVE PERFORMANCE</span> </div> <div class=table-color-con> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead style=background-color:#a0dbfc> <tr> <th colspan=1>Status</th> <th ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" colspan=1>{{console.report_name}}</th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=1> <span style=\"background-color:#31c4a7;border-radius:24px;padding:0 13px;color:#fff;font-size:13px\"> Highest </span> </td> <td ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" style=font-size:20px colspan=1><span ng-if=myCumulativeReportCtrl.relationValue[console._id].highest.length style=\"background-color:#31c4a7;border-radius:24px;padding:0 5px;color:#fff;font-size:13px\" ng-repeat=\"val in myCumulativeReportCtrl.relationValue[console._id].highest\">{{val}},</span> <span ng-if=!myCumulativeReportCtrl.relationValue[console._id].highest.length style=color:#101010>-</span> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=1> <span style=\"background-color:#e6aa22;border-radius:24px;padding:0 13px;color:#fff;font-size:13px\"> Above Average </span> </td> <td ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" style=font-size:20px colspan=1> <span ng-if=myCumulativeReportCtrl.relationValue[console._id].above_average.length style=\"background-color:#e6aa22;border-radius:24px;padding:0 5px;color:#fff;font-size:13px\" ng-repeat=\"val in myCumulativeReportCtrl.relationValue[console._id].above_average\">{{val}},</span> <span ng-if=!myCumulativeReportCtrl.relationValue[console._id].above_average.length style=color:#101010>-</span> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=1> <span style=\"background-color:#64c0f3;border-radius:24px;padding:0 13px;color:#fff;font-size:13px\"> Below Average </span> </td> <td ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" style=font-size:20px colspan=1> <span ng-if=myCumulativeReportCtrl.relationValue[console._id].below_average.length style=\"background-color:#64c0f3;border-radius:24px;padding:0 5px;color:#fff;font-size:13px\" ng-repeat=\"val in myCumulativeReportCtrl.relationValue[console._id].below_average\">{{val}},</span> <span ng-if=!myCumulativeReportCtrl.relationValue[console._id].below_average.length style=color:#101010>-</span> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=1> <span style=\"background-color:#e64242;border-radius:24px;padding:0 13px;color:#fff;font-size:13px\"> Lowest </span> </td> <td ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\" style=font-size:20px colspan=1> <span ng-if=myCumulativeReportCtrl.relationValue[console._id].lowest.length style=\"background-color:#e64242;border-radius:24px;padding:0 5px;color:#fff;font-size:13px\" ng-repeat=\"val in myCumulativeReportCtrl.relationValue[console._id].lowest\">{{val}},</span> <span ng-if=!myCumulativeReportCtrl.relationValue[console._id].lowest.length style=color:#101010>-</span> </td> </tr> </thead> </table> </div> <div class=color-top-bar> <span> OVERALL ACADEMIC GRADE</span> </div> <div class=table-color-con> <div style=float:left;width:100%;margin-bottom:30px> </div> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=1>Reports</th> <th colspan=1>Student Grade</th> <th colspan=1>Class Grade</th> </tr> </thead> <thead> <tr style=font-size:12px ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\"> <td style=font-size:20px;font-weight:700 colspan=1>{{console.report_name}} </td> <td style=font-size:20px;font-weight:700 colspan=1> <span ng-if=myCumulativeReportCtrl.overallAcg[console._id].grade>{{myCumulativeReportCtrl.overallAcg[console._id].grade}}</span> <span ng-if=!myCumulativeReportCtrl.overallAcg[console._id].grade>-</span> </td> <td style=font-size:20px;font-weight:700 colspan=1>{{myCumulativeReportCtrl.classAvg[console._id].grade}} </td> </tr> </thead> </table> </div> </div> <div class=main_con style=width:679px> <div class=full_w2idth> <div> </div> </div> </div> <div class=space-around-color ng-repeat=\"console in myCumulativeReportCtrl.reportCardConsoleDetails\"> <div class=color-top-bar> <span> CO SCHOLASTIC/ CO CURRICULAR PERFORMANCE of {{console.report_name}}</span> </div> <div class=table-color-con> <div style=float:right;width:100%;margin-bottom:30px> <span class=e1> <span class=range-color> C </span> <span class=start-0> 0 </span> <span class=end-32>1</span> </span> <span style=background-color:#93ca16 class=e2> <span class=range-new>B </span> <span class=end-new>2</span> </span> <span style=background-color:#cd9de4 class=e2> <span class=range-new> A </span> <span class=end-new>3</span> </span> <span>CO SCHOLASTIC</span> </div> <div style=float:left;width:100%;margin-bottom:30px> <span class=e1> <span class=range-color> E2 </span> <span class=start-0> 0 </span> <span class=end-32>20</span> </span> <span style=background-color:#e2b60c class=e2> <span class=range-new> E1 </span> <span class=end-new>32</span> </span> <span style=background-color:#d6aa00 class=e2> <span class=range-new> D </span> <span class=end-new>40</span> </span> <span style=background-color:#e6c95a class=e2> <span class=range-new> C2 </span> <span class=end-new>50</span> </span> <span style=background-color:#b7b6b1 class=e2> <span class=range-new> C1 </span> <span class=end-new>60</span> </span> <span style=background-color:#93ca16 class=e2> <span class=range-new> B2 </span> <span class=end-new>70</span> </span> <span style=background-color:#56bbec class=e2> <span class=range-new> B1 </span> <span class=end-new>80</span> </span> <span style=background-color:#d0a1f3 class=e2> <span class=range-new> A2 </span> <span class=end-new>90</span> </span> <span style=background-color:#d0a1f3 class=e2> <span class=range-new> A1 </span> <span class=end-new>100</span> </span> <span>CO CURRICULAR</span> </div> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=1>SUBJECTS</th> <th colspan=1>Grade</th> <th colspan=1>Remarks</th> </tr> </thead> <thead> <tr style=font-size:12px ng-repeat=\"subject in myCumulativeReportCtrl.extraSubjectArray\"> <td style=font-size:20px;font-weight:700 colspan=1>{{subject.name}} </td> <td ng-if=myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].grade style=font-size:20px colspan=1><span class=extra-subject ng-style={{myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].color}}> {{myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].grade}}</span> </td> <td ng-if=!myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].grade style=font-size:20px colspan=1><span class=extra-subject style=color:#101010>- {{myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].grade}}</span> </td> <td ng-if=myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].remarks style=font-size:20px colspan=1><span class=extra-subject ng-style={{myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].color}}>{{myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].remarks}}</span> </td> <td ng-if=!myCumulativeReportCtrl.extraSubjectData[console._id][subject._id].remarks style=font-size:20px colspan=1><span class=extra-subject style=color:#101010>-</span> </td> </tr> </thead> </table> </div> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div> <div ng-cloak> <div flex layout=row layout-padding class=footer layout-align=center-center> <md-button ng-if=\"!isPdfData && !myCumulativeReportCtrl.noData\" ng-click=myCumulativeReportCtrl.export() class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" aria-label=Add> Export as pdf <i class=\"footer_icon_allign far fa-file-pdf fa-lg\"></i> </md-button> <md-button ng-if=isPdfData ng-click=myCumulativeReportCtrl.backToHtml() class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" aria-label=Add> Back to HTML <i class=\"fas fa-chevron-left footer_icon_allign\"></i>  </md-button> </div> </div> </div>";

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout-padding class=\"md-whiteframe-3dp margin_20 bgColor pages clubActivityCtrl\" md-theme=makeMeWhite layout=row layout-align=\"space-between center\" flex-xs=100 layout-xs=column> <div ng-if=\"getClubs.length >=1||canCreateClub\"> <md-input-container class=md-block> <label>Club Name</label> <md-select ng-model=activeClub> <md-option value={{clubName._id}} ng-click=getClubDetails(clubName._id,clubName.created_by) ng-repeat=\"clubName in getClubs | orderBy : '-created_date'\"> <img id=imgIdLogo ng-if=clubName.logo class=club_logos ng-src=\"{{urlval + clubName.logo}}\" alt=\"\"/> {{clubName.name}} </md-option> <md-option value=all ng-click=getAllPosts()>View All Posts</md-option> </md-select> </md-input-container> </div> <div ng-if=\"getClubs.length <=0 && !isLoading\"> <div> <div layout=row layout-align=\"space-around center\"> <div></div> <div>No club found !</div> <div></div> </div> </div> </div> <div layout=row layout-align=\"start center\" flex-sm=100 layout-sm=column flex-xs=100 layout-xs=column> <div class=create_club ng-if=canCreateClub> <md-button class=\"md-whiteframe-2dp button_font\" style=background-color:#1665c1!important ng-click=createClub()> <img src=" + __webpack_require__(55) + "> Create Club </md-button> </div> <div ng-if=(canCreateClub&&addMembers)||isDeleteClub> <span ng-if=(loadPrivileges&&loadPrimary)||isDeleteClub> <div class=dropBoxMenu layout=column flex-xs=100 flex-sm=100 flex=33 layout-align=\"center center\"> <md-menu> <md-button class=\"md-whiteframe-2dp button_font\" ng-click=$mdOpenMenu($event) style=background-color:#1665c1!important> <img src=" + __webpack_require__(900) + "> settings <i class=\"fas fa-chevron-down\"></i> </md-button> <md-menu-content width=4> <md-menu-item ng-if=addMembers> <md-button ng-click=renameClub()> <img class=club_logos src=" + __webpack_require__(901) + " alt=logo> Rename Club </md-button> </md-menu-item> <md-menu-item ng-if=addMembers> <md-button ng-click=addUser()> <img class=club_logos src=" + __webpack_require__(902) + " alt=logo> Add User </md-button> </md-menu-item> <md-menu-item ng-if=toRemoveUser> <md-button ng-click=removeUser()> <img class=club_logos src=" + __webpack_require__(903) + " alt=logo> Remove User </md-button> </md-menu-item> <md-menu-item ng-if=isDeleteClub> <md-button ng-click=deleteClub()> <img class=club_logos src=" + __webpack_require__(386) + " alt=logo> Delete Club </md-button> </md-menu-item> <md-menu-item ng-if=addMembers> <md-button ng-click=editLogo()> <img class=club_logos src=" + __webpack_require__(904) + " alt=logo> Edit Club Logo </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </span> </div> <div class=create_club ng-if=canComment&&loadPrivileges&&loadPrimary> <md-button class=\"md-whiteframe-2dp button_font\" style=background-color:#1665c1!important ng-click=viewUser()> <img src=" + __webpack_require__(905) + "> View Club Users </md-button> </div> </div> </div> <div class=\"clubActivityCtrl club\" scroller> <div class=\"postLoop md-whiteframe-10dp\" ng-repeat=\"post in clubActivity | orderBy : '-post_date'\" md-theme=makeMeWhite layout=column> <div flex class=club_title layout=row layout-align=\"space-between start\" flex=10> <h4>{{post.title}}</h4> <span ng-if=\"post.isShow && post.view=='private' && !post.isClubOwner\" class=post_status> <label>Status:</label> Private ! </span> </div> <div class=posted-by flex=10><span>Posted by:</span><b>{{post.postedBy}}</b></div> <div layout=row layout-align=\"space-around center\" flex> <div layout=column ng-if=\"post.url!=null\" flex=45 style=\"\"> <div ng-if=\"post.type =='image'\" flex class=img_min_height style=\"\"> <img ng-if=post.url id=imgId class=\"Img hand\" ng-src={{post.url}} alt={{post.title}} ng-click=showSelectedPost(post._id,post.url,post.type)> </div> <div ng-if=\"post.type =='video'\" flex class=img_min_height style=\"\"> <img class=\"Img hand\" ng-src={{post.thumbUrl}} alt={{post.title}} ng-click=showSelectedPost(post._id,post.url,post.type)> </div> <div class=\"post-text hand\" flex ng-if=post.textarea ng-click=\"showSelectedPost(post._id,post.textarea,'text')\"> {{ post.textarea | limitTo: 65 }}{{post.textarea.length > 65 ? '...' : ''}} </div> <div layout=row flex layout-align=\"space-between center\" ng-if=loadPrivileges class=like-del> <div flex=20 ng-if=canComment class=\"hand leftmargin-thumpsup\" style=margin-left:20px!important> <img ng-if=!post.likeMem class=like src=" + __webpack_require__(387) + " ng-click=\"postLike(post._id, post)\"> <img ng-if=post.likeMem class=like src=" + __webpack_require__(75) + " ng-click=\"postUnLike(post._id, post)\"> <span ng-if=post.likeMem class=like_color>Liked </span> </div> <div flex=20 ng-if=post.setPrivacy class=setPrivacy> <md-switch class=privacy style=color:#297290!important;margin:0 ng-model=post.postView aria-label=Privacy ng-click=\"postPrivillege(post._id,post.postView, post)\"> {{post.view =='public' ? 'Public' : 'Private'}} </md-switch> </div> <div flex=30 ng-if=\"deletePost&&(post.setPrivacy || post.isShow)\" class=hand ng-click=postDelete(post._id) style=margin-left:20px!important> <img class=delete src=" + __webpack_require__(388) + "> </div> </div> </div> <div layout=column ng-if=\"post.url==null\" flex=45 style=\"\"> <div class=img_min_height flex> <img id=imgId class=\"Img hand\" src=" + __webpack_require__(906) + "> </div> <div class=\"post-text hand\" ng-if=post.textarea ng-click=\"showSelectedPost(post._id,post.textarea,'text')\"> {{ post.textarea | limitTo: 65 }}{{post.textarea.length > 65 ? '...' : ''}} </div> <div flex layout=row layout-align=\"space-between center\" ng-if=loadPrivileges class=like-del> <div flex=20 ng-if=canComment class=\"hand leftmargin-thumpsup\" style=margin-left:20px!important> <img ng-if=!post.likeMem class=like src=" + __webpack_require__(387) + " ng-click=postLike(post._id)> <img ng-if=post.likeMem class=like src=" + __webpack_require__(75) + " ng-click=postUnLike(post._id)> <span ng-if=post.likeMem class=like_color>Liked </span> </div> <div flex=20 ng-if=post.setPrivacy class=setPrivacy> <md-switch class=privacy style=color:#297290!important;margin:0 ng-model=post.postView aria-label=Privacy ng-click=\"postPrivillege(post._id,post.postView, post)\"> {{post.view =='public' ? 'Public' : 'Private'}} </md-switch> </div> <div flex=30 ng-if=\"deletePost&&(post.setPrivacy || post.isShow)\" class=hand ng-click=postDelete(post._id) style=margin-left:20px!important> <img class=delete src=" + __webpack_require__(388) + "> </div> </div> </div> <div flex=55 layout=column class=md-whiteframe-3dp layout-align=\"end stretch\"> <div ng-repeat=\"comment in post.comments | orderBy: '-added_date' | limitTo:2\" style=padding:20px> <div layout=row> <div flex=10> <img style=height:40px;width:40px;border-radius:28px ng-src={{comment.profileImg}}> </div> <div flex=90 style=margin-left:9px;background-color:#c9e7fe;padding-bottom:10px;padding-top:10px> <span style=color:#2e75c7!important;font-weight:700;padding:15px>{{comment.userName}}</span><br> <span class=post-stye style=padding-left:15px>{{comment.comment | limitTo: 100}} {{comment.comment.length > 100 ? '...' : ''}}</span> <span class=hand style=padding-left:15px ng-if=\"comment.comment.length > 100\" ng-click=showSingleComment(comment.comment)>...</span><br> <span class=date_time style=padding-left:15px>{{comment.added_date | date:'medium'}} </span> </div> </div> <md-divider style=margin-top:11px></md-divider> </div> <div ng-if=!post.comments flex=90></div> <div class=\"comment_width enter_comment\" ng-if=\"loadPrivileges && canComment\" layout=column> <div flex style=\"padding:0 10px\"> <md-input-container flex style=width:100%> <textarea ng-model=comment[$index] placeholder=\"\n              Enter comment\" class=post-stye-comment></textarea> </md-input-container> </div> <div style=background-color:#36b55e;height:32px layout=row layout-align=\"end center\" flex> <div ng-click=addCommentData(post._id,$index) style=\"background-color:#fff;height:27px;padding:5px 6px;width:27px;margin:6px;border-radius:17px;-webkit-transform:rotate(308deg)\"> <i class=\"far fa-share-square\"></i> </div> </div> </div> <div flex layout=row class=post_counts> <div ng-if=readComment||isDeleteClub class=\"like-box viewLike\" style=\"\">{{post.likesCount}} <img class=\"likeCount hand\" src=" + __webpack_require__(75) + " title=liked alt=liked ng-click=showLikedDetails(post._id) ng-if=\"post.likesCount >=1\"> <img class=\"likeCount hand\" src=" + __webpack_require__(75) + " title=\"un liked\" alt=\"un liked\" ng-if=\"post.likesCount <=0\"> </div> <div ng-if=readComment||isDeleteClub class=\"like-box viewComment\" style=\"\">{{post.commentsCount}} <img class=\"comment hand\" src=" + __webpack_require__(389) + " ng-click=\"showCommentDetails($event, post._id)\" ng-if=\"post.commentsCount >=1\"> <img class=\"comment hand\" src=" + __webpack_require__(389) + " ng-if=\"post.commentsCount <=0\"> </div> </div> </div> </div> </div> <div ng-if=\"getClubs.length >=1 && getClubActivity.length <=0 && !isLoading\"> <div layout=row layout-align=\"space-around center\"> <div></div> <div>No posts found !</div> <div></div> </div> </div> </div> <footer class=\"footer-Btn clubActivityCtrl\" ng-if=isCreatePost> <div style=\"background:0 0;position:fixed;bottom:20px;right:100px\"> <md-button ng-show=\"loadPrivileges && loadPrimary\" class=\"md-fab md-primary md-hue-2\" aria-label=Add style=background:#1565c0 ng-click=createPost(isClubOwnerID)> <i class=\"fas fa-plus fa-lg\"></i> </md-button> </div> </footer> ";

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.loadinfTxt{color:#fff;font-weight:700}.userDet{font-size:10px;text-transform:uppercase}.club_name{margin-left:15px}.only_owner{color:#29cae1;font-size:10px;font-weight:700}</style> <div md-theme=makeMeWhite flex layout=column layout-margin=3px layout-padding=10px class=\"club create-club createClubCtrl md-whiteframe-3dp containerArea clubActivityCtrl\"> <div layout=column md-theme=makeMeWhite class=\"controls space-around md-whiteframe-3dp margin_20 bgColor pages\"> <div class=club_title flex style=background-color:#35b558> <h4>Club Details</h4> </div> <div layout=row layout-align=\"space-between center\" flex layout-xs=column style=padding-top:12px> <div flex=20 class=\"\"> <md-input-container class=\"md-block club_name\" flex-gt-sm style=\"\" ng-if=!club_id> <label>Enter Club name</label> <input id=club_name ng-model=club.name> </md-input-container> <span ng-if=club_id> <h3 class=club_name>{{club.name}}</h3></span> </div> <div flex=20 ng-if=!clubMode></div> <div flex=40 ng-if=!clubMode layout=row layout-align=\"space-between center\"> <div flex ng-if=showBrowseBtn layout=row> <span style=padding-top:13px>Upload Club Logo</span> <span> <div ng-show=club.picFile class=club_logos_1> <div layout-wrap layout=row></div> </div> </span> <md-button class=\"md-whiteframe-2dp button_font\" style=background-color:#1665c1!important;min-width:97px!important ngf-max-size=20MB ngf-resize=\"{width: 150, height: 150, centerCrop: false}\" ngf-pattern=\"'image/*'\" ngf-min-height=100 ngf-select=handleFileSelect($files) ng-model=club.picFile accept=image/*><img src=" + __webpack_require__(916) + "> Browse </md-button> </div> <div flex=40> <div ng-if=\"!club_id && myImage\" class=box_> <img src={{myImage}} class=Images> </div> </div> </div> <div ng-if=\"club_id && clubMode\" class=logo_margin> <img class=Images src={{club.logo}} alt=Logo> </div> <div flex=5 ng-if=!clubMode></div> <div flex=25 ng-if=clubMode></div> <div flex ng-if=\"ifMembersExist&&clubMode !='view'&&showCreateButton\"> <md-button class=button_font style=background-color:#1665c1!important ng-if=!clubMode ng-click=imgSubmit(croppedDataUrl) ng-disabled=ifCliked> <img src=" + __webpack_require__(55) + "> Create Club </md-button> <md-button class=button_font style=background-color:#1665c1!important ng-if=\"clubMode =='addmore'\" ng-click=createClub() ng-disabled=ifUpdated> <img src=" + __webpack_require__(55) + "> Add Members </md-button> <md-button class=button_font style=background-color:#1665c1!important ng-if=\"clubMode =='remove' && removeMode\" ng-click=removeMembers() ng-disabled=ifRemoved> <img src=" + __webpack_require__(55) + "> Remove Members </md-button> </div> </div> </div> <div class=\"filterLists divfixedheight_ controls space-around md-whiteframe-3dp margin_20 bgColor pages\" md-theme=makeMeWhite ng-if=\"selectedUsers.length!=0\"> <div class=club_title style=padding-top:10px> <h4 style=padding-bottom:10px>Selected Members</h4> </div> <div layout=row layout-align=\"space-between center\"> <md-input-container class=\"studentSearch md-icon-float md-icon-right\" style=width:250px> <label>Search User</label> <i class=\"fas fa-search fa-lg\" style=color:#2b2b2b></i> <input type=text ng-model=createClub.searchUser autocomplete=off> </md-input-container> <md-button class=button_font style=background-color:#1665c1!important ng-click=deleteFromSelectedMembers() ng-disabled=ifRemoved> <img src=" + __webpack_require__(55) + "> Remove Members </md-button> </div> <div layout=row layout-padding layout-wrap style=padding-bottom:32px> <md-whiteframe ng-repeat=\"personList in selectedUsers | filter : createClub.searchUser | orderBy : 'name'\" class=\"md-whiteframe-3dp club_members\" flex-xl=20 flex-lg=30 flex-md=30 flex-sm=45 flex-xs=100 layout layout-align=space-between> <img ng-if=personList.image.original style=height:60px src={{personList.image.original}} style=height:60px flex=15> <img ng-if=!personList.image.original style=height:60px src=" + __webpack_require__(392) + " flex=15> <div flex=5></div> <div flex=50 class=names>{{personList.name}}</div> <div flex=2></div> <div layout=row flex> <div class=userChkBk>Remove <md-checkbox ng-model=personList.isChecked class=checkbxinput aria-label=\"Checkbox_{{$index+1}} checked checkbox\" ng-checked=false> </md-checkbox> </div> </div> </md-whiteframe> </div> </div> <div ng-if=\"clubMode !='remove'&&clubMode !='view'\"> here multi fulter <common-filter ng-init=\"isClub = clubs\"></common-filter> </div> <div class=\"club filterLists divfixedheight_ controls space-around md-whiteframe-3dp margin_20 bgColor pages\" md-theme=makeMeWhite ng-if=\"clubMode =='remove'||clubMode =='view' \"> <div class=club_title style=padding-top:10px> <h4 style=padding-bottom:10px>Members</h4> </div> <div class=userLength ng-if=\"totalUsersInThsClub>=1\" style=padding-top:10px>Total Members : {{totalUsersInThsClub}}</div> <md-input-container class=\"studentSearch md-icon-float md-icon-right\" style=width:250px ng-if=showSearchBox> <label style=padding-left:22px> <i class=\"fas fa-search\" style=color:#2b2b2b></i> Search User</label> <input type=text ng-model=createClub.searchUser autocomplete=off> </md-input-container> <div layout=row layout-padding layout-wrap> <md-whiteframe ng-repeat=\"personList in userNames | filter : createClub.searchUser | orderBy : 'name'\" class=\"md-whiteframe-3dp club_members\" flex-xl=20 flex-lg=30 flex-md=30 flex-sm=45 flex-xs=100 layout=row> <img src={{personList.image}} style=margin-right:10px;height:60px flex=15 onerror='this.src=\"../../../../src/img/header/profile_61x64.png\"'/> <div flex=80> <div flex class=names>{{personList.name}}</div> <p>{{personList.username| limitTo: 25 }}{{personList.username.length > 25 ? '...' : ''}}</p> <div layout=row class=user_details ng-if=\"personList.role_type=='student'\"> <p class=userDet>{{personList.sess_name+\" | \"+personList.cur_name+\" | \"+personList.cls_name+\" | \"+personList.btc_name}}</p> </div> <div ng-if=\"personList.role_type=='student'\"> <p class=\"userDet names\">{{personList.role_type}} </p> <p class=\"userDet names\">Admission No : {{personList.admission_number}} </p> </div> <h5 ng-if=\"personList.is_exists && personList.hideChkBox\"> Club Member </h5> <div class=user_details ng-if=\"personList.role_type !='student'\"> <span ng-repeat=\"role in personList.role_type\" class=\"userDet names\">{{role}} </span> <p class=\"userDet names\">Employee No : {{personList.empNo}} </p> <span ng-if=personList.owner class=only_owner>Club Owner</span> </div> </div> <div ng-if=\"showCheckBox && userNames.length>=1\" layout=row layout-align=\"end start\" flex=5> <md-checkbox ng-model=personList.isChecked ng-change=getClicked(personList) class=checkbxinput aria-label=\"Checkbox_{{$index+1}} checked checkbox\" ng-if=\"!personList.is_exists && personList.hideChkBox \"> </md-checkbox> </div> </md-whiteframe> </div> </div> </div> ";

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports = " <style>material-icons.initialSets{padding-top:50px;padding-bottom:25px}.oneByFour{width:25%}.reedAlert{color:red}.backred{background-color:red}.acadyear{margin-top:15px}.smallIcon{font-size:1.7rem;cursor:pointer;color:#717171}.timeInput{min-width:250px}.acadyearwidth{width:25%}.yearBox{margin-left:25%}.btn3{width:10%}.delSubject{margin-right:0}.logoBtn{margin-top:8px}.boxTitle{margin-top:8px;color:#666!important;font-weight:700}.packList{margin-bottom:15px!important;margin-top:10px!important;border:1px solid #e6e6e6}.dragBox{height:330px;overflow-y:scroll}.boxAround{padding-bottom:25px}.BoxSpace{margin-bottom:10px!important;margin-left:10px}.tab_outer5{border:2px solid #e7e7e7;margin-bottom:25px;margin-left:40px;margin-right:40px}.step_no{width:30px;height:30px;border-radius:100px;display:block;font-size:16px;text-align:center;position:relative;z-index:5;margin-left:15px;margin-top:15px}.green{background:url(../../img/tick_mark_green.png) #15a861 no-repeat center!important}.red{background:#aa171d!important}.initial{font-size:16px;padding:0;margin-left:65px;margin-top:-27px;padding-bottom:50px;color:#225491;font-weight:700}.basicBx{float:left;margin-top:-30px;margin-left:15px}.proceedBtn{margin-top:-30px;float:right;margin-right:40px;background-color:#18a8a9!important;color:#fff!important}.terms{margin-left:20px}.margin_right{margin-right:10px}.addAdd{float:right;cursor:pointer}.roleList{width:20%;margin:5px;padding-left:75px;padding-top:10px;font-weight:700}.space{margin-top:15px}.boxPadd{margin-top:5px;margin-right:25px}.roles{margin-bottom:15px}test-drag-drop-directive{width:100%!important}.addBtn{background-color:#19c4de;color:#fff!important}.drbTitle{font-weight:700;height:33px;margin-top:10px}.fontWeight{font-weight:600}.delSession{margin-right:0;height:14px;float:right}.mdp-timepicker{width:50%}.timePicker{padding-bottom:0!important}.time{height:60px}.no-margin{margin-top:0!important;line-height:50px}.mgmtLightBox{border:1px solid #dadada}.mgmtLightBoxHead{border:1px solid #dadada;min-height:10px}.box{border:1px solid #d9d9d9;padding:2px 7px;margin-right:10px;margin-top:5px;margin-bottom:10px}.sessTime{width:100%}.bold{margin-top:10px;color:#00525e!important;font-size:14px}.curri_type{margin-top:10px}.firstDiv{overflow:hidden}.session_title{font-weight:700;color:#666}.tab_outer{border:2px solid #e7e7e7}.form_wizard .stepContainer{display:block;position:relative;margin:0;padding:0;border:0 solid #ccc;overflow-x:hidden}.wizard_horizontal ul.wizard_steps{display:table;list-style:none;position:relative;width:100%;margin:0 0 20px}.wizard_horizontal ul.wizard_steps li{display:table-cell;text-align:center}.wizard_horizontal ul.wizard_steps li a,.wizard_horizontal ul.wizard_steps li:hover{display:block;position:relative;-moz-opacity:1;opacity:1;color:#666}.wizard_horizontal ul.wizard_steps li a:before{content:\"\";position:absolute;height:4px;background:#ccc;top:20px;width:100%;z-index:4;left:0}.wizard_horizontal ul.wizard_steps li a.disabled .step_no{background:#ccc}.wizard_horizontal ul.wizard_steps li a .step_no{width:40px;height:40px;line-height:40px;border-radius:100px;display:block;margin:0 auto 5px;font-size:16px;text-align:center;position:relative;z-index:5}.step_no,.wizard_horizontal ul.wizard_steps li a.selected:before{background:#34495e;color:#fff}.wizard_horizontal ul.wizard_steps li a.done .step_no,.wizard_horizontal ul.wizard_steps li a.done:before{background:#1abb9c;color:#fff}.wizard_horizontal ul.wizard_steps li:first-child a:before{left:50%}.wizard_horizontal ul.wizard_steps li:last-child a:before{right:50%;width:50%;left:auto}.link{cursor:pointer;text-decoration:none}.tab_outer{border:2px solid #e7e7e7}.logo{border:1px solid #cabdbd;min-height:180px}.logoBox{border:2px solid #e7e7e7;float:left;width:150px;height:150px;margin-right:15%;margin-top:15px;margin-left:25px}.file-field{position:relative}.input-field{position:relative;margin-top:1rem}.file-field .btn{float:right;height:3rem;line-height:3rem}.file-field input[type=file]{position:absolute;top:0;right:0;left:0;bottom:0;width:100%;margin:0;padding:0;font-size:20px;cursor:pointer;opacity:0}.file-field span{cursor:pointer}input{line-height:normal}.file-field .file-path-wrapper{overflow:hidden;padding-left:10px}.file-field input.file-path{width:100%}.btn,.btn-large{text-decoration:none;color:#fff;background-color:#ff4081;text-align:center;letter-spacing:.5px;-webkit-transition:.2s ease-out;-moz-transition:.2s ease-out;-o-transition:.2s ease-out;-ms-transition:.2s ease-out;transition:.2s ease-out;cursor:pointer}.btn,.btn-flat,.btn-large{border:none;border-radius:2px;display:inline-block;height:36px;line-height:36px;outline:0;padding:0 2rem;text-transform:uppercase;vertical-align:middle;-webkit-tap-highlight-color:transparent}.logoBrowser{background-color:transparent;border:none;border-bottom:1px solid #9e9e9e;border-radius:0;outline:0;height:3rem;font-size:1rem;margin:0 0 15px 0;padding:0;box-shadow:none;-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;transition:all .3s}a:hover{text-decoration:none!important}.wizard_horizontal ul.wizard_steps li a.disabled .step_no{background:#ccc}.wizard_horizontal ul.wizard_steps li a .step_no{width:40px;height:40px;line-height:40px;border-radius:100px;display:block;margin:0 auto 5px;font-size:16px;text-align:center;position:relative;z-index:5}.wizard_horizontal ul.wizard_steps li a.disabled:before{background:#ccc}.step_no,.wizard_horizontal ul.wizard_steps li a:before{background:#34495e;color:#fff}.wizard_horizontal ul.wizard_steps li a.done .step_no,.wizard_horizontal ul.wizard_steps li a.done:before{background:#1abb9c;color:#fff}.wizard_horizontal ul.wizard_steps li:first-child a:before{left:50%}.wizard_horizontal ul.wizard_steps li:last-child a:before{right:50%;width:50%;left:auto}.step_no{cursor:pointer}.bgColor{background-color:#fff!important}.imgCls{width:100%}.bgColor{background-color:#fff!important}.wrapper{color:#55637d}.slider{padding:15px;text-align:left}.btn{float:right}.division{float:right}.rz-pointer-max{left:100px}.btn_cir{border:1px solid #a1a1a1;border-radius:25px;width:10%;text-align:center;margin:2px;outline:0}.batch{background-color:#aafbfc!important;color:#4c6e70!important}.btn_subject{background-color:#fff!important;color:#5d5d5d!important;margin-bottom:25px}.tab_outer{border:2px solid #e7e7e7}.padBt{padding-bottom:20px}.padTp{padding-top:25px}.mgmtLightBox{border:1px solid #dadada}.mgmtLightBoxHead{border:1px solid #dadada;min-height:10px}.box{border:1px solid #d9d9d9;padding:2px 7px;margin-right:10px;margin-top:5px}.clr{color:#000;margin-top:30px}.md-pagination-wrapper{width:100%!important}.addAddbtn{float:right;color:#fff!important;height:25%}.hand{cursor:pointer}.myClass1,.myClass10,.myClass2,.myClass3,.myClass4,.myClass5,.myClass6,.myClass7,.myClass8,.myClass9{background-color:#34495e!important}.selectedCuri{background:#34495e}.red{background:url(img/delete_white_icon.png) red no-repeat center!important}.colorRed{color:red}.imgClsd{display:block;max-width:150px;max-height:150px;width:auto;height:auto}.classSlider md-dialog{width:100%!important}.img_preview{width:100px;margin-top:55px;height:100px}.cropArea{width:200px;height:155px}form .progress{line-height:15px}.progress{display:inline-block;width:100px;border:3px groove #ccc}.progress div{font-size:smaller;background:orange;width:0}.img-crop{width:73%!important;height:93%!important}.drag_height{min-height:120px}.manage_btn{position:relative;bottom:48px}.privilege .greenlabels{background-color:#d5e5f8;margin-right:25px!important;color:#1565c0;font-size:12px;cursor:pointer}.privilege .redlabels{background-color:#ffc9cd;margin-right:25px!important;color:#912931;font-size:12px;cursor:pointer}.privilege .heading{color:#fff;text-transform:uppercase;width:17%;padding:6px;padding-left:10px}.privilege .lessbottomMargin{margin-bottom:4px}.privilege .borderaround{border-top:1px solid rgba(128,128,128,.27);border-bottom:1px solid rgba(128,128,128,.27);padding-top:10px;padding-bottom:10px}.privilege .marginaround{margin:20px;padding-bottom:40px}.privilege .icondiv{position:relative;left:140px}.privilege .icons{width:20px;position:absolute;font-size:16px!important;float:right;bottom:1px;height:20px;text-align:center;vertical-align:middle;border-radius:15px;color:#fff;padding-top:2px}.privilege .icontick{background-color:#47b94a}.privilege .iconcross{background-color:#e7505a}.privilege .margins{margin:4px}.privilege .paddings{padding:7px}#search input[type=text]{border:1px solid #f5f5f5;width:300px;padding:6px 15px 6px 35px;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;text-shadow:0 2px 3px rgba(0,0,0,.1);-webkit-box-shadow:0 1px 3px rgba(0,0,0,.15) inset;-moz-box-shadow:0 1px 3px rgba(0,0,0,.15) inset;box-shadow:0 1px 3px rgba(0,0,0,.15) inset;-webkit-transition:all .7s ease 0s;-moz-transition:all .7s ease 0s;-o-transition:all .7s ease 0s;transition:all .7s ease 0s;outline:0}#search input[type=text]:focus{width:400px}input::placeholder{color:#000}.privilege .img_edit{width:15px;height:15px}.privilege .togglebutton{width:100px;border-radius:30px;border:2px solid #5bdbe8;height:27px;cursor:pointer}.privilege .toggleItem{width:50px;outline:0}.privilege .currentItem{background-color:#5bdbe8}.privilege .img_toggle{width:18px;height:18px}.privilege .leftradius{border-top-left-radius:2em;border-bottom-left-radius:2em}.privilege .rightradius{border-top-right-radius:2em;border-bottom-right-radius:2em}.privilege .selectedpac{font-size:16px;margin-top:5px}.privilege .marginsarnd{margin:20px 20px 10px 20px}.privilege .serachicon{position:absolute;margin-top:6px;margin-left:10px;font-size:21px!important}.privilege .margin_left{margin-left:10px!important}.privilege .aroundmargin{margin:10px}.privilege .aroundPadding{padding:20px}.privilege .boxes{background-color:#d5e5f8;padding:3px 4px 3px 4px;font-size:12px;margin:0 5px 5px 2px}.privilege .showboxes{height:60px;overflow-y:scroll;overflow-x:hidden}.privilege .set_heading{padding:10px;background-color:#36b3f3;color:#fff;font-size:19px}.privilege .pagesize{height:70vh;margin-bottom:65px;overflow-y:scroll}.privilege .ashbackground{background-color:#f3f3f2}.privilege .md-accordion{margin:0!important;padding:0 0!important;margin-bottom:5px!important}.privilege .md-accordion .expandCollapse{width:32px;height:32px;position:relative;font-weight:700;cursor:pointer;color:#000;display:block;margin-top:-2px;margin-left:-2px;overflow:hidden}.privilege .md-accordion .expandCollapse:active{border:0}.privilege .md-accordion .expandCollapse:after,.privilege .md-accordion .expandCollapse:before{width:32px;height:32px;position:absolute;top:0;left:0;line-height:36px;text-align:center;-webkit-transition:.3s all ease-out;transition:.3s all ease-out}.privilege .md-accordion .expandCollapse:before{opacity:1 -webkit-transform: rotate(0);transform:rotate(0);content:\"|\";margin-top:-3px}.privilege .md-accordion .expandCollapse:after{opacity:1;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);content:\"|\";margin-left:-3px}.privilege .md-accordion .active:before{opacity:1;-webkit-transform:rotate(90deg);transform:rotate(90deg);margin-left:3px;margin-top:0}.privilege .md-accordion .dataContent{background:#fff;height:0;overflow:hidden;-webkit-transition:.3s all ease-out;transition:.3s all ease-out}.privilege .md-accordion .activeContent{height:auto;padding:0;margin:10px}.normalAccordionHeadColor{background:#fff;font-size:15px;letter-spacing:.005em;box-sizing:border-box;font-weight:400;display:flex;align-items:center;flex-direction:row;width:100%;height:50px;max-height:50px;padding:0 16px;margin:0}.selectedAccordionHeadColor{background:#82b1ff;font-size:12px;letter-spacing:.005em;box-sizing:border-box;font-weight:400;display:flex;align-items:center;flex-direction:row;width:100%;height:50px;max-height:50px;padding:0 16px;margin:0}.privilege .acctoolbar{padding:6px;padding-left:35px;color:#fff;font-size:17px}md-checkbox.md-checked .md-icon:after{width:5.66667px!important;height:10.33333px!important}.privilege .smallcheckbox .md-checkbox .md-icon{height:15px!important;width:15px!important}md-checkbox .md-icon{height:15px!important;width:15px!important}.privilege .feturebox{background-color:#e7e5e6;padding:5px;padding-bottom:2px!important;margin-right:10px;margin-top:5px;margin-bottom:5px}.privilege .featureboxfont{font-size:12px}.privilege .redbackground{background-color:#e6505d!important}.privilege .margin_check{margin-bottom:4px!important;margin-top:4px}.privilege .margin-left{margin-left:7px}.privilege .margin-right{margin-left:2px}.privilege .font-size-icon{font-size:20px!important}.underline{text-decoration:underline}.bold{font-weight:700}.md-body-1,.md-body-2{color:#828282!important;width:100%;white-space:pre-wrap;word-break:break-all;word-wrap:break-word}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bulkTable>tbody>tr>td,.bulkTable>thead>tr>th{padding:15px!important;border-bottom:1px solid #b5a49e}.bulkTable thead tr th{min-width:235px!important}.bulkTable tbody tr td{min-width:234px!important}.bold{font-weight:700!important}.bulkDialog tbody{display:block;height:250px;overflow:auto}.bulkDialog thead{display:table;table-layout:fixed}.bulkDialog .table-responsive-vertical{overflow-x:scroll}.feature{max-width:95%;height:40px;padding:10px 0 0 15px}.sub{max-width:95%;height:40px;padding:5px 0 0 15px;margin:5px}.division{margin-bottom:5px!important}.intialstupBox{background:#dbdde0;padding:20px}#rcorners11{border-radius:0;background:#fff;padding:2px;margin:6px;-moz-box-shadow:0 0 2px 2px #eaeaea;-webkit-box-shadow:0 0 2px 2px#eaeaea;box-shadow:0 0 2px 2px #eaeaea}#rcorners2{height:100%;border-radius:0;background:#fff;padding:10px;margin:5px}#rcorners_new{border-radius:0;background:#fff;padding:10px;border:1px solid #dbdbdb}.as-sortable-item-handle{padding:15px}</style> <div class=intialstupBox> <div layout-padding ng-cloak ng-hide=noToolBar class=\"md-whiteframe-2dp bgColor pageInit\" md-theme=makeMeWhite> <wizard-status ng-show=showWizard feature-data=tabStats></wizard-status> <a id=top></a> <h4 class=\"noMargin fontWeight\">Curriculum & Session</h4> <div layout=row flex=60 layout-sm=column ng-if=curriculumCtrl.editMode> <div flex> <div style=margin-top:10px> <md-card-title> <label class=md-body-1>Update Session</label> <md-divider></md-divider> </md-card-title> </div> <div layout=row layout-align=\"end end\"> <md-button class=\"md-raised md-hue-2 md-primary addBtn\" ng-click=curriculumCtrl.updateSession()>Update</md-button> <md-button class=\"md-raised md-hue-2 md-primary addBtn\" ng-click=curriculumCtrl.cancelEdit()>Cancel</md-button> </div> <div style=min-height:15px flex> <div ng-init=getTime(curriculumCtrl.sessionToEdit)> <div id=rcorners11> <div layout-gt-xs=column layout-padding> <div layout-gt-xs=row class=drbTitle> {{curriculumCtrl.sessionToEdit.name}} </div> <md-divider></md-divider> <div layout-gt-xs=row class=timePicker1> <label for=exampleInput class=no-margins>Start Time</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <md-input-container> <label>Hour</label> <md-select ng-model=curriculumCtrl.sessionToEdit.hh> <md-option ng-repeat=\"h in curriculumCtrl.hours\" ng-value=h> {{h}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Minutes</label> <md-select ng-model=curriculumCtrl.sessionToEdit.mm> <md-option ng-repeat=\"m in curriculumCtrl.minutes\" ng-value=m> {{m}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Meridian</label> <md-select ng-model=curriculumCtrl.sessionToEdit.mer> <md-option value=AM> AM </md-option> <md-option value=PM> PM </md-option> </md-select> </md-input-container> </div> <span ng-if=\"curriculumCtrl.errors['editStart']\" class=reedAlert>{{curriculumCtrl.errors['editStart']}}</span> <md-divider></md-divider> <div layout-gt-xs=row class=timePicker1> <label for=exampleInput class=no-margins>End Time</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <md-input-container> <label>Hour</label> <md-select ng-model=curriculumCtrl.sessionToEdit.hhEnd> <md-option ng-repeat=\"h in curriculumCtrl.hours\" ng-value=h> {{h}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Minutes</label> <md-select ng-model=curriculumCtrl.sessionToEdit.mmEnd> <md-option ng-repeat=\"m in curriculumCtrl.minutes\" ng-value=m> {{m}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Meridian</label> <md-select ng-model=curriculumCtrl.sessionToEdit.merEnd> <md-option value=AM> AM </md-option> <md-option value=PM> PM </md-option> </md-select> </md-input-container> </div> <span ng-if=\"curriculumCtrl.errors['editEnd']\" class=reedAlert>{{curriculumCtrl.errors['editEnd']}}</span> <md-divider></md-divider> <div layout-gt-xs=row> <md-input-container class=md-block flex-gt-sm> <label>Select curriculum</label> <md-select ng-model=curriculumCtrl.sessionToEdit.curriculum multiple=true> <md-option ng-click=curriculumCtrl.getcurriculum(curriculum.name) ng-repeat=\"curriculum in curriculumCtrl.curriculumPackage[0].list\" value={{curriculum._id}}> {{curriculum.name}} </md-option> </md-select> <span ng-if=\"curriculumCtrl.errors['editCurriculum']\" class=reedAlert>{{curriculumCtrl.errors['editCurriculum']}}</span> </md-input-container> </div> </div> </div> </div> </div> </div> </div> <div layout=row layout-wrap layout-xs=column ng-if=\"!curriculumCtrl.editMode && curriculumCtrl.enableNextBtn\"> <div class=\"md-whiteframe-3dp border_none\" layout=row flex=100 flex-gt-sm=40 id=rcorners_new> <div flex> <div style=margin-top:10px> <md-card-title> <h4>List of Session</h4> <md-divider></md-divider> </md-card-title> </div> <div layout=column style=min-height:100px flex as-sortable=curriculumCtrl.sortableCloneOptions2 ng-model=curriculumCtrl.sessionPackage.list> <md-card id=rcorners7 style=height:50px!important class=top_mar_20 flex ng-repeat=\"sessionName in curriculumCtrl.sessionPackage.list| filter : Search\" as-sortable-item> <div flex as-sortable-item-handle> {{sessionName.name}} <i style=float:right class=\"hand fas fa-arrows-alt fa-lg\"></i> </div> </md-card> </div> </div> </div> <div class=\"md-whiteframe-3dp border_none\" layout=row id=rcorners_new flex=100 flex-gt-sm=60 layout-sm=column> <div flex> <div style=margin-top:10px> <md-card-title> <h4>Selected Session</h4> <md-divider></md-divider> </md-card-title> </div> <div layout=row layout-align=\"end end\"> <md-button ng-show=\"curriculumCtrl.selectedSessions.length > 0\" class=\"md-raised md-primary addBtn\" ng-click=curriculumCtrl.saveSession()>Save</md-button> </div> <div style=min-height:100px flex as-sortable=curriculumCtrl.sortableCloneOptions1 ng-model=curriculumCtrl.selectedSessions> <div ng-repeat=\"curPkg in curriculumCtrl.selectedSessions\" as-sortable-item ng-init=getTime(curPkg)> <div as-sortable-item-handle id=rcorners11> <div layout-gt-xs=column layout-padding> <div layout-gt-xs=row class=drbTitle style=position:relative> {{curPkg.name}} <span style=position:absolute;right:11px;bottom:15px> <i ng-click=curriculumCtrl.deleteSession(curPkg) class=\"fas fa-arrows-alt fa-lg\"></i> </span> </div> <md-divider></md-divider> <div layout-gt-xs=row class=timePicker1> <label for=exampleInput class=no-margins>Start Time</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <md-input-container> <label>Hour</label> <md-select ng-model=curPkg.hh> <md-option ng-repeat=\"h in curriculumCtrl.hours\" ng-value=h> {{h}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Minutes</label> <md-select ng-model=curPkg.mm> <md-option ng-repeat=\"m in curriculumCtrl.minutes\" ng-value=m> {{m}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Meridian</label> <md-select ng-model=curPkg.mer> <md-option value=AM> AM </md-option> <md-option value=PM> PM </md-option> </md-select> </md-input-container> </div> <span ng-if=curriculumCtrl.errors.create[$index].start_time class=reedAlert>{{curriculumCtrl.errors.create[$index].start_time}}</span> <md-divider></md-divider> <div layout-gt-xs=row class=timePicker1> <label for=exampleInput class=no-margins>End Time</label> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <md-input-container> <label>Hour</label> <md-select ng-model=curPkg.hhEnd> <md-option ng-repeat=\"h in curriculumCtrl.hours\" ng-value=h> {{h}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Minutes</label> <md-select ng-model=curPkg.mmEnd> <md-option ng-repeat=\"m in curriculumCtrl.minutes\" ng-value=m> {{m}} </md-option> </md-select> </md-input-container> <md-input-container> <label>Meridian</label> <md-select ng-model=curPkg.merEnd> <md-option value=AM> AM </md-option> <md-option value=PM> PM </md-option> </md-select> </md-input-container> </div> <span ng-if=curriculumCtrl.errors.create[$index].end_time class=reedAlert>{{curriculumCtrl.errors.create[$index].end_time}}</span> <md-divider></md-divider> <div layout-gt-xs=row> <md-input-container class=md-block flex-gt-sm> <label>Select curriculum</label> <md-select ng-model=curPkg.curriculum multiple=true> <md-option ng-click=curriculumCtrl.getcurriculum(curriculum.name) ng-repeat=\"curriculum in curriculumCtrl.curriculumPackage[0].list\" value={{curriculum._id}}> {{curriculum.name}} </md-option> </md-select> <span ng-if=curriculumCtrl.errors.create[$index].curriculum class=reedAlert>{{curriculumCtrl.errors.create[$index].curriculum}}</span> </md-input-container> </div> </div> </div> </div> </div> </div> </div> </div> <md-content class=md-padding> <div flex=100 layout=row layout-xs=column layout-align-xs=space-between layout-wrap> <div class=\"ng-scope md-whiteframe-3dp border_none top_mar_20\" flex=100 flex-xs=100 ng-repeat=\"session in curriculumCtrl.sessionsDetails\"> <div class=\"md-hue-3 mgmtLightBoxHead border_none layout-row flex\" layout=row flex=\"\"> <p flex=85 flex-sm=100 flex-xs=100 class=\"md-body-1 mar_left_15 ng-binding flex boxTitle\" flex-offset=5>{{session.name}}</p> <div layout=row flex=15 flex-sm=100 flex-xs=100> <i ng-click=curriculumCtrl.editMe(session) class=\"pad_10 hand far fa-edit\"></i> <i ng-click=curriculumCtrl.removeSession(session._id) class=\"pad_10 hand far fa-trash-alt\"></i> </div> </div> <div class=\"mgmtLightBox layout-column border_top_none\" layout=row layout-sm=column layout-padding flex> <div layout=column flex> <div layout=row layout-align=\"center center\" flex layout-wrap> <div flex=45>Start Time : {{session.start_time| date:'hh:mm a'}}</div> <div flex=45>End Time : {{session.end_time| date:'hh:mm a'}}</div> <div flex=10></div> </div> <div layout=row class=\"\"> <div ng-repeat=\"curriculumData in session.curriculum\" class=curri_type> <span class=\"box hand\">{{curriculumData.name}}</span> </div> </div> </div> </div> </div> </div> <div ng-if=\"curriculumCtrl.sessionsLength >= 1\"> <md-button class=\"md-raised md-primary md-hue-2 top_mar_20 mar_left_nill\" ng-click=\"curriculumCtrl.goNext( )\">{{btnLabel}} </md-button> </div> </md-content> </div> </div>";

/***/ }),
/* 145 */
/***/ (function(module, exports) {

module.exports = " <div class=\"margin_20 md-whiteframe-3dp\" layout-margin nomargin> <md-content md-theme=makeMeWhite layout=column style=background-color:#fff layout-margin layout-padding ng-cloak> <div layout-padding></div> <div layout=row layout-padding ng-cloak flex> <md-input-container class=iptCnter flex-gt-sm=33 style=margin-bottom:0> <label>Enter Name</label> <input ng-model=curriculumSetupController.curriculum.name class=loadFocus autofocus=\"autofocus=true\" required> <error-msg class=redAlert msg=curriculumSetupController.errors.name></error-msg> </md-input-container> <span> <md-button class=\"md-raised md-primary\" ng-click=curriculumSetupController.saveCurriculum(curriculumSetupController.curriculum)>{{ curriculumSetupController.isEdit?\"Update\": \"Save\" }} </md-button> <md-button class=md-raised ng-show=curriculumSetupController.isEdit ng-click=curriculumSetupController.reset()>Cancel</md-button> </span> </div> <div layout-padding layout-wrap ng-cloak layout=row layout-align=\"start start\"> <div class=ng-scope flex=45 flex-xs=100 ng-repeat=\"curriculum in curriculums.list\"> <div class=\"md-makeMeWhite-theme layout-row flex md-whiteframe-3dp\" layout=row flex=\"\" style=max-height:50px> <p class=\"md-body-1 ng-binding flex-offset-5 flex curri\" flex=\"\" flex-offset=5>{{curriculum.name.toUpperCase()}}</p> <md-menu md-position-mode=\"target-right target\"> <md-button aria-label=\"Open phone interactions menu\" class=md-icon-button ng-click=\"curriculumSetupController.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-ellipsis-v\"></i> </md-button> <md-menu-content width=1> <md-menu-item> <md-button ng-click=curriculumSetupController.editCurriculum(curriculum)> <i class=\"fas fa-edit\"></i> Edit </md-button> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item> <md-button ng-click=\"curriculumSetupController.removeCurriculum(curriculum._id, curriculum.name)\"> <i class=\"fas fa-trash-alt\"></i> Delete </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> </md-content> </div>";

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = " <div layout-margin> <md-content md-theme=makeMeWhite class=\"md-whiteframe-1dp md-primary noPadding\" layout-margin layout=column ng-cloak style=margin:20px;background-color:#fff> <div layout-padding layout-wrap ng-cloak layout=row layout-align=\"start start\"> <div class=ng-scope flex=50 flex-xs=100 ng-repeat=\"package in subjectSettingsCtrl.packages\"> <md-toolbar class=\"md-hue-3 mgmtLightBoxHead md-makeMeWhite-theme layout-row flex\" layout=row flex=\"\"> <p class=\"pheading ng-binding flex-offset-5 flex pack_name\" flex=\"\" flex-offset=5>{{package.name}}</p> <md-menu md-position-mode=\"target-right target\"> <md-button aria-label=\"Open phone interactions \" class=md-icon-button ng-click=\"subjectSettingsCtrl.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-ellipsis-v\"></i> </md-button> <md-menu-content width=1> <md-menu-item> <md-button ng-click=subjectSettingsCtrl.editSubjectPackage(package._id)>Edit</md-button> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item> <md-button ng-click=subjectSettingsCtrl.removeSubPackage(package)>Delete</md-button> </md-menu-item> </md-menu-content> </md-menu> </md-toolbar> <div class=\"mgmtLightBox layout-column\" layout-padding layout=row layout-sm=column layout-wrap> <div class=box ng-repeat=\"subject in package.list\">{{subject.name}}</div> </div> </div> </div> </md-content> </div>";

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = " <div layout-margin> <md-content md-theme=makeMeWhite class=\"md-whiteframe-1dp md-primary noPadding\" layout=column style=margin:20px;background-color:#fff layout-margin layout-padding ng-cloak> <div layout-padding></div> <div class=md-whiteframe-2dp layout-padding layout=row ng-cloak flex layout-wrap style=\"margin:0 26px\"> <div flex-gt-xs=25> <md-input-container class=md-block flex-gt-xs> <label>Enter Session Name</label> <input ng-model=sessionSettingsCtrl.session.name> <error-msg class=redAlert msg=sessionSettingsCtrl.errors.name></error-msg> </md-input-container> </div> <div flex-gt-xs=25> <md-input-container class=md-block flex-gt-sm> <input mdc-datetime-picker=\"\" date=false time=true type=text max-date=dateTimeEnd placeholder=\"Select start time\" ng-model=sessionSettingsCtrl.session.start_time class=md-input format=\"hh:mm a\" id=input_0> <error-msg class=redAlert msg=sessionSettingsCtrl.errors.start_time></error-msg> </md-input-container> </div> <div flex-gt-xs=25> <md-input-container class=md-block flex-gt-sm> <input mdc-datetime-picker=\"\" date=false time=true type=text min-date=\"sessionSettingsCtrl.session.start_time===dateTimeEnd\" placeholder=\"Select end time\" ng-model=sessionSettingsCtrl.session.end_time format=\"hh:mm a\" class=md-input id=input_0> <error-msg class=redAlert msg=sessionSettingsCtrl.errors.end_time></error-msg> </md-input-container> </div> <div flex-gt-xs=20> <md-button class=\"md-raised md-primary\" ng-click=sessionSettingsCtrl.saveSession(sessionSettingsCtrl.session)>{{ sessionSettingsCtrl.isEdit?\"Update\": \"Save\" }}</md-button> <md-button class=\"md-raised md-primary\" ng-show=sessionSettingsCtrl.isEdit ng-click=sessionSettingsCtrl.reset()>Cancel</md-button> </div> </div> <div layout-padding layout-wrap ng-cloak layout=row layout-align=\"space-between start\"> <div class=ng-scope flex=50 flex-xs=100 ng-if=\"sessionData.end_time!=undefined\" ng-repeat=\"sessionData in session.list\" style=margin-bottom:20px> <md-toolbar style=height:50px class=\"md-hue-3 mgmtLightBoxHead md-makeMeWhite-theme layout-row flex\" layout=row flex=\"\"> <p class=\"pheading ng-binding flex-offset-5 flex sess_name\" flex=\"\" flex-offset=5>{{sessionData.name}}</p> <md-menu md-position-mode=\"target-right target\"> <md-button aria-label=\"Open phone interactions menu\" class=md-icon-button ng-click=\"sessionSettingsCtrl.openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-ellipsis-v\"></i> </md-button> <md-menu-content width=1> <md-menu-item> <md-button ng-click=sessionSettingsCtrl.editSession(sessionData)>Edit</md-button> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item> <md-button ng-click=sessionSettingsCtrl.removeSession(sessionData._id)>Delete</md-button> </md-menu-item> </md-menu-content> </md-menu> </md-toolbar> <div class=\"mgmtLightBox layout-column\" layout-padding layout=row layout-sm=column layout-wrap> <div>Start Time: {{sessionData.start_time | date:'hh:mm a'}}</div> <div>End Time: {{sessionData.end_time | date:'hh:mm a'}}</div> </div> </div> </div> </md-content> </div>";

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <style>.fixedrow{width:100%;text-align:left}.bodyheight{overflow:auto;height:280px}</style> <common-filter></common-filter> <div layout=column layout-xs=column class=\"margin_20 md-whiteframe-3dp\" ng-cloak> <div layout-padding class=md-whiteframe-3dp> <md-backdrop style=position:fixed!important;z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div ng-if=\"Users.length>0\" layout=column style=height:362px;overflow:scroll> <table ng-if=\"userFilter.role_id != 'student' && !isparent \" class=\"table table-bordered\"> <thead> <tr class=fixedrow> <th>SL No</th> <th>Employee No</th> <th>Name</th> <th>Email</th> <th>Phone No</th> </tr> </thead> <tbody class=bodyheight> <tr ng-if=\"userFilter.role_id != 'student' && !isparent \" ng-repeat=\"record in Users\"> <td ng-init=\"record.index=$index+1\"> <label>{{$index+1}}</label></td> <td> <input type=text name=name class=form-control ng-model=record.employee_no /> <span style=color:red;font-weight:700>{{record.employee_no_error}}</span> </td> <td> <input type=text name=city class=form-control ng-model=record.name /> <span style=color:red;font-weight:700>{{record.name_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.username /> <span style=color:red;font-weight:700>{{record.username_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.phone /> <span style=color:red;font-weight:700>{{record.phone_error}}</span> </td> </tr> </tbody> </table> <table ng-if=\"userFilter.role_id != 'student' && isparent \" class=\"table table-bordered\"> <thead> <tr class=fixedrow> <th>SL No</th> <th>Name</th> <th>Email</th> <th>Phone No</th> </tr> </thead> <tbody class=bodyheight> <tr ng-if=\"userFilter.role_id != 'student' \" ng-repeat=\"record in Users\"> <td ng-init=\"record.index=$index+1\"> <label>{{$index+1}}</label></td> <td> <input type=text name=city class=form-control ng-model=record.name /> <span style=color:red;font-weight:700>{{record.name_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.username /> <span style=color:red;font-weight:700>{{record.username_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.phone /> <span style=color:red;font-weight:700>{{record.phone_error}}</span> </td> </tr> </tbody> </table> <table ng-if=\"userFilter.role_id === 'student' && !isparent\" class=\"table table-bordered\"> <thead> <tr class=fixedrow> <th>SL No</th> <th>Academic </th> <th>Admission No</th> <th>Name</th> <th>Email</th> <th>Parent Phone No</th> <th>Parent Email</th> <th>parent name</th> <th>Mother Email</th> <th>Mother name</th> <th>Mother phone</th> <th>Status</th> <th>Mapped </th> </tr> </thead> <tbody class=bodyheight> <tr ng-if=\"userFilter.role_id === 'student' \" ng-repeat=\"record in Users\"> <td ng-init=\"record.index=$index+1\"> <label>{{$index+1}}</label></td> <td> <span style=color:red;font-weight:700>{{record.academicDetails}}</span> </td> <td> <input type=text name=name class=form-control ng-model=record.admission_number /> <span style=color:red;font-weight:700>{{record.employee_no_error}}</span> </td> <td> <input type=text name=city class=form-control ng-model=record.name /> <span style=color:red;font-weight:700>{{record.name_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.username /> <span style=color:red;font-weight:700>{{record.username_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.phone /> <span style=color:red;font-weight:700>{{record.phone_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.parent_email /> <span style=color:red;font-weight:700>{{record.parent_email_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.parent_name /> <span style=color:red;font-weight:700>{{record.parentname_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.mother_obj.mother_email /> <span style=color:red;font-weight:700>{{record.mother_obj.email_error}}</span> </td> <td> <input type=text name=state class=form-control ng-model=record.mother_obj.mother_name /> <span style=color:red;font-weight:700>{{record.mother_obj.name_error}}</span> </td> <td> <input decimal-numbers-only type=text name=state class=form-control ng-model=record.mother_obj.mother_mobile /> <span style=color:red;font-weight:700>{{record.mother_obj.phone_error}}</span> </td> <td> <span style=color:red;font-weight:700>{{record.mapped}}</span> </td> <td> <span style=color:red;font-weight:700>{{record.mappedStudent}}</span> </td> </tr> </tbody> </table> </div> </div> </div> <footer ng-if=\"Users.length>0\" class=footer> <div layout=row flex layout-align=\"space-around center\" class=theme-color> <div flex layout=row layout-align=\"space-around center\"> <div layout=row layout-align=\"start center\"> <md-button class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" aria-label=Add ng-click=\"updateUsers('Create')\"> Update <i class=\"far fa-save fa-lg footer_icon_allign\"></i> </md-button> <md-button class=\"md-whiteframe-3dp md-raised bottom_ctrl-btn md-button md-ink-ripple\" aria-label=Add ng-click=\"exportAsCSV('Create')\"> Download csv <i class=\"far fa-file-alt fa-lg footer_icon_allign\"></i> </md-button> </div> </div> </div> </footer> ";

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _commonFilter = __webpack_require__(919);

var _commonFilter2 = _interopRequireDefault(_commonFilter);

__webpack_require__(922);

var _commonFilterController = __webpack_require__(923);

var _commonFilterController2 = _interopRequireDefault(_commonFilterController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var name = 'commonFilter';
var _module = angular.module("app.commonFilter", []).directive(name, function () {
    return {
        restrict: 'E',
        template: _commonFilter2.default,
        bindToController: {
            stateId: '='
        },
        scope: true,
        controllerAs: "multipleBatchFilterCtrl",
        controller: ['$state', '$rootScope', '$scope', '$mdDialog', '$stateParams', 'localStorageService', 'authService', 'filterCons', 'CONSTANTS', 'CommonFilterRoleService', function ($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, filterCons, CONSTANTS, CommonFilterRoleService) {

            var userId = localStorageService.get('user_id');

            var self = this;
            var vm = this;
            vm.limit = 50;
            vm.Items = 60;
            vm.pager = {};
            vm.setPage = setPage;
            vm.pageIndex = [];

            function GetPager(totalItems, currentPage, pageSize) {
                // default to first page
                currentPage = currentPage || 1;
                pageSize = pageSize || vm.limit;
                var totalPages = Math.ceil(totalItems / pageSize);
                var startPage, endPage;
                if (totalPages <= 10) {
                    startPage = 1;
                    endPage = totalPages;
                } else {
                    if (currentPage <= 6) {
                        startPage = 1;
                        endPage = 10;
                    } else if (currentPage + 4 >= totalPages) {
                        startPage = totalPages - 9;
                        endPage = totalPages;
                    } else {
                        startPage = currentPage - 5;
                        endPage = currentPage + 4;
                    }
                }

                var startIndex = (currentPage - 1) * pageSize;
                var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
                var pages = _.range(startPage, endPage + 1);
                return {
                    totalItems: totalItems,
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalPages: totalPages,
                    startPage: startPage,
                    endPage: endPage,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    pages: pages
                };
            }

            function initController() {
                $scope.announcementForAll = self.checkAnnouncementReceivers;
                if (self.checkAnnouncementReceivers) {
                    console.log('SEND TO ALL');
                    self.getAllUsersForAnnouncement();
                    $scope.showFilteredUsers = false;
                } else {
                    vm.setPage(1);
                }
            }

            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = GetPager(vm.Items, page);
                console.log(vm.pager);
                $scope.showFilteredUsers = true;
                if (vm.pageIndex.indexOf(page) === -1) {

                    if (page === 1) self.getUsersLists(0, vm.limit, page);else self.getUsersLists(vm.pager.startIndex, vm.limit, page);
                } else {
                    findValueBasedOnIndex(page);
                }
            }

            $scope.filteredEndorsedUsers = [];
            $scope.selectedFilterData = "Select..";
            $scope.userNamesNotEndorsed = [];
            $scope.showAcademicFilters = true;
            $scope.isBatch = false;
            $scope.isClass = false;
            self.checkAllClass = false;
            $scope.showSavedSearch = false;
            $scope.saveSearchData = false;
            $scope.showbatch = true;
            $scope.isSearched = false;
            self.showMultiBatch = [];
            self.showChart = [];
            $scope.filterObj = {};
            $scope.buttonName = 'Add';
            $scope.open = false;
            $scope.announcementForAll = false;

            function saveFilterDataToStorage() {
                try {
                    if ($scope.stateId && $scope.filterObj) {
                        var _storageKey = "searched item";
                        var filterData = {
                            role: $scope.filterObj.role || '',
                            role_id: $scope.filterObj.role_id || '',
                            session: $scope.filterObj.session || '',
                            curriculum: $scope.filterObj.curriculum || '',
                            xclass: $scope.filterObj.xclass || [],
                            singlefieldclass: $scope.filterObj.singlefieldclass || '',
                            batch: $scope.filterObj.batch || [],
                            subject: $scope.filterObj.subject || [],
                            chart: $scope.filterObj.chart || '',
                            multirole: $scope.filterObj.multirole || '',
                            selectedFilterTitle: $scope.selectedFilterData || 'SELECT.'
                        };
                        localStorageService.set(_storageKey, filterData);
                    }
                } catch (error) {
                    console.error('Error saving filter data to localStorage:', error);
                }
            }

            $scope.saveFilterDataToStorage = saveFilterDataToStorage;

            function isFilterMatchingSavedSearch() {
                if (!self.selectedSavedSerach) {
                    return false;
                }

                var savedSearch = self.selectedSavedSerach;
                var currentFilter = $scope.filterObj;

                var roleMatches = savedSearch.role === currentFilter.role_id;
                var sessionMatches = savedSearch.session === currentFilter.session;
                var curriculumMatches = savedSearch.curriculum === currentFilter.curriculum;
                var classMatches = _.isEqual(_.sortBy(savedSearch.class || []), _.sortBy(currentFilter.xclass || []));
                var batchMatches = _.isEqual(_.sortBy(savedSearch.batch || []), _.sortBy(currentFilter.batch || []));
                var subjectMatches = _.isEqual(_.sortBy(savedSearch.subject || []), _.sortBy(currentFilter.subject || []));

                return roleMatches && sessionMatches && curriculumMatches && classMatches && batchMatches && subjectMatches;
            }

            var everywhere = angular.element(window.document);
            everywhere.bind('click', function (event) {

                try {
                    var isButtonClick = event.target.className === "btn-filter btn-primary dropdown-toggle ng-binding";
                    if (isButtonClick === false) {
                        $scope.open = false;
                        _.defer(function () {
                            $scope.$apply();
                        });;
                    }
                } catch (ex) {}
            });

            //self.subscribe('getAllFilter', () => [$scope.stateId, localStorageService.get('school_id')])

            function findValueBasedOnIndex(page) {

                $scope.userNamesNotEndorsed = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                    return user.page === page;
                });
                self.userNotEndorsedAcademic = _.uniq(_.pluck($scope.userNamesNotEndorsed, 'academic_details'));
            }

            function clearUsersListResults() {
                self.userNotEndorsedAcademic = [];
                $scope.userNamesNotEndorsed = [];
                $scope.filteredNotEndorsedUsers = [];
                vm.pager = {};
                vm.setPage = setPage;
                vm.pageIndex = [];
                self.allItemsSelected = [];
            }

            function clearFields() {
                self.showMultiSubject = [];
                $scope.filterObj['batch'] = [];
                $scope.filterObj['subject'] = [];
                $scope.isSubject = false;
                self.checkAll = false;
                self.checkAllSubject = false;
                vm.pager = {};
                vm.setPage = setPage;
                clearUsersListResults();
                vm.pageIndex = [];
                self.allItemsSelected = [];
            }

            var storageKey = "searched item";
            var savedFilterData = localStorageService.get(storageKey);
            if (!savedFilterData) {
                clearFields();
            }

            $scope.chartTypes = [{
                name: 'Pie',
                type: 'pie'
            }, {
                name: 'Bar',
                type: 'Bar'
            }, {
                name: 'Doughnut',
                type: 'Doughnut'
            }];

            function featureBaseFilter() {
                console.log("***********************");
                console.log($scope.stateId);
                switch ($scope.stateId) {
                    case 'userManagement':
                        hideUserManagementFilterFields();
                        break;
                    case 'reportGradeDetailsConsole':
                        hideReportGradeDetailsConsoleFields();
                        break;
                    case 'announcementsUsers':
                        $scope.buttonName = 'Proceed';
                        $scope.announcementForAll = true;
                        hideClubFilterFields();
                        break;
                    case 'club':
                        $scope.buttonName = 'Add';
                        hideClubFilterFields();
                        break;
                    case 'manageReportCards':
                        $scope.buttonName = 'Add';
                        hidefilterInManageReports();
                        break;
                    case 'viewDetails':
                        $scope.buttonName = 'Proceed';
                        forSecurityAppConsole();
                        break;
                    case 'transferStudent':
                        $scope.buttonName = 'Search';
                        roleasStudentOnly();
                        break;
                    case 'edituser':
                        $scope.buttonName = 'Search';
                        forEditinguser();
                        break;
                    case 'removeUser':
                        forRemoveUser();
                        break;
                    case 'userProfile':
                        $scope.buttonName = 'Search';
                        hideMedicalFilterFields();
                        break;
                    case 'createProgramme':
                        $scope.buttonName = 'Search';
                        hideMedicalFilterFields();
                        break;

                }
            }

            featureBaseFilter();

            function forRemoveUser() {
                $scope.visibleRole = true;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = false;
            }

            function forEditinguser() {
                $scope.visibleRole = true;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = false;
                $scope.showFilteredUsers = false;
            }

            function hidefilterInManageReports() {
                $scope.visibleRole = false;
                $scope.showAcademicFilters = true;
                $scope.showbatch = false;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = false;
                $scope.showFilteredUsers = false;
            }

            function hideClubFilterFields() {
                $scope.visibleRole = true;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = false;
                $scope.blnsearchValuesBasedOnFilterOnComponent = true;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = false;
            }

            function hideUserManagementFilterFields() {
                $scope.visibleRole = true;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = true;
            }

            function roleasStudentOnly() {
                $scope.visibleRole = false;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = false;

                $scope.filterObj['role'] = 'student';
                $scope.filterObj['role_id'] = 'student';
            }

            function forSecurityAppConsole() {
                $scope.visibleRole = false;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = false;
                $scope.blnsearchValuesBasedOnFilterOnComponent = true;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = true;

                $scope.filterObj['role'] = 'student';
                $scope.filterObj['role_id'] = 'student';
            }
            function hideMedicalFilterFields() {
                $scope.visibleRole = true;
                $scope.showAcademicFilters = true;
                $scope.showbatch = true;
                $scope.showSubject = false;
                $scope.showChart = false;
                $scope.showMultiRole = false;
                $scope.showDate = false;
                $scope.blnsearchValuesBasedOnFilter = true;
                $scope.blnsearchValuesBasedOnFilterOnComponent = false;
                $scope.showSavedSearchField = true;
                $scope.showFilteredUsers = false;
            }

            var subsModules = undefined,
                subsAcademicSet = undefined,
                subsAcademicPack = undefined,
                academicDetail = undefined;

            /*
             * To get user's assigned module's features
             *
             * @Developer : Jeevanantham N
             */
            var parentId = '';
            var principalId = '';
            var vicePrincipalId = '';
            var senEducatorId = '';
            var senCoordinatorId = '';
            var senCounselorId = '';
            var getUserModules = function getUserModules() {
                authService.callAPI(filterCons.API_GET_MODULE_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, function (response) {
                    if (response.result && response.result.data && response.result.data.module_features) {
                        try {
                            moduleDetails = response.result.data.module_features;
                            var _principalId = '';
                            var _vicePrincipalId = '';
                            var _senEducatorId = '';
                            var _senCoordinatorId = '';
                            var _senCounselorId = '';
                            if (moduleDetails != undefined && moduleDetails.feature_role && $scope.isClub) {

                                _.each(moduleDetails.feature_role, function (each) {
                                    if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                                        parentId = each.role_id;
                                    } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                                        _principalId = each.role_id;
                                    } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                                        _vicePrincipalId = each.role_id;
                                    } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                                        _senEducatorId = each.role_id;
                                    } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                                        _senCoordinatorId = each.role_id;
                                    } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                                        _senCounselorId = each.role_id;
                                    }
                                });
                            }
                            _.defer(function () {
                                $scope.$apply();
                            });
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                });
            };

            /*
             * To get school based academic deatils
             *
             * @Developer : Jeevanantham N
             */
            var getAcademicPck = function getAcademicPck() {
                authService.callAPI(filterCons.API_GET_SCHOOL_ACADEMICS + localStorageService.get('school_id'), "GET", {}, function (response) {
                    console.log(response);
                    if (response.result && response.result.data && response.result.data.academic_det) {
                        //$scope.hodPersonArr = response.result.data.departments

                        self.sessions = [];
                        academicDetail = response.result.data.academic_det;

                        if (academicDetail === undefined || academicDetail.length <= 0) return false;

                        if (self.allSessions && academicDetail) {
                            _.each(academicDetail, function (doc) {
                                var thisSessionDetails = _.find(self.allSessions.list, function (eachSession) {
                                    return eachSession._id == doc.session_id;
                                });
                                if (thisSessionDetails && !_.find(self.sessions, function (sess) {
                                    return sess._id == thisSessionDetails._id;
                                })) {
                                    self.sessions.push({
                                        _id: thisSessionDetails._id,
                                        name: thisSessionDetails.name
                                    });
                                }
                            });
                        }

                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
            };

            /*
             * To get school based settings
             *
             * @Developer : Jeevanantham N
             */
            var getAcademicSettings = function getAcademicSettings() {
                authService.callAPI(filterCons.API_GET_SCHOOL_SETTINGS + localStorageService.get('school_id'), "GET", {}, function (response) {
                    try {
                        console.log(response);
                        if (response.result && response.result.data) {
                            self.rolePackage = response.result.data.role_det ? response.result.data.role_det : [];

                            self.allSessions = response.result.data.session_det ? response.result.data.session_det : [];

                            self.allCurriculum = response.result.data.curriculum_det ? response.result.data.curriculum_det : [];

                            self.allClassess = response.result.data.class_det ? response.result.data.class_det : [];

                            self.allBatchess = response.result.data.batch_det ? response.result.data.batch_det : [];

                            self.allSubjectsList = response.result.data.subject_det ? response.result.data.subject_det : [];

                            if (self.allSessions && academicDetail) {
                                _.each(academicDetail, function (doc) {
                                    var thisSessionDetails = _.find(self.allSessions.list, function (eachSession) {
                                        return eachSession._id == doc.session_id;
                                    });
                                    if (thisSessionDetails && !_.find(self.sessions, function (sess) {
                                        return sess._id == thisSessionDetails._id;
                                    })) {
                                        self.sessions.push({
                                            _id: thisSessionDetails._id,
                                            name: thisSessionDetails.name
                                        });
                                    }
                                });
                            }

                            self.allRoles = [];

                            if ($scope.isClub) {
                                if (self.rolePackage) {
                                    _.each(self.rolePackage.list, function (role) {
                                        if (role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true) {
                                            self.allRoles.push(role);
                                        }
                                    });
                                }
                            } else if (self.rolePackage) {
                                console.log(self.rolePackage.list, "_____________________________________________________________________________");
                                console.log($scope.stateId, "$scope.stateId$scope.stateId");

                                if ($scope.stateId === 'userManagement') {

                                    self.allRoles = _.filter(self.rolePackage.list, function (role) {
                                        return role.status === true && (role._id === 'role12123rqwer' || role._id === 'student');
                                    });
                                } else {

                                    self.allRoles = _.filter(self.rolePackage.list, function (role) {
                                        return role._id != CONSTANTS.ADMIN_ID && role.status === true;
                                    });
                                }
                                // self.allRoles = _.filter(self.rolePackage.list, function(role) {
                                //     return role._id != CONSTANTS.ADMIN_ID && role.status === true
                                // })
                                console.log(self.allRoles, "self.allRolesself.allRolesself.allRolesself.allRoles");

                                // if($scope.stateId == "userManagement"){
                                //     let roleNames = ["Student", "Teacher"]
                                //     let roleArrayOfuserManagement = []
                                //     _.each(roleNames, function(oneRoleName){
                                //         let ex = _.find(self.allRoles, function(oneRole){
                                //             return oneRole.name == oneRoleName
                                //         })
                                //         if(ex){
                                //             roleArrayOfuserManagement.push(ex)
                                //         }
                                //     })
                                //     if(roleArrayOfuserManagement.length){
                                //         self.allRoles = roleArrayOfuserManagement
                                //     }
                                // }
                            } else {
                                return false;
                            }

                            getSubJectPack();

                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            };

            /*
             * To get saved search details
             *
             * @Developer : Jeevanantham N
             */
            var getSavedSearch = function getSavedSearch() {
                authService.callAPI(filterCons.API_GET_SAVED_SEARCH + localStorageService.get('school_id') + "/" + $scope.stateId, "GET", {}, function (response) {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.search_det) {
                        //$scope.hodPersonArr = response.result.data.departments

                        $scope.savedSearchData = response.result.data.search_det;

                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
            };

            /*
             * To get user's academic details
             *
             * @Developer : Jeevanantham N
             */
            var userPrsnData = function userPrsnData(user_id) {
                authService.callAPI(filterCons.API_GET_PERSON_ACDEMICS + localStorageService.get('school_id') + "/" + userId, "GET", {}, function (response) {

                    if (response.result && response.result.data && response.result.data.person_data) {
                        $scope.persnData = response.result.data.person_data;

                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
            };

            var initSubs = function initSubs() {
                //subsModules = self.subscribe('getModulesFeaturesForFilter', () => [localStorageService.get('school_id')])
                //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [localStorageService.get('school_id')])
                //subsAcademicSet = self.subscribe('getAllAcademicSettings', () => [localStorageService.get('school_id')])
            };

            this.$onInit = function () {
                //initSubs()
                getUserModules();
                getAcademicSettings();
                getAcademicPck();
                getSavedSearch();
                userPrsnData();
                // Set loading to true before starting the async operation
                $scope.loading = true;

                var loadSavedFilterData = function loadSavedFilterData() {
                    try {
                        var _storageKey2 = "searched item";
                        var _savedFilterData = localStorageService.get(_storageKey2);
                        if (_savedFilterData && _savedFilterData.role_id) {
                            console.log('Found saved filter data in localStorage:', _savedFilterData);

                            if ($scope.savedSearchData && $scope.savedSearchData.length > 0) {
                                var matchingSavedSearch = _.find($scope.savedSearchData, function (savedSearch) {
                                    return savedSearch.role === _savedFilterData.role_id && savedSearch.session === _savedFilterData.session && savedSearch.curriculum === _savedFilterData.curriculum && _.isEqual(savedSearch.class, _savedFilterData.xclass || []) && _.isEqual(savedSearch.batch, _savedFilterData.batch || []) && _.isEqual(savedSearch.subject, _savedFilterData.subject || []);
                                });

                                if (matchingSavedSearch) {
                                    console.log('Found matching saved search:', matchingSavedSearch);
                                    $scope.selectedFilterData = matchingSavedSearch.title;
                                    $scope.getSavedData(matchingSavedSearch);
                                } else {
                                    var mockSavedSearch = {
                                        title: 'SELECT..',
                                        role: _savedFilterData.role_id,
                                        session: _savedFilterData.session,
                                        curriculum: _savedFilterData.curriculum,
                                        class: _savedFilterData.xclass || [],
                                        batch: _savedFilterData.batch || [],
                                        subject: _savedFilterData.subject || [],
                                        chart_type: _savedFilterData.chart || '',
                                        multirole: _savedFilterData.multirole || '',
                                        check_all_class: false,
                                        check_all_batch: false,
                                        check_all_subject: false
                                    };

                                    $scope.selectedFilterData = mockSavedSearch.title;
                                    $scope.getSavedData(mockSavedSearch);
                                }
                            } else {
                                var _mockSavedSearch = {
                                    title: 'SELECT..',
                                    role: _savedFilterData.role_id,
                                    session: _savedFilterData.session,
                                    curriculum: _savedFilterData.curriculum,
                                    class: _savedFilterData.xclass || [],
                                    batch: _savedFilterData.batch || [],
                                    subject: _savedFilterData.subject || [],
                                    chart_type: _savedFilterData.chart || '',
                                    multirole: _savedFilterData.multirole || '',
                                    check_all_class: false,
                                    check_all_batch: false,
                                    check_all_subject: false
                                };

                                $scope.selectedFilterData = _mockSavedSearch.title;
                                $scope.getSavedData(_mockSavedSearch);
                            }
                        }
                        // Stop loading after data is processed and fields are populated
                        $scope.loading = false;
                        _.defer(function () {
                            $scope.$apply();
                        });
                    } catch (error) {
                        console.error('Error loading saved filter data from localStorage:', error);
                        // Stop loading even if there's an error
                        $scope.loading = false;
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                };
                setTimeout(loadSavedFilterData, 1500);
            };

            this.$onDestroy = function () {
                if (subsModules) subsModules.stop();
                if (subsAcademicSet) subsAcademicSet.stop();
                if (subsAcademicPack) subsAcademicPack.stop();
            };

            /* self.autorun(() => {
            let moduleDetails = Modules_features_new.findOne({
                state: "roleSetting",
                school_id: localStorageService.get('school_id')
            })
            let parentId = ''
            let principalId = ''
            let vicePrincipalId = ''
            let senEducatorId = ''
            let senCoordinatorId = ''
            let senCounselorId = ''
            if (moduleDetails != undefined && $scope.isClub) {
                console.log("moduleDetails.feature_role")
                console.log(moduleDetails.feature_role)
                _.each(moduleDetails.feature_role, function(each) {
                    if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                        parentId = each.role_id
                    } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                        principalId = each.role_id
                    } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                        vicePrincipalId = each.role_id
                    } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                        senEducatorId = each.role_id
                    } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                        senCoordinatorId = each.role_id
                    } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                        senCounselorId = each.role_id
                    }
                })
            }
            self.rolePackage = Settings.findOne({
                school_id: localStorageService.get('school_id'),
                type: "role"
            })
             self.allSessions = Settings.find({
                school_id: localStorageService.get('school_id'),
                type: "session"
            }).fetch();
             self.allCurriculum = Settings.find({
                school_id: localStorageService.get('school_id'),
                type: "curriculum"
            }).fetch();
             self.allClassess = Settings.find({
                school_id: localStorageService.get('school_id'),
                type: "class"
            }).fetch();
             self.allBatchess = Settings.find({
                school_id: localStorageService.get('school_id'),
                type: "batch"
            }).fetch();
             self.allSubjectsList = Settings.find({
                school_id: localStorageService.get('school_id'),
                type: "subject"
            }).fetch();
            self.allRoles = [];
            if ($scope.isClub) {
                console.log("self.rolePackage.list")
                console.log(self.rolePackage.list)
                if (self.rolePackage) {
                    _.each(self.rolePackage.list, function(role) {
                        if ((role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true)) {
                            self.allRoles.push(role)
                        }
                    })
                }
            } else if (self.rolePackage) {
                self.allRoles = _.filter(self.rolePackage.list, function(role) {
                    return role._id != CONSTANTS.ADMIN_ID && role.status === true
                })
            } else {
                return false;
            }
            getSubJectPack()
            self.sessions = []
            let academicDetail = AcademicConsole.find({
                school_id: localStorageService.get('school_id')
            }).fetch();
             if (academicDetail === undefined || academicDetail.length <= 0)
                return false;
            _.each(academicDetail, function(doc) {
                let thisSessionDetails = _.find(self.allSessions.list, function(eachSession) {
                    return eachSession._id == doc.session_id
                })
                if (thisSessionDetails && !_.find(self.sessions, function(sess) {
                        return sess._id == thisSessionDetails._id
                    })) {
                    self.sessions.push({
                        _id: thisSessionDetails._id,
                        name: thisSessionDetails.name
                    })
                }
            })
            $scope.savedSearchData = SavedSearches.find({
                school_id: localStorageService.get('school_id'),
                state: $scope.stateId
            }).fetch()
            }) */

            function getSubJectPack() {
                self.allSubjects = _.flatten(_.pluck(self.allSubjectsList, 'list'));
            }

            self.getRoleDetails = function (id) {
                if (self.selectedSavedSerach != undefined) {
                    if (self.selectedSavedSerach.role != id) {
                        $scope.selectedFilterData = "Select.. ";
                    };
                };

                try {
                    $scope.multiRoles = _.filter(self.rolePackage.list, function (role) {
                        return role._id != SuperAdminTYPE && role._id != AdminTYPE && role._id != id && role.status === true;
                    });
                } catch (ex) {}
            };

            function clearFilterResult() {
                if ($scope.stateId) {

                    $scope.clearParentFields();
                }
            }

            $scope.setFilterObj = function (data, key) {
                console.log(data);
                console.log(key);
                console.log($scope.filterObj);
                $scope.open = false;
                clearFilterResult();
                if (key == 'Role') {
                    $scope.filterObj['role'] = data;
                    clearComponentField();
                } else if (key == 'Session') {
                    $scope.filterObj['session'] = data;
                } else if (key == 'Curiculum') {
                    $scope.filterObj['curriculum'] = data;
                } else if (key == 'role_id') {
                    clearComponentField();
                    $scope.filterObj['role_id'] = data;
                    CommonFilterRoleService.setSelectedRole(data);
                } else if (key == 'Chart') {
                    $scope.filterObj['chart'] = data;
                } else if (key == 'Multi') {
                    $scope.filterObj['multirole'] = data;
                }
                if (!isFilterMatchingSavedSearch()) {
                    $scope.selectedFilterData = "Select..";
                    self.selectedSavedSerach = undefined;
                }
            };

            function clearComponentField() {
                $scope.filteredEndorsedUsers = [];
                self.userEndorsedAcademic = [];
                self.userNotEndorsedAcademic = [];
                $scope.userNamesNotEndorsed = [];
                $scope.filteredNotEndorsedUsers = [];
                vm.pager = {};
                vm.setPage = setPage;
                vm.pageIndex = [];
                self.allItemsSelected = [];
            }

            $scope.removeFilter = function () {
                $scope.filterObj = {};
                $scope.filteredExamDetails = [];
                try {
                    if ($scope.stateId) {
                        var _storageKey3 = "searched item";
                        localStorageService.remove(_storageKey3);
                    }
                } catch (error) {
                    console.error('Error clearing filter data from localStorage:', error);
                }
            };

            $scope.setSessionFilters = function (item) {
                var items = item.split(",");
            };

            $scope.deleteSearch = function (item) {
                $scope.open = false;

                /* Meteor.call('deleteSearchDetails', item._id, localStorageService.get('school_id'), function(err, res) {
                    if (err) {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                    } else {
                        getSavedSearch()
                        $scope.selectedFilterData = "Select.. "
                        toastr.success('Deleted Successfully')
                    }
                }) */

                var obj = {
                    'search_id': item._id,
                    'school_id': localStorageService.get('school_id')

                    /*
                     * To removed filter data
                     *
                     * @Developer : Jeevanantham N
                     */
                };authService.callAPI(filterCons.API_POST_REMOVE_SERACH, "POST", obj, function (response) {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.info) {
                        $scope.selectedFilterData = "Select.. ";
                        getSavedSearch();
                        toastr.success('Deleted Successfully');
                    } else {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
                    }
                });
            };
            function _breakReference(data) {
                try {
                    var keys = Object.keys(data);
                    var obj = {};
                    for (var k = 0; k < keys.length; k++) {
                        obj[keys[k]] = data[keys[k]];
                    }
                    return obj;
                } catch (e) {
                    console.log(e);
                }
            }
            self.getBatch = function (bid) {

                //console.log("wwwwwwwwww")
                $scope.open = false;
                clearUsersListResults();
                $scope.batchId = bid;
                $scope.isBatch = true;
                $scope.isSubject = false;
                $scope.filterObj['batch'] = [];
                $scope.filterObj['subject'] = [];
                var flag = false;
                for (var i = 0; i < $scope.filterObj['xclass'].length; i++) {
                    if ($scope.filterObj['xclass'][i] === bid) {
                        flag = true;
                    }
                }
                self.showMultiSubject = [];
                self.checkAll = false;
                self.checkAllSubject = false;

                /* self.showThisBatch = AcademicConsole.findOne({
                    session_id: $scope.selectCuriculum,
                    curriculum_id: $scope.selectClass
                }, {
                    xclass: 1
                }) */

                self.showThisBatch = _.find(academicDetail, function (lst) {
                    return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
                });

                var classDet = _.find(self.showThisBatch.xclass, function (batch) {
                    return batch._id === bid;
                });

                if ($scope.isTeacher && userId && self.allClassess) {

                    /* let personDetails = Person.findOne({
                        user_id: Meteor.userId(),
                        "status": "active"
                    }) */

                    var personDetails = $scope.persnData;

                    if (personDetails && personDetails.details) {

                        var batchData = _.where(personDetails.details, {
                            session_id: $scope.filterObj['session'],
                            curriculum_id: $scope.filterObj['curriculum'],
                            class_id: bid
                        });

                        batchData = _.uniq(_.flatten(_.pluck(batchData, "batch_id")));

                        self.showBatchName = _.filter(self.allBatches.list, function (data) {
                            return batchData.indexOf(data._id) !== -1;
                        });
                    }
                } else {

                    if (flag) {
                        for (var j = 0; j < classDet.batches.length; j++) {
                            for (var jj = 0; jj < self.showBatchName.length; jj++) {
                                if (self.showBatchName[jj]._id === classDet.batches[j]) {
                                    self.showBatchName.splice(jj, 1);
                                    break;
                                }
                            }
                        }
                    } else {
                        self.showBatchName = [];
                        for (var index = 0; index < classDet.batches.length; index++) {
                            try {
                                (function () {
                                    var bId = classDet.batches[index];
                                    var ex = _.find(self.allBatchess.list, function (one) {
                                        return one._id == bId;
                                    });
                                    if (ex) {
                                        self.showBatchName.push(_breakReference(ex));
                                    }
                                })();
                            } catch (error) {
                                console.log(error);
                            }
                        }
                        if (!self.showBatchName.length) {
                            _.each(self.allBatchess.list, function (v) {
                                _.each(classDet.batches, function (k) {
                                    if (v._id === k) {
                                        var item = {
                                            _id: v._id,
                                            name: v.name
                                        };
                                        self.showBatchName.push(item);
                                    }
                                });
                            });
                        }
                    }
                }
                self.showMultiBatch = _.uniq(self.showBatchName, false, function (p) {
                    return p._id;
                });
                if (self.showMultiBatch.length <= 0) {
                    $scope.isBatch = false;
                }
            };

            self.getClass = function (sid) {
                clearFilterResult();
                $scope.open = false;

                if (self.selectedSavedSerach != undefined) {
                    if (self.selectedSavedSerach.curriculum != sid) {
                        $scope.selectedFilterData = "Select.. ";
                        self.selectedSavedSerach = undefined;
                    };
                };
                var cid = $scope.selectCuriculum;
                $scope.selectClass = sid;
                var addedClass = [];
                self.showClassName = [];
                $scope.isBatch = false;
                $scope.filterObj['xclass'] = [];
                $scope.filterObj['singlefieldclass'] = undefined;
                clearFields();
                /* self.showThisClass = AcademicConsole.find({
                    session_id: cid,
                    curriculum_id: sid
                }).fetch(); */

                self.showThisClass = _.filter(academicDetail, function (lst) {
                    return lst.session_id == cid && lst.curriculum_id == sid;
                });

                //console.log(self.showThisClass)
                //console.log(cid)
                //console.log(sid)

                if (self.showThisClass != undefined && self.showThisClass.length > 0) {
                    _.each(self.showThisClass[0].xclass, function (classes) {
                        addedClass.push(classes._id);
                    });
                }
                addedClass = _.uniq(addedClass);

                //console.log(addedClass)

                if ($scope.isTeacher && userId && self.allClassess) {
                    /* let personDetails = Person.findOne({
                        user_id: Meteor.userId(),
                        "status": "active"
                    }) */

                    var personDetails = $scope.persnData;

                    //console.log("===11111===")
                    //console.log(personDetails)

                    if (personDetails && personDetails.details) {
                        var classData = _.where(personDetails.details, {
                            session_id: $scope.filterObj['session'],
                            curriculum_id: sid
                        });

                        classData = _.uniq(_.flatten(_.pluck(classData, "class_id")));

                        self.showClassName = _.filter(self.allClassess.list, function (data) {
                            return classData.indexOf(data._id) !== -1;
                        });
                        //
                    }
                } else {
                    //console.log("===2222===")
                    //console.log(self.allClassess)
                    if (self.allClassess != undefined) {
                        _.each(self.allClassess.list, function (v) {
                            _.each(addedClass, function (k) {
                                if (v._id === k) {
                                    var item = {
                                        _id: v._id,
                                        name: v.name
                                    };
                                    self.showClassName.push(item);
                                }
                            });
                        });
                    }
                }

                //console.log(self.showClassName)

                if (self.showClassName && self.showClassName.length > 0) {
                    $scope.isClass = true;
                }

                self.classArr = _.pluck(self.showClassName, "_id");
            };

            self.getCuriculum = function (cid) {
                $scope.open = false;
                if (self.selectedSavedSerach != undefined) {
                    if (self.selectedSavedSerach.session != cid) {
                        $scope.selectedFilterData = "Select.. ";
                    };
                };

                $scope.selectCuriculum = cid;
                self.showCurriculumName = [];
                var addedCuricullumID = [];
                $scope.filterObj['curriculum'] = undefined;
                $scope.filterObj['xclass'] = [];
                $scope.filterObj['singlefieldclass'] = undefined;
                clearFields();
                self.showMultiBatch = [];
                self.checkAllClass = false;
                self.showClassName = [];
                self.showBatchName = [];
                $scope.isBatch = false;
                $scope.isClass = false;

                /* self.showThisSessions = AcademicConsole.find({
                    session_id: cid
                }).fetch(); */

                self.showThisSessions = _.filter(academicDetail, function (lst) {
                    return lst.session_id == cid;
                });

                _.each(self.showThisSessions, function (v) {
                    addedCuricullumID.push(v.curriculum_id);
                });
                addedCuricullumID = _.uniq(addedCuricullumID);
                self.showCurriculumName = [];

                if ($scope.isTeacher && userId && self.allCurriculum) {
                    /* let personDetails = Person.findOne({
                        user_id: Meteor.userId(),
                        "status": "active"
                    }) */

                    var personDetails = $scope.persnData;

                    if (personDetails && personDetails.details) {
                        var currData = _.where(personDetails.details, {
                            session_id: cid
                        });

                        currData = _.uniq(_.flatten(_.pluck(currData, "curriculum_id")));

                        self.showCurriculumName = _.filter(self.allCurriculum.list, function (data) {
                            return currData.indexOf(data._id) !== -1;
                        });
                    }
                } else {

                    _.each(self.allCurriculum.list, function (v) {
                        _.each(addedCuricullumID, function (k) {
                            if (v._id === k) {
                                var item = {
                                    _id: v._id,
                                    name: v.name
                                };
                                self.showCurriculumName.push(item);
                            }
                        });
                    });
                }
            };

            self.getSubject = function () {
                $scope.open = false;
                self.checkAllSubject = false;
                getAllSubject();
            };

            function getAllSubject() {
                $scope.open = false;
                $scope.isSubject = true;
                $scope.filterObj['subject'] = [];
                self.showMultiSubject = [];
                /* self.showThisSubject = AcademicConsole.findOne({
                    session_id: $scope.selectCuriculum,
                    curriculum_id: $scope.selectClass
                }, {
                    subject_package: 1
                }) */

                self.showThisSubject = _.find(academicDetail, function (lst) {
                    return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
                });

                var allSubject = _.flatten(_.pluck(self.showThisSubject.subject_package, 'subjects'));
                _.each(self.allSubjects, function (v) {
                    _.each(allSubject, function (k) {
                        if (v._id === k) {
                            var item = {
                                _id: v._id,
                                name: v.name
                            };
                            self.showMultiSubject.push(item);
                        }
                    });
                });

                if (self.showMultiSubject.length <= 0) {
                    $scope.isSubject = false;
                } else {
                    self.checkAllSubject = false;
                }
            }

            $scope.selectBatches = function (opt) {
                $scope.open = false;
                clearUsersListResults();
                clearFilterResult();
                if (opt == "all") {
                    if (self.checkAll) {
                        $scope.filterObj['batch'] = _.union($scope.filterObj['batch'], _.pluck(self.showMultiBatch, "_id"));
                        getAllSubject();
                    } else {
                        $scope.filterObj['batch'] = [];
                        self.showMultiSubject = [];
                        $scope.isSubject = false;
                    }
                } else {
                    if ($scope.filterObj['batch'].length == _.pluck(self.showMultiBatch, "_id").length) {
                        self.checkAll = true;
                    } else {
                        self.checkAll = false;
                        if ($scope.filterObj['batch'].length === 0) {
                            self.showMultiSubject = [];
                            $scope.isSubject = false;
                        }
                    }
                }
                // Mismatch detection: if saved search is selected and batch array differs, reset filter name
                // if (self.selectedSavedSerach != undefined) {
                //     if (!_.isEqual(self.selectedSavedSerach.batch || [], $scope.filterObj['batch'])) {
                //         $scope.selectedFilterData = "Select.. ";
                //     }
                // }
                // if (self.selectedSavedSerach != undefined) {
                //   if (self.selectedSavedSerach.batch.length != $scope.filterObj['batch'].length) {
                //         self.selectedSavedSerach.batch=$scope.filterObj['batch']
                //         self.selectedSavedSerach.title=""
                //         $scope.saved_search = undefined
                //         $scope.savedSearchData.push(self.selectedSavedSerach)
                //         $scope.getSavedData(self.selectedSavedSerach)
                //         $scope.savedSearchData = _.filter( $scope.savedSearchData, function(data) {
                //         return data.title  !=""
                //         })
                //     };
                // };

                // Save filter data to localStorage when batches are selected
                if (!isFilterMatchingSavedSearch()) {
                    $scope.selectedFilterData = "Select..";
                    self.selectedSavedSerach = undefined;
                }
                // saveFilterDataToStorage();
            };

            $scope.selectClasses = function (opt) {
                $scope.open = false;
                clearFilterResult();
                if (opt == "all") {
                    if (self.checkAllClass) {
                        $scope.filterObj['xclass'] = _.union($scope.filterObj['xclass'], self.classArr);
                        filterBatchBasedOnClass(self.classArr);
                        clearFields();
                    } else {
                        $scope.filterObj['xclass'] = [];
                        clearFields();
                        self.showMultiBatch = [];
                        $scope.isBatch = false;
                        self.showBatchName = [];
                    }
                } else {
                    if ($scope.stateId === 'userManagement') {
                        $scope.filterObj['xclass'] = [];
                        $scope.filterObj['xclass'].push($scope.filterObj['singlefieldclass']);
                    }
                    if ($scope.filterObj['xclass'].length == self.classArr.length) {
                        self.checkAllClass = true;
                    } else {
                        self.checkAllClass = false;
                    }
                }
                //  if (self.selectedSavedSerach != undefined) {
                //   if (self.selectedSavedSerach.class.length != self.classArr.length) {
                //         self.selectedSavedSerach.class=self.classArr
                //         self.selectedSavedSerach.title=""
                //         $scope.saved_search = undefined
                //         $scope.savedSearchData.push(self.selectedSavedSerach)
                //         $scope.getSavedData(self.selectedSavedSerach)
                //         $scope.savedSearchData = _.filter( $scope.savedSearchData, function(data) {
                //         return data.title  !=""
                //         })
                //     };
                // };

                // Save filter data to localStorage when classes are selected
                // saveFilterDataToStorage();
                if (!isFilterMatchingSavedSearch()) {
                    $scope.selectedFilterData = "Select..";
                    self.selectedSavedSerach = undefined;
                }
            };

            $scope.selectAnnouncementReceivers = function (opt) {
                console.log(opt);
            };

            $scope.selectSubject = function (opt) {
                $scope.open = false;
                clearUsersListResults();
                clearFilterResult();
                if (opt == "all") {
                    if (self.checkAllSubject) {
                        $scope.filterObj['subject'] = _.union($scope.filterObj['subject'], _.pluck(self.showMultiSubject, "_id"));
                    } else {
                        $scope.filterObj['subject'] = [];
                    }
                } else {
                    if ($scope.filterObj['subject'].length == self.showMultiSubject.length) {
                        self.checkAllSubject = true;
                    } else {
                        self.checkAllSubject = false;
                    }
                }
                if (!isFilterMatchingSavedSearch()) {
                    $scope.selectedFilterData = "Select..";
                    self.selectedSavedSerach = undefined;
                }
                // Save filter data to localStorage when subjects are selected
                saveFilterDataToStorage();
            };

            function filterBatchBasedOnClass(totalClass) {
                $scope.isBatch = true;
                /* self.showThisBatch = AcademicConsole.findOne({
                    session_id: $scope.selectCuriculum,
                    curriculum_id: $scope.selectClass
                }, {
                    xclass: 1
                }) */

                self.showThisBatch = _.find(academicDetail, function (lst) {
                    return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
                });

                self.showBatchName = [];
                for (var i = totalClass.length - 1; i >= 0; i--) {
                    var classDet = _.find(self.showThisBatch.xclass, function (batch) {
                        return batch._id === totalClass[i];
                    });

                    _.each(self.allBatchess.list, function (v) {
                        _.each(classDet.batches, function (k) {
                            if (v._id === k) {
                                var item = {
                                    _id: v._id,
                                    name: v.name
                                };
                                self.showBatchName.push(item);
                            }
                        });
                    });
                }
                self.showMultiBatch = _.uniq(self.showBatchName, false, function (p) {
                    return p._id;
                });
                if (self.showMultiBatch.length <= 0) {
                    $scope.isBatch = false;
                }
            }

            self.searchValuesBasedOnFilterOnComponent = function () {

                $scope.open = false;
                self.userFilter = {};
                self.userFilter.roleId = $scope.filterObj.role_id;
                self.userFilter.sessionId = $scope.filterObj.session;
                self.userFilter.curriculumId = $scope.filterObj.curriculum;
                self.userFilter.classId = $scope.filterObj.xclass;
                self.userFilter.batchId = $scope.filterObj.batch;
                $scope.isSearched = true;

                if ($scope.filterObj === undefined || $scope.filterObj.role_id === undefined) {
                    toastr.error('Please Select the Role');
                    return false;
                } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.session === undefined)) {
                    toastr.error('Please Select the Session');
                    return false;
                } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.curriculum === undefined)) {
                    toastr.error('Please Select the Curriculum');
                    return false;
                } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.xclass === undefined || $scope.filterObj.xclass.length <= 0)) {
                    toastr.error('Please Select the Class');
                    return false;
                } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.batch === undefined || $scope.filterObj.batch.length <= 0)) {
                    toastr.error('Please Select the Batch');
                    return false;
                }
                setFilterValue($scope.filterObj);
            };

            function setFilterValue(userAcademicDetails) {

                self.userMgt = {};
                self.userMgt.roleId = userAcademicDetails.role_id;
                self.userMgt.sessionId = userAcademicDetails.session;
                self.userMgt.curriculumId = userAcademicDetails.curriculum;
                self.userMgt.classId = userAcademicDetails.xclass;
                self.userMgt.batchId = userAcademicDetails.batch;
                // self.getUsersLists(0, limit);
                initController();
                saveFilterDataToStorage();
            }

            //Added for sending announcement to all users without listing list
            self.getAllUsersForAnnouncement = function () {
                $scope.loading = true;

                var req = vm.userMgt;
                req["school_id"] = localStorageService.get('school_id');
                req.user_id = localStorageService.get('user_id');

                /*
                 * To get all users against selected role
                 *
                 * @Developer : Jeevanantham N
                 */
                authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, function (response) {
                    if (response.result && response.result.data && response.result.data.users) {
                        if (response.result.data.users === undefined || response.result.data.users.length === 0) toastr.error("No results found");else if (response.result.data.users && response.result.data.users.length != 0) {
                            var _$scope$filteredNotEn;

                            //console.log('**************')
                            // $scope.filteredNotEndorsedUsers = res.users
                            (_$scope$filteredNotEn = $scope.filteredNotEndorsedUsers).push.apply(_$scope$filteredNotEn, _toConsumableArray(response.result.data.users));
                            //console.log($scope.filteredNotEndorsedUsers)
                            //console.log('**************')
                            // Save filter data to localStorage when ProcessValue is called
                            saveFilterDataToStorage();
                            $scope.ProcessValue();
                        }

                        $scope.loading = false;
                        _.defer(function () {
                            $scope.$apply();
                        });
                    } else {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
                    }
                });

                /* Meteor.call('getAllUserDetails', vm.userMgt, localStorageService.get('school_id'), null, null, function (err, res) {
                if (err) {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                } else {
                    if ((res.users === undefined || res.users.length === 0))
                        toastr.error("No results found");
                    else if ((res.users && res.users.length != 0)) {
                        console.log('**************')
                        // $scope.filteredNotEndorsedUsers = res.users
                        $scope.filteredNotEndorsedUsers.push(...res.users);
                        console.log($scope.filteredNotEndorsedUsers)
                        console.log('**************')
                        $scope.ProcessValue()
                    }
                     $scope.loading = false;
                    _.defer(function () {
                        $scope.$apply();
                    });;
                }
                }) */
            };

            self.getUsersLists = function (skip, limit, page) {
                $scope.open = false;
                self.showList = true;
                // self.allItemsSelected = []
                $scope.loading = true;

                var req = vm.userMgt;
                req["school_id"] = localStorageService.get('school_id');
                req.user_id = localStorageService.get('user_id');
                req["skip"] = skip;
                req["limit"] = limit;

                /*
                 * To get all users against selected role
                 *
                 * @Developer : Jeevanantham N
                 */
                authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, function (response) {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.users) {
                        if (response.result.data.users === undefined || response.result.data.users.length === 0) {
                            $scope.loading = false;
                            toastr.error("No results found");
                        } else if (response.result.data.users && response.result.data.users.length != 0) {
                            vm.Items = response.result.data.totallength;
                            vm.pager = GetPager(vm.Items, page);
                            vm.pageIndex.push(page);
                            bindData(response.result.data, page);
                        }

                        var userList = [];
                        if ($scope.isClub && $scope.userNames) {
                            var availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                            _.each($scope.filteredNotEndorsedUsers, function (each, index) {
                                if (availableMembers.indexOf(each._id) != -1) {
                                    each.isExists = true;
                                }
                            });

                            $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers;
                            $scope.userNamesNotEndorsed.sort(function (a, b) {
                                var textA = a.name.toUpperCase();
                                var textB = b.name.toUpperCase();
                                return textA < textB ? -1 : textA > textB ? 1 : 0;
                            });
                        }

                        $scope.loading = false;
                        $scope.UniqueNoText = "Employee No";

                        if ($scope.userNamesNotEndorsed.length && $scope.userNamesNotEndorsed[0].role == "student") {
                            $scope.UniqueNoText = "Admission No";
                        }

                        _.defer(function () {
                            $scope.$apply();
                        });
                    } else {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
                    }
                });

                /* Meteor.call('getAllUserDetails', vm.userMgt, localStorageService.get('school_id'), skip, limit, function(err, res) {
                if (err) {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.', 'error-toast')
                } else {
                    if ((res.users === undefined || res.users.length === 0))
                        toastr.error("No results found");
                    else if ((res.users && res.users.length != 0)) {
                        vm.Items = res.totallength;
                        vm.pager = GetPager(vm.Items, page);
                        vm.pageIndex.push(page);
                        bindData(res, page)
                    }
                    let userList = []
                    if ($scope.isClub && $scope.userNames) {
                        let availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                        _.each($scope.filteredNotEndorsedUsers, function(each, index) {
                            if (availableMembers.indexOf(each._id) != -1) {
                                each.isExists = true
                            }
                        })
                         $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers
                        $scope.userNamesNotEndorsed.sort(function(a, b) {
                            var textA = a.name.toUpperCase();
                            var textB = b.name.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                    }
                     $scope.loading = false;
                    if ($scope.userNamesNotEndorsed[0].role == "student") {
                        $scope.UniqueNoText = "Admission No";
                    } else {
                         $scope.UniqueNoText = "Employee No";
                    }
                    _.defer(function() {
                        $scope.$apply();
                    });;
                }
                }) */
            };

            function bindData(res, page) {
                var _$scope$filteredNotEn2;

                _.each(res.users, function (user) {
                    user.page = page;
                });
                $scope.userNamesNotEndorsed = res.users;
                $scope.userNamesNotEndorsed.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                (_$scope$filteredNotEn2 = $scope.filteredNotEndorsedUsers).push.apply(_$scope$filteredNotEn2, _toConsumableArray(res.users));
                $scope.filteredNotEndorsedUsers.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                self.userNotEndorsedAcademic = _.uniq(_.pluck(res.users, 'academic_details'));
                self.userNotEndorsedAcademic.sort(function (a, b) {
                    if (a.name && b.name) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    }
                });
            }

            self.selectAllNotEndorsed = function (selected, index, acade) {
                $scope.open = false;
                if (acade != undefined) {
                    var cnt = 0;
                    _.each($scope.filteredNotEndorsedUsers, function (user) {
                        if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                            cnt = cnt + 1;
                            user.isChecked = selected;
                        }
                    });
                    var userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                        return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage;
                    });

                    if (cnt === userTo.length) {
                        self.allItemsSelected[vm.pager.currentPage][index] = true;
                    } else {
                        self.allItemsSelected[vm.pager.currentPage][index] = false;
                    }
                } else {
                    _.each($scope.filteredNotEndorsedUsers, function (user) {
                        if (user.page == vm.pager.currentPage) user.isChecked = selected;
                    });
                }
                $scope.filteredNotEndorsedUsers.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            };

            self.getClickedNotEndorsedUser = function (person, index, acade) {
                $scope.open = false;
                if (acade != undefined) {
                    var cnt = 0;
                    _.each($scope.filteredNotEndorsedUsers, function (user) {
                        if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                            cnt = cnt + 1;
                        }
                    });

                    var userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                        return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage;
                    });

                    if (cnt === userTo.length) {
                        self.allItemsSelected[vm.pager.currentPage][index] = true;
                    } else {
                        self.allItemsSelected[vm.pager.currentPage][index] = false;
                    }
                } else {
                    var _userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                        return user.isChecked === true && user.page == vm.pager.currentPage;
                    });
                    if ($scope.filteredNotEndorsedUsers.length === _userTo.length) {
                        self.allItemsSelected[vm.pager.currentPage] = true;
                    } else {
                        self.allItemsSelected[vm.pager.currentPage] = false;
                    }
                }
                $scope.filteredNotEndorsedUsers.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            };

            $scope.saveSearchFilter = function () {
                $scope.open = false;

                var filterItem = {
                    'school_id': localStorageService.get('school_id'),
                    'title': self.saveName,
                    'state': $scope.stateId,
                    'role': $scope.filterObj.role_id,
                    'session': $scope.filterObj.session,
                    'curriculum': $scope.filterObj.curriculum,
                    'class': $scope.filterObj.xclass,
                    'batch': $scope.filterObj.batch,
                    'subject': $scope.filterObj.subject,
                    'check_all_batch': self.checkAll,
                    'check_all_class': self.checkAllClass,
                    'check_all_subject': self.checkAllSubject,
                    'chart_type': $scope.filterObj.chart,
                    'multirole': $scope.filterObj.multirole
                };

                if ($scope.filterObj.role_id === undefined && $scope.filterObj.session === undefined) {
                    toastr.error("Please select atleast one field");
                    return false;
                }

                if (!self.saveName) {
                    toastr.error("Please enter title");
                    return false;
                }

                /*
                 * To add filter data
                 *
                 * @Developer : Jeevanantham N
                 */
                authService.callAPI(filterCons.API_POST_ADD_SERACH, "POST", filterItem, function (response) {
                    //console.log(response)
                    if (response.result && response.result.data && response.result.data.info) {
                        self.saveName = undefined;
                        getSavedSearch();
                        toastr.success("Successfully saved");
                    } else {
                        $scope.loading = false;
                        toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
                    }
                });

                /* Meteor.call("saveSearch", filterItem, function(error, result) {
                    if (error) { // if it fails, show error message
                        toastr.error(error.reason);
                        return;
                    } else {
                        self.saveName = undefined;
                        _.defer(function() {
                            $scope.$apply();
                        });;
                        getSavedSearch()
                        toastr.success("Successfully saved");
                    }
                }); */
            };

            $scope.openDropdown = function (data) {

                if (data) {
                    $scope.open = !$scope.open;
                }
            };

            $scope.getSavedData = function (savedDet) {
                $scope.open = false;
                $scope.selectedFilterData = savedDet.title;
                // $scope.openDropdown("open");
                self.selectedSavedSerach = savedDet;
                clearComponentField();
                self.getCuriculum(savedDet.session);
                self.getClass(savedDet.curriculum);
                $scope.filterObj['role'] = savedDet.role;
                $scope.filterObj['session'] = savedDet.session;
                $scope.filterObj['curriculum'] = savedDet.curriculum;
                $scope.selectCuriculum = savedDet.session;

                if (savedDet.check_all_class) {
                    $scope.selectClasses('all');
                }

                if (savedDet.class != undefined) {
                    if ($scope.stateId === 'userManagement') {
                        self.getBatch(savedDet.class[0]);
                        $scope.filterObj['xclass'] = [];
                        $scope.filterObj['xclass'].push(savedDet.class);
                        $scope.filterObj['singlefieldclass'] = savedDet.class[0];
                    } else {
                        for (var i = savedDet.class.length - 1; i >= 0; i--) {
                            self.getBatch(savedDet.class[i]);
                        }
                    }
                }

                if (savedDet.check_all_batch) {
                    self.checkAll = true;
                    $scope.selectBatches('all');
                }
                $scope.filterObj['xclass'] = savedDet.class;
                $scope.filterObj['batch'] = savedDet.batch;
                $scope.filterObj['subject'] = savedDet.subject;
                $scope.filterObj['role_id'] = savedDet.role;
                self.checkAllClass = savedDet.check_all_class;
                self.checkAllSubject = savedDet.check_all_subject;
                $scope.filterObj['chart'] = savedDet.chart_type;
                $scope.filterObj['multirole'] = savedDet.multirole;
                $scope.selectCuriculum = savedDet.session;

                try {
                    if ($scope.stateId === 'userManagement') {

                        $scope.searchValuesBasedOnFilter();
                    }
                } catch (ex) {}

                // Save the selected savedDet to localStorage when option is clicked
                saveFilterDataToStorage();
            };

            $scope.unsetValue = function () {
                $scope.saved_search = null;
            };
        }]

    };
});

/* component(name, {
    template: commonFilterTpl,
    controllerAs: name,
    bindings: {
        stateId: '<',
        searchValuesBasedOnFilter: '&searchfilter'
    },
    scope: {
        searchValuesBasedOnFilter: '&searchfilter'
    },
    controller: commonFilterCtrl
}); */

_module.constant("filterCons", {
    API_GET_SCHOOL_SETTINGS: "/v0/endorsement/school/settings/",
    API_GET_SCHOOL_ACADEMICS: "/v0/endorsement/school/academics/",
    API_GET_SAVED_SEARCH: "/v0/endorsement/saved_searches/",
    API_GET_MODULE_FEATURE: "/v0/endorsement/module_features/",
    API_GET_PERSON_ACDEMICS: "/v0/endorsement/person_academics/",
    API_POST_ENDORSED_USERS: "/v0/endorsement/users_list",
    API_GET_SUBJECT_PACK_LIST: "/v0/endorsement/get_sub_pack_details",
    API_GET_SCHOOL_SUBJECT_PACK_LIST: "/v0/endorsement/get_school_sub_pack_details/",
    API_GET_TEACHER_MAIN_SUBJ: "/v0/endorsement/get_main_teacher_lst/",
    API_POST_GET_ALL_USERS: "/v0/endorsement/get_all_users",
    API_POST_ADD_SERACH: "/v0/endorsement/add_save_search",
    API_POST_REMOVE_SERACH: "/v0/endorsement/remove_save_search",
    API_POST_STUDENT_SUB_LIST: "/v0/endorsement/get_stu_subjects",
    API_POST_UPDATE_STU_ENDORSEMENT: "/v0/endorsement/update_endorsement",
    API_POST_DELETE_STU_ENDORSEMENT: "/v0/endorsement/delete_endorsement",
    API_POST_BULK_DELETE_STU_ENDORSEMENT: "/v0/endorsement/delete_bulk_endorsement",
    STUDENTROLEID: "student"
});

_module.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('commonFilter', {
        parent: 'app',
        url: '/commonFilter',
        views: {
            '@': {
                template: _commonFilter2.default,
                controller: _commonFilterController2.default,
                controllerAs: 'multipleBatchFilterCtrl'
            }
        }
    });
}]);

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=\"fadeInUp animated fast delay-25ms md-whiteframe-3dp container\" layout-margin flex ng-cloak ng-repeat=\"data in classCurriculumDetails |  orderBy :'curriculumSession'\" style=margin-top:24px!important> <h2 class=\"h2color text-style-only\">{{data.curriculumSession}}</h2> <div ng-repeat=\"details in data.curriculumSessionValue\"> <h4 class=\"h2color noMargin\">{{details.classBatch}}</h4> <div class=tile layout=row flex layout-wrap layout-align=\"start center\"> <div layout=row layout-align=\"start start\" class=\"md-whiteframe-3dp divimg\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"subject in details.classBatchValue\" ng-style=\"{'background-color':subject.color}\"> <div flex=100 layout=row layout-align=\"start center\" class=subjectdiv ng-click=routeToMainPage(subject)> <div class=\"flex-90 h3color hvr-bounce-in\"> {{subject.subject.name}} </div> <div ng-if=\"subject.bookmarkItems.length>0\" layout=column> <md-menu layout flex=none> <div aria-label=Menu class=md-icon-button ng-click=$mdOpenMenu($event)> <i class=\"hvr-push far fa-star icnDiv hvr-bounce-in\"></i> </div> <md-menu-content class=menuData> <md-menu-item style=padding:10px;cursor:pointer ng-repeat=\"bookmark in subject.bookmarkItems\" ng-click=gotoBookmark(bookmark,$event)><span>{{bookmark.title}}</span></md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> </div> </div> </div> <div layout=column class=\"fadeInUp animated fast delay-15ms\" layout-margin flex ng-cloak ng-if=\"!loading && classCurriculumDetails.length === 0\" layout-align=\"center center\" style=min-height:400px> <p style=text-align:center;font-size:16px;color:rgba(0,0,0,.54)> Not any subjects endorsed to the teacher </p> </div>";

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div style=\"margin:20px 10px 0\" layout=row layout-align=end> <md-button class=\"md-primary addToQues action-btn-clr\" ng-if=\"isTpCreate && !classroomDetails\" ng-click=addGoogleClassroom($event)>Add Google Classroom</md-button> <md-button class=\"md-primary addToQues action-btn-clr\" ng-if=classroomDetails ng-click=viewGoogleClassroom()>View Google Classroom</md-button> </div> <div class=overview> <div class=\"main-div md-whiteframe-2dp\"> <div class=\"overview-content md-margin md-padding\" ng-show=!isThemeAvailable> {{errorMsg}} </div> <div ng-show=isThemeAvailable style=background:#4aadf7;height:49px;padding:15px;font-size:19px;width:220px>Themes / Chapters</div> <div layout=column ng-show=\"isSyllabusAvail && isThemeAvailable\"> <div class=head> <h4 class=\"overview-head md-margin md-padding\">Subject Description</h4> </div> <div class=\"overview-content md-margin md-padding\"> {{subject_description}} </div> </div> <div layout=column ng-show=isThemeAvailable ng-repeat=\"theme in themes\" flex> <div layout=row flex class=\"overview-head md-margin md-padding\"> <div flex>{{theme.name}}</div> <div flex=5 ng-show=isTpCreate ng-click=\"createPlan(theme._id, theme.name,concetp.title)\"> <img src=" + __webpack_require__(171) + " tooltip=\"create plan\"> </div> </div> </div> </div> </div>";

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=overview> <div class=\"main-div md-whiteframe-2dp\"> <div layout=column ng-if=userAccess.overviewReport&&userAccess.overviewReport.create> <div class=head> <h4 class=\"overview-head md-margin md-padding\">Today's Attendance</h4> </div> <div class=\"overview-content md-margin md-padding\"> <div ng-show=!isAttendanceTaken> <h6 style=font-size:16px;align:center>No attendance marked for today. </h6></div> <div layout=row flex layout-align=\"space-between center\" ng-show=isAttendanceTaken> <div flex=30 layout=row> <div flex=80 class=caption>Total Students - {{attendance.total_count}}</div> </div> <div flex=30 layout=row> <div flex=80 class=present>Present - {{attendance.present_count}}</div> </div> <div flex=30 layout=row> <div flex=80 class=absent>Absent - {{attendance.absent_count}}</div> </div> </div> </div> </div> <div layout=column ng-if=userAccess.overviewReport&&userAccess.overviewReport.read> <div class=\"overview-head md-margin md-padding\">{{themeName}}</div> <div class=\"overview-content md-margin md-padding\" ng-show=\"planList.length === 0\">No Teaching Plans</div> <div class=\"overview-content md-margin\" ng-hide=\"planList.length === 0\"> <div layout=row class=all-head> <div class=\"md-margin table-head\" flex=30>Plan Name</div> <div ng-show=userAccess.overviewReport.create class=\"md-margin table-head\" flex=15>Start Date</div> <div ng-show=userAccess.overviewReport.create class=\"md-margin table-head\" flex=15>End Date</div> <div ng-show=userAccess.overviewReport.create class=\"md-margin table-head\" flex=15>Completion Date</div> <div class=\"md-margin table-head\" flex=20>Progress</div> <div flex=10></div> </div> <md-divider class=theme-divider></md-divider> <div ng-repeat=\"plan in planList\" layout=row ng-if=plan._id> <div class=md-margin flex=30>{{plan.name}}</div> <div ng-show=userAccess.overviewReport.create class=md-margin flex=15>{{plan.start_date | date: \"dd.MM.y\"}}</div> <div ng-show=userAccess.overviewReport.create class=md-margin flex=15>{{plan.end_date | date: \"dd.MM.y\"}}</div> <div ng-show=userAccess.overviewReport.create&&plan.completed_date class=md-margin flex=15>{{plan.completed_date | date: \"dd.MM.y\"}}</div> <div ng-show=userAccess.overviewReport.create&&!plan.completed_date class=md-margin flex=15>NA</div> <div class=\"md-margin theme-progress\" flex=20> <div class=theme-progress-bar ng-class=\"{'theme-low-percent':plan.progressType == 'isLow','theme-medium-percent':plan.progressType == 'isMedium','theme-high-percent':plan.progressType == 'isHigh'}\" ng-style=\"{width:{{plan.progressPercentage}} + '%'}\"> <span class=theme-progress-percent>{{plan.progressPercentage}}%</span> </div> </div> <div flex=10 ng-click=gotoViewPage(plan._id) title=\"view plan\" layout=row layout-align=\"center center\"><img src=" + __webpack_require__(924) + " class=hand></div> </div> <br/> </div> </div> </div> </div>";

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=activity-reports> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section\"> <div layout=row> <div flex=40> <div class=common-title> Total Number of Published Activity : <span class=common-value>{{activityCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Activity (Attended) : <span class=common-value>{{attendedCount}}</span> </div> </div> <div ng-show=isShowGoBack flex layout=row layout-align=\"end end\"> <div> <div class=report-close tooltip=\"Go Back\" tooltip-position=down ng-click=goBack()> <i class=material-icons>arrow_back</i> </div> </div> </div> </div> <div layout=row> <div flex=40> <div class=common-title> Number of Activity (Absent) : <span class=common-value>{{absentCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Activity (Not Attended) : <span class=common-value>{{notAttendedCount}}</span> </div> </div> </div> <div class=report-close tooltip=\"Download PDF\" tooltip-position=down ng-click=exportAsPDF() ng-show=isChartAvailable> <i class=\"far fa-file-pdf\"></i> </div> </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isChartAvailable&&isActivityConducted> None of the activity assigned is attended. </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isActivityConducted> None of the activity assigned is conducted. </div> <div layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" style=margin-left:22px> <common-chart flex graph-data=chartdata.value colors=colorArray header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </common-chart> </div> </div> ";

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = "<div class=\"md-whiteframe-2dp reports\"> <div layout=row flex layout-padding layout-wrap layout-fill> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"student in studentList\" ng-click=gotoStudentSubjectReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"fas fa-user-circle\" style=font-size:25px></i> <b flex=85>{{student.name}}</b> </div> </div> </div> </div> ";

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: createQuestionController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var CreateQuestionController =
// @ngInject
["$scope", "$rootScope", "$state", "localStorageService", "authService", "archiveService", "CQuesConst", "ARCHIVE_CONSTANTS", function CreateQuestionController($scope, $rootScope, $state, localStorageService, authService, archiveService, CQuesConst, ARCHIVE_CONSTANTS) {
    _classCallCheck(this, CreateQuestionController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.is_qp_type_lW = false;
    //On destroy function
    this.$onDestroy = function () {};
    /******* API CALL ********/
    var BASIC_DETAIL_URL = CQuesConst.API_GET_BASIC_DETAILS;
    var GET_QUES_URL = CQuesConst.API_GET_QUESTION;
    /************ SESSION DETAILS ***********/
    var schoolId = localStorageService.get("school_id");
    var authoringDetails = localStorageService.get("authoringData");
    //Wheter inside auth tool or not
    var isInsideAuthoring = false;
    //inside auth tool set basic session details
    if (authoringDetails) {
        isInsideAuthoring = false;
        $scope.class_id = authoringDetails.class_id;
        $scope.curriculum_id = authoringDetails.curriculum_id;
        $scope.subject_id = authoringDetails.subject_id;
    }
    //is practice or assessment
    $scope.isPractice = false;
    /****** STATIC FILTER *******/
    $scope.skillList = CQuesConst.SKILL_LIST;
    $scope.questionTypeList = CQuesConst.QUESTION_TYPE_LIST;

    /****** VAR DECLARATION ****/
    $scope.question_type = undefined;
    $scope.linkSubjects = [];
    $scope.themesArray = [];
    $scope.waveDetails = [];
    $scope.strandsList = [];
    $scope.theme = {
        det: null
    };
    $scope.strand = [];
    $scope.wave = [];
    $scope.level = [];
    $scope.cognitive_skill = [];
    $scope.link_subject = [];
    $scope.link_theme = [];
    $scope.tag = [];
    $scope.isEditQuestion = false;
    //Strand auto complete
    $scope.querySearch = function querySearch(query) {
        var filteredStrands = _.filter($scope.strandsList, function (strand) {
            return strand.toLowerCase().indexOf(query.toLowerCase()) === 0;
        });
        var results = query ? filteredStrands : [];
        return results;
    };

    /********* DYNAMIC FILTER ************/
    var getLinkSubjectDetails = function getLinkSubjectDetails() {
        var apiRequestData = {
            curriculum_id: $scope.curriculum_id,
            class_id: $scope.class_id,
            subject_id: $scope.subject_id,
            school_id: schoolId
        };
        authService.callAPI(BASIC_DETAIL_URL, "POST", apiRequestData, function (resultObj) {
            var response = resultObj.result;
            if (response.data) {
                if (response.data.themeList && response.data.themeList.length > 0) {
                    var otherSubjects = _.filter(response.data.themeList, function (sub) {
                        return sub._id !== $scope.subject_id;
                    });
                    $scope.linkSubjects = otherSubjects;
                    if ($scope.isTActivityQuestion || $scope.isTpActivityQuestion) {
                        var currentSubject = _.find(response.data.themeList, function (sub) {
                            return sub._id === $scope.subject_id;
                        });
                        $scope.themesArray = currentSubject.themes;
                    }
                }
                if (response.data.strandList && response.data.strandList.length > 0) {
                    $scope.strandsList = response.data.strandList;
                }
                if (response.data.waveList && response.data.waveList.length > 0) {
                    $scope.waveDetails = response.data.waveList;
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    /********* SET ARCHIVE PAGE ***********/
    var setArchivePage = function setArchivePage() {
        $scope.isArchiveQuestion = true;
        $scope.isTActivityQuestion = false;
        if (!isInsideAuthoring) {
            $scope.class_id = $scope.$parent.$parent.class;
            $scope.curriculum_id = $scope.$parent.$parent.curriculum;
            $scope.subject_id = $scope.$parent.$parent.subject;
            getLinkSubjectDetails();
            $scope.$watch('$parent.$parent.curriculum', function (newValue) {
                if (newValue) {
                    $scope.curriculum_id = newValue;
                    getLinkSubjectDetails();
                }
            });

            $scope.$watch('$parent.$parent.class', function (newValue) {
                if (newValue) {
                    $scope.class_id = newValue;
                    getLinkSubjectDetails();
                }
            });

            $scope.$watch('$parent.$parent.subject', function (newValue) {
                if (newValue) {
                    $scope.subject_id = newValue;
                    getLinkSubjectDetails();
                }
            });
        } else {
            getLinkSubjectDetails();
        }
        $scope.question_type = $scope.$parent.$parent.questionType ? $scope.$parent.$parent.questionType : undefined;
        $scope.theme.det = {
            theme_id: $scope.$parent.$parent.theme
        };
        $scope.$watch('$parent.$parent.questionType', function (newValue) {
            if (newValue) {
                $scope.question_type = newValue;
            }
        });

        $scope.$watch('$parent.$parent.theme', function (newValue) {
            if (newValue) {
                $scope.theme.det = {
                    theme_id: newValue
                };
                $scope.isShowUploadCsv = true;
            }
        });
    };

    /********** SET TRADITIONAL ACTIVITY *********/
    var setTActivityPage = function setTActivityPage() {
        $scope.isArchiveQuestion = false;
        $scope.isTActivityQuestion = true;
        $scope.isTpActivityQuestion = false;
        $scope.tqp_id = sessionDetails.qp_id;
        $scope.qp_title = sessionDetails.qp_title;
        $scope.isPractice = sessionDetails.isPractice;
        getLinkSubjectDetails();
    };
    /********** SET TP ACTIVITY *********/
    var setTpActivityPage = function setTpActivityPage() {
        $scope.isArchiveQuestion = false;
        $scope.isTpActivityQuestion = true;
        $scope.isTActivityQuestion = false;
        //$scope.tqp_id = sessionDetails.qp_id;
        //$scope.qp_title = sessionDetails.qp_title;
        $scope.isPractice = sessionDetails.isPractice;
        getLinkSubjectDetails();
    };

    /********** SET SESSION AND BASIC DETAILS ***********/
    var setSession = function setSession(sessionDetails) {
        switch (sessionDetails.state) {
            case "archive":
                setArchivePage();
                break;
            case "tactivity":
                setTActivityPage();
                break;
            case "tpActivity":
                setTpActivityPage();
                break;
        }
        if (sessionDetails.question_id) {
            $scope.isLoading = true;
            $scope.isHideCreateSection = true;
            $scope.loadingMsg = "Loading question to edit... Please, wait...";
            authService.callAPI(GET_QUES_URL + sessionDetails.question_id, "GET", {}, function (resp) {
                if (resp.result != undefined) {
                    var resultObj = resp.result;
                    var status = resultObj.status;
                    var result = resultObj.data.data;
                    if (status.code === 200) {
                        if (status.message == "Success") {
                            var linkSubjects = [];
                            _.each(result.xlink, function (link) {
                                if (linkSubjects.length > 0) {
                                    if (linkSubjects.findIndex(function (i) {
                                        return i._id === link.subject_id;
                                    }) === -1) {
                                        linkSubjects.push({
                                            _id: link.subject_id,
                                            name: link.subject_name
                                        });
                                    }
                                } else linkSubjects.push({
                                    _id: link.subject_id,
                                    name: link.subject_name
                                });
                            });
                            $scope.strandEntered = result.strand;
                            $scope.cognitive_skill = result.cognitive_skills;
                            $scope.strand = result.strand;
                            $scope.tag = result.tag;
                            $scope.level = result.level;
                            $scope.wave = result.wave;
                            $scope.link_subject = linkSubjects;
                            $scope.link_theme = result.xlink;
                            $scope.editQuestion = result;
                            $scope.question_type = result.type;
                            $scope.theme = {
                                det: {
                                    theme_id: result.theme_id,
                                    theme_name: result.theme_name
                                }
                            };
                            if ($scope.isArchiveQuestion) {
                                $scope.$parent.$parent.theme = result.theme_id;
                                $scope.$parent.$parent.questionType = result.type;
                            }
                            $scope.isLoading = false;
                            $scope.isHideCreateSection = false;
                            $scope.isEditQuestion = true;
                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    }
                } else {
                    console.log("error : " + response.error);
                }
            });
        }
    };

    //GET SESSION DETAILS
    var sessionDetails = localStorageService.get("createQuesiton");
    console.log(sessionDetails);
    if (sessionDetails && sessionDetails.is_qp_type_lW) {
        $scope.is_qp_type_lW = true;
        $scope.questionTypeList = ARCHIVE_CONSTANTS.ARCHIVE_QUESTION_TYPE_LIST_LW;
    }
    setSession(sessionDetails);

    //TO GO TO ARCHIVE TO SELECT QUESTIONS
    $scope.goToArchive = function () {
        var qType = _.find($scope.questionTypeList, function (qn) {
            return qn._id === $scope.question_type;
        });
        var searchFilters = [];
        searchFilters.push({
            type: 'curriculum',
            value: {
                _id: authoringDetails.curriculum_id,
                name: authoringDetails.curriculum
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'class',
            value: {
                _id: authoringDetails.class_id,
                name: authoringDetails.class
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'subject',
            value: {
                _id: authoringDetails.subject_id,
                name: authoringDetails.subject
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: "tab",
            value: {
                _id: "question",
                name: "Questions"
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: "question_type",
            value: qType,
            deletable: true,
            visible: true
        });
        console.log(sessionDetails);
        var previousState = void 0;
        if (sessionDetails.state === "tactivity") {
            previousState = {
                state: 'createActivity',
                params: {
                    qpId: $scope.qp_id ? $scope.qp_id : sessionDetails.qp_id,
                    activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                }
            };
        } else {
            previousState = {
                state: 'activityForm',
                params: {
                    planId: sessionDetails.teaching_plan_id,
                    resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                }
            };
        }
        var details = {
            searchFilters: searchFilters,
            previousState: previousState,
            isMultiSelect: true,
            activeTab: "question",
            resourceType: {
                _id: "question",
                name: "Questions"
            }
        };
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    //GOTO PREVIOUS PAGE ON CANCEL CLICK
    $scope.redirectToPreviousPage = function () {
        if (sessionDetails.isQuestionAvailable) {
            if (sessionDetails.state === "tactivity") {
                $state.go('formatQuestion', {
                    qpId: sessionDetails.qp_id,
                    activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                });
            } else {
                $state.go('formatQp', {
                    resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                });
            }
        } else {
            if (sessionDetails.state === "tactivity") {
                $state.go('createActivity', {
                    qpId: sessionDetails.qp_id,
                    activityId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                });
            } else {
                $state.go('activityForm', {
                    resourceId: sessionDetails.activity_id ? sessionDetails.activity_id : ""
                });
            }
        }
    };

    //SET TAB TO SHOW ERROR MESSAGE
    var setSecondTab = function setSecondTab() {
        if ($scope.isTActivityQuestion) {
            $scope.selectedIndex = 1;
        }
    };

    //VALIDATE BASIC DETAILS
    var validate = function validate(questionDetails) {
        var activityErrorCount = 0;
        $scope.errors = {};
        var isThemeError = false;
        if (questionDetails.is_created_from_archive) {
            $scope.$parent.$parent.errors = {};
            if (!questionDetails.curriculum_id) {
                $scope.$parent.$parent.errors["curriculum"] = "Please, Select a curriculum";
                activityErrorCount++;
            }
            if (!questionDetails.class_id) {
                $scope.$parent.$parent.errors["class"] = "Please, Select a class";
                activityErrorCount++;
            }
            if (!questionDetails.subject_id) {
                $scope.$parent.$parent.errors["subject"] = "Please, Select a subject";
                activityErrorCount++;
            }
            if (questionDetails.theme) {
                if (!questionDetails.theme._id) {
                    $scope.$parent.$parent.errors["theme"] = "Please, Select a theme";
                    activityErrorCount++;
                }
            } else {
                $scope.$parent.$parent.errors["theme"] = "Please, Select a theme";
                activityErrorCount++;
            }
        } else {
            if (questionDetails.theme) {
                if (!questionDetails.theme._id) {
                    isThemeError = true;
                    $scope.errors["theme"] = "Please, Select a theme";
                    activityErrorCount++;
                }
            } else {
                isThemeError = true;
                $scope.errors["theme"] = "Please, Select a theme";
                activityErrorCount++;
            }
        }
        if ($scope.question_type != "passage") {
            if (questionDetails.strand) {
                if (questionDetails.strand.length <= 0) {
                    $scope.errors["strand"] = "Please, Enter atleast one strand";
                    if (!isThemeError) {
                        setSecondTab();
                    }
                    activityErrorCount++;
                }
            } else {
                $scope.errors["strand"] = "Please, Enter atleast one strand";
                if (!isThemeError) {
                    setSecondTab();
                }
                activityErrorCount++;
            }
            if (questionDetails.level) {
                if (questionDetails.level.length <= 0) {
                    $scope.errors["level"] = "Please, Enter atleast one level";
                    if (!isThemeError) {
                        setSecondTab();
                    }
                    activityErrorCount++;
                }
            } else {
                $scope.errors["level"] = "Please, Enter atleast one level";
                if (!isThemeError) {
                    setSecondTab();
                }
                activityErrorCount++;
            }
            if (questionDetails.wave) {
                if (questionDetails.wave.length <= 0) {
                    $scope.errors["wave"] = "Please, Enter atleast one wave";
                    if (!isThemeError) {
                        setSecondTab();
                    }
                    activityErrorCount++;
                }
            } else {
                $scope.errors["wave"] = "Please, Enter atleast one wave";
                if (!isThemeError) {
                    setSecondTab();
                }
                activityErrorCount++;
            }
            if (questionDetails.cognitive_skill) {
                if (questionDetails.cognitive_skill.length <= 0) {
                    $scope.errors["cognitive_skill"] = "Please, Enter atleast one skill";
                    if (!isThemeError) {
                        setSecondTab();
                    }
                    activityErrorCount++;
                }
            } else {
                $scope.errors["cognitive_skill"] = "Please, Enter atleast one skill";
                if (!isThemeError) {
                    setSecondTab();
                }
                activityErrorCount++;
            }
        }
        return activityErrorCount;
    };

    //SAVE QUESION
    $scope.addQuestion = function () {
        var _questionDetails;

        $scope.isLoading = true;
        $scope.loadingMsg = "Question is saving... Please wait...";
        var activityErrorCount = 0;
        var questionDetails = (_questionDetails = {
            curriculum_id: $scope.curriculum_id,
            class_id: $scope.class_id,
            subject_id: $scope.subject_id,
            qp_id: sessionDetails.qp_id,
            session_id: sessionDetails.session_id,
            batch_id: sessionDetails.batch_id,
            school_id: schoolId,
            question_type: $scope.question_type,
            strand: $scope.strand,
            theme: {
                _id: $scope.theme && $scope.theme.det && $scope.theme.det.theme_id ? $scope.theme.det.theme_id : "",
                name: $scope.theme && $scope.theme.det && $scope.theme.det.theme_name ? $scope.theme.det.theme_name : ""
            },
            tag: $scope.tag,
            level: $scope.level,
            wave: $scope.wave,
            link_subject: $scope.link_subject,
            link_theme: $scope.link_theme,
            cognitive_skill: $scope.cognitive_skill
        }, _defineProperty(_questionDetails, "qp_id", $scope.tqp_id), _defineProperty(_questionDetails, "activity_id", sessionDetails.activity_id), _defineProperty(_questionDetails, "is_traditional_activity", $scope.isTActivityQuestion), _defineProperty(_questionDetails, "is_created_from_archive", $scope.isArchiveQuestion), _defineProperty(_questionDetails, "isPractice", $scope.isPractice), _defineProperty(_questionDetails, "isNotAddToQp", $scope.isArchiveQuestion ? $scope.isArchiveQuestion : false), _defineProperty(_questionDetails, "teaching_plan_id", sessionDetails.teaching_plan_id), _questionDetails);
        activityErrorCount = validate(questionDetails);
        localStorageService.set("questionDetails", {
            question: questionDetails,
            errorCount: activityErrorCount
        });
        switch ($scope.question_type) {
            case 'MCQ':
                $scope.$broadcast('addMcqQuestion');
                break;
            case 'TF':
                $scope.$broadcast('addTfQuestion');
                break;
            case 'FIB':
                $scope.$broadcast('addFibQuestion');
                break;
            case 'MTF':
                $scope.$broadcast('addMatchQuestion');
                break;
            case 'OWQ':
                $scope.$broadcast('addOwqQuestion');
                break;
            case 'SA':
                $scope.$broadcast('addShortQuestion');
                break;
            case 'LA':
                $scope.$broadcast('addLongQuestion');
                break;
            case 'passage':
                $scope.$broadcast('addPassage');
                break;
            case 'DRAW':
                $scope.$broadcast('addDrawing');
                break;
            case 'ASLSPEAK':
                $scope.$broadcast('addAslSpeaking');
                break;
            case 'ASLLISTEN':
                $scope.$broadcast('addAslListening');
                break;
        }
    };

    //RESET VALUES
    $rootScope.resetValues = function () {
        $scope.strand = [];
        $scope.wave = [];
        $scope.level = [];
        $scope.cognitive_skill = [];
        $scope.link_subject = [];
        $scope.link_theme = [];
        $scope.tag = [];
        if ($scope.question_type == 'passage') {
            $scope.question_type = "";
            $scope.theme.det = "";
        }
    };

    //HIDE SAVE BUTTON ON SERVER CALL
    $rootScope.setHideSaveButton = function (value) {
        $scope.isSaveClicked = value;
    };

    //SET LOADER WHILE EDIT OR SAVE
    $rootScope.setLoader = function (value, msg) {
        $scope.isLoading = value;
        if (value) {
            $scope.loadingMsg = msg;
        }
    };
}];

exports.default = CreateQuestionController;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <style>.qpPreview .comment_box{border-top:1px solid #7bc5bc}.qpPreview .comment_box div{font-style:italic}</style> <md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=\"qpPreview answer-preview\" ng-if=!fee_status_label> <md-card> <md-card-title> <md-card-title-text> <span class=md-headline>Sorry cannot view the answer sheet as you have fees dues</span> </md-card-title-text> </md-card-title> </md-card> </div> <div class=\"qpPreview answer-preview\" layout=column ng-if=\"!isLoading && fee_status_label\"> <div class=md-whiteframe-2dp layout=row> <div flex=10> <div class=school-logo> <img src={{qpHeader.schoolLogo}} width=100> </div> </div> <div layout=column flex=80> <div class=schoolName> {{qpHeader.schoolName}}</div> <div class=exam>{{qpDetails.question_paper_title}}</div> <div class=subject>{{qpDetails.subject}}</div> </div> </div> <div class=\"timeClass md-whiteframe-2dp\" layout=row> <div flex=30> <span>Time: {{qpDetails.time.hour}} hour {{qpDetails.time.min}} min</span> </div> <div flex=30>Class: {{qpDetails.class}}</div> <div flex=30> <span>Score: {{my_score}} / {{totalmark}} </span> </div> </div> <div layout=row class=date-div> <div flex=30 class=preview-heading> <p style=margin-bottom:0!important;color:#2196f3> <label><b>Date: {{qpDetails.due_date | date: \"dd.MM.y\"}}</b></label> </p> </div> <div flex=30 layout=row> <label class=correct-indication></label> <label style=color:green;font-size:14px!important;padding-left:10px>Correct answer</label> </div> <div flex=30 layout=row> <label class=wrong-indication></label> <label style=color:red;font-size:14px!important;padding-left:10px>Wrong answer</label> </div> </div> <div class=\"mtf-answer-border md-whiteframe-2dp\"> <div class=mtf-white-border> <div ng-repeat=\"section in questions track by $index\"> <div layout=row layout-align=\"center center\" class=mtf-answer-sectionBorder> <b> <p class=mtf-inside-content ng-if=\"section.answers.length>section.mandatory_no\"> {{section.name}} (Any {{section.mandatory_no}}) </p> <p class=mtf-inside-content ng-if=\"section.answers.length===section.mandatory_no\"> {{section.name}} (Attend all) </p> </b> </div> <div ng-repeat-start=\"question in section.answers track by $index\"> <div ng-switch=question.type> <div ng-switch-when=MCQ|IBT_MCQ ng-switch-when-separator=| layout=column> <div ng-switch=question.pattern> <div flex ng-switch-when=single> <div flex layout=row> <div flex=90 layout=column> <p ng-if=question.passage class=composed_dom style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-model=question.my_answer[0] flex> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=\"question-outline question_desc\" ng-if=question.isLatex>{{choice.tag}} ) {{choice.desc}}</div> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=question-outline ng-if=!question.isLatex>{{choice.tag}} ) {{choice.desc}}</div> <div layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> <div ng-switch-when=multiple layout=column> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p></div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <md-divider ng-if=\"question.questionImg && question.questionImg.length>0\"></md-divider> <div layout=row flex layout-align=\"space-between center\" ng-repeat-start=\"choice in question.choice\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{choice.tag}}){{ choice.desc }} </div> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{choice.tag}}){{ choice.desc }} </div> <div layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> </div> <md-divider ng-repeat-end ng-if=\"choice.optImage && choice.optImage.length>0\"></md-divider> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=TF layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-model=question.my_answer[0] flex> <div ng-disabled=false ng-click=$event.stopImmediatePropagation(); ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\">{{choice.tag}}</div> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=OWQ layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div ng-repeat=\"choice in question.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{question.my_answer[$index]}}</b> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{question.my_answer[$index]}}</b> </label> <label ng-if=choice.wrong>Your Answer - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc style=padding-right:20px ng-if=question.isLatex>{{question.my_answer[$index]}}</b> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex style=padding-right:20px>{{question.my_answer[$index]}}</b> Correct Answer - <b class=\"correct-ans-mcq question_desc\" ng-if=question.isLatex>{{choice.desc}}</b> <b class=correct-ans-mcq ng-if=!question.isLatex>{{choice.desc}}</b> </label> </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=FIB|IBT_FIB ng-switch-when-separator=| layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p>{{$index+1}} ) {{beautifyFIB(question.qn_desc)}}&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div ng-repeat=\"choice in question.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc>{{question.my_answer[$index]}}</b></label> <label ng-if=choice.wrong>Your Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{question.my_answer[$index]}}</b> Correct Answer {{$index+1}} - <b class=\"correct-ans-mcq question_desc\">{{choice.desc}}</b></label> </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=MTF layout=column> <div layout=column flex> <div layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p>{{$index+1}} ) Match the following questions and answers &nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div flex layout=row> <div flex=30 layout=column> Question: <div ng-if=!quest.no_question class=md-whiteframe-2dp ng-repeat=\"quest in question.option\" layout=row style=margin:5px> <label style=padding:15px;background:#00bcd4;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:15px;background:#fff;margin:0;font-size:14px!important class=question_desc ng-if=question.isLatex>{{quest.question.desc}}</label> <label flex style=padding:15px;background:#fff;margin:0;font-size:14px!important ng-if=!question.isLatex>{{quest.question.desc}}</label> <img flex ng-src={{setFilePath(quest.question.questionImg)}} ng-if=quest.question.questionImg class=mtf-question-img /> </div> </div> <div flex=30 layout=column> Correct Answer: <div ng-if=!quest.no_question class=md-whiteframe-2dp ng-repeat=\"quest in question.option\" layout=row style=margin:5px> <label style=padding:15px;background:#00bcd4;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:15px;background:#fff;margin:0;font-size:14px!important class=question_desc ng-if=question.isLatex>{{quest.answer.desc}}</label> <label flex style=padding:15px;background:#fff;margin:0;font-size:14px!important ng-if=!question.isLatex>{{quest.answer.desc}}</label> <img flex ng-src={{setFilePath(quest.answer.optImage)}} ng-if=quest.answer.optImage class=mtf-question-img /> </div> </div> <div flex=30 layout=column ng-if=\"question.ans_key.length>0\">Student Answer: <div ng-if=answer.needed ng-repeat=\"answer in question.ans_key\" class=md-whiteframe-2dp layout=row style=margin:5px;height:60px> <label style=padding:7px;width:25px;background:#009688;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label style=padding:5px flex class=\"mtf_answer question_desc\" ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : !answer.correct}\" ng-if=question.isLatex>{{answer.desc}}</label> <label style=padding:5px;height:60px;overflow:auto;float:left flex class=mtf_answer ng-if=!question.isLatex ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : !answer.correct}\">{{answer.desc}}</label> <img flex ng-src={{setFilePath(answer.optImage)}} ng-if=answer.optImage class=mtf-question-img /> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=SA layout=column> <div flex layout=row> <div flex=90 layout=column> <p class=composed_dom ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}} &nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div flex ng-if=question.value_points[0]> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Value Points </b></p> <div class=txt-area-box ng-if=question.showHint ng-repeat=\"keyValue in question.value_points\" style=background-color:#f0f8ff> <p class=question_desc ng-if=question.isLatex>{{$index+1}} . {{keyValue.name}} </p> <p ng-if=!question.isLatex>{{$index+1}} . {{keyValue.name}}</p> </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer> Student: <br/> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img flex ng-src={{setFilePath(question.answerImg)}} style=max-width:600px;max-height:400px> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=LA layout=column> <div flex layout=row> <div flex=90 layout=column> <p ng-if=question.passage class=composed_dom style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px> </div> </div> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} ) <span class=composed_dom ng-bind-html=\"data=conertToHtml(question.qn_desc)\"></span>&nbsp;</p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex ng-if=question.value_points[0]> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Value Points</b></p> <div class=txt-area-box ng-if=question.showHint ng-repeat=\"keyValue in question.value_points\" style=background-color:#f0f8ff> <p class=question_desc ng-if=question.isLatex>{{$index+1}} . {{keyValue.name}} </p> <p ng-if=!question.isLatex>{{$index+1}} . {{keyValue.name}}</p> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer> Student: <br/> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img flex ng-src={{setFilePath(question.answerImg)}} style=max-width:600px;max-height:400px> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex ng-if=question.questionReview> <p>Comment By teacher :{{question.questionReview}}</p> </div> <div ng-if=question.comment flex layout=column class=comment_box> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=DRAW layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> </p> </div> <div flex=10 layout=row> <input ng-disabled=true class=policy oninput=\"100<value&&(value=null)\" type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <img ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.answerImg> Student: <br/> <img flex src={{setFilePath(question.answerImg)}} style=max-width:600px;max-height:400px> </div> </div> <div flex> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLLISTEN layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> </p> <div ng-if=question.audio_url class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.audio_url)}}></audio> </div> </div> <div flex=10 layout=row> <input class=policy ng-disabled=true type=text ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <img flex ng-src={{setFilePath(question.questionImg)}} class=question-img ng-if=question.questionImg /> <div ng-repeat=\"answer in question.questions\" flex> <div ng-switch=answer.type> <div ng-switch-when=mcq> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{choice.tag}}){{ choice.desc }} <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{choice.tag}}){{ choice.desc }} <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> </div> </div> </div> <div ng-switch-when=tf layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" class=question_desc ng-if=question.isLatex>{{choice.tag}} </div> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" ng-if=!question.isLatex>{{choice.tag}} </div> </div> </div> </div> </div> <div ng-switch-when=fib layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p>{{$index+1}} ) {{beautifyFIB(answer.qn_desc)}}</p> </div> </div> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div ng-repeat=\"choice in answer.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{answer.my_answer[$index]}}</b> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{answer.my_answer[$index]}}</b> </label> <label ng-if=choice.wrong>Your Answer {{$index+1}} - <b class=question_desc ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px ng-if=question.isLatex>{{answer.my_answer[$index]}}</b> <b ng-if=!question.isLatex ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{answer.my_answer[$index]}}</b> Correct Answer {{$index+1}} - <b class=correct-ans-mcq ng-if=!question.isLatex>{{choice.desc}}</b> <b class=\"correct-ans-mcq question_desc\" ng-if=question.isLatex>{{choice.desc}}</b> </label> </div> </div> </div> </div> <div ng-switch-when=audio layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <div> <div flex ng-if=answer.answer> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"answer.showHint = answer.showHint?false:true;\"><b style=color:green>{{answer.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=answer.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(answer.answer)}}></audio> </div> </div> <div flex layout-align=\"start center\" ng-if=answer.my_answer> Student: <br/> <div class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(answer.my_answer)}}></audio> </div> </div> </div> </div> </div> <div ng-switch-when=text layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <label ng-if=answer.correct>Answer - <b ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : answer.wrong}\">{{answer.my_answer}}</b></label> <label ng-if=!answer.correct>Your Answer - <b ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : answer.wrong}\" style=padding-right:20px>{{answer.my_answer}}</b> Correct Answer - <b class=correct-ans-mcq>{{answer.answer}}</b></label> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLSPEAK layout=column> <div flex layout=row> <div flex=90> <p>{{$index+1}} ) {{question.qn_desc}}</p> </div> <div flex=10 layout=row> <input class=policy ng-disabled=true oninput=\"100<value&&(value=null)\" type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=column flex> <div flex ng-if=question.ans_audio_url> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=question.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.answer)}}></audio> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer> Student: <br/> <div class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.my_answer)}}></audio> </div> </div> </div> </div> </div> </div> <md-divider ng-repeat-end ng-if=!$last style=\"padding:5px 0;margin:5px 0\"></md-divider> </div> </div> </div> <div class=\"answer-preview mtf-answer-border md-whiteframe-2dp\" layout=column style=\"margin-bottom:65px;border:2px solid #00b6ec\" ng-if=\"!isLoading && !pdfData && comment\"> <div class=comment_box ng-if=comment flex layout=column> <label><p><b style=color:red>Overall activity comment</b></p></label><div flex>{{comment}}</div> </div> </div> </div> ";

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
var StudentAnswerController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", function StudentAnswerController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
    _classCallCheck(this, StudentAnswerController);

    var authoring = localStorageService.get("authoringData");
    var qpId = $state.params.qpId;
    var studentId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    $scope.continue = false;
    $scope.no_fee_status = false;
    var self = this;
    $scope.isLoading = true;
    $scope.comment = undefined;
    $scope.fee_status_label = true;
    function getSchoolTokens(schoolId) {
        var dummySchool = [{
            "_id": "2ebFyzgjEwmdvep5L",
            "school_name": "The Oxford School,Trivandrum",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "https://portal.oxford.edu.in/index.php/portal_data_contract",
            // "school_data_token" : "d8ba88f080664a1420d2d080b658fc04"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "53d553cca766bb843eeb6464608ac93e"
        }, {
            "_id": "Mvb8uY53ijBX9DNJS",
            "school_name": "The Oxford School,Kollam",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "https://portal.oxfordkollam.edu.in/index.php/portal_data_contract",
            // "school_data_token" : "795dce7a5fa85ef8d4945441549b6578"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "25c921722bec9527d59eb0e34713347c"
        }, {
            "_id": "f5BCz8T7LqzpFsSP3",
            "school_name": "The Oxford School,Calicut",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "http://portal.oxfordcalicut.com/index.php/Portal_data_contract",
            // "school_data_token" : "cded12b4cd909d4e00610ff0699ca069"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
        }, {
            "_id": "CPpbKPQTcuG97i3kv",
            "school_name": "The New Indian Model School,Dubai",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
            // "school_data_token" : "e370c37780b957637493e9727c9b304d",
            // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
            // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "7a9d733269d23bc35b04b56dc855d330"
        }, {
            "_id": "m2LMtqaESFZf6xDE8",
            "school_name": "The Central School,Dubai",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
            // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "47e2b919b8551d762e1dd1f5769b66ba"
        }, {
            "_id": "2FwuqhgeoKt6SQiCG",
            "school_name": "The New Indian Model School,Al-Ain",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
            // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "0ae409a7d98dde57b35a4643d2354906"
        }, {
            "_id": "ps4vyLJhQvPZjfxaH",
            "school_name": "The New Indian Model School,Sharjah",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
        }, {
            "_id": "apX7mQ9LsV2kZdFaH",
            "school_name": "APEX Vision Model School, Sharjah",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "fe8acc83e277e3112e1dbf520291bfc9"
        }];
        var ex = _.find(dummySchool, function (one) {
            return one._id == schoolId;
        });
        return ex;
    }
    function feesCheckOneStudent() {
        var school_id = localStorageService.get("school_id");
        var tokens = getSchoolTokens(school_id);
        var admn_no = localStorageService.get('admission_no');

        if (!admn_no) {
            admn_no = localStorageService.get('st_admission_number');
        }
        console.log(admn_no);
        authService.callAPI("/v0/parent/portal/fee/", "POST", {
            school_data_token: tokens.school_data_token,
            school_data_url: tokens.school_data_url,
            admn_no: admn_no
        }, function (response) {
            try {
                if (response.result.status.code == 200) {
                    if (response.result.data && response.result.data.details) {
                        self.feesDocument = response.result.data.details;
                        var exmpList = response.result.data.exemption_list ? response.result.data.exemption_list : [];
                        _.each(self.feesDocument, function (det, index) {
                            if (det.fee_last_date) {
                                var someDate = new Date(det.fee_last_date);
                                var numberOfDaysToAdd = 20;
                                someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                det.fee_last_date = someDate;
                            }
                            // det.fee_last_date = new Date(det.fee_last_date)
                            var today = new Date();
                            det.fee_last_date.setHours(0, 0, 0, 0);
                            today.setHours(0, 0, 0, 0);
                            if (det.fee_last_date <= today) {
                                if (det.fee_status === "Pending" && det.blocking_status === "Y") {
                                    var isExepted = exmpList.includes(admn_no);
                                    if (isExepted) {
                                        $scope.fee_status_label = true;
                                    } else {
                                        $scope.fee_status_label = false;
                                    }
                                } else {
                                    $scope.fee_status_label = true;
                                }
                            }
                        });
                        init();
                    } else {
                        $scope.fee_status_label = true;
                        init();
                    }
                } else {
                    $scope.fee_status_label = true;
                }
            } catch (ex) {
                console.log(ex);
                $scope.fee_status_label = true;
            }
        });
    }
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (authoring) {
            feesCheckOneStudent();
            $rootScope.authMenu = true;
            $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject;
        } else {
            $state.go("authdashboard");
        }
    };
    function init() {
        authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    var result = response.result.data.details;
                    if (result && result.comment) {
                        $scope.comment = result.comment;
                    }
                    var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
                    $scope.my_score = 0;
                    $scope.totalmark = 0;
                    $scope.quesCount = 0;
                    var myScore = 0;
                    $scope.isTeacherEvaluation = false;
                    _.each(result.consolidatedData, function (sec) {
                        delete sec.questions;
                        _.each(sec.answers, function (ans) {
                            if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                $scope.quesCount++;
                            }
                            $scope.totalmark = ans.total_mark;
                            if (!isNaN(ans.my_score)) {
                                myScore = parseFloat(myScore) + parseFloat(ans.my_score);
                                myScore = myScore.toFixed(2);
                                $scope.my_score = myScore;
                            }
                        });
                    });
                    $scope.qpDetails = {
                        question_paper_title: result.question_paper_title,
                        subject: authoring.subject,
                        class: authoring.class,
                        time: result.time,
                        due_date: result.due_date
                    };
                    $scope.questions = result.consolidatedData;
                    $scope.isLoading = false;
                    setTimeout(function () {
                        $scope.loadLatex();
                    }, 100);
                    setChoice();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                //toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
        //To get school details
        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
            if (response.result && response.result.status && response.result.data.details) {
                var result = response.result.data.details;
                console.log(result);
                $scope.qpHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                    'subject': authoring.subject,
                    'class': authoring.class
                };
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        });
    }

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }
    /* Set answered choice is wrong or correct*/
    function setChoice() {
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (data, key) {
                $scope.total_mark += parseFloat(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    _.each(data.choice, function (choice) {
                        if ($scope.checkingChoiceExists(choice.desc, data)) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                        }
                    });
                } else if (data.type == 'TF') {
                    _.each(data.choice, function (choice) {
                        if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        }
                    });
                } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    var whole_answer_correct = false;
                    if (Number(data.my_score) > 0) {
                        whole_answer_correct = true;
                    }
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                            if (whole_answer_correct) {
                                choice.wrong = false;
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (whole_answer_correct) {
                                choice.wrong = false;
                                choice.correct = true;
                            }
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    var _whole_answer_correct = false;
                    if (Number(data.my_score) > 0) {
                        _whole_answer_correct = true;
                    }
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key2]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                            if (_whole_answer_correct) {
                                choice.wrong = false;
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (_whole_answer_correct) {
                                choice.wrong = false;
                                choice.correct = true;
                            }
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var needed = true;
                        if (!choice.question.desc) {
                            choice['no_question'] = true;
                            needed = false;
                        }
                        var correctAnswer = removeSpecialCharacter(choice.answer.desc);
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key3].desc);
                            if (correctAnswer !== studentAnswer) {
                                correct = false;
                            } else {
                                correct = true;
                            }
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage,
                                needed: needed
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacter(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                } else {
                                    choice.wrong = true;
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacter(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacter(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    aslListQues.wrong = true;
                                } else {
                                    aslListQues.correct = true;
                                }
                            } else {
                                aslListQues.wrong = true;
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
    }
    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };
    $scope.gotoQpPreview = function () {
        $state.go('qpSummary', {
            qpId: qpId
        });
    };
    $scope.setFilePath = function (img) {
        var new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined;
        return new_url;
    };

    $scope.beautifyFIB = function (question) {
        return question.toString().replace(/_/g, " _______ ");
    };
    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };
    $scope.conertToHtml = function (string) {
        // string = "<span style='color: #89a000'>123</span>"
        return $sce.trustAsHtml(string);
    };
}];

exports.default = StudentAnswerController;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.hand_on_img{cursor:pointer}.qpPreview .comment_box{border-top:1px solid #7bc5bc}.qpPreview .comment_box div{font-style:italic}.addCmt{float:right;color:#56ce59;position:absolute;right:46px;width:133px;cursor:pointer}</style> <md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=\"qpPreview answer-preview\" layout=column style=margin-bottom:65px ng-if=\"!isLoading && !pdfData\"> <div class=md-whiteframe-2dp layout=row> <div flex=10> <div class=school-logo> <img src={{qpHeader.schoolLogo}} width=100> </div> </div> <div layout=column flex=80> <div class=schoolName> {{qpHeader.schoolName}}</div> <div class=exam>{{qpDetails.question_paper_title}}</div> <div class=subject>{{qpDetails.subject}}</div> <div class=exam> {{student_user_doc.name}}</div> </div> </div> <div class=\"timeClass md-whiteframe-2dp\" layout=row> <div flex=30> <span>Time: {{qpDetails.time.hour}} hour {{qpDetails.time.min}} min</span> </div> <div flex=30>Class: {{qpDetails.class}}</div> <div flex=30> <span>Score: {{my_score}} / {{totalmark}} </span> </div> </div> <div layout=row class=date-div> <div flex=30 class=preview-heading> <p style=margin-bottom:0!important;color:#2196f3> <label><b>Date: {{qpDetails.due_date | date: \"dd.MM.y\"}}</b></label> </p> </div> <div flex=30 layout=row> <label class=correct-indication></label> <label style=color:green;font-size:14px!important;padding-left:10px>Correct answer</label> </div> <div flex=30 layout=row> <label class=wrong-indication></label> <label style=color:red;font-size:14px!important;padding-left:10px>Wrong answer</label> </div> </div> <div class=\"answer-preview mtf-answer-border md-whiteframe-2dp\"> <div class=mtf-white-border> <div ng-repeat=\"section in questions track by $index\"> <div layout=row layout-align=\"center center\" class=mtf-answer-sectionBorder> <b> <p class=mtf-inside-content ng-if=\"section.answers.length>section.mandatory_no\"> {{section.name}} (Any {{section.mandatory_no}}) </p> <p class=mtf-inside-content ng-if=\"section.answers.length===section.mandatory_no\"> {{section.name}} (Attend all) </p> </b> </div> <div ng-repeat=\"question in section.answers track by $index\"> <div ng-switch=question.type> <div ng-switch-when=MCQ|IBT_MCQ ng-switch-when-separator=|> <div ng-switch=question.pattern> <div flex ng-switch-when=single> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\" ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}} &nbsp; </p> <p ng-if=!question.isLatex>{{$index+1}} ) <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-model=question.my_answer[0] flex> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=\"question-outline question_desc\" ng-if=question.isLatex>{{choice.tag}}){{choice.desc}}</div> <div ng-value=choice.desc ng-disabled=false aria-label={{choice.desc}} ng-click=$event.stopImmediatePropagation(); class=question-outline ng-if=!question.isLatex>{{choice.tag}}){{choice.desc}}</div> <div layout=row layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> <div ng-switch-when=multiple layout=column> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\" ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex>{{$index+1}} ) <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <md-divider ng-if=\"question.questionImg && question.questionImg.length>0\"></md-divider> <div layout=row flex layout-align=\"space-between center\" ng-repeat-start=\"choice in question.choice\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{choice.tag}}){{ choice.desc }} </div> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{choice.tag}}){{ choice.desc }} </div> <div layout=row layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div flex=40 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> </div> <md-divider ng-repeat-end ng-if=\"choice.optImage && choice.optImage.length>0\"></md-divider> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=TF> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\" ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex>{{$index+1}} ) <span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-model=question.my_answer[0] flex> <div ng-disabled=false ng-click=$event.stopImmediatePropagation(); ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" class=question_desc ng-if=question.isLatex>{{choice.tag}}</div> <div ng-disabled=false ng-click=$event.stopImmediatePropagation(); ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" ng-if=!question.isLatex>{{choice.tag}}</div> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=OWQ> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\" ng-model=question.my_score />&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex> {{$index+1}} ) {{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex> {{$index+1}} ) &nbsp;<span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span> </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div ng-repeat=\"choice in question.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc ng-if=question.isLatex>{{question.my_answer[$index]}}</b> <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{question.my_answer[$index]}}</b> </label> <label ng-if=choice.wrong>Your Answer - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{question.my_answer[$index]}}</b> Correct Answer(s) - <b class=\"correct-ans-mcq question_desc\" ng-if=question.isLatex>{{choice.desc}}</b> <b class=correct-ans-mcq ng-if=!question.isLatex>{{choice.desc}}</b> </label> </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" ng-src={{setFilePath(img)}} style=max-width:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=FIB|IBT_FIB ng-switch-when-separator=| layout=column> <div layout=column flex> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p>{{$index+1}} ) <span class=composed_dom ng-bind-html=beautifyFIB(question.qn_desc)|safeHtml></span> &nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div ng-repeat=\"choice in question.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\">{{question.my_answer[$index]}}</b> </label> <label ng-if=choice.wrong>Your Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{question.my_answer[$index]}}</b> Correct Answer {{$index+1}} - <b class=correct-ans-mcq>{{choice.desc}}</b> </label> </div> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" ng-src={{setFilePath(img)}} style=max-width:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=MTF layout=column> <div layout=column flex> <div layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark type=text /> </div> </div> <div layout=row> <p>{{$index+1}} ) Match the following questions and answers &nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div flex layout=row> <div flex=30 layout=column> Question: <div ng-if=!quest.no_question class=md-whiteframe-2dp ng-repeat=\"quest in question.option\" layout=row style=margin:5px;height:60px> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:15px;background:#fff;margin:0;font-size:14px!important class=question_desc ng-if=question.isLatex>{{quest.question.desc}}</label> <label flex style=padding:5px;height:60px;overflow:auto;float:left;background:#fff;margin:0;font-size:14px!important ng-if=!question.isLatex><span class=composed_dom ng-bind-html=quest.question.desc|safeHtml></span></label> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(quest.question.questionImg)) flex ng-src={{setFilePath(quest.question.questionImg)}} ng-if=quest.question.questionImg class=mtf-question-img /> </div> </div> <div flex=30 layout=column> Correct Answer: <div ng-if=!quest.no_question class=md-whiteframe-2dp ng-repeat=\"quest in question.option\" layout=row style=margin:5px;height:60px> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:5px;background:#fff;margin:0;font-size:14px!important;overflow:auto;float:left class=question_desc ng-if=question.isLatex>{{quest.answer.desc}}</label> <label flex style=padding:5px;height:60px;overflow:auto;float:left;background:#fff;margin:0;font-size:14px!important ng-if=!question.isLatex>{{quest.answer.desc}}</label> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(quest.answer.optImage)) flex ng-src={{setFilePath(quest.answer.optImage)}} ng-if=quest.answer.optImage class=mtf-question-img /> </div> </div> <div flex=30 layout=column ng-if=\"question.ans_key.length>0\">Student Answer: <div ng-if=answer.needed ng-repeat=\"answer in question.ans_key\" class=md-whiteframe-2dp layout=row style=margin:5px;height:60px> <label style=padding:7px;width:25px;background:#009688;color:#fff;margin:0;font-size:14px!important>{{$index+1}}</label> <label style=padding:5px flex class=\"mtf_answer question_desc\" ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : !answer.correct}\" ng-if=question.isLatex>{{answer.desc}}</label> <label style=padding:5px;height:60px;overflow:auto;float:left flex class=mtf_answer ng-if=!question.isLatex ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : !answer.correct}\">{{answer.desc}}</label> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(answer.optImage), answer, question, $index)\" flex ng-src={{setFilePath(answer.optImage)}} ng-if=answer.optImage class=mtf-question-img /> <span layout=column ng-if=answer.optImage> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=SA layout=column> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\" type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-disabled=\"questionPaper.status=='published'\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div flex layout=row> <div flex=90></div> <div flex=10>{{question.mark_error}}</div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp;</p> <p ng-if=!question.isLatex>{{$index+1}} )<span class=composed_dom ng-bind-html=question.qn_desc|safeHtml></span>&nbsp; </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=float:right;color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex ng-if=question.value_points[0]> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Value Points </b></p> <div class=txt-area-box ng-if=question.showHint ng-repeat=\"keyValue in question.value_points\" style=background-color:#f0f8ff> <p class=question_desc ng-if=question.isLatex>{{$index+1}} . {{keyValue.name}} </p> <p ng-if=!question.isLatex>{{$index+1}} . {{keyValue.name}}</p> </div> </div> <div flex layout-align=\"start center\" ng-if=\"question.my_answer && question.my_answer.length>0\"> Student: <br/> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(question.answerImg), answer, question, $index)\" flex ng-src={{setFilePath(question.answerImg)}} style=max-width:600px;max-height:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" ng-src={{setFilePath(img)}} style=max-width:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> <div flex> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=LA layout=column> <div flex layout=row> <div flex=90 layout=column> <div style=font-size:18px!important;padding-left:10px;font-weight:700>{{question.title}}</div> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\" style=margin:10px> <div flex=40 ng-repeat=\"img in question.passage_image track by $index\"> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-width:400px;max-height:200px> </div> </div> </div> <div flex=10 layout=row> <input class=policy type=text decimal-numbers-only ng-model=question.my_score ng-disabled=\"questionPaper.status=='published'\" ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div flex layout=row> <div flex=90></div> <div flex=10>{{question.mark_error}}</div> </div> <div layout=row> <p class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}&nbsp; </p> <p ng-if=!question.isLatex>{{$index+1}} )&nbsp; <span class=composed_dom ng-bind-html=\"data=conertToHtml(question.qn_desc)\"></span> </p> <p ng-class=\"{'attended' : question.is_attended,'not-attended':!question.is_attended}\">({{question.attendedStatus}})</p> <div style=color:#56ce59 ng-if=\"status!='published'\" class=\"preview-image addCmt\" ng-click=\"addComment(question._id,$parent.$parent.$index, section, question.qn_mark, true, question)\"> <i style=float:right;cursor:pointer class=\"fas fa-comment\"></i>Add Comment </div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex ng-if=question.value_points[0]> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Value Points</b></p> <div class=txt-area-box ng-if=question.showHint ng-repeat=\"keyValue in question.value_points\" style=background-color:#f0f8ff> <p class=question_desc ng-if=question.isLatex>{{$index+1}} . {{keyValue.name}} </p> <p ng-if=!question.isLatex>{{$index+1}} . {{keyValue.name}}</p> </div> </div> <div flex layout-align=\"start center\" ng-if=\"question.my_answer && question.my_answer.length > 0\"> Student: <br/> <pre class=message-text>{{question.my_answer}}</pre> </div> <div ng-if=\"question.answerImg && isString(question.answerImg)\"> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" ng-src={{setFilePath(img)}} style=max-width:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> <div layout=row layout-wrap ng-if=\"question.answerImg && !isString(question.answerImg)\"> <div flex=40 ng-repeat=\"img in question.answerImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" ng-src={{setFilePath(img)}} style=max-width:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> <div class=comment_box ng-if=question.comment flex layout=column> <label><p><b style=color:red>Teacher Comment</b></p></label><div flex>{{question.comment}}</div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=DRAW layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc>{{$index+1}} ) {{question.qn_desc}}</b> </p> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div flex layout=row> <div flex=90></div> <div flex=10>{{question.mark_error}}</div> </div> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=40 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px ng-if=img> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(img)) ng-src={{setFilePath(img)}} style=max-width:400px> </div> </div> <div flex layout-align=\"start center\" ng-if=question.answerImg> Student: <br/> <img title=\"Click here to appear large\" class=hand_on_img ng-click=\"showImagepopUpWithCanvas(setFilePath(img), answer, question, $index)\" flex src={{setFilePath(question.answerImg)}} style=max-width:600px;max-height:400px> <span layout=column> <a href=\"{{fileServerUrl+question['original_images']['images'][$index]}}\" target=_blank download> View Original </a> </span> </div> </div> <div flex> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLLISTEN layout=column> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{question.qn_desc}}</b> </p> <div ng-if=question.audio_url class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.audio_url)}}></audio> </div> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section, question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div flex layout=row> <div flex=90></div> <div flex=10>{{question.mark_error}}</div> </div> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(question.questionImg)) flex ng-src={{setFilePath(question.questionImg)}} class=question-img ng-if=question.questionImg /> <div ng-repeat=\"answer in question.questions\" flex> <div ng-switch=answer.type> <div ng-switch-when=mcq> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(answer.questionImg)) flex ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=question.isLatex class=question_desc>{{choice.tag}}){{ choice.desc }} <img class=hand_on_img ng-click=showImagepopUp(setFilePath(choice.optImage)) flex ng-src={{setFilePath(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> <div ng-value=choice ng-disabled=false ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" ng-if=!question.isLatex>{{choice.tag}}){{ choice.desc }} <img title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(choice.optImage)) flex ng-src={{setFilePath(choice.optImage)}} class=option-img ng-if=choice.optImage /> </div> </div> </div> </div> <div ng-switch-when=tf layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p> <b class=question_desc ng-if=question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> <b ng-if=!question.isLatex>{{$index+1}} ) {{answer.qn_desc}}</b> </p> </div> </div> <img flex title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(answer.questionImg)) ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding-left:10px;padding-right:10px;padding-top:10px> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" class=question_desc ng-if=question.isLatex>{{choice.tag}} </div> <div ng-disabled=false ng-value=choice.tag aria-label={{choice.tag}} ng-class=\"{'selected-wrong-mcq' : choice.wrong,'correct-ans-mcq' : choice.correct}\" ng-if=!question.isLatex>{{choice.tag}} </div> </div> </div> </div> </div> <div ng-switch-when=fib layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <b>{{$index+1}} ) {{beautifyFIB(answer.qn_desc)}}</b> </div> </div> <img flex title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(answer.questionImg)) ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div ng-repeat=\"choice in answer.answer\"> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=choice.desc> <label ng-if=choice.correct>Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" class=question_desc>{{answer.my_answer[$index]}}</b></label> <label ng-if=choice.wrong>Your Answer {{$index+1}} - <b ng-class=\"{'correct-ans-mcq' : choice.correct,'selected-wrong-mcq' : choice.wrong}\" style=padding-right:20px>{{answer.my_answer[$index]}}</b> Correct Answer {{$index+1}} - <b class=\"correct-ans-mcq question_desc\">{{choice.desc}}</b></label> </div> </div> </div> </div> <div ng-switch-when=audio layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <div> <div flex ng-if=answer.answer> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"answer.showHint = answer.showHint?false:true;\"><b style=color:green>{{answer.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=answer.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(answer.answer)}}></audio> </div> </div> <div flex layout-align=\"start center\" ng-if=answer.my_answer> Student: <br/> <div class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(answer.my_answer)}}></audio> </div> </div> </div> </div> </div> <div ng-switch-when=text layout=row> <div layout=column flex> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{answer.qn_desc}}</b></p> </div> </div> <img flex title=\"Click here to appear large\" class=hand_on_img ng-click=showImagepopUp(setFilePath(answer.questionImg)) ng-src={{setFilePath(answer.questionImg)}} class=question-img ng-if=answer.questionImg /> <div layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <label ng-if=answer.correct>Answer - <b ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : answer.wrong}\" class=question_desc>{{answer.my_answer}}</b></label> <label ng-if=!answer.correct>Your Answer - <b ng-class=\"{'correct-ans-mcq' : answer.correct,'selected-wrong-mcq' : answer.wrong}\" style=padding-right:20px class=question_desc>{{answer.my_answer}}</b> Correct Answer - <b class=\"correct-ans-mcq question_desc\">{{answer.answer}}</b></label> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLSPEAK layout=column> <div flex layout=row> <div flex=90> <p><b class=question_desc>{{$index+1}} ) {{question.qn_desc}}</b></p> </div> <div flex=10 layout=row> <input class=policy type=text txt-maxlength=5 decimal-numbers-only ng-model=question.my_score ng-change=\"markValidation(question._id,$parent.$parent.$index, section,question.qn_mark)\"/>&nbsp; <p class=slash>/</p> &nbsp; <input ng-disabled=true class=policy ng-model=question.qn_mark numbers-only type=text /> </div> </div> <div flex layout=row> <div flex=90></div> <div flex=10>{{question.mark_error}}</div> </div> <div layout=column flex> <div flex ng-if=question.ans_audio_url> <p style=font-size:1.2rem;color:grey;outline:0;cursor:pointer ng-click=\"question.showHint = question.showHint?false:true;\"><b style=color:green>{{question.showHint?\"Hide\":\"View\"}} Sample Audio</b></p> <div ng-if=question.showHint class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.answer)}}></audio> </div> </div> <div flex layout-align=\"start center\" ng-if=question.my_answer> Student: <br/> <div class=md-whiteframe-2dp flex=35> <audio controls ng-src={{setFilePath(question.my_answer)}}></audio> </div> </div> </div> </div> </div> </div> <md-divider ng-repeat-end ng-if=!$last style=\"padding:5px 0;margin:5px 0\"></md-divider> </div> </div> </div> <div class=\"answer-preview mtf-answer-border md-whiteframe-2dp\" layout=column style=\"margin-bottom:65px;border:2px solid #00b6ec\"> <div ng-if=\"status!='published'\"> <md-input-container style=width:100%> <label>You can add comment here if you wish</label> <textarea md-maxlength=150 maxlength=150 ng-model=comment_obj.comment md-autofocus></textarea> <error-msg class=redAlert msg=errors.commentItem></error-msg> </md-input-container> </div> <div ng-if=\"status=='published'\" class=comment_box flex layout=column> <label><p><b style=color:red>Overall activity comment</b></p></label><div flex>{{comment_obj.comment}}</div> </div> </div> </div> <div class=\"qpPreview answer-preview\" layout=column style=margin-bottom:65px ng-if=pdfData> <iframe id=myCanvasImage ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px ng-if=!canvasData allowfullscreen></iframe> <canvas id=canvasArea style=\"width:650px;height:550px;cursor:url(../../../img/activity/pen_3.png),default;border:1px solid\" ng-if=canvasData> Your browser does not support the HTML5 canvas tag. </canvas> </div> <footer class=footer style=background:#1665c1;padding:5px> <div layout=row layout-align=\"center center\"> <div layout=row style=cursor:pointer layout-align=\"center center\" ng-click=saveMark() ng-if=!pdfData> <span class=md-whiteframe-2dp style=\"background:#3266c1;padding:5px 16px;border-radius:24px;border:2px solid #fff\"> <i tooltip=Save style=color:#fff;font-size:20px;float:left tooltip-position=down class=\"save-icon far fa-save\"> </i> <span style=color:#fff;font-size:16px;padding-left:4px;padding-bottom:7px;position:relative> save </span> </span> </div> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=pdfData ng-click=backToHtml()> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative>Back</span> <span class=\"hand footer-circle-button\"> <i class=\"fas fa-chevron-left\" class=\"ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:6px></i> </span> </span> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=\"pdfData && canvasData\" ng-click=clearCanvas(url)> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative>Reset </span> </span> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=\"pdfData && canvasData\" ng-click=saveCanvasImage()> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative>Update </span> </span> </div>  </footer> ";

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _addComment = __webpack_require__(928);

var _addComment2 = _interopRequireDefault(_addComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: qpSummary.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-13
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var TeacherAnswerController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", "$window", "$http", function TeacherAnswerController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce, $window, $http) {
    _classCallCheck(this, TeacherAnswerController);

    var authoring = localStorageService.get("authoringData");
    var qpId = $state.params.qpId;
    var studentId = $state.params.studentId;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    $scope.isLoading = true;
    $scope.fileServerUrl = CONSTANTS.FILE_UPLOAD_URL;
    $scope.comment = undefined;
    $scope.comment_obj = {};
    $scope.status = undefined;
    $scope._is_creator = false;
    this.$onInit = function () {
        $scope.comment = undefined;
        $scope.comment_obj = {};
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getPrivileges();
        if (authoring) {
            $rootScope.authMenu = true;
            $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject;
        } else {
            $state.go("authdashboard");
        }
    };
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope.activityUserPrivilege = {};
    function getPrivileges() {
        try {
            if (userAccess.length > 0) {
                _.each(userAccess, function (tpObj) {
                    var user_access = {};
                    _.each(tpObj.privilege, function (privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status;
                    });
                    $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
    function checkPrivilegeToUpdate(result) {
        if ($scope.activityUserPrivilege && $scope.activityUserPrivilege.createActivity && $scope.activityUserPrivilege.createActivity.create && result && result.teacher_id && result.teacher_id == userId) {
            $scope._is_creator = true;
        }
    }
    authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.details) {
            try {

                var result = response.result.data.details;
                checkPrivilegeToUpdate(result);
                $scope.status = result.activity_status;
                if (result.status) {
                    $scope.status = result.status;
                }
                $scope.student_user_doc = result.student_user_doc;
                var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
                $scope.my_score = 0;
                $scope.totalmark = 0;
                $scope.quesCount = 0;
                var myScore = 0;
                if (result && result.comment) {
                    $scope.comment_obj.comment = result.comment;
                }
                $scope.isTeacherEvaluation = false;
                _.each(result.consolidatedData, function (sec) {
                    delete sec.questions;
                    _.each(sec.answers, function (ans) {
                        if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                            $scope.quesCount++;
                        }
                        $scope.totalmark = ans.total_mark;
                        if (!isNaN(ans.my_score)) {
                            myScore = parseFloat(myScore) + parseFloat(ans.my_score);
                            myScore = myScore.toFixed(2);
                            $scope.my_score = myScore;
                        }
                    });
                });
                /*if ($scope.quesCount > 0 && $scope.questionPaper.status != 'published')
                    $scope.isTeacherEvaluation = true*/
                $scope.questions = result.consolidatedData;
                //For teaching plan activity
                $scope.teachingPlanId = result.plan_id;
                $scope.qpDetails = {
                    question_paper_title: result.question_paper_title,
                    subject: authoring.subject,
                    class: authoring.class,
                    time: result.time,
                    due_date: result.due_date
                };
                $scope.isLoading = false;
                setTimeout(function () {
                    $scope.loadLatex();
                }, 100);
                setChoice();
            } catch (ex) {
                console.log(ex);
            }
        } else {
            // toastr.error('Network Error. Please try later');
        }
        _.defer(function () {
            $scope.$apply();
        });
    });
    //To get school details
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            console.log(result);
            $scope.qpHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'subject': authoring.subject,
                'class': authoring.class
            };
            _.defer(function () {
                $scope.$apply();
            });
        } else {
            //error
        }
    });

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }
    /* Set answered choice is wrong or correct*/
    function setChoice() {
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (data, key) {

                $scope.total_mark += parseFloat(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    _.each(data.choice, function (choice) {
                        if ($scope.checkingChoiceExists(choice.desc, data)) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                        }
                    });
                } else if (data.type == 'TF') {
                    _.each(data.choice, function (choice) {
                        if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        }
                    });
                } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    _.each(data.answer, function (choice) {
                        /**OWQ auto evaluation of multiple answers starts */
                        // let correctAnswer = removeSpecialCharacter(choice.desc)
                        var correctAnswer = choice.desc;
                        var answer_as_array = correctAnswer.split(",");

                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key2]);
                            if (answer_as_array.length) {
                                for (var a = 0; a < answer_as_array.length; a++) {
                                    var one_qb_ans_str = answer_as_array[a];
                                    if (one_qb_ans_str) {
                                        one_qb_ans_str = one_qb_ans_str.toLowerCase().trim();
                                        if (studentAnswer.toLowerCase().trim() == one_qb_ans_str) {
                                            choice.correct = true;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                            // if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                            //     choice.wrong = true
                            // } else {
                            //     choice.correct = true
                            // }
                            /**OWQ auto evaluation of multiple answers ends */
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var needed = true;
                        if (!choice.question.desc) {
                            choice['no_question'] = true;
                            needed = false;
                        }
                        var correctAnswer = removeSpecialCharacter(choice.answer.desc);
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key3].desc);
                            if (correctAnswer !== studentAnswer) {
                                correct = false;
                            } else {
                                correct = true;
                            }
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage,
                                needed: needed
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacter(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                } else {
                                    choice.wrong = true;
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacter(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacter(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    aslListQues.wrong = true;
                                } else {
                                    aslListQues.correct = true;
                                }
                            } else {
                                aslListQues.wrong = true;
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
        console.log($scope.questions);
    }
    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };
    $scope.gotoQpPreview = function () {
        $state.go('qpSummary', {
            qpId: qpId
        });
    };
    $scope.markValidation = function (questionId, sectionIndex, section, qnMark) {
        var answersMarkCount = 0;
        _.each(section.answers, function (data) {
            if (parseFloat(data.my_score) > 0) {
                answersMarkCount++;
            }
        });
        if (answersMarkCount > section.mandatory_no) {
            var _questionIndex = section.answers.findIndex(function (i) {
                return i._id === questionId;
            });
            section.answers[_questionIndex].my_score = 0;
            toastr.error(" You have already entered the marks all mandatory question");
            section.answers[sectionIndex];
        };
        var actualScore = 0;
        var totalScore = qnMark;
        var questionIndex = $scope.questions[sectionIndex].answers.findIndex(function (i) {
            return i._id === questionId;
        });
        if (questionIndex > -1) {
            actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score;
        }
        if (actualScore > totalScore) $scope.questions[sectionIndex].answers[questionIndex].my_score = 0;
    };
    $scope.saveMark = function () {
        var errorCount = 0;
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (quest) {
                //mark_each_qn changed to qn_mark
                //For individual mark  for each question
                //Developer-Raziya
                quest.qn_mark = parseFloat(quest.qn_mark);
                if (quest.my_score > quest.qn_mark) {
                    quest.mark_error = "Enter the mark less than total mark";
                    errorCount++;
                }
            });
        });
        if (errorCount > 0) {
            toastr.error("Check the marks");
        } else {
            var requestObj = {
                questions: $scope.questions,
                student_id: studentId,
                question_paper_id: qpId,
                user_id: userId,
                authoring_data: authoring,
                comment: $scope.comment_obj.comment
            };
            console.log(requestObj);
            authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function (response) {
                if (response.result && response.result.data && response.result.data.message) {
                    try {
                        var result = response.result.data.message;
                        toastr.success(result);
                        if ($scope.teachingPlanId !== null) {
                            $state.go("submissionList", {
                                qpId: qpId
                            });
                        } else {
                            $state.go("viewSubmissionList", {
                                qpId: qpId
                            });
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };
    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }
    $scope.setFilePath = function (img) {
        if (!img) {
            return undefined;
        }
        var isValid = validURL(img);
        var new_url = undefined;
        if (!isValid) {
            new_url = CONSTANTS.FILE_UPLOAD_URL + img;
        } else {
            var splitValidUrl = img.split("uploads");
            if (splitValidUrl && splitValidUrl.length && splitValidUrl.length == 2) {
                new_url = CONSTANTS.FILE_UPLOAD_URL + "/uploads" + splitValidUrl[1];
            } else {
                new_url = undefined;
            }
        }
        return new_url;
    };

    $scope.beautifyFIB = function (question) {
        return question.toString().replace(/_/g, " _______ ");
    };
    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };

    $scope.showImagepopUpWithCanvas = function (url, answer, question, image_index) {
        console.log(question['answerImg'][image_index]);
        $scope.answerDetails = {
            school_id: schoolId,
            qp_id: qpId,
            question: question,
            student_id: studentId,
            question_id: question._id,
            image_index: image_index,
            current_url: url,
            new_url: "/uploads/dR6YPLMmGngGhysiY/question/file_1589974617305.png"
        };

        var canvas = document.getElementById("canvasArea");
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        canvas.width = 650;
        canvas.height = 550;

        var ctx = canvas.getContext("2d");

        var imageObj = new Image();
        imageObj.onload = function () {
            var maxHeight = 550;
            var maxWidth = 650;

            var height = this.height;
            var width = this.width;

            // calculate the width and height, constraining the proportions
            if (width > height) {
                if (width > maxWidth) {
                    height = Math.round(height *= maxWidth / width);
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width = Math.round(width *= maxHeight / height);
                    height = maxHeight;
                }
            }

            ctx.drawImage(this, 0, 0, width, height);
        };
        imageObj.crossOrigin = 'Anonymous';
        imageObj.src = url;

        document.addEventListener('mousemove', draw);
        document.addEventListener('mousedown', setPosition);
        document.addEventListener('mouseenter', setPosition);

        var pos = { x: 0, y: 0 };
        function setPosition(e) {
            pos.x = e.clientX - 10;
            pos.y = e.clientY - 60;
        }
        function draw(e) {
            // mouse left button must be pressed
            if (e.buttons !== 1) return;
            ctx.beginPath(); // begin
            ctx.lineWidth = 2;
            ctx.lineCap = 'round';
            ctx.strokeStyle = '#c0392b';
            ctx.moveTo(pos.x, pos.y); // from
            setPosition(e);
            ctx.lineTo(pos.x, pos.y); // to
            ctx.stroke(); // draw it!
        }

        $scope.canvasData = true;
        $scope.pdfData = false;
        var isValid = validURL(url);
        isValid = true;
        if (isValid) {
            $scope.url = $sce.trustAsResourceUrl(url);
            $scope.pdfData = true;
        }
    };

    $scope.showImagepopUp = function (url) {

        $scope.canvasData = false;
        $scope.pdfData = false;
        var isValid = validURL(url);
        if (isValid) {
            $scope.url = $sce.trustAsResourceUrl(url);
            $scope.pdfData = true;
        }
    };
    $scope.backToHtml = function () {
        $scope.pdfData = false;
        $scope.canvasData = false;
        $scope.url = undefined;
    };

    $scope.saveCanvasImage = function () {
        var canvas = document.getElementById('canvasArea');
        $scope.answerDetails.imgUrl = canvas.toDataURL('image/png');
        console.log($scope.answerDetails);
        authService.callAPI("/v0/traditional/teacher/comment/image", "POST", $scope.answerDetails, function (response) {
            console.log(response);
            var imgUrl = $scope.answerDetails.current_url;
            try {
                imgUrl = response.result.data.imgUrl;
            } catch (ex) {
                console.log(ex);
            }
            console.log($scope.answerDetails.question);
            $scope.answerDetails.question['answerImg'][$scope.answerDetails.image_index] = imgUrl;
            toastr.success("Updated the image");
        });
    };

    $scope.clearCanvas = function (url) {
        var canvas = document.getElementById("canvasArea");
        canvas.width = 650;
        canvas.height = 550;

        var ctx = canvas.getContext("2d");
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

        var imageObj = new Image();
        imageObj.onload = function () {
            var maxHeight = 550;
            var maxWidth = 650;

            var height = this.height;
            var width = this.width;

            // calculate the width and height, constraining the proportions
            if (width > height) {
                if (width > maxWidth) {
                    height = Math.round(height *= maxWidth / width);
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width = Math.round(width *= maxHeight / height);
                    height = maxHeight;
                }
            }

            ctx.drawImage(this, 0, 0, width, height);
        };
        imageObj.crossOrigin = 'Anonymous';
        imageObj.src = url;
    };

    $scope.addComment = function (questionId, sectionIndex, section, qnMark, isMcq, mcq_question) {
        showMetadataPopUp(questionId, sectionIndex, section, isMcq, mcq_question);
    };
    function showMetadataPopUp(questionId, sectionIndex, section, isMcq, mcq_question) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', 'questionId', 'sectionIndex', 'section', 'questions', 'isMcq', 'mcq_question', AddCommentInAnswerCtrl],
            locals: {
                parentScope: $scope,
                questionId: questionId,
                sectionIndex: sectionIndex,
                section: section,
                questions: $scope.questions,
                isMcq: isMcq,
                mcq_question: mcq_question
            },
            template: _addComment2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    }
    $scope.saveCommentInAnswer = function (questionId, sectionIndex, section, comment, isMcq, mcq_question) {
        if (!isMcq) {
            var questionIndex = $scope.questions[sectionIndex].answers.findIndex(function (i) {
                return i._id === questionId;
            });
            if ($scope.questions[sectionIndex].answers[questionIndex]) {
                $scope.questions[sectionIndex].answers[questionIndex]['comment'] = comment;
            }
        } else {
            mcq_question['comment'] = comment;
        }
    };
    $scope.conertToHtml = function (string) {
        // string = "<span style='color: #89a000'>123</span>"
        return $sce.trustAsHtml(string);
    };
}];

exports.default = TeacherAnswerController;

var AddCommentInAnswerCtrl = function AddCommentInAnswerCtrl($scope, $mdDialog, parentScope, questionId, sectionIndex, section, questions, isMcq, mcq_question) {
    _classCallCheck(this, AddCommentInAnswerCtrl);

    $scope.metadata = {};
    $scope.answer = {};

    if (!isMcq) {
        var questionIndex = parentScope.questions[sectionIndex].answers.findIndex(function (i) {
            return i._id === questionId;
        });
        if (parentScope.questions[sectionIndex].answers[questionIndex]) {
            $scope.answer = parentScope.questions[sectionIndex].answers[questionIndex];
        }
    } else {
        $scope.answer = mcq_question;
    }

    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.addComment = function () {
        parentScope.saveCommentInAnswer(questionId, sectionIndex, section, $scope.answer.comment, isMcq, mcq_question);
        $mdDialog.hide();
    };
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.singleMCQ input[type=radio]{border:0;width:100%;height:2em}</style> <div class=question-directive ng-repeat=\"question in questionsSet track by $index\" ng-cloak ng-if=\"$index == scope.indexToShow\"> <div ng-switch=question.type> <div ng-switch-when=MCQ|IBT_MCQ ng-switch-when-separator=|> <div ng-switch=question.pattern> <div ng-switch-when=multiple layout=column> <div class=pass-con ng-if=question.passage> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <p ng-if=\"question.type=='IBT_MCQ'\" style=float:left;word-break:break-all;white-space:normal>{{question.passage}}</p> </div> </div> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <div> <span ng-show=question.isLatex class=question_desc style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(question.qn_desc)\"></span></span> </div> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div layout=row flex ng-repeat=\"choice in question.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px ng-show=scope.isPracticeTest> <div ng-if=question.is_single_pattern layout=row class=singleMCQ> <input style=width:18px class=radioBtnInput ng-value=choice type=radio ng-checked=choice.isChecked ng-click=\"check($event, choice.isChecked, $index, question, choice)\"> <span ng-show=question.isLatex class=question_desc style=float:left;margin-top:10px>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left;margin-top:10px>{{choice.desc}}</span> </div> <md-checkbox ng-if=!question.is_single_pattern type=checkbox ng-value=choice ng-checked=scope.checkingChoiceExists(choice.desc) ng-click=\"scope.setSelectedAns(choice.desc,'MR')\" class=\"question-outline cntr-checkbox\"> <span ng-show=question.isLatex class=question_desc style=float:left>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left>{{choice.desc}}</span> </md-checkbox> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> </div> </div> <div style=margin-bottom:10px> <p class={{scope.errorMrQues[choice.desc].answerStatus}}> </p> </div> </div> <div layout=column flex layout-align=\"space-between start\" ng-repeat=\"choice in question.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px ng-show=!scope.isPracticeTest> <div ng-if=question.is_single_pattern layout=row class=singleMCQ> <input style=width:18px class=radioBtnInput ng-value=choice type=radio ng-checked=choice.isChecked ng-click=\"check($event, choice.isChecked, $index, question, choice)\"> <span ng-show=question.isLatex class=question_desc style=float:left;margin-top:10px>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left;margin-top:10px>{{choice.desc}}</span> </div> <md-checkbox ng-value=choice ng-if=!question.is_single_pattern ng-checked=scope.checkingChoiceExists(choice.desc) ng-click=\"scope.setSelectedAns(choice.desc,'MR');checkIfAnswerd(question)\" class=\"question-outline cntr-checkbox\"> <span ng-show=question.isLatex class=question_desc style=float:left>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left>{{choice.desc}}</span> </md-checkbox> <div class=width_100 layout=row layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <div style=margin-bottom:10px> <p class={{scope.errorMrQues[choice.desc].answerStatus}}> </p> </div> </div> <div layout=row layout-align=\"end end\"> <md-button ng-disabled=!question.answer_exists class=\"md-raised md-primary\" ng-click=resetMCQAns(question)>Clear selection </md-button> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=TF> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(question.qn_desc)\"></span></span> <span ng-show=question.isLatex class=question_desc style=float:left>{{question.qn_desc}}</span> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.selectedAns[scope.indexToShow] flex ng-show=scope.isPracticeTest> <md-radio-button ng-show=\"$index==0\" value=True ng-click=\"scope.setSelectedAns(True,'TF')\" name=radio class=\"question-outline cntr-checkbox\" aria-label=True>True </md-radio-button> <md-radio-button ng-show=\"$index==1\" value=False ng-click=\"scope.setSelectedAns(False,'TF')\" name=radio class=\"question-outline cntr-checkbox\" aria-label=False>False </md-radio-button> </md-radio-group> <md-radio-group ng-model=scope.selectedAns[scope.indexToShow] flex ng-show=!scope.isPracticeTest> <md-radio-button value=True ng-show=\"$index==0\" ng-click=\"scope.setSelectedAns('True','TF')\" class=question-outline aria-label=True>True </md-radio-button> <md-radio-button value=False ng-show=\"$index==1\" ng-click=\"scope.setSelectedAns('False','TF')\" class=question-outline aria-label=False>False </md-radio-button> </md-radio-group> <div style=margin-bottom:5px> <p class={{scope.errorTFQues[choice.tag].answerStatus}}> </p> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=FIB|IBT_FIB ng-switch-when-separator=|> <div class=pass-con> <div class=pass-sub-con layout=column> <h3 ng-if=question.title style=margin:0>{{question.title}}</h3> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal;margin:0 class=composed_dom ng-bind-html=question.passage></p> <p ng-if=\"question.type=='IBT_FIB'\" style=float:left;word-break:break-all;white-space:normal;margin:0>{{question.passage}}</p> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(beautifyFIB(question.qn_desc))\"></span></span> <span ng-show=question.isLatex class=question_desc style=float:left>{{beautifyFIB(question.qn_desc)}}</span> <div layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=30 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=width:200px;height:150px;float:left> </div> </div> </div> </div> <div> <div layout=row layout-align=\"end end\"> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:0.5, ratio: '1:1.2',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> <div ng-repeat=\"choice in question.question_answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=\"choice.desc!=undefined\"> <md-input-container class=md-block flex-gt-sm> <div> <label>Enter Answer {{$index+1}}</label> <input stopccp ng-model=scope.ansFib[scope.indexToShow].choice[$index] ng-change=\"scope.setSelectedAns('enteredAns','FIB')\" autocomplete=off> </div> </md-input-container> <div style=margin:5px> <p class={{scope.errorFib[choice.desc].answerStatus}}> </p> </div> </div> </div> <div class=width_100 layout=row layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)></span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=OWQ> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(question.qn_desc)\"></span></span> <span ng-show=question.isLatex class=question_desc style=float:left> {{question.qn_desc}} </span> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div ng-repeat=\"choice in question.question_answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=\"choice.desc!=undefined\"> <md-input-container class=md-block flex> <div> <label>Enter One Word Answer</label> <input stopccp ng-model=scope.ansOwq[scope.indexToShow] ng-change=\"scope.setSelectedAns('enteredAns','OWQ')\" autocomplete=off> </div> </md-input-container> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:0.5, ratio: '1:1.2',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> <div style=margin:5px> <p class={{scope.errorOwq[choice.desc].answerStatus}}> </p> </div> </div> <div class=width_100 layout=row layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=SA> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(question.qn_desc)\"></span></span> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div layout=row flex layout-xs=column ng-repeat=\"imgItem in uploadData\" ng-show=online> <div flex=60> <md-input-container style=width:100%> <label>{{imgItem.title}}</label> <input ng-model=question.image_title autocomplete=off> </md-input-container> </div> <div flex> <md-button class=md-raised ng-click=loadPopUp(question,$index) ng-disabled=\"question.image_title==undefined\">Upload</md-button> </div> </div> <div layout=row flex layout-align=\"start center\"> <div layout=column flex> <div layout=row flex layout-align=\"start center\"> <div flex=90> <md-input-container style=width:100%> <div> <label>Enter Answer</label> <textarea stopccp focus-it=true name=notes ng-model=scope.ansSa[scope.indexToShow]></textarea> </div> </md-input-container> </div> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:0.5, ratio: '1:1.2',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> </div> <div class=width_100 layout=row layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> <div flex ng-repeat=\"imgObj in imageData[$index].images\"> <div flex style=overflow:auto;padding:5px layout-align=\"center center\"> <img flex src={{imgObj.image_url}} style=max-width:600px;max-height:400px> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=LA> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div class=width_100 layout=row layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span class=question_desc ng-if=question.isLatex style=float:left> {{question.qn_desc}}</span> <span ng-if=!question.isLatex style=float:left><span class=composed_dom ng-bind-html=\"data=uCanTrust(question.qn_desc)\"> </span></span> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} style=max-height:150px ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div layout=row flex layout-xs=column ng-repeat=\"imgItem in uploadData\" ng-show=online> <div flex=60> <md-input-container style=width:100%> <label>{{imgItem.title}}</label> <input ng-model=question.image_title autocomplete=off> </md-input-container> </div> <div flex> <md-button class=md-raised ng-click=loadPopUp(question,$index) ng-disabled=\"question.image_title==undefined\">Upload</md-button> </div> </div> <div layout=row flex layout-align=\"start center\"> <div layout=column flex> <div layout=row flex layout-align=\"start center\"> <div flex=90> <md-input-container flex style=width:100%> <div> <label>Enter Answer</label> <textarea stopccp class=answer-text-field focus-it=true name=notes ng-model=scope.ansLa[scope.indexToShow]></textarea> </div> </md-input-container> </div> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:0.5, ratio: '1:1.2',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> </div> <div layout=row layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> <div flex ng-repeat=\"imgObj in imageData[$index].images\"> <div flex style=overflow:auto;padding:5px layout-align=\"center center\"> <img flex src={{imgObj.image_url}} style=max-width:600px;max-height:400px> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=DRAW> <div class=pass-con> <div class=pass-sub-con layout=column> <span style=float:left>{{question.qn_desc}}</span> <img flex ng-src={{setFilePath(question.questionImg)}} class=question-img ng-click=showImage(setFilePath(question.questionImg)) /> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div flex layout=row layout-align=\"space-around center\"> <div ng-repeat=\"toolData in tools\" layout=row layout-align=\"center center\"> <div layout=row layout-align=\"start center\" ng-click=setTools(toolData.tool,toolData) ng-class=\"{'pdfControlSelected':toolData.expanded,'pdfControls':!toolData.expanded}\"> <md-button class=\"md-fab md-mini footer-circle-button\" aria-label=Add ng-class=\"{'pdfBtnSelected':toolData.expanded,'pdfBtn':!toolData.expanded}\"> <img src={{toolData.icon}} class=result-icon-button alt=Attendance> </md-button> </div> </div> <ng-color-picker selected=selected></ng-color-picker> </div> </div> <md-divider></md-divider> <div flex layout=column style=background:#fff> <div> <div flex layout-align=\"center center\"> <img style=max-width:600px;max-height:400px ng-if=online flex src={{quesTypes[0].imageUrl}} ng-click=showImage(quesTypes[0].imageUrl)> </div> <div flex layout-align=\"center center\"> <canvas id={{question.canvasId}} class=canvas flex width=600 height=400 style=background-color:#000;width:600px!important;max-width:600px;height:auto!important></canvas> <div layout=row layout-align=\"start center\" ng-click=uploadDrawing($index)> <md-button class=\"md-fab md-mini footer-circle-button\" aria-label=Add style=background:#1a97ab> <img src=" + __webpack_require__(413) + " class=result-icon-button alt=Attendance> </md-button> </div> <img ng-src={{setFilePath(question.answerImg)}} ng-click=showImage(setFilePath(question.answerImg))> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLSPEAK> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> </div> <div flex layout=row layout-align=space-between> <asl-voice-record flex=5></asl-voice-record> <div flex=40 ng-if=scope.ansAslSpeak[scope.indexToShow].answer class=\"md-whiteframe-2dp asl-audio-play\"> <audio controls ng-src={{setFilePath(scope.ansAslSpeak[scope.indexToShow].answer)}}></audio> </div> <div flex=40></div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLLISTEN> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> </div> <div flex=40 ng-if=question.playableQuestionUrl class=\"md-whiteframe-2dp asl-audio-play\" ng-init=playableQuestionUrl> <audio controls ng-src={{question.playableQuestionUrl}}></audio> </div> <div layout=column class=dictationspacediv layout-xs=row> <p class=asl-qn-inst> Answer the below question by listening the audio: </p> <div ng-repeat=\"answer in question.questions\" style=margin:5px> <div ng-switch=answer.type> <div ng-switch-when=mcq> <div ng-switch=answer.pattern> <div flex ng-switch-when=single> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer flex> <md-radio-button ng-value=choice.desc ng-click=\"scope.setSelectedAns(choice.desc,'ASLLISTEN','MCQ',$parent.$index)\" aria-label={{choice.desc}} class=\"question-outline cntr-checkbox\"> <span class=question_desc style=float:left>{{choice.desc}}</span> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </md-radio-button> </md-radio-group> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </div> </div> </div> </div> <div ng-switch-when=multiple layout=column> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div layout=row flex layout-align=\"space-between center\" ng-repeat=\"choice in answer.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px> <md-checkbox ng-value=choice ng-click=\"scope.setSelectedAns(choice.desc,'ASLLISTEN','MR',$parent.$index)\" class=question-outline> <span class=question_desc style=float:left>{{choice.desc}}</span> </md-checkbox> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </div> </div> </div> </div> </div> <div ng-switch-when=tf> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer flex> <md-radio-button ng-value=choice.tag ng-click=\"scope.setSelectedAns(choice.tag,'ASLLISTEN','TF',$parent.$index)\" class=\"question-outline cntr-checkbox\" aria-label={{choice.tag}}>{{choice.tag}} </md-radio-button> </md-radio-group> </div> </div> </div> </div> <div ng-switch-when=fib> <div class=qstn-con layout=column> <span style=float:left>{{beautifyFIB(answer.qn_desc)}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div ng-repeat=\"choice in answer.answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-input-container class=md-block flex-gt-sm> <span class=answer-field ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer[$index] style=height:auto autocomplete=off ng-init=\"formatToLatex(question.type,$parent.$index,'fib',$index)\" style=height:auto></span> </md-input-container> </div> </div> </div> </div> <div ng-switch-when=audio> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> </div> <div flex layout=row layout-align=space-between> <asl-voice-record flex=5 index=$index></asl-voice-record> <div flex=40 ng-if=scope.ansAslListen[scope.indexToShow].ans[$index].answer class=\"md-whiteframe-2dp asl-audio-play\"> <audio controls ng-src={{setFilePath(scope.ansAslListen[scope.indexToShow].ans[$index].answer)}}></audio> </div> <div flex=40></div> </div> </div> <div ng-switch-when=text> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> </div> <div> <md-input-container class=md-block flex-gt-sm> <span class=answer-field ng-model=scope.ansAslListen[scope.indexToShow].ans[$index].answer style=height:auto autocomplete=off ng-init=\"formatToLatex(question.type,$index,'text')\" style=height:auto></span> </md-input-container> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=MTF layout=column> <div class=pass-con> <div class=pass-sub-con layout=column> <p>Match the following Questions & Answers</p> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal class=composed_dom ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div flex layout=row> <div flex=45 layout=column> <div> <div ng-if=questions.question.desc ng-repeat=\"questions in question.option track by $index\" class=md-whiteframe-2dp layout=row style=margin:5px> <div layout=row> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;height:60px;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:5px;background:#fff;margin:0> <span ng-show=!question.isLatex style=font-size:14px!important>{{questions.question.desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left;overflow:auto;height:50px>{{questions.question.desc}}</span> </label> <img flex ng-src={{setFilePath(questions.question.questionImg)}} ng-if=questions.question.questionImg class=mtf-question-img ng-click=showImage(setFilePath(questions.question.questionImg)) /> </div> </div> </div> </div> <div flex=45 layout=column> <div as-sortable=dragControlListeners ng-model=question.optionAnswer> <div ng-repeat=\"answer in question.optionAnswer \" ng-init=\"sectionIndex = $index\" as-sortable-item class=md-whiteframe-2dp layout=row style=margin:5px> <div as-sortable-item-handle style=display:inline-flex;width:100% flex> <label flex style=padding:5px;background:#fff;margin:0> <span ng-show=!question.isLatex style=font-size:14px!important>{{answer.desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left;overflow:auto;height:50px>{{answer.desc}}</span> </label> <img flex ng-src={{setFilePath(answer.optImage)}} ng-if=answer.optImage class=mtf-question-img ng-click=showImage(setFilePath(answer.optImage)) /> <div style=height:60px> <md-input-container style=float:right flex=40 class=md-block flex-gt-sm> <label>Enter No:</label> <input ng-keyup=\"checkPoint($index, question)\" decimal-numbers-only ng-model=answer.number autocomplete=off> </md-input-container> </div> </div> </div> </div> </div> </div> </div> </div> </div> <style>.mq-root-block{display:contents!important;line-height:31px!important;white-space:break-spaces!important}</style> ";

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div flex layout=row layout-gt-xs=row class=overFlowContainer style=width:100%;height:85vh;margin-bottom:60px> <div layout=column flex=25 style=background:#e4f0ff;margin:5px;margin-left:17px!important;margin-right:3px!important;max-height:100%;padding-bottom:56px class=\"margin_15 md-whiteframe-5dp md-padding\" ng-show=!fullScreen> <div class=allqstn flex=70 flex-gt-xs> <div flex ng-repeat=\"questionCount in totalQuestion track by $index\" style=display:inline-block layout-align=\"center center\"> <button style=margin:3px class=\"md-whiteframe-2dp {{questionCount.status}}\" aria-label=questionCount.count ng-click=changeQuestion($index)>{{questionCount.count}}</button> </div> </div> <div flex flex-gt-xs layout-align=\"center center\"> <div layout=row layout-gt-xs=column layout-align=\"center start\" flex> <div layout=row layout-align=\"start center\"> <div class=circleSubmit></div> <label style=margin:0!important>Answered</label> </div> <div layout=row layout-align=\"start center\" class=\"layout-align-start-center layout-row\" title=\"Due to Internet Connectivity issue\"> <div class=\"circleSubmit uploading\" style=height:18px;min-width:10px!important;width:20px></div> <label style=margin:0!important>Answer not saved </label> </div> <div layout=row layout-align=\"start center\"> <div class=\"circleReview notAnsW\"></div> <label style=margin:0!important>Mark for Review</label> </div> <div layout=row layout-align=\"start center\"> <div class=circleNormal></div> <label style=margin:0!important>Not Answered</label> </div> </div> </div> </div> <div flex=75 layout=column style=background:#fff;margin:15px;margin-left:30px!important;max-height:100% class=\"md-whiteframe-5dp md-padding overFlowContainer\"> <div class=\"button assessclick assessmentbtnopen filter md-whiteframe-3dp hand-cursor\" ng-show=!fullScreen ng-click=toggleFullScreen(fullScreen) tooltip=Hide tooltip-position=left> <i class=\"fas fa-angle-left filter-arrow\" style=margin-top:2px;margin-left:-14px;font-size:35px></i> </div> <div class=\"button assessclick assessmentbtnclose filter md-whiteframe-3dp hand-cursor\" ng-show=fullScreen ng-click=toggleFullScreen(fullScreen) tooltip=Show tooltip-position=right> <i class=\"fas fa-angle-right filter-arrow\" style=margin-left:-12px;margin-top:2px;font-size:32px></i> </div> <header ng-show=\"loadQuestionDirective && !previewLoad\"> <div layout=row layout-align=\"space-between start\" style=background:#fff flex> <div flex=66 layout-align=\"start center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=color:#9e9e9e;margin-bottom:0> <span style=color:#1b1b1b> Question : </span> <label style=padding-right:8px class=colorthemeColor>{{indexToShow+1}}</label> <span class=colorthemeColor> {{questions[indexToShow].section_name}} &nbsp {{questions[indexToShow].section_instruction}}</span> </p> </span> </div> <div flex=30 ng-show=isPracticeTest layout-align=\"end center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=margin-bottom:0> <span style=font-size:15px> Time Taken : </span> <label class=colorthemeColor>{{timerWithTimeout | hhmmss}}</label> </p> </span> </div> <div flex=30 ng-show=!isPracticeTest layout-align=\"end center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=margin-bottom:0 ng-if=\"remainingTime !== '00 : 00 : 00'\"> <span style=font-size:15px> Time Remaining : </span> <label class=colorthemeColor>{{remainingTime}}</label> </p> <p style=margin-bottom:0 ng-if=\"remainingTime === '00 : 00 : 00'\"> <span style=font-size:15px> Time Elapsed </span> </p> </span> </div> </div> </header> <div flex ng-cloak> <student-attending-page ng-if=loadQuestionDirective></student-attending-page> <answersheet-preview ng-if=\"!loadQuestionDirective && previewLoad\"></answersheet-preview> </div> </div> </div> <footer> <div layout=row flex style=\"position:fixed;bottom:0;z-index:1;background:#1665c1;width:100%;border-top:2px solid #f2f2f2;box-shadow:0 0 10px 0 #f2f2f2;overflow-x:auto;padding-left:10px;padding-right:10px\" layout-align=\"space-around center\"> <div flex layout=row ng-repeat=\"questionCount in totalQuestion\" layout-align=center-center ng-show=\"$index == indexToShow\" ng-if=haveNoPassword style=\"margin:10px 0\"> <div layout-align=\"start center\"> <div ng-show=\"indexToShow>0 && (loadQuestionDirective && !previewLoad)\"> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-click=loadPrevQues()> <img style=margin-bottom:-4px src=" + __webpack_require__(162) + "> <span class=\"footer-text student-footer-ctrl\">Prev</span> </span> </div> <div ng-show=\"!loadQuestionDirective && previewLoad\"> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-click=loadlastQuestion()> <img style=margin-bottom:-4px src=" + __webpack_require__(162) + "> <span class=\"footer-text student-footer-ctrl\">Prev</span> </span> </div> </div> <div layout-align=\"start center\" ng-show=\"loadQuestionDirective && !previewLoad\"> <div> <span style=padding:7px class=\"hand quizbtneffect md-whiteframe-3dp quizbtnwidth quizbtn md-mini\" ng-click=reviewQuestion()> <span class=\"footer-text student-footer-ctrl\">{{questionCount.label}}</span> <img style=float:right;width:19px;margin-left:10px src=" + __webpack_require__(415) + "> </span> </div> </div> <div layout-align=\"start center\" ng-if=\"!loadQuestionDirective && previewLoad\"> <div> <span style=padding:7px class=\"hand quizbtneffect md-whiteframe-3dp quizbtnwidth quizbtn md-mini\" ng-disabled=isSubmitted ng-click=submitLastQuestion(true,false)> <span class=\"footer-text student-footer-ctrl\">Submit</span> <img style=float:right;width:19px;margin-left:10px src=" + __webpack_require__(86) + "> </span> </div> </div> <div layout-align=\"start center\" ng-hide=\"indexToShow<(totalQuestiontoShow-1)\"> <div ng-if=!previewLoad> <span style=padding:7px class=\"hand quizbtneffect md-whiteframe-3dp quizbtnwidth quizbtn md-mini\" ng-disabled=isSubmitted ng-click=answerPreview(true,false)> <span class=\"footer-text student-footer-ctrl\">Preview</span> <img style=float:right;width:19px;margin-left:10px src=" + __webpack_require__(86) + "> </span> </div> </div> <div layout-align=\"start center\" ng-if=\"!clickFromPreview && loadQuestionDirective && !previewLoad\"> <div> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-show=\"indexToShow<(totalQuestiontoShow-1)\" ng-click=loadNextQues()> <span class=\"footer-text student-footer-ctrl\">Next</span> <img style=margin-bottom:-4px src=" + __webpack_require__(163) + "> </span> </div> </div> <div layout-align=\"start center\" ng-if=\"clickFromPreview && loadQuestionDirective && !previewLoad\"> <div> <span layout=row class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-show=\"indexToShow<(totalQuestiontoShow-1)\" ng-click=loadNextQues()> <span class=\"footer-text student-footer-ctrl\">Save</span> <img src=" + __webpack_require__(163) + "> </span> </div> </div> <div style=height:300px!important;width:100% ng-if=showEmptyDiv></div> </div></div></footer> <style>.uploading{min-width:32px;width:36px;height:36px;line-height:32px;border:1px solid;border-color:#4caf50;color:#fff;font-weight:400;background-color:#4caf50;border-radius:50%;background-image:url(data:image/gif;base64,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);background-repeat:round}</style>";

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAMlJREFUOI2l0ztOQkEUBuBB4DZAR+PiNDGwAQoSKW6Jja/OR0WHpa7CBbAHEgzRoIkNMflsTmGIzZ2Z8iT/lz85c1Jq8NDBFKsmuUOkwjk+8ZCLtFFjjzu0c6Ea37hGJxe5xA43qHKAboQ3uEA3BxngEWvMGgOBDAPZYJKFBLTAD86a5I7+mb2nlPYppePsNtGohzm2uCrFqtjUG26zP+AfsI7N3aNXik3wgScMSrExvrBEvxQbxb09F2Fo4SS2+VLUKsBTvB7OfwEVXusaI/3ZMAAAAABJRU5ErkJggg=="

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABLklEQVQ4T6WUu0oEQRBFz8VHon6RuSZirokoBgYiKCuibqAs+ABxA0EWVxMVYwW/wQ/wO8zExAdXCnpkWGd3ZrSjbqrrcLvqVoueZfsJ6Ei67o0NOqsAdA9MAhvArSRXARaBxoEbYApYk3T1J1Ak2Q7YBTATyiRdlsF+KcoSbE8k2DTQktSuVaP8ZdtjwAkwmxrQ6gfrqyinbCjB5oGo156k915gKSgHDGUL6bkHkt7ysMqg1IQdoAmcS2r8B7QIdMMekmL/syorsr0ObAEPwK6kl9og29vAKvAINCS91iq27RFgH1gC7kKRpI8iCwwy5ChwlCBdSZu1DWl7GDgGVgImqa8RM3jR0IYBz4DlGA0gPPNVe9Zsd4A54BA4LXJxpRrZfk7fSFvSZ5mSLP4NIrNjEz9+IsAAAAAASUVORK5CYII="

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deviceUuid = __webpack_require__(930);

var _answersheetPreview = __webpack_require__(78);

var _answersheetPreview2 = _interopRequireDefault(_answersheetPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: studentQuestionSelection.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-19
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var StudentQuestionSelection =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$timeout", "$interval", "$sce", function StudentQuestionSelection($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, $interval, $sce) {
    _classCallCheck(this, StudentQuestionSelection);

    var authoring = localStorageService.get("authoringData");
    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $stateParams.qpId;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    var activityId = $stateParams.activityId;
    if (authoring === undefined) $state.go('dashboard');
    var subjectId = '';
    localStorage.setItem('authoringData', JSON.stringify(authoring));
    localStorageService.set("failureQuestIds", []);
    localStorage.removeItem("is_restart");
    $scope.autoSubState = false;
    $scope.fullScreen = false;
    $scope.totalQuestion = [];
    $scope.questions = [];
    $scope.attendedQuesObj = [];
    $scope.selectedAns = [];
    $scope.questionCollection = [];
    $scope.imageData = [];
    $scope.ansFib = [];
    $scope.ansOwq = [];
    $scope.ansSa = [];
    $scope.ansLa = [];
    $scope.ansDraw = [];
    $scope.ansAslListen = [];
    $scope.ansAslSpeak = [];
    $scope.loadQuestionDirective = false;
    $scope.isOptionSelected = false;
    $scope.actionBtnName = 'Submit';
    $scope.errorFib = {};
    $scope.errorOwq = {};
    $scope.errorMtf = {};
    $scope.errorMrQues = {};
    $scope.errorMcqQues = {};
    $scope.errorTFQues = {};
    $scope.totalQuestiontoShow = 0;
    $scope.indexToShow = 0;
    $scope.quizTotalMark = 0;
    $scope.noOfAttempts = 0;
    $scope.elapsedTime = 0;
    $scope.remainingTime = '';
    $scope.score = 0;
    // questionPaperId = '';
    $scope.isPracticeTest = false;
    $scope.timeData = "";
    $scope.haveNoPassword = true;
    $scope.accessbility = true;
    $scope.isActivity = true;
    $scope.selectedCheckAns = [];
    $scope.multipleCheckAnsData = [];
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    $scope.previewLoad = false;
    var totalMark = 0;

    var endTime = undefined;

    //Meteor.subscribe('questionPaper')

    var tempQuestions = [];
    var currentDay = '';
    var questionPaperData = {};

    var startTime = 0,
        currentTime = null,
        offset = 0,
        interval = null,

    // self = this;
    options = {};
    if (!options.interval) {
        options.interval = 100;
    }
    localStorage.setItem('activityId', activityId);
    localStorage.setItem('backfromexam', true);
    options.elapsedTime = new Date(0);
    $scope.running = false;
    this.$onDestroy = function () {
        //submitAnsEachQuestion(false, true);
        submitAnsEachQuestion(false, false);

        clearTimer();
        toastr.success("Your answer is submitted successfully");
        $mdDialog.cancel();
    };

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        try {
            var nVer = navigator.appVersion;
            var nAgt = navigator.userAgent;
            var browserName = navigator.appName;
            var fullVersion = '' + parseFloat(navigator.appVersion);
            var majorVersion = parseInt(navigator.appVersion, 10);
            var nameOffset, verOffset, ix;

            // In Opera, the true version is after "Opera" or after "Version"
            if ((verOffset = nAgt.indexOf("Opera")) != -1) {
                browserName = "Opera";
                fullVersion = nAgt.substring(verOffset + 6);
                if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
            }
            // In MSIE, the true version is after "MSIE" in userAgent
            else if ((verOffset = nAgt.indexOf("MSIE")) != -1) {
                    browserName = "Microsoft Internet Explorer";
                    fullVersion = nAgt.substring(verOffset + 5);
                } else if ((verOffset = nAgt.indexOf("Edg")) != -1) {
                    browserName = "Edge";
                    fullVersion = nAgt.substring(verOffset + 7);
                }
                // In Chrome, the true version is after "Chrome"  
                else if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
                        browserName = "Chrome";
                        fullVersion = nAgt.substring(verOffset + 7);
                    }
                    // In Safari, the true version is after "Safari" or after "Version" 
                    else if ((verOffset = nAgt.indexOf("Safari")) != -1) {
                            browserName = "Safari";
                            fullVersion = nAgt.substring(verOffset + 7);
                            if ((verOffset = nAgt.indexOf("Version")) != -1) fullVersion = nAgt.substring(verOffset + 8);
                        }
                        // In Firefox, the true version is after "Firefox" 
                        else if ((verOffset = nAgt.indexOf("Firefox")) != -1) {
                                browserName = "Firefox";
                                fullVersion = nAgt.substring(verOffset + 8);
                            }
                            // In most other browsers, "name/version" is at the end of userAgent 
                            else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
                                    browserName = nAgt.substring(nameOffset, verOffset);
                                    fullVersion = nAgt.substring(verOffset + 1);
                                    if (browserName.toLowerCase() == browserName.toUpperCase()) {
                                        browserName = navigator.appName;
                                    }
                                }
            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);

            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }
            var OSName = "Unknown OS";
            if (nAgt.indexOf("Win") != -1) OSName = "Windows";
            if (nAgt.indexOf("Mac") != -1) OSName = "Macintosh";
            if (nAgt.indexOf("Linux") != -1) OSName = "Linux";
            if (nAgt.indexOf("Android") != -1) OSName = "Android";
            if (nAgt.indexOf("like Mac") != -1) OSName = "iOS";

            var ua = nAgt;
            var DeviceName = "Unknown";
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                var DeviceName = "Tablet";
            } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                var DeviceName = "Mobile";
            } else {
                var DeviceName = "Desktop";
            }

            // console.log(browserName)
            // console.log(majorVersion)
            // console.log(OSName) 
            var localAgentDet = {
                "browser": browserName,
                "major_version": majorVersion,
                "os_name": OSName,
                "device": DeviceName,
                "ua": nAgt
            };
        } catch (e) {}

        var userlog = localAgentDet;

        var uuid = new _deviceUuid.DeviceUUID().get();

        var requestObj = {};
        requestObj["activity_id"] = activityId;
        requestObj["qp_id"] = qpId;
        requestObj["student_id"] = userId;
        requestObj["browser_agent"] = localAgentDet ? localAgentDet : {};

        requestObj["user_logged"] = userlog ? userlog : {};
        requestObj['user_logged']['timeStart'] = new Date();
        requestObj['user_logged']['version'] = 'Educore5';
        requestObj['user_logged']['uuid'] = uuid;

        var academics = _.pick(authoring, 'curriculum_id', 'session_id', 'class_id', 'subject_id', 'batch_id', 'school_id', 'academic_year');
        requestObj = _.extend(requestObj, academics);
        authService.callAPI(activityCons.API_GET_EXAM_QUESTIONS, "POST", requestObj, function (response) {
            if (response) {
                if (response.result.status && response.result.status.code == 200) {
                    loadQuestions(response.result);
                } else {
                    toastr.error(response.result.data.message);
                    $state.go('qpSummary', {
                        qpId: qpId
                    }, {
                        reload: true
                    });
                }
            } else {
                console.log("error : " + response.error);
                if (response.error.status && response.error.status.message) {
                    toastr.error(response.error.status.message);
                }
                if (response.error.data && response.error.data.message) {
                    toastr.error(response.error.data.message);
                }
                if (response.error.error && response.error.error.status) {
                    toastr.error(response.error.error.status);
                }
            }
        });
        //  Check the Internet Connection ...
        window.addEventListener('offline', function (e) {
            toastr.error("Internet Disconnected.");
        });
        window.addEventListener('online', function (e) {
            toastr.success("Internet Connected.");
        });
    };

    var initilaizeTimer = function initilaizeTimer(timeObj) {
        var deadline = void 0;
        $scope.remainingTime = '';
        if (parseInt(timeObj.hour) == 0 && parseInt(timeObj.min) == 0) {
            $scope.remainingTime = '00 : 00 : 00';
        } else {
            if (parseInt(timeObj.hour) === 0) {
                $scope.elapsedTime = parseInt(timeObj.min) * 60 * 1000 + parseInt(timeObj.sec) * 1000;
            } else {
                $scope.elapsedTime = parseInt(timeObj.hour) * 60 * 60 * 1000 + parseInt(timeObj.min) * 60 * 1000 + parseInt(timeObj.sec) * 1000;
            }

            deadline = new Date(Date.parse(new Date()) + $scope.elapsedTime);
            $scope.initializeClock(deadline);
            $scope.startTimer();
        }
    };
    /**varunsj 7-7-2020 for shuffling MTF if needed */
    function _checkMTF_LHS_RHS_AndShuffleIfNeeded(_RHS_ARRAY, quest) {
        var flag_for_shuffle = false; //if this var is true shuffle is done
        if (_RHS_ARRAY && _RHS_ARRAY.length && quest && quest.option && quest.option.length) {
            for (var r = 0; r < _RHS_ARRAY.length; r++) {
                var oneRHS = _RHS_ARRAY[r],
                    oneLHS = quest['option'][r];
                if (oneLHS.question.desc) {
                    /**if RHS == LHS var "flag_for_shuffle" is done true**/
                    if (oneRHS.desc == oneLHS.answer.desc) {
                        flag_for_shuffle = true;
                        break;
                    }
                }
            }
        }
        /** if var "flag_for_shuffle" is done true , goes this condition */
        if (flag_for_shuffle) {
            /**shuffling again WITHOUT undercore js starts */
            var array = _RHS_ARRAY;
            var currentIndex = array.length,
                temporaryValue,
                randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            /**shuffling again WITHOUT undercore js ends */

            /**shuffling again USING undercore js starts */
            // _RHS_ARRAY = _.shuffle(optionAnswer)
            /**shuffling again USING undercore js ends */
        }
        return _RHS_ARRAY;
    }
    var loadQuestions = function loadQuestions(questionPaperData) {
        $scope.isPracticeTest = questionPaperData.practice_qn;
        $scope.graceTime = 0;

        if (questionPaperData && questionPaperData.data && questionPaperData.data.details) {

            var responseObj = questionPaperData.data.details;
            $scope.isPracticeTest = responseObj.practice_qn;
            $scope.autoSubState = responseObj.autoSubmitState;
            endTime = new Date(responseObj.endTime);
            $scope.serverDate = new Date(responseObj.serverTime);
            var timeObj = {};
            if ($scope.autoSubState) {
                console.log("auto Submit State................");
                timeObj = { "hour": responseObj.time.hour, "min": responseObj.time.min, "sec": "00" };
                console.log(timeObj);
                initilaizeTimer(timeObj);
            } else {
                if ($scope.serverDate.getTime() > endTime.getTime()) {
                    console.log("Time Expired...");

                    timeObj = {
                        "hour": 0,
                        "min": 0,
                        "sec": 0
                    };
                    initilaizeTimer(timeObj);
                } else {
                    var secondsToTime = (endTime.getTime() - $scope.serverDate.getTime()) / 1000;
                    timeObj = secondsToHrMin(secondsToTime);
                    initilaizeTimer(timeObj);
                }
            }
            totalMark = responseObj.total_mark;
            if (responseObj.serverTime) {
                currentDay = new Date($scope.serverDate.getFullYear(), $scope.serverDate.getMonth(), $scope.serverDate.getDate());
            } else {
                var today = new Date();
                currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            }

            var result = responseObj.questions;
            _.each(result, function (quest, key) {
                $scope.questions.push(quest);
                if (quest.isLatex) {
                    $scope.formatToLatex();
                }
                var optionAnswer = [];
                //To covert image into image array - multiple image
                if (quest) {
                    if (quest.type === "MCQ") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                        _.each(quest.choice, function (eachChoice) {
                            if (!Array.isArray(eachChoice.optImage) && eachChoice.optImage != null) eachChoice.optImage = _.flatten([eachChoice.optImage]);
                        });
                    } else if (quest.type === "FIB" || quest.type === "TF" || quest.type === "OWQ" || quest.type === "SA" || quest.type === "LA") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    } else if (quest.type === "IBT_FIB") {
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    } else if (quest.type === "IBT_MCQ") {
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                        _.each(quest.choice, function (eachChoice) {
                            if (!Array.isArray(eachChoice.optImage) && quest.questionImg != null) eachChoice.optImage = _.flatten([eachChoice.optImage]);
                        });
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                    } else if (quest.type === "DRAW") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    }
                }

                if (quest.type === "MTF") {
                    quest['quesData'] = [];
                    _.each(quest.option, function (eachAns) {
                        quest.quesData.push(eachAns.question);
                        if (eachAns.question.tag) {
                            eachAns.answer['mtf_question_tag'] = eachAns.question.tag;
                        }
                        if (!quest.auto_shuffle && quest.shuffled_options && quest.shuffled_options.length) {} else {
                            optionAnswer.push(eachAns.answer);
                        }
                    });
                    if (!quest.auto_shuffle && quest.shuffled_options && quest.shuffled_options.length) {
                        optionAnswer = quest.shuffled_options;
                        console.log('MANUAL SHUFFLE');
                    } else {
                        optionAnswer = _.shuffle(optionAnswer);
                        optionAnswer = _checkMTF_LHS_RHS_AndShuffleIfNeeded(optionAnswer, quest);
                    }
                    quest.optionAnswer = optionAnswer;
                }

                if (quest.type === "TF") {
                    var choices = _.shuffle(quest.choice);
                    quest.choice = choices;
                }

                if (quest.type === "DRAW") {
                    quest.canvasId = "canvas_" + key;
                    var emptyObj = {
                        'choice': ''
                    };
                    $scope.ansDraw.push(emptyObj);
                }

                if (quest.type === "ASLLISTEN") {
                    quest.playableQuestionUrl = $sce.trustAsResourceUrl(FILE_PREVIEW_URL + quest.audio_url);
                    var emptyAnsList = [];
                    _.each(quest.questions, function (question) {
                        var emptyObj = {
                            _id: question._id,
                            type: question.type
                        };
                        switch (question.type) {
                            case 'mcq':
                                if (question.pattern == 'single') emptyObj['answer'] = "";else emptyObj['answer'] = [];
                                break;
                            case 'fib':
                                emptyObj['answer'] = [];
                                break;
                            default:
                                emptyObj['answer'] = "";
                                break;
                        }
                        emptyAnsList.push(emptyObj);
                    });
                    $scope.ansAslListen[key] = {
                        ans: emptyAnsList
                    };
                }
                if (quest.type === "ASLSPEAK") {
                    $scope.ansAslSpeak[key] = {
                        answer: ''
                    };
                }

                quest.submit_status = quest.q_status;
                //Display previously Submitted answer
                if (quest.answer && quest.answer.length > 0) {

                    if (quest.type === "FIB" || quest.type === "IBT_FIB") {
                        _.each(quest.answer, function (fib_ans, c_key) {
                            if (fib_ans) {
                                if (!$scope.ansFib) {
                                    $scope.ansFib = [];
                                }

                                var choiceObj = {
                                    "choice": {}
                                };
                                choiceObj["choice"][c_key] = fib_ans;
                                $scope.ansFib.splice(key, 0, choiceObj);
                            }
                        });
                        $scope.imageData[key] = quest.answerImg;
                    } else if (quest.type === "MCQ" || quest.type === "IBT_MCQ") {

                        if (!$scope.multipleCheckAnsData) {
                            $scope.multipleCheckAnsData = [];
                        }
                        //$scope.multipleCheckAnsData.splice(key, 0, quest.answer);
                        $scope.multipleCheckAnsData[key] = quest.answer;
                    } else if (quest.type === "OWQ") {
                        if (!$scope.ansOwq) {
                            $scope.ansOwq = [];
                        }
                        $scope.ansOwq[key] = quest.answer[0];
                        $scope.imageData[key] = quest.answerImg;
                    } else if (quest.type === "MTF") {
                        _.each(quest.optionAnswer, function (opt, o_key) {
                            //  opt["desc"] = quest.answer[o_key].desc
                            /** issue of one student from live nims;fixed on 9-10-2020 varun
                             * in exam doc of one student, is not having same number of objects in the field answer with respect to 
                             * question opts
                             * 
                             * root cause not found till date
                            */
                            opt["desc"] = quest.answer[o_key] ? quest.answer[o_key].desc : opt.desc;
                        });
                    } else if (quest.type === "TF") {
                        if (!$scope.selectedAns) {
                            $scope.selectedAns = [];
                        }
                        //$scope.selectedAns.splice(key, 0, quest.answer[0]);
                        $scope.selectedAns[key] = quest.answer[0];
                    }
                }

                if (quest.type === "SA") {
                    if (!$scope.ansSa) {
                        $scope.ansSa = [];
                    }
                    if (!$scope.imageData) {
                        $scope.imageData = [];
                    }
                    $scope.imageData[key] = quest.answerImg;
                    $scope.ansSa[key] = quest.answer;
                } else if (quest.type === "LA") {
                    if (!$scope.ansLa) {
                        $scope.ansLa = [];
                    }
                    if (!$scope.imageData) {
                        $scope.imageData = [];
                    }
                    $scope.imageData[key] = quest.answerImg;
                    $scope.ansLa[key] = quest.answer;
                }

                if (quest.submit_status && quest.submit_status == "submit" && quest.is_attended) {
                    status = true;
                }

                $scope.totalQuestion.push({
                    question: quest,
                    count: key + 1,
                    isActive: false,
                    status: quest.submit_status ? quest.submit_status : 'normal',
                    label: quest.submit_status && quest.submit_status == 'review' ? 'Unmark' : 'Mark for review'
                });
                if ($scope.questions[key]) {
                    $scope.attendedQuesObj[key] = {
                        questionId: $scope.questions[key]._id,
                        mark: 0,
                        timeElapsed: 0,
                        section_name: $scope.questions[key].section_name
                    };
                }
                _loadMCQAnswers(quest);
            });
        }
        $scope.loadQuestionDirective = true;
        $scope.totalQuestiontoShow = $scope.questions.length;
    };
    function _loadMCQAnswers(quest) {
        if (quest.type === "MCQ") {
            if (quest.is_single_pattern) {
                for (var i = 0; i < quest.choice.length; i++) {
                    quest.choice[i]['isChecked'] = false;
                    if (quest.answer && quest.answer.length) {
                        if (quest.answer.indexOf(quest.choice[i].desc) !== -1) {
                            quest.choice[i]['isChecked'] = true;
                        }
                    }
                }
            }
            /** MCQ answer reset starts */
            quest['answer_exists'] = false;
            if (quest.answer && quest.answer.length) {
                quest['answer_exists'] = true;
            }
            /** MCQ answer reset ends */
        }
    }
    function secondsToHrMin(secs) {
        var hours = Math.floor(secs / (60 * 60));

        var divisor_for_minutes = secs % (60 * 60);
        var minutes = Math.floor(divisor_for_minutes / 60);

        var divisor_for_seconds = divisor_for_minutes % 60;
        var seconds = Math.ceil(divisor_for_seconds);

        var obj = {
            "hour": hours,
            "min": minutes,
            "sec": seconds
        };
        return obj;
    }

    $scope.toggleFullScreen = function (fullScreen) {
        $scope.fullScreen = !fullScreen;
    };

    function clearTimer() {
        $interval.cancel(timeinterval);
        $scope.remainingTime = '00 : 00 : 00';
    }

    $scope.getTimeRemaining = function (endTime) {
        var t = Date.parse(endTime) - Date.parse(new Date());
        $scope.elapsedTimeForReset = t;
        var seconds = Math.floor(t / 1000 % 60);
        var minutes = Math.floor(t / 1000 / 60 % 60);
        var hours = Math.floor(t / (1000 * 60 * 60) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    };

    var MQ = MathQuill.getInterface(2);
    $scope.formatToLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('question_desc');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    var timeinterval = void 0;
    $scope.initializeClock = function (endTime) {

        function updateClock() {
            if (!$scope.isSubmitted) {
                var t = $scope.getTimeRemaining(endTime);
                if (t) $scope.totalTimeRemaining = t.total;
                var days = t.days > 0 ? t.days + ' : ' : '';
                $scope.remainingTime = days + ('0' + t.hours).slice(-2) + " : " + ('0' + t.minutes).slice(-2) + " : " + ('0' + t.seconds).slice(-2);
                if ($scope.remainingTime == '00 : 00 : 00') {
                    $scope.remainingTime = '00 : 00 : 00';
                    $interval.cancel(timeinterval);
                    //Auto submission
                    //$scope.submitQuizQuestion()
                    submitAnsEachQuestion(false, true);
                    if ($scope.autoSubState) {
                        var requestObjData = {
                            "student_id": userId,
                            "qp_id": qpId,
                            "activity_id": activityId
                        };
                        stopExamAuto(requestObjData);
                    }
                }
            } else {
                $interval.cancel(timeinterval);
            }
        }

        updateClock();
        timeinterval = $interval(updateClock, 1000);
    };
    $scope.startTimer = function () {
        if ($scope.running === false) {
            startTime = new Date().getTime();
            interval = $interval($scope.updateTime, options.interval);
            $scope.running = true;
        }
    };

    $scope.updateTime = function () {
        currentTime = new Date().getTime();
        var timeElapsed = offset + (currentTime - startTime);
        options.elapsedTime.setTime(timeElapsed);
    };

    $scope.config = {
        autoHideScrollbar: true,
        theme: 'minimal'
    };

    $scope.stopTimer = function () {
        if ($scope.running === false) {
            return;
        }
        $scope.updateTime();
        offset = offset + currentTime - startTime;
        $scope.running = false;
        $scope.timeData = currentTime - startTime;
    };

    //timer with timeout
    $scope.timerWithTimeout = 0;
    $scope.startTimerWithTimeout = function () {
        $scope.timerWithTimeout = 0;
        if ($scope.myTimeout) {
            $timeout.cancel($scope.myTimeout);
        }
        $scope.onTimeout = function () {
            $scope.timerWithTimeout++;
            $scope.myTimeout = $timeout($scope.onTimeout, 1000);
        };
        $scope.myTimeout = $timeout($scope.onTimeout, 1000);
    };

    $scope.startTimerWithTimeout();
    $scope.resetTimerWithTimeout = function () {
        $scope.timerWithTimeout = 0;
        $timeout.cancel($scope.myTimeout);
    };

    //timer with interval
    $scope.timerWithInterval = 0;
    $scope.startTimerWithInterval = function () {
        $scope.timerWithInterval = 0;
        if ($scope.myInterval) {
            $interval.cancel($scope.myInterval);
        }
        $scope.onInterval = function () {
            $scope.timerWithInterval++;
        };
        $scope.myInterval = $interval($scope.onInterval, 1000);
    };

    $scope.resetTimerWithInterval = function () {
        $scope.timerWithInterval = 0;
        $interval.cancel($scope.myInterval);
    };
    function setBtnclickFromPreviewOnOff(clickFromPreview) {
        if (clickFromPreview) {
            $scope.clickFromPreview = true;
        } else {
            $scope.clickFromPreview = false;
        }
    }
    $scope.clickFromPreview = false;
    /* Change question by clicking question number in left side*/
    $scope.changeQuestion = function (questCount, clickFromPreview) {
        clearPreview();
        setBtnclickFromPreviewOnOff(clickFromPreview);
        if (questCount != $scope.indexToShow) {
            //Change button name for next question
            if ($scope.isPracticeTest) {
                if ($scope.totalQuestion[questCount].accessbility === true) {
                    $scope.accessbility = true;
                    $scope.disableCntrlBtn = true;
                } else {
                    if ($scope.totalQuestion.length === questCount + 1) {
                        $scope.actionBtnName = "Submit";
                    } else {
                        $scope.accessbility = false;
                        $scope.disableCntrlBtn = true;
                        $scope.actionBtnName = "Next";
                    }
                }
                if ($scope.totalQuestion[questCount].status === 'submit') {
                    $scope.resultStatus = 'Explanation';
                    var questObj = $scope.questions[questCount];
                    if (questObj.type == "MCQ") {
                        if (questObj.pattern == "single") {
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplanation = value.explanation;
                                }
                            });
                        } else {
                            $scope.ansExplantionMR = "";
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplantionMR += key + 1 + ' . ' + value.explanation;
                                }
                            });
                        }
                    } else if (questObj.type == "TF") {
                        angular.forEach(questObj.choice, function (value, key) {
                            if (value.correct) {
                                $scope.ansExplanation = value.explanation;
                            }
                        });
                    } else if (questObj.type == "FIB") {
                        $scope.ansExplantionFIB = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionFIB += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "OWQ") {
                        $scope.ansExplantionOWQ = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionOWQ += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "MTF") {
                        //for (var i = 0; i < $scope.quesData.length; i++) {
                        var optionsObj = questObj.option;
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each(optionsObj, function (option) {
                            index += 1;
                            var explanation = option.explanation === undefined ? 'NA' : option.explanation;
                            if (index === 1) {
                                $scope.ansExplantionMTF += index + ' . ' + explanation;
                            } else {
                                $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation;
                            }
                        });
                    }
                    $scope.isOptionSelected = true;
                } else {
                    $scope.isOptionSelected = false;
                }
            } else {
                $scope.evaluateQuizQuestion($scope.indexToShow);
                //To send details of each question. if student attend
                submitAnsEachQuestion(false, false);
            }
            $scope.indexToShow = questCount;
            $scope.totalQuestion[questCount].status = $scope.totalQuestion[questCount].status + ' selectedQes';

            if (!$scope.isPracticeTest) {
                $scope.startTimer();
            }
        }
    };

    /* Invoke while clicking review option*/

    $scope.reviewQuestion = function () {
        clearPreview();
        if ($scope.totalQuestion[$scope.indexToShow].label == "Mark for review") {
            $scope.totalQuestion[$scope.indexToShow].status = 'review';
            $scope.totalQuestion[$scope.indexToShow].label = 'Unmark';
        } else {
            $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            $scope.totalQuestion[$scope.indexToShow].label = 'Mark for review';
        }
    };

    /* Practice Test Starts*/

    var marks = {
        'student_id': userId,
        'type': 'PracticeTest',
        'date': currentDay,
        'result': [],
        "subject_id": authoring.subject_id,
        "session_id": authoring.session_id,
        "curriculum_id": authoring.curriculum_id,
        "batch_id": authoring.batch_id,
        "class_id": authoring.class_id,
        "theme_id": $scope.selectedThemeId,
        'activity_id': activityId,
        'qp_id': qpId
    };

    var scoreDetails = [];
    /* Submitting practice test questions*/
    $scope.submitQuestion = function () {
        if (!$scope.isOptionSelected) {
            toastr.error("Please answer the question");
            return;
        }
        if ($scope.actionBtnName == "Submit") {
            //|| $scope.actionBtnName == "Try Again") {
            $scope.noOfAttempts += 1;
            var isCorrectAns = false;
            var questObj = $scope.questions[$scope.indexToShow];
            var mark = $scope.questionCollection[$scope.indexToShow].mark_each_qn;
            if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    $scope.errorMcqQues = {};
                    angular.forEach(questObj.choice, function (value, key) {
                        if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc) {
                            $scope.stopTimer();
                            if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                                scoreDetails[$scope.indexToShow] = {
                                    mark: parseFloat(mark)
                                };
                                $scope.score += parseFloat(mark);
                            }
                            isCorrectAns = true;
                            $scope.answerType = "Correct Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "correct";
                            $scope.errorMcqQues[value.desc] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: value.hint
                            };
                            marks.result[$scope.indexToShow] = {
                                question_id: questObj._id,
                                attempt_count: $scope.noOfAttempts,
                                time_elapsed: $scope.timeData
                            };
                        } else if ($scope.selectedAns[$scope.indexToShow] == value.desc) {
                            $scope.answerType = "Wrong Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "wrong";
                            $scope.errorMcqQues[value.desc] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: value.hint
                            };
                        }
                    });
                } else {
                    var _wrongAnsCount = 0;
                    $scope.ansExplantionMR = '';
                    $scope.errorMrQues = {};
                    var _correctAns = '';
                    var choices = [];
                    var crctObj = _.filter(questObj.choice, function (det) {
                        return det.correct === true;
                    });
                    for (var i = crctObj.length - 1; i >= 0; i--) {
                        _correctAns += crctObj[i].desc + "[,]";
                    }

                    _.each(questObj.choice, function (choice) {
                        choices.push({
                            name: choice.desc,
                            "description": {
                                "en-US": choice.hint
                            }
                        });
                    });

                    angular.forEach(questObj.choice, function (value, key) {
                        if (value.correct) {
                            if ($scope.checkingChoiceExists(value.desc)) {
                                var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                $scope.errorMrQues[value.desc] = {
                                    answerType: 'Correct Answer',
                                    answerStatus: 'correct',
                                    msg: key + 1 + ' . ' + explanation
                                };
                                $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = key + 1 + ' . ' + explanation : $scope.ansExplantionMR += key + 1 + ' . ' + explanation;
                            } else {
                                _wrongAnsCount += 1;
                                //$scope.errorMrq[value.desc] = {answerType: 'Wrong Answer', answerStatus: 'wrong', msg:(key+1)+' . '+value.hint};
                            }
                            $scope.stopTimer();
                        } else if ($scope.checkingChoiceExists(value.desc)) {
                            _wrongAnsCount += 1;
                            var hint = value.hint === undefined ? 'NA' : value.hint;
                            $scope.errorMrQues[value.desc] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: key + 1 + ' . ' + hint
                            };
                            $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = key + 1 + ' . ' + hint : $scope.ansExplantionMR += key + 1 + ' . ' + hint;
                        }
                    });
                    if (_wrongAnsCount == 0) {
                        //$scope.score+=questObj.mark;
                        $scope.accessbility = false;
                        if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                            scoreDetails[$scope.indexToShow] = {
                                mark: parseFloat(mark)
                            };
                            $scope.score += parseFloat(mark);
                        }
                        marks.result[$scope.indexToShow] = {
                            question_id: questObj._id,
                            attempt_count: $scope.noOfAttempts,
                            time_elapsed: $scope.timeData
                        };
                        isCorrectAns = true;
                    }
                }
            } else if (questObj.type == "TF") {

                var keepGoing = false;
                $scope.errorTFQues = {};
                var correctAns;
                angular.forEach(questObj.choice, function (value, key) {
                    if (!keepGoing) {
                        if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag) {
                            correctAns = value.correct;
                            $scope.stopTimer();
                            //$scope.score+=questObj.mark;
                            if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                                scoreDetails[$scope.indexToShow] = {
                                    mark: parseFloat(mark)
                                };
                                $scope.score += parseFloat(mark);
                            }
                            marks.result[$scope.indexToShow] = {
                                question_id: questObj._id,
                                attempt_count: $scope.noOfAttempts,
                                time_elapsed: $scope.timeData
                                //marks.result.push(markObj)
                            };isCorrectAns = true;
                            $scope.accessbility = false;
                            keepGoing = true;
                            $scope.answerType = "Correct Answer";
                            $scope.ansExplanation = value.explanation === undefined ? 'NA' : value.explanation;
                            $scope.answerStatus = "correct";
                            $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: value.explanation
                            };
                        } else {
                            keepGoing = false;
                            $scope.answerType = "Wrong Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "wrong";
                            $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: value.hint
                            };
                        }
                    }
                });
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var fibAnswerCount = questObj.question_answer.length;
                var wrongAnsCount = 0;
                $scope.ansExplantionFIB = '';
                var studentAnswer = '';
                var correctValue = '';
                angular.forEach(questObj.question_answer, function (value, key) {
                    if (value.desc != undefined) {
                        if ($scope.ansFib.length > 0) {
                            if ($scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                wrongAnsCount += 1;
                                $scope.stopTimer();
                                var hint = value.explanation === undefined ? 'NA' : value.explanation;
                                $scope.errorFib[value.desc] = {
                                    answerType: 'Cant be empty',
                                    answerStatus: 'info',
                                    msg: key + 1 + ' . ' + hint
                                };
                                $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + hint : $scope.ansExplantionFIB += key + 1 + ' . ' + hint;
                            } else {
                                var _correctValue = value.desc;
                                var _studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key];
                                if (_correctValue.toLowerCase().trim() == _studentAnswer.toLowerCase().trim()) {
                                    var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorFib[value.desc] = {
                                        answerType: 'Correct Answer',
                                        answerStatus: 'correct',
                                        msg: key + 1 + ' . ' + value.explanation
                                    };
                                    $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + explanation : $scope.ansExplantionFIB += key + 1 + ' . ' + explanation;
                                } else {
                                    $scope.stopTimer();
                                    var _hint = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorFib[value.desc] = {
                                        answerType: 'Wrong Answer',
                                        answerStatus: 'wrong',
                                        msg: key + 1 + ' . ' + _hint
                                    };
                                    $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + _hint : $scope.ansExplantionFIB += key + 1 + ' . ' + _hint;
                                    wrongAnsCount += 1;
                                }
                            }
                        } else {
                            wrongAnsCount += 1;
                            $scope.stopTimer();
                            var _hint2 = 'Cant be empty';
                            $scope.errorFib[value.desc] = {
                                answerType: 'Cant be empty',
                                answerStatus: 'info',
                                msg: key + 1 + ' . ' + _hint2
                            };
                        }
                    }
                });

                if (wrongAnsCount == 0) {
                    $scope.accessbility = false;
                    $scope.stopTimer();
                    //$scope.score+=questObj.mark;
                    if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                        scoreDetails[$scope.indexToShow] = {
                            mark: parseFloat(mark)
                        };
                        $scope.score += parseFloat(mark);
                    }
                    marks.result[$scope.indexToShow] = {
                        question_id: questObj._id,
                        attempt_count: $scope.noOfAttempts,
                        time_elapsed: $scope.timeData
                    };
                    isCorrectAns = true;
                }
            } else if (questObj.type == "OWQ") {
                var fibAnswerCount = questObj.answer.length;
                var wrongAnsCount = 0;
                $scope.ansExplantionOWQ = '';
                var correctans = undefined;
                angular.forEach(questObj.answer, function (value, key) {
                    if (value.desc != undefined) {
                        correctans = value.desc;
                        if ($scope.ansOwq.length > 0) {
                            if ($scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                wrongAnsCount += 1;
                                $scope.stopTimer();
                                var hint = value.hint === undefined ? 'NA' : value.hint;
                                $scope.errorOwq[value.desc] = {
                                    answerType: 'Cant be empty',
                                    answerStatus: 'info',
                                    msg: key + 1 + ' . ' + hint
                                };
                                $scope.ansExplantionOWQ = key + 1 + ' . ' + hint;
                            } else {
                                /*let correctValue = removeSpecialCharacter(value.desc)
                                let studentValue = removeSpecialCharacter($scope.ansOwq[$scope.indexToShow])*/

                                var _correctValue2 = value.desc;
                                var studentValue = $scope.ansOwq[$scope.indexToShow];
                                if (_correctValue2.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                    var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorOwq[value.desc] = {
                                        answerType: 'Correct Answer',
                                        answerStatus: 'correct',
                                        msg: key + 1 + ' . ' + value.explanation
                                    };
                                    $scope.ansExplantionOWQ = key + 1 + ' . ' + explanation;
                                } else {
                                    $scope.stopTimer();
                                    var _hint3 = value.hint === undefined ? 'NA' : value.hint;
                                    $scope.errorOwq[value.desc] = {
                                        answerType: 'Wrong Answer',
                                        answerStatus: 'wrong',
                                        msg: key + 1 + ' . ' + _hint3
                                    };
                                    $scope.ansExplantionOWQ = key + 1 + ' . ' + _hint3;
                                    wrongAnsCount += 1;
                                }
                            }
                        } else {
                            wrongAnsCount += 1;
                            $scope.stopTimer();
                            var _hint4 = 'Cant be empty';
                            $scope.errorOwq[value.desc] = {
                                answerType: 'Cant be empty',
                                answerStatus: 'info',
                                msg: key + 1 + ' . ' + _hint4
                            };
                        }
                    }
                });

                if (wrongAnsCount == 0) {
                    //babin
                    $scope.accessbility = false;
                    //
                    $scope.stopTimer();
                    //$scope.score+=questObj.mark;
                    if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                        scoreDetails[$scope.indexToShow] = {
                            mark: parseFloat(mark)
                        };
                        $scope.score += parseFloat(mark);
                    }
                    marks.result[$scope.indexToShow] = {
                        question_id: questObj._id,
                        attempt_count: $scope.noOfAttempts,
                        time_elapsed: $scope.timeData
                    };
                    isCorrectAns = true;
                }
            } else if (questObj.type == "MTF") {
                $scope.ansExplantionMTF = '';
                var _wrongAnsCount2 = 0;
                var _correctans = '';
                var source = [];
                var target = [];

                for (var i = 0; i < questObj.option.length; i++) {
                    var optionsObj = questObj.option[i];

                    _correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]";

                    source.push({
                        "id": optionsObj.question.desc,
                        "description": {
                            "en-US": optionsObj.question.desc
                        }
                    });

                    target.push({
                        "id": optionsObj.answer.desc,
                        "description": {
                            "en-US": optionsObj.answer.desc
                        }
                    });

                    for (var i = 0; i < questObj.option.length; i++) {
                        var optionsObj = questObj.option[i];
                        if ($scope.questions[$scope.indexToShow].quesData[i].tag == optionsObj.question.tag && $scope.questions[$scope.indexToShow].optionAnswer[i].desc == optionsObj.answer.desc) {
                            var explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation;
                            $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: i + 1 + ' . ' + explanation
                            };
                            $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = i + 1 + ' . ' + explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + explanation;
                        } else {
                            var _explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation;
                            $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: i + 1 + ' . ' + _explanation
                            };
                            _wrongAnsCount2 += 1;
                            $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = i + 1 + ' . ' + _explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + _explanation;
                        }
                    }
                    if (_wrongAnsCount2 == 0) {
                        $scope.accessbility = false;
                        $scope.stopTimer();
                        //$scope.score+=questObj.mark.total;
                        if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                            scoreDetails[$scope.indexToShow] = {
                                mark: parseFloat(mark)
                            };
                            $scope.score += parseFloat(mark); //.total;
                        }
                        isCorrectAns = true;
                        marks.result[$scope.indexToShow] = {
                            question_id: questObj._id,
                            attempt_count: $scope.noOfAttempts,
                            time_elapsed: $scope.timeData
                        };
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each($scope.errorMtf, function (obj, key) {
                            if (obj.answerStatus === 'correct') {
                                index += 1;
                                if (index === 1) {
                                    $scope.ansExplantionMTF += obj.msg;
                                } else {
                                    $scope.ansExplantionMTF += ' , ' + obj.msg;
                                }
                            }
                        });
                    } else {
                        var index = 0;
                        _.each($scope.errorMtf, function (obj, key) {
                            if (obj.answerStatus === 'wrong') {
                                index += 1;
                                if (index === 1) {
                                    $scope.ansExplantionMTF += obj.msg;
                                } else {
                                    $scope.ansExplantionMTF += ' , ' + obj.msg;
                                }
                            }
                        });
                    }
                }
            }

            if (isCorrectAns) {
                $scope.resultStatus = 'Explanation';
                $scope.totalQuestion[$scope.indexToShow].isActive = true;
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                $scope.totalQuestion[$scope.indexToShow].accessbility = false;
                if ($scope.indexToShow + 1 != $scope.questions.length) {
                    $scope.actionBtnName = "Next";
                } else {
                    marks.theme_id = $scope.selectedThemeId;
                    marks.date = currentDay;
                    var questionCount = $scope.totalQuestion.length;
                    var answeredCount = 0;
                    _.each($scope.totalQuestion, function (quest) {
                        if (quest.status === 'submit') {
                            answeredCount++;
                        }
                    });
                    if (questionCount === answeredCount) {
                        $scope.disableCntrlBtn = false;
                    } else {
                        var remainingQuestion = questionCount - answeredCount;
                        toastr.success("Still you have to practice" + remainingQuestion + "question(s)");
                    }
                }
                $scope.noOfAttempts = 0;
            } else {
                $scope.resultStatus = 'Hint';
                $scope.actionBtnName = "Try Again";
            }
        } else if ($scope.actionBtnName == "Next") {
            //$scope.startTimer()
            $scope.answerStatus = "normal";
            // load next question
            $scope.accessbility = true;
            $scope.indexToShow = ($scope.indexToShow + 1) % $scope.questions.length;
            //$scope.isOptionSelected = false;
            if ($scope.isPracticeTest) {

                $scope.resetValues();
                if ($scope.totalQuestion[$scope.indexToShow].status === 'submit') {
                    if ($scope.totalQuestion.length === $scope.indexToShow + 1) {
                        $scope.actionBtnName = "Submit";
                    } else {
                        $scope.actionBtnName = "Next";
                    }

                    $scope.accessbility = false;
                    $scope.resultStatus = 'Explanation';
                    var questObj = $scope.questions[$scope.indexToShow];
                    if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                        if (questObj.pattern == "single") {
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplanation = value.explanation;
                                }
                            });
                        } else {
                            $scope.ansExplantionMR = "";
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplantionMR += key + 1 + ' . ' + value.explanation;
                                }
                            });
                        }
                    } else if (questObj.type == "TF") {
                        angular.forEach(questObj.choice, function (value, key) {
                            if (value.correct) {
                                $scope.ansExplanation = value.explanation;
                            }
                        });
                    } else if (questObj.type == "FIB") {
                        $scope.ansExplantionFIB = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionFIB += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "OWQ") {
                        $scope.ansExplantionOWQ = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionOWQ += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "MTF") {
                        //for (var i = 0; i < $scope.quesData.length; i++) {
                        var optionsObj = questObj.option;
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each(optionsObj, function (option) {
                            index += 1;
                            var explanation = option.explanation === undefined ? 'NA' : option.explanation;
                            if (index === 1) {
                                $scope.ansExplantionMTF += index + ' . ' + explanation;
                            } else {
                                $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation;
                            }
                        });
                    }
                    $scope.isOptionSelected = true;
                } else {
                    $scope.isOptionSelected = false;
                }
            }
        } else if ($scope.actionBtnName == "Try Again") {
            $scope.resetValues();
            $scope.isOptionSelected = false;
            var questObj = $scope.questions[$scope.indexToShow];
            if (questObj.type == "TF") {
                var idx = $scope.selectedAns[$scope.indexToShow];
                $scope.selectedDesc = "";
                if (idx != undefined) {
                    $scope.selectedAns.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var idx = $scope.ansFib[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansFib.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "OWQ") {
                var idx = $scope.ansOwq[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansOwq.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    var idx = $scope.selectedAns[$scope.indexToShow];
                    $scope.selectedDesc = "";
                    if (idx != undefined) {
                        $scope.selectedAns.splice($scope.indexToShow, 1);
                    }
                } else {
                    var emptyarry = [];
                    $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry;
                }
            }
        }
    };

    /* Practice Test Ends*/

    $scope.checkingChoiceExists = function (item) {
        var isChecked = false;
        if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
            $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow];
            return $scope.selectedCheckAns.indexOf(item) > -1;
        } else {
            return isChecked;
        }
    };

    $scope.resetValues = function () {
        //Change button name for next question
        $scope.actionBtnName = "Submit";
        //Empty the answer type and explanation
        $scope.removeErrors();
    };
    $scope.removeErrors = function () {
        //Empty the answer type and explanation
        $scope.answerType = "";
        $scope.ansExplanation = "";
        //$scope.ansFib = [];
        $scope.errorFib = {};
        $scope.errorOwq = {};
        $scope.errorMtf = {};
        $scope.errorMcqQues = {};
        $scope.errorMrQues = {};
        $scope.resultStatus = '';
        $scope.selectedDesc = '';
        $scope.errorTFQues = {};
        $scope.ansExplantionMTF = '';
        $scope.ansExplantionMR = '';
        $scope.ansExplantionFIB = '';
        $scope.ansExplantionOWQ = '';
    };

    /* Invoke while clicking Prev button*/
    $scope.loadPrevQues = function () {
        clearPreview();
        setBtnclickFromPreviewOnOff(false);
        $scope.evaluateQuizQuestion($scope.indexToShow);

        //To send details of each question. if student attend
        submitAnsEachQuestion(false, false);
        $scope.indexToShow = ($scope.indexToShow - 1) % $scope.totalQuestiontoShow;
        $scope.isOptionSelected = false;
        $scope.totalQuestion[$scope.indexToShow].status = $scope.totalQuestion[$scope.indexToShow].status + ' selectedQes';
    };

    /* Invoke while clicking Next button*/
    $scope.loadNextQues = function () {
        $scope.$broadcast('showQuestion');
        if ($scope.clickFromPreview) {
            $scope.evaluateQuizQuestion($scope.indexToShow);
            submitAnsEachQuestion(false, false, true);
        } else {
            setBtnclickFromPreviewOnOff(false);
            if ($scope.indexToShow + 1 != $scope.totalQuestiontoShow) {
                $scope.evaluateQuizQuestion($scope.indexToShow);

                //To send details of each question. if student attend
                submitAnsEachQuestion(false, false);

                $scope.indexToShow = ($scope.indexToShow + 1) % $scope.totalQuestiontoShow;
                $scope.isOptionSelected = false;
                $scope.totalQuestion[$scope.indexToShow].status = $scope.totalQuestion[$scope.indexToShow].status + ' selectedQes';
            } else {
                //To send details of last question. if student attend
                submitAnsEachQuestion(true, false);
            }
            // $scope.startTimer()
        }
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }

    /* Evaluate selected answer*/
    $scope.evaluateQuizQuestion = function (index) {

        var isCorrectAns = false;
        var questionMark = 0;
        var selectedChoice = [];
        var imageData = [];
        var questObj = $scope.questions[index];

        //let mark = $scope.questionCollection[$scope.indexToShow].mark;
        var mark = $scope.questions[$scope.indexToShow].mark_each_qn;

        $scope.stopTimer();
        $scope.timeData = $scope.attendedQuesObj[$scope.indexToShow].timeElapsed + $scope.timeData;

        /*START - MCQ*/
        if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
            if (questObj.pattern == "single") {
                if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                    selectedChoice.push($scope.selectedAns[$scope.indexToShow]);
                    if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    }
                }

                var crctAnsObj = _.find(questObj.choice, function (value) {
                    return value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc;
                });

                if (crctAnsObj != undefined) {
                    isCorrectAns = true;
                    questionMark = parseFloat(mark);
                }
            } else {
                var wrongAnsCount = 0;
                var attendedCount = 0;
                var answerChoiceLength = 0;
                var choosenCorrectCount = 0;
                var choosenWrongCount = 0;
                if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                    var mrqObj = $scope.multipleCheckAnsData[$scope.indexToShow];
                    if (mrqObj) {
                        answerChoiceLength = mrqObj.length;
                    }
                }
                if (answerChoiceLength > 0) {
                    attendedCount += 1;
                }
                //get Correct answer count
                var crctObj = _.filter(questObj.choice, function (det) {
                    return det.correct === true;
                });

                var correctAns = '';
                var choices = [];
                for (var i = crctObj.length - 1; i >= 0; i--) {
                    correctAns += crctObj[i].desc + "[,]";
                }

                _.each(questObj.choice, function (choice) {
                    choices.push({
                        name: choice.desc,
                        "description": {
                            "en-US": choice.hint
                        }
                    });
                });

                var correcrAnswerCount = crctObj ? crctObj.length : 0;
                if (answerChoiceLength === questObj.choice.length) {
                    questionMark = 0;
                    _.each(questObj.choice, function (choice) {
                        if (choice.correct) {
                            if ($scope.checkingChoiceExists(choice.desc)) {
                                //CASE : Correct Ans
                                selectedChoice.push(choice.desc);
                                choosenCorrectCount += 1;
                            } else {
                                wrongAnsCount += 1;
                            }
                        } else if ($scope.checkingChoiceExists(choice.desc)) {
                            wrongAnsCount += 1;
                            selectedChoice.push(choice.desc);
                            choosenWrongCount += 1;
                        }
                    });
                } else {
                    _.each(questObj.choice, function (choice) {
                        if (choice.correct) {
                            if ($scope.checkingChoiceExists(choice.desc)) {
                                //CASE : Correct Ans
                                selectedChoice.push(choice.desc);
                                choosenCorrectCount += 1;
                            } else {
                                wrongAnsCount += 1;
                            }
                        } else if ($scope.checkingChoiceExists(choice.desc)) {
                            wrongAnsCount += 1;
                            selectedChoice.push(choice.desc);
                            choosenWrongCount += 1;
                        }
                    });
                    if (correcrAnswerCount === choosenCorrectCount && choosenWrongCount === 0) {
                        questionMark = parseFloat(mark);
                    } else {
                        if (choosenCorrectCount >= choosenWrongCount && choosenCorrectCount > 0 && choosenWrongCount > 0) {
                            questionMark = parseFloat(parseFloat(mark) / 2);
                        } else if (choosenCorrectCount > 0 && choosenWrongCount === 0 && choosenCorrectCount >= Math.round(correcrAnswerCount / 2)) {
                            questionMark = parseFloat(parseFloat(mark) / 2);
                        }
                    }
                    if (wrongAnsCount == 0) {
                        isCorrectAns = true;
                        questionMark = parseFloat(mark);
                    }
                }
            }
        }
        /*END - MCQ*/

        /* START - TF*/
        else if (questObj.type == "TF") {
                var keepGoing = false;
                var _correctAns2 = false;
                if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                    selectedChoice.push($scope.selectedAns[$scope.indexToShow]);
                }

                var tfAnsObj = _.find(questObj.choice, function (value) {
                    return value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag;
                });

                if (tfAnsObj != undefined) {
                    isCorrectAns = true;
                    keepGoing = true;
                    questionMark = parseFloat(mark);
                }
            }
            /*END - TF*/

            /*START - FIB*/
            else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                    if (questObj.answerImg) imageData.push(questObj.answerImg);
                    var fibAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                    var wrongAnsCount = 0;
                    var _attendedCount = 0;
                    if (questObj.question_answer) {
                        _.each(questObj.question_answer, function (value, key) {
                            if (value != undefined && value.desc != undefined) {
                                if ($scope.ansFib.length > 0) {
                                    if ($scope.ansFib[$scope.indexToShow] == undefined || $scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                        wrongAnsCount += 1;
                                        selectedChoice.push(undefined);
                                        //$scope.stopTimer();
                                        //Case : User doesnt't write
                                    } else {
                                        _attendedCount += 1;
                                        /*let correctValue = removeSpecialCharacter(value.desc)
                                        let studentAnswer = removeSpecialCharacter($scope.ansFib[$scope.indexToShow].choice[key])
                                        */
                                        var correctValue = value.desc;
                                        var studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key];
                                        if (correctValue.toLowerCase().trim() == studentAnswer.toLowerCase().trim()) {
                                            //Case :  Correct Answer
                                            //$scope.stopTimer();                                    
                                            selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key]);
                                        } else {
                                            //Case :  Wrong Answer
                                            wrongAnsCount += 1;
                                            selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key]);
                                        }
                                    }
                                } else {
                                    wrongAnsCount += 1;
                                    selectedChoice.push(undefined);
                                }
                            }
                        });
                    }

                    if (wrongAnsCount == 0) {
                        isCorrectAns = true;
                        questionMark = parseFloat(mark);
                    }

                    /* $scope.stopTimer();*/
                }
                /*END - FIB*/

                /*START - OWQ*/
                else if (questObj.type == "OWQ") {
                        var owqAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                        var wrongAnsCount = 0;
                        var _attendedCount2 = 0;
                        if (questObj.answerImg) imageData.push(questObj.answerImg);
                        if (questObj.question_answer) {

                            _.each(questObj.question_answer, function (value, key) {
                                if (value != undefined && value.desc != undefined) {
                                    if ($scope.ansOwq.length > 0) {
                                        if ($scope.ansOwq[$scope.indexToShow] == undefined || $scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                            wrongAnsCount += 1;
                                            selectedChoice.push(undefined);
                                            //$scope.stopTimer();
                                            //Case : User doesnt't write
                                        } else {
                                            _attendedCount2 += 1;
                                            var correctValue = value.desc;
                                            var studentValue = $scope.ansOwq[$scope.indexToShow];
                                            if (correctValue.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                                //Case :  Correct Answer
                                                //$scope.stopTimer();
                                                selectedChoice.push($scope.ansOwq[$scope.indexToShow]);
                                            } else {
                                                //Case :  Wrong Answer
                                                wrongAnsCount += 1;
                                                selectedChoice.push($scope.ansOwq[$scope.indexToShow]);
                                            }
                                        }
                                    } else {
                                        wrongAnsCount += 1;
                                        selectedChoice.push(undefined);
                                    }
                                }
                            });
                        }

                        if (wrongAnsCount == 0) {
                            isCorrectAns = true;
                            questionMark = parseFloat(mark);
                        }
                        /* $scope.stopTimer();*/
                    }
                    /*END - OWQ*/

                    /*START - MTF*/
                    else if (questObj.type == "MTF") {
                            var db_attended = false;
                            if ($scope.isOptionSelected == true) {
                                var eachOptMark = parseFloat(mark / questObj.optionAnswer.length);
                                var wrongAnsCount = 0;
                                var crctAnsCount = 0;
                                for (var i = 0; i < questObj.optionAnswer.length; i++) {

                                    var optionsObj = questObj.option[i];

                                    if (questObj.optionAnswer[i].tag == optionsObj.answer.tag) {
                                        crctAnsCount++;
                                        var desc = questObj.optionAnswer[i].desc !== undefined ? optionsObj.answer.desc : undefined;
                                        var mtfAnsObj = {
                                            "desc": desc,
                                            "optImage": optionsObj.answer.optImage,
                                            mtf_question_tag: optionsObj.answer.mtf_question_tag,
                                            right: true
                                        };
                                        selectedChoice.push(mtfAnsObj);
                                    } else {
                                        //Case : Wrong Answer
                                        wrongAnsCount += 1;
                                        var _mtfAnsObj = {
                                            "desc": questObj.optionAnswer[i].desc,
                                            "optImage": questObj.optionAnswer[i].optImage,
                                            mtf_question_tag: optionsObj.answer.mtf_question_tag,
                                            right: false
                                        };
                                        selectedChoice.push(_mtfAnsObj);
                                    }
                                }

                                //questionMark = parseFloat(eachOptMark * crctAnsCount) 
                                if (wrongAnsCount == 0) {

                                    isCorrectAns = true;
                                } else {
                                    isCorrectAns = false;
                                }

                                var correctans = '';
                                var source = [];
                                var target = [];

                                for (var i = 0; i < questObj.length; i++) {
                                    var optionsObj = questObj.option[i];

                                    correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]";

                                    source.push({
                                        "id": optionsObj.question.desc,
                                        "description": {
                                            "en-US": optionsObj.question.desc
                                        }
                                    });

                                    target.push({
                                        "id": optionsObj.answer.desc,
                                        "description": {
                                            "en-US": optionsObj.answer.desc
                                        }
                                    });
                                }
                            } else {
                                db_attended = true;
                            }

                            var isAttend = false;

                            if (questObj.answer && questObj.answer.length > 0) {
                                isAttend = true;
                                if (selectedChoice.length == 0) {
                                    if (db_attended && questObj.is_attended) {
                                        var arr = [];
                                        for (var _i = 0; _i < questObj.optionAnswer.length; _i++) {
                                            var tag = questObj.quesData[_i].tag;
                                            var _obj = {
                                                "desc": questObj.optionAnswer[_i].desc,
                                                mtf_question_tag: tag
                                            };
                                            arr.push(_obj);
                                        }
                                        if (arr && arr.length) {
                                            selectedChoice = arr;
                                        }
                                    } else {
                                        selectedChoice = questObj.answer;
                                    }
                                }
                            } else if ($scope.attendedQuesObj[$scope.indexToShow] && $scope.attendedQuesObj[$scope.indexToShow].answer && $scope.attendedQuesObj[$scope.indexToShow].answer.length > 0) {
                                isAttend = true;
                                var _arr = [];
                                if (!selectedChoice.length) {
                                    for (var _i2 = 0; _i2 < questObj.optionAnswer.length; _i2++) {
                                        var _tag = questObj.quesData[_i2].tag;
                                        var _obj2 = {
                                            "desc": questObj.optionAnswer[_i2].desc,
                                            mtf_question_tag: _tag
                                        };
                                        selectedChoice.push(_obj2);
                                    }
                                }
                                // console.log(arr)
                                // if(arr && arr.length){
                                //     selectedChoice = arr
                                // }else{
                                //     selectedChoice = $scope.attendedQuesObj[$scope.indexToShow].answer
                                // }
                            } else {
                                isAttend = $scope.isOptionSelected;
                            }

                            var obj = {
                                questionId: questObj.question_id,
                                mark: 0,
                                timeElapsed: $scope.timeData,
                                q_type: questObj.type,
                                answer: selectedChoice,
                                section_name: questObj.section_name,
                                is_attended: isAttend
                            };
                            $scope.attendedQuesObj[$scope.indexToShow] = obj;

                            //console.log($scope.totalQuestion[$scope.indexToShow].label)

                            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                                $scope.totalQuestion[$scope.indexToShow].status = 'review';
                            } else {
                                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                            }

                            /* $scope.stopTimer();*/
                        }
                        /*END - MTF*/

                        /*START - SA*/
                        else if (questObj.type == "SA" || questObj.type == "LA") {
                                isCorrectAns = true;
                                questionMark = parseFloat(mark); //.total;
                            }
        /*END - SA*/

        if (questObj.type == "SA") {
            var _isAttend = false;
            if ($scope.ansSa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                if (_.compact($scope.ansSa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                    $scope.attendedQuesObj[$scope.indexToShow] = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: $scope.ansSa[$scope.indexToShow],
                        section_name: questObj.section_name,
                        is_attended: true
                    };
                    _isAttend = true;
                    /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    } */

                    //$scope.attendedQuesObj[$scope.indexToShow] = obj
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            } else {
                $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
             if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
             $scope.totalQuestion[$scope.indexToShow].status = 'submit';
             }
             }*/
        } else if (questObj.type == "LA") {
            var _isAttend2 = false;
            if ($scope.ansLa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                if (_.compact($scope.ansLa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                    $scope.attendedQuesObj[$scope.indexToShow] = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: $scope.ansLa[$scope.indexToShow],
                        section_name: questObj.section_name,
                        is_attended: true

                    };
                    _isAttend2 = true;
                    /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    } */

                    //$scope.attendedQuesObj[$scope.indexToShow] = obj
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            } else {
                $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend2) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
             if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
             $scope.totalQuestion[$scope.indexToShow].status = 'submit';
             }
             }*/
        } else if (questObj.type == "DRAW") {
            if (questObj.answerImg !== undefined) {

                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    /* images: $scope.imageData[$scope.indexToShow],*/
                    answer: $scope.ansDraw[$scope.indexToShow],
                    answerImg: questObj.answerImg,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "ASLLISTEN") {
            if (_.compact(_.flatten(_.pluck($scope.ansAslListen[$scope.indexToShow].ans, 'answer'))).length > 0) {
                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: $scope.ansAslListen[$scope.indexToShow].ans,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "ASLSPEAK") {
            if ($scope.ansAslSpeak[$scope.indexToShow].answer != '') {

                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: $scope.ansAslSpeak[$scope.indexToShow].answer,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB" || questObj.type == "OWQ") {
            var _isAttend3 = false;
            if (selectedChoice || $scope.imageData[$scope.indexToShow]) {

                //console.log(_.compact(selectedChoice))
                //console.log(selectedChoice)
                //console.log($scope.imageData[$scope.indexToShow])

                var ansData = _.compact(selectedChoice);
                var imgData = $scope.imageData[$scope.indexToShow];

                if (ansData && ansData.length > 0 || imgData && imgData.length > 0) {
                    var _obj3 = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: selectedChoice,
                        section_name: questObj.section_name,
                        is_attended: true

                    };
                    _isAttend3 = true;
                    /*  if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     } */
                    $scope.attendedQuesObj[$scope.indexToShow] = _obj3;
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend3) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }
        } else if (questObj.type != "MTF") {

            var _isAttend4 = false;
            var _mark = 0;
            var _ansData = _.compact(selectedChoice);
            if (_ansData && _ansData.length > 0) {
                if (questObj.type !== 'MTF') {
                    _mark = questionMark.toFixed(2);
                }
                /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                } */
            }

            /* console.log("==========================")
            console.log(ansData)
            console.log($scope.multipleCheckAnsData)
            console.log(questObj.answer)
                console.log("==========================") */

            var _obj4 = {
                questionId: questObj.question_id,
                mark: _mark,
                timeElapsed: $scope.timeData,
                q_type: questObj.type,
                answer: selectedChoice,
                section_name: questObj.section_name,
                is_attended: _ansData && _ansData.length > 0 ? true : false
            };

            _isAttend4 = _ansData && _ansData.length > 0 ? true : false;
            $scope.attendedQuesObj[$scope.indexToShow] = _obj4;
            //$scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend4) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }
        }

        /*  else {
            if (_.compact(selectedChoice).length > 0) {
                let mark = 0
                if (questObj.type !== 'MTF')
                    mark = questionMark.toFixed(2)
                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: mark,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: selectedChoice,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected,
                    imageData: imageData
                }
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            } else
                $scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected
        } */
    };

    /* Set selected answer for evaluation */
    $scope.setSelectedAns = function (option, quesType, ansType, index) {
        var is_single_pattern = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        if ($scope.actionBtnName === "Try Again") {
            $scope.actionBtnName = "Submit";

            $scope.resetValues();
            $scope.isOptionSelected = false;
            var questObj = $scope.questions[$scope.indexToShow];
            if (questObj.type == "TF") {
                var idx = $scope.selectedAns[$scope.indexToShow];
                $scope.selectedDesc = "";
                if (idx != undefined) {
                    $scope.selectedAns.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var idx = $scope.ansFib[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansFib.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "OWQ") {
                var idx = $scope.ansOwq[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansOwq.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    var idx = $scope.selectedAns[$scope.indexToShow];
                    $scope.selectedDesc = "";
                    if (idx != undefined) {
                        $scope.selectedAns.splice($scope.indexToShow, 1);
                    }
                } else {

                    var emptyarry = [];
                    $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry;
                }
            }
        }

        if (quesType == "MCQ" || quesType == "TF") {
            $scope.isOptionSelected = true;
            $scope.selectedDesc = option;
            $scope.selectedAns[$scope.indexToShow] = option;
        } else if (quesType == "MR") {
            $scope.isOptionSelected = true;
            $scope.selectedCheckAns = [];
            if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow];
                var idx = $scope.selectedCheckAns.indexOf(option);
                if (idx > -1) {
                    $scope.selectedCheckAns.splice(idx, 1);
                } else {
                    $scope.selectedCheckAns.push(option);
                }
            } else {
                $scope.selectedCheckAns.push(option);
            }
            if (is_single_pattern) {
                $scope.selectedCheckAns = [option];
            }
            $scope.multipleCheckAnsData[$scope.indexToShow] = $scope.selectedCheckAns;
        } else if (quesType == "FIB") {
            if ($scope.ansFib[$scope.indexToShow] != undefined) {
                $scope.isOptionSelected = true;
            }
        } else if (quesType == "OWQ") {
            if ($scope.ansOwq[$scope.indexToShow] != undefined) {
                $scope.isOptionSelected = true;
            }
        } else if (quesType == "ASLLISTEN") {
            if (ansType == "MCQ" || ansType == "TF") {
                $scope.ansAslListen[$scope.indexToShow].ans[index].answer = option;
            } else if (ansType == "MR") {
                $scope.selectedCheckAns = [];
                if ($scope.ansAslListen[$scope.indexToShow].ans[index].answer[$scope.indexToShow] != undefined) {
                    $scope.selectedCheckAns = $scope.ansAslListen[$scope.indexToShow].ans[index].answer;
                    var idx = $scope.selectedCheckAns.indexOf(option);
                    if (idx > -1) {
                        $scope.selectedCheckAns.splice(idx, 1);
                    } else {
                        $scope.selectedCheckAns.push(option);
                    }
                } else {
                    $scope.selectedCheckAns.push(option);
                }
                $scope.ansAslListen[$scope.indexToShow].ans[index].answer = $scope.selectedCheckAns;
            }
        }
    };

    var quizMarks = {
        'student_id': userId,
        'date': currentDay,
        'time_elapsed': $scope.elapsedTime,
        'score': 0,
        'total_mark': 0,
        'activity_id': activityId,
        'qp_id': qpId,
        'result': []

        /* Invoke while submitting last question */
    };$scope.submitQuizQuestion = function () {
        $scope.stopTimer();
        $scope.evaluateQuizQuestion($scope.indexToShow);
        var isReviewedQuestionCount = 0;
        _.each($scope.totalQuestion, function (question, key) {
            if (question.status == 'review') {
                isReviewedQuestionCount++;
            }
        });
        if (isReviewedQuestionCount == 0) {
            var confirm = $mdDialog.confirm().title('Do you want to submit the exam?').targetEvent(event).ariaLabel('Information').ok('YES').cancel('NO');
            $mdDialog.show(confirm).then(function () {
                $scope.submitExam();
            }, function () {
                //toastr.success("You decided to continue the exam")
            });
        } else {
            var confirm = $mdDialog.confirm().title('You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam').targetEvent(event).ariaLabel('Review Alert').ok('YES').cancel('NO');
            $mdDialog.show(confirm).then(function () {
                $scope.submitExam();
            }, function () {
                toastr.success("You decided to continue the exam");
                // ToastService.getToastbox($mdToast, 'You decided to continue the exam', 'success-toast')
                //'You decided to keep your entry.';
            });
        }
    };

    /* Submit exam data to server */
    $scope.submitExam = function () {
        $scope.isSubmitted = true;
        localStorage.removeItem("backfromexam");
        localStorage.setItem('activitySubmitted', true);
        var finalScore = 0;
        var timeSpent = 0;

        for (var i = 0; i < $scope.attendedQuesObj.length; i++) {
            if ($scope.attendedQuesObj[i] != undefined) {

                //Get Spent Time
                timeSpent += parseInt($scope.attendedQuesObj[i].timeElapsed);

                finalScore += parseFloat($scope.attendedQuesObj[i].mark);
                if ($scope.attendedQuesObj[i].q_type == "SA" || $scope.attendedQuesObj[i].q_type == "LA") {

                    if ($scope.attendedQuesObj[i].images != undefined) {
                        _.each($scope.attendedQuesObj[i].images.images, function (imgs) {
                            delete imgs.$$hashKey;
                        });
                    }

                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answerImg: $scope.attendedQuesObj[i].imageData,
                        answer: $scope.attendedQuesObj[i].answer ? $scope.attendedQuesObj[i].answer : "",
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                } else if ($scope.attendedQuesObj[i].q_type == "DRAW") {
                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answer: $scope.attendedQuesObj[i].answer,
                        answerImg: $scope.attendedQuesObj[i].answerImg,
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                } else {
                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answer: $scope.attendedQuesObj[i].answer,
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                }
            }
        }
        quizMarks.time_elapsed = $scope.elapsedTime;
        quizMarks.score = finalScore; //.toFixed(2)
        quizMarks.total_mark = $scope.quizTotalMark;
        quizMarks.activity_id = activityId;
        quizMarks.qp_id = qpId;
        quizMarks.time_spent = timeSpent;

        if ($scope.totalTimeRemaining) quizMarks.totalTimeRemaining = $scope.totalTimeRemaining;
        $scope.isPracticeTest = false;
        $scope.isActivity = false;
    };

    /*
     * To submit attended question to server
     * 
     * @isLstQues : Boolean - Last question check
     * @isAutoSubmit : Boolean - Auto submission check
     * @return : null
     * @Developer : Jeevanantham N
     */
    var submitAnsEachQuestion = function submitAnsEachQuestion(isLstQues, isAutoSubmit, frpmPreview) {
        if ($scope.attendedQuesObj.length && $scope.attendedQuesObj[$scope.indexToShow]) {
            var resultObj = {};
            var ansObj = $scope.attendedQuesObj[$scope.indexToShow];
            if (ansObj && ansObj.questionId != undefined || isLstQues && !isAutoSubmit) {
                var timeSpent = 0;
                _.each($scope.attendedQuesObj, function (data) {
                    if (data && data.timeElapsed) {
                        timeSpent += parseInt(data.timeElapsed);
                    }
                });

                resultObj = {
                    question_id: ansObj.questionId,
                    mark: ansObj.mark,
                    time_elapsed: ansObj.timeElapsed,
                    q_type: ansObj.q_type,
                    answerImg: "",
                    answer: "",
                    q_status: $scope.totalQuestion[$scope.indexToShow].status,
                    section_name: ansObj.section_name,
                    is_attended: ansObj.is_attended != undefined ? ansObj.is_attended : false
                    //question_index: $scope.indexToShow

                    //If theer is no answer while submitting last question
                };if (isLstQues && resultObj.question_id == undefined) {
                    var questObj = $scope.questions[$scope.indexToShow];
                    resultObj.question_id = questObj.question_id;
                    resultObj.q_type = questObj.type;
                }

                if (ansObj.q_type == "SA" || ansObj.q_type == "LA" || ansObj.q_type == "OWQ" || ansObj.q_type == "FIB" || ansObj.q_type == "MTF") {
                    if (ansObj.images != undefined) {
                        _.each(ansObj.images.images, function (imgs) {
                            delete imgs.$$hashKey;
                        });
                    }
                    resultObj.answerImg = ansObj.imageData;
                    resultObj.answer = ansObj.answer ? ansObj.answer : "";
                } else if (ansObj.q_type == "DRAW") {
                    resultObj.answer = ansObj.answer;
                    resultObj.answerImg = ansObj.answerImg;
                } else {
                    resultObj.answer = ansObj.answer;
                }

                var requestObj = {};

                //activity_id:, student_id:
                /* requestObj["activity_id"] = "KDqybKrnxrC44";
                requestObj["qp_id"] = "Gn4JwyXBAMtp9JZ2c";
                requestObj["student_id"] = "7vprkAsiMgMRESaf9"; */

                requestObj["activity_id"] = activityId;
                requestObj["time_spent"] = timeSpent;
                requestObj["qp_id"] = qpId;
                requestObj["student_id"] = userId;
                requestObj["total_mark"] = totalMark;
                requestObj["result"] = resultObj;
                requestObj["qn_number"] = $scope.indexToShow;

                if (isLstQues && !isAutoSubmit) {

                    var isReviewedQuestionCount = 0;
                    isReviewedQuestionCount = _.filter($scope.totalQuestion, function (dta) {
                        return dta.status == 'review';
                    }).length;
                    var answFailureArr = localStorageService.get("failureQuestIds");
                    if (answFailureArr && answFailureArr.length) {
                        var str = "There are " + answFailureArr.length + " not saved question(s). Please submit the answers.";
                        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('WARNING').textContent(str).ariaLabel('Alert Dialog Demo').ok('Ok'));
                    } else {
                        var msg = 'Do you want to submit the exam?';
                        if (isReviewedQuestionCount > 0) {
                            msg = 'You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam';
                        }

                        var confirm = $mdDialog.confirm().title(msg).targetEvent(event).ariaLabel('Information').ok('YES').cancel('NO');
                        $mdDialog.show(confirm).then(function () {
                            var back = true;

                            submitAnswer(requestObj, back, frpmPreview);
                        }, function () {});
                    }
                } else {
                    var back = false;
                    if (frpmPreview) {
                        back = true;
                    }
                    submitAnswer(requestObj, false, frpmPreview);
                }
            } else {
                if (frpmPreview) {
                    $scope.showPreview();
                }
            }
        }
    };
    /**checks schoollogo is get within 5 seconds; else 
     * assume as no network and show toast
    */
    function doesConnectionExist() {
        try {
            var logo = localStorageService.get("school_logo");
            if (logo) {
                var processRequest = function processRequest(e) {
                    if (xhr.readyState == 4) {
                        if (xhr.status >= 200 && xhr.status < 304) {} else {
                            toastr.error("Network error.Please try after sometime..");
                        }
                    }
                };

                var xhr = new XMLHttpRequest();
                var file = CONSTANTS.FILE_UPLOAD_URL + logo;
                xhr.open('HEAD', file, true);
                xhr.timeout = 5000; // time in milliseconds
                xhr.ontimeout = function (e) {};
                xhr.send();
                xhr.addEventListener("readystatechange", processRequest, true);
            }
        } catch (e) {
            console.log(e);
        }
    }
    function removeFromLocalfailureQuestIds(requestObj) {
        var answFailureArr = localStorageService.get("failureQuestIds");
        if (requestObj && requestObj.result) {
            if (!answFailureArr) {
                answFailureArr = [];
            }
            for (var i = 0; i < answFailureArr.length; i++) {
                if (answFailureArr[i] === requestObj.result.question_id) {
                    answFailureArr.splice(i, 1);
                }
            }
            localStorageService.set("failureQuestIds", answFailureArr);
        }
        if (!answFailureArr) {
            answFailureArr = [];
        }
        localStorageService.set("failureQuestIds", answFailureArr);
    }
    /**varunsj 20-10-2021
     * on load, set not saved for not saved questions
     */
    function _checkForFailuresOnLoad(answFailureArrOnLoad) {
        var totalQuestions = $scope.totalQuestion;
        if (answFailureArrOnLoad && answFailureArrOnLoad.length) {
            if (totalQuestions && totalQuestions.length) {
                for (var i = 0; i < totalQuestions.length; i++) {
                    var oneItem = totalQuestions[i];
                    if (oneItem.question && oneItem.question.question_id) {
                        if (answFailureArrOnLoad.indexOf(oneItem.question.question_id) !== -1) {
                            oneItem['status'] = 'uploading';
                        }
                    }
                }
            }
        } else {
            localStorageService.set("failureQuestIds", []);
        }
    }
    function addToLocalfailureQuestIds(requestObj) {
        if (requestObj && requestObj.result) {
            var answFailureArr = localStorageService.get("failureQuestIds");
            if (!answFailureArr) {
                answFailureArr = [];
            }
            if (requestObj.result.is_attended) {
                var pushDataDupChk = answFailureArr.includes(requestObj.result.question_id);
                if (!pushDataDupChk) {
                    answFailureArr.push(requestObj.result.question_id);
                }
                $scope.totalQuestion[requestObj["qn_number"]].status = 'uploading';
            }
            localStorageService.set("failureQuestIds", answFailureArr);
        }
    }
    var submitAnswer = function submitAnswer(requestObj, isBack, frpmPreview) {
        //  doesConnectionExist() /**checks connection: commmented on 2-12-2020 */
        authService.callAPI(activityCons.API_SUBMIT_EXAM_QUESTION, "POST", requestObj, function (response) {
            try {
                if (response.result != undefined) {
                    if (isBack) {
                        stopExam(requestObj);
                    } else {
                        if (frpmPreview) {
                            $scope.showPreview();
                        }
                    }
                    removeFromLocalfailureQuestIds(requestObj);
                } else {
                    if (response.error && response.error.error && response.error.error.status === "completedExam") {
                        toastr.success("Exam is over");
                        stopExam(requestObj);
                    }
                    addToLocalfailureQuestIds(requestObj);
                }
            } catch (e) {
                console.log(e);
            }
        });
    };

    var stopExam = function stopExam(requestObj) {
        var res = _.pick(requestObj, "student_id", "qp_id", "activity_id");
        authService.callAPI(activityCons.API_SUBMIT_EXAM, "POST", res, function (response) {
            if (response.result != undefined) {
                clearTimer();
                toastr.success("Your answer is submitted successfully");
                $state.go('qpSummary', {
                    qpId: qpId
                }, {
                    reload: true
                });
            } else {}
        });
    };

    var stopExamAuto = function stopExamAuto(requestObj) {
        var res = _.pick(requestObj, "student_id", "qp_id", "activity_id");
        authService.callAPI(activityCons.API_SUBMIT_EXAM, "POST", res, function (response) {
            if (response.result != undefined) {
                clearTimer();
                toastr.success("Your exam time is over, Exam auto submitted.");
                $state.go('qpSummary', {
                    qpId: qpId
                }, {
                    reload: true
                });
            } else {}
        });
    };

    $scope.submitLastQuestion = function (isLstQues, isAutoSubmit) {
        $scope.evaluateQuizQuestion($scope.indexToShow);
        submitAnsEachQuestion(isLstQues, isAutoSubmit);
    };

    /*
     * Function to cancel timer
     */
    $scope.$on("$destroy", function () {
        if (angular.isDefined(timeinterval)) {
            $interval.cancel(timeinterval);
        }
    });
    function clearPreview() {
        $scope.previewLoad = false;
        $scope.loadQuestionDirective = true;
    }
    $scope.showPreview = function () {
        setBtnclickFromPreviewOnOff(false);
        $scope.previewLoad = true;
        $scope.loadQuestionDirective = false;
    };
    $scope.answerPreview = function () {
        $scope.evaluateQuizQuestion($scope.indexToShow);
        submitAnsEachQuestion(false, false, true);
    };
    $scope.clickedOneQuestion = function () {};
    $scope.loadlastQuestion = function () {
        $scope.changeQuestion($scope.totalQuestiontoShow - 1);
    };
}];

exports.default = StudentQuestionSelection;

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAATCAYAAACDW21BAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAq9JREFUeNqklVuITVEYx88+jiFmxiXl0mhIRDIpl+T+Yl5oDFLINeSWECGXBw/CgwwPJtRILuMwJA0vExGpya0YRaOkQR4Yjbtz5szx+/Tftdr2PqN89Wuttffa67++b33r2142m40Nv3Y7FmEdYAksg36QgLdwGk5Aq016Nn3Kn8msU0ZTDFU8+xa2YCIWbT3hMgyEY3AHUjAJdsN8mA0fJFZBMxNaYAis/1fBQiiCo9ARRsIn5329eQDX4SQsRuwcbV+YCKNhW5QX8cB4OzTADegPZQEx35qhHAbBffhhYoTRwp0P6ShB18OlsAPmwVP4Dh9zhPy9NtYHobk55lm4R9EUMO+W6+EK2KtQNbUj5lsNjGDBkgihQhhLtzdU0+/lChbpwKOsW8gzS+89sI/FwvKhM1yBN/AA1viCh3Se9yLEVsMTZWXQqrXgOOfZVzawhXayrs8mOA4z4rwopbPKBlo0aGuhUkmUhDkhc+4qO33L6ow3Qi2UaFP55tUCuBki5mlnB2ArPIddcFbfBBOoR6BgvICu8Etjz78W+REJUqCMnQXnoTtUKBrLtYhvnQJXLK3vHikyLboRbQk9XBQi+AXGQ8YyUc/Mi1PyMuPMHaqQ+dYFLsqRpL6ZCo1x1UXb/eaAYNZZ1Au8a3X6Vo1KdSy+5XHnHmveK6hTqatM8KKJxFmpHdnhXoLPCpEJvXQEMvLGwtSmMFlhb2CdxsBmrai/s/Nm/YVWixnX+XenVi7vhMPORwllaFJjE16nsuZvYgBMaKdAXEDsTLCW1qt2WqUfJqy/X2di3ubBBhgsTw27b1fxolzrpIJHgFgq198iHVJ8Pae1UP503h1UwlQhWhzyQ8j5t4gyz/HyL8MDC/k0naclx5H/FXytItAcNQHRhzRWqMfQr4ma91uAAQD1F8J0VO6hlgAAAABJRU5ErkJggg=="

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 167 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAAAzCAYAAAByki+qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABv8SURBVHgB7V1bbBzXef7PmVleZFdaFUjRNG28eiiq2KK0QtHWsSlxGaB9FZWX9qGAlmgqQTZQkracPBQoly8FEtshmSBWZBflEn3KS0gXKPLUcKiL7TSJtboFRgvHYzdNW6SoVvWFS+7MOf3/c2Z257a7s1xSN+8HLLk7c+bc//Nfzxm2cfXJ3CBklqRkuQ/+axA++O8huHJ9L1y+loVf/GoPEBh+JITB1B8GUsrQff87/RdS2hw/Egxry2Xr77zzdRv66KOPrsDE28fWhIQCY/Gb/3jpM3Bh9XPwy18NBi8jXUrG9ANSESlLejoOTFuuu+Zcn1j76CM9mPMvoyvI9iaIziQj5hjmm/T7/Pd/C777/c/JAC0yRZ36PvOpNki9PihVhISRqvkiN7bmKpWFKvTRRx9twTbefDKX4ZkSkt1jjPEs0lCeZFVNsDoRUeO/frAHzn79C5Xqh6YiLIEf7mUS/C7xecaMLOaFBOqCR8vNAj0RGf/YW645vl2uWih8Jy8lnw9eI0598eIzy9BHKoyOfrtgGOZs8BqO3Yxlna5AHz1j5NC5teBvnPqV6zdemoEuYQ5/8S0b/xeDF+tvjha4wU4hsRaVfokU+Huf/wR++J2fAGfmSXbUaskBjxz66g8NIzPOjQxwTh8DiUfAZu3/QAinSbSM5TKm+8ODB7/2pe0RKi0oUAhfk+vQR2qYJs/hcBTCV90s9LEjYJH5KSVsCzzpYuaLly3jDy9Ncsc4wFywwcWLLhbhsrwQ7ny7DJXYS7xXVwj/cpnJ7IG92d+xkbfO6cp6ojLAgUFTrOTz0/2J0UcfLcDb3WRftNA6a4wjgVaki8TnIm25UHR+cvxUq2ek/tNYMxhvaKSycvPlEhfsKFJytZle5oU7MAt99NFHIninBIpQayYSKnFU1CcdtPs4Yl5eLbTgfkIrnkSa9Fc2KFYRa+VnL1ZQAP6ybCqrKA27U/mDX8tBH330EUNHIiWwcasqt+SkshAJpDuX7a9/XC+2zNInwAZ9yhB3RY5qIRl/y+exJCILU0xDH330EUMqIiVkxi9byE0trZ/igy470Sqt544Bj59KxUQjnlRuuiVMQ2Kvb0M+9WnWTQuF87lCYem+bD/VayfrlstNZ/MHp3O7lf5eYbfqaHaTWNbR8GOgxUqJsqwg1wpZ4rJJabWrBar4JeszzOB98pEePvT8MhLqX3m+1azjGHn8b0GPoAkvhJzGbGkhyQVuWeSm4ZytW9ZZO11eS1khPjmFLqUJ5Z4C5k1WWmBYpVN+hcIrC+g93uf/poUJ3UQzOt/aFLa8QMm07FGDsbHzlA9JGnPp6/jKBLqj0E4gCs36KZArpYJL5uuW9cwqdIFC4dtYJxPzlJh3TeWJdaN/VjtX18gTzy8FfzMwrOu3vrFMhLb3UXMK50MROyFHQtnhQ+doBbdQ/Zkj6Sr4XP7Q8wUX+BTz2uSn121i5S2Hv57GK9AoF2CCsg3corGr+ME1h7A8tHiGbC1Gxp3xffmHD72A4yj2NdvFrl2/9dLC44+/kDe4nGdkW8F6+nW8fvOlo9AFkBamcA7ko9ddyRdTRQr5IKJ0HOe275aRrjg68CdvhHxqR0a+toa+twJjmWW0M00PDz+6wLl5Ct0y9sWLzx4Iph0ZeX6CSbai8qZACGDPUcPT1AUJkSZ2yA+FnYjWY+M2TspOedhYXKmTT/X48e8iEYlSZOIn5oeLwuKlS8/EysWJ/R6EFwobCXDcq3uuXZ7Yjpl2xOUR0lKHfELlBgkffc1FJO4wUWEaIdgJLLuT+lFmbAjrNxlapHGShhwNjKLMcKKZXKx16McSTuw5Iqpfe9RcYTH3WgQUbsqNmRs3vtGyf2jiU74pxq8kGXsf6xrqC+44ByrvLNgqr5EX3qPFpVE8LaTYNuywcrxuzL5+68UD0b6gZ27cfGk8mvzIyAtLOB+LsWyEmLzxs2+WU4u7BKWbuszWuqnSMfNJ6QRW/qdXS8VKpVR9881zRSwukRiMutsgcCUac3gMegByu1MpCJSQQy5bPn78fKJVmbgcEteazqvjAKv8kJvO4zNLKdJCCgJVeeKytUJcMunm8eMXZpFA0+QTyA/ew+dOQfu6zaYgUAISeG2lUyKB/nCTiZU0hILcamrvI8bVjgRKwHyZFCvEAZNu08THRGnHr8SEnIIuwIhgGbSYazJVJB0tSBTwECdQWUXyGicCpV9dEakCEaiD2TjITB0m47fFcuXa304Gr125MlPkHOKEOqRigqUGrj9C9qr35LpJjAtDKWnSSrlBxFZo8ZjtfZJQPH78lbZ+ZNB1zEFKIKEuRfVBIlDN4bsHPlcmKaRNknb3YmmPHXulLUErgkOCglTARTF1Wg0uYSlqy0AONpvEmdqCJTOc1ulZrtUCgCJhRyI9iN6MvY+Ya7EFiTalCD5+MyD+d02kSJyaUMmAJHmsMjduvFhOes6yni3FLtY26a+3oSZdkH5a4CAt4oScJPENP7hoyESxCNMsBImAREC8GuFesko6Iop3+9fXzx6gD32na/H82HQHIojkKU8265hI/FnX3Sg263c+14ZArWab5Unsg0QJBhfEpRSGoEBeJJ4n54USRDoOhJMP/0wTh6APtMgvCBInJbaD0pPop/OIJmI5dyvTGK+D2pVXSqhAFUW8RT+/tHVIA6nsKBSoQxKInGMt5lqwjgOGsxZbGIhAXXec3JTBy90ZjlYK2bpwtEjK0Y7kyjvQC0wjp3VRL3+GonTvULrX+vozduQ6cRAU0eR8ZAUkwxBxg5Kqg+QxERgJ7yTqclbwmqeLlTBPmyZ98B6JjNDWAEYEyo5GDUOYl5UkCiMhHPG/o+5biq9nKr9YHRGrmGcpkif1zyTVHxckSAIS+CLqwlEOaXltjfZP7sknz+feequNkYsm38fu0Yod2lBhjTz+nMU4T1YRJMxcu/VyVJwsk3gY5T6ciTG6R98zhlOKuRL8ye/pl8E6oEW2JAxjrVsOHsh87sbNl0tpUzcJNFKehArW8WRCHbvjpK50x0jM1ZFHEoaqZgV6ADLkCcVBvVnHdyD2NmocCQKvo7HDSOB+XIm8HgfMRW6XEyZ/KE+IE2S+Qx0TLbd0zeOoUeR0/eaz2FWn4vklEmgwTzJWKEMUSQHt2kPpEgjUz6uUpG8NDbUX3xWB2PEdT6RzyYTFjK61MiBKL7Q0fI2p/iaxN6l/WhCoAl13JD8J2wBx+utdECjpsUkESu3lHzst69gVJ3XrJOdLRU1oAVxnk1YqBbklJJwA5m8Rp9q4PRE9aIKy2yWwrDMLY2OvzEa4qeIGQogC7d4JVVHKO1oEbg3t7w2t3tn23IW1EYdq2AdD0Ys5/W8oHy8bXkfCs6ANvD45ACmAbXm9/X1YRqJPb2RBDtFq8hFQNLyGfwuha9imVulJV0OrbTU8ft537cKLFA9Wu/IJP0Px8vATzy9DAoG3g8ugO3E5gVsjh1q9fvPFtotEaiLd+IfRgnTkBO1AI5Md52h+7gGeX+gx5k1uWpV63V+KC8dqmnQ0sXGihQaEuAE+n4umxZV5qimQp4fHXeyke+0WEsuaqXr+yASIXFT4QaKyYAeBfWN3SFGNiZPtUnc2olTjdWDtn2FoC5FxI6PLOFp8I1sj2xB8qEzOyaXSFZHejPh2twOUDHIkAbSb+6nE3Y2lJ3NMiCUyFkkHp7eQ9sCfXtm20q2Ve1ZizR3mUri8DHcNcQOE6xIBPIiQPS1su5/fvUVHgvdgSGFDN5A7Yj8h5N16pq1HoCORbpxHApXGChCXISJFXRR/l2CboED6gQw5tsFfCYlWl2+882LP+iiS2v40qVAvPRK9Zhjchh1ErdaJI+0UUvkBP7VAyS+VawV9+925YHpCeCFEW0GR3EatUrcl0g/PjxbQtLiGFp4jtJ9UCiU+LAz8+cVtcVEK9RKoOKNCGwxaeI8Z9TnYAXDOU4oriQNClsuYTozW1Bnk9we6/bS1dm4b8YUELb8n0jx5v8YF7yRcNz5+KE4eSfMsehbGYNchq2qrppRJ872EenHi/I3ppHKpkP2o5uRNQ85iZgWlfwgdJM8Zqwxws2uCIuKUjM/ialVgnJHVSYUv4Pc73GVfRnnchp1BgSy07ayXFAigdbsQbNIT8dlKdPc8EQHeW4D7AmRUGowYTTq3mXyrUtbWjh9/pfQwHy+jDEARoxK5a2jyX7/1cst2K+YR843vPFAGrXg+UKpnDmsXNsAxtoCqYOxUTXPjtdEC6ptTuJJkKTaxtlXPmRwgeIYnbWj56S/2wV//4Hft6oY5P/LE70MacMazaGWiDsiqfaV6CxvzdNHbSKBfijpue4V21J+fTJq0zVjc6DNcXaNn0GhDzxUCtwsUPnjx4tm2ixPF0QphnKDgedglkFEJCS1mXcU2r+D16SQC1PG9UoXlUSgktg9tAcbJh/gcI+qD2OQ//MRXgQL9o4k1gULH8MadBrpuptHneyTi882SiwYNSUeDhiQTyCBEpmH/QJMIPtw04bUf/TZ879pn6eeEprLWhQdPB6QtpJHTAvU5oLTzwTQmK5VdOdqTYlTXiNhQPl/lHO4IwR/Tu01IMojB5lw09GHyYUbP/aHwQXTbTOD1BbRqo8vAj7Ry0CJsjlHe0jsWFYmlspvcivPNkpSDp6IBGR4BFrHN69hmWwiKT+Zj8TOMqH9cmpSpXDIPGrjjLgjTiPUPMEGBEEVyeaAwd0dI2Iezc0J0Fwa5ozAcZzIWSEERVI5J4zPuX0KeyXLtDkj6aNNQn2YemhBbIUrAgVgF8BcBRr6r3SHQIMjnuUC7PIjIoMVgYJqZoEuEuCmFFCakzBMhYH5XKVBdf8y1aN6YZmE39T/iplhGK25NbZ7VbVaRU4V4EhWOOA4PKZRPNFnn8w4GkwtC7XaRC+weEiihVSAF1Wtk5FzD4kuCbREHnUQfuyHjBijts3s34W/++F2YOWYHM1FoRazR69ITdVlThi6hNevnu3BkSlcinN4KdibmW0VOOJ1MqGlAbaztqqVQR07x7YjVFHU0nnaf6oOK67e+uQAgu7OdSLgn4j/p0WikiY0lGminDz9xbpq+8+EzV5aHTl8+iv8PDJ95A32gLBJ4rA/J/bP8f8IP/uLHq7THbst1DtD/uvdfXfM+jeums9+VIk8BzRSogHR/RwY0XUkbf9EVc3AHCVUIsdgmUD0Ib2/lMy0NQkSoKfPy4AfMD3cKu9sRUOQUWZEh/SZ52v951LKefVh10RAoXK9lUH4I6A6RMCM52+ai3Du8RSVePoN52lQes+4On71s4T8L/aMlYMYsqMgcZeqRv76nfuKtmZ/aQ2cupV3FSXdDHQ5W8wen51BXoJVBKfXoLqEjVnJJinJK2HqTdxOGkamQQYQC1UGfdkAm7VwgiYXtWE5LRF5cbpn2dKKOh6IkBbpTpEvjdAayBr+PTUFuPFyJboAm0GZw5F5dib/RdrVyyHsccZwOCheCFXX9gu2l+nGL88HlpLqBOp0g3ofQBjhuFi6GoWvI1e1AmaH8kCO81yY7it+2eORNQy6w9guJcBfpxI/AlcT+8fZjlkcef64I3DiBUzjnP4dzz8bf6/wjd4HiihUx8Aj3HQrkm7LMMNL3BR0nJBwjlqfJ+JGO8V2bF0Zn0QNTCl4TwE8+cubSKmwD3mkMtPOBGqzsUCgMr964+fK2gpz76ONhR0ciJWxceGpWh/F5L2gCdmdwIHNguwH23qr1NgA03yPjsMLORB310cfDhVSxu6iroq5FB1CpY/9o30r2k9rWNGwTnrL8HKhAD89KZWzvpIE++njYkXo/qXTdSfXiNc9Ei3pYVzsGolDKspTv+7+RVgv5FufV9NHHpxmpiXT47Fs2Uue6985gQm7r1T/o0dWgLVr+afbiHvut7jY++s5T+c1Xn17aevWpuxjc3ceDhq42fYOLrhkOY761V4BJQcnbNulzV6wKk8833khMgfxdgHbogMEL4HLbs0o/UMhk+KykKC4BtHtnAu4y/P7j3KgOfqW1IbDRz4jh02+UoY+7ii4PIhOWH+mgOKrkOegBese82rajgxIZ75Kj8AIDvsQN2ZPofa8gXCBJAt1Cd3MvbRC6/6SQK7SxolM6+kAfdx1dEWltaChgzVUhRL2HvzFeldt9cWMXoEmoOEIKULr2kzaed6v07col7j90+vL44Jn2XCxNXbppXxJqW05LQyDjxizscNlpn+k2727Hrpv03eS7k0jlggli48LTDYriDMqDp69MQg84PHLubeSj+kh+dDBfv/Vy6sDvjfNPFZlBK7xsWQ+1y0efcFfwr1F64bpzpGcH026+NjqL6wVNVn8wLOk6k8wwlRMaCYpFy5X6KI+iBDFDoiD2T1kdhiXlDOjXXHjlShvFytLAV5p7cTcujJJbi8qcGz5zuUTXaheOvYeOqZx6HviU+u4/D/LkwOnwGwPi7dPluK47TvXAek22ElH9dng/q4MZM+ZWi6Rp9IEqCSdtbau+4L3OI9vsW7nuPaMWId1W3S/UVmzzWLt+0eU+mcN+D55/jP3MylK41yjvYJ8RNi8cm5BMUj/kg/kKIYqUh3RhPKgSxcc6YXy8tqs6c7YPx2Q6ms/dQFectGng0KzPlWmiLjpAQs4zHNF+md7zC4AGjunjLAuKoKQ6J9dCSR0731gLroy1147N4/0Sfae0+G8RJwVNlKvQsupsggYO01U5M26HbjLmB0hjPrBKGxlwwpQ3aCN9GtDzTEXFlEGF/uHzwNeCXCXYPp2GxGdmUzke4aSDPgokm8RNcZJOecfNhMaG+m5zy73qn86n6ontlBJFY4PPt24WzDJNGKF+obb4aRSB8ozXLlU2pbWwP6aZwWJcnYgJCZR2jtD8tHSf6X6AhJMbm2OtVK1Fdaaw5KDqgcSbUOcpb5xtuAfoynC05ULeUGTtR+CL96EHUFADdtR+9XJwHdhgww4CM1WThVa/obNXLP/6J6+OLnBgU96kLBE3UoOAEwJdTZhWc9jbS4XScN2hwS+0KCKrV9ZLVkLhq0NnLp8MlwlTzOh0Jq/3eIRT+JwIFw2q8zQE2xdLqzk0pIQEucyobnqfaqmRj+oXyOM9XOBYAQLhjZtb9aLeYiXtwUzmqM+BPQ7YcmHDvCqDpy83XmZUu/D0NC1ISGRUthb7kaNpaYL68EqjD8kabmb4WixPJY6rEPMZTL/Qrh8+psXAG+ukehPx4gK0GJYoJL1e5WTiON8FdMVJMwb3VmfNSU3mWNADDCamdG5agsYO3VaoYRIU19eiIoqHjk2D4H/8cnBtOKXL15ZV2kIXFIH3T9K7b6D1bgohX28l+qB4VA7+3syYJf2t+dKfdsC+CfUFctFVr8wchNon7SCBErzfFegC2AdkxMpuvnasyYGFflUDqQaxBzxOjZN3MjihlatO59WinPCp8RsDmbL3Nd/M2stbOKEY8UeffaMiIHyMplpI9DhbQQJVddH9UA1XW+8pxkVnuVarZf054dVNnSyoFqDgM2pe3DvvQWoivY0NEVJO+ASKE90eOP3jbbtfaJsa4ypoHXwXDM+YOxYW6DLur/p50ilDn8jb2Jh3PKRIOJy73eBg/W+3uiec8On++7sMoXRdEUrPuXd4FdevUWy2L1kEwwl3DbpAbcCkCU5GPMWl9WKGnBtFx6jurgtgOf3Fid/jrSUF5JihdgX6JWiUoe/VpHKZK8JzztFH4TBoKYVVwlXTbj4ldkfnhSe6y8jhbkKyniTGXpFa3B0yjCU6I9cPZuAy6X0b6SEy7hQNtP8CcH3u7s5tBDekqCL3UeKVcEXiyk7+weBvJuMn7/ViMd1N+O0DSLaw44R7DLoAEQuK5Mskkiu9mftclC1DlxCCZQ3Ws8VeWcxj8eE82e3n+ZoT8wmlk/J9jycsyijBe3DFvdlb2grpzt2lAHtJW7+UfYf+2ANntn/urjq+UDbOodGcOUmk6gEfZwZsIM4AkBsaGlgdPvtG2f+oQTDUNjI9AYR3wHSCsYWb5n3pg/Xbh5981BjlLSwF6BLMdZS4yA2Y90TOlmKeYFo0RANP7DR7NMFMQG+w6E9U7FTlQTgctYZjqwtlY9EF1fsdMhxJj7Miu9kXnBP0oTlBn0f2qL69b9CWk2oLXp2iYqabVxkaRrd/7q53vmjJLwK0G6jU6VUAbYEcMDhAQ+jPpRUYDQe0CXx2q+6soe4yAw6KZqaZw0WejEFZbghlwKCBHt5yZ5GVFjYvjK4IjjoVpiUClT1KDLuF/YH2MUMubf3d8RLK2NckN3KoR88DdM/JSLysvTqK1m9N4Jy3DrJQBG3gAoYW163XjpFyukwiOBO4+LLeoqfIDsDUG+XZPBqWkP6kpfJWrqawTu9JAIvaKGesUT+49S10AZkncF5MR/thE3VgHOsp9PEX0ZJrMyleJ9WCmZkp36CEc6cM9xFaclI6c7e2uXU1TKAENhf1aaUBBc8fOXSOdMFSMDNSyukNz9ADsMMngrrFVr2urJ5kOBAk1pBeinpoSB9FS6Dvc1QGIlEfJxO7ystLqyx9EnaUw+8k/Pb5bgwUf69S9BC5biD9iQ0hNA1l0m43zspA5KpjP6poq5imslXfqkPZenulIHHvRr8joTbyRgLV7Q2DjHK6TN0Pnl97weuHkOgaGmscX5U3pQ9Y9+E+g+KkxIUcQA4DIscZTmgGJ7wVK7QM/ejf961Or37Byh/6o0LwuuNgRkk8mXE0NqG4gfkJGVoBpdqlBrzCzHoPm72FhZMqFsQgA4dI7zl9eRrbt0ArKw4KvVP0Njrtl6O6jmekOEAmeg6S+uA25n2NJgz64eykcmXCYdUoB5alCp+Mv7YAJ/VkUA92HbGKLi07qAO5ADPcFdmhUHQXcnvTrAzVtiajerRu3+gqLrcFXb4WUT2XDcT8twntCJZPz2IfnJROuP5+vYLXSETEvrUobJB0Rb9vqYJYVytU12a/WJDQL9FrtABh3mV/3FA3sUltIYss9nslWGfP+FTEfihH+wElg5jLJjrWzfRXrE79cy/APkJHsKHeEdlePPrmxZz83rXfZH6QkrdZW+URSOZnwgJpWOBe4Dv7FjfrpV5f0vRphppkzM0OZQZWo4uONzkL9yJC5m7D74ekyCo/ggv15KPRaK0HBaZhqBC26Pm4CnTt6i/3EYHCv/3PHu8UhaQ3czfor0GcfprGyQtkFtbngdqS8+KNG/1TGHoFGWiQV57a3HLJrdDwKaJedope46h8qDHu8PDBUIEQvIA65mODf3m5oZ7gQjWlJUIU3R9QAiWYdFgw6RGafjQj/HAzA+vvZuGf3vkNePs/9jYShwkziOblAFEqU7B/Wj2KvusCxOLNW72/Lq4PD8ItoXN5jIw3tVefniCfKVNvLhdKhGNyW8d+PnBw6mKGIpFIx8R+KKIrrYJTMie1Zbfq1OUDfX6Woi4SF6Rwsz//3yH4+x9/Hv753c80EvjHYrved/rP6F0unF7a6d11XTpmrpG+mVZUjbpb6cly20dbKKs2N0reSYFqUgKdAogGoIddzA2i0Q/Ax7wIJNUPRMAUqQQPMP4fqHrUaKcEt0YAAAAASUVORK5CYII="

/***/ }),
/* 169 */
/***/ (function(module, exports) {

module.exports = "<style>.scheduler_header{background-color:#00b6f2!important;display:block;color:#fff}table,td{border:1px solid grey;border-collapse:collapse;padding:5px}.quiz-table{width:100%}.quiz-tr-head{background-color:#5d545470;color:#fff;text-align:center}.quiz-tr{text-align:center;background-color:#80808024}.tr-label{color:#035cc9;font-weight:600}.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}#customers{font-family:\"Trebuchet MS\",Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td,#customers th{border:1px solid #ddd;padding:8px}#customers tr:nth-child(even){background-color:#d0f1d1}#customers tr:nth-child(odd){background-color:#c5ffc6}#customers tr:hover{background-color:#ddd}#customers th{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#4caf50;color:#fff}.metadata-question{background-color:#1f5fab}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading metadata-question\"> <h3> Metadata </h3> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <i aria-label=\"Close dialog\" class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=\"whitebackground md-padding\"> <div> <div layout=column> <div layout=row> <table id=customers> <tr ng-if=metadata.qn_desc> <td>Question</td> <td ng-bind-html=\"data=convertTitle(metadata.qn_desc,\n                        metadata.type)\">{{metadata.qn_desc}}</td> </tr> <tr ng-if=metadata.type> <td>Type</td> <td>{{metadata.type}}</td> </tr> <tr ng-if=metadata.usage.allUsage.count> <td>No of Activities used this Question</td> <td>{{metadata.usage.allUsage.count}}</td> </tr> <tr ng-if=metadata.usage.user_usage.count> <td>No of Activities used this Question By You</td> <td>{{metadata.usage.user_usage.count}}</td> </tr> <tr ng-if=metadata.score_percentage_all_qp.themesUsed> <td>No of Themes used</td> <td>{{metadata.score_percentage_all_qp.themesUsed}}</td> </tr> </table> </div> </div> </div></md-dialog-content> </md-dialog>";

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2pJREFUeNqkl1uITVEYx/feZxtTJgejYaRm5MGLeCEhEi8jRskTmjQuuYQODxgzzJBGRIxyK8kU4/ag3PKAonngQVHKrYQmZiiXlBlmzln+X/03q2WvdfYZX/3a++zbd//WOn7X/BmB53k+UGXX7uc8ysfqmV5CkXeDmOuK9+KuqTB6CUqzUFaJ02F8IInCbvAMiMGpmPtx7wi5kJ6K0jqcN4EiL7n0gktgJegBYYJ3xCnlK6UkrGPx4xW4AS5bQme+LB7uAeXgHKjhvVQS5ZGFwxmC0/D+SgE53kzFS8FnsJFhz2f4n9BERVVMpflClmNKdAUbqLxJy6VVggQFUYg00oBsvgeDmNwlFRVFyJAjoAop60sS6jiPc3rfWSp6J5hEDxUdWc2c33K0oQodOZSPDLAMA/n9E5wlutRwFrgi9Y/HSqvy22CkVnhmVLaAVraPntOTYjAK1O+PxzKRrtKAOMVy7QV/i9JxYBT4Bhos9eP0OJIf2gdcUg12gMnatXegRZACs7VmkKdi02AwSTN3A7VQS1RKwHowBywGT8FBcBFKi2ypsikWJQ/AW4034A6jNBvsA2fARHAU3AUXwDywCiwCu/UVzxXqqCB6WDhlmsVi5BPmvxm8ZOv0Gt+RD58C00AGXktffzBnuK2qf4FDlmhUgCmgjs/ZjBeFtWAWvG7TZr+zqkUGMc9Ke+Erc+ox/C7p5LsVhYRaiqkdVBqhXsE8e0yDrU9FhvK8M8nIVFof72cfK02xrNmfwHOwhG2TNfIXGVrLe/eSKNbncKsjjLvAeR5lRTIXhLlgk+QZ+X2N/KYK6eMhnEblBqVsmxYuEtfBAjBeCgkcBjfpVBpKF8rWyuzn0NHHD8GYmJWpm7nOMPSN7F1PG6F76dRWsBzKm6G8npWdclW1jMx65tiMRMDdRzEHRxuYAEaDLxw8shOZSsUi26FUNpUN0eJhU5zlpi/fWh5SmV5Ay2QAQYmMzHU4P8br9Ryh2/Qc6xPLy7d7oPTFFJXIAVa0fOc4Dmu1eyVmjr/zWAWrugyDVMy5bfNQyvro4KYxBeUncCxmvWSib/v4C5PiByVfa7z/lw5W+eOov6MIwoCAipUoDqlYLJ4ORkS7fYvHfszG0Nf6/xF476ifv39hon0wLGvvx582W+G50qJ+CzAAEasYS0hrjWoAAAAASUVORK5CYII="

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: studentActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var individualStudentTraditionalReportCtrl =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", function individualStudentTraditionalReportCtrl($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, individualStudentTraditionalReportCtrl);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var studentId = $state.params.student_id;
    $scope.isShowGoBack = $state.params.isShowGoBack;
    var planId = $state.params.qpId;
    var authoring = localStorageService.get('authoringData');
    $scope.activity_name = localStorageService.get('current_activity_name');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;
    $scope.isLoading = true;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 525;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];
    $scope.activityCount = 0;
    $scope.absentCount = 0;
    $scope.attendedCount = 0;
    $scope.notAttendedCount = 0;
    //On destroy function
    this.$onDestroy = function () {};
    authService.callAPI('/v0/traditional/assessment-activity-based-report/' + studentId + '/' + planId, "GET", {}, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            console.log(resultData);
            setComboChart(resultData.tm_elapsed, "tm_elapsed");
            setComboChart(resultData.cognitives, "cognitives");
            $scope.isLoading = false;
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_count) $scope.activityCount = resultData.basicDetails[0].total_count;
                if (resultData.basicDetails[0].absent_count) $scope.absentCount = resultData.basicDetails[0].absent_count;
                if (resultData.basicDetails[0].attended_count) $scope.attendedCount = resultData.basicDetails[0].attended_count;
                if (resultData.basicDetails[0].not_attended_count) $scope.notAttendedCount = resultData.basicDetails[0].not_attended_count;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails[0].questionDetail) {
                        if (resultData.graphDetails[0].questionDetail.length > 0) {
                            var questionDetail = resultData.graphDetails[0].questionDetail;
                            var values = [];
                            var header = [];
                            header.push("Question");
                            header.push("Total Questions");
                            header.push("No. of Questions Attended");
                            header.push("No. of Correct Answers");
                            values.push(header);
                            _.each(questionDetail, function (data) {
                                var arr = [];
                                arr.push(data.question_paper_title);

                                arr.push(data.total_question);
                                arr.push(data.attended_count);
                                arr.push(data.correct_answer);
                                values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Question" + '  vs  ' + "Count",
                                'value': values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            $scope.isLoading = false;
                            $scope.isChartAvailable = true;
                        }
                    }
                    if (resultData.graphDetails[0].waveDetails) {
                        if (resultData.graphDetails[0].waveDetails.length > 0) {
                            var waveDetails = resultData.graphDetails[0].waveDetails;
                            var _values = [];
                            var _header = [];
                            _header.push("Wave");
                            _header.push("Total Questions");
                            _values.push(_header);
                            _.each(waveDetails, function (data) {
                                var arr = [];
                                arr.push(data.wave[0].wave);
                                arr.push(data.total_questions);
                                _values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Wave" + '  vs  ' + "Count",
                                'value': _values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            console.log($scope.chartArray);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].tagDetails) {
                        if (resultData.graphDetails[0].tagDetails.length > 0) {
                            var tagDetails = resultData.graphDetails[0].tagDetails;
                            var _values2 = [];
                            var _header2 = [];
                            _header2.push("Tag");
                            _header2.push("Total Questions");
                            _values2.push(_header2);
                            _.each(tagDetails, function (data) {
                                var arr = [];
                                arr.push(data._id);
                                arr.push(data.total_questions);
                                _values2.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "wave",
                                'graph': "Bar",
                                'title': "Tag" + '  vs  ' + "Count",
                                'value': _values2
                            };
                            $scope.chartArray.push($scope.tagObj);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].levelDetails) {
                        if (resultData.graphDetails[0].levelDetails.length > 0) {
                            var levelDetails = resultData.graphDetails[0].levelDetails;
                            var _values3 = [];
                            var _header3 = [];
                            _header3.push("Level");
                            _header3.push("Total Questions");
                            _values3.push(_header3);
                            _.each(levelDetails, function (data) {
                                var arr = [];
                                arr.push(data.level[0].level);
                                arr.push(data.total_questions);
                                _values3.push(arr);
                            });
                            $scope.levelObj = {
                                'key': "level",
                                'graph': "Bar",
                                'title': "Level" + '  vs  ' + "Count",
                                'value': _values3
                            };
                            $scope.chartArray.push($scope.levelObj);
                            $scope.isLoading = false;
                        }
                    }
                }
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var rankDetails = resultData.rankDetails;
                var isPresent = 0;
                var _values4 = [];
                var _header4 = [];
                _header4.push("Activity");
                _header4.push("Total Mark");
                _header4.push("Marks Scored");
                _values4.push(_header4);
                _.each(rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.total_mark);
                    arr.push(data.score);
                    _values4.push(arr);
                    if (data.score) isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Mark",
                    'value': _values4
                };
                if (isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var _rankDetails = resultData.rankDetails;
                var _values5 = [];
                var _header5 = [];
                var _isPresent = 0;
                _header5.push("Activity");
                _header5.push("Rank");
                _values5.push(_header5);
                _.each(_rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.rank);
                    _values5.push(arr);
                    if (data.rank) _isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Rank",
                    'value': _values5
                };
                if (_isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }

            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    function drawVisualization() {
        // Some raw data (not necessarily accurate)
        console.log($scope.comboArrayTm);
        var data = google.visualization.arrayToDataTable($scope.comboArrayTm);

        var options = {
            title: 'Activity Report : Time Elapsed',
            vAxis: { title: 'Minutes Elapsed For The Student' },
            hAxis: { title: 'Questions' },
            seriesType: 'bars',
            series: { 1: { type: 'line' }
                // colors: ['#000', '#fff']
            } };

        var chart = new google.visualization.ComboChart(document.getElementById('chart_div'));
        chart.draw(data, options);
    }
    function drawVisualizationCongnitive() {
        // Some raw data (not necessarily accurate)
        console.log($scope.comboArrayCog);
        var data = google.visualization.arrayToDataTable($scope.comboArrayCog);

        var options = {
            title: 'Activity Report : Student Score vs Class Skill average',
            vAxis: { title: 'Student Score' },
            hAxis: { title: 'Cognitive Skills' },
            seriesType: 'bars',
            series: { 1: { type: 'line' }
                // colors: ['#000', '#fff']
            } };

        var chart = new google.visualization.ComboChart(document.getElementById('chart_div_cog'));
        chart.draw(data, options);
    }
    function setComboChart(response, type) {
        try {

            google.charts.load('current', { 'packages': ['corechart'] });
            if (type == "tm_elapsed") {
                $scope.comboArrayTm = response;
                google.charts.setOnLoadCallback(drawVisualization);
            } else if (type == "cognitives") {
                $scope.comboArrayCog = response;
                google.charts.setOnLoadCallback(drawVisualizationCongnitive);
            }
        } catch (e) {
            console.log(e);
        }
    }
    // authService.callAPI('/v0/qp-reports/time-elapsed/student/', "POST", {
    //     qp_id : planId,
    //     student_id : studentId
    // }, function(response) {
    //     setComboChart(response)
    //     console.log(response)
    // })
    $scope.goBack = function () {
        $state.go("activityReports");
    };
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            console.log(CONSTANTS.FILE_UPLOAD_URL + result.logo);
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });
    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
    };$scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.addFont('Roboto Condensed');
        doc.setFont('Roboto Condensed');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);

        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Student Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;
        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = individualStudentTraditionalReportCtrl;

/***/ }),
/* 173 */,
/* 174 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAaFJREFUeNrMlE8oBGEUwGe23fXfQf5Eqzg4uBCllIP8uSgHNzdydXFbZ+XguMpBnFBqXVwUOYhVDo4OK0oruXBQRNi1O35veqNRs5ndvXj1a9438+Z9773vvc+0LMvwkttwUwuPDegFMdqBubb0Q8bLPmjkl3UwoQfqYQ/uYMnL2JSI2H0EfRxqIAvlMAX7cK3vxqAdNnWDADzCFlFemqlQo/ywBifwogaSyqs6DOmm75CDKl2L8wh0wKg4SqJs43XRKELI5pDHfUDDNI3ixfYhEU2jrMBRgU6zWtNuOzUtdlRPY1UN/nImNWyASRikLAnn+G8EXswWUJtWiQRSTn4iYdH5GCygNtUaedjtqGQJeOQuYcdhWPUYzKgehQU/I+IM3gAcqN4HH6p3Qa2fiByRH79U/wRnUNO69u2o5Br9X0eVroOocHoFKdMbIe+p2VcHnZ3T9S5cqS6nl1Q94bpGMr9mU2aNwR2CN4jI2g/YTsAz1MnaiegMTuGchrtw9ZPpoVuaaj8sk8XTz1WrXdvMYx46fdRWSnAMMRzZffUtwABQJKDSMP7IjQAAAABJRU5ErkJggg=="

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANhJREFUeNqc0j8LQWEUx/F7/YlIlBjErKxegIFIBgab2WpWMmJgYDPIK5CXoJQycm0WCwMyUFYeXzw3UvLn1Oc+de/vdJ5OVxVCKL+WQfmjTD/mIzB/2xRDHEt4Pl0vgS5CaMlzo75ZRAoFjLCAhiB6CLxOSstgDiVY4ccJHQyxUphkQQZTTBBFGDO0YcRY3Kt6uxmPJnbIw4ayDNSvATTEo1J6kwNOuKHJjzXZkMVZvlvDrjfpXDhiADN82D5N6evZ50XsUYQbXhyQRAVzuaBbqf/8excBBgBe+M9pFP55mwAAAABJRU5ErkJggg=="

/***/ }),
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */

var re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;

var parts = [
    'source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'
];

module.exports = function parseuri(str) {
    var src = str,
        b = str.indexOf('['),
        e = str.indexOf(']');

    if (b != -1 && e != -1) {
        str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }

    var m = re.exec(str || ''),
        uri = {},
        i = 14;

    while (i--) {
        uri[parts[i]] = m[i] || '';
    }

    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }

    return uri;
};


/***/ }),
/* 224 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {
module.exports = isBuf;

var withNativeBuffer = typeof Buffer === 'function' && typeof Buffer.isBuffer === 'function';
var withNativeArrayBuffer = typeof ArrayBuffer === 'function';

var isView = function (obj) {
  return typeof ArrayBuffer.isView === 'function' ? ArrayBuffer.isView(obj) : (obj.buffer instanceof ArrayBuffer);
};

/**
 * Returns true if obj is a buffer or an arraybuffer.
 *
 * @api private
 */

function isBuf(obj) {
  return (withNativeBuffer && Buffer.isBuffer(obj)) ||
          (withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)));
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80).Buffer))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var eio = __webpack_require__(870);
var Socket = __webpack_require__(231);
var Emitter = __webpack_require__(44);
var parser = __webpack_require__(118);
var on = __webpack_require__(232);
var bind = __webpack_require__(233);
var debug = __webpack_require__(71)('socket.io-client:manager');
var indexOf = __webpack_require__(167);
var Backoff = __webpack_require__(886);

/**
 * IE6+ hasOwnProperty
 */

var has = Object.prototype.hasOwnProperty;

/**
 * Module exports
 */

module.exports = Manager;

/**
 * `Manager` constructor.
 *
 * @param {String} engine instance or engine uri/opts
 * @param {Object} options
 * @api public
 */

function Manager (uri, opts) {
  if (!(this instanceof Manager)) return new Manager(uri, opts);
  if (uri && ('object' === typeof uri)) {
    opts = uri;
    uri = undefined;
  }
  opts = opts || {};

  opts.path = opts.path || '/socket.io';
  this.nsps = {};
  this.subs = [];
  this.opts = opts;
  this.reconnection(opts.reconnection !== false);
  this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
  this.reconnectionDelay(opts.reconnectionDelay || 1000);
  this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
  this.randomizationFactor(opts.randomizationFactor || 0.5);
  this.backoff = new Backoff({
    min: this.reconnectionDelay(),
    max: this.reconnectionDelayMax(),
    jitter: this.randomizationFactor()
  });
  this.timeout(null == opts.timeout ? 20000 : opts.timeout);
  this.readyState = 'closed';
  this.uri = uri;
  this.connecting = [];
  this.lastPing = null;
  this.encoding = false;
  this.packetBuffer = [];
  var _parser = opts.parser || parser;
  this.encoder = new _parser.Encoder();
  this.decoder = new _parser.Decoder();
  this.autoConnect = opts.autoConnect !== false;
  if (this.autoConnect) this.open();
}

/**
 * Propagate given event to sockets and emit on `this`
 *
 * @api private
 */

Manager.prototype.emitAll = function () {
  this.emit.apply(this, arguments);
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].emit.apply(this.nsps[nsp], arguments);
    }
  }
};

/**
 * Update `socket.id` of all sockets
 *
 * @api private
 */

Manager.prototype.updateSocketIds = function () {
  for (var nsp in this.nsps) {
    if (has.call(this.nsps, nsp)) {
      this.nsps[nsp].id = this.generateId(nsp);
    }
  }
};

/**
 * generate `socket.id` for the given `nsp`
 *
 * @param {String} nsp
 * @return {String}
 * @api private
 */

Manager.prototype.generateId = function (nsp) {
  return (nsp === '/' ? '' : (nsp + '#')) + this.engine.id;
};

/**
 * Mix in `Emitter`.
 */

Emitter(Manager.prototype);

/**
 * Sets the `reconnection` config.
 *
 * @param {Boolean} true/false if it should automatically reconnect
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnection = function (v) {
  if (!arguments.length) return this._reconnection;
  this._reconnection = !!v;
  return this;
};

/**
 * Sets the reconnection attempts config.
 *
 * @param {Number} max reconnection attempts before giving up
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionAttempts = function (v) {
  if (!arguments.length) return this._reconnectionAttempts;
  this._reconnectionAttempts = v;
  return this;
};

/**
 * Sets the delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelay = function (v) {
  if (!arguments.length) return this._reconnectionDelay;
  this._reconnectionDelay = v;
  this.backoff && this.backoff.setMin(v);
  return this;
};

Manager.prototype.randomizationFactor = function (v) {
  if (!arguments.length) return this._randomizationFactor;
  this._randomizationFactor = v;
  this.backoff && this.backoff.setJitter(v);
  return this;
};

/**
 * Sets the maximum delay between reconnections.
 *
 * @param {Number} delay
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.reconnectionDelayMax = function (v) {
  if (!arguments.length) return this._reconnectionDelayMax;
  this._reconnectionDelayMax = v;
  this.backoff && this.backoff.setMax(v);
  return this;
};

/**
 * Sets the connection timeout. `false` to disable
 *
 * @return {Manager} self or value
 * @api public
 */

Manager.prototype.timeout = function (v) {
  if (!arguments.length) return this._timeout;
  this._timeout = v;
  return this;
};

/**
 * Starts trying to reconnect if reconnection is enabled and we have not
 * started reconnecting yet
 *
 * @api private
 */

Manager.prototype.maybeReconnectOnOpen = function () {
  // Only try to reconnect if it's the first time we're connecting
  if (!this.reconnecting && this._reconnection && this.backoff.attempts === 0) {
    // keeps reconnection from firing twice for the same reconnection loop
    this.reconnect();
  }
};

/**
 * Sets the current transport `socket`.
 *
 * @param {Function} optional, callback
 * @return {Manager} self
 * @api public
 */

Manager.prototype.open =
Manager.prototype.connect = function (fn, opts) {
  debug('readyState %s', this.readyState);
  if (~this.readyState.indexOf('open')) return this;

  debug('opening %s', this.uri);
  this.engine = eio(this.uri, this.opts);
  var socket = this.engine;
  var self = this;
  this.readyState = 'opening';
  this.skipReconnect = false;

  // emit `open`
  var openSub = on(socket, 'open', function () {
    self.onopen();
    fn && fn();
  });

  // emit `connect_error`
  var errorSub = on(socket, 'error', function (data) {
    debug('connect_error');
    self.cleanup();
    self.readyState = 'closed';
    self.emitAll('connect_error', data);
    if (fn) {
      var err = new Error('Connection error');
      err.data = data;
      fn(err);
    } else {
      // Only do this if there is no fn to handle the error
      self.maybeReconnectOnOpen();
    }
  });

  // emit `connect_timeout`
  if (false !== this._timeout) {
    var timeout = this._timeout;
    debug('connect attempt will timeout after %d', timeout);

    // set timer
    var timer = setTimeout(function () {
      debug('connect attempt timed out after %d', timeout);
      openSub.destroy();
      socket.close();
      socket.emit('error', 'timeout');
      self.emitAll('connect_timeout', timeout);
    }, timeout);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }

  this.subs.push(openSub);
  this.subs.push(errorSub);

  return this;
};

/**
 * Called upon transport open.
 *
 * @api private
 */

Manager.prototype.onopen = function () {
  debug('open');

  // clear old subs
  this.cleanup();

  // mark as open
  this.readyState = 'open';
  this.emit('open');

  // add new subs
  var socket = this.engine;
  this.subs.push(on(socket, 'data', bind(this, 'ondata')));
  this.subs.push(on(socket, 'ping', bind(this, 'onping')));
  this.subs.push(on(socket, 'pong', bind(this, 'onpong')));
  this.subs.push(on(socket, 'error', bind(this, 'onerror')));
  this.subs.push(on(socket, 'close', bind(this, 'onclose')));
  this.subs.push(on(this.decoder, 'decoded', bind(this, 'ondecoded')));
};

/**
 * Called upon a ping.
 *
 * @api private
 */

Manager.prototype.onping = function () {
  this.lastPing = new Date();
  this.emitAll('ping');
};

/**
 * Called upon a packet.
 *
 * @api private
 */

Manager.prototype.onpong = function () {
  this.emitAll('pong', new Date() - this.lastPing);
};

/**
 * Called with data.
 *
 * @api private
 */

Manager.prototype.ondata = function (data) {
  this.decoder.add(data);
};

/**
 * Called when parser fully decodes a packet.
 *
 * @api private
 */

Manager.prototype.ondecoded = function (packet) {
  this.emit('packet', packet);
};

/**
 * Called upon socket error.
 *
 * @api private
 */

Manager.prototype.onerror = function (err) {
  debug('error', err);
  this.emitAll('error', err);
};

/**
 * Creates a new socket for the given `nsp`.
 *
 * @return {Socket}
 * @api public
 */

Manager.prototype.socket = function (nsp, opts) {
  var socket = this.nsps[nsp];
  if (!socket) {
    socket = new Socket(this, nsp, opts);
    this.nsps[nsp] = socket;
    var self = this;
    socket.on('connecting', onConnecting);
    socket.on('connect', function () {
      socket.id = self.generateId(nsp);
    });

    if (this.autoConnect) {
      // manually call here since connecting event is fired before listening
      onConnecting();
    }
  }

  function onConnecting () {
    if (!~indexOf(self.connecting, socket)) {
      self.connecting.push(socket);
    }
  }

  return socket;
};

/**
 * Called upon a socket close.
 *
 * @param {Socket} socket
 */

Manager.prototype.destroy = function (socket) {
  var index = indexOf(this.connecting, socket);
  if (~index) this.connecting.splice(index, 1);
  if (this.connecting.length) return;

  this.close();
};

/**
 * Writes a packet.
 *
 * @param {Object} packet
 * @api private
 */

Manager.prototype.packet = function (packet) {
  debug('writing packet %j', packet);
  var self = this;
  if (packet.query && packet.type === 0) packet.nsp += '?' + packet.query;

  if (!self.encoding) {
    // encode, then write to engine with result
    self.encoding = true;
    this.encoder.encode(packet, function (encodedPackets) {
      for (var i = 0; i < encodedPackets.length; i++) {
        self.engine.write(encodedPackets[i], packet.options);
      }
      self.encoding = false;
      self.processPacketQueue();
    });
  } else { // add packet to the queue
    self.packetBuffer.push(packet);
  }
};

/**
 * If packet buffer is non-empty, begins encoding the
 * next packet in line.
 *
 * @api private
 */

Manager.prototype.processPacketQueue = function () {
  if (this.packetBuffer.length > 0 && !this.encoding) {
    var pack = this.packetBuffer.shift();
    this.packet(pack);
  }
};

/**
 * Clean up transport subscriptions and packet buffer.
 *
 * @api private
 */

Manager.prototype.cleanup = function () {
  debug('cleanup');

  var subsLength = this.subs.length;
  for (var i = 0; i < subsLength; i++) {
    var sub = this.subs.shift();
    sub.destroy();
  }

  this.packetBuffer = [];
  this.encoding = false;
  this.lastPing = null;

  this.decoder.destroy();
};

/**
 * Close the current socket.
 *
 * @api private
 */

Manager.prototype.close =
Manager.prototype.disconnect = function () {
  debug('disconnect');
  this.skipReconnect = true;
  this.reconnecting = false;
  if ('opening' === this.readyState) {
    // `onclose` will not fire because
    // an open event never happened
    this.cleanup();
  }
  this.backoff.reset();
  this.readyState = 'closed';
  if (this.engine) this.engine.close();
};

/**
 * Called upon engine close.
 *
 * @api private
 */

Manager.prototype.onclose = function (reason) {
  debug('onclose');

  this.cleanup();
  this.backoff.reset();
  this.readyState = 'closed';
  this.emit('close', reason);

  if (this._reconnection && !this.skipReconnect) {
    this.reconnect();
  }
};

/**
 * Attempt a reconnection.
 *
 * @api private
 */

Manager.prototype.reconnect = function () {
  if (this.reconnecting || this.skipReconnect) return this;

  var self = this;

  if (this.backoff.attempts >= this._reconnectionAttempts) {
    debug('reconnect failed');
    this.backoff.reset();
    this.emitAll('reconnect_failed');
    this.reconnecting = false;
  } else {
    var delay = this.backoff.duration();
    debug('will wait %dms before reconnect attempt', delay);

    this.reconnecting = true;
    var timer = setTimeout(function () {
      if (self.skipReconnect) return;

      debug('attempting reconnect');
      self.emitAll('reconnect_attempt', self.backoff.attempts);
      self.emitAll('reconnecting', self.backoff.attempts);

      // check again for the case socket closed in above events
      if (self.skipReconnect) return;

      self.open(function (err) {
        if (err) {
          debug('reconnect attempt error');
          self.reconnecting = false;
          self.reconnect();
          self.emitAll('reconnect_error', err.data);
        } else {
          debug('reconnect success');
          self.onreconnect();
        }
      });
    }, delay);

    this.subs.push({
      destroy: function () {
        clearTimeout(timer);
      }
    });
  }
};

/**
 * Called upon successful reconnect.
 *
 * @api private
 */

Manager.prototype.onreconnect = function () {
  var attempt = this.backoff.attempts;
  this.reconnecting = false;
  this.backoff.reset();
  this.updateSocketIds();
  this.emitAll('reconnect', attempt);
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var XMLHttpRequest = __webpack_require__(119);
var XHR = __webpack_require__(873);
var JSONP = __webpack_require__(882);
var websocket = __webpack_require__(883);

/**
 * Export transports.
 */

exports.polling = polling;
exports.websocket = websocket;

/**
 * Polling transport polymorphic constructor.
 * Decides on xhr vs jsonp based on feature detection.
 *
 * @api private
 */

function polling (opts) {
  var xhr;
  var xd = false;
  var xs = false;
  var jsonp = false !== opts.jsonp;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    xd = opts.hostname !== location.hostname || port !== opts.port;
    xs = opts.secure !== isSSL;
  }

  opts.xdomain = xd;
  opts.xscheme = xs;
  xhr = new XMLHttpRequest(opts);

  if ('open' in xhr && !opts.forceJSONP) {
    return new XHR(opts);
  } else {
    if (!jsonp) throw new Error('JSONP disabled');
    return new JSONP(opts);
  }
}


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var Transport = __webpack_require__(120);
var parseqs = __webpack_require__(72);
var parser = __webpack_require__(45);
var inherit = __webpack_require__(73);
var yeast = __webpack_require__(230);
var debug = __webpack_require__(74)('engine.io-client:polling');

/**
 * Module exports.
 */

module.exports = Polling;

/**
 * Is XHR2 supported?
 */

var hasXHR2 = (function () {
  var XMLHttpRequest = __webpack_require__(119);
  var xhr = new XMLHttpRequest({ xdomain: false });
  return null != xhr.responseType;
})();

/**
 * Polling interface.
 *
 * @param {Object} opts
 * @api private
 */

function Polling (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (!hasXHR2 || forceBase64) {
    this.supportsBinary = false;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(Polling, Transport);

/**
 * Transport name.
 */

Polling.prototype.name = 'polling';

/**
 * Opens the socket (triggers polling). We write a PING message to determine
 * when the transport is open.
 *
 * @api private
 */

Polling.prototype.doOpen = function () {
  this.poll();
};

/**
 * Pauses polling.
 *
 * @param {Function} callback upon buffers are flushed and transport is paused
 * @api private
 */

Polling.prototype.pause = function (onPause) {
  var self = this;

  this.readyState = 'pausing';

  function pause () {
    debug('paused');
    self.readyState = 'paused';
    onPause();
  }

  if (this.polling || !this.writable) {
    var total = 0;

    if (this.polling) {
      debug('we are currently polling - waiting to pause');
      total++;
      this.once('pollComplete', function () {
        debug('pre-pause polling complete');
        --total || pause();
      });
    }

    if (!this.writable) {
      debug('we are currently writing - waiting to pause');
      total++;
      this.once('drain', function () {
        debug('pre-pause writing complete');
        --total || pause();
      });
    }
  } else {
    pause();
  }
};

/**
 * Starts polling cycle.
 *
 * @api public
 */

Polling.prototype.poll = function () {
  debug('polling');
  this.polling = true;
  this.doPoll();
  this.emit('poll');
};

/**
 * Overloads onData to detect payloads.
 *
 * @api private
 */

Polling.prototype.onData = function (data) {
  var self = this;
  debug('polling got data %s', data);
  var callback = function (packet, index, total) {
    // if its the first message we consider the transport open
    if ('opening' === self.readyState) {
      self.onOpen();
    }

    // if its a close packet, we close the ongoing requests
    if ('close' === packet.type) {
      self.onClose();
      return false;
    }

    // otherwise bypass onData and handle the message
    self.onPacket(packet);
  };

  // decode payload
  parser.decodePayload(data, this.socket.binaryType, callback);

  // if an event did not trigger closing
  if ('closed' !== this.readyState) {
    // if we got data we're not polling
    this.polling = false;
    this.emit('pollComplete');

    if ('open' === this.readyState) {
      this.poll();
    } else {
      debug('ignoring poll - transport state "%s"', this.readyState);
    }
  }
};

/**
 * For polling, send a close packet.
 *
 * @api private
 */

Polling.prototype.doClose = function () {
  var self = this;

  function close () {
    debug('writing close packet');
    self.write([{ type: 'close' }]);
  }

  if ('open' === this.readyState) {
    debug('transport open - closing');
    close();
  } else {
    // in case we're trying to close while
    // handshaking is in progress (GH-164)
    debug('transport not open - deferring close');
    this.once('open', close);
  }
};

/**
 * Writes a packets payload.
 *
 * @param {Array} data packets
 * @param {Function} drain callback
 * @api private
 */

Polling.prototype.write = function (packets) {
  var self = this;
  this.writable = false;
  var callbackfn = function () {
    self.writable = true;
    self.emit('drain');
  };

  parser.encodePayload(packets, this.supportsBinary, function (data) {
    self.doWrite(data, callbackfn);
  });
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

Polling.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'https' : 'http';
  var port = '';

  // cache busting is forced
  if (false !== this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  if (!this.supportsBinary && !query.sid) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // avoid port if default for schema
  if (this.port && (('https' === schema && Number(this.port) !== 443) ||
     ('http' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/* global Blob File */

/*
 * Module requirements.
 */

var isArray = __webpack_require__(875);

var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' ||
                        typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]';
var withNativeFile = typeof File === 'function' ||
                        typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]';

/**
 * Module exports.
 */

module.exports = hasBinary;

/**
 * Checks for binary data.
 *
 * Supports Buffer, ArrayBuffer, Blob and File.
 *
 * @param {Object} anything
 * @api public
 */

function hasBinary (obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (hasBinary(obj[i])) {
        return true;
      }
    }
    return false;
  }

  if ((typeof Buffer === 'function' && Buffer.isBuffer && Buffer.isBuffer(obj)) ||
    (typeof ArrayBuffer === 'function' && obj instanceof ArrayBuffer) ||
    (withNativeBlob && obj instanceof Blob) ||
    (withNativeFile && obj instanceof File)
  ) {
    return true;
  }

  // see: https://github.com/Automattic/has-binary/pull/4
  if (obj.toJSON && typeof obj.toJSON === 'function' && arguments.length === 1) {
    return hasBinary(obj.toJSON(), true);
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
      return true;
    }
  }

  return false;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80).Buffer))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split('')
  , length = 64
  , map = {}
  , seed = 0
  , i = 0
  , prev;

/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */
function encode(num) {
  var encoded = '';

  do {
    encoded = alphabet[num % length] + encoded;
    num = Math.floor(num / length);
  } while (num > 0);

  return encoded;
}

/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */
function decode(str) {
  var decoded = 0;

  for (i = 0; i < str.length; i++) {
    decoded = decoded * length + map[str.charAt(i)];
  }

  return decoded;
}

/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */
function yeast() {
  var now = encode(+new Date());

  if (now !== prev) return seed = 0, prev = now;
  return now +'.'+ encode(seed++);
}

//
// Map each character to its index.
//
for (; i < length; i++) map[alphabet[i]] = i;

//
// Expose the `yeast`, `encode` and `decode` functions.
//
yeast.encode = encode;
yeast.decode = decode;
module.exports = yeast;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parser = __webpack_require__(118);
var Emitter = __webpack_require__(44);
var toArray = __webpack_require__(885);
var on = __webpack_require__(232);
var bind = __webpack_require__(233);
var debug = __webpack_require__(71)('socket.io-client:socket');
var parseqs = __webpack_require__(72);
var hasBin = __webpack_require__(229);

/**
 * Module exports.
 */

module.exports = exports = Socket;

/**
 * Internal events (blacklisted).
 * These events can't be emitted by the user.
 *
 * @api private
 */

var events = {
  connect: 1,
  connect_error: 1,
  connect_timeout: 1,
  connecting: 1,
  disconnect: 1,
  error: 1,
  reconnect: 1,
  reconnect_attempt: 1,
  reconnect_failed: 1,
  reconnect_error: 1,
  reconnecting: 1,
  ping: 1,
  pong: 1
};

/**
 * Shortcut to `Emitter#emit`.
 */

var emit = Emitter.prototype.emit;

/**
 * `Socket` constructor.
 *
 * @api public
 */

function Socket (io, nsp, opts) {
  this.io = io;
  this.nsp = nsp;
  this.json = this; // compat
  this.ids = 0;
  this.acks = {};
  this.receiveBuffer = [];
  this.sendBuffer = [];
  this.connected = false;
  this.disconnected = true;
  this.flags = {};
  if (opts && opts.query) {
    this.query = opts.query;
  }
  if (this.io.autoConnect) this.open();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Subscribe to open, close and packet events
 *
 * @api private
 */

Socket.prototype.subEvents = function () {
  if (this.subs) return;

  var io = this.io;
  this.subs = [
    on(io, 'open', bind(this, 'onopen')),
    on(io, 'packet', bind(this, 'onpacket')),
    on(io, 'close', bind(this, 'onclose'))
  ];
};

/**
 * "Opens" the socket.
 *
 * @api public
 */

Socket.prototype.open =
Socket.prototype.connect = function () {
  if (this.connected) return this;

  this.subEvents();
  this.io.open(); // ensure open
  if ('open' === this.io.readyState) this.onopen();
  this.emit('connecting');
  return this;
};

/**
 * Sends a `message` event.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.send = function () {
  var args = toArray(arguments);
  args.unshift('message');
  this.emit.apply(this, args);
  return this;
};

/**
 * Override `emit`.
 * If the event is in `events`, it's emitted normally.
 *
 * @param {String} event name
 * @return {Socket} self
 * @api public
 */

Socket.prototype.emit = function (ev) {
  if (events.hasOwnProperty(ev)) {
    emit.apply(this, arguments);
    return this;
  }

  var args = toArray(arguments);
  var packet = {
    type: (this.flags.binary !== undefined ? this.flags.binary : hasBin(args)) ? parser.BINARY_EVENT : parser.EVENT,
    data: args
  };

  packet.options = {};
  packet.options.compress = !this.flags || false !== this.flags.compress;

  // event ack callback
  if ('function' === typeof args[args.length - 1]) {
    debug('emitting packet with ack id %d', this.ids);
    this.acks[this.ids] = args.pop();
    packet.id = this.ids++;
  }

  if (this.connected) {
    this.packet(packet);
  } else {
    this.sendBuffer.push(packet);
  }

  this.flags = {};

  return this;
};

/**
 * Sends a packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.packet = function (packet) {
  packet.nsp = this.nsp;
  this.io.packet(packet);
};

/**
 * Called upon engine `open`.
 *
 * @api private
 */

Socket.prototype.onopen = function () {
  debug('transport is open - connecting');

  // write connect packet if necessary
  if ('/' !== this.nsp) {
    if (this.query) {
      var query = typeof this.query === 'object' ? parseqs.encode(this.query) : this.query;
      debug('sending connect packet with query %s', query);
      this.packet({type: parser.CONNECT, query: query});
    } else {
      this.packet({type: parser.CONNECT});
    }
  }
};

/**
 * Called upon engine `close`.
 *
 * @param {String} reason
 * @api private
 */

Socket.prototype.onclose = function (reason) {
  debug('close (%s)', reason);
  this.connected = false;
  this.disconnected = true;
  delete this.id;
  this.emit('disconnect', reason);
};

/**
 * Called with socket packet.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onpacket = function (packet) {
  var sameNamespace = packet.nsp === this.nsp;
  var rootNamespaceError = packet.type === parser.ERROR && packet.nsp === '/';

  if (!sameNamespace && !rootNamespaceError) return;

  switch (packet.type) {
    case parser.CONNECT:
      this.onconnect();
      break;

    case parser.EVENT:
      this.onevent(packet);
      break;

    case parser.BINARY_EVENT:
      this.onevent(packet);
      break;

    case parser.ACK:
      this.onack(packet);
      break;

    case parser.BINARY_ACK:
      this.onack(packet);
      break;

    case parser.DISCONNECT:
      this.ondisconnect();
      break;

    case parser.ERROR:
      this.emit('error', packet.data);
      break;
  }
};

/**
 * Called upon a server event.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onevent = function (packet) {
  var args = packet.data || [];
  debug('emitting event %j', args);

  if (null != packet.id) {
    debug('attaching ack callback to event');
    args.push(this.ack(packet.id));
  }

  if (this.connected) {
    emit.apply(this, args);
  } else {
    this.receiveBuffer.push(args);
  }
};

/**
 * Produces an ack callback to emit with an event.
 *
 * @api private
 */

Socket.prototype.ack = function (id) {
  var self = this;
  var sent = false;
  return function () {
    // prevent double callbacks
    if (sent) return;
    sent = true;
    var args = toArray(arguments);
    debug('sending ack %j', args);

    self.packet({
      type: hasBin(args) ? parser.BINARY_ACK : parser.ACK,
      id: id,
      data: args
    });
  };
};

/**
 * Called upon a server acknowlegement.
 *
 * @param {Object} packet
 * @api private
 */

Socket.prototype.onack = function (packet) {
  var ack = this.acks[packet.id];
  if ('function' === typeof ack) {
    debug('calling ack %s with %j', packet.id, packet.data);
    ack.apply(this, packet.data);
    delete this.acks[packet.id];
  } else {
    debug('bad ack %s', packet.id);
  }
};

/**
 * Called upon server connect.
 *
 * @api private
 */

Socket.prototype.onconnect = function () {
  this.connected = true;
  this.disconnected = false;
  this.emit('connect');
  this.emitBuffered();
};

/**
 * Emit buffered events (received and emitted).
 *
 * @api private
 */

Socket.prototype.emitBuffered = function () {
  var i;
  for (i = 0; i < this.receiveBuffer.length; i++) {
    emit.apply(this, this.receiveBuffer[i]);
  }
  this.receiveBuffer = [];

  for (i = 0; i < this.sendBuffer.length; i++) {
    this.packet(this.sendBuffer[i]);
  }
  this.sendBuffer = [];
};

/**
 * Called upon server disconnect.
 *
 * @api private
 */

Socket.prototype.ondisconnect = function () {
  debug('server disconnect (%s)', this.nsp);
  this.destroy();
  this.onclose('io server disconnect');
};

/**
 * Called upon forced client/server side disconnections,
 * this method ensures the manager stops tracking us and
 * that reconnections don't get triggered for this.
 *
 * @api private.
 */

Socket.prototype.destroy = function () {
  if (this.subs) {
    // clean subscriptions to avoid reconnections
    for (var i = 0; i < this.subs.length; i++) {
      this.subs[i].destroy();
    }
    this.subs = null;
  }

  this.io.destroy(this);
};

/**
 * Disconnects the socket manually.
 *
 * @return {Socket} self
 * @api public
 */

Socket.prototype.close =
Socket.prototype.disconnect = function () {
  if (this.connected) {
    debug('performing disconnect (%s)', this.nsp);
    this.packet({ type: parser.DISCONNECT });
  }

  // remove socket from pool
  this.destroy();

  if (this.connected) {
    // fire events
    this.onclose('io client disconnect');
  }
  return this;
};

/**
 * Sets the compress flag.
 *
 * @param {Boolean} if `true`, compresses the sending data
 * @return {Socket} self
 * @api public
 */

Socket.prototype.compress = function (compress) {
  this.flags.compress = compress;
  return this;
};

/**
 * Sets the binary flag
 *
 * @param {Boolean} whether the emitted data contains binary
 * @return {Socket} self
 * @api public
 */

Socket.prototype.binary = function (binary) {
  this.flags.binary = binary;
  return this;
};


/***/ }),
/* 232 */
/***/ (function(module, exports) {


/**
 * Module exports.
 */

module.exports = on;

/**
 * Helper for subscriptions.
 *
 * @param {Object|EventEmitter} obj with `Emitter` mixin or `EventEmitter`
 * @param {String} event name
 * @param {Function} callback
 * @api public
 */

function on (obj, ev, fn) {
  obj.on(ev, fn);
  return {
    destroy: function () {
      obj.removeListener(ev, fn);
    }
  };
}


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * Slice reference.
 */

var slice = [].slice;

/**
 * Bind `obj` to `fn`.
 *
 * @param {Object} obj
 * @param {Function|String} fn or string
 * @return {Function}
 * @api public
 */

module.exports = function(obj, fn){
  if ('string' == typeof fn) fn = obj[fn];
  if ('function' != typeof fn) throw new Error('bind() requires a function');
  var args = slice.call(arguments, 2);
  return function(){
    return fn.apply(obj, args.concat(slice.call(arguments)));
  }
};


/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


DialogController.$inject = ["$scope", "$mdDialog", "topics"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _textAngularPopup = __webpack_require__(362);

var _textAngularPopup2 = _interopRequireDefault(_textAngularPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeachingPlanController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "TPCONSTANT", "$mdMedia", "$mdDialog", "$stateParams", "archiveService", "Upload", "GOOGLE_CLASSROOM_CONSTANTS", "CONSTANTS", function TeachingPlanController($scope, $rootScope, authService, localStorageService, $state, TPCONSTANT, $mdMedia, $mdDialog, $stateParams, archiveService, Upload, GOOGLE_CLASSROOM_CONSTANTS, CONSTANTS) {
    _classCallCheck(this, TeachingPlanController);

    var authoringData = localStorageService.get("authoringData");
    //To get current user id
    var userId = localStorageService.get('user_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (!authoringData) {
            $state.go("authdashboard");
        } else {
            var reqObj = {
                session_id: authoringData.session_id,
                curriculum_id: authoringData.curriculum_id,
                class_id: authoringData.class_id,
                batch_id: authoringData.batch_id,
                subject_id: authoringData.subject_id,
                school_id: authoringData.school_id,
                academic_year: authoringData.academic_year,
                user_id: userId
            };
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classroomDetails = response.result.data.details;
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };
    //To get Roles and Privileges
    var tpUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "teachingPlan";
    });
    var authoring = {
        session_id: authoringData.session_id,
        curriculum_id: authoringData.curriculum_id,
        class_id: authoringData.class_id,
        batch_id: authoringData.batch_id,
        school_id: authoringData.school_id,
        subject_id: authoringData.subject_id,
        academic_year: authoringData.academic_year,
        class: authoringData.class,
        batch: authoringData.batch,
        curriculum: authoringData.curriculum,
        subject: authoringData.subject
    };
    authService.callAPI(TPCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function (response) {
        if (response && response.result && response.result.data) {
            $scope.serverDate = response.result.data.data;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    $scope.tpUserPrivilege = {};
    if (tpUserAccess.length > 0) {
        _.each(tpUserAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.tpUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    //To get all the resource types
    $scope.resourceTypes = TPCONSTANT.RESOURCES_LABEL;
    //Flag for new teaching plan
    $scope.newPlan = true;
    //To set privilege for creating resources
    if ($scope.tpUserPrivilege && $scope.tpUserPrivilege.resources && $scope.tpUserPrivilege.resources.create) $scope.createResource = true;
    if ($scope.tpUserPrivilege && $scope.tpUserPrivilege.visibleToStudent && $scope.tpUserPrivilege.visibleToStudent.create) $scope.visibleToStudent = true;
    //initializing teaching plan object
    var stat = false;
    $scope.errors = {};
    $scope.teachingPlan = {
        "title": "",
        "objectives": "",
        "objectives_status": true,
        "learning_materials": "",
        "knowledge_required_status": true,
        "knowledge_required": "",
        "learning_materials_status": true,
        "teaching_methodology": "",
        "teaching_methodology_status": stat,
        "life_skills": "",
        "life_skills_status": stat,
        "conclusion_status": stat,
        "conclusion": "",
        "formative_assessment_status": stat,
        "formative_assessment": "",
        "resources_including_ICT": [],
        "resources_including_ICT_status": stat,
        "flow_of_tp": "",
        "flow_of_tp_status": stat,
        "other_details": "",
        "other_details_status": stat,
        "remedial_tp": "",
        "remedial_tp_status": stat,
        "resources": [],
        "status": "",
        "start_date": "",
        "end_date": "",
        "academic_year": ""

    };
    //Object: Teachingplan resources
    $scope.resource = {};
    $scope.isEdit = false;

    //To get theme name
    var planDetails = localStorageService.get('plan_details');
    if (planDetails) {
        $scope.themeName = planDetails.theme_name;
        $scope.teachingPlan.title = planDetails.plan_name;
    }
    //Popup for text angular editor window
    $scope.viewTextAngular = function (obj, teachingPlan) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                teachingPlan: teachingPlan
            },
            template: _textAngularPopup2.default,
            controller: ['$scope', '$mdDialog', 'teachingPlan', function ($scope, $mdDialog) {
                $scope.tp = {};
                $scope.teachingPlan = teachingPlan;
                if ($scope.teachingPlan[obj]) $scope.tp[obj] = $scope.teachingPlan[obj].toString();
                var nameobj = [{
                    _id: "objectives",
                    name: "OBJECTIVES"
                }, {
                    _id: "knowledge_required",
                    name: "REQUIRED KNOWLEDGE"
                }, {
                    _id: "learning_materials",
                    name: "REQUIRED LEARNING MATERIALS"
                }, {
                    _id: "teaching_methodology",
                    name: "REQUIRED TEACHING METHODOLOGY"
                }, {
                    _id: "life_skills",
                    name: "REQUIRED LIFE SKILLS"
                }, {
                    _id: "conclusion",
                    name: "REQUIRED CONCLUSION"
                }, {
                    _id: "formative_assessment",
                    name: "REQUIRED FORMATIVE ASSESSMENT"
                }, {
                    _id: "flow_of_tp",
                    name: "FLOW OF TEACHING PLAN"
                }, {
                    _id: "remedial_tp",
                    name: "REMEDIAL TEACHING PLAN"
                }, {
                    _id: "other_details",
                    name: "OTHER DETAILS"
                }];
                _.each(nameobj, function (name) {
                    if (name._id == obj) $scope.popupTitle = name.name;
                });

                $scope.reqObj = obj;
                $scope.saveContent = function () {
                    $scope.teachingPlan[obj] = $scope.tp[obj];
                    $mdDialog.hide();
                };
                $scope.closeEditor = function () {
                    $mdDialog.hide();
                };
            }],
            parent: angular.element(document.body),
            // clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    $scope.getTeachingPlan = function (planId) {
        authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.teachingPlan = response.result.data;
                $scope.themeName = $scope.teachingPlan.theme_title;
                $scope.resource.file = $scope.teachingPlan.resources;
                if ($scope.teachingPlan.teacher_id === userId) $scope.isCreator = true;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };
    $scope.getTeachingPlanFromArchive = function (planId) {
        authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.teachingPlan = response.result.data;
                $scope.themeName = $scope.teachingPlan.theme_title;
                $scope.resource.file = $scope.teachingPlan.resources;
                _.each($scope.teachingPlan.resources, function (resource) {
                    if (resource.status) resource.status = "created";
                    resource.assign_users = {};
                    resource.current_approver = {};
                    resource.isComplete = false;
                });
                if ($scope.teachingPlan.teacher_id === userId) $scope.isCreator = true;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };
    var redirectDetails = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();
    if (redirectDetails && redirectDetails.returnData) {
        var planId = redirectDetails.returnData.resource._id;
        $scope.getTeachingPlanFromArchive(planId);
        $scope.isFromArchive = true;
        /*Meteor.call("getTeachingPlan", planId, (error, teachingPlan) => {
            if (error) {
                toastr.error("Network Error, please try later.")
            } else {
                $scope.teachingPlan = teachingPlan
                _.each(teachingPlan.resources, function(resource) {
                    if (resource.status)
                        resource.status = STATUS_CREATED;
                    resource.assign_users = {};
                    resource.current_approver = {};
                    resource.isComplete = false;
                })
                $scope.resource = {
                    file: teachingPlan.resources
                }
                $scope.isFromArchive = true;
                $scope.$apply()
            }
        })*/
    }
    if ($stateParams.planId) {
        $scope.newPlan = false;
        $scope.getTeachingPlan($stateParams.planId);
        $scope.isEdit = true;
    }
    $scope.save = function (tpStatus) {
        console.log($scope.teachingPlan);
        authoring['theme_name'] = $scope.themeName;
        authoring['theme_id'] = $state.params.id;
        $scope.teachingPlan.resources = angular.copy($scope.resource.file);
        var tpError = 0;
        //validation
        // $scope.resource.file.forEach(element => {

        // });
        $scope.errors.resourcefile = [];
        for (var eachresource in $scope.resource.file) {
            for (var each in $scope.resource.file) {
                if ($scope.resource.file[eachresource].type && $scope.resource.file[eachresource].title && eachresource != each && $scope.resource.file[eachresource].title === $scope.resource.file[each].title && $scope.resource.file[eachresource].type === $scope.resource.file[each].type) {
                    $scope.errors.resourcefile[each] = "Duplicate value for same resource";
                    tpError++;
                }
            }
        }
        if (tpStatus === "draft" || tpStatus === "created") {
            if ($scope.teachingPlan.title === "" || $scope.teachingPlan.title === undefined || $scope.teachingPlan.title === null) {
                $scope.errors['title'] = "Teaching plan name required";
                tpError++;
            }
        }
        if (tpStatus === "created") {
            if ($scope.teachingPlan.objectives === "" || $scope.teachingPlan.objectives === undefined || $scope.teachingPlan.objectives === null) {
                $scope.errors['objectives'] = "Objectives required";
                tpError++;
            }
            if ($scope.teachingPlan.learning_materials === "" || $scope.teachingPlan.learning_materials === undefined || $scope.teachingPlan.learning_materials === null) {
                $scope.errors['learning_materials'] = "Learning materials required";
                tpError++;
            }
            if ($scope.teachingPlan.knowledge_required === "" || $scope.teachingPlan.knowledge_required === undefined || $scope.teachingPlan.knowledge_required === null) {
                $scope.errors['knowledge_required'] = "Knowledge required";
                tpError++;
            }
            if ($scope.teachingPlan.start_date === "" || $scope.teachingPlan.start_date === undefined || $scope.teachingPlan.start_date === null) {
                $scope.errors['start_date'] = "Start date required";
                tpError++;
            }
            if ($scope.teachingPlan.end_date === "" || $scope.teachingPlan.end_date === undefined || $scope.teachingPlan.end_date === null) {
                $scope.errors['end_date'] = "End date required";
                tpError++;
            }
        }
        $scope.errors.resources = [];
        _.each($scope.teachingPlan.resources, function (eachResource, index) {
            $scope.errors.resources.push({
                title: '',
                type: ''
            });
            if (eachResource.title === undefined || eachResource.title === null || eachResource.title === '') {
                $scope.errors.resources[index].title = 'Resource Title is required';
                tpError++;
            }
            if (eachResource.type === undefined || eachResource.type === null || eachResource.type === '') {
                $scope.errors.resources[index].type = 'Resource Type is required';
                tpError++;
            }
        });
        if (tpError === 0) {
            if ($scope.isEdit) {
                var tpObj = {
                    authoring: authoring,
                    user_id: userId,
                    teaching_plan: $scope.teachingPlan,
                    status: tpStatus,
                    tp_id: $stateParams.planId
                };
                authService.callAPI(TPCONSTANT.API_UPDATE_TP, "POST", tpObj, function (response) {
                    if (response && response.result && response.result.data) {
                        $rootScope.updateSidenav();
                        var _planId = response.result.data.details;
                        toastr.success('Teaching Plan updated successfully');
                        if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                            $state.go('wizard', {
                                "planId": $stateParams.planId
                            });
                        } else {
                            $state.go('viewTeachingPlan', {
                                "planId": $stateParams.planId
                            });
                        }

                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
            } else {
                if ($scope.isFromArchive) {
                    var _tpObj = {
                        authoring: authoring,
                        user_id: userId,
                        teaching_plan: $scope.teachingPlan,
                        status: tpStatus
                    };
                    console.log(_tpObj);
                    authService.callAPI(TPCONSTANT.API_SELECT_TP, "POST", _tpObj, function (response) {
                        if (response && response.result && response.result.data) {
                            console.log(response);
                            if (response.result.data.details) {
                                if (response.result.data.details.planId) {
                                    var _planId2 = response.result.data.details.planId;
                                    $rootScope.updateSidenav();
                                    if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                                        $state.go('wizard', {
                                            "planId": _planId2
                                        });
                                    } else {
                                        $state.go('viewTeachingPlan', {
                                            "planId": _planId2
                                        });
                                    }
                                } else {
                                    toastr.error(response.result.data.details.msg);
                                }
                            }

                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    });
                } else {

                    var _tpObj2 = {
                        authoring: authoring,
                        user_id: userId,
                        teaching_plan: $scope.teachingPlan,
                        status: tpStatus
                    };
                    console.log(_tpObj2);
                    authService.callAPI(TPCONSTANT.API_CREATE_TP, "POST", _tpObj2, function (response) {
                        if (response && response.result && response.result.data) {
                            if (response.result.data.details) {
                                $rootScope.updateSidenav();
                                var _planId3 = response.result.data.details;
                                toastr.success('Teaching Plan created successfully');
                                if ($scope.resource && $scope.resource.file && $scope.resource.file.length > 0) {
                                    $state.go('wizard', {
                                        "planId": _planId3
                                    });
                                } else {
                                    $state.go('viewTeachingPlan', {
                                        "planId": _planId3
                                    });
                                }
                            }

                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    });
                }
            }
        } else {
            toastr.error("Please fill all mandatory field");
        }
    };
    // To delete resource
    $scope.deleteResource = function (index) {
        $scope.resource.file.splice(index, 1);
    };
    // To add new resource
    $scope.addNewResource = function (resource, index) {
        if (!$scope.resource.file) {
            $scope.resource.file = [];
        }
        $scope.resource.file.push({
            "type": null,
            "title": null,
            "isPractice": false
        });
    };
    //To set default title for each resource
    $scope.setDefaultTitle = function (dataObj, curResIndex, isPractice) {
        var pracCount = 0;
        var assCount = 0;
        _.each($scope.resource.file, function (res) {
            if (res.type === "activityForm") {
                if (res.isPractice) pracCount++;else assCount++;
            }
        });
        //Number - Index for default title
        var index = void 0;
        //String - type of resource
        var type = dataObj.type;
        //[Object] - Same type resources
        var sameRes = _.filter($scope.resource.file, function (res) {
            return res.type === type;
        });
        index = sameRes.length;
        if (type === "activityForm") {
            if (isPractice) dataObj['title'] = TPCONSTANT.RESOURCES_TITLE["practice"] + " " + pracCount;else dataObj['title'] = TPCONSTANT.RESOURCES_TITLE["assessment"] + " " + assCount;
        } else {
            dataObj['title'] = TPCONSTANT.RESOURCES_TITLE[type] + " " + index;
        }
    };
    //To show user assign screen
    $scope.showAssignUser = function () {
        if ($scope.isUserAssigned) {
            var confirm = $mdDialog.confirm().textContent('It will reassign previously assigned students of all resources and activities').ok('Ok').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                $state.go('assignUsers', {
                    planId: $state.params.planId,
                    previousState: {
                        state: 'newTeachingPlan',
                        params: $stateParams
                    }
                });
            }, function () {});
        } else {
            $state.go('assignUsers', {
                planId: $state.params.planId,
                previousState: {
                    state: 'newTeachingPlan',
                    params: $state.params
                }
            });
        }
    };
    $scope.gotoOverviewPage = function () {
        if ($scope.isEdit) $state.go('viewTeachingPlan', {
            planId: $stateParams.planId
        });else $state.go('authoringTool');
    };
    $scope.selectFromArchive = function () {

        var teachingPlan = $scope.teachingPlan;
        var searchFilters = [];
        searchFilters.push({
            type: "tab",
            value: {
                _id: "teachingPlan",
                name: "Plans"
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: "theme",
            value: {
                _id: $state.params.id,
                name: $scope.themeName
            },
            deletable: false,
            visible: true
        });
        var details = {
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            isMultiSelect: false,
            activeTab: 'teachingPlan',
            resourceType: {
                _id: "teachingPlan",
                name: "Plans"
            }
        };
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    $scope.getClassroomTopics = function () {
        $scope.isLoading = true;
        var reqObj = {
            course_id: $scope.classroomDetails._id,
            teacher_email: localStorageService.get('username'),
            school_id: authoringData.school_id
        };
        authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_CLASSROOM_TOPICS, 'POST', reqObj, function (response) {
            $scope.isLoading = false;
            if (response.result && response.result.data && response.result.data.details) {
                $scope.topics = response.result.data.details.topic;
                if ($scope.topics) {
                    $mdDialog.show({
                        controller: DialogController,
                        template: '<md-dialog>' + '<md-toolbar>' + '<div class="md-toolbar-tools">' + '<h2>Select Teaching Plan</h2>' + '<span flex></span>' + '<md-button class="md-icon-button" ng-click="cancel()">' + '<i class="fas fa-times"></i>' + '</md-button>' + '</div>' + '</md-toolbar>' + '<md-dialog-content>' + '<div class="md-dialog-content">' + '<div ng-repeat="topic in topics" ng-click="selectTeachingPlan(topic)">' + '<p>{{topic.name}}</p>' + '</div>' + '</div>' + '</md-dialog-content>' + '</md-dialog>',
                        parent: angular.element(document.body),
                        topics: $scope.topics,
                        clickOutsideToClose: true
                    }).then(function (topic) {
                        $scope.isLoading = true;
                        $scope.importFromClassroom(topic);
                    });
                } else {
                    toastr.error('No Topics are added for this Course in Google Classroom');
                }
            } else {
                $scope.isLoading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.importFromClassroom = function (topic) {
        var reqObj = {
            topic_details: topic,
            teacher_id: userId,
            teacher_email: localStorageService.get('username'),
            academic_details: {
                session_id: authoringData.session_id,
                curriculum_id: authoringData.curriculum_id,
                class_id: authoringData.class_id,
                batch_id: authoringData.batch_id,
                subject_id: authoringData.subject_id,
                session: authoringData.session,
                curriculum: authoringData.curriculum,
                class: authoringData.class,
                batch: authoringData.batch,
                subject: authoringData.subject,
                school_id: authoringData.school_id,
                academic_year: authoringData.academic_year,
                theme_id: $state.params.id,
                theme_title: $scope.themeName
            }
        };
        $scope.isLoading = true;
        authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_IMPORT_FROM_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
            $scope.isLoading = false;
            if (response.result && response.result.data && response.result.data.details) {
                var _planId4 = response.result.data.details._id;
                toastr.success('Teaching Plan created successfully');
                if (response.result.data.details.is_resource_exists) {
                    $state.go('wizard', {
                        planId: _planId4
                    });
                } else {
                    $state.go('viewTeachingPlan', {
                        planId: _planId4
                    });
                }
            } else {
                $scope.isLoading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    this.$onDestroy = function () {};
}];

function DialogController($scope, $mdDialog, topics) {
    $scope.topics = topics;
    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.selectTeachingPlan = function (topicId) {
        $mdDialog.hide(topicId);
    };
}

exports.default = TeachingPlanController;

/***/ }),
/* 362 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.btn,.btn-large{color:#424242!important;background-color:#d6dff5!important;height:30px;width:46px;margin:0 2px}.popup-header-color{background:#00b6f2!important;color:#fff;padding:5px}.dialog-content{width:100%}.ta-scroll-window.form-control{border:1px solid #ccc;border-radius:4px}</style> <md-dialog class=dialog-content> <form> <md-toolbar> <div class=\"md-toolbar-tools popup-header-color\"> <h2 class=popup-head>{{popupTitle}}</h2> <span flex></span> <div style=cursor:pointer;outline:0 flex=5 ng-click=saveContent()> <i class=\"far fa-save\"></i> </div> <div style=cursor:pointer;outline:0 flex=5 ng-click=closeEditor()> <i class=\"fas fa-times\"></i> </div> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content style=\"border:1px solid #ccc\"> <text-angular ng-model=tp[reqObj] ta-toolbar=\"[['p', 'pre'],['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol'], ['justifyLeft','justifyCenter','justifyRight','indent','outdent']]\"></text-angular> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _textAngularPopup = __webpack_require__(362);

var _textAngularPopup2 = _interopRequireDefault(_textAngularPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewTeachingPlanController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "TPCONSTANT", "$stateParams", "$mdDialog", "GOOGLE_CLASSROOM_CONSTANTS", "Upload", "CONSTANTS", function ViewTeachingPlanController($scope, $rootScope, authService, localStorageService, $state, TPCONSTANT, $stateParams, $mdDialog, GOOGLE_CLASSROOM_CONSTANTS, Upload, CONSTANTS) {
    _classCallCheck(this, ViewTeachingPlanController);

    //To current teaching plan id
    var planId = $state.params.planId;
    //To get current user id
    var userId = localStorageService.get('user_id');
    $scope.editTp = false;
    var authoring = localStorageService.get("authoringData");
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (!authoring) {
            $state.go("authdashboard");
        } else {
            var reqObj = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                academic_year: authoring.academic_year,
                user_id: userId
            };
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classroomDetails = response.result.data.details;
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
            $scope.getTeachingPlan(planId);
        }
    };
    //To get Roles and Privileges
    var tpPrivilege = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "teachingPlan";
    });
    $scope.tpUserPrivilege = {};
    if (tpPrivilege.length > 0) {
        _.each(tpPrivilege, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.tpUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    //to check whether the user assigned for tp or not
    $scope.isUserAssigned = false;

    //to show or hide select role and user for approval process
    $scope.isSubmitApproval = false;

    //Status sent for approval
    $scope.isSentforApproval = false;

    //status (approve or reject)
    $scope.isStatusAdded = false;

    //approved
    $scope.isApproved = false;

    //created
    $scope.isCreated = false;

    //Boolean - To show complete button when the Teaching plan is approved
    $scope.isSetComplete = false;

    //Boolean - To show Teaching plan completed status
    $scope.isCompleted = false;
    $scope.isShowComplete = false;

    //Boolean - To show uncompleted resources
    $scope.isShowApprovedResources = false;

    //[Object] - Holds selected resource to submit for approval
    $scope.selectedResources = [];

    //[Object] - Holds selected resource to approve
    $scope.selectedResourcesforApproval = [];

    //Boolean - Current user is teaching plan creator or not
    $scope.isCreator = false;

    //Boolean -Current user is approver or not
    $scope.isApprover = false;

    $scope.isShowTpComplete = false;
    //Get approver list
    var APPROVER_LIST_URL = TPCONSTANT.API_TP_APPROVERS;

    // to get type of resource
    $scope.resourceTypes = TPCONSTANT.RESOURCES_LABEL;

    //Get teachingplan
    //let GET_TP_URL = API_GET_TP
    $scope.approveMode = false;

    var teachingPlanImgSize = 25;
    var rightArrowIconSize = 10;

    var setStatus = function setStatus(status) {
        switch (status) {
            case TPCONSTANT.STATUS_CREATED:
                $scope.isSentforApproval = false;
                $scope.isStatusAdded = false;
                $scope.isApproved = false;
                $scope.isCreated = true;
                break;
            case TPCONSTANT.STATUS_SENT_FOR_APPROVAL:
                $scope.isCreated = false;
                $scope.isStatusAdded = false;
                $scope.isApproved = false;
                $scope.isSentforApproval = true;
                break;
            case TPCONSTANT.STATUS_APPROVED:
                $scope.isCreated = false;
                $scope.isSentforApproval = false;
                $scope.isStatusAdded = true;
                $scope.isApproved = true;
                $scope.preetyStatus = 'Teaching Plan Approved';
                break;
            case TPCONSTANT.STATUS_REJECTED:
                $scope.isCreated = false;
                $scope.isSentforApproval = false;
                $scope.isStatusAdded = true;
                $scope.preetyStatus = 'Rejected';
                $scope.isApproved = false;
                break;
        }
    };

    this.userId = userId;
    localStorageService.set("viewMode", true);

    var plansSub = undefined;

    $scope.getTeachingPlan = function (planId) {
        authService.callAPI(TPCONSTANT.API_GET_TP + planId + "/" + userId, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.teachingPlan = response.result.data;
                if ($scope.teachingPlan && $scope.teachingPlan.teacher_id === userId) $scope.isCreator = true;

                var isStatusSet = false;
                $scope.themeId = $scope.teachingPlan.theme_id;

                if ($scope.tpUserPrivilege.newTeachingPlan && $scope.tpUserPrivilege.newTeachingPlan.edit) {
                    isStatusSet = true;
                    $scope.editStatus = true;
                }
                if ($scope.tpUserPrivilege.approveTeachingPlan && $scope.tpUserPrivilege.approveTeachingPlan.create) {
                    $scope.approveMode = true;
                    isStatusSet = true;
                }
                if (!isStatusSet) {
                    $scope.isStudent = true;
                }

                //to check whether the tp has assigned users
                if ($scope.teachingPlan && $scope.teachingPlan.assign_users && $scope.teachingPlan.assign_users.list && $scope.teachingPlan.assign_users.list.length > 0) {
                    $scope.isUserAssigned = true;
                }

                /***************** For send for Approval : START *************/

                var isCurrentApprover = false;
                var academics = {
                    session_id: authoring.session_id,
                    curriculum_id: authoring.curriculum_id,
                    class_id: authoring.class_id,
                    batch_id: authoring.batch_id,
                    subject_id: authoring.subject_id,
                    school_id: authoring.school_id
                };
                authService.callAPI(APPROVER_LIST_URL, "POST", academics, function (response) {
                    if (response.result && response.result.data && response.result.data.data) {
                        var resultData = response.result.data.data;
                        if (resultData && resultData.length > 0 && resultData[0].roles) $scope.approverRoles = resultData[0].roles;
                        if ($scope.teachingPlan && $scope.teachingPlan.current_approver) {
                            $scope.approverRole = $scope.teachingPlan.current_approver.role;
                            $scope.filterPerson();
                            $scope.approverPerson = $scope.teachingPlan.current_approver._id;
                            isCurrentApprover = true;
                            if ($scope.teachingPlan.status !== TPCONSTANT.STATUS_SENT_FOR_APPROVAL) $scope.isApprover = false;
                        }
                        $scope.$apply();
                    } else {}
                });

                /*if ($scope.teachingPlan && $scope.teachingPlan.status === "approved") {
                    if ($scope.teachingPlan.isComplete === false) {
                        $scope.isShowComplete = true
                    }
                    if ($scope.teachingPlan.isComplete === true) {
                        $scope.isCompleted = true
                        $scope.isShowComplete = false
                    }
                }*/

                //To get content added resources for send for approval
                $scope.contentCreatedResources = [];
                $scope.contentCreatedResourceIds = [];
                if ($scope.teachingPlan && $scope.teachingPlan.resources && $scope.teachingPlan.resources.length > 0) {
                    _.each($scope.teachingPlan.resources, function (resource) {
                        if (resource.status) {
                            if (resource.status === 'created' || resource.status === 'sent_for_approval') {
                                $scope.contentCreatedResources.push(resource);
                                $scope.contentCreatedResourceIds.push(resource._id);
                                if (isCurrentApprover) {
                                    if (resource.current_approver) {
                                        if (resource.current_approver._id === $scopeteachingPlan.current_approver._id) $scope.selectedResources.push(resource._id);
                                    }
                                }
                            }
                        }
                    });
                }
                /********** For Approval : START *****************/
                if ($scope.approveMode) {
                    //[Object] - details of resources to approve
                    $scope.approveResources = [];

                    //[String] - Ids of resources to approve
                    $scope.approveResourcesIds = [];

                    //whether to approve this teaching plan or not
                    $scope.isTeachingPlantoApporve = false;
                    if ($scope.teachingPlan.current_approver) {
                        if ($scope.teachingPlan.status === 'sent_for_approval' && $scope.teachingPlan.current_approver._id === userId) {
                            $scope.isTeachingPlantoApporve = true;
                            $scope.isApprover = true;
                        }
                    }
                    _.each($scope.teachingPlan.resources, function (resource) {
                        if (resource.current_approver) {
                            if (resource.status === 'sent_for_approval' && resource.current_approver._id === userId) {
                                $scope.isResourceAccess = true;
                                $scope.approveResources.push(resource);
                                $scope.approveResourcesIds.push(resource._id);
                                $scope.isApprover = true;
                            }
                        }
                    });
                }
                /********** For Approval : END *****************/

                /********** For Approval : START *****************/
                if ($scope.teachingPlan.students && $scope.teachingPlan.students.length > 0) {
                    if ($scope.teachingPlan.status === TPCONSTANT.STATUS_APPROVED && $scope.teachingPlan.isComplete === false) {
                        $scope.isSetComplete = true;
                        $scope.isShowComplete = false;
                        $scope.isCompleted = false;
                        $scope.isShowApprovedResources = false;
                    } else if ($scope.teachingPlan.status === TPCONSTANT.STATUS_APPROVED && $scope.teachingPlan.isComplete === true) {
                        $scope.isCompleted = true;
                        $scope.isSetComplete = false;
                        $scope.isShowApprovedResources = false;
                        $scope.isShowComplete = false;
                    }
                }
                $scope.approvedResources = [];
                $scope.approvedResourcesIds = [];
                $scope.completedResources = [];
                if ($scope.teachingPlan && $scope.teachingPlan.resources.length > 0) {
                    _.each($scope.teachingPlan.resources, function (resource) {
                        if (resource.status) {
                            if ((resource.status === 'approved' || resource.status === 'conducted' || resource.status === 'published') && resource.isComplete === false) {
                                $scope.approvedResources.push(resource);
                                $scope.approvedResourcesIds.push(resource._id);
                            } else if (resource.status === 'approved' && resource.isComplete === true) $scope.completedResources.push(resource);
                        }
                        if ($scope.teachingPlan.resources.length === $scope.completedResources.length) {
                            $scope.isShowComplete = true;
                        }
                    });
                } else if ($scope.teachingPlan && $scope.teachingPlan.status === "approved") {
                    if ($scope.teachingPlan.resources.length === 0 && $scope.teachingPlan.isComplete === false) {
                        $scope.isShowTpComplete = true;
                    } else {
                        $scope.isShowComplete = true;
                    }
                }
                /********** For Approval : END *****************/
                setStatus($scope.teachingPlan.status);
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    this.$onDestroy = function () {};
    //To show user assign screen
    $scope.showAssignUser = function () {
        if ($scope.isUserAssigned) {
            var confirm = $mdDialog.confirm().textContent('It will reassign previously assigned students').ok('Ok').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                $state.go('assignUsers', {
                    planId: $state.params.planId,
                    previousState: {
                        state: $state.current.name,
                        params: {
                            'planId': $state.params.planId,
                            resourceId: $state.params.resourceId
                        }
                    }
                });
            }, function () {});
        } else {
            $state.go('assignUsers', {
                planId: $state.params.planId,
                previousState: {
                    state: $state.current.name,
                    params: {
                        'planId': $state.params.planId,
                        resourceId: $state.params.resourceId
                    }
                }
            });
        }
    };

    $scope.filterPerson = function () {
        // let approverList = _.filter($scope.approverRoles, function (person) {
        //     return person._id.indexOf($scope.approverRole) !== -1;
        // })
        var approverList = _.filter($scope.approverRoles, function (person) {
            return person._id == $scope.approverRole;
        });
        if (approverList && approverList.length > 0) $scope.approverRolePersons = approverList[0].users;
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    var teachingPlanImg = 'teaching_plan.png';
    var rightArrow = 'ibt/arrow_right.png';
    convertFileToDataURLviaFileReader(teachingPlanImg, function (base64Image) {
        $scope.teachingPlanImg = base64Image;
    });
    convertFileToDataURLviaFileReader(rightArrow, function (base64Image) {
        $scope.rightArrow = base64Image;
    });

    $scope.gotoSite = function (site) {
        if (site.indexOf("http") === -1) {
            site = "http://" + site;
        }
        window.open(site, "_blank");
    };

    // go to teaching plan edit mode with plan id and theme id
    $scope.gotoEdit = function () {
        console.log($scope.themeId);
        console.log(planId);
        $state.go('newTeachingPlan', {
            "id": $scope.themeId,
            "planId": planId
        });
    };

    // goto wizard page when click on next
    $scope.viewWizard = function () {
        $state.go('wizard', {
            "planId": planId
        });
    };

    //to show dropdown for selecting role and user for approval process
    $scope.submitforApprovalClick = function () {
        $scope.isSubmitApproval = true;
    };

    $scope.submitforApproval = function () {
        if (!$scope.approverRole) {
            $scope.approverRoleError = "Select a role";
        }
        if (!$scope.approverPerson) {
            $scope.approverPersonError = "Select a person";
        }
        if ($scope.approverRole && $scope.approverPerson) {
            var approverId = $scope.approverPerson;
            var resIds = [];
            if ($scope.selectedResources.length > 0) resIds = $scope.selectedResources;
            $scope.isSubmitApproval = false;
            var academics = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                class: authoring.class,
                batch: authoring.batch,
                session: authoring.session,
                subject: authoring.subject,
                curriculum: authoring.curriculum,
                academic_year: authoring.academic_year,
                tp_id: planId,
                res_ids: resIds,
                user_id: userId,
                approver_id: approverId,
                approver_role: $scope.approverRole,
                is_tp_approval: true
            };
            authService.callAPI(TPCONSTANT.API_SEND_FOR_APPROVAL, "POST", academics, function (response) {
                if (response.result) {
                    toastr.success("Successfully send for approval");
                    setStatus(TPCONSTANT.STATUS_SENT_FOR_APPROVAL);
                    console.log(response);
                } else {
                    console.log(response.error);
                }
            });
        }
    };

    $scope.setCompleteStatus = function () {

        $scope.isSetComplete = false;
        $scope.isShowApprovedResources = false;
        $scope.isShowComplete = false;
        $scope.isShowTpComplete = false;
        $scope.isSubmitApproval = false;
        var resIds = [];
        if ($scope.selectedApprovedResources) resIds = $scope.selectedApprovedResources;
        var palnObj = {
            plan_id: planId,
            res_ids: resIds,
            user_id: userId
        };
        authService.callAPI(TPCONSTANT.API_COMPLETE_TP, "POST", palnObj, function (response) {
            if (response) {
                $scope.isCompleted = true;
                $scope.isSetComplete = false;
                $scope.isShowApprovedResources = false;
                $scope.isShowComplete = false;
                $scope.isShowTpComplete = false;

                toastr.success("Updated complete status");
                $scope.getTeachingPlan(planId);
                $scope.$apply();
            } else {
                toastr.error("Network Error, please try later.");
            }
        });
    };

    $scope.cancelApproval = function () {
        $scope.isSubmitApproval = false;
    };

    $scope.approve = function (action) {
        var tpData = {
            approver_id: userId,
            tp_status: "approved",
            tp_id: planId,
            is_tp_approval: $scope.isTeachingPlantoApporve,
            res_ids: $scope.selectedResourcesforApproval,
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id,
            class: authoring.class,
            batch: authoring.batch,
            session: authoring.session,
            subject: authoring.subject,
            curriculum: authoring.curriculum,
            academic_year: authoring.academic_year
        };
        authService.callAPI(TPCONSTANT.API_APPROVE_TP, "POST", tpData, function (response) {
            if (response.result) {
                toastr.success("Teaching plan approved Successfully");
                console.log(response);
                setStatus(TPCONSTANT.STATUS_APPROVED);
                $scope.getTeachingPlan(planId);
                $scope.$apply();
            } else {
                console.log(response.error);
            }
        });
    };
    $scope.reject = function () {
        var tpData = {
            approver_id: userId,
            tp_status: "rejected",
            tp_id: planId,
            is_tp_approval: $scope.isTeachingPlantoApporve,
            res_ids: $scope.selectedResourcesforApproval,
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id,
            class: authoring.class,
            batch: authoring.batch,
            session: authoring.session,
            subject: authoring.subject,
            curriculum: authoring.curriculum,
            academic_year: authoring.academic_year
        };
        authService.callAPI(TPCONSTANT.API_REJECT_TP, "POST", tpData, function (response) {
            if (response.result) {
                toastr.success("Teaching plan rejected Successfully");
                console.log(response);
                setStatus(TPCONSTANT.STATUS_REJECTED);
                $scope.getTeachingPlan(planId);
                $scope.$apply();
            } else {
                console.log(response.error);
            }
        });
    };

    $scope.showComplete = function () {
        $scope.isShowApprovedResources = true;
        $scope.isShowComplete = true;
        $scope.isSetComplete = false;
    };

    $scope.selectAllStudent = {
        check: false

        /*
         * Function to select all resources to submit for approval
         * 
         * @return : null
         */
    };$scope.selectAllResources = function (type) {
        if (type == "submit") {
            if ($scope.selectAllStudent.check) $scope.selectedResources = $scope.contentCreatedResourceIds;else $scope.selectedResources = [];
        } else if (type == "approve") {
            if ($scope.selectAllStudent.check) $scope.selectedResourcesforApproval = $scope.approveResourcesIds;else $scope.selectedResourcesforApproval = [];
        } else if (type == "complete") {
            if ($scope.selectAllStudent.check) $scope.selectedApprovedResources = $scope.approvedResourcesIds;else $scope.selectedApprovedResources = [];
        }
    };

    $scope.changeResources = function (type) {
        if (type == "submit") {
            if ($scope.contentCreatedResourceIds.length !== $scope.selectedResources.length) $scope.selectAllStudent.check = false;else $scope.selectAllStudent.check = true;
        } else if (type == "approve") {
            if ($scope.selectedResourcesforApproval.length !== $scope.approveResourcesIds.length) $scope.selectAllStudent.check = false;else $scope.selectAllStudent.check = true;
        } else if (type == "complete") {
            if ($scope.selectedApprovedResources.length = $scope.approvedResourcesIds.length) $scope.selectAllStudent.check = false;else $scope.selectAllStudent.check = true;
        }
    };

    /*
     * Function to unselect all resources to submit for approval
     * 
     * @return : null
     */
    $scope.unselectAllResources = function (type) {
        if (type == "submit") {
            $scope.selectedResources = [];
        } else if (type == "approve") {
            $scope.selectedResourcesforApproval = [];
        } else if (type == "complete") {
            $scope.selectedApprovedResources = [];
        }
    };

    $scope.gotoauthoringtool = function () {
        $state.go('authoringTool');
    };

    /*
     * To export teaching plan as PDF file
     * 
     * @return : null
     */

    $scope.exportAspagePDF = function () {
        if ($scope.teachingPlan) {
            var teachingPlanData = $scope.teachingPlan;

            /* html2canvas($("#myCanvas"),{
             onrendered: function(canvas) {  
             var imgData = canvas.toDataURL(
             'image/png');          
             var doc = new jsPDF('landscape');  
             var width  = canvas.width;
             var height  = canvas.height;
             console.log(width+"  "+height)
             doc.addImage(imgData, 'PNG',0, 5, width, height);
             doc.save(teachingPlanData.title + ".pdf"); 
             }
             }); */
            var quotes = document.getElementById('myCanvas');
            html2canvas(quotes, {
                onrendered: function onrendered(canvas) {
                    //! MAKE YOUR PDF
                    var pdf = new jsPDF('p', 'pt', 'letter');
                    for (var i = 0; i <= quotes.clientHeight / 1080; i++) {
                        //! This is all just html2canvas stuff
                        var srcImg = canvas;
                        var sX = 0;
                        var sY = 1080 * i; // start 980 pixels down for every new page
                        var sWidth = 900;
                        var sHeight = 1080;
                        var dX = 0;
                        var dY = 0;
                        var dWidth = 900;
                        var dHeight = 1080;
                        window.onePageCanvas = document.createElement("canvas");
                        onePageCanvas.setAttribute('width', 900);
                        onePageCanvas.setAttribute('height', 1080);
                        var ctx = onePageCanvas.getContext('2d');
                        ctx.drawImage(srcImg, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);
                        var canvasDataURL = onePageCanvas.toDataURL("image/png", 1.0);

                        var width = onePageCanvas.width;
                        var height = onePageCanvas.clientHeight;
                        if (i > 0) {
                            pdf.addPage(612, 791); //8.5" x 11" in pts (in*72)
                        }
                        pdf.setPage(i + 1);
                        //! now we add content to that page!
                        pdf.addImage(canvasDataURL, 'PNG', 20, 40, width * .62, height * .62);
                    }
                    //! after the for loop is finished running, we save the pdf.
                    pdf.save(teachingPlanData.title + ".pdf");
                }
            });
        }
        /*if ($scope.viewTeachingPlan.teachingPlanDetails) {
          let teachingPlanData = $scope.viewTeachingPlan.teachingPlanDetails;
          kendo.drawing
          .drawDOM("#myCanvas", 
          { 
          paperSize: "A4",
          margin: { top: "1cm", bottom: "1cm" },
          scale: 0.8,
          height: 500
          })
          .then(function(group){
          kendo.drawing.pdf.saveAs(group, teachingPlanData.title + ".pdf")
          });
        }*/
    };

    $scope.exportAsPDF = function () {
        if ($scope.viewTeachingPlan.teachingPlanDetails) {
            var teachingPlanData = $scope.viewTeachingPlan.teachingPlanDetails;
            var pdfContent = [];

            var header = {
                style: 'pdfheader',
                table: {
                    widths: ['*', '*', '*'],
                    body: [[{
                        width: 70,
                        height: 70,
                        image: $scope.imgurl1,
                        rowSpan: '3'
                    }, {
                        text: $scope.schoolHeader.schoolName,
                        fontSize: 18,
                        bold: true,
                        alignment: 'center'
                    }, {}], [{}, {
                        alignment: 'center',
                        fontSize: 13,
                        text: 'Academic Year : ' + $scope.schoolHeader.academicYear
                    }, {}], [{}, {
                        alignment: 'center',
                        fontSize: 14,
                        text: authoring.session + '/' + authoring.curriculum + '/' + authoring.class + '/' + authoring.batch
                    }, {}]]
                },
                layout: 'noBorders'
            };
            pdfContent.push(header);

            var teachingPlanHeader = {
                style: 'tpheader',
                table: {
                    widths: ['*', '*', 'auto'],
                    body: [[{
                        text: 'Theme : ' + teachingPlanData.theme_title,
                        style: 'tpheadertext'
                    }, {
                        text: 'Teaching Plan : ' + teachingPlanData.title,
                        style: 'tpheadertext'
                    }, {}]]
                },
                layout: 'noBorders'
            };
            pdfContent.push(teachingPlanHeader);

            var dateHeader = {
                style: 'dateheader',
                table: {
                    widths: ['*'],
                    body: [[{
                        text: 'Start Date : ' + teachingPlanData.start_date.getDate() + '.' + teachingPlanData.start_date.getMonth() + '.' + teachingPlanData.start_date.getFullYear() + '    End Date : ' + teachingPlanData.end_date.getDate() + '.' + teachingPlanData.end_date.getMonth() + '.' + teachingPlanData.end_date.getFullYear(),
                        fontSize: 11,
                        color: '#006cbb',
                        margin: [5, 5, 5, 5]
                    }]]
                },
                layout: 'noBorders'
            };
            pdfContent.push(dateHeader);

            if (teachingPlanData.objectives && teachingPlanData.objectives.length > 0) {
                var tableBody = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#f14e5a'
                }, {
                    text: 'OBJECTIVES',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.objectives, function (data) {
                    tableBody.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var tpBody = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: tableBody
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(tpBody);
            }

            if (teachingPlanData.knowledge_required && teachingPlanData.knowledge_required.length > 0) {
                var _tableBody = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00b4be'
                }, {
                    text: 'REQUIRED KNOWLEDGE',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.knowledge_required, function (data) {
                    _tableBody.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody);
            }

            if (teachingPlanData.learning_materials && teachingPlanData.learning_materials.length > 0) {
                var _tableBody2 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#fbbc48'
                }, {
                    text: 'REQUIRED LEARNING MATERIALS',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.learning_materials, function (data) {
                    _tableBody2.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody2 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody2
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody2);
            }

            if (teachingPlanData.teaching_methodology && teachingPlanData.teaching_methodology.length > 0) {
                var _tableBody3 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00b6ef'
                }, {
                    text: 'REQUIRED TEACHING METHODOLOGY',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.teaching_methodology, function (data) {
                    _tableBody3.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody3 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody3
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody3);
            }

            if (teachingPlanData.life_skills && teachingPlanData.life_skills.length > 0) {
                var _tableBody4 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00ba9c'
                }, {
                    text: 'REQUIRED LIFE SKILLS',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.life_skills, function (data) {
                    _tableBody4.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody4 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody4
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody4);
            }

            if (teachingPlanData.conclusion && teachingPlanData.conclusion.length > 0) {
                var _tableBody5 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#f14e5a'
                }, {
                    text: 'REQUIRED CONCLUSION',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.conclusion, function (data) {
                    _tableBody5.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody5 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody5
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody5);
            }

            if (teachingPlanData.formative_assessment && teachingPlanData.formative_assessment.length > 0) {
                var _tableBody6 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00b4be'
                }, {
                    text: 'REQUIRED FORMATIVE ASSESSMENT',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.formative_assessment, function (data) {
                    _tableBody6.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody6 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody6
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody6);
            }

            if (teachingPlanData.resources_including_ICT && teachingPlanData.resources_including_ICT.length > 0) {
                var _tableBody7 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#fbbc48'
                }, {
                    text: 'REQUIRED RESOURCES INCLUDING ICT',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.resources_including_ICT, function (data) {
                    _tableBody7.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody7 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody7
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody7);
            }

            if (teachingPlanData.flow_of_lesson && Object.keys(teachingPlanData.flow_of_lesson).length > 0) {
                var tableHead = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00b6ef'
                }, {
                    text: 'FLOW OF TEACHING PLAN',
                    style: 'tpbodyhead'
                }]];
                var tpHead = {
                    pageBreak: 'before',
                    style: 'tpnewhead',
                    table: {
                        widths: ['auto', '*'],
                        body: tableHead
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(tpHead);
                var _tableBody8 = [];
                var tableBodyKey = [];
                var tableBodyData = [];
                _.each(teachingPlanData.flow_of_lesson, function (data, key) {
                    tableBodyKey.push({
                        text: $scope.keyReplaceCase(key),
                        style: 'tpbodyheaddata'
                    });
                    tableBodyData.push({
                        text: data,
                        style: 'tpnewbodydata'
                    });
                });
                var dataLength = Math.ceil(tableBodyKey.length / 2);
                for (var i = 0; i < dataLength; i++) {
                    var keys = [];
                    var values = [];
                    tableBodyKey[2 * i] != undefined ? keys.push(tableBodyKey[2 * i]) : keys.push({});
                    tableBodyKey[2 * i + 1] != undefined ? keys.push(tableBodyKey[2 * i + 1]) : keys.push({});
                    _tableBody8.push(keys);
                    tableBodyData[2 * i] != undefined ? values.push(tableBodyData[2 * i]) : values.push({});
                    tableBodyData[2 * i + 1] != undefined ? values.push(tableBodyData[2 * i + 1]) : values.push({});
                    _tableBody8.push(values);
                }
                var _tpBody8 = {
                    style: 'tpnewbody',
                    table: {
                        widths: ['*', '*'],
                        body: _tableBody8
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody8);
            }

            if (teachingPlanData.remedial_teaching_plan && Object.keys(teachingPlanData.remedial_teaching_plan).length > 0) {
                var _tableHead = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#00ba9c'
                }, {
                    text: 'REMEDIAL TEACHING PLAN',
                    style: 'tpbodyhead'
                }]];
                var _tpHead = {
                    style: 'tpnewhead',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableHead
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpHead);
                var _tableBody9 = [];
                var _tableBodyKey = [];
                var _tableBodyData = [];
                _.each(teachingPlanData.remedial_teaching_plan, function (data, key) {
                    _tableBodyKey.push({
                        text: $scope.keyReplaceCase(key),
                        style: 'tpbodyheaddata'
                    });
                    _tableBodyData.push({
                        text: data,
                        style: 'tpnewbodydata'
                    });
                });
                var _dataLength = Math.ceil(_tableBodyKey.length / 2);
                for (var _i = 0; _i < _dataLength; _i++) {
                    var _keys = [];
                    var _values = [];
                    _tableBodyKey[2 * _i] != undefined ? _keys.push(_tableBodyKey[2 * _i]) : _keys.push({});
                    _tableBodyKey[2 * _i + 1] != undefined ? _keys.push(_tableBodyKey[2 * _i + 1]) : _keys.push({});
                    _tableBody9.push(_keys);
                    _tableBodyData[2 * _i] != undefined ? _values.push(_tableBodyData[2 * _i]) : _values.push({});
                    _tableBodyData[2 * _i + 1] != undefined ? _values.push(_tableBodyData[2 * _i + 1]) : _values.push({});
                    _tableBody9.push(_values);
                }
                var _tpBody9 = {
                    style: 'tpnewbody',
                    table: {
                        widths: ['*', '*'],
                        body: _tableBody9
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody9);
            }

            if (teachingPlanData.resources && teachingPlanData.resources.length > 0) {
                var _tableBody10 = [[{
                    width: teachingPlanImgSize,
                    height: teachingPlanImgSize,
                    image: $scope.teachingPlanImg,
                    fillColor: '#f14e5a'
                }, {
                    text: 'RESOURCES REQUIRED',
                    style: 'tpbodyhead'
                }]];
                _.each(teachingPlanData.resources, function (data) {
                    _tableBody10.push([{
                        width: rightArrowIconSize,
                        height: rightArrowIconSize,
                        image: $scope.rightArrow
                    }, {
                        text: data.title,
                        style: 'tpbodydata'
                    }]);
                });
                var _tpBody10 = {
                    style: 'tpbody',
                    table: {
                        widths: ['auto', '*'],
                        body: _tableBody10
                    },
                    dontBreakRows: true,
                    layout: {
                        hLineColor: function hLineColor(i, node) {
                            return i === 0 || i === node.table.body.length ? '#dfdfdf' : 'white';
                        },
                        vLineColor: function vLineColor(i, node) {
                            return i === 0 || i === node.table.widths.length ? '#dfdfdf' : 'white';
                        }
                    }
                };
                pdfContent.push(_tpBody10);
            }

            var docDefinition = {
                footer: function footer(currentPage, pageCount) {
                    return {
                        text: currentPage.toString() + ' of ' + pageCount,
                        alignment: 'center'
                    };
                },
                content: pdfContent,
                styles: {
                    pdfheader: {
                        margin: [0, 5, 0, 15]
                    },
                    tpheader: {
                        margin: [0, 0, 0, 10],
                        fillColor: '#00ba9c'
                    },
                    tpheadertext: {
                        margin: [5, 10, 5, 10],
                        color: 'white',
                        bold: true,
                        fontSize: 13
                    },
                    dateheader: {
                        margin: [0, 0, 0, 10],
                        fillColor: '#dfdfdf'
                    },
                    tpbody: {
                        margin: [0, 0, 0, 10]
                    },
                    tpbodyhead: {
                        margin: [5, 5, 0, 0],
                        color: '#006cbb',
                        fillColor: '#dfdfdf',
                        fontSize: 13,
                        bold: true
                    },
                    tpbodydata: {
                        margin: [0, 3, 0, 0],
                        fontSize: 12
                    },
                    tpnewhead: {
                        margin: [0, 0, 0, 0],
                        color: '#006cbb',
                        fillColor: '#dfdfdf',
                        fontSize: 13,
                        bold: true
                    },
                    tpnewbody: {
                        margin: [0, 0, 0, 10]
                    },
                    tpbodyheaddata: {
                        margin: [5, 5, 0, 0],
                        color: '#006cbb',
                        fontSize: 12,
                        bold: true
                    },
                    tpnewbodydata: {
                        margin: [5, 0, 0, 5]
                    }
                }
            };
            pdfMake.createPdf(docDefinition).download(teachingPlanData.title + '.pdf');
            try {
                var tincanData = {
                    actor: {
                        "mbox": "mailto:" + Meteor.user().username,
                        "account": {
                            "name": Meteor.user().name,
                            "homePage": SITE_URL
                        },
                        "objectType": "Agent"
                    },
                    verb: {
                        id: SITE_URL + "expapi/verbs/interacted",
                        display: {
                            "en-US": "clicked"
                        }
                    },
                    object: {
                        id: window.location.href,
                        definition: {
                            type: SITE_URL + "type/teachingplan",
                            name: {
                                "en-US": "Export as PDF"
                            },
                            description: {
                                "en-US": "Export as PDF button is clicked"
                            },
                            "objectType": "Activity"
                        }
                    }
                };
                TinCanApiService.sendTincanApiRequest(tincanData);
            } catch (ex) {}
        }
    };

    /*
     * To replace '_' and convert each word first letter as Upper case letter
     * 
     * @data : String - Data to be replace
     * 
     * @return : String - Given data without Underscore
     */
    $scope.keyReplaceCase = function (data) {
        var str = data.replace(/_/g, ' ');
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    $scope.exportToClassroom = function (name) {
        var topicName = name ? name : $scope.teachingPlan.title;
        var reqObj = {
            tp_id: $scope.teachingPlan._id,
            tp_name: topicName,
            course_id: $scope.classroomDetails._id,
            teacher_email: localStorageService.get('username'),
            school_id: authoring.school_id
        };
        $scope.isLoading = true;
        authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_EXPORT_TO_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
            if (response.result && response.result.data) {
                try {
                    $scope.isLoading = false;
                    toastr.success('Teaching Plan exported successfully');
                } catch (ex) {
                    $scope.isLoading = false;
                    console.log(ex);
                }
            } else if (response.error && response.error.error && response.error.error.errors) {
                if (response.error.error.errors[0].reason === 'alreadyExists') {
                    var confirm = $mdDialog.confirm().title('Already Exists!').textContent('A topic with the same Teaching Plan name already exists on your Google Classroom course. Do you want to make a copy?').ariaLabel('Lucky day').ok('Yes').cancel('No');
                    $mdDialog.show(confirm).then(function () {
                        var newTopicName = $scope.teachingPlan.title + '_copy_' + +new Date();
                        $scope.exportToClassroom(newTopicName);
                    }, function () {
                        $scope.isLoading = false;
                    });
                } else {
                    $scope.isLoading = false;
                    toastr.error('Network Error. Please try later');
                }
            } else {
                $scope.isLoading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
}];

exports.default = ViewTeachingPlanController;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WizardController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var WizardController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$mdDialog", "TPCONSTANT", function WizardController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $mdDialog, TPCONSTANT) {
    _classCallCheck(this, WizardController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var authoring = localStorageService.get("authoringData");
    var planId = $state.params.planId;
    var note = {};

    var GET_PLAN = TPWIZARDCONSTANT.API_GET_TP + planId + "/" + userId;

    var RESOURCES_LABEL = TPWIZARDCONSTANT.RESOURCES_LABEL;
    var RESOURCE_IMAGE = TPWIZARDCONSTANT.RESOURCES_IMG;

    $scope.wizardItems = [];
    $scope.isViewMode = false;
    var reportId = "reports";
    $scope.approveMode = false;

    $scope.isResourceCompleted = function () {
        var currentResource = $scope.currentResource;
        if (currentResource) {
            if (currentResource.type === "activityForm") {
                if (currentResource.status === "conducted" || currentResource.status === "published") {
                    var alert = $mdDialog.alert().textContent(currentResource.title + ' is ' + currentResource.status + '.' + ' So you cannot edit it').clickOutsideToClose(true).ok('Ok');
                    $mdDialog.show(alert);
                    return true;
                } else {
                    return false;
                }
            }
            if (currentResource.isComplete) {
                var alert = $mdDialog.alert().textContent(currentResource.title + ' is completed. So you cannot edit it').clickOutsideToClose(true).ok('Ok');
                $mdDialog.show(alert);
                return true;
            } else {
                return false;
            }
        }
    };

    var setResource = function setResource() {
        var stateName = $scope.currentResource.type;
        var _id = $scope.currentResource._id;
        if ($scope.isViewMode) {
            stateName = stateName + "Preview";
        }
        if (stateName !== "reports") {
            $state.go(stateName, {
                resourceId: _id
            });
        }
    };

    $scope.gotoEditMode = function () {
        if (!$scope.isResourceCompleted()) {
            localStorageService.set("viewMode", false);
            $scope.isViewMode = false;
            setResource();
            authService.callAPI(GET_PLAN, "GET", {}, setWizard);
        }
    };

    $scope.gotoViewMode = function () {
        localStorageService.set("viewMode", true);
        $scope.isViewMode = true;
        setResource();
        authService.callAPI(GET_PLAN, "GET", {}, setWizard);
    };

    $rootScope.setStatus = function (itemId, status) {
        _.each($scope.wizardItems, function (resource) {
            if (resource._id == itemId) resource.status = status;
        });
        setStatus(status);
    };

    /*
     * To set boolean values based on resource status
     * 
     * @status : String - status of the resources
     * 
     * @return : null
     */
    var setStatus = function setStatus(status) {
        if (!status) {
            $scope.isCreated = false;
            $scope.isSentforApproval = false;
            $scope.isStatusAdded = false;
            $scope.isApproved = false;
        } else {
            switch (status) {
                case TPWIZARDCONSTANT.STATUS_CREATED:
                    $scope.isCreated = true;
                    $scope.isSentforApproval = false;
                    $scope.isStatusAdded = false;
                    $scope.isApproved = false;
                    break;
                case TPWIZARDCONSTANT.STATUS_SENT_FOR_APPROVAL:
                    $scope.isSentforApproval = true;
                    $scope.isStatusAdded = false;
                    $scope.isCreated = false;
                    $scope.isApproved = false;
                    break;
                case TPWIZARDCONSTANT.STATUS_APPROVED:
                    $scope.isCreated = false;
                    $scope.isSentforApproval = false;
                    $scope.isApproved = true;
                    $scope.isStatusAdded = true;
                    $scope.preetyStatus = 'Approved';
                    break;
                case TPWIZARDCONSTANT.STATUS_REJECTED:
                    $scope.isCreated = false;
                    $scope.isSentforApproval = false;
                    $scope.isApproved = false;
                    $scope.isStatusAdded = true;
                    $scope.preetyStatus = 'Rejected';
                    break;
                case TPWIZARDCONSTANT.STATUS_CONDUCTED:
                    $scope.isCreated = false;
                    $scope.isSentforApproval = false;
                    $scope.isApproved = true;
                    $scope.isStatusAdded = true;
                    $scope.preetyStatus = 'Approved';
                    break;
            }
        }
    };

    var itemClicked = function itemClicked(clickedResource) {
        $scope.writeNote = false;
        $scope.isSubmitApproval = false;
        $scope.isUserAssigned = false;
        $scope.isSentforApproval = false;
        $scope.isReport = false;
        $scope.isActivityConducted = false;
        $scope.toShare = false;

        //Boolean - To show complete button when the Teaching plan is approved
        $scope.isShowComplete = false;

        //Boolean - To show Teaching plan completed status
        $scope.isCompleted = false;

        if (clickedResource.type === "reports") {
            $scope.isReport = true;
        }
        if (clickedResource.type != "reports" && clickedResource.type != "activityForm") {
            $scope.toShare = true;
        }
        $scope.currentResource = clickedResource;
        $scope.currentStatus = clickedResource.status;
        setStatus(clickedResource.status);
        note.resource = {
            '_id': clickedResource._id,
            'title': clickedResource.title,
            'type': clickedResource.type,
            'mode': $scope.isViewMode
        };
        if (clickedResource.type == "activityForm") {
            $scope.isPractice = clickedResource.isPractice;
            $scope.isActivityConducted = false;
        }

        //to check whether the resources has assigned users or not
        if (clickedResource.assign_users && clickedResource.assign_users.list && clickedResource.assign_users.list.length > 0) {
            $scope.isUserAssigned = true;
            var status = TPWIZARDCONSTANT.STATUS_APPROVED;
            if (clickedResource.type == "activityForm") status = TPWIZARDCONSTANT.STATUS_CONDUCTED;
            if (clickedResource.status && clickedResource.status === status) {
                if (clickedResource === TPWIZARDCONSTANT.STATUS_CONDUCTED) $scope.isActivityConducted = true;
                if (clickedResource.isComplete) {
                    $scope.isShowComplete = false;
                    $scope.isCompleted = true;
                } else {
                    $scope.isCompleted = false;
                    $scope.isShowComplete = true;
                }
            }
        }
        _.each($scope.wizardItems, function (item) {
            if (item._id === clickedResource._id) {
                item.active = true;
            } else {
                item.active = false;
            }
        });
        setResource();
    };

    $scope.clicked = function (clickedResource) {
        if (clickedResource) {
            if (clickedResource._id === reportId) {
                itemClicked(clickedResource);
            } else {
                if ($scope.isViewMode !== true) {
                    if (!$scope.isResourceCompleted(clickedResource)) {
                        itemClicked(clickedResource);
                    }
                } else {
                    itemClicked(clickedResource);
                }
            }
        }
    };

    function addResources(each) {
        var visited = false;
        var active = false;
        if (each.type) {
            if ($state.params.resource && $state.params.resource == each._id) {
                $scope.currentStatus = each.status;
                setStatus(each.status);
                if (each.assign_users && each.assign_users.list && each.assign_users.list.length > 0) {
                    $scope.isUserAssigned = true;
                    var status = TPWIZARDCONSTANT.STATUS_APPROVED;
                    if (each.type == "activityForm" && !each.isPractice) status = TPWIZARDCONSTANT.STATUS_CONDUCTED;
                    if (each.status && each.status === status) {
                        if (each.status === TPWIZARDCONSTANT.STATUS_CONDUCTED) $scope.isActivityConducted = true;
                        if (each.isComplete) {
                            $scope.isShowComplete = false;
                            $scope.isCompleted = true;
                        } else {
                            $scope.isCompleted = false;
                            $scope.isShowComplete = true;
                        }
                    }
                }
                if (each.type != "reports" && each.type != "activityForm") {
                    $scope.toShare = true;
                }

                active = true;
            }
            if (each.status) {
                visited = true;
            }

            var obj = each;
            obj.name = RESOURCES_LABEL[each.type];
            obj.caption = RESOURCES_LABEL[each.type] + "-" + each.title;
            obj.imgUrl = RESOURCE_IMAGE[each.type];
            obj.visited = visited;
            obj.active = active;
            obj.direction = "left";
            if ($scope.wizardItems.findIndex(function (i) {
                return i._id === obj._id;
            }) === -1) $scope.wizardItems.push(obj);
        }
    }

    var setWizard = function setWizard(response) {
        if (response && response.result && response.result.data) {
            var tp = response.result.data;
            localStorageService.set("currentPlan", tp);
            $scope.planTilte = tp.title;
            $scope.themeTitle = tp.theme_title;
            note = {
                'academics': {
                    'session_id': tp.session_id,
                    'curriculum_id': tp.curriculum_id,
                    'class_id': tp.class_id,
                    'batch_id': tp.batch_id,
                    'subject_id': tp.subject_id,
                    'school_id': tp.school_id
                },
                'teaching_plan': {
                    '_id': tp._id,
                    'title': tp.title
                },
                'theme': {
                    '_id': tp.theme_id,
                    'title': tp.theme_title
                },
                'academic_year': tp.academic_year
            };
            if (tp.teacher_id === userId) {
                $scope.isCreator = true;
            }
            if (tp.status === 'draft') {
                $scope.isDraft = true;
            }
            var resources = tp.resources;
            var assignedResources = tp.assign_resources;
            if (resources && resources.length > 0) {
                _.each(resources, function (each) {
                    if ($scope.wizardUserPrivilege.approveResource && $scope.wizardUserPrivilege.approveResource.create) {
                        var resIds = localStorageService.get("approverResourceIds");
                        if (resIds && resIds.length > 0) {
                            $scope.isApprover = true;
                            _.each(resIds, function (ob) {
                                if (each._id === ob) {
                                    $scope.isResourceExist = true;
                                    addResources(each);
                                }
                            });
                        }
                    }
                    if ($scope.wizardUserPrivilege.shareContent && $scope.wizardUserPrivilege.shareContent.read) {
                        if (each.status === 'approved') {
                            // Display teaching plan to shared parents only
                            if (each.shared_parents) {
                                _.each(each.shared_parents, function (eachUser) {
                                    if (eachUser.parent_id === userId) {
                                        addResources(each);
                                    }
                                });
                            }
                        }
                    }
                    if ($scope.wizardUserPrivilege.studentPreview && $scope.wizardUserPrivilege.studentPreview.read) {
                        if (_.contains(assignedResources, each._id)) {
                            addResources(each);
                        }
                    }
                    if ($scope.wizardUserPrivilege.enableToggleView && $scope.wizardUserPrivilege.enableToggleView.edit && $scope.isCreator) {
                        addResources(each);
                    }
                });
                if ($scope.isViewMode && !$scope.approveMode) {
                    var report = {
                        _id: reportId,
                        name: reportId,
                        type: "reports",
                        visited: false,
                        active: false,
                        direction: "left",
                        imgUrl: "../../../../../img/report_card.png",
                        caption: "Report"
                    };
                    if ($scope.wizardItems.length > 0) {
                        var reportItem = $scope.wizardItems[$scope.wizardItems.length - 1];
                        if (reportItem._id !== reportId) {
                            $scope.wizardItems.push(report);
                        }
                    }
                } else {
                    $scope.wizardItems = $scope.wizardItems.filter(function (elem) {
                        return elem.type !== "reports";
                    });
                }
                if ($state.params.resourceId) {
                    var clickedResource = void 0;
                    _.each($scope.wizardItems, function (item) {
                        if (item._id === $state.params.resourceId) {
                            clickedResource = item;
                        }
                    });
                    $scope.clicked(clickedResource);
                } else {
                    $scope.clicked($scope.wizardItems[0]);
                }
            }
        }
    };

    // UserPrivilages.getUserPrivilageInitialSetting(function () {
    // let wizardUserAccess = UserPrivilages.getFeatures('wizard');
    // let noteUserAccess = UserPrivilages.getFeatures('viewnote');
    var wizardUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "wizard";
    });
    var noteUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "viewnote";
    });
    $scope.wizardUserPrivilege = {};
    $scope.noteUserPrivilege = {};
    if (wizardUserAccess.length > 0) {
        _.each(wizardUserAccess, function (wizardObj) {
            var user_access = {};
            _.each(wizardObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.wizardUserPrivilege[wizardObj.feature_id] = user_access;
        });
        if (noteUserAccess.length > 0) {
            _.each(noteUserAccess, function (noteObj) {
                var user_access = {};
                _.each(noteObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status;
                });
                $scope.noteUserPrivilege[noteObj.feature_id] = user_access;
            });
        }
        if ($scope.wizardUserPrivilege.approveResource && $scope.wizardUserPrivilege.approveResource.create) {
            if (!localStorageService.get("viewMode")) $scope.isViewMode = false;else $scope.isViewMode = true;
            $scope.approveMode = true;
        }
        if ($scope.wizardUserPrivilege.studentPreview && $scope.wizardUserPrivilege.studentPreview.read) {
            $scope.isViewMode = true;
        }
        authService.callAPI(GET_PLAN, "GET", {}, setWizard);
    }

    // Added by: Raziya
    // Assign users - start
    $scope.showAssignUser = function () {
        if ($scope.isUserAssigned) {
            var confirm = $mdDialog.confirm().textContent('It will reassign previously assigned students').ok('Ok').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                $state.go('assignUsers', {
                    planId: $state.params.planId,
                    previousState: {
                        state: $state.current.name,
                        params: {
                            'planId': $state.params.planId,
                            resourceId: $state.params.resourceId
                        }
                    }
                });
            }, function () {});
        } else {
            $state.go('assignUsers', {
                planId: $state.params.planId,
                previousState: {
                    state: $state.current.name,
                    params: {
                        'planId': $state.params.planId,
                        resourceId: $state.params.resourceId
                    }
                }
            });
        }
    };
    // Added by: Raziya
    //   Assign users - end

    // Added by: Raziya
    // To get approver list  - start
    var isCurrentApprover = false;
    var academics = {
        session_id: authoring.session_id,
        curriculum_id: authoring.curriculum_id,
        class_id: authoring.class_id,
        batch_id: authoring.batch_id,
        subject_id: authoring.subject_id,
        school_id: authoring.school_id
    };
    authService.callAPI(TPCONSTANT.API_TP_APPROVERS, "POST", academics, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            var resultData = response.result.data.data;
            if (resultData && resultData.length > 0 && resultData[0].roles) $scope.approverRoles = resultData[0].roles;
            $scope.$apply();
        } else {}
    });
    // Added by: Raziya
    //   To get approver list  - end

    //to filter person dropdown based on role
    $scope.filterPerson = function () {
        // let approverList = _.filter($scope.approverRoles, function(person) {
        //     return person._id.indexOf($scope.approverRole) !== -1;
        // })
        var approverList = _.filter($scope.approverRoles, function (person) {
            return person._id == $scope.approverRole;
        });
        if (approverList && approverList.length > 0) $scope.approverRolePersons = approverList[0].users;
    };

    // Added by: Raziya
    // send for approval  - start
    // to show dropdown for selecting role and user for approval process
    $scope.submitforApprovalClick = function () {

        $scope.isSubmitApproval = true;
    };

    // Added by: Raziya
    //   send for approval - start
    $scope.submitforApproval = function () {
        $scope.isLoading = true;
        var resId = [];
        if (!$scope.approverRole) {
            $scope.approverRoleError = "Select a role";
        }
        if (!$scope.approverPerson) {
            $scope.approverPersonError = "Select a person";
        }
        if ($scope.approverRole && $scope.approverPerson) {
            var approverId = $scope.approverPerson;
            if ($scope.currentResource) resId.push($scope.currentResource._id);
            $scope.isSubmitApproval = false;
            var _academics = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                session: authoring.session,
                curriculum: authoring.curriculum,
                class: authoring.class,
                batch: authoring.batch,
                subject: authoring.subject,
                tp_id: planId,
                res_ids: resId,
                user_id: userId,
                approver_id: approverId,
                approver_role: $scope.approverRole,
                is_tp_approval: false
            };
            authService.callAPI(TPCONSTANT.API_SEND_FOR_APPROVAL, "POST", _academics, function (response) {
                if (response.result) {
                    $scope.isSentforApproval = true;
                    $scope.isLoading = false;
                    toastr.success("Successfully send for approval");
                    console.log(response);
                } else {
                    $scope.isLoading = false;
                    console.log(response.error);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };

    $scope.cancelApproval = function () {
        $scope.isSubmitApproval = false;
    };

    // Added by: Raziya
    //   To approve or reject resources - start
    $scope.setResourceStatus = function (status) {
        var approveStatus = status;
        var isActivity = false;
        var currentResource = $scope.currentResource;
        if (currentResource.type === 'activityForm') {
            isActivity = true;
        }
        var resId = void 0;
        if ($scope.currentResource) resId = $scope.currentResource._id;
        var academics = {
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id,
            tp_id: planId,
            res_id: resId,
            user_id: userId,
            is_activity: isActivity,
            res_status: approveStatus
        };
        authService.callAPI(TPWIZARDCONSTANT.API_APPROVE_RESOURCE, "POST", academics, function (response) {
            if (response.result) {
                if (approveStatus === 'approved') {
                    setStatus(approveStatus);
                    toastr.success("Approved Successfully");
                } else {
                    setStatus(approveStatus);
                    toastr.error('Rejected');
                }
                console.log(response);
            } else {
                console.log(response.error);
            }
        });
    };
    /*Added by: Raziya
      To approve or reject resources - end*/

    //To add notes
    $scope.addNote = function () {
        $scope.userNotes = "";
        var data = {
            user_id: userId,
            plan_id: planId,
            theme_id: note.theme._id,
            resource_id: $scope.currentResource ? $scope.currentResource._id : null,
            academic_year: authoring.academic_year
        };
        authService.callAPI(TPWIZARDCONSTANT.API_GET_PREV_NOTES, "POST", data, function (response) {
            if (response && response.result && response.result.data) {
                $scope.prevNote = response.result.data.note;
                $scope.userNotes = response.result.data.note;
                $scope.writeNote = true;
            } else {
                $scope.writeNote = true;
            }
            _.delay(function () {
                $scope.$apply();
            });
        });
    };

    //To close notes
    $scope.closeNote = function () {
        $scope.writeNote = false;
        if ($scope.userNotes && $scope.prevNote !== $scope.userNotes) {
            var data = {
                noteObj: note,
                userId: userId,
                noteVal: $scope.userNotes,
                toArchive: $scope.toArchive
            };
            authService.callAPI(TPWIZARDCONSTANT.API_ADD_NOTES, "POST", data, function (response) {
                if (response.result.data) {
                    toastr.success("Notes added successfully");
                }
            });
        }
    };
    /*
     * To set complete status for Resources
     * 
     * @planId : Teaching plan id
     *
     * @return : null
     */

    $scope.setCompleteStatus = function () {
        var planId = $state.params.planId;
        var resId = $scope.currentResource._id;
        authService.callAPI(TPWIZARDCONSTANT.API_COMPLETE_RESOURCE + planId + '/' + resId, "GET", {}, function (response) {
            if (response) {
                console.log(response);
                $scope.isShowComplete = false;
                $scope.isCompleted = true;
                toastr.success("Updated complete status");
                $scope.$apply();
            } else {
                toastr.error("Network Error, please try later.");
            }
        });
        $scope.isShowComplete = false;
        $scope.isCompleted = true;
    };
}];

exports.default = WizardController;

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _subjectProperty = __webpack_require__(367);

var _subjectProperty2 = _interopRequireDefault(_subjectProperty);

var _studentSubjectSelection = __webpack_require__(891);

var _studentSubjectSelection2 = _interopRequireDefault(_studentSubjectSelection);

var _template_edit = __webpack_require__(892);

var _template_edit2 = _interopRequireDefault(_template_edit);

var _showpdf = __webpack_require__(893);

var _showpdf2 = _interopRequireDefault(_showpdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ManagelistController =
// @ngInject
["$scope", "$rootScope", "$state", "$mdDialog", "localStorageService", "authService", "CONSTANTS", "$sce", function ManagelistController($scope, $rootScope, $state, $mdDialog, localStorageService, authService, CONSTANTS, $sce) {
    'ngInject';
    // $reactive(this).attach($scope);

    _classCallCheck(this, ManagelistController);

    var self = this;
    $scope.loading = true;
    $scope.stateId = 'manageReportCards';
    $scope.filterObj = {};
    $scope.filterObj['school_id'] = localStorageService.get('school_id');
    $scope.pdfData = false;
    $rootScope.Title = "Report Card Formats";
    $scope.schoolSelected = undefined;
    $scope.dataArry = {};
    $scope.schoolAdmin = undefined;
    $scope.FILE_UPLOAD_URL = CONSTANTS.FILE_UPLOAD_URL;
    var subsReport = undefined;
    $scope.isLoading = false;
    self.archived_templates = null;
    self.selected_tab = 0;
    var _AVAILABLE = "available";
    var _ARCHIVES = 'archives';
    var _SELECTALL_TXT = "Select All";
    var _UNSELECTALL_TXT = "Unselect All";
    $scope.selectedIndex = _AVAILABLE;
    $scope.rc_selection = {
        all_selected: false,
        txt: _SELECTALL_TXT,
        selected_any: false
    };
    $scope.pdfClicked = false;
    $scope.url = null;
    $scope.showPrev = function (format) {
        var isFomArchive = false;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'format', 'parentScope', 'authService', 'localStorageService', 'isFomArchive', '$sce', showPdfDialog],
            locals: {
                "format": format,
                "parentScope": $scope,
                authService: authService,
                localStorageService: localStorageService,
                isFomArchive: isFomArchive,
                '$sce': $sce
            },
            template: _showpdf2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true
        });
        // $scope.pdfClicked = !$scope.pdfClicked
        // $scope.url = $sce.trustAsResourceUrl('https://oxf4000.educore.guru/uploads/report-formats/type-1-annual.pdf')
    };
    $scope.closepdf = function () {
        $scope.pdfClicked = false;
        $scope.url = null;
    };

    $scope.selectAllRcs = function (rc_selection, isFromArchives) {
        var all_selected = rc_selection.all_selected;
        if (rc_selection.all_selected) {
            rc_selection.txt = _UNSELECTALL_TXT;
        } else {
            rc_selection.txt = _SELECTALL_TXT;
        }
        var formats = self.availableFormats;
        if (isFromArchives) {
            formats = self.archived_templates;
        }
        for (var index = 0; index < formats.length; index++) {
            var element = formats[index];
            element.to_archive = all_selected;
        }
        showHideRcSelection(isFromArchives);
    };
    function showHideRcSelection() {
        var isFromArchives = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var rc_selection = $scope.rc_selection;
        var formats = self.availableFormats;
        if (isFromArchives) {
            formats = self.archived_templates;
        }
        var selected_any = 0;
        for (var index = 0; index < formats.length; index++) {
            var element = formats[index];
            if (element.to_archive) {
                selected_any++;
                break;
            }
        }
        rc_selection.selected_any = selected_any ? true : false;
    }
    $scope.selectOneRcToArchive = function (format) {
        var isFromArchives = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (format.to_archive) {
            $scope.rc_selection.selected_any = true;
        }
        showHideRcSelection(isFromArchives);
    };
    $scope.toggleExpansion = function (accordianData, data, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !data.expanded;
        });
    };
    var cb = function cb(_format, index) {
        console.log(_format);
        self.availableFormats[index] = _format;
    };
    self.OneRcController = function (format, index) {
        var data = {};
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'data', 'format', 'parentScope', 'authService', 'localStorageService', 'cb', 'index', OneRcController],
            locals: {
                "data": data,
                format: format,
                "parentScope": $scope,
                authService: authService,
                localStorageService: localStorageService,
                cb: cb,
                index: index
            },
            template: _template_edit2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true
        });
    };
    function _breakReference(data) {
        var keys = Object.keys(data);
        var obj = {};
        for (var k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[keys[k]];
        }
        return obj;
    }
    function iterateArray() {
        var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        for (var index = 0; index < array.length; index++) {
            var element = array[index];
            element.path = $scope.FILE_UPLOAD_URL + element.path;
            var assigned_academics = element.assigned_academics;
            var total_classes = 0;
            if (assigned_academics) {
                for (var a = 0; a < assigned_academics.length; a++) {
                    var acd = assigned_academics[a];
                    if (acd && acd.classes && acd.classes.length) {
                        total_classes = total_classes + acd.classes.length;
                    }
                }
            }
            element['total_classes'] = total_classes;
        }
    }
    function callBack(data, isFomArchive) {
        if (data) {
            if (data.templates) {
                self.availableFormats = data.templates;
                iterateArray(self.availableFormats);
            }
            if (data.archived_templates) {
                self.archived_templates = data.archived_templates;
            }
        }
        self.selected_tab = isFomArchive ? 0 : 1;
        $scope.$apply();
    }
    $scope.callBack = function (data, isFomArchive) {
        self.availableFormats = [];
        self.archived_templates = [];
        callBack(data, isFomArchive);
    };
    $scope.confirmToArchive = function () {
        var isFomArchive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var data = [];
        if (isFomArchive) {
            data = _.filter(self.archived_templates, function (one) {
                return one.to_archive == true;
            });
        } else {
            data = _.filter(self.availableFormats, function (one) {
                return one.to_archive == true;
            });
        }

        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'data', 'parentScope', 'authService', 'localStorageService', 'isFomArchive', ToArchiveCtrl],
            locals: {
                "data": data,
                "parentScope": $scope,
                authService: authService,
                localStorageService: localStorageService,
                isFomArchive: isFomArchive
            },
            template: _studentSubjectSelection2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true
        });
    };
    $scope.onTabSelected = function (data) {};
    $scope.reset = function () {
        var isArchivedTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        $scope.rc_selection = {
            all_selected: false,
            txt: _SELECTALL_TXT,
            selected_any: false
        };
        if (isArchivedTab) {
            _.each(self.archived_templates, function (one) {
                one.to_archive = false;
            });
        } else {
            _.each(self.availableFormats, function (one) {
                one.to_archive = false;
            });
        }
    };
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Report Card Formats";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        loadFirst();
        pushLog();
    };
    this.$onDestroy = function () {
        if (subsReport) subsReport.stop();

        self.sessionArray = undefined;
        self.curriculumArray = undefined;
        self.classArray = undefined;
        self.templated_based_academic = undefined;
        self.availableFormats = undefined;
        self.assigned_templates = undefined;
    };

    function loadFirst() {
        $scope.isLoading = true;
        $scope.filterObj.academic_year = localStorageService.get('academic_year');
        authService.callAPI("/v0/reportcards/manager/init", "POST", { args: $scope.filterObj }, function (response) {
            var result = response.result.data.details.response;
            console.log(result);
            if (result) {
                self.availableFormats = result.templates;
                self.archived_templates = result.archived_templates;
                iterateArray(self.availableFormats);
                self.sessionArray = result.session;
                self.assigned_templates = result.assigned_templates ? result.assigned_templates : [];
                self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : [];
                for (var i = 0; i < self.templated_based_academic.length; i++) {
                    var classes = _.pluck(self.templated_based_academic[i].academics, "classes");
                    classes = _.flatten(classes);

                    if (!classes.length) {
                        self.templated_based_academic.splice(i, 1);
                    } else {}
                }
                if (result.schoolDoc) {
                    $scope.school_name = result.schoolDoc.school_name;
                    $scope.schoolSelected = result.schoolDoc;
                }
                if (result.schoolAdmin) {
                    $scope.schoolAdmin = result.schoolAdmin;
                }
                $scope.formats_pending = result.formats_pending ? result.formats_pending : [];
            }
            _.defer(function () {
                $scope.isLoading = false;
                $scope.$apply();
            });;
        });
    }

    function removeTemplateWithNoClasses(templated_based_academic) {
        _.each(templated_based_academic, function (oneTemplate, key) {});
        for (var i = 0; i < templated_based_academic.length; i++) {
            var classes = _.pluck(templated_based_academic[i].academics, "classes");
            classes = _.flatten(classes);

            if (!classes.length) {
                templated_based_academic.splice(i, 1);
            } else {}
        }
    }

    function clearFilter() {
        $scope.filterObj['session'] = undefined;
        $scope.filterObj['curriculum'] = undefined;
        $scope.filterObj['xclass'] = undefined;
        $scope.filterObj['templates'] = undefined;
    }

    $scope.searchValuesBasedOnFilter = function (ev) {
        if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
            toastr.error('Please Select the Session');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
            toastr.error('Please Select the Curriculum');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
            toastr.error('Please Select the Class');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['templates'] === undefined || this.filterObj['templates'].length <= 0) {
            toastr.error('No report cards selected');
            return false;
        }
        this.filterObj['school_id'] = localStorageService.get('school_id');
        var showValidation = validate(this.filterObj);
        if (showValidation) {
            showAssingWarning(this.filterObj, ev);
        } else {
            assignTemplate(this.filterObj);
        }
        // 
    };
    function showAssingWarning(filterObj, ev) {
        var confirm = $mdDialog.confirm().title('Information').textContent('Some of the selected class(s) have been already assigned, but this will not cause any issues').ariaLabel('Lucky day').targetEvent(ev).ok('Proceed').cancel('Cancel');
        $mdDialog.show(confirm).then(function () {
            assignTemplate(filterObj);
        }, function () {});;
    }
    function validate(filterObj) {
        console.log(filterObj);
        var templates = filterObj['templates'];
        var avails = self.availableFormats;
        var session_id = filterObj.session;
        var curr_id = filterObj.curriculum;
        var xclass = filterObj.xclass;
        var show_val = false;
        try {
            var _loop = function _loop(t) {
                var element = templates[t];
                var rcs_selected = _.find(avails, function (one) {
                    return one._id == element;
                });
                if (rcs_selected) {
                    var combExs = _.find(rcs_selected.assigned_academics, function (one) {
                        return one.session_id == session_id && one.curriculum_id == curr_id;
                    });
                    if (combExs && combExs.classes && combExs.classes.length) {
                        var _loop2 = function _loop2(c) {
                            var selectedOneClass = xclass[c];
                            var classExs = _.find(combExs.classes, function (cls) {
                                return cls._id == selectedOneClass;
                            });
                            if (classExs) {
                                show_val = true;
                                return 'break';
                            }
                        };

                        for (var c = 0; c < xclass.length; c++) {
                            var _ret2 = _loop2(c);

                            if (_ret2 === 'break') break;
                        }
                    }
                }
            };

            for (var t = 0; t < templates.length; t++) {
                _loop(t);
            }
        } catch (e) {
            console.log(e);
            show_val = false;
        }
        console.log(show_val);
        return show_val;
    }
    function findAcadamicDetails(id) {
        var settings = Settings.findOne({
            type: "class",
            "list._id": id
        });
        if (settings) {
            var findClassObj = _.find(settings.list, function (list) {
                return list._id == id;
            });
            if (findClassObj) {
                return findClassObj.name;
            }
        }
    }

    function uploadToPmsFileServerAndSend(objdata, callBackData) {
        this.serverUrl = PMS_FILESERVER_URL + "/server-uploads";
        this.userPath = "pdfrequest/";
        // console.log($scope.dataArry.attachedFile)
        // return false


        uploadService.uploadToPMS($scope.dataArry.attachedFile, this.serverUrl, this.userPath, function (result) {
            if (result.url) {
                console.log('pms');
                console.log(result.url);
                var _objdata = {
                    "school_admin_id": Meteor.userId(),
                    "school_admin_email": $scope.schoolAdmin.username,
                    "school_id": $scope.schoolSelected._id,
                    "school_name": $scope.schoolSelected.school_name,
                    "details": $scope.dataArry.description,
                    "file_url": result.url
                };
                $scope.dataArry = undefined;
                Meteor.call('saveReportCardRequestToPMS', _objdata, callBackData, function (err, res) {
                    if (err) {
                        toastr.error('Error on sending report card request');
                        return false;
                    } else {
                        toastr.success('Report card request send successfully to the customer PMS');
                        $scope.formats_pending = res.formats_pending ? res.formats_pending : [];
                    }
                    $scope.dataArry = undefined;
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        });
    }
    $scope.sendRequest = function () {
        if ($scope.dataArry === undefined || $scope.dataArry.description === undefined || $scope.dataArry.description === '') {
            $scope.errors_description = "Description is required !";
            return false;
        } else {
            $scope.errors_description = undefined;
            $scope.dataArry.date_added = new Date();
            // $scope.dataArry.school_id = $scope.schoolId;
            //$scope.dataArry.users = self.selectedDetails;
            $scope.dataArry.send_by = Meteor.userId(); //logined user
            //$scope.dataArry.send_to = roleType; // lower roles id
            // console.log($scope.dataArry.attachedFile)
            if ($scope.dataArry.attachedFile) {
                this.serverUrl = FILE_UPLOAD_URL + "/server-uploads";
                this.userPath = "pdfrequest/";
                uploadService.uploadCheckService($scope.dataArry.attachedFile, this.serverUrl, this.userPath, function (result) {
                    if (result.url) {
                        console.log(result.url);
                        var objdata = {
                            "school_admin_id": Meteor.userId(),
                            "school_admin_email": $scope.schoolAdmin.username,
                            "school_id": $scope.schoolSelected._id,
                            "school_name": $scope.schoolSelected.name,
                            "details": $scope.dataArry.description,
                            "file_url": result.url
                        };
                        uploadToPmsFileServerAndSend(objdata, result);
                    }
                });
            } else {}
        }
    };

    function showValidationBforeAssign(filterObj, templated_based_academic) {
        if (filterObj.templates && filterObj.templates.length) {
            var rcFormats = ReportTemplatePreview.find({
                _id: {
                    $in: filterObj.templates
                }
            }).fetch();
            var templateSelectedArray = [];
            _.each(filterObj.templates, function (rcFormat) {
                var obj = {
                    format_id: rcFormat
                };
                var findFormat = _.find(rcFormats, function (eachDoc) {
                    return eachDoc._id == rcFormat;
                });
                if (findFormat) {
                    obj['report_console_id'] = findFormat.report_console_id;
                    obj['format_name'] = findFormat.name;
                }
                templateSelectedArray.push(obj);
            });
            var validationArray = [];
            _.each(templateSelectedArray, function (oneSelected) {
                var obj = {};
                obj['format_name'] = oneSelected.format_name;

                obj['classes_exists'] = [];
                var findAssigned = _.find(templated_based_academic, function (one) {

                    return one.report_console_id == oneSelected.report_console_id;
                });
                if (findAssigned) {
                    var findFiltered = _.find(findAssigned.academics, function (academic) {
                        return academic.session_id == filterObj.session && academic.curriculum_id == filterObj.curriculum;
                    });
                    obj['session'] = findFiltered.session;
                    obj['curriculum'] = findFiltered.curriculum;
                    if (findFiltered) {
                        if (filterObj.xclass) {
                            _.each(filterObj.xclass, function (oneSeltdClass) {
                                var classIds = _.pluck(findFiltered.classes, "_id");
                                if (classIds.indexOf(oneSeltdClass) !== -1) {
                                    var value = findAcadamicDetails(oneSeltdClass);
                                    if (!value) {
                                        value = oneSeltdClass;
                                    }
                                    obj['classes_exists'].push(value);
                                }
                            });
                        }
                    }
                }
            });
        }
    }

    function assignTemplate(filterObj) {
        $scope.isLoading = true;
        // showValidationBforeAssign(filterObj, self.templated_based_academic)
        // return false
        authService.callAPI("/v0/reportcards/manager/assign", "POST", { args: {
                clientData: filterObj
            } }, function (response) {
            var result = response.result.data.details.response;
            if (result) {
                self.assigned_templates = [];
                self.assigned_templates = result.assigned_templates ? result.assigned_templates : [];
                self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : [];
                self.availableFormats = result.templates ? result.templates : [];
                iterateArray(self.availableFormats);
            }
            $scope.isLoading = false;
            clearFilter();
            toastr.success('Assigned the template');
            _.defer(function () {
                $scope.$apply();
                self.selected_tab = 0;
            });
        });
    }

    $scope.deleteClassFromTheTemplate = function (template, academic, class_id) {
        var params = {
            clientDataObj: {
                report_console_id: template.report_console_id,
                academics: {
                    session_id: academic.session_id,
                    curriculum_id: academic.curriculum_id,
                    school_id: $scope.filterObj['school_id'],
                    class_id: class_id,
                    report_console_id: template.report_console_id
                }
            }
        };
        $scope.loading = true;
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog.confirm().title('Would you like to delete permanently?').textContent('Deleting will make data loss.Please make sure that reportcard is not generated using this template for this class').ariaLabel('Lucky day').ok('Delete').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            authService.callAPI("/v0/reportcards/manager/deleteclass", "POST", { args: params }, function (response) {
                var result = response.result.data.details.response;
                if (result) {

                    self.templated_based_academic = [];
                    self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : [];
                    // removeTemplateWithNoClasses(self.templated_based_academic)
                    for (var i = 0; i < self.templated_based_academic.length; i++) {
                        var classes = _.pluck(self.templated_based_academic[i].academics, "classes");
                        classes = _.flatten(classes);

                        if (!classes.length) {
                            self.templated_based_academic.splice(i, 1);
                        } else {}
                    }
                }
                $scope.loading = false;
                toastr.success('Deleted');

                _.defer(function () {
                    $scope.$apply();
                });
            });
            // Meteor.call('deleteClassFromTemplate', params, function(error, result) {
            //     if (result) {

            //         self.templated_based_academic = []
            //         self.templated_based_academic = result.templated_based_academic ? result.templated_based_academic : []
            //             // removeTemplateWithNoClasses(self.templated_based_academic)
            //         for (let i = 0; i < self.templated_based_academic.length; i++) {
            //             let classes = _.pluck(self.templated_based_academic[i].academics, "classes")
            //             classes = _.flatten(classes)

            //             if (!classes.length) {
            //                 self.templated_based_academic.splice(i, 1)
            //             } else {}
            //         }
            //     }
            //     $scope.loading = false
            //     toastr.success('Deleted')

            //     _.defer(function() {
            //         $scope.$apply();
            //     });
            // })

        }, function (f, r) {
            $scope.loading = false;
        });
        clearFilter();
    };
    $scope.setSessionFilters = function (filterObj) {
        if (!$scope.filterObj) {
            $scope.filterObj = {};
        }
        if ($scope.filterObj.curriculum) {
            delete $scope.filterObj.curriculum;
        }
        if ($scope.filterObj.templates) {
            delete $scope.filterObj.templates;
        }
        if ($scope.filterObj.xclass) {
            delete $scope.filterObj.xclass;
        }
        // $scope.filterObj['school_id'] = Session.get('school_id')
        $scope.loading = true;
        authService.callAPI("/v0/reportcards/manager/selectacademic", "POST", { args: {
                filter: $scope.filterObj
            } }, function (response) {
            var result = response.result.data.details.response;
            if (result) {
                self.curriculumArray = [];
                self.curriculumArray = result.curriculum ? result.curriculum : [];
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    self.getClass = function (filterObj) {
        $scope.loading = true;
        $scope.filterObj['curriculum'] = filterObj;
        authService.callAPI("/v0/reportcards/manager/selectacademic", "POST", { args: {
                filter: $scope.filterObj
            } }, function (response) {
            var result = response.result.data.details.response;
            if (result) {
                self.classArray = result.class;
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        // Meteor.call('makeFilteredSeletction', $scope.filterObj, function(error, result) {
        //     if (result) {
        //         self.classArray = result.class
        //     }
        //     $scope.loading = false
        //     _.defer(function() {
        //         $scope.$apply();
        //     });
        // })
    };
    // self.deleteAssigned = (data, obj) => {
    //     $scope.loading = true

    //     // Appending dialog to document.body to cover sidenav in docs app
    //     var confirm = $mdDialog.confirm()
    //         .title('Would you like to delete permanently?')
    //         .textContent('Deleting will make data loss.Please make sure that reportcard is not generated using this template')
    //         .ariaLabel('Lucky day')
    //         .ok('Delete')
    //         .cancel('Dont delete');

    //     $mdDialog.show(confirm).then(function() {
    //         Meteor.call('deleteSelectedAcademic', data, obj, function(error, result) {
    //             if (result) {
    //                 self.assigned_templates = []
    //                 self.assigned_templates = result.assigned_templates ? result.assigned_templates : []
    //             }
    //             $scope.loading = false
    //             toastr.success('Deleted permanently')
    //             _.defer(function() {
    //                 $scope.$apply();
    //             });
    //         })


    //     }, function(f, r) {
    //         $scope.loading = false
    //     });

    // }
    $scope.showPdf = function (dataId, flag, format) {
        if (dataId) {
            // Meteor.call('getUploadedTEmplateById', dataId, flag, function(err, res) {
            //     if (res) {
            //         $scope.pdfData = true
            //         if (!flag) {
            //             res.path = FILE_UPLOAD_URL + res.path
            //         } else {
            //             res.path = FILE_UPLOAD_URL + res.file_url
            //         }

            //         res.path = $sce.trustAsResourceUrl(res.path)
            //         $scope.item = res
            //         _.defer(function() {
            //             $scope.$apply();
            //         });
            //     }
            // })
        }
    };
    $scope.backToHtml = function () {
        $scope.pdfData = false;
    };
    $scope.setProperty = function (data) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'data', 'parentScope', 'sessionArray', 'school_id', 'authService', propertyController],
            locals: {
                "data": data,
                "parentScope": $scope,
                sessionArray: self.sessionArray,
                school_id: localStorageService.get('school_id'),
                authService: authService
            },
            template: _subjectProperty2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: true
        });
    };
    function pushLog() {
        var userIds = localStorageService.get('user_id');
        var schoolIds = localStorageService.get('school_id');
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userIds + "/" + schoolIds + "/AssignReportFormat_View", "GET", {}, function (response) {
            // console.log(response)
        });
    }
}];
ManagelistController.$inject = ["$scope", "$rootScope", "$state", "$mdDialog", "localStorageService", "authService", "CONSTANTS", "$sce"];

var propertyController = function propertyController($scope, $mdDialog, data, parentScope, sessionArray, school_id, authService) {
    _classCallCheck(this, propertyController);

    var activeAcd = localStorage.getItem('academic_year');
    $scope.propertObj = {};
    $scope.array = [{ name: 1 }, { name: 1 }, { name: 1 }];
    $scope.propertObj['school_id'] = school_id;
    $scope.propertObj['activeAcd'] = activeAcd;
    $scope.sessionArray = _.uniq(data.academics, false, function (one) {
        return one.session_id;
    });
    var curriculumToRemove = _.flatten(_.pluck(data.academics, 'curriculum_id'));
    $scope.getCurriculum = function (id) {
        /*get curriculum*/
        $scope.propertObj['class_id'] = undefined;
        $scope.propertObj['batches'] = undefined;
        $scope.propertObj['curriculum_id'] = undefined;
        $scope.curriculumArray = [];
        $scope.classArray = [];
        $scope.batchesArray = [];
        $scope.propertObj['session_id'] = id;
        authService.callAPI("/v0/reportcards/manager/propertycurriculum", "POST", { args: {
                propertObj: $scope.propertObj
            } }, function (response) {
            var result = response.result.data.details.response;
            $scope.curriculumArray = result;
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClassRc = function (id) {
        /*get curriculum*/
        $scope.propertObj['class_id'] = undefined;
        $scope.propertObj['curriculum_id'] = id;
        $scope.classArray = [];
        $scope.batchesArray = [];
        authService.callAPI("/v0/reportcards/manager/propertyclass", "POST", { args: {
                propertObj: $scope.propertObj
            } }, function (response) {
            var result = response.result.data.details.response;
            $scope.classArray = result;
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getBatchesRc = function (id) {
        /*get curriculum*/
        $scope.propertObj['class_id'] = id;
        $scope.batchesArray = [];
        authService.callAPI("/v0/reportcards/manager/propertybatch", "POST", { args: {
                propertObj: $scope.propertObj
            } }, function (response) {
            var result = response.result.data.details.response;
            $scope.batchesArray = result;
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    function fetchSubjects(propertObj) {
        $scope.loading = true;
        authService.callAPI("/v0/reportcards/manager/propertysubject", "POST", { args: {
                propertObj: $scope.propertObj
            } }, function (response) {

            var result = response.result.data.details.response;
            console.log(result);
            $scope.subjectArray = result.subjectList;
            $scope.subectArray = result.allSubjects;
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    }
    function validate(propertObj) {
        if (!propertObj.session_id) {
            toastr.error("Please select session!");
            return false;
        }
        if (!propertObj.curriculum_id) {
            toastr.error("Please select curriculum!");
            return false;
        }
        if (!propertObj.class_id) {
            toastr.error("Please select class!");
            return false;
        }
        if (!propertObj.batches) {
            toastr.error("Please select any batch!");
            return false;
        }
        fetchSubjects(propertObj);
    }
    $scope.searchSubjects = function () {
        validate($scope.propertObj);
    };
    function validateProperty(list) {
        var totalerror = 0;
        _.each(list, function (oneObj) {
            oneObj.errors = {};
            oneObj.use_in_report = true;
            if (oneObj.is_linked) {
                if (!oneObj.linked_primary_subject) {
                    oneObj.errors['linked_primary_subject'] = "Please select Primary subject";
                    totalerror++;
                }
            }
        });
        if (!totalerror) {
            sendToServer(list);
        }
    }
    function sendToServer(list) {
        list, school_id;
        authService.callAPI("/v0/reportcards/manager/propertysave", "POST", { args: {
                list: list,
                school_id: school_id
            } }, function (response) {
            var result = response.result.data.details.response;
            if (result) {
                toastr.success("saved properties to the subjects");
            }
            $mdDialog.hide();
        });
    }
    $scope.saveSbjectProperty = function () {
        validateProperty($scope.subjectArray);
    };
    $scope.cancel = function () {
        $mdDialog.hide();
    };
    $scope.eventOfIslinked = function (subject, index) {
        var subjectPrimaryId = subject.linked_primary_subject;
        if (subject.is_linked) {
            _.each($scope.subectArray, function (eachColumn) {
                if (eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id) {
                    if (subjectPrimaryId == eachColumn._id) {
                        eachColumn.disableThis = true;
                    } else {
                        eachColumn.disableThis = false;
                    }
                }
            });
        } else {
            if (subjectPrimaryId) {
                _.each($scope.subectArray, function (eachColumn) {
                    if (eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id) {
                        if (subjectPrimaryId == eachColumn._id) {
                            eachColumn.disableThis = false;
                        }
                    }
                });
            }
        }
    };
    $scope.disableThisSubjectsPrimary = function (subject) {
        var subjectPrimaryId = subject.linked_primary_subject;
        _.each($scope.subectArray, function (eachColumn) {
            if (eachColumn.session_id == subject.session_id && eachColumn.curriculum_id == subject.curriculum_id && eachColumn.class_id == subject.class_id && eachColumn.batch_id == subject.batch_id) {
                if (subjectPrimaryId == eachColumn._id) {

                    if (subject.is_linked) {
                        eachColumn.disableThis = true;
                        eachColumn.is_linked = undefined;
                        eachColumn.linked_primary_subject = undefined;
                    } else {
                        eachColumn.disableThis = false;
                    }
                } else {
                    eachColumn.disableThis = false;
                }
            } else {
                // eachColumn.disableThis = false
            }
        });
        // _.each(self.addedSubjects, function(eachColumn){
        //     if(eachColumn._id == subjectId){
        //         eachColumn.disableThis = true
        //         eachColumn.is_linked = undefined
        //         eachColumn.linked_primary_subject = undefined
        //     }else{
        //         eachColumn.disableThis = false
        //     }
        // })
    };
};

exports.default = ManagelistController;

var ToArchiveCtrl = function ToArchiveCtrl($scope, $mdDialog, data, parentScope, authService, localStorageService, isFomArchive) {
    _classCallCheck(this, ToArchiveCtrl);

    $scope.data = [];
    $scope.parentScope = null;
    var school_id = localStorageService.get('school_id');
    var _warning = "Warning : Selected report(s) will not be available to generate reports";
    var _heading = "Are you sure to archive?";
    var _btnTxt = "Move to Archive";
    if (isFomArchive) {
        _warning = "";
        _heading = "Are you sure to restore?";
        _btnTxt = "Restore";
    }
    $scope.headers = {
        _heading: _heading,
        _warning: _warning,
        _btnTxt: _btnTxt,
        _disableBtn: false
    };
    this.$onInit = function () {
        $scope.data = data;
        $scope.parentScope = parentScope;
    };
    $scope.items = data;

    $scope.cancel = function () {
        $mdDialog.hide();
    };
    $scope.confirm = function () {
        $scope.headers._disableBtn = true;
        callArchivingApi();
    };
    function callArchivingApi() {
        var req = {
            user_id: localStorageService.get('user_id'),
            academic_year: localStorageService.get('academic_year'),
            items: data,
            school_id: school_id,
            restore: isFomArchive ? true : false
        };
        parentScope.isLoading = true;
        $scope.cancel();
        var successTxt = isFomArchive ? "Restored selected report(s)" : "Archived the selected report(s)";
        authService.callAPI("/v0/reportcards/manager/archive/console", "POST", req, function (response) {
            parentScope.isLoading = false;
            $scope.headers._disableBtn = false;
            var result = response.result.data.details.response;
            if (result) {
                toastr.success(successTxt);
                parentScope.callBack(result, isFomArchive);
            } else {
                toastr.success("Something went wrong");
            }

            // _.defer(function() {
            //     $scope.$apply();
            // });
        });
    }
};

var OneRcController = function OneRcController($scope, $mdDialog, data, format, parentScope, authService, localStorageService, cb, index) {
    _classCallCheck(this, OneRcController);

    var school_id = localStorageService.get('school_id');
    $scope.format = null;
    var actual_format = null;
    $scope.real_format = null;
    var _SELECTALL_TXT = "Select All";
    var _UNSELECTALL_TXT = "Unselect All";
    $scope.isLoading = false;
    $scope.updatorData = {
        update: false
    };
    $scope.class_removal = {
        confirm: false
    };
    $scope.display_name_length = 20;
    $scope.name_length = 40;
    function _breakReference(data) {
        var keys = Object.keys(data);
        var obj = {};
        for (var k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[keys[k]];
        }
        return obj;
    }
    $scope.saveMetadata = function () {
        $scope.updatorData.update = true;
    };
    $scope.cancelUpdate = function () {
        $scope.updatorData.update = false;
    };
    function validateCode(string) {
        var TCode = string;
        for (var i = 0; i < TCode.length; i++) {
            var char1 = TCode.charAt(i);
            var cc = char1.charCodeAt(0);
            if (cc > 47 && cc < 58 || cc > 64 && cc < 91 || cc > 96 && cc < 123) {} else {
                return false;
            }
        }
        return true;
    }
    $scope.doUpdate = function () {

        var _format = $scope.format;
        _format.error = {};
        var err = 0;
        if (_format) {
            if (!_format.name) {
                _format.error['name'] = {};
                _format.error['name']['msg'] = "Name is required";
                err++;
            }
            if (_format.name) {
                var trimmed = _format.name.trim();
                var len = trimmed.length;
                if (len > $scope.name_length) {
                    _format.error['name'] = {};
                    _format.error['name']['msg'] = "Report name should not exceed " + $scope.name_length;
                    err++;
                }
            }
            if (_format.display_name) {
                var _trimmed = _format.display_name.trim();
                var _len = _trimmed.length;
                if (_len > $scope.display_name_length) {
                    _format.error['display_name'] = {};
                    _format.error['display_name']['msg'] = "Display name should not exceed " + $scope.display_name_length;
                    err++;
                }
            }
        }
        if (err) {
            return false;
        }
        $scope.isLoading = true;
        var req = {
            user_id: localStorageService.get('user_id'),
            academic_year: localStorageService.get('academic_year'),
            _id: _format.report_console_id,
            school_id: school_id,
            format: _format
        };
        authService.callAPI("/v0/reportcards/manager/update/metadata", "POST", req, function (response) {

            $scope.isLoading = false;
            $scope.cancelUpdate();
            var result = response.result.data.details.response;
            if (result) {
                toastr.success("Updated successfully");
            } else {
                toastr.success("Something went wrong");
            }
            cb(format, index);
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    this.$onInit = function () {
        $scope.real_format = format;
        var actual_format = format;
        format = _breakReference(format);
        format.can_delete_classes = false;
        if (format.assigned_academics && format.assigned_academics.length) {
            var assigned_academics = format.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var acd = assigned_academics[e];
                // let xclasses = []
                // if(acd && acd.classes && acd.classes.length){
                //     _.each(acd.classes, function(one){
                //         one.to_remove = false
                //         xclasses.push(_breakReference(one))
                //     })
                // }
                // acd.classes = xclasses
                // console.log(acd)
                assigned_academics[e] = acd;
            }
        }
        $scope.format = format;
    };
    function doBack() {
        var format = $scope.format;
        if (format && format.assigned_academics && format.assigned_academics.length) {
            var assigned_academics = format.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var acd = assigned_academics[e];
                // let xclasses = []
                if (acd && acd.classes && acd.classes.length) {
                    _.each(acd.classes, function (one) {
                        one.to_remove = false;
                    });
                }
                // acd.classes = xclasses
                // console.log(acd)
                assigned_academics[e] = acd;
            }
        }
        $scope.format = null;
        $scope.real_format = null;
    }
    this.$onDestroy = function () {
        // doBack()
    };
    $scope.cancel = function () {
        doBack();
        $mdDialog.hide();
    };
    $scope.confirm = function () {};
    $scope.selectAllClassesPerReport = function (format, event) {
        var class_selection = format.class_selection;
        if (class_selection) {
            format.class_selection_txt = _UNSELECTALL_TXT;
        } else {
            format.class_selection_txt = _SELECTALL_TXT;
            $scope.class_removal.confirm = false;
        }
        if (format.assigned_academics && format.assigned_academics.length) {
            var assigned_academics = format.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var _element = assigned_academics[e];
                if (_element.classes && _element.classes.length) {
                    var classes = _element.classes;
                    for (var c = 0; c < classes.length; c++) {
                        classes[c].to_remove = class_selection;
                    }
                }
            }
        }
        showHideClassRemoveBtn(format);
    };
    $scope.oneClassSelection = function (format, selectedclass) {
        var to_remove = selectedclass.to_remove;
        if (!to_remove) {
            format.class_selection_txt = _SELECTALL_TXT;
            format.class_selection = false;
        }
        showHideClassRemoveBtn(format);
    };
    function showHideClassRemoveBtn(format) {
        format.can_delete_classes = false;
        if (format.assigned_academics && format.assigned_academics.length) {
            var assigned_academics = format.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var _element2 = assigned_academics[e];
                if (_element2.classes && _element2.classes.length) {
                    var classes = _element2.classes;
                    for (var c = 0; c < classes.length; c++) {
                        if (classes[c].to_remove) {
                            format.can_delete_classes = true;
                            $scope.class_removal.confirm = false;
                            break;
                        }
                    }
                }
            }
        }
    }
    $scope.cancelClassRemovaval = function (format) {
        $scope.class_removal.confirm = false;
        showHideClassRemoveBtn(format);
    };
    $scope.deleteClassFromTheTemplate = function (template, academic, class_id) {
        if (academic.classes) {
            for (var _index = 0; _index < academic.classes.length; _index++) {
                var _element3 = academic.classes[_index];
                if (_element3 && _element3._id == class_id) {
                    academic.classes.splice(_index, 1);
                    break;
                }
            }
        }
        parentScope.deleteClassFromTheTemplate(template, academic, class_id);
    };
    $scope.removeClasses = function (format) {
        var remove_params = [];
        if (format.assigned_academics && format.assigned_academics.length) {
            var assigned_academics = format.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var _element4 = assigned_academics[e];
                var obj = {
                    session_id: _element4.session_id,
                    curriculum_id: _element4.curriculum_id,
                    classes: []
                };
                if (_element4.classes && _element4.classes.length) {
                    var classes = _element4.classes;
                    for (var c = 0; c < classes.length; c++) {
                        if (classes[c].to_remove) {
                            obj.classes.push(classes[c]._id);
                        }
                    }
                }
                if (obj.classes.length) {
                    remove_params.push(obj);
                }
            }
        }
        if (remove_params.length) {
            removeClassCallApi(remove_params, format);
        }
    };
    function removeClassessFromClient(formatP) {
        var total_classes = 0;
        if (formatP.assigned_academics && formatP.assigned_academics.length) {
            var assigned_academics = formatP.assigned_academics;
            for (var e = 0; e < assigned_academics.length; e++) {
                var _element5 = assigned_academics[e];
                if (_element5.classes && _element5.classes.length) {
                    var classes = _element5.classes;
                    var con = 0;
                    var exs = _.filter(_element5.classes, function (one) {
                        return one.to_remove != true;
                    });
                    _element5.classes = exs;
                    total_classes = total_classes + exs.length;
                    // for (let c = 0; c < classes.length; c++) {
                    //     if(classes[c].to_remove){
                    //         classes.splice(c, 1)
                    //         con++
                    //     }
                    // }
                }
            }
        }
        formatP.total_classes = total_classes;
        if (total_classes) {
            formatP.isassigned = true;
        } else {
            formatP.isassigned = false;
        }
        formatP.can_delete_classes = false;
        $scope.class_removal.confirm = false;
        formatP.class_selection_txt = _SELECTALL_TXT;
        formatP.class_selection = false;
        cb(formatP, index);
    }
    function removeClassCallApi(remove_params, formatP) {
        var req = {
            user_id: localStorageService.get('user_id'),
            academic_year: localStorageService.get('academic_year'),
            _id: formatP.report_console_id,
            school_id: school_id,
            academics: remove_params
        };
        $scope.isLoading = true;
        authService.callAPI("/v0/reportcards/manager/removeclasses", "POST", req, function (response) {
            $scope.isLoading = false;
            var result = response.result.data.details.response;
            if (result) {
                console.log(formatP);
                removeClassessFromClient(formatP);
                toastr.success("Removed selected classes");
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }
};

var showPdfDialog = function showPdfDialog($scope, $mdDialog, format, parentScope, authService, localStorageService, isFomArchive, $sce) {
    _classCallCheck(this, showPdfDialog);

    $scope.format = null;
    this.$onInit = function () {
        if (format) {
            format.url = $sce.trustAsResourceUrl(format.path);
            $scope.format = format;
        }
    };
    $scope.cancel = function () {
        $mdDialog.hide();
    };
};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.endorse_edit_padding{padding-left:15px!important;padding-right:20px}.endorsePadding{padding:20px}.endorsePadding12{padding:12px}.labelColor{color:#aba2a2;padding-bottom:10px}.fixedMargin{padding-top:10px!important;padding-bottom:20px!important}.headingStyle{color:#18a8a9}.aroundMargin{margin:30px}.search-top-margin{margin-top:10px}.padding-col{padding:10px}.my-icon-button{outline:0;line-height:normal;height:40px;margin-top:10px!important;width:40px}.doctr.md-accordion1{margin:0;padding:0 0!important}.right-margin{margin-right:10px}.doctr .md-accordion1.expandCollapse{width:32px;height:32px;position:relative;font-weight:700;cursor:pointer;color:#000;display:block;margin-top:-2px;margin-left:-2px;overflow:hidden}.doctr.md-accordion1 .expandCollapse:active{border:0}.doctr.md-accordion1 .expandCollapse:after,.doctr.md-accordion1 .expandCollapse:before{width:32px;height:32px;position:absolute;top:0;left:0;line-height:36px;text-align:center;-webkit-transition:.3s all ease-out;transition:.3s all ease-out}.doctr.md-accordion1 .expandCollapse:before{opacity:1 -webkit-transform: rotate(0);transform:rotate(0);content:\"|\";margin-top:-3px}.doctr.md-accordion1 .expandCollapse:after{opacity:1;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);content:\"|\";margin-left:-3px}.doctr.md-accordion1 .active:before{opacity:1;-webkit-transform:rotate(90deg);transform:rotate(90deg);margin-left:3px;margin-top:0}.doctr.md-accordion1 .dataContent{background:#fff;height:0;overflow:hidden;-webkit-transition:.3s all ease-out;transition:.3s all ease-out}.doctr.md-accordion1 .activeContent{height:auto;padding:10px;margin:10px}.headingStyle{color:#1665c1;font-family:RobotoMedium}.padTopTen{padding-top:10px}.padBottomTen{padding-bottom:10px}.doctr.md-accordion1 div{cursor:pointer;margin:0;border-bottom:0 solid #f2f2f2}.fixedPadding{padding:20px;padding-left:30px}.noleftPadding{padding-left:0!important}.noleftMargin{margin-left:0!important}.bottomRigt{float:right}.sl-class{padding:18px!important}.button-class:{float:right!important}.inventoryctrl label{font:normal 12px courier!important}.headerFont{font-size:20px}.endorsePageCtrl .inventory-div-margin{margin:20px}.endorsePageCtrl .heading{background:#bff9ff;height:44px;margin:20px;font-size:25px;color:#464646;padding:8px;font-weight:300}.endorsePageCtrl .inventory-details{margin:20px}.endorsePageCtrl .inventory-title{background:#00ba9c;color:#fff;padding:10px;font-weight:600}.endorsePageCtrl .subject-title{color:#fff!important;padding:10px;font-weight:600}.endorsePageCtrl .btnMinus{height:35px;width:36px;background:#dd4449;margin-top:15px;margin-left:20px}.endorsePageCtrl .minusIcon{color:#fff;padding:5px}.endorsePageCtrl .btnPlus{height:35px;width:36px;background:#1e5ea8}.endorsePageCtrl .sl-no{padding:20px;font-size:15px;color:#505050}.endorsePageCtrl .odd-div{background:#fff!important}.endorsePageCtrl .even-div{background:#ececeb!important}.endorsePageCtrl .span-head{font-size:19px}.endorsePageCtrl .subject-background{background-color:#bff9ff}.endorsePageCtrl .iconcross{background-color:#e7505a;border-radius:90px;color:#fff}.endorsePageCtrl .md-whiteframe-2dp{box-shadow:0 1px 5px 0 #fff,0 2px 2px 0 rgba(0,0,0,.14),0 3px 1px -2px rgba(0,0,0,.12)!important}.endorsePageCtrl .student_name{text-transform:capitalize}.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:100%}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}</style> <md-dialog aria-label=\"Reject request\" class=\"flex-80 full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2><font color=#FFFFFF>PROPERTIES</font></h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <md-icon aria-label=\"Close dialog\">close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground> <div flex=\"\" layout=row layout-xs=column layout-sm=column flex-xs=\"\" flex-sm=\"\" layout-padding=\"\" style=background:#fff class=\"layout-padding layout-xs-column layout-sm-column layout-row flex-xs flex-sm flex\"> <md-input-container style=margin-left:10px flex=\"\" class=\"flex md-input-has-value\"> <label for=select_4 class=\"\">Session</label> <md-select ng-model=\"propertObj['session_id']\"> <md-option value={{sesName.session_id}} ng-click=\"getCurriculum(sesName.session_id);setpropertObj(sesName.session_id,'Session')\" ng-repeat=\"sesName in sessionArray  | orderBy:'session'\">{{sesName.session}}</md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_6 class=\"\">Curriculum</label> <md-select ng-model=\"propertObj['curriculum_id']\"> <md-option value={{curName._id}} ng-click=\"getClassRc(curName._id);setpropertObj(curName._id,'Curriculum')\" ng-repeat=\"curName in curriculumArray | orderBy:'name'\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_8 class=\"\">Class</label> <md-select ng-model=\"propertObj['class_id']\"> <md-checkbox ng-if=isClass ng-change=\"selectClasses('all');\" aria-label=\"Checkbox 1\" style=margin-bottom:0;margin-left:10px> All </md-checkbox> <md-option ng-click=\"getBatchesRc(clsName._id);setpropertObj(curName._id,'Curriculum')\" value={{clsName._id}} ng-repeat=\"clsName in classArray \"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=\"\" class=\"flex md-input-has-value\"> <label for=select_10 class=\"\">Select Batches</label> <md-select ng-model=\"propertObj['batches']\" multiple=multiple> <md-option value={{clsName._id}} ng-repeat=\"clsName in batchesArray\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <button class=\"md-raised md-primary md-button md-ink-ripple rep-btn\" type=button ng-click=searchSubjects()> SEARCH SUBJECTS <div class=md-ripple-container style=\"\"></div> </button> </div> <div class=endorsePageCtrl> <md-content class=\"md-whiteframe-2dp inventory-div-margin\"> <div class=\"heading md-whiteframe-2dp\">Subject List</div> <div flex layout=column class=\"md-whiteframe-2dp inventory-details\"> <div flex layout=row class=inventory-title layout-align=\"space-between end\"> <div flex>SUBJECTS</div> <div flex>CODE</div> <div flex>ORDER</div> <div flex>IS LINKED</div> <div flex>PRIMARY SUBJECT</div> </div> <div flex ng-repeat=\"subject in subjectArray\" layout=row layout-align=\"space-between stretch\" class=md-whiteframe-2dp> <div flex class=subject-background layout layout-align=\"center center\" layout=column> <span class=subject_property_name style=text-align:center>{{subject.acd}}</span> </div> <div flex layout layout-align=\"center end\"> <md-input-container class=\"md-block moPadding noMargin\" flex-gt-sm> <label>Code</label> <input ng-model=subject.code maxlength=5> <error-msg class=redAlert msg=subject.errors.code></error-msg> </md-input-container> </div> <div flex layout layout-align=\"center end\"> <md-input-container class=\"md-block moPadding noMargin\" flex-gt-sm> <label>Order</label> <input ng-model=subject.order numbers-only maxlength=3> <error-msg class=redAlert msg=subject.errors.order></error-msg> </md-input-container> </div> <div flex style=padding-left:40px layout layout-align=\"start center\"> <md-checkbox ng-change=eventOfIslinked(subject,$index) ng-disabled=subject.disableThis ng-model=subject.is_linked aria-label=\"Checkbox 1\"> </md-checkbox> <error-msg class=redAlert msg=subject.errors.is_linked></error-msg> </div> <div flex> <md-input-container class=md-block flex-gt-sm> <label>Linked Subjects</label> <md-select ng-change=disableThisSubjectsPrimary(subject) ng-disabled=\"!subject.is_linked || subject.disableThis\" ng-model=subject.linked_primary_subject> <md-option ng-if=\"subj._id != subject._id\" value={{subj._id}} ng-repeat=\"subj in subectArray track by $index\">{{subj.name}}</md-option> </md-select> <error-msg class=redAlert msg=subject.errors.linked_primary_subject></error-msg> </md-input-container> </div> </div> </div> </md-content> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button class=md-whiteframe-3dp ng-if=subjectArray.length ng-click=saveSbjectProperty() style=background:#3f51b5;color:#fff> Confirm </md-button> <md-button class=md-whiteframe-3dp ng-click=cancel() style=margin-right:20px;background:#3f51b5;color:#fff> Cancel </md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/controllers/publishedReportController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:41 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Fri Dec 14 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var publishReportController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "$mdDialog", function publishReportController($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
    _classCallCheck(this, publishReportController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Publish Reports";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var active_year = localStorageService.get('academic_year');
    function findPredecessor(records, targetYear) {
        for (var i = 1; i < records.length; i++) {
            if (records[i].year === targetYear) {
                return records[i - 1];
            }
        }
        return null; // Return null if no predecessor is found
    }
    var self = this;
    self.permissions = {};
    function checkPrivileges(feature_privileges) {
        var ex = _.find(feature_privileges, function (oneP) {
            return oneP.name == "Publish Reports";
        });
        if (ex && ex.privilege) {
            var priviegeEx = _.find(ex.privilege, function (oneP) {
                return oneP.name == "Create" && oneP.status == true;
            });
            if (priviegeEx) {
                self.permissions.Create = true;
            }
        }
        console.log(self.permissions);
    }

    var school_id = localStorageService.get('school_id');
    var user_id = localStorageService.get('user_id');
    var yearRcSelected = localStorageService.get('yearRcSelected');
    var feature_privileges = localStorageService.get('feature_privileges');
    checkPrivileges(feature_privileges);

    authService.callAPI("/v0/school/details/" + school_id, "GET", {}, function (response) {
        try {
            self.scData = response.result.data.details[0].academic_year;
            var immediatePrevYear = findPredecessor(response.result.data.details[0].academic_year, active_year);
            var other_old_years = [];
            if (immediatePrevYear) {
                var olds = [active_year, immediatePrevYear.year];
                try {
                    for (var index = 0; index < self.scData.length; index++) {
                        var element = self.scData[index];
                        try {
                            if (olds.indexOf(element.year) === -1) {
                                other_old_years.push(element);
                            }
                        } catch (e2) {
                            console.log(e2);
                        }
                    }
                } catch (e1) {
                    console.log(e1);
                }
            }
            console.log(other_old_years, "??????????");
            self.other_old_years = other_old_years.map(function (y) {
                return y.year;
            });
            self.isOtherOldYear = function (year) {
                return self.other_old_years && self.other_old_years.includes(year);
            };
            var acdYear = _.find(self.scData, function (oneY) {
                return oneY.status == 'active';
            });
            if (acdYear) {
                if (yearRcSelected) {
                    self.selected_year = yearRcSelected;
                } else {
                    self.selected_year = acdYear.year;
                }
            }
            $scope.getSelectedFeature(true, self.selected_year);
            // $scope.loading = false
            $scope.$apply();
        } catch (ex) {
            console.log(ex);
        }
    });

    $scope.keys = [];
    $scope.resultData = [];
    $scope.gap = 10;
    self.noAction = false;
    $scope.loading = true;
    $scope.filteredItems = [];
    $scope.groupedItems = [];
    $scope.values = [];
    $scope.isLoaded = true;
    $scope.isViewFilter = false;
    $scope.filterObj = {};
    $scope.searchKey;
    var activeAcd_only = localStorageService.get('activeAcdYear');
    // $scope.selectedFeature = SITE_URL + "reportCardDataSet";
    // $scope.applicationFeature = [{
    //     _id: 'Report Card',
    //     name: 'ChatGroup',
    //     api_endpoints: $scope.selectedFeature,
    //     filters: []
    // }]
    // $scope.applicationFeature = _.sortBy($scope.applicationFeature, 'name')
    $scope.savedFilterArr = [];
    $scope.templateName = undefined;

    $scope.fetchSavedFilter = function () {
        var send = {
            school_id: school_id,
            myUserId: user_id
        };
        authService.callAPI("/v0/reportcards/publish/fetchsave", "POST", {
            args: send
        }, function (response) {
            try {
                console.log(response);
                $scope.savedFilterArr = response.result.data.details.response;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (ex) {
                console.log(ex);
            }
        });
    };

    $scope.selectedCls = function (column) {
        var vale = $scope.sort.column && 'sort-' + $scope.sort.descending;
        return column == $scope.sort.column && 'sort-' + $scope.sort.descending;
    };

    $scope.changeSorting = function (column) {
        var sort = $scope.sort;
        if (sort.column == column) {
            sort.descending = !sort.descending;
        } else {
            sort.column = column;
            sort.descending = false;
        }
    };
    self.listRcWithSelectedYear = function (selected_year) {

        if (selected_year) {
            localStorageService.set({
                yearRcSelected: selected_year
            });
        }
        self.selected_year = selected_year;
        $scope.loading = true;
        $scope.getSelectedFeature(false, selected_year);
    };
    function makedateString(db_value) {
        if (!db_value || db_value == "NA") {
            return db_value;
        }
        var date = new Date(db_value);
        var str = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
        return str;
    }
    function setDateOrder() {
        try {
            var fields = ['generated_date', "sent_for_approval_date", "approved_date"];
            var values = $scope.values;
            for (var v = 0; v < values.length; v++) {
                if (fields.indexOf(values[v].key) !== -1) {
                    var date_as_strings = values[v].value;
                    var dates = [],
                        redef_dates = [],
                        _NA_exists = false;
                    for (var s = 0; s < date_as_strings.length; s++) {
                        if (date_as_strings[s]) {
                            if (date_as_strings[s].name != "NA") {
                                var split_str = date_as_strings[s].name.split("-");
                                var date_str = split_str[2] + "-" + split_str[1] + "-" + split_str[0] + " 00:01:01";
                                var one_ = new Date(date_str);
                                var obj = {
                                    name: one_,
                                    is_selected: date_as_strings[s].is_selected
                                };
                                dates.push(obj);
                            } else {
                                _NA_exists = true;
                            }
                        }
                    }
                    dates.sort(function (a, b) {
                        // Turn your strings into dates, and then subtract them
                        // to get a value that is either negative, positive, or zero.
                        return new Date(b.name) - new Date(a.name);
                    });
                    for (var d = 0; d < dates.length; d++) {
                        var date = dates[d].name;
                        var str = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
                        redef_dates.push({
                            name: str,
                            is_selected: dates[d].is_selected
                        });
                    }
                    if (_NA_exists) {
                        redef_dates.push({
                            name: "NA", is_selected: true
                        });
                    }
                    if (redef_dates && redef_dates.length) {
                        values[v].value = redef_dates;
                    }
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    $scope.getSelectedFeature = function (initialLoad, passedYear) {
        $scope.fetchSavedFilter();
        var schoolObj = {
            "school_id": school_id
        };
        schoolObj['academic_year'] = passedYear;
        schoolObj['user_id'] = user_id;
        var requestBody = {
            args: schoolObj
        };
        try {
            $scope.loading = true;
            $scope.originalResultData = [];
            authService.callAPI("/v0/reportcards/published/main", "POST", requestBody, function (response) {
                try {
                    var resultObj = response.result.data.details;
                    for (var i = 0; i < resultObj.length; i++) {
                        resultObj[i]['generated_date'] = makedateString(resultObj[i]['generated_date']);
                        // resultObj[i]['sent_for_approval_date'] = makedateString(resultObj[i]['sent_for_approval_date'])
                        // resultObj[i]['approved_date'] = makedateString(resultObj[i]['approved_date'])
                    }
                    $scope.originalResultData = resultObj;
                    $scope.templateFilter = [];
                    if ($scope.originalResultData.length) {
                        $scope.header = _.without(Object.keys($scope.originalResultData[0]), "_id");
                        $scope.keys = _.without(Object.keys($scope.originalResultData[0]), "_id");
                        _.each($scope.header, function (data, key) {
                            $scope.templateFilter.push({
                                key: $scope.keys[key],
                                label: $scope.header[key]
                            });
                        });
                        $scope.resultData = $scope.originalResultData;
                        $scope.totalItems = $scope.resultData.length;
                        $scope.search();
                        $scope.isLoaded = true;
                        $scope.sort = {
                            column: $scope.header[0],
                            descending: false
                        };
                        $scope.viewFilters(false);
                    } else {
                        $scope.templateFilter = [];
                        $scope.header = undefined;
                        $scope.keys = undefined;
                        $scope.resultData = undefined;
                        // $scope.totalItems = undefined
                        $scope.isViewFilter = undefined;
                        $scope.filterObj = {};
                        $scope.filteredItems = [];
                        $scope.groupedItems = [];
                        $scope.values = [];
                        $scope.totalItems = [];
                        $scope.isLoaded = false;
                        $scope.pagedItems = [];
                    }
                    if ($scope.isDataObject(resultObj)) {
                        $scope.status = "success";
                    } else {
                        $scope.status = "fail";
                    }
                    console.log(passedYear + '!= ' + activeAcd_only);
                    // Toggles the 'Publish reports' button
                    try {
                        // Set of years the button 'Publish reports' should show when selecting the year
                        var Allowed_years_to_publish = new Set(['2026-2027', '2025-2026', '2024-2025', '2023-2024']);
                        if (Allowed_years_to_publish.has(passedYear)) {
                            self.noAction = true;
                        } else {
                            self.noAction = false;
                        }
                    } catch (error) {
                        // this is the fall back code(legacy code) in case the above logic doesnt work
                        if (passedYear != activeAcd_only) {
                            self.noAction = false;
                        } else {
                            self.noAction = true;
                        }
                    }
                    // setDateOrder()
                } catch (error) {
                    console.log(error);
                    $scope.status = "fail";
                }
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });;

                try {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                } catch (scroll_error) {
                    console.log(scroll_error);
                }
            });
        } catch (ex) {
            $scope.status = "fail";
        }
    };

    $scope.exportCSVData = function () {
        var nameObj = _.find($scope.applicationFeature, function (dt) {
            return dt.api_endpoints === $scope.selectedFeature;
        });
        csvCovertor($scope.resultData, nameObj._id, true);
        //JSONToCSVConvertor($scope.obj, nameObj._id, true);
    };

    function fetchValues(keys, value) {
        var name = void 0,
            ids = void 0,
            arr = [];

        if (keys.type != undefined && keys.type != 'bool') {
            ids = _.compact(_.uniq(_.pluck($scope.originalResultData, keys.key)));
        } else {
            ids = _.compact(_.uniq(_.pluck($scope.originalResultData, keys.key)));
        }
        _.each(ids, function (dat) {
            if (value) {
                var filterObj = JSON.parse($scope.selectedFilter).fields;
                if (_.contains(filterObj[keys.key], dat)) {
                    arr.push({
                        'name': dat,
                        'is_selected': true
                    });
                } else {
                    arr.push({
                        'name': dat,
                        'is_selected': false
                    });
                }
            } else {
                arr.push({
                    'name': dat,
                    'is_selected': true
                });
            }
        });
        return arr;
    }
    $scope.viewFilters = function (value) {
        $scope.refreshFilter();
        $scope.values = [];

        if (!value) {
            $scope.selectedFilterToShow = [];
            $scope.chipsFilter = $scope.templateFilter;

            //To re assign if user dynamically remove any column field.
            $scope.header = _.pluck($scope.chipsFilter, "key");
            $scope.keys = _.pluck($scope.chipsFilter, "key");

            _.each($scope.chipsFilter, function (data) {
                data._lowerkey = data.key.toLowerCase();
                data._lowerlabel = data.label.toLowerCase();
                $scope.selectedFilterToShow.push(data);
            });
        }

        var filters = $scope.templateFilter;
        var totalDataCount = $scope.originalResultData.length;
        var count = 1;
        if (totalDataCount <= 1000) {
            count = 1;
        } else {
            count = Math.ceil(totalDataCount / 1000);
        }

        for (var i = 0; i < count; i++) {
            if (i == 0) {
                _.each(filters, function (data) {
                    var result = fetchValues(data, value);
                    $scope.values.push({
                        key: data.key,
                        label: data.label,
                        value: result,
                        selected_text: ""
                    });
                });
            } else {
                _.each(filters, function (data) {
                    var result = fetchValues(data, value);
                    var requiredIndex = -1;
                    _.each($scope.values, function (dt, key) {
                        if (dt.key === data.key) {
                            requiredIndex = key;
                            dt.value.concat(result);
                        }
                    });
                });
            }

            if (i === count - 1) {
                $scope.filterObj = {};
                $scope.selectedObj = {};
                _.each($scope.values, function (pt) {
                    var obj = _.filter(pt.value, function (ft) {
                        return ft.is_selected == true;
                    });
                    var names = _.pluck(obj, "name");
                    $scope.selectedObj[pt.key] = names;
                    pt.selected_text = "All";
                    pt.value = _.sortBy(pt.value, 'name');
                });
                $scope.columnFilterResult();
            }
        }
    };

    $scope.showFilters = function () {
        $scope.isViewFilter ? $scope.isViewFilter = false : $scope.isViewFilter = true;
    };

    $scope.clearSearchTerm = function () {
        $scope.searchKey = '';
    };

    $scope.getSelectedText = function (key) {
        var result = "";
        if ($scope.selectedObj[key] != undefined && $scope.selectedObj[key].length > 0) {
            return $scope.selectedObj[key][0];
        } else {
            return "all";
        }
    };

    $scope.toggleDropdown = function (data) {
        if (data != undefined) {
            _.each($scope.values, function (dt) {
                if (data.key == dt.key) {
                    dt.open = !dt.open;
                } else {
                    dt.open = false;
                }
            });
        }
    };

    $scope.columnFilterResult = function () {
        _.each($scope.values, function (val) {
            _.each(val.value, function (key, index) {
                if (!_.contains($scope.selectedObj[val.key], key.name)) {
                    key.is_selected = false;
                } else {
                    key.is_selected = true;
                }
            });
        });
        var selectedAllCount = 0;
        var selectedCustomCount = 0;
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
                selectedAllCount++;
            } else {
                val.selected_text = "Custom";
                selectedCustomCount++;
            }
        });
        $scope.chatData = [];
        var allKeys = [];
        if (selectedCustomCount > 0) {
            allKeys = _.keys($scope.selectedObj);
            var customKeys = _.filter($scope.values, function (val) {
                return val.selected_text === "Custom";
            });
            var customKey = _.pluck(customKeys, "key");
            allKeys = customKey;
            var selectedValueCount = 0;
            _.each(allKeys, function (key) {
                if ($scope.selectedObj[key] !== undefined && $scope.selectedObj[key].length > 0) {
                    selectedValueCount++;
                }
            });
            if (selectedValueCount == allKeys.length) {
                _.each(allKeys, function (ch, pKey) {
                    if ($scope.selectedObj[ch] !== undefined && $scope.selectedObj[ch].length > 0) {
                        if ($scope.selectedObj[ch].length == 1) {
                            var searchObj = {};
                            searchObj[ch] = $scope.selectedObj[ch][0];
                            if ($scope.chatData.length === 0) {
                                $scope.chatData = _.where($scope.originalResultData, searchObj);
                            } else {
                                if (pKey == 0) {
                                    $scope.chatData = _.where($scope.originalResultData, searchObj);
                                } else {
                                    $scope.chatData = _.where($scope.chatData, searchObj);
                                }
                            }
                        } else {
                            var i;

                            (function () {
                                var chatData = [];
                                for (i = 0; i < $scope.selectedObj[ch].length; i++) {
                                    var _searchObj = {};
                                    _searchObj[ch] = $scope.selectedObj[ch][i];
                                    if (chatData.length === 0) {
                                        if (pKey == 0) {
                                            $scope.chatData = _.where($scope.originalResultData, _searchObj);
                                            chatData = _.where($scope.originalResultData, _searchObj);
                                        } else {
                                            chatData = _.where($scope.chatData, _searchObj);
                                        }
                                        if (i == $scope.selectedObj[ch].length - 1) {
                                            $scope.chatData = chatData;
                                        }
                                    } else {
                                        var resultArray = void 0;
                                        if (pKey == 0) {
                                            resultArray = _.where($scope.originalResultData, _searchObj);
                                        } else {
                                            resultArray = _.where($scope.chatData, _searchObj);
                                        }
                                        if (i == 0) {
                                            chatData = resultArray;
                                        } else {
                                            _.each(resultArray, function (data) {
                                                chatData.push(data);
                                            });
                                        }
                                        if (i == $scope.selectedObj[ch].length - 1) {
                                            $scope.chatData = chatData;
                                        }
                                    }
                                }
                            })();
                        }
                    } else {
                        $scope.chatData = [];
                    }
                });
            } else {
                $scope.chatData = [];
            }
        }
        if (allKeys.length > 0) {
            $scope.resultData = $scope.chatData;
        } else {
            $scope.resultData = $scope.originalResultData;
        }
        $scope.totalItems = $scope.resultData.length;
        $scope.search();
    };

    $scope.keyDownHandler = function (event) {
        if (event.target != null && event.target.offsetParent != null) {
            if (event.target.id === "btnSelect" || event.target.offsetParent.id === "lstItem") {
                return;
            } else {
                _.each($scope.values, function (dt) {
                    dt.open = false;
                });
            }
        }
    };

    $scope.setFilterObj = function (data, key) {
        if (!data.is_selected) {
            var obj = _.reject($scope.selectedObj[key], function (kt) {
                return kt === data.name;
            });
            $scope.selectedObj[key] = obj;
        } else {
            if (!_.contains($scope.selectedObj[key], data.name)) {
                if ($scope.selectedObj[key] != undefined) {
                    $scope.selectedObj[key].push(data.name);
                } else {
                    $scope.selectedObj[key] = [];
                    $scope.selectedObj[key].push(data.name);
                }
            }
        }
        $scope.filterObj[key] = data.name;
    };

    $scope.refreshFilter = function () {
        $scope.filterObj = {};
        $scope.selectedObj = {};
        _.each($scope.values, function (pt) {
            $scope.setAllData(pt.value, pt.key);
        });
        $scope.columnFilterResult();
    };

    $scope.isDataString = function (data) {
        return _.isString(data);
    };
    $scope.isDataBoolean = function (data) {
        return _.isBoolean(data);
    };
    $scope.isDataNumber = function (data) {
        return _.isNumber(data);
    };
    $scope.isDataArray = function (data) {
        return _.isArray(data);
    };
    $scope.isDataObject = function (data) {
        return _.isObject(data);
    };
    $scope.isArrayOfDataObject = function (data) {
        var type = 'text';
        if (_.isString(data) || _.isBoolean(data) || _.isNumber(data)) {
            type = 'text';
        } else if (_.isObject(data)) {
            var obj = data[0].name;
            if (_.isObject(obj)) {
                type = 'array_of_object';
            } else {
                type = 'text';
            }
        }
        return type;
    };
    $scope.isId = function (data) {
        var isIdExist = false;
        if (_.isString(data) && data.indexOf("_id") >= 0) {
            isIdExist = true;
        }
        return isIdExist;
    };

    $scope.keyReplace = function (data) {
        //let isIdExist = false
        var str = data.replace(/_/g, ' ');
        return str; //.toUpperCase()
    };

    $scope.currentPage = 0;
    $scope.numPerPage = 10;
    $scope.itemsPerPage = 10;

    $scope.paginate = function (value) {
        var begin, end, index;
        begin = ($scope.currentPage - 1) * $scope.numPerPage;
        end = begin + $scope.numPerPage;
        index = $scope.resultData.indexOf(value);
        return begin <= index && index < end;
    };

    $scope.setAllData = function (data, key) {
        _.each(data, function (dt) {
            dt.is_selected = true;
        });
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
            } else {
                val.selected_text = "Custom";
            }
        });
        var keyBasedValues = _.pluck(data, 'name');
        $scope.selectedObj[key] = keyBasedValues;
        $scope.columnFilterResult();
    };

    $scope.unSetAllData = function (data, key) {
        _.each(data, function (dt) {
            dt.is_selected = false;
        });
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
            } else {
                val.selected_text = "Custom";
            }
        });
        $scope.selectedObj[key] = [];
        $scope.columnFilterResult();
    };

    $scope.prevPage = function () {
        if ($scope.currentPage > 0) {
            $scope.currentPage--;
        }
    };

    $scope.nextPage = function () {
        if ($scope.currentPage < $scope.totalItems / 10 - 1) {
            $scope.currentPage++;
        }
    };

    $scope.setPage = function (n) {
        $scope.currentPage = n;
    };

    $scope.search = function () {
        $scope.filteredItems = $scope.resultData;
        $scope.currentPage = 0;
        $scope.groupToPages();
    };

    $scope.groupToPages = function () {
        $scope.pagedItems = [];
        _.each($scope.filteredItems, function (data) {
            if (data['report'] === "Report Card for VI-VIII (Term - 2)") {
                data['report'] = "Annual Report";
            }
        });
        for (var i = 0; i < $scope.filteredItems.length; i++) {
            if (i % $scope.itemsPerPage === 0) {
                $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)] = [$scope.filteredItems[i]];
            } else {
                $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)].push($scope.filteredItems[i]);
                //$scope.pagedItems.push($scope.filteredItems[i]);
            }
        }

        if ($scope.pagedItems.length < 11) {
            $scope.gap = $scope.pagedItems.length;
        } else {
            $scope.gap = 10;
        }
        $scope.limit = $scope.pagedItems.length;
    };
    $scope.range = function (size, start, end) {
        var ret = [];
        if (size < end) {
            end = size;
            start = size - $scope.gap;
        }
        for (var i = start; i < end; i++) {
            if (i < $scope.limit) {
                ret.push(i);
            }
        }
        return ret;
    };

    function csvCovertor(JSONData, reportTitle, showLabel) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = (typeof JSONData === "undefined" ? "undefined" : _typeof(JSONData)) != 'object' ? JSON.parse(JSONData) : JSONData;
        var CSV = '';
        //Set Report title in first row or line
        CSV += reportTitle + '\r\n\n';
        //This condition will generate the Label/Header
        if (showLabel) {
            var row = "";
            //This loop will extract the label from 1st index of on array
            _.each($scope.header, function (header) {
                row += header + ',';
            });
            row = row.slice(0, -1);
            //append Label row with line break
            CSV += row + '\r\n';
        }

        _.each(arrData, function (data) {
            var row = "";
            _.each($scope.keys, function (key) {
                row += '"' + data[key] + '",';
            });
            row.slice(0, row.length - 1);
            //add a line break after each row
            CSV += row + '\r\n';
        });

        if (CSV == '') {
            alert("Invalid data");
            return;
        }
        //Generate a file name
        var fileName = "Report_";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += reportTitle.replace(/ /g, "_");

        //Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    $scope.publishReport = function (ev) {
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = $mdDialog.confirm().title('Are you sure to publish?').textContent('Report cards which are approved get published through this action').ariaLabel('Lucky day').targetEvent(ev).ok('Yes').cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
            $scope.errorKey = [];
            $scope.loading = true;
            if ($scope.resultData != undefined && $scope.resultData.length > 0) {
                var approvedData = _.filter($scope.resultData, function (dt) {
                    return dt.status !== 'approved';
                });
                var approvedDataOnly = _.filter($scope.resultData, function (dt) {
                    return dt.status == 'approved';
                });
                if (approvedData && approvedData.length) {
                    console.log('there are reportcards of other status also but only approved status will come published');
                }
                if (!approvedDataOnly || !approvedDataOnly.length) {
                    toastr.error("there are no approved reports!");
                    $scope.loading = false;
                    return false;
                }
                var requestBody = {
                    args: {
                        ids: _.pluck(approvedDataOnly, "_id"),
                        school_id: school_id,
                        myUserId: localStorageService.get('user_id'),
                        year: localStorageService.get('academic_year')
                    }
                };
                authService.callAPI("/v0/reportcards/published/publish", "POST", requestBody, function (response) {
                    try {
                        console.log(response, "responserrrrrrrrrrrr");
                        $scope.loading = false;
                        $scope.getSelectedFeature(false, self.selected_year);
                        toastr.success("Report published successfully");
                    } catch (ex) {
                        $scope.loading = false;
                        console.log(ex);
                    }
                });
            }
        }, function () {
            $scope.status = 'You decided to cancel.';
        });
    };

    function publishStatusController($scope, $mdDialog, $mdToast, $document, $state, errorMsg, $reactive) {
        $scope.errorMsg = errorMsg;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
    $scope.saveFilter = function () {
        if ($scope.templateName != undefined) {
            var fields = {};
            var filterObj = {};
            _.each($scope.values, function (dt) {
                fields[dt.key] = $scope.selectedObj[dt.key];
                if (dt.selected_text === "Custom") {
                    filterObj[dt.key] = $scope.selectedObj[dt.key];
                }
            });
            var data = {
                'creator_id': user_id,
                'school_id': school_id,
                'title': $scope.templateName,
                'fields': fields,
                'layouts': angular.copy($scope.selectedFilterToShow),
                'isReportFilter': true,
                'state': "publishReport"
            };
            authService.callAPI("/v0/reportcards/publish/saveSearch", "POST", { filterPage: data }, function (response) {
                try {
                    $scope.templateName = undefined;
                    $scope.fetchSavedFilter();
                    _.defer(function () {
                        $scope.$apply();
                    });;
                    toastr.success("Saved search criteria successfully");
                } catch (ex) {
                    console.log(ex);
                }
            });
        } else {
            toastr.error('Please enter filter name');
        }
    };

    $scope.displaySavedFilterResult = function (data) {
        if (data != 'None') {
            $scope.selectedFilter = data;
            console.log($scope.selectedFilter);
            $scope.selectedFilterToShow = JSON.parse($scope.selectedFilter).layouts;
            $scope.header = _.pluck($scope.selectedFilterToShow, "label");
            $scope.keys = _.pluck($scope.selectedFilterToShow, "key");
            $scope.viewFilters(true);
        } else {
            $scope.refreshFilter();
        }
    };

    $scope.transformChip = function (chip) {
        // If it is an object, it's already a known chip
        if (angular.isObject(chip)) {
            return chip;
        }

        // Otherwise, create a new one
        return {
            key: chip,
            label: 'new'
        };
    };

    $scope.autocompleteDemoRequireMatch = true;
    $scope.selectedFilterToShow = [];
    $scope.querySearch = function (query) {
        var results = query ? $scope.chipsFilter.filter(createFilterFor(query)) : [];
        return results;
    };

    function createFilterFor(query) {
        var lowercaseQuery = angular.lowercase(query);
        return function filterFn(report_field) {
            return report_field._lowerkey.indexOf(lowercaseQuery) === 0 || report_field._lowerlabel.indexOf(lowercaseQuery) === 0;
        };
    }
    $scope.chipRemoveHandler = function (chip) {
        if ($scope.selectedFilterToShow.length <= 2) {
            $scope.isReadOnly = true;
        } else {
            $scope.isReadOnly = false;
        }
        if ($scope.selectedFilterToShow.length == 0) {
            $scope.header = _.pluck($scope.chipsFilter, "key");
            $scope.keys = _.pluck($scope.chipsFilter, "key");
            _.each($scope.chipsFilter, function (data) {
                data._lowerkey = data.key.toLowerCase();
                data._lowerlabel = data.label.toLowerCase();
                $scope.selectedFilterToShow.push(data);
            });
        } else {
            $scope.header = _.pluck($scope.selectedFilterToShow, "key");
            $scope.keys = _.pluck($scope.selectedFilterToShow, "key");
        }
    };
    $scope.chipAddHandler = function (chip) {
        $scope.header = _.pluck($scope.selectedFilterToShow, "key");
        $scope.keys = _.pluck($scope.selectedFilterToShow, "key");

        if ($scope.selectedFilterToShow.length <= 2) {
            $scope.isReadOnly = true;
        } else {
            $scope.isReadOnly = false;
        }
    };

    $scope.viewReport = function (dataId) {
        var is_edit = false;
        if (self.permissions && self.permissions.Create) {
            is_edit = true;
        }
        $state.go('viewGeneratedReportData', {
            'dataId': dataId,
            selected_year: self.selected_year,
            is_edit: is_edit
        });
    };

    this.$onDestroy = function () {};
}];

exports.default = publishReportController;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/controllers/approveReportsController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:11:19 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var ApproveReportsController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "prevReportService", function ApproveReportsController($scope, $rootScope, authService, localStorageService, $state, prevReportService) {
    _classCallCheck(this, ApproveReportsController);

    var self = this;
    var school_id = localStorageService.get('school_id');
    var user_id = localStorageService.get('user_id');
    var activeAcd = self.scData = localStorageService.get('activeAcdYear');
    var rcApproveYear = localStorageService.get('rcApproveYear');
    var _SENT_APPROVAL = 'sent_for_approval';
    var _SENT_APPROVAL_OBJ = {
        _id: "sent_for_approval",
        name: "Not Approved"
    };
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Approve Reports";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        var stored_data = prevReportService.getSelectedCriterias();
        var isFromStore = false;
        getSchool_acds(function (callBackData) {
            console.log(callBackData);
            $scope.year_array = findOneObject(callBackData, "Acadmic Year").array;
            console.log($scope.year_array);
            loadFilters(activeAcd, function () {
                var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                if (stored_data) {
                    setFilterData(data, false);
                    initPaginate();
                    setModelFromStore(stored_data);
                    $scope.search(true);
                } else {
                    console.log("no saved data");
                    clearModels();
                    $scope.model_statuses = [_SENT_APPROVAL];
                    setFilterData(data, true);
                }
            });
        });

        console.log(stored_data);
        pushLog();
    };
    $scope.loading = true;
    function _breakReference(data) {
        var keys = Object.keys(data);
        var obj = {};
        for (var k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[keys[k]];
        }
        return obj;
    }
    var myUserId = user_id;
    $scope.year_array = [];
    $scope._selected_year = activeAcd;

    function initPaginate() {
        $scope.skip = 0;
        $scope.morePage = true;
        self.total_count = 0;
    }

    function findOneObject(array, labelStr, isForCsv) {
        if (isForCsv) {
            return _.find(array, function (one) {
                return one._id == labelStr;
            });
        }
        return _.find(array, function (one) {
            return one.label == labelStr;
        });
    }
    $scope.session_array = [];
    $scope.curriculum_array = [];
    $scope.class_array = [];
    $scope.batch_array = [];
    $scope.subject_array = [];
    $scope.report_array = [];
    $scope.status_array = [];
    $scope.list = [];
    self.reportCardListArray = [];
    function getSchool_acds(callBack) {
        var obj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd
        };
        authService.callAPI("/v0/afl/get/school_acds", "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                callBack(response.result.data.details);
            } else {
                toastr.error("Server Interrupted .");
                callBack(null);
            }
        });
    }

    function loadFilters(selectedYear, _cb) {
        var obj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: selectedYear
        };
        authService.callAPI("/v0/getApproverFilters", "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                _cb(response.result.data.details);
            } else {
                toastr.error("Server Interrupted .");
                _cb(null);
            }
        });
    }
    function setFilterData() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var isInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var items = data.response;
        $scope.session_array = items.sessions;
        $scope.curriculum_array = items.curriculums;
        $scope.class_array = items.classes;
        $scope.batch_array = items.batches;
        $scope.subject_array = items.subjects;
        $scope.report_array = items.reports;
        $scope.status_array = items.statuses;
        if (!$scope.status_array.length || !$scope.status_array.find(function (status) {
            return status._id == _SENT_APPROVAL;
        })) {
            $scope.status_array.push(_SENT_APPROVAL_OBJ);
        }
        if (isInit) {
            $scope.model_statuses = [_SENT_APPROVAL];
            $scope.search(isInit);
        }
    }

    $scope.clearAllFilters = function () {
        $scope.loading = true;
        $scope.model_sessions = null;
        $scope.model_curriculums = null;
        $scope.model_classes = null;
        $scope.model_batches = null;
        $scope.model_subjects = null;
        $scope.model_reports = null;
        $scope.model_statuses = [];
        $scope.search(true);
    };
    function setModelFromStore(stored_data) {
        var obj = {
            school_id: school_id,
            academic_year: $scope._selected_year
        };
        if (stored_data.session_ids && stored_data.session_ids.length) {
            $scope.model_sessions = stored_data.session_ids;
        }
        if (stored_data.curriculum_ids && stored_data.curriculum_ids.length) {
            $scope.model_curriculums = stored_data.curriculum_ids;
        }
        if (stored_data.class_ids && stored_data.class_ids.length) {
            $scope.model_classes = stored_data.class_ids;
        }
        if (stored_data.batch_ids && stored_data.batch_ids.length) {
            $scope.model_batches = stored_data.batch_ids;
        }
        if (stored_data.subject_ids && stored_data.subject_ids.length) {
            $scope.model_subjects = stored_data.subject_ids;
        }
        if (stored_data.report_console_ids && stored_data.report_console_ids.length) {
            $scope.model_reports = stored_data.report_console_ids;
        }
        if (stored_data.statuses && stored_data.statuses.length) {
            $scope.model_statuses = stored_data.statuses;
        }
        return obj;
    }
    $scope.search = function () {
        var isOninit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        var args = getSelectedModels();
        if (isOninit) {
            initPaginate();
            self.reportCardListArray = [];
            $scope.skip = 0;
        }
        args.skip = $scope.skip;
        args.morePage = $scope.morePage;
        args.user_id = myUserId;
        $scope.loading = true;
        authService.callAPI("/v0/approverList", "POST", args, function (response) {
            if (response && response.result && response.result.data && response.result.data.details) {
                _pushToList(response.result.data.details.response);
                $scope.skip = response.result.data.details.skip;
                $scope.morePage = response.result.data.details.morePage;
                if (response.result.data.details.total_count) {
                    $scope.total_count = response.result.data.details.total_count;
                    self.total_count = response.result.data.details.total_count;
                }
            }
            $scope.loading = false;
            console.log(response, $scope.skip);
            prevReportService.setSelectedCriterias(null);
            $scope.$apply();
        });
    };
    function clearModels() {
        $scope.model_sessions = null;
        $scope.model_curriculums = null;
        $scope.model_classes = null;
        $scope.model_batches = null;
        $scope.model_subjects = null;
        $scope.model_reports = null;
        $scope.model_statuses = [_SENT_APPROVAL];
    }
    function getSelectedModels() {
        var obj = {
            school_id: school_id,
            academic_year: $scope._selected_year
        };
        if ($scope.model_sessions && $scope.model_sessions.length) {
            obj.session_ids = $scope.model_sessions;
        }
        if ($scope.model_curriculums && $scope.model_curriculums.length) {
            obj.curriculum_ids = $scope.model_curriculums;
        }
        if ($scope.model_classes && $scope.model_classes.length) {
            obj.class_ids = $scope.model_classes;
        }
        if ($scope.model_batches && $scope.model_batches.length) {
            obj.batch_ids = $scope.model_batches;
        }
        if ($scope.model_subjects && $scope.model_subjects.length) {
            obj.subject_ids = $scope.model_subjects;
        }
        if ($scope.model_reports && $scope.model_reports.length) {
            obj.report_console_ids = $scope.model_reports;
        }
        if ($scope.model_statuses && $scope.model_statuses.length) {
            obj.statuses = $scope.model_statuses;
        }
        if ($scope._selected_year && $scope._selected_year.length) {
            obj._selected_year = $scope._selected_year;
        }
        return obj;
    }
    function _pushToList() {
        var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        for (var index = 0; index < array.length; index++) {
            try {
                if (!self.reportCardListArray) {
                    self.reportCardListArray.list = [];
                }
                var element = array[index];
                if (element.report_card_header.academic_year != activeAcd) {
                    element['is_active'] = false;
                } else {
                    element['is_active'] = true;
                }
                self.reportCardListArray.push(element);
            } catch (er) {
                console.log(er);
            }
        }
    }

    $scope.loadMore = function () {
        $scope.search(false);
    };
    authService.callAPI("/v0/school/details/" + school_id, "GET", {}, function (response) {
        try {
            self.scData = response.result.data.details[0].academic_year;
            var acdYear = _.find(self.scData, function (oneY) {
                return oneY.status == 'active';
            });
            if (acdYear) {
                if (rcApproveYear) {
                    self.selected_year = rcApproveYear;
                } else {
                    self.selected_year = acdYear.year;
                }
                // loadData(self.selected_year)
                // $scope.search(true)
            }
            $scope.$apply();
        } catch (ex) {
            console.log(ex);
        }
    });

    function loadData(selected_year) {
        var postValues = {
            args: {
                selected_year: selected_year,
                myUserId: user_id
            }
        };
        authService.callAPI("/v0/reportcards/approver/reports", "POST", postValues, function (response) {
            try {
                var reportCardListArray = response.result.data.details.response;
                _.each(reportCardListArray, function (oneRcData) {
                    if (oneRcData.report_card_header.academic_year != activeAcd) {
                        oneRcData['is_active'] = false;
                    } else {
                        oneRcData['is_active'] = true;
                    }
                });
                self.reportCardListArray = reportCardListArray;
                $scope.loading = false;
                $scope.$apply();
            } catch (ex) {
                console.log(ex);
            }
        });
    }

    self.listRcWithSelectedYear = function (selected_year) {
        if (selected_year) {
            localStorageService.set({
                rcApproveYear: selected_year
            });
        }
        self.selected_year = selected_year;
        $scope.loading = true;
        console.log(selected_year);
        loadFilters(selected_year, function (data) {
            console.log('year changed');
            setFilterData(data, true);
        });
        // loadData(self.selected_year)
    };

    self.viewTemplate = function () {
        var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var obj = getSelectedModels();
        prevReportService.setSelectedCriterias(obj);
        $state.go('viewGeneratedReportData', {
            "dataId": card._id,
            selected_year: self.selected_year,
            is_edit: false
        });
    };

    function pushLog() {
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + user_id + "/" + school_id + "/reportCardApproval_Listing", "GET", {}, function (response) {
            // console.log(response)
        });
    }

    this.$onDestroy = function () {};
}];

exports.default = ApproveReportsController;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportCardValidationPopup = __webpack_require__(894);

var _reportCardValidationPopup2 = _interopRequireDefault(_reportCardValidationPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportCardListingCtrl = function ReportCardListingCtrl($scope, $state, $mdDialog, authService, localStorageService, $rootScope, MARK_ENTRY_SAVE_CONSTANTS) {
    'ngInject';

    _classCallCheck(this, ReportCardListingCtrl);

    var self = this;
    var authoring = localStorageService.get('authoringData');
    var userId = localStorageService.get('user_id');
    $rootScope.title = "Report Cards";
    var activeAcd = localStorage.getItem('activeAcdYear');
    if (!activeAcd) {
        activeAcd = localStorageService.get('activeAcdYear');
    }
    if (!activeAcd) {
        activeAcd = localStorageService.get('academic_year');
    }
    if (!activeAcd) {
        activeAcd = "2018-2019";
    }
    var rcListingYear = localStorageService.get('rcListingYear');
    if (rcListingYear) {
        // console.log(rcListingYear)
    }
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, { reload: true });
        }
        pushLog();
    };
    // $rootScope.reportExist= {
    // 	"data_exist": true,
    // 	"console_id": "periodicTestOneNoConversion"
    // }
    // console.log($rootScope.reportExist,"$rootScope.reportExist");
    $scope.sessionName = authoring.session;
    $scope.curiculumName = authoring.curriculum;
    $scope.className = authoring.class;
    $scope.batchName = authoring.batch;
    $scope.subjectName = authoring.subject;
    this.featureMoreThanOne = false;
    this.report_console = true;
    this.approve_reject = false;
    $scope.loading = true;
    self.selected_year = undefined;
    if (activeAcd) {
        if (rcListingYear) {
            self.selected_year = rcListingYear;
        } else {
            self.selected_year = activeAcd;
        }
        subscribeAndMakeFunction(self.selected_year);
    }
    var subjectId = undefined;
    var sessionId = undefined;
    var curriculumId = undefined;
    var xClassId = undefined;
    var batchId = undefined;
    var schoolId = undefined;
    if (authoring) {
        subjectId = authoring.subject_id;
        sessionId = authoring.session_id;
        curriculumId = authoring.curriculum_id;
        xClassId = authoring.class_id, batchId = authoring.batch_id, schoolId = authoring.school_id;
    }
    $scope.isBucketSelection = false;
    $scope.autoGenertion = false;
    if (MARK_ENTRY_SAVE_CONSTANTS.KG_CLASSES.includes(authoring.class_id)) $scope.isBucketSelection = true;else $scope.autoGenertion = true;

    function subscribeAndMakeFunction(selected_year) {
        var obj = {
            authoring: authoring,
            selected_year: selected_year,
            activeAcd: activeAcd,
            my_user_id: userId
        };
        authService.callAPI("/v0/reportcards/teacher/list", "POST", { args: obj, subject_id: authoring.subject_id }, function (response) {

            if (response && response.result && response.result.data && response.result.data.details) {
                var schoolDataSub = response.result.data.details.response.permissions.schooldata;
                var personData = response.result.data.details.response.permissions.personData;
                self.scData = schoolDataSub.academic_year;
                var acdYear = _.find(schoolDataSub.academic_year, function (oneY) {
                    return oneY.status == 'active';
                });
                var featuresAll = personData.feature_privileges;
                if (featuresAll) {
                    self.reportCardListArray = response.result.data.details.response.rcData;
                    for (var i = 0; i < self.reportCardListArray.length; i++) {

                        // if(self.reportCardListArray[i]  && $rootScope.reportExist && $rootScope.reportExist.data_exist && self.reportCardListArray[i]._id == $rootScope.reportExist.console_id){
                        // 	self.reportCardListArray[i].is_pending = true
                        // 	//  $rootScope.reportExist.data_exist = false
                        // }else{
                        // 	self.reportCardListArray[i].is_pending = false
                        // }
                    }
                } else {
                    $state.go("dashboard");
                }

                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }

    self.listRcWithSelectedYear = function (selected_year) {
        self.selected_year = selected_year;
        localStorageService.set({
            rcListingYear: selected_year
        });
        $scope.loading = true;
        subscribeAndMakeFunction(self.selected_year);
    };

    function verifyData(result, cardId) {
        // $scope.loading = true
        if (!result || !result.response) {
            if ($scope.isBucketSelection) {
                kgReportCheck(cardId);
            } else if ($scope.autoGenertion) {
                mainReportCheck(cardId);
            } else {
                $state.go('reportCardGenConsole', {
                    cardId: cardId,
                    dataId: false,
                    re_generate: false,
                    fromCt: false
                });
            }
        } else {
            if (result.response && result.response._id) {
                if (result.response.current_status && result.response.current_status.status == "rejected") {
                    if ($scope.isBucketSelection) {
                        kgReportCheck(cardId);
                    } else if ($scope.autoGenertion) {
                        mainReportCheck(cardId);
                    } else {
                        $state.go('reportCardGenConsole', {
                            cardId: cardId,
                            dataId: result.response._id,
                            re_generate: false,
                            fromCt: false
                        });
                    }
                } else {
                    $state.go('viewGeneratedReportData', {
                        dataId: result.response._id,
                        selected_year: self.selected_year,
                        is_edit: false
                    });
                }
            } else {
                if ($scope.isBucketSelection) {
                    kgReportCheck(cardId);
                } else if ($scope.autoGenertion) {
                    mainReportCheck(cardId);
                } else {
                    $state.go('reportCardGenConsole', {
                        cardId: cardId
                    });
                }
            }
        }
    }

    self.syncReportCard = function (card) {
        if (!card.mark_entry_updated) {
            toastr.success('Report Card is already up to date with the latest mark entry');
            return;
        }
        syncReportCheck(card);
    };
    function syncReportCheck(card) {
        var api_url = "/v0/reportcards/teacher/main/autogenerate";
        if (card.kg_rc || card.montessori_rc) {
            api_url = MARK_ENTRY_SAVE_CONSTANTS.API_AUTO_GENERATE_KG_REPORT;
        }
        var st = "Are you sure you want to sync the report card with latest mark entry?";
        var confirm = $mdDialog.confirm().title(st).ok("Yes").cancel("No");
        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            var reqObj = {
                session: authoring.session_id,
                curriculum: authoring.curriculum_id,
                class: authoring.class_id,
                batch: authoring.batch_id,
                subject: authoring.subject_id,
                school_id: schoolId,
                academic_year: activeAcd,
                report_console_id: card._id
            };

            authService.callAPI(api_url, 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    var reqArr = [];
                    _.each(response.result.data.details, function (data) {
                        if (card.kg_rc || card.montessori_rc) {
                            reqArr.push({
                                aliace: data.bucket.db_key,
                                db_key: data.bucket.db_key,
                                list: [{
                                    activity_name: data.mark_entry_details.exam,
                                    activity_id: data.mark_entry_details._id,
                                    created_by: userId,
                                    type: "activities"
                                }],
                                // max_mark: data.bucket.max_mark,
                                max_mark: 100,
                                name: data.bucket.name,
                                selection: "best"
                            });
                        } else {
                            console.log("ooooooooo+++++++");
                            reqArr.push({
                                aliace: data.bucket.aliace,
                                db_key: data.bucket.db_key,
                                list: [{
                                    activity_name: data.markEntryDetail.exam,
                                    activity_id: data.markEntryDetail._id,
                                    created_by: userId,
                                    type: "activities"
                                }],
                                max_mark: data.bucket.max_mark,
                                // max_mark: 100,
                                name: data.bucket.name,
                                selection: "best"
                            });
                        }
                    });
                    var activityCondition = {
                        session_id: authoring.session_id,
                        curriculum_id: authoring.curriculum_id,
                        class_id: authoring.class_id,
                        batch_id: authoring.batch_id,
                        subject_id: authoring.subject_id,
                        school_id: schoolId
                    };
                    var _reqObj = {
                        args: {
                            cardId: card._id,
                            report_card_id: card.report_data_id,
                            valuesUnderSkills: reqArr,
                            activityCondition: activityCondition,
                            dataId: false,
                            re_generateFlag: false,
                            fromCt: false,
                            select_regen: false,
                            get_students_selected: [],
                            myUserId: userId,
                            report_card_sync: true
                        }
                    };
                    console.log(_reqObj);
                    authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', _reqObj, function (response) {
                        try {
                            if (response.error && response.error.error == "Already generated the report!") {
                                toastr.error(response.error.error);
                            } else {
                                var result = response.result.data.details.response;
                                card.mark_entry_updated = false;
                                toastr.success("Report card is updated with latest mark entry");
                            }
                            $scope.loading = false;
                            $scope.$apply();
                        } catch (ex) {
                            console.log(ex);
                        }
                    });
                } else if (response.error && response.error.error && response.error.error.message) {
                    $scope.loading = false;
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Alert!').textContent(response.error.error.message).ariaLabel('Alert Dialog Demo').ok('OK'));
                }
            });
        }, function () {});
    }
    self.viewTemplate = function (cardId, view_only) {
        // $scope.loading = true
        $scope.templateCard = _.find(self.reportCardListArray, function (rec) {
            return rec._id == cardId;
        });
        if (subjectId && sessionId && curriculumId && xClassId && cardId && batchId && schoolId) {
            var activityCondition = {
                subject_id: subjectId,
                session_id: sessionId,
                curriculum_id: curriculumId,
                class_id: xClassId,
                batch_id: batchId,
                school_id: schoolId
            };
            var page = false;
            var toServer = {
                cardId: cardId,
                conditions: activityCondition,
                page: page,
                isFromListingPage: true,
                re_generateFlag: false,
                fromCt: false,
                fromView: true,
                passedYear: self.selected_year
            };
            authService.callAPI("/v0/reportcards/teacher/validation", "POST", { args: toServer }, function (response) {
                try {
                    if (!response.error) {
                        var result = response.result.data.details;
                        verifyData(result, cardId);
                    } else {
                        if (response.error.error && response.error.error.error) {
                            toastr.error(response.error.error.error);
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            });
        }
    };

    self.viewActivities = function (cardId, report_data_id, card) {
        var activityCondition = {
            "subject_id": subjectId,
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": xClassId,
            "batch_id": batchId,
            "school_id": schoolId
        };
        var toServer = {
            cardId: cardId,
            report_data_id: report_data_id,
            acdCondition: activityCondition
        };
        authService.callAPI("/v0/reportcards/teacher/viewActivitiesRc", "POST", { args: toServer }, function (response) {
            if (response.result) {
                var data = response.result.data.details.response;
                if (data && data.buckets.length) {
                    $mdDialog.show({
                        controller: ['$scope', '$mdDialog', 'data', validationCtrl],
                        locals: {
                            "data": data

                        },
                        template: _reportCardValidationPopup2.default,
                        parent: angular.element(document.body),
                        clickOutsideToClose: true
                    });
                }
            }
        });
    };

    function kgReportCheck(console_id) {
        var st = "Are you sure you want to proceed ?";
        var confirm = $mdDialog.confirm().title(st).ok("Generate").cancel("Cancel");
        $mdDialog.show(confirm).then(function () {
            var reqObj = {
                session: sessionId,
                curriculum: curriculumId,
                class: xClassId,
                batch: batchId,
                subject: subjectId,
                school_id: schoolId,
                academic_year: activeAcd,
                report_console_id: console_id
            };
            $scope.loading = true;
            authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_AUTO_GENERATE_KG_REPORT, 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    var reqArr = [];
                    _.each(response.result.data.details, function (data) {
                        reqArr.push({
                            aliace: data.bucket.db_key,
                            db_key: data.bucket.db_key,
                            list: [{
                                activity_name: data.mark_entry_details.exam,
                                activity_id: data.mark_entry_details._id,
                                created_by: userId,
                                type: "activities"
                            }],
                            // max_mark: data.bucket.max_mark,
                            max_mark: 100,
                            name: data.bucket.name,
                            selection: "best"
                        });
                    });
                    var activityCondition = {
                        subject_id: subjectId,
                        session_id: sessionId,
                        curriculum_id: curriculumId,
                        class_id: xClassId,
                        batch_id: batchId,
                        school_id: schoolId
                    };
                    var _reqObj2 = {
                        args: {
                            cardId: console_id,
                            valuesUnderSkills: reqArr,
                            activityCondition: activityCondition,
                            dataId: false,
                            re_generateFlag: false,
                            fromCt: false,
                            select_regen: false,
                            get_students_selected: [],
                            myUserId: userId
                        }
                    };
                    authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', _reqObj2, function (response) {
                        try {
                            if (response.error && response.error.error == "Already generated the report!") {
                                toastr.error(response.error.error);
                            } else {
                                var result = response.result.data.details.response;
                                if (result) {
                                    toastr.success("Auto Generated the report");
                                    if (result._id._id) {
                                        $state.go('viewGeneratedReportData', {
                                            dataId: result._id._id,
                                            selected_year: activeAcd,
                                            is_edit: false
                                        });
                                    } else {
                                        $state.go('viewGeneratedReportData', {
                                            dataId: result._id,
                                            selected_year: activeAcd,
                                            is_edit: false
                                        });
                                    }
                                }
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    });
                } else if (response.error && response.error.error && response.error.error.message) {
                    $scope.loading = false;
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Alert!').textContent(response.error.error.message).ariaLabel('Alert Dialog Demo').ok('OK'));
                }
            });
        });
    }

    function pushLog() {
        var userId = localStorageService.get('user_id');
        var schoolId = localStorageService.get('school_id');
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userId + "/" + schoolId + "/reportCardTeacherList", "GET", {}, function (response) {
            // console.log(response)
        });
    }

    function mainReportCheck(console_id) {
        var st = "Are you sure you want to proceed ?";
        var confirm = $mdDialog.confirm().title(st).ok("Generate").cancel("Cancel");
        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            var reqObj = {
                session: sessionId,
                curriculum: curriculumId,
                class: xClassId,
                batch: batchId,
                subject: subjectId,
                school_id: schoolId,
                academic_year: activeAcd,
                report_console_id: console_id
            };
            authService.callAPI("/v0/reportcards/teacher/main/autogenerate", 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    var reqArr = [];
                    _.each(response.result.data.details, function (data) {
                        if (data && data.bucket) {
                            reqArr.push({
                                aliace: data.bucket.aliace,
                                db_key: data.bucket.db_key,
                                list: [{
                                    activity_name: data.markEntryDetail.exam,
                                    activity_id: data.markEntryDetail._id,
                                    created_by: userId,
                                    type: "activities"
                                }],
                                max_mark: data.bucket.max_mark,
                                // max_mark: 100,
                                name: data.bucket.name,
                                selection: "best"
                            });
                        } else {
                            reqArr.push({

                                list: [{
                                    activity_name: data.markEntryDetail.exam,
                                    activity_id: data.markEntryDetail._id,
                                    created_by: userId,
                                    type: "activities"
                                }],

                                selection: "best"
                            });
                        }
                    });
                    var activityCondition = {
                        subject_id: subjectId,
                        session_id: sessionId,
                        curriculum_id: curriculumId,
                        class_id: xClassId,
                        batch_id: batchId,
                        school_id: schoolId
                    };
                    var _reqObj3 = {
                        args: {
                            cardId: console_id,
                            valuesUnderSkills: reqArr,
                            activityCondition: activityCondition,
                            dataId: false,
                            re_generateFlag: false,
                            fromCt: false,
                            select_regen: false,
                            get_students_selected: [],
                            myUserId: userId
                        }
                    };

                    authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', _reqObj3, function (response) {
                        try {
                            if (response.error && response.error.error == "Already generated the report!") {
                                toastr.error(response.error.error);
                            } else {
                                var result = response.result.data.details.response;
                                if (result) {
                                    toastr.success("Auto Generated the report");
                                    if (result._id._id) {
                                        $state.go('viewGeneratedReportData', {
                                            dataId: result._id._id,
                                            selected_year: activeAcd,
                                            is_edit: false
                                        });
                                    } else {
                                        $state.go('viewGeneratedReportData', {
                                            dataId: result._id,
                                            selected_year: activeAcd,
                                            is_edit: false
                                        });
                                    }
                                }
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    });
                } else if (response.error && response.error.error && response.error.error.message) {
                    $scope.loading = false;
                    $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Alert!').textContent(response.error.error.message).ariaLabel('Alert Dialog Demo').ok('OK'));
                }
            });
        }, function () {});
    }
};
ReportCardListingCtrl.$inject = ["$scope", "$state", "$mdDialog", "authService", "localStorageService", "$rootScope", "MARK_ENTRY_SAVE_CONSTANTS"];

var validationCtrl = function validationCtrl($scope, $mdDialog, data) {
    _classCallCheck(this, validationCtrl);

    $scope.data = data;
    $scope.cancel = function () {
        $mdDialog.cancel();
        $mdDialog.hide();
    };
};

exports.default = ReportCardListingCtrl;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportCardValidationPopup = __webpack_require__(895);

var _reportCardValidationPopup2 = _interopRequireDefault(_reportCardValidationPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportCardGenConsoleCtrl = function ReportCardGenConsoleCtrl($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, authService, localStorageService, setAndSelectStudentRc, $rootScope, RC_CONSTANTS_) {
    'ngInject';

    _classCallCheck(this, ReportCardGenConsoleCtrl);

    var self = this;
    var authoring = localStorageService.get('authoringData');
    var sessionData = localStorageService.get('authoringData');
    var activeAcd = localStorageService.get('academic_year');
    var subjectId = sessionData.subject_id;
    var xClassId = sessionData.class_id;
    var curriculumId = sessionData.curriculum_id;
    var batchId = sessionData.batch_id;
    var sessionId = sessionData.session_id;
    var templateCardId = $stateParams.cardId;
    var re_generate = $stateParams.re_generate ? $stateParams.re_generate : false;
    var dataId = $stateParams.dataId ? $stateParams.dataId : false;
    var fromCt = $stateParams.fromCt ? $stateParams.fromCt : false;
    $scope.copyOfActivities = [];
    $scope.get_students_selected = setAndSelectStudentRc.get_students_selected();

    if (subjectId && xClassId && curriculumId && sessionId && batchId && templateCardId) {
        var activityCondition = {
            "subject_id": subjectId,
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": xClassId,
            "batch_id": batchId,
            "school_id": sessionData.school_id
        };
        if (fromCt != "false") {
            var cTData = localStorageService.get('cTregen');
            activityCondition = {
                "subject_id": cTData.subject_id,
                "session_id": cTData.session_id,
                "curriculum_id": cTData.curriculum_id,
                "class_id": cTData.class_id,
                "batch_id": cTData.batch_id,
                "school_id": cTData.school_id
            };
        }
        var obj = {
            cardId: templateCardId,
            activityCondition: activityCondition,
            page: true,
            re_generate: re_generate,
            fromCt: fromCt,
            activeAcd: activeAcd,
            get_students_selected: $scope.get_students_selected,
            my_user_id: localStorageService.get('user_id'),
            regenarateFlag: re_generate
        };
        this.$onInit = function () {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, { reload: true });
            }
            pushLog();
        };
        authService.callAPI("/v0/reportcards/teacher/genration", "POST", { args: obj, subject_id: authoring.subject_id }, function (response) {

            var result = response.result.data.details.response;
            if (result && result.report_template && result.activities) {
                if (result.redirectList) {
                    //not to show console page again while clicking back button;redirects to listing page
                    $state.go('reportCardListing');
                }
                var templateCard = result.report_template;
                $scope.templateCard = templateCard;
                var activities = result.activities;
                var activityKeys = Object.keys(activities);
                var arrayActivity = [];
                _.each(activityKeys, function (activityType) {
                    var obj = {
                        name: activityType,
                        type: activityType.toLowerCase(),
                        list: activities[activityType]
                    };
                    arrayActivity.push(obj);
                });
                $scope.activities = arrayActivity;
                // _.each(templateCard.activity_buckets, function(each) {
                //     _.each(each.sub_skills, function(sub) {
                //         sub.list = [];
                //     });
                // });
                $scope.activities[0].showItem = true;
                $scope.selectedactivities = templateCard.activity_buckets;
                $scope.have_sub_skill = templateCard.have_skill_subskill_format;
                if ($scope.have_sub_skill) {
                    if (templateCard.skill_only) {
                        $scope.skill_only = true;
                    }
                    _.each($scope.selectedactivities, function (curData, key) {
                        if (curData.sub_skills) {
                            _.each(curData.sub_skills, function (data, key) {
                                data.selection = "best";
                                data.list = [];
                            });
                        } else {
                            if (templateCard.skill_only) {
                                curData.list = [];
                                curData.selection = "best";
                            }
                        }
                    });
                } else {
                    _.each($scope.selectedactivities, function (curData, key) {
                        curData.selection = "best";
                    });
                }
            }

            _.defer(function () {
                $scope.$apply();
            });;
        });
    }
    self.showItem = function (data) {

        _.each($scope.activities, function (curData, key) {
            if (curData != data) {
                curData.showItem = false;
            }
        });
        data.showItem = true;
    };

    self.showSelectedItem = function (data) {

        _.each($scope.selectedactivities, function (curData, key) {

            curData.showItem = false;
            _.each(curData.sub_skills, function (data, key) {
                data.isdisplay = false;
            });
        });
        data.showItem = true;
    };
    self.flagdata = function (data) {
        _.each($scope.selectedactivities, function (curData, key) {

            curData.showItem = true;
            _.each(curData.sub_skills, function (data, key) {
                data.isdisplay = false;
            });
        });
    };

    self.flagNoSkill = function () {
        $scope.showItem = true;
    };
    self.showMore = function (activity, item) {
        /* $scope.selectedactivities.*/

        _.find($scope.selectedactivities, function (data) {
            if (activity == data) {
                activity.showItem = false;
                _.find(activity.sub_skills, function (data1) {
                    /*if (data1.list.length > 1) {
                      data1.selection = "best";
                     }*/
                    if (data1 == item) {
                        data1.isdisplay = true;
                    }
                });
            }
        });
    };

    self.showNoSkill = function (activity) {
        /* $scope.selectedactivities.*/
        $scope.showItem = false;
        _.find($scope.selectedactivities, function (data) {
            if (activity == data) {
                activity.showItem = true;
                /*if (data.list.length > 1)
                {
                    data.selection = "best";
                  } */
            }
        });
    };

    self.closed = function (activity) {
        activity.showItem = false;
        $scope.showItem = true;
    };
    self.close = function (activity, item) {
        activity.showItem = true;
        item.isdisplay = false;
    };

    self.openMenu = function ($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
    };
    self.deleteSession = function (item, data) {
        _.each($scope.activities, function (curData, key) {
            if (curData.type == data.type) {
                curData.list.push(data);
            }
        });
        item.list = _.without(item.list, data);

        if (item.list.length < 1) {
            data.selection = undefined;
        }
    };
    self.deleteSessions = function (item, data) {

        _.each($scope.activities, function (curData, key) {

            if (curData.type == data.type) {
                curData.list.push(data);
            }
        });
        item.list = _.without(item.list, data);

        if (item.list.length < 1) {
            data.selection = undefined;
        }
    };
    self.dragControlListeners = {
        //optional param
        containment: '#sortable-container'
    };
    function showErrorOnDrag() {
        if ($scope.templateCard && $scope.templateCard.no_conversion) {
            return true;
        }
        return false;
    }
    self.sortableCloneOptions1 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        dragEnd: function dragEnd(event) {},
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            var allow = true;
            var noMoreActivities = showErrorOnDrag();
            if (destSortableScope.$parent && destSortableScope.$parent.activity && destSortableScope.$parent.activity.list && destSortableScope.$parent.activity.list.length) {
                if (noMoreActivities) {
                    allow = false;
                    toastr.error("Sorry, Only one entry is possible to add");
                }
            }
            return allow;
        }

    };
    self.makeReportCard = function (ev) {
        $scope.errorarray = [];
        $scope.validationArray = [];
        if ($scope.have_sub_skill) {
            _.each($scope.selectedactivities, function (curData, key) {
                if (curData.sub_skills) {
                    _.each(curData.sub_skills, function (data, key) {
                        if (data.list.length <= 0) {
                            var _obj = {
                                skill_name: curData.name,
                                sub_skill: data.name
                            };
                            $scope.validationArray.push(_obj);
                            $scope.errorarray.push(data.name + " under " + curData.name + " contains no elements");
                        }
                    });
                } else {
                    _.each($scope.selectedactivities, function (curData, key) {
                        if (curData.list.length <= 0) {
                            var _obj2 = {
                                skill_name: curData.name
                            };
                            $scope.validationArray.push(_obj2);
                            $scope.errorarray.push(curData.name + " contains no elements");
                        }
                    });
                }
            });
        } else {
            _.each($scope.selectedactivities, function (curData, key) {
                if (curData.list.length <= 0) {
                    var _obj3 = {
                        skill_name: curData.name
                    };
                    $scope.validationArray.push(_obj3);
                    $scope.errorarray.push(curData.name + " contains no elements");
                }
            });
        }
        var errorString = $scope.errorarray.join();
        errorString = errorString.replace(/,/gi, "\n").replace(/^,/, "");
        /*alert(errorString)*/
        if ($scope.errorarray.length > 0) {
            // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'validationData', validationCtrl],
                locals: {
                    "validationData": $scope.validationArray

                },
                template: _reportCardValidationPopup2.default,
                parent: angular.element(document.body),
                clickOutsideToClose: true
                // fullscreen: useFullScreen
            });
            return false;
        }
        // if ($scope.errorarray.length === 0) {
        if (activityCondition) {
            activityCondition['batch_id'] = batchId;
            if (fromCt == "true") {
                var _cTData = localStorageService.get('cTregen');
                activityCondition = {
                    "subject_id": _cTData.subject_id,
                    "session_id": _cTData.session_id,
                    "curriculum_id": _cTData.curriculum_id,
                    "class_id": _cTData.class_id,
                    "batch_id": _cTData.batch_id,
                    "school_id": _cTData.school_id,
                    academic_year: activeAcd
                };
            }
            // console.log(activityCondition)
            var select_regen = false;
            if (re_generate && fromCt && $scope.get_students_selected && $scope.get_students_selected.length) {
                select_regen = true;
            }
            var passObj = {
                cardId: templateCardId,
                valuesUnderSkills: $scope.selectedactivities,
                activityCondition: activityCondition,
                dataId: dataId,
                re_generateFlag: re_generate,
                fromCt: fromCt,
                select_regen: select_regen,
                get_students_selected: $scope.get_students_selected ? $scope.get_students_selected : [],
                myUserId: localStorageService.get('user_id')
            };
            console.log(passObj);
            // return false
            $scope.loading = true;
            authService.callAPI("/v0/reportcards/teacher/start", "POST", { args: passObj }, function (response) {
                $scope.loading = false;
                try {
                    if (response.error && response.error.error == "Already generated the report!") {
                        toastr.error(response.error.error);
                        $state.go('reportCardListing');
                    } else {

                        var result = response.result.data.details.response;
                        console.log(result, "ersuluuuuuuuuuuuuuuuuuuuuu");

                        if (result) {
                            toastr.success("Generated the report");
                            if (re_generate == 'true') {
                                $state.go('viewGeneratedReportData', {
                                    "dataId": result._id,
                                    "selected_year": activeAcd,
                                    is_edit: false
                                });
                            } else {
                                if (result._id._id) {
                                    $state.go('viewGeneratedReportData', {
                                        "dataId": result._id._id,
                                        "selected_year": activeAcd,
                                        is_edit: false
                                    });
                                } else {
                                    $state.go('viewGeneratedReportData', {
                                        "dataId": result._id,
                                        "selected_year": activeAcd,
                                        is_edit: false
                                    });
                                }
                            }
                        }
                    }
                } catch (e) {
                    console.log(e);
                    $scope.loading = false;
                }
            });
        }
    };
    function pushLog() {
        var userId = localStorageService.get('user_id');
        var schoolId = localStorageService.get('school_id');
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userId + "/" + schoolId + "/reportCardGenerationView", "GET", {}, function (response) {
            // console.log(response)
        });
    }
};
ReportCardGenConsoleCtrl.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "authService", "localStorageService", "setAndSelectStudentRc", "$rootScope", "RC_CONSTANTS_"];

var validationCtrl = function validationCtrl($scope, $mdDialog, validationData) {
    _classCallCheck(this, validationCtrl);

    var skillsArray = _.pluck(validationData, "skill_name");
    skillsArray = _.compact(skillsArray);
    var noValidArray = [];
    _.each(skillsArray, function (doc) {
        var filterSkill = _.filter(validationData, function (each) {
            return each.skill_name == doc;
        });
        var pluckSubSkills = _.pluck(filterSkill, "sub_skill");
        pluckSubSkills = _.compact(pluckSubSkills);
        if (filterSkill.length) {
            var obj = {
                skill_name: doc,
                sub_skill: pluckSubSkills
            };
            noValidArray.push(obj);
        }
    });

    noValidArray = _.uniq(noValidArray, false, function (p) {
        return p.skill_name;
    });
    $scope.validationArray = noValidArray;

    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.answer = function (answer) {
        $mdDialog.hide(answer);
    };
};

exports.default = ReportCardGenConsoleCtrl;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _select_regen = __webpack_require__(896);

var _select_regen2 = _interopRequireDefault(_select_regen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/controllers/approveReportsController.js
                                                                                                                                                           * Project: /home/cordova03/projects/educore_3.5
                                                                                                                                                           * Created Date: Monday, December 10th 2018, 12:11:19 pm
                                                                                                                                                           * Author: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Last Modified: Mon Dec 10 2018
                                                                                                                                                           * Modified By: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var ReportCardClassTeacher = function ReportCardClassTeacher($scope, $rootScope, authService, localStorageService, $state, setAndSelectStudentRc, $mdDialog, MARK_ENTRY_SAVE_CONSTANTS) {
  'ngInject';

  _classCallCheck(this, ReportCardClassTeacher);

  var self = this;
  var academicSub = undefined;
  var cTReport = undefined;
  $scope.view_only = true;
  $rootScope.title = "Class Teacher View";
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, { reload: true });
    }
    pushLog();
  };
  // if(menuHeaderService && menuHeaderService.authMenu){
  //   $scope.view_only = true
  // }
  // $rootScope.Title("Class Teacher View")
  // self.noAction = false
  var authoring = localStorageService.get('authoringData');
  var subjectDataRegister = localStorageService.get('subjectDataRegister');
  var from_authoring = localStorageService.get('from_authoring');
  var studentRcData = localStorageService.get('studentRcData');
  // Session.clear('subjectDataRc')
  // $scope.loading = true
  var settingsDocs = [];
  var school_id = localStorageService.get('school_id');
  var activeAcd = localStorageService.get('activeAcdYear');
  activeAcd = localStorageService.get('academic_year');
  var school_years = localStorageService.get('school_years');
  var school_yearsAlt = localStorageService.get('school_acdy');
  var userId = localStorageService.get('school_id');
  $scope.filterObj = {};
  var thisSchoolId = school_id;
  var filterThru = localStorageService.get('can_filter');
  if (filterThru == "true") {
    filterThru = true;
  } else {
    filterThru = undefined;
  }
  var subjectDataRc = localStorageService.get('subjectDataRc');
  function setRcBelow(firstSubject, generatedData) {

    self.generatedData = _.filter(generatedData, function (one) {

      return one.academic_details.subject_id == firstSubject;
    });
  }

  this.$onDestroy = function () {
    if (academicSub) academicSub.stop();
    if (cTReport) cTReport.stop();
  };

  // initLoad(authoring, activeAcd)
  function setData(result, authoring, school_yearsArray) {

    self.subjects = result.subjects;
    var generatedData = result.subjectRcs;
    self.allGeneratedData = result.subjectRcs;
    var firstSubject = undefined;
    var authSubEx = 0;
    if (authoring.subject_id || !subjectDataRc) {
      _.each(self.subjects, function (subjectObj) {

        if (subjectObj._id == authoring.subject_id) {
          authSubEx++;
          subjectObj.toBeHighLighted = true;
        } else {
          subjectObj.toBeHighLighted = false;
        }
      });
      if (authSubEx > 0) {
        firstSubject = authoring.subject_id;
      } else {
        if (result.subjects && result.subjects.length) {
          firstSubject = result.subjects[0]._id;
          result.subjects[0].toBeHighLighted = true;
        }
      }
    } else if (subjectDataRc && subjectDataRc.subjectId) {
      //not subjects endoresed
      _.each(self.subjects, function (subjectObj) {
        var sEx = 0;
        if (subjectObj._id == subjectDataRc.subjectId) {

          subjectObj.toBeHighLighted = true;
        } else {
          subjectObj.toBeHighLighted = false;
        }
      });
      firstSubject = subjectDataRc.subjectId;
    } else {
      if (result.subjects && result.subjects.length) {
        firstSubject = result.subjects[0]._id;
        result.subjects[0].toBeHighLighted = true;
      }
    }
    $scope.loading = false;
    setscYears(school_yearsArray);
    setRcBelow(firstSubject, generatedData);
  }
  function getYearThenConditions() {
    var cond = undefined;
    if (localStorageService.get('academicYearRc')) {
      self.selected_year = localStorageService.get('academicYearRc');
    } else {
      self.selected_year = activeAcd;
    }
    if (!self.selected_year) {
      self.selected_year = "2018-2019";
    }
    if (subjectDataRegister) {
      cond = subjectDataRegister;
    } else {
      cond = authoring;
    }
    initLoad(cond, self.selected_year);
    setNoAction(self.selected_year);
  }
  getYearThenConditions();

  function initLoad(authoring, selectedYear) {
    var loadObj = {
      authoring: authoring,
      activeAcd: selectedYear,
      school_id: school_id
    };
    authService.callAPI("/v0/reportcards/classteacher/list", "POST", { args: loadObj }, function (response) {
      console.log(response.result.data.details.response);
      self.userList = _.filter(response.result.data.details.response.users, function (u) {
        return u.user_name;
      });
      setData(response.result.data.details.response.docs, authoring, response.result.data.details.response.school_years);
      _.defer(function () {
        $scope.$apply();
      });
    });
  }
  $scope.goToSubjectRcs = function (subject_id, subjectname) {
    self.generatedData = _.filter(self.allGeneratedData, function (one) {
      return one.academic_details.subject_id == subject_id;
    });
    _.each(self.subjects, function (subject) {
      if (subject._id == subject_id) {
        subject.toBeHighLighted = true;
      } else {
        subject.toBeHighLighted = false;
      }
    });
    localStorageService.set({
      subjectDataRc: {
        subjectId: subject_id,
        subjectName: subjectname
      }
    });
    var obj = {
      session_id: authoring.session_id,
      curriculum_id: authoring.curriculum_id,
      class_id: authoring.class_id,
      batch_id: authoring.batch_id,
      subject_id: authoring.subject_id,
      school_id: authoring.school_id,
      year_selected: self.selected_year
    };
    localStorageService.set({
      subjectDataRegister: obj
    });
  };
  var schoolid = localStorageService.get('school_id');
  var toServer = {
    school_id: schoolid
  };
  authService.callAPI("/v0/reportcards/classteacher/init", "POST", { args: toServer }, function (response) {
    console.log(response);
  });
  function setscYears(response) {
    if (!self.scData) {
      self.scData = response;
    }
  }
  function setNoAction(passedYear) {
    console.log(passedYear + '!=' + activeAcd);
    if (passedYear != activeAcd) {
      self.noAction = false;
    } else {
      self.noAction = true;
    }
  }
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    if (fromState.name === "studentListingForReports") {
      $mdDialog.cancel();
    }
  });
  $scope.setSessionFilters = function (filterObj) {
    if (!$scope.filterObj) {
      $scope.filterObj = {};
    }
    if ($scope.filterObj.curriculum) {
      delete $scope.filterObj.curriculum;
    }
    if ($scope.filterObj.templates) {
      delete $scope.filterObj.templates;
    }if ($scope.filterObj.xclass) {
      delete $scope.filterObj.xclass;
    }
    Meteor.call('curriculumFiterRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function (error, result) {
      if (result) {
        self.curriculumArray = [];
        self.curriculumArray = result;
      }
      $scope.loading = false;
      _.defer(function () {
        $scope.$apply();
      });
    });
  };
  self.getClass = function (filterObj) {
    $scope.filterObj['curriculum'] = filterObj;

    Meteor.call('classFiterRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function (error, result) {
      if (result) {
        self.classArray = result;
      }
      $scope.loading = false;
      _.defer(function () {
        $scope.$apply();
      });
    });
  };
  self.selectBatches = function (filterObj) {
    $scope.filterObj['xclass'] = filterObj;
    $scope.filterObj['batch_id'] = undefined;
    $scope.filterObj['subject_id'] = undefined;

    Meteor.call('batchFiterRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function (error, result) {
      if (result) {
        self.batchArray = result.batchArray;
      }
      $scope.loading = false;
      _.defer(function () {
        $scope.$apply();
      });
    });
  };
  self.selectSubjects = function (filterObj) {
    $scope.filterObj['batch_id'] = filterObj;
    $scope.filterObj['subject_id'] = undefined;
    self.subjectArray = undefined;

    Meteor.call('getSubjectRc', $scope.filterObj, thisSchoolId, filterThru, activeAcd, function (error, result) {
      if (result) {
        if (!filterThru) {
          self.subjectArray = result.selection.subjectArray;
        } else {
          self.subjectArray = result.subjects;
        }
      } else {
        if (error) {

          toastr.error(error.reason);
        }
      }
      $scope.loading = false;
      _.defer(function () {
        $scope.$apply();
      });
    });
  };
  function getAuthoringData(authoring) {
    if (!authoring) {
      authoring = {};
    }
    if (!authoring.session_id) {
      authoring.session_id = $scope.filterObj.session;
    }
    if (!authoring.curriculum_id) {
      authoring.curriculum_id = $scope.filterObj.curriculum;
    }
    if (!authoring.class_id) {
      authoring.class_id = $scope.filterObj.xclass;
    }
    if (!authoring.batch_id) {
      authoring.batch_id = $scope.filterObj.batch_id;
    }
    if (!authoring.subject_id) {
      authoring.subject_id = $scope.filterObj.subject_id;
    }
    if (!authoring.school_id) {
      authoring.school_id = thisSchoolId;
    }

    return authoring;
  }
  function getSettingsName(authoring) {
    if (settingsDocs && settingsDocs.length) {
      if (!authoring.session && authoring.session_id) {
        var res = _.find(settingsDocs, function (oneObj) {
          return oneObj._id == authoring.session_id;
        });
        if (res) {
          authoring.session = res.name;
        }
      }
      if (!authoring.curriculum && authoring.curriculum_id) {
        var _res = _.find(settingsDocs, function (oneObj) {
          return oneObj._id == authoring.curriculum_id;
        });
        if (_res) {
          authoring.curriculum = _res.name;
        }
      }
      if (!authoring.class && authoring.class_id) {
        var _res2 = _.find(settingsDocs, function (oneObj) {
          return oneObj._id == authoring.class_id;
        });
        if (_res2) {
          authoring.class = _res2.name;
        }
      }
      if (!authoring.batch && authoring.batch_id) {
        var _res3 = _.find(settingsDocs, function (oneObj) {
          return oneObj._id == authoring.batch_id;
        });
        if (_res3) {
          authoring.batch = _res3.name;
        }
      }
      if (!authoring.subject && authoring.subject_id) {
        var _res4 = _.find(settingsDocs, function (oneObj) {
          return oneObj._id == authoring.subject_id;
        });
        if (_res4) {
          authoring.subject = _res4.name;
        }
      }
    }

    return authoring;
  }
  $scope.goToSubjectReport = function (subjectId, subjectName, fromSession) {
    setscYears();
    setNoAction(self.selected_year);
    $scope.loading = true;
    // return false
    localStorageService.set({
      subjectDataRc: {
        subjectId: subjectId,
        subjectName: subjectName
      }
    });

    authoring = getAuthoringData(authoring);
    authoring = getSettingsName(authoring);
    var obj = {
      session_id: authoring.session_id,
      curriculum_id: authoring.curriculum_id,
      class_id: authoring.class_id,
      batch_id: authoring.batch_id,
      subject_id: authoring.subject_id,
      school_id: authoring.school_id,
      year_selected: self.selected_year
    };
    if (authoring.session) {
      obj.session = obj.session;
    }
    if (authoring.curriculum) {
      obj.curriculum = obj.curriculum;
    }
    if (authoring.class) {
      obj.class = obj.class;
    }
    if (authoring.batch) {
      obj.batch = obj.batch;
    }
    if (authoring.subject) {
      obj.subject = obj.subject;
    }
    localStorageService.set({
      subjectDataRegister: obj
    });
    var dontMiss = localStorageService.get("subjectDataRegister");
    if (dontMiss && fromSession) {
      if (!authoring.session_id) {
        authoring.session_id = dontMiss.session_id;
      }
      if (!authoring.curriculum_id) {
        authoring.curriculum_id = dontMiss.curriculum_id;
      }
      if (!authoring.class_id) {
        authoring.class_id = dontMiss.class_id;
      }
      if (!authoring.batch_id) {
        authoring.batch_id = dontMiss.batch_id;
      }
      if (!authoring.batch_id) {
        authoring.subject_id = dontMiss.subject_id;
      }
    }

    Meteor.call('getReportCardForThisSubject', authoring, subjectId, self.selected_year, function (err, res) {
      if (res) {
        self.generatedData = res.data;
        if (res.existingDataSubjectIds && !fromSession) {
          _.each(self.subjects, function (subjectObj) {
            if (subjectObj._id == res.existingDataSubjectIds) {
              subjectObj.toBeHighLighted = true;
            } else {
              subjectObj.toBeHighLighted = false;
            }
          });
        }
      }
      if (fromSession && res && res.existingDataSubjectIds) {
        loadPage(true, res.existingDataSubjectIds, self.selected_year);
      }
      $scope.loading = false;
      _.defer(function () {
        $scope.$apply();
      });;
    });
  };
  function initialLoad() {

    Meteor.call('getSchoolDataYear', thisSchoolId, function (err, scd) {
      if (scd) {
        self.scData = scd.academic_year;

        var acdYear = _.find(scd.academic_year, function (oneY) {
          return oneY.status == 'active';
        });
        if (acdYear) {
          if (Session.get('academicYearRc')) {
            self.selected_year = localStorageService.get('academicYearRc');
          } else {
            self.selected_year = acdYear.year;
          }
          if (subjectDataRc) {
            console.log('>>>>>>>>>>>');
            // $scope.goToSubjectReport(subjectDataRc.subjectId, subjectDataRc.subjectName, true)
          } else {
            console.log('<<<<<<<<<<<<');
            loadPage(false, null, self.selected_year);
          }
        }
      }
    });
  }
  self.searchValuesBasedOnFilter = function () {
    initialLoad();
  };

  self.listRcWithSelectedYear = function (selected_year) {
    self.subjects = [];
    console.log(self.selected_year);
    self.selected_year = selected_year;
    localStorageService.remove('subjectDataRc');
    self.generatedData = [];
    $scope.loading = true;
    localStorageService.set({
      academicYearRc: selected_year
    });

    initLoad(authoring, selected_year);
    // loadPage(false, null, selected_year)
  };

  function loadPage(fromSession, existingDataSubjectId, selected_year) {
    setscYears();
    if (!selected_year) {
      selected_year = self.selected_year;
    }
    setNoAction(selected_year);
    authoring = getAuthoringData(authoring);
    if (!authoring) {
      toastr.error("Please check academic selection!");
      return false;
    }
    if (!authoring.session_id) {
      toastr.error("Please check academic session!");
      return false;
    }
    if (!authoring.curriculum_id) {
      toastr.error("Please check academic curriculum!");
      return false;
    }
    if (!authoring.class_id) {
      toastr.error("Please check academic class!");
      return false;
    }
    if (!authoring.batch_id) {
      toastr.error("Please check academic batch!");
      return false;
    }
    if (!authoring.subject_id) {
      toastr.error("Please check academic subject!");
      return false;
    }
  }
  self.viewTemplate = function (id) {
    $state.go('viewGeneratedReportData', {
      "dataId": id,
      "isClassTeacher": true,
      selected_year: self.selected_year,
      is_edit: false
    });
  };

  $scope.goToStudentReports = function (user_id, user_name) {
    localStorageService.set({
      studentRcData: {
        user_id: user_id,
        user_name: user_name
      }
    });
    localStorageService.set("classTeacherRole", true);
    $state.go('publishedReports', {
      "student_id": user_id,
      fee_status: true
    });
  };

  $scope.regenerateByCt = function (card) {
    var cardId = card.report_console_id;
    var reportDataId = card._id;
    var academics = card.academic_details;
    localStorageService.set({
      cTregen: {
        session_id: academics.session_id,
        curriculum_id: academics.curriculum_id,
        class_id: academics.class_id,
        batch_id: academics.batch_id,
        subject_id: academics.subject_id,
        school_id: authoring.school_id
      }
    });
    // console.log(Session.get('cTregen'))
    $state.go('reportCardGenConsole', {
      "cardId": cardId,
      "dataId": reportDataId,
      "re_generate": true,
      "fromCt": true
    });
  };
  $scope.selectRegen = function (card) {
    // console.log(authoring)
    var cardId = card.report_console_id;
    var reportDataId = card._id;
    var academics = card.academic_details;
    // Session.set({
    //      cTregen: {
    //          session_id: academics.session_id,
    //          curriculum_id: academics.curriculum_id,
    //          class_id: academics.class_id,
    //          batch_id: academics.batch_id,
    //          subject_id: academics.subject_id,
    //          school_id: authoring.school_id
    //      }
    //  })
    var acd = {
      session_id: academics.session_id,
      curriculum_id: academics.curriculum_id,
      class_id: academics.class_id,
      batch_id: academics.batch_id,
      subject_id: academics.subject_id,
      school_id: authoring.school_id
    };
    if (self.userList) {
      // console.log(res)
      // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
      $mdDialog.show({
        template: _select_regen2.default,
        controller: ['$scope', '$mdDialog', 'list', '$state', 'parentScopeObj', 'card', 'authoring', 'setAndSelectStudentRc', 'localStorageService', StudentsCtrl],
        parent: angular.element(document.body),
        locals: {
          list: self.userList,
          parentScopeObj: $scope,
          card: card,
          authoring: authoring,
          setAndSelectStudentRc: setAndSelectStudentRc,
          localStorageService: localStorageService
        },
        clickOutsideToClose: true,
        fullscreen: true
      }).then(function () {}, function () {
        $scope.status = 'You cancelled the dialog.';
      });
    }
    //  Meteor.call('getStudentsThisclass', acd,function(er, res){
    //             // make dialog popup here
    //   if(res){
    //       // console.log(res)
    //       // var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
    //       $mdDialog.show({
    //           templateUrl: templatePop,
    //           controller: ['$scope', '$mdDialog', 'list', '$state', 'parentScopeObj' ,'card','authoring','setAndSelectStudentRc', StudentsCtrl],
    //           parent: angular.element(document.body),
    //           locals: {
    //               list: res,
    //               parentScopeObj: $scope,
    //               card : card,
    //               authoring:authoring,
    //           },
    //           clickOutsideToClose: true,
    //           fullscreen: true
    //       })
    //       .then(function() {

    //       }, function() {
    //           $scope.status = 'You cancelled the dialog.';
    //       });
    //   }
    //   _.defer(function() { $scope.$apply(); });;
    // })
  };
  $scope.navigateToDownload = function () {
    $state.go('multipleReportsSelectionCtrl', {});
  };
  function pushLog() {
    var userIds = localStorageService.get('user_id');
    var schoolIds = localStorageService.get('school_id');
    authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userIds + "/" + schoolIds + "/studentReportListing", "GET", {}, function (response) {
      // console.log(response)
    });
  }
  self.syncReportCard = function (card) {
    console.log(card);
    if (!card.mark_entry_updated) {
      toastr.success('Report Card is already up to date with the latest mark entry');
      return;
    }
    mainReportCheck(card);
  };
  function mainReportCheck(card) {
    var st = "Are you sure you want to sync the report card with latest mark entry?";
    var confirm = $mdDialog.confirm().title(st).ok("Yes").cancel("No");
    $mdDialog.show(confirm).then(function () {
      $scope.loading = true;
      var reqObj = {
        session: card.academic_details.session_id,
        curriculum: card.academic_details.curriculum_id,
        class: card.academic_details.class_id,
        batch: card.academic_details.batch_id,
        subject: card.academic_details.subject_id,
        school_id: card.report_card_header.school_id,
        academic_year: card.report_card_header.academic_year,
        report_console_id: card.report_console_id
      };
      authService.callAPI("/v0/reportcards/teacher/main/autogenerate", 'POST', reqObj, function (response) {
        if (response.result && response.result.data && response.result.data.details) {
          var reqArr = [];
          _.each(response.result.data.details, function (data) {
            reqArr.push({
              aliace: data.bucket.aliace,
              db_key: data.bucket.db_key,
              list: [{
                activity_name: data.markEntryDetail.exam,
                activity_id: data.markEntryDetail._id,
                created_by: userId,
                type: "activities"
              }],
              max_mark: data.bucket.max_mark,
              // max_mark: 100,
              name: data.bucket.name,
              selection: "best"
            });
          });
          var activityCondition = {
            session_id: card.academic_details.session_id,
            curriculum_id: card.academic_details.curriculum_id,
            class_id: card.academic_details.class_id,
            batch_id: card.academic_details.batch_id,
            subject_id: card.academic_details.subject_id,
            school_id: card.report_card_header.school_id
          };
          var _reqObj = {
            args: {
              cardId: card.report_console_id,
              report_card_id: card._id,
              valuesUnderSkills: reqArr,
              activityCondition: activityCondition,
              dataId: false,
              re_generateFlag: false,
              fromCt: false,
              select_regen: false,
              get_students_selected: [],
              myUserId: userId,
              report_card_sync: true
            }
          };

          authService.callAPI(MARK_ENTRY_SAVE_CONSTANTS.API_REPORT_CARD_GENERATE, 'POST', _reqObj, function (response) {
            try {
              if (response.error && response.error.error == "Already generated the report!") {
                toastr.error(response.error.error);
              } else {
                var result = response.result.data.details.response;
                card.mark_entry_updated = false;
                toastr.success("Report card is updated with latest mark entry");
              }
              $scope.loading = false;
              $scope.$apply();
            } catch (ex) {
              console.log(ex);
            }
          });
        } else if (response.error && response.error.error && response.error.error.message) {
          $scope.loading = false;
          $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('Alert!').textContent(response.error.error.message).ariaLabel('Alert Dialog Demo').ok('OK'));
        }
      });
    }, function () {});
  }
};
ReportCardClassTeacher.$inject = ["$scope", "$rootScope", "authService", "localStorageService", "$state", "setAndSelectStudentRc", "$mdDialog", "MARK_ENTRY_SAVE_CONSTANTS"];

var StudentsCtrl = function StudentsCtrl($scope, $mdDialog, list, $state, parentScopeObj, card, authoring, setAndSelectStudentRc, localStorageService) {
  _classCallCheck(this, StudentsCtrl);

  var usersList = [];
  var academics = card.academic_details;
  console.log(setAndSelectStudentRc);
  _.each(list, function (oneUser) {
    if (oneUser.subjects && oneUser.subjects.indexOf(academics.subject_id) !== -1) {
      usersList.push(oneUser);
    }
  });
  $scope.items = usersList;
  $scope.selected = [];
  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    } else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function () {
    return $scope.selected.length !== 0 && $scope.selected.length !== $scope.items.length;
  };

  $scope.isChecked = function () {
    return $scope.selected.length === $scope.items.length;
  };

  $scope.toggleAll = function () {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };

  $scope.cancel = function () {
    $mdDialog.hide();
  };
  $scope.confirm = function () {
    var cardId = card.report_console_id;
    var reportDataId = card._id;
    var academics = card.academic_details;
    // localStorageService.set({
    //      cTregen: {
    //          session_id: academics.session_id,
    //          curriculum_id: academics.curriculum_id,
    //          class_id: academics.class_id,
    //          batch_id: academics.batch_id,
    //          subject_id: academics.subject_id,
    //          school_id: authoring.school_id
    //      }
    //  })
    localStorageService.set("cTregen", {
      session_id: academics.session_id,
      curriculum_id: academics.curriculum_id,
      class_id: academics.class_id,
      batch_id: academics.batch_id,
      subject_id: academics.subject_id,
      school_id: authoring.school_id
    });

    if (!$scope.selected.length) {
      toastr.error("Please select any student!");
      return false;
    }
    var set_students_selected = setAndSelectStudentRc.set_students_selected($scope.selected);
    $mdDialog.hide();
    $state.go('reportCardGenConsole', {
      "cardId": cardId,
      "dataId": reportDataId,
      "re_generate": true,
      "fromCt": true
    });
  };
};

exports.default = ReportCardClassTeacher;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loader = __webpack_require__(476);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/controllers/publishedReportController.js
                                                                                                                                                           * Project: /home/cordova03/projects/educore_3.5
                                                                                                                                                           * Created Date: Monday, December 10th 2018, 5:44:41 pm
                                                                                                                                                           * Author: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Last Modified: Wed Dec 12 2018
                                                                                                                                                           * Modified By: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var PublishedReportsController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "$stateParams", "pulishedReportCardsConstants", "$mdDialog", "CONSTANTS", function PublishedReportsController($scope, $rootScope, authService, localStorageService, $state, $stateParams, pulishedReportCardsConstants, $mdDialog, CONSTANTS) {
    _classCallCheck(this, PublishedReportsController);

    var self = this;
    var school_id = localStorageService.get('school_id');
    localStorageService.set('attendance_save_not', false);
    var user_id = localStorageService.get('user_id');
    self.selected_year = localStorageService.get('academic_year');

    if ($stateParams.fee_status) {
        user_id = $stateParams.student_id;
    }
    var rcApproveYear = localStorageService.get('rcApproveYear');
    var feeStatus = $stateParams.fee_status;
    $scope.fee_status_label = true;
    $scope.loading = true;
    var nofeeCheck = false;
    if (pulishedReportCardsConstants.NO_FEESCHOOLIDS.indexOf(school_id) !== -1) {
        nofeeCheck = true;
    }

    $scope.$watch(function () {
        return localStorageService.get('st_id');
    }, function (newVal, oldVal) {
        if ($rootScope.userRoleParentAccess) {
            user_id = newVal;
            self.scData = [];
            self.publishedReports = [];
            getLoadForParent(user_id);
        }
    });
    function getLoadForParent(user_id) {
        authService.callAPI("/v0/school/details/student/" + school_id + "/" + user_id, "GET", {}, function (response) {
            try {
                $scope.studentDoc = response.result.data.details.user_doc;
                // getPublishedReports(user_id, self.selected_year)
                self.scData = response.result.data.details.schoolDet[0].academic_year;
                var acdYear = _.find(self.scData, function (oneY) {
                    return oneY.status == 'active';
                });
                if (acdYear) {
                    if (rcApproveYear) {
                        self.selected_year = rcApproveYear;
                    } else {
                        self.selected_year = acdYear.year;
                    }
                } else {
                    if (self.scData && self.scData.length) {
                        var len = self.scData.length;
                        self.selected_year = self.scData[len - 1].year;
                    }
                }
                if (!$rootScope.userRoleParentAccess) {
                    getPublishedReports(user_id, self.selected_year);
                } else {
                    getPublishedReports(user_id, self.selected_year);
                    // $scope.fee_status_label = false
                }
                if (!$rootScope.userRoleParentAccess) {
                    $scope.loading = false;
                }
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    }
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Published Reports";
        $rootScope.userRoleParentAccess = undefined;
        if ($stateParams.fee_status == 'false') $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        } else {
            authService.callAPI("/v0/school/details/student/" + school_id + "/" + user_id, "GET", {}, function (response) {
                try {
                    self.scData = response.result.data.details.schoolDet[0].academic_year;
                    var acdYear = _.find(self.scData, function (oneY) {
                        return oneY.status == 'active';
                    });
                    if (acdYear) {
                        if (rcApproveYear) {
                            self.selected_year = rcApproveYear;
                        } else {
                            self.selected_year = acdYear.year;
                        }
                    }
                    if (!$rootScope.userRoleParentAccess) getPublishedReports(user_id, self.selected_year);
                    // $scope.loading = false
                    $scope.$apply();
                } catch (ex) {
                    console.log(ex);
                }
            });
        }
        pushLog();
    };

    $scope.hideLoader = function () {
        $mdDialog.hide();
    };
    $scope.showLoader = function (infoMsg) {
        $mdDialog.show({
            locals: {
                infoMsg: infoMsg,
                parentScopeObj: $scope
            },
            template: _loader2.default,
            bindToController: true,
            controllerAs: '$ctrl',
            controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                $scope.infoMsg = this.infoMsg;
            }],
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: true
        });
    };
    function getSchoolTokens(schoolId) {
        var dummySchool = [{
            "_id": "2ebFyzgjEwmdvep5L",
            "school_name": "The Oxford School,Trivandrum",
            "domain": "oxfordtvm.com",
            "site_url": "http://35.200.145.155:3000",
            "node_socket_url": "http://35.200.145.155:3002",
            "file_server": "http://35.200.145.155:4000",
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "53d553cca766bb843eeb6464608ac93e"
        }, {
            "_id": "Mvb8uY53ijBX9DNJS",
            "school_name": "The Oxford School,Kollam",
            "domain": "oxfordkollam.com",
            "site_url": "http://35.200.145.155:3000",
            "node_socket_url": "http://35.200.145.155:3002",
            "file_server": "http://35.200.145.155:4000",
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "25c921722bec9527d59eb0e34713347c"
        }, {
            "_id": "f5BCz8T7LqzpFsSP3",
            "school_name": "The Oxford School,Calicut",
            "domain": "oxfordcalicut.com",
            "site_url": "http://35.200.145.155:3000",
            "node_socket_url": "http://35.200.145.155:3002",
            "file_server": "http://35.200.145.155:4000",
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
        }, {
            "_id": "CPpbKPQTcuG97i3kv",
            "school_name": "The New Indian Model School,Dubai",
            "domain": "nimsdxb.com",
            "site_url": "http://35.189.123.171:3000",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://35.189.123.171:4000",
            // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
            // "school_data_token" : "e370c37780b957637493e9727c9b304d",
            // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
            // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "7a9d733269d23bc35b04b56dc855d330"
        }, {
            "_id": "m2LMtqaESFZf6xDE8",
            "school_name": "The Central School,Dubai",
            "domain": "centralschool.net",
            "site_url": "http://35.189.123.171:3000",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://35.189.123.171:4000",
            // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
            // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "47e2b919b8551d762e1dd1f5769b66ba"
        }, {
            "_id": "2FwuqhgeoKt6SQiCG",
            "school_name": "The New Indian Model School,Al-Ain",
            "domain": "nimsalain.com",
            "site_url": "http://35.189.123.171:3000",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://35.189.123.171:4000",
            // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
            // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "0ae409a7d98dde57b35a4643d2354906"
        }, {
            "_id": "ps4vyLJhQvPZjfxaH",
            "school_name": "The New Indian Model School,Sharjah",
            "domain": "nimsshj.com",
            "site_url": "http://35.189.123.171:3000",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://35.189.123.171:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
        }, {
            "_id": "apX7mQ9LsV2kZdFaH",
            "school_name": "APEX Vision Model School, Sharjah",
            "domain": "apexsharjah.com",
            "site_url": "http://35.189.123.171:3000",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://35.189.123.171:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "fe8acc83e277e3112e1dbf520291bfc9"
        }, {
            "_id": "EDcRnWShllFrmAuh",
            "school_name": "The Model School,Abu Dhabi",
            "domain": "themodel.ae",
            "site_url": "http://104.199.53.109:3700",
            "node_socket_url": "http://35.189.123.171:3002",
            "file_server": "http://104.199.53.109:4000",
            "school_data_url": "https://portal.themodel.ae/index.php/portal_data_contract",
            "school_data_token": "7b4f98b8d9f1f00fc0a6ebab23b82d40"
        }];
        var ex = _.find(dummySchool, function (one) {
            return one._id == schoolId;
        });
        return ex;
    }
    function getPublishedReports(child, passedSelectedYear) {
        // alert(1)
        $scope.loading = true;
        console.log(nofeeCheck);
        if (feeStatus == "true" || nofeeCheck) {
            $scope.fee_status_label = true;
            $scope.loading = true;
            getReportCardList(child, passedSelectedYear);
        } else {
            $scope.fee_status_label = true;
            var tokens = getSchoolTokens(school_id);
            // $scope.showLoader("Please wait..")
            var admn_no = localStorageService.get('admission_no');
            if (!admn_no) {
                if ($scope.studentDoc && $scope.studentDoc.admission_number) {
                    admn_no = $scope.studentDoc.admission_number;
                }
            }
            authService.callAPI("/v0/parent/portal/fee/", "POST", {
                school_data_token: tokens.school_data_token,
                school_data_url: tokens.school_data_url,
                admn_no: admn_no
            }, function (response) {
                try {
                    if (response.result.status.code == 200) {
                        if (response.result.data && response.result.data.details) {
                            self.feesDocument = response.result.data.details;
                            var exmpList = response.result.data.exemption_list ? response.result.data.exemption_list : [];
                            _.each(self.feesDocument, function (det, index) {
                                if (det.fee_last_date) {
                                    var someDate = new Date(det.fee_last_date);
                                    var numberOfDaysToAdd = 20;
                                    someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                    det.fee_last_date = someDate;
                                }
                                // det.fee_last_date = new Date(det.fee_last_date)
                                var today = new Date();
                                det.fee_last_date.setHours(0, 0, 0, 0);
                                today.setHours(0, 0, 0, 0);
                                if (det.fee_last_date <= today) {
                                    if (det.fee_status === "Pending" && det.blocking_status === "Y") {
                                        // console.log(exmpList)
                                        var isExepted = exmpList.includes(admn_no);
                                        if (isExepted) {
                                            $scope.fee_status_label = true;
                                        } else {
                                            $scope.fee_status_label = false;
                                        }
                                    } else {
                                        $scope.fee_status_label = true;
                                    }
                                }
                            });
                            getReportCardList(child, passedSelectedYear);
                        } else {
                            $scope.fee_status_label = true;
                            getReportCardList(child, passedSelectedYear);
                        }
                    } else {
                        $scope.fee_status_label = false;
                    }
                    $scope.hideLoader();
                } catch (ex) {
                    $scope.hideLoader();
                    console.log(ex);
                }
                $scope.$apply();
            });
        }
    }
    self.listRcWithSelectedYear = function (selected_year) {
        if (selected_year) {
            localStorageService.set({
                acdYearRcStudent: selected_year
            });
        }
        self.selected_year = selected_year;
        $scope.loading = true;
        if (selected_year !== localStorageService.get('academic_year')) {
            getReportCardList(user_id, self.selected_year);
            $scope.fee_status_label = true;
        } else {
            getPublishedReports(user_id, self.selected_year);
        }
    };
    function getReportCardList(child, passedSelectedYear) {
        var forCt = false;
        if ($stateParams.fee_status == 'true') {
            forCt = true;
        }

        var requestBody = {
            args: {
                schoolId: school_id,
                user_id: child,
                passedSelectedYear: passedSelectedYear,
                forCt: forCt,
                is_web: true,
                parent_status: localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC') !== -1 ? true : false,
                student_status: localStorageService.get('role_ids').indexOf('student') !== -1 ? true : false

            }

        };
        console.log(localStorageService.get('role_ids'));
        if (localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC') !== -1) {
            console.log(localStorageService.get('role_ids').indexOf('Rt4ZwrDRxw8Zwer6aC'));
            $scope.isAdmUsr = true;
        }
        authService.callAPI("/v0/reportcards/published/list", "POST", requestBody, function (response) {
            try {
                self.publishedReports = response.result.data.details.arrayToClient;
            } catch (ex) {
                self.publishedReports = [];
            }
            $scope.loading = false;
            $scope.$apply();
        });
    }

    this.$onDestroy = function () {};
    $scope.showReportCard = function (consoleId, type, asset_format, card) {

        // HPC report card → generate + download the PDF instead of routing to reportsMain
        if (card && card.is_hpc) {
            $scope.downloadHpcReport(card);
            return;
        }

        if (card.attendance_butn_not) {
            localStorageService.set('attendance_save_not', true);
        }
        var obj = {
            student_id: user_id,
            console_id: consoleId,
            type: type ? type : false,
            template_view: "cbse",
            asset_format: asset_format ? asset_format : false,
            selected_year: self.selected_year,
            kb_consolidated: card.kb_consolidated ? true : false,
            kg_consolidated: card.kg_consolidated ? true : false,
            montessori_consolidated: card.montessori_consolidated ? true : false
        };
        obj['for_ct'] = false;
        if ($stateParams.fee_status) {
            obj['for_ct'] = true;
        }

        $state.go('reportsMain', obj);
    };
    $scope.showEducoreReportCard = function (consoleId, type, asset_format, card) {
        var obj = {
            student_id: user_id,
            console_id: consoleId,
            type: type,
            template_view: "educore",
            selected_year: self.selected_year,
            asset_format: asset_format ? asset_format : false,
            kb_consolidated: card.kb_consolidated ? true : false,
            kg_consolidated: card.kg_consolidated ? true : false,
            montessori_consolidated: false
        };
        if (card.attendance_butn_not) {
            localStorageService.set('attendance_save_not', true);
        }
        obj['for_ct'] = false;
        if ($stateParams.fee_status) {
            obj['for_ct'] = true;
        }
        $state.go('reportsMain', obj);
    };

    // ── HPC report card: generate on the server, download the returned PDF ──
    $scope.downloadHpcReport = function (card) {
        var sheetRecordId = card && (card.sheet_record_id || card.report_console_id) || undefined;
        var admn = localStorageService.get('admission_no') || $scope.studentDoc && $scope.studentDoc.admission_number || undefined;
        if (!sheetRecordId || !admn) {
            toastr.error('Missing report details (sheet / admission number).');
            return;
        }
        $scope.loading = true;
        authService.callAPI('/v0/hpc/report-card/generate', 'POST', {
            sheet_record_id: sheetRecordId,
            admission_number: admn,
            fileUpload: CONSTANTS.FILE_UPLOAD_URL
        }, function (response) {
            try {
                var res = response && response.result && response.result.data;
                if (res && res.success && res.data && res.data.pdf_base64) {
                    // Only announce success if the blob/download step actually ran —
                    // it has its own failure path that toasts an error.
                    if (_downloadBase64Pdf(res.data.pdf_base64, res.data.filename || 'HPC_Report.pdf')) {
                        toastr.success('Downloaded HPC report');
                    }
                } else {
                    toastr.error(res && res.message || 'Failed to generate HPC report');
                }
            } catch (ex) {
                console.log(ex);
                toastr.error('Failed to generate HPC report');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    // Convert a base64 PDF to a Blob, trigger a browser download, and open the
    // same PDF in a new tab so the parent can read it without hunting for the file.
    function _downloadBase64Pdf(base64, filename) {
        try {
            var byteChars = atob(base64);
            var byteNumbers = new Array(byteChars.length);
            for (var i = 0; i < byteChars.length; i++) {
                byteNumbers[i] = byteChars.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var blob = new Blob([byteArray], { type: 'application/pdf' });
            var urlCreator = window.URL || window.webkitURL;
            var url = urlCreator.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // View copy — a separate object URL, so revoking the download's URL
            // can never pull the PDF out from under the open tab.
            var viewUrl = urlCreator.createObjectURL(blob);
            var tab = window.open(viewUrl, '_blank');
            if (!tab) {
                // Pop-up blocked — the download still succeeded, so this is a hint,
                // not an error.
                toastr.info('Allow pop-ups to view the report in a new tab');
                urlCreator.revokeObjectURL(viewUrl);
            } else {
                // Give the new tab time to load before releasing the blob. Revoking
                // on a 1s timer like the download URL can blank the viewer.
                setTimeout(function () {
                    urlCreator.revokeObjectURL(viewUrl);
                }, 60000);
            }

            setTimeout(function () {
                urlCreator.revokeObjectURL(url);
            }, 1000);
            return true;
        } catch (ex) {
            console.log(ex);
            toastr.error('Could not download the PDF');
            return false;
        }
    }

    function pushLog() {
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + user_id + "/" + school_id + "/publishedReports_Listing", "GET", {}, function (response) {
            // console.log(response)
        });
    }
}];

exports.default = PublishedReportsController;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _viewNotMappedStatus = __webpack_require__(897);

var _viewNotMappedStatus2 = _interopRequireDefault(_viewNotMappedStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var studentParentMapping = function studentParentMapping($scope, $mdDialog, $state, $mdMedia, $timeout, localStorageService, authService, CONSTANTS, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, studentParentMapping);

    var self = this;
    /** @Author: Naveen Nazimudeen N  @Date: 2018-02-23 15:17:34  @Desc: For url authorisation --starts */
    // localStorageService
    // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
    //         let userAccessJson = UserPrivilages.getFeatures("userEndorsement");
    //         if (userAccessJson && userAccessJson.length > 0) {
    //             $scope.userAccess = {};
    //             _.each(userAccessJson, function(noteObj) {
    //                 user_access = {};
    //                 _.each(noteObj.privilege, function(privObj) {
    //                     user_access[privObj.name.toLowerCase()] = privObj.status
    //                 })
    //                 $scope.userAccess[noteObj.feature_id] = user_access;
    //             })
    //         } else
    //             $state.go('dashboard')
    //     })
    /** @Author: Naveen Nazimudeen N  @Date: 2018-02-23 15:18:09  @Desc: For url authorisation --ends */
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Student Parent Mapping";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.showList = false;
    $scope.filteredUsers = [];
    this.userMgt = {};
    this.dataCount = [];
    this.selectedIndex = 'userNames';
    this.userNamesEndorsed = [];
    self.sessions = [];
    $scope.loading = true;

    this.$onDestroy = function () {
        self.userNamesEndorsed = [];
        self.userNames = [];
        self.parentOnlyList = [];
        self.xclasses = [];
        self.batches = [];
        self.curricula = [];
        self.sessions = [];
    };
    var schoolIdLocal = localStorageService.get('school_id');
    function loadSelections() {
        var loadObj = {
            school_id: schoolIdLocal
        };
        authService.callAPI("/v0/student_mapping/init", "POST", { args: loadObj }, function (response) {
            $scope.loading = false;
            if (!response.error) {
                var res = response.result.data.details.response;
                self.sessions = res ? res : [];
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
    }
    loadSelections();
    $scope.$watch(function () {
        $scope.fileFiltered = $scope.$eval('studentParentMapping.userNames | filter : studentParentMapping.searchUser');
    });

    $scope.fileFilteredParents = []; //filter no results
    $scope.$watch(function () {
        $scope.fileFilteredParents = $scope.$eval('studentParentMapping.parentOnlyList | filter : studentParentMapping.searchMappedParent');
    });

    $scope.fileFilteredNotMapped = []; //filter no results
    $scope.$watch(function () {
        $scope.fileFilteredNotMapped = $scope.$eval('studentParentMapping.userNamesEndorsed | filter : studentParentMapping.searchUser');
    });

    this.getRoleDetails = function (id) {
        $scope.roleType = id;
    };
    this.getBatch = function () {
        self.batches = [];
        var loadObj = {
            classId: self.userMgt.classId,
            curriculumId: _this.userMgt.curriculumId,
            sessionId: _this.userMgt.sessionId,
            school_id: schoolIdLocal
        };
        authService.callAPI("/v0/student_mapping/getBatchFiltered", "POST", { args: loadObj }, function (response) {
            if (!response.error) {
                var res = response.result.data.details.response;
                self.batches = res ? res : [];
                self.userMgt.batchId = undefined;
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
    };

    self.searchMappedStudents = function () {
        $scope.loading = true;
        self.userNamesEndorsed = [];
        self.userNames = [];

        var load = {
            school_id: schoolIdLocal,
            userMgt: _this.userMgt,
            FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL
        };
        authService.callAPI("/v0/student_mapping/searchMappedStudents", "POST", { args: load }, function (response) {
            if (!response.error) {
                var res = response.result.data.details.response;
                console.log(res);
                if (res) {
                    self.userNamesEndorsed = res.userNamesEndorsed;
                    self.userNames = res.userNames;
                }
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
        $scope.showList = true;
    };
    var paginateCount = $scope.parentCount / 100;
    paginateCount = Math.ceil(paginateCount);

    $scope.paginatedParentCount = 0;
    $scope.alreadyCount = self.parentOnlyList ? self.parentOnlyList.length : 0;
    $scope.notMappedPages = [];
    $scope.mappedPages = [];
    $scope.notMappedParents = [];
    $scope.mappedParents = [];

    function search(data, fromPaginate, npSE) {
        var load = {
            school_id: schoolIdLocal,
            data: data,
            academics: self.userMgt,
            count: $scope.callCount,
            fromPaginate: fromPaginate
        };
        authService.callAPI("/v0/student_mapping/searchParentMappedOrNot", "POST", { args: load }, function (response) {

            try {
                $scope.loading = false;
                if (!response.error) {
                    var res = response.result.data.details.response;
                    if (res) {
                        self.parentOnlyList = res.parentOnlyList;
                        if (!fromPaginate) {
                            $scope.parentCount = res.parentCount;
                            $scope.paginatedParentCount = self.parentOnlyList.length;
                            paginateCount = $scope.parentCount / 100;
                            paginateCount = Math.ceil(paginateCount);
                        }
                        if ($scope.callCount == paginateCount) {
                            $scope.disableNext = true;
                        } else {
                            $scope.disableNext = false;
                        }
                        $scope.callCount++;
                        if ($scope.callCount == 2) {
                            if (self.parentOnlyList.length < 100) {
                                $scope.disableNext = true;
                            } else {
                                $scope.disableNext = false;
                            }
                        }
                    }
                    if (data == '0') {
                        $scope.mappedParents.push(self.parentOnlyList);
                        $scope.mappedParents = _.flatten($scope.mappedParents);
                        $scope.mappedPages.push($scope.callCount);
                    } else {
                        $scope.notMappedParents.push(self.parentOnlyList);
                        $scope.notMappedParents = _.flatten($scope.notMappedParents);
                        $scope.notMappedPages.push($scope.callCount);
                    }
                    getCountShown($scope.callCount, data, npSE);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    }
    self.searchParentMappedOrNot = function (data, fromPaginate, npSE) {
        self.showPagination = true;
        $scope.loading = true;
        self.mappedTrue = [];
        self.mappedFalse = [];
        self.parentOnlyList = [];
        // if(npSE == "first" || npSE == "last"){

        //     search(data, fromPaginate, npSE)
        // }
        if (npSE == "pre") {
            $scope.callCount = $scope.callCount - 2;
        }
        if (!$scope.callCount) {
            $scope.callCount = 1;
        }
        if (!fromPaginate) {
            self.searchMappedParent = undefined;
            $scope.callCount = 1;
            $scope.paginatedParentCount = 0;
            $scope.preCount = 0;
        }
        // if($scope.callCount = 1){
        //     $scope.currentPage = 0
        // }


        if ($scope.callCount == 1) {
            $scope.disablePrev = true;
        } else {
            $scope.disablePrev = false;
        }
        if (paginateCount == $scope.callCount) {
            $scope.disableNext = true;
        } else {
            $scope.disableNext = false;
        }

        if (npSE == "first") {
            $scope.callCount = 1;
        }
        var flag = false;
        if (data == '0') {
            //     $scope.mappedParents = self.parentOnlyList
            $scope.users = $scope.mappedParents;
            $scope.callCountArray = $scope.mappedPages;
            flag = true;
        } else {
            //     $scope.notMappedParents = self.parentOnlyList
            $scope.users = $scope.notMappedParents;
            $scope.callCountArray = $scope.notMappedPages;
        }
        $scope.callCountArray = _.uniq($scope.callCountArray);

        if (!$scope.users || !$scope.users.length) {
            search(data, fromPaginate, npSE);
        } else {
            if (!$scope.callCountArray || !$scope.callCountArray.length) {
                search(data, fromPaginate, npSE);
            } else {

                $scope.loading = false;
                if ($scope.callCountArray.indexOf($scope.callCount) !== -1) {
                    self.parentOnlyList = _.filter($scope.users, function (one) {
                        return one.count == $scope.callCount && one.mapped == flag;
                    });
                    // console.log($scope.callCount)s
                    if (!self.parentOnlyList.length) {
                        $scope.loading = true;
                        search(data, fromPaginate, npSE);
                    } else {

                        self.parentOnlyList = _.filter($scope.users, function (one) {
                            return one.count == $scope.callCount && one.mapped == flag;
                        });
                        var _paginateCount = $scope.parentCount / 100;
                        _paginateCount = Math.ceil(_paginateCount);
                        if ($scope.callCount == _paginateCount) {
                            $scope.disableNext = true;
                        } else {
                            $scope.disableNext = false;
                        }
                        $scope.callCount++;
                        if ($scope.callCount == 2) {
                            if (self.parentOnlyList.length < 100) {
                                $scope.disableNext = true;
                            } else {
                                $scope.disableNext = false;
                            }
                        }
                        getCountShown($scope.callCount, data, npSE);
                    }
                } else {
                    search(data, fromPaginate, npSE);
                }
            }
        }
        // getCountShown($scope.callCount, data, npSE)

    };

    function getCountShown(callCount, data, npSE) {

        var users = [];
        var flag = false;
        if (data == '0') {
            users = [];
            users = $scope.mappedParents;
            flag = true;
        } else {
            users = [];
            users = $scope.notMappedParents;
        }
        callCount = callCount - 1;
        var cnt = 0;
        // if(npSE == "pre"){
        //     callCount = callCount - 1
        // }

        if (callCount < 1) {
            callCount = 1;
        }
        users = _.uniq(users, false, function (o) {
            return o._id;
        });

        // console.log(callCount)
        var counttWiseDoc = _.groupBy(users, function (val) {
            return val.count;
        });
        // console.log(counttWiseDoc)
        var arr = [];
        for (var i = callCount; i >= 1; i--) {
            arr.push(i);
        }
        var keys = Object.keys(counttWiseDoc);
        _.each(arr, function (key) {
            var len = counttWiseDoc[key] ? counttWiseDoc[key].length : 0;
            // console.log(counttWiseDoc[key])
            cnt = cnt + len;
        });
        $scope.paginatedParentCount = cnt;

        /*if(npSE == 'pre'){
            callCount = callCount - 2    
        }*/
        // let subjectWiseDoc = _.groupBy(users, function (val) {
        //     return val.academic_details.subject_id;
        // })
    }
    self.showNameSearch = false;
    self.searchParentMappedOrNotByName = function (data, fromPaginate, npSE) {
        self.showPagination = false;
        $scope.users = [];
        $scope.mappedParents = [];
        $scope.notMappedParents = [];
        $scope.notMappedPages = [];
        $scope.mappedPages = [];
        $scope.callCountArray = [];
        $scope.paginatedParentCount = 0;
        $scope.callCount = 1;
        self.parentOnlyList = [];

        if (!self.searchMappedParent || !self.searchMappedParent.length || self.searchMappedParent == '') {
            self.searchParentMappedOrNot(data, false, npSE);
        } else {
            $scope.loading = true;
            var loadObj = {
                school_id: schoolIdLocal,
                data: data,
                academics: _this.userMgt,
                count: $scope.callCount,
                fromPaginate: fromPaginate,
                nameString: self.searchMappedParent
            };
            authService.callAPI("/v0/student_mapping/searchParentMappedOrNotByName", "POST", { args: loadObj }, function (response) {
                if (!response.error) {
                    $scope.loading = false;
                    var res = response.result.data.details.response;
                    if (res) {
                        self.parentOnlyList = res;
                    }
                }
                self.showNameSearch = true;
                _.defer(function () {
                    $scope.$apply();
                });
            });
            // Meteor.call("searchParentMappedOrNotByName",
            //  Session.get('school_id'), data, this.userMgt, $scope.callCount, fromPaginate, self.searchMappedParent, function(err, res) {
            //     $scope.loading = false
            //     if (res) {

            //         self.parentOnlyList = res


            //     }
            //     self.showNameSearch = true
            //     _.defer(function() { $scope.$apply(); });
            // })
        }
    };
    self.clearParent = function (data) {
        self.searchMappedParent = undefined;
        self.searchParentMappedOrNot(data, false, {});
    };

    $scope.callCount = 1;

    // self.clearSelection = () => {
    //     Meteor.call("searchParentMappedOrNotCount", Session.get('school_id'), this.userMgt, function(err, res){
    //         $scope.loading = false
    //         if(res){
    //             self.notMappedParentCount = res.notMappedParentCount ? res.notMappedParentCount : 0
    //             self.mappedParentCount = res.mappedParentCount ? res.mappedParentCount : 0
    //         }
    //         _.defer(function() { $scope.$apply(); });
    //     })
    // }


    this.getClass = function () {
        // $scope.loading = true
        self.xclasses = [];
        var loadObj = {
            curriculumId: _this.userMgt.curriculumId,
            sessionId: _this.userMgt.sessionId,
            school_id: schoolIdLocal
        };
        authService.callAPI("/v0/student_mapping/getClassFiltered", "POST", { args: loadObj }, function (response) {
            if (!response.error) {
                var res = response.result.data.details.response;
                if (res) {
                    self.xclasses = res;
                } else {
                    self.xclasses = [];
                }
                self.userMgt.classId = undefined;
                self.userMgt.batchId = undefined;
                self.showBatchName = [];
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
    };

    this.getCuriculum = function () {
        // $scope.loading = true

        var loadObj = {
            school_id: schoolIdLocal,
            sessionId: _this.userMgt.sessionId
        };
        authService.callAPI("/v0/student_mapping/getCuriculumFiltered", "POST", { args: loadObj }, function (response) {
            if (!response.error) {
                var res = response.result.data.details.response;
                if (res) {
                    self.curricula = res;
                } else {
                    self.curricula = [];
                }
                self.userMgt.curriculumId = undefined;
                self.userMgt.classId = undefined;
                self.userMgt.batchId = undefined;
                self.showClassName = [];
                self.showBatchName = [];
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
        // Meteor.call("getCuriculumFiltered", this.userMgt.sessionId, Session.get('school_id'), function(err, res) {
        //     if (res) {
        //         self.curricula = res
        //     } else {
        //         self.curricula = []

        //     }

        //     self.userMgt.curriculumId = undefined
        //     self.userMgt.classId = undefined
        //     self.userMgt.batchId = undefined
        //     self.showClassName = []
        //     self.showBatchName = []
        //     $scope.loading = false
        //     _.defer(function() { $scope.$apply(); });;
        // })
    };

    this.getUsersListsforMap = function () {

        $scope.showList = true;

        var conditions = {
            role_ids: {
                $in: ['student']
            },
            school_id: schoolIdLocal,
            status: "active"
        };
        if (_this.userMgt.sessionId) {

            conditions['session_id'] = _this.userMgt.sessionId;
        }
        if (_this.userMgt.curriculumId) {
            conditions['curriculum_id'] = _this.userMgt.curriculumId;
        }
        if (_this.userMgt.classId) {

            conditions['class_id'] = _this.userMgt.classId;
        }
        if (_this.userMgt.batchId) {

            conditions['batch_id'] = _this.userMgt.batchId;
        }

        $scope.loadingUser = true;

        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to map ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            conditions['FILE_UPLOAD_URL'] = CONSTANTS.FILE_UPLOAD_URL;
            authService.callAPI("/v0/student_mapping/mapStudentWithParent", "POST", { args: conditions }, function (response) {
                if (!response.error) {
                    var result = response.result.data.details.response;
                    var res = result.mapped;
                    res = res ? res : "0";
                    toastr.success(res + " students mapped");
                    $scope.selectedTab = 0;
                    if (result.userNamesEndorsed) {
                        self.userNamesEndorsed = result.userNamesEndorsed;
                    }
                    if (result.userNames) {
                        self.userNames = result.userNames;
                    }
                } else {
                    toastr.error(response.error.error);
                }
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });;
            });
        });
    };

    self.viewNotMappedStatus = function () {
        var conditions = {
            school_id: schoolIdLocal
        };
        authService.callAPI("/v0/student_mapping/personGroupByStudents", "POST", { args: conditions }, function (response) {
            console.log(response);
            if (!response.error) {
                var res = response.result.data.details.response;
                self.dataCount = [];
                _.each(res, function (count) {
                    self.dataCount.push(count);
                });
                $mdDialog.show({
                    controller: ['$scope', '$state', '$stateParams', 'data', '$mdMedia', '$mdDialog', viewNotMappedStatusController],
                    locals: {
                        data: self.dataCount
                    },
                    template: _viewNotMappedStatus2.default,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true
                });
            }
        });
        // Meteor.call('personGroupByStudents', Session.get('school_id'), function(err, res) {
        //     if (err) {
        //         toastr.success("server not found")
        //     } else {
        //         self.dataCount = [];
        //         _.each(res, function(count) {
        //             self.dataCount.push(count)
        //         })
        //     }
        //     $mdDialog.show({
        //         controller: ['$scope',  '$state', '$stateParams', 'data', '$mdMedia', '$mdDialog', viewNotMappedStatusController],
        //         locals: {
        //             data: self.dataCount
        //         },
        //         templateUrl: PreviewViewNotMappedStatus,
        //         parent: angular.element(document.body),
        //         clickOutsideToClose: true,
        //     })
        // })
    };
};
studentParentMapping.$inject = ["$scope", "$mdDialog", "$state", "$mdMedia", "$timeout", "localStorageService", "authService", "CONSTANTS", "$rootScope"];

var viewNotMappedStatusController = function viewNotMappedStatusController($scope, $state, $stateParams, data, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, viewNotMappedStatusController);

    $scope.notMappedStatusArray = data;
    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};
viewNotMappedStatusController.$inject = ["$scope", "$state", "$stateParams", "data", "$mdMedia", "$mdDialog"];

exports.default = studentParentMapping;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PeopleSearch = function PeopleSearch($scope, $state, $rootScope, $mdDialog, errorValidatorUtil, navigatePeopleLookUp, localStorageService, authService, CONSTANTS) {
    'ngInject';

    _classCallCheck(this, PeopleSearch);

    this.$state = $state;
    var myUserId = localStorageService.get('user_id');
    //[Object] - Holds pagination data
    $scope.filteredItems = [];

    //Object - Holds selected filter query
    $scope.selectedObj = {};

    //[Object] - Holds filters object against each key(column name)
    $scope.values = [];

    //Array - Holds column value of report(table)
    $scope.keys = [];

    //[Array] - Holds object of fecthed result
    $scope.originalResultData = [];

    //[Array] - Holds object of filtered result
    $scope.resultData = [];

    //Number -  To set current page number, by default 0
    $scope.currentPage = 0;

    //Number -  To set number of items to display inech page
    $scope.itemsPerPage = 50;

    //Number -  To set number of pagination page should display
    $scope.gap = $scope.itemsPerPage;

    //Number -  To set the pagination index
    $scope.paginationInt = 1;

    //Number - Length of the total collection
    $scope.totalCollectionLength = 0;

    //Boolean - For showing loader
    $scope.loading = true;

    //String - Filter button label
    $scope.buttonLabel = 'Advanced Filter';

    //Boolean - For setting search privilege
    $scope.searchPrivilege = false;

    //Object - Holds details of pages
    $scope.pager = {};

    //Show header title
    $rootScope.title = "People Search";
    var school_id = localStorageService.get('school_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "People Search";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
    };
    try {
        var object = {
            "actor": {
                "mbox": "mailto:" + Meteor.user().username,
                "account": {
                    "name": Meteor.user().name,
                    "homePage": SITE_URL
                },
                "objectType": "Agent"
            },
            "verb": {
                "id": SITE_URL + "expapi/verbs/view",
                "display": {
                    "en-US": "previewed"
                }
            },
            "object": {
                "id": window.location.href,
                "definition": {
                    type: SITE_URL + "type/peoplelookup",
                    "name": {
                        "en-US": "People Lookup"
                    },
                    "description": {
                        "en-US": "People Lookup"
                    }
                },
                "objectType": "Agent"
            }
        };
        TinCanApiService.sendTincanApiRequest(object);
    } catch (ex) {}
    $scope.getUserList = function () {
        try {
            var obj = {
                paginationInt: $scope.paginationInt,
                school_id: school_id,
                uploadUrl: CONSTANTS.FILE_UPLOAD_URL,
                myUserId: myUserId
            };
            console.log('camehere');
            authService.callAPI("/v0/peoplelookup/fetch", "POST", { args: obj }, function (response) {
                try {
                    if (response && response.result && response.result.data && response.result.data && response.result.data.details) {
                        var result = response.result.data.details.response.response;
                        if (!result || !result.user_details || result.user_details.length == 0) {
                            toastr.error("No privileged uers to show");
                            window.history.back();
                            return;
                        }

                        $scope.templateFilter = [];
                        $scope.originalResultData = result.user_details;
                        $scope.values = [];
                        $scope.keys = _.keys($scope.originalResultData[0]);
                        $scope.totalCollectionLength = result.total_users;
                        $scope.keys = _.without($scope.keys, 'name', 'class_id', 'batch', 'batch_id', 'subject', 'subject_id', 'role_id', 'curriculum_id', 'session_id', 'user_id', 'username', 'image', 'empNo', 'admissionNo');
                        _.each($scope.keys, function (data) {
                            var result = _.sortBy(fetchValues(data), "name");
                            result.sort(function (a, b) {
                                if (!isNaN(Number(a.name))) {
                                    return a.name - b.name;
                                } else {
                                    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                                    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                                    if (nameA < nameB) {
                                        return -1;
                                    }
                                    if (nameA > nameB) {
                                        return 1;
                                    }
                                    return 0;
                                }
                            });
                            $scope.values.push({
                                key: data,
                                label: $scope.keyReplaceCase(data),
                                value: result,
                                selected_text: ""
                            });
                        });
                        $scope.selectedObj = {};
                        _.each($scope.values, function (pt) {
                            var obj = _.filter(pt.value, function (ft) {
                                return ft.is_selected == true;
                            });
                            var names = _.without(obj, _.findWhere(obj, {
                                name: 'undefined'
                            }));
                            names = _.pluck(names, "name");
                            $scope.selectedObj[pt.key] = names;
                            pt.selected_text = "All";
                        });
                        _.each($scope.keys, function (key) {
                            $scope.templateFilter.push({
                                'key': key,
                                'label': key,
                                'is_required': true
                            });
                        });
                        $scope.columnFilterResult(false);
                        $scope.paginationInt++;
                        $scope.pager = {
                            "page_no": 1,
                            "start_page": 1,
                            "end_page": Math.ceil($scope.originalResultData.length / $scope.itemsPerPage),
                            "f_start_page": 1,
                            "f_end_page": Math.ceil($scope.resultData.length / $scope.itemsPerPage),
                            "filter_data": $scope.resultData.length,
                            "total_data": $scope.totalCollectionLength,
                            "received_data": $scope.originalResultData.length
                        };
                        if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                            $scope.hasValue = false;
                        } else {
                            $scope.hasValue = true;
                        }
                        if ($scope.pager.f_start_page == $scope.pager.f_end_page) {
                            fetchData($scope.paginationInt);
                        }
                        $scope.refreshReport();
                        $scope.loading = false;
                    } else {
                        $scope.loading = false;
                        toastr.error("Unable to find user details.. Please try after some time");
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("previewFacultyDetails", $scope.paginationInt, function(error, result) {
            //     if (error) {

            //     } else {

            //     }
            // })
        } catch (e) {
            console.log(e);
        }
    };
    /*Roles and Privilege*/

    var features = localStorageService.get('feature_privileges');
    var userAccessJson = _.filter(features, function (feature) {
        return feature.module_state == "peopleSearch";
    });
    if (userAccessJson) {
        _.each(userAccessJson, function (feature) {
            if (feature.feature_id == 'peopleSearch') {
                var user_access = {};
                _.each(feature.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status;
                });
                if (user_access.create == true || user_access.edit == true) {
                    $scope.searchPrivilege = true;
                    $scope.getUserList();
                }
            }
        });
    }
    $scope.loading = false;
    // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
    //     if (result != undefined) {
    //         let features = result.feature_privileges;
    //         let userAccessJson = _.filter(features, function(feature) {
    //             return feature.module_state == "peopleSearch";
    //         });
    //         if (userAccessJson) {
    //             _.each(userAccessJson, function(feature) {
    //                 if (feature.feature_id == 'peopleSearch') {
    //                     let user_access = {};
    //                     _.each(feature.privilege, function(privObj) {
    //                         user_access[privObj.name.toLowerCase()] = privObj.status
    //                     })
    //                     if (user_access.create == true || user_access.edit == true) {
    //                         $scope.searchPrivilege = true
    //                         $scope.getUserList()
    //                     }
    //                 }
    //             })
    //         }
    //         $scope.loading = false;
    //     }
    // })

    /*
     * To fetch list of values against each column name
     * 
     * @key : Object - Selected column object contains key and customized label
     * 
     * @return : [Object] - List of values
     */
    function fetchValues(key) {
        var name = void 0,
            ids = void 0,
            arr = [];
        ids = _.compact(_.uniq(_.pluck($scope.originalResultData, key)));
        _.each(ids, function (dat) {
            if (dat != 'undefined') {
                arr.push({
                    'name': dat,
                    'is_selected': true
                });
            }
        });
        return arr;
    }

    function fetchData(req_count) {
        try {
            $scope.loading = true;
            console.log('>>>>>>>>>>>>>>>>>>>>>');
            var obj = {
                paginationInt: req_count,
                school_id: school_id,
                uploadUrl: CONSTANTS.FILE_UPLOAD_URL,
                myUserId: myUserId
            };
            console.log('camehere');
            authService.callAPI("/v0/peoplelookup/fetch", "POST", { args: obj }, function (response) {
                if (response.result && response.result.data && response.result.data && response.result.data.details) {
                    var result = response.result.data.details.response.response;
                    if (result) {
                        _.each(result.user_details, function (data) {
                            $scope.originalResultData.push(data);
                        });
                        var filters = $scope.templateFilter;
                        _.each(filters, function (data) {
                            var resultArr = [];
                            var ids = _.compact(_.uniq(_.pluck(result.user_details, data.key)));
                            _.each(ids, function (dat) {
                                resultArr.push({
                                    'name': dat,
                                    'is_selected': true
                                });
                            });
                            if (resultArr.length > 0) {
                                _.each($scope.values, function (dt, key) {
                                    if (dt.key === data.key) {

                                        var newArr = dt.value.concat(resultArr);
                                        var uniqArr = [];

                                        var unique = {};
                                        _.each(newArr, function (item) {
                                            if (!unique[item.name] && item.name != 'undefined') {
                                                uniqArr.push(item);
                                                unique[item.name] = item;
                                            }
                                        });
                                        dt.value = uniqArr;
                                    }
                                });
                            }
                        });
                        _.each($scope.values, function (pt) {
                            var obj = _.filter(pt.value, function (ft) {
                                return ft.is_selected == true;
                            });
                            var names = _.pluck(obj, "name");
                            $scope.selectedObj[pt.key] = names;
                        });
                        var page = $scope.pager.page_no;
                        $scope.columnFilterResult(false);
                        $scope.loading = false;
                        $scope.paginationInt++;
                        $scope.pager.page_no = page;
                        $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage);
                        $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage);
                        $scope.pager.filter_data = $scope.resultData.length;
                        $scope.pager.received_data = $scope.originalResultData.length;
                        if (($scope.pager.page_no - 1) * $scope.itemsPerPage >= $scope.pager.filter_data) {
                            $scope.pager.page_no = $scope.pager.page_no - 1;
                        }
                        if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                            $scope.hasValue = false;
                        } else {
                            $scope.hasValue = true;
                        }
                        $scope.groupToPages();
                    } else {
                        $scope.loading = false;
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
            // Meteor.call("previewFacultyDetails", req_count, function(error, result) {
            //     if (result) {
            //         _.each(result.user_details, function(data) {
            //             $scope.originalResultData.push(data)
            //         })
            //         let filters = $scope.templateFilter;
            //         _.each(filters, function(data) {
            //             let resultArr = []
            //             let ids = _.compact(_.uniq(_.pluck(result.user_details, data.key)))
            //             _.each(ids, function(dat) {
            //                 resultArr.push({
            //                     'name': dat,
            //                     'is_selected': true
            //                 })
            //             })
            //             if (resultArr.length > 0) {
            //                 _.each($scope.values, function(dt, key) {
            //                     if (dt.key === data.key) {

            //                         let newArr = dt.value.concat(resultArr)
            //                         let uniqArr = []

            //                         var unique = {};
            //                         _.each(newArr, function(item) {
            //                             if (!unique[item.name] && item.name != 'undefined') {
            //                                 uniqArr.push(item);
            //                                 unique[item.name] = item;
            //                             }
            //                         });
            //                         dt.value = uniqArr
            //                     }
            //                 })
            //             }
            //         })
            //         _.each($scope.values, function(pt) {
            //             let obj = _.filter(pt.value, function(ft) {
            //                 return ft.is_selected == true
            //             })
            //             let names = _.pluck(obj, "name")
            //             $scope.selectedObj[pt.key] = names;
            //         })
            //         let page = $scope.pager.page_no
            //         $scope.columnFilterResult(false)
            //         $scope.loading = false;
            //         $scope.paginationInt++;
            //         $scope.pager.page_no = page
            //         $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage)
            //         $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage)
            //         $scope.pager.filter_data = $scope.resultData.length
            //         $scope.pager.received_data = $scope.originalResultData.length
            //         if (($scope.pager.page_no - 1) * $scope.itemsPerPage >= $scope.pager.filter_data) {
            //             $scope.pager.page_no = $scope.pager.page_no - 1
            //         }
            //         if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
            //             $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
            //             $scope.hasValue = false
            //         } else {
            //             $scope.hasValue = true
            //         }
            //         $scope.groupToPages();
            //         _.defer(function() { $scope.$apply(); });
            //     } else {
            //         $scope.loading = false
            //     }
            // })
        } catch (e) {
            console.log(e);
        }
    }

    /*
     * Paginate to Previous page
     * 
     * @return : null
     */
    $scope.prevPage = function () {
        if ($scope.pager["page_no"] > 0) {
            $scope.pager["page_no"] = $scope.pager["page_no"] - 1;
            if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                $scope.hasValue = false;
            } else {
                $scope.hasValue = true;
            }
            $scope.setPaginationMsg();
        }
    };

    $scope.nextPage = function () {
        if ($scope.pager["page_no"] > 0) {
            $scope.pager["page_no"] = $scope.pager["page_no"] + 1;
            if ($scope.pager["total_data"] > $scope.pager["received_data"] && $scope.pager["page_no"] * $scope.itemsPerPage >= $scope.pager["filter_data"]) {
                fetchData($scope.paginationInt);
            }
            if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                $scope.hasValue = false;
            } else {
                $scope.hasValue = true;
            }
            $scope.setPaginationMsg();
        }
    };

    $scope.goToPage = function (page) {
        if (page > 0) {
            $scope.pager["page_no"] = page;
            if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                $scope.hasValue = false;
            } else {
                $scope.hasValue = true;
            }
            $scope.setPaginationMsg();
        }
    };

    /*
     * To refresh report table
     * 
     * @return : null
     */
    $scope.refreshReport = function () {
        $scope.filteredItems = $scope.resultData;
        $scope.pager.page_no = 1;
        $scope.groupToPages();
    };

    /*
     * To generate group of page for pagination
     * 
     * @return : null
     */
    $scope.groupToPages = function () {
        $scope.pagedItems = [];
        try {
            for (var i = 0; i < $scope.filteredItems.length; i++) {
                if (i % $scope.itemsPerPage === 0) {
                    $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)] = [$scope.filteredItems[i]];
                } else {
                    $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)].push($scope.filteredItems[i]);
                }
            }
            if ($scope.pagedItems.length < 11) {
                $scope.gap = $scope.pagedItems.length;
            } else {
                $scope.gap = $scope.itemsPerPage;
            }
            $scope.limit = $scope.pagedItems.length;
            $scope.setPaginationMsg();
        } catch (e) {
            console.log(e);
        }
    };

    /*
     * To set pagination information message
     * 
     * @return : null
     */
    $scope.setPaginationMsg = function () {
        var start = 1;
        var end = $scope.itemsPerPage;
        var page = $scope.pager.page_no != undefined ? $scope.pager.page_no : 1;
        try {
            if (page != 1) {
                start = page * $scope.itemsPerPage - ($scope.itemsPerPage - 1);
                end = start + $scope.pagedItems[$scope.pager.page_no - 1].length - 1;
            } else {
                start = 1;
                if ($scope.pager.page_no != undefined) {
                    end = start + $scope.pagedItems[$scope.pager.page_no - 1].length - 1;
                } else {
                    end = start + $scope.pagedItems[0].length - 1;
                }
            }
            // $scope.paginationMsg = start + " - " + end + " / " + $scope.filteredItems.length + " users"
            $scope.paginationMsg = start + " - " + end + " / " + $scope.totalCollectionLength + " users";
        } catch (ex) {
            $scope.paginationMsg = "There is no data against selected criteria"; //undefined
        }
    };

    /*
     * To replace '_' and convert each word first letler as Upper case letter
     * 
     * @data : String - Data to be replace
     * 
     * @return : String - Given data without Underscore
     */
    $scope.keyReplaceCase = function (data) {
        var str = data.replace(/_/g, ' ');
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    $scope.navigatePeopleLookUp = function (user_obj) {
        try {
            var _object = {
                "actor": {
                    "mbox": "mailto:" + Meteor.user().username,
                    "account": {
                        "name": Meteor.user().name,
                        "homePage": SITE_URL
                    },
                    "objectType": "Agent"
                },
                "verb": {
                    "id": SITE_URL + "expapi/verbs/interacted",
                    "display": {
                        "en-US": "clicked"
                    }
                },
                "object": {
                    "id": window.location.href,
                    "definition": {
                        type: SITE_URL + "type/peoplelookup",
                        "name": {
                            "en-US": "Userdetails"
                        },
                        "description": {
                            "en-US": "view user details"
                        }
                    },
                    "objectType": "Agent"
                }
            };
            TinCanApiService.sendTincanApiRequest(_object);
        } catch (ex) {}

        if (user_obj && user_obj !== 0) {
            var pdfUserAccsssess = navigatePeopleLookUp.setUserInput(user_obj);
            localStorageService.set('selectUser', user_obj.user_id);
            localStorageService.set('FROMSEARCH', "true");
            $state.go('myProfile');
        } else {
            toastr.error("Insufficient data available. Please select another user");
        }
    };

    /*
     * To close the all opened dropdwon
     * 
     * @event : Object - Current element object
     * 
     * @return : null
     */
    $scope.keyDownHandler = function (event) {
        if (event.target != null && event.target.offsetParent != null) {
            if (event.target.id === "btnSelect" || event.target.offsetParent.id === "lstItem") {
                return;
            } else {
                _.each($scope.values, function (dt) {
                    dt.open = false;
                });
            }
        }
    };

    /*
     * To open/close filter dropdown
     * 
     * @data : Object - Object of selected column filter
     * 
     * @return : null
     */
    $scope.toggleDropdown = function (data) {
        if (data != undefined) {
            _.each($scope.values, function (dt) {
                if (data.key == dt.key) {
                    dt.open = !dt.open;
                } else {
                    dt.open = false;
                }
            });
        }
    };

    /*
     * To generate list of selected values depends on the selection/dis selection of value
     * 
     * @data : Object - Selected value object against column name
     * @key : String - Selected column name
     * 
     * @return : null
     */
    $scope.setFilterObj = function (data, key) {
        if (data && key) {
            if (!data.is_selected) {
                var obj = _.reject($scope.selectedObj[key], function (kt) {
                    return kt === data.name;
                });
                if (obj) {
                    $scope.selectedObj[key] = obj;
                }
            } else {
                if (data && data.name) {
                    if (!_.contains($scope.selectedObj[key], data.name)) {
                        if ($scope.selectedObj[key] != undefined) {
                            $scope.selectedObj[key].push(data.name);
                        } else {
                            $scope.selectedObj[key] = [];
                            $scope.selectedObj[key].push(data.name);
                        }
                    }
                }
            }
        }
    };

    /*
     * To filter result based on the selection/disselection of value in each column filter
     * 
     * @isManual : Boolean - To define whether this function called by manual button click
     * 
     * @return : null
     */
    $scope.columnFilterResult = function (isManual) {
        if (isManual) {
            _.each($scope.values, function (val) {
                _.each(val.value, function (key, index) {
                    if (key.name != 'undefined') {
                        if (!_.contains($scope.selectedObj[val.key], key.name)) {
                            key.is_selected = false;
                        } else {
                            key.is_selected = true;
                        }
                    }
                });
            });
        }
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
            } else {
                val.selected_text = "Custom";
            }
        });
        var allKeys = _.keys($scope.selectedObj);
        var customKeys = _.filter($scope.values, function (val) {
            return val.selected_text === "Custom";
        });
        var customKey = _.pluck(customKeys, "key");
        allKeys = customKey;
        var selectedValueCount = 0;
        _.each(allKeys, function (key) {
            if ($scope.selectedObj[key] !== undefined && $scope.selectedObj[key].length > 0) {
                selectedValueCount++;
            }
        });
        if (selectedValueCount == allKeys.length) {
            _.each(allKeys, function (ch, pKey) {
                if ($scope.selectedObj[ch] !== undefined && $scope.selectedObj[ch].length > 0) {
                    if ($scope.selectedObj[ch].length == 1) {
                        var searchObj = {};
                        searchObj[ch] = $scope.selectedObj[ch][0];
                        if ($scope.chatData == undefined || $scope.chatData.length === 0) {
                            $scope.chatData = _.where($scope.originalResultData, searchObj);
                        } else {
                            if (pKey == 0) {
                                $scope.chatData = _.where($scope.originalResultData, searchObj);
                            } else {
                                $scope.chatData = _.where($scope.chatData, searchObj);
                            }
                        }
                    } else {
                        var i;

                        (function () {
                            var chatData = [];
                            var selectedObjLen = $scope.selectedObj[ch];
                            for (i = 0; i < selectedObjLen.length; i++) {
                                var _searchObj = {};
                                _searchObj[ch] = $scope.selectedObj[ch][i];
                                if (chatData.length === 0) {
                                    if (pKey == 0) {
                                        $scope.chatData = _.where($scope.originalResultData, _searchObj);
                                        chatData = _.where($scope.originalResultData, _searchObj);
                                    } else {
                                        chatData = _.where($scope.chatData, _searchObj);
                                    }
                                    if (i == $scope.selectedObj[ch].length - 1) {
                                        $scope.chatData = chatData;
                                    }
                                } else {
                                    var resultArray = void 0;
                                    if (pKey == 0) {
                                        resultArray = _.where($scope.originalResultData, _searchObj);
                                    } else {
                                        resultArray = _.where($scope.chatData, _searchObj);
                                    }
                                    if (i == 0) {
                                        chatData = resultArray;
                                    } else {
                                        _.each(resultArray, function (data) {
                                            chatData.push(data);
                                        });
                                    }
                                    if (i == $scope.selectedObj[ch].length - 1) {
                                        $scope.chatData = chatData;
                                    }
                                }
                            }
                        })();
                    }
                } else {
                    $scope.chatData = [];
                }
            });
        } else {
            $scope.chatData = [];
        }
        if (allKeys.length > 0) {
            $scope.resultData = $scope.chatData;
        } else {
            $scope.resultData = $scope.originalResultData;
        }
        $scope.totalItems = $scope.resultData.length;
        $scope.filteredItems = $scope.resultData;
        $scope.refreshReport();
        $scope.groupToPages();
        $scope.setPaginationMsg();
        $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage);
        $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage);
        $scope.pager.filter_data = $scope.resultData.length;
        $scope.pager.received_data = $scope.originalResultData.length;
        if ($scope.pager["received_data"] >= $scope.pager["total_data"] && $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
            $scope.hasValue = false;
        } else {
            $scope.hasValue = true;
        }
    };

    /*
     * To select all values in column filter
     * 
     * @data : Object - Object of selected column filter
     * @key : String - Selected column filter name
     * 
     * @return : null
     */
    $scope.setAllData = function (data, key) {
        _.each(data, function (dt) {
            dt.is_selected = true;
        });
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
            } else {
                val.selected_text = "Custom";
            }
        });
        var keyBasedValues = _.pluck(data, 'name');
        $scope.selectedObj[key] = keyBasedValues;
        $scope.columnFilterResult(true);
    };

    /*
     * To unselect all values in column filter
     * 
     * @data : Object - Object of selected column filter
     * @key : String - Selected column filter name
     * 
     * @return : null
     */
    $scope.unSetAllData = function (data, key) {
        _.each(data, function (dt) {
            dt.is_selected = false;
        });
        _.each($scope.values, function (val) {
            var nonSelecteditems = _.filter(val.value, function (data) {
                return data.is_selected === false;
            });
            if (nonSelecteditems.length === 0) {
                val.selected_text = "All";
            } else {
                val.selected_text = "Custom";
            }
        });
        $scope.selectedObj[key] = [];
        $scope.columnFilterResult(true);
    };

    /*
     * To replace '_' and convert each word first letler as Upper case letter
     * 
     * @data : String - Data to be replace
     * 
     * @return : String - Given data without Underscore
     */
    $scope.keyReplaceCase = function (data) {
        var str = data.replace(/_/g, ' ');
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };

    $scope.enableFilter = function () {
        $scope.buttonLabel == 'Advanced Filter' ? $scope.buttonLabel = 'Hide Filter' : $scope.buttonLabel = 'Advanced Filter';
        try {
            var _object2 = {
                "actor": {
                    "mbox": "mailto:" + Meteor.user().username,
                    "account": {
                        "name": Meteor.user().name,
                        "homePage": SITE_URL
                    },
                    "objectType": "Agent"
                },
                "verb": {
                    "id": SITE_URL + "expapi/verbs/interacted",
                    "display": {
                        "en-US": clicked
                    }
                },
                "object": {
                    "id": window.location.href,
                    "definition": {
                        type: SITE_URL + "type/peoplelookup",
                        "name": {
                            "en-US": $scope.buttonLabel
                        },
                        "description": {
                            "en-US": $scope.buttonLabel
                        }
                    },
                    "objectType": "Agent"
                }
            };
            TinCanApiService.sendTincanApiRequest(_object2);
        } catch (ex) {}
    };
};
PeopleSearch.$inject = ["$scope", "$state", "$rootScope", "$mdDialog", "errorValidatorUtil", "navigatePeopleLookUp", "localStorageService", "authService", "CONSTANTS"];

exports.default = PeopleSearch;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

var AcademicPerformance = function AcademicPerformance($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, AcademicPerformance);

    var self = this;
    var curriculumId = $state.params.curriculumId;
    var sessionId = $state.params.sessionId;
    $scope.loading = true;
    $scope.dataExists = false;
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "School Performance Report";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.dataExists = false;
        $scope.selectAcademics.session = session;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClass = function (curriculum) {
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.dataExists = false;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
    };
    // $scope.getReport = (year) => {
    //     $scope.toSearchObj.academic_year = year
    //     getReport($scope.toSearchObj)
    // }
    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
            args: {
                school_id: $scope.toSearchObj.school_id,
                year: $scope.toSearchObj.academic_year,
                curriculum_id: $scope.toSearchObj.curriculum,
                session_id: $scope.toSearchObj.session
            }
        }, function (response) {
            try {
                var result = response.result.data.details;
                $scope.rc_combinations = result;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    };
    $scope.getReportFromCombination = function (combination) {
        $scope.toSearchObj.combination = combination;
        getReport($scope.toSearchObj);
    };
    function getReport(toSearchObj) {
        $scope.loading = true;
        authService.callAPI("/v0/educore_reports/school/class_average", "POST", {
            args: {
                curriculumId: toSearchObj.curriculum,
                sessionId: toSearchObj.session,
                schoolId: localStorageService.get('school_id'),
                activeYear: toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                myUserId: localStorageService.get('user_id'),
                "pdfFlag": "false",
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                combination: toSearchObj.combination
            }
        }, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    if (!response.error) {

                        $scope.dataExists = true;
                        var result = response.result.data.details;
                        $scope.barcode = result.barcode;
                        $scope.classArray = result.classArray;
                        $scope.settSubject = result.subjectSett;
                        $scope.academicYear = result.academic_year;
                        $scope.schoolName = result.schoolName;
                        $scope.schoolLogo = CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo;
                        // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
                        $scope.reportCardConsoleDetails = result.reportCardConsoleDetails;
                        $scope.retval = result.retval;
                        $scope.sessionName = result.sessionName;
                        $scope.curriculumName = result.curriculumName;
                        //Added generated by and generated date
                        $scope.generatedBy = result.generatedBy;
                        $scope.generatedDate = result.generatedDate;
                        $scope.urls = result.pdf_url;
                    }
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        $scope.barcodeToHtml = function () {
            var lines = $scope.barcode.bcode.lines;
            var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
            return $sce.trustAsHtml(lines + barcodeNumber);
        };
        // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
        //     if (result) {
        //         $scope.classArray = result.classArray
        //         $scope.settSubject = result.subjectSett
        //         $scope.academicYear = result.academic_year
        //         $scope.schoolName = result.schoolName
        //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
        //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
        //         $scope.retval = result.retval
        //         $scope.sessionName = result.sessionName
        //         $scope.curriculumName = result.curriculumName
        //         //Added generated by and generated date
        //         $scope.generatedBy = result.generatedBy
        //         $scope.generatedDate = result.generatedDate

        //     }
        //     $scope.loading = false
        //     $scope.$apply()
        // })
    }
    $scope.exportpdf = function () {
        $scope.isPdfData = true;
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };
    $scope.backToHtml = function () {
        $scope.isPdfData = false;
        $scope.loading = false;
    };
};
AcademicPerformance.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog"];

exports.default = AcademicPerformance;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

var TermDifference = function TermDifference($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, TermDifference);

    var self = this;
    $rootScope.title = "Difference in Class Average";
    var curriculumId = $state.params.curriculumId;
    var sessionId = $state.params.sessionId;
    $scope.loading = true;
    $scope.dataExists = false;
    //Boolean - To set view for fetch
    $scope.isFilter = true;
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    //Object - Holds selection data
    $scope.selectAcademics = {};
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Difference in Class Average";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };
    $scope.barcodeToHtml = function () {
        var lines = $scope.barcode.bcode.lines;
        var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
        return $sce.trustAsHtml(lines + barcodeNumber);
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.dataExists = false;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClass = function (curriculum) {
        $scope.dataExists = false;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
    };

    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
            args: {
                school_id: $scope.toSearchObj.school_id,
                year: $scope.toSearchObj.academic_year,
                curriculum_id: $scope.toSearchObj.curriculum,
                session_id: $scope.toSearchObj.session
            }
        }, function (response) {
            try {
                var result = response.result.data.details;
                $scope.rc_combinations = result;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    };

    $scope.getReportFromCombination = function (combination) {
        $scope.toSearchObj.combination = combination;
        getReport($scope.toSearchObj);
    };
    function getReport(toSearchObj) {
        $scope.loading = true;
        authService.callAPI("/v0/educore_reports/school/classavgdiff", "POST", {
            args: {
                curriculumId: toSearchObj.curriculum,
                sessionId: toSearchObj.session,
                schoolId: localStorageService.get('school_id'),
                activeYear: toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                myUserId: localStorageService.get('user_id'),
                "pdfFlag": "false",
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                combination: toSearchObj.combination
            }
        }, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    if (!response.error) {
                        $scope.dataExists = true;
                        var result = response.result.data.details;
                        console.log(result);
                        $scope.barcode = result.barcode;
                        $scope.classArray = result.classArray;
                        $scope.settSubject = result.subjectSett;
                        $scope.academicYear = result.academic_year;
                        $scope.schoolName = result.schoolName;
                        $scope.schoolLogo = CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo;
                        // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
                        $scope.reportCardConsoleDetails = result.reportCardConsoleDetails;
                        $scope.retval = result.retval;
                        $scope.diffTerm = result.diffTerm;
                        $scope.diffYear = result.diffYear;
                        $scope.sessionName = result.sessionName;
                        $scope.curriculumName = result.curriculumName;
                        //Added generated by and generated date
                        $scope.generatedBy = result.generatedBy;
                        $scope.generatedDate = result.generatedDate;
                        $scope.urls = result.pdf_url;
                    }
                    $scope.loading = false;
                    $scope.$apply();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
        //     if (result) {
        //         $scope.classArray = result.classArray
        //         $scope.settSubject = result.subjectSett
        //         $scope.academicYear = result.academic_year
        //         $scope.schoolName = result.schoolName
        //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
        //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
        //         $scope.retval = result.retval
        //         $scope.sessionName = result.sessionName
        //         $scope.curriculumName = result.curriculumName
        //         //Added generated by and generated date
        //         $scope.generatedBy = result.generatedBy
        //         $scope.generatedDate = result.generatedDate

        //     }
        //     $scope.loading = false
        //     $scope.$apply()
        // })
    }
    $scope.exportpdf = function () {
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
        $scope.isPdfData = true;
    };
    $scope.backToHtml = function () {
        $scope.isPdfData = false;
        $scope.loading = false;
    };
};
TermDifference.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog"];

exports.default = TermDifference;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

var AttentionNeedingStudents = function AttentionNeedingStudents($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, AttentionNeedingStudents);

    $rootScope.title = "Attention Needing Students";
    var self = this;
    // $rootScope.title = "School Performance Report"
    var curriculumId = $state.params.curriculumId;
    var sessionId = $state.params.sessionId;
    $scope.loading = true;
    $scope.dataExists = false;
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Attention Needing Students";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.rc_combinations = [];
                    $scope.toSearchObj.combination = undefined;
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.dataExists = false;
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.rc_combinations = [];
                    $scope.toSearchObj.combination = undefined;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClass = function (curriculum) {
        $scope.dataExists = false;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
    };
    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.getreportCards($scope.toSearchObj);

        // $scope.($scope.toSearchObj)
    };
    $scope.getreportCards = function (toSearchObj) {

        authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
            args: {
                school_id: toSearchObj.school_id,
                year: toSearchObj.academic_year
            }
        }, function (response) {
            try {
                var result = response.result.data.details;
                $scope.rc_combinations = result;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    };
    $scope.getReportFromCombination = function (combination) {
        $scope.toSearchObj.combination = combination;
        getReport($scope.toSearchObj);
    };
    function getReport(toSearchObj) {
        $scope.loading = true;
        authService.callAPI("/v0/educore_reports/school/getStudentsNeedingAttention", "POST", {
            args: {
                curriculumId: toSearchObj.curriculum,
                sessionId: toSearchObj.session,
                schoolId: localStorageService.get('school_id'),
                activeYear: toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                myUserId: localStorageService.get('user_id'),
                "pdfFlag": "false",
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                combination: toSearchObj.combination
            }
        }, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    if (!response.error) {
                        $scope.dataExists = true;
                        var result = response.result.data.details;
                        $scope.barcode = result.barcode;
                        $scope.classArray = result.classArray;
                        $scope.settSubject = result.subjectSett;
                        $scope.academicYear = result.academic_year;
                        $scope.schoolName = result.schoolName;
                        $scope.schoolLogo = CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo;
                        // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
                        $scope.reportCardConsoleDetails = result.reportCardConsoleDetails;
                        $scope.retval = result.retval;
                        $scope.sessionName = result.sessionName;
                        $scope.curriculumName = result.curriculumName;
                        //Added generated by and generated date
                        $scope.generatedBy = result.generatedBy;
                        $scope.generatedDate = result.generatedDate;
                        $scope.urls = result.pdf_url;
                    }
                    $scope.loading = false;
                    $scope.$apply();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        $scope.barcodeToHtml = function () {
            var lines = $scope.barcode.bcode.lines;
            var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
            return $sce.trustAsHtml(lines + barcodeNumber);
        };
        // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
        //     if (result) {
        //         $scope.classArray = result.classArray
        //         $scope.settSubject = result.subjectSett
        //         $scope.academicYear = result.academic_year
        //         $scope.schoolName = result.schoolName
        //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
        //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
        //         $scope.retval = result.retval
        //         $scope.sessionName = result.sessionName
        //         $scope.curriculumName = result.curriculumName
        //         //Added generated by and generated date
        //         $scope.generatedBy = result.generatedBy
        //         $scope.generatedDate = result.generatedDate

        //     }
        //     $scope.loading = false
        //     $scope.$apply()
        // })
    }
    $scope.exportpdf = function () {
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
        $scope.isPdfData = true;
    };
    $scope.backToHtml = function () {
        $scope.isPdfData = false;
        $scope.loading = false;
    };
    $scope.barcodeToHtml = function () {
        var lines = $scope.barcode.bcode.lines;
        var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
        return $sce.trustAsHtml(lines + barcodeNumber);
    };
};
AttentionNeedingStudents.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog"];

exports.default = AttentionNeedingStudents;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

var PerformingSection = function PerformingSection($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog, SchoolLogo) {
    'ngInject';

    _classCallCheck(this, PerformingSection);

    var self = this;
    $rootScope.title = "Performing Section";
    var curriculumId = $state.params.curriculumId;
    var sessionId = $state.params.sessionId;
    $scope.loading = true;
    $scope.dataExists = false;
    //Boolean - To set view for fetch
    $scope.isFilter = true;
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    //Object - Holds selection data
    $scope.selectAcademics = {};
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Performing Section";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.dataExists = false;
        $scope.selectAcademics.session = session;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClass = function (curriculum) {
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        $scope.dataExists = false;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
    };
    // $scope.getReport = (year) => {
    //     $scope.toSearchObj.academic_year = year
    //     getReport($scope.toSearchObj)
    // }
    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
            args: {
                school_id: $scope.toSearchObj.school_id,
                year: $scope.toSearchObj.academic_year,
                curriculum_id: $scope.toSearchObj.curriculum,
                session_id: $scope.toSearchObj.session
            }
        }, function (response) {
            try {
                var result = response.result.data.details;
                $scope.rc_combinations = result;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    };
    $scope.getReportFromCombination = function (combination) {
        $scope.toSearchObj.combination = combination;
        getReport($scope.toSearchObj);
    };
    function getReport(toSearchObj) {
        $scope.loading = true;
        authService.callAPI("/v0/educore_reports/school/performingsection", "POST", {
            args: {
                curriculumId: toSearchObj.curriculum,
                sessionId: toSearchObj.session,
                schoolId: localStorageService.get('school_id'),
                activeYear: toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                myUserId: localStorageService.get('user_id'),
                "pdfFlag": "false",
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                combination: toSearchObj.combination
            }
        }, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    if (!response.error) {
                        $scope.dataExists = true;
                        var result = response.result.data.details;
                        $scope.classArray = result.classArray;
                        $scope.settSubject = result.subjectSett;
                        $scope.academicYear = result.academic_year;
                        $scope.barcode = result.barcode;
                        $scope.schoolName = result.schoolName;
                        $scope.schoolLogo = SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo);
                        $scope.reportCardConsoleDetails = result.reportCardConsoleDetails;
                        $scope.retval = result.retval;
                        $scope.sessionName = result.sessionName;
                        $scope.curriculumName = result.curriculumName;
                        //Added generated by and generated date
                        $scope.generatedBy = result.generatedBy;
                        $scope.generatedDate = result.generatedDate;
                        $scope.urls = result.pdf_url;
                    }
                    $scope.loading = false;
                    $scope.$apply();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        $scope.barcodeToHtml = function () {
            var lines = $scope.barcode.bcode.lines;
            var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
            return $sce.trustAsHtml(lines + barcodeNumber);
        };
        // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
        //     if (result) {
        //         $scope.classArray = result.classArray
        //         $scope.settSubject = result.subjectSett
        //         $scope.academicYear = result.academic_year
        //         $scope.schoolName = result.schoolName
        //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
        //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
        //         $scope.retval = result.retval
        //         $scope.sessionName = result.sessionName
        //         $scope.curriculumName = result.curriculumName
        //         //Added generated by and generated date
        //         $scope.generatedBy = result.generatedBy
        //         $scope.generatedDate = result.generatedDate

        //     }
        //     $scope.loading = false
        //     $scope.$apply()
        // })
    }
    $scope.exportpdf = function () {
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
        $scope.isPdfData = true;
    };
    $scope.backToHtml = function () {
        $scope.isPdfData = false;
        $scope.loading = false;
    };
};
PerformingSection.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog", "SchoolLogo"];

exports.default = PerformingSection;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer : Raziya S
// 2. Module/Feature Name : Academic Performance
//--------------------------------------------------------

var SectionWiseAttention = function SectionWiseAttention($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog, SchoolLogo) {
    'ngInject';

    _classCallCheck(this, SectionWiseAttention);

    $scope.isPdfData = false;
    var self = this;
    var curriculumId = $state.params.curriculumId;
    var sessionId = $state.params.sessionId;
    $scope.loading = true;
    $scope.dataExists = false;
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    $scope.selectAcademics = {};
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Section Wise Attention Needing Students";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.dataExists = false;
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.getClass = function (curriculum) {
        $scope.dataExists = false;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
    };
    // $scope.getReport = (year) => {
    //     $scope.toSearchObj.academic_year = year
    //     getReport($scope.toSearchObj)
    // }
    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
        $scope.rc_combinations = [];
        $scope.toSearchObj.combination = undefined;
        authService.callAPI("/v0/educore_reports/school/get-reports-for-selection", "POST", {
            args: {
                school_id: $scope.toSearchObj.school_id,
                year: $scope.toSearchObj.academic_year,
                curriculum_id: $scope.toSearchObj.curriculum,
                session_id: $scope.toSearchObj.session
            }
        }, function (response) {
            try {
                var result = response.result.data.details;
                $scope.rc_combinations = result;
                _.defer(function () {
                    $scope.$apply();
                });
            } catch (e) {
                console.log(e);
            }
        });
    };
    $scope.getReportFromCombination = function (combination) {
        $scope.toSearchObj.combination = combination;
        getReport($scope.toSearchObj);
    };
    function getReport(toSearchObj) {
        $scope.loading = true;
        authService.callAPI("/v0/educore_reports/school/sectionwiseattention", "POST", {
            args: {
                curriculumId: toSearchObj.curriculum,
                sessionId: toSearchObj.session,
                schoolId: localStorageService.get('school_id'),
                activeYear: toSearchObj.academic_year ? toSearchObj.academic_year.year : localStorageService.get('academic_year'),
                myUserId: localStorageService.get('user_id'),
                "pdfFlag": "false",
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                combination: toSearchObj.combination
            }
        }, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    if (!response.error) {
                        $scope.dataExists = true;
                        var result = response.result.data.details;
                        console.log(result);
                        $scope.barcode = result.barcode;
                        $scope.classArray = result.classArray;
                        $scope.settSubject = result.subjectSett;
                        $scope.academicYear = result.academic_year;
                        $scope.schoolName = result.schoolName;
                        $scope.schoolLogo = SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.schoolLogo);
                        $scope.reportCardConsoleDetails = result.reportCardConsoleDetails;
                        $scope.retval = result.retval;
                        $scope.sessionName = result.sessionName;
                        $scope.curriculumName = result.curriculumName;
                        //Added generated by and generated date
                        $scope.generatedBy = result.generatedBy;
                        $scope.generatedDate = result.generatedDate;
                        $scope.urls = result.pdf_url;
                    }
                    $scope.loading = false;
                    $scope.$apply();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            $scope.loading = false;
            _.defer(function () {
                $scope.$apply();
            });
        });
        $scope.barcodeToHtml = function () {
            var lines = $scope.barcode.bcode.lines;
            var barcodeNumber = $scope.barcode.bcode.barcodeNumber;
            return $sce.trustAsHtml(lines + barcodeNumber);
        };
        // Meteor.call('getRcPerCurriculum', curriculumId, sessionId, Session.get('school_id'), false, (error, result) => {
        //     if (result) {
        //         $scope.classArray = result.classArray
        //         $scope.settSubject = result.subjectSett
        //         $scope.academicYear = result.academic_year
        //         $scope.schoolName = result.schoolName
        //         // $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolLogo)
        //         $scope.reportCardConsoleDetails = result.reportCardConsoleDetails
        //         $scope.retval = result.retval
        //         $scope.sessionName = result.sessionName
        //         $scope.curriculumName = result.curriculumName
        //         //Added generated by and generated date
        //         $scope.generatedBy = result.generatedBy
        //         $scope.generatedDate = result.generatedDate

        //     }
        //     $scope.loading = false
        //     $scope.$apply()
        // })
    }
    $scope.exportpdf = function () {
        // $scope.loading = true
        $scope.isPdfData = true;
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };
    $scope.backToHtml = function () {
        $scope.isPdfData = false;
        $scope.loading = false;
    };
};
SectionWiseAttention.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog", "SchoolLogo"];

exports.default = SectionWiseAttention;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _studentpopupList = __webpack_require__(898);

var _studentpopupList2 = _interopRequireDefault(_studentpopupList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StudentFilteration = function StudentFilteration($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, StudentFilteration);

    $rootScope.title = "Individual Student Report";
    var self = this;
    $scope.loading = true;
    self.typeArray = undefined;
    self.levelArray = undefined;
    self.resPerTheme = undefined;
    self.tagArr = undefined;
    self.data_set = undefined;
    self.header = undefined;
    self.perTypeObj = {};

    self.perTagObj = {};
    self.perLevelObj = {};
    self.themeTotal = undefined;
    self.no_of_students = undefined;
    self.allThemeTotal = {};
    self.noData = true;
    $scope.view_only = false;
    $scope.filterObj = {};
    self.noAcademics = true;
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    var thisSchoolId = school_id;
    var filterThru = localStorageService.get('can_filter');
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    // let currentYear= _.find(allAcademic_year, function (object) {
    //     return object.status == 'active'
    // })

    if (filterThru == "true") {
        filterThru = true;
    } else {
        filterThru = undefined;
    }
    var insideCourseware = false;
    var LEVEL_ARRAY = [{
        level: "1",
        alias: "Easy"
    }, {
        level: "2",
        alias: "Medium"
    }, {
        level: "3",
        alias: "Difficult"
    }];
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Individual Student Report";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };
    $scope.barcodeToHtml = function () {
        var lines = $scope.REFERENCE.bcode.lines;
        var barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber;
        return $sce.trustAsHtml(lines + barcodeNumber);
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        setAcademic();
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;

        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getClass = function (curriculum) {
        setAcademic();
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classes = response.result.data.details;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getBatch = function (xclass) {
        setAcademic();
        $scope.selectAcademics.class = xclass;
        $scope.toSearchObj.class = $scope.selectAcademics.class._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.batches = response.result.data.details;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getSubject = function (batch) {
        setAcademic();
        $scope.selectAcademics.batch = batch;
        $scope.selectAcademics.subject = undefined;
        $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year) {
            if ($scope.toSearchObj.academic_year.year) {
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
            }
        }
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.subjects = response.result.data.details;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.fetchReport = function (subject) {
        $scope.selectAcademics.subject = subject;
        $scope.selectedAcademics = angular.copy($scope.selectAcademics);
        $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
    };
    $scope.getReport = function (academic_year) {
        $scope.toSearchObj.academic_year = academic_year;
    };
    $scope.findReport = function () {
        $scope.getStudents($scope.toSearchObj);
    };
    $scope.getStudents = function (toSearchObj) {

        if (toSearchObj) {

            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                template: _studentpopupList2.default,
                controller: ['$scope', '$mdDialog', "toSearchObj", "authService", 'parentScopeObj', 'localStorageService', StudentsCtrl],
                parent: angular.element(document.body),
                locals: {
                    toSearchObj: toSearchObj,
                    parentScopeObj: $scope,
                    authService: authService,
                    localStorageService: localStorageService
                },
                clickOutsideToClose: true,
                fullscreen: true
            }).then(function () {}, function () {
                $scope.status = 'You cancelled the dialog.';
            });
        }
    };
    $scope.uCanTrust = function (obj) {
        // string = "<span style='color: #89a000'>123</span>"
        if (obj && obj.color) {
            var color = obj.color['background-color'];
            var string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
            return $sce.trustAsHtml(string);
        }
    };
    $scope.getStudentReport = function (academics, user_id) {

        $scope.loading = true;
        var send = {
            "conditions": {
                "class_id": academics.class_id,
                "curriculum_id": academics.curriculum_id,
                "batch_id": academics.batch_id,
                "subject_id": academics.subject_id,
                "session_id": academics.session_id,
                "school_id": academics.school_id
            },
            "myUserId": myUserId,
            "acdYear": academics.academic_year ? academics.academic_year : activeAcd,
            "student_id": user_id,
            "pdfFlag": false,
            "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
            "SITE_URL": CONSTANTS.FILE_UPLOAD_URL + "/uploads/"
        };
        authService.callAPI("/v0/educore_reports/individual_report", "POST", { args: send }, function (resp) {
            try {
                if (!resp.error) {
                    var response = resp.result.data.details;
                    console.log(response);
                    self.activitiesConducted = response.activitiesConducted ? response.activitiesConducted : [];

                    $scope.REFERENCE = response.REFERENCE;
                    var data_set = response.typesArr;
                    data_set = _.groupBy(data_set, function (val) {
                        return val.theme_id;
                    });
                    if (response.activitiesConducted.length) {
                        self.noData = false;
                    } else {
                        self.noData = true;
                    }

                    var obj = {};
                    var levelObj = {};
                    var tagObj = {};
                    var themeArray = [];
                    var typeArray = response.pluckTypes;
                    var tagArray = response.tagArray;
                    _.each(data_set, function (array, themeId) {
                        obj[themeId] = {};
                        levelObj[themeId] = {};
                        tagObj[themeId] = {};
                        themeArray.push(themeId);
                        var pluckTypeThiisTheme = _.uniq(_.pluck(array, "type"));
                        _.each(pluckTypeThiisTheme, function (oneType) {
                            var findThisType = _.filter(array, function (object) {
                                return object.type == oneType;
                            });
                            var score = undefined;
                            if (findThisType) {
                                score = findThisType.sum("score");
                            }
                            obj[themeId][oneType] = score;
                        });
                        _.each(LEVEL_ARRAY, function (oneLevel) {
                            var findThisLevel = _.filter(array, function (object) {
                                return object && object.level && object.level.length && object.level.indexOf(oneLevel.level) != -1;
                            });
                            var score = undefined;
                            score = findThisLevel ? findThisLevel.sum("score") : 0;
                            levelObj[themeId][oneLevel.alias] = score;
                        });

                        _.each(tagArray, function (oneTag) {
                            var findThisTag = _.filter(array, function (object) {
                                return object && object.tags && object.tags.indexOf(oneTag) != -1;
                            });
                            var score = undefined;
                            score = findThisTag ? findThisTag.sum("score") : 0;
                            tagObj[themeId][oneTag] = score;
                        });
                    });

                    self.level_set = levelObj;
                    self.levels = LEVEL_ARRAY;
                    self.data_set = obj;
                    self.typeArray = typeArray;
                    self.tagArray = tagArray;
                    self.tag_set = tagObj;
                    var themeCount = 1;
                    _.each(response.themesArr, function (oneTheme) {
                        oneTheme.alias = "C" + themeCount;
                        themeCount++;
                    });
                    self.themeArray = response.themesArr;
                    self.data = response.data;
                    self.level = response.level;
                    self.tag = response.tag;
                    self.avgPerTheme = response.avgPerTheme;
                    self.avgTagPerTheme = response.avgTagPerTheme;
                    self.avgLevelPerTheme = response.avgLevelPerTheme;

                    self.typeOver = response.typeOver;
                    self.levelOver = response.levelOver;
                    self.tagOver = response.tagOver;
                    self.header = response.header;
                    self.classMethod = response.classMethod;
                    self.generator = response.generator;
                    self.allThemeTotal = response.allThemeTotal;
                    self.highest = response.highest;
                    self.allThemeLevelObj = response.allThemeLevelObj;
                    self.allThemeTagObj = response.allThemeTagObj;
                    var colSpanCountTag = 4; //setting collspan length in tag overalll
                    colSpanCountTag = colSpanCountTag + response.themesArr.length;
                    self.tagCollSpan = colSpanCountTag;
                    $scope.urls = response.pdfdata;
                } else {
                    self.noData = true;
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                $scope.loading = false;
                console.log(e);
            }
        });
    };

    // self.export = () => {
    //     $scope.loading = true

    // }
    self.export = function () {
        $scope.loading = true;
        $scope.pdfData = true;

        $scope.url = $sce.trustAsResourceUrl($scope.urls);

        $scope.loading = false;
        _.defer(function () {
            $scope.$apply();
        });;
    };
    self.backToHtml = function () {
        $scope.pdfData = false;
    };
    $scope.ref_code = undefined;
    $scope.submitRefCode = function () {
        $scope.loading = true;
        authService.callAPI("/v0/educore-reports/getreportbyreference", "POST", { args: {
                ref_code: $scope.ref_code,
                type: 'student_report',
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                user_id: myUserId
            } }, function (resp) {
            try {
                if (!resp.error) {
                    var response = resp.result.data.details;
                    $scope.reference_data = resp.result.data.reference_data;
                    console.log($scope.reference_data);
                    self.activitiesConducted = response.activitiesConducted ? response.activitiesConducted : [];

                    var data_set = response.typesArr;
                    data_set = _.groupBy(data_set, function (val) {
                        return val.theme_id;
                    });
                    if (response.activitiesConducted.length) {
                        self.noData = false;
                    } else {
                        self.noData = true;
                    }

                    var obj = {};
                    var levelObj = {};
                    var tagObj = {};
                    var themeArray = [];
                    var typeArray = response.pluckTypes;
                    var tagArray = response.tagArray;
                    _.each(data_set, function (array, themeId) {
                        obj[themeId] = {};
                        levelObj[themeId] = {};
                        tagObj[themeId] = {};
                        themeArray.push(themeId);
                        var pluckTypeThiisTheme = _.uniq(_.pluck(array, "type"));
                        _.each(pluckTypeThiisTheme, function (oneType) {
                            var findThisType = _.filter(array, function (object) {
                                return object.type == oneType;
                            });
                            var score = undefined;
                            if (findThisType) {
                                score = findThisType.sum("score");
                            }
                            obj[themeId][oneType] = score;
                        });
                        _.each(LEVEL_ARRAY, function (oneLevel) {
                            var findThisLevel = _.filter(array, function (object) {
                                return object.level.indexOf(oneLevel.level) != -1;
                            });
                            var score = undefined;
                            score = findThisLevel ? findThisLevel.sum("score") : 0;
                            levelObj[themeId][oneLevel.alias] = score;
                        });

                        _.each(tagArray, function (oneTag) {
                            var findThisTag = _.filter(array, function (object) {
                                return object && object.tags && object.tags.indexOf(oneTag) != -1;
                            });
                            var score = undefined;
                            score = findThisTag ? findThisTag.sum("score") : 0;
                            tagObj[themeId][oneTag] = score;
                        });
                    });

                    self.level_set = levelObj;
                    self.levels = LEVEL_ARRAY;
                    self.data_set = obj;
                    self.typeArray = typeArray;
                    self.tagArray = tagArray;
                    self.tag_set = tagObj;
                    var themeCount = 1;
                    _.each(response.themesArr, function (oneTheme) {
                        oneTheme.alias = "C" + themeCount;
                        themeCount++;
                    });
                    self.themeArray = response.themesArr;
                    self.data = response.data;
                    self.level = response.level;
                    self.tag = response.tag;
                    self.avgPerTheme = response.avgPerTheme;
                    self.avgTagPerTheme = response.avgTagPerTheme;
                    self.avgLevelPerTheme = response.avgLevelPerTheme;

                    self.typeOver = response.typeOver;
                    self.levelOver = response.levelOver;
                    self.tagOver = response.tagOver;
                    self.header = response.header;
                    self.classMethod = response.classMethod;
                    self.generator = response.generator;
                    self.allThemeTotal = response.allThemeTotal;
                    self.highest = response.highest;
                    self.allThemeLevelObj = response.allThemeLevelObj;
                    self.allThemeTagObj = response.allThemeTagObj;
                    var colSpanCountTag = 4; //setting collspan length in tag overalll
                    colSpanCountTag = colSpanCountTag + response.themesArr.length;
                    self.tagCollSpan = colSpanCountTag;
                    $scope.urls = response.pdfdata;
                } else {
                    self.noData = true;
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    };

    function setAcademic() {
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year && $scope.toSearchObj.academic_year._id) {
            $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
        }
    }
};
StudentFilteration.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog"];

Array.prototype.sum = function (prop) {
    var total = 0;
    for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][prop];
    }
    return total;
};

var StudentsCtrl = function StudentsCtrl($scope, $mdDialog, toSearchObj, authService, parentScopeObj, localStorageService) {
    _classCallCheck(this, StudentsCtrl);

    var send = {
        session_id: toSearchObj.session,
        curriculum_id: toSearchObj.curriculum,
        class_id: toSearchObj.class,
        batch_id: toSearchObj.batch,
        subject_id: toSearchObj.subject,
        school_id: toSearchObj.school_id,
        academic_year: toSearchObj.academic_year.year
    };

    authService.callAPI("/v0/educore_reports/student/list", "POST", { args: send }, function (response) {
        if (!response.error) {
            var res = response.result.data.details;
            $scope.studentList = res;
            $scope.$apply();
        }
    });
    $scope.gotoStudentSubjectReport = function (user_id) {
        $mdDialog.hide();
        parentScopeObj.getStudentReport(send, user_id);
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};

exports.default = StudentFilteration;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClassActivityReportCard = function ClassActivityReportCard($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
    'ngInject';

    _classCallCheck(this, ClassActivityReportCard);

    var self = this;
    $rootScope.title = "Class Report";
    $scope.loading = true;
    self.typeArray = undefined;
    self.levelArray = undefined;
    self.resPerTheme = undefined;
    self.tagArr = undefined;
    self.data_set = undefined;
    self.header = undefined;
    self.perTypeObj = {};
    self.perTagObj = {};
    self.perLevelObj = {};
    self.themeTotal = undefined;
    self.no_of_students = undefined;
    self.allThemeTotal = {};
    self.noData = true;
    $scope.view_only = false;
    $scope.filterObj = {};
    self.noAcademics = true;
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    var thisSchoolId = school_id;
    var filterThru = localStorageService.get('can_filter');
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    if (filterThru == "true") {
        filterThru = true;
    } else {
        filterThru = undefined;
    }
    var insideCourseware = false;
    var LEVEL_ARRAY = [{
        level: "1",
        alias: "Easy"
    }, {
        level: "2",
        alias: "Medium"
    }, {
        level: "3",
        alias: "Difficult"
    }];
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Class Report";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        self.noData = true;
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        self.noData = true;
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year) {
            if ($scope.toSearchObj.academic_year.year) {
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
            }
        }
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getClass = function (curriculum) {
        self.noData = true;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year) {
            if ($scope.toSearchObj.academic_year.year) {
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
            }
        }
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classes = response.result.data.details;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getBatch = function (xclass) {
        self.noData = true;
        $scope.selectAcademics.class = xclass;
        $scope.toSearchObj.class = $scope.selectAcademics.class._id;
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year) {
            if ($scope.toSearchObj.academic_year.year) {
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
            }
        }
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.batches = response.result.data.details;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getSubject = function (batch) {
        console.log(batch);
        self.noData = true;
        $scope.selectAcademics.batch = batch;
        $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
        if ($scope.toSearchObj && $scope.toSearchObj.academic_year) {
            if ($scope.toSearchObj.academic_year.year) {
                $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year.year;
            }
        }

        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.subjects = response.result.data.details;
                    console.log($scope.subjects);
                    $scope.selectAcademics.subject = undefined;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.fetchReport = function (subject) {
        self.noData = true;
        $scope.selectAcademics.subject = subject;
        $scope.selectedAcademics = angular.copy($scope.selectAcademics);
        $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
    };
    $scope.getReport = function (year) {
        $scope.toSearchObj.academic_year = year;
    };
    $scope.uCanTrust = function (obj) {
        // string = "<span style='color: #89a000'>123</span>"
        if (obj && obj.color) {
            var color = obj.color['background-color'];
            var string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
            return $sce.trustAsHtml(string);
        }
    };
    $scope.barcodeToHtml = function () {
        var lines = $scope.REFERENCE.bcode.lines;
        var barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber;
        return $sce.trustAsHtml(lines + barcodeNumber);
    };

    var authoring = localStorageService.get('authoringData');
    // loadData(authoring)
    function loadData(academics) {
        $scope.loading = true;
        self.noAcademics = false;
        self.academicsForExp = academics;
        var send = {
            "conditions": {
                "class_id": academics.class,
                "curriculum_id": academics.curriculum,
                "batch_id": academics.batch,
                "subject_id": academics.subject,
                "session_id": academics.session,
                "school_id": school_id
            },
            "myUserId": myUserId,
            "acdYear": academics.academic_year ? academics.academic_year.year : activeAcd,
            // "student_id": "q72pkhd4GGKeoy7sA",
            "pdfFlag": false,
            "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
            "SITE_URL": CONSTANTS.SITE_URL

            // return false
        };authService.callAPI("/v0/educore_reports/clasReportRedef", "POST", { args: send }, function (resp) {
            try {

                console.log('sendsendsendsend');
                if (!resp.error) {
                    var response = resp.result.data.details;
                    console.log(response);
                    if (response.typesUsed && response.typesUsed.length) {
                        self.noData = false;
                    } else {
                        toastr.error("No results available");
                        self.noData = true;
                    }

                    var data = response;
                    var typeData = data.type_obj;
                    self.themeArray = data.themeArray;
                    self.header = data.header;
                    self.typeArray = data.typesUsed;
                    self.data_set = data.type_obj;
                    self.level_set = data.level_obj;
                    self.tag_set = data.tag_obj;
                    self.perTypeObj = data.type_total;
                    self.perLevelObj = data.level_total;
                    self.perTagObj = data.tag_total;
                    self.levelArray = LEVEL_ARRAY;
                    self.tagArr = data.tagsUsed;
                    self.allScorePerTheme = data.allScorePerTheme;
                    self.allThemeTotal = data.allThemeTotal;
                    self.no_of_students = data.batchStudentIds.length;
                    self.highest = data.highest;
                    self.levelAveragesPerTheme = data.levelAveragesPerTheme;
                    self.tagAveragesPerTheme = data.tagAveragesPerTheme;
                    self.totalLevelObj = data.totalLevelObj;
                    self.totalTagObj = data.totalTagObj;
                    self.generated_date = data.generated_date;
                    self.generated_by = data.generated_by;
                    var colSpanCountTag = 4;
                    colSpanCountTag = colSpanCountTag + self.themeArray.length;
                    self.tagCollSpan = colSpanCountTag;
                    $scope.urls = data.pdf_url;
                    $scope.REFERENCE = data.REFERENCE;
                } else {
                    $scope.loading = false;
                    toastr.error("Network error");
                }
            } catch (e) {

                console.log(e);
            }

            $scope.loading = false;
            $scope.$apply();
        });
    }

    $scope.findReport = function () {
        if (!$scope.toSearchObj.academic_year) {
            toastr.error("please select year");
            return false;
        }
        loadData($scope.toSearchObj);
    };
    self.export = function () {
        // $scope.loading = true
        $scope.isPdfData = true;
        console.log($scope.urls);
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };
    self.backToHtml = function () {
        $scope.isPdfData = false;
    };
    $scope.ref_code = undefined;
    $scope.submitRefCode = function () {
        $scope.loading = true;
        authService.callAPI("/v0/educore-reports/getreportbyreference", "POST", { args: {
                ref_code: $scope.ref_code,
                type: 'class_report',
                FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
                user_id: myUserId
            } }, function (resp) {
            try {
                if (!resp.error) {
                    var response = resp.result.data.details;
                    console.log(response);
                    if (response.typesUsed && response.typesUsed.length) {
                        self.noData = false;
                    } else {
                        toastr.error("No results available");
                        self.noData = true;
                    }
                    var data = response;
                    var typeData = data.type_obj;
                    self.themeArray = data.themeArray;
                    self.header = data.header;
                    self.typeArray = data.typesUsed;
                    self.data_set = data.type_obj;
                    self.level_set = data.level_obj;
                    self.tag_set = data.tag_obj;
                    self.perTypeObj = data.type_total;
                    self.perLevelObj = data.level_total;
                    self.perTagObj = data.tag_total;
                    self.levelArray = LEVEL_ARRAY;
                    self.tagArr = data.tagsUsed;
                    self.allScorePerTheme = data.allScorePerTheme;
                    self.allThemeTotal = data.allThemeTotal;
                    self.no_of_students = data.batchStudentIds.length;
                    self.highest = data.highest;
                    self.levelAveragesPerTheme = data.levelAveragesPerTheme;
                    self.tagAveragesPerTheme = data.tagAveragesPerTheme;
                    self.totalLevelObj = data.totalLevelObj;
                    self.totalTagObj = data.totalTagObj;
                    self.generated_date = data.generated_date;
                    self.generated_by = data.generated_by;
                    var colSpanCountTag = 4;
                    colSpanCountTag = colSpanCountTag + self.themeArray.length;
                    self.tagCollSpan = colSpanCountTag;
                    $scope.urls = data.pdf_url;
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    };
};
ClassActivityReportCard.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS"];

exports.default = ClassActivityReportCard;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EducoreStandardReport = function EducoreStandardReport($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
    'ngInject';

    _classCallCheck(this, EducoreStandardReport);

    var self = this;
    $rootScope.title = "Standard Report";
    $scope.loading = true;
    $scope.filterObj = {};
    self.noAcademics = true;
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    var thisSchoolId = school_id;
    var filterThru = localStorageService.get('can_filter');
    var insideCourseware = false;
    var LEVEL_ARRAY = [{
        level: "1",
        alias: "Easy"
    }, {
        level: "2",
        alias: "Medium"
    }, {
        level: "3",
        alias: "Difficult"
    }];
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Standard Report";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        self.noData = true;
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        self.noData = true;
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getClass = function (curriculum) {

        self.noData = true;
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classes = response.result.data.details;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getBatch = function (xclass) {

        self.noData = true;
        $scope.selectAcademics.class = xclass;
        $scope.toSearchObj.class = $scope.selectAcademics.class._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.batches = response.result.data.details;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getSubject = function (batch) {

        self.noData = true;
        $scope.selectAcademics.batch = batch;
        $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.subjects = response.result.data.details;
                    $scope.selectAcademics.subject = undefined;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.fetchReport = function (subject) {

        self.noData = true;
        $scope.selectAcademics.subject = subject;
        $scope.selectedAcademics = angular.copy($scope.selectAcademics);
        $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
        loadData($scope.toSearchObj);
    };

    $scope.uCanTrust = function (obj) {
        // string = "<span style='color: #89a000'>123</span>"
        if (obj && obj.color) {
            var color = obj.color['background-color'];
            var string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
            return $sce.trustAsHtml(string);
        }
    };
    var authoring = localStorageService.get('authoringData');
    // loadData(authoring)
    function loadData(academics) {
        $scope.loading = true;
        self.noAcademics = false;
        self.academicsForExp = academics;
        var send = {
            "conditions": {
                "class_id": academics.class,
                "curriculum_id": academics.curriculum,
                "batch_id": academics.batch,
                "subject_id": academics.subject,
                "session_id": academics.session,
                "school_id": school_id
            },
            "myUserId": myUserId,
            "acdYear": activeAcd,
            // "student_id": "q72pkhd4GGKeoy7sA",
            "pdfFlag": false,
            "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
            "SITE_URL": CONSTANTS.SITE_URL
        };
        authService.callAPI("/v0/educore_reports/standardEducore", "POST", { args: send }, function (resp) {
            try {
                if (!resp.error) {
                    var result = resp.result.data.details;
                    console.log(resp);
                    if (result.types.length) {
                        self.hasResult = true;
                    } else {
                        self.hasResult = false;
                    }
                    self.themeArray = result.themeDocs;

                    self.typeArray = result.types;
                    self.tagArr = result.tags;
                    self.levelArray = LEVEL_ARRAY;
                    self.data_set = result.themeObj;
                    self.tag_all_theme = result.tag_all_theme;
                    self.level_all_theme = result.level_all_theme;
                    self.type_all_theme = result.type_all_theme;
                    self.batchObjArray = result.batchObjArray;
                    self.batchArray = result.batchArray;
                    self.scorePerBatch = result.scorePerBatch;
                    self.allThemeTotalAllBatch = result.allThemeTotalAllBatch;
                    self.header = result.header;
                    self.bestSection = result.bestSection;
                    self.lowestTheme = result.lowestTheme;
                    self.bestTheme = result.bestTheme;
                    self.total_score_per_batch = result.total_score_per_batch;
                    self.levelAveragesPerTheme = result.levelAveragesPerTheme;
                    self.tagAveragesPerTheme = result.tagAveragesPerTheme;
                    self.typeAveragesPerTheme = result.typeAveragesPerTheme;
                    self.totalTypeObj = result.totalTypeObj;
                    self.totalLevelObj = result.totalLevelObj;
                    self.totalTagObj = result.totalTagObj;
                    self.generated_date = result.generated_date;
                    self.generated_by = result.generated_by;
                    var colSpanCountTag = 4; //setting collspan length in tag overalll
                    colSpanCountTag = colSpanCountTag + self.themeArray.length;
                    self.tagCollSpan = colSpanCountTag;
                    $scope.urls = result.pdf_url;
                } else {
                    console.log(resp.error);
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                $scope.loading = false;
                $scope.$apply();
                console.log(e);
            }
        });
    }

    self.export = function () {
        // $scope.loading = true
        $scope.isPdfData = true;
        console.log($scope.urls);
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };
    self.backToHtml = function () {
        $scope.isPdfData = false;
    };
};
EducoreStandardReport.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS"];

exports.default = EducoreStandardReport;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EducorePerformanceAnalysis = function EducorePerformanceAnalysis($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS) {
    'ngInject';

    _classCallCheck(this, EducorePerformanceAnalysis);

    $rootScope.title = "Performance Analysis";
    var self = this;
    var author = localStorageService.get('authoringData');
    $scope.showList = false;
    $scope.isPdfData = false;
    $scope.loading = true;
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    var thisSchoolId = school_id;
    var filterThru = localStorageService.get('can_filter');
    if (filterThru == "true") {
        filterThru = true;
    } else {
        filterThru = undefined;
    }
    var insideCourseware = false;
    var LEVEL_ARRAY = [{
        level: "1",
        alias: "Easy"
    }, {
        level: "2",
        alias: "Medium"
    }, {
        level: "3",
        alias: "Difficult"
    }];
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};
    $scope.allAcademic_year = localStorageService.get('allAcademic_year');
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Performance Analysis";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        $scope.hasResult = false;
        var searchObj = $scope.toSearchObj;
        searchObj.academic_year = activeAcd;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", searchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getClass = function (curriculum) {
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classes = response.result.data.details;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getBatch = function (xclass) {
        $scope.selectAcademics.class = xclass;
        $scope.toSearchObj.class = $scope.selectAcademics.class._id;

        $scope.loading = true;
        setTimeout(function () {
            $scope.toSearchObj.academic_year_selected = $scope.toSearchObj.academic_year;
            if ($scope.toSearchObj.academic_year && $scope.toSearchObj.academic_year.year) {
                var year = $scope.toSearchObj.academic_year.year;
                $scope.getReport(year);
            }
            $scope.toSearchObj.academic_year = $scope.toSearchObj.academic_year_selected;
            $scope.loading = false;
        }, 100);

        // authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
        //     if (response.result && response.result.data && response.result.data.details) {
        //         try {
        //             $scope.batches = response.result.data.details;
        //             $scope.selectAcademics.batch = undefined;
        //             $scope.selectAcademics.subject = undefined;
        //             $scope.subjects = [];
        //         } catch (ex) {
        //             console.log(ex);
        //         }
        //     } else {
        //         toastr.error('Network Error. Please try later');
        //     }
        //     _.defer(function () {
        //         $scope.$apply();
        //     });
        // });
    };
    $scope.getReport = function (year) {
        $scope.loading = false;
        $scope.toSearchObj.academic_year = year;
        loadStReport(thisSchoolId, $scope.toSearchObj);
    };
    $scope.getSubject = function (batch) {
        $scope.selectAcademics.batch = batch;
        $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.subjects = response.result.data.details;
                    $scope.selectAcademics.subject = undefined;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };
    $scope.fetchReport = function (subject) {
        $scope.selectAcademics.subject = subject;
        $scope.selectedAcademics = angular.copy($scope.selectAcademics);
        $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
        loadStReport(thisSchoolId, $scope.toSearchObj);
    };
    $scope.barcodeToHtml = function () {
        var lines = $scope.REFERENCE.bcode.lines;
        var barcodeNumber = $scope.REFERENCE.bcode.barcodeNumber;
        return $sce.trustAsHtml(lines + barcodeNumber);
    };
    function loadStReport(thisSchoolId, academics) {
        self.noselection = false;
        $scope.loading = true;
        self.academicsForPdf = academics;
        console.log(academics);
        var send = {
            "conditions": {
                "class_id": academics.class,
                "curriculum_id": academics.curriculum,
                "batch_id": academics.batch ? academics.batch : undefined,
                "subject_id": academics.subject ? academics.subject : undefined,
                "session_id": academics.session,
                "school_id": localStorageService.get('school_id')
            },
            "myUserId": myUserId,
            "acdYear": academics.academic_year ? academics.academic_year : activeAcd,
            // "student_id": "q72pkhd4GGKeoy7sA",
            "pdfFlag": false,
            "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL,
            "SITE_URL": CONSTANTS.SITE_URL
        };
        console.log(send);
        authService.callAPI("/v0/educore_reports/educorePerformanceAnalysis", "POST", { args: send }, function (resp) {
            try {

                if (!resp.error) {
                    var result = resp.result.data.details;
                    console.log(result);
                    if (result.settSubject.length) {
                        self.hasResult = true;
                    } else {
                        self.hasResult = false;
                        $scope.showNoActivitiesFlag = true;
                    }

                    console.log(self.hasResult);
                    $scope.REFERENCE = result.REFERENCE;
                    self.settSubject = result.settSubject;
                    self.settBatch = result.settBatch;
                    self.average_per_term = result.ret_val.average_per_term;
                    self.reportCardConsoleDetails = result.reportCardConsoleDetails;
                    self.section_performance = result.ret_val.section_performance;
                    self.needing_attention = result.ret_val.needing_attention;
                    self.less_than_sixty = result.less_than_sixty;
                    self.average_per_term_color = result.ret_val.average_per_term_color;
                    self.header = result.header;
                    self.generator = result.generator;
                    $scope.urls = result.pdf_url;
                    // console.log(self.average_per_term)
                    // console.log(self.average_per_term_color)
                    $scope.loading = false;
                    $scope.$apply();
                } else {
                    $scope.loading = false;
                    toastr.error("Network error");
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                $scope.loading = false;
                $scope.$apply();
                console.log(e);
            }

            $scope.loading = false;
            $scope.$apply();
        });
        //   Meteor.call('educorePerformanceAnalysis', thisSchoolId, academics, false, function(err, result){
        //       if(result){
        //           console.log(result)
        //           // if(result.settSubject.length){
        //           //     self.noData = false
        //           // }
        //           if(result.settSubject.length){
        //               self.hasResult = true
        //           }else{
        //               self.hasResult = false
        //           }
        //           self.settSubject = result.settSubject
        //           self.settBatch = result.settBatch
        //           self.average_per_term = result.ret_val.average_per_term
        //           self.reportCardConsoleDetails = result.reportCardConsoleDetails
        //           self.section_performance = result.ret_val.section_performance
        //           self.needing_attention = result.ret_val.needing_attention
        //           self.less_than_sixty = result.less_than_sixty
        //           self.average_per_term_color = result.ret_val.average_per_term_color
        //           self.header = result.header
        //           self.generator = result.generator
        //           // console.log(self.average_per_term)
        //           // console.log(self.average_per_term_color)
        //           $scope.loading = false
        //           $scope.$apply()
        //       }
        //   })
    }

    // self.noData = true
    // self.acd = author.session +"/"+ author.curriculum+"/"+author.class+"/"+author.batch


    self.goToThisTermAtention = function (report_console, subject) {
        console.log(self.settSubject);
        self.subjectSelected = subject.name;
        self.selectedReport = report_console.report_name;
        Meteor.call('getMarksPerRcLessThanSixty', author.school_id, Session.get('authoringData'), subject._id, self.settSubject, function (err, res) {
            console.log(res);
            self.studentData = res.studentData;
            self.reportCardConsoleDetails = res.reportCardConsoleDetails;
            $scope.showList = true;
            $scope.$apply();
        });
    };
    self.backToHtml = function () {
        $scope.isPdfData = false;
    };
    self.export = function () {
        // $scope.loading = true
        $scope.isPdfData = true;
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };

    self.showHideSubjectr = function (subject) {
        _.each(self.settSubject, function (oneSubject) {
            if (oneSubject._id == subject._id) {
                if (subject.is_active) {
                    oneSubject.is_active = false;
                } else {
                    oneSubject.is_active = true;
                }
            } else {
                oneSubject.is_active = false;
            }
        });
    };
};
EducorePerformanceAnalysis.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS"];

exports.default = EducorePerformanceAnalysis;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _studentpopupList = __webpack_require__(899);

var _studentpopupList2 = _interopRequireDefault(_studentpopupList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var myCumulativeReport = function myCumulativeReport($scope, $state, $stateParams, $sce, $rootScope, authService, localStorageService, RESULT_ANALYSIS_CONSTANTS, CONSTANTS, $mdMedia, $mdDialog) {
    'ngInject';

    _classCallCheck(this, myCumulativeReport);

    var self = this;
    $rootScope.title = "Cumulative Report";
    $scope.loading = true;
    self.typeArray = undefined;
    self.levelArray = undefined;
    self.resPerTheme = undefined;
    self.tagArr = undefined;
    self.data_set = undefined;
    self.header = undefined;
    self.perTypeObj = {};
    self.perTagObj = {};
    self.perLevelObj = {};
    self.themeTotal = undefined;
    self.no_of_students = undefined;
    self.allThemeTotal = {};
    self.noData = true;
    $scope.view_only = false;
    $scope.filterObj = {};
    self.noAcademics = true;
    var myUserId = localStorageService.get('user_id');
    var activeAcd = localStorageService.get('academic_year');
    var school_id = localStorageService.get('school_id');
    var thisSchoolId = school_id;
    var filterThru = localStorageService.get('can_filter');
    if (filterThru == "true") {
        filterThru = true;
    } else {
        filterThru = undefined;
    }
    var insideCourseware = false;
    var LEVEL_ARRAY = [{
        level: "1",
        alias: "Easy"
    }, {
        level: "2",
        alias: "Medium"
    }, {
        level: "3",
        alias: "Difficult"
    }];
    //Boolean - To set view for fetch
    $scope.isFilter = true;

    //Object - Holds selection data
    $scope.selectAcademics = {};

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Cumulative Report";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getSession();
    };

    function getSession() {
        $scope.toSearchObj = {
            user_id: myUserId,
            school_id: school_id,
            academic_year: activeAcd,
            exam: {
                $exists: 1
            }
        };
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SESSION_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.sessions = response.result.data.details;
                    $scope.selectAcademics.session = undefined;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.curriculums = [];
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                    $scope.loading = false;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.loading = false;
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }

    $scope.getCuriculum = function (session) {
        $scope.selectAcademics.session = session;
        $scope.toSearchObj.session = $scope.selectAcademics.session._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CURRICULUM_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.curriculums = response.result.data.details;
                    $scope.selectAcademics.curriculum = undefined;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.classes = [];
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getClass = function (curriculum) {
        $scope.selectAcademics.curriculum = curriculum;
        $scope.toSearchObj.curriculum = $scope.selectAcademics.curriculum._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_CLASS_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classes = response.result.data.details;
                    $scope.selectAcademics.class = undefined;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.batches = [];
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getBatch = function (xclass) {
        $scope.selectAcademics.class = xclass;
        $scope.toSearchObj.class = $scope.selectAcademics.class._id;
        authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_BATCH_DETAILS, "POST", $scope.toSearchObj, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.batches = response.result.data.details;
                    $scope.selectAcademics.batch = undefined;
                    $scope.selectAcademics.subject = undefined;
                    $scope.subjects = [];
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.getSubject = function (batch) {
        $scope.selectAcademics.batch = batch;
        $scope.toSearchObj.batch = $scope.selectAcademics.batch._id;
        $scope.getStudents($scope.toSearchObj);
        // authService.callAPI(RESULT_ANALYSIS_CONSTANTS.API_GET_SUBJECT_DETAILS, "POST", $scope.toSearchObj, function (response) {
        //     if (response.result && response.result.data && response.result.data.details) {
        //         try {
        //             $scope.subjects = response.result.data.details;
        //             $scope.selectAcademics.subject = undefined;
        //         } catch (ex) {
        //             console.log(ex);
        //         }
        //     } else {
        //         toastr.error('Network Error. Please try later');
        //     }
        //     _.defer(function () {
        //         $scope.$apply();
        //     });
        // });
    };
    // $scope.fetchReport = function (subject) {
    //     $scope.selectAcademics.subject = subject;
    //     $scope.selectedAcademics = angular.copy($scope.selectAcademics);
    //     $scope.toSearchObj.subject = $scope.selectAcademics.subject._id;
    //     $scope.getStudents($scope.toSearchObj)
    // }

    $scope.getStudents = function (toSearchObj) {
        console.log(toSearchObj);
        if (toSearchObj) {
            console.log(toSearchObj);
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                template: _studentpopupList2.default,
                controller: ['$scope', '$mdDialog', "toSearchObj", "authService", 'parentScopeObj', 'localStorageService', StudentsCtrl],
                parent: angular.element(document.body),
                locals: {
                    toSearchObj: toSearchObj,
                    parentScopeObj: $scope,
                    authService: authService,
                    localStorageService: localStorageService
                },
                clickOutsideToClose: true,
                fullscreen: true
            }).then(function () {}, function () {
                $scope.status = 'You cancelled the dialog.';
            });
        }
    };
    $scope.uCanTrust = function (obj) {
        // string = "<span style='color: #89a000'>123</span>"
        if (obj && obj.color) {
            var color = obj.color['background-color'];
            var string = '<span class="td-color" style="background-color:' + color + ';">' + obj.score + '</span>';
            return $sce.trustAsHtml(string);
        }
    };
    $scope.getStudentReport = function (academics, user_id) {
        $scope.loading = true;
        var send = {
            "curriculumId": academics.curriculum_id,
            "sessionId": academics.session_id,
            "schoolId": academics.school_id,
            "pdfFlag": "false",
            "myUserId": myUserId,
            "acdYear": activeAcd,
            "studentId": user_id,
            "student_id": user_id,
            "FILE_UPLOAD_URL": CONSTANTS.FILE_UPLOAD_URL
        };
        authService.callAPI("/v0/educore_reports/cumulative", "POST", { args: send }, function (resp) {
            try {
                if (!resp.error) {
                    var result = resp.result.data.details;
                    console.log(result);
                    if (result.scholasticSubjects.length || result.extraSubjectArray.length) {
                        self.noData = false;
                    }
                    self.scholasticSubjects = result.scholasticSubjects;
                    self.subject_report = result.subject_report;
                    self.reportCardConsoleDetails = result.reportCardConsoleDetails;
                    self.returnArray = result.returnArray;
                    self.relationValue = result.relationValue;
                    self.overallAcg = result.overallAcg;
                    self.classAvg = result.classAvg;
                    self.extraSubjectArray = result.extraSubjectArray;
                    self.extraSubjectData = result.extraSubjectData;
                    self.header = result.header;
                    $scope.urls = result.pdf_url;
                    $scope.loading = false;
                    $scope.$apply();
                } else {
                    self.noData = true;
                }
                $scope.loading = false;
                $scope.$apply();
            } catch (e) {
                $scope.loading = false;
                console.log(e);
            }
        });
    };

    self.export = function () {
        $scope.isPdfData = true;
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
        _.defer(function () {
            $scope.$apply();
        });;
    };
    self.backToHtml = function () {
        $scope.isPdfData = false;
    };
};
myCumulativeReport.$inject = ["$scope", "$state", "$stateParams", "$sce", "$rootScope", "authService", "localStorageService", "RESULT_ANALYSIS_CONSTANTS", "CONSTANTS", "$mdMedia", "$mdDialog"];

Array.prototype.sum = function (prop) {
    var total = 0;
    for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][prop];
    }
    return total;
};

var StudentsCtrl = function StudentsCtrl($scope, $mdDialog, toSearchObj, authService, parentScopeObj, localStorageService) {
    _classCallCheck(this, StudentsCtrl);

    var send = {
        session_id: toSearchObj.session,
        curriculum_id: toSearchObj.curriculum,
        class_id: toSearchObj.class,
        batch_id: toSearchObj.batch,
        subject_id: toSearchObj.subject ? toSearchObj.subject : undefined,
        school_id: toSearchObj.school_id
    };
    authService.callAPI("/v0/educore_reports/student/list", "POST", { args: send }, function (response) {
        if (!response.error) {
            var res = response.result.data.details;
            $scope.studentList = res;
            $scope.$apply();
        }
    });
    $scope.gotoStudentSubjectReport = function (user_id) {
        $mdDialog.hide();
        parentScopeObj.getStudentReport(send, user_id);
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};

exports.default = myCumulativeReport;

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAVCAYAAACg/AXsAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAahJREFUeNq0lE0oRFEUx+fOvGkYqUkWUuxmI5KFZCMLC9YWSIql5bxINpSkSFPsrK2UKClfxcrCQilZiqxl4SMTM/P8js6rm958vIVbv8695537v/eee+4znudFgprruoOYLWiFJ5jMZrMXQbHREgLNmH04ggE4lTH+hqB4k8lkDHZcg43609ALO/AMjTACl3CvMXKEQ3a3KyIrDObhFgoakIcPqNfdFuEN6sDRmBh0wIw4ZmEJxcVIyMbxJGdrjm4rhSOB/Q6hEded5kVkDlZhGBIhRHKaq2kjV8wuNhmMwUaVAjFdfIE0rPtJ+oRHHMsh8jGFebXrJKrq1QrE7TlOQIDkpR/ONahP+7XqP9bLKFuxPVJEukA3nEALNMGB+Dh2vpJIUoutaO3UWIWYrObtFK3teiW+V36AYdu/icSs6zZ/bCSoFOw68c/6osUnE7/UV9D8FPS7ny9ji8iklHS4vitMFzYH8v9IY6WaH+i3Ya+pJUdv6ffG/LfTTv9Gfzp78A41ulpO+/6jk5c7qjXUieid8f+xCA1hJqwJ5Zosso3AmQx+BBgA/luEjFKgxdUAAAAASUVORK5CYII="

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAAMpJREFUeNqk0a1OA1EQxfHfLluPaFAIgqxBNLxEJRJdcwUPgEHX1DIengZbg8QgICQovgSwmNvkZtMNWzjJJDOT+ScnZ6q2bXUVERNc4RvzlNLKBtU26whTHOO856YXLvfTiNjZBj4t+reU0tcgOCJOMCtWqz7bVRlYRBzgBnvFzX2uKs9r4LqJiCUOMcdFB4T9XF09NTjDCEuMDdd7jdfCzucWcG/ag9j/wA9/hV9wWeew5Fc0A+FFSum2wSN28ZH751/Au/wZPwMAXUgv51Z0f7MAAAAASUVORK5CYII="

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARJJREFUeNqMkr1qQkEQhfduTJT8gBZiiAj6DqkkZV4mL2CfJ7CxF9Klt0mvVhZKChuxTG5CkIQEjb835+BZWPTKzcDH7M7MgZnZDQqdccEYc2a2lgJ1UNL9B9yBb93nLOiBogKB2bc+iHR+o+AULL1g5J1p1jsfU3ANLncShyyk4B08gVxC8RpUKUiDPMgmCNhmxmoToYKPYAgGoA1eQVO5L3Zjdwa8Bx3QBS0wAjVv+A1b2oCpgufgROvNgCNwoRxrljasVjjM5z82xJqZjdn1IWNN4ApfvE3EbYf2AVZOsJDni6/kF5pv7nJoP0rp8ivfAGUJOOQVePCGNk4wkb+JaenWr3EC/tjnhKH5PuZPgAEA6NNDiIh+vS8AAAAASUVORK5CYII="

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAFhJREFUeNpiFD967woDA4MkA3ngPQuQkAdiHjINYGUCEr8YyAe/mRgoBKMGjBoASoks6GkbiP+TmhcYoZw2IO4j0YD/IAMEgHgqEFeTGwYgm3PJDQSAAAMASm0N61XH4KIAAAAASUVORK5CYII="

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _renameClub = __webpack_require__(907);

var _renameClub2 = _interopRequireDefault(_renameClub);

var _deleteClub = __webpack_require__(908);

var _deleteClub2 = _interopRequireDefault(_deleteClub);

var _addPost = __webpack_require__(909);

var _addPost2 = _interopRequireDefault(_addPost);

var _editLogo = __webpack_require__(910);

var _editLogo2 = _interopRequireDefault(_editLogo);

var _showSelectedPost = __webpack_require__(911);

var _showSelectedPost2 = _interopRequireDefault(_showSelectedPost);

var _singleComment = __webpack_require__(912);

var _singleComment2 = _interopRequireDefault(_singleComment);

var _like = __webpack_require__(913);

var _like2 = _interopRequireDefault(_like);

var _comment = __webpack_require__(914);

var _comment2 = _interopRequireDefault(_comment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClubPost = function ClubPost($scope, $state, $stateParams, $mdMedia, $mdDialog, $rootScope, authService, localStorageService, CONSTANTS) {
    'ngInject';

    RenameClubController.$inject = ["$scope", "$mdDialog", "data", "parentCtrl", "clubActivity", "clubs", "userDocs", "CONSTANTS"];
    DeleteClubController.$inject = ["$scope", "$mdDialog", "parentCtrl", "data"];
    EditLogoClubController.$inject = ["$scope", "$mdDialog", "data", "parentScope", "clubActivity", "clubs", "userDocs", "CONSTANTS", "localStorageService", "$timeout", "$interval", "uploadService"];
    CreatePostController.$inject = ["$scope", "$mdDialog", "parentCtrl", "data", "owner_id", "clubActivity", "clubs", "userDocs", "CONSTANTS", "localStorageService", "$timeout", "$interval", "uploadService"];
    showSelectedPostController.$inject = ["$scope", "$sce", "$mdDialog", "data", "url", "type", "$compile"];
    singleCommentController.$inject = ["$scope", "$mdDialog", "data"];
    LikeController.$inject = ["$scope", "$mdDialog", "data", "clubActivity", "clubs", "userDocs", "CONSTANTS"];
    CommentController.$inject = ["$scope", "$mdDialog", "parentCtrl", "data", "logedUser", "clubActivity", "clubs", "userDocs", "CONSTANTS"];
    _classCallCheck(this, ClubPost);

    $rootScope.title = "Club";

    $scope.getClubActivity = [];
    $scope.comment = [];

    //To check privilege
    //$scope.canCreateClub = false;
    $scope.accessSettings = false;
    $scope.updateClub = false;
    $scope.addMembers = false;
    $scope.toRemoveUser = false;
    $scope.isDeleteClub = false;
    $scope.canComment = false;
    $scope.setPrivacy = false;
    $scope.deletePost = false;
    $scope.loadPrimary = true;
    $scope.loadPrivileges = false;
    var isCreator = false;
    $scope.isLoaded = false;
    $scope.isLoading = true;

    //To get club details
    $scope.getClubs = [];
    $scope.clubActivity = [];

    var members = [];
    var uid = localStorageService.get('user_id'); //login user id
    $scope.userIdOf = uid;
    $scope.urlval = CONSTANTS.FILE_UPLOAD_URL;

    // this.subscribe('clubActivity');
    var localSchoolId = localStorageService.get('school_id');
    function loadInitial() {
        var send = {
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/club/me", "POST", { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
            try {
                if (!resp.error) {
                    autoRun(resp.result.data.details);
                }
                console.log(resp);
            } catch (e) {}
        });
    }
    this.$onInit = function () {
        loadInitial();
    };
    // this.subscribe('clubList', () => [localStorageService.get('school_id')]);
    // this.subscribe('getModulesFeatures', () => [localStorageService.get('school_id')]);
    if (localStorageService.get('selectedClubId')) {
        $scope.selectedClubId = localStorageService.get('selectedClubId');
        localStorageService.set('selectedClubId', $scope.selectedClubId);
    } else {
        $scope.selectedClubId = '';
    }

    //********************loadmore STARTS*************************
    //Obtain current club details after each activity
    $scope.counter = 0;
    $scope.loadMore = function (club_id) {

        if (localStorageService.get('isClubOwnerID')) {
            $scope.isClubOwnerID = localStorageService.get('isClubOwnerID');
        }

        $scope.activeClub = club_id;
        var i = 1;
        var activityCount = _.filter($scope.clubActivityResponse, function (cA) {
            return cA.club_id == club_id && cA.status == "active";
        });
        var totalActvityCount = activityCount.length;
        $scope.counter = totalActvityCount <= $scope.counter ? totalActvityCount : $scope.counter + 2;

        var roleHead = $scope.userDoc;
        var getRoleIdd = void 0;
        if (roleHead) {
            getRoleIdd = roleHead.role_id;

            if (localStorageService.get('loadFirstTime') != '') {

                // to show only selected club activity
                $scope.getClubActivity = [];
                var getClubActivity = _.filter($scope.clubActivityResponse, function (cA) {
                    return cA.club_id == club_id && cA.status == "active";
                });
                _.each(getClubActivity, function (eachActivity) {
                    var addedPost = false;
                    if (eachActivity && eachActivity.view === "public") {
                        $scope.getClubActivity.push(eachActivity);
                        addedPost = true;
                    } else if (eachActivity && eachActivity.added_by === uid && eachActivity.view != "public") {
                        $scope.getClubActivity.push(eachActivity);
                        addedPost = true;
                    } else if (eachActivity && eachActivity.added_by != uid && eachActivity.view != "public" && eachActivity.owner_id === uid) {
                        $scope.getClubActivity.push(eachActivity);
                        addedPost = true;
                    }
                    if ($scope.isDeleteClub && !addedPost) {
                        $scope.getClubActivity.push(eachActivity);
                    }
                });
            } else {
                // to show all club activities(posts)
                $scope.getClubActivity = [];
                var _getClubActivity = _.filter($scope.clubActivityResponse, function (cA) {
                    return cA.club_id.indexOf($scope.myActiveClubID) !== -1;
                });

                _.each(_getClubActivity, function (allPosts) {
                    var addedPost = false;
                    if (allPosts.view === "public") {
                        $scope.getClubActivity.push(allPosts);
                        addedPost = true;
                    } else if (allPosts && allPosts.added_by === uid && allPosts.view != "public") {
                        $scope.getClubActivity.push(allPosts);
                        addedPost = true;
                    } else if (allPosts && allPosts.added_by != uid && allPosts.view != "public" && allPosts.owner_id === uid) {
                        $scope.getClubActivity.push(allPosts);
                        addedPost = true;
                    }
                    if ($scope.isDeleteClub && !addedPost) {
                        $scope.getClubActivity.push(allPosts);
                    }
                    // allPosts.clubName = Club.findOne({
                    //   _id: allPosts.club_id
                    // }).name
                });
                $scope.activeClub = '';
            }
            $scope.getPostDetailsByCID();
        }
    };

    //******************loadmore ENDS**************************** 

    /*
     * To get details of posts in each club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.getPostDetailsByCID = function (data) {
        console.log(data);
        if (data) {
            //after delete the club
            localStorageService.set('selectedClubId', '');
            $scope.selectedClubId = '';
            $scope.getClubActivity = '';
        } else {
            var userMem = void 0,
                memName = void 0;
            userMem = $scope.userDoc;
            //$scope.clubActivity = angular.copy($scope.getClubActivity);
            $scope.clubActivity = $scope.getClubActivity;

            _.each($scope.clubActivity, function (eachPost) {
                userMem = _.find($scope.allUserDocs, function (one) {
                    return one._id == eachPost.added_by;
                });
                // userMem = result;
                if (userMem != undefined) {
                    eachPost.postedBy = userMem.name;
                }
                if (eachPost.likes) {
                    //to get the likes count for each posts
                    eachPost.likesCount = eachPost.likes.length;
                    eachPost.likeMem = _.contains(eachPost.likes, uid);
                } else {
                    eachPost.likesCount = 0;
                }
                if (eachPost.comments) {
                    //to get the comments count for each posts
                    eachPost.commentsCount = eachPost.comments.length;
                } else {
                    eachPost.commentsCount = 0;
                }
                if (eachPost.owner_id == uid) {
                    eachPost.isClubOwner = true;
                } else {
                    eachPost.isClubOwner = false;
                }
                if (eachPost.added_by == uid) {
                    eachPost.isShow = true;
                } else {
                    eachPost.isShow = false;
                }

                if (eachPost.view == 'public') {
                    eachPost.postView = true;
                } else {
                    eachPost.postView = false;
                }

                if (eachPost.type === 'image') {

                    var str = eachPost.url.split('http');
                    if (str.length && str.length < 2) {
                        eachPost.url = CONSTANTS.FILE_UPLOAD_URL + eachPost.url;
                    }
                } else {
                    if (eachPost.type === 'video') {
                        if (eachPost.url) {
                            var _str = eachPost.url.split('http');
                            if (_str.length && _str.length < 2) {
                                eachPost.thumbUrl = CONSTANTS.FILE_UPLOAD_URL + eachPost.url.thumbnail_url;
                                eachPost.url = CONSTANTS.FILE_UPLOAD_URL + eachPost.url.video_url;
                            }
                        }
                    }
                }

                if (eachPost.added_by == uid || $scope.userAccess && $scope.userAccess.deleteClub && $scope.userAccess.deleteClub.create) {
                    $scope.deletePost = true;
                }

                if (eachPost.owner_id == uid) {
                    eachPost.setPrivacy = true;
                }

                _.each(eachPost.comments, function (user) {
                    //to get user name based on user id
                    var result = _.find($scope.allUserDocs, function (one) {
                        return one._id == user.user_id;
                    });
                    user.userName = result.name;
                    if (result.image && result.image.original) user.profileImg = CONSTANTS.FILE_UPLOAD_URL + result.image.original;else
                        // /home/cordova/node_project/educore_3.5/server/file-server/public/uploads/profile_145-03.png
                        user.profileImg = CONSTANTS.FILE_UPLOAD_URL + "/uploads/profile_145-03.png";
                });
            });
        }
    };

    /*
     * To get club details after club activities
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.getClubDetails = function (club_id, ownerId) {
        $scope.toRemoveUser = false;
        $scope.addMembers = false;
        $scope.loadPrimary = true;
        $scope.loadPrivileges = true;
        // to get the selected club id (from dropbox) and related posts
        localStorageService.set('loadFirstTime', true);
        $scope.loadFirstTime = localStorageService.get('loadFirstTime');
        var v = true;
        localStorageService.set('selectedClubId', club_id);
        localStorageService.set('isClubOwnerID', ownerId);
        $scope.selectedClubId = localStorageService.get('selectedClubId');
        if ($scope.selectedClubId) {
            $scope.isClubId = true;
            $scope.isClubOwnerID = ownerId;
        }
        if ($scope.allpost) {
            $scope.allpost = false;
        }
        if (ownerId == localStorageService.get('user_id')) {
            $scope.toRemoveUser = true;
            $scope.addMembers = true;
        }
        $scope.loadMore(localStorageService.get('selectedClubId'));
        //$scope.$apply();
    };

    /*
     * To get details of selected clud 
     * 
     * @param : null
     * 
     * @return - null
     */
    $scope.loadMoreData = function () {
        $scope.loadMore($scope.selectedClubId);
    };

    $scope.loadCheckData = function () {
        $scope.loadMore($scope.selectedClubId);
    };

    function autoRun(firstReponse) {

        try {
            $scope.userDoc = firstReponse.getUserDetails;
            $scope.allUserDocs = firstReponse.allUserDocs;
            var clubs = firstReponse.resClubs,
                clubActivity = firstReponse.resClubActivity;
            $scope.clubs = firstReponse.resClubs, $scope.clubActivityResponse = firstReponse.resClubActivity;
            $scope.myActiveClubID = [];
            if (localStorageService.get('selectedClubId')) {
                $scope.loadMoreData();
                $scope.loadMore($scope.selectedClubId, $scope.isClubOwnerID);
            }
            /*************** START USER PRIVILEGES *************/
            var UserPrivilages = localStorageService.get('module_privileges');
            var moduleEx = _.find(UserPrivilages, function (one) {
                return one.name == "Club";
            });
            if (moduleEx) {
                var feat = localStorageService.get('feature_privileges');
                var clubUserAccess = _.filter(feat, function (one) {
                    return one.module_state == "clubPost";
                });

                if (clubUserAccess && clubUserAccess.length > 0) {

                    $scope.userAccess = {};
                    _.each(clubUserAccess, function (clubObj) {
                        var user_access = {};
                        _.each(clubObj.privilege, function (privObj) {
                            user_access[privObj.name.toLowerCase()] = privObj.status;
                        });
                        $scope.userAccess[clubObj.feature_id] = user_access;
                    });

                    if ($scope.userAccess) {
                        if ($scope.userAccess.createClub && $scope.userAccess.createClub.create) {
                            $scope.canCreateClub = true;
                            $scope.accessSettings = true;
                            //$scope.$apply();
                        }

                        // if ($scope.userAccess.addMembers && $scope.userAccess.addMembers.edit) {

                        // }
                        if ($scope.userAccess.addPost && $scope.userAccess.addPost.create) {
                            $scope.isCreatePost = true;
                        }
                        if ($scope.userAccess.likeAndComment && $scope.userAccess.likeAndComment.edit) {
                            $scope.canComment = true;
                        }
                        if ($scope.userAccess.likeAndComment && $scope.userAccess.likeAndComment.read) {
                            $scope.readComment = true;
                        }

                        if ($scope.userAccess.deleteClub && $scope.userAccess.deleteClub.create) {
                            $scope.isDeleteClub = true;
                        }
                    }
                } else {
                    $state.go("dashboard");
                }

                var moduleDetails = firstReponse.moduleDetails;
                var roleIds = firstReponse.getUserDetails;
                if (roleIds) {
                    roleIds = roleIds.role_ids;
                    $scope.assignNames = '';
                    _.each(roleIds, function (roleId) {
                        if (moduleDetails && moduleDetails.feature_role) {
                            _.each(moduleDetails.feature_role, function (eachRole) {
                                if (eachRole.role_id == roleId) {
                                    if (eachRole.f_id == "hosComponent") $scope.assignNames += "HOS";else if (eachRole.f_id == "hodComponent") $scope.assignNames += "HOD";else if (eachRole.f_id == "parentComponent") $scope.assignNames += "Parent";else if (eachRole.f_id == "teacherComponent") $scope.assignNames += "Teacher";else if (eachRole.f_id == "studentComponent") $scope.assignNames += "Student";else if (eachRole.f_id == "principalComponent") $scope.assignNames += "Principal";else if (eachRole.f_id == "adminComponent") $scope.assignNames += "Super Admin";
                                }
                            });
                        }
                    });
                    if (moduleDetails && $scope.assignNames.indexOf("Super Admin") != -1) {
                        if (localStorageService.get('selectedClubId')) {
                            console.log(1);

                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year');
                            });
                            console.log($scope.getClubs);
                            $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'));
                        } else {
                            console.log(11);
                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year');
                            });
                            if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                $scope.activeClub = $scope.getClubs[0]._id;
                                $scope.selectedClubId = $scope.getClubs[0]._id;
                                if ($scope.selectedClubId) {
                                    $scope.isClubId = true;
                                    $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                    localStorageService.set('isClubOwnerID', $scope.isClubOwnerID);
                                }
                                if ($scope.loadPrimary) $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                            }
                        }
                        _.each($scope.getClubs, function (doc) {
                            $scope.myActiveClubID.push(doc._id);
                        });
                        $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                        $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                    }
                    if (moduleDetails && $scope.assignNames.indexOf("Student") != -1) {
                        //only for students
                        console.log(111);
                        if (localStorageService.get('selectedClubId')) {
                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year') && _.find(one.users, function (fn) {
                                    return fn.user_id == uid;
                                });
                            });
                            $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'));
                        } else {
                            console.log(1111);
                            //return false;
                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year');
                            });

                            if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                $scope.activeClub = $scope.getClubs[0]._id;
                                $scope.selectedClubId = $scope.getClubs[0]._id;
                                if ($scope.selectedClubId) {
                                    $scope.isClubId = true;
                                    $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                    localStorageService.set('isClubOwnerID', $scope.isClubOwnerID);
                                }
                                if ($scope.loadPrimary) $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                            }
                        }
                        _.each($scope.getClubs, function (doc) {
                            $scope.myActiveClubID.push(doc._id);
                        });
                        $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                        //$scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                    }
                    if (moduleDetails && $scope.assignNames.indexOf("Student") == -1 && $scope.assignNames.indexOf("Super Admin") == -1) {
                        console.log(11111);
                        if (localStorageService.get('selectedClubId')) {
                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year') && (_.find(one.users, function (fn) {
                                    return fn.user_id == uid;
                                }) || one.created_by == uid);
                            });
                            $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'));
                        } else {
                            console.log(111111);
                            $scope.getClubs = _.filter(clubs, function (one) {
                                return one.status == "active" && one.school_id == localStorageService.get('school_id') && one.academic_year == localStorageService.get('academic_year') && (_.find(one.users, function (fn) {
                                    return fn.user_id == uid;
                                }) || one.created_by == uid);
                            });
                            var myActiveClubIDCount = $scope.myActiveClubID.length;
                            console.log(1111111);
                            if ($scope.getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                $scope.activeClub = $scope.getClubs[0]._id;
                                $scope.selectedClubId = $scope.getClubs[0]._id;
                                $scope.isClubOwnerID = $scope.getClubs[0].created_by;
                                localStorageService.set('isClubOwnerID', $scope.isClubOwnerID);
                                if ($scope.selectedClubId) {
                                    $scope.isClubId = true;
                                }
                                if ($scope.assignNames.indexOf("Teacher") != -1 && $scope.getClubs[0].created_by == uid) {
                                    $scope.isShow = true;
                                }
                                if ($scope.loadPrimary) $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                            } else {
                                // if ($scope.createPost || $scope.createClub) {
                                //   $scope.loadFirstTime = true;
                                //   localStorageService.set('isClubOwnerID', '1001')
                                // }
                            }
                        }

                        _.each($scope.getClubs, function (doc) {
                            $scope.myActiveClubID.push(doc._id);
                        });
                        $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                    }
                    if (moduleDetails && $scope.assignNames.indexOf("Parent") != -1) {
                        var childData = [];
                        var getClubs = [];
                        Meteor.call("getPersonDataClub", uid, function (error, result) {
                            if (error) {
                                toastr.error("Something went wrong, Try after some times");
                            } else {
                                _.each(result[0].child, function (eachChild) {
                                    childData.push(eachChild._id);
                                });
                                if (localStorageService.get('selectedClubId')) {
                                    getClubs = Club.find({
                                        status: "active",
                                        academic_year: localStorageService.get('academic_year'),
                                        school_id: localStorageService.get('school_id'),
                                        "users.user_id": {
                                            $in: childData
                                        }
                                    }).fetch(); //to get child's club
                                    $scope.getClubDetails(localStorageService.get('selectedClubId'), localStorageService.get('isClubOwnerID'));
                                } else {
                                    getClubs = Club.find({
                                        status: "active",
                                        academic_year: localStorageService.get('academic_year'),
                                        school_id: localStorageService.get('school_id'),
                                        "users.user_id": {
                                            $in: childData
                                        }
                                    }, {
                                        sort: {
                                            created_date: -1
                                        }
                                    }).fetch();
                                    if (getClubs.length >= 1 && !localStorageService.get('selectedClubId')) {
                                        $scope.activeClub = getClubs[0]._id;
                                        $scope.selectedClubId = getClubs[0]._id;
                                        $scope.isClubOwnerID = getClubs[0].created_by;
                                        localStorageService.set('isClubOwnerID', $scope.isClubOwnerID);
                                        if ($scope.selectedClubId) {
                                            $scope.isClubId = true;
                                        }
                                        if ($scope.loadPrimary) $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                                    }
                                }
                                if ($scope.getClubs == null && getClubs != null) $scope.getClubs = getClubs;else if (getClubs != null && $scope.getClubs != null) {
                                    _.each(getClubs, function (eachClub) {
                                        $scope.getClubs.push(eachClub);
                                    });
                                }
                                _.each($scope.getClubs, function (doc) {
                                    $scope.myActiveClubID.push(doc._id);
                                });
                                $scope.loadMore($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                                //$scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'))
                            }
                        });
                    }
                    _.find($scope.getClubs, function (eachClub) {
                        if (eachClub.created_by === uid) {
                            isCreator = true;
                        }
                    });

                    if (isCreator) {
                        $scope.updateClub = true;
                        //$scope.$apply();
                    }
                }
                $scope.isLoading = false;
                $scope.isLoaded = true;
                // $scope.$apply();
            }
        } catch (e) {
            console.log(e);
        }
        /**************** END USER PRIVILEGES ***************/

        // Start :To set features during loading club activities
        //$scope.loading = true;

        if ($scope.loadFirstTime != true) {
            var v = false;
        } else {
            var v = $scope.loadFirstTime;
        }
        // End :To set features during loading club activities


        if ($stateParams.clubId) {
            $scope.selectedClubId = $stateParams.clubId;
            $scope.getClubDetails($stateParams.clubId, $stateParams.ownerId);
        }
        if ($stateParams.ownerId) $scope.owner = $stateParams.ownerId;
    }
    //To get Role of members and get club which user is part of.


    /*
     * To get complete activity list when button to view all post is selected 
     * 
     * @param : null
     * 
     * @return - null
     */
    $scope.getAllPosts = function () {
        localStorageService.set('loadFirstTime', '');
        localStorageService.set('selectedClubId', '');
        $scope.loadPrimary = false;
        $scope.selectedClubId = '';
        $scope.loadFirstTime = '';
    };

    $scope.createClub = function () {
        $state.go('createClub', {});
    };

    /*
     * To rename club title -popup
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.renameClub = function () {
        var currentClub = $scope.selectedClubId; //selected club id
        $mdDialog.show({
            controller: RenameClubController,
            locals: {
                "data": currentClub,
                "parentCtrl": $scope,
                clubActivity: $scope.clubActivityResponse,
                clubs: $scope.clubs,
                userDocs: $scope.allUserDocs,
                CONSTANTS: CONSTANTS
            },
            template: _renameClub2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * To add more members to a club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.addUser = function () {
        $state.go('createClub', {
            "club_id": $scope.selectedClubId,
            "owner_id": localStorageService.get('isClubOwnerID'),
            "mode": "addmore"
        });
    };

    /*
     * To remove already existing members in club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.removeUser = function () {
        $state.go('createClub', {
            "club_id": $scope.selectedClubId,
            "owner_id": localStorageService.get('isClubOwnerID'),
            "mode": "remove"
        });
    };

    /*
     * To view all already existing members in club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.viewUser = function () {
        $state.go('createClub', {
            "club_id": $scope.selectedClubId,
            "owner_id": localStorageService.get('isClubOwnerID'),
            "mode": "view"
        });
    };

    /*
     * To delete an existing club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.deleteClub = function () {
        var currentClub = $scope.selectedClubId; //selected club id
        $mdDialog.show({
            controller: DeleteClubController,
            locals: {
                "data": currentClub,
                "parentCtrl": $scope
            },
            template: _deleteClub2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * To update club logo-popup
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.editLogo = function () {
        var currentClub = $scope.selectedClubId; //selected club id
        $mdDialog.show({
            controller: EditLogoClubController,
            locals: {
                "data": currentClub,
                "parentScope": $scope,
                clubActivity: $scope.clubActivityResponse,
                clubs: $scope.clubs,
                userDocs: $scope.allUserDocs,
                CONSTANTS: CONSTANTS,
                localStorageService: localStorageService
            },
            template: _editLogo2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    $scope.viewClubUsers = function () {
        $state.go('createClub', {
            "club_id": $scope.selectedClubId,
            "owner_id": localStorageService.get('isClubOwnerID'),
            "mode": "view"
        });
    };

    /*
     * To add new post for members of club-popup
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.createPost = function (id) {

        var currentClub = $scope.selectedClubId; //selected club id
        var ownerID = $scope.isClubOwnerID; //selected club owner id
        $mdDialog.show({
            controller: CreatePostController,
            locals: {
                "parentCtrl": $scope,
                "data": currentClub,
                "owner_id": ownerID,
                clubActivity: $scope.clubActivityResponse,
                clubs: $scope.clubs,
                userDocs: $scope.allUserDocs,
                CONSTANTS: CONSTANTS,
                localStorageService: localStorageService
            },
            template: _addPost2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * For viewing selected post -popup
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.showSelectedPost = function (post_id, post_url, type) {
        var currentClub = post_id; //selected post id
        var postUrl = post_url; //selected post url
        var post_type = type;
        $mdDialog.show({
            controller: showSelectedPostController,
            locals: {
                "data": currentClub,
                "url": postUrl,
                "type": post_type
            },
            template: _showSelectedPost2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * For liking a post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.postLike = function (post_id) {
        // Meteor.call("postLike", post_id, Meteor.userId(), function (error, result) {
        //     if (error) {
        //         if (error.error) {
        //             toastr.error("Some thing went wrong !.Please try after some time.")
        //         }
        //     }
        // })
        var send = {
            school_id: localStorageService.get('school_id'),
            post: post_id,
            uid: localStorageService.get('user_id'),
            myUserId: localStorageService.get('user_id')
        };
        authService.callAPI("/v0/club/postLike", "POST", { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
            try {
                if (resp.error) {
                    toastr.error("Some thing went wrong !.Please try after some time.");
                }
                _.each($scope.clubActivity, function (oneCa) {

                    if (oneCa._id == post_id) {
                        oneCa.likeMem = true;
                    } else {
                        oneCa.likeMem = false;
                    }
                });
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    };

    /*
     * To unlike an already liked post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.postUnLike = function (post_id, post) {
        var send = {
            school_id: localStorageService.get('school_id'),
            post: post_id,
            uid: localStorageService.get('user_id'),
            myUserId: localStorageService.get('user_id')
        };
        authService.callAPI("/v0/club/postUnLike", "POST", { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
            try {
                if (resp.error) {
                    toastr.error("Some thing went wrong !.Please try after some time.");
                }
                _.each($scope.clubActivity, function (oneCa) {

                    if (oneCa._id == post_id) {
                        oneCa.likeMem = false;
                    } else {
                        oneCa.likeMem = true;
                    }
                });
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    };

    /*
     * To make post public and private by owner of post
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.postPrivillege = function (post_id, privacy, post) {
        var txt = void 0,
            successTxt = void 0;

        if (privacy === true) {

            txt = "Are you sure to make this post as private ?";
            successTxt = "Private mode is enabled !";
        } else {
            txt = "Are you sure to make this post as public ?";
            successTxt = "Public mode is enabled !";
        }
        var confirm = $mdDialog.confirm().title('').textContent(txt).targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            // Meteor.call("toPublicView", post_id, privacy, function (error, result) {
            //     if (error) {

            //         toastr.error("Something went wrong !.Please try after some time.");

            //     } else {

            //         toastr.success(successTxt);
            //     }
            // })
            var send = {
                schoolId: localStorageService.get('school_id'),
                privacy: privacy,
                postId: post_id,
                myUserid: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/club/toPublicView", "POST", { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        toastr.success(successTxt);
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
        }, function () {
            post.postView = privacy;
        });
    };

    /*
     * To add comments to post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.addCommentData = function (post_id, index) {
        var text = $scope.comment[index];
        if (text && text.length >= 1) {
            authService.callAPI("/v0/club/add/post/comment", "POST", {
                postId: post_id, comment: text, userId: localStorageService.get('user_id'),
                uid: localStorageService.get('user_id')
            }, function (resp) {
                try {
                    if (!resp.error) {
                        toastr.success("Comment added successfully !");
                        $scope.comment[index] = '';
                        _.each($scope.clubActivityResponse, function (oneCa) {
                            if (oneCa._id == post_id) {
                                var thisComments = oneCa.comments;
                                _.each(thisComments, function (eachUser) {
                                    eachUser.comment = text;
                                    eachUser.added_date = new Date();
                                });
                            }
                        });
                        $scope.$apply();
                    } else {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    }
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("addComments", post_id, text, Meteor.userId(), function (error, result) {
            //     if (error) {
            //         toastr.error("Some thing went wrong !.Please try after some time.")
            //     } else {

            //         toastr.success("Comment added successfully !")
            //         $scope.comment[index] = '';
            //     }
            // })
            //$scope.getClubDetails($scope.selectedClubId,$scope.isClubOwnerID)
        } else if (!text || text.length < 1) {
            toastr.error("Enter any comment");
        }
    };

    /*
     * To view a large comment completly of a post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.showSingleComment = function (comment) {
        var currentClub = $scope.selectedClubId; //selected club id
        $mdDialog.show({
            controller: singleCommentController,
            locals: {
                "data": comment
            },
            template: _singleComment2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * To show who and all liked the post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.showLikedDetails = function (post_id) {

        $mdDialog.show({
            controller: LikeController,
            locals: {
                "data": post_id,
                clubActivity: $scope.clubActivityResponse,
                clubs: $scope.clubs,
                userDocs: $scope.allUserDocs,
                CONSTANTS: CONSTANTS
            },
            template: _like2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: $scope.customFullscreen
        });
    };

    /*
     * To show complete lists of comments for a post by a member of club
     * 
     * @param : null
     * 
     * @return - null
     */

    //CommentController.$inject = ['$scope', '$mdDialog', 'data']
    $scope.showCommentDetails = function (ev, post_id) {

        var log_id = localStorageService.get('user_id');
        $scope.model = {};
        $mdDialog.show({
            controller: CommentController,
            template: _comment2.default,
            parent: angular.element(document.body),
            targetEvent: ev,
            locals: {
                "parentCtrl": $scope,
                "data": post_id,
                "logedUser": log_id,
                clubActivity: $scope.clubActivityResponse,
                clubs: $scope.clubs,
                userDocs: $scope.allUserDocs,
                CONSTANTS: CONSTANTS
            },
            clickOutsideToClose: false
        }).then(function (answer) {

            $scope.status = 'You said the information was "' + answer + '".';
        }, function () {
            $scope.status = 'You cancelled the dialog.';
        });
    };

    /*
     * To delete post by owner of post or club 
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.postDelete = function (post_id) {
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to remove this post ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI("/v0/club/delete/post", "DELETE", { postId: post_id }, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Server Interpreted.Please try after some time.");
                    } else {
                        toastr.success("Post deleted successfully!");
                        $scope.getClubDetails($scope.selectedClubId, localStorageService.get('isClubOwnerID'));
                        $scope.$apply();
                    }
                } catch (e) {
                    console.log(e);
                }
            });
        });
    };
    function RenameClubController($scope, $mdDialog, data, parentCtrl, clubActivity, clubs, userDocs, CONSTANTS) {
        $scope.clubId = data;
        $scope.postTitle = _.find(clubs, function (one) {
            return one._id == data && one.academic_year == localStorageService.get('academic_year');
        }).name;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.update = function () {
            if ($scope.postTitle == undefined) {
                toastr.error("Club name can't be blank !");
                return false;
            }
            if ($scope.postTitle.length < 2) {
                toastr.error("Club title is too short!");
                return false;
            }
            if ($scope.postTitle.length > 100) {
                toastr.error("Club title maximun length exceeds !");
                return false;
            }
            var reg = /^([A-Za-z0-9])[^]*$/;
            var clubName = $scope.postTitle.match(reg) ? "passed" : "failed";
            if (clubName == 'failed') {
                toastr.error("Please enter valid club title");
                $scope.postTitle = '';
                $("#club_title").focus();
                return false;
            } else {
                $scope.postTitle = $scope.postTitle;
            }
            var myUserId = localStorageService.get('user_id');
            var school_id = localStorageService.get('school_id');
            authService.callAPI("/v0/club/check-name/" + school_id + "/" + myUserId + "/" + $scope.postTitle, "GET", {}, function (resp) {
                try {
                    if (!resp.error) {
                        $scope.updateClub = {};
                        $scope.updateClub.club_id = $scope.clubId;
                        $scope.updateClub.title = $scope.postTitle;
                        $scope.updateClub.modified_by = myUserId;
                        $scope.updateClub.modified_date = new Date();
                        $scope.updateClub.last_modified_by = myUserId;
                        authService.callAPI("/v0/club/update/name", "POST", {
                            clubId: $scope.clubId,
                            clubDetails: $scope.updateClub
                        }, function (response) {
                            try {
                                console.log(response);
                                if (response.error) {
                                    toastr.error("Some thing went wrong !.Please try after some time.");
                                } else {
                                    parentCtrl.getClubDetails($scope.clubId, myUserId);
                                    localStorageService.set('loadFirstTime', $scope.clubId);
                                    toastr.success("Club name updated successfully!");
                                    $mdDialog.cancel();
                                }
                            } catch (e) {
                                console.log(e);
                            }
                        });
                    } else {
                        toastr.error("Club title exists, Please rename club title");
                        return false;
                    }
                } catch (e) {
                    console.log(e);
                    toastr.error("Somethingwent wrong,Please try after sometimew");
                }
            });
        };
    }

    function DeleteClubController($scope, $mdDialog, parentCtrl, data) {
        $scope.clubId = data;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.clubDelete = function () {
            authService.callAPI("/v0/club/delete", "DELETE", {
                club_id: $scope.clubId, userId: localStorageService.get('user_id')
            }, function (resp) {
                try {
                    if (!resp.error) {
                        toastr.success("Club deleted successfully!");
                        $mdDialog.cancel();
                        $scope.$apply();
                        parentCtrl.getPostDetailsByCID('delete');
                        localStorageService.set('selectedClubId', '');
                        $scope.getClubActivity = [];
                        $scope.selectedClubId = '';
                        $scope.$apply();
                    } else {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    }
                } catch (e) {
                    console.log(e);
                }
            });
        };
    }
    function EditLogoClubController($scope, $mdDialog, data, parentScope, clubActivity, clubs, userDocs, CONSTANTS, localStorageService, $timeout, $interval, uploadService) {

        $scope.clubId = data;
        $scope.loaderImg = false;
        $scope.browse_btn = true;
        $scope.edit_logo_btn = false;
        $scope.determinateValue = 1;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        var userId = localStorageService.get('user_id');
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        var logo = _.find(clubs, function (one) {
            return one._id == $scope.clubId;
        }).logo;
        $scope.postLogo = CONSTANTS.FILE_UPLOAD_URL + logo;
        $scope.myImage = '';
        $scope.editFileSelect = function (evt) {
            var file = evt[0];
            var reader = new FileReader();
            reader.onload = function (evt) {
                $scope.$apply(function ($scope) {
                    $scope.myImage = evt.target.result;
                });
            };
            reader.readAsDataURL(file);
        };
        var editPostPopUp = function editPostPopUp(pic, name) {
            //let baseUrl = $location.protocol() + "://" + $location.host()
            var serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads";
            var userPath = userId + "/clubActivity/";
            var fileObj = pic;
            uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
                if (result.url) {
                    $scope.actionEdit = false;
                    $scope.updateFileurl = result.url;
                    $scope.updateLogoPopUp();
                }
                if (result.progress) {
                    $scope.updateFileurl = "";
                    $scope.progressRep = result.progress;
                }
            });
        };
        $scope.showPic = true;
        $scope.showFooterBtns = function () {
            $scope.edit_logo_btn = true;
        };
        $scope.updateLOGO = function () {
            $scope.showPic = false;
            $scope.browse_btn = false;
            $scope.edit_logo_btn = false;
            if ($scope.picFile) {
                $scope.loaderImg = true;
                editPostPopUp($scope.picFile);
            }
        };
        $scope.updateLogoPopUp = function () {
            var send = {
                logo: $scope.updateFileurl,
                cid: $scope.clubId,
                myUserid: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/club/create/updateLogo", "POST", { args: send, myUserId: localStorageService.get('user_id') }, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        $scope.loading = true;
                        $timeout(function () {
                            $scope.picFile = undefined;
                            $scope.loading = false;
                            parentScope.getClubDetails($scope.clubId, userId);
                            localStorageService.set('loadFirstTime', $scope.clubId);
                            toastr.success("Logo updated successfully !");
                            $mdDialog.cancel();
                        }, 200);
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
        };
    }
    function CreatePostController($scope, $mdDialog, parentCtrl, data, owner_id, clubActivity, clubs, userDocs, CONSTANTS, localStorageService, $timeout, $interval, uploadService) {
        $scope.currentDate = new Date();
        $scope.hidePopupButtons = true;
        $scope.clubId = data;
        $scope.owner_id = owner_id;
        $scope.determinateValue = 1;
        var myUserid = localStorageService.get('user_id');
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {

            $mdDialog.cancel();
        };
        if ($scope.picFile) {
            $scope.uploadedFileName = $scope.picFile.name;
        }
        $scope.myImage = '';
        $scope.showFileSelect = function (evt) {
            var x = 0;
            var file = evt[0];
            $scope.myImage = '';
            if (file.type == "video/webm") {
                toastr.error("Unsupported format");
                return false;
            }
            if (file.type) {
                var uploadType = file.type;
                if (uploadType == "video/mp4") {
                    x = 1;
                    $scope.myImage = '';
                    $scope.picFileVid = false;
                } else {
                    var reader = new FileReader();
                    reader.onload = function (evt) {
                        $scope.$apply(function ($scope) {
                            x = 0;
                            $scope.picFileVid = true;
                            $scope.myImage = evt.target.result;
                        });
                    };
                    reader.readAsDataURL(file);
                }
            }
        };
        var uploadPostPopUp = function uploadPostPopUp(pic, name) {
            $interval(function () {
                $scope.determinateValue += 1;
                if ($scope.determinateValue > 100) {
                    $scope.determinateValue = 5;
                }
            }, 300);
            //let baseUrl = $location.protocol() + "://" + $location.host()
            var serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads";
            //let serverUrl = "http://192.168.0.59:4000/server-uploads"
            var userPath = myUserid + "/clubActivity/";
            var fileObj = pic;
            uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
                if (result.url) {
                    $scope.actionEdit = false;
                    $scope.postFileurl = result.url;
                    if (fileObj && fileObj.type == 'video/mp4') {
                        $scope.postFileType = 'video';
                    } else {
                        $scope.postFileType = 'image';
                    }
                    $scope.addNewPost();
                }
                if (result.progress) {
                    $scope.updateFileurl = "";
                    $scope.progressRep = result.progress;
                }
            });
        };
        $scope.postComment = function () {
            $scope.errors = {};

            if ($scope.postTitle == undefined || $scope.postTitle == null) {
                toastr.error("Add title");
                return false;
            }

            if (!$scope.picFile && !$scope.postTitleArea) {
                toastr.error("Please update with any post, text/image/video");
                return false;
            }
            if ($scope.postTitleArea && $scope.postTitleArea.length > 1000) {
                $scope.errors.message = "Description should be limited to 1000 letters";
                return false;
            }

            if ($scope.postTitle && $scope.postTitle.length > 0 && $scope.postTitle.length < 2) {
                toastr.error("Text is too short!");
                return false;
            }

            $scope.uploading = true;
            if (!$scope.picFile && $scope.postTitle) {
                //for text
                $scope.hidePopupButtons = false;
                $scope.loaderImg = true;
                $scope.postFileType = 'text';
                $scope.addNewPost();
            }

            if ($scope.picFile) {

                if (!$scope.postTitle) {
                    $scope.postTitle = "";
                }

                $scope.hidePopupButtons = false;
                $scope.loaderImg = true;
                uploadPostPopUp($scope.picFile);
            }
        };
        $scope.postDataType = false;
        $scope.postType = function () {
            if ($scope.postDataType) {
                return "public";
            } else {
                return "private";
            }
        };

        $scope.addNewPost = function () {
            var clubOwner = _.find(clubs, function (one) {
                return one._id == $scope.clubId && one.academic_year == localStorageService.get('academic_year');
            });
            $scope.clubPost = {};
            $scope.clubPost.club_id = $scope.clubId;
            $scope.clubPost.title = $scope.postTitle;
            $scope.clubPost.added_by = myUserid;
            $scope.clubPost.view = $scope.postType();
            $scope.clubPost.status = 'active';
            $scope.clubPost.url = $scope.postFileurl;
            $scope.clubPost.type = $scope.postFileType;
            $scope.clubPost.description = $scope.postTitleArea;
            $scope.clubPost.post_date = $scope.currentDate;
            $scope.clubPost.owner_id = clubOwner.created_by;
            $scope.clubPost.school_id = localStorageService.get('school_id');
            if ($scope.postTitleArea) {
                $scope.clubPost.textarea = $scope.postTitleArea;
            }

            var send = {
                logo: $scope.updateFileurl,
                cid: $scope.clubId,
                myUserid: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/club/add/post", "POST", { post: $scope.clubPost, myUserId: localStorageService.get('user_id') }, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        $timeout(function () {
                            $scope.picFile = undefined;
                            toastr.success("Created successfully!");
                            parentCtrl.getClubDetails($scope.clubId, clubOwner.created_by);
                            localStorageService.set('loadFirstTime', $scope.clubId);
                            $mdDialog.cancel();
                        }, 200);
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("clubPost", $scope.clubPost, function (error, result) {
            //     $scope.uploading = false;
            //     if (error) {
            //         if (error.error) {
            //             toastr.error("Some thing went wrong !.Please try after some time.")
            //         }
            //     } else {


            //     }
            // });
        };
    }

    function showSelectedPostController($scope, $sce, $mdDialog, data, url, type, $compile) {
        $scope.post_Id = data;

        $scope.post_URL = $sce.trustAsResourceUrl(url);
        $scope.post_type = type;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }

    function singleCommentController($scope, $mdDialog, data) {
        $scope.comment = data;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }

    function LikeController($scope, $mdDialog, data, clubActivity, clubs, userDocs, CONSTANTS) {
        $scope.likesIsLoading = true;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        var likedUserArray = _.find(clubActivity, function (o) {
            return o._id == data;
        });
        $scope.likedUserDetail = [];
        _.each(likedUserArray.likes, function (userLiked) {
            var result = _.find(userDocs, function (one) {
                return one._id == userLiked;
            });
            var obj = {};
            if (result.image && result.image.original) {
                obj = {
                    name: result.name,
                    image: FILE_UPLOAD_URL + result.image.original
                };
            } else {
                obj = {
                    name: result.name,
                    image: CONSTANTS.FILE_UPLOAD_URL + "/uploads/profile_145-03.png"
                };
            }
            $scope.likedUserDetail.push(obj);
            $scope.likesIsLoading = false;
        });
    }
    function CommentController($scope, $mdDialog, parentCtrl, data, logedUser, clubActivity, clubs, userDocs, CONSTANTS) {
        $scope.commentsIsLoading = true;
        $scope.clubId = data;
        $scope.logedUser = logedUser;
        $scope.showCommentBox = false;
        $scope.hide = function () {
            $mdDialog.hide();
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.commentsData = _.find(clubActivity, function (o) {
            return o._id == data;
        }).comments;
        $scope.userComments = [];
        _.each($scope.commentsData, function (eachUser) {
            var result = _.find(userDocs, function (one) {
                return one._id == eachUser.user_id;
            });
            var userName = result.name;
            var items = {
                user_id: eachUser.user_id,
                user_name: userName,
                comment: eachUser.comment,
                _id: eachUser._id,
                logedUser: $scope.logedUser,
                added_date: eachUser.added_date
            };
            $scope.userComments.push(items);
            $scope.commentsIsLoading = false;
        });
        $scope.deleteComment = function (selectedCommt) {
            $scope.commentId = selectedCommt._id;
            var send = {
                cmtId: $scope.commentId,
                cid: $scope.clubId,
                userId: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/club/delete/post/comment", "DELETE", send, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        $mdDialog.cancel();
                        toastr.success("Successfully deleted your comment");
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("deleteComment", $scope.clubId, $scope.commentId, function (error, result) {
            //     if (error) {

            //         toastr.error("Some thing went wrong !.Please try after some time.")
            //     } else {
            //         //parentCtrl.getClubDetails(Session.get('selectedClubId'))
            //         $mdDialog.cancel();
            //         toastr.success("Successfully deleted your comment")
            //     }
            // });
        };
        $scope.commentText = '';
        $scope.editComment = function (selectedCommt) {
            $scope.commentText = selectedCommt.comment;
            $scope.showCommentBox = true;
            $scope.commentId = selectedCommt._id;
            angular.element("#cmt").focus();
        };

        $scope.updateComment = function () {
            var cmt = $('textarea#cmt').val();
            // Meteor.call("updateComment", $scope.clubId, $scope.commentId, cmt, function (error, result) {
            //     if (error) {

            //         toastr.error("Some thing went wrong !.Please try after some time.")

            //     } else {
            //         toastr.success("Updated successfully !")
            //         //parentCtrl.getClubDetails(Session.get('selectedClubId'))
            //         $scope.showCommentBox = false;
            //         $mdDialog.cancel();
            //     }
            // });
            var send = {
                club_id: $scope.clubId,
                cmt_id: $scope.commentId,
                cmt: cmt,
                userId: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/club/update/post/comment", "PUT", send, function (resp) {
                try {
                    if (resp.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        _.each(parentCtrl.clubActivityResponse, function (oneCa) {
                            if (oneCa._id == $scope.clubId) {
                                var thisComments = oneCa.comments;
                                _.each(thisComments, function (eachUser) {
                                    eachUser.comment = cmt;
                                    eachUser.added_date = new Date();
                                });
                            }
                        });
                        toastr.success("Updated successfully !");
                        $scope.showCommentBox = false;
                        $mdDialog.cancel();
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
        };
    }
};
ClubPost.$inject = ["$scope", "$state", "$stateParams", "$mdMedia", "$mdDialog", "$rootScope", "authService", "localStorageService", "CONSTANTS"];

exports.default = ClubPost;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfNJREFUeNqU1E1IVFEYxnG9jaKYJCioEARBIImCIQpphQhFtTACIYIWGbgSaWjRQtQKUclFBJI7jZZBGPhBQhnYQixaBMpgC9ukgtUixEg07f/Cc+F4OfPhgR86c8955ny852bH4/GsNO00rqEaRfiKD3iNHd+AIE1gN5bwEOXYw1W8xEf94KFCB/AIQziBC7iCU2jGUbzV5wMtFvlch1Ycxw080CzdZrOdxXl8xijOJZvpbSzgpmY2hr4UK1nHHTSi3hd6DE8xqeWcRRv+pdnzOfzBfXcbwlA72UJ0qVOmbUtbZMtP4K4belJ/81IEXEKx53s7yAo8wxM7Ewut1Rcz+JYksBdvVJtFnue/0IkJDFvoMNbQgh+eAT1aYpYOZTpJcFjXMQs9g8fYjnTIcUpqBD/xAlWYQqkn9Lv1C1R3y54OFTq4fh1AocKaNZFbnjE2kRwr/myV0FykQ0JVkVDJBVq2Xc9K/PaENtjFsY7j6EBJpMOuAq0diTxb0eG4zcYPYtFC7+ke29Vr0v+uXOxr4L5WVuA8t1VcxyeU2c200FVc1ntgVpvteo6/CtzUTVuN9HmFDVzEl/CFMo8alUy0wNc0W5thPt6j3XPq8+GK3LeUldS7JPUX/lCu9nMl1d0NMrzj4V5m1IJDvDximXb8L8AAkD9o55oxQkIAAAAASUVORK5CYII="

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABACAYAAACp3n/2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA81JREFUeNrsW1ly4jAQlYRsDIQU+Z2Z+99lfnOBOQAfVCCs3qafsBlSqcGLWsLGdJVxJQFZr19v6iZytVz+FkL8pCsRjy8hXe+aXn7R9UMMR5aKXmIxLImVGKA8QT9BP0E/QT9B91G0rwfleS5yuku6Cymv/3D+me5SqccADbCAONJa6CAQioCp0cj8DkrI0lRkWSbSOBZpkpwVc62UPoE2YGnz4XgsxlFkQN9iMgdwAn08HER8PDoF7wQ0AGgCGb28iCAMa30GCtH0Xlzx6SQO261IiH0XJq9dAAazAKxabhiKgtJ2n5/iRMxzA2cFDd8cTyZiQoBtTRNAZ/O5WQcmz2nqitOHA/LfKQPgf8ilUWBAARAW1DnQAMoK+GrdCRiniG/SW1dAg2WY9QgbcyBYN6L1864wDcAIWAheLiWk9RWTUhWXLytHLF82SooNKarnDCZuDRoejEDjpXysmfPdg0ZZqf2U8KZ8Rc62ZFvZmjaiquta+TqSw8zzLpi3T9CyC+Z9OR4OqolQnJM9HcrvH71hbqi3M8YSsaq2z4rz+V2ZNhtJ/IzB0jQ91+CWMYQlkMWxn8kQ13PsQZPWEzr0gwXXLKOjwpEp7ANZ4dfH3c4p6ON+z3a8ZElZ0P6JWEgcmTnWPTE2ElibCGjvcEdysIt1c8ZagLWJgDbudrNh2yAAYz10STvZLioPHwg2m48Ps1HbwLVdr01nlLvMZe+v4kAAxterlQk+bQT+i8+fHAB2AhomWTb527aAYTFj+jzaRDlT6fnlXM4ZyMq2DlpHNgd+9L1xYeSD9q9JV8XEpDOgyz4Z2rVgmLNpMJnNjAIOVAdw+TdL7Q1W54sFK+AvzASBmL2+mo6rSYmW5q5tGY6IiSldPhoI02JUtN9uv498fTANjU+mUy+AryWiZ8KNTAxpyXgr0IjQYDjyDPgCnMw8KoH7AI0HhfTQ6Z0AlwIrQ6ZocwhRTQFjhArf6oJA8Rj2N2VcNQ0mMGlf3c/K/WDG1cLiVBOWkTICpikDlyBNGjNvwLaqC3hEqQIBpIuCfTWxPlWTZhFS4PD1laemAr+GBdYNaqoWy+Q7446Z9Tczx6i4Jim13qXJb6TjUSxHqapxKqvBdjVo8pXAUU3NXaaafdbwbVVp2vAXT/Nna7bJBaUtaASwQGvRF0HhpIrGQ3umi8jYJ9E1rPIm6PLLq32SkQ3TphuCyX8PQasKv1ZVtW1X6uwm9Tjy9S22AVreSld9E/MVjdtFivw/6GL4LXsIvEovg/3HlbeBYV4gCb8/EnB5M0gZ+fNXgAEA/8d3y4aomPcAAAAASUVORK5CYII="

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateClub = function CreateClub($scope, $state, $stateParams, $mdMedia, $mdDialog, $rootScope, authService, localStorageService, CONSTANTS, uploadService, $interval, $timeout) {
    'ngInject';

    _classCallCheck(this, CreateClub);

    $rootScope.title = "Create Club";

    //For viewing searchbox
    $scope.showSearchBottomSheet = true;

    $scope.clubActionBtns = true; //For removing the action button (Add,Create and Update) in footer

    //localStorageService details for student
    $scope.showSessionName = [];

    //Members added to club stored
    $scope.addedMemberData = [];

    //Roles of members added
    $scope.allRoles = [];

    //To get detals of members
    $scope.userMgt = [];

    //Selected users for adding to club
    $scope.selectedUsers = [];

    //To get academic details
    $scope.allSessions = {};
    $scope.allCurriculum = {};
    $scope.allBatchess = {};
    $scope.allClassess = {};
    $scope.club = {};
    $scope.clubs = true;

    //If updating details of a club ,fetch clubId
    $scope.stateId = 'club';

    //To check member exist to create and update aclub
    $scope.ifMembersExist = false;

    //To set authority of viewing create club button-after adding valid users
    $scope.showCreateButton = false;
    $scope.showSearchBox = false;
    $scope.ifCliked = false;
    $scope.ifUpdated = false;
    $scope.ifRemoved = false;

    //To identify role Id of participants of club.
    $scope.whoIsThis = '';

    //To set privilege and roletypes
    var moduleDetails = [];
    var addedSessionsID = [];
    //To fetch person collection
    var personArrys = [];

    //To get participant role id from privileges
    var roles = [];
    var uid = localStorageService.get('user_id');

    var schoolId = localStorageService.get('school_id');

    $scope.clearParentFields = function () {};
    $scope.currentDate = new Date();
    // Meteor.call("timeZone", function(error, result) {
    //     if (error) {
    //         if (error.error) {
    //             toastr.error("Server Interpreted.Please try after some time.")
    //         }
    //     } else {
    //         $scope.currentDate = new Date();
    //         $scope.$apply();
    //     }
    // })
    console.log($stateParams);
    if ($stateParams.club_id) {
        localStorageService.set('selectedClubId', $stateParams.club_id);
    }

    $scope.initialLoad = function () {
        $scope.club_id = $stateParams.club_id;
        $scope.userNames = [];
        $scope.club = {};
        var send = {
            myUserId: localStorageService.get('user_id'),
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/club/create/init", "POST", { args: send }, function (resp) {
            try {
                if (!resp.error) {
                    setData(resp.result.data.details);
                }
            } catch (e) {
                console.log(e);
            }
        });
    };
    var item = {};
    var name, club_owner;
    $scope.showCheckBox = true;
    $scope.showSelect = true;
    $scope.showBrowseBtn = true;
    $scope.showRoleArea = true;
    $scope.initialLoad();
    function setData(firstResponse) {
        moduleDetails = firstResponse.moduleDetails;
        $scope.moduleDetailsData = firstResponse.moduleDetails;
        var sett = firstResponse.sett;
        $scope.allSessions = _.find(sett, function (one) {
            return one.type == 'session';
        });
        $scope.allCurriculum = _.find(sett, function (one) {
            return one.type == 'curriculum';
        });
        $scope.allClassess = _.find(sett, function (one) {
            return one.type == 'class';
        });
        $scope.allBatchess = _.find(sett, function (one) {
            return one.type == 'batch';
        });
        if ($stateParams.club_id) {
            if ($stateParams.mode == 'remove') {
                $scope.selectedActivity = {
                    "name": 'Remove Users'
                };
                $scope.clubMode = $stateParams.mode;
                $scope.showCheckBox = true;
                $scope.showBrowseBtn = false;
                $scope.showSelect = true;
                $scope.showSeachFiled = true;
                $scope.showRoleArea = false;
            }
            if ($stateParams.mode == 'addmore') {
                $scope.selectedActivity = {
                    "name": 'Add New Users'
                };
                $scope.clubMode = $stateParams.mode;
                $scope.showCheckBox = false;
                $scope.showBrowseBtn = false;
                $scope.showSelect = false;
                $scope.showSeachFiled = true;
            }
            if ($stateParams.mode == 'view') {
                $scope.showRoleArea = false;
                $scope.showSeachFiled = true;
                $scope.selectedActivity = {
                    "name": 'View Club Users'
                };
                $scope.clubMode = $stateParams.mode;
                $scope.showCheckBox = false;
                $scope.showBrowseBtn = false;
            }
            $scope.clubDataExits();
        } else {
            $scope.isCreateClub = true;
        }
    }
    // this.subscribe('getSession');
    // this.subscribe('getModulesFeatures', () => [localStorageService.get('school_id')]);

    $scope.clubDataExits = function () {
        var send = {
            myUserId: localStorageService.get('user_id'),
            schoolId: localStorageService.get('school_id'),
            club_id: $stateParams.club_id
        };
        authService.callAPI("/v0/club/create/clubListToUpdate", "POST", { args: send }, function (resp) {
            try {
                if (!resp.error) {
                    setDataForView(resp.result.data.details);
                }
            } catch (e) {
                console.log(e);
            }
        });
    };

    function setDataForView(response) {
        console.log(response);
        $scope.userNames = [];
        var itemcount = 0;
        var getClubData = response.clubs;
        var userDocs = response.userDocs;
        $scope.getClubData = {};
        $scope.getClubData = getClubData[0];
        $scope.club.name = $scope.getClubData.name;
        $scope.club.logo = CONSTANTS.FILE_UPLOAD_URL + $scope.getClubData.logo;
        $scope.totalUsersInThsClub = $scope.getClubData.users.length;
        $scope.array = [];
        _.each($scope.getClubData.users, function (eachClubUser) {
            if (eachClubUser) {
                var _personArrys = [];
                _personArrys = _.filter(userDocs, function (one) {
                    return one.user_id == eachClubUser.user_id;
                });
                if (_personArrys && _personArrys.length) {
                    var _name = _personArrys[0].userDoc[0];
                    if (_name) {
                        var userPic = undefined;
                        $scope.showSearchBox = true;
                        if (_name.image) {
                            userPic = CONSTANTS.FILE_UPLOAD_URL + _name.image.original;
                        } else {
                            userPic = CONSTANTS.FILE_UPLOAD_URL + '/uploads/header/profile_61x64.png';
                        }
                        if (_personArrys[0] && _personArrys[0].role_ids) {
                            club_owner = eachClubUser.user_id === eachClubUser.added_by ? true : false;
                            var added = false;
                            _.each(_personArrys[0].role_ids, function (roleId) {
                                var roleMode = $scope.identifyUserRoleId(roleId);
                                if (roleMode.indexOf("Student") != -1 && $scope.allSessions && $scope.allCurriculum && $scope.allClassess && $scope.allBatchess) {
                                    console.log('roleMode');
                                    sessionname = _.find($scope.allSessions.list, function (data) {
                                        return data._id === _personArrys[0].session_id;
                                    });
                                    curriculumname = _.find($scope.allCurriculum.list, function (data) {
                                        return data._id === _personArrys[0].curriculum_id;
                                    });
                                    classname = _.find($scope.allClassess.list, function (data) {
                                        return data._id === _personArrys[0].class_id;
                                    });
                                    batchname = _.find($scope.allBatchess.list, function (data) {
                                        return data._id === _personArrys[0].batch_id;
                                    });
                                    var userDetails = {
                                        user_id: _name._id,
                                        name: _name.name,
                                        sess_id: sessionname._id,
                                        sess_name: sessionname.name,
                                        cur_id: curriculumname._id,
                                        cur_name: curriculumname.name,
                                        cls_id: classname._id,
                                        cls_name: classname.name,
                                        btc_id: batchname._id,
                                        btc_name: batchname.name,
                                        role_type: "student",
                                        owner: club_owner,
                                        can_delete: eachClubUser.can_delete,
                                        image: userPic,
                                        username: _name.username,
                                        admission_number: _name.admission_number
                                    };
                                    userDetails.hideChkBox = userDetails.can_delete == false && userDetails.owner == true || userDetails.can_delete == false && userDetails.owner == false ? false : true;

                                    $scope.userNames.push(userDetails);
                                    return;
                                } else if (roleMode.indexOf("Student") == -1) {
                                    var _roleMode = $scope.identifyUserRoleId(roleId);

                                    if (!added) {
                                        var userDetails = {
                                            user_id: _name._id,
                                            name: _name.name,
                                            role_type: [_roleMode],
                                            owner: club_owner,
                                            can_delete: eachClubUser.can_delete,
                                            image: userPic,
                                            username: _name.username,
                                            empNo: _name.employee_no
                                        };
                                        userDetails.hideChkBox = userDetails.can_delete == false && userDetails.owner == true || userDetails.can_delete == false && userDetails.owner == false ? false : true;
                                        added = true;
                                        $scope.userNames.push(userDetails);
                                        return;
                                    } else {
                                        $scope.userNames[$scope.userNames.length - 1].role_type.push(_roleMode);
                                    }
                                }
                            });
                            $scope.userNames = _.uniq($scope.userNames);
                            if ($scope.userNames != null) {
                                $scope.ifMembersExist = true;
                            }
                        }

                        $scope.club_Members = angular.copy($scope.userNames);
                        $scope.selectedUsers = $scope.club_Members;
                        console.log($scope.club_Members);
                    }
                }
            }
        });
        console.log($scope.club);
        $scope.$apply();
    }

    //To show search list
    $scope.showDropBox = function () {
        $scope.showSearchBottomSheet = true;
    };

    /*
     * Creates a club after validating the details
     * 
     * @param : null
     * 
     * @return - null
     */
    $scope.createNewClub = function () {
        $scope.loading = true;
        $scope.clubActionBtns = false;
        $scope.ifUpdated = true;
        $scope.selectedUserstoClub = _.uniq($scope.selectedUserstoClub);

        for (var i = 0; i < $scope.selectedUsers.length; i++) {
            var data = $scope.selectedUsers[i];
            $scope.membersObj.push(data);
        }
        $scope.clubMember = [];
        $scope.clubDetails = {};
        var arrayObj = {};
        var newArrayObj = {};
        if ($stateParams.club_id) {
            //Its for updating the club with new users
            var existingMemberCount = 0;
            _.each($scope.membersObj, function (eachUser) {
                var isexisting = false;
                if (eachUser) {
                    _.each($scope.getClubData.users, function (eachmember) {
                        if (eachUser._id === eachmember.user_id) {
                            isexisting = true;
                            existingMemberCount++;
                        }
                    });
                    if (!isexisting) {
                        var users = {
                            user_id: eachUser._id,
                            status: 'active',
                            added_by: uid,
                            can_delete: true,
                            added_date: $scope.currentDate
                        };
                        $scope.clubMember.push(users);
                    }
                }
            });
            $scope.clubDetails = $scope.clubMember;
            if (existingMemberCount > 0) toastr.error(existingMemberCount + " member(s) is/are already members of the club");
            if ($scope.clubDetails.length == 0) {
                localStorageService.set('selectedClubId', $stateParams.club_id);
                localStorageService.set('isClubOwnerID', Meteor.userId());
                $state.go('clubPost');
                toastr.error("No new members");
                return;
            }
        } else {
            //Its for inserting the club with new users          
            $scope.clubDetails.name = $scope.clubName;
            $scope.clubDetails.created_by = uid;
            $scope.clubDetails.created_date = $scope.currentDate;
            $scope.clubDetails.status = 'active';
            if ($scope.serverFileurl) {
                $scope.clubDetails.logo = $scope.serverFileurl;
            }
            $scope.clubDetails.school_id = schoolId;

            _.each($scope.membersObj, function (eachUser) {
                if (eachUser) {
                    var users = {
                        user_id: eachUser._id,
                        status: 'active',
                        added_by: uid,
                        can_delete: true,
                        added_date: $scope.currentDate
                    };
                    $scope.clubMember.push(users);
                }
            });

            if ($scope.isCreateClub == true) {
                var usersData = {
                    user_id: uid,
                    status: 'active',
                    added_by: uid,
                    can_delete: false,
                    added_date: $scope.currentDate
                };
                var id = Math.random().toString(36).substr(2, 10);
                // var mongoose = require('mongoose');
                //let id = new mongoose.Types.ObjectId().toString()
                newArrayObj._id = id;
                newArrayObj.item = "Created  " + $scope.club.name;
                newArrayObj.status = "approved";
                newArrayObj.approver_id = uid;
                newArrayObj.doc_type = "auto_generated";
                newArrayObj.club_name = $scope.club.name;
                newArrayObj.date = $scope.currentDate;
                newArrayObj.school_id = schoolId;
            }
            $scope.clubMember.push(usersData);
            // _.each($scope.myHODData, function(eachHod) {
            //   $scope.clubMember.push(eachHod);
            // })

            // _.each($scope.myHOSData, function(eachHos) {
            //   $scope.clubMember.push(eachHos);
            // })
            // _.each($scope.myPrinceData, function(eachprincipal) {
            //   $scope.clubMember.push(eachprincipal);
            // })
            $scope.clubDetails.users = [];
            $scope.clubMember = _.uniq($scope.clubMember);
            _.each($scope.clubMember, function (eachMember) {
                if (eachMember != null) {
                    $scope.clubDetails.users.push(eachMember);
                }
            });
        }
        $scope.determinateValue = true;
        $scope.clubDetails.academic_year = localStorageService.get('academic_year');
        authService.callAPI("/v0/club/create", "POST", {
            userId: localStorageService.get('user_id'),
            club_id: $stateParams.club_id,
            details: angular.copy($scope.clubDetails)
        }, function (resp) {
            try {
                console.log(resp);

                if (!resp.error) {
                    var result = resp.result.data.data;
                    $scope.determinateValue = 1;
                    $interval(function () {
                        $scope.determinateValue += 1;
                    }, 400);
                    $timeout(function () {
                        $scope.determinateValue = false;
                        if ($stateParams.mode == 'addmore') {
                            toastr.success("New member(s) added successfully!");
                        } else {
                            toastr.success("Club created successfully!");
                        }

                        localStorageService.set('selectedClubId', result);
                        localStorageService.set('isClubOwnerID', localStorageService.get('user_id'));
                        $state.go('clubPost');
                        $scope.addedMemberData = [];
                        $scope.loading = false;
                    }, 5000);
                } else {
                    toastr.error("Some thing went wrong !.Please try after some time.dd");
                    $scope.ifCliked = false;
                }
            } catch (e) {
                console.log(e);
                toastr.error("Some thing went wrong !.Please try after some time.gg");
                $scope.ifCliked = false;
            }
        });
        // Meteor.call("clubCreation", angular.copy($scope.clubDetails), $stateParams.club_id, function (error, result) {
        //     if (error) {
        //         toastr.error("Some thing went wrong !.Please try after some time.")
        //         $scope.ifCliked = false;
        //     } else {


        //     }
        //     $scope.$apply();
        // });
    };
    /*********************Logo uploads****************************/
    /*
     * To upload club logo
     * 
     * @param : null
     * 
     * @return - null
     */

    var upload = function upload(pic) {
        $scope.clubActionBtns = false;
        var serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads";
        var userPath = localStorageService.get('user_id') + "/clubActivity/";
        var fileObj = pic;

        uploadService.uploadCheckService(fileObj, serverUrl, userPath, function (result) {
            // try {
            if (result.url) {
                $scope.actionEdit = false;
                $scope.club.picFile = undefined;
                $scope.serverFileurl = result.url;
                $scope.createNewClub();
            }
            if (result.progress) {
                $scope.progressRep = result.progress;
            }
            if (!result) {
                $scope.ifCliked = false;
            }
            // } catch (e) {
            //     console.log(e)
            // }
        });
    };
    $scope.myImage = '';
    $scope.myCroppedImage = '';
    $scope.handleFileSelect = function (evt) {
        var file = evt[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
                $scope.myImage = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    };

    /*
     * Validation for creating club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.imgSubmit = function (logo) {
        $scope.ifCliked = true;
        var reg = /^([A-Za-z0-9])[^]*$/;
        if ($scope.club == undefined || $scope.club == '' || $scope.club.name == undefined) {
            toastr.error("Please enter club title");
            $scope.loading = false;
            $scope.ifCliked = false;
            return false;
        }
        var myUserId = localStorageService.get('user_id');
        var school_id = localStorageService.get('school_id');
        authService.callAPI("/v0/club/check-name/" + school_id + "/" + myUserId + "/" + $scope.club.name, "GET", {}, function (resp) {
            try {
                if (!resp.error) {
                    var clubName = $scope.club.name.match(reg) ? "passed" : "failed";
                    if (clubName == 'failed') {
                        toastr.error("Please enter valid club title");
                        $scope.club.name = '';
                        $("#club_name").focus();
                        $scope.ifCliked = false;
                        return false;
                    } else {
                        $scope.clubName = $scope.club.name;
                    }

                    $scope.loading = true;
                    $scope.usersArray = [];
                    for (var i = 0; i < $scope.selectedUserstoClub.length; i++) {
                        var data = $scope.selectedUserstoClub[i];
                        for (var j = 0; j < data.length; j++) {
                            $scope.usersArray.push(data[j]);
                        }
                    }
                    $scope.members = _.uniq($scope.usersArray);
                    if ($scope.club == undefined || $scope.club == '' || $scope.club.name == undefined) {
                        toastr.error("Please enter club title");
                        $scope.loading = false;
                        $scope.ifCliked = false;
                        return false;
                    }
                    if ($scope.club.name.length > 30) {
                        toastr.error("Title is too long !");
                        $scope.loading = false;
                        $scope.ifCliked = false;
                        return false;
                    }
                    if ($scope.club.name.length < 2) {
                        toastr.error("Title is too short !");
                        $scope.loading = false;
                        $scope.ifCliked = false;
                        return false;
                    }
                    if (!$scope.club.picFile) {
                        toastr.error("Please Upload Club Logo !");
                        $scope.loading = false;
                        $scope.ifCliked = false;
                        return false;
                    }
                    if ($scope.club.picFile) {
                        console.log($scope.club.picFile);
                        upload($scope.club.picFile);
                    } else {
                        $scope.createNewClub();
                    }
                } else {
                    toastr.error("Club title exists, Please create club with another name");
                    $scope.loading = false;
                    $scope.ifCliked = false;
                    return false;
                }
                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
        });
    };
    $scope.addedMemberData = [];

    /*
     * To add members from common filter and get their role details
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.ProcessValue = function () {
        var selectedUser = _.filter(this.filteredNotEndorsedUsers, function (user) {
            return user.isChecked === true;
        });
        if (selectedUser === undefined || selectedUser.length === 0) {
            toastr.error('Please Select the User');
            return false;
        } else {
            var members = [];
            if ($stateParams.club_id) {
                Meteor.call("usersOfClub", $stateParams.club_id, function (error, result) {
                    if (error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    } else {
                        members = result;
                    }
                });
            }
            _.each(selectedUser, function (eachUser, $index) {
                if ($stateParams.club_id && members != null && eachUser) {
                    _.each(members, function (eachMember) {
                        if (eachUser._id === eachMember.user_id) {
                            toastr.error("Already existing member of club");
                            selectedUser[$index] = null;
                        }
                    });
                }
                _.each($scope.selectedUsers, function (eachAddedMember) {
                    if (eachUser && eachAddedMember) {
                        if (eachUser._id === eachAddedMember._id) {
                            eachAddedMember.isChecked = false;
                            toastr.error("Already added member");
                            selectedUser[$index] = null;
                        }
                    }
                });
                if (eachUser._id === uid) {
                    if (selectedUser[$index]) {
                        selectedUser[$index] = null;
                    }
                }
            });
        }
        _.each(selectedUser, function (user) {
            if (user != null) {
                $scope.selectedUsers.push(user);
            }
        });
        if (moduleDetails && moduleDetails.feature_role) {
            _.each(moduleDetails.feature_role, function (eachRole) {
                var memberData = {};
                memberData.mem_count = 0;
                memberData.role = '';
                if (eachRole.f_id == "hosComponent") memberData.role = "HOS";else if (eachRole.f_id == "hodComponent") memberData.role = "HOD";else if (eachRole.f_id == "parentComponent") memberData.role = "Parent";else if (eachRole.f_id == "teacherComponent") memberData.role = "Teacher";else if (eachRole.f_id == "studentComponent") memberData.role = "Student";else if (eachRole.f_id == "principalComponent") memberData.role = "Principal";
                _.each(selectedUser, function (member) {
                    if (member) {
                        if (member.role_ids) {
                            for (var i = 0; i < member.role_ids.length; i++) {
                                if (member.role_ids[i] == eachRole.role_id && eachRole.name != "Parent Component") {
                                    memberData.mem_count++;
                                    break;
                                }
                            }
                        }
                    }
                });
                if (memberData.mem_count > 0) {
                    $scope.addedMemberData.push(memberData);
                    //toastr.success(memberData.mem_count + " " + memberData.role + " added successfully")
                    $scope.showCreateButton = true;
                }
            });
        }
        if ($scope.addedMemberData != null) $scope.ifMembersExist = true;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    };

    $scope.showSearchBottomSheet = true;
    $scope.showDropBox = function () {
        $scope.showSearchBottomSheet = true;
    };

    /*
     * To identify role details from roleids 
     * 
     * @param : null
     * 
     * @return - Role name of specified roleids
     */

    $scope.identifyUserRoleId = function (role_id) {
        $scope.assignNames = '';
        var moduleDetails = [];
        moduleDetails = $scope.moduleDetailsData;

        if (moduleDetails && moduleDetails.feature_role) {
            _.each(moduleDetails.feature_role, function (eachRole) {
                if (eachRole.role_id == role_id) {
                    if (eachRole.f_id == "hosComponent") $scope.assignNames += "HOS";else if (eachRole.f_id == "hodComponent") $scope.assignNames += "HOD";else if (eachRole.f_id == "parentComponent") $scope.assignNames += "Parent";else if (eachRole.f_id == "teacherComponent") $scope.assignNames += "Teacher";else if (eachRole.f_id == "studentComponent") $scope.assignNames += "Student";else if (eachRole.f_id == "principalComponent") $scope.assignNames += "Principal";else if (eachRole.f_id == "adminComponent") $scope.assignNames += "Super Admin";
                }
            });
        }
        console.log($scope.assignNames);
        return $scope.assignNames;
    };

    //Start : To set mode of operation in create club page


    /*
     * Remove selected users from a club
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.removeMembers = function () {
        $scope.showSearchBox = false;
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure you want to remove selected user ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            $scope.ifRemoved = true;
            var finalUsers = void 0;

            var userMember = _.filter($scope.userNames, function (user) {
                return user.isChecked === true;
            });
            var clubID = $stateParams.club_id;
            var selectedClub = Club.findOne({
                _id: clubID
            });
            var resUser = _.where(userMember, {
                owner: false
            }); // to avoid club owner          

            var resUser2 = _.where(userMember, {
                can_delete: true
            }); // to avoid (HOS,HOD and Principal) default users 

            Meteor.call("updateUsersToClub", resUser2, $stateParams.club_id, function (error, result) {
                if (error) {
                    if (error.error) {
                        toastr.error("Some thing went wrong !.Please try after some time.");
                    }
                } else {
                    toastr.success("Users removed successfully!");
                }
                localStorageService.set('selectedClubId', $stateParams.club_id);
                localStorageService.set('isClubOwnerID', Meteor.userId());
                $state.go('clubPost');
            });
        });
    };

    $scope.removeMode = false;

    /*
     * To select all members from filter
     * 
     * @param : null
     * 
     * @return - null
     */

    $scope.selectAll = function (selected) {
        //select all clicks
        if (selected === true) {
            for (var i = 0; i < $scope.userNames.length; i++) {
                if ($scope.userNames[i].is_exists == undefined) {
                    $scope.userNames[i].isChecked = true;
                }
            }
            $scope.removeMode = true;
        }
        if (selected === false) {
            for (var i = 0; i < $scope.userNames.length; i++) {
                $scope.userNames[i].isChecked = false;
            }
            $scope.removeMode = false;
        }
    };
    $scope.personArray = [];

    /*
     * To get selected members from filter
     * 
     * @param : null
     * 
     * @return - null
     */
    $scope.getClicked = function (person) {
        //On single checkbox clicks
        if (person) {

            var userMember = _.filter($scope.userNames, function (user) {
                return user.isChecked === true;
            });
            $scope.removeMode = $stateParams.mode == 'remove' && userMember.length >= 1 ? true : false;
            if (person.isChecked === true) {
                $scope.subjectEndorsementBtn = true;
                if ($scope.personArray.indexOf(person.user_id) === -1) {
                    $scope.personArray.push(person);
                }
            } else {
                if ($scope.personArray.indexOf(person.user_id) === -1) {
                    $scope.personArray.splice($scope.personArray.indexOf(person), 1);
                }
            }
            if ($scope.personArray.length === 0) {
                $scope.subjectEndorsementBtn = false;
            }
            var userTo = _.filter($scope.userNames, function (user) {
                return user.isChecked === true;
            });
            if ($scope.userNames.length === userTo.length) {
                $scope.allItemsSelected = true;
            }
        }
    };
    $scope.addedUserDetails = [];
    $scope.members = [];
    $scope.membersObj = [];
    $scope.selectedUserstoClub = [];

    $scope.deleteFromSelectedMembers = function () {

        var selectedUserForRemove = _.filter($scope.selectedUsers, function (user) {

            return user.isChecked === false || !user.isChecked;
        });
        console.log($scope.selectedUsers);
        console.log(selectedUserForRemove);
        if (selectedUserForRemove != undefined && selectedUserForRemove.length <= 0) {
            toastr.error("Please select the user");
            return false;
        }
        $scope.selectedUsers = selectedUserForRemove;
        // $scope.selectedUsers = _.filter($scope.selectedUsers, function (user) {
        //     return user.isChecked === false;
        // })
        // console.log($scope.selectedUsers)
    };

    $scope.makeChecked = function (personList) {
        console.log(personList);
        // if(!personList.isChecked == true){
        //     personList.isChecked = false
        // }else{
        //     personList.isChecked = true
        // }
    };
};
CreateClub.$inject = ["$scope", "$state", "$stateParams", "$mdMedia", "$mdDialog", "$rootScope", "authService", "localStorageService", "CONSTANTS", "uploadService", "$interval", "$timeout"];

exports.default = CreateClub;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Fri Dec 21 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var CurriculumConsoleController = function CurriculumConsoleController($scope, $rootScope, authService, localStorageService, $state, $mdDialog, $location, $anchorScroll) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CurriculumConsoleController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Curriculum Console";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var ctrl = this;
    ctrl.minDate = new Date();
    ctrl.selectedSessions = [];
    var sessionsArry = [];
    ctrl.enableNextBtn = false;
    ctrl.showSessBtn = false;
    this.addedSessions = [];
    ctrl.initialSettingId = 0;
    $scope.showWizard = false;
    this.errors = {};
    var schoolId = localStorageService.get('school_id');

    $scope.getList = function () {
        authService.callAPI("/v0/initial-settings/curriculum-console/academic/" + schoolId, "GET", null, function (response) {
            try {
                ctrl.acdConsole = response.result.data.data.academicConsoleData;
                ctrl.fullSettings = response.result.data.data.settingsData;
                var addedSessions = ctrl.acdConsole;
                var allSettings = angular.copy(ctrl.fullSettings);

                if (addedSessions) {
                    ctrl.addedSessions = _.pluck(addedSessions, 'session_id');
                }

                var alreadyAddedSessions = ctrl.addedSessions;
                ctrl.sessionPackage = _.find(ctrl.fullSettings, function (sess) {
                    return sess.type == 'session';
                });

                if (ctrl.sessionPackage) {
                    ctrl.sessionPackage.list = _.filter(ctrl.sessionPackage.list, function (sess) {
                        return alreadyAddedSessions.indexOf(sess._id) === -1;
                    });
                    ctrl.sessionPackage.list = _.uniq(ctrl.sessionPackage.list, function (doc) {
                        return doc._id;
                    });
                }
                ctrl.curriculumPackage = _.filter(ctrl.fullSettings, function (sess) {
                    return sess.type == 'curriculum';
                });

                ctrl.getSession(allSettings);
                ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
            } catch (e) {
                console.log(e);
            }
            $scope.$apply();
        });
    };

    $scope.getList();

    $scope.btnLabel = "Save";

    this.editMe = function (newsession) {
        _this.currentEditSession = newsession._id;
        var session = angular.copy(newsession);
        _this.sessionToEdit = session;
        var timeObjStart = converTimeBack(session.start_time);
        var timeObjEnd = converTimeBack(session.end_time);
        if (timeObjStart) {
            _this.sessionToEdit.hh = timeObjStart.hh;
            _this.sessionToEdit.mm = timeObjStart.mm;
            _this.sessionToEdit.mer = timeObjStart.mer;
            _this.sessionToEdit.hhEnd = timeObjEnd.hh;
            _this.sessionToEdit.mmEnd = timeObjEnd.mm;
            _this.sessionToEdit.merEnd = timeObjEnd.mer;
        }
        _this.sessionToEdit.curriculum = _.pluck(session.curriculum, "_id");
        _this.editMode = true;
        $location.hash('top');
        $anchorScroll();
    };

    this.updateSession = function () {
        validateSessionUpdate();
        if (Object.keys(_this.errors).length > 0) {
            return false;
        }

        var requestBody = {
            sessions: [_this.sessionToEdit],
            settingId: ctrl.sessionPackage._id,
            school_id: schoolId
        };

        authService.callAPI("/v0/initial-settings/curriculum-console/add", "POST", requestBody, function (response) {
            if (response && response.result) {
                ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                ctrl.selectedSessions = [];
                ctrl.cancelEdit();
                $scope.getList();
                toastr.success("Updated successfully!");
            } else {
                try {
                    console.log(response.error);
                } catch (ex) {
                    console.log(ex);
                }
            }
            $scope.$apply();
        });
    };

    var editTimeValidate = function editTimeValidate(timeObj, sessionObj) {

        var startHours = parseInt(timeObj.hh);
        var startMinutes = parseInt(timeObj.mm);
        var startMeridian = timeObj.mer;
        var endHours = parseInt(timeObj.hhEnd);
        var endMinutes = parseInt(timeObj.mmEnd);
        var endMeridian = timeObj.merEnd;
        if (startMeridian == 'PM' && startHours != 12) {
            startHours += 12;
        }
        if (endMeridian == 'PM' && endHours != 12) {
            endHours += 12;
        }

        if (endMeridian == 'AM' && endHours == 12) {
            endHours = 0;
        }
        if (startMeridian == 'AM' && startHours == 12) {
            startHours = 0;
        }
        var d = new Date(1991, '04', '01', startHours, startMinutes, '00', '000');
        var dEnd = new Date(1991, '04', '01', endHours, endMinutes, '00', '000');
        if (d >= dEnd) {
            return false;
        }
        sessionObj.start_time = d;
        sessionObj.end_time = dEnd;
        return true;
    };

    var validateSessionUpdate = function validateSessionUpdate(obj) {
        _this.errors = {};
        if (!_this.sessionToEdit.hh || _this.sessionToEdit.hh == '') {
            _this.errors['editStart'] = 'start time hours required';
        } else if (!_this.sessionToEdit.mm || _this.sessionToEdit.mm == '') {
            _this.errors['editStart'] = 'start time minutes required';
        } else if (!_this.sessionToEdit.mer || _this.sessionToEdit.mer == '') {
            _this.errors['editStart'] = 'start time meridian required';
        } else {
            delete _this.errors['editStart'];
        }
        if (!_this.sessionToEdit.hhEnd || _this.sessionToEdit.hhEnd == '') {
            _this.errors['editEnd'] = 'end time hours required';
        } else if (!_this.sessionToEdit.mmEnd || _this.sessionToEdit.mmEnd == '') {
            _this.errors['editEnd'] = 'end time minutes required';
        } else if (!_this.sessionToEdit.merEnd || _this.sessionToEdit.merEnd == '') {
            _this.errors['editEnd'] = 'end time meridian required';
        } else if (!editTimeValidate(_this.sessionToEdit, _this.sessionToEdit)) {
            _this.errors['editEnd'] = 'end time should be after start time';
        } else {
            delete _this.errors['editEnd'];
        }
        if (!_this.sessionToEdit.curriculum || _this.sessionToEdit.curriculum == '' || _this.sessionToEdit.curriculum.length <= 0) {
            _this.errors['editCurriculum'] = 'curriculum required';
        } else {
            delete _this.errors['editCurriculum'];
        }
    };

    var validateSessionCreate = function validateSessionCreate() {
        ctrl.errors.iscreateError = false;
        _this.errors = {};
        var count = 0;
        _this.errors.create = [];

        _.each(ctrl.selectedSessions, function (sess) {
            if (!ctrl.errors.create[count]) {
                ctrl.errors.create[count] = {};
            }
            if (!sess.curriculum || sess.curriculum.length <= 0) {
                ctrl.errors.create[count].curriculum = 'curriculum required';
            } else {
                delete ctrl.errors.create[count].curriculum;
            }
            if (!sess.hh || sess.hh == null) {
                ctrl.errors.create[count].start_time = 'start time hours required';
            } else if (!sess.mm || sess.mm == null) {
                ctrl.errors.create[count].start_time = 'start time minutes required';
            } else if (!sess.mer || sess.mer == null) {
                ctrl.errors.create[count].start_time = 'start time meridian required';
            } else {
                delete ctrl.errors.create[count].start_time;
            }

            if (!sess.hhEnd || sess.hhEnd == null) {
                ctrl.errors.create[count].end_time = 'end time hours required';
            } else if (!sess.mmEnd || sess.mmEnd == null) {
                ctrl.errors.create[count].end_time = 'end time minutes required';
            } else if (!sess.merEnd || sess.merEnd == null) {
                ctrl.errors.create[count].end_time = 'end time hours required';
            } else if (!editTimeValidate(sess, sess)) {
                ctrl.errors.create[count].end_time = 'end time should be after start time';
            } else {
                delete ctrl.errors.create[count].end_time;
            }
            if (Object.keys(ctrl.errors.create[count]).length !== 0) {
                ctrl.errors.iscreateError = true;
            }
            count++;
        });

        if (ctrl.errors.create.length === 0) {
            delete ctrl.errors.create;
        }
    };

    this.cancelEdit = function () {
        _this.editMode = false;
        _this.currentEditSession = false;
        _this.sessionToEdit = {};
    };

    this.getSession = function (allSettings) {
        ctrl.curriculumList = [];

        var sessionIds = ctrl.acdConsole;

        ctrl.curriculumList = ctrl.curriculumPackage[0].list;
        sessionsArry = _.uniq(_.pluck(sessionIds, 'session_id'));

        ctrl.sessionsNames = [];

        var sessionData = _.find(allSettings, function (sess) {
            return sess.type == "session";
        });

        _.each(sessionsArry, function (data2) {
            var sessionDataSet = _.find(sessionData.list, function (sess) {
                return sess._id == data2;
            });

            ctrl.sessionsNames.push(sessionDataSet);
        });

        ctrl.sessionsDetails = [];
        var i = 0;
        _.each(ctrl.sessionsNames, function (data3) {
            if (!data3) {
                data3 = {};
            }
            data3.curriculum = [];
            var curriculumData = _.filter(ctrl.acdConsole, function (one) {
                return one.session_id == data3._id;
            });

            var j = 0;
            _.each(curriculumData, function (data4) {
                var curriculumDetails = _.find(allSettings, function (oneS) {
                    return _.find(oneS.list, function (two) {
                        return two._id == data4.curriculum_id;
                    });
                });
                var curriculumDataSet = _.find(curriculumDetails.list, function (curr) {
                    return curr._id == data4.curriculum_id;
                });
                data3.curriculum[j] = curriculumDataSet;
                j++;
            });
            ctrl.sessionsDetails.push(data3);
            i++;
        });
        ctrl.sessionsLength = ctrl.sessionsDetails.length;
    };

    ctrl.dragControlListeners = {
        //optional param
        containment: '#blocks'
    };

    ctrl.sortableCloneOptions1 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        dragEnd: function dragEnd(obj) {
            for (var i = 0; i < ctrl.sessionPackage.list.length; i++) {
                var data = {
                    _id: ctrl.sessionPackage.list[i]._id,
                    end_time: ctrl.sessionPackage.list[i].end_time,
                    name: ctrl.sessionPackage.list[i].name,
                    start_time: ctrl.sessionPackage.list[i].start_time
                };
                ctrl.sessionPackage.list[i] = undefined;
                ctrl.sessionPackage.list[i] = data;
            }
        }
    };

    ctrl.showSessions = function () {
        ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
    };

    ctrl.getcurriculum = function (id) {
        ctrl.showSessBtn = true;
    };

    ctrl.saveSession = function () {
        validateSessionCreate();

        if (ctrl.errors.iscreateError) {
            return false;
        }

        var requestBody = {
            sessions: ctrl.selectedSessions,
            settingId: ctrl.sessionPackage._id,
            school_id: schoolId
        };

        authService.callAPI("/v0/initial-settings/curriculum-console/add", "POST", requestBody, function (response) {
            if (response && response.result) {
                ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                ctrl.selectedSessions = [];
                $scope.getList();
                toastr.success("Updated successfully!");
            } else {
                try {
                    console.log(response.error);
                } catch (ex) {
                    console.log(ex);
                }
            }
            $scope.$apply();
        });
    };

    function checkPreviouslyAssignedCirriculumToUser(id) {

        var requestBody = {
            id: id,
            settinsCurr: ctrl.curriculumPackage[0].list
        };
        authService.callAPI("/v0/initial-settings/curriculum-console/check/assigned-or-not", "POST", requestBody, function (response) {
            console.log(response);
            if (response && response.result) {
                try {
                    showPopupforDeleteAction(response.result.data.details.no_of_users, id);
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                try {
                    console.log(response.error);
                } catch (ex) {
                    console.log(ex);
                }
            }
            $scope.$apply();
        });
    }

    function showPopupforDeleteAction(no_of_users, id) {
        if (no_of_users > 0) {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Warning').textContent('Cannot delete. Users are already assigned').ariaLabel('Alert Dialog Demo').ok('Ok').targetEvent());
            return false;
        } else {
            var delete_toast_msg = 'You will loose previously added session info, if any.';
            var confirm = $mdDialog.confirm().title('Are you sure?').textContent(delete_toast_msg).ariaLabel('Confirm delete').ok('Yes').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                var requestBody = {
                    sessionId: id,
                    school_id: schoolId
                };
                authService.callAPI("/v0/initial-settings/curriculum-console/delete", "DELETE", requestBody, function (response) {
                    if (response && response.result) {
                        try {
                            ctrl.enableNextBtn = ctrl.sessionPackage.list.length > 0 ? true : false;
                            ctrl.selectedSessions = [];
                            ctrl.cancelEdit();
                            $scope.getList();
                            toastr.success("Deleted successfully!");
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        try {
                            console.log(response.error);
                        } catch (ex) {
                            console.log(ex);
                        }
                    }
                    $scope.$apply();
                });
            });
        }
    }

    ctrl.removeSession = function (id) {
        if (id != _this.currentEditSession) checkPreviouslyAssignedCirriculumToUser(id);else toastr.error("Same session is taken to edit mode");
    };

    ctrl.deleteSession = function (pkg) {
        ctrl.sessionPackage.list.push(pkg);
        ctrl.selectedSessions.remove(pkg._id);
    };

    Array.prototype.remove = function (value) {
        this.splice(this.indexOf(value), 1);
        return true;
    };

    $scope.getTime = function (curPkg) {
        curPkg.start_time = new Date(curPkg.start_time);
        curPkg.end_time = new Date(curPkg.end_time);
    };

    var converTimeBack = function converTimeBack(time) {
        if (time) {
            time = time.trim();
            time = new Date(time);
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var meridian = hours > 11 ? "PM" : "AM";
            if (hours > 12) {
                hours -= 12;
                // meridian = "PM"
            } else if (hours === 0) {
                hours = 12;
            }
            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }

            return {
                hh: hours,
                mm: minutes,
                mer: meridian
            };
        }
    };

    this.goNext = function () {

        if ($scope.btnLabel === "Next") {
            Meteor.call("updateInitialSettingValue", 2, function (error, result) {
                toastr.success("Successfully saved!");
                $state.go("academicConsole");
            });
        } else {
            toastr.success("Updated successfully!");
            $state.go("initialSetting");
        }
    };
    ctrl.hours = [];
    ctrl.minutes = [];

    for (var i = 0; i < 60; i++) {
        var time = i < 10 ? '0' + i : i;
        ctrl.minutes.push(time);
    }

    for (var _i = 1; _i < 60; _i++) {
        var htime = _i < 10 ? '0' + _i : _i;
        if (_i < 13) {
            ctrl.hours.push(htime);
        }
    }

    this.$onDestroy = function () {
        self.hours = [];
        self.minutes = [];
        self.sessionPackage = undefined;
        self.curriculumPackage = undefined;
        self.sessionsDetails = undefined;
    };
};
CurriculumConsoleController.$inject = ["$scope", "$rootScope", "authService", "localStorageService", "$state", "$mdDialog", "$location", "$anchorScroll"];

exports.default = CurriculumConsoleController;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 19 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var CurriculumSetupController = function CurriculumSetupController($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, CurriculumSetupController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Curriculum Setup";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var self = this;

    self.reset = function () {
        self.isEdit = false;
        self.errors = {};
        self.curriculumAvailablility = null;
        self.curriculum = {};
    };

    $scope.getList = function (schoolId) {
        self.reset();
        authService.callAPI("/v0/school/details/" + schoolId + "/curriculum", "GET", null, function (response) {
            try {
                $scope.curriculums = response.result.data.data;
            } catch (e) {
                $scope.curriculums = [];
            }
            $scope.$apply();
        });
    };

    var schoolId = localStorageService.get('school_id');
    $scope.getList(schoolId);

    this.saveCurriculum = function () {
        $scope.loading = true;
        var toSave = {
            school_id: schoolId,
            curriculum_name: _this.curriculum.name
        };

        var method = "POST";
        var message = "Curriculum created successfully";
        if (_this.isEdit) {
            method = "PUT";
            toSave.curriculum_id = self.curriculum._id;
            message = "Curriculum updated successfully";
        }

        authService.callAPI("/v0/utilities/curriculum/setup", method, toSave, function (response) {
            if (response && response.result) {
                toastr.success(message);
                $scope.loading = false;
                $scope.getList(schoolId);
            } else {
                try {
                    console.log(response.error);

                    self.errors = {};

                    if (response.error.status.code == 400) {
                        toastr.error(response.error.error.message);
                    }

                    if (response.error.status.code == 422) {

                        var error = response.error.error.errors;
                        if (error.curriculum_name && error.curriculum_name['param'] == 'curriculum_name') {
                            self.errors.name = error.curriculum_name['msg'];
                        }
                    }
                } catch (ex) {
                    console.log(ex);
                }
            }
        });
    };

    self.removeCurriculum = function (curId, currName) {
        var requestBody = {
            school_id: schoolId,
            curriculum_id: curId
        };
        var confirm = $mdDialog.confirm().title('Are you sure to delete ' + currName + "?").textContent('').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            authService.callAPI("/v0/utilities/curriculum/setup", "DELETE", requestBody, function (response) {
                if (response && response.result) {
                    self.reset();
                    $scope.getList(schoolId);
                    $scope.loading = false;
                    toastr.success('Successfully removed!');
                } else {
                    var error = response.error;
                    try {
                        toastr.error(error.error.message);
                        $scope.loading = false;
                    } catch (ex) {
                        toastr.error(error);
                    }
                }
            });
        });
    };

    this.editCurriculum = function (curriculum) {
        this.isEdit = true;
        this.focusMe = true;
        this.oldCurriculum = curriculum.name;
        this.curriculum = angular.copy(curriculum);
    };

    this.openMenu = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    this.$onDestroy = function () {};
};
CurriculumSetupController.$inject = ["$scope", "$rootScope", "authService", "localStorageService", "$state", "$mdDialog"];

exports.default = CurriculumSetupController;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _editSubjectPackage = __webpack_require__(917);

var _editSubjectPackage2 = _interopRequireDefault(_editSubjectPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
                                                                                                                                                           * Project: /home/cordova03/projects/educore_3.5
                                                                                                                                                           * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
                                                                                                                                                           * Author: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Last Modified: Thu Dec 20 2018
                                                                                                                                                           * Modified By: Naveen Nazimudeen N
                                                                                                                                                           * -----
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var SubjectSetupController = function SubjectSetupController($scope, $rootScope, authService, localStorageService, $state, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, SubjectSetupController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Subject Setup";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var self = this;
    var schoolId = localStorageService.get('school_id');

    var requestObj = {
        args: {
            school_id: schoolId
        }
    };

    $scope.getList = function () {
        authService.callAPI("/v0/utilites/subject/init", "POST", requestObj, function (response) {
            try {
                console.log(response.result.data.details.response);
                self.packages = response.result.data.details.response;
            } catch (e) {
                self.packages = [];
            }
            $scope.$apply();
        });
    };

    $scope.getList();

    self.editSubjectPackage = function (packId) {
        var packageDetails = _.find(self.packages, function (o) {
            return o._id == packId;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'data', 'localStorageService', 'authService', 'parentScope', UpdatePackageController],
            controllerAs: 'updatePackageCtrl',
            locals: {
                "data": packageDetails,
                parentScope: $scope
            },
            template: _editSubjectPackage2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: useFullScreen
        }).then(function (answer) {
            $scope.status = 'You said the information was "' + answer + '".';
        }, function () {
            $scope.status = 'You cancelled the dialog.';
        });
    };

    self.removeSubPackage = function (subjectPack) {
        var packId = subjectPack._id;

        var requestObj = {
            args: {
                packId: packId,
                school_id: schoolId
            }
        };
        var confirm = $mdDialog.confirm().title('Are you sure to delete ' + subjectPack.name + '?').textContent('').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI("/v0/utilites/subject/remove-package", "POST", requestObj, function (response) {
                if (response && response.result) {
                    $scope.getList();
                    toastr.success('Successfully removed!');
                } else {
                    try {
                        console.log(response.error);
                        if (response.error.status.code == 400) {
                            toastr.error(response.error.error.error);
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                }
            });
        });
    };

    self.openMenu = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    this.$onDestroy = function () {};
};
SubjectSetupController.$inject = ["$scope", "$rootScope", "authService", "localStorageService", "$state", "$mdDialog", "$mdMedia"];

var UpdatePackageController = function UpdatePackageController($scope, $mdDialog, data, localStorageService, authService, parentScope) {
    _classCallCheck(this, UpdatePackageController);

    var self = this;

    $scope.packData = {};
    $scope.packData.list = [{
        "name": ""
    }];

    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
        parentScope.getList();
    };
    $scope.answer = function (answer) {
        $mdDialog.hide(answer);
    };
    if (data) {
        $scope.isEdit = true;
        $scope.packData = data;
        $scope.oldPackName = $scope.packData.name;
    }

    $scope.updateSubPckage = function () {
        $scope.errors = {};
        if ($scope.packData["deletes"]) {
            if ($scope.packData.deletes.length > 0) {
                var names = _.pluck($scope.packData.deletes, 'name');
                var confirm = $mdDialog.confirm().title('Are you sure to delete the ' + names + '?').textContent('').targetEvent(event).ok('Yes').cancel('No');
                $mdDialog.show(confirm).then(function () {
                    updateSubjetPackage($scope.packData);
                }, function () {
                    parentScope.getList();
                });
            }
        } else {
            validatePackdata($scope.packData);
        }
    };
    function validatePackdata(packData) {
        var undefinedName = 0;
        _.each(packData.list, function (listObj) {
            if (listObj.name == "" || listObj.name == null || listObj.name == undefined) undefinedName = 1;
        });
        if (undefinedName == 0) updateSubjetPackage(packData);else toastr.error("Please enter subject name");
    }

    function updateSubjetPackage(packData) {
        var requestObj = {
            args: {
                pack_data: packData,
                school_id: localStorageService.get('school_id')
            }
        };

        authService.callAPI("/v0/utilites/subject/update-package", "POST", requestObj, function (response) {
            if (response && response.result) {
                $scope.isEdit = false;
                parentScope.getList();
                toastr.success('Successfully saved!');
                $scope.cancel();
            } else {
                try {
                    console.log(response.error);
                    if (response.error.status.code == 400) {
                        toastr.error(response.error.error.message);
                    }
                } catch (ex) {
                    console.log(ex);
                }
            }
        });
    }

    $scope.addSubject = function () {
        if (!$scope.packData) {
            $scope.packData = {};
            $scope.packData.list = [];
        }

        if (!$scope.packData.list) {
            $scope.packData.list = [];
        }

        $scope.packData.list.push({
            name: ""
        });
    };

    $scope.removeSubject = function (subjectDet, position) {
        if (!$scope.packData.deletes) {
            $scope.packData.deletes = [];
        }
        if (subjectDet._id && subjectDet.name) {
            var subObj = {};
            subObj._id = subjectDet._id;
            subObj.name = subjectDet.name;
            $scope.packData.deletes.push(subObj);
        }
        if (!subjectDet.name) {
            $scope.packData.list.splice(position, 1);
        }
        $scope.packData.list = _.without($scope.packData.list, _.findWhere($scope.packData.list, {
            _id: subjectDet._id
        }));
    };
};

exports.default = SubjectSetupController;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/controllers/curriculumSetupController.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:00:18 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Tue Dec 18 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var SessionSetupController = function SessionSetupController($scope, $rootScope, authService, localStorageService, $state, $mdDialog) {
    "ngInject";

    var _this = this;

    _classCallCheck(this, SessionSetupController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Session Setup";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var self = this;

    this.reset = function () {
        _this.isEdit = false;
        _this.errors = {};
        _this.sessionAvailablility = null;
        self.session = {};
        _.defer(function () {
            $scope.$apply();
        });
    };

    $scope.getList = function (schoolId) {
        self.reset();
        authService.callAPI("/v0/school/details/" + schoolId + "/session", "GET", null, function (response) {
            try {
                $scope.session = response.result.data.data;
            } catch (e) {
                $scope.session = [];
            }
            $scope.$apply();
        });
    };

    var schoolId = localStorageService.get('school_id');
    $scope.getList(schoolId);

    self.saveSession = function () {
        _this.errors = {};
        if (!self.session) {
            toastr.error("Name is required");
            return false;
        }
        if (!self.session.name) {
            toastr.error("Name is required");
            return false;
        }
        if (!self.session.start_time) {
            toastr.error("Starttime is required");
            return false;
        }
        if (!self.session.end_time) {
            toastr.error("Endtime is required");
            return false;
        }
        var session = self.session;
        $scope.loading = true;

        var requestBody = {
            school_id: schoolId,
            session_name: session.name,
            start_time: session.start_time,
            end_time: session.end_time
        };

        var method = "POST";
        var message = "Session saved successfully";
        if (_this.isEdit) {
            method = "PUT";
            requestBody.session_id = session._id;
            message = "Session updated successfully";
        }
        authService.callAPI("/v0/utilities/session/setup", method, requestBody, function (response) {
            if (response && response.result) {
                toastr.success(message);
                $scope.loading = false;
                $scope.getList(schoolId);
                self.session = {};
                self.reset();
            } else {
                var error = response.error;
                try {
                    toastr.error(error.error.message);
                } catch (ex) {
                    toastr.error(error);
                }
            }
        });
    };

    self.editSession = function (session) {
        self.focusMe = true;
        _this.isEdit = true;
        _this.oldSession = session.name;
        self.session = angular.copy(session);
    };

    self.removeSession = function (curId) {
        var requestBody = {
            school_id: schoolId,
            session_id: curId
        };
        var confirm = $mdDialog.confirm().title('Are you sure to delete the session?').textContent('').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            authService.callAPI("/v0/utilities/session/setup", "DELETE", requestBody, function (response) {
                if (response && response.result) {
                    $scope.getList(schoolId);
                    $scope.loading = false;
                    self.session = undefined;
                    self.isEdit = false;
                    toastr.success('Successfully removed!');
                } else {
                    var error = response.error;
                    try {
                        toastr.error(error.error.message);
                        $scope.loading = false;
                    } catch (ex) {
                        toastr.error(error);
                    }
                }
            });
        });
    };

    this.openMenu = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    this.$onDestroy = function () {};
};
SessionSetupController.$inject = ["$scope", "$rootScope", "authService", "localStorageService", "$state", "$mdDialog"];

exports.default = SessionSetupController;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _commonFilterModule = __webpack_require__(149);

var _commonFilterModule2 = _interopRequireDefault(_commonFilterModule);

var _edituser = __webpack_require__(148);

var _edituser2 = _interopRequireDefault(_edituser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var name = 'editUser';

var EditUser = function EditUser($scope, $state, $compile, $element, authService, localStorageService, $rootScope) {
    'ngInject';

    _classCallCheck(this, EditUser);

    var ctrl = this;
    var self = this;

    $scope.showRolesList = true;
    $scope.showAcademicFilters = true;
    $scope.Users = [];
    $scope.isparent = false;
    $scope.keys = [];
    $scope.stateId = 'edituser';
    $scope.userFilter = {};
    $scope.loading = false;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Edit User";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    this.$onDestroy = function () {
        $scope.Users = [];
    };

    $scope.clearParentFields = function () {
        // clearArrayFields();
        $scope.Users = [];
    };

    $scope.searchValuesBasedOnFilter = function () {

        if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
            toastr.error('Please Select the Role');
            return false;
        } else if (this.filterObj.role_id === 'student' && (this.filterObj === undefined || this.filterObj['session'] === undefined)) {
            toastr.error('Please Select the Session');
            return false;
        } else if (this.filterObj.role_id === 'student' && (this.filterObj === undefined || this.filterObj['curriculum'] === undefined)) {
            toastr.error('Please Select the Curriculum');
            return false;
        } else if (this.filterObj.role_id === 'student' && (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0)) {
            toastr.error('Please Select the Class');
            return false;
        } else if (this.filterObj.role_id === 'student' && (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0)) {
            toastr.error('Please Select the Batch');
            return false;
        }
        console.log(this.filterObj);
        callServerToGetusers(this.filterObj);
    };

    var schoolIdLocal = localStorageService.get('school_id');
    function callServerToGetusers(filters) {
        $scope.userFilter = filters;
        var obj = {
            userMgt: filters,
            school_id: schoolIdLocal
        };
        authService.callAPI("/v0/edit_user/getAllUserBasicDetails", "POST", { args: obj }, function (response) {
            if (!response.error) {
                var result = response.result.data.details.response;
                if (result.users.length > 0) {
                    $scope.Users = [];
                    $scope.Users = result.users;
                    $scope.Users.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                    $scope.isparent = result.isparent;
                } else {
                    toastr.success('No records found');
                }
                _.defer(function () {
                    $scope.$apply();
                });;
            } else {
                console.log('error');
            }
        });
        // Meteor.call("getAllUserBasicDetails", filters, Session.get('school_id'), function(error, result) {
        //     if (error) {
        //         console.log('error')
        //     } else {
        //         console.log(result)
        //         if (result.users.length > 0) {
        //             $scope.Users = [];
        //             $scope.Users = result.users;
        //             $scope.Users.sort(function(a, b) {
        //                 var textA = a.name.toUpperCase();
        //                 var textB = b.name.toUpperCase();
        //                 return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        //             });
        //             $scope.isparent = result.isparent;
        //             _.defer(function() { $scope.$apply(); });;
        //         } else {
        //             toastr.success('No records found')
        //         }


        //     }
        // })
    }
    function _checkAllValuesInMotherObj(arr) {
        var len = arr.length;
        var motherKvs = {
            mother_name: {
                other_keys: ['mother_mobile', 'mother_email'],
                error_key: "name"
            },
            mother_mobile: {
                other_keys: ['mother_email', 'mother_name'],
                error_key: "phone"
            },
            mother_email: {
                other_keys: ['mother_mobile', 'mother_name'],
                error_key: "email"
            }
        };
        var keys = Object.keys(motherKvs);
        var str = '_error';
        var array = [];
        for (var i = 0; i < len; i++) {
            var item = arr[i];
            if (item.mother_obj) {
                for (var k = 0; k < keys.length; k++) {
                    item.mother_obj[motherKvs[keys[k]]['error_key'] + str] = '';
                }
                var err = 0;
                for (var _k = 0; _k < keys.length; _k++) {
                    if (item.mother_obj[keys[_k]]) {
                        var otherKeys = motherKvs[keys[_k]].other_keys;
                        for (var o = 0; o < otherKeys.length; o++) {
                            if (!item.mother_obj[otherKeys[o]]) {
                                err++;
                                item.mother_obj[motherKvs[otherKeys[o]].error_key + str] = motherKvs[otherKeys[o]].error_key + " is required";
                            }
                        }
                    }
                }
                if (err) {
                    array.push(item);
                } else {
                    if (item.mother_obj.mother_email) {
                        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(item.mother_obj.mother_email)) {} else {
                            item.mother_obj['email' + str] = "Please enter valid email";
                            array.push(item);
                        }
                    }
                }
            }
        }
        return array.length;
    }
    function _checkMotherPhoneAndEmail(arr) {
        var _duArray = [];
        arr.forEach(function (item) {
            if (item.mother_obj) {
                item.mother_obj.phone_error = '';
                if (item.mother_obj.mother_mobile) {
                    var len = item.mother_obj.mother_mobile.length;
                    if (len < 8 || len > 18) {
                        item.mother_obj.phone_error = "Phone number should be greater than 8 and less than 18";
                        _duArray.push(item);
                    }
                }
                if (item.mother_obj.mother_email) {
                    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(item.mother_obj.mother_email)) {} else {
                        item.mother_obj['email_error'] = "Please enter valid email";
                        _duArray.push(item);
                    }
                }
            }
        });
        return _duArray.length;
    }
    $scope.updateUsers = function () {

        if ($scope.userFilter["role_id"] === 'student') {
            console.log('jjjjjjjjjjjjjj');
            var empErrorlength = findDuplicateArrayValue($scope.Users, "admission_number", "employee_no_error");
            var nameErrorlength = findUndefinedArrayValue($scope.Users, "name", "name_error");
            var userNameErrorlength = findDuplicateArrayValue($scope.Users, "username", "username_error");
            // let phoneErrorlength = findUndefinedArrayValue($scope.Users, "phone", "phone_error")
            var parentEmailErrorlength = findUndefinedArrayValue($scope.Users, "parent_email", "parent_email_error");
            var parentnameErrorlength = findUndefinedArrayValue($scope.Users, "parent_name", "parentname_error");
            var parentnameErrolength = findDuplicateDifferentkayValue($scope.Users, "parent_email", "username", "parent_email_error");
            var motherphoneErrors = _checkMotherPhoneAndEmail($scope.Users);
            // let  = empErrorlength + userNameErrorlength + nameErrorlength + parentEmailErrorlength + parentnameErrorlength + motherphoneErrors

            if (empErrorlength + userNameErrorlength + nameErrorlength + parentEmailErrorlength + parentnameErrorlength + motherphoneErrors === 0) {
                // let error = _checkAllValuesInMotherObj($scope.Users)
                callServerToUpdate("updateStudentDetails");
            } else {
                return false;
            }
        } else {

            if ($scope.isparent) {
                var _userNameErrorlength = findDuplicateArrayValue($scope.Users, "username", "username_error");
                // let phoneErrorlength = findDuplicateArrayValue($scope.Users, "phone", "phone_error")
                var _nameErrorlength = findUndefinedArrayValue($scope.Users, "name", "name_error");

                if (_userNameErrorlength + _nameErrorlength === 0) {
                    callServerToUpdate("updateParentDetailsToUpdate");
                } else {
                    return false;
                }
            } else {
                var _empErrorlength = findDuplicateArrayValue($scope.Users, "employee_no", "employee_no_error");
                var _userNameErrorlength2 = findDuplicateArrayValue($scope.Users, "username", "username_error");
                // let phoneErrorlength = findDuplicateArrayValue($scope.Users, "phone", "phone_error")
                var _nameErrorlength2 = findUndefinedArrayValue($scope.Users, "name", "name_error");

                if (_empErrorlength + _userNameErrorlength2 + _nameErrorlength2 === 0) {
                    callServerToUpdate("updateEmployeeDetails");
                } else {
                    return false;
                }
            }
        }
    };

    function callServerToUpdate(methodname) {
        var obj = {
            users: $scope.Users,
            school_id: schoolIdLocal
        };
        $scope.loading = true;
        authService.callAPI("/v0/edit_user/" + methodname, "POST", { args: obj }, function (response) {
            $scope.loading = false;
            if (!response.error) {
                var result = response.result.data.details.response;
                console.log(result);
                $scope.Users = result;
                if (result != undefined && result.length > 0) {
                    toastr.error('Some values not updated');
                } else {
                    toastr.success('Updated successfully');
                }
                _.defer(function () {
                    $scope.$apply();
                });;
            } else {
                console.log('error');
            }
        });
        // Meteor.call(methodname, $scope.Users, Session.get('school_id'), function(error, result) {
        //     if (error) {
        //         console.log('error')
        //     } else {

        //         $scope.Users = result;
        //         if (result != undefined && result.length > 0) {
        //             toastr.error('Some values not updated');
        //         } else {
        //             toastr.success('Updated successfully')
        //         }
        //         _.defer(function() { $scope.$apply(); });;

        //     }
        // })
    }

    function findUndefinedArrayValue(arr, key, errorkey) {
        var _unArray = [];
        var _duArray = [];
        arr.forEach(function (item) {
            if (item[key] === undefined || item[key] === "" || item[key] === null) {
                item[errorkey] = "please enter the value";
                _duArray.push(item);
            }
        });
        return _duArray.length;
    }

    function findDuplicateArrayValue(arr, key, errorkey) {
        var _unArray = [];
        var _duArray = [];
        arr.forEach(function (item) {
            if (item[key] === undefined || item[key] === "" || item[key] === null) {
                item[errorkey] = "please enter the value";
                _duArray.push(item);
            } else {
                var isPresent = _unArray.filter(function (elem) {
                    return elem[key] === item[key];
                });

                if (isPresent.length > 0) {
                    item[errorkey] = "This Value is available at index : " + isPresent[0].index;
                    _duArray.push(item);
                } else {
                    delete item[errorkey];
                    _unArray.push(item);
                }
            }
        });
        return _duArray.length;
    }

    function findDuplicateDifferentkayValue(arr, key, altKey, errorkey) {
        var _unArray = [];
        var _duArray = [];
        arr.forEach(function (item) {

            var isPresent = _unArray.filter(function (elem) {
                return elem[key] === item[altKey];
            });

            if (isPresent.length > 0) {
                item[errorkey] = "This Value is available at index : " + isPresent[0].index;
                _duArray.push(item);
            } else {
                delete item[errorkey];
                _unArray.push(item);
            }
        });
        return _duArray.length;
    }

    function csvCovertor(jsonData, reportTitle, showLabel) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = (typeof jsonData === 'undefined' ? 'undefined' : _typeof(jsonData)) != 'object' ? JSON.parse(jsonData) : jsonData;
        var csv = '';
        //Set Report title in first row or line
        // csv += reportTitle + '\r\n\n';
        //This condition will generate the Label/Header
        if (showLabel) {
            var row = "";
            //This loop will extract the label from 1st index of on array
            _.each($scope.header, function (header) {
                row += header + ',';
            });
            row = row.slice(0, -1);
            //append Label row with line break
            csv += row + '\r\n';
        }

        _.each(arrData, function (data) {
            var row = "";
            _.each($scope.keys, function (key) {
                if (key === "address") {
                    row += '"' + ((data.addrLine1 ? data.addrLine1.replace(/['"]+/g, '') : '') + (data.addrLine1 ? ', ' : '') + (data.addrLine2 ? data.addrLine2.replace(/['"]+/g, '') : '') + (data.addrLine2 ? ', ' : '') + (data.city ? data.city.replace(/['"]+/g, '') : '') + (data.city ? ', ' : '') + (data.country ? data.country.replace(/['"]+/g, '') : '') + (data.country ? ', ' : '') + (data.pincode ? data.pincode.replace(/['"]+/g, '') : '')) + '",';
                } else {
                    row += '"' + data[key] + '",';
                }
            });
            row.slice(0, row.length - 1);
            //add a line break after each row
            csv += row + '\r\n';
        });

        if (csv == '') {
            alert("Invalid data");
            return;
        }
        //Generate a file name
        var fileName = "Report_";
        //this will remove the blank-spaces from the title and replace it with an underscore
        fileName += reportTitle.replace(/ /g, "_");

        //Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,' + escape(csv);

        //this trick will generate a temp <a /> tag
        var link = document.createElement("a");
        link.href = uri;

        //set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";

        //this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    $scope.exportAsCSV = function () {

        $scope.keys = [];
        $scope.header = [];

        if ($scope.userFilter["role_id"] === 'student') {

            $scope.header.push("Academic Details");
            $scope.header.push("Admission No");
            $scope.header.push("Name");
            $scope.header.push("Email");
            $scope.header.push("Phone No");
            $scope.header.push("Address");
            $scope.header.push("Parent Email");
            $scope.header.push("parent name");
            $scope.header.push("Status");
            $scope.header.push("Mapped");

            $scope.keys.push("academicDetails");
            $scope.keys.push("admission_number");
            $scope.keys.push("name");
            $scope.keys.push("username");
            $scope.keys.push("phone");
            $scope.keys.push("address");
            $scope.keys.push("parent_email");
            $scope.keys.push("parent_name");
            $scope.keys.push("mapped");
            $scope.keys.push("mappedStudent");
        } else {

            $scope.header.push("Employee No");
            $scope.header.push("Name");
            $scope.header.push("Email");
            $scope.header.push("Phone No");
            $scope.header.push("Address");

            $scope.keys.push("employee_no");
            $scope.keys.push("name");
            $scope.keys.push("username");
            $scope.keys.push("phone");
            $scope.keys.push("address");
        }

        csvCovertor($scope.Users, "Record", true);
    };
};
EditUser.$inject = ["$scope", "$state", "$compile", "$element", "authService", "localStorageService", "$rootScope"];

exports.default = angular.module(name, []).component(name, {
    template: _edituser2.default,
    controller: ['$scope', '$state', '$compile', '$element', 'authService', 'localStorageService', EditUser]
}).controller('editUser', EditUser);

// function config($stateProvider) {
//     'ngInject';
//     $stateProvider.state('editUser', {
//         url: '/edit-user',
//         template: '<edit-user></edit-user>'
//     });
// }

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: authDashboardController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AuthDashboardController =
// @ngInject
["$scope", "$rootScope", "AUTHDASHCONSTANT", "authService", "localStorageService", "$state", "menuHeaderService", "randomColorService", function AuthDashboardController($scope, $rootScope, AUTHDASHCONSTANT, authService, localStorageService, $state, menuHeaderService, randomColorService) {
    _classCallCheck(this, AuthDashboardController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Courseware";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {
        $scope.loading = "";
        acdYear = "";
        userId = "";
        personData = "";
        featuresList = [];
        url = "";
        $scope.myBookmarkList = [];
        $scope.classCurriculumDetails = [];
    };
    $scope.loading = true;
    $scope.classCurriculumDetails = [];
    var acdYear = localStorageService.get('academic_year');
    var userId = localStorageService.get('user_id');
    var schoolId = localStorageService.get("school_id");
    var personData = void 0;
    var featuresList = [];
    var url = AUTHDASHCONSTANT.AUTH_DASH_URL + "/" + userId + "/" + acdYear;

    menuHeaderService.exitFromAuthoring();

    /*************** ALPHANUMERIC SORTING ********************/
    function normalizeMixedDataValue(value) {
        var padding = "000000000000000";
        // Loop over all numeric values in the string and
        // replace them with a value of a fixed-width for
        // both leading (integer) and trailing (decimal)
        // padded zeroes.
        value = value.replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
            // If this numeric value has "multiple"
            // decimal portions, then the complexity
            // is too high for this simple approach -
            // just return the padded integer.
            if (decimal !== $3) {
                return padding.slice(integer.length) + integer + decimal;
            }
            decimal = decimal || ".0";
            return padding.slice(integer.length) + integer + decimal + padding.slice(decimal.length);
        });
        return value;
    }

    function sortByAlaphaNumeric(array, key) {
        array.sort(function (a, b) {
            // Normalize the file names with fixed-
            // width numeric data.
            var aMixed = normalizeMixedDataValue(a[key]);
            var bMixed = normalizeMixedDataValue(b[key]);
            return aMixed < bMixed ? -1 : 1;
        });
        return array;
    }
    /*************** ALPHANUMERIC SORTING ********************/

    /*
     * Function to set dashboard
     * Developer : Arul Mozhi J
     */
    var setDashboard = function setDashboard() {
        authService.callAPI(url, "GET", undefined, function (response) {
            if (response) {
                var result = response.result.data;
                $scope.myBookmarkList = result.bookmarks;
                personData = result.person;
                if (result.person.courseware.length > 0) {
                    _.each(result.person.courseware, function (eachItem) {
                        var isPresent = false;
                        if (eachItem.subject) {
                            eachItem.class_sort_order = eachItem.class.name + eachItem.batch.name;
                            if (featuresList && featuresList.length > 0) {
                                _.each(featuresList, function (item) {
                                    if (item.class._id == eachItem.class._id && item.session._id == eachItem.session._id && item.curriculum._id == eachItem.curriculum._id && item.batch._id == eachItem.batch._id && item.subject._id == eachItem.subject._id) {
                                        if (eachItem.assign_roles != undefined) {
                                            if (eachItem.assign_roles.length > 0) {
                                                item.assign_roles = _.union(eachItem.assign_roles, item.assign_roles);
                                            }
                                        };
                                        isPresent = true;
                                    }
                                });
                            }
                            if (!isPresent) {
                                featuresList.push(eachItem);
                            }
                        }
                    });
                }
                console.log(featuresList);
                _.each(featuresList, function (ob) {
                    ob["school_id"] = localStorageService.get("school_id");
                    var bookmarkList = _.filter($scope.myBookmarkList, function (bookmark) {
                        return bookmark.academic_details.session_id === ob.session._id && bookmark.academic_details.curriculum_id === ob.curriculum._id && bookmark.academic_details.school_id === ob.school_id && bookmark.academic_details.class_id === ob.class._id && bookmark.academic_details.batch_id === ob.batch._id && bookmark.academic_details.subject_id === ob.subject._id;
                    });
                    if (bookmarkList.length > 0) {
                        console.log("bookmark present");
                        var pinnedBookmarkList = _.filter(bookmarkList, function (bookmark) {
                            return bookmark.is_pinned_to_courseware;
                        });
                        if (pinnedBookmarkList.length > 0) {
                            console.log("bookmark pinner");
                            ob['bookmarkItems'] = pinnedBookmarkList;
                        } else {
                            if (bookmarkList.length > 5) {
                                console.log("bookmarkmore than 5");
                                pinnedBookmarkList = _.last(_.sortBy(bookmarkList, 'audit_log.created_date'), 5);
                                ob['bookmarkItems'] = pinnedBookmarkList;
                            } else {
                                console.log(bookmarkList);
                                ob['bookmarkItems'] = bookmarkList;
                            }
                        }
                        ob["isShowBookmark"] = true;
                    } else {
                        ob['bookmarkItems'] = [];
                        ob["isShowBookmark"] = false;
                    }
                    ob["color"] = randomColorService.getRandomColor();
                });
                // grouping crurriculum/session/class/bath
                var classCurriculumDetails = [];
                featuresList = sortByAlaphaNumeric(featuresList, 'class_sort_order');
                _.each(_.groupBy(featuresList, function (eachFeature) {
                    return eachFeature.curriculum.name + '/' + eachFeature.session.name;
                }), function (featureArray, curriculumSession) {
                    var classBatchObj = [];
                    _.each(_.groupBy(featureArray, function (each) {
                        return each.class.name + each.batch.name;
                    }), function (eachArray, classBatchName) {
                        var obj = {
                            classBatch: classBatchName
                        };
                        obj['classBatchValue'] = eachArray;
                        classBatchObj.push(obj);
                    });
                    classCurriculumDetails.push({
                        curriculumSession: curriculumSession,
                        curriculumSessionValue: classBatchObj
                    });
                });
                $scope.classCurriculumDetails = classCurriculumDetails;
                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };
    //To set Previlege
    var prev = localStorageService.get("module_privileges");
    if (prev && prev.length > 0) {
        if (prev.findIndex(function (module) {
            return module.state === "authdashboard";
        }) === -1) {
            $state.go('dashboard');
        } else {
            setDashboard();
        }
    }

    // UserPrivilages.getUserPrivilageInitialSetting(function (result) {
    //     if (result.module_privileges && result.module_privileges.length > 0) {
    //         if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
    //             $state.go('dashboard')
    //         } else {
    //             $scope.loading = false
    //             setDashboard();
    //         }
    //     }
    // })


    /*
     * Function to goto Teaching plan
     * Developer : Arul Mozhi J
     */
    $scope.gotoTeachingPlan = function () {
        $state.go('newTeachingPlan');
    };

    /*
     * Function to goto bookmark page
     * @bookmark : Object - bookmark details
     * @return : boolean - success or fail
     * Developer : Arul Mozhi J
     */
    $scope.gotoBookmark = function (bookmark, e) {
        _.each(bookmark.session_details, function (sessionData) {
            localStorageService.set(sessionData.key, sessionData.value);
        });
        $state.go(bookmark.state_details.name, bookmark.state_details.params);
        e.stopPropagation();
    };

    /*
     * Function to goto authoring tool
     * @data : Object - courseware details
     * Developer : Arul Mozhi J
     */
    $scope.routeToMainPage = function (data) {

        // try {
        //     let tincanData = {
        //         actor: {
        //             "mbox": "mailto:" + Meteor.user().username,
        //             "account": {
        //                 "name": Meteor.user().name,
        //                 "homePage": SITE_URL
        //             },
        //             "objectType": "Agent"
        //         },
        //         verb: {
        //             id: SITE_URL + "expapi/verbs/interacted",
        //             display: {
        //                 "en-US": "clicked"
        //             }
        //         },
        //         object: {
        //             id: window.location.href,
        //             definition: {
        //                 type: SITE_URL + "authoringtool/subject",
        //                 name: {
        //                     "en-US": data.name
        //                 },
        //                 description: {
        //                     "en-US": "user selected subject " + data.name
        //                 }
        //             }
        //         }
        //     }

        //     TinCanApiService.sendTincanApiRequest(tincanData)

        // } catch (ex) {

        // }

        menuHeaderService.destroySession();
        localStorageService.set("authoringData", {
            class: data.class.name,
            batch: data.batch.name,
            curriculum: data.curriculum.name,
            curriculum_id: data.curriculum._id,
            session: data.session.name,
            subject: data.subject.name,
            class_id: data.class._id,
            batch_id: data.batch._id,
            session_id: data.session._id,
            subject_id: data.subject._id,
            role: data.assign_roles,
            academic_year: acdYear,
            currentUser: personData,
            currRoleId: personData.role_ids,
            school_id: schoolId
        });
        localStorageService.set('personData', personData);
        localStorageService.set('multiRoles', data.assign_roles);
        menuHeaderService.setDefault();
        $state.go('authoringTool');
    };
}];

exports.default = AuthDashboardController;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: authOverviewController.js
 * Project: educore
 * Created Date: 2018-12-06
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AuthOverviewController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "menuHeaderService", "AUTHDASHCONSTANT", "GOOGLE_CLASSROOM_CONSTANTS", "$mdDialog", function AuthOverviewController($scope, $rootScope, authService, localStorageService, $state, menuHeaderService, AUTHDASHCONSTANT, GOOGLE_CLASSROOM_CONSTANTS, $mdDialog) {
    _classCallCheck(this, AuthOverviewController);

    var authoring = void 0;

    //On init function
    // this.$onInit = () => {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    if (!$rootScope.isLoggedIn) {
        $state.go("login", {}, {
            reload: true
        });
    } else {
        authoring = localStorageService.get("authoringData");
        if (authoring) {
            $rootScope.authMenu = true;
            $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject;
        } else {
            $state.go("authdashboard");
        }
    }
    // }

    //On destroy function
    this.$onDestroy = function () {
        schoolId = "";
        userId = "";
        authoring = "";
        $scope.isSyllabusAvail = "";
        $scope.isThemeAvailable = "";
        $scope.isTpCreate = "";
        $scope.monthArray = "";
        $scope.themes = "";
        $scope.errorMsg = "";
    };

    // To get authoring tool side nav
    menuHeaderService.setAuthMenu();

    //String - school id
    var schoolId = localStorageService.get("school_id");

    //String - user id
    var userId = localStorageService.get("user_id");

    //Boolean - Availability of syllabus in courseware
    $scope.isSyllabusAvail = false;

    //Boolean - Availability of themes in courseware
    $scope.isThemeAvailable = false;

    //Boolean - privilege to create teaching plan
    $scope.isTpCreate = false;

    //[String] - Array of months
    $scope.monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    /******** For Tincan : START *********/
    // try {
    //     let tincanData = {
    //         actor: {
    //             "mbox": "mailto:" + Meteor.user().username,
    //             "account": {
    //                 "name": Meteor.user().name,
    //                 "homePage": SITE_URL
    //             },
    //             "objectType": "Agent"
    //         },
    //         verb: {
    //             id: SITE_URL + "expapi/verbs/view",
    //             display: {
    //                 "en-US": "viewed"
    //             }
    //         },
    //         object: {
    //             id: SITE_URL + "educore/authoringtool/overview/view",
    //             definition: {
    //                 type: SITE_URL + "authoring-tool",
    //                 name: {
    //                     "en-US": "overview "
    //                 },
    //                 description: {
    //                     "en-US": "To show the overview of Theme and teachingplan"
    //                 }
    //             },
    //             "objectType": "Activity"
    //         },
    //         "context": {
    //             "contextActivities": {

    //                 "Category": [{
    //                     "id": SITE_URL + "expapi/subject/" + Session.get('authoringData').subject_id,
    //                     "definition": {
    //                         "name": {
    //                             "en-US": Session.get('authoringData').subject
    //                         },
    //                         "description": {
    //                             "en-US": Session.get('authoringData').subject
    //                         }
    //                     },
    //                 }]
    //             }
    //         }
    //     }

    //     TinCanApiService.sendTincanApiRequest(tincanData)
    // } catch (ex) { }
    /******** For Tincan : END *********/

    //Service to get user privilage
    // UserPrivilages.getUserPrivilageInitialSetting(function (result) {
    //     if (result.module_privileges && result.module_privileges.length > 0) {
    //         if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
    var module_privileges = localStorageService.get("module_privileges");
    if (module_privileges && module_privileges.length > 0) {
        if (module_privileges.findIndex(function (module) {
            return module.state === "authdashboard";
        }) === -1) {
            $state.go('dashboard');
        } else {
            // let tpUserAccess = UserPrivilages.getFeatures("teachingPlan")
            var tpUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
                return feature.module_state == "teachingPlan";
            });
            var userAccess = {};
            _.each(tpUserAccess, function (rpObj) {
                var user_access = {};
                _.each(rpObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status;
                });
                userAccess[rpObj.feature_id] = user_access;
            });
            if (userAccess.newTeachingPlan && userAccess.newTeachingPlan.create) $scope.isTpCreate = true;
            /*
             * Function to get syllabus of the subject
             * @authoring : Object - academic details
             * return : [Object] - Syllabus of the subject
             * Developer : Arul Mozhi J
             */
            var reqObj = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: schoolId,
                academic_year: authoring.academic_year,
                user_id: userId,
                is_teacher: $scope.isTpCreate
            };
            authService.callAPI(AUTHDASHCONSTANT.API_AUTH_DASH_OVERVIEW_URL, 'POST', reqObj, function (resultObj) {
                var result = resultObj.result.data;
                if (result.success) {
                    if (result.themes && result.themes.length > 0) {
                        $scope.isThemeAvailable = true;
                        if (result.subject_description) {
                            $scope.isSyllabusAvail = true;
                            $scope.subject_description = result.subject_description;
                        }
                        $scope.themes = result.themes;
                    } else {
                        $scope.errorMsg = "No themes added for this subject.";
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            });
            authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_GET_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.classroomDetails = response.result.data.details;
                    } catch (ex) {
                        console.log(ex);
                    }
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    }
    // })

    /*
     * Function to create new plan
     *  @theme_id : String - id of the themes
     *  @planName : String - Name of the plan to be created
     *  return : null
     */
    $scope.createPlan = function (theme_id, theme_name, planName) {
        localStorageService.set("plan_details", {
            theme_name: theme_name,
            plan_name: planName
        });
        $state.go("newTeachingPlan", {
            id: theme_id,
            planId: ''
        });
    };

    function showInfo(ev) {
        try {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Information').htmlContent('<div style="text-align: center;">You are not added to the Classroom group required to create a course.</div><br> Please contact your administrator to ensure your account is included in the correct group.').ariaLabel('Alert Dialog Demo').ok('Cancel').targetEvent(ev)).then(function () {
                // This function will be triggered when the dialog is closed (either by clicking "Got it" or clicking outside)
                handleDialogClose();
            });
        } catch (error) {
            console.log(error);
        }
    }
    function handleDialogClose() {
        // Your callback logic here
        location.reload();
        // You can trigger any custom logic, like logging, changing UI, etc.
    }

    $scope.addGoogleClassroom = function (ev) {
        console.log('ADD CLASSROOM');
        var reqObj = {
            teacher_id: userId,
            teacher_email: localStorageService.get('username'),
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: schoolId,
            academic_year: authoring.academic_year,
            title: authoring.class + authoring.batch + '/' + authoring.curriculum + '/' + authoring.session + '/' + authoring.subject + ' - ' + authoring.academic_year
        };
        $scope.isLoading = true;
        authService.callAPI(GOOGLE_CLASSROOM_CONSTANTS.API_ADD_GOOGLE_CLASSROOM, 'POST', reqObj, function (response) {
            $scope.isLoading = false;
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.classroomDetails = response.result.data.details;
                    toastr.success('Google Classroom added successfully');
                } catch (ex) {
                    $scope.isLoading = false;
                    location.reload();
                    console.log(ex);
                }
            } else {
                $scope.isLoading = false;
                // location.reload();
                showInfo(ev);
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    $scope.viewGoogleClassroom = function () {
        pushLog();
        window.open($scope.classroomDetails.link, '_blank');
    };

    function pushLog() {
        var userId = localStorageService.get('user_id');
        var schoolId = localStorageService.get('school_id');
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userId + "/" + schoolId + "/viewGoogleClassroom", "GET", {}, function (response) {});
    }
}];

exports.default = AuthOverviewController;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: themeSummaryController.js
 * Project: educore
 * Created Date: 2018-12-06
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ThemeSummaryController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "AUTHDASHCONSTANT", function ThemeSummaryController($scope, $rootScope, authService, localStorageService, $state, AUTHDASHCONSTANT) {
    _classCallCheck(this, ThemeSummaryController);

    var authoring = void 0;

    //On init function
    // this.$onInit = () => {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    if (!$rootScope.isLoggedIn) {
        $state.go("login", {}, {
            reload: true
        });
    } else {
        authoring = localStorageService.get("authoringData");
        if (authoring) {
            $rootScope.authMenu = true;
            $rootScope.title = authoring.class + "" + authoring.batch + "/" + authoring.curriculum + "/" + authoring.session + "/" + authoring.subject;
        } else {
            $state.go("authdashboard");
        }
    }
    // }

    //On destroy function
    this.$onDestroy = function () {
        authoring = "";
        themeId = "";
        userId = "";
        reportAccess = "";
        $scope.userAccess = {};
        params = "";
        $scope.isAttendanceTaken = "";
        $scope.attendance = "";
        $scope.planList = "";
        $scope.themeName = "";
    };

    //String  - Theme id
    var themeId = $state.params.theme_id;

    //String - userId
    var userId = localStorageService.get("user_id");

    //Roles and Privileges
    // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
    // if (result.module_privileges.findIndex(module => module.state === "authdashboard") === -1) {
    //     $state.go('dashboard')
    // }
    // let reportAccess = UserPrivilages.getFeatures("reports")
    var reportAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state === "reports";
    });
    $scope.userAccess = {};
    if (reportAccess.length > 0) {
        _.each(reportAccess, function (rpObj) {
            var user_access = {};
            _.each(rpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userAccess[rpObj.feature_id] = user_access;
        });
    }
    var tpAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state === "teachingPlan";
    });
    $scope.tpUserAccess = {};
    if (tpAccess.length > 0) {
        _.each(tpAccess, function (rpObj) {
            var user_access = {};
            _.each(rpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.tpUserAccess[rpObj.feature_id] = user_access;
        });
    }
    // })


    //Object - academic details
    var params = {
        session_id: authoring.session_id,
        curriculum_id: authoring.curriculum_id,
        class_id: authoring.class_id,
        batch_id: authoring.batch_id,
        theme_id: themeId,
        school_id: authoring.school_id,
        academic_year: authoring.academic_year,
        user_id: userId,
        overviewReport: $scope.userAccess.overviewReport
    };
    authService.callAPI(AUTHDASHCONSTANT.API_THEME_SUMMARY_URL, "POST", params, function (response) {
        var result = response.result.data;
        if (result) {
            result.plans = _.filter(result.plans, function (plan) {
                return plan._id != null;
            });
            var teachingPlans = result.plans;
            $scope.planList = [];
            //Developer- Raziya
            //start
            //To get only assigned teaching plan for students
            _.each(teachingPlans, function (tp) {
                if ($scope.tpUserAccess) {
                    if ($scope.tpUserAccess.approvedPlans && $scope.tpUserAccess.approvedPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_APPROVED) {
                            if (tp.teacher_id === userId) {
                                $scope.planList.push(tp);
                            }
                            // Display teaching plan to assigned students only
                            if (tp.students && tp.students.length > 0) {
                                _.each(tp.students, function (student) {
                                    if (student === userId) {
                                        $scope.planList.push(tp);
                                    }
                                });
                            }
                        }
                    }
                    if ($scope.tpUserAccess.rejectedPlans && $scope.tpUserAccess.rejectedPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_REJECTED) {
                            if (tp.teacher_id === userId) $scope.planList.push(tp);
                        }
                    }
                    if ($scope.tpUserAccess.newTeachingPlan && $scope.tpUserAccess.newTeachingPlan.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_CREATED || tp.status === AUTHDASHCONSTANT.STATUS_DRAFT) {
                            if (tp.teacher_id === userId) $scope.planList.push(tp);
                        }
                    }
                    if ($scope.tpUserAccess.sentForApprovalPlans && $scope.tpUserAccess.sentForApprovalPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_SENT_FOR_APPROVAL) {
                            if (tp.teacher_id === userId) $scope.planList.push(tp);
                        }
                    }
                }
            });
            // end
            if (result.attendance) {
                $scope.isAttendanceTaken = true;
                $scope.attendance = result.attendance;
            }
            $scope.themeName = result.theme.name;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.gotoViewPage = function (planId) {
        $state.go('viewTeachingPlan', {
            planId: planId
        });
    };
}];

exports.default = ThemeSummaryController;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: subjectReport.js
 * Project: educore
 * Created Date: 2019-02-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var SubjectReportController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "AUTHDASHCONSTANT", "activityCons", "SchoolLogo", "CONSTANTS", function SubjectReportController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, AUTHDASHCONSTANT, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, SubjectReportController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var studentId = $state.params.studentId;
    var academicDet = localStorageService.get("authoringData");
    var schoolId = academicDet.school_id;
    var academicYear = academicDet.academic_year;
    var academics = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year,
        student_id: studentId
    };
    $scope.isLoading = true;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 1360;

    //Number - To set height of chart
    $scope.chartHeight = 400;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];
    $scope.activityCount = 0;
    $scope.absentCount = 0;
    $scope.attendedCount = 0;
    $scope.notAttendedCount = 0;
    //On destroy function
    this.$onDestroy = function () {};
    authService.callAPI(AUTHDASHCONSTANT.API_SUBJECT_REPORT, "POST", academics, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            console.log("************");
            console.log(resultData);
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_count) $scope.activityCount = resultData.basicDetails[0].total_count;
                if (resultData.basicDetails[0].absent_count) $scope.absentCount = resultData.basicDetails[0].absent_count;
                if (resultData.basicDetails[0].attended_count) $scope.attendedCount = resultData.basicDetails[0].attended_count;
                if (resultData.basicDetails[0].not_attended_count) $scope.notAttendedCount = resultData.basicDetails[0].not_attended_count;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails[0].questionDetail) {
                        if (resultData.graphDetails[0].questionDetail.length > 0) {
                            var questionDetail = resultData.graphDetails[0].questionDetail;
                            var values = [];
                            var header = [];
                            header.push("Question");
                            header.push("Total Questions");
                            header.push("No. of Questions Attended");
                            header.push("No. of Correct Answers");
                            values.push(header);
                            _.each(questionDetail, function (data) {
                                var arr = [];
                                arr.push(data.question_paper_title);
                                arr.push(data.attended_count);
                                arr.push(data.total_question);
                                arr.push(data.correct_answer);
                                values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Question" + '  vs  ' + "Count",
                                'value': values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            $scope.isLoading = false;
                            $scope.isChartAvailable = true;
                        }
                    }
                }
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var rankDetails = resultData.rankDetails;
                var isPresent = 0;
                var _values = [];
                var _header = [];
                _header.push("Activity");
                _header.push("Total Mark");
                _header.push("Marks Scored");
                _values.push(_header);
                _.each(rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.total_mark);
                    arr.push(data.score);
                    _values.push(arr);
                    if (data.score) isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Mark",
                    'value': _values
                };
                if (isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var _rankDetails = resultData.rankDetails;
                var _values2 = [];
                var _header2 = [];
                var _isPresent = 0;
                _header2.push("Activity");
                _header2.push("Rank");
                _values2.push(_header2);
                _.each(_rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.rank);
                    _values2.push(arr);
                    if (data.rank) _isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Rank",
                    'value': _values2
                };
                if (_isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }

            _.defer(function () {
                $scope.$apply();
            });
        } else {
            toastr.error('Network Error. Please try later');
        }
    });

    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        } else {
            //error
        }
    });

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
    };$scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Activity Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = SubjectReportController;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: subjectStudentListing.js
 * Project: educore
 * Created Date: 2019-02-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var SubjectStudentController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", function SubjectStudentController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
    _classCallCheck(this, SubjectStudentController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var academicDet = localStorageService.get("authoringData");
    var academics = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year

        /*
         * Function to get assigned users
         * 
         */
    };authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;

                $scope.studentList = response.result.data.data;
                //To sort student list
                $scope.studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        } else {
            toastr.error('Network Error. Please try later');
        }
    });
    /*
     * Function to go to single student based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoStudentSubjectReport = function (id) {
        $state.go("subjectReport", {
            studentId: id
        });
    };
}];

exports.default = SubjectStudentController;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: activityList.js
 * Project: educore
 * Created Date: 2018-12-10
 * Author: Jeevanantham Nagarathinam
 * Screen : FE162
 * -----
 * Last Modified: 2018-12-10
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

//import templatePopLoader from '../../generic/views/loader.html';
//import teacherSubViewTpl from '../views/teacherSubjectView.html';
// Modified By: Raziya S

var TraditionalActivityListController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "CONSTANTS", "NO_SHARE_AFL_SCHOOLS", "qpHandler", function TraditionalActivityListController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, CONSTANTS, NO_SHARE_AFL_SCHOOLS, qpHandler) {
    _classCallCheck(this, TraditionalActivityListController);

    //CurrentPage.setTitle("Activity List")
    var self = this;

    $scope.fee_status_label = true;
    $scope.no_share_afl = false;
    var academicDet = localStorageService.get('authoringData');
    $scope.myActivityList = [];
    var academicDetails = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year,
        is_traditional_activity: true
    };
    $scope.myuserId = localStorageService.get("user_id");
    var ad_no = localStorageService.get("st_admission_number");
    console.log(ad_no);
    var features = localStorageService.get("feature_privileges");
    var activityUserAccess = _.filter(features, function (feature) {
        return feature.feature_id === "activityList";
    });
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    function _isNO_SHARE_AFL_SCHOOLS() {
        var school_id = localStorageService.get("school_id");
        if (NO_SHARE_AFL_SCHOOLS && NO_SHARE_AFL_SCHOOLS.SCHOOL_IDS.indexOf(school_id) !== -1) {
            $scope.no_share_afl = true;
        }
    }
    var getAllActivity = function getAllActivity() {
        //To get assignee 
        var _is_teacher = false;
        if ($scope.activityUserPrivilege.attendExam && $scope.activityUserPrivilege.attendExam.read) academicDetails.student_id = $scope.myuserId;

        //To get creator 
        if ($scope.activityUserPrivilege.createActivity && $scope.activityUserPrivilege.createActivity.create) {
            localStorageService.set("is_staff", true);
            $scope.is_staff = true;
            academicDetails.teacher_id = $scope.myuserId;
        }

        //To get approver details
        if ($scope.activityUserPrivilege.approveQuestionPaper && $scope.activityUserPrivilege.approveQuestionPaper.create) academicDetails.approver_id = $scope.myuserId;

        authService.callAPI(activityCons.API_GET_ALL_ACTIVITY, "POST", academicDetails, function (response) {
            console.log(response);
            if (response.result && response.result.status && response.result.data.data) {
                var myActivityList = response.result.data.data;
                for (var i = 0; i < myActivityList.length; i++) {
                    myActivityList[i]['showReport'] = true;
                    if (myActivityList[i]['status'] != "published") {
                        if (!$scope.is_staff) {
                            myActivityList[i]['showReport'] = false;
                        }
                    }
                }
                if (_is_teacher) {
                    _isNO_SHARE_AFL_SCHOOLS();
                }
                setNewStatusPartial(myActivityList);
                $scope.myActivityList = myActivityList;
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        });
    };

    var setNewStatusPartial = function setNewStatusPartial() {
        var myActivityList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        try {
            for (var index = 0; index < myActivityList.length; index++) {
                var element = myActivityList[index];
                try {
                    if (element) {
                        var temp_sections = element.temp_sections;
                        var sections = element.sections;
                        if (element.status == 'created') {
                            var partial = 0;
                            if (temp_sections && temp_sections.length) {
                                partial++;
                            }
                            if (!sections || !sections.length) {
                                partial++;
                            } else {
                                var questions = _.flatten(_.pluck(sections, "questions"));
                                if (!questions || !questions.length) {
                                    partial++;
                                }
                            }
                            if (partial) {
                                element.status = 'partial';
                            }
                        }
                    }
                } catch (e1) {
                    console.log(e1);
                }
            }
        } catch (e) {
            console.log(e);
        }
    };
    var getThemeData = function getThemeData(res) {
        console.log(academicDet);
        authService.callAPI(activityCons.API_GET_THEMES, "POST", academicDet, function (response) {
            console.log(response);
            if (response.result && response.result.status && response.result.data.themeList) {
                $scope.themes = response.result.data.themeList;
                res(response.result.data.themeList);
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        });
    };

    var getTraditionalActivityDet = function getTraditionalActivityDet(qpDet) {
        authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, function (response) {
            if (response.result && response.result.status && response.result.data.data) {
                var result = response.result.data.data[0];
                academicDetails['qp_id'] = result.basic_details[0]._id;
                academicDetails['themes'] = $scope.themes;
                academicDetails['question_paper_title'] = result.basic_details[0].question_paper_title;
                academicDetails['is_traditional_activity'] = true;
                academicDetails[' isNotAddToQp'] = false;

                academicDetails['theme_id'] = result.basic_details[0].theme_id;
                academicDetails['practice_qn'] = result.basic_details[0].practice_qn;
                if (result.temp_sections && result.temp_sections.length > 0 || result.sections && result.sections.length > 0) {
                    academicDetails["isQuestionAvailable"] = true;
                    localStorageService.set('academicDetails', academicDetails);
                    $state.go("formatQuestion", {
                        'qpId': result.basic_details[0]._id
                    });
                } else {
                    academicDetails["isQuestionAvailable"] = false;
                    localStorageService.set('academicDetails', academicDetails);
                    $state.go('createActivity', {
                        'qpId': result.basic_details[0]._id,
                        'activityId': result.basic_details[0].activity_id
                    });
                }
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        });
    };
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity List";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }

        var academics = {
            school_id: academicDet.school_id,
            batch_id: academicDet.batch_id,
            curriculum_id: academicDet.curriculum_id,
            subject_id: academicDet.subject_id,
            session_id: academicDet.session_id,
            class_id: academicDet.class_id,
            academic_year: academicDet.academic_year

            //String - Teaching plan id
        };var tpId = $state.params.planId;

        //Boolean - Activity created or not
        $scope.isActivityCreated = false;

        /*
        * Function to get assigned users
        * 
        */
        authService.callAPI("/v0/tp-reports/student-details", "POST", academics, function (response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    $scope.isLoading = false;

                    $scope.studentList = response.result.data.data;
                    //To sort student list
                    $scope.studentList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                    localStorageService.set("students_this_class", $scope.studentList);
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
        getAllActivity();
    };
    function getSchoolTokens(schoolId) {
        var dummySchool = [{
            "_id": "2ebFyzgjEwmdvep5L",
            "school_name": "The Oxford School,Trivandrum",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "https://portal.oxford.edu.in/index.php/portal_data_contract",
            // "school_data_token" : "d8ba88f080664a1420d2d080b658fc04"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "53d553cca766bb843eeb6464608ac93e"
        }, {
            "_id": "Mvb8uY53ijBX9DNJS",
            "school_name": "The Oxford School,Kollam",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "https://portal.oxfordkollam.edu.in/index.php/portal_data_contract",
            // "school_data_token" : "795dce7a5fa85ef8d4945441549b6578"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "25c921722bec9527d59eb0e34713347c"
        }, {
            "_id": "f5BCz8T7LqzpFsSP3",
            "school_name": "The Oxford School,Calicut",
            "site_url": "http://35.200.206.239:3600",
            "file_server": "http://35.200.206.239:4000",
            // "school_data_url" : "http://portal.oxfordcalicut.com/index.php/Portal_data_contract",
            // "school_data_token" : "cded12b4cd909d4e00610ff0699ca069"
            "school_data_url": "https://docmeschool.oxford.edu.in/api/app",
            "school_data_token": "aa8d7f8e0352b2712b9e80cf25bb60d4"
        }, {
            "_id": "CPpbKPQTcuG97i3kv",
            "school_name": "The New Indian Model School,Dubai",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsdxb.com/index.php/portal_data_contract",
            // "school_data_token" : "e370c37780b957637493e9727c9b304d",
            // "school_data_url" : "http://qnap.ddns.cyberoam.com:3000/rims-tools/api/App",
            // "school_data_token" : "ed0a5a7f2b76668e8a6dd3388868c068"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "7a9d733269d23bc35b04b56dc855d330"
        }, {
            "_id": "m2LMtqaESFZf6xDE8",
            "school_name": "The Central School,Dubai",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.centraldxb.com/index.php/portal_data_contract",
            // "school_data_token" : "f2f78f635a660af6257dab8da79c650f"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "47e2b919b8551d762e1dd1f5769b66ba"
        }, {
            "_id": "2FwuqhgeoKt6SQiCG",
            "school_name": "The New Indian Model School,Al-Ain",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsalain.com/index.php/portal_data_contract",
            // "school_data_token" : "874d4634f7c741f397045aeb7fd133c6"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "0ae409a7d98dde57b35a4643d2354906"
        }, {
            "_id": "ps4vyLJhQvPZjfxaH",
            "school_name": "The New Indian Model School,Sharjah",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "99d351fe9165be1c0cf35fa0a0885c17"
        }, {
            "_id": "apX7mQ9LsV2kZdFaH",
            "school_name": "APEX Vision Model School, Sharjah",
            "site_url": "http://104.199.53.109:3700",
            "file_server": "http://104.199.53.109:4000",
            // "school_data_url" : "https://portal.nimsshj.com/index.php/portal_data_contract",
            // "school_data_token" : "8838d896e6aecc58323ef9b26c374ebe"
            "school_data_url": "https://sqa.globtech.in/bm-school-2/api/App",
            "school_data_token": "fe8acc83e277e3112e1dbf520291bfc9"
        }];
        var ex = _.find(dummySchool, function (one) {
            return one._id == schoolId;
        });
        return ex;
    }
    function feesCheckOneStudent(id) {
        var school_id = localStorageService.get("school_id");
        var tokens = getSchoolTokens(school_id);
        var admn_no = localStorageService.get('admission_no');

        if (!admn_no) {
            admn_no = localStorageService.get('st_admission_number');
        }
        if (admn_no) {
            authService.callAPI("/v0/parent/portal/fee/", "POST", {
                school_data_token: tokens.school_data_token,
                school_data_url: tokens.school_data_url,
                admn_no: admn_no
            }, function (response) {
                try {
                    if (response.result.status.code == 200) {
                        if (response.result.data && response.result.data.details) {
                            self.feesDocument = response.result.data.details;
                            var exmpList = response.result.data.exemption_list ? response.result.data.exemption_list : [];
                            _.each(self.feesDocument, function (det, index) {
                                if (det.fee_last_date) {
                                    var someDate = new Date(det.fee_last_date);
                                    var numberOfDaysToAdd = 20;
                                    someDate.setDate(someDate.getDate() + numberOfDaysToAdd);
                                    det.fee_last_date = someDate;
                                }
                                // det.fee_last_date = new Date(det.fee_last_date)
                                var today = new Date();
                                det.fee_last_date.setHours(0, 0, 0, 0);
                                today.setHours(0, 0, 0, 0);
                                if (det.fee_last_date <= today) {
                                    if (det.fee_status === "Pending" && det.blocking_status === "Y") {
                                        var isExepted = exmpList.includes(admn_no);
                                        if (isExepted) {
                                            $scope.fee_status_label = true;
                                        } else {
                                            $scope.fee_status_label = false;
                                        }
                                    } else {
                                        $scope.fee_status_label = true;
                                    }
                                }
                            });
                            redirectToReport(id);
                        } else {
                            $scope.fee_status_label = true;
                            redirectToReport(id);
                        }
                    } else {
                        $scope.fee_status_label = false;
                    }
                } catch (ex) {
                    redirectToReport(id);
                    console.log(ex);
                }
            });
        } else {
            redirectToReport(id);
        }
    }
    function redirectToReport(id) {
        $scope.isLoading = false;
        if (!$scope.fee_status_label) {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Information').textContent('Sorry, as fees dues are there, cannot view the report!').ariaLabel('Alert Dialog Demo').ok('Got it!')
            // .targetEvent(ev)
            );
            return false;
        }
        $state.go("activitypersstudentCtrl", {
            student_id: localStorageService.get('user_id'),
            qp_id: id,
            page: 1,
            isFromModule: false
        });
    }
    $scope.viewComment = function (ev, activity) {
        if (activity && activity.approver_comment) {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Approver comment').textContent(activity.approver_comment).ariaLabel('Alert Dialog Demo').ok('OK').targetEvent(ev));
        }
    };
    $scope.gotoReport = function (id) {
        if ($scope.activityUserPrivilege.conductingActivity && $scope.activityUserPrivilege.conductingActivity.create) {
            $state.go("reportsMainCtrl", {
                prevParams: {
                    planId: null
                },
                qpId: id,
                isFromModule: false
            });
        } else {
            if (ad_no) {
                $scope.isLoading = true;
                feesCheckOneStudent(id);
            } else {
                redirectToReport(id);
            }
        }
    };
    this.$onDestroy = function () {};
    $scope.collapseAll = function (data) {
        data.expanded = !data.expanded;
    };
    $scope.redirectToCreate = function () {
        $state.go("createActivity", {
            qpId: null,
            activityId: null
        }, {
            reload: true
        });
    };
    $scope.toggleExpansion = function (accordianData, selectedData, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !selectedData.expanded;
        });
    };
    $scope.gotoActivityEditPage = function (qpId, activityId) {
        console.log(qpId);
        var qpDet = {
            "qp_id": qpId,
            "activity_id": activityId,
            "teacher_id": localStorageService.get("user_id"),
            "school_id": localStorageService.get("school_id")
        };
        getThemeData(function (response) {
            getTraditionalActivityDet(qpDet);
        });
    };
    $scope.gotoSummaryPreview = function (qpId) {
        var qpDet = {
            "qp_id": qpId,
            "teacher_id": localStorageService.get("user_id"),
            "school_id": localStorageService.get("school_id")
        };

        getThemeData(function (response) {
            authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, function (response) {
                if (response.result && response.result.status && response.result.data.data) {
                    var result = response.result.data.data;
                    academicDetails['theme_id'] = result.theme_id;
                    academicDetails['is_traditional_activity'] = result.is_traditional_activity;
                    academicDetails['practice_qn'] = result.practice_qn;
                    academicDetails['qp_id'] = result._id;
                    academicDetails['question_paper_title'] = result.question_paper_title;
                    academicDetails['themes'] = $scope.themes;
                    localStorageService.set('academicDetails', academicDetails);
                    $state.go('qpSummary', {
                        qpId: qpId
                    });
                } else {
                    //error
                }
            });
        });
    };
    $scope.deleteActivty = function (qpId) {
        var confirm = $mdDialog.confirm().textContent('Do you want to delete Activity?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI(activityCons.API_DELETE_QP + qpId, "POST", {}, function (response) {
                if (response.result) {
                    toastr.success("Activity deleted successfully");
                    getAllActivity();
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    console.log("error : " + response.error);
                    console.log(response.error);
                }
            });
        }, function () {});
    };

    $scope.share = function (activity) {

        var obj = {
            qp_id: activity._id,
            FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
            teacher_id: activity.teacher_id,
            user_id: localStorageService.get('user_id'),
            school_id: localStorageService.get("school_id")
        };
        var confirm = $mdDialog.confirm().textContent('This will send email to the parents.Are you sure to send?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI("/v0/assesment-report/send/link/to/parents", "POST", obj, function (response) {
                if (response.result) {
                    toastr.success("Activity report link sent Successfully");
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    console.log("error : " + response.error);
                    console.log(response.error);
                }
            });
        }, function () {});
    };
    $scope.updateParentVisibility = function (activity) {
        var obj = {
            school_id: localStorageService.get("school_id"),
            qp_id: activity._id,
            is_visibleto_parents: activity.is_visibleto_parents,
            toastr: toastr
        };
        qpHandler.updateParentVisibility(authService, obj);
    };
}];

exports.default = TraditionalActivityListController;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _html2canvas = __webpack_require__(82);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: singleActivityReport.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2019-01-29
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var reportsMainCtrl =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", "$sce", "OPTIONAL_SCHOOLFONTS", function reportsMainCtrl($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS, $sce, OPTIONAL_SCHOOLFONTS) {
    _classCallCheck(this, reportsMainCtrl);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getPrivileges();
    };
    var userId = localStorageService.get("user_id");
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope._is_creator = false;
    $scope.activityUserPrivilege = {};
    function getPrivileges() {
        try {
            if (userAccess.length > 0) {
                _.each(userAccess, function (tpObj) {
                    var user_access = {};
                    _.each(tpObj.privilege, function (privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status;
                    });
                    $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
                });
            }
        } catch (e) {
            console.log(e);
        }
    }
    function checkPrivilegeToUpdate(result) {
        try {
            if ($scope.activityUserPrivilege && $scope.activityUserPrivilege.createActivity && $scope.activityUserPrivilege.createActivity.create && result && result.teacher_id && result.teacher_id == userId) {
                $scope._is_creator = true;
            }
        } catch (e) {
            console.log(e);
        }
    }
    $scope.studentList = localStorageService.get('students_this_class');
    var is_staff = localStorageService.get("is_staff");
    //On destroy function
    this.$onDestroy = function () {};
    //String - Question paper id
    var qpId = $state.params.qpId;
    var authoring = localStorageService.get('authoringData');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;
    // $scope.isLoading = true
    $scope.pdfData = false;
    //[Object] - Contains chart data
    $scope.chartArray = [];
    $scope.chartImages = {};
    $scope.chartImages.mcqs = [];
    //Number - To set width of chart
    $scope.chartWidth = 1000;

    //Number - To set height of chart
    $scope.chartHeight = 500;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    //[Object] - chart availability
    $scope.chartAvailability = {
        isQuesVsStudent: false
    };
    $scope.quesCount = 0;
    $scope.studCount = 0;
    $scope.studAttendCount = 0;
    $scope.absentees = 0;
    $scope.canview_class_avg = true;
    $scope.afl_extra_info = {};
    function graphrange_values() {
        google.charts.load('current', { packages: ['corechart', 'bar'] });
        google.charts.setOnLoadCallback(drawRangeValues);
    }
    function drawRangeValues() {
        var data = google.visualization.arrayToDataTable($scope.range_values);

        var options = {
            // title: 'Population of Largest U.S. Cities',
            chartArea: { width: '50%' },
            hAxis: {
                title: 'Score in percentage',
                minValue: 0,
                textStyle: {
                    bold: true,
                    fontSize: 14,
                    color: '#4d4d4d'
                },
                titleTextStyle: {
                    bold: true,
                    fontSize: 14,
                    color: '#4d4d4d'
                }
            },

            vAxis: {
                title: 'Number Of Students',
                textStyle: {
                    fontSize: 14,
                    bold: true,
                    color: '#848484'
                },
                titleTextStyle: {
                    fontSize: 14,
                    bold: true,
                    color: '#848484'
                }
            },
            legend: {
                position: 'none'
            }
        };
        var chart = new google.visualization.ColumnChart(document.getElementById('range_values'));
        google.visualization.events.addListener(chart, 'ready', function () {
            $scope.chartImages.score_percent = chart.getImageURI();
        });
        chart.draw(data, options);
    }
    // */
    function graphavg_per_theme() {
        google.charts.load('current', { packages: ['corechart', 'bar'] });
        google.charts.setOnLoadCallback(drawAvdPerTheme);
    }
    function drawAvdPerTheme() {
        var data = google.visualization.arrayToDataTable($scope.avg_per_theme);
        var options = {

            title: 'Theme Wise Performance %',
            legend: {
                position: 'none'
            },
            vAxis: {
                title: 'Themes'
            },
            hAxis: {
                minValue: 0
            }
        };
        // if($scope.avg_per_theme.length > 6){
        options['width'] = 600;
        // options['height'] = 400
        options['chartArea'] = { left: '50%', right: "10%"
            // }
        };var chart = new google.visualization.BarChart(document.getElementById('avg_per_theme'));
        google.visualization.events.addListener(chart, 'ready', function () {
            $scope.chartImages.avg_per_theme = chart.getImageURI();
        });
        chart.draw(data, options);
    }
    function drawPieChart() {
        var data = google.visualization.arrayToDataTable($scope.pie);

        var colorsArray = [];
        if ($scope.pie.length) {
            for (var i = 1; i < $scope.pie.length; i++) {
                colorsArray.push($scope.pie[i][2]);
            }
        }
        var options = {
            title: 'Grade Distribution',
            // width:'50px',
            colors: colorsArray,
            pieSliceText: ['none']
            //   chartArea:{left:1,top:6,width:"100%",height:"100px"}
        };
        var chart = new google.visualization.PieChart(document.getElementById('pie'));
        google.visualization.events.addListener(chart, 'ready', function () {
            $scope.chartImages.pie = chart.getImageURI();
        });
        chart.draw(data, options);
    }
    function graphPie() {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(drawPieChart);
    }
    function setHeader(data) {
        if (data) {
            $scope.quesCount = data.question_data.count;
            $scope.studCount = data.qp_data.students;
            $scope.studAttendCount = data.qp_data.atended;
            $scope.absentees = data.qp_data.students - data.qp_data.atended;
            $scope.activity_name = data.qp_data.question_paper_title;
            $scope.authoring = authoring;
            $scope.schoollogo = CONSTANTS.FILE_UPLOAD_URL + data.school_data.logo;
            $scope.schoolName = data.school_data.school_name;
            if (OPTIONAL_SCHOOLFONTS.CANTERBURY_FONT_SCHOOLS.indexOf(data.school_data._id) !== -1) {
                $scope.canterburySchools = true;
            }
        } else {
            var obj = {
                quesCount: $scope.quesCount,
                studCount: $scope.studCount,
                studAttendCount: $scope.studAttendCount,
                absentees: $scope.absentees,
                activity_name: $scope.activity_name,
                authoring: $scope.authoring
            };
            return obj;
        }
    }
    $scope.isLoading = true;
    $scope.showGraphs = false;
    function initLoad() {

        $scope.url = undefined;
        authService.callAPI("/v0/assesment-report/class/report", "POST", {
            qp_id: qpId, school_id: schoolId, 'FILE_UPLOAD_URL': CONSTANTS.FILE_UPLOAD_URL
        }, function (response) {
            try {
                var data = response.result.data.details.response;
                checkPrivilegeToUpdate(data);
                $scope.range_values = data.range_values;
                $scope.avg_per_theme = data.avg_per_theme;
                $scope.result_per_mcq = data.result_per_mcq.returnObj;
                $scope.first_set_MCQ = data.result_per_mcq.first_set_MCQ;
                $scope.qbDocuments = data.result_per_mcq.qbDocuments;
                $scope.performance = data.highest_average;
                $scope.pie = data.pie;
                $scope.secondObj = data.result_per_mcq.secondObj;
                $scope.allMcq = data.result_per_mcq.allMcq;
                setHeader(data.header);
                if (data.resultsAllStudents && data.resultsAllStudents.length) {
                    $scope.showGraphs = true;
                    graphrange_values();
                    graphavg_per_theme();
                }
                $scope.afl_extra_info = data.afl_extra_info ? data.afl_extra_info : {};

                google.charts.load('current', { packages: ['corechart', 'bar'] });
                google.charts.setOnLoadCallback(redefinedMCQ);

                graphPie();
            } catch (e) {
                console.log(e);
            }

            $scope.isLoading = false;
            $scope.$apply();
        });
    }

    if (!is_staff) {
        $state.go("activityList");
    } else {
        $scope.isLoading = true;
        initLoad();
    }
    function mcqSetQuestions() {
        google.charts.load('current', { packages: ['corechart', 'bar'] });

        var questionIds = Object.keys($scope.allMcq);
        $scope.MCQs = [];
        $scope.questionTitleArray = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            var _loop = function _loop() {
                var _step$value = _slicedToArray(_step.value, 2),
                    index = _step$value[0],
                    one = _step$value[1];

                var exq = _.find($scope.qbDocuments, function (oneq) {
                    return oneq._id == one;
                });
                if (exq && exq.qn_desc) {
                    $scope.questionTitleArray.push({
                        qn_desc: exq.qn_desc, isLatex: exq.isLatex
                    });
                }
                $scope.MCQs.push($scope.allMcq[one]);
                // $('#chart-main-div').append('<div flex="20" id="result_per_mcq' + index + '"  style="width:45%;height: 220px;"></div>');
            };

            for (var _iterator = questionIds.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                _loop();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function redefinedMCQ() {
        mcqSetQuestions();
        var firstDocLength = 5;
        var docLength = 12;
        $scope.mcqGroupData = [];
        $scope.allMcqCount = $scope.MCQs;
        var groupLength = Math.ceil(($scope.allMcqCount.length - firstDocLength) / docLength) + 1;
        for (var i = 0; i < groupLength; i++) {
            if (i) {

                $scope.mcqGroupData.push({
                    _id: i,
                    mcqGroupData: $scope.allMcqCount.slice((i - 1) * docLength + firstDocLength, i * docLength + firstDocLength)
                });
            } else {
                $scope.mcqGroupData.push({
                    _id: i,
                    mcqGroupData: $scope.allMcqCount.slice(0, firstDocLength)
                });
            }
        }
        $scope.$apply();
        var aliQuestion = 0;
        $scope.chartImages.mcqs = [];
        for (var j = 0; j < $scope.mcqGroupData.length; j++) {
            var _loop2 = function _loop2(_i) {
                var _options;

                var generatedId = 'result_per_mcq' + j + '_' + _i;
                var str = '<div flex="20" id="' + generatedId + '" style="width:45%;height: 220px;"></div>';
                if ($scope.questionTitleArray[aliQuestion].isLatex) {
                    str = '<div class="question_desc" flex="20" id="' + generatedId + '" style="width:45%;height: 220px;"></div>';
                }
                $('#group_' + j).append(str);
                var idStr = generatedId;
                var options = (_options = {
                    // title: 'Population of Largest U.S. Cities',
                    title: "Q"
                }, _defineProperty(_options, "title", "Q" + (aliQuestion + 1) + ": " + $scope.questionTitleArray[aliQuestion].qn_desc), _defineProperty(_options, "chartArea", { width: '50%' }), _defineProperty(_options, "hAxis", {

                    minValue: 0,
                    textStyle: {
                        bold: true,
                        fontSize: 12,
                        color: '#4d4d4d'
                    },
                    titleTextStyle: {
                        bold: true,
                        fontSize: 18,
                        color: '#4d4d4d'
                    }
                }), _defineProperty(_options, "vAxis", {
                    minValue: 0,
                    title: '% Of Students',
                    textStyle: {
                        fontSize: 14,
                        bold: true,
                        color: '#848484'
                    },
                    titleTextStyle: {
                        fontSize: 14,
                        bold: true,
                        color: '#848484'
                    }
                }), _defineProperty(_options, "legend", {
                    position: 'none'
                }), _options);
                var chart = new google.visualization.ColumnChart(document.getElementById(generatedId));
                var data = google.visualization.arrayToDataTable($scope.mcqGroupData[j].mcqGroupData[_i]);
                google.visualization.events.addListener(chart, 'ready', function () {
                    $scope.chartImages.mcqs.push(chart.getImageURI());
                });
                chart.draw(data, options);
                aliQuestion++;
            };

            for (var _i = 0; _i < $scope.mcqGroupData[j].mcqGroupData.length; _i++) {
                _loop2(_i);
            }
        }
        // setMCQ()
    }
    function setMCQ() {
        setTimeout(function () {
            var MQ = MathQuill.getInterface(2);
            var questionElements = document.getElementsByClassName('question_desc');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        });
    }
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
    };$scope.goBack = function () {
        $state.go("activityReports");
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };
    $scope.exportAsPDF = function () {
        try {
            $scope.pdfLoading = true;
            (0, _html2canvas2.default)(document.querySelector("#container_main")).then(function (mainCon) {
                try {
                    var maindoc = new jsPDF('p', 'pt', 'a4', false);

                    var maintableImageProps = maindoc.getImageProperties(mainCon.toDataURL("image/png"));
                    var mainheightThisCanvas = maintableImageProps.height;

                    var _str = $scope.authoring.class + "-" + $scope.authoring.batch + "-" + $scope.authoring.subject + "-" + $scope.activity_name;

                    (0, _html2canvas2.default)(document.querySelector("#acitivity-per-data")).then(function (canvas) {
                        try {
                            var doc;
                            var width;
                            var height;

                            var _ret3 = function () {
                                doc = new jsPDF('p', 'pt', 'a4', false);
                                width = doc.internal.pageSize.getWidth();
                                height = doc.internal.pageSize.getHeight();
                                // let tableImageProps = doc.getImageProperties(canvas.toDataURL("image/png"));
                                // let height = tableImageProps.height;

                                doc.addImage(canvas.toDataURL("image/png"), 'png', 0, 10, width, height - 500, undefined, 'none');
                                var oneFullContent = 0;
                                if (!$scope.mcqGroupData.length) {
                                    doc.save(_str + '.pdf');
                                    $scope.pdfLoading = false;
                                    $scope.$apply();
                                    return {
                                        v: false
                                    };
                                }

                                var _loop3 = function _loop3(i) {
                                    (0, _html2canvas2.default)(document.querySelector('#group_' + i)).then(function (eachGroup) {
                                        try {
                                            var yAxis = 200;
                                            var chartHeight = 400;
                                            var tableImageProps = doc.getImageProperties(eachGroup.toDataURL("image/png"));
                                            var len = $scope.mcqGroupData[i].mcqGroupData.length;
                                            var heightThisCanvas = tableImageProps.height;
                                            if (i) {
                                                yAxis = 10;
                                                doc.addPage();
                                                chartHeight = chartHeight + 300;
                                                if (len < 12) {
                                                    if (i == $scope.mcqGroupData.length - 1) {
                                                        if (!oneFullContent) {
                                                            oneFullContent = heightThisCanvas;
                                                        }
                                                        chartHeight = chartHeight - oneFullContent;
                                                        chartHeight = chartHeight + 25;
                                                    } else {
                                                        oneFullContent = heightThisCanvas;
                                                        chartHeight = chartHeight - eachGroup.height + yAxis;
                                                    }
                                                }
                                            } else {
                                                yAxis = 380;
                                                var _len = $scope.mcqGroupData[i].mcqGroupData.length;
                                                if (_len < 5) {
                                                    chartHeight = heightThisCanvas - yAxis;
                                                }
                                            }
                                            doc.addImage(eachGroup.toDataURL('image/png'), 'png', 10, yAxis, width - 20, chartHeight);
                                        } catch (ex2) {
                                            console.log(ex2);
                                        }
                                    });
                                };

                                for (var i = 0; i < $scope.mcqGroupData.length; i++) {
                                    _loop3(i);
                                }
                                setTimeout(function () {
                                    doc.save(_str + '.pdf');
                                    $scope.pdfLoading = false;
                                    $scope.$apply();
                                }, 20000);
                                // doc.setFontSize(5);
                                // doc.text((width / 2) - 20, height - 10, 'page 1');
                                // doc.save(str + '.pdf')
                            }();

                            if ((typeof _ret3 === "undefined" ? "undefined" : _typeof(_ret3)) === "object") return _ret3.v;
                        } catch (ex1) {
                            console.log(ex1);
                        }
                    });
                } catch (e) {
                    console.log(e);
                }
            });
        } catch (ex) {
            $scope.pdfLoading = false;
            $scope.$apply();
            console.log(ex);
        }
    };
    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    // $scope.exportAsPDF = function () {
    //     var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
    //     doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
    //     doc.setFontSize(18);
    //     doc.setFontType('bold');
    //     var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
    //     doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
    //     doc.setFontSize(12);
    //     doc.setFontType('normal');
    //     doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
    //     doc.setFontSize(16);
    //     doc.text(220, 90, 'Activity Based Report');
    //     doc.setFontSize(15); /* Define font size for the document */
    //     var yAxis = 150;

    //     for (var i = 0; i < $scope.chartImgData.length; i++) {
    //         if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
    //             doc.addPage(); /* Adds a new page*/
    //             yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
    //         }

    //         var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
    //         var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

    //         if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
    //             width = doc.internal.pageSize.width;
    //         } else {
    //             width = $scope.chartImgData[i].width;
    //         }

    //         height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
    //         height = width * (3 / 4) - 100

    //         var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
    //         doc.text(60, yAxis, someText); /* Add some text in the PDF */
    //         yAxis = yAxis + 20; /* Update yAxis */
    //         //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
    //         doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
    //         yAxis = yAxis + 360; /* Update yAxis */
    //     }
    //     window.open(doc.output('bloburl'))
    //     // doc.save('Activity_Based_Report.pdf')
    // }
    $scope.backToHtml = function () {
        $scope.pdfData = false;
        $scope.isLoading = true;
        initLoad();
    };
    $scope.exportQuestionWiseReport = function () {
        $scope.isPdfData = true;
        $scope.url = $sce.trustAsResourceUrl($scope.urls);
    };
    $scope.htmlDivReport = function () {
        try {
            return $sce.trustAsHtml($scope.reportData.htmlStr);
        } catch (e) {
            console.log(e);
        }
    };
    // authService.callAPI('/v0/qp-reports/cognitive-skills/performance', "POST", {
    //     qp_id : qpId,
    //     my_user_id : localStorageService.get('user_id'),
    //     FILE_UPLOAD_URL : CONSTANTS.FILE_UPLOAD_URL
    // }, function(response) {
    //     try{
    //         $scope.reportData = response.result.data.details.response
    //         $scope.urls = $scope.reportData.pdf_url
    //    console.log(response)
    //     }catch(e){
    //         console.log(e)
    //     }
    // })
    $scope.gotoStudentReport = function (id) {
        // $state.go("individualStudentTraditionalReportCtrl", {
        //     student_id: id,
        //     qpId: qpId
        // })
        $state.go("activitypersstudentCtrl", {
            student_id: id,
            qp_id: qpId,
            page: 1
        });
    };

    $scope.exportFromServer = function () {
        // console.log($scope.chartImages)
        $scope.pdfData = true;
        var obj = {};
        $scope.loading = false;
        $scope.isLoading = true;
        obj['headers'] = setHeader(false);
        obj['charts'] = $scope.chartImages;
        obj['headers']['performance'] = $scope.performance;
        obj['headers']['schoolName'] = $scope.schoolName;
        obj['headers']['schoolHeader'] = $scope.schoolHeader;
        obj['headers']['schoollogo'] = $scope.schoollogo;

        obj.canterburySchools = $scope.canterburySchools;
        obj['FILE_UPLOAD_URL'] = CONSTANTS.FILE_UPLOAD_URL;
        obj.qp_id = qpId, obj.school_id = schoolId, authService.callAPI("/v0/assesment-report/export/class/report", "POST", obj, function (response) {
            try {

                if (response.result) {

                    var data = response.result.data.details.response;
                    // console.log(data)
                    $scope.url = $sce.trustAsResourceUrl(data);
                }
            } catch (e) {
                console.log(e);
            }
            $scope.loading = false;
            $scope.isLoading = false;
            $scope.$apply();
        });
    };
    $scope.extra_info_error = {};
    $scope.saveExtraInfoInExams = function () {
        var err_cnt = 0;
        $scope.extra_info_error = {};
        if (!$scope.afl_extra_info) {
            toastr.error("Please enter teacher analysis or remedial measure");
            return false;
        }
        if (!$scope.afl_extra_info.teacher_analysis && !$scope.afl_extra_info.remedial_measure) {
            toastr.error("Please enter teacher analysis or remedial measure");
            return false;
        }
        if ($scope.afl_extra_info.teacher_analysis) {
            var len = $scope.afl_extra_info.teacher_analysis.length;
            if (len > 250) {
                $scope.extra_info_error.teacher_analysis = {};
                $scope.extra_info_error.teacher_analysis['message'] = "Please enter text less than 250 characters";
                err_cnt++;
            }
        }
        if ($scope.afl_extra_info.remedial_measure) {
            var _len2 = $scope.afl_extra_info.remedial_measure.length;
            if (_len2 > 250) {
                $scope.extra_info_error.remedial_measure = {};
                $scope.extra_info_error.remedial_measure['message'] = "Please enter text less than 250 characters";
                err_cnt++;
            }
        }
        if (err_cnt) {
            return false;
        }
        var obj = {
            qp_id: qpId,
            school_id: schoolId,
            afl_extra_info: $scope.afl_extra_info
        };
        authService.callAPI("/v0/assesment-report/class/report/save/extrainfo", "POST", obj, function (response, error) {
            if (!response.error) {
                // $scope.afl_extra_info
                // $scope.studentScore.afl_extra_info = {
                //     teacher_analysis : $scope.afl_extra_info.teacher_analysis,
                //     remedial_measure : $scope.afl_extra_info.remedial_measure
                // }
                toastr.success("Remarks saved");
            }
            $scope.$apply();
        });
    };
}];

exports.default = reportsMainCtrl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _titlesPopup = __webpack_require__(925);

var _titlesPopup2 = _interopRequireDefault(_titlesPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: createActivity.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-10
                                                                                                                                                           * Author: Jeevanantham Nagarathinam
                                                                                                                                                           * Screen : FE162
                                                                                                                                                           * -----
                                                                                                                                                           * Last Modified: 2018-12-10
                                                                                                                                                           * Modified By: Jeevanantham Nagarathinam
                                                                                                                                                           * -----
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */

//import templatePopLoader from '../../generic/views/loader.html';
//import teacherSubViewTpl from '../views/teacherSubjectView.html';

var CreateActivityController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "CONSTANTS", "archiveService", "QP_HANDLING_CONSTANTS", "$stateParams", function CreateActivityController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, CONSTANTS, archiveService, QP_HANDLING_CONSTANTS, $stateParams) {
    var _this = this;

    _classCallCheck(this, CreateActivityController);

    var self = this;
    //CurrentPage.setTitle("Create Activity")
    $scope.schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    $scope.isPractice = false;
    var academicDetails = localStorageService.get('academicDetails');
    var authoring = localStorageService.get('authoringData');
    var currTimeunix = Math.floor(Date.now() / 1000);
    $scope.userToredir = btoa(localStorageService.get('username')) + "_" + currTimeunix;
    console.log($scope.userToredir);
    if (!authoring) {
        $state.go("dashboard");
    }
    var authoringData = {
        class_id: authoring.class_id,
        curriculum_id: authoring.curriculum_id,
        batch_id: authoring.batch_id,
        subject_id: authoring.subject_id,
        session_id: authoring.session_id,
        school_id: authoring.school_id,
        batch: authoring.batch,
        class: authoring.class,
        subject: authoring.subject,
        session: authoring.session,
        curriculum: authoring.curriculum,
        academic_year: authoring.academic_year
    };
    $scope.qp_handler = {};
    $scope.qp_handler['is_visibleto_parents'] = true;
    $scope.themeselection = {};
    $scope.themeselection.type = 'multiple';
    $scope.qp_type = {};
    var normal_type = {
        _id: "normal",
        name: "General"
    };
    var LO_TEXT = "Learning Outcome";
    var WT_TEXT = "Wrap Up Test";
    var LO_ID = "learning_outcome";
    var WT_ID = "wrapup_test";
    $scope.activity_types = [{
        _id: LO_ID,
        name: LO_TEXT
    }, {
        _id: WT_ID,
        name: WT_TEXT
    }, normal_type];
    $scope.qp_type['activity_type'] = normal_type._id;
    $scope.is_qp_type_lW = false;
    $scope.isTWWTCLASSES = false;
    var new_activity_types = [{
        _id: LO_ID,
        name: LO_TEXT
    }, {
        _id: WT_ID,
        name: WT_TEXT
    }];
    $scope.titles = [];
    $scope.titleitem = {};
    $scope.error_div = {
        msg: null,
        has_error: false
    };
    $scope.tracker_obj = {
        is_tracker: false
    };
    function nullErrorDiv() {
        $scope.error_div = {
            msg: null,
            has_error: false
        };
    }
    function msgErrorDiv() {
        var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        $scope.error_div = {
            msg: msg,
            has_error: true
        };
    }
    function lTcreationLimitErr() {
        var str = '';
        if ($scope.qp_type && $scope.qp_type['activity_type']) {
            if ($scope.qp_type['activity_type'] == LO_ID) {
                str = "Sorry. Cannot proceed. " + LO_TEXT + " activities limit exceeded. Please change the topic (theme).";
            }
            if ($scope.qp_type['activity_type'] == WT_ID) {
                str = "Sorry. Cannot proceed. " + WT_TEXT + " activities limit exceeded. Please change the topic (theme).";
            }
        }
        msgErrorDiv(str);
        $scope.$apply();
        toastr.error(str);
    }
    function validateLearningTracker(callBack) {
        nullErrorDiv();
        try {
            if (!$scope.isTWWTCLASSES) {
                callBack(true);
                return;
            }
            if (!$scope.is_qp_type_lW) {
                callBack(true);
                return;
            }
            var url = "/v0/traditional/qp/validate/learning/tracker";
            var isEdit = false;
            if ($scope.qpId) {
                isEdit = true;
            }
            var obj = {
                authoringData: authoringData,
                qp_type: $scope.qp_type,
                theme: $scope.theme[0],
                isEdit: isEdit,
                qpId: $scope.qpId,
                userId: userId
            };
            authService.callAPI(url, "POST", obj, function (response) {
                try {
                    if (response.result && response.result.data) {
                        callBack(response.result.data.details);
                    } else {
                        callBack(true);
                    }
                } catch (er) {
                    console.log(er);
                    callBack(true);
                }
            });
        } catch (e) {
            callBack(true);
        }
    }
    $scope.showTitlesInPoUp = function () {
        if ([LO_ID, WT_ID].indexOf($scope.qp_type.activity_type) !== -1) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', 'titles', 'authoringData', 'authService', 'userId', titlePopUpController],
                locals: {
                    "parentScope": $scope,
                    titles: $scope.titles,
                    authoringData: authoringData,
                    authService: authService,
                    userId: userId
                },
                template: _titlesPopup2.default,
                parent: angular.element(document.body),
                clickOutsideToClose: true
                // fullscreen: useFullScreen
            });
        }
    };
    var LWWT_REQUIRED_CLASSES = [];
    var LWWT_REQUIRED_SUBJECTS = [];
    if (QP_HANDLING_CONSTANTS) {
        if (QP_HANDLING_CONSTANTS.QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS && QP_HANDLING_CONSTANTS.QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS.indexOf(localStorageService.get("school_id")) !== -1) {
            $scope.qp_handler['is_visibleto_parents'] = false;
        }
    }
    $scope.disableFilter = false;
    $scope.qpId = $state.params.qpId;
    $scope.activityId = $state.params.activityId;

    var whiteFeatureList = ['createQuestion', 'selectQuestion', 'selectTemplate', 'selectQuestionPaper'];

    //[Object] - List of features menu
    $scope.featuresList = [{
        "_id": "createQuestion",
        "name": "Create Question",
        "state": "createQuestion",
        "icon": "../../../../img/icons/create-question.png",
        "color": "#f16e02"
    }, {
        "_id": "selectQuestion",
        "name": "Select Question",
        "state": "selectQuestion",
        "icon": "../../../../img/icons/select-question.png",
        "color": "#00b4bd"
    }, {
        "_id": "selectTemplate",
        "name": "Select Template",
        "state": "selectTemplate",
        "icon": "../../../../img/icons/question-template.png",
        "color": "#f35966"
    }, {
        "_id": "selectQuestionPaper",
        "name": "Select Question Paper",
        "state": "selectQuestionPaper",
        "icon": "../../../../img/icons/archives.png",
        "color": "#00ba9c"
    }];

    var isLWisLW = function isLWisLW(qp_doc) {
        var ret = false;
        try {
            var typeids = _.pluck(new_activity_types, "_id");
            if (qp_doc) {
                if (qp_doc.qp_type && qp_doc.qp_type.activity_type && typeids.indexOf(qp_doc.qp_type.activity_type) !== -1) {
                    ret = true;
                }
            }
            return ret;
        } catch (e) {
            console.log(e);
            ret = false;
            return ret;
        }
    };
    function setRadio() {
        var qp_doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (qp_doc.qp_type) {
            $scope.qp_type.activity_type = qp_doc.qp_type.activity_type;
        }
    }
    var __IS_AUTO_WRAPUP = false;
    var setUiIfFromTracker = function setUiIfFromTracker() {
        if (__IS_AUTO_WRAPUP) {
            $scope.themeselection.type = 'single';
            $scope.tracker_obj.is_tracker = true;
        } else {
            $scope.themeselection.type = 'multiple';
            $scope.tracker_obj.is_tracker = false;
        }
    };
    var getActivity = function getActivity(obj) {
        console.log('getActivity');
        authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.data.data) {
                var result = response.result.data.data[0];
                console.log(result);
                if (result.basic_details[0]['qp_type']) {
                    $scope.qp_type['activity_type'] = result.basic_details[0]['qp_type'].activity_type;
                    $scope.is_qp_type_lW = isLWisLW(result.basic_details[0]);
                    if (result.basic_details[0].auto_wrapup) {
                        __IS_AUTO_WRAPUP = true;
                        $scope.theme = result.basic_details[0].theme_id[0];
                    } else {
                        $scope.theme = result.basic_details[0].theme_id;
                    }
                }
                $scope.disableFilter = true;
                $scope.activityResult = result;

                $scope.qpTitle = result.basic_details[0].question_paper_title;
                $scope.isPractice = result.basic_details[0].practice_qn;
                setUiIfFromTracker();
            } else {
                //error
            }
            console.log($scope.qp_type);
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    var getThemeData = function getThemeData() {
        authoringData['isLwWT'] = true;
        authService.callAPI(activityCons.API_GET_THEMES, "POST", authoringData, function (response) {
            if (response.result && response.result.status && response.result.data.themeList) {
                $scope.themes = response.result.data.themeList;
                LWWT_REQUIRED_CLASSES = response.result.data.required_classes;
                LWWT_REQUIRED_SUBJECTS = response.result.data.required_subjects;
                if (LWWT_REQUIRED_CLASSES.indexOf(authoring.class_id) !== -1) {
                    if (LWWT_REQUIRED_SUBJECTS.indexOf(authoring.subject_id) !== -1) {
                        $scope.isTWWTCLASSES = true;
                    }
                }
                if (response.result.data.titles && response.result.data.titles.length) {
                    $scope.titles = response.result.data.titles;
                }
                console.log($scope.titles);
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                //error
            }
        });

        _.defer(function () {
            $scope.$apply();
        });
    };

    var addActivityToQp = function addActivityToQp(academic_details, res) {
        authService.callAPI(activityCons.API_ADD_ACTIVITY_TO_QP, "POST", academic_details, function (response) {
            if (response.result && response.result.status && response.result.data.data) {
                res(response.result.data.data);
            } else {
                console.log(response);
            }
        });
    };

    var updateActivityToQp = function updateActivityToQp(qp_id, title, theme, res) {
        var obj = {
            qpId: qp_id,
            qpTitle: title,
            theme: theme,
            qp_type: $scope.qp_type
        };
        obj['is_visibleto_parents'] = $scope.qp_handler['is_visibleto_parents'];
        authService.callAPI(activityCons.API_UPDATE_ACTIVITY_QP, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.data.details) {
                res(response.result.data.details);
            } else {
                //error
            }
        });
    };

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity List";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (!authoring) {
            $state.go("dashboard");
        }
        if ($scope.qpId) {
            var obj = {
                "qp_id": $scope.qpId,
                "teacher_id": localStorageService.get("user_id"),
                "school_id": localStorageService.get("school_id")
            };
            getActivity(obj);
        }

        getThemeData();
    };

    var redirectDetails = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();
    if (redirectDetails) {
        $scope.isLoading = true;
        console.log('academicDetails', academicDetails);
        $scope.qpTitle = academicDetails.question_paper_title;
        $scope.theme = academicDetails.theme_id;
        if (redirectDetails.returnData) {
            var _academicDetails = localStorageService.get('academicDetails');
            if (redirectDetails.activeTab == "qp") {
                var archiveQpId = redirectDetails.returnData.resource._id;
                _academicDetails["archive_qp_id"] = archiveQpId;
                authService.callAPI(activityCons.API_SELECT_QP, "POST", _academicDetails, function (response) {
                    if (response.result && response.result && response.result.data) {
                        var qpId = response.result.data._id;
                        $state.go('activityPreview', {
                            qpId: qpId
                        });
                    }
                });
            } else if (redirectDetails.activeTab == "question") {
                var ques_ids = [];
                _.each(redirectDetails.returnData, function (questionArchive) {
                    ques_ids.push(questionArchive.resource._id);
                });
                _academicDetails['ques_ids'] = ques_ids;
                authService.callAPI(activityCons.API_SELECT_QUESTION, "POST", _academicDetails, function (response) {
                    if (response.result && response.result && response.result.data) {
                        var qpId = response.result.data.qp_id;
                        $state.go('formatQuestion', {
                            qpId: qpId
                        });
                    }
                });
            } else if (redirectDetails.activeTab == "qp_template") {
                var qpId = redirectDetails.returnData.resource._id;
                _academicDetails["qp_id"] = qpId;
                _academicDetails["title"] = qpId;
                authService.callAPI(activityCons.API_SELECT_TEMPLATE, "POST", _academicDetails, function (response) {
                    if (response.result && response.result && response.result.data) {
                        var questioPaperId = response.result.data.data._id;
                        $state.go('activityPreview', {
                            qpId: questioPaperId
                        });
                    }
                });
            } else {
                $scope.isLoading = false;
            }
        } else {
            $scope.isLoading = false;
        }
    }

    $scope.qpTitleChange = function () {
        $scope.isTitleChanged = true;
    };
    $scope.onSelectChange = function (type, theme_id) {
        nullErrorDiv();
        if (type == 'single') {
            $scope.theme = [theme_id];
        } else {
            $scope.theme = theme_id;
        }
        $scope.isThemeChanged = true;
    };

    /*
     * To navigate to selected page
     * 
     * @feature : Object - Selected feature detail
     * 
     * @return : null
     *
     * 
     */

    $scope.navigatePage = function (feature) {
        nullErrorDiv();
        if ($scope.theme && $scope.qpTitle) {
            academicDetails = authoringData;

            academicDetails['theme_id'] = $scope.theme;
            academicDetails['question_paper_title'] = $scope.qpTitle;
            academicDetails['practice_qn'] = $scope.isPractice;
            academicDetails['isNotAddToQp'] = false;
            academicDetails['is_traditional_activity'] = true;
            academicDetails['isQuestionAvailable'] = false;
            academicDetails['qp_id'] = $scope.qpId;
            academicDetails['teacher_id'] = userId;
            academicDetails['is_visibleto_parents'] = $scope.qp_handler['is_visibleto_parents'];
            academicDetails['qp_type'] = $scope.qp_type;
            $scope.is_qp_type_lW = isLWisLW(academicDetails);
            academicDetails['is_qp_type_lW'] = $scope.is_qp_type_lW;
            $scope.currentTheme = _.find($scope.themes, function (theme) {
                return theme._id === $scope.theme;
            });
            console.log(feature._id, academicDetails);
            $scope.selectedActivity = feature;
            switch (feature._id) {
                case 'createQuestion':
                    if (!$scope.qpId) {
                        academicDetails["academic_year"] = localStorageService.get("activeAcdYear");
                        //checks limits of learning tracker
                        validateLearningTracker(function (canContinue) {
                            console.log(canContinue);
                            if (canContinue) {
                                addActivityToQp(academicDetails, function (result) {
                                    console.log(result);
                                    academicDetails['qp_id'] = result._id;
                                    localStorageService.set('academicDetails', academicDetails);
                                    localStorageService.set("createQuesiton", {
                                        state: "tactivity",
                                        qp_id: result._id,
                                        qp_title: result.question_paper_title,
                                        activity_id: result.activity_id,
                                        theme_id: result.theme_id,
                                        class_id: authoringData.class_id,
                                        curriculum_id: authoringData.curriculum_id,
                                        subject_id: authoringData.subject_id,
                                        batch_id: authoringData.batch_id,
                                        session_id: authoringData.session_id,
                                        school_id: authoringData.school_id,
                                        practice_qn: $scope.isPractice,
                                        academic_year: localStorageService.get("activeAcdYear"),
                                        is_visibleto_parents: $scope.qp_handler['is_visibleto_parents'],
                                        qp_type: $scope.qp_type,
                                        is_qp_type_lW: $scope.is_qp_type_lW
                                    });
                                    $state.go(feature.state);
                                });
                            } else {
                                //limiting learning tracker err handling
                                lTcreationLimitErr();
                            }
                        });
                    } else {
                        validateLearningTracker(function (canContinue) {
                            if (canContinue) {
                                if ($scope.isTitleChanged || $scope.isThemeChanged) academicDetails['question_paper_title'] = $scope.qpTitle;
                                academicDetails["academic_year"] = localStorageService.get("activeAcdYear");
                                localStorageService.set('academicDetails', academicDetails);
                                localStorageService.set("createQuesiton", {
                                    state: "tactivity",
                                    class_id: authoringData.class_id,
                                    curriculum_id: authoringData.curriculum_id,
                                    subject_id: authoringData.subject_id,
                                    batch_id: authoringData.batch_id,
                                    session_id: authoringData.session_id,
                                    school_id: authoringData.school_id,
                                    practice_qn: $scope.isPractice,
                                    qp_id: $scope.qpId,
                                    qp_title: $scope.qpTitle,
                                    activity_id: $scope.activityId,
                                    theme_id: $scope.theme,
                                    academic_year: localStorageService.get("activeAcdYear"),
                                    is_visibleto_parents: $scope.qp_handler['is_visibleto_parents'],
                                    qp_type: $scope.qp_type,
                                    is_qp_type_lW: $scope.is_qp_type_lW
                                });
                                updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, function (result) {
                                    $state.go(feature.state);
                                });
                            } else {
                                //limiting learning tracker err handling
                                lTcreationLimitErr();
                            }
                        });
                    }

                    break;
                case 'selectQuestionPaper':
                    validateLearningTracker(function (canContinue) {
                        if (canContinue) {
                            academicDetails["qp_id"] = $scope.qpId;
                            academicDetails['question_paper_title'] = $scope.qpTitle;

                            updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, function (result) {
                                localStorageService.set('academicDetails', academicDetails);
                                goToArchive({
                                    tabId: "qp",
                                    searchFilterId: "qp",
                                    name: 'Select Question Paper'
                                }, false);
                            });
                        } else {
                            lTcreationLimitErr();
                        }
                    });

                    break;
                case 'selectQuestion':
                    validateLearningTracker(function (canContinue) {
                        if (canContinue) {
                            academicDetails["qp_id"] = $scope.qpId;
                            academicDetails['question_paper_title'] = $scope.qpTitle;
                            if ($scope.isTitleChanged) academicDetails['question_paper_title'] = $scope.qpTitle;

                            updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, function (result) {
                                localStorageService.set('academicDetails', academicDetails);
                                goToArchive({
                                    tabId: 'question',
                                    searchFilterId: 'question',
                                    name: "Select Question"
                                }, true);
                            });
                        } else {
                            lTcreationLimitErr();
                        }
                    });
                    break;
                case 'selectTemplate':
                    academicDetails["qp_id"] = $scope.qpId;
                    academicDetails['question_paper_title'] = $scope.qpTitle;
                    updateActivityToQp($scope.qpId, $scope.qpTitle, $scope.theme, function (result) {
                        localStorageService.set('academicDetails', academicDetails);
                        goToArchive({
                            tabId: 'qp_template',
                            searchFilterId: 'qp',
                            name: "Select Template"
                        }, false);
                    });
                    break;
                default:
                    this.state.go("createActivity");
                    break;
            }
        } else {
            toastr.error('Please select theme and question paper title');
        }
    };

    var goToArchive = function goToArchive(type, isMultiSelect) {

        var teachingPlan = $scope.teachingPlan;
        var searchFilters = [];
        var authoring = localStorageService.get('authoringData');
        searchFilters.push({
            type: 'curriculum',
            value: {
                _id: authoring.curriculum_id,
                name: authoring.curriculum
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'class',
            value: {
                _id: authoring.class_id,
                name: authoring.class
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'subject',
            value: {
                _id: authoring.subject_id,
                name: authoring.subject
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: "tab",
            value: {
                _id: type.tabId,
                name: type.name
            },
            deletable: false,
            visible: false
        });
        if ($scope.isPractice && type.searchFilterId == 'qp') {
            searchFilters.push({
                type: "exam_type",
                value: {
                    _id: "Practice",
                    name: "Practice Exam"
                },
                deletable: false,
                visible: true
            });
        }
        if (!$scope.isPractice && type.searchFilterId == 'qp') {
            searchFilters.push({
                type: "exam_type",
                value: {
                    _id: "Assesment",
                    name: "Assessment Exam"
                },
                deletable: false,
                visible: true
            });
        }
        var details = _defineProperty({
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            isMultiSelect: isMultiSelect,
            isPractice: $scope.isPractice,
            activeTab: type.tabId,
            resource: _this.resource,
            resourceType: {
                _id: type.searchFilterId,
                name: type.name
            }
        }, 'isPractice', $scope.isPractice);
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };
    function _breakReference(data) {
        var arrayOfKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var keys = Object.keys(data);
        if (arrayOfKeys && arrayOfKeys.length) {
            keys = arrayOfKeys;
        }
        var obj = {};
        for (var k = 0; k < keys.length; k++) {
            obj[keys[k]] = data[keys[k]];
        }
        return obj;
    }
    function cleartitle() {
        $scope.qpTitle = '';
    }
    $scope.selectActType = function (model_type) {
        cleartitle();
        if ($scope.qp_type && $scope.qp_type.activity_type == 'normal') {
            $scope.theme = undefined;
            $scope.themeselection.type = 'multiple';
        } else {
            if ($scope.themeselection.type == 'single') {} else {
                $scope.themeselection.type = 'single';
                $scope.theme = undefined;
            }
        }
        var obj = {};
        obj.qp_type = $scope.qp_type;
        $scope.is_qp_type_lW = isLWisLW(obj);
    };
}];

exports.default = CreateActivityController;

var titlePopUpController = function titlePopUpController($scope, $mdDialog, parentScope, titles, authoringData, authService, userId) {
    _classCallCheck(this, titlePopUpController);

    $scope.modal = {};
    $scope.modal['title'] = "Select Question Paper Title";
    $scope.titleitem = {};
    $scope.titleitem.canContinue = true;
    $scope.titles = [];
    $scope.selections = {};
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.saveAction = function () {
        parentScope.qpTitle = getTitleTxt();
        toastr.success("Question paper title selected.");
        $mdDialog.cancel();
    };
    function getTitleTxt() {
        var ret = null;
        var exists = _.find($scope.titles, function (one) {
            return one._id == $scope.titleitem.qpTitle;
        });
        if (exists) {
            ret = exists.title;
        }
        return ret;
    }
    function getThemeTxt() {
        var ret = '';
        var exists = _.find(parentScope.themes, function (one) {
            return one.theme_id == parentScope.theme[0];
        });
        if (exists) {
            ret = exists.theme_name;
        }
        return ret;
    }
    $scope.validateTitle = function () {
        if (parentScope.theme && parentScope.theme.length) {
            var isEdit = false;
            if (parentScope.qpId) {
                isEdit = true;
            }

            var obj = {
                authoringData: authoringData,
                qp_type: parentScope.qp_type,
                theme: parentScope.theme[0],
                isEdit: isEdit,
                qpId: parentScope.qpId,
                title: getTitleTxt(),
                userId: userId
            };
            var url = "/v0/validate/qp/title";
            authService.callAPI(url, "POST", obj, function (response) {

                try {
                    if (response.result && response.result.data) {
                        $scope.titleitem.canContinue = response.result.data.details;
                    }
                } catch (er) {
                    console.log(er);
                }
                $scope.$apply();
            });
            console.log(obj);
        }
    };
    this.$onInit = function () {
        $scope.titles = titles;
        $scope.titleitem.theme_txt = getThemeTxt();
        console.log(parentScope.theme);
    };
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commentsPopup = __webpack_require__(535);

var _commentsPopup2 = _interopRequireDefault(_commentsPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: qpSummary.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-13
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var QpSummaryController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "CONSTANTS", "qpHandler", function QpSummaryController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, CONSTANTS, qpHandler) {
    _classCallCheck(this, QpSummaryController);

    var noActvity = true;
    $scope.array = [];
    $scope.questionList = [];
    $scope.qpStatus = false;
    $scope.questionDetails = {};
    $scope.questions = [];
    $scope.score = 0;
    this.viewSubmission = true;
    $scope.isCreator = false;
    $scope.isUserAssigned = false;
    $scope.isSubmitApproval = false;
    $scope.enableStartNow = false;
    $scope.activityAttended = false;
    var noAuthMenuBar = localStorageService.get('noAuthMenuBar');
    //Boolean - To check whether activity password is present or not
    $scope.isActivityPassword = false;
    $scope.activity_answer_sheet_view = false;
    $scope.total_mark = 0;
    var self = this;
    var qpId = $stateParams.qpId;
    var activity_answer_sheet_view = localStorageService.get('activity_answer_sheet_view');
    var authoring = localStorageService.get('authoringData');
    // if(!authoring){
    //     authoring = localStorageService.get('activity_answer_sheet')
    // }
    if (activity_answer_sheet_view) {
        $scope.activity_answer_sheet_view = true;
    }
    var userId = localStorageService.get("user_id");

    if (authoring) $scope.class = authoring.class;
    $scope.isApprover = false;
    self.date = '';
    $scope.questionPaper = {};
    var qpSub = undefined;
    var TYPE_INFO = {};
    var normal_type = {
        _id: "normal",
        name: "Normal"
    };
    var activity_types = [{
        _id: "learning_outcome",
        name: "Learning Outcome"
    }, {
        _id: "wrapup_test",
        name: "Wrap Up Test"
    }, normal_type];
    for (var index = 0; index < activity_types.length; index++) {
        var element = activity_types[index];
        TYPE_INFO[element._id] = element;
    }
    // $scope.qp_type['activity_type'] = normal_type._id
    this.$onDestroy = function () {
        if (qpSub) qpSub.stop();
    };
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        authService.callAPI(activityCons.API_GET_QP_SUMMARY + "/" + qpId, "GET", undefined, function (response) {
            if (response.result != undefined) {
                loadTemplate(response.result);
            } else {
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
        loadActivityStatus();
    };
    $scope.minDate = new Date();
    var loadTemplate = function loadTemplate(resultObj) {
        var result = undefined;
        if (resultObj.data && resultObj.data && resultObj.data.data && resultObj.data.data.template) {
            result = resultObj.data.data.template;

            $scope.serverDate = result.server_time;
            try {
                var date_server = new Date(result.server_time);
                var _date = new Date(date_server.getFullYear(), date_server.getMonth(), date_server.getDate());
                $scope.minDate = _date;
            } catch (ed) {
                console.log(ed);
                $scope.minDate = result.server_time;
            }
            //Object - Summary details of the activity
            $scope.qpTemplatePreview = {
                template: result
            };

            getQPDetails(1);
            $scope.$apply();
        }
    };
    $scope.addToDL = function () {
        $scope._disable_archive_add = true;
        authService.callAPI("/v1/sync_to_archive/" + qpId, "GET", {}, function (response) {
            if (response && response.result && response.result.status && response.result.status.code == 200) {
                $scope._can_add_to_archive = false;
                toastr.success("Added this question paper to digital library");
            } else {
                $scope._disable_archive_add = false;
            }
            $scope.$apply();
        });
    };
    function canAddToArchive(qpDoc) {
        if (qpDoc && qpDoc._can_add_to_archive) {
            $scope._can_add_to_archive = true;
        }
    }
    $scope._can_add_to_archive = false;
    $scope._disable_archive_add = false;
    var getQPDetails = function getQPDetails(call) {
        console.log(call);
        authService.callAPI(activityCons.API_QP_DETAILS + qpId, "GET", {}, function (response) {
            if (response.result != undefined) {
                var result = response.result.data.details;
                if (result.academic && !$rootScope.title) {
                    $rootScope.title = result.academic;
                }
                $scope.activityId = result.activity_id;
                _.each(result.students, function (eachStud) {
                    if (eachStud._id === userId) {
                        if (eachStud.status === "not attended") {
                            // TO get activity password
                            $scope.enableStartNow = true;
                            if (result.activity_password && result.activity_password !== null && result.activity_password !== undefined && result.activity_password !== "") {
                                $scope.activityPwd = result.activity_password;
                                $scope.isActivityPassword = true;
                            }
                        }
                        $scope.studentStatus = eachStud.status;
                        $scope.resultStatus = eachStud.result;
                    }
                });
                if (result.students && result.students.length > 0) $scope.isUserAssigned = true;

                $scope.isStart = false;
                $scope.isSchedule = false;
                $scope.isReschedule = false;
                $scope.isViewSubmission = false;
                $scope.isPublishResult = false;
                $scope.isPublished = false;
                $scope.isCompleted = false;

                if (result.status == "approved") {
                    $scope.isSchedule = true;
                    $scope.isStart = true;
                    canAddToArchive(result);
                } else if (result.status == "scheduled") {
                    $scope.isStart = true;
                    $scope.isReschedule = true;
                    canAddToArchive(result);
                } else if (result.status == "conducted") {
                    $scope.isViewSubmission = true;
                    $scope.isPublishResult = true;
                    $scope.isCompleted = false;
                    canAddToArchive(result);
                } else if (result.status == "published") {
                    $scope.isViewSubmission = true;
                    $scope.isCompleted = true;
                    $scope.isPublished = true;
                    canAddToArchive(result);
                } else if (result.status == "completed") {
                    $scope.isCompleted = true;
                    $scope.isViewSubmission = true;
                    $scope.isPublishResult = true;
                    canAddToArchive(result);
                } else if (result.status == "sent_for_approval") {
                    if (result.current_approver && result.current_approver._id) {
                        if (result.current_approver._id === userId) $scope.isApprover = true;
                    }
                }

                $scope.questionList = {
                    id: result.activity_id,
                    title: result.question_paper_title,
                    status: result.status,
                    isPractice: result.practice_qn,
                    approver_comment: result.approver_comment,
                    is_visibleto_parents: result.is_visibleto_parents,
                    qp_type: normal_type.name,
                    auto_wrapup: result.auto_wrapup
                };
                if (result.qp_type) {
                    $scope.questionList.qp_type = TYPE_INFO[result.qp_type.activity_type]['name'];
                }
                if (result.teacher_id === userId) $scope.isCreator = true;
                if ($scope.questionList.length === 0) {
                    noActvity = true;
                } else {
                    noActvity = false;
                }
                $scope.$apply();
            } else {
                console.log(response.error);
            }
        });
    };
    $scope.viewComment = function (ev) {
        if ($scope.questionList && $scope.questionList.approver_comment) {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Approver comment').textContent($scope.questionList.approver_comment).ariaLabel('Alert Dialog Demo').ok('OK').targetEvent(ev));
        }
    };
    $scope.routeToQpPreview = function () {
        localStorageService.set("isViewAllQuestion", true);

        $state.go('activityPreview', {
            "qpId": qpId
        });
    };
    $scope.gotoAssigningPage = function () {
        if ($scope.isUserAssigned) {
            var confirm = $mdDialog.confirm().textContent('It will reassign previously assigned students').ok('Ok').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                $state.go('assignStudents', {
                    qpId: $state.params.qpId,
                    previousState: {
                        state: 'qpSummary',
                        params: $stateParams
                    }
                });
            }, function () {});
        } else {
            $state.go('assignStudents', {
                qpId: $state.params.qpId,
                previousState: {
                    state: 'qpSummary',
                    params: $stateParams
                }
            });
        }
    };

    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };
    $scope.viewMyAnswer = function (data) {
        if (data.status !== "published" && !data.isPractice) {
            alert = $mdDialog.alert({
                textContent: 'Result is not published',
                ok: 'Ok'
            });

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
            });
        } else {
            $state.go('studentAnswerView', {
                qpId: qpId
            });
        }
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }

    /* Set answered choice is wrong or correct*/
    function setChoice() {
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (data, key) {
                $scope.total_mark += parseInt(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    _.each(data.choice, function (choice) {
                        if ($scope.checkingChoiceExists(choice.desc, data)) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                        }
                    });
                } else if (data.type == 'TF') {
                    _.each(data.choice, function (choice) {
                        if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        }
                    });
                } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key2]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.question.desc);
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key3].desc);
                            if (correctAnswer !== studentAnswer) {
                                correct = false;
                            } else {
                                correct = true;
                            }
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacter(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                } else {
                                    choice.wrong = true;
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacter(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacter(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    aslListQues.wrong = true;
                                } else {
                                    aslListQues.correct = true;
                                }
                            } else {
                                aslListQues.wrong = true;
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
    }

    $scope.score = $scope.score.toFixed(2);
    $scope.cancel = function () {
        $mdDialog.hide();
    };
    $scope.setFilePath = function (img) {
        var new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined;
        return new_url;
    };
    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " (_______) ");
    };

    /* Formating the date value to display format*/
    $scope.getDateInFormat = function () {
        var dateFormat = $filter('date')(assignedDate, "dd-MM-yyyy");
        if (dateFormat) {
            self.date = dateFormat;
        } else {
            self.date = "";
        }
    };

    $scope.startTest = function (data) {

        // Object - Holds validation errors
        $scope.errors = {};

        if ($scope.activityPassword === "") {
            $scope.errors['activityPassword'] = "Please enter password";
        } else if ($scope.activityPassword !== $scope.activityPwd) {
            $scope.errors['activityPassword'] = "Please enter correct password";
        } else if ($scope.activityPassword === $scope.activityPwd) {
            $scope.isActivityPassword = false;
            $state.go('studentQuestionSelection', {
                qpId: qpId,
                activityId: data.id
            });
        }
    };

    $scope.scheduleExam = function (dueDate) {
        $scope.qpTemplatePreview.template.date = $scope.dueDate;
        var schedulExDate = $scope.dueDate;
        schedulExDate.setHours(10);
        var obj = {
            dueDate: schedulExDate,
            qpId: qpId,
            userId: userId
        };
        authService.callAPI(activityCons.API_SCHEDULE_EXAM, "POST", obj, function (response) {
            if (response.result) {
                toastr.success("Activity scheduled Successfully");
            } else {
                getQPDetails();
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
        $scope.isScheduleDate = false;
        $scope.isSchedule = false;
        $scope.isStart = true;
        $scope.viewSubmission = false;
    };
    $scope.conductTest = function () {

        var reqObj = {
            activity_id: $scope.activityId,
            qp_id: qpId
        };
        authService.callAPI(activityCons.API_START_EXAM, "POST", reqObj, function (response) {
            if (response.result != undefined) {
                $scope.isScheduleDate = false;
                $scope.isSchedule = false;
                $scope.isStart = false;
                $scope.isViewSubmission = true;
                $scope.isPublished = false;
                $scope.isPublishResult = false;
                toastr.success("Exam started successfully");
                getQPDetails();
            } else {
                console.log(response.error);
            }
        });
    };
    $scope.filterPerson = function () {
        var approverList = _.filter($scope.approverRoles, function (person) {
            return person._id == $scope.approverRole;
        });
        // let approverList = _.filter($scope.approverRoles, function(person) {
        //     return person._id.indexOf($scope.approverRole) !== -1;
        // })
        if (approverList && approverList.length > 0) $scope.approverRolePersons = approverList[0].users;
    };
    function showConfirmtoPublish() {
        authService.callAPI(activityCons.API_PUBLISH_RESULT + qpId + '/' + userId, "GET", {}, function (response) {
            if (response.result != undefined) {
                toastr.success('Result published');
                $scope.isScheduleDate = false;
                $scope.isSchedule = false;
                $scope.isStart = false;
                $scope.isViewSubmission = true;
                $scope.isPublished = true;
                $scope.isPublishResult = false;
                getQPDetails();
            } else {
                console.log("error : " + response.error);
            }
        });
    }
    $scope.gotoPublish = function (ev) {
        var confirm = $mdDialog.confirm().title('Are you sure to publish the activity?').textContent('Once published, all the results will be available to student(s) and their parent(s)').ariaLabel('Lucky day').targetEvent(ev).ok('Publish').cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
            showConfirmtoPublish();
        }, function () {});
    };
    $scope.gotoSubmissionList = function () {

        $state.go("viewSubmissionList", {
            qpId: $stateParams.qpId
        });
    };
    $scope.closeDiv = function () {
        $scope.isScheduleDate = false;
    };
    $scope.setScheduleDate = function (ev) {
        if ($scope.isUserAssigned) {
            $scope.isScheduleDate = true;
        } else {
            var confirm = $mdDialog.confirm().textContent('Please assign users').targetEvent(ev).ok('Ok');
            $mdDialog.show(confirm).then(function () {
                $scope.isAssignUsers = true;
            }, function () {
                $scope.isAssignUsers = false;
            });
            $scope.isPrompt = true;
        }
    };
    $scope.submitforApprovalClick = function () {
        var academics = {
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id
        };
        authService.callAPI(activityCons.API_APPROVER_LIST, "POST", academics, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                var resultData = response.result.data.data;
                if (resultData && resultData.length > 0 && resultData[0].roles) $scope.approverRoles = resultData[0].roles;
                $scope.$apply();
            } else {
                console.log(response.error);
            }
        });
        $scope.isSubmitApproval = true;
    };
    $scope.cancelApproval = function () {
        $scope.isSubmitApproval = false;
    };
    $scope.submitforApproval = function () {
        if (!$scope.approverRole) {
            $scope.approverRoleError = "Select a role";
        }
        if (!$scope.approverPerson) {
            $scope.approverPersonError = "Select a person";
        }
        if ($scope.approverRole && $scope.approverPerson) {
            var approverId = $scope.approverPerson;
            $scope.isSubmitApproval = false;
            var academics = {
                session_id: authoring.session_id,
                curriculum_id: authoring.curriculum_id,
                class_id: authoring.class_id,
                batch_id: authoring.batch_id,
                subject_id: authoring.subject_id,
                school_id: authoring.school_id,
                qp_id: qpId,
                user_id: userId,
                approver_id: approverId,
                approver_role: $scope.approverRole
            };
            authService.callAPI(activityCons.API_SEND_FOR_APPROVAL, "POST", academics, function (response) {
                if (response.result) {
                    toastr.success("Successfully sent for approval");
                    getQPDetails();
                } else {
                    console.log(response.error);
                }
            });
        }
    };
    $scope.goToActivityList = function () {
        $state.go("activityList");
    };
    $scope.approveActivity = function (ev) {
        showPopup(true);
        // var confirm = $mdDialog.prompt()
        // .title('Approve comment')
        // .textContent('Please enter the comment')
        // .placeholder('Enter reason')
        // .ariaLabel('Enter reason')
        // .initialValue('Approved')
        // .targetEvent(ev)
        // .required(true)
        // .ok('Approve')
        // .cancel('Cancel');

        // $mdDialog.show(confirm).then(function(result) {
        //     console.log(result)
        // }, function(d) {
        //     console.log(d)
        // });

    };
    $scope.approveFromPoppup = function (reason) {
        var obj = {
            qpId: qpId,
            userId: userId,
            comment: reason
        };
        authService.callAPI(activityCons.API_APPROVE_QP, "POST", obj, function (response) {
            if (response.result) {
                toastr.success('Question paper approved successfully');
                getQPDetails();
            } else {
                console.log(response.error);
            }
        });
    };
    $scope.rejectFromPoppup = function (reason) {
        var obj = {
            qpId: qpId,
            userId: userId,
            comment: reason
        };
        authService.callAPI(activityCons.API_REJECT_QP, "POST", obj, function (response) {
            if (response.result) {
                toastr.error('Question paper rejected');
                getQPDetails();
            } else {
                console.log(response.error);
            }
        });
    };
    function showPopup(_toApprove) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', '_toApprove', approveRejectCommentsController],
            locals: {
                _toApprove: _toApprove,
                "parentScope": $scope
            },
            template: _commentsPopup2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    }
    $scope.rejectActivity = function () {
        showPopup(false);
    };

    function getTime(millseconds) {
        var oneSecond = 1000;
        var oneMinute = oneSecond * 60;
        var oneHour = oneMinute * 60;
        var oneDay = oneHour * 24;

        var seconds = Math.floor(millseconds % oneMinute / oneSecond);
        var minutes = Math.floor(millseconds % oneHour / oneMinute);
        var hours = Math.floor(millseconds % oneDay / oneHour);
        var days = Math.floor(millseconds / oneDay);

        var timeString = '';
        if (days !== 0) {
            timeString += days !== 1 ? days + ' days ' : days + ' day ';
        }
        if (hours !== 0) {
            timeString += hours !== 1 ? hours + ' hours ' : hours + ' hour ';
        }
        if (minutes !== 0) {
            timeString += minutes !== 1 ? minutes + ' min ' : minutes + ' min ';
        }
        if (seconds !== 0 || millseconds < 1000) {
            timeString += seconds !== 1 ? seconds + ' sec ' : seconds + ' sec ';
        }

        return timeString;
    }

    $scope.stopExam = function () {

        var reqObj = {
            activity_id: $scope.activityId,
            qp_id: qpId
        };

        authService.callAPI(activityCons.API_STOP_EXAM, "POST", reqObj, function (response) {
            if (response.result != undefined) {
                console.log("result : " + response.result);
                getQPDetails();
            } else {
                console.log("error : " + response.error);
            }
        });
    };
    $scope.viewReport = function () {
        // $state.go('attendeeList', {
        //     qpId: qpId
        // })
        $state.go("reportsMainCtrl", {
            prevParams: {
                planId: null
            },
            qpId: $stateParams.qpId,
            isFromModule: noAuthMenuBar
        });
    };
    $scope.viewScores = function () {
        $state.go("reportsScoresCtrl", {
            qp_id: qpId
        });
    };
    var loadActivityStatus = function loadActivityStatus() {
        authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + qpId + '/' + userId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                console.log(response.result.data.details);
                if (response.result.data.details.student_user_doc && response.result.data.details.student_user_doc.admission_number) {
                    localStorageService.set("st_admission_number", response.result.data.details.student_user_doc.admission_number);
                }
                // $scope.admission_number

                $scope.activityAttended = true;
            } else {
                console.log("error : " + response.error);
            }
        });
    };
    $scope.copyPwdToClipboard = function () {
        var id = 'answer_sheet_lock';
        var r = document.createRange();
        r.selectNode(document.getElementById(id));
        var str = '';
        var dom = document.getElementById(id);
        if (dom && dom.innerText) {
            str = dom.innerText;
        }
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(r);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        toastr.success("Copied the password " + str);
    };
    function setAcdademicdata() {
        var fields = ['class', 'batch', 'subject', 'session', 'curriculum', 'academic_year'];
        var obj = {};
        for (var r = 0; r < fields.length; r++) {
            obj[fields[r]] = authoring[fields[r]];
        }
        return obj;
    }
    $scope.updateParentVisibility = function (activity) {
        var obj = {
            school_id: localStorageService.get("school_id"),
            qp_id: $stateParams.qpId,
            is_visibleto_parents: activity.is_visibleto_parents,
            toastr: toastr
        };
        qpHandler.updateParentVisibility(authService, obj);
    };
}];

exports.default = QpSummaryController;

var approveRejectCommentsController = function approveRejectCommentsController($scope, $mdDialog, parentScope, _toApprove) {
    _classCallCheck(this, approveRejectCommentsController);

    $scope.modal = {};
    $scope.modal['title'] = "Proceed";
    if (_toApprove) {
        $scope.modal['title'] = "Are you sure to Approve?";
        $scope.modal['btn_text'] = "Approve";
    } else {
        $scope.modal['title'] = "Are you sure to Reject?";
        $scope.modal['btn_text'] = "Reject";
    }
    $scope.selections = {};
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.saveAction = function () {
        if (_toApprove) {
            parentScope.approveFromPoppup($scope.selections['reason']);
        } else {
            parentScope.rejectFromPoppup($scope.selections['reason']);
        }
        $mdDialog.cancel();
    };
};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: formatQuestion.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
var FormatQuestionController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "archiveService", "$timeout", "CONSTANTS", "$sce", "ARCHIVE_CONSTANTS", function FormatQuestionController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout, CONSTANTS, $sce, ARCHIVE_CONSTANTS) {
    _classCallCheck(this, FormatQuestionController);

    this.writeNote = false;
    this.scope = $scope;
    this.state = $state;

    var academics = localStorageService.get('academicDetails');
    var userId = localStorageService.get('user_id');
    if (academics === undefined) $state.go('dashboard');
    var qpId = $state.params.qpId ? $state.params.qpId : academics.qp_id;
    self = this;
    $scope.sectionName = "";
    $scope.sectionName = "";
    $scope.sectionInstruction = "";
    $scope.markForEach = 0;
    $scope.attendQues = 0;
    $scope.allQues = 0;
    $scope.time = [];
    $scope.sectionInstruction = "";
    $scope.show_edit_icon = true;
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    $scope.formatQuestion = [];
    $scope.is_qp_type_lW = false;
    var normal_type = {
        _id: "normal",
        name: "Normal"
    };
    var new_activity_types = [{
        _id: "learning_outcome",
        name: "Learning Outcome"
    }, {
        _id: "wrapup_test",
        name: "Wrap Up Test"
    }];
    $scope.new_type_KV = {};
    _.each(new_activity_types, function (one) {
        $scope.new_type_KV[one._id] = one.name;
    });
    var _LW_WT_INFO = {
        MAX_MARK: 10,
        MAX_QUES: 10,
        MIN_QUES: 10,
        ALLOWED_TYPES: _.pluck(ARCHIVE_CONSTANTS.ARCHIVE_QUESTION_TYPE_LIST_LW, "_id")
        //$scope.tempData = $location.protocol() + "://" + $location.host() + ":4000"

        //   $scope.qpTitle = ""
    };$scope.sectionQuestions = [];
    $scope.sectionWiseQuestions = [];

    $scope.hours = [];
    for (var hour = 0; hour <= 12; hour++) {
        hour = hour > 9 ? hour : "0" + hour;
        $scope.hours.push(hour);
    }

    $scope.minutes = [];
    for (var min = 0; min < 60; min++) {
        min = min > 9 ? min : "0" + min;
        $scope.minutes.push(min);
    }

    var MQ = MathQuill.getInterface(2);
    var redirectDetails = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $scope.loadData();
    };
    $scope.convertTitle = function (title, TYPE, insideAccordian) {
        if (TYPE == "LA" || TYPE == 'passage') {
            var plntxt = title ? String(title).replace(/<[^>]+>/gm, '') : '';
            var string = plntxt.slice(0, 30);
            if (TYPE == 'passage') {
                string = "Passage Question";
            }
            return $sce.trustAsHtml(string);
        }
        var res = title;
        if (!insideAccordian) {
            res = res.slice(0, 30);
        }
        return $sce.trustAsHtml(res);
    };
    if (redirectDetails && redirectDetails.returnData) {
        if (redirectDetails.activeTab == "question") {
            var questions = [];
            _.each(redirectDetails.returnData, function (questionArchive) {
                questions.push(questionArchive.resource._id);
            });
            academics['ques_ids'] = questions;
            authService.callAPI(activityCons.API_SELECT_QUESTION, "POST", academics, function (response) {
                if (response.result && response.result && response.result.data) {
                    $scope.loadData();
                }
            });
        }
    }
    academics.qp_id = qpId;
    var qpDet = {
        "qp_id": qpId,
        "teacher_id": userId,
        "school_id": academics.school_id
    };
    $scope.qp_doc = undefined;
    $scope.questionType = activityCons.QUESTION_TYPE_DETAILS;
    function showErrAlert(ev, text) {
        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Learning outcome / Wrap up test warning.').textContent(text).ariaLabel('Alert Dialog Demo').ok('Close').targetEvent(ev));
    }
    var isLWisLW = function isLWisLW(qp_doc) {
        var ret = false;
        try {
            var typeids = _.pluck(new_activity_types, "_id");
            if (qp_doc) {
                if (qp_doc.qp_type && qp_doc.qp_type.activity_type && typeids.indexOf(qp_doc.qp_type.activity_type) !== -1) {
                    ret = true;
                }
            }
            return ret;
        } catch (e) {
            console.log(e);
            ret = false;
            return ret;
        }
    };
    function set1Mark() {
        if ($scope.is_qp_type_lW) {
            $scope.markForEach = 1;
        }
    }
    function setItemsLWWT() {
        try {
            if ($scope.is_qp_type_lW) {
                $scope.hour = "01";
                $scope.min = "00";
                set1Mark();
            }
        } catch (e) {
            console.log(e);
        }
    }
    var validateMinQuesAF = function validateMinQuesAF() {
        try {
            var len = 0;
            if ($scope.is_qp_type_lW) {
                if ($scope.formatQuestion.allQuestions && $scope.formatQuestion.allQuestions.length) {
                    var ques_already = _.flatten(_.pluck($scope.formatQuestion.allQuestions, "questions"));
                    if (ques_already && ques_already.length) {
                        len = len + Number(ques_already.length);
                    }
                }
                if (len < _LW_WT_INFO.MAX_QUES) {
                    return false;
                }
            }
            return true;
        } catch (e) {
            console.log(e);
            return true;
        }
    };
    var validateMinQues = function validateMinQues() {
        try {
            var len = 0;
            if ($scope.is_qp_type_lW) {
                if ($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length) {
                    var ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"));
                    if (ques_already && ques_already.length) {
                        len = len + Number(ques_already.length);
                    }
                }
                if (len < _LW_WT_INFO.MIN_QUES) {
                    return false;
                }
            }
            return true;
        } catch (e) {
            console.log(e);
            return true;
        }
    };
    var validateMaxQues = function validateMaxQues() {
        try {
            var len = $scope.sectionFormat.length;
            if ($scope.is_qp_type_lW) {
                if ($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length) {
                    var ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"));
                    if (ques_already && ques_already.length) {
                        len = len + ques_already.length;
                    }
                }
                if (len >= _LW_WT_INFO.MAX_QUES) {
                    return false;
                }
            }
            return true;
        } catch (e) {
            console.log(e);
            return true;
        }
    };
    var checkMaxMarks = function checkMaxMarks() {
        var reference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var isPreviewBtn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _total_marks = 0;
        try {
            if ($scope.is_qp_type_lW) {
                var markForEach = $scope.markForEach;
                var allQues = $scope.allQues;
                var attendQues = $scope.attendQues;
                var sectionFormat = $scope.sectionFormat;
                // console.log(markForEach, allQues, attendQues)
                if (sectionFormat && sectionFormat.length) {
                    var this_section_max = markForEach * attendQues;
                    if (!isNaN(this_section_max)) {
                        _total_marks = _total_marks + Number(this_section_max);
                    }
                    // for (let index = 0; index < sectionFormat.length; index++) {
                    //     try{
                    //         let this_section_max = markForEach * attendQues
                    //         let element = sectionFormat[index];
                    //         console.log(this_section_max)
                    //         if(!isNaN(element.qn_mark)){
                    //             _total_marks = _total_marks + Number(element.qn_mark)
                    //         }
                    //     }catch(e1){
                    //         console.log(e1)
                    //     }
                    // }
                }
                if ($scope.sectionWiseQuestions && $scope.sectionWiseQuestions.length) {
                    var sectionWiseQuestions = $scope.sectionWiseQuestions;
                    for (var index = 0; index < sectionWiseQuestions.length; index++) {
                        var element = sectionWiseQuestions[index];
                        var mark_each_qn = element.mark_each_qn;
                        var mandatory_no = element.mandatory_no;
                        var _this_section_max = Number(mark_each_qn) * Number(mandatory_no);
                        if (!isNaN(_this_section_max)) {
                            _total_marks = _total_marks + _this_section_max;
                        }
                    }
                    // let ques_already = _.flatten(_.pluck($scope.sectionWiseQuestions, "questions"))
                    // for (let index = 0; index < ques_already.length; index++) {
                    //     try{
                    //         let element = ques_already[index];
                    //         if(!isNaN(element.qn_mark)){

                    //         }
                    //     }catch(e2){
                    //         console.log(e2)
                    //     }
                    // }
                }
                console.log(_total_marks, '_total_marks');
                if (!isPreviewBtn) {
                    if (_total_marks > _LW_WT_INFO.MAX_MARK) {
                        reference['_total_marks'] = _total_marks;
                        return false;
                    }
                } else {
                    if (_total_marks !== _LW_WT_INFO.MAX_MARK) {
                        reference['_total_marks'] = _total_marks;
                        return false;
                    }
                }

                return true;
            } else {
                return true;
            }
        } catch (e) {
            console.log(e);
            return true;
        }
        console.log(_total_marks);
    };
    $scope.auto_wrapup = false;
    $scope.loadData = function (call) {
        authService.callAPI(activityCons.API_GET_TRADITIONAL_ACTIVITY, "POST", qpDet, function (response) {
            if (response.result && response.result.status && response.result.data.data) {
                var result = response.result.data.data[0];
                $scope.qp_doc = result;
                $scope.is_qp_type_lW = isLWisLW($scope.qp_doc.basic_details[0]);
                $scope.auto_wrapup = result.basic_details[0].auto_wrapup;
                setItemsLWWT();
                $scope.sectionFormat = [];
                $scope.qp_title = result.basic_details[0].question_paper_title;
                $scope.qnPaperId = result._id;
                $scope.practice_qn = result.basic_details[0].practice_qn;
                $scope.isPractice = $scope.practice_qn;
                $scope.activityId = result.basic_details[0].activity_id;
                if (result.temp_sections && result.temp_sections.length > 0) $scope.formatQuestion.allQuestions = result.temp_sections;
                if (result.sections && result.sections.length > 0) $scope.sectionWiseQuestions = result.sections;
                _.each($scope.formatQuestion.allQuestions, function (data, index) {
                    data.color = getColor(index);
                });
                if (result.basic_details[0].time) {
                    if (!$scope.is_qp_type_lW) {
                        $scope.hour = result.basic_details[0].time.hour;
                        $scope.min = result.basic_details[0].time.min;
                    }
                }
                localStorageService.set('theme_id', result.theme_id);
                $scope.$apply();

                $scope.goToArchive = function () {

                    var searchFilters = [];
                    var authoring = academics;
                    searchFilters.push({
                        type: 'curriculum',
                        value: {
                            _id: authoring.curriculum_id,
                            name: authoring.curriculum
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: 'class',
                        value: {
                            _id: authoring.class_id,
                            name: authoring.class
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: 'subject',
                        value: {
                            _id: authoring.subject_id,
                            name: authoring.subject
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: "tab",
                        value: {
                            _id: "question",
                            name: "Questions"
                        },
                        deletable: false,
                        visible: false
                    });
                    var details = {
                        searchFilters: searchFilters,
                        previousState: {
                            state: 'formatQuestion',
                            params: $state.params
                        },
                        isMultiSelect: true,
                        isPractice: $scope.practice_qn,
                        activeTab: "question",
                        resourceType: {
                            _id: "question",
                            name: "Questions"
                        },
                        basic_details: $scope.qp_doc.basic_details[0]
                    };
                    archiveService.setRedirectJson(details);
                    localStorageService.set('academicDetails', academics);
                    $state.go("archives");
                };
            }
        });
    };

    //})

    /*
     * Function to delete question from qp
     * 
     * @question : Object - Details of question
     * 
     * @return : Null
     *
     */
    $scope.deleteQuestion = function (questionId, sectionId) {

        var confirm = $mdDialog.confirm().textContent('Do you want to delete this question?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {

            var obj = {
                qp_id: qpId,
                question_id: questionId,
                section_id: sectionId
            };
            authService.callAPI(activityCons.API_DELETE_QUESTION, "POST", obj, function (response) {
                if (response.result) {
                    //Number - Count of section without questions
                    var secEmptyCount = 0;

                    _.each($scope.formatQuestion.allQuestions, function (section, index) {

                        //Number - index of question which need to be removed
                        var quesIndex = section.questions.findIndex(function (i) {
                            return i._id === questionId;
                        });
                        if (quesIndex !== -1) {
                            section.questions.splice(quesIndex, 1);
                        }
                        if (section.questions.length === 0) {
                            secEmptyCount++;
                        }
                    });
                    toastr.success("Question deleted successfully");
                    //  if no questions, redirect to create page by varun 8-8-2018
                    if (secEmptyCount === $scope.formatQuestion.allQuestions.length) {
                        $state.go("createActivity", {
                            qpId: qpId
                        });
                    }
                    $scope.$apply();
                } else {
                    console.log("error : " + response.error);
                    console.log(response.error);
                }
            });
        }, function () {});
    };
    function gotoEditPage(question) {
        localStorageService.set("createQuesiton", {
            state: "tactivity",
            qp_id: qpId,
            question_id: question._id,
            qp_title: $scope.qp_title,
            activity_id: $scope.activityId,
            theme_id: localStorageService.get('theme_id'),
            class_id: academics.class_id,
            curriculum_id: academics.curriculum_id,
            subject_id: academics.subject_id,
            batch_id: academics.batch_id,
            session_id: academics.session_id,
            school_id: academics.school_id,
            practice_qn: $scope.practice_qn,
            academic_year: localStorageService.get("activeAcdYear"),
            isQuestionAvailable: true
        });
        $state.go("createQuestion");
    }
    function showCreateDuplicateConfirm(question, event) {
        var confirm = $mdDialog.confirm({
            targetEvent: event,
            onComplete: function afterShowAnimation() {
                var $dialog = angular.element(document.querySelector('md-dialog'));
                var $actionsSection = $dialog.find('md-dialog-actions');
                var $cancelButton = $actionsSection.children()[0];
                var $confirmButton = $actionsSection.children()[1];
                angular.element($confirmButton).addClass('md-raised');
                angular.element($cancelButton).addClass('md-raised');
            }
        }).textContent('This is an approved question.Do you want to create a copy and continue?').ok('Continue').cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
            var obj = {
                qp_id: $state.params.qpId,
                school_id: academics.school_id,
                question_id: question._id,
                question: question
            };
            authService.callAPI("/v0/activity/create/duplicate/question", "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.dupeQb) {
                    var dupe_question = response.result.data.dupeQb;
                    gotoEditPage(dupe_question);
                } else {
                    gotoEditPage(question);
                }
            });
        }, function () {
            toastr.info("You cancelled the process");
        });
    }
    function checkQuestionStatus(question, event) {
        var obj = {
            qp_id: $state.params.qpId,
            school_id: academics.school_id,
            question_id: question._id
        };
        authService.callAPI("/v0/activity/questions/archivestatus", "POST", obj, function (response) {
            if (response.result) {
                if (response.result.data) {
                    gotoEditPage(question);
                } else {
                    showCreateDuplicateConfirm(question, event);
                }
            } else {
                gotoEditPage(question);
            }
        });
    }
    /*
     * Function to edit question from qp
     * 
     * @question : Object - Details of question
     * 
     * @return : Null
     *
     */
    $scope.editQuestion = function (question, event) {
        checkQuestionStatus(question, event);
    };
    /*
     * Function to auto format qp
     * 
     * @return : Null
     *
     */
    $scope.autoformat = function (ev) {
        //String - Name of the theme
        if (!validateMinQuesAF()) {
            var str = "Minimum " + _LW_WT_INFO.MAX_QUES + " questions required for Auto format.";
            showErrAlert(ev, str);
            return false;
        }
        var obj = {
            qp_id: $state.params.qpId,
            is_practice: $scope.practice_qn,
            user_id: userId,
            temp_sections: angular.copy($scope.formatQuestion.allQuestions),
            is_qp_type_lW: $scope.is_qp_type_lW
        };
        authService.callAPI(activityCons.API_AUTO_FORMAT, "POST", obj, function (response) {
            if (response.result) {
                try {
                    autoApprove(function (res) {
                        $state.go('qpSummary', {
                            qpId: qpId
                        });
                    });
                } catch (e) {
                    console.log(e);
                    gotQpPreview();
                }
            } else {
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
    };

    $scope.onSetPolicy = function () {
        if ($scope.attendQues > $scope.allQues) $scope.attendQues = $scope.allQues;
    };
    $scope.changeStatus = function (status) {
        if (status) {
            $scope.isIndividualMark = true;
            $scope.allQues = $scope.sectionFormat.length;
            $scope.attendQues = $scope.allQues;
            //Fixed bug #6220
            //Developer- Raziya
            if ($scope.sectionFormat) {
                _.each($scope.sectionFormat, function (eachQues) {
                    if (isNaN(eachQues.qn_mark)) eachQues.qn_mark = undefined;
                });
            }
        } else {
            $scope.isIndividualMark = false;
        }
    };

    $scope.moveQuestion = function (ev, eachQues, index) {
        var questData = [];
        var max_err = 0;
        _.each($scope.formatQuestion.allQuestions, function (sections) {
            if (sections.name == eachQues.type) {
                if (index > -1) {
                    if (validateMaxQues()) {
                        sections.questions.splice(index, 1);
                        $scope.sectionFormat.push(eachQues);
                        $timeout(function () {
                            $scope.formatToLatex();
                        });
                    } else {
                        max_err++;
                        return;
                    }
                }
            }
        });
        if (max_err) {
            // toastr.error("Only " + _LW_WT_INFO.MAX_QUES + " questions can be added.")
            var str = "Only " + _LW_WT_INFO.MAX_QUES + " questions can be added.";
            showErrAlert(ev, str);
        }
        $scope.allQues = $scope.sectionFormat.length;
        $scope.attendQues = $scope.allQues;
        set1Mark();
    };

    $scope.moveFromSection = function (eachQues, index) {
        var questData = $scope.sectionFormat[index];
        var isTypeExists = false;
        if (!$scope.formatQuestion.allQuestions) $scope.formatQuestion.allQuestions = [];
        if ($scope.formatQuestion.allQuestions.length > 0) {
            _.each($scope.formatQuestion.allQuestions, function (sections) {
                if (sections.name == eachQues.type) {
                    sections.questions.push(questData);
                    isTypeExists = true;
                }
            });
        }
        if (!isTypeExists) {
            var secIndex = $scope.formatQuestion.allQuestions.length;
            var newSection = {
                name: eachQues.type,
                questions: [questData],
                color: getColor(secIndex)
            };
            $scope.formatQuestion.allQuestions.push(newSection);
        }
        if (index > -1) {
            $scope.sectionFormat.splice(index, 1);
        }
        $timeout(function () {
            $scope.formatToLatex();
        });
        $scope.allQues = $scope.sectionFormat.length; // to get total question in each section
        $scope.attendQues = $scope.allQues;
        var total = 0;
        if ($scope.allQues === 0) {
            $scope.markForEach = 0;
            $scope.sectionName = "";
            $scope.sectionInstruction = "";
        }
        var obj = {
            qp_id: $state.params.qpId,
            is_practice: $scope.practice_qn,
            user_id: userId,
            time: {
                hour: $scope.hour,
                min: $scope.min
            },
            total_mark: total,
            //total_questions: totalQuestions,
            title: $scope.qp_title,
            sections: angular.copy($scope.sectionWiseQuestions),
            temp_sections: angular.copy($scope.formatQuestion.allQuestions)
        };
        authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, function (response) {
            if (response.result && response.result) {}
        });
        set1Mark();
    };

    $scope.moveFromCreatedSection = function (eachQues, index) {
        if ($scope.sectionFormat && $scope.sectionFormat.length > 0) toastr.error("You have already selected one section");else {
            $scope.sectionData = angular.copy($scope.sectionWiseQuestions);
            $scope.sectionFormat = eachQues.questions;
            $scope.sectionName = eachQues.name;
            $scope.sectionInstruction = eachQues.instruction;
            $scope.attendQues = eachQues.mandatory_no;
            $scope.allQues = eachQues.qn_no;
            $scope.markForEach = eachQues.mark_each_qn;
            if (eachQues.mark_each_qn > 0) $scope.checkStatus = false;else $scope.checkStatus = true;
            $scope.changeStatus($scope.checkStatus);
            $scope.sectionWiseQuestions.splice(index, 1);
            $timeout(function () {
                $scope.formatToLatex();
            });
        }
    };
    //To cancel editing section 
    $scope.closeSection = function () {
        if ($scope.sectionData.length > 0 && $scope.sectionFormat.length > 0) $scope.sectionWiseQuestions = $scope.sectionData;
        $scope.errors = {};
        $scope.sectionName = "";
        $scope.sectionInstruction = "";
        $scope.markForEach = 0;
        $scope.attendQues = 0;
        $scope.allQues = 0;
        $scope.checkStatus = false;
        $scope.changeStatus($scope.checkStatus);
        $scope.sectionFormat = [];
    };
    $scope.createSection = function (ev) {
        $scope.errors = {};
        var error = false;
        if (!$scope.isPractice) {
            if ($scope.hour === undefined || $scope.hour === "" || $scope.min === "" || $scope.min === undefined) {
                $scope.errors['hour'] = "time is required";
                error = true;
            }
        }
        if ($scope.sectionName === undefined || $scope.sectionName === "") {
            $scope.errors['sectionName'] = "Section Name is required.";
            error = true;
        }
        if ($scope.sectionInstruction === undefined || $scope.sectionInstruction === "") {
            $scope.errors['sectionInstruction'] = "Instruction is required.";
            error = true;
        }
        if ($scope.sectionFormat.length === 0) {
            $scope.errors['selectQuestion'] = "Please add atleast one question.";
            error = true;
        }
        if (!$scope.isIndividualMark) {
            if ($scope.markForEach === undefined || $scope.markForEach === "") {
                $scope.errors['markForEach'] = "Enter mark for each question";
                error = true;
            }
            if ($scope.markForEach == 0) {
                $scope.errors['markForEach'] = "Mark should be greater than 0";
                error = true;
            }
            //To save mark to each question
            if ($scope.markForEach > 0) {
                _.each($scope.sectionFormat, function (eachQues) {
                    eachQues.qn_mark = $scope.markForEach;
                });
            }
        }

        if ($scope.isIndividualMark) {
            //Bug  #6132 -start
            $scope.markForEach = 0;
            //Bug  #6132 -end

            _.each($scope.sectionFormat, function (eachQues) {
                if (eachQues.qn_mark) {
                    if (eachQues.qn_mark == 0) {
                        eachQues['qn_mark_error'] = true;
                        toastr.error("Mark should be greater than 0");
                        error = true;
                    } else eachQues['qn_mark_error'] = false;
                }
                if (!eachQues.qn_mark || eachQues.qn_mark === null || eachQues.qn_mark === undefined || eachQues.qn_mark === "") {
                    eachQues['qn_mark_error'] = true;
                    toastr.error("Please enter mark for all questions");
                    error = true;
                } else eachQues['qn_mark_error'] = false;
            });
        }
        $scope.sectionFormat['is_individual_mark'] = $scope.checkStatus;
        if ($scope.attendQues === undefined || $scope.attendQues === "") {
            $scope.errors['attendQues'] = "Enter policy";
            error = true;
        }
        if ($scope.attendQues === 0) {
            $scope.errors['markForEach'] = "Please add atleast one question";
            error = true;
        }
        _.each($scope.sectionWiseQuestions, function (section) {
            if (section.name === $scope.sectionName) {
                $scope.errors['sectionName'] = "Section name already exsits";
                error = true;
            }
        });
        console.log($scope.errors);
        console.log(error);
        if (!error) {
            var reference = {};
            if (checkMaxMarks(reference, false)) {
                $scope.sectionWiseQuestions.push({
                    'name': $scope.sectionName,
                    'instruction': $scope.sectionInstruction,
                    'mark_each_qn': $scope.markForEach,
                    'mandatory_no': $scope.attendQues,
                    'qn_no': $scope.allQues,
                    'questions': $scope.sectionFormat
                });
                var obj = {
                    qp_id: $state.params.qpId,
                    is_practice: $scope.practice_qn,
                    user_id: userId,
                    time: {
                        hour: $scope.hour,
                        min: $scope.min
                    },
                    title: $scope.qp_title,
                    sections: angular.copy($scope.sectionWiseQuestions),
                    temp_sections: angular.copy($scope.formatQuestion.allQuestions),
                    update_to_create_status: true
                };

                authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, function (response) {
                    if (response.result && response.result) {}
                });
                $scope.sectionFormat = [];
                $scope.sectionName = "";
                $scope.sectionInstruction = "";
                $scope.markForEach = 0;
                $scope.attendQues = 0;
                $scope.allQues = 0;
                $scope.checkStatus = false;
                $scope.changeStatus($scope.checkStatus);
            } else {
                var str = "Activity total marks exceeded " + _LW_WT_INFO.MAX_MARK + " marks.";
                if (reference && reference._total_marks) {
                    str = "Activity total marks exceeded " + _LW_WT_INFO.MAX_MARK + "." +
                    //  ".Now " +
                    // "it is "+ reference._total_marks +
                    // " marks." +
                    " Please reduce the number of questions or marks.";
                }
                // toastr.error(str)
                showErrAlert(ev, str);
            }
        }
    };

    var calIndex = function calIndex(index, length) {
        if (index >= length) {
            if (index - length >= length) return calIndex(index - length, length);else return index - length;
        } else return index;
    };

    var getColor = function getColor(index) {
        var colorArr = ['#2ab4c0', '#1bbc9b', '#f3c200', '#e7505a'];
        var i = calIndex(index, colorArr.length);
        return colorArr[i];
    };
    _.each($scope.formatQuestion.allQuestions, function (data, index) {
        data.color = getColor(index);
    });
    // $scope.formatQuestion.addedQuestions = [];
    $scope.toggleExpansion = function (accordianData, data, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !data.expanded;
        });
        $scope.formatToLatex();
    };

    $scope.formatToLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('question_desc');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
            var choiceElements = document.getElementsByClassName('choice-desc');
            _.each(choiceElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.preview = function (ev) {

        var obj = {
            qp_id: $state.params.qpId,
            user_id: userId,
            title: $scope.qp_title,
            is_practice: $scope.practice_qn,
            time: {
                hour: $scope.hour,
                min: $scope.min
            },
            sections: angular.copy($scope.sectionWiseQuestions) ? angular.copy($scope.sectionWiseQuestions) : [],
            temp_sections: $scope.formatQuestion.allQuestions ? angular.copy($scope.formatQuestion.allQuestions) : []
        };
        $scope.errors = {};
        var error = false;
        // if ($scope.hour === undefined || $scope.hour === "" || $scope.hour === "00") {
        //     if ($scope.min === undefined || $scope.min === "" || $scope.min === "00") {
        //         $scope.errors['time'] = "time is required";
        //         error = true
        //     }
        // }
        if ($scope.hour === undefined || $scope.hour === "" || $scope.min === undefined || $scope.min === "") {
            if (!$scope.practice_qn) {
                $scope.errors['time'] = "Time is required";
                error = true;
            }
        }
        if ($scope.sectionFormat && $scope.sectionFormat.length > 0) {
            toastr.warning("Please save the changes.");
            error = true;
        }
        if (!error) {
            if (!validateMinQues()) {
                var str = "Number of questions should be  " + _LW_WT_INFO.MIN_QUES + ".";
                showErrAlert(ev, str);
                return false;
            }
            var reference = {};
            if (checkMaxMarks(reference, true)) {
                authService.callAPI(activityCons.API_SAVE_SECTION, "POST", obj, function (response) {
                    if (response.result && response.result) {
                        try {
                            autoApprove(function (res) {
                                if (res) {
                                    $state.go('qpSummary', {
                                        qpId: qpId
                                    });
                                }
                            });
                        } catch (e) {
                            console.log(e);
                            gotQpPreview();
                        }
                    }
                });
            } else {
                var _str = "" + _LW_WT_INFO.MAX_MARK + " marks";
                if (reference && reference._total_marks) {
                    _str = "Activity total marks should be " + _LW_WT_INFO.MAX_MARK + ".Now " + "it is " + reference._total_marks + " marks.";
                }
                // toastr.error(str)
                showErrAlert(ev, _str);
            }
        }
    };
    function autoApprove(callBack) {
        if (!$scope.auto_wrapup) {
            gotQpPreview();
        } else {
            authService.callAPI("/v0/auto/approve/wrapup/qp", "POST", qpDet, function (response) {
                console.log(response.result);
                if (response.result && response.result.data) {
                    try {
                        if (response.result.data.details) {
                            callBack(true);
                        } else {
                            // toastr.warning("Cannot approve")
                            gotQpPreview();
                        }
                    } catch (e) {
                        console.log(e);
                        gotQpPreview();
                    }
                }
            });
        }
    }
    function gotQpPreview() {
        $state.go('activityPreview', {
            qpId: $state.params.qpId
        });
    }
    $scope.routeToCreateQuestion = function () {
        if (academics) {
            academics['is_qp_type_lW'] = $scope.is_qp_type_lW;
        }
        localStorageService.set('academicDetails', academics);
        localStorageService.set("createQuesiton", {
            state: "tactivity",
            qp_id: qpId,
            qp_title: $scope.qp_title,
            activity_id: $scope.activityId,
            theme_id: localStorageService.get('theme_id'),
            class_id: academics.class_id,
            curriculum_id: academics.curriculum_id,
            subject_id: academics.subject_id,
            batch_id: academics.batch_id,
            session_id: academics.session_id,
            school_id: academics.school_id,
            practice_qn: $scope.practice_qn,
            academic_year: localStorageService.get("activeAcdYear"),
            isQuestionAvailable: true,
            is_qp_type_lW: $scope.is_qp_type_lW
        });
        $state.go("createQuestion", {
            isPractice: $scope.practice_qn
        }, {
            reload: true
        });
    };
    $scope.validateMark = function () {
        if ($scope.markForEach && $scope.markForEach > 100) $scope.markForEach = 0;
    };
    $scope.addQnMark = function (eachQues) {
        if (eachQues.qn_mark > 0) eachQues['qn_mark_error'] = false;
    };

    //Added for dragging sections
    //developer - Raziya
    $scope.sortableOptions = {
        containment: '#sortable-container'
    };
    $scope.dragControlListeners = {
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        },
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {},
        containment: '#board', //optional param.
        containerPositioning: 'relative',
        clone: false, //optional param for clone feature.
        allowDuplicates: false //optional param allows duplicates to be dropped.
    };
    $scope.sortableOptions1 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart(event, ui) {
            // let id = "sortFirst_" + event.source.index
            // document.getElementById(id).style.background = 'blue'
        },
        dragEnd: function dragEnd() {},
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {

            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        }
    };
    $scope.sortableOptions2 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {},
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        }
    };
    function checkMinsDiff(min, basic_details) {
        var time = basic_details.time ? basic_details.time : {};
        if (min != time.min) {
            $scope.updateQpToCreatedStatus();
        }
    }
    function checkHourDiff(hour, basic_details) {
        var time = basic_details.time ? basic_details.time : {};
        if (hour != time.hour) {
            $scope.updateQpToCreatedStatus();
        }
    }
    $scope.onSelectChange = function (field, value) {
        if ($scope.qp_doc) {
            switch (field) {
                case "min":
                    checkMinsDiff(value, $scope.qp_doc.basic_details[0]);
                    break;
                case "hour":
                    checkHourDiff(value, $scope.qp_doc.basic_details[0]);
                    break;
            }
        }
    };
    $scope.updateQpToCreatedStatus = function () {
        if (qpId) {
            var obj = {
                qp_id: qpId
            };
            try {
                authService.callAPI("/v0/set/qp/status/created", "POST", obj, function (response) {
                    try {} catch (e) {
                        console.log(e);
                    }
                });
            } catch (er) {
                console.log(er);
            }
        }
    };
    $scope.request_sent = false;
    $scope.shuffleOneSection = function (section, index) {
        if (qpId && section) {
            var obj = {
                qp_id: qpId,
                section: section,
                index: index
            };
            $scope.request_sent = true;
            try {
                authService.callAPI("/v0/qp/shuffle/selected/section", "POST", obj, function (response) {
                    try {
                        if (section.is_shuffle) {
                            toastr.success("Selected shuffle option for the section");
                        } else {
                            toastr.success("Deselected shuffle option for the section");
                        }
                    } catch (e) {
                        console.log(e);
                        toastr.error("Network error");
                    }
                    $scope.request_sent = false;
                    $scope.$apply();
                });
            } catch (er) {
                console.log(er);
                $scope.request_sent = false;
                $scope.$apply();
            }
        }
    };
}];

exports.default = FormatQuestionController;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _questionMetaData = __webpack_require__(169);

var _questionMetaData2 = _interopRequireDefault(_questionMetaData);

var _html2canvas = __webpack_require__(82);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _addsectionComment = __webpack_require__(646);

var _addsectionComment2 = _interopRequireDefault(_addsectionComment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: activityPreview.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-13
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var ActivityPreviewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "$timeout", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", function ActivityPreviewController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, $timeout, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
    _classCallCheck(this, ActivityPreviewController);

    this.writeNote = false;
    this.scope = $scope;
    this.state = $state;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.pdfData = false;
    $scope.dont_show_metadata_icon = false;
    var fromApproverList = localStorageService.get('fromApproverList');
    var academics = localStorageService.get('authoringData');
    if (academics === undefined) $state.go('dashboard');
    var userId = localStorageService.get('user_id');
    $scope.user_id = userId;
    //String - Activity id
    //$scope.qpId = $state.params.qpId
    var qpId = $state.params.qpId;

    //Boolean - Whether to show or hide close button
    $scope.isShowClose = localStorageService.get("isViewAllQuestion");
    $scope._toContinueCreation = false;
    //localStorageService.clear("isViewAllQuestion")

    //Boolean - To make activity password field visible
    $scope.isPassword = false;

    $scope.isCreator = false;
    $scope.isConducted = false;
    $scope.isLoading = true;

    var schoolId = academics.school_id;
    $scope.class = academics.class;
    $scope.curriculum = academics.curriculum;

    $scope.convertedURLAnswer = {};
    $scope.convertedURLQuestion = {};
    $scope.file_server_url = CONSTANTS.FILE_UPLOAD_URL;
    $scope.question_ids = [];
    $scope.section_ids = [];
    $scope.chartUrl = 'https://chart.googleapis.com/chart?cht=tx&chf=bg,s,FFFFFF00&chl=';
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    var fieldAlignment = function fieldAlignment(eachQues) {
        if (eachQues.questionImg && eachQues.questionImg.length) {
            convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.questionImg, function (base64Image) {
                $scope.imgurl2 = base64Image;
                eachQues.qn_img_url = $scope.imgurl2;
            });
        }
        if (eachQues.qn_img_array && eachQues.qn_img_array.length) {
            eachQues.qn_img_urlarray = [];
            _.each(eachQues.qn_img_array, function (eachQnImage) {
                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function (base64Image) {
                    eachQues.qn_img_urlarray.push(base64Image);
                });
            });
        }
        if (eachQues.choice && eachQues.choice.length > 0) {
            _.each(eachQues.choice, function (eachChoice) {
                eachChoice.opt_image_url = [];
                _.each(eachChoice.optImage, function (eachOptImage) {
                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function (base64Image) {
                        eachChoice.opt_image_url.push(base64Image);
                    });
                });
                _.each(eachChoice.opt_img, function (eachOptImage) {
                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function (base64Image) {
                        eachChoice.opt_image_url.push(base64Image);
                    });
                });
            });
        }
        if (eachQues.isLatex) {
            if (eachQues.optionQuestion && eachQues.optionQuestion.length && eachQues.optionAnswer && eachQues.optionAnswer.length) {
                _.each(eachQues.optionQuestion, function (ques) {
                    var latexValue = encodeURIComponent(ques.desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        ques.latexDesc = base64Image;
                    });
                });
                _.each(eachQues.optionAnswer, function (ans) {
                    var latexValue = encodeURIComponent(ans.desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        ans.latexDesc = base64Image;
                    });
                });
            } else {
                var latexValue = encodeURIComponent(eachQues.qn_desc);
                var urlsec = $scope.chartUrl + latexValue;
                getDataUri(urlsec, function (base64Image) {
                    eachQues.latexQues = base64Image;
                });
                _.each(eachQues.choice, function (eachQnchice, index) {
                    var latexValue = encodeURIComponent(eachQues.choice[index].desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        eachQues.choice[index].latexDesc = base64Image;
                    });
                });
            }
        }
    };

    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    if (qpId) {
        authService.callAPI(activityCons.API_ACTIVITY_PREVIEW + qpId, "POST", {}, function (response) {
            if (response.result && response.result.status && response.result.data.details && response.result.data.details.length > 0) {
                var result = response.result.data.details[0];
                $scope.allQuestions = result;
                $scope.qpDetails = result.qp_details[0];
                $scope.qpId = result.qp_details[0]._id;
                $scope._toContinueCreation = ifTrackerCheckQnos();
                if ($scope.qpDetails.status === 'conducted' || $scope.qpDetails.status === 'published' || $scope.qpDetails.status === 'completed') $scope.isConducted = true;
                if ($scope.qpDetails.teacher_id === _userId) $scope.isCreator = true;
                var question_ids = [],
                    section_ids = [],
                    cnt_s = 1;
                _.each($scope.allQuestions.sections, function (eachSection) {
                    eachSection['sc_index'] = cnt_s;
                    cnt_s++;
                    section_ids.push(eachSection._id.section_id);
                    _.each(eachSection.questions, function (eachQues) {
                        question_ids.push(eachQues._id);
                        if (eachQues.type == 'passage') {
                            _.each(eachQues.questions, function (ibtQues) {
                                fieldAlignment(ibtQues);
                            });
                        } else {
                            if (eachQues.type === 'MTF') $scope.shuffleOptions(eachQues);
                            fieldAlignment(eachQues);
                        }

                        if (eachQues.passage_image && eachQues.passage_image.length) {
                            convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.passage_image, function (base64Image) {
                                $scope.imgurl3 = base64Image;
                                eachQues.passage_image_url = $scope.imgurl3;
                                _.defer(function () {
                                    $scope.$apply();
                                });
                            });
                        }
                        if (eachQues.image && eachQues.image.length) {
                            eachQues.passage_image_arrayUrl = [];
                            _.each(eachQues.image, function (eachQnImage) {
                                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function (base64Image) {
                                    eachQues.passage_image_arrayUrl.push(base64Image);
                                    _.defer(function () {
                                        $scope.$apply();
                                    });
                                });
                            });
                        }
                        if (eachQues.optionAnswer && eachQues.optionAnswer.length > 0) {
                            _.each(eachQues.optionAnswer, function (eachChoice, index) {
                                if (eachChoice.optImage) {
                                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.optImage, function (base64Image) {
                                        eachQues.optionAnswer[index].answerimage = base64Image;
                                        _.defer(function () {
                                            $scope.$apply();
                                        });
                                    });
                                }
                            });
                        }
                        if (eachQues.optionQuestion && eachQues.optionQuestion.length > 0) {
                            _.each(eachQues.optionQuestion, function (eachChoice, index) {
                                if (eachChoice.questionImg) {
                                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.questionImg, function (base64Image) {
                                        eachQues.optionQuestion[index].questionimage = base64Image;
                                        _.defer(function () {
                                            $scope.$apply();
                                        });
                                    });
                                }
                            });
                        }
                    });
                });
                $timeout(function () {
                    $scope.loadLatex();
                });
                $scope.question_ids = question_ids;
                $scope.section_ids = section_ids;
                $scope.isLoading = false;
                $scope.$apply();
            }
        });
        // RabbitMQ Push API ..............
        var _userId = localStorageService.get('user_id');
        var _schoolId = localStorageService.get('school_id');
        authService.callAPI("/v0/rabbitmqpush/" + _userId + "/" + _schoolId + "/QusestionPaper_View", "GET", {}, function (response) {
            // console.log(response)
        });
        // RabbitMQ push API end .............
    }
    var ifTrackerCheckQnos = function ifTrackerCheckQnos() {
        console.log($scope.allQuestions);
        var LO_ID = "learning_outcome";
        var WT_ID = "wrapup_test";
        var MAX_QN = 10;
        var _QP_TYPES = [LO_ID, WT_ID];
        var ret = true;
        try {
            var ALLOW_STATUSES = ["published", "completed", "conducted"];
            var qp_details = $scope.allQuestions.qp_details[0];
            var sections = $scope.allQuestions.sections;
            if (qp_details && qp_details.qp_type && qp_details.qp_type.activity_type && qp_details.teacher_id == $scope.user_id) {
                if (_QP_TYPES.indexOf(qp_details.qp_type.activity_type) !== -1) {
                    if (ALLOW_STATUSES.indexOf(qp_details.status) === -1) {
                        if (sections && sections.length) {
                            var all_qbs = _.pluck(sections, "questions");
                            if (all_qbs && all_qbs.length) {
                                var qLen = _.flatten(all_qbs).length;
                                if (qLen != MAX_QN) {
                                    ret = false;
                                }
                            }
                        }
                    }
                }
            }
            return ret;
        } catch (e) {
            console.log(e);
            return ret;
        }
    };
    $scope.gotoQpPreview = function () {
        if (fromApproverList) {
            $state.go('activityApprovalsList');
        } else {
            if (academics.from_all_activity) {
                history.back();
            } else {
                $state.go('qpSummary', {
                    qpId: qpId
                });
            }
        }
    };

    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.qpHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'subject': academics.subject,
                'class': academics.class
            };
            convertFileToDataURLviaFileReader($scope.qpHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        } else {
            //error
        }
    });
    function showMetadataPopUp(metadata, question) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'metadata', 'question', '$sce', questionMetadataCtrl],
            locals: {
                "metadata": metadata,
                question: question,
                $sce: $sce

            },
            template: _questionMetaData2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    }
    $scope.getmetadata = function (oneQuestion) {
        console.log(oneQuestion);
        var obj = {
            "args": {
                "qpId": qpId,
                "question_id": oneQuestion._id,
                "school_id": localStorageService.get('school_id'),
                "user_id": userId,
                "teacher_id": userId
            }
        };

        authService.callAPI("/v0/get-question/metadata", "POST", obj, function (response) {
            if (response.result && response.result.status) {
                try {
                    showMetadataPopUp(response.result.data, oneQuestion);
                } catch (e) {
                    console.log(e);
                }
            }
        });
    };

    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };

    $scope.convertURLTotrustUrl = function (url, index, type) {
        if (type == "question") {
            $scope.convertedURLQuestion[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
        } else if (type == 'answer') {
            $scope.convertedURLAnswer[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
        }
    };

    $scope.gotoSectionPage = function () {
        $state.go('formatQuestion', {
            qpId: $scope.qpId
        });
    };

    $scope.saveQuestionPaper = function () {
        var _academicDetails;

        removeQpCopiedHtmlForPdf();
        var academicDetails = (_academicDetails = {
            session_id: academics.session_id,
            curriculum_id: academics.curriculum_id,
            batch_id: academics.batch_id,
            class_id: academics.class_id,
            subject_id: academics.subject_id,
            school_id: academics.school_id,
            class: academics.class,
            batch: academics.batch,
            curriculum: academics.curriculum,
            subject: academics.subject
        }, _defineProperty(_academicDetails, 'class', academics.class), _defineProperty(_academicDetails, 'session', academics.session), _defineProperty(_academicDetails, 'user_id', userId), _defineProperty(_academicDetails, 'qp_id', qpId), _academicDetails);
        authService.callAPI(activityCons.API_SAVE_QP, "POST", academicDetails, function (response) {
            if (response.result && response.result.status) {
                toastr.success("Question Paper Saved Successfully");
            }
        });
    };
    function getShuffledOPtByTeacher(editQuestion) {
        var shuffled_options = editQuestion.shuffled_options;
        return shuffled_options;
    }
    /*
    * Function To suffle match
    * @eachQues - MTF
    * @developer - Arul Mozhi J
    */
    $scope.shuffleOptions = function (eachQues) {
        eachQues.choiceData = eachQues.option;
        var optionQuestion = [];
        var optionAnswer = [];
        _.each(eachQues.option, function (eachOption) {
            optionQuestion.push(eachOption.question);
            optionAnswer.push(eachOption.answer);
        });
        if (!eachQues.auto_shuffle && eachQues.shuffled_options && eachQues.shuffled_options.length) {
            optionAnswer = getShuffledOPtByTeacher(eachQues);
        }
        //To shuffle match the following answers
        // optionAnswer = _.shuffle(optionAnswer)
        eachQues.optionQuestion = optionQuestion;
        eachQues.optionAnswer = optionAnswer;
    };
    $scope.addPassword = function () {
        $scope.isPassword = true;
    };

    $scope.beautifyFIB = function (question) {
        return question ? question.replace(/_/g, " _______ ") : '';
    };

    $scope.closePasswordDiv = function () {
        $scope.isPassword = false;
    };

    /*
     * To set password to an activity
     * 
     *  @data : String - activity password
     * 
     * @return : null
     */
    $scope.saveActivityPassword = function (activityPassword) {
        if (activityPassword === "" || activityPassword === null || activityPassword === undefined) toastr.error("Please enter password");else {
            authService.callAPI(activityCons.API_SAVE_PASSWORD + qpId + '/' + userId + '/' + activityPassword, "POST", {}, function (response) {
                if (response.result && response.result.status) {
                    toastr.success("Activity password saved successfully");
                }
            });
            $scope.isPassword = false;
        }
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    function getDataUri(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }
    function sendBase64ToSever(_base64_images) {
        var obj = {
            qpHeader: $scope.qpHeader,
            qpDetails: $scope.qpDetails,
            academics: academics,
            school_id: schoolId,
            _base64_images: _base64_images,
            allQuestions: $scope.allQuestions
            // return false
        };authService.callAPI("/v0/traditional/activity/pages/pdf/export", "POST", obj, function (response) {
            // console.log(response)
            try {
                if (response.result && response.result.data) {
                    for (var _i = 0; _i < $scope.section_ids.length; _i++) {
                        var one_id = "#group_" + $scope.section_ids[_i];
                        var element = document.getElementById(one_id);
                        if (element) {
                            element.remove();
                        }
                    }
                    $('.my-class').html('');
                    $scope.pdfData = true;
                    $scope.url = $sce.trustAsResourceUrl(response.result.data.details);
                }
                $scope.isLoadingPdf = false;
                $scope.dont_show_metadata_icon = false;
            } catch (e) {
                console.log(e);
                removeQpCopiedHtmlForPdf();
            }

            $scope.$apply();
        });
    }
    var removeQpCopiedHtmlForPdf = function removeQpCopiedHtmlForPdf() {
        $('.my-class').html('');
    };
    this.$onDestroy = function () {
        removeQpCopiedHtmlForPdf();
    };
    $scope.backToHtml = function () {
        $scope.pdfData = false;
        $scope.dont_show_metadata_icon = false;
        try {
            $timeout(function () {
                try {
                    $scope.loadLatex();
                } catch (e1) {
                    console.log(e1);
                }
            });
        } catch (error) {
            console.log(error);
        }
    };
    function dontShowMetsIcon() {
        $scope.dont_show_metadata_icon = true;
    }
    $scope.generateQuestionsAsImages = function () {
        dontShowMetsIcon();
        removeQpCopiedHtmlForPdf();
        $timeout(function () {
            var _base64_images = [];
            $scope.isLoadingPdf = true;
            var len = $scope.section_ids.length;

            var _loop = function _loop(_i2) {
                var one_id = "#group_" + $scope.section_ids[_i2];
                if (one_id) {
                    try {
                        var targetDom = document.querySelector(one_id);
                        var copyDom = targetDom.cloneNode(true);
                        document.body.appendChild(copyDom);
                        copyDom.classList.add("my-class");
                        (0, _html2canvas2.default)(copyDom, { logging: false, letterRendering: 1,
                            allowTaint: false, useCORS: true }).then(function (canvas) {
                            try {
                                var img = canvas.toDataURL("image/png");
                                if (img) {
                                    _base64_images.push({
                                        index: parseInt(_i2) + 1,
                                        img: img
                                    });
                                    if (len == _base64_images.length) {
                                        sendBase64ToSever(_base64_images);
                                        return;
                                    }
                                }
                            } catch (e1) {
                                console.log(e1);
                                $scope.isLoadingPdf = false;
                                $scope.dont_show_metadata_icon = false;
                            }
                        }).catch(function getError(err) {
                            console.log(err);
                            removeQpCopiedHtmlForPdf();
                            $scope.isLoadingPdf = false;
                            $scope.dont_show_metadata_icon = false;
                        });
                    } catch (e) {
                        console.log(e);
                        $scope.isLoadingPdf = false;
                        removeQpCopiedHtmlForPdf();
                        $scope.$apply();
                    }
                }
            };

            for (var _i2 = 0; _i2 < $scope.section_ids.length; _i2++) {
                _loop(_i2);
            }
        });
    };
    $scope.generatePdf = function () {
        var content = [];
        content.push({
            table: {
                widths: [70, '*', 70],
                body: [[{
                    width: 70,
                    height: 70,
                    image: $scope.imgurl1,
                    rowSpan: '3'
                }, {
                    text: $scope.qpHeader.schoolName,
                    style: 'title'
                }, {}], [{}, {
                    alignment: 'center',
                    text: $scope.qpDetails.question_paper_title
                }, {}], [{}, {
                    alignment: 'center',
                    text: $scope.qpHeader.subject
                }, {}]]
            },
            layout: 'noBorders'
        });
        content.push({
            canvas: [{
                type: 'line',
                x1: 0,
                y1: 10,
                x2: 520,
                y2: 10,
                lineWidth: 0.5
            }]
        });
        content.push("\n");
        var hour = 0;
        var min = 0;
        if ($scope.qpDetails.time.hour) hour = $scope.qpDetails.time.hour;
        if ($scope.qpDetails.time.min) min = $scope.qpDetails.time.min;
        content.push({
            columns: [{
                text: "Time : " + "  " + hour + " hour  " + min + " min"
            }, {
                text: "Curriculum/Class : " + "  " + $scope.curriculum + "/" + $scope.class
            }, {
                text: "Maximum Marks : " + "  " + $scope.qpDetails.total_mark
            }]
        });
        content.push({
            canvas: [{
                type: 'line',
                x1: 0,
                y1: 10,
                x2: 520,
                y2: 10,
                lineWidth: 0.5
            }]
        });
        var sections = angular.copy($scope.allQuestions.sections);
        _.each(sections, function (eachSection) {
            var quesNo = 1;
            content.push("\n");
            var policy = void 0;
            if (eachSection.qn_no === eachSection.mandatory_no) policy = "(Attend All)";else policy = "(Any " + eachSection.mandatory_no + ")";
            var ob = {
                columns: [{
                    text: eachSection.name + " " + policy,
                    alignment: 'center',
                    style: 'sectionTitle'
                }]
            };
            content.push(ob);
            var sectionInsPolicy = {
                columns: [{
                    text: eachSection.instruction + ":",
                    style: 'sectionTitle'
                }]
            };
            content.push(sectionInsPolicy);
            _.each(eachSection.questions, function (eachQues) {
                content.push("\n");
                var obj = void 0;
                var para = void 0;
                if (eachQues.type === "passage") {
                    var paragraphTitle = void 0;
                    if (!eachQues.isLatex) {
                        paragraphTitle = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.title,
                            style: 'boldStyle'
                        }];
                    } else {
                        paragraphTitle = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.title,
                            style: 'boldStyle'
                        }];
                    }
                    content.push({
                        columns: paragraphTitle
                    });
                    content.push("\n");

                    var paragraph = pdfForElement("<p>" + eachQues.desc + "</p>");
                    para = paragraph;
                    content.push(para);
                    content.push("\n");
                    if (eachQues.passage_image_arrayUrl) {
                        _.each(eachQues.passage_image_arrayUrl, function (eachQnImage) {
                            var imgObj = {
                                columns: [{
                                    alignment: 'left',
                                    width: 300,
                                    image: eachQnImage
                                }]

                            };
                            content.push(imgObj);
                            content.push("\n");
                        });
                    }
                    if (eachQues.passage_image_url) {
                        var imgObj = {
                            columns: [{
                                alignment: 'left',
                                width: 300,
                                image: eachQues.passage_image_url
                            }]
                        };

                        content.push(imgObj);
                    }
                    content.push("\n");
                    var ibtQuesNo = 1;
                    _.each(eachQues.questions, function (ibtQues) {
                        if (!ibtQues.isLatex) {
                            if (ibtQues.type === "FIB") {
                                ibtQues.qn_desc = $scope.beautifyFIB(ibtQues.qn_desc);
                            }

                            obj = [{
                                width: '*',
                                alignment: "left",
                                text: quesNo + "." + ibtQuesNo + ". " + ibtQues.qn_desc
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + ibtQues.mark + ")"
                            }];
                        } else {
                            obj = [{
                                width: '*',
                                alignment: "left",
                                text: quesNo + "." + ibtQuesNo + ". " + ibtQues.latexQues
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + ibtQues.mark + ")"
                            }];
                        }
                        content.push(obj);
                        if (ibtQues.qn_img_url) {
                            var _imgObj = {
                                columns: [{
                                    alignment: 'left',
                                    width: 300,
                                    image: ibtQues.qn_img_url
                                }]
                            };
                            content.push(_imgObj);
                            content.push("\n");
                        }
                        if (ibtQues.qn_img_urlarray) {
                            _.each(ibtQues.qn_img_urlarray, function (eachQnImage) {
                                var imgObj = {
                                    columns: [{
                                        alignment: 'left',
                                        width: 300,
                                        image: eachQnImage
                                    }]
                                };
                                content.push(imgObj);
                                content.push("\n");
                            });
                        }
                        if (ibtQues.type === "MCQ") {
                            var ch = [];
                            _.each(ibtQues.choice, function (eachChoice) {
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + eachChoice.tag + ")  " + eachChoice.desc;
                                    content.push({
                                        text: choice
                                    });
                                    content.push("\n");
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function (eachImage) {
                                            var imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            };
                                            content.push(imgObj);
                                            content.push("\n");
                                        });
                                    }
                                } else {
                                    var _choice = "(" + eachChoice.tag + ")  ";
                                    var choiceLatex = [{
                                        text: _choice
                                    }, {
                                        image: eachChoice.latexDesc
                                    }];
                                    content.push(choiceLatex);
                                    content.push("\n");
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function (eachImage) {
                                            var imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            };
                                            content.push(imgObj);
                                            content.push("\n");
                                        });
                                    }
                                }
                            });
                        }

                        /************** LINK QUESTION TO PASSAGE : START - Added by Arul Mozhi J  ****************/
                        if (ibtQues.type === "MTF") {
                            var ch1 = [];
                            _.each(ibtQues.optionQuestion, function (optionQues) {
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + optionQues.tag + ")  " + optionQues.desc;
                                    var chContent = [];
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }]);
                                    }
                                    ch1.push(chContent);
                                } else {
                                    var _choice2 = "(" + optionQues.tag + ")  ";
                                    var _chContent = [];
                                    _chContent.push([{
                                        text: _choice2,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionQues.latexDesc) {
                                        _chContent.push([{
                                            /*text: choice,*/
                                            image: optionQues.latexDesc,
                                            border: [false, false, false, false]
                                        }]);
                                    }
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        _chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }]);
                                    }
                                    ch1.push(_chContent);
                                }
                            });
                            var ch2 = []; // answerimage   questionimage
                            _.each(ibtQues.optionAnswer, function (optionAns, ansIndex) {
                                var choicesl = ansIndex + 1;
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + choicesl + ")  " + optionAns.desc;
                                    var chContent = [];
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }]);
                                    }
                                    ch2.push(chContent);
                                } else {
                                    var _choice3 = "(" + choicesl + ")  ";
                                    var _chContent2 = [];
                                    _chContent2.push([{
                                        text: _choice3,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionAns.latexDesc) {
                                        _chContent2.push([{
                                            image: optionAns.latexDesc,
                                            border: [false, false, false, false]
                                        }]);
                                    }
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        _chContent2.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }]);
                                    }
                                    ch2.push(_chContent2);
                                }
                            });
                            content.push({
                                table: {
                                    widths: ['*', '*', 90],
                                    body: [[{
                                        text: "Question"
                                    }, {
                                        text: "Option"
                                    }, {
                                        text: "Answer"
                                    }]]

                                }
                            });

                            for (i = 0; i < ch1.length; i++) {
                                var tableContent = [];
                                tableContent.push({
                                    table: {
                                        body: ch1[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({
                                    table: {
                                        body: ch2[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({});
                                content.push({
                                    table: {
                                        widths: ['*', '*', 90],
                                        body: [tableContent]
                                    }
                                });
                            }
                        }
                        if (ibtQues.type === "TF") {
                            var _ch = [];
                            _ch.push({
                                text: "(A) True"
                            });
                            _ch.push({
                                text: "(B) False"
                            });

                            content.push({
                                columns: _ch
                            });
                        }
                        /************** LINK QUESTION TO PASSAGE : END - Added by Arul Mozhi J  ****************/
                        ibtQuesNo = ibtQuesNo + 1;
                    });
                } else if (eachQues.type === "ASLLISTEN") {
                    obj = [{
                        width: 'auto',
                        alignment: "left",
                        text: quesNo + "."
                    }, {
                        width: 500,
                        text: eachQues.qn_desc + "(ASL)"
                    }, {
                        width: 'auto',
                        alignment: "right",
                        text: "(" + eachQues.mark + ")"
                    }];
                } else if (eachQues.type === "ASLSPEAK") {
                    obj = [{
                        width: 'auto',
                        alignment: "left",
                        text: quesNo + "."
                    }, {
                        width: 500,
                        text: eachQues.qn_desc + "(ASL)"
                    }, {
                        width: 'auto',
                        alignment: "right",
                        text: "(" + eachQues.mark + ")"
                    }];
                } else {
                    if (eachQues.type === "FIB") {
                        eachQues.qn_desc = $scope.beautifyFIB(eachQues.qn_desc);
                    }
                    if (!eachQues.isLatex) {
                        obj = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.qn_desc
                        }, {
                            width: 'auto',
                            alignment: "right",
                            text: "(" + eachQues.mark + ")"
                        }];
                    } else {
                        var headObj = eachQues.latexQues ? {
                            alignment: 'left',
                            image: eachQues.latexQues
                        } : {
                            width: 500,
                            text: eachQues.qn_desc
                        };
                        obj = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, headObj, {
                            width: 'auto',
                            alignment: "right",
                            text: "(" + eachQues.mark + ")"
                        }];
                    }
                }
                content.push({
                    columns: obj
                });
                if (eachQues.qn_img_url) {
                    var _imgObj2 = {
                        columns: [{
                            alignment: 'left',
                            width: 300,
                            image: eachQues.qn_img_url
                        }]
                    };
                    content.push(_imgObj2);
                    content.push("\n");
                }
                if (eachQues.qn_img_urlarray) {
                    _.each(eachQues.qn_img_urlarray, function (eachQnImage) {
                        var imgObj = {
                            columns: [{
                                alignment: 'left',
                                width: 300,
                                image: eachQnImage
                            }]

                        };
                        content.push(imgObj);
                        content.push("\n");
                    });
                }

                if (eachQues.type === "MCQ" || eachQues.type === "IBT_MCQ") {

                    var ch = [];
                    _.each(eachQues.choice, function (eachChoice) {
                        if (!eachQues.isLatex) {
                            var choice = "(" + eachChoice.tag + ")  " + eachChoice.desc;
                            content.push({
                                text: choice
                            });
                            content.push("\n");
                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                _.each(eachChoice.opt_image_url, function (eachImage) {
                                    var imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: eachImage
                                        }]

                                    };
                                    content.push(imgObj);
                                    content.push("\n");
                                });
                            }
                        } else {
                            var _choice4 = "(" + eachChoice.tag + ")  ";
                            var choiceLatex = [{
                                text: _choice4
                            }, {
                                image: eachChoice.latexDesc
                            }];
                            content.push(choiceLatex);
                            content.push("\n");
                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                _.each(eachChoice.opt_image_url, function (eachImage) {
                                    var imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: eachImage
                                        }]

                                    };
                                    content.push(imgObj);
                                    content.push("\n");
                                });
                            }
                        }
                    });
                }
                if (eachQues.type === "MTF") {
                    var ch1 = [];
                    _.each(eachQues.optionQuestion, function (optionQues) {
                        if (!eachQues.isLatex) {
                            var choice = "(" + optionQues.tag + ")  " + optionQues.desc;
                            // ch1.push([{ text: choice,border: [false, false, false, false] }])
                            // let imgObj = {
                            //     border: [false, false, false, false],
                            //     alignment: 'left',
                            //     width: 100,
                            //     image: optionQues.questionimage
                            // }
                            var chContent = [];
                            chContent.push([{
                                text: choice,
                                border: [false, false, false, false]
                            }]);
                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                chContent.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionQues.questionimage
                                }]);
                            }
                            ch1.push(chContent);
                        } else {
                            var _choice5 = "(" + optionQues.tag + ")  ";
                            var _chContent3 = [];
                            _chContent3.push([{
                                text: _choice5,
                                border: [false, false, false, false]
                            }]);
                            if (optionQues.latexDesc) {
                                _chContent3.push([{
                                    /*text: choice,*/
                                    image: optionQues.latexDesc,
                                    border: [false, false, false, false]
                                }]);
                            }
                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                _chContent3.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionQues.questionimage
                                }]);
                            }
                            ch1.push(_chContent3);
                        }
                    });
                    var ch2 = []; // answerimage   questionimage
                    _.each(eachQues.optionAnswer, function (optionAns, ansIndex) {
                        var choicesl = ansIndex + 1;
                        if (!eachQues.isLatex) {
                            var choice = "(" + choicesl + ")  " + optionAns.desc;
                            var chContent = [];
                            chContent.push([{
                                text: choice,
                                border: [false, false, false, false]
                            }]);
                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                chContent.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionAns.answerimage
                                }]);
                            }
                            ch2.push(chContent);
                        } else {
                            var _choice6 = "(" + choicesl + ")  ";
                            var _chContent4 = [];
                            _chContent4.push([{
                                text: _choice6,
                                border: [false, false, false, false]
                            }]);
                            if (optionAns.latexDesc) {
                                _chContent4.push([{
                                    image: optionAns.latexDesc,
                                    border: [false, false, false, false]
                                }]);
                            }
                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                _chContent4.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionAns.answerimage
                                }]);
                            }
                            ch2.push(_chContent4);
                        }
                    });
                    content.push({
                        table: {
                            widths: ['*', '*', 90],
                            body: [[{
                                text: "Question"
                            }, {
                                text: "Option"
                            }, {
                                text: "Answer"
                            }]]

                        }
                    });

                    for (var i = 0; i < ch1.length; i++) {
                        var tableContent = [];
                        tableContent.push({
                            table: {
                                body: ch1[i],
                                layout: 'noBorders'
                            }
                        });
                        tableContent.push({
                            table: {
                                body: ch2[i],
                                layout: 'noBorders'
                            }
                        });
                        tableContent.push({});
                        content.push({
                            table: {
                                widths: ['*', '*', 90],
                                body: [tableContent]
                            }
                        });
                    }
                }
                if (eachQues.type === "TF") {
                    var _ch2 = [];
                    _ch2.push({
                        text: "(A) True"
                    });
                    _ch2.push({
                        text: "(B) False"
                    });

                    content.push({
                        columns: _ch2
                    });
                }
                if (eachQues.type === "ASLLISTEN") {
                    _.each(eachQues.questions, function (ques, index) {
                        var quesData = [{
                            width: 10,
                            text: ""
                        }, {
                            width: "auto",
                            alignment: "left",
                            text: index + 1
                        }, {
                            width: 500,
                            text: ques.qn_desc
                        }];
                        content.push({
                            columns: quesData
                        });
                        if (ques.type === "mcq") {
                            var _ch3 = [];
                            _.each(ques.choice, function (eachChoice) {
                                if (ques.isLatex) {
                                    var choice = "(" + eachChoice.tag + ")" + eachChoice.desc;
                                    _ch3.push({
                                        text: choice
                                    });
                                } else {
                                    var _choice7 = "(" + eachChoice.tag + ")  ";
                                    _ch3.push({
                                        text: _choice7
                                    });
                                    _ch3.push({
                                        image: eachChoice.latexDesc
                                    });
                                }
                            });
                            content.push({
                                columns: _ch3
                            });
                        } else if (ques.type === "tf") {
                            var _ch4 = [];
                            _ch4.push({
                                text: "(A) True"
                            });
                            _ch4.push({
                                text: "(B) False"
                            });

                            content.push({
                                columns: _ch4
                            });
                        }
                    });
                }
                quesNo++;
            });
            content.push({
                canvas: [{
                    type: 'line',
                    x1: 0,
                    y1: 10,
                    x2: 520,
                    y2: 10,
                    lineWidth: 0.5
                }]
            });
        });

        var font = $scope.qpHeader.subject == 'Malayalam' ? 'Rachana' : $scope.qpHeader.subject == 'Hindi' ? 'Kruti' : 'Roboto';

        var docDefinition = {
            info: {
                title: $scope.allQuestions.title
            },
            content: content,
            styles: {
                title: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                sectionTitle: {
                    bold: true,
                    italics: true
                },
                boldStyle: {
                    bold: true
                }
            },
            defaultStyle: {
                font: font
            }
        };
        pdfMake.createPdf(docDefinition).open();
    };
    /*
     * Function check whether it is array or not
     * @obj - Object/Array to check
    */
    $scope.isArray = function (obj) {
        return Array.isArray(obj);
    };
    $scope.uCanTrust = function (string) {
        // string = "<span style='color: #89a000'>123</span>"
        return $sce.trustAsHtml(string);
    };
    $scope.addCommentInSection = function (section_from_page, event) {
        showCommentInputPerSection(section_from_page, event);
    };
    function showCommentInputPerSection(section_from_page, event) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', 'section_from_page', AddCommentInSectionCtrl],
            locals: {
                parentScope: $scope,
                section_from_page: section_from_page
            },
            template: _addsectionComment2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            targetEvent: event
            // fullscreen: useFullScreen
        });
    }
    $scope.setApproverCommentInQpSection = function (section) {
        var obj = {
            user_id: $scope.user_id,
            qp_id: qpId,
            section: section,
            school_id: schoolId
        };
        authService.callAPI("/v0/traditional/activity/set/section/approvercomment", "POST", obj, function (response) {
            console.log(response);
            toastr.success("Added approver comment");
        });
    };
}];

exports.default = ActivityPreviewController;

var AddCommentInSectionCtrl = function AddCommentInSectionCtrl($scope, $mdDialog, parentScope, section_from_page) {
    _classCallCheck(this, AddCommentInSectionCtrl);

    $scope.section = section_from_page;
    $scope.addComment = function () {
        console.log(section_from_page);
        $mdDialog.hide();
        parentScope.setApproverCommentInQpSection(section_from_page);
    };
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};

var pdfForElement = function pdfForElement(htmlTextInput) {

    //Parse inner elements
    function ParseContainer(cnt, e, p, styles) {
        var elements = [];
        var children = e.childNodes;
        if (children.length != 0) {
            for (var i = 0; i < children.length; i++) {
                p = ParseElement(elements, children[i], p, styles);
            }
        }
        if (elements.length != 0) {
            for (var i = 0; i < elements.length; i++) {
                cnt.push(elements[i]);
            }
        }
        return p;
    }

    //Convert styles to pdfmake JSON
    function ComputeStyle(o, styles) {
        for (var i = 0; i < styles.length; i++) {
            styles[i] = styles[i].replace();
            var st = styles[i].trim().toLowerCase().split(":");
            if (st.length == 2) {
                st[0] = st[0].trim();
                st[1] = st[1].trim();
                switch (st[0]) {
                    case "font-size":
                        {
                            o.fontSize = parseInt(st[1]);
                            break;
                        }
                    case "text-align":
                        {
                            switch (st[1]) {
                                case "right":
                                    o.alignment = 'right';
                                    break;
                                case "center":
                                    o.alignment = 'center';
                                    break;
                            }
                            break;
                        }
                    case "font-weight":
                        {
                            switch (st[1]) {
                                case "bold":
                                    o.bold = true;
                                    break;
                            }
                            break;
                        }
                    case "text-decoration":
                        {
                            switch (st[1]) {
                                case "line-through":
                                    o.decoration = "lineThrough";
                                    break;
                                case "underline":
                                    o.decoration = "underline";
                                    break;
                            }
                            break;
                        }
                    case "font-style":
                        {
                            switch (st[1]) {
                                case "italic":
                                    o.italics = true;
                                    break;
                            }
                            break;
                        }
                }
            }
        }
    }

    //Parse each element
    function ParseElement(cnt, e, p, styles) {
        if (!styles) {
            styles = [];
        }
        //If styles in the element
        if (e.getAttribute) {
            var nodeStyle = e.getAttribute("style");
            if (nodeStyle) {
                var ns = nodeStyle.split(";");
                for (var k = 0; k < ns.length; k++) {
                    if (ns[k]) {
                        styles.push(ns[k]);
                    }
                }
            }
        }
        switch (e.nodeName.toLowerCase()) {
            case "#text":
                {
                    var t = {
                        text: e.textContent.replace(/\n/g, "")
                    };
                    if (styles) {
                        ComputeStyle(t, styles);
                    }
                    if (p.text) {
                        p.text.push(t);
                    } else if (p.ul) {
                        p.ul.push(t);
                    } else if (p.ol) {
                        p.ol.push(t);
                    }
                    break;
                }
            case "b":
            case "strong":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-weight:bold"]));
                    break;
                }
            case "strike":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:line-through"]));
                    break;
                }
            case "u":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:underline"]));
                    break;
                }
            case "i":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-style:italic"]));
                    break;
                }
            case "span":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            case "br":
                {
                    p = CreateParagraph();
                    var t = {
                        text: "\n"
                    };
                    p.text.push(t);
                    cnt.push(p);
                    break;
                }
            case "blackquote":
            case "div":
            case "p":
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p, styles);
                    cnt.push(p);
                    break;
                }
            case "ul":
                {
                    ul = createList("ul");
                    ParseContainer(cnt, e, ul, styles);
                    cnt.push(ul);
                    break;
                }
            case "ol":
                {
                    ol = createList("ol");
                    ParseContainer(cnt, e, ol, styles);
                    cnt.push(ol);
                    break;
                }
            case "li":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            default:
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p);
                    cnt.push(p);
                    break;
                }
        }
        return p;
    }

    //Create pragragh content in pdfmake
    function CreateParagraph() {
        var p = {
            text: []
        };
        return p;
    }

    //Create pragragh content in pdfmake
    function createList(type) {
        if (type === "ol") {
            var list = {
                ol: []
            };
            return list;
        }
        if (type === "ul") {
            var list = {
                ul: []
            };
            return list;
        }
    }

    //Parse HTML input and convert to JSON
    function ParseHtml(cnt, htmlText) {
        var html = $(htmlText.replace(/\t/g, "").replace(/\n/g, ""));
        var p = CreateParagraph();
        for (var i = 0; i < html.length; i++) {
            ParseElement(cnt, html.get(i), p);
        }
    }
    var content = [];
    ParseHtml(content, htmlTextInput);
    return content;
};

var questionMetadataCtrl = function questionMetadataCtrl($scope, $mdDialog, metadata, question, $sce) {
    _classCallCheck(this, questionMetadataCtrl);

    metadata['qn_desc'] = question.qn_desc;
    metadata['type'] = question.type;

    $scope.metadata = metadata;
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.convertTitle = function (title, TYPE) {
        if (TYPE == "LA" || TYPE == 'passage') {
            var string = "Long Answer";
            if (TYPE == 'passage') {
                string = "Passage Question";
            }
            return $sce.trustAsHtml(string);
        }
        return $sce.trustAsHtml(title);
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _progress_popup = __webpack_require__(926);

var _progress_popup2 = _interopRequireDefault(_progress_popup);

var _procturedDocument = __webpack_require__(77);

var _procturedDocument2 = _interopRequireDefault(_procturedDocument);

var _proceedView = __webpack_require__(927);

var _proceedView2 = _interopRequireDefault(_proceedView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: qpSummary.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-13
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var ActivitySubmissionController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", function ActivitySubmissionController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
    _classCallCheck(this, ActivitySubmissionController);

    var authoring = localStorageService.get("authoringData");
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $stateParams.qpId;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    var self = this;
    $scope.isLoading = true;
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.qpHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'subject': authoring.subject,
                'class': authoring.class
            };
            $scope.$apply();
        } else {
            //error
        }
    });
    getQp();

    $scope.auto_evaluating = false;
    function getQp() {
        try {

            authService.callAPI(activityCons.API_GET_QP_ATTENDEE_DETAILS + qpId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        $scope.isLoading = false;
                        $scope.questionPaper = response.result.data.details;
                        console.log($scope.questionPaper);
                        $scope.questionPaper.auto_evaluating = false;
                        if ($scope.questionPaper && $scope.questionPaper.time) {
                            $scope.hour = $scope.questionPaper.time.hour;
                            $scope.min = $scope.questionPaper.time.min;
                        }
                        if ($scope.questionPaper && $scope.questionPaper.due_date) {
                            $scope.date = $scope.questionPaper.due_date;
                        }
                        if ($scope.questionPaper && $scope.questionPaper.students) {
                            $scope.assignedUsers = $scope.questionPaper.students;
                        }

                        if ($scope.assignedUsers.length > 0) {
                            modifyLoginDetails();
                        }

                        if ($scope.assignedUsers.length > 0 && $scope.questionPaper.status != 'completed') {
                            generateAlertMessage();
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    //toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    $scope.validateExamProceed = false;

    function modifyLoginDetails() {
        var obj_green = {
            "border-radius": "5px",
            "background-color": 'green',
            "padding": 5,
            "color": "white"
        };
        var obj_red = {
            "border-radius": "5px",
            "background-color": 'red',
            "padding": 5,
            "color": "white"
        };
        for (var n = 0; n < $scope.assignedUsers.length; n++) {
            var lock_validate = true;
            var flag = 0;
            if ($scope.assignedUsers[n].user_logged && $scope.assignedUsers[n].user_logged.length > 0) {

                var userDetails = $scope.assignedUsers[n].user_logged;
                for (var m = 0; m < userDetails.length; m++) {
                    var validate = false;
                    for (var j = 0; j < userDetails.length; j++) {

                        if (m != j) {
                            if (userDetails[m]['uuid'] == userDetails[j]['uuid']) {
                                validate = true;
                            }
                        }
                    }
                    if (validate == true) {
                        $scope.assignedUsers[n].user_logged[m]['color'] = obj_green;
                    } else {
                        $scope.assignedUsers[n].user_logged[m]['color'] = obj_red;
                        flag = flag + 1;
                    }
                    if (userDetails.length == 1) {
                        flag = 0;
                        $scope.assignedUsers[n].user_logged[m]['color'] = obj_green;
                    }
                }
            }
            if (flag > 0) {
                $scope.assignedUsers[n]['validate_user_login'] = {
                    "color": 'red',
                    "float": "right",
                    "padding": 0,
                    "animation": "blinker 1s linear infinite"
                };
            } else {
                $scope.assignedUsers[n]['validate_user_login'] = {
                    "color": 'green',
                    "float": "right",
                    "padding": 0
                };
            }
        }
    }

    self.openMenu = function ($mdOpenMenu, ev) {
        console.log(ev);
        $mdOpenMenu(ev);
    };

    function generateAlertMessage() {
        $scope.poceedingStuList = [];
        toastr.options.timeOut = 5000;
        toastr.options.positionClass = "toast-bottom-right";
        toastr.options.closeButton = true;
        for (var n = 0; n < $scope.assignedUsers.length; n++) {

            if ($scope.assignedUsers[n].examOutStatus && $scope.assignedUsers[n].status == 'attending') {
                $scope.validateExamProceed = true;
                $scope.poceedingStuList.push($scope.assignedUsers[n]);
                toastr.info($scope.assignedUsers[n].name + ' is waiting to start the exam.');
            }
        }
        if ($scope.poceedingStuList.length == 0) {
            $scope.validateExamProceed = false;
        }
        _.defer(function () {
            $scope.$apply();
        });
    }

    $scope.is_call_api = undefined;
    function makeInterval(flag) {
        if (!flag) {
            $scope.is_call_api = setInterval(function () {
                getQp();
            }, 10000);
        } else {
            clearInterval($scope.is_call_api);
        }
    }
    makeInterval(false);
    $scope.answerPreview = function (studentId) {
        $state.go('teacherAnswerView', {
            qpId: qpId,
            studentId: studentId
        });
    };
    $scope.answerPreview1 = function (studentId) {
        $scope.studentId = studentId;
        if ($rootScope.online) {
            authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + $scope.questionPaper._id + '/' + studentId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        var result = response.result.data.details;
                        var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
                        $scope.my_score = 0;
                        $scope.totalmark = 0;
                        $scope.quesCount = 0;
                        var myScore = 0;
                        $scope.isTeacherEvaluation = false;
                        _.each(result.consolidatedData, function (sec) {
                            delete sec.questions;
                            _.each(sec.answers, function (ans) {
                                if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                    $scope.quesCount++;
                                }
                                $scope.totalmark = ans.total_mark;
                                if (!isNaN(ans.my_score)) {
                                    myScore = parseFloat(myScore) + parseFloat(ans.my_score);
                                    myScore = myScore.toFixed(2);
                                    $scope.my_score = myScore;
                                }
                            });
                        });
                        if ($scope.quesCount > 0 && $scope.questionPaper.status != 'published') $scope.isTeacherEvaluation = true;
                        $scope.questions = result.consolidatedData;
                        setTimeout(function () {
                            $scope.loadLatex();
                        }, 100);
                        setChoice();
                        $mdDialog.show({
                            templateUrl: teacherViewAnswerUrl,
                            clickOutsideToClose: true,
                            scope: $scope,
                            fullscreen: useFullScreen,
                            preserveScope: true
                        }).then(function () {}, function () {
                            self.status = 'You cancelled the dialog.';
                        });
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            var consolidatedData = [];
            nodeAPIService.callAPI(API_GET_FETCH_MY_ANSWER + schoolId + "/" + studentId + "/" + activityId, "GET", undefined, function (response) {
                if (response.result != undefined) {
                    var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
                    var result = response.result.data.data;
                    $scope.my_score = 0;
                    $scope.totalmark = 0;
                    $scope.quesCount = 0;
                    var myScore = 0;
                    if (result && result.answerDetails && result.answerDetails.length > 0) {
                        $scope.totalmark = result.answerDetails[0].total_mark;
                        $scope.my_score = result.answerDetails[0].score;
                        $scope.qpTitle = result.answerDetails[0].qp_title;
                        $scope.class = result.answerDetails[0].class;
                        $scope.batch = result.answerDetails[0].batch;
                        $scope.subject = result.answerDetails[0].subject;
                        $scope.date = result.answerDetails[0].date;
                        if (result.answerDetails[0].time) {
                            if ($scope.hour = result.answerDetails[0].time.hour) $scope.hour = result.answerDetails[0].time.hour;
                            if ($scope.min = result.answerDetails[0].time.min) $scope.min = result.answerDetails[0].time.min;
                        }
                        $scope.questions = result.answerDetails;
                    }
                    if (result && result.schoolDetails && result.schoolDetails.length > 0) {
                        $scope.schoolName = result.schoolDetails[0].school_name;
                        $scope.schoolLogo = SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.schoolDetails[0].logo);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };

    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };

    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };

    $scope.markValidation = function (questionId, sectionIndex, section, qnMark) {
        var answersMarkCount = 0;
        _.each(section.answers, function (data) {
            if (parseFloat(data.my_score) > 0) {
                answersMarkCount++;
            }
        });
        if (answersMarkCount > section.mandatory_no) {
            var _questionIndex = section.answers.findIndex(function (i) {
                return i._id === questionId;
            });
            section.answers[_questionIndex].my_score = 0;
            toastr.error(" You have already entered the marks all mandatory question");
            section.answers[sectionIndex];
        };
        var actualScore = 0;
        var totalScore = qnMark;
        var questionIndex = $scope.questions[sectionIndex].answers.findIndex(function (i) {
            return i._id === questionId;
        });
        if (questionIndex > -1) {
            actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score;
        }
        if (actualScore > totalScore) $scope.questions[sectionIndex].answers[questionIndex].my_score = 0;
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.toString().replace(/\\quad/g, "");
            value = value.toString().replace(/\\/g, "");
        }
        return value;
    }

    /* Set answered choice is wrong or correct*/
    function setChoice() {
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (data, key) {
                $scope.total_mark += parseFloat(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    _.each(data.choice, function (choice) {
                        if ($scope.checkingChoiceExists(choice.desc, data)) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                        }
                    });
                } else if (data.type == 'TF') {
                    _.each(data.choice, function (choice) {
                        if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        }
                    });
                } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key2]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.answer.desc);
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key3].desc);
                            if (correctAnswer !== studentAnswer) {
                                correct = false;
                            } else {
                                correct = true;
                            }
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacter(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                } else {
                                    choice.wrong = true;
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacter(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacter(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    aslListQues.wrong = true;
                                } else {
                                    aslListQues.correct = true;
                                }
                            } else {
                                aslListQues.wrong = true;
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
    }

    $scope.score = $scope.score.toFixed(2);
    $scope.cancel = function () {
        $mdDialog.hide();
    };

    $scope.gotoActivityPreview = function () {
        $state.go('qpSummary', {
            qpId: qpId
        });
    };

    $scope.saveMark = function () {
        var errorCount = 0;
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (quest) {
                //mark_each_qn changed to qn_mark
                //For individual mark  for each question
                //Developer-Raziya
                quest.qn_mark = parseFloat(quest.qn_mark);
                if (quest.my_score > quest.qn_mark) {
                    quest.mark_error = "Enter the mark less than total mark";
                    errorCount++;
                }
            });
        });
        if (errorCount > 0) {
            toastr.error("Check the marks");
        } else {
            var requestObj = {
                questions: $scope.questions,
                student_id: $scope.studentId,
                question_paper_id: $scope.questionPaper._id,
                user_id: userId,
                authoring_data: authoring
            };
            authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function (response) {
                if (response.result && response.result.data && response.result.data.message) {
                    try {
                        var result = response.result.data.message;
                        toastr.success(result);
                        $mdDialog.hide();
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };

    $scope.setFilePath = function (img) {
        var new_url = img ? FILE_UPLOAD_URL + img : undefined;
        return new_url;
    };

    $scope.beautifyFIB = function (question) {
        return question.toString().replace(/_/g, " _______ ");
    };

    function getTime(millseconds) {
        var oneSecond = 1000;
        var oneMinute = oneSecond * 60;
        var oneHour = oneMinute * 60;
        var oneDay = oneHour * 24;
        var seconds = Math.floor(millseconds % oneMinute / oneSecond);
        var minutes = Math.floor(millseconds % oneHour / oneMinute);
        var hours = Math.floor(millseconds % oneDay / oneHour);
        var days = Math.floor(millseconds / oneDay);
        var timeString = '';
        if (days !== 0) {
            timeString += days !== 1 ? days + ' days ' : days + ' day ';
        }
        if (hours !== 0) {
            timeString += hours !== 1 ? hours + ' hours ' : hours + ' hour ';
        }
        if (minutes !== 0) {
            timeString += minutes !== 1 ? minutes + ' min ' : minutes + ' min ';
        }
        if (seconds !== 0 || millseconds < 1000) {
            timeString += seconds !== 1 ? seconds + ' sec ' : seconds + ' sec ';
        }
        return timeString;
    }

    $scope.isString = function (value) {
        return typeof value == 'string';
    };
    $scope.$on("$destroy", function () {
        makeInterval(true);
    });
    $scope.showProgresspopup = function (array) {
        if (array) {
            $mdDialog.show({
                controller: ['$scope', '$mdMedia', '$mdDialog', 'array', 'parentScope', ProgressPreviewController],
                template: _progress_popup2.default,
                parent: angular.element(document.body),
                locals: {
                    array: array,
                    parentScope: $scope
                },
                clickOutsideToClose: true
            });
        } else {
            toastr.error("No progress Data");
        }
    };

    $scope.changeStudentTabColor = function (studList) {
        var assignedUsers = $scope.assignedUsers;
        var ex = _.find(assignedUsers, function (one) {
            return one._id == studList._id;
        });
        if (ex) {
            ex.tab_color = false;
            console.log(ex);
        }
        // for (let m = 0; m < assignedUsers.length; m++) {

        // }
    };
    $scope.showColor = function (obj) {
        var string = "<span style='color: #00000'>" + obj.name + "</span>";
        if (obj && obj.tab_color) {
            string = "<span style='background:red;padding:5px;color: white !important;'>" + obj.name + "</span>";
        }
        return $sce.trustAsHtml(string);
    };
    $scope.ExamProceedAllow = function () {
        console.log($scope.poceedingStuList);
        $mdDialog.show({
            controller: ['$scope', '$mdMedia', '$mdDialog', 'parentScope', 'authService', 'CONSTANTS', 'poceedingStuList', 'qpId', ExamProceedViewController],
            template: _proceedView2.default,
            parent: angular.element(document.body),
            locals: {
                parentScope: $scope,
                authService: authService,
                CONSTANTS: CONSTANTS,
                poceedingStuList: $scope.poceedingStuList,
                qpId: qpId
            },
            clickOutsideToClose: true
        });
    };

    $scope.viewOneStudent = function (one_student) {

        $scope.editDialog = $mdDialog;
        $scope.editDialog.show({

            // $mdDialog.show({
            controller: ['$scope', '$mdMedia', '$mdDialog', 'parentScope', 'authService', 'CONSTANTS', 'studList', 'qpId', ProcturingViewController],
            template: _procturedDocument2.default,
            parent: angular.element(document.body),
            locals: {
                parentScope: $scope,
                authService: authService,
                CONSTANTS: CONSTANTS,
                studList: one_student,
                qpId: qpId
            },
            clickOutsideToClose: false,
            multiple: true
        });
    };
    var scope = $scope;
    $scope.autoEvaluate = function (event) {
        var confirm = $mdDialog.confirm({
            targetEvent: event,
            onComplete: function afterShowAnimation() {
                var $dialog = angular.element(document.querySelector('md-dialog'));
                var $actionsSection = $dialog.find('md-dialog-actions');
                var $cancelButton = $actionsSection.children()[0];
                var $confirmButton = $actionsSection.children()[1];
                angular.element($confirmButton).addClass('md-raised md-accent');
                angular.element($cancelButton).addClass('md-raised');
                var $title = angular.element(document.querySelector('md-title'));
                angular.element($title).addClass('md-raised md-accent');
            }
        }).title('Are you sure to proceed').textContent('This action will evaluate the question types - MCQ, OWQ, TF and MTF').ok('Proceed').cancel('Cancel');

        $mdDialog.show(confirm).then(function () {
            scope.questionPaper.auto_evaluating = true;
            var requestObj = {
                school_id: schoolId,
                qp_id: qpId
            };
            authService.callAPI("/v0/auto/evaluate/students/activity", "POST", requestObj, function (response) {
                if (response.result && response.result.data && response.result.data.message) {
                    try {
                        toastr.success("Auto evaluation is on progress.Please check after some minute(s)");
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }, function () {
            toastr.info("You cancelled the process");
        });
        // 
    };
}];

exports.default = ActivitySubmissionController;

var ProgressPreviewController = function ProgressPreviewController($scope, $mdMedia, $mdDialog, array, parentScope) {
    'ngInject';

    _classCallCheck(this, ProgressPreviewController);

    $scope.array = array;

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};
ProgressPreviewController.$inject = ["$scope", "$mdMedia", "$mdDialog", "array", "parentScope"];

var ProcturingViewController = function ProcturingViewController($scope, $mdMedia, $mdDialog, parentScope, authService, CONSTANTS, studList, qpId) {
    'ngInject';

    _classCallCheck(this, ProcturingViewController);

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    var obj = {
        qp_id: qpId,
        student_id: studList._id,
        status: "attending",
        FILE_UPLOAD_URL: CONSTANTS.CLOUD_URL
    };
    $scope.studList = studList;
    function attachFILESERVER(array) {
        var FILE_UPLOAD_URL = CONSTANTS.CLOUD_URL;
        var arr = [];
        for (var a = 0; a < array.length; a++) {
            var path = FILE_UPLOAD_URL + array[a]['path'];
            array[a]['path'] = path;
            arr.push(array[a]);
        }
        arr.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return new Date(b.datetime) - new Date(a.datetime);
        });
        return arr;
    }
    function imageZoom(imgID, resultID) {
        var img, lens, result, cx, cy;
        img = document.getElementById(imgID);
        if (img) {
            var moveLens = function moveLens(e) {
                var pos, x, y;
                /* Prevent any other actions that may occur when moving over the image */
                e.preventDefault();
                /* Get the cursor's x and y positions: */
                pos = getCursorPos(e);
                /* Calculate the position of the lens: */
                x = pos.x - lens.offsetWidth / 2;
                y = pos.y - lens.offsetHeight / 2;
                /* Prevent the lens from being positioned outside the image: */
                if (x > img.width - lens.offsetWidth) {
                    x = img.width - lens.offsetWidth;
                }
                if (x < 0) {
                    x = 0;
                }
                if (y > img.height - lens.offsetHeight) {
                    y = img.height - lens.offsetHeight;
                }
                if (y < 0) {
                    y = 0;
                }
                /* Set the position of the lens: */
                lens.style.left = x + "px";
                lens.style.top = y + "px";
                /* Display what the lens "sees": */
                result.style.backgroundPosition = "-" + x * cx + "px -" + y * cy + "px";
            };

            result = document.getElementById(resultID);
            /* Create lens: */
            lens = document.createElement("DIV");
            lens.setAttribute("class", "img-zoom-lens");
            /* Insert lens: */
            img.parentElement.insertBefore(lens, img);
            /* Calculate the ratio between result DIV and lens: */
            cx = result.offsetWidth / lens.offsetWidth;
            cy = result.offsetHeight / lens.offsetHeight;
            /* Set background properties for the result DIV */
            result.style.backgroundImage = "url('" + $scope.one_image.path + "')";
            result.style.backgroundSize = img.width * cx + "px " + img.height * cy + "px";
            /* Execute a function when someone moves the cursor over the image, or the lens: */
            lens.addEventListener("mousemove", moveLens);
            img.addEventListener("mousemove", moveLens);
            /* And also for touch screens: */
            lens.addEventListener("touchmove", moveLens);
            img.addEventListener("touchmove", moveLens);
        }

        function getCursorPos(e) {
            var a,
                x = 0,
                y = 0;
            e = e || window.event;
            /* Get the x and y positions of the image: */
            a = img.getBoundingClientRect();
            /* Calculate the cursor's x and y coordinates, relative to the image: */
            x = e.pageX - a.left;
            y = e.pageY - a.top;
            /* Consider any page scrolling: */
            x = x - window.pageXOffset;
            y = y - window.pageYOffset;
            return { x: x, y: y };
        }
    }
    $scope.one_image = {};
    $scope.one_audio = {};

    makeIntervalProctoring(false);

    $scope.is_call_api_proctoring = undefined;
    function makeIntervalProctoring(flag) {
        if (!flag) {
            $scope.is_call_api_proctoring = setInterval(function () {
                getProctoringImages();
            }, 50000);
        } else {
            clearInterval($scope.is_call_api_proctoring);
        }
    }

    getProctoringImages();
    function getProctoringImages() {
        try {
            $scope.one_image = {};
            authService.callAPI("/v0/activity/attendees/images", "POST", obj, function (response) {
                if (response.result) {
                    var data = response.result.data;
                    var proctured_data = {};
                    proctured_data['cameraShots'] = attachFILESERVER(data.cameraShots);
                    $scope.one_image.path = proctured_data['cameraShots'][0]['path'];
                    imageZoom("myimage", "myresult");
                    proctured_data['activityShots'] = attachFILESERVER(data.activityShots);
                    proctured_data['textShots'] = data.textShots;
                    proctured_data['examStudentStatus'] = data.examStudentStatus;
                    if (data.examQPDetails) {
                        if (data.examQPDetails.examOutStatus) {
                            proctured_data['examOutStatus'] = data.examQPDetails.examOutStatus;
                        }
                    }
                    $scope.proctured_data = proctured_data;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } catch (e) {
            console.log(e);
        }
    }

    var file = "/home/cordova/count.txt";
    $scope.imageDetails = function (one_image) {
        $scope.one_image = one_image;
        imageZoom("myimage", "myresult");
        _.defer(function () {
            $scope.$apply();
        });
    };
    $scope.audioDetails = function (one_audio) {
        $scope.one_audio.audio = one_audio;
        _.defer(function () {
            $scope.$apply();
        });
    };
    var downloadFile = function downloadFile(url, outputstr) {
        fetch(url).then(function (resp) {
            return resp.arrayBuffer();
        }).then(function (resp) {
            try {
                // set the blog type to final pdf
                var _file = new Blob([resp], { type: 'application/mp3' });
                // process to auto download it
                var fileURL = URL.createObjectURL(_file);
                var link = document.createElement('a');
                link.href = fileURL;
                link.click();
            } catch (e) {
                console.log(e);
            }
        });
    };

    $scope.download = function (data) {
        var url = data.path;
        downloadFile(url);
    };

    $scope.showConfirm = function (ev, funName) {
        var titleMsg;
        $scope.funName = funName;
        if (funName == 'stopExam') {
            titleMsg = 'Would you like to stop the exam ?';
        }
        if (funName == 'proceedExam') {
            titleMsg = 'Would you like to unlock the exam ?';
        }
        if (funName == 'sendWarning') {
            titleMsg = 'Would you like to send a warning message ?';
        }
        if (funName == 'takePhoto') {
            titleMsg = 'Would you like to take the current snap shot?';
        }

        var confirm = $mdDialog.confirm().title(titleMsg).targetEvent(ev).ok('Yes').cancel('No').multiple(true);

        $mdDialog.show(confirm).then(function () {
            console.log($scope.funName);
            if ($scope.funName == 'stopExam') {
                $scope.stopExam();
            }
            if ($scope.funName == 'proceedExam') {

                $scope.proceedExam();
            }
            if ($scope.funName == 'sendWarning') {
                $scope.sendWarning();
            }
            if ($scope.funName == 'takePhoto') {
                $scope.takePhoto();
            }
        }, function () {});
    };

    $scope.proceedExam = function () {
        updateStudentExamQPDetails();
        $scope.proctured_data.examOutStatus = false;
    };
    $scope.stopExam = function () {
        updateStudentExam('forcedToSubmit');
    };
    $scope.sendWarning = function () {
        updateStudentExam('sendWarning');
    };
    $scope.takePhoto = function () {
        updateStudentExam('takePhoto');
    };
    function updateStudentExamQPDetails() {
        try {
            var _obj = {
                qp_id: qpId,
                student_id: studList._id
            };
            authService.callAPI("/v0/activity/attendees/update/exam/qp/details", "POST", _obj, function (response) {
                if (response.result) {}
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
    function updateStudentExam(changeStatus) {
        try {
            var _obj2 = {
                qp_id: qpId,
                student_id: studList._id,
                changeStatus: changeStatus
            };
            authService.callAPI("/v0/activity/attendees/update/exam", "POST", _obj2, function (response) {
                if (response.result) {}
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
};
ProcturingViewController.$inject = ["$scope", "$mdMedia", "$mdDialog", "parentScope", "authService", "CONSTANTS", "studList", "qpId"];

var ExamProceedViewController = function ExamProceedViewController($scope, $mdMedia, $mdDialog, parentScope, authService, CONSTANTS, poceedingStuList, qpId) {
    'ngInject';

    _classCallCheck(this, ExamProceedViewController);

    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    $scope.qpId = qpId;

    var arr = [];
    for (var m = 0; m < poceedingStuList.length; m++) {
        var keys = Object.keys(poceedingStuList[m]);
        var _obj3 = {};
        for (var k = 0; k < keys.length; k++) {
            _obj3[keys[k]] = poceedingStuList[m][keys[k]];
        }
        arr.push(_obj3);
    }
    $scope.poceedingStuListNEW = arr;
    $scope.isChecked = false;

    $scope.proceedExamALLBtn = false;
    $scope.proceedExam = function (studList) {
        updateStudentExamQPDetails(studList._id, studList);
        _.defer(function () {
            $scope.$apply();
        });
    };

    $scope.proceedExamALL = function () {
        for (var _k = 0; _k < $scope.poceedingStuListNEW.length; _k++) {
            if ($scope.poceedingStuListNEW[_k]['isChecked']) {
                updateStudentExamQPDetails($scope.poceedingStuListNEW[_k]._id, $scope.poceedingStuListNEW[_k]);
            }
        }
        _.defer(function () {
            $scope.$apply();
        });
    };

    $scope.selectAll = function () {
        for (var _k2 = 0; _k2 < $scope.poceedingStuListNEW.length; _k2++) {
            if ($scope.isChecked) {
                $scope.poceedingStuListNEW[_k2]['isChecked'] = true;
            } else {
                $scope.poceedingStuListNEW[_k2]['isChecked'] = false;
            }
        }
        if ($scope.isChecked) {
            $scope.proceedExamALLBtn = true;
        } else {
            $scope.proceedExamALLBtn = false;
        }
    };

    $scope.showConfirmProceed = function (ev) {
        var titleMsg = 'Would you like to unlock the exam of all the students ?';
        var confirm = $mdDialog.confirm().title(titleMsg).targetEvent(ev).ok('Yes').cancel('No').multiple(true);
        $mdDialog.show(confirm).then(function () {
            $scope.proceedExamALL();
        }, function () {});
    };

    function updateStudentExamQPDetails(student_id, studList) {
        try {
            var _obj4 = {
                qp_id: $scope.qpId,
                student_id: student_id
            };
            authService.callAPI("/v0/activity/attendees/update/exam/qp/details", "POST", _obj4, function (response) {
                if (response.result) {
                    for (var _m = 0; _m < $scope.poceedingStuListNEW.length; _m++) {
                        if ($scope.poceedingStuListNEW[_m]._id == student_id) {
                            $scope.poceedingStuListNEW.splice(_m, 1);
                        }
                    }

                    if ($scope.poceedingStuListNEW.length <= 0) {
                        parentScope.validateExamProceed = false;
                        $mdDialog.cancel();
                    }

                    parentScope.changeStudentTabColor(studList);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } catch (e) {
            console.log(e);
        }
    }
};
ExamProceedViewController.$inject = ["$scope", "$mdMedia", "$mdDialog", "parentScope", "authService", "CONSTANTS", "poceedingStuList", "qpId"];

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AssignStudents =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "activityCons", "$mdMedia", "$mdDialog", "$stateParams", function AssignStudents($scope, $rootScope, authService, localStorageService, $state, activityCons, $mdMedia, $mdDialog, $stateParams) {
    _classCallCheck(this, AssignStudents);

    this.scope = $scope;
    this.state = $state;
    var authoring = localStorageService.get("authoringData");
    var userId = localStorageService.get('user_id');
    var academicDetails = {
        session_id: authoring.session_id,
        curriculum_id: authoring.curriculum_id,
        class_id: authoring.class_id,
        batch_id: authoring.batch_id,
        school_id: authoring.school_id,
        subject_id: authoring.subject_id,
        academic_year: authoring.academic_year,
        user_id: userId,
        class: authoring.class,
        batch: authoring.batch,
        curriculum: authoring.curriculum,
        session: authoring.session,
        subject: authoring.subject

        //Boolean - Assign all students or  not
    };$scope.isAllStudents = false;

    //Boolean - Assign all groups or not
    $scope.isAllGroups = false;

    //[Object] - List of all students in the class
    $scope.allStudents = [];

    //[Object] - List of groups
    $scope.groupList = [];

    var qpId = $state.params.qpId;

    //Object - basic academic details
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (authoring) {
            authoring['user_id'] = userId;
            getGroupList();
            getAllStudents();
        } else {
            $state.go("authdashboard");
        }
    };

    //Object - Assigned users
    $scope.assignedUsers = {};

    //[Object] - Selected Groups
    $scope.selectedGroupList = [];

    //[Object] - Selected Students
    $scope.selectedStudentList = [];

    $scope.isServerCall = false;

    var subsGroup = undefined;

    this.$onDestroy = function () {
        if (subsGroup) subsGroup.stop();
    };

    if ($stateParams.previousState.state !== "") {
        localStorageService.set('assignUserHistory', $stateParams.previousState);
        //Object - State param
        $scope.previousState = $stateParams.previousState;
    } else {
        $scope.previousState = localStorageService.get('assignUserHistory');
    }

    if ($scope.previousState == null || $scope.previousState == undefined || $scope.previousState == '') {
        $state.go('qpSummary', {
            qpId: $stateParams.qpId
        });
    }

    function getAllStudents() {
        authService.callAPI(activityCons.API_GET_STUDENT_LIST, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                if (response.result.data.data.length > 0) $scope.allStudents = response.result.data.data;
                console.log($scope.allStudents);
                $scope.$apply();
            }
        });
    }

    function getGroupList() {
        authService.callAPI(activityCons.API_GET_GROUP_DETAILS, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                var groupList = response.result.data.data;
                authService.callAPI(activityCons.API_GET_ASSIGNED_USERS + qpId, "GET", {}, function (response) {
                    if (response && response.result && response.result.data) {
                        var result = response.result.data.data;
                        _.each(groupList, function (group) {
                            var isLeader = false;
                            var leaderName = '';
                            _.each(group.students, function (student) {
                                if (student.leader) {
                                    isLeader = true;
                                    if (leaderName === '') leaderName = student.name;else leaderName += ", " + student.name;
                                }
                            });
                            group.isLeader = isLeader;
                            group.leaderName = leaderName;
                            group.isSelected = false;
                            if (result && result.group_Ids && result.group_Ids.length > 0) {
                                var assignGroup = _.find(result.group_Ids, function (obj) {
                                    return group._id == obj._id;
                                });
                                if (assignGroup) {
                                    group.isSelected = true;
                                    $scope.selectedGroupList.push({
                                        _id: group._id
                                    });
                                }
                            }
                        });
                        if (result && result.group_Ids && result.group_Ids.length == groupList.length) $scope.isAllGroups = true;

                        if (result && result.students && result.students.length > 0) {
                            var list = [];
                            _.each($scope.allStudents, function (student) {
                                list.push({
                                    _id: student._id,
                                    name: student.name
                                });
                            });
                            $scope.selectedStudentList = list;
                            $scope.isAllStudents = true;
                        }
                        $scope.groupList = groupList;
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        });
    }

    $scope.allStudentsSelected = function () {
        $scope.isServerCall = true;
        $scope.selectedGroupList = [];
        $scope.isAllGroups = false;
        _.each($scope.groupList, function (group) {
            group.isSelected = false;
        });
        if ($scope.selectedStudentList.length === 0) {
            //[Object] - List of student Ids
            var list = [];
            _.each($scope.allStudents, function (student) {
                list.push({
                    _id: student._id,
                    name: student.name
                });
            });
            $scope.selectedStudentList = list;
            $scope.selectedGroupList = [];
        } else $scope.selectedStudentList = [];
    };

    $scope.allGroupSelected = function () {
        $scope.isServerCall = true;
        $scope.selectedGroupList = [];
        $scope.isAllStudents = false;
        //[Object] - List of student Ids
        var list = [];
        _.each($scope.groupList, function (group) {
            group.isSelected = !$scope.isAllGroups;
            if (group.isSelected) list.push({
                _id: group._id
            });
        });
        $scope.selectedGroupList = list;
        $scope.selectedStudentList = [];
    };

    $scope.groupSelected = function (group, index) {
        $scope.isServerCall = true;
        $scope.isAllStudents = false;
        $scope.selectedStudentList = [];
        if (!group.isSelected) {
            if ($scope.selectedGroupList.findIndex(function (i) {
                return i._id === group._id;
            }) == -1) $scope.selectedGroupList.push({
                _id: group._id
            });
        } else $scope.selectedGroupList = _.without($scope.selectedGroupList, _.findWhere($scope.selectedGroupList, {
            _id: group._id
        }));
        if ($scope.selectedGroupList.length == $scope.groupList.length) $scope.isAllGroups = true;else $scope.isAllGroups = false;
    };

    $scope.assignGroupUsers = function () {
        var previousState = $scope.previousState;
        if (previousState.state === "") {
            previousState = localStorageService.get('assignUserHistory');
            localStorageService.clear('assignUserHistory');
        }
        if ($scope.selectedStudentList.length > 0 || $scope.selectedGroupList.length > 0) {
            if ($scope.selectedGroupList.length > 0) {
                $scope.assignedUsers = {
                    type: "group",
                    list: $scope.selectedGroupList
                };
            }
            if ($scope.selectedStudentList.length > 0) {
                $scope.assignedUsers = {
                    type: "all",
                    list: $scope.selectedStudentList
                };
            }
        } else {
            toastr.error("Select Students to assign");
            return false;
        }
        if ($scope.isServerCall) {
            if (qpId) {
                var assigneeDetails = {
                    qp_id: qpId,
                    assigned_users: $scope.assignedUsers,
                    academic_details: academicDetails,
                    user_id: userId
                };
                console.log(assigneeDetails);
                authService.callAPI(activityCons.API_UPDATE_ASSIGNEE_DETAILS, "POST", assigneeDetails, function (response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Students assigned");
                        $state.go("qpSummary", {
                            qpId: qpId
                        });
                    }
                });
            }
        } else {
            $state.go(previousState.state, previousState.params);
        }
    };

    $scope.cancelAssignUser = function () {
        $state.go('qpSummary', {
            qpId: qpId
        });
    };

    $scope.createNewGroup = function () {
        $state.go('createStudentGroup', {
            qpId: qpId,
            groupId: ""
        });
    };

    $scope.toggleExpansion = function (accordianData, selectedData, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !selectedData.expanded;
        });
    };

    /*
     * Function to open menu
     *
     * @return : null
     */
    $scope.openMenu = function ($mdOpenMenu, ev) {
        var originatorEv = ev;
        $mdOpenMenu(ev);
    };

    $scope.editGroup = function (groupId) {
        $state.go('createStudentGroup', {
            qpId: qpId,
            groupId: groupId
        });
    };

    $scope.deleteGroup = function (groupId) {
        var confirm = $mdDialog.confirm().textContent('Do you want to delete Group?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI(activityCons.API_DELETE_GROUP + groupId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    toastr.success("Student group deleted successfully");
                    getGroupList();
                    getAllStudents();
                }
            });
        }, function () {});
    };

    this.$onDestroy = function () {};
}];

exports.default = AssignStudents;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateStudentGroup =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "activityCons", "$mdMedia", "$mdDialog", "$stateParams", function CreateStudentGroup($scope, $rootScope, authService, localStorageService, $state, activityCons, $mdMedia, $mdDialog, $stateParams) {
    _classCallCheck(this, CreateStudentGroup);

    this.scope = $scope;
    this.state = $state;

    //[Object] - List of all students in class
    $scope.studentList = [];
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //[Object] - List of student in group
    $scope.groupStudents = [];

    //Object - basic academic details
    var academicDetails = localStorageService.get("authoringData");
    //To get current user id
    var userId = localStorageService.get('user_id');
    var qpId = $state.params.qpId;
    var groupId = $state.params.groupId;

    $scope.isShowWaveFilter = false;

    $scope.isEdit = false;

    $scope.isEdited = false;

    if (academicDetails == null || academicDetails == undefined || academicDetails == '') {
        $state.go('dashboard');
    }

    if ($state.params.groupId) {
        $scope.isEdit = true;
        academicDetails['group_id'] = groupId;
        authService.callAPI(activityCons.API_STUDENT_GROUP_DETAILS, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                var result = response.result.data.data;
                var studentList = result.studentList;
                var groupDetails = result.groupDetails;
                $scope.groupName = groupDetails.group_name;
                _.each(groupDetails.students, function (student) {
                    var studentDetail = _.find(studentList, function (stu) {
                        return student._id === stu._id;
                    });
                    if (studentDetail) {
                        studentDetail.isLeader = student.leader;
                        $scope.groupStudents.push(studentDetail);
                        studentList = _.filter(studentList, function (stu) {
                            return student._id !== stu._id;
                        });
                    }
                });
                studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                $scope.studentList = studentList;
                $scope.studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                $scope.isShowWaveFilter = true;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
    } else {
        authService.callAPI(activityCons.API_GET_STUDENT_LIST, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                if (response.result.data.data.length > 0) {
                    $scope.studentList = response.result.data.data;
                    $scope.studentList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                    $scope.allstudentList = response.result.data.data;

                    $scope.isShowWaveFilter = true;
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }

    $scope.filterStudents = function (wave) {
        var waveStudents = [];
        var otherStudents = [];
        $scope.isEdited = true;
        _.each($scope.allstudentList, function (eachStud, index) {
            var flag = false;
            _.each(eachStud.wave, function (eachWave) {
                if (eachWave.subject_id === academicDetails.subject_id) {
                    if (eachWave.current_wave.wave_id === wave) {
                        waveStudents.push(eachStud);
                        flag = true;
                    }
                }
            });
            if (!flag) otherStudents.push(eachStud);
        });
        $scope.groupStudents = waveStudents;
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList = otherStudents;
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    /*
     * Function to add student to group
     * 
     * @id : String - id of student to add
     *
     * @return : null
     */
    $scope.addtoGroup = function (id) {
        var index = void 0;
        $scope.isEdited = true;
        _.each($scope.studentList, function (student, key) {
            if (student._id == id) index = key;
        });
        if (index > -1) {
            $scope.groupStudents.push($scope.studentList[index]);
            $scope.studentList.splice(index, 1);
        }
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    /*
     * Function to remove student from group
     * 
     * @id : String - id of student to remove
     *
     * @return : null
     */
    $scope.removefromGroup = function (id) {
        var index = void 0;
        $scope.isEdited = true;
        _.each($scope.groupStudents, function (student, key) {
            if (student.user_id == id) index = key;
        });
        if (index > -1) {
            $scope.studentList.push($scope.groupStudents[index]);
            $scope.groupStudents.splice(index, 1);
        }
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    $scope.updateEdit = function () {
        $scope.isEdited = true;
    };

    $scope.saveGroup = function () {
        var errCount = 0;
        if ($scope.groupName == undefined || $scope.groupName == "") {
            $scope.groupNameError = "Please, Enter Group Name";
            errCount++;
        }
        if ($scope.groupStudents.length == 0) {
            $scope.studentError = "Please, Add Student(s) for group";
            errCount++;
        }
        if (errCount == 0) {
            if ($scope.groupStudents.length > 0) {
                if ($scope.isEdit) {
                    //[Object] - List of student in group to save
                    var studentList = [];

                    _.each($scope.groupStudents, function (student) {
                        if (!student.isLeader) {
                            student.isLeader = false;
                        }
                        var obj = {
                            _id: student._id,
                            name: student.name,
                            leader: student.isLeader
                        };
                        studentList.push(obj);
                    });
                    studentList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    var group = {
                        group_name: $scope.groupName,
                        teacher_id: userId,
                        status: 'active',
                        academic_year: academicDetails.academic_year,
                        session_id: academicDetails.session_id,
                        curriculum_id: academicDetails.curriculum_id,
                        subject_id: academicDetails.subject_id,
                        class_id: academicDetails.class_id,
                        batch_id: academicDetails.batch_id,
                        school_id: academicDetails.school_id,
                        assigned_resources: 0,
                        assigned_activity: 0,
                        group_id: $stateParams.groupId,
                        students: studentList
                    };
                    authService.callAPI(activityCons.API_UPDATE_STUDENT_GROUP, "POST", group, function (response) {
                        if (response && response.result && response.result.data) {
                            console.log(response.result.data);
                            toastr.success("Group edited successfully");
                            $state.go('assignStudents', { qpId: qpId });
                        }
                    });
                } else {
                    //[Object] - List of student in group to save
                    var _studentList = [];
                    _.each($scope.groupStudents, function (student) {
                        if (!student.isLeader) {
                            student.isLeader = false;
                        }
                        var obj = {
                            _id: student._id,
                            name: student.name,
                            leader: student.isLeader
                        };
                        _studentList.push(obj);
                    });
                    _studentList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });

                    var _group = {
                        group_name: $scope.groupName,
                        teacher_id: userId,
                        status: 'active',
                        academic_year: academicDetails.academic_year,
                        session_id: academicDetails.session_id,
                        curriculum_id: academicDetails.curriculum_id,
                        subject_id: academicDetails.subject_id,
                        class_id: academicDetails.class_id,
                        batch_id: academicDetails.batch_id,
                        school_id: academicDetails.school_id,
                        assigned_resources: 0,
                        assigned_activity: 0,
                        students: _studentList
                    };
                    authService.callAPI(activityCons.API_ADD_STUDENT_GROUP, "POST", _group, function (response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Group added successfully");
                            $state.go('assignStudents', { qpId: qpId });
                        }
                    });
                }
            }
        } else {
            return false;
        }
    };

    $scope.backToGroupList = function () {
        $state.go('assignStudents', $stateParams);
    };

    this.$onDestroy = function () {};
}];

exports.default = CreateStudentGroup;

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAFrElEQVR42u2d+2vWVRzHT6uclU81L7Ny1ooSkW5LayRolmKohDMqfCgS2lY06plZUBZIC6P9MKMiI8pkdsFL01o3yiIzCFYW6oYxxMwIgqA/IIioz4fnRM8efNxzObfPOe8XfBD2wzzn/TrffW/ne45SAAAAAAAAAAAAACBWzkUEaXIm1ZO5XO4f+vd8xJEWrVTDLF8PgMcQSRpkqF7+T3zBADhBdTriiZuVmUzmt2L5BYPgdkQUJ9OoBkqJLxgA+xFVfNwxnviiQXAtIouDKVQ7KpGvB0A/oovgXJ/NZv+qVD5OA/Lhe/m3qhGv5e+jmoQYZXLzqa7wy5D/CdVZiFEe/DSvt1rxWv4A1QREKY9ZVN/XKH8bHgDJpLMW8Vr+K1SnIUpZNFDtNiC/D1HKo7Wuru4XA/I3IUp5PFqreC3/RUQp70/+oCH5mxGnLG6g+tmQ/NdwwSeLnAnxWv5WyJfD2VTvGJT/JlUdYpXBZVSHDcrfhYc8clhmSryWv1fh8a4I+Ny8wbD8IapzEG34ZEzd4hXIP0I1GdGGz6VUI4bln6CagWjDZ6FJ8VwdHR1/0++9AtGGT6dp+frob0G0YcO3Yy9Zkn8L4g3/Yu9TS/LvRbxh02Ty4U6R/A2IN2xampub/7AkfyviDZsVNsRr+Z+r/GRQEChdFuUPKyzoEDTP2ZLPpxP6/TMRcZicQdVvS74++uci5jDhd/gfW5Z/F2IOk6lUQ5blP4OYw+QSqlHL8ncrTOcKktm1fIxZpvyDCu/1g2SuTfEFb/cuRtThsdC2fH30z0fUCT3dK5LfiajD405H8rcg6vC4x5H8A1T1UkNaFOkVa7sL+XoAiLzo43vUHt2BERXXvLQuh/KXSAzopNOa6WcrI5D/iEP5T0gMiI/0H0/RqWeV3G/S1jmUv0diQMsq+DxpCo78kvkcUwLf7a+v4mOFeUL6ttaVfJ3NdZLE8xX+rho62w75Y/J4SJJ8/ozpsIFOvx7ofW6XY/kDkuQvNtz57wK7373PsfyfqM6TIn9t5Pe9WZfydb9FXA9NpNrmIIz1yt9kh1Ue5HdLOfI/chjKex5uhZZ6kP+BpPP+lY7DGaWa46hvN7qW39bW9qfK79sjims8HCW2Z75e7bpPul+3Sn0e3uIhrOdVfo69aS6vdhuV1JdmnechtK+ophvswwVUxz30Y1gJfr9fSKvr8BobG3/n87WBtvMF5kFPf/qvUhEx31OItTwy5aPvS0/t7lYRssBTmLzcaaUbGvHzhZ2e2rtXRfwxxyJPoR5S+aVUy2WTj3bqtjapyFnsMdwVZbQv57F9a1QiLPUYco8qPdtolcd2DarEWO4xbN7osKGoPdf7ao9u03SVILd5DPy4+n+365n8yNVjW5L+fr/N85H3gLK0FFuZ//9OBSrbpz6mUvImvlpjdYLyV0P7WO5OSP6H0H1y1iQyAJqgujTtkct/EIrH5/5I5e9XWLipbLoiHACzoLUyuiOSjyXaq2RdBPKPqkhm+PjiceEDYAkU1s5TQuVvhzpzPC1wAFwIbWbZKEj+w9Blh14B8nm9XuzAbZG+wAfAAiiyzwuBysd7fodsDnAAYLVuh/Cz9VcDkt8DJX4GwRbf8uvr639V+X2AgAd4une/56M/Cw3+B8HbnuR/i/jDgO+9t3sYADch+rAGwbuY45c2vFrIHkcDYA7iDhPeKXsQW7WkzQRlcXtW+t0XIeLw4dk4n1mQ34do5cCrmH5heABMQ6yy4OVi9hmS34s4ZcL7F3yNDzvTZhLVNzXI34gI5cM7lw1VOQAaEF8c8AYMB3DlnzZ8NP9QwQCYgcjiYzLVoTLkv4Go4mUq1cg4A2A2YoqbRqojJeS/j3jSgJeIH8X3fWnDL3iOFm1Ng4UdEoOv9o/pAZBDHGnC8/tHlKANG4F5JiICAAAAAAAAAAAAgLH8C9FbckvquWD5AAAAAElFTkSuQmCC"

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imageViewPopup = __webpack_require__(929);

var _imageViewPopup2 = _interopRequireDefault(_imageViewPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: studentAttendingPage.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-19
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var StudentAttendingPage =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$timeout", "uploadService", "CQuesConst", "$sce", function StudentAttendingPage($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, uploadService, CQuesConst, $sce) {
    _classCallCheck(this, StudentAttendingPage);

    $scope.isLoading = false;
    var self = this;
    var authoring = localStorageService.get("authoringData");
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.uCanTrust = function (string) {
        // string = "<span style='color: #89a000'>123</span>"
        return $sce.trustAsHtml(string);
    };
    $scope.scope = $scope.$parent;

    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $stateParams.qpId;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var USER_PATH = userId + "/question/";
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;

    $scope.questionsSet = $scope.$parent.questions;
    $scope.$timeout = $timeout;
    // $scope.serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
    // $scope.userPath = userId + "/drawing/"
    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " (_______) ");
    };
    $scope.sortableOptions = {
        containment: '#sortable-container'
    };

    $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
        //console.log(fromState.name)
        if (fromState.name === "studentQuestionPaperPreview") {
            $mdDialog.canel();
        }
    });

    this.$postLink = function () {
        if ($scope.$parent.indexToShow === 0) {
            $mdDialog.cancel();
        }
    };
    $scope.$on('showQuestion', function () {
        $scope.scope = $scope.$parent;

        console.log("&&&&&&&&&&&&&");
        console.log($scope.scope.indexToShow);
        console.log("&&&&&&&&&&&&&");
    });
    function clearCheckPoints() {
        try {
            var current_question = $scope.questionsSet[$scope.scope.indexToShow];
            if (current_question && current_question.type && current_question.type == "MTF" && current_question.optionAnswer && current_question.optionAnswer.length) {
                for (var a = 0; a < current_question.optionAnswer.length; a++) {
                    current_question.optionAnswer[a]['number'] = "";
                }
            }
        } catch (e) {
            console.log(e);
        }
    }
    $scope.dragControlListeners = {
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        },
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {
            $scope.$parent.$parent.isOptionSelected = true;
            clearCheckPoints();
        },
        containment: '#board', //optional param.
        clone: false, //optional param for clone feature.
        allowDuplicates: false //optional param allows duplicates to be dropped.
    };

    function moveObjWithinArray(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };
    $scope.changeValue = function (index, question, answers, key, event) {
        $scope.$parent.$parent.isOptionSelected = true;
        // event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
    };
    $scope.removeAnswerImg = function (index) {
        $scope.$parent.imageData[$scope.$parent.indexToShow].splice(index, 1);
    };
    //Image upload for question
    $scope.answerImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        if (!_.isArray($scope.$parent.imageData[$scope.$parent.indexToShow])) $scope.$parent.imageData[$scope.$parent.indexToShow] = [];
                        $scope.$parent.imageData[$scope.$parent.indexToShow].push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };
    //Open dialog to view image
    $scope.showImage = function (url) {
        var imageObj = {
            image: url
        };
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageDetails: imageObj
            },
            template: _imageViewPopup2.default,
            controller: ['$scope', '$mdDialog', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.imageDetails = imageDetails;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    var MQ = MathQuill.getInterface(2);
    $timeout(function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    }, 1000);

    $scope.formatToLatex = function (type, index, ansType, ansIndex) {
        var answerElements = document.getElementsByClassName('answer-field');
        _.each(answerElements, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            var mathField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        if (type === 'SA') {
                            $scope.$parent.ansSa[$scope.$parent.indexToShow] = mathField.latex();
                        } else if (type === 'LA') {
                            $scope.$parent.ansLa[$scope.$parent.indexToShow] = mathField.latex();
                        } else if (type === 'OWQ') {
                            if (!$scope.$parent.ansOwq[$scope.$parent.indexToShow]) {
                                $scope.$parent.ansOwq[$scope.$parent.indexToShow] = {
                                    choice: []
                                };
                            }
                            $scope.$parent.ansOwq[$scope.$parent.indexToShow] = mathField.latex();
                            $scope.$parent.$parent.setSelectedAns('enteredAns', 'OWQ');
                        } else if (type === 'FIB' || type == 'IBT_FIB') {
                            if (!$scope.$parent.ansFib[$scope.$parent.indexToShow]) {
                                $scope.$parent.ansFib[$scope.$parent.indexToShow] = {
                                    choice: []
                                };
                            }
                            $scope.$parent.ansFib[$scope.$parent.indexToShow].choice[index] = mathField.latex();
                            $scope.$parent.$parent.setSelectedAns('enteredAns', 'FIB');
                        } else if (type === 'ASLLISTEN') {
                            if (ansType === 'fib') {
                                $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer[ansIndex] = mathField.latex();
                            } else if (ansType == 'text') {
                                $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = mathField.latex();
                            }
                        }
                    }
                }
            });
        });
    };

    /*
     * Function to save recorded file url
     *
     * @url : uploaded file url
     *
     * @return : null
     */
    $scope.saveRecordedUrl = function (url, index) {
        if (index >= 0) {
            $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = url;
        } else {
            $scope.$parent.ansAslSpeak[$scope.$parent.indexToShow].answer = url;
        }
    };

    $scope.setFilePath = function (img) {
        var new_url = img ? PREVIEW_URL + img : undefined;
        return new_url;
    };
    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " _______ ");
    };

    //for question -drawing
    /*####################################################################################*/
    $timeout(function () {

        var canvasList = document.getElementsByClassName('canvas');

        _.each(canvasList, function (canvas) {

            if (canvas) {
                var ctx = canvas.getContext('2d');
            }

            $scope.backingScale = function () {
                //var ctx = canvas.getContext('2d');
                var dpr = window.devicePixelRatio || 1;
                /*var bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;*/

                /* return dpr / bsr;*/
            };
            $scope.normalHeight = $window.innerHeight;
            var ratio = $scope.backingScale();
            var w = 600;
            var h = 400;

            $scope.windowWidth = Math.floor(w * ratio);
            $scope.windowHeight = Math.floor(h * ratio);
            $scope.windowInnerWidth = Math.floor(w) + 'px';
            $scope.windowInnerHeight = Math.floor(h) + 'px';
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
            //scope.resetDrawing()
            //ctx.scale(scope.scale,scope.scale);
            //scope.resetDrawing()
            canvas.style.pointerEvents = 'auto|none';

            var drawing = false;
            var lastX = void 0;
            var lastY = void 0;
            ctx.lineJoin = ctx.lineCap = 'round';
            var points = [],
                fhPoints = [];
            var rect = void 0;

            $scope.setTool = function (tool) {
                $scope.toolName = tool;
            };
            $scope.getPdfHeight = function () {
                // pdfHolder = element.find('pdfviewer')[0];

                var ratio = $scope.backingScale();
                var w = 600;
                var h = 400;
                $scope.windowWidth = Math.floor(w * ratio);
                $scope.windowHeight = Math.floor(h * ratio);
                $scope.windowInnerWidth = Math.floor(w) + 'px';
                $scope.windowInnerHeight = Math.floor(h) + 'px';
                ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                //scope.resetDrawing()
                //ctx.scale(scope.scale,scope.scale);
                $scope.resetDrawing();
                canvas.style.pointerEvents = 'auto|none';
            };

            $scope.clearPageAnnotation = function () {
                for (var i in points) {
                    if (points[i].page == $scope.pageNumber) {
                        points.splice(i, 1);
                        //break;
                        $scope.clearPageAnnotation();
                    }
                }
                $scope.resetDrawing();
            };

            $scope.updateNewDrawing = function (pts) {
                points = [];
                points = pts;
                $scope.resetDrawing();
            };
            $scope.setTool = function (toolName, data) {

                for (var i in $scope.tools) {
                    if ($scope.tools[i] != data) {
                        $scope.tools[i].expanded = false;
                    }
                }
                data.expanded = !data.expanded;

                if (data.expanded) {
                    $scope.tool = toolName;
                } else {
                    $scope.tool = '';
                }
            };
            $scope.resetDrawing = function () {
                ctx.clearRect(0, 0, $scope.windowWidth, $scope.windowHeight);
                // Resize original canvas
                //canvas.width = window.innerWidth;
                //canvas.height = window.innerHeight;
                var imgs = [];
                var imgIndex = 0;
                //Load previously Saved Annotation
                for (var i in points) {
                    ctx.beginPath();
                    if (points[i].page == $scope.pageNumber) {
                        //ctx.lineWidth = 2;
                        ctx.lineJoin = ctx.lineCap = 'round';
                        if (points[i].tool_name == 'Pencil') {
                            ctx.lineWidth = points[i].thickness; //scope.lineThickness;
                            ctx.strokeStyle = '#FFFFFF';
                            ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                            for (var j = 1; j < points[i].draw_points.length; j++) {
                                ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                            }
                            ctx.stroke();
                        } else if (points[i].tool_name == 'Marker') {
                            ctx.lineWidth = 15; //points[i].thickness;
                            ctx.strokeStyle = '#000000';
                            if (points[i].draw_points != undefined) {
                                ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                                for (var j = 1; j < points[i].draw_points.length; j++) {
                                    ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                                }
                                ctx.stroke();
                            }
                        }
                    }
                }
            };
            canvas.onmouseover = function (event) {
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }

                for (var i in points) {
                    if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                        if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                            //alert ('Your Notes : ' + points[i].notes);
                            //isNotesOpen = true
                        }
                    }
                }
            };
            canvas.onmouseout = function (event) {
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }

                for (var i in points) {
                    if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                        if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                            //alert ('Your Notes : ' + points[i].notes);
                            //isNotesOpen = true
                        }
                    }
                }
            };
            canvas.addEventListener('touchstart', onTouchStart, false);
            canvas.addEventListener('touchmove', onTouchMove, false);
            canvas.addEventListener('touchend', onTouchEnd, false);

            canvas.addEventListener('mousedown', onMouseStart, false);
            canvas.addEventListener('mousemove', onMouseMove, false);
            canvas.addEventListener('mouseup', onMouseEnd, false);

            $window.addEventListener('load', resize, false);
            $window.addEventListener('resize', resize, false);

            function resize() {}

            /* // Our canvas must cover full height of screen
             // regardless of the resolution
             var height = window.innerHeight;
             // So we need to calculate the proper scaled width
             // that should work well with every resolution
             var ratio = canvas.width / canvas.height;
             var width = height * ratio;
              canvas.style.width = width + 'px';
             canvas.style.height = height + 'px';*/

            // Get the position of a touch relative to the canvas
            function getTouchPos(canvasDom, touchEvent) {
                var rect = canvasDom.getBoundingClientRect();
                return {
                    x: touchEvent.touches[0].clientX - rect.left,
                    y: touchEvent.touches[0].clientY - rect.top
                };
            }
            // Get the position of the mouse relative to the canvas
            function getMousePos(canvasDom, mouseEvent) {
                var rect = canvasDom.getBoundingClientRect();
                return {
                    x: mouseEvent.clientX - rect.left,
                    y: mouseEvent.clientY - rect.top
                };
            }

            document.body.addEventListener("touchstart", function (e) {
                if (e.target == canvas && !drawing) {
                    e.preventDefault();
                }
            }, false);
            document.body.addEventListener("touchend", function (e) {
                if (e.target == canvas && drawing) {
                    e.preventDefault();
                }
            }, false);
            document.body.addEventListener("touchmove", function (e) {
                if (e.target == canvas && drawing) {
                    e.preventDefault();
                }
            }, false);

            function onTouchStart(event) {
                mousePos = getTouchPos(canvas, event);
                var touch = event.touches[0];
                var mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }

            function onTouchMove(event) {
                var touch = event.touches[0];
                var mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }

            function onTouchEnd(event) {
                var mouseEvent = new MouseEvent("mouseup", {});
                canvas.dispatchEvent(mouseEvent);
            }

            function onMouseStart(event) {
                lastX = lastY = '';
                lastPos = getMousePos(canvas, event);
                if (event.offsetX !== undefined) {
                    lastX = event.offsetX;
                    lastY = event.offsetY;
                } else {
                    lastX = lastPos.x; //event.layerX - event.currentTarget.offsetLeft;
                    lastY = lastPos.y; //event.layerY - event.currentTarget.offsetTop;
                }

                // begins new line
                ctx.beginPath();
                fhPoints = [];
                drawing = true;
                var isNotesOpen = false;

                if ($scope.tool == 'Pencil') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = '#FFFFFF'; //$scope.selected; //
                    ctx.fillStyle = '#FFFFFF'; //$scope.selected; //'#FFFFFF';
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    canvas.style.cursor = "url('/pdf/ic_create_cursor.png'), auto";
                } else if ($scope.tool == 'Marker') {
                    ctx.lineWidth = 15; //scope.lineThickness;
                    ctx.strokeStyle = '#000000';
                    //ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    canvas.style.cursor = "url('/pdf/ic_eraser_cursor.png'), auto";
                }
            }

            function onMouseMove(event) {
                if (drawing) {
                    // get current mouse position
                    currentPos = getMousePos(canvas, event);
                    if (event.offsetX !== undefined) {
                        currentX = event.offsetX;
                        currentY = event.offsetY;
                    } else {
                        currentX = currentPos.x; //event.layerX - event.currentTarget.offsetLeft;
                        currentY = currentPos.y; //event.layerY - event.currentTarget.offsetTop;
                    }

                    if ($scope.tool == 'Pencil') {
                        ctx.lineTo(currentX, currentY);
                        fhPoints.push({
                            x: currentX,
                            y: currentY
                        });
                        ctx.stroke();
                    } else if ($scope.tool == 'Marker') {
                        ctx.lineTo(currentX, currentY);
                        fhPoints.push({
                            x: currentX,
                            y: currentY
                        });
                        ctx.stroke();
                    }
                }
            }

            function onMouseEnd(event) {

                var valueObj = {};
                drawing = false;
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }
                if ($scope.tool == 'Pencil') {

                    valueObj = {
                        page: $scope.pageNumber,
                        tool_name: $scope.tool,
                        draw_points: fhPoints,
                        thickness: $scope.lineThickness,
                        user_id: Meteor.userId()

                    };
                    points.push(valueObj);
                    canvas.style.cursor = "default";
                } else if ($scope.tool == 'Marker') {

                    valueObj = {
                        page: $scope.pageNumber,
                        tool_name: $scope.tool,
                        draw_points: fhPoints,
                        thickness: 15,
                        user_id: Meteor.userId()
                    };
                    points.push(valueObj);
                    $scope.resetDrawing();
                    canvas.style.cursor = "default";
                }
            }
            // Get a regular interval for drawing to the screen
            window.requestAnimFrame = function (callback) {
                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimaitonFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
            }();
        });
    }, 0);
    $scope.tools = [{
        tool: 'Pencil',
        expanded: true,
        icon: '/pdf/ic_create.png'
    }, {
        tool: 'Marker',
        expanded: false,
        icon: '/pdf/ic_eraser.png'
    }];
    $scope.tool = 'Pencil';
    $scope.pageNumber = 1;
    $scope.scale = 1.0;
    $scope.lineThickness = 2;
    $scope.totalPageNumber = 1;
    $scope.setTools = function (toolName, data) {

        for (var i in $scope.tools) {
            if ($scope.tools[i] != data) {
                $scope.tools[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;

        if (data.expanded) {
            $scope.tool = toolName;
        } else {
            $scope.tool = '';
        }
    };
    $scope.uploadDrawing = function (index) {
        var today = new Date();
        var day = today.getDay();
        var currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible'; //might need to do this to grandparent nodes as well, possibly.
        html2canvas([document.getElementById('canvas_' + $scope.$parent.indexToShow)], {
            onrendered: function onrendered(canvas) {
                document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible';
                var dataUrl = canvas.toDataURL();
                var fileObj = Upload.dataUrltoBlob(dataUrl);
                uploadService.uploadCheckService(fileObj, $scope.serverUrl, $scope.userPath, function (result) {
                    if (result.url) {
                        self.questions[index].answerImg = result.url;
                        //self.questions[index].answer=result.url;
                    }
                });
            }
        });
    };
    $scope.checkPoint = function (answer_index, question) {
        var selected_opt = question.optionAnswer[answer_index];
        try {
            $scope.$parent.$parent.isOptionSelected = true;
            if (selected_opt['number']) {
                var selected_opt_number = Number(selected_opt['number']);
                if (selected_opt_number <= 0) {
                    selected_opt['number'] = '';
                    toastr.error("Please enter number greater than zero");
                    return;
                }
                if (selected_opt_number > question.option.length) {
                    selected_opt['number'] = '';
                    toastr.error("Please enter number less than or equal to " + question.option.length);
                    return;
                }
                if (selected_opt_number > question.option.length) {
                    selected_opt['number'] = '';
                    toastr.error("Please enter number less than or equal to " + question.option.length);
                    return;
                }
                var result = selected_opt_number - Math.floor(selected_opt_number) !== 0;
                if (result) {
                    selected_opt['number'] = '';
                    toastr.error("Please enter a whole number");
                    return;
                }
                if (selected_opt_number <= question.option.length) {
                    question.optionAnswer.swap(Number(answer_index), selected_opt_number - 1);
                    question.optionAnswer[selected_opt_number - 1]['number'] = selected_opt_number;
                    question.optionAnswer[answer_index]['number'] = '';
                    if (Number(answer_index) == selected_opt_number - 1) {
                        question.optionAnswer[selected_opt_number - 1]['number'] = selected_opt_number;
                    }
                }
            } else {
                return;
            }
        } catch (e) {
            console.log(e);
        }
    };
    /** MCQ answer reset starts */
    $scope.check = function (event, isChecked, index, question, choice) {
        var counter = 0;
        for (var i = 0; i < question.choice.length; i++) {
            if (i == index) {
                question.choice[i]['isChecked'] = true;
            } else {
                question.choice[i]['isChecked'] = false;
            }
            if (question.choice[i]['isChecked']) {
                counter++;
            }
        }
        if (counter) {
            question['answer_exists'] = true;
        } else {
            question['answer_exists'] = false;
        }
        $scope.scope.setSelectedAns(choice.desc, 'MR', null, null, true);
    };
    $scope.checkIfAnswerd = function (question) {
        var multipleCheckAnsData = $scope.scope.multipleCheckAnsData;
        if (multipleCheckAnsData && multipleCheckAnsData[$scope.scope.indexToShow] && multipleCheckAnsData[$scope.scope.indexToShow].length) {
            question['answer_exists'] = true;
        } else {
            question['answer_exists'] = false;
        }
    };
    $scope.resetMCQAns = function () {
        var question = $scope.questionsSet[$scope.scope.indexToShow];
        if (question.type == 'MCQ') {
            if (question.answer && question.answer.length) {
                for (var a = 0; a < question.answer.length; a++) {
                    question.answer.splice(a, 1);
                }
            }
            for (var c = 0; c < question.choice.length; c++) {
                question.choice[c]['isChecked'] = false;
            }
            var requestObj = {
                qp_id: qpId,
                q_index: $scope.scope.indexToShow,
                question: question,
                student_id: userId
            };
            $scope.scope.isOptionSelected = false;
            $scope.$parent.$parent.isOptionSelected = false;
            var multipleCheckAnsData = $scope.scope.multipleCheckAnsData;
            var selectedCheckAns = $scope.scope.selectedCheckAns;
            selectedCheckAns = [];
            multipleCheckAnsData[$scope.scope.indexToShow] = [];
            $scope.scope.totalQuestion[$scope.scope.indexToShow]['status'] = 'normal';
            question['answer_exists'] = false;
            var answFailureArr = localStorageService.get("failureQuestIds");
            if (answFailureArr && answFailureArr.length) {
                for (var i = 0; i < answFailureArr.length; i++) {
                    if (answFailureArr[i] === question.question_id) {
                        answFailureArr.splice(i, 1);
                    }
                }
            }
            authService.callAPI("/v0/qp/reset/mcq/ans", "POST", requestObj, function (response) {
                try {
                    // toastr.info("Answer reset done")
                } catch (e) {
                    console.log(e);
                }
            });
        }
    };
}]
/** MCQ answer reset ends */
;

exports.default = StudentAttendingPage;

Array.prototype.swap = function (x, y) {
    var b = this[x];
    this[x] = this[y];
    this[y] = b;
    return this;
};

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgFJREFUeNqslksoRFEYx+8dk1d2svMoWcwWYUvySBmLSRlFk2RhQSwUFiILC0ljYaMQ4xEbKYUFYmNjSymJBaZkmLzNXP+Tb3I67r3nDL76de89r+91zneubhiGxskCKAUJmrVE6PkC+sGiJhOmhCNkfEkUfJggyjvwCmv8wCnofANRUAnORXtAMmgGPUAHbP4c9S2pehIEEZAjse6APLnmPGqwGu+w0J0oifIZPcfACHk0DxrMBju030kCF95eMEFts6BeHOyULNYGvBT/W9AFLrh5HcBNxkYoAsyjR7Ahy0kefe8Ku6ma2v2GvUzb7a6Y6PRsAgX0/QD2qH0AbJucpzrg486SUrguCVHuwLpJeyYpMeJR4iZ0G4/ZyfeDE5BkNshKScySPlCisNtuwKBVpywn7VTLdBsFbBuv2lkgC9cR8SeRKWGhKpd48goC4Iobp8eTE5bQYgVjU8GQuHVVc8LOQ61CTpbpfQVkk2ffiwmXVhCkAxc41f5JZDnJBUVCrMNgizywkzKwo1K79i1qk0dy34zTOkq1a4osd9BmYO0hblungHxwyCWd3TGdVOtsq3CW7N4musmzAEgDo5y3PpknhSCDLDeEvmdwzB3WJ9BI1dpF7a1gRva3IpMabk4VCHN9LbK/lTVQYXMtM8/uqSDGZBN4wDCYBNPipE8BBgB+kFiVpm7FfQAAAABJRU5ErkJggg=="

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeacherViewReport =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", function TeacherViewReport($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, TeacherViewReport);

    var self = this;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //String - Question paper id
    var qpId = $stateParams.qpId;

    //[String] - label for question vs no of students
    $scope.questionLabels = [];

    //[String] - label for question vs no of students tooltip
    $scope.questionTooltipLabels = [];

    //[Number] - data for question vs no of students
    $scope.quesAttendedStudentsCount = [];

    //[String] - label for tag vs no of students
    $scope.questionTags = [];

    //[Number] - data for tag vs no of students
    $scope.tagAttendedStudentsCount = [];

    //[Number] - data for tag vs no of Questions
    $scope.tagQuesCount = [];

    //[String] - label for Wave vs no of students
    $scope.questionWave = [];

    //[Number] - data for Wave vs no of students
    $scope.waveAttendedStudentsCount = [];

    //[Number] - data for Wave vs no of questions
    $scope.waveQuesCount = [];

    //[String] - label for Level vs no of students
    $scope.questionLevel = [];

    //[Number] - data for Level vs no of students
    $scope.levelAttendedStudentsCount = [];

    //[Number] - data for student vs mark
    $scope.mark = [];

    //[String] - label for student vs rank
    $scope.studentList = [];

    //[Number] - data for student vs rank
    $scope.rank = [];

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 530;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    //[Object] - chart availability
    $scope.chartAvailability = {
        isQuesVsStudent: false
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
    };$scope.goBack = function () {
        var params = $stateParams.prevParams;
        $state.go("wizard.activityReport", params);
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    $scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Activity Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // doc.save('Activity_Based_Report.pdf')
    };
}];

exports.default = TeacherViewReport;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * File: attendeeList.js
 * Project: educore
 * Created Date: 2019-01-09
 * Author: Raziya S
 *
 */

var AttendeeList =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", function AttendeeList($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, AttendeeList);

    var self = this;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //Object - Basic academic details
    var academicDetails = localStorageService.get("authoringData");

    //String - Teaching plan id
    var qpId = $stateParams.qpId;

    //Boolean - Activity created or not
    $scope.isActivityCreated = false;

    /*
     * Function to get assigned users
     * 
     * @qpId : String - Id of the question paper
     * 
     *
     */
    authService.callAPI(activityCons.API_GET_QP_DETAILS + qpId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.details) {
            try {
                $scope.isLoading = false;
                $scope.questionPaper = response.result.data.details;
                if ($scope.questionPaper && $scope.questionPaper.students) {
                    $scope.assignedUsers = $scope.questionPaper.students;
                    $scope.assignedUsers.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                }
            } catch (ex) {
                console.log(ex);
            }
        } else {
            // toastr.error('Network Error. Please try later');
        }
        _.defer(function () {
            $scope.$apply();
        });
    });

    /*
     * Function to go to single student based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoStudentReport = function (id) {
        $state.go("studentViewReport", {
            qpId: qpId,
            studentId: id
        });
    };
}];

exports.default = AttendeeList;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AssignUsers =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "ASSIGN_USER_CONSTANT", "$mdMedia", "$mdDialog", "$stateParams", function AssignUsers($scope, $rootScope, authService, localStorageService, $state, ASSIGN_USER_CONSTANT, $mdMedia, $mdDialog, $stateParams) {
    _classCallCheck(this, AssignUsers);

    this.scope = $scope;
    this.state = $state;
    var authoringData = localStorageService.get("authoringData");
    var authoring = {
        class_id: authoringData.class_id,
        batch_id: authoringData.batch_id,
        subject_id: authoringData.subject_id,
        school_id: authoringData.school_id,
        curriculum_id: authoringData.curriculum_id,
        subject: authoringData.subject,
        class: authoringData.class,
        batch: authoringData.batch,
        session_id: authoringData.session_id,
        session: authoringData.session,
        curriculum: authoringData.curriculum,
        academic_year: authoringData.academic_year

        //Boolean - Assign all students or  not
    };$scope.isAllStudents = false;

    //Boolean - Assign all groups or not
    $scope.isAllGroups = false;

    //[Object] - List of all students in the class
    $scope.allStudents = [];

    //[Object] - List of groups
    $scope.groupList = [];
    var userId = localStorageService.get('user_id');
    var planId = $state.params.planId;

    //Object - basic academic details
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        if (authoring) {
            authoring['user_id'] = userId;
            getGroupList();
            getAllStudents();
        } else {
            $state.go("authdashboard");
        }
    };

    //Object - Assigned users
    $scope.assignedUsers = {};

    //[Object] - Selected Groups
    $scope.selectedGroupList = [];

    //[Object] - Selected Students
    $scope.selectedStudentList = [];

    $scope.isServerCall = false;

    if ($stateParams.previousState.state !== "") {
        localStorageService.set('assignUserHistory', $stateParams.previousState);
        //Object - State param
        $scope.previousState = $stateParams.previousState;
    } else {
        $scope.previousState = localStorageService.get('assignUserHistory');
    }

    if ($scope.previousState == null || $scope.previousState == undefined || $scope.previousState == '') {
        $state.go('viewTeachingPlan', {
            planId: $stateParams.planId
        });
    }
    function getAllStudents() {
        authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_STUDENT_LIST, "POST", authoring, function (response) {
            if (response && response.result && response.result.data) {
                if (response.result.data.data.length > 0) $scope.allStudents = response.result.data.data;
                $scope.$apply();
            }
        });
    }

    function getGroupList() {
        authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_GROUP_DETAILS, "POST", authoring, function (response) {
            if (response && response.result && response.result.data) {
                var groupList = response.result.data.data;
                authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_ASSIGNED_USERS + planId, "POST", {}, function (response) {
                    if (response && response.result && response.result.data) {
                        var result = response.result.data.data;
                        if (result && result.type == "all") {
                            var list = [];
                            _.each($scope.allStudents, function (student) {
                                list.push({
                                    _id: student.user_id
                                });
                            });
                            $scope.selectedStudentList = list;
                            $scope.isAllStudents = true;
                        }

                        _.each(groupList, function (group) {
                            var isLeader = false;
                            var leaderName = '';
                            _.each(group.students, function (student) {
                                if (student.leader) {
                                    isLeader = true;
                                    if (leaderName === '') leaderName = student.name;else leaderName += ", " + student.name;
                                }
                            });
                            group.isLeader = isLeader;
                            group.leaderName = leaderName;
                            group.isSelected = false;
                            if (result && result.type == "group") {
                                var assignGroup = _.find(result.list, function (obj) {
                                    return group._id == obj._id;
                                });
                                if (assignGroup) {
                                    group.isSelected = true;
                                    $scope.selectedGroupList.push({
                                        _id: group._id
                                    });
                                }
                            }
                        });
                        if (result && result.type == "group" && result.list.length == groupList.length) $scope.isAllGroups = true;
                        $scope.groupList = groupList;
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });;
                });
            }
        });
    }

    $scope.allStudentsSelected = function () {
        $scope.isServerCall = true;
        $scope.selectedGroupList = [];
        $scope.isAllGroups = false;
        _.each($scope.groupList, function (group) {
            group.isSelected = false;
        });
        if ($scope.selectedStudentList.length === 0) {
            //[Object] - List of student Ids
            var list = [];
            _.each($scope.allStudents, function (student) {
                list.push({
                    _id: student._id,
                    name: student.name
                });
            });
            $scope.selectedStudentList = list;
            $scope.selectedGroupList = [];
        } else $scope.selectedStudentList = [];
    };

    $scope.allGroupSelected = function () {
        $scope.isServerCall = true;
        $scope.selectedGroupList = [];
        $scope.isAllStudents = false;
        //[Object] - List of student Ids
        var list = [];
        _.each($scope.groupList, function (group) {
            group.isSelected = !$scope.isAllGroups;
            if (group.isSelected) list.push({
                _id: group._id
            });
        });
        $scope.selectedGroupList = list;
        $scope.selectedStudentList = [];
    };

    $scope.groupSelected = function (group, index) {
        $scope.isServerCall = true;
        $scope.isAllStudents = false;
        $scope.selectedStudentList = [];
        if (!group.isSelected) {
            if ($scope.selectedGroupList.findIndex(function (i) {
                return i._id === group._id;
            }) == -1) $scope.selectedGroupList.push({
                _id: group._id
            });
        } else $scope.selectedGroupList = _.without($scope.selectedGroupList, _.findWhere($scope.selectedGroupList, {
            _id: group._id
        }));
        if ($scope.selectedGroupList.length == $scope.groupList.length) $scope.isAllGroups = true;else $scope.isAllGroups = false;
    };

    $scope.assignGroupUsers = function () {
        var previousState = $scope.previousState;
        if (previousState.state === "") {
            previousState = localStorageService.get('assignUserHistory');
            localStorageService.clear('assignUserHistory');
        }
        if ($scope.selectedStudentList.length > 0 || $scope.selectedGroupList.length > 0) {
            if ($scope.selectedGroupList.length > 0) {
                $scope.assignedUsers = {
                    type: "group",
                    list: $scope.selectedGroupList
                };
            }
            if ($scope.selectedStudentList.length > 0) {
                $scope.assignedUsers = {
                    type: "all",
                    list: $scope.selectedStudentList
                };
            }
        } else {
            toastr.error("Select Students to assign");
            return false;
        }
        if ($scope.isServerCall) {
            var state_details = ["viewTeachingPlan", "wizard"];
            if (previousState.params.planId && previousState.params.resourceId) {
                var assigneeDetails = {
                    tp_id: planId,
                    assigned_users: $scope.assignedUsers,
                    academic_details: authoring,
                    user_id: userId,
                    res_id: previousState.params.resourceId
                };
                console.log(assigneeDetails);
                authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_RESOURCE_ASSIGNEE_DETAILS, "POST", assigneeDetails, function (response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Students assigned");
                        $state.go(previousState.state, previousState.params);
                    }
                });
            } else if (previousState.params.planId && !previousState.params.resourceId) {

                var _assigneeDetails = {
                    tp_id: planId,
                    assigned_users: $scope.assignedUsers,
                    academic_details: authoring,
                    user_id: userId
                };
                console.log(_assigneeDetails);
                authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_ASSIGNEE_DETAILS, "POST", _assigneeDetails, function (response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Students assigned");
                        $state.go(previousState.state, previousState.params);
                    }
                });
            }
        } else {
            $state.go(previousState.state, previousState.params);
        }
    };

    $scope.cancelAssignUser = function () {
        $state.go('viewTeachingPlan', {
            planId: planId
        });
    };

    $scope.createNewGroup = function () {
        $state.go('createGroup', {
            planId: planId, groupId: ""
        });
    };

    $scope.toggleExpansion = function (accordianData, selectedData, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !selectedData.expanded;
        });
    };

    /*
     * Function to open menu
     *
     * @return : null
     */
    $scope.openMenu = function ($mdOpenMenu, ev) {
        var originatorEv = ev;
        $mdOpenMenu(ev);
    };

    $scope.editGroup = function (groupId) {
        $state.go('createGroup', { planId: planId, groupId: groupId });
    };

    $scope.deleteGroup = function (groupId) {
        var confirm = $mdDialog.confirm().textContent('Do you want to delete Group?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            authService.callAPI(ASSIGN_USER_CONSTANT.API_DELETE_GROUP + groupId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    toastr.success("Student group deleted successfully");
                    getGroupList();
                    getAllStudents();
                }
            });
        }, function () {});
    };

    this.$onDestroy = function () {};
}];

exports.default = AssignUsers;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateGroup =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "ASSIGN_USER_CONSTANT", "$mdMedia", "$mdDialog", "$stateParams", function CreateGroup($scope, $rootScope, authService, localStorageService, $state, ASSIGN_USER_CONSTANT, $mdMedia, $mdDialog, $stateParams) {
    _classCallCheck(this, CreateGroup);

    this.scope = $scope;
    this.state = $state;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //[Object] - List of all students in class
    $scope.studentList = [];

    //[Object] - List of student in group
    $scope.groupStudents = [];

    $scope.leader = undefined;

    //To get current user id
    var userId = localStorageService.get('user_id');
    var planId = $state.params.planId;

    //Object - basic academic details
    var authoringData = localStorageService.get("authoringData");
    var academicDetails = {
        class_id: authoringData.class_id,
        batch_id: authoringData.batch_id,
        subject_id: authoringData.subject_id,
        school_id: authoringData.school_id,
        curriculum_id: authoringData.curriculum_id,
        subject: authoringData.subject,
        class: authoringData.class,
        batch: authoringData.batch,
        session_id: authoringData.session_id,
        session: authoringData.session,
        curriculum: authoringData.curriculum,
        academic_year: authoringData.academic_year,
        user_id: userId
    };

    $scope.isShowWaveFilter = false;

    $scope.isEdit = false;

    $scope.isEdited = false;

    if (academicDetails == null || academicDetails == undefined || academicDetails == '') {
        $state.go('dashboard');
    }

    if ($stateParams.groupId) {
        $scope.isEdit = true;
        /*Meteor.call('getStudentListwithGroupDetails', academicDetails, $stateParams.groupId, (error, result) => {
            if (result) {
        */
        academicDetails['group_id'] = $stateParams.groupId;
        authService.callAPI(ASSIGN_USER_CONSTANT.API_STUDENT_GROUP_DETAILS, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                var result = response.result.data.data;
                var studentList = result.studentList;
                var groupDetails = result.groupDetails;
                $scope.groupName = groupDetails.group_name;
                _.each(groupDetails.students, function (student) {
                    var studentDetail = _.find(studentList, function (stu) {
                        return student._id === stu._id;
                    });
                    if (studentDetail) {
                        studentDetail.isLeader = student.leader;
                        $scope.groupStudents.push(studentDetail);
                        studentList = _.filter(studentList, function (stu) {
                            return student._id !== stu._id;
                        });
                    }
                });
                var leader = _.find($scope.groupStudents, function (eachStudent) {
                    return eachStudent.isLeader;
                });
                if (leader) $scope.leader = leader._id;
                studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                $scope.studentList = studentList;
                $scope.studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                $scope.isShowWaveFilter = true;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        });
    } else {
        authService.callAPI(ASSIGN_USER_CONSTANT.API_GET_STUDENT_LIST, "POST", academicDetails, function (response) {
            if (response && response.result && response.result.data) {
                if (response.result.data.data.length > 0) {
                    $scope.studentList = response.result.data.data;
                    $scope.studentList.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                    $scope.allstudentList = response.result.data.data;

                    $scope.isShowWaveFilter = true;
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }

    $scope.filterStudents = function (wave) {
        var waveStudents = [];
        var otherStudents = [];
        $scope.isEdited = true;
        _.each($scope.allstudentList, function (eachStud, index) {
            var flag = false;
            _.each(eachStud.wave, function (eachWave) {
                if (eachWave.subject_id === academicDetails.subject_id) {
                    if (eachWave.current_wave.wave_id === wave) {
                        waveStudents.push(eachStud);
                        flag = true;
                    }
                }
            });
            if (!flag) otherStudents.push(eachStud);
        });
        $scope.groupStudents = waveStudents;
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList = otherStudents;
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    /*
     * Function to add student to group
     * 
     * @id : String - id of student to add
     *
     * @return : null
     */
    $scope.addtoGroup = function (id) {
        var index = void 0;
        $scope.isEdited = true;
        _.each($scope.studentList, function (student, key) {
            if (student._id == id) index = key;
        });
        if (index > -1) {
            $scope.groupStudents.push($scope.studentList[index]);
            $scope.studentList.splice(index, 1);
        }
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    /*
     * Function to remove student from group
     * 
     * @id : String - id of student to remove
     *
     * @return : null
     */
    $scope.removefromGroup = function (id) {
        var index = void 0;
        $scope.isEdited = true;
        _.each($scope.groupStudents, function (student, key) {
            if (student.user_id == id) index = key;
        });
        if (index > -1) {
            $scope.studentList.push($scope.groupStudents[index]);
            $scope.groupStudents.splice(index, 1);
        }
        $scope.groupStudents.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        $scope.studentList.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    $scope.updateEdit = function () {
        $scope.isEdited = true;
    };

    $scope.saveGroup = function () {
        var errCount = 0;
        if ($scope.groupName == undefined || $scope.groupName == "") {
            $scope.groupNameError = "Please, Enter Group Name";
            errCount++;
        } else {
            $scope.groupNameError = "";
        }
        if ($scope.groupStudents.length == 0) {
            $scope.studentError = "Please, Add Student(s) for group";
            errCount++;
        } else {
            $scope.studentError = "";
        }
        if (!$scope.leader) {
            $scope.leaderError = "Please, Select Group Leader";
            errCount++;
        } else {
            $scope.leaderError = "";
        }
        if (errCount == 0) {
            if ($scope.groupStudents.length > 0) {
                var studentList = [];
                // _.each($scope.groupStudents, function(student) {
                //     if (!student.isLeader) {
                //         student.isLeader = false
                //     }
                //     let obj = {
                //         _id: student._id,
                //         name: student.name,
                //         leader: student.isLeader
                //     }
                //     studentList.push(obj)
                // })
                _.each($scope.groupStudents, function (student) {
                    var obj = {
                        _id: student._id,
                        name: student.name,
                        leader: student._id === $scope.leader ? true : false
                    };
                    studentList.push(obj);
                });
                studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
                if ($scope.isEdit) {
                    var group = {
                        group_name: $scope.groupName,
                        teacher_id: userId,
                        status: 'active',
                        academic_year: academicDetails.academic_year,
                        session_id: academicDetails.session_id,
                        curriculum_id: academicDetails.curriculum_id,
                        subject_id: academicDetails.subject_id,
                        class_id: academicDetails.class_id,
                        batch_id: academicDetails.batch_id,
                        school_id: academicDetails.school_id,
                        assigned_resources: 0,
                        assigned_activity: 0,
                        group_id: $stateParams.groupId,
                        students: studentList
                    };
                    authService.callAPI(ASSIGN_USER_CONSTANT.API_UPDATE_STUDENT_GROUP, "POST", group, function (response) {
                        if (response && response.result && response.result.data) {
                            console.log(response.result.data);
                            toastr.success("Group edited successfully");
                            $state.go('assignUsers', { planId: planId });
                        }
                    });
                } else {
                    var _group = {
                        group_name: $scope.groupName,
                        teacher_id: userId,
                        status: 'active',
                        academic_year: academicDetails.academic_year,
                        session_id: academicDetails.session_id,
                        curriculum_id: academicDetails.curriculum_id,
                        subject_id: academicDetails.subject_id,
                        class_id: academicDetails.class_id,
                        batch_id: academicDetails.batch_id,
                        school_id: academicDetails.school_id,
                        assigned_resources: 0,
                        assigned_activity: 0,
                        students: studentList
                    };
                    authService.callAPI(ASSIGN_USER_CONSTANT.API_ADD_STUDENT_GROUP, "POST", _group, function (response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Group added successfully");
                            $state.go('assignUsers', { planId: planId });
                        }
                    });
                }
            }
        } else {
            return false;
        }
    };

    $scope.backToGroupList = function () {
        $state.go('assignUsers', $stateParams);
    };

    this.$onDestroy = function () {};
}];

exports.default = CreateGroup;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: createImmunizationForm.js
 * Project: educore
 * Created Date: 2019-03-13
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var CreateImmunizationForm =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", "$mdDialog", function CreateImmunizationForm($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, $mdDialog) {
    _classCallCheck(this, CreateImmunizationForm);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    var academicYear = localStorageService.get('academic_year');
    $scope.selectedSubjects = [];
    $scope.messageDetails = [];
    var data = {
        question: "wewe"
    };
    $scope.questionObj = {};
    $scope.topicList = [{
        "name": "Objective",
        "description": "objective"
    }, {
        "name": "Descriptive",
        "description": "descriptive"
    }, {
        "name": "Time",
        "description": "time"
    }];

    $scope.showDescription = false;
    var immunizationForm = void 0;

    function fetchQuestions() {
        authService.callAPI(MEDICALCONSTANT.API_GET_QUESTION + schoolId + '/' + academicYear, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                console.log(response.result);
                if (response.result.data.data.length > 0) {
                    immunizationForm = response.result.data.data[0];
                    $scope.questionDetails = response.result.data.data[0].questions;
                }

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }
    fetchQuestions();
    $scope.addQuestion = function () {
        //Validation  
        $scope.errors = {};
        var errrorCount = 0;
        if ($scope.questionObj.question == null || $scope.questionObj.question == undefined || $scope.questionObj.question == "") {
            $scope.errors["question"] = "Question is required";
            errrorCount++;
        }
        if ($scope.questionObj.type == null || $scope.questionObj.type == undefined || $scope.questionObj.type == "") {
            $scope.errors["type"] = "Question type is required";
            errrorCount++;
        }
        if (errrorCount === 0) {
            var obj = {
                question: $scope.questionObj.question ? $scope.questionObj.question : null,
                type: $scope.questionObj.type ? $scope.questionObj.type : null,
                school_id: schoolId,
                user_id: userId,
                academic_year: academicYear
            };
            authService.callAPI(MEDICALCONSTANT.API_CREATE_QUESTION, "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Successfully created a Question");
                    fetchQuestions();
                }
            });
            $scope.questionObj = {};
        }
    };

    $scope.editAndSubmitQuestion = function () {
        if ($scope.questionObj) {
            if ($scope.questionObj._id) {
                var obj = {
                    question: $scope.questionObj.question ? $scope.questionObj.question : null,
                    type: $scope.questionObj.type ? $scope.questionObj.type : null,
                    _id: $scope.questionObj._id,
                    user_id: userId
                };
                $scope.errors = {};
                authService.callAPI(MEDICALCONSTANT.API_UPDATE_QUESTION, "POST", obj, function (response) {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Question updated successfully");
                        console.log(response.result);
                        $scope.isEdit = false;
                        $scope.flagForEdit = false;
                        fetchQuestions();
                    } else {
                        $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Warning').textContent('Cannot edit.Question has been sent to users').ariaLabel('Alert Dialog Demo').ok('Ok').targetEvent());
                    }
                });
                $scope.questionObj = {};
            }
        }
    };

    $scope.editQuestion = function (index, data) {
        $scope.isEdit = true;
        $scope.errors = {};
        if (data) {
            if (data._id && data.question) {
                $scope.flagForEdit = true;
                if (!$scope.questionObj) {
                    $scope.questionObj = {};
                }
                $scope.questionObj._id = data._id;
                $scope.questionObj.question = data.question;
                $scope.questionObj.type = data.type;
                if (data.type === "descriptive") {
                    $scope.showDescription = true;
                } else {
                    $scope.showDescription = false;
                }
            }
        }
    };

    $scope.cancelEdit = function () {
        $scope.isEdit = false;
        $scope.showDescription = false;
        $scope.flagForEdit = false;
        $scope.questionObj = {};
        $scope.errors = {};
    };

    $scope.deleteQuestion = function (index, data) {
        var questAnswer = void 0;
        if (immunizationForm && immunizationForm.questions_answers) {
            questAnswer = _.find(immunizationForm.questions_answers, function (obj) {
                return data._id === obj._id;
            });
        }
        if (questAnswer) {
            $mdDialog.show($mdDialog.alert().parent(angular.element(document.querySelector('#popupContainer'))).clickOutsideToClose(true).title('Warning').textContent('Cannot delete.Question has been sent to users').ariaLabel('Alert Dialog Demo').ok('Ok').targetEvent());
            return false;
        } else {
            var confirm = $mdDialog.confirm().title('Do you want to delete this question?').clickOutsideToClose(true).ariaLabel('Confirm delete').ok('Yes').cancel('Cancel');
            $mdDialog.show(confirm).then(function () {
                authService.callAPI(MEDICALCONSTANT.API_DELETE_QUESTION + data._id, "GET", {}, function (response) {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Question deleted Successfully");
                        fetchQuestions();
                        $scope.questionObj = {};
                        $scope.showDescription = false;
                        $scope.flagForEdit = false;
                    }
                });
            });
        }
    };
    $scope.showDescConsole = function () {
        var type = $scope.questionObj.type;
        if (type === "descriptive") {
            $scope.showDescription = true;
        } else {
            $scope.showDescription = false;
        }
    };

    $scope.goBack = function () {
        $state.go("filterStudents");
    };
}];

exports.default = CreateImmunizationForm;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: medicalFeatureList.js
 * Project: educore
 * Created Date: 2019-03-12
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var MedicalFeatureController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", function MedicalFeatureController($scope, $rootScope, localStorageService, $state) {
    _classCallCheck(this, MedicalFeatureController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //To get Roles and Privileges
    var medicalUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "medicalFeatureList";
    });
    var medicalUserPrivilege = {};
    if (medicalUserAccess.length > 0) {
        _.each(medicalUserAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            medicalUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    var featuresList = [{
        "_id": "userProfile",
        "name": "User Profile",
        "state": "userFilter",
        "icon": "../../../img/medical/incidents.png",
        "color": "#f16e02"
    }, {
        "_id": "programme",
        "name": "Programme",
        "state": "viewProgramme",
        "icon": "../../../img/medical/medical.png",
        "color": "#00b4bd"
    }, {
        "_id": "inventory",
        "name": "Inventory",
        "state": "inventoryList",
        "icon": "../../../img/medical/medical.png",
        "color": "#f35966"

    }, {
        "_id": "purchase",
        "name": "Purchase",
        "state": "purchaseList",
        "icon": "../../../img/medical/medical.png",
        "color": "#00ba9c"
    }, {
        "_id": "programmeConsole",
        "name": "Programme Console",
        "state": "programmeConsole",
        "icon": "../../../img/medical/medical.png",
        "color": "#00b4bd"
    }, {
        "_id": "medicalDashboard",
        "name": "Medical Dashboard",
        "state": "medicalProfile",
        "icon": "../../../img/medical/medical_dashboard.png",
        "color": "#f35966"
    }, {
        "_id": "childMedicalProfile",
        "name": "Child Medical Profile",
        "state": "childProfile",
        "icon": "../../../img/medical/child_view.png",
        "color": "#f16e02"
    }, {
        "_id": "createImmunization",
        "name": "Create Immunization",
        "state": "createImmunization",
        "icon": "../../../img/medical/medical_questions.png",
        "color": "#00ba9c"
    }];

    if (medicalUserPrivilege != undefined) {
        $scope.featuresList = [];
        _.each(medicalUserPrivilege, function (obj, key) {
            var feature = _.find(featuresList, function (featureObj) {
                return featureObj._id === key;
            });
            if (feature) $scope.featuresList.push(feature);
        });
    }

    /*
     * To navigate to selected page
     * 
     * @feature : Object - Selected feature detail
     * 
     * @return : null
     *
     * 
     */
    $scope.navigatePage = function (feature) {
        console.log(feature);
        $state.go(feature.state, {}, {
            reload: true
        });
    };

    this.$onDestroy = function () {};
}];

exports.default = MedicalFeatureController;

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IncidentController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", function IncidentController($scope, $rootScope, localStorageService, $state) {
    _classCallCheck(this, IncidentController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    $scope.showCreateDiv = true;
    var userId = void 0;
    var selectedUsers = localStorageService.get('selectedUsers');
    if (selectedUsers && selectedUsers.length === 1) userId = selectedUsers[0].user_id;
    $scope.gotoFirstAid = function () {
        $state.go("firstAidForm");
    };
    $scope.gotoRedirectForm = function () {
        $state.go("referralForm");
    };
    $scope.gotoVaccinationForm = function () {
        $state.go("vaccinationForm");
        /*if (selectedUsers) {
            if (selectedUsers.length === 1) {
                $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                    "type": "reply",
                    "user_id": userId,
                    "doctor_id": Meteor.userId()
                })
                if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied") {
                    $state.go("vaccinationForm")
                } else
                    toastr.error("This user doesn't replied for immunization questions")
            } else {
                let userCount = selectedUsers.length
                $scope.selectedUsersForVaccination = []
                _.each(selectedUsers, function(eachUser) {
                    $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                        "type": "reply",
                        "user_id": eachUser.user_id,
                        "doctor_id": Meteor.userId()
                    })
                    if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied")
                        $scope.selectedUsersForVaccination.push(eachUser)
                 })
                if ($scope.selectedUsersForVaccination && $scope.selectedUsersForVaccination.length > 0) {
                    $state.go("vaccinationForm")
                } else
                    toastr.error("None of the users replied for Immunization questions")
            }
        }*/
    };
}];

exports.default = IncidentController;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FirstAidController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$stateParams", "MEDICALCONSTANT", "authService", function FirstAidController($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {
    _classCallCheck(this, FirstAidController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    var patientid = "";
    $scope.selectedUsers = localStorageService.get('selectedUsers');
    authService.callAPI(MEDICALCONSTANT.API_GET_MEDICINE_LIST + schoolId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            if (response.result.data.data.length > 0) $scope.medicineList = response.result.data.data;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.selectedMedicine = function (medicineName) {
        $scope.batchIds = [];
        _.each($scope.medicineList, function (eachPdt) {
            if (eachPdt.medicine_name === medicineName) {
                $scope.batchIds.push({
                    'batch_no': eachPdt.batch_no,
                    'exp_date': eachPdt.exp_date
                });
            }
        });
        $scope.batchIds.sort(function (a, b) {
            var nameA = a.exp_date;
            var nameB = b.exp_date;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    };
    $scope.expDateError = null;
    $scope.selectedBatchId = function (batchId) {
        if ($scope.batchIds[0].batch_no !== batchId) $scope.expDateError = "Please select first batchId in the list having least expiry date";else $scope.expDateError = null;

        $scope.quantity = [];
        _.each($scope.medicineList, function (eachPdt) {
            if (eachPdt.batch_no === batchId) {
                if (eachPdt.remaining_count > 0) {

                    for (var i = 1; i <= eachPdt.remaining_count; i++) {
                        $scope.quantity.push(i);
                    }
                }
            }
        });
    };

    $scope.firstAid = {};
    if ($stateParams.userId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
        if ($stateParams.is_edit) {
            $scope.isEdit = true;
        }
        $scope.firstAid.complaint = $stateParams.data.complaint;
        $scope.firstAid.treatement = $stateParams.data.treatment_given;
        $scope.firstAid.remarks = $stateParams.data.remarks;
    }

    $scope.saveFirstAid = function () {
        $scope.errors = {};
        var errCount = 0;
        var obj = {
            complaint: $scope.firstAid.complaint ? $scope.firstAid.complaint : null,
            treatement: $scope.firstAid.treatement ? $scope.firstAid.treatement : null,
            remarks: $scope.firstAid.remarks ? $scope.firstAid.remarks : null,
            medicine: $scope.firstAid.medicine ? $scope.firstAid.medicine : null,
            quantity: $scope.firstAid.quantity ? $scope.firstAid.quantity : null,
            batch_id: $scope.firstAid.batch_id ? $scope.firstAid.batch_id : null,
            follow_up: $scope.firstAid.follow_up ? $scope.firstAid.follow_up : null,
            selected_users: $scope.selectedUsers,
            user_id: userId
        };
        if (errCount > 0) {
            console.log("***");
        } else {
            if ($stateParams.is_edit === true && $stateParams.data !== true) {
                /*Meteor.call("editFirstAid", obj, $scope.selectUser, $stateParams.data._id, function(error, result) {
                    if (error) {
                        toastr.error(error.reason)
                    } else {
                        $scope.errors = {}
                        ToastService.getToastbox($mdToast, "Successfully edited", 'warn-toast');
                        $state.go("medicalProfile", {
                            userId: $scope.selectUser
                        })
                    }
                })*/

            } else {
                if ($scope.expDateError === null) {
                    authService.callAPI(MEDICALCONSTANT.API_SAVE_FIRST_AID, "POST", obj, function (response) {
                        if (response.result && response.result.data && response.result.data.data) {
                            $state.go("userProfile");
                        }
                    });
                }
            }
        }
    };
}];

exports.default = FirstAidController;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReferralFormController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$stateParams", "MEDICALCONSTANT", "authService", function ReferralFormController($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {
    _classCallCheck(this, ReferralFormController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    $scope.selectedUsers = localStorageService.get('selectedUsers');
    $scope.referal = {};
    authService.callAPI(MEDICALCONSTANT.API_GET_MEDICINE_LIST + schoolId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            if (response.result.data.data.length > 0) $scope.medicineList = response.result.data.data;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.selectedMedicine = function (medicineName) {
        $scope.batchIds = [];
        _.each($scope.medicineList, function (eachPdt) {
            if (eachPdt.medicine_name === medicineName) {
                $scope.batchIds.push({
                    'batch_no': eachPdt.batch_no,
                    'exp_date': eachPdt.exp_date
                });
            }
        });
        $scope.batchIds.sort(function (a, b) {
            var nameA = a.exp_date;
            var nameB = b.exp_date;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    };
    $scope.expDateError = null;
    $scope.selectedBatchId = function (batchId) {
        if ($scope.batchIds[0].batch_no !== batchId) $scope.expDateError = "Please select first batchId in the list having least expiry date";else $scope.expDateError = null;

        $scope.quantity = [];
        _.each($scope.medicineList, function (eachPdt) {
            if (eachPdt.batch_no === batchId) {
                if (eachPdt.remaining_count > 0) {

                    for (var i = 1; i <= eachPdt.remaining_count; i++) {
                        $scope.quantity.push(i);
                    }
                }
            }
        });
    };
    if ($stateParams.studentId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
        $scope.isEdit = true;
        $scope.referal.date = $stateParams.data.date_incident_occured;
        $scope.referal.time = $stateParams.data.time_incident_occured;
        $scope.referal.injury_type = $stateParams.data.injury_type;
        $scope.referal.from_exercise_session = $stateParams.data.absence_day[0].from_exercise_session;
        $scope.referal.from_school = $stateParams.data.absence_day[0].from_school;
        $scope.referal.injury_cause = $stateParams.data.injury_cause;
        $scope.referal.injury_level = $stateParams.data.injury_level;
        $scope.referal.blood_group = $stateParams.data.blood_group;
        $scope.referal.injured_part_body = $stateParams.data.injured_part_body;
    }
    $scope.saveReferalForm = function () {
        $scope.errors = {};
        var errorCount = 0;
        var obj = {
            date: $scope.referal.date ? $scope.referal.date : null,
            time: $scope.referal.time ? $scope.referal.time : null,
            injury_type: $scope.referal.injury_type ? $scope.referal.injury_type : null,
            injured_body_part: $scope.referal.injured_body_part ? $scope.referal.injured_body_part : null,
            injury_level: $scope.referal.injury_level ? $scope.referal.injury_level : null,
            injury_cause: $scope.referal.injury_cause ? $scope.referal.injury_cause : null,
            from_exercise_session: $scope.referal.from_exercise_session ? $scope.referal.from_exercise_session : null,
            from_school: $scope.referal.from_school ? $scope.referal.from_school : null,
            accident_location: $scope.referal.accident_location ? $scope.referal.accident_location : null,
            medicine: $scope.referal.medicine ? $scope.referal.medicine : null,
            batch_id: $scope.referal.batch_id ? $scope.referal.batch_id : null,
            quantity: $scope.referal.quantity ? $scope.referal.quantity : null,
            follow_up: $scope.referal.follow_up ? $scope.referal.follow_up : null,
            selected_users: $scope.selectedUsers,
            user_id: userId
        };
        if (errorCount === 0) {
            if ($stateParams.is_edit === true && $stateParams.data !== true) {
                /* Meteor.call("editReferalIncident", obj, $scope.selectUser, $stateParams.data._id, function(error, result) {
                     if (error) { // if it fails, show error message
                         toastr.error(error.reason);
                         return;
                     } else {
                         $scope.errors = {}
                         toastr.success("Successfully edited");
                         $state.go("medicalUserProfile", {
                             userId: $scope.selectUser
                         })
                     }
                 })*/
            } else {
                if ($scope.expDateError === null) {
                    authService.callAPI(MEDICALCONSTANT.API_SAVE_REFERRAL_FORM, "POST", obj, function (response) {
                        if (response.result && response.result.data && response.result.data.data) {
                            $state.go("userProfile");
                        }
                    });
                }
            }
        }
    };
}];

exports.default = ReferralFormController;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VaccinationController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$stateParams", "MEDICALCONSTANT", "authService", function VaccinationController($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {
    _classCallCheck(this, VaccinationController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    //Meteor.subscribe('getMedicalInventoryList', schoolId);
    //Meteor.subscribe('getImmuzationReply', schoolId)
    $scope.selectedUsers = localStorageService.get('selectedUsers');
    authService.callAPI(MEDICALCONSTANT.API_GET_VACCINATION_LIST + schoolId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            if (response.result.data.data.length > 0) $scope.medicineList = response.result.data.data;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.selectedMedicine = function (medicineName) {
        $scope.batchIds = [];
        _.each($scope.medicineList, function (eachPdt) {
            if (eachPdt.medicine_name === medicineName) {
                $scope.batchIds.push({
                    'batch_no': eachPdt.batch_no,
                    'exp_date': eachPdt.exp_date
                });
            }
        });
        $scope.batchIds.sort(function (a, b) {
            var nameA = a.exp_date;
            var nameB = b.exp_date;
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    };
    $scope.selectedBatchId = function (batchId) {
        if ($scope.batchIds[0].batch_no !== batchId) $scope.expDateError = "Please select first batchId in the list having least expiry date";else $scope.expDateError = null;
    };
    /*$scope.autorun(() => {
        if ($scope.selectedUsers.length > 0) {
            $scope.selectedUsersForVaccination = []
            _.each($scope.selectedUsers, function(eachUser) {
                    $scope.getDiagnosticReply = Doctor_Immunization.findOne({
                        "type": "reply",
                        "user_id": eachUser.user_id,
                        "doctor_id": Meteor.userId()
                    })
                    if ($scope.getDiagnosticReply && $scope.getDiagnosticReply.status == "replied")
                        $scope.selectedUsersForVaccination.push(eachUser)
                 })
        }
    })*/
    /*$scope.autorun(() => {
        $scope.productList = Medical_Inventory.find({
            category: "Vaccines"
        }, {
            sort: {
                added_date: -1
            }
        }).fetch()
        $scope.medicineList = []
        Meteor.call("currentDate", function(error, result) {
            if (result) {
                _.each($scope.productList, function(eachPdt) {
                    if (result < eachPdt.exp_date && eachPdt.remaining_count > 0) {
                        $scope.medicineList
    .push(eachPdt)
                    }
                })
                $scope.$apply()
            }
        })
          $scope.selectedMedicine = (medicineName) => {
            $scope.batchIds = []
            _.each($scope.medicineList, function(eachPdt) {
                if (eachPdt.medicine_name === medicineName) {
                    $scope.batchIds.push({
                        'batch_no': eachPdt.batch_no,
                        'exp_date': eachPdt.exp_date
                    })
                 }
            })
            $scope.batchIds.sort(function(a, b) {
                var nameA = a.exp_date
                var nameB = b.exp_date
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        }
        $scope.selectedBatchId = (batchId) => {
            if ($scope.batchIds[0].batch_no !== batchId)
                $scope.expDateError = "Please select first batchId in the list having least expiry date"
            else
                $scope.expDateError = null
        }
     })*/
    $scope.today = new Date();
    $scope.vaccination = {};
    if ($stateParams.studentId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
        $scope.isEdit = true;
        $scope.vaccination.vaccination_name = $stateParams.data.vaccine_name;
        $scope.vaccination.manufactured_date = $stateParams.data.mfg_date;
        $scope.vaccination.expiry_date = $stateParams.data.expiry_date;
        $scope.vaccination.remarks = $stateParams.data.remarks;
        $scope.vaccination.vaccination_batch = $stateParams.data.batch_no;
    }
    $scope.vaccinationSubmit = function () {
        $scope.errors = {};
        var errorCount = 0;
        var obj = {
            vaccination_name: $scope.vaccination.vaccination_name ? $scope.vaccination.vaccination_name : null,
            remarks: $scope.vaccination.remarks ? $scope.vaccination.remarks : null,
            vaccination_batch: $scope.vaccination.vaccination_batch ? $scope.vaccination.vaccination_batch : null,
            follow_up: $scope.vaccination.follow_up ? $scope.vaccination.follow_up : null,
            selected_users: $scope.selectedUsers,
            user_id: userId
        };

        if (errorCount === 0) {
            if ($stateParams.is_edit === true && $stateParams.data !== true) {
                Meteor.call("editVaccinationIncident", obj, $scope.selectUser, $stateParams.data._id, function (error, result) {
                    if (error) {
                        toastr.error(error.reason);
                    } else {
                        toastr.success("Successfully edited");
                        $state.go("medicalUserProfile", {
                            userId: $scope.selectUser
                        });
                    }
                });
            } else {
                if ($scope.selectedUsersForVaccination && $scope.selectedUsersForVaccination.length > 0) $scope.selectedUsers = $scope.selectedUsersForVaccination;
                if ($scope.expDateError === null) {
                    authService.callAPI(MEDICALCONSTANT.API_SAVE_VACCINATION_DETAILS, "POST", obj, function (response) {
                        if (response.result && response.result.data && response.result.data.data) {
                            $state.go("userProfile");
                        }
                    });
                }
            }
        }
    };
}];

exports.default = VaccinationController;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: inventory.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var InventoryController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function InventoryController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, InventoryController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.existingBatchId = false;
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    authService.callAPI(MEDICALCONSTANT.API_GET_DELIVERED_DETAILS + schoolId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            $scope.productList = response.result.data.data;
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.addProductFromToList = function () {
        var len = $scope.productList.length;
        if (len % 2 === 0) {
            $scope.productList.push({
                "div_color": false
            });
        } else {
            $scope.productList.push({
                "div_color": true
            });
        }
    };
    $scope.saveProducts = function () {
        var batchArray = [];
        $scope.batchError = [];
        $scope.batchErrorCount = 0;
        _.each($scope.productList, function (each, index) {
            if (batchArray.indexOf(each.batch_no) === -1) {
                batchArray.push(each.batch_no);
            } else {
                $scope.batchErrorCount++;
                $scope.batchError[index] = "Same batch Id";
            }
        });
        var medicineList = [];
        _.each($scope.productList, function (each) {
            each.errors = {};
            var eachObj = {
                medicine_name: each.medicine_name ? each.medicine_name : null,
                quantity: each.quantity ? each.quantity : null,
                company_name: each.company_name ? each.company_name : null,
                vials_count: each.vials_count ? each.vials_count : null,
                category: each.category ? each.category : null,
                medicine_type: each.medicine_type ? each.medicine_type : null,
                price: each.price ? each.price : null,
                mfg_date: each.mfg_date ? each.mfg_date : null,
                exp_date: each.exp_date ? each.exp_date : null,
                batch_no: each.batch_no ? each.batch_no : null,
                school_id: each.school_id ? each.school_id : schoolId
            };
            eachObj.purchase_id = each.purchase_id ? each.purchase_id : null;
            medicineList.push(eachObj);
        });
        if (medicineList.length === $scope.productList.length && $scope.batchErrorCount === 0) {
            if ($scope.productList.length === 0) {
                toastr.error("Please add atleast one medicine");
                return false;
            }
            var medicineObj = {
                medicine_list: medicineList,
                school_id: schoolId,
                user_id: userId
            };
            authService.callAPI(MEDICALCONSTANT.API_SAVE_MEDICINE_DETAILS, "POST", medicineObj, function (response) {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Medicine added successfully");
                    $state.go('inventoryList');
                }
            });
        }
    };
    $scope.removeProduct = function (product, index) {
        if ($scope.productList.length > 1) {
            $scope.productList.splice(index, 1);
        }
    };
}];

exports.default = InventoryController;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: inventoryList.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var InventoryListController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "SchoolLogo", "authService", "CONSTANTS", function InventoryListController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, SchoolLogo, authService, CONSTANTS) {
    _classCallCheck(this, InventoryListController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    $scope.showFilters = false;
    $scope.pageSize = 50;
    $scope.totalCount = 0;
    $scope.medicineCount = 0;
    $scope.searchWord = undefined;
    $scope.errors = {};

    /*********** Prototype for pagination: START ******************/
    function inventoryItems() {
        this.loadedPages = {}; //details of loaded pages on scroll
        this.numItems = 0; //total number of items
        this.PAGE_SIZE = $scope.pageSize; //number of items per page
        this.fetchPage_(0);
    };

    //To get the item at the index
    //index -> current index
    inventoryItems.prototype.getItemAtIndex = function (index) {
        //calculate the page number of the given index
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
        //if page items are loaded
        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            //else fetch the page content. calling method to fetch item from db
            this.fetchPage_(pageNumber);
        }
    };

    //To get the total number of items
    inventoryItems.prototype.getLength = function () {
        return this.numItems;
    };

    //To fetch the items from db
    //pageNumber -> number for which page the items to be fetched
    inventoryItems.prototype.fetchPage_ = function (pageNumber) {
        var _this = this;

        this.loadedPages[pageNumber] = null;
        //To calculate the page offset(number of items to be skiped)
        var pageOffset = pageNumber * this.PAGE_SIZE;
        var paginationOpts = {
            limit: parseInt(this.PAGE_SIZE),
            skip: parseInt(pageOffset)
        };
        var obj = {
            pagination_options: paginationOpts,
            school_id: schoolId,
            filters: filterObj,
            search_word: $scope.searchWord
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_LIST, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                _this.numItems = response.result.data.data.count;
                _this.totalCount = response.result.data.data.count;
                $scope.medicineCount = response.result.data.data.count;
                _this.loadedPages[pageNumber] = response.result.data.data.list;
                $scope.productDetails = response.result.data.data.list;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };
    $scope.productList = new inventoryItems();
    authService.callAPI(MEDICALCONSTANT.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo)
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    function getDataUri(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    $scope.generatePdf = function (fromDate, toDate, search_type) {
        var obj = {
            filters: filterObj,
            school_id: schoolId,
            search_word: $scope.searchWord
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_PDF, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                $scope.allMedicineList = response.result.data.data;
                var content = [];
                if (filterObj && filterObj.search_type) {
                    if (filterObj.search_type === 'M') $scope.searchType = "Mfg";else $scope.searchType = "Exp";
                }
                if (filterObj && filterObj.category_search) $scope.categorySearch = filterObj.category_search;else $scope.categorySearch = "All";
                content.push({
                    columns: [{
                        width: 70,
                        height: 70,
                        image: $scope.imgurl1
                    }, [{
                        alignment: 'center',
                        columns: [{
                            text: $scope.schoolHeader.schoolName,
                            style: 'title'
                        }]
                    }, {
                        alignment: 'center',
                        columns: [{
                            text: "Inventory of Medicine"
                        }]
                    }]]
                });
                content.push({
                    canvas: [{
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 760,
                        y2: 10,
                        lineWidth: 0.5
                    }]
                });
                content.push("\n");
                if (filterObj && filterObj.exp_start && filterObj.exp_end) {
                    content.push({
                        columns: [[{
                            columns: [{
                                text: "Category:" + $scope.categorySearch
                            }]
                        }, {
                            columns: [{
                                text: $scope.searchType + " From:" + filterObj.exp_start.getFullYear() + '-' + (filterObj.exp_start.getMonth() + 1) + '-' + filterObj.exp_start.getDate()
                            }]
                        }, {
                            columns: [{
                                text: $scope.searchType + " To:" + filterObj.exp_end.getFullYear() + '-' + (filterObj.exp_end.getMonth() + 1) + '-' + filterObj.exp_end.getDate()
                            }]
                        }]]

                    });
                    content.push({
                        canvas: [{
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 760,
                            y2: 10,
                            lineWidth: 0.5
                        }]
                    });
                }
                content.push("\n");
                if (filterObj && !filterObj.exp_start && !filterObj.exp_end && filterObj.category_search) {
                    content.push({
                        columns: [[{
                            columns: [{
                                text: "Category:" + filterObj.category_search
                            }]
                        }]]

                    });
                    content.push({
                        canvas: [{
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 760,
                            y2: 10,
                            lineWidth: 0.5
                        }]
                    });
                }
                content.push("\n");

                var body = [];
                var header = [{
                    text: "S.No.",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Product Name",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Category",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Product Type",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Unit(count/ml)",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Unit Price",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Mfg Date",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Exp Date",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Batch Id",
                    style: 'tableHeader',
                    alignment: 'center'
                }];
                body.push(header);
                _.each($scope.allMedicineList, function (eachPdt, index) {
                    var sNo = index + 1;
                    var mDate = new Date(eachPdt.mfg_date);
                    var eDate = new Date(eachPdt.exp_date);
                    var mfg_date = mDate.getFullYear() + '-' + (mDate.getMonth() + 1) + '-' + mDate.getDate();
                    var exp_date = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate();
                    body.push([sNo, eachPdt.medicine_name, eachPdt.category, eachPdt.medicine_type, eachPdt.remaining_count, eachPdt.price, mfg_date, exp_date, eachPdt.batch_no]);
                });
                var table = {
                    widths: ['25', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                    style: 'tableExample',
                    table: {
                        headerRows: 1,
                        body: body
                    }
                };

                content.push(table);

                var docDefinition = {
                    pageOrientation: 'landscape',
                    content: content,
                    styles: {
                        title: {
                            fontSize: 18,
                            bold: true,
                            alignment: 'center'
                        },
                        sectionTitle: {
                            bold: true,
                            italics: true
                        },
                        boldStyle: {
                            bold: true
                        }
                    }
                };
                pdfMake.createPdf(docDefinition).open();
            }
        });
    };
    $scope.backToHtml = function () {
        $scope.pdfData = false;
    };
    $scope.addInventory = function () {
        $state.go('inventory');
    };
    var firstClick = false;
    $scope.pdfExport = function () {
        //filter
        $scope.showFilters = true;
        firstClick = true;
    };
    $scope.refreshFilter = function () {
        $scope.errors = {};
        $scope.exp_start = null;
        $scope.exp_end = null;
        $scope.showFilters = false;
        $scope.search_type = undefined;
        $scope.category_search = undefined;
        filterObj = {};
        $scope.productList = new inventoryItems();
        firstClick = false;
    };
    var filterObj = {};
    $scope.filterOrExp = function () {
        if ($scope.search_type && !$scope.exp_start) $scope.errors.exp_start = "Please select from date";
        if ($scope.search_type && !$scope.exp_end) $scope.errors.exp_end = "Please select To Date";
        if (($scope.exp_end || $scope.exp_start) && !$scope.search_type) $scope.errors.search_type = "Please select Search Type";
        if ($scope.exp_start && $scope.exp_end && $scope.search_type || $scope.category_search) {
            filterObj = {
                exp_start: $scope.exp_start,
                exp_end: $scope.exp_end,
                search_type: $scope.search_type,
                category_search: $scope.category_search
            };
            $scope.productList = new inventoryItems();
        }
    };
    $scope.stockDetails = function () {
        $state.go('stockList');
    };
    $scope.searchByName = function () {
        $scope.productList = new inventoryItems();
    };
}];

exports.default = InventoryListController;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: purchaseOrder.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PurchaseOrderController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function PurchaseOrderController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, PurchaseOrderController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    var academicYear = localStorageService.get('academic_year');
    $scope.newDate = new Date();
    $scope.productList = [{
        company_name: null,
        medicine_name: null,
        medicine_type: null,
        vials_count: null,
        div_color: false
    }];
    $scope.addProductFromToList = function () {
        var len = $scope.productList.length;
        if (len % 2 === 0) {
            $scope.productList.push({
                "div_color": false
            });
        } else {
            $scope.productList.push({
                "div_color": true
            });
        }
    };
    $scope.submitOrder = function () {

        var productObj = [];
        var errorCount = 0;
        _.each($scope.productList, function (each) {
            each.errors = {};
            var eachObj = {
                company_name: each.company_name ? each.company_name : null,
                medicine_name: each.medicine_name ? each.medicine_name : null,
                medicine_type: each.medicine_type ? each.medicine_type : null,
                vials_count: each.vials_count ? each.vials_count : null,
                school_id: schoolId,
                user_id: userId,
                academic_year: academicYear
            };
            if (errorCount === 0) productObj.push(eachObj);
        });
        if (productObj.length === $scope.productList.length) {
            authService.callAPI(MEDICALCONSTANT.API_SAVE_PURCHASE_ORDER, "POST", productObj, function (response) {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Purchase Order saved Successfully");
                    $state.go('purchaseList');
                }
            });
        }
    };
    $scope.removeProduct = function (product, index) {
        if ($scope.productList.length > 1) {
            $scope.productList.splice(index, 1);
        }
    };
}];

exports.default = PurchaseOrderController;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: purchaseList.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PurchaseListController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function PurchaseListController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, PurchaseListController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    $scope.productList = [];
    $scope.showUpdateButton = false;
    $scope.showEditConsole = [];
    $scope.pageSize = 50;
    $scope.totalCount = 0;
    $scope.medicineCount = 0;
    $scope.errors = {};
    $scope.gotoPurchaseorder = function () {
        $state.go('purchaseOrder');
    };
    $scope.editProduct = function (index, productId, product) {
        $scope.showEditConsole[index] = true;
        $scope.showUpdateButton = true;
    };
    //To update delivery status of medicine
    $scope.updatePurchaseStatus = function (product) {
        authService.callAPI(MEDICALCONSTANT.API_UPDATE_PURCHASE_ORDER, "POST", product, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                toastr.success("Updated Successfully");
                $scope.showEditConsole = [];
                $scope.productList = new purchaseItems();
            }
        });
    };

    /*********** Prototype for pagination: START ******************/
    function purchaseItems() {
        this.loadedPages = {}; //details of loaded pages on scroll
        this.numItems = 0; //total number of items
        this.PAGE_SIZE = $scope.pageSize; //number of items per page
        this.fetchPage_(0);
    };

    //To get the item at the index
    //index -> current index
    purchaseItems.prototype.getItemAtIndex = function (index) {
        //calculate the page number of the given index
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
        //if page items are loaded
        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            //else fetch the page content. calling method to fetch item from db
            this.fetchPage_(pageNumber);
        }
    };

    //To get the total number of items
    purchaseItems.prototype.getLength = function () {
        return this.numItems;
    };

    //To fetch the items from db
    //pageNumber -> number for which page the items to be fetched
    purchaseItems.prototype.fetchPage_ = function (pageNumber) {
        var _this = this;

        this.loadedPages[pageNumber] = null;
        //To calculate the page offset(number of items to be skiped)
        var pageOffset = pageNumber * this.PAGE_SIZE;
        var paginationOpts = {
            limit: parseInt(this.PAGE_SIZE),
            skip: parseInt(pageOffset)
        };
        var obj = {
            pagination_options: paginationOpts,
            school_id: schoolId
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_PURCHASE_ORDER, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                _this.numItems = response.result.data.data.count;
                _this.totalCount = response.result.data.data.count;
                $scope.medicineCount = response.result.data.data.count;
                _this.loadedPages[pageNumber] = response.result.data.data.list;
                $scope.productDetails = response.result.data.data.list;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };
    $scope.productList = new purchaseItems();
}];

exports.default = PurchaseListController;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: stockDetails.js
 * Project: educore
 * Created Date: 2019-03-15
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var StockDetailsController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", "CONSTANTS", "SchoolLogo", function StockDetailsController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, CONSTANTS, SchoolLogo) {
    _classCallCheck(this, StockDetailsController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    $scope.pageSize = 50;
    $scope.totalCount = 0;
    $scope.errors = {};
    $scope.addInventoryRedirect = function () {
        $state.go('addInventory');
    };
    authService.callAPI(MEDICALCONSTANT.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo)
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });

    function convertFileToDataURLviaFileReader(url, callback) {
        console.log(url);
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    function getDataUri(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    $scope.generatePdf = function (pdfDetails) {
        var obj = {
            school_id: schoolId
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_PDF, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                var productDetails = response.result.data.data;
                var content = [];
                content.push({
                    columns: [{
                        width: 70,
                        height: 70,
                        image: $scope.imgurl1
                    }, [{}, {
                        alignment: 'center',
                        columns: [{
                            text: $scope.schoolName,
                            style: 'title'
                        }]
                    }, {
                        alignment: 'center',
                        columns: [{
                            text: "Inventory of Medicine"
                        }]
                    }]]
                });
                content.push({
                    canvas: [{
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 760,
                        y2: 10,
                        lineWidth: 0.5
                    }]
                });
                content.push("\n");
                var body = [];
                var header = [{
                    text: "Sr No.",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Product Name",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Batch Id",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Opening Stock",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Stock In (Purchased) Units",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Stock Out (Consumed) Units",
                    style: 'tableHeader',
                    alignment: 'center'
                }, {
                    text: "Closing Stock Units",
                    style: 'tableHeader',
                    alignment: 'center'
                }];
                body.push(header);
                var sortedList = _.sortBy(productDetails, 'medicine_name');
                _.each(sortedList, function (product, index) {
                    var detail = [index + 1, product.medicine_name, product.batch_no, 0, product.vials_count * product.quantity, product.vials_count * product.quantity - product.remaining_count, product.remaining_count];
                    body.push(detail);
                });
                console.log(body);
                var table = {
                    style: 'tableExample',
                    table: {
                        widths: [25, 300, 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: body
                    }
                };
                content.push(table);

                var docDefinition = {
                    pageOrientation: 'landscape',
                    content: content,
                    styles: {
                        title: {
                            fontSize: 18,
                            bold: true,
                            alignment: 'center'
                        },
                        sectionTitle: {
                            bold: true,
                            italics: true
                        },
                        boldStyle: {
                            bold: true
                        },
                        tableExample: {
                            margin: [0, 5, 0, 15]
                        },
                        tableHeader: {
                            bold: true,
                            fontSize: 13,
                            color: 'black'
                        }
                    }
                };
                pdfMake.createPdf(docDefinition).open();
            }
        });
    };

    /*********** Prototype for pagination: START ******************/
    function stockItems() {
        this.loadedPages = {}; //details of loaded pages on scroll
        this.numItems = 0; //total number of items
        this.PAGE_SIZE = $scope.pageSize; //number of items per page
        this.fetchPage_(0);
    };

    //To get the item at the index
    //index -> current index
    stockItems.prototype.getItemAtIndex = function (index) {
        //calculate the page number of the given index
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
        //if page items are loaded
        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            //else fetch the page content. calling method to fetch item from db
            this.fetchPage_(pageNumber);
        }
    };

    //To get the total number of items
    stockItems.prototype.getLength = function () {
        return this.numItems;
    };

    //To fetch the items from db
    //pageNumber -> number for which page the items to be fetched
    stockItems.prototype.fetchPage_ = function (pageNumber) {
        var _this = this;

        this.loadedPages[pageNumber] = null;
        //To calculate the page offset(number of items to be skiped)
        var pageOffset = pageNumber * this.PAGE_SIZE;
        var paginationOpts = {
            limit: parseInt(this.PAGE_SIZE),
            skip: parseInt(pageOffset)
        };
        var obj = {
            pagination_options: paginationOpts,
            school_id: schoolId
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_INVENTORY_LIST, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                _this.numItems = response.result.data.data.count;
                _this.totalCount = response.result.data.data.count;
                $scope.medicineCount = response.result.data.data.count;
                _this.loadedPages[pageNumber] = response.result.data.data.list;
                $scope.productDetails = response.result.data.data.list;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    $scope.productList = new stockItems();
}];

exports.default = StockDetailsController;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: userProfile.js
 * Project: educore
 * Created Date: 2019-03-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var UserProfileController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "authService", "MEDICALCONSTANT", function UserProfileController($scope, $rootScope, localStorageService, $state, authService, MEDICALCONSTANT) {
    _classCallCheck(this, UserProfileController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    var academicYear = localStorageService.get('academic_year');
    $scope.isShowFilter = false;
    $scope.isSelected = false;
    var patientId = void 0;
    $scope.selectedUsers = localStorageService.get('selectedUsers');
    if ($scope.selectedUsers && $scope.selectedUsers.length === 1) {
        patientId = $scope.selectedUsers[0].patient_id;
        $scope.role = $scope.selectedUsers[0].role;
    }

    $scope.allUserDetails = [];
    if ($scope.selectedUsers && $scope.selectedUsers.length > 1) {
        $scope.selectedPersonDetails = [];
        _.each($scope.selectedUsers, function (eachUser) {
            /* Meteor.call('getPersonDetails', schoolId, eachUser.user_id, (error, result) => {
                 if (error) {} else {
                     if (result.image) {
                         if (result.image.original) {
                             result.image.original = FILE_PREVIEW_URL + result.image.original
                         }
                     }
                     $scope.selectedPersonDetails.push(result)
                 }
                 $scope.$apply()
              })*/

        });
    } else {
        getMedicalProfile();
    }

    function getMedicalProfile() {
        var reqObj = {
            patient_id: patientId,
            role: $scope.role
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_MEDICAL_PROFILE, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0) {
                    $scope.userDetails = response.result.data.data[0];
                    var curriculumName = $scope.userDetails.curriculum && $scope.userDetails.curriculum.name ? $scope.userDetails.curriculum.name : "";
                    var className = $scope.userDetails.class && $scope.userDetails.class.name ? $scope.userDetails.class.name : "";
                    var batchName = $scope.userDetails.batch && $scope.userDetails.batch.name ? $scope.userDetails.batch.name : "";
                    var sessionName = $scope.userDetails.session && $scope.userDetails.session.name ? $scope.userDetails.session.name : "";
                    if (curriculumName && sessionName && sessionName && batchName) $scope.userDetails['academicDet'] = curriculumName + '/' + sessionName + '/' + className + batchName;
                    if ($scope.userDetails.incidents && $scope.userDetails.incidents.length > 0) $scope.incidentList = $scope.userDetails.incidents;
                    getImmuzationForm();
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }

    function getImmuzationForm() {
        var reqObj = {
            patient_id: patientId,
            academic_year: academicYear,
            school_id: schoolId
        };
        $scope.immunizationReply = [];
        $scope.medicalQuestions = [];
        authService.callAPI(MEDICALCONSTANT.API_GET_IMMUNIZATION_FORM, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data) {
                    var resultData = response.result.data.data;
                    if (resultData.questions && resultData.questions.questions) $scope.medicalQuestions = resultData.questions.questions;
                    if (resultData.reply && resultData.reply.questions_answers) $scope.immunizationReply = resultData.reply.questions_answers;
                    if (resultData.reply && resultData.reply.status === "sent") {
                        $scope.viewAnswers = false;
                        $scope.sent_date = resultData.reply.sent_date;
                    } else if (resultData.reply && resultData.reply.status === "replied") {
                        $scope.viewAnswers = true;
                        $scope.sent_date = resultData.reply.sent_date;
                        $scope.reply_date = resultData.reply.reply_date;
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }
    var ansQues = [];
    $scope.medicalhistory = [{
        title: "VIEW ALL HISTORY"
    }];
    if ($scope.medicalhistory) {
        if ($scope.medicalhistory.length > 0) {
            $scope.medicalhistory[0].expanded = true;
        }
    }
    $scope.collapseMedicalHistory = function (expa) {
        for (var i in $scope.medicalhistory) {
            if ($scope.medicalhistory[i] != expa) {
                $scope.medicalhistory[i].expanded = false;
                if ($scope.showImmunization) {
                    $scope.showImmunizationCreateButton = false;
                }
            }
        }
        expa.expanded = !expa.expanded;
    };
    $scope.collapseHistory = function (expa) {
        for (var i in self.incidentList) {
            if (self.incidentList[i] != expa) {
                self.incidentList[i].expanded = false;
            }
        }
        expa.expanded = !expa.expanded;
    };
    $scope.selectAll = function (isSelected) {
        _.each($scope.medicalQuestions, function (obj) {
            obj.selected = isSelected ? true : false;
        });
    };
    $scope.selectQuestion = function () {
        var selectedCount = 0;
        _.each($scope.medicalQuestions, function (obj) {
            if (obj.selected === true) selectedCount++;
        });
        if ($scope.medicalQuestions.length === selectedCount) $scope.isSelected = true;else $scope.isSelected = false;
    };

    $scope.immunizationDivShow = function () {
        var userDetails = Person.findOne({
            user_id: userId,
            "status": "active"
        });
        var selectedRole = userDetails.role_ids;
        if (selectedRole.indexOf("student") !== -1) {
            if (!userDetails.parent_id) {
                toastr.error('Parents are not mapped');
            } else {
                $scope.showImmunization = true;
                $scope.showImmunizationCreateButton = false;
            }
        } else {
            $scope.showImmunization = true;
            $scope.showImmunizationCreateButton = false;
        }
    };

    $scope.exportFilter = function () {
        $scope.isShowFilter = true;
        $scope.isShowexportButton = false;
        $scope.t_type = {};
        $scope.selectDate = null;
        $scope.t_type.weekly = false;
        $scope.t_type.monthly = false;
        $scope.t_type.dailyOrNot = false;
        $scope.incident_type = {};
        $scope.faDisable = false;
        $scope.vaDisable = false;
        $scope.riDisable = false;
        $scope.submit = function () {};
        $scope.week = false;
        $scope.month = false;
        $scope.daily = false;
        $scope.weeklyOnChange = function () {
            if ($scope.t_type.weekly == true) {
                //on change for weekly
                $scope.month = true;
                $scope.daily = true;
            } else {
                $scope.month = false;
                $scope.daily = false;
            }
        };
        $scope.monthlyOnChange = function () {
            //on change for monthly
            if ($scope.t_type.monthly) {
                $scope.week = true;
                $scope.daily = true;
            } else {
                $scope.week = false;
                $scope.daily = false;
            }
        };
        $scope.dailyOnChange = function () {
            if ($scope.t_type.dailyOrNot == true) {
                //on change for daily
                $scope.week = true;
                $scope.month = true;
            } else {
                $scope.week = false;
                $scope.month = false;
            }
        };

        $scope.iFaChange = function () {
            // $scope.faDisable = false

            if ($scope.incident_type.FA_I === true) {
                $scope.vaDisable = true;
                $scope.riDisable = true;
            } else {
                $scope.vaDisable = false;
                $scope.riDisable = false;
            }
        };
        $scope.iVaChange = function () {

            if ($scope.incident_type.V_I === true) {
                $scope.faDisable = true;
                $scope.riDisable = true;
            } else {
                $scope.faDisable = false;
                $scope.riDisable = false;
            }
        };
        $scope.iRiChange = function () {

            if ($scope.incident_type.R_I === true) {
                $scope.faDisable = true;
                $scope.vaDisable = true;
            } else {
                $scope.faDisable = false;
                $scope.vaDisable = false;
            }
        };
    };

    $scope.cancel = function () {
        $mdDialog.hide();
    };
    $scope.redirectToCreate = function () {
        if (patientId) {
            $state.go("incidents", {
                patientId: patientId
            });
        } else {
            $state.go("incidents", {
                patientId: ""
            });
        }
    };
    $scope.sendDiagnosticQuestions = function () {
        if (!$scope.medicalQuestions) {
            $scope.medicalQuestions = [];
        }
        var questionSetCount = $scope.medicalQuestions.length;
        var selectedQuestions = _.where($scope.medicalQuestions, {
            selected: true
        });
        if (selectedQuestions.length === 0) {
            toastr.error("Please select atleast one question");
        } else {
            var reqObj = {
                question_set: selectedQuestions,
                school_id: schoolId,
                selected_users: $scope.selectedUsers,
                user_id: userId,
                academic_year: academicYear
            };
            authService.callAPI(MEDICALCONSTANT.API_SEND_IMMUNIZATION_FORM, "POST", reqObj, function (response) {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Immunization form sent Successfully");
                    getImmuzationForm();
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            });
        }
    };
}];

exports.default = UserProfileController;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: userFilter.js
 * Project: educore
 * Created Date: 2019-03-18
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var UserFilterController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "authService", "MEDICALCONSTANT", function UserFilterController($scope, $rootScope, localStorageService, $state, authService, MEDICALCONSTANT) {
    _classCallCheck(this, UserFilterController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.stateId = "userProfile";
    $scope.reqObj = {};
    $scope.personList = [];
    $scope.isSelected = false;

    $scope.clearParentFields = function () {
        $scope.userNamesEndorsed = [];
        $scope.userEndorsedAcademic = [];
        $scope.userNotEndorsedAcademic = [];
        $scope.userNamesNotEndorsed = [];
    };

    function clearFields() {
        $scope.pager = {};
        $scope.setPage = setPage;
        $scope.pageIndex = [];
    }

    $scope.searchValuesBasedOnFilter = function () {

        if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
            toastr.error('Please Select the Role');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
            toastr.error('Please Select the Session');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
            toastr.error('Please Select the Curriculum');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
            toastr.error('Please Select the Class');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0) {
            toastr.error('Please Select the Batch');
            return false;
        }

        //setFilterValue(this.filterObj)

        $scope.reqObj.roleId = this.filterObj.role_id;
        $scope.reqObj.sessionId = this.filterObj.session;
        $scope.reqObj.curriculumId = this.filterObj.curriculum;
        $scope.reqObj.classId = this.filterObj.xclass;
        $scope.reqObj.batchId = this.filterObj.batch;
        $scope.reqObj["school_id"] = localStorageService.get('school_id');
        $scope.getUsersLists();
    };
    $scope.getUsersLists = function () {
        $scope.loading = true;
        authService.callAPI(MEDICALCONSTANT.API_POST_GET_ALL_USERS, "POST", $scope.reqObj, function (response) {
            if (response.result && response.result.data) {
                $scope.userNames = response.result.data.users;
                $scope.loading = false;
                $scope.UniqueNoText = $scope.reqObj.roleId === "student" ? "Admission No" : "Employee No";
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.');
            }
        });
    };
    $scope.toggleUnSelectAllUser = function () {
        _.each($scope.userNames, function (data) {
            data.is_selected = $scope.isSelected ? false : true;
        });
        console.log($scope.userNames);
    };
    /*
     * To navigate to user dashboard
     * 
     * @user_obj : Object - user details
     * 
     * @return : null
     */
    $scope.navigateUserDashboard = function () {
        var userIdArray = [];
        _.each($scope.userNames, function (eachUser) {
            if (eachUser.is_selected === true) userIdArray.push({
                "patient_id": eachUser._id,
                "role": eachUser.role
            });
        });
        if (userIdArray.length === 0) {
            toastr.error('Please Select user');
        } else {
            localStorageService.set('selectedUsers', userIdArray);
            $state.go('userProfile');
        }
    };
}];

exports.default = UserFilterController;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MedicalProfileController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function MedicalProfileController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, MedicalProfileController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        } else {
            getMedicalProfile();
        }
    };
    var userId = localStorageService.get('user_id');
    var schoolId = localStorageService.get('school_id');
    var academicYear = localStorageService.get('academic_year');

    var profileObj = {
        patient_id: userId,
        role: $scope.role
    };

    function getMedicalProfile() {
        authService.callAPI(MEDICALCONSTANT.API_GET_MEDICAL_PROFILE, "POST", profileObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0) {
                    $scope.userDetails = response.result.data.data[0];
                    var curriculumName = $scope.userDetails.curriculum && $scope.userDetails.curriculum.name ? $scope.userDetails.curriculum.name : "";
                    var className = $scope.userDetails.class && $scope.userDetails.class.name ? $scope.userDetails.class.name : "";
                    var batchName = $scope.userDetails.batch && $scope.userDetails.batch.name ? $scope.userDetails.batch.name : "";
                    var sessionName = $scope.userDetails.session && $scope.userDetails.session.name ? $scope.userDetails.session.name : "";
                    $scope.userDetails['academicDet'] = curriculumName + '/' + sessionName + '/' + className + batchName;
                    if ($scope.userDetails.incidents && $scope.userDetails.incidents.length > 0) $scope.incidentList = $scope.userDetails.incidents;
                    getImmunizationForm();
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }
    var userObj = {
        patient_id: userId,
        academic_year: academicYear,
        school_id: schoolId
    };

    function getImmunizationForm() {
        authService.callAPI(MEDICALCONSTANT.API_GET_USER_IMM_FORM, "POST", userObj, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0) {
                    var resultData = response.result.data.data[0];
                    $scope.immunizationResults = resultData.questions_answers;
                    if (resultData.status === "sent") {
                        $scope.viewAnswers = false;
                        $scope.sent_date = resultData.sent_date;
                    } else if (resultData.status === "replied") {
                        $scope.viewAnswers = true;
                        $scope.sent_date = resultData.sent_date;
                        $scope.reply_date = resultData.reply_date;
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }

    /*$scope.subscribe('getPatientUsers');
    Meteor.subscribe('getImmuzationQuestions', schoolId)
    Meteor.subscribe('getImmuzationReply', schoolId)
    Meteor.call("currentDate", function(error, result) {
        if (error) {
         } else {
            $scope.serverDate = result;
            $scope.$apply()
        }
    })*/
    /*$scope.autorun(() => {
        $scope.subscribe('getPatientProfile', () => {
            return [userId]
        }, () => {
            $scope.result = Person.findOne({
                user_id: userId,
                "status": "active"
            })
            if ($scope.result && $scope.result.incidents) {
                $scope.incidentList = $scope.result.incidents
            }
         })*/

    $scope.medicalhistory = [{
        "op": "dvsd"
    }];
    /*if (userId) {
        Meteor.call('getPersonDetails', schoolId, userId, (error, result) => {
            if (error) {
             } else {
                if (result.image) {
                    if (result.image.original) {
                        $scope.profilePic = FILE_PREVIEW_URL + result.image.original
                    }
                } else {
                    $scope.profilePic = "icons/studentprofile.png"
                }
                $scope.selectedPersonData = result.selectedPersonData
                if (result.incidentList) {
                    $scope.incidentList = result.incidentList
                }
                $scope.$apply()
             }
        })
    }
    */

    /* var immunizationExists = Doctor_Immunization.findOne({
         "type": "reply",
         "user_id": userId
     })
     var fullImmuzations = Doctor_Immunization.findOne({
         type: "questions"
     })*/
    var immunizationExists = [];
    var fullImmuzations = [];
    var questions = [];
    if (immunizationExists && fullImmuzations) {
        if (immunizationExists.questions_answers) {
            _.each(immunizationExists.questions_answers, function (quest) {
                if (immunizationExists.status == "sent") {
                    var findQuest = _.find(fullImmuzations.questions, function (doc) {
                        return doc._id == quest._id;
                    });
                    findQuest.q_type = findQuest.q_type ? findQuest.q_type : null;
                    questions.push(_defineProperty({
                        q_type: findQuest.q_type,
                        question: findQuest.question,
                        type: findQuest.type,
                        _id: findQuest._id
                    }, "q_type", findQuest.q_type));
                } else {
                    var _findQuest = _.find(fullImmuzations.questions, function (doc) {
                        return doc._id == quest._id;
                    });
                    _findQuest.q_type = _findQuest.q_type ? _findQuest.q_type : null;
                    questions.push(_defineProperty({
                        q_type: _findQuest.q_type,
                        question: _findQuest.question,
                        answer: quest.answer,
                        type: _findQuest.type,
                        _id: _findQuest._id
                    }, "q_type", _findQuest.q_type));
                }
            });
            /******************Medical incidents start************************/
            if ($scope.result && $scope.result.incidents) {
                _.each($scope.result.incidents, function (incident) {
                    // if (incident.doctor_id === self.loggedUserId) {
                    // if(incident.type =='emergency_referral'){
                    if (incident.follow_up) {
                        incident.canFollow = false; //cannot add but view
                    } else {
                        incident.canFollow = true; // can add not view
                    }
                    incident.emergency = {};
                    if (incident.type == 'emergency_referral') {
                        if (incident.injury_level == "1") {
                            incident.emergency = "Temporary Disablity";
                        } else if (incident.injury_level == "2") {
                            incident.emergency = "Chronic disability";
                        } else if (incident.injury_level == "3") {
                            incident.emergency = "Dead";
                        } else if (incident.injury_level == "4") {
                            incident.emergency = "Mild";
                        }
                    }
                    // }
                    // incidentObs.push(incident)
                    // }
                });
                $scope.incidentList = $scope.result.incidents;
            }
            /******************Medical incidents Ends************************/
        }
        $scope.immunizationResults = questions;
        if (immunizationExists.status == "sent") {
            $scope.enterAnswers = true;
            $scope.viewAnswers = false;
            $scope.sent_date = immunizationExists.sent_date;
        } else {
            $scope.viewAnswers = true;
            $scope.enterAnswers = false;
            $scope.reply_date = immunizationExists.reply_date;
            $scope.sent_date = immunizationExists.reply_date;
        }
    }

    if ($scope.immunizationResults) {
        if ($scope.immunizationResults.length > 0) {
            $scope.immunizationResults[0].expanded = true;
        }

        $scope.collapseMedicalHistory = function (expa) {
            for (var i in $scope.immunizationResults) {
                if ($scope.immunizationResults[i] != expa) {
                    $scope.immunizationResults[i].expanded = false;
                }
            }
            expa.expanded = !expa.expanded;
        };
    }
    /******************Accordian collapse for medical history ends************************/
    $scope.collapseAll = function (data) {
        for (var i in $scope.medicalhistory) {
            if ($scope.medicalhistory[i] != data) {
                $scope.medicalhistory[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;
    };
    $scope.collapseHistory = function (data) {
        for (var i in $scope.incidentList) {
            if ($scope.incidentList[i] != data) {
                $scope.incidentList[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;
    };

    $scope.sendImmunization = function () {
        var error = 0;
        $scope.immuneError = {};
        $scope.descriptiveError = [];
        $scope.objectiveError = [];
        $scope.timeError = [];
        _.each($scope.immunizationResults, function (result, key) {
            if (result.type == "objective") {
                if (result.objective != "0" && result.objective != "1") {
                    $scope.objectiveError[key] = "please select answer";
                    error++;
                }
            } else if (result.type == "time") {

                if (!result.startDate) {
                    error++;
                    $scope.timeError[key] = "please select date";
                } else {}
            } else if (result.type == "descriptive") {

                if (!result.answer || result.answer[key] === "" || result.answer[key] === null || result.answer[key] === undefined) {
                    error++;
                    $scope.descriptiveError[key] = "please enter answer";
                }
            }
        });
        if (error === 0) {
            var userReply = angular.copy($scope.immunizationResults);
            var obj = {
                user_reply: userReply,
                patient_id: userId
            };
            authService.callAPI(MEDICALCONSTANT.API_SAVE_USER_REPLY, "POST", obj, function (response) {
                if (response.result && response.result.data && response.result.data.data) {
                    toastr.success("Reply send successfully");
                    getImmunizationForm();

                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            });
        }
    };

    /* $scope.addComment = (data, index) => {
          if (data.follow_up == "" || data.follow_up == null) {
             toastr.error("Please enter a comment");
             return false
         } else {
             Meteor.call("addFollowUp", data, Meteor.userId(), function(error, res) {
                 if (error) {
                     toastr.error(error.reason);
                 } else {
                     toastr.success("Successfully added followup");
                  }
             })
         }
     }*/
}];

exports.default = MedicalProfileController;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: createProgramme.js
 * Project: educore
 * Created Date: 2019-03-22
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var CreateProgrammeController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function CreateProgrammeController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, CreateProgrammeController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.stateId = "createProgramme";
    var schoolId = localStorageService.get('school_id');
    var academicYear = localStorageService.get('academic_year');
    var userId = localStorageService.get('user_id');
    $scope.doctorProgram = {};
    $scope.selectUsers = false;

    //Boolean - To show loading
    $scope.isFacultyLoaded = true;
    $scope.findTime = function () {
        console.log('111');
    };
    $scope.reqObj = {};
    $scope.personList = [];
    $scope.isSelected = false;
    $scope.clearParentFields = function () {
        $scope.userNamesEndorsed = [];
        $scope.userEndorsedAcademic = [];
        $scope.userNotEndorsedAcademic = [];
        $scope.userNamesNotEndorsed = [];
    };

    function clearFields() {
        $scope.pager = {};
        $scope.setPage = setPage;
        $scope.pageIndex = [];
    }

    $scope.searchValuesBasedOnFilter = function () {
        if (this.filterObj === undefined || this.filterObj.role_id === undefined) {
            toastr.error('Please Select the Role');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['session'] === undefined) {
            toastr.error('Please Select the Session');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['curriculum'] === undefined) {
            toastr.error('Please Select the Curriculum');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['xclass'] === undefined || this.filterObj['xclass'].length <= 0) {
            toastr.error('Please Select the Class');
            return false;
        } else if (this.filterObj === undefined || this.filterObj['batch'] === undefined || this.filterObj['batch'].length <= 0) {
            toastr.error('Please Select the Batch');
            return false;
        }

        //setFilterValue(this.filterObj)

        $scope.reqObj.roleId = this.filterObj.role_id;
        $scope.reqObj.sessionId = this.filterObj.session;
        $scope.reqObj.curriculumId = this.filterObj.curriculum;
        $scope.reqObj.classId = this.filterObj.xclass;
        $scope.reqObj.batchId = this.filterObj.batch;
        $scope.reqObj["school_id"] = localStorageService.get('school_id');
        $scope.getUsersLists();
    };
    $scope.getUsersLists = function () {
        $scope.loading = true;
        authService.callAPI(MEDICALCONSTANT.API_POST_GET_ALL_USERS, "POST", $scope.reqObj, function (response) {
            if (response.result && response.result.data) {
                $scope.userNames = response.result.data.users;
                $scope.loading = false;
                $scope.UniqueNoText = $scope.reqObj.roleId === "student" ? "Admission No" : "Employee No";
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.');
            }
        });
    };
    $scope.toggleUnSelectAllUser = function () {
        _.each($scope.userNames, function (data) {
            data.is_selected = $scope.isSelected ? false : true;
        });
        console.log($scope.userNames);
    };

    $scope.saveProgram = function (programme, resultData) {
        $scope.errors = {};
        var errorCount = 0;
        var datePgm = programme.date;
        var dateRedef = void 0;
        var timeRedef = void 0;
        if (datePgm) {
            dateRedef = new Date(datePgm.getFullYear() + '-' + (datePgm.getMonth() + 1) + '-' + datePgm.getDate() + ' ' + "00" + ":" + "00" + ": 01");
            timeRedef = new Date(datePgm.getFullYear() + '-' + (datePgm.getMonth() + 1) + '-' + datePgm.getDate() + ' ' + datePgm.getHours() + ":" + datePgm.getMinutes() + ": 01");
        }

        var userIdArray = [];
        _.each($scope.userNames, function (eachUser) {
            if (eachUser.is_selected === true) userIdArray.push(eachUser);
        });
        if (userIdArray.length === 0) {
            $scope.errors['setOfClasseseror'] = "Please select attendees";
            return false;
        }
        var pgmData = {
            date: programme.date ? dateRedef : null,
            organiser: programme.organiser ? programme.organiser : null,
            time: timeRedef ? timeRedef : dateRedef,
            topic: programme.topic ? programme.topic : null,
            user_list: userIdArray,
            school_id: schoolId,
            academic_year: academicYear,
            user_id: userId
        };
        console.log(pgmData);
        if (errorCount === 0) {
            $scope.errors = {};
            $scope.on_progress = true;
            $scope.returnValue = false;
            $scope.loading = true;
            /*Meteor.call("announceProgram", objToPass, userIdArray, schoolId, function(error, result) {
                if (error) {
                    if (error.error) {
                        $scope.loading = false
                        toastr.error("Server Interpreted.Please try after some time.")
                    }
                } else {
                    $scope.on_progress = false
                    $scope.loading = false
                    toastr.success("Programme created successfully!")
                    $state.go("programConsole")
                }
            });*/
            authService.callAPI(MEDICALCONSTANT.API_SAVE_PROGRAMME, "POST", pgmData, function (response) {
                if (response.result && response.result.data) {
                    toastr.success('Programme created successfully');
                    $state.go("programmeConsole");
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    $scope.loading = false;
                    toastr.error('Server Interpreted.Please try after some time.');
                }
            });
        }
    };
}];

exports.default = CreateProgrammeController;

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: viewProgramme.js
 * Project: educore
 * Created Date: 2019-03-22
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ViewProgrammeController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", function ViewProgrammeController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {
    _classCallCheck(this, ViewProgrammeController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getDate();
        getAssignedProgramme();
    };
    var schoolId = localStorageService.get('school_id');
    var academicYear = localStorageService.get('academic_year');
    var userId = localStorageService.get('user_id');
    $scope.programmeList = [];

    function getDate() {
        authService.callAPI(MEDICALCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.serverDate = response.result.data.data;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }

    function getAssignedProgramme() {
        var obj = {
            school_id: schoolId,
            academic_year: academicYear,
            user_id: userId
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_ASSIGNED_PROGRAMME, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0) {
                    var resultData = response.result.data.data;
                    _.each(resultData, function (pgm) {
                        pgm.my_comment = null;
                        var feedbackExists = _.find(pgm.attendees, function (pgm) {
                            return pgm.user_id == userId;
                        });
                        if ($scope.serverDate > pgm.programme_time) {
                            pgm.can_add_comment = true;
                        }
                        if (feedbackExists) {
                            if (feedbackExists.feedback) {
                                pgm.can_add_comment = false;
                                pgm.my_comment = feedbackExists.feedback;
                            }
                        }
                    });
                    $scope.programmeList = resultData;
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }
    $scope.addComment = function (data) {
        //adding comment by the invitee
        if (data.comment == '' || data.comment == null || data.comment == undefined) {
            toastr.error("Please enter comment");
        } else {
            var commentObj = {
                user_id: userId,
                comment: data.comment,
                pgm_id: data._id
            };
            authService.callAPI(MEDICALCONSTANT.API_ADD_COMMENT, "POST", commentObj, function (response) {
                if (response && response.result && response.result.data.data) {
                    console.log(response.result.data.data);
                    toastr.success("Comment added successfully!");
                    getAssignedProgramme();
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error('Server Interpreted.Please try after some time.');
                }
            });
        }
    };

    $scope.collapseHistory = function (expa) {
        $scope.viewReportData = []; //to view report of the particular pgm by index
        for (var i in $scope.programList) {
            if ($scope.programList[i] != expa) {
                $scope.programList[i].expanded = false;
            }
        }
        expa.expanded = !expa.expanded;
    };
    $scope.viewReport = function (data, index) {
        // view rport
        if ($scope.viewReportData[index]) {
            $scope.viewReportData[index] = false;
        } else {
            $scope.viewReportData[index] = true;
        }
    };
    $scope.setFilePath = function (img) {
        var new_url = FILE_UPLOAD_URL + img;
        return new_url;
    };
    $scope.viewImage = function (dataUrl) {
        var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
        $scope.imgurl = FILE_UPLOAD_URL + dataUrl;
        $mdDialog.show({
            templateUrl: viewImage,
            clickOutsideToClose: true,
            scope: $scope,
            fullscreen: useFullScreen,
            preserveScope: true
        }).then(function () {}, function () {
            self.status = 'You cancelled the dialog.';
        });
        $scope.$watch(function () {
            return $mdMedia('xs') || $mdMedia('sm');
        }, function (wantsFullScreen) {
            $scope.customFullscreen = wantsFullScreen === true;
        });
    };
    $scope.cancel = function () {
        $mdDialog.hide();
    };
}];

exports.default = ViewProgrammeController;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _programmeAttendeeList = __webpack_require__(932);

var _programmeAttendeeList2 = _interopRequireDefault(_programmeAttendeeList);

var _programmeCommentList = __webpack_require__(933);

var _programmeCommentList2 = _interopRequireDefault(_programmeCommentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: programmeConsole.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2019-03-22
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var ProgrammeConsoleController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "MEDICALCONSTANT", "authService", "$mdMedia", "$mdDialog", function ProgrammeConsoleController($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService, $mdMedia, $mdDialog) {
    _classCallCheck(this, ProgrammeConsoleController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        getDate();
        getProgrammeList();
    };
    var schoolId = localStorageService.get('school_id');
    var userId = localStorageService.get('user_id');
    var academicYear = localStorageService.get('academic_year');

    function getDate() {
        authService.callAPI(MEDICALCONSTANT.API_GET_CURRENT_DATE, "GET", {}, function (response) {
            if (response && response.result && response.result.data) {
                $scope.serverDate = response.result.data.data;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    }

    function getProgrammeList() {
        var obj = {
            school_id: schoolId,
            academic_year: academicYear,
            user_id: userId
        };
        authService.callAPI(MEDICALCONSTANT.API_GET_CREATED_PROGRAMME, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0) {
                    $scope.programmeList = response.result.data.data;
                    _.each($scope.programmeList, function (pgm) {
                        pgm.can_publish = true;
                        pgm.can_report = false;
                        if ($scope.serverDate > pgm.programme_time) {
                            pgm.can_report = true;
                            pgm.can_publish = false;
                        }
                        if (!pgm.report) {
                            pgm.report = {};
                            pgm.report.messages = [{
                                name: ''
                            }];
                        }
                    });
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    }
    $scope.createProgramme = function () {
        $state.go('createProgramme');
    };

    $scope.collapseHistory = function (expa) {
        $scope.viewReportData = [];
        for (var i in $scope.programmeList) {
            if ($scope.programmeList[i] != expa) {
                $scope.programmeList[i].expanded = false;
            }
        }
        expa.expanded = !expa.expanded;
    };
    $scope.viewAttendees = function (pgmData) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                pgmData: pgmData
            },
            template: _programmeAttendeeList2.default,
            controller: ['$scope', '$mdDialog', 'pgmData', function ($scope, $mdDialog) {
                $scope.viewAttendeesArray = pgmData.attendees;
                $scope.cancel = function () {
                    $mdDialog.hide();
                };
            }],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
    $scope.publish = function (pgmId) {
        if (pgmId) {
            authService.callAPI(MEDICALCONSTANT.API_PUBLISH_PROGRAMME + userId + '/' + pgmId, "GET", {}, function (response) {
                if (response && response.result && response.result.data) {
                    toastr.success('Programme published successfully');
                    getProgrammeList();
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error('Server Interpreted.Please try after some time.');
                }
            });
        }
    };
    $scope.viewCommments = function (pgmData) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        var commentlist = [];
        _.each(pgmData.attendees, function (eachUser) {
            if (eachUser.feedback) {
                commentlist.push(eachUser);
            }
        });
        if (commentlist.length > 0) {
            $mdDialog.show({
                locals: {
                    commentlist: commentlist
                },
                template: _programmeCommentList2.default,
                controller: ['$scope', '$mdDialog', 'commentlist', function ($scope, $mdDialog) {
                    $scope.commentlist = commentlist;
                    $scope.cancel = function () {
                        $mdDialog.hide();
                    };
                }],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            });
        } else {
            var confirm = $mdDialog.confirm().textContent('No comments found...').ok('Ok');
            $mdDialog.show(confirm).then(function () {
                $scope.isAssignUsers = true;
            }, function () {
                $scope.isAssignUsers = false;
            });
            $scope.isPrompt = true;
        }
    };
    $scope.viewImage = function (dataUrl) {
        var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
        $scope.imgurl = FILE_UPLOAD_URL + dataUrl;
        $mdDialog.show({
            templateUrl: viewImage,
            clickOutsideToClose: true,
            scope: $scope,
            fullscreen: useFullScreen,
            preserveScope: true
        }).then(function () {}, function () {
            self.status = 'You cancelled the dialog.';
        });
        $scope.$watch(function () {
            return $mdMedia('xs') || $mdMedia('sm');
        }, function (wantsFullScreen) {
            $scope.customFullscreen = wantsFullScreen === true;
        });
    };
    $scope.addReport = function (data, index) {
        // shows report form
        $scope.showreportForm = []; //to show form of the particular pgm by index
        $scope.showreportForm[index] = true; //show report form
    };
    $scope.addMessagefield = function (data) {
        data.report.messages.push({
            name: ''
        });
    };

    $scope.removeMessagefield = function (data, index) {
        data.report.messages.splice(index, 1);
    };
    $scope.submitReport = function (data, index) {
        $scope.errors = {};
        var errorCount = 0;
        $scope.reportData = {
            comment: data.report.comment ? data.report.comment : null,
            messages: data.report.messages,
            mode: data.report.mode ? data.report.mode : null,
            official: data.report.official ? data.report.official : null,
            speaker: data.report.speaker ? data.report.speaker : null,
            supporting_staff: data.report.supporting_staff ? data.report.supporting_staff : null,
            pgm_id: data._id,
            user_id: userId
        };

        if (errorCount === 0) {
            $scope.indexPgm = index;
            if ($scope.imgArray) //if there is images
                $scope.reportData['images'] = $scope.imgArray;
            authService.callAPI(MEDICALCONSTANT.API_ADD_REPORT, "POST", $scope.reportData, function (response) {
                if (response && response.result && response.result.data) {
                    $scope.uploading = "";
                    toastr.success("Report submitted successfully!");
                    $scope.showreportForm = []; //to show form of the particular pgm by index
                    $scope.showreportForm[$scope.indexPgm] = false; //hide report form
                    $scope.viewReportData = []; //to view report of the particular pgm by index
                    $scope.viewReportData[$scope.indexPgm] = true; //view report
                    getProgrammeList();
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error('Server Interpreted.Please try after some time.');
                }
            });
        }
    };
    $scope.setFilePath = function (img) {
        var new_url = FILE_UPLOAD_URL + img;
        return new_url;
    };
    $scope.viewReport = function (data, index) {
        // view rport
        if ($scope.viewReportData[index]) {
            $scope.viewReportData[index] = false;
        } else {
            $scope.viewReportData[index] = true;
        }
    };

    $scope.imgArray = [];
    $scope.removeImage = function (index) {
        $scope.imgArray.splice(index, 1);
    };
    $scope.optionImgUpload = function (file, data) {
        _.each(file, function (fileObj) {
            if (fileObj.type === "image/jpg" || fileObj.type === "image/jpeg" || fileObj.type === "image/png") {
                uploadService.uploadCheckService(fileObj, $scope.serverUrl, $scope.userPath, function (result) {
                    if (result.url) {
                        $scope.imgArray.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };
}];

exports.default = ProgrammeConsoleController;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: qpSummary.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
var answersheetPreview =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", function answersheetPreview($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
    _classCallCheck(this, answersheetPreview);

    var authoring = localStorageService.get("authoringData");
    var qpId = $state.params.qpId;
    var studentId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    $scope.continue = false;
    $scope.no_fee_status = false;
    var self = this;
    var vm = this;
    // $scope.isLoading = true
    vm.reportCardArray = undefined;
    vm.buckets = undefined;
    $scope.reportCardArray = undefined;
    this.$onInit = function () {
        if (authoring) {
            init();
        }
    };
    $scope.checkingChoiceExistsPreview = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };
    $scope.gotoQpPreview = function () {
        $state.go('qpSummary', {
            qpId: qpId
        });
    };
    $scope.setFilePathPreview = function (img) {
        var new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined;
        return new_url;
    };

    $scope.beautifyFIBPreview = function (question) {
        return question.toString().replace(/_/g, " _______ ");
    };
    var MQ = MathQuill.getInterface(2);
    $scope.loadLatexPreview = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };
    $scope.conertToHtml = function (string) {
        // string = "<span style='color: #89a000'>123</span>"
        return $sce.trustAsHtml(string);
    };
    function init() {
        $scope.isLoadingPreview = true;
        var studentId = localStorageService.get('user_id');
        authService.callAPI(activityCons.API_GET_STUDENT_ANSWER_DETAILS + qpId + '/' + studentId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    var result = response.result.data.details;
                    if (result && result.comment) {
                        $scope.comment = result.comment;
                    }
                    var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
                    $scope.my_score = 0;
                    $scope.totalmark = 0;
                    $scope.quesCount = 0;
                    var myScore = 0;
                    $scope.isTeacherEvaluation = false;
                    _.each(result.consolidatedData, function (sec) {
                        delete sec.questions;
                        _.each(sec.answers, function (ans) {
                            if (ans.type === "SA" || ans.type === "LA" || ans.type == "ASLLISTEN" || ans.type == "ASLSPEAK" || ans.type == "DRAW") {
                                $scope.quesCount++;
                            }
                            $scope.totalmark = ans.total_mark;
                            if (!isNaN(ans.my_score)) {
                                myScore = parseFloat(myScore) + parseFloat(ans.my_score);
                                myScore = myScore.toFixed(2);
                                $scope.my_score = myScore;
                            }
                        });
                    });
                    $scope.qpDetails = {
                        question_paper_title: result.question_paper_title,
                        subject: authoring.subject,
                        class: authoring.class,
                        time: result.time,
                        due_date: result.due_date
                    };
                    $scope.questionsPreview = result.consolidatedData;
                    setNUmberingAndDeleteSections();
                    $scope.isLoadingPreview = false;
                    setTimeout(function () {
                        $scope.loadLatexPreview();
                    }, 100);
                    setChoice();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    }
    var answFailureArr = localStorageService.get("failureQuestIds");
    if (!answFailureArr || !answFailureArr.length) {
        answFailureArr = [];
    }
    answFailureArr = _.uniq(answFailureArr);
    function setSavedOrNot(one_question) {
        if (one_question) {
            var ex = _.find(answFailureArr, function (one) {
                return one == one_question._id;
            });
            if (ex) {
                if (!one_question.is_attended) {
                    one_question.attendedStatus = "Not saved";
                } else {
                    one_question.attendedStatus = "Not saved!";
                }
            } else {
                if (one_question.attendedStatus == "Not attended") {
                    one_question.attendedStatus = "Not Answered";
                } else if (one_question.attendedStatus == "Attended") {
                    one_question.attendedStatus = "Answered";
                }
            }
        }
    }
    $scope.array = [];
    function setNUmberingAndDeleteSections() {
        var sections = $scope.questionsPreview;
        var array = [];
        for (var s = 0; s < sections.length; s++) {
            for (var a = 0; a < sections[s].answers.length; a++) {
                setSavedOrNot(sections[s].answers[a]);
                array.push(sections[s].answers[a]);
            }
        }
        $scope.array = array;
    }
    function removeSpecialCharacterPreview(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }
    function setChoice() {
        _.each($scope.questionsPreview, function (section) {
            _.each(section.answers, function (data, key) {
                $scope.total_mark += parseFloat(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {} else if (data.type == 'TF') {} else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    var whole_answer_correct = false;
                    _.each(data.answer, function (choice) {
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {} else {
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    var _whole_answer_correct = false;
                    if (Number(data.my_score) > 0) {
                        _whole_answer_correct = true;
                    }
                    _.each(data.answer, function (choice) {
                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {} else {
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var needed = true;
                        if (!choice.question.desc) {
                            choice['no_question'] = true;
                            needed = false;
                        }
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage,
                                needed: needed
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExistsPreview(choice.desc, aslListQues)) {}
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {}
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacterPreview(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacterPreview(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        // choice.wrong = true
                                    } else {
                                            // choice.correct = true
                                        }
                                } else {
                                    // choice.wrong = true
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacterPreview(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacterPreview(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    // aslListQues.wrong = true
                                } else {
                                        // aslListQues.correct = true
                                    }
                            } else {
                                // aslListQues.wrong = true
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
    }
    $scope.clearPreview = function () {
        $scope.questionsPreview = [];
    };
    $scope.clickQuestion = function (index) {
        try {
            if ($scope.$parent && $scope.$parent.$parent) {
                $scope.$parent.$parent.changeQuestion(index, true);
            }
        } catch (e) {
            console.log(e);
        }
    };
}];

exports.default = answersheetPreview;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: procturedCocumentController.js
 * Project: educore
 * Created Date: 2020-12-24
 * Author: Varun
 * Screen : 
 */
var ProcturedDocumentController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "CONSTANTS", function ProcturedDocumentController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, CONSTANTS) {
    _classCallCheck(this, ProcturedDocumentController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
}];

exports.default = ProcturedDocumentController;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAANZJREFUeNpi/D+f4QMDA8MJBtIBHxC/Y0j478MCNiDhvwfJRixglAOSs0BMkCGsUEF2IMmMQ8svoEV/0MQEgPgtUF86C5JgFRAbI/EZgVgQym4C4h1YDP8JxBrIhpwB4ldI/H9A26cT8BTIop9MSALMUK+BMDcQ8wOdykZM8CC7RB/JOxOBrthLbBgjG9IND2QGhu+kRBTCkIT/3xjIBEwMVACjhmA35DeZej8iR7ExMGUWkmGIHDRl/wO5pJ5Ml9wD4g6QQYzAQglk4iQyDeIAYh2AAAMAEo4pQ2sFH5sAAAAASUVORK5CYII="

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZpJREFUeNp80kkoRVEcx/H3eCHztBAyZGclRDayNJRkx0oJsVMWimJlp8TCQtjYErJSpoQs2JlKkpIQigyZru+f363b7eXW53Xf6Zz/Pef8f0HHcQK+pxQdKEEcgnjDIaaw7J0c9BSIwDAasIBFnOILOahGE/bRhqffVVYAnVjEGvI0Fk4K5rCHxN+P8xOJK+fvyfVMjkIGMhHrKzSPWXu3I0SzkRbcYRORGEQFonW8DxxhAAeI1520B8Nc4jrOMYILfCMDzbqDMjygD+URvsX2xXzEIAkJkqSOZCNZc5dQEOInEzf4VMus+iv6Ndk+8oITXGuOPZf2bgVWtT1rj6PzmVHcaiwFdUjVkQJuoZC+WKgCNviOe3Rpge3gWZf3qEu2J9eKhZSsRsxo8RnSMabOODpKvf7fqoAF7th6moMbFKnHyRjCNvZlF+OenKQrO5VuMHpwhjRfYOIQ7xsLYQOTbhJdEzhG8T9Rth2sY8UC6CbRm4NedGIL82rdl7JRixr1v1vpDIRLYgFaUYUsdcFysoNp7Hkn/wgwADdcW3zGghZAAAAAAElFTkSuQmCC"

/***/ }),
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAMAAAB1/u6nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAW5QTFRFAAAA//Xyr7rUV4zFH3W9B2y9D3nDL5DQd77p3/r/x7DUn+z/18PSL3W7AGy7B3XHb8z2x7DHD2zHj+z/v6fFD2y7AGy9J5DWl9Hw3/X8z9Hhb5XDAGy/N5DFAGzH17rJAHDFZ8z038zSL3C7/+zfP3C7AGzDZ9X49+jpp8fu5///59HSx6fBH6Pr377JB2zOr/r/59HU///wb367d+P///Xrj6PQV5nQV57at/H///XjR2y7AHXSv/r/P2y7AH7Wz///B2zJl+z/x8Pah7rlz/X///Hjv///997fR3m7X77u///ub3m7AGzMn/X/AGzFh+P///r0r6zMH2y7D4LUr/H/AHnWx///v6PBJ6Pr9+jnd6fj1///z6zFB2y7/+jfN3C7b9r6997YAHDHj+j/z7rHAHXHd9X479raR3W7N7ryt6fFN57ft+P25+Ppl6PHF2y7L6fpz8PQF3W/AHXFX8PyV4zDD3XBL4zOb7rn5skZLQAAAHp0Uk5TAEz///////////////////////////////////////////////////////////////9/////////////////////////////////s///////GP////////////////////////////////////////////////////8NTqAuAAAA8ElEQVR4nGNgoB5gZGJmYWVj5+AEsrm4YaI8vHwQwC/AICgkDBUVERUTl5BkYJCSFpWRFZWDCsuLKihCFSgp8/FBhVVU1dSBlIamFgODNkJYh08XROnpGzAYAkWhwkbGaiZQYVMzcyCwsARxraxtbGGqkYCKnb0DWNjRCcx3dnEFUW7WNu4g2sNTwQtoqbePrx+I6+3jHwBWFhgUHBIK1BwWDuZG8EVCzYuKjmGIjdOFcOIT/BPhNiUlJKdAmamiaelQZkamWBZcSbaoTE4ukM7LLxAr1EI4sggYgmLFonx8JaVo4V3GEldeUenKgBcAAGUcJVYgDysuAAAAAElFTkSuQmCC"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAn5JREFUeNqslkuIzVEcx+d/Xe9RTJ5JUSRZkQ3Ko1lQlCgpg1DjsfYossF4pFlYaNSUndJspCxGFmYwymKaKaLRxCzMAlGeY9zLvT5H36PTcc6955Zfffq/7v/8Xt/z+99sRnN3XcAuwE4o1KXbRDj/rn1tm3szr+McWORcr4ZTcLcGB83QOPPA/QFdF+G5WXArXINp3gvH4G21VYn4z5GFBzmchW3O44GMEg1xMhUOwns92K2UT8LPhOgnwGV4Bp26txjOGQdmgR5Y59XzNMyHLMFBGZ6YBcmorIzqOfSZEv2CnPfCdzieUnhbooBNNsHlExtoAijBGGX314jUnrqZfvNVVMkOwUI4CmtgT0K5zsCnkIN5MA5e6voEbIEmXb+GLu+dLODgsy2772A6XJd6THGXwgYbDTZJ2fjmrlNSkIWQg37YBe1SxSZPpg3alK4N0uhLvkd6MzvWg37t5NCY6IVX3r0fFXoRbXJsBn0VKTJNVpHZgCugVZntiMjUjbzVBhJqskn5i65NDy5KTcY+BkoUcjAaU9ESLWi0vxIOa2w/dVTUEFl4vDZhWbMpmMFDuAI3YRg2ehO1oNESsk760e2UblasBzfgMbzRTHLtg5PNP2OpliYPRe4PixQVZTEH61WGBzAFNkOHdugy2F5FRSWVuRBzUNTHo02LPbKbRup6kaCiQqUMevTpuwV3oMV5Zhq3PMFBl1VRLvCDRul+r37U4kzMETW6GsVKGZgIjqg0HfpTkOm++eDUV8mg5I7wvDuYZPec81HJ1h12vSkqsvsgp6hSP5212Ij9JpvxvAquqn41WUCm1hbAXONgv3S7D8b+xwzMFLj9W4ABAG8br/gbSq1yAAAAAElFTkSuQmCC"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wizard = __webpack_require__(1403);

var _wizard2 = _interopRequireDefault(_wizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var name = 'wizardStatus';

var WizardStatus = function WizardStatus($scope, $state, $attrs, $compile, $element) {
    'ngInject';

    _classCallCheck(this, WizardStatus);

    var ctrl = this;
    ctrl.$onInit = function () {
        $scope.tabStats = ctrl.featureData;
    };

    ctrl.$onChange = function (data) {
        $scope.tabStats = ctrl.featureData;
    };

    ctrl.$doCheck = function () {
        $scope.tabStats = ctrl.featureData;
    };

    ctrl.selectedWizard = function (feature) {
        $state.go(feature);
    };
};
WizardStatus.$inject = ["$scope", "$state", "$attrs", "$compile", "$element"];

exports.default = angular.module(name, []).component(name, {
    template: _wizard2.default,
    transclude: true,
    controllerAs: 'wizardCtrl',
    bindings: {
        featureData: '<'
    },
    controller: ['$scope', '$state', '$attrs', '$compile', '$element', WizardStatus]
});

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEwIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjA4MjY4IDEuNTE4MDZMOC4yNjAxOCAwLjY5NTU1N0w0Ljk5OTM1IDMuOTU2MzlMMS43Mzg1MiAwLjY5NTU1N0wwLjkxNjAxNiAxLjUxODA2TDQuMTc2ODUgNC43Nzg4OUwwLjkxNjAxNiA4LjAzOTcyTDEuNzM4NTIgOC44NjIyMkw0Ljk5OTM1IDUuNjAxMzlMOC4yNjAxOCA4Ljg2MjIyTDkuMDgyNjggOC4wMzk3Mkw1LjgyMTg1IDQuNzc4ODlMOS4wODI2OCAxLjUxODA2WiIgZmlsbD0iI0RDNTc1NyIvPgo8L3N2Zz4K"

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuOTk5OTEgMTZDNy43MTY1NyAxNiA3LjQ3OTI0IDE1LjkwNCA3LjI4NzkxIDE1LjcxMkM3LjA5NTkxIDE1LjUyMDcgNi45OTk5MSAxNS4yODMzIDYuOTk5OTEgMTVWOUwxLjE5OTkxIDEuNkMwLjk0OTkwOCAxLjI2NjY3IDAuOTEyNTc0IDAuOTE2NjY3IDEuMDg3OTEgMC41NUMxLjI2MjU3IDAuMTgzMzM0IDEuNTY2NTcgMCAxLjk5OTkxIDBIMTUuOTk5OUMxNi40MzMyIDAgMTYuNzM3NiAwLjE4MzMzNCAxNi45MTI5IDAuNTVDMTcuMDg3NiAwLjkxNjY2NyAxNy4wNDk5IDEuMjY2NjcgMTYuNzk5OSAxLjZMMTAuOTk5OSA5VjE1QzEwLjk5OTkgMTUuMjgzMyAxMC45MDQyIDE1LjUyMDcgMTAuNzEyOSAxNS43MTJDMTAuNTIwOSAxNS45MDQgMTAuMjgzMiAxNiA5Ljk5OTkxIDE2SDcuOTk5OTFaIiBmaWxsPSIjMDA3NUZGIi8+Cjwvc3ZnPgo="

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI2OTQgOS4zODU5OUwxMi45NDYyIDEyLjA2MjJMMTIuMDYxOSAxMi45NDY2TDkuMzg1NjMgMTAuMjY5N0M4LjM4OTg0IDExLjA2OCA3LjE1MTI1IDExLjUwMjIgNS44NzUgMTEuNTAwNEMyLjc3IDExLjUwMDQgMC4yNSA4Ljk4MDM3IDAuMjUgNS44NzUzN0MwLjI1IDIuNzcwMzcgMi43NyAwLjI1MDM2NiA1Ljg3NSAwLjI1MDM2NkM4Ljk4IDAuMjUwMzY2IDExLjUgMi43NzAzNyAxMS41IDUuODc1MzdDMTEuNTAxOCA3LjE1MTYyIDExLjA2NzYgOC4zOTAyIDEwLjI2OTQgOS4zODU5OVpNOS4wMTU2MiA4LjkyMjI0QzkuODA4ODIgOC4xMDY1NCAxMC4yNTE4IDcuMDEzMTMgMTAuMjUgNS44NzUzN0MxMC4yNSAzLjQ1Nzg3IDguMjkxODcgMS41MDAzNyA1Ljg3NSAxLjUwMDM3QzMuNDU3NSAxLjUwMDM3IDEuNSAzLjQ1Nzg3IDEuNSA1Ljg3NTM3QzEuNSA4LjI5MjI0IDMuNDU3NSAxMC4yNTA0IDUuODc1IDEwLjI1MDRDNy4wMTI3NyAxMC4yNTIyIDguMTA2MTggOS44MDkxOSA4LjkyMTg4IDkuMDE1OTlMOS4wMTU2MiA4LjkyMjI0WiIgZmlsbD0iIzAwNzVGRiIvPgo8L3N2Zz4K"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAdklEQVR42u3WwQ1AMBiGYYmDDsE+pukENrCMC7GHI2bhlzRCD476kfdNvqTH59Q2y4iI/lcdpoHx3m/HFFAnJoAmW66CmW2lCmYB84CpVDArmEtdBGpT3zfONkaoBhQoUG+j7NynfO1vKNtgK1Q+aU4JQ0T0+XYKwX6IHMu5RQAAAABJRU5ErkJggg=="

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAZUlEQVR42u3VsQ2AMAxE0RRMAEySwTwFYzEDygDZBZwiFECVJhf0v3T9kxuHQEQ0botvVsGsvuQ7FFBTgZjZWSaBqhhQoEB1aHug9p6Y+HGlCAYMmMZvn1UwrwspYG6UEoaI6LddleGS2KTb9ZoAAAAASUVORK5CYII="

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "<md-dialog flex=50> <md-dialog-content> <div class=md-dialog-content layout=row layout-align=\"start center\" layout-wrap style=background:#fff> <md-progress-linear md-mode=indeterminate ng-if=!percentLoad></md-progress-linear> <md-progress-linear md-mode=determinate value={{percentLoad}} ng-if=percentLoad></md-progress-linear> <p style=margin-bottom:0!important;padding-left:10px><span ng-if=percentLoad>{{percentLoad}}% &nbsp;</span>{{infoMsg}}</p> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 463 */,
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArpJREFUeNpiVNq1gIFIoArE1kBsAsQ6QKwIxOJQuZdAfB+IrwDxGSA+CsS3iTGUhQg1DkAcBMR+QCyPQ40cFNtD+Q+BeBMQrwPiA+Q6QAmIU4A4EYglGEgDIIfmAnEoEM8H4jlAfI8UBzgDcSEQezNQBkAOrwRiPSDuB+K96AqYsGgCBXUHFSxHBt5QM/0IOQDk81poQqM2MIGa7YzLAUrQYKeF5ciOKITahZEGUogNdmshSYY8ZQMGdR4Bhhuf3zNMuneR4di756RExyUgrkIOAQdoaicIDPlFGaboOzCYCIgx8LKwMZgKijNM0XNgMOAXISUkEqF2wh0QRGxWi5fTZOADWowM+FnZGOJkNUnNHUEwB6hiS524gCQHN1ZxKRzieADITlUmaPEqT6yuPa8eYRd//ZiBjMLKmonUVL/0yU2GbS8foIiB+MuA4uTkChZoxUI0+Pb3D0PRlcNgSzV5hRiuf34H9v3vf//IcYAOI7A2fAitSAYCPGJBqlKJAsJsHMAsJ8ogwc7FwMHMzPDj71+GFz+/MVz4+Jrh7a8fpDpAnIVYlSrcAgwJwCxoIyzJIAqynIkZLvcdGC1vfn1nOPz2GcPCRzcY7nz9QLQLiIoCdzF5hjYtSwYBVnaCBn74/ZOh8toxhl04cgt6FDBBWzJ4QZ26GVGWgwBIXb26ObEBcJ8F2oyyx6fqPxCCfPafmCCFqicSXGGBtuHwApvDa2iVC84wQRuQDwcgC4LsPMoEbb1uGgAHgOy8DasNQa3XF3S0/AXUTnh1fADaeqUXmA9rriM3yUBN5610sHwr1C6MNuE9aNP5DA0tPwO14x6uVjGo3d5MI0ecgZq9l1DHBJQ6v1KpY4Ic7Fg7Jrgqo73QIvoSmV0z5NROVtcMliZATeddRHROsRUyFHdOGZCyKAhPpkX3HCDAAL5BuAWAUO3HAAAAAElFTkSuQmCC"

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAn1JREFUeNq8V01IVFEUPu96h9Ax3AgjThYTKS2mXbRoIjQJCdN0aCOthNkWuLIJd25mN6BbYXAfjihuDEuQ2Vk0YQUKSc3GKYgkJhJ1nudOZ+SN9u478/PeB99qzrvnm3vPPee7hmmaYMXQ4ijYoBsZQd5EhpEhZIB+yyN3kVvITWRmeSS9AwwYDAG9yChyGHkFePiKXEIuoJD1WgVcRcaQ48gOqA17yBRyDoV8+V+AsPmwHzmDjNeRHOhbtcYM/rF+rgC11QnkIDQOaq0EihjWHgGpTFChuQFVoM/xONbO7QAmV2c+4WJyoLUnKNe5I4g1eNt1xxGrEICKeqnavcI45TzdgWid1V7L7YiWivBhekR1uFe6JvPk+hg8ujYEzbKZnaFoFuHTz88Q35jSNav7ktqrtsM97onCt985yP7IsgW0XWiDe119uhCVMyI5VS+FhPffs5D6OM8WEGwNOgko3QpJg0WLwuEfeBAagLuX7rAFNBmSExaWNNUcz9Pva62qBpgICctItZ9Yhmu3IcDapxbZAq9zb+Dldpq9ctfFIMRvTTrGSTITl3VBwhDw6+8+5PAmcGFCkROWF+RknItKiKr21id8nLBdQTbKEUfF46oEHBwfcMK2JI1I597pD8CN9jBbQIef1dk3lYAMtUXbbvg2/w4inbdLrAaFw4KTb8yUDAlOJmW/noK3mEVj8qxcWQtkIL3CHuX8N47JOqc8FJAq23Xr3ZpDrniQfIVyVVoy8u1J7q2ow5QmrW+Eiu5CbnXaJRFqzWmrIy634rNQT6oCOeTBBm578mxyOwEKa9SiP7j9NNNNQ/XBC+Sqm49TzjheJ8668Tw/EWAAP63Ev9r44ksAAAAASUVORK5CYII="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAvJJREFUeNrMV11oklEYfvdlztwaS0kHW7pJeRH2YwwiBrUQrwYj7KqLLgZe1F2DiO2iIAwyVkiD7gZeBWvRCmNXMehGuliNMqEicP6sWNGUlaaZP73n+16H5t/nbz3wgKjnPO95z3vO+5yObDYL+VA+eQllcAA5ghxGGpBDSDX99gW5hvQi2QTuzTPDH0EEOkQEMIq0IMeRWhCHANKFXMRAntcbgA5pRU4g+6A+bCCdyDkMxFfqD1yZgSbkLHK6AXGgsWyOWVyYSWwALNV25Bg0D2wuOwYxXnELKEo7FVorwPZ3CrdjuSgDKM72fLKF4kBzT5JW0RZYm5z2StthLQgAIxqlam8XJkhzOwOWBqt9Gwd7ZHBJrwJdl7Ta6bDwRah4vMJuuGc1XDJlMYSitw4PgEmtgIXgV7i4Gqx2WZk5ul4bFt/fLYWZIxpenMHc11ttCNMc4cRWvVK6A/S7S6eVpfvGoQE4rRJEY+k0XPOGRJ0KjhpL5etMJoHrhn6YP6GH4wpZkfidoxow08ojyd9w9W0Q5kMRMQEYOOpqFXFeq4RzGhVo5TK4d0wHxt5O/nuNfCfcRvGTe4WVJzIZFA/A/UAYMllxZcPltdSyWAlHwR+NCyO65bjiQTjb3wM2wz44ReLRVAouv/bBw/UtSGWzYktHzU5BAj90VmyZSOOeXXDXOIjHrIv/LomrlXLCKY6h+DSm/UEwUos4wy+OzERFsClXI3G48iYA/piQiZx4AgtuyuOvR5w3Mhw5GVF4sfkTLrzywYcfMT6oWCrNr3whtFWPOMMaRzZKfDsLx+Hmu0/wLZGEmfdBeLQeqVecwSuhFikaTOrp5+9IT1PaM8uAm67FdoNpujlyr65/EICLaee64SIZyHZhgzSFdkzW2dnGAJw5u57viOaQS20QXyKtQktGvt1R66mow5Q68t8IBbac3KqtRUGwOW35jphBUqo62SVHDnmsiWl3/C1eLgCGZbqiPa1+mv3Xj9O2PM//CDAAG+4ZDdQnCo0AAAAASUVORK5CYII="

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAudJREFUeNrMV1tLVFEU/vaeScmHLvagaSQT1NMEBUEXKyXzSRAS+gHCPHUDocgeQ4qhHobsqRDmISgo8CGQiBKMmJKaCMR5EhK7Oob2EF4qPbu1j2vwnJnOcc+VPvhgOHPO/tZee+21vy2UUnBi5dF+eGA3sZl4gBgmhoh1/F+aOEkcJyaJicDp9xMwgDAIoJXYRewkNsEMU8THxEEKZKTQAHYRI8RuYj0KwzQxThygQD786wXp8WEbsZ94pQhx8Ld6jH6aWJtpADrVUWIHSgc9VpSC6PRdAo4yyoVWDugC7aXlGM7JAInrNe8pozh47B7WylmCSInT7rccEVcAFFErV3vxkBsgD9+ECJ3ye6ubNRHkB11FVvua+MFrEDtOQjSegLWyBPXxidfu0JojYvnhPt3hnq3bZGroGxHIKmFKoLUMLHwj8Sqa+Q2IhhbXK9ZoL9Snp17Nqj3I7XXdDhdouwdUb3UH8WeeBC5DLaYhD13PEVczb6F+pLyG1JrNQeOqr661Z6K+vlh7tjgDNTu2OvNGd59R39/BStCmWp733RVBPlgMTg1pi2WnUx69BbH9uFs8/RrWq0vriWuEJZ9qxkXmWv+qzZTmZE7aDWaeQUg6jtT8QEsiW+5CfX4OK3mVZz4K6+W53GL1Rp0sdMeJ2jDElj0ItD8A5lKU8os2Rf0RyPBZ86Symcg/gG17gZ9TlPI3wKYQ1JdhO+0ifMbOjiHSQXYyO/MNwJq4D6Tu0I/f7j+URVwxHWZSso0yhMO8LM3mimcCMMd4kI9IMwQ2UvOu8V+aQDWUMC6tpA4gwW3RvxsuTEM2dUA1HPMfkrYmfs2Z+saEbUjoZNL26zwqi9tkTC5kcjXIBrJSmGbNVT/A1jlewQDiGbvurJYB4lAFxIdYy23J2LfH8toVhZnSmPOO4Nov7Fb7yhSEHrPP6YidlswJfaWaZ4fcUcK0x7LFvQLQGOYWPVbuq9l/fTmtyPX8rwADAGiPEOb7DSjoAAAAAElFTkSuQmCC"

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAhNJREFUeNrEV79LQlEY/d7tGf3YWmoTA6EhaGmroWgMHPoLChwac6tsC8toMKRR6D9oEFqCyMWlmsItyhoiHfoxGKkldr76omem6NX33oGDoN7vnHfvd98916hWq2RFeOWUGsAPToGT4DjoA4fltzyYBTPgBZiO7M1eUQswWjAwAy6AAdBLreEOTIKHMJLSNTAKBsElcIT0kAMPwASM3Pz3B9Vg4BwYB9c6ECcZyzXieLC5Vg3wVEfBeeoeuFYUJgJNl0BcRqXR7AA36CqW46RuBiDOax6yUZykdki06pYg2OVpb7YcwRoDcDQj3e4UlkSTTPliQafbw5Fp8ngUPT0WKb5z1u7uYM2UghO/dH7bGBj0kKe3h/r6TZ3hAdY25fXq1anwcF+AAUXPmAENsOaU2UnX7++ed7wrlBwsbmHclFNNC/6xITIMg8rlCt1ev+iU8JmWI7VtLC5PfH2+Fsq0tZHWKTGsOpm/dzw5o/hW0a6hJEy4hbySJOMWskpilFvIKDki3cIFG0hLhnMarJlWkl6TOhUMZcinloEka/8MPZQA2RaKbx9UKlV0tmFONH8jGU6mLQmQTmAbT7/+NxElwCMHxI9EqzaSSW6P2bwruHbMekeoaR9Jq5s2meCam9ZEbI1kNd3J54sk5PkuTnvsr3gjA4wTeUVf2n01axbmeAB36rGjl9OGCfg7vHb9ev4pwABjzbfp4TMIwwAAAABJRU5ErkJggg=="

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */
/***/ (function(module, exports) {

module.exports = "<md-dialog flex=50> <md-dialog-content> <div class=md-dialog-content layout=row layout-align=\"start center\" layout-wrap style=background:#fff> <md-progress-circular md-mode=indeterminate></md-progress-circular> <p style=margin-bottom:0!important;padding-left:10px>{{infoMsg}}</p> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var url = __webpack_require__(862);
var parser = __webpack_require__(118);
var Manager = __webpack_require__(226);
var debug = __webpack_require__(71)('socket.io-client');

/**
 * Module exports.
 */

module.exports = exports = lookup;

/**
 * Managers cache.
 */

var cache = exports.managers = {};

/**
 * Looks up an existing `Manager` for multiplexing.
 * If the user summons:
 *
 *   `io('http://localhost/a');`
 *   `io('http://localhost/b');`
 *
 * We reuse the existing instance based on same scheme/port/host,
 * and we initialize sockets for each namespace.
 *
 * @api public
 */

function lookup (uri, opts) {
  if (typeof uri === 'object') {
    opts = uri;
    uri = undefined;
  }

  opts = opts || {};

  var parsed = url(uri);
  var source = parsed.source;
  var id = parsed.id;
  var path = parsed.path;
  var sameNamespace = cache[id] && path in cache[id].nsps;
  var newConnection = opts.forceNew || opts['force new connection'] ||
                      false === opts.multiplex || sameNamespace;

  var io;

  if (newConnection) {
    debug('ignoring socket cache for %s', source);
    io = Manager(source, opts);
  } else {
    if (!cache[id]) {
      debug('new io instance for %s', source);
      cache[id] = Manager(source, opts);
    }
    io = cache[id];
  }
  if (parsed.query && !opts.query) {
    opts.query = parsed.query;
  }
  return io.socket(parsed.path, opts);
}

/**
 * Protocol version.
 *
 * @api public
 */

exports.protocol = parser.protocol;

/**
 * `connect`.
 *
 * @param {String} uri
 * @api public
 */

exports.connect = lookup;

/**
 * Expose constructors for standalone build.
 *
 * @api public
 */

exports.Manager = __webpack_require__(226);
exports.Socket = __webpack_require__(231);


/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgFJREFUeNqslksoRFEYx+8dk1d2svMoWcwWYUvySBmLSRlFk2RhQSwUFiILC0ljYaMQ4xEbKYUFYmNjSymJBaZkmLzNXP+Tb3I67r3nDL76de89r+91zneubhiGxskCKAUJmrVE6PkC+sGiJhOmhCNkfEkUfJggyjvwCmv8wCnofANRUAnORXtAMmgGPUAHbP4c9S2pehIEEZAjse6APLnmPGqwGu+w0J0oifIZPcfACHk0DxrMBju030kCF95eMEFts6BeHOyULNYGvBT/W9AFLrh5HcBNxkYoAsyjR7Ahy0kefe8Ku6ma2v2GvUzb7a6Y6PRsAgX0/QD2qH0AbJucpzrg486SUrguCVHuwLpJeyYpMeJR4iZ0G4/ZyfeDE5BkNshKScySPlCisNtuwKBVpywn7VTLdBsFbBuv2lkgC9cR8SeRKWGhKpd48goC4Iobp8eTE5bQYgVjU8GQuHVVc8LOQ61CTpbpfQVkk2ffiwmXVhCkAxc41f5JZDnJBUVCrMNgizywkzKwo1K79i1qk0dy34zTOkq1a4osd9BmYO0hblungHxwyCWd3TGdVOtsq3CW7N4musmzAEgDo5y3PpknhSCDLDeEvmdwzB3WJ9BI1dpF7a1gRva3IpMabk4VCHN9LbK/lTVQYXMtM8/uqSDGZBN4wDCYBNPipE8BBgB+kFiVpm7FfQAAAABJRU5ErkJggg=="

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Not Updated Admission numbers\" flex=60> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>{{modal.title}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <md-input-container style=width:100%> <label>You can add comment here if you wish</label> <textarea md-maxlength=150 maxlength=150 ng-model=selections.reason md-autofocus></textarea> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <div> </div> <div> <md-button class=\"md-raised md-primary\" ng-click=saveAction()>{{modal.btn_text}}</md-button> <md-button class=\"md-primary md-raised\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-actions> </form> </md-dialog>";

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqJJREFUeNqMVEtrU0EU/ubO3ERzU5qHbZVWkdIHAS1WVAq6diG4KLjWjeDGlfgjXLnQjXbbf6C/IHQhgqAbQawPamttjblNmqbJfcwdz9w26U178zgw3LlnzvnON9+cGXbh+d/rZ63KSwU+9W/7N3tycxSLsxY+f/8FYRhQSkEIgcLsVPjV/9qsJMfy+w08K25Vc2MTD8i/ov1iJLX7OlBsHiyMg2Ew1Op7+LG5DpMLBARwKmFiZnoSJq0fwHVYjnLf0sJdmq8IBjUZXWUE7EuJhuNAChkCKhUgzhhrT4dp/oZCFw36kS2v3k1AuUliFBCo7/vwaHDOibnRwY4Tgo6N+DLkWhbtajRMzlD8WsK9uQLu3FpA03XDIvlsBlkrGbJtgdUdieK3cjiP2BC79mq1rHVgzIC3X0W1tIkbF7O4XRgDJz01REBUtAytwiQCiqs23v3cwfCZczCtTEsWuw3Y4uk3dlHfqxGAQmfxI9NEOe0mbaUhUsPRo7LFsVCYFJChoeLOM3ogh21x/MDEyeoBBrFuBUWcM1ADYcJgfQA1kEvaWSbrql9Ux7qnkCAto8AiCiaoKx/ND2FhPNmXpQb58MfF0qcaPHnEtg3Y9BXuX7bw8Eoa+76+BawPQ4VLIyZqboClj3tImawTUOdP5wR8xVCyKyiVbaoaD6r7Mp/PYWIkixnKid1ya9v6NpimST1mdWWpOyFBMTr2uDQi/tKT0NzowZB1LSbiGtZxHVQq1Z5bFoITqHUSMPBcbiRPE5I8rKqQzWToQcj2PJTwoVDqIEcPgyNwGlw0d7fWkunROXqx4Tgu6k0DDW+wzg7oNdU5yvcg/Qac/Z0tYbvrj3O2fNFU6vzGWop9kQk4/mCAuqnXtz00y3UoKTcqV8ef/hdgAAPYJnYgDfE2AAAAAElFTkSuQmCC"

/***/ }),
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJEAAACRCAIAAABMus10AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAADFRJREFUeNrsXYl22sgSBSGQwAKEAS8xsZN4JhNn/v9rJu+cWWLHZhMSYhWCd6V+40eQwDIGdTWojuOTOIAl3bpVt3qpThvtdioxoUxKHkGCWWIJZoklmCWYJZZglliCWYJZYglmiW1l8qHe2GKxcOfzmW+L+Xy+WOCHaTipJKUlSZblrCzj7wlmnA3QTKbTyXg8nnrmzmYMqqCl0wBOyuVyeVUt5POKogh0m+kDGG90XXc0Hg+GQ4AFVm3xCaqiFItF7eRECOYJjBmiH6CybXs4GgG2t39gNpvVy+VSsZhgthdi9W0bXwiAO/9wRMtqtarkcglmuzHHcax+H2jthFhrxbQkVXQdnEs0yJsM4sI0zcFgsE5W7FbLdLpdZMdarSZnMgnPtslbRq8HwGJAazXDyXK9Xke0TGrq16Wux6cnYBY/YF4ons1+PD4iGCeYRQZsPgdgkIV8Wd5st+E0CWbRHlazOZ5MKFxM1zCQ4RLMXjC4Nl+GrRgyarvTSTBba6AXnhG1qzItC4RLMAs3BKIFD9ERhf1ALsFs1VCEoTYiG7ThT3yDNkXMCEbFFXHUarW2G4w+TMxGoxERrbjBZq7LUY+Qw8yy7ZQINhgObU6XSgsz13WHw2FKEOsYxnw+P3bMkNu5PIUtI+RsZvHQkLQwG4hDsueKLX4nI4QZbp6yxF8nRlCZHC9mk8lkrzOZe7L+MWM2Eo1kzBAbHMc5Xp6JiBlK7JgLSiqYsaWJKTEt5jRMBTOEFxGTGbPpccbGmG9754VanIqfCmaCJrPnwH6MmE2FTWYMszhn+yQi9+zwm9oQzkhgNnNdcQVIyt9lgz9HhtlsRnMlQXTM0seGmSt4YJS8jYhHhpnolslk4ty4RgIzid4+hldZVo51qwoJzGRZ7C3CuXg3q0lE/FRo2GLejk0jNkqSSmy/0KsuXjlCnsG0QkFQzFRFycSbj6lgls/ns2KGx0Ls3kYFM0SYUqkkYjV9vJjBSsWicFQr8AgPhDDzugVUKmJhxqWZCK1xkKKmCSQgIReRho8ds8ViMRdngF8vl+McGiaKmdddTJBFBrIsn5yc8EkipB6EQGu/Z7MZr31yhDBDYCS16f1FM3o9Luv7JFKeOxNqIg1Oduz7YhzHEW62Ggk4/mumxDMBl4RwWclCay+TcJgtfDtq3Sicxbx6hxxmInbhzvh2vJiJOBej5HJHzbNsNisc1Qo8pmoJPSNZlil3bg4N5skYcYrXCN52pqoql27F5DATKDwWeJCMHGZw26KmiYIZr97S5JxaL5eFoFrWtwSz/ymRiq4LkMwUhcuEZ4rmOEi5VKJ/UNIJvwWZFDGD/9aqVV5eHDEw5hPMgpGnTPW4FhYJJH4uRTfbn+p6jmSJjcKf73lbdDFDbKzTi5Be3K7V+F4VaVWtqiq1E+ROKxWVtz6iXglB99M5zUrTNAqHolHHLJPJEFkQjjSGWE3hSgQYcShqWo7TiMP/H5MkndXrRAZoRDgmNp0u8s5qSGN0RKwYg+h8TyHmLu6FxMybDuWn1lBBkyo5hJms4qWwIYIKxGZihcGM18SHt8Wd2NyQMJhlOFVpBPcwCoMZr4yS5V1miIzZkfH7EDBbcCI3wWk8cTDjsc3J+6X0tlcJgxmvvpzzBLOtjdfeeII9XMXBjFMzd4J9FMTAzDsabTKJf1MhzVNsxMAsXyh8+PAhr6qu68YjRvBb8LvKun59c0OtH6gAW77wyNRCIX9yUiqVHh4ems0m3H+vw/xAS1GUd1dX9Xqd/dM2TTr789NGu026lE6ntXJ5ubC1bfv7P/9YluU3SN9x8QRvwGdWq9WrRmN5wmw6Hg9jP09QVMxALyUw4geXf3r0DMJkV+MUXqut+bxwcvK+0SiHLT4f9PsOjdxGPTY6jhPEDFS4uLzUK5X779+73W7qzXuxWbC9urrCx65zgtFoRGQ1EWkN4sxmf/3997rmPKqq3v7yy+3tLXLP1tqEaQ1kyi93d4iH6wDrW9b9wwORbhh0McPTbLZaA9tuNZsbXnZard59/Xp+cQHyvfaZAi0IHCjSz7/9tnmL6Y8fPxCHu4aRYLbJANh4PIbMgFDcfDBtNpu9ubnxnrumRSQcO2WuVqsB77Pz881axuz1TNNE8DQta0SgixpRzNqdju3rtLQkTSaT5tPTi28pFotfvnx5//69lMls6GfEgiGLq5/8uPoi3UGy53+2Oh3ux35RxAwhyFzq1wYHb7VaUcau8MrLd++QmSqVSujZf0zKX15egl6np6dRLqbX6/X7/WeNA8bDnxLMfnLqTrdr9HorKhGARaEas0I+/+vnzx8/fcrmcs+cYPQCFxFC319fRxzawLtQUaz8EAGAV7dNWlrfa7g5HBqmGXoYK6Na/ews+oo55Cpv3OT+vt1uAy0UyI1Gg0mV6FdlGIa9RLLlSADUNU7rsfhjBg4NRyPbtjeMxuJBIyg9PT1dX19H/2Tg9OHjR13XEd8uLi7UV7aG8Ei2lMmCmhZXxWWHLp9xEOSVqeOMfBtPJlGUHl4Df//6+++xLYTqdDr/+fZt8zhLRddLxWLMg8jx/TI8dOCE0AecQCnnlfNScGoU18hq1zc38XjV0+Pji4EUqdeyLNR2iJNwpngWj8j7xgnYjFBnTTx741mr4Bl8HznpVevAkcxQYJ2+chsSMhnK+SgHILrzudXv4wtlIkIlTMnl9jrtIO/JSYETC307nOdlWQ0lNoqwV1QO3e5ff/6ZLxSi9xPz0hVk6itJg2uDnsSX19VAVQEemLePNcg7xgx8QjUDBbin5sIe1drt8/PziDuLwOwfDw+g2sPDw+3tbcTfAs0CTbQ1VxzfwDzkQsDmOYuq7nBtq7wrYg2GQ6AFeu1XMv1bqzWiUQ05CYEZGqHb6dTr9SjHdbGJnp1cLXxl4BsuG/Gcgae8uYHPWzHDE+zDJweD2Frjw/1Rcp1FoBrQemo2mfADEvffvxfv7l58XubPAx+7yutj31KsH4yqevApynaCU96aWAiAQGsUe4N5RrV2q/Xu6mrzK1FQzxyHYYbvQAJgs+UCm0gWecDlrZFTksC5vG+5bDY6+eQt/AWs2l/Giki1VqsFqm3wU0hwqI/l6grvQm6rVCqb38VWLcRwFxCcw9GIHbeCmMFkixJh65QcPQYCKmA1JTC/DpdE5QDSXFxcrPOt+/t7fF92XvwdDvf4+NhoNNZ9MjIll7U6U99My5KZbPFV7rppcflF3cUGliKOVsRJNYTHs7OzUE4ATht0CdwzXoxSoXp6GtphDD4JkvHdCIPoBW7gy2t2rKqapgG9lXuU1xZYgGowwHeX5PESIA2uDZVvNVAse9VVs7lYV+FNp612O3TcstVsQukR2bzEpDi+EMmLmlZcOuxUXrlbaAovBI5GQhyRBKoFMQMwFV0f2HboWwCJHrasCqHJ6PUItmgFELgwhM1SsVgulWSWjQEV0gND1RHkmD8W6CAF4WHBpRz1szOQxpnNVsQYnLes66FVGgo4Z3cr7/ZBu55pQm16Q9LAELdNcFV6xDuBOAxihhqoXKlAUKxgAO+s1WqhmgVhlnKXz2XkpK5hCAoYC4OmaYYut4KmXwl0AAZKOpRkSI2oXkRpEy/2uUx4yhN/MDr4XyAfip5lrbuYz/HD0OIMctEV5/Q14c/SwrNGVgspYmQZJc4yBYGetqYFUp/HEY/HixnC47onvrKYAK8MnY6B7BIoMB4IZt5AWlhlsjw1iiAJPRI6ITL0B3foC5CDwsybCg872BpF6DISYFJoMkMlJ9bZr4dwNiSSlh1WQa+MXa1r9oH3CkSy1MGc5znYdkMfgipkZ4IZB8WPnBQU6yt1W+gZt0N/6CfBjENK8xa2BlLaSmuPub/8OxgYhTtj+UBiozcKHgiPk+n0mVje7jTXnQVGU9cNJSeYxUE1O1BZT35eUMSajASTmXAHvx4OZitVmjevFMBjJX4KV5kdGmZ4+ssDj/7C5ckqroifSzIE1BQumR0OZiz0LQ9iQVy4P8+fpSWJbel4/km/3xeOZAeFGZ6+tZTSzMC2vrSfwJ5xBQsRGxPMeKe0wYCt+0TJBWzSAXGB1xj/9h6wLEu4yuwAMfOWTviQ4HuouGDLEVjaM/xmMEKOIaQOyNgODGc6xfd1BEJZ3el0hv7uArKrPzabfEiYsVWn3/74Y7i+6mK49gxjZcVqghnX4tpf0LnhBWzFvKCAwf4rwADK3UKbgjYl6AAAAABJRU5ErkJggg=="

/***/ }),
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 645 */,
/* 646 */
/***/ (function(module, exports) {

module.exports = "<style>.scheduler_header{background-color:#00b6f2!important;display:block;color:#fff}table,td{border:1px solid grey;border-collapse:collapse;padding:5px}.quiz-table{width:100%}.quiz-tr-head{background-color:#5d545470;color:#fff;text-align:center}.quiz-tr{text-align:center;background-color:#80808024}.tr-label{color:#035cc9;font-weight:600}.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}#customers{font-family:\"Trebuchet MS\",Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td,#customers th{border:1px solid #ddd;padding:8px}#customers tr:nth-child(even){background-color:#d0f1d1}#customers tr:nth-child(odd){background-color:#c5ffc6}#customers tr:hover{background-color:#ddd}#customers th{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#4caf50;color:#fff}.metadata-question{background-color:#1f5fab}.qn-label{color:#a7a7a7;font-size:12px}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading metadata-question\"> <h3> Add Section Comment </h3> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <i aria-label=\"Close dialog\" class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=\"whitebackground md-padding\"> <div> <div layout=column> <md-input-container md-select-on-focus flex=90> <div class=qn-label>Enter Section Comment</div> <textarea ng-model=section.approver_comment md-maxlength=500 md-select-on-focus></textarea> </md-input-container> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <div flex-lg=100 layout layout-align=\"end end\"> <md-button class=\"md-raised md-primary\" ng-click=addComment()>Save</md-button> </div> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _styles = __webpack_require__(798);

var _styles2 = _interopRequireDefault(_styles);

__webpack_require__(799);

__webpack_require__(803);

__webpack_require__(831);

__webpack_require__(934);

var _ngMaterialDatetimepicker = __webpack_require__(449);

var _ngMaterialDatetimepicker2 = _interopRequireDefault(_ngMaterialDatetimepicker);

__webpack_require__(149);

__webpack_require__(1420);

__webpack_require__(1423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.jQuery = __webpack_require__(4);
//require('bootstrap-sass');
//import 'angular';
//import 'oclazyload'

// for loading styles we need to load main scss file


//import 'angular'
// loading shared module


// loading all module components

//import './libs/angular-local-storage.min';

//import angularAnimate from 'angular-animate';
//import angularAria from 'angular-aria';
//import angularMaterial from 'angular-material';
//import 'angular-messages';
//import toastr from 'toastr';

//import ngFileUpload from 'ng-file-upload';

// To fix issue  in text angular
angular.lowercase = function (text) {
    return text ? text.toLowerCase() : " ";
};
/*require('textangular/dist/textAngular-sanitize.min');
require('textangular/dist/textAngularSetup');*/

var appModule = angular.module('app', [
// 3rd party modules
'textAngular', 'ngSanitize', 'oc.lazyLoad', 'ui.router', 'LocalStorageModule', 'ngAnimate', 'ngAria', 'ngMaterial', 'ngMessages', 'as.sortable', 'ngImgCrop', 'ngFileUpload', 'rzModule', 'ngMaterialDatePicker',
// 'jquery-ui',
// 'jquery-easyui',
//'jsPDF',
//'toastr',
//'underscore',
// shared module
'app.core',
// application specific modules
'app.StateModule', 'app.ConstantModule', 'LocalStorageModule', 'app.LoginModule', 'app.navigation', 'app.AuthDashboardModule', 'app.commonFilter', 'app.teacherView', 'app.hodView', 'app.hosView', 'app.supervisorView', 'app.parentView', 'app.profileView', 'PrivilegeDashboard', 'PrivilegeSettings', 'app.TeachingPlanModule', 'TraditionalActivityModule', 'ManageReportsModule', 'ReportCardListsModule', 'viewGeneratedReportData', 'ApproveReportsModule', 'reportCardGenConsoleModule', 'AssignUserModule', 'PublishedReportModule', 'reportCardGenConsoleModule', 'RoleHeirarchy', 'UserHeirarchy', 'RoleSettings', 'UserSettings', 'reportCardClassTeacher', 'PublishReportModule', 'CreateQuestionModule', 'reportsMainComponent', 'TpWizardModule', 'commonChart', 'singlechart', 'childrenComponentModule', 'classActivityReportcard', 'educorePerformanceAnalysis', 'studentFilteration', 'academicPerformance', 'attentionNeedingStudents', 'performingSection', 'sectionWiseAttention', 'termDifference', 'myCumulativeReport', 'educoreStandardReport', 'CurriculumConsoleModule', 'academicConsole', 'userConsole', 'MedicalModule']);

exports.default = appModule;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _routerHelper = __webpack_require__(800);

var _routerHelper2 = _interopRequireDefault(_routerHelper);

var _user = __webpack_require__(802);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreModule = angular.module('app.core', ['ui.router']);

// inject services, config, filters and re-usable code
// which can be shared via all modules
coreModule.config(_routerHelper2.default);

coreModule.service('authService', _user2.default);
coreModule.service('dashBoardSeachedList', function () {
    var dataSet = '';
    return {
        getList: function getList() {
            return dataSet;
        },
        setList: function setList(newObj) {
            dataSet = newObj;
        }
    };
});
coreModule.service('userEndorseService', function () {
    var dataSet = '';
    return {
        getEndorsedObj: function getEndorsedObj() {
            return dataSet;
        },
        setEndorsedObj: function setEndorsedObj(newObj) {
            dataSet = newObj;
        }
    };
});
coreModule.service('CommonFilterRoleService', function () {
    var selected_role = '';
    return {
        getSelectedRole: function getSelectedRole() {
            return selected_role;
        },
        setSelectedRole: function setSelectedRole(item) {
            selected_role = item;
        }
    };
});
coreModule.service('quarterlyReportService', function () {
    var dataSet = '';
    return {
        getParams: function getParams() {
            return dataSet;
        },
        setParams: function setParams(newObj) {
            dataSet = newObj;
        }
    };
});
coreModule.service('classStoryServive', function () {
    var dataSet = '',
        criterias = '',
        isnewCs = '';
    return {
        getParams: function getParams() {
            return dataSet;
        },
        setParams: function setParams(newObj) {
            dataSet = newObj;
        },
        setSelectedCriterias: function setSelectedCriterias(criteriasParams) {
            criterias = criteriasParams;
        },
        getSelectedCriterias: function getSelectedCriterias() {
            return criterias;
        },
        getParamsFULL: function getParamsFULL() {
            return dataSet;
        },
        setDirectedFromNewCS: function setDirectedFromNewCS(bool) {
            isnewCs = bool;
        },
        isRedDirectedFromNewCS: function isRedDirectedFromNewCS() {
            return isnewCs;
        }
    };
});
coreModule.service('facultyEvalService', function () {
    var dataSet = '',
        criterias = '',
        eval_type = '';
    return {
        setSelectedCriterias: function setSelectedCriterias(criteriasParams) {
            criterias = criteriasParams;
        },
        getSelectedCriterias: function getSelectedCriterias() {
            return criterias;
        },
        setEvalCriteria: function setEvalCriteria(eval_typeData) {
            eval_type = eval_typeData;
        },
        getEvalCriteria: function getEvalCriteria() {
            return eval_type;
        }
    };
});
coreModule.service('uploadService', ['Upload', function (Upload) {
    this.uploadCheckService = function (file, serverUrl, baseUrl, sendUrl) {
        var extraInfo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

        this.sucVal = 0;
        Upload.upload({
            url: serverUrl,
            data: {
                file: file,
                "userPath": baseUrl
            }
        }).then(function (resp) {
            var userPathUrl = {};
            userPathUrl.url = resp.data;
            sendUrl(userPathUrl);
            if (!extraInfo || !extraInfo.no_toast) {
                toastr.success("Uploaded successfully");
            }
        }, function (resp) {
            toastr.error("Server Unreachable");
        });
    };
    this.uploadToPMS = function (file, serverUrl, baseUrl, sendUrl) {
        this.sucVal = 0;
        Upload.upload({
            url: serverUrl,
            data: {
                file: file,
                "userPath": baseUrl
            }
        }).then(function (resp) {
            var userPathUrl = {};
            userPathUrl.url = resp.data;
            sendUrl(userPathUrl);
            toastr.success("Uploaded successfully");
        }, function (resp) {
            toastr.error("Server Unreachable");
        });
    };
}]);

coreModule.service("setAndSelectStudentRc", function () {
    var _this = this;

    this.students_selected = '';
    this.set_students_selected = function (json) {
        _this.students_selected = json;
    };
    this.get_students_selected = function () {
        return _this.students_selected;
    };
});

coreModule.service("navigatePeopleLookUp", function () {
    var _this2 = this;

    this.userArray = [];
    this.setUserInput = function (userDetails) {
        _this2.userArray = [];
        _this2.userArray.push(userDetails);
    };
    this.getUserDetails = function (userId) {
        var even = _.find(_this2.userArray, function (num) {
            return num.user_id == userId;
        });
        return even;
    };
});

//Service to generate random color
coreModule.service("randomColorService", function () {
    this.color = ["#d1615d", "#1a97ab", "#37caba", "#ff9f00", "#b090e3", "#47b94a", "#ff9f12", "#b09063", "#47b998"];
    this.getRandomColor = function () {
        return this.color[Math.floor(Math.random() * this.color.length)];
    };
    this.getRandomColorGraph = function () {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };
});

//To preview file from local if available in local server else from cloud
//Developer - Arul Mozhi J
coreModule.service('filePreviewAvailable', ['CONSTANTS', 'localStorageService', '$http', function (CONSTANTS, localStorageService, $http) {
    this.checkFileExists = function (serverUrl, filePath, callback) {
        try {
            var self = this;
            var cloudServerUrl = CONSTANTS.FILE_UPLOAD_URL;
            var fileUrl = serverUrl + filePath;
            $http({
                url: fileUrl,
                method: 'HEAD'
            }).then(function () {
                var response = {
                    fileAvaliable: true,
                    fileUrl: fileUrl
                };
                callback(response);
            }, function () {
                if (serverUrl === cloudServerUrl) {
                    var response = {
                        fileAvaliable: false,
                        fileUrl: null
                    };
                    callback(response);
                } else {
                    self.filePreviewUrl('cloud', filePath, function (response) {
                        callback(response);
                    });
                }
            });
        } catch (ex) {
            console.log(ex);
        }
    };
    this.filePreviewUrl = function (server, filePath, callback) {
        try {
            var self = this;
            var serverUrl = void 0;
            var cloudServerUrl = CONSTANTS.FILE_UPLOAD_URL;
            if (server === 'local') {
                var school_id = localStorageService.get('school_id');
                // Meteor.call("getLocalServerUrl", school_id, (error, result) => {
                //     if (result && result.value) {
                //         self.checkFileExists(result.value, filePath, function (response) {
                //             callback(response)
                //         })
                //     } else {
                self.checkFileExists(cloudServerUrl, filePath, function (response) {
                    callback(response);
                });
                //     }
                // })
            } else if (server === 'cloud') {
                self.checkFileExists(cloudServerUrl, filePath, function (response) {
                    callback(response);
                });
            }
        } catch (ex) {
            console.log(ex);
        }
    };
}]);
coreModule.service("prevReportService", ['localStorageService', function (localStorageService) {
    var criterias = '';
    this.clearRedirectJson = function () {
        localStorageService.remove('prevReportJson');
    };
    this.setSelectedCriterias = function (criteriasParams) {
        localStorageService.set('prevReportJson', criteriasParams);
    }, this.getSelectedCriterias = function () {
        return localStorageService.get('prevReportJson');
    };
}]);
//To set details for archives to load
//Developer - Arul Mozhi J
coreModule.service("archiveService", ['localStorageService', function (localStorageService) {
    this.getRedirectJson = function () {
        return localStorageService.get('redirectJson');
    };
    this.setRedirectJson = function (details) {
        localStorageService.set('redirectJson', details);
    };
    this.clearRedirectJson = function () {
        localStorageService.remove('redirectJson');
    };
}]);

coreModule.service('UserPrivilages', ['localStorageService', function (localStorageService) {
    var _this3 = this;

    this.modules = '';
    this.features = '';
    this.getAllModules = function () {
        return _this3.modules;
    };
    this.getFeatures = function (module) {
        var features = _.filter(_this3.features, function (feature) {
            return feature.module_state == module;
        });
        return features;
    };
    this.getAllFeatures = function () {
        return _this3.features;
    };
    this.getUserPrivilageInitialSetting = function (callbackResult) {
        var self = this;
        var roleList = localStorageService.get("multiRoles");
        self.modules = localStorageService.get("module_privileges");
        var feature_privileges = localStorageService.get("feature_privileges");
        var featureList = [];
        if (roleList.length > 0) {
            _.each(roleList, function (role) {
                var result = _.filter(feature_privileges, function (obj) {
                    return obj.role_id === role;
                });
                _.each(result, function (res) {
                    featureList.push(res);
                });
            });
        } else {
            featureList = feature_privileges;
        }
        var finalFeatureList = [];
        var groupedFeature = _.groupBy(featureList, function (value) {
            return value.feature_id + '#' + value.module_state;
        });
        _.each(groupedFeature, function (value) {
            var privilegeList = [];
            _.each(value, function (each) {
                _.each(each.privilege, function (priv) {
                    privilegeList.push(priv);
                });
            });

            var groupedPrivileges = _.groupBy(privilegeList, 'type');
            var finalPrivilege = [];
            _.each(groupedPrivileges, function (privValue, index) {
                var privObj = _.find(privValue, function (stat) {
                    return stat.status == true;
                });
                if (privObj) {} else {
                    var privObj = privValue[0];
                }
                finalPrivilege.push(privObj);
            });
            var featureObj = value[0];
            finalFeatureList.push(featureObj);
            featureObj.privilege = finalPrivilege;
        });
        self.features = finalFeatureList;
        callbackResult({
            module_privileges: self.modules,
            feature_privileges: self.features
        });
    };
}]);

coreModule.service("PDFViewerService", ['$rootScope', function ($rootScope) {
    var svc = {};
    var scale;
    var pageNumber;
    var totlaPages, userNotes;
    svc.minPage = function () {
        $rootScope.$broadcast('pdfviewer.minPage');
    };

    svc.nextPage = function () {
        $rootScope.$broadcast('pdfviewer.nextPDFPage');
    };

    svc.prevPage = function () {
        $rootScope.$broadcast('pdfviewer.prevPDFPage');
    };

    svc.fitPage = function () {
        $rootScope.$broadcast('pdfviewer.setFitPDFPage');
    };

    svc.getScale = function () {
        $rootScope.$broadcast('pdfviewer.getScale');
        return this.scale;
    };

    svc.getPageNumber = function () {
        $rootScope.$broadcast('pdfviewer.getPageNumber');
        return this.pageNumber;
    };
    svc.getTotalPageNumber = function () {
        $rootScope.$broadcast('pdfviewer.getTotalPageNumber');
        return this.totlaPages;
    };

    svc.setPageNumber = function (pageNum) {
        this.pageNumber = pageNum;
    };
    svc.setTotalPageNumber = function (totalPageNum) {
        this.totlaPages = totalPageNum;
    };
    svc.setScale = function (scale) {
        this.scale = scale;
    };
    svc.setUserNotes = function (note) {
        this.userNotes = note;
    };
    svc.getUserNotes = function () {
        return this.userNotes;
    };
    svc.Instance = function (id) {
        var instance_id = id;

        return {
            prevPage: function prevPage() {
                $rootScope.$broadcast('pdfviewer.prevPage', instance_id);
            },
            nextPage: function nextPage() {
                $rootScope.$broadcast('pdfviewer.nextPage', instance_id);
            },
            gotoPage: function gotoPage(page) {
                $rootScope.$broadcast('pdfviewer.gotoPage', instance_id, page);
            },
            zoomIn: function zoomIn() {
                $rootScope.$broadcast('pdfviewer.zoomIn', instance_id);
            },
            zoomOut: function zoomOut() {
                $rootScope.$broadcast('pdfviewer.zoomOut', instance_id);
            },
            fitPage: function fitPage() {
                $rootScope.$broadcast('pdfviewer.setFitPage', instance_id);
            }
        };
    };

    return svc;
}]);

/* --------------- Services ends --------------- */

/* --------------- Factories starts --------------- */

coreModule.factory('AppInterceptor', ['$q', '$location', function ($q, $location) {
    return {
        'responseError': function responseError(rejection) {
            var defer = $q.defer();
            if (rejection.status == 401) {
                $location.path('/login');
            }
            defer.reject(rejection);
            return defer.promise;
        }
    };
}]);

/* @Author: Sree Swathy S  @Date: 2018-05-16  @Desc: Function for checking school logo */
coreModule.factory('SchoolLogo', ["CONSTANTS", function (CONSTANTS) {
    var checkLogofactory = {};
    checkLogofactory.checkLogo = function (image_url) {
        try {
            var http = new XMLHttpRequest();
            http.open('HEAD', image_url, false);
            http.send();
            if (http.status == 200) {
                return image_url;
            } else {
                return CONSTANTS.DEFAULT_SCHOOL_LOGO;
            }
        } catch (ex) {
            return CONSTANTS.DEFAULT_SCHOOL_LOGO;
        }
    };
    return checkLogofactory;
}]);
/* End */
coreModule.factory('ProfileImage', ["CONSTANTS", function (CONSTANTS) {
    var checkLogofactory = {};
    checkLogofactory.checkLogo = function (image_url) {
        try {
            var http = new XMLHttpRequest();
            http.open('HEAD', image_url, false);
            http.send();
            if (http.status == 200) {
                return image_url;
            } else {
                return CONSTANTS.DEFAULT_PROFILE_IMAGE;
            }
        } catch (ex) {
            return CONSTANTS.DEFAULT_PROFILE_IMAGE;
        }
    };
    return checkLogofactory;
}]);

/** @Author: Naveen Nazimudeen N  @Date: 2018-02-07 19:30:02  @Desc:Function for error validation factory  */
coreModule.factory('errorValidatorUtil', function () {
    var errorValidatorUtil = {};
    errorValidatorUtil.assignErrorValue = assignErrorValue;
    return errorValidatorUtil;
});
/* End */

//Factory for auth settings - Arul Mozhi J
coreModule.factory('menuHeaderService', ["localStorageService", "$rootScope", function (localStorageService, $rootScope) {
    return {
        authMenu: this.authMenu,
        setAuthMenu: function setAuthMenu() {
            this.authMenu = true;
        },
        setDefault: function setDefault() {
            console.log(localStorageService.get("authoringData"));
            if (localStorageService.get("authoringData")) {
                this.authMenu = true;
                $rootScope.authMenu = true;
            } else {
                this.authMenu = false;
                $rootScope.authMenu = false;
            }
        },
        destroySession: function destroySession() {
            localStorageService.keys().forEach(function (key) {
                console.log(key);
                var notClearSessions = ['is_login', 'activeAcdYear', 'academic_year', 'current_Page', 'feature_privileges', 'full_name', 'module_privileges', 'role_ids', 'school_id', 'user_id', 'user_image', 'username', 'login_timestamp'];
                if (_.contains(notClearSessions, key)) {} else {
                    localStorageService.remove(key);
                }
            });
        },
        exitFromAuthoring: function exitFromAuthoring() {
            this.destroySession();
            this.setDefault();
        }
    };
}]);

coreModule.factory('AnnouncementUsers', function () {
    var usersIds = {};
    return {
        addAnnouncement: function addAnnouncement(data, stdids) {
            this.usersIds = data;
            this.studentsIds = stdids;
        },
        getAnnouncement: function getAnnouncement() {
            return usersIds;
        }
    };
});

coreModule.factory('matomoEventTrack', function () {
    return {
        pushEvent: function pushEvent(category, action, name, value) {
            try {
                _paq.push(['trackEvent', category, action, name, value]);
            } catch (e) {
                console.log(e);
            }
        }
    };
});

/* --------------- Factories ends --------------- */

/* --------------- Directives starts --------------- */
coreModule.directive('stopccp', function () {
    return {
        scope: {},
        link: function link(scope, element) {
            element.on('cut copy paste', function (event) {
                event.preventDefault();
                toastr.error("Sorry, This operation is not permitted");
            });
        }
    };
});
coreModule.directive('numbersOnly', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

coreModule.directive('repeatDone', function () {
    return function (scope, element, attrs) {
        if (scope.$last) {
            // all are rendered
            scope.$eval(attrs.repeatDone);
        }
    };
});

coreModule.directive('decimalNumbersOnly', function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text) {
                    var transformedInput = text.replace(/[^0-9.]/g, '');

                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                }
                return undefined;
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
});

coreModule.directive("errorMsg", function () {
    var directive = {};
    directive.restrict = "E";
    directive.template = '<i class="md-accent">{{msg}}</i>';
    directive.scope = {
        msg: "=msg"
    };
    return directive;
});

coreModule.directive('onError', function () {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            element.on('error', function () {
                element.attr('src', attr.onError);
            });
        }
    };
});

coreModule.directive('hcChart', function () {
    return {
        restrict: 'E',
        template: '<div></div>',
        scope: {
            options: '='
        },
        link: function link(scope, element) {
            Highcharts.chart(element[0], scope.options);
        }
    };
});

coreModule.directive("multiScroll", function () {
    return {
        restrict: 'AE',
        scope: {
            loading: "@",
            whenScrolled: '&whenscroll'
        },
        link: function link(scope, elem, attrs) {
            elem.bind("scroll", function () {
                var raw = elem[0];
                if (raw.scrollTop + raw.clientHeight >= raw.scrollHeight) {
                    scope.whenScrolled();
                }
            });
        }
    };
});

coreModule.filter('hhmmss', function () {
    return function (time) {
        var sec_num = parseInt(time, 10); // don't forget the second param
        var hours = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - hours * 3600) / 60);
        var seconds = sec_num - hours * 3600 - minutes * 60;

        if (hours < 10) {
            hours = "0" + hours;
        }
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        if (seconds < 10) {
            seconds = "0" + seconds;
        }
        var time = hours + ':' + minutes + ':' + seconds;
        return time;
    };
});

coreModule.directive('userAvatar', function () {
    return {
        link: function link(scope, element, attrs) {

            var placeholder = '../../img/icons/ic_person_black.svg';
            //var placeholder = '../../img/images/profile-pic.png';

            scope.$watch(function () {
                return attrs.ngSrc;
            }, function (value) {
                if (!value) {
                    element.attr('src', placeholder);
                }
            });

            element.bind('error', function () {
                element.attr('src', placeholder);
            });
        }
    };
});

coreModule.directive('starRating', function () {
    return {
        restrict: 'A',
        template: '<ul class="rating">' + '<li ng-repeat="star in stars" ng-class="star">' + '\u2605' + '</li>' + '</ul>',
        scope: {
            ratingValue: '=',
            max: '='
        },
        link: function link(scope, elem, attrs) {
            scope.stars = [];
            for (var i = 0; i < scope.max; i++) {
                scope.stars.push({
                    filled: i < scope.ratingValue
                });
            }
        }
    };
});

coreModule.directive('pdfviewer', ['$parse', function ($parse, PDFViewerService, $location, $state) {
    var canvas = null;
    var instance_id = null;

    return {
        restrict: "E",
        template: '<canvas style="height:100%;width:100%" ></canvas>',
        scope: {
            onPageLoad: '&',
            loadProgress: '&',
            src: '@',
            id: '='
        },

        controllerAs: "pdfUrlCtrller",
        controller: ['$scope', 'PDFViewerService', '$state', '$mdToast', function ($scope, PDFViewerService, $state, $mdToast) {
            $scope.pageNum = 1;
            $scope.pdfDoc = null;
            $scope.scale = 1.0;
            $scope.pageFit = true;
            var BASE64_MARKER = ';base64,';

            function convertDataURIToBinary(dataURI) {
                var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                var base64 = dataURI.substring(base64Index);
                var raw = window.atob(base64);
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));

                for (var i = 0; i < rawLength; i++) {
                    array[i] = raw.charCodeAt(i);
                }
                return array;
            }

            function convertDataURIToBinaryLocal(dataURI) {
                // var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
                // var base64 = dataURI.substring(base64Index);
                // var raw = window.atob(base64); 
                var raw = dataURI;
                var rawLength = raw.length;
                var array = new Uint8Array(new ArrayBuffer(rawLength));
                for (var i = 0; i < rawLength; i++) {
                    array[i] = raw.charCodeAt(i);
                }
                return array;
            }

            $scope.documentProgress = function (progressData) {
                if ($scope.loadProgress) {
                    $scope.loadProgress({
                        state: "loading",
                        loaded: progressData.loaded,
                        total: progressData.total
                    });
                }
            };
            $scope.loadPDF = function (path, initPage) {

                pdfjsLib.getDocument(path).then(function (_pdfDoc) {
                    $scope.$parent.showLoadingFirst = false;

                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage;
                    }
                    $scope.renderPage($scope.pageNum, function (success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function (message, exception) {
                    if (message.status === 0) {
                        toastr.error($mdToast, "Unable to connect the file server, please contact your system admin", 'error-toast');
                        //$state.go("additionalResourcesTile"); // commented by jishnu since its not yet defined in the project
                        return;
                    }
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: message,
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };
            $scope.loadPDFData = function (data, initPage) {
                var pdfAsDataUri = "data:application/pdf;base64," + data; // shortened
                var pdfAsArray = convertDataURIToBinary(pdfAsDataUri);
                //PDFJS.getDocument(pdfAsArray)
                pdfjsLib.getDocument(pdfAsArray, null, null, $scope.documentProgress).then(function (_pdfDoc) {
                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage;
                    }
                    $scope.renderPage($scope.pageNum, function (success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function (message, exception) {
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: "error",
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };
            $scope.loadPDFDatalocal = function (data, initPage) {
                // let pdfAsDataUri = "data:application/pdf;base64," + data; // shortened
                // 
                var pdfAsArray = convertDataURIToBinaryLocal(data);
                //PDFJS.getDocument(pdfAsArray)
                pdfjsLib.getDocument(pdfAsArray, null, null, $scope.documentProgress).then(function (_pdfDoc) {
                    $scope.$parent.showLoadingFirst = false;
                    $scope.pdfDoc = _pdfDoc;
                    if (initPage) {
                        $scope.pageNum = initPage;
                    }
                    $scope.renderPage($scope.pageNum, function (success) {
                        if ($scope.loadProgress) {
                            $scope.loadProgress({
                                state: "finished",
                                loaded: 0,
                                total: 0
                            });
                        }
                    });
                }, function (message, exception) {
                    if ($scope.loadProgress) {
                        $scope.loadProgress({
                            state: "error",
                            loaded: 0,
                            total: 0
                        });
                    }
                });
            };

            $scope.backingScale = function () {
                var ctx = canvas.getContext('2d');
                var dpr = window.devicePixelRatio || 1;
                var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

                return dpr / bsr;
            };
            $scope.renderPage = function (num, callback) {
                if ($scope.$parent.pageEnd < num) {
                    return false;
                }
                if ($scope.$parent.pageStart > num) {

                    return false;
                }

                // sendTinCanApiStatement($scope.$parent, num)
                $scope.pdfDoc.getPage(num).then(function (page) {
                    var viewport, pageWidthScale;
                    if ($scope.pageFit) {
                        viewport = page.getViewport(1);
                        var clientRect = canvas.getBoundingClientRect();
                        pageWidthScale = clientRect.width / viewport.width;
                        $scope.scale = pageWidthScale;
                    }

                    viewport = page.getViewport($scope.scale);
                    var ctx = canvas.getContext('2d');
                    var ratio = $scope.backingScale();
                    //canvas.height = viewport.height;
                    //canvas.width = viewport.width;
                    var w = viewport.width;
                    var h = viewport.height;
                    canvas.width = Math.floor(w * ratio);
                    canvas.height = Math.floor(h * ratio);
                    canvas.style.width = Math.floor(w) + 'px';
                    canvas.style.height = Math.floor(h) + 'px';

                    canvas.getContext('2d').setTransform(ratio, 0, 0, ratio, 0, 0);

                    page.render({
                        canvasContext: ctx,
                        viewport: viewport
                    }).promise.then(function () {
                        if (callback) {
                            callback(true);
                        }
                        $scope.$apply(function () {
                            $scope.onPageLoad({
                                page: $scope.pageNum,
                                total: $scope.pdfDoc._pdfInfo.numPages
                            });
                        });
                    }, function () {
                        if (callback) {
                            callback(false);
                        }
                    });
                });
            };

            $scope.count = 0;

            function timer() {
                $scope.count = $scope.count + 1;
            }

            $scope.$on('pdfviewer.nextPage', function (evt, id) {
                if (id !== instance_id) {
                    return;
                }
                if ($scope.$parent.pageEnd < $scope.pageNum + 1) {
                    return false;
                }
                if ($scope.pageNum < $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum++;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.prevPage', function (evt, id) {
                if (id !== instance_id) {
                    return;
                }
                if ($scope.$parent.pageStart > $scope.pageNum - 1) {
                    return false;
                }
                if ($scope.pageNum > 1) {
                    $scope.pageNum--;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.nextPDFPage', function (evt, id) {
                /*if (id !== instance_id) {
                    return;
                }*/
                if ($scope.$parent.pageEnd < $scope.pageNum + 1) {
                    return false;
                }
                if ($scope.pageNum < $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum++;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.prevPDFPage', function (evt, id) {
                /*if (id !== instance_id) {
                    return;
                }*/
                if ($scope.$parent.pageStart > $scope.pageNum - 1) {
                    return false;
                }
                if ($scope.pageNum > 1) {
                    $scope.pageNum--;
                    $scope.renderPage($scope.pageNum);
                }
            });
            $scope.$on('pdfviewer.gotoPage', function (evt, id, page) {
                if (id !== instance_id) {
                    return;
                }
                if (page >= 1 && page <= $scope.pdfDoc._pdfInfo.numPages) {
                    $scope.pageNum = page;
                    $scope.renderPage($scope.pageNum);
                }
                /*if (page >= 1 && page <= 5 - 1) {
                    $scope.pageNum = page;
                    $scope.renderPage($scope.pageNum);
                }*/
            });
            $scope.$on('pdfviewer.zoomIn', function (evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = false;
                $scope.scale = parseFloat($scope.scale) + 0.2;
                $scope.renderPage($scope.pageNum);
            });
            $scope.$on('pdfviewer.setFitPage', function (evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = true;
                $scope.scale = 1.0;
                $scope.renderPage($scope.pageNum);
            });

            $scope.$on('pdfviewer.setFitPDFPage', function (evt) {
                /*if (id !== instance_id) {
                    return;
                }*/
                $scope.pageFit = true;
                $scope.scale = 1.0;
                $scope.renderPage($scope.pageNum);
            });

            $scope.$on('pdfviewer.zoomOut', function (evt, id) {
                if (id !== instance_id) {
                    return;
                }
                $scope.pageFit = false;
                $scope.scale = parseFloat($scope.scale) - 0.2;
                $scope.renderPage($scope.pageNum);
            });
            $scope.$on('pdfviewer.getScale', function (evt) {

                PDFViewerService.setScale($scope.scale);
            });
            $scope.$on('pdfviewer.getPageNumber', function (evt) {

                PDFViewerService.setPageNumber($scope.pageNum);
            });
            $scope.$on('pdfviewer.getTotalPageNumber', function (evt) {

                PDFViewerService.setTotalPageNumber($scope.pdfDoc.numPages);
            });
        }],
        link: function link(scope, iElement, iAttr) {
            canvas = iElement.find('canvas')[0];
            instance_id = iAttr.id;
            iAttr.$observe('src', function (v, p) {
                if (v !== undefined && v !== null && v !== '') {
                    scope.pageNum = 1;
                    if (scope.src.length > 200) {
                        if (scope.$parent.additionalResourcesPdfLoad) {
                            scope.loadPDFDatalocal(scope.src, scope.$parent.pageStart);
                        } else {
                            scope.loadPDFData(scope.src, scope.$parent.pageStart);
                        }
                    } else {
                        scope.loadPDF(scope.src, scope.$parent.pageStart);
                    }
                    //scope.loadPDF(scope.src, scope.$parent.pageStart);/uploads/pdfsingle/file-1469271850767.pdf
                }
            });
        }
    };
}]);

coreModule.directive('ngEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if (event.which === 13) {
                scope.$apply(function () {
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
});

/* --------------- Directives ends --------------- */

/** @Author: Naveen Nazimudeen N  @Date: 2018-02-07 19:28:47  @Desc: Function for error validation factory  */
function assignErrorValue(obj, keyPath, value) {
    var lastKeyIndex = keyPath.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
        var key = keyPath[i];
        if (!(key in obj)) obj[key] = {};
        obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
}

exports.default = coreModule;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


routerHelper.$inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider"];
Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = routerHelper;

var _appRoutes = __webpack_require__(801);

var _appRoutes2 = _interopRequireDefault(_appRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function routerHelper($stateProvider, $urlRouterProvider, $locationProvider) {
	'ngInject';

	$locationProvider.html5Mode(true); // setting html5 mode to remove !# from url
	$urlRouterProvider.otherwise('/'); // setting default route

	_appRoutes2.default.forEach(function (route) {
		$stateProvider.state(route);
	});
}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
var publishedMainUrl = '/view-report/:student_id/:console_id/:type/:template_view/:asset_format/:selected_year/:kb_consolidated/:kg_consolidated/:montessori_consolidated/:for_ct';
exports.default = [{
   name: 'login',
   url: '/',
   component: 'login'
}, {
   name: 'home',
   url: '/home',
   component: 'home'
}, {
   name: 'user',
   url: '/user',
   component: 'user'
}, {
   name: 'navigation',
   url: '/navigation',
   component: 'navigation'
}, {
   name: 'teacherView',
   url: '/teacherView',
   component: 'teacherView'
}, {
   name: 'commonChart',
   url: '/commonChart',
   component: 'commonChart'
}, {
   name: 'ssbdForm',
   url: '/ssbdForm',
   component: 'ssbdForm'
}, {
   name: 'pbslpForm',
   url: '/pbslpForm',
   component: 'pbslpForm'
}, {
   name: 'switForm',
   url: '/switForm',
   component: 'switForm'
}, {
   name: 'parentConsentForm',
   url: '/parentConsentForm',
   component: 'parentConsentForm'
}, {
   name: 'senRefferalForm',
   url: '/senRefferalForm',
   component: 'senRefferalForm'
}, {
   name: 'sendAccomodation',
   url: '/sendAccomodation',
   component: 'sendAccomodation'
}, {
   name: 'historyIep',
   url: '/historyIep',
   component: 'historyIep'
}, {
   name: 'historyIlp',
   url: '/historyIlp',
   component: 'historyIlp'
}, {
   name: 'iepParentComment',
   url: '/iepParentComment',
   component: 'iepParentComment'
}, {
   name: 'sendBuddy',
   url: '/sendBuddy',
   component: 'sendBuddy'
}, {
   name: 'icesKgForm',
   url: '/icesKgForm',
   component: 'icesKgForm'
}, {
   name: 'icesFirstgrade',
   url: '/icesFirstgrade',
   component: 'icesFirstgrade'
}, {
   name: 'icesTwosix',
   url: '/icesTwosix',
   component: 'icesTwosix'
}, {
   name: 'icesAboveSix',
   url: '/icesAboveSix',
   component: 'icesAboveSix'
}, {
   name: 'icesParentConsentForm',
   url: '/icesParentConsentForm',
   component: 'icesParentConsentForm'
   /* {
       name: 'commonFilter',
       url: '/commonFilter',
       component: 'commonFilter'
   } */

}, {
   name: 'viewGeneratedReportData',
   url: '/view-genareted-report/:dataId/:selected_year/:is_edit',
   component: 'viewGeneratedReportData'
}, {
   name: 'typeFourMarkComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeFourMarkComponent'
}, {
   name: 'typeFourAnnualComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeFourAnnualComponent'
}, {
   name: 'typeOneMarkComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeOneMarkComponent'
}, {
   name: 'typeTwoMarkComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeTwoMarkComponent'
}, {
   name: 'typeThreeSubSkillComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeThreeSubSkillComponent'
}, {
   name: 'typeSkillOnlyComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeSkillOnlyComponent'
}, {
   name: 'typeOneGradeComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'typeOneGradeComponent'
}, {
   name: 'periodicTestDefaultHfComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'periodicTestDefaultHfComponent'
}, {
   name: 'periodicTestDefaultAnnualComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'periodicTestDefaultAnnualComponent'
}, {
   name: 'periodicTestDefaultHfTwoComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'periodicTestDefaultHfTwoComponent'
}, {
   name: 'periodicTestDefaultAnnualTwoComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'periodicTestDefaultAnnualTwoComponent'
}, {
   name: 'hssTemplateComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'hssTemplateComponent'
}, {
   name: 'cbsehssComponent',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'cbsehssComponent'
}, {
   name: 'termonehalfyearlyComp',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'termonehalfyearlyComp'
}, {
   name: 'kbhfhssComp',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'kbhfhssComp'
}, {
   name: 'gradeNineComp',
   url: '/view-genareted-report/:dataId/:selected_year',
   component: 'gradeNineComp'
}, {
   name: 'reportsMain',
   url: publishedMainUrl,
   component: 'reportsMainComponent'
}, {
   name: 'typeOneHfComponent',
   url: publishedMainUrl,
   component: 'typeOneHfComponent'
}, {
   name: 'periodicTestDefaultHfPublished',
   url: publishedMainUrl,
   component: 'periodicTestDefaultHfPublished'
}, {
   name: 'periodicTestDefaultAnnualPublished',
   url: publishedMainUrl,
   component: 'periodicTestDefaultAnnualPublished'
}, {
   name: 'defaultYearEnd',
   url: publishedMainUrl,
   component: 'defaultYearEnd'
}, {
   name: 'termConsolidated',
   url: publishedMainUrl,
   component: 'termConsolidated'
}, {
   name: 'educoreYearEnd',
   url: publishedMainUrl,
   component: 'educoreYearEnd'
}, {
   name: 'skilSubSkill',
   url: publishedMainUrl,
   component: 'skilSubSkill'
}, {
   name: 'assetHfComponent',
   url: publishedMainUrl,
   component: 'assetHfComponent'
}, {
   name: 'assetAnnualComponent',
   url: publishedMainUrl,
   component: 'assetAnnualComponent'
}, {
   name: 'kgTerms',
   url: publishedMainUrl,
   component: 'kgTerms'
}, {
   name: 'periodicTestDefaultHfTwoPublished',
   url: publishedMainUrl,
   component: 'periodicTestDefaultHfTwoPublished'
}, {
   name: 'periodicTestDefaultAnnualTwoPublished',
   url: publishedMainUrl,
   component: 'periodicTestDefaultAnnualTwoPublished'
}, {
   name: 'kgConsolidated',
   url: publishedMainUrl,
   component: 'kgConsolidated'
}, {
   name: 'kbTerms',
   url: publishedMainUrl,
   component: 'kbTerms'
}, {
   name: 'hssComponent',
   url: publishedMainUrl,
   component: 'hssComponent'
}, {
   name: 'cbseHssPublishedComponent',
   url: publishedMainUrl,
   component: 'cbseHssPublishedComponent'
}, {
   name: 'specificHf',
   url: publishedMainUrl,
   component: 'specificHf'
}, {
   name: 'kbhfhsspublishedComp',
   url: publishedMainUrl,
   component: 'kbhfhsspublishedComp'
}, {
   name: 'cbseSpecificSubjectsFinalComp',
   url: publishedMainUrl,
   component: 'cbseSpecificSubjectsFinalComp'
}, {
   name: 'userConsole',
   url: '/userConsole',
   component: 'userConsole'
}, {
   name: 'csvUploadCtrl',
   url: '/userConsole',
   component: 'csvUploadCtrl'
}, {
   name: 'academicConsole',
   url: '/academicConsole',
   component: 'academicConsole'
}, {
   name: 'addSubject',
   url: '/userConsole',
   component: 'addSubject'
}];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserService = function () {
    UserService.$inject = ["$http", "CONSTANTS", "$state"];
    function UserService($http, CONSTANTS, $state) {
        'ngInject';

        var _this = this;

        _classCallCheck(this, UserService);

        this.get = function () {
            return _this.$http.get('https://jsonplaceholder.typicode.com/users').then(function (response) {
                return response.data;
            });
        };

        this.$http = $http;
        this.CONSTANTS = CONSTANTS;
        this.state = $state;
    }

    _createClass(UserService, [{
        key: 'callAPI',


        /*  callAPI = (endpoint, method, args, callback) => {
             var url = this.CONSTANTS.NODE_URL + endpoint;
               this.$http.defaults.headers.post["Content-Type"] = "application/json";
             this.$http.defaults.headers.post["x-auth-token"] = "tq355lY3MJyd8Uj2ySzm"
             this.$http.defaults.headers.post["x-auth-userid"] = "44B7TvzRTZkpdxs9u"
              return this.$http({
                     url: url,
                     method: "POST",
                     data: JSON.stringify(args)
                  })
                 .then(function(response) {
                         return response;
                     },
                     function(response) { // optional
                         return response;
                     });
         } */

        value: function callAPI(endpoint, method, args, callback) {
            try {
                var url = this.CONSTANTS.NODE_URL + endpoint;
                //var url = endpoint;
                console.log(url);
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        try {
                            resultObj.result = JSON.parse(xhttp.responseText);
                            callback(resultObj);
                        } catch (error) {
                            resultObj.error = "Bad Request - End Point is invalid";
                            callback(resultObj);
                        }
                    } else {
                        if (this.readyState == 4) {
                            var _resultObj = {
                                "result": undefined,
                                "error": undefined
                            };
                            _resultObj.error = JSON.parse(xhttp.responseText);
                            callback(_resultObj);
                        }
                    }
                };
                xhttp.open(method, url, true);
                xhttp.setRequestHeader("Content-type", "application/json");
                xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
                xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
                xhttp.onerror = function (e) {
                    var resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    resultObj.error = "Bad Request - Server is Down";
                    callback(resultObj);
                };
                if (args != undefined) {
                    xhttp.send(JSON.stringify(args));
                } else {
                    xhttp.send();
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }, {
        key: 'callRabbitMQAPI',
        value: function callRabbitMQAPI(endpoint, method, args, callback) {
            try {
                console.log("rabbitMq log Push.....");
                var url = this.CONSTANTS.NODE_URL + endpoint;
                //var url = endpoint;
                console.log(url);
                var xhttp = new XMLHttpRequest();
                // xhttp.onreadystatechange = function() {
                //    // callBack
                // };
                xhttp.open(method, url, true);
                xhttp.setRequestHeader("Content-type", "application/json");
                xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
                xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
                // xhttp.onerror = function(e) {
                //     let resultObj = {
                //         "result": undefined,
                //         "error": undefined
                //     };
                //     resultObj.error = "Bad Request - Server is Down";
                //     callback(resultObj);
                // };
                if (args != undefined) {
                    xhttp.send(JSON.stringify(args));
                } else {
                    xhttp.send();
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }, {
        key: 'downloadAPI',
        value: function downloadAPI(endpoint, method, args, callback) {
            try {
                var url = this.CONSTANTS.NODE_URL + endpoint;
                var xhttp = new XMLHttpRequest();

                xhttp.onload = function () {
                    var resultObj = {
                        "result": undefined,
                        "error": undefined
                    };

                    if (this.status >= 200 && this.status < 300) {
                        var disposition = xhttp.getResponseHeader("content-disposition");
                        var fileName = "download";
                        var matchedFileName = disposition && disposition.match(/filename="?([^"]+)"?/);

                        if (matchedFileName && matchedFileName[1]) {
                            fileName = matchedFileName[1];
                        }

                        resultObj.result = {
                            data: xhttp.response,
                            fileName: fileName
                        };
                    } else {
                        resultObj.error = {
                            status: this.status,
                            message: "Unable to download file"
                        };
                    }

                    callback(resultObj);
                };

                xhttp.onerror = function () {
                    callback({
                        "result": undefined,
                        "error": {
                            message: "Bad Request - Server is Down"
                        }
                    });
                };

                xhttp.open(method, url, true);
                xhttp.responseType = "blob";
                xhttp.setRequestHeader("Content-type", "application/json");
                xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
                xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");

                if (args != undefined) {
                    xhttp.send(JSON.stringify(args));
                } else {
                    xhttp.send();
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }]);

    return UserService;
}();

exports.default = UserService;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('app.ConstantModule', [_angularUiRouter2.default
//import modules
]);

_module.constant("CONSTANTS", {
    // NODE_URL: "https://staging-nims-bml3000.globtech.in",
    // NODE_URL: "http://localhost:3000",
    NODE_URL: "https://sqa-bml3000.globtech.in",
    FILE_UPLOAD_URL: "https://teamsqa4000.globtech.in",
    // FILE_UPLOAD_URL: "https://nims4000.benchmark.school",
    LRS_URL: "https://teamsqa3000.globtech.in",
    NODE_SOCKET_URL: "https://teamsqa3002.globtech.in",
    ARCHIVE_PAGE_SIZE: 100,
    ADMIN_ID: "super_admin",
    DEFAULT_SCHOOL_LOGO: "../../../src/img/school_dummy_logo.png",
    DEFAULT_PROFILE_IMAGE: "../../../src/img/dashboard/profile-pic.png",
    PMS_URL: "https://qcpms.globtech.in",
    SITE_URL: "https://teamsqa.globtech.in/",
    BUILD_VERSION: "4.0",
    SERVER_UPLOAD: "https://teamsqa4000.globtech.in/server-uploads",
    OXFORDTVM_CLIENTID: "688819777685-e5sdb510r6t05tmp1go46fjdbcvfjkov.apps.googleusercontent.com",
    OXFORDQLN_CLIENTID: "1070065984397-9n9os7dkj2c11fk22ljd68d8tmhmj7n0.apps.googleusercontent.com",
    OXFORDCLT_CLIENTID: "",
    NIMSDXB_CLIENTID: "47340146053-tjddjdu5ek23de49ki6euh0c367i7j95.apps.googleusercontent.com",
    NIMSSHJ_CLIENTID: "1070065984397-9n9os7dkj2c11fk22ljd68d8tmhmj7n0.apps.googleusercontent.com",
    NIMSALAIN_CLIENTID: "",
    TCS_CLIENTID: "92525820903-3c0lpbbtn8pulc70bcp7gi0mauaajij7.apps.googleusercontent.com",
    GOOGLE_ANALYTICS_MEASUREMENT_ID: "G-8KZ3H54C0M",
    OXFORD_CLIENT_ID: "688819777685-e5sdb510r6t05tmp1go46fjdbcvfjkov.apps.googleusercontent.com",
    NIMS_CLIENT_ID: "47340146053-tjddjdu5ek23de49ki6euh0c367i7j95.apps.googleusercontent.com",
    CLOUD_URL: "https://storage.googleapis.com/nims-content", //for proctoring ,
    GC_CLIENT_ID: "808404300357-chm4nloggfj56lbq5tfe407js7m3upe7.apps.googleusercontent.com",
    BM_REPORTS_URL: "https://bmreport.globtech.in",
    CSDASHBOARD_URL: "https://bmcs.docme.online"

});

_module.constant('RESULT_ANALYSIS_CONSTANTS', {
    API_GET_SCHOOL_DETAILS: "/v0/school/details/",
    API_GET_STUDENT_RESULT: "/v0/analysis/student",
    API_GET_CONSOLIDATED_REPORT: "/v0/analysis/consolidated",
    API_GET_EXAM_CONSOLIDATED_REPORT: "/v0/analysis/exam/consolidated",
    API_SAVE_ANALYSIS_TEMPLATE: "/v0/analysis/template/save",
    API_DELETE_ANALYSIS_TEMPLATE: "/v0/analysis/template/delete",
    API_GET_SESSION_DETAILS: "/v0/analysis/filter/session",
    API_GET_CURRICULUM_DETAILS: "/v0/analysis/filter/curriculum",
    API_GET_CLASS_DETAILS: "/v0/analysis/filter/class",
    API_GET_SECTION_DETAILS: "/v0/analysis/filter/section",
    API_GET_BATCH_DETAILS: "/v0/analysis/filter/batch",
    API_GET_SUBJECT_DETAILS: "/v0/analysis/filter/subject",
    API_GET_EXAM_DETAILS: "/v0/analysis/filter/exam",
    API_GET_CONSOLIDATED_EXAM_DETAILS: "/v0/analysis/filter/consolidated/exam",
    API_GET_STUDENT_FILTER_DETAILS: "/v0/analysis/filter/all/student",
    API_GET_EXAM_FILTER_DETAILS: "/v0/analysis/filter/all/exam",
    API_GET_STUDENTS_REPORT: "/v0/analysis/report/students",
    API_GET_SUBJECT_REPORT: "/v0/analysis/report/subject",
    API_GET_EXAM_REPORT: "/v0/analysis/report/exam",
    API_GET_CLASS_REPORT: "/v0/analysis/report/class",
    API_GET_BATCH_REPORT: "/v0/analysis/report/batch",
    API_GET_SECTION_REPORT: "/v0/analysis/report/section",
    API_GET_GRADE_REPORT: "/v0/analysis/report/grade",
    API_GET_MARK_REPORT: "/v0/analysis/report/mark",
    API_GET_SECTION_GRADE_REPORT: "/v0/analysis/report/grade/section",
    API_GET_SECTION_MARK_REPORT: "/v0/analysis/report/mark/section",
    SCHOOL_DUMMY_LOGO: "../../img/school_dummy_logo.png",
    NOT_APPLICABLE: "NA",
    RESULT_ANALYSIS_EXAM_ORDER: ['Periodic Test-Half Yearly', 'Half Yearly', 'Periodic Test-Annual', 'Annual', 'Evaluation-1', 'Evaluation-2', 'Evaluation-3', 'Term 1', 'Term 2'],
    RESULT_ANALYSIS_GRADE_ORDER: ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'D', 'E1', 'A', 'B', 'C', 'ABSENT'],
    RESULT_ANALYSIS_MARK_ORDER: ['Outstanding (90 to 100)', 'Excellent (75 to 89)', 'Good (50 to 74)', 'Average (35 to 49)', 'Needs to improve (below 35)', 'ABSENT'],
    RESULT_ANALYSIS_CLASS_ORDER: ['Tiny tots', 'KG1', 'KG2', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    RESULT_ANALYSIS_BATCH_ORDER: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ'],
    RESULT_ANALYSIS_SECTION_ORDER: ['KG', '1 - 5 (Primary)', '6 - 8 (Middle)', '9 - 10 (Secondary)', '11 - 12 (Higher Secondary)'],
    RESULT_ANALYSIS_SLEEP_TIME: 1000,
    API_GET_TEACHER_CLASS: "/v0/analysis/filter/classteacherclassList"
});

_module.constant('MARK_ENTRY_SAVE_CONSTANTS', {
    KG_CLASSES: ['class123', 'class1234'],
    API_GET_TERMS: '/v0/markentry/terms',
    API_AUTO_GENERATE_KG_REPORT: '/v0/reportcards/teacher/autogenerate',
    API_REPORT_CARD_GENERATE: '/v0/reportcards/teacher/start'
});

_module.constant("ATTENDANCE_CONSTANTS", {
    API_GET_TIMETABLE_CONSOLE: "/v0/timetable/console",
    API_GET_BATCH_WISE_ATTENDANCE: "/v0/attendance/lite/batch-wise/attendance",
    API_GET_STUDENT_ATTENDANCE: "/v0/attendance/lite/batch-wise/students",
    API_GET_ATTENDANCE_CONSOLE: "/v0/attendance/console",
    API_GET_PERIODS: "/v0/attendance/periods",
    API_UPDATE_ATTENDANCE: "/v0/attendance/edit",
    API_MARK_ATTENDANCE: "/v0/attendance/mark",
    API_MARK_PREVIOUS_ATTENDANCE: "/v0/attendance/mark/previous",
    API_GET_TEACHERS: "/v0/set_availability/teacher/subjects",
    API_SAVE_ATTENDANCE_CONSOLE: "/v0/attendance/console/add",
    API_GET_SCHOOL_DETAILS: "/v0/school/details/",
    API_GET_CURRENT_DATE_TIME: "/v0/server/now",
    API_GET_STUDENT_MONTH_WISE_ATTENDANCE: "/v0/attendance/report/student/monthwise",
    API_GET_STUDENT_DATE_WISE_ATTENDANCE: "/v0/attendance/report/student/datewise",
    SCHOOL_DUMMY_LOGO: "../../../img/school_dummy_logo.png",
    API_GET_ADMIN_ATTENDANCE_FILTERS: "/v0/attendance/lite/filter/admin/",
    API_GET_TEACHER_ATTENDANCE_FILTERS: "/v0/attendance/lite/filter/teacher/",
    API_GET_MONTHLY_ATTENDANCE_DETAILS: "/v0/attendance/report/monthly",
    API_GET_YEARLY_ATTENDANCE_DETAILS: "/v0/attendance/report/yearly",
    API_GET_ATTENDANCE_DETAILS: "/v0/attendance/lite/batch-wise/attendance"
});

_module.constant('APPOINTMENT_CONSTANT', {
    GET_SERVER_DATE: "/v0/server/now",
    GET_AVAILABILITY: "/v0/set_availability/teacher/not-available",
    GET_TEACHER_AVAILABILITY: "/v0/set_availability/mine",
    ADD_APPOINTMENT: "/v0/set_availability/add",
    EDIT_APPOINTMENT: "/v0/set_availability/edit",
    DELETE_APPOINTMENT: "/v0/set_availability/delete",
    PUBLISH_APPOINTMENT: "/v0/set_availability/update",
    GET_APPOINTMENTS_FOR_PARENT: "/v0/set_availability/get/available",
    API_GET_PARENT_DETAILS: "/v0/parent/portal/person/details/",
    API_GET_PARENT_CHILD_DETAILS: "/v0/parent/portal/child/details/",
    GET_REQUESTED_APPOINTMENTS: "/v0/set_availability/get/requested",
    SEND_PARENT_REQUEST: "/v0/set_availability/parent/request",
    API_GET_TEACHERS: "/v0/set_availability/teacher/subjects",
    DELETE_WITH_REASON: "/v0/set_availability/cancel/reason",
    ACCEPT_REQUEST: "/v0/set_availability/accept",
    REJECT_REQUEST: "/v0/set_availability/reject",
    CANCELLED_APPOINTMENTS: "/v0/set_availability/get/cancelled",
    DELETE_REASSIGN: "/v0/set_availability/reassign/delete",
    REASSIGN_APPOINTMENT: "/v0/set_availability/reassign"
});

_module.constant("TIMETABLE_CONSTANTS", {
    API_GET_SUBJECTS: "/v0/set_availability/teacher/subjects",
    API_GET_TEACHER_SUBJECTS: "/v0/timetable/teacher/subjects",
    API_GET_TEACHER_TIMETABLE: "/v0/timetable/preview/teacher",
    API_GET_STUDENT_TIMETABLE: "/v0/timetable/preview/student",
    API_GET_PERSON: "/v0/endorsement/person_academics",
    API_GET_TIMETABLE_CONSOLE: "/v0/timetable/console",
    API_SAVE_TIMETABLE_CONSOLE: "/v0/timetable/console/add",
    API_GET_PREVIOUS_CONSOLE: "/v0/check_previous/timetable/attendance/appointment",
    API_GET_TEACHER_WITH_SUBJECTS: "/v0/set_availability/teacher/subjects",
    API_GET_TEACHER_AVAILABILITY: "/v0/timetable/teacher/availability",
    API_SAVE_TIMETABLE_ALLOCATION: "/v0/timetable/allocation/add",
    API_FORCE_SAVE_TIMETABLE_ALLOCATION: "/v0/timetable/allocation/force_update"
});
_module.constant("ARCHIVE_CONSTANTS", {
    API_ARCHIVE_ACADEMIC_URL: "/v0/archives/filters/academic",
    API_ARCHIVE_THEME_URL: "/v0/archives/filters/theme",
    API_ARCHIVE_RESOURCE_URL: "/v0/archives/filters/resource-metadata",
    API_ARCHIVE_DATA_URL: "/v0/archives/list",
    API_ARCHIVE_RESOURCE_PREVIEW_URL: "/v0/archives/preview/resources",
    API_ARCHIVE_PLAN_PREVIEW_URL: "/v0/archives/preview/plan",
    API_ARCHIVE_QP_TEMPLATE_PREVIEW_URL: "/v0/archives/preview/qp-template",
    API_ARCHIVE_QP_PREVIEW_URL: "/v0/archives/preview/qp",
    API_ARCHIVE_QUESTION_PREVIEW_URL: "/v0/archives/preview/question",
    API_ARCHIVE_SYLLABUS_PREVIEW_URL: "/v0/archives/preview/syllabus",
    API_MY_ARCHIVE_DATA_URL: "/v0/archives/my-list",
    API_MY_ARCHIVE_EDIT_NOTE_URL: "/v0/archives/edit-my-notes",
    API_MY_ARCHIVE_DELETE_ARCHIVE_URL: "/v0/archives/delete-my-archive",
    API_MY_ARCHIVE_DELETE_THEME_URL: "/v0/archives/delete-my-theme",
    API_SEND_APPROVAL_ARCHIVE_DATA_URL: "/v0/archives/send-approval-list",
    API_ARCHIVE_APPROVER_LIST_URL: "/v0/archives/approver-list",
    API_TO_APPROVE_ARCHIVE_DATA_URL: "/v0/archives/to-approve-list",
    API_ARCHIVE_SEND_FOR_APPROVAL_URL: "/v0/archives/send-for-approval",
    API_ARCHIVE_APPROVE_URL: "/v0/archives/apporve",
    API_ARCHIVE_PUBLISH_LIST_URL: "/v0/archives/publish-list",
    API_ARCHIVE_PUBLISH_ALL_LIST_URL: "/v0/archives/publish-all-list",
    API_ARCHIVE_PUBLISH_URL: "/v0/archives/publish",
    API_ARCHIVE_REJECTED_LIST_URL: "/v0/archives/publish-rejected-list",
    API_ARCHIVE_LINK_THEME_FILTER_URL: "/v0/archives/link-themes/filters",
    API_ARCHIVE_LINK_THEME_ALL_URL: "/v0/archives/link-themes/all-themes",
    API_ARCHIVE_LINK_THEME_DEFAULT_URL: "/v0/archives/link-themes/default-themes",
    API_ARCHIVE_LINK_THEME_SAVE_URL: "/v0/archives/link-themes/save",
    API_ARCHIVE_SYLLABUS_GET_THEMES_URL: "/v0/archives/syllabus/get-themes",
    API_ARCHIVE_SYLLABUS_SAVE_URL: "/v0/archives/syllabus/save",
    API_ARCHIVE_THEME_SAVE_URL: "/v0/archives/themes/save",
    API_ARCHIVE_RESOURCE_SAVE_URL: "/v0/archives/resource/save",
    API_ARCHIVE_CREATE_QP: "/v0/archives/question-paper/create",
    API_ARCHIVE_EDIT_QP: "/v0/archives/question-paper/edit",
    API_ARCHIVE_AUTOFORMAT_URL: "/v0/archives/question-paper/auto-format",
    API_ARCHIVE_DELETE_QUES_URL: "/v0/archives/question-paper/del-ques",
    API_ARCHIVE_SAVE_QP_URL: "/v0/archives/question-paper/save",
    API_ARCHIVE_SAVE_SECTION_QP_URL: "/v0/archives/question-paper/save-section",
    ARCHIVE_RESOURCE_TYPES: [{
        name: "Google Docs",
        _id: "googledocs"
        // }, {
        //     name: "Interactive Anime",
        //     _id: "flash"
    }, {
        name: "Khan Academy",
        _id: "khanAcademy"
    }, {
        name: "PDF",
        _id: "pdf"
    }, {
        name: "Reference Books",
        _id: "refbooks"
    }, {
        name: "Video",
        _id: "video"
    }, {
        name: "You Tube",
        _id: "utubeVideo"
    }, {
        name: "Web Links",
        _id: "weblinks"
    }],
    ARCHIVE_ALL_STATUS_LIST: [{
        name: "Approved",
        _id: "approved"
    }, {
        name: "Published",
        _id: "published"
    }],
    ARCHIVE_MY_STATUS_LIST: [{
        name: "Approved",
        _id: "approved"
    }, {
        name: "Created",
        _id: "created"
    }, {
        name: "Rejected",
        _id: "rejected"
    }, {
        name: "Pending",
        _id: "sent_for_approval"
    }, {
        name: "Published",
        _id: "published"
    }],
    ARCHIVE_QUESTION_TYPE_LIST: [{
        name: "Multiple Choice Question",
        _id: "MCQ",
        isPractice: true
    }, {
        name: "Fill in the Blanks",
        _id: "FIB",
        isPractice: true
    }, {
        name: "True or False",
        _id: "TF",
        isPractice: true
    }, {
        name: "One Word Question",
        _id: "OWQ",
        isPractice: true
    }, {
        name: "Match the Following",
        _id: "MTF",
        isPractice: true
    }, {
        name: "Short Answer",
        _id: "SA",
        isPractice: false
    }, {
        name: "Long Answer",
        _id: "LA",
        isPractice: false
    },
    /*{
        name: "Drawing",
        _id: "DRAW",
        isPractice: false
    }, {
        name: "Asl - Listening",
        _id: "ASLLISTEN",
        isPractice: false
    }, {
        name: "Asl - Speaking",
        _id: "ASLSPEAK",
        isPractice: false
    },*/
    {
        name: "Passage",
        _id: "passage",
        isPractice: false
    }],
    ARCHIVE_QUESTION_TYPE_LIST_LW: [{
        name: "Multiple Choice Question",
        _id: "MCQ",
        isPractice: true
    }, {
        name: "Short Answer",
        _id: "SA",
        isPractice: false
    }],
    ARCHIVE_EXAM_TYPES: [{
        name: 'Practice Exam',
        _id: 'Practice'
    }, {
        name: 'Assessment Exam',
        _id: 'Assesment'
    }],
    ARCHIVES_LEVELS: [1, 2, 3],
    ARCHIVE_TABS: [{
        imgActiveSrc: "../../../img/archives/syllabus-blue.png",
        imgInActiveSrc: "../../../img/archives/syllabus-white.png",
        _id: "syllabus",
        name: "Syllabus",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/theme-blue.png",
        imgInActiveSrc: "../../../img/archives/theme-white.png",
        _id: "themes",
        name: "Themes",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/resource-blue.png",
        imgInActiveSrc: "../../../img/archives/resource-white.png",
        _id: "resources",
        name: "Resources",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/tp-blue.png",
        imgInActiveSrc: "../../../img/archives/tp-white.png",
        _id: "teachingPlan",
        name: "Plans",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/note-blue.png",
        imgInActiveSrc: "../../../img/archives/note-white.png",
        _id: "notes",
        name: "Notes",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/questions-blue.png",
        imgInActiveSrc: "../../../img/archives/questions-white.png",
        _id: "question",
        name: "Questions",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/qp-blue.png",
        imgInActiveSrc: "../../../img/archives/qp-white.png",
        _id: "qp",
        name: "Question Paper",
        isActive: false,
        isVisible: false
    }, {
        imgActiveSrc: "../../../img/archives/qp-temp-blue.png",
        imgInActiveSrc: "../../../img/archives/qp-temp-white.png",
        _id: "qp_template",
        name: "Question Template",
        isActive: false,
        isVisible: false
    }],
    ARCHIVE_PASSAGE_SELECTION: [{
        _id: true,
        name: "Questions With Passage"
    }, {
        _id: false,
        name: "Questions Without Passage"
    }],
    ARCHIVE_MAPPED_TABS: [{
        _id: "syllabus",
        name: "syllabus"
    }, {
        _id: "themes",
        name: "themes"
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "teachingPlan",
        name: "planContent"
    }, {
        _id: "notes",
        name: "notesContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }, {
        _id: "qp_template",
        name: "qpTempContent"
    }],
    ARCHIVE_MAPPED_CREATE_TABS: [{
        _id: "syllabus",
        name: "syllabus"
    }, {
        _id: "themes",
        name: "themes"
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }],
    ARCHIVE_MAPPED_APPROVAL_TABS: [{
        _id: "syllabus",
        name: "syllabus"
    }, {
        _id: "resources",
        name: "resourceContent"
    }, {
        _id: "question",
        name: "questionsContent"
    }, {
        _id: "qp",
        name: "qpContent"
    }],
    ARCHIVE_MAPPED_APPROVE_TABS: [{
        _id: "syllabus",
        name: "approveSyllabus"
    }, {
        _id: "resources",
        name: "approveResourceContent"
    }, {
        _id: "question",
        name: "approveQuestionsContent"
    }, {
        _id: "qp",
        name: "approveQpContent"
    }],
    ARCHIVE_MAPPED_SCHOOL_TABS: [{
        _id: "resources",
        name: "publishResources"
    }, {
        _id: "question",
        name: "publishQuestions"
    }],
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs"
    },
    QUESTION_TYPE_DETAILS: {
        MCQ: "Multiple choice question",
        FIB: "Fill in the blanks",
        MTF: "Match the following",
        OWQ: "One word question",
        TF: "True or False",
        SA: "Short answer question",
        LA: "Long answer question",
        IBT_MCQ: "IBT - Multiple choice question",
        IBT_FIB: "IBT - Fill in the blanks",
        DRAW: "Drawing",
        ASLSPEAK: "ASL - Speaking",
        ASLLISTEN: "ASL - Listening",
        PASSAGE: "Passage"
    },
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/"
});

_module.constant('GOOGLE_CLASSROOM_CONSTANTS', {
    API_GET_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/get',
    API_ADD_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/add',
    API_GET_CLASSROOM_TOPICS: '/v0/google_classroom/classroom/topics',
    API_EXPORT_TO_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/export',
    API_IMPORT_FROM_GOOGLE_CLASSROOM: '/v0/google_classroom/classroom/import'
});
_module.constant('pulishedReportCardsConstants', {
    NO_FEESCHOOLIDS: ['2FwuqhgeoKt6SQiCG']
});
_module.constant('OPTIONAL_SCHOOLFONTS', {
    CANTERBURY_FONT_SCHOOLS: ['2ebFyzgjEwmdvep5L', 'f5BCz8T7LqzpFsSP3']
});
_module.constant('NO_SHARE_AFL_SCHOOLS', {
    SCHOOL_IDS: ['a4C45mm9XLYagBQgH']
});
_module.constant('RC_CONSTANTS_', {
    PORT_FOLIO_AS_NB_SCHOOLS: ['2ebFyzgjEwmdvep5L']
});
_module.constant('PASS_CMP_CHECK', {
    PASS_CMP_CHECK_CLASSES: ['KG1', 'KG2', '1', '2', '3']
});
_module.constant('QP_HANDLING_CONSTANTS', {
    QP_NOTVISBLE_DEFAULT_PARENT_SCHOOLS: ['CPpbKPQTcuG97i3kv']
});

/***/ }),
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//import uiRouter from 'angular-ui-router';
var _module = angular.module('app.StateModule', ['ui.router', 'oc.lazyLoad'
//import modules
]);

var stateArray = [{
    "_id": "student_details",
    "name": "Student Details"
}, {
    "_id": "teacher_details",
    "name": "Teacher Details"
}, {
    "_id": "acd_inform",
    "name": "Academics Information"
}, {
    "_id": "inclusion_dept",
    "name": "Inclusion Department"
}, {
    "_id": "staff_development",
    "name": "Staff Development"
}, {
    "_id": "sports_trip_curr_activities",
    "name": "Sports-Trip-Extra Curricular Activity"
}, {
    "_id": "parent_updates",
    "name": "Parent Updates"
}, {
    "_id": "3rd_party_vendors",
    "name": "Third Party Vendors"
}, {
    "_id": "operations",
    "name": "Operations"
}, {
    "_id": "resources_updates",
    "name": "Resources Updates"
}, {
    "_id": "it_updates",
    "name": "IT Updates"
}, {
    "_id": "happiness_dept",
    "name": "Happiness Department"
}, {
    "_id": "hs_updates",
    "name": "H&S Updates"
}, {
    "_id": "procurement_updates",
    "name": "Procurement Updates"
}, {
    "_id": "school_transport",
    "name": "School Transport"
}, {
    "_id": "compliance_&_pro",
    "name": "Compliance & Pro"
}, {
    "_id": "hr_updates",
    "name": "HR Updates"
}, {
    "_id": "governance",
    "name": "Governance"
}];
_module.config(["$stateProvider", "$urlRouterProvider", "$locationProvider", function ($stateProvider, $urlRouterProvider, $locationProvider) {
    'ngInject';
    //$locationProvider.html5Mode(true).hashPrefix('!');
    //$locationProvider.hashPrefix('');
    //$urlRouterProvider.otherwise('/login');

    $stateProvider.state('app', {
        url: '',
        abstract: true
    }).state('dashboard', {
        name: 'dashboard',
        url: '/dashboard',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(57).then((function () {
                        var template = __webpack_require__(463);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'DashBoardController',
                controllerAs: 'test'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(27/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(545);
                    $ocLazyLoad.load({
                        name: 'app.DashBoardModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('menutile', {
        url: '/menutile',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(90).then((function () {
                        var template = __webpack_require__(471);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'MenuController',
                controllerAs: 'test'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(73).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1458);
                    $ocLazyLoad.load({
                        name: 'menutile'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('archives', {
        url: '/archives',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(78).then((function () {
                        var template = __webpack_require__(472);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'archives',
                controllerAs: 'archives'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(67).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1459);
                    $ocLazyLoad.load({
                        name: 'ArchivesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('userManagement', {
        url: '/userEndorsement',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(146).then((function () {
                        var template = __webpack_require__(473);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'userEndorsementCtrl',
                controllerAs: 'userManagementDirective'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(56).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1460);
                    $ocLazyLoad.load({
                        name: 'userEndorsement'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('studentEndorse', {
        url: '/user-management/student-endorse',
        parent: 'userManagement',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(291).then((function () {
                        var template = __webpack_require__(474);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'stuEndrseCtrl',
                controllerAs: 'stuEndrseCtrl'
            }
        }
    }).state('teacherEndorse', {
        url: '/user-management/teacher-endorse/:hos_supervisor',
        parent: 'userManagement',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(290).then((function () {
                        var template = __webpack_require__(475);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'teacherEndorsementCtrl',
                controllerAs: 'teachrEndrsCtrl'
            }
        }
    }).state('moduleWithFeature', {
        url: '/moduleWithFeature',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(49).then((function () {
                        var template = __webpack_require__(477);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'moduleFeatureCtrl',
                controllerAs: 'test'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(48).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1461);
                    $ocLazyLoad.load({
                        name: 'moduleWithFeature'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('profileSetting', {
        url: '/profile-setting',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(255).then((function () {
                        var template = __webpack_require__(478);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'profileSettingCtrl',
                controllerAs: 'userMgt'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(107).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1462);
                    $ocLazyLoad.load({
                        name: 'userSearchDirective'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('profileData', {
        url: '/profile-view/:person_id',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    new Promise(function(resolve) { resolve(); }).then((function () {
                        var template = __webpack_require__(117);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'profileViewCtrl',
                controllerAs: 'profileViewCtrls'
            }
        }
    })
    /* .state('teacherView', {
                url: '/teacherView',
                parent: 'profileData',
                views: {
                    '@': {
                        templateProvider: ['$q', function($q) {
                            let deferred = $q.defer();
                            require.ensure(['./app/profileSetting/views/teacherView.html'], function() {
                                let template = require('./app/profileSetting/views/teacherView.html');
                                deferred.resolve(template);
                            });
                            return deferred.promise;
                        }],
                        controller: 'teacherViewCtrl',
                        controllerAs: 'teacherView'
                    }
                },
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/profileSetting/teacherViewModule.js');
                            $ocLazyLoad.load({
                                name: 'teacherView'
                            });
                            deferred.resolve(module);
                        });
                         return deferred.promise;
                    }]
                }
            }).state('hodView', {
                url: '/hodView',
                parent: 'profileData',
                views: {
                    '@': {
                        templateProvider: ['$q', function($q) {
                            let deferred = $q.defer();
                            require.ensure(['./app/profileSetting/views/hodView.html'], function() {
                                let template = require('./app/profileSetting/views/hodView.html');
                                deferred.resolve(template);
                            });
                            return deferred.promise;
                        }],
                        controller: 'hodViewCtrl',
                        controllerAs: 'hodView'
                    }
                },
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/profileSetting/hodViewModule.js');
                            $ocLazyLoad.load({
                                name: 'hodView'
                            });
                            deferred.resolve(module);
                        });
                         return deferred.promise;
                    }]
                }
            }).state('hosView', {
                url: '/hosView',
                parent: 'profileData',
                views: {
                    '@': {
                        templateProvider: ['$q', function($q) {
                            let deferred = $q.defer();
                            require.ensure(['./app/profileSetting/views/hosView.html'], function() {
                                let template = require('./app/profileSetting/views/hosView.html');
                                deferred.resolve(template);
                            });
                            return deferred.promise;
                        }],
                        controller: 'hosViewCtrl',
                        controllerAs: 'hosView'
                    }
                },
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/profileSetting/hosViewModule.js');
                            $ocLazyLoad.load({
                                name: 'hosView'
                            });
                            deferred.resolve(module);
                        });
                         return deferred.promise;
                    }]
                }
            }).state('parentView', {
                url: '/parentView',
                parent: 'profileData',
                views: {
                    '@': {
                        templateProvider: ['$q', function($q) {
                            let deferred = $q.defer();
                            require.ensure(['./app/profileSetting/views/parentView.html'], function() {
                                let template = require('./app/profileSetting/views/parentView.html');
                                deferred.resolve(template);
                            });
                            return deferred.promise;
                        }],
                        controller: 'parentViewCtrl',
                        controllerAs: 'parentView',
                    }
                },
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/profileSetting/parentViewModule.js');
                            $ocLazyLoad.load({
                                name: 'parentView'
                            });
                            deferred.resolve(module);
                        });
                         return deferred.promise;
                    }]
                }
            }) */
    /* .state('navigation', {
                name: 'navigation',
                url: '/navigation',
                views: {
                    '@': {
                         templateProvider: ['$q', function($q) {
                            let deferred = $q.defer();
                            require.ensure(['./app/navigation/views/navigation.html'], function() {
                                let template = require('./app/navigation/views/navigation.html');
                                deferred.resolve(template);
                            });
                            return deferred.promise;
                        }],
                        controller: 'navigationCtrl',
                        controllerAs: 'navigation'
                    }
                },
                resolve: {
                    foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                        let deferred = $q.defer();
                        require.ensure([], function() {
                            let module = require('./app/dashboard/dashboardModule.js');
                            $ocLazyLoad.load({
                                name: 'app.navigation'
                            });
                            deferred.resolve(module);
                        });
                         return deferred.promise;
                    }]
                }
            }) */
    .state('archivesPreview', {
        parent: 'app',
        url: '/archives-preview',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(53).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1463);
                    $ocLazyLoad.load({
                        name: 'ArchivesPreviewModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        },
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(282).then((function () {
                        var template = __webpack_require__(479);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'archivesPreviewCtrl',
                controllerAs: 'archivesPreview'
            }
        }
    }).state('resourcePreview', {
        parent: 'archivesPreview',
        url: '/resource-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(446).then((function () {
                        var template = __webpack_require__(480);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'resourcesCtrl',
                controllerAs: 'resources'
            }
        }
    }).state('syllabusPreview', {
        parent: 'archivesPreview',
        url: '/syllabus-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(445).then((function () {
                        var template = __webpack_require__(481);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'syllabusCtrl',
                controllerAs: 'syllabus'
            }
        }
    }).state('notesPreview', {
        parent: 'archivesPreview',
        url: '/notes-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(283).then((function () {
                        var template = __webpack_require__(482);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'notesCtrl',
                controllerAs: 'notes'
            }
        }
    }).state('teachingPlanPreview', {
        parent: 'archivesPreview',
        url: '/teaching-plan-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(444).then((function () {
                        var template = __webpack_require__(483);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "tp",
                controller: "tpCtrl"
            }
        }

    }).state('questionPreview', {
        parent: 'archivesPreview',
        url: '/question-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(447).then((function () {
                        var template = __webpack_require__(484);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "question",
                controller: 'questionCtrl'
            }
        }
    }).state('qpPreview', {
        parent: 'archivesPreview',
        url: '/qp-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(449).then((function () {
                        var template = __webpack_require__(485);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "qp",
                controller: "qpCtrl"
            }
        }
    }).state('qpTemplatePreview', {
        parent: 'archivesPreview',
        url: '/qp-template-preview/:id',
        views: {
            'archivePreview': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(448).then((function () {
                        var template = __webpack_require__(486);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "qpTemplate",
                controller: "qpTemplateCtrl"
            }
        }
    }).state('myArchives', {
        parent: 'app',
        url: '/my-archives',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(79).then((function () {
                        var template = __webpack_require__(487);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'myArchivesCtrl',
                controllerAs: 'myArchives'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(19/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(173);
                    $ocLazyLoad.load({
                        name: 'MyArchivesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('sendForApprovalArchive', {
        parent: 'app',
        url: '/archives/send-for-approval',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(183).then((function () {
                        var template = __webpack_require__(488);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "sendForApproval",
                controller: "sendForApprovalCtrl"
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(19/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(173);
                    $ocLazyLoad.load({
                        name: 'MyArchivesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('approveArchive', {
        parent: 'app',
        url: '/archives/approve',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(124).then((function () {
                        var template = __webpack_require__(489);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "approve",
                controller: "approveCtrl"
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(19/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(173);
                    $ocLazyLoad.load({
                        name: 'MyArchivesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('publishArchive', {
        parent: 'app',
        url: '/archives/publish-contents',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(281).then((function () {
                        var template = __webpack_require__(490);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "publish",
                controller: "publishCtrl"
            }
        },

        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(88).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1464);
                    $ocLazyLoad.load({
                        name: 'PublishArchivesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('rejectedArchive', {
        parent: 'app',
        url: '/archives/rejected-contents',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(280).then((function () {
                        var template = __webpack_require__(491);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controllerAs: "rejected",
                controller: "rejectedCtrl"
            }
        }

    }).state('linkThemes', {
        parent: 'app',
        url: '/link-themes',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(450).then((function () {
                        var template = __webpack_require__(492);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "linkThemeCtrl",
                controllerAs: 'linkTheme'
            }
        },

        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(136).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1465);
                    $ocLazyLoad.load({
                        name: 'LinkThemeModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('createArchiveItem', {
        parent: 'app',
        url: '/create-archive',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(451).then((function () {
                        var template = __webpack_require__(493);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "createCtrl",
                controllerAs: 'create'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(51).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1466);
                    $ocLazyLoad.load({
                        name: 'CreateArchiveModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('curriculumEndorsement', {
        parent: 'app',
        url: '/reEndorsement',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(253).then((function () {
                        var template = __webpack_require__(494);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "reEndorsementCtrl",
                controllerAs: 'reEndorseDirective'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(100).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1467);
                    $ocLazyLoad.load({
                        name: 'ReEndorseModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('toDo', {
        parent: 'app',
        url: '/myplanner/todo',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(304).then((function () {
                        var template = __webpack_require__(548);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "toDoCtrl",
                controllerAs: 'toDo'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(189).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1468);
                    $ocLazyLoad.load({
                        name: 'ToDoModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('chat', {
        parent: 'app',
        url: '/chatPage',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(173).then((function () {
                        var template = __webpack_require__(549);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "ChatPageCtrl",
                controllerAs: 'chatPageList'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(139).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1469);
                    $ocLazyLoad.load({
                        name: 'ChatModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('bookmark', {
        parent: 'app',
        url: '/bookmark',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(427).then((function () {
                        var template = __webpack_require__(550);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "bookmark",
                controllerAs: 'bookmark'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(199).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1470);
                    $ocLazyLoad.load({
                        name: 'BookmarkModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('faq', {
        parent: 'app',
        url: '/faq',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(400).then((function () {
                        var template = __webpack_require__(551);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "faqCtrl",
                controllerAs: 'faqCtrl'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(197).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1471);
                    $ocLazyLoad.load({
                        name: 'FAQModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('recieverFeedbackList', {
        parent: 'app',
        url: '/feedback/list/reciever',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(396).then((function () {
                        var template = __webpack_require__(552);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "recieverFeedbackListCtrl",
                controllerAs: 'recieverFeedbackListCtrl'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(24/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(175);
                    $ocLazyLoad.load({
                        name: 'FeedbackModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('createFeedback', {
        parent: 'app',
        url: '/feedback/create',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(398).then((function () {
                        var template = __webpack_require__(553);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "feedbackCreateCtrl",
                controllerAs: 'feedbackCreateCtrl'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(24/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(175);
                    $ocLazyLoad.load({
                        name: 'FeedbackModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('parentFeedback', {
        parent: 'app',
        url: '/feedback/list/parent',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(397).then((function () {
                        var template = __webpack_require__(554);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "parentFeedbackListCtrl",
                controllerAs: 'parentFeedbackCtrl'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(24/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(175);
                    $ocLazyLoad.load({
                        name: 'FeedbackModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('forumList', {
        parent: 'app',
        url: '/forum',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(395).then((function () {
                        var template = __webpack_require__(555);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "forumCtrl",
                controllerAs: 'forum'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(195).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1472);
                    $ocLazyLoad.load({
                        name: 'ForumModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('setTarget', {
        url: '/set-target',
        parent: 'app',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(312).then((function () {
                        var template = __webpack_require__(556);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: 'setTargetCtrl',
                controllerAs: 'SetTargetModule'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(190).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1473);
                    $ocLazyLoad.load({
                        name: 'SetTargetModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('reports', {
        url: '/reports',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(328).then((function () {
                var template = __webpack_require__(557);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'reports',
        controllerAs: 'reports',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(191).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1474);
                    $ocLazyLoad.load({
                        name: 'reports'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentReport', {
        url: '/student-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(238).then((function () {
                var template = __webpack_require__(558);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentReport',
        controllerAs: 'studentReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentsProgressionReport', {
        url: '/students-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(237).then((function () {
                var template = __webpack_require__(559);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentsProgressionReport',
        controllerAs: 'studentsProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('subjectWiseProgressionReport', {
        url: '/subject-wise-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(236).then((function () {
                var template = __webpack_require__(560);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'subjectWiseProgressionReport',
        controllerAs: 'subjectWiseProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examWiseProgressionReport', {
        url: '/exam-wise-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(244).then((function () {
                var template = __webpack_require__(561);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examWiseProgressionReport',
        controllerAs: 'examWiseProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('batchPerformanceGradeReport', {
        url: '/batch-performance-grade-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(252).then((function () {
                var template = __webpack_require__(562);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'batchPerformanceGradeReport',
        controllerAs: 'batchPerformanceGradeReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('batchPerformanceMarkReport', {
        url: '/batch-performance-mark-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(251).then((function () {
                var template = __webpack_require__(563);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'batchPerformanceMarkReport',
        controllerAs: 'batchPerformanceMarkReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('batchWiseProgressionReport', {
        url: '/batch-wise-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(250).then((function () {
                var template = __webpack_require__(564);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'batchWiseProgressionReport',
        controllerAs: 'batchWiseProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classPerformanceGradeReport', {
        url: '/class-performance-grade-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(249).then((function () {
                var template = __webpack_require__(565);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classPerformanceGradeReport',
        controllerAs: 'classPerformanceGradeReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classPerformanceMarkReport', {
        url: '/class-performance-mark-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(248).then((function () {
                var template = __webpack_require__(566);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classPerformanceMarkReport',
        controllerAs: 'classPerformanceMarkReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classWiseProgressionReport', {
        url: '/class-wise-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(247).then((function () {
                var template = __webpack_require__(567);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classWiseProgressionReport',
        controllerAs: 'classWiseProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sectionPerformanceGradeReport', {
        url: '/section-performance-grade-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(241).then((function () {
                var template = __webpack_require__(568);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sectionPerformanceGradeReport',
        controllerAs: 'sectionPerformanceGradeReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sectionPerformanceMarkReport', {
        url: '/section-performance-mark-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(240).then((function () {
                var template = __webpack_require__(569);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sectionPerformanceMarkReport',
        controllerAs: 'sectionPerformanceMarkReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sectionWiseProgressionReport', {
        url: '/section-wise-progression-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(239).then((function () {
                var template = __webpack_require__(570);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sectionWiseProgressionReport',
        controllerAs: 'sectionWiseProgressionReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('genderWiseProgressionGradeReport', {
        url: '/gender-wise-progression-grade-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(243).then((function () {
                var template = __webpack_require__(571);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'genderWiseProgressionGradeReport',
        controllerAs: 'genderWiseProgressionGradeReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('genderWiseProgressionMarkReport', {
        url: '/gender-wise-progression-mark-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(242).then((function () {
                var template = __webpack_require__(572);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'genderWiseProgressionMarkReport',
        controllerAs: 'genderWiseProgressionMarkReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('consolidatedReport', {
        url: '/consolidated-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(245).then((function () {
                var template = __webpack_require__(573);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'consolidatedReport',
        controllerAs: 'consolidatedReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('consolidatedExamReport', {
        url: '/consolidated-exam-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(246).then((function () {
                var template = __webpack_require__(574);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'consolidatedExamReport',
        controllerAs: 'consolidatedExamReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(13);
                    $ocLazyLoad.load({
                        name: 'resultAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('announcements', {
        url: '/announcements',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(125).then((function () {
                var template = __webpack_require__(575);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'announcements',
        controllerAs: 'announcements',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(17/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(91);
                    $ocLazyLoad.load({
                        name: 'announcements'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('announcementsUsers', {
        url: '/announcementsUsers',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(454).then((function () {
                var template = __webpack_require__(576);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'announcementsUsers',
        controllerAs: 'announcementsUsers',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(17/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(91);
                    $ocLazyLoad.load({
                        name: 'announcements'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createAnnouncements', {
        url: '/create-announcements',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(453).then((function () {
                var template = __webpack_require__(577);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createAnnouncements',
        controllerAs: 'createAnnouncements',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(17/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(91);
                    $ocLazyLoad.load({
                        name: 'announcements'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewAnnouncements', {
        url: '/view-announcements/:announceId/:send_by',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(452).then((function () {
                var template = __webpack_require__(578);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewAnnouncements',
        controllerAs: 'viewAnnouncements',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(17/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(91);
                    $ocLazyLoad.load({
                        name: 'announcements'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('addAvailability', {
        url: '/addAvailability',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(108).then((function () {
                var template = __webpack_require__(495);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'SetAppointmentController',
        controllerAs: 'SetAppointmentController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(21/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(176);
                    $ocLazyLoad.load({
                        name: 'SetAppointmentModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('getAvailability', {
        url: '/getAvailability',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(109).then((function () {
                var template = __webpack_require__(496);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'GetAppointmentController',
        controllerAs: 'GetAppointmentController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(21/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(176);
                    $ocLazyLoad.load({
                        name: 'GetAppointmentModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('attendanceReport', {
        url: '/attendance_report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(439).then((function () {
                var template = __webpack_require__(498);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AttendanceReportController',
        controllerAs: 'AttendanceReportController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(31/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(579);
                    $ocLazyLoad.load({
                        name: 'attendance_report'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('datewiseAttReport', {
        url: '/datewiseAttReport',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(179).then((function () {
                var template = __webpack_require__(499);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'DatewiseAttReportController',
        controllerAs: 'DatewiseAttReportController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(31/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(579);
                    $ocLazyLoad.load({
                        name: 'attendance_report'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('cpdSections', {
        url: '/cpd-sections',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(72).then((function () {
                var template = __webpack_require__(580);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'cpdSections',
        controllerAs: 'cpdSections',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(25/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(178);
                    $ocLazyLoad.load({
                        name: 'cpdSections'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('addCpd', {
        url: '/add-cpd',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(404).then((function () {
                var template = __webpack_require__(581);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'addCpd',
        controllerAs: 'addCpd',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(25/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(178);
                    $ocLazyLoad.load({
                        name: 'cpdSections'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('cpdPublish', {
        url: '/cpd-publish/:cpd_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(267).then((function () {
                var template = __webpack_require__(582);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'cpdPublish',
        controllerAs: 'cpdPublish',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(25/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(178);
                    $ocLazyLoad.load({
                        name: 'cpdSections'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attnd-list', {
        url: '/attendance',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(279).then((function () {
                var template = __webpack_require__(500);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AttendanceController',
        controllerAs: 'AttendanceController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(80).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1475);
                    $ocLazyLoad.load({
                        name: 'attendance'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('attendance', {
        url: '/take_attendance',
        params: {
            resource: '',
            from: ''
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(278).then((function () {
                var template = __webpack_require__(501);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'TakeAttendanceController',
        controllerAs: 'TakeAttendanceController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(104).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1476);
                    $ocLazyLoad.load({
                        name: 'take_attendance'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('attendanceconsole', {
        url: '/attendance_console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(440).then((function () {
                var template = __webpack_require__(502);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AttendanceConsoleController',
        controllerAs: 'AttendanceConsoleController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(134).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1477);
                    $ocLazyLoad.load({
                        name: 'attendance_console'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('reassignAvailability', {
        url: '/reassignAvailability',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(258).then((function () {
                var template = __webpack_require__(497);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ReassignAppointmentController',
        controllerAs: 'ReassignAppointmentController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(21/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(176);
                    $ocLazyLoad.load({
                        name: 'ReassignAppointmentModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('myProfile', {
        url: '/my-profile',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(95).then((function () {
                var template = __webpack_require__(583);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'myProfile',
        controllerAs: 'myProfile',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(28/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(584);
                    $ocLazyLoad.load({
                        name: 'myProfile'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('editProfile', {
        url: '/edit-profile',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(350).then((function () {
                var template = __webpack_require__(585);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'editProfile',
        controllerAs: 'editProfile',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(28/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(584);
                    $ocLazyLoad.load({
                        name: 'myProfile'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('changePassword', {
        url: '/change-password',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(412).then((function () {
                var template = __webpack_require__(586);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'changePassword',
        controllerAs: 'changePassword',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(132).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1478);
                    $ocLazyLoad.load({
                        name: 'changePassword'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attendanceLite', {
        url: '/attendance-lite',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(277).then((function () {
                var template = __webpack_require__(587);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attendanceLite',
        controllerAs: 'attendanceLite',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(200).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1479);
                    $ocLazyLoad.load({
                        name: 'AttendanceLiteModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('notifications', {
        url: '/notifications',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(257).then((function () {
                var template = __webpack_require__(588);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'notifications',
        controllerAs: 'notifications',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(206).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1480);
                    $ocLazyLoad.load({
                        name: 'notifications'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('contentSummary', {
        url: '/content-summary',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(405).then((function () {
                var template = __webpack_require__(589);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'contentSummary',
        controllerAs: 'contentSummary',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(74).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1481);
                    $ocLazyLoad.load({
                        name: 'contentSummary'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('calendarTask', {
        url: '/calendar-task:redirect',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(426).then((function () {
                var template = __webpack_require__(590);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'calendarTask',
        controllerAs: 'calendarTask',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(103).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1482);
                    $ocLazyLoad.load({
                        name: 'calendarTask'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attendancePreview', {
        url: '/my-attendance',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(441).then((function () {
                var template = __webpack_require__(458);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'StudentAttendancePreview',
        controllerAs: 'StudentAttendancePreview',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(135).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1483);
                    $ocLazyLoad.load({
                        name: 'student_attendance'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('myTimetable', {
        url: '/my-timetable',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(348).then((function () {
                var template = __webpack_require__(503);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'MyTimetablePreview',
        controllerAs: 'MyTimetablePreview',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(129).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1484);
                    $ocLazyLoad.load({
                        name: 'my_timetable'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('timetableconsole', {
        url: '/timetable_console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(305).then((function () {
                var template = __webpack_require__(504);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'TimetableConsoleController',
        controllerAs: 'TimetableConsoleController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(127).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1485);
                    $ocLazyLoad.load({
                        name: 'timetable_console'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('leaveManagement', {
        url: '/leave_management',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(262).then((function () {
                var template = __webpack_require__(591);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'leaveManagement',
        controllerAs: 'leaveManagement',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(34/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(592);
                    $ocLazyLoad.load({
                        name: 'LeaveManagementModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createLeave', {
        url: '/create-leave/:parent_state/:user_id/',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(377).then((function () {
                var template = __webpack_require__(593);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createLeaveController',
        controllerAs: 'createLeaveController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(34/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(592);
                    $ocLazyLoad.load({
                        name: 'LeaveManagementModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('timetableallocation', {
        url: '/timetable_allocation',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(306).then((function () {
                var template = __webpack_require__(505);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'TimetableAllocationController',
        controllerAs: 'TimetableAllocationController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(99).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1486);
                    $ocLazyLoad.load({
                        name: 'timetable_allocation'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('createUserManual', {
        url: '/create-user-manual',
        params: {
            um_id: null,
            feature_id: null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(289).then((function () {
                var template = __webpack_require__(594);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createUserManual',
        controllerAs: 'createUserManual',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(35/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(595);
                    $ocLazyLoad.load({
                        name: 'UserManual'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewUserManual', {
        url: '/view-user-manual',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(145).then((function () {
                var template = __webpack_require__(596);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewUserManual',
        controllerAs: 'viewUserManual',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(35/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(595);
                    $ocLazyLoad.load({
                        name: 'UserManual'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('removeUser', {
        url: '/deactivate_users',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(403).then((function () {
                var template = __webpack_require__(506);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'DeactivateUsersCtrlController',
        controllerAs: 'userManagementDirective',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(131).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1487);
                    $ocLazyLoad.load({
                        name: 'deactivateUsers'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('criteriaConsole', {
        url: '/criteria-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(165).then((function () {
                var template = __webpack_require__(597);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'criteriaConsole',
        controllerAs: 'criteriaConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(38/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(598);
                    $ocLazyLoad.load({
                        name: 'fpi'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('criteriaScheduler', {
        url: '/criteria-scheduler',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(394).then((function () {
                var template = __webpack_require__(599);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'criteriaScheduler',
        controllerAs: 'criteriaScheduler',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(38/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(598);
                    $ocLazyLoad.load({
                        name: 'fpi'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('markEntryProgress', {
        url: '/mark-entry-progress',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(169).then((function () {
                var template = __webpack_require__(600);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'markEntryProgress',
        controllerAs: 'markEntryProgress',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('teachingPlanReport', {
        url: '/teaching-plan-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(168).then((function () {
                var template = __webpack_require__(601);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'teachingPlanReport',
        controllerAs: 'teachingPlanReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('dailyAttendenceReport', {
        url: '/daily-attendence-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(87).then((function () {
                var template = __webpack_require__(602);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'dailyAttendenceReport',
        controllerAs: 'dailyAttendenceReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('trackActivityReport', {
        url: '/track-activity-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(120).then((function () {
                var template = __webpack_require__(603);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'trackActivityReport',
        controllerAs: 'trackActivityReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('loginTrackerReport', {
        url: '/login-tracker-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(170).then((function () {
                var template = __webpack_require__(604);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'loginTrackerReport',
        controllerAs: 'loginTrackerReport',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('rimsData', {
        url: '/rims-settings',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(326).then((function () {
                var template = __webpack_require__(605);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'rimsData',
        controllerAs: 'rimsData',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(32/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(606);
                    $ocLazyLoad.load({
                        name: 'rimsData'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('rimsConsole', {
        url: '/rims-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(327).then((function () {
                var template = __webpack_require__(607);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'rimsConsole',
        controllerAs: 'rimsConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(32/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(606);
                    $ocLazyLoad.load({
                        name: 'rimsData'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('newTeachingPlan', {
        url: '/new-teaching-plan/:id/:planId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(121);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'tpController',
        controllerAs: 'newTeachingPlan',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(361);
                    $ocLazyLoad.load({
                        name: 'newTeachingPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewTeachingPlan', {
        url: '/view-teaching-plan/:planId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(122);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'tpViewController',
        controllerAs: 'viewTeachingPlan',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(363);
                    $ocLazyLoad.load({
                        name: 'viewTeachingPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('wizard', {
        url: '/wizard/:planId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(123);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'wizardController',
        controllerAs: 'wizard',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(364);
                    $ocLazyLoad.load({
                        name: 'wizard'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sendConsole', {
        url: '/sen/send-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(315).then((function () {
                var template = __webpack_require__(508);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sendConsoleCtrl',
        controllerAs: 'sendConsoleCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('send', {
        url: '/sen/dashboard-page',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(58).then((function () {
                var template = __webpack_require__(509);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sendDashboard',
        controllerAs: 'sendDashboard',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createSendForms', {
        url: '/sen/create-send-forms',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(316).then((function () {
                var template = __webpack_require__(510);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createSendForms',
        controllerAs: 'createSendForms',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('chooseApprover', {
        url: '/sen/choose-approver/:id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(317).then((function () {
                var template = __webpack_require__(511);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'chooseApprover',
        controllerAs: 'chooseApprover',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('commonSurveyList', {
        url: '/common-survey-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(121).then((function () {
                var template = __webpack_require__(608);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'commonSurveyList',
        controllerAs: 'commonSurveyList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(198).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1488);
                    $ocLazyLoad.load({
                        name: 'commonSurveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('surveyList', {
        url: '/survey-list/:user_id/:schedule_id/:is_fpi_survey',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(123).then((function () {
                var template = __webpack_require__(609);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'surveyList',
        controllerAs: 'surveyList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createSurvey', {
        url: '/create-survey/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(435).then((function () {
                var template = __webpack_require__(610);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createSurvey',
        controllerAs: 'createSurvey',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('conductSurvey', {
        url: '/conduct-survey/:id/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(276).then((function () {
                var template = __webpack_require__(611);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'conductSurvey',
        controllerAs: 'conductSurvey',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attemptSurvey', {
        url: '/attempt-survey/:surveyId/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(436).then((function () {
                var template = __webpack_require__(612);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attemptSurvey',
        controllerAs: 'attemptSurvey',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('listSurveyAnswer', {
        url: '/list-survey-answer/:surveyId/:parent_state/:user_id/:schedule_id/:is_fpi_survey',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(275).then((function () {
                var template = __webpack_require__(613);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'listSurveyAnswer',
        controllerAs: 'listSurveyAnswer',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewMySubmittedSurveyAnswer', {
        url: '/view-my-submitted-survey-answer/:surveyId/:userId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(434).then((function () {
                var template = __webpack_require__(614);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewMySubmittedSurveyAnswer',
        controllerAs: 'viewMySubmittedSurveyAnswer',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewSurveyAnswer', {
        url: '/view-survey-answer/:surveyId/:userId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(433).then((function () {
                var template = __webpack_require__(615);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewSurveyAnswer',
        controllerAs: 'viewSurveyAnswer',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(4/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(37);
                    $ocLazyLoad.load({
                        name: 'surveyList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('manageReportCards', {
        url: '/manage-report-cards',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(124);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'manageReportCards',
        controllerAs: 'manageReportCardsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(366);
                    $ocLazyLoad.load({
                        name: 'ManageReportsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('publishReports', {
        url: '/publish-reports',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(125);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'publishReports',
        controllerAs: 'publishReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(368);
                    $ocLazyLoad.load({
                        name: 'publishReports'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('approveReports', {
        url: '/report-card-approvals',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(126);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'approveReports',
        controllerAs: 'reportCardApprovalCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(369);
                    $ocLazyLoad.load({
                        name: 'ApproveReportsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('consoleSetting', {
        url: '/console-setting',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(409).then((function () {
                var template = __webpack_require__(616);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'consoleSetting',
        controllerAs: 'consoleSetting',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('wifiConsole', {
        url: '/wifi-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(406).then((function () {
                var template = __webpack_require__(617);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'wifiConsole',
        controllerAs: 'wifiConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('adminConsole', {
        url: '/admin-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(172).then((function () {
                var template = __webpack_require__(618);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'adminConsole',
        controllerAs: 'adminConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewDetails', {
        url: '/view-details',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(408).then((function () {
                var template = __webpack_require__(619);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewDetails',
        controllerAs: 'viewDetails',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewTabletDetails', {
        url: '/view-tablet-details',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(407).then((function () {
                var template = __webpack_require__(620);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewTabletDetails',
        controllerAs: 'viewTabletDetails',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('appListConsole', {
        url: '/app-list-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(410).then((function () {
                var template = __webpack_require__(621);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'appListConsole',
        controllerAs: 'appListConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(6/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(46);
                    $ocLazyLoad.load({
                        name: 'consoleSetting'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('parentPortalHome', {
        url: '/parent-portal',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(344).then((function () {
                var template = __webpack_require__(622);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'parentPortalHome',
        controllerAs: 'parentPortal',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentActivity', {
        url: '/student-activity',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(159).then((function () {
                var template = __webpack_require__(624);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentActivity',
        controllerAs: 'studentActivity',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('tabletDetailsofChild', {
        url: '/device-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(343).then((function () {
                var template = __webpack_require__(625);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'tabletDetailsofChild',
        controllerAs: 'tabletDetailsofChild',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('parentFees', {
        url: '/parent-fees',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(256).then((function () {
                var template = __webpack_require__(626);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'parentFees',
        controllerAs: 'parentFees',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('parentLibrary', {
        url: '/parent-library',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(345).then((function () {
                var template = __webpack_require__(627);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'parentLibrary',
        controllerAs: 'parentLibrary',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('trackSchoolBus', {
        url: '/track-school-bus',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(342).then((function () {
                var template = __webpack_require__(628);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'trackSchoolBus',
        controllerAs: 'trackSchoolBus',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(7/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(48);
                    $ocLazyLoad.load({
                        name: 'ParentPortalModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportCardListing', {
        url: '/report-card-teacher-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(151).then((function () {
                var template = __webpack_require__(629);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'reportCardListing',
        controllerAs: 'reportCardListingCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(370);
                    $ocLazyLoad.load({
                        name: 'ReportCardListsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportCardGenConsole', {
        url: '/report-card-gen-console/:cardId/:dataId/:re_generate/:fromCt',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(127);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'reportCardGenConsole',
        controllerAs: 'reportCardGenConsoleCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(371);
                    $ocLazyLoad.load({
                        name: 'reportCardGenConsoleModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentListingForReports', {
        url: '/student-list-class-teacher',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(128);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentListingForReports',
        controllerAs: 'reportCardClassTeacherCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(372);
                    $ocLazyLoad.load({
                        name: 'reportCardClassTeacher'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('publishedReports', {
        url: '/published-reports/:student_id/:fee_status',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(129);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'publishedReports',
        controllerAs: 'publishedReportsListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(373);
                    $ocLazyLoad.load({
                        name: 'PublishedReportModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentParentMapping', {
        url: '/studentParentMapping',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(130);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentParentMapping',
        controllerAs: 'studentParentMapping',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(374);
                    $ocLazyLoad.load({
                        name: 'studentParentMapping'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('peopleSearch', {
        url: '/people-search',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(131);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'peopleSearch',
        controllerAs: 'peopleSearch',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(375);
                    $ocLazyLoad.load({
                        name: 'peopleSearch'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examListingPage', {
        url: '/examListingPage',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(83).then((function () {
                var template = __webpack_require__(518);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examListingPage',
        controllerAs: 'resultEntryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(62).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1489);
                    $ocLazyLoad.load({
                        name: 'MarkEntryListModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examMarkEntry', {
        url: '/examMarkEntry',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(369).then((function () {
                var template = __webpack_require__(631);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examMarkEntry',
        controllerAs: 'resultEntryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(193).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1490);
                    $ocLazyLoad.load({
                        name: 'MarkEntrySaveModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classteacherApproval', {
        url: '/class-teacher-approval',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(97).then((function () {
                var template = __webpack_require__(632);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classteacherApproval',
        controllerAs: 'EndrosementListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(114).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1491);
                    $ocLazyLoad.load({
                        name: 'classteacherApproval'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('academicPerformance', {
        url: '/academic-performance',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(132);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'academicPerformance',
        controllerAs: 'academicPerformance',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(376);
                    $ocLazyLoad.load({
                        name: 'academicPerformance'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('termDifference', {
        url: '/term-difference',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(133);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'termDifference',
        controllerAs: 'termDifference',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(377);
                    $ocLazyLoad.load({
                        name: 'termDifference'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attentionNeedingStudents', {
        url: '/attention-needing-students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(134);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attentionNeedingStudents',
        controllerAs: 'attentionNeedingStudents',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(378);
                    $ocLazyLoad.load({
                        name: 'attentionNeedingStudents'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('performingSection', {
        url: '/performing-section',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(135);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'performingSection',
        controllerAs: 'performingSection',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(379);
                    $ocLazyLoad.load({
                        name: 'performingSection'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sectionWiseAttention', {
        url: '/section-wise-attention',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(136);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sectionWiseAttention',
        controllerAs: 'sectionWiseAttention',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(380);
                    $ocLazyLoad.load({
                        name: 'sectionWiseAttention'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentFilteration', {
        url: '/student-filteration',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(137);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentFilteration',
        controllerAs: 'activityReportCardCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(381);
                    $ocLazyLoad.load({
                        name: 'studentFilteration'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classActivityReportCard', {
        url: '/class-activity-report-card',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(138);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classActivityReportCard',
        controllerAs: 'classActivityReportCardCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(382);
                    $ocLazyLoad.load({
                        name: 'classActivityReportcard'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('educoreStandardReport', {
        url: '/educore-standard-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(139);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'educoreStandardReport',
        controllerAs: 'standardreportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(383);
                    $ocLazyLoad.load({
                        name: 'educoreStandardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('educorePerformanceAnalysis', {
        url: '/educore-performance-analysis',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(140);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'educorePerformanceAnalysis',
        controllerAs: 'educorePerformanceAnalysisCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(384);
                    $ocLazyLoad.load({
                        name: 'educorePerformanceAnalysis'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('myCumulativeReport', {
        url: '/my-cumulative-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(141);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'myCumulativeReport',
        controllerAs: 'myCumulativeReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(385);
                    $ocLazyLoad.load({
                        name: 'myCumulativeReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('clubPost', {
        url: '/club-post',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(142);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],

        controller: 'clubPost',
        controllerAs: 'clubPost',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(390);
                    $ocLazyLoad.load({
                        name: 'clubPost'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createClub', {
        url: '/create-club',
        params: {
            "user_privilege": null,
            "club_id": null,
            "mode": null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(143);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createClub',
        controllerAs: 'createClub',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(393);
                    $ocLazyLoad.load({
                        name: 'createClub'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('curriculumConsole', {
        url: '/curriculum-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(144);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'curriculumConsole',
        controllerAs: 'curriculumCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(394);
                    $ocLazyLoad.load({
                        name: 'CurriculumConsoleModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('basicSettings', {
        url: '/basicSetting',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(382).then((function () {
                var template = __webpack_require__(633);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'basicSettings',
        controllerAs: 'basicSettings',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(207).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1492);
                    $ocLazyLoad.load({
                        name: 'basicSettings'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('curriculumSetup', {
        url: '/curriculum-setup',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(145);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'curriculumSetup',
        controllerAs: 'curriculumSetupController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(395);
                    $ocLazyLoad.load({
                        name: 'CurriculumSetupModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('subjectSetup', {
        url: '/subject-setup',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(146);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'subjectSetup',
        controllerAs: 'subjectSettingsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(396);
                    $ocLazyLoad.load({
                        name: 'SubjectSetupModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sessionSetup', {
        url: '/session-setup',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(147);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],

        controller: 'sessionSetup',
        controllerAs: 'sessionSettingsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(397);
                    $ocLazyLoad.load({
                        name: 'SessionSetupModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('adminAddNewUserInGoogle', {
        url: '/add-new-user',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(286).then((function () {
                var template = __webpack_require__(634);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'addUser',
        controllerAs: 'addUser',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(186).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1493);
                    $ocLazyLoad.load({
                        name: 'addUser'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('editUser', {
        url: '/edit-user',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(148);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],

        controller: 'editUser',
        controllerAs: 'editUser',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(398);
                    $ocLazyLoad.load({
                        name: 'editUser'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('assignSenPerson', {
        url: '/sen/assign-senperson/:id',
        params: {
            'id': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(319).then((function () {
                var template = __webpack_require__(512);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'assignSenPerson',
        controllerAs: 'assignSenPerson',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('changeWave', {
        url: '/sen/change-wave',
        params: {
            'id': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(318).then((function () {
                var template = __webpack_require__(513);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'changeWave',
        controllerAs: 'changeWave',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createIep', {
        url: '/sen/createiep/:iep_id/:new_iep',
        params: {
            'iep_id': null,
            'new_iep': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(235).then((function () {
                var template = __webpack_require__(514);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createIep',
        controllerAs: 'createIep',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createIlp', {
        url: '/sen/createilp/:ilp_id/:new_ilp',
        params: {
            'ilp_id': null,
            'new_ilp': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(234).then((function () {
                var template = __webpack_require__(515);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createIlp',
        controllerAs: 'createIlp',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewHistoryIep', {
        url: '/sen/viewHistoryIep/:old_id/:id',
        params: {
            'old_id': null,
            'id': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(314).then((function () {
                var template = __webpack_require__(516);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewHistoryIep',
        controllerAs: 'viewHistoryIep',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewHistoryIlp', {
        url: '/sen/viewHistoryIlp',
        params: {
            'old_id': null,
            'id': null
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(313).then((function () {
                var template = __webpack_require__(517);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewHistoryIlp',
        controllerAs: 'viewHistoryIlp',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(23);
                    $ocLazyLoad.load({
                        name: 'send'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('giftedTalented', {
        url: '/giftedTalented/dashboard-page',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(65).then((function () {
                var template = __webpack_require__(635);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'giftedTalented',
        controllerAs: 'giftedTalented',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(20/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(179);
                    $ocLazyLoad.load({
                        name: 'giftedTalented'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createGiftedTalentedForms', {
        url: '/giftedTalented/create-gifted-talented-forms',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(264).then((function () {
                var template = __webpack_require__(636);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createGiftedTalentedForms',
        controllerAs: 'createGiftedTalentedForms',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(20/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(179);
                    $ocLazyLoad.load({
                        name: 'giftedTalented'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('chooseApproverForGifted', {
        url: '/giftedTalented/chooseApprover',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(393).then((function () {
                var template = __webpack_require__(637);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],

        controller: 'chooseApprover',
        controllerAs: 'chooseApprover',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(20/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(179);
                    $ocLazyLoad.load({
                        name: 'giftedTalented'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('authdashboard', {
        url: '/authDashboard',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(150);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'authDashboardCtrl',
        controllerAs: 'authDashboardCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(399);
                    $ocLazyLoad.load({
                        name: 'authDashboardCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('authoringTool', {
        url: '/authoring-tool',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(151);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'authOverviewCtrl',
        controllerAs: 'authOverviewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(400);
                    $ocLazyLoad.load({
                        name: 'authOverviewCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('theme-summary', {
        url: '/theme-summary/:theme_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(152);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'themeSummaryCtrl',
        controllerAs: 'themeSummaryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(401);
                    $ocLazyLoad.load({
                        name: 'themeSummaryCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('subjectReport', {
        url: '/subject-report/:studentId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(153);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'subjectReportCtrl',
        controllerAs: 'subjectReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(402);
                    $ocLazyLoad.load({
                        name: 'subjectReportCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('subjectStudent', {
        url: '/subject-student',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(154);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'subjectStudentCtrl',
        controllerAs: 'subjectStudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(403);
                    $ocLazyLoad.load({
                        name: 'subjectStudentCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    })
    // .state('createAlp', {
    //     url: '/gifted-talented/createalp/:alp_id/:new_alp',
    //     templateProvider: ['$q', function ($q) {
    //         let deferred = $q.defer();
    //         require.ensure(['./app/giftedTalented/views/createALP.html'], function () {
    //             let template = require('./app/giftedTalented/views/createALP.html');
    //             deferred.resolve(template);
    //         });
    //         return deferred.promise;
    //     }],
    //     controller: 'createAlp',
    //     controllerAs: 'createAlp',
    //     resolve: {
    //         foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
    //             let deferred = $q.defer();
    //             require.ensure([], function () {
    //                 let module = require('./app/giftedTalented/giftedModule.js');
    //                 $ocLazyLoad.load({
    //                     name: 'giftedTalented'
    //                 });
    //                 deferred.resolve(module);
    //             });
    //             return deferred.promise;
    //         }]
    //     }
    // })
    .state('createQuestion', {
        url: '/createQuestion',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(76);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createQuestionCtrl',
        controllerAs: 'createQuestionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(155);
                    $ocLazyLoad.load({
                        name: 'createQuestionCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activityList', {
        url: '/activity-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(69).then((function () {
                var template = __webpack_require__(638);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'activityListCtrl',
        controllerAs: 'activityListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(404);
                    $ocLazyLoad.load({
                        name: 'activityListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportsMainCtrl', {
        url: '/traditional-activity-reports/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(295).then((function () {
                var template = __webpack_require__(639);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'reportsMainCtrl',
        controllerAs: 'reportsMainCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(405);
                    $ocLazyLoad.load({
                        name: 'reportsMainCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('individualStudentTraditionalReportCtrl', {
        url: '/traditional-activity-reports/student/:qpId/:student_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(297).then((function () {
                var template = __webpack_require__(640);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'individualStudentTraditionalReportCtrl',
        controllerAs: 'individualStudentTraditionalReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(172);
                    $ocLazyLoad.load({
                        name: 'individualStudentTraditionalReportCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createActivity', {
        url: '/create-activity/:qpId/:activityId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(300).then((function () {
                var template = __webpack_require__(641);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createActivityCtrl',
        controllerAs: 'createActivityCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(406);
                    $ocLazyLoad.load({
                        name: 'createActivityCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('qpSummary', {
        url: '/qp-summary/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(296).then((function () {
                var template = __webpack_require__(642);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'qpSummaryCtrl',
        controllerAs: 'qpSummaryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(407);
                    $ocLazyLoad.load({
                        name: 'qpSummaryCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('formatQuestion', {
        url: '/format-question/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(298).then((function () {
                var template = __webpack_require__(643);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'formatQuestionCtrl',
        controllerAs: 'formatQuestionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(408);
                    $ocLazyLoad.load({
                        name: 'formatQuestionCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activityPreview', {
        url: '/activity-preview/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(303).then((function () {
                var template = __webpack_require__(645);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'activityPreviewCtrl',
        controllerAs: 'activityPreviewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(409);
                    $ocLazyLoad.load({
                        name: 'activityPreviewCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewSubmissionList', {
        url: '/submission-list/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(55).then((function () {
                var template = __webpack_require__(647);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewSubmissionListCtrl',
        controllerAs: 'viewSubmissionListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(410);
                    $ocLazyLoad.load({
                        name: 'viewSubmissionListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('assignStudents', {
        url: '/assign-students/:qpId',
        params: {
            previousState: {}
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(302).then((function () {
                var template = __webpack_require__(648);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'assignStudentsCtrl',
        controllerAs: 'assignStudentsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(411);
                    $ocLazyLoad.load({
                        name: 'assignStudentsCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createStudentGroup', {
        url: '/assign-students/:qpId',
        params: {
            previousState: {}
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(299).then((function () {
                var template = __webpack_require__(649);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createStudentGroupCtrl',
        controllerAs: 'createStudentGroupCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(412);
                    $ocLazyLoad.load({
                        name: 'createStudentGroupCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentAnswerView', {
        url: '/student-answer-view/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(156);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentAnswerViewCtrl',
        controllerAs: 'studentAnswerViewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(157);
                    $ocLazyLoad.load({
                        name: 'studentAnswerViewCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('teacherAnswerView', {
        url: '/teacher-answer-view/:qpId/:studentId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(158);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'teacherAnswerViewCtrl',
        controllerAs: 'teacherAnswerViewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(159);
                    $ocLazyLoad.load({
                        name: 'teacherAnswerViewCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentAttendingPage', {
        url: '/student-attending-page/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(160);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentAttendingCtrl',
        controllerAs: 'studentAttendingCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(414);
                    $ocLazyLoad.load({
                        name: 'studentAttendingCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentQuestionSelection', {
        url: '/student-question-selection/:qpId/:activityId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(161);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentQuestionCtrl',
        controllerAs: 'studentQuestionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(164);
                    $ocLazyLoad.load({
                        name: 'studentQuestionCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentViewReport', {
        url: '/student-view-report/:qpId/:studentId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(294).then((function () {
                var template = __webpack_require__(650);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentViewReportCtrl',
        controllerAs: 'studentViewReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(164);
                    $ocLazyLoad.load({
                        name: 'studentViewReportCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('teacherViewReport', {
        url: '/teacher-view-report/:qpId/:studentId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(293).then((function () {
                var template = __webpack_require__(651);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'teacherViewReportCtrl',
        controllerAs: 'teacherViewReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(416);
                    $ocLazyLoad.load({
                        name: 'teacherViewReportCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attendeeList', {
        url: '/attendee-list/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(301).then((function () {
                var template = __webpack_require__(652);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attendeeListCtrl',
        controllerAs: 'attendeeListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(417);
                    $ocLazyLoad.load({
                        name: 'attendeeListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('assignUsers', {
        url: '/assign-users/:planId',
        params: {
            previousState: {
                state: '',
                params: {}
            }
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(438).then((function () {
                var template = __webpack_require__(653);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'assignController',
        controllerAs: 'assignController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(418);
                    $ocLazyLoad.load({
                        name: 'assignController'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createGroup', {
        url: '/create-group/:planId/:groupId',
        params: {
            previousState: {}
        },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(437).then((function () {
                var template = __webpack_require__(654);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'groupController',
        controllerAs: 'groupController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(419);
                    $ocLazyLoad.load({
                        name: 'groupController'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('aboutUs', {
        url: '/about_us',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(461).then((function () {
                var template = __webpack_require__(655);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'aboutUs',
        controllerAs: 'aboutUs',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(138).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1494);
                    $ocLazyLoad.load({
                        name: 'aboutUs'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('forgotPassword', {
        url: '/forgot-password',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(98).then((function () {
                var template = __webpack_require__(656);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'forgotPassword',
        controllerAs: 'forgotPassword',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(210).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1495);
                    $ocLazyLoad.load({
                        name: 'forgotPasswordModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('resetPassword', {
        url: '/cordova/reset-password/:tokenId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(93).then((function () {
                var template = __webpack_require__(657);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'resetPassword',
        controllerAs: 'resetPassword',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(203).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1496);
                    $ocLazyLoad.load({
                        name: 'resetPasswordModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('transferStudent', {
        url: '/transfer-student',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(292).then((function () {
                var template = __webpack_require__(658);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'transferStudent',
        controllerAs: 'transferStudent',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(126).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1497);
                    $ocLazyLoad.load({
                        name: 'transferStudent'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createImmunization', {
        url: '/create-form',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(364).then((function () {
                var template = __webpack_require__(659);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createFormCtrl',
        controllerAs: 'createFormCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(420);
                    $ocLazyLoad.load({
                        name: 'createFormCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('medicalFeatureList', {
        url: '/medical-feature-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(356).then((function () {
                var template = __webpack_require__(660);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'featureListCtrl',
        controllerAs: 'featureListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(421);
                    $ocLazyLoad.load({
                        name: 'featureListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('incidents', {
        url: '/incidents/:patientId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(111).then((function () {
                var template = __webpack_require__(661);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'incidentsCtrl',
        controllerAs: 'incidentsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(422);
                    $ocLazyLoad.load({
                        name: 'incidentsCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('firstAidForm', {
        url: '/first-aid-form',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(363).then((function () {
                var template = __webpack_require__(662);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'firstAidCtrl',
        controllerAs: 'firstAidCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(423);
                    $ocLazyLoad.load({
                        name: 'firstAidCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('referralForm', {
        url: '/referral-form',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(362).then((function () {
                var template = __webpack_require__(663);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'referralCtrl',
        controllerAs: 'referralCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(424);
                    $ocLazyLoad.load({
                        name: 'referralCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('vaccinationForm', {
        url: '/vaccination-form',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(361).then((function () {
                var template = __webpack_require__(664);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'vaccinationCtrl',
        controllerAs: 'vaccinationCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(425);
                    $ocLazyLoad.load({
                        name: 'vaccinationCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('inventory', {
        url: '/inventory',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(360).then((function () {
                var template = __webpack_require__(665);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'inventoryCtrl',
        controllerAs: 'inventoryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(426);
                    $ocLazyLoad.load({
                        name: 'inventoryCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('inventoryList', {
        url: '/inventory-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(110).then((function () {
                var template = __webpack_require__(666);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'inventoryListCtrl',
        controllerAs: 'inventoryListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(427);
                    $ocLazyLoad.load({
                        name: 'inventoryListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('purchaseOrder', {
        url: '/purchase-order',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(358).then((function () {
                var template = __webpack_require__(667);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'purchaseOrderCtrl',
        controllerAs: 'purchaseOrderCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(428);
                    $ocLazyLoad.load({
                        name: 'purchaseOrderCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('purchaseList', {
        url: '/purchase-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(359).then((function () {
                var template = __webpack_require__(668);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'purchaseListCtrl',
        controllerAs: 'purchaseListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(429);
                    $ocLazyLoad.load({
                        name: 'purchaseListCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('stockList', {
        url: '/stock-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(357).then((function () {
                var template = __webpack_require__(669);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'stockDetailsCtrl',
        controllerAs: 'stockDetailsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(430);
                    $ocLazyLoad.load({
                        name: 'stockDetailsCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('userProfile', {
        url: '/user-profile',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(161).then((function () {
                var template = __webpack_require__(670);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'userProfileCtrl',
        controllerAs: 'userProfileCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(431);
                    $ocLazyLoad.load({
                        name: 'userProfileCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('userFilter', {
        url: '/user-filter',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(352).then((function () {
                var template = __webpack_require__(671);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'userFilterCtrl',
        controllerAs: 'userFilterCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(432);
                    $ocLazyLoad.load({
                        name: 'userFilterCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('medicalProfile', {
        url: '/medical-profile',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(259).then((function () {
                var template = __webpack_require__(672);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'medicalProfileCtrl',
        controllerAs: 'medicalProfileCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(433);
                    $ocLazyLoad.load({
                        name: 'medicalProfileCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createProgramme', {
        url: '/create-programme',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(355).then((function () {
                var template = __webpack_require__(673);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createProgrammeCtrl',
        controllerAs: 'createProgrammeCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(434);
                    $ocLazyLoad.load({
                        name: 'createProgrammeCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewProgramme', {
        url: '/view-programme',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(353).then((function () {
                var template = __webpack_require__(674);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewProgrammeCtrl',
        controllerAs: 'viewProgrammeCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(435);
                    $ocLazyLoad.load({
                        name: 'viewProgrammeCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('programmeConsole', {
        url: '/programme-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(354).then((function () {
                var template = __webpack_require__(675);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'programmeConsoleCtrl',
        controllerAs: 'programmeConsoleCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(436);
                    $ocLazyLoad.load({
                        name: 'programmeConsoleCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('myStudentsList', {
        url: '/my-students-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(349).then((function () {
                var template = __webpack_require__(519);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'myStudentsList',
        controllerAs: 'myStudentsList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(94).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1498);
                    $ocLazyLoad.load({
                        name: 'myStudentsList'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('Shuffle', {
        url: '/Shuffle',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(383).then((function () {
                var template = __webpack_require__(676);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'houseShufflerController',
        controllerAs: 'houseShufflerController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(208).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1499);
                    $ocLazyLoad.load({
                        name: 'houseShuffler'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('manageHouses', {
        url: '/manageHouses',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(370).then((function () {
                var template = __webpack_require__(677);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'manageHousesController',
        controllerAs: 'manageHousesController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(163).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1500);
                    $ocLazyLoad.load({
                        name: 'manageHouses'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    })

    /* .state('teacherProfiler', {
        url: '/teacherProfiler',
        parent: 'app',
        templateProvider: ['$q', function($q) {
            let deferred = $q.defer();
            require.ensure(['./app/teacherProfiler/views/teacherProfiler.html'], function() {
                let template = require('./app/teacherProfiler/views/teacherProfiler.html');
                deferred.resolve(template);
            });
            return deferred.promise;
        }],
        controller: 'teacherProfilerController',
        controllerAs: 'tpCtrl',
        resolve: {
            loadController: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
                let deferred = $q.defer();
                require.ensure([], function() {
                    let module = require('./app/teacherProfiler/teacherProfilerModule');
                    $ocLazyLoad.load({
                        name: 'teacherProfiler'
                    });
                    deferred.resolve(module);
                });
                return deferred.promise;
            }]
        }
    }) */

    .state('lessonPlanDownload', {
        url: '/lessonPlanDownload',
        parent: 'app',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(372).then((function () {
                var template = __webpack_require__(678);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lessonPlanDownloadController',
        controllerAs: 'lpDownloadCtrl',
        resolve: {
            loadController: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(10/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(58);
                    $ocLazyLoad.load({
                        name: 'lessonPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    })
    // .state('lessonPlan',{
    //     url:'/lessonPlan',
    //     templateProvider:['$q',function($q){
    //         let deffered = $q.defer();
    //         require.ensure(['./app/lessonPlan/views/lessonPlan.html'],function(){
    //             let template = require('./app/lessonPlan/views/lessonPlan.html');
    //             deffered.resolve(template);
    //         });
    //         return deffered.promise
    //     }],
    //     controller:'lpController',
    //     controllerAs:'lpController',
    //     resolve:{
    //         foo:['$q','$ocLazyLoad',function($q,$ocLazyLoad){
    //             let deferred = $q.defer();
    //           require.ensure([],function(){
    //             let module = require('./app/lessonPlan/lessonPlanModule');
    //             $ocLazyLoad.load({
    //                 name:'lessonPlan'
    //             });
    //             deferred.resolve(module)
    //           });
    //           return deferred.promise
    //         }]
    //     }
    // })
    .state('editLesson', {
        url: '/lessonPlan/editLesson/:lesson_id',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(43/* duplicate */).then((function () {
                var template = __webpack_require__(92);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'editLpController',
        controllerAs: 'editLpController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(10/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(58);
                    $ocLazyLoad.load({
                        name: 'lessonPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('copyLesson', {
        url: '/lessonPlan/copyLesson/:lesson_id',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(373).then((function () {
                var template = __webpack_require__(679);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'editLpController',
        controllerAs: 'editLpController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(10/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(58);
                    $ocLazyLoad.load({
                        name: 'lessonPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewLesson', {
        url: '/lessonPlan/viewLesson/:lesson_id/:view',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(43/* duplicate */).then((function () {
                var template = __webpack_require__(92);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'editLpController',
        controllerAs: 'editLpController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(10/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(58);
                    $ocLazyLoad.load({
                        name: 'lessonPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewLessonPlan', {
        url: '/lessonPlan/viewLessonPlan/:lesson_id/:view',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(371).then((function () {
                var template = __webpack_require__(680);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'editLpController',
        controllerAs: 'editLpController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(10/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(58);
                    $ocLazyLoad.load({
                        name: 'lessonPlan'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('addLesson', {
        url: '/lessonPlan/addLesson',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(460).then((function () {
                var template = __webpack_require__(520);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'addLessonController',
        controllerAs: 'addLessonController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(14/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(93);
                    $ocLazyLoad.load({
                        name: 'addLesson'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('editHodLesson', {
        url: '/lessonPlan/editHodLesson/:lesson_id',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(459).then((function () {
                var template = __webpack_require__(521);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'editHodLessonController',
        controllerAs: 'editHodLessonController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(14/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(93);
                    $ocLazyLoad.load({
                        name: 'addLesson'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('addTeacherLesson', {
        url: '/lessonPlan/addTeacherLesson',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(44/* duplicate */).then((function () {
                var template = __webpack_require__(87);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'addTeacherLessonCrtl',
        controllerAs: 'addTeacherLessonCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(14/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(93);
                    $ocLazyLoad.load({
                        name: 'addLesson'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('editTeacherLesson', {
        url: '/lessonPlan/editTeacherLesson/:lesson_id',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(44/* duplicate */).then((function () {
                var template = __webpack_require__(87);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'addTeacherLessonCrtl',
        controllerAs: 'addTeacherLessonCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(14/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(93);
                    $ocLazyLoad.load({
                        name: 'addLesson'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examTmConsole', {
        url: '/exam-scheduler-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(166).then((function () {
                var template = __webpack_require__(522);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examTmConsole',
        controllerAs: 'examTmConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(85).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1501);
                    $ocLazyLoad.load({
                        name: 'examTmConsole'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examTmCreate', {
        url: '/exam-scheduler-form/:scheduler_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(401).then((function () {
                var template = __webpack_require__(523);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examTmCreate',
        controllerAs: 'examTmCreate',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(118).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1502);
                    $ocLazyLoad.load({
                        name: 'examTmCreate'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('quizApiMain', {
        url: '/user/quiz/main/:category',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(331).then((function () {
                var template = __webpack_require__(524);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'quizApiMain',
        controllerAs: 'quizApiMain',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(155).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1503);
                    $ocLazyLoad.load({
                        name: 'quizApiMain'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('quizPointSummary', {
        url: '/user/quiz/summary',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(330).then((function () {
                var template = __webpack_require__(459);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'quizPointSummary',
        controllerAs: 'quizPointSummary',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(153).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1504);
                    $ocLazyLoad.load({
                        name: 'quizPointSummary'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('quizDetailMain', {
        url: '/user/quiz/detail/:quiz_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(333).then((function () {
                var template = __webpack_require__(681);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'quizDetailMain',
        controllerAs: 'quizDetailMain',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(154).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1505);
                    $ocLazyLoad.load({
                        name: 'quizDetailMain'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('lastquizQuizDetail', {
        url: '/user/quiz/last/:quiz_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(332).then((function () {
                var template = __webpack_require__(525);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lastquizQuizDetail',
        controllerAs: 'lastquizQuizDetail',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(156).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1506);
                    $ocLazyLoad.load({
                        name: 'lastquizQuizDetail'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('gmail', {
        url: '/gmail',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(392).then((function () {
                var template = __webpack_require__(682);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'gmailCtrl',
        controllerAs: 'gmailCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(194).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1507);
                    $ocLazyLoad.load({
                        name: 'GmailModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('batchChange', {
        url: '/batch_change',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(432).then((function () {
                var template = __webpack_require__(683);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'batchChangeCtrl',
        controllerAs: 'batchChangeCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(178).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1508);
                    $ocLazyLoad.load({
                        name: 'BatchChangeModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('markEntrySheet', {
        url: '/mark_entry_sheet',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(112).then((function () {
                var template = __webpack_require__(684);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'MarkEntryCtrl',
        controllerAs: 'MarkEntryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(96).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1509);
                    $ocLazyLoad.load({
                        name: 'MarkEntry'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('messageMainModule', {
        url: '/messages-main',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(89).then((function () {
                var template = __webpack_require__(1510);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'messageMainModuleController',
        controllerAs: 'messageMainModuleController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(101).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(537);
                    $ocLazyLoad.load({
                        name: 'messageMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('messageHistory', {
        url: '/messages-history',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(102).then((function () {
                var template = __webpack_require__(1511);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'messageHisModuleController',
        controllerAs: 'messageHisModuleController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(192).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(538);
                    $ocLazyLoad.load({
                        name: 'messageHisModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activitypersstudentCtrl', {
        url: '/student/one-activity/:qp_id/:student_id/:page',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(442).then((function () {
                var template = __webpack_require__(685);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'activitypersstudentCtrl',
        controllerAs: 'activitypersstudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(224).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1512);
                    $ocLazyLoad.load({
                        name: 'activitypersstudentCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ActivitiesComparisonStudentWiseCtrl', {
        url: '/activity-comparison/student',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(181).then((function () {
                var template = __webpack_require__(1513);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ActivitiesComparisonStudentWiseCtrl',
        controllerAs: 'activitiesComparisonStudentWiseCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(225).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(539);
                    $ocLazyLoad.load({
                        name: 'ActivitiesComparisonStudentWiseCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ActivitiesComparisonBatchWiseCtrl', {
        url: '/activity-comparison/batch',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(182).then((function () {
                var template = __webpack_require__(1514);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ActivitiesComparisonBatchWiseCtrl',
        controllerAs: 'activitiesComparisonBatchWiseCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(226).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(540);
                    $ocLazyLoad.load({
                        name: 'ActivitiesComparisonBatchWiseCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportsScoresCtrl', {
        url: '/activity-report/scores/:qp_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(180).then((function () {
                var template = __webpack_require__(1515);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'reportsScoresCtrl',
        controllerAs: 'reportsScoresCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(223).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(541);
                    $ocLazyLoad.load({
                        name: 'reportsScoresCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('feedueList', {
        url: '/feedue-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(265).then((function () {
                var template = __webpack_require__(686);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'feedueList',
        controllerAs: 'feedueList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(196).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1516);
                    $ocLazyLoad.load({
                        name: 'FeedueListModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('eduConnect', {
        url: '/edu-connect',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(9/* duplicate */).then((function () {
                var template = __webpack_require__(1454);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'eduConnect',
        controllerAs: 'eduConnect',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(9/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(32);
                    $ocLazyLoad.load({
                        name: 'eduConnect'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('eduConnectMeet', {
        url: '/edu-connect-meet',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(46).then((function () {
                var template = __webpack_require__(1517);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'eduConnect',
        controllerAs: 'eduConnect',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(9/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(32);
                    $ocLazyLoad.load({
                        name: 'eduConnect'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('eduConnectMeetCreate', {
        url: '/create-meet',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(47).then((function () {
                var template = __webpack_require__(1518);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'eduConnect',
        controllerAs: 'eduConnect',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(9/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(32);
                    $ocLazyLoad.load({
                        name: 'eduConnect'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('eduConnectMeetList', {
        url: '/meet-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(45).then((function () {
                var template = __webpack_require__(1519);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'eduConnect',
        controllerAs: 'eduConnect',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(9/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(32);
                    $ocLazyLoad.load({
                        name: 'eduConnect'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activityApprovalsList', {
        url: '/activity-approvals-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(91).then((function () {
                var template = __webpack_require__(1520);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ActivityApprovalsList',
        controllerAs: 'activityApprovalsListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(201).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(542);
                    $ocLazyLoad.load({
                        name: 'ActivityApprovalsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activityReportViaLinkCtrl', {
        url: '/one-student/one-activity/:qp_id/:student_id/:page/:teacher_id/:parent_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(443).then((function () {
                var template = __webpack_require__(687);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'activityReportViaLinkCtrl',
        controllerAs: 'activityReportViaLinkCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(143).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1521);
                    $ocLazyLoad.load({
                        name: 'activityReportViaLinkCtrl'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('feeDueMessageConsole', {
        url: '/fee-due-msg-console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(399).then((function () {
                var template = __webpack_require__(688);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'FeeDueMessageConsole',
        controllerAs: 'feeDueMessageConsole',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(130).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1522);
                    $ocLazyLoad.load({
                        name: 'FeeDueMessageConsole'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('qpToOtherSchoolsController', {
        url: '/assign-qp-other-schools',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(338).then((function () {
                var template = __webpack_require__(689);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'qpToOtherSchoolsController',
        controllerAs: 'qpToOtherSchoolsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(36/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(690);
                    $ocLazyLoad.load({
                        name: 'qpToOtherSchoolsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('qpPreviewController', {
        url: '/qp-preview-page/:qpId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(339).then((function () {
                var template = __webpack_require__(691);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'qpPreviewController',
        controllerAs: 'qpPreviewController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(36/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(690);
                    $ocLazyLoad.load({
                        name: 'qpToOtherSchoolsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentEndorsementController', {
        url: '/student_endorsement/ct',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(149).then((function () {
                var template = __webpack_require__(692);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentEndorsementByCTController',
        controllerAs: 'usermgtStudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(148).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1523);
                    $ocLazyLoad.load({
                        name: 'teacherStudentEndorsement'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('endorsementByHosController', {
        url: '/teacher-endorse/by/hos',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(167).then((function () {
                var template = __webpack_require__(693);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'endorsementByHosController',
        controllerAs: 'userManagementDirectiveHOS',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(147).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1524);
                    $ocLazyLoad.load({
                        name: 'endorsementByHosModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewActivityAttendeesSheet', {
        url: '/view/activity-answer-sheet',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(287).then((function () {
                var template = __webpack_require__(694);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewActivityAttendeesSheetCtrl',
        controllerAs: 'viewActivityAttendeesSheetCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(202).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1525);
                    $ocLazyLoad.load({
                        name: 'viewActivityAttendeesSheetModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('loginViaLinkController', {
        url: '/one-student/shared-activity/:qp_id/:student_id/:page/:teacher_id/:parent_username/:parent_id/:school_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(260).then((function () {
                var template = __webpack_require__(695);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'loginViaLinkController',
        controllerAs: 'loginViaLinkController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(137).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1526);
                    $ocLazyLoad.load({
                        name: 'loginViaLinkController'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('answersheetPreview', {
        url: '/student-answer-sheet/:qpId/:studentId',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(78);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'answersheetPreview',
        controllerAs: 'answersheetPreview',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(437);
                    $ocLazyLoad.load({
                        name: 'answersheetPreview'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('CatfourMainController', {
        url: '/cat-4-main',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(270).then((function () {
                var template = __webpack_require__(696);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'CatfourMainController',
        controllerAs: 'CatfourMainController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(219).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1527);
                    $ocLazyLoad.load({
                        name: 'catfourMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ClassteacherCrudController', {
        url: '/cat-4-teacher-entry',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(418).then((function () {
                var template = __webpack_require__(697);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ClassteacherCrudController',
        controllerAs: 'ClassteacherCrudController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(215).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1528);
                    $ocLazyLoad.load({
                        name: 'ClassteacherCrudModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('entryByClassTeacherController', {
        url: '/class-story',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(425).then((function () {
                var template = __webpack_require__(698);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'entryByClassTeacherController',
        controllerAs: 'entryByClassTeacherController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(222).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1529);
                    $ocLazyLoad.load({
                        name: 'classStoryModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentclassStoryController', {
        url: '/student-class-story/:student_id/:report_console_id/:academic_year',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(413).then((function () {
                var template = __webpack_require__(699);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'studentclassStoryController',
        controllerAs: 'studentclassStoryController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(212).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1530);
                    $ocLazyLoad.load({
                        name: 'studentclassStoryModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('StudentScoreViewController', {
        url: '/asset-score/student-view/:student_id/:report_console_id/:subject_id/:selected_year',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(414).then((function () {
                var template = __webpack_require__(700);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'StudentScoreViewController',
        controllerAs: 'StudentScoreViewController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(176).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1531);
                    $ocLazyLoad.load({
                        name: 'studentScoreViewModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ClassStoryViewController', {
        url: '/view/class/story/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher/:is_authority/:selected_year',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(424).then((function () {
                var template = __webpack_require__(701);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ClassStoryViewController',
        controllerAs: 'ClassStoryViewController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(177).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1532);
                    $ocLazyLoad.load({
                        name: 'ClassStoryViewModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ClassStudentsController', {
        url: '/view/class/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(411).then((function () {
                var template = __webpack_require__(702);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ClassStudentsController',
        controllerAs: 'ClassStudentsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(122).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1533);
                    $ocLazyLoad.load({
                        name: 'ClassStudentsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ProcturedDocumentController', {
        url: '/view/activity/students/procturing',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            new Promise(function(resolve) { resolve(); }).then((function () {
                var template = __webpack_require__(77);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ProcturedDocumentController',
        controllerAs: 'ProcturedDocumentController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                new Promise(function(resolve) { resolve(); }).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(438);
                    $ocLazyLoad.load({
                        name: 'ProcturedDocumentController'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('hodHosClassStory', {
        url: '/view/class/story',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(417).then((function () {
                var template = __webpack_require__(703);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'hodHosClassStory',
        controllerAs: 'hodHosClassStory',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(213).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1534);
                    $ocLazyLoad.load({
                        name: 'hodHosClassStory'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classStoryRedefinedController', {
        url: '/class/story/eoy',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(419).then((function () {
                var template = __webpack_require__(704);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classStoryRedefinedController',
        controllerAs: 'classStoryRedefinedController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(216).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1535);
                    $ocLazyLoad.load({
                        name: 'classStoryRedefinedModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classStoryForMngrCtrl', {
        url: '/class/story/eoy/mngr',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(421).then((function () {
                var template = __webpack_require__(705);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classStoryForMngrCtrl',
        controllerAs: 'classStoryForMngrCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(218).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1536);
                    $ocLazyLoad.load({
                        name: 'classStoryForMngrModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classStoryPreYearUpdatesCtrl', {
        url: '/class/story/eoy/pre/year',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(420).then((function () {
                var template = __webpack_require__(706);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classStoryPreYearUpdatesCtrl',
        controllerAs: 'classStoryPreYearUpdatesCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(217).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1537);
                    $ocLazyLoad.load({
                        name: 'classStoryPreYearUpdatesModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attainmentReportAsset', {
        url: '/attainment-report/asset',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(423).then((function () {
                var template = __webpack_require__(707);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attainmentReportAsset',
        controllerAs: 'attainmentReportAsset',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(221).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1538);
                    $ocLazyLoad.load({
                        name: 'AttainmentReportAssetModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('attainmentReportInternalscore', {
        url: '/attainment-report/internal-score',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(422).then((function () {
                var template = __webpack_require__(708);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'attainmentReportInternalscore',
        controllerAs: 'attainmentReportInternalscore',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(220).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1539);
                    $ocLazyLoad.load({
                        name: 'AttainmentReportInternalscoreModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('PasswordResetCtrl', {
        url: '/password-reset',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(229).then((function () {
                var template = __webpack_require__(709);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'PasswordResetCtrl',
        controllerAs: 'PasswordResetCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(187).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1540);
                    $ocLazyLoad.load({
                        name: 'PasswordresetModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('BlockUsersCtrl', {
        url: '/utilities/block/users',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(288).then((function () {
                var template = __webpack_require__(710);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'BlockUsersCtrl',
        controllerAs: 'BlockUsersCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(144).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1541);
                    $ocLazyLoad.load({
                        name: 'BlockUsersModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('policyManagement', {
        url: '/school/policy/list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(324).then((function () {
                var template = __webpack_require__(711);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'policyManagement',
        controllerAs: 'policyManagement',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(23/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(180);
                    $ocLazyLoad.load({
                        name: 'schoolPolicyModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('schoolPolicyAddConttroller', {
        url: '/school/policy/add/:policy_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(325).then((function () {
                var template = __webpack_require__(712);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'schoolPolicyAddController',
        controllerAs: 'schoolPolicyAddController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(23/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(180);
                    $ocLazyLoad.load({
                        name: 'schoolPolicyModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('schoolPolicyViewController', {
        url: '/school/policy/view/:policy_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(323).then((function () {
                var template = __webpack_require__(713);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'schoolPolicyViewController',
        controllerAs: 'schoolPolicyViewController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(23/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(180);
                    $ocLazyLoad.load({
                        name: 'schoolPolicyModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('multipleReportsSelectionCtrl', {
        url: '/multiple-report-selection',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(351).then((function () {
                var template = __webpack_require__(714);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'multipleReportsSelectionCtrl',
        controllerAs: 'multipleReportsSelectionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(160).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1542);
                    $ocLazyLoad.load({
                        name: 'multipleReportCardModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('khdaMainModule', {
        url: '/khda-main',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(116).then((function () {
                var template = __webpack_require__(1543);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'khdaMainModule',
        controllerAs: 'khdaMainModule',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(142).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(543);
                    $ocLazyLoad.load({
                        name: 'khdaMainModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examReminder', {
        url: '/exam-reminder-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(61).then((function () {
                var template = __webpack_require__(1544);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examCalendarListModule',
        controllerAs: 'examCalendarListModule',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(30/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(89);
                    $ocLazyLoad.load({
                        name: 'examCalendarMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('examCalendarMainModule', {
        url: '/exam-reminder',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(66).then((function () {
                var template = __webpack_require__(1545);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'examCalendarMainModule',
        controllerAs: 'examCalendarMainModule',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(30/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(89);
                    $ocLazyLoad.load({
                        name: 'examCalendarMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('phaseModule', {
        url: '/khda-phase',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(115).then((function () {
                var template = __webpack_require__(1546);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

            return deferred.promise;
        }],
        controller: 'phaseModule',
        controllerAs: 'phaseModule',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(141).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(544);
                    $ocLazyLoad.load({
                        name: 'phaseModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('learningevaluationLearningWalk', {
        // url: '/learning/walk',
        // templateProvider: ['$q', function($q) {
        //     let deferred = $q.defer();
        //     require.ensure(['./app/learning_walk/views/learning_walkHtml.html'], function() {
        //         let template = require('./app/learning_walk/views/learning_walkHtml.html');
        //         deferred.resolve(template);
        //     });
        //     return deferred.promise;
        // }],
        // controller: 'learningwalkController',
        // controllerAs: 'learningwalkController',
        // resolve: {
        //     foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
        //         let deferred = $q.defer();
        //         require.ensure([], function() {
        //             let module = require('./app/learning_walk/learingModule.js');
        //             $ocLazyLoad.load({
        //                 name: 'learningModule',
        //                 // files: [
        //                 //     './app/learning_walk/views/learning_walkHtml.html'
        //                 // ]
        //             });
        //             deferred.resolve(module);
        //         });
        //         return deferred.promise;
        //     }]
        // }
        url: '/learningwalk/home',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(26/* duplicate */).then((function () {
                var template = __webpack_require__(49);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'learningWalkHome',
        controllerAs: 'learningWalkHome',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(12/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(24);
                    $ocLazyLoad.load({
                        name: "learningWalkModule"
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }

    }).state('learningevaluationLearningObservation', {
        url: '/lession/observation',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(376).then((function () {
                var template = __webpack_require__(715);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lessionController',
        controllerAs: 'lessionController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(15/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(94);
                    $ocLazyLoad.load({
                        name: 'lessionModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('lessonList', {
        url: '/lession/observation/list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(375).then((function () {
                var template = __webpack_require__(716);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lessionControllerList',
        controllerAs: 'lessionControllerList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(15/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(94);
                    $ocLazyLoad.load({
                        name: 'lessionModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('lessonView', {
        url: '/lession/observation/view/:_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(374).then((function () {
                var template = __webpack_require__(717);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lessionControllerView',
        controllerAs: 'lessionControllerView',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(15/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(94);
                    $ocLazyLoad.load({
                        name: 'lessionModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('learningList', {
        url: '/learning/walk/list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(379).then((function () {
                var template = __webpack_require__(718);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'learningControllerList',
        controllerAs: 'learningControllerList',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(33/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(719);
                    $ocLazyLoad.load({
                        name: 'learningModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('learningView', {
        url: '/learning/walk/view/:_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(378).then((function () {
                var template = __webpack_require__(720);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'learningControllerView',
        controllerAs: 'learningControllerView',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(33/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(719);
                    $ocLazyLoad.load({
                        name: 'learningModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('finalConsolidatedController', {
        url: '/final/Consolidated/sheets',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(268).then((function () {
                var template = __webpack_require__(721);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'finalConsolidatedController',
        controllerAs: 'finalConsolidatedController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(171).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1547);
                    $ocLazyLoad.load({
                        name: 'consolidatedSheetsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('BenchmarkUtilitiesMain', {
        url: '/benchmark-utilities',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(271).then((function () {
                var template = __webpack_require__(722);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkUtilitiesMainController',
        controllerAs: 'benchmarkUtilitiesMainController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('BenchmarkBatchChangeCtrl', {
        url: '/benchmark-utilities-batchchange',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(429).then((function () {
                var template = __webpack_require__(723);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkBatchChangeCtrl',
        controllerAs: 'benchmarkBatchChangeCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('benchmarkNewStudentCtrl', {
        url: '/benchmark-utilities-new-students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(273).then((function () {
                var template = __webpack_require__(724);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkNewStudentCtrl',
        controllerAs: 'benchmarkNewStudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('benchmarkStatusChangeCtrl', {
        url: '/benchmark-utilities-students-status',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(272).then((function () {
                var template = __webpack_require__(725);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkStatusChangeCtrl',
        controllerAs: 'benchmarkStatusChangeCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('benchmarkNewAcdStudentCtrl', {
        url: '/benchmark-utilities-new-acd-students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(274).then((function () {
                var template = __webpack_require__(726);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkNewAcdStudentCtrl',
        controllerAs: 'benchmarkNewAcdStudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('academicYearTransitionCtrl', {
        url: '/academic-year-transition',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(431).then((function () {
                var template = __webpack_require__(727);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'academicYearTransitionCtrl',
        controllerAs: 'academicYearTransitionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('benchmarkAssessmentUploadCtrl', {
        url: '/benchmark-assessment-upload',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(430).then((function () {
                var template = __webpack_require__(728);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkAssessmentUploadCtrl',
        controllerAs: 'benchmarkAssessmentUploadCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('benchmarkUploadHistoryCtrl', {
        url: '/benchmark-assessment-upload-history',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(428).then((function () {
                var template = __webpack_require__(729);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'benchmarkUploadHistoryCtrl',
        controllerAs: 'benchmarkUploadHistoryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(33);
                    $ocLazyLoad.load({
                        name: 'benchmarkUtilitiesMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('ClassparentsController', {
        url: '/view/class/parents/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(269).then((function () {
                var template = __webpack_require__(730);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ClassparentsController',
        controllerAs: 'ClassparentsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(211).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1548);
                    $ocLazyLoad.load({
                        name: 'ClassparentsModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('evaluationSubmissions', {
        url: '/teacherevaluation',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(232).then((function () {
                var template = __webpack_require__(731);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'loSubmissionsCtrl',
        controllerAs: 'loSubmissionsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(11/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(59);
                    $ocLazyLoad.load({
                        name: 'teacherEvaluationMainModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('analysisCtrl', {
        url: '/evaluation/analysis/:teacher_id/:eval_type/:year',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(105).then((function () {
                var template = __webpack_require__(732);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'analysisCtrl',
        controllerAs: 'analysisCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(11/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(59);
                    $ocLazyLoad.load({
                        name: 'teacherEvaluationMainModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('AdmitcardController', {
        // url: '/view/admitcard/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic/:is_class_teacher',
        url: '/view/admitcard/students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(458).then((function () {
                var template = __webpack_require__(733);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AdmitcardController',
        controllerAs: 'AdmitcardController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(41/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(734);
                    $ocLazyLoad.load({
                        name: 'AdmitcardModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('AdmitcardList', {
        url: '/view/admitcard/list/:admitcardid/:session_id/:curriculum_id/:class_id/:batch_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(285).then((function () {
                var template = __webpack_require__(1550);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AdmitcardController',
        controllerAs: 'AdmitcardController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(41/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(734);
                    $ocLazyLoad.load({
                        name: 'AdmitcardModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('GreetingsController', {
        url: '/view/Greetings/students/:session_id/:curriculum_id/:class_id/:batch_id/:academic',
        // url: '/view/Greetings/students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(164).then((function () {
                var template = __webpack_require__(735);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'GreetingsController',
        controllerAs: 'GreetingsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(40/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(736);
                    $ocLazyLoad.load({
                        name: 'GreetingsModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('greetingsView', {
        url: '/greetings_list',
        // url: '/view/Greetings/students',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(391).then((function () {
                var template = __webpack_require__(737);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'GreetingsController',
        controllerAs: 'GreetingsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(40/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(736);
                    $ocLazyLoad.load({
                        name: 'GreetingsModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('documentController', {
        url: '/ext/assessment/documents',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(402).then((function () {
                var template = __webpack_require__(738);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'documentController',
        controllerAs: 'documentController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(119).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1551);
                    $ocLazyLoad.load({
                        name: 'documentModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('khdaAttendanceController', {
        url: '/khda/attendance',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(380).then((function () {
                var template = __webpack_require__(739);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'khdaAttendanceController',
        controllerAs: 'khdaAttendanceController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(140).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1552);
                    $ocLazyLoad.load({
                        name: 'khdaAttModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('khdaReportController', {
        url: '/khda/report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(381).then((function () {
                var template = __webpack_require__(740);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'khdaReportController',
        controllerAs: 'khdaReportController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(63).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1553);
                    $ocLazyLoad.load({
                        name: 'khdareportModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('phaseWiseAtt', {
        url: '/phasewise-attendence-report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(86).then((function () {
                var template = __webpack_require__(507);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'phaseWiseAtt',
        controllerAs: 'phaseWiseAtt',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(5/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {

                    var module = __webpack_require__(47);
                    $ocLazyLoad.load({
                        name: 'DashboardReport'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('studentInfoController', {
        url: '/student-information/:student_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(64).then((function () {
                var template = __webpack_require__(526);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'StudentInfoController',
        controllerAs: 'studentInfoController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(54).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1554);
                    $ocLazyLoad.load({
                        name: 'studentInfoMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('syllabus', {
        url: '/syllabus-management',
        views: {
            '@': {
                templateProvider: ['$q', function ($q) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(92).then((function () {
                        var template = __webpack_require__(741);
                        deferred.resolve(template);
                    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }],
                controller: "syllabusCtrl",
                controllerAs: 'syllabus'
            }
        },
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(128).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1555);
                    $ocLazyLoad.load({
                        name: 'syllabusModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);

                return deferred.promise;
            }]
        }
    }).state('aflReportListCtrl', {
        url: '/afl/list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(50).then((function () {
                var template = __webpack_require__(742);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'aflReportListCtrl',
        controllerAs: 'aflReportListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(227).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1556);
                    $ocLazyLoad.load({
                        name: 'aflreportModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('AflViewMainCtrl', {
        url: '/afl/class/:qp_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(456).then((function () {
                var template = __webpack_require__(743);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'AflViewMainCtrl',
        controllerAs: 'AflViewMainCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(37/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(744);
                    $ocLazyLoad.load({
                        name: 'aflViewMainComponent'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('aflStudentCtrl', {
        url: '/afl/student/:student_id/:qp_id/:page',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(455).then((function () {
                var template = __webpack_require__(527);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'aflStudentCtrl',
        controllerAs: 'aflStudentCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(37/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(744);
                    $ocLazyLoad.load({
                        name: 'aflViewMainComponent'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('sodStudentsReports', {
        url: '/sod/report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(233).then((function () {
                var template = __webpack_require__(746);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'sodReportListCtrl',
        controllerAs: 'sodReportListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(150).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1557);
                    $ocLazyLoad.load({
                        name: 'sodModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('arabiclevelreport', {
        url: '/arabic/report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(284).then((function () {
                var template = __webpack_require__(747);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'arabicReportListCtrl',
        controllerAs: 'arabicReportListCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(184).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1558);
                    $ocLazyLoad.load({
                        name: 'arabicModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('gridView', {
        url: '/learnngTracker/view/:ref_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(263).then((function () {
                var template = __webpack_require__(528);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'learningTrackerCrctl',
        controllerAs: 'learningTrackerCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(29/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(748);
                    $ocLazyLoad.load({
                        name: 'learningTracker'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('learningOutcomeTracker', {
        url: '/learningTracker',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(84).then((function () {
                var template = __webpack_require__(529);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'gridViewCrctl',
        controllerAs: 'gridViewCrctl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(29/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(748);
                    $ocLazyLoad.load({
                        name: 'learningTracker'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('prevReportEditCtrl', {
        url: '/prev-report-edit/:publish',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(75).then((function () {
                var template = __webpack_require__(749);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'prevReportEditCtrl',
        controllerAs: 'prevReportEditCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(204).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1559);
                    $ocLazyLoad.load({
                        name: 'prevReportEditModule'

                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportCardPendingListing', {
        url: '/report-card-pending-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(329).then((function () {
                var template = __webpack_require__(750);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ReportCardPendingListingCtrl',
        controllerAs: 'ReportCardPendingListingCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(60).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1560);
                    $ocLazyLoad.load({
                        name: 'ReportCardPendingListsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportCardPendingListingTeacher', {
        url: '/report-card-pending-list-teacher/:class_id/:class_name',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(152).then((function () {
                var template = __webpack_require__(751);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'ReportCardPendingTeacherListingCtrl',
        controllerAs: 'ReportCardPendingTeacherListingCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(59).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1561);
                    $ocLazyLoad.load({
                        name: 'ReportCardPendingTeacherListsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('reportCardPendingListingTable', {
        url: '/report-card-pending-list-table',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(266).then((function () {
                var template = __webpack_require__(470);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'DashBoardController',
        controllerAs: 'test',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(27/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(545);
                    $ocLazyLoad.load({
                        name: 'app.DashBoardModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('activityExportCtrl', {
        url: '/activity-list-export',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(52).then((function () {
                var template = __webpack_require__(752);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'activityExportCtrl',
        controllerAs: 'activityExportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(228).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1562);
                    $ocLazyLoad.load({
                        name: 'activityExportModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('schedulelo', {
        url: '/schedule/lo',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(308).then((function () {
                var template = __webpack_require__(753);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'lo_scheduleCrtl',
        controllerAs: 'lo_scheduleCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(11/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(59);
                    $ocLazyLoad.load({
                        name: 'teacherEvaluationMainModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('createLearningWalk', {
        // url: '/learning/walk/create',
        // templateProvider: ['$q', function($q) {
        //     let deferred = $q.defer();
        //     require.ensure(['./app/learning_walk/views/createLearningWalk.html'], function() {
        //         let template = require('./app/learning_walk/views/createLearningWalk.html');
        //         deferred.resolve(template);
        //     });
        //     return deferred.promise;
        // }],
        // controller: 'createLearningWalk', // no:1
        // controllerAs: 'createLearningWalk',
        // resolve: {
        //     foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
        //         let deferred = $q.defer();
        //         require.ensure([], function() {
        //             let module = require('./app/learning_walk/learingModule.js');
        //             $ocLazyLoad.load({
        //                 name: 'learningModule',
        //                 // files: [
        //                 //     './app/learning_walk/views/learning_walkHtml.html'
        //                 // ]
        //             });
        //             deferred.resolve(module);
        //         });
        //         return deferred.promise;
        //     }]
        // }
        url: '/learningwalk/home',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(26/* duplicate */).then((function () {
                var template = __webpack_require__(49);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'learningWalkHome',
        controllerAs: 'learningWalkHome',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(12/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(24);
                    $ocLazyLoad.load({
                        name: "learningWalkModule"
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }
    }).state('createLessonObservation', {
        url: '/lesson/observation/create/:lo_id?',
        params: {
            lo_id: { value: null, squash: true // squash removes it from URL if null/undefined
            } },
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(261).then((function () {
                var template = __webpack_require__(754);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'createLessonObservation',
        controllerAs: 'createLessonObservation',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(15/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(94);
                    $ocLazyLoad.load({
                        name: 'lessionModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('timeTablePreview', {
        url: '/schedule/lo/timeTablePreview/:teacher_id/:teacher_name',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(231).then((function () {
                var template = __webpack_require__(755);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'timeTablePreview',
        controllerAs: 'timeTablePreview',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(11/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(59);
                    $ocLazyLoad.load({
                        name: 'teacherEvaluationMainModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('scheduledLoHistory', {
        url: '/schedule/lo/history',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(307).then((function () {
                var template = __webpack_require__(756);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'scheduledHistory',
        controllerAs: 'scheduledHistory',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(11/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(59);
                    $ocLazyLoad.load({
                        name: 'teacherEvaluationMainModule'
                        // files: [
                        //     './app/learning_walk/views/learning_walkHtml.html'
                        // ]
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('pdpCreateCtrl', {
        url: '/pdp/main',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(42/* duplicate */).then((function () {
                var template = __webpack_require__(95);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'pdpMainCtrl',
        controllerAs: 'pdpMainCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(13/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(60);
                    $ocLazyLoad.load({
                        name: 'pdpModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('schemeofwork', {
        url: "/schemeofwork/home",
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(81).then((function () {
                var template = __webpack_require__(530);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: "homePageController",
        controllerAs: "homePageController",
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(68).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1563);
                    $ocLazyLoad.load({
                        name: 'schemeOfWorkModule'
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }
    }).state('learningwalk', { //no:2
        url: '/learningwalk/home',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(26/* duplicate */).then((function () {
                var template = __webpack_require__(49);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'learningWalkHome',
        controllerAs: 'learningWalkHome',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(12/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(24);
                    $ocLazyLoad.load({
                        name: "learningWalkModule"
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }
    }).state('learningwalkcreate', {
        url: '/learningwalk/create/:lw_id?',
        params: {
            lw_id: { value: null, squash: true // squash removes it from URL if null/undefined
            } },
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(347).then((function () {
                var template = __webpack_require__(757);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'learningWalkCrtl',
        controllerAs: 'learningWalkCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(12/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(24);
                    $ocLazyLoad.load({
                        name: "learningWalkModule"
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }
    }).state('learningwalkview', {
        url: '/learningwalk/view/:lw_id',
        templateProvider: ['$q', function ($q) {
            var deffered = $q.defer();
            __webpack_require__.e/* require.ensure */(346).then((function () {
                var template = __webpack_require__(758);
                deffered.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deffered.promise;
        }],
        controller: 'learningWalkView',
        controllerAs: 'learningWalkView',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deffered = $q.defer();
                __webpack_require__.e/* require.ensure */(12/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(24);
                    $ocLazyLoad.load({
                        name: "learningWalkModule"
                    });
                    deffered.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deffered.promise;
            }]
        }
    }).state('pdpMainCtrl', {
        url: '/pdp/home',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(39/* duplicate */).then((function () {
                var template = __webpack_require__(96);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'homeCrctl',
        controllerAs: 'homeCrctl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(13/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(60);
                    $ocLazyLoad.load({
                        name: 'pdpModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('pdpTeacherView', {
        url: '/pdp/home/:teacher_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(39/* duplicate */).then((function () {
                var template = __webpack_require__(96);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'homeCrctl',
        controllerAs: 'homeCrctl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(13/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(60);
                    $ocLazyLoad.load({
                        name: 'pdpModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('editpdp', {
        url: '/pdp/edit/:pdp_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(42/* duplicate */).then((function () {
                var template = __webpack_require__(95);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'pdpMainCtrl',
        controllerAs: 'pdpMainCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(13/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(60);
                    $ocLazyLoad.load({
                        name: 'pdpModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewpdp', {
        url: '/pdp/view/:pdp_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(341).then((function () {
                var template = __webpack_require__(759);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'pdpViewCtrl',
        controllerAs: 'pdpViewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(13/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(60);
                    $ocLazyLoad.load({
                        name: 'pdpModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('pdpV2ViewCtrl', {
        url: '/pdp-v2/view/:pdp_id',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(340).then((function () {
                var template = __webpack_require__(760);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'pdpV2ViewCtrl',
        controllerAs: 'pdpV2ViewCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(205).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1564);
                    $ocLazyLoad.load({
                        name: 'pdpV2Module'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state("principalQaurterlyReport", {
        url: '/principal/quarterly/report',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(336).then((function () {
                var template = __webpack_require__(761);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'principalReportCrtl',
        controllerAs: 'principalReportCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(18/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(97);
                    $ocLazyLoad.load({
                        name: 'quarterlyDataModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('principal_synopsis', {
        url: '/quarterlyreport/data/entry/principal_synopsis',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(335).then((function () {
                var template = __webpack_require__(762);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'principalSynopsisCrtl',
        controllerAs: 'principalSynopsisCrtl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(18/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(97);
                    $ocLazyLoad.load({
                        name: 'quarterlyDataModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('previous_reports', {
        url: '/quarterlyreport/previous_reports',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(254).then((function () {
                var template = __webpack_require__(763);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'previous_reports',
        controllerAs: 'previous_reports',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(18/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(97);
                    $ocLazyLoad.load({
                        name: 'quarterlyDataModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('rEutilsCtrls', {
        url: '/markentry/consolidated/view',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(365).then((function () {
                var template = __webpack_require__(764);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'rEutilsCtrl',
        controllerAs: 'rEutilsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('markEntryMonitorCtrls', {
        url: '/markentry/monitor/view',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(366).then((function () {
                var template = __webpack_require__(765);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'markEntryMonitorCtrl',
        controllerAs: 'markEntryMonitorCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('hodReCtrl', {
        url: '/markentry/hod/view',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(367).then((function () {
                var template = __webpack_require__(766);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'hodReCtrl',
        controllerAs: 'hodReCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classTeacherReCtrl', {
        url: '/markentry/ct/view',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(368).then((function () {
                var template = __webpack_require__(767);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classTeacherReCtrl',
        controllerAs: 'classTeacherReCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('scriptingCtrl', {
        url: '/script/run',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(320).then((function () {
                var template = __webpack_require__(768);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'scriptingCtrl',
        controllerAs: 'scriptingCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(16/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(98);
                    $ocLazyLoad.load({
                        name: 'scriptingModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('SelectionCtrl', {
        url: '/script/selections',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(106).then((function () {
                var template = __webpack_require__(769);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'SelectionCtrl',
        controllerAs: 'SelectionCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(16/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(98);
                    $ocLazyLoad.load({
                        name: 'scriptingModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('listSheetsCtrl', {
        url: '/script/listSheets',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(321).then((function () {
                var template = __webpack_require__(770);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'listSheetsCtrl',
        controllerAs: 'listSheetsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(16/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(98);
                    $ocLazyLoad.load({
                        name: 'scriptingModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('duplicateMarksheet', {
        url: '/scripts/duplicate-marksheet',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(322).then((function () {
                var template = __webpack_require__(771);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'DuplicateMarksheetCtrl',
        controllerAs: 'duplicateMarksheetCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(16/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(98);
                    $ocLazyLoad.load({
                        name: 'scriptingModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('listMarkentryCtrl', {
        url: '/markentry/hod/view/list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(162).then((function () {
                var template = __webpack_require__(772);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'listMarkentryCtrl',
        controllerAs: 'listMarkentryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('TransferredStudents', {
        url: '/transferred-students-list',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(230).then((function () {
                var template = __webpack_require__(773);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'transferred_listCtrl',
        controllerAs: 'transferred_listCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(188).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1565);
                    $ocLazyLoad.load({
                        name: 'TransferredStudentsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classStoryColumnCtrl', {
        url: '/class/story/column',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(175).then((function () {
                var template = __webpack_require__(774);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classStoryColumnCtrl',
        controllerAs: 'classStoryColumnCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(133).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1566);
                    $ocLazyLoad.load({
                        name: 'classStoryColumnModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('CsconsoleSettingCtrl', {
        url: '/set-column-catfour',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(416).then((function () {
                var template = __webpack_require__(775);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'setColumn',
        controllerAs: 'setColumn',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(174).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1567);
                    $ocLazyLoad.load({
                        name: 'setColumn'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('CsconsoleSettingTeacherCtrl', {
        url: '/set-column-catfour-teacher',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(415).then((function () {
                var template = __webpack_require__(776);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'setColumnTeacher',
        controllerAs: 'setColumnTeacher',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(214).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1568);
                    $ocLazyLoad.load({
                        name: 'setColumnTeacher'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('questionPaperCtrl', {
        url: '/question-paper',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(76).then((function () {
                var template = __webpack_require__(777);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'questionPaperCtrl',
        controllerAs: 'questionPaperCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(158).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1569);
                    $ocLazyLoad.load({
                        name: 'questionPaperModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('questionPaperTeacherCtrl', {
        url: '/teacher-question-paper',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(82).then((function () {
                var template = __webpack_require__(778);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'questionPaperTeacherCtrl',
        controllerAs: 'questionPaperTeacherCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(157).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1570);
                    $ocLazyLoad.load({
                        name: 'teacherQuestionPaperModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    })

    // /home/cordova/projects/dubai live/bm-client_2/educore_3.5/client/src/app/holistic_reports
    .state('holisticReportsCtrl', {
        url: '/holistic-reports',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(390).then((function () {
                var template = __webpack_require__(779);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'holisticReportsCtrl',
        controllerAs: 'holisticReportsCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(209).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1571);
                    $ocLazyLoad.load({
                        name: 'holisticreportsmodule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('classTeacherReportCtrl', {
        url: '/markentry/exams/report/view',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(113).then((function () {
                var template = __webpack_require__(780);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'classTeacherReportCtrl',
        controllerAs: 'classTeacherReportCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(8/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(50);
                    $ocLazyLoad.load({
                        name: 'rEutilsModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('qpPrincipalCtrl', {
        url: '/principal-question-paper',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(77).then((function () {
                var template = __webpack_require__(781);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'qpPrincipalCtrl',
        controllerAs: 'qpPrincipalCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(71).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1572);
                    $ocLazyLoad.load({
                        name: 'qpPrincipalModule'
                    });

                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('viewqpPrincipalCtrl', {
        url: '/view-question-papers',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(337).then((function () {
                var template = __webpack_require__(782);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'viewqpPrincipalCtrl',
        controllerAs: 'viewqpPrincipalCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(70).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1573);
                    $ocLazyLoad.load({
                        name: 'viewqpModule'
                    });

                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('HpcMainController', {

        url: '/hpc/home',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(117).then((function () {
                var template = __webpack_require__(783);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HpcMainController',
        controllerAs: 'HpcMainController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('HpcConsoleController', {
        url: '/hpc/console',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(389).then((function () {
                var template = __webpack_require__(785);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HpcConsoleController',
        controllerAs: 'HpcConsoleController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('HpcMarkEntryController', {
        url: '/hpc/mark-entry',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(387).then((function () {
                var template = __webpack_require__(786);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HpcMarkEntryController',
        controllerAs: 'HpcMarkEntryController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('HpcReportsController', {
        url: '/hpc/reports',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(388).then((function () {
                var template = __webpack_require__(787);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HpcReportsController',
        controllerAs: 'HpcReportsController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('MultipleMarkEntryCtrl', {
        url: '/hpc/multiple/selections',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(386).then((function () {
                var template = __webpack_require__(788);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'MultipleMarkEntryCtrl',
        controllerAs: 'MultipleMarkEntryCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('HpcSheetController', {
        url: '/hpc/sheets',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(384).then((function () {
                var template = __webpack_require__(789);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HpcSheetController',
        controllerAs: 'HpcSheetController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('publishHpcController', {
        url: '/hpc/publish',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(385).then((function () {
                var template = __webpack_require__(790);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'publishHpcController',
        controllerAs: 'publishHpcController',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(3/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(38);
                    $ocLazyLoad.load({
                        name: 'hpcMainModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    })

    //newly added for the advertisement.

    .state('advertisementCtrl', {

        url: '/advertisements',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(457).then((function () {
                var template = __webpack_require__(791);

                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'advertisementCtrl',
        controllerAs: 'advertisementCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(185).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(1574);
                    $ocLazyLoad.load({
                        name: 'advertisementModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('behaviour_data_entry', {
        url: '/stdprofile/behaviourscreen',
        parent: 'app',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(311).then((function () {
                var template = __webpack_require__(792);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'BehaviourScreenController',
        controllerAs: 'behaviourScreenCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(22/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(181);
                    $ocLazyLoad.load({
                        name: 'studentProfilerModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('inclusion_sen_data_entry', {
        url: '/stdprofile/inclusionSen',
        parent: 'app',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(309).then((function () {
                var template = __webpack_require__(794);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'InclusionSenController',
        controllerAs: 'inclusionSenCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(22/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(181);
                    $ocLazyLoad.load({
                        name: 'studentProfilerModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    }).state('happines_data_entry', {
        url: '/stdprofile/happinessDepartment',
        parent: 'app',
        templateProvider: ['$q', function ($q) {
            var deferred = $q.defer();
            __webpack_require__.e/* require.ensure */(310).then((function () {
                var template = __webpack_require__(795);
                deferred.resolve(template);
            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
            return deferred.promise;
        }],
        controller: 'HappinessDepartmentController',
        controllerAs: 'happinessCtrl',
        resolve: {
            foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(22/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                    var module = __webpack_require__(181);
                    $ocLazyLoad.load({
                        name: 'studentProfilerModule'
                    });
                    deferred.resolve(module);
                
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }]
        }
    });
    // .state('selectTeachers',{
    //     url: '/exampaper/select/teachers',
    //     templateProvider: ['$q', function($q) {
    //         let deferred = $q.defer();
    //         require.ensure(['./app/exampaper_selection/views/selectTeachers.html'], function() {
    //             let template = require('./app/exampaper_selection/views/selectTeachers.html');
    //             deferred.resolve(template);
    //         });
    //         return deferred.promise;
    //     }],
    //     controller: 'selectTeacherCrtl',
    //     controllerAs: 'selectTeacherCrtl',
    //     resolve: {
    //         foo: ['$q', '$ocLazyLoad', function($q, $ocLazyLoad) {
    //             let deferred = $q.defer();
    //             require.ensure([], function() {
    //                 let module = require('./app/exampaper_selection/exampaperModule');
    //                 $ocLazyLoad.load({
    //                     name: 'exampaperModule',
    //                 });
    //                 deferred.resolve(module);
    //             });
    //             return deferred.promise;
    //         }]
    //     }
    // })
    // Add new states above this loop
    stateArray.forEach(function (stateObj) {
        $stateProvider.state(stateObj._id, {
            url: '/quarterlyreport/data/entry/:type',
            templateProvider: ['$q', function ($q) {
                var deferred = $q.defer();
                __webpack_require__.e/* require.ensure */(334).then((function () {
                    var template = __webpack_require__(796);
                    deferred.resolve(template);
                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                return deferred.promise;
            }],
            controller: 'viewController',
            controllerAs: 'viewController',
            resolve: {
                foo: ['$q', '$ocLazyLoad', function ($q, $ocLazyLoad) {
                    var deferred = $q.defer();
                    __webpack_require__.e/* require.ensure */(18/* duplicate */).then((function () {/* WEBPACK VAR INJECTION */(function(module) {
                        var module = __webpack_require__(97);
                        $ocLazyLoad.load({
                            name: 'quarterlyDataModule'
                        });
                        deferred.resolve(module);
                    
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(0)(module)))}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                    return deferred.promise;
                }]
            }
        });
    });
}]);

/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Module dependencies.
 */

var parseuri = __webpack_require__(223);
var debug = __webpack_require__(71)('socket.io-client:url');

/**
 * Module exports.
 */

module.exports = url;

/**
 * URL parser.
 *
 * @param {String} url
 * @param {Object} An object meant to mimic window.location.
 *                 Defaults to window.location.
 * @api public
 */

function url (uri, loc) {
  var obj = uri;

  // default to window.location
  loc = loc || (typeof location !== 'undefined' && location);
  if (null == uri) uri = loc.protocol + '//' + loc.host;

  // relative path support
  if ('string' === typeof uri) {
    if ('/' === uri.charAt(0)) {
      if ('/' === uri.charAt(1)) {
        uri = loc.protocol + uri;
      } else {
        uri = loc.host + uri;
      }
    }

    if (!/^(https?|wss?):\/\//.test(uri)) {
      debug('protocol-less url %s', uri);
      if ('undefined' !== typeof loc) {
        uri = loc.protocol + '//' + uri;
      } else {
        uri = 'https://' + uri;
      }
    }

    // parse
    debug('parse %s', uri);
    obj = parseuri(uri);
  }

  // make sure we treat `localhost:80` and `localhost` equally
  if (!obj.port) {
    if (/^(http|ws)$/.test(obj.protocol)) {
      obj.port = '80';
    } else if (/^(http|ws)s$/.test(obj.protocol)) {
      obj.port = '443';
    }
  }

  obj.path = obj.path || '/';

  var ipv6 = obj.host.indexOf(':') !== -1;
  var host = ipv6 ? '[' + obj.host + ']' : obj.host;

  // define unique id
  obj.id = obj.protocol + '://' + host + ':' + obj.port;
  // define href
  obj.href = obj.protocol + '://' + host + (loc && loc.port === obj.port ? '' : (':' + obj.port));

  return obj;
}


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(85);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(865);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  '#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC',
  '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF',
  '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC',
  '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF',
  '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC',
  '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033',
  '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366',
  '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933',
  '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC',
  '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF',
  '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // Internet Explorer and Edge do not support colors.
  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(85);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

/*global Blob,File*/

/**
 * Module requirements
 */

var isArray = __webpack_require__(224);
var isBuf = __webpack_require__(225);
var toString = Object.prototype.toString;
var withNativeBlob = typeof Blob === 'function' || (typeof Blob !== 'undefined' && toString.call(Blob) === '[object BlobConstructor]');
var withNativeFile = typeof File === 'function' || (typeof File !== 'undefined' && toString.call(File) === '[object FileConstructor]');

/**
 * Replaces every Buffer | ArrayBuffer in packet with a numbered placeholder.
 * Anything with blobs or files should be fed through removeBlobs before coming
 * here.
 *
 * @param {Object} packet - socket.io event packet
 * @return {Object} with deconstructed packet and list of buffers
 * @api public
 */

exports.deconstructPacket = function(packet) {
  var buffers = [];
  var packetData = packet.data;
  var pack = packet;
  pack.data = _deconstructPacket(packetData, buffers);
  pack.attachments = buffers.length; // number of binary 'attachments'
  return {packet: pack, buffers: buffers};
};

function _deconstructPacket(data, buffers) {
  if (!data) return data;

  if (isBuf(data)) {
    var placeholder = { _placeholder: true, num: buffers.length };
    buffers.push(data);
    return placeholder;
  } else if (isArray(data)) {
    var newData = new Array(data.length);
    for (var i = 0; i < data.length; i++) {
      newData[i] = _deconstructPacket(data[i], buffers);
    }
    return newData;
  } else if (typeof data === 'object' && !(data instanceof Date)) {
    var newData = {};
    for (var key in data) {
      newData[key] = _deconstructPacket(data[key], buffers);
    }
    return newData;
  }
  return data;
}

/**
 * Reconstructs a binary packet from its placeholder packet and buffers
 *
 * @param {Object} packet - event packet with placeholders
 * @param {Array} buffers - binary buffers to put in placeholder positions
 * @return {Object} reconstructed packet
 * @api public
 */

exports.reconstructPacket = function(packet, buffers) {
  packet.data = _reconstructPacket(packet.data, buffers);
  packet.attachments = undefined; // no longer useful
  return packet;
};

function _reconstructPacket(data, buffers) {
  if (!data) return data;

  if (data && data._placeholder) {
    return buffers[data.num]; // appropriate buffer (should be natural order anyway)
  } else if (isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      data[i] = _reconstructPacket(data[i], buffers);
    }
  } else if (typeof data === 'object') {
    for (var key in data) {
      data[key] = _reconstructPacket(data[key], buffers);
    }
  }

  return data;
}

/**
 * Asynchronously removes Blobs or Files from data via
 * FileReader's readAsArrayBuffer method. Used before encoding
 * data as msgpack. Calls callback with the blobless data.
 *
 * @param {Object} data
 * @param {Function} callback
 * @api private
 */

exports.removeBlobs = function(data, callback) {
  function _removeBlobs(obj, curKey, containingObject) {
    if (!obj) return obj;

    // convert any blob
    if ((withNativeBlob && obj instanceof Blob) ||
        (withNativeFile && obj instanceof File)) {
      pendingBlobs++;

      // async filereader
      var fileReader = new FileReader();
      fileReader.onload = function() { // this.result == arraybuffer
        if (containingObject) {
          containingObject[curKey] = this.result;
        }
        else {
          bloblessData = this.result;
        }

        // if nothing pending its callback time
        if(! --pendingBlobs) {
          callback(bloblessData);
        }
      };

      fileReader.readAsArrayBuffer(obj); // blob -> arraybuffer
    } else if (isArray(obj)) { // handle array
      for (var i = 0; i < obj.length; i++) {
        _removeBlobs(obj[i], i, obj);
      }
    } else if (typeof obj === 'object' && !isBuf(obj)) { // and object
      for (var key in obj) {
        _removeBlobs(obj[key], key, obj);
      }
    }
  }

  var pendingBlobs = 0;
  var bloblessData = data;
  _removeBlobs(bloblessData);
  if (!pendingBlobs) {
    callback(bloblessData);
  }
};


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 868 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 869 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


module.exports = __webpack_require__(871);

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = __webpack_require__(45);


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

var transports = __webpack_require__(227);
var Emitter = __webpack_require__(44);
var debug = __webpack_require__(74)('engine.io-client:socket');
var index = __webpack_require__(167);
var parser = __webpack_require__(45);
var parseuri = __webpack_require__(223);
var parseqs = __webpack_require__(72);

/**
 * Module exports.
 */

module.exports = Socket;

/**
 * Socket constructor.
 *
 * @param {String|Object} uri or options
 * @param {Object} options
 * @api public
 */

function Socket (uri, opts) {
  if (!(this instanceof Socket)) return new Socket(uri, opts);

  opts = opts || {};

  if (uri && 'object' === typeof uri) {
    opts = uri;
    uri = null;
  }

  if (uri) {
    uri = parseuri(uri);
    opts.hostname = uri.host;
    opts.secure = uri.protocol === 'https' || uri.protocol === 'wss';
    opts.port = uri.port;
    if (uri.query) opts.query = uri.query;
  } else if (opts.host) {
    opts.hostname = parseuri(opts.host).host;
  }

  this.secure = null != opts.secure ? opts.secure
    : (typeof location !== 'undefined' && 'https:' === location.protocol);

  if (opts.hostname && !opts.port) {
    // if no port is specified manually, use the protocol default
    opts.port = this.secure ? '443' : '80';
  }

  this.agent = opts.agent || false;
  this.hostname = opts.hostname ||
    (typeof location !== 'undefined' ? location.hostname : 'localhost');
  this.port = opts.port || (typeof location !== 'undefined' && location.port
      ? location.port
      : (this.secure ? 443 : 80));
  this.query = opts.query || {};
  if ('string' === typeof this.query) this.query = parseqs.decode(this.query);
  this.upgrade = false !== opts.upgrade;
  this.path = (opts.path || '/engine.io').replace(/\/$/, '') + '/';
  this.forceJSONP = !!opts.forceJSONP;
  this.jsonp = false !== opts.jsonp;
  this.forceBase64 = !!opts.forceBase64;
  this.enablesXDR = !!opts.enablesXDR;
  this.timestampParam = opts.timestampParam || 't';
  this.timestampRequests = opts.timestampRequests;
  this.transports = opts.transports || ['polling', 'websocket'];
  this.transportOptions = opts.transportOptions || {};
  this.readyState = '';
  this.writeBuffer = [];
  this.prevBufferLen = 0;
  this.policyPort = opts.policyPort || 843;
  this.rememberUpgrade = opts.rememberUpgrade || false;
  this.binaryType = null;
  this.onlyBinaryUpgrades = opts.onlyBinaryUpgrades;
  this.perMessageDeflate = false !== opts.perMessageDeflate ? (opts.perMessageDeflate || {}) : false;

  if (true === this.perMessageDeflate) this.perMessageDeflate = {};
  if (this.perMessageDeflate && null == this.perMessageDeflate.threshold) {
    this.perMessageDeflate.threshold = 1024;
  }

  // SSL options for Node.js client
  this.pfx = opts.pfx || null;
  this.key = opts.key || null;
  this.passphrase = opts.passphrase || null;
  this.cert = opts.cert || null;
  this.ca = opts.ca || null;
  this.ciphers = opts.ciphers || null;
  this.rejectUnauthorized = opts.rejectUnauthorized === undefined ? true : opts.rejectUnauthorized;
  this.forceNode = !!opts.forceNode;

  // detect ReactNative environment
  this.isReactNative = (typeof navigator !== 'undefined' && typeof navigator.product === 'string' && navigator.product.toLowerCase() === 'reactnative');

  // other options for Node.js or ReactNative client
  if (typeof self === 'undefined' || this.isReactNative) {
    if (opts.extraHeaders && Object.keys(opts.extraHeaders).length > 0) {
      this.extraHeaders = opts.extraHeaders;
    }

    if (opts.localAddress) {
      this.localAddress = opts.localAddress;
    }
  }

  // set on handshake
  this.id = null;
  this.upgrades = null;
  this.pingInterval = null;
  this.pingTimeout = null;

  // set on heartbeat
  this.pingIntervalTimer = null;
  this.pingTimeoutTimer = null;

  this.open();
}

Socket.priorWebsocketSuccess = false;

/**
 * Mix in `Emitter`.
 */

Emitter(Socket.prototype);

/**
 * Protocol version.
 *
 * @api public
 */

Socket.protocol = parser.protocol; // this is an int

/**
 * Expose deps for legacy compatibility
 * and standalone browser access.
 */

Socket.Socket = Socket;
Socket.Transport = __webpack_require__(120);
Socket.transports = __webpack_require__(227);
Socket.parser = __webpack_require__(45);

/**
 * Creates transport of the given type.
 *
 * @param {String} transport name
 * @return {Transport}
 * @api private
 */

Socket.prototype.createTransport = function (name) {
  debug('creating transport "%s"', name);
  var query = clone(this.query);

  // append engine.io protocol identifier
  query.EIO = parser.protocol;

  // transport name
  query.transport = name;

  // per-transport options
  var options = this.transportOptions[name] || {};

  // session id if we already have one
  if (this.id) query.sid = this.id;

  var transport = new transports[name]({
    query: query,
    socket: this,
    agent: options.agent || this.agent,
    hostname: options.hostname || this.hostname,
    port: options.port || this.port,
    secure: options.secure || this.secure,
    path: options.path || this.path,
    forceJSONP: options.forceJSONP || this.forceJSONP,
    jsonp: options.jsonp || this.jsonp,
    forceBase64: options.forceBase64 || this.forceBase64,
    enablesXDR: options.enablesXDR || this.enablesXDR,
    timestampRequests: options.timestampRequests || this.timestampRequests,
    timestampParam: options.timestampParam || this.timestampParam,
    policyPort: options.policyPort || this.policyPort,
    pfx: options.pfx || this.pfx,
    key: options.key || this.key,
    passphrase: options.passphrase || this.passphrase,
    cert: options.cert || this.cert,
    ca: options.ca || this.ca,
    ciphers: options.ciphers || this.ciphers,
    rejectUnauthorized: options.rejectUnauthorized || this.rejectUnauthorized,
    perMessageDeflate: options.perMessageDeflate || this.perMessageDeflate,
    extraHeaders: options.extraHeaders || this.extraHeaders,
    forceNode: options.forceNode || this.forceNode,
    localAddress: options.localAddress || this.localAddress,
    requestTimeout: options.requestTimeout || this.requestTimeout,
    protocols: options.protocols || void (0),
    isReactNative: this.isReactNative
  });

  return transport;
};

function clone (obj) {
  var o = {};
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      o[i] = obj[i];
    }
  }
  return o;
}

/**
 * Initializes transport to use and starts probe.
 *
 * @api private
 */
Socket.prototype.open = function () {
  var transport;
  if (this.rememberUpgrade && Socket.priorWebsocketSuccess && this.transports.indexOf('websocket') !== -1) {
    transport = 'websocket';
  } else if (0 === this.transports.length) {
    // Emit error on next tick so it can be listened to
    var self = this;
    setTimeout(function () {
      self.emit('error', 'No transports available');
    }, 0);
    return;
  } else {
    transport = this.transports[0];
  }
  this.readyState = 'opening';

  // Retry with the next transport if the transport is disabled (jsonp: false)
  try {
    transport = this.createTransport(transport);
  } catch (e) {
    this.transports.shift();
    this.open();
    return;
  }

  transport.open();
  this.setTransport(transport);
};

/**
 * Sets the current transport. Disables the existing one (if any).
 *
 * @api private
 */

Socket.prototype.setTransport = function (transport) {
  debug('setting transport %s', transport.name);
  var self = this;

  if (this.transport) {
    debug('clearing existing transport %s', this.transport.name);
    this.transport.removeAllListeners();
  }

  // set up transport
  this.transport = transport;

  // set up transport listeners
  transport
  .on('drain', function () {
    self.onDrain();
  })
  .on('packet', function (packet) {
    self.onPacket(packet);
  })
  .on('error', function (e) {
    self.onError(e);
  })
  .on('close', function () {
    self.onClose('transport close');
  });
};

/**
 * Probes a transport.
 *
 * @param {String} transport name
 * @api private
 */

Socket.prototype.probe = function (name) {
  debug('probing transport "%s"', name);
  var transport = this.createTransport(name, { probe: 1 });
  var failed = false;
  var self = this;

  Socket.priorWebsocketSuccess = false;

  function onTransportOpen () {
    if (self.onlyBinaryUpgrades) {
      var upgradeLosesBinary = !this.supportsBinary && self.transport.supportsBinary;
      failed = failed || upgradeLosesBinary;
    }
    if (failed) return;

    debug('probe transport "%s" opened', name);
    transport.send([{ type: 'ping', data: 'probe' }]);
    transport.once('packet', function (msg) {
      if (failed) return;
      if ('pong' === msg.type && 'probe' === msg.data) {
        debug('probe transport "%s" pong', name);
        self.upgrading = true;
        self.emit('upgrading', transport);
        if (!transport) return;
        Socket.priorWebsocketSuccess = 'websocket' === transport.name;

        debug('pausing current transport "%s"', self.transport.name);
        self.transport.pause(function () {
          if (failed) return;
          if ('closed' === self.readyState) return;
          debug('changing transport and sending upgrade packet');

          cleanup();

          self.setTransport(transport);
          transport.send([{ type: 'upgrade' }]);
          self.emit('upgrade', transport);
          transport = null;
          self.upgrading = false;
          self.flush();
        });
      } else {
        debug('probe transport "%s" failed', name);
        var err = new Error('probe error');
        err.transport = transport.name;
        self.emit('upgradeError', err);
      }
    });
  }

  function freezeTransport () {
    if (failed) return;

    // Any callback called by transport should be ignored since now
    failed = true;

    cleanup();

    transport.close();
    transport = null;
  }

  // Handle any error that happens while probing
  function onerror (err) {
    var error = new Error('probe error: ' + err);
    error.transport = transport.name;

    freezeTransport();

    debug('probe transport "%s" failed because of error: %s', name, err);

    self.emit('upgradeError', error);
  }

  function onTransportClose () {
    onerror('transport closed');
  }

  // When the socket is closed while we're probing
  function onclose () {
    onerror('socket closed');
  }

  // When the socket is upgraded while we're probing
  function onupgrade (to) {
    if (transport && to.name !== transport.name) {
      debug('"%s" works - aborting "%s"', to.name, transport.name);
      freezeTransport();
    }
  }

  // Remove all listeners on the transport and on self
  function cleanup () {
    transport.removeListener('open', onTransportOpen);
    transport.removeListener('error', onerror);
    transport.removeListener('close', onTransportClose);
    self.removeListener('close', onclose);
    self.removeListener('upgrading', onupgrade);
  }

  transport.once('open', onTransportOpen);
  transport.once('error', onerror);
  transport.once('close', onTransportClose);

  this.once('close', onclose);
  this.once('upgrading', onupgrade);

  transport.open();
};

/**
 * Called when connection is deemed open.
 *
 * @api public
 */

Socket.prototype.onOpen = function () {
  debug('socket open');
  this.readyState = 'open';
  Socket.priorWebsocketSuccess = 'websocket' === this.transport.name;
  this.emit('open');
  this.flush();

  // we check for `readyState` in case an `open`
  // listener already closed the socket
  if ('open' === this.readyState && this.upgrade && this.transport.pause) {
    debug('starting upgrade probes');
    for (var i = 0, l = this.upgrades.length; i < l; i++) {
      this.probe(this.upgrades[i]);
    }
  }
};

/**
 * Handles a packet.
 *
 * @api private
 */

Socket.prototype.onPacket = function (packet) {
  if ('opening' === this.readyState || 'open' === this.readyState ||
      'closing' === this.readyState) {
    debug('socket receive: type "%s", data "%s"', packet.type, packet.data);

    this.emit('packet', packet);

    // Socket is live - any packet counts
    this.emit('heartbeat');

    switch (packet.type) {
      case 'open':
        this.onHandshake(JSON.parse(packet.data));
        break;

      case 'pong':
        this.setPing();
        this.emit('pong');
        break;

      case 'error':
        var err = new Error('server error');
        err.code = packet.data;
        this.onError(err);
        break;

      case 'message':
        this.emit('data', packet.data);
        this.emit('message', packet.data);
        break;
    }
  } else {
    debug('packet received with socket readyState "%s"', this.readyState);
  }
};

/**
 * Called upon handshake completion.
 *
 * @param {Object} handshake obj
 * @api private
 */

Socket.prototype.onHandshake = function (data) {
  this.emit('handshake', data);
  this.id = data.sid;
  this.transport.query.sid = data.sid;
  this.upgrades = this.filterUpgrades(data.upgrades);
  this.pingInterval = data.pingInterval;
  this.pingTimeout = data.pingTimeout;
  this.onOpen();
  // In case open handler closes socket
  if ('closed' === this.readyState) return;
  this.setPing();

  // Prolong liveness of socket on heartbeat
  this.removeListener('heartbeat', this.onHeartbeat);
  this.on('heartbeat', this.onHeartbeat);
};

/**
 * Resets ping timeout.
 *
 * @api private
 */

Socket.prototype.onHeartbeat = function (timeout) {
  clearTimeout(this.pingTimeoutTimer);
  var self = this;
  self.pingTimeoutTimer = setTimeout(function () {
    if ('closed' === self.readyState) return;
    self.onClose('ping timeout');
  }, timeout || (self.pingInterval + self.pingTimeout));
};

/**
 * Pings server every `this.pingInterval` and expects response
 * within `this.pingTimeout` or closes connection.
 *
 * @api private
 */

Socket.prototype.setPing = function () {
  var self = this;
  clearTimeout(self.pingIntervalTimer);
  self.pingIntervalTimer = setTimeout(function () {
    debug('writing ping packet - expecting pong within %sms', self.pingTimeout);
    self.ping();
    self.onHeartbeat(self.pingTimeout);
  }, self.pingInterval);
};

/**
* Sends a ping packet.
*
* @api private
*/

Socket.prototype.ping = function () {
  var self = this;
  this.sendPacket('ping', function () {
    self.emit('ping');
  });
};

/**
 * Called on `drain` event
 *
 * @api private
 */

Socket.prototype.onDrain = function () {
  this.writeBuffer.splice(0, this.prevBufferLen);

  // setting prevBufferLen = 0 is very important
  // for example, when upgrading, upgrade packet is sent over,
  // and a nonzero prevBufferLen could cause problems on `drain`
  this.prevBufferLen = 0;

  if (0 === this.writeBuffer.length) {
    this.emit('drain');
  } else {
    this.flush();
  }
};

/**
 * Flush write buffers.
 *
 * @api private
 */

Socket.prototype.flush = function () {
  if ('closed' !== this.readyState && this.transport.writable &&
    !this.upgrading && this.writeBuffer.length) {
    debug('flushing %d packets in socket', this.writeBuffer.length);
    this.transport.send(this.writeBuffer);
    // keep track of current length of writeBuffer
    // splice writeBuffer and callbackBuffer on `drain`
    this.prevBufferLen = this.writeBuffer.length;
    this.emit('flush');
  }
};

/**
 * Sends a message.
 *
 * @param {String} message.
 * @param {Function} callback function.
 * @param {Object} options.
 * @return {Socket} for chaining.
 * @api public
 */

Socket.prototype.write =
Socket.prototype.send = function (msg, options, fn) {
  this.sendPacket('message', msg, options, fn);
  return this;
};

/**
 * Sends a packet.
 *
 * @param {String} packet type.
 * @param {String} data.
 * @param {Object} options.
 * @param {Function} callback function.
 * @api private
 */

Socket.prototype.sendPacket = function (type, data, options, fn) {
  if ('function' === typeof data) {
    fn = data;
    data = undefined;
  }

  if ('function' === typeof options) {
    fn = options;
    options = null;
  }

  if ('closing' === this.readyState || 'closed' === this.readyState) {
    return;
  }

  options = options || {};
  options.compress = false !== options.compress;

  var packet = {
    type: type,
    data: data,
    options: options
  };
  this.emit('packetCreate', packet);
  this.writeBuffer.push(packet);
  if (fn) this.once('flush', fn);
  this.flush();
};

/**
 * Closes the connection.
 *
 * @api private
 */

Socket.prototype.close = function () {
  if ('opening' === this.readyState || 'open' === this.readyState) {
    this.readyState = 'closing';

    var self = this;

    if (this.writeBuffer.length) {
      this.once('drain', function () {
        if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      });
    } else if (this.upgrading) {
      waitForUpgrade();
    } else {
      close();
    }
  }

  function close () {
    self.onClose('forced close');
    debug('socket closing - telling transport to close');
    self.transport.close();
  }

  function cleanupAndClose () {
    self.removeListener('upgrade', cleanupAndClose);
    self.removeListener('upgradeError', cleanupAndClose);
    close();
  }

  function waitForUpgrade () {
    // wait for upgrade to finish since we can't send packets while pausing a transport
    self.once('upgrade', cleanupAndClose);
    self.once('upgradeError', cleanupAndClose);
  }

  return this;
};

/**
 * Called upon transport error
 *
 * @api private
 */

Socket.prototype.onError = function (err) {
  debug('socket error %j', err);
  Socket.priorWebsocketSuccess = false;
  this.emit('error', err);
  this.onClose('transport error', err);
};

/**
 * Called upon transport close.
 *
 * @api private
 */

Socket.prototype.onClose = function (reason, desc) {
  if ('opening' === this.readyState || 'open' === this.readyState || 'closing' === this.readyState) {
    debug('socket close with reason: "%s"', reason);
    var self = this;

    // clear timers
    clearTimeout(this.pingIntervalTimer);
    clearTimeout(this.pingTimeoutTimer);

    // stop event from firing again for transport
    this.transport.removeAllListeners('close');

    // ensure transport won't stay open
    this.transport.close();

    // ignore further transport communication
    this.transport.removeAllListeners();

    // set ready state
    this.readyState = 'closed';

    // clear session id
    this.id = null;

    // emit close event
    this.emit('close', reason, desc);

    // clean buffers after, so users can still
    // grab the buffers on `close` event
    self.writeBuffer = [];
    self.prevBufferLen = 0;
  }
};

/**
 * Filters upgrades, returning only those matching client transports.
 *
 * @param {Array} server upgrades
 * @api private
 *
 */

Socket.prototype.filterUpgrades = function (upgrades) {
  var filteredUpgrades = [];
  for (var i = 0, j = upgrades.length; i < j; i++) {
    if (~index(this.transports, upgrades[i])) filteredUpgrades.push(upgrades[i]);
  }
  return filteredUpgrades;
};


/***/ }),
/* 872 */
/***/ (function(module, exports) {


/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */

try {
  module.exports = typeof XMLHttpRequest !== 'undefined' &&
    'withCredentials' in new XMLHttpRequest();
} catch (err) {
  // if XMLHttp support is disabled in IE then it will throw
  // when trying to create
  module.exports = false;
}


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

/* global attachEvent */

/**
 * Module requirements.
 */

var XMLHttpRequest = __webpack_require__(119);
var Polling = __webpack_require__(228);
var Emitter = __webpack_require__(44);
var inherit = __webpack_require__(73);
var debug = __webpack_require__(74)('engine.io-client:polling-xhr');

/**
 * Module exports.
 */

module.exports = XHR;
module.exports.Request = Request;

/**
 * Empty function
 */

function empty () {}

/**
 * XHR Polling constructor.
 *
 * @param {Object} opts
 * @api public
 */

function XHR (opts) {
  Polling.call(this, opts);
  this.requestTimeout = opts.requestTimeout;
  this.extraHeaders = opts.extraHeaders;

  if (typeof location !== 'undefined') {
    var isSSL = 'https:' === location.protocol;
    var port = location.port;

    // some user agents have empty `location.port`
    if (!port) {
      port = isSSL ? 443 : 80;
    }

    this.xd = (typeof location !== 'undefined' && opts.hostname !== location.hostname) ||
      port !== opts.port;
    this.xs = opts.secure !== isSSL;
  }
}

/**
 * Inherits from Polling.
 */

inherit(XHR, Polling);

/**
 * XHR supports binary
 */

XHR.prototype.supportsBinary = true;

/**
 * Creates a request.
 *
 * @param {String} method
 * @api private
 */

XHR.prototype.request = function (opts) {
  opts = opts || {};
  opts.uri = this.uri();
  opts.xd = this.xd;
  opts.xs = this.xs;
  opts.agent = this.agent || false;
  opts.supportsBinary = this.supportsBinary;
  opts.enablesXDR = this.enablesXDR;

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  opts.requestTimeout = this.requestTimeout;

  // other options for Node.js client
  opts.extraHeaders = this.extraHeaders;

  return new Request(opts);
};

/**
 * Sends data.
 *
 * @param {String} data to send.
 * @param {Function} called upon flush.
 * @api private
 */

XHR.prototype.doWrite = function (data, fn) {
  var isBinary = typeof data !== 'string' && data !== undefined;
  var req = this.request({ method: 'POST', data: data, isBinary: isBinary });
  var self = this;
  req.on('success', fn);
  req.on('error', function (err) {
    self.onError('xhr post error', err);
  });
  this.sendXhr = req;
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

XHR.prototype.doPoll = function () {
  debug('xhr poll');
  var req = this.request();
  var self = this;
  req.on('data', function (data) {
    self.onData(data);
  });
  req.on('error', function (err) {
    self.onError('xhr poll error', err);
  });
  this.pollXhr = req;
};

/**
 * Request constructor
 *
 * @param {Object} options
 * @api public
 */

function Request (opts) {
  this.method = opts.method || 'GET';
  this.uri = opts.uri;
  this.xd = !!opts.xd;
  this.xs = !!opts.xs;
  this.async = false !== opts.async;
  this.data = undefined !== opts.data ? opts.data : null;
  this.agent = opts.agent;
  this.isBinary = opts.isBinary;
  this.supportsBinary = opts.supportsBinary;
  this.enablesXDR = opts.enablesXDR;
  this.requestTimeout = opts.requestTimeout;

  // SSL options for Node.js client
  this.pfx = opts.pfx;
  this.key = opts.key;
  this.passphrase = opts.passphrase;
  this.cert = opts.cert;
  this.ca = opts.ca;
  this.ciphers = opts.ciphers;
  this.rejectUnauthorized = opts.rejectUnauthorized;

  // other options for Node.js client
  this.extraHeaders = opts.extraHeaders;

  this.create();
}

/**
 * Mix in `Emitter`.
 */

Emitter(Request.prototype);

/**
 * Creates the XHR object and sends the request.
 *
 * @api private
 */

Request.prototype.create = function () {
  var opts = { agent: this.agent, xdomain: this.xd, xscheme: this.xs, enablesXDR: this.enablesXDR };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;

  var xhr = this.xhr = new XMLHttpRequest(opts);
  var self = this;

  try {
    debug('xhr open %s: %s', this.method, this.uri);
    xhr.open(this.method, this.uri, this.async);
    try {
      if (this.extraHeaders) {
        xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
        for (var i in this.extraHeaders) {
          if (this.extraHeaders.hasOwnProperty(i)) {
            xhr.setRequestHeader(i, this.extraHeaders[i]);
          }
        }
      }
    } catch (e) {}

    if ('POST' === this.method) {
      try {
        if (this.isBinary) {
          xhr.setRequestHeader('Content-type', 'application/octet-stream');
        } else {
          xhr.setRequestHeader('Content-type', 'text/plain;charset=UTF-8');
        }
      } catch (e) {}
    }

    try {
      xhr.setRequestHeader('Accept', '*/*');
    } catch (e) {}

    // ie6 check
    if ('withCredentials' in xhr) {
      xhr.withCredentials = true;
    }

    if (this.requestTimeout) {
      xhr.timeout = this.requestTimeout;
    }

    if (this.hasXDR()) {
      xhr.onload = function () {
        self.onLoad();
      };
      xhr.onerror = function () {
        self.onError(xhr.responseText);
      };
    } else {
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 2) {
          try {
            var contentType = xhr.getResponseHeader('Content-Type');
            if (self.supportsBinary && contentType === 'application/octet-stream') {
              xhr.responseType = 'arraybuffer';
            }
          } catch (e) {}
        }
        if (4 !== xhr.readyState) return;
        if (200 === xhr.status || 1223 === xhr.status) {
          self.onLoad();
        } else {
          // make sure the `error` event handler that's user-set
          // does not throw in the same tick and gets caught here
          setTimeout(function () {
            self.onError(xhr.status);
          }, 0);
        }
      };
    }

    debug('xhr data %s', this.data);
    xhr.send(this.data);
  } catch (e) {
    // Need to defer since .create() is called directly fhrom the constructor
    // and thus the 'error' event can only be only bound *after* this exception
    // occurs.  Therefore, also, we cannot throw here at all.
    setTimeout(function () {
      self.onError(e);
    }, 0);
    return;
  }

  if (typeof document !== 'undefined') {
    this.index = Request.requestsCount++;
    Request.requests[this.index] = this;
  }
};

/**
 * Called upon successful response.
 *
 * @api private
 */

Request.prototype.onSuccess = function () {
  this.emit('success');
  this.cleanup();
};

/**
 * Called if we have data.
 *
 * @api private
 */

Request.prototype.onData = function (data) {
  this.emit('data', data);
  this.onSuccess();
};

/**
 * Called upon error.
 *
 * @api private
 */

Request.prototype.onError = function (err) {
  this.emit('error', err);
  this.cleanup(true);
};

/**
 * Cleans up house.
 *
 * @api private
 */

Request.prototype.cleanup = function (fromError) {
  if ('undefined' === typeof this.xhr || null === this.xhr) {
    return;
  }
  // xmlhttprequest
  if (this.hasXDR()) {
    this.xhr.onload = this.xhr.onerror = empty;
  } else {
    this.xhr.onreadystatechange = empty;
  }

  if (fromError) {
    try {
      this.xhr.abort();
    } catch (e) {}
  }

  if (typeof document !== 'undefined') {
    delete Request.requests[this.index];
  }

  this.xhr = null;
};

/**
 * Called upon load.
 *
 * @api private
 */

Request.prototype.onLoad = function () {
  var data;
  try {
    var contentType;
    try {
      contentType = this.xhr.getResponseHeader('Content-Type');
    } catch (e) {}
    if (contentType === 'application/octet-stream') {
      data = this.xhr.response || this.xhr.responseText;
    } else {
      data = this.xhr.responseText;
    }
  } catch (e) {
    this.onError(e);
  }
  if (null != data) {
    this.onData(data);
  }
};

/**
 * Check if it has XDomainRequest.
 *
 * @api private
 */

Request.prototype.hasXDR = function () {
  return typeof XDomainRequest !== 'undefined' && !this.xs && this.enablesXDR;
};

/**
 * Aborts the request.
 *
 * @api public
 */

Request.prototype.abort = function () {
  this.cleanup();
};

/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */

Request.requestsCount = 0;
Request.requests = {};

if (typeof document !== 'undefined') {
  if (typeof attachEvent === 'function') {
    attachEvent('onunload', unloadHandler);
  } else if (typeof addEventListener === 'function') {
    var terminationEvent = 'onpagehide' in self ? 'pagehide' : 'unload';
    addEventListener(terminationEvent, unloadHandler, false);
  }
}

function unloadHandler () {
  for (var i in Request.requests) {
    if (Request.requests.hasOwnProperty(i)) {
      Request.requests[i].abort();
    }
  }
}


/***/ }),
/* 874 */
/***/ (function(module, exports) {


/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};


/***/ }),
/* 875 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 876 */
/***/ (function(module, exports) {

/**
 * An abstraction for slicing an arraybuffer even when
 * ArrayBuffer.prototype.slice is not supported
 *
 * @api public
 */

module.exports = function(arraybuffer, start, end) {
  var bytes = arraybuffer.byteLength;
  start = start || 0;
  end = end || bytes;

  if (arraybuffer.slice) { return arraybuffer.slice(start, end); }

  if (start < 0) { start += bytes; }
  if (end < 0) { end += bytes; }
  if (end > bytes) { end = bytes; }

  if (start >= bytes || start >= end || bytes === 0) {
    return new ArrayBuffer(0);
  }

  var abv = new Uint8Array(arraybuffer);
  var result = new Uint8Array(end - start);
  for (var i = start, ii = 0; i < end; i++, ii++) {
    result[ii] = abv[i];
  }
  return result.buffer;
};


/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports = after

function after(count, callback, err_cb) {
    var bail = false
    err_cb = err_cb || noop
    proxy.count = count

    return (count === 0) ? callback() : proxy

    function proxy(err, result) {
        if (proxy.count <= 0) {
            throw new Error('after called too many times')
        }
        --proxy.count

        // after first error, rest are passed to err_cb
        if (err) {
            bail = true
            callback(err)
            // future error callbacks will go to error handler
            callback = err_cb
        } else if (proxy.count === 0 && !bail) {
            callback(null, result)
        }
    }
}

function noop() {}


/***/ }),
/* 878 */
/***/ (function(module, exports) {

/*! https://mths.be/utf8js v2.1.2 by @mathias */

var stringFromCharCode = String.fromCharCode;

// Taken from https://mths.be/punycode
function ucs2decode(string) {
	var output = [];
	var counter = 0;
	var length = string.length;
	var value;
	var extra;
	while (counter < length) {
		value = string.charCodeAt(counter++);
		if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
			// high surrogate, and there is a next character
			extra = string.charCodeAt(counter++);
			if ((extra & 0xFC00) == 0xDC00) { // low surrogate
				output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
			} else {
				// unmatched surrogate; only append this code unit, in case the next
				// code unit is the high surrogate of a surrogate pair
				output.push(value);
				counter--;
			}
		} else {
			output.push(value);
		}
	}
	return output;
}

// Taken from https://mths.be/punycode
function ucs2encode(array) {
	var length = array.length;
	var index = -1;
	var value;
	var output = '';
	while (++index < length) {
		value = array[index];
		if (value > 0xFFFF) {
			value -= 0x10000;
			output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
			value = 0xDC00 | value & 0x3FF;
		}
		output += stringFromCharCode(value);
	}
	return output;
}

function checkScalarValue(codePoint, strict) {
	if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
		if (strict) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
		return false;
	}
	return true;
}
/*--------------------------------------------------------------------------*/

function createByte(codePoint, shift) {
	return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
}

function encodeCodePoint(codePoint, strict) {
	if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
		return stringFromCharCode(codePoint);
	}
	var symbol = '';
	if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
		symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
	}
	else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
		if (!checkScalarValue(codePoint, strict)) {
			codePoint = 0xFFFD;
		}
		symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
		symbol += createByte(codePoint, 6);
	}
	else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
		symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
		symbol += createByte(codePoint, 12);
		symbol += createByte(codePoint, 6);
	}
	symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
	return symbol;
}

function utf8encode(string, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	var codePoints = ucs2decode(string);
	var length = codePoints.length;
	var index = -1;
	var codePoint;
	var byteString = '';
	while (++index < length) {
		codePoint = codePoints[index];
		byteString += encodeCodePoint(codePoint, strict);
	}
	return byteString;
}

/*--------------------------------------------------------------------------*/

function readContinuationByte() {
	if (byteIndex >= byteCount) {
		throw Error('Invalid byte index');
	}

	var continuationByte = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	if ((continuationByte & 0xC0) == 0x80) {
		return continuationByte & 0x3F;
	}

	// If we end up here, it’s not a continuation byte
	throw Error('Invalid continuation byte');
}

function decodeSymbol(strict) {
	var byte1;
	var byte2;
	var byte3;
	var byte4;
	var codePoint;

	if (byteIndex > byteCount) {
		throw Error('Invalid byte index');
	}

	if (byteIndex == byteCount) {
		return false;
	}

	// Read first byte
	byte1 = byteArray[byteIndex] & 0xFF;
	byteIndex++;

	// 1-byte sequence (no continuation bytes)
	if ((byte1 & 0x80) == 0) {
		return byte1;
	}

	// 2-byte sequence
	if ((byte1 & 0xE0) == 0xC0) {
		byte2 = readContinuationByte();
		codePoint = ((byte1 & 0x1F) << 6) | byte2;
		if (codePoint >= 0x80) {
			return codePoint;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 3-byte sequence (may include unpaired surrogates)
	if ((byte1 & 0xF0) == 0xE0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
		if (codePoint >= 0x0800) {
			return checkScalarValue(codePoint, strict) ? codePoint : 0xFFFD;
		} else {
			throw Error('Invalid continuation byte');
		}
	}

	// 4-byte sequence
	if ((byte1 & 0xF8) == 0xF0) {
		byte2 = readContinuationByte();
		byte3 = readContinuationByte();
		byte4 = readContinuationByte();
		codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
			(byte3 << 0x06) | byte4;
		if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
			return codePoint;
		}
	}

	throw Error('Invalid UTF-8 detected');
}

var byteArray;
var byteCount;
var byteIndex;
function utf8decode(byteString, opts) {
	opts = opts || {};
	var strict = false !== opts.strict;

	byteArray = ucs2decode(byteString);
	byteCount = byteArray.length;
	byteIndex = 0;
	var codePoints = [];
	var tmp;
	while ((tmp = decodeSymbol(strict)) !== false) {
		codePoints.push(tmp);
	}
	return ucs2encode(codePoints);
}

module.exports = {
	version: '2.1.2',
	encode: utf8encode,
	decode: utf8decode
};


/***/ }),
/* 879 */
/***/ (function(module, exports) {

/*
 * base64-arraybuffer
 * https://github.com/niklasvh/base64-arraybuffer
 *
 * Copyright (c) 2012 Niklas von Hertzen
 * Licensed under the MIT license.
 */
(function(){
  "use strict";

  var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

  // Use a lookup table to find the index.
  var lookup = new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
  }

  exports.encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64 = "";

    for (i = 0; i < len; i+=3) {
      base64 += chars[bytes[i] >> 2];
      base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
      base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
      base64 += chars[bytes[i + 2] & 63];
    }

    if ((len % 3) === 2) {
      base64 = base64.substring(0, base64.length - 1) + "=";
    } else if (len % 3 === 1) {
      base64 = base64.substring(0, base64.length - 2) + "==";
    }

    return base64;
  };

  exports.decode =  function(base64) {
    var bufferLength = base64.length * 0.75,
    len = base64.length, i, p = 0,
    encoded1, encoded2, encoded3, encoded4;

    if (base64[base64.length - 1] === "=") {
      bufferLength--;
      if (base64[base64.length - 2] === "=") {
        bufferLength--;
      }
    }

    var arraybuffer = new ArrayBuffer(bufferLength),
    bytes = new Uint8Array(arraybuffer);

    for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64.charCodeAt(i)];
      encoded2 = lookup[base64.charCodeAt(i+1)];
      encoded3 = lookup[base64.charCodeAt(i+2)];
      encoded4 = lookup[base64.charCodeAt(i+3)];

      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }

    return arraybuffer;
  };
})();


/***/ }),
/* 880 */
/***/ (function(module, exports) {

/**
 * Create a blob builder even when vendor prefixes exist
 */

var BlobBuilder = typeof BlobBuilder !== 'undefined' ? BlobBuilder :
  typeof WebKitBlobBuilder !== 'undefined' ? WebKitBlobBuilder :
  typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder :
  typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : 
  false;

/**
 * Check if Blob constructor is supported
 */

var blobSupported = (function() {
  try {
    var a = new Blob(['hi']);
    return a.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if Blob constructor supports ArrayBufferViews
 * Fails in Safari 6, so we need to map to ArrayBuffers there.
 */

var blobSupportsArrayBufferView = blobSupported && (function() {
  try {
    var b = new Blob([new Uint8Array([1,2])]);
    return b.size === 2;
  } catch(e) {
    return false;
  }
})();

/**
 * Check if BlobBuilder is supported
 */

var blobBuilderSupported = BlobBuilder
  && BlobBuilder.prototype.append
  && BlobBuilder.prototype.getBlob;

/**
 * Helper function that maps ArrayBufferViews to ArrayBuffers
 * Used by BlobBuilder constructor and old browsers that didn't
 * support it in the Blob constructor.
 */

function mapArrayBufferViews(ary) {
  return ary.map(function(chunk) {
    if (chunk.buffer instanceof ArrayBuffer) {
      var buf = chunk.buffer;

      // if this is a subarray, make a copy so we only
      // include the subarray region from the underlying buffer
      if (chunk.byteLength !== buf.byteLength) {
        var copy = new Uint8Array(chunk.byteLength);
        copy.set(new Uint8Array(buf, chunk.byteOffset, chunk.byteLength));
        buf = copy.buffer;
      }

      return buf;
    }

    return chunk;
  });
}

function BlobBuilderConstructor(ary, options) {
  options = options || {};

  var bb = new BlobBuilder();
  mapArrayBufferViews(ary).forEach(function(part) {
    bb.append(part);
  });

  return (options.type) ? bb.getBlob(options.type) : bb.getBlob();
};

function BlobConstructor(ary, options) {
  return new Blob(mapArrayBufferViews(ary), options || {});
};

if (typeof Blob !== 'undefined') {
  BlobBuilderConstructor.prototype = Blob.prototype;
  BlobConstructor.prototype = Blob.prototype;
}

module.exports = (function() {
  if (blobSupported) {
    return blobSupportsArrayBufferView ? Blob : BlobConstructor;
  } else if (blobBuilderSupported) {
    return BlobBuilderConstructor;
  } else {
    return undefined;
  }
})();


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(85);

/**
 * Active `debug` instances.
 */
exports.instances = [];

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  var prevTime;

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);
  debug.destroy = destroy;

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  exports.instances.push(debug);

  return debug;
}

function destroy () {
  var index = exports.instances.indexOf(this);
  if (index !== -1) {
    exports.instances.splice(index, 1);
    return true;
  } else {
    return false;
  }
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var i;
  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }

  for (i = 0; i < exports.instances.length; i++) {
    var instance = exports.instances[i];
    instance.enabled = exports.enabled(instance.namespace);
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  if (name[name.length - 1] === '*') {
    return true;
  }
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Module requirements.
 */

var Polling = __webpack_require__(228);
var inherit = __webpack_require__(73);

/**
 * Module exports.
 */

module.exports = JSONPPolling;

/**
 * Cached regular expressions.
 */

var rNewline = /\n/g;
var rEscapedNewline = /\\n/g;

/**
 * Global JSONP callbacks.
 */

var callbacks;

/**
 * Noop.
 */

function empty () { }

/**
 * Until https://github.com/tc39/proposal-global is shipped.
 */
function glob () {
  return typeof self !== 'undefined' ? self
      : typeof window !== 'undefined' ? window
      : typeof global !== 'undefined' ? global : {};
}

/**
 * JSONP Polling constructor.
 *
 * @param {Object} opts.
 * @api public
 */

function JSONPPolling (opts) {
  Polling.call(this, opts);

  this.query = this.query || {};

  // define global callbacks array if not present
  // we do this here (lazily) to avoid unneeded global pollution
  if (!callbacks) {
    // we need to consider multiple engines in the same page
    var global = glob();
    callbacks = global.___eio = (global.___eio || []);
  }

  // callback identifier
  this.index = callbacks.length;

  // add callback to jsonp global
  var self = this;
  callbacks.push(function (msg) {
    self.onData(msg);
  });

  // append to query string
  this.query.j = this.index;

  // prevent spurious errors from being emitted when the window is unloaded
  if (typeof addEventListener === 'function') {
    addEventListener('beforeunload', function () {
      if (self.script) self.script.onerror = empty;
    }, false);
  }
}

/**
 * Inherits from Polling.
 */

inherit(JSONPPolling, Polling);

/*
 * JSONP only supports binary as base64 encoded strings
 */

JSONPPolling.prototype.supportsBinary = false;

/**
 * Closes the socket.
 *
 * @api private
 */

JSONPPolling.prototype.doClose = function () {
  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  if (this.form) {
    this.form.parentNode.removeChild(this.form);
    this.form = null;
    this.iframe = null;
  }

  Polling.prototype.doClose.call(this);
};

/**
 * Starts a poll cycle.
 *
 * @api private
 */

JSONPPolling.prototype.doPoll = function () {
  var self = this;
  var script = document.createElement('script');

  if (this.script) {
    this.script.parentNode.removeChild(this.script);
    this.script = null;
  }

  script.async = true;
  script.src = this.uri();
  script.onerror = function (e) {
    self.onError('jsonp poll error', e);
  };

  var insertAt = document.getElementsByTagName('script')[0];
  if (insertAt) {
    insertAt.parentNode.insertBefore(script, insertAt);
  } else {
    (document.head || document.body).appendChild(script);
  }
  this.script = script;

  var isUAgecko = 'undefined' !== typeof navigator && /gecko/i.test(navigator.userAgent);

  if (isUAgecko) {
    setTimeout(function () {
      var iframe = document.createElement('iframe');
      document.body.appendChild(iframe);
      document.body.removeChild(iframe);
    }, 100);
  }
};

/**
 * Writes with a hidden iframe.
 *
 * @param {String} data to send
 * @param {Function} called upon flush.
 * @api private
 */

JSONPPolling.prototype.doWrite = function (data, fn) {
  var self = this;

  if (!this.form) {
    var form = document.createElement('form');
    var area = document.createElement('textarea');
    var id = this.iframeId = 'eio_iframe_' + this.index;
    var iframe;

    form.className = 'socketio';
    form.style.position = 'absolute';
    form.style.top = '-1000px';
    form.style.left = '-1000px';
    form.target = id;
    form.method = 'POST';
    form.setAttribute('accept-charset', 'utf-8');
    area.name = 'd';
    form.appendChild(area);
    document.body.appendChild(form);

    this.form = form;
    this.area = area;
  }

  this.form.action = this.uri();

  function complete () {
    initIframe();
    fn();
  }

  function initIframe () {
    if (self.iframe) {
      try {
        self.form.removeChild(self.iframe);
      } catch (e) {
        self.onError('jsonp polling iframe removal error', e);
      }
    }

    try {
      // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
      var html = '<iframe src="javascript:0" name="' + self.iframeId + '">';
      iframe = document.createElement(html);
    } catch (e) {
      iframe = document.createElement('iframe');
      iframe.name = self.iframeId;
      iframe.src = 'javascript:0';
    }

    iframe.id = self.iframeId;

    self.form.appendChild(iframe);
    self.iframe = iframe;
  }

  initIframe();

  // escape \n to prevent it from being converted into \r\n by some UAs
  // double escaping is required for escaped new lines because unescaping of new lines can be done safely on server-side
  data = data.replace(rEscapedNewline, '\\\n');
  this.area.value = data.replace(rNewline, '\\n');

  try {
    this.form.submit();
  } catch (e) {}

  if (this.iframe.attachEvent) {
    this.iframe.onreadystatechange = function () {
      if (self.iframe.readyState === 'complete') {
        complete();
      }
    };
  } else {
    this.iframe.onload = complete;
  }
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * Module dependencies.
 */

var Transport = __webpack_require__(120);
var parser = __webpack_require__(45);
var parseqs = __webpack_require__(72);
var inherit = __webpack_require__(73);
var yeast = __webpack_require__(230);
var debug = __webpack_require__(74)('engine.io-client:websocket');
var BrowserWebSocket, NodeWebSocket;
if (typeof self === 'undefined') {
  try {
    NodeWebSocket = __webpack_require__(884);
  } catch (e) { }
} else {
  BrowserWebSocket = self.WebSocket || self.MozWebSocket;
}

/**
 * Get either the `WebSocket` or `MozWebSocket` globals
 * in the browser or try to resolve WebSocket-compatible
 * interface exposed by `ws` for Node-like environment.
 */

var WebSocket = BrowserWebSocket || NodeWebSocket;

/**
 * Module exports.
 */

module.exports = WS;

/**
 * WebSocket transport constructor.
 *
 * @api {Object} connection options
 * @api public
 */

function WS (opts) {
  var forceBase64 = (opts && opts.forceBase64);
  if (forceBase64) {
    this.supportsBinary = false;
  }
  this.perMessageDeflate = opts.perMessageDeflate;
  this.usingBrowserWebSocket = BrowserWebSocket && !opts.forceNode;
  this.protocols = opts.protocols;
  if (!this.usingBrowserWebSocket) {
    WebSocket = NodeWebSocket;
  }
  Transport.call(this, opts);
}

/**
 * Inherits from Transport.
 */

inherit(WS, Transport);

/**
 * Transport name.
 *
 * @api public
 */

WS.prototype.name = 'websocket';

/*
 * WebSockets support binary
 */

WS.prototype.supportsBinary = true;

/**
 * Opens socket.
 *
 * @api private
 */

WS.prototype.doOpen = function () {
  if (!this.check()) {
    // let probe timeout
    return;
  }

  var uri = this.uri();
  var protocols = this.protocols;
  var opts = {
    agent: this.agent,
    perMessageDeflate: this.perMessageDeflate
  };

  // SSL options for Node.js client
  opts.pfx = this.pfx;
  opts.key = this.key;
  opts.passphrase = this.passphrase;
  opts.cert = this.cert;
  opts.ca = this.ca;
  opts.ciphers = this.ciphers;
  opts.rejectUnauthorized = this.rejectUnauthorized;
  if (this.extraHeaders) {
    opts.headers = this.extraHeaders;
  }
  if (this.localAddress) {
    opts.localAddress = this.localAddress;
  }

  try {
    this.ws = this.usingBrowserWebSocket && !this.isReactNative ? (protocols ? new WebSocket(uri, protocols) : new WebSocket(uri)) : new WebSocket(uri, protocols, opts);
  } catch (err) {
    return this.emit('error', err);
  }

  if (this.ws.binaryType === undefined) {
    this.supportsBinary = false;
  }

  if (this.ws.supports && this.ws.supports.binary) {
    this.supportsBinary = true;
    this.ws.binaryType = 'nodebuffer';
  } else {
    this.ws.binaryType = 'arraybuffer';
  }

  this.addEventListeners();
};

/**
 * Adds event listeners to the socket
 *
 * @api private
 */

WS.prototype.addEventListeners = function () {
  var self = this;

  this.ws.onopen = function () {
    self.onOpen();
  };
  this.ws.onclose = function () {
    self.onClose();
  };
  this.ws.onmessage = function (ev) {
    self.onData(ev.data);
  };
  this.ws.onerror = function (e) {
    self.onError('websocket error', e);
  };
};

/**
 * Writes data to socket.
 *
 * @param {Array} array of packets.
 * @api private
 */

WS.prototype.write = function (packets) {
  var self = this;
  this.writable = false;

  // encodePacket efficient as it uses WS framing
  // no need for encodePayload
  var total = packets.length;
  for (var i = 0, l = total; i < l; i++) {
    (function (packet) {
      parser.encodePacket(packet, self.supportsBinary, function (data) {
        if (!self.usingBrowserWebSocket) {
          // always create a new object (GH-437)
          var opts = {};
          if (packet.options) {
            opts.compress = packet.options.compress;
          }

          if (self.perMessageDeflate) {
            var len = 'string' === typeof data ? Buffer.byteLength(data) : data.length;
            if (len < self.perMessageDeflate.threshold) {
              opts.compress = false;
            }
          }
        }

        // Sometimes the websocket has already been closed but the browser didn't
        // have a chance of informing us about it yet, in that case send will
        // throw an error
        try {
          if (self.usingBrowserWebSocket) {
            // TypeError is thrown when passing the second argument on Safari
            self.ws.send(data);
          } else {
            self.ws.send(data, opts);
          }
        } catch (e) {
          debug('websocket closed before onclose event');
        }

        --total || done();
      });
    })(packets[i]);
  }

  function done () {
    self.emit('flush');

    // fake drain
    // defer to next tick to allow Socket to clear writeBuffer
    setTimeout(function () {
      self.writable = true;
      self.emit('drain');
    }, 0);
  }
};

/**
 * Called upon close
 *
 * @api private
 */

WS.prototype.onClose = function () {
  Transport.prototype.onClose.call(this);
};

/**
 * Closes socket.
 *
 * @api private
 */

WS.prototype.doClose = function () {
  if (typeof this.ws !== 'undefined') {
    this.ws.close();
  }
};

/**
 * Generates uri for connection.
 *
 * @api private
 */

WS.prototype.uri = function () {
  var query = this.query || {};
  var schema = this.secure ? 'wss' : 'ws';
  var port = '';

  // avoid port if default for schema
  if (this.port && (('wss' === schema && Number(this.port) !== 443) ||
    ('ws' === schema && Number(this.port) !== 80))) {
    port = ':' + this.port;
  }

  // append timestamp to URI
  if (this.timestampRequests) {
    query[this.timestampParam] = yeast();
  }

  // communicate binary support capabilities
  if (!this.supportsBinary) {
    query.b64 = 1;
  }

  query = parseqs.encode(query);

  // prepend ? to query
  if (query.length) {
    query = '?' + query;
  }

  var ipv6 = this.hostname.indexOf(':') !== -1;
  return schema + '://' + (ipv6 ? '[' + this.hostname + ']' : this.hostname) + port + this.path + query;
};

/**
 * Feature detection for WebSocket.
 *
 * @return {Boolean} whether this transport is available.
 * @api public
 */

WS.prototype.check = function () {
  return !!WebSocket && !('__initialize' in WebSocket && this.name === WS.prototype.name);
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(80).Buffer))

/***/ }),
/* 884 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = toArray

function toArray(list, index) {
    var array = []

    index = index || 0

    for (var i = index || 0; i < list.length; i++) {
        array[i - index] = list[i]
    }

    return array
}


/***/ }),
/* 886 */
/***/ (function(module, exports) {


/**
 * Expose `Backoff`.
 */

module.exports = Backoff;

/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */

function Backoff(opts) {
  opts = opts || {};
  this.ms = opts.min || 100;
  this.max = opts.max || 10000;
  this.factor = opts.factor || 2;
  this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
  this.attempts = 0;
}

/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */

Backoff.prototype.duration = function(){
  var ms = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var rand =  Math.random();
    var deviation = Math.floor(rand * this.jitter * ms);
    ms = (Math.floor(rand * 10) & 1) == 0  ? ms - deviation : ms + deviation;
  }
  return Math.min(ms, this.max) | 0;
};

/**
 * Reset the number of attempts.
 *
 * @api public
 */

Backoff.prototype.reset = function(){
  this.attempts = 0;
};

/**
 * Set the minimum duration
 *
 * @api public
 */

Backoff.prototype.setMin = function(min){
  this.ms = min;
};

/**
 * Set the maximum duration
 *
 * @api public
 */

Backoff.prototype.setMax = function(max){
  this.max = max;
};

/**
 * Set the jitter
 *
 * @api public
 */

Backoff.prototype.setJitter = function(jitter){
  this.jitter = jitter;
};



/***/ }),
/* 887 */,
/* 888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAXCAYAAAD6FjQuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAjlJREFUeNqslk+ITVEcx8997qPMTEmDmNQMJRY2YkFq3oKRpqaMxFJKGLEwG2JjZUMpITuKGFGTP6tRNjaajT8bs7NRZJAaUzNvxvU59b3NmdO5950x71efxT333Ps9v7/3JlmWLTHGJGbOZmEr3IAVZr7ZfZl3bby1kL2HAWPFIAXjcDVrvu1OdSrrzSZYD59g1DTf0sR6gp2GK9AGP+AkrIJbzuZf8B2WRb68Bdqd65oNWSdMei7PQD8cd9Y+wzYv3GV0wLjzfLf1rIbq68DJZuAwrHE8HIOHgQLxzaalA45BNffMirWrWtaVCK6G24vMWS3P2X54AssLTnlIObzj5XAClgaeyZSzNj9nFcW4D/4UlG0dDsIpZ+0jbIFE7eNi39cFP/2c5U1tQ9YLQzpVKKRHFNI8h6PanwQGw1o441RvzW3q/ES9MLEAD2Otu+JVlm3yl8rRZKgx4RF8U2+6Ni3vC60SWLNhHYEDJYJDEjzrrH+BHtisabQHfjcSs/G+qEra20BwHM5rrQvOwUaxQfucGp3LWeoM5GswC/tgV0mVXoAqfF1ozlybktfPVJk9AQ+va57W4VVMV1ca3LcN+wJavZDehUFn39NmiOWCz/Uh7YN7cAL+6v6ApvtYjFgWIWiH6bBG1lGVuZHoTYV5JEYsiRykVU18OzUuwQ6V9mPohDfKX/HX8z/Cu11chrcK8f2CETfv/yUt+R7FRGWniLF6SMyG9YFOvzIip4kTiaJDfoB3/wQYANhfVQuPQ/7LAAAAAElFTkSuQmCC"

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAalJREFUeNpi/P//PwMtAQuMUVNT4wGkAonQs7WlpWUTsRYwIbENgDgWiI3x4BAgXg10TAjJPoCCO0DXmeBSDDR4KdSSpUA2A1DtGlJ8QCzYDcTToZaE0MICkMsLoJasIGQJORZ4Aw0FJb18IGaGWiJBLQtqgNgECadALWEjNpIJBc19IHUfKdI5aRIHZGU0LMkxioBeW7ItAIK5QHwQjz45aMaUI8sCYFjvA1L7cPiuAkiB8C8gfg0V3gIU94fGEcVBBDI4C2jYLKhadVBSBeJdQLYeUPw7MZEMCqJ0NFwAsx9mONS3N4GUDxBLYHMU0UEEdJ0NlLkGi/qnQPnjQKYN1HEEg6gFSHmgCfND6e84fP0dW4bDlYpAkXUWizgoGJKBuBXNQYpAygmIc4kNornoXoUa9AhI1QHpL0A1E9EiGQRWouthhFWZ0OQHcl0EgaRdAa0T/kKTKchXF4AYZNF6II4DWv4Xlw9UgPgMkaUAM9RwEPCH6t0CxPOBjk2EWYJswQJoZUIOeAE08BHQYB+oJb+gJS0iiKgFgJaAIpsH1jBgpHWzBSDAAPtrmNNeLu6JAAAAAElFTkSuQmCC"

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAbJJREFUeNqk1E0rRFEYwPE713gdU0I2oiiykLKwECn5AF62fAHNip2UhZQ0xBeYKYrMblZiLbGxkBIWzMLsMCmvw8z1P3mmTrd77hWnfs3cO2eec5/nPudYjuNYmEYOrwYvyGJU5vsKWz+jHgWMy6d7tCKBtMxJW35Dos/j1mf1NtwjhU+M+z2prcUPIWxYO4JKzGMZKYyZHjRs/W44qMUhnlGOXfTh/K9B7zCFGhRRhTW0/CfoE7a162osSgaB6atJTZKq1x9U3XOw5XtgTR1pp1VMSJrukccK4jL/KyioWrkMC9jwCKqCDGEYB9LbjV5BbY97n3iTpyp5RT+W5OU84ARJTP6m+Xekwd816lqNGa3JQ1hEAV168+tBMwijFg2o12zi1LCDrhD32vt63TrR7KppL44ML/sMHUFvPyZbsKjdj+LeELQbe6aaZqROlYhKGZQI+qV2MVfqc8ij3ZS+LTvlQ9643tzHmMW6HH0X6MGgzBvAjTv9grTKtaQb8qj1mxwkI8KSdqrDlvyW1IOqQzeLioAzIK/VWi28j0c5aBJyL1EKein+OlYl23d18S3AANttqPHbrIvfAAAAAElFTkSuQmCC"

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#3365c1}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:332px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.student_name{text-transform:capitalize}.rcName{padding:10px;background:#d7edff;border-radius:5px;margin:5px;color:#3367c3;height:50px;border:1px solid #3365c1;border-left:5px solid #3365c1}</style> <md-dialog aria-label=\"Reject request\" class=\"flex-40 full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2> <font color=#FFFFFF>{{headers._heading}}</font> </h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <md-icon aria-label=\"Close dialog\">close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground style=padding:20px;height:100%> <div layout=row layout-wrap flex=100 layout-wrap style=background:#e1e9ef> <div ng-repeat=\"item in items track by $index\" flex=45 class=\"student_name rcName\"> {{$index+1}}<b>.</b>&nbsp;{{item.name}} </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex style=color:#e81717;font-size:14px> {{headers._warning}} </span> <md-button ng-disabled=headers._disableBtn class=\"md-raised md-accent\" ng-click=confirm()> {{headers._btnTxt}} </md-button> <md-button ng-disabled=headers._disableBtn class=\"md-raised md-primary\" ng-click=cancel() style=margin-right:20px> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#3365c1}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:332px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.student_name{text-transform:capitalize}#manage_reports_edit{font-family:Roboto Condensed}.confirm_true{border:1px solid #f21d00;border-radius:5px;color:#f21d00}.assigned_clas_headtxt{font-size:20px;font-weight:600;color:#416d3b}.txtgreen{color:#345230}.onconfrmstage{background:#ffcfb5}</style> <md-dialog aria-label=\"Reject request\" class=flex-80 ng-cloak id=manage_reports_edit> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2> <font color=#FFFFFF>REPORT - {{format.name}}</font> </h2> <span flex></span> </div> </md-toolbar> <md-backdrop style=position:fixed!important;z-index:59!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column layout-padding=\"\" class=\"md-whiteframe-3dp margin_20 layout-padding _md flex\" flex=100 style=background:#fff;margin-left:10px!important;padding:10px> <div layout=row> <md-input-container class=hundred_percent_width flex=50> <label>Report name</label> <input maxlength=name_length type=text ng-model=format.name> <div ng-if=format.name class=md-errors-spacer><div class=md-char-counter>{{format.name.length}} / {{name_length}}</div></div> <div ng-if=\"format.error && format.error.name && format.error.name.msg\" class=errorMessage> {{format.error.name.msg}}</div> </md-input-container> <md-input-container class=hundred_percent_width flex=50> <label>Display name</label> <input maxlength=display_name_length type=text ng-model=format.display_name> <div ng-if=format.display_name class=md-errors-spacer><div class=md-char-counter>{{format.display_name.length}} / {{display_name_length}}</div></div> <div ng-if=\"format.error && format.error.display_name && format.error.display_name.msg\" class=errorMessage> {{format.error.display_name.msg}}</div> </md-input-container> </div> <md-divider></md-divider> <md-input-container class=hundred_percent_width flex=80> <label>Report description</label> <input maxlength=40 md-maxlength=40 type=text ng-model=format.description> <div ng-if=\"format.error && format.error.description && format.error.description.msg\" class=errorMessage>{{format.error.description.msg}}</div> </md-input-container> <md-divider></md-divider> <div ng-class=\"{'confirm_true':updatorData.update}\" class=greenlabels layout=row layout-align=\"space-between center\"> <div layout=row layout-align=\"space-between center\"> <div ng-show=updatorData.update layout=row> <span> <b>Important Warning :</b>This action will affect all the report(s) generated till date. Proceed anyway? </span> </div> <div ng-show=updatorData.update layout=row layout-align=\"end end\"> <md-button title=\"Name and description update\" class=\"md-raised md-accent\" ng-click=doUpdate()> <i class=\"icons-margin hand far fa-save\"></i> SAVE </md-button> <md-button title=\"Cancel update\" class=\"md-raised md-primary\" ng-click=cancelUpdate()> Cancel </md-button> </div> </div> <div> <md-button ng-disabled=updatorData.update title=\"Update report name and description\" class=\"md-raised md-primary\" ng-click=saveMetadata()> <i class=\"far fa-save icons-margin hand\"></i> Update name and description </md-button> </div> </div> <md-divider></md-divider> <div ng-class=\"{'confirm_true':(format.can_delete_classes && class_removal.confirm)}\" class=greenlabels style=height:80px layout=row layout-align=\"space-between center\"> <div layout=row flex=60> <div class=assigned_clas_headtxt ng-show=!class_removal.confirm>Assigned classes</div> <div style=color:#f21d00 ng-show=\"format.can_delete_classes && class_removal.confirm\"> Are you sure to remove selected class(s)?. </div> </div> <div layout=row flex=40 layout-align=\"end end\"> <md-button ng-show=\"format.can_delete_classes && !class_removal.confirm\" class=\"md-raised md-primary\" ng-click=\"class_removal.confirm = true\"> <i class=\"icons-margin hand fas fa-trash-alt\"></i> Remove class(s) </md-button> <md-button ng-show=\"format.can_delete_classes && class_removal.confirm\" class=\"md-raised md-accent\" ng-click=removeClasses(format)> <i class=\"icons-margin hand fas fa-trash-alt\"></i> Remove </md-button> <md-button ng-show=\"format.can_delete_classes && class_removal.confirm\" class=\"md-raised md-primary\" ng-click=cancelClassRemovaval(format)> Cancel </md-button> <md-checkbox ng-disabled=\"format.can_delete_classes && class_removal.confirm\" ng-change=\"selectAllClassesPerReport(format, $event)\" ng-model=format.class_selection aria-label=\"Checkbox 1\"> {{format.class_selection_txt}} </md-checkbox> </div> </div> <md-divider></md-divider> <div style=max-height:400px;overflow:auto> <div flex layout-wrap=\"\" layout=row class=\"greenlabels layout-wrap layout-row flex\" ng-repeat=\"academic in format.assigned_academics\" style=margin-right:0> <div flex=100 class=txtgreen> <span style=padding-right:12px> {{academic.session}} </span> <span> {{academic.curriculum}} </span> </div> <div layout=row ng-repeat=\"class in academic.classes | orderBy : 'name'\" ng-if=academic.classes.length> <div> <div style=border-radius:5px layout=row class=border-box-rep ng-class=\"{'onconfrmstage':(format.can_delete_classes && class_removal.confirm && class.to_remove)}\"> <md-checkbox ng-change=\"oneClassSelection(format, class)\" style=margin:0!important ng-model=class.to_remove aria-label=\"Checkbox 1\" ng-disabled=\"format.can_delete_classes && class_removal.confirm\"> </md-checkbox> <div class=\"box-class-report txtgreen\" style=padding:7px> Class - {{class.name}}</div> </div> </div> </div> <div ng-if=!academic.classes.length> <div> <div layout=row class=border-box>No Classes Assigned</div> </div> </div> </div> </div> </div>  <md-dialog-actions layout=row> <span flex></span> <md-button class=\"md-raised md-primary\" ng-click=cancel() style=margin-right:20px> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#3365c1}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.student_name{text-transform:capitalize}.rcName{padding:10px;background:#d7edff;border-radius:5px;margin:5px;color:#3367c3;height:50px;border:1px solid #3365c1;border-left:5px solid #3365c1}</style> <md-dialog aria-label=\"Reject request\" class=\"flex-70 full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2> <font color=#FFFFFF>{{format.name}}</font> </h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <md-icon aria-label=\"Close dialog\">close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground style=padding:20px;height:100%> <div layout=row layout-wrap flex=100 layout-wrap style=background:#e1e9ef> <iframe ng-src={{format.url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button class=\"md-raised md-primary\" ng-click=cancel() style=margin-right:20px> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = " <style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}.activity_used h3{text-decoration:underline}.activity_used h5{text-decoration:underline}.activity_used p{font-weight:700}.activity_used h3.thick{font-weight:700}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly activity_used\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h3 style=text-decoration:none;color:#fff class=head>Information</h3> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <i class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground> <div layout-xs=column layout=row layout-wrap layout-padding> <div ng-if=!data.sub_skill_format class=rightborder ng-repeat=\"oneBucket in data.buckets\" flex=45 layout=row layout-wrap> <div layout-align=\"start center\"> <h5>{{oneBucket.skill}} ({{oneBucket.selection}}) </h5> Activities Used : <div ng-repeat=\"activity in oneBucket.activities_used\"> {{activity}} </div> </div> </div> <div ng-if=data.sub_skill_format class=rightborder ng-repeat=\"oneBucket in data.buckets\" flex=100 layout=column> <div layout-align=\"start center\"> <h3>{{oneBucket.skill}} </h3> <div ng-repeat=\"subSkill in oneBucket.sub_skills\"> <i class=material-icons></i> <p>{{subSkill.sub_skill_name}}({{subSkill.selection}})</p> Activities Used : <div ng-repeat=\"activity in subSkill.activities_used\"> {{activity}} </div> </div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = " <style>.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h3> Warning </h3> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <i aria-label=\"Close dialog\" class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=\"whitebackground md-padding\"> <div layout-xs=column layout=row layout-wrap layout-paddingl> <div class=rightborder ng-repeat=\"result in validationArray\" flex=45 layout=row layout-wrap> <div layout-align=\"start center\" ng-if=\"result.sub_skill.length==0\"> <i class=\"fas fa-times\"></i> {{result.skill_name}} contains no activities </div> <div layout-align=\"start center\" ng-if=\"result.sub_skill.length>0\"> <span class=head> Skill : {{result.skill_name}}</span> <div ng-repeat=\"sub in result.sub_skill\"> <i class=\"fas fa-times\"></i> {{sub}} contains no activities </div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:332px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}</style> <md-dialog aria-label=\"Reject request\" class=\"flex-40 full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2> <font color=#FFFFFF>STUDENTS</font> </h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <i class=\"fas fa-lg fa-times color-white\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=\"whitebackground md-padding\"> <div layout=row layout-wrap flex> <div flex-xs flex=50> <md-checkbox aria-label=\"Select All\" ng-checked=isChecked() md-indeterminate=isIndeterminate() ng-click=toggleAll()> <span ng-if=isChecked()>Un-</span>Select All </md-checkbox> </div> <div ng-repeat=\"item in items\" flex=100> <md-checkbox ng-checked=\"exists(item, selected)\" ng-click=\"toggle(item, selected)\">{{item.user_name}}</md-checkbox> </div> </div> </md-dialog-content> <md-dialog-actions layout=row style=\"border-top:1px solid #d2d2d2\"> <span flex></span> <md-button ng-click=confirm()> Confirm </md-button> <md-button ng-click=cancel() style=margin-right:20px> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}table,td,th{border:1px solid grey;border-collapse:collapse;padding:5px}table tr:nth-child(odd){background-color:#f1f1f1}table tr:nth-child(even){background-color:#fff}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal md-makeMeWhite-theme\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=\"coloroftext ng-binding\"> Not mapped students count </h1> <span flex=\"\" class=flex></span> <button class=\"md-icon-button md-button md-ink-ripple color_black\" type=button ng-click=cancel()> <span class=ng-scope> <i class=\"fas fa-times\"></i> </span></button> </div> </md-toolbar> <md-dialog-content> <div layout-xs=column layout=column layout-padding> <div class=mapping-border layout=row ng-repeat=\"object in notMappedStatusArray\"> <div flex=70 layout=row layout-align=\"start center\"> {{object.session}}&nbsp;{{object.curr}}&nbsp;{{object.xclass}}&nbsp;{{object.batch}} </div> <div flex=20 layout=row layout-align=\"center center\"> <p><b>{{object.count}}</b></p> </div> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:332px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}</style> <md-dialog aria-label=\"Reject request\" class=viewOnly ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2><font color=#FFFFFF>STUDENTS</font></h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <i class=\"fas fa-lg fa-times color-white\"></i> </md-button> </div> </md-toolbar> <div class=\"md-whiteframe-2dp reports\"> <div ng-if=\"studentList && studentList.length\" layout=row flex layout-padding layout-wrap> <div title=\"Click to get report of this student\" style=cursor:pointer ng-if=student.user_name layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=30 ng-repeat=\"student in studentList\" ng-click=gotoStudentSubjectReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"far fa-user-circle fa-lg\"></i> <b flex=85>{{student.user_name}}</b> </div> </div> </div> <div ng-if=\"studentList && studentList.length == 0\" layout=row flex layout-padding layout-wrap> <div title=\"\" style=cursor:pointer layout=row class=\"md-whiteframe-3dp list-container\" flex=100 flex-xs=75 flex-sm=30> <div layout=row flex layout-align=space-between> <b flex=85>No students found.</b> </div> </div> </div> </div> </md-dialog> ";

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:500px;height:332px}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}</style> <md-dialog aria-label=\"Reject request\" class=viewOnly ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2><font color=#FFFFFF>STUDENTS</font></h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <i class=\"fas fa-lg fa-times color-white\"></i> </md-button> </div> </md-toolbar> <div class=\"md-whiteframe-2dp reports\"> <div ng-if=\"studentList && studentList.length\" layout=row flex layout-padding layout-wrap> <div ng-if=student.user_name layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=30 ng-repeat=\"student in studentList\" ng-click=gotoStudentSubjectReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"far fa-user-circle fa-lg\"></i> <b flex=85>{{student.user_name}}</b> </div> </div> </div> <div ng-if=\"studentList && studentList.length == 0\" layout=row flex layout-padding layout-wrap> <div title=\"\" style=cursor:pointer layout=row class=\"md-whiteframe-3dp list-container\" flex=100 flex-xs=75 flex-sm=30> <div layout=row flex layout-align=space-between> <b flex=85>No students found.</b> </div> </div> </div> </div> </md-dialog> ";

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAddJREFUeNrk1D9IVWEYx/FzjscazK5kScE1DEeH7KKGi17CHNyUChTuYhFBSEGKg5vgIIJ/CJQLDUG1NFikDkKES/eCVENew8WhJC9mkZUKann7vvI78XIQWmzqhQ+cP8/78Lx/3Vwu5xxk85wDbv88YTWe4x2mEUchKnEex1COh5jDK1xGXpDAteYwikHEcFdJf+A6amECP2AY6ziDG+rbhdTek0kol7CKRr1H8AxLSCCONDKoVEwpFtELz3yzh3wUO/io9xpcQA8eYEbVnsRFxaxgDQXID8/hLD6hE6dwCJtYtWLW9X4YR3ALRUhjK5zQfJhQVX3q+A1tiCjmCk4go2o7VPmyWY9gDosxrLl4ghhKUISbyOINUlhBEsfV7zRG1fcpyk3CASygQxNrVr4Jr/ESrbiKO2jRQr3HbRQovgGzuG8SPsakVsxR5894hLpg9SwV6McaxvQtH0Mmj8+otzXJQatHFu3BRIfaPLpRhir41r9tTxs2qq1gVva7Vvdvx9LEfNGWMUVUmK1jOiWxhATO4ZeOkhfiWhzruJktdk3F3HP3ub5GNNxxbFgJ/hxXjaoZb9GEn8FPf5+hvFClZ7Ebqs5XZeb5K6bsZOHL4T+5YH8LMACexl1mQfQeTgAAAABJRU5ErkJggg=="

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.renameClub .post_title{margin-top:30px}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite renameClub\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>Rename Club</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important;margin-left:30px> <md-input-container class=\"md-block post_title\" flex-gt-sm> <label>Enter New Name</label> <input ng-model=postTitle id=club_title> </md-input-container> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=update()> UPDATE </md-button> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=cancel()> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.deleteClub .post_title{margin-top:30px}.dele_txt{min-height:90px;padding-top:20px;text-align:center}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite deleteClub\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>Delete Club</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-padding md-theme=altTheme style=background:#fff!important;margin-left:30px> <div class=dele_txt>Are you sure you want to delete this club ?</div> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button ng-click=clubDelete()> Yes </md-button> <md-button ng-click=cancel()> No </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.createBox .post_title{margin-top:30px}.upload_img{width:20px}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite createBox clubActivityCtrl\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 flex=50 class=coloroftext>Add New Post</h1> <div flex=50 layout-align=\"end end\" layout=row> <i class=\"fas fa-plus\" ng-click=cancel()></i> </div> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important;margin-left:30px> <md-input-container class=\"md-block post_title\" flex-gt-sm style=width:940px> <label>Enter Title</label> <textarea ng-model=postTitle md-maxlength=80 txt-maxlength=80 md-select-on-focus></textarea> </md-input-container> <div layout=column class=upload_image> <div><img class=upload_img src=" + __webpack_require__(391) + " alt=upload>&nbsp; Upload Image / Video </div> <div> <md-button class=\"md-raised md-primary md-hue-1 noleftMargin\" ngf-max-size=100MB ngf-resize=\"{width: 400, height: 400, centerCrop: false}\" ngf-pattern=image/*,video/* ngf-min-height=100 ng-model=picFile accept=image/*,video/* ngf-select=showFileSelect($files) style=margin-left:-3px> Browse </md-button> </div> <div> <p style=word-break:break-all ng-if=picFile.name> {{picFile.name}}</p> </div> <div class=loading-progress> <md-progress-circular ng-if=uploading md-mode=determinate></md-progress-circular> <span flex ng-if=uploading>Please wait... Loading </span> </div> </div> <div class=text_area style=margin-top:20PX> <textarea ng-model=postTitleArea md-select-on-focus placeholder=\"Enter Description\" style=border-color:£e0e0e0;background:#fff;white-space:pre-wrap;height:178px;width:99%;padding:10px;resize:none></textarea> <error-msg class=redAlert msg=errors.message></error-msg> </div> <div layout=row layout-align=\"space-around center\"> <div> <div layout-wrap layout=row> <div ng-if=picFileVid>&nbsp;&nbsp;&nbsp; <img ng-show=picFile ng-src={{myImage}} class=\"img_previewd crop_Area\"/> </div> </div> <div></div> </div> </div></md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button class=\"button_font md-button md-ink-ripple\" ng-if=hidePopupButtons ng-click=postComment()> POST </md-button> <md-button class=\"button_font md-button md-ink-ripple\" ng-if=hidePopupButtons ng-click=cancel()> Cancel</md-button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.editLogo .post_title{margin-top:30px}.logo_area{padding:20px 0}.btn_area{padding:10px 0}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite editLogo\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>Edit Club Logo</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important;margin-left:30px> <div layout=row> <div class=logo_area> <img src={{postLogo}} ng-show=!picFile> <img ng-show=picFile src={{myImage}} class=img_previewd /> </div> </div> <div class=\"file-field input-field btn_area\" flex layout=row> <span><img src=" + __webpack_require__(391) + " alt=upload>&nbsp; Upload Image <md-button class=\"md-raised md-primary md-hue-1\" ngf-max-size=20MB ngf-resize=\"{width: 150, height: 150, centerCrop: false}\" ngf-pattern=\"'image/*'\" ngf-min-height=100 ng-model=picFile accept=image/* ng-click=showFooterBtns() ngf-select=editFileSelect($files)> Browse </md-button> </span> </div> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=updateLOGO() ng-if=edit_logo_btn> UPDATE </md-button> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=cancel()> Cancel </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.editLogo .post_title{margin-top:30px}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite editLogo\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>View Club Activity</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important;padding-bottom:5px;padding-top:15px> <span ng-if=\"post_type =='image'\"> <img src={{post_URL}} alt=logo style=\"margin:0 auto;display:table\" on-error=clubActivity/icons/loader.gif></span> <iframe src={{post_URL}} autoplay=false ng-if=\"post_type =='video'\" style=width:100%;height:420px></iframe> <p style=border:none;background:#fff;white-space:pre-wrap ng-if=\"post_type =='text'\" on-error=clubActivity/icons/loader.gif>{{post_URL}}</p> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=cancel()> Close </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.commentBox .commentBox{padding-left:35px;padding-bottom:10px;padding-top:10px;border-bottom:1px solid #e6e6e6}.commentBox .comment{font-size:18px}.commentBox .user_name{font-size:16px;font-weight:700}.commentBox .del_comment{outline:0}.del_cmt{padding-left:40px}.cmtEdit{padding-left:20px}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite commentBox\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>My Comment</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important> <div flex=100 layout=row class=commentBox> <div flex=80> <div class=comment><span class=user_name></span>{{comment}} </div> </div> </div> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom> <div layout=row layout-align=\"space-around end\"> <div></div> <div> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=cancel()> Close </md-button> </div> </div> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.user_img{width:40px;padding-bottom:10px;padding-top:6px}.user_name{font-size:15px;font-weight:700}.likeBox{margin-left:5px;border-bottom:1px solid #e6e6e6}</style> <md-backdrop style=z-index:60!important ng-show=likesIsLoading class=loading-opacity layout=column layout-align=\"center center\"> 2 <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> 3 <span class=loadinfTxt style=color:#fff>Loading, please wait ...</span> 4: </md-backdrop> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite LokeBox\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>Members Who Liked</h1> </div> </md-toolbar> <md-dialog-content> <md-content md-theme=altTheme style=background:#fff!important> <div layout-align=\"space-around center\" layout=row class=likeBox ng-repeat=\"likedUser in likedUserDetail\"> <div> <img class=user_img src={{likedUser.image}} alt={{likedUser.name}}> </div> <div class=user_name flex=85> {{likedUser.name}} </div> <md-divider></md-divider> </div> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom layout=row> <md-button ng-click=cancel()> Close </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.commentBox .commentBox{padding-left:35px;padding-bottom:10px;padding-top:10px;border-bottom:1px solid #e6e6e6}.commentBox .comment{font-size:18px}.commentBox .user_name{font-size:16px;font-weight:700}.commentBox .del_comment{outline:0}.del_cmt{padding-left:40px}.cmtEdit{padding-left:20px}.cmt_date{float:right;font-size:10px;color:#00bcd5}.updateBox{margin:10px;padding-top:5px}.text_wrap{word-wrap:break-word}</style> <md-backdrop style=z-index:60!important ng-show=commentsIsLoading class=loading-opacity layout=column layout-align=\"center center\"> 2 <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> 3 <span class=loadinfTxt style=color:#fff>Loading, please wait ...</span> </md-backdrop> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite commentBox\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>All Comments</h1> </div> </md-toolbar> <md-dialog-content> <div layout=column class=updateBox> <md-input-container class=comment_width style=width:100% ng-if=showCommentBox layout=column> <label>Update comment ...</label> <textarea ng-model=commentText rows=2 id=cmt name=cmt></textarea> </md-input-container> </div> <md-content md-theme=altTheme style=background:#fff!important> <div flex=100 layout=row class=commentBox ng-repeat=\"com in userComments | orderBy : '-added_date'\"> <div flex=80> <div class=comment><span class=user_name>{{com.user_name}}</span>: <span class=text_wrap> {{com.comment}} </span> <span class=cmt_date>{{com.added_date | date}}</span> </div> </div> <div class=\"del_comment hand del_cmt\" flex=10 ng-click=deleteComment(com) ng-if=\"com.user_id == logedUser\"> <img src=" + __webpack_require__(386) + " alt=\"delete comment\"> </div> <div class=\"del_comment hand cmtEdit\" flex=10 ng-if=\"com.user_id == logedUser\"> <img src=" + __webpack_require__(915) + " class=hand alt=\"edit comment\" ng-click=editComment(com)> </div> </div> </md-content> </md-dialog-content> <md-dialog-actions class=borderbottom> <div layout=row layout-align=\"space-around end\"> <div> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=updateComment() ng-if=showCommentBox> Update </md-button> </div> <div></div> <div> <md-button class=\"md-raised md-primary md-button md-ink-ripple\" ng-click=cancel()> Close </md-button> </div> </div> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxMy4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDE0OTQ4KSAgLS0+DQo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjE4cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE4IDE4IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxOCAxOCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8ZyBpZD0iUGFnZS0xIj4NCgk8ZyBpZD0iQ29yZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIxMy4wMDAwMDAsIC0xMjkuMDAwMDAwKSI+DQoJCTxnIGlkPSJjcmVhdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMy4wMDAwMDAsIDEyOS4wMDAwMDApIj4NCgkJCTxwYXRoIGlkPSJTaGFwZSIgZmlsbD0iIzcxNzE3MSIgZD0iTTAuNSwxMy44NThWMTcuNWgzLjY0MkwxNC42ODQsNi44NjJsLTMuNjQyLTMuNjQyTDAuNSwxMy44NThMMC41LDEzLjg1OHogTTE3LjQ2Myw0LjA4Mw0KCQkJCWMwLjM4My0wLjM4MywwLjM4My0wLjk1OCwwLTEuMzQybC0yLjIwNC0yLjIwNWMtMC4zODQtMC4zODMtMC45NTgtMC4zODMtMS4zNDIsMGwtMS43MjYsMS43MjZsMy42NDIsMy42NDJMMTcuNDYzLDQuMDgzDQoJCQkJTDE3LjQ2Myw0LjA4M3oiLz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KICAgIDxwYXRoIGQ9Ik0xOSA0SDVjLTEuMTEgMC0yIC45LTIgMnYxMmMwIDEuMS44OSAyIDIgMmg0di0ySDVWOGgxNHYxMGgtNHYyaDRjMS4xIDAgMi0uOSAyLTJWNmMwLTEuMS0uODktMi0yLTJ6bS03IDZsLTQgNGgzdjZoMnYtNmgzbC00LTR6Ii8+Cjwvc3ZnPg=="

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <md-dialog aria-label=\"Subject Endorsed\" flex=40 class=\"md-whiteframe-3dp user-management-popup subjPOP\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 class=coloroftext>Subject Package</h1> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <md-icon class=\"material-icons close_btn\">clear</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content style=width:100%!important> <md-content class=md-padding> <div layout-padding></div> <div class=ng-scope> <div class=\"mgmtLightBox layout-column\" layout-padding layout=column layout-sm=column layout-wrap> <div class=\"box pading10\"> <md-input-container flex> <label>Package Name</label> <input type=text maxlength=25 ng-model=packData.name ng-disabled=true> <error-msg class=redAlert msg=errors.name></error-msg> </md-input-container> </div> </div> <div class=mgmtLightBox layout-padding layout=column layout-sm=column layout-wrap flex> <div class=\"box pading10\" layout=row ng-repeat=\"subData in packData.list\"> <md-input-container class=iptCnter> <label>Enter Subject Name</label> <input ng-model=subData.name> <error-msg class=redAlert msg=errors.list[$index].name></error-msg> </md-input-container> <md-button class=\"btn md-raised\" ng-show=\"packData.list.length > 1\" ng-click=\"removeSubject(subData, $index)\" style=height:36px;top:25px><img alt=additionalResourcesFlash class=imageSize src=" + __webpack_require__(918) + "></md-button> </div> <div> <md-button class=md-raised ng-click=addSubject()> Add New Subject</md-button> </div> </div> </div> <div> <md-button class=\"md-primary md-raised\" ng-click=updateSubPckage()> {{ isEdit?\"Update\": \"Save\" }} </md-button> <md-button class=\"md-primary md-raised\" ng-click=cancel()> Cancel </md-button> </div> </md-content> </md-dialog-content> </md-dialog>";

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAACCAIAAAAIKhHDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABVJREFUeNpi1NPTYyAaMDGQAgACDAAxmACOsmGDkAAAAABJRU5ErkJggg=="

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.controlsbtn{float:left}.right-space-btn{margin-right:30px!important}.icon_con{padding-top:2px!important;padding-left:0!important;width:auto!important;height:auto!important;margin:0}.common-filter-add{text-transform:capitalize;font-size:14px;border:2px solid #fff;border-radius:25px;padding-left:8px;padding-bottom:0;padding-top:0;background-color:#1665c1;color:#fff;min-height:30px;line-height:30px}.auto_w_h{width:auto!important;height:auto!important}.userImg{height:50px}.user-management .aroundSpace{margin:20px}.userManPad20{padding:20px}.userManPad5{padding-bottom:5px}.customfooter{margin-top:0!important}.userBtnStyle{background-color:#1665c1!important;border:2px solid #fff;border-radius:26px;color:#fff!important}.listes{margin-right:20px;min-width:30%;margin-bottom:20px;border-top:1px solid #e6e6e6;height:125px}.filter_title{margin-left:0;margin-right:0;padding-left:10px;padding-right:10px;background-color:#009bee;color:#fff}ul{max-height:85px;overflow:auto}.show-dropdown{height:40px;margin-top:10px;min-width:140px}.custom-btn{background:#a8d5fc;color:#165aad}.btn-filter{min-width:186px;border:none;border-radius:2px;display:inline-block;height:36px;line-height:36px;outline:0;padding:0 2rem;text-transform:lowercase;vertical-align:middle;-webkit-tap-highlight-color:transparent;text-decoration:none;color:#265ca2!important;background-color:#b1d4fe;text-align:left;letter-spacing:.5px}.dropdown-menu{position:absolute;top:100%;left:0;width:205px;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;font-size:14px;text-align:left;list-style:none;background-color:#fff;-webkit-background-clip:padding-box;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;-webkit-box-shadow:0 6px 12px rgba(0,0,0,.175);box-shadow:0 6px 12px rgba(0,0,0,.175)}.btn-primary{color:#fff;background-color:#b1d4fe;border-color:#2e6da4}.display-size{font-size:13px!important}</style> <md-backdrop style=z-index:60!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column md-theme=makeMeWhite id=filter class=\"margin_20 md-whiteframe-3dp bgColor pages\"> <div flex class=filter_title layout=row layout-align=\"space-between start\" flex=10> <h4>Advance Filter</h4> </div> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding style=z-index:0> <md-input-container class=bottom-0-margin-bottom flex ng-if=visibleRole> <label>Role</label> <md-select ng-model=\"filterObj['role_id']\" ng-disabled=multipleBatchFilterCtrl.hideSelect> <md-option ng-value=roleName._id ng-click=\"multipleBatchFilterCtrl.getRoleDetails(roleName._id); setFilterObj(roleName._id,'role_id')\" ng-repeat=\"roleName in multipleBatchFilterCtrl.allRoles\">{{roleName.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=showAcademicFilters> <label>Session</label> <md-select ng-model=\"filterObj['session']\" ng-change=\"setSessionFilters(filterObj['session'])\"> <md-option value={{sesName._id}} ng-click=\"multipleBatchFilterCtrl.getCuriculum(sesName._id);setFilterObj(sesName._id,'Session')\" ng-repeat=\"sesName in multipleBatchFilterCtrl.sessions\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=showAcademicFilters> <label>Curriculum</label> <md-select ng-model=\"filterObj['curriculum']\"> <md-option value={{curName._id}} ng-click=\"multipleBatchFilterCtrl.getClass(curName._id);setFilterObj(curName._id,'Curriculum')\" ng-repeat=\"curName in multipleBatchFilterCtrl.showCurriculumName\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=\"showAcademicFilters && stateId=='userManagement'\"> <label>Class</label> <md-select ng-change=\"selectClasses(filterObj['singlefieldclass']);\" ng-model=\"filterObj['singlefieldclass']\"> <md-option value={{clsName._id}} ng-repeat=\"clsName in multipleBatchFilterCtrl.showClassName\" ng-click=\"multipleBatchFilterCtrl.getBatch(clsName._id);setFilterObj(clsName._id,'Class')\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=\"showAcademicFilters && stateId !='userManagement'\"> <label>Class</label> <md-select ng-change=\"selectClasses(filterObj['xclass']);\" ng-model=\"filterObj['xclass']\" multiple=multiple> <md-checkbox ng-model=multipleBatchFilterCtrl.checkAllClass ng-if=isClass ng-change=\"selectClasses('all');\" aria-label=\"Checkbox 1\" style=margin-bottom:0;margin-left:10px> All </md-checkbox> <md-option value={{clsName._id}} ng-click=\"multipleBatchFilterCtrl.getBatch(clsName._id);setFilterObj(clsName._id,'Class')\" ng-repeat=\"clsName in multipleBatchFilterCtrl.showClassName\"> {{clsName.name}}</md-option> </md-select> <md-select ng-change=\"selectClasses(filterObj['xclass']);\" ng-model=\"filterObj['xclass']\" ng-if=isSingle> <md-option value={{clsName._id}} ng-repeat=\"clsName in multipleBatchFilterCtrl.showClassName\" ng-click=\"multipleBatchFilterCtrl.getBatch(clsName._id);setFilterObj(clsName._id,'Class')\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=\"showAcademicFilters && showbatch\"> <label style=color:#2196f3!important>Batch</label> <md-select ng-change=\"selectBatches(filterObj['batch'])\" ng-model=\"filterObj['batch']\" ng-if=!isSingle multiple=multiple> <md-checkbox ng-model=multipleBatchFilterCtrl.checkAll ng-if=isBatch ng-change=\"selectBatches('all');\" aria-label=\"Checkbox 1\" style=margin-bottom:0;margin-left:10px> All </md-checkbox> <md-option value={{batch._id}} ng-repeat=\"batch in multipleBatchFilterCtrl.showMultiBatch\" ng-click=\"multipleBatchFilterCtrl.getSubject(batch._id);setFilterObj(batch._id,'Batch')\"> {{batch.name}}</md-option> </md-select> <md-select ng-change=\"selectBatches(filterObj['batch'])\" ng-model=\"filterObj['batch']\" ng-if=isSingle> <md-option value={{batch._id}} ng-repeat=\"batch in multipleBatchFilterCtrl.showMultiBatch\" ng-click=\"multipleBatchFilterCtrl.getSubject(batch._id);setFilterObj(batch._id,'Batch')\"> {{batch.name}}</md-option> </md-select> </md-input-container> <md-input-container class=bottom-0-margin-bottom flex ng-if=announcementForAll> <md-checkbox ng-model=multipleBatchFilterCtrl.checkAnnouncementReceivers ng-change=selectAnnouncementReceivers(multipleBatchFilterCtrl.checkAnnouncementReceivers); aria-label=\"Send to all\" style=margin-bottom:0;margin-left:10px> Send to all </md-checkbox> </md-input-container> <md-input-container flex ng-if=showSubject> <label>Subject</label> <md-select ng-change=\"selectSubject(filterObj['subject']);\" ng-model=\"filterObj['subject']\" ng-if=!isSingle multiple=multiple> <md-checkbox ng-model=multipleBatchFilterCtrl.checkAllSubject ng-if=isSubject ng-change=\"selectSubject('all');\" aria-label=\"Checkbox 1\" style=margin-bottom:0;margin-left:10px> All </md-checkbox> <md-option value={{subject._id}} ng-repeat=\"subject in multipleBatchFilterCtrl.showMultiSubject\" ng-click=\"setFilterObj(subject._id,'Subject')\"> {{subject.name}}</md-option> </md-select> <md-select ng-change=\"selectSubject(filterObj['subject']);\" ng-model=\"filterObj['subject']\" ng-if=isSingle> <md-option value={{subject._id}} ng-repeat=\"subject in multipleBatchFilterCtrl.showMultiSubject\" ng-click=\"setFilterObj(subject._id,'Subject')\"> {{subject.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=showChart> <label>Chart</label> <md-select ng-model=\"filterObj['chart']\"> <md-option value={{chart.type}} ng-repeat=\"chart in chartTypes\" ng-click=\"setFilterObj(chart.type,'Chart')\"> {{chart.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=showMultiRole> <label>Multi Role</label> <md-select ng-model=\"filterObj['multirole']\"> <md-option value={{multirole._id}} ng-repeat=\"multirole in multiRoles\" ng-click=\"setFilterObj(multirole._id,'Multi')\"> {{multirole.name}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block ng-if=showDate flex-gt-sm> <label>Select Date</label> <input mdc-datetime-picker=\"\" time=false date=true type=text max-date=currDate min-date=minDate ng-model=txtDOB class=md-input id=input_0> </md-input-container> <div flex layout=row ng-if=blnsearchValuesBasedOnFilterOnComponent layout-align=\"center center\"> <md-button class=\"md-fab md-mini md-primary md-hue-2 search_animation\" aria-label=search ng-click=multipleBatchFilterCtrl.searchValuesBasedOnFilterOnComponent() style=margin-left:20px;min-width:35px!important;margin-bottom:20px> <img style=width:23px src=" + __webpack_require__(84) + "> </md-button> </div> <div flex layout=row ng-show=blnsearchValuesBasedOnFilter layout-align=\"center center\"> <md-button class=\"md-fab md-mini md-primary md-hue-2 search_animation\" aria-label=search ng-click=\"saveFilterDataToStorage(); searchValuesBasedOnFilter()\"> <img src=" + __webpack_require__(84) + "> </md-button> </div> <div id=filterlist ng-if=showSavedSearchField class=\"dropdown show-dropdown\" data-ng-class=\"{open: open}\"> <button style=border:0;border-radius:4px;border-color:#204d74;background-color:#b1d4fe!important;color:#265ca2!important;text-transform:uppercase;width:100% data-ng-click='openDropdown(\"data\")' data-toggle=dropdown class=\"btn-filter btn-primary dropdown-toggle\" style=text-transform:capitalize>{{selectedFilterData}} <span class=caret style=float:right;position:relative></span> </button> <ul class=\"custom-dropdown-new dropdown-menu\" aria-labelledby=dropdownMenu style=\"margin:8px 7px 0;width:189px!important\"> <li layout=row data-ng-repeat=\"savedDet in savedSearchData\"> <a flex=90 ng-click=getSavedData(savedDet)> {{savedDet.title}} </a> <div flex=10> <img style=width:14px ng-click=deleteSearch(savedDet) src=" + __webpack_require__(920) + " alt=Add /> </div> </li> </ul> </div> <md-input-container class=bottom-0-margin-bottom md-block ng-if=showSavedSearchField style=width:16%> <label>Enter filter name</label> <input ng-model=multipleBatchFilterCtrl.saveName md-maxlength=20 txt-maxlength=20> </md-input-container> <md-button ng-if=showSavedSearchField class=\"md-primary md-raised\" style=height:5px;padding-top:0;margin-top:19px aria-label=search ng-click=saveSearchFilter()> <img src=" + __webpack_require__(921) + " style=padding-bottom:2px;width:15px;margin-right:6px>Save Filter </md-button> </div> </div> <div ng-if=\"showFilteredUsers && userNamesNotEndorsed.length>=1\" layout=column md-theme=makeMeWhite class=\"margin_20 md-whiteframe-3dp bgColor pages\" style=margin-bottom:95px!important> <div flex class=filter_title layout=row layout-align=\"space-between start\" flex=10> <h4>Members</h4> </div> <md-content ng-if=showFilteredUsers class=md-padding class=\"controls space-around md-whiteframe-3dp margin_20 bgColor pages\"> <div layout=row layout-align=\"space-between center\"> <div ng-if=\"userNamesNotEndorsed.length>=1\"> <md-input-container class=\"studentSearch iconLeft md-icon-float md-icon-right\" style=width:250px;padding:0> <label style=z-index:0>Filter User </label> <i class=\"fas fa-search font-icon-size ng-scope\" style=float:right;color:#717171></i> <input type=text ng-model=multipleBatchFilterCtrl.searchUser autocomplete=off> </md-input-container> </div> <div style=height:94px> <a>showing {{multipleBatchFilterCtrl.pager.startIndex+1}} - {{multipleBatchFilterCtrl.pager.endIndex+1}} / {{multipleBatchFilterCtrl.pager.totalItems}} entries</a></div> <div ng-if=\"multipleBatchFilterCtrl.Items>multipleBatchFilterCtrl.limit\" class=text-center> <ul ng-if=multipleBatchFilterCtrl.pager.pages.length class=pagination> <li ng-class=\"{disabled:multipleBatchFilterCtrl.pager.currentPage === 1}\"> <a ng-click=multipleBatchFilterCtrl.setPage(1)>First</a> </li> <li ng-class=\"{disabled:multipleBatchFilterCtrl.pager.currentPage === 1}\"> <a ng-click=\"multipleBatchFilterCtrl.setPage(multipleBatchFilterCtrl.pager.currentPage - 1)\">Prev</a> </li> <li ng-class=\"{disabled:multipleBatchFilterCtrl.pager.currentPage === multipleBatchFilterCtrl.pager.totalPages}\"> <a ng-click=\"multipleBatchFilterCtrl.setPage(multipleBatchFilterCtrl.pager.currentPage + 1)\">Next</a> </li> <li ng-class=\"{disabled:multipleBatchFilterCtrl.pager.currentPage === multipleBatchFilterCtrl.pager.totalPages}\"> <a ng-click=multipleBatchFilterCtrl.setPage(multipleBatchFilterCtrl.pager.totalPages)>Last</a> </li> </ul> </div> </div> <div class=\"studLists divfixedList\"> <div layout=column ng-repeat=\"acade in multipleBatchFilterCtrl.userNotEndorsedAcademic | orderBy\" ng-init=\"outerNotEndorsedIndex = $index\" flex class=\"normalHeadColor att_border_cls\"> <md-content flex layout-padding class=md-whiteframe-3dp> <div layout=row layout-align=\"end start\"> <div flex class=bold_text>{{acade}}</div> <div ng-show=\"multipleBatchFilterCtrl.searchUser===undefined || multipleBatchFilterCtrl.searchUser===null || multipleBatchFilterCtrl.searchUser==='' \"> <md-checkbox ng-if=\"filterObj.role_id!='student'\" md-no-ink class=md-primary ng-model=multipleBatchFilterCtrl.allItemsSelected[multipleBatchFilterCtrl.pager.currentPage] aria-label=\"Checkbox 1\" ng-change=\"multipleBatchFilterCtrl.selectAllNotEndorsed(multipleBatchFilterCtrl.allItemsSelected[multipleBatchFilterCtrl.pager.currentPage], $index, acade)\"> Select All</md-checkbox> <md-checkbox ng-if=\"filterObj.role_id==='student'\" md-no-ink class=md-primary ng-model=multipleBatchFilterCtrl.allItemsSelected[multipleBatchFilterCtrl.pager.currentPage][outerNotEndorsedIndex] aria-label=\"Checkbox 1\" ng-change=\"multipleBatchFilterCtrl.selectAllNotEndorsed(multipleBatchFilterCtrl.allItemsSelected[multipleBatchFilterCtrl.pager.currentPage][outerNotEndorsedIndex], outerNotEndorsedIndex, acade)\">Select All </md-checkbox> </div> </div> <div flex layout=row layout-wrap layout-align=\"start center\"> <div class=md-whiteframe-3dp flex=30 layout=column layout-margin ng-if=\"personList.academic_details===acade\" ng-repeat=\"personList in userNamesNotEndorsed | filter : multipleBatchFilterCtrl.searchUser | orderBy : 'name'\"> <div layout=column layout-align=space-between flex class=user-list-height> <div layout=row flex layout-xs=column layout-sm=column> <div flex-gt-xs=30 flex-lg=20 flex=20 flex-sm=20> <div class=imgs> <span ng-if=\"personList.image && personList.image.original\"> <img class=userImg ng-src={{personList.image.original}} /> </span> <span ng-if=\"!personList.image || !personList.image.original\"> <img class=userImg src=" + __webpack_require__(392) + "> </span> </div> </div> <div flex-sm=70 flex-gt-xs=60 flex-lg=70 flex=70> <div layout=row class=\"name display-name\"> {{personList.name}} </div> <div layout=row class=\"name display-size\" ng-if=personList.username> {{ personList.username | limitTo: 25 }}{{personList.username.length > 25 ? '...' : ''}} </div> <div layout=row ng-if=personList.employee_no class=name> {{UniqueNoText}} : <span class=display-name>{{personList.employee_no}}</span> </div> </div> <div ng-if=\"personList.isExists === undefined\" flex flex-sm flex-gt-xs flex-lg> <md-checkbox md-no-ink ng-model=personList.isChecked ng-change=\"multipleBatchFilterCtrl.getClickedNotEndorsedUser(personList, outerNotEndorsedIndex, acade)\" class=\"checkbxinput md-primary\" aria-label=\"Checkbox_{{$index+1}} checked checkbox\"> </md-checkbox> </div> </div> </div> </div> </div> </md-content> </div> </div> </md-content> </div> <footer ng-if=showFilteredUsers class=\"filter-footer md-whiteframe-3dp\" style=background:#1665c1> <div layout=row flex style=background:#1665c1;overflow-x:auto;padding-left:10px;padding-right:10px layout-align=\"space-around center\"> <div flex layout=row layout-align=\"space-around center\"> <div layout=row layout-align=\"start center\" ng-click=ProcessValue()> <md-button class=bottom_ctrl-btn aria-label=Add>{{buttonName}} <i class=\"fas fa-check\"></i> </md-button> </div> </div> </div> </footer>";

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAYAAADNX8xBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAaFJREFUeNrMlE8oBGEUwGe23fXfQf5Eqzg4uBCllIP8uSgHNzdydXFbZ+XguMpBnFBqXVwUOYhVDo4OK0oruXBQRNi1O35veqNRs5ndvXj1a9438+Z9773vvc+0LMvwkttwUwuPDegFMdqBubb0Q8bLPmjkl3UwoQfqYQ/uYMnL2JSI2H0EfRxqIAvlMAX7cK3vxqAdNnWDADzCFlFemqlQo/ywBifwogaSyqs6DOmm75CDKl2L8wh0wKg4SqJs43XRKELI5pDHfUDDNI3ixfYhEU2jrMBRgU6zWtNuOzUtdlRPY1UN/nImNWyASRikLAnn+G8EXswWUJtWiQRSTn4iYdH5GCygNtUaedjtqGQJeOQuYcdhWPUYzKgehQU/I+IM3gAcqN4HH6p3Qa2fiByRH79U/wRnUNO69u2o5Br9X0eVroOocHoFKdMbIe+p2VcHnZ3T9S5cqS6nl1Q94bpGMr9mU2aNwR2CN4jI2g/YTsAz1MnaiegMTuGchrtw9ZPpoVuaaj8sk8XTz1WrXdvMYx46fdRWSnAMMRzZffUtwABQJKDSMP7IjQAAAABJRU5ErkJggg=="

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABu0lEQVRIS9WWMUhcQRCGvx8VRRRtRBQCOYiVgtopSMDaxsoykBAD6YT0CSTYqVirlXaCkCaxEG2180RSJaBEMIWCiE0CSUZG9x3H4/bu3T0bt9u3w3w7M//OPJlZERgm3/oDzEraSLuRmRnwGviWOhwE1oDxGuwOYAdwP58kfSi3TwDjkg7KD8xsDNiXJP9uZk3ADNAa7H5K2jOzbuAKeAksAdvAK0keFfUACsDnAGgBfN8D/AsA3zv8K/ALmJZ0mRmQiu4pcAL0Ab8TgKRTM3OoX6QXmGoU4GnZBZ4DHo2nqOCAkM42YB2YaAiQiiapQQkQIPc1DCqqVOQh4Bh4W0NF7cCCp0TSRWJbEkkMEG7hqph0MVSB/Ae2JM1XVGE1QJ63lymCxwkws3fAi7IXmzUQf7nrkhajKjKzfuAMmANusnoOdp3AMvBE0nnFGpjZCHCY9J86Ad6vvOGNSipmBpiZS7QrAruW5E7vVqOAWWAlAngjaTUvoBl4FgH8kPQ3F6CeOjSaIh8yHyOg95I2c0UQ+vtUBPAl1eDqV9FDpSgZ+gNhUNQa9DHufugC34G7nwafBw/x2xIDHt0CFvl9uHaUMicAAAAASUVORK5CYII="

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: commonFilterController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var CommonFilterController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$filter", "$stateParams", "localStorageService", "authService", "filterCons", "CONSTANTS", function CommonFilterController($state, $rootScope, $scope, $mdDialog, $filter, $stateParams, localStorageService, authService, filterCons, CONSTANTS) {
    _classCallCheck(this, CommonFilterController);

    var multipleBatchFilterCtrl = this;
    var vm = this;
    vm.limit = 50;
    vm.Items = 60;
    vm.pager = {};
    vm.setPage = setPage;
    vm.pageIndex = [];

    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;
        pageSize = pageSize || vm.limit;
        var totalPages = Math.ceil(totalItems / pageSize);
        var startPage, endPage;
        if (totalPages <= 10) {
            startPage = 1;
            endPage = totalPages;
        } else {
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
        var pages = _.range(startPage, endPage + 1);
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    function initController() {
        $scope.announcementForAll = multipleBatchFilterCtrl.checkAnnouncementReceivers;
        if (multipleBatchFilterCtrl.checkAnnouncementReceivers) {
            console.log('SEND TO ALL');
            multipleBatchFilterCtrl.getAllUsersForAnnouncement();
            $scope.showFilteredUsers = false;
        } else {
            vm.setPage(1);
        }
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = GetPager(vm.Items, page);
        console.log(vm.pager);
        $scope.showFilteredUsers = true;
        if (vm.pageIndex.indexOf(page) === -1) {

            if (page === 1) multipleBatchFilterCtrl.getUsersLists(0, vm.limit, page);else multipleBatchFilterCtrl.getUsersLists(vm.pager.startIndex, vm.limit, page);
        } else {
            findValueBasedOnIndex(page);
        }
    }

    $scope.filteredEndorsedUsers = [];
    $scope.selectedFilterData = "Select..";
    $scope.userNamesNotEndorsed = [];
    $scope.showAcademicFilters = true;
    $scope.isBatch = false;
    $scope.isClass = false;
    multipleBatchFilterCtrl.checkAllClass = false;
    $scope.showSavedSearch = false;
    $scope.saveSearchData = false;
    $scope.showbatch = true;
    $scope.isSearched = false;
    $scope.showMultiBatch = [];
    multipleBatchFilterCtrl.showChart = [];
    $scope.filterObj = {};
    $scope.buttonName = 'Add';
    $scope.open = false;
    $scope.announcementForAll = false;

    var everywhere = angular.element(window.document);
    everywhere.bind('click', function (event) {

        try {
            var isButtonClick = event.target.className === "btn-filter btn-primary dropdown-toggle ng-binding";
            if (isButtonClick === false) {
                $scope.open = false;
                _.defer(function () {
                    $scope.$apply();
                });;
            }
        } catch (ex) {}
    });

    function findValueBasedOnIndex(page) {

        $scope.userNamesNotEndorsed = _.filter($scope.filteredNotEndorsedUsers, function (user) {
            return user.page === page;
        });
        multipleBatchFilterCtrl.userNotEndorsedAcademic = _.uniq(_.pluck($scope.userNamesNotEndorsed, 'academic_details'));
    }

    function clearUsersListResults() {
        multipleBatchFilterCtrl.userNotEndorsedAcademic = [];
        $scope.userNamesNotEndorsed = [];
        $scope.filteredNotEndorsedUsers = [];
        vm.pager = {};
        vm.setPage = setPage;
        vm.pageIndex = [];
        multipleBatchFilterCtrl.allItemsSelected = [];
    }

    function clearFields() {
        multipleBatchFilterCtrl.showMultiSubject = [];
        $scope.filterObj['batch'] = [];
        $scope.filterObj['subject'] = [];
        $scope.isSubject = false;
        multipleBatchFilterCtrl.checkAll = false;
        multipleBatchFilterCtrl.checkAllSubject = false;
        vm.pager = {};
        vm.setPage = setPage;
        clearUsersListResults();
        vm.pageIndex = [];
        multipleBatchFilterCtrl.allItemsSelected = [];
    }

    var storageKey = "searched item";
    var savedFilterData = localStorageService.get(storageKey);
    if (!savedFilterData) {
        clearFields();
    }
    $scope.chartTypes = [{
        name: 'Pie',
        type: 'pie'
    }, {
        name: 'Bar',
        type: 'Bar'
    }, {
        name: 'Doughnut',
        type: 'Doughnut'
    }];

    function featureBaseFilter() {
        switch ($scope.stateId) {
            case 'userManagement':
                hideUserManagementFilterFields();
                break;
            case 'reportGradeDetailsConsole':
                hideReportGradeDetailsConsoleFields();
                break;
            case 'announcementsUsers':
                $scope.buttonName = 'Proceed';
                $scope.announcementForAll = true;
                hideClubFilterFields();
                break;
            case 'club':
                $scope.buttonName = 'Add';
                hideClubFilterFields();
                break;
            case 'manageReportCards':
                $scope.buttonName = 'Add';
                hidefilterInManageReports();
                break;
            case 'viewDetails':
                $scope.buttonName = 'Proceed';
                forSecurityAppConsole();
                break;
            case 'transferStudent':
                $scope.buttonName = 'Search';
                roleasStudentOnly();
                break;
            case 'edituser':
                $scope.buttonName = 'Search';
                forEditinguser();
                break;
            case 'removeUser':
                forRemoveUser();
                break;

        }
    }

    featureBaseFilter();

    function forRemoveUser() {
        $scope.visibleRole = true;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = true;
        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
        $scope.showSavedSearchField = true;
        $scope.showFilteredUsers = false;
    }

    function forEditinguser() {
        $scope.visibleRole = true;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = true;
        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
        $scope.showSavedSearchField = false;
        $scope.showFilteredUsers = false;
    }

    function hidefilterInManageReports() {
        $scope.visibleRole = false;
        $scope.showAcademicFilters = true;
        $scope.showbatch = false;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = true;
        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
        $scope.showSavedSearchField = false;
        $scope.showFilteredUsers = false;
    }

    function hideClubFilterFields() {
        $scope.visibleRole = true;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = false;
        $scope.blnsearchValuesBasedOnFilterOnComponent = true;
        $scope.showSavedSearchField = true;
        $scope.showFilteredUsers = false;
    }

    function hideUserManagementFilterFields() {
        $scope.visibleRole = true;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = true;
        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
        $scope.showSavedSearchField = true;
        $scope.showFilteredUsers = true;
    }

    function roleasStudentOnly() {
        $scope.visibleRole = false;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = true;
        $scope.blnsearchValuesBasedOnFilterOnComponent = false;
        $scope.showSavedSearchField = true;
        $scope.showFilteredUsers = false;

        $scope.filterObj['role'] = 'student';
        $scope.filterObj['role_id'] = 'student';
    }

    function forSecurityAppConsole() {
        $scope.visibleRole = false;
        $scope.showAcademicFilters = true;
        $scope.showbatch = true;
        $scope.showSubject = false;
        $scope.showChart = false;
        $scope.showMultiRole = false;
        $scope.showDate = false;
        $scope.blnsearchValuesBasedOnFilter = false;
        $scope.blnsearchValuesBasedOnFilterOnComponent = true;
        $scope.showSavedSearchField = true;
        $scope.showFilteredUsers = true;

        $scope.filterObj['role'] = 'student';
        $scope.filterObj['role_id'] = 'student';
    }

    var subsModules = undefined,
        subsAcademicSet = undefined,
        subsAcademicPack = undefined,
        academicDetail = undefined;

    /*
     * To get user's assigned module's features
     * 
     * @Developer : Jeevanantham N
     */
    var getUserModules = function getUserModules() {
        authService.callAPI(filterCons.API_GET_MODULE_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.module_features) {
                try {
                    moduleDetails = response.result.data.module_features;
                    var _parentId = '';
                    var _principalId = '';
                    var _vicePrincipalId = '';
                    var _senEducatorId = '';
                    var _senCoordinatorId = '';
                    var _senCounselorId = '';
                    if (moduleDetails != undefined && moduleDetails.feature_role && $scope.isClub) {
                        _.each(moduleDetails.feature_role, function (each) {
                            if (each.f_id == 'parentComponent' && each.privilege[0].status) {
                                _parentId = each.role_id;
                            } else if (each.f_id == 'principalComponent' && each.privilege[0].status) {
                                _principalId = each.role_id;
                            } else if (each.f_id == 'vicePrincipalComponent' && each.privilege[0].status) {
                                _vicePrincipalId = each.role_id;
                            } else if (each.f_id == 'senEducatorComponent' && each.privilege[0].status) {
                                _senEducatorId = each.role_id;
                            } else if (each.f_id == 'senCoordinatorComponent' && each.privilege[0].status) {
                                _senCoordinatorId = each.role_id;
                            } else if (each.f_id == 'senCounselorComponent' && each.privilege[0].status) {
                                _senCounselorId = each.role_id;
                            }
                        });
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                } catch (ex) {
                    console.log(ex);
                }
            }
        });
    };

    /*
     * To get school based academic deatils
     * 
     * @Developer : Jeevanantham N
     */
    var getAcademicPck = function getAcademicPck() {
        authService.callAPI(filterCons.API_GET_SCHOOL_ACADEMICS + localStorageService.get('school_id'), "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.academic_det) {
                //$scope.hodPersonArr = response.result.data.departments

                $scope.sessions = [];
                academicDetail = response.result.data.academic_det;

                if (academicDetail === undefined || academicDetail.length <= 0) return false;

                if (multipleBatchFilterCtrl.allSessions && academicDetail) {
                    _.each(academicDetail, function (doc) {
                        var thisSessionDetails = _.find(multipleBatchFilterCtrl.allSessions.list, function (eachSession) {
                            return eachSession._id == doc.session_id;
                        });
                        if (thisSessionDetails && !_.find($scope.sessions, function (sess) {
                            return sess._id == thisSessionDetails._id;
                        })) {
                            $scope.sessions.push({
                                _id: thisSessionDetails._id,
                                name: thisSessionDetails.name
                            });
                        }
                    });
                }

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /*
     * To get school based settings
     * 
     * @Developer : Jeevanantham N
     */
    var getAcademicSettings = function getAcademicSettings() {
        authService.callAPI(filterCons.API_GET_SCHOOL_SETTINGS + localStorageService.get('school_id'), "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data) {
                multipleBatchFilterCtrl.rolePackage = response.result.data.role_det ? response.result.data.role_det : [];

                multipleBatchFilterCtrl.allSessions = response.result.data.session_det ? response.result.data.session_det : [];

                multipleBatchFilterCtrl.allCurriculum = response.result.data.curriculum_det ? response.result.data.curriculum_det : [];

                multipleBatchFilterCtrl.allClassess = response.result.data.class_det ? response.result.data.class_det : [];

                multipleBatchFilterCtrl.allBatchess = response.result.data.batch_det ? response.result.data.batch_det : [];

                multipleBatchFilterCtrl.allSubjectsList = response.result.data.subject_det ? response.result.data.subject_det : [];

                if (multipleBatchFilterCtrl.allSessions && academicDetail) {
                    _.each(academicDetail, function (doc) {
                        var thisSessionDetails = _.find(multipleBatchFilterCtrl.allSessions.list, function (eachSession) {
                            return eachSession._id == doc.session_id;
                        });
                        if (thisSessionDetails && !_.find($scope.sessions, function (sess) {
                            return sess._id == thisSessionDetails._id;
                        })) {
                            $scope.sessions.push({
                                _id: thisSessionDetails._id,
                                name: thisSessionDetails.name
                            });
                        }
                    });
                }

                $scope.allRoles = [];

                if ($scope.isClub) {
                    if (multipleBatchFilterCtrl.rolePackage) {
                        _.each(multipleBatchFilterCtrl.rolePackage.list, function (role) {
                            if (role._id != CONSTANTS.ADMIN_ID && role._id != parentId && role._id != senEducatorId && role._id != senCoordinatorId && role._id != principalId && role._id != vicePrincipalId && role._id != senCounselorId && role.status === true) {
                                $scope.allRoles.push(role);
                            }
                        });
                    }
                } else if (multipleBatchFilterCtrl.rolePackage) {
                    $scope.allRoles = _.filter(multipleBatchFilterCtrl.rolePackage.list, function (role) {
                        return role._id != CONSTANTS.ADMIN_ID && role.status === true;
                    });
                } else {
                    return false;
                }

                getSubJectPack();

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /*
     * To get saved search details
     * 
     * @Developer : Jeevanantham N
     */
    var getSavedSearch = function getSavedSearch() {
        authService.callAPI(filterCons.API_GET_SAVED_SEARCH + localStorageService.get('school_id') + "/" + $scope.stateId, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.search_det) {
                //$scope.hodPersonArr = response.result.data.departments

                $scope.savedSearchData = response.result.data.search_det;

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /*
     * To get user's academic details
     * 
     * @Developer : Jeevanantham N
     */
    var userPrsnData = function userPrsnData(user_id) {
        authService.callAPI(filterCons.API_GET_PERSON_ACDEMICS + localStorageService.get('school_id') + "/" + localStorageService.get("user_id"), "GET", {}, function (response) {

            if (response.result && response.result.data && response.result.data.person_data) {
                $scope.persnData = response.result.data.person_data;

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    function saveFilterDataToStorage() {
        try {
            var _storageKey = "searched item";
            var filterData = {
                role: $scope.filterObj.role || '',
                role_id: $scope.filterObj.role_id || '',
                session: $scope.filterObj.session || '',
                curriculum: $scope.filterObj.curriculum || '',
                xclass: $scope.filterObj.xclass || [],
                singlefieldclass: $scope.filterObj.singlefieldclass || '',
                batch: $scope.filterObj.batch || [],
                subject: $scope.filterObj.subject || [],
                chart: $scope.filterObj.chart || '',
                multirole: $scope.filterObj.multirole || '',
                selectedFilterTitle: $scope.selectedFilterData || 'SELECT..'
            };
            localStorageService.set(_storageKey, filterData);
        } catch (error) {
            console.error('Error saving filter data to localStorage:', error);
        }
    }

    $scope.saveFilterDataToStorage = saveFilterDataToStorage;

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        /*  if ($rootScope.isLoggedIn) {
             $state.go("login", {}, {
                 reload: true
             })
         } */
        getUserModules();
        getAcademicSettings();
        getAcademicPck();
        getSavedSearch();
        userPrsnData();

        var loadSavedFilterData = function loadSavedFilterData() {
            try {
                var _storageKey2 = "searched item";
                var _savedFilterData = localStorageService.get(_storageKey2);
                if (_savedFilterData && _savedFilterData.role_id) {
                    console.log('Found saved filter data in localStorage:', _savedFilterData);

                    if ($scope.savedSearchData && $scope.savedSearchData.length > 0) {
                        var matchingSavedSearch = _.find($scope.savedSearchData, function (savedSearch) {
                            return savedSearch.role === _savedFilterData.role_id && savedSearch.session === _savedFilterData.session && savedSearch.curriculum === _savedFilterData.curriculum && _.isEqual(savedSearch.class, _savedFilterData.xclass || []) && _.isEqual(savedSearch.batch, _savedFilterData.batch || []) && _.isEqual(savedSearch.subject, _savedFilterData.subject || []);
                        });

                        if (matchingSavedSearch) {
                            console.log('Found matching saved search:', matchingSavedSearch);
                            $scope.selectedFilterData = matchingSavedSearch.title;
                            $scope.getSavedData(matchingSavedSearch);
                        } else {
                            var mockSavedSearch = {
                                title: 'SELECT..',
                                role: _savedFilterData.role_id,
                                session: _savedFilterData.session,
                                curriculum: _savedFilterData.curriculum,
                                class: _savedFilterData.xclass || [],
                                batch: _savedFilterData.batch || [],
                                subject: _savedFilterData.subject || [],
                                chart_type: _savedFilterData.chart || '',
                                multirole: _savedFilterData.multirole || '',
                                check_all_class: false,
                                check_all_batch: false,
                                check_all_subject: false
                            };

                            $scope.selectedFilterData = mockSavedSearch.title;
                            $scope.getSavedData(mockSavedSearch);
                        }
                    } else {
                        var _mockSavedSearch = {
                            title: 'SELECT..',
                            role: _savedFilterData.role_id,
                            session: _savedFilterData.session,
                            curriculum: _savedFilterData.curriculum,
                            class: _savedFilterData.xclass || [],
                            batch: _savedFilterData.batch || [],
                            subject: _savedFilterData.subject || [],
                            chart_type: _savedFilterData.chart || '',
                            multirole: _savedFilterData.multirole || '',
                            check_all_class: false,
                            check_all_batch: false,
                            check_all_subject: false
                        };

                        $scope.selectedFilterData = _mockSavedSearch.title;
                        $scope.getSavedData(_mockSavedSearch);
                    }
                }
            } catch (error) {
                console.error('Error loading saved filter data from localStorage:', error);
            }
        };
        setTimeout(loadSavedFilterData, 1500);
    };

    this.$onDestroy = function () {};

    function getSubJectPack() {
        multipleBatchFilterCtrl.allSubjects = _.flatten(_.pluck(multipleBatchFilterCtrl.allSubjectsList, 'list'));
    }

    multipleBatchFilterCtrl.getRoleDetails = function (id) {
        if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
            if (multipleBatchFilterCtrl.selectedSavedSerach.role != id) {
                $scope.selectedFilterData = "Select.. ";
            };
        };

        try {
            $scope.multiRoles = _.filter(multipleBatchFilterCtrl.rolePackage.list, function (role) {
                return role._id != SuperAdminTYPE && role._id != AdminTYPE && role._id != id && role.status === true;
            });
        } catch (ex) {}
    };

    function clearFilterResult() {
        if ($scope.stateId) {

            $scope.clearParentFields();
        }
    }

    $scope.setFilterObj = function (data, key) {
        console.log(data);
        console.log(key);
        console.log($scope.filterObj);
        $scope.open = false;
        clearFilterResult();
        if (key == 'Role') {
            $scope.filterObj['role'] = data;
            clearComponentField();
        } else if (key == 'Session') {
            $scope.filterObj['session'] = data;
        } else if (key == 'Curiculum') {
            $scope.filterObj['curriculum'] = data;
        } else if (key == 'role_id') {
            clearComponentField();
            $scope.filterObj['role_id'] = data;
        } else if (key == 'Chart') {
            $scope.filterObj['chart'] = data;
        } else if (key == 'Multi') {
            $scope.filterObj['multirole'] = data;
        }
        // saveFilterDataToStorage();
    };

    function clearComponentField() {
        $scope.filteredEndorsedUsers = [];
        multipleBatchFilterCtrl.userEndorsedAcademic = [];
        multipleBatchFilterCtrl.userNotEndorsedAcademic = [];
        $scope.userNamesNotEndorsed = [];
        $scope.filteredNotEndorsedUsers = [];
        vm.pager = {};
        vm.setPage = setPage;
        vm.pageIndex = [];
        multipleBatchFilterCtrl.allItemsSelected = [];
    }

    $scope.removeFilter = function () {
        $scope.filterObj = {};
        $scope.filteredExamDetails = [];
        // Clear filter data from localStorage
        try {
            var _storageKey3 = "searched item";
            localStorageService.remove(_storageKey3);
        } catch (error) {
            console.error('Error removing filter data from localStorage:', error);
        }
    };

    $scope.setSessionFilters = function (item) {
        var items = item.split(",");
    };

    $scope.deleteSearch = function (item) {
        $scope.open = false;

        var obj = {
            'search_id': item._id,
            'school_id': localStorageService.get('school_id')

            /*
             * To removed filter data
             * 
             * @Developer : Jeevanantham N
             */
        };authService.callAPI(filterCons.API_POST_REMOVE_SERACH, "POST", obj, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.info) {
                $scope.selectedFilterData = "Select.. ";
                getSavedSearch();
                toastr.success('Deleted Successfully');
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
            }
        });
    };

    multipleBatchFilterCtrl.getBatch = function (bid) {

        //console.log("wwwwwwwwww")
        $scope.open = false;
        clearUsersListResults();
        $scope.batchId = bid;
        $scope.isBatch = true;
        $scope.isSubject = false;
        $scope.filterObj['batch'] = [];
        $scope.filterObj['subject'] = [];
        var flag = false;
        for (var i = 0; i < $scope.filterObj['xclass'].length; i++) {
            if ($scope.filterObj['xclass'][i] === bid) {
                flag = true;
            }
        }
        multipleBatchFilterCtrl.showMultiSubject = [];
        multipleBatchFilterCtrl.checkAll = false;
        multipleBatchFilterCtrl.checkAllSubject = false;

        multipleBatchFilterCtrl.showThisBatch = _.find(academicDetail, function (lst) {
            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
        });

        var classDet = _.find(multipleBatchFilterCtrl.showThisBatch.xclass, function (batch) {
            return batch._id === bid;
        });

        if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allClassess) {

            /* let personDetails = Person.findOne({
                user_id: localStorageService.get("user_id"),
                "status": "active"
            }) */

            var personDetails = $scope.persnData;

            if (personDetails && personDetails.details) {

                var batchData = _.where(personDetails.details, {
                    session_id: $scope.filterObj['session'],
                    curriculum_id: $scope.filterObj['curriculum'],
                    class_id: bid
                });

                batchData = _.uniq(_.flatten(_.pluck(batchData, "batch_id")));

                multipleBatchFilterCtrl.showBatchName = _.filter(multipleBatchFilterCtrl.allBatches.list, function (data) {
                    return batchData.indexOf(data._id) !== -1;
                });
            }
        } else {

            if (flag) {
                for (var j = 0; j < classDet.batches.length; j++) {
                    for (var jj = 0; jj < multipleBatchFilterCtrl.showBatchName.length; jj++) {
                        if (multipleBatchFilterCtrl.showBatchName[jj]._id === classDet.batches[j]) {
                            multipleBatchFilterCtrl.showBatchName.splice(jj, 1);
                            break;
                        }
                    }
                }
            } else {
                _.each(multipleBatchFilterCtrl.allBatchess.list, function (v) {
                    _.each(classDet.batches, function (k) {
                        if (v._id === k) {
                            var item = {
                                _id: v._id,
                                name: v.name
                            };
                            multipleBatchFilterCtrl.showBatchName.push(item);
                        }
                    });
                });
            }
        }
        $scope.showMultiBatch = _.uniq(multipleBatchFilterCtrl.showBatchName, false, function (p) {
            return p._id;
        });
        if ($scope.showMultiBatch.length <= 0) {
            $scope.isBatch = false;
        }
    };

    multipleBatchFilterCtrl.getClass = function (sid) {
        clearFilterResult();
        $scope.open = false;

        if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
            if (multipleBatchFilterCtrl.selectedSavedSerach.curriculum != sid) {
                $scope.selectedFilterData = "Select.. ";
            };
        };
        var cid = $scope.selectCuriculum;
        $scope.selectClass = sid;
        var addedClass = [];
        $scope.showClassName = [];
        $scope.isBatch = false;
        $scope.filterObj['xclass'] = [];
        $scope.filterObj['singlefieldclass'] = undefined;
        clearFields();
        /* multipleBatchFilterCtrl.showThisClass = AcademicConsole.find({
            session_id: cid,
            curriculum_id: sid
        }).fetch(); */

        multipleBatchFilterCtrl.showThisClass = _.filter(academicDetail, function (lst) {
            return lst.session_id == cid && lst.curriculum_id == sid;
        });

        //console.log(multipleBatchFilterCtrl.showThisClass)
        //console.log(cid)
        //console.log(sid)

        if (multipleBatchFilterCtrl.showThisClass != undefined && multipleBatchFilterCtrl.showThisClass.length > 0) {
            _.each(multipleBatchFilterCtrl.showThisClass[0].xclass, function (classes) {
                addedClass.push(classes._id);
            });
        }
        addedClass = _.uniq(addedClass);

        //console.log(addedClass)

        if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allClassess) {
            /* let personDetails = Person.findOne({
                user_id: localStorageService.get("user_id"),
                "status": "active"
            }) */

            var personDetails = $scope.persnData;

            //console.log("===11111===")
            //console.log(personDetails)

            if (personDetails && personDetails.details) {
                var classData = _.where(personDetails.details, {
                    session_id: $scope.filterObj['session'],
                    curriculum_id: sid
                });

                classData = _.uniq(_.flatten(_.pluck(classData, "class_id")));

                $scope.showClassName = _.filter(multipleBatchFilterCtrl.allClassess.list, function (data) {
                    return classData.indexOf(data._id) !== -1;
                });
                //
            }
        } else {
            //console.log("===2222===")
            //console.log(multipleBatchFilterCtrl.allClassess)
            if (multipleBatchFilterCtrl.allClassess != undefined) {
                _.each(multipleBatchFilterCtrl.allClassess.list, function (v) {
                    _.each(addedClass, function (k) {
                        if (v._id === k) {
                            var item = {
                                _id: v._id,
                                name: v.name
                            };
                            $scope.showClassName.push(item);
                        }
                    });
                });
            }
        }

        //console.log($scope.showClassName)

        if ($scope.showClassName && $scope.showClassName.length > 0) {
            $scope.isClass = true;
        }

        multipleBatchFilterCtrl.classArr = _.pluck($scope.showClassName, "_id");
    };

    multipleBatchFilterCtrl.getCuriculum = function (cid) {
        $scope.open = false;
        if (multipleBatchFilterCtrl.selectedSavedSerach != undefined) {
            if (multipleBatchFilterCtrl.selectedSavedSerach.session != cid) {
                $scope.selectedFilterData = "Select.. ";
            };
        };

        $scope.selectCuriculum = cid;
        $scope.showCurriculumName = [];
        var addedCuricullumID = [];
        $scope.filterObj['curriculum'] = undefined;
        $scope.filterObj['xclass'] = [];
        $scope.filterObj['singlefieldclass'] = undefined;
        clearFields();
        $scope.showMultiBatch = [];
        multipleBatchFilterCtrl.checkAllClass = false;
        $scope.showClassName = [];
        multipleBatchFilterCtrl.showBatchName = [];
        $scope.isBatch = false;
        $scope.isClass = false;

        /* multipleBatchFilterCtrl.showThisSessions = AcademicConsole.find({
            session_id: cid
        }).fetch(); */

        multipleBatchFilterCtrl.showThisSessions = _.filter(academicDetail, function (lst) {
            return lst.session_id == cid;
        });

        _.each(multipleBatchFilterCtrl.showThisSessions, function (v) {
            addedCuricullumID.push(v.curriculum_id);
        });
        addedCuricullumID = _.uniq(addedCuricullumID);
        $scope.showCurriculumName = [];

        if ($scope.isTeacher && localStorageService.get("user_id") && multipleBatchFilterCtrl.allCurriculum) {
            /* let personDetails = Person.findOne({
                user_id: localStorageService.get("user_id"),
                "status": "active"
            }) */

            var personDetails = $scope.persnData;

            if (personDetails && personDetails.details) {
                var currData = _.where(personDetails.details, {
                    session_id: cid
                });

                currData = _.uniq(_.flatten(_.pluck(currData, "curriculum_id")));

                $scope.showCurriculumName = _.filter(multipleBatchFilterCtrl.allCurriculum.list, function (data) {
                    return currData.indexOf(data._id) !== -1;
                });
            }
        } else {

            _.each(multipleBatchFilterCtrl.allCurriculum.list, function (v) {
                _.each(addedCuricullumID, function (k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        };
                        $scope.showCurriculumName.push(item);
                    }
                });
            });
        }
    };

    multipleBatchFilterCtrl.getSubject = function () {
        $scope.open = false;
        multipleBatchFilterCtrl.checkAllSubject = false;
        getAllSubject();
    };

    function getAllSubject() {
        $scope.open = false;
        $scope.isSubject = true;
        $scope.filterObj['subject'] = [];
        multipleBatchFilterCtrl.showMultiSubject = [];

        multipleBatchFilterCtrl.showThisSubject = _.find(academicDetail, function (lst) {
            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
        });

        var allSubject = _.flatten(_.pluck(multipleBatchFilterCtrl.showThisSubject.subject_package, 'subjects'));
        _.each(multipleBatchFilterCtrl.allSubjects, function (v) {
            _.each(allSubject, function (k) {
                if (v._id === k) {
                    var item = {
                        _id: v._id,
                        name: v.name
                    };
                    multipleBatchFilterCtrl.showMultiSubject.push(item);
                }
            });
        });

        if (multipleBatchFilterCtrl.showMultiSubject.length <= 0) {
            $scope.isSubject = false;
        } else {
            multipleBatchFilterCtrl.checkAllSubject = false;
        }
    }

    $scope.selectBatches = function (opt) {
        $scope.open = false;
        clearUsersListResults();
        clearFilterResult();
        if (opt == "all") {
            if (multipleBatchFilterCtrl.checkAll) {
                $scope.filterObj['batch'] = _.union($scope.filterObj['batch'], _.pluck($scope.showMultiBatch, "_id"));
                getAllSubject();
            } else {
                $scope.filterObj['batch'] = [];
                multipleBatchFilterCtrl.showMultiSubject = [];
                $scope.isSubject = false;
            }
        } else {
            if ($scope.filterObj['batch'].length == _.pluck($scope.showMultiBatch, "_id").length) {
                multipleBatchFilterCtrl.checkAll = true;
            } else {
                multipleBatchFilterCtrl.checkAll = false;
                if ($scope.filterObj['batch'].length === 0) {
                    multipleBatchFilterCtrl.showMultiSubject = [];
                    $scope.isSubject = false;
                }
            }
        }
        saveFilterDataToStorage();
    };

    $scope.selectClasses = function (opt) {
        $scope.open = false;
        clearFilterResult();
        if (opt == "all") {
            if (multipleBatchFilterCtrl.checkAllClass) {
                $scope.filterObj['xclass'] = _.union($scope.filterObj['xclass'], multipleBatchFilterCtrl.classArr);
                filterBatchBasedOnClass(multipleBatchFilterCtrl.classArr);
                clearFields();
            } else {
                $scope.filterObj['xclass'] = [];
                clearFields();
                $scope.showMultiBatch = [];
                $scope.isBatch = false;
                multipleBatchFilterCtrl.showBatchName = [];
            }
        } else {
            if ($scope.stateId === 'userManagement') {
                $scope.filterObj['xclass'] = [];
                $scope.filterObj['xclass'].push($scope.filterObj['singlefieldclass']);
            }
            if ($scope.filterObj['xclass'].length == multipleBatchFilterCtrl.classArr.length) {
                multipleBatchFilterCtrl.checkAllClass = true;
            } else {
                multipleBatchFilterCtrl.checkAllClass = false;
            }
        }
        saveFilterDataToStorage();
    };

    $scope.selectAnnouncementReceivers = function (opt) {
        console.log(opt);
    };

    $scope.selectSubject = function (opt) {
        $scope.open = false;
        clearUsersListResults();
        clearFilterResult();
        if (opt == "all") {
            if (multipleBatchFilterCtrl.checkAllSubject) {
                $scope.filterObj['subject'] = _.union($scope.filterObj['subject'], _.pluck(multipleBatchFilterCtrl.showMultiSubject, "_id"));
            } else {
                $scope.filterObj['subject'] = [];
            }
        } else {
            if ($scope.filterObj['subject'].length == multipleBatchFilterCtrl.showMultiSubject.length) {
                multipleBatchFilterCtrl.checkAllSubject = true;
            } else {
                multipleBatchFilterCtrl.checkAllSubject = false;
            }
        }
        saveFilterDataToStorage();
    };

    function filterBatchBasedOnClass(totalClass) {
        $scope.isBatch = true;
        /* multipleBatchFilterCtrl.showThisBatch = AcademicConsole.findOne({
            session_id: $scope.selectCuriculum,
            curriculum_id: $scope.selectClass
        }, {
            xclass: 1
        }) */

        multipleBatchFilterCtrl.showThisBatch = _.find(academicDetail, function (lst) {
            return lst.session_id == $scope.selectCuriculum && lst.curriculum_id == $scope.selectClass;
        });

        multipleBatchFilterCtrl.showBatchName = [];
        for (var i = totalClass.length - 1; i >= 0; i--) {
            var classDet = _.find(multipleBatchFilterCtrl.showThisBatch.xclass, function (batch) {
                return batch._id === totalClass[i];
            });

            _.each(multipleBatchFilterCtrl.allBatchess.list, function (v) {
                _.each(classDet.batches, function (k) {
                    if (v._id === k) {
                        var item = {
                            _id: v._id,
                            name: v.name
                        };
                        multipleBatchFilterCtrl.showBatchName.push(item);
                    }
                });
            });
        }
        $scope.showMultiBatch = _.uniq(multipleBatchFilterCtrl.showBatchName, false, function (p) {
            return p._id;
        });
        if ($scope.showMultiBatch.length <= 0) {
            $scope.isBatch = false;
        }
    }

    multipleBatchFilterCtrl.searchValuesBasedOnFilterOnComponent = function () {

        $scope.open = false;
        multipleBatchFilterCtrl.userFilter = {};
        multipleBatchFilterCtrl.userFilter.roleId = $scope.filterObj.role_id;
        multipleBatchFilterCtrl.userFilter.sessionId = $scope.filterObj.session;
        multipleBatchFilterCtrl.userFilter.curriculumId = $scope.filterObj.curriculum;
        multipleBatchFilterCtrl.userFilter.classId = $scope.filterObj.xclass;
        multipleBatchFilterCtrl.userFilter.batchId = $scope.filterObj.batch;
        $scope.isSearched = true;

        if ($scope.filterObj === undefined || $scope.filterObj.role_id === undefined) {
            toastr.error('Please Select the Role');
            return false;
        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.session === undefined)) {
            toastr.error('Please Select the Session');
            return false;
        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.curriculum === undefined)) {
            toastr.error('Please Select the Curriculum');
            return false;
        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.xclass === undefined || $scope.filterObj.xclass.length <= 0)) {
            toastr.error('Please Select the Class');
            return false;
        } else if ($scope.filterObj.role_id === filterCons.STUDENTROLEID && ($scope.filterObj === undefined || $scope.filterObj.batch === undefined || $scope.filterObj.batch.length <= 0)) {
            toastr.error('Please Select the Batch');
            return false;
        }
        setFilterValue($scope.filterObj);
    };

    function setFilterValue(userAcademicDetails) {

        multipleBatchFilterCtrl.userMgt = {};
        multipleBatchFilterCtrl.userMgt.roleId = userAcademicDetails.role_id;
        multipleBatchFilterCtrl.userMgt.sessionId = userAcademicDetails.session;
        multipleBatchFilterCtrl.userMgt.curriculumId = userAcademicDetails.curriculum;
        multipleBatchFilterCtrl.userMgt.classId = userAcademicDetails.xclass;
        multipleBatchFilterCtrl.userMgt.batchId = userAcademicDetails.batch;
        // multipleBatchFilterCtrl.getUsersLists(0, limit);

        initController();
        saveFilterDataToStorage();
    }

    //Added for sending announcement to all users without listing list
    multipleBatchFilterCtrl.getAllUsersForAnnouncement = function () {
        $scope.loading = true;

        var req = vm.userMgt;
        req["school_id"] = localStorageService.get('school_id');

        /*
         * To get all users against selected role
         * 
         * @Developer : Jeevanantham N
         */
        authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, function (response) {
            if (response.result && response.result.data && response.result.data.users) {
                if (response.result.data.users === undefined || response.result.data.users.length === 0) toastr.error("No results found");else if (response.result.data.users && response.result.data.users.length != 0) {
                    var _$scope$filteredNotEn;

                    //console.log('**************')
                    // $scope.filteredNotEndorsedUsers = res.users
                    (_$scope$filteredNotEn = $scope.filteredNotEndorsedUsers).push.apply(_$scope$filteredNotEn, _toConsumableArray(response.result.data.users));
                    //console.log($scope.filteredNotEndorsedUsers)
                    //console.log('**************')
                    // Save filter data to localStorage when ProcessValue is called
                    saveFilterDataToStorage();
                    $scope.ProcessValue();
                }

                $scope.loading = false;
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
            }
        });
    };

    multipleBatchFilterCtrl.getUsersLists = function (skip, limit, page) {
        $scope.open = false;
        multipleBatchFilterCtrl.showList = true;
        // multipleBatchFilterCtrl.allItemsSelected = []
        $scope.loading = true;

        var req = vm.userMgt;
        req["school_id"] = localStorageService.get('school_id');
        req["skip"] = skip;
        req["limit"] = limit;

        /*
         * To get all users against selected role
         * 
         * @Developer : Jeevanantham N
         */
        authService.callAPI(filterCons.API_POST_GET_ALL_USERS, "POST", req, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.users) {
                if (response.result.data.users === undefined || response.result.data.users.length === 0) {
                    $scope.loading = false;
                    toastr.error("No results found");
                } else if (response.result.data.users && response.result.data.users.length != 0) {
                    vm.Items = response.result.data.totallength;
                    vm.pager = GetPager(vm.Items, page);
                    vm.pageIndex.push(page);
                    bindData(response.result.data, page);
                }

                var userList = [];
                if ($scope.isClub && $scope.userNames) {
                    var availableMembers = _.uniq(_.pluck($scope.userNames, 'user_id'));
                    _.each($scope.filteredNotEndorsedUsers, function (each, index) {
                        if (availableMembers.indexOf(each._id) != -1) {
                            each.isExists = true;
                        }
                    });

                    $scope.userNamesNotEndorsed = $scope.filteredNotEndorsedUsers;
                    $scope.userNamesNotEndorsed.sort(function (a, b) {
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return textA < textB ? -1 : textA > textB ? 1 : 0;
                    });
                }

                $scope.loading = false;
                $scope.UniqueNoText = "Employee No";

                if ($scope.userNamesNotEndorsed && $scope.userNamesNotEndorsed[0].role == "student") {
                    $scope.UniqueNoText = "Admission No";
                }

                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
            }
        });
    };

    function bindData(res, page) {
        var _$scope$filteredNotEn2;

        _.each(res.users, function (user) {
            user.page = page;
        });
        $scope.userNamesNotEndorsed = res.users;
        $scope.userNamesNotEndorsed.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        (_$scope$filteredNotEn2 = $scope.filteredNotEndorsedUsers).push.apply(_$scope$filteredNotEn2, _toConsumableArray(res.users));
        $scope.filteredNotEndorsedUsers.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        multipleBatchFilterCtrl.userNotEndorsedAcademic = _.uniq(_.pluck(res.users, 'academic_details'));
        multipleBatchFilterCtrl.userNotEndorsedAcademic.sort(function (a, b) {
            if (a.name && b.name) {
                var textA = a.name.toUpperCase();
                var textB = b.name.toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            }
        });
    }

    multipleBatchFilterCtrl.selectAllNotEndorsed = function (selected, index, acade) {
        $scope.open = false;
        if (acade != undefined) {
            var cnt = 0;
            _.each($scope.filteredNotEndorsedUsers, function (user) {
                if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                    cnt = cnt + 1;
                    user.isChecked = selected;
                }
            });
            var userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage;
            });

            if (cnt === userTo.length) {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = true;
            } else {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = false;
            }
        } else {
            _.each($scope.filteredNotEndorsedUsers, function (user) {
                if (user.page == vm.pager.currentPage) user.isChecked = selected;
            });
        }
        $scope.filteredNotEndorsedUsers.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    multipleBatchFilterCtrl.getClickedNotEndorsedUser = function (person, index, acade) {
        $scope.open = false;
        if (acade != undefined) {
            var cnt = 0;
            _.each($scope.filteredNotEndorsedUsers, function (user) {
                if (user.academic_details === acade && user.page == vm.pager.currentPage) {
                    cnt = cnt + 1;
                }
            });

            var userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                return user.isChecked === true && user.academic_details === acade && user.page == vm.pager.currentPage;
            });

            if (cnt === userTo.length) {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = true;
            } else {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage][index] = false;
            }
        } else {
            var _userTo = _.filter($scope.filteredNotEndorsedUsers, function (user) {
                return user.isChecked === true && user.page == vm.pager.currentPage;
            });
            if ($scope.filteredNotEndorsedUsers.length === _userTo.length) {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage] = true;
            } else {
                multipleBatchFilterCtrl.allItemsSelected[vm.pager.currentPage] = false;
            }
        }
        $scope.filteredNotEndorsedUsers.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
    };

    $scope.saveSearchFilter = function () {
        $scope.open = false;

        var filterItem = {
            'school_id': localStorageService.get('school_id'),
            'title': multipleBatchFilterCtrl.saveName,
            'state': $scope.stateId,
            'role': $scope.filterObj.role_id,
            'session': $scope.filterObj.session,
            'curriculum': $scope.filterObj.curriculum,
            'class': $scope.filterObj.xclass,
            'batch': $scope.filterObj.batch,
            'subject': $scope.filterObj.subject,
            'check_all_batch': multipleBatchFilterCtrl.checkAll,
            'check_all_class': multipleBatchFilterCtrl.checkAllClass,
            'check_all_subject': multipleBatchFilterCtrl.checkAllSubject,
            'chart_type': $scope.filterObj.chart,
            'multirole': $scope.filterObj.multirole
        };

        if ($scope.filterObj.role_id === undefined && $scope.filterObj.session === undefined) {
            toastr.error("Please select atleast one field");
            return false;
        }

        if (!multipleBatchFilterCtrl.saveName) {
            toastr.error("Please enter title");
            return false;
        }

        /*
         * To add filter data
         * 
         * @Developer : Jeevanantham N
         */
        authService.callAPI(filterCons.API_POST_ADD_SERACH, "POST", filterItem, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.info) {
                multipleBatchFilterCtrl.saveName = undefined;
                getSavedSearch();
                toastr.success("Successfully saved");
            } else {
                $scope.loading = false;
                toastr.error('Server Interpreted.Please try after some time.', 'error-toast');
            }
        });
    };

    $scope.openDropdown = function (data) {

        if (data) {
            $scope.open = !$scope.open;
        }
    };

    $scope.getSavedData = function (savedDet) {
        $scope.open = false;
        $scope.selectedFilterData = savedDet.title;
        // $scope.openDropdown("open");
        multipleBatchFilterCtrl.selectedSavedSerach = savedDet;
        clearComponentField();
        multipleBatchFilterCtrl.getCuriculum(savedDet.session);
        multipleBatchFilterCtrl.getClass(savedDet.curriculum);
        $scope.filterObj['role'] = savedDet.role;
        $scope.filterObj['session'] = savedDet.session;
        $scope.filterObj['curriculum'] = savedDet.curriculum;
        $scope.selectCuriculum = savedDet.session;

        if (savedDet.check_all_class) {
            $scope.selectClasses('all');
        }

        if (savedDet.class != undefined) {
            if ($scope.stateId === 'userManagement') {
                multipleBatchFilterCtrl.getBatch(savedDet.class[0]);
                $scope.filterObj['xclass'] = [];
                $scope.filterObj['xclass'].push(savedDet.class);
                $scope.filterObj['singlefieldclass'] = savedDet.class[0];
            } else {
                for (var i = savedDet.class.length - 1; i >= 0; i--) {
                    multipleBatchFilterCtrl.getBatch(savedDet.class[i]);
                }
            }
        }

        if (savedDet.check_all_batch) {
            multipleBatchFilterCtrl.checkAll = true;
            $scope.selectBatches('all');
        }
        $scope.filterObj['xclass'] = savedDet.class;
        $scope.filterObj['batch'] = savedDet.batch;
        $scope.filterObj['subject'] = savedDet.subject;
        $scope.filterObj['role_id'] = savedDet.role;
        multipleBatchFilterCtrl.checkAllClass = savedDet.check_all_class;
        multipleBatchFilterCtrl.checkAllSubject = savedDet.check_all_subject;
        $scope.filterObj['chart'] = savedDet.chart_type;
        $scope.filterObj['multirole'] = savedDet.multirole;
        $scope.selectCuriculum = savedDet.session;

        try {
            if ($scope.stateId === 'userManagement') {

                $scope.searchValuesBasedOnFilter();
            }
        } catch (ex) {}
        saveFilterDataToStorage();
    };

    $scope.unsetValue = function () {
        $scope.saved_search = null;
    };
}];

exports.default = CommonFilterController;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0BJREFUeNqEU19IU1EYP+fcu+lUnFNTpzLNmZrOmylhoKlhEcJeegoirCyK6CGht17CeoteDCGMwAdD0HpJIUJ7UWsWgShoTmXN+We5OZx2r3Nz957Td3fH9KX6Hi73nPP9zvf7/c73YYfDMT4+TilF/wtBEOx2+9EdHsBtbW3p6emAxxj/DakoyujoKGMMcrSvCoaw2WyEkH8gtZientZyEpk8wCKRiMFgCIVCiCkM8bF9VQXDiGOYYWpIScOIylRJHCFGEEY8sOU4DpZOpzMaVTCSGRwBjmBCCUWKPjWptuo0EOVwDIhVGMKUIcIDB9ADMsrKysA1xqKqKsRDqTlxbcI7/8XnXlp+TRAx4aSNeUNrQZ1gssASblBJQmUAu93ucCRKsFqDY3QkOPtenN8IB2VOwUASoW229+zH8LvVr3fL226UNqp+aU7q9Xqr1YooY4QD5QOeyT7P973IPgMfY0g1YmatiFtPZwZ1jLt64hyfcM/lcskHUVC7GPX1+j4BMi0ppavmypnsUozwT9HXNTvkEjcpuIJo79LH6syC+K1AOy8vz2w25xeal/H2ejgI7Psa7ucaMu5Nvbo22e2WfANNnbkGIySHlahT2hz7NUcAphWXJCm4J/6Wdh3+ZYYVIJlnMLVPvpjbWV2R/I9nBhd3ve3WlrgCSif8C7zWMbA2Go2pCuMJdUUDSH0INBtcUdhh2zq2FuuySuJMEXburMU1Az4QCIQPInrQpFDM8RwmlcbCox1Wk1m8sLuu/RPEAYZo7wx9Bu8s2KorhMrKbItaj7GQctBTf7s4LSc/JfNBpf2ypX5hZyNemaNVpiICHQbIhG3wbco5Ce5D39z83KPndODTUPND2ATl3fUdF/NPxQaFnc2t4BOYGH8GTdtaIAx7vjklrz+8e8fx8lhyuo5w3lDweFrOm6bOC2ZhzDtbYbRcMlerhiUqgxbgW2Mq7ii/+GTmraTsw1YgLGpnbsnf8OGRmoTxrfLz1aZiXpblo64QpOq4XtoiM/n53Mj2gcjU6TqMJMLbMiztJc0q0/7+fqCdnJysYWEAgbtKH9M1Jk6Jyx5dZEsXhjkRciyNuVWt5lohq4iLXflHgAEAWDGU/rRQ/n0AAAAASUVORK5CYII="

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "<style>.slctBt{margin:9px;border-radius:7px;margin-top:16px;background-color:#007aff;height:33px!important;border:#fff;color:#fff;width:126px;display:flex;justify-content:center;align-items:center;font-size:13px}.cancelBt{margin:9px;border-radius:7px;margin-top:16px;background-color:rgb(229 229 229);height:33px!important;border:#fff;color:#080808;width:126px;display:flex;justify-content:center;align-items:center;font-size:13px}.ft-weight{font-weight:600!important}.oneTitle:hover{background-color:rgb(239 239 239);border-radius:5px}</style> <md-dialog aria-label=\"Not Updated Admission numbers\" style=max-height:350px;border-radius:10px;max-width:600px flex=60> <form ng-cloak> <md-toolbar> <div style=background-color:#007aff class=md-toolbar-tools> <h2 style=font-size:13px class=ft-weight>{{modal.title}} &nbsp; (Topic:{{titleitem.theme_txt| limitTo: 25 }}{{titleitem.theme_txt.length > 50 ? '...' : ''}})</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> </md-button> </div> </md-toolbar> <md-dialog-content style=\"border-bottom:1px solid #e5e5e5\"> <div class=md-dialog-content> <div layout=row> <p felx=100 ng-show=\"titles && titles.length && qp_type.activity_type != 'normal'\"> <md-radio-group ng-model=titleitem.qpTitle ng-change=validateTitle()> <md-radio-button class=oneTitle style=line-height:1.4 value={{title._id}} ng-repeat=\"title in titles| orderBy:'title' track by title._id\" class=md-primary>{{title.title}}</md-radio-button> </md-radio-group> </p> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <div style=padding:5px;background:#fafad2;color:#bd4f2e ng-show=!titleitem.canContinue> Same title has been used for the selected topic.Are you sure to proceed? </div> <div layout=row> <button ng-if=titleitem.qpTitle class=\"slctBt ft-weight\" ng-click=saveAction()>Select </button> <button class=\"cancelBt ft-weight\" ng-click=cancel()>Cancel</button> </div> </md-dialog-actions> </form> </md-dialog>";

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Reject request\" class=\"flex-40 full_modal viewOnly\" ng-cloak style=max-width:36%!important> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h2> <font>Exam progression Status </font> </h2> <span flex></span> <md-button class=\"md-icon-button md-primary\" ng-click=cancel()> <md-icon aria-label=\"Close dialog\" style=color:#fff>X</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground style=padding:20px;height:100%> <div class=allqstn flex=100 flex-gt-xs style=height:auto;min-height:auto;overflow:auto> <div flex ng-repeat=\"questionState in array track by $index\" style=display:inline-block layout-align=\"center center\"> <button style=margin:3px;cursor:auto;outline:0 class=\"md-whiteframe-2dp {{(questionState.attendStatus)?'submit':'normal'}}\" aria-label=questionState.count> {{$index+1}}</button> </div> </div> </md-dialog-content> <md-dialog-actions layout=row md-whiteframe-1dp> <span flex></span> <md-button class=\"md-raised md-primary\" ng-click=cancel() style=margin-right:20px> Cancel </md-button> </md-dialog-actions> </md-dialog> <style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#3365c1}.overflow{padding:7px 142px;overflow:none}.full_modal{height:45%}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.student_name{text-transform:capitalize}.ownerClss{background:#aaecc2!important}</style>";

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports = "<link href=\"https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap\" rel=stylesheet> <style>.image_div_font_size{font-size:small;color:#541953}.image_div_content{border:1px solid #ff9efd}.font_roboto{font-family:Roboto Condensed}.image_download_icon{color:#fff;padding:4px;background:#541953}.border_radius5{border-radius:5px}.card{border-radius:5px;padding:10px;border:1px solid #aaa;font-size:12px;min-height:64px;max-height:64px}.image_card_border{border:1px solid #ffe1fef0}.hand_mouse{cursor:pointer}.zoom{transition:transform .2s;width:200px;margin:0 auto}.zoom:hover{transform:scale(1.5)}*{box-sizing:border-box}.img-zoom-container{position:relative}.img-zoom-lens{position:absolute;border:1px solid #d4d4d4;width:40px;height:40px}.img-zoom-result{border:1px solid #d4d4d4;width:300px;height:242px}.font_majentha{color:#6c246c}.textcenter{text-align:center}.padding10{padding:10px}.dateDiv{font-size:13px;font-weight:900;color:grey}.timeDiv{font-weight:900;color:#3265c0;font-size:14px}.btn_download{min-width:50px!important;margin-left:22px}.btn_cancel{background-color:#2e2d2d!important;color:#fcfcfc!important}.dialogHead{background-color:#52b0f5!important}.large-Modal .modal-dialog{height:400px;width:400px;margin:auto;position:absolute;top:0;right:0;bottom:0;left:0}.btn_proceed{background-color:#129218!important;color:#fcfcfc!important}.btn_stop{background-color:#c04332!important;color:#fcfcfc!important}.btn_warning{background-color:#fc0!important;color:#2e2d2d!important}.btn_click{background-color:#3265c0!important;color:#fcfcfc!important}.md-fab{margin:0 0 0 6px!important}.selectAll .md-icon{border-color:#fff!important}.md-cancel-button{background-color:#2e2d2d!important}.md-confirm-button{background-color:#3265c0!important}</style> <script></script> <md-dialog flex=90 class=proctoring_modal> <md-toolbar> <div class=\"md-toolbar-tools dialogHead\"> <h2>Student Exam Proceed List</h2> <div flex=5 style=\"padding:10px 0 0 0;margin:0 0 0 20px\"> <md-checkbox ng-change=selectAll() class=selectAll ng-model=isChecked aria-label=Finished?></md-checkbox> </div> <md-button ng-if=proceedExamALLBtn ng-click=showConfirmProceed() class=\"md-raised btn_proceed md-fab md-primary\" style=width:40px;height:40px> <md-tooltip md-direction=left>Unlock ALL </md-tooltip> <i class=\"fa fa-unlock-alt\" aria-hidden=true></i> </md-button> <div><b></b></div> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content layout=column> <md-content flex layout-padding class=md-whiteframe-3dp> <div flex=100 layout-padding layout-wrap style=margin-bottom:38px> <div flex=100 flex layout=row layout-wrap> <div flex=33 ng-repeat=\"studList in poceedingStuListNEW | orderBy:'name'\" ng-style={{studList.remove_div}}> <div flex layout=row class=card flex=100> <div flex=5 style=\"padding:10px 0 0 0\"> <md-checkbox ng-model=studList.isChecked aria-label=Finished?></md-checkbox> </div> <div flex=75 style=padding:10px> {{studList.name}}</div> <div flex=20> <md-button ng-click=proceedExam(studList) class=\"md-raised md-fab btn_proceed md-primary\" style=width:40px;height:40px> <md-tooltip md-direction=left>Unlock</md-tooltip> <i class=\"fa fa-unlock-alt\" aria-hidden=true></i> </md-button> </div> </div> </div> </div> </div> </md-content> <md-divider></md-divider> </div> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-click=cancel() class=\"md-raised btn_cancel md-fab md-primary\" style=width:40px;height:40px> <i class=\"fas fa-times-circle\"></i> </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "<style>.scheduler_header{background-color:#00b6f2!important;display:block;color:#fff}table,td{border:1px solid grey;border-collapse:collapse;padding:5px}.quiz-table{width:100%}.quiz-tr-head{background-color:#5d545470;color:#fff;text-align:center}.quiz-tr{text-align:center;background-color:#80808024}.tr-label{color:#035cc9;font-weight:600}.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}#customers{font-family:\"Trebuchet MS\",Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td,#customers th{border:1px solid #ddd;padding:8px}#customers tr:nth-child(even){background-color:#d0f1d1}#customers tr:nth-child(odd){background-color:#c5ffc6}#customers tr:hover{background-color:#ddd}#customers th{padding-top:12px;padding-bottom:12px;text-align:left;background-color:#4caf50;color:#fff}.metadata-question{background-color:#1f5fab}.qn-label{color:#a7a7a7;font-size:12px}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading metadata-question\"> <h3> Add Comment </h3> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <i aria-label=\"Close dialog\" class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=\"whitebackground md-padding\"> <div> <div layout=column> <md-input-container md-select-on-focus flex=90> <div class=qn-label>Enter Comment</div> <textarea ng-model=answer.comment md-maxlength=500 md-select-on-focus></textarea> </md-input-container> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <div flex-lg=100 layout layout-align=\"end end\"> <md-button class=\"md-raised md-primary\" ng-click=addComment()>Save</md-button> </div> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = "<md-dialog flex> <md-toolbar> <div flex layout=row class=md-toolbar-tools layout-align=\"space-around center\"> <div flex class=preview-heading> <p style=margin-bottom:0!important;font-size:20px>Image Preview</p> </div> <i class=\"fas fa-times\" style=display:flex ng-click=cancel()></i> </div> </md-toolbar> <md-divider></md-divider> <md-dialog-content> <div class=md-dialog-content layout=column style=background:#fff;text-align:center> <div> <img src={{imageDetails.image}} style=height:300px> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *
 * @revision    $Id: index.js 2012-03-24 16:21:10 Aleksey $
 * @created     2016-09-24 16:21:10
 * @category    Express Helpers
 * @package     device-uuid
 * @version     1.0.2
 * @copyright   Copyright (c) 2016-2017 - All rights reserved.
 * @license     MIT License
 * @author      Alexey Gordeyev IK <aleksej@gordejev.lv>
 * @link        http://www.gordejev.lv
 *
 */
module.exports = __webpack_require__(931);

/***/ }),
/* 931 */
/***/ (function(module, exports) {

/*!
 * device-uuid.js v1.0.4 (https://github.com/biggora/device-uuid/)
 * Copyright 2016-2017 Alexey Gordeyev
 * Licensed under MIT (https://github.com/biggora/device-uuid/blob/master/LICENSE)
 */
/*global
 screen, window, navigator
 */
(function (exports) {
    'use strict';

    var BOTS = [
        '\\+https:\\/\\/developers.google.com\\/\\+\\/web\\/snippet\\/',
        'googlebot',
        'baiduspider',
        'gurujibot',
        'yandexbot',
        'slurp',
        'msnbot',
        'bingbot',
        'facebookexternalhit',
        'linkedinbot',
        'twitterbot',
        'slackbot',
        'telegrambot',
        'applebot',
        'pingdom',
        'tumblr ',
        'Embedly',
        'spbot'
    ];
    var IS_BOT_REGEXP = new RegExp('^.*(' + BOTS.join('|') + ').*$');

    var DeviceUUID = function (options) {
        options = options ? options : {};
        var defOptions = {
            version: false,
            language: false,
            platform: true,
            os: true,
            pixelDepth: true,
            colorDepth: true,
            resolution: false,
            isAuthoritative: true,
            silkAccelerated: true,
            isKindleFire: true,
            isDesktop: true,
            isMobile: true,
            isTablet: true,
            isWindows: true,
            isLinux: true,
            isLinux64: true,
            isChromeOS: true,
            isMac: true,
            isiPad: true,
            isiPhone: true,
            isiPod: true,
            isAndroid: true,
            isSamsung: true,
            isSmartTV: true,
            isRaspberry: true,
            isBlackberry: true,
            isTouchScreen: true,
            isOpera: false,
            isIE: false,
            isEdge: false,
            isIECompatibilityMode: false,
            isSafari: false,
            isFirefox: false,
            isWebkit: false,
            isChrome: false,
            isKonqueror: false,
            isOmniWeb: false,
            isSeaMonkey: false,
            isFlock: false,
            isAmaya: false,
            isPhantomJS: false,
            isEpiphany: false,
            source: false,
            cpuCores: false
        };
        for (var key in options) {
            if (options.hasOwnProperty(key) && typeof defOptions[key] !== 'undefined') {
                defOptions[key] = options[key];
            }
        }
        this.options = defOptions;
        this.version = '1.0.0';
        this._Versions = {
            Edge: /Edge\/([\d\w\.\-]+)/i,
            Firefox: /firefox\/([\d\w\.\-]+)/i,
            IE: /msie\s([\d\.]+[\d])|trident\/\d+\.\d+;.*[rv:]+(\d+\.\d)/i,
            Chrome: /chrome\/([\d\w\.\-]+)/i,
            Chromium: /(?:chromium|crios)\/([\d\w\.\-]+)/i,
            Safari: /version\/([\d\w\.\-]+)/i,
            Opera: /version\/([\d\w\.\-]+)|OPR\/([\d\w\.\-]+)/i,
            Ps3: /([\d\w\.\-]+)\)\s*$/i,
            Psp: /([\d\w\.\-]+)\)?\s*$/i,
            Amaya: /amaya\/([\d\w\.\-]+)/i,
            SeaMonkey: /seamonkey\/([\d\w\.\-]+)/i,
            OmniWeb: /omniweb\/v([\d\w\.\-]+)/i,
            Flock: /flock\/([\d\w\.\-]+)/i,
            Epiphany: /epiphany\/([\d\w\.\-]+)/i,
            WinJs: /msapphost\/([\d\w\.\-]+)/i,
            PhantomJS: /phantomjs\/([\d\w\.\-]+)/i,
            UC: /UCBrowser\/([\d\w\.]+)/i
        };
        this._Browsers = {
            Edge: /edge/i,
            Amaya: /amaya/i,
            Konqueror: /konqueror/i,
            Epiphany: /epiphany/i,
            SeaMonkey: /seamonkey/i,
            Flock: /flock/i,
            OmniWeb: /omniweb/i,
            Chromium: /chromium|crios/i,
            Chrome: /chrome/i,
            Safari: /safari/i,
            IE: /msie|trident/i,
            Opera: /opera|OPR/i,
            PS3: /playstation 3/i,
            PSP: /playstation portable/i,
            Firefox: /firefox/i,
            WinJs: /msapphost/i,
            PhantomJS: /phantomjs/i,
            UC: /UCBrowser/i
        };
        this._OS = {
            Windows10: /windows nt 10\.0/i,
            Windows81: /windows nt 6\.3/i,
            Windows8: /windows nt 6\.2/i,
            Windows7: /windows nt 6\.1/i,
            UnknownWindows: /windows nt 6\.\d+/i,
            WindowsVista: /windows nt 6\.0/i,
            Windows2003: /windows nt 5\.2/i,
            WindowsXP: /windows nt 5\.1/i,
            Windows2000: /windows nt 5\.0/i,
            WindowsPhone8: /windows phone 8\./,
            OSXCheetah: /os x 10[._]0/i,
            OSXPuma: /os x 10[._]1(\D|$)/i,
            OSXJaguar: /os x 10[._]2/i,
            OSXPanther: /os x 10[._]3/i,
            OSXTiger: /os x 10[._]4/i,
            OSXLeopard: /os x 10[._]5/i,
            OSXSnowLeopard: /os x 10[._]6/i,
            OSXLion: /os x 10[._]7/i,
            OSXMountainLion: /os x 10[._]8/i,
            OSXMavericks: /os x 10[._]9/i,
            OSXYosemite: /os x 10[._]10/i,
            OSXElCapitan: /os x 10[._]11/i,
            OSXSierra: /os x 10[._]12/i,
            Mac: /os x/i,
            Linux: /linux/i,
            Linux64: /linux x86_64/i,
            ChromeOS: /cros/i,
            Wii: /wii/i,
            PS3: /playstation 3/i,
            PSP: /playstation portable/i,
            iPad: /\(iPad.*os (\d+)[._](\d+)/i,
            iPhone: /\(iPhone.*os (\d+)[._](\d+)/i,
            Bada: /Bada\/(\d+)\.(\d+)/i,
            Curl: /curl\/(\d+)\.(\d+)\.(\d+)/i
        };
        this._Platform = {
            Windows: /windows nt/i,
            WindowsPhone: /windows phone/i,
            Mac: /macintosh/i,
            Linux: /linux/i,
            Wii: /wii/i,
            Playstation: /playstation/i,
            iPad: /ipad/i,
            iPod: /ipod/i,
            iPhone: /iphone/i,
            Android: /android/i,
            Blackberry: /blackberry/i,
            Samsung: /samsung/i,
            Curl: /curl/i
        };

        this.DefaultAgent = {
            isAuthoritative: true,
            isMobile: false,
            isTablet: false,
            isiPad: false,
            isiPod: false,
            isiPhone: false,
            isAndroid: false,
            isBlackberry: false,
            isOpera: false,
            isIE: false,
            isEdge: false,
            isIECompatibilityMode: false,
            isSafari: false,
            isFirefox: false,
            isWebkit: false,
            isChrome: false,
            isKonqueror: false,
            isOmniWeb: false,
            isSeaMonkey: false,
            isFlock: false,
            isAmaya: false,
            isPhantomJS: false,
            isEpiphany: false,
            isDesktop: false,
            isWindows: false,
            isLinux: false,
            isLinux64: false,
            isMac: false,
            isChromeOS: false,
            isBada: false,
            isSamsung: false,
            isRaspberry: false,
            isBot: false,
            isCurl: false,
            isAndroidTablet: false,
            isWinJs: false,
            isKindleFire: false,
            isSilk: false,
            isCaptive: false,
            isSmartTV: false,
            isUC: false,
            isTouchScreen: false,
            silkAccelerated: false,
            colorDepth: -1,
            pixelDepth: -1,
            resolution: [],
            cpuCores: -1,
            language: 'unknown',
            browser: 'unknown',
            version: 'unknown',
            os: 'unknown',
            platform: 'unknown',
            geoIp: {},
            source: '',
            hashInt: function (string) {
                var hash = 0, i, chr, len;
                if (string.length === 0) { return hash; }
                for (i = 0, len = string.length; i < len; i++) {
                    chr = string.charCodeAt(i);
                    hash = ((hash << 5) - hash) + chr;
                    hash |= 0;
                }
                return hash;
            },
            hashMD5: function (string) {
                function rotateLeft(lValue, iShiftBits) {
                    return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
                }

                function addUnsigned(lX, lY) {
                    var lX4, lY4, lX8, lY8, lResult;
                    lX8 = (lX & 0x80000000);
                    lY8 = (lY & 0x80000000);
                    lX4 = (lX & 0x40000000);
                    lY4 = (lY & 0x40000000);
                    lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);

                    if (lX4 & lY4) {
                        return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
                    }
                    if (lX4 | lY4) {
                        if (lResult & 0x40000000) {
                            return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                        } else {
                            return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                        }
                    } else {
                        return (lResult ^ lX8 ^ lY8);
                    }
                }

                function gF(x, y, z) {
                    return (x & y) | ((~x) & z);
                }

                function gG(x, y, z) {
                    return (x & z) | (y & (~z));
                }

                function gH(x, y, z) {
                    return (x ^ y ^ z);
                }

                function gI(x, y, z) {
                    return (y ^ (x | (~z)));
                }

                function gFF(a, b, c, d, x, s, ac) {
                    a = addUnsigned(a, addUnsigned(addUnsigned(gF(b, c, d), x), ac));
                    return addUnsigned(rotateLeft(a, s), b);
                }

                function gGG(a, b, c, d, x, s, ac) {
                    a = addUnsigned(a, addUnsigned(addUnsigned(gG(b, c, d), x), ac));
                    return addUnsigned(rotateLeft(a, s), b);
                }

                function gHH(a, b, c, d, x, s, ac) {
                    a = addUnsigned(a, addUnsigned(addUnsigned(gH(b, c, d), x), ac));
                    return addUnsigned(rotateLeft(a, s), b);
                }

                function gII(a, b, c, d, x, s, ac) {
                    a = addUnsigned(a, addUnsigned(addUnsigned(gI(b, c, d), x), ac));
                    return addUnsigned(rotateLeft(a, s), b);
                }

                function convertToWordArray(string) {
                    var lWordCount;
                    var lMessageLength = string.length;
                    var lNumberOfWordsTemp1 = lMessageLength + 8;
                    var lNumberOfWordsTemp2 = (lNumberOfWordsTemp1 - (lNumberOfWordsTemp1 % 64)) / 64;
                    var lNumberOfWords = (lNumberOfWordsTemp2 + 1) * 16;
                    var lWordArray = new Array(lNumberOfWords - 1);
                    var lBytePosition = 0;
                    var lByteCount = 0;

                    while (lByteCount < lMessageLength) {
                        lWordCount = (lByteCount - (lByteCount % 4)) / 4;
                        lBytePosition = (lByteCount % 4) * 8;
                        lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount) << lBytePosition));
                        lByteCount++;
                    }

                    lWordCount = (lByteCount - (lByteCount % 4)) / 4;
                    lBytePosition = (lByteCount % 4) * 8;
                    lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
                    lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
                    lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
                    return lWordArray;
                }

                function wordToHex(lValue) {
                    var wordToHexValue = '', wordToHexValueTemp = '', lByte, lCount;
                    for (lCount = 0; lCount <= 3; lCount++) {
                        lByte = (lValue >>> (lCount * 8)) & 255;
                        wordToHexValueTemp = '0' + lByte.toString(16);
                        wordToHexValue = wordToHexValue + wordToHexValueTemp.substr(wordToHexValueTemp.length - 2, 2);
                    }
                    return wordToHexValue;
                }

                function utf8Encode(string) {
                    string = string.replace(/\r\n/g, '\n');
                    var utftext = '';

                    for (var n = 0; n < string.length; n++) {
                        var c = string.charCodeAt(n);
                        if (c < 128) {
                            utftext += String.fromCharCode(c);
                        } else if ((c > 127) && (c < 2048)) {
                            utftext += String.fromCharCode((c >> 6) | 192);
                            utftext += String.fromCharCode((c & 63) | 128);
                        } else {
                            utftext += String.fromCharCode((c >> 12) | 224);
                            utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                            utftext += String.fromCharCode((c & 63) | 128);
                        }
                    }
                    return utftext;
                }

                var x = [];
                var k, AA, BB, CC, DD, a, b, c, d;
                var S11 = 7, S12 = 12, S13 = 17, S14 = 22;
                var S21 = 5, S22 = 9, S23 = 14, S24 = 20;
                var S31 = 4, S32 = 11, S33 = 16, S34 = 23;
                var S41 = 6, S42 = 10, S43 = 15, S44 = 21;
                string = utf8Encode(string);
                x = convertToWordArray(string);
                a = 0x67452301;
                b = 0xEFCDAB89;
                c = 0x98BADCFE;
                d = 0x10325476;

                for (k = 0; k < x.length; k += 16) {
                    AA = a;
                    BB = b;
                    CC = c;
                    DD = d;
                    a = gFF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
                    d = gFF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
                    c = gFF(c, d, a, b, x[k + 2], S13, 0x242070DB);
                    b = gFF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
                    a = gFF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
                    d = gFF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
                    c = gFF(c, d, a, b, x[k + 6], S13, 0xA8304613);
                    b = gFF(b, c, d, a, x[k + 7], S14, 0xFD469501);
                    a = gFF(a, b, c, d, x[k + 8], S11, 0x698098D8);
                    d = gFF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
                    c = gFF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
                    b = gFF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
                    a = gFF(a, b, c, d, x[k + 12], S11, 0x6B901122);
                    d = gFF(d, a, b, c, x[k + 13], S12, 0xFD987193);
                    c = gFF(c, d, a, b, x[k + 14], S13, 0xA679438E);
                    b = gFF(b, c, d, a, x[k + 15], S14, 0x49B40821);
                    a = gGG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
                    d = gGG(d, a, b, c, x[k + 6], S22, 0xC040B340);
                    c = gGG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
                    b = gGG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
                    a = gGG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
                    d = gGG(d, a, b, c, x[k + 10], S22, 0x2441453);
                    c = gGG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
                    b = gGG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
                    a = gGG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
                    d = gGG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
                    c = gGG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
                    b = gGG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
                    a = gGG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
                    d = gGG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
                    c = gGG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
                    b = gGG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
                    a = gHH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
                    d = gHH(d, a, b, c, x[k + 8], S32, 0x8771F681);
                    c = gHH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
                    b = gHH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
                    a = gHH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
                    d = gHH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
                    c = gHH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
                    b = gHH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
                    a = gHH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
                    d = gHH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
                    c = gHH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
                    b = gHH(b, c, d, a, x[k + 6], S34, 0x4881D05);
                    a = gHH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
                    d = gHH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
                    c = gHH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
                    b = gHH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
                    a = gII(a, b, c, d, x[k + 0], S41, 0xF4292244);
                    d = gII(d, a, b, c, x[k + 7], S42, 0x432AFF97);
                    c = gII(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
                    b = gII(b, c, d, a, x[k + 5], S44, 0xFC93A039);
                    a = gII(a, b, c, d, x[k + 12], S41, 0x655B59C3);
                    d = gII(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
                    c = gII(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
                    b = gII(b, c, d, a, x[k + 1], S44, 0x85845DD1);
                    a = gII(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
                    d = gII(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
                    c = gII(c, d, a, b, x[k + 6], S43, 0xA3014314);
                    b = gII(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
                    a = gII(a, b, c, d, x[k + 4], S41, 0xF7537E82);
                    d = gII(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
                    c = gII(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
                    b = gII(b, c, d, a, x[k + 9], S44, 0xEB86D391);
                    a = addUnsigned(a, AA);
                    b = addUnsigned(b, BB);
                    c = addUnsigned(c, CC);
                    d = addUnsigned(d, DD);
                }
                var temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);
                return temp.toLowerCase();
            }
        };

        this.Agent = {};

        this.getBrowser = function (string) {
            switch (true) {
                case this._Browsers.Edge.test(string):
                    this.Agent.isEdge = true;
                    return 'Edge';
                case this._Browsers.PhantomJS.test(string):
                    this.Agent.isPhantomJS = true;
                    return 'PhantomJS';
                case this._Browsers.Konqueror.test(string):
                    this.Agent.isKonqueror = true;
                    return 'Konqueror';
                case this._Browsers.Amaya.test(string):
                    this.Agent.isAmaya = true;
                    return 'Amaya';
                case this._Browsers.Epiphany.test(string):
                    this.Agent.isEpiphany = true;
                    return 'Epiphany';
                case this._Browsers.SeaMonkey.test(string):
                    this.Agent.isSeaMonkey = true;
                    return 'SeaMonkey';
                case this._Browsers.Flock.test(string):
                    this.Agent.isFlock = true;
                    return 'Flock';
                case this._Browsers.OmniWeb.test(string):
                    this.Agent.isOmniWeb = true;
                    return 'OmniWeb';
                case this._Browsers.Opera.test(string):
                    this.Agent.isOpera = true;
                    return 'Opera';
                case this._Browsers.Chromium.test(string):
                    this.Agent.isChrome = true;
                    return 'Chromium';
                case this._Browsers.Chrome.test(string):
                    this.Agent.isChrome = true;
                    return 'Chrome';
                case this._Browsers.Safari.test(string):
                    this.Agent.isSafari = true;
                    return 'Safari';
                case this._Browsers.WinJs.test(string):
                    this.Agent.isWinJs = true;
                    return 'WinJs';
                case this._Browsers.IE.test(string):
                    this.Agent.isIE = true;
                    return 'IE';
                case this._Browsers.PS3.test(string):
                    return 'ps3';
                case this._Browsers.PSP.test(string):
                    return 'psp';
                case this._Browsers.Firefox.test(string):
                    this.Agent.isFirefox = true;
                    return 'Firefox';
                case this._Browsers.UC.test(string):
                    this.Agent.isUC = true;
                    return 'UCBrowser';
                default:
                    // If the UA does not start with Mozilla guess the user agent.
                    if (string.indexOf('Mozilla') !== 0 && /^([\d\w\-\.]+)\/[\d\w\.\-]+/i.test(string)) {
                        this.Agent.isAuthoritative = false;
                        return RegExp.$1;
                    }
                    return 'unknown';
            }
        };

        this.getBrowserVersion = function (string) {
            var regex;
            switch (this.Agent.browser) {
                case 'Edge':
                    if (this._Versions.Edge.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'PhantomJS':
                    if (this._Versions.PhantomJS.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Chrome':
                    if (this._Versions.Chrome.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Chromium':
                    if (this._Versions.Chromium.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Safari':
                    if (this._Versions.Safari.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Opera':
                    if (this._Versions.Opera.test(string)) {
                        return RegExp.$1 ? RegExp.$1 : RegExp.$2;
                    }
                    break;
                case 'Firefox':
                    if (this._Versions.Firefox.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'WinJs':
                    if (this._Versions.WinJs.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'IE':
                    if (this._Versions.IE.test(string)) {
                        return RegExp.$2 ? RegExp.$2 : RegExp.$1;
                    }
                    break;
                case 'ps3':
                    if (this._Versions.Ps3.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'psp':
                    if (this._Versions.Psp.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Amaya':
                    if (this._Versions.Amaya.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Epiphany':
                    if (this._Versions.Epiphany.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'SeaMonkey':
                    if (this._Versions.SeaMonkey.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'Flock':
                    if (this._Versions.Flock.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'OmniWeb':
                    if (this._Versions.OmniWeb.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                case 'UCBrowser':
                    if (this._Versions.UC.test(string)) {
                        return RegExp.$1;
                    }
                    break;
                default:
                    if (this.Agent.browser !== 'unknown') {
                        regex = new RegExp(this.Agent.browser + '[\\/ ]([\\d\\w\\.\\-]+)', 'i');
                        if (regex.test(string)) {
                            return RegExp.$1;
                        }
                    }
            }
        };

        this.getOS = function (string) {
            switch (true) {
                case this._OS.WindowsVista.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows Vista';
                case this._OS.Windows7.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 7';
                case this._OS.Windows8.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 8';
                case this._OS.Windows81.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 8.1';
                case this._OS.Windows10.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 10.0';
                case this._OS.Windows2003.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 2003';
                case this._OS.WindowsXP.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows XP';
                case this._OS.Windows2000.test(string):
                    this.Agent.isWindows = true;
                    return 'Windows 2000';
                case this._OS.WindowsPhone8.test(string):
                    return 'Windows Phone 8';
                case this._OS.Linux64.test(string):
                    this.Agent.isLinux = true;
                    this.Agent.isLinux64 = true;
                    return 'Linux 64';
                case this._OS.Linux.test(string):
                    this.Agent.isLinux = true;
                    return 'Linux';
                case this._OS.ChromeOS.test(string):
                    this.Agent.isChromeOS = true;
                    return 'Chrome OS';
                case this._OS.Wii.test(string):
                    return 'Wii';
                case this._OS.PS3.test(string):
                    return 'Playstation';
                case this._OS.PSP.test(string):
                    return 'Playstation';
                case this._OS.OSXCheetah.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Cheetah';
                case this._OS.OSXPuma.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Puma';
                case this._OS.OSXJaguar.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Jaguar';
                case this._OS.OSXPanther.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Panther';
                case this._OS.OSXTiger.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Tiger';
                case this._OS.OSXLeopard.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Leopard';
                case this._OS.OSXSnowLeopard.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Snow Leopard';
                case this._OS.OSXLion.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Lion';
                case this._OS.OSXMountainLion.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Mountain Lion';
                case this._OS.OSXMavericks.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Mavericks';
                case this._OS.OSXYosemite.test(string):
                    this.Agent.isMac = true;
                    return 'OS X Yosemite';
                case this._OS.OSXElCapitan.test(string):
                    this.Agent.isMac = true;
                    return 'OS X El Capitan';
                case this._OS.OSXSierra.test(string):
                    this.Agent.isMac = true;
                    return 'macOS Sierra';
                case this._OS.Mac.test(string):
                    this.Agent.isMac = true;
                    return 'OS X';
                case this._OS.iPad.test(string):
                    this.Agent.isiPad = true;
                    return string.match(this._OS.iPad)[0].replace('_', '.');
                case this._OS.iPhone.test(string):
                    this.Agent.isiPhone = true;
                    return string.match(this._OS.iPhone)[0].replace('_', '.');
                case this._OS.Bada.test(string):
                    this.Agent.isBada = true;
                    return 'Bada';
                case this._OS.Curl.test(string):
                    this.Agent.isCurl = true;
                    return 'Curl';
                default:
                    return 'unknown';
            }
        };

        this.getPlatform = function (string) {
            switch (true) {
                case this._Platform.Windows.test(string):
                    return 'Microsoft Windows';
                case this._Platform.WindowsPhone.test(string):
                    this.Agent.isWindowsPhone = true;
                    return 'Microsoft Windows Phone';
                case this._Platform.Mac.test(string):
                    return 'Apple Mac';
                case this._Platform.Curl.test(string):
                    return 'Curl';
                case this._Platform.Android.test(string):
                    this.Agent.isAndroid = true;
                    return 'Android';
                case this._Platform.Blackberry.test(string):
                    this.Agent.isBlackberry = true;
                    return 'Blackberry';
                case this._Platform.Linux.test(string):
                    return 'Linux';
                case this._Platform.Wii.test(string):
                    return 'Wii';
                case this._Platform.Playstation.test(string):
                    return 'Playstation';
                case this._Platform.iPad.test(string):
                    this.Agent.isiPad = true;
                    return 'iPad';
                case this._Platform.iPod.test(string):
                    this.Agent.isiPod = true;
                    return 'iPod';
                case this._Platform.iPhone.test(string):
                    this.Agent.isiPhone = true;
                    return 'iPhone';
                case this._Platform.Samsung.test(string):
                    this.Agent.isiSamsung = true;
                    return 'Samsung';
                default:
                    return 'unknown';
            }
        };

        this.testCompatibilityMode = function () {
            var ua = this;
            if (this.Agent.isIE) {
                if (/Trident\/(\d)\.0/i.test(ua.Agent.source)) {
                    var tridentVersion = parseInt(RegExp.$1, 10);
                    var version = parseInt(ua.Agent.version, 10);
                    if (version === 7 && tridentVersion === 7) {
                        ua.Agent.isIECompatibilityMode = true;
                        ua.Agent.version = 11.0;
                    }

                    if (version === 7 && tridentVersion === 6) {
                        ua.Agent.isIECompatibilityMode = true;
                        ua.Agent.version = 10.0;
                    }

                    if (version === 7 && tridentVersion === 5) {
                        ua.Agent.isIECompatibilityMode = true;
                        ua.Agent.version = 9.0;
                    }

                    if (version === 7 && tridentVersion === 4) {
                        ua.Agent.isIECompatibilityMode = true;
                        ua.Agent.version = 8.0;
                    }
                }
            }
        };

        this.testSilk = function () {
            var ua = this;
            switch (true) {
                case new RegExp('silk', 'gi').test(ua.Agent.source):
                    this.Agent.isSilk = true;
                    break;
                default:
            }

            if (/Silk-Accelerated=true/gi.test(ua.Agent.source)) {
                this.Agent.SilkAccelerated = true;
            }
            return this.Agent.isSilk ? 'Silk' : false;
        };

        this.testKindleFire = function () {
            var ua = this;
            switch (true) {
                case /KFOT/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire';
                case /KFTT/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HD';
                case /KFJWI/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HD 8.9';
                case /KFJWA/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HD 8.9 4G';
                case /KFSOWI/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HD 7';
                case /KFTHWI/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HDX 7';
                case /KFTHWA/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HDX 7 4G';
                case /KFAPWI/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HDX 8.9';
                case /KFAPWA/gi.test(ua.Agent.source):
                    this.Agent.isKindleFire = true;
                    return 'Kindle Fire HDX 8.9 4G';
                default:
                    return false;
            }
        };

        this.testCaptiveNetwork = function () {
            var ua = this;
            switch (true) {
                case /CaptiveNetwork/gi.test(ua.Agent.source):
                    ua.Agent.isCaptive = true;
                    ua.Agent.isMac = true;
                    ua.Agent.platform = 'Apple Mac';
                    return 'CaptiveNetwork';
                default:
                    return false;
            }
        };

        this.testMobile = function testMobile() {
            var ua = this;
            switch (true) {
                case ua.Agent.isWindows:
                case ua.Agent.isLinux:
                case ua.Agent.isMac:
                case ua.Agent.isChromeOS:
                    ua.Agent.isDesktop = true;
                    break;
                case ua.Agent.isAndroid:
                case ua.Agent.isSamsung:
                    ua.Agent.isMobile = true;
                    ua.Agent.isDesktop = false;
                    break;
                default:
            }
            switch (true) {
                case ua.Agent.isiPad:
                case ua.Agent.isiPod:
                case ua.Agent.isiPhone:
                case ua.Agent.isBada:
                case ua.Agent.isBlackberry:
                case ua.Agent.isAndroid:
                case ua.Agent.isWindowsPhone:
                    ua.Agent.isMobile = true;
                    ua.Agent.isDesktop = false;
                    break;
                default:
            }
            if (/mobile/i.test(ua.Agent.source)) {
                ua.Agent.isMobile = true;
                ua.Agent.isDesktop = false;
            }
        };

        this.testTablet = function testTablet() {
            var ua = this;
            switch (true) {
                case ua.Agent.isiPad:
                case ua.Agent.isAndroidTablet:
                case ua.Agent.isKindleFire:
                    ua.Agent.isTablet = true;
                    break;
            }
            if (/tablet/i.test(ua.Agent.source)) {
                ua.Agent.isTablet = true;
            }
        };

        this.testNginxGeoIP = function testNginxGeoIP(headers) {
            var ua = this;
            Object.keys(headers).forEach(function (key) {
                if (/^GEOIP/i.test(key)) {
                    ua.Agent.geoIp[key] = headers[key];
                }
            });
        };

        this.testBot = function testBot() {
            var ua = this;
            var isBot = IS_BOT_REGEXP.exec(ua.Agent.source.toLowerCase());
            if (isBot) {
                ua.Agent.isBot = isBot[1];
            } else if (!ua.Agent.isAuthoritative) {
                // Test unauthoritative parse for `bot` in UA to flag for bot
                ua.Agent.isBot = /bot/i.test(ua.Agent.source);
            }
        };

        this.testSmartTV = function testBot() {
            var ua = this;
            var isSmartTV = new RegExp('smart-tv|smarttv|googletv|appletv|hbbtv|pov_tv|netcast.tv', 'gi').exec(ua.Agent.source.toLowerCase());
            if (isSmartTV) {
                ua.Agent.isSmartTV = isSmartTV[1];
            }
        };

        this.testAndroidTablet = function testAndroidTablet() {
            var ua = this;
            if (ua.Agent.isAndroid && !/mobile/i.test(ua.Agent.source)) {
                ua.Agent.isAndroidTablet = true;
            }
        };

        this.testTouchSupport = function () {
            var ua = this;
            ua.Agent.isTouchScreen = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
        };

        this.getLaguage = function () {
            var ua = this;
            ua.Agent.language = (navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || '').toLowerCase();
        };

        this.getColorDepth = function () {
            var ua = this;
            ua.Agent.colorDepth = screen.colorDepth || -1;
        };

        this.getScreenResolution = function () {
            var ua = this;
            ua.Agent.resolution = [screen.availWidth, screen.availHeight];
        };

        this.getPixelDepth = function () {
            var ua = this;
            ua.Agent.pixelDepth = screen.pixelDepth || -1;
        };

        this.getCPU = function () {
            var ua = this;
            ua.Agent.cpuCores = navigator.hardwareConcurrency || -1;
        };

        this.reset = function reset() {
            var ua = this;
            for (var key in ua.DefaultAgent) {
                if (ua.DefaultAgent.hasOwnProperty(key)) {
                    ua.Agent[key] = ua.DefaultAgent[key];
                }
            }
            return ua;
        };

        this.parse = function get(source) {
            source = source || navigator.userAgent;
            var ua = new DeviceUUID();
            ua.Agent.source = source.replace(/^\s*/, '').replace(/\s*$/, '');
            ua.Agent.os = ua.getOS(ua.Agent.source);
            ua.Agent.platform = ua.getPlatform(ua.Agent.source);
            ua.Agent.browser = ua.getBrowser(ua.Agent.source);
            ua.Agent.version = ua.getBrowserVersion(ua.Agent.source);
            ua.testBot();
            ua.testSmartTV();
            ua.testMobile();
            ua.testAndroidTablet();
            ua.testTablet();
            ua.testCompatibilityMode();
            ua.testSilk();
            ua.testKindleFire();
            ua.testCaptiveNetwork();
            ua.testTouchSupport();
            ua.getLaguage();
            ua.getColorDepth();
            ua.getPixelDepth();
            ua.getScreenResolution();
            ua.getCPU();
            return ua.Agent;
        };

        this.get = function (customData) {
            var pref = 'a', du = this.parse();
            var dua = [];
            for (var key in this.options) {
                if (this.options.hasOwnProperty(key) && this.options[key] === true) {
                    dua.push(du[key]);
                }
            }
            if (customData) {
                dua.push(customData);
            }
            if (!this.options.resolution && du.isMobile) {
                dua.push(du.resolution);
            }
            // 8, 9, a, b
            pref = 'b';
            var tmpUuid = du.hashMD5(dua.join(':'));
            var uuid = [
                tmpUuid.slice(0,8),
                tmpUuid.slice(8,12),
                '4' + tmpUuid.slice(12,15),
                pref + tmpUuid.slice(15,18),
                tmpUuid.slice(20)
            ];
            return uuid.join('-');
        };

        this.Agent = this.DefaultAgent;
        return this;
    };

    exports.DeviceUUID = DeviceUUID;
    return new DeviceUUID(navigator.userAgent);

})(this);


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.listPadding{padding:12px;margin-top:-2px}.dummy_pic_width{width:60px}.row_margin{margin:8px}.attendesBox{width:100%}.doctr .attendesBox{width:100%!important}</style> <md-dialog aria-label=Share flex ng-cloak class=attendesBox> <md-toolbar> <div class=\"md-toolbar-tools bordertop\" layout=row> <div flex=95> <h1 class=coloroftext>Invitees</h1></div> <div style=cursor:pointer flex=5 ng-click=cancel()> <i class=\"far fa-times-circle\"></i></div> </div> </md-toolbar> <md-dialog-content id=dialogContent_89> <div class=\"md-dialog-content dialogPadding\" flex=100> <div layout=row layout-xs=column layout-padding layout-wrap flex ng-cloak class=\"listPadding attendeeCtrl\"> <div flex-xs=100 layout=row ng-repeat=\"attendee in viewAttendeesArray | orderBy :'name'\" class=\"md-whiteframe-2dp whiteBoxMargin\" flex-gt-sm=30 flex-sm=45> <div> <img class=dummy_pic_width src=" + __webpack_require__(166) + "> </div> <div layout=column class=row_margin> <div>{{attendee.name}}</div> </div> </div> </div> </div> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.listPadding{padding:12px;margin-top:-2px}.dummy_pic_width{width:60px}.row_margin{margin:8px}.fontReduce{font-size:90%}.attendesBox{width:100%}.whiteframewidth{width:400px}</style> <md-dialog aria-label=Share flex ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools bordertop\" layout=row> <div flex=95> <h1 class=coloroftext>All Comments</h1></div> <div style=cursor:pointer flex=5 ng-click=cancel()> <i class=\"far fa-times-circle\"></i></div> </div> </md-toolbar> <md-dialog-content> <md-content layout-padding> <div layout=row class=\"doctorctrl prgrmCtrl\"> <div layout=column layout-xs=column layout-padding flex ng-cloak class=\"listPadding whiteBoxMargin attendesBox\"> <div layout=row ng-repeat=\"attendee in commentlist | orderBy :'name'\" class=\"md-whiteframe-3dp whiteframewidth leftBox\"> <div> <img class=dummy_pic_width src=" + __webpack_require__(166) + "> </div> <div layout=column class=row_margin style=outline:0> <div><b>{{attendee.name}}</b></div> <div class=fontReduce>Comments:{{attendee.feedback | limitTo: 100}}{{attendee.feedback.length > 100 ? '...' : ''}} <span ng-if=\"attendee.feedback.length > 100\" class=\"fontReduce readMore\" ng-click=showFullComment(attendee,$index)> read more..</span> </div> </div> </div> </div> <div layout-padding class=\"listPadding whiteBoxMargin attendesBox\" ng-if=\"entireComment!=null\"> <div class=\"md-whiteframe-3dp whiteframewidth rightBox\"> <div layout=row layout-align=\"space-between start\" ng-click=clear()> <span><b>{{commentedUser}}</b></span><i class=material-icons>clear</i> </div> <div layout=column class=row_margin style=outline:0> <div class=fontReduce>{{entireComment}}</div> </div> </div> </div> </div> </md-content> </md-dialog-content> </md-dialog> ";

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(935);

__webpack_require__(946);

__webpack_require__(952);

__webpack_require__(149);

__webpack_require__(963);

__webpack_require__(966);

__webpack_require__(969);

__webpack_require__(972);

__webpack_require__(975);

__webpack_require__(977);

__webpack_require__(980);

__webpack_require__(983);

__webpack_require__(990);

__webpack_require__(992);

__webpack_require__(994);

__webpack_require__(996);

__webpack_require__(998);

__webpack_require__(999);

__webpack_require__(1130);

__webpack_require__(1131);

__webpack_require__(1132);

__webpack_require__(1133);

__webpack_require__(1238);

__webpack_require__(1239);

__webpack_require__(1240);

__webpack_require__(1250);

__webpack_require__(1311);

__webpack_require__(398);

__webpack_require__(1313);

__webpack_require__(1315);

__webpack_require__(1388);

__webpack_require__(1389);

__webpack_require__(1390);

__webpack_require__(1391);

__webpack_require__(1392);

__webpack_require__(1393);

__webpack_require__(1394);

__webpack_require__(1395);

__webpack_require__(1396);

__webpack_require__(1397);

__webpack_require__(1398);

__webpack_require__(1399);

__webpack_require__(1404);

__webpack_require__(1410);

__webpack_require__(1412);

__webpack_require__(1413);

__webpack_require__(1415);

__webpack_require__(1417);

__webpack_require__(1419);

__webpack_require__(784);

__webpack_require__(793);

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _login = __webpack_require__(936);

var _login2 = _interopRequireDefault(_login);

__webpack_require__(943);

var _loginController = __webpack_require__(944);

var _loginController2 = _interopRequireDefault(_loginController);

var _authService = __webpack_require__(945);

var _authService2 = _interopRequireDefault(_authService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import loginSrv from './services/loginService'
var name = "login";
var _module = angular.module('app.LoginModule', [
    //import modules

]).component(name, {
    template: _login2.default,
    controller: _loginController2.default,
    controllerAs: name
});

//module.service('authService', authSrv);
//module.service('loginService', loginSrv);
/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('login', {
            url: '/login',
            views: {
                '@': {
                    template: loginTpl,
                    controller: loginCtrl,
                    controllerAs: 'login'
                }
            }
        })

}); */

// export this module
exports.default = _module;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<script src=https://accounts.google.com/gsi/client async defer=defer></script> <link rel=stylesheet href=../../../libs/style.css> <link rel=stylesheet href=https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css> <link href=https://cdn.rawgit.com/mdehoog/Semantic-UI/6e6d051d47b598ebab05857545f242caf2b4b48c/dist/semantic.min.css rel=stylesheet type=text/css /> <div class=login-main-container> <div class=login-main-div> <div class=login-left-container> <div> <img src=" + __webpack_require__(168) + " alt=\"\" style=height:37px> </div> <div class=iso-img> <img src=" + __webpack_require__(937) + " alt=\"\"> </div> <div class=banner-logos> <div><img src=" + __webpack_require__(938) + " alt=\"\"></div> <div><img src=" + __webpack_require__(939) + " alt=\"\"></div> <div> </div> </div> </div> <div class=login-right-container> <div class=bm-logo> <img src=" + __webpack_require__(168) + " alt=\"\" style=height:37px> </div> <div class=signin-form> <div class=bg-images> <img class=ellipse src=" + __webpack_require__(940) + " alt=\"\"> <img class=traj-edutn src=" + __webpack_require__(941) + " alt=\"\"> </div> <div class=form-details> <div class=\"login-header animate_form\"> <span> Welcome back to </span> <p> Benchmark Learning <br> Manager</p> </div> <div class=animate_form style=width:100%> <div ng-click=gsuitLogin(); style=margin-bottom:25px;margin-top:14px> <div id=buttonDiv></div> </div> </div> <div class=\"form-group animate_form\" style=text-align:center> <span class=or> <span class=or_text>OR</span> </span> </div> <div class=\"form-group mail-pass animate_form\" style=width:100%> <form> <span>E-mail Address</span><br> <input type=text class=\"mail ng-pristine ng-valid md-input ng-touched\" name=mail placeholder=\"Enter Your Email\" ng-model=newUser.username ng-focus=\"errors['username'] = ''\" maxlength=50 id=input_175 aria-invalid=false> <span>Password</span><br> <div class=password-container> <input type=password placeholder=Password... id=password ng-model=newUser.password ng-focus=\"errors['password'] = ''\" class=\"password ng-pristine ng-valid md-input ng-touched\" maxlength=55 aria-invalid=false ng-keyup=checkEnter($event)> <i class=\"fa-solid fa-eye\" id=eye ng-click=passCheck();></i> </div> </form> <a class=fpassword ui-sref=forgotPassword style=color:#fff>Forgot Password?</a> </div> <div class=signin-btn> <button type=submit class=\"btn_form animate_form\" ng-click=loginUser();>Sign in</button></div> <p class=explore>To explore more:</p> <div class=bm-btn> <a class=bm-careers href=https://benchmark.school/ target=_blank> <div class=bulb-lamp><img src=" + __webpack_require__(942) + " alt=\"\"></div> <div style=color:#fff>Benchmark Careers</div> </a></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginController =
// @ngInject
["$state", "$rootScope", "$scope", "localStorageService", "authService", "CONSTANTS", "$window", function LoginController($state, $rootScope, $scope, localStorageService, authService, CONSTANTS, $window) {
    _classCallCheck(this, LoginController);

    this.state = $state;
    this.Root = $rootScope;
    this.scope = $scope;

    // $scope.buildVersion = CONSTANTS.BUILD_VERSION
    $scope.buildVersion = "5.0";
    $scope.newUser = {};
    function reloadPage() {
        // location.reload();
        _showPrompt(1);
        initGapi();
    }
    function parseJwt(token) {
        try {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace('-', '+').replace('_', '/');
            return JSON.parse($window.atob(base64));
        } catch (e) {
            console.log(e);
            return null;
        }
    }
    function onOneTapSignedIn(data) {
        try {
            var user = parseJwt(data.credential);
            if (user && user.email && user.email_verified) {
                _hidePrompt();
                _loginFromOneTap(user);
            } else {
                // reloadPage()
                console.log('client parse error');
            }
        } catch (e) {
            console.log(e);
            // reloadPage()
            console.log('client parse error');
        }
    }
    function _doNothing() {}
    function initializeOneTap() {
        try {
            google.accounts.id.initialize({
                client_id: CONSTANTS.GC_CLIENT_ID,
                cancel_on_tap_outside: false,
                style: {
                    position: 'absolute', top: '1px', right: '30px',
                    width: 0, height: 0, 'z-index': '1001'
                },
                type: "icon",
                theme: "filled_blue",
                callback: onOneTapSignedIn,
                prompt_parent_id: "root",
                intermediate_iframe_close_callback: _doNothing
            });
            google.accounts.id.prompt(function (notification) {
                try {
                    if (notification.isNotDisplayed()) {
                        console.log(notification.getNotDisplayedReason());
                    } else if (notification.isSkippedMoment()) {
                        console.log(notification.getSkippedReason());
                    } else if (notification.isDismissedMoment()) {
                        console.log(notification.getDismissedReason());
                    } else {
                        if (notification.isSkippedMoment() && notification.getSkippedReason() === 'user_cancel') {
                            // do fallback logic
                            console.log(notification);
                        }
                    }
                } catch (gE) {
                    console.log(gE);
                }
            });
        } catch (eRR) {
            console.log(eRR);
        }
    }
    function _showPrompt() {
        var _DOM = document.getElementById("credential_picker_container");
        if (_DOM) {
            _DOM.style.display = "block";
        }
        var GBTN_DOM = document.getElementById("buttonDiv");
        if (GBTN_DOM) {
            GBTN_DOM.style.display = "block";
        }
    }
    function _hidePrompt() {
        var _DOM = document.getElementById("credential_picker_container");
        if (_DOM) {
            _DOM.style.display = "none";
        }
        var GBTN_DOM = document.getElementById("buttonDiv");
        if (GBTN_DOM) {
            GBTN_DOM.display = "none";
        }
    }
    function loadOneTapLogin() {
        if (!google.accounts || !google.accounts.id) {
            window.onGoogleLibraryLoad = function () {
                initializeOneTap();
            };
        } else {
            initializeOneTap();
        }
    }
    function _loginFromOneTap(resp) {
        try {
            authService.callAPI("/v1/gsuit_login_auth", "POST", resp, function (response) {
                if (response.result != undefined) {
                    var result = response.result.data.data[0];
                    try {
                        var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo;
                        var userBatchDetails = result.name;
                        if (result.admission_number) userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name;
                        _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                        _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                        _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                        _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                        _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                        _paq.push(['setUserId', result.username]);
                        _paq.push(['trackPageView']);
                    } catch (e) {
                        console.log(e);
                    }
                    // matomo analytics code ends

                    if (result.admission_number) {
                        localStorageService.set("className", result.className);
                    }
                    localStorageService.set("allAcademic_year", result.allAcademic_year);
                    localStorageService.set("is_login", true);
                    localStorageService.set("school_id", result.school_id);
                    localStorageService.set("school_name", result.school_name);
                    localStorageService.set("academic_year", result.academic_year);
                    localStorageService.set("user_id", result.user_id);
                    localStorageService.set("role_ids", result.role_ids);
                    localStorageService.set("full_name", result.name);
                    localStorageService.set("activeAcdYear", result.academic_year);
                    localStorageService.set("admission_no", result.admission_number);
                    localStorageService.set("username", result.username);
                    localStorageService.set("user_image", result.image);
                    localStorageService.set("active_time_check", result.active_time_check);
                    localStorageService.set('login_timestamp', new Date().getTime());
                    localStorageService.set("full_name", result.name);
                    localStorageService.set("mobile", result.phone);
                    localStorageService.set("user_address", result.addrLine1 + "," + result.addrLine2 + "," + result.city + "," + result.country);
                    localStorageService.set("module_privileges", result.module_privileges);
                    localStorageService.set("feature_privileges", result.feature_privileges);
                    $rootScope.username = result.name;

                    if (result.feeDuePopup) {
                        localStorageService.set("feedue_popup", result.feeDuePopup);
                        if (result.feedue_popup_message) {
                            localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                        }
                    }
                    if (result.bannerstatus) {
                        localStorageService.set("bannerstatus", result.bannerstatus);
                    }

                    // if(result.password_tracking){ 
                    //     localStorageService.set("password_tracking", true)
                    // } 

                    var userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                        return feature.module_state === "childrenComponent";
                    });
                    if (userAccessJson && userAccessJson.length) {
                        _.each(userAccessJson, function (feature) {
                            var user_access = {};
                            _.each(feature.privilege, function (privObj) {
                                user_access[privObj.name.toLowerCase()] = privObj.status;
                            });
                            localStorageService.set('parent_user_access', user_access);
                            $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                            _.defer(function () {
                                $scope.$apply();
                            });;
                        });
                    }

                    $rootScope.isLoggedIn = true;
                    var toredirected = localStorageService.get('toredirected');
                    if (toredirected && toredirected.student_id && toredirected.qp_id && toredirected.page && toredirected.parent_id && toredirected.parent_id == result.user_id) {
                        $state.go("activityReportViaLinkCtrl", {
                            student_id: toredirected.student_id,
                            qp_id: toredirected.qp_id,
                            page: toredirected.page,
                            teacher_id: toredirected.teacher_id,
                            parent_id: result.user_id
                        });
                    } else {
                        $state.go("dashboard");
                    }
                } else {
                    var msg = response.error.error.message;
                    //$scope.signOut();
                    toastr.error(msg);
                    reloadPage();
                }
            });
        } catch (eR) {
            console.log(eR);
            reloadPage();
        }
    }
    function handleGgOneTap(data) {}
    function handleCredentialResponse(data) {}
    function initializeGoogle() {
        var self = this;
        google.accounts.id.initialize({
            client_id: CONSTANTS.GC_CLIENT_ID,
            callback: onOneTapSignedIn,
            theme: "filled_white"
        });
        google.accounts.id.prompt();
        // google.accounts.id.initialize({
        //     client_id: CONSTANTS.GC_CLIENT_ID,
        //     callback: onOneTapSignedIn
        // });
        google.accounts.id.renderButton(document.getElementById("buttonDiv"), { size: "large", theme: "filled_white", 'width': 337 });
    }
    $scope.showHide = function () {
        var showForm = $scope.showForm;
        if (showForm) {} else {}
    };
    function initGapi() {
        try {

            gapi.load('auth2', function () {
                initializeGoogle();
            });

            // gapi.load('auth2', function() {
            //     /* Ready. Make a call to gapi.auth2.init or some other API */
            //     $scope.renderButton();
            // });
        } catch (e) {
            console.log(e);
        }
    }
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if ($rootScope.isLoggedIn) {
            $state.go("dashboard");
        } else {
            _showPrompt(1);
            // loadOneTapLogin()
            initGapi();
            //$scope.signOut();
        }
        $rootScope.title = "Login";
    };
    $scope.loginUser = function () {
        $scope.newUser.userAgent = "web";

        if ($scope.newUser.username && $scope.newUser.password) {
            _hidePrompt(2);
            authService.callAPI("/v1/login_auth", "POST", $scope.newUser, function (response) {

                if (response.result != undefined) {
                    var result = response.result.data.data[0];

                    // matomo analytics code starts
                    try {
                        if (response.result.data.sessionId != undefined) {
                            localStorageService.set("sessionId", response.result.data.sessionId);
                        }
                        var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo;
                        var userBatchDetails = result.name;
                        if (result.admission_number) userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name;
                        // _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                        // _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                        // _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                        // _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                        // _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                        _paq.push(['setCustomDimension', 1, result.school_name]);
                        _paq.push(['setCustomDimension', 2, result.role_ids]);
                        _paq.push(['setCustomDimension', 3, result.quick_login_id]);
                        _paq.push(['setCustomDimension', 4, empOrAdmnNo]);
                        _paq.push(['setCustomDimension', 5, userBatchDetails]);
                        _paq.push(['setUserId', result.username]);
                        _paq.push(['trackPageView']);

                        // google analytics----------------
                        gtag('set', 'user_properties', {
                            'school_name': result.school_name,
                            'user_data': userBatchDetails,
                            'user_id': $scope.newUser.username,
                            'role_id': result.role_ids
                        });
                        // ---------------google analytics
                    } catch (e) {
                        console.log(e);
                    }
                    // matomo analytics code ends 
                    if (result.admission_number) {
                        localStorageService.set("className", result.className);

                        localStorageService.set("session_name", result.sessionName);
                        localStorageService.set("curriculum_name", result.curriculumName);
                        localStorageService.set("class_name", result.className);
                        localStorageService.set("batch_name", result.batchName);

                        localStorageService.set("class_id", result.class_id);
                        localStorageService.set("session_id", result.session_id);
                        localStorageService.set("curriculum_id", result.curriculum_id);
                        localStorageService.set("batch_id", result.batch_id);
                    }
                    localStorageService.set("allAcademic_year", result.allAcademic_year);
                    localStorageService.set("is_login", true);
                    localStorageService.set("loListPopupShown", true);
                    localStorageService.set("school_id", result.school_id);
                    localStorageService.set("academic_year", result.academic_year);
                    localStorageService.set("user_id", result.user_id);
                    localStorageService.set("role_ids", result.role_ids);
                    localStorageService.set("full_name", result.name);
                    localStorageService.set("activeAcdYear", result.academic_year);
                    localStorageService.set("admission_no", result.admission_number);
                    localStorageService.set("username", result.username);
                    localStorageService.set("user_image", result.image);
                    localStorageService.set("active_time_check", result.active_time_check);
                    localStorageService.set('login_timestamp', new Date().getTime());
                    localStorageService.set("school_name", result.school_name);

                    if (result.feeDuePopup) {
                        localStorageService.set("feedue_popup", result.feeDuePopup);
                        if (result.feedue_popup_message) {
                            localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                        }
                    }
                    if (result.bannerstatus) {
                        localStorageService.set("bannerstatus", result.bannerstatus);
                    }
                    if (result && result.new_users && result.new_users.length && result.new_users.includes(result.username)) {
                        localStorageService.set("loListPopupShown", false);
                    }
                    // if(result.role_ids[0] == "student"){  
                    //     readTextFile("privileges.json", function(text){
                    //         var data = JSON.parse(text);
                    //         console.log("======= Previlage Set From JSON ===========")  
                    //         localStorageService.set("module_privileges", data.modeules)
                    //         localStorageService.set("feature_privileges", data.fatures)
                    //     });
                    // } else {
                    localStorageService.set("module_privileges", result.module_privileges);
                    localStorageService.set("feature_privileges", result.feature_privileges);
                    //}
                    $rootScope.username = result.name;

                    //toastr.success("Login success")

                    var userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                        return feature.module_state === "childrenComponent";
                    });
                    if (userAccessJson && userAccessJson.length) {
                        _.each(userAccessJson, function (feature) {
                            var user_access = {};
                            _.each(feature.privilege, function (privObj) {
                                user_access[privObj.name.toLowerCase()] = privObj.status;
                            });
                            localStorageService.set('parent_user_access', user_access);
                            $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                            _.defer(function () {
                                $scope.$apply();
                            });;
                        });
                    }

                    if (result.password_tracking) {
                        localStorageService.set("password_tracking", true);
                    }
                    //ads page only access checking
                    var featurePrivileges = result.feature_privileges || []; // to check the current logged in user only have Advertisement_ID in the feature privilages.
                    var isOnlyAdvertisementAccess = featurePrivileges.length === 1 && featurePrivileges[0].feature_id === "Advertisement_ID";
                    // $scope.onlyAdvertisementAccess = false;                /////hding bakc and home buttons from ads page.
                    $rootScope.isLoggedIn = true;
                    var toredirected = localStorageService.get('toredirected');
                    try {
                        if (toredirected && toredirected.student_id && toredirected.qp_id && toredirected.page && toredirected.parent_id && toredirected.parent_id == result.user_id) {
                            $state.go("activityReportViaLinkCtrl", {
                                student_id: toredirected.student_id,
                                qp_id: toredirected.qp_id,
                                page: toredirected.page,
                                teacher_id: toredirected.teacher_id,
                                parent_id: result.user_id
                            });
                        } else if (result && result.new_users && result.new_users.length && result.new_users.includes(result.username)) {
                            localStorageService.set("dataEntryUserLogin", true);
                            $state.go("menutile");
                        }
                        // }else if (isOnlyAdvertisementAccess) {   // directly navigating user to ads page if only ads access in feature privilages.
                        //     // $scope.onlyAdvertisementAccess = true; ////hiding bakc and home buttons
                        //     $state.go("advertisementCtrl"); 
                        // }
                        else {
                                $state.go("dashboard");
                            }
                    } catch (error) {
                        $state.go("dashboard");
                    }
                } else {
                    var msg = response.error.error.message;
                    toastr.error(msg);
                }
            });
        } else {
            if (!$scope.newUser.username && !$scope.newUser.password) {
                toastr.error("Please enter username/password");
            } else if ($scope.newUser.username && !$scope.newUser.password) {
                toastr.error("Please enter password");
            } else if (!$scope.newUser.username && $scope.newUser.password) {
                toastr.error("Please enter username");
            }
        }
    };

    $scope.checkEnter = function (event) {
        //if enter login should happen
        event = event || window.event; //For IE
        if (event.keyCode === 13) {
            $scope.loginUser();
        }
    };

    this.$onDestroy = function () {
        _hidePrompt();
        $scope.newUser = undefined;
    };
    function readTextFile(file, callback) {
        var rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", file, true);
        rawFile.onreadystatechange = function () {
            if (rawFile.readyState === 4 && rawFile.status == "200") {
                callback(rawFile.responseText);
            }
        };
        rawFile.send(null);
    }
    $scope.gsuitLogin = function () {
        localStorageService.set("gLongin", '0');
        _hidePrompt();
        $scope.signOut();
    };

    // Render Google Sign-in button
    $scope.renderButton = function () {
        //  function renderButton() {
        if (!gapi || !gapi.signin2) {
            console.log('missed', gapi.signin2);
            return;
        }
        gapi.signin2.render('gSignIn', {
            'scope': 'profile email',
            'width': 300,
            'height': 42,
            'longtitle': true,
            'theme': 'dark',
            'onsuccess': onSuccess,
            'onfailure': onFailure
        });
    };

    // Sign-in success callback
    function onSuccess(googleUser) {
        // Get the Google profile data (basic)
        //var profile = googleUser.getBasicProfile();

        // Retrieve the Google account data
        gapi.client.load('oauth2', 'v2', function () {
            var request = gapi.client.oauth2.userinfo.get({
                'userId': 'me'
            });
            request.execute(function (resp) {
                // Display the user details
                console.log(resp);
                var LoggEdmailId = resp.email;
                console.log(localStorageService.get("gLongin"));
                console.log('=======================================');
                //var ndata = LoggEdmailId.includes("hilltop.in"); 
                if (LoggEdmailId && localStorageService.get("gLongin") != '1') {
                    authService.callAPI("/v1/gsuit_login_auth", "POST", resp, function (response) {

                        if (response.result != undefined) {
                            _hidePrompt(3);
                            var result = response.result.data.data[0];
                            try {
                                var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo;
                                var userBatchDetails = result.name;
                                if (result.admission_number) userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name;
                                _paq.push(['setCustomVariable', 1, "School ID", result.school_name, "visit"]);
                                _paq.push(['setCustomVariable', 2, "Role IDs", result.role_ids, "visit"]);
                                _paq.push(['setCustomVariable', 3, "Login Username ", result.quick_login_id, "visit"]);
                                _paq.push(['setCustomVariable', 4, "Admn No/Emp No ", empOrAdmnNo, "visit"]);
                                _paq.push(['setCustomVariable', 5, "User Details", userBatchDetails, "visit"]);
                                _paq.push(['setUserId', result.username]);
                                _paq.push(['trackPageView']);
                            } catch (e) {
                                console.log(e);
                            }
                            // matomo analytics code ends

                            if (result.admission_number) {
                                localStorageService.set("className", result.className);
                            }
                            localStorageService.set("allAcademic_year", result.allAcademic_year);
                            localStorageService.set("is_login", true);
                            localStorageService.set("school_id", result.school_id);
                            localStorageService.set("school_name", result.school_name);
                            localStorageService.set("academic_year", result.academic_year);
                            localStorageService.set("user_id", result.user_id);
                            localStorageService.set("role_ids", result.role_ids);
                            localStorageService.set("full_name", result.name);
                            localStorageService.set("activeAcdYear", result.academic_year);
                            localStorageService.set("admission_no", result.admission_number);
                            localStorageService.set("username", result.username);
                            localStorageService.set("user_image", result.image);
                            localStorageService.set("active_time_check", result.active_time_check);
                            localStorageService.set('login_timestamp', new Date().getTime());
                            localStorageService.set("full_name", result.name);
                            localStorageService.set("mobile", result.phone);
                            localStorageService.set("user_address", result.addrLine1 + "," + result.addrLine2 + "," + result.city + "," + result.country);
                            localStorageService.set("module_privileges", result.module_privileges);
                            localStorageService.set("feature_privileges", result.feature_privileges);
                            $rootScope.username = result.name;

                            if (result.feeDuePopup) {
                                localStorageService.set("feedue_popup", result.feeDuePopup);
                                if (result.feedue_popup_message) {
                                    localStorageService.set("feedue_popup_message", result.feedue_popup_message);
                                }
                            }
                            console.log(result.bannerstatus);
                            console.log("result.bannerstatus++++++++++");
                            if (result.bannerstatus) {
                                localStorageService.set("bannerstatus", result.bannerstatus);
                            }

                            // if(result.password_tracking){ 
                            //     localStorageService.set("password_tracking", true)
                            // } 

                            var userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                                return feature.module_state === "childrenComponent";
                            });
                            if (userAccessJson && userAccessJson.length) {
                                _.each(userAccessJson, function (feature) {
                                    var user_access = {};
                                    _.each(feature.privilege, function (privObj) {
                                        user_access[privObj.name.toLowerCase()] = privObj.status;
                                    });
                                    localStorageService.set('parent_user_access', user_access);
                                    $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                    _.defer(function () {
                                        $scope.$apply();
                                    });;
                                });
                            }

                            console.log("Gsuit Auth");
                            $rootScope.isLoggedIn = true;
                            var toredirected = localStorageService.get('toredirected');
                            if (toredirected && toredirected.student_id && toredirected.qp_id && toredirected.page && toredirected.parent_id && toredirected.parent_id == result.user_id) {
                                $state.go("activityReportViaLinkCtrl", {
                                    student_id: toredirected.student_id,
                                    qp_id: toredirected.qp_id,
                                    page: toredirected.page,
                                    teacher_id: toredirected.teacher_id,
                                    parent_id: result.user_id
                                });
                            } else {
                                $state.go("dashboard");
                            }
                        } else {
                            var msg = response.error.error.message;
                            //$scope.signOut();
                            toastr.error(msg);
                        }
                    });
                } else {
                    // toastr.error('Please try again..');
                }
            });
        });
    }

    // Sign-in failure callback
    function onFailure(error) {
        // alert(error);
        console.log(error);
        _showPrompt();
    }
    // Sign out the user
    $scope.signOut = function () {
        var auth2 = gapi.auth2.getAuthInstance();
        auth2.signOut().then(function () {
            console.log('User signed out.');
        });
        auth2.disconnect();
    };

    $scope.passCheck = function () {
        var passwordInput = document.querySelector("#password");
        var eye = document.querySelector("#eye");
        eye.classList.toggle("fa-eye-slash");
        var type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
        passwordInput.setAttribute("type", type);
    };
}];

exports.default = LoginController;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * API call service
 */

var AuthService = function () {
    // @ngInject
    AuthService.$inject = ["CONSTANTS", "$state"];
    function AuthService(CONSTANTS, $state) {
        _classCallCheck(this, AuthService);

        //this.localStorageService = localStorageService;
        //this.q = $q;
        this.CONSTANTS = CONSTANTS;
        this.state = $state;
    }

    _createClass(AuthService, [{
        key: "callAPI",
        value: function callAPI(endpoint, method, args, callback) {
            try {
                var url = this.CONSTANTS.NODE_URL + endpoint;
                //var url = endpoint;
                console.log(url);
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4 && this.status == 200) {
                        var resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        try {
                            resultObj.result = JSON.parse(xhttp.responseText);
                            callback(resultObj);
                        } catch (error) {
                            resultObj.error = "Bad Request - End Point is invalid";
                            callback(resultObj);
                        }
                    } else {
                        if (this.readyState == 4) {
                            var _resultObj = {
                                "result": undefined,
                                "error": undefined
                            };
                            _resultObj.error = JSON.parse(xhttp.responseText);
                            callback(_resultObj);
                        }
                    }
                };
                xhttp.open(method, url, true);
                xhttp.withCredentials = true;
                xhttp.setRequestHeader("Content-type", "application/json");
                xhttp.setRequestHeader("x-auth-token", "tq355lY3MJyd8Uj2ySzm");
                xhttp.setRequestHeader("x-auth-userid", "44B7TvzRTZkpdxs9u");
                xhttp.onerror = function (e) {
                    var resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    resultObj.error = "Bad Request - Server is Down";
                    callback(resultObj);
                };
                if (args != undefined) {
                    xhttp.send(JSON.stringify(args));
                } else {
                    xhttp.send();
                }
            } catch (ex) {
                console.log(ex);
            }
        }
    }]);

    return AuthService;
}();

exports.default = AuthService;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _navigation = __webpack_require__(947);

var _navigation2 = _interopRequireDefault(_navigation);

__webpack_require__(948);

var _navigationController = __webpack_require__(949);

var _navigationController2 = _interopRequireDefault(_navigationController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'navigation';
var _module = angular.module('app.navigation', ['angular-send-feedback']).component(name, {
    template: _navigation2.default,
    controller: _navigationController2.default,
    controllerAs: name
}).controller('navigationCtrl', _navigationController2.default);

_module.constant('NAVIGATION_CONSTANTS', {
    API_GET_NOTIFICATION_HEADER_DETAILS: "/v0/notifications/header/details/",
    API_UPDATE_NOTIFICATION_TRACKER: "/v0/notifications/update/tracker",
    API_UPDATE_NOTIFICATION_STATUS: "/v0/notifications/update/status",
    API_GET_PERSON_DETAILS: "/v0/user/person/details/",
    API_GET_USER_DETAILS: "/v0/user/",
    API_GET_DICTIONARY_SEARCH: "/v0/dictionary/search/",
    API_ADD_BOOKMARK: "/v0/bookmark/add-bookmark",
    API_UPDATE_BOOKMARK: "/v0/bookmark/update-bookmark",
    API_DELETE_BOOKMARK: "/v0/bookmark/delete-bookmark/",
    API_IS_BOOKMARK: "/v0/bookmark/checkIsPageBookmarked",
    API_GET_GMAIL_INBOX_DETAILS: '/v0/gmail/inbox/',
    API_GET_WHATS_NEW: '/v0/dashboard/whatsnew/'
});

exports.default = _module;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-toolbar ng-if=$root.isLoggedIn layout=row flex class=\"fixed-header md-hue-2 nav-head\" scroll ng-cloak style=z-index:10> <div md-whiteframe=1 class=\"md-toolbar-tools toolcolor\" flex layout=row layout-align=\"space-between center\"> <div layout=row class=nav-left layout-align=\"start center\" flex=40> <md-button title=Menu ng-show=!$root.authMenu ng-click=goMenu() class=md-icon-button aria-label=Settings> <i class=\"fas fa-th font-icon-size\"></i> </md-button> <md-button ng-show=$root.authMenu class=md-icon-button aria-label=Settings ng-click=$root.toggleLeft()> <i class=\"fas fa-bars font-icon-size\"></i> </md-button> <md-button class=\"md-icon-button hvr-push\" title=Home ng-click=goHome() ng-disabled=onlyAdvertisementAccess> <i class=\"fas fa-home font-icon-size\"></i> </md-button> <md-button class=md-icon-button aria-label=Back ng-click=goBack() ng-show=backBtnStatus ng-disabled=onlyAdvertisementAccess> <i class=\"fas fa-angle-left\" style=font-size:x-large></i> </md-button> <span class=\"toolHeader hide-xs\">{{$root.title}}</span> </div> <div layout=row class=nav-right flex=60 layout-align=\"end center\"> <md-button ng-if=isSuparAdmin class=\"md-icon-button hide-xs\" aria-label=Back ng-click=maskLogin()> <i class=\"fas fa-theater-masks\" style=font-size:20px></i> </md-button> <md-button class=\"md-icon-button hide-xs\" aria-label=Back ng-click=goToUnMaskedLoginFn(maskedUserData) ng-if=maskedUserData title=\"Go back to {{maskedUserData}}\"> <i class=\"fas fa-sign-out-alt\" style=font-size:20px id=unmask1></i> <img style=display:none;height:22px src=" + __webpack_require__(88) + " id=unmask2> </md-button> <div class=\"userfont hide-xs\" layout layout-padding ng-if=$root.username> <span> <i> Welcome </i></span> &nbsp; <span>{{$root.username}}</span> </div> <div class=\"menu-demo-container notifications\" layout=column ng-cloak> <md-menu md-position-mode=\"target-right target\"> <md-button aria-label=\"Open phone interactions menu\" class=md-icon-button> <i class=\"fas fa-bell\" ng-click=$mdMenu.open($event)></i> </md-button> <md-menu-content class=\"backgroundColor menuWidth\"> <p class=\"noNotificationsP noNotifications\" ng-if=!notifications.length>No notifications found ..!</p> <md-menu-item flex layout=column style=min-height:64px!important class=\"menu-height notifyBox\" ng-repeat=\"notification in notifications | orderBy : 'gen-date' : reverse\" ng-click=routeToPage(notification) ng-style=\"notification.clickStatus === 'active' && {'background-color':'#cfebff'}\"> <md-button class=\"headerIcons topPadding\" ng-class=\"(notification.notification_status && notification.notificationClicked) ? 'read-notification' : 'unread-notification'\" ng-click=routeToPage(notification)> <img ng-if=\"notification.icon_type === 1\" src=" + __webpack_require__(464) + " class=\"material-icons imageMargin\"> <img ng-if=\"notification.icon_type === 2\" src=" + __webpack_require__(465) + " class=\"material-icons imageMargin\"> <img ng-if=\"notification.icon_type === 3\" src=" + __webpack_require__(466) + " class=\"material-icons imageMargin\"> <img ng-if=\"notification.icon_type === 4\" src=" + __webpack_require__(467) + " class=\"material-icons imageMargin\"> <img ng-if=\"notification.icon_type === 5\" src=" + __webpack_require__(468) + " class=\"material-icons imageMargin\"> <img ng-if=\"notification.icon_type === 6\" src=" + __webpack_require__(469) + " class=\"material-icons imageMargin\"> <p style=word-break:break-word class=\"text-break-wrap md-body-1 notifiyMsg sizeofFont flex-90\" ng-style=\"notification.clickStatus === 'active' && {'font-weight':'1000'}\">{{notification.msg}}</p> </md-button> <md-divider ng-if=!$last></md-divider> </md-menu-item> <md-menu-item class=view-all-notifications ng-click=goToNotificationsPage() ng-if=notifications.length> <p>View All</p> </md-menu-item> </md-menu-content> </md-menu> <div class=notificationsItems ng-show=\"notificationCounts > 0\">{{notificationCounts}}</div> </div> <md-button class=md-icon-button aria-label=Back ng-show=$root.authMenu&&!isBookmarked ng-click=addBookmark()> <i class=\"hvr-push far fa-star\"></i> </md-button> <md-button class=md-icon-button aria-label=Back ng-show=$root.authMenu&&isBookmarked ng-click=addBookmark()> <i class=\"hvr-push fas fa-star\"></i> </md-button> <div class=\"menu-demo-container profilePic\" layout-align=\"center center\" layout=column ng-cloak> <md-button aria-label=\"Profile icon\" class=md-icon-button> <img ng-src=\"{{currentUser.image.original ? locationPath + currentUser.image.original : currentImagePath}}\" onerror='this.src=\"../../../../img/header/teacher_profile1.png\"'/> </md-button> </div> <div layout=column ng-cloak ng-hide> <md-menu md-position-mode=\"target-right target\" md-offset=\"0 45\"> <md-button aria-label=\"Open menu\" class=md-icon-button ng-click=$mdMenu.open($event)> <i class=\"fas fa-ellipsis-v font-icon-size\"></i> </md-button> <md-menu-content width=4> <md-menu-item class=\"menu-bottom-border hand\" ng-click=directToMyprofile() layout=\"row \"> <i class=\"fas fa-user nav-menu-icon\"></i> <span class=headerIconLeft>My Profile</span> </md-menu-item> <md-menu-item class=\"hand menu-bottom-border\" ng-click=navigateModule(moreOption.stateName) ng-repeat=\" moreOption in moreOptionList\" ng-show=\"moreOption.accessPermission  && $root.authMenu\" style=outline:0> <img style=width:25%!important ng-src={{moreOption.iconUrl}}> <span class=headerIconLeft>{{moreOption.name}}</span> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item class=\"menu-bottom-border hand\" ui-sref=changePassword layout=\" row\"> <i class=\"fas fa-cog nav-menu-icon\"></i> <span class=headerIconLeft>Change Password</span> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item class=\"menu-bottom-border hand\" ui-sref=aboutUs layout=\" row\"> <i class=\"fas fa-info-circle nav-menu-icon\"></i> <span class=headerIconLeft>About Us</span> </md-menu-item> <md-menu-divider></md-menu-divider> <md-menu-item class=\"hand noNavOutLine\" ng-click=\"logout() \"> <i class=\"fas fa-sign-out-alt nav-menu-icon\"></i> <span class=headerIconLeft>Logout</span> </md-menu-item> </md-menu-content> </md-menu> </div> </div> </div> <angular-feedback ng-if=showFeedBack options=options></angular-feedback> </md-toolbar> <div layout=row class=header layout-align=\"end end\" ng-if=\"$root.authMenu && isShowBookmark\"> <div class=\"md-whiteframe-5dp add_bookmark\"> <div layout=row layout-align=\"end end\"> <img class=close src=" + __webpack_require__(90) + " ng-click=closeBookmark()> </div> <div layout=row layout-align=\"start start\"> <md-input-container class=\"md-block bkmarkinput\" flex-gt-sm> <label>Name</label> <input type=text ng-model=navigation.bookmarkTitle /> <p>{{bookmarkError}}</p> </md-input-container> <div class=bkmarksave ng-click=saveBookmark()> <i class=\"fas fa-save\" style=padding-top:4px></i> </div> <div class=bkmarkremove ng-click=removeBookmark() ng-show=isBookmarked> <i class=\"fas fa-times\"></i> </div> </div> </div> </div>";

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _socket = __webpack_require__(532);

var _socket2 = _interopRequireDefault(_socket);

var _dictionary = __webpack_require__(950);

var _dictionary2 = _interopRequireDefault(_dictionary);

var _masklogin = __webpack_require__(951);

var _masklogin2 = _interopRequireDefault(_masklogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavigationController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$transitions", "localStorageService", "menuHeaderService", "NAVIGATION_CONSTANTS", "CONSTANTS", "authService", "$location", "matomoEventTrack", function NavigationController($state, $rootScope, $scope, $mdDialog, $transitions, localStorageService, menuHeaderService, NAVIGATION_CONSTANTS, CONSTANTS, authService, $location, matomoEventTrack) {
    DictionaryController.$inject = ["$scope", "$mdDialog", "$timeout"];
    MaskLoginPreviewController.$inject = ["$scope", "$mdDialog", "$timeout"];
    _classCallCheck(this, NavigationController);

    $scope.stateChangeDetected = false;$scope.isButtonDisabled = false;
    // matomo analytics code starts
    try {
        var _webpushrScriptReady = function _webpushrScriptReady() {
            var roleDatasuser = localStorageService.get('role_ids')[0];
            if (roleDatasuser == "student") {
                var myrole = "Student";
            } else if (roleDatasuser == "Rt4ZwrDRxw8Zwer6aC") {
                var myrole = "Parent";
            } else {
                var myrole = "Employee";
            }
            webpushr('attributes', {
                "email": localStorageService.get('username'),
                "full_name": localStorageService.get('full_name'),
                "school_name": localStorageService.get('school_name'),
                "role_ids": myrole

            });
        };

        $rootScope.$on('$locationChangeSuccess', function (event, current) {
            if (_paq) {
                // _paq.push(['setDocumentTitle', $rootScope.title]);
                // _paq.push(['setCustomUrl', $location.path()]);
                // // _paq.push(['setCustomVariable', 1, "Page Title", $rootScope.title, "page"]);
                _paq.push(['setCustomDimension', 6, $rootScope.title]);
                _paq.push(['trackPageView']);
            }
            console.log($rootScope.title + "=========================");
            if ($rootScope.title === "Question paper uploads") {
                $rootScope.title = "Question Paper Uploads";
            }

            $scope.ga4_measurement_id = CONSTANTS.GOOGLE_ANALYTICS_MEASUREMENT_ID;
            gtag('config', $scope.ga4_measurement_id, {
                'page_title': $rootScope.title,
                'page_path': $location.path()
            });

            $rootScope.getNotifications();
        });

        _webpushrScriptReady();

        this.$onInit = function () {
            var dataEntryUserLogin = false;
            var passCheckStatus = localStorageService.get("password_tracking");
            if (passCheckStatus) {
                $state.go("changePassword");
            }
            dataEntryUserLogin = localStorageService.get("dataEntryUserLogin");
            //     if(dataEntryUserLogin){
            //         console.log("yyyaaa");
            //         $state.go('menutile')
            //     }
        };

        $scope.$watch(function () {
            return localStorageService.get('username');
        }, function (newVal, oldVal) {
            userId = newVal;
            if (userId !== undefined && userId !== null && userId !== "") {
                try {
                    _paq.push(['setUserId', localStorageService.get('username')]);
                    _paq.push(['trackPageView']);
                } catch (e) {
                    console.log(e);
                }
            }
        });
    } catch (e) {
        console.log(e);
    }
    //Check Chrome Version Start ......................
    try {
        var nVer = navigator.appVersion;
        var nAgt = navigator.userAgent;
        var browserName = navigator.appName;
        var fullVersion = '' + parseFloat(navigator.appVersion);
        var majorVersion = parseInt(navigator.appVersion, 10);
        var nameOffset, verOffset, ix;

        // In Chrome, the true version is after "Chrome"
        if ((verOffset = nAgt.indexOf("Chrome")) != -1) {
            browserName = "chromeCheck";
            fullVersion = nAgt.substring(verOffset + 7);

            // trim the fullVersion string at semicolon/space if present
            if ((ix = fullVersion.indexOf(";")) != -1) fullVersion = fullVersion.substring(0, ix);
            if ((ix = fullVersion.indexOf(" ")) != -1) fullVersion = fullVersion.substring(0, ix);

            majorVersion = parseInt('' + fullVersion, 10);
            if (isNaN(majorVersion)) {
                fullVersion = '' + parseFloat(navigator.appVersion);
                majorVersion = parseInt(navigator.appVersion, 10);
            }

            console.log(majorVersion + "     " + browserName);
            if (majorVersion < 75) {
                console.log("Here ............................####");
                var confirm = $mdDialog.confirm().title('Your Chrome version is Outdated ?').textContent('Your current Chrome version is ' + majorVersion + '. Please update the latest version 75.0').ariaLabel('chromecheck')
                //.targetEvent(ev)
                .ok('Update Now').cancel('Cancel');

                $mdDialog.show(confirm).then(function () {
                    console.log("Yes.................");
                    window.open("https://www.google.com/chrome/", "_blank");
                }, function () {
                    console.log("No.................");
                });
            }
        }
    } catch (e) {
        console.log(e);
    }
    //Check Chrome Version End ......................
    var roleDataUserEd = localStorageService.get('role_ids')[0];
    if (roleDataUserEd == "student") {
        var myCurrrole = "Student";
    } else if (roleDataUserEd == "Rt4ZwrDRxw8Zwer6aC") {
        var myCurrrole = "Parent";
    } else {
        var myCurrrole = "Employee";
    }

    $scope.options = {
        ajaxURL: CONSTANTS.NODE_URL + '/v0/userfeedback/' + localStorageService.get('user_id'),
        myRole: myCurrrole
    };

    $scope.backBtnStatus = true;
    $scope.locationPath = CONSTANTS.FILE_UPLOAD_URL;
    $scope.currentImagePath = "../../../../img/header/teacher_profile1.png";
    var userId = void 0;
    var bookmarkName = void 0;

    $scope.$watch(function () {
        return localStorageService.get('user_id');
    }, function (newVal, oldVal) {
        userId = newVal;
        if (userId !== undefined && userId !== null && userId !== "") {
            $rootScope.getNotifications();
            //getGmailInboxDetails()
        }
        $scope.isSuparAdmin = false;
        if (localStorageService.get("masked_user")) {
            $scope.maskedUserData = localStorageService.get("masked_user");
        }
        if (localStorageService.get('role_ids').indexOf('super_admin') !== -1 || localStorageService.get('role_ids').indexOf('master_admin') !== -1) {
            $scope.isSuparAdmin = true;
        }
    });
    function backToDashboard(state, oldVal) {
        if (state && state === "quizApiMain" && oldVal && oldVal.name !== "dashboard") {
            $state.go("dashboard");
        }
    }
    /**  Author: Sreeswathy  Description: To find the state change  */
    $transitions.onSuccess({}, function () {
        var passCheckStatus = localStorageService.get("password_tracking");
        if (passCheckStatus) {
            $state.go("changePassword");
        }

        $scope.stateChangeDetected = true;
        _.defer(function () {
            isBookmarked($state.$current.name, $state.params);
        });
    });
    $scope.showFeedBack = true;
    function disableFeedBackBtn() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var NO_FEEDBACK_STATES = ['studentQuestionSelection'];
        $scope.showFeedBack = true;
        try {
            if (state) {
                if (NO_FEEDBACK_STATES.indexOf(state) !== -1) {
                    $scope.showFeedBack = false;
                }
            }
        } catch (e2) {
            console.log(e2);
            $scope.showFeedBack = true;
        }
    }
    $scope.$watch(function () {
        return $state.$current;
    }, function (newVal, oldVal) {
        var state = newVal.name;
        try {
            disableFeedBackBtn(state);
        } catch (e1) {
            console.log(e1);
            $scope.showFeedBack = true;
        }
        if (state === "dashboard") {
            $scope.backBtnStatus = false;
        } else {
            $scope.backBtnStatus = true;
        }
        userId = localStorageService.get('user_id');
        var nonAuthoringStates = ['dashboard', 'menutile', 'myProfile', 'aboutUs', 'viewUserManual', 'notifications', 'learningTracker', "learningOutcomeTracker", 'gridView', 'prevReportEditCtrl', 'activityExportCtrl', 'classTeacherReportCtrl', 'questionPaperCtrl', 'qpPrincipalCtrl', 'viewqpPrincipalCtrl', 'questionPaperTeacherCtrl'];
        if (!nonAuthoringStates.includes(state)) {
            var authoringDetails = localStorageService.get("authoringData");
            if (authoringDetails) {
                $rootScope.authMenu = true;
                var title = '';
                if (authoringDetails.class && authoringDetails.class && authoringDetails.batch && authoringDetails.curriculum && authoringDetails.session) {
                    title = authoringDetails.class + "" + authoringDetails.batch + "/" + authoringDetails.curriculum + "/" + authoringDetails.session + "/" + authoringDetails.subject;
                }
                $rootScope.title = title;
            }
        } else {
            $rootScope.authMenu = false;
        }
        backToDashboard(state, oldVal);
        setMoreOptions();
        var urlState = newVal.self.url.split('/')[1];
        localStorageService.set('current_Page', urlState);
        if (!$scope.stateChangeDetected) {
            isBookmarked(state, $state.params);
        }
        if (localStorageService.get('login_timestamp')) {
            if (new Date().getTime() - localStorageService.get('login_timestamp') >= 18000000) {
                toastr.error('Session Expired. Please login again to continue');
                $scope.logout();
            }
        } else {
            // toastr.error('Session Expired. Please login again to continue');
            $scope.logout();
        }
    });

    if (localStorageService.get("current_Page") == "dashboard" || localStorageService.get("current_Page") === "parentPortalHome") {
        $scope.backBtnStatus = false;
    } else {
        $scope.backBtnStatus = true;
    }

    if (localStorageService.get("full_name")) {
        $rootScope.username = localStorageService.get("full_name");
    }

    //To set authoring tool menu
    $scope.menuService = menuHeaderService;
    $scope.directToMyprofile = function () {
        localStorageService.set('FROMSEARCH', "false");
        $state.go('myProfile');
    };

    /******************* Bookmark Functions - START ***********************/

    function isBookmarked(stateName, stateParams) {
        $scope.isShowBookmark = false;
        $scope.bookmark = undefined;
        if (stateName && $rootScope.authMenu && localStorageService.get('authoringData')) {
            var authoringData = localStorageService.get('authoringData');
            if (authoringData) {
                var academic_details = {
                    session_id: authoringData.session_id,
                    curriculum_id: authoringData.curriculum_id,
                    batch_id: authoringData.batch_id,
                    class_id: authoringData.class_id,
                    subject_id: authoringData.subject_id,
                    school_id: authoringData.school_id
                };
                var current_academic_year = authoringData.academic_year;
                var state_param = stateParams;
                var objKeys = Object.keys(state_param);
                if (objKeys[0] === "#") {
                    delete state_param["#"];
                }
                var params = {
                    academic_details: academic_details,
                    academic_year: current_academic_year,
                    user_id: localStorageService.get("user_id"),
                    state: stateName,
                    params: state_param
                };
                authService.callAPI(NAVIGATION_CONSTANTS.API_IS_BOOKMARK, 'POST', params, function (response) {
                    if (response && response.result && response.result.data) {
                        if (response.result.data.isBookmarked) {
                            $scope.isBookmarked = true;
                            $scope.bookmark = response.result.data.data;
                        } else {
                            $scope.isBookmarked = false;
                        }
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        }
    }
    $scope.closeBookmark = function () {
        $scope.isShowBookmark = false;
    };
    $scope.addBookmark = function () {
        $scope.isShowBookmark = true;
        if ($scope.bookmark) $scope.navigation.bookmarkTitle = $scope.bookmark.title;else $scope.navigation.bookmarkTitle = undefined;
    };
    $scope.saveBookmark = function () {
        if ($scope.navigation.bookmarkTitle) {
            $scope.isShowBookmark = false;
            if ($scope.isBookmarked) {
                if ($scope.bookmark.title !== $scope.navigation.bookmarkTitle) {
                    var params = {
                        bookmark_id: $scope.bookmark._id,
                        bookmark_title: $scope.navigation.bookmarkTitle,
                        user_id: localStorageService.get("user_id")
                    };
                    authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_BOOKMARK, 'POST', params, function (response) {
                        if (response && response.result && response.result.data) {
                            $scope.bookmark.title = $scope.navigation.bookmarkTitle;
                            $scope.isBookmarked = true;
                            toastr.success("Bookmark added");
                        }
                        _.defer(function () {
                            $scope.$apply();
                        });
                    });
                }
            } else {
                var authoringData = localStorageService.get("authoringData");
                var academic_details = void 0;
                if (authoringData) {
                    academic_details = {
                        session_id: authoringData.session_id,
                        curriculum_id: authoringData.curriculum_id,
                        batch_id: authoringData.batch_id,
                        class_id: authoringData.class_id,
                        subject_id: authoringData.subject_id,
                        school_id: authoringData.school_id
                    };
                }
                var session_details = [];
                localStorageService.keys().forEach(function (key) {
                    var value = localStorageService.get(key);
                    session_details.push({
                        key: key,
                        value: value
                    });
                });
                var _params = $state.params;
                var objKeys = Object.keys(_params);
                if (objKeys[0] === "#") {
                    delete _params["#"];
                }
                var state_details = {
                    name: $state.current.name,
                    params: $state.params
                };
                var bookmark = {
                    bookmark_title: $scope.navigation.bookmarkTitle,
                    academic_details: academic_details,
                    session_details: session_details,
                    state_details: state_details,
                    academic_year: authoringData.academic_year,
                    user_id: localStorageService.get("user_id")
                };
                authService.callAPI(NAVIGATION_CONSTANTS.API_ADD_BOOKMARK, 'POST', bookmark, function (response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Bookmark added");
                        $scope.isBookmarked = true;
                        $scope.bookmark = response.result.data.info;
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        } else {
            $scope.bookmarkError = "Please enter the bookmark title";
        }
    };
    $scope.removeBookmark = function () {
        $scope.isShowBookmark = false;
        authService.callAPI(NAVIGATION_CONSTANTS.API_DELETE_BOOKMARK + $scope.bookmark._id, 'GET', {}, function (response) {
            if (response) {
                toastr.success("Bookmark is deleted successfully");
                $scope.isBookmarked = false;
                $scope.bookmark = undefined;
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    /******************* Bookmark Functions - END ***********************/

    /* Notifications NodeJS migration. Restrict to recent notifications */
    $rootScope.getNotifications = function () {
        var appName = 'educore';
        authService.callAPI(NAVIGATION_CONSTANTS.API_GET_NOTIFICATION_HEADER_DETAILS + userId + '/' + appName, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.notifications = response.result.data.details.recentNotifications;
                    $scope.notificationCounts = response.result.data.details.unreadCount;
                    if ($scope.notifications.length >= 1) {
                        _.each($scope.notifications, function (eachNotify) {
                            eachNotify.clickStatus = 'active';
                            if (eachNotify.notification_status != undefined) {
                                _.each(eachNotify.notification_status, function (user_details) {
                                    if (user_details.user_id === userId) {
                                        eachNotify.notificationClicked = true;
                                        eachNotify.clickStatus = 'inactive';
                                    }
                                });
                            };
                        });
                    } else {
                        $scope.noNotifications = true;
                    }
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                //toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
        authService.callAPI(NAVIGATION_CONSTANTS.API_GET_USER_DETAILS + userId, 'GET', {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.currentUser = response.result.data.details;
                    var st_admission_number = localStorageService.get("st_admission_number");
                    if (!st_admission_number && $scope.currentUser && $scope.currentUser.admission_number) {
                        localStorageService.set("st_admission_number", $scope.currentUser.admission_number);
                    }
                    $rootScope.email = $scope.currentUser.username;
                } catch (ex) {
                    console.log(ex);
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        });

        /* Added Socket Communication */
        // const socket = io(CONSTANTS.NODE_SOCKET_URL + "/notify?username=" + userId);
        // socket.on('getNotification', function (data) {
        //     if (data.notification_status != undefined) {
        //         _.each(data.notification_status, function (user_details) {
        //             if (user_details.user_id === userId)
        //                 data.notificationClicked = true;
        //         });
        //     };
        //     $scope.notifications.unshift(data);
        //     $scope.notificationCounts++;
        //     _.defer(function () {
        //         $scope.$apply();
        //     });
        // });
    };

    $scope.goDashboard = function () {
        $state.go('dashboard');
    };

    $scope.goMenu = function () {
        $state.go('menutile');
    };

    $scope.goHome = function () {
        $state.go('dashboard');
    };

    $scope.goBack = function () {
        if ($state.current.name == "myStudentsList") {
            localStorageService.set('searchSession', undefined);
        }
        if ($state.current.name == "questionPaperCtrl") {
            console.log($rootScope.title, "???????");

            if ($rootScope.title == "Question Paper Uploads - HOD") {
                $rootScope.title = "Question Paper Uploads";
            }
            if ($rootScope.title == "Question Paper Uploads - Teacher") {
                $rootScope.title = "Question Paper Uploads";
            }
            $rootScope.title = "Question Paper Uploads";
        }
        if ($state.current.name == 'qpSummary' && $scope.currentUser.role_ids[0] == 'student') $state.go("dashboard");else window.history.back();
    };

    $scope.logout = function () {
        $rootScope.count = 0;
        $rootScope.isLoggedIn = false;
        $rootScope.authMenu = false;
        localStorageService.set("login_det", null);
        localStorage.clear();
        localStorageService.set("gLongin", '1');

        // matomo analytics code starts
        try {
            _paq.push(['resetUserId']);
            _paq.push(['trackPageView']);
        } catch (e) {
            console.log(e);
        }
        // matomo analytics code ends

        $state.go('login', {}, {
            reload: true
        });
    };

    $scope.openMenuAll = function ($mdOpenMenu, ev) {
        var originatorEv = ev;
        $mdOpenMenu(ev);
    };

    $scope.dictionarySearch = function () {
        $mdDialog.show({
            controller: DictionaryController,
            template: _dictionary2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: true
        });
    };

    function DictionaryController($scope, $mdDialog, $timeout) {
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };

        $scope.triggersubmit = function () {
            $timeout(function () {
                angular.element('#dicbtn').triggerHandler('click');
                document.querySelector("#dicbtn").focus();
            });
        };

        $scope.getsearchData = function (dictionary) {
            $scope.dictionaryItems = [];
            document.getElementById("issearchimg").style.display = "block";
            if (dictionary && dictionary.searchkey) {
                var searchword = dictionary.searchkey.toLowerCase();
                authService.callAPI(NAVIGATION_CONSTANTS.API_GET_DICTIONARY_SEARCH + searchword, 'GET', {}, function (response) {
                    if (response.result && response.result.data && response.result.data.result) {
                        try {
                            var result = response.result.data.result;
                            if (result == "DB error") {
                                toastr.error('Server connection error');
                            } else if (result == "No data") {
                                toastr.error('No data found in Dictionary. try some other word.');
                            } else {
                                $scope.dictionaryItems = [];
                                _.each(result[0].meaning, function (dataObj) {
                                    _.each(dataObj, function (datameanObj) {
                                        $scope.dictionaryItems.push(datameanObj.definition);
                                    });
                                });
                            }
                        } catch (ex) {
                            console.log(ex);
                        }
                    } else {
                        //toastr.error('Something went error !Please try after sometime')

                    }
                    document.getElementById("search_dc").focus();
                    document.getElementById("issearchimg").style.display = "none";

                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else {
                toastr.error('Please enter some word for search.');
                document.getElementById("issearchimg").style.display = "none";
            }
        };
    }

    $scope.moreOptionList = [{
        name: 'Forum',
        stateName: 'forumList',
        _id: 'forum',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/forum.png'
    }, {
        name: 'FAQ',
        stateName: 'faq',
        _id: 'faq',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/faq.png'
    }, {
        name: 'Chat',
        stateName: 'chat',
        _id: 'chat',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/chat.png'
    }, {
        name: 'Activity',
        stateName: 'activityList',
        _id: 'activityList',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/activity-side-nav.png'
    }, {
        name: 'Set Target',
        stateName: 'studentSetTarget',
        _id: 'studentSetTarget',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/set-target.png'
        // }, {
        //     name: 'Survey',
        //     stateName: 'surveyList',
        //     _id: 'commonSurveyList',
        //     accessPermission: false,
        //     iconUrl: '../../../img/icons/header-icons/survey.png'
    }, {
        name: 'Bookmark',
        stateName: 'bookmark',
        _id: 'bookmark',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/bookmark.png'
    }, {
        name: 'Digital Library [Archives]',
        stateName: 'archives',
        _id: 'archives',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/archives.png'
        // }, {
        //     name: 'View note',
        //     stateName: 'viewnote',
        //     _id: 'viewnote',
        //     accessPermission: false,
        //     iconUrl: '../../../img/icons/header-icons/view-note.png'
    }, {
        name: 'Send',
        stateName: 'send',
        _id: 'send',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/SEND.png'
    }, {
        name: 'G&T',
        stateName: 'giftedTalented',
        _id: 'giftedTalented',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/G-and-T.png'
    }, {
        // name: 'Mark Entry',
        // stateName: 'examListingPage',
        // _id: 'examMarkEntryList',
        // accessPermission: false,
        // iconUrl: '../../../img/icons/header-icons/mark-entry.png'
    }, {
        name: 'Mark Entry Sheet',
        stateName: 'markEntrySheet',
        _id: 'examMarkEntryList',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/mark-entry.png'
    }, {
        name: 'Set Target',
        stateName: 'setTarget',
        _id: 'setTarget',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/set-target.png'
    }, {
        name: 'Report Cards',
        stateName: 'reportCardListing',
        _id: 'reportCardListing',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/report-card.png'
    }, {
        name: 'Buddy',
        stateName: 'buddyDashboard',
        _id: 'buddyDashboard',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/buddy.png'
    }, {
        name: 'Student Report Cards',
        stateName: 'studentListingForReports',
        _id: 'studentListingForReports',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/report-card.png'
    }, {
        name: 'Holistic Reports Sheet',
        stateName: 'HpcSheetController',
        _id: 'HpcSheetController',
        accessPermission: false,
        iconUrl: '../../../img/icons/header-icons/mark-entry.png'
    }];

    //To update menu list
    function setMoreOptions() {
        var module_privileges = localStorageService.get("module_privileges");
        if (module_privileges) {
            _.each($scope.moreOptionList, function (option) {
                var moduleIndex = module_privileges.findIndex(function (i) {
                    return i.state == option._id;
                });
                if (moduleIndex !== -1) {
                    option.accessPermission = true;
                }
            });

            // HPC visibility: only show when the selected class is a KG class (KG1 / KG2)
            var KG_CLASS_NAMES = ['KG1', 'KG2'];
            var authoringData = localStorageService.get('authoringData');
            var isKgClass = authoringData && KG_CLASS_NAMES.indexOf(authoringData.class) !== -1;
            var reportCardOption = _.find($scope.moreOptionList, function (o) {
                return o._id === 'reportCardListing';
            });
            var hpcOption = _.find($scope.moreOptionList, function (o) {
                return o._id === 'HpcSheetController';
            });
            if (reportCardOption && hpcOption) {
                hpcOption.accessPermission = reportCardOption.accessPermission && isKgClass;
            }
        }
    }

    //To navigate to module
    $scope.navigateModule = function (state, object) {
        // if (state === "surveyList") {
        //     const mongoose = require('mongoose');
        //     $state.go(state, {
        //         user_id: userId,
        //         schedule_id: new mongoose.Types.ObjectId().toString(),
        //         is_fpi_survey: false
        //     });
        // } else {
        $state.go(state);
        // }
    };

    $scope.openNotificationMenu = function ($mdOpenMenu, ev) {

        // matomo track event starts
        matomoEventTrack.pushEvent('Navigation', 'Notification', "Icon Click", 1);
        // matomo track event ends

        authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_NOTIFICATION_TRACKER, "PUT", {
            user_id: userId
        }, function (response) {
            if (response.result && response.result.data && response.result.data.message) {
                try {
                    $scope.notificationCounts = 0;
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                //toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
        $mdOpenMenu(ev);
    };

    /*
     * To navigate to notifications page
     *
     * @return: null
     */
    $scope.goToNotificationsPage = function () {
        $state.go('notifications');
    };

    /*
    * To close all popups
    *
    * @return : null
    */
    $scope.cancel = function () {
        $mdDialog.cancel();
    };

    /*
     * To navigate to corresponding pages (un-optimised)
     *
     * @notification: Object - Holds notification details
     *
     * @return : null
     */
    $scope.routeToPage = function (notification) {
        console.log(notification, "99999999999");
        var reqObj = {
            user_id: userId,
            notification_id: notification._id
        };
        authService.callAPI(NAVIGATION_CONSTANTS.API_UPDATE_NOTIFICATION_STATUS, "PUT", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.message) {} else {
                $scope.cancel();
                // toastr.error('Network Error. Please try later');
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
        var roleList = [];
        if (notification.references && notification.references.academic_details) {
            var academics = notification.references.academic_details;
            authService.callAPI(NAVIGATION_CONSTANTS.API_GET_PERSON_DETAILS + userId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    try {
                        var userDetails = response.result.data.details;
                        if (userDetails.details) {
                            var classDetails = userDetails.details;
                            var curriculumData = _.find(classDetails, function (obj) {
                                return obj.class_id === academics.class_id && obj.curriculum_id === academics.curriculum_id && obj.batch_id === academics.batch_id && obj.session_id === academics.session_id;
                            });
                            if (curriculumData && curriculumData.subjects) {
                                var subject = _.find(curriculumData.subjects, function (data) {
                                    return data === academics.subject_id;
                                });
                                if (subject) {
                                    localStorageService.set('multiRoles', userDetails.role_ids);
                                    roleList = userDetails.role_ids;
                                }
                            }
                        }
                        if (userDetails.details === undefined || curriculumData === undefined || curriculumData.subjects === undefined || subject === undefined) {
                            roleList = fetchRoleFromCoursewareDetails(userDetails, academics);
                            if (roleList === undefined) roleList = [];
                            localStorageService.set('multiRoles', roleList);
                        }
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    $scope.cancel();
                    // toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }

        self.notificationCounts = 0;
        $rootScope.notif_id = null;
        console.log(roleList, "----------55555555----------");
        if (roleList) {

            switch (parseInt(notification.type)) {
                case 600:
                    $state.go('commonSurveyList', {
                        user_id: userId,
                        schedule_id: notification.references.schedule_id,
                        is_fpi_survey: notification.references.is_fpi_survey
                    });
                    break;
                case 601:
                    if (notification.references != undefined) {
                        $state.go('listSurveyAnswer', {
                            surveyId: notification.references.survey_id,
                            parent_state: notification.references.parent_state,
                            user_id: userId,
                            schedule_id: notification.references.schedule_id,
                            is_fpi_survey: notification.references.is_fpi_survey
                        });
                    }
                    break;
                case 100:
                    $rootScope.notif_id = notification._id;
                    $state.go('viewDictation');
                    break;
                case 101:
                    if (userData.role_ids.indexOf('student') !== -1) {
                        $state.go('studentNewAssignmentView', {
                            "getAssginmentQuestion": notification.title,
                            "assignment_id": notification.references,
                            "question_id": notification.references
                        });
                    } else $state.go('assignment');
                    break;
                case 102:
                    if (self.getNotification && Notifications.find({}).fetch().length > 0) {
                        for (var i = 0; i < self.getNotification.data.length; i++) {
                            //Check nofication data have the the current user
                            //---START---
                            if (self.getNotification.data[i].student_id === userId) {
                                //Check onexam is true for current user
                                //if condition start
                                if (!self.getNotification.data[i].onExam) {
                                    if (userData.role_ids.indexOf('student') !== -1) {
                                        var quizObj = {
                                            "teacher_id": notification.sender_id,
                                            "quiz_id": notification.references,
                                            'type': "assessment"
                                        };
                                        if (notification.references.subject_id != undefined) {
                                            localStorageService.set("subjectId", notification.references.subject_id);
                                            localStorageService.set("classId", notification.references.class_id);
                                            localStorageService.set("batchId", notification.references.batch_id);
                                            localStorageService.set("sessionId", notification.references.session_id);
                                            localStorageService.set("curriculumId", notification.references.curriculum_id);
                                        }
                                        $state.go('assessmentList');
                                    } else {
                                        $state.go('teacherAssessmentList');
                                        if (notification.references.subject_id != undefined) {
                                            localStorageService.set("subjectId", notification.references.subject_id);
                                            localStorageService.set("classId", notification.references.class_id);
                                            localStorageService.set("batchId", notification.references.batch_id);
                                            localStorageService.set("sessionId", notification.references.session_id);
                                            localStorageService.set("curriculumId", notification.references.curriculum_id);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    break;
                case 103:
                    if (userData.role_ids.indexOf('student') !== -1) $state.go('studentDrawingView', {
                        "getAssginmentQuestion": notification.references,
                        "assignment_id": notification.references,
                        "question_id": notification.references
                    });else $state.go('drawingAssignmentList');
                    break;
                case 104:
                    $state.go('addAvailability');
                    break;
                case 105:
                    if (self.getNotification && Notifications.find({}).fetch().length > 0) {
                        for (var i = 0; i < self.getNotification.data.length; i++) {
                            //Check nofication data have the the current user
                            //---START---
                            if (self.getNotification.data[i].student_id === userId) {
                                //Check onexam is true for current user
                                //if condition start
                                if (!self.getNotification.data[i].onExam) {
                                    if (userData.role_ids.indexOf('student') !== -1) {
                                        var _quizObj = {
                                            "teacher_id": notification.sender_id,
                                            "quiz_id": notification.references,
                                            'type': "quiz"
                                        };
                                        if (notification.references.subject_id != undefined) {
                                            localStorageService.set("subjectId", notification.references.subject_id);
                                            localStorageService.set("classId", notification.references.class_id);
                                            localStorageService.set("batchId", notification.references.batch_id);
                                            localStorageService.set("sessionId", notification.references.session_id);
                                            localStorageService.set("curriculumId", notification.references.curriculum_id);
                                        }
                                        $state.go('quizList');
                                    } else $state.go('questionList');
                                }
                            }
                        }
                    }
                    break;
                case 107:
                    $state.go('facultySearchFilter');
                    break;
                case 109:
                    QuestionsFactory.addEyfsId(notification.references._id);
                    $state.go('studentReportView', {
                        "getTeachingPlan": notification.references
                    });
                    break;
                case 200:
                    $state.go('facultyEvaluationFilter');
                    break;
                case 201:
                    $state.go('hosOwnDashboard');
                    break;
                case 202:
                    //FPI points noti for teacher
                    $state.go('myDashboard');
                    break;
                case 203:
                    //FPI points dispute request from teacher to Princi
                    $state.go('pointsObservation');
                    break;
                case 204:
                    //FPI points dispute approve/reject to teacher from Princi
                    $state.go('myDashboard');
                    break;
                case 205:
                    //FPI report submission to Principal
                    $state.go('criteriaApproval');
                    break;
                case 206:
                    //FPI published report to Teacher
                    $state.go('fpiEvaluationReport', {
                        "faculty_id": notification.references.faculty_id,
                        "schedule_id": notification.references.schedule_id,
                        "faculty_role_id": notification.references.faculty_role_id
                    });
                    break;
                case 211:
                    //FPI Rejected Self Evaluation
                    $state.go('myDashboard');
                    break;
                case 208:
                    //FPI Rejected Criteria Reports
                    $state.go('facultyDashboard', {
                        "faculty_id": notification.references.faculty_id,
                        "faculty_role_id": notification.references.faculty_role_id
                    });
                    break;
                case 207:
                    //HOS Uploaded Document to Principal
                    $state.go("hosDashboard", {
                        "faculty_id": notification.references.user_id,
                        "faculty_role_id": notification.references.role_id
                    });
                    break;
                case 209:
                    //Teacher' dashboard at Principal/HOD/HOS
                    $state.go("fpiPointsTeacher", {
                        "f_id": notification.references.faculty_id
                    });
                    break;
                case 210:
                    //For HOS criteria
                    $state.go("hosOwnDashboard");
                    break;
                case 300:
                    //Mark entry approval request to class teacher- updated - Developer : Shereen
                    localStorageService.set("authoringData", notification.references.authoringData);
                    menuHeaderService.setAuthMenu();
                    $state.go('classteacherApproval');
                    break;
                case 301:
                    //Mark entry approve/reject to subject teacher
                    if (notification.references.subject_id != undefined) {
                        localStorageService.set("subjectId", notification.references.subject_id);
                        localStorageService.set("classId", notification.references.class_id);
                        localStorageService.set("batchId", notification.references.batch_id);
                        localStorageService.set("sessionId", notification.references.session_id);
                        localStorageService.set("curriculumId", notification.references.curriculum_id);
                        localStorageService.set("authoringData", notification.references);
                    }
                    menuHeaderService.setAuthMenu();
                    $state.go('examListingPage');
                    break;
                case 500:
                    //Mark entry approve/reject to subject teacher
                    $state.go('peopleLookUp', {
                        "user_id": notification.references.user_id
                    });
                    break;
                case 400:
                    // SEND Teacher notification
                    $state.go('senWaveProcess', {
                        studentDetails: notification.references
                    });
                    break;
                case 401:
                    // SEND CO Ordinator notification redirect page
                    $rootScope.notif_id = notification._id;
                    $state.go('studentProfileView', {
                        studentDetails: notification.references
                    });
                    break;
                case 402:
                    // SEND Counselor & SEND Educator notification
                    $state.go('studentProfileView', {
                        studentDetails: notification.references
                    });
                    break;
                case 403:
                    // SEND Parent notification
                    $rootScope.notif_id = notification._id;
                    $state.go('parentChildSenPage', {
                        studentDetails: notification.references
                    });
                    break;
                case 404:
                    // SEND Counselor notification
                    $state.go('studentProfileView', {
                        studentDetails: notification.references
                    });
                    break;
                case 800:
                    // Availability notification for parent
                    $state.go('getAvailability');
                    break;
                case 801:
                    // Availability notification for parent
                    $state.go('reassignAvailability');
                    break;
                /*medical start*/
                case 1000:
                    $state.go('userProgramList');
                    break;
                case 1001:
                    userIdArray = [];
                    userIdArray.push({
                        user_id: notification.references.patient_id
                    });
                    localStorageService.set('selectedUsers', userIdArray);
                    $state.go('medicalUserProfile');
                    break;
                case 1002:
                    userIdArray = [];
                    userIdArray.push({
                        user_id: notification.references._id
                    });
                    localStorageService.set('selectedUsers', userIdArray);
                    $state.go('medicalUserProfile');
                    break;
                case 1004:
                    $state.go('medicalDashboard');
                    break;
                case 1011:
                    $state.go('userProgramList');
                    break;
                case 1012:
                    localStorageService.set('st_id', notification.references);
                    $state.go('childProfile');
                    break;
                /*medical ends*/
                case 700:
                    //Club Activities -Developed by: Shereen
                    if (notification.references) {
                        localStorageService.set("isClubOwnerID", notification.references.owner_id);
                        localStorageService.set("selectedClubId", notification.references.club_id);
                        $state.go('clubPost');
                    }
                    break;
                case 777:
                    //for ASL activity
                    ASLFactory.addCategory(notification.references);
                    $state.go('aslList');
                    break;
                case 3100:
                    $state.go('announcements');
                    break;
                case 3200:
                    $state.go('announcements');
                    break;
                case 1500:
                    // $state.go('cpdSections');
                    $state.go('cpdSections', {
                        viewReq: "new"
                    });
                    break;
                case 2001:
                    $state.go('approverTeachingPlanView', {
                        "getTeachingPlan": notification.references._id
                    });
                    break;
                case 2002:
                    $state.go("calendar");
                    break;
                case 6001:
                    //Report card creation
                    $state.go('showReportCards');
                    break;
                case 6002:
                    // localStorageService.set("authoringData", notification.references.academic_details)
                    $state.go('publishedReports', {
                        "student_id": localStorageService.get('user_id'),
                        "fee_status": false
                    });
                    break;
                case 6003:
                    $state.go('publishedReports', {
                        "student_id": notification.references.student_id,
                        "fee_status": false
                    });
                    break;
                case 110:
                    localStorageService.set("authoringData", notification.references);
                    localStorageService.set("chat_subjectId", notification.references.subject_id);
                    localStorageService.set("chat_classId", notification.references.class_id);
                    localStorageService.set("chat_batchId", notification.references.batch_id);
                    localStorageService.set("chat_sessionId", notification.references.session_id);
                    localStorageService.set("chat_curriculumId", notification.references.curriculum_id);

                    localStorageService.set("chat_schoolId", notification.references.school_id);
                    menuHeaderService.setAuthMenu();
                    $state.go('chat');
                    break;
                case 111:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go('forumList');
                    break;
                case 112:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go('faq');
                    break;
                case 7001:
                    //Survey -authoring tool - Developed by : Shereen
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go("attemptSurvey", {
                        "surveyId": notification.references
                    });
                    break;
                case 7005:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go("viewGeneratedReportData", {
                        "dataId": notification.references._id,
                        "selected_year": notification.references.selected_year,
                        is_edit: false
                    });
                    break;
                case 7007:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go("reportCardListing");
                    break;
                case 7006:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go("viewGeneratedReportData", {
                        "dataId": notification.references._id,
                        "selected_year": notification.references.selected_year,
                        is_edit: false
                    });
                    break;
                case 444:
                    notification.references.academic_details.academic_year = localStorageService.get('academic_year');
                    localStorageService.set("authoringData", notification.references.academic_details);
                    if (notification.references && notification.references.res_ids) localStorageService.set("approverResourceIds", notification.references.res_ids);
                    $state.go('viewTeachingPlan', {
                        planId: notification.references.tp_id
                    });
                    break;
                case 3001:
                    localStorageService.set("notifyData", notification.references);
                    menuHeaderService.setAuthMenu();
                    $state.go('send');
                    break;
                case 3003:
                    localStorageService.set("notifyData", notification.references);
                    menuHeaderService.setAuthMenu();
                    $state.go('giftedTalented');
                    break;
                case 3004:
                    localStorageService.set("notifyData", notification.references);
                    $state.go('buddyDashboard');
                    break;
                case 3005:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    $state.go('viewnote');
                    break;
                case 555:
                    notification.references.academic_details.academic_year = localStorageService.get('academic_year');
                    localStorageService.set("authoringData", notification.references.academic_details);
                    $state.go('activityFormPreview', {
                        "planId": notification.references.tp_id,
                        "resourceId": notification.references.activity_id
                    });
                    break;
                case 1100:
                    //Set Target- Developed by: Shereen
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go('setTarget', {});
                    break;
                case 1101:
                    if (notification.references.type === "sendForApproval") {
                        $state.go("approveArchive");
                    }
                    if (notification.references.type === "approved") {
                        $state.go("myArchives");
                    }
                    break;
                case 333:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    $state.go('qpSummary', {
                        qpId: notification.references.qp_id
                    });
                    break;
                case 190:
                    $state.go('approveAppList');
                    break;
                case 191:
                    localStorageService.set("st_id", notification.references.student_id);
                    $state.go('tabletDetailsofChild');
                    break;
                case 1102:
                    $state.go('viewSyllabus', {
                        syllabusId: notification.references.syllabus_id
                    });
                    break;
                case 4000:
                    $state.go('userApproval');
                    break;
                case 4001:
                    $state.go('recieverFeedbackList');
                    break;
                case 4002:
                    $state.go('parentFeedback');
                    break;
                case 7698:
                    localStorageService.set("authoringData", notification.references.academic_details);
                    menuHeaderService.setAuthMenu();
                    $state.go('multipleReportsSelectionCtrl');
                    break;
                case 955:
                    $state.go('greetingsView');
                    break;
                default:
                    $state.go("notifications", {}, { reload: true });
                    break;
                case 956:
                    $state.go('lessonView', { _id: notification.references.lo_id });
                case 960:
                    $state.go('lessonView', { _id: notification.references.lo_id });
                    break;
                case 957:
                    $state.go('learningView', { _id: notification.references.lo_id });
                    break;
                case 958:
                    $state.go('myStudentsList');
                    break;
                case 959:
                    $state.go('leaveManagement');
                case 3000:
                    $state.go('learningwalkview', { lw_id: notification.references.lw_id ? notification.references.lw_id : notification.references });
                    break;
                case 3010:
                    $state.go('learningwalkview', { lw_id: notification.references.lw_id ? notification.references.lw_id : notification.references });
                    break;
            }
        }
    };

    function fetchRoleFromCoursewareDetails(UserDetails, academics) {
        if (UserDetails.courseware_details) {
            var coursewareList = [];
            var coursewareObj = UserDetails.courseware_details; // courseware details of logged in user
            if (coursewareObj.sendObj) {
                _.each(coursewareObj.sendObj, function (each) {
                    //for sendObj
                    coursewareList.push(each);
                });
            }
            if (coursewareObj.traditional_activity_approval) {
                _.each(coursewareObj.traditional_activity_approval, function (each) {
                    //for sendObj
                    if (each) {
                        coursewareList.push(each);
                    }
                });
            }
            if (coursewareObj.teaching_plan_approval) {
                _.each(coursewareObj.teaching_plan_approval, function (each) {
                    //for sendObj
                    coursewareList.push(each);
                });
            }
            if (coursewareObj.teaching_plan_sharing) {
                _.each(coursewareObj.teaching_plan_sharing, function (each) {
                    //for sendObj
                    coursewareList.push(each);
                });
            }
            if (coursewareObj.notes_sharing) {
                _.each(coursewareObj.notes_sharing, function (each) {
                    //for sendObj
                    coursewareList.push(each);
                });
            }
            //for setTarget to get courseware details for parent- Developer: Shereen - Date : 12/12/2017
            if (coursewareObj.set_target_obj) {
                _.each(coursewareObj.set_target_obj, function (each) {
                    coursewareList.push(each);
                });
            }
            //If the class teacher is not assigned with any of the subjects of the selected class- Courseware tile is added
            //ISQA bug- #5493 -Developer- Shereen- Date : 23/12/2017
            if (coursewareObj.mark_entry_obj) {
                _.each(coursewareObj.mark_entry_obj, function (each) {
                    coursewareList.push(each);
                });
            }
            if (coursewareList.length > 0) {
                var dataList = _.filter(coursewareList, function (obj) {
                    return obj.class_id === academics.class_id && obj.curriculum_id === academics.curriculum_id && obj.batch_id === academics.batch_id && obj.session_id === academics.session_id && obj.subject_id === academics.subject_id;
                });
                var roles = [];
                if (dataList && dataList.length > 0) {
                    _.each(dataList, function (each) {
                        if (each.assign_roles != undefined) {
                            if (each.assign_roles.length > 0) {
                                var roleList = _.union(each.assign_roles, roles);
                                roles = roleList;
                            }
                        }
                    });
                }
            }
        }
        return roles;
    }

    // function getGmailInboxDetails() {
    //     authService.callAPI(NAVIGATION_CONSTANTS.API_GET_GMAIL_INBOX_DETAILS + localStorageService.get('username') + '/' + localStorageService.get('school_id'), "GET", {}, function (response) {
    //         if (response.result && response.result.data) {
    //             try {
    //                 $scope.gmailInboxDetails = response.result.data.details;
    //             } catch (ex) {
    //                 console.log(ex);
    //             }
    //         }
    //         _.defer(function () {
    //             $scope.$apply();
    //         });
    //     });
    // }

    $scope.goToEmail = function () {
        $state.go('gmail');
    };
    $scope.maskLogin = function () {
        $mdDialog.show({
            controller: MaskLoginPreviewController,
            template: _masklogin2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose: true
        });
    };
    function MaskLoginPreviewController($scope, $mdDialog, $timeout) {
        $scope.hide = function () {
            $mdDialog.hide();
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
        $scope.triggersubmitMask = function () {
            $timeout(function () {
                angular.element('#dicbtnMask').triggerHandler('click');
                document.querySelector("#dicbtnMask").focus();
            });
        };

        $scope.goToMaskedLoginFn = function (maskemailId) {
            document.getElementById("issearchimg").style.display = "block";
            if (maskemailId) {
                var maskEmail = maskemailId.toLowerCase();
                console.log(maskEmail);
                if (maskEmail.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    if (localStorageService.get('username') == maskEmail) {
                        document.getElementById("issearchimg").style.display = "none";
                        toastr.error("Can't mask own email Id.");
                    } else {
                        var logData = {
                            username: maskEmail,
                            school_id: localStorageService.get('school_id'),
                            masked_user: localStorageService.get('username'),
                            userAgent: "web"
                        };
                        // valid Email Id ... Start Login function Satrt..........................................
                        if (logData) {
                            $state.go("dashboard");
                            authService.callAPI("/v1/mask_login_auth", "POST", logData, function (response) {
                                if (response.result != undefined) {
                                    localStorage.clear();
                                    var result = response.result.data.data[0];
                                    console.log(result);
                                    try {
                                        if (response.result.data.sessionId != undefined) {
                                            localStorageService.set("sessionId", response.result.data.sessionId);
                                        }
                                        var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo;
                                        var userBatchDetails = result.name;
                                        if (result.admission_number) userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name;
                                        _paq.push(['setCustomDimension', 1, "School ID", result.school_name]);
                                        _paq.push(['setCustomDimension', 2, "Role IDs", result.role_ids]);
                                        _paq.push(['setCustomDimension', 3, "Login Username", result.quick_login_id]);
                                        _paq.push(['setCustomDimension', 4, "AdmnNo-EmpNo", empOrAdmnNo]);
                                        _paq.push(['setCustomDimension', 5, "User Details", userBatchDetails]);
                                        _paq.push(['setUserId', result.username]);
                                        _paq.push(['trackPageView']);
                                    } catch (e) {
                                        console.log(e);
                                    }
                                    // matomo analytics code ends
                                    localStorageService.set("masked_user", result.masked_user);
                                    localStorageService.set("loListPopupShown", true);
                                    localStorageService.set("allAcademic_year", result.allAcademic_year);
                                    localStorageService.set("is_login", true);
                                    localStorageService.set("school_id", result.school_id);
                                    localStorageService.set("school_name", result.school_name);
                                    localStorageService.set("school_logo", result.school_logo);
                                    localStorageService.set("academic_year", result.academic_year);
                                    localStorageService.set("user_id", result.user_id);
                                    localStorageService.set("role_ids", result.role_ids);
                                    localStorageService.set("full_name", result.name);
                                    localStorageService.set("activeAcdYear", result.academic_year);
                                    localStorageService.set("admission_no", result.admission_number);
                                    localStorageService.set("username", result.username);
                                    localStorageService.set("user_image", result.image);
                                    localStorageService.set("active_time_check", result.active_time_check);
                                    localStorageService.set('login_timestamp', new Date().getTime());
                                    localStorageService.set("full_name", result.name);
                                    localStorageService.set("mobile", result.phone);
                                    localStorageService.set("user_address", result.addrLine1 + "," + result.addrLine2 + "," + result.city + "," + result.country);
                                    localStorageService.set("module_privileges", result.module_privileges);
                                    localStorageService.set("feature_privileges", result.feature_privileges);
                                    $rootScope.username = result.name;
                                    var userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                                        return feature.module_state === "childrenComponent";
                                    });
                                    if (userAccessJson && userAccessJson.length) {
                                        _.each(userAccessJson, function (feature) {
                                            var user_access = {};
                                            _.each(feature.privilege, function (privObj) {
                                                user_access[privObj.name.toLowerCase()] = privObj.status;
                                            });
                                            localStorageService.set('parent_user_access', user_access);
                                            $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                            _.defer(function () {
                                                $scope.$apply();
                                            });;
                                        });
                                    }
                                    $rootScope.isLoggedIn = true;
                                    if (result && result.new_users && result.new_users.length && result.new_users.includes(result.username)) {
                                        localStorageService.set("loListPopupShown", false);
                                    }
                                    if (result && result.new_users && result.new_users.length && result.new_users.includes(result.username)) {
                                        localStorageService.set("dataEntryUserLogin", true);
                                        $state.go('menutile');
                                        $mdDialog.hide();
                                        _.defer(function () {
                                            $scope.$apply();
                                        });
                                        return;
                                    }
                                    // $scope.onlyAdvertisementAccess = false;                  //////hiding the back and home buttons
                                    // Check for only Advertisement_ID access
                                    // let featurePrivileges = result.feature_privileges || []; //ads page only access checking
                                    // let isOnlyAdvertisementAccess = (
                                    //     featurePrivileges.length === 1 &&
                                    //     featurePrivileges[0].feature_id === "Advertisement_ID"
                                    // );

                                    // if (isOnlyAdvertisementAccess) { //ads page only access checking if yes directly navigate user to ads page.
                                    //     // $scope.onlyAdvertisementAccess = true;               ////hiding bakc and home buttons
                                    //     $state.go("advertisementCtrl"); 
                                    //     $mdDialog.hide();
                                    //     _.defer(function () {
                                    //         $scope.$apply();
                                    //     });
                                    //     return;
                                    // }
                                    location.reload();
                                } else {
                                    var msg = response.error.error.message;
                                    toastr.error(msg);
                                }
                                document.getElementById("issearchimg").style.display = "none";
                            });
                        }
                        // valid Email Id ... Start Login function End..........................................
                    }
                } else {
                    document.getElementById("issearchimg").style.display = "none";
                    toastr.error('Invalid email Id. Please enter valid email Id.');
                }
            } else {
                document.getElementById("issearchimg").style.display = "none";
                toastr.error('Please enter valid email Id.');
            }
        };
    }

    $scope.goToUnMaskedLoginFn = function (maskemailId) {
        if (maskemailId) {
            var maskEmail = maskemailId.toLowerCase();
            console.log(maskEmail);
            if (maskEmail.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                var logData = {
                    username: maskEmail,
                    school_id: localStorageService.get('school_id'),
                    masked_user: localStorageService.get('username'),
                    userAgent: "web"
                };
                // valid Email Id ... Start Login function Satrt..........................................
                if (logData) {
                    document.getElementById("unmask1").style.display = "none";
                    document.getElementById("unmask2").style.display = "block";
                    $state.go("dashboard");
                    authService.callAPI("/v1/mask_login_auth", "POST", logData, function (response) {
                        if (response.result != undefined) {
                            localStorage.clear();
                            var result = response.result.data.data[0];
                            console.log(result);
                            try {
                                if (response.result.data.sessionId != undefined) {
                                    localStorageService.set("sessionId", response.result.data.sessionId);
                                }
                                var empOrAdmnNo = result.admission_number ? result.admission_number : result.employeeNo;
                                var userBatchDetails = result.name;
                                if (result.admission_number) userBatchDetails = result.sessionName + "/" + result.curriculumName + "/" + result.className + "/" + result.batchName + "/" + result.name;
                                _paq.push(['setCustomDimension', 1, "School ID", result.school_name]);
                                _paq.push(['setCustomDimension', 2, "Role IDs", result.role_ids]);
                                _paq.push(['setCustomDimension', 3, "Login Username", result.quick_login_id]);
                                _paq.push(['setCustomDimension', 4, "AdmnNo-EmpNo", empOrAdmnNo]);
                                _paq.push(['setCustomDimension', 5, "User Details", userBatchDetails]);
                                _paq.push(['setUserId', result.username]);
                                _paq.push(['trackPageView']);
                            } catch (e) {
                                console.log(e);
                            }
                            // matomo analytics code ends
                            //    localStorageService.set("masked_user", result.masked_user)
                            localStorageService.set("allAcademic_year", result.allAcademic_year);
                            localStorageService.set("is_login", true);
                            localStorageService.set("school_id", result.school_id);
                            localStorageService.set("school_name", result.school_name);
                            localStorageService.set("school_logo", result.school_logo);
                            localStorageService.set("academic_year", result.academic_year);
                            localStorageService.set("user_id", result.user_id);
                            localStorageService.set("role_ids", result.role_ids);
                            localStorageService.set("full_name", result.name);
                            localStorageService.set("activeAcdYear", result.academic_year);
                            localStorageService.set("admission_no", result.admission_number);
                            localStorageService.set("username", result.username);
                            localStorageService.set("user_image", result.image);
                            localStorageService.set("active_time_check", result.active_time_check);
                            localStorageService.set('login_timestamp', new Date().getTime());
                            localStorageService.set("full_name", result.name);
                            localStorageService.set("mobile", result.phone);
                            localStorageService.set("user_address", result.addrLine1 + "," + result.addrLine2 + "," + result.city + "," + result.country);
                            localStorageService.set("module_privileges", result.module_privileges);
                            localStorageService.set("feature_privileges", result.feature_privileges);
                            $rootScope.username = result.name;
                            var userAccessJson = _.filter(localStorageService.get('feature_privileges'), function (feature) {
                                return feature.module_state === "childrenComponent";
                            });
                            if (userAccessJson && userAccessJson.length) {
                                _.each(userAccessJson, function (feature) {
                                    var user_access = {};
                                    _.each(feature.privilege, function (privObj) {
                                        user_access[privObj.name.toLowerCase()] = privObj.status;
                                    });
                                    localStorageService.set('parent_user_access', user_access);
                                    $rootScope.userRoleParentAccess = localStorageService.get('parent_user_access');
                                    _.defer(function () {
                                        $scope.$apply();
                                    });;
                                });
                            }
                            $rootScope.isLoggedIn = true;
                            location.reload();
                        } else {
                            var msg = response.error.error.message;
                            toastr.error(msg);
                        }
                        document.getElementById("issearchimg").style.display = "none";
                    });
                }
                // valid Email Id ... Start Login function End..........................................
            } else {
                document.getElementById("issearchimg").style.display = "none";
                toastr.error('Invalid email Id. Please enter valid email Id.');
            }
        } else {
            document.getElementById("issearchimg").style.display = "none";
            toastr.error('Please enter valid email Id.');
        }
    };

    this.$onDestroy = function () {
        $scope.moreOptionList = [];
    };
}];

exports.default = NavigationController;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.resdatadic{width:100%;background:#f1e6e6;margin-bottom:12px}.dicsarchbox{max-width:50%!important;height:auto!important}.mddicsearchbox{min-height:415px!important}.dash_content{position:relative;width:98%;padding-top:28px;margin:auto}</style> <md-dialog aria-label=Share flex ng-cloak class=\"maindialog backgroundwhite dicsarchbox\"> <md-toolbar> <div class=\"md-toolbar-tools bordertop\"> <h1 flex=95 class=coloroftext>Dictionary</h1> <span><i class=\"fas fa-times\" ng-click=cancel()></i> </span> </div> </md-toolbar> <md-dialog-content class=mddicsearchbox> <div class=\"dash_content iii\" style=padding-top:12px!important> <div class=\"col-md-12 md-whiteframe-5dp\" style=position:absolute;width:100%> <div layout=row style=\"padding:10px 10px 0 10px\"> <div flex=60> <md-input-container class=\"flex md-default-theme mdtxinput mdfirst\" style=width:100%;margin-bottom:0> <label> Enter a word </label> <input ng-model=dictionary.searchkey required class=\"ng-pristine ng-valid md-input ng-touched\" id=search_dc aria-invalid=false ng-keyup=\"$event.keyCode == 13 ? triggersubmit() : null\"> </md-input-container> </div> <div flex=20> <md-button class=\"md-whiteframe-1dp usbtn\" id=dicbtn ng-click=getsearchData(dictionary) style=float:left;margin-top:13px>Search</md-button> </div> <div flex=20><img style=display:none;padding-top:12px;padding-left:10px id=issearchimg src=" + __webpack_require__(88) + " /></div> </div> <div class=md-padding> <div class=resdatadic ng-repeat=\"dicdata in dictionaryItems\"> <div ng-bind-html=dicdata style=\"padding:5px 10px\"></div> </div> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.resdatadic{width:100%;background:#f1e6e6;margin-bottom:12px}.dicsarchbox{max-width:50%!important;height:auto!important}.mddicsearchbox{min-height:415px!important}.dash_content{position:relative;width:98%;padding-top:28px;margin:auto}.md-scroll-mask{background:#000!important;opacity:.8!important}</style> <md-dialog md-theme=default aria-label=FeePending ng-class=dialog.css class=\"_md md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_4> <md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_4 style=width:500px> <h2 class=\"md-title ng-binding\" style=text-align:center>Masked Login <span style=float:right;cursor:pointer> <i id=feduemsgclose class=\"fas fa-times\" ng-click=cancel() style=color:#5f9ea0></i> </span> </h2> <div class=\"md-dialog-content-body ng-binding ng-scope\"> <div class=\"col-md-12 md-whiteframe-5dp\" style=width:100%> <div layout=row style=\"padding:10px 10px 0 10px\"> <div flex=90> <md-input-container class=\"flex md-default-theme mdtxinput mdfirst\" style=width:100%;margin-bottom:0> <label> Enter Email ID </label> <input ng-model=maskemailId required class=\"ng-pristine ng-valid md-input ng-touched\" id=search_dc aria-invalid=false ng-keyup=\"$event.keyCode == 13 ? triggersubmitMask() : null\"> </md-input-container> </div> <div flex=10 style=display:none id=issearchimg> <img style=padding-top:12px;padding-left:10px src=" + __webpack_require__(88) + " /> </div> </div> </div> </div> </md-dialog-content> <md-dialog-actions style=margin:auto;width:95%> <md-button class=\"md-whiteframe-1dp usbtn\" id=dicbtnMask ng-click=goToMaskedLoginFn(maskemailId) style=float:right;margin:0;background-color:#1bbc9b!important>Go &nbsp;&nbsp;<i class=\"fas fa-sign-in-alt\"></i> </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _authDashboard = __webpack_require__(150);

var _authDashboard2 = _interopRequireDefault(_authDashboard);

var _authDashboardController = __webpack_require__(399);

var _authDashboardController2 = _interopRequireDefault(_authDashboardController);

var _authSidenav = __webpack_require__(953);

var _authSidenav2 = _interopRequireDefault(_authSidenav);

var _authSidenavController = __webpack_require__(960);

var _authSidenavController2 = _interopRequireDefault(_authSidenavController);

var _authOverview = __webpack_require__(151);

var _authOverview2 = _interopRequireDefault(_authOverview);

var _authOverviewController = __webpack_require__(400);

var _authOverviewController2 = _interopRequireDefault(_authOverviewController);

var _themeSummary = __webpack_require__(152);

var _themeSummary2 = _interopRequireDefault(_themeSummary);

var _themeSummaryController = __webpack_require__(401);

var _themeSummaryController2 = _interopRequireDefault(_themeSummaryController);

var _subjectStudentListing = __webpack_require__(154);

var _subjectStudentListing2 = _interopRequireDefault(_subjectStudentListing);

var _subjectStudentListing3 = __webpack_require__(403);

var _subjectStudentListing4 = _interopRequireDefault(_subjectStudentListing3);

var _subjectReport = __webpack_require__(153);

var _subjectReport2 = _interopRequireDefault(_subjectReport);

var _subjectReport3 = __webpack_require__(402);

var _subjectReport4 = _interopRequireDefault(_subjectReport3);

__webpack_require__(962);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//Courseware module
var _module = angular.module('app.AuthDashboardModule', [_angularUiRouter2.default]).component("authsidenav", {
    template: _authSidenav2.default,
    controllerAs: "authsidenav",
    controller: _authSidenavController2.default
}).controller('authSidenavCtrl', _authSidenavController2.default).controller('authDashboardCtrl', _authDashboardController2.default).controller('authOverviewCtrl', _authOverviewController2.default).controller('themeSummaryCtrl', _themeSummaryController2.default).controller('subjectStudentCtrl', _subjectStudentListing4.default).controller('subjectReportCtrl', _subjectReport4.default);

_module.constant('AUTHDASHCONSTANT', {
    AUTH_DASH_URL: "/v0/auth-dashboard/get-details",
    API_AUTH_DASH_OVERVIEW_URL: "/v0/auth-dashboard/overview/get-syllabus",
    API_THEME_SUMMARY_URL: "/v0/theme/summary/teachingplan",
    //Status for teaching plan and resources
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_SUBJECT_REPORT: "/v0/subject-report",
    API_GET_STUDENT_EMAILS: '/v0/auth-dashboard/student/emails'
});
//Sidenav module
/* var authSidenavmodule = angular.module('AuthSidenavModule', [
     uiRouter
     //import modules
 ]).component("authsidenav", {
     template: authSidenavTpl,
     controllerAs: "authsidenav",
     controller: authSidenavCtrl
 });*/
_module.constant('AUTHSIDENAVCONSTANT', {
    API_AUTH_SIDENAV_URL: "/v0/auth-dashboard/side-nav/tp-list"
});
/* module.config(function($stateProvider) {
     "ngInject";
      $stateProvider
         .state('authsidenav', {
             parent: 'app',
             url: '/authDashboard',
             views: {
                 '@': {
                     template: authSidenavTpl,
                     controller: authSidenavCtrl,
                     controllerAs: 'authsidenav'
                 }
             }
         })
 });*/
/*module.config(function($stateProvider) {
    "ngInject";
     $stateProvider
        .state('authdashboard', {
            parent: 'app',
            url: '/authDashboard',
            views: {
                '@': {
                    template: authDashboardTpl,
                    controller: authDashboardCtrl,
                    controllerAs: 'authDashboard'
                }
            }
        })
});
 //Sidenav module
var authSidenavmodule = angular.module('AuthSidenavModule', [
    uiRouter
    //import modules
]).component("authsidenav", {
    template: authSidenavTpl,
    controllerAs: "authsidenav",
    controller: authSidenavCtrl
});
authSidenavmodule.constant('AUTHSIDENAVCONSTANT', {
    API_AUTH_SIDENAV_URL: "/v0/auth-dashboard/side-nav/tp-list"
})
authSidenavmodule.config(function($stateProvider) {
    "ngInject";
     $stateProvider
        .state('authsidenav', {
            parent: 'app',
            url: '/authDashboard',
            views: {
                '@': {
                    template: authSidenavTpl,
                    controller: authSidenavCtrl,
                    controllerAs: 'authsidenav'
                }
            }
        })
});
 //Overview module
var authOverviewmodule = angular.module('AuthOverviewModule', [
    uiRouter
    //import modules
]);
authOverviewmodule.config(function($stateProvider) {
    "ngInject";
     $stateProvider
        .state('authoringTool', {
            parent: 'app',
            url: '/authoring-tool',
            views: {
                '@': {
                    template: authOverviewTpl,
                    controller: authOverviewCtrl,
                    controllerAs: 'authoringTool'
                }
            }
        })
});
//Theme summary module
var themeSummaryModule = angular.module('ThemeSummaryModule', [
    uiRouter
    //import modules
]);
themeSummaryModule.config(function($stateProvider) {
    "ngInject";
     $stateProvider
        .state('theme-summary', {
            parent: 'app',
            url: '/theme-summary/:theme_id',
            views: {
                '@': {
                    template: themeSummaryTpl,
                    controller: themeSummaryCtrl,
                    controllerAs: 'themeSummary'
                }
            }
        })
});*/

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";
}]);

exports.default = _module;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.bottom-style{border-top:1px solid #dfdfdf!important}</style> <md-sidenav id=inner-content-div layout=column class=\"md-asidenav-left leftNav\" md-component-id=left style=overflow-y:scroll!important> <div class=md-accordion> <div class=\"normalAccHeadColor mousePointer\"> <div ng-click=gotoauthDahBoard() layout=row layout-align=space-between flex> <img style=width:24px;height:13px flex=5 src=" + __webpack_require__(439) + "> <span flex=90>Courseware</span> </div> </div> <md-divider></md-divider> <div class=\"normalAccHeadColor mousePointer\"> <div ng-click=gotoauthoringtool() layout=row layout-align=space-between flex> <img style=width:21px;height:13px flex=5 src=" + __webpack_require__(954) + "> <span flex=90>Overview</span> </div> </div> <md-divider></md-divider> </div> <div class=md-accordion ng-repeat=\"module in menuPlan\"> <div ng-click=collapseAll(menuPlan,module,$index) class=mousePointer ui-sref=theme-summary({theme_id:module._id}) style=outline:0 tooltip={{module.name}} tooltip-position=right> <div ng-class=\"{'selectedAccHeadColorFaq' : module.expanded, 'normalAccHeadColor' : !module.expanded}\"> <div layout=row layout-align=space-between flex=100> <img style=width:24px;height:13px;margin-top:5px flex=5 src=" + __webpack_require__(955) + "> <span flex=80> {{module.name}}</span> <i flex=5 class=\"fas fa-angle-down\" ng-if=!module.expanded></i> <i flex=5 class=\"fas fa-angle-up\" ng-if=module.expanded></i> </div> </div> </div> <div class=faqAnswerRepeat ng-class=\"{dataContentss:true, activContent:module.expanded}\" flex layout=row layout-align=\"center center\"> <div flex layout=column> <div layout=column> <div> <div ng-repeat=\"feature in module.plans\"> <div class=normalAccHeadColor ng-class=\"feature.isToApprove?'to-approve-plans':''\" ng-if=\"module.plans.length>0\" ui-sref-active=sideNavSelected flex layout=row ng-click=gotoViewPage(feature) tooltip={{feature.title}} tooltip-position=right> <div flex style=font-size:14px;text-transform:capitalize title={{feature.title}}> <img class=hand ng-if=\"feature.status==='created'\" src=" + __webpack_require__(171) + "> <img class=hand ng-if=\"feature.status==='draft'\" src=" + __webpack_require__(956) + "> <img class=hand ng-if=\"feature.status==='approved'\" src=" + __webpack_require__(957) + "> <img class=hand ng-if=\"feature.status==='rejected'\" src=" + __webpack_require__(958) + "> <img class=hand ng-if=\"feature.status==='sent_for_approval'&&!feature.isToApprove\" src=" + __webpack_require__(534) + "> <img class=hand ng-if=\"feature.status==='sent_for_approval'&&feature.isToApprove\" src=" + __webpack_require__(959) + "> {{feature.title|limitTo:15}} <span ng-if=\"feature.title.length>15\">...</span> </div> </div> </div> <div class=normalAccHeadColor ui-sref-active=sideNavSelected flex layout=row ng-click=gotoCreatePage(module) ng-if=\"userAccess.newTeachingPlan && userAccess.newTeachingPlan.create\"> <p flex style=font-size:14px> + Add New Plan </p> </div> </div> </div> </div> </div> <md-divider></md-divider> </div> <div class=md-accordion ng-show=\"reportUserAccess.subjectReport && reportUserAccess.subjectReport.read\"> <div class=\"normalAccHeadColor mousePointer\"> <div ui-sref=subjectStudent layout=row layout-align=space-between flex> <img style=width:24px;height:13px flex=5 src=" + __webpack_require__(439) + "> <span flex=90>Subject Report</span> </div> </div> </div> <div class=\"normalAccHeadColor mousePointer\"> <div class=normalAccHeadColor ui-sref-active=sideNavSelected flex layout=row ng-click=newThemePopup() ng-if=\"userAccess.newTeachingPlan && userAccess.newTeachingPlan.create\"> <p flex style=font-size:14px> + Add New Theme </p> </div> </div> </md-sidenav>";

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAUBJREFUeNpi/D+f4QwDA4MiAwScAmJPINYG4tNAzMRAGLxjARIaQMwNFVADYpDYQyD2I8IAdpBFLGi2wdisQCwLxIwEDDkHxBdAhhxG8g7Ia3+AWAKIW4jwzgyQIYz///9nYFjAyA4V/InkIlYivPMXZCkLmmYY+IdFDCdgAboiFUhLQ/m3gHgZEEsCcSERYQIC3xiBUQyykQ0q8AiIFYBYGYjXEBEmIPlPIO98RTLkOzQs7gKxKRGu+M0ATROsKN6DSKgD8X6oTf9xGADy6jQgbgRpCgdicajEA6im1yBJIlxyEWwaNIoZKAGg2OEH0lxQ/mcg/gL1ogiRsfMPlmLlkVKsMzRMzhCZAd+zQJM8D1RAHuqKe0DsQGQGZMGWAUEBywHExkR4B1R0nGKBOlsHKVf+gabgfiK80wcyBCDAAAupQa02W+H3AAAAAElFTkSuQmCC"

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAO9JREFUeNpi/P//PwOlgImBCoAFzlrAOBlI5gDxNSDeBMQTgfgFklo2IE4A4hAgtgHiL0AsA8S/WJAUKUJpLSjOB2J/IN4NxKJAvAuIDZDUc0Ix0JAFjHVAxh0srgQp2AjEqkA8E80AGOAH4pOgMFHH411OqAvl8KhRp0rAjhqC2xBQLHwkUe8vIP6LnGKTgdgTiPugcW8JxGloUfsdiJcB8Q4gvg/FOciGgDR9AOKn0KQOSqUO0GQOAsehqdcVargocuJj/D+fIQpIOwHxO2jKvY/kgvVQcRDwA2IJqBpQAhQCYhVQHmIcNEUBQIABAE26L8fR1qepAAAAAElFTkSuQmCC"

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAc1JREFUeNqUU0tLAlEUPjPO+AIXhpsQhDbhAxUlc9HWZdsIolWbVi38Ie3b9hv6AcosBElCUXBtOmRmGBK+xkffueVCu2N04TL33jnfOd/5zjlKPp8nRVEunU5nkr7Xcjwev6uquqLdS9cWi4Xi9/vPc7ncKQCEbdVqtXij0Rjqur4LfKTB+Ho6nR42m00Kh8MEBh+ZTMZ0OByf1WqV73bgF3W5XN653e6nRCJBLpeLwITm87kjlUpRPB4ny7JotZJmoKrINwpAoN/vCyDuwpjPYEDsFM6koRmcgff9Xq+3YcQO+J5OpykWixEY/gbj8d7r9T6yEehvUOQz70gkInLfpg+91KvRaHRcqVRoMpnww4bBOgUpbfw0UJJOMBgkTdPsxLEFP6MsQ5/PR/j+D4x1g45KozGktHeCIdgtBCtls1nyeDxyVeGQSygr1clsNjtotVqiIbaNWIfBYCD9xxz3kKebKW9H5Y4zTZNKpZKcEYAPMGpEo1FhvBaMh6LdbpNhGARmUi2Y9hmiJuv1OmFABDVuiG63S8ViUbxxFWzrDOO3UCgkIiOip9PpWIVCQTSHHZDnnkfyFR1mlMtl/YfyBENyAYFmf5Qt8CXAAOdJ/NrM9KrfAAAAAElFTkSuQmCC"

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0lJREFUeNqEU1tLVFEU3pcz40ya0+miUxNq3stx6E50D6mwpOcuUFHRexD9gYoogrKXCIQehIgo6EphPaSRFaEYOc6oTJOYldOE1ZidmXP23n3bI9JLtQcG9lnr2+v7vrUW7ezsbG9vl1KS/51IJNLU1PTnFwPgxsbGwsJC4Cmlf0MKIdra2pRSyHH/NRgnHA4zxv6BdE93d7ebM51pAJbNZv1+/8TEBFFCEWPyu1ahKOGKKir9MwookY4U0yGiGKHEAFvOOa7xeNy2BSWOQgg4Rplkkghvft7yumUgyukkkGoYoVIRZoAD9EBGdXU1XFPK1qqIgVK9meGOj9Hno8mBwRZGmEnzRqL+htCKiFmCK17QJFEZ4GQyaWVtRnUNruS9sTd3MtERa8zhNlUG3vuqfp7ru3P7w+vDVdsOVq7XfrlOer3eiooKIpViHMqvDT27OvR6wvqlYIk0mIJGsJWM8Hdjn0/33PAovrdqgzHtXiKRcHI21Pbbo1dGn7hICFPEQQabbKQgsrhg3rqiqisDj+pnh1xvIVUFg0FhO9By/33sgzWmW0lhpANxTHCHCfg3119wIryzOhDaMXTm8adeAzC3+Pj4uOXYnKrO1KCisH2yJpQIpn9KLiosPrdy3zy/earnFpWyIxUz3IkBPhAI5AtlMJmw04DkebwI/HJy0IRwxCw7v+pg0D9rT3tz9FsScuLfhqc0A59Op61c1ispEZJy49iSpqBv1tm3d0esdH2g9NLqI+WB4NHnl3u/JzE9cA6YqT7DVPTZHaAl6ZKXqQGQ3l2+tih/9vVEx4HKzbVmqLnv4YORLk7gOxFc1pmlesKYvk7ZBpIbixa/Sg2c77tnKXE8vGvtnKo8w9OTTrT0t6GNhGIIBBFkTXEtczEuWI+WYg2hSM3MYE5km2P3L7y97eOenBIXY4++ZH9goNzk2kDJ9vn1mvZ0ZUIwzGSpWXaoZuupN7cyduZi9IHP51voM1+mYtgR4GD7TF/B4Zot9WaZ4TjOn3vHiNYBkWDREn/an/l4susmQzmsrA6K2sCCQ5Vb95dv0kxbW1sRwvMuFgsI7po+lcMq8yIzOOTJfvFY2JNIUcn64rqG+csjc0q5TiC/BRgAxPap+juLLfQAAAAASUVORK5CYII="

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAt9JREFUeNp8VM1PE0EUn5ndFpGaBgKKFIiyaTBUGyLIgYMHEi61RCOkB6OcFP4ECIarAYk3TeTjpIIRvAgRoyAhxDRgYjlooGCWNQhSqdKDTUphd8ffdGtpNDJptm9m3u/jvZldGgwGZ2dnOefk0IEEr9fb1NSUvSgD7PP5HA4HpZQQk1MmHpRyamJb4pIJICW6rs+8mU7REEIFF1Jkm83m8XhkWRZzQnUsccqJiNP8YOEMs1AoBHaDMknAkUNl7CaTScYYntwwTShzLlFiEoNyZhJKGcs7ahckBuiYxIU7mkILQUs2HA4Db5kXMEECRZ6Tk1PtPU+YCbqUEZayJChkZKMeu93udrt1+OP7oDS5jVH509zEysSoPB/aWttC+l554dN342darlc3+KloIRFgSZJM09Q0LZnYtUmSLnpCFocfOMfGT238zPS2YmmDLD1TX77VbrVe7bqH+oRhIFGzoiiisSaK5K/6bpc9HM5N7P17ZsfXfyTu3H/ByeXuPiYKY+KpqurKcnh1Zfn1yCAZemIhyzo66nd25Px8xEcqKi5yfrKtDVv7Q48+zEwCyCzK4uJil8tVWlrya37uxB+3X3t7Y9PT7v5+xFWjo5huDQxY+qvPR9K2UXk8Hjf39nEc0sJits/P7e11qnpuagqx1tl5cOeCC+KcxX3i3Ol0GoZBqFT4JZIN1mMxCJ7u6VkOBLLX89Vvac/AR6PR7xiRSOoGHgyUisphHnir+Mxg1qUHuLKy8iyGpyqmuLIzUGp0bOxjYyMsAJ9ZjyklzPJsUeAP7wOrr8tkQBNqVqlLgQBajV9atv4Cs2Qt5/CLyN1ybbu8KNPt94oCTcS7a2tzlFrd3i4vdLdcZ2lYunKhX9NwSb55I5Fr/9+7jS0k1DT4ZVzsDDiFl6Dv6+6bpCQ++LhoPfoXEppSW+uVrrvC5iFfEsfmZkE47NS0vEjq8HCBm5sL/P5jtbVWwm8BBgBR2HI4io9w2gAAAABJRU5ErkJggg=="

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAIAAAAf7rriAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKT2lDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVNnVFPpFj333vRCS4iAlEtvUhUIIFJCi4AUkSYqIQkQSoghodkVUcERRUUEG8igiAOOjoCMFVEsDIoK2AfkIaKOg6OIisr74Xuja9a89+bN/rXXPues852zzwfACAyWSDNRNYAMqUIeEeCDx8TG4eQuQIEKJHAAEAizZCFz/SMBAPh+PDwrIsAHvgABeNMLCADATZvAMByH/w/qQplcAYCEAcB0kThLCIAUAEB6jkKmAEBGAYCdmCZTAKAEAGDLY2LjAFAtAGAnf+bTAICd+Jl7AQBblCEVAaCRACATZYhEAGg7AKzPVopFAFgwABRmS8Q5ANgtADBJV2ZIALC3AMDOEAuyAAgMADBRiIUpAAR7AGDIIyN4AISZABRG8lc88SuuEOcqAAB4mbI8uSQ5RYFbCC1xB1dXLh4ozkkXKxQ2YQJhmkAuwnmZGTKBNA/g88wAAKCRFRHgg/P9eM4Ors7ONo62Dl8t6r8G/yJiYuP+5c+rcEAAAOF0ftH+LC+zGoA7BoBt/qIl7gRoXgugdfeLZrIPQLUAoOnaV/Nw+H48PEWhkLnZ2eXk5NhKxEJbYcpXff5nwl/AV/1s+X48/Pf14L7iJIEyXYFHBPjgwsz0TKUcz5IJhGLc5o9H/LcL//wd0yLESWK5WCoU41EScY5EmozzMqUiiUKSKcUl0v9k4t8s+wM+3zUAsGo+AXuRLahdYwP2SycQWHTA4vcAAPK7b8HUKAgDgGiD4c93/+8//UegJQCAZkmScQAAXkQkLlTKsz/HCAAARKCBKrBBG/TBGCzABhzBBdzBC/xgNoRCJMTCQhBCCmSAHHJgKayCQiiGzbAdKmAv1EAdNMBRaIaTcA4uwlW4Dj1wD/phCJ7BKLyBCQRByAgTYSHaiAFiilgjjggXmYX4IcFIBBKLJCDJiBRRIkuRNUgxUopUIFVIHfI9cgI5h1xGupE7yAAygvyGvEcxlIGyUT3UDLVDuag3GoRGogvQZHQxmo8WoJvQcrQaPYw2oefQq2gP2o8+Q8cwwOgYBzPEbDAuxsNCsTgsCZNjy7EirAyrxhqwVqwDu4n1Y8+xdwQSgUXACTYEd0IgYR5BSFhMWE7YSKggHCQ0EdoJNwkDhFHCJyKTqEu0JroR+cQYYjIxh1hILCPWEo8TLxB7iEPENyQSiUMyJ7mQAkmxpFTSEtJG0m5SI+ksqZs0SBojk8naZGuyBzmULCAryIXkneTD5DPkG+Qh8lsKnWJAcaT4U+IoUspqShnlEOU05QZlmDJBVaOaUt2ooVQRNY9aQq2htlKvUYeoEzR1mjnNgxZJS6WtopXTGmgXaPdpr+h0uhHdlR5Ol9BX0svpR+iX6AP0dwwNhhWDx4hnKBmbGAcYZxl3GK+YTKYZ04sZx1QwNzHrmOeZD5lvVVgqtip8FZHKCpVKlSaVGyovVKmqpqreqgtV81XLVI+pXlN9rkZVM1PjqQnUlqtVqp1Q61MbU2epO6iHqmeob1Q/pH5Z/YkGWcNMw09DpFGgsV/jvMYgC2MZs3gsIWsNq4Z1gTXEJrHN2Xx2KruY/R27iz2qqaE5QzNKM1ezUvOUZj8H45hx+Jx0TgnnKKeX836K3hTvKeIpG6Y0TLkxZVxrqpaXllirSKtRq0frvTau7aedpr1Fu1n7gQ5Bx0onXCdHZ4/OBZ3nU9lT3acKpxZNPTr1ri6qa6UbobtEd79up+6Ynr5egJ5Mb6feeb3n+hx9L/1U/W36p/VHDFgGswwkBtsMzhg8xTVxbzwdL8fb8VFDXcNAQ6VhlWGX4YSRudE8o9VGjUYPjGnGXOMk423GbcajJgYmISZLTepN7ppSTbmmKaY7TDtMx83MzaLN1pk1mz0x1zLnm+eb15vft2BaeFostqi2uGVJsuRaplnutrxuhVo5WaVYVVpds0atna0l1rutu6cRp7lOk06rntZnw7Dxtsm2qbcZsOXYBtuutm22fWFnYhdnt8Wuw+6TvZN9un2N/T0HDYfZDqsdWh1+c7RyFDpWOt6azpzuP33F9JbpL2dYzxDP2DPjthPLKcRpnVOb00dnF2e5c4PziIuJS4LLLpc+Lpsbxt3IveRKdPVxXeF60vWdm7Obwu2o26/uNu5p7ofcn8w0nymeWTNz0MPIQ+BR5dE/C5+VMGvfrH5PQ0+BZ7XnIy9jL5FXrdewt6V3qvdh7xc+9j5yn+M+4zw33jLeWV/MN8C3yLfLT8Nvnl+F30N/I/9k/3r/0QCngCUBZwOJgUGBWwL7+Hp8Ib+OPzrbZfay2e1BjKC5QRVBj4KtguXBrSFoyOyQrSH355jOkc5pDoVQfujW0Adh5mGLw34MJ4WHhVeGP45wiFga0TGXNXfR3ENz30T6RJZE3ptnMU85ry1KNSo+qi5qPNo3ujS6P8YuZlnM1VidWElsSxw5LiquNm5svt/87fOH4p3iC+N7F5gvyF1weaHOwvSFpxapLhIsOpZATIhOOJTwQRAqqBaMJfITdyWOCnnCHcJnIi/RNtGI2ENcKh5O8kgqTXqS7JG8NXkkxTOlLOW5hCepkLxMDUzdmzqeFpp2IG0yPTq9MYOSkZBxQqohTZO2Z+pn5mZ2y6xlhbL+xW6Lty8elQfJa7OQrAVZLQq2QqboVFoo1yoHsmdlV2a/zYnKOZarnivN7cyzytuQN5zvn//tEsIS4ZK2pYZLVy0dWOa9rGo5sjxxedsK4xUFK4ZWBqw8uIq2Km3VT6vtV5eufr0mek1rgV7ByoLBtQFr6wtVCuWFfevc1+1dT1gvWd+1YfqGnRs+FYmKrhTbF5cVf9go3HjlG4dvyr+Z3JS0qavEuWTPZtJm6ebeLZ5bDpaql+aXDm4N2dq0Dd9WtO319kXbL5fNKNu7g7ZDuaO/PLi8ZafJzs07P1SkVPRU+lQ27tLdtWHX+G7R7ht7vPY07NXbW7z3/T7JvttVAVVN1WbVZftJ+7P3P66Jqun4lvttXa1ObXHtxwPSA/0HIw6217nU1R3SPVRSj9Yr60cOxx++/p3vdy0NNg1VjZzG4iNwRHnk6fcJ3/ceDTradox7rOEH0x92HWcdL2pCmvKaRptTmvtbYlu6T8w+0dbq3nr8R9sfD5w0PFl5SvNUyWna6YLTk2fyz4ydlZ19fi753GDborZ752PO32oPb++6EHTh0kX/i+c7vDvOXPK4dPKy2+UTV7hXmq86X23qdOo8/pPTT8e7nLuarrlca7nuer21e2b36RueN87d9L158Rb/1tWeOT3dvfN6b/fF9/XfFt1+cif9zsu72Xcn7q28T7xf9EDtQdlD3YfVP1v+3Njv3H9qwHeg89HcR/cGhYPP/pH1jw9DBY+Zj8uGDYbrnjg+OTniP3L96fynQ89kzyaeF/6i/suuFxYvfvjV69fO0ZjRoZfyl5O/bXyl/erA6xmv28bCxh6+yXgzMV70VvvtwXfcdx3vo98PT+R8IH8o/2j5sfVT0Kf7kxmTk/8EA5jz/GMzLdsAAAAgY0hSTQAAeiUAAICDAAD5/wAAgOkAAHUwAADqYAAAOpgAABdvkl/FRgAAAyNJREFUeNqEk+9rm1UUx7/n3pvkSdsla0vb1NpWly0wTSubhSGMivUHK9S+sW82EMEiiqh/gQzfifpGEfpGcEp9KepwMixFG5lBRi2mW0asC22da7o1dm1M0id5nnuPL259HIh6uFy455wP597vOZey2WwmkzHG4P9seHh4YmLibo/KZrPj4+OxWMwYQ0T/Rmqt5+bmmJmI7A5AKaXS6bQQ4j9Ia0tLSzYnyFRCiEajEY1G6/U6WDMUAMAAYIJkYjLRljaC8Y0OQmABgjLGSCkBFAoFz9MEnwFmgiBhhIEOt0aOP3iMiSQBBiABAsgwhCIirTUzp1IpY8DsERFDEcyl0tq573/+4Xq9fCvv15xwC7+z8tnkscGXRtM9sQgBCoCUkplXV1fdhieIiaRk897V/Pmcu3uzA2izL2zUnFyec/m1L3/ceHtqZCzdq6yS4XA4mUzCMAsJ1mcXFj69rJt3OpX8WzBfM4CDraGeSPsbn19hSBWoVywW/abHTIuVzY++2WhsdwbyW6zzQPjMyYHpsftWStXXPvzpzfPLVlswcyKR0J4PQRcvrOz+1iEFmKENA0gcdJ4dHXjhiUPlPxoDXS3vXyxu7ribO65iZlu8Wq26vieJL6/UgLjFBrtannt0cPrx+/s6ou9+9csD98ZCUmSube332U4MgHg83qpZCbP9exhAb7vz+jNHT5/sj0VDrqefn1k8caTjqYd6LhXKxVvVfdiWZeZyuew2G2FDfs0B4DZN/kYlf6PSHXemZxbH0l0vPnkIwPzybWYQgRn7fRZCpFIpO0DRA1frldBOvTnzdfHjhfWpR/rGhrrPTh21yi3ktwAIIs0sjDFCiEA2AEf6IzasJNUa/s3tvdKdvXPfrgEo7bjL67tBF1TAACBisJg83p/Lr++HJc0v3wbwwfxq5trW4URbZc9TkiyhiCioDAgDvDw6dGGxlCt41iUFATDMn3z3qz0ygxmTI73C9/27/52A6WyLvDV1YrBPasPB+utysMeHk+2vnDpMs7OzzOw4jmWZDDGIcWWLv7hu8huhf37sp0fuefVU8rGh7j8HAJkQluwBAB6mAAAAAElFTkSuQmCC"

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _newThemePopup = __webpack_require__(961);

var _newThemePopup2 = _interopRequireDefault(_newThemePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: authDashboardController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-05
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var AuthSidenavController =
// @ngInject
["$scope", "$rootScope", "$mdSidenav", "authService", "localStorageService", "$state", "AUTHSIDENAVCONSTANT", "AUTHDASHCONSTANT", "$mdDialog", "$mdMedia", function AuthSidenavController($scope, $rootScope, $mdSidenav, authService, localStorageService, $state, AUTHSIDENAVCONSTANT, AUTHDASHCONSTANT, $mdDialog, $mdMedia) {
    _classCallCheck(this, AuthSidenavController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        // $rootScope.title = "Courseware"
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {
        planIds = [];
        resourceIds = [];
        authoring = localStorageService.get('authoringData');
        userDetails = [];
        url = "";
        userId = "";
        $scope.userAccess = "";
        $scope.menuPlan = "";
    };

    var planIds = [];
    var resourceIds = [];
    var authoring = localStorageService.get('authoringData');
    var userDetails = [];
    var url = AUTHSIDENAVCONSTANT.API_AUTH_SIDENAV_URL;
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    //For toggle sidenav
    var buildToggler = function buildToggler(navID, $mdSidenav) {
        return function () {
            $mdSidenav(navID).toggle();
        };
    };
    $rootScope.toggleLeft = buildToggler('left', $mdSidenav);
    $rootScope.isOpenLeft = function () {
        return $mdSidenav('left').isOpen();
    };

    /*
     * Function to set Teaching plan
     * @data: [Object] - theme list 
     * Developer : Arul Mozhi J
    */
    var setTeachingplanList = function setTeachingplanList(data) {
        _.each(data, function (theme) {
            var planList = [];
            _.each(theme.plans, function (tp) {
                if ($scope.userAccess) {
                    if ($scope.userAccess.approvedPlans && $scope.userAccess.approvedPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_APPROVED) {
                            if (tp.teacher_id === userId) {
                                planList.push(tp);
                            }
                            // Display teaching plan to assigned students only
                            if (tp.students && tp.students.length > 0) {
                                _.each(tp.students, function (student) {
                                    if (student === userId) {
                                        planList.push(tp);
                                    }
                                });
                            }
                            // Display teaching plan to shared to parents only
                            if (tp.shared_parents && tp.shared_parents.length > 0) {
                                _.each(tp.shared_parents, function (parent) {
                                    if (parent.parent_id === userId) {
                                        if (planList.findIndex(function (i) {
                                            return i._id === tp._id;
                                        }) === -1) planList.push(tp);
                                    }
                                });
                            }
                        }
                    }
                    if ($scope.userAccess.rejectedPlans && $scope.userAccess.rejectedPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_REJECTED) {
                            if (tp.teacher_id === userId) planList.push(tp);
                        }
                    }
                    if ($scope.userAccess.newTeachingPlan && $scope.userAccess.newTeachingPlan.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_CREATED || tp.status === AUTHDASHCONSTANT.STATUS_DRAFT) {
                            if (tp.teacher_id === userId) planList.push(tp);
                        }
                    }
                    if ($scope.userAccess.sentForApprovalPlans && $scope.userAccess.sentForApprovalPlans.read) {
                        if (tp.status === AUTHDASHCONSTANT.STATUS_SENT_FOR_APPROVAL) {
                            if (tp.teacher_id === userId) planList.push(tp);
                        }
                        if (planIds.indexOf(tp._id) > -1) {
                            if (tp.teacher_id !== userId) {
                                tp.isToApprove = true;
                                planList.push(tp);
                            }
                        }
                    }
                }
            });
            theme.plans = planList;
        });
        $scope.menuPlan = data;
        _.defer(function () {
            $scope.$apply();
        });
    };

    /*
     * Function to upadate sidenave 
     * Developer : Arul Mozhi J
    */
    $rootScope.updateSidenav = function () {
        // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
        // let tpSideNavUserAccess = UserPrivilages.getFeatures("teachingPlan");
        var tpSideNavUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "teachingPlan";
        });
        $scope.userAccess = {};
        if (tpSideNavUserAccess.length > 0) {
            _.each(tpSideNavUserAccess, function (forumObj) {
                var user_access = {};
                _.each(forumObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status;
                });
                $scope.userAccess[forumObj.feature_id] = user_access;
            });
        }
        var reportAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
            return feature.module_state == "reports";
        });
        // let reportAccess = UserPrivilages.getFeatures("reports");
        $scope.reportUserAccess = {};
        if (reportAccess.length > 0) {
            _.each(reportAccess, function (forumObj) {
                var user_access = {};
                _.each(forumObj.privilege, function (privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status;
                });
                $scope.reportUserAccess[forumObj.feature_id] = user_access;
            });
        }
        if (tpSideNavUserAccess.length > 0) {
            userDetails = localStorageService.get("personData");
            if (userDetails && userDetails.courseware_details) {
                var coursewareObj = userDetails.courseware_details;
                if (coursewareObj.teaching_plan_approval) {
                    var tp = _.find(coursewareObj.teaching_plan_approval, function (obj) {
                        return obj.class_id === authoring.class_id && obj.batch_id === authoring.batch_id && obj.session_id === authoring.session_id && obj.subject_id === authoring.subject_id && obj.curriculum_id === authoring.curriculum_id;
                    });
                    if (tp) {
                        planIds = tp.plan_ids;
                        resourceIds = tp.resource_ids;
                        localStorageService.set("planIds", tp.plan_ids);
                        localStorageService.set("approverResourceIds", resourceIds);
                        localStorageService.set("teachingPlanIdstoApprove", tp.plan_ids_to_approve);
                    }
                }
            }
            if ($scope.userAccess.newTeachingPlan && $scope.userAccess.newTeachingPlan.create) {
                $scope.createStatus = true;
            }
        }
        var params = {
            curriculum_id: authoring.curriculum_id,
            session_id: authoring.session_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            subject_id: authoring.subject_id,
            school_id: authoring.school_id,
            academic_year: authoring.academic_year
        };
        authService.callAPI(url, 'POST', params, function (response) {
            if (response) {
                var result = response.result.data;
                setTeachingplanList(result);
            }
        });
        // })
    };

    $rootScope.updateSidenav();

    /*
     * Function to goto tp create page
     * @module: Object - theme details
     * Developer : Arul Mozhi J
    */
    $scope.gotoCreatePage = function (module) {
        $rootScope.toggleLeft();
        localStorageService.set("plan_details", {
            theme_name: module.name
        });

        $state.go('newTeachingPlan', {
            "id": module._id,
            "planId": ''
        });
    };

    /*
     * Function to goto plan view
     * @feature: Object - plan details 
     * Developer : Arul Mozhi J
    */
    $scope.gotoViewPage = function (feature) {
        $rootScope.toggleLeft();
        console.log("*************");
        $state.go('viewTeachingPlan', {
            "planId": feature._id

        });
    };

    /*
     * Function to goto overview page
     * Developer : Arul Mozhi J
    */
    $scope.gotoauthoringtool = function () {
        $state.go('authoringTool');
    };

    /*
     * Function to goto courseware 
     * Developer : Arul Mozhi J
    */
    $scope.gotoauthDahBoard = function () {
        $state.go('authdashboard');
    };

    //To collapse all accordian
    $scope.collapseAll = function (accordianData, selectedData, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !selectedData.expanded;
        });
    };
    $scope.newThemePopup = function () {
        $rootScope.toggleLeft();
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                localStorageService: localStorageService,
                authoring: authoring,
                userId: userId,
                schoolId: schoolId
            },
            template: _newThemePopup2.default,
            controller: ['$scope', '$mdDialog', 'localStorageService', newThemePopupCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        }).then(function () {});
    };
    var newThemePopupCtrl = function newThemePopupCtrl($scope, $mdDialog) {
        $scope.cancel = function () {
            $mdDialog.hide();
        };

        //To save theme
        $scope.saveTheme = function () {
            var themeObject = {
                curriculum_id: authoring.curriculum_id,
                subject_id: authoring.subject_id,
                class_id: authoring.class_id,
                theme_title: $scope.theme_title ? $scope.theme_title.trim() : ""
            };
            var errorCount = validateTheme(themeObject);
            if (errorCount === 0) {
                var params = {
                    curriculum_id: themeObject.curriculum_id,
                    subject_id: themeObject.subject_id,
                    class_id: themeObject.class_id,
                    school_id: schoolId,
                    user_id: userId,
                    theme_title: themeObject.theme_title,
                    id: $scope.theme_id
                };
                authService.callAPI("/v0/archives/themes/save", "POST", params, function (resultObj) {
                    var result = resultObj.result.data;
                    if (result.success) {
                        if (result.is_exists) {
                            $scope.errors["theme_title"] = "Theme Already exists";
                        } else {
                            toastr.success("Saved successfully");
                            $rootScope.updateSidenav();
                            $mdDialog.hide();
                        }
                    } else {
                        toastr.error("Network Error");
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            }
        };

        // To validate theme

        var validateTheme = function validateTheme(themeObject) {
            var errorCount = 0;
            $scope.errors = {};
            $scope.errors = {};
            if (themeObject.curriculum_id === undefined || themeObject.curriculum_id === "" || themeObject.curriculum_id === null) {
                $scope.errors["curriculum"] = "Please select curriculum";
                $scope.fullScreen = false;
                errorCount++;
            }
            if (themeObject.subject_id === undefined || themeObject.subject_id === "" || themeObject.subject_id === null) {
                $scope.errors["subject"] = "Please select subject";
                $scope.fullScreen = false;
                errorCount++;
            }
            if (themeObject.class_id === undefined || themeObject.class_id === "" || themeObject.class_id === null) {
                $scope.errors["class"] = "Please select class";
                $scope.fullScreen = false;
                errorCount++;
            }
            if (themeObject.theme_title === undefined || themeObject.theme_title === "" || themeObject.theme_title === null) {
                $scope.errors["theme_title"] = "Enter Theme Name";
                errorCount++;
            }
            return errorCount;
        };
    };
}];

exports.default = AuthSidenavController;

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports = "<md-dialog flex> <md-toolbar> <div class=\"md-toolbar-tools endorsePageCtrl heading\"> <h2> <font color=#FFFFFF>New Theme</font> </h2> <span flex></span> </div> </md-toolbar> <md-divider ng-if=!$last></md-divider> <md-dialog-content> <div layout=column class=create-archive style=border:10px> <div layout=column layout-wrap layout-align=space-around> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex> <label>Theme</label> <input type=text ng-model=theme_title> <div class=errorMessage>{{errors['theme_title']}}</div> </md-input-container> </div> </div> <div layout=row layout-align=\"end center\" flex class=pad_15> <md-dialog-actions layout=row> <md-input-container class=topMargin> <md-button class=\"md-raised md-primary primaryButton\" ng-click=saveTheme() ng-disabled=isClicked>Save</md-button> <md-button class=\"md-raised md-primary primaryButton\" ng-click=cancel()>Cancel</md-button> </md-input-container> </md-dialog-actions> </div> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _teacherView = __webpack_require__(964);

var _teacherView2 = _interopRequireDefault(_teacherView);

__webpack_require__(36);

var _teacherViewController = __webpack_require__(965);

var _teacherViewController2 = _interopRequireDefault(_teacherViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'teacherView';
var _module = angular.module("app.teacherView", ['ui.router']).component(name, {
    template: _teacherView2.default,
    controllerAs: name,
    controller: _teacherViewController2.default
}).controller('teacherViewCtrl', _teacherViewController2.default);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('teacherView', {
            parent: 'app',
            url: '/teacherView',
            views: {
                '@': {
                    template: navigationTpl,
                    controller: navigationCtrl,
                    controllerAs: 'teacherView'
                }
            }
        })
}); */

exports.default = _module;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-content class=\"md-padding secondDiv bgColor md-whiteframe-3dp profileEditSection\"> <h4>Daily Working Periods</h4> <div flex layout=column> <div layout-gt-sm=row> <md-input-container class=md-block flex-gt-sm> <label>Maximum periods per week</label> <input onkeypress=\"return 48<=event.charCode&&event.charCode<=57\" maxlength=2 ng-model=working_hours.weekly type=text value=\"\"> <error-msg msg=errors.name class=redAlert></error-msg> </md-input-container> <md-input-container class=md-block flex-gt-sm> <label>Maximum periods per day</label> <input onkeypress=\"return 48<=event.charCode&&event.charCode<=57\" maxlength=2 ng-model=working_hours.daily type=text ng-required=true value=\"\"> <error-msg msg=errors.name class=redAlert></error-msg> </md-input-container> <div> <img src=" + __webpack_require__(222) + " class=\"result-icon-button hand updateIconProfileSettings\" alt=profileEdit ng-click=updateUser() role=button tabindex=0> </div> </div> </div> <div class=\"md-whiteframe-3dp marginaround ng-scope teacher_component\" layout=row style=overflow-y:hidden> <div flex=15 layout-wrap ng-repeat=\"academic in academics\" layout=row style=margin-bottom:10px;outline:0 class=\"ng-scope layout-column flex-20\" role=button tabindex=0> <div class=\"margins paddings ng-binding redlabels greenlabels\" layout=column layout-align=\"center center\">{{academic.session_name}}/{{academic.curriculum_name}}/{{academic.class_name}}/{{academic.batch_name}} </div> </div> </div> </md-content>";

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: teacherViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var TeacherViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$stateParams", "localStorageService", "authService", "profileCons", function TeacherViewController($state, $rootScope, $scope, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, TeacherViewController);

    var selectedUserId = $stateParams.person_id;

    $scope.working_hours = {};

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get teacher details
     **/
    var getEndorsedAcademics = function getEndorsedAcademics() {
        authService.callAPI(profileCons.API_TEACHER_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                $scope.academics = response.result.data.details;
                $scope.working_hours = response.result.data.working_hours ? response.result.data.working_hours.working_hours : undefined;

                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    this.$onInit = function () {
        $scope.working_hours = {};
        getEndorsedAcademics();
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To update/save working hours
     **/
    $scope.updateUser = function () {

        if (!$scope.working_hours) {
            toastr.error("Please enter weekly details");
            return false;
        }

        if (!$scope.working_hours.weekly || isNaN($scope.working_hours.weekly)) {
            toastr.error("Please enter weekly max hours");
            return false;
        }
        if (!$scope.working_hours.daily || isNaN($scope.working_hours.daily)) {
            toastr.error("Please enter daily max hours");
            return false;
        }
        /* if (isNaN($scope.working_hours.weekly)) {
            toastr.error("Please enter valid weekly max hours")
            return false
        }
        if (isNaN($scope.working_hours.daily)) {
            toastr.error("Please enter valid daily max hours")
            return false
        } */

        if (parseInt($scope.working_hours.daily) > parseInt($scope.working_hours.weekly)) {
            toastr.error("Daily max hours should not be greater!");
            return false;
        }

        var obj = {
            'school_id': localStorageService.get('school_id'),
            'user_id': selectedUserId,
            'working_hours': $scope.working_hours
        };

        authService.callAPI(profileCons.API_UPDATE_WORKING_HRS, "POST", obj, function (response) {
            console.log(response);
            if (response.result && response.result.data) {
                toastr.success("Working hours saved!");
                getEndorsedAcademics();
            }
        });
    };
}];

exports.default = TeacherViewController;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hodView = __webpack_require__(967);

var _hodView2 = _interopRequireDefault(_hodView);

__webpack_require__(36);

var _hodViewController = __webpack_require__(968);

var _hodViewController2 = _interopRequireDefault(_hodViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'hodView';
var _module = angular.module("app.hodView", []).component(name, {
    template: _hodView2.default,
    controllerAs: name,
    controller: _hodViewController2.default
}).controller('hodViewCtrl', _hodViewController2.default);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('hodView', {
            parent: 'app',
            url: '/hodView',
            views: {
                '@': {
                    template: hodViewTpl,
                    controller: hodViewCtrl,
                    controllerAs: 'hodView'
                }
            }
        })
}); */

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.class_box{height:30px;padding:5px;border-radius:2px;display:flex;justify-content:center;align-items:center;-webkit-box-shadow:3px 3px 2px 0 rgba(0,0,0,.36);-moz-box-shadow:3px 3px 2px 0 rgba(0,0,0,.36);box-shadow:3px 3px 2px 0 rgba(0,0,0,.36)}</style> <md-backdrop style=z-index:60!important;position:fixed ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner alt=Loader src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=box_3> <div flex=100 layout=row layout-align=space-around class=boxListing ng-model=boxListing> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <div flex=100 layout=row> <md-input-container flex=50 style=padding-right:20px> <label>Select Session</label> <md-select ng-model=userMgt.session_id ng-disabled=hideSelect> <md-option value={{sesName._id}} ng-click=getCuriculumLst(sesName._id) ng-repeat=\"sesName in sessionLst\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=50> <label>Select Curriculum</label> <md-select ng-model=userMgt.curriculum_id ng-disabled=hideSelect> <md-option value={{curName._id}} ng-click=getAllPhases(curName._id) ng-repeat=\"curName in curriculumLst\">{{curName.name}}</md-option> </md-select> </md-input-container> </div> </div> </div> <div flex=100 layout=row layout-align=space-around class=boxListing ng-model=boxListing> <div flex layout=row layout-padding> <div flex=100 layout=row> <md-input-container flex=100> <label>Select Phases</label> <md-select ng-model=userMgt.phases ng-disabled=hideSelect multiple=true ng-change=showClassInfo(userMgt.phases)> <md-option ng-disabled=loading value={{phase._id}} ng-repeat=\"phase in Phases\"> {{phase.name}}</md-option> </md-select> </md-input-container> </div> </div> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <div> <p ng-if=\"selected_classes.length > 0\"> Classes Associated with: <span style=color:green> <span ng-repeat=\"phase in selected_phase\"> {{phase.name}}<span ng-if=!$last>, </span> </span> </span> Phase </p> <div flex=100 layout=row layout-wrap> <div style=\"margin:10px 20px\" class=class_box ng-repeat=\"class in selected_classes\"><span>Class : {{class}}</span></div> </div> </div> </div> </div> <div flex=100 layout=row layout-align=space-around class=boxListing ng-model=boxListing> <div flex layout=row layout-padding> <div flex=100 layout=row> <md-input-container flex=100> <label>Select Subject</label> <md-select ng-model=userMgt.subjects multiple=true ng-change=getData()> <md-option ng-disabled=loading ng-selected=subjName.is_selected value={{subjName._id}} ng-repeat=\"subjName in subjectLst track by $index\"> {{subjName.name}}</md-option> </md-select> </md-input-container> </div> </div> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <md-button ng-if=showAddBtn class=\"md-raised md-primary md-hue-2 newButton\" ng-click=updateDepartment() style=margin-top:20px> ADD</md-button> </div> </div> </div> <div ng-if=roleHOD flex> <div style=\"max-height:400px;overflow-y:auto;border:1px solid #ddd\"> <div ng-if=\"hodPersonArr.length >=1\"> <table class=table> <tr> <th class=title>Session</th> <th class=title>Curriculum</th> <th class=title>Department</th> <th class=title>Phase</th> <th class=title>Action</th> </tr> <tr ng-repeat=\"hodData in hodPersonArr track by $index\"> <td style=padding-left:10px>{{hodData.hod_class_details.session.name}}</td> <td style=padding-left:10px>{{hodData.hod_class_details.curriculum.name}}</td> <td style=padding-left:10px>{{hodData.hod_class_details.subject.name}}</td> <td style=padding-left:10px>{{hodData.hod_class_details.phase.name}}</td> <td class=hand style=padding-left:10px> <img src=" + __webpack_require__(79) + " title=Delete class=\"result-icon-button hand\" ng-click=deleteSubject(hodData)></td> </tr> </table> </div> </div> </div>";

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: hodViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var HodViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$stateParams", "localStorageService", "authService", "profileCons", function HodViewController($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, HodViewController);

    $scope.loading = false;
    var self = this;
    var selectedUserId = $stateParams.person_id;
    var addedSessionsID = [];
    $scope.showSessionName = [];
    $scope.showCurriculumName = [];
    $scope.userMgt = {};
    $scope.selected_classes = [];
    $scope.selected_phase = [];
    $scope.selected_curriculum = {};
    $scope.selected_session = {};
    $scope.allClasses = [];
    $scope.firstLoad = true; //flag to check the page is loaded first or not
    $scope.showAddBtn = false;

    var module_privileges = localStorageService.get("feature_privileges");

    $scope.userAccess = {};
    var features = module_privileges;
    var userAccessJson = _.filter(features, function (feature) {
        return feature.module_state == "userEndorsement";
    });
    if (userAccessJson) {
        _.each(userAccessJson, function (feature) {
            var user_access = {};
            _.each(feature.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userAccess = user_access;
        });
    } else {
        $state.go("dashboard");
    }

    self.myStudents = [];
    if (!selectedUserId) {
        $state.go('profileSetting');
    }

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get endorsed department
     **/
    var hodEndorsedDept = function hodEndorsedDept() {
        try {
            $scope.roleHOD = true;
            $scope.loading = true;
            authService.callAPI(profileCons.API_HOD_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
                if (response.result && response.result.data && response.result.data.departments) {
                    $scope.hodPersonArr = response.result.data.departments;
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error("Failed to fetch data.");
                }
                $scope.loading = false;
                $scope.$apply();
            });
        } catch (error) {
            toastr.error("Failed to Fetch data.");
            $scope.loading = false;
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load session list
     **/
    var sessionDet = function sessionDet() {
        authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.sessionLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load curriculum list
     **/
    var curriculumDet = function curriculumDet(session_id) {
        $scope.loading = true;
        try {
            authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, function (response) {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.curriculumLst = response.result.data.details;
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
                $scope.loading = false;
                $scope.$apply();
            });
        } catch (error) {
            console.log(error);
            $scope.loading = false;
            $scope.$apply();
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load subject list
     **/
    var departmentDet = function departmentDet(curriculum_id) {
        try {
            $scope.loading = true;
            authService.callAPI(profileCons.API_GET_SUBJECTS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id + "/" + selectedUserId, "GET", {}, function (response) {
                //console.log(response)
                if (response.result && response.result.data && response.result.data.details) {
                    $scope.subjectLst = response.result.data.details;
                    if ($scope.subjectLst && $scope.subjectLst.length) {
                        $scope.subjectLst = $scope.subjectLst.map(function (eachSub) {
                            eachSub.is_selected = false;
                            return eachSub;
                        });
                    }
                    // Filter out duplicate objects in the $scope.subjectLst array based on the _id property.
                    // The filter checks if the current item's index matches the first occurrence of an item with the same _id.
                    // This ensures that only unique objects remain in the array.
                    var unique_subject_list = [];
                    try {
                        unique_subject_list = Array.isArray($scope.subjectLst) ? $scope.subjectLst.filter(function (current_item, index_of_current_item, subjectList) {
                            return index_of_current_item === subjectList.findIndex(function (each_subject_obj) {
                                return current_item._id.toString() === each_subject_obj._id.toString();
                            });
                        }) : [];
                        $scope.subjectLst = unique_subject_list;
                    } catch (error) {
                        console.log("Error occured while removing duplicates : hodViewController: /profileSetting/controllers/hodViewController.js  : line 151");
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                    updateSubjectDropdown();
                }
                $scope.loading = false;
                $scope.$apply();
            });
        } catch (error) {
            toastr.error("Error getting Subjects");
            $scope.loading = false;
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: update department
     **/
    var updateDepartment = function updateDepartment(academic_obj, user_id) {
        try {
            $scope.loading = true;
            var obj = {
                curriculum_id: academic_obj.curriculum_id,
                session_id: academic_obj.session_id,
                school_id: localStorageService.get('school_id'),
                subjects: academic_obj.subjects,
                user_id: user_id,
                phases: $scope.selected_phase
            };
            authService.callAPI(profileCons.API_UPDATE_DEPARTMENT, "POST", obj, function (response) {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    toastr.success("Updated successfully.");
                } else {
                    toastr.error("Update Failed.");
                }
                $scope.loading = false;
                $scope.firstLoad = false;
                $scope.userMgt = {};
                hodEndorsedDept();
                $scope.showAddBtn = false;
                $scope.curriculumLst = [];
                $scope.subjectLst = [];
                $scope.selected_classes = [];
                $scope.selected_phase = [];
                $scope.Phases = [];
                $scope.$apply();
            });
        } catch (error) {
            toastr.error("Update Failed .");
            $scope.loading = false;
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Remove department
     **/
    var removeDepartment = function removeDepartment(user_id, academic_obj) {
        try {
            $scope.loading = true;
            var obj = {
                curriculum_id: academic_obj.hod_class_details.curriculum._id,
                session_id: academic_obj.hod_class_details.session._id,
                subject_id: academic_obj.hod_class_details.subject._id,
                phase_id: academic_obj.hod_class_details.phase._id,

                user_id: user_id
            };
            authService.callAPI(profileCons.API_DELETE_DEPARTMENT, "POST", obj, function (response) {
                if (response.result && response.result.status && response.result.status.code == 200) {
                    hodEndorsedDept();
                    toastr.success("Deleted successfully.");
                } else {
                    toastr.error("Delete Failed.");
                }
                $scope.loading = false;
                $scope.$apply();
            });
        } catch (error) {
            toastr.success("Failed to Delete.");
            $scope.loading = false;
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Initialization
     **/
    this.$onInit = function () {
        hodEndorsedDept();
        sessionDet();
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load curriculum list
     **/
    $scope.getCuriculumLst = function (session_id) {
        $scope.selected_session = session_id;
        curriculumDet(session_id);
        if ($scope.userMgt && $scope.userMgt.curriculum_id) {
            $scope.userMgt.curriculum_id = null;
        }
        if ($scope.userMgt && $scope.userMgt.subjects) {
            $scope.userMgt.subjects = null;
            $scope.subjectLst = [];
            if (!$scope.subjectLst.length) {
                $scope.showAddBtn = false;
            }
        }

        if ($scope.userMgt.phases && $scope.userMgt.phases) {
            $scope.userMgt.phases = null;
            $scope.Phases = [];
        }
        if ($scope.selected_phase.length > 0) {
            $scope.selected_phase = [];
            $scope.selected_classes = [];
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load subject list
     **/
    // $scope.getSubjectsLst = (curriculum_id) => {
    //     departmentDet(curriculum_id)
    // }

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to update department
     **/
    $scope.updateDepartment = function () {
        $scope.userMgt.school_id = localStorageService.get('school_id');
        if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
            if ($scope.userMgt.subjects && $scope.userMgt.subjects.length > 0) {
                updateDepartment($scope.userMgt, selectedUserId);
            } else {
                toastr.error("Please select atleast one subject");
            }
        } else {
            if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                toastr.error("Please select all necessary fields");
            } else {
                if ($scope.userMgt.curriculum_id === undefined) {
                    toastr.error("Please select curriculum");
                }
                if ($scope.userMgt.session_id === undefined) {
                    toastr.error("Please select session");
                }
            }
        }
    };

    function updateSubjectDropdown() {
        try {
            var hodPersonArr = $scope.hodPersonArr;
            var selected_session = $scope.userMgt.session_id;
            var selected_curriculum = $scope.userMgt.curriculum_id;
            var used_subjects = [];
            var selectedPhaseList = $scope.selected_phase.map(function (eachPhase) {
                return eachPhase._id;
            });
            if (selected_session && selected_curriculum) {
                var userData = hodPersonArr;
                userData.forEach(function (data) {
                    var user = data.hod_class_details;
                    if (user) {
                        if (user.curriculum._id === selected_curriculum && user.session._id === selected_session && selectedPhaseList.includes(user.phase._id)) {
                            used_subjects.push(user.subject._id);
                        }
                    }
                });
                var subjectLst = $scope.subjectLst;
                subjectLst.forEach(function (sub) {
                    if (used_subjects.includes(sub._id)) {
                        sub.is_selected = true;
                    }
                });
            }
        } catch (error) {
            toastr.error("Error in fetching user info");
        }
    }
    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to set visibility of add btn
     **/
    $scope.getData = function () {
        $scope.showAddBtn = true;
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to conform delete department
     **/
    $scope.deleteSubject = function (department) {
        var selectedUserId = $stateParams.person_id;
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to remove ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            removeDepartment(selectedUserId, department);
        }, function () {});
    };
    /**
     * @Author: Jayasurya
     * @Date: 2024-12-05
     * @Desc: Get phases based on the curriculum and session , get all classes
    **/
    $scope.getAllPhases = function (curriculum) {
        $scope.loading = true;
        if ($scope.userMgt && $scope.userMgt.subjects) {
            $scope.userMgt.subjects = null;
            $scope.subjectLst = [];
            if (!$scope.subjectLst.length) {
                $scope.showAddBtn = false;
            }
        }

        if ($scope.userMgt.phases && $scope.userMgt.phases) {
            $scope.userMgt.phases = null;
        }
        if ($scope.selected_phase.length > 0) {
            $scope.selected_phase = [];
            $scope.selected_classes = [];
        }
        $scope.selected_curriculum = curriculum;
        var url = profileCons.API_GET_PHASES + "/" + localStorageService.get('school_id') + '/' + $scope.selected_session + "/" + $scope.selected_curriculum;
        authService.callAPI(url, 'GET', {}, function (res) {
            try {
                if (res.result && res.result.data.Phases) {
                    $scope.Phases = res.result.data.Phases.list;
                    $scope.allClasses = res.result.data.Classes;
                }
                $scope.loading = false;
            } catch (error) {
                console.log(error);
                $scope.loading = false;
            }

            $scope.$apply();
        });
    };
    /** 
        * Filter the classes based on the based on the phase selected
        * 
    **/

    $scope.toTitleCase = function (str) {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    /**
     * @Author: Jayasurya
     * @Date: 2024-12-27
     * @Desc: Show classes based on the phases selected
    **/
    $scope.showClassInfo = function (selected_phase_list) {
        if ($scope.userMgt && $scope.userMgt.subjects) {
            $scope.userMgt.subjects = null;
            $scope.subjectLst = [];
            if (!$scope.subjectLst.length) {
                $scope.showAddBtn = false;
            }
        }
        if ($scope.selected_phase.length > 0) {
            $scope.selected_phase = [];
            $scope.selected_classes = [];
        }
        $scope.selected_phase = $scope.Phases.filter(function (eachPhase) {
            return selected_phase_list.includes(eachPhase._id);
        });
        if ($scope.selected_phase && $scope.selected_phase.length) {
            departmentDet($scope.selected_curriculum);
            try {
                // Extract class IDs from the selected phases array and flatten them into a single array
                var class_ids_seleted_phases = $scope.selected_phase.map(function (classArray) {
                    return classArray.class_ids;
                }).flat();
                // Filter all classes to include only those matching the selected class IDs
                $scope.selected_classes = Object.values($scope.allClasses).filter(function (classItem) {
                    return class_ids_seleted_phases.includes(classItem._id);
                }).map(function (classItem) {
                    // Format the class name to title case if it contains more than one word, otherwise keep it unchanged
                    return classItem.name.split(" ").length > 1 ? $scope.toTitleCase(classItem.name) : classItem.name;
                });
            } catch (error) {
                toastr.error("Some error occured");
                console.log(error);
            }
        }
    };
}];

exports.default = HodViewController;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hosView = __webpack_require__(970);

var _hosView2 = _interopRequireDefault(_hosView);

__webpack_require__(36);

var _hosViewController = __webpack_require__(971);

var _hosViewController2 = _interopRequireDefault(_hosViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'hosView';
var _module = angular.module("app.hosView", []).component(name, {
    template: _hosView2.default,
    controllerAs: name,
    controller: _hosViewController2.default
}).controller('hosViewCtrl', _hosViewController2.default);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('hosView', {
            parent: 'app',
            url: '/hosView',
            views: {
                '@': {
                    template: hosViewTpl,
                    controller: hosViewCtrl,
                    controllerAs: 'hosView'
                }
            }
        })
}); */

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div ng-if=roleHOS class=\"box_2 roleSUPERVISOR\"> <div flex=100 layout=row layout-align=space-around class=boxListing ng-model=boxListing> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <md-input-container flex=30> <label>Select Session</label> <md-select ng-model=userMgt.session_id ng-disabled=profileSettingsHosCtrl.hideSelect> <md-option value={{sesName._id}} ng-click=getCuriculumLst(sesName._id) ng-repeat=\"sesName in sessionLst\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=30> <label>Select Curriculum</label> <md-select ng-model=userMgt.curriculum_id ng-disabled=profileSettingsHosCtrl.hideSelect> <md-option value={{curName._id}} ng-click=getClassLst(curName._id) ng-repeat=\"curName in curriculumLst\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=30> <label>Select Class</label> <md-select ng-model=userMgt.classes ng-disabled=profileSettingsHosCtrl.hideSelect multiple=true> <md-option value={{clsName._id}} ng-click=getData() ng-repeat=\"clsName in clsLst\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-button ng-if=showAddBtn class=\"md-raised md-primary md-hue-2 newButton\" ng-click=updateSection() style=margin-top:20px> ADD </md-button> </div> </div> </div> <div ng-if=roleHOS class=roleSUPERVISOR> <div ng-if=\"hosPersonArr.length >=1\"> <table class=table> <tr> <th class=title>Session</th> <th class=title>Curriculum</th> <th class=title>Class</th> <th class=title>Action</th> </tr> <tr ng-repeat=\"hosData in hosPersonArr track by $index\"> <td style=padding-left:10px>{{hosData.session_name}}</td> <td style=padding-left:10px>{{hosData.curriculum_name}}</td> <td style=padding-left:10px>{{hosData.class_name}}</td> <td class=hand style=padding-left:10px ng-click=\"deleteClass($event, hosData)\"> <img src=" + __webpack_require__(79) + " class=\"result-icon-button hand\"></td> </tr> </table> </div> </div>";

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: hosViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var HosViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$stateParams", "localStorageService", "authService", "profileCons", function HosViewController($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, HosViewController);

    var self = this;
    var selectedUserId = $stateParams.person_id;
    var addedSessionsID = [];
    $scope.showSessionName = [];
    $scope.showCurriculumName = [];
    $scope.userMgt = {};
    $scope.firstLoad = true; //flag to check the page is loaded first or not

    var module_privileges = localStorageService.get("feature_privileges");

    $scope.userAccess = {};
    var features = module_privileges;
    var userAccessJson = _.filter(features, function (feature) {
        return feature.module_state == "userEndorsement";
    });
    if (userAccessJson) {
        _.each(userAccessJson, function (feature) {
            var user_access = {};
            _.each(feature.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userAccess = user_access;
        });
    } else {
        $state.go("dashboard");
    }

    self.myStudents = [];
    if (!selectedUserId) {
        $state.go('profileSetting');
    }

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Gte endorsed sections
     **/
    var hosEndorsedDept = function hosEndorsedDept() {
        $scope.roleHOS = true;
        authService.callAPI(profileCons.API_HOS_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.sections) {
                $scope.hosPersonArr = response.result.data.sections;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load session list
     **/
    var sessionDet = function sessionDet() {
        authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.sessionLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load curriculum list
     **/
    var curriculumDet = function curriculumDet(session_id) {
        authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.curriculumLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load class list
     **/
    var classDet = function classDet(curriculum_id) {
        authService.callAPI(profileCons.API_GET_CLASS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.clsLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Update section(class)
     **/
    var updateSection = function updateSection(academic_obj, user_id) {

        var obj = {
            curriculum_id: academic_obj.curriculum_id,
            session_id: academic_obj.session_id,
            school_id: localStorageService.get('school_id'),
            classes: academic_obj.classes,
            id: user_id
        };

        authService.callAPI(profileCons.API_UPDATE_SECTION, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                toastr.success("Updated successfully!");
            }

            $scope.firstLoad = false;
            $scope.userMgt = {};
            hosEndorsedDept();
            $scope.showAddBtn = false;
            $scope.curriculumLst = [];
            $scope.clsLst = [];
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To remove section
     **/
    var removeSection = function removeSection(user_id, academic_obj) {
        var obj = {
            curriculum_id: academic_obj.curriculum_id,
            session_id: academic_obj.session_id,
            class_id: academic_obj.class_id,
            id: user_id
        };
        authService.callAPI(profileCons.API_DELETE_SECTION, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                hosEndorsedDept();
                toastr.success("Deleted successfully!");
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Initialization
     **/
    this.$onInit = function () {
        hosEndorsedDept();
        sessionDet();
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load curriculum list
     **/
    $scope.getCuriculumLst = function (session_id) {
        curriculumDet(session_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load class list
     **/
    $scope.getClassLst = function (curriculum_id) {
        classDet(curriculum_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to set visibility of add btn
     **/
    $scope.getData = function () {
        $scope.showAddBtn = true;
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Update section
     **/
    $scope.updateSection = function () {
        $scope.userMgt.school_id = localStorageService.get('school_id');

        if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
            if ($scope.userMgt.classes && $scope.userMgt.classes.length > 0) {
                updateSection($scope.userMgt, selectedUserId);
            } else {
                toastr.error("Please select atleast one class");
            }
        } else {
            if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                toastr.error("Please select all necessary fields");
            } else {
                if ($scope.userMgt.curriculum_id === undefined) {
                    toastr.error("Please select curriculum");
                }
                if ($scope.userMgt.session_id === undefined) {
                    toastr.error("Please select session");
                }
            }
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to conform delete section
     **/
    $scope.deleteClass = function (event, section) {
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to remove ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            removeSection(selectedUserId, section);
        }, function () {});
    };
}];

exports.default = HosViewController;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _parentView = __webpack_require__(973);

var _parentView2 = _interopRequireDefault(_parentView);

__webpack_require__(36);

var _parentViewController = __webpack_require__(974);

var _parentViewController2 = _interopRequireDefault(_parentViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'parentView';
var _module = angular.module("app.parentView", []).component(name, {
    template: _parentView2.default,
    controllerAs: name,
    controller: _parentViewController2.default
}).controller('parentViewCtrl', _parentViewController2.default);

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('parentView', {
            parent: 'app',
            url: '/parentView',
            views: {
                '@': {
                    template: parentViewTpl,
                    controller: parentViewCtrl,
                    controllerAs: 'parentView'
                }
            }
        })
}); */

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=box_4> <div flex=100 layout=row layout-align=space-around class=boxListingPar ng-model=boxListing> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <md-input-container flex> <label>Session</label> <md-select ng-model=userMgt.session_id ng-disabled=hideSelect> <md-option value={{sesName._id}} ng-click=getCuriculumLst(sesName._id) ng-repeat=\"sesName in sessionLst\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex> <label>Curriculum</label> <md-select ng-model=userMgt.curriculum_id ng-disabled=hideSelect> <md-option value={{curName._id}} ng-click=\"getClassLst(curName._id,'parent')\" ng-repeat=\"curName in curriculumLst\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex> <label>Class</label> <md-select ng-model=userMgt.class_id ng-disabled=hideSelect> <md-option value={{clsName._id}} ng-click=getBatchLst(clsName._id) ng-repeat=\"clsName in clsLst\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex> <label>Batch</label> <md-select ng-model=userMgt.batch_id ng-disabled=hideSelect> <md-option value={{batch._id}} ng-click=getStudentLst(batch._id) ng-repeat=\"batch in batchLst\"> {{batch.name}}</md-option> </md-select> </md-input-container> <md-input-container flex> <label>Select Students</label> <md-select ng-model=userMgt.student_id multiple=true> <md-option ng-click=getRelationBox(student._id) ng-repeat=\"student in studentLst\" ng-value=student._id>{{student.name}} </md-option> </md-select> </md-input-container> <md-input-container flex ng-if=getRelationDrp> <label>Relation</label> <md-select ng-model=userMgt.relation> <md-option value=Father ng-click=\"getRelation('Father')\">Father</md-option> <md-option value=Mother ng-click=\"getRelation('Mother')\">Mother</md-option> </md-select> </md-input-container> </div> </div> <div layout=column> <div layout-gt-sm=row ng-if=\"relationType !='none'\"> <md-input-container class=md-block flex-gt-sm ng-if=\"relationType==='Guardian'\"> <label>Father Name</label> <input name=userMgt.fathername ng-model=userMgt.fathername /> </md-input-container> <div flex=5 hide-xs hide-sm> </div> <md-input-container class=md-block flex-gt-sm ng-if=\"relationType==='Guardian'\"> <label>Mother Name</label> <input name=userMgt.mothername ng-model=userMgt.mothername /> </md-input-container> <md-input-container class=md-block flex-gt-sm ng-if=\"relationType !='Guardian'\"> <label>Spouse Name</label> <input name=userMgt.spousename ng-model=userMgt.spousename /> </md-input-container> </div> </div> <md-button ng-if=showParentSaveBtn class=\"md-raised md-primary md-hue-2\" ng-click=saveChild()> ADD</md-button> </div> <div ng-if=rolePARENT layout-xs=column layout-sm=column flex-xs flex-sm> <div ng-if=\"childPersonArr.length >=1\"> <table class=table> <tr> <th class=title>Session</th> <th class=title>Curriculum</th> <th class=title>Class</th> <th class=title>Batch</th> <th class=title>Student</th> <th class=title>Action</th> </tr> <tr ng-repeat=\"eachUser in childPersonArr track by $index\"> <td style=padding-left:10px>{{eachUser.session_name}}</td> <td style=padding-left:10px>{{eachUser.curriculum_name}}</td> <td style=padding-left:10px>{{eachUser.class_name}}</td> <td style=padding-left:10px>{{eachUser.batch_name}} </td> <td style=padding-left:10px>{{eachUser.child_name}}</td> <td class=hand style=padding-left:10px> <img src=" + __webpack_require__(79) + " class=\"result-icon-button hand\" ng-click=deleteChild(eachUser)></td> </tr> </table> </div> <md-divider></md-divider> <md-divider></md-divider> </div>";

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: parentViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ParentViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$stateParams", "localStorageService", "authService", "profileCons", function ParentViewController($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, ParentViewController);

    var self = this;
    var selectedUserId = $stateParams.person_id;
    var addedSessionsID = [];
    $scope.showSessionName = [];
    $scope.showCurriculumName = [];
    $scope.userMgt = {};
    $scope.firstLoad = true; //flag to check the page is loaded first or not4 occurences
    $scope.relationType = 'none'; //to check the relation type(Father,Mother or Guardian)
    var module_privileges = localStorageService.get("feature_privileges");

    $scope.userAccess = {};
    var features = module_privileges;
    var userAccessJson = _.filter(features, function (feature) {
        return feature.module_state == "userEndorsement";
    });
    if (userAccessJson) {
        _.each(userAccessJson, function (feature) {
            var user_access = {};
            _.each(feature.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userAccess = user_access;
        });
    }

    self.myStudents = [];
    if (!selectedUserId) {
        $state.go('profileSetting');
    }

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get endorsed child list
     **/
    var getChild = function getChild() {
        $scope.rolePARENT = true;
        authService.callAPI(profileCons.API_PARENT_CHILD_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.childPersonArr = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Gte session list
     **/
    var sessionDet = function sessionDet() {
        authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.sessionLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Gte curriculum list
     **/
    var curriculumDet = function curriculumDet(session_id) {
        authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.curriculumLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get class list
     **/
    var classDet = function classDet(curriculum_id) {
        authService.callAPI(profileCons.API_GET_ALL_CLASS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id, "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.clsLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Gte batch list
     **/
    var batchDet = function batchDet(class_id) {
        authService.callAPI(profileCons.API_GET_BATCH + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + $scope.userMgt.curriculum_id + "/" + class_id, "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.batchLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get unassigned  chils list
     **/
    var studentDet = function studentDet(batch_id) {
        authService.callAPI(profileCons.API_GET_STUDENTS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + $scope.userMgt.curriculum_id + "/" + $scope.userMgt.class_id + "/" + batch_id, "GET", {}, function (response) {
            console.log(response);
            if (response.result && response.result.data && response.result.data.details) {
                $scope.studentLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To update child data
     **/
    var updateChild = function updateChild(academic_obj, user_id) {

        var parent_obj = {
            "email": undefined,
            "relation": academic_obj.relation,
            "mapped": true
        };

        var details_obj = {};
        if (academic_obj.relation === 'Father' || academic_obj.relation === 'Mother') {
            details_obj.spouse_name = academic_obj.spousename;
        }
        if (academic_obj.relation === 'Guardian') {
            details_obj.father_name = academic_obj.fathername;
            details_obj.mother_name = academic_obj.mothername;
        }

        var obj = {
            'child_id': academic_obj.student_id,
            'id': user_id,
            'parent_obj': parent_obj,
            'details_obj': details_obj
        };

        authService.callAPI(profileCons.API_UPDATE_CHILD, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                toastr.success("Updated successfully!");
            }

            $scope.firstLoad = false;
            $scope.userMgt = {};
            getChild();
            $scope.showParentSaveBtn = false;
            $scope.curriculumLst = [];
            $scope.clsLst = [];
            $scope.batchLst = [];
            $scope.studentLst = [];
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To remove child
     **/
    var removeChild = function removeChild(user_id, academic_obj) {
        var obj = {
            child_id: academic_obj._id,
            id: user_id
        };
        authService.callAPI(profileCons.API_DELETE_CHILD, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                getChild();
                toastr.success("Deleted successfully!");
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Intialization
     **/
    this.$onInit = function () {
        getChild();
        sessionDet();
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load curriculum list
     **/
    $scope.getCuriculumLst = function (session_id) {
        curriculumDet(session_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load class list
     **/
    $scope.getClassLst = function (curriculum_id) {
        classDet(curriculum_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load batch list
     **/
    $scope.getBatchLst = function (session_id) {
        batchDet(session_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load unassigned child list
     **/
    $scope.getStudentLst = function (curriculum_id) {
        studentDet(curriculum_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To add child 
     **/
    $scope.saveChild = function () {
        $scope.userMgt.school_id = localStorageService.get('school_id');
        if (!$scope.userMgt.spousename) {
            toastr.error("Please enter spouse name !");
            return false;
        }
        if ($scope.userMgt.session_id !== undefined && $scope.userMgt.curriculum_id !== undefined && $scope.userMgt.class_id !== undefined && $scope.userMgt.batch_id !== undefined) {
            if ($scope.userMgt.student_id && $scope.userMgt.student_id.length > 0) {
                updateChild($scope.userMgt, selectedUserId);
            } else {
                toastr.error("Please select atleast one student");
            }
        } else {
            if ($scope.userMgt.session_id === undefined && $scope.userMgt.curriculum_id === undefined && $scope.userMgt.class_id === undefined && $scope.userMgt.batch_id === undefined) {
                toastr.error("Please select all necessary fields");
            } else {
                if ($scope.userMgt.session_id === undefined) {
                    toastr.error("Please select session");
                }
                if ($scope.userMgt.curriculum_id === undefined) {
                    toastr.error("Please select curriculum");
                }
                if ($scope.userMgt.class_id === undefined) {
                    toastr.error("Please select class");
                }
                if ($scope.userMgt.batch_id === undefined) {
                    toastr.error("Please select batch");
                }
            }
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Get relation data
     **/
    $scope.getRelationBox = function (studIds) {
        if (studIds.length >= 1) {
            $scope.getRelationDrp = true;
            if ($scope.isChildExist) {
                $scope.showParentSaveBtn = true;
            }
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Chanage handler to set relation
     **/
    $scope.getRelation = function (rel) {
        $scope.relationType = rel;
        $scope.showParentSaveBtn = true;
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to remove child
     **/
    $scope.deleteChild = function (child) {
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to remove ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            removeChild(selectedUserId, child);
        }, function () {});
    };
}];

exports.default = ParentViewController;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _profileView = __webpack_require__(117);

var _profileView2 = _interopRequireDefault(_profileView);

__webpack_require__(36);

var _profileViewController = __webpack_require__(976);

var _profileViewController2 = _interopRequireDefault(_profileViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var profilView = "profileViewPage";
var _module = angular.module('app.profileView', [
    //import modules
]).component(profilView, {
    templateUrl: _profileView2.default,
    controllerAs: "profileViewCtrls",
    controller: _profileViewController2.default
}).controller('profileViewCtrl', _profileViewController2.default);

_module.constant("profileCons", {
    API_GET_PROFILE_SETTING_ROLES: "/v0/profile/settings/role/list/",
    API_GET_PROFILE_USERS: "/v0/profile/user/role/list/",
    API_USER_PERSONAL: "/v0/profile/user/personal/",
    API_USER_MODULES_FEATURE: "/v0/profile/modules_feature_role/",
    API_TEACHER_ENDORSE_DETAILS: "/v0/profile/details/list/",
    API_HOD_ENDORSE_DETAILS: "/v0/profile/departments/list/",
    API_HOS_ENDORSE_DETAILS: "/v0/profile/sections/list/",
    API_PARENT_CHILD_DETAILS: "/v0/profile/child/list/",
    API_GET_SESSION: "/v0/profile/dropdown/session/detail/",
    API_GET_CURRICULUM: "/v0/profile/dropdown/curriculum/detail/",
    API_GET_ALL_CLASS: "/v0/profile/dropdown/allclass/detail/",
    API_GET_CLASS: "/v0/profile/dropdown/class/detail/",
    API_GET_BATCH: "/v0/profile/dropdown/batch/detail/",
    API_GET_SUBJECTS: "/v0/profile/dropdown/department/detail/",
    API_GET_STUDENTS: "/v0/profile/dropdown/student/detail/",
    API_UPDATE_DEPARTMENT: "/v0/profile/hod/details/save",
    API_DELETE_DEPARTMENT: "/v0/profile/hod/details/delete",
    API_UPDATE_SECTION: "/v0/profile/hos/details/save",
    API_DELETE_SECTION: "/v0/profile/hos/details/delete",
    API_UPDATE_CHILD: "/v0/profile/parent/details/save",
    API_DELETE_CHILD: "/v0/profile/parent/details/delete",
    API_UPDATE_WORKING_HRS: "/v0/profile/update-working-det",
    API_GET_PHASES: "/v0/profile/list_phases_BySchool"
});

/* module.config(function($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider
        .state('profileSetting', {
            url: '/profile-setting',
            views: {
                '@': {
                    template: profileSettingTpl,
                    controller: profileSettingCtrl,
                    controllerAs: 'userProfileCtrl'
                }
            }
        })
        .state('profileData', {
            url: '/profile-view/:person_id',
            views: {
                '@': {
                    template: profileViewTpl,
                    controller: profileViewCtrl,
                    controllerAs: 'profileViewCtrls'
                }
            }
        })

}); */

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: profileViewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Jeevanantham Nagarathinam
 * -----
 * Last Modified: 2018-12-05
 * Modified By: Jeevanantham Nagarathinam
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ProfileViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$stateParams", "localStorageService", "authService", "profileCons", function ProfileViewController($state, $rootScope, $scope, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, ProfileViewController);

    //CurrentPage.setTitle("Profile Settings")
    var selectedUserId = $stateParams.person_id;

    var profileViewCtrls = this;
    profileViewCtrls.modeStatus = true;
    profileViewCtrls.editBtn = true;
    profileViewCtrls.profileData = true;
    profileViewCtrls.profileDataEdit = false;
    profileViewCtrls.getRelationDrp = false;

    $scope.firstLoad = true; //flag to check the page is loaded first or not
    if (!selectedUserId) {
        $state.go('profileSetting', {}, {
            reload: true
        });
    }

    var subsUsers = undefined;

    var userDetails = function userDetails() {
        authService.callAPI(profileCons.API_USER_PERSONAL + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    profileViewCtrls.eachPerson = response.result.data.details;
                    fetchFunction();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                profileViewCtrls.eachPerson = undefined;
                $scope.isLoading = false;
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    var getRoles = function getRoles() {
        authService.callAPI(profileCons.API_GET_PROFILE_SETTING_ROLES + localStorageService.get('school_id'), "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    $scope.rolesList = response.result.data.details;
                    userDetails();
                } catch (ex) {
                    console.log(ex);
                }
            } else {
                $scope.rolesList = [];
                $scope.isLoading = false;
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    var getUserModules = function getUserModules() {

        authService.callAPI(profileCons.API_USER_MODULES_FEATURE + localStorageService.get('school_id') + "/" + "roleSetting", "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                try {
                    var i;

                    (function () {
                        var moduleDetails = response.result.data.details;
                        //console.log(result)
                        if (moduleDetails && moduleDetails.feature_role) {
                            for (i = moduleDetails.feature_role.length - 1; i >= 0; i--) {
                                var findRole = _.find(profileViewCtrls.eachPerson.role_ids, function (role) {
                                    return role == moduleDetails.feature_role[i].role_id;
                                });
                                //console.log(findRole)
                                if (findRole != undefined) {
                                    if (moduleDetails.feature_role[i].f_id == "hodComponent") {
                                        $scope.roleHOD = true;
                                    } else if (moduleDetails.feature_role[i].f_id == "hosComponent") {
                                        $scope.roleHOS = true;
                                    } else if (moduleDetails.feature_role[i].f_id == "parentComponent") {
                                        $scope.rolePARENT = true;
                                    } else if (moduleDetails.feature_role[i].f_id == "teacherComponent") {
                                        $scope.roleTeacher = true;
                                    } else if (moduleDetails.feature_role[i].f_id == "supervisorComponent") {
                                        $scope.roleSupervisor = true;
                                    }
                                }
                            }
                        }
                        _.defer(function () {
                            $scope.$apply();
                        });
                    })();
                } catch (ex) {
                    console.log(ex);
                }
            }
        });
    };

    var fetchFunction = function fetchFunction() {
        if (!profileViewCtrls.eachPerson) {
            $state.go('profileSetting');
        }
        var schoolDataNew = undefined;
        if (localStorageService.get('school_id')) {
            schoolDataNew = localStorageService.get('school_id');
        } else {
            schoolDataNew = localStorageService.get('school_id');
        }
        if (profileViewCtrls.eachPerson || localStorageService.get('school_id')) {
            if (profileViewCtrls.eachPerson.school_id === null || profileViewCtrls.eachPerson.school_id === undefined) {
                toastr.error("School id will not be empty.");
            }
        } else {
            toastr.error("User data not found.");
            $state.go('profileSetting');
        }

        /* profileViewCtrls.fullRoles = Settings.findOne({
            type: "role"
        }) */

        if (profileViewCtrls.eachPerson) {
            if (profileViewCtrls.eachPerson.image && profileViewCtrls.eachPerson.image.original) {
                profileViewCtrls.tempImg = FILE_UPLOAD_URL + profileViewCtrls.eachPerson.image.original;
            } else {
                profileViewCtrls.tempImg = "../../../img/header/teacher_profile1.png";
            }

            if (profileViewCtrls.eachPerson.role_ids) {

                if ($scope.rolesList) {
                    $scope.rolesList = $scope.rolesList;
                    $scope.assignedRoleNames = "";
                    _.each($scope.rolesList, function (item) {
                        if (profileViewCtrls.eachPerson.role_ids.indexOf(item._id) !== -1) {
                            $scope.assignedRoleNames += item.name + ", ";
                        }
                    });
                    $scope.assignedRoleNames = $scope.assignedRoleNames.substring(0, $scope.assignedRoleNames.length - 2);
                    $scope.rolesList = _.uniq($scope.rolesList, false, function (oneR) {
                        return oneR._id;
                    });
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
            //Get Modeules
            getUserModules();
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To check login status 
     **/
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Profile Settings";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }

        getRoles();
    };

    if ($scope.firstLoad) {
        if (!profileViewCtrls.childPersonArr) {
            profileViewCtrls.childPersonArr = [];
        }
    }

    profileViewCtrls.getRoleDetails = function (id) {
        $scope.roleType = id;
    };

    profileViewCtrls.getRelationBox = function (studIds) {
        if (studIds.length >= 1) {
            profileViewCtrls.getRelationDrp = true;
            if ($scope.isChildExist) {
                $scope.showParentSaveBtn = true;
            }
        }
    };

    $scope.relationType = 'none'; //to check the relation type(Father,Mother or Guardian)
    profileViewCtrls.getRelation = function (rel) {
        $scope.relationType = rel;
        $scope.showParentSaveBtn = true;
    };

    var validate = function validate(eachPerson) {}
    /* let pageData = UserCollection.simpleSchema().clean(eachPerson);
    UserCollection.simpleSchema().namedContext("ProfileSchema").validate(eachPerson, {
        modifier: false
    });
    let context = UserCollection.simpleSchema().namedContext("ProfileSchema");
    let errorsList = context.invalidKeys();
    let ret_val = context.invalidKeys();
    ret_val = _.map(ret_val, function(res) {
        return _.extend({
            message: context.keyErrorMessage(res.name)
        }, res);
    });
    return ret_val */


    /* profileViewCtrls.updateUser = (croppedDataUrl, basciImg) => {
        $scope.errors = {}
        let errors = validate(profileViewCtrls.eachPerson)
        if (errors.length > 0) {
            showErrors(errors)
        } else {
            if (croppedDataUrl && basciImg) {
                this.serverUrl = FILE_UPLOAD_URL + "/server-uploads"
                this.userPath = Meteor.userId() + "/basicprofile/"
                let fileObj = Upload.dataUrltoBlob(croppedDataUrl)
                uploadService.uploadCheckService(fileObj, this.serverUrl, this.userPath, function(result) {
                    if (result.url) {
                        let urlRes = result.url
                        profileViewCtrls.eachPerson.url = urlRes
                        updateUserDetails(selectedUserId)
                    }
                    if (result.progress) {
                        $scope.progressRep = result.progress
                    }
                })
            } else {
                updateUserDetails(selectedUserId)
            }
        }
    } */

    ;function updateUserDetails(selectedUserId) {
        /* Meteor.call("updateCurrentUser", profileViewCtrls.eachPerson, selectedUserId, localStorageService.get('school_id'), function(error, result) {
            if (error) {
                if (error.error) {
                    toastr.error(error.error)
                }
            } else {
                profileViewCtrls.close()
                toastr.success("Updated successfully!")
                profileViewCtrls.userMgt = '';
                profileViewCtrls.profileData = true;
                profileViewCtrls.profileDataEdit = false;
                profileViewCtrls.editBtn = true;
            }
            _.defer(function() {
                $scope.$apply();
            });
        }); */
    }

    var showErrors = function showErrors(ret_val) {
        for (var i = 0; i < ret_val.length; i++) {
            var errorMap = ret_val[i]['name'].split('.');
            // assignErrorValue global function written in lib/app.js 
            errorValidatorUtil.assignErrorValue($scope.errors, errorMap, ret_val[i]['message']);
        }
    };

    profileViewCtrls.editUser = function () {
        profileViewCtrls.modeStatus = false;
        profileViewCtrls.editBtn = false;
        profileViewCtrls.profileData = false;
        profileViewCtrls.profileDataEdit = true;
    };

    profileViewCtrls.cancelEdit = function () {
        profileViewCtrls.modeStatus = true;
        profileViewCtrls.editBtn = true;
    };

    profileViewCtrls.close = function () {
        profileViewCtrls.profileDataEdit = false;
        profileViewCtrls.profileData = true;
        profileViewCtrls.editBtn = true;
        profileViewCtrls.eachPerson = profileViewCtrls.eachPerson;
    };
}];

exports.default = ProfileViewController;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _supervisorView = __webpack_require__(978);

var _supervisorView2 = _interopRequireDefault(_supervisorView);

__webpack_require__(36);

var _supervisorViewController = __webpack_require__(979);

var _supervisorViewController2 = _interopRequireDefault(_supervisorViewController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'supervisorView';
var _module = angular.module("app.supervisorView", []).component(name, {
    template: _supervisorView2.default,
    controllerAs: name,
    controller: _supervisorViewController2.default
}).controller('supervisorViewCtrl', _supervisorViewController2.default);

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div ng-if=roleSupervisor class=\"box_2 roleSUPERVISOR\"> <div flex=100 layout=row layout-align=space-around class=boxListing ng-model=boxListing> <div flex layout=row layout-xs=column layout-sm=column flex-xs flex-sm layout-padding> <md-input-container flex=30> <label>Select Session</label> <md-select ng-model=userMgt.session_id ng-disabled=profileSettingsHosCtrl.hideSelect> <md-option value={{sesName._id}} ng-click=getCuriculumLst(sesName._id) ng-repeat=\"sesName in sessionLst\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=30> <label>Select Curriculum</label> <md-select ng-model=userMgt.curriculum_id ng-disabled=profileSettingsHosCtrl.hideSelect> <md-option value={{curName._id}} ng-click=getClassLst(curName._id) ng-repeat=\"curName in curriculumLst\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex=30> <label>Select Class</label> <md-select ng-model=userMgt.classes ng-disabled=profileSettingsHosCtrl.hideSelect multiple=true> <md-option value={{clsName._id}} ng-click=getData() ng-repeat=\"clsName in clsLst\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-button ng-if=showAddBtn class=\"md-raised md-primary md-hue-2 newButton\" ng-click=updateSection() style=margin-top:20px> ADD </md-button> </div> </div> </div> <div ng-if=roleSupervisor class=roleSupervisor> <div ng-if=\"hosPersonArr.length >=1\"> <table class=table> <tr> <th class=title>Session</th> <th class=title>Curriculum</th> <th class=title>Class</th> <th class=title>Action</th> </tr> <tr ng-repeat=\"hosData in hosPersonArr track by $index\"> <td style=padding-left:10px>{{hosData.session_name}}</td> <td style=padding-left:10px>{{hosData.curriculum_name}}</td> <td style=padding-left:10px>{{hosData.class_name}}</td> <td class=hand style=padding-left:10px ng-click=\"deleteClass($event, hosData)\"> <img src=" + __webpack_require__(79) + " class=\"result-icon-button hand\"></td> </tr> </table> </div> </div>";

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: supervisorViewController.js
 * Project: educore
 * Created Date: 2020-09-11
 * Author: varunsj
 * -----
 * Last Modified: 2020-09-11
 * Modified By: varunsj
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var supervisorViewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdDialog", "$stateParams", "localStorageService", "authService", "profileCons", function supervisorViewController($state, $rootScope, $scope, $mdDialog, $stateParams, localStorageService, authService, profileCons) {
    _classCallCheck(this, supervisorViewController);

    var self = this;
    var selectedUserId = $stateParams.person_id;
    var addedSessionsID = [];
    $scope.showSessionName = [];
    $scope.showCurriculumName = [];
    $scope.userMgt = {};
    console.log('tttttttttttttttttttttttt');
    $scope.firstLoad = true; //flag to check the page is loaded first or not

    var module_privileges = localStorageService.get("feature_privileges");

    $scope.userAccess = {};
    var features = module_privileges;
    var userAccessJson = _.filter(features, function (feature) {
        return feature.module_state == "userEndorsement";
    });
    if (userAccessJson) {
        _.each(userAccessJson, function (feature) {
            var user_access = {};
            _.each(feature.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userAccess = user_access;
        });
    } else {
        $state.go("dashboard");
    }

    self.myStudents = [];
    if (!selectedUserId) {
        $state.go('profileSetting');
    }

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Gte endorsed sections
     **/
    var hosEndorsedDept = function hosEndorsedDept() {
        $scope.roleSupervisor = true;
        authService.callAPI(profileCons.API_HOS_ENDORSE_DETAILS + localStorageService.get('school_id') + "/" + selectedUserId, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.sections) {
                $scope.hosPersonArr = response.result.data.sections;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load session list
     **/
    var sessionDet = function sessionDet() {
        authService.callAPI(profileCons.API_GET_SESSION + localStorageService.get('school_id'), "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.sessionLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load curriculum list
     **/
    var curriculumDet = function curriculumDet(session_id) {
        authService.callAPI(profileCons.API_GET_CURRICULUM + localStorageService.get('school_id') + "/" + session_id, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.curriculumLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Load class list
     **/
    var classDet = function classDet(curriculum_id) {
        authService.callAPI(profileCons.API_GET_CLASS + localStorageService.get('school_id') + "/" + $scope.userMgt.session_id + "/" + curriculum_id, "GET", {}, function (response) {
            //console.log(response)
            if (response.result && response.result.data && response.result.data.details) {
                $scope.clsLst = response.result.data.details;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Update section(class)
     **/
    var updateSection = function updateSection(academic_obj, user_id) {

        var obj = {
            curriculum_id: academic_obj.curriculum_id,
            session_id: academic_obj.session_id,
            school_id: localStorageService.get('school_id'),
            classes: academic_obj.classes,
            id: user_id,
            is_supervisor: true
        };

        authService.callAPI(profileCons.API_UPDATE_SECTION, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                toastr.success("Updated successfully!");
            }

            $scope.firstLoad = false;
            $scope.userMgt = {};
            hosEndorsedDept();
            $scope.showAddBtn = false;
            $scope.curriculumLst = [];
            $scope.clsLst = [];
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: To remove section
     **/
    var removeSection = function removeSection(user_id, academic_obj) {
        var obj = {
            curriculum_id: academic_obj.curriculum_id,
            session_id: academic_obj.session_id,
            class_id: academic_obj.class_id,
            id: user_id
        };
        authService.callAPI(profileCons.API_DELETE_SECTION, "POST", obj, function (response) {
            if (response.result && response.result.status && response.result.status.code == 200) {
                hosEndorsedDept();
                toastr.success("Deleted successfully!");
            }
        });
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Initialization
     **/
    this.$onInit = function () {
        hosEndorsedDept();
        sessionDet();
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load curriculum list
     **/
    $scope.getCuriculumLst = function (session_id) {
        curriculumDet(session_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to load class list
     **/
    $scope.getClassLst = function (curriculum_id) {
        classDet(curriculum_id);
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to set visibility of add btn
     **/
    $scope.getData = function () {
        $scope.showAddBtn = true;
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: Update section
     **/
    $scope.updateSection = function () {
        $scope.userMgt.school_id = localStorageService.get('school_id');

        if ($scope.userMgt.curriculum_id !== undefined && $scope.userMgt.session_id !== undefined) {
            if ($scope.userMgt.classes && $scope.userMgt.classes.length > 0) {
                updateSection($scope.userMgt, selectedUserId);
            } else {
                toastr.error("Please select atleast one class");
            }
        } else {
            if ($scope.userMgt.curriculum_id === undefined && $scope.userMgt.session_id === undefined) {
                toastr.error("Please select all necessary fields");
            } else {
                if ($scope.userMgt.curriculum_id === undefined) {
                    toastr.error("Please select curriculum");
                }
                if ($scope.userMgt.session_id === undefined) {
                    toastr.error("Please select session");
                }
            }
        }
    };

    /** 
     * @Author: Jeevanantham N
     * @Date: 2018-12-05
     * @Desc: call fn to conform delete section
     **/
    $scope.deleteClass = function (event, section) {
        var confirm = $mdDialog.confirm().title('').textContent('Are you sure to remove ?').targetEvent(event).ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {
            removeSection(selectedUserId, section);
        }, function () {});
    };
}];

exports.default = supervisorViewController;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _childrenComponent = __webpack_require__(981);

var _childrenComponent2 = _interopRequireDefault(_childrenComponent);

var _childrenComponentController = __webpack_require__(982);

var _childrenComponentController2 = _interopRequireDefault(_childrenComponentController);

__webpack_require__(623);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('childrenComponentModule', []).component('childrenComponent', {
  template: _childrenComponent2.default,
  controllerAs: 'childrenComponent',
  controller: _childrenComponentController2.default
}).config(["$stateProvider", function ($stateProvider) {
  'ngInject';

  $stateProvider.state('childrenComponent', {
    parent: 'app',
    url: '/children-component',
    template: '<children-component></children-component>'
  });
}]).constant('CHILDREN_COMPONENT_CONSTANTS', {
  API_GET_PARENT_DETAILS: "/v0/parent/portal/person/details/",
  API_GET_PARENT_CHILD_DETAILS: "/v0/parent/portal/child/details/"
});

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"childrenList && childrenList.length > 0 && isParent\" flex=100 md-theme=makeMeWhite layout layout-padding class=\"childMainContainer md-whiteframe-2dp\" layout-wrap style=margin-top:60px> <md-tabs flex=95 ng-if=showAllComponent md-on-deselect md-no-ink md-dynamic-height md-swipe-content no-padding> <md-tab flex=90 flex-xs=100 flex-md=33 ng-repeat=\"child in childrenList | orderBy: 'name' \" layout-padding> <md-tab-label flex> <div ng-class=\"{'floatlabels' : !child.active, 'floatlabels_active' : child.active}\" flex ng-click=saveStudentDetails(child) layout class=\"md-whiteframe-2dp bg_white padChild\"> <img flex=20 ng-src=\"{{child.image?child.image : '../../../img/images/student.png' }}\" on-error-src=../../../img/images/student.png class=\"md-card-image image_res\"> <div flex layout=column layout-align=\"start start\" class=padChildLeft> <span class=\"textColorNew childName\">{{child.name}}</span> <span class=\"textColorNew fontSize\">ADMN NO : {{child.admission_number}}</span> <span class=\"textColorNew fontSize\">{{child.curriculum}}/ {{child.session}}/ {{child.class}}/ {{child.batch}}</span> </div> </div> </md-tab-label> </md-tab> </md-tabs> <div ng-if=!showAllComponent children-list=childrenList flex=100 class=no-padding> <div ng-if=\"childrenList.length > 0 && child.active\" flex=100 ng-class=\"{'flex-25': child.aciveStudent, 'flex-100' : child.clickActive }\" layout ng-repeat=\"child in childrenList\"> <div ng-class=\"{'floatlabels' : !child.active, 'childSubContainer' : child.clickActive }\" flex=100 layout md-theme=makeMeWhite class=\"md-whiteframe-2dp childSubContainer\"> <img flex=5 ng-src=\"{{child.image ? child.image : '../../../img/images/student.png'}}\" on-error-src=../../../img/images/student.png class=md-card-image style=height:28px;padding-right:5px;padding:5px;max-width:36px> <span class=textColorSelectedChild flex>{{child.name}}</span> <div class=\"md-whiteframe-2dp hand\" layout layout-align=\"end end\" style=background-color:#fff> <i ng-click=\"viewAllChild('showAll')\" class=\"fa fa-angle-down\" style=\"padding:4px 9px;font-size:16px\"></i> </div> </div> </div> </div> </div> <div class=\"chilfFloat hand\" ng-if=\"childrenList && childrenList.length > 0 && isParent \"> <div ng-if=showAllComponent class=\"md-whiteframe-2dp floatTop\" layout layout-align=\"start end\" style=background-color:#fff> <i ng-click=\"viewSelectedChild('showSelected')\" class=\"fa fa-angle-up\" style=\"padding:4px 9px;font-size:16px\"></i> </div> </div>";

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var childrenComponent = function childrenComponent($scope, $state, $rootScope, localStorageService, CHILDREN_COMPONENT_CONSTANTS, authService) {
  'ngInject';

  _classCallCheck(this, childrenComponent);

  var userId = localStorageService.get('user_id');
  var schoolId = localStorageService.get('school_id');

  $scope.showAllComponent = true;
  $scope.parentStateArray = ['parentPortalHome', 'parentFeedback', 'parentFees', 'parentLibrary', 'trackSchoolBus', 'studentActivity', 'publishedReports', 'medicalFeatureList', 'getAvailability', 'archiveResources'];
  $scope.$watch(function () {
    return $state.$current.name;
  }, function (newVal, oldVal) {
    $scope.isParent = _.contains($scope.parentStateArray, newVal);
    localStorageService.set('isParent', $scope.isParent);
    showChild();
    $scope.showAllComponent = newVal === "authdashboard" ? false : true;
  });

  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, { reload: true });
    } else {
      authService.callAPI(CHILDREN_COMPONENT_CONSTANTS.API_GET_PARENT_DETAILS + userId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.details) {
          try {
            $scope.personData = response.result.data.details;
            showChild();
          } catch (ex) {
            console.log(ex);
          }
        } else {
          toastr.error('Network Error. Please try later');
        }
        _.defer(function () {
          $scope.$apply();
        });
      });
    }
  };

  function showChild() {
    var prnt = localStorageService.get('isParent');
    if (prnt === undefined || prnt === null) return false;
    $scope.isParent = prnt;
    if ($scope.isParent === false) {
      $scope.showAllComponent = false;
      return false;
    }
    $scope.showAllComponent = $state && $state.current && $state.current.name === "authdashboard" ? false : true;
    if (!schoolId) {
      toastr.error("No school id found");
    }
    if ($scope.personData && $scope.personData.child) {
      if ($scope.personData.child.length > 0) {
        var myChildIds = _.pluck($scope.personData.child, "_id");
        myChildIds = _.compact(_.flatten(myChildIds));
        if (myChildIds) {
          authService.callAPI(CHILDREN_COMPONENT_CONSTANTS.API_GET_PARENT_CHILD_DETAILS + JSON.stringify(myChildIds), "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
              try {
                if ($state.params.student_id) localStorageService.set('st_id', $state.params.student_id);
                $scope.childrenList = response.result.data.details;
                if (localStorageService.get('st_id')) {
                  _.each($scope.childrenList, function (doc) {
                    doc.active = false;
                    if (doc.user_id === localStorageService.get('st_id')) {
                      doc.active = true;
                      localStorageService.set({
                        portalData: {
                          session_id: doc.session_id,
                          curriculum_id: doc.curriculum_id,
                          class_id: doc.class_id,
                          batch_id: doc.batch_id,
                          session: doc.session,
                          curriculum: doc.curriculum,
                          class: doc.class,
                          batch: doc.batch
                        }
                      });
                      localStorageService.set("st_session_id", doc.session_id);
                      localStorageService.set("st_curriculum_id", doc.curriculum_id);
                      localStorageService.set("st_class_id", doc.class_id);
                      localStorageService.set("st_batch_id", doc.batch_id);
                      localStorageService.set("st_name", doc.name);
                    }
                  });
                } else {
                  localStorageService.set({
                    portalData: {
                      session_id: $scope.childrenList[0].session_id,
                      curriculum_id: $scope.childrenList[0].curriculum_id,
                      class_id: $scope.childrenList[0].class_id,
                      batch_id: $scope.childrenList[0].batch_id,
                      session: $scope.childrenList[0].session,
                      curriculum: $scope.childrenList[0].curriculum,
                      class: $scope.childrenList[0].class,
                      batch: $scope.childrenList[0].batch
                    }
                  });
                  localStorageService.set("st_id", $scope.childrenList[0].user_id);
                  localStorageService.set("st_session_id", $scope.childrenList[0].session_id);
                  localStorageService.set("st_curriculum_id", $scope.childrenList[0].curriculum_id);
                  localStorageService.set("st_class_id", $scope.childrenList[0].class_id);
                  localStorageService.set("st_batch_id", $scope.childrenList[0].batch_id);
                  localStorageService.set("st_name", $scope.childrenList[0].name);
                  $scope.childrenList[0].active = true;
                }
              } catch (ex) {
                console.log(ex);
              }
            } else {
              toastr.error('Network Error. Please try later');
            }
            localStorageService.set("childrenList", $scope.childrenList);
            console.log($scope.childrenList);
            _.defer(function () {
              $scope.$apply();
            });
          });
        }
      }
    }
  }

  $scope.saveStudentDetails = function (child) {
    if (child && child._id) {
      if (!child.active || child.active === false) {
        localStorageService.set({
          portalData: {
            session_id: child.session_id,
            curriculum_id: child.curriculum_id,
            class_id: child.class_id,
            batch_id: child.batch_id,
            session: child.session,
            curriculum: child.curriculum,
            class: child.class,
            batch: child.batch
          }
        });
        localStorageService.set("st_session_id", child.session_id);
        localStorageService.set("st_curriculum_id", child.curriculum_id);
        localStorageService.set("st_class_id", child.class_id);
        localStorageService.set("st_batch_id", child.batch_id);
        localStorageService.set("st_id", child.user_id);
        localStorageService.set("st_name", child.name);

        localStorageService.set("st_session_name", child.name);
        localStorageService.set("st_name", child.name);
        localStorageService.set("st_name", child.name);
        localStorageService.set("st_name", child.name);
        child._id = child.user_id;
        child.child_name = child.name;
        localStorage.setItem('childDetails', JSON.stringify(child));
        toastr.success(child.name);
        if ($state.$current.name == "getAvailability") {
          $rootScope.$emit("getAllAvailablityList", {});
        }
        if ($scope.childrenList.length > 0) {
          _.each($scope.childrenList, function (doc) {
            doc.active = false;
            if (doc.user_id === child.user_id) doc.active = true;
          });
        }
      }
    }
  };

  $scope.viewSelectedChild = function (data) {
    $scope.showAllComponent = false;
    if (data === 'showSelected') {
      $scope.showAllComponent = false;
      $scope.showComponent = true;
    }
  };

  $scope.viewAllChild = function (data) {
    $scope.showComponent = true;
    $scope.showAllComponent = false;
    if (data === 'showAll') {
      $scope.showAllComponent = true;
      $scope.showComponent = false;
    }
  };
};
childrenComponent.$inject = ["$scope", "$state", "$rootScope", "localStorageService", "CHILDREN_COMPONENT_CONSTANTS", "authService"];

exports.default = childrenComponent;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

__webpack_require__(984);

var _privilegeDashboard = __webpack_require__(985);

var _privilegeDashboard2 = _interopRequireDefault(_privilegeDashboard);

var _privilegeDashboardController = __webpack_require__(987);

var _privilegeDashboardController2 = _interopRequireDefault(_privilegeDashboardController);

var _privilegeSettings = __webpack_require__(988);

var _privilegeSettings2 = _interopRequireDefault(_privilegeSettings);

var _privilegeSettingsController = __webpack_require__(989);

var _privilegeSettingsController2 = _interopRequireDefault(_privilegeSettingsController);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('PrivilegeDashboard', [_angularUiRouter2.default]);

_module.constant('PRIVILEGECONSTANT', {
    API_GET_MODULE_LIST: "/v0/privilege/get-all-modules/",
    API_SET_PRIVILEGE_DEFAULT: "/v0/privilege/set-selected-privilege-default",
    API_UPDATE_PRIVILEGE: "/v0/privilege/update-features"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('privilegeDashboard', {
        parent: 'app',
        url: '/privilege/main-page',
        views: {
            '@': {
                template: _privilegeDashboard2.default,
                controller: _privilegeDashboardController2.default,
                controllerAs: 'privilegeDashboard'
            }
        }
    });
}]);

var _module = angular.module('PrivilegeSettings', [_angularUiRouter2.default]);
_module.constant('PRIVSETTINGSCONSTANT', {
    API_GET_ALL_ROLES: "/v0/initial-settings/user-console/roles/added/",
    API_GET_MODULE_LIST: "/v0/privilege/get-all-modules/",
    API_CHECK_PRIVILEGE_EXISTS: "/v0/privilege/check-if-privilege-exits",
    API_SET_PRIVILEGE_DEFAULT: "/v0/privilege/set-selected-privilege-default",
    API_UPDATE_PRIVILEGE: "/v0/privilege/update-features",
    API_UPDATE_DEFAULT_PRIVILEGE: "/v0/privilege/update-default-features"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('privilegeSettings', {
        parent: 'app',
        url: '/privilege/settings',
        views: {
            '@': {
                template: _privilegeSettings2.default,
                controller: _privilegeSettingsController2.default,
                controllerAs: 'privilegeSettings'
            }
        },
        params: {
            role_id: undefined,
            module_id: undefined

        }
    });
}]);

exports.default = _module;

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column md-theme=makeMeWhite ng-cloak class=privilege> <div class=\"md-whiteframe-3dp marginaround md-no-momentum\" ng-init=loadData()> <div layout=row class=marginsarnd> <div flex=80 layout=row> <div flex=20 class=selectedpac>Selected Package:<span></span></div> <div flex=30 layout=row id=search ng-show=userwise> <input name=cq type=text size=40 ng-model=userSearchs placeholder=\"Type role...\"/> </div> <div flex=30 layout=row id=search ng-show=!userwise> <input name=q type=text size=40 ng-model=userSearch placeholder=\"Type module...\"/> </div> </div> <div flex=20 layout=row layout-align=\"space-between center\"> <div layout=row class=togglebutton> <div class=\"toggleItem leftradius\" tooltips tooltip-template=User tooltip-side=left ng-class=\"userwise?'currentItem':''\" ng-click=\"userwise===true||toggleView()\" layout=row layout-align=\"center center\"> <img ng-src={{usericon}} class=img_toggle /></div> <div class=\"toggleItem rightradius\" ng-class=\"!userwise?'currentItem':' '\" tooltips tooltip-template=Module tooltip-side=right ng-click=\"userwise===false||toggleView()\" layout=row layout-align=\"center center\"> <img ng-src={{moduleicon}} class=img_toggle /> </div> </div> <div class=md-whiteframe-3dp tooltips tooltip-template=\"Edit settings\" tooltip-side=bottom ui-sref=privilegeSettings style=border-radius:50px;background-color:#1bbc9b;width:35px;height:35px;cursor:pointer layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(986) + " /></div> <div class=md-whiteframe-3dp tooltips tooltip-template=\"Set as default\" tooltip-side=bottom ng-click=setPrivilgeAsDefault($event) style=border-radius:50px;background-color:#1665c1;width:35px;height:35px;cursor:pointer;outline:0 layout=row layout-align=\"center center\"> <img src=" + __webpack_require__(440) + " /></div> </div> </div> <div class=\"md-whiteframe-3dp marginaround\" ng-if=userwise> <div layout=column ng-repeat=\"item in roleModuleList | filter:{name: userSearchs}\"> <div class=heading style=background-color:#b090e3> <div>{{item.name}}</div> </div> <div class=borderaround> <div layout=row layout-wrap class=margin_left> <div flex=15 ng-repeat=\"data in item.modules\" ng-click=setPrivilege(item._id,data._id) layout=column style=margin-bottom:10px;outline:0> <div class=\"margins paddings\" ng-class=\"data.isAvailable?'greenlabels':'redlabels'\" layout=row layout-align=\"center center\">{{data.name}} </div> <div class=icondiv> <i class=\"fas fa-check icons icontick\" ng-if=data.isAvailable></i> <i class=\"fas fa-times icons iconcross\" ng-if=!data.isAvailable></i> </div> </div> </div> </div> </div> </div> <div class=\"md-whiteframe-3dp marginaround\" ng-if=!userwise> <div layout=column ng-repeat=\"item in modulewiseList | filter:{name: userSearch}\"> <div class=heading style=background-color:{};>{{item.name}}</div> <div class=borderaround> <div layout=row layout-wrap class=margin_left> <div flex=15 ng-repeat=\"data in item.roles\" layout=column ng-click=setPrivilege(data._id,item._id) style=margin-bottom:10px;outline:0> <div class=\"margins paddings greenlabels\" layout=row layout-align=\"center center\">{{data.name}} </div> <div class=icondiv> <i class=\"fas fa-check icons icontick\" ng-if=data.isAvailable></i> <i class=\"fas fa-times icons iconcross\" ng-if=!data.isAvailable></i> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAATxJREFUeNqM07suREEcx/Ezu8fG5gSFQu0JJBqV2IJC4vIKCs0+gEhoJFiJFxC9RkdsotGoNvEAGtFTKITsLmLHd+Q3TMbacyb5ZM7c/2cuxlq7miRJA5WkWHrHFs5dwTDBHfkOrvCRM3gI8+o/hXbJTYImHtEbMLinPk2NGXWVKazyDJcY+2eCZ63ux1g/gUtldLCu737pU32ysDINGqs4yolgUX2N/ImgXiCCEQ1+y4vABO0+ggV0sRFP0C8Ct+tPwcm4/FXtszj87u/uAcaRoYVbaakuCQzjwP6mhzTYzDZWUApW7AS/4H5xW/fgBqc48xFMRCvFqthDTeUZRVIuMkGKTcyp7PJdVFzZX+XugCu8hklco6aTaOhR/VzLJT2mOL1oX5a10D32w70xOc/5GNM6ugucxB2+BBgAGevjtz9oGyMAAAAASUVORK5CYII="

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrivilegeController = function PrivilegeController($scope, $state, $mdDialog, localStorageService, randomColorService, authService, PRIVILEGECONSTANT, $rootScope) {
    'ngInject';

    _classCallCheck(this, PrivilegeController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $rootScope.title = "Roles & Privileges Dashboard";
    };
    this.$onDestroy = function () {
        $scope.roleModuleList = undefined;
        $scope.modulewiseList = undefined;
    };

    var dashboardUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "utilities";
    });

    $scope.getColor = randomColorService;
    $scope.userwise = true;
    $scope.usericon = "../../../img/roles_modules/roles_white.png";
    $scope.moduleicon = "../../../img/roles_modules/modules_dark.png";
    $scope.roleModuleList = [];
    $scope.modulewiseList = [];
    $scope.userSearchs = "";
    $scope.userSearch = "";
    $scope.school_id = localStorageService.get('school_id');
    $scope.toggleView = function () {
        $scope.userwise = !$scope.userwise;
        if ($scope.userwise) {
            $scope.usericon = "../../../img/roles_modules/roles_white.png";
            $scope.moduleicon = "../../../img/roles_modules/modules_dark.png";
        }
        if (!$scope.userwise) {
            $scope.usericon = "../../../img/roles_modules/roles_dark.png";
            $scope.moduleicon = "../../../img/roles_modules/modules_white.png";
        }
    };
    $scope.setPrivilege = function (roleid, moduleid) {

        $state.go('privilegeSettings', {
            'role_id': roleid,
            'module_id': moduleid

        });
    };

    function loadData() {
        /************ API CALL TO GET ALL ROLES & THEIR PRIVILEGES ***********/
        /* Function to display roles and their module status.
         * @school_id : String - 
         * @return : List of modules 
         * @Developer : Ashitha
        */

        authService.callAPI(PRIVILEGECONSTANT.API_GET_MODULE_LIST + $scope.school_id, "GET", {}, function (response) {
            if (response.result != undefined) {
                if (response.result.data && response.result.data.data) {
                    var resultItem = response.result.data.data;
                    $scope.roleList = response.result.data.data[0].role_list;
                    var modules = [];
                    modules = response.result.data.data;
                    $scope.selectedModules = angular.copy(modules);
                    _.each(modules, function (obj) {
                        var roleList = [];
                        _.each($scope.roleList, function (role) {
                            var roleItem = {};
                            var featurerole = _.filter(obj.feature_role, function (item) {
                                return role._id == item.role_id;
                            });
                            roleItem.name = role.name;
                            roleItem._id = role._id;
                            roleItem.isAvailable = false;
                            if (featurerole.length > 0) {

                                _.each(featurerole, function (obj) {
                                    _.each(obj.privilege, function (each) {
                                        if (each.status) {
                                            roleItem.isAvailable = true;
                                        }
                                    });
                                });
                            } else {
                                roleItem.isAvailable = false;
                            }
                            roleList.push(roleItem);
                        });
                        $scope.modulewiseList.push({
                            "_id": obj._id,
                            "name": obj.name,
                            color: randomColorService.getRandomColor(),
                            "roles": roleList
                        });
                    });
                    _.defer(function () {
                        $scope.$apply();
                    });;
                    _.each($scope.roleList, function (role) {
                        var moduleList = [];
                        _.each(modules, function (obj) {
                            var module = {};
                            module.name = obj.name;
                            module._id = obj._id;
                            module.isAvailable = false;
                            var featurerole = _.filter(obj.feature_role, function (item) {
                                return role._id == item.role_id;
                            });

                            if (featurerole.length > 0) {
                                _.each(featurerole, function (obj) {

                                    _.each(obj.privilege, function (each) {

                                        if (each.status) {
                                            module.isAvailable = true;
                                        }
                                    });
                                });
                            } else {
                                module.isAvailable = false;
                            }
                            moduleList.push(module);
                        });
                        $scope.roleModuleList.push({
                            "_id": role._id,
                            "name": role.name,
                            "color": randomColorService.getRandomColor(),
                            "modules": moduleList
                        });
                    });
                }
            }
        });
    }

    /*
     * Set default privileges for selected roles and modules
     * 
     * @ev : Object - Click Event
     * 
     * @return : null
     */
    $scope.setPrivilgeAsDefault = function (ev) {
        var confirm = $mdDialog.confirm().title('Are you sure you want to continue?').textContent('This will set the default privileges to all the users').ariaLabel('').targetEvent(ev).ok('Yes').cancel('No');

        $mdDialog.show(confirm).then(function () {
            $scope.loading = true;
            var dataToSend = {
                module_state: _.pluck($scope.selectedModules, 'state'),
                roles: $scope.roleList,
                school_id: localStorageService.get('school_id')
                /************ API CALL TO GET ALL DEFAULT PRIVILEGES ***********/
                /* Function to get all default privileges
                 * @school_id : String - 
                 * @return : modules with default privileges
                 * @Developer : Ashitha
                */
            };authService.callAPI(PRIVILEGECONSTANT.API_SET_PRIVILEGE_DEFAULT, "POST", dataToSend, function (response) {
                var result = response.result.data.data;
                if (result.length > 0) {
                    var selectedModules = result;
                    // _.each(selectedModules, function (each) {
                    //     var finalList = [];
                    //     var resultModule = _.find($scope.selectedModules, function (mod) {
                    //         return each.state === mod.state
                    //     })
                    //     _.each(each.feature_role, function (eachItem) {
                    //         var counts = 0;

                    //         //find whether the selected feature is new  or modified 
                    //         if (resultModule && resultModule.feature_role) {
                    //             var resObject = _.find(resultModule.feature_role, function (stat) {
                    //                 return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id
                    //             })
                    //         }
                    //         //if modified ,then allowing to save
                    //         if (resObject) {
                    //             _.each(eachItem.privilege, function (data) {
                    //                 var objec = _.find(resObject.privilege, function (res) {
                    //                     return res.name === data.name && res.status === data.status
                    //                 })
                    //                 if (objec) {
                    //                     counts++
                    //                 }
                    //             })
                    //             if (counts != resObject.privilege.length) {
                    //                 //console.log("here")
                    //                 finalList.push(eachItem)
                    //             }
                    //         } else {
                    //             //if new and if any of the 'CRUD' item is true,then allowing to save
                    //             if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                    //                 finalList.push(eachItem)
                    //             }
                    //         }

                    //     })
                    //     each.feature_role = angular.copy(finalList)

                    // })
                    if (selectedModules) {
                        var objToSend = {
                            selected_modules: angular.copy(selectedModules),
                            school_id: localStorageService.get('school_id'),
                            flag: 0
                            /************ API CALL TO UPDATE PRIVILEGE ***********/
                            /* Function to update  privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                        };authService.callAPI(PRIVILEGECONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                            $scope.loading = false;
                            toastr.success("Successfully added");
                            $scope.modulewiseList = [];
                            $scope.roleModuleList = [];
                            loadData();
                        });
                    }
                } else {
                    $scope.loading = false;
                    toastr.error("Default privileges not found");
                }
                //_.defer(function() { $scope.$apply(); });
            });
        });
    };
    //$scope.roleModuleList=[]
    //$scope.modulewiseList=[]
    loadData();
};
PrivilegeController.$inject = ["$scope", "$state", "$mdDialog", "localStorageService", "randomColorService", "authService", "PRIVILEGECONSTANT", "$rootScope"];

exports.default = PrivilegeController;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column md-theme=makeMeWhite ng-cloak class=privilege> <div class=\"md-whiteframe-3dp marginaround md-no-momentum\"> <div class=\"md-whiteframe-3dp aroundmargin aroundPadding ashbackground\" layout=row layout-align=\"space-between center\"> <div flex=50 layout=row> <md-input-container class=\"md-block margins\" flex-gt-sm=50> <label>Select Roles</label> <md-select ng-model=selectedRoles multiple=multiple> <md-option ng-value=role ng-disabled=isDisableRole ng-repeat=\"role in roleList\" ng-click=onRoleChanged()>{{role.name}}</md-option> </md-select> </md-input-container> <md-input-container class=\"md-block margins\" flex-gt-sm=50> <label>Select Modules</label> <md-select ng-model=selectedModules multiple=multiple ng-change=setFeatureIfExitsInServer()> <md-option ng-value=module ng-click=onModuleChange(module,$index) ng-repeat=\"module in moduleList\">{{module.name}}</md-option> </md-select> </md-input-container> </div> <div class=\"md-whiteframe-1dp margins paddings showboxes\" id=style-4 flex=45> <div layout=row layout-wrap> <div ng-if=\"selectedModules.length==0\" layout=row flex=100 layout-align=\"center center\">Please select modules</div> <div ng-repeat=\"module in selectedModules\" class=boxes> {{module.name}} </div> </div> </div> </div> <div layout=row> <div flex=40 class=\"md-whiteframe-3dp aroundmargin\"> <div layout=row class=set_heading>Selecting Features</div> <div class=pagesize> <div class=aroundmargin> <div class=\"md-accordion md-whiteframe-1dp\" ng-init=\"parentIndex = $index\" ng-repeat=\"module in selectedModules\"> <div id={{module.state}}s ng-init=\"module.expanded = false\" ng-click=collapseLeft(module,0)> <div ng-class=\"{greenbackground:true, redbackground:module.expanded}\" layout=row flex class=acctoolbar layout-align=\"start center\"> <div flex layout-align=\"start center\"> {{module.name}} </div> </div> </div> <div ng-class=\"{dataContent:true, activeContent:module.expanded}\"> <div> <md-checkbox ng-model=module.isEveryFeature ng-change=selectAllFeatures(module.state,module.isEveryFeature) class=margin_check aria-label=\"Checkbox 1\"><span class=checkboxlabel>Select All</span> </md-checkbox> </div> <div layout=row layout-wrap> <div ng-repeat=\"feature in module.features\" flex=45 layout=row layout-align=\"space-between center\" class=feturebox> <div flex=90 class=featureboxfont ng-init=\"feature.selected== false\"> {{feature.name}}</div> <md-checkbox flex=10 ng-model=feature.selected ng-change=onAddRemoveFeature(feature,module.state) class=margin_check aria-label=\"Checkbox 1\"> </md-checkbox> </div> </div> </div> </div> </div> </div> </div> <div flex=60 class=\"md-whiteframe-3dp aroundmargin\"> <div layout=row class=set_heading>Permission Settings</div> <div class=pagesize> <div class=aroundmargin> <div class=\"md-accordion md-whiteframe-1dp\" ng-init=\"parentIndex = $index\" ng-repeat=\"module in selectedModules\"> <div id={{module.state}} ng-init=\"module.expandedright = false\" ng-click=collapseRight(module,0)> <div layout=row flex class=acctoolbar ng-class=\"{greenbackground:true, redbackground:module.expanded}\" layout-align=\"start center\"> <div flex layout-align=\"start center\"> {{module.name}} </div> </div> </div> <div ng-class=\"{dataContent:true, activeContent:module.expandedright}\"> <div layout=column> <div layout=row ng-if=\"module.features.length>0\"> <div flex=30> <md-checkbox ng-model=module.status aria-label=\"Checkbox 1\" ng-click=changeAllPrivilege(module.status,module.state)> <span class=checkboxlabel>Select All</span> </md-checkbox> </div> <div layout=row flex> <div ng-repeat=\"item in module.privilegeType\"> <span class=margin-right style=position:relative;top:10px>{{item.name}}</span> <md-checkbox ng-model=item.status class=margin-left ng-click=changeByPrivilegeType(item,module.state) aria-label=\"Checkbox 1\"> </md-checkbox> </div> </div> </div> <md-divider style=margin-top:10px class=md-makeMeWhite-theme></md-divider> <div ng-repeat=\"feature in module.features\" style=padding-top:10px ng-if=feature.selected layout=column> <div layout=row> <div flex=30 class=featureboxfont>{{feature.name}}</div> <div layout=row flex> <span ng-repeat=\"item in privilegeType\" ng-init=\"\"> <md-menu> <i class=\"fas fa-angle-down font-size-icon\" ng-click=\"openMenu($mdOpenMenu, $event,feature,module.state)\" style=position:relative;top:11px></i> <md-menu-content width=4> <md-menu-item ng-repeat=\"featureRole in module.feature_role\" ng-if=\"feature._id==featureRole.f_id\"> <div flex=90 ng-repeat=\"role in roleList\" ng-if=\"featureRole.role_id==role._id\">{{role.name}}</div> <md-checkbox md-prevent-menu-close=md-prevent-menu-close ng-model=data.status aria-label=\"Checkbox 1\" ng-if=\"data.type==item.type\" ng-repeat=\"data in featureRole.privilege\" ng-click=changedRole(data.status,feature._id,item,module.state)> </md-checkbox> </md-menu-item> </md-menu-content> </md-menu> <md-checkbox class=margin-left ng-model=feature.status[$index] aria-label=\"Checkbox 1\" ng-click=changeRolesByFeaturePrivilegeType(feature.status[$index],feature._id,item,module.state)> </md-checkbox> </span> </div> </div> <md-divider style=margin-top:10px></md-divider> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <footer class=footer style=background:#1665c1> <div layout=row layout-align=\"center center\"> <div layout=row layout-align=space-between-center> <md-button class=tpFooter aria-label=Add style=background:#1665c1 ng-disabled=loading ng-click=saveDetails($event)>save <i class=\"far fa-lg fa-save\"></i> </md-button> <md-button class=tpFooter aria-label=Add style=background:#1665c1 ng-click=setSelectedPrivilegeAsDefault($event)>Set as Default <img style=margin-bottom:0!important;min-height:20px;min-width:20px;position:relative;top:5px src=" + __webpack_require__(440) + " class=result-icon-button width=20 alt=Attendance> </md-button> <md-button class=tpFooter aria-label=Add style=background:#1665c1 ng-click=gobackToDashboard()>cancel <i class=\"far fa-lg fa-trash-alt\"></i> </md-button> <md-button class=tpFooter aria-label=Add style=background:#1665c1 ng-click=privilegeSettings.reset()>reset <i class=\"fas fa-lg fa-redo-alt\"></i> </md-button> </div> </div></footer> ";

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//--------------------------------------------------------
// 1. Developer(s) : Ashitha
// 2. Module/Feature Name :  Privilege Settings
// 3. Developed on : Jun 23, 2017
// 4. Dependencies :  
// 5. Reference Doc name : 
//--------------------------------------------------------

/*To set modules,features and feature privileges for a role*/
var PrivilegeSetting =

// constructor($scope, $reactive, randomColorService, $state, $stateParams, $mdDialog, UserPrivilages, $location, $anchorScroll, CurrentPage) {
function PrivilegeSetting($scope, $state, $mdDialog, localStorageService, randomColorService, authService, PRIVSETTINGSCONSTANT, $stateParams, $location, $anchorScroll, $rootScope) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, PrivilegeSetting);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $rootScope.title = "Roles & Privileges Settings";
    };
    this.$onDestroy = function () {
        $scope.roleList = undefined;
        $scope.moduleList = undefined;
        $scope.selectedModules = undefined;
        $scope.privilegeType = undefined;
        $scope.featureRole = undefined;
    };
    var dashboardUserAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "utilities";
    });

    //To store selected roles from dropdown
    $scope.selectedRoles = [];
    //To store selected modulles from dropdown
    $scope.selectedModules = [];
    //To disable role dropdown once a feature is checked
    $scope.isDisableRole = false;
    // To store  modules
    $scope.moduleList = [];
    // Background colors  for accordion head
    this.color = ["#2db4bd", "#1fbc9b", "#36b3f3"];
    $scope.isSave = true;
    $scope.setIndex;

    // To show the proper menu (CRUD) against each feature

    $scope.school_id = localStorageService.get('school_id');
    $scope.privilegeType = [{
        name: "C",
        type: 0

    }, {
        name: "R",
        type: 1
    }, {
        name: "U",
        type: 2
    }, {
        name: "D",
        type: 3
    }];

    /* let role = $stateParams.role*/
    //Role List
    authService.callAPI(PRIVSETTINGSCONSTANT.API_GET_ALL_ROLES + $scope.school_id, "GET", {}, function (response) {
        if (response.result != undefined) {
            if (response.result.data && response.result.data.data && response.result.data.data.length > 0) {
                $scope.roleList = response.result.data.data[0].roles;
                if ($stateParams.role_id) {
                    $scope.setSelectBoxWithRole($stateParams.role_id);
                }
            }
        }
    });
    $scope.setSelectBoxWithRole = function (roleId) {

        var role = _.find($scope.roleList, function (obj) {
            return obj._id == roleId;
        });
        if (role) {
            $scope.selectedRoles.push(role);
            $scope.getAllModules();
        }
    };
    $scope.setSelectBoxWithModule = function (moduleId) {
        var module = _.find($scope.moduleList, function (obj) {
            return obj._id == moduleId;
        });
        $scope.setIndex = $scope.moduleList.findIndex(function (i) {
            return i._id === moduleId;
        });
        $scope.setFeatureIfExitsInServer();
        if (module) {
            $scope.selectedModules.push(module);

            $scope.isDisableRole = true;
            var roleFeature = [];
            _.each($scope.selectedRoles, function (role) {
                var role_feature = _.filter(module.staticFeatureRole, function (each) {
                    return role._id == each.role_id;
                });

                _.each(role_feature, function (obj) {
                    roleFeature.push(obj);
                });
            });
            module.staticFeatureRole = roleFeature;
        }
        _.defer(function () {
            $scope.$apply();
        });
    };
    // To choose random colors for accordion
    //arg :null
    //return :string 
    this.getRandomColor = function () {
        return this.color[Math.floor(Math.random() * this.color.length)];
    };
    this.reset = function () {
        if (!($stateParams.role_id && $stateParams.module_id)) {
            _.each($scope.selectedModules, function (obj) {
                obj.expanded = false;
                obj.expandedright = false;
                obj.featureRoleList = [];
                obj.feature_role = [];
                _.each(obj.features, function (data) {
                    data.status = [false, false, false, false];
                });
                /*obj.features=[]*/
                obj.isDisableFeature = false;
                obj.isEveryFeature = false;
                //obj.name=undefined
                //obj.school_id=undefined
                //obj.state=undefined
                obj.status = false;
                obj.subscription_status = true;
                obj.staticFeatureRole = angular.copy(obj.feature_role);
                obj.privilegeType = [{
                    name: "C",
                    type: 0,
                    status: false
                }, {
                    name: "R",
                    type: 1,
                    status: false
                }, {
                    name: "U",
                    type: 2,
                    status: false
                }, {
                    name: "D",
                    type: 3,
                    status: false
                }];
            });
            $scope.selectedRoles = [];
            $scope.selectedModules = [];
            $scope.moduleList = [];
            $scope.isDisableRole = false;
        } else {
            if ($stateParams.role_id) {
                $scope.selectedModules = [];
                $scope.setSelectBoxWithRole($stateParams.role_id);
            }
        }
    };
    // To open and close accordion on left
    // arg 1: data - object
    $scope.collapseLeft = function (data, flag) {
        // To close all accordions other than the clicked one

        for (var i in $scope.selectedModules) {

            if ($scope.selectedModules[i] != data) {
                $scope.selectedModules[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;
        if (flag == 0) {
            //$scope.setFeatureIfExitsInServer(data)
            $location.hash(data.state);
            $scope.collapseRight(data, 1);

            $anchorScroll();
        }
    };

    // To open and close accordion on right
    // arg 1: data - Object

    $scope.collapseRight = function (data, flag) {

        // To close all accordions other than the clicked one
        for (var i in $scope.selectedModules) {

            if ($scope.selectedModules[i] != data) {
                $scope.selectedModules[i].expandedright = false;
            }
        }
        data.expandedright = !data.expandedright;
        var state = data.state + 's';
        if (flag == 0) {
            //$scope.setFeatureIfExitsInServer(data)
            $location.hash(state);
            $scope.collapseLeft(data, 1);

            // call $anchorScroll()
            $anchorScroll();
        }
    };

    //go back to dashboard
    $scope.gobackToDashboard = function () {
        $state.go('privilegeDashboard');
    };
    //To reset the settings of a module
    //arg 1:module - Object of module

    $scope.onModuleChange = function (module, index) {
        $scope.isDisableRole = true;
        var roleFeature = [];
        _.each($scope.selectedRoles, function (role) {
            var role_feature = _.filter(module.staticFeatureRole, function (each) {
                return role._id == each.role_id;
            });

            _.each(role_feature, function (obj) {
                roleFeature.push(obj);
            });
        });
        module.staticFeatureRole = roleFeature;

        //To check whether checkbox is checked or unchecked,true=checkbox unselected,false=checkbox selected
        if (_.contains($scope.selectedModules, module)) {
            //To reset back the  properties of a module
            _.each($scope.selectedModules, function (mod, key) {
                //to find matching 'module' in selectedModules
                if (mod._id === module._id) {
                    mod.status = false;
                    mod.isEveryFeature = false;
                    //To reset back the  properties of a feature
                    _.each(mod.features, function (feature) {
                        feature.selected = false;
                        $scope.onAddRemoveFeature(feature, module.state);
                        //feature.status = [false, false, false, false];
                    });
                    //To reset back the  privilegeType array of a module
                    _.each(mod.privilegeType, function (priv) {
                        priv.status = false;
                    });
                    //to remove feature_role added  currently
                    mod.feature_role = _.reject(mod.feature_role, function (item) {
                        return item.is_manual;
                    });
                }
            });
        }
        $scope.setIndex = index;
    };
    //To set features and its crud privileges as such in server
    //arg1 -Object of module
    $scope.setFeatureIfExitsInServer = function () {
        var mod = $scope.moduleList[$scope.setIndex];
        var indexOfModule = $scope.selectedModules.findIndex(function (i) {
            return i._id == mod._id;
        });
        var module = $scope.selectedModules[indexOfModule];
        if (module) {
            _.each(module.features, function (feat) {
                var features = _.find(module.staticFeatureRole, function (data) {
                    return data.f_id === feat._id;
                });
                if (features) {
                    feat.selected = true;

                    $scope.onAddRemoveFeature(feat, module.state);
                }
            });
        }
    };
    //To select all features of a particular module
    //arg 1:moduleIndex -String -index of module
    //arg 2:featureIndex -String -index of feature
    $scope.selectAllFeatures = function (state, status) {
        var moduleIndex = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        if (status) {
            _.each($scope.selectedModules[moduleIndex].features, function (data) {
                data.selected = true;
                $scope.onAddRemoveFeature(data, state);
            });
        } else {

            _.each($scope.selectedModules[moduleIndex].features, function (data) {
                data.selected = false;
                $scope.onAddRemoveFeature(data, state);
            });
        }
    };
    // To modify  feature_role array according to feature selection
    //arg1 : feature-Object of feature
    //arg1 : parentIndex- String of moduleList index
    //return null 


    $scope.onAddRemoveFeature = function (feature, state) {
        var parentIndex = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        //if role not selected show toast
        if ($scope.selectedRoles.length == 0) {
            toastr.error("Please select role");
            feature.selected = false;
        }
        //if role choosed 
        else {
                //if checkbox against feature is selected , show only those roles in menu, which are in selected roles
                if (feature.selected) {

                    //$scope.isDisableRole = true;


                    //to remove objects from feature_role array whose feature and role ids  are not in selected feature or selected roles
                    if (!$scope.selectedModules[parentIndex].isDisableFeature) {
                        _.each($scope.selectedRoles, function (role) {

                            //to find matching feature_role object
                            var featureRole = _.filter($scope.selectedModules[parentIndex].feature_role, function (item) {

                                return role._id == item.role_id;
                            });
                            //if selected role and feature are already there in feature_role array
                            if (featureRole.length > 0) {
                                //edited as 1 as 0
                                _.each(featureRole, function (each) {
                                    $scope.selectedModules[parentIndex].featureRoleList.push(each);
                                });
                                var havefeatures = _.filter(featureRole, function (item) {

                                    return feature._id == item.f_id;
                                });
                                if (havefeatures.length == 0) {
                                    $scope.selectedModules[parentIndex].featureRoleList.push({
                                        "f_id": feature._id,
                                        "role_id": role._id,
                                        "is_manual": true,
                                        "privilege": [{
                                            "name": "Create",
                                            "status": false,
                                            "type": 0

                                        }, {
                                            "name": "Read",
                                            "status": false,
                                            "type": 1

                                        }, {
                                            "name": "Edit",
                                            "status": false,
                                            "type": 2

                                        }, {
                                            "name": "Delete",
                                            "status": false,
                                            "type": 3

                                        }]

                                    });
                                }
                            }

                            //if selected role ais not in  feature_role array
                            else {
                                    $scope.selectedModules[parentIndex].featureRoleList.push({
                                        "f_id": feature._id,
                                        "role_id": role._id,
                                        "is_manual": true,
                                        "privilege": [{
                                            "name": "Create",
                                            "status": false,
                                            "type": 0

                                        }, {
                                            "name": "Read",
                                            "status": false,
                                            "type": 1

                                        }, {
                                            "name": "Edit",
                                            "status": false,
                                            "type": 2

                                        }, {
                                            "name": "Delete",
                                            "status": false,
                                            "type": 3

                                        }]

                                    });
                                }
                        });
                        $scope.selectedModules[parentIndex].feature_role = $scope.selectedModules[parentIndex].featureRoleList;
                        _this.changeCheckBoxAgainstFeatures(parentIndex, feature._id);
                        $scope.selectedModules[parentIndex].isDisableFeature = true;
                    } else {
                        _.each($scope.selectedRoles, function (role) {
                            var res = _.find($scope.selectedModules[parentIndex].featureRoleList, function (each) {
                                return role._id == each.role_id && each.f_id == feature._id;
                            });

                            if (!res) {
                                $scope.selectedModules[parentIndex].featureRoleList.push({
                                    "f_id": feature._id,
                                    "role_id": role._id,
                                    "is_manual": true,
                                    "privilege": [{
                                        "name": "Create",
                                        "status": false,
                                        "type": 0

                                    }, {
                                        "name": "Read",
                                        "status": false,
                                        "type": 1

                                    }, {
                                        "name": "Edit",
                                        "status": false,
                                        "type": 2

                                    }, {
                                        "name": "Delete",
                                        "status": false,
                                        "type": 3

                                    }]

                                });
                                $scope.selectedModules[parentIndex].feature_role = $scope.selectedModules[parentIndex].featureRoleList;

                                /*{
                                  {
                                    $scope.selectedModules[parentIndex].status
                                  }
                                }*/

                                if ($scope.selectedModules[parentIndex].status) {
                                    _.each($scope.selectedModules[parentIndex].features, function (obj) {
                                        if (obj._id == feature._id) {
                                            for (var i = 0; i < 4; i++) {
                                                obj.status[i] = true;
                                            }
                                        }
                                    });

                                    _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                        _.each(obj.privilege, function (data) {
                                            data.status = true;
                                        });
                                    });
                                } else {
                                    _.each($scope.selectedModules[parentIndex].privilegeType, function (each) {

                                        if (each.status) {
                                            _.each($scope.selectedModules[parentIndex].features, function (obj) {
                                                if (obj.selected) {
                                                    obj.status[each.type] = true;
                                                }
                                            });
                                            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                                _.each(obj.privilege, function (data) {
                                                    if (data.type === each.type) {
                                                        data.status = true;
                                                    }
                                                });
                                            });
                                        }
                                    });
                                }
                            }
                        });
                        _this.changeCheckBoxAgainstFeatures(parentIndex, feature._id);
                        _.each($scope.privilegeType, function (privilege) {
                            var privilegeCount = 0;
                            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                                _.each(obj.privilege, function (data) {
                                    if (data.type == privilege.type) {
                                        if (data.status) {
                                            privilegeCount++;
                                        }
                                    }
                                });
                            });
                            if (privilegeCount == $scope.selectedModules[parentIndex].feature_role.length) {
                                var privType = _.find($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                                    return privilege.type === priv.type;
                                });
                                privType.status = true;
                            }
                        });
                        var privFilter = _.filter($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                            return priv.status === true;
                        });
                        if (privFilter.length == $scope.privilegeType.length) {
                            $scope.selectedModules[parentIndex].status = true;
                        }
                    }
                    // to check whether all features are selected
                    var featureCount = _.filter($scope.selectedModules[parentIndex].features, function (feat) {
                        return feat.selected == true;
                    });
                    if (featureCount.length == $scope.selectedModules[parentIndex].features.length) {
                        $scope.selectedModules[parentIndex].isEveryFeature = true;
                    }
                }
                //if checkbox against feature is unselected
                else {
                        // added to fix internal QA bug no: 4740
                        $scope.selectedModules[parentIndex].featureRoleList = _.reject($scope.selectedModules[parentIndex].featureRoleList, function (item) {

                            return item.f_id === feature._id;
                        });
                        $scope.selectedModules[parentIndex].isEveryFeature = false;
                    }
            }
    };
    //This will change all the checkbox values of a module
    //arg1 -status-boolean
    //arg2 -index-string
    $scope.changeAllPrivilege = function (status, state) {
        var index = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        if (!status) {
            _.each($scope.selectedModules[index].features, function (obj) {

                for (var i = 0; i < 4; i++) {
                    obj.status[i] = true;
                }
            });
            _.each($scope.selectedModules[index].privilegeType, function (obj) {
                obj.status = true;
            });
            _.each($scope.selectedModules[index].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    data.status = true;
                });
            });
        } else {
            _.each($scope.selectedModules[index].features, function (obj) {
                for (var i = 0; i < 4; i++) {

                    obj.status[i] = false;
                }
            });
            _.each($scope.selectedModules[index].privilegeType, function (obj) {
                obj.status = false;
            });
            _.each($scope.selectedModules[index].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    data.status = false;
                });
            });
        }
    };

    //This will modify role status By Feature and PrivilegeType
    //arg1-status-boolean
    //arg2-id-int
    //arg3-privilege-object

    $scope.changeRolesByFeaturePrivilegeType = function (status, id, privilege, state) {
        var parentIndex = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        if (!status) {
            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                if (obj.f_id == id) {
                    _.each(obj.privilege, function (data) {
                        if (data.type == privilege.type) {
                            data.status = true;
                        }
                    });
                }
            });
            var privilegeCount = 0;
            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    if (data.type == privilege.type) {
                        if (data.status) {
                            privilegeCount++;
                        }
                    }
                });
            });
            if (privilegeCount == $scope.selectedModules[parentIndex].feature_role.length) {
                var privType = _.find($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                    return privilege.type === priv.type;
                });
                privType.status = true;
            }
            var privFilter = _.filter($scope.selectedModules[parentIndex].privilegeType, function (priv) {
                return priv.status === true;
            });
            if (privFilter.length == $scope.privilegeType.length) {
                $scope.selectedModules[parentIndex].status = true;
            }
        } else {
            _.each($scope.selectedModules[parentIndex].privilegeType, function (obj) {
                if (obj.type == privilege.type) {
                    obj.status = false;
                }
            });
            $scope.selectedModules[parentIndex].status = false;
            _.each($scope.selectedModules[parentIndex].feature_role, function (obj) {
                if (obj.f_id == id) {
                    _.each(obj.privilege, function (data) {
                        if (data.type == privilege.type) {
                            data.status = false;
                        }
                    });
                }
            });
        }
    };

    //This will modify role status and privilege checkbox against features according to privilegeType
    //arg 1-privilegeType-obj
    /*arg2-index-string*/
    $scope.changeByPrivilegeType = function (privilegeType, state) {
        var index = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        if (!privilegeType.status) {
            _.each($scope.selectedModules[index].features, function (obj) {
                if (obj.selected) {
                    obj.status[privilegeType.type] = true;
                }
            });
            _.each($scope.selectedModules[index].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    if (data.type === privilegeType.type) {
                        data.status = true;
                    }
                });
            });
            var privFilter = _.filter($scope.selectedModules[index].privilegeType, function (priv) {
                return priv.status === true;
            });
            if (privFilter.length == $scope.privilegeType.length - 1) {
                $scope.selectedModules[index].status = true;
            }
        } else {
            $scope.selectedModules[index].status = false;
            _.each($scope.selectedModules[index].features, function (obj) {
                obj.status[privilegeType.type] = false;
            });
            _.each($scope.selectedModules[index].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    if (data.type === privilegeType.type) {

                        data.status = false;
                    }
                });
            });
        }
    };
    //To change all parent check box of a role checkbox
    //arg1-status-boolean
    //arg2-id-int
    //arg3-item-object
    //arg4-index-string

    $scope.changedRole = function (status, id, item, state) {
        var index = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        if (status) {
            $scope.selectedModules[index].status = false;
            _.each($scope.selectedModules[index].features, function (obj) {
                if (obj._id == id) {
                    obj.status[item.type] = false;
                }
            });
            _.each($scope.selectedModules[index].privilegeType, function (obj) {
                if (obj.type == item.type) {
                    obj.status = false;
                }
            });
        } else {
            var count = 0;
            var featureList = _.filter($scope.selectedModules[index].feature_role, function (obj) {
                return obj.f_id == id;
            });
            _.each(featureList, function (obj) {
                var object = _.find(obj.privilege, function (obje) {
                    return obje.type == item.type;
                });
                if (object.status) {
                    count = count + 1;
                }
            });

            if (count == $scope.selectedRoles.length - 1) {
                _.each($scope.selectedModules[index].features, function (obj) {
                    if (obj._id == id) {
                        obj.status[item.type] = true;
                    }
                });
            }
            var privilegeCount = 0;
            _.each($scope.selectedModules[index].feature_role, function (obj) {
                _.each(obj.privilege, function (data) {
                    if (data.type == item.type) {
                        if (data.status) {
                            privilegeCount++;
                        }
                    }
                });
            });
            privilegeCount = privilegeCount + 1;
            if (privilegeCount == $scope.selectedModules[index].feature_role.length) {
                var privType = _.find($scope.selectedModules[index].privilegeType, function (priv) {
                    return item.type === priv.type;
                });
                privType.status = true;
            }
            var privFilter = _.filter($scope.selectedModules[index].privilegeType, function (priv) {
                return priv.status === true;
            });
            if (privFilter.length == $scope.privilegeType.length) {
                $scope.selectedModules[index].status = true;
            }
        }
    };
    this.changeCheckBoxAgainstFeatures = function (index, featureId) {
        var featureList = _.filter($scope.selectedModules[index].staticFeatureRole, function (obj) {
            return obj.f_id == featureId;
        });

        var indexOfFeature = $scope.selectedModules[index].features.findIndex(function (i) {
            return i._id == featureId;
        });
        _.each($scope.privilegeType, function (item) {
            var count = 0;
            _.each(featureList, function (obj) {
                var object = _.find(obj.privilege, function (obje) {
                    return obje.type == item.type;
                });
                if (object.status) {
                    count = count + 1;
                }
            });

            if (count === $scope.selectedRoles.length) {

                $scope.selectedModules[index].features[indexOfFeature].status[item.type] = true;
            }
        });
    };
    $scope.openMenu = function ($mdOpenMenu, ev, feature, state) {
        var parentIndex = $scope.selectedModules.findIndex(function (i) {
            return i.state === state;
        });
        $mdOpenMenu(ev);
        /* $scope.onAddRemoveFeature(feature, parentIndex);*/
    };
    $scope.onRoleChanged = function () {
        if ($scope.moduleList.length == 0) {
            $scope.getAllModules();
        }
    };

    /************ API CALL TO GET ALL ROLES & THEIR PRIVILEGES ***********/
    /* Function to display roles and their module status.
     * @school_id : String - 
     * @return : List of modules 
     * @Developer : Ashitha
    */
    $scope.getAllModules = function () {
        authService.callAPI(PRIVSETTINGSCONSTANT.API_GET_MODULE_LIST + $scope.school_id, "GET", {}, function (response) {
            if (response.result != undefined) {
                if (response.result.data && response.result.data.data) {
                    var modules = response.result.data.data;
                    _.each(modules, function (obj) {
                        obj.isDisableFeature = false, obj.featureRoleList = [], obj.staticFeatureRole = angular.copy(obj.feature_role);
                        obj.privilegeType = [{
                            name: "C",
                            type: 0,
                            status: false
                        }, {
                            name: "R",
                            type: 1,
                            status: false
                        }, {
                            name: "U",
                            type: 2,
                            status: false
                        }, {
                            name: "D",
                            type: 3,
                            status: false
                        }];
                        _.each(obj.features, function (data) {
                            data.status = [false, false, false, false];
                        });
                    });
                    _.defer(function () {
                        $scope.$apply();
                    });

                    $scope.moduleList = modules;
                    if ($stateParams.module_id) {
                        $scope.setSelectBoxWithModule($stateParams.module_id);
                    }
                }
            }
        });
    };

    ///This will save all privilege settings in server
    $scope.saveDetails = function (ev) {
        var isSaved = false;
        $scope.isSave = true;

        var count = 0;
        //does n't allow if no module and role is selected
        if ($scope.selectedModules.length > 0 && $scope.selectedRoles.length > 0) {
            _.each($scope.selectedModules, function (obj) {
                if (obj.featureRoleList.length > 0) count++;
            });
            //doesn't allow if no feature is selected against module
            if (count === $scope.selectedModules.length) {

                _.each($scope.selectedModules, function (each) {
                    //filter out the selected features 
                    var selectedfeatures = _.filter(each.features, function (obj) {
                        return obj.selected;
                    });
                    var featureList = [];
                    //filter out 'feature_role' for selected features
                    _.each(selectedfeatures, function (data) {
                        var features = _.filter(each.feature_role, function (obj) {
                            return obj.f_id === data._id;
                        });
                        _.each(features, function (fet) {
                            featureList.push(fet);
                        });
                    });
                    //assign filtered feature_role  
                    each.feature_role = featureList;
                    var finalList = [];
                    _.each(each.feature_role, function (eachItem) {
                        var counts = 0;
                        //find whether the selected feature is new  or modified 
                        var resObject = _.find(each.staticFeatureRole, function (stat) {
                            return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id;
                        });
                        //if modified ,then allowing to save
                        if (resObject) {
                            _.each(eachItem.privilege, function (data) {
                                var objec = _.find(resObject.privilege, function (res) {
                                    return res.name === data.name && res.status === data.status;
                                });
                                if (objec) {
                                    counts++;
                                }
                            });
                            if (counts != resObject.privilege.length) {
                                finalList.push(eachItem);
                            }
                        } else {
                            //if new and if any of the 'CRUD' item is true,then allowing to save
                            if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                                finalList.push(eachItem);
                            }
                        }
                        delete eachItem.is_manual;
                    });
                    if ($scope.isSave) {
                        if (finalList.length > 0) {
                            each.feature_role = angular.copy(finalList);
                        } else {
                            toastr.error("No changes made in " + each.name);
                            $scope.isSave = false;
                        }
                    }
                });
                if ($scope.isSave) {

                    // $scope.loading = true

                    /************ API CALL TO CHECK PRIVILEGES EXISTS OR  NOT***********/
                    /* Function to check a module exists in default privilges for a particular role.
                     * @school_id : String - 
                     * @return : List of modules with boolean set
                     * @Developer : Ashitha
                    */
                    var dataToSend = {
                        module_state: _.pluck($scope.selectedModules, 'state'),
                        roles: $scope.selectedRoles,
                        school_id: localStorageService.get('school_id')
                    };
                    authService.callAPI(PRIVSETTINGSCONSTANT.API_CHECK_PRIVILEGE_EXISTS, "POST", dataToSend, function (response) {
                        var result = response.result.data.data;
                        var defaultList = [];
                        var stringVar = [];
                        _.each(result, function (resObj) {
                            defaultList = result;
                            if (resObj.isNewModule) {
                                stringVar.push(resObj.module_name + " is new Module");
                            } else {
                                stringVar.push(resObj.module_name + "," + resObj.role_name + " is a new combination.");
                            }
                        });
                        var stringResult = "";
                        _.each(stringVar, function (str) {
                            stringResult = stringResult + str + '</br>';
                        });
                        if (stringVar.length == 0) {
                            stringResult = "Do you want to save??";
                        } else {
                            stringResult = stringResult + "This will save as default privilege.";
                        }
                        console.log(stringResult);
                        var confirm = $mdDialog.confirm().title('Are you sure to continue?')
                        //.htmlContent(stringResult)
                        .ariaLabel('').targetEvent(ev).ok('Yes').cancel('No');

                        $mdDialog.show(confirm).then(function () {
                            $scope.loading = true;
                            var objToSend = {
                                selected_modules: angular.copy($scope.selectedModules),
                                school_id: localStorageService.get('school_id'),
                                flag: 1
                                /************ API CALL TO UPDATE PRIVILEGE ***********/
                                /* Function to update  privileges
                                 * @school_id : String -
                                 * @ selected_modules: List of modules
                                 * @return : null
                                 * @Developer : Ashitha
                                */
                            };authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                $scope.loading = false;
                                isSaved = true;
                                if (response && response.data && response.data.message == "Success") {
                                    if (defaultList.length == 0) {
                                        if (isSaved) {
                                            $scope.loading = false;
                                            toastr.success("Saved Successfully");
                                            $state.go('privilegeDashboard');
                                        }
                                    }
                                }
                            });

                            /* Function to update default privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                            var reqObj = {
                                selected_modules: angular.copy($scope.selectedModules),
                                default_list: angular.copy(defaultList)

                            };
                            authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_DEFAULT_PRIVILEGE, "POST", reqObj, function (response) {
                                $scope.loading = false;
                                if (response && response.result && response.result.data && response.result.data.message) {
                                    if (response.result.data.message === "Success") toastr.success("Saved Successfully");
                                }
                                $state.go('privilegeDashboard');
                            });
                        }, function () {
                            if (defaultList.length > 0) {
                                $scope.loading = false;
                                var objToSend = {
                                    selected_modules: angular.copy($scope.selectedModules),
                                    school_id: localStorageService.get('school_id'),
                                    flag: 1
                                };
                                authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                    $scope.loading = false;
                                    isSaved = true;
                                    if (isSaved) {
                                        $scope.loading = false;
                                        toastr.success("Saved Successfully");
                                        $state.go('privilegeDashboard');
                                    }
                                });
                            }
                        });
                    });
                } else {
                    toastr.error("Please make any changes and save");
                }
            } else {
                toastr.error("Please choose atleast one feature for all selected modules");
            }
        } else {
            if ($scope.selectedRoles.length === 0) {
                toastr.error("Please select role");
            }
            if ($scope.selectedModules.length === 0) {

                toastr.error("Please select module");
            }
        }
    };
    /*
     * Sets all default privileges in modules_features
     * 
     * @ev : Object - Click Event
     * 
     * @return : null
     */
    $scope.setSelectedPrivilegeAsDefault = function (ev) {
        if ($scope.selectedModules.length == 0 || $scope.selectedRoles.length == 0) {
            toastr.error("Please select role and module");
        } else {
            var confirm = $mdDialog.confirm().title('Are you sure to continue?').textContent('Do you want to set the default privileges?').ariaLabel('').targetEvent(ev).ok('Yes').cancel('No');

            $mdDialog.show(confirm).then(function () {
                $scope.loading = true;
                var dataToSend = {
                    module_state: _.pluck($scope.selectedModules, 'state'),
                    roles: $scope.roleList,
                    school_id: localStorageService.get('school_id'),
                    flag: 0
                    /************ API CALL TO GET ALL DEFAULT PRIVILEGES ***********/
                    /* Function to get all default privileges
                     * @school_id : String - 
                     * @return : modules with default privileges
                     * @Developer : Ashitha
                    */
                };authService.callAPI(PRIVSETTINGSCONSTANT.API_SET_PRIVILEGE_DEFAULT, "POST", dataToSend, function (response) {
                    var result = response.result.data.data;
                    if (result.length > 0) {
                        var selectedModules = result;
                        _.each(selectedModules, function (each) {
                            var finalList = [];
                            _.each(each.feature_role, function (eachItem) {
                                var counts = 0;
                                var resultModule = _.find($scope.selectedModules, function (mod) {
                                    return each.state === mod.state;
                                });
                                //find whether the selected feature is new  or modified 
                                if (resultModule) {
                                    var resObject = _.find(resultModule.staticFeatureRole, function (stat) {
                                        return eachItem.role_id === stat.role_id && eachItem.f_id === stat.f_id;
                                    });
                                }
                                //if modified ,then allowing to save
                                if (resObject) {
                                    _.each(eachItem.privilege, function (data) {
                                        var objec = _.find(resObject.privilege, function (res) {
                                            return res.name === data.name && res.status === data.status;
                                        });
                                        if (objec) {
                                            counts++;
                                        }
                                    });
                                    if (counts != resObject.privilege.length) {
                                        finalList.push(eachItem);
                                    }
                                } else {
                                    //if new and if any of the 'CRUD' item is true,then allowing to save
                                    if (_.compact(_.pluck(eachItem.privilege, 'status')).length > 0) {
                                        finalList.push(eachItem);
                                    }
                                }
                            });

                            each.feature_role = angular.copy(finalList);
                        });
                        if (selectedModules) {
                            /************ API CALL TO UPDATE PRIVILEGE ***********/
                            /* Function to update  privileges
                             * @school_id : String -
                             * @ selected_modules: List of modules
                             * @return : null
                             * @Developer : Ashitha
                            */
                            var objToSend = {
                                selected_modules: angular.copy(selectedModules),
                                school_id: localStorageService.get('school_id'),
                                flag: 1
                            };
                            authService.callAPI(PRIVSETTINGSCONSTANT.API_UPDATE_PRIVILEGE, "POST", objToSend, function (response) {
                                if (response && response.result && response.result.data && response.result.data.message == "Success") {
                                    $scope.loading = false;
                                    toastr.success("Successfully added");
                                    $state.go('privilegeDashboard');
                                } else {
                                    $scope.loading = false;
                                    toastr.error("Try again");
                                }
                            });
                        }
                    } else {
                        $scope.loading = false;
                        toastr.error("Default privileges not found");
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            });
        }
    };
};
PrivilegeSetting.$inject = ["$scope", "$state", "$mdDialog", "localStorageService", "randomColorService", "authService", "PRIVSETTINGSCONSTANT", "$stateParams", "$location", "$anchorScroll", "$rootScope"];

exports.default = PrivilegeSetting;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _textangular = __webpack_require__(441);

var _textangular2 = _interopRequireDefault(_textangular);

var _createTeachingPlan = __webpack_require__(121);

var _createTeachingPlan2 = _interopRequireDefault(_createTeachingPlan);

var _viewTeachingPlan = __webpack_require__(122);

var _viewTeachingPlan2 = _interopRequireDefault(_viewTeachingPlan);

var _createTeachingPlanController = __webpack_require__(361);

var _createTeachingPlanController2 = _interopRequireDefault(_createTeachingPlanController);

var _viewTeachingPlanController = __webpack_require__(363);

var _viewTeachingPlanController2 = _interopRequireDefault(_viewTeachingPlanController);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('app.TeachingPlanModule', ['ui.router'
//import modules
]).component('newTeachingPlan', {
    template: _createTeachingPlan2.default,
    controller: _createTeachingPlanController2.default,
    controllerAs: _createTeachingPlanController2.default
}).controller('tpController', _createTeachingPlanController2.default).component('viewTeachingPlan', {
    template: _viewTeachingPlan2.default,
    controller: _viewTeachingPlanController2.default,
    controllerAs: _viewTeachingPlanController2.default
}).controller('tpViewController', _viewTeachingPlanController2.default);
//import './createTeachingPlan.scss';

/*var module = angular.module('TeachingPlanModule', [
    uiRouter,
    textAngular
]);*/

_module.constant('TPCONSTANT', {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs"
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
        //  flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../src/img/auth/pdf.png",
        //  flash: "../../../../src/img/auth/interactive_anime.png",
        video: '../../../../src/img/auth/video.png',
        weblinks: '../../../../src/img/auth/web.png',
        refbooks: '../../../../src/img/auth/refbook.png',
        activityForm: '../../../../src/img/auth/activity.png',
        khanAcademy: '../../../../src/img/auth/khan_academy.png',
        utubeVideo: '../../../../src/img/auth/utube.png',
        googleDocs: "../../../../src/img/auth/google_docs.png"
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_CREATE_TP: "/v0/teachingPlan/addTeachingPlan/",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_GET_TP_ACTIVITIES_DETAILS: '/v0/teachingPlan/getTeachingPlanActivitiesDetails/',
    API_TP_APPROVERS: "/v0/teachingPlan/approver-list",
    API_SEND_FOR_APPROVAL: "/v0/teachingPlan/send-plan-approval",
    API_REJECT_TP: "/v0/teachingPlan/reject-tp",
    API_APPROVE_TP: "/v0/teachingPlan/approve-tp",
    API_UPDATE_TP: "/v0/teachingPlan/edit-plan",
    API_COMPLETE_TP: "/v0/teachingPlan/complete-status",
    API_SELECT_TP: "/v0/teachingPlan/addTeachingPlanFromArchive",
    API_GET_CURRENT_DATE: "/v0/server/now"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";
}]);

/***/ }),
/* 991 */,
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _groupCreationController = __webpack_require__(419);

var _groupCreationController2 = _interopRequireDefault(_groupCreationController);

var _assignUserController = __webpack_require__(418);

var _assignUserController2 = _interopRequireDefault(_assignUserController);

__webpack_require__(993);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('AssignUserModule', []).controller('assignController', _assignUserController2.default).controller('groupController', _groupCreationController2.default);
_module.constant('ASSIGN_USER_CONSTANT', {
    API_GET_STUDENT_LIST: "/v0/assign-users/student-details/",
    API_GET_ASSIGNED_USERS: "/v0/assign-users/assignee-details/",
    API_GET_GROUP_DETAILS: "/v0/assign-users/get-group-details/",
    API_UPDATE_ASSIGNEE_DETAILS: "/v0/assign-users/update-assignee-details/",
    API_DELETE_GROUP: "/v0/assign-users/delete-group/",
    API_STUDENT_GROUP_DETAILS: "/v0/assign-users/student-group-details/",
    API_ADD_STUDENT_GROUP: "/v0/assign-users/create-group/",
    API_UPDATE_STUDENT_GROUP: "/v0/assign-users/edit-group/",
    API_UPDATE_RESOURCE_ASSIGNEE_DETAILS: "/v0/assign-users/update-resource-assignee-details"

});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider;
    /*.state('assignUsers', {
        parent: 'app',
        url: '/assign-users/:planId',
        params: {
            previousState: {
                state: '',
                params: {}
            }
        },
        views: {
            '@': {
                template: assignUsers,
                controller: assignController,
                controllerAs: 'assignController'
            }
        }
    })
    .state('createGroup', {
        parent: 'app',
        url: '/create-group/:planId/:groupId',
        params: {
            previousState: {}
        },
        views: {
            '@': {
                template: createGroup,
                controller: groupController,
                controllerAs: 'groupController'
            }
        }
    })*/
}]);

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$constant;

__webpack_require__(745);

__webpack_require__(457);

var _studentAttendingPage = __webpack_require__(160);

var _studentAttendingPage2 = _interopRequireDefault(_studentAttendingPage);

var _studentQuestionSelection = __webpack_require__(161);

var _studentQuestionSelection2 = _interopRequireDefault(_studentQuestionSelection);

var _activityList = __webpack_require__(404);

var _activityList2 = _interopRequireDefault(_activityList);

var _createActivity = __webpack_require__(406);

var _createActivity2 = _interopRequireDefault(_createActivity);

var _qpSummary = __webpack_require__(407);

var _qpSummary2 = _interopRequireDefault(_qpSummary);

var _activityPreview = __webpack_require__(409);

var _activityPreview2 = _interopRequireDefault(_activityPreview);

var _formatQuestion = __webpack_require__(408);

var _formatQuestion2 = _interopRequireDefault(_formatQuestion);

var _viewSubmissionList = __webpack_require__(410);

var _viewSubmissionList2 = _interopRequireDefault(_viewSubmissionList);

var _assignStudents = __webpack_require__(411);

var _assignStudents2 = _interopRequireDefault(_assignStudents);

var _createGroup = __webpack_require__(412);

var _createGroup2 = _interopRequireDefault(_createGroup);

var _studentAnswerView = __webpack_require__(157);

var _studentAnswerView2 = _interopRequireDefault(_studentAnswerView);

var _teacherAnswerView = __webpack_require__(159);

var _teacherAnswerView2 = _interopRequireDefault(_teacherAnswerView);

var _studentAttendingPage3 = __webpack_require__(414);

var _studentAttendingPage4 = _interopRequireDefault(_studentAttendingPage3);

var _studentQuestionSelection3 = __webpack_require__(164);

var _studentQuestionSelection4 = _interopRequireDefault(_studentQuestionSelection3);

var _studentViewReport = __webpack_require__(995);

var _studentViewReport2 = _interopRequireDefault(_studentViewReport);

var _teacherViewReport = __webpack_require__(416);

var _teacherViewReport2 = _interopRequireDefault(_teacherViewReport);

var _procturedDocumentsController = __webpack_require__(438);

var _procturedDocumentsController2 = _interopRequireDefault(_procturedDocumentsController);

var _attendeeList = __webpack_require__(417);

var _attendeeList2 = _interopRequireDefault(_attendeeList);

var _reportsMain = __webpack_require__(405);

var _reportsMain2 = _interopRequireDefault(_reportsMain);

var _individualStudentReport = __webpack_require__(172);

var _individualStudentReport2 = _interopRequireDefault(_individualStudentReport);

var _answersheetPreview = __webpack_require__(437);

var _answersheetPreview2 = _interopRequireDefault(_answersheetPreview);

var _answersheetPreview3 = __webpack_require__(78);

var _answersheetPreview4 = _interopRequireDefault(_answersheetPreview3);

var _procturedDocument = __webpack_require__(77);

var _procturedDocument2 = _interopRequireDefault(_procturedDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var name = 'activityList';
var createActivity = "createActivity";
var createQuestion = "createQuestion";
var _module = angular.module("TraditionalActivityModule", []).component('studentAttendingPage', {
    template: _studentAttendingPage2.default,
    controllerAs: 'studentAttendingCtrl',
    controller: _studentAttendingPage4.default
}).component('studentQuestionSelection', {
    template: _studentQuestionSelection2.default,
    controllerAs: 'studentQuestionCtrl',
    controller: _studentQuestionSelection4.default
}).component('answersheetPreview', {
    template: _answersheetPreview4.default,
    controller: _answersheetPreview2.default,
    controllerAs: 'answersheetPreview'
}).controller('activityListCtrl', _activityList2.default).controller('createActivityCtrl', _createActivity2.default).controller('qpSummaryCtrl', _qpSummary2.default).controller('activityPreviewCtrl', _activityPreview2.default).controller('formatQuestionCtrl', _formatQuestion2.default).controller('viewSubmissionListCtrl', _viewSubmissionList2.default).controller('assignStudentsCtrl', _assignStudents2.default).controller('createStudentGroupCtrl', _createGroup2.default).controller('studentAnswerViewCtrl', _studentAnswerView2.default).controller('teacherAnswerViewCtrl', _teacherAnswerView2.default).controller('studentAttendingCtrl', _studentAttendingPage4.default).controller('studentQuestionCtrl', _studentQuestionSelection4.default).controller('studentViewReportCtrl', _studentViewReport2.default).controller('teacherViewReportCtrl', _teacherViewReport2.default).controller('attendeeListCtrl', _attendeeList2.default).controller('reportsMainCtrl', _reportsMain2.default).controller('individualStudentTraditionalReportCtrl', _individualStudentReport2.default).controller('ProcturedDocumentController', _procturedDocumentsController2.default);

_module.constant('TPWIZARDCONSTANT', (_module$constant = {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs"
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
        // flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../../img/auth/pdf.png",
        // flash: "../../../../../src/img/auth/interactive_anime.png",
        video: '../../../../../img/auth/video.png',
        weblinks: '../../../../../img/auth/web.png',
        refbooks: '../../../../../img/auth/refbook.png',
        activityForm: '../../../../../img/auth/activity.png',
        khanAcademy: '../../../../../img/auth/khan_academy.png',
        utubeVideo: '../../../../../img/auth/utube.png',
        googleDocs: "../../../../../img/auth/google_docs.png"
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_SAVE_WEBLINK: "/v0/tp-resources/weblink/save",
    API_SAVE_REFBOOK: "/v0/tp-resources/refbook/save",
    API_SAVE_GOOGLEDOCS: "/v0/tp-resources/googledoc/save",
    API_SAVE_UTUBE: "/v0/tp-resources/youtube/save",
    API_SAVE_KHANACADEMY: "/v0/tp-resources/khanacademy/save",
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/",
    API_GET_FORMAT_QP: "/v0/tp-activity/format-qp",
    API_GET_TP_ACTIVITY: "/v0/tp-activity/get-activity/",
    API_SAVE_SECTION: "/v0/tp-activity/save-section",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_QUESTION: "/v0/tp-activity/add-questions",
    API_AUTO_FORMAT: "/v0/tp-activity/auto-format",
    API_SELECT_QP: "/v0/tp-activity/create-qp-from-qp",
    API_SELECT_TEMPLATE: "/v0/tp-activity/qp/template",
    API_GET_QP_SUMMARY: "/v0/tp-activity/summary/",
    API_SAVE_FLASH: "/v0/tp-resources/flash/save",
    API_SAVE_VIDEO: "/v0/tp-resources/video/save",
    API_SAVE_PDF: "/v0/tp-resources/pdf/save",
    API_ADD_PDF_ANNOTATION: '/v0/tp-resources/annotation/add-annotation',
    API_FETCH_ANNOTATION: "/v0/tp-resources/annotation/fetch",
    API_REMOVE_ANNOTATION: "/v0/tp-resources/annotation/remove-page-annotation",
    API_UPDATE_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-page-annotation",
    API_UPDATE_ALL_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-all-page-annotation",
    API_APPROVE_RESOURCE: "/v0/tp-resources/approve-resource",
    API_GET_ACTIVITY_REPORT: "/v0/tp-reports/assessment-activity-based-report/"
}, _defineProperty(_module$constant, 'API_APPROVE_RESOURCE', "/v0/tp-resources/approve-resource"), _defineProperty(_module$constant, 'API_GET_STUDENTS', "/v0/tp-reports/student-details"), _defineProperty(_module$constant, 'API_GET_ALL_ACTIVITY', "/v0/tp-reports/activity-list/"), _defineProperty(_module$constant, 'API_ADD_LEARNING_PROGRESS', "/v0/tp-resources/learning-progress/save"), _defineProperty(_module$constant, 'API_ADD_NOTES', "/v0/tp-resources/add-note"), _defineProperty(_module$constant, 'API_GET_PREV_NOTES', "/v0/tp-resources/get-previous-note"), _defineProperty(_module$constant, 'API_GET_STUDENT_REPORT', "/v0/tp-reports/assessment-activity-student-based-report/"), _defineProperty(_module$constant, 'API_GET_ASSIGNED_RESOURCES', "/v0/tp-reports/assigned-resources/"), _defineProperty(_module$constant, 'API_GET_LEARNING_PROGRESS', "/v0/tp-reports/learning-progress"), _defineProperty(_module$constant, 'API_GET_ALL_PRACTICE_ACTIVITY', "/v0/tp-reports/practice-activity-list/"), _defineProperty(_module$constant, 'API_GET_PRACTICE_ACTIVITY_REPORT', "/v0/tp-reports/practice-activity-based-report/"), _defineProperty(_module$constant, 'API_GET_STUDENT_PRACTICE_REPORT', "/v0/tp-reports/practice-activity-student-based-report/"), _defineProperty(_module$constant, 'API_COMPLETE_RESOURCE', "/v0/teachingPlan/resource-complete/"), _module$constant));
_module.constant("activityCons", {
    API_GET_ALL_ACTIVITY: "/v0/traditional/get-activity",
    API_GET_STUDENT_ACTIVITY: "/v0/traditional/get-assigned-students/",
    API_GET_TRADITIONAL_ACTIVITY: "/v0/traditional/format-qp/",
    API_GET_THEMES: "/v0/traditional/theme-details",
    API_ADD_ACTIVITY_TO_QP: "/v0/traditional/qp/save",
    API_UPDATE_ACTIVITY_QP: "/v0/traditional/update-title-theme",
    API_GET_STRANDS_WAVE: "/v0/traditional/get-wave-strands-tag/",
    API_GET_QUESTION: "/v0/tp-activity/get-question/",
    API_GET_EXAM_QUESTIONS: "/v0/qp/exam/questions/",
    API_SUBMIT_EXAM_QUESTION: "/v0/qp/exam/answer",
    API_GET_QP_SUMMARY: "/v0/qp/summary",
    API_SUBMIT_EXAM: "/v0/qp/exam/submit",
    API_STOP_EXAM: "/v0/qp/exam/stop",
    API_START_EXAM: "/v0/qp/exam/start",
    API_GET_SCHOOL_DETAILS: "/v0/teachingPlan/school-details/",
    API_CURRENT_DATE: "/v0/teachingPlan/current-date",
    API_ACTIVITY_PREVIEW: "/v0/traditional/activity-preview/",
    API_QP_DETAILS: "/v0/traditional/qp/details/",
    API_GET_QP_DETAILS: "/v0/traditional/qp/details/",
    API_GET_QP_ATTENDEE_DETAILS: "/v0/traditional/qp/attendeelist/",
    API_GET_ANSWER_DETAILS: "/v0/traditional/answer/details/",
    API_GET_EXAM_AND_QB_DETAILS: "/v0/traditional/exam/qb/details/",
    API_UPDATE_EXAM_SCORE: "/v0/traditional/exam/score/update",
    API_SAVE_SECTION: "/v0/traditional/save-section",
    API_SAVE_QP: "/v0/traditional/qp/update",
    API_SAVE_PASSWORD: "/v0/traditional/activity-password/",
    API_UPDATE_ASSIGNEE_DETAILS: "/v0/assign-users/activity-assignee-details",
    API_GET_STUDENT_LIST: "/v0/assign-users/student-details/",
    API_GET_ASSIGNED_USERS: "/v0/assign-users/activity-students/",
    API_GET_GROUP_DETAILS: "/v0/assign-users/get-group-details/",
    API_DELETE_GROUP: "/v0/assign-users/delete-group/",
    API_STUDENT_GROUP_DETAILS: "/v0/assign-users/student-group-details/",
    API_ADD_STUDENT_GROUP: "/v0/assign-users/create-group/",
    API_UPDATE_STUDENT_GROUP: "/v0/assign-users/edit-group/",
    API_GET_FETCH_MY_ANSWER: "/v0/traditional/fetch-answer/",
    SKILL_LIST: ["Analysing", "Applying", "Creating", "Evaluating", "Recall", "Understanding"],
    QUESTION_TYPE_DETAILS: {
        MCQ: "Multiple choice question",
        FIB: "Fill in the blanks",
        MTF: "Match the following",
        OWQ: "One word question",
        TF: "True or False",
        SA: "Short answer question",
        LA: "Long answer question",
        IBT_MCQ: "IBT - Multiple choice question",
        IBT_FIB: "IBT - Fill in the blanks",
        DRAW: "Drawing",
        ASLSPEAK: "ASL - Speaking",
        ASLLISTEN: "ASL - Listening",
        PASSAGE: "Passage"
    },
    API_SELECT_QP: "/v0/traditional/create-qp-from-qp",
    API_SELECT_QUESTION: "/v0/traditional/add-questions",
    API_STUDENT_QUESTION: "/v0/traditional/student/question/",
    API_AUTO_FORMAT: "/v0/traditional/auto-format",
    API_DELETE_QP: "/v0/traditional/delete-qp/",
    API_SCHEDULE_EXAM: "/v0/traditional/update-due-date",
    API_APPROVER_LIST: "/v0/traditional/qp/approvers",
    API_SEND_FOR_APPROVAL: "/v0/traditional/qp/send-for-approval",
    API_APPROVE_QP: "/v0/traditional/qp/approve/",
    API_REJECT_QP: "/v0/traditional/qp/reject/",
    API_PUBLISH_RESULT: "/v0/traditional/publish-result/",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_TEMPLATE: "/v0/traditional/qp/create-from-template",
    API_STUDENT_REPORT: "/v0/traditional/student-report/",
    API_GET_STUDENT_ANSWER_DETAILS: "/v0/traditional/studentanswer/details/"
});

_module.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";
}]);
_module.service('qpHandler', function () {
    return {
        updateParentVisibility: function updateParentVisibility(authService, args) {
            var url = '/v0/qp/parentvisibility/update';
            var method = "POST";
            var msg = 'now the activity is visible to parents';
            if (!args.is_visibleto_parents) {
                msg = 'now the activity is not visible to parents';
            }
            var req = {
                school_id: args.school_id,
                qp_id: args.qp_id,
                is_visibleto_parents: args.is_visibleto_parents
            };
            authService.callAPI(url, method, req, function (response) {
                if (response.result && response.result.data && response.result.data.details) {
                    args.toastr.success("Updated, " + msg);
                } else {
                    args.toastr.error("Network error");
                }
            });
        }
    };
});

_module.filter('safeHtml', ["$sce", function ($sce) {
    return function (val) {
        return $sce.trustAsHtml(val);
    };
}]);

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * File: studentViewReport.js
 * Project: educore
 * Created Date: 2019-01-09
 * Author: Raziya S
 *
 */
var StudentViewReport =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", function StudentViewReport($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, StudentViewReport);

    var qpId = $stateParams.qpId;
    var studentId = $stateParams.studentId;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    $scope.isLoading = true;
    //[Object] - dataset for wave details
    $scope.waveDetails = [];

    //[Object] - dataset for level details
    $scope.levelDetails = [];

    //[Object] - dataset for tag
    $scope.tagDetails = [];

    //[String] - List of tags label
    $scope.tagLabel = [];

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 610;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#109618', '#f44336'];

    /*
     * Function to get assigned users
     * 
     * @qpId : String - Id of the question paper
     * 
     *
     */
    authService.callAPI(activityCons.API_STUDENT_REPORT + qpId + '/' + studentId, "GET", {}, function (response) {
        console.log(response);
        if (response && response.result && response.result.data) {
            var resultData = response.result.data;
            console.log(resultData.basicDetails);
            if (resultData.basicDetails) {
                $scope.studentName = resultData.basicDetails.studentName;
                $scope.examTitle = resultData.basicDetails.examTitle;
                $scope.isLoading = false;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails[0].questionDetail && resultData.graphDetails[0].questionDetail) {
                        if (resultData.graphDetails[0].questionDetail.length > 0) {
                            var questionDetails = resultData.graphDetails[0].questionDetail[0];
                            var values = [];
                            var header = [];
                            header.push("Activity");
                            header.push("Total Questions");
                            header.push("No. of Correct Answers");
                            header.push("No. of Wrong Answers");
                            values.push(header);
                            var wrongAnswer = questionDetails.total_question - questionDetails.correct_answer;

                            var arr = [];
                            arr.push("");
                            arr.push(questionDetails.total_question);
                            arr.push(questionDetails.correct_answer);
                            arr.push(wrongAnswer);
                            values.push(arr);

                            $scope.quesObj = {
                                'key': "activity",
                                'graph': "Bar",
                                'title': "Activity" + '  vs  ' + "Questions",
                                'value': values
                            };
                            $scope.chartArray.push($scope.quesObj);
                        }
                    }
                    if (resultData.graphDetails[0].waveDetails && resultData.graphDetails[0].waveDetails) {
                        if (resultData.graphDetails[0].waveDetails.length > 0) {
                            var waveDetails = resultData.graphDetails[0].waveDetails;
                            var _values = [];
                            var _header = [];
                            _header.push("Wave");
                            _header.push("Total Questions");
                            _header.push("No. of Correct Answers");
                            //header.push("No. of Wrong Answers")
                            _values.push(_header);
                            _.each(waveDetails, function (data) {
                                var arr = [];
                                arr.push(data.wave.wave);
                                arr.push(data.activity[0].total_questions);
                                arr.push(data.activity[0].correct_answer);
                                //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                //arr.push(wrongAnswer)
                                _values.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "wave",
                                'graph': "Bar",
                                'title': "Wave" + '  vs  ' + "Count",
                                'value': _values
                            };
                            $scope.chartArray.push($scope.tagObj);
                        }
                    }
                    if (resultData.graphDetails[0].tagDetails && resultData.graphDetails[0].tagDetails) {
                        if (resultData.graphDetails[0].tagDetails.length > 0) {
                            var tagDetails = resultData.graphDetails[0].tagDetails;
                            var _values2 = [];
                            var _header2 = [];
                            _header2.push("Tag");
                            _header2.push("Total Questions");
                            _header2.push("No. of Correct Answers");
                            //header.push("No. of Wrong Answers")
                            _values2.push(_header2);
                            _.each(tagDetails, function (data) {
                                var arr = [];
                                arr.push(data._id);
                                arr.push(data.activity[0].total_questions);
                                arr.push(data.activity[0].correct_answer);
                                //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                //arr.push(wrongAnswer)
                                _values2.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "tag",
                                'graph': "Bar",
                                'title': "Tag" + '  vs  ' + "Count",
                                'value': _values2
                            };
                            $scope.chartArray.push($scope.tagObj);
                        }
                    }
                    if (resultData.graphDetails[0].levelDetails && resultData.graphDetails[0].levelDetails) {
                        if (resultData.graphDetails[0].levelDetails.length > 0) {
                            var levelDetails = resultData.graphDetails[0].levelDetails;
                            var _values3 = [];
                            var _header3 = [];
                            _header3.push("Level");
                            _header3.push("Total Questions");
                            _header3.push("No. of Correct Answers");
                            //header.push("No. of Wrong Answers")
                            _values3.push(_header3);
                            _.each(levelDetails, function (data) {
                                var arr = [];
                                arr.push(data.level.level);
                                arr.push(data.activity[0].total_questions);
                                arr.push(data.activity[0].correct_answer);
                                //let wrongAnswer = data.activity[0].total_questions - data.activity[0].correct_answer
                                //arr.push(wrongAnswer)
                                _values3.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "level",
                                'graph': "Bar",
                                'title': "Level" + '  vs  ' + "Count",
                                'value': _values3
                            };
                            $scope.chartArray.push($scope.tagObj);
                        }
                    }
                }
            }
        } else {
            // toastr.error('Network Error. Please try later');
        }
        _.defer(function () {
            $scope.$apply();
        });
    });

    //Object - details of tp and student
    var details = {
        studentId: $stateParams.studentId,
        tpId: $stateParams.planId
    };
    $scope.barOptions = {
        responsive: true,
        maintainAspectRatio: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
    };$scope.goBack = function () {
        var params = $stateParams.prevParams;
        $state.go("wizard.activityReport", params);
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    $scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Student Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = StudentViewReport;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _manageList = __webpack_require__(124);

var _manageList2 = _interopRequireDefault(_manageList);

var _managelistController = __webpack_require__(366);

var _managelistController2 = _interopRequireDefault(_managelistController);

__webpack_require__(997);

var _subjectProperty = __webpack_require__(367);

var _subjectProperty2 = _interopRequireDefault(_subjectProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//import homeFctr from './services/homeFactory';
//import userSrv from './services/userService'

//module.service('homeFactory', homeFctr);
//module.service('userService', userSrv);


// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('manageReportCards', {
//             parent: 'app',
//             url: '/manage-report-cards',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'manageReportCardsCtrl'
//                 }
//             }
//         })

// });
var _module = angular.module('ManageReportsModule', [
    //import modules
]).controller('manageReportCards', _managelistController2.default);

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportcardController = __webpack_require__(370);

var _reportcardController2 = _interopRequireDefault(_reportcardController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ReportCardListsModule', []).controller('reportCardListing', _reportcardController2.default);

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reportView = __webpack_require__(1000);

var _reportView2 = _interopRequireDefault(_reportView);

var _type1Mark = __webpack_require__(1004);

var _type1Mark2 = _interopRequireDefault(_type1Mark);

var _type2Mark = __webpack_require__(1005);

var _type2Mark2 = _interopRequireDefault(_type2Mark);

var _reportApprovalPopUp = __webpack_require__(1006);

var _reportApprovalPopUp2 = _interopRequireDefault(_reportApprovalPopUp);

var _type3Sub_skill = __webpack_require__(1007);

var _type3Sub_skill2 = _interopRequireDefault(_type3Sub_skill);

var _type1Grade = __webpack_require__(1008);

var _type1Grade2 = _interopRequireDefault(_type1Grade);

var _periodicTestHf = __webpack_require__(1009);

var _periodicTestHf2 = _interopRequireDefault(_periodicTestHf);

var _periodicTestAnnual = __webpack_require__(1010);

var _periodicTestAnnual2 = _interopRequireDefault(_periodicTestAnnual);

var _skill_only = __webpack_require__(1011);

var _skill_only2 = _interopRequireDefault(_skill_only);

var _type4Mark = __webpack_require__(1012);

var _type4Mark2 = _interopRequireDefault(_type4Mark);

var _type4Annual = __webpack_require__(1013);

var _type4Annual2 = _interopRequireDefault(_type4Annual);

var _periodicTestHf3 = __webpack_require__(1014);

var _periodicTestHf4 = _interopRequireDefault(_periodicTestHf3);

var _periodicTestAnnualTwo = __webpack_require__(1015);

var _periodicTestAnnualTwo2 = _interopRequireDefault(_periodicTestAnnualTwo);

var _hss = __webpack_require__(1016);

var _hss2 = _interopRequireDefault(_hss);

var _cbse_hss = __webpack_require__(1017);

var _cbse_hss2 = _interopRequireDefault(_cbse_hss);

var _term1halfyearly = __webpack_require__(1018);

var _term1halfyearly2 = _interopRequireDefault(_term1halfyearly);

var _kbhfhss = __webpack_require__(1019);

var _kbhfhss2 = _interopRequireDefault(_kbhfhss);

var _grade9Annual = __webpack_require__(1020);

var _grade9Annual2 = _interopRequireDefault(_grade9Annual);

var _grade1_8Annual = __webpack_require__(1021);

var _grade1_8Annual2 = _interopRequireDefault(_grade1_8Annual);

var _annual_cbse_hss = __webpack_require__(1022);

var _annual_cbse_hss2 = _interopRequireDefault(_annual_cbse_hss);

var _termAnnualOnly = __webpack_require__(1023);

var _termAnnualOnly2 = _interopRequireDefault(_termAnnualOnly);

var _kb_hss_annual = __webpack_require__(1024);

var _kb_hss_annual2 = _interopRequireDefault(_kb_hss_annual);

var _periodicTestHfKb = __webpack_require__(1025);

var _periodicTestHfKb2 = _interopRequireDefault(_periodicTestHfKb);

var _hf1Exam = __webpack_require__(1026);

var _hf1Exam2 = _interopRequireDefault(_hf1Exam);

var _reportCardEditValidationPopup = __webpack_require__(1027);

var _reportCardEditValidationPopup2 = _interopRequireDefault(_reportCardEditValidationPopup);

var _type5_9_10_grade_term = __webpack_require__(1028);

var _type5_9_10_grade_term2 = _interopRequireDefault(_type5_9_10_grade_term);

var _type5_9_10_grade_term3 = __webpack_require__(1029);

var _type5_9_10_grade_term4 = _interopRequireDefault(_type5_9_10_grade_term3);

var _type5_6_8_grade_term = __webpack_require__(1030);

var _type5_6_8_grade_term2 = _interopRequireDefault(_type5_6_8_grade_term);

var _type5_6_8_grade_term3 = __webpack_require__(1031);

var _type5_6_8_grade_term4 = _interopRequireDefault(_type5_6_8_grade_term3);

var _type5_6_7_grade_term = __webpack_require__(1032);

var _type5_6_7_grade_term2 = _interopRequireDefault(_type5_6_7_grade_term);

var _type7_1_2_grade_term = __webpack_require__(1033);

var _type7_1_2_grade_term2 = _interopRequireDefault(_type7_1_2_grade_term);

var _type6_6_7_grade_term = __webpack_require__(1034);

var _type6_6_7_grade_term2 = _interopRequireDefault(_type6_6_7_grade_term);

var _type5_3_5_grade_term = __webpack_require__(1035);

var _type5_3_5_grade_term2 = _interopRequireDefault(_type5_3_5_grade_term);

var _type5_8_grade_term = __webpack_require__(1036);

var _type5_8_grade_term2 = _interopRequireDefault(_type5_8_grade_term);

var _type5_1_2_grade_term = __webpack_require__(1037);

var _type5_1_2_grade_term2 = _interopRequireDefault(_type5_1_2_grade_term);

var _type6_1_2_grade_term = __webpack_require__(1038);

var _type6_1_2_grade_term2 = _interopRequireDefault(_type6_1_2_grade_term);

var _type6_3_5_grade_term = __webpack_require__(1039);

var _type6_3_5_grade_term2 = _interopRequireDefault(_type6_3_5_grade_term);

var _type5_1_5_grade_term = __webpack_require__(1040);

var _type5_1_5_grade_term2 = _interopRequireDefault(_type5_1_5_grade_term);

var _type5_1_5_grade_term3 = __webpack_require__(1041);

var _type5_1_5_grade_term4 = _interopRequireDefault(_type5_1_5_grade_term3);

var _type5_KB_10_grade_term = __webpack_require__(1042);

var _type5_KB_10_grade_term2 = _interopRequireDefault(_type5_KB_10_grade_term);

var _type5_KB_10_grade_term3 = __webpack_require__(1043);

var _type5_KB_10_grade_term4 = _interopRequireDefault(_type5_KB_10_grade_term3);

var _type5_KB_8_9_grade_term = __webpack_require__(1044);

var _type5_KB_8_9_grade_term2 = _interopRequireDefault(_type5_KB_8_9_grade_term);

var _type5_KB_8_9_grade_term3 = __webpack_require__(1045);

var _type5_KB_8_9_grade_term4 = _interopRequireDefault(_type5_KB_8_9_grade_term3);

var _type5_KB_8_9_grade_term5 = __webpack_require__(1046);

var _type5_KB_8_9_grade_term6 = _interopRequireDefault(_type5_KB_8_9_grade_term5);

var _type_6_model_exam_ = __webpack_require__(1047);

var _type_6_model_exam_2 = _interopRequireDefault(_type_6_model_exam_);

var _type_6_model_exam_1_nineten = __webpack_require__(1048);

var _type_6_model_exam_1_nineten2 = _interopRequireDefault(_type_6_model_exam_1_nineten);

var _type_6_model_exam_2_nineten = __webpack_require__(1049);

var _type_6_model_exam_2_nineten2 = _interopRequireDefault(_type_6_model_exam_2_nineten);

var _type_6_model_exam_3 = __webpack_require__(1050);

var _type_6_model_exam_4 = _interopRequireDefault(_type_6_model_exam_3);

var _type_6_model_annualexam_ = __webpack_require__(1051);

var _type_6_model_annualexam_2 = _interopRequireDefault(_type_6_model_annualexam_);

var _calicut_annual = __webpack_require__(1052);

var _calicut_annual2 = _interopRequireDefault(_calicut_annual);

var _type9_cbse_pt = __webpack_require__(1053);

var _type9_cbse_pt2 = _interopRequireDefault(_type9_cbse_pt);

var _type9_term1_hf = __webpack_require__(1054);

var _type9_term1_hf2 = _interopRequireDefault(_type9_term1_hf);

var _type9_term2_ae = __webpack_require__(1055);

var _type9_term2_ae2 = _interopRequireDefault(_type9_term2_ae);

var _type9_grade12term2_ae = __webpack_require__(1056);

var _type9_grade12term2_ae2 = _interopRequireDefault(_type9_grade12term2_ae);

var _type9_kb_unit_test = __webpack_require__(1057);

var _type9_kb_unit_test2 = _interopRequireDefault(_type9_kb_unit_test);

var _type9_kbterm1_hf = __webpack_require__(1058);

var _type9_kbterm1_hf2 = _interopRequireDefault(_type9_kbterm1_hf);

var _type9_kbterm = __webpack_require__(1059);

var _type9_kbterm2 = _interopRequireDefault(_type9_kbterm);

var _type9_kbterm3 = __webpack_require__(1060);

var _type9_kbterm4 = _interopRequireDefault(_type9_kbterm3);

var _type12_termcbse = __webpack_require__(1061);

var _type12_termcbse2 = _interopRequireDefault(_type12_termcbse);

var _type12_ninetentermcbse = __webpack_require__(1062);

var _type12_ninetentermcbse2 = _interopRequireDefault(_type12_ninetentermcbse);

var _elt_report = __webpack_require__(1063);

var _elt_report2 = _interopRequireDefault(_elt_report);

var _type20_KB_10_grade_term = __webpack_require__(1064);

var _type20_KB_10_grade_term2 = _interopRequireDefault(_type20_KB_10_grade_term);

var _type20_termcbse = __webpack_require__(1065);

var _type20_termcbse2 = _interopRequireDefault(_type20_termcbse);

var _type20_termcbse3 = __webpack_require__(1066);

var _type20_termcbse4 = _interopRequireDefault(_type20_termcbse3);

var _type20_term2cbse = __webpack_require__(1067);

var _type20_term2cbse2 = _interopRequireDefault(_type20_term2cbse);

var _type20_term2cbse3 = __webpack_require__(1068);

var _type20_term2cbse4 = _interopRequireDefault(_type20_term2cbse3);

var _type20_KB_10_grade_term3 = __webpack_require__(1069);

var _type20_KB_10_grade_term4 = _interopRequireDefault(_type20_KB_10_grade_term3);

var _type30_KB_grade_term = __webpack_require__(1070);

var _type30_KB_grade_term2 = _interopRequireDefault(_type30_KB_grade_term);

var _type30_KB_grade_term3 = __webpack_require__(1071);

var _type30_KB_grade_term4 = _interopRequireDefault(_type30_KB_grade_term3);

var _type30_KB_grade_term5 = __webpack_require__(1072);

var _type30_KB_grade_term6 = _interopRequireDefault(_type30_KB_grade_term5);

var _type30_KB_grade_term1_new = __webpack_require__(1073);

var _type30_KB_grade_term1_new2 = _interopRequireDefault(_type30_KB_grade_term1_new);

var _type30_KB_grade_term2_new = __webpack_require__(1074);

var _type30_KB_grade_term2_new2 = _interopRequireDefault(_type30_KB_grade_term2_new);

var _type30_KB_grade_term3_new = __webpack_require__(1075);

var _type30_KB_grade_term3_new2 = _interopRequireDefault(_type30_KB_grade_term3_new);

var _type8to10_termcbse = __webpack_require__(1076);

var _type8to10_termcbse2 = _interopRequireDefault(_type8to10_termcbse);

var _typetermcbse_8to = __webpack_require__(1077);

var _typetermcbse_8to2 = _interopRequireDefault(_typetermcbse_8to);

var _type6to7_alncbse = __webpack_require__(1078);

var _type6to7_alncbse2 = _interopRequireDefault(_type6to7_alncbse);

var _type6to7_tcscbse = __webpack_require__(1079);

var _type6to7_tcscbse2 = _interopRequireDefault(_type6to7_tcscbse);

var _type3to5_tcscbse = __webpack_require__(1080);

var _type3to5_tcscbse2 = _interopRequireDefault(_type3to5_tcscbse);

var _type3to5_alncbse = __webpack_require__(1081);

var _type3to5_alncbse2 = _interopRequireDefault(_type3to5_alncbse);

var _type1to2_tcscbse = __webpack_require__(1082);

var _type1to2_tcscbse2 = _interopRequireDefault(_type1to2_tcscbse);

var _type10_KB_grade_term = __webpack_require__(1083);

var _type10_KB_grade_term2 = _interopRequireDefault(_type10_KB_grade_term);

var _type10_KB_grade_term3 = __webpack_require__(1084);

var _type10_KB_grade_term4 = _interopRequireDefault(_type10_KB_grade_term3);

var _type10_KB_grade11_12_term = __webpack_require__(1085);

var _type10_KB_grade11_12_term2 = _interopRequireDefault(_type10_KB_grade11_12_term);

var _type10_KB_grade11_12_term3 = __webpack_require__(1086);

var _type10_KB_grade11_12_term4 = _interopRequireDefault(_type10_KB_grade11_12_term3);

var _type10_KB_grade11_12_term1_new = __webpack_require__(1087);

var _type10_KB_grade11_12_term1_new2 = _interopRequireDefault(_type10_KB_grade11_12_term1_new);

var _type10_KB_grade11_12_term2_new = __webpack_require__(1088);

var _type10_KB_grade11_12_term2_new2 = _interopRequireDefault(_type10_KB_grade11_12_term2_new);

var _type02grade_11_science = __webpack_require__(1089);

var _type02grade_11_science2 = _interopRequireDefault(_type02grade_11_science);

var _type02grade_11_sciencet = __webpack_require__(1090);

var _type02grade_11_sciencet2 = _interopRequireDefault(_type02grade_11_sciencet);

var _type02grade_12_science = __webpack_require__(1091);

var _type02grade_12_science2 = _interopRequireDefault(_type02grade_12_science);

var _type02grade_12_sciencet = __webpack_require__(1092);

var _type02grade_12_sciencet2 = _interopRequireDefault(_type02grade_12_sciencet);

var _type5_3_5_grade_term3 = __webpack_require__(1093);

var _type5_3_5_grade_term4 = _interopRequireDefault(_type5_3_5_grade_term3);

var _type6_6_7_grade_term3 = __webpack_require__(1094);

var _type6_6_7_grade_term4 = _interopRequireDefault(_type6_6_7_grade_term3);

var _type8to10_termcbseterm = __webpack_require__(1095);

var _type8to10_termcbseterm2 = _interopRequireDefault(_type8to10_termcbseterm);

var _type5_1_2_grade_term3 = __webpack_require__(1096);

var _type5_1_2_grade_term4 = _interopRequireDefault(_type5_1_2_grade_term3);

var _type1to2shjcbset = __webpack_require__(1097);

var _type1to2shjcbset2 = _interopRequireDefault(_type1to2shjcbset);

var _type1to2_tcscbse_term = __webpack_require__(1098);

var _type1to2_tcscbse_term2 = _interopRequireDefault(_type1to2_tcscbse_term);

var _type6to7_tcscbseterm = __webpack_require__(1099);

var _type6to7_tcscbseterm2 = _interopRequireDefault(_type6to7_tcscbseterm);

var _type3to5_tcscbseterm = __webpack_require__(1100);

var _type3to5_tcscbseterm2 = _interopRequireDefault(_type3to5_tcscbseterm);

var _type6_3_5_grade_term3 = __webpack_require__(1101);

var _type6_3_5_grade_term4 = _interopRequireDefault(_type6_3_5_grade_term3);

var _type5_6_7_grade_term3 = __webpack_require__(1102);

var _type5_6_7_grade_term4 = _interopRequireDefault(_type5_6_7_grade_term3);

var _type5_8_grade_term3 = __webpack_require__(1103);

var _type5_8_grade_term4 = _interopRequireDefault(_type5_8_grade_term3);

var _type7_1_2_grade_term3 = __webpack_require__(1104);

var _type7_1_2_grade_term4 = _interopRequireDefault(_type7_1_2_grade_term3);

var _type3to5_alncbseterm = __webpack_require__(1105);

var _type3to5_alncbseterm2 = _interopRequireDefault(_type3to5_alncbseterm);

var _type6to7_alncbse_term = __webpack_require__(1106);

var _type6to7_alncbse_term2 = _interopRequireDefault(_type6to7_alncbse_term);

var _typetermcbse_8to10_term = __webpack_require__(1107);

var _typetermcbse_8to10_term2 = _interopRequireDefault(_typetermcbse_8to10_term);

var _pt_1_no_conv = __webpack_require__(1108);

var _pt_1_no_conv2 = _interopRequireDefault(_pt_1_no_conv);

var _updateLog = __webpack_require__(1109);

var _updateLog2 = _interopRequireDefault(_updateLog);

var _type1to5_tcscbse_new = __webpack_require__(1110);

var _type1to5_tcscbse_new2 = _interopRequireDefault(_type1to5_tcscbse_new);

var _type1to5_tcscbseterm2_new = __webpack_require__(1111);

var _type1to5_tcscbseterm2_new2 = _interopRequireDefault(_type1to5_tcscbseterm2_new);

var _type5_1_2_grade_term1_new = __webpack_require__(1112);

var _type5_1_2_grade_term1_new2 = _interopRequireDefault(_type5_1_2_grade_term1_new);

var _type5_1_2_grade_term2_new = __webpack_require__(1113);

var _type5_1_2_grade_term2_new2 = _interopRequireDefault(_type5_1_2_grade_term2_new);

var _type5_3_5_grade_term1_new = __webpack_require__(1114);

var _type5_3_5_grade_term1_new2 = _interopRequireDefault(_type5_3_5_grade_term1_new);

var _type5_3_5_grade_term2_new = __webpack_require__(1115);

var _type5_3_5_grade_term2_new2 = _interopRequireDefault(_type5_3_5_grade_term2_new);

var _type6_6_7_grade_term1_new = __webpack_require__(1116);

var _type6_6_7_grade_term1_new2 = _interopRequireDefault(_type6_6_7_grade_term1_new);

var _type6_6_7_grade_term2_new = __webpack_require__(1117);

var _type6_6_7_grade_term2_new2 = _interopRequireDefault(_type6_6_7_grade_term2_new);

var _type8to10_termcbse_new = __webpack_require__(1118);

var _type8to10_termcbse_new2 = _interopRequireDefault(_type8to10_termcbse_new);

var _type8to10_termcbseterm2_new = __webpack_require__(1119);

var _type8to10_termcbseterm2_new2 = _interopRequireDefault(_type8to10_termcbseterm2_new);

var _type9_termcbse_new = __webpack_require__(1120);

var _type9_termcbse_new2 = _interopRequireDefault(_type9_termcbse_new);

var _type9_termcbseterm2_new = __webpack_require__(1121);

var _type9_termcbseterm2_new2 = _interopRequireDefault(_type9_termcbseterm2_new);

var _type10_termcbse_new = __webpack_require__(1122);

var _type10_termcbse_new2 = _interopRequireDefault(_type10_termcbse_new);

var _type10_termcbseterm2_new = __webpack_require__(1123);

var _type10_termcbseterm2_new2 = _interopRequireDefault(_type10_termcbseterm2_new);

var _type02grade_11_science_new = __webpack_require__(1124);

var _type02grade_11_science_new2 = _interopRequireDefault(_type02grade_11_science_new);

var _type02grade_11_sciencet2_new = __webpack_require__(1125);

var _type02grade_11_sciencet2_new2 = _interopRequireDefault(_type02grade_11_sciencet2_new);

var _type02grade_12_science_new = __webpack_require__(1126);

var _type02grade_12_science_new2 = _interopRequireDefault(_type02grade_12_science_new);

var _type02grade_12_sciencet2_new = __webpack_require__(1127);

var _type02grade_12_sciencet2_new2 = _interopRequireDefault(_type02grade_12_sciencet2_new);

var _type10_KB_grade_term1_new = __webpack_require__(1128);

var _type10_KB_grade_term1_new2 = _interopRequireDefault(_type10_KB_grade_term1_new);

var _type10_KB_grade_term2_new = __webpack_require__(1129);

var _type10_KB_grade_term2_new2 = _interopRequireDefault(_type10_KB_grade_term2_new);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
// import type_aln_1_2_Term1_template from './views/generated-templates/typealn_1_2_grade_term1.html';

// import type_5_3_5_Term1_template from './views/generated-templates/type5_1_5_grade_term2.html';
// import type_5_1_5_Term3_template from './views/generated-templates/type5_1_5_grade_term3.html';


// NEW26 Teacher Templates


var name = 'viewGeneratedReportData';

var reportGeneratedViewController = function reportGeneratedViewController($scope, $state, $window, $mdMedia, $mdDialog, $stateParams, authService, localStorageService, rcConstants, CONSTANTS, $sce, $rootScope, RC_CONSTANTS_) {
    'ngInject';

    DialogController.$inject = ["$scope", "$mdDialog", "updateLogs"];
    _classCallCheck(this, reportGeneratedViewController);

    var self = this;
    $scope.showButton = false;
    $scope.loading = true;
    self.conditions = {};
    $scope.showButton = false;
    $scope.showPending = false;
    $scope.updateLogs = [];
    $rootScope.title = "Generated Report";
    var activeYear = localStorageService.get('academic_year');
    var _KG_CLASSES = ["class123", "class1234"];
    var _FIVE_MARKS_ = 5;
    if ($stateParams.selected_year != activeYear) {
        self.noAction = true;
    } else {
        self.noAction = false;
    }
    $scope.published_edit = $stateParams.is_edit;
    var subsSettng = undefined,
        subsPrsn = undefined,
        subsRprt = undefined;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, { reload: true });
        }
        pushLog();
    };
    this.$onDestroy = function () {
        if (subsSettng) subsSettng.stop();
        if (subsPrsn) subsPrsn.stop();
        if (subsRprt) subsRprt.stop();
    };

    var authoring = localStorageService.get('authoringData');
    var reportDataId = $stateParams.dataId;
    this.sendForApprovalFlag = false;
    this.can_published_edit = false;
    this.can_published_edit = false;
    function intializeFlags() {
        $scope.oneToFiveSkillOnlyFlag = false;
        $scope.oneToFiveSkillAndSubSkillFlag = false;
        $scope.SixToEightScholasticFlag = false;
        $scope.locationUrl = CONSTANTS.FILE_UPLOAD_URL;
        $scope.typeOneMark = false;
        $scope.typeOneGrade = false;
        $scope.typeTwoMark = false;
        $scope.typeThreeSubSkill = false;
        $scope.defaultPtHf = false;
        $scope.defaultPtAnnual = false;
        $scope.default_skill_only = false;
        $scope.type_four_mark = false;
        $scope.type_four_annual = false;
        $scope.defaultPtHfTwo = false;
        $scope.defaultPtAnnualTwo = false;
        $scope.cbsehss = false;
        $scope.term1halfyearly = false;
        $scope.kbhfhss = false;
        self.allStudentReportData = undefined;
        $scope.grade9annual = false;
        $scope.grade0neeightAnnual = false;
        $scope.annualcbseHss = false;
        $scope.kbhssannual = false;
        $scope.ptHfKB = false;
        $scope.hfExamOne = false;
        $scope.type5_9_10_grade_term1 = false;
        $scope.type5_9_10_grade_term2 = false;
        $scope.typefive_6_8_term1 = false;
        $scope.typefive_6_8_term2 = false;
        $scope.typefive_1_5term1 = false;
        $scope.typefive_1_5term2 = false;
        $scope.typefive_6_7_term1 = false;
        $scope.typeseven_1_2_term1 = false;
        $scope.typesix_6_7_term1 = false;
        $scope.typesix_3_5_term1 = false;
        $scope.typealn_1_2_term1 = false;
        $scope.typefive_8_term1 = false;
        $scope.typefive_1_2_term1 = false;
        $scope.typesix_1_2_term1 = false;
        $scope.typefive_3_5_term1 = false;
        $scope.typefive_KB_105term1 = false;
        $scope.typefive_KB_105term2 = false;
        $scope.type5_KB_8_9_grade_term1 = false;
        $scope.type5_KB_8_9_grade_term2 = false;
        $scope.type5_KB_8_9_grade_term3 = false;

        $scope.type_6_model_exam_term1 = false;
        $scope.type_6_model_exam_term1nineten = false;
        $scope.type_6_model_exam_term2nineten = false;
        $scope.type_6_model_exam_term2 = false;
        $scope.type_6_model_annualexam_term = false;

        $scope.type9_cbse_pt1 = false;
        $scope.type9_term1_hf = false;
        $scope.type9_term2_ae = false;
        $scope.type9_grade12term2_ae = false;
        $scope.type9_kb_unit_test1 = false;
        $scope.type9_kbterm1_hf = false;
        $scope.type9_kbterm2 = false;
        $scope.type9_kbterm3 = false;
        $scope.type_7calicut_annual = false;

        $scope.skill_template = undefined;
        $scope.ApprovalUser = undefined;
        $scope.type12termOneEightcbse = false;
        $scope.type12_ninetentermcbse = false;
        $scope.elt_report = false;
        $scope.type20_KB_10_grade_term1 = false;
        $scope.type20termNineTencbse = false;
        $scope.type20termOneEightcbse = false;
        $scope.type20_KB_10_grade_term2 = false;
        $scope.type20term2NineTencbse = false;
        $scope.type20termTwoOneEightcbse = false;
        $scope.typeeightToTenTermCbse = false;
        $scope.typeTermCbseeightToTen = false;
        $scope.typesixToSevenAlnCbse = false;
        $scope.typesixToSevenTcsCbse = false;
        $scope.typethreeToFiveTcsCbse = false;
        $scope.typethreeToFiveAlnCbse = false;
        $scope.typeOneToTwoTcsCbse = false;

        $scope.typethirtykbtenTermOne = false;
        $scope.typethirtykbtenTermTwo = false;
        $scope.typethirtykbtenTermThree = false;
        $scope.typethirtykbtenTermOneNew26 = false;
        $scope.typethirtykbtenTermTwoNew26 = false;
        $scope.typethirtykbtenTermThreeNew26 = false;

        $scope.typetenkbtenTermOne = false;
        $scope.typetenkbtenTermTwo = false;
        $scope.typetenkbeleventwelveTermOne = false;
        $scope.typetenkbeleventwelveTermTwo = false;
        $scope.typetenkbeleventwelveTermOneNew26 = false;
        $scope.typetenkbeleventwelveTermTwoNew26 = false;
        $scope.type02grade11sc = false;
        $scope.type02grade11sct2 = false;
        $scope.type02grade12sc = false;
        $scope.type02grade12sct2 = false;
        $scope.typefivethreefiveterm2 = false;
        $scope.typeonetwoshjterm2 = false;
        $scope.typesix_6_7_term2 = false;
        $scope.typeeightToTenTermCbseterm2 = false;
        $scope.typefive_1_2_term2 = false;
        $scope.typeOneToTwoTcsCbseterm2 = false;
        $scope.typesixToSevenTcsCbseTerm2 = false;
        $scope.typethreeToFiveTcsCbseTerm2 = false;
        $scope.typesix_3_5_term2 = false;
        $scope.typefive_6_7_term2 = false;
        $scope.typefive_8_term2 = false;
        $scope.typeseven_1_2_term2 = false;
        $scope.typethreeToFiveAlnCbseterm2 = false;
        $scope.type6to7_alncbse_term2 = false;
        $scope.typeTermCbseeightToTenterm2 = false;
        $scope.pt_1_no_conv = false;
        $scope.type1to5_tcscbse_new = false;
        $scope.type1to5_tcscbseterm2_new = false;

        // NEW26 Templates
        $scope.type5_1_2_term1_new26 = false;
        $scope.type5_1_2_term2_new26 = false;
        $scope.type5_3_5_term1_new26 = false;
        $scope.type5_3_5_term2_new26 = false;
        $scope.type6_6_7_term1_new26 = false;
        $scope.type6_6_7_term2_new26 = false;
        $scope.type8to10_termcbse_new26 = false;
        $scope.type8to10_termcbseterm2_new26 = false;
        $scope.type9_termcbse_new26 = false;
        $scope.type9_termcbseterm2_new26 = false;
        $scope.type10_termcbse_new26 = false;
        $scope.type10_termcbseterm2_new26 = false;
        $scope.type02grade_11_science_new26 = false;
        $scope.type02grade_11_sciencet2_new26 = false;
        $scope.type02grade_12_science_new26 = false;
        $scope.type02grade_12_sciencet2_new = false;
        $scope.type10_kb_grade_term1_new26 = false;
        $scope.type10_kb_grade_term2_new26 = false;
    }
    intializeFlags();

    var school_id = localStorageService.get('school_id');
    function loadPage(result) {
        // NEW26 Debug: Log incoming data
        console.log('=== CLIENT NEW26 DEBUG: loadPage called ===');
        console.log('Result object keys:', Object.keys(result));
        console.log('result.rc_template:', result.rc_template);
        console.log('result.report_template:', result.report_template);
        if (result && result.rc_template) {
            console.log('Template from server:', result.rc_template.template);
            console.log('Is NEW26 template:', result.rc_template.template.indexOf('new26') > -1 || result.rc_template.template.indexOf('NEW26') > -1);
        }
        console.log('=====================================');
        var lUser = localStorageService.get('user_id');
        console.log(result);
        if (reportDataId) {
            if (result && result.pdf_data) {
                $scope.url = result.pdf_data;
            } else {
                $scope.url = CONSTANTS.FILE_UPLOAD_URL + "/uploads/academic_reports/" + lUser + "/" + result.pdf_url;
            }
            $scope.loading = false;
            var cardDetails = [];
            if (result) {
                $scope.withOutSkillButMark = true;
                self.full_data = result;
                self.card_details = result.card_details ? result.card_details : result.report_template.activity_buckets;
                var report_data = result.report_data;
                if (report_data.current_status.status != "rejected" && $scope.published_edit == "true") {
                    self.can_published_edit = true;
                }
                try {
                    var allowed_edit_years = ['2024-2025', '2025-2026', '2026-2027'];
                    var selected_year = report_data.report_card_header.academic_year;
                    console.log(selected_year, "selected_yearselected_year");
                    if (!allowed_edit_years.includes(selected_year) || selected_year == activeYear && report_data.current_status.status == "approved") {
                        self.can_published_edit = false;
                    }
                } catch (error) {
                    console.log(error);
                }
                $scope.report_data = report_data;
                var academicDetails = {
                    report_name: report_data.report_card_header.report_card_name,
                    school_name: "School Name Dummy",
                    generated_by: report_data.generated_by.name,
                    academics: report_data.academic_details.session + "/" + report_data.academic_details.curriculum + "/" + report_data.academic_details.class + "/" + report_data.academic_details.batch,
                    subject: report_data.academic_details.subject
                };
                if (result.stream) {
                    academicDetails.stream = result.stream;
                }
                self.academic_header = academicDetails;
                report_data.results.sort(function (a, b) {
                    var nameA = a.student_name.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.student_name.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
                if (result.rc_template.template === rcConstants.TYPE_3_SUB_SLILL) {
                    $scope.skill_template = rcConstants.TYPE_3_SUB_SLILL;
                    _.each(report_data.results, function (eachStudent) {
                        eachStudent['result_redefined'] = {};
                        _.each(eachStudent.skills, function (eachSkill) {
                            var sub_obj = {};
                            _.each(eachSkill.sub_skill, function (subSkill) {
                                sub_obj[subSkill.subname] = {
                                    "name": subSkill.subname,
                                    "grade": subSkill.grade,
                                    "remarks": subSkill.remarks,
                                    "total_mark": subSkill.total_mark
                                };
                            });
                            eachStudent['result_redefined'][eachSkill.name] = {
                                "name": eachSkill.name,
                                "grade": eachSkill.grade,
                                "total_mark": eachSkill.total_mark,
                                "subSkill": sub_obj
                            };
                        });
                    });
                } else {
                    if (result.rc_template.template === rcConstants.TYPE_SKILL_ONLY) {
                        $scope.skill_template = rcConstants.TYPE_SKILL_ONLY;
                        _.each(report_data.results, function (eachStudent) {
                            eachStudent['result_redefined'] = {};
                            _.each(eachStudent.skills, function (skill) {
                                eachStudent['result_redefined'][skill.name] = skill;
                            });
                        });
                    }
                }
                if (result.rc_template) {
                    switchTemplate(result.rc_template.template);
                }
                self.allStudentReportData = report_data;
                if (result.sendForButtonShow == true) {
                    self.sendForApprovalFlag = true;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    }
    var loadObj = {
        reportDataId: reportDataId,
        school_id: school_id,
        pdfFlag: false,
        authoring: authoring,
        can_approve: false,
        year: $stateParams.selected_year,
        isGeneration: false,
        my_user_id: localStorageService.get('user_id'),
        CONSTANTS: CONSTANTS
    };
    function initialLoad(loadObj) {

        authService.callAPI("/v0/reportcards/teacher/subject/report", "POST", { args: loadObj }, function (response) {
            // if(response.error){
            //     $scope.loading = false
            //     toastr.error(response.error)
            //     return false
            // }response.reportCardApprover
            if (response && response.result && response.result.data && response.result.data.details && response.result.data.details.response) {
                if (response.result.data.details.response.report_data && response.result.data.details.response.report_data.update_logs) {
                    $scope.updateLogs = response.result.data.details.response.report_data.update_logs;
                }
                if (response.result.data.details.response.permissions.reportCardListing || response.result.data.details.response.permissions.publishReports || response.result.data.details.response.permissions.reportCardApprover) {
                    self.can_approve = true;
                } else {
                    $state.go("dashboard");
                    return false;
                }
                self.roles = response.result.data.details.response.approverRoles;
                var sdata = response.result.data.details.response.permissions.schoolData;
                sdata.logo = CONSTANTS.FILE_UPLOAD_URL + sdata.logo;
                $scope.schoolData = sdata;
                self.can_approve = true;
                var report_data = response.result.data.details.response.report_data;
                if (report_data.current_status && report_data.current_status.status === 'approved') {
                    $scope.showButton = false;
                    $scope.loading = false;
                }

                if (response.result.data.details.response.approve_permission) {
                    // $scope.showButton = true
                    if (report_data.current_status && report_data.current_status.status === 'sent_for_approval') {

                        if (report_data.approval_details && report_data.approval_details.length) {
                            var isMeApprover = _.find(report_data.approval_details, function (one) {
                                return one.user_id == localStorageService.get('user_id') && one.status == "received";
                            });
                            if (isMeApprover) {
                                $scope.showButton = true;
                            }
                            if (!isMeApprover) {
                                $scope.ApprovalUser = report_data.approval_details[0].user_name;
                                $scope.showPending = true;
                            }
                        }
                        $scope.loading = false;
                    }
                    if (report_data.current_status && report_data.current_status.status === 'created' || report_data.current_status.status === 're_generated') {
                        self.sendForApprovalFlag = true;
                    }
                }
                loadPage(response.result.data.details.response);
            }
            $scope.loading = false;
        });
    }
    initialLoad(loadObj);

    function switchTemplate(template) {
        console.log("templates", template);
        console.log(rcConstants);
        switch (template) {
            case rcConstants.TYPE_1_MARK:
                $scope.typeOneMark = true;
                break;
            case rcConstants.TYPE_1_GRADE:
                $scope.typeOneGrade = true;
                break;
            case rcConstants.TYPE_2_MARK:
                $scope.typeTwoMark = true;
                break;
            case rcConstants.TYPE_3_SUB_SLILL:
                $scope.typeThreeSubSkill = true;
                break;
            case rcConstants.TYPE_1_DEFAULT_ANNUAL:
                $scope.typeOneMark = true;
                break;
            case rcConstants.DEFAULT_PERIODICTEST_HF:
                $scope.defaultPtHf = true;
                break;
            case rcConstants.DEFAULT_PERIODICTEST_ANNUAL:
                $scope.defaultPtAnnual = true;
                break;
            case rcConstants.TYPE_SKILL_ONLY:
                $scope.default_skill_only = true;
                break;
            case rcConstants.TYPE_4_MARK:
                $scope.type_four_mark = true;
                break;
            case rcConstants.TYPE_4_ANNUAL:
                $scope.type_four_annual = true;
                break;
            case rcConstants.DEFAULT_PERIODICTEST_HF_TWO:
                $scope.defaultPtHfTwo = true;
                break;
            case rcConstants.DEFAULT_PERIODICTEST_ANNUAL_TWO:
                $scope.defaultPtAnnualTwo = true;
                break;
            case rcConstants.HIGHER_SECONDARY_REPORT:
                $scope.defaultHss = true;
                break;
            case rcConstants.CBSE_HSHF:
                $scope.cbsehss = true;
                break;
            case 'term1halfyearly':
                $scope.term1halfyearly = true;
                break;
            case rcConstants.KBHFHSS:
                $scope.kbhfhss = true;
                break;
            case "grade-9-annual":
                $scope.grade9annual = true;
                break;
            case "grade-1_8-annual":
                $scope.grade0neeightAnnual = true;
                break;
            case "annual_cbse_hss":
                $scope.annualcbseHss = true;
                break;
            case 'term-annual-only':
                $scope.annualnineonly = true;
                break;
            case "kb_hss_annual":
                $scope.kbhssannual = true;
                break;
            case "periodic-test-hf-kb":
                $scope.ptHfKB = true;
            case "hf1-exam":
                $scope.hfExamOne = true;
                break;
            case "type5_9_10_grade_term1":
                $scope.type5_9_10_grade_term1 = true;
                break;
            case "type5_6_8_grade_term1":
                $scope.typefive_6_8_term1 = true;
                break;
            case "type5_6_8_grade_term2":
                $scope.typefive_6_8_term2 = true;
                break;
            case "type5_1_5_grade_term1":
                $scope.typefive_1_5term1 = true;
                break;
            case "type5_1_5_grade_term2":
                $scope.typefive_1_5term2 = true;
                break;
            case "type5_6_7_grade_term1":
                $scope.typefive_6_7_term1 = true;
                break;
            case "type6_6_7_grade_term1":
                $scope.typesix_6_7_term1 = true;
                break;
            case "type6_3_5_grade_term1":
                $scope.typesix_3_5_term1 = true;
                break;

            case "typealn_1_2_grade_term1":
                $scope.typealn_1_2_term1 = true;
                break;
            case "type5_8_grade_term1":
                $scope.typefive_8_term1 = true;
                break;
            case "type7_1_2_grade_term1":
                $scope.typeseven_1_2_term1 = true;
                break;
            case "type5_1_2_grade_term1":
                $scope.typefive_1_2_term1 = true;
                break;
            case "type6_1_2_grade_term1":
                $scope.typesix_1_2_term1 = true;
                break;
            case "type5_3_5_grade_term1":
                $scope.typefive_3_5_term1 = true;
                break;
            case "type5_KB_10_grade_term1":
                $scope.typefive_KB_105term1 = true;
                break;
            case "type5_KB_10_grade_term2":
                $scope.typefive_KB_105term2 = true;
                break;
            case "type5_9_10_grade_term2":
                $scope.type5_9_10_grade_term2 = true;
                break;
            case "type5_KB_8_9_grade_term1":
                $scope.type5_KB_8_9_grade_term1 = true;
                break;
            case "type5_KB_8_9_grade_term2":
                $scope.type5_KB_8_9_grade_term2 = true;
                break;
            case "type5_KB_8_9_grade_term3":
                $scope.type5_KB_8_9_grade_term3 = true;
                break;
            case "type_6_model_exam_1":
                $scope.type_6_model_exam_term1 = true;
                break;
            case "type_6_model_exam_1_nineten":
                $scope.type_6_model_exam_term1nineten = true;
                break;
            case 'type_6_model_exam_2_nineten':
                $scope.type_6_model_exam_term2nineten = true;
                break;
            case "type_6_model_exam_2":
                $scope.type_6_model_exam_term2 = true;
                break;
            case "type_6_model_annualexam_2":
                $scope.type_6_model_annualexam_term = true;
                break;
            case "calicut_annual":
                $scope.type_7calicut_annual = true;
                break;
            case "type9_cbse_pt1":
                $scope.type9_cbse_pt1 = true;
                break;
            case "type9_term1_hf":
                $scope.type9_term1_hf = true;
                break;
            case "type9_term2_ae":
                $scope.type9_term2_ae = true;
                break;
            case "type9_grade12term2_ae":
                $scope.type9_grade12term2_ae = true;
                break;
            case "type9_kb_unit_test1":
                $scope.type9_kb_unit_test1 = true;
                break;
            case "type9_kbterm1_hf":
                $scope.type9_kbterm1_hf = true;
                break;
            case "type9_kbterm2":
                $scope.type9_kbterm2 = true;
                break;
            case "type9_kbterm3":
                $scope.type9_kbterm3 = true;
                break;
            case "type12_termcbse":
                $scope.type12termOneEightcbse = true;
                break;
            case "type12_ninetentermcbse":
                $scope.type12_ninetentermcbse = true;
                break;
            case "elt-report":
                console.log('ooooooo');
                $scope.elt_report = true;
                break;
            case "type20_KB_10_grade_term1":
                $scope.type20_KB_10_grade_term1 = true;
                break;
            case "type20_termcbse":
                $scope.type20termNineTencbse = true;
                break;
            case "type20_termcbse18":
                $scope.type20termOneEightcbse = true;
                break;
            case "type20_term2cbse":
                $scope.type20term2NineTencbse = true;
                break;
            case "type20_term2cbse18":
                $scope.type20termTwoOneEightcbse = true;
                break;
            case "type20_KB_10_grade_term2":
                $scope.type20_KB_10_grade_term2 = true;
                break;
            case "type30_KB_grade_term1":
                $scope.typethirtykbtenTermOne = true;
                break;
            case "type30_KB_grade_term2":
                $scope.typethirtykbtenTermTwo = true;
                break;
            case "type30_KB_grade_term3":
                $scope.typethirtykbtenTermThree = true;
                break;
            case "type30_KB_grade_term1_new26":
                $scope.typethirtykbtenTermOneNew26 = true;
                break;
            case "type30_KB_grade_term2_new26":
                $scope.typethirtykbtenTermTwoNew26 = true;
                break;
            case "type30_KB_grade_term3_new26":
                $scope.typethirtykbtenTermThreeNew26 = true;
                break;
            case "type8to10_termcbse":
                $scope.typeeightToTenTermCbse = true;
                break;
            case "typetermcbse_8to10":
                $scope.typeTermCbseeightToTen = true;
                break;
            case "type6to7_alncbse":
                $scope.typesixToSevenAlnCbse = true;
                break;
            case "type6to7_tcscbse":
                $scope.typesixToSevenTcsCbse = true;
                break;
            case "type3to5_tcscbse":
                $scope.typethreeToFiveTcsCbse = true;
                break;
            case "type3to5_alncbse":
                $scope.typethreeToFiveAlnCbse = true;
                break;
            case "type1to2_tcscbse":
                $scope.typeOneToTwoTcsCbse = true;
                break;
            case "type10_KB_grade_term1":
                $scope.typetenkbtenTermOne = true;
                break;
            case "type10_KB_grade_term2":
                $scope.typetenkbtenTermTwo = true;
                break;
            case "type10_KB_grade11_12_term1_new26":
                $scope.typetenkbeleventwelveTermOneNew26 = true;
                break;
            case "type10_KB_grade11_12_term2_new26":
                $scope.typetenkbeleventwelveTermTwoNew26 = true;
                break;
            case "type10_KB_grade11_12_term1":
                $scope.typetenkbeleventwelveTermOne = true;
                break;
            case "type10_KB_grade11_12_term2":
                $scope.typetenkbeleventwelveTermTwo = true;
                break;
            case "type02grade_11_science":
                $scope.type02grade11sc = true;
                break;
            case "type02grade_11_sciencet2":
                $scope.type02grade11sct2 = true;
                break;
            case "type02grade_12_science":
                $scope.type02grade12sc = true;
                break;
            case "type02grade_12_sciencet2":
                $scope.type02grade12sct2 = true;
                break;
            case "type5_3_5_grade_term2":
                $scope.typefivethreefiveterm2 = true;
                break;
            case "type6_6_7_grade_term2":
                $scope.typesix_6_7_term2 = true;
                break;

            case "type8to10_termcbseterm2":
                $scope.typeeightToTenTermCbseterm2 = true;
                break;
            case "type5_1_2_grade_term2":
                $scope.typefive_1_2_term2 = true;
                break;
            case "type1to2shjcbset2":
                $scope.typeonetwoshjterm2 = true;
                break;
            case "type1to2_tcscbse_term2":
                $scope.typeOneToTwoTcsCbseterm2 = true;
                break;
            case "type6to7_tcscbseterm2":
                $scope.typesixToSevenTcsCbseTerm2 = true;
                break;
            case "type3to5_tcscbseterm2":
                $scope.typethreeToFiveTcsCbseTerm2 = true;
                break;
            case "type6_3_5_grade_term2":
                $scope.typesix_3_5_term2 = true;
                break;
            case "type5_6_7_grade_term2":
                $scope.typefive_6_7_term2 = true;
                break;
            case "type5_8_grade_term2":
                $scope.typefive_8_term2 = true;
                break;
            case "type7_1_2_grade_term2":
                $scope.typeseven_1_2_term2 = true;
                break;
            case "type3to5_alncbseterm2":
                $scope.typethreeToFiveAlnCbseterm2 = true;
                break;
            case "type6to7_alncbse_term2":
                $scope.type6to7_alncbse_term2 = true;
                break;
            case "typetermcbse_8to10_term2":
                $scope.typeTermCbseeightToTenterm2 = true;
                break;
            case "pt_1_no_conv":
                $scope.pt_1_no_conv = true;
                break;
            case "type1to5_tcscbse_new":
                $scope.type1to5_tcscbse_new = true;
                break;
            case "type1to5_tcscbseterm2_new":
                $scope.type1to5_tcscbseterm2_new = true;
                break;
        }
        handleNew26Switch(template);
        console.log('=== NEW26 DEBUG: Switch case matched, template:', template);
    }

    function handleNew26Switch(template) {
        switch (template) {
            case "type5_1_2_grade_term1_new26":
            case "type5_1_2_grade_term1_new26_shj":
                $scope.type5_1_2_term1_new26 = true;
                break;
            case "type5_1_2_grade_term2_new26":
            case "type5_1_2_grade_term2_new26_shj":
                $scope.type5_1_2_term2_new26 = true;
                break;
            case "type5_3_5_grade_term1_new26":
                $scope.type5_3_5_term1_new26 = true;
                break;
            case "type5_3_5_grade_term2_new26":
                $scope.type5_3_5_term2_new26 = true;
                break;
            case "type6_6_7_grade_term1_new26":
                $scope.type6_6_7_term1_new26 = true;
                break;
            case "type6_6_7_grade_term2_new26":
                $scope.type6_6_7_term2_new26 = true;
                break;
            case "type8to10_termcbse_new26":
                $scope.type8to10_termcbse_new26 = true;
                break;
            case "type8_8_termcbseterm2_new26":
                $scope.type8to10_termcbseterm2_new26 = true;
                break;
            case "type8to10_termcbseterm2_new26":
            case "type9_termcbse_new26":
                $scope.type9_termcbse_new26 = true;
                break;
            case "type9_termcbseterm2_new26":
                $scope.type9_termcbseterm2_new26 = true;
                break;
            case "type10_termcbse_new26":
                $scope.type10_termcbse_new26 = true;
                break;
            case "type10_termcbseterm2_new26":
                $scope.type10_termcbseterm2_new26 = true;
                break;
                $scope.type8to10_termcbseterm2_new26 = true;
                break;
            case "type02grade_11_science_new26":
                $scope.type02grade_11_science_new26 = true;
                break;
            case "type02grade_11_sciencet2_new26":
                $scope.type02grade_11_sciencet2_new26 = true;
                break;
            case "type02grade_12_science_new26":
                $scope.type02grade_12_science_new26 = true;
                break;
            case "type02grade_12_sciencet2_new":
                $scope.type02grade_12_sciencet2_new = true;
                break;
            case "type10_KB_grade_term1_new26":
                $scope.type10_kb_grade_term1_new26 = true;
                break;
            case "type10_KB_grade_term2_new26":
                $scope.type10_kb_grade_term2_new26 = true;
                break;
        }
    }

    self.showModal = function (ev) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'reportDataId', 'selected_year', 'school_id', 'localStorageService', 'authService', 'parentScope', MdController],
            locals: {
                "reportDataId": reportDataId,
                "selected_year": $stateParams.selected_year,
                school_id: school_id,
                localStorageService: localStorageService,
                authService: authService,
                parentScope: $scope
            },
            template: _reportApprovalPopUp2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
    self.selectUserByRole = function (role_id) {

        if (role_id) {
            self.users = [];
            self.conditions.role_selected = role_id;
            var _loadObj = {
                role_id: role_id,
                schoolId: localStorageService.get('school_id')
            };
            authService.callAPI("/v0/reportcards/teacher/approvers", "POST", { args: _loadObj }, function (response) {
                var result = response.result.data.details.response;
                if (result) {

                    self.users = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };
    self.setUser = function (user_id) {
        self.conditions.user_selected = user_id;
    };
    self.confirmMarkUpdate = function (ev) {
        var confirm = $mdDialog.confirm({
            targetEvent: ev,
            onComplete: function afterShowAnimation() {
                var $dialog = angular.element(document.querySelector('md-dialog'));
                var $actionsSection = $dialog.find('md-dialog-actions');
                var $cancelButton = $actionsSection.children()[0];
                var $confirmButton = $actionsSection.children()[1];
                angular.element($confirmButton).addClass('md-raised submitEx');
                angular.element($cancelButton).addClass('md-raised');
                var $title = angular.element(document.querySelector('md-title'));
                angular.element($title).addClass('md-raised md-accent');
            }
        }).title('Are you sure to update Marks?').htmlContent("<div class='mdCustom' style='line-height: 3.9;padding:5px !important;'><div style='padding: 10px !important;text-align:center;'>Please verify that the marks entered are correct.</div></br><div>Note : Entering anything other than numeric characters will be classified as an absence.</div></div>")
        // .textContent('Please make sure marks are entered correctly. Note : Entering Alpha Numerical characters will be considered as ABSENT.')
        // .ariaLabel('Lucky day')
        // .targetEvent(ev)
        .ok('UPDATE').cancel('CANCEL');

        $mdDialog.show(confirm).then(function () {
            self.saveRemarks();
        }, function () {
            return false;
        });
    };

    self.showUpdateLog = function (ev) {
        if ($scope.updateLogs.length) {
            $mdDialog.show({
                controller: DialogController,
                template: _updateLog2.default,
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    updateLogs: $scope.updateLogs
                }
            });
        } else {
            toastr.error("Update log not available");
        }
    };
    function DialogController($scope, $mdDialog, updateLogs) {

        try {
            $scope.updateLogs = angular.copy(updateLogs);
        } catch (error) {
            $scope.updateLogs = JSON.parse(JSON.stringify(updateLogs));
        }

        try {
            $scope.updateLogs.sort(function (a, b) {
                return new Date(b.updated_on) - new Date(a.updated_on);
            });
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = $scope.updateLogs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.updated_on) {
                        item.updated_on = formatToMMDDYY(item.updated_on);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }

        $scope.closeDialog = function () {
            $mdDialog.hide();
        };

        function formatToMMDDYY(isoString) {
            var date = new Date(isoString);
            var month = String(date.getMonth() + 1).padStart(2, '0');
            var day = String(date.getDate()).padStart(2, '0');
            var year = String(date.getFullYear()).slice(-2);
            return day + '-' + month + '-' + year;
        }
    }
    function isNumber(n) {
        if (Math.round(n) == n && n.length == Math.round(n).length) return true;else return false;
    }
    self.saveRemarks = function () {

        if (!self.can_published_edit) {
            if (!self.conditions.role_selected || !self.conditions.user_selected) {
                toastr.error("Please select the user");
                return false;
            }
        }

        var nullRemarks = false;
        var ifKgExceedFive = 0;
        var error_exceeded = 0;
        var errorStudents = [];
        _.each(self.allStudentReportData.results, function (result) {
            delete result.empty;
            delete result.invalid;
            result.kgMarkExceederror = undefined;
            if (result.result_redefined) {
                var redefinedObj = result.result_redefined;
                var redefinedObjKeys = Object.keys(result.result_redefined);
                _.each(redefinedObjKeys, function (redefObj) {
                    if (result.skills) {
                        _.each(result.skills, function (skill) {
                            if (skill.remarks == undefined) {
                                nullRemarks = true;
                            }
                            if (authoring && authoring.class_id && self.can_published_edit) {
                                if (_KG_CLASSES.indexOf(authoring.class_id) !== -1) {
                                    if (skill.total_mark > _FIVE_MARKS_) {
                                        result.kgMarkExceederror = 'Marks exceeded ' + _FIVE_MARKS_;
                                        ifKgExceedFive++;
                                    }
                                }
                            }
                            if (skill.name == redefObj) {
                                if (redefinedObj[redefObj].subSkill) {
                                    //for subskills
                                    var subSkillObj = redefinedObj[redefObj].subSkill;
                                    var subSkillObjKeys = Object.keys(redefinedObj[redefObj].subSkill);
                                    _.each(subSkillObjKeys, function (subKey) {
                                        _.each(skill.sub_skill, function (subSkill) {
                                            if (subSkill.subname == subKey) {
                                                subSkill.remarks = subSkillObj[subKey].remarks;
                                                if (subSkill.remarks == undefined) {
                                                    nullRemarks = true;
                                                }
                                            }
                                        });
                                    });
                                }
                            }
                        });
                    }
                });
            } else {
                if (self.can_published_edit && $scope.report_data.no_conversion && $scope.report_data.bucket_max_mark) {
                    var keys = Object.keys($scope.report_data.bucket_max_mark);
                    var ThisStudentError = 0;
                    if (keys && keys.length) {
                        for (var k = 0; k < keys.length; k++) {
                            var element = keys[k];
                            try {
                                if ($scope.report_data.bucket_max_mark[element]) {
                                    if ($scope.report_data.bucket_max_mark[element].max_mark) {
                                        var max_mark = $scope.report_data.bucket_max_mark[element].max_mark;
                                        if (result.marks && result.marks[element]) {
                                            if (!isNaN(result.marks[element])) {
                                                if (Number(result.marks[element]) > Number(max_mark)) {
                                                    console.log(result.marks[element] + '>' + max_mark);
                                                    ThisStudentError++;
                                                    error_exceeded++;
                                                }
                                            }
                                        }
                                    }
                                }
                            } catch (e1) {
                                console.log(e1);
                            }
                        }
                    }
                    if (ThisStudentError) {

                        errorStudents.push(result);
                    }
                }
            }
        });
        if (error_exceeded && self.can_published_edit) {
            if (errorStudents && errorStudents.length) {
                console.log(errorStudents);
                showValidationFromServer({
                    error_array: errorStudents
                });
            }
            return false;
        }
        // return false
        if (self.allStudentReportData && self.allStudentReportData._id && self.allStudentReportData.results) {
            // Meteor.call("saveRemarksInTemplate", self.allStudentReportData, self.conditions, Session.get('school_id'), $stateParams.selected_year, function(error, result) {
            //     if (error) {
            //         toastr.error(error.reason)
            //     } else {
            //         if (result) {
            //             toastr.success("Successfully sent")
            //             $state.go('reportCardListing');
            //             // self.allStudentReportData = [];
            //             // self.allStudentReportData = result;
            //             // if (result.current_status && (result.current_status.status == "sent_for_approval")) {
            //             //     self.sendForApprovalFlag = false
            //             // }
            //         }
            //     }
            // })

            var _loadObj2 = {
                templateDataSet: self.allStudentReportData,
                approverObj: self.conditions,
                school_id: school_id,
                report_academic_year: $stateParams.selected_year
            };

            var url = "/v0/reportcards/edit/published/subject/reportcard";
            var succes = "Sent for approval";
            if (!self.can_published_edit) {
                url = "/v0/reportcards/teacher/saveRemarksInTemplate";
                succes = "Sent for approval";
            } else {
                _loadObj2['CONSTANTS'] = CONSTANTS;
                _loadObj2['my_user_id'] = localStorageService.get('user_id');
                _loadObj2['rcConstants'] = rcConstants;
                _loadObj2['skill_template'] = $scope.skill_template;
                succes = "Mark Updated Successfully";
                if (ifKgExceedFive) {
                    toastr.error("Sorry..marks should not exceed 5");
                    return false;
                }
            }

            console.log(_loadObj2);
            $scope.loading = true;
            authService.callAPI(url, "POST", { args: _loadObj2 }, function (response) {
                if (!response.error) {
                    console.log(response);

                    self.sendForApprovalFlag = false;
                    if (self.can_published_edit) {

                        var result = response.result.data.details.response;
                        console.log(result);
                        if (result.validation_error > 0) {
                            $scope.loading = false;
                            showValidationFromServer(result);
                            return false;
                        } else {

                            toastr.success(succes);
                            try {
                                intializeFlags();
                                var _loadObj3 = {
                                    reportDataId: reportDataId,
                                    school_id: school_id,
                                    pdfFlag: false,
                                    authoring: authoring,
                                    can_approve: false,
                                    year: $stateParams.selected_year,
                                    isGeneration: false,
                                    my_user_id: localStorageService.get('user_id'),
                                    CONSTANTS: CONSTANTS
                                };
                                if (RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS && RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS.indexOf(school_id) !== -1) {
                                    console.log("this");
                                    _loadObj3['PORT_FOLIO_AS_NB_SCHOOLS'] = true;
                                }
                                initialLoad(_loadObj3);
                            } catch (err) {
                                console.log(err);
                                $scope.loading = false;
                                location.reload();
                            }
                        }
                    } else {
                        $scope.loading = false;
                    }
                    toastr.success(succes);
                } else {
                    $scope.loading = false;
                    toastr.success(error.error);
                }

                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };
    function showValidationFromServer(result) {
        try {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'validationData', validationCtrl],
                locals: {
                    "validationData": result.error_array

                },
                template: _reportCardEditValidationPopup2.default,
                parent: angular.element(document.body),
                clickOutsideToClose: true
                // fullscreen: useFullScreen
            });
        } catch (e) {
            console.log(e);
        }
    }
    self.deleteReportCard = function () {
        $scope.loading = true;
        var warn = "If you delete this data will be lost.And You have to create another one";
        if ($scope.report_data && $scope.report_data.current_status && $scope.report_data.current_status.status) {
            if ($scope.report_data.current_status.status == "re_generated") {
                warn = "If you delete,only result of new student(s) will be deleted";
            }
        }
        var confirm = $mdDialog.confirm().title('Would you like to delete?').textContent(warn).ariaLabel('Lucky day').ok('Delete').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {

            authService.callAPI("/v0/reportcards/teacher/delete", "POST", { args: loadObj }, function (response) {
                if (!response.error) {
                    var res = response.result.data.details.response;
                    if (res.reverted) {
                        toastr.success('Deleted regenerated result of new student(s)');
                    } else {
                        toastr.success('deleted');
                    }
                    $state.go('reportCardListing');
                } else {
                    toastr.success(error.error);
                }
            });
        }, function (f, r) {
            $scope.loading = false;
        });
    };
    this.backToHtml = function () {
        $scope.pdfData = false;
        $scope.downloadable = false;
    };
    this.subjectTeacherExport = function (data) {
        // $scope.loading = true
        console.log(CONSTANTS.FILE_UPLOAD_URL);
        console.log($scope.url);
        $scope.pdfData = true;
        $scope.urls = $sce.trustAsResourceUrl($scope.url);
        _.defer(function () {
            $scope.$apply();
        });;
    };
    function pushLog() {
        var userId = localStorageService.get('user_id');
        var schoolId = localStorageService.get('school_id');
        authService.callRabbitMQAPI("/v0/rabbitmqpush/" + userId + "/" + schoolId + "/genaretedReportView", "GET", {}, function (response) {
            // console.log(response)
        });
    }
};
reportGeneratedViewController.$inject = ["$scope", "$state", "$window", "$mdMedia", "$mdDialog", "$stateParams", "authService", "localStorageService", "rcConstants", "CONSTANTS", "$sce", "$rootScope", "RC_CONSTANTS_"];

var validationCtrl = function validationCtrl($scope, $mdDialog, validationData) {
    _classCallCheck(this, validationCtrl);

    $scope.validationArray = validationData;
    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};

var MdController = function MdController($scope, $mdDialog, reportDataId, selected_year, school_id, localStorageService, authService, parentScope) {
    _classCallCheck(this, MdController);

    $scope.dialogItem = [{
        _id: "123",
        "action": "Approve"
    }, {
        _id: "456",
        "action": "Reject"
    }];

    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.answer = function (answer) {
        $mdDialog.hide(answer);
    };
    $scope.saveAction = function () {
        var actionObj = {
            _id: reportDataId,
            actionItem: $scope.item ? $scope.item.action : null,
            commentItem: $scope.commentReason
        };
        var ret_val = [];
        if (!actionObj) {
            toastr.error("Please select the action");
            return false;
        }
        if (!actionObj.actionItem || !actionObj.commentItem) {
            if (!actionObj.actionItem) {
                toastr.error("Please select the action");
                return false;
            }
            if (!actionObj.commentItem) {
                toastr.error("Please enter the comment");
                return false;
            }
            if (!actionObj.actionItem && !actionObj.commentItem) {
                toastr.error("Please select the action");
                return false;
            }
            return false;
        }
        if (actionObj) {
            var loadObj = {
                actionItem: actionObj,
                commentItem: $scope.commentReason,
                myUserId: localStorageService.get('user_id'),
                selected_year: selected_year,
                school_id: school_id,
                _id: reportDataId
            };
            authService.callAPI("/v0/reportcards/teacher/decision", "POST", { args: loadObj }, function (response) {
                if (response.error) {
                    toastr.error('Please try after sometime');
                } else {
                    var res = response.result.data.details.response;
                    if (res) {
                        var msg = actionObj.actionItem == 'Approve' ? "Approved" : "Rejected";
                        toastr.success(msg);
                        $mdDialog.cancel();
                    }
                }
                parentScope.showButton = false;
                _.defer(function () {
                    $scope.$apply();
                });
            });
            // Meteor.call("statusAction", actionObj, selected_year, function(error, result) {
            //     if (error) {
            //         toastr.error(error.reason)

            //     } else {
            //         let msg = (actionObj.actionItem == 'Approve') ? "Approved" : "Rejected"
            //         toastr.success(msg)
            //         $mdDialog.cancel();
            //     }
            //     $scope.showButton = false
            //     _.defer(function() { $scope.$apply(); });;
            // })
        }
        // }
    };
};

var typeFourMarkComponent = 'typeFourMarkComponent';

var TypeFourMarkComponent = function TypeFourMarkComponent($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeFourMarkComponent);

    var vm = this;
    vm.allStudentReportData = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeFourMarkTemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeFourMarkTemplateCtrl.sendForApprovalFlag;
        vm.can_published_edit = this.typeFourMarkTemplateCtrl.can_published_edit;
    };
};
TypeFourMarkComponent.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeFourAnnualComponent = 'typeFourAnnualComponent';

var TypeFourAnnualComponent = function TypeFourAnnualComponent($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeFourAnnualComponent);

    var vm = this;
    vm.allStudentReportData = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeFourAnnualTemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeFourAnnualTemplateCtrl.sendForApprovalFlag;
        vm.can_published_edit = this.typeFourAnnualTemplateCtrl.can_published_edit;
    };
};
TypeFourAnnualComponent.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeOneMarkComponent = 'typeOneMarkComponent';

var TypeOneMarkClass = function TypeOneMarkClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeOneMarkClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeOneMarkTemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeOneMarkTemplateCtrl.sendForApprovalFlag;
        vm.can_published_edit = this.typeOneMarkTemplateCtrl.can_published_edit;
    };
};
TypeOneMarkClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeTwoMarkComponent = 'typeTwoMarkComponent';

var TypeTwoMarkClass = function TypeTwoMarkClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeTwoMarkClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeTwoMarkTemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeTwoMarkTemplateCtrl.sendForApprovalFlag;
        vm.can_published_edit = this.typeTwoMarkTemplateCtrl.can_published_edit;
    };
};
TypeTwoMarkClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeThreeSubSkillComponent = 'typeThreeSubSkillComponent';

var TypeThreeSubSkillClass = function TypeThreeSubSkillClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeThreeSubSkillClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.typeThreeSubSkillCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeThreeSubSkillCtrl.sendForApprovalFlag;
        vm.card_details = this.typeThreeSubSkillCtrl.card_details;
        vm.can_published_edit = this.typeThreeSubSkillCtrl.can_published_edit;
    };
};
TypeThreeSubSkillClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeSkillOnlyComponent = 'typeSkillOnlyComponent';

var TypeSkillOnlyClass = function TypeSkillOnlyClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeSkillOnlyClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.typeSkillOnlyComponentCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeSkillOnlyComponentCtrl.sendForApprovalFlag;
        vm.card_details = this.typeSkillOnlyComponentCtrl.card_details;
        vm.can_published_edit = this.typeSkillOnlyComponentCtrl.can_published_edit;
    };
};
TypeSkillOnlyClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeOneGradeComponent = 'typeOneGradeComponent';

var TypeOneGradeComponentClass = function TypeOneGradeComponentClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeOneGradeComponentClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.academic_header = undefined;
    vm.card_details = undefined;
    vm.report_name = undefined;
    this.$onInit = function () {
        vm.academic_header = this.typeOneGradeComponentCtrl.academic_header;
        vm.allStudentReportData = this.typeOneGradeComponentCtrl.allStudentReportData;
        if (vm.allStudentReportData.report_console_id == 'v93tfR4ScfZKkM297type02grade11Scdxb' || vm.allStudentReportData.report_console_id == 'v93tfR4ScfZKkM297type02grade12Scdxb') {
            vm.allStudentReportData.report_card_header.report_card_name = 'TERM I';
        } else if (vm.allStudentReportData.report_console_id == 'v93tfR4ScfZKkM297type02grade11ScT2dxb' || vm.allStudentReportData.report_console_id == 'v93tfR4ScfZKkM297type02grade12ScT2dxb') {
            vm.allStudentReportData.report_card_header.report_card_name = 'TERM II';
        }

        vm.sendForApprovalFlag = this.typeOneGradeComponentCtrl.sendForApprovalFlag;
        vm.card_details = this.typeOneGradeComponentCtrl.card_details;
        vm.can_published_edit = this.typeOneGradeComponentCtrl.can_published_edit;
        vm.report_name = this.typeOneGradeComponentCtrl.full_data.rc_template.display_name;
        console.log(this.typeOneGradeComponentCtrl, "this.typeOneGradeComponentCtrl-----------------");
    };
};
TypeOneGradeComponentClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var periodicTestDeafaultHFcomponent = 'periodicTestDefaultHfComponent';

var PeriodicTestDeafaultHFClass = function PeriodicTestDeafaultHFClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, PeriodicTestDeafaultHFClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.periodicTestDeafaultHFCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.periodicTestDeafaultHFCtrl.sendForApprovalFlag;
        vm.card_details = this.periodicTestDeafaultHFCtrl.card_details;
        vm.can_published_edit = this.periodicTestDeafaultHFCtrl.can_published_edit;
    };
};
PeriodicTestDeafaultHFClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var periodicTestDeafaultAnnualcomponent = 'periodicTestDefaultAnnualComponent';

var PeriodicTestDeafaultAnnualClass = function PeriodicTestDeafaultAnnualClass($scope, $state, $window, $stateParams, $sce) {
    'ngInject';

    _classCallCheck(this, PeriodicTestDeafaultAnnualClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.periodicTestDeafaultAnnualCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.periodicTestDeafaultAnnualCtrl.sendForApprovalFlag;
        vm.card_details = this.periodicTestDeafaultAnnualCtrl.card_details;
        vm.can_published_edit = this.periodicTestDeafaultAnnualCtrl.can_published_edit;
    };
};
PeriodicTestDeafaultAnnualClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var periodicTestDeafaultHFTwocomponent = 'periodicTestDefaultHfTwoComponent';

var PeriodicTestDefaultHfTwoClass = function PeriodicTestDefaultHfTwoClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, PeriodicTestDefaultHfTwoClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.periodicTestDefaultHfTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.periodicTestDefaultHfTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.periodicTestDefaultHfTwoCtrl.card_details;
        vm.can_published_edit = this.periodicTestDefaultHfTwoCtrl.can_published_edit;
    };
};
PeriodicTestDefaultHfTwoClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var periodicTestDefaultAnnualTwocomponent = 'periodicTestDefaultAnnualTwoComponent';

var PeriodicTestDefaultAnnualTwoClass = function PeriodicTestDefaultAnnualTwoClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, PeriodicTestDefaultAnnualTwoClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.periodicTestDefaultAnnualTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.periodicTestDefaultAnnualTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.periodicTestDefaultAnnualTwoCtrl.card_details;
        vm.can_published_edit = this.periodicTestDefaultAnnualTwoCtrl.can_published_edit;
    };
};
PeriodicTestDefaultAnnualTwoClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var hssTemplateComponent = 'hssTemplateComponent';

var HssTemplateComponentClass = function HssTemplateComponentClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, HssTemplateComponentClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.hssTemplateComponentCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.hssTemplateComponentCtrl.sendForApprovalFlag;
        vm.card_details = this.hssTemplateComponentCtrl.card_details;
        vm.can_published_edit = this.hssTemplateComponentCtrl.can_published_edit;
    };
};
HssTemplateComponentClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var cbsehssComponent = 'cbsehssComponent';

var CbsehssClass = function CbsehssClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, CbsehssClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.cbsehssComponentCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.cbsehssComponentCtrl.sendForApprovalFlag;
        vm.card_details = this.cbsehssComponentCtrl.card_details;
        vm.can_published_edit = this.cbsehssComponentCtrl.can_published_edit;
    };
};
CbsehssClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var termonehalfyearlyComp = 'termonehalfyearlyComp';

var TermonehalfyearlyCompClass = function TermonehalfyearlyCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TermonehalfyearlyCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.termonehalfyearlyCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.termonehalfyearlyCompCtrl.sendForApprovalFlag;
        vm.card_details = this.termonehalfyearlyCompCtrl.card_details;
        vm.can_published_edit = this.termonehalfyearlyCompCtrl.can_published_edit;
    };
};
TermonehalfyearlyCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var kbhfhssComp = 'kbhfhssComp';

var KbhfhssCompClass = function KbhfhssCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, KbhfhssCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.kbhfhssCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.kbhfhssCompCtrl.sendForApprovalFlag;
        vm.card_details = this.kbhfhssCompCtrl.card_details;
        vm.can_published_edit = this.kbhfhssCompCtrl.can_published_edit;
    };
};
KbhfhssCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var gradeNineComp = 'gradeNineComp';

var gradeNineCompClass = function gradeNineCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, gradeNineCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.gradeNineCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.gradeNineCompCtrl.sendForApprovalFlag;
        vm.card_details = this.gradeNineCompCtrl.card_details;
        vm.can_published_edit = this.gradeNineCompCtrl.can_published_edit;
    };
};
gradeNineCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var gradeOneEightComp = 'gradeOneEightComp';

var GradeOneEightCompClass = function GradeOneEightCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, GradeOneEightCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.gradeOneEightCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.gradeOneEightCompCtrl.sendForApprovalFlag;
        vm.card_details = this.gradeOneEightCompCtrl.card_details;
        vm.can_published_edit = this.gradeOneEightCompCtrl.can_published_edit;
    };
};
GradeOneEightCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var annualCbseHssComp = 'annualCbseHssComp';

var AnnualCbseHssCompClass = function AnnualCbseHssCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, AnnualCbseHssCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {

        vm.allStudentReportData = this.annualCbseHssCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.annualCbseHssCompCtrl.sendForApprovalFlag;
        vm.card_details = this.annualCbseHssCompCtrl.card_details;
        vm.can_published_edit = this.annualCbseHssCompCtrl.can_published_edit;
    };
};
AnnualCbseHssCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var annualNineOnlyComp = 'annualNineOnlyComp';

var AnnualNineOnlyClass = function AnnualNineOnlyClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, AnnualNineOnlyClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.annualNineOnlyCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.annualNineOnlyCompCtrl.sendForApprovalFlag;
        vm.card_details = this.annualNineOnlyCompCtrl.card_details;
        vm.can_published_edit = this.annualNineOnlyCompCtrl.can_published_edit;
    };
};
AnnualNineOnlyClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var kbannualComponent = 'kbannualComponent';

var KbannualComponentClass = function KbannualComponentClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, KbannualComponentClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.kbannualComponentCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.kbannualComponentCtrl.sendForApprovalFlag;
        vm.card_details = this.kbannualComponentCtrl.card_details;
        vm.can_published_edit = this.kbannualComponentCtrl.can_published_edit;
    };
};
KbannualComponentClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var kbhfComponent = 'kbptHfComp';

var KbhfCompClass = function KbhfCompClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, KbhfCompClass);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.kbhfPtCompCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.kbhfPtCompCtrl.sendForApprovalFlag;
        vm.card_details = this.kbhfPtCompCtrl.card_details;
        vm.can_published_edit = this.kbhfPtCompCtrl.can_published_edit;
    };
};
KbhfCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var halfyearlyExam = 'halfyearlyExam';

var HalfyearlyExam = function HalfyearlyExam($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, HalfyearlyExam);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.halfyearlyExamCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.halfyearlyExamCtrl.sendForApprovalFlag;
        vm.card_details = this.halfyearlyExamCtrl.card_details;
        vm.can_published_edit = this.halfyearlyExamCtrl.can_published_edit;
    };
};
HalfyearlyExam.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveNineTen = 'typefiveNineTen';

var TypefiveNineTen = function TypefiveNineTen($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveNineTen);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveNineTenCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveNineTenCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveNineTenCtrl.card_details;
        vm.can_published_edit = this.typefiveNineTenCtrl.can_published_edit;
    };
};
TypefiveNineTen.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveNineTenTermTwo = 'typefiveNineTenTermTwo';

var TypefiveNineTenTermTwo = function TypefiveNineTenTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveNineTenTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveNineTenTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveNineTenTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveNineTenTermTwoCtrl.card_details;
        vm.can_published_edit = this.typefiveNineTenTermTwoCtrl.can_published_edit;
    };
};
TypefiveNineTenTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveSixEightTermone = 'typefiveSixEightTermone';

var TypefiveSixEightTerm1 = function TypefiveSixEightTerm1($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveSixEightTerm1);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveSixEightTerm1Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveSixEightTerm1Ctrl.sendForApprovalFlag;
        vm.card_details = this.typefiveSixEightTerm1Ctrl.card_details;
        vm.can_published_edit = this.typefiveSixEightTerm1Ctrl.can_published_edit;
    };
};
TypefiveSixEightTerm1.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveSixEightTermtwo = 'typefiveSixEightTermtwo';

var TypefiveSixEightTerm2 = function TypefiveSixEightTerm2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveSixEightTerm2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveSixEightTerm2Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveSixEightTerm2Ctrl.sendForApprovalFlag;
        vm.card_details = this.typefiveSixEightTerm2Ctrl.card_details;
        vm.can_published_edit = this.typefiveSixEightTerm2Ctrl.can_published_edit;
    };
};
TypefiveSixEightTerm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveOneFiveTermone = 'typefiveOneFiveTermone';

var TypefiveOneFiveTermone = function TypefiveOneFiveTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveOneFiveTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveOneFiveTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveOneFiveTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveOneFiveTermoneCtrl.card_details;
        vm.can_published_edit = this.typefiveOneFiveTermoneCtrl.can_published_edit;

        console.log("🥰🥰🥰🥰🥰", vm.can_published_edit);
    };
};
TypefiveOneFiveTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveOneFiveTermtwo = 'typefiveOneFiveTermtwo';

var TypefiveOneFiveTermtwo = function TypefiveOneFiveTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveOneFiveTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveOneFiveTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveOneFiveTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveOneFiveTermtwoCtrl.card_details;
    };
};
TypefiveOneFiveTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveSixSevenTermone = 'typefiveSixSevenTermone';

var TypefiveSixSevenTermone = function TypefiveSixSevenTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveSixSevenTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveSixSevenTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveSixSevenTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveSixSevenTermoneCtrl.card_details;
        vm.full_data = this.typefiveSixSevenTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card = vm.full_data.report_template;
            if (_card.additional_subjects && _card.additional_subjects && _card.additional_subjects.subjects && _card.additional_subjects.subjects.length) {
                if (_card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveSixSevenTermoneCtrl.can_published_edit;
    };
};
TypefiveSixSevenTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixSixSevenTermone = 'typesixSixSevenTermone';

var TypesixSixSevenTermone = function TypesixSixSevenTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixSixSevenTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesixSixSevenTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixSixSevenTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixSixSevenTermoneCtrl.card_details;
        vm.full_data = this.typesixSixSevenTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card2 = vm.full_data.report_template;
            if (_card2.additional_subjects && _card2.additional_subjects && _card2.additional_subjects.subjects && _card2.additional_subjects.subjects.length) {
                if (_card2.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card2.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesixSixSevenTermoneCtrl.can_published_edit;
    };
};
TypesixSixSevenTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesevenOneTwoTermone = 'typesevenOneTwoTermone';

var TypesevenOneTwoTermone = function TypesevenOneTwoTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesevenOneTwoTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesevenOneTwoTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesevenOneTwoTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typesevenOneTwoTermoneCtrl.card_details;
        vm.full_data = this.typesevenOneTwoTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card3 = vm.full_data.report_template;
            if (_card3.additional_subjects && _card3.additional_subjects && _card3.additional_subjects.subjects && _card3.additional_subjects.subjects.length) {
                if (_card3.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card3.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesevenOneTwoTermoneCtrl.can_published_edit;
    };
};
TypesevenOneTwoTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typealnOneTwoTermone = 'typealnOneTwoTermone';

var TypealnOneTwoTermone = function TypealnOneTwoTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypealnOneTwoTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typealnOneTwoTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typealnOneTwoTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typealnOneTwoTermoneCtrl.card_details;
        vm.full_data = this.typealnOneTwoTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card4 = vm.full_data.report_template;
            if (_card4.additional_subjects && _card4.additional_subjects && _card4.additional_subjects.subjects && _card4.additional_subjects.subjects.length) {
                if (_card4.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card4.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typealnOneTwoTermoneCtrl.can_published_edit;
    };
};
TypealnOneTwoTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveEightTermone = 'typefiveEightTermone';

var TypefiveEightTermone = function TypefiveEightTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveEightTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveEightTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveEightTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveEightTermoneCtrl.card_details;
        vm.full_data = this.typefiveEightTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card5 = vm.full_data.report_template;
            if (_card5.additional_subjects && _card5.additional_subjects && _card5.additional_subjects.subjects && _card5.additional_subjects.subjects.length) {
                if (_card5.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card5.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveEightTermoneCtrl.can_published_edit;
        vm.total_max_mark = 0;
        if (vm.card_details && vm.card_details.length) {
            vm.card_details.forEach(function (bucket) {
                vm.total_max_mark += parseInt(bucket.max_mark) || 0;
            });
        }
    };
};
TypefiveEightTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

// const typefiveOneTwoTermone = 'typefiveOneTwoTermone'
// class TypefiveOneTwoTermone {
//     constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
//         'ngInject';
//         let vm = this;
//         vm.allStudentReportData = undefined;
//         vm.card_details = undefined;
//         this.$onInit = function () {
//             vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
//             vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
//             vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
// 			console.log("typefiveOneTwoTermoneCtrl",this.typefiveOneTwoTermoneCtrl)
//         };
//     }
// }


var typesixOneTwoTermone = 'typesixOneTwoTermone';

var TypesixOneTwoTermone = function TypesixOneTwoTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixOneTwoTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesixOneTwoTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixOneTwoTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixOneTwoTermoneCtrl.card_details;
        vm.full_data = this.typesixOneTwoTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card6 = vm.full_data.report_template;
            if (_card6.additional_subjects && _card6.additional_subjects && _card6.additional_subjects.subjects && _card6.additional_subjects.subjects.length) {
                if (_card6.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card6.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.typesixOneTwoTermoneCtrl.can_published_edit;
    };
};
TypesixOneTwoTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixThreeFiveTermone = 'typesixThreeFiveTermone';

var TypesixThreeFiveTermone = function TypesixThreeFiveTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixThreeFiveTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesixThreeFiveTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixThreeFiveTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixThreeFiveTermoneCtrl.card_details;
        vm.full_data = this.typesixThreeFiveTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card7 = vm.full_data.report_template;
            if (_card7.additional_subjects && _card7.additional_subjects && _card7.additional_subjects.subjects && _card7.additional_subjects.subjects.length) {
                if (_card7.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card7.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesixThreeFiveTermoneCtrl.can_published_edit;
    };
};
TypesixThreeFiveTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];
// const typefiveOneTwoTermone = 'typefiveOneTwoTermone'
// class TypefiveOneTwoTermone {
//     constructor($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
//         'ngInject';
//         let vm = this;
//         vm.allStudentReportData = undefined;
//         vm.card_details = undefined;
//         this.$onInit = function () {
//             vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
//             vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
//             vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
// 			console.log("typefiveOneTwoTermoneCtrl",this.typefiveOneTwoTermoneCtrl)
//         };
//     }
// }


var typefiveOneTwoTermone = 'typefiveOneTwoTermone';

var TypefiveOneTwoTermone = function TypefiveOneTwoTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveOneTwoTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveOneTwoTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveOneTwoTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveOneTwoTermoneCtrl.card_details;
        vm.full_data = this.typefiveOneTwoTermoneCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card8 = vm.full_data.report_template;
            if (_card8.additional_subjects && _card8.additional_subjects && _card8.additional_subjects.subjects && _card8.additional_subjects.subjects.length) {
                if (_card8.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card8.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.typefiveOneTwoTermoneCtrl.can_published_edit;
    };
};
TypefiveOneTwoTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveThreeFiveTermone = 'typefiveThreeFiveTermone';

var TypefiveThreeFiveTermone = function TypefiveThreeFiveTermone($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveThreeFiveTermone);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveThreeFiveTermoneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveThreeFiveTermoneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveThreeFiveTermoneCtrl.card_details;
        vm.full_data = this.typefiveThreeFiveTermoneCtrl.full_data;
        console.log("this.typefiveThreeFiveTermoneCtrl", this.typefiveThreeFiveTermoneCtrl);

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card9 = vm.full_data.report_template;
            if (_card9.additional_subjects && _card9.additional_subjects && _card9.additional_subjects.subjects && _card9.additional_subjects.subjects.length) {
                if (_card9.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card9.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveThreeFiveTermoneCtrl.can_published_edit;
    };
};
TypefiveThreeFiveTermone.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivekbtenTermOne = 'typefivekbtenTermOne';

var TypefivekbtenTermOne = function TypefivekbtenTermOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivekbtenTermOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefivekbtenTermOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefivekbtenTermOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefivekbtenTermOneCtrl.card_details;
    };
};
TypefivekbtenTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivekbtenTermTwo = 'typefivekbtenTermTwo';

var TypefivekbtenTermTwo = function TypefivekbtenTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivekbtenTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefivekbtenTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefivekbtenTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefivekbtenTermTwoCtrl.card_details;
    };
};
TypefivekbtenTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivekbEightNineTermOne = 'typefivekbEightNineTermOne';

var TypefivekbEightNineTermOne = function TypefivekbEightNineTermOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivekbEightNineTermOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefivekbEightNineTermOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefivekbEightNineTermOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typefivekbEightNineTermOneCtrl.card_details;
    };
};
TypefivekbEightNineTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivekbEightNineTermTwo = 'typefivekbEightNineTermTwo';

var TypefivekbEightNineTermTwo = function TypefivekbEightNineTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivekbEightNineTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefivekbEightNineTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefivekbEightNineTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefivekbEightNineTermTwoCtrl.card_details;
    };
};
TypefivekbEightNineTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivekbEightNineTermThree = 'typefivekbEightNineTermThree';

var TypefivekbEightNineTermThree = function TypefivekbEightNineTermThree($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivekbEightNineTermThree);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefivekbEightNineTermThreeCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefivekbEightNineTermThreeCtrl.sendForApprovalFlag;
        vm.card_details = this.typefivekbEightNineTermThreeCtrl.card_details;
    };
};
TypefivekbEightNineTermThree.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelExamTermOne = 'typesixModelExamTermOne';

var TypeSixModelExamOne = function TypeSixModelExamOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeSixModelExamOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        console.log('componentttttt');
        console.log(_type_6_model_exam_2.default);
        vm.allStudentReportData = this.typeSixModelExamOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeSixModelExamOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typeSixModelExamOneCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeSixModelExamOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelExamTermOnenineten = 'typesixModelExamTermOnenineten';

var TypesixModelExamTermOnenineten = function TypesixModelExamTermOnenineten($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixModelExamTermOnenineten);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        console.log('componentttttt');
        console.log(_type_6_model_exam_1_nineten2.default);
        vm.allStudentReportData = this.typesixModelExamTermOneninetenCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixModelExamTermOneninetenCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixModelExamTermOneninetenCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypesixModelExamTermOnenineten.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelExamTermTwonineten = 'typesixModelExamTermTwonineten';

var TypesixModelExamTermTwonineten = function TypesixModelExamTermTwonineten($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixModelExamTermTwonineten);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        console.log('componentttttt');
        vm.allStudentReportData = this.typesixModelExamTermTwoninetenCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixModelExamTermTwoninetenCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixModelExamTermTwoninetenCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypesixModelExamTermTwonineten.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelExamTermTwoNospace = 'typesixModelExamTermTwoNospace';

var TypesixModelExamTermTwoNospace = function TypesixModelExamTermTwoNospace($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixModelExamTermTwoNospace);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        console.log('componentttttt');
        vm.allStudentReportData = this.typesixModelExamTermTwoNospaceCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixModelExamTermTwoNospaceCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixModelExamTermTwoNospaceCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypesixModelExamTermTwoNospace.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelAnnualExamTerm = 'typesixModelAnnualExamTerm';

var TypesixModelAnnualExamTerm = function TypesixModelAnnualExamTerm($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixModelAnnualExamTerm);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        console.log('componentttttt');
        vm.allStudentReportData = this.typesixModelAnnualExamTermCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixModelAnnualExamTermCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixModelAnnualExamTermCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypesixModelAnnualExamTerm.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeSevenCalicultAnnual = 'typeSevenCalicultAnnual';

var TypeSevenCalicultAnnual = function TypeSevenCalicultAnnual($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeSevenCalicultAnnual);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeSevenCalicultAnnualCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeSevenCalicultAnnualCtrl.sendForApprovalFlag;
        vm.card_details = this.typeSevenCalicultAnnualCtrl.card_details;
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeSevenCalicultAnnual.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNinePT = 'typeNinePt';

var TypeNinePT = function TypeNinePT($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNinePT);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNinePTCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNinePTCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNinePTCtrl.card_details;
        console.log(vm.allStudentReportData);
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop = function _loop(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop(k);
                }
            })();
        }
        console.log(vm.card_details);
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNinePT.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNineTermOneHF = 'typeNineTermOneHf';

var TypeNineTermOneHF = function TypeNineTermOneHF($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNineTermOneHF);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.can_published_edit = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNineTermOneHFCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNineTermOneHFCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNineTermOneHFCtrl.card_details;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop2 = function _loop2(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop2(k);
                }
            })();
        }
        vm.can_published_edit = this.typeNineTermOneHFCtrl.can_published_edit;
    };
};
TypeNineTermOneHF.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNineTermAe = 'typeNineTermAe';

var TypeNineTermAe = function TypeNineTermAe($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNineTermAe);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNineTermAeCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNineTermAeCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNineTermAeCtrl.card_details;
        vm.full_data = this.typeNineTermAeCtrl.full_data;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop3 = function _loop3(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop3(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subject && card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.type9_specific_subject = true;
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                }
            }
        }
        console.log(vm.card_details);
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNineTermAe.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNineTwelveTermAe = 'typeNineTwelveTermAe';

var TypeNineTwelveTermAe = function TypeNineTwelveTermAe($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNineTwelveTermAe);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.type9_specific_subject = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNineTwelveTermAeCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNineTwelveTermAeCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNineTwelveTermAeCtrl.card_details;
        vm.full_data = this.typeNineTwelveTermAeCtrl.full_data;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop4 = function _loop4(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop4(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subject && card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.type9_specific_subject = true;
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                }
            }
        }
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNineTwelveTermAe.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNinekbUnitTestOne = 'typeNinekbUnitTestOne';

var TypeNinekbUnitTestOne = function TypeNinekbUnitTestOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNinekbUnitTestOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNinekbUnitTestOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNinekbUnitTestOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNinekbUnitTestOneCtrl.card_details;
        console.log(vm.allStudentReportData);
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop5 = function _loop5(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop5(k);
                }
            })();
        }
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNinekbUnitTestOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNineKbtermOnehf = 'typeNineKbtermOnehf';

var TypeNineKbtermOnehf = function TypeNineKbtermOnehf($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNineKbtermOnehf);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNineKbtermOnehfCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNineKbtermOnehfCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNineKbtermOnehfCtrl.card_details;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop6 = function _loop6(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop6(k);
                }
            })();
        }
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNineKbtermOnehf.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNineKbtermTwo = 'typeNinekbtermTwo';

var TypeNineKbtermTwo = function TypeNineKbtermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNineKbtermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNineKbtermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNineKbtermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNineKbtermTwoCtrl.card_details;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop7 = function _loop7(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop7(k);
                }
            })();
        }
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNineKbtermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNinekbTermThreeCtrl = 'typeNinekbTermThree';

var TypeNinekbTermThreeCtrl = function TypeNinekbTermThreeCtrl($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeNinekbTermThreeCtrl);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.type9_specific_subject = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeNinekbTermThreeCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeNinekbTermThreeCtrl.sendForApprovalFlag;
        vm.card_details = this.typeNinekbTermThreeCtrl.card_details;
        vm.full_data = this.typeNinekbTermThreeCtrl.full_data;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop8 = function _loop8(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop8(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subject && card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.type9_specific_subject = true;
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                }
            }
        }
        // vm.can_published_edit = this.typeSixModelExamOneCtrl.can_published_edit;
    };
};
TypeNinekbTermThreeCtrl.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type12termcbse = 'type12termcbse';

var Type12_termcbse = function Type12_termcbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type12_termcbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type12_termcbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type12_termcbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type12_termcbseCtrl.card_details;
        vm.full_data = this.type12_termcbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card10 = vm.full_data.report_template;
            if (_card10.additional_subjects && _card10.additional_subjects && _card10.additional_subjects.subjects && _card10.additional_subjects.subjects.length) {
                if (_card10.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card10.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type12_termcbseCtrl.can_published_edit;
    };
};
Type12_termcbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type12NineTentermcbse = 'type12NineTentermcbse';

var Type12NineTentermcbse = function Type12NineTentermcbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type12NineTentermcbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.is_main = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type12NineTentermcbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type12NineTentermcbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type12NineTentermcbseCtrl.card_details;
        vm.full_data = this.type12NineTentermcbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card11 = vm.full_data.report_template;
            if (_card11.additional_subjects && _card11.additional_subjects && _card11.additional_subjects.subjects && _card11.additional_subjects.subjects.length) {
                if (_card11.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card11.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card12 = vm.full_data.report_template;
            if (_card12.additional_subjects && _card12.additional_subjects && _card12.additional_subjects.subjects && _card12.additional_subjects.subjects.length) {
                if (_card12.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) === -1 && _card12.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) === -1) {
                    vm.card_details = _card12.activity_buckets;
                    vm.is_main = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type12NineTentermcbseCtrl.can_published_edit;
    };
};
Type12NineTentermcbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var eltPublishedReport = 'eltPublishedReport';

var EltPublishedReport = function EltPublishedReport($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, EltPublishedReport);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.is_main = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.eltPublishedReportCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.eltPublishedReportCtrl.sendForApprovalFlag;
        vm.card_details = this.eltPublishedReportCtrl.card_details;
        vm.full_data = this.eltPublishedReportCtrl.full_data;

        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.eltPublishedReportCtrl.can_published_edit;
    };
};
EltPublishedReport.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20kb10Gradeterm1 = 'type20kb10Gradeterm1';

var Type20kb10Gradeterm1Ctrl = function Type20kb10Gradeterm1Ctrl($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20kb10Gradeterm1Ctrl);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.is_main = false;
    this.$onInit = function () {

        vm.allStudentReportData = this.type20kb10Gradeterm1Ctrl.allStudentReportData;
        var subject_id = vm.allStudentReportData.academic_details.subject_id;
        vm.sendForApprovalFlag = this.type20kb10Gradeterm1Ctrl.sendForApprovalFlag;
        vm.card_details = this.type20kb10Gradeterm1Ctrl.card_details;
        vm.full_data = this.type20kb10Gradeterm1Ctrl.full_data;
        var card = vm.full_data.report_template;
        vm.can_published_edit = this.type20kb10Gradeterm1Ctrl.can_published_edit;
        var _isMain = true,
            isSpecific = false,
            is40 = false;
        if (card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.indexOf(subject_id) !== -1) {
            _isMain = false;
            isSpecific = false;
            is40 = true;
        }
        if (card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.indexOf(subject_id) !== -1) {
            _isMain = false;
            isSpecific = true;
            is40 = false;
        }
        vm._isMain = _isMain;
        vm.isSpecific = isSpecific;
        vm.is40 = is40;
    };
};
Type20kb10Gradeterm1Ctrl.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20termcbse = 'type20termcbse';

var Type20_termcbse = function Type20_termcbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20_termcbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type20_termcbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type20_termcbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type20_termcbseCtrl.card_details;
        vm.full_data = this.type20_termcbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card13 = vm.full_data.report_template;
            if (_card13.additional_subjects && _card13.additional_subjects && _card13.additional_subjects.subjects && _card13.additional_subjects.subjects.length) {
                if (_card13.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card13.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.type20_termcbseCtrl.can_published_edit;
    };
};
Type20_termcbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20termcbse18 = 'type20termcbse18';

var Type20_termcbse18 = function Type20_termcbse18($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20_termcbse18);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type20_termcbse18Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type20_termcbse18Ctrl.sendForApprovalFlag;
        vm.card_details = this.type20_termcbse18Ctrl.card_details;
        vm.full_data = this.type20_termcbse18Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card14 = vm.full_data.report_template;
            if (_card14.additional_subjects && _card14.additional_subjects && _card14.additional_subjects.subjects && _card14.additional_subjects.subjects.length) {
                if (_card14.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card14.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type20_termcbse18Ctrl.can_published_edit;
    };
};
Type20_termcbse18.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20term2cbse = 'type20term2cbse';

var Type20_term2cbse = function Type20_term2cbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20_term2cbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.can_published_edit = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.type20_term2cbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type20_term2cbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type20_term2cbseCtrl.card_details;
        vm.full_data = this.type20_term2cbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card15 = vm.full_data.report_template;
            if (_card15.additional_subjects && _card15.additional_subjects && _card15.additional_subjects.subjects && _card15.additional_subjects.subjects.length) {
                if (_card15.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card15.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.type20_term2cbseCtrl.can_published_edit;
    };
};
Type20_term2cbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20term2cbse18 = 'type20term2cbse18';

var Type20_termtwocbse18 = function Type20_termtwocbse18($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20_termtwocbse18);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type20_term2cbse18Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type20_term2cbse18Ctrl.sendForApprovalFlag;
        vm.card_details = this.type20_term2cbse18Ctrl.card_details;
        vm.full_data = this.type20_term2cbse18Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card16 = vm.full_data.report_template;
            if (_card16.additional_subjects && _card16.additional_subjects && _card16.additional_subjects.subjects && _card16.additional_subjects.subjects.length) {
                if (_card16.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card16.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type20_term2cbse18Ctrl.can_published_edit;
    };
};
Type20_termtwocbse18.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type20kb10Gradeterm2 = 'type20kb10Gradeterm2';

var Type20kb10Gradeterm2Ctrl = function Type20kb10Gradeterm2Ctrl($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type20kb10Gradeterm2Ctrl);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.is_main = false;
    this.$onInit = function () {

        vm.allStudentReportData = this.type20kb10Gradeterm2Ctrl.allStudentReportData;
        var subject_id = vm.allStudentReportData.academic_details.subject_id;
        vm.sendForApprovalFlag = this.type20kb10Gradeterm2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type20kb10Gradeterm2Ctrl.card_details;
        vm.full_data = this.type20kb10Gradeterm2Ctrl.full_data;
        var card = vm.full_data.report_template;
        vm.can_published_edit = this.type20kb10Gradeterm2Ctrl.can_published_edit;
        var _isMain = true,
            isSpecific = false,
            is40 = false;
        if (card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.indexOf(subject_id) !== -1) {
            _isMain = false;
            isSpecific = false;
            is40 = true;
        }
        if (card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.indexOf(subject_id) !== -1) {
            _isMain = false;
            isSpecific = true;
            is40 = false;
        }
        vm._isMain = _isMain;
        vm.isSpecific = isSpecific;
        vm.is40 = is40;
    };
};
Type20kb10Gradeterm2Ctrl.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typethirtykbtenTermOne = 'typethirtykbtenTermOne';

var TypethirtykbtenTermOne = function TypethirtykbtenTermOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermOneCtrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermOneCtrl.card_details;
        vm.can_published_edit = this.typethirtykbtenTermOneCtrl.can_published_edit;
        var card = vm.full_data.report_template;
        if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
            vm.moe_maxmark = 50;
            if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                vm.moe_maxmark = 100;
            }
        }
    };
};
TypethirtykbtenTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var typethirtykbtenTermTwo = 'typethirtykbtenTermTwo';

var TypethirtykbtenTermTwo = function TypethirtykbtenTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermTwoCtrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermTwoCtrl.card_details;
        vm.can_published_edit = this.typethirtykbtenTermTwoCtrl.can_published_edit;

        var card = vm.full_data.report_template;
        if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
            vm.moe_maxmark = 50;
            if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                vm.moe_maxmark = 100;
            }
        }
    };
};
TypethirtykbtenTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var type8to10termcbse = 'type8to10termcbse';

var Type8to10_termOnecbse = function Type8to10_termOnecbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type8to10_termOnecbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type8to10_termcbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type8to10_termcbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type8to10_termcbseCtrl.card_details;
        vm.full_data = this.type8to10_termcbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card17 = vm.full_data.report_template;
            if (_card17.additional_subjects && _card17.additional_subjects && _card17.additional_subjects.subjects && _card17.additional_subjects.subjects.length) {
                if (_card17.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card17.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type8to10_termcbseCtrl.can_published_edit;
    };
};
Type8to10_termOnecbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typetermcbse8to10 = 'typetermcbse8to10';

var TypetermOnecbse_8to10 = function TypetermOnecbse_8to10($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypetermOnecbse_8to10);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typetermcbse_8to10Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetermcbse_8to10Ctrl.sendForApprovalFlag;
        vm.card_details = this.typetermcbse_8to10Ctrl.card_details;
        vm.full_data = this.typetermcbse_8to10Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card18 = vm.full_data.report_template;
            if (_card18.additional_subjects && _card18.additional_subjects && _card18.additional_subjects.subjects && _card18.additional_subjects.subjects.length) {
                if (_card18.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card18.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.typetermcbse_8to10Ctrl.can_published_edit;
    };
};
TypetermOnecbse_8to10.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type6to7alncbse = 'type6to7alncbse';

var Type6to7_termAlncbse = function Type6to7_termAlncbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type6to7_termAlncbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6to7_alncbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type6to7_alncbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type6to7_alncbseCtrl.card_details;
        vm.full_data = this.type6to7_alncbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card19 = vm.full_data.report_template;
            if (_card19.additional_subjects && _card19.additional_subjects && _card19.additional_subjects.subjects && _card19.additional_subjects.subjects.length) {
                if (_card19.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card19.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type6to7_alncbseCtrl.can_published_edit;
    };
};
Type6to7_termAlncbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type6to7tcscbse = 'type6to7tcscbse';

var Type6to7_termTcscbse = function Type6to7_termTcscbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type6to7_termTcscbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6to7_tcscbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type6to7_tcscbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type6to7_tcscbseCtrl.card_details;
        vm.full_data = this.type6to7_tcscbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card20 = vm.full_data.report_template;
            if (_card20.additional_subjects && _card20.additional_subjects && _card20.additional_subjects.subjects && _card20.additional_subjects.subjects.length) {
                if (_card20.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card20.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type6to7_tcscbseCtrl.can_published_edit;
    };
};
Type6to7_termTcscbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type3to5tcscbse = 'type3to5tcscbse';

var Type3to5_termTcscbse = function Type3to5_termTcscbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type3to5_termTcscbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type3to5_tcscbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type3to5_tcscbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type3to5_tcscbseCtrl.card_details;
        vm.full_data = this.type3to5_tcscbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card21 = vm.full_data.report_template;
            if (_card21.additional_subjects && _card21.additional_subjects && _card21.additional_subjects.subjects && _card21.additional_subjects.subjects.length) {
                if (_card21.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card21.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type3to5_tcscbseCtrl.can_published_edit;
    };
};
Type3to5_termTcscbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type3to5alncbse = 'type3to5alncbse';

var Type3to5_termAlncbse = function Type3to5_termAlncbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type3to5_termAlncbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type3to5_alncbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type3to5_alncbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type3to5_alncbseCtrl.card_details;
        vm.full_data = this.type3to5_alncbseCtrl.full_data;
        // let is25 = false
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    // is25 = true
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card22 = vm.full_data.report_template;
            if (_card22.additional_subjects && _card22.additional_subjects && _card22.additional_subjects.subjects && _card22.additional_subjects.subjects.length) {
                if (_card22.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card22.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type3to5_alncbseCtrl.can_published_edit;
        // vm.is25 = is25
    };
};
Type3to5_termAlncbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type1to2tcscbse = 'type1to2tcscbse';

var Type1to2_termTcscbse = function Type1to2_termTcscbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type1to2_termTcscbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type1to2_tcscbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type1to2_tcscbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type1to2_tcscbseCtrl.card_details;
        vm.full_data = this.type1to2_tcscbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card23 = vm.full_data.report_template;
            if (_card23.additional_subjects && _card23.additional_subjects && _card23.additional_subjects.subjects && _card23.additional_subjects.subjects.length) {
                if (_card23.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card23.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type1to2_tcscbseCtrl.can_published_edit;
    };
};
Type1to2_termTcscbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typethirtykbtenTermThree = 'typethirtykbtenTermThree';

var TypethirtykbtenTermThree = function TypethirtykbtenTermThree($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermThree);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.subject_40_subjects = false;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermThreeCtrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermThreeCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermThreeCtrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermThreeCtrl.card_details;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            //40
            console.log(card);
            if (card.subject_40_subjects && card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                }
            }
            //subjects on top
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                console.log(card.specific_subjects.subjects, 'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id);
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                }
            }
        }
    };
    console.log(vm.content_mngr);
};
TypethirtykbtenTermThree.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typethirtykbtenTermOneNew26 = 'typethirtykbtenTermOneNew26';

var TypethirtykbtenTermOneNew26 = function TypethirtykbtenTermOneNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermOneNew26);

    var vm = this;
    vm.full_data = undefined;
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermOneNew26Ctrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermOneNew26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermOneNew26Ctrl.card_details;
    };
};
TypethirtykbtenTermOneNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typethirtykbtenTermTwoNew26 = 'typethirtykbtenTermTwoNew26';

var TypethirtykbtenTermTwoNew26 = function TypethirtykbtenTermTwoNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermTwoNew26);

    var vm = this;
    vm.full_data = undefined;
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermTwoNew26Ctrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermTwoNew26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermTwoNew26Ctrl.card_details;
    };
};
TypethirtykbtenTermTwoNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typethirtykbtenTermThreeNew26 = 'typethirtykbtenTermThreeNew26';

var TypethirtykbtenTermThreeNew26 = function TypethirtykbtenTermThreeNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypethirtykbtenTermThreeNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.subject_40_subjects = false;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    this.$onInit = function () {
        vm.full_data = this.typethirtykbtenTermThreeNew26Ctrl.full_data;
        vm.allStudentReportData = this.typethirtykbtenTermThreeNew26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag;
        vm.card_details = this.typethirtykbtenTermThreeNew26Ctrl.card_details;
        vm.can_published_edit = this.typethirtykbtenTermThreeNew26Ctrl.can_published_edit;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                }
            }
            if (card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                }
            }
        }
    };
    console.log(vm.content_mngr);
};
TypethirtykbtenTermThreeNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typetenkbtenTermOne = 'typetenkbtenTermOne';

var TypetenkbTermOne = function TypetenkbTermOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypetenkbTermOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.subject_40_subjects = false;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        vm.full_data = this.typetenkbtenTermOneCtrl.full_data;
        // console.log(vm.full_data,"lllllllllllllllyyyyyyyyyyyyyyyyy")
        vm.allStudentReportData = this.typetenkbtenTermOneCtrl.allStudentReportData;
        // console.log(vm.allStudentReportData,"lllllllllllllllyyyyyyyyyyyyyyyyy")
        vm.sendForApprovalFlag = this.typetenkbtenTermOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbtenTermOneCtrl.card_details;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            //40
            console.log(card);
            if (card.subject_40_subjects && card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                }
            }
            //subjects on top
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                console.log(card.specific_subjects.subjects, 'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id);
                console.log(vm.typetenkbtenTermOneCtrl.can_published_edit, "lllllyyyy");
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                    vm.moe_maxmark = 50;
                    if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                        vm.moe_maxmark = 100;
                    }
                }
            }
        }
        vm.can_published_edit = this.typetenkbtenTermOneCtrl.can_published_edit;
    };
    console.log(vm.content_mngr);
};
TypetenkbTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var typetenkbtenTermTwo = 'typetenkbtenTermTwo';

var TypetenkbTermTwo = function TypetenkbTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypetenkbTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.subject_40_subjects = false;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        vm.full_data = this.typetenkbtenTermTwoCtrl.full_data;
        // console.log(vm.full_data,"lllllllllllllllyyyyyyyyyyyyyyyyy")
        vm.allStudentReportData = this.typetenkbtenTermTwoCtrl.allStudentReportData;
        // console.log(vm.allStudentReportData,"lllllllllllllllyyyyyyyyyyyyyyyyy")
        vm.sendForApprovalFlag = this.typetenkbtenTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbtenTermTwoCtrl.card_details;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            //40
            console.log(card);
            if (card.subject_40_subjects && card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                }
            }
            //subjects on top
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                console.log(card.specific_subjects.subjects, 'specific_subjectsspecific_subjects', vm.allStudentReportData.academic_details.subject_id);
                console.log(vm.typetenkbtenTermTwoCtrl.can_published_edit, "lllllyyyy");
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                    vm.moe_maxmark = 50;
                    if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                        vm.moe_maxmark = 100;
                    }
                }
            }
        }
    };
    // console.log(vm)
};
TypetenkbTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var typetenkbeleventwelveTermOne = 'typetenkbeleventwelveTermOne';

var TypetenkbeleventwelveTermOne = function TypetenkbeleventwelveTermOne($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypetenkbeleventwelveTermOne);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        console.log(vm.full_data, "vm.full_data-------------");
        vm.full_data = this.typetenkbeleventwelveTermOneCtrl.full_data;
        vm.allStudentReportData = this.typetenkbeleventwelveTermOneCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetenkbeleventwelveTermOneCtrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbeleventwelveTermOneCtrl.card_details;
        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(vm.card_details, "77777777777777777");
            if (card.type10_specific_subjects && card.type10_specific_subjects && card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length) {
                if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type10_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    // vm.additional_subjects = false
                    vm.moe_maxmark = 50;
                    if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                        vm.moe_maxmark = 100;
                    }
                }
            }
        }
        // console.log(vm.full_data,"vm.full_data----");
        vm.can_published_edit = this.typetenkbeleventwelveTermOneCtrl.can_published_edit;
    };
};
TypetenkbeleventwelveTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var typetenkbeleventwelveTermTwo = 'typetenkbeleventwelveTermTwo';

var TypetenkbeleventwelveTermTwo = function TypetenkbeleventwelveTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, TypetenkbeleventwelveTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    var schoolid = localStorageService.get('school_id');
    var SCHOOLS_100 = ['ps4vyLJhQvPZjfxaH', '2FwuqhgeoKt6SQiC', 'apX7mQ9LsV2kZdFaH'];
    this.$onInit = function () {
        vm.full_data = this.typetenkbeleventwelveTermTwoCtrl.full_data;
        vm.allStudentReportData = this.typetenkbeleventwelveTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetenkbeleventwelveTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbeleventwelveTermTwoCtrl.card_details;
        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.type10_specific_subjects && card.type10_specific_subjects && card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length) {
                if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type10_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    // vm.additional_subjects = false

                    vm.moe_maxmark = 50;
                    if (SCHOOLS_100.indexOf(schoolid) !== -1) {
                        vm.moe_maxmark = 100;
                    }
                }
            }
        }
        vm.can_published_edit = this.typetenkbeleventwelveTermTwoCtrl.can_published_edit;
        // console.log(vm.full_data,"vm.full_data----");
    };
};
TypetenkbeleventwelveTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var typetenkbeleventwelveTermOneNew26 = 'typetenkbeleventwelveTermOneNew26';

var TypetenkbeleventwelveTermOneNew26 = function TypetenkbeleventwelveTermOneNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypetenkbeleventwelveTermOneNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    this.$onInit = function () {
        vm.full_data = this.typetenkbeleventwelveTermOneNew26Ctrl.full_data;
        vm.allStudentReportData = this.typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetenkbeleventwelveTermOneNew26Ctrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbeleventwelveTermOneNew26Ctrl.card_details;
        vm.can_published_edit = this.typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type10_specific_subjects && card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length) {
                if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type10_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
    };
};
TypetenkbeleventwelveTermOneNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typetenkbeleventwelveTermTwoNew26 = 'typetenkbeleventwelveTermTwoNew26';

var TypetenkbeleventwelveTermTwoNew26 = function TypetenkbeleventwelveTermTwoNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypetenkbeleventwelveTermTwoNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    this.$onInit = function () {
        vm.full_data = this.typetenkbeleventwelveTermTwoNew26Ctrl.full_data;
        vm.allStudentReportData = this.typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetenkbeleventwelveTermTwoNew26Ctrl.sendForApprovalFlag;
        vm.card_details = this.typetenkbeleventwelveTermTwoNew26Ctrl.card_details;
        vm.can_published_edit = this.typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type10_specific_subjects && card.type10_specific_subjects.subjects && card.type10_specific_subjects.subjects.length) {
                if (card.type10_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type10_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
    };
};
TypetenkbeleventwelveTermTwoNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02grade11sc = 'type02grade11sc';

var Type02grade11sc = function Type02grade11sc($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, localStorageService) {
    'ngInject';

    _classCallCheck(this, Type02grade11sc);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.academic_header = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.show_pct = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade11scCtrl.allStudentReportData;
        vm.academic_header = this.type02grade11scCtrl.academic_header;
        vm.sendForApprovalFlag = this.type02grade11scCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade11scCtrl.card_details;
        $scope.getColspan = function (cardDetails) {
            return cardDetails.filter(function (bucket) {
                return bucket.max_mark;
            }).length + 1;
        };
        if (vm.allStudentReportData.results[0] && vm.allStudentReportData.results[0]["marks"]) {
            if (Object.keys(vm.allStudentReportData.results[0]["marks"]).includes("periodic_test")) {
                vm.show_pct = true;
            }
        }
        vm.full_data = this.type02grade11scCtrl.full_data;
        vm.non_practical_sub = this.type02grade11scCtrl.full_data.report_template.type02_non_practical_sub;

        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop9 = function _loop9(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop9(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.additional_subjects && card.additional_subjects && card.additional_subjects.subjects && card.additional_subjects.subjects.length) {
                if (card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card24 = vm.full_data.report_template;
            // console.log(card,'vm.is_specific');
            if (_card24.type9_specific_subject && _card24.type9_specific_subjects.subjects && _card24.type9_specific_subjects.subjects.length) {
                if (_card24.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card24.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type02grade11scCtrl.can_published_edit;

        vm.show_pct = vm.allStudentReportData.results.some(function (r) {
            return r.marks && r.marks.pct !== undefined;
        });

        var school_id = localStorageService.get('school_id');
        var school_list = [];
        // vm.show_pct = true
        // if(!school_list.includes(school_id)){
        //     vm.show_pct = false
        // }
    };
};
Type02grade11sc.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "localStorageService"];

var type02grade11sct2 = 'type02grade11sct2';

var Type02grade11sct2 = function Type02grade11sct2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02grade11sct2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.academic_header = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade11sct2Ctrl.allStudentReportData;
        vm.academic_header = this.type02grade11sct2Ctrl.academic_header;
        vm.sendForApprovalFlag = this.type02grade11sct2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type02grade11sct2Ctrl.card_details;
        $scope.getColspan = function (cardDetails) {
            return cardDetails.filter(function (bucket) {
                return bucket.max_mark;
            }).length + 1;
        };

        vm.full_data = this.type02grade11sct2Ctrl.full_data;
        vm.non_practical_sub = this.type02grade11sct2Ctrl.full_data.report_template.type02_non_practical_sub;

        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop10 = function _loop10(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop10(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.additional_subjects && card.additional_subjects && card.additional_subjects.subjects && card.additional_subjects.subjects.length) {
                if (card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card25 = vm.full_data.report_template;
            // console.log(card,'vm.is_specific');
            if (_card25.type9_specific_subject && _card25.type9_specific_subjects.subjects && _card25.type9_specific_subjects.subjects.length) {
                if (_card25.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card25.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }

        var NO_MODEL_EXAM_SCHOOLS = ["CPpbKPQTcuG97i3kv", "m2LMtqaESFZf6xDE8"];
        var NO_MODEL_EXAM_YEARS = ["2025-2026", "2026-2027"];

        vm.hideModelExam = NO_MODEL_EXAM_SCHOOLS.indexOf(vm.full_data.school_id) !== -1 && vm.full_data.permissions && NO_MODEL_EXAM_YEARS.indexOf(vm.full_data.permissions.year) !== -1;

        if (vm.hideModelExam && vm.card_details) {
            vm.card_details = vm.card_details.filter(function (b) {
                return b.db_key !== 'model';
            });
        }

        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type02grade11sct2Ctrl.can_published_edit;
    };
};
Type02grade11sct2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02grade12sc = 'type02grade12sc';

var Type02grade12sc = function Type02grade12sc($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02grade12sc);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.academic_header = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.show_pct = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade12scCtrl.allStudentReportData;
        vm.academic_header = this.type02grade12scCtrl.academic_header;
        vm.sendForApprovalFlag = this.type02grade12scCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade12scCtrl.card_details;
        $scope.getColspan = function (cardDetails) {
            return cardDetails.filter(function (bucket) {
                return bucket.max_mark;
            }).length + 1;
        };

        vm.full_data = this.type02grade12scCtrl.full_data;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop11 = function _loop11(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop11(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.additional_subjects && card.additional_subjects && card.additional_subjects.subjects && card.additional_subjects.subjects.length) {
                if (card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card26 = vm.full_data.report_template;
            if (_card26.type9_specific_subject && _card26.type9_specific_subjects.subjects && _card26.type9_specific_subjects.subjects.length) {
                if (_card26.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card26.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.allStudentReportData.results[0] && vm.allStudentReportData.results[0]["marks"]) {
            if (Object.keys(vm.allStudentReportData.results[0]["marks"]).includes("pct")) {
                vm.show_pct = true;
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type02grade12scCtrl.can_published_edit;
    };
};
Type02grade12sc.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02grade12sct2 = 'type02grade12sct2';

var Type02grade12sct2 = function Type02grade12sct2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02grade12sct2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.academic_header = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade12sct2Ctrl.allStudentReportData;
        vm.academic_header = this.type02grade12sct2Ctrl.academic_header;
        vm.sendForApprovalFlag = this.type02grade12sct2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type02grade12sct2Ctrl.card_details;
        $scope.getColspan = function (cardDetails) {
            return cardDetails.filter(function (bucket) {
                return bucket.max_mark;
            }).length + 1;
        };

        vm.full_data = this.type02grade12sct2Ctrl.full_data;
        vm.non_practical_sub = this.type02grade12sct2Ctrl.full_data.report_template.type02_non_practical_sub;

        // console.log(this.type02grade12scCtrl,'fulllll');

        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop12 = function _loop12(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop12(k);
                }
            })();
        }
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.additional_subjects && card.additional_subjects && card.additional_subjects.subjects && card.additional_subjects.subjects.length) {
                if (card.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card27 = vm.full_data.report_template;
            if (_card27.type9_specific_subject && _card27.type9_specific_subjects.subjects && _card27.type9_specific_subjects.subjects.length) {
                if (_card27.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card27.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type02grade12sct2Ctrl.can_published_edit;
    };
};
Type02grade12sct2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveThreeFiveTermtwo = 'typefiveThreeFiveTermtwo';

var TypefiveThreeFiveTermtwo = function TypefiveThreeFiveTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveThreeFiveTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveThreeFiveTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveThreeFiveTermtwoCtrl.card_details;
        vm.full_data = this.typefiveThreeFiveTermtwoCtrl.full_data;
        console.log("this.typefiveThreeFiveTermtwoCtrl", this.typefiveThreeFiveTermtwoCtrl);

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card28 = vm.full_data.report_template;
            if (_card28.additional_subjects && _card28.additional_subjects && _card28.additional_subjects.subjects && _card28.additional_subjects.subjects.length) {
                if (_card28.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card28.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveThreeFiveTermtwoCtrl.can_published_edit;
    };
};
TypefiveThreeFiveTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixSixSevenTermtwo = 'typesixSixSevenTermtwo';

var TypesixSixSevenTermtwo = function TypesixSixSevenTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixSixSevenTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesixSixSevenTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixSixSevenTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixSixSevenTermtwoCtrl.card_details;
        vm.full_data = this.typesixSixSevenTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card29 = vm.full_data.report_template;
            if (_card29.additional_subjects && _card29.additional_subjects && _card29.additional_subjects.subjects && _card29.additional_subjects.subjects.length) {
                if (_card29.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card29.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesixSixSevenTermtwoCtrl.can_published_edit;
    };
};
TypesixSixSevenTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type8to10term2cbse = 'type8to10term2cbse';

var Type8to10termtwocbse = function Type8to10termtwocbse($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type8to10termtwocbse);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type8to10_term2cbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type8to10_term2cbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type8to10_term2cbseCtrl.card_details;
        vm.full_data = this.type8to10_term2cbseCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card30 = vm.full_data.report_template;
            if (_card30.additional_subjects && _card30.additional_subjects && _card30.additional_subjects.subjects && _card30.additional_subjects.subjects.length) {
                if (_card30.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card30.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type8to10_term2cbseCtrl.can_published_edit;
    };
};
Type8to10termtwocbse.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveOneTwoTermtwo = 'typefiveOneTwoTermtwo';

var TypefiveOneTwoTermtwo = function TypefiveOneTwoTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveOneTwoTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveOneTwoTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveOneTwoTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveOneTwoTermtwoCtrl.card_details;
        vm.full_data = this.typefiveOneTwoTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card31 = vm.full_data.report_template;
            if (_card31.additional_subjects && _card31.additional_subjects && _card31.additional_subjects.subjects && _card31.additional_subjects.subjects.length) {
                if (_card31.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card31.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.typefiveOneTwoTermtwoCtrl.can_published_edit;
    };
};
TypefiveOneTwoTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeoneTwoShjTermTwo = 'typeoneTwoShjTermTwo';

var TypeoneTwoShjTermTwo = function TypeoneTwoShjTermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeoneTwoShjTermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typeoneTwoShjTermTwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typeoneTwoShjTermTwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typeoneTwoShjTermTwoCtrl.card_details;
        vm.full_data = this.typeoneTwoShjTermTwoCtrl.full_data;
        console.log("this.typeoneTwoShjTermTwoCtrl", this.typeoneTwoShjTermTwoCtrl);

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card32 = vm.full_data.report_template;
            if (_card32.additional_subjects && _card32.additional_subjects && _card32.additional_subjects.subjects && _card32.additional_subjects.subjects.length) {
                if (_card32.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card32.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typeoneTwoShjTermTwoCtrl.can_published_edit;
    };
};
TypeoneTwoShjTermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type1to2tcscbsetermtwo = 'type1to2tcscbsetermtwo';

var TypeonetotwoTcstermTwo = function TypeonetotwoTcstermTwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeonetotwoTcstermTwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    console.log(vm, "type1to2_tcscbseterm2Ctrl---------");
    this.$onInit = function () {

        vm.allStudentReportData = this.type1to2_tcscbseterm2Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type1to2_tcscbseterm2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type1to2_tcscbseterm2Ctrl.card_details;
        vm.full_data = this.type1to2_tcscbseterm2Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card33 = vm.full_data.report_template;
            if (_card33.additional_subjects && _card33.additional_subjects && _card33.additional_subjects.subjects && _card33.additional_subjects.subjects.length) {
                if (_card33.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card33.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type1to2_tcscbseterm2Ctrl.can_published_edit;
        console.log(vm.can_published_edit, "vm.can_published_edit===========");
    };
};
TypeonetotwoTcstermTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type6to7tcscbseterm2 = 'type6to7tcscbseterm2';

var Type6to7_termTcscbseterm2 = function Type6to7_termTcscbseterm2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type6to7_termTcscbseterm2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6to7_tcscbseterm2Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type6to7_tcscbseterm2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type6to7_tcscbseterm2Ctrl.card_details;
        vm.full_data = this.type6to7_tcscbseterm2Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card34 = vm.full_data.report_template;
            if (_card34.additional_subjects && _card34.additional_subjects && _card34.additional_subjects.subjects && _card34.additional_subjects.subjects.length) {
                if (_card34.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card34.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type6to7_tcscbseterm2Ctrl.can_published_edit;
    };
};
Type6to7_termTcscbseterm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type3to5tcscbseterm2 = 'type3to5tcscbseterm2';

var Type3to5_termTcscbseterm2 = function Type3to5_termTcscbseterm2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type3to5_termTcscbseterm2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type3to5_tcscbseCtrltermtwo.allStudentReportData;
        vm.sendForApprovalFlag = this.type3to5_tcscbseCtrltermtwo.sendForApprovalFlag;
        vm.card_details = this.type3to5_tcscbseCtrltermtwo.card_details;
        vm.full_data = this.type3to5_tcscbseCtrltermtwo.full_data;
        console.log(vm.full_data, "vm.full_data----------------");
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card35 = vm.full_data.report_template;
            if (_card35.additional_subjects && _card35.additional_subjects && _card35.additional_subjects.subjects && _card35.additional_subjects.subjects.length) {
                if (_card35.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card35.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type3to5_tcscbseCtrltermtwo.can_published_edit;
    };
};
Type3to5_termTcscbseterm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixThreeFiveTermtwo = 'typesixThreeFiveTermtwo';

var TypesixThreeFiveTermtwo = function TypesixThreeFiveTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixThreeFiveTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesixThreeFiveTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesixThreeFiveTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typesixThreeFiveTermtwoCtrl.card_details;
        vm.full_data = this.typesixThreeFiveTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card36 = vm.full_data.report_template;
            if (_card36.additional_subjects && _card36.additional_subjects && _card36.additional_subjects.subjects && _card36.additional_subjects.subjects.length) {
                if (_card36.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card36.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesixThreeFiveTermtwoCtrl.can_published_edit;
    };
};
TypesixThreeFiveTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveSixSevenTermtwo = 'typefiveSixSevenTermtwo';

var TypefiveSixSevenTermtwo = function TypefiveSixSevenTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveSixSevenTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveSixSevenTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveSixSevenTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveSixSevenTermtwoCtrl.card_details;
        vm.full_data = this.typefiveSixSevenTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card37 = vm.full_data.report_template;
            if (_card37.additional_subjects && _card37.additional_subjects && _card37.additional_subjects.subjects && _card37.additional_subjects.subjects.length) {
                if (_card37.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card37.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveSixSevenTermtwoCtrl.can_published_edit;
    };
};
TypefiveSixSevenTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveEightTermtwo = 'typefiveEightTermtwo';

var TypefiveEightTermtwo = function TypefiveEightTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveEightTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typefiveEightTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typefiveEightTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typefiveEightTermtwoCtrl.card_details;
        vm.full_data = this.typefiveEightTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card38 = vm.full_data.report_template;
            if (_card38.additional_subjects && _card38.additional_subjects && _card38.additional_subjects.subjects && _card38.additional_subjects.subjects.length) {
                if (_card38.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card38.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typefiveEightTermtwoCtrl.can_published_edit;
        vm.total_max_mark = 0;
        if (vm.card_details && vm.card_details.length) {
            vm.card_details.forEach(function (bucket) {
                vm.total_max_mark += parseInt(bucket.max_mark) || 0;
            });
        }
    };
};
TypefiveEightTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type6to7alncbseterm2 = 'type6to7alncbseterm2';

var Type6to7_termAlncbseterm2 = function Type6to7_termAlncbseterm2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type6to7_termAlncbseterm2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6to7_alncbseCtrlterm2.allStudentReportData;
        vm.sendForApprovalFlag = this.type6to7_alncbseCtrlterm2.sendForApprovalFlag;
        vm.card_details = this.type6to7_alncbseCtrlterm2.card_details;
        vm.full_data = this.type6to7_alncbseCtrlterm2.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card39 = vm.full_data.report_template;
            if (_card39.additional_subjects && _card39.additional_subjects && _card39.additional_subjects.subjects && _card39.additional_subjects.subjects.length) {
                if (_card39.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card39.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type6to7_alncbseCtrlterm2.can_published_edit;
    };
};
Type6to7_termAlncbseterm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesevenOneTwoTermtwo = 'typesevenOneTwoTermtwo';

var TypesevenOneTwoTermtwo = function TypesevenOneTwoTermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesevenOneTwoTermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typesevenOneTwoTermtwoCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typesevenOneTwoTermtwoCtrl.sendForApprovalFlag;
        vm.card_details = this.typesevenOneTwoTermtwoCtrl.card_details;
        vm.full_data = this.typesevenOneTwoTermtwoCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {

            var card = vm.full_data.report_template;
            // console.log()
            console.log(card, "77777777777777777");
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card40 = vm.full_data.report_template;
            if (_card40.additional_subjects && _card40.additional_subjects && _card40.additional_subjects.subjects && _card40.additional_subjects.subjects.length) {
                if (_card40.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card40.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific, '===========');
        vm.can_published_edit = this.typesevenOneTwoTermtwoCtrl.can_published_edit;
    };
};
TypesevenOneTwoTermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type3to5alnterm2cbse = 'type3to5alnterm2cbse';

var TypeThreeToFiveTermAlncbsetermtwo = function TypeThreeToFiveTermAlncbsetermtwo($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypeThreeToFiveTermAlncbsetermtwo);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        console.log("ppp0000------");
        vm.allStudentReportData = this.type3to5_alnterm2cbseCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type3to5_alnterm2cbseCtrl.sendForApprovalFlag;
        vm.card_details = this.type3to5_alnterm2cbseCtrl.card_details;
        vm.full_data = this.type3to5_alnterm2cbseCtrl.full_data;
        // let is25 = false
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    // is25 = true
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card41 = vm.full_data.report_template;
            if (_card41.additional_subjects && _card41.additional_subjects && _card41.additional_subjects.subjects && _card41.additional_subjects.subjects.length) {
                if (_card41.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card41.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type3to5_alnterm2cbseCtrl.can_published_edit;
        // vm.is25 = is25
    };
};
TypeThreeToFiveTermAlncbsetermtwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typetermcbse8to10term2 = 'typetermcbse8to10term2';

var TypetermOnecbseterm2_8to10 = function TypetermOnecbseterm2_8to10($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypetermOnecbseterm2_8to10);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.typetermcbse_8to10term2Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typetermcbse_8to10term2Ctrl.sendForApprovalFlag;
        vm.card_details = this.typetermcbse_8to10term2Ctrl.card_details;
        vm.full_data = this.typetermcbse_8to10term2Ctrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card42 = vm.full_data.report_template;
            if (_card42.additional_subjects && _card42.additional_subjects && _card42.additional_subjects.subjects && _card42.additional_subjects.subjects.length) {
                if (_card42.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card42.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.typetermcbse_8to10term2Ctrl.can_published_edit;
    };
};
TypetermOnecbseterm2_8to10.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeptnoconv = 'typeptnoconv';

var TypePtNoConv = function TypePtNoConv($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypePtNoConv);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.max_mark = undefined;
    this.$onInit = function () {
        vm.allStudentReportData = this.typePtNoConvCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.typePtNoConvCtrl.sendForApprovalFlag;
        vm.card_details = this.typePtNoConvCtrl.card_details;

        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop13 = function _loop13(k) {
                    var bucket = _.find(vm.card_details, function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop13(k);
                }
            })();
        }

        vm.can_published_edit = this.typePtNoConvCtrl.can_published_edit;
        if (vm.allStudentReportData.results[0].marks.max_mark_data) {
            vm.max_mark = vm.allStudentReportData.results[0].marks.max_mark_data.periodic_test.max_mark;
        } else {
            try {
                vm.max_mark = vm.allStudentReportData["bucket_max_mark"]['periodic_test']['max_mark'];
            } catch (error) {
                console.log("Error in finding max mark");
            }
        }
    };
};
TypePtNoConv.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type25tcscbseOneFiveTerm2 = 'type25tcscbseOneFiveTerm2';

var Type25tcscbseOneFiveTerm2 = function Type25tcscbseOneFiveTerm2($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type25tcscbseOneFiveTerm2);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type25tcscbseOneFiveTerm2Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag;
        vm.card_details = this.type25tcscbseOneFiveTerm2Ctrl.card_details;
        vm.full_data = this.type25tcscbseOneFiveTerm2Ctrl.full_data;
        console.log(vm.full_data, "vm.full_data----------------");
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card43 = vm.full_data.report_template;
            if (_card43.additional_subjects && _card43.additional_subjects && _card43.additional_subjects.subjects && _card43.additional_subjects.subjects.length) {
                if (_card43.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card43.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type25tcscbseOneFiveTerm2Ctrl.can_published_edit;
    };
};
Type25tcscbseOneFiveTerm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type25tcscbseOneFive = 'type25tcscbseOneFive';

var Type25tcscbseOneFive = function Type25tcscbseOneFive($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type25tcscbseOneFive);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type25tcscbseOneFiveCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type25tcscbseOneFiveCtrl.sendForApprovalFlag;
        vm.card_details = this.type25tcscbseOneFiveCtrl.card_details;
        vm.full_data = this.type25tcscbseOneFiveCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card44 = vm.full_data.report_template;
            if (_card44.additional_subjects && _card44.additional_subjects && _card44.additional_subjects.subjects && _card44.additional_subjects.subjects.length) {
                if (_card44.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card44.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false;
                }
            }
        }
        console.log(vm.card_details, vm.full_data, vm.is_specific);
        vm.can_published_edit = this.type25tcscbseOneFiveCtrl.can_published_edit;
    };
};
Type25tcscbseOneFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveonetwoGrdTerm1New26 = 'typefiveonetwoGrdTerm1New26';

var TypefiveonetwoGrdTerm1New26 = function TypefiveonetwoGrdTerm1New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveonetwoGrdTerm1New26);

    console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^__________^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
    console.log('=== NEW26 DEBUG: TypefiveonetwoGrdTerm1New26 CONSTRUCTOR called ===');
    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type5_1_2_grade_term1_new26TemplateCtrl.card_details;
        vm.full_data = this.type5_1_2_grade_term1_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card45 = vm.full_data.report_template;
            if (_card45.additional_subjects && _card45.additional_subjects && _card45.additional_subjects.subjects && _card45.additional_subjects.subjects.length) {
                if (_card45.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card45.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypefiveonetwoGrdTerm1New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefiveonetwoGrdTerm2New26 = 'typefiveonetwoGrdTerm2New26';

var TypefiveonetwoGrdTerm2New26 = function TypefiveonetwoGrdTerm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefiveonetwoGrdTerm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type5_1_2_grade_term2_new26TemplateCtrl.card_details;
        vm.full_data = this.type5_1_2_grade_term2_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card46 = vm.full_data.report_template;
            if (_card46.additional_subjects && _card46.additional_subjects && _card46.additional_subjects.subjects && _card46.additional_subjects.subjects.length) {
                if (_card46.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card46.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypefiveonetwoGrdTerm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivethreefiveGrdTerm1New26 = 'typefivethreefiveGrdTerm1New26';

var TypefivethreefiveGrdTerm1New26 = function TypefivethreefiveGrdTerm1New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivethreefiveGrdTerm1New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type5_3_5_grade_term1_new26TemplateCtrl.card_details;
        vm.full_data = this.type5_3_5_grade_term1_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card47 = vm.full_data.report_template;
            if (_card47.additional_subjects && _card47.additional_subjects && _card47.additional_subjects.subjects && _card47.additional_subjects.subjects.length) {
                if (_card47.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card47.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypefivethreefiveGrdTerm1New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typefivethreefiveGrdTerm2New26 = 'typefivethreefiveGrdTerm2New26';

var TypefivethreefiveGrdTerm2New26 = function TypefivethreefiveGrdTerm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypefivethreefiveGrdTerm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type5_3_5_grade_term2_new26TemplateCtrl.card_details;
        vm.full_data = this.type5_3_5_grade_term2_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card48 = vm.full_data.report_template;
            if (_card48.additional_subjects && _card48.additional_subjects && _card48.additional_subjects.subjects && _card48.additional_subjects.subjects.length) {
                if (_card48.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card48.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypefivethreefiveGrdTerm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixsixsevenGrdTerm1New26 = 'typesixsixsevenGrdTerm1New26';

var TypesixsixsevenGrdTerm1New26 = function TypesixsixsevenGrdTerm1New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixsixsevenGrdTerm1New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type6_6_7_grade_term1_new26TemplateCtrl.card_details;
        vm.full_data = this.type6_6_7_grade_term1_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card49 = vm.full_data.report_template;
            if (_card49.additional_subjects && _card49.additional_subjects && _card49.additional_subjects.subjects && _card49.additional_subjects.subjects.length) {
                if (_card49.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card49.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypesixsixsevenGrdTerm1New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixsixsevenGrdTerm2New26 = 'typesixsixsevenGrdTerm2New26';

var TypesixsixsevenGrdTerm2New26 = function TypesixsixsevenGrdTerm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, TypesixsixsevenGrdTerm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type6_6_7_grade_term2_new26TemplateCtrl.card_details;
        vm.full_data = this.type6_6_7_grade_term2_new26TemplateCtrl.full_data;

        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card50 = vm.full_data.report_template;
            if (_card50.additional_subjects && _card50.additional_subjects && _card50.additional_subjects.subjects && _card50.additional_subjects.subjects.length) {
                if (_card50.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card50.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
TypesixsixsevenGrdTerm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type8to10TermcbseNew26 = 'type8to10TermcbseNew26';

var Type8to10TermcbseNew26 = function Type8to10TermcbseNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type8to10TermcbseNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type8to10_termcbse_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type8to10_termcbse_new26TemplateCtrl.card_details;
        vm.full_data = this.type8to10_termcbse_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card51 = vm.full_data.report_template;
            if (_card51.additional_subjects && _card51.additional_subjects && _card51.additional_subjects.subjects && _card51.additional_subjects.subjects.length) {
                if (_card51.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card51.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type8to10_termcbse_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type8to10TermcbseNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type8to10Termcbseterm2New26 = 'type8to10Termcbseterm2New26';

var Type8to10Termcbseterm2New26 = function Type8to10Termcbseterm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type8to10Termcbseterm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type8to10_termcbseterm2_new26TemplateCtrl.card_details;
        vm.full_data = this.type8to10_termcbseterm2_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card52 = vm.full_data.report_template;
            if (_card52.additional_subjects && _card52.additional_subjects && _card52.additional_subjects.subjects && _card52.additional_subjects.subjects.length) {
                if (_card52.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card52.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type8to10Termcbseterm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type9TermcbseNew26 = 'type9TermcbseNew26';

var Type9TermcbseNew26 = function Type9TermcbseNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type9TermcbseNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type9_termcbse_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type9_termcbse_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type9_termcbse_new26TemplateCtrl.card_details;
        vm.full_data = this.type9_termcbse_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card53 = vm.full_data.report_template;
            if (_card53.additional_subjects && _card53.additional_subjects && _card53.additional_subjects.subjects && _card53.additional_subjects.subjects.length) {
                if (_card53.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card53.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type9_termcbse_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type9TermcbseNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type9Termcbseterm2New26 = 'type9Termcbseterm2New26';

var Type9Termcbseterm2New26 = function Type9Termcbseterm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type9Termcbseterm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type9_termcbseterm2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type9_termcbseterm2_new26TemplateCtrl.card_details;
        vm.full_data = this.type9_termcbseterm2_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card54 = vm.full_data.report_template;
            if (_card54.additional_subjects && _card54.additional_subjects && _card54.additional_subjects.subjects && _card54.additional_subjects.subjects.length) {
                if (_card54.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card54.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = false; // bug 28032: an additional subject is NOT a specific subject;
                    // leaving this true rendered BOTH template sections
                }
            }
        }
        vm.can_published_edit = this.type9_termcbseterm2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type9Termcbseterm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type10TermcbseNew26 = 'type10TermcbseNew26';

var Type10TermcbseNew26 = function Type10TermcbseNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type10TermcbseNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type10_termcbse_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type10_termcbse_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type10_termcbse_new26TemplateCtrl.card_details;
        vm.full_data = this.type10_termcbse_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card55 = vm.full_data.report_template;
            if (_card55.additional_subjects && _card55.additional_subjects && _card55.additional_subjects.subjects && _card55.additional_subjects.subjects.length) {
                if (_card55.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card55.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type10_termcbse_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type10TermcbseNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type10Termcbseterm2New26 = 'type10Termcbseterm2New26';

var Type10Termcbseterm2New26 = function Type10Termcbseterm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type10Termcbseterm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type10_termcbseterm2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type10_termcbseterm2_new26TemplateCtrl.card_details;
        vm.full_data = this.type10_termcbseterm2_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card56 = vm.full_data.report_template;
            if (_card56.additional_subjects && _card56.additional_subjects && _card56.additional_subjects.subjects && _card56.additional_subjects.subjects.length) {
                if (_card56.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card56.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type10_termcbseterm2_new26TemplateCtrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type10Termcbseterm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type10KbGradeTerm1New26 = 'type10KbGradeTerm1New26';

var Type10KbGradeTerm1New26 = function Type10KbGradeTerm1New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type10KbGradeTerm1New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type10KbGradeTerm1New26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type10KbGradeTerm1New26Ctrl.sendForApprovalFlag;
        vm.card_details = this.type10KbGradeTerm1New26Ctrl.card_details;
        vm.full_data = this.type10KbGradeTerm1New26Ctrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            var cardSchoolId = vm.allStudentReportData && vm.allStudentReportData.report_card_header ? vm.allStudentReportData.report_card_header.school_id : null;
            if (card.subject_40_subjects && card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                    vm.card_details = card.subject_40_subjects.activity_buckets;
                }
            }
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                    vm.card_details = card.specific_subjects.activity_buckets;
                    if (cardSchoolId == 'ps4vyLJhQvPZjfxaH' && vm.card_details) {
                        vm.card_details = vm.card_details.map(function (b) {
                            b.max_mark = 100;
                            return b;
                        });
                    }
                }
            }
        }
        vm.can_published_edit = this.type10KbGradeTerm1New26Ctrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type10KbGradeTerm1New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type10KbGradeTerm2New26 = 'type10KbGradeTerm2New26';

var Type10KbGradeTerm2New26 = function Type10KbGradeTerm2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type10KbGradeTerm2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.content_mngr = {
        is_specific: false,
        subject_40_subjects: false,
        subject_80_subjects: true
    };
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type10KbGradeTerm2New26Ctrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type10KbGradeTerm2New26Ctrl.sendForApprovalFlag;
        vm.card_details = this.type10KbGradeTerm2New26Ctrl.card_details;
        vm.full_data = this.type10KbGradeTerm2New26Ctrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            var cardSchoolId = vm.allStudentReportData && vm.allStudentReportData.report_card_header ? vm.allStudentReportData.report_card_header.school_id : null;
            if (card.subject_40_subjects && card.subject_40_subjects && card.subject_40_subjects.subjects && card.subject_40_subjects.subjects.length) {
                if (card.subject_40_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: false,
                        subject_40_subjects: true,
                        subject_80_subjects: false
                    };
                    vm.card_details = card.subject_40_subjects.activity_buckets;
                }
            }
            if (card.specific_subjects && card.specific_subjects && card.specific_subjects.subjects && card.specific_subjects.subjects.length) {
                if (card.specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.content_mngr = {
                        is_specific: true,
                        subject_40_subjects: false,
                        subject_80_subjects: false
                    };
                    vm.card_details = card.specific_subjects.activity_buckets;
                    if (cardSchoolId == 'ps4vyLJhQvPZjfxaH' && vm.card_details) {
                        vm.card_details = vm.card_details.map(function (b) {
                            b.max_mark = 100;
                            return b;
                        });
                    }
                }
            }
        }
        vm.can_published_edit = this.type10KbGradeTerm2New26Ctrl.can_published_edit;
        vm.showScholasticTable = true;
    };
};
Type10KbGradeTerm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02Grade11ScienceNew26 = 'type02Grade11ScienceNew26';

var Type02Grade11ScienceNew26 = function Type02Grade11ScienceNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02Grade11ScienceNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade_11_science_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade_11_science_new26TemplateCtrl.card_details;
        vm.full_data = this.type02grade_11_science_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card57 = vm.full_data.report_template;
            if (_card57.additional_subjects && _card57.additional_subjects.subjects && _card57.additional_subjects.subjects.length) {
                if (_card57.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card57.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type02grade_11_science_new26TemplateCtrl.can_published_edit;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop14 = function _loop14(k) {
                    var bucket = (vm.card_details || []).find(function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop14(k);
                }
            })();
        }
        vm.showScholasticTable = true;
    };
};
Type02Grade11ScienceNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02Grade11Sciencet2New26 = 'type02Grade11Sciencet2New26';

var Type02Grade11Sciencet2New26 = function Type02Grade11Sciencet2New26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02Grade11Sciencet2New26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade_11_sciencet2_new26TemplateCtrl.card_details;
        vm.full_data = this.type02grade_11_sciencet2_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card58 = vm.full_data.report_template;
            if (_card58.additional_subjects && _card58.additional_subjects.subjects && _card58.additional_subjects.subjects.length) {
                if (_card58.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card58.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop15 = function _loop15(k) {
                    var bucket = (vm.card_details || []).find(function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop15(k);
                }
            })();
        }
        vm.showScholasticTable = true;
    };
};
Type02Grade11Sciencet2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02Grade12ScienceNew26 = 'type02Grade12ScienceNew26';

var Type02Grade12ScienceNew26 = function Type02Grade12ScienceNew26($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02Grade12ScienceNew26);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade_12_science_new26TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade_12_science_new26TemplateCtrl.card_details;
        vm.full_data = this.type02grade_12_science_new26TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card59 = vm.full_data.report_template;
            if (_card59.additional_subjects && _card59.additional_subjects.subjects && _card59.additional_subjects.subjects.length) {
                if (_card59.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card59.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type02grade_12_science_new26TemplateCtrl.can_published_edit;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop16 = function _loop16(k) {
                    var bucket = (vm.card_details || []).find(function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop16(k);
                }
            })();
        }
        vm.showScholasticTable = true;
    };
};
Type02Grade12ScienceNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var type02Grade12Sciencet2New = 'type02Grade12Sciencet2New';

var Type02Grade12Sciencet2New = function Type02Grade12Sciencet2New($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
    'ngInject';

    _classCallCheck(this, Type02Grade12Sciencet2New);

    var vm = this;
    vm.allStudentReportData = undefined;
    vm.card_details = undefined;
    vm.full_data = undefined;
    vm.is_specific = false;
    vm.additional_subjects = false;
    vm.showScholasticTable = false;
    this.$onInit = function () {
        vm.allStudentReportData = this.type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData;
        vm.sendForApprovalFlag = this.type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag;
        vm.card_details = this.type02grade_12_sciencet2_new_TemplateCtrl.card_details;
        vm.full_data = this.type02grade_12_sciencet2_new_TemplateCtrl.full_data;
        if (vm.full_data && vm.full_data.report_template) {
            var card = vm.full_data.report_template;
            if (card.type9_specific_subjects && card.type9_specific_subjects.subjects && card.type9_specific_subjects.subjects.length) {
                if (card.type9_specific_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = card.type9_specific_subjects.activity_buckets;
                    vm.is_specific = true;
                    vm.additional_subjects = false;
                }
            }
        }
        if (vm.full_data && vm.full_data.report_template) {
            var _card60 = vm.full_data.report_template;
            if (_card60.additional_subjects && _card60.additional_subjects.subjects && _card60.additional_subjects.subjects.length) {
                if (_card60.additional_subjects.subjects.indexOf(vm.allStudentReportData.academic_details.subject_id) !== -1) {
                    vm.card_details = _card60.additional_subjects.activity_buckets;
                    vm.additional_subjects = true;
                    vm.is_specific = true;
                }
            }
        }
        vm.can_published_edit = this.type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit;
        if (vm.allStudentReportData.bucket_max_mark) {
            (function () {
                var keys = Object.keys(vm.allStudentReportData.bucket_max_mark);

                var _loop17 = function _loop17(k) {
                    var bucket = (vm.card_details || []).find(function (one) {
                        return one.db_key == keys[k];
                    });
                    if (bucket) {
                        bucket['max_mark'] = vm.allStudentReportData.bucket_max_mark[keys[k]]['max_mark'];
                    }
                };

                for (var k = 0; k < keys.length; k++) {
                    _loop17(k);
                }
            })();
        }
        vm.showScholasticTable = true;
    };
};
Type02Grade12Sciencet2New.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

// create a module


exports.default = angular.module(name, []).component(name, {
    template: _reportView2.default,
    controllerAs: "generatedViewCtrl",
    controller: reportGeneratedViewController
}).component(typeOneMarkComponent, {
    template: _type1Mark2.default,
    transclude: true,
    require: {
        typeOneMarkTemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeOneMarkCtrl",
    controller: TypeOneMarkClass
}).component(typeTwoMarkComponent, {
    template: _type2Mark2.default,
    transclude: true,
    require: {
        typeTwoMarkTemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeTwoMarkCtrl",
    controller: TypeTwoMarkClass
}).component(typeThreeSubSkillComponent, {
    template: _type3Sub_skill2.default,
    transclude: true,
    require: {
        typeThreeSubSkillCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeThreeMarkCtrl",
    controller: TypeThreeSubSkillClass
}).component(typeSkillOnlyComponent, {
    template: _skill_only2.default,
    transclude: true,
    require: {
        typeSkillOnlyComponentCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeSkillOnlyCtrl",
    controller: TypeSkillOnlyClass
}).component(typeOneGradeComponent, {
    template: _type1Grade2.default,
    transclude: true,
    require: {
        typeOneGradeComponentCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeOneGradeCtrl",
    controller: TypeOneGradeComponentClass
}).component(periodicTestDeafaultHFcomponent, {
    template: _periodicTestHf2.default,
    transclude: true,
    require: {
        periodicTestDeafaultHFCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "pTdefaultHFCtrl",
    controller: PeriodicTestDeafaultHFClass
}).component(periodicTestDeafaultAnnualcomponent, {
    template: _periodicTestAnnual2.default,
    transclude: true,
    bindings: true,
    require: {
        periodicTestDeafaultAnnualCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "pTdefaultAnnualCtrl",
    controller: PeriodicTestDeafaultAnnualClass
}).component(typeFourMarkComponent, {
    template: _type4Mark2.default,
    transclude: true,
    bindings: true,
    require: {
        typeFourMarkTemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeFourMarkCtrl",
    controller: TypeFourMarkComponent
}).component(typeFourAnnualComponent, {
    template: _type4Annual2.default,
    transclude: true,
    bindings: true,
    require: {
        typeFourAnnualTemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeFourAnnualCtrl",
    controller: TypeFourAnnualComponent
}).component(periodicTestDeafaultHFTwocomponent, {
    template: _periodicTestHf4.default,
    transclude: true,
    bindings: true,
    require: {
        periodicTestDefaultHfTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "periodicTestDefaultHfTwoCtrl",
    controller: PeriodicTestDefaultHfTwoClass
}).component(periodicTestDefaultAnnualTwocomponent, {
    template: _periodicTestAnnualTwo2.default,
    transclude: true,
    bindings: true,
    require: {
        periodicTestDefaultAnnualTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "periodicTestDefaultAnnualTwoCtrl",
    controller: PeriodicTestDefaultAnnualTwoClass
}).component(hssTemplateComponent, {
    template: _hss2.default,
    transclude: true,
    bindings: true,
    require: {
        hssTemplateComponentCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "hssTemplateComponentCtrl",
    controller: HssTemplateComponentClass
}).component(cbsehssComponent, {
    template: _cbse_hss2.default,
    transclude: true,
    bindings: true,
    require: {
        cbsehssComponentCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "cbsehssComponentCtrl",
    controller: CbsehssClass
}).component(kbhfhssComp, {
    template: _kbhfhss2.default,
    transclude: true,
    bindings: true,
    require: {
        kbhfhssCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "kbhfhssCompCtrl",
    controller: KbhfhssCompClass
}).component(termonehalfyearlyComp, {
    template: _term1halfyearly2.default,
    transclude: true,
    bindings: true,
    require: {
        termonehalfyearlyCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "termonehalfyearlyCompCtrl",
    controller: TermonehalfyearlyCompClass
}).component(gradeNineComp, {
    template: _grade9Annual2.default,
    transclude: true,
    bindings: true,
    require: {
        gradeNineCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "gradeNineAnnualCompCtrl",
    controller: gradeNineCompClass
}).component(gradeOneEightComp, {
    template: _grade1_8Annual2.default,
    transclude: true,
    bindings: true,
    require: {
        gradeOneEightCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "gradeOneEightCompCtrl",
    controller: GradeOneEightCompClass
}).component(annualCbseHssComp, {
    template: _annual_cbse_hss2.default,
    transclude: true,
    require: {
        annualCbseHssCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "annualCbseHssCompCtrl",
    controller: AnnualCbseHssCompClass
}).component(annualNineOnlyComp, {
    template: _termAnnualOnly2.default,
    transclude: true,
    bindings: true,
    require: {
        annualNineOnlyCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "annualNineOnlyCompCtrl",
    controller: AnnualNineOnlyClass
}).component(kbannualComponent, {
    template: _kb_hss_annual2.default,
    transclude: true,
    bindings: true,
    require: {
        kbannualComponentCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "kbannualComponentCtrl",
    controller: KbannualComponentClass
}).component(kbhfComponent, {
    template: _periodicTestHfKb2.default,
    transclude: true,
    bindings: true,
    require: {
        kbhfPtCompCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "kbhfPtCompCtrl",
    controller: KbhfCompClass
}).component(halfyearlyExam, {
    template: _hf1Exam2.default,
    transclude: true,
    bindings: true,
    require: {
        halfyearlyExamCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "halfyearlyExamCtrl",
    controller: HalfyearlyExam
}).component(typefiveNineTen, {
    template: _type5_9_10_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveNineTenCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveNineTenCtrl",
    controller: TypefiveNineTen
}).component(typefiveNineTenTermTwo, {
    template: _type5_9_10_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveNineTenTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveNineTenTermTwoCtrl",
    controller: TypefiveNineTenTermTwo
}).component(typefiveSixEightTermone, {
    template: _type5_6_8_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveSixEightTerm1Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveSixEightTerm1Ctrl",
    controller: TypefiveSixEightTerm1
}).component(typefiveSixEightTermtwo, {
    template: _type5_6_8_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveSixEightTerm2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveSixEightTerm2Ctrl",
    controller: TypefiveSixEightTerm2
}).component(typefiveOneFiveTermone, {
    template: _type5_1_5_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveOneFiveTermoneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveOneFiveTermoneCtrl",
    controller: TypefiveOneFiveTermone
}).component(typefiveOneFiveTermtwo, {
    template: _type5_1_5_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveOneFiveTermtwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefiveOneFiveTermtwoCtrl",
    controller: TypefiveOneFiveTermtwo
}).component(typefivekbtenTermOne, {
    template: _type5_KB_10_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefivekbtenTermOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefivekbtenTermOneCtrl",
    controller: TypefivekbtenTermOne
}).component(typefivekbtenTermTwo, {
    template: _type5_KB_10_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefivekbtenTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefivekbtenTermTwoCtrl",
    controller: TypefivekbtenTermTwo
}).component(typefivekbEightNineTermOne, {
    template: _type5_KB_8_9_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefivekbEightNineTermOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefivekbEightNineTermOneCtrl",
    controller: TypefivekbEightNineTermOne
}).component(typefivekbEightNineTermTwo, {
    template: _type5_KB_8_9_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefivekbEightNineTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefivekbEightNineTermTwoCtrl",
    controller: TypefivekbEightNineTermTwo
}).component(typefivekbEightNineTermThree, {
    template: _type5_KB_8_9_grade_term6.default,
    transclude: true,
    bindings: true,
    require: {
        typefivekbEightNineTermThreeCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typefivekbEightNineTermThreeCtrl",
    controller: TypefivekbEightNineTermThree
}).component(typesixModelExamTermOne, {
    template: _type_6_model_exam_2.default,
    transclude: true,
    bindings: true,
    require: {
        typeSixModelExamOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeSixModelExamOneCtrl",
    controller: TypeSixModelExamOne
}).component(typesixModelExamTermOnenineten, {
    template: _type_6_model_exam_1_nineten2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixModelExamTermOneninetenCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typesixModelExamTermOneninetenCtrl",
    controller: TypesixModelExamTermOnenineten
}).component(typesixModelExamTermTwonineten, {
    template: _type_6_model_exam_2_nineten2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixModelExamTermTwoninetenCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typesixModelExamTermTwoninetenCtrl",
    controller: TypesixModelExamTermTwonineten
}).component(typesixModelExamTermTwoNospace, {
    template: _type_6_model_exam_4.default,
    transclude: true,
    bindings: true,
    require: {
        typesixModelExamTermTwoNospaceCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typesixModelExamTermTwoNospaceCtrl",
    controller: TypesixModelExamTermTwoNospace
}).component(typesixModelAnnualExamTerm, {
    template: _type_6_model_annualexam_2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixModelAnnualExamTermCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typesixModelAnnualExamTermCtrl",
    controller: TypesixModelAnnualExamTerm
}).component(typeSevenCalicultAnnual, {
    template: _calicut_annual2.default,
    transclude: true,
    bindings: true,
    require: {
        typeSevenCalicultAnnualCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeSevenCalicultAnnualCtrl",
    controller: TypeSevenCalicultAnnual
}).component(typeNinePT, {
    template: _type9_cbse_pt2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNinePTCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNinePTCtrl",
    controller: TypeNinePT
}).component(typeNineTermOneHF, {
    template: _type9_term1_hf2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNineTermOneHFCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNineTermOneHFCtrl",
    controller: TypeNineTermOneHF
}).component(typeNineTermAe, {
    template: _type9_term2_ae2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNineTermAeCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNineTermAeCtrl",
    controller: TypeNineTermAe
}).component(typeNineTwelveTermAe, {
    template: _type9_grade12term2_ae2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNineTwelveTermAeCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNineTwelveTermAeCtrl",
    controller: TypeNineTwelveTermAe
}).component(typeNinekbUnitTestOne, {
    template: _type9_kb_unit_test2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNinekbUnitTestOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNinekbUnitTestOneCtrl",
    controller: TypeNinekbUnitTestOne
}).component(typeNineKbtermOnehf, {
    template: _type9_kbterm1_hf2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNineKbtermOnehfCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNineKbtermOnehfCtrl",
    controller: TypeNineKbtermOnehf
}).component(typeNineKbtermTwo, {
    template: _type9_kbterm2.default,
    transclude: true,
    bindings: true,
    require: {
        typeNineKbtermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNineKbtermTwoCtrl",
    controller: TypeNineKbtermTwo
}).component(typeNinekbTermThreeCtrl, {
    template: _type9_kbterm4.default,
    transclude: true,
    bindings: true,
    require: {
        typeNinekbTermThreeCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typeNinekbTermThreeCtrl",
    controller: TypeNinekbTermThreeCtrl
}).component(type12termcbse, {
    template: _type12_termcbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type12_termcbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type12_termcbseCtrl",
    controller: Type12_termcbse
}).component(type12NineTentermcbse, {
    template: _type12_ninetentermcbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type12NineTentermcbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type12NineTentermcbseCtrl",
    controller: Type12NineTentermcbse
}).component(eltPublishedReport, {
    template: _elt_report2.default,
    transclude: true,
    bindings: true,
    require: {
        eltPublishedReportCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "eltPublishedReportCtrl",
    controller: EltPublishedReport
}).component(type20kb10Gradeterm1, {
    template: _type20_KB_10_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        type20kb10Gradeterm1Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20kb10Gradeterm1Ctrl",
    controller: Type20kb10Gradeterm1Ctrl
}).component(type20termcbse, {
    template: _type20_termcbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type20_termcbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20_termcbseCtrl",
    controller: Type20_termcbse
}).component(type20termcbse18, {
    template: _type20_termcbse4.default,
    transclude: true,
    bindings: true,
    require: {
        type20_termcbse18Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20_termcbse18Ctrl",
    controller: Type20_termcbse18
}).component(type20term2cbse, {
    template: _type20_term2cbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type20_term2cbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20_term2cbseCtrl",
    controller: Type20_term2cbse
}).component(type20term2cbse18, {
    template: _type20_term2cbse4.default,
    transclude: true,
    bindings: true,
    require: {
        type20_term2cbse18Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20_term2cbse18Ctrl",
    controller: Type20_termtwocbse18
}).component(typefiveSixSevenTermone, {
    template: _type5_6_7_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveSixSevenTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveSixSevenTermoneCtrl",
    controller: TypefiveSixSevenTermone

}).component(typesixSixSevenTermone, {
    template: _type6_6_7_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixSixSevenTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesixSixSevenTermoneCtrl",
    controller: TypesixSixSevenTermone

}).component(typefiveOneTwoTermone, {
    template: _type5_1_2_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveOneTwoTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveOneTwoTermoneCtrl",
    controller: TypefiveOneTwoTermone

}).component(typesixOneTwoTermone, {
    template: _type6_1_2_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixOneTwoTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesixOneTwoTermoneCtrl",
    controller: TypesixOneTwoTermone

}).component(typesixThreeFiveTermone, {
    template: _type6_3_5_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typesixThreeFiveTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesixThreeFiveTermoneCtrl",
    controller: TypesixThreeFiveTermone

}).component(typefiveEightTermone, {
    template: _type5_8_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveEightTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveEightTermoneCtrl",
    controller: TypefiveEightTermone

}).component(typefiveThreeFiveTermone, {
    template: _type5_3_5_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveThreeFiveTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveThreeFiveTermoneCtrl",
    controller: TypefiveThreeFiveTermone

}).component(type20kb10Gradeterm2, {
    template: _type20_KB_10_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        type20kb10Gradeterm2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type20kb10Gradeterm2Ctrl",
    controller: Type20kb10Gradeterm2Ctrl
}).component(typethirtykbtenTermOne, {
    template: _type30_KB_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermOneCtrl",
    controller: TypethirtykbtenTermOne
}).component(typethirtykbtenTermTwo, {
    template: _type30_KB_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermTwoCtrl",
    controller: TypethirtykbtenTermTwo
}).component(typethirtykbtenTermThree, {
    template: _type30_KB_grade_term6.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermThreeCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermThreeCtrl",
    controller: TypethirtykbtenTermThree
}).component(typethirtykbtenTermOneNew26, {
    template: _type30_KB_grade_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermOneNew26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermOneNew26Ctrl",
    controller: TypethirtykbtenTermOneNew26
}).component(typethirtykbtenTermTwoNew26, {
    template: _type30_KB_grade_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermTwoNew26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermTwoNew26Ctrl",
    controller: TypethirtykbtenTermTwoNew26
}).component(typethirtykbtenTermThreeNew26, {
    template: _type30_KB_grade_term3_new2.default,
    transclude: true,
    bindings: true,
    require: {
        typethirtykbtenTermThreeNew26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typethirtykbtenTermThreeNew26Ctrl",
    controller: TypethirtykbtenTermThreeNew26
}).component(type8to10termcbse, {
    template: _type8to10_termcbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type8to10_termcbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type8to10_termcbseCtrl",
    controller: Type8to10_termOnecbse
}).component(typetermcbse8to10, {
    template: _typetermcbse_8to2.default,
    transclude: true,
    bindings: true,
    require: {
        typetermcbse_8to10Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetermcbse_8to10Ctrl",
    controller: TypetermOnecbse_8to10
}).component(type6to7alncbse, {
    template: _type6to7_alncbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type6to7_alncbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type6to7_alncbseCtrl",
    controller: Type6to7_termAlncbse
}).component(type6to7tcscbse, {
    template: _type6to7_tcscbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type6to7_tcscbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type6to7_tcscbseCtrl",
    controller: Type6to7_termTcscbse
}).component(type3to5tcscbse, {
    template: _type3to5_tcscbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type3to5_tcscbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type3to5_tcscbseCtrl",
    controller: Type3to5_termTcscbse
}).component(typesevenOneTwoTermone, {
    template: _type7_1_2_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typesevenOneTwoTermoneCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesevenOneTwoTermoneCtrl",
    controller: TypesevenOneTwoTermone

}).component(type3to5alncbse, {
    template: _type3to5_alncbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type3to5_alncbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type3to5_alncbseCtrl",

    controller: Type3to5_termAlncbse
}).component(type1to2tcscbse, {
    template: _type1to2_tcscbse2.default,
    transclude: true,
    bindings: true,
    require: {
        type1to2_tcscbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type1to2_tcscbseCtrl",
    controller: Type1to2_termTcscbse
}).component(typetenkbtenTermOne, {
    template: _type10_KB_grade_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbtenTermOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbtenTermOneCtrl",
    controller: TypetenkbTermOne
}).component(typetenkbtenTermTwo, {
    template: _type10_KB_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbtenTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbtenTermTwoCtrl",
    controller: TypetenkbTermTwo
}).component(typetenkbeleventwelveTermOne, {
    template: _type10_KB_grade11_12_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbeleventwelveTermOneCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbeleventwelveTermOneCtrl",
    controller: TypetenkbeleventwelveTermOne
}).component(typetenkbeleventwelveTermTwo, {
    template: _type10_KB_grade11_12_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbeleventwelveTermTwoCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbeleventwelveTermTwoCtrl",
    controller: TypetenkbeleventwelveTermTwo
}).component(typetenkbeleventwelveTermOneNew26, {
    template: _type10_KB_grade11_12_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbeleventwelveTermOneNew26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbeleventwelveTermOneNew26Ctrl",
    controller: TypetenkbeleventwelveTermOneNew26
}).component(typetenkbeleventwelveTermTwoNew26, {
    template: _type10_KB_grade11_12_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        typetenkbeleventwelveTermTwoNew26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetenkbeleventwelveTermTwoNew26Ctrl",
    controller: TypetenkbeleventwelveTermTwoNew26
}).component(type02grade11sc, {
    template: _type02grade_11_science2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade11scCtrl: '^viewGeneratedReportData'
    },

    controllerAs: "type02grade11scCtrl",
    controller: Type02grade11sc
}).component(type02grade11sct2, {
    template: _type02grade_11_sciencet2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade11sct2Ctrl: '^viewGeneratedReportData'
    },

    controllerAs: "type02grade11sct2Ctrl",
    controller: Type02grade11sct2
}).component(type02grade12sc, {
    template: _type02grade_12_science2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade12scCtrl: '^viewGeneratedReportData'
    },

    controllerAs: "type02grade12scCtrl",
    controller: Type02grade12sc
}).component(type02grade12sct2, {
    template: _type02grade_12_sciencet2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade12sct2Ctrl: '^viewGeneratedReportData'
    },

    controllerAs: "type02grade12sct2Ctrl",
    controller: Type02grade12sct2
}).component(typefiveThreeFiveTermtwo, {
    template: _type5_3_5_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveThreeFiveTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveThreeFiveTermtwoCtrl",
    controller: TypefiveThreeFiveTermtwo

}).component(typesixSixSevenTermtwo, {
    template: _type6_6_7_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typesixSixSevenTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesixSixSevenTermtwoCtrl",
    controller: TypesixSixSevenTermtwo
}).component(typeoneTwoShjTermTwo, {
    template: _type1to2shjcbset2.default,
    transclude: true,
    bindings: true,
    require: {
        typeoneTwoShjTermTwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typeoneTwoShjTermTwoCtrl",
    controller: TypeoneTwoShjTermTwo

}).component(type8to10term2cbse, {
    template: _type8to10_termcbseterm2.default,
    transclude: true,
    bindings: true,
    require: {
        type8to10_term2cbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type8to10_term2cbseCtrl",
    controller: Type8to10termtwocbse
}).component(typefiveOneTwoTermtwo, {
    template: _type5_1_2_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveOneTwoTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveOneTwoTermtwoCtrl",
    controller: TypefiveOneTwoTermtwo

}).component(type1to2tcscbsetermtwo, {
    template: _type1to2_tcscbse_term2.default,
    transclude: true,
    bindings: true,
    require: {
        type1to2_tcscbseterm2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type1to2_tcscbseterm2Ctrl",
    controller: TypeonetotwoTcstermTwo
}).component(type6to7tcscbseterm2, {
    template: _type6to7_tcscbseterm2.default,
    transclude: true,
    bindings: true,
    require: {
        type6to7_tcscbseterm2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type6to7_tcscbseterm2Ctrl",
    controller: Type6to7_termTcscbseterm2
}).component(type3to5tcscbseterm2, {
    template: _type3to5_tcscbseterm2.default,
    transclude: true,
    bindings: true,
    require: {
        type3to5_tcscbseCtrltermtwo: '^viewGeneratedReportData'
    },
    controllerAs: "type3to5_tcscbseCtrltermtwo",
    controller: Type3to5_termTcscbseterm2
}).component(typesixThreeFiveTermtwo, {
    template: _type6_3_5_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typesixThreeFiveTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesixThreeFiveTermtwoCtrl",
    controller: TypesixThreeFiveTermtwo

}).component(typefiveSixSevenTermtwo, {
    template: _type5_6_7_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveSixSevenTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveSixSevenTermtwoCtrl",
    controller: TypefiveSixSevenTermtwo

}).component(typefiveEightTermtwo, {
    template: _type5_8_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typefiveEightTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typefiveEightTermtwoCtrl",
    controller: TypefiveEightTermtwo

}).component(typesevenOneTwoTermtwo, {
    template: _type7_1_2_grade_term4.default,
    transclude: true,
    bindings: true,
    require: {
        typesevenOneTwoTermtwoCtrl: '^viewGeneratedReportData'

    },
    controllerAs: "typesevenOneTwoTermtwoCtrl",
    controller: TypesevenOneTwoTermtwo

}).component(type3to5alnterm2cbse, {
    template: _type3to5_alncbseterm2.default,
    transclude: true,
    bindings: true,
    require: {
        type3to5_alnterm2cbseCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type3to5_alnterm2cbseCtrl",
    controller: TypeThreeToFiveTermAlncbsetermtwo
}).component(type6to7alncbseterm2, {
    template: _type6to7_alncbse_term2.default,
    transclude: true,
    bindings: true,
    require: {
        type6to7_alncbseCtrlterm2: '^viewGeneratedReportData'
    },
    controllerAs: "type6to7_alncbseCtrlterm2",
    controller: Type6to7_termAlncbseterm2
}).component(typetermcbse8to10term2, {
    template: _typetermcbse_8to10_term2.default,
    transclude: true,
    bindings: true,
    require: {
        typetermcbse_8to10term2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "typetermcbse_8to10term2Ctrl",
    controller: TypetermOnecbseterm2_8to10
}).component(typeptnoconv, {
    template: _pt_1_no_conv2.default,
    transclude: true,
    bindings: true,
    require: {
        typePtNoConvCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "typePtNoConvCtrl",
    controller: TypePtNoConv
}).component(type25tcscbseOneFive, {
    template: _type1to5_tcscbse_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type25tcscbseOneFiveCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type25tcscbseOneFiveCtrl",
    controller: Type25tcscbseOneFive
}).component(type25tcscbseOneFiveTerm2, {
    template: _type1to5_tcscbseterm2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type25tcscbseOneFiveTerm2Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type25tcscbseOneFiveTerm2Ctrl",
    controller: Type25tcscbseOneFiveTerm2
}).component(type9TermcbseNew26, {
    template: _type9_termcbse_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type9_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type9_termcbse_new26TemplateCtrl",
    controller: Type9TermcbseNew26
}).component(type9Termcbseterm2New26, {
    template: _type9_termcbseterm2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type9_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type9_termcbseterm2_new26TemplateCtrl",
    controller: Type9Termcbseterm2New26
}).component(type10TermcbseNew26, {
    template: _type10_termcbse_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type10_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type10_termcbse_new26TemplateCtrl",
    controller: Type10TermcbseNew26
}).component(type10Termcbseterm2New26, {
    template: _type10_termcbseterm2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type10_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type10_termcbseterm2_new26TemplateCtrl",
    controller: Type10Termcbseterm2New26
})

// NEW26 Component Registrations
.component(typefiveonetwoGrdTerm1New26, {
    template: _type5_1_2_grade_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type5_1_2_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type5_1_2_grade_term1_new26TemplateCtrl",
    controller: TypefiveonetwoGrdTerm1New26
}).component(typefiveonetwoGrdTerm2New26, {
    template: _type5_1_2_grade_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type5_1_2_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type5_1_2_grade_term2_new26TemplateCtrl",
    controller: TypefiveonetwoGrdTerm2New26
}).component(typefivethreefiveGrdTerm1New26, {
    template: _type5_3_5_grade_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type5_3_5_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type5_3_5_grade_term1_new26TemplateCtrl",
    controller: TypefivethreefiveGrdTerm1New26
}).component(typefivethreefiveGrdTerm2New26, {
    template: _type5_3_5_grade_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type5_3_5_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type5_3_5_grade_term2_new26TemplateCtrl",
    controller: TypefivethreefiveGrdTerm2New26
}).component(typesixsixsevenGrdTerm1New26, {
    template: _type6_6_7_grade_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type6_6_7_grade_term1_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type6_6_7_grade_term1_new26TemplateCtrl",
    controller: TypesixsixsevenGrdTerm1New26
}).component(typesixsixsevenGrdTerm2New26, {
    template: _type6_6_7_grade_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type6_6_7_grade_term2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type6_6_7_grade_term2_new26TemplateCtrl",
    controller: TypesixsixsevenGrdTerm2New26
}).component(type8to10TermcbseNew26, {
    template: _type8to10_termcbse_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type8to10_termcbse_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type8to10_termcbse_new26TemplateCtrl",
    controller: Type8to10TermcbseNew26
}).component(type8to10Termcbseterm2New26, {
    template: _type8to10_termcbseterm2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type8to10_termcbseterm2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type8to10_termcbseterm2_new26TemplateCtrl",
    controller: Type8to10Termcbseterm2New26
}).component(type02Grade11ScienceNew26, {
    template: _type02grade_11_science_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade_11_science_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type02grade_11_science_new26TemplateCtrl",
    controller: Type02Grade11ScienceNew26
}).component(type02Grade11Sciencet2New26, {
    template: _type02grade_11_sciencet2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade_11_sciencet2_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type02grade_11_sciencet2_new26TemplateCtrl",
    controller: Type02Grade11Sciencet2New26
}).component(type02Grade12ScienceNew26, {
    template: _type02grade_12_science_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade_12_science_new26TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type02grade_12_science_new26TemplateCtrl",
    controller: Type02Grade12ScienceNew26
}).component(type02Grade12Sciencet2New, {
    template: _type02grade_12_sciencet2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type02grade_12_sciencet2_new_TemplateCtrl: '^viewGeneratedReportData'
    },
    controllerAs: "type02grade_12_sciencet2_new_TemplateCtrl",
    controller: Type02Grade12Sciencet2New
}).component(type10KbGradeTerm1New26, {
    template: _type10_KB_grade_term1_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type10KbGradeTerm1New26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type10KbGradeTerm1New26Ctrl",
    controller: Type10KbGradeTerm1New26
}).component(type10KbGradeTerm2New26, {
    template: _type10_KB_grade_term2_new2.default,
    transclude: true,
    bindings: true,
    require: {
        type10KbGradeTerm2New26Ctrl: '^viewGeneratedReportData'
    },
    controllerAs: "type10KbGradeTerm2New26Ctrl",
    controller: Type10KbGradeTerm2New26
}).constant('rcConstants', {
    _ggg: "jjj",
    _NOT_APPLICABLE: "NA",
    ABSENT: "ABSENT",
    TYPE_1_MARK: "type-1-mark",
    TYPE_1_DEFAULT_ANNUAL: "type-1-annual",
    TYPE_1_GRADE: "type-1-grade",
    TYPE_2_MARK: "type-2-mark",
    TYPE_SKILL_ONLY: "skill_only",
    TYPE_3_SUB_SLILL: "type-3-sub_skill",
    DEFAULT_PERIODICTEST_HF: "periodic-test-hf",
    DEFAULT_PERIODICTEST_ANNUAL: "periodic-test-annual",
    _CO_SCHOLASTIC_NAME: "Co-scholastic",
    GRADE_BASED_SUBJECT_PACKAGES: ['Co-scholastic'],
    DEFAULT_REPORTCARD_PT_HF_TWO: "Periodic Test-II-Half Yearly",
    DEFAULT_REPORTCARD_PT_ANNUAL_TWO: "Periodic Test-II-Annual",
    REPORT_CARDS_PERIODIC_TEST: ["Periodic Test-Half Yearly", "Periodic Test-II-Half Yearly", "Periodic Test-Annual", "Periodic Test-II-Annual"],
    DEFAULT_REPORTCARDS: ['Annual', 'Half Yearly', "Periodic Test-Half Yearly", "Periodic Test-Annual", "Periodic Test-II-Half Yearly", "Periodic Test-II-Annual"],
    DEFAULT_ANUAL_REPORTCARD: 'Annual',
    DEFAULT_REPORTCARD_PT_ANNUAL: 'Periodic Test-Annual',
    DEFAULT_REPORTCARD_PT_HF: "Periodic Test-Half Yearly",
    DEFAULT_PERIODICTEST_HF_TWO: "periodic-test-hf-2",
    DEFAULT_PERIODICTEST_ANNUAL_TWO: "periodic-test-annual-two",
    DEFAULT_HF_REPORTCARD: 'Half Yearly',
    DEFAULT_REPORT_CARDS_FOR_YEAREND: ['Annual', 'Half Yearly'],
    DEFAULT_YEAR_END: "default-year-end",
    EDUCORE_YEAR_END: "educore-year-end",
    EVALUATION_RC: ["Evaluation-3", "Evaluation-2", "Evaluation-1"],
    EVAL_ONE_RC: "Evaluation-1",
    EVAL_TWO_RC: "Evaluation-2",
    EVAL_THREE_RC: "Evaluation-3",
    ASSET_ME_RC_HALF: ["Term 1"],
    ASSET_ME_RC_HALF_NAME: "Term 1",
    ASSET_ME_RC_ANNUAL_NAME: "Term 2",
    ASSET_ME_RC_NAMES: ["Term 1", "Term 2"],
    TYPE_4_MARK: "type-4-mark",
    TYPE_4_ANNUAL: "type-4-annual",
    ASSET_CONSOLIDATED: "term1-term2",
    KG_CARDS: ['KG-Term-1', 'KG-Term-2', 'KG-Term-3'],
    KB_CARDS: ['KB-Term-1', 'KB-Term-2', 'KB-Term-3'],
    KG_TERM: 'kg-term',
    KG_TERMS: 'kg-terms',
    KB_TERMS: 'kb-terms',
    KG_CONSOLIDATED: 'kg-consolidated',
    HIGHER_SECONDARY_REPORT: "hss-template",
    CBSE_HSHF: "cbse_hss",
    TERMONEHALF_YEARLY: "term1halfyearly",
    GRADE_9_ANNUAL: "grade-9-annual"
}).controller('viewGeneratedReportData', reportGeneratedViewController);

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.remarks_field{width:160px}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;height:133px;margin:0 auto;float:left;display:block}.annexure_con{width:929px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.2rem 1rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.input_con{margin-bottom:0!important;margin-top:0!important}.name{color:#2d2a2a!important;font-weight:700!important}.plusTwoHint{margin-left:10px}.apr_btn{background:#1665c1;border-radius:50px;border:2px solid #fff;height:38px}.rep-ctrl{border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px}input[type=text]{border:1px solid #ccc}.mdCustom{padding:5px!important;line-height:2.9!important}</style> <div class=\"main_bg md-whiteframe-3dp\" ng-if=!pdfData aria-label=report-view> <md-backdrop style=z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=main_con style=margin-top:40px;padding-bottom:0!important> <div class=profile_img> <img ng-src={{schoolData.logo}}> </div> <div class=annexure_con> <div clas=heading_mid> <h1 class=\"logo_name ng-binding\" style=\"text-align:center;font-family:Century Gothic;font-weight:Regular;margin-bottom:0;margin-top:0\"> {{schoolData.school_name}}</h1> <h2 class=ng-binding> {{generatedViewCtrl.academic_header.report_name}} {{generatedViewCtrl.academic_header.stream}} Report </h2> <h3 class=ng-binding>Generated by: {{generatedViewCtrl.academic_header.generated_by}} </h3> <h4 class=ng-binding>{{generatedViewCtrl.academic_header.academics}}</h4> <h4 class=ng-binding>{{generatedViewCtrl.academic_header.subject}}</h4> </div> </div> </div> <type-one-mark-component ng-if=typeOneMark></type-one-mark-component> <type-two-mark-component ng-if=typeTwoMark></type-two-mark-component> <type-three-sub-skill-component ng-if=typeThreeSubSkill></type-three-sub-skill-component> <type-one-grade-component ng-if=typeOneGrade></type-one-grade-component> <periodic-test-default-hf-component ng-if=defaultPtHf></periodic-test-default-hf-component> <periodic-test-default-hf-two-component ng-if=defaultPtHfTwo></periodic-test-default-hf-two-component> <periodic-test-default-annual-component ng-if=defaultPtAnnual></periodic-test-default-annual-component> <periodic-test-default-annual-two-component ng-if=defaultPtAnnualTwo></periodic-test-default-annual-two-component> <type-skill-only-component ng-if=default_skill_only></type-skill-only-component> <type-one-mark-component ng-if=type_four_mark></type-one-mark-component> <type-four-annual-component ng-if=type_four_annual></type-four-annual-component> <hss-template-component ng-if=defaultHss></hss-template-component> <cbsehss-component ng-if=cbsehss></cbsehss-component> <termonehalfyearly-comp ng-if=term1halfyearly></termonehalfyearly-comp> <kbhfhss-comp ng-if=kbhfhss></kbhfhss-comp> <grade-nine-comp ng-if=grade9annual></grade-nine-comp> <grade-one-eight-comp ng-if=grade0neeightAnnual></grade-one-eight-comp> <annual-cbse-hss-comp ng-if=annualcbseHss></annual-cbse-hss-comp> <annual-nine-only-comp ng-if=annualnineonly></annual-nine-only-comp> <kbannual-component ng-if=kbhssannual></kbannual-component> <kbpt-hf-comp ng-if=ptHfKB></kbpt-hf-comp> <halfyearly-exam ng-if=hfExamOne></halfyearly-exam> <typefive-nine-ten ng-if=type5_9_10_grade_term1></typefive-nine-ten> <typefive-nine-ten-term-two ng-if=type5_9_10_grade_term2></typefive-nine-ten-term-two> <typefive-six-eight-termone ng-if=typefive_6_8_term1></typefive-six-eight-termone> <typefive-six-eight-termtwo ng-if=typefive_6_8_term2></typefive-six-eight-termtwo> <typefive-one-five-termone ng-if=typefive_1_5term1></typefive-one-five-termone> <typefive-one-five-termtwo ng-if=typefive_1_5term2></typefive-one-five-termtwo> <typefivekbten-term-one ng-if=typefive_KB_105term1></typefivekbten-term-one> <typefivekbten-term-two ng-if=typefive_KB_105term2></typefivekbten-term-two> <typefivekb-eight-nine-term-one ng-if=type5_KB_8_9_grade_term1></typefivekb-eight-nine-term-one> <typefivekb-eight-nine-term-two ng-if=type5_KB_8_9_grade_term2></typefivekb-eight-nine-term-two> <typefivekb-eight-nine-term-three ng-if=type5_KB_8_9_grade_term3></typefivekb-eight-nine-term-three> <typesix-model-exam-term-one ng-if=type_6_model_exam_term1></typesix-model-exam-term-one> <typesix-model-exam-term-onenineten ng-if=type_6_model_exam_term1nineten></typesix-model-exam-term-onenineten> <typesix-model-exam-term-twonineten ng-if=type_6_model_exam_term2nineten></typesix-model-exam-term-twonineten> <typesix-model-exam-term-two-nospace ng-if=type_6_model_exam_term2></typesix-model-exam-term-two-nospace> <typesix-model-annual-exam-term ng-if=type_6_model_annualexam_term></typesix-model-annual-exam-term> <type-seven-calicult-annual ng-if=type_7calicut_annual></type-seven-calicult-annual> <type-nine-pt ng-if=type9_cbse_pt1></type-nine-pt> <type-nine-term-one-hf ng-if=type9_term1_hf></type-nine-term-one-hf> <type-nine-term-ae ng-if=type9_term2_ae></type-nine-term-ae> <type-nine-twelve-term-ae ng-if=type9_grade12term2_ae></type-nine-twelve-term-ae> <type-ninekb-unit-test-one ng-if=type9_kb_unit_test1></type-ninekb-unit-test-one> <type-nine-kbterm-onehf ng-if=type9_kbterm1_hf></type-nine-kbterm-onehf> <type-ninekbterm-two ng-if=type9_kbterm2></type-ninekbterm-two> <type-ninekb-term-three ng-if=type9_kbterm3></type-ninekb-term-three> <type12termcbse ng-if=type12termOneEightcbse></type12termcbse> <type12-nine-tentermcbse ng-if=type12_ninetentermcbse></type12-nine-tentermcbse> <elt-published-report ng-if=elt_report></elt-published-report> <type20kb10-gradeterm1 ng-if=type20_KB_10_grade_term1></type20kb10-gradeterm1> <type20termcbse ng-if=type20termNineTencbse></type20termcbse> <type20termcbse18 ng-if=type20termOneEightcbse></type20termcbse18> <type20term2cbse ng-if=type20term2NineTencbse></type20term2cbse> <type20term2cbse18 ng-if=type20termTwoOneEightcbse></type20term2cbse18> <type20kb10-gradeterm2 ng-if=type20_KB_10_grade_term2></type20kb10-gradeterm2> <typethirtykbten-term-one ng-if=typethirtykbtenTermOne></typethirtykbten-term-one> <typethirtykbten-term-two ng-if=typethirtykbtenTermTwo></typethirtykbten-term-two> <typethirtykbten-term-three ng-if=typethirtykbtenTermThree></typethirtykbten-term-three> <typethirtykbten-term-one-new26 ng-if=typethirtykbtenTermOneNew26></typethirtykbten-term-one-new26> <typethirtykbten-term-two-new26 ng-if=typethirtykbtenTermTwoNew26></typethirtykbten-term-two-new26> <typethirtykbten-term-three-new26 ng-if=typethirtykbtenTermThreeNew26></typethirtykbten-term-three-new26> <type8to10termcbse ng-if=typeeightToTenTermCbse></type8to10termcbse> <typetermcbse8to10 ng-if=typeTermCbseeightToTen></typetermcbse8to10> <type6to7alncbse ng-if=typesixToSevenAlnCbse></type6to7alncbse> <type6to7tcscbse ng-if=typesixToSevenTcsCbse></type6to7tcscbse> <type3to5tcscbse ng-if=typethreeToFiveTcsCbse></type3to5tcscbse> <type3to5alncbse ng-if=typethreeToFiveAlnCbse></type3to5alncbse> <type1to2tcscbse ng-if=typeOneToTwoTcsCbse></type1to2tcscbse> <typefive-six-seven-termone ng-if=typefive_6_7_term1></typefive-six-seven-termone> <typesix-six-seven-termone ng-if=typesix_6_7_term1></typesix-six-seven-termone> <typesix-three-five-termone ng-if=typesix_3_5_term1></typesix-three-five-termone> <typealn-one-two-termone ng-if=typealn_1_2_term1></typealn-one-two-termone> <typefive-eight-termone ng-if=typefive_8_term1></typefive-eight-termone> <typefive-one-two-termone ng-if=typefive_1_2_term1></typefive-one-two-termone> <typesix-one-two-termone ng-if=typesix_1_2_term1></typesix-one-two-termone> <typefive-three-five-termone ng-if=typefive_3_5_term1></typefive-three-five-termone> <typeseven-one-two-termone ng-if=typeseven_1_2_term1></typeseven-one-two-termone> <typetenkbten-term-one ng-if=typetenkbtenTermOne></typetenkbten-term-one> <typetenkbten-term-two ng-if=typetenkbtenTermTwo></typetenkbten-term-two> <typetenkbeleventwelve-term-one ng-if=typetenkbeleventwelveTermOne></typetenkbeleventwelve-term-one> <typetenkbeleventwelve-term-two ng-if=typetenkbeleventwelveTermTwo></typetenkbeleventwelve-term-two> <typetenkbeleventwelve-term-one-new26 ng-if=typetenkbeleventwelveTermOneNew26></typetenkbeleventwelve-term-one-new26> <typetenkbeleventwelve-term-two-new26 ng-if=typetenkbeleventwelveTermTwoNew26></typetenkbeleventwelve-term-two-new26> <type02grade11sc ng-if=type02grade11sc></type02grade11sc> <type02grade11sct2 ng-if=type02grade11sct2></type02grade11sct2> <type02grade12sc ng-if=type02grade12sc></type02grade12sc> <type02grade12sct2 ng-if=type02grade12sct2></type02grade12sct2> <typefive-three-five-termtwo ng-if=typefivethreefiveterm2></typefive-three-five-termtwo> <typesix-six-seven-termtwo ng-if=typesix_6_7_term2></typesix-six-seven-termtwo> <type8to10term2cbse ng-if=typeeightToTenTermCbseterm2></type8to10term2cbse> <typefive-one-two-termtwo ng-if=typefive_1_2_term2></typefive-one-two-termtwo> <typeone-two-shj-term-two ng-if=typeonetwoshjterm2></typeone-two-shj-term-two> <type1to2tcscbsetermtwo ng-if=typeOneToTwoTcsCbseterm2></type1to2tcscbsetermtwo> <type6to7tcscbseterm2 ng-if=typesixToSevenTcsCbseTerm2></type6to7tcscbseterm2> <type3to5tcscbseterm2 ng-if=typethreeToFiveTcsCbseTerm2></type3to5tcscbseterm2> <typesix-three-five-termtwo ng-if=typesix_3_5_term2></typesix-three-five-termtwo> <typefive-six-seven-termtwo ng-if=typefive_6_7_term2></typefive-six-seven-termtwo> <typefive-eight-termtwo ng-if=typefive_8_term2></typefive-eight-termtwo> <typeseven-one-two-termtwo ng-if=typeseven_1_2_term2></typeseven-one-two-termtwo> <type3to5alnterm2cbse ng-if=typethreeToFiveAlnCbseterm2></type3to5alnterm2cbse> <type6to7alncbseterm2 ng-if=type6to7_alncbse_term2></type6to7alncbseterm2> <typetermcbse8to10term2 ng-if=typeTermCbseeightToTenterm2></typetermcbse8to10term2> <typeptnoconv ng-if=pt_1_no_conv></typeptnoconv> <type25tcscbse-one-five ng-if=type1to5_tcscbse_new></type25tcscbse-one-five> <type25tcscbse-one-five-term2 ng-if=type1to5_tcscbseterm2_new></type25tcscbse-one-five-term2> <typefiveonetwo-grd-term1-new26 ng-if=type5_1_2_term1_new26></typefiveonetwo-grd-term1-new26> <typefiveonetwo-grd-term2-new26 ng-if=type5_1_2_term2_new26></typefiveonetwo-grd-term2-new26> <typefivethreefive-grd-term1-new26 ng-if=type5_3_5_term1_new26></typefivethreefive-grd-term1-new26> <typefivethreefive-grd-term2-new26 ng-if=type5_3_5_term2_new26></typefivethreefive-grd-term2-new26> <typesixsixseven-grd-term1-new26 ng-if=type6_6_7_term1_new26></typesixsixseven-grd-term1-new26> <typesixsixseven-grd-term2-new26 ng-if=type6_6_7_term2_new26></typesixsixseven-grd-term2-new26> <type8to10-termcbse-new26 ng-if=type8to10_termcbse_new26></type8to10-termcbse-new26> <type8to10-termcbseterm2-new26 ng-if=type8to10_termcbseterm2_new26></type8to10-termcbseterm2-new26> <type9-termcbse-new26 ng-if=type9_termcbse_new26></type9-termcbse-new26> <type9-termcbseterm2-new26 ng-if=type9_termcbseterm2_new26></type9-termcbseterm2-new26> <type10-termcbse-new26 ng-if=type10_termcbse_new26></type10-termcbse-new26> <type10-termcbseterm2-new26 ng-if=type10_termcbseterm2_new26></type10-termcbseterm2-new26> <type02-grade11-science-new26 ng-if=type02grade_11_science_new26></type02-grade11-science-new26> <type02-grade11-sciencet2-new26 ng-if=type02grade_11_sciencet2_new26></type02-grade11-sciencet2-new26> <type02-grade12-science-new26 ng-if=type02grade_12_science_new26></type02-grade12-science-new26> <type02-grade12-sciencet2-new ng-if=type02grade_12_sciencet2_new></type02-grade12-sciencet2-new> <type10-kb-grade-term1-new26 ng-if=type10_kb_grade_term1_new26></type10-kb-grade-term1-new26> <type10-kb-grade-term2-new26 ng-if=type10_kb_grade_term2_new26></type10-kb-grade-term2-new26> </div> <div aria-label=report-view class=main_bg ng-if=pdfData> <iframe ng-src={{urls}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div aria-label=report-view ng-if=generatedViewCtrl.sendForApprovalFlag layout=row layout-padding style=\"margin:0 50px 50px\"> <md-input-container class=md-block flex-gt-sm flex-sm> <label>Select Role</label> <md-select ng-model=generatedViewCtrl.conditions.role_selected> <md-option value={{role._id}} ng-click=generatedViewCtrl.selectUserByRole(role._id) ng-repeat=\"role in generatedViewCtrl.roles track by $index\">{{role.name}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm flex-sm> <label>Select User</label> <md-select ng-model=generatedViewCtrl.conditions.user_selected> <md-option ng-if=user._id ng-click=generatedViewCtrl.setUser(user._id) value={{user._id}} ng-repeat=\"user in generatedViewCtrl.users track by $index\">{{user.name}}</md-option> </md-select> </md-input-container> </div> <div aria-label=report-view> <div ng-cloak> <div flex layout=row layout-padding class=\"theme-color md-whiteframe-3dp footer\" layout-align=center-center> <div class=\"md-button md-ink-ripple rep-ctrl md-whiteframe-3dp\" ng-click=generatedViewCtrl.saveRemarks() ng-if=\"generatedViewCtrl.sendForApprovalFlag && !generatedViewCtrl.noAction\" style=\"border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px\"> <span class=\"color-white txt-manage font_wight controlsbtn user hand\">Send for approval </span> <span class=\"rep-no-border doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(177) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin-top:-3px;padding-top:11px;padding-right:3px;float:right> </span> </div> <div class=\"bottom_ctrl-btn md-button md-ink-ripple rep-ctrl md-whiteframe-3dp\" ng-click=generatedViewCtrl.showUpdateLog($event) ng-if=\"generatedViewCtrl.can_published_edit && !loading && !pdfData\"> <span> <span class=\"font_wight controlsbtn user hand\" style=padding-top:3px>Previous Updates</span> </span> </div> <div class=\"bottom_ctrl-btn md-button md-ink-ripple rep-ctrl md-whiteframe-3dp\" ng-click=generatedViewCtrl.confirmMarkUpdate($event) ng-if=\"generatedViewCtrl.can_published_edit && !loading && !pdfData\"> <span> <span class=\"font_wight controlsbtn user hand\" style=padding-top:3px>Update marks</span> <span class=\"round doneRnd hand footer-circle-button\" style=border:none;padding-top:8px> <img src=" + __webpack_require__(177) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:8px> </span> </span> </div> <div class=\"md-button md-ink-ripple rep-ctrl md-whiteframe-3dp\" ng-click=generatedViewCtrl.deleteReportCard() ng-if=\"generatedViewCtrl.sendForApprovalFlag && !generatedViewCtrl.noAction\" style=\"border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px\"> <span class=\"color-white font_wight controlsbtn user hand txt-manage\">delete </span> <span class=\"rep-no-border doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(1001) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin-top:3px;padding-top:6px;float:right> </span> </div> <div class=\"md-button md-ink-ripple md-whiteframe-3dp\" style=\"border:2px solid #fff;background:#1665c1;border-radius:32px;padding:0 10px\" ng-click=generatedViewCtrl.showModal($event) ng-if=\"showButton && !generatedViewCtrl.noAction\"> <span> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;color:#fff;padding-top:5px;float:left>Approve/Reject </span> <span style=border:none;padding-top:8px class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(1002) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin-top:3px> </span> </span> </div> <div class=\"md-button md-ink-ripple md-whiteframe-3dp\" style=\"border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:0 10px\" ng-if=showPending> <span> <span class=\"font_wight controlsbtn\" style=color:#fff;color:#fff;padding-top:5px;float:left> Approval Pending from {{ApprovalUser}} </span> </span> </div> <div aria-label=report-view class=\"bottom_ctrl-btn md-button md-ink-ripple\" ng-if=\"!generatedViewCtrl.sendForApprovalFlag && !pdfData\" class=md-whiteframe-3dp ng-click=generatedViewCtrl.subjectTeacherExport()> <span> <span class=\"font_wight controlsbtn user hand\" style=padding-top:3px>Export As Pdf</span> <span class=\"round doneRnd hand footer-circle-button\" style=border:none;padding-top:8px> <img src=" + __webpack_require__(1003) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:8px> </span> </span> </div> <div aria-label=report-view class=\"bottom_ctrl-btn md-button md-ink-ripple\" ng-if=pdfData ng-click=generatedViewCtrl.backToHtml()> <span class=\"\"> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;padding-top:2px;float:left>Back to html</span> <span style=border:none;padding-top:8px class=\"round doneRnd hand footer-circle-button\"> <img src=" + __webpack_require__(365) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:8px> </span> </span> </div> </div> </div> </div> ";

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASBJREFUeNp80k0rRFEcx/H/va6lyI7koYSdJUki2c0L8BrmHcxuVlOytLBRvAQ7xZqysSJRFDbKUyMLi5l7fY9+R3/jjlufezr/zu+ep2tFURziA/fYwCAMmZhMYBvHmA6Fy+L3c4E5FxhAA+/Yx2Som2ao48mFX7GMNdyoVnUfS811xrGLlgZ+oo1bLMSAlp+W7aXmZs6xonqPG/snuIQrhdpqw2H0ISkLhnYVTXdAizhVf6tj1p89zuPNHcys6kM4U73irimNp3rt9rXuvh7aUTzonvu15O/gpgvtlRxEXFGu+wz9JLweFXrBSMdf48NVHdhY/AHivdW7hDK37APsxOARzrXXpEswc//rCWbCwGEz68UdUvv/yTGF5y8BBgDsaWhta+dV/gAAAABJRU5ErkJggg=="

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeOneMarkCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typeOneMarkCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=\"typeOneMarkCtrl.can_published_edit && subjectResult.marks['periodic_test']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.periodic_test maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeOneMarkCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=\"typeOneMarkCtrl.can_published_edit && subjectResult.marks['note_book_submission']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.note_book_submission maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeOneMarkCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"typeOneMarkCtrl.can_published_edit && subjectResult.marks['subject_enrichment']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.subject_enrichment maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeOneMarkCtrl.can_published_edit && typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"!typeOneMarkCtrl.can_published_edit && typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typeOneMarkCtrl.can_published_edit && typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"typeOneMarkCtrl.can_published_edit && typeOneMarkCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeOneMarkCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeOneMarkCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports = " <div class=main_bg ng-if=!pdfData> <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typeTwoMarkCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeTwoMarkCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeTwoMarkCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['Per-Test']}}</td> <td colspan=1>{{subjectResult.marks['Note Book']}}</td> <td colspan=1>{{subjectResult.marks['SeA']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeTwoMarkCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeTwoMarkCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> </div> ";

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports = "<md-dialog aria-label=\"Approve / Rejects\" flex=60> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools style=background-color:#4dd0e2> <h2 style=color:#fff>Approve / Reject</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> <md-icon aria-label=\"Close dialog\"></md-icon> </md-button> </div> </md-toolbar> <md-dialog-content> <div class=md-dialog-content> <div layout=column flex=100 layout-padding> <md-input-container class=md-block flex-gt-sm> <label>Action</label> <md-select ng-model=item.action> <md-option ng-repeat=\"item in dialogItem\" value={{item.action}}>{{item.action}}</md-option> </md-select> <error-msg class=redAlert msg=errors.actionItem></error-msg> </md-input-container> <md-input-container flex> <label>Comment</label> <textarea md-maxlength=150 maxlength=150 ng-model=commentReason md-autofocus></textarea> <error-msg class=redAlert msg=errors.commentItem></error-msg> </md-input-container> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button class=\"md-raised md-primary\" ng-click=saveAction()>Submit</md-button> <md-button class=\"md-primary md-raised\" ng-click=cancel()>Cancel</md-button> </md-dialog-actions> </form> </md-dialog> ";

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "<div flex=100> <md-content aria-label=report-view flex=100 style=width:100%> <md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"md-margin md-whiteframe-3dp\"> <md-tab label={{eachBucket.name}} ng-repeat=\"eachBucket in typeThreeMarkCtrl.card_details\"> <md-content class=md-padding> <div class=\"table-responsive-vertical shadow-z-1 whiteframe-3dp tableWidth\"> <table id=table class=\"table table-hover\"> <thead> <tr> <th class=name>Sr No</th> <th class=name>Student Name</th> <th class=name ng-repeat=\"subskill in eachBucket.sub_skills\">{{subskill.name}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"student in typeThreeMarkCtrl.allStudentReportData.results\"> <td data-title=SrNo class=name> {{$index+1}}</td> <td data-title=Description aria-label=report-view> <div layout=column aria-label=report-view> <p aria-label=report-view class=name>{{student.student_name}}</p> <p aria-label=report-view><b>Final Score - </b>{{student.result_redefined[eachBucket.name].total_mark}}</p> <p aria-label=report-view><b>Final Grade - </b>{{student.result_redefined[eachBucket.name].grade}}</p> </div> </td> <td ng-repeat=\"subskill in eachBucket.sub_skills\"> <div aria-label=report-view layout=column> <p aria-label=report-view> {{student.result_redefined[eachBucket.name].subSkill[subskill.name].total_mark}}</p> <p aria-label=report-view ng-if=!typeThreeMarkCtrl.sendForApprovalFlag>{{student.result_redefined[eachBucket.name].subSkill[subskill.name].remarks}}</p> <error-msg class=redAlert msg=student.errors.result_redefined[eachBucket.name].subSkill[subskill.name].errors></error-msg> <p aria-label=report-view>{{student.result_redefined[eachBucket.name].subSkill[subskill.name].grade}}</p> </div> <md-input-container aria-label=report-view ng-if=typeThreeMarkCtrl.sendForApprovalFlag class=\"md-block input_con\" flex-gt-sm> <input aria-label=report-view maxlength=100 ng-model=student.result_redefined[eachBucket.name].subSkill[subskill.name].remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </tbody> </table> </div> </md-content> </md-tab> </md-tabs> </md-content> </div>";

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=2>CO SCHOLASTIC ACHIEVEMENT</th> <th colspan=2 style=text-align:left>{{typeOneGradeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeOneGradeCtrl.allStudentReportData.report_card_header.report_card_name}} ({{typeOneGradeCtrl.report_name}})</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typeOneGradeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typeOneGradeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typeOneGradeCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> </td> <td colspan=1 ng-if=!typeOneGradeCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeOneGradeCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{pTdefaultHFCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : pTdefaultHFCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in pTdefaultHFCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!pTdefaultHFCtrl.can_published_edit>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=pTdefaultHFCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!pTdefaultHFCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=pTdefaultHFCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{pTdefaultAnnualCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : pTdefaultAnnualCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in pTdefaultAnnualCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!pTdefaultAnnualCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=pTdefaultAnnualCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "<div> <md-content flex=100 style=width:100%> <md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"md-margin md-whiteframe-3dp\"> <md-tab label={{eachBucket.name}} ng-repeat=\"eachBucket in typeSkillOnlyCtrl.card_details\"> <md-content class=md-padding style=margin-bottom:40px> <div class=\"table-responsive-vertical shadow-z-1 whiteframe-3dp tableWidth\"> <table id=table class=\"table table-hover\"> <thead> <tr> <th>Sr No</th> <th>Student Name</th> <th>{{eachBucket.name}}</th> </tr> </thead> <tbody> <tr ng-repeat=\"student in typeSkillOnlyCtrl.allStudentReportData.results\"> <td data-title=SrNo>{{$index + 1}}</td> <td data-title=Description> <div layout=column> <span>{{student.student_name}}</span> <span style=color:red;font-size:10px ng-if=student.kgMarkExceederror>{{student.kgMarkExceederror}}</span> </div> </td> <td data-title=Description> <div layout=column> <div ng-if=\"student.result_redefined[eachBucket.name].total_mark === 'ABSENT'\"> <p ng-if=!typeSkillOnlyCtrl.can_published_edit>Score: ABSENT</p> <p ng-if=typeSkillOnlyCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=student.result_redefined[eachBucket.name].total_mark type=text ng-required=true value=\"\"> </md-input-container> </p> <p>Grade: ABSENT</p> <p ng-if=!typeSkillOnlyCtrl.sendForApprovalFlag>Remark: ABSENT</p> </div> <div ng-if=\"student.result_redefined[eachBucket.name].total_mark != 'ABSENT'\"> <p ng-if=!typeSkillOnlyCtrl.can_published_edit> Score: {{student.result_redefined[eachBucket.name].total_mark}}</p> <p ng-if=typeSkillOnlyCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=student.result_redefined[eachBucket.name].total_mark type=text ng-required=true value=\"\"> </md-input-container> </p> <p>Grade: {{student.result_redefined[eachBucket.name].grade}}</p> <p aria-label=report-view ng-if=!typeSkillOnlyCtrl.sendForApprovalFlag> Remark: {{student.result_redefined[eachBucket.name].remarks}}</p> </div> </div> <md-input-container class=md-block ng-if=typeSkillOnlyCtrl.sendForApprovalFlag flex-gt-sm> <input aria-label=report-view maxlength=100 ng-model=student.result_redefined[eachBucket.name].remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </tbody> </table> </div> </md-content> </md-tab> <md-tab label=\"Student Subject Remark\"> <md-content class=md-padding style=margin-bottom:40px> <div class=\"table-responsive-vertical shadow-z-1 whiteframe-3dp tableWidth\"> <table id=table class=\"table table-hover\"> <thead> <tr> <th>Sr No</th> <th>Student Name</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"student in typeSkillOnlyCtrl.allStudentReportData.results\"> <td data-title=SrNo>{{$index + 1}}</td> <td data-title=Description> <div>{{student.student_name}}</div> </td> <td data-title=Description> <div layout=column> <p aria-label=report-view ng-if=!typeSkillOnlyCtrl.sendForApprovalFlag> {{student.remarks}}</p> </div> <md-input-container class=md-block ng-if=typeSkillOnlyCtrl.sendForApprovalFlag flex-gt-sm> <input aria-label=report-view maxlength=100 ng-model=student.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </tbody> </table> </div> </md-content> </md-tab> </md-tabs> </md-content> </div>";

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeFourMarkCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"typeFourMarkCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeFourMarkCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeFourMarkCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>{{typeFourAnnualCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeFourAnnualCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typeFourAnnualCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeFourAnnualCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> <td colspan=1>Term1 + Term2 (Avg)</td> <td colspan=1>Asset ME</td> </tr> <tr ng-repeat=\"subjectResult in typeFourAnnualCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1>{{subjectResult.marks['annual_exam']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeFourAnnualCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeFourAnnualCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['term1_term2_avg']}}</td> <td colspan=1>{{subjectResult.marks['asset_mark_entry']}}</td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{periodicTestDefaultHfTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : periodicTestDefaultHfTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in periodicTestDefaultHfTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!periodicTestDefaultHfTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=periodicTestDefaultHfTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{periodicTestDefaultAnnualTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : periodicTestDefaultAnnualTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in periodicTestDefaultAnnualTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!periodicTestDefaultAnnualTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=periodicTestDefaultAnnualTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>{{hssTemplateComponentCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : hssTemplateComponentCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>ELT <br/> </td> <td colspan=1>MID TERM <br/> </td> <td colspan=1>CYCLE TEST <br/> </td> <td colspan=1> BREAK UP TEST </td> <td>SA 1 </td> <td colspan=1>SA 2</td> <td colspan=1>THEORY ANNUAL</td> <td colspan=1>PRACTICAL ANNUAL</td> </tr> <tr ng-repeat=\"subjectResult in hssTemplateComponentCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['elt']}}</td> <td colspan=1>{{subjectResult.marks['mid_term']}}</td> <td colspan=1>{{subjectResult.marks['cycle_test']}}</td> <td colspan=1>{{subjectResult.marks['breakuptest']}}</td> <td colspan=1>{{subjectResult.marks['SA_1']}}</td> <td colspan=1>{{subjectResult.marks['SA_2']}}</td> <td colspan=1>{{subjectResult.marks['theory_annual']}}</td> <td colspan=1>{{subjectResult.marks['practical_annual']}}</td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{cbsehssComponentCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : cbsehssComponentCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in cbsehssComponentCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!cbsehssComponentCtrl.can_published_edit>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=cbsehssComponentCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!cbsehssComponentCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=cbsehssComponentCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80/100) </td> <td>Total Mks <br/> Obt. <br/> (80/100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in termonehalfyearlyCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['periodic_test']\"> {{subjectResult.marks['periodic_test']}} </td> <td colspan=1 ng-if=\"!subjectResult.marks['periodic_test']\"> NA </td> <td colspan=1 ng-if=\"termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['periodic_test']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.periodic_test maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['note_book_submission']\"> {{subjectResult.marks['note_book_submission']}} </td> <td colspan=1 ng-if=\"!subjectResult.marks['note_book_submission']\"> NA </td> <td colspan=1 ng-if=\"termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['note_book_submission']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.note_book_submission maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['subject_enrichment']\"> {{subjectResult.marks['subject_enrichment']}} </td> <td colspan=1 ng-if=\"!subjectResult.marks['subject_enrichment']\"> NA </td> <td colspan=1 ng-if=\"termonehalfyearlyCompCtrl.can_published_edit && subjectResult.marks['subject_enrichment']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.subject_enrichment maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!termonehalfyearlyCompCtrl.can_published_edit && termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=\"termonehalfyearlyCompCtrl.can_published_edit && termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!termonehalfyearlyCompCtrl.can_published_edit && termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\"> {{subjectResult.marks['annual_exam']}} </td> <td colspan=1 ng-if=\"termonehalfyearlyCompCtrl.can_published_edit && termonehalfyearlyCompCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!termonehalfyearlyCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=termonehalfyearlyCompCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{kbhfhssCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : kbhfhssCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in kbhfhssCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!kbhfhssCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=kbhfhssCompCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{gradeNineAnnualCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : gradeNineAnnualCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1>*Total (20) <br/> </td> <td colspan=1> Pen & Paper <br/> Exam (80/100) </td> <td>Aggregate <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in gradeNineAnnualCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"subjectResult.marks['periodic_test']\">{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['periodic_test']\">NA</td> <td colspan=1 ng-if=\"subjectResult.marks['note_book_submission']\">{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['note_book_submission']\">NA</td> <td colspan=1 ng-if=\"subjectResult.marks['subject_enrichment']\">{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['subject_enrichment']\">NA</td> <td colspan=1>{{subjectResult.marks['assessment_total']}}</td> <td colspan=1 ng-if=\"gradeNineAnnualCompCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['pen_paper']}}</td> <td colspan=1 ng-if=\"gradeNineAnnualCompCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['pen_paper']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!gradeNineAnnualCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=gradeNineAnnualCompCtrl.sendForApprovalFlag> <md-input-container class=\"md-block remarks_field\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{gradeOneEightCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : gradeOneEightCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1>*Total (20) <br/> </td> <td colspan=1> Pen & Paper <br/> Exam (80/ 100) </td> <td>Aggregate <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in gradeOneEightCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['periodic_test']\">{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['periodic_test']\">NA</td> <td colspan=1 ng-if=\"gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['periodic_test']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.periodic_test maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['note_book_submission']\">{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['note_book_submission']\">NA</td> <td colspan=1 ng-if=\"gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['note_book_submission']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.note_book_submission maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['subject_enrichment']\">{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"!subjectResult.marks['subject_enrichment']\">NA</td> <td colspan=1 ng-if=\"gradeOneEightCompCtrl.can_published_edit && subjectResult.marks['subject_enrichment']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.subject_enrichment maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['assessment_total']}}</td> <td colspan=1 ng-if=\"!gradeOneEightCompCtrl.can_published_edit && gradeOneEightCompCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['pen_paper']}}</td> <td colspan=1 ng-if=\"!gradeOneEightCompCtrl.can_published_edit && gradeOneEightCompCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['pen_paper']}}</td> <td colspan=1 ng-if=\"gradeOneEightCompCtrl.can_published_edit && gradeOneEightCompCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-if=subjectResult.marks.pen_paper ng-model=subjectResult.marks.pen_paper type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!gradeOneEightCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=gradeOneEightCompCtrl.sendForApprovalFlag> <md-input-container class=\"md-block remarks_field\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{annualCbseHssCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : annualCbseHssCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in annualCbseHssCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!annualCbseHssCompCtrl.can_published_edit>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=annualCbseHssCompCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!annualCbseHssCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=annualCbseHssCompCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{annualNineOnlyCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : annualNineOnlyCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{annualNineOnlyCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : annualNineOnlyCompCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in annualNineOnlyCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1>{{subjectResult.marks['annual_exam']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!annualNineOnlyCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=annualNineOnlyCompCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{kbannualComponentCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : kbannualComponentCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in kbannualComponentCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!kbannualComponentCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=kbannualComponentCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{kbhfPtCompCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : kbhfPtCompCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in kbhfPtCompCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!kbhfPtCompCtrl.can_published_edit>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=kbhfPtCompCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!kbhfPtCompCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=kbhfPtCompCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in halfyearlyExamCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"halfyearlyExamCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!halfyearlyExamCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=halfyearlyExamCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports = "<style>.dialogdemoBasicUsage .footer{width:100%;text-align:center;margin-left:20px}.dialogdemoBasicUsage .footer,.dialogdemoBasicUsage .footer>code{font-size:.8em;margin-top:25px}.heading{background-color:#4dd0e2}.overflow{padding:7px 142px;overflow:none}.full_modal{width:600px;height:auto}.md-body-1{text-overflow:ellipsis!important;white-space:nowrap}.head{color:#e6505b}.head{font-size:16px;color:#c73333;font-weight:700}.icons{color:red!important;font-size:16px!important}.activity_used h3{text-decoration:underline}.activity_used h5{text-decoration:underline}.activity_used p{font-weight:700}.activity_used h3.thick{font-weight:700}table.blueTable{border:1px solid #1c6ea4;background-color:#eee;width:100%;text-align:left;border-collapse:collapse}table.blueTable td,table.blueTable th{border:1px solid #aaa;padding:3px 2px;text-align:center}table.blueTable tbody td{font-size:13px}table.blueTable tr:nth-child(even){background:#d0e4f5}table.blueTable thead{background:#1c6ea4;background:-moz-linear-gradient(top,#5592bb 0,#327cad 66%,#1c6ea4 100%);background:-webkit-linear-gradient(top,#5592bb 0,#327cad 66%,#1c6ea4 100%);background:linear-gradient(to bottom,#5592bb 0,#327cad 66%,#1c6ea4 100%);border-bottom:2px solid #444}table.blueTable thead th{font-size:15px;font-weight:700;color:#fff;border-left:2px solid #d0e4f5}table.blueTable thead th:first-child{border-left:none}table.blueTable tfoot{font-size:14px;font-weight:700;color:#fff;background:#d0e4f5;background:-moz-linear-gradient(top,#dcebf7 0,#d4e6f6 66%,#d0e4f5 100%);background:-webkit-linear-gradient(top,#dcebf7 0,#d4e6f6 66%,#d0e4f5 100%);background:linear-gradient(to bottom,#dcebf7 0,#d4e6f6 66%,#d0e4f5 100%);border-top:2px solid #444}table.blueTable tfoot td{font-size:14px}table.blueTable tfoot .links{text-align:right}table.blueTable tfoot .links a{display:inline-block;background:#1c6ea4;color:#fff;padding:2px 8px;border-radius:5px}span{text-align:center}</style> <md-dialog aria-label=\"Reject request\" class=\"full_modal viewOnly activity_used\" ng-cloak> <md-toolbar> <div class=\"md-toolbar-tools heading\"> <h3 style=text-decoration:none;color:#fff class=head> </h3> <span flex> Warning </span> <md-button class=md-icon-button ng-click=cancel()> <i class=\"fas fa-times fa-lg\"></i> </md-button> </div> </md-toolbar> <md-dialog-content class=whitebackground> <table class=blueTable> <thead> <tr> <th>#</th> <th>Students</th> <th>Reason</th> </tr> </thead> <tfoot></tfoot> <tbody> <tr ng-repeat=\"student in validationArray track by $index\"> <td>{{$index+1}}</td> <td>{{student.student_name}}</td> <td ng-if=!student.validation_error> <span ng-if=\"student.empty && !student.invalid\">Marks Not Entered</span> <span ng-if=\"!student.empty && !student.invalid\">Marks Exceeded</span> <span ng-if=student.invalid>Invalid Marks</span> </td> <td ng-if=student.validation_error> <span>{{student.validation_error}}</span> </td> </tr> </tbody> </table> </md-dialog-content> <md-dialog-actions layout=row> <span flex></span> <md-button ng-click=cancel()> Ok </md-button> </md-dialog-actions> </md-dialog>";

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = " <style>#table-example-1 td,#table-example-1 th{padding:.2rem .5rem!important}.input_width{width:70px!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=7> {{typefiveNineTenCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveNineTenCtrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (5 or 10) <br/> </td> <td colspan=1>*Multiple <br/> Aassessment (5) </td> <td colspan=1> {{typefiveNineTenCtrl.allStudentReportData.report_card_header.school_id == \"Mvb8uY53ijBX9DNJS\"?\"*PORT FOLIO (5)\":\"*NB (5)\"}} <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1>*Theory (50) <br/> </td> <td colspan=1>*Practical (50) <br/> </td> <td colspan=1> Half yearly <br/> Exam (80/100) </td> <td>Aggregate <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveNineTenCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['periodic_test']\"> {{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['periodic_test']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        !subjectResult.marks['periodic_test']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                        !subjectResult.marks['periodic_test']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['multiple_assessment']\"> {{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            subjectResult.marks['multiple_assessment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['multiple_assessment']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['multiple_assessment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['note_book_submission']\"> {{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            subjectResult.marks['note_book_submission']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['note_book_submission']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['note_book_submission']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['subject_enrichment']\"> {{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            subjectResult.marks['subject_enrichment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['subject_enrichment']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['subject_enrichment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['theory']\"> {{subjectResult.marks['theory']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            subjectResult.marks['theory']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['theory']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['theory']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                        subjectResult.marks['practical']\"> {{subjectResult.marks['practical']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            subjectResult.marks['practical']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['practical']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit && \n                            !subjectResult.marks['practical']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.practical type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenCtrl.can_published_edit \"> {{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"typefiveNineTenCtrl.can_published_edit \"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveNineTenCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}} </td> <td colspan=1 ng-if=typefiveNineTenCtrl.sendForApprovalFlag> <md-input-container class=\"md-block remarks_field\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports = " <style>#table-example-1 td,#table-example-1 th{padding:.2rem .5rem!important}.input_width{width:70px!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=7> {{typefiveNineTenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveNineTenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (5 or 10) <br/> </td> <td colspan=1>*Multiple <br/> Aassessment (5) </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1>*Theory (50) <br/> </td> <td colspan=1>*Practical (50) <br/> </td> <td colspan=1> ANNUAL EXAM <br/> Exam (80/100) </td> <td>Aggregate <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveNineTenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['periodic_test']\"> {{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['periodic_test']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        !subjectResult.marks['periodic_test']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                        !subjectResult.marks['periodic_test']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['multiple_assessment']\"> {{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            subjectResult.marks['multiple_assessment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['multiple_assessment']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['multiple_assessment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['note_book_submission']\"> {{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            subjectResult.marks['note_book_submission']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['note_book_submission']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['note_book_submission']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['subject_enrichment']\"> {{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            subjectResult.marks['subject_enrichment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['subject_enrichment']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['subject_enrichment']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['theory']\"> {{subjectResult.marks['theory']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            subjectResult.marks['theory']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['theory']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['theory']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                        subjectResult.marks['practical']\"> {{subjectResult.marks['practical']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            subjectResult.marks['practical']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['practical']\"> NA</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit && \n                            !subjectResult.marks['practical']\"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.practical type=text ng-required=true value=NA> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveNineTenTermTwoCtrl.can_published_edit \"> {{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typefiveNineTenTermTwoCtrl.can_published_edit \"> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveNineTenTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}} </td> <td colspan=1 ng-if=typefiveNineTenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=\"md-block remarks_field\" flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80 or 100) </td> <td>Total Mks <br/> Obt. <br/> (100 ) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixEightTerm1Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveSixEightTerm1Ctrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm1Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixEightTerm1Ctrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm1Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixEightTerm1Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm1Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveSixEightTerm1Ctrl.can_published_edit && typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"typefiveSixEightTerm1Ctrl.can_published_edit && typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveSixEightTerm1Ctrl.can_published_edit && typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typefiveSixEightTerm1Ctrl.can_published_edit && typefiveSixEightTerm1Ctrl.allStudentReportData.report_card_header.report_card_name =='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixEightTerm1Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm1Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typefiveSixEightTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixEightTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typefiveSixEightTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixEightTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80 or 100) </td> <td>Total Mks <br/> Obt. <br/> (100 </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixEightTerm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveSixEightTerm2Ctrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixEightTerm2Ctrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixEightTerm2Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveSixEightTerm2Ctrl.can_published_edit \">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixEightTerm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixEightTerm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveSixSevenTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveSixSevenTermoneCtrl.is_specific && subjectResult.marks['term1']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveSixSevenTermoneCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.additional_subjects> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.additional_subjects> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term1'] && !typefiveSixSevenTermoneCtrl.additional_subjects && typefiveSixSevenTermoneCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveSixSevenTermoneCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesevenOneTwoTermoneCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typesevenOneTwoTermoneCtrl.card_details.length}}>{{typesevenOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesevenOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesevenOneTwoTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesevenOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesevenOneTwoTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesevenOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesevenOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesevenOneTwoTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesevenOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesevenOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typesevenOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesevenOneTwoTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesixSixSevenTermoneCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typesixSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesixSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixSixSevenTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesixSixSevenTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesixSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixSixSevenTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixSixSevenTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixSixSevenTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixSixSevenTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typesixSixSevenTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixSixSevenTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixSixSevenTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveThreeFiveTermoneCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typefiveThreeFiveTermoneCtrl.card_details.length}}>{{typefiveThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typefiveThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveThreeFiveTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveThreeFiveTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveThreeFiveTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typefiveThreeFiveTermoneCtrl.card_details.length}}>{{typefiveThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveThreeFiveTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveThreeFiveTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typefiveThreeFiveTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveThreeFiveTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveEightTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.allStudentReportData> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveEightTermoneCtrl.is_specific && subjectResult.marks['annual_exam']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveEightTermoneCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.additional_subjects> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.additional_subjects> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['annual_exam'] && !typefiveEightTermoneCtrl.additional_subjects && typefiveEightTermoneCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveEightTermoneCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.({{typefiveEightTermoneCtrl.total_max_mark}})</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.allStudentReportData> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.allStudentReportData> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.allStudentReportData> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.allStudentReportData> <span ng-if=!typefiveEightTermoneCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveEightTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveOneTwoTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveOneTwoTermoneCtrl.is_specific && subjectResult.marks['term1']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveOneTwoTermoneCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.additional_subjects> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.additional_subjects> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term1'] && !typefiveOneTwoTermoneCtrl.additional_subjects && typefiveOneTwoTermoneCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermoneCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveOneTwoTermoneCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesixOneTwoTermoneCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typesixOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesixOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixOneTwoTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1>{{subjectResult.marks['remarks']}}</td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesixOneTwoTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typesixOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixOneTwoTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixOneTwoTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixOneTwoTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesixOneTwoTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesixOneTwoTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixOneTwoTermoneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typesixOneTwoTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1>{{subjectResult.marks['remarks']}}</td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesixThreeFiveTermoneCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typesixThreeFiveTermoneCtrl.card_details.length}}>{{typesixThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesixThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixThreeFiveTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixThreeFiveTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesixThreeFiveTermoneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesixThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixThreeFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixThreeFiveTermoneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixThreeFiveTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixThreeFiveTermoneCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typesixThreeFiveTermoneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixThreeFiveTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80 or 100) </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneFiveTermoneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveOneFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermoneCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermoneCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneFiveTermoneCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermoneCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveOneFiveTermoneCtrl.can_published_edit && typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"typefiveOneFiveTermoneCtrl.can_published_edit && typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name !='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typefiveOneFiveTermoneCtrl.can_published_edit && typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typefiveOneFiveTermoneCtrl.can_published_edit && typefiveOneFiveTermoneCtrl.allStudentReportData.report_card_header.report_card_name =='Annual'\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneFiveTermoneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermoneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typefiveOneFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typefiveOneFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80 or 100) </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneFiveTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveOneFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermtwoCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermtwoCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermtwoCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermtwoCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneFiveTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneFiveTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typefivekbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefivekbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefivekbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefivekbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typefivekbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefivekbtenTermOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefivekbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typefivekbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefivekbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Mark(40 or 50 or 80)</td> <td colspan=1>CE(10 or 20)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefivekbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefivekbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </td> <td colspan=1 ng-if=typefivekbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefivekbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['ce_exam']}} </td> <td colspan=1 ng-if=typefivekbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefivekbtenTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefivekbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typefivekbEightNineTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefivekbEightNineTermOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefivekbEightNineTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefivekbEightNineTermOneCtrl.can_published_edit>{{subjectResult.marks['term1']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefivekbEightNineTermOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typefivekbEightNineTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefivekbEightNineTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefivekbEightNineTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefivekbEightNineTermTwoCtrl.can_published_edit>{{subjectResult.marks['term2']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefivekbEightNineTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typefivekbEightNineTermThreeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefivekbEightNineTermThreeCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Mark(40 or 80 or 100)</td> <td colspan=1>CE(10 or 20)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefivekbEightNineTermThreeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefivekbEightNineTermThreeCtrl.can_published_edit>{{subjectResult.marks['term3']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefivekbEightNineTermThreeCtrl.can_published_edit>{{subjectResult.marks['ce_exam']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefivekbEightNineTermThreeCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefivekbEightNineTermThreeCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typeSixModelExamOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeSixModelExamOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Theory(70 or 80)</td> <td colspan=1>Practical(30 or 20)</td> <td colspan=1>Total(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeSixModelExamOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['theory']}}</td> <td colspan=1>{{subjectResult.marks['practical']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeSixModelExamOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeSixModelExamOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typesixModelExamTermOneninetenCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixModelExamTermOneninetenCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixModelExamTermOneninetenCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixModelExamTermOneninetenCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixModelExamTermOneninetenCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typesixModelExamTermTwoninetenCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixModelExamTermTwoninetenCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixModelExamTermTwoninetenCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixModelExamTermTwoninetenCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixModelExamTermTwoninetenCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typesixModelExamTermTwoNospaceCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixModelExamTermTwoNospaceCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Theory(70 or 80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixModelExamTermTwoNospaceCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['theory']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixModelExamTermTwoNospaceCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixModelExamTermTwoNospaceCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typesixModelAnnualExamTermCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixModelAnnualExamTermCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Theory(70 or 80)</td> <td colspan=1>Practical(30 or 20)</td> <td colspan=1>Total(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixModelAnnualExamTermCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['theory']}}</td> <td colspan=1>{{subjectResult.marks['practical']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixModelAnnualExamTermCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixModelAnnualExamTermCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>{{typeSevenCalicultAnnualCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeSevenCalicultAnnualCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>*PT (10) <br/> </td> <td colspan=1>*NB (5) <br/> </td> <td colspan=1>*S.E (5) <br/> </td> <td colspan=1> {{typeSevenCalicultAnnualCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeSevenCalicultAnnualCtrl.allStudentReportData.report_card_header.report_card_name}} <br/> Exam (80) </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeSevenCalicultAnnualCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1>{{subjectResult.marks['annual_exam']}}</td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typeSevenCalicultAnnualCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typeSevenCalicultAnnualCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNinePTCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNinePTCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typeNinePTCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNinePTCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typeNinePTCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=2 ng-if=typeNinePTCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNineTermOneHFCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNineTermOneHFCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typeNineTermOneHFCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNineTermOneHFCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typeNineTermOneHFCtrl.can_published_edit>{{subjectResult.marks['term1_hf']}}</td> <td colspan=2 ng-if=typeNineTermOneHFCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_hf type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=\"{{typeNineTermAeCtrl.card_details.length + 1}}\">SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNineTermAeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNineTermAeCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"bucket in typeNineTermAeCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNineTermAeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!typeNineTermAeCtrl.can_published_edit && subjectResult.marks['annual_exam']\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typeNineTermAeCtrl.can_published_edit && subjectResult.marks['annual_exam']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.annual_exam maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNineTermAeCtrl.can_published_edit && subjectResult.marks['project_practical']\">{{subjectResult.marks['project_practical']}}</td> <td colspan=1 ng-if=\"typeNineTermAeCtrl.can_published_edit && subjectResult.marks['project_practical']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.project_practical maxlength=6 ng-model=subjectResult.marks.project_practical type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNineTermAeCtrl.can_published_edit && subjectResult.marks['final_theory']\">{{subjectResult.marks['final_theory']}}</td> <td colspan=1 ng-if=\"typeNineTermAeCtrl.can_published_edit && subjectResult.marks['final_theory']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.final_theory maxlength=6 ng-model=subjectResult.marks.final_theory type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan={{typeNineTwelveTermAeCtrl.card_details.length+1}}>SCHOLASTIC ACHIEVEMENT-{{typeNineTwelveTermAeCtrl.card_details.length}}</th> <th colspan={{typeNineTwelveTermAeCtrl.card_details.length+1}}>{{typeNineTwelveTermAeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNineTwelveTermAeCtrl.allStudentReportData.report_card_header.report_card_name}}-{{typeNineTwelveTermAeCtrl.card_details.length}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"bucket in typeNineTwelveTermAeCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNineTwelveTermAeCtrl.allStudentReportData.results\" ng-if=typeNineTwelveTermAeCtrl.type9_specific_subject> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=typeNineTwelveTermAeCtrl.type9_specific_subject> </ng-container> <td colspan=1 ng-if=\"!typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['annual_exam']\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['annual_exam']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.annual_exam maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> <tr ng-repeat=\"subjectResult in typeNineTwelveTermAeCtrl.allStudentReportData.results\" ng-if=!typeNineTwelveTermAeCtrl.type9_specific_subject> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=typeNineTwelveTermAeCtrl.type9_specific_subject> </ng-container> <td colspan=1 ng-if=\"!typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['pre_model']\">{{subjectResult.marks['pre_model']}}</td> <td colspan=1 ng-if=\"typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['pre_model']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.pre_model maxlength=6 ng-model=subjectResult.marks.pre_model type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['project_practical']\">{{subjectResult.marks['project_practical']}}</td> <td colspan=1 ng-if=\"typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['project_practical']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.project_practical maxlength=6 ng-model=subjectResult.marks.project_practical type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['model_exam']\">{{subjectResult.marks['model_exam']}}</td> <td colspan=1 ng-if=\"typeNineTwelveTermAeCtrl.can_published_edit && subjectResult.marks['model_exam']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.model_exam maxlength=6 ng-model=subjectResult.marks.model_exam type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNinekbUnitTestOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNinekbUnitTestOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typeNinekbUnitTestOneCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNinekbUnitTestOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typeNinekbUnitTestOneCtrl.can_published_edit>{{subjectResult.marks['unit_test']}}</td> <td colspan=2 ng-if=typeNinekbUnitTestOneCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.unit_test type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNineKbtermOnehfCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNineKbtermOnehfCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typeNineKbtermOnehfCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNineKbtermOnehfCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typeNineKbtermOnehfCtrl.can_published_edit>{{subjectResult.marks['term1_hf']}}</td> <td colspan=2 ng-if=typeNineKbtermOnehfCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_hf type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typeNineKbtermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNineKbtermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typeNineKbtermTwoCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNineKbtermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typeNineKbtermTwoCtrl.can_published_edit>{{subjectResult.marks['term2']}}</td> <td colspan=2 ng-if=typeNineKbtermTwoCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan={{typeNinekbTermThreeCtrl.card_details.length+1}}>SCHOLASTIC ACHIEVEMENT-{{typeNinekbTermThreeCtrl.card_details.length}}</th> <th colspan={{typeNinekbTermThreeCtrl.card_details.length+1}}>{{typeNinekbTermThreeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeNinekbTermThreeCtrl.allStudentReportData.report_card_header.report_card_name}}-{{typeNinekbTermThreeCtrl.card_details.length}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"bucket in typeNinekbTermThreeCtrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typeNinekbTermThreeCtrl.allStudentReportData.results\" ng-if=typeNinekbTermThreeCtrl.type9_specific_subject> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=typeNinekbTermThreeCtrl.type9_specific_subject> </ng-container> <td colspan=1 ng-if=\"!typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['annual_exam']\">{{subjectResult.marks['annual_exam']}}</td> <td colspan=1 ng-if=\"typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['annual_exam']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.annual_exam maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> <tr ng-repeat=\"subjectResult in typeNinekbTermThreeCtrl.allStudentReportData.results\" ng-if=!typeNinekbTermThreeCtrl.type9_specific_subject> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=typeNinekbTermThreeCtrl.type9_specific_subject> </ng-container> <td colspan=1 ng-if=\"!typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['pre_model']\">{{subjectResult.marks['pre_model']}}</td> <td colspan=1 ng-if=\"typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['pre_model']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.pre_model maxlength=6 ng-model=subjectResult.marks.pre_model type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['term_3']\">{{subjectResult.marks['term_3']}}</td> <td colspan=1 ng-if=\"typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['term_3']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.term_3 maxlength=6 ng-model=subjectResult.marks.term_3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['ce']\">{{subjectResult.marks['ce']}}</td> <td colspan=1 ng-if=\"typeNinekbTermThreeCtrl.can_published_edit && subjectResult.marks['ce']\"> <md-input-container class=md-block flex-gt-sm> <input ng-if=subjectResult.marks.ce maxlength=6 ng-model=subjectResult.marks.ce type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type12_termcbseCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type12_termcbseCtrl.card_details.length}}>{{type12_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type12_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type12_termcbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type12_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type12_termcbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12_termcbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12_termcbseCtrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12_termcbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type12_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type12_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1_theory']}} </span> <span ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type12_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type12_termcbseCtrl.can_published_edit> {{subjectResult.marks['term2_theory']}} </span> <span ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=\"!type12_termcbseCtrl.sendForApprovalFlag || type12_termcbseCtrl.can_published_edit\">{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=\"type12_termcbseCtrl.sendForApprovalFlag && !type12_termcbseCtrl.can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type12_termcbseCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type12_termcbseCtrl.card_details.length}}>{{type12_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type12_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type12_termcbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type12_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type12_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type12_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type12_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type12_termcbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type12_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=\"!type12_termcbseCtrl.sendForApprovalFlag || type12_termcbseCtrl.can_published_edit\">{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=\"type12_termcbseCtrl.sendForApprovalFlag && !type12_termcbseCtrl.can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type12NineTentermcbseCtrl.is_main> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type12NineTentermcbseCtrl.card_details.length}}>{{type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type12NineTentermcbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type12NineTentermcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td ng-if=type12NineTentermcbseCtrl.allStudentReportData.isTerm1 colspan=1> <span ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['term1_theory']}}</span> <md-input-container ng-if=type12NineTentermcbseCtrl.can_published_edit class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td ng-if=!type12NineTentermcbseCtrl.allStudentReportData.isTerm1 colspan=1> <span ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['term2_theory']}}</span> <md-input-container ng-if=type12NineTentermcbseCtrl.can_published_edit class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type12NineTentermcbseCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type12NineTentermcbseCtrl.card_details.length}}>{{type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type12NineTentermcbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type12NineTentermcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit> <span ng-if=type12NineTentermcbseCtrl.allStudentReportData.isTerm1>{{subjectResult.marks['term1']}}</span> <span ng-if=!type12NineTentermcbseCtrl.allStudentReportData.isTerm1>{{subjectResult.marks['term2']}}</span> </td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container ng-if=type12NineTentermcbseCtrl.allStudentReportData.isTerm1 class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> <md-input-container ng-if=!type12NineTentermcbseCtrl.allStudentReportData.isTerm1 class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type12NineTentermcbseCtrl.additional_subjects> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type12NineTentermcbseCtrl.card_details.length}}>{{type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type12NineTentermcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type12NineTentermcbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type12NineTentermcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['theory']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.can_published_edit>{{subjectResult.marks['practical']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type12NineTentermcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type12NineTentermcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{ eltPublishedReportCtrl .allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : eltPublishedReportCtrl .allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in  eltPublishedReportCtrl .allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"! eltPublishedReportCtrl .can_published_edit\">{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=\" eltPublishedReportCtrl .can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=\"! eltPublishedReportCtrl .sendForApprovalFlag\">{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=\" eltPublishedReportCtrl .sendForApprovalFlag\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>&nbsp; {{ type20kb10Gradeterm1Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20kb10Gradeterm1Ctrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=2 ng-repeat=\"bucket in type20kb10Gradeterm1Ctrl.card_details\">{{bucket.name}} <span ng-if=type20kb10Gradeterm1Ctrl._isMain>(80)</span> <span ng-if=type20kb10Gradeterm1Ctrl.isSpecific>(50)</span> <span ng-if=type20kb10Gradeterm1Ctrl.is40>(40)</span> </td> </tr> <tr ng-repeat=\"subjectResult in type20kb10Gradeterm1Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!type20kb10Gradeterm1Ctrl.can_published_edit> {{subjectResult.marks['term1']}}</td> <td colspan=2 ng-if=type20kb10Gradeterm1Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type20_termcbseCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbseCtrl.card_details.length}}>{{type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_termcbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type20_termcbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbseCtrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type20_termcbseCtrl.allStudentReportData> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1_theory']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_termcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type20_termcbseCtrl.is_specific && subjectResult.marks['term1']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbseCtrl.card_details.length}}>{{type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_termcbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type20_termcbseCtrl.additional_subjects> <td colspan=1 ng-if=!type20_termcbseCtrl.additional_subjects> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_termcbseCtrl.additional_subjects> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_termcbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type20_termcbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term1'] && !type20_termcbseCtrl.additional_subjects && type20_termcbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbseCtrl.card_details.length}}>{{type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Term 1 (100)</strong></td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_termcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_termcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type20_termcbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbseCtrl.card_details.length}}>{{type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type20_termcbseCtrl.allStudentReportData> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type20_termcbseCtrl.allStudentReportData> <span ng-if=!type20_termcbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type20_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type20_termcbseCtrl.allStudentReportData> <span> {{subjectResult.marks['total_mark']}} </span> </td> <td colspan=1 ng-if=type20_termcbseCtrl.allStudentReportData> <span> {{subjectResult.marks['grade']}} </span> </td> <ng-container ng-if=!type20_termcbseCtrl.can_published_edit> <td colspan=1 ng-if=\"!type20_termcbseCtrl.sendForApprovalFlag && !type20_termcbseCtrl.can_published_edit\">{{subjectResult.marks['remarks']}}===</td> <td colspan=1 ng-if=\"type20_termcbseCtrl.sendForApprovalFlag && !type20_termcbseCtrl.can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </ng-container> <ng-container ng-if=type20_termcbseCtrl.can_published_edit> <td colspan=1 ng-if=\"!type20_termcbseCtrl.sendForApprovalFlag && type20_termcbseCtrl.can_published_edit\">{{subjectResult.marks['remarks']}}</td> </ng-container> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type20_termcbse18Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbse18Ctrl.card_details.length}}>{{type20_termcbse18Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbse18Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_termcbse18Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td><strong>Total Mks <br/> Obt. <br/> (50 or 100)</strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbse18Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type20_termcbse18Ctrl.allStudentReportData> <span ng-if=!type20_termcbse18Ctrl.can_published_edit> {{subjectResult.marks['term1_theory']}} </span> <span ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.allStudentReportData> <span ng-if=!type20_termcbse18Ctrl.can_published_edit> {{subjectResult.marks['term2_theory']}} </span> <span ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type20_termcbse18Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_termcbse18Ctrl.card_details.length}}>{{type20_termcbse18Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_termcbse18Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_termcbse18Ctrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_termcbse18Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type20_termcbse18Ctrl.allStudentReportData> <span ng-if=!type20_termcbse18Ctrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.allStudentReportData> <span ng-if=!type20_termcbse18Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_termcbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_termcbse18Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_termcbse18Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type20_term2cbseCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbseCtrl.card_details.length}}>{{type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_term2cbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type20_term2cbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type20_term2cbseCtrl.allStudentReportData> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2_theory']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type20_term2cbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbseCtrl.card_details.length}}>{{type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_term2cbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type20_term2cbseCtrl.additional_subjects> <td colspan=1 ng-if=!type20_term2cbseCtrl.additional_subjects> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.additional_subjects> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type20_term2cbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type20_term2cbseCtrl.additional_subjects && type20_term2cbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbseCtrl.card_details.length}}>{{type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Term 2 (100)</strong></td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1>{{subjectResult.marks['term2']}} </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type20_term2cbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbseCtrl.card_details.length}}>{{type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type20_term2cbseCtrl.allStudentReportData> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type20_term2cbseCtrl.allStudentReportData> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type20_term2cbseCtrl.allStudentReportData> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type20_term2cbseCtrl.allStudentReportData> <span ng-if=!type20_term2cbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type20_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type20_term2cbse18Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbse18Ctrl.card_details.length}}>{{type20_term2cbse18Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbse18Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_term2cbse18Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td><strong>Total Mks <br/> Obt. <br/> (50 or 100)</strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbse18Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.can_published_edit>{{subjectResult.marks['portfolio']}}</td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.portfolio type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.allStudentReportData> <span ng-if=!type20_term2cbse18Ctrl.can_published_edit> {{subjectResult.marks['term2_theory']}} </span> <span ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.allStudentReportData> <span ng-if=!type20_term2cbse18Ctrl.can_published_edit> {{subjectResult.marks['term2_theory']}} </span> <span ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2_theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type20_term2cbse18Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type20_term2cbse18Ctrl.card_details.length}}>{{type20_term2cbse18Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20_term2cbse18Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type20_term2cbse18Ctrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type20_term2cbse18Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.allStudentReportData> <span ng-if=!type20_term2cbse18Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type20_term2cbse18Ctrl.allStudentReportData> <span ng-if=!type20_term2cbse18Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type20_term2cbse18Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=\"!type20_term2cbse18Ctrl.sendForApprovalFlag && !type20_term2cbse18Ctrl.can_published_edit\">{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=\"type20_term2cbse18Ctrl.sendForApprovalFlag && !type20_term2cbse18Ctrl.can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type20_term2cbse18Ctrl.can_published_edit>{{subjectResult.marks['remarks']}}</td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>&nbsp; {{ type20kb10Gradeterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type20kb10Gradeterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=2 ng-repeat=\"bucket in type20kb10Gradeterm2Ctrl.card_details\">{{bucket.name}} <span ng-if=type20kb10Gradeterm2Ctrl._isMain>(80)</span> <span ng-if=type20kb10Gradeterm2Ctrl.isSpecific>(50)</span> <span ng-if=type20kb10Gradeterm2Ctrl.is40>(40)</span> </td> </tr> <tr ng-repeat=\"subjectResult in type20kb10Gradeterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!type20kb10Gradeterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}}</td> <td colspan=2 ng-if=type20kb10Gradeterm2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typethirtykbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneCtrl.full_data.report_data.content_mngr\n.                is_specific\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark({{typethirtykbtenTermOneCtrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneCtrl.full_data.report_data.content_mngr\n.                subject_40_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneCtrl.full_data.report_data.content_mngr\n.                subject_80_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typethirtykbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoCtrl.full_data.report_data.content_mngr\n.                is_specific\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark({{typethirtykbtenTermTwoCtrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoCtrl.full_data.report_data.content_mngr\n.                subject_40_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 2(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoCtrl.full_data.report_data.content_mngr\n.                subject_80_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3> {{typethirtykbtenTermThreeCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermThreeCtrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeCtrl.content_mngr.is_specific> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100 or 50)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeCtrl.content_mngr.subject_40_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 3(40)</td> <td colspan=1>CE(10)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.can_published_edit> {{subjectResult.marks['ce']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeCtrl.content_mngr.subject_80_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 3(80)</td> <td colspan=1>CE(20)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.can_published_edit> {{subjectResult.marks['ce']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typethirtykbtenTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneNew26Ctrl.full_data.report_data.content_mngr\n    .                is_specific\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark({{typethirtykbtenTermOneNew26Ctrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneNew26Ctrl.full_data.report_data.content_mngr\n    .                subject_40_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermOneNew26Ctrl.full_data.report_data.content_mngr\n    .                subject_80_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermOneNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermOneNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typethirtykbtenTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoNew26Ctrl.full_data.report_data.content_mngr\n    .                is_specific\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark({{typethirtykbtenTermTwoNew26Ctrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoNew26Ctrl.full_data.report_data.content_mngr\n    .                subject_40_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 2(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=\"typethirtykbtenTermTwoNew26Ctrl.full_data.report_data.content_mngr\n    .                subject_80_subjects\"> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermTwoNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermTwoNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3> {{typethirtykbtenTermThreeNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typethirtykbtenTermThreeNew26Ctrl.allStudentReportData.report_card_header.report_card_name}} </th> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeNew26Ctrl.content_mngr.is_specific> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Total Mark(100 or 50)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeNew26Ctrl.content_mngr.subject_40_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 3(40)</td> <td colspan=1>CE(10)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.can_published_edit> {{subjectResult.marks['ce']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typethirtykbtenTermThreeNew26Ctrl.content_mngr.subject_80_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 3(80)</td> <td colspan=1>CE(20)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typethirtykbtenTermThreeNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.can_published_edit> {{subjectResult.marks['term3']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term3 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.can_published_edit> {{subjectResult.marks['ce']}} </td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ce type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typethirtykbtenTermThreeNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div>";

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type8to10_termcbseCtrl.is_specific && !type8to10_termcbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type8to10_termcbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type8to10_termcbseCtrl.additional_subjects> <td colspan=1 ng-if=!type8to10_termcbseCtrl.additional_subjects> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.additional_subjects> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type8to10_termcbseCtrl.additional_subjects && type8to10_termcbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseCtrl.card_details\"> <br/> Term -1 ({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type8to10_termcbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_termcbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_termcbseCtrl.allStudentReportData> <span ng-if=!type8to10_termcbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type8to10_termcbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_termcbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!typetermcbse_8to10Ctrl.is_specific && !typetermcbse_8to10Ctrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10Ctrl.card_details.length}}>{{typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typetermcbse_8to10Ctrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10Ctrl.card_details.length}}>{{typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typetermcbse_8to10Ctrl.additional_subjects> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.additional_subjects> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.additional_subjects> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !typetermcbse_8to10Ctrl.additional_subjects && typetermcbse_8to10Ctrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10Ctrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData.isTerm1> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.allStudentReportData.isTerm1> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetermcbse_8to10Ctrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10Ctrl.card_details.length}}>{{typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10Ctrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typetermcbse_8to10Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type6to7_alncbseCtrl.is_specific && !type6to7_alncbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrl.card_details.length}}>{{type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type6to7_alncbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrl.card_details.length}}>{{type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type6to7_alncbseCtrl.additional_subjects> <td colspan=1 ng-if=!type6to7_alncbseCtrl.additional_subjects> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.additional_subjects> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type6to7_alncbseCtrl.additional_subjects && type6to7_alncbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrl.card_details.length}}>{{type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type6to7_alncbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrl.card_details.length}}>{{type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrl.allStudentReportData> <span ng-if=!type6to7_alncbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type6to7_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type6to7_tcscbseCtrl.is_specific && !type6to7_tcscbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.allStudentReportData> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type6to7_tcscbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type6to7_tcscbseCtrl.additional_subjects> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.additional_subjects> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.additional_subjects> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type6to7_tcscbseCtrl.additional_subjects && type6to7_tcscbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type6to7_tcscbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(30)</strong></td> <td colspan=1><strong>Practical(20)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.allStudentReportData> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.allStudentReportData> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.allStudentReportData> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.allStudentReportData> <span ng-if=!type6to7_tcscbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type6to7_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type3to5_tcscbseCtrl.is_specific && !type3to5_tcscbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type3to5_tcscbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type3to5_tcscbseCtrl.additional_subjects> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.additional_subjects> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.additional_subjects> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type3to5_tcscbseCtrl.additional_subjects && type3to5_tcscbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type3to5_tcscbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type3to5_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type3to5_alncbseCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type3to5_alncbseCtrl.card_details.length}}>{{type3to5_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : type3to5_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_alncbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type3to5_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.can_published_edit>{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type3to5_alncbseCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{type3to5_alncbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_alncbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_alncbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type3to5_alncbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type3to5_alncbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type3to5_alncbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type3to5_alncbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_alncbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_alncbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type1to2_tcscbseCtrl.is_specific && !type1to2_tcscbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.allStudentReportData> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type1to2_tcscbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type1to2_tcscbseCtrl.additional_subjects> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.additional_subjects> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.additional_subjects> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type1to2_tcscbseCtrl.additional_subjects && type1to2_tcscbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-I)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type1to2_tcscbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(20)</strong></td> <td colspan=1><strong>Practical(30)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.allStudentReportData> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.allStudentReportData> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.allStudentReportData> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.allStudentReportData> <span ng-if=!type1to2_tcscbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type1to2_tcscbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbtenTermOneCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=typetenkbtenTermOneCtrl.full_data.report_data.content_mngr.is_specific> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1({{typetenkbtenTermOneCtrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typetenkbtenTermOneCtrl.full_data.report_data.content_mngr.subject_40_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typetenkbtenTermOneCtrl.full_data.report_data.content_mngr.subject_80_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbtenTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead ng-if=typetenkbtenTermTwoCtrl.full_data.report_data.content_mngr.is_specific> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 2({{typetenkbtenTermTwoCtrl.moe_maxmark}})</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typetenkbtenTermTwoCtrl.full_data.report_data.content_mngr.subject_40_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 2(40)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.sendForApprovalFlag> {{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> <thead ng-if=typetenkbtenTermTwoCtrl.full_data.report_data.content_mngr.subject_80_subjects> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1>Term 1(80)</td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbtenTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbtenTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbtenTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typetenkbeleventwelveTermOneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typetenkbeleventwelveTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typetenkbeleventwelveTermOneCtrl.allStudentReportData.report_card_header.report_card_name}} (Term - 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetenkbeleventwelveTermOneCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneCtrl.can_published_edit>{{subjectResult.marks['unit_test']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.unit_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneCtrl.can_published_edit>{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetenkbeleventwelveTermOneCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbeleventwelveTermOneCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbeleventwelveTermOneCtrl.allStudentReportData.report_card_header.report_card_name}}(Term -1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td>Total Mks <br/> Obt. <br/> {{typetenkbeleventwelveTermOneCtrl.moe_maxmark}} </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermOneCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typetenkbeleventwelveTermOneCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typetenkbeleventwelveTermOneCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typetenkbeleventwelveTermTwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typetenkbeleventwelveTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typetenkbeleventwelveTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term - 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetenkbeleventwelveTermTwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoCtrl.can_published_edit>{{subjectResult.marks['unit_test_2']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.unit_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoCtrl.can_published_edit>{{subjectResult.marks['model_2']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.model_2 type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetenkbeleventwelveTermTwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbeleventwelveTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbeleventwelveTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term -2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td>Total Mks <br/> Obt. <br/> ({{typetenkbeleventwelveTermTwoCtrl.moe_maxmark}}) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typetenkbeleventwelveTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typetenkbeleventwelveTermTwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typetenkbeleventwelveTermOneNew26Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term - 1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetenkbeleventwelveTermOneNew26Ctrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit>{{subjectResult.marks['unit_test']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.unit_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit>{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetenkbeleventwelveTermOneNew26Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.report_card_header.report_card_name}}(Term -1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td>Total Mks <br/> Obt. <br/> {{typetenkbeleventwelveTermOneNew26Ctrl.moe_maxmark}} </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermOneNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typetenkbeleventwelveTermOneNew26Ctrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbeleventwelveTermOneNew26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermOneNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typetenkbeleventwelveTermTwoNew26Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name}}(Term - 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetenkbeleventwelveTermTwoNew26Ctrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit>{{subjectResult.marks['unit_test_2']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.unit_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit>{{subjectResult.marks['model_2']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.model_2 type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetenkbeleventwelveTermTwoNew26Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.report_card_header.report_card_name}}(Term -2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td>Total Mks <br/> Obt. <br/> ({{typetenkbeleventwelveTermTwoNew26Ctrl.moe_maxmark}}) </td> <td colspan=1>Grade</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetenkbeleventwelveTermTwoNew26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typetenkbeleventwelveTermTwoNew26Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetenkbeleventwelveTermTwoNew26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetenkbeleventwelveTermTwoNew26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none ng-if=\"!type02grade11scCtrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT </th> <th colspan={{type02grade11scCtrl.card_details.length}}>Term I</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade11scCtrl.card_details\" ng-if=bucket.max_mark> {{bucket.name}} ({{bucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in type02grade11scCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!type02grade11scCtrl.can_published_edit \">{{subjectResult.marks['periodic_test']}} </td> <td colspan=1 ng-if=type02grade11scCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td ng-if=\"!type02grade11scCtrl.can_published_edit && type02grade11scCtrl.show_pct\"> {{subjectResult.marks['pct']}} </td> <td ng-if=\"type02grade11scCtrl.can_published_edit && type02grade11scCtrl.show_pct\"> <md-input-container> <input ng-model=subjectResult.marks.pct> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade11scCtrl.can_published_edit \">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=type02grade11scCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type02grade11scCtrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>HALF YEARLY(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade11scCtrl.card_details\"> <strong>{{oneBucket.name}}({{type02grade11scCtrl.full_data.report_data.bucket_max_mark.term1.max_mark}})</strong> </td> <td colspan=1> <strong>Grades</strong> </td> <td colspan=1> <strong>Subject Remarks</strong> </td> </tr> <tr ng-repeat=\"subjectResult in type02grade11scCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type02grade11scCtrl.additional_subjects> <td colspan=1 ng-if=!type02grade11scCtrl.additional_subjects> <span ng-if=!type02grade11scCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type02grade11scCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> </ng-container> <td colspan=1> {{subjectResult.marks['grade']}} </td> <td colspan=1> {{subjectResult.marks['remarks']}} </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none ng-if=!type02grade11sct2Ctrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type02grade11sct2Ctrl.card_details.length}}>TERM II</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade11sct2Ctrl.card_details\">{{bucket.name}} ({{bucket.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in type02grade11sct2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!type02grade11sct2Ctrl.can_published_edit && subjectResult.marks['periodic_test2'] !== undefined\">{{subjectResult.marks['periodic_test2']}}</td> <td colspan=1 ng-if=\"type02grade11sct2Ctrl.can_published_edit \"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade11sct2Ctrl.hideModelExam && !type02grade11sct2Ctrl.can_published_edit && subjectResult.marks['model'] !== undefined\">{{subjectResult.marks['model']}}</td> <td colspan=1 ng-if=\"!type02grade11sct2Ctrl.hideModelExam && type02grade11sct2Ctrl.can_published_edit\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.model type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade11sct2Ctrl.can_published_edit && subjectResult.marks['ae'] !== undefined\">{{subjectResult.marks['ae']}}</td> <td colspan=1 ng-if=type02grade11sct2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.ae type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade11sct2Ctrl.can_published_edit && subjectResult.marks['pp'] !== undefined\">{{subjectResult.marks['pp']}}</td> <td colspan=1 ng-if=type02grade11sct2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.pp type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type02grade11sct2Ctrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>TERM II</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade11sct2Ctrl.card_details\"> <strong>{{oneBucket.name}}({{type02grade11sct2Ctrl.full_data.report_data.bucket_max_mark.term2.max_mark}})</strong> </td> <td colspan=1> <strong>Grades</strong> </td> <td colspan=1> <strong>Subject Remarks</strong> </td> </tr> <tr ng-repeat=\"subjectResult in type02grade11sct2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type02grade11sct2Ctrl.additional_subjects> <td colspan=1 ng-if=!type02grade11sct2Ctrl.additional_subjects> <span ng-if=!type02grade11sct2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type02grade11sct2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> </ng-container> <td colspan=1> {{subjectResult.marks['grade']}} </td> <td colspan=1> {{subjectResult.marks['remarks']}} </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none ng-if=\"!type02grade12scCtrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=4>TERM I</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade12scCtrl.card_details\" ng-if=bucket.max_mark> {{bucket.name}} ({{bucket.max_mark}}) </td> <td colspan=1>Grade</td> <td colspan=1>Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type02grade12scCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!type02grade12scCtrl.can_published_edit && subjectResult.marks['periodic_test'] !== undefined\">{{subjectResult.marks['periodic_test']}} </td> <td colspan=1 ng-if=type02grade12scCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade12scCtrl.can_published_edit && subjectResult.marks['pct'] !== undefined\">{{subjectResult.marks['pct']}}</td> <td colspan=1 ng-if=\"type02grade12scCtrl.can_published_edit && type02grade12scCtrl.show_pct\"> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.pct type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade12scCtrl.can_published_edit && subjectResult.marks['half_yearly'] !== undefined\">{{subjectResult.marks['half_yearly']}}</td> <td colspan=1 ng-if=\"!type02grade12scCtrl.can_published_edit && subjectResult.marks['grade'] !== undefined\">{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=\"!type02grade12scCtrl.can_published_edit && subjectResult.marks['remarks'] !== undefined\">{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade12scCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type02grade12scCtrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>HALF YEARLY(Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade12scCtrl.card_details\"> <strong>{{oneBucket.name}} ({{type02grade12scCtrl.full_data.report_data.bucket_max_mark.term1.max_mark}})</strong> </td> <td colspan=1> <strong>Grades</strong> </td> <td colspan=1> <strong>Subject Remarks</strong> </td> </tr> <tr ng-repeat=\"subjectResult in type02grade12scCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type02grade12scCtrl.additional_subjects> <td colspan=1 ng-if=!type02grade12scCtrl.additional_subjects> <span ng-if=!type02grade12scCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=type02grade12scCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> </ng-container> <td colspan=1> {{subjectResult.marks['grade']}} </td> <td colspan=1> {{subjectResult.marks['remarks']}} </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none ng-if=\"!type02grade12sct2Ctrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT </th> <th colspan={{type02grade12sct2Ctrl.card_details.length}}>TERM II</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade12sct2Ctrl.card_details\" ng-if=bucket.max_mark> {{bucket.name}} ({{bucket.max_mark}}) </td> </tr> <tr ng-repeat=\"subjectResult in type02grade12sct2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=\"!type02grade12sct2Ctrl.can_published_edit && subjectResult.marks['periodic_test2'] !== undefined\">{{subjectResult.marks['periodic_test2']}}</td> <td colspan=1 ng-if=type02grade12sct2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade12sct2Ctrl.can_published_edit && subjectResult.marks['theory'] !== undefined\">{{subjectResult.marks['theory']}}</td> <td colspan=1 ng-if=type02grade12sct2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=\"!type02grade12sct2Ctrl.can_published_edit && subjectResult.marks['pp'] !== undefined\">{{subjectResult.marks['pp']}}</td> <td colspan=1 ng-if=type02grade12sct2Ctrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.pp type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type02grade12sct2Ctrl.is_specific \"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6>TERM II</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade12sct2Ctrl.card_details\"> <strong>{{oneBucket.name}}({{type02grade12sct2Ctrl.full_data.report_data.bucket_max_mark.term2.max_mark}})</strong> </td> <td colspan=1> <strong>Grades</strong> </td> <td colspan=1> <strong>Subject Remarks</strong> </td> </tr> <tr ng-repeat=\"subjectResult in type02grade12sct2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type02grade12sct2Ctrl.additional_subjects> <td colspan=1 ng-if=!type02grade12sct2Ctrl.additional_subjects> <span ng-if=!type02grade12sct2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type02grade12sct2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> </ng-container> <td colspan=1> {{subjectResult.marks['grade']}} </td> <td colspan=1> {{subjectResult.marks['remarks']}} </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveThreeFiveTermtwoCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typefiveThreeFiveTermtwoCtrl.card_details.length}}>{{typefiveThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typefiveThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveThreeFiveTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveThreeFiveTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission_2']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam_2']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveThreeFiveTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typefiveThreeFiveTermtwoCtrl.card_details.length}}>{{typefiveThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveThreeFiveTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typefiveThreeFiveTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam_2']}} </span> <span ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typefiveThreeFiveTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam_2']}} </span> <span ng-if=typefiveThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveThreeFiveTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesixSixSevenTermtwoCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typesixSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesixSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixSixSevenTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission_2']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam_2']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesixSixSevenTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesixSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixSixSevenTermtwoCtrl.card_details\"> <br/> Term -2 ({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam_2']}} </span> <span ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam_2']}} </span> <span ng-if=typesixSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixSixSevenTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixSixSevenTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type8to10_term2cbseCtrl.is_specific && !type8to10_term2cbseCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_term2cbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type8to10_term2cbseCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}} (Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_term2cbseCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type8to10_term2cbseCtrl.additional_subjects> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.additional_subjects> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.additional_subjects> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type8to10_term2cbseCtrl.additional_subjects && type8to10_term2cbseCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_term2cbseCtrl.card_details\"> <br/> Term -2 ({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type8to10_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type8to10_term2cbseCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type8to10_term2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_term2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['theory_2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['practical_2']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.allStudentReportData> <span ng-if=!type8to10_term2cbseCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type8to10_term2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type8to10_term2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_term2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveOneTwoTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveOneTwoTermtwoCtrl.is_specific && subjectResult.marks['term1']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveOneTwoTermtwoCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.additional_subjects> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.additional_subjects> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term1'] && !typefiveOneTwoTermtwoCtrl.additional_subjects && typefiveOneTwoTermtwoCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveOneTwoTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam_2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam_2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveOneTwoTermtwoCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveOneTwoTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveOneTwoTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typeoneTwoShjTermTwoCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typeoneTwoShjTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typeoneTwoShjTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typeoneTwoShjTermTwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeoneTwoShjTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1>{{subjectResult.marks['remarks']}}</td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typeoneTwoShjTermTwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>{{typeoneTwoShjTermTwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typeoneTwoShjTermTwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typeoneTwoShjTermTwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typeoneTwoShjTermTwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typeoneTwoShjTermTwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typeoneTwoShjTermTwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typeoneTwoShjTermTwoCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typeoneTwoShjTermTwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1>{{subjectResult.marks['remarks']}}</td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type1to2_tcscbseterm2Ctrl.is_specific && !type1to2_tcscbseterm2Ctrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-II)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type1to2_tcscbseterm2Ctrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-II)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type1to2_tcscbseterm2Ctrl.additional_subjects> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.additional_subjects> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.additional_subjects> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type1to2_tcscbseterm2Ctrl.additional_subjects && type1to2_tcscbseterm2Ctrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-II)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type1to2_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades 3</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type1to2_tcscbseterm2Ctrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type1to2_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-II)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(20)</strong></td> <td colspan=1><strong>Practical(30)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type1to2_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['theory_2']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['practical_2']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type1to2_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type1to2_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type1to2_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type1to2_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type6to7_tcscbseterm2Ctrl.is_specific && !type6to7_tcscbseterm2Ctrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type6to7_tcscbseterm2Ctrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type6to7_tcscbseterm2Ctrl.additional_subjects> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.additional_subjects> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.additional_subjects> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type6to7_tcscbseterm2Ctrl.additional_subjects && type6to7_tcscbseterm2Ctrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_tcscbseterm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades 3</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type6to7_tcscbseterm2Ctrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_tcscbseterm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(30)</strong></td> <td colspan=1><strong>Practical(20)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_tcscbseterm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.allStudentReportData> <span ng-if=!type6to7_tcscbseterm2Ctrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type6to7_tcscbseterm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_tcscbseterm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_tcscbseterm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type3to5_tcscbseCtrltermtwo.is_specific && !type3to5_tcscbseCtrltermtwo.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrltermtwo.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrltermtwo.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type3to5_tcscbseCtrltermtwo.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrltermtwo.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrltermtwo.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type3to5_tcscbseCtrltermtwo.additional_subjects> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.additional_subjects> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.additional_subjects> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type3to5_tcscbseCtrltermtwo.additional_subjects && type3to5_tcscbseCtrltermtwo.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_tcscbseCtrltermtwo.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades 3</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrltermtwo.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type3to5_tcscbseCtrltermtwo.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_tcscbseCtrltermtwo.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type3to5_tcscbseCtrltermtwo.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.allStudentReportData> <span ng-if=!type3to5_tcscbseCtrltermtwo.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type3to5_tcscbseCtrltermtwo.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_tcscbseCtrltermtwo.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_tcscbseCtrltermtwo.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesixThreeFiveTermtwoCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typesixThreeFiveTermtwoCtrl.card_details.length}}>{{typesixThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesixThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixThreeFiveTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixThreeFiveTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesixThreeFiveTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesixThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesixThreeFiveTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesixThreeFiveTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesixThreeFiveTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesixThreeFiveTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typesixThreeFiveTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesixThreeFiveTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesixThreeFiveTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveSixSevenTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveSixSevenTermtwoCtrl.is_specific && subjectResult.marks['term1']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveSixSevenTermtwoCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.additional_subjects> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.additional_subjects> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term1'] && !typefiveSixSevenTermtwoCtrl.additional_subjects && typefiveSixSevenTermtwoCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveSixSevenTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveSixSevenTermtwoCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveSixSevenTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveSixSevenTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveSixSevenTermtwoCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveSixSevenTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveSixSevenTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveSixSevenTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typefiveEightTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['half_yearly_exam']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typefiveEightTermtwoCtrl.is_specific && subjectResult.marks['annual_exam']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typefiveEightTermtwoCtrl.additional_subjects> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.additional_subjects> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.additional_subjects> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['annual_exam'] && !typefiveEightTermtwoCtrl.additional_subjects && typefiveEightTermtwoCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typefiveEightTermtwoCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades 4</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.annual_exam type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['annual_exam']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typefiveEightTermtwoCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=8>{{typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typefiveEightTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.({{typefiveEightTermtwoCtrl.total_max_mark}})</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typefiveEightTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.allStudentReportData> <span ng-if=!typefiveEightTermtwoCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typefiveEightTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typefiveEightTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typefiveEightTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!typesevenOneTwoTermtwoCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typesevenOneTwoTermtwoCtrl.card_details.length}}>{{typesevenOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : typesevenOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesevenOneTwoTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesevenOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['note_book_submission_2']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit>{{subjectResult.marks['half_yearly_exam_2']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_exam_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typesevenOneTwoTermtwoCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typesevenOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typesevenOneTwoTermtwoCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typesevenOneTwoTermtwoCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typesevenOneTwoTermtwoCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.allStudentReportData.isTerm1> <span ng-if=!typesevenOneTwoTermtwoCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typesevenOneTwoTermtwoCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typesevenOneTwoTermtwoCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typesevenOneTwoTermtwoCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type3to5_alnterm2cbseCtrl.is_specific> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type3to5_alnterm2cbseCtrl.card_details.length}}>{{type3to5_alnterm2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VII (Term - 1)\" ? \"Annual\" : type3to5_alnterm2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_alnterm2cbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type3to5_alnterm2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit>{{subjectResult.marks['half_yearly_2']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type3to5_alnterm2cbseCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{type3to5_alnterm2cbseCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type3to5_alnterm2cbseCtrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type3to5_alnterm2cbseCtrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type3to5_alnterm2cbseCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.allStudentReportData.isTerm1> <span ng-if=!type3to5_alnterm2cbseCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type3to5_alnterm2cbseCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type3to5_alnterm2cbseCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type3to5_alnterm2cbseCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type6to7_alncbseCtrlterm2.is_specific && !type6to7_alncbseCtrlterm2.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrlterm2.card_details.length}}>{{type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name}} (Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrlterm2.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrlterm2.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['yearly']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type6to7_alncbseCtrlterm2.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrlterm2.card_details.length}}>{{type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name}} (Term 2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrlterm2.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrlterm2.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type6to7_alncbseCtrlterm2.additional_subjects> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.additional_subjects> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.additional_subjects> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type6to7_alncbseCtrlterm2.additional_subjects && type6to7_alncbseCtrlterm2.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrlterm2.card_details.length}}> {{type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name}} (Term 2) </th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6to7_alncbseCtrlterm2.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrlterm2.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData.isTerm1> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.allStudentReportData.isTerm1> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type6to7_alncbseCtrlterm2.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{type6to7_alncbseCtrlterm2.card_details.length}}>{{type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type6to7_alncbseCtrlterm2.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6to7_alncbseCtrlterm2.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.allStudentReportData> <span ng-if=!type6to7_alncbseCtrlterm2.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type6to7_alncbseCtrlterm2.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type6to7_alncbseCtrlterm2.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6to7_alncbseCtrlterm2.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!typetermcbse_8to10term2Ctrl.is_specific && !typetermcbse_8to10term2Ctrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10term2Ctrl.card_details.length}}>{{typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name}}(Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10term2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10term2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"typetermcbse_8to10term2Ctrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10term2Ctrl.card_details.length}}>{{typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10term2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (50 or 100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10term2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!typetermcbse_8to10term2Ctrl.additional_subjects> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.additional_subjects> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.additional_subjects> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !typetermcbse_8to10term2Ctrl.additional_subjects && typetermcbse_8to10term2Ctrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10term2Ctrl.card_details.length}}>{{typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=1 ng-repeat=\"oneBucket in typetermcbse_8to10term2Ctrl.card_details\"> <br/> {{oneBucket.name}}({{oneBucket.max_mark}}) </td> <td colspan=1>Grades</td> <td colspan=1>Subject Remarks</td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10term2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData.isTerm1> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.allStudentReportData.isTerm1> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=typetermcbse_8to10term2Ctrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan={{typetermcbse_8to10term2Ctrl.card_details.length}}>{{typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typetermcbse_8to10term2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in typetermcbse_8to10term2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['theory_2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['practical_2']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.allStudentReportData> <span ng-if=!typetermcbse_8to10term2Ctrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=typetermcbse_8to10term2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!typetermcbse_8to10term2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=typetermcbse_8to10term2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:40px;border:none> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>{{typePtNoConvCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : typePtNoConvCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr.No</strong></td> <td colspan=1><strong>Student</strong></td> <td colspan=2 ng-repeat=\"bucket in typePtNoConvCtrl.card_details\">Total Mark({{typePtNoConvCtrl.max_mark}})</td> </tr> <tr ng-repeat=\"subjectResult in typePtNoConvCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=2 ng-if=!typePtNoConvCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=2 ng-if=typePtNoConvCtrl.can_published_edit> <md-input-container class=md-block flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports = "<style>md-dialog{padding:5px;border-radius:8px;box-shadow:0 4px 10px rgba(0,0,0,.2);width:700px;margin:auto;overflow:hidden}md-toolbar{background-color:#3f51b5;color:#fff;border-radius:8px 8px 0 0}md-toolbar .md-toolbar-tools{display:flex;justify-content:space-between;align-items:center}md-button.md-icon-button{color:#fff}.scrollable-table-container{max-height:300px;overflow-y:auto;border:1px solid #ddd;border-radius:4px}.styled-table{width:100%;border-collapse:collapse;font-size:16px;text-align:left}.styled-table thead tr{background-color:#1c6ea4;color:#fff;text-transform:uppercase;font-weight:700;padding:5px}.styled-table td,.styled-table th{padding:10px 30px;border:1px solid #ccc;text-align:center}.styled-table tbody tr:nth-child(even){background-color:#f9f9f9}.styled-table tbody tr:hover{background-color:#f1f1f1;cursor:pointer}table.blueTable{border:1px solid #1c6ea4;background-color:#eee;text-align:left;border-collapse:collapse;width:100%}</style> <md-dialog> <md-toolbar> <div class=md-toolbar-tools> <h2>Update Logs</h2> <span flex></span> <md-button class=md-icon-button ng-click=closeDialog()> <md-icon>X</md-icon> </md-button> </div> </md-toolbar> <div class=scrollable-table-container> <table class=\"styled-table blueTable\"> <thead> <tr> <th>#</th> <th>Name</th> <th>Updated On</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in updateLogs track by $index\"> <td>{{$index + 1}}</td> <td>{{item.name}}</td> <td>{{item.updated_on | date: 'yyyy-MM-dd'}}</td> </tr> </tbody> </table> </div> </md-dialog> ";

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type25tcscbseOneFiveCtrl.is_specific && !type25tcscbseOneFiveCtrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.can_published_edit>{{subjectResult.marks['periodic_test']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.can_published_edit>{{subjectResult.marks['note_book']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['half_yearly']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type25tcscbseOneFiveCtrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type25tcscbseOneFiveCtrl.additional_subjects> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.additional_subjects> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.additional_subjects> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type25tcscbseOneFiveCtrl.additional_subjects && type25tcscbseOneFiveCtrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term1 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['term1']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type25tcscbseOneFiveCtrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveCtrl.allStudentReportData.report_card_header.report_card_name}} (Term-1)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveCtrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type25tcscbseOneFiveCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports = " <div class=main_con style=padding-top:0;margin-bottom:50px> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=\"!type25tcscbseOneFiveTerm2Ctrl.is_specific && !type25tcscbseOneFiveTerm2Ctrl.additional_subjects\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveTerm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit>{{subjectResult.marks['periodic_test_2']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.periodic_test_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit>{{subjectResult.marks['note_book_2']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit>{{subjectResult.marks['subject_enrichment_2']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit>{{subjectResult.marks['multiple_assessment_2']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment_2 type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['half_yearly_2']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.half_yearly_2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"type25tcscbseOneFiveTerm2Ctrl.is_specific && subjectResult.marks['term2']\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveTerm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <ng-container ng-if=!type25tcscbseOneFiveTerm2Ctrl.additional_subjects> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.additional_subjects> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.additional_subjects> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.additional_subjects>{{subjectResult.marks['total_mark']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.additional_subjects>{{subjectResult.marks['grade']}}</td> </ng-container> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=\"!subjectResult.marks['term2'] && !type25tcscbseOneFiveTerm2Ctrl.additional_subjects && type25tcscbseOneFiveTerm2Ctrl.is_specific\"> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type25tcscbseOneFiveTerm2Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades 3</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.term2 type=text ng-required=true value=\"\"/> </md-input-container> </span> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['term2']}} </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100% ng-if=type25tcscbseOneFiveTerm2Ctrl.additional_subjects> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=10>{{type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name === \"Report Card for VI-VIII (Term - 2)\" ? \"Annual\" : type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.report_card_header.report_card_name}} (Term-2)</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1><strong>Theory(50)</strong></td> <td colspan=1><strong>Practical(50)</strong></td> <td colspan=1><strong>Total Mks Obt.(50 or 100)</strong></td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type25tcscbseOneFiveTerm2Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['theory']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.theory type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['practical']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.practical type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['total_mark']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.total_mark type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.allStudentReportData> <span ng-if=!type25tcscbseOneFiveTerm2Ctrl.can_published_edit> {{subjectResult.marks['grade']}} </span> <span ng-if=type25tcscbseOneFiveTerm2Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.grade type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1 ng-if=!type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type25tcscbseOneFiveTerm2Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type5_1_2_grade_term1_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type5_1_2_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_1_2_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(50 or 100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_1_2_grade_term1_new26TemplateCtrl.card_details\"> <span ng-if=!type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type5_1_2_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_1_2_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_1_2_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_1_2_grade_term1_new26TemplateCtrl.card_details\"> <span ng-if=!type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_1_2_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_1_2_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type5_1_2_grade_term2_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type5_1_2_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_1_2_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(50 or 100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_1_2_grade_term2_new26TemplateCtrl.card_details\"> <span ng-if=!type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type5_1_2_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_1_2_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_1_2_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_1_2_grade_term2_new26TemplateCtrl.card_details\"> <span ng-if=!type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_1_2_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_1_2_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type5_3_5_grade_term1_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_3_5_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['performance_evaluation']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.performance_evaluation type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type5_3_5_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_3_5_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_3_5_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_3_5_grade_term1_new26TemplateCtrl.card_details\"> <span ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_3_5_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type5_3_5_grade_term2_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_3_5_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['performance_evaluation']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.performance_evaluation type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type5_3_5_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type5_3_5_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type5_3_5_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type5_3_5_grade_term2_new26TemplateCtrl.card_details\"> <span ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type5_3_5_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type5_3_5_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type6_6_7_grade_term1_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6_6_7_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['performance_evaluation']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.performance_evaluation type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type6_6_7_grade_term1_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6_6_7_grade_term1_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6_6_7_grade_term1_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type6_6_7_grade_term1_new26TemplateCtrl.card_details\"> <span ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type6_6_7_grade_term1_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term1_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=type6_6_7_grade_term2_new26TemplateCtrl.showScholasticTable> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6_6_7_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['note_book_submission']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.note_book_submission type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['subject_enrichment']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.subject_enrichment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['multiple_assessment']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.multiple_assessment type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks['performance_evaluation']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks.performance_evaluation type=text ng-required=true value=\"\"> </md-input-container> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;font-size:11px ng-if=type6_6_7_grade_term2_new26TemplateCtrl.is_specific> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type6_6_7_grade_term2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type6_6_7_grade_term2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type6_6_7_grade_term2_new26TemplateCtrl.card_details\"> <span ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit>{{subjectResult.marks[bucket.db_key]}}</span> <span ng-if=type6_6_7_grade_term2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type6_6_7_grade_term2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> </div> ";

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbse_new26TemplateCtrl.showScholasticTable && !type8to10_termcbse_new26TemplateCtrl.is_specific && !type8to10_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type8to10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbse_new26TemplateCtrl.showScholasticTable && type8to10_termcbse_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type8to10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbse_new26TemplateCtrl.showScholasticTable && type8to10_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type8to10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbseterm2_new26TemplateCtrl.showScholasticTable && !type8to10_termcbseterm2_new26TemplateCtrl.is_specific && !type8to10_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbseterm2_new26TemplateCtrl.showScholasticTable && type8to10_termcbseterm2_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type8to10_termcbseterm2_new26TemplateCtrl.showScholasticTable && type8to10_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type8to10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type8to10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type8to10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type8to10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbse_new26TemplateCtrl.showScholasticTable && !type9_termcbse_new26TemplateCtrl.is_specific && !type9_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1)</th> <th colspan=8>{{type9_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbse_new26TemplateCtrl.showScholasticTable && type9_termcbse_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type9_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbse_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbse_new26TemplateCtrl.showScholasticTable && type9_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 1) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type9_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbseterm2_new26TemplateCtrl.showScholasticTable && !type9_termcbseterm2_new26TemplateCtrl.is_specific && !type9_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2)</th> <th colspan=8>{{type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbseterm2_new26TemplateCtrl.showScholasticTable && type9_termcbseterm2_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type9_termcbseterm2_new26TemplateCtrl.showScholasticTable && type9_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (NEW26 TERM 2) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type9_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type9_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type9_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type9_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type9_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbse_new26TemplateCtrl.showScholasticTable && !type10_termcbse_new26TemplateCtrl.is_specific && !type10_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1)</th> <th colspan=8>{{type10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbse_new26TemplateCtrl.showScholasticTable && type10_termcbse_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbse_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbse_new26TemplateCtrl.showScholasticTable && type10_termcbse_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type10_termcbse_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbse_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbse_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbse_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbse_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbse_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbse_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbse_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-rl;-webkit-writing-mode:vertical-rl;transform:rotate(180deg);-webkit-transform:rotate(180deg);white-space:nowrap;display:inline-block;text-align:center;vertical-align:middle!important;font-weight:400}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbseterm2_new26TemplateCtrl.showScholasticTable && !type10_termcbseterm2_new26TemplateCtrl.is_specific && !type10_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2)</th> <th colspan=8>{{type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbseterm2_new26TemplateCtrl.showScholasticTable && type10_termcbseterm2_new26TemplateCtrl.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10_termcbseterm2_new26TemplateCtrl.showScholasticTable && type10_termcbseterm2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td>Total Mks <br/> Obt. <br/> (100) </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10_termcbseterm2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10_termcbseterm2_new26TemplateCtrl.card_details\"> <span ng-if=!type10_termcbseterm2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10_termcbseterm2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10_termcbseterm2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_science_new26TemplateCtrl.showScholasticTable && !type02grade_11_science_new26TemplateCtrl.is_specific && !type02grade_11_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 1)</th> <th colspan=8>{{type02grade_11_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_science_new26TemplateCtrl.showScholasticTable && type02grade_11_science_new26TemplateCtrl.is_specific && !type02grade_11_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type02grade_11_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_science_new26TemplateCtrl.showScholasticTable && type02grade_11_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 1) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type02grade_11_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_sciencet2_new26TemplateCtrl.showScholasticTable && !type02grade_11_sciencet2_new26TemplateCtrl.is_specific && !type02grade_11_sciencet2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 2)</th> <th colspan=8>{{type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_sciencet2_new26TemplateCtrl.showScholasticTable && type02grade_11_sciencet2_new26TemplateCtrl.is_specific && !type02grade_11_sciencet2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_11_sciencet2_new26TemplateCtrl.showScholasticTable && type02grade_11_sciencet2_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 11 SCIENCE - TERM 2) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_11_sciencet2_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_11_sciencet2_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_11_sciencet2_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_11_sciencet2_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_science_new26TemplateCtrl.showScholasticTable && !type02grade_12_science_new26TemplateCtrl.is_specific && !type02grade_12_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 1)</th> <th colspan=8>{{type02grade_12_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_science_new26TemplateCtrl.showScholasticTable && type02grade_12_science_new26TemplateCtrl.is_specific && !type02grade_12_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type02grade_12_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_science_new26TemplateCtrl.showScholasticTable && type02grade_12_science_new26TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 1) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type02grade_12_science_new26TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_science_new26TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_science_new26TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_science_new26TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_science_new26TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_science_new26TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_sciencet2_new_TemplateCtrl.showScholasticTable && !type02grade_12_sciencet2_new_TemplateCtrl.is_specific && !type02grade_12_sciencet2_new_TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 2)</th> <th colspan=8>{{type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_sciencet2_new_TemplateCtrl.showScholasticTable && type02grade_12_sciencet2_new_TemplateCtrl.is_specific && !type02grade_12_sciencet2_new_TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=8>{{type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type02grade_12_sciencet2_new_TemplateCtrl.showScholasticTable && type02grade_12_sciencet2_new_TemplateCtrl.additional_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT (GRADE 12 SCIENCE - TERM 2) - ADDITIONAL SUBJECTS</th> <th colspan=8>{{type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{oneBucket.max_mark}})</strong> </td> <td>Total Mks<br/>Obt.<br/>(100)</td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type02grade_12_sciencet2_new_TemplateCtrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type02grade_12_sciencet2_new_TemplateCtrl.card_details\"> <span ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type02grade_12_sciencet2_new_TemplateCtrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['total_mark']}}</td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type02grade_12_sciencet2_new_TemplateCtrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> ";

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm1New26Ctrl.showScholasticTable && type10KbGradeTerm1New26Ctrl.content_mngr.subject_80_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1)</th> <th colspan=5>{{type10KbGradeTerm1New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm1New26Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm1New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm1New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm1New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm1New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm1New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm1New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm1New26Ctrl.showScholasticTable && type10KbGradeTerm1New26Ctrl.content_mngr.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1) - SPECIFIC SUBJECTS</th> <th colspan=5>{{type10KbGradeTerm1New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm1New26Ctrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm1New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm1New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm1New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm1New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm1New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm1New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm1New26Ctrl.showScholasticTable && type10KbGradeTerm1New26Ctrl.content_mngr.subject_40_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 1) - 40 MARK SUBJECTS</th> <th colspan=5>{{type10KbGradeTerm1New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm1New26Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm1New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm1New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm1New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm1New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm1New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm1New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div>";

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}.input_width{display:flex!important;align-items:center!important;justify-content:center!important;height:100%!important}</style> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm2New26Ctrl.showScholasticTable && type10KbGradeTerm2New26Ctrl.content_mngr.subject_80_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2)</th> <th colspan=5>{{type10KbGradeTerm2New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm2New26Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm2New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm2New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm2New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm2New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm2New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm2New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm2New26Ctrl.showScholasticTable && type10KbGradeTerm2New26Ctrl.content_mngr.is_specific\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2) - SPECIFIC SUBJECTS</th> <th colspan=5>{{type10KbGradeTerm2New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm2New26Ctrl.card_details\"> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm2New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm2New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm2New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm2New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm2New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm2New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0;margin-bottom:50px ng-if=\"type10KbGradeTerm2New26Ctrl.showScholasticTable && type10KbGradeTerm2New26Ctrl.content_mngr.subject_40_subjects\"> <div class=full_width> <table id=table-example-1 style=width:100%;font-size:11px> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT (GRADE 10 - TERM 2) - 40 MARK SUBJECTS</th> <th colspan=5>{{type10KbGradeTerm2New26Ctrl.allStudentReportData.report_card_header.report_card_name}}</th> </tr> </thead> <thead> <tr> <td colspan=1><strong>Sr. No.</strong></td> <td colspan=1><strong>Students</strong></td> <td colspan=1 ng-repeat=\"oneBucket in type10KbGradeTerm2New26Ctrl.card_details\"> <br/> <strong>{{oneBucket.name}}({{ oneBucket.max_mark}})</strong> </td> <td colspan=1><strong>Grades</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"subjectResult in type10KbGradeTerm2New26Ctrl.allStudentReportData.results\"> <td colspan=1><strong>{{$index+1}}</strong></td> <td colspan=1><strong>{{subjectResult.student_name}}</strong></td> <td colspan=1 ng-repeat=\"bucket in type10KbGradeTerm2New26Ctrl.card_details\"> <span ng-if=!type10KbGradeTerm2New26Ctrl.can_published_edit> {{subjectResult.marks[bucket.db_key]}} </span> <span ng-if=type10KbGradeTerm2New26Ctrl.can_published_edit> <md-input-container class=\"md-block input_width\" flex-gt-sm> <input maxlength=6 ng-model=subjectResult.marks[bucket.db_key] type=text ng-required=true value=\"\"> </md-input-container> </span> </td> <td colspan=1>{{subjectResult.marks['grade']}}</td> <td colspan=1 ng-if=!type10KbGradeTerm2New26Ctrl.sendForApprovalFlag>{{subjectResult.marks['remarks']}}</td> <td colspan=1 ng-if=type10KbGradeTerm2New26Ctrl.sendForApprovalFlag> <md-input-container class=md-block flex-gt-sm> <input maxlength=100 ng-model=subjectResult.marks.remarks type=text ng-required=true value=\"\"> </md-input-container> </td> </tr> </thead> </table> </div> </div>";

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _approveReportsController = __webpack_require__(369);

var _approveReportsController2 = _interopRequireDefault(_approveReportsController);

var _approveReports = __webpack_require__(126);

var _approveReports2 = _interopRequireDefault(_approveReports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('approveReports', {
//             parent: 'app',
//             url: '/report-card-approvals',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'reportCardApprovalCtrl'
//                 }
//             }
//         })

// });
var _module = angular.module('ApproveReportsModule', [
  //import modules
]).controller('approveReports', _approveReportsController2.default); /**
                                                                      * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/approveReportsModule.js
                                                                      * Project: /home/cordova03/projects/educore_3.5
                                                                      * Created Date: Monday, December 10th 2018, 12:02:16 pm
                                                                      * Author: Naveen Nazimudeen N
                                                                      * -----
                                                                      * Last Modified: Mon Dec 10 2018
                                                                      * Modified By: Naveen Nazimudeen N
                                                                      * -----
                                                                      * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                      * ------------------------------------
                                                                      */

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _publishedReport = __webpack_require__(129);

var _publishedReport2 = _interopRequireDefault(_publishedReport);

var _publishedReportController = __webpack_require__(373);

var _publishedReportController2 = _interopRequireDefault(_publishedReportController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('PublishedReportModule', [
  //import modules
]).controller('publishedReports', _publishedReportController2.default);

// module.constant('pulishedReportCardConstants', {
//     NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG'],
// })
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('publishedReports', {
//             parent: 'app',
//             url: '/published-reports/:student_id/:fee_status',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'publishedReportsListCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _publishReport = __webpack_require__(125);

var _publishReport2 = _interopRequireDefault(_publishReport);

var _publishReportController = __webpack_require__(368);

var _publishReportController2 = _interopRequireDefault(_publishReportController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/client/src/app/report_cards/publish_reports/publishReportModule.js
 * Project: /home/cordova03/projects/educore_3.5/client
 * Created Date: Thursday, December 13th 2018, 1:21:09 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Thu Dec 13 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var _module = angular.module('PublishReportModule', [
    //import modules
]);

var _module = angular.module('publishReports', [
    //import modules
]);
_module.constant('pulishedReportCardConstants', {
    NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG']
}).controller('publishReports', _publishReportController2.default);

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('publishReports', {
//             parent: 'app',
//             url: '/publish-reports',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'publishReportCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


config.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
	value: true
});

var _publishedMain = __webpack_require__(1134);

var _publishedMain2 = _interopRequireDefault(_publishedMain);

var _type1Hf = __webpack_require__(1136);

var _type1Hf2 = _interopRequireDefault(_type1Hf);

var _periodicTestHf = __webpack_require__(1137);

var _periodicTestHf2 = _interopRequireDefault(_periodicTestHf);

var _periodicTestAnnual = __webpack_require__(1138);

var _periodicTestAnnual2 = _interopRequireDefault(_periodicTestAnnual);

var _defaultYearEnd = __webpack_require__(1139);

var _defaultYearEnd2 = _interopRequireDefault(_defaultYearEnd);

var _skillSubskill = __webpack_require__(1140);

var _skillSubskill2 = _interopRequireDefault(_skillSubskill);

var _educoreYearEnd = __webpack_require__(1141);

var _educoreYearEnd2 = _interopRequireDefault(_educoreYearEnd);

var _type4Mark = __webpack_require__(1142);

var _type4Mark2 = _interopRequireDefault(_type4Mark);

var _type4Annual = __webpack_require__(1143);

var _type4Annual2 = _interopRequireDefault(_type4Annual);

var _term1Term = __webpack_require__(1144);

var _term1Term2 = _interopRequireDefault(_term1Term);

var _periodicTestHf3 = __webpack_require__(1145);

var _periodicTestHf4 = _interopRequireDefault(_periodicTestHf3);

var _periodicTestAnnualTwo = __webpack_require__(1146);

var _periodicTestAnnualTwo2 = _interopRequireDefault(_periodicTestAnnualTwo);

var _kbTerms = __webpack_require__(1147);

var _kbTerms2 = _interopRequireDefault(_kbTerms);

var _kgTerms = __webpack_require__(1148);

var _kgTerms2 = _interopRequireDefault(_kgTerms);

var _kgConsolidated = __webpack_require__(1149);

var _kgConsolidated2 = _interopRequireDefault(_kgConsolidated);

var _hssTemplate = __webpack_require__(1150);

var _hssTemplate2 = _interopRequireDefault(_hssTemplate);

var _cbse_hss = __webpack_require__(1151);

var _cbse_hss2 = _interopRequireDefault(_cbse_hss);

var _term1halfyearly = __webpack_require__(1152);

var _term1halfyearly2 = _interopRequireDefault(_term1halfyearly);

var _kbhfhss = __webpack_require__(1153);

var _kbhfhss2 = _interopRequireDefault(_kbhfhss);

var _grade9Annual = __webpack_require__(1154);

var _grade9Annual2 = _interopRequireDefault(_grade9Annual);

var _grade1_8Annual = __webpack_require__(1155);

var _grade1_8Annual2 = _interopRequireDefault(_grade1_8Annual);

var _kb_final = __webpack_require__(1156);

var _kb_final2 = _interopRequireDefault(_kb_final);

var _annual_cbse_hss = __webpack_require__(1157);

var _annual_cbse_hss2 = _interopRequireDefault(_annual_cbse_hss);

var _termAnnualOnly = __webpack_require__(1158);

var _termAnnualOnly2 = _interopRequireDefault(_termAnnualOnly);

var _kb_hss_annual = __webpack_require__(1159);

var _kb_hss_annual2 = _interopRequireDefault(_kb_hss_annual);

var _montessoryTerms = __webpack_require__(1160);

var _montessoryTerms2 = _interopRequireDefault(_montessoryTerms);

var _montessoryConsolidated = __webpack_require__(1161);

var _montessoryConsolidated2 = _interopRequireDefault(_montessoryConsolidated);

var _periodicTestHfKb = __webpack_require__(1162);

var _periodicTestHfKb2 = _interopRequireDefault(_periodicTestHfKb);

var _hf1Exam = __webpack_require__(1163);

var _hf1Exam2 = _interopRequireDefault(_hf1Exam);

var _type5_9_10_grade_term = __webpack_require__(1164);

var _type5_9_10_grade_term2 = _interopRequireDefault(_type5_9_10_grade_term);

var _type5_KB_10_grade_term = __webpack_require__(1165);

var _type5_KB_10_grade_term2 = _interopRequireDefault(_type5_KB_10_grade_term);

var _type5_1_5_grade_term = __webpack_require__(1166);

var _type5_1_5_grade_term2 = _interopRequireDefault(_type5_1_5_grade_term);

var _type5_KB_8_9_grade_term = __webpack_require__(1167);

var _type5_KB_8_9_grade_term2 = _interopRequireDefault(_type5_KB_8_9_grade_term);

var _type_6_model_exam_ = __webpack_require__(1168);

var _type_6_model_exam_2 = _interopRequireDefault(_type_6_model_exam_);

var _type_6_model_exam_1_nineten = __webpack_require__(1169);

var _type_6_model_exam_1_nineten2 = _interopRequireDefault(_type_6_model_exam_1_nineten);

var _type_6_model_exam_2_nineten = __webpack_require__(1170);

var _type_6_model_exam_2_nineten2 = _interopRequireDefault(_type_6_model_exam_2_nineten);

var _type_6_model_exam_3 = __webpack_require__(1171);

var _type_6_model_exam_4 = _interopRequireDefault(_type_6_model_exam_3);

var _type_6_model_annualexam_ = __webpack_require__(1172);

var _type_6_model_annualexam_2 = _interopRequireDefault(_type_6_model_annualexam_);

var _calicut_annual = __webpack_require__(1173);

var _calicut_annual2 = _interopRequireDefault(_calicut_annual);

var _kgThematicterms = __webpack_require__(1174);

var _kgThematicterms2 = _interopRequireDefault(_kgThematicterms);

var _type9_term1_hf = __webpack_require__(1175);

var _type9_term1_hf2 = _interopRequireDefault(_type9_term1_hf);

var _type9_cbse_pt = __webpack_require__(1176);

var _type9_cbse_pt2 = _interopRequireDefault(_type9_cbse_pt);

var _type9_grade12term2_ae = __webpack_require__(1177);

var _type9_grade12term2_ae2 = _interopRequireDefault(_type9_grade12term2_ae);

var _type9_kb_unit_test = __webpack_require__(1178);

var _type9_kb_unit_test2 = _interopRequireDefault(_type9_kb_unit_test);

var _type9_kbterm = __webpack_require__(1179);

var _type9_kbterm2 = _interopRequireDefault(_type9_kbterm);

var _type12_termcbse = __webpack_require__(1180);

var _type12_termcbse2 = _interopRequireDefault(_type12_termcbse);

var _type12_ninetentermcbse = __webpack_require__(1181);

var _type12_ninetentermcbse2 = _interopRequireDefault(_type12_ninetentermcbse);

var _elt_report = __webpack_require__(1182);

var _elt_report2 = _interopRequireDefault(_elt_report);

var _type20_KB_10_grade_term = __webpack_require__(1183);

var _type20_KB_10_grade_term2 = _interopRequireDefault(_type20_KB_10_grade_term);

var _type20_termcbse = __webpack_require__(1184);

var _type20_termcbse2 = _interopRequireDefault(_type20_termcbse);

var _type20_termcbse3 = __webpack_require__(1185);

var _type20_termcbse4 = _interopRequireDefault(_type20_termcbse3);

var _type20_KB_10_grade_term3 = __webpack_require__(1186);

var _type20_KB_10_grade_term4 = _interopRequireDefault(_type20_KB_10_grade_term3);

var _type20_term2cbse = __webpack_require__(1187);

var _type20_term2cbse2 = _interopRequireDefault(_type20_term2cbse);

var _type20_term2cbse3 = __webpack_require__(1188);

var _type20_term2cbse4 = _interopRequireDefault(_type20_term2cbse3);

var _type8to10_termcbse = __webpack_require__(1189);

var _type8to10_termcbse2 = _interopRequireDefault(_type8to10_termcbse);

var _typetermcbse_8to = __webpack_require__(1190);

var _typetermcbse_8to2 = _interopRequireDefault(_typetermcbse_8to);

var _type6to7_alncbse = __webpack_require__(1191);

var _type6to7_alncbse2 = _interopRequireDefault(_type6to7_alncbse);

var _type6to7_tcscbse = __webpack_require__(1192);

var _type6to7_tcscbse2 = _interopRequireDefault(_type6to7_tcscbse);

var _type3to5_tcscbse = __webpack_require__(1193);

var _type3to5_tcscbse2 = _interopRequireDefault(_type3to5_tcscbse);

var _type3to5_alncbse = __webpack_require__(1194);

var _type3to5_alncbse2 = _interopRequireDefault(_type3to5_alncbse);

var _type1to2_tcscbse = __webpack_require__(1195);

var _type1to2_tcscbse2 = _interopRequireDefault(_type1to2_tcscbse);

var _type5_6_8_grade_term = __webpack_require__(1196);

var _type5_6_8_grade_term2 = _interopRequireDefault(_type5_6_8_grade_term);

var _type5_6_7_grade_term = __webpack_require__(1197);

var _type5_6_7_grade_term2 = _interopRequireDefault(_type5_6_7_grade_term);

var _type6_1_2_grade_term = __webpack_require__(1198);

var _type6_1_2_grade_term2 = _interopRequireDefault(_type6_1_2_grade_term);

var _type6_6_7_grade_term = __webpack_require__(1199);

var _type6_6_7_grade_term2 = _interopRequireDefault(_type6_6_7_grade_term);

var _type6_3_5_grade_term = __webpack_require__(1200);

var _type6_3_5_grade_term2 = _interopRequireDefault(_type6_3_5_grade_term);

var _type5_1_2_grade_term = __webpack_require__(1201);

var _type5_1_2_grade_term2 = _interopRequireDefault(_type5_1_2_grade_term);

var _type5_3_5_grade_term = __webpack_require__(1202);

var _type5_3_5_grade_term2 = _interopRequireDefault(_type5_3_5_grade_term);

var _type5_8_grade_term = __webpack_require__(1203);

var _type5_8_grade_term2 = _interopRequireDefault(_type5_8_grade_term);

var _type7_1_2_grade_term = __webpack_require__(1204);

var _type7_1_2_grade_term2 = _interopRequireDefault(_type7_1_2_grade_term);

var _type30_KB_8_9_grade_term = __webpack_require__(1205);

var _type30_KB_8_9_grade_term2 = _interopRequireDefault(_type30_KB_8_9_grade_term);

var _type10_KB_grade_term = __webpack_require__(1206);

var _type10_KB_grade_term2 = _interopRequireDefault(_type10_KB_grade_term);

var _type10_KB_grade11_12_term = __webpack_require__(1207);

var _type10_KB_grade11_12_term2 = _interopRequireDefault(_type10_KB_grade11_12_term);

var _type10_KB_grade11_12_term1_new = __webpack_require__(1208);

var _type10_KB_grade11_12_term1_new2 = _interopRequireDefault(_type10_KB_grade11_12_term1_new);

var _type02grade_11_science = __webpack_require__(1209);

var _type02grade_11_science2 = _interopRequireDefault(_type02grade_11_science);

var _type02grade_11_science_noModelExam = __webpack_require__(1210);

var _type02grade_11_science_noModelExam2 = _interopRequireDefault(_type02grade_11_science_noModelExam);

var _type02grade_12_science = __webpack_require__(1211);

var _type02grade_12_science2 = _interopRequireDefault(_type02grade_12_science);

var _pt_1_no_conv = __webpack_require__(1212);

var _pt_1_no_conv2 = _interopRequireDefault(_pt_1_no_conv);

var _type5_3_5_grade_term3 = __webpack_require__(1213);

var _type5_3_5_grade_term4 = _interopRequireDefault(_type5_3_5_grade_term3);

var _type6_6_7_grade_term3 = __webpack_require__(1214);

var _type6_6_7_grade_term4 = _interopRequireDefault(_type6_6_7_grade_term3);

var _type8to10_termcbse3 = __webpack_require__(1215);

var _type8to10_termcbse4 = _interopRequireDefault(_type8to10_termcbse3);

var _type5_1_2_grade_term3 = __webpack_require__(1216);

var _type5_1_2_grade_term4 = _interopRequireDefault(_type5_1_2_grade_term3);

var _type1to5_tcscbse_new = __webpack_require__(1217);

var _type1to5_tcscbse_new2 = _interopRequireDefault(_type1to5_tcscbse_new);

var _type5_1_2_grade_term1_new = __webpack_require__(1218);

var _type5_1_2_grade_term1_new2 = _interopRequireDefault(_type5_1_2_grade_term1_new);

var _type5_3_5_grade_term1_new = __webpack_require__(1219);

var _type5_3_5_grade_term1_new2 = _interopRequireDefault(_type5_3_5_grade_term1_new);

var _type6_6_7_grade_term1_new = __webpack_require__(1220);

var _type6_6_7_grade_term1_new2 = _interopRequireDefault(_type6_6_7_grade_term1_new);

var _type5_1_2_grade_term2_new = __webpack_require__(1221);

var _type5_1_2_grade_term2_new2 = _interopRequireDefault(_type5_1_2_grade_term2_new);

var _type5_3_5_grade_term2_new = __webpack_require__(1222);

var _type5_3_5_grade_term2_new2 = _interopRequireDefault(_type5_3_5_grade_term2_new);

var _type6_6_7_grade_term2_new = __webpack_require__(1223);

var _type6_6_7_grade_term2_new2 = _interopRequireDefault(_type6_6_7_grade_term2_new);

var _type8to10_termcbse_new = __webpack_require__(1224);

var _type8to10_termcbse_new2 = _interopRequireDefault(_type8to10_termcbse_new);

var _type8to10_termcbseterm2_new = __webpack_require__(1225);

var _type8to10_termcbseterm2_new2 = _interopRequireDefault(_type8to10_termcbseterm2_new);

var _type9_termcbse_new = __webpack_require__(1226);

var _type9_termcbse_new2 = _interopRequireDefault(_type9_termcbse_new);

var _type9_termcbseterm2_new = __webpack_require__(1227);

var _type9_termcbseterm2_new2 = _interopRequireDefault(_type9_termcbseterm2_new);

var _type10_termcbse_new = __webpack_require__(1228);

var _type10_termcbse_new2 = _interopRequireDefault(_type10_termcbse_new);

var _type10_termcbseterm2_new = __webpack_require__(1229);

var _type10_termcbseterm2_new2 = _interopRequireDefault(_type10_termcbseterm2_new);

var _type10_KB_grade_term1_new = __webpack_require__(1230);

var _type10_KB_grade_term1_new2 = _interopRequireDefault(_type10_KB_grade_term1_new);

var _type10_KB_grade_term2_new = __webpack_require__(1231);

var _type10_KB_grade_term2_new2 = _interopRequireDefault(_type10_KB_grade_term2_new);

var _type02grade_11_science_new = __webpack_require__(1232);

var _type02grade_11_science_new2 = _interopRequireDefault(_type02grade_11_science_new);

var _type02grade_11_sciencet2_new = __webpack_require__(1233);

var _type02grade_11_sciencet2_new2 = _interopRequireDefault(_type02grade_11_sciencet2_new);

var _type02grade_12_science_new = __webpack_require__(1234);

var _type02grade_12_science_new2 = _interopRequireDefault(_type02grade_12_science_new);

var _type02grade_12_sciencet2_new = __webpack_require__(1235);

var _type02grade_12_sciencet2_new2 = _interopRequireDefault(_type02grade_12_sciencet2_new);

var _type5_1_2_grade_term1_new26_shj = __webpack_require__(1236);

var _type5_1_2_grade_term1_new26_shj2 = _interopRequireDefault(_type5_1_2_grade_term1_new26_shj);

var _type5_1_2_grade_term2_new26_shj = __webpack_require__(1237);

var _type5_1_2_grade_term2_new26_shj2 = _interopRequireDefault(_type5_1_2_grade_term2_new26_shj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
// ===== NEW26: Import =====

// ===== END NEW26 =====


// ===== NEW26: Imports Section Start =====
//NEW26 Imports

//TERM 1


var term1TemplatepublishedType6_6_7_templateNew26 = _type6_6_7_grade_term1_new2.default; // alias for term1 component

//TERM 2


//8-10 NEW26
//TERM 1

//TERM 2


//8-10 NEW26 Constants
var termoneTemplatepublishedTypeEightToTenNew26 = "termoneTemplatepublishedTypeEightToTenNew26";
var publishedTypeEightToTenNew26Term2 = "publishedTypeEightToTenNew26Term2";

//Grade 9 NEW26
//TERM 1

//TERM 2


//Grade 9 NEW26 Constants
var termoneTemplatepublishedTypeNineTermCbseNew26 = "termoneTemplatepublishedTypeNineTermCbseNew26";
var publishedTypeNineTermCbseNew26Term2 = "publishedTypeNineTermCbseNew26Term2";

//Grade 10 NEW26
//TERM 1

//TERM 2


//Grade 10 NEW26 Constants
var termoneTemplatepublishedTypeTenTermCbseNew26 = "termoneTemplatepublishedTypeTenTermCbseNew26";
var publishedTypeTenTermCbseNew26Term2 = "publishedTypeTenTermCbseNew26Term2";

//Grade 10 Kerala Board NEW26
//TERM 1

//TERM 2


//Grade 10 Kerala Board NEW26 Constants
var termoneTemplatepublishedType10KbGradeTerm1New26 = "termoneTemplatepublishedType10KbGradeTerm1New26";
var publishedType10KbGradeTerm2New26 = "publishedType10KbGradeTerm2New26";

//Grade 11 NEW26
//TERM 1

//TERM 2


//Grade 11 NEW26 Constants
var termoneTemplatepublishedTypeZeroTwoGradeElevenScienceNew26 = "termoneTemplatepublishedTypeZeroTwoGradeElevenScienceNew26";
var publishedTypeZeroTwoGradeElevenScienceNew26Term2 = "publishedTypeZeroTwoGradeElevenScienceNew26Term2";

//Grade 12 NEW26
//TERM 1

//TERM 2


//Grade 12 NEW26 Constants
var termoneTemplatepublishedTypeZeroTwoGradeTwelveScienceNew26 = "termoneTemplatepublishedTypeZeroTwoGradeTwelveScienceNew26";
var publishedTypeZeroTwoGradeTwelveScienceNew26Term2 = "publishedTypeZeroTwoGradeTwelveScienceNew26Term2";
// SHJ

// ===== END NEW26: Imports/Constants =====

var name = "reportsMainComponent";

var PublishedReportsListCtrl = function PublishedReportsListCtrl($scope, $state, $rootScope, $stateParams, $mdDialog, $sce, CONSTANTS, localStorageService, authService, rcConstants, RC_CONSTANTS_) {
	"ngInject";

	_classCallCheck(this, PublishedReportsListCtrl);

	$rootScope.attendance_save_not = false;
	var self = this;
	$scope.loading = true;
	$scope.typeOneHF = false;
	$scope.typeOneGrade = false;
	$scope.typeTwoMark = false;
	$scope.typeThreeSubSkill = false;
	$scope.assetHF = false;
	$scope.assetAnnual = false;
	$scope.term1term2 = false;
	$scope.defaultPtHfTwo = false;
	$scope.defaultPtAnnualTwo = false;
	$scope.gradeNineFinal = false;
	$scope.publishedoneeight = false;
	$scope.attendance = undefined;
	$scope.mepStatic = false;
	$scope.annualKbTemp = false;
	$scope.montessoryTerms = false;
	$scope.montessoryConsolidate = false;
	$scope.ptHfKbPublished = false;
	$scope.hfExamOne = false;

	$scope.publishedType5_9_10 = false;
	$scope.publishedType5_KB_10 = false;
	$scope.type5_6_8_grade_terms = false;
	$scope.type5_6_7_grade_terms = false;

	$scope.type6_6_7_grade_terms = false;
	$scope.type6_3_5_grade_terms = false;

	$scope.type5_3_5_grade_terms = false;
	$scope.type5_8_grade_terms = false;
	$scope.type5_1_5_grade_terms = false;
	$scope.type6_1_2_grade_terms = false;
	$scope.type5_1_2_grade_terms = false;
	$scope.type5_KB_8_9_grade_term3 = false;

	$scope.type6_modelExamOne = false;
	$scope.type_6_model_exam_1_nineten = false;
	$scope.type_6_model_exam_II_nineten = false;
	$scope.type6_modelExamTwoNospace = false;
	$scope.type6_modelAnnualExamTerm = false;

	$scope.kgthematictermsFlag = false;
	$scope.publishedtype_seven_calicut_annual = false;
	$scope.type9_cbse_pt1 = false;
	$scope.type9_term1_hf = false;
	$scope.type9_grade12term2_ae = false;
	$scope.type9_kb_unit_test1 = false;
	$scope.type9_kbterm3 = false;
	$scope.publishedTypeTwelveOneEight = false;
	$scope.type12_ninetentermcbse = false;
	$scope.elt_report = false;
	$scope.type20_KB_10_grade_term = false;
	$scope.publishedTypeTwentyNineTen = false;
	$scope.publishedTypeTwentyOneEight = false;
	$scope.publishedTypeTwentyTwoNineTen = false;
	$scope.publishedTypeTwentyOneEightTwo = false;
	$scope.publishedTypeEightToTen = false;
	$scope.publishedTypeEightToTen2 = false;
	$scope.publishedTypeSixToSeven = false;
	$scope.publishedTypeSixDXB = false;
	$scope.publishedTypeThreeDXB = false;
	$scope.publishedTypeDXB = false;
	$scope.publishedTypeSixToSeven2 = false;
	$scope.publishedTypeThreeToFive = false;
	$scope.publishedTypeThreeToFive2 = false;
	$scope.publishedTypeOneToTwo = false;
	$scope.PublishedTypesevenOneTwo = false;
	$scope.publishedType30KB78 = false;
	$scope.publishedType10KB = false;
	$scope.publishedType10KBElevenTwelve = false;
	// ===== NEW26: Scope Flags Start =====
	$scope.publishedType10KBElevenTwelveNew26 = false;
	$scope.publishedTypeElevenScience = false;
	$scope.publishedTypeElevenScienceNoModel = false;
	$scope.publishedTypeTwelveScience = false;
	$scope.T1type5_3_5_grade_terms = false;
	$scope.T1type6_6_7_grade_terms = false;
	$scope.T1type8_9_grade_terms = false;
	$scope.T1type1_2_grade_terms = false;
	$scope.pt_1_no_conv = false;
	$scope.publishedtcsOneFivetemplate = false;

	//NEW26 — Scope flags & new26Templates function

	$scope.new26Templates = function () {
		return $scope.T1type1_2_grade_terms_new26 || $scope.type5_1_2_grade_terms_new26 || $scope.T1type5_3_5_grade_terms_new26 || $scope.type5_3_5_grade_terms_new26 || $scope.T1type6_6_7_grade_terms_new26 || $scope.type6_6_7_grade_terms_new26 || $scope.T1type8to10_grade_terms_new26 || $scope.type8to10_grade_terms_new26 || $scope.T1type02grade_11_science_new26 || $scope.type02grade_11_science_new26 || $scope.T1type02grade_12_science_new26 || $scope.type02grade_12_science_new26 || $scope.T1type9_grade_terms_new26 || $scope.type9_grade_terms_new26 || $scope.T1type10_grade_terms_new26 || $scope.type10_grade_terms_new26 || $scope.T1type10_KB_grade_term1_new26 || $scope.type10_KB_grade_term2_new26 || $scope.publishedType10KBElevenTwelveNew26 || $scope.T1type1_2_grade_terms_new26_shj || $scope.type5_1_2_grade_terms_new26_shj_term2;
	};

	$scope.new26Term1Templates = function () {
		return $scope.T1type1_2_grade_terms_new26 || $scope.T1type5_3_5_grade_terms_new26 || $scope.T1type6_6_7_grade_terms_new26 || $scope.T1type8to10_grade_terms_new26 || $scope.T1type02grade_11_science_new26 || $scope.T1type02grade_12_science_new26 || $scope.T1type9_grade_terms_new26 || $scope.T1type10_grade_terms_new26 || $scope.T1type10_KB_grade_term1_new26 || $scope.T1type1_2_grade_terms_new26_shj;
	};

	// NEW26 DXB student header — uses updated field labels (Name of the student, Admission Number, Roll Number, GRADE & Division)
	$scope.new26DXBStudentHeader = function () {
		return $scope.new26Templates() || $scope.publishedTypeDXB || $scope.publishedTypeThreeDXB || $scope.publishedTypeSixDXB;
	};

	//NEW26 — Variable initializations

	$scope.T1type5_3_5_grade_terms_new26 = false;
	$scope.T1type6_6_7_grade_terms_new26 = false;
	$scope.T1type1_2_grade_terms_new26 = false;
	$scope.T1type8to10_grade_terms_new26 = false;
	$scope.type6_6_7_grade_terms_new26 = false;
	$scope.type5_3_5_grade_terms_new26 = false;
	$scope.type5_3_5_grade_terms_new26_term2 = false;
	$scope.type5_1_2_grade_terms_new26 = false;
	$scope.type5_1_2_grade_terms_new26_term2 = false;
	$scope.T1type1_2_grade_terms_new26_shj = false;
	$scope.type5_1_2_grade_terms_new26_shj_term2 = false;
	$scope.type8to10_grade_terms_new26 = false;
	$scope.T1type02grade_12_science_new26 = false;
	$scope.type02grade_12_science_new26 = false;
	$scope.T1type02grade_11_science_new26 = false;
	$scope.type02grade_11_science_new26 = false;
	$scope.T1type9_grade_terms_new26 = false;
	$scope.type9_grade_terms_new26 = false;
	$scope.T1type10_grade_terms_new26 = false;
	$scope.type10_grade_terms_new26 = false;
	$scope.T1type10_KB_grade_term1_new26 = false;
	$scope.type10_KB_grade_term2_new26 = false;
	// ===== END NEW26: Scope Flags =====
	var classTeacher = localStorageService.get("classTeacherRole");
	if (classTeacher == true) {
		$rootScope.isTeachingStaff = true;
	} else {
		$rootScope.isTeachingStaff = false;
	}
	var attendance_save_not = localStorageService.get("attendance_save_not");
	if (attendance_save_not) {
		$rootScope.attendance_save_not = true;
	}
	var school_id = localStorageService.get("school_id");
	if (!$stateParams.selected_year) {
		$state.go("dashboard");
	}
	var stuReportDataSub = undefined;

	this.$onInit = function () {
		//     console.log(localStorageService.get('parent_user_access','---------------------' )
		//    )
		$rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
		if (!$rootScope.isLoggedIn) {
			$state.go("login", {}, { reload: true });
		}
		pushLog();
	};

	this.$onDestroy = function () {
		if (stuReportDataSub) stuReportDataSub.stop();
	};

	console.log(localStorageService.get("role_ids"));
	var requestBody = {
		studentId: $stateParams.student_id,
		rc_id: $stateParams.console_id,
		is_consolidated: $stateParams.type == "true" ? true : false,
		pdfFalg: false,
		school_id: school_id,
		template_view: $stateParams.template_view,
		asset_format: $stateParams.asset_format == "true" ? true : false,
		yearFromClient: $stateParams.selected_year,
		kb_consolidatedFlag: $stateParams.kb_consolidated == "true" ? true : false,
		forCT: classTeacher ? true : false,
		FILE_UPLOAD_URL: CONSTANTS.FILE_UPLOAD_URL,
		SITE_URL: CONSTANTS.SITE_URL,
		clientFileServer: CONSTANTS.FILE_UPLOAD_URL,
		kg_consolidated: $stateParams.kg_consolidated == "true" ? true : false,
		montessori_consolidated: $stateParams.montessori_consolidated == "true" ? true : false,
		is_web: true,
		parent_status: localStorageService.get("role_ids").indexOf("Rt4ZwrDRxw8Zwer6aC") !== -1 ? true : false,
		student_status: localStorageService.get("role_ids").indexOf("student") !== -1 ? true : false
	};
	function loadReport(requestBody) {
		var isSaveEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		console.log(requestBody, "requestBody");
		$rootScope.attendance = undefined;
		$rootScope.house = undefined;
		$rootScope.height = undefined;
		$rootScope.weight = undefined;
		$rootScope.bmi = undefined;
		$rootScope.working_days = undefined;
		$rootScope.selectedLevel = undefined;

		$rootScope.days_attended = undefined;
		$rootScope.term_remarks = undefined;
		$rootScope.attendance_term1 = undefined;

		$rootScope.attendance_term2 = undefined;
		$rootScope.lifeskillselection = undefined;
		$rootScope.attitudeselection = undefined;
		$rootScope.attitudeDataByIndex = undefined;
		$rootScope.lifeskillDataByIndex = undefined;
		$rootScope.attendance68_term1 = undefined;
		$rootScope.attendance68_term2 = undefined;
		$rootScope.attendanceKb89_term1 = undefined;
		$rootScope.attendanceKb89_term2 = undefined;
		$rootScope.attendanceKb89_term3 = undefined;
		$rootScope.attendanceKb10_term1 = undefined;
		$rootScope.attendanceKb10_term2 = undefined;
		$rootScope.StdResult = undefined;
		$rootScope.StdPromotGrade = undefined;
		$rootScope.StdReportDate = undefined;
		$rootScope.term_remarks1 = undefined;
		$rootScope.promoted_to = undefined;
		$rootScope.term_remarks2 = undefined;
		$rootScope.attitudeselction = undefined;
		$rootScope.lifeskillselction = undefined;
		$rootScope.attendancetenKb10_term1 = undefined;
		$rootScope.attendancetenKb10_term2 = undefined;
		$rootScope.published_date = undefined;
		authService.callAPI("/v0/reportcards/published/getReportCardPublished", "POST", { args: requestBody }, function (response) {
			try {
				var result = response.result.data.details.response;
				console.log(result);
				console.log(response, "iiiiiiiiiiiiiiii");
				if (!result.error) {
					if (isSaveEvent) {
						toastr.success("Report Saved successfully");
					}
					if (result.attendance) {
						$rootScope.attendance = result.attendance;
					}
					if (result.extra_info) {
						if (result.extra_info.house) {
							$rootScope.house = result.extra_info.house;
						}
						if (result.extra_info.height) {
							$rootScope.height = result.extra_info.height;
						}
						if (result.extra_info.weight) {
							$rootScope.weight = result.extra_info.weight;
						}
						if (result.extra_info.bmi) {
							$rootScope.bmi = result.extra_info.bmi;
						}
						if (result.extra_info.working_days) {
							$rootScope.working_days = result.extra_info.working_days;
						}
						if (result.extra_info.days_attended) {
							$rootScope.days_attended = result.extra_info.days_attended;
						}
						if (result.extra_info.attendance_term1) {
							$rootScope.attendance_term1 = result.extra_info.attendance_term1;
						}
						if (result.extra_info.attendance_term2) {
							$rootScope.attendance_term2 = result.extra_info.attendance_term2;
						}
						if (result.extra_info.attendance68_term1) {
							$rootScope.attendance68_term1 = result.extra_info.attendance68_term1;
						}

						if (result.extra_info.attendance68_term2) {
							$rootScope.attendance68_term2 = result.extra_info.attendance68_term2;
						}
						if (result.extra_info.attendanceKb89_term1) {
							$rootScope.attendanceKb89_term1 = result.extra_info.attendanceKb89_term1;
						}
						if (result.extra_info.attendanceKb89_term2) {
							$rootScope.attendanceKb89_term2 = result.extra_info.attendanceKb89_term2;
						}
						if (result.extra_info.attendanceKb89_term3) {
							$rootScope.attendanceKb89_term3 = result.extra_info.attendanceKb89_term3;
						}
						if (result.extra_info.attendanceKb10_term1) {
							$rootScope.attendanceKb10_term1 = result.extra_info.attendanceKb10_term1;
						}
						if (result.extra_info.attendanceKb10_term2) {
							$rootScope.attendanceKb10_term2 = result.extra_info.attendanceKb10_term2;
						}
						if (result.extra_info.StdResult) {
							$rootScope.StdResult = result.extra_info.StdResult;
						}
						if (result.extra_info.StdPromotGrade) {
							$rootScope.StdPromotGrade = result.extra_info.StdPromotGrade;
						}
						if (result.extra_info.StdReportDate) {
							$rootScope.StdReportDate = result.extra_info.StdReportDate;
						}
						if (result.extra_info.term_remarks1) {
							$rootScope.term_remarks1 = result.extra_info.term_remarks1;
						}
						if (result.extra_info.promoted_to) {
							$rootScope.promoted_to = result.extra_info.promoted_to;
						}
						if (result.extra_info.term_remarks2) {
							$rootScope.term_remarks2 = result.extra_info.term_remarks2;
						}
						if (result.extra_info.attitudeselction) {
							$rootScope.attitudeselction = result.extra_info.attitudeselction;
						}
						if (result.extra_info.lifeskillselction) {
							$rootScope.lifeskillselction = result.extra_info.lifeskillselction;
						}if (result.extra_info.lifeskillselection) {
							$rootScope.lifeskillselection = result.extra_info.lifeskillselection;
						}if (result.extra_info.attitudeselection) {
							$rootScope.attitudeselection = result.extra_info.attitudeselection;
						}if (result.extra_info.attitudeDataByIndex) {
							$rootScope.attitudeDataByIndex = result.extra_info.attitudeDataByIndex;
						}if (result.extra_info.lifeskillDataByIndex) {
							$rootScope.lifeskillDataByIndex = result.extra_info.lifeskillDataByIndex;
						}if (result.extra_info.attendancetenKb10_term1) {
							$rootScope.attendancetenKb10_term1 = result.extra_info.attendancetenKb10_term1;
						}if (result.extra_info.attendancetenKb10_term2) {
							$rootScope.attendancetenKb10_term2 = result.extra_info.attendancetenKb10_term2;
						}
					}
					if (result.term_remarks) {
						$rootScope.term_remarks = result.term_remarks;
					}
					console.log(result.header);
					if (result.header && result.header.published_date) {
						console.log(result.header.published_date);
						$rootScope.published_date = result.header.published_date;
					}
					$scope.urls = result.pdf_data;
					if (result.report_card_template) {
						switchTemplate(result.report_card_template.template, result.is_term1);
					}
					// $scope.urls = CONSTANTS.FILE_UPLOAD_URL +
					// "/uploads/academic_reports/"+$stateParams.student_id+"/"+result.pdf_url
					self.reportCardArray = result;
					if (result.report_card_template && result.report_card_template.template == rcConstants.TYPE_3_SUB_SLILL) {
						self.reportCardArray = result.reportCardArray;
						$scope.reportCardArray = result.reportCardArray;
					}
					console.log("THE REPORT CARD DATA IS : ", self.reportCardArray);
				} else {
					toastr.error(result.error.message);
					window.history.back();
				}
				$scope.loading = false;
				_.defer(function () {
					$scope.$apply();
				});
			} catch (e) {
				toastr.error(e);
				$scope.loading = false;
				console.log(e);
			}
		});
	}
	if ($stateParams.student_id && school_id) {
		console.log("KKKKk", requestBody);
		loadReport(requestBody);
	}
	self.saveAttendace = function () {

		if ($rootScope.attendance) {
			if (isNaN($rootScope.attendance) || $rootScope.attendance > 100) {
				toastr.error("Please enter attendance in percentage");
				return false;
			}
		}
		var new26AttendanceKeys = ["attendance_term1", "attendance_term2", "attendance68_term1", "attendance68_term2", "attendanceKb89_term1", "attendanceKb89_term2", "attendanceKb89_term3", "attendanceKb10_term1", "attendanceKb10_term2", "attendancetenKb10_term1", "attendancetenKb10_term2"];
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = new26AttendanceKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var key = _step.value;

				if ($rootScope[key] !== undefined && $rootScope[key] !== null && $rootScope[key] !== '' && (isNaN(Number($rootScope[key])) || Number($rootScope[key]) > 100)) {
					toastr.error("Attendance cannot be more than 100%");
					return false;
				}
			}
			// if($rootScope.term_remarks){

			//     var re = /^[ A-Za-z0-9_@./#&+-]*$/
			//     if (!re.test($rootScope.term_remarks)) {
			//         toastr.error('Will not accept a special character');
			//         return false;
			//     }
			// }
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		$scope.loading = true;
		$scope.typeOneHF = false;
		$scope.typeOneGrade = false;
		$scope.typeTwoMark = false;
		$scope.typeThreeSubSkill = false;
		$scope.assetHF = false;
		$scope.assetAnnual = false;
		$scope.term1term2 = false;
		$scope.defaultPtHfTwo = false;
		$scope.defaultPtAnnualTwo = false;
		$scope.gradeNineFinal = false;
		$scope.publishedoneeight = false;
		$scope.attendance = undefined;
		$scope.Kb_Term = false;
		$scope.annualKbTemp = false;
		$scope.type6_modelExamOne = false;
		$scope.type_6_model_exam_1_nineten = false;
		$scope.type_6_model_exam_II_nineten = false;
		$scope.type6_modelExamTwoNospace = false;
		$scope.type6_modelAnnualExamTerm = false;

		$scope.publishedtype_seven_calicut_annual = false;
		$scope.kgthematictermsFlag = false;

		$scope.type9_term1_hf = false;
		$scope.type9_cbse_pt1 = false;
		$scope.type9_grade12term2_ae = false;
		$scope.type9_kb_unit_test1 = false;
		$scope.type9_kbterm3 = false;
		$scope.publishedTypeTwelveOneEight = false;
		$scope.type12_ninetentermcbse = false;
		$scope.elt_report = false;
		$scope.type20_KB_10_grade_term = false;
		self.reportCardArray = undefined;
		$scope.publishedTypeTwentyNineTen = false;
		$scope.publishedTypeTwentyOneEight = false;
		$scope.publishedType30KB78 = false;
		$scope.pt_1_no_conv = false;
		requestBody["term_remarks"] = $rootScope.term_remarks;
		requestBody["attendance"] = $rootScope.attendance;
		requestBody["term_remarks1"] = $rootScope.term_remarks1;
		requestBody["promoted_to"] = $rootScope.promoted_to;
		$scope.selectedValues = [];

		//NEW26 Variables 2

		$scope.type5_1_2_grade_terms_new26 = false;
		$scope.type5_1_2_grade_terms_new26_term2 = false;
		$scope.T1type1_2_grade_terms_new26 = false;
		$scope.type5_3_5_grade_terms_new26 = false;
		$scope.T1type5_3_5_grade_terms_new26 = false;
		$scope.type6_6_7_grade_terms_new26 = false;
		$scope.T1type6_6_7_grade_terms_new26 = false;
		$scope.type5_3_5_grade_terms_new26_term2 = false;
		$scope.T1type8to10_grade_terms_new26 = false;
		$scope.type8to10_grade_terms_new26 = false;
		$scope.T1type02grade_11_science_new26 = false;
		$scope.type02grade_11_science_new26 = false;
		$scope.T1type1_2_grade_terms_new26_shj = false;
		$scope.type5_1_2_grade_terms_new26_shj_term2 = false;
		$scope.T1type02grade_12_science_new26 = false;
		$scope.type02grade_12_science_new26 = false;
		$scope.T1type9_grade_terms_new26 = false;
		$scope.type9_grade_terms_new26 = false;
		$scope.T1type10_grade_terms_new26 = false;
		$scope.type10_grade_terms_new26 = false;
		$scope.T1type10_KB_grade_term1_new26 = false;
		$scope.type10_KB_grade_term2_new26 = false;

		// Function to store the selected value
		$scope.storeSelectedValue = function (index) {
			$scope.selectedValues[index] = $scope.selectedLevel[index];
			console.log("Selected value:", $scope.selectedValues[index]);
		};
		var extra_info = {};
		if ($rootScope.house) {
			extra_info.house = $rootScope.house;
		}
		if ($rootScope.height) {
			extra_info.height = $rootScope.height;
		}
		if ($rootScope.weight) {
			extra_info.weight = $rootScope.weight;
		}
		if ($rootScope.bmi) {
			extra_info.bmi = $rootScope.bmi;
		}
		if ($rootScope.working_days) {
			extra_info.working_days = $rootScope.working_days;
		}
		if ($rootScope.selectedLevel) {
			extra_info.selectedLevel = $rootScope.selectedLevel;
		}
		if ($rootScope.days_attended) {
			extra_info.days_attended = $rootScope.days_attended;
		}
		if ($rootScope.attendance_term1) {
			extra_info.attendance_term1 = $rootScope.attendance_term1;
		}
		if ($rootScope.attitudeselction) {
			extra_info.attitudeselction = $rootScope.attitudeselction;
		}
		if ($rootScope.lifeskillselction) {
			extra_info.lifeskillselction = $rootScope.lifeskillselction;
		}

		if ($rootScope.attendance_term2) {
			extra_info.attendance_term2 = $rootScope.attendance_term2;
		}
		if ($rootScope.attendance68_term1) {
			extra_info.attendance68_term1 = $rootScope.attendance68_term1;
		}
		if ($rootScope.lifeskillselection) {
			extra_info.lifeskillselection = $rootScope.lifeskillselection;
		}if ($rootScope.attitudeselection) {
			extra_info.attitudeselection = $rootScope.attitudeselection;
		}if ($rootScope.attitudeDataByIndex) {
			extra_info.attitudeDataByIndex = $rootScope.attitudeDataByIndex;
		}if ($rootScope.lifeskillDataByIndex) {
			extra_info.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex;
		}

		// if ($rootScope.selectedDescription1) {
		// 	extra_info.selectedDescription1 =
		// 		$rootScope.selectedDescription1;
		// }
		// if ($rootScope.selectedDescription2) {
		// 	extra_info.selectedDescription2 =
		// 		$rootScope.selectedDescription2;
		// }
		// if ($rootScope.selectedDescription3) {
		// 	extra_info.selectedDescription3 =
		// 		$rootScope.selectedDescription3;
		// }
		// if ($rootScope.selectedDescription4) {
		// 	extra_info.selectedDescription4 =
		// 		$rootScope.selectedDescription4;
		// }
		// if ($rootScope.selectedDescription5) {
		// 	extra_info.selectedDescription5 =
		// 		$rootScope.selectedDescription5;
		// }
		// if ($rootScope.selectedDescription6) {
		// 	extra_info.selectedDescription6 =
		// 		$rootScope.selectedDescription6;
		// }
		// if ($rootScope.selectedDescription7) {
		// 	extra_info.selectedDescription7 =
		// 		$rootScope.selectedDescription7;
		// }
		// if ($rootScope.selectedDescription8) {
		// 	extra_info.selectedDescription8 =
		// 		$rootScope.selectedDescription8;
		// }
		// if ($rootScope.selectedDescription9) {
		// 	extra_info.selectedDescription9 =
		// 		$rootScope.selectedDescription9;
		// }
		// if ($rootScope.selectedDescription10) {
		// 	extra_info.selectedDescription10 =
		// 		$rootScope.selectedDescription10;
		// }
		// if ($rootScope.selectedDescription11) {
		// 	extra_info.selectedDescription11 =
		// 		$rootScope.selectedDescription11;
		// }
		// if ($rootScope.selectedDescription12) {
		// 	extra_info.selectedDescription12 =
		// 		$rootScope.selectedDescription12;
		// }
		// if ($rootScope.selectedDescription13) {
		// 	extra_info.selectedDescription13 =
		// 		$rootScope.selectedDescription13;
		// }
		// if ($rootScope.selectedDescription14) {
		// 	extra_info.selectedDescription14 =
		// 		$rootScope.selectedDescription14;
		// }
		if ($rootScope.attendance68_term2) {
			extra_info.attendance68_term2 = $rootScope.attendance68_term2;
		}
		if ($rootScope.attendanceKb89_term1) {
			extra_info.attendanceKb89_term1 = $rootScope.attendanceKb89_term1;
		}
		if ($rootScope.attendanceKb89_term2) {
			extra_info.attendanceKb89_term2 = $rootScope.attendanceKb89_term2;
		}
		if ($rootScope.attendanceKb89_term3) {
			extra_info.attendanceKb89_term3 = $rootScope.attendanceKb89_term3;
		}
		if ($rootScope.attendanceKb10_term1) {
			extra_info.attendanceKb10_term1 = $rootScope.attendanceKb10_term1;
		}
		if ($rootScope.attendanceKb10_term2) {
			extra_info.attendanceKb10_term2 = $rootScope.attendanceKb10_term2;
		}
		if ($rootScope.StdResult) {
			extra_info.StdResult = $rootScope.StdResult;
		}
		if ($rootScope.StdPromotGrade) {
			extra_info.StdPromotGrade = $rootScope.StdPromotGrade;
		}
		if ($rootScope.StdReportDate) {
			extra_info.StdReportDate = $rootScope.StdReportDate;
		}
		if ($rootScope.promoted_to) {
			extra_info.promoted_to = $rootScope.promoted_to;
		}
		if ($rootScope.term_remarks1) {
			extra_info.term_remarks1 = $rootScope.term_remarks1;
		}
		if ($rootScope.term_remarks2) {
			extra_info.term_remarks2 = $rootScope.term_remarks2;
		}if ($rootScope.attendancetenKb10_term1) {
			extra_info.attendancetenKb10_term1 = $rootScope.attendancetenKb10_term1;
		}
		if ($rootScope.attendancetenKb10_term2) {
			extra_info.attendancetenKb10_term2 = $rootScope.attendancetenKb10_term2;
		}
		requestBody["extra_info"] = extra_info;
		$scope.loading = true;
		console.log(extra_info, "pppextra_info----++++++");
		loadReport(requestBody, true);
	};
	// self.subscribe('getReportCardDataThisStudent',authoring})
	// stuReportDataSub = self.subscribe("getReportCardDataThisStudent", () => [$stateParams.student_id, $stateParams.selected_year])
	// if($stateParams.student_id && school_id){
	//     let rc = ReportCardData.find({}).fetch()
	// 	Meteor.call("getReportCardPublished",$stateParams.student_id, $stateParams.console_id, $stateParams.type,
	//      false, school_id, $stateParams.template_view, $stateParams.asset_format,
	//      $stateParams.selected_year, $stateParams.kb_consolidated, $stateParams.for_ct,
	//      function(error, result) {
	// 		if(result){
	//             console.log(result)
	// 			// if(result){
	// 				if(result.report_card_template){
	// 					switchTemplate(result.report_card_template.template)

	// 				}
	//                 self.reportCardArray = result
	//                 if(result.report_card_template.template == TYPE_3_SUB_SLILL){
	//                     self.reportCardArray = result.reportCardArray
	//                     $scope.reportCardArray = result.reportCardArray
	//                 }

	// 			// }
	// 		}
	//         $scope.loading = false
	// 		_.defer(function() { $scope.$apply(); });;
	//     })
	// }

	function switchTemplate(template) {
		var isterm1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		console.log("============TEMPLATE USING==============>", template);
		switch (template) {
			case rcConstants.TYPE_1_MARK:
				$scope.typeOneHF = true;
				break;
			case rcConstants.TYPE_1_GRADE:
				$scope.typeOneGrade = true;
				break;
			case rcConstants.TYPE_2_MARK:
				$scope.typeTwoMark = true;
				break;
			case rcConstants.TYPE_3_SUB_SLILL:
				$scope.typeThreeSubSkill = true;
				break;
			case rcConstants.TYPE_1_DEFAULT_ANNUAL:
				$scope.typeOneHF = true;
				break;
			case rcConstants.DEFAULT_PERIODICTEST_HF:
				$scope.defaultPtHf = true;
				break;
			case rcConstants.DEFAULT_PERIODICTEST_ANNUAL:
				$scope.defaultPtAnnual = true;
				break;
			case rcConstants.DEFAULT_YEAR_END:
				$scope.defaultYearEnd = true;
				break;
			case rcConstants.EDUCORE_YEAR_END:
				$scope.educoreYearEnd = true;
				break;
			case rcConstants.TYPE_4_MARK:
				$scope.type_four_mark = true;
				break;
			case rcConstants.TYPE_4_ANNUAL:
				$scope.type_four_annual = true;
				break;
			case rcConstants.ASSET_CONSOLIDATED:
				$scope.term1term2 = true;
				break;
			case rcConstants.DEFAULT_PERIODICTEST_HF_TWO:
				$scope.defaultPtHfTwo = true;
				break;
			case rcConstants.DEFAULT_PERIODICTEST_ANNUAL_TWO:
				$scope.defaultPtAnnualTwo = true;
				break;
			case rcConstants.KG_TERMS:
				$scope.Kg_Terms = true;
				break;
			case rcConstants.KG_CONSOLIDATED:
				$scope.Kg_Consolidated = true;
				break;
			case rcConstants.KB_TERMS:
				$scope.Kb_Terms = true;
				break;
			case rcConstants.HIGHER_SECONDARY_REPORT:
				$scope.hssTemplate = true;
				break;
			case rcConstants.CBSE_HSHF:
				$scope.cbsehss = true;
				break;
			case "term1halfyearly":
				$scope.term1halfyearly = true;
				break;
			case "grade-9-annual":
				$scope.gradeNineFinal = true;
				break;
			case rcConstants.KBHFHSS:
				$scope.KBHFHSSflag = true;
				break;
			case "grade-1_8-annual":
				$scope.publishedoneeight = true;
				break;
			case "kb_final":
				$scope.kb_finalFlag = true;
				break;
			case "annual_cbse_hss":
				$scope.cbseAnnualHss = true;
				break;
			case "term-annual-only":
				$scope.nineOnlyAnnual = true;
				break;
			case "kb_hss_annual":
				$scope.annualKbTemp = true;
				break;
			case rcConstants.MONTESSORY_TERMS:
				$scope.montessoryTerms = true;
				break;
			case rcConstants.MONTESSORY_CONSOLIDATED:
				$scope.montessoryConsolidate = true;
				break;
			case "periodic-test-hf-kb":
				$scope.ptHfKbPublished = true;
				break;
			case "hf1-exam":
				$scope.hfExamOne = true;
				break;
			case "type5_9_10_grade_term1":
				$scope.publishedType5_9_10 = true;
				break;
			case "type5_KB_10_grade_term2":
				$scope.publishedType5_KB_10 = true;
				break;
			case "type5_6_8_grade_term1":
				$scope.type5_6_8_grade_terms = true;
				break;
			case "type5_6_7_grade_term1":
				$scope.type5_6_7_grade_terms = true;
				break;

			case "type6_6_7_grade_term1":
				$scope.publishedTypeSixDXB = true;
				if (isterm1) {
					$scope.T1type6_6_7_grade_terms = true;
				} else {
					$scope.type6_6_7_grade_terms = true;
				}
				break;
			case "type6_3_5_grade_term1":
				$scope.type6_3_5_grade_terms = true;
				break;

			case "type5_3_5_grade_term1":
				$scope.publishedTypeThreeDXB = true;
				if (isterm1) {
					$scope.T1type5_3_5_grade_terms = true;
				} else {
					$scope.type5_3_5_grade_terms = true;
				}
				break;
			case "type5_8_grade_term1":
				$scope.type5_8_grade_terms = true;
				break;
			case "type5_1_5_grade_term2":
				$scope.type5_1_5_grade_terms = true;
				break;
			case "type6_1_2_grade_term1":
				$scope.type6_1_2_grade_terms = true;
				break;
			case "type5_1_2_grade_term1":
				$scope.publishedTypeDXB = true;
				if (isterm1) {
					$scope.T1type1_2_grade_terms = true;
				} else {
					$scope.type5_1_2_grade_terms = true;
				}
				break;
			case "type5_KB_8_9_grade_term3":
				$scope.type5_KB_8_9_grade_term3 = true;
				break;
			case "type_6_model_exam_1":
				$scope.type6_modelExamOne = true;
				break;
			case "type_6_model_exam_1_nineten":
				$scope.type_6_model_exam_1_nineten = true;
				break;
			case "type_6_model_exam_2_nineten":
				$scope.type_6_model_exam_II_nineten = true;
				break;
			case "type_6_model_exam_2":
				$scope.type6_modelExamTwoNospace = true;
				break;
			case "type_6_model_annualexam_2":
				$scope.type6_modelAnnualExamTerm = true;
				break;
			case "calicut_annual":
				$scope.publishedtype_seven_calicut_annual = true;
				break;
			case "kg-thematicterms":
				$scope.kgthematictermsFlag = true;
				break;
			case "type9_term1_hf":
				$scope.type9_term1_hf = true;
				break;
			case "type9_cbse_pt1":
				$scope.type9_cbse_pt1 = true;
				break;
			case "type9_grade12term2_ae":
				$scope.type9_grade12term2_ae = true;
				break;
			case "type9_kb_unit_test1":
				$scope.type9_kb_unit_test1 = true;
				break;
			case "type9_kbterm3":
				$scope.type9_kbterm3 = true;
				break;
			case "type12_termcbse":
				$scope.publishedTypeTwelveOneEight = true;
				break;
			case "type12_ninetentermcbse":
				$scope.type12_ninetentermcbse = true;
				break;
			case "elt-report":
				$scope.elt_report = true;
				break;
			case "type20_KB_10_grade_term1":
				$scope.type20_KB_10_grade_term = true;
				break;
			case "type20_termcbse":
				$scope.publishedTypeTwentyNineTen = true;
				break;
			case "type20_termcbse18":
				$scope.publishedTypeTwentyOneEight = true;
				break;
			case "type20_KB_10_grade_term2":
				$scope.type20_KB_10_grade_term2 = true;
				break;
			case "type20_term2cbse":
				$scope.publishedTypeTwentyTwoNineTen = true;
				break;
			case "type20_term2cbse18":
				$scope.publishedTypeTwentyOneEightTwo = true;
				break;
			case "type8to10_termcbse":
				if (isterm1) {
					$scope.T1type8_9_grade_terms = true;
				} else {
					$scope.publishedTypeEightToTen = true;
				}
				break;
			case "typetermcbse_8to10":
				$scope.publishedTypeEightToTen2 = true;
				break;
			case "type6to7_alncbse":
				$scope.publishedTypeSixToSeven = true;
				break;
			case "type6to7_tcscbse":
				$scope.publishedTypeSixToSeven2 = true;
				break;
			case "type3to5_tcscbse":
				$scope.publishedTypeThreeToFive = true;
				break;
			case "type3to5_alncbse":
				$scope.publishedTypeThreeToFive2 = true;
				break;
			case "type1to2_tcscbse":
				$scope.publishedTypeOneToTwo = true;
				break;
			case "type7_1_2_grade_term1":
				$scope.PublishedTypesevenOneTwo = true;
				break;
			case "type30_KB_8_9_grade_term3_new26":
			case "type30_KB_8_9_grade_term2_new26":
			case "type30_KB_8_9_grade_term1_new26":
			case "type30_KB_8_9_grade_term3":
				$scope.publishedType30KB78 = true;
				if (template && (template.indexOf("new26") !== -1 || template.indexOf("NEW26") !== -1)) {
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
				}
				break;
			case "type10_KB_grade_term1":
				$scope.publishedType10KB = true;
				break;
			case "type10_KB_grade11_12_term1_new26":
			case "type10_KB_grade11_12_term2_new26":
				$scope.publishedType10KBElevenTwelveNew26 = true;
				break;
			case "type10_KB_grade11_12_term1":
				$scope.publishedType10KBElevenTwelve = true;
				break;
			case "type02grade_11_science":
				$scope.publishedTypeElevenScience = true;
				break;
			case "type02grade_11_science_noModelExam":
				$scope.publishedTypeElevenScienceNoModel = true;
				break;
			case "type02grade_12_science":
				$scope.publishedTypeTwelveScience = true;
				break;
			case "pt_1_no_conv":
				$scope.pt_1_no_conv = true;
				break;
			case "type1to5_tcscbse_new":
				$scope.publishedtcsOneFivetemplate = true;
				break;

		}
		// ===== NEW26: handleNew26Switch Call =====
		handleNew26Switch(template, isterm1);

		// ===== NEW26: handleNew26Switch Function Start =====
		function handleNew26Switch(template, isterm1) {
			switch (template) {
				case "type6_6_7_grade_term1_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type6_6_7_grade_terms_new26 = true;
					} else {
						$scope.type6_6_7_grade_terms_new26 = true;
					}
					break;

				case "type6_6_7_grade_term2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type6_6_7_grade_terms_new26 = true;
					break;

				case "type5_1_2_grade_term1_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeDXB = true;
					if (isterm1) {
						$scope.T1type1_2_grade_terms_new26 = true;
					} else {
						$scope.type5_1_2_grade_terms_new26 = true;
					}
					break;

				case "type5_1_2_grade_term2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeDXB = true;
					$scope.type5_1_2_grade_terms_new26_term2 = true;
					break;

				case "type5_1_2_grade_term1_new26_shj":
					$scope.isNew26Console = true;
					$scope.publishedTypeDXB = true;
					$scope.T1type1_2_grade_terms_new26_shj = true;
					break;

				case "type5_1_2_grade_term2_new26_shj":
					$scope.isNew26Console = true;
					$scope.publishedTypeDXB = true;
					$scope.type5_1_2_grade_terms_new26_shj_term2 = true;
					break;

				case "type5_3_5_grade_term1_new26":
					$scope.publishedTypeThreeDXB = true;
					if (isterm1) {
						$scope.T1type5_3_5_grade_terms_new26 = true;
					} else {
						$scope.type5_3_5_grade_terms_new26 = true;
					}
					break;

				case "type5_3_5_grade_term2_new26":
					$scope.publishedTypeThreeDXB = true;
					$scope.type5_3_5_grade_terms_new26_term2 = true;
					break;

				case "type8to10_termcbse_new26":
				case "type8_8_termcbse_new26":
				case "type8_8_grade_term1_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type8to10_grade_terms_new26 = true;
					} else {
						$scope.type8to10_grade_terms_new26 = true;
					}
					break;

				case "type8to10_termcbseterm2_new26":
				case "type8_8_termcbseterm2_new26":
				case "type8_8_grade_term2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type8to10_grade_terms_new26 = true;
					break;

				case "type9_termcbse_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type9_grade_terms_new26 = true;
					} else {
						$scope.type9_grade_terms_new26 = true;
					}
					break;

				case "type9_termcbseterm2_new26":
				case "type9_9_termcbseterm2_new26":
				case "type9_9_grade_term2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type9_grade_terms_new26 = true;
					break;

				case "type10_termcbse_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type10_grade_terms_new26 = true;
					} else {
						$scope.type10_grade_terms_new26 = true;
					}
					break;

				case "type10_termcbseterm2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type10_grade_terms_new26 = true;
					break;

				case "type10_KB_grade_term1_new26":
				case "type30_KB_grade_term1_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type10_KB_grade_term1_new26 = true;
					} else {
						$scope.type10_KB_grade_term2_new26 = true;
					}
					break;

				case "type10_KB_grade_term2_new26":
				case "type30_KB_grade_term2_new26":
				case "type30_KB_grade_term3_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type10_KB_grade_term2_new26 = true;
					break;

				case "type02grade_11_science_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type02grade_11_science_new26 = true;
					} else {
						$scope.type02grade_11_science_new26 = true;
					}
					break;

				case "type02grade_11_sciencet2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type02grade_11_science_new26 = true;
					break;

				case "type02grade_12_science_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					if (isterm1) {
						$scope.T1type02grade_12_science_new26 = true;
					} else {
						$scope.type02grade_12_science_new26 = true;
					}
					break;

				case "type02grade_12_sciencet2_new":
				case "type02grade_12_sciencet2_new26":
					$scope.isNew26Console = true;
					$scope.publishedTypeSixDXB = true;
					$scope.type02grade_12_science_new26 = true;
					break;
			}
			// ===== END NEW26: handleNew26Switch =====
		}
	}

	// $scope.set = (val) => {
	//     return array = JSON.parse(val)
	// }

	self.export = function () {
		$scope.loading = true;
		$scope.pdfData = true;
		$scope.url = $sce.trustAsResourceUrl($scope.urls);
		$scope.loading = false;
		_.defer(function () {
			$scope.$apply();
		});
	};

	self.backToHtml = function () {
		$scope.pdfData = false;
	};
	function pushLog() {
		var userIds = localStorageService.get("user_id");
		var schoolIds = localStorageService.get("school_id");
		var logData = requestBody.studentId + "_" + requestBody.rc_id;
		authService.callRabbitMQAPI("/v0/rabbitmqpush_withlog/" + userIds + "/" + schoolIds + "/ReportCard_View/" + logData, "GET", {}, function (response) {
			// console.log(response)
		});
	}
};
PublishedReportsListCtrl.$inject = ["$scope", "$state", "$rootScope", "$stateParams", "$mdDialog", "$sce", "CONSTANTS", "localStorageService", "authService", "rcConstants", "RC_CONSTANTS_"];

var typeOneHfYComponent = "typeOneHfComponent";

var TypeOneHfYTemplateClass = function TypeOneHfYTemplateClass($scope, $state, $window, $stateParams, $mdDialog, $mdMedia, RC_CONSTANTS_, localStorageService) {
	"ngInject";

	_classCallCheck(this, TypeOneHfYTemplateClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		var school_id = localStorageService.get("school_id");
		if (RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS && RC_CONSTANTS_.PORT_FOLIO_AS_NB_SCHOOLS.indexOf(school_id) !== -1) {
			vm.PORT_FOLIO_AS_NB_SCHOOLS = true;
		}
		vm.reportCardArray = this.typeOneHfYTemplateCtrl.reportCardArray;
		vm.buckets = this.typeOneHfYTemplateCtrl.reportCardArray.report_card_template.activity_buckets;
	};
	//  $scope.set = (val) => {
	//     return array = JSON.parse(val)
	// }

	// this.exportReportData = () => {
	// }
};
TypeOneHfYTemplateClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia", "RC_CONSTANTS_", "localStorageService"];

var periodicTestDefaultHfPublished = "periodicTestDefaultHfPublished";

var PeriodicTestDefaultHfPublished = function PeriodicTestDefaultHfPublished($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
	"ngInject";

	_classCallCheck(this, PeriodicTestDefaultHfPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.pTPublishedDefauHlFCtrl.reportCardArray;
		vm.buckets = this.pTPublishedDefauHlFCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PeriodicTestDefaultHfPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var periodicTestDefaultAnnualPublished = "periodicTestDefaultAnnualPublished";

var PeriodicTestDefaultAnnualPublished = function PeriodicTestDefaultAnnualPublished($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PeriodicTestDefaultAnnualPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.pTPublishedDefaultAnnualCtrl.reportCardArray;
		vm.buckets = this.pTPublishedDefaultAnnualCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PeriodicTestDefaultAnnualPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var defaultYearEnd = "defaultYearEnd";

var DefaultYearEnd = function DefaultYearEnd($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, DefaultYearEnd);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.defaultYearEndCtrl.reportCardArray;
		vm.buckets = this.defaultYearEndCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
DefaultYearEnd.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var termConsolidated = "termConsolidated";

var TermConsolidated = function TermConsolidated($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TermConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.termConsolidatedCtrl.reportCardArray;
		vm.buckets = this.termConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TermConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var educoreYearEnd = "educoreYearEnd";

var EducoreYearEnd = function EducoreYearEnd($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, EducoreYearEnd);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.educoreYearEndCtrl.reportCardArray;
		_.each(vm.reportCardArray.main_results, function (value, subjectName) {
			if (value.grade_1 == "A1") {
				value["color_1"] = "#d0a1f3";
			}
			if (value.grade_1 == "A2") {
				value["color_1"] = "#56bbec";
			}
			if (value.grade_1 == "B1") {
				value["color_1"] = "#93ca16";
			}
			if (value.grade_1 == "B2") {
				value["color_1"] = "#b7b6b1";
			}
			if (value.grade_1 == "C1") {
				value["color_1"] = "#e6c95a";
			}
			if (value.grade_1 == "C2") {
				value["color_1"] = "#d6aa00";
			}
			if (value.grade_1 == "D") {
				value["color_1"] = "#e2b60c";
			}
			if (value.grade_1 == "E") {
				value["color_1"] = "#f37404";
			}
			if (value.grade_1 == "NA") {
				value["color_1"] = "red";
			}
			if (value.grade_2 == "A1") {
				value["color_2"] = "#d0a1f3";
			}
			if (value.grade_2 == "A2") {
				value["color_2"] = "#56bbec";
			}
			if (value.grade_2 == "B1") {
				value["color_2"] = "#93ca16";
			}
			if (value.grade_2 == "B2") {
				value["color_2"] = "#b7b6b1";
			}
			if (value.grade_2 == "C1") {
				value["color_2"] = "#e6c95a";
			}
			if (value.grade_2 == "C2") {
				value["color_2"] = "#d6aa00";
			}
			if (value.grade_2 == "D") {
				value["color_2"] = "#e2b60c";
			}
			if (value.grade_2 == "E") {
				value["color_2"] = "#f37404";
			}
			if (value.grade_2 == "NA") {
				value["color_2"] = "red";
			}
		});
		_.each(vm.reportCardArray.other_sections, function (value, subjectName) {
			if (value.grade_1 == "A") {
				value["color_1"] = "#d0a1f3";
			}
			if (value.grade_1 == "B") {
				value["color_1"] = "#93ca16";
			}
			if (value.grade_1 == "C") {
				value["color_1"] = "#e6c95a";
			}
			if (value.grade_1 == "NA") {
				value["color_1"] = "red";
			}
			if (value.grade_2 == "A") {
				value["color_2"] = "#d0a1f3";
			}
			if (value.grade_2 == "B") {
				value["color_2"] = "#93ca16";
			}
			if (value.grade_2 == "C") {
				value["color_2"] = "#e6c95a";
			}
			if (value.grade_2 == "NA") {
				value["color_2"] = "red";
			}
		});
		vm.buckets = this.educoreYearEndCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
EducoreYearEnd.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var skilSubSkill = "skilSubSkill";

var SkilSubSkill = function SkilSubSkill($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, SkilSubSkill);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.skilSubSkillCtrl.reportCardArray;
		$scope.reportCardArray = this.skilSubSkillCtrl.reportCardArray;
		// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
	};
};
SkilSubSkill.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var assetHF = "assetHfComponent";

var AssetHF = function AssetHF($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, AssetHF);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.assetHFCtrl.reportCardArray;
		$scope.reportCardArray = this.assetHFCtrl.reportCardArray;
		// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
	};
};
AssetHF.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var assetAnnual = "assetAnnualComponent";

var AssetAnnual = function AssetAnnual($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, AssetAnnual);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.assetAnnualCtrl.reportCardArray;
		$scope.reportCardArray = this.assetAnnualCtrl.reportCardArray;
		// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
	};
};
AssetAnnual.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kgTerms = "kgTerms";

var KgTerms = function KgTerms($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KgTerms);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.kgTermsCtrl.reportCardArray;
		$scope.reportCardArray = this.kgTermsCtrl.reportCardArray;
		console.log($scope.reportCardArray.main_results);
		console.log(">>>>>>>>>>");
		vm.evaluations = vm.reportCardArray.response.evals;
		vm.resultValues = vm.reportCardArray.reportCardArray.main_results;
		console.log(vm.reportCardArray);
	};
	// vm.buckets = this.skilSubSkillCtrl.reportCardArray.report_card_template.activity_buckets
};
KgTerms.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var periodicTestDefaultHfTwoPublished = "periodicTestDefaultHfTwoPublished";

var PeriodicTestDefaultHfTwoPublished = function PeriodicTestDefaultHfTwoPublished($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PeriodicTestDefaultHfTwoPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.pTPublishedHfTwoCtrl.reportCardArray;
		vm.buckets = this.pTPublishedHfTwoCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PeriodicTestDefaultHfTwoPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var periodicTestDefaultAnnualTwoPublished = "periodicTestDefaultAnnualTwoPublished";

var PeriodicTestDefaultAnnualTwoPublished = function PeriodicTestDefaultAnnualTwoPublished($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PeriodicTestDefaultAnnualTwoPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.pTPublishedDefaultAnnualTwoCtrl.reportCardArray;
		vm.buckets = this.pTPublishedDefaultAnnualTwoCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PeriodicTestDefaultAnnualTwoPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kgConsolidated = "kgConsolidated";

var KgConsolidated = function KgConsolidated($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KgConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.kgConsolidatedCtrl.reportCardArray;
		vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
		vm.reportResultArray = vm.reportCardArray.reportCardArray.main_result_report;
		console.log(vm.reportResultArray);
	};
};
KgConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kbTerms = "kbTerms";

var KbTerms = function KbTerms($scope, $state, $window, localStorageService, rcConstants) {
	"ngInject";

	_classCallCheck(this, KbTerms);

	var vm = this;
	vm.reportCardArray = undefined;

	this.$onInit = function () {
		vm.reportCardArray = this.kbTermsCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
		if (rcConstants.MEP_STATIC_SCHOOL_IDS.indexOf(localStorageService.get("school_id")) !== -1) {
			if (vm.reportCardArray.header.report_name == "KB-Term-3") {
				$scope.mepStatic = true;
			}
		}
	};
};
KbTerms.$inject = ["$scope", "$state", "$window", "localStorageService", "rcConstants"];

var hssTemplateComponent = "hssComponent";

var HssTemplateComponentClass = function HssTemplateComponentClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, HssTemplateComponentClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.hssReportCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
HssTemplateComponentClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var cbseHssPublishedComponent = "cbseHssPublishedComponent";

var CbseHssPublishedClass = function CbseHssPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, CbseHssPublishedClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.cbseHssPublishedCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
CbseHssPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var specificHFComponent = "specificHf";

var SpecificHFPublishedClass = function SpecificHFPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, SpecificHFPublishedClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.specificHFPublishedCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
SpecificHFPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kbhfhssComp = "kbhfhsspublishedComp";

var KbhfhssPublishedClass = function KbhfhssPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KbhfhssPublishedClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.KbhfhssPublishedCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
KbhfhssPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var cbseSpecificoneeigthFinalComp = "cbseSpecificoneeigthFinalComp";

var CbseSpecificoneeigthFinalClass = function CbseSpecificoneeigthFinalClass($scope, rcConstants, localStorageService) {
	"ngInject";

	_classCallCheck(this, CbseSpecificoneeigthFinalClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;

	/** Added to check the school ids for not showing final */
	$scope.nonFinalSchoolIds = !rcConstants.NON_FINAL_SCHOOL_IDS.includes(localStorageService.get("school_id"));

	this.$onInit = function () {
		vm.reportCardArray = this.cbseSpecificoneeghtFinalCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
CbseSpecificoneeigthFinalClass.$inject = ["$scope", "rcConstants", "localStorageService"];

var cbseSpecificSubjectsFinalComp = "cbseSpecificSubjectsFinalComp";

var CbseSpecificSubjectsFinalClass = function CbseSpecificSubjectsFinalClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, CbseSpecificSubjectsFinalClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.cbseSpecificSubjectsFinalCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
CbseSpecificSubjectsFinalClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kbFinalComponent = "kbFinalComponent";

var kbFinalComponentClass = function kbFinalComponentClass($scope, $state, $window, $stateParams, localStorageService, rcConstants) {
	"ngInject";

	_classCallCheck(this, kbFinalComponentClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	if (rcConstants.MEP_STATIC_SCHOOL_IDS.indexOf(localStorageService.get("school_id")) !== -1) {
		$scope.mepStatic = true;
	}
	this.$onInit = function () {
		vm.reportCardArray = this.kbFinalComponentCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
		console.log(vm.reportCardArray);
	};
};
kbFinalComponentClass.$inject = ["$scope", "$state", "$window", "$stateParams", "localStorageService", "rcConstants"];

var pubishedcbsehssAnnual = "pubishedcbsehssAnnual";

var PubishedcbsehssAnnual = function PubishedcbsehssAnnual($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PubishedcbsehssAnnual);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.pubishedcbsehssAnnualCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
		console.log(vm.reportCardArray);
	};
};
PubishedcbsehssAnnual.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var nineonlypubllishedComp = "nineonlypubllishedComp";

var NineonlypubllishedCompClass = function NineonlypubllishedCompClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, NineonlypubllishedCompClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.nineonlypubllishedCompCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
NineonlypubllishedCompClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kbannualHssPublished = "kbannualHssPublished";

var KbannualHssPublishedClass = function KbannualHssPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KbannualHssPublishedClass);

	var vm = this;
	vm.allStudentReportData = undefined;
	vm.card_details = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.kbannualHssPublishedCtrl.reportCardArray;
		vm.reportCardArray = vm.reportCardArray;
	};
};
KbannualHssPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var montessoryTerms = "montessoryTerms";

var montessoryTermsPublishedClass = function montessoryTermsPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, montessoryTermsPublishedClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.montessoryTermsPublishedCtrl.reportCardArray;
		$scope.reportCardArray = this.montessoryTermsPublishedCtrl.reportCardArray;
		console.log($scope.reportCardArray.main_results);
		vm.evaluations = vm.reportCardArray.response.evals;
		vm.resultValues = vm.reportCardArray.reportCardArray.main_results;
		console.log(vm.reportCardArray);
	};
};
montessoryTermsPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var montessoryConsolidated = "montessoryConsolidated";

var montessoryConsolidatedPublishedClass = function montessoryConsolidatedPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, montessoryConsolidatedPublishedClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.montessoryConsolidatedPublishedCtrl.reportCardArray;
		vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
		console.log(vm.reportCardArray);
	};
};
montessoryConsolidatedPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kbhfPtPublishedComponent = "kbhfPtPublishedComponent";

var KbhfPtPublishedPublishedClass = function KbhfPtPublishedPublishedClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KbhfPtPublishedPublishedClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.kbhfPtPublishedPublishedCtrl.reportCardArray;
		vm.buckets = this.kbhfPtPublishedPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
KbhfPtPublishedPublishedClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var hfexamOnePublishedComponent = "hfexamOnePublishedComponent";

var HfexamOnePublishedComponentClass = function HfexamOnePublishedComponentClass($scope, $state, $rootScope, $window, $stateParams, $mdDialog, $mdMedia) {
	"ngInject";

	_classCallCheck(this, HfexamOnePublishedComponentClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.hfexamOnePublishedCtrl.reportCardArray;
		vm.buckets = this.hfexamOnePublishedCtrl.reportCardArray.report_card_template.activity_buckets;
	};
	//  $scope.set = (val) => {
	//     return array = JSON.parse(val)
	// }

	// this.exportReportData = () => {
	// }

	self.calbmi = function () {
		console.log($rootScope.height + "  " + $rootScope.weight);
		var cc = Number($rootScope.height) * Number($rootScope.height);
		var bmiVal = Number($rootScope.weight) / Number($rootScope.height) / Number($rootScope.height) * Number(10000);
		$rootScope.bmi = Math.round(bmiVal);
		$scope.$apply();
		console.log(bmiVal);
	};
	self.calatt = function () {
		console.log($rootScope.working_days + "  " + $rootScope.days_attended);
		var attVal = Number($rootScope.days_attended) / Number($rootScope.working_days) * Number(100);
		$rootScope.attendance_term1 = Math.round(attVal);
		$scope.$apply();
		console.log(attVal);
	};
};
HfexamOnePublishedComponentClass.$inject = ["$scope", "$state", "$rootScope", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var publishedCbseTypefiveNineTen = "publishedCbseTypefiveNineTen";

var PublishedCbseTypefiveNineTenClass = function PublishedCbseTypefiveNineTenClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedCbseTypefiveNineTenClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedCbseTypefiveNineTenCtrl.reportCardArray;
		vm.buckets = this.publishedCbseTypefiveNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedCbseTypefiveNineTenClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeFiveKbten = "publishedTypeFiveKbten";

var PublishedTypeFiveKbtenClass = function PublishedTypeFiveKbtenClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveKbtenClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveKbtenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveKbtenCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeFiveKbtenClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeFiveSixEight = "publishedTypeFiveSixEight";

var PublishedTypeFiveSixEight = function PublishedTypeFiveSixEight($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveSixEight);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveSixEightCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveSixEightCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeFiveSixEight.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeFiveOneFive = "publishedTypeFiveOneFive";

var PublishedTypeFiveOneFive = function PublishedTypeFiveOneFive($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveOneFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveOneFiveCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveOneFiveCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeFiveOneFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeFiveKbEightNine = "publishedTypeFiveKbEightNine";

var PublishedTypeFiveKbEightNine = function PublishedTypeFiveKbEightNine($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveKbEightNine);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveKbEightNineCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveKbEightNineCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeFiveKbEightNine.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeSixModalExamTermOne = "publishedTypeSixModalExamTermOne";

var PublishedTypeSixModalExamTermOne = function PublishedTypeSixModalExamTermOne($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixModalExamTermOne);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixModalExamTermOneCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixModalExamTermOneCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeSixModalExamTermOne.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var typesixModelExamTermOneninetenPublished = "publishedTypesixModelExamNineTen";

var TypesixModelExamTermOneninetenPublished = function TypesixModelExamTermOneninetenPublished($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
	"ngInject";

	_classCallCheck(this, TypesixModelExamTermOneninetenPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typesixModelExamTermOneninetenPublishedCtrl.reportCardArray;
		vm.buckets = this.typesixModelExamTermOneninetenPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TypesixModelExamTermOneninetenPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typesixModelExamTermTwoninetenPublished = "publishedTypesixModelExamNineTenTwo";

var TypesixModelExamTermTwoninetenPublished = function TypesixModelExamTermTwoninetenPublished($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
	"ngInject";

	_classCallCheck(this, TypesixModelExamTermTwoninetenPublished);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray;
		vm.buckets = this.typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TypesixModelExamTermTwoninetenPublished.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var publishedTypeSixModalExamTermTwonospace = "publishedTypeSixModalExamTermTwonospace";

var PublishedTypeSixModalExamTermTwonospace = function PublishedTypeSixModalExamTermTwonospace($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixModalExamTermTwonospace);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeSixModalExamTermTwonospace.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeSixModelannualexam = "publishedTypeSixModelannualexam";

var PublishedTypeSixModelannualexam = function PublishedTypeSixModelannualexam($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixModelannualexam);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixModelannualexamCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixModelannualexamCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeSixModelannualexam.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeSevenCalicutAnnualexam = "publishedTypeSevenCalicutAnnualexam";

var PublishedTypeSevenCalicutAnnualexam = function PublishedTypeSevenCalicutAnnualexam($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSevenCalicutAnnualexam);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeSevenCalicutAnnualexam.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var kgthematictermsComponent = "kgthematictermsComponent";

var KgthematictermsClass = function KgthematictermsClass($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, KgthematictermsClass);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.kgthematictermsCtrl.reportCardArray;
		$scope.reportCardArray = this.kgthematictermsCtrl.reportCardArray;
		vm.evaluations = vm.reportCardArray.response.evals;
		console.log(vm.evaluations);
	};
};
KgthematictermsClass.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var typeNineCbseConsolidated = "typeNineCbseConsolidated";

var TypeNineCbseConsolidated = function TypeNineCbseConsolidated($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TypeNineCbseConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray;
		vm.buckets = this.typeNineCbseConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
		//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    vm.evaluations = vm.reportCardArray.response.evals
		//    console.log(vm.evaluations)
	};
};
TypeNineCbseConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var typeNineCbsept = "typeNineCbsept";

var TypeNineCbsept = function TypeNineCbsept($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TypeNineCbsept);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typeNineCbseptCtrl.reportCardArray;
		vm.buckets = this.typeNineCbseptCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TypeNineCbsept.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var typeNineTwelveCbseConsolidated = "typeNineTwelveCbseConsolidated";

var TypeNineTwelveCbseConsolidated = function TypeNineTwelveCbseConsolidated($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TypeNineTwelveCbseConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typeNineTwelveCbseConsolidatedCtrl.reportCardArray;
		vm.buckets = this.typeNineTwelveCbseConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
		//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    vm.evaluations = vm.reportCardArray.response.evals
		//    console.log(vm.evaluations)
	};
};
TypeNineTwelveCbseConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var typeNinekbUnitTest = "typeNinekbUnitTest";

var TypeNinekbUnitTest = function TypeNinekbUnitTest($scope, $state, $window, $stateParams, $mdDialog, $mdMedia) {
	"ngInject";

	_classCallCheck(this, TypeNinekbUnitTest);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typeNinekbUnitTestCtrl.reportCardArray;
		vm.buckets = this.typeNinekbUnitTestCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TypeNinekbUnitTest.$inject = ["$scope", "$state", "$window", "$stateParams", "$mdDialog", "$mdMedia"];

var typeNinekbConsolidated = "typeNinekbConsolidated";

var TypeNinekbConsolidated = function TypeNinekbConsolidated($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TypeNinekbConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typeNinekbConsolidatedCtrl.reportCardArray;
		vm.buckets = this.typeNinekbConsolidatedCtrl.reportCardArray.report_card_template.activity_buckets;
		//    vm.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    $scope.reportCardArray = this.typeNineCbseConsolidatedCtrl.reportCardArray
		//    vm.evaluations = vm.reportCardArray.response.evals
		//    console.log(vm.evaluations)
	};
};
TypeNinekbConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwelveOneEight = "publishedTypeTwelveOneEight";

var PublishedTypeTwelveOneEight = function PublishedTypeTwelveOneEight($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwelveOneEight);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwelveOneEightCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwelveOneEightCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwelveOneEight.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwelveNineTen = "publishedTypeTwelveNineTen";

var PublishedTypeTwelveNineTen = function PublishedTypeTwelveNineTen($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwelveNineTen);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwelveNineTenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwelveNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwelveNineTen.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedEltReport = "publishedEltReport";

var PublishedEltReport = function PublishedEltReport($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedEltReport);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedEltReportCtrl.reportCardArray;
		vm.buckets = this.publishedEltReportCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedEltReport.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedType20kbterms = "publishedType20kbterms";

var PublishedType20kbterms = function PublishedType20kbterms($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedType20kbterms);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedType20kbtermsCtrl.reportCardArray;
		vm.buckets = this.publishedType20kbtermsCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedType20kbterms.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwentyNineTen = "publishedTypeTwentyNineTen";

var PublishedTypeTwentyNineTen = function PublishedTypeTwentyNineTen($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwentyNineTen);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwentyNineTenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwentyNineTenCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwentyNineTen.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwentyOneEight = "publishedTypeTwentyOneEight";

var PublishedTypeTwentyOneEight = function PublishedTypeTwentyOneEight($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwentyOneEight);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwentyOneEightCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwentyOneEightCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwentyOneEight.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwentyNineTenTwo = "publishedTypeTwentyNineTenTwo";

var PublishedTypeTwentyNineTenTwo = function PublishedTypeTwentyNineTenTwo($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwentyNineTenTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwentyNineTenTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwentyNineTenTwoCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwentyNineTenTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTwentyOneEightTwo = "publishedTypeTwentyOneEightTwo";

var PublishedTypeTwentyOneEightTwo = function PublishedTypeTwentyOneEightTwo($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwentyOneEightTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwentyOneEightTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwentyOneEightTwoCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTwentyOneEightTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedType20kbterms2 = "publishedType20kbterms2";

var PublishedType20kbterms2 = function PublishedType20kbterms2($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, PublishedType20kbterms2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedType20kbterms2Ctrl.reportCardArray;
		vm.buckets = this.publishedType20kbterms2Ctrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedType20kbterms2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeEightToTen = "publishedTypeEightToTen";

var PublishedTypeEightToTen = function PublishedTypeEightToTen($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeEightToTen);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	$scope.eightclass = false;
	var eightclass = ["class12384"];
	var ninthclass = ["class129345"];
	$scope.isadditional = false;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeEightToTenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeEightToTenCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		if (this.publishedTypeEightToTenCtrl.reportCardArray && Object.keys(this.publishedTypeEightToTenCtrl.reportCardArray.additional_subjects).length) {
			$scope.isadditional = true;
		}
		console.log(this.publishedTypeEightToTenCtrl.reportCardArray.student.class_id, "lllllllllll", eightclass);
		if (eightclass.indexOf(this.publishedTypeEightToTenCtrl.reportCardArray.student.class_id) != -1) {
			$scope.eightclass = true;
		}
		if (ninthclass.indexOf(this.publishedTypeEightToTenCtrl.reportCardArray.student.class_id) != -1) {
			$scope.ninthclass = true;
		}
		$scope.bestOfTermSchoolTCS = this.publishedTypeEightToTenCtrl.reportCardArray.header && this.publishedTypeEightToTenCtrl.reportCardArray.header.school_id === 'm2LMtqaESFZf6xDE8';
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeEightToTenCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeEightToTenCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTenCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeEightToTenCtrl.reportCardArray.att_values);
			this.publishedTypeEightToTenCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeEightToTenCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTenCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeEightToTen.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeEightToTen2 = "publishedTypeEightToTen2";

var PublishedTypeEightToTen2 = function PublishedTypeEightToTen2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeEightToTen2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.isadditional = false;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeEightToTen2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeEightToTen2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		if (this.publishedTypeEightToTen2Ctrl.reportCardArray && Object.keys(this.publishedTypeEightToTen2Ctrl.reportCardArray.additional_subjects).length) {
			$scope.isadditional = true;
		}

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTen2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values);
			this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTen2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeEightToTen2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixToSeven = "publishedTypeSixToSeven";

var PublishedTypeSixToSeven = function PublishedTypeSixToSeven($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixToSeven);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixToSevenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixToSevenCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixToSevenCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixToSevenCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixToSevenCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixToSevenCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixToSevenCtrl.reportCardArray.att_values);
			this.publishedTypeSixToSevenCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixToSevenCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixToSevenCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixToSeven.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixToSeven2 = "publishedTypeSixToSeven2";

var PublishedTypeSixToSeven2 = function PublishedTypeSixToSeven2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixToSeven2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixToSeven2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeSixToSeven2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixToSeven2Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixToSeven2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values);
			this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixToSeven2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixToSeven2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeThreeToFive = "publishedTypeThreeToFive";

var PublishedTypeThreeToFive = function PublishedTypeThreeToFive($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeThreeToFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeThreeToFiveCtrl.reportCardArray;
		vm.buckets = this.publishedTypeThreeToFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeThreeToFiveCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeThreeToFiveCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values);
			this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeThreeToFiveCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeThreeToFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeThreeToFive2 = "publishedTypeThreeToFive2";

var PublishedTypeThreeToFive2 = function PublishedTypeThreeToFive2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeThreeToFive2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeThreeToFive2Ctrl.reportCardArray;
		console.log(vm.reportCardArray, 'reportCardArray');
		vm.buckets = this.publishedTypeThreeToFive2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeThreeToFive2Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeThreeToFive2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values);
			this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeThreeToFive2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeThreeToFive2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeOneToTwo = "publishedTypeOneToTwo";

var PublishedTypeOneToTwo = function PublishedTypeOneToTwo($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeOneToTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeOneToTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypeOneToTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeOneToTwoCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeOneToTwoCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeOneToTwoCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeOneToTwoCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeOneToTwoCtrl.reportCardArray.att_values);
			this.publishedTypeOneToTwoCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeOneToTwoCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeOneToTwoCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeOneToTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeElevenScience = "publishedTypeElevenScience";
var publishedTypeElevenScienceNoModel = "publishedTypeElevenScienceNoModel";

var PublishedTypeElevenScience = function PublishedTypeElevenScience($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeElevenScience);

	var vm = this;
	$scope.scienceComment = false;
	$scope.commerceComment = false;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeElevenScienceCtrl.reportCardArray;
		vm.buckets = this.publishedTypeElevenScienceCtrl.reportCardArray.report_card_template.activity_buckets;
		if (this.publishedTypeElevenScienceCtrl.reportCardArray.student.stream == 'Science') {
			$scope.scienceComment = true;
			$scope.commerceComment = false;
		}
		if (this.publishedTypeElevenScienceCtrl.reportCardArray.student.stream == 'Commerce') {
			$scope.commerceComment = true;
			$scope.scienceComment = false;
		}
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;

		if (vm.reportCardArray && vm.reportCardArray.header) {
			$scope.TCS_SCHOOL = vm.reportCardArray.header.school_id === 'm2LMtqaESFZf6xDE8';
		}

		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
	};
};
PublishedTypeElevenScience.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixOneTwo = "publishedTypeSixOneTwo";

var PublishedTypeSixOneTwo = function PublishedTypeSixOneTwo($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixOneTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];

	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixOneTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");

		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixOneTwoCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee, "this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixOneTwoCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values);
			this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixOneTwoCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixOneTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypesevenOneTwo = "publishedTypesevenOneTwo";

var PublishedTypesevenOneTwo = function PublishedTypesevenOneTwo($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypesevenOneTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypesevenOneTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypesevenOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		self.checkWorkingDays = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (presentDays > workingDays) {
				toastr.error("Working days cannot be less than present days.");
				$rootScope.working_days = presentDays.toString();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypesevenOneTwoCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee);

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypesevenOneTwoCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values);
			this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypesevenOneTwoCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$scope.customOrderFn = function (skill) {
				var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
				return orderList.indexOf(skill.dimension);
			};
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypesevenOneTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveOneTwo = "publishedTypeFiveOneTwo";

var PublishedTypeFiveOneTwo = function PublishedTypeFiveOneTwo($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveOneTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveOneTwoCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};

		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveOneTwoCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee, "this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveOneTwoCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values);
			this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveOneTwoCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveOneTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveEight = "publishedTypeFiveEight";

var PublishedTypeFiveEight = function PublishedTypeFiveEight($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveEight);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	vm.isNine = false;
	this.$onInit = function () {
		vm.isNine = false;
		try {
			if (this.publishedTypeFiveEightCtrl && this.publishedTypeFiveEightCtrl.reportCardArray && this.publishedTypeFiveEightCtrl.reportCardArray.student && this.publishedTypeFiveEightCtrl.reportCardArray.student.class) {
				if (this.publishedTypeFiveEightCtrl.reportCardArray.student.class == "9") {
					vm.isNine = true;
				}
			}
		} catch (e1) {
			console.log(e1);
		}

		vm.reportCardArray = this.publishedTypeFiveEightCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveEightCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveEightCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeFiveEightCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeFiveEightCtrl.reportCardArray.lifee, "this.publishedTypeFiveEightCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeFiveEightCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveEightCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveEightCtrl.reportCardArray.att_values);
			this.publishedTypeFiveEightCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveEightCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveEightCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveEight.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveThreeFive = "publishedTypeFiveThreeFive";

var PublishedTypeFiveThreeFive = function PublishedTypeFiveThreeFive($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveThreeFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveThreeFiveCtrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveThreeFiveCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee, "this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values);
			this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveThreeFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixThreeFive = "publishedTypeSixThreeFive";

var PublishedTypeSixThreeFive = function PublishedTypeSixThreeFive($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixThreeFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixThreeFiveCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		console.log(this.publishedTypeSixThreeFiveCtrl, "this.publishedTypeSixThreeFiveCtrl");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixThreeFiveCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee, "this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixThreeFiveCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values);
			this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixThreeFiveCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixThreeFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixSixSeven = "publishedTypeSixSixSeven";

var PublishedTypeSixSixSeven = function PublishedTypeSixSixSeven($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixSixSeven);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixSixSevenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeSixSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee, "this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixSixSevenCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values);
			this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});

			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixSixSevenCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixSixSeven.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveSixSeven = "publishedTypeFiveSixSeven";

var PublishedTypeFiveSixSeven = function PublishedTypeFiveSixSeven($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveSixSeven);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveSixSevenCtrl.reportCardArray;
		console.log(this.publishedTypeFiveSixSevenCtrl.reportCardArray, "$onInit");
		vm.buckets = this.publishedTypeFiveSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveSixSevenCtrl.reportCardArray.additional_subjects;

		self.checkWorkingDays = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (presentDays > workingDays) {
				toastr.error("Working days cannot be less than present days.");
				$rootScope.working_days = presentDays.toString();
			}
		};

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee);
			console.log(this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee, "this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveSixSevenCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values);
			this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveSixSevenCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveSixSeven.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeThirtyKbEightNine = 'publishedTypeThirtykbEightNine';

var PublishedTypeThirtyKbEightNine = function PublishedTypeThirtyKbEightNine($scope, $state, $window, $stateParams, $sce) {
	'ngInject';

	_classCallCheck(this, PublishedTypeThirtyKbEightNine);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeThirtyKbEightNineCtrl.reportCardArray;
		vm.buckets = this.publishedTypeThirtyKbEightNineCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeThirtyKbEightNine.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTenKbTen = 'publishedTypeTenKbTen';

var PublishedTypeTenKbTen = function PublishedTypeTenKbTen($scope, $state, $window, $stateParams, $sce) {
	'ngInject';

	_classCallCheck(this, PublishedTypeTenKbTen);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTenKbTenCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTenKbTenCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
PublishedTypeTenKbTen.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var publishedTypeTenKbElevenTwelve = 'publishedTypeTenKbElevenTwelve';

var PublishedTypeTenKbElevenTwelve = function PublishedTypeTenKbElevenTwelve($scope, $state, $window, $stateParams, $sce) {
	'ngInject';

	_classCallCheck(this, PublishedTypeTenKbElevenTwelve);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTenKbElevenTwelveCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTenKbElevenTwelveCtrl.reportCardArray.report_card_template.activity_buckets;

		$scope.isEmpty = function (obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					return false;
				}
			}
			return true;
		};
	};
};
PublishedTypeTenKbElevenTwelve.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

// ===== NEW26: PublishedTypeTenKbElevenTwelveNew26 Class Start =====


var publishedTypeTenKbElevenTwelveNew26 = 'publishedTypeTenKbElevenTwelveNew26';

var PublishedTypeTenKbElevenTwelveNew26 = function PublishedTypeTenKbElevenTwelveNew26($scope, $state, $window, $stateParams, $sce) {
	'ngInject';

	_classCallCheck(this, PublishedTypeTenKbElevenTwelveNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.report_card_template.activity_buckets;

		$scope.isEmpty = function (obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					return false;
				}
			}
			return true;
		};
	};
};
PublishedTypeTenKbElevenTwelveNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];
// ===== END NEW26: PublishedTypeTenKbElevenTwelveNew26 =====

var publishedTypeTwelveScience = "publishedTypeTwelveScience";

var PublishedTypeTwelveScience = function PublishedTypeTwelveScience($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTwelveScience);

	var vm = this;
	$scope.scienceComment = false;
	$scope.commerceComment = false;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTwelveScienceCtrl.reportCardArray;
		vm.buckets = this.publishedTypeTwelveScienceCtrl.reportCardArray.report_card_template.activity_buckets;
		if (this.publishedTypeTwelveScienceCtrl.reportCardArray.student.stream == 'Science') {
			$scope.scienceComment = true;
			$scope.commerceComment = false;
		}
		if (this.publishedTypeTwelveScienceCtrl.reportCardArray.student.stream == 'Commerce') {
			$scope.commerceComment = true;
			$scope.scienceComment = false;
		}

		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
	};
};
PublishedTypeTwelveScience.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var typePtNoConv = "typePtNoConv";

var TypePtNoConv = function TypePtNoConv($scope, $state, $window, $stateParams, $sce) {
	"ngInject";

	_classCallCheck(this, TypePtNoConv);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.typePtNoConvCtrl.reportCardArray;
		vm.buckets = this.typePtNoConvCtrl.reportCardArray.report_card_template.activity_buckets;
	};
};
TypePtNoConv.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce"];

var montessoryConsolidate = "montessoryConsolidate";

var MontessoryConsolidated = function MontessoryConsolidated($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, MontessoryConsolidated);

	var vm = this;
	vm.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.montessoryConsolidatedCtrl.reportCardArray;
		vm.evaluations = vm.reportCardArray.reportCardArray.main_results;
		vm.reportResultArray = vm.reportCardArray.reportCardArray.main_result_report;
	};
};
MontessoryConsolidated.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var termoneTemplatepublishedTypeFiveThreeFive = "termoneTemplatepublishedTypeFiveThreeFive";

var TermOneTemplatePublishedTypeFiveThreeFive = function TermOneTemplatePublishedTypeFiveThreeFive($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeFiveThreeFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log($rootScope.published_date);
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeFiveThreeFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var termoneTemplatepublishedTypeSixSixSeven = "termoneTemplatepublishedTypeSixSixSeven";

var TermOneTemplatePublishedTypeSixSixSeven = function TermOneTemplatePublishedTypeSixSixSeven($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeSixSixSeven);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects;
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeSixSixSeven.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var termoneTemplatepublishedTypeEightNine = "termoneTemplatepublishedTypeEightNine";

var TermOneTemplatePublishedTypeEightNine = function TermOneTemplatePublishedTypeEightNine($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeEightNine);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeEightNine.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var termoneTemplatepublishedTypeOneTwo = "termoneTemplatepublishedTypeOneTwo";

var TermOneTemplatePublishedTypeOneTwo = function TermOneTemplatePublishedTypeOneTwo($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeOneTwo);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeOneTwo.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedtcsOneFive = "publishedtcsOneFive";

var PublishedtcsOneFive = function PublishedtcsOneFive($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedtcsOneFive);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedtcsOneFiveCtrl.reportCardArray;
		vm.buckets = this.publishedtcsOneFiveCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		console.log(this.publishedtcsOneFiveCtrl, "this.publishedtcsOneFiveCtrl");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedtcsOneFiveCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedtcsOneFiveCtrl.reportCardArray.lifee);
			console.log(this.publishedtcsOneFiveCtrl.reportCardArray.lifee, "this.publishedtcsOneFiveCtrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedtcsOneFiveCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedtcsOneFiveCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;

			console.log($rootScope.lifeskillselection, "$rootScope.lifeskillselection");
		};
		console.log(vm.selectedLifeskillValues, "vm.selectedLifeskillValues2");
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedtcsOneFiveCtrl.reportCardArray.att_values);
			this.publishedtcsOneFiveCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedtcsOneFiveCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedtcsOneFiveCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedtcsOneFive.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// ===== NEW26: Controllers Section Start =====
// NEW26 template controllers

// 1 to 2


var termoneTemplatepublishedTypeOneTwoNew26 = "termoneTemplatepublishedTypeOneTwoNew26";

var TermOneTemplatePublishedTypeOneTwoNew26 = function TermOneTemplatePublishedTypeOneTwoNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeOneTwoNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) return -1;
				if (a.dimension > b.dimension) return 1;
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeOneTwoNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var termoneTemplatepublishedTypeOneTwoNew26Shj = "termoneTemplatepublishedTypeOneTwoNew26Shj";

var TermOneTemplatePublishedTypeOneTwoNew26Shj = function TermOneTemplatePublishedTypeOneTwoNew26Shj($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeOneTwoNew26Shj);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) return -1;
				if (a.dimension > b.dimension) return 1;
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeOneTwoNew26Shj.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveOneTwoNew26ShjTerm2 = "publishedTypeFiveOneTwoNew26ShjTerm2";

var PublishedTypeFiveOneTwoNew26ShjTerm2 = function PublishedTypeFiveOneTwoNew26ShjTerm2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveOneTwoNew26ShjTerm2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	$scope.reportCardArray = undefined;
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray;
		if (this.publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.report_card_template) {
			vm.buckets = this.publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.report_card_template.activity_buckets;
		}
	};
};
PublishedTypeFiveOneTwoNew26ShjTerm2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveOneTwoNew26Term2 = "publishedTypeFiveOneTwoNew26Term2";

var PublishedTypeFiveOneTwoNew26Term2 = function PublishedTypeFiveOneTwoNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveOneTwoNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.report_card_template.activity_buckets;
		console.log("new26 Term2 (Annual) component init", vm.buckets);
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) return -1;
				if (a.dimension > b.dimension) return 1;
				return 0;
			});
		}

		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
		};

		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.att_values);
			this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};

		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex || {}).map(function (skill) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});

		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveOneTwoNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// 3 to 5


var termoneTemplatepublishedTypeFiveThreeFiveNew26 = "termoneTemplatepublishedTypeFiveThreeFiveNew26";

var TermOneTemplatePublishedTypeFiveThreeFiveNew26 = function TermOneTemplatePublishedTypeFiveThreeFiveNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeFiveThreeFiveNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.additional_subjects;
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) return -1;
				if (a.dimension > b.dimension) return 1;
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = { dimension: selectedDimension, selectedLevel: selectedLevel, description: selectedDescription };
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = { dimension: selectedDimension, selectedLevel: selectedLevel, description: selectedDescription };
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeFiveThreeFiveNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeFiveThreeFiveNew26Term2 = "publishedTypeFiveThreeFiveNew26Term2";

var PublishedTypeFiveThreeFiveNew26Term2 = function PublishedTypeFiveThreeFiveNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeFiveThreeFiveNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		console.log("publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.main_results", this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.main_results);
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.additional_subjects;
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) return -1;
				if (a.dimension > b.dimension) return 1;
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = { dimension: selectedDimension, selectedLevel: selectedLevel, description: selectedDescription };
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.att_values);
			this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = { dimension: selectedDimension, selectedLevel: selectedLevel, description: selectedDescription };
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeFiveThreeFiveNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];
// 6 to 7


var termoneTemplatepublishedTypeSixSixSevenNew26 = "termoneTemplatepublishedTypeSixSixSevenNew26";

var TermOneTemplatePublishedTypeSixSixSevenNew26 = function TermOneTemplatePublishedTypeSixSixSevenNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeSixSixSevenNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.additional_subjects;
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeSixSixSevenNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var publishedTypeSixSixSevenNew26 = "publishedTypeSixSixSevenNew26";

var PublishedTypeSixSixSevenNew26 = function PublishedTypeSixSixSevenNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeSixSixSevenNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		console.log(vm.life_skills, "vm.life_skills");
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {

			orderByDimension(this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee);
			console.log(this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee, "this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee");

			var selectedLevel = $rootScope.lifeskillselection[index].level;

			var selectedDescription = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedDimensionn = $rootScope.lifeskillselection[index].dimension;
			console.log(selectedDimensionn, 'selectedDimensionn');
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			console.log(selectedLifeskillData, "selectedLifeskillData");
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;

			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {

			orderByDimension(this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values);
			this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeSixSixSevenNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeSixSixSevenNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// 8-10 NEW26 Controllers


var TermOneTemplatePublishedTypeEightToTenNew26 = function TermOneTemplatePublishedTypeEightToTenNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeEightToTenNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeEightToTenNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedTypeEightToTenNew26Term2 = function PublishedTypeEightToTenNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeEightToTenNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.att_values);
			this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeEightToTenNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// Grade 9 NEW26 Controllers


var TermOneTemplatePublishedTypeNineTermCbseNew26 = function TermOneTemplatePublishedTypeNineTermCbseNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeNineTermCbseNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeNineTermCbseNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedTypeNineTermCbseNew26Term2 = function PublishedTypeNineTermCbseNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeNineTermCbseNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.att_values);
			this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeNineTermCbseNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// Grade 10 NEW26 Controllers


var TermOneTemplatePublishedTypeTenTermCbseNew26 = function TermOneTemplatePublishedTypeTenTermCbseNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeTenTermCbseNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
TermOneTemplatePublishedTypeTenTermCbseNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedTypeTenTermCbseNew26Term2 = function PublishedTypeTenTermCbseNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeTenTermCbseNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray;
		vm.buckets = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calatt = function () {
			var workingDays = Number($rootScope.working_days);
			var presentDays = Number($rootScope.days_attended);
			if (workingDays < presentDays) {
				$rootScope.days_attended = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendance_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		$scope.showAdditionalSubjectRow = 'Information Technology' in this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.additional_subjects;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.att_values);
			this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};
		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
			return skill;
		});
		$scope.customOrderFn = function (skill) {
			return skill.order;
		};
	};
};
PublishedTypeTenTermCbseNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];
// Grade 10 Kerala Board NEW26 Controllers


var TermOneTemplatePublishedType10KbGradeTerm1New26 = function TermOneTemplatePublishedType10KbGradeTerm1New26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedType10KbGradeTerm1New26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calattt1 = function () {
			var workingDays = Number($rootScope.working_days_term1);
			var presentDays = Number($rootScope.days_attended_term1);
			if (workingDays < presentDays) {
				$rootScope.days_attended_term1 = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendancetenKb10_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		self.calattt2 = function () {
			var workingDays = Number($rootScope.working_days_term2);
			var presentDays = Number($rootScope.days_attended_term2);
			if (workingDays < presentDays) {
				$rootScope.days_attended_term2 = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendancetenKb10_term2 = Math.round(attVal);
				$scope.$apply();
			}
		};
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.att_values);
			this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
			$rootScope.selectedAttitudeValues = selectedAttitudeData;
		};
		$scope.getLifeSkillValues = function (index) {
			if ($rootScope.lifeskillDataByIndex && $rootScope.lifeskillDataByIndex[index]) {
				return $rootScope.lifeskillDataByIndex[index].selectedLevel;
			}
			return '';
		};
		$scope.getAttitudeValue = function (index) {
			if ($rootScope.attitudeDataByIndex && $rootScope.attitudeDataByIndex[index]) {
				return $rootScope.attitudeDataByIndex[index].selectedLevel;
			}
			return '';
		};
		var self = this;
		if (this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee) {
			var orderList = [];
			var dimensionList = this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee.map(function (skill) {
				return skill.dimension;
			});
			this.termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.lifee.forEach(function (skill) {
				var orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});
			$scope.customOrderFn = function (skill) {
				return skill.order;
			};
		}
	};
};
TermOneTemplatePublishedType10KbGradeTerm1New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedType10KbGradeTerm2New26 = function PublishedType10KbGradeTerm2New26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedType10KbGradeTerm2New26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray;
		vm.buckets = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		self.calattt1 = function () {
			var workingDays = Number($rootScope.working_days_term1);
			var presentDays = Number($rootScope.days_attended_term1);
			if (workingDays < presentDays) {
				$rootScope.days_attended_term1 = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendancetenKb10_term1 = Math.round(attVal);
				$scope.$apply();
			}
		};
		self.calattt2 = function () {
			var workingDays = Number($rootScope.working_days_term2);
			var presentDays = Number($rootScope.days_attended_term2);
			if (workingDays < presentDays) {
				$rootScope.days_attended_term2 = '';
				toastr.error("Working days cannot be less than present days.");
			} else {
				var attVal = presentDays / workingDays * 100;
				$rootScope.attendancetenKb10_term2 = Math.round(attVal);
				$scope.$apply();
			}
		};
		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}
		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};
		$scope.saveSelectedValues = function (index) {
			orderByDimension(this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.att_values);
			this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
			$rootScope.selectedAttitudeValues = selectedAttitudeData;
		};
		$scope.getLifeSkillValues = function (index) {
			if ($rootScope.lifeskillDataByIndex && $rootScope.lifeskillDataByIndex[index]) {
				return $rootScope.lifeskillDataByIndex[index].selectedLevel;
			}
			return '';
		};
		$scope.getAttitudeValue = function (index) {
			if ($rootScope.attitudeDataByIndex && $rootScope.attitudeDataByIndex[index]) {
				return $rootScope.attitudeDataByIndex[index].selectedLevel;
			}
			return '';
		};
		var self = this;
		if (this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee) {
			var orderList = [];
			var dimensionList = this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee.map(function (skill) {
				return skill.dimension;
			});
			this.publishedType10KbGradeTerm2New26Ctrl.reportCardArray.lifee.forEach(function (skill) {
				var orderIndex = orderList.indexOf(skill.dimension);
				skill.order = orderIndex !== -1 ? orderIndex : orderList.length;
				return skill;
			});
			$scope.customOrderFn = function (skill) {
				return skill.order;
			};
		}
	};
};
PublishedType10KbGradeTerm2New26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// Grade 11 NEW26 Controllers


var TermOneTemplatePublishedTypeZeroTwoGradeElevenScienceNew26 = function TermOneTemplatePublishedTypeZeroTwoGradeElevenScienceNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeZeroTwoGradeElevenScienceNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		vm.can_published_edit = this.termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.can_published_edit;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}

		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(vm.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = vm.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};

		$scope.saveSelectedValues = function (index) {
			orderByDimension(vm.reportCardArray.att_values);
			vm.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = vm.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};

		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex || {}).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			return Object.assign({}, skill, { order: orderIndex !== -1 ? orderIndex : 999 });
		}).sort(function (a, b) {
			return a.order - b.order;
		});
	};
};
TermOneTemplatePublishedTypeZeroTwoGradeElevenScienceNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedTypeZeroTwoGradeElevenScienceNew26Term2 = function PublishedTypeZeroTwoGradeElevenScienceNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeZeroTwoGradeElevenScienceNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl && this.publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray;
		$scope.reportCardArray = vm.reportCardArray;
		if (vm.reportCardArray) {
			vm.buckets = vm.reportCardArray.report_card_template ? vm.reportCardArray.report_card_template.activity_buckets : undefined;
			vm.life_skills = vm.reportCardArray.lifee;
			vm.att_values = vm.reportCardArray.att_values;
			if (vm.reportCardArray.extra_info) {
				$rootScope.attendance_term1 = $rootScope.attendance_term1 || vm.reportCardArray.extra_info.attendance_term1 || vm.reportCardArray.extra_info.attendance_term2 || vm.reportCardArray.extra_info.attendance;
				$rootScope.StdResult = $rootScope.StdResult || vm.reportCardArray.extra_info.StdResult || vm.reportCardArray.extra_info.result;
				$rootScope.StdPromotGrade = $rootScope.StdPromotGrade || vm.reportCardArray.extra_info.StdPromotGrade || vm.reportCardArray.extra_info.promoted_to;
				$rootScope.term_remarks1 = $rootScope.term_remarks1 || vm.reportCardArray.extra_info.term_remarks1 || vm.reportCardArray.extra_info.term_remarks2 || vm.reportCardArray.extra_info.remarks;
			}
		}
		vm.can_published_edit = this.publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl && this.publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.can_published_edit;

		function orderByDimension(array) {
			if (!array) return [];
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}

		$scope.saveSelectedValuesOne = function (index) {
			if (vm.reportCardArray && vm.reportCardArray.lifee) {
				orderByDimension(vm.reportCardArray.lifee);
				var selectedLevel = $rootScope.lifeskillselection[index].level;
				var selectedDescription = vm.reportCardArray.lifee[index].levels.find(function (level) {
					return level.level === selectedLevel;
				}).description;
				var selectedDimension = vm.reportCardArray.lifee[index].dimension;
				var selectedLifeskillData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription
				};
				$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
				$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
				$rootScope.lifeskillselection.push(selectedLifeskillData);
				$rootScope.selectedLifeskillValues = selectedLifeskillData;
			}
		};

		$scope.saveSelectedValues = function (index) {
			if (vm.reportCardArray && vm.reportCardArray.att_values) {
				orderByDimension(vm.reportCardArray.att_values);
				vm.reportCardArray.att_values.sort(function (a, b) {
					return a.order - b.order;
				});
				var selectedLevel = $rootScope.attitudeselection[index].level;
				var selectedDescription = vm.reportCardArray.att_values[index].levels.find(function (level) {
					return level.level === selectedLevel;
				}).description;
				var selectedDimension = vm.reportCardArray.att_values[index].dimension;
				var selectedAttitudeData = {
					dimension: selectedDimension,
					selectedLevel: selectedLevel,
					description: selectedDescription
				};
				$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
				$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
				$rootScope.attitudeselection.push(selectedAttitudeData);
			}
		};

		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex || {}).map(function (skill, index) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			return Object.assign({}, skill, { order: orderIndex !== -1 ? orderIndex : 999 });
		}).sort(function (a, b) {
			return a.order - b.order;
		});
	};
};
PublishedTypeZeroTwoGradeElevenScienceNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

// Grade 12 NEW26 Controllers


var TermOneTemplatePublishedTypeZeroTwoGradeTwelveScienceNew26 = function TermOneTemplatePublishedTypeZeroTwoGradeTwelveScienceNew26($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, TermOneTemplatePublishedTypeZeroTwoGradeTwelveScienceNew26);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.life_skills = undefined;
	$scope.att_values = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray;
		vm.buckets = this.termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.report_card_template.activity_buckets;
		vm.life_skills = vm.reportCardArray.lifee;
		vm.att_values = vm.reportCardArray.att_values;
		vm.can_published_edit = this.termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.can_published_edit;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}

		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(vm.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = vm.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};

		$scope.saveSelectedValues = function (index) {
			orderByDimension(vm.reportCardArray.att_values);
			vm.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = vm.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};

		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex || {}).map(function (skill) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			return Object.assign({}, skill, { order: orderIndex !== -1 ? orderIndex : 999 });
		}).sort(function (a, b) {
			return a.order - b.order;
		});
	};
};
TermOneTemplatePublishedTypeZeroTwoGradeTwelveScienceNew26.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];

var PublishedTypeZeroTwoGradeTwelveScienceNew26Term2 = function PublishedTypeZeroTwoGradeTwelveScienceNew26Term2($scope, $state, $window, $stateParams, $sce, $rootScope) {
	"ngInject";

	_classCallCheck(this, PublishedTypeZeroTwoGradeTwelveScienceNew26Term2);

	var vm = this;
	vm.reportCardArray = undefined;
	vm.buckets = undefined;
	vm.life_skills = undefined;
	vm.att_values = undefined;
	$scope.reportCardArray = undefined;
	$scope.selectedDescription = [];
	this.$onInit = function () {
		vm.reportCardArray = this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl && this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray ? this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray : {};
		vm.buckets = vm.reportCardArray && vm.reportCardArray.report_card_template && vm.reportCardArray.report_card_template.activity_buckets ? vm.reportCardArray.report_card_template.activity_buckets : [];
		vm.life_skills = vm.reportCardArray && vm.reportCardArray.lifee ? vm.reportCardArray.lifee : [];
		vm.att_values = vm.reportCardArray && vm.reportCardArray.att_values ? vm.reportCardArray.att_values : [];
		vm.can_published_edit = this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl && this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.can_published_edit ? this.publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.can_published_edit : false;

		function orderByDimension(array) {
			return array.sort(function (a, b) {
				if (a.dimension < b.dimension) {
					return -1;
				}
				if (a.dimension > b.dimension) {
					return 1;
				}
				return 0;
			});
		}

		$scope.saveSelectedValuesOne = function (index) {
			orderByDimension(vm.reportCardArray.lifee);
			var selectedLevel = $rootScope.lifeskillselection[index].level;
			var selectedDescription = vm.reportCardArray.lifee[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.lifee[index].dimension;
			var selectedLifeskillData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.lifeskillDataByIndex = $rootScope.lifeskillDataByIndex || {};
			$rootScope.lifeskillDataByIndex[index] = selectedLifeskillData;
			$rootScope.lifeskillselection.push(selectedLifeskillData);
			$rootScope.selectedLifeskillValues = selectedLifeskillData;
		};

		$scope.saveSelectedValues = function (index) {
			orderByDimension(vm.reportCardArray.att_values);
			vm.reportCardArray.att_values.sort(function (a, b) {
				return a.order - b.order;
			});
			var selectedLevel = $rootScope.attitudeselection[index].level;
			var selectedDescription = vm.reportCardArray.att_values[index].levels.find(function (level) {
				return level.level === selectedLevel;
			}).description;
			var selectedDimension = vm.reportCardArray.att_values[index].dimension;
			var selectedAttitudeData = {
				dimension: selectedDimension,
				selectedLevel: selectedLevel,
				description: selectedDescription
			};
			$rootScope.attitudeDataByIndex = $rootScope.attitudeDataByIndex || {};
			$rootScope.attitudeDataByIndex[index] = selectedAttitudeData;
			$rootScope.attitudeselection.push(selectedAttitudeData);
		};

		$scope.attitudeArray = Object.values($rootScope.attitudeDataByIndex || {}).map(function (skill) {
			var orderList = ["Attitude Towards School Program and Environment", "Attitude Towards Classmates", "Attitude Towards Teachers", "Value System"];
			var orderIndex = orderList.indexOf(skill.dimension);
			return Object.assign({}, skill, { order: orderIndex !== -1 ? orderIndex : 999 });
		}).sort(function (a, b) {
			return a.order - b.order;
		});
	};
};
PublishedTypeZeroTwoGradeTwelveScienceNew26Term2.$inject = ["$scope", "$state", "$window", "$stateParams", "$sce", "$rootScope"];
// ===== END NEW26: Controllers Section =====

exports.default = angular.module(name, []).component(name, {
	template: _publishedMain2.default,
	controllerAs: "publishedReportsListCtrl",
	controller: PublishedReportsListCtrl
}).component(typeOneHfYComponent, {
	template: _type1Hf2.default,
	transclude: true,
	require: {
		typeOneHfYTemplateCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeOneHfYTemplateCtrl",
	controller: TypeOneHfYTemplateClass
}).component(periodicTestDefaultHfPublished, {
	template: _periodicTestHf2.default,
	transclude: true,
	require: {
		pTPublishedDefauHlFCtrl: "^reportsMainComponent"
	},
	controllerAs: "pTHFCtrl",
	controller: PeriodicTestDefaultHfPublished
}).component(periodicTestDefaultAnnualPublished, {
	template: _periodicTestAnnual2.default,
	transclude: true,
	bindings: true,
	require: {
		pTPublishedDefaultAnnualCtrl: "^reportsMainComponent"
	},
	controllerAs: "pTAnnualCtrl",
	controller: PeriodicTestDefaultAnnualPublished
}).component(defaultYearEnd, {
	template: _defaultYearEnd2.default,
	transclude: true,
	bindings: true,
	require: {
		defaultYearEndCtrl: "^reportsMainComponent"
	},
	controllerAs: "defaultYearEndCtrl",
	controller: DefaultYearEnd
}).component(termConsolidated, {
	template: _term1Term2.default,
	transclude: true,
	bindings: true,
	require: {
		termConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "termConsolidatedCtrl",
	controller: TermConsolidated
}).component(educoreYearEnd, {
	template: _educoreYearEnd2.default,
	transclude: true,
	bindings: true,
	require: {
		educoreYearEndCtrl: "^reportsMainComponent"
	},
	controllerAs: "educoreYearEndCtrl",
	controller: EducoreYearEnd
}).component(skilSubSkill, {
	template: _skillSubskill2.default,
	transclude: true,
	bindings: true,
	require: {
		skilSubSkillCtrl: "^reportsMainComponent"
	},
	controllerAs: "skilSubSkillCtrl",
	controller: SkilSubSkill
}).component(assetHF, {
	template: _type4Mark2.default,
	transclude: true,
	bindings: true,
	require: {
		assetHFCtrl: "^reportsMainComponent"
	},
	controllerAs: "assetHFCtrl",
	controller: AssetHF
}).component(assetAnnual, {
	template: _type4Annual2.default,
	transclude: true,
	bindings: true,
	require: {
		assetAnnualCtrl: "^reportsMainComponent"
	},
	controllerAs: "assetAnnualCtrl",
	controller: AssetAnnual
}).component(periodicTestDefaultHfTwoPublished, {
	template: _periodicTestHf4.default,
	transclude: true,
	require: {
		pTPublishedHfTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "ptHfTwoCtrl",
	controller: PeriodicTestDefaultHfTwoPublished
}).component(periodicTestDefaultAnnualTwoPublished, {
	template: _periodicTestAnnualTwo2.default,
	transclude: true,
	require: {
		pTPublishedDefaultAnnualTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "ptAnnualTwoCtrl",
	controller: PeriodicTestDefaultAnnualTwoPublished
}).component(kgTerms, {
	template: _kgTerms2.default,
	transclude: true,
	bindings: true,
	require: {
		kgTermsCtrl: "^reportsMainComponent"
	},
	controllerAs: "kgTermsCtrl",
	controller: KgTerms
}).component(kgConsolidated, {
	template: _kgConsolidated2.default,
	transclude: true,
	bindings: true,
	require: {
		kgConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "kgConsolidatedCtrl",
	controller: KgConsolidated
}).component(kbTerms, {
	template: _kbTerms2.default,
	transclude: true,
	bindings: {
		attendance: "@"
	},
	require: {
		kbTermsCtrl: "^reportsMainComponent"
	},
	controllerAs: "kbTermsCtrl",
	controller: KbTerms
}).component(hssTemplateComponent, {
	template: _hssTemplate2.default,
	transclude: true,
	bindings: true,
	require: {
		hssReportCtrl: "^reportsMainComponent"
	},
	controllerAs: "hssReportCtrl",
	controller: HssTemplateComponentClass
}).component(cbseHssPublishedComponent, {
	template: _cbse_hss2.default,
	transclude: true,
	bindings: true,
	require: {
		cbseHssPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "cbseHssPublishedCtrl",
	controller: CbseHssPublishedClass
}).component(specificHFComponent, {
	template: _term1halfyearly2.default,
	transclude: true,
	bindings: true,
	require: {
		specificHFPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "specificHFPublishedCtrl",
	controller: SpecificHFPublishedClass
}).component(kbhfhssComp, {
	template: _kbhfhss2.default,
	transclude: true,
	bindings: true,
	require: {
		KbhfhssPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "KbhfhssPublishedCtrl",
	controller: KbhfhssPublishedClass
}).component(cbseSpecificSubjectsFinalComp, {
	template: _grade9Annual2.default,
	transclude: true,
	bindings: true,
	require: {
		cbseSpecificSubjectsFinalCtrl: "^reportsMainComponent"
	},
	controllerAs: "cbseSpecificSubjectsFinalCtrl",
	controller: CbseSpecificSubjectsFinalClass
}).component(cbseSpecificoneeigthFinalComp, {
	template: _grade1_8Annual2.default,
	transclude: true,
	bindings: true,
	require: {
		cbseSpecificoneeghtFinalCtrl: "^reportsMainComponent"
	},
	controllerAs: "cbseSpecificoneeghtFinalCtrl",
	controller: CbseSpecificoneeigthFinalClass
}).component(kbFinalComponent, {
	template: _kb_final2.default,
	transclude: true,
	bindings: true,
	require: {
		kbFinalComponentCtrl: "^reportsMainComponent"
	},
	controllerAs: "kbFinalComponentCtrl",
	controller: kbFinalComponentClass
}).component(pubishedcbsehssAnnual, {
	template: _annual_cbse_hss2.default,
	transclude: true,
	bindings: true,
	require: {
		pubishedcbsehssAnnualCtrl: "^reportsMainComponent"
	},
	controllerAs: "pubishedcbsehssAnnualCtrl",
	controller: PubishedcbsehssAnnual
}).component(nineonlypubllishedComp, {
	template: _termAnnualOnly2.default,
	transclude: true,
	bindings: true,
	require: {
		nineonlypubllishedCompCtrl: "^reportsMainComponent"
	},
	controllerAs: "nineonlypubllishedCompCtrl",
	controller: NineonlypubllishedCompClass
}).component(kbannualHssPublished, {
	template: _kb_hss_annual2.default,
	transclude: true,
	bindings: true,
	require: {
		kbannualHssPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "kbannualHssPublishedCtrl",
	controller: KbannualHssPublishedClass
}).component(montessoryTerms, {
	template: _montessoryTerms2.default,
	transclude: true,
	bindings: true,
	require: {
		montessoryTermsPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "montessoryTermsPublishedCtrl",
	controller: montessoryTermsPublishedClass
}).component(montessoryConsolidated, {
	template: _montessoryConsolidated2.default,
	transclude: true,
	bindings: true,
	require: {
		montessoryConsolidatedPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "montessoryConsolidatedPublishedCtrl",
	controller: montessoryConsolidatedPublishedClass
}).component(kbhfPtPublishedComponent, {
	template: _periodicTestHfKb2.default,
	transclude: true,
	bindings: true,
	require: {
		kbhfPtPublishedPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "kbhfPtPublishedPublishedCtrl",
	controller: KbhfPtPublishedPublishedClass
}).component(hfexamOnePublishedComponent, {
	template: _hf1Exam2.default,
	transclude: true,
	bindings: true,
	require: {
		hfexamOnePublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "hfexamOnePublishedCtrl",
	controller: HfexamOnePublishedComponentClass
}).component(publishedCbseTypefiveNineTen, {
	template: _type5_9_10_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedCbseTypefiveNineTenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedCbseTypefiveNineTenCtrl",
	controller: PublishedCbseTypefiveNineTenClass
}).component(publishedTypeFiveKbten, {
	template: _type5_KB_10_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveKbtenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveKbtenCtrl",
	controller: PublishedTypeFiveKbtenClass
}).component(publishedTypeFiveSixEight, {
	template: _type5_6_8_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveSixEightCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveSixEightCtrl",
	controller: PublishedTypeFiveSixEight
}).component(publishedTypeFiveOneFive, {
	template: _type5_1_5_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveOneFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveOneFiveCtrl",
	controller: PublishedTypeFiveOneFive
}).component(publishedTypeFiveKbEightNine, {
	template: _type5_KB_8_9_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveKbEightNineCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveKbEightNineCtrl",
	controller: PublishedTypeFiveKbEightNine
}).component(publishedTypeSixModalExamTermOne, {
	template: _type_6_model_exam_2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixModalExamTermOneCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixModalExamTermOneCtrl",
	controller: PublishedTypeSixModalExamTermOne
}).component(typesixModelExamTermOneninetenPublished, {
	template: _type_6_model_exam_1_nineten2.default,
	transclude: true,
	bindings: true,
	require: {
		typesixModelExamTermOneninetenPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "typesixModelExamTermOneninetenPublishedCtrl",
	controller: TypesixModelExamTermOneninetenPublished
}).component(typesixModelExamTermTwoninetenPublished, {
	template: _type_6_model_exam_2_nineten2.default,
	transclude: true,
	bindings: true,
	require: {
		typesixModelExamTermTwoninetenPublishedCtrl: "^reportsMainComponent"
	},
	controllerAs: "typesixModelExamTermTwoninetenPublishedCtrl",
	controller: TypesixModelExamTermTwoninetenPublished
}).component(publishedTypeSixModalExamTermTwonospace, {
	template: _type_6_model_exam_4.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixModalExamTermTwonospaceCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixModalExamTermTwonospaceCtrl",
	controller: PublishedTypeSixModalExamTermTwonospace
}).component(publishedTypeSixModelannualexam, {
	template: _type_6_model_annualexam_2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixModelannualexamCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixModelannualexamCtrl",
	controller: PublishedTypeSixModelannualexam
}).component(publishedTypeSevenCalicutAnnualexam, {
	template: _calicut_annual2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSevenCalicutAnnualexamCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSevenCalicutAnnualexamCtrl",
	controller: PublishedTypeSevenCalicutAnnualexam
}).component(kgthematictermsComponent, {
	template: _kgThematicterms2.default,
	transclude: true,
	bindings: true,
	require: {
		kgthematictermsCtrl: "^reportsMainComponent"
	},
	controllerAs: "kgthematictermsCtrl",
	controller: KgthematictermsClass
}).component(typeNineCbseConsolidated, {
	template: _type9_term1_hf2.default,
	transclude: true,
	bindings: true,
	require: {
		typeNineCbseConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeNineCbseConsolidatedCtrl",
	controller: TypeNineCbseConsolidated
}).component(typeNineCbsept, {
	template: _type9_cbse_pt2.default,
	transclude: true,
	bindings: true,
	require: {
		typeNineCbseptCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeNineCbseptCtrl",
	controller: TypeNineCbsept
}).component(typeNineTwelveCbseConsolidated, {
	template: _type9_grade12term2_ae2.default,
	transclude: true,
	bindings: true,
	require: {
		typeNineTwelveCbseConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeNineTwelveCbseConsolidatedCtrl",
	controller: TypeNineTwelveCbseConsolidated
}).component(typeNinekbUnitTest, {
	template: _type9_kb_unit_test2.default,
	transclude: true,
	bindings: true,
	require: {
		typeNinekbUnitTestCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeNinekbUnitTestCtrl",
	controller: TypeNinekbUnitTest
}).component(typeNinekbConsolidated, {
	template: _type9_kbterm2.default,
	transclude: true,
	bindings: true,
	require: {
		typeNinekbConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "typeNinekbConsolidatedCtrl",
	controller: TypeNinekbConsolidated
}).component(publishedTypeTwelveOneEight, {
	template: _type12_termcbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwelveOneEightCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwelveOneEightCtrl",
	controller: PublishedTypeTwelveOneEight
}).component(publishedTypeTwelveNineTen, {
	template: _type12_ninetentermcbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwelveNineTenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwelveNineTenCtrl",
	controller: PublishedTypeTwelveNineTen
}).component(publishedEltReport, {
	template: _elt_report2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedEltReportCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedEltReportCtrl",
	controller: PublishedEltReport
}).component(publishedType20kbterms, {
	template: _type20_KB_10_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedType20kbtermsCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedType20kbtermsCtrl",
	controller: PublishedType20kbterms
}).component(publishedTypeTwentyNineTen, {
	template: _type20_termcbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwentyNineTenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwentyNineTenCtrl",
	controller: PublishedTypeTwentyNineTen
}).component(publishedTypeTwentyOneEight, {
	template: _type20_termcbse4.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwentyOneEightCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwentyOneEightCtrl",
	controller: PublishedTypeTwentyOneEight
}).component(publishedType20kbterms2, {
	template: _type20_KB_10_grade_term4.default,
	transclude: true,
	bindings: true,
	require: {
		publishedType20kbterms2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedType20kbterms2Ctrl",
	controller: PublishedType20kbterms2
}).component(publishedTypeTwentyNineTenTwo, {
	template: _type20_term2cbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwentyNineTenTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwentyNineTenTwoCtrl",
	controller: PublishedTypeTwentyNineTenTwo
}).component(publishedTypeTwentyOneEightTwo, {
	template: _type20_term2cbse4.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwentyOneEightTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwentyOneEightTwoCtrl",
	controller: PublishedTypeTwentyOneEightTwo
}).component(publishedTypeFiveSixSeven, {
	template: _type5_6_7_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveSixSevenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveSixSevenCtrl",
	controller: PublishedTypeFiveSixSeven
}).component(publishedTypeSixSixSeven, {
	template: _type6_6_7_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixSixSevenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixSixSevenCtrl",
	controller: PublishedTypeSixSixSeven
}).component(publishedTypeSixThreeFive, {
	template: _type6_3_5_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixThreeFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixThreeFiveCtrl",
	controller: PublishedTypeSixThreeFive
}).component(publishedTypeFiveOneTwo, {
	template: _type5_1_2_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveOneTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveOneTwoCtrl",
	controller: PublishedTypeFiveOneTwo
}).component(publishedTypeSixOneTwo, {
	template: _type6_1_2_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixOneTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixOneTwoCtrl",
	controller: PublishedTypeSixOneTwo
}).component(publishedTypeFiveEight, {
	template: _type5_8_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveEightCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveEightCtrl",
	controller: PublishedTypeFiveEight
}).component(publishedTypeFiveThreeFive, {
	template: _type5_3_5_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveThreeFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveThreeFiveCtrl",
	controller: PublishedTypeFiveThreeFive
}).component(publishedTypeEightToTen, {
	template: _type8to10_termcbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeEightToTenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeEightToTenCtrl",
	controller: PublishedTypeEightToTen
}).component(publishedTypeEightToTen2, {
	template: _typetermcbse_8to2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeEightToTen2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeEightToTen2Ctrl",
	controller: PublishedTypeEightToTen2
}).component(publishedTypeSixToSeven, {
	template: _type6to7_alncbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixToSevenCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixToSevenCtrl",
	controller: PublishedTypeSixToSeven
}).component(publishedTypeSixToSeven2, {
	template: _type6to7_tcscbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixToSeven2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixToSeven2Ctrl",
	controller: PublishedTypeSixToSeven2
}).component(publishedTypeThreeToFive, {
	template: _type3to5_tcscbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeThreeToFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeThreeToFiveCtrl",
	controller: PublishedTypeThreeToFive
}).component(publishedTypeThreeToFive2, {
	template: _type3to5_alncbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeThreeToFive2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeThreeToFive2Ctrl",
	controller: PublishedTypeThreeToFive2
}).component(publishedTypeOneToTwo, {
	template: _type1to2_tcscbse2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeOneToTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeOneToTwoCtrl",
	controller: PublishedTypeOneToTwo
}).component(publishedTypesevenOneTwo, {
	template: _type7_1_2_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypesevenOneTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypesevenOneTwoCtrl",
	controller: PublishedTypesevenOneTwo
}).component(publishedTypeThirtyKbEightNine, {
	template: _type30_KB_8_9_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeThirtyKbEightNineCtrl: '^reportsMainComponent'
	},
	controllerAs: "publishedTypeThirtyKbEightNineCtrl",
	controller: PublishedTypeThirtyKbEightNine
}).component(publishedTypeTenKbTen, {
	template: _type10_KB_grade_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTenKbTenCtrl: '^reportsMainComponent'
	},
	controllerAs: "publishedTypeTenKbTenCtrl",
	controller: PublishedTypeTenKbTen
}).component(publishedTypeTenKbElevenTwelve, {
	template: _type10_KB_grade11_12_term2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTenKbElevenTwelveCtrl: '^reportsMainComponent'
	},
	controllerAs: "publishedTypeTenKbElevenTwelveCtrl",
	controller: PublishedTypeTenKbElevenTwelve
}).component(publishedTypeTenKbElevenTwelveNew26, {
	// ===== NEW26: Component Registration Start =====
	template: _type10_KB_grade11_12_term1_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTenKbElevenTwelveNew26Ctrl: '^reportsMainComponent'
	},
	controllerAs: "publishedTypeTenKbElevenTwelveNew26Ctrl",
	controller: PublishedTypeTenKbElevenTwelveNew26
	// ===== END NEW26 =====
}).component(publishedTypeElevenScience, {
	template: _type02grade_11_science2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeElevenScienceCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeElevenScienceCtrl",
	controller: PublishedTypeElevenScience
}).component(publishedTypeElevenScienceNoModel, {
	template: _type02grade_11_science_noModelExam2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeElevenScienceCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeElevenScienceCtrl",
	controller: PublishedTypeElevenScience
}).component(publishedTypeTwelveScience, {
	template: _type02grade_12_science2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTwelveScienceCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTwelveScienceCtrl",
	controller: PublishedTypeTwelveScience
}).component(typePtNoConv, {
	template: _pt_1_no_conv2.default,
	transclude: true,
	bindings: true,
	require: {
		typePtNoConvCtrl: "^reportsMainComponent"
	},
	controllerAs: "typePtNoConvCtrl",
	controller: TypePtNoConv
}).component(montessoryConsolidate, {
	template: _montessoryConsolidated2.default,
	transclude: true,
	bindings: true,
	require: {
		montessoryConsolidatedCtrl: "^reportsMainComponent"
	},
	controllerAs: "montessoryConsolidatedCtrl",
	controller: MontessoryConsolidated
}).component(termoneTemplatepublishedTypeFiveThreeFive, {
	template: _type5_3_5_grade_term4.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeFiveThreeFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeFiveThreeFiveCtrl",
	controller: TermOneTemplatePublishedTypeFiveThreeFive
}).component("termoneTemplatepublishedTypeSixSixSeven", {
	template: _type6_6_7_grade_term4.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeSixSixSevenCtrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeSixSixSevenCtrl",
	controller: TermOneTemplatePublishedTypeSixSixSeven
}).component("termoneTemplatepublishedTypeEightNine", {
	template: _type8to10_termcbse4.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeEightNineCtrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeEightNineCtrl",
	controller: TermOneTemplatePublishedTypeEightNine
}).component("termoneTemplatepublishedTypeOneTwo", {
	template: _type5_1_2_grade_term4.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeOneTwoCtrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeOneTwoCtrl",
	controller: TermOneTemplatePublishedTypeOneTwo
}).component(publishedtcsOneFive, {
	template: _type1to5_tcscbse_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedtcsOneFiveCtrl: "^reportsMainComponent"
	},
	controllerAs: "publishedtcsOneFiveCtrl",
	controller: PublishedtcsOneFive
})

// ===== NEW26: Component Registrations Block Start =====
//NEW26 Templates

// 1  to 2;

.component("termoneTemplatepublishedTypeOneTwoNew26", { // grade 1-2 term 1
	template: _type5_1_2_grade_term1_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeOneTwoNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeOneTwoNew26Ctrl",
	controller: TermOneTemplatePublishedTypeOneTwoNew26
})

// 1 to 2 Term 1 (Sharjah)

.component(termoneTemplatepublishedTypeOneTwoNew26Shj, { // grade 1-2 term 1 shj
	template: _type5_1_2_grade_term1_new26_shj2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeOneTwoNew26ShjCtrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeOneTwoNew26ShjCtrl",
	controller: TermOneTemplatePublishedTypeOneTwoNew26Shj
}).component(publishedTypeFiveOneTwoNew26ShjTerm2, { // grade 1-2 term 2 SHJ
	template: _type5_1_2_grade_term2_new26_shj2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveOneTwoNew26ShjTerm2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveOneTwoNew26ShjTerm2Ctrl",
	controller: PublishedTypeFiveOneTwoNew26ShjTerm2
})

// 1 to 2 term 2 (annual)

.component(publishedTypeFiveOneTwoNew26Term2, { // grade 1-2 term 2 (annual)
	template: _type5_1_2_grade_term2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveOneTwoNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveOneTwoNew26Term2Ctrl",
	controller: PublishedTypeFiveOneTwoNew26Term2
})

// 3 to 5

.component(termoneTemplatepublishedTypeFiveThreeFiveNew26, { //grade 3-5 term 1
	template: _type5_3_5_grade_term1_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl",
	controller: TermOneTemplatePublishedTypeFiveThreeFiveNew26
}).component(publishedTypeFiveThreeFiveNew26Term2, { //grade 3-5 term 2
	template: _type5_3_5_grade_term2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeFiveThreeFiveNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeFiveThreeFiveNew26Term2Ctrl",
	controller: PublishedTypeFiveThreeFiveNew26Term2
})

// 6 to 7

.component(termoneTemplatepublishedTypeSixSixSevenNew26, { //grade 6-7 term 1
	template: term1TemplatepublishedType6_6_7_templateNew26,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeSixSixSevenNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeSixSixSevenNew26Ctrl",
	controller: TermOneTemplatePublishedTypeSixSixSevenNew26
}).component(publishedTypeSixSixSevenNew26, { //grade 6-7 term 2
	template: _type6_6_7_grade_term2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeSixSixSevenNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeSixSixSevenNew26Ctrl",
	controller: PublishedTypeSixSixSevenNew26
})

// Grade 11 NEW26 Components

.component(termoneTemplatepublishedTypeZeroTwoGradeElevenScienceNew26, {
	template: _type02grade_11_science_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedType02Grade11ScienceNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedType02Grade11ScienceNew26Ctrl",
	controller: TermOneTemplatePublishedTypeZeroTwoGradeElevenScienceNew26
}).component(publishedTypeZeroTwoGradeElevenScienceNew26Term2, {
	template: _type02grade_11_sciencet2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl",
	controller: PublishedTypeZeroTwoGradeElevenScienceNew26Term2
})

// Grade 12 NEW26 Components

.component(termoneTemplatepublishedTypeZeroTwoGradeTwelveScienceNew26, {
	template: _type02grade_12_science_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedType02Grade12ScienceNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedType02Grade12ScienceNew26Ctrl",
	controller: TermOneTemplatePublishedTypeZeroTwoGradeTwelveScienceNew26
}).component(publishedTypeZeroTwoGradeTwelveScienceNew26Term2, {
	template: _type02grade_12_sciencet2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl",
	controller: PublishedTypeZeroTwoGradeTwelveScienceNew26Term2
})

// 8-10 NEW26 Components

.component(termoneTemplatepublishedTypeEightToTenNew26, { //grade 8-10 term 1
	template: _type8to10_termcbse_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeEightToTenNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeEightToTenNew26Ctrl",
	controller: TermOneTemplatePublishedTypeEightToTenNew26
}).component(publishedTypeEightToTenNew26Term2, { //grade 8-10 term 2
	template: _type8to10_termcbseterm2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeEightToTenNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeEightToTenNew26Term2Ctrl",
	controller: PublishedTypeEightToTenNew26Term2
})

// Grade 9 NEW26 Components

.component(termoneTemplatepublishedTypeNineTermCbseNew26, { //grade 9 term 1
	template: _type9_termcbse_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeNineTermCbseNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeNineTermCbseNew26Ctrl",
	controller: TermOneTemplatePublishedTypeNineTermCbseNew26
}).component(publishedTypeNineTermCbseNew26Term2, { //grade 9 term 2
	template: _type9_termcbseterm2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeNineTermCbseNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeNineTermCbseNew26Term2Ctrl",
	controller: PublishedTypeNineTermCbseNew26Term2
})

// Grade 10 NEW26 Components

.component(termoneTemplatepublishedTypeTenTermCbseNew26, { //grade 10 term 1
	template: _type10_termcbse_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedTypeTenTermCbseNew26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedTypeTenTermCbseNew26Ctrl",
	controller: TermOneTemplatePublishedTypeTenTermCbseNew26
}).component(publishedTypeTenTermCbseNew26Term2, { //grade 10 term 2
	template: _type10_termcbseterm2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedTypeTenTermCbseNew26Term2Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedTypeTenTermCbseNew26Term2Ctrl",
	controller: PublishedTypeTenTermCbseNew26Term2
})

// Grade 10 Kerala Board NEW26 Components

.component(termoneTemplatepublishedType10KbGradeTerm1New26, {
	template: _type10_KB_grade_term1_new2.default,
	transclude: true,
	bindings: true,
	require: {
		termOneTemplatepublishedType10KbGradeTerm1New26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "termOneTemplatepublishedType10KbGradeTerm1New26Ctrl",
	controller: TermOneTemplatePublishedType10KbGradeTerm1New26
}).component(publishedType10KbGradeTerm2New26, {
	template: _type10_KB_grade_term2_new2.default,
	transclude: true,
	bindings: true,
	require: {
		publishedType10KbGradeTerm2New26Ctrl: "^reportsMainComponent"
	},
	controllerAs: "publishedType10KbGradeTerm2New26Ctrl",
	controller: PublishedType10KbGradeTerm2New26
})
// ===== END NEW26: Component Registrations Block =====


.constant("rcConstants", {
	_NOT_APPLICABLE: "NA",
	ABSENT: "ABSENT",
	TYPE_1_MARK: "type-1-mark",
	TYPE_1_DEFAULT_ANNUAL: "type-1-annual",
	TYPE_1_GRADE: "type-1-grade",
	TYPE_2_MARK: "type-2-mark",
	TYPE_SKILL_ONLY: "skill_only",
	TYPE_3_SUB_SLILL: "type-3-sub_skill",
	DEFAULT_PERIODICTEST_HF: "periodic-test-hf",
	DEFAULT_PERIODICTEST_ANNUAL: "periodic-test-annual",
	_CO_SCHOLASTIC_NAME: "Co-scholastic",
	GRADE_BASED_SUBJECT_PACKAGES: ["Co-scholastic"],
	DEFAULT_REPORTCARD_PT_HF_TWO: "Periodic Test-II-Half Yearly",
	DEFAULT_REPORTCARD_PT_ANNUAL_TWO: "Periodic Test-II-Annual",
	REPORT_CARDS_PERIODIC_TEST: ["Periodic Test-Half Yearly", "Periodic Test-II-Half Yearly", "Periodic Test-Annual", "Periodic Test-II-Annual"],
	DEFAULT_REPORTCARDS: ["Annual", "Half Yearly", "Periodic Test-Half Yearly", "Periodic Test-Annual", "Periodic Test-II-Half Yearly", "Periodic Test-II-Annual"],
	DEFAULT_ANUAL_REPORTCARD: "Annual",
	DEFAULT_REPORTCARD_PT_ANNUAL: "Periodic Test-Annual",
	DEFAULT_REPORTCARD_PT_HF: "Periodic Test-Half Yearly",
	DEFAULT_PERIODICTEST_HF_TWO: "periodic-test-hf-2",
	DEFAULT_PERIODICTEST_ANNUAL_TWO: "periodic-test-annual-two",
	DEFAULT_HF_REPORTCARD: "Half Yearly",
	DEFAULT_REPORT_CARDS_FOR_YEAREND: ["Annual", "Half Yearly"],
	DEFAULT_YEAR_END: "default-year-end",
	EDUCORE_YEAR_END: "educore-year-end",
	EVALUATION_RC: ["Evaluation-3", "Evaluation-2", "Evaluation-1"],
	EVAL_ONE_RC: "Evaluation-1",
	EVAL_TWO_RC: "Evaluation-2",
	EVAL_THREE_RC: "Evaluation-3",
	ASSET_ME_RC_HALF: ["Term 1"],
	ASSET_ME_RC_HALF_NAME: "Term 1",
	ASSET_ME_RC_ANNUAL_NAME: "Term 2",
	ASSET_ME_RC_NAMES: ["Term 1", "Term 2"],
	TYPE_4_MARK: "type-4-mark",
	TYPE_4_ANNUAL: "type-4-annual",
	ASSET_CONSOLIDATED: "term1-term2",
	KG_CARDS: ["KG-Term-1", "KG-Term-2", "KG-Term-3"],
	KB_CARDS: ["KB-Term-1", "KB-Term-2", "KB-Term-3"],
	MONTESSORY_CARDS: ["MONTESSORI-Term-I", "MONTESSORI-Term-II", "MONTESSORI-Term-III"],
	KG_TERM: "kg-term",
	KG_TERMS: "kg-terms",
	KB_TERMS: "kb-terms",
	MONTESSORY_TERMS: "montessory",
	MONTESSORY_CONSOLIDATED: "montessory-consolidated",
	KG_CONSOLIDATED: "kg-consolidated",
	HIGHER_SECONDARY_REPORT: "hss-template",
	CBSE_HSHF: "cbse_hss",
	NON_FINAL_SCHOOL_IDS: ["m2LMtqaESFZf6xDE8", "ps4vyLJhQvPZjfxaH", "apX7mQ9LsV2kZdFaH"],
	MEP_STATIC_SCHOOL_IDS: ["ps4vyLJhQvPZjfxaH", "apX7mQ9LsV2kZdFaH"]
}).controller("reportsMainComponent", PublishedReportsListCtrl);


function config($stateProvider) {
	"ngInject";

	$stateProvider.state("reportsMain", {
		url: "/view-report/:student_id/:console_id/:type/:template_view/:asset_format/:selected_year/:kb_consolidated/:kg_consolidated/:montessori_consolidated:for_ct",
		template: "<reports-main-component></reports-main-component>"
	});
}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1080px;margin:5px auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 -40;float:left;display:block;height:130px}.tcs_1_5_school_logo img{width:100px;height:100px;margin:0 -10px;float:left;display:block}.tcs_1_5_student_img img{width:120px;height:130px;margin:0 16px;float:left;display:block}.annexure_con{width:872px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.2rem 1rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.footer-bottom-reportbtn{border:2px solid #fff;background:#1665c1;margin:10px 10px;border-radius:32px;padding:3px 10px}.max_mark_span{font-style:italic;font-size:12px;float:right}.stud_img{width:140px;height:170px;border-radius:5%;margin:4px;margin-left:-86px;margin-top:0;border:6px solid #fff;position:absolute}</style> <div class=main_bg style=padding-bottom:65px ng-if=!pdfData> <md-backdrop style=position:fixed;z-index:59!important ng-show=loading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=main_con ng-if=\"!hssTemplate \"> <div ng-if=!publishedtcsOneFivetemplate class=profile_img> </div> <div ng-if=publishedtcsOneFivetemplate class=tcs_1_5_school_logo> <img src={{publishedReportsListCtrl.reportCardArray.header.school_logo}}> </div> <div ng-if=\"!ptHfKbPublished && !Kb_Terms && !montessoryTerms && !montessoryConsolidate && !type20_KB_10_grade_term &&\n        !type20_KB_10_grade_term2 && !publishedTypeSixToSeven && !publishedTypeEightToTen && !publishedTypeEightToTen2 && !publishedTypeSixToSeven2 && !publishedTypeThreeToFive &&\n        !publishedTypeThreeToFive2 && !publishedTypeOneToTwo && !type6_3_5_grade_terms\n\t\t && !type6_6_7_grade_terms && !PublishedTypesevenOneTwo &&\n\t\t !type5_6_8_grade_terms && !type5_6_7_grade_terms && !type6_1_2_grade_terms && !type5_1_2_grade_terms && !type5_3_5_grade_terms && !type5_8_grade_terms && !publishedType30KB78 && !publishedType10KB && !publishedType10KBElevenTwelve && !publishedType10KBElevenTwelveNew26 && !Kg_Consolidated && !montessoryConsolidate && !Kg_Terms && !publishedtcsOneFivetemplate && !publishedTypeDXB && !publishedTypeThreeDXB && !publishedTypeSixDXB\" class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.header.cbse_logo}}> </div> <div ng-if=\"!publishedTypeSixToSeven && !publishedTypeEightToTen && !publishedTypeEightToTen2 && !publishedTypeSixToSeven2 && !publishedTypeThreeToFive &&\n                !publishedTypeThreeToFive2 && !publishedTypeOneToTwo && !type6_3_5_grade_terms && !type6_6_7_grade_terms && !PublishedTypesevenOneTwo && !type5_6_8_grade_terms && !type5_6_7_grade_terms && !type6_1_2_grade_terms && !type5_1_2_grade_terms && !type5_3_5_grade_terms && !type5_8_grade_terms && !Kg_Consolidated && !montessoryConsolidate && !montessoryTerms && !Kg_Terms && !publishedTypeTwelveScience && !publishedType10KBElevenTwelve && !publishedType10KBElevenTwelveNew26\" class=profile_img> <img ng-show=publishedType10KB src={{publishedReportsListCtrl.reportCardArray.header.school_logo}}> </div> <div ng-if=\"publishedTypeSixToSeven || publishedTypeEightToTen || publishedTypeEightToTen2 || publishedTypeSixToSeven2 || publishedTypeThreeToFive ||\n        publishedTypeThreeToFive2 || publishedTypeOneToTwo || type6_3_5_grade_terms ||\n\t\ttype6_6_7_grade_terms || PublishedTypesevenOneTwo || type5_6_8_grade_terms ||\n\t\ttype5_6_7_grade_terms || type6_1_2_grade_terms || type5_1_2_grade_terms || type5_3_5_grade_terms || type5_8_grade_terms || Kg_Consolidated || montessoryConsolidate || montessoryTerms || Kg_Terms || publishedType30KB78 || publishedTypeDXB || publishedTypeThreeDXB || publishedTypeSixDXB\" class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.header.school_logo}}> </div> <div ng-if=\"publishedType10KBElevenTwelve || publishedType10KBElevenTwelveNew26\" class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.header.school_logo}}> </div> <div class=annexure_con> <div clas=heading_mid> <h1 class=logo_name style=text-align:center;font-size:26px;margin-bottom:0;margin-top:0><strong> {{publishedReportsListCtrl.reportCardArray.header.school_name}} </strong> </h1> <h3 ng-if=\"!ptHfKbPublished && !Kb_Terms && !montessoryTerms && !montessoryConsolidate &&\n                !type20_KB_10_grade_term && !type20_KB_10_grade_term || !kbStudent\"> [Affiliated to Central Board of Secondary Education, Delhi] </h3> <ng-container ng-if=\"!publishedType30KB78 && !publishedTypeElevenScience && !publishedTypeElevenScienceNoModel && !publishedTypeTwelveScience\"> <h1 class=h1_font_size> Academic Year : {{publishedReportsListCtrl.reportCardArray.header.academic_year}} </h1> <h1 ng-if=\"publishedReportsListCtrl.reportCardArray.header.school_id !=='CPpbKPQTcuG97i3kv'&&\n                    publishedReportsListCtrl.reportCardArray.report_card_template.template !== 'kg-terms'\" class=h1_font_size> PROGRESS REPORT - {{publishedReportsListCtrl.reportCardArray.header.report_name }} <h1 ng-if=\"publishedReportsListCtrl.reportCardArray.header.school_id !=='CPpbKPQTcuG97i3kv' &&\n                    publishedReportsListCtrl.reportCardArray.report_card_template.template === 'kg-terms'\" class=h1_font_size> PROGRESS REPORT - KINDERGARTEN {{publishedReportsListCtrl.reportCardArray.header.display_name }} </h1> <h1 ng-if=\"publishedReportsListCtrl.reportCardArray.header.school_id ==='CPpbKPQTcuG97i3kv' && publishedReportsListCtrl.reportCardArray.report_card_template.template !== 'kg-terms'\" class=h1_font_size> PROGRESS REPORT - {{publishedReportsListCtrl.reportCardArray.header.report_name}} </h1> <h1 ng-if=\"publishedReportsListCtrl.reportCardArray.header.school_id ==='CPpbKPQTcuG97i3kv' && publishedReportsListCtrl.reportCardArray.report_card_template.template === 'kg-terms'\" class=h1_font_size> PROGRESS REPORT - KINDERGARTEN {{publishedReportsListCtrl.reportCardArray.header.display_name}} </h1> </h1></ng-container> <ng-container ng-if=publishedType30KB78> <h1 class=h1_font_size> Academic Year : {{publishedReportsListCtrl.reportCardArray.header.academic_year}} </h1> <h1 class=h1_font_size style=margin-bottom:20px> PROGRESS REPORT - Grade {{publishedReportsListCtrl.reportCardArray.student.class_name}} KB </h1> </ng-container> <ng-container ng-if=\"!publishedType30KB78 && (publishedTypeElevenScience || publishedTypeElevenScienceNoModel) || publishedTypeTwelveScience\"> <h1 class=h1_font_size> Academic Year : {{publishedReportsListCtrl.reportCardArray.header.academic_year}} </h1> <h1 class=h1_font_size> PROGRESS REPORT - {{publishedReportsListCtrl.reportCardArray.header.report_name}} {{publishedReportsListCtrl.reportCardArray.student.stream}}</h1> </ng-container> </div> </div> <div ng-if=\"!isNew26Console && !publishedTypeSixDXB && (publishedType30KB78 || publishedTypeElevenScience || publishedTypeElevenScienceNoModel || publishedTypeTwelveScience || publishedType10KBElevenTwelve || publishedType10KB || publishedType10KBElevenTwelveNew26)\" class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.student.image}} ng-style=\"publishedType30KB78 && {'margin': '0px -80px'} || (publishedTypeElevenScience || publishedTypeElevenScienceNoModel) && {'margin': '0px -64px'} || publishedTypeTwelveScience && {'margin': '0px -64px'}\"> </div> <div ng-if=publishedtcsOneFivetemplate class=tcs_1_5_student_img> <img src={{publishedReportsListCtrl.reportCardArray.student.image}}> </div> <div ng-if=\"!publishedTypeSixDXB && !publishedTypeThreeDXB && !publishedTypeDXB && (publishedTypeSixToSeven || publishedTypeEightToTen || publishedTypeEightToTen2 || publishedTypeSixToSeven2 || publishedTypeThreeToFive ||\n        publishedTypeThreeToFive2 || publishedTypeOneToTwo || type6_3_5_grade_terms || type6_6_7_grade_terms || PublishedTypesevenOneTwo || type5_6_8_grade_terms || type5_6_7_grade_terms || type6_1_2_grade_terms || type5_3_5_grade_terms || type5_8_grade_terms || Kg_Consolidated || montessoryConsolidate || montessoryTerms || Kg_Terms) && !publishedTypeTwelveScience\" class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.student.image}} class=stud_img> </div> <div ng-if=\"publishedTypeSixDXB || publishedTypeThreeDXB || publishedTypeDXB\"> <img src={{publishedReportsListCtrl.reportCardArray.student.image}} class=stud_img> </div> </div> <div class=main_con ng-if=hssTemplate> <div class=profile_img> <img src={{publishedReportsListCtrl.reportCardArray.header.school_logo}}> </div> <div class=annexure_con> <div clas=heading_mid style=margin-top:26px> <h1 class=logo_name style=text-align:center;font-size:26px;margin-bottom:0;margin-top:0><strong> {{publishedReportsListCtrl.reportCardArray.header.school_name}} </strong> </h1> <h1 class=h1_font_size> ANNUAL REPORT - {{publishedReportsListCtrl.reportCardArray.header.report_name }} [{{publishedReportsListCtrl.reportCardArray.header.published_date}}] </h1> </div> </div> </div> <div class=main_con style=padding-top:0 ng-if=\"!hssTemplate && !cbsehss && !publishedTypeEightToTen && !publishedTypeEightToTen2 &&\n    !publishedTypeSixToSeven &&   !publishedTypeEightToTen2 && !publishedTypeSixToSeven2 && !publishedTypeThreeToFive &&\n        !publishedTypeThreeToFive2 && !publishedTypeOneToTwo && !type6_3_5_grade_terms && !type6_6_7_grade_terms && !PublishedTypesevenOneTwo && !type5_6_8_grade_terms && !type5_6_7_grade_terms && !type5_1_2_grade_terms && !type6_1_2_grade_terms && !type5_3_5_grade_terms && !type5_8_grade_terms && (!publishedType30KB78 || isNew26Console) && !publishedType10KB && !publishedTypeElevenScience && !publishedTypeElevenScienceNoModel && !publishedType10KBElevenTwelve && !publishedTypeTwelveScience\"> <div class=full_width ng-if=\"!publishedtcsOneFivetemplate && !new26Templates() && !new26DXBStudentHeader()\"> <table class=full_width id=table-example-1 style=margin-bottom:2px> <thead> <tr ng-if=hssTemplate> <th>Name of Student</th> <th colspan=5>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</th> <th colspan=1>{{publishedReportsListCtrl.reportCardArray.student.grade}}</th> </tr> <tr ng-if=!hssTemplate> <th>&nbsp;&nbsp;Name of Student</th> <th colspan=6>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.student_name}}</th> </tr> </thead> <tbody> <tr> <td><strong>Comp. No.</strong></td> <td colspan=2>{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> <td><strong>Grade & Div</strong></td> <td>{{publishedReportsListCtrl.reportCardArray.student.batch_details}}</td> <td><strong>Date of Birth </strong></td> <td>{{publishedReportsListCtrl.reportCardArray.student.dob}}</td> </tr> <tr> <td><strong>Name of Parent/Guardian</strong></td> <td colspan=6>{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> </tbody> </table> </div> <div class=full_width ng-if=new26DXBStudentHeader()> <h1 ng-if=new26Term1Templates() class=h1_font_size style=text-align:center;margin-bottom:10px>TERM 1</h1> <table class=full_width id=table-example-1 style=margin-bottom:20px> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Name of the student</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</strong></td> <td colspan=3>&nbsp;&nbsp;<strong>Admission Number</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> </tr> </tbody> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Mother's Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.mothers_name}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Father's Name</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Date of Birth</strong></td> <td colspan=3 style=text-align:left> &nbsp;&nbsp;{{ publishedReportsListCtrl.reportCardArray.student.dob | date:'yyyy-MM-dd' }} </td> <td colspan=3>&nbsp;&nbsp;<strong>Roll Number</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.roll_number}}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>GRADE &amp; Division</strong></td> <td colspan=9 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.class}} {{publishedReportsListCtrl.reportCardArray.student.grade}}</td> </tr> </tbody> </table> </div> </div> <div ng-if=\"(type6_3_5_grade_terms || type6_1_2_grade_terms || type5_6_7_grade_terms || type5_8_grade_terms)  && !(hssTemplate || cbsehss) && !isNew26Console\" class=main_con style=padding-top:0> <div class=full_width> <table class=full_width id=table-example-1 style=margin-bottom:20px> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</strong></td> <td colspan=3>&nbsp;&nbsp;<strong>Admission No.</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> </tr> </tbody> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Mother's Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.mothers_name}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Father's Name</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong><strong>Date of Birth </strong></strong></td> <td colspan=8 style=text-align:left> &nbsp;&nbsp;{{ publishedReportsListCtrl.reportCardArray.student.dob | date:'yyyy-MM-dd' }} </td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Roll No.</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.roll_number}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Class </strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.class}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Div</strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.grade}}</td> </tr> </tbody> </table> </div> </div> <div ng-if=\"(PublishedTypesevenOneTwo || publishedTypeThreeToFive2 || publishedTypeSixToSeven || publishedTypeEightToTen2 ||\ntype6_6_7_grade_terms || type5_6_8_grade_terms || publishedTypeEightToTen || publishedTypeSixToSeven2 || publishedTypeThreeToFive ||\npublishedTypeOneToTwo || type5_1_2_grade_terms || type5_3_5_grade_terms )  && !(hssTemplate || cbsehss) && !isNew26Console\" class=main_con style=padding-top:0> <div class=full_width> <table class=full_width id=table-example-1 style=margin-bottom:20px> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</strong></td> <td colspan=3>&nbsp;&nbsp;<strong>Admission No.</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> </tr> </tbody> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Mother's Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.mothers_name}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Father's Name</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong><strong>Date of Birth </strong></strong></td> <td colspan=9 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.dob | date:'yyyy-MM-dd' }}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Roll No.</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.roll_number}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Class</strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.class}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Div</strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.grade}}</td> </tr> </tbody> </table> </div> </div> <div class=main_con style=padding-top:0 ng-if=hssTemplate> <div class=full_width> <table class=full_width id=table-example-1 style=margin-bottom:20px> <thead> <tr ng-if=hssTemplate> <th colspan=3>Name of Student:<br>{{publishedReportsListCtrl.reportCardArray.student.student_name}} </th> <th colspan=2>Comp No:<br>{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</th> <th colspan=1>{{publishedReportsListCtrl.reportCardArray.student.grade}}</th> </tr> </thead> </table> </div> </div> <div class=main_con style=padding-top:0 ng-if=cbsehss> <div class=full_width ng-if=cbsehss> <table class=full_width id=table-example-1 style=margin-bottom:20px> <tbody> <tr> <td><strong>Comp. No.</strong></td> <td colspan=2 class=ng-binding>{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> <td colspan=2><strong>Student Name</strong></td> <td colspan=2 class=ng-binding>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</td> </tr> <tr> <td><strong>Std &amp; Div.</strong></td> <td colspan=2 class=ng-binding>{{publishedReportsListCtrl.reportCardArray.student.batch_details}}</td> <td colspan=2><strong>Name of Parent /Guardian</strong></td> <td colspan=2 class=ng-binding>{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> </tbody> </table> </div> </div> <div class=full_width ng-if=\"(publishedType30KB78 && !isNew26Console) || publishedTypeElevenScience || publishedTypeElevenScienceNoModel || publishedTypeTwelveScience\"> <table class=full_width id=table-example-1 style=margin-bottom:20px> <thead> <tr> <td colspan=3>&nbsp;&nbsp; <strong>Name</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.student_name}}</td> <td colspan=3><strong>Admission No.</strong></td> <td colspan=3>{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> </tr> </thead> <tbody> <tr> <td colspan=3>&nbsp;&nbsp;<strong>Mother's Name</strong></td> <td colspan=3>{{publishedReportsListCtrl.reportCardArray.student.mother_name}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Father's Name</strong></td> <td colspan=3>{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> <tr> <td colspan=3>&nbsp;&nbsp;<strong><strong>Date of Birth </strong></strong></td> <td colspan=3>{{publishedReportsListCtrl.reportCardArray.student.dob}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Comp No.</strong> </td> <td colspan=3></td> </tr> <tr> <td colspan=3>&nbsp;&nbsp;<strong>Roll No.</strong></td> <td colspan=2>{{publishedReportsListCtrl.reportCardArray.student.roll_number}}</td> <td colspan=2><strong>Class</strong></td> <td colspan=2>{{publishedReportsListCtrl.reportCardArray.student.class_name}}</td> <td colspan=2><strong>Div</strong></td> <td colspan=1>{{publishedReportsListCtrl.reportCardArray.student.batch_name}}</td> </tr> </tbody> </table> </div> <div ng-if=\"(publishedType10KBElevenTwelve || publishedType10KB) && !isNew26Console\" class=main_con style=padding-top:0> <div class=full_width> <table class=full_width id=table-example-1 style=margin-bottom:20px> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>{{publishedReportsListCtrl.reportCardArray.student.student_name}}</strong></td> <td colspan=3>&nbsp;&nbsp;<strong>Admission No.</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.admission_number}}</td> </tr> </tbody> <tbody> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Mother's Name</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.mothers_name}}</td> <td colspan=3>&nbsp;&nbsp;<strong>Father's Name</strong></td> <td colspan=3>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.parent_name}}</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong><strong>Date of Birth </strong></strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.dob | date:'yyyy-MM-dd' }}</td> <td colspan=3>&nbsp;&nbsp;<strong><strong>Comp No.</strong></strong></td> <td colspan=3 style=text-align:left;padding-left:98px>&nbsp;&nbsp;</td> </tr> <tr> <td colspan=3 style=text-align:left>&nbsp;&nbsp;<strong>Roll No.</strong></td> <td colspan=3 style=text-align:left>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.roll_number}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Class</strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.class}}</td> <td colspan=1>&nbsp;&nbsp;<strong>Div</strong></td> <td colspan=2>&nbsp;&nbsp;{{publishedReportsListCtrl.reportCardArray.student.grade}}</td> </tr> </tbody> </table> </div> </div> <type-one-hf-component ng-if=typeOneHF></type-one-hf-component> <periodic-test-default-hf-published ng-if=defaultPtHf></periodic-test-default-hf-published> <periodic-test-default-annual-published ng-if=defaultPtAnnual></periodic-test-default-annual-published> <default-year-end ng-if=defaultYearEnd></default-year-end> <educore-year-end ng-if=educoreYearEnd></educore-year-end> <skil-sub-skill ng-if=typeThreeSubSkill></skil-sub-skill> <asset-hf-component ng-if=type_four_mark></asset-hf-component> <asset-annual-component ng-if=type_four_annual></asset-annual-component> <term-consolidated ng-if=term1term2></term-consolidated> <periodic-test-default-hf-two-published ng-if=defaultPtHfTwo></periodic-test-default-hf-two-published> <periodic-test-default-annual-two-published ng-if=defaultPtAnnualTwo></periodic-test-default-annual-two-published> <kg-terms ng-if=Kg_Terms></kg-terms> <kg-consolidated ng-if=Kg_Consolidated></kg-consolidated> <kb-terms ng-if=Kb_Terms></kb-terms> <hss-component ng-if=hssTemplate></hss-component> <cbse-hss-published-component ng-if=cbsehss></cbse-hss-published-component> <specific-hf ng-if=term1halfyearly></specific-hf> <kbhfhsspublished-comp ng-if=KBHFHSSflag></kbhfhsspublished-comp> <cbse-specific-subjects-final-comp ng-if=gradeNineFinal></cbse-specific-subjects-final-comp> <cbse-specificoneeigth-final-comp ng-if=publishedoneeight></cbse-specificoneeigth-final-comp> <kb-final-component ng-if=kb_finalFlag></kb-final-component> <pubishedcbsehss-annual ng-if=cbseAnnualHss></pubishedcbsehss-annual> <nineonlypubllished-comp ng-if=nineOnlyAnnual></nineonlypubllished-comp> <kbannual-hss-published ng-if=annualKbTemp></kbannual-hss-published> <montessory-terms ng-if=montessoryTerms></montessory-terms> <montessory-consolidate ng-if=montessoryConsolidate></montessory-consolidate> <kbhf-pt-published-component ng-if=ptHfKbPublished></kbhf-pt-published-component> <hfexam-one-published-component ng-if=hfExamOne></hfexam-one-published-component> <published-cbse-typefive-nine-ten ng-if=publishedType5_9_10></published-cbse-typefive-nine-ten> <published-type-five-kbten ng-if=publishedType5_KB_10></published-type-five-kbten> <published-type-five-one-five ng-if=type5_1_5_grade_terms></published-type-five-one-five> <published-type-five-kb-eight-nine ng-if=type5_KB_8_9_grade_term3></published-type-five-kb-eight-nine> <published-type-six-modal-exam-term-one ng-if=type6_modelExamOne></published-type-six-modal-exam-term-one> <published-typesix-model-exam-nine-ten ng-if=type_6_model_exam_1_nineten></published-typesix-model-exam-nine-ten> <published-typesix-model-exam-nine-ten-two ng-if=type_6_model_exam_II_nineten></published-typesix-model-exam-nine-ten-two> <published-type-six-modal-exam-term-twonospace ng-if=type6_modelExamTwoNospace></published-type-six-modal-exam-term-twonospace> <published-type-six-modelannualexam ng-if=type6_modelAnnualExamTerm></published-type-six-modelannualexam> <published-type-seven-calicut-annualexam ng-if=publishedtype_seven_calicut_annual></published-type-seven-calicut-annualexam> <kgthematicterms-component ng-if=kgthematictermsFlag></kgthematicterms-component> <type-nine-cbse-consolidated ng-if=type9_term1_hf></type-nine-cbse-consolidated> <type-nine-cbsept ng-if=type9_cbse_pt1></type-nine-cbsept> <type-nine-twelve-cbse-consolidated ng-if=type9_grade12term2_ae></type-nine-twelve-cbse-consolidated> <type-ninekb-unit-test ng-if=type9_kb_unit_test1></type-ninekb-unit-test> <type-ninekb-consolidated ng-if=type9_kbterm3></type-ninekb-consolidated> <published-type-twelve-one-eight ng-if=publishedTypeTwelveOneEight></published-type-twelve-one-eight> <published-type-twelve-nine-ten ng-if=type12_ninetentermcbse></published-type-twelve-nine-ten> <published-elt-report ng-if=elt_report></published-elt-report> <published-type20kbterms ng-if=type20_KB_10_grade_term></published-type20kbterms> <published-type-twenty-nine-ten ng-if=publishedTypeTwentyNineTen></published-type-twenty-nine-ten> <published-type-twenty-one-eight ng-if=publishedTypeTwentyOneEight></published-type-twenty-one-eight> <published-type-twenty-nine-ten-two ng-if=publishedTypeTwentyTwoNineTen></published-type-twenty-nine-ten-two> <published-type-twenty-one-eight-two ng-if=publishedTypeTwentyOneEightTwo></published-type-twenty-one-eight-two> <published-type20kbterms2 ng-if=type20_KB_10_grade_term2></published-type20kbterms2> <published-type-thirtykb-eight-nine ng-if=publishedType30KB78></published-type-thirtykb-eight-nine> <published-type-eight-to-ten ng-if=publishedTypeEightToTen></published-type-eight-to-ten> <published-type-eight-to-ten2 ng-if=publishedTypeEightToTen2></published-type-eight-to-ten2> <published-type-six-to-seven ng-if=publishedTypeSixToSeven></published-type-six-to-seven> <published-type-six-to-seven2 ng-if=publishedTypeSixToSeven2></published-type-six-to-seven2> <published-type-three-to-five ng-if=publishedTypeThreeToFive></published-type-three-to-five> <published-type-three-to-five2 ng-if=publishedTypeThreeToFive2></published-type-three-to-five2> <published-type-one-to-two ng-if=publishedTypeOneToTwo></published-type-one-to-two> <published-typeseven-one-two ng-if=PublishedTypesevenOneTwo></published-typeseven-one-two> <published-type-five-six-eight ng-if=type5_6_8_grade_terms></published-type-five-six-eight> <published-type-five-six-seven ng-if=type5_6_7_grade_terms></published-type-five-six-seven> <published-type-six-six-seven ng-if=type6_6_7_grade_terms></published-type-six-six-seven> <published-type-six-three-five ng-if=type6_3_5_grade_terms></published-type-six-three-five> <published-type-six-one-two ng-if=type6_1_2_grade_terms></published-type-six-one-two> <published-type-five-one-two ng-if=type5_1_2_grade_terms></published-type-five-one-two> <published-type-five-three-five ng-if=type5_3_5_grade_terms></published-type-five-three-five> <published-type-five-eight ng-if=type5_8_grade_terms></published-type-five-eight> <published-type-ten-kb-ten ng-if=publishedType10KB></published-type-ten-kb-ten> <published-type-ten-kb-eleven-twelve ng-if=publishedType10KBElevenTwelve></published-type-ten-kb-eleven-twelve> <published-type-ten-kb-eleven-twelve-new26 ng-if=publishedType10KBElevenTwelveNew26></published-type-ten-kb-eleven-twelve-new26> <published-type-eleven-science ng-if=publishedTypeElevenScience></published-type-eleven-science> <published-type-eleven-science-no-model ng-if=publishedTypeElevenScienceNoModel></published-type-eleven-science-no-model> <published-type-twelve-science ng-if=publishedTypeTwelveScience></published-type-twelve-science> <termone-templatepublished-type-five-three-five ng-if=T1type5_3_5_grade_terms></termone-templatepublished-type-five-three-five> <termone-templatepublished-type-six-six-seven ng-if=T1type6_6_7_grade_terms></termone-templatepublished-type-six-six-seven> <termone-templatepublished-type-eight-nine ng-if=T1type8_9_grade_terms></termone-templatepublished-type-eight-nine> <termone-templatepublished-type-one-two ng-if=T1type1_2_grade_terms></termone-templatepublished-type-one-two> <type-pt-no-conv ng-if=pt_1_no_conv></type-pt-no-conv> <publishedtcs-one-five ng-if=publishedtcsOneFivetemplate></publishedtcs-one-five> <termone-templatepublished-type-one-two-new26 ng-if=T1type1_2_grade_terms_new26></termone-templatepublished-type-one-two-new26> <termone-templatepublished-type-one-two-new26-shj ng-if=T1type1_2_grade_terms_new26_shj></termone-templatepublished-type-one-two-new26-shj> <termone-templatepublished-type-five-three-five-new26 ng-if=T1type5_3_5_grade_terms_new26></termone-templatepublished-type-five-three-five-new26> <termone-templatepublished-type-six-six-seven-new26 ng-if=T1type6_6_7_grade_terms_new26></termone-templatepublished-type-six-six-seven-new26> <termone-templatepublished-type-eight-to-ten-new26 ng-if=T1type8to10_grade_terms_new26></termone-templatepublished-type-eight-to-ten-new26> <termone-templatepublished-type-zero-two-grade-eleven-science-new26 ng-if=T1type02grade_11_science_new26></termone-templatepublished-type-zero-two-grade-eleven-science-new26> <termone-templatepublished-type-zero-two-grade-twelve-science-new26 ng-if=T1type02grade_12_science_new26></termone-templatepublished-type-zero-two-grade-twelve-science-new26> <termone-templatepublished-type-nine-term-cbse-new26 ng-if=T1type9_grade_terms_new26></termone-templatepublished-type-nine-term-cbse-new26> <termone-templatepublished-type-ten-term-cbse-new26 ng-if=T1type10_grade_terms_new26></termone-templatepublished-type-ten-term-cbse-new26> <published-type-five-one-two-new26 ng-if=type5_1_2_grade_terms_new26></published-type-five-one-two-new26> <published-type-five-one-two-new26-term2 ng-if=type5_1_2_grade_terms_new26_term2></published-type-five-one-two-new26-term2> <published-type-five-one-two-new26-shj-term2 ng-if=type5_1_2_grade_terms_new26_shj_term2></published-type-five-one-two-new26-shj-term2> <published-type-five-three-five-new26-term2 ng-if=type5_3_5_grade_terms_new26_term2></published-type-five-three-five-new26-term2> <published-type-six-six-seven-new26 ng-if=type6_6_7_grade_terms_new26></published-type-six-six-seven-new26> <published-type-eight-to-ten-new26-term2 ng-if=type8to10_grade_terms_new26></published-type-eight-to-ten-new26-term2> <published-type-zero-two-grade-eleven-science-new26-term2 ng-if=type02grade_11_science_new26></published-type-zero-two-grade-eleven-science-new26-term2> <published-type-zero-two-grade-twelve-science-new26-term2 ng-if=type02grade_12_science_new26></published-type-zero-two-grade-twelve-science-new26-term2> <published-type-nine-term-cbse-new26-term2 ng-if=type9_grade_terms_new26></published-type-nine-term-cbse-new26-term2> <published-type-ten-term-cbse-new26-term2 ng-if=type10_grade_terms_new26></published-type-ten-term-cbse-new26-term2> <termone-templatepublished-type10-kb-grade-term1-new26 ng-if=T1type10_KB_grade_term1_new26></termone-templatepublished-type10-kb-grade-term1-new26> <published-type10-kb-grade-term2-new26 ng-if=type10_KB_grade_term2_new26></published-type10-kb-grade-term2-new26> </div> <div class=main_bg ng-if=pdfData> <md-backdrop ng-if=loading class=\"md-backdrop md-opaque\" layout=column layout-align=\"center center\" style=background-color:#262626!important;position:fixed> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"theme-color md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=!pdfData ng-click=publishedReportsListCtrl.export()> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative;top:6px>Export As Pdf</span> <span class=\"hand footer-circle-button\"> <img src=" + __webpack_require__(1135) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:8px> </span> </span> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=\"$root.isTeachingStaff && !pdfData && !$root.attendance_save_not\" ng-click=publishedReportsListCtrl.saveAttendace()> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative;top:4px>Save</span> <span class=\"hand footer-circle-button\"> <i class=\"fa fa-save\" style=margin:8px;font-size:18px></i> </span> </span> <span class=\"bottom_ctrl-btn md-whiteframe-3dp\" ng-if=pdfData ng-click=publishedReportsListCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\" style=color:#fff;position:relative>Back to html</span> <span class=\"hand footer-circle-button\"> <i class=\"fas fa-chevron-left\" class=\"ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=margin:6px></i> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=4>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{typeOneHfYTemplateCtrl.reportCardArray.report_card_name}}</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td colspan=1><strong>*PT (10) <br/></strong> </td> <td colspan=1><strong>*NB (5) <br/></strong> </td> <td colspan=1><strong>*S.E (5) <br/></strong> </td> <td ng-if=\"typeOneHfYTemplateCtrl.reportCardArray.header.report_name=='Annual'\" colspan=1><strong>Annual <br/> Exam (80) </strong> </td> <td ng-if=\"typeOneHfYTemplateCtrl.reportCardArray.header.report_name!='Annual'\" colspan=1><strong>Half <br/> Yearly <br/> Exam (80) </strong> </td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in typeOneHfYTemplateCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td colspan=1>{{value.periodic_test}}</td> <td colspan=1>{{value.note_book_submission}}</td> <td colspan=1>{{value.subject_enrichment}}</td> <td colspan=1 ng-if=\"typeOneHfYTemplateCtrl.reportCardArray.header\n.report_name!='Annual'\">{{value.half_yearly}}</td> <td colspan=1 ng-if=\"typeOneHfYTemplateCtrl.reportCardArray.header\n.report_name=='Annual'\">{{value.annual_exam}}</td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <h2 style=text-align:left;font-size:16px;margin-bottom:0> Abbreviations : * PT : Periodic Test * NB : Notebook Maintainence *S.E : Subject Enrichment </h2> <br> <div ng-repeat=\"(key, subjectKeyValue) in typeOneHfYTemplateCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1137 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test </th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in pTHFCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in pTHFCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff max=1000 type=text ng-model=$root.attendance_term1 style=width:351px;margin-left:50px;height:32px></td>  </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in pTAnnualCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in pTAnnualCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg h1,h2,h3,h4,h6{text-align:center}.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=\"\" ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6> HALF YEARLY</th> <th colspan=6> ANNUAL</th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Half <br/> Yearly<br/> Exam (80)</td> <td colspan=1>Mark <br/> Obt. (100)</td> <td> Grade </td> <td colspan=1>Periodic<br/> Test<br/> (10)</td> <td colspan=1>Note<br/> book<br/> (5)</td> <td colspan=1>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Annual<br/> Exam (80)</td> <td colspan=1>Mark <br/> obt. (100)</td> <td colspan=1>Grade</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in defaultYearEndCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.periodic_test_1}}</td> <td colspan=1>{{subjectResult.note_book_submission_1}}</td> <td colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td colspan=1>{{subjectResult.half_yearly_1}}</td> <td colspan=1>{{subjectResult.total_mark_1}}</td> <td colspan=1>{{subjectResult.grade_1}}</td> <td colspan=1>{{subjectResult.periodic_test_2}}</td> <td colspan=1>{{subjectResult.note_book_submission_2}}</td> <td colspan=1>{{subjectResult.subject_enrichment_2}}</td> <td colspan=1>{{subjectResult.annual_exam_2}}</td> <td colspan=1>{{subjectResult.total_mark_2}}</td> <td colspan=1>{{subjectResult.grade_2}}</td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th colspan=5> Co-Scholastic : (Half yearly) (3 - Point Gr.) </th> <th colspan=5> Co-Scholastic : (Annual) (3 - Point Gr.) </th> </tr> <tr> <th colspan=2> Attribute </th> <th colspan=1> Gr. </th> <th colspan=2> Remarks </th> <th colspan=2> Attribute </th> <th colspan=1> Gr. </th> <th colspan=2> Remarks </th> </tr> </thead> <tbody> <tr ng-repeat=\"(subject, coSubjectResult) in defaultYearEndCtrl.reportCardArray.other_sections\"> <th colspan=2> <strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade_1}}</th> <th colspan=2>{{coSubjectResult.remarks_1}}</th> <th colspan=2><strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade_2}}</th> <th colspan=2>{{coSubjectResult.remarks_2}}</th> </tr> </tbody> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Attendance </th> <th ng-if=$root.isTeachingStaff colspan=7>&nbsp; <input decimal-numbers-only max=100 type=text ng-model=$root.attendance></th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg h1,h2,h3,h4,h6{text-align:center}.main_bg{width:1088px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:2px;margin-bottom:10px;padding-top:10px;margin-top:10px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;width:872px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .2rem}#table-example-1 td{white-space:normal}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=2>A. LANGUAGES</th> <th colspan=6>ENGLISH {{reportCardArray.evaluationResults.english.status === \"published\"?\"\":\" - Not Published\"}}</th> <th colspan=8>A1. {{reportCardArray.evaluationResults.second_language.subject}} {{reportCardArray.evaluationResults.second_language.status === \"published\"?\"\":\" - Not Published\"}}</th> </tr> </thead> <thead> <tr> <td colspan=2><strong>TESTING AREA/SKILL</strong> </td> <td colspan=2><strong> SUBSKILL </strong> </td> <td colspan=1><strong>Gr.</strong> </td> <td colspan=3><strong>Descriptive Indicators</strong> </td> <td colspan=2><strong> TESTING AREA/SKILL </strong> </td> <td colspan=2><strong> SUBSKILL </strong> </td> <td colspan=1><strong> Gr. </strong> </td> <td colspan=3><strong> Descriptive <br> Indicators </strong> </td> </tr> </thead> <thead> <tr> <td style=\"padding:.3rem .5rem\" colspan=2><strong>READING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> <td style=\"padding:.3rem .5rem\" colspan=2><strong>READING SKILLS</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> </tr> <tr style=font-size:11px> <td rowspan=3 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Pronunciation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1> {{reportCardArray.evaluationResults.english.reading.pronunciation.grade}} </td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.reading.pronunciation.remarks:\"NA\"}}</td> <td rowspan=3 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Pronunciation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.pronunciation.grade:\"NA\"}}</td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.pronunciation.remarks:\"NA\"}}</td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px><strong>Fluency </strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.reading.fluency.grade:\"NA\"}}</td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.reading.fluency.remarks:\"NA\"}} </td> <td colspan=2 style=font-size:13px><strong>Fluency</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.fluency.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.fluency.remarks:\"NA\"}} </p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px><strong>Comprehension </strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.reading.comprehension.grade:\"NA\"}}</td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.reading.comprehension.remarks:\"NA\"}}</td> <td colspan=2 style=font-size:13px><strong>Comprehension</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.comprehension.grade:\"NA\"}}</td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.reading.comprehension.remarks:\"NA\"}} </td> </tr> <tr> <td style=\"padding:.3rem .5rem\" colspan=2><strong>WRITING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> <td style=\"padding:.3rem .5rem\" colspan=2><strong>WRITING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> </tr> <tr style=font-size:11px> <td rowspan=5 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Creative writing </strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.creative_writing.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.creative_writing.remarks:\"NA\"}} </p> </td> <td rowspan=5 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Creative writing</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.creative_writing.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.creative_writing.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px> <p><strong>Handwriting</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.handwriting.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.handwriting.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:13px> <p><strong>Handwriting</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.handwriting.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.handwriting.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px> <p><strong>Grammar</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.grammar.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.grammar.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:13px> <p><strong>Grammar</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.grammar.grade:\"NA\"}}</td> <td class=body_text colspan=3>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.grammar.remarks:\"NA\"}} </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px> <p><strong>Spelling</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.spelling.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.spelling.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:13px> <p><strong>Spelling</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.spelling.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.spelling.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px> <p><strong>Vocabulary</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.vocabulary.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.writing.vocabulary.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:13px> <p><strong>Vocabulary</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.vocabulary.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.writing.vocabulary.remarks:\"NA\"}}</p> </td> </tr> <tr> <td style=\"padding:.3rem .5rem\" colspan=2><strong>SPEAKING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> <td style=\"padding:.3rem .5rem\" colspan=2><strong>SPEAKING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> </tr> <tr style=font-size:11px> <td rowspan=3 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Conversation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.speaking.conversation.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.speaking.conversation.remarks:\"NA\"}}</p> </td> <td rowspan=3 colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Conversation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.speaking.conversation.grade:\"NA\"}} </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.speaking.conversation.remarks:\"NA\"}} </p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:13px><strong>Recitation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.speaking.recitation.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.speaking.recitation.remarks:\"NA\"}} </p> </td> <td colspan=2 style=font-size:13px><strong>Recitation</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.speaking.recitation.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.speaking.recitation.remarks:\"NA\"}} </p> </td> </tr> </thead> <tr> <td style=\"padding:.3rem .5rem\" colspan=2><strong>LISTENING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> <td style=\"padding:.3rem .5rem\" colspan=2><strong>LISTENING SKILL</strong> </td> <td style=\"padding:.3rem .5rem;background:#e2e3e4\" colspan=6>&nbsp;</td> </tr> <tr style=font-size:11px> <td colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Comprehension</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.listening_skill.comprehension.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.listening_skill.comprehension.remarks:\"NA\"}}</p> </td> <td colspan=2 style=background:#e2e3e4>&nbsp;</td> <td colspan=2 style=font-size:13px><strong>Comprehension</strong> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.listening_skill.comprehension.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.listening_skill.comprehension.remarks:\"NA\"}} </p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:15px> <p><strong>PENCIL-PAPER </strong><strong><br/> </strong><strong>TEST</strong> </p> </td> <td colspan=2 style=font-size:13px> <p><strong>(All Writing skills)</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.pencil_paper_test.all_writing_skills.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.pencil_paper_test.all_writing_skills.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:15px> <p><strong>PENCIL-PAPER </strong><strong><br/> </strong><strong>TEST</strong> </p> </td> <td colspan=2 style=font-size:13px> <p><strong>(All Writing skills)</strong> </p> </td> <td style=font-size:15px;font-weight:700 colspan=1>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.pencil_paper_test.all_writing_skills.grade:\"NA\"}}</td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.pencil_paper_test.all_writing_skills.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:15px> <p><strong>OVERALL SUBJECT <br/> GRADE </strong> </p> </td> <td colspan=3 style=font-size:13px> <p><span style=font-size:25px;font-weight:700>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.overall_subject_grade:\"NA\"}}</span> </p> </td> <td colspan=3> <p><span style=font-size:25px;font-weight:700>{{reportCardArray.evaluationResults.english.status === \"published\"?reportCardArray.evaluationResults.english.overall_subject_remarks:\"NA\"}}</span> </p> </td> <td colspan=2 style=font-size:15px> <p><strong>OVERALL <br/> SUBJECT GRADE</strong> </p> </td> <td colspan=3 style=font-size:13px> <p><span style=font-size:25px;font-weight:700>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.overall_subject_grade:\"NA\"}}</span> </p> </td> <td colspan=3> <p><span style=font-size:25px;font-weight:700>{{reportCardArray.evaluationResults.second_language.status === \"published\"?reportCardArray.evaluationResults.second_language.overall_subject_remarks:\"NA\"}}</span> </p> </td> </tr> <tr style=font-size:11px> <td colspan=8 style=font-size:20px> <p><strong>B. MATHEMATICS {{reportCardArray.evaluationResults.maths.status === \"published\"?\"\":\" - Not Published\"}}</strong> </p> </td> <td colspan=8 style=font-size:20px> <p><strong>C. ENVIRONMENTAL SCIENCE {{reportCardArray.evaluationResults.evs.status === \"published\"?\"\":\" - Not Published\"}}</strong> </p> </td> </tr> <tr> <td colspan=4> <p><strong>TESTING AREA/SKILL</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive Indicators</strong> </p> </td> <td colspan=4> <p><strong>Testing Area / Skills/ <br/> Sub Skills</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive <br> Indicators</strong> </p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>CONCEPT</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.concept.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.concept.remarks:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>ENVIRONMENTAL </strong><strong><br/> </strong><strong>SENSITIVITY</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.evsensitivity.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.evsensitivity.remarks:\"NA\"}} </p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>ACTIVITY</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.activity.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.activity.remarks:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>ACTIVITY / PROJECT</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.activity.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.activity.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>TABLES</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.tables.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.tables.remarks:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>GROUP DISCUSSION</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.gd.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.gd.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>MENTAL ABILITY</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.mental_ability.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p align=center>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.mental_ability.remarks:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>WRITTEN WORK</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.written_work.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p align=center>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.written_work.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>PENCIL - PAPER TEST</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.pencil_paper_test.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.pencil_paper_test.remarks:\"NA\"}}</p> </td> <td rowspan=2 colspan=4 style=font-size:13px> <p><strong>OVERALL SUBJECT GRADE </strong> </p> </td> <td rowspan=2 colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.overall_subject_grade:\"NA\"}}</strong> </p> </td> <td rowspan=2 colspan=3 style=font-size:15px> <p> <strong>{{reportCardArray.evaluationResults.evs.status === \"published\"?reportCardArray.evaluationResults.evs.overall_subject_remarks:\"NA\"}}</strong> </p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>OVERALL SUBJECT GRADE</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.overall_subject_grade:\"\"}}</strong></p> </td> <td colspan=3 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.maths.status === \"published\"?reportCardArray.evaluationResults.maths.overall_subject_remarks:\"NA\"}}</strong> </p> </td> </tr> <tr style=font-size:11px> <td colspan=8 style=font-size:20px> <p><strong>D. ARABIC</strong> </p> </td> <td colspan=8 style=font-size:20px> <p><strong>E. ISLAMIC EDUCATION / MORALS</strong> </p> </td> </tr> <tr> <td colspan=4> <p><strong>Testing Area / Skills/ Sub </strong><strong><br/> </strong><strong>Skills</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive Indicators</strong> </p> </td> <td colspan=4> <p><strong>Testing Area / Skills/ <br/> Sub Skills</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive <br> Indicators</strong> </p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>ORALS</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.orals.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.orals.remarks:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>ORALS</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.orals.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.orals.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=4 style=font-size:14px> <p><strong>PENCIL - PAPER TEST</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.pencil_paper_test.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.pencil_paper_test.grade:\"NA\"}}</p> </td> <td colspan=4 style=font-size:13px> <p><strong>PENCIL - PAPER TEST</strong> </p> </td> <td colspan=1 style=font-size:15px> <p><strong>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.pencil_paper_test.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.pencil_paper_test.remarks:\"NA\"}}</p> </td> </tr> <tr> <td colspan=4> <p><strong>OVERALL SUBJECT GRADE</strong> </p> </td> <td colspan=1> <p><strong>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.overall_subject_grade:\"NA\"}}</strong> </p> </td> <td colspan=3> <p><strong>{{reportCardArray.evaluationResults.arabic.status === \"published\"?reportCardArray.evaluationResults.arabic.overall_subject_remarks:\"NA\"}}</strong> </p> </td> <td colspan=4> <p><strong>OVERALL SUBJECT GRADE</strong> </p> </td> <td colspan=1> <p><strong>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.overall_subject_grade:\"NA\"}}</strong> </p> </td> <td colspan=3> <p><strong>{{reportCardArray.evaluationResults.islamic_education.status === \"published\"?reportCardArray.evaluationResults.islamic_education.overall_subject_remarks:\"NA\"}}</strong> </p> </td> </tr> <thead> <tr style=font-size:11px></tr> </thead> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <td colspan=6> <p><strong>F. Co-Curricular Activity <br/> </strong><strong>(Computer Education)</strong> </p> </td> <td colspan=6> <p><strong>G. Co-Curricular Activity </strong><strong><br/> </strong><strong>(Games)</strong> </p> </td> <td colspan=6> <p><strong>H. Co-Curricular Activity</strong><strong><br/> </strong><strong>(Art &amp; Craft)</strong> </p> </td> </tr> <tr> <td colspan=2> <p><strong>Testing Area / </strong><strong><br/> </strong><strong>Skills/ Sub Skills</strong> </p> </td> <td colspan=1><strong>Gr.</strong> </td> <td colspan=3> <p><strong>Descriptive <br/> Indicators</strong> </p> </td> <td colspan=2> <p><strong>ATTRIBUTE</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive <br/> Indicators</strong> </p> </td> <td colspan=2> <p><strong>ATTRIBUTE</strong> </p> </td> <td colspan=1> <p><strong>Gr.</strong> </p> </td> <td colspan=3> <p><strong>Descriptive <br/> Indicators</strong> </p> </td> </tr> <tr style=font-size:11px> <td rowspan=2 colspan=2 style=font-size:14px> <p><strong>KNOWLEDGE</strong> </p> </td> <td rowspan=2 colspan=1 style=font-size:14px><strong>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.knowledge.grade:\"NA\"}}</strong> </td> <td class=body_text rowspan=2 colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.knowledge.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:14px> <p><strong>ENTHUSIASM</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.enthusiasm.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.enthusiasm.remarks:\"NA\"}} </p> </td> <td colspan=2 style=font-size:14px> <p><strong>INTEREST</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.interest.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.interest.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:14px> <p><strong>DISCIPLINE</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.discipline.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.discipline.remarks:\"NA\"}} </p> </td> <td colspan=2 style=font-size:14px> <p><strong>CREATIVITY</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.creativity.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.creativity.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td rowspan=2 colspan=2 style=font-size:14px> <p><strong>SKILL</strong> </p> </td> <td rowspan=2 colspan=1 style=font-size:14px><strong>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.skill.grade:\"NA\"}}</strong> </td> <td class=body_text rowspan=2 colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.skill.remarks:\"NA\"}} </p> </td> <td colspan=2 style=font-size:14px> <p><strong>TEAM SPIRIT</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.team_spirit.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.team_spirit.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:14px> <p><strong>SKILL</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.skill.grade:\"NA\"}}</strong> </p> </td> <td class=body_text colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.skill.remarks:\"NA\"}}</p> </td> </tr> <tr style=font-size:11px> <td colspan=2 style=font-size:14px> <p><strong>TALENT</strong> </p> </td> <td colspan=1 style=font-size:14px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.talent.grade:\"NA\"}}</strong> </p> </td> <td colspan=3> <p>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.talent.remarks:\"NA\"}}</p> </td> <td colspan=2 style=font-size:14px> <p>&nbsp;</p> </td> <td colspan=1 style=font-size:14px> <p>&nbsp;</p> </td> <td colspan=3> <p>&nbsp;</p> </td> </tr> <tr> <td colspan=2> <p><strong>OVERALL <br/> SUBJECT </strong><strong><br/> </strong><strong>GRADE</strong> </p> </td> <td colspan=1><strong>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.overall_subject_grade:\"NA\"}}</strong> </td> <td colspan=3 style=font-size:25px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.ce.status === \"published\"?reportCardArray.evaluationCoCurricularResults.ce.overall_subject_remarks:\"NA\"}}</strong> </p> </td> <td colspan=2> <p><strong>OVERALL SUBJECT </strong><strong><br/> </strong><strong>GRADE</strong> </p> </td> <td colspan=1> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.overall_subject_grade:\"NA\"}}</strong> </p> </td> <td colspan=3 style=font-size:25px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.games.status === \"published\"?reportCardArray.evaluationCoCurricularResults.games.overall_subject_remarks:\"NA\"}}</strong> </p> </td> <td colspan=2> <p><strong>OVERALL </strong><strong><br/> </strong><strong>SUBJECT GRADE</strong> </p> </td> <td colspan=1> <p><strong>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.overall_subject_grade:\"NA\"}}</strong> </p> </td> <td colspan=3 style=font-size:25px> <p><strong>{{reportCardArray.evaluationCoCurricularResults.art_and_craft.status === \"published\"?reportCardArray.evaluationCoCurricularResults.art_and_craft.overall_subject_remarks:\"NA\"}}</strong> </p> </td> </tr> </thead> <thead> <tr></tr> </thead> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <td colspan=6> <p><strong>Attendance % </strong></p> </td> <td colspan=6> <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </td> </tr> </thead> <thead> <tr></tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span ng-if=!isPdfData class=\"\" ng-click=reportCardEvaluationTypeCtrl.exportPdf()> <span class=\"font_wight controlsbtn user hand\">Export as pdf</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportCardEvaluationTypeCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg h1,h2,h3,h4,h6{text-align:center}.main_bg{width:770px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_con{width:700px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #d8d8d8}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #d8d8d8;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #d8d8d8;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #d8d8d8;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:13px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:14px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border-bottom:1px solid #ccc;border-top:1px solid #ccc}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #d8d8d8;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:0 solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{padding:.2rem .2rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:13px;border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff}#table-example-1 th{font-weight:400}#table-example-1 td{border-bottom:1px solid #ccc;border-top:1px solid #ccc;border-right:0 solid #fff;border-left:0 solid #fff;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.space-around-color{border:1px solid #ccc;border-top:0;border-bottom:0;border-radius:10px}.color-top-bar{background-color:#93ca16;color:#fff;padding:3px 12px;border-radius:10px 10px 0 0}.table-color-con{padding:10px}.e1{width:80px;background-color:#f37404;float:left;text-align:center;color:#fff}.start-0{position:relative;top:21px;right:34px;color:#000;font-size:12px}.end-32{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-color{position:relative;left:18px;font-size:12px}.each-grade{border-bottom:1px solid #ccc;padding:5px 0;padding-bottom:22px}.each-grade-txt{font-size:13px;width:88%;float:left}.grade-mark{float:left;width:11%;text-align:center;font-size:13px;height:16px;color:#fff}.e2{width:40px;float:left;text-align:center;color:#fff}.end-new{position:relative;top:22px;left:20px;color:#111;font-size:12px}.range-new{position:relative;left:9px;font-size:12px}.scholastic_areas{width:100%}.scholastic_areas_1{float:left;width:49%;margin-right:13px}.scholastic_areas_2{float:left;width:49%}.grade_show{padding:1px 5px;float:left;width:100%;border:2px solid #fff}.w100{width:100%;float:left}.fair{padding:2px;width:40%;float:left}.very-good{width:30%;float:left}.outstanding{width:30%;float:left}.perfomance{color:#fff;font-size:13px;height:16px;text-align:center;margin-top:0;width:25%;margin-right:6%;float:left}.fair-head{float:left;font-size:12px}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0;padding-bottom:3px> <div class=full_width> <div class=space-around-color> <div class=color-top-bar> <span> SCHOLASTIC AREAS </span> </div> <div class=table-color-con> <div style=float:left;width:100%;margin-bottom:30px> <span class=e1> <span class=range-color> E </span> <span class=start-0> 0 </span> <span class=end-32>32</span> </span> <span style=background-color:#e2b60c class=e2> <span class=range-new> D </span> <span class=end-new>40</span> </span> <span style=background-color:#d6aa00 class=e2> <span class=range-new> C2 </span> <span class=end-new>50</span> </span> <span style=background-color:#e6c95a class=e2> <span class=range-new> C1 </span> <span class=end-new>60</span> </span> <span style=background-color:#b7b6b1 class=e2> <span class=range-new> B2 </span> <span class=end-new>70</span> </span> <span style=background-color:#93ca16 class=e2> <span class=range-new> B1 </span> <span class=end-new>80</span> </span> <span style=background-color:#56bbec class=e2> <span class=range-new> A2 </span> <span class=end-new>90</span> </span> <span style=background-color:#d0a1f3 class=e2> <span class=range-new> A1 </span> <span class=end-new>100</span> </span> </div> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=8>TERM - 1 (100 marks) </th> <th colspan=8>TERM - 2 (100 marks) </th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:14px;font-weight:700 colspan=2>Sub </td> <td style=font-size:12px;background-color:#ecebeb;font-weight:700 colspan=1>Periodic <br/> Test (10) <br/> </td> <td style=font-size:12px;font-weight:700 colspan=1>Note <br/> book (5) <br/> </td> <td style=font-size:12px;background-color:#ecebeb;font-weight:700>Sub <br/> Enrich. <br/> (5) </td> <td style=font-size:12px;font-weight:700 colspan=1>Half <br/> Yearly <br/> Exam (80)</td> <td style=font-size:12px;background-color:#ecebeb;font-weight:700 colspan=1>Mark <br/> Obt. (100)</td> <td style=font-weight:700> Gr </td> <td style=font-weight:700;background-color:#ecebeb colspan=1>Periodic <br/> Test <br/> (10) </td> <td style=font-weight:700 colspan=1>Note <br/> book <br/> (5) </td> <td style=font-weight:700;background-color:#ecebeb colspan=1>Sub <br/> Enrich. <br/> (5) </td> <td style=font-weight:700 colspan=1>Annual <br/> Exam (80)</td> <td style=font-weight:700;background-color:#ecebeb colspan=1>Mark <br/> obt. (100)</td> <td style=font-weight:700 class=g1 colspan=1>Gr</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in educoreYearEndCtrl.reportCardArray.main_results\"> <td style=font-size:14px colspan=2>{{subject}}</td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.periodic_test_1}}</td> <td colspan=1>{{subjectResult.note_book_submission_1}}</td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td colspan=1>{{subjectResult.half_yearly_1}}</td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.total_mark_1}}</td> <td style=width:7%;color:#fff colspan=1> <span class=grade_show style=background-color:{};>{{subjectResult.grade_1}} </span></td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.periodic_test_2}}</td> <td colspan=1>{{subjectResult.note_book_submission_2}}</td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.subject_enrichment_2}}</td> <td colspan=1>{{subjectResult.annual_exam_2}}</td> <td style=background-color:#ecebeb colspan=1>{{subjectResult.total_mark_2}}</td> <td style=width:7%;color:#fff colspan=1> <span class=grade_show style=background-color:{};>{{subjectResult.grade_2}} </span> </td> </tr> </thead> </table> </div> </div> </div> </div> <div style=padding-bottom:8px;padding-top:2px class=main_con> <div class=scholastic_areas> <div class=\"scholastic_areas_1 space-around-color\"> <div class=color-top-bar> <span>CO - SCHOLASTIC AREAS: TERM - 1</span> </div> <div style=\"padding:8px 8px 8px 3px\" class=w100> <span class=fair> <span style=background-color:#e6c95a class=perfomance>C</span> <span class=fair-head>Fair</span> </span> <span class=fair> <span style=background-color:#93ca16 class=perfomance>B</span> <span class=fair-head>Very good</span> </span> <span class=fair> <span style=background-color:#d0a1f3 class=perfomance>A</span> <span class=fair-head>Outstanding</span> </span> <span class=fair> <span style=background-color:red class=perfomance>NA</span> <span class=fair-head>Not Applicable</span> </span> </div> <div style=\"padding:0 8px 8px 8px\" class=\"grade_detail w100\"> <div class=each-grade> <span style=background-color:#fff;color:#000;float:right;margin-right:4px class=grade-mark>Grade</span> </div> <div class=each-grade ng-repeat=\"(subject, coSubjectResult) in educoreYearEndCtrl.reportCardArray.other_sections\" ng-if=\"subject != 'Discipline'\"> <span class=each-grade-txt>{{subject}}</span> <span style=background-color:{}; class=grade-mark>{{coSubjectResult.grade_1}}</span> </div> </div> </div> <div class=\"scholastic_areas_2 space-around-color\"> <div class=color-top-bar> <span>CO - SCHOLASTIC AREAS: TERM - 2</span> </div> <div style=\"padding:8px 8px 8px 3px\" class=w100> <span class=fair> <span style=background-color:#e6c95a class=perfomance>C</span> <span class=fair-head>Fair</span> </span> <span class=fair> <span style=background-color:#93ca16 class=perfomance>B</span> <span class=fair-head>Very good</span> </span> <span class=fair> <span style=background-color:#d0a1f3 class=perfomance>A</span> <span class=fair-head>Outstanding</span> </span> <span class=fair> <span style=background-color:red class=perfomance>NA</span> <span class=fair-head>Not Applicable</span> </span> </div> <div style=\"padding:0 8px 8px 8px\" class=\"grade_detail w100\"> <div class=each-grade> <span style=background-color:#fff;color:#000;float:right;margin-right:4px class=grade-mark>Grade</span> </div> <div class=each-grade ng-repeat=\"(subject, coSubjectResult) in educoreYearEndCtrl.reportCardArray.other_sections\" ng-if=\"subject != 'Discipline'\"> <span class=each-grade-txt>{{subject}}</span> <span style=background-color:{}; class=grade-mark>{{coSubjectResult.grade_2}}</span> </div> </div> </div> </div> </div> <div style=padding-top:0 class=main_con> <div class=scholastic_areas> <div class=\"scholastic_areas_1 space-around-color\"> <div class=color-top-bar> <span>DISCIPLINE: TERM - 1</span> </div> <div style=\"padding:8px 8px 8px 3px\" class=w100> <span class=fair> <span style=background-color:#e6c95a class=perfomance> C </span> <span class=fair-head>Fair</span> </span> <span class=fair> <span style=background-color:#93ca16 class=perfomance> B </span> <span class=fair-head>Very good</span> </span> <span class=fair> <span style=background-color:#d0a1f3 class=perfomance> A </span> <span class=fair-head>Outstanding</span> </span> <span class=fair> <span style=background-color:red class=perfomance>NA</span> <span class=fair-head>Not Applicable</span> </span> </div> <div style=\"padding:0 8px 8px 8px\" class=\"grade_detail w100\"> <div class=each-grade> <span style=background-color:#fff;color:#000;float:right;margin-right:4px class=grade-mark>Grade</span> </div> <div class=each-grade ng-repeat=\"(subject, coSubjectResult) in educoreYearEndCtrl.reportCardArray.other_sections\" ng-if=\"subject == 'Discipline'\"> <span class=each-grade-txt>{{subject}}</span> <span style=background-color:{}; class=grade-mark>{{coSubjectResult.grade_1}}</span> </div> </div> </div> <div class=\"scholastic_areas_2 space-around-color\"> <div class=color-top-bar> <span>DISCIPLINE: TERM - 2</span> </div> <div style=\"padding:8px 8px 8px 3px\" class=w100> <span class=fair> <span style=background-color:#e6c95a class=perfomance> C </span> <span class=fair-head>Fair</span> </span> <span class=fair> <span style=background-color:#93ca16 class=perfomance> B </span> <span class=fair-head>Very good</span> </span> <span class=fair> <span style=background-color:#d0a1f3 class=perfomance> A </span> <span class=fair-head>Outstanding</span> </span> <span class=fair> <span style=background-color:red class=perfomance>NA</span> <span class=fair-head>Not Applicable</span> </span> </div> <div style=\"padding:0 8px 8px 8px\" class=\"grade_detail w100\"> <div class=each-grade> <span style=background-color:#fff;color:#000;float:right;margin-right:4px class=grade-mark>Grade</span> </div> <div class=each-grade ng-repeat=\"(subject, coSubjectResult) in educoreYearEndCtrl.reportCardArray.other_sections\" ng-if=\"subject == 'Discipline'\"> <span class=each-grade-txt>{{subject}}</span> <span style=background-color:{}; class=grade-mark>{{coSubjectResult.grade_2}}</span> </div> </div> </div> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div>";

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=4>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>TERM 1</th> <th colspan=2> {{reportCardPublishedYear}} </th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Half<br/> Yearly<br/> Exam (80)</td> <td colspan=1>Mark <br/> Obt. (100)</td> <td colspan=1>Grade</td> <td colspan=1>Remarks</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in assetHFCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.periodic_test}}</td> <td colspan=1>{{subjectResult.note_book_submission}}</td> <td colspan=1>{{subjectResult.subject_enrichment}}</td> <td colspan=1>{{subjectResult.half_yearly}}</td> <td colspan=1>{{subjectResult.total_mark}}</td> <td colspan=1>{{subjectResult.grade}}</td> <td colspan=1>{{subjectResult.remarks}}</td> </tr> </thead> </table> <div ng-repeat=\"(key, subjectKeyValue) in assetHFCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Attendance </th> <th colspan=7>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=4>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>TERM 2</th> <th colspan=2> {{reportCardPublishedYear}} </th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Annual<br/> Exam (80)</td> <td colspan=1>Mark <br/> Obt. (100)</td> <td colspan=1>Grade</td> <td colspan=1>Remarks</td> <td colspan=1>T1 & T2 (avg)</td> <td colspan=1>Asset</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in assetAnnualCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.periodic_test}}</td> <td colspan=1>{{subjectResult.note_book_submission}}</td> <td colspan=1>{{subjectResult.subject_enrichment}}</td> <td colspan=1>{{subjectResult.annual_exam}}</td> <td colspan=1>{{subjectResult.total_mark}}</td> <td colspan=1>{{subjectResult.grade}}</td> <td colspan=1>{{subjectResult.remarks}}</td> <td colspan=1>{{subjectResult.term1_term2_avg}}</td> <td colspan=1>{{subjectResult.asset_mark_entry}}</td> </tr> </thead> </table> <div ng-repeat=\"(key, subjectKeyValue) in assetAnnualCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Attendance % </th> <th colspan=7 style=text-align:left> <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.style1{font-size:25px;margin-bottom:0;margin-top:7px;font-weight:700}.txtleft{text-align:left!important}.thick-right-border{border-right:2px solid #000!important}.double-right-border{border-right:5px double #000!important}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=2 class=thick-right-border>SCHOLASTIC ACHIEVEMENT</th> <th colspan=6 class=double-right-border>TERM 1</th> <th colspan=6 style=border-right:none!important>TERM 2</th> <th colspan=2 style=border-left:none!important></th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2 class=thick-right-border><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Half <br/> Yearly<br/> Exam (80)</td> <td colspan=1>Mark <br/> Obt. (100)</td> <td class=double-right-border> Grade </td> <td colspan=1>Periodic<br/> Test<br/> (10)</td> <td colspan=1>Note<br/> book<br/> (5)</td> <td colspan=1>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Annual<br/> Exam (80)</td> <td colspan=1>Mark <br/> obt. (100)</td> <td colspan=1>Grade</td> <td colspan=1>T1 & T2 (avg)</td> <td colspan=1>Asset</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in termConsolidatedCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2 class=thick-right-border><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.periodic_test_1}}</td> <td colspan=1>{{subjectResult.note_book_submission_1}}</td> <td colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td colspan=1>{{subjectResult.half_yearly_1}}</td> <td colspan=1>{{subjectResult.total_mark_1}}</td> <td colspan=1 class=double-right-border>{{subjectResult.grade_1}}</td> <td colspan=1>{{subjectResult.periodic_test_2}}</td> <td colspan=1>{{subjectResult.note_book_submission_2}}</td> <td colspan=1>{{subjectResult.subject_enrichment_2}}</td> <td colspan=1>{{subjectResult.annual_exam_2}}</td> <td colspan=1>{{subjectResult.total_mark_2}}</td> <td colspan=1>{{subjectResult.grade_2}}</td> <td colspan=1>{{subjectResult.term1_term2_avg_2}}</td> <td colspan=1>{{subjectResult.asset_mark_entry_2}}</td> </tr> </thead> </table> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th colspan=5> Co-Scholastic : (Half yearly) (3 - Point Gr.) </th> <th colspan=5> Co-Scholastic : (Annual) (3 - Point Gr.) </th> </tr> <tr> <th colspan=2> Attribute </th> <th colspan=1> Gr. </th> <th colspan=2> Remarks </th> <th colspan=2> Attribute </th> <th colspan=1> Gr. </th> <th colspan=2> Remarks </th> </tr> </thead> <tbody> <tr ng-repeat=\"(subject, coSubjectResult) in termConsolidatedCtrl.reportCardArray.other_sections\"> <th colspan=2> <strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade_1}}</th> <th colspan=2>{{coSubjectResult.remarks_1}}</th> <th colspan=2><strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade_2}}</th> <th colspan=2>{{coSubjectResult.remarks_2}}</th> </tr> </tbody> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Attendance % </th> <th colspan=7 style=text-align:left> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in ptHfTwoCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in ptHfTwoCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <input style=width:85% max=200 type=text ng-model=$root.term_remarks> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in ptAnnualTwoCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in ptAnnualTwoCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports = "<style>.kb-terms td,.kb-terms th{padding:5px 10px;border:1px solid #000}.kg-terms h1,h2,h3,h4,h6{text-align:center}.kb-terms .center,.kb-terms th{text-align:center}.kb-terms.full-body{padding:0 20px;width:1073px}.kb-terms .bottom-table,.kb-terms .main-table,.kb-terms .remarks-table{margin-bottom:30px;border:3px solid #000;width:100%}.kb-terms .remarks-cell{width:50%}.kb-terms .sign-content{margin:50px 10px 25px}.kb-terms .hos-sign{float:right}.kb-terms .score-head{font-weight:700;font-style:italic}.kb-terms .score-table{font-style:italic;margin-bottom:30px;width:100%}.kb-terms .score-table td{border:none;width:25%}.kb-terms .attendance-content{font-weight:900;margin:-5px 5px 25px}.kb-terms .remarks-head{font-weight:700;text-align:left;margin:0 2px}.kb-terms .remarks-table{height:70px}.kb-terms .bottom-table{text-align:center;font-weight:700;height:80px}.kb-terms .signature-text{width:33%;color:silver;font-size:26px}.kb-terms .teacher-sign{width:33%}</style> <div class=\"kb-terms full-body\"> <table class=main-table> <thead> <tr> <th>Subject</th> <th>{{kbTermsCtrl.reportCardArray.header.term_name}}</th> <th>Grade</th> <th class=remarks-cell>Remarks</th> </tr> </thead> <tbody> <tr ng-repeat=\"result in kbTermsCtrl.reportCardArray.response.results\"> <td class=center>{{result.subject}}</td> <td class=center>{{result.mark}}</td> <td class=center>{{result.grade}}</td> <td>{{result.remarks}}</td> </tr> <tr colspan=4 ng-if=mepStatic> <td class=center>Moral Education Program</td> <td colspan=4 style=text-align:right>Passed</td> </tr> </tbody> </table> <div class=sign-content> <span>Signature of Teacher ...........................</span> <span class=hos-sign>Signature of Supervisor/HOS ..........................</span> </div> <h3 class=score-head>Scoring Criteria</h3> <table class=score-table> <tr> <td>A+(Outstanding) : 90 - 100 %</td> <td>B+ (Very Good) : 70 - 79 %</td> <td>C+ (Above Avg) : 50 - 69 %</td> <td>D+ (Below Avg) : 30 - 39 %</td> </tr> <tr> <td>A (Excellent) : 80 - 89 %</td> <td>B (Good) : 60 - 69 %</td> <td>C (Avg) : 40 - 49 % </td> <td>D (Need Improvement) : 20 - 29 %</td> </tr> <tr> <td></td> <td></td> <td></td> <td>E (Great Effort Required to pass) : 0 - 19 %</td> </tr> </table> <div class=attendance-content>Attendance % of the Student: </div> <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> <h3 class=remarks-head style=\"padding:10px 0\">General Remarks:</h3> <table class=remarks-table> <tr> <td></td> </tr> </table> <table class=bottom-table> <tr> <td rowspan=2 class=signature-text>Signature</td> <td class=teacher-sign>Class Teacher</td> <td></td> </tr> <tr> <td>Academic Supervisor / Head of Section</td> <td></td> </tr> </table> </div>";

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-terms td,.kg-terms th{padding:5px 10px;border:1px solid #000}.kg-terms h1,h2,h3,h4,h6{text-align:center}.kg-terms.full-body{padding:0 20px}.kg-terms .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-terms .indicator-table,.kg-terms .progress-table,.kg-terms .subject-table{margin-bottom:30px;border:1px solid #000;width:100%}.kg-terms .indicator-table td{font-weight:700}.kg-terms .indicator-grade{margin-right:10px}.kg-terms .subject-head{background:silver;text-align:center}.kg-terms .skill-key{font-style:italic;width:50%}.kg-terms .skill-grade{font-weight:700;text-align:center}.kg-terms .attendance-content{font-weight:900;margin:-5px 0 20px 5px}.kg-terms .progress-head{font-weight:900;font-size:18px}.kg-terms .progress-comment{height:75px}.kg-terms .progress-signature{padding-top:50px;font-weight:700}.kg-terms .progress-hos-sign{float:right;margin-right:100px}</style> <div class=\"kg-terms full-body\"> <h1 class=indicator-head>Performance Indicators</h1> <table class=indicator-table> <tr> <td><span class=indicator-grade>A+</span> Exceeds expectations</td> <td><span class=indicator-grade>A</span> Fully Meets expectations</td> <td><span class=indicator-grade>B</span> Progressing towards expected level</td> </tr> <tr> <td><span class=indicator-grade>C</span> Meets expectations at a beginning level</td> <td><span class=indicator-grade>D</span> Not within expectations</td> <td><span class=indicator-grade>NA</span> Not applicable at this stage</td> </tr> <tr> <td colspan=3><span class=indicator-grade>AB</span> Absent</td> </tr> </table> <table class=subject-table ng-repeat=\"result in kgTermsCtrl.resultValues track by $index\" ng-init=\"rowIndex = $index+1\"> <tr> <th class=subject-head>{{result.subject_name_value}} </th> <th class=subject-head>{{kgTermsCtrl.reportCardArray.header.display_name}} (GRADE)</th> <th class=subject-head>OVERALL PERFORMANCE / DESCRIPTIVE INDICATORS</th> </tr> <tr ng-repeat=\"buckets in result.subject_results track by $index\" ng-init=\"columnIndex = $index+1\"> <td class=skill-key>{{rowIndex}}.{{columnIndex}}. {{buckets.bucketName}}</td> <td class=skill-grade>{{buckets.grade === 'ABSENT' ? 'AB' : buckets.grade}}</td> <td class=skill-grade>{{buckets.remarks === 'ABSENT' ? 'Absent' : buckets.remarks}}</td> </tr> <tr> <td class=skill-key style=font-weight:700>OVERALL GRADE</td> <td class=skill-grade>{{result.overall_grade === 'ABSENT' ? 'AB' : result.overall_grade}}</td> <td class=skill-grade>{{result.remarks === 'ABSENT' ? 'Absent' : result.remarks}}</td> </tr> </table> <div class=attendance-content>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></div> <table class=progress-table> <thead> <th class=progress-head>Performance and Progress Remarks - {{kgTermsCtrl.reportCardArray.header.display_name}}{{kgTermsCtrl.header.display_name}}</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-comment> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks}}</span> <input style=width:100%;height:70% ng-if=$root.isTeachingStaff type=text ng-model=$root.term_remarks> </td></tr></table></div>  <td rowspan=2></td>  <tr> <td class=progress-signature> <span>Class Teacher</span> <span class=progress-hos-sign>Head of Section</span> </td> </tr> ";

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-consolidated td,.kg-consolidated th{padding:5px 10px;border:3px solid #000}.kg-consolidated h1,h2,h3,h4,h6{text-align:center}.kg-consolidated.full-body{padding:0 20px}.kg-consolidated .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-consolidated .indicator-table,.kg-consolidated .progress-table,.kg-consolidated .subject-table{margin-bottom:30px;border:3px solid #000;width:100%}.kg-consolidated .indicator-table td{font-weight:700}.kg-consolidated .indicator-grade{margin-right:10px}.kg-consolidated .subject-head{background:silver;text-align:center}.kg-consolidated .skill-key{font-style:italic;width:50%}.kg-consolidated .skill-grade{font-weight:700;text-align:center}.kg-consolidated .progress-head{font-weight:900;font-size:18px}.kg-consolidated .progress-content{width:75%}.kg-consolidated .progress-term-comment{font-weight:700}.kg-consolidated .progress-comment{height:100px}.kg-consolidated .progress-signature{font-weight:700}.kg-consolidated .progress-hos-sign{float:right;margin-right:100px}</style> <div class=\"kg-consolidated full-body\"> <h1 class=indicator-head>Performance Indicators</h1> <table class=indicator-table> <tr> <td><span class=indicator-grade>A+</span> Exceeds expectations</td> <td><span class=indicator-grade>A</span> Fully Meets expectations</td> <td><span class=indicator-grade>B</span> Progressing towards expected level</td> </tr> <tr> <td><span class=indicator-grade>C</span> Meets expectations at a beginning level</td> <td><span class=indicator-grade>D</span> Not within expectations</td> <td><span class=indicator-grade>NA</span> Not applicable at this stage</td> </tr> <tr> <td colspan=3><span class=indicator-grade>AB</span> Absent</td> </tr> </table> <table class=subject-table ng-repeat=\"result in kgConsolidatedCtrl.reportResultArray track by $index\" ng-init=\"rowIndex = $index+1\"> <tr> <th class=subject-head>{{result.subject_name_value}}</th> <th class=subject-head>TERM 1 (GRADE)</th> <th class=subject-head>TERM 2 (GRADE)</th> <th class=subject-head>TERM 3 (GRADE)</th> </tr> <tr ng-repeat=\"buckets in result.bucketArray track by $index\" ng-init=\"columnIndex = $index+1\"> <td class=skill-key>{{rowIndex}}.{{columnIndex}}. {{buckets.bucketName}}</td> <td class=skill-grade>{{buckets.term_1 === 'ABSENT' ? 'AB' : buckets.term_1}}</td> <td class=skill-grade>{{buckets.term_2 === 'ABSENT' ? 'AB' : buckets.term_2}}</td> <td class=skill-grade>{{buckets.term_3 === 'ABSENT' ? 'AB' : buckets.term_3}}</td> </tr> <tr> <td class=subject-head style=font-weight:700;background:#fff!important;text-align:left!important>OVERALL GRADE</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termone === 'ABSENT' ? 'AB' : result.overall_termone}}</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termtwo === 'ABSENT' ? 'AB' : result.overall_termtwo}}</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termthree === 'ABSENT' ? 'AB' : result.overall_termthree}}</td> </tr> </table> <table class=progress-table> <thead> <th class=progress-head>Performance and Progress</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-content> <div class=progress-term-comment>1st Term Comments</div> <div class=progress-comment>{{kgConsolidatedCtrl.reportCardArray.term_obj.term_1}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> <tr> <td class=progress-content> <div class=progress-term-comment>2nd Term Comments</div> <div class=progress-comment>{{kgConsolidatedCtrl.reportCardArray.term_obj.term_2}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> <tr> <td class=progress-content> <div class=progress-term-comment>3rd Term Comments</div> <div class=progress-comment>{{kgConsolidatedCtrl.reportCardArray.term_obj.term_3}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> </table> </div> ";

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr style=font-size:12px> <th colspan=2 style=font-size:12px>Subjects</th> <th colspan=1 style=font-size:12px> ELT <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>MID TERM <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>CYCLE TEST <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>BREAK UP TEST <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>SA 1 <br/>(100)<br/></th> <th colspan=1 style=font-size:12px> SA 2 <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>THEORY ANNUAL <br/>(100)<br/></th> <th colspan=1 style=font-size:12px>THEORY ANNUAL <br/>(100)<br/></th> </tr> </thead> <thead> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in hssReportCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.elt}}</td> <td colspan=1>{{subjectResult.mid_term}}</td> <td colspan=1>{{subjectResult.cycle_test}}</td> <td colspan=1>{{subjectResult.breakuptest}}</td> <td colspan=1>{{subjectResult.SA_1}}</td> <td colspan=1>{{subjectResult.SA_2}}</td> <td colspan=1>{{subjectResult.theory_annual}}</td> <td colspan=1>{{subjectResult.practical_annual}}</td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Remarks</strong> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=2> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>ClassTeacher Signature</strong> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=2> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Supervisor Signature</strong> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=2> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>HOS Signature</strong> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=2> </td> </tr> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Parent Signature</strong> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=1> </td> <td style=font-size:20px colspan=2> </td> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Term1</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=2><strong>Grade</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in cbseHssPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=2>{{value.grade}}</td> </tr> </thead> </table> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=4>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2>{{specificHFPublishedCtrl.reportCardArray.report_card_name}}</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td colspan=1><strong>*PT (10) <br/></strong> </td> <td colspan=1><strong>*NB (5) <br/></strong> </td> <td colspan=1><strong>*S.E (5) <br/></strong> </td> <td ng-if=\"specificHFPublishedCtrl.reportCardArray.header.report_name=='Annual'\" colspan=1><strong>Annual <br/> Exam (80) </strong> </td> <td ng-if=\"specificHFPublishedCtrl.reportCardArray.header.report_name!='Annual'\" colspan=1><strong>Half <br/> Yearly <br/> Exam (80/100) </strong> </td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in specificHFPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td colspan=1 ng-if=value.periodic_test>{{value.periodic_test}}</td> <td colspan=1 ng-if=!value.periodic_test>NA</td> <td colspan=1 ng-if=value.note_book_submission>{{value.note_book_submission}}</td> <td colspan=1 ng-if=!value.note_book_submission>NA</td> <td colspan=1 ng-if=value.subject_enrichment>{{value.subject_enrichment}}</td> <td colspan=1 ng-if=!value.subject_enrichment>NA</td> <td colspan=1 ng-if=\"specificHFPublishedCtrl.reportCardArray.header\n.report_name!='Annual'\">{{value.half_yearly}}</td> <td colspan=1 ng-if=\"specificHFPublishedCtrl.reportCardArray.header\n.report_name=='Annual'\">{{value.annual_exam}}</td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <h2 style=text-align:left;font-size:16px;margin-bottom:0> Abbreviations : * PT : Periodic Test * NB : Notebook Maintainence *S.E : Subject Enrichment </h2> <br> <div ng-repeat=\"(key, subjectKeyValue) in specificHFPublishedCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=2><strong>Grade</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in cbseHssPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=2>{{value.grade}}</td> </tr> </thead> </table> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=5>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5> Term1</th> <th colspan=7> Term2 /Final</th> </tr> </thead> <thead> <tr style=font-size:12px> <td colspan=1>Sl <br/> No. <br/> </td> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td>Total<br/> <br/> (20)</td> <td colspan=1>Term1 <br/> Exam (80/100)</td> <td colspan=1>Aggregate <br/> Obt. (100)</td> <td> Grade </td> <td colspan=1>Periodic<br/> Test<br/> (10)</td> <td colspan=1>Note<br/> book<br/> (5)</td> <td colspan=1>Subject<br/> Enrich.<br/> (5)</td> <td>Total<br/> <br/> (20)</td> <td colspan=1>Pen & Paper<br/> Exam (80/100)</td> <td colspan=1>Aggregate <br/> obt. (100)</td> <td colspan=1>Grade</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in cbseSpecificSubjectsFinalCtrl.reportCardArray.main_results track by $index\"> <td colspan=1>{{$index+1}}</td> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1 ng-if=subjectResult.periodic_test1>{{subjectResult.periodic_test1}}</td> <td colspan=1 ng-if=!subjectResult.periodic_test1>NA</td> <td colspan=1 ng-if=subjectResult.note_book_submission1>{{subjectResult.note_book_submission1}}</td> <td colspan=1 ng-if=!subjectResult.note_book_submission1>NA</td> <td colspan=1 ng-if=subjectResult.subject_enrichment1>{{subjectResult.subject_enrichment1}}</td> <td colspan=1 ng-if=!subjectResult.subject_enrichment1>NA</td> <td colspan=1 ng-if=subjectResult.assessment_total1>{{subjectResult.assessment_total1}}</td> <td colspan=1 ng-if=!subjectResult.assessment_total1>NA</td> <td colspan=1 ng-if=subjectResult.half_yearly1>{{subjectResult.half_yearly1}}</td> <td colspan=1 ng-if=!subjectResult.half_yearly1>NA</td> <td colspan=1 ng-if=subjectResult.total_mark1>{{subjectResult.total_mark1}}</td> <td colspan=1 ng-if=!subjectResult.total_mark1>NA</td> <td colspan=1 ng-if=subjectResult.grade1>{{subjectResult.grade1}}</td> <td colspan=1 ng-if=!subjectResult.grade1>NA</td> <td colspan=1 ng-if=subjectResult.periodic_test2>{{subjectResult.periodic_test2}}</td> <td colspan=1 ng-if=!subjectResult.periodic_test2>NA</td> <td colspan=1 ng-if=subjectResult.note_book_submission2>{{subjectResult.note_book_submission2}}</td> <td colspan=1 ng-if=!subjectResult.note_book_submission2>NA</td> <td colspan=1 ng-if=subjectResult.subject_enrichment2>{{subjectResult.subject_enrichment2}}</td> <td colspan=1 ng-if=!subjectResult.subject_enrichment2>NA</td> <td colspan=1 ng-if=subjectResult.assessment_total2>{{subjectResult.assessment_total2}}</td> <td colspan=1 ng-if=!subjectResult.assessment_total2>NA</td> <td colspan=1 ng-if=subjectResult.pen_paper2>{{subjectResult.pen_paper2}}</td> <td colspan=1 ng-if=!subjectResult.pen_paper2>NA</td> <td colspan=1 ng-if=subjectResult.total_mark2>{{subjectResult.total_mark2}}</td> <td colspan=1 ng-if=!subjectResult.total_mark2>NA</td> <td colspan=1 ng-if=subjectResult.grade2>{{subjectResult.grade2}}</td> <td colspan=1 ng-if=!subjectResult.grade2>NA</td> </tr> <tr style=font-size:12px ng-if=\"subject != 'Discipline'\" ng-repeat=\"(subject, coSubjectResult) in cbseSpecificSubjectsFinalCtrl.reportCardArray.other_sections\"> <td colspan=1>{{coSubjectResult.index}}</td> <td style=font-size:18px;text-align:left colspan=15><strong>{{subject}}</strong></td> <td colspan=1>{{coSubjectResult.grade2}}</td> </tr> </thead> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3> DISCIPLINE (Term1) (A-C Gr.) <br/> </th> <th colspan=7> DISCIPLINE (Term2) (A-C Gr.) </th> </tr> </thead> <tbody> <tr ng-if=\"subject == 'Discipline'\" ng-repeat=\"(subject, coSubjectResult) in cbseSpecificSubjectsFinalCtrl.reportCardArray.other_sections\"> <th colspan=2> <strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade1}}</th> <th colspan=2>{{coSubjectResult.remarks1}}</th> <th colspan=2><strong>{{subject}} </strong></th> <th colspan=1>{{coSubjectResult.grade2}}</th> <th colspan=2>{{coSubjectResult.remarks2}}</th> </tr> </tbody> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 align=left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Attendance % </th> <th colspan=7 style=text-align:left> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance> </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> ";

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "<style>.main_bg{width:1120px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1120px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:3px 1px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.style1{font-size:25px;margin-bottom:0;margin-top:7px;font-weight:700}.txtleft{text-align:left!important}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0!important> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3>SCHOLASTIC ACHIEVEMENT</th> <th colspan=7 ng-if=nonFinalSchoolIds> Term1</th> <th colspan=7 ng-if=nonFinalSchoolIds> Term2 </th> <th colspan=7 ng-if=!nonFinalSchoolIds> Term1</th> <th colspan=7 ng-if=!nonFinalSchoolIds> Annual </th> <th colspan=7 ng-if=nonFinalSchoolIds> Final</th> </tr> </thead> <thead> <tr style=font-size:12px> <td colspan=1>Sl <br/> No. <br/> </td> <td style=font-size:16px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td>Total<br/> <br/> (20)</td> <td colspan=1>Term1 <br/> Exam (80/100)</td> <td colspan=1>Aggregate <br/> Obt. (100)</td> <td> Grade </td> <td colspan=1>Periodic<br/> Test<br/> (10)</td> <td colspan=1>Note<br/> book<br/> (5)</td> <td colspan=1>Subject<br/> Enrich.<br/> (5)</td> <td>Total<br/> <br/> (20)</td> <td colspan=1>Pen & Paper<br/> (80/100)</td> <td colspan=1>Aggregate <br/> obt. (100)</td> <td colspan=1>Grade</td> <td colspan=1 ng-if=nonFinalSchoolIds>Periodic<br/> Test<br/> (10)</td> <td colspan=1 ng-if=nonFinalSchoolIds>Note<br/> book<br/> (5)</td> <td colspan=1 ng-if=nonFinalSchoolIds>Subject<br/> Enrich.<br/> (5)</td> <td ng-if=nonFinalSchoolIds>Total<br/> <br/> (20)</td> <td colspan=1 ng-if=nonFinalSchoolIds>Pen & Paper<br/> (80/100)</td> <td colspan=1 ng-if=nonFinalSchoolIds>Aggregate <br/> obt. (100)</td> <td colspan=1 ng-if=nonFinalSchoolIds>Grade</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in cbseSpecificoneeghtFinalCtrl.reportCardArray.main_results track by $index\"> <td colspan=1>{{subjectResult.index}}</td> <td style=font-size:13px colspan=2><strong>{{subject}}</strong></td> <td colspan=1 ng-if=subjectResult.periodic_test1>{{subjectResult.periodic_test1}}</td> <td colspan=1 ng-if=!subjectResult.periodic_test1>NA</td> <td colspan=1 ng-if=subjectResult.note_book_submission1> {{subjectResult.note_book_submission1}}</td> <td colspan=1 ng-if=!subjectResult.note_book_submission1>NA</td> <td colspan=1 ng-if=subjectResult.subject_enrichment1>{{subjectResult.subject_enrichment1}} </td> <td colspan=1 ng-if=!subjectResult.subject_enrichment1>NA</td> <td colspan=1 ng-if=subjectResult.assessment_total1>{{subjectResult.assessment_total1}}</td> <td colspan=1 ng-if=!subjectResult.assessment_total1>NA</td> <td colspan=1 ng-if=subjectResult.half_yearly1>{{subjectResult.half_yearly1}}</td> <td colspan=1 ng-if=!subjectResult.half_yearly1>NA</td> <td colspan=1 ng-if=subjectResult.total_mark1>{{subjectResult.total_mark1}}</td> <td colspan=1 ng-if=!subjectResult.total_mark1>NA</td> <td colspan=1 ng-if=subjectResult.grade1>{{subjectResult.grade1}}</td> <td colspan=1 ng-if=!subjectResult.grade1>NA</td> <td colspan=1 ng-if=subjectResult.periodic_test2>{{subjectResult.periodic_test2}}</td> <td colspan=1 ng-if=!subjectResult.periodic_test2>NA</td> <td colspan=1 ng-if=subjectResult.note_book_submission2> {{subjectResult.note_book_submission2}}</td> <td colspan=1 ng-if=!subjectResult.note_book_submission2>NA</td> <td colspan=1 ng-if=subjectResult.subject_enrichment2>{{subjectResult.subject_enrichment2}} </td> <td colspan=1 ng-if=!subjectResult.subject_enrichment2>NA</td> <td colspan=1 ng-if=subjectResult.assessment_total2>{{subjectResult.assessment_total2}}</td> <td colspan=1 ng-if=!subjectResult.assessment_total2>NA</td> <td colspan=1 ng-if=subjectResult.pen_paper2>{{subjectResult.pen_paper2}}</td> <td colspan=1 ng-if=!subjectResult.pen_paper2>NA</td> <td colspan=1 ng-if=subjectResult.total_mark2>{{subjectResult.total_mark2}}</td> <td colspan=1 ng-if=!subjectResult.total_mark2>NA</td> <td colspan=1 ng-if=subjectResult.grade2>{{subjectResult.grade2}}</td> <td colspan=1 ng-if=!subjectResult.grade2>NA</td> <td colspan=1 ng-if=\"subjectResult.periodic_test3 && nonFinalSchoolIds\"> {{subjectResult.periodic_test3}}</td> <td colspan=1 ng-if=\"!subjectResult.periodic_test3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.note_book_submission3 && nonFinalSchoolIds\"> {{subjectResult.note_book_submission3}}</td> <td colspan=1 ng-if=\"!subjectResult.note_book_submission3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.subject_enrichment3 && nonFinalSchoolIds\"> {{subjectResult.subject_enrichment3}}</td> <td colspan=1 ng-if=\"!subjectResult.subject_enrichment3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.assessment_total3 && nonFinalSchoolIds\"> {{subjectResult.assessment_total3}}</td> <td colspan=1 ng-if=\"!subjectResult.assessment_total3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.pen_paper3 && nonFinalSchoolIds\"> {{subjectResult.pen_paper3}}</td> <td colspan=1 ng-if=\"!subjectResult.pen_paper3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.total_mark3 && nonFinalSchoolIds\"> {{subjectResult.total_mark3}}</td> <td colspan=1 ng-if=\"!subjectResult.total_mark3 && nonFinalSchoolIds\">NA</td> <td colspan=1 ng-if=\"subjectResult.grade3 && nonFinalSchoolIds\">{{subjectResult.grade3}}</td> <td colspan=1 ng-if=\"!subjectResult.grade3 && nonFinalSchoolIds\">NA</td> </tr> <tr style=font-size:12px ng-if=\"subject != 'Discipline'\" ng-repeat=\"(subject, coSubjectResult) in cbseSpecificoneeghtFinalCtrl.reportCardArray.other_sections\"> <td colspan=1>{{coSubjectResult.index}}</td> <td ng-if=nonFinalSchoolIds style=font-size:16px;text-align:left colspan=21><strong>{{subject}}</strong></td> <td ng-if=nonFinalSchoolIds colspan=2>{{coSubjectResult.grade1_2}}</td> <td ng-if=!nonFinalSchoolIds style=font-size:16px;text-align:left colspan=15><strong>{{subject}}</strong></td> <td ng-if=!nonFinalSchoolIds colspan=1>{{coSubjectResult.grade1_2}}</td> </tr> </thead> </table> <table style=\"margin:10px 0;border:3px solid #000;width:100%\"> <thead> <tr style=height:70px;text-align:left;display:block;font-size:18px;padding:5px> <th>Result</th> </tr> </thead> </table> <div style=font-size:18px> <p>Promoted to Grade &nbsp;&nbsp;&nbsp;&nbsp;_____ &nbsp;&nbsp;&nbsp;&nbsp;Attendance % &nbsp;&nbsp;&nbsp;&nbsp;<input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></p> </div> <table style=\"margin:10px 0;width:100%;border-collapse:collapse;font-size:18px;font-weight:100\"> <thead> <tr style=text-align:left> <th style=\"border:4px solid #000;padding:0 5px;font-weight:500;line-height:2\"> Discipline: Term 1 [on a 3 point (A-C) scale] <br/> Grade &nbsp;&nbsp;&nbsp;&nbsp;{{cbseSpecificoneeghtFinalCtrl.reportCardArray.other_sections.Discipline.grade1}} </th> <th style=\"border:4px solid #000;padding:0 5px;font-weight:500;line-height:2\"> Discipline: Term 2 [on a 3 point (A-C) scale] <br/> Grade &nbsp;&nbsp;&nbsp;&nbsp;{{cbseSpecificoneeghtFinalCtrl.reportCardArray.other_sections.Discipline.grade2}} </th> </tr> </thead> </table> <table style=\"margin:10px 0;width:100%;border-collapse:collapse;border:4px solid #000;font-size:18px;font-weight:100\"> <tbody> <tr> <th style=\"border:2px solid #000;padding:5px\">Grade</th> <th style=\"border:2px solid #000;padding:5px\">Marks Range</th> <td style=\"border:2px solid #000;padding:5px\">Class Teacher</td> <td style=\"border:2px solid #000;padding:5px;text-align:center;vertical-align:top\" rowspan=9>School Stamp</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">A1</th> <th style=\"border:2px solid #000;padding:5px\">91-100</th> <td style=\"border:2px solid #000;padding:5px\">Signature</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">A2</th> <th style=\"border:2px solid #000;padding:5px\">81-90</th> <td style=\"border:2px solid #000;padding:5px\">Date</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">B1</th> <th style=\"border:2px solid #000;padding:5px\">71-80</th> <td style=\"border:2px solid #000;padding:5px\">Superviser</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">B2</th> <th style=\"border:2px solid #000;padding:5px\">61-70</th> <td style=\"border:2px solid #000;padding:5px\">Signature</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">C1</th> <th style=\"border:2px solid #000;padding:5px\">51-60</th> <td style=\"border:2px solid #000;padding:5px\">Date</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">C2</th> <th style=\"border:2px solid #000;padding:5px\">41-50</th> <td style=\"border:2px solid #000;padding:5px\">HOS</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">D</th> <th style=\"border:2px solid #000;padding:5px\">33-40</th> <td style=\"border:2px solid #000;padding:5px\">Signature</td> </tr> <tr> <th style=\"border:2px solid #000;padding:5px\">E</th> <th style=\"border:2px solid #000;padding:5px\">&lt;=33</th> <td style=\"border:2px solid #000;padding:5px\">Date</td> </tr> </tbody> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> ";

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-terms td,.kg-terms th{padding:5px 10px;border:3px solid #000}.kg-terms h1,h2,h3,h4,h6{text-align:center}.kg-terms.full-body{padding:0 20px}.kg-terms .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-terms .indicator-table,.kg-terms .progress-table,.kg-terms .subject-table{margin-bottom:30px;border:3px solid #000;width:100%}.kg-terms .indicator-table td{font-weight:700}.kg-terms .indicator-grade{margin-right:10px}.kg-terms .subject-head{background:silver;text-align:center}.kg-terms .skill-key{font-style:italic;width:50%}.kg-terms .skill-grade{font-weight:700;text-align:center}.kg-terms .attendance-content{font-weight:900;margin:15px 0 20px 5px}.kg-terms .progress-head{font-weight:900;font-size:18px}.kg-terms .progress-comment{height:75px}.kg-terms .progress-signature{padding-top:50px;font-weight:700}.kg-terms .progress-hos-sign{float:right;margin-right:100px}#table-example-1{border:3px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <div class=\"kg-terms full-body\"> <table id=table-example-1 class=full_width> <thead> <tr> <th>Subject</th> <th class=subject-head>Term 1</th> <th class=subject-head>Term 2</th> <th class=subject-head>Term 3</th> <th class=subject-head>Final</th> </tr> </thead> <tbody> <tr ng-repeat=\"(onesubject, result) in kbFinalComponentCtrl.reportCardArray.main_results\"> <td class=center>{{onesubject}}</td> <td class=center>{{result.term1grade}}</td> <td class=center>{{result.term2grade}}</td> <td class=center>{{result.term3grade}}</td> <td class=center>{{result.aggregate_grade}}</td> </tr> <tr colspan=4 ng-if=mepStatic> <td class=center>Moral Education Program</td> <td colspan=4 class=center style=text-align:right>Passed</td> </tr> </tbody> </table> <table cellpadding=0 cellspacing=0 class=t1 id=table-example-1 class=full_width> <thead ng-repeat=\"result in kbFinalComponentCtrl.reportCardArray.specificResults\"> <tr> <td class=subject-head><b>{{result.subject}}</b></td> </tr> <tr ng-repeat=\"oneSkill in result.report.skills\"> <td style=padding:0 class=center> <table cellpadding=0 cellspacing=0 class=t1 style=width:100%> <tr style=width:100%> <td class=center> {{oneSkill.name}} </td> </tr> <tr ng-repeat=\"sub in oneSkill.sub_skills\"> <td style=width:35% class=center>{{sub.sl_no}}</td> <td style=width:60% class=center>{{sub.subkill_name}}</td> <td style=width:5% class=center>{{sub.grade}}</td> </tr> </table> </td> </tr> </thead> </table> <div class=attendance-content>Attendance % of the Student: </div> <table id=table-example-1 class=full_width> <thead> <th class=progress-head>Performance and Progress Remarks - {{kbFinalComponentCtrl.reportCardArray.header.report_name}}{{kbFinalComponentCtrl.header.report_name}}</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-comment></td> <td rowspan=2></td> </tr> <tr> <td class=progress-signature> <span>Class Teacher</span> <span class=progress-hos-sign>Head of Section</span> </td> </tr> </table> <h1 class=indicator-head>Performance Indicators</h1> <table id=table-example-1 class=full_width> <tr> <td><span class=indicator-grade>A+</span> (Outstanding) : 90 - 100 %</td> <td><span class=indicator-grade>A</span> (Excellent) : 80 - 89 %</td> <td><span class=indicator-grade>B+</span> (Very Good) : 70 - 79 %</td> <td><span class=indicator-grade>B</span>(Good) : 60 - 69 %</td> </tr> <tr> <td><span class=indicator-grade>C</span>(Avg) : 40 - 49 %</td> <td><span class=indicator-grade>D+</span>(Below Avg) : 30 - 39 %</td> <td><span class=indicator-grade>D</span>(Need Improvement) : 20 - 29 %</td> <td><span class=indicator-grade>E</span>(Great Effort Required to pass) : 0 -19 %</td> </tr> </table> </div>";

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.style1{font-size:25px;margin-bottom:0;margin-top:7px;font-weight:700}.txtleft{text-align:left!important}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2> HALF YEARLY</th> <th colspan=2> ANNUAL</th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Half <br/> Yearly<br/> Exam (100)</td> <td> Grade </td> <td colspan=1>Annual<br/> Exam (100)</td> <td colspan=1>Grade</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in pubishedcbsehssAnnualCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1 ng-if=subjectResult.total_mark1>{{subjectResult.total_mark1}}</td> <td colspan=1 ng-if=!subjectResult.total_mark1>NA</td> <td colspan=1 ng-if=subjectResult.grade1>{{subjectResult.grade1}}</td> <td colspan=1 ng-if=!subjectResult.grade1>NA</td> <td colspan=1 ng-if=subjectResult.total_mark2>{{subjectResult.total_mark2}}</td> <td colspan=1 ng-if=!subjectResult.total_mark2>NA</td> <td colspan=1 ng-if=subjectResult.grade2>{{subjectResult.grade2}}</td> <td colspan=1 ng-if=!subjectResult.grade2>NA</td> </tr> </thead> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3 height=59 style=width:50%> RESULT </th> <th colspan=7 style=text-align:left ;> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </th> </tr> <tr> <th colspan=3 height=59>Attendance </th> <th colspan=7>&nbsp;{{reportCardArray.attendance}} <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term1 style=width:142px;float:left> </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp;</th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.style1{font-size:25px;margin-bottom:0;margin-top:7px;font-weight:700}.txtleft{text-align:left!important}</style> <div class=\"\" ng-if=!isPdfData> <div class=main_con style=padding-top:0;margin-bottom:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=4>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>Annual</th> <th colspan=2> {{reportCardPublishedYear}} </th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Periodic <br/> Test (10) <br/> </td> <td colspan=1>Note <br/> book (5) <br/> </td> <td>Subject<br/> Enrich.<br/> (5)</td> <td colspan=1>Annual<br/> <br/> Exam (80)</td> <td colspan=1>Mark <br/> Obt. (100)</td> <td colspan=1>Grade</td> <td colspan=1>Remarks</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in nineonlypubllishedCompCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1>{{subjectResult.periodic_test}}</td> <td colspan=1>{{subjectResult.note_book_submission}}</td> <td colspan=1>{{subjectResult.subject_enrichment}}</td> <td colspan=1>{{subjectResult.annual_exam}}</td> <td colspan=1>{{subjectResult.total_mark}}</td> <td colspan=1>{{subjectResult.grade}}</td> <td colspan=1>{{subjectResult.remarks}}</td> </tr> </thead> </table> <div ng-repeat=\"(key, subjectKeyValue) in nineonlypubllishedCompCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=\"width:100%;margin:20px 0\"> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <table id=table-example-1 style=width:100%;border-top:none!important> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp; </th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.main_bg{width:1070px;margin:0 auto;padding:10px;background-color:#fff;padding-bottom:65px}.main_bg h1,h2,h3,h4,h6{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px!important}.full_width{width:100%}.full_width_new{width:100%;border:1px solid #e1e1e1;display:flex}.left_width{width:370px;float:left;padding:10px;border-right:1px solid #e1e1e1}.right_width{width:250px;float:left}.emerging{width:28%;border:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left}.tick{width:28%;border-right:1px solid #e1e1e1;padding:5px;font-size:13px;font-weight:700;float:left;height:26px}.tick img{padding:6px 26px}.left_margin{padding-left:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:790px;float:left;display:block}.annexure{width:130px;height:40px;border:1px solid #000;float:right;display:block;margin-right:130px}.annexure h3{text-align:center;margin-top:7px;margin-left:5px}.school_logo{width:450px;display:block;float:left}.school_logo img{width:130px;height:135px;margin-right:35px;margin-top:0;display:block;position:relative;top:40px;float:right}.main_img{width:200px}.profile_detail{width:460px;float:left}.profile_left{width:120px;float:left}.profile_right{width:290px;float:left}.margin_nill{margin:5px 0!important}.activity_con{background-color:#e1e1e1;padding:14px;margin:15px 0;font-size:15px;color:#353535}.activity_con span.left_title{background-color:#e1e1e1}.activity_con span.eyfs_activity{background-color:#e1e1e1;font-weight:700}.profile_con{width:100%;margin-bottom:20px}.batch{width:300px}.heading_mid{width:1000px;float:left}.date_right{width:200}.pdftable{width:100%;max-width:100%;margin-bottom:1rem}.pdftable{border-collapse:collapse;background-color:transparent}.pdftable{display:table;border-spacing:2px;border-color:#5e6161;margin-left:0}.pdftable td,.pdftable th{padding:.75rem;vertical-align:top;width:120px;min-width:100px;max-width:120px;word-wrap:break-word}.pdftable th{padding:.75rem;vertical-align:top;font-size:20px;font-weight:600}.pdftable-bordered{border:1px solid #5e6161}.pdftable-bordered td,.pdftable-bordered th{padding:8px;line-height:1.42857143;vertical-align:top;border:1px solid #5e6161}.border_bottom{border-bottom:1px solid;margin-bottom:50px;float:left;width:1070px}.remarks_con{float:left;width:100%;display:block;font-weight:700;margin-top:20px}.remarks_con span.remarks{float:left;display:block}.remarks_con span.remarks_head{float:left;display:block;margin-right:10px}.profile_img{float:left}.date_area{float:left;display:block;width:300px;margin-top:50px}.date_area span.date_label{float:left;display:block;margin-right:5px;font-weight:700}.date_area span.Date_only{float:left;display:block;width:190px;font-weight:700}.teacher_sign{float:left;display:block;width:410px;margin-top:50px;font-weight:700}.Principal_sign{float:left;display:block;width:290px;margin-top:50px;font-weight:700}.grading_con{float:left;display:block;width:100%;margin-bottom:20px}.grading_con span.grade_head{float:left;display:block;font-weight:700}.grading_con span.grade_content{float:left;display:block}.border_bottom{border-bottom:1px solid #000;margin-top:5px}.no_border{border-right-color:#fff}.mark_range{float:left;display:block;margin-left:300px}.sign_con{float:left;display:block;margin-bottom:5px}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.8rem .5rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700;text-align:center;vertical-align:middle;font-size:18px}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;vertical-align:middle}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-example-1 tbody td:first-child::after{content:leader(\". \")}.logo_name{font-size:35px;text-transform:uppercase}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px;text-align:center}.style1{font-size:25px;margin-bottom:0;margin-top:7px;font-weight:700}.txtleft{text-align:left!important}</style> <div class=main_bg ng-if=!isPdfData> <div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;border-bottom:none!important> <thead> <tr> <th colspan=2>SCHOLASTIC ACHIEVEMENT</th> <th colspan=2> HALF YEARLY</th> <th colspan=2> ANNUAL</th> </tr> </thead> <thead> <tr style=font-size:12px> <td style=font-size:20px colspan=2><strong>Subject</strong> </td> <td colspan=1>Half <br/> Yearly<br/> Exam (100)</td> <td> Grade </td> <td colspan=1>Annual<br/> Exam (100)</td> <td colspan=1>Grade</td> </tr> <tr style=font-size:12px ng-repeat=\"(subject, subjectResult) in kbannualHssPublishedCtrl.reportCardArray.main_results\"> <td style=font-size:18px colspan=2><strong>{{subject}}</strong></td> <td colspan=1 ng-if=subjectResult.total_mark1>{{subjectResult.total_mark1}}</td> <td colspan=1 ng-if=!subjectResult.total_mark1>NA</td> <td colspan=1 ng-if=subjectResult.grade1>{{subjectResult.grade1}}</td> <td colspan=1 ng-if=!subjectResult.grade1>NA</td> <td colspan=1 ng-if=subjectResult.total_mark2>{{subjectResult.total_mark2}}</td> <td colspan=1 ng-if=!subjectResult.total_mark2>NA</td> <td colspan=1 ng-if=subjectResult.grade2>{{subjectResult.grade2}}</td> <td colspan=1 ng-if=!subjectResult.grade2>NA</td> </tr> </thead> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=3 height=59> RESULT </th> <th colspan=7 style=text-align:left ;> Promoted to Class&hellip;&hellip;.. </th> </tr> <tr> <th colspan=3 height=59>Attendance </th> <th colspan=7>&nbsp;{{reportCardArray.attendance}} </th> </tr> <tr> <th colspan=3 height=59> Signature of Class Teacher</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th height=59 colspan=3>Signature of Principal/HoS</th> <th colspan=7>&nbsp; </th> </tr> <tr> <th colspan=3 height=59>Date & Place </th> <th colspan=7>&nbsp;</th> </tr> </thead> </table> </div> </div> </div> <div class=main_bg ng-if=isPdfData> <iframe ng-src={{url}} frameborder=0 style=border:0;top:0;left:0;bottom:0;right:0;width:100%;height:600px allowfullscreen></iframe> </div> <div class=footerSection> <div ng-cloak class=normal_footer> <div flex layout=row layout-padding class=\"md-whiteframe-3dp footer\" layout-align=center-center> <span class=\"\" ng-if=!isPdfData ng-click=reportcardConsoleCtrl.exportSixEigthAnnual()> <span class=\"font_wight controlsbtn user hand\">Export as pdf </span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> <span class=\"\" ng-if=isPdfData ng-click=reportcardConsoleCtrl.backToHtml()> <span class=\"font_wight controlsbtn user hand\">Back to html</span> <span class=\"round doneRnd right-space-btn hand footer-circle-button\"> <img src=" + __webpack_require__(10) + " class=\"imgClass2 auto_w_h ng-pristine ng-valid ng-touched\" role=button tabindex=0 aria-invalid=false style=\"\"> </span> </span> </div> </div> </div> ";

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-terms td,.kg-terms th{padding:5px 10px;border:1px solid #000}.kg-terms h1,h2,h3,h4,h6{text-align:center}.kg-terms.full-body{padding:0 20px}.kg-terms .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-terms .indicator-table,.kg-terms .progress-table,.kg-terms .subject-table{margin-bottom:30px;border:1px solid #000;width:100%}.kg-terms .indicator-table td{font-weight:700}.kg-terms .indicator-grade{margin-right:10px}.kg-terms .subject-head{background:silver;text-align:center}.kg-terms .skill-key{font-style:italic;width:50%}.kg-terms .skill-grade{font-weight:700;text-align:center}.kg-terms .attendance-content{font-weight:900;margin:-5px 0 20px 5px}.kg-terms .progress-head{font-weight:900;font-size:18px}.kg-terms .progress-comment{height:75px}.kg-terms .progress-signature{padding-top:50px;font-weight:700}.kg-terms .progress-hos-sign{float:right;margin-right:100px}</style> <div class=\"kg-terms full-body\"> <h1 class=indicator-head>Evaluation Key:</h1> <table class=indicator-table> <tr> <td><span class=indicator-grade>A+</span> Exceeds expectations</td> <td><span class=indicator-grade>A</span> Fully Meets expectations</td> <td><span class=indicator-grade>B</span> Progressing towards expected level</td> </tr> <tr> <td><span class=indicator-grade>C</span> Meets expectations at a beginning level</td> <td><span class=indicator-grade>D</span> Not within expectations</td> <td><span class=indicator-grade>NA</span> Not applicable at this stage</td> </tr> <tr> <td colspan=3><span class=indicator-grade>AB</span> Absent</td> </tr> </table> <table class=subject-table ng-repeat=\"result in montessoryTermsPublishedCtrl.resultValues track by $index\" ng-init=\"rowIndex = $index+1\"> <tr> <th class=subject-head>{{result.subject_name_value}} </th> <th class=subject-head>{{montessoryTermsPublishedCtrl.reportCardArray.header.term_name}} (GRADE)</th> <th class=subject-head>OVERALL PERFORMANCE / DESCRIPTIVE INDICATORS</th> </tr> <tr ng-repeat=\"buckets in result.subject_results track by $index\" ng-init=\"columnIndex = $index+1\"> <td class=skill-key>{{rowIndex}}.{{columnIndex}}. {{buckets.bucketName}}</td> <td class=skill-grade>{{buckets.grade === 'ABSENT' ? 'AB' : buckets.grade}}</td> <td class=skill-grade>{{buckets.remarks === 'ABSENT' ? 'Absent' : buckets.remarks}}</td> </tr> <tr> <td class=skill-key style=font-weight:700>OVERALL GRADE</td> <td class=skill-grade>{{result.overall_grade === 'ABSENT' ? 'AB' : result.overall_grade}}</td> <td class=skill-grade>{{result.remarks === 'ABSENT' ? 'Absent' : result.remarks}}</td> </tr> </table> <div class=attendance-content>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></div> <table class=progress-table> <thead> <th class=progress-head>Performance and Progress Remarks - {{montessoryTermsPublishedCtrl.reportCardArray.header.report_name}}{{montessoryTermsPublishedCtrl.header.report_name}}</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-comment> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks}}</span> <input style=width:100%;height:70% ng-if=$root.isTeachingStaff type=text ng-model=$root.term_remarks> </td> </tr> <tr> <td class=progress-signature> <span>Class Teacher</span> </td> </tr> </table> </div> ";

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-consolidated td,.kg-consolidated th{padding:5px 10px;border:3px solid #000}.kg-consolidated h1,h2,h3,h4,h6{text-align:center}.kg-consolidated.full-body{padding:0 20px}.kg-consolidated .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-consolidated .indicator-table,.kg-consolidated .progress-table,.kg-consolidated .subject-table{margin-bottom:30px;border:3px solid #000;width:100%}.kg-consolidated .indicator-table td{font-weight:700}.kg-consolidated .indicator-grade{margin-right:10px}.kg-consolidated .subject-head{background:silver;text-align:center}.kg-consolidated .skill-key{font-style:italic;width:50%}.kg-consolidated .skill-grade{font-weight:700;text-align:center}.kg-consolidated .progress-head{font-weight:900;font-size:18px}.kg-consolidated .progress-content{width:75%}.kg-consolidated .progress-term-comment{font-weight:700}.kg-consolidated .progress-comment{height:100px}.kg-consolidated .progress-signature{font-weight:700}.kg-consolidated .progress-hos-sign{float:right;margin-right:100px}</style> <div class=\"kg-consolidated full-body\"> <h1 class=indicator-head>Performance Indicators</h1> <table class=indicator-table> <tr> <td><span class=indicator-grade>A+</span> Exceeds expectations</td> <td><span class=indicator-grade>A</span> Fully Meets expectations</td> <td><span class=indicator-grade>B</span> Progressing towards expected level</td> </tr> <tr> <td><span class=indicator-grade>C</span> Meets expectations at a beginning level</td> <td><span class=indicator-grade>D</span> Not within expectations</td> <td><span class=indicator-grade>NA</span> Not applicable at this stage</td> </tr> <tr> <td colspan=3><span class=indicator-grade>AB</span> Absent</td> </tr> </table> <table class=subject-table ng-repeat=\"result in montessoryConsolidatedCtrl.reportResultArray track by $index\" ng-init=\"rowIndex = $index+1\"> <tr> <th class=subject-head>{{result.subject_name_value}}</th> <th class=subject-head>TERM 1 (GRADE)</th> <th class=subject-head>TERM 2 (GRADE)</th> <th class=subject-head>TERM 3 (GRADE)</th> </tr> <tr ng-repeat=\"buckets in result.bucketArray track by $index\" ng-init=\"columnIndex = $index+1\"> <td class=skill-key>{{rowIndex}}.{{columnIndex}}. {{buckets.bucketName}}</td> <td class=skill-grade>{{buckets.term_1 === 'ABSENT' ? 'AB' : buckets.term_1}}</td> <td class=skill-grade>{{buckets.term_2 === 'ABSENT' ? 'AB' : buckets.term_2}}</td> <td class=skill-grade>{{buckets.term_3 === 'ABSENT' ? 'AB' : buckets.term_3}}</td> </tr> <tr> <td class=subject-head style=font-weight:700;background:#fff!important;text-align:left!important>OVERALL GRADE</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termone === 'ABSENT' ? 'AB' : result.overall_termone}}</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termtwo === 'ABSENT' ? 'AB' : result.overall_termtwo}}</td> <td class=subject-head style=font-weight:700;background:#fff!important>{{result.overall_termthree === 'ABSENT' ? 'AB' : result.overall_termthree}}</td> </tr> </table> <table class=progress-table> <thead> <th class=progress-head>Performance and Progress</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-content> <div class=progress-term-comment>1st Term Comments</div> <div class=progress-comment>{{montessoryConsolidatedCtrl.reportCardArray.term_obj.term_1}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> <tr> <td class=progress-content> <div class=progress-term-comment>2nd Term Comments</div> <div class=progress-comment>{{montessoryConsolidatedCtrl.reportCardArray.term_obj.term_2}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> <tr> <td class=progress-content> <div class=progress-term-comment>3rd Term Comments</div> <div class=progress-comment>{{montessoryConsolidatedCtrl.reportCardArray.term_obj.term_3}}</div> <div class=progress-signature> <span>Teacher Signature</span> <span class=progress-hos-sign>Head of Section Signature</span> </div> </td> <td></td> </tr> </table> </div> ";

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test</th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in kbhfPtPublishedPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in kbhfPtPublishedPublishedCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%;margin-bottom:16px> <thead> <tr style=font-weight:700> <td colspan=1>Working Days</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.working_days> </td> <td colspan=1>Days Attended</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.days_attended> </td> </tr> </thead> <tr> <td colspan=1>House</td> <td colspan=1>Height (in Centimeters)</td> <td colspan=1>Weight (in Kg)</td> <td colspan=1>BMI</td> </tr> <tr> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.house}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.house></td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.height}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.height onkeyup=calbmi()> </td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.weight}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.weight onkeyup=calbmi()> </td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.bmi}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.bmi> </td> </tr> </table> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC AREA</th> <th colspan=4 style=text-align:right> HALF YEARLY </th> <th colspan=2>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td colspan=1><strong>*PT (10) <br/></strong> </td> <td colspan=1><strong>*NB (5) <br/></strong> </td> <td colspan=1><strong>*S.E (5) <br/></strong> </td> <td ng-if=\"hfexamOnePublishedCtrl.reportCardArray.header.report_name=='Annual'\" colspan=1> <strong>Annual <br/> Exam (80) </strong> </td> <td ng-if=\"hfexamOnePublishedCtrl.reportCardArray.header.report_name!='Annual'\" colspan=1> <strong>Half <br/> Yearly <br/> Exam (80) </strong> </td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in hfexamOnePublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td colspan=1>{{value.periodic_test}}</td> <td colspan=1>{{value.note_book_submission}}</td> <td colspan=1>{{value.subject_enrichment}}</td> <td colspan=1 ng-if=\"hfexamOnePublishedCtrl.reportCardArray.header\n.report_name!='Annual'\">{{value.half_yearly}}</td> <td colspan=1 ng-if=\"hfexamOnePublishedCtrl.reportCardArray.header\n.report_name=='Annual'\">{{value.annual_exam}}</td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> </tr> </thead> </table> <h2 style=text-align:left;font-size:16px;margin-bottom:0> Abbreviations : * PT : Periodic Test * NB : Notebook Maintainence *S.E : Subject Enrichment </h2> <br> <div ng-repeat=\"(key, subjectKeyValue) in hfexamOnePublishedCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=1><strong>Signature of Grade in Charge</strong></th> <th colspan=1>Signature of Principal</th> <th colspan=1>Signature of Parent</th> </tr> </thead> <tr> <td style=padding-left:5px height=50> </td> <td colspan=1>&nbsp; <span ng-if=hfexamOnePublishedCtrl.reportCardArray.header.signature> <img style=width:13% src={{hfexamOnePublishedCtrl.reportCardArray.header.signature}}> </span> </td> <td colspan=1>&nbsp;</td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=6>Term I</td> <td class=s10 colspan=6>Term II</td> <td class=s11 dir=ltr><span> </span></td> <td class=s11 dir=ltr><span> </span></td> </tr> <tr> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s11 dir=ltr colspan=2>Grade</td> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s12 colspan=2>Grade</td> <td class=s11 dir=ltr><span> Average </span></td> <td class=s11 dir=ltr><span> Grade </span></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedCbseTypefiveNineTenCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.half_yearly_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> <td class=s14 colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.annual_exam_2}}</td> <td class=s13 colspan=2>{{subjectResult.grade_2}}</td> <td>{{subjectResult.aggregate_avg_total}} </td> <td>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=7>TERM 1</td> <td class=s21 colspan=7>TERM 2 / FINAL</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=s23></td> <td class=s23></td> <td class=s24 rowspan=4>Grade</td> <td class=s22 colspan=4>Internal Assessments</td> <td class=s23></td> <td class=s23></td> <td class=s25 rowspan=4>Grade</td> </tr><tr> <td class=s24 colspan=2>Periodic Assessment</td> <td class=s26 rowspan=2>{{publishedCbseTypefiveNineTenCtrl.reportCardArray.header.school_id == \"Mvb8uY53ijBX9DNJS\"?\"PORT FOLIO\":\"Note Book\"}}</td> <td class=s26 rowspan=2>Subject Enrichment</td> <td class=s26 rowspan=2>Half Yearly</td> <td class=s26 rowspan=2>Aggregate </td> <td class=s24 colspan=2>Periodic Assessment</td> <td class=s26 rowspan=2>{{publishedCbseTypefiveNineTenCtrl.reportCardArray.header.school_id == \"Mvb8uY53ijBX9DNJS\"?\"PORT FOLIO\":\"Note Book\"}}</td> <td class=s26 rowspan=2>Subject Enrichment</td> <td class=s26 rowspan=2>Yearly</td> <td class=s26 rowspan=2>Aggregate </td> </tr> <tr> <td class=s26> Periodic Test </td> <td class=s26> Multiple <br> Assessment </td> <td class=s26>Periodic Test</td> <td class=s26>Multiple Assessment</td> </tr> <tr> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr><tr ng-repeat=\"(subject, subjectResult) in publishedCbseTypefiveNineTenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.note_book_submission_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.half_yearly_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td class=s14>{{subjectResult.grade_1}}</td> <td class=s14>{{subjectResult.periodic_test_2}}</td> <td class=s13>{{subjectResult.multiple_assessment_2}}</td> <td class=s13>{{subjectResult.note_book_submission_2}}</td> <td class=s13>{{subjectResult.subject_enrichment_2}}</td> <td class=s13>{{subjectResult.annual_exam_2}}</td> <td class=s12>{{subjectResult.total_mark_2}}</td> <td class=s13>{{subjectResult.grade_2}}</td> </tr><tr> <td class=s27 colspan=2>Additional Subject</td> <td class=s13 colspan=3>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14>Total</td> <td class=s14>Grade</td> <td class=s13 colspan=3>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14>Total</td> <td class=s28>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedCbseTypefiveNineTenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=3>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30>{{subjectResult.total_mark_1}}</td> <td class=s30>{{subjectResult.grade_1}}</td> <td class=s18 colspan=3>{{subjectResult.theory_2}}</td> <td class=s18 colspan=2>{{subjectResult.practical_2}}</td> <td class=s30>{{subjectResult.total_mark_2}}</td> <td class=s32>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=16>Co-Scholastic Areas [ on a five point grading scale ]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedCbseTypefiveNineTenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=7>{{subjectResult.grade_1}}</td> <td class=s34 colspan=7>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s6 colspan=2>Result</td> <td class=s38 colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=5>Supervisor</td> <td class=s40 colspan=5>Head of Section</td> <td class=s40 colspan=4>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px> </div> </td> <td class=s43 colspan=5></td> <td class=s43 colspan=5></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s44 colspan=16>Instructions:</td> </tr> <tr> <td class=s45 colspan=16>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=4>Marks Range</td> <td class=s47 colspan=10 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=4>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=4>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=4>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=4>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=4>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=4>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=4>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=4>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>a.comment-indicator:hover+comment{background:#ffd;position:absolute;display:block;border:1px solid #000;padding:.5em}a.comment-indicator{background:red;display:inline-block;border:1px solid #000;width:.5em;height:.5em}comment{display:none}.head_content{border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000}.subject_sub_cell{border-bottom:1px solid #000;border-right:1px solid #000;color:#000}.subject_sub_cell1{border-bottom:1px solid #000;border-right:1px solid #000}.class_batch{border-bottom:1px solid #000;border-right:1px solid #000}.head_content1{border-right:1px solid #000}.total_content1{border-bottom:1px solid #000;border-right:1px solid #000}.date_content{border-bottom:1px solid #000}.grade_content{border-right:1px solid #000}.fonf_face{size:3px;text-align:center}.allign_left{text-align:left}.allign_center{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:830px;float:left;display:block;text-align:center}.heading_mid{width:1000px;float:left}.logo_name{font-size:38px;text-transform:uppercase;text-align:center}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px}.full_width{width:100%}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.2rem 1rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <table cellspacing=0 border=0 style=\"border:1px solid #000\"> <colgroup span=17 width=107></colgroup> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 rowspan=2 height=42 class=allign_left> Subject </td> <td class=\"subject_sub_cell allign_center\" colspan=6> Term I (100 Marks) </td> <td class=\"subject_sub_cell allign_left\" colspan=6> Term II (100 Marks) </td> <td class=\"subject_sub_cell allign_left\" rowspan=2> Mark Obt (200) </td> <td class=class_batch rowspan=2> Average </td> <td class=total_content1 rowspan=2> Grade </td> </tr> <tr> <td class=\"subject_sub_cell allign_center\" colspan=2 bgcolor=#D8D8D8> Max Marks </td> <td class=\"subject_sub_cell allign_center\" colspan=2> Mark Obt </td> <td class=\"subject_sub_cell allign_center\" colspan=2 bgcolor=#D8D8D8> Grade </td> <td class=\"subject_sub_cell allign_center\" colspan=2 bgcolor=#D8D8D8> Max Marks </td> <td class=\"subject_sub_cell allign_center\" colspan=2> Mark Obt </td> <td class=\"subject_sub_cell allign_center\" colspan=2 bgcolor=#D8D8D8> Grade </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveKbtenCtrl.reportCardArray.specific_subjects\"> <td class=\"grade_content allign_left\" style=\"border-bottom:1px solid #000\" colspan=2 height=21> {{subject}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> 100 </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.grade_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> 100 </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.total_mark_2}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.grade_2}} </td> <td class=\"subject_sub_cell allign_center\"> {{subjectResult.aggregate}} </td> <td class=\"subject_sub_cell allign_center\"> {{subjectResult.aggregate_avg_total}} </td> <td class=\"subject_sub_cell allign_center\"> {{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 rowspan=2 height=42 class=allign_left bgcolor=#FFFFFF><b> Subjects </b></td> <td class=\"subject_sub_cell allign_center\" colspan=6 bgcolor=#FFFFFF><b> Term I </b></td> <td class=\"subject_sub_cell1 allign_center\" colspan=9 bgcolor=#FFFFFF><b> Term II </b></td> </tr> <tr> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> Max Marks </td> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> Mark Obt </td> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> Grade </td> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> Max Marks </td> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> Mark Obt </td> <td class=\"class_batch allign_center\" colspan=2 bgcolor=#FFFFFF> CE </td> <td class=\"class_batch allign_center\" colspan=2> Total </td> <td class=\"total_content1 allign_left\"> Grade </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveKbtenCtrl.reportCardArray.main_results\"> <td class=\"head_content grade_content allign_left\" colspan=2 height=21 class=allign_left><b> {{subject}} </b></td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.max_mark1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.grade_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.max_mark2}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.annual_exam_2}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.ce_exam_2}} </td> <td class=\"subject_sub_cell allign_center\" colspan=2> {{subjectResult.annual_total_mark}} </td> <td class=\"subject_sub_cell1 allign_center\"> {{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td class=head_content class=grade_content colspan=2 height=21> Result </td> <td class=\"subject_sub_cell allign_left\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </td> <td class=\"subject_sub_cell allign_center\" colspan=3> Attendance </td> </tr> <tr> <td class=head_content colspan=2 height=21 class=allign_left> Promoted to Grade </td> <td class=subject_sub_cell colspan=12 class=allign_left> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td class=\"subject_sub_cell allign_center\" rowspan=2> Term I </td> <td class=\"subject_sub_cell allign_center\" colspan=2 rowspan=2> Term II </td> </tr> <tr> <td class=\"subject_sub_cell1 allign_left\" colspan=2 height=21> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> </tr> <tr> <td class=\"grade_content head_content\" colspan=2 height=21 class=allign_left> Class Teacher </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> Supervisor </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> Head of Section </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> Principal </td> <td class=\"head_content grade_content allign_center\"> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb10_term1 style=width:65px> </td> <td class=\"head_content grade_content allign_center\" colspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb10_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb10_term2 style=width:65px> </td> </tr> <tr> <td colspan=2 class=subject_sub_cell style=\"border-bottom:1px solid #000;border-left:1px solid #000\" height=21> Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px> </td> <td class=\"subject_sub_cell allign_left\" colspan=4> </td> <td class=\"subject_sub_cell allign_left\" colspan=4> </td> <td class=\"subject_sub_cell allign_left\" colspan=4> </td> <td class=subject_sub_cell colspan=3 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=14 height=21> Instructions: </td> <td class=\"head_content grade_content allign_center\" colspan=3> School Seal </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" class=\"\" colspan=2 height=21><b> Grade </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> Marks Range </b></td> <td colspan=9 rowspan=9 class=\"subject_sub_cell allign_center\"> </td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=\"head_content1 allign_left\"> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 90-100 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 80-89 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> B+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 70-79 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> B </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 60-69 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> C+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 50-59 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" colspan=2 height=21><b> C </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 40-49 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> D+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 30-39 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" style=\"border-bottom:1px solid #000;border-left:1px solid #000;border-right:1px solid #000\" colspan=2 height=21><b> D </b></td> <td class=\"class_batch allign_center\" colspan=3><b> &lt;=30 </b></td> <td class=\"date_content allign_left\"> </td> <td class=\"date_content allign_left\"> </td> <td class=\"total_content1 allign_left\" class=allign_left> </td> </tr> </table> ";

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0 style=width:900px> <tbody> <tr> <td colspan=2 rowspan=2>Subject</td> <td colspan=6>Term I (100 Marks)</td> <td colspan=6>Term II (100 Marks)</td> <td rowspan=2>Mark Obtained(200)</td> <td rowspan=2>Average</td> <td rowspan=2>Grade</td> </tr> <tr> <td colspan=2>Max Marks</td> <td colspan=2>Mark Obt</td> <td colspan=2>Grade</td> <td colspan=2>Max Marks</td> <td colspan=2>Mark Obt</td> <td colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneFiveCtrl.reportCardArray.specific_subjects\"> <td colspan=2>{{subject}}</td> <td colspan=2>100</td> <td colspan=2>{{subjectResult.half_yearly_1}}</td> <td colspan=2>{{subjectResult.grade_1}}</td> <td colspan=2>100</td> <td colspan=2>{{subjectResult.annual_exam_2}}</td> <td colspan=2>{{subjectResult.grade_2}}</td> <td>{{subjectResult.aggregate}} </td> <td>{{subjectResult.aggregate_avg_total}}</td> <td>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td colspan=2 rowspan=4>Scholastic Area</td> <td colspan=6>TERM 1 (100 Marks)</td> <td colspan=6>TERM 2 (100 Marks)</td> <td colspan=3>Overall</td> </tr> <tr> <td rowspan=2>Periodic Test</td> <td rowspan=2>Note Book</td> <td rowspan=2>Subject Enrichment</td> <td rowspan=2>Half yearly Exam</td> <td rowspan=2>Marks Obtained</td> <td rowspan=3>Grade</td> <td rowspan=2>Periodic Test</td> <td rowspan=2>Note Book</td> <td rowspan=2>Subject Enrichment</td> <td rowspan=2>Yearly Exam</td> <td rowspan=2>Marks Obtained</td> <td rowspan=3>Grade</td> <td rowspan=3>Mark Obtained(200)</td> <td rowspan=3>Average</td> <td rowspan=3>Grade</td> </tr> <tr> </tr> <tr> <td>[10]</td> <td>[5]</td> <td>[5]</td> <td>[80]</td> <td>[100]</td> <td>[10]</td> <td>[5]</td> <td>[5]</td> <td>[80]</td> <td>[100]</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneFiveCtrl.reportCardArray.main_results\"> <td colspan=2>{{subject}}</td> <td>{{subjectResult.periodic_test_1}}</td> <td>{{subjectResult.note_book_submission_1}}</td> <td>{{subjectResult.subject_enrichment_1}}</td> <td>{{subjectResult.half_yearly_1}}</td> <td>{{subjectResult.total_mark_1}}</td> <td>{{subjectResult.grade_1}}</td> <td>{{subjectResult.periodic_test_2}}</td> <td>{{subjectResult.note_book_submission_2}}</td> <td>{{subjectResult.subject_enrichment_2}}</td> <td>{{subjectResult.annual_exam_2}}</td> <td>{{subjectResult.total_mark_2}}</td> <td>{{subjectResult.grade_2}}</td> <td>{{subjectResult.aggregate}} </td> <td>{{subjectResult.aggregate_avg_total}}</td> <td>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr style=height:20px> <td class=s45 colspan=6>Co-Scholastic Term I </td> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=7>Co-Scholastic Term II</td> <td class=s47 colspan=2>Grade </td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneFiveCtrl.reportCardArray.other_sections\"> <td colspan=6>{{subject}}</td> <td colspan=2>{{subjectResult.grade_1}}</td> <td class=s48 colspan=7>{{subject}}</td> <td class=s49 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneFiveCtrl.reportCardArray.discipline\"> <td class=s40 colspan=2>Discipline</td> <td class=s52 colspan=4></td> <td class=s52 colspan=2>{{subjectResult.grade_1}}</td> <td class=s52 colspan=7>Discipline</td> <td class=s28 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:35px> <td colspan=2>Result</td> <td class=s53 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </td> <td colspan=3>Attendance</td> </tr> <tr style=height:24px> <td class=\"s3 softmerge\" colspan=2> <div class=softmerge-inner style=width:197px;left:-1px>Promoted to Grade </div> </td> <td class=s54 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td rowspan=1>Term I</td> <td colspan=2 rowspan=1>Term II</td> </tr> <tr style=height:24px> <td colspan=2></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=s55 colspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr style=height:24px> <td colspan=2>Class Teacher </td> <td class=s55 colspan=4>Supervisor</td> <td class=s55 colspan=4>Head of Section</td> <td class=s55 colspan=4>Principal</td> <td></td> <td class=s56 colspan=2></td> </tr> <tr style=height:24px> <td class=\"s57 softmerge\" colspan=2> <div class=softmerge-inner style=width:207px;left:-11px>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px> </div> </td> <td class=s59 colspan=4></td> <td class=s59 colspan=4></td> <td class=s59 colspan=4></td> <td class=s56 colspan=3></td> </tr> <tr style=height:24px> <td class=s60 colspan=14>Instructions:</td> <td class=s61 colspan=3>School Seal</td> </tr> <tr style=height:24px> <td class=s62 colspan=14>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> <td class=s1 colspan=3 rowspan=10></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>Grade</td> <td class=s63 colspan=3>Marks Range</td> <td class=s64 colspan=9 rowspan=9></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A1</td> <td class=s63 colspan=3>91-100</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A2</td> <td class=s63 colspan=3>81-90</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B1</td> <td class=s63 colspan=3>71-80</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B2</td> <td class=s63 colspan=3>61-70</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C1</td> <td class=s63 colspan=3>51-60</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C2</td> <td class=s63 colspan=3>41-50</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>D</td> <td class=s63 colspan=3>33-40</td> </tr> <tr style=height:19px> <td class=s66 colspan=2>E (Failed)</td> <td class=s66 colspan=3>&lt;=32</td> </tr> </tbody> </table> </div>";

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}table.sheet0 tr{height:15.75pt}.subjects_tr{text-align:center!important}</style> <table style=\"border-top:solid 1px\" border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1> <td class=\"column0 style5 s style9\" colspan=2 rowspan=2>Subject</td> <td class=\"column2 style7 s style9\" colspan=6>Term I (100 Marks)</td> <td class=\"column8 style10 s style9\" colspan=6>Term II (100 Marks)</td> <td class=\"column8 style10 s style9\" colspan=6>Term III (100 Marks)</td> <td class=\"column14 style11 s style9\" colspan=2 rowspan=2>Total</td> <td class=\"column16 style12 s style9\" colspan=2 rowspan=2>Average</td> <td class=\"column18 style13 s style9\" rowspan=2>Grade</td> </tr> <tr class=row2> <td class=\"column2 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column6 style15 s style9\" colspan=2>Grade</td> <td class=\"column8 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=2>Grade</td> <td class=\"column8 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=2>Grade</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeFiveKbEightNineCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style17 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>100</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>100</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_2}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>100</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_3}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_3}}</td> <td class=\"column14 style7 s style9 subjects_tr\" colspan=2>&nbsp;{{subjectResult.aggregate}}</td> <td class=\"column16 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.aggregate_avg_total}}</td> <td class=\"column18 style19 null subjects_tr\">{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=2 rowspan=2>Subjects</td> <td class=\"column2 style21 s style9\" colspan=6>Term I</td> <td class=\"column8 style21 s style9\" colspan=6>Term II</td> <td class=\"column14 style22 s style9\" colspan=2>Term III</td> <td class=\"column8 style21 s style9\" colspan=9>Final</td> </tr> <tr class=row5> <td class=\"column2 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style23 s style9\" colspan=2>Mark Obt</td> <td class=\"column6 style23 s style9\" colspan=2>Grade</td> <td class=\"column8 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style23 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style23 s style9\" colspan=2>Grade</td> <td class=\"column14 style24 s\">Max Marks</td> <td class=\"column15 style24 s\">Mark Obt</td> <td class=\"column16 style25 s\">TE Aggregate</td> <td class=\"column16 style25 s\" colspan=2>CE</td> <td class=\"column17 style26 s\" colspan=4>Total</td> <td class=\"column18 style27 s\" colspan=2>Grade</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedTypeFiveKbEightNineCtrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_2}}</td> <td class=\"column14 style19 null subjects_tr\">{{subjectResult.max_mark3}}</td> <td class=\"column15 style19 null subjects_tr\">{{subjectResult.term3_3}}</td> <td class=\"column15 style19 null subjects_tr\">{{subjectResult.term3_3}}</td> <td class=\"column16 style19 null subjects_tr\" colspan=2>{{subjectResult.ce_exam_3}}</td> <td class=\"column17 style19 null subjects_tr\" colspan=4>{{subjectResult.ce_plus_avg}}</td> <td class=\"column18 style19 null subjects_tr\" colspan=2>{{subjectResult.ce_plus_avg_gr}}</td> </tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=2>Result</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style7 s style9\" colspan=11>Attendance</td> </tr> <tr class=row8> <td class=\"column0 style29 s\">Promoted to Grade </td> <td class=\"column1 style27 null\"> </td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style30 s style9\" colspan=3 rowspan=2>Term I</td> <td class=\"column16 style30 s style9\" colspan=5 rowspan=2>Term II</td> <td class=\"column18 style31 s style9\" colspan=3 rowspan=2>Term III</td> </tr> <tr class=row9> <td class=\"column0 style18 null style3\" colspan=2></td> <td class=\"column2 style18 null style3\" colspan=4></td> <td class=\"column6 style18 null style3\" colspan=4></td> <td class=\"column10 style18 null style3\" colspan=4></td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=2>Class Teacher </td> <td class=\"column2 style33 s style9\" colspan=4>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=4>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4>Principal</td> <td class=\"column14 style18 null style3\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column16 style18 null style3\" colspan=5> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column18 style19 null\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term3}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term3 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:10px></td>  </tr> <tr class=row11> <td class=\"column0 style34 s\" colspan=2>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column14 style7 s style9\" colspan=11>School Seal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=14>Instructions:</td> <td class=\"column14 style19 null\" colspan=11 rowspan=10></td> </tr> <tr class=row13> <td class=\"column0 style36 s style9\" colspan=2>Grade</td> <td class=\"column2 style37 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style38 null style9\" colspan=9 rowspan=9></td> </tr> <tr class=row14> <td class=\"column0 style36 s style9\" colspan=2>A+</td> <td class=\"column2 style37 s style9\" colspan=3>90-100</td> </tr> <tr class=row15> <td class=\"column0 style36 s style9\" colspan=2>A</td> <td class=\"column2 style37 s style9\" colspan=3>80-89</td> </tr> <tr class=row16> <td class=\"column0 style36 s style9\" colspan=2>B+</td> <td class=\"column2 style37 s style9\" colspan=3>70-79</td> </tr> <tr class=row17> <td class=\"column0 style36 s style9\" colspan=2>B</td> <td class=\"column2 style37 s style9\" colspan=3>60-69</td> </tr> <tr class=row18> <td class=\"column0 style36 s style9\" colspan=2>C+</td> <td class=\"column2 style37 s style9\" colspan=3>50-59</td> </tr> <tr class=row19> <td class=\"column0 style36 s style9\" colspan=2>C</td> <td class=\"column2 style37 s style9\" colspan=3>40-49</td> </tr> <tr class=row20> <td class=\"column0 style36 s style9\" colspan=2>D+</td> <td class=\"column2 style37 s style9\" colspan=3>30-39</td> </tr> <tr class=row21> <td class=\"column0 style36 s style9\" colspan=2>D </td> <td class=\"column2 style37 s style9\" colspan=3>&lt;=30</td> </tr> </tbody> </colgroup></table>";

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=5>Model Exam 1</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Theory </strong> </td> <td><strong>Practical </strong> </td> <td><strong>Total Mks Obt. (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in publishedTypeSixModalExamTermOneCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.theory}}<span class=max_mark_span>out of {{value.max_mark_theory}}</span></td> <td>{{value.practical}}<span class=max_mark_span>out of {{value.max_mark_practical}}</span></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in publishedTypeSixModalExamTermOneCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=150 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>Model Exam I</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in typesixModelExamTermOneninetenPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in typesixModelExamTermOneninetenPublishedCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=150 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=3>Model Exam II</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in typesixModelExamTermTwoninetenPublishedCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=150 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Model Exam-II</th> <th style=font-size:12px colspan=1></th> <th colspan=3>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Theory </strong> </td>  <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.theory}}<span class=max_mark_span>out of {{value.max_mark_theory}}</span></td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in publishedTypeSixModalExamTermTwonospaceCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Annual Exam</th> <th style=font-size:12px colspan=1></th> <th colspan=3>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Theory </strong> </td> <td><strong>Practical </strong> </td> <td><strong>Total Mks Obt. (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in publishedTypeSixModelannualexamCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.theory}}<span class=max_mark_span>out of {{value.max_mark_theory}}</span></td> <td>{{value.practical}}<span class=max_mark_span>out of {{value.max_mark_practical}}</span></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in publishedTypeSixModelannualexamCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <br> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> </td> </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendace %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

module.exports = " <style>.width_20{width:40px}</style> <table style=width:98%;float:right cellpadding=1 cellspacing=1> <th width=113> </th><th width=118> </th><th width=118> </th><th width=118> </th><th width=118> </th><th width=108> <tr valign=TOP> <td width=113 height=21 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.12in;margin-top:.02in;font-weight:400> <b>Working Days</b> </p> </td> <td width=118 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <b>Days Attended</b> </p> </td> <td width=118 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> <b>House</b> </p> </td> <td width=118 style=\"border-top:2.25pt solid #000001;border-bottom:1px solid #00000a;border-left:1pt solid #000001;border-right:1px solid #00000a;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <b>Height (in cm)</b> </p> </td> <td width=118 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1px solid #00000a;border-right:1px solid #00000a;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-top:.02in;font-weight:400> <b>Weight (in kg)</b> </p> </td> <td width=108 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1px solid #00000a;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-top:.02in;font-weight:400> <b>BMI</b> </p> </td> </tr> <tr valign=TOP> <td width=113 height=18 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:15px!important;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <span class=width_20 ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input class=width_20 ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.working_days> <br> </p> </td> <td width=118 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <span class=width_20 ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input class=width_20 ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.days_attended> <br> </p> </td> <td width=118 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <span ng-if=!$root.isTeachingStaff>{{$root.house}}</span> <input ng-if=$root.isTeachingStaff maxlength=20 type=text ng-model=$root.house> <br> </p> </td> <td width=118 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1pt solid #000001;border-right:1px solid #00000a;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.16in;margin-top:.02in;font-weight:400> <span class=width_20 ng-if=!$root.isTeachingStaff>{{$root.height}}</span> <input class=width_20 ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.height> <br> </p> </td> <td width=118 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1px solid #00000a;border-right:1px solid #00000a;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-top:.02in;font-weight:400> <span class=width_20 ng-if=!$root.isTeachingStaff>{{$root.weight}}</span> <input class=width_20 ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.weight> <br> </p> </td> <td width=108 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1px solid #00000a;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-top:.02in;font-weight:400> <span class=width_20 ng-if=!$root.isTeachingStaff>{{$root.bmi}}</span> <input class=width_20 ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.bmi> <br> </p> </td> </tr> </th></table> <p class=western><br> </p> <table style=width:98%;float:right;margin-top:46px cellpadding=1 cellspacing=0> <th width=181> </th><th width=87> </th><th width=81> </th><th width=83> </th><th width=95> </th><th width=98> </th><th width=65> <tr valign=TOP> <td width=181 height=19 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.03in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>SCHOLASTIC AREA</b></font> </font> </p> </td> <td colspan=4 width=353 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p align=CENTER style=margin-right:.01in;margin-top:.03in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>ANNUAL EXAM</b></font> </font> </p> </td> <td colspan=2 width=165 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=font-weight:400><br> </p> </td> </tr> <tr valign=TOP> <td width=181 height=41 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.12in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Subject</b></font> </font> </p> </td> <td width=87 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>*PT (10)</b></font> </font> </p> </td> <td width=81 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>*NB (5)</b></font> </font> </p> </td> <td width=83 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>*S.E (5)</b></font> </font> </p> </td> <td width=95 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-right:.23in;margin-top:.01in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Annual </b></font> <font size=1 style=font-size:8pt><b> </b></font> <font size=1 style=font-size:8pt><b>Exam</b></font> <font size=1 style=font-size:8pt><b> </b></font> <font size=1 style=font-size:8pt><b>(80)</b></font> </font> </p> </td> <td width=98 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-right:.07in;margin-top:.01in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Total Marks </b></font> <font size=1 style=font-size:8pt><b>Obt. </b></font> </font> </p> <p style=margin-left:.13in;margin-right:.07in;margin-top:.01in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>(100)</b></font> </font> </p> </td> <td width=65 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Grade</b></font> </font> </p> </td> </tr> <tr valign=TOP style=font-size:12px ng-repeat=\"(subject, subjectResult) in publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray.main_results\"> <td width=181 height=24 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.12in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>{{subject}}</b></font> </font> </p> </td> <td width=87 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.periodic_test}} <br> </p> </td> <td width=81 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.note_book_submission}} <br> </p> </td> <td width=83 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.subject_enrichment}} <br> </p> </td> <td width=95 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.annual_exam}} <br> </p> </td> <td width=98 style=\"border:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.total_mark}} <br> </p> </td> <td width=65 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectResult.grade}} <br> </p> </td> </tr> </th></table> <p class=western style=margin-left:22px;line-height:26px>Abbreviations: * PT: Periodic Test * NB: Notebook Maintenance *S.E: Subject Enrichment</p> <p class=western style=margin-top:0;margin-bottom:0><br><br> </p> <div ng-repeat=\"(key, subjectKeyValue) in publishedTypeSevenCalicutAnnualexamCtrl.reportCardArray.other_sections\"> <table style=width:98%;float:right cellpadding=1 cellspacing=0> <th width=565> </th><th width=136> <tr valign=TOP> <td width=565 height=24 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.03in;font-weight:400><a name=_GoBack></a> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt;text-transform:uppercase><b>Co-Scholastic Area</b></font> </font> </p> </td> <td width=136 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.03in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Grade</b></font> </font> </p> </td> </tr> <tr valign=TOP ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td width=565 height=24 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.12in;margin-top:.02in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt>{{subjectName}}</font> </font> </p> </td> <td width=136 style=\"border-top:1pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.13in;margin-top:.02in;font-weight:400> {{subjectValue.grade}} <br> </p> </td> </tr> </th></table> </div> <table style=width:98%;margin-bottom:111px;float:right;margin-top:40px cellpadding=1 cellspacing=0> <th width=284> </th><th width=219> </th><th width=196> <tr valign=TOP> <td width=284 height=18 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.1in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Signature of Grade in Charge</b></font> </font> </p> </td> <td width=219 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.1in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Signature of Principal</b></font> </font> </p> </td> <td width=196 style=\"border-top:2.25pt solid #000001;border-bottom:1pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=margin-left:.04in;margin-top:.1in;font-weight:400> <font size=2 style=font-size:11pt> <font size=1 style=font-size:8pt><b>Signature of Parent</b></font> </font> </p> </td> </tr> <tr valign=TOP> <td width=284 height=36 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:2.25pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=font-weight:400><br> </p> </td> <td width=219 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1pt solid #000001;border-right:1pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=font-weight:400><br> </p> </td> <td width=196 style=\"border-top:1pt solid #000001;border-bottom:2.25pt solid #000001;border-left:1pt solid #000001;border-right:2.25pt solid #000001;padding-top:0;padding-bottom:0;padding-left:.02in;padding-right:0\"> <p style=font-weight:400><br> </p> </td> </tr> </th></table> <p class=western style=font-weight:400><br> </p>";

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

module.exports = "<style>.kg-terms td,.kg-terms th{padding:5px 10px;border:1px solid #000}.kg-terms h1,h2,h3,h4,h6{text-align:center}.kg-terms.full-body{padding:0 20px}.kg-terms .indicator-head{text-align:left;margin-bottom:5px;font-weight:700;font-size:17px}.kg-terms .indicator-table,.kg-terms .progress-table,.kg-terms .subject-table{margin-bottom:30px;border:1px solid #000;width:100%}.kg-terms .indicator-table td{font-weight:700}.kg-terms .indicator-grade{margin-right:10px}.kg-terms .subject-head{background:silver;text-align:center}.kg-terms .skill-key{font-style:italic;width:50%}.kg-terms .skill-grade{font-weight:700;text-align:center}.kg-terms .attendance-content{font-weight:900;margin:-5px 0 20px 5px}.kg-terms .progress-head{font-weight:900;font-size:18px}.kg-terms .progress-comment{height:75px}.kg-terms .progress-signature{padding-top:50px;font-weight:700}.kg-terms .progress-hos-sign{float:right;margin-right:100px}</style> <div class=\"kg-terms full-body\"> <h1 class=indicator-head>Performance Indicators</h1> <table class=indicator-table> <tr> <td><span class=indicator-grade>A</span> Exceeding</td> <td><span class=indicator-grade>B</span> Expected</td> <td><span class=indicator-grade>C</span> Emerging</td> </tr> <tr> <td colspan=3><span class=indicator-grade>AB</span> ABSENT</td> </tr> </table> <table class=subject-table ng-repeat=\"(sub, keyval) in kgthematictermsCtrl.evaluations \" ng-init=\"parentIndex = $index\"> <tr> <th class=subject-head>{{sub}}</th> <th class=subject-head>{{kgthematictermsCtrl.reportCardArray.header.term_name}} (GRADE)</th> <th class=subject-head>OVERALL PERFORMANCE / DESCRIPTIVE INDICATORS</th> </tr> <tr ng-repeat=\"db_key in keyval.db_keys track by $index\"> <td class=skill-key><b>{{parentIndex+1}}.&nbsp;{{$index + 1}}.&nbsp;</b>{{keyval[db_key].bucket.name}}</td> <td class=skill-grade>{{keyval[db_key].grade}}</td> <td class=skill-grade>{{keyval[db_key].remarks}}</td> </tr> <tr> <td class=skill-key>Total</td> <td class=skill-grade>{{keyval.overall_grade}}</td> <td class=skill-grade>{{keyval.remarks}}</td> </tr> </table> <div class=attendance-content>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></div> <table class=progress-table> <thead> <th class=progress-head>Performance and Progress Remarks - {{kgTermsCtrl.reportCardArray.header.report_name}}{{kgTermsCtrl.header.report_name}}</th> <th class=progress-head>Parent Signature</th> </thead> <tr> <td class=progress-comment> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks}}</span> <input style=width:100%;height:70% ng-if=$root.isTeachingStaff type=text ng-model=$root.term_remarks> </td></tr></table></div>  <td rowspan=2></td>  <tr> <td class=progress-signature> <span>Class Teacher</span> <span class=progress-hos-sign>Head of Section</span> </td> </tr> ";

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>#table_class div,p,table,tbody,td,tfoot,th,thead,tr{font-family:Arial;font-size:x-small}table td{border:1px solid}table{width:100%}.m02{margin-left:3px!important}.mo3{text-align:center}</style> <body> <table cellspacing=0 border=0 id=table_class> <tbody> <tr style=text-align:center> <td colspan=2 rowspan=2 height=61>Subject</td> <td colspan=6>Term I </td> <td colspan=6>Term II </td> <td rowspan=2>Mark Obtained(100)</td> <td rowspan=2>Grade</td> </tr> <tr> <td colspan=2 bgcolor=#D8D8D8>Max Marks</td> <td colspan=2 bgcolor=#D8D8D8>Mark Obt</td> <td colspan=2 bgcolor=#D8D8D8>Grade</td> <td colspan=2 bgcolor=#D8D8D8>Max Marks</td> <td colspan=2 bgcolor=#D8D8D8>Mark Obt</td> <td colspan=2 bgcolor=#D8D8D8>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineCbseConsolidatedCtrl.reportCardArray.specific_subjects\"> <td colspan=2 height=28><span class=m02>{{subject}}</span></td> <td colspan=2 scale style=text-align:center><br>{{subjectResult.max_mark_data.term1_hf}}</td> <td colspan=2 style=text-align:center><br>{{subjectResult.term1_hf}}</td> <td colspan=2 sdnum=1033;0;0 style=text-align:center><b><br>{{subjectResult.grade_1}}</b></td> <td colspan=2 style=text-align:center><br>{{subjectResult.max_mark_data.annual_exam}}</td> <td colspan=2 style=text-align:center><br>{{subjectResult.annual_exam}}</td> <td colspan=2 sdnum=1033;0;0 style=text-align:center><b><br></b>{{subjectResult.grade_2}}</td> <td style=text-align:center> {{subjectResult.total_score}}</td> <td style=text-align:center><br>{{subjectResult.over_all_grade}}</td> </tr> <tr style=text-align:center> <td colspan=2 rowspan=3 height=120><b>Scholastic Area</b></td> <td colspan=6><b>TERM 1 </b></td> <td colspan=6><b>TERM 2 </b></td> <td colspan=2><b>Overall</b></td> </tr> <tr> <td colspan=2>Periodic Test I</td> <td colspan=2>Periodic Test II</td> <td colspan=2>Half Yearly</td> <td colspan=2>Annual Exam</td> <td colspan=2>Project / Practical</td> <td colspan=2>Final Theory Marks </td> <td rowspan=2 style=text-align:center>Total</td> <td rowspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineCbseConsolidatedCtrl.reportCardArray.main_results\" style=text-align:center> <td colspan=2 height=60><b><span class=m02>{{subject}}</span></b></td> <td><br>{{subjectResult.max_mark_data.periodic_test_1}}</td> <td><br>{{subjectResult.periodic_test_1}}</td> <td><br>{{subjectResult.max_mark_data.periodic_test_2}}</td> <td><br>{{subjectResult.periodic_test_2}}</td> <td sdnum=1033;0;0><br><b>{{subjectResult.max_mark_data.term1_hf}} </b></td> <td><b><br>{{subjectResult.term1_hf}}</b></td> <td><br>{{subjectResult.max_mark_data.annual_exam}}</td> <td><br>{{subjectResult.annual_exam}}</td> <td><br>{{subjectResult.max_mark_data.project_practical}}</td> <td><br>{{subjectResult.project_practical}}</td> <td sdnum=1033;0;0><b><br>{{subjectResult.max_mark_data.final_theory}}</b></td> <td><b><br>{{subjectResult.final_theory}}</b></td> <td><br>{{subjectResult.total_score}}</td> <td><br>{{subjectResult.over_all_grade}}</td> </tr> <tr style=text-align:center> <td colspan=6 height=21><b>Co-Scholastic Term I </b></td> <td colspan=2><b>Grade</b></td> <td colspan=7><b>Co-Scholastic Term II</b></td> <td><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineCbseConsolidatedCtrl.reportCardArray.other_sections\"> <td colspan=6 height=42><b><span class=m02>{{subject}}</span></b></td> <td colspan=2 style=text-align:center><br>{{subjectResult.grade_1}}</td> <td colspan=7><b><span class=m02>{{subject}}</span></b></td> <td style=text-align:center><br>{{subjectResult.grade_2}}</td> </tr> <tr> <td colspan=6 height=21><b><br></b></td> <td colspan=2><br></td> <td colspan=7><br></td> <td><br></td> </tr> <tr style=text-align:center> <td colspan=6 height=21><b> Term I </b></td> <td colspan=2><b>Grade</b></td> <td colspan=7><b> Term II</b></td> <td><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineCbseConsolidatedCtrl.reportCardArray.discipline\"> <td colspan=6 height=21><b><span class=m02>{{subject}}</span></b></td> <td colspan=2 style=text-align:center><br>{{subjectResult.grade_1}}</td> <td colspan=7><b><span class=\"\">{{subject}}</span></b></td> <td style=text-align:center><br>{{subjectResult.grade_2}}</td> </tr> <tr> <td colspan=2 height=36>Result</td> <td colspan=12><br></td> <td colspan=2>Attendance <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance>  </td> </tr> <tr> <td colspan=2 height=25>Promoted to Grade</td> <td colspan=4> <span ng-if=!$root.StdPromotGrade>{{$root.StdPromotGrade}}</span> <input maxlength=100 type=text ng-model=$root.StdPromotGrade style=width:100%> </td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 rowspan=4><br></td> </tr> <tr> <td colspan=2 height=25></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> </tr> <tr> <td colspan=2 height=25>Class Teacher </td> <td colspan=4 bgcolor=#D8D8D8 style=text-align:center>Supervisor</td> <td colspan=4 bgcolor=#D8D8D8 style=text-align:center>Head of Section</td> <td colspan=4 bgcolor=#D8D8D8 style=text-align:center>Principal</td> </tr> <tr> <td height=25 colspan=2>Date:</td> <td colspan=12><br></td> </tr> <tr> <td colspan=14 height=25>Instructions:</td> <td colspan=2>School Seal</td> </tr> <tr> <td colspan=14 height=25>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> <td colspan=2 rowspan=10><br></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>Grade</b></td> <td colspan=3><b>Marks Range</b></td> <td colspan=9 rowspan=9><br></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>A1</b></td> <td colspan=3><b>91-100</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>A2</b></td> <td colspan=3><b>81-90</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>B1</b></td> <td colspan=3><b>71-80</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>B2</b></td> <td colspan=3><b>61-70</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>C1</b></td> <td colspan=3><b>51-60</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>C2</b></td> <td colspan=3><b>41-50</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>D</b></td> <td colspan=3><b>33-40</b></td> </tr> <tr class=mo3> <td colspan=2 height=20><b>E (Failed)</b></td> <td colspan=3><b>&lt;=32</b></td> </tr> </tbody> </table> </body>";

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test Annual</th> <th style=font-size:12px colspan=1></th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Max mark </strong> </td> <td><strong>Marks Obtained </strong> </td> </tr> <tr ng-repeat=\"(subjectResult, value) in typeNineCbseptCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.max_mark_data.periodic_test.max_mark}}</td> <td colspan=1>{{value.periodic_test}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in typeNineCbseptCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <input style=width:85% max=200 type=text ng-model=$root.term_remarks></td>  </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1177 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>#table_class div,table,td{border:1px solid gray}.m03{text-align:center}</style> <table cellspacing=0 border=0 id=table_class> <tbody> <tr style=text-align:center> <td colspan=2 rowspan=2 height=70>Subject</td> <td colspan=6>Term I </td> <td colspan=8>Term II </td> <td colspan=2 rowspan=2>Grade</td> </tr> <tr class=m03> <td colspan=2 bgcolor=#D8D8D8>Max Marks</td> <td colspan=2 bgcolor=#D8D8D8>Mark Obt</td> <td colspan=2 bgcolor=#D8D8D8>Grade</td> <td colspan=2 bgcolor=#D8D8D8>Max Marks</td> <td colspan=2 bgcolor=#D8D8D8>Mark Obt</td> <td colspan=2 bgcolor=#D8D8D8>Grade</td> <td colspan=2 bgcolor=#D8D8D8>Mark Obtained(100)</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineTwelveCbseConsolidatedCtrl.reportCardArray.specific_subjects\" style=text-align:center> <td colspan=2 height=28>{{subject}}</td> <td colspan=2><br>{{subjectResult.max_mark_data.term1_hf}}</td> <td colspan=2><br>{{subjectResult.term1_hf}}</td> <td colspan=2><b><br></b>{{subjectResult.grade_1}}</td> <td colspan=2><br>{{subjectResult.max_mark_data.annual_exam}}</td> <td colspan=2><br>{{subjectResult.annual_exam}}</td> <td colspan=2><b><br>{{subjectResult.grade_2}}</b></td> <td colspan=2><b><br>{{subjectResult.total_score}}</b></td> <td colspan=2>{{subjectResult.over_all_grade}} </td> </tr> <tr style=text-align:center> <td colspan=2 rowspan=3 height=120><b>Scholastic Area</b></td> <td colspan=6><b>TERM 1 </b></td> <td colspan=8><b>TERM 2 </b></td> <td colspan=2 rowspan=2>Board Marks</td> </tr> <tr> <td colspan=2>Periodic Test I</td> <td colspan=2>Periodic Test II</td> <td colspan=2>Half Yearly</td> <td colspan=2>Pre Model</td> <td colspan=2>Model Exam</td> <td colspan=2>Project / Practical</td> <td rowspan=2>Total</td> <td rowspan=2>Grade</td> </tr> <tr> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineTwelveCbseConsolidatedCtrl.reportCardArray.main_results\"> <td colspan=2 height=60><b>{{subject}}</b></td> <td><br>{{subjectResult.max_mark_data.periodic_test_1}}</td> <td><br>{{subjectResult.periodic_test_1}}</td> <td><br>{{subjectResult.max_mark_data.periodic_test_2}}</td> <td><br>{{subjectResult.periodic_test_2}}</td> <td><b><br> </b>{{subjectResult.max_mark_data.term1_hf}}</td> <td><b><br></b>{{subjectResult.term1_hf}}</td> <td><br>{{subjectResult.max_mark_data.pre_model}}</td> <td><br>{{subjectResult.pre_model}}</td> <td><br>{{subjectResult.max_mark_data.project_practical}}</td> <td><br>{{subjectResult.project_practical}}</td> <td><br>{{subjectResult.max_mark_data.model_exam}}</td> <td><br>{{subjectResult.model_exam}}</td> <td><b><br></b>{{subjectResult.total_score}}</td> <td><b><br></b>{{subjectResult.over_all_grade}}</td> <td><br></td> <td><br></td> </tr> <tr style=text-align:center> <td colspan=6 height=21><b>Co-Scholastic Term I </b></td> <td colspan=2><b>Grade</b></td> <td colspan=9><b>Co-Scholastic Term II</b></td> <td><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineTwelveCbseConsolidatedCtrl.reportCardArray.other_sections\"> <td colspan=6 height=42><b>{{subject}}</b></td> <td colspan=2 style=text-align:center><br>{{subjectResult.grade_1}}</td> <td colspan=9><b>{{subject}}</b></td> <td style=text-align:center><br>{{subjectResult.grade_2}}</td> </tr> <tr> <td colspan=6 height=21><b><br></b></td> <td colspan=2><br></td> <td colspan=9><br></td> <td><br></td> </tr> <tr style=text-align:center> <td colspan=6 height=21><b> Term I </b></td> <td colspan=2><b>Grade</b></td> <td colspan=9><b> Term II</b></td> <td><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNineTwelveCbseConsolidatedCtrl.reportCardArray.discipline\"> <td colspan=6 height=21><b>{{subject}}</b></td> <td colspan=2 style=text-align:center><br>{{subjectResult.grade_1}}</td> <td colspan=9><b>{{subject}}</b></td> <td style=text-align:center><br>{{subjectResult.grade_2}}</td> </tr> <tr> <td colspan=2 height=36>Result</td> <td colspan=14><br></td> <td colspan=2 style=text-align:center>Attendance <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance>  </td> </tr> <tr> <td colspan=2 height=25>Promoted to Grade </td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=6 bgcolor=#D8D8D8><br></td> <td colspan=2 rowspan=4><br></td> </tr> <tr> <td colspan=2 height=35><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=4 bgcolor=#D8D8D8><br></td> <td colspan=6 bgcolor=#D8D8D8><br></td> </tr> <tr> <td colspan=2 height=25>Class Teacher </td> <td colspan=4 bgcolor=#D8D8D8 style=text-align:center>Supervisor</td> <td colspan=4 bgcolor=#D8D8D8 style=text-align:center>Head of Section</td> <td colspan=6 bgcolor=#D8D8D8 style=text-align:center>Principal</td> </tr> <tr> <td colspan=16 height=25>Date:</td> </tr> <tr> <td colspan=16 height=25>Instructions:</td> <td colspan=2>School Seal</td> </tr> <tr> <td colspan=16 height=25>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> <td colspan=2 rowspan=10><br></td> </tr> <tr class=m03> <td colspan=2 height=20><b>Grade</b></td> <td colspan=3><b>Marks Range</b></td> <td colspan=11 rowspan=9><br></td> </tr> <tr class=m03> <td colspan=2 height=20><b>A1</b></td> <td colspan=3><b>91-100</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>A2</b></td> <td colspan=3><b>81-90</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>B1</b></td> <td colspan=3><b>71-80</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>B2</b></td> <td colspan=3><b>61-70</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>C1</b></td> <td colspan=3><b>51-60</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>C2</b></td> <td colspan=3><b>41-50</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>D</b></td> <td colspan=3><b>33-40</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>E (Failed)</b></td> <td colspan=3><b>&lt;=32</b></td> </tr></tbody> </table> ";

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Unit Test</th> <th style=font-size:12px colspan=1></th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Max mark </strong> </td> <td><strong>Marks Obtained </strong> </td> </tr> <tr ng-repeat=\"(subjectResult, value) in typeNinekbUnitTestCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.max_mark_data.unit_test.max_mark}}</td> <td colspan=1>{{value.unit_test}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in typeNinekbUnitTestCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <input style=width:85% max=200 type=text ng-model=$root.term_remarks></td>  </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports = " <style type=text/css>table{width:100%;border-collapse:collapse}.m02{margin-left:3px!important}.m03{text-align:center}</style> <table cellspacing=1 border=2> <colgroup width=30></colgroup> <colgroup width=126></colgroup> <colgroup width=42></colgroup> <colgroup width=38></colgroup> <colgroup width=42></colgroup> <colgroup width=39></colgroup> <colgroup width=36></colgroup> <colgroup width=46></colgroup> <colgroup width=38></colgroup> <colgroup width=42></colgroup> <colgroup width=39></colgroup> <colgroup width=46></colgroup> <colgroup width=42></colgroup> <colgroup width=43></colgroup> <colgroup width=60></colgroup> <colgroup width=62></colgroup> <tbody> <tr style=text-align:center> <td colspan=2 rowspan=2 height=61>Subject</td> <td colspan=6>Term I </td> <td colspan=6>Term II </td> <td rowspan=2>Mark Obtained(100)</td> <td rowspan=2>Grade</td> </tr> <tr style=text-align:center;background-color:#e4e3e3> <td colspan=2>Max Marks</td> <td colspan=2>Mark Obt</td> <td colspan=2>Grade</td> <td colspan=2>Max Marks</td> <td colspan=2>Mark Obt</td> <td colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNinekbConsolidatedCtrl.reportCardArray.specific_subjects\"> <td colspan=2 height=28 class=m02>{{subject}}</td> <td colspan=2 class=m03><br>{{subjectResult.max_mark_data.term1_hf}}</td> <td colspan=2 class=m03><br>{{subjectResult.term1_hf}}</td> <td colspan=2 class=m03><br>{{subjectResult.grade_1}}</td> <td colspan=2 class=m03><br>{{subjectResult.max_mark_data.term2}}</td> <td colspan=2 class=m03><br>{{subjectResult.term2}}</td> <td colspan=2 class=m03><br>{{subjectResult.grade_2}}</td> <td class=m03> {{subjectResult.total_score}}</td> <td class=m03><br>{{subjectResult.over_all_grade}}</td> </tr> <tr style=text-align:center> <td colspan=2 rowspan=2 height=97><b>Subjects</b></td> <td colspan=2><b>Unit Test I / (Cycle)</b></td> <td colspan=2><b>Term 1 ( Half Yearly)</b></td> <td colspan=2><b>Unit Test II (Monthly)</b></td> <td colspan=2><b>Term II (Model)</b></td> <td colspan=2><b>Term III (Board)</b></td> <td colspan=2><b>CE</b></td> <td rowspan=2 style=\"border-right:1px solid\">Total</td> <td rowspan=2>Grade</td> </tr> <tr> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNinekbConsolidatedCtrl.reportCardArray.main_results\"> <td colspan=2 height=60><b>{{subject}}</b></td> <td class=m03><br>{{subjectResult.max_mark_data.unit_test_1}}</td> <td class=m03><br>{{subjectResult.unit_test_1}}</td> <td class=m03><br>{{subjectResult.max_mark_data.term1_hf}}</td> <td class=m03><br>{{subjectResult.term1_hf}}</td> <td class=m03><br> {{subjectResult.max_mark_data.unit_test_2}}</td> <td class=m03><br>{{subjectResult.unit_test_2}}</td> <td class=m03><br>{{subjectResult.max_mark_data.term2}}</td> <td class=m03><br>{{subjectResult.term2}}</td> <td class=m03><br>{{subjectResult.max_mark_data.term_3}}</td> <td class=m03><br>{{subjectResult.term_3}}</td> <td class=m03><br>{{subjectResult.max_mark_data.ce}}</td> <td class=m03><br>{{subjectResult.ce}}</td> <td class=m03><br>{{subjectResult.total_score}}</td> <td class=m03><br>{{subjectResult.over_all_grade}}</td> </tr> <tr> <td colspan=14 height=48><b>Average Score</b></td> <td colspan=2 class=m03><br>{{typeNinekbConsolidatedCtrl.reportCardArray.avg_data.average}}</td> </tr> <tr ng-if=typeNinekbConsolidatedCtrl.reportCardArray.discipline style=text-align:center> <td class=m03 colspan=6 height=21><b> Term I </b></td> <td class=m03 colspan=2><b>Grade</b></td> <td class=m03 colspan=7><b> Term II</b></td> <td class=m03><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in typeNinekbConsolidatedCtrl.reportCardArray.discipline\"> <td colspan=6 height=21><b>{{subject}}</b></td> <td class=m03 colspan=2><br>{{subjectResult.grade_1}}</td> <td colspan=7><b>{{subject}}</b></td> <td class=m03><br>{{subjectResult.grade_2}}</td> </tr> <tr> <td colspan=2 height=36>Result</td> <td colspan=12><br></td> <td colspan=2>Attendance <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance>  </td> </tr> <tr> </tr><tr> <td colspan=2 height=36>Promoted to Grade </td> <td colspan=12> </td> <td colspan=3 rowspan=4><br></td>  </tr> <tr style=background-color:#e4e3e3> <td colspan=2 height=25><br></td> <td colspan=4><br></td> <td colspan=4><br></td> <td colspan=4><br></td> </tr> <tr style=text-align:center;background-color:#e4e3e3> <td colspan=2 height=25>Class Teacher </td> <td colspan=4>Supervisor</td> <td colspan=4>Head of Section</td> <td colspan=4>Principal</td> </tr> <tr> <td height=25>Date:</td> <td colspan=13><br></td> </tr> <tr> <td colspan=14 height=25>Instructions: </td> <td colspan=2>School Seal</td> </tr> <tr> <td colspan=16 height=25>Grading Scale : </td> </tr> <tr> <td colspan=2 height=20><b>Grade</b></td> <td colspan=3><b>Marks Range</b></td> <td colspan=9 rowspan=9><br></td> <td colspan=3 rowspan=9><br></td> </tr> <tr class=m03> <td colspan=2 height=20><b>A+</b></td> <td colspan=3><b>90-100</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>A </b></td> <td colspan=3><b>80-89</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>B+</b></td> <td colspan=3><b>70-79</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>B</b></td> <td colspan=3><b>60-69</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>C+</b></td> <td colspan=3><b>50-59</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>C</b></td> <td colspan=3><b>40-49</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>D</b></td> <td colspan=3><b>30-39</b></td> </tr> <tr class=m03> <td colspan=2 height=20><b>E (Failed)</b></td> <td colspan=3><b>&lt;30</b></td> </tr> </tbody> </table>";

/***/ }),
/* 1180 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=6>Term I</td> <td class=s10 colspan=6>Term II</td> <td class=\"s11 v_m\" rowspan=2 dir=ltr><span> Average </span></td> <td class=\"s11 v_m\" colspan=2 rowspan=2 dir=ltr><span> Grade </span></td> </tr> <tr> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s11 dir=ltr colspan=2>Grade</td> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s12 colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveOneEightCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> <td class=s14 colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_2}}</td> <td class=s13 colspan=2>{{subjectResult.grade_2}}</td> <td>{{subjectResult.aggregate_avg_total}} </td> <td colspan=2>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveOneEightCtrl.reportCardArray.additional_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>50</td> <td class=s13 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> <td class=s14 colspan=2>50</td> <td class=s13 colspan=2>{{subjectResult.total_mark_2}}</td> <td class=s13 colspan=2>{{subjectResult.grade_2}}</td> <td>{{subjectResult.aggregate_avg_total}} </td> <td colspan=2>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=7>TERM 1</td> <td class=s21 colspan=8>TERM 2 / FINAL</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 1 theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 2 theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Final</span></div> </td> <td class=\"s25 v_m\" rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessment</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=s24 colspan=2>Periodic Assessment</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[3]</td> <td class=s22>[2]</td> <td class=s22>[2]</td> <td class=s22>[3]</td> <td class=s22>[40]</td> <td class=s22>[50]</td> <td class=s22>[3]</td> <td class=s22>[2]</td> <td class=s22>[2]</td> <td class=s22>[3]</td> <td class=s22>[40]</td> <td class=s22>[50]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveOneEightCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term1_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td class=s14>{{subjectResult.grade_1}}</td> <td class=s14>{{subjectResult.periodic_test_2}}</td> <td class=s13>{{subjectResult.multiple_assessment_2}}</td> <td class=s13>{{subjectResult.portfolio_2}}</td> <td class=s13>{{subjectResult.subject_enrichment_2}}</td> <td class=s13>{{subjectResult.term2_theory_2}}</td> <td class=s12>{{subjectResult.total_mark_2}}</td> <td class=s12><span ng-show=subjectResult.has_term2>{{subjectResult.grand_total}}</span></td> <td class=s13><span ng-show=subjectResult.has_term2> {{subjectResult.grand_total_grade}} </span></td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=7>Term 1</td> <td class=s34 colspan=8>Term 2</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveOneEightCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=7>{{subjectResult.grade_1}}</td> <td class=s34 colspan=8>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=7>Term 1 <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=s34 colspan=10>Term 2 <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks1 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=15> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=5>Supervisor</td> <td class=s40 colspan=5>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwelveOneEightCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=5></td> <td class=s43 colspan=5></td> <td class=s43 colspan=5></td> </tr> <tr> <td class=s44 colspan=17>Instructions:</td> </tr> <tr> <td class=s45 colspan=17>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=4>Marks Range</td> <td class=s47 colspan=11 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=4>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=4>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=4>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=4>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=4>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=4>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=4>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=4>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=6>Term I</td> <td class=s10 colspan=6>Term II</td> <td class=\"s11 v_m\" rowspan=2 colspan=2 dir=ltr><span> Average </span></td> <td class=\"s11 v_m\" colspan=3 rowspan=2 dir=ltr><span> Grade </span></td> </tr> <tr> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s11 dir=ltr colspan=2>Grade</td> <td class=s11 colspan=2>Max Marks</td> <td class=s12 colspan=2>Mark Obt</td> <td class=s12 colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveNineTenCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> <td class=s14 colspan=2>100.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_2}}</td> <td class=s13 colspan=2>{{subjectResult.grade_2}}</td> <td colspan=2>{{subjectResult.aggregate_avg_total}} </td> <td colspan=3>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=7>TERM 1</td> <td class=s21 colspan=10>TERM 2 / FINAL</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 1 theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 2 theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Final CE</span></div> </td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Theory</span></div> </td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Final</span></div> </td> <td class=\"s25 v_m\" rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessment</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=s24 colspan=2>Periodic Assessment</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[3]</td> <td class=s22>[2]</td> <td class=s22>[2]</td> <td class=s22>[3]</td> <td class=s22>[40]</td> <td class=s22>[50]</td> <td class=s22>[3]</td> <td class=s22>[2]</td> <td class=s22>[2]</td> <td class=s22>[3]</td> <td class=s22>[40]</td> <td class=s22>[50]</td> <td class=s22>[20]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveNineTenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term1_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td class=s14>{{subjectResult.grade_1}}</td> <td class=s14>{{subjectResult.periodic_test_2}}</td> <td class=s13>{{subjectResult.multiple_assessment_2}}</td> <td class=s13>{{subjectResult.portfolio_2}}</td> <td class=s13>{{subjectResult.subject_enrichment_2}}</td> <td class=s13>{{subjectResult.term2_theory_2}}</td> <td class=s12>{{subjectResult.total_mark_2}}</td> <td class=s12><span ng-show=subjectResult.has_term2>{{subjectResult.finalCE}}</span></td> <td class=s13><span ng-show=subjectResult.has_term2> {{subjectResult.theory80}} </span></td> <td class=s12><span ng-show=subjectResult.has_term2>{{subjectResult.grand_total}}</span></td> <td class=s13><span ng-show=subjectResult.has_term2> {{subjectResult.grand_total_grade}} </span></td> </tr> <tr> <td class=s27 colspan=2>Additional Subject</td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=2>Total</td> <td class=s14 colspan=1>Grade</td> <td class=s13 colspan=4>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=2>Total</td> <td class=s28 colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveNineTenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=1>{{subjectResult.grade_1}}</td> <td class=s18 colspan=4>{{subjectResult.theory_2}}</td> <td class=s18 colspan=2>{{subjectResult.practical_2}}</td> <td class=s30 colspan=2>{{subjectResult.total_mark_2}}</td> <td class=s32 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=7>Term 1</td> <td class=s34 colspan=10>Term 2</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveNineTenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=7>{{subjectResult.grade_1}}</td> <td class=s34 colspan=10>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=7>Term 1 <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=s34 colspan=10>Term 2 <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks1 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=5>Supervisor</td> <td class=s40 colspan=6>Head of Section</td> <td class=s40 colspan=6>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwelveNineTenCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=5></td> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s44 colspan=19>Instructions:</td> </tr> <tr> <td class=s45 colspan=19>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=6>Marks Range</td> <td class=s47 colspan=11 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=6>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=6>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=6>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=6>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=6>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=6>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=6>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=6>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>Periodic Test </th> <th style=font-size:12px colspan=1></th> <th colspan=1>&nbsp;</th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Total Mks <br/> Obt. <br/> (100) </strong> </td> <td colspan=1><strong>Grade</strong></td> <td colspan=1><strong>Subject Remarks</strong></td> </tr> <tr ng-repeat=\"(subjectResult, value) in publishedEltReportCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.total_mark}}</td> <td colspan=1>{{value.grade}}</td> <td colspan=1>{{value.remarks}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in publishedEltReportCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff max=1000 type=text ng-model=$root.attendance_term1 style=width:351px;margin-left:50px;height:32px></td>  </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div>";

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>a.comment-indicator:hover+comment{background:#ffd;position:absolute;display:block;border:1px solid #000;padding:.5em}a.comment-indicator{background:red;display:inline-block;border:1px solid #000;width:.5em;height:.5em}comment{display:none}.head_content{border-bottom:1px solid #000;border-right:1px solid #000}.subject_sub_cell{border-bottom:1px solid #000;border-right:1px solid #000;color:#000}.subject_sub_cell1{border-bottom:1px solid #000;border-right:1px solid #000}.class_batch{border-bottom:1px solid #000;border-right:1px solid #000}.head_content1{border-right:1px solid #000}.total_content1{border-bottom:1px solid #000;border-right:1px solid #000}.date_content{border-bottom:1px solid #000}.grade_content{border-right:1px solid #000}.fonf_face{size:3px;text-align:center}.allign_left{text-align:left}.allign_center{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:830px;float:left;display:block;text-align:center}.heading_mid{width:1000px;float:left}.logo_name{font-size:38px;text-transform:uppercase;text-align:center}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px}.full_width{width:100%}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.2rem 1rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <table cellspacing=0 border=0 style=\"border:1px solid #000\"> <colgroup span=17 width=107></colgroup> <tr> <td style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=4 rowspan=2 height=42 class=allign_left> <strong>Subjects</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=13> <strong>Term I (50 Marks)</strong> </td> </tr> <tr> <td class=\"subject_sub_cell allign_center\" colspan=4 bgcolor=#D8D8D8> <strong>Max Marks</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=6> <strong>Marks Obt.</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=6 bgcolor=#D8D8D8> <strong>Grade</strong> </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedType20kbtermsCtrl.reportCardArray.specific_subjects\"> <td class=\"grade_content allign_left\" style=\"border-bottom:1px solid #000;border-left:1px solid #000\" colspan=4 height=21> &nbsp;&nbsp;{{subject}} </td> <td class=\"subject_sub_cell allign_center\" colspan=4> 50 </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.grade_1}} </td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=4 rowspan=2 height=42 class=allign_left bgcolor=#FFFFFF><b> &nbsp;Subjects </b></td> <td class=\"subject_sub_cell allign_center\" colspan=13 bgcolor=#FFFFFF><b> Term I </b></td> </tr> <tr> <td class=\"class_batch allign_center\" colspan=4 bgcolor=#FFFFFF> <strong>Max Marks</strong> </td> <td class=\"class_batch allign_center\" colspan=6 bgcolor=#FFFFFF> <strong>Marks Obt.</strong> </td> <td class=\"class_batch allign_center\" colspan=6 bgcolor=#FFFFFF> <strong>Grade</strong> </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedType20kbtermsCtrl.reportCardArray.main_results\"> <td class=\"head_content grade_content allign_left\" colspan=4 height=21 class=allign_left><b> &nbsp;&nbsp;{{subject}} </b></td> <td class=\"subject_sub_cell allign_center\" colspan=4> {{subjectResult.max_mark1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.grade_1}} </td> </tr> <tr> <td class=head_content class=grade_content colspan=2 height=21> &nbsp; Result </td> <td class=\"subject_sub_cell allign_left\" colspan=12> <span ng-if=!$root.isTeachingStaff> &nbsp;{{ $root.StdResult}}</span> <input ng-if=$root.isTeachingStaff maxlength=55 type=text ng-model=$root.StdResult style=width:80%> </td> <td class=\"subject_sub_cell allign_center\" colspan=3> Attendance </td> </tr> <tr> <td class=head_content colspan=2 height=21 class=allign_left> &nbsp; Promoted to Grade </td> <td class=subject_sub_cell colspan=12 class=allign_left> <span ng-if=!$root.isTeachingStaff>&nbsp; {{ $root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td class=\"subject_sub_cell allign_center\" rowspan=2 colspan=3> Term I </td> </tr> <tr> <td style=\"border-left:1px solid #000\" class=\"subject_sub_cell1 allign_left\" colspan=2 height=21> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> </tr> <tr> <td class=\"grade_content head_content\" colspan=2 height=21 class=allign_left bgcolor=#D8D8D8> &nbsp;Class Teacher </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Supervisor </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Head of Section </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Principal </td> <td class=\"head_content grade_content allign_center\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendanceKb10_term1 style=width:65px> </td> </tr> <tr> <td colspan=2 class=subject_sub_cell height=21 style=\"border-right:#fff;border-left:1px solid #000\"> &nbsp;Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff maxlength=12 ng-model=$root.StdReportDate style=width:110px> </td> <td class=\"head_content grade_content allign_center\" colspan=12 height=21> Instructions: </td> <td class=\"head_content grade_content allign_center\" colspan=3> School Seal </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" class=\"\" colspan=2 height=21><b> Grade </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> Percentage Range </b></td> <td colspan=9 rowspan=9 class=\"subject_sub_cell allign_center\"> </td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=\"head_content1 allign_left\"> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 90-100 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 80-89 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> B+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 70-79 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> B </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 60-69 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> C+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 50-59 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" colspan=2 height=21><b> C </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 40-49 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> D+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 31-39 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 height=21><b> D </b></td> <td class=\"class_batch allign_center\" colspan=3><b> &lt;=30 </b></td> <td class=\"date_content allign_left\"> </td> <td class=\"date_content allign_left\"> </td> <td class=\"total_content1 allign_left\" class=allign_left> </td> </tr> </table>";

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=12>TERM 1</td> </tr> <tr> <td class=s11 colspan=3>Max Marks</td> <td class=s12 colspan=6>Mark Obt</td> <td class=s11 dir=ltr colspan=3>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=3>100</td> <td class=s13 colspan=6>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=12>TERM 1</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 1 Theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" colspan=6 rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessments</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term1_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td colspan=6 class=s14>{{subjectResult.grade_1}}</td>  </tr> <tr> <td class=s27 colspan=2>Additional Subject</td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=2>Total</td> <td class=s14 colspan=6>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=6>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=12>TERM 1</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=13>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenCtrl.reportCardArray.discipline\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=13>{{subjectResult.grade_1}}</td> </tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=12>TERM 1 : <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td>  <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks1 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=2>Head of Section</td> <td class=s40 colspan=6>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwentyNineTenCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s44 colspan=19>Instructions:</td> </tr> <tr> <td class=s45 colspan=19>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=6>Marks Range</td> <td class=s47 colspan=12 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=6>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=6>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=6>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=6>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=6>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=6>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=6>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=6>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=11>TERM 1</td> </tr> <tr> <td class=s11 colspan=3>Max Marks</td> <td class=s12 colspan=6>Mark Obt</td> <td class=s11 dir=ltr colspan=3>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=3>100</td> <td class=s13 colspan=6>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightCtrl.reportCardArray.additional_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>50.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=11>TERM 1</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 1 Theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" colspan=6 rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessments</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term1_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td colspan=6 class=s14>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=11>TERM 1</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=11>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=10>TERM 1 : <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> </tr> <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks1 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=15> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=2>Head of Section</td> <td class=s40 colspan=6>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwentyOneEightCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s44 colspan=17>Instructions:</td> </tr> <tr> <td class=s45 colspan=17>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=4>Marks Range</td> <td class=s47 colspan=11 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=4>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=4>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=4>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=4>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=4>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=4>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=4>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=4>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>a.comment-indicator:hover+comment{background:#ffd;position:absolute;display:block;border:1px solid #000;padding:.5em}a.comment-indicator{background:red;display:inline-block;border:1px solid #000;width:.5em;height:.5em}comment{display:none}.head_content{border-bottom:1px solid #000;border-right:1px solid #000}.subject_sub_cell{border-bottom:1px solid #000;border-right:1px solid #000;color:#000}.subject_sub_cell1{border-bottom:1px solid #000;border-right:1px solid #000}.class_batch{border-bottom:1px solid #000;border-right:1px solid #000}.head_content1{border-right:1px solid #000}.total_content1{border-bottom:1px solid #000;border-right:1px solid #000}.date_content{border-bottom:1px solid #000}.grade_content{border-right:1px solid #000}.fonf_face{size:3px;text-align:center}.allign_left{text-align:left}.allign_center{text-align:center}.main_con{width:1070px;margin:0 auto;background:#fff;display:flex;padding:20px}.profile_img img{width:120px;margin:0 auto;float:left;display:block}.annexure_con{width:830px;float:left;display:block;text-align:center}.heading_mid{width:1000px;float:left}.logo_name{font-size:38px;text-transform:uppercase;text-align:center}.h1_font_size{font-size:25px;margin-bottom:0;margin-top:7px}.full_width{width:100%}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:.2rem 1rem}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <table cellspacing=0 border=0 style=\"border:1px solid #000\"> <colgroup span=17 width=107></colgroup> <tr> <td style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=4 rowspan=2 height=42 class=allign_left> <strong>&nbsp; Subjects</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=13> <strong>Term II (50 Marks)</strong> </td> </tr> <tr> <td class=\"subject_sub_cell allign_center\" colspan=4 bgcolor=#D8D8D8> <strong>Max Marks</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=6> <strong>Marks Obt.</strong> </td> <td class=\"subject_sub_cell allign_center\" colspan=6 bgcolor=#D8D8D8> <strong>Grade</strong> </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedType20kbterms2Ctrl.reportCardArray.specific_subjects\"> <td class=\"grade_content allign_left\" style=\"border-bottom:1px solid #000;border-left:1px solid #000\" colspan=4 height=21> &nbsp;&nbsp;{{subject}} </td> <td class=\"subject_sub_cell allign_center\" colspan=4> 50 </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.grade_1}} </td> </tr> <tr> <td style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=4 rowspan=2 height=42 class=allign_left bgcolor=#FFFFFF><b> &nbsp;Subjects </b></td> <td class=\"subject_sub_cell allign_center\" colspan=13 bgcolor=#FFFFFF><b> Term II </b></td> </tr> <tr> <td class=\"class_batch allign_center\" colspan=4 bgcolor=#FFFFFF> <strong>Max Marks</strong> </td> <td class=\"class_batch allign_center\" colspan=6 bgcolor=#FFFFFF> <strong>Marks Obt.</strong> </td> <td class=\"class_batch allign_center\" colspan=6 bgcolor=#FFFFFF> <strong>Grade</strong> </td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedType20kbterms2Ctrl.reportCardArray.main_results\"> <td class=\"head_content grade_content allign_left\" colspan=4 height=21 class=allign_left><b> &nbsp;&nbsp;{{subject}} </b></td> <td class=\"subject_sub_cell allign_center\" colspan=4> {{subjectResult.max_mark1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.total_mark_1}} </td> <td class=\"subject_sub_cell allign_center\" colspan=6> {{subjectResult.grade_1}} </td> </tr> <tr> <td class=head_content class=grade_content colspan=2 height=21> &nbsp; Result </td> <td class=\"subject_sub_cell allign_left\" colspan=12> <span ng-if=!$root.isTeachingStaff> &nbsp;{{ $root.StdResult}}</span> <input ng-if=$root.isTeachingStaff maxlength=55 type=text ng-model=$root.StdResult style=width:80%> </td> <td class=\"subject_sub_cell allign_center\" colspan=3> Attendance </td> </tr> <tr> <td class=head_content colspan=2 height=21 class=allign_left> &nbsp; Promoted to Grade </td> <td class=subject_sub_cell colspan=12 class=allign_left> <span ng-if=!$root.isTeachingStaff>&nbsp; {{ $root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td class=\"subject_sub_cell allign_center\" rowspan=2 colspan=3> Term II </td> </tr> <tr> <td style=\"border-left:1px solid #000\" class=\"subject_sub_cell1 allign_left\" colspan=2 height=21> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> <td class=\"subject_sub_cell1 allign_left\" colspan=4> </td> </tr> <tr> <td class=\"grade_content head_content\" colspan=2 height=21 class=allign_left bgcolor=#D8D8D8> &nbsp;Class Teacher </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Supervisor </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Head of Section </td> <td class=\"subject_sub_cell allign_left\" colspan=4 valign=top bgcolor=#D8D8D8 sdnum=1033;0;0.0> &nbsp;Principal </td> <td class=\"head_content grade_content allign_center\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb10_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendanceKb10_term2 style=width:65px> </td> </tr> <tr> <td colspan=2 class=subject_sub_cell height=21 style=\"border-right:#fff;border-left:1px solid #000\"> &nbsp;Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff maxlength=12 ng-model=$root.StdReportDate style=width:110px> </td> <td class=\"head_content grade_content allign_center\" colspan=12 height=21> Instructions: </td> <td class=\"head_content grade_content allign_center\" colspan=3> School Seal </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" class=\"\" colspan=2 height=21><b> Grade </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> Percentage Range </b></td> <td colspan=9 rowspan=9 class=\"subject_sub_cell allign_center\"> </td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=\"head_content1 allign_left\"> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 90-100 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> A </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 80-89 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> B+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 70-79 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> B </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 60-69 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content grade_content allign_center\" colspan=2 height=21><b> C+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 50-59 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" colspan=2 height=21><b> C </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 40-49 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" class=grade_content colspan=2 height=21><b> D+ </b></td> <td class=\"subject_sub_cell allign_center\" colspan=3><b> 31-39 </b></td> <td class=allign_left> </td> <td class=allign_left> </td> <td class=head_content1 class=allign_left> </td> </tr> <tr> <td class=\"head_content allign_center grade_content\" style=\"border-bottom:1px solid #000;border-right:1px solid #000\" colspan=2 height=21><b> D </b></td> <td class=\"class_batch allign_center\" colspan=3><b> &lt;=30 </b></td> <td class=\"date_content allign_left\"> </td> <td class=\"date_content allign_left\"> </td> <td class=\"total_content1 allign_left\" class=allign_left> </td> </tr> </table>";

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=12>TERM 2</td> </tr> <tr> <td class=s11 colspan=3>Max Marks</td> <td class=s12 colspan=6>Mark Obt</td> <td class=s11 dir=ltr colspan=3>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenTwoCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=3>100.0</td> <td class=s13 colspan=6>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=12>TERM 2</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 1 Theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" colspan=6 rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessments</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term2_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td colspan=6 class=s14>{{subjectResult.grade_1}}</td>  </tr> <tr> <td class=s27 colspan=2>Additional Subject</td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=2>Total</td> <td class=s14 colspan=6>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenTwoCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=6>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=12>TERM 2</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=13>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyNineTenTwoCtrl.reportCardArray.discipline\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=13>{{subjectResult.grade_1}}</td> </tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=12>TERM 2 : <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </td>  <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks2 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=2>Head of Section</td> <td class=s40 colspan=6>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwentyNineTenTwoCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s44 colspan=19>Instructions:</td> </tr> <tr> <td class=s45 colspan=19>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=6>Marks Range</td> <td class=s47 colspan=12 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=6>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=6>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=6>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=6>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=6>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=6>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=6>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=6>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2>Subject</td> <td class=s10 dir=ltr colspan=11>TERM 2</td> </tr> <tr> <td class=s11 colspan=3>Max Marks</td> <td class=s12 colspan=6>Mark Obt</td> <td class=s11 dir=ltr colspan=3>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightTwoCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=3>100</td> <td class=s13 colspan=6>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightTwoCtrl.reportCardArray.additional_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s13 dir=ltr colspan=2>50.0</td> <td class=s13 colspan=2>{{subjectResult.total_mark_1}}</td> <td class=s13 colspan=2>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s19 colspan=2 rowspan=5>Scholastic Area</td> <td class=s20 colspan=11>TERM 2</td> </tr> <tr> <td class=s22 colspan=4>Internal Assessments</td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Term 2 Theory</span></div></td> <td class=\"s26 v_m\" rowspan=3><div id=t_center><span id=mySpan>Total</span></div> </td> <td class=\"s24 v_m\" colspan=6 rowspan=4><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s24 colspan=2>Periodic Assessments</td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> </tr> <tr> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[5]</td> <td class=s22>[80]</td> <td class=s22>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13>{{subjectResult.periodic_test_1}}</td> <td class=s13>{{subjectResult.multiple_assessment_1}}</td> <td class=s13>{{subjectResult.portfolio_1}}</td> <td class=s13>{{subjectResult.subject_enrichment_1}}</td> <td class=s13>{{subjectResult.term2_theory_1}}</td> <td class=s14>{{subjectResult.total_mark_1}}</td> <td colspan=6 class=s14>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Co-Scholastic Areas [ on a five point grading scale ]</td> <td class=s34 colspan=11>TERM 2</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwentyOneEightTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=11>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=10>TERM 2 : <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr> <td class=s6 colspan=2>Remarks</td> <td class=s38 colspan=17> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks2}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.term_remarks2 style=width:100%> </td> </tr> <tr> <td class=\"s1 softmerge\" colspan=2> <div class=softmerge-inner style=width:234px;left:-1px>Promoted to Grade </div> </td> <td class=s39 colspan=15> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to> </td> </tr> <tr> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=2>Head of Section</td> <td class=s40 colspan=6>Principal</td> </tr> <tr> <td class=\"s41 softmerge\" colspan=2> <div> Date:&nbsp;{{publishedTypeTwentyOneEightTwoCtrl.reportCardArray.header.published_date}}</div> </td> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s44 colspan=17>Instructions:</td> </tr> <tr> <td class=s45 colspan=17>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=4>Marks Range</td> <td class=s47 colspan=11 rowspan=9></td> </tr> <tr> <td class=s46 colspan=2>A1</td> <td class=s46 colspan=4>91-100</td> </tr> <tr> <td class=s46 colspan=2>A2</td> <td class=s46 colspan=4>81-90</td> </tr> <tr> <td class=s46 colspan=2>B1</td> <td class=s46 colspan=4>71-80</td> </tr> <tr> <td class=s46 colspan=2>B2</td> <td class=s46 colspan=4>61-70</td> </tr> <tr> <td class=s46 colspan=2>C1</td> <td class=s46 colspan=4>51-60</td> </tr> <tr> <td class=s46 colspan=2>C2</td> <td class=s46 colspan=4>41-50</td> </tr> <tr> <td class=s46 colspan=2>D</td> <td class=s46 colspan=4>33-40</td> </tr> <tr> <td class=s49 colspan=2>E (Failed)</td> <td class=s49 colspan=4>&lt;=32</td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td ng-if=\"eightclass && !bestOfTermSchoolTCS\" class=s12 colspan=4 style=text-align:center><b>Mark Obtained</b><br>Best of Term 1 & Term 2</td> <td ng-if=\"eightclass && bestOfTermSchoolTCS\" class=s12 colspan=4 style=text-align:center><b>Annual</b><br>Mark</td> <td ng-if=\"ninthclass && bestOfTermSchoolTCS\" class=s12 colspan=4 style=text-align:center><b>Annual</b><br>Mark</td> <td ng-if=\"ninthclass && !eightclass && !bestOfTermSchoolTCS\" class=s12 colspan=4 style=text-align:center><b>Total (100) <br> ( Term 1,Term 2) </b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan> Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td ng-if=!bestOfTermSchoolTCS class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained<br>Best of Term 1 & Term 2</span></div></td> <td ng-if=\"bestOfTermSchoolTCS && !eightclass && !ninthclass\" class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span> <b>Mark Obtained (100)</b><br>Best of Term 1 & Term 2</span></div></td> <td ng-if=\"bestOfTermSchoolTCS && eightclass\" class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span> <b>Annual</b><br>Mark</span></div></td> <td ng-if=\"bestOfTermSchoolTCS && ninthclass\" class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span> <b>Annual</b><br>Mark</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr ng-if=isadditional> <td class=s33 colspan=2 style=text-align:center rowspan=2><b>Information Technology</b></td> <td class=s33 colspan=3 style=text-align:center><b>Theory(50)</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical(50)</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=3 style=text-align:center><b>Theory(50)</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical(50)</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenCtrl.reportCardArray.additional_subjects\" ng-if=isadditional> <td class=s18 dir=ltr colspan=3 style=font-size:10px;text-align:center>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2 style=font-size:10px;text-align:center>{{subjectResult.practical_1}}</td> <td class=s30 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s30 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td> <td class=s18 dir=ltr colspan=3 style=font-size:10px;text-align:center>{{subjectResult.theory_2_2}}</td> <td class=s18 colspan=2 style=font-size:10px;text-align:center>{{subjectResult.practical_2_2}}</td> <td class=s30 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s30 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeEightToTenCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeEightToTenCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeEightToTenCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Total (100) <br>Average ( Term1 & Term 2)</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Final Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTen2Ctrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained (100) <br> Avg(Term 1 & Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTen2Ctrl.reportCardArray.main_results\"> <td class=s27 rowspan=1 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr ng-if=isadditional> <td class=s33 colspan=2 style=text-align:center rowspan=2><b>Information Technology</b></td> <td class=s33 colspan=3 style=text-align:center><b>Theory(50)</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical(50)</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=3 style=text-align:center><b>Theory(50)</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical(50)</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTen2Ctrl.reportCardArray.additional_subjects\" ng-if=isadditional> <td class=s18 dir=ltr colspan=3 style=font-size:10px;text-align:center>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2 style=font-size:10px;text-align:center>{{subjectResult.practical_1}}</td> <td class=s30 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s30 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td> <td class=s18 dir=ltr colspan=3 style=font-size:10px;text-align:center>{{subjectResult.theory_2_2}}</td> <td class=s18 colspan=2 style=font-size:10px;text-align:center>{{subjectResult.practical_2_2}}</td> <td class=s30 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s30 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTen2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTen2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeEightToTen2Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeEightToTen2Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeEightToTen2Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Total (100) <br> Avg (Term 1 & Term 2)\t</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Final Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSevenCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Total (100) <br> Avg\t(Term 1 & Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSevenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.yearly_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I </b></td> <td class=s33 style=text-align:center colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSevenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSevenCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixToSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixToSevenCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeSixToSevenCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixToSevenCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Annual<br>Mark</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSeven2Ctrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Annual<br>Mark</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSeven2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSeven2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixToSeven2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2> <b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2 style=text-align:center>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2 style=text-align:center>{{subjectResult.practical_1}}</td> <td class=s30 colspan=2 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s18 dir=ltr colspan=2 style=text-align:center>{{subjectResult.theory_2}}</td> <td class=s18 colspan=2 style=text-align:center>{{subjectResult.practical_2}}</td> <td class=s30 colspan=2 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s30 colspan=1 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixToSeven2Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeSixToSeven2Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixToSeven2Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><div id=t_center><span>Mark Obtained<br>Best of Term 1 & Term 2</span></div></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFiveCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained<br>Best of Term 1 & Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFiveCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFiveCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFiveCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeThreeToFiveCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeThreeToFiveCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeThreeToFiveCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Total <br> Avg Of Term 1 + Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFive2Ctrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Total <br>(100) Term 1 + Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFive2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFive2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFive2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeThreeToFive2Ctrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThreeToFive2Ctrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> <tr class=headcolor> <td colspan=4 style=text-align:left!important><b>SEA(Subject Enrichment Activities),<br> MA(Multiple Assessment)</b> </td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeThreeToFive2Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeThreeToFive2Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeThreeToFive2Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained <br>Best of Term 1 & Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeOneToTwoCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained <br>Best of Term 1 & Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeOneToTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeOneToTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeOneToTwoCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeOneToTwoCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeOneToTwoCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeOneToTwoCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}</style> <div class=\"ritz grid-container\" dir=ltr> <table ng-if=!publishedTypeFiveSixEightCtrl.reportCardArray.header.hide_aggregate id=table-example-1 class=waffle cellspacing=0 cellpadding=0 style=width:900px> <tbody> <tr> <td class=s8 colspan=2 rowspan=2>Subject</td> <td class=s14 colspan=6>Term I (100 Marks)</td> <td class=s14 colspan=6>Term II (100 Marks)</td> <td class=s15 rowspan=2>Mark Obtained(200)</td> <td class=s16 rowspan=2>Average</td> <td class=s17 rowspan=2>Grade</td> </tr> <tr> <td class=s18 colspan=2>Max Marks</td> <td class=s19 colspan=2>Mark Obt</td> <td class=s18 colspan=2>Grade</td> <td class=s18 colspan=2>Max Marks</td> <td class=s19 colspan=2>Mark Obt</td> <td class=s18 colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.specific_subjects\"> <td class=s8 colspan=2>{{subject}}</td> <td class=s20 colspan=2>100</td> <td class=s20 colspan=2>{{subjectResult.half_yearly_1}}</td> <td class=s21 colspan=2>{{subjectResult.grade_1}}</td> <td class=s20 colspan=2>100</td> <td class=s20 colspan=2>{{subjectResult.annual_exam_2}}</td> <td class=s21 colspan=2>{{subjectResult.grade_2}}</td> <td class=s22>{{subjectResult.aggregate}} </td> <td class=s22>{{subjectResult.aggregate_avg_total}}</td> <td class=s23>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr> <td class=s29 colspan=2 rowspan=4>Scholastic Area</td> <td class=s30 colspan=6>TERM 1 (100 Marks)</td> <td class=s30 colspan=6>TERM 2 (100 Marks)</td> <td class=s31 colspan=3>Overall</td> </tr> <tr> <td class=s32 rowspan=2>Periodic Test</td> <td class=s32 rowspan=2>Note Book</td> <td class=s32 rowspan=2>Subject Enrichment</td> <td class=s32 rowspan=2>Half yearly Exam</td> <td class=s32 rowspan=2>Marks Obtained</td> <td class=s33 rowspan=3>Grade</td> <td class=s32 rowspan=2>Periodic Test</td> <td class=s32 rowspan=2>Note Book</td> <td class=s32 rowspan=2>Subject Enrichment</td> <td class=s32 rowspan=2>Yearly Exam</td> <td class=s32 rowspan=2>Marks Obtained</td> <td class=s33 rowspan=3>Grade</td> <td class=s15 rowspan=3>Mark Obtained(200)</td> <td class=s14 rowspan=3>Average</td> <td class=s34 rowspan=3>Grade</td> </tr> <tr> </tr> <tr> <td class=s35>[10]</td> <td class=s35>[5]</td> <td class=s35>[5]</td> <td class=s35>[80]</td> <td class=s35>[100]</td> <td class=s35>[10]</td> <td class=s35>[5]</td> <td class=s35>[5]</td> <td class=s35>[80]</td> <td class=s35>[100]</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.main_results\"> <td class=s36 colspan=2>{{subject}}</td> <td class=s20>{{subjectResult.periodic_test_1}}</td> <td class=s20>{{subjectResult.note_book_submission_1}}</td> <td class=s20>{{subjectResult.subject_enrichment_1}}</td> <td class=s20>{{subjectResult.half_yearly_1}}</td> <td class=s21>{{subjectResult.total_mark_1}}</td> <td class=s21>{{subjectResult.grade_1}}</td> <td class=s20>{{subjectResult.periodic_test_2}}</td> <td class=s20>{{subjectResult.note_book_submission_2}}</td> <td class=s20>{{subjectResult.subject_enrichment_2}}</td> <td class=s19>{{subjectResult.annual_exam_2}}</td> <td class=s21>{{subjectResult.total_mark_2}}</td> <td class=s21>{{subjectResult.grade_2}}</td> <td class=s22>{{subjectResult.aggregate}} </td> <td class=s22>{{subjectResult.aggregate_avg_total}}</td> <td class=s23>{{subjectResult.aggregate_avg_grade}} </td> </tr> <tr style=height:20px> <td class=s45 colspan=6>Co-Scholastic Term I </td> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=7>Co-Scholastic Term II</td> <td class=s47 colspan=2>Grade </td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.other_sections\"> <td class=s36 colspan=6>{{subject}}</td> <td class=s20 colspan=2>{{subjectResult.grade_1}}</td> <td class=s48 colspan=7>{{subject}}</td> <td class=s49 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.discipline\"> <td class=s40 colspan=2>Discipline</td> <td class=s52 colspan=4></td> <td class=s52 colspan=2>{{subjectResult.grade_1}}</td> <td class=s52 colspan=7>Discipline</td> <td class=s28 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:35px> <td class=s8 colspan=2>Result</td> <td class=s53 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </td> <td class=s14 colspan=3>Attendance</td> </tr> <tr style=height:24px> <td class=\"s3 softmerge\" colspan=2> <div class=softmerge-inner style=width:197px;left:-1px>Promoted to Grade </div> </td> <td class=s54 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td class=s16 rowspan=1>Term I</td> <td class=s16 colspan=2 rowspan=1>Term II</td> </tr> <tr style=height:24px> <td class=s19 colspan=2></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55> <span ng-if=!$root.isTeachingStaff>{{$root.attendance68_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance68_term1 style=width:65px> </td> <td class=s55 colspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance68_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance68_term2 style=width:65px> </td> </tr> <tr style=height:24px> <td class=s19 colspan=2>Class Teacher </td> <td class=s55 colspan=4>Supervisor</td> <td class=s55 colspan=4>Head of Section</td> <td class=s55 colspan=4>Principal</td> <td class=s22></td> <td class=s56 colspan=2></td> </tr> <tr style=height:24px> <td class=\"s57 softmerge\" colspan=2> <div class=softmerge-inner style=width:207px;left:-11px>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px> </div> </td> <td class=s58 colspan=4></td> <td class=s59 colspan=4></td> <td class=s59 colspan=4></td> <td class=s56 colspan=3></td> </tr> <tr style=height:24px> <td class=s60 colspan=14>Instructions:</td> <td class=s61 colspan=3>School Seal</td> </tr> <tr style=height:24px> <td class=s62 colspan=14>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> <td class=s1 colspan=3 rowspan=10></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>Grade</td> <td class=s63 colspan=3>Marks Range</td> <td class=s64 colspan=9 rowspan=9></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A1</td> <td class=s63 colspan=3>91-100</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A2</td> <td class=s63 colspan=3>81-90</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B1</td> <td class=s63 colspan=3>71-80</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B2</td> <td class=s63 colspan=3>61-70</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C1</td> <td class=s63 colspan=3>51-60</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C2</td> <td class=s63 colspan=3>41-50</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>D</td> <td class=s63 colspan=3>33-40</td> </tr> <tr style=height:19px> <td class=s66 colspan=2>E (Failed)</td> <td class=s66 colspan=3>&lt;=32</td> </tr> </tbody> </table> <table ng-if=publishedTypeFiveSixEightCtrl.reportCardArray.header.hide_aggregate id=table-example-1 class=waffle cellspacing=0 cellpadding=0 style=width:1028px!important;margin:auto> <tbody> <tr> <td class=s8 colspan=2 rowspan=2>Subject</td> <td class=s14 colspan=6>Term I (100 Marks)</td> <td class=s14 colspan=8>Term II (100 Marks)</td> </tr> <tr> <td class=s18 colspan=2>Max Marks</td> <td class=s19 colspan=2>Mark Obt</td> <td class=s18 colspan=2>Grade</td> <td class=s18 colspan=3>Max Marks</td> <td class=s19 colspan=3>Mark Obt</td> <td class=s18 colspan=2>Grade</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.specific_subjects\"> <td class=s8 colspan=2>{{subject}}</td> <td class=s20 colspan=2>100</td> <td class=s20 colspan=2>{{subjectResult.half_yearly_1}}</td> <td class=s21 colspan=2>{{subjectResult.grade_1}}</td> <td class=s20 colspan=3>100</td> <td class=s20 colspan=3>{{subjectResult.annual_exam_2}}</td> <td class=s21 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s29 colspan=2 rowspan=4>Scholastic Area</td> <td class=s30 colspan=6>TERM 1 (100 Marks)</td> <td class=s30 colspan=8>TERM 2 (100 Marks)</td> </tr> <tr> <td class=s32 rowspan=2>Periodic Test</td> <td class=s32 rowspan=2>Note Book</td> <td class=s32 rowspan=2>Subject Enrichment</td> <td class=s32 rowspan=2>Half yearly Exam</td> <td class=s32 rowspan=2>Marks Obtained</td> <td class=s33 rowspan=3>Grade</td> <td class=s32 rowspan=2>Periodic Test</td> <td class=s32 rowspan=2>Note Book</td> <td class=s32 rowspan=2>Subject Enrichment</td> <td class=s32 rowspan=2>Yearly Exam</td> <td class=s32 rowspan=2>Marks Obtained</td> <td class=s33 rowspan=3 colspan=3>Grade</td> </tr> <tr> </tr> <tr> <td class=s35>[10]</td> <td class=s35>[5]</td> <td class=s35>[5]</td> <td class=s35>[80]</td> <td class=s35>[100]</td> <td class=s35>[10]</td> <td class=s35>[5]</td> <td class=s35>[5]</td> <td class=s35>[80]</td> <td class=s35>[100]</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.main_results\"> <td class=s36 colspan=2>{{subject}}</td> <td class=s20>{{subjectResult.periodic_test_1}}</td> <td class=s20>{{subjectResult.note_book_submission_1}}</td> <td class=s20>{{subjectResult.subject_enrichment_1}}</td> <td class=s20>{{subjectResult.half_yearly_1}}</td> <td class=s21>{{subjectResult.total_mark_1}}</td> <td class=s21>{{subjectResult.grade_1}}</td> <td class=s20>{{subjectResult.periodic_test_2}}</td> <td class=s20>{{subjectResult.note_book_submission_2}}</td> <td class=s20>{{subjectResult.subject_enrichment_2}}</td> <td class=s19>{{subjectResult.annual_exam_2}}</td> <td class=s21>{{subjectResult.total_mark_2}}</td> <td class=s21 colspan=3>{{subjectResult.grade_2}}</td> </tr> <tr style=height:20px> <td class=s45 colspan=6>Co-Scholastic Term I </td> <td class=s46 colspan=2>Grade</td> <td class=s46 colspan=7>Co-Scholastic Term II</td> <td class=s47 colspan=2>Grade </td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.other_sections\"> <td class=s36 colspan=6>{{subject}}</td> <td class=s20 colspan=2>{{subjectResult.grade_1}}</td> <td class=s48 colspan=7>{{subject}}</td> <td class=s49 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:20px ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixEightCtrl.reportCardArray.discipline\"> <td class=s40 colspan=2>Discipline</td> <td class=s52 colspan=4></td> <td class=s52 colspan=2>{{subjectResult.grade_1}}</td> <td class=s52 colspan=7>Discipline</td> <td class=s28 colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr style=height:35px> <td class=s8 colspan=2>Result</td> <td class=s53 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%> </td> <td class=s14 colspan=3>Attendance</td> </tr> <tr style=height:24px> <td class=\"s3 softmerge\" colspan=2> <div class=softmerge-inner style=width:197px;left:-1px>Promoted to Grade </div> </td> <td class=s54 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%> </td> <td class=s16 rowspan=1>Term I</td> <td class=s16 colspan=2 rowspan=1>Term II</td> </tr> <tr style=height:24px> <td class=s19 colspan=2></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55 colspan=4></td> <td class=s55> <span ng-if=!$root.isTeachingStaff>{{$root.attendance68_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance68_term1 style=width:65px> </td> <td class=s55 colspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance68_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance68_term2 style=width:65px> </td> </tr> <tr style=height:24px> <td class=s19 colspan=2>Class Teacher </td> <td class=s55 colspan=4>Supervisor</td> <td class=s55 colspan=4>Head of Section</td> <td class=s55 colspan=4>Principal</td> <td class=s22></td> <td class=s56 colspan=2></td> </tr> <tr style=height:24px> <td class=\"s57 softmerge\" colspan=2> <div class=softmerge-inner style=width:207px;left:-11px>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px> </div> </td> <td class=s58 colspan=4></td> <td class=s59 colspan=4></td> <td class=s59 colspan=4></td> <td class=s56 colspan=3></td> </tr> <tr style=height:24px> <td class=s60 colspan=14>Instructions:</td> <td class=s61 colspan=3>School Seal</td> </tr> <tr style=height:24px> <td class=s62 colspan=14>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> <td class=s1 colspan=3 rowspan=10></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>Grade</td> <td class=s63 colspan=3>Marks Range</td> <td class=s64 colspan=9 rowspan=9></td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A1</td> <td class=s63 colspan=3>91-100</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>A2</td> <td class=s63 colspan=3>81-90</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B1</td> <td class=s63 colspan=3>71-80</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>B2</td> <td class=s63 colspan=3>61-70</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C1</td> <td class=s63 colspan=3>51-60</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>C2</td> <td class=s63 colspan=3>41-50</td> </tr> <tr style=height:19px> <td class=s63 colspan=2>D</td> <td class=s63 colspan=3>33-40</td> </tr> <tr style=height:19px> <td class=s66 colspan=2>E (Failed)</td> <td class=s66 colspan=3>&lt;=32</td> </tr> </tbody> </table> </div>";

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Total(100) <br> Avg(Term 1 & Term 2 )</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixSevenCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Total(100) <br> Avg(Term 1 & Term 2 )</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixSevenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixSevenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveSixSevenCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveSixSevenCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeFiveSixSevenCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveSixSevenCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained(100) <br> Avg of Term 1 + Term 2 </b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixOneTwoCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained(100) <br> Term 1 + Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixOneTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixOneTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixOneTwoCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixOneTwoCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeSixOneTwoCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixOneTwoCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained Best of Term 1 & Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained Best of Term 1 & Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[60]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixSixSevenCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeSixSixSevenCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixSixSevenCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Average <br>(100) Term 1 + Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Final Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixThreeFiveCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Total <br> (100) Term 1 + Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixThreeFiveCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixThreeFiveCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixThreeFiveCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixThreeFiveCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeSixThreeFiveCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeSixThreeFiveCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained Best of Term 1 & Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained Best of Term 1 & Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeFiveOneTwoCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveOneTwoCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeFiveOneTwoCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveOneTwoCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained Best of Term 1 & Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Final Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained Best of Term 1 & Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[20]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[50]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[20]</td> <td class=s22 colspan=1 style=font-size:10px;text-align:center>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveThreeFiveCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeFiveThreeFiveCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveThreeFiveCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.info-banner{background-color:#e0f2fe;border-left:4px solid #0284c7;color:#0c4a6e;font-size:13px;font-weight:500;padding:10px 14px;border-radius:4px;margin:10px 0;display:flex;align-items:center;gap:8px}.info-banner .info-icon{font-size:16px}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Total(100) <br> Avg(Term 1 & Term 2 )</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Final Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveEightCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.annual_exam_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span ng-if=!publishedTypeFiveEightCtrl.isNine>Total(100)<br>Avg(Term 1 & Term 2)</span> <span ng-if=publishedTypeFiveEightCtrl.isNine><br>Total(100)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[80]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveEightCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr ng-if=publishedTypeFiveEightCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveEightCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2> <b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2 style=text-align:center>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2 style=text-align:center>{{subjectResult.practical_1}}</td> <td class=s30 colspan=2 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s18 dir=ltr colspan=2 style=text-align:center>{{subjectResult.theory_2}}</td> <td class=s18 colspan=2 style=text-align:center>{{subjectResult.practical_2}}</td> <td class=s30 colspan=2 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s30 colspan=1 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s30 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveEightCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveEightCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveEightCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeFiveEightCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeFiveEightCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <div class=info-banner ng-if=publishedTypeFiveEightCtrl.isNine> <span class=info-icon>ℹ</span> The overall aggregate total marks for each scholastic subject will be calculated as 30% of Term 1 and 70% of Term 2. </div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained <br>(100) Avg Of Term 1 + Term 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypesevenOneTwoCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (50 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (50 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Mark Obtained <br>(100) Term 1 + Term 2</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[5]</td> <td class=s22 style=text-align:center colspan=1>[15]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypesevenOneTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_exam_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypesevenOneTwoCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypesevenOneTwoCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-show=showAdditionalSubjectRow> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypesevenOneTwoCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypesevenOneTwoCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypesevenOneTwoCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypesevenOneTwoCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}.subjects_tr{text-align:center!important}#table-example-1,table,table.sheet0{border-collapse:collapse!important}#table-example-1,.table-wrap{border:2px solid #000!important}#table-example-1 td,#table-example-1 th,table.sheet0 td,table.sheet0 th{border:1px solid #000!important;font-family:Arial,Helvetica,sans-serif!important;font-size:12px!important;padding:5px 3px!important}</style> <table style=\"border-top:solid 1px\" border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1> <td class=\"column0 style5 s style9\" colspan=2 rowspan=2>Subject</td> <td class=\"column2 style7 s style9\" colspan=7>Term I </td> <td class=\"column8 style10 s style9\" colspan=7>Term II </td> <td class=\"column8 style10 s style9\" colspan=8 ng-if=\"publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\" style=background-color:#ffe699;font-weight:700>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> <td class=\"column8 style10 s style9\" colspan=8 ng-if=\"publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Final</td> </tr> <tr class=row2> <td class=\"column2 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column6 style15 s style9\" colspan=3>Grade</td> <td class=\"column8 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=3>Grade</td> <td class=\"column8 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=5>Grade</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeThirtyKbEightNineCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style17 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2> {{ (publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' || publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>{{ (publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' || publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeThirtyKbEightNineCtrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.grade_2}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>100</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.specificfinalScore}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=5>{{subjectResult.specificfinalGr}}</td> </tr> <tr> <td colspan=25 style=\"border:1px solid #000;height:25px;background-color:#fff;border-collapse:separate\"> </td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=2 rowspan=2>Subjects</td> <td class=\"column2 style21 s style9\" colspan=6>Term I</td> <td class=\"column8 style21 s style9\" colspan=6>Term II</td> <td class=\"column14 style22 s style9\" colspan=2>Term III</td> <td class=\"column8 style21 s style9\" colspan=9>Final</td> </tr> <tr class=row5> <td class=\"column2 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style23 s style9\" colspan=2>Mark Obt</td> <td class=\"column6 style23 s style9\" colspan=2>Grade</td> <td class=\"column8 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style23 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style23 s style9\" colspan=2>Grade</td> <td class=\"column14 style24 s\">Max Marks</td> <td class=\"column15 style24 s\">Mark Obt</td> <td class=\"column16 style25 s\">TE</td> <td class=\"column16 style25 s\" colspan=2>CE</td> <td class=\"column17 style26 s\" colspan=4>Total</td> <td class=\"column18 style27 s\" colspan=2>Grade</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedTypeThirtyKbEightNineCtrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=2 style=font-weight:unset>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_2}}</td> <td class=\"column14 style19 null subjects_tr\">{{subjectResult.max_mark3}}</td> <td class=\"column15 style19 null subjects_tr\">{{subjectResult.term3_3}}</td> <td class=\"column16 style19 null subjects_tr\">{{subjectResult.term3_3}}</td> <td class=\"column16 style19 null subjects_tr\" colspan=2>{{subjectResult.ce_3}}</td> <td class=\"column17 style19 null subjects_tr\" colspan=4>{{subjectResult.total_mark_3}}</td> <td class=\"column18 style19 null subjects_tr\" colspan=2>{{subjectResult.grade_3}}</td> </tr> <tr> <td class=\"column0 style28 s style9\" colspan=2><b>Co-Scholastic</b></td> <td class=\"column2 style21 s style9\" colspan=6 style=text-align:center><b>Grade</b></td> <td class=\"column8 style21 s style9\" colspan=6 style=text-align:center><b>Grade</b></td> <td class=\"column14 style22 s style9\" colspan=5 style=text-align:center><b>Grade</b></td> <td class=\"column17 style19 null subjects_tr\" colspan=6></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThirtyKbEightNineCtrl.reportCardArray.other_sections\"> <td class=\"column0 style28 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=6>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=6>{{subjectResult.grade_2}}</td> <td class=\"column14 style19 null subjects_tr\" colspan=5>{{subjectResult.grade_3}}</td> <td class=\"column17 style19 null subjects_tr\" colspan=6></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeThirtyKbEightNineCtrl.reportCardArray.discipline\"> <td class=\"column0 style28 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=6>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=6>{{subjectResult.grade_2}}</td> <td class=\"column14 style19 null subjects_tr\" colspan=5>{{subjectResult.grade_3}}</td> <td class=\"column17 style19 null subjects_tr\" colspan=6></td> </tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=2>Result</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style7 s style9\" colspan=11>Attendance</td> </tr> <tr class=row8> <td class=\"column0 style17 s style9\" colspan=2>Promoted to Grade</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style30 s style9\" colspan=3 rowspan=2>Term I</td> <td class=\"column16 style30 s style9\" colspan=5 rowspan=2>Term II</td> <td class=\"column18 style31 s style9\" colspan=3 rowspan=2>Term III</td> </tr> <tr class=row9> <td class=\"column0 style18 null style3\" colspan=2></td> <td class=\"column2 style18 null style3\" colspan=4></td> <td class=\"column6 style18 null style3\" colspan=4></td> <td class=\"column10 style18 null style3\" colspan=4></td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=2>Class Teacher </td> <td class=\"column2 style33 s style9\" colspan=4>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=4>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4>Principal</td> <td class=\"column14 style18 null style3\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column16 style18 null style3\" colspan=5> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column18 style19 null\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendanceKb89_term3}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendanceKb89_term3 style=width:50px;margin-top:6px;margin-bottom:6px;margin-left:10px;margin-right:10px></td>  </tr> <tr class=row11> <td class=\"column0 style34 s\" colspan=2>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column14 style7 s style9\" colspan=11>School Seal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=14>Instructions:</td> <td class=\"column14 style19 null\" colspan=11 rowspan=10></td> </tr> <tr class=row13> <td class=\"column0 style36 s style9\" colspan=2>Grade</td> <td class=\"column2 style37 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style38 null style9\" colspan=9 rowspan=9></td> </tr> <tr class=row14> <td class=\"column0 style36 s style9\" colspan=2>A+</td> <td class=\"column2 style37 s style9\" colspan=3>90-100</td> </tr> <tr class=row15> <td class=\"column0 style36 s style9\" colspan=2>A</td> <td class=\"column2 style37 s style9\" colspan=3>80-89</td> </tr> <tr class=row16> <td class=\"column0 style36 s style9\" colspan=2>B+</td> <td class=\"column2 style37 s style9\" colspan=3>70-79</td> </tr> <tr class=row17> <td class=\"column0 style36 s style9\" colspan=2>B</td> <td class=\"column2 style37 s style9\" colspan=3>60-69</td> </tr> <tr class=row18> <td class=\"column0 style36 s style9\" colspan=2>C+</td> <td class=\"column2 style37 s style9\" colspan=3>50-59</td> </tr> <tr class=row19> <td class=\"column0 style36 s style9\" colspan=2>C</td> <td class=\"column2 style37 s style9\" colspan=3>40-49</td> </tr> <tr class=row20> <td class=\"column0 style36 s style9\" colspan=2>D+</td> <td class=\"column2 style37 s style9\" colspan=3>30-39</td> </tr> <tr class=row21> <td class=\"column0 style36 s style9\" colspan=2>D </td> <td class=\"column2 style37 s style9\" colspan=3>&lt;30</td> </tr> </tbody> </colgroup></table>";

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{padding-left:3px;text-align:left;vertical-align:middle;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{padding-left:3px;text-align:left;vertical-align:middle;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{text-align:center;vertical-align:middle;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{padding-left:3px;text-align:left;vertical-align:middle;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{padding-left:3px;text-align:left;vertical-align:middle;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}table.sheet0 tr{height:15.75pt}.subjects_tr{text-align:center!important}</style> <table style=\"border:solid 4px;width:97%;margin-left:20px\" border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1> <td class=\"column0 style5 s style9\" colspan=2 rowspan=2><strong>Subject</strong> </td> <td class=\"column8 style10 s style9\" colspan=7>Term I </td> <td class=\"column8 style10 s style9\" colspan=7>Term II </td> <td class=\"column8 style10 s style9\" colspan=2 rowspan=2>Total(100)</td> <td class=\"column8 style10 s style9\" colspan=3 rowspan=2>Grade</td> </tr> <tr class=row2> <td class=\"column2 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column6 style15 s style9\" colspan=3>Grade</td> <td class=\"column8 style15 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=3>Grade</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbTenCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style17 s style9\" colspan=2>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2> {{ (publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' || publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>{{ (publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' || publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeTenKbTenCtrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.grade_2}}</td> <td class=\"column10 style18 null style3 subjects_tr ng-binding\" colspan=2>{{subjectResult.aggregate_avg_total}}</td> <td class=\"column12 style18 null style3 subjects_tr ng-binding\" colspan=3>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td colspan=25 style=\"border:1px solid #000;height:25px;background-color:#fff;border-collapse:separate\"> </td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=6 rowspan=2>Subjects</td> <td class=\"column2 style21 s style9\" colspan=7>Term I</td> <td class=\"column8 style21 s style9\" colspan=12>Term II</td> </tr> <tr class=row5> <td class=\"column2 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column4 style23 s style9\" colspan=3>Mark Obt</td> <td class=\"column6 style23 s style9\" colspan=2>Grade</td> <td class=\"column8 style23 s style9\" colspan=2>Max Marks</td> <td class=\"column10 style23 s style9\" colspan=3>Mark Obt</td> <td class=\"column12 style23 s style9\" colspan=7>Grade</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbTenCtrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=6 style=font-weight:unset>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.total_mark_1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.grade_1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=3>{{subjectResult.total_mark_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=7>{{subjectResult.grade_2}}</td> </tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=6>Result</td> <td class=\"column2 style18 null style3\" colspan=9> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=10>Attendance</td> </tr> <tr class=row9> <td class=\"column0 style18 null style3\" colspan=3></td> <td class=\"column2 style18 null style3\" colspan=3></td> <td class=\"column6 style18 null style3\" colspan=5></td> <td class=\"column10 style18 null style3\" colspan=4></td> <td class=\"column6 style18 null style3\" style=text-align:center colspan=2>Term I</td> <td class=\"column10 style18 null style3\" style=text-align:center colspan=8>Term II</td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=3>Class Teacher </td> <td class=\"column2 style33 s style9\" colspan=3>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=5>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4>Principal</td> <td class=\"column14 style18 null style3\" colspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column14 style18 null style3\" colspan=8> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr class=row11> <td class=\"column0 style34 s\" colspan=3>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column2 style27 null\" colspan=3></td> <td class=\"column2 style27 null\" colspan=5></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column0 style35 s style9\" colspan=11>School Seal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=15>Instructions:</td> <td class=\"column14 style19 null\" colspan=11 rowspan=10></td> </tr> <tr class=row13> <td class=\"column0 style36 s style9\" colspan=3>Grade</td> <td class=\"column2 style37 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style38 null style9\" colspan=9 rowspan=9></td> </tr> <tr class=row14> <td class=\"column0 style36 s style9\" colspan=3>A+</td> <td class=\"column2 style37 s style9\" colspan=3>90-100</td> </tr> <tr class=row15> <td class=\"column0 style36 s style9\" colspan=3>A</td> <td class=\"column2 style37 s style9\" colspan=3>80-89</td> </tr> <tr class=row16> <td class=\"column0 style36 s style9\" colspan=3>B+</td> <td class=\"column2 style37 s style9\" colspan=3>70-79</td> </tr> <tr class=row17> <td class=\"column0 style36 s style9\" colspan=3>B</td> <td class=\"column2 style37 s style9\" colspan=3>60-69</td> </tr> <tr class=row18> <td class=\"column0 style36 s style9\" colspan=3>C+</td> <td class=\"column2 style37 s style9\" colspan=3>50-59</td> </tr> <tr class=row19> <td class=\"column0 style36 s style9\" colspan=3>C</td> <td class=\"column2 style37 s style9\" colspan=3>40-49</td> </tr> <tr class=row20> <td class=\"column0 style36 s style9\" colspan=3>D+</td> <td class=\"column2 style37 s style9\" colspan=3>30-39</td> </tr> <tr class=row21> <td class=\"column0 style36 s style9\" colspan=3>D </td> <td class=\"column2 style37 s style9\" colspan=3>&lt;=29</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;white-space:normal!important;font-size:12px}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}table.sheet0 tr{height:15.75pt}.subjects_tr{text-align:center!important}#mySpan{text-align:center;writing-mode:vertical-lr;transform:rotate(180deg)}.align_text{text-align:center}</style> <table id=table-example-1 style=width:97.5%;margin-left:20px border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1 ng-if=\"publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style35 s style9\" colspan=9 style=text-align:center;font-weight:700>SUBJECT</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=4 style=text-align:center;font-weight:700>Maximum Marks</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=4 style=text-align:center;font-weight:700>Mark Obtained</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveCtrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=9 height=30>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=30 colspan=4 style=text-align:center>100</td> <td class=\"column4 style18 null style3 subjects_tr\" height=30 colspan=4 style=text-align:center>{{subjectResult.term1}}</td> <td class=\"column10 style18 null style3 subjects_tr ng-binding\" height=30 colspan=2 style=text-align:center>{{subjectResult.total_score}}</td> </tr> <tr class=row1 ng-if=\"publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style35 s style9\" colspan=9 style=text-align:center;font-weight:700>SUBJECT</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=4 style=text-align:center;font-weight:700>Maximum Marks</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=4 style=text-align:center;font-weight:700>Mark Obtained</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Overall Score</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveCtrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=9 height=30>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=30 colspan=4 style=text-align:center>{{ (publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeTenKbElevenTwelveCtrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column4 style18 null style3 subjects_tr\" height=30 colspan=4 style=text-align:center>{{subjectResult.term1}}</td> <td class=\"column10 style18 null style3 subjects_tr ng-binding\" height=30 colspan=2 style=text-align:center>{{subjectResult.total_score}}</td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=9 rowspan=2>Subjects</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan><strong>Unit Test I </strong> </td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>(Half Yearly) Term I </strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>Unit Test II</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>MODEL</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 rowspan=2 id=mySpan> <strong>Grade</strong></td> </tr> <tr class=row5> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveCtrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=9 style=font-weight:unset height=35><strong>{{subject}}</strong> </td> <td class=\"column2 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data_2.unit_test.max_mark}}</td> <td class=\"column4 style18 null style3 subjects_tr\" height=35>{{subjectResult.unit_test}}</td> <td class=\"column6 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data_2.half_yearly.max_mark}}</td> <td class=\"column8 style18 null style3 subjects_tr\" height=35>{{subjectResult.half_yearly}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data.unit_test_2.max_mark}}</td> <td class=\"column4 style18 null style3 subjects_tr\" height=35>{{subjectResult.unit_test_2}}</td> <td class=\"column6 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data.model_2.max_mark}}</td> <td class=\"column8 style18 null style3 subjects_tr\" height=35>{{subjectResult.model_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" height=35 colspan=2>{{subjectResult.model_grade}}</td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9><strong>Co-Scholastic</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=10><strong>Grade</strong></td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Discipline</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveCtrl.reportCardArray.discipline\">{{subjectResult.grade_1}}</span> </td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Health &amp;Physical Education</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveCtrl.reportCardArray.other_sections\">{{subjectResult.grade_1}}</span> </td> </tr> <tr><td class=\"column2 style18 null style3\" colspan=19 height=20></td></tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Attendance</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:120px;margin-top:4px;margin-bottom:4px;margin-left:7px> </td> </tr> <tr><td class=\"column2 style18 null style3\" colspan=19 height=20></td></tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=9>Result</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row8> <td class=\"column0 style17 s style9\" colspan=9>Promoted to Grade</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row11> <td class=\"column0 style17 s style9\" colspan=19>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=5 style=text-align:center>Class teacher</td> <td class=\"column2 style33 s style9\" colspan=5 style=text-align:center>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=5 style=text-align:center>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4 style=text-align:center>Principal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=10 style=text-align:center>Instructions:</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=9 rowspan=11>School Seal</td> </tr> <tr class=row13> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5 style=text-align:center;font-weight:700>Grade</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5 style=text-align:center;font-weight:700>Grade %</td> </tr> <tr class=row14> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>A+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>90-100</td> </tr> <tr class=row15> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>A</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>80-89</td> </tr> <tr class=row16> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>B+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>70-79</td> </tr> <tr class=row17> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>B</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>60-69</td> </tr> <tr class=row18> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>C+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>50-59</td> </tr> <tr class=row19> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>C</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>40-49</td> </tr> <tr class=row20> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>D+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>30-39</td> </tr> <tr class=row21> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>E</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>&lt;30</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports = " <style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;white-space:normal!important;font-size:12px}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}table.sheet0 tr{height:15.75pt}.subjects_tr{text-align:center!important}#mySpan{text-align:center;writing-mode:vertical-lr;transform:rotate(180deg)}.align_text{text-align:center}</style> <table id=table-example-1 style=width:97.5%;margin-left:20px border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1 ng-if=\"publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style35 s style9\" colspan=9 style=text-align:center;font-weight:700>SUBJECT</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Maximum Marks</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Mark Obtained</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=6 style=text-align:center;font-weight:700;background-color:#ffe699!important>Overall score [Avg [Term1 ,Term2]- Ministry subjects</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=9 height=30>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=30 colspan=2 style=text-align:center>100</td> <td class=\"column4 style18 null style3 subjects_tr\" height=30 colspan=2 style=text-align:center>{{subjectResult.term2 || subjectResult.term1 || subjectResult.total_mark_2 || subjectResult.total_mark_1 || subjectResult.total_mark}}</td> <td class=\"column10 style18 null style3 subjects_tr ng-binding\" height=30 colspan=6 style=text-align:center>{{ (subjectResult.term1 && subjectResult.term2) ? (((1 * subjectResult.term1) + (1 * subjectResult.term2)) / 2) : (subjectResult.total_score || subjectResult.term2 || subjectResult.term1 || '-') }}</td> </tr> <tr class=row1 ng-if=\"publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style35 s style9\" colspan=9 style=text-align:center;font-weight:700>SUBJECT</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Maximum Marks</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Mark Obtained</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center;font-weight:700>Grade</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=4 style=text-align:center;font-weight:700>Mark Obtained 100 TERM I + Term II</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=9 height=30>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=30 colspan=2 style=text-align:center>{{ (publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? 100 : 50 }} </td> <td class=\"column4 style18 null style3 subjects_tr\" height=30 colspan=2 style=text-align:center>{{subjectResult.term1 || subjectResult.term2 || subjectResult.total_mark_1 || subjectResult.total_mark_2 || subjectResult.total_mark}}</td> <td class=\"column4 style18 null style3 subjects_tr\" height=30 colspan=2 style=text-align:center>{{subjectResult.grade_1 || subjectResult.grade_2 || subjectResult.grade || subjectResult.aggregate_avg_grade}}</td> <td class=\"column10 style18 null style3 subjects_tr ng-binding\" height=30 colspan=4 style=text-align:center>{{(subjectResult.total_score && (subjectResult.total_score+'').trim() != '' && (subjectResult.total_score+'').trim() != 'NA') ? subjectResult.total_score : ((publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == '2FwuqhgeoKt6SQiCG' || publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.header.school_id == 'apX7mQ9LsV2kZdFaH') ? (subjectResult.term1 || '-') : ((subjectResult.aggregate_avg_total && (subjectResult.aggregate_avg_total+'').trim() != '' && (subjectResult.aggregate_avg_total+'').trim() != 'NA') ? subjectResult.aggregate_avg_total : '-'))}}</td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=9 rowspan=2>Subjects</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan><strong>Unit Test I </strong> </td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>(Half Yearly) Term I </strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>Unit Test II</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 id=mySpan> <strong>MODEL</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 rowspan=2 id=mySpan> <strong>Grade</strong></td> </tr> <tr class=row5> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> <td class=\"column2 style18 null style3 subjects_tr\">Max Marks</td> <td class=\"column2 style18 null style3 subjects_tr\">Mark Obt</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=9 style=font-weight:unset height=35><strong>{{subject}}</strong> </td> <td class=\"column2 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data_2.unit_test.max_mark}}</td> <td class=\"column4 style18 null style3 subjects_tr\" height=35>{{subjectResult.unit_test}}</td> <td class=\"column6 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data_2.half_yearly.max_mark}}</td> <td class=\"column8 style18 null style3 subjects_tr\" height=35>{{subjectResult.half_yearly}}</td> <td class=\"column2 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data.unit_test_2.max_mark}}</td> <td class=\"column4 style18 null style3 subjects_tr\" height=35>{{subjectResult.unit_test_2}}</td> <td class=\"column6 style18 null style3 subjects_tr\" height=35>{{subjectResult.max_mark_data.model_2.max_mark}}</td> <td class=\"column8 style18 null style3 subjects_tr\" height=35>{{subjectResult.model_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" height=35 colspan=2>{{subjectResult.model_grade}}</td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9><strong>Co-Scholastic</strong></td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=10><strong>Grade</strong></td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Discipline</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.discipline\">{{subjectResult.grade_1 || subjectResult.grade_2 || subjectResult.grade}}</span> </td> </tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Health &amp;Physical Education</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-repeat=\"(subject, subjectResult) in publishedTypeTenKbElevenTwelveNew26Ctrl.reportCardArray.other_sections\">{{subjectResult.grade_1 || subjectResult.grade_2 || subjectResult.grade}}</span> </td> </tr> <tr><td class=\"column2 style18 null style3\" colspan=19 height=20></td></tr> <tr> <td class=\"column2 style18 null style3\" colspan=9>Attendance</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1 || $root.attendancetenKb10_term2 || $root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:120px;margin-top:4px;margin-bottom:4px;margin-left:7px> </td> </tr> <tr><td class=\"column2 style18 null style3\" colspan=19 height=20></td></tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=9>Result</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row8> <td class=\"column0 style17 s style9\" colspan=9>Promoted to Grade</td> <td class=\"column2 style18 null style3\" colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row11> <td class=\"column0 style17 s style9\" colspan=19>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=5 style=text-align:center>Class teacher</td> <td class=\"column2 style33 s style9\" colspan=5 style=text-align:center>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=5 style=text-align:center>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4 style=text-align:center>Principal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=10 style=text-align:center>Instructions:</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=9 rowspan=11>School Seal</td> </tr> <tr class=row13> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5 style=text-align:center;font-weight:700>Grade</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5 style=text-align:center;font-weight:700>Grade %</td> </tr> <tr class=row14> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>A+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>90-100</td> </tr> <tr class=row15> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>A</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>80-89</td> </tr> <tr class=row16> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>B+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>70-79</td> </tr> <tr class=row17> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>B</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>60-69</td> </tr> <tr class=row18> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>C+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>50-59</td> </tr> <tr class=row19> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>C</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>40-49</td> </tr> <tr class=row20> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>D+</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>30-39</td> </tr> <tr class=row21> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>E</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=5>&lt;30</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5> <td class=\"column0 style20 s style14\" colspan=2 style=vertical-align:middle;text-align:left rowspan=2>Subjects</td> <td class=\"column2 style22 s style9\" colspan=8>Term I </td> <td class=\"column10 style22 s style9\" colspan=8>Term II </td> <td class=\"column18 style23 s style17\" rowspan=2><span ng-if=publishedTypeElevenScienceCtrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!publishedTypeElevenScienceCtrl.reportCardArray.is_best_taking>Average of</span><br>Term1&Term2 (100)</td> <td class=\"column19 style24 s style14\" rowspan=2>Grade</td> </tr> <tr class=row6> <td class=\"column2 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column4 style27 s style9\" colspan=3>Mark Obt</td> <td class=\"column7 style26 s style9\" colspan=3 id=ash_box>Grade</td> <td class=\"column10 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column13 style27 s style9\" colspan=3>Mark Obt</td> <td class=\"column16 style26 s style9\" colspan=3 id=ash_box>Grade</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term1}}</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_1}}</td> <td class=\"column10 style28 null\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term2}}</td> <td class=\"column12 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term2}}</td> <td class=\"column14 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_2}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle>{{subjectResult.total_score}}</td> <td class=\"column17 style29 null\" style=vertical-align:middle>{{ subjectResult.total_score === 'NA' ? 'NA' : subjectResult.over_all_grade }}</td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=6 id=bold_font>TERM I</td> <td class=\"column8 style38 s style9\" colspan=10 id=bold_font>TERM II</td> <td class=\"column18 style39 s style11\" colspan=2 id=bold_font>Overall</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=2>Periodic Test 2</td> <td class=slanted-text colspan=2>Model Exam</td> <td class=slanted-text colspan=2>Annual Exam</td> <td class=slanted-text colspan=2>Project / Practical</td> <td class=slanted-text colspan=2 id=bold_font>Final Theory Marks </td> <td colspan=2 rowspan=2 id=bold_font style=vertical-align:middle>Grades (Final Theory)</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td id=bold_font>Max Marks</td> <td id=bold_font>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td class=\"column3 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test_1}}</td> <td class=\"column2 style29 null\" style=vertical-align:middle>{{subjectResult.periodic_test_1}}</td> <td class=\"column6 style29 null\" style=vertical-align:middle>{{ subjectResult.max_mark_data.pct_1 ? subjectResult.max_mark_data.pct_1 : 'NA' }}</td> <td class=\"column7 style29 null\" style=vertical-align:middle>{{ subjectResult.pct_1 !== undefined ? subjectResult.pct_1 : 'NA' }}</td> <td class=\"column10 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.half_yearly_1}}</td> <td class=\"column9 style29 null\" style=vertical-align:middle>{{subjectResult.half_yearly_1}}</td> <td class=\"column11 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test2_2}}</td> <td class=\"column3 style29 null\" style=vertical-align:middle>{{subjectResult.periodic_test2_2}}</td> <td class=\"column12 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.model_2}}</td> <td class=\"column4 style29 null\" style=vertical-align:middle>{{subjectResult.model_2}}</td> <td class=\"column13 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.ae_2}}</td> <td class=\"column5 style29 null\" style=vertical-align:middle>{{subjectResult.ae_2}}</td> <td class=\"column15 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.pp_2}}</td> <td class=\"column14 style30 null\" style=vertical-align:middle>{{subjectResult.pp_2}}</td> <td class=\"column8 style47 s\" style=vertical-align:middle>&nbsp;{{subjectResult.static_mark}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle>{{subjectResult.total_score}}</td> <td class=\"column17 style29 null\" colspan=2 style=vertical-align:middle>{{ subjectResult.total_score === 'NA' ? 'NA' : subjectResult.over_all_grade }}</td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=6 style=text-align:center id=bold_font>Co-Scholastic Term I </td> <td class=\"column6 style55 s style9\" colspan=3 style=text-align:center id=bold_font>Grade</td> <td class=\"column12 style55 s style9\" colspan=5 style=text-align:center id=bold_font>Co-Scholastic Term II</td> <td class=\"column18 style55 s style11\" colspan=6 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=6 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column6 style7 null style9\" colspan=3 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> <td class=\"column12 style56 s style9\" colspan=5 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column18 style7 null style11\" colspan=6 style=text-align:center;vertical-align:middle>{{subjectResult.grade_2}}</td> </tr> <tr class=row22> <td style=padding:12px colspan=20></td> </tr> </tbody> </colgroup></table> <tr class=row23> <td class=\"column0 style46 s style11\" colspan=20 id=bold_font> <span ng-if=scienceComment>*Practicals in Term 1 is conducted only for Physics, Chemistry, Biology, Computer Science &amp; Informatics Practices </span> <span ng-if=commerceComment>*Practicals in Term 1 is conducted only for Informatics Practices </span> </td> </tr> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row24 ng-if=publishedTypeElevenScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 rowspan=2 style=text-align:right id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row24 ng-if=!publishedTypeElevenScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 rowspan=1 style=text-align:right id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row25 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.discipline\"> <td class=\"column2 style7 null style9\" colspan=12>{{subjectResult.grade_1}}</td> <td class=\"column12 style7 null style9\" colspan=9>{{subjectResult.grade_2}}</td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.term_remarks1 style=width:70%> </td> <td class=\"column18 style61 s style9\" colspan=2 id=bold_font>Attendance</td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to style=width:100%> </td> <td class=\"column18 style62 s\">TERM I</td> <td class=\"column19 style62 s\">TERM II</td> </tr> <tr class=row28> <td style=padding:25px colspan=2></td> <td class=\"column2 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column8 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column14 style7 null style9\" colspan=4 id=ash_box></td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:left>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=6 id=ash_box>Supervisor</td> <td class=\"column8 style64 s style9\" colspan=6 id=ash_box>Head of Section</td> <td class=\"column14 style64 s style9\" colspan=4 id=ash_box>Principal</td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=18>{{publishedTypeElevenScienceCtrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row31> <td class=\"column0 style66 s style11\" colspan=18>Instructions:</td> <td class=\"column18 style67 s style21\" colspan=2><b>School Seal</b> </td> </tr> <tr class=row32> <td class=\"column0 style12 s style11\" style=text-align:left colspan=18>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr class=row33> <td class=\"column0 style69 s style11\" colspan=2>Grades</td> <td class=\"column2 style70 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style0 null style0\" colspan=13 rowspan=9></td> </tr> <tr class=row34> <td class=\"column0 style69 s style11\" colspan=2>A1</td> <td class=\"column2 style70 s style9\" colspan=3>91-100</td> </tr> <tr class=row35> <td class=\"column0 style69 s style11\" colspan=2>A2</td> <td class=\"column2 style70 s style9\" colspan=3>81-90</td> </tr> <tr class=row36> <td class=\"column0 style69 s style11\" colspan=2>B1</td> <td class=\"column2 style70 s style9\" colspan=3>71-80</td> </tr> <tr class=row37> <td class=\"column0 style69 s style11\" colspan=2>B2</td> <td class=\"column2 style70 s style9\" colspan=3>61-70</td> </tr> <tr class=row38> <td class=\"column0 style69 s style11\" colspan=2>C1</td> <td class=\"column2 style70 s style9\" colspan=3>51-60</td> </tr> <tr class=row39> <td class=\"column0 style69 s style11\" colspan=2>C2</td> <td class=\"column2 style70 s style9\" colspan=3>41-50</td> </tr> <tr class=row40> <td class=\"column0 style69 s style11\" colspan=2>D</td> <td class=\"column2 style70 s style9\" colspan=3>33-40</td> </tr> <tr class=row41> <td class=\"column0 style71 s style14\" colspan=2>E (Failed)</td> <td class=\"column2 style72 s style17\" colspan=3>&lt;=32</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5> <td class=\"column0 style20 s style14\" colspan=2 style=vertical-align:middle;text-align:left rowspan=2>Subjects</td> <td class=\"column2 style22 s style9\" colspan=8>Term I </td> <td class=\"column10 style22 s style9\" colspan=8>Term II </td> <td class=\"column18 style23 s style17\" rowspan=2 style=text-align:center> <span ng-if=\"publishedTypeElevenScienceCtrl.reportCardArray.header.school_id === 'm2LMtqaESFZf6xDE8'\"> Final<br>Mark </span> <span ng-if=\"publishedTypeElevenScienceCtrl.reportCardArray.header.school_id !== 'm2LMtqaESFZf6xDE8' \n                     && publishedTypeElevenScienceCtrl.reportCardArray.is_best_taking\"> Best of<br>Term1 & Term2 (100) </span> <span ng-if=\"publishedTypeElevenScienceCtrl.reportCardArray.header.school_id !== 'm2LMtqaESFZf6xDE8' \n                     && !publishedTypeElevenScienceCtrl.reportCardArray.is_best_taking\"> Average of<br>Term1 & Term2 (100) </span> </td> <td class=\"column19 style24 s style14\" rowspan=2>Grade</td> </tr> <tr class=row6> <td class=\"column2 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column4 style27 s style9\" colspan=3>Mark Obt</td> <td class=\"column7 style26 s style9\" colspan=3 id=ash_box>Grade</td> <td class=\"column10 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column13 style27 s style9\" colspan=3>Mark Obt</td> <td class=\"column16 style26 s style9\" colspan=3 id=ash_box>Grade</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term1}}</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_1}}</td> <td class=\"column10 style28 null\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term2}}</td> <td class=\"column12 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term2}}</td> <td class=\"column14 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_2}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle>{{subjectResult.total_score}}</td> <td class=\"column17 style29 null\" style=vertical-align:middle>{{ subjectResult.total_score === 'NA' ? 'NA' : subjectResult.over_all_grade }}</td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=6 id=bold_font>TERM I</td> <td class=\"column8 style38 s style9\" colspan=8 id=bold_font>TERM II</td> <td class=\"column18 style39 s style11\" colspan=4 id=bold_font>Overall</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=2>Periodic Test 2</td> <td class=slanted-text colspan=2>Annual Exam</td> <td class=slanted-text colspan=2>Project / Practical</td> <td class=slanted-text colspan=2 id=bold_font>Final Theory Marks </td> <td colspan=4 rowspan=2 id=bold_font style=vertical-align:middle>Grades (Final Theory)</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td id=bold_font>Max Marks</td> <td id=bold_font>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td class=\"column3 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test_1}}</td> <td class=\"column2 style29 null\" style=vertical-align:middle>{{subjectResult.periodic_test_1}}</td> <td class=\"column6 style29 null\" style=vertical-align:middle>{{ subjectResult.max_mark_data.pct_1 ? subjectResult.max_mark_data.pct_1 : 'NA' }}</td> <td class=\"column7 style29 null\" style=vertical-align:middle>{{ subjectResult.pct_1 !== undefined ? subjectResult.pct_1 : 'NA' }}</td> <td class=\"column10 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.half_yearly_1}}</td> <td class=\"column9 style29 null\" style=vertical-align:middle>{{subjectResult.half_yearly_1}}</td> <td class=\"column11 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test2_2}}</td> <td class=\"column3 style29 null\" style=vertical-align:middle>{{subjectResult.periodic_test2_2}}</td> <td class=\"column13 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.ae_2}}</td> <td class=\"column5 style29 null\" style=vertical-align:middle>{{subjectResult.ae_2}}</td> <td class=\"column15 style29 null\" style=vertical-align:middle>{{subjectResult.max_mark_data.pp_2}}</td> <td class=\"column14 style30 null\" style=vertical-align:middle>{{subjectResult.pp_2}}</td> <td ng-if=TCS_SCHOOL class=\"column8 style47 s\"> &nbsp;{{subjectResult.max_mark_data.ae_2}} </td> <td ng-if=TCS_SCHOOL class=\"column16 style47 null\"> {{subjectResult.ae_2}} </td> <td ng-if=!TCS_SCHOOL class=\"column8 style47 s\"> &nbsp;{{subjectResult.static_mark}} </td> <td ng-if=!TCS_SCHOOL class=\"column16 style47 null\"> {{subjectResult.total_score}} </td> <td class=\"column17 style29 null\" colspan=4 style=vertical-align:middle> {{ TCS_SCHOOL ? (subjectResult.ae_2 !== null && subjectResult.ae_2 !== undefined ? subjectResult.over_all_grade : '') : (subjectResult.total_score === 'NA' ? 'NA' : subjectResult.over_all_grade) }} </td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=6 style=text-align:center id=bold_font>Co-Scholastic Term I </td> <td class=\"column6 style55 s style9\" colspan=3 style=text-align:center id=bold_font>Grade</td> <td class=\"column12 style55 s style9\" colspan=5 style=text-align:center id=bold_font>Co-Scholastic Term II</td> <td class=\"column18 style55 s style11\" colspan=6 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=6 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column6 style7 null style9\" colspan=3 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> <td class=\"column12 style56 s style9\" colspan=5 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column18 style7 null style11\" colspan=6 style=text-align:center;vertical-align:middle>{{subjectResult.grade_2}}</td> </tr> <tr class=row22> <td style=padding:12px colspan=20></td> </tr> </tbody> </colgroup></table> <tr class=row23> <td class=\"column0 style46 s style11\" colspan=20 id=bold_font> <span ng-if=scienceComment>*Practicals in Term 1 is conducted only for Physics, Chemistry, Biology, Computer Science &amp; Informatics Practices </span> <span ng-if=commerceComment>*Practicals in Term 1 is conducted only for Informatics Practices </span> </td> </tr> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row24 ng-if=publishedTypeElevenScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 rowspan=2 style=text-align:right id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row24 ng-if=!publishedTypeElevenScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 rowspan=1 style=text-align:right id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row25 ng-repeat=\"(subject, subjectResult) in publishedTypeElevenScienceCtrl.reportCardArray.discipline\"> <td class=\"column2 style7 null style9\" colspan=12>{{subjectResult.grade_1}}</td> <td class=\"column12 style7 null style9\" colspan=9>{{subjectResult.grade_2}}</td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.term_remarks1 style=width:70%> </td> <td class=\"column18 style61 s style9\" colspan=2 id=bold_font>Attendance</td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to style=width:100%> </td> <td class=\"column18 style62 s\">TERM I</td> <td class=\"column19 style62 s\">TERM II</td> </tr> <tr class=row28> <td style=padding:25px colspan=2></td> <td class=\"column2 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column8 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column14 style7 null style9\" colspan=4 id=ash_box></td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:left>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=6 id=ash_box>Supervisor</td> <td class=\"column8 style64 s style9\" colspan=6 id=ash_box>Head of Section</td> <td class=\"column14 style64 s style9\" colspan=4 id=ash_box>Principal</td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=18>{{publishedTypeElevenScienceCtrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row31> <td class=\"column0 style66 s style11\" colspan=18>Instructions:</td> <td class=\"column18 style67 s style21\" colspan=2><b>School Seal</b> </td> </tr> <tr class=row32> <td class=\"column0 style12 s style11\" style=text-align:left colspan=18>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr class=row33> <td class=\"column0 style69 s style11\" colspan=2>Grades</td> <td class=\"column2 style70 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style0 null style0\" colspan=13 rowspan=9></td> </tr> <tr class=row34> <td class=\"column0 style69 s style11\" colspan=2>A1</td> <td class=\"column2 style70 s style9\" colspan=3>91-100</td> </tr> <tr class=row35> <td class=\"column0 style69 s style11\" colspan=2>A2</td> <td class=\"column2 style70 s style9\" colspan=3>81-90</td> </tr> <tr class=row36> <td class=\"column0 style69 s style11\" colspan=2>B1</td> <td class=\"column2 style70 s style9\" colspan=3>71-80</td> </tr> <tr class=row37> <td class=\"column0 style69 s style11\" colspan=2>B2</td> <td class=\"column2 style70 s style9\" colspan=3>61-70</td> </tr> <tr class=row38> <td class=\"column0 style69 s style11\" colspan=2>C1</td> <td class=\"column2 style70 s style9\" colspan=3>51-60</td> </tr> <tr class=row39> <td class=\"column0 style69 s style11\" colspan=2>C2</td> <td class=\"column2 style70 s style9\" colspan=3>41-50</td> </tr> <tr class=row40> <td class=\"column0 style69 s style11\" colspan=2>D</td> <td class=\"column2 style70 s style9\" colspan=3>33-40</td> </tr> <tr class=row41> <td class=\"column0 style71 s style14\" colspan=2>E (Failed)</td> <td class=\"column2 style72 s style17\" colspan=3>&lt;=32</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5> <td class=\"column0 style20 s style14\" colspan=2 style=vertical-align:middle;text-align:left rowspan=2>Subjects</td> <td class=\"column2 style22 s style9\" colspan=6>Term I </td> <td class=\"column10 style22 s style9\" colspan=6>Term II </td> <td class=\"column10 style22 s style9\" colspan=6>Overall</td> </tr> <tr class=row6> <td class=\"column2 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column4 style27 s style9\" colspan=2>Mark Obt</td> <td class=\"column7 style26 s style9\" colspan=2 id=ash_box>Grade</td> <td class=\"column10 style26 s style9\" colspan=2 id=ash_box>Max Marks</td> <td class=\"column13 style27 s style9\" colspan=2>Mark Obt</td> <td class=\"column16 style26 s style9\" colspan=2 id=ash_box>Grade</td> <td class=\"column18 style23 s style17\" colspan=3><span ng-if=publishedTypeTwelveScienceCtrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!publishedTypeTwelveScienceCtrl.reportCardArray.is_best_taking>Average of</span><br>Term1&Term2 (100)</td> <td class=\"column19 style24 s style14\" colspan=3>Final Grade</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveScienceCtrl.reportCardArray.specific_subjects\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term1}}</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.term1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.grade_1}}</td> <td class=\"column10 style28 null\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data.term2}}</td> <td class=\"column12 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.term2}}</td> <td class=\"column14 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.grade_2}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle colspan=3>{{subjectResult.total_score}}</td> <td class=\"column17 style29 null\" style=vertical-align:middle colspan=3>{{ subjectResult.total_score === 'NA' ? 'NA' : subjectResult.over_all_grade }}</td> </tr> <tr> <td colspan=2 rowspan=4 style=vertical-align:middle;text-align:left><b>Scholastic Area</b></td> <td colspan=6><b>TERM I</b></td> <td colspan=13><b>TERM II</b></td> </tr> <tr> <td colspan=2 rowspan=2 class=slanted-text>Periodic Test I</td> <td colspan=2 rowspan=2 class=slanted-text> Practical</td> <td colspan=2 rowspan=2 class=slanted-text>Half Yearly</td> <td colspan=2 rowspan=2 class=slanted-text>Periodic Test 2</td> <td colspan=12 valign=middle><b>Model</b></td> </tr> <tr> <td colspan=2 class=slanted-text>Theory</td> <td colspan=2 class=slanted-text>Project / Practical</td> <td colspan=6 rowspan=2 style=vertical-align:middle><b>Grade(Theory)</b></td> </tr> <tr> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveScienceCtrl.reportCardArray.main_results\"> <td colspan=2 style=text-align:left;vertical-align:middle><b>{{subject}}</b></td> <td style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test_1}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test_1}}</td> <td style=vertical-align:middle>{{ subjectResult.max_mark_data.pct_1 ? subjectResult.max_mark_data.pct_1 : 'NA' }}</td> <td style=vertical-align:middle>{{ subjectResult.pct_1 !== undefined ? subjectResult.pct_1 : 'NA' }}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data.half_yearly_1}}</td> <td style=vertical-align:middle>{{subjectResult.half_yearly_1}}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data.periodic_test2_2}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test2_2}}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data.theory_2}}</td> <td style=vertical-align:middle>{{subjectResult.theory_2}}</td> <td style=vertical-align:middle>{{ subjectResult.max_mark_data.pp_2 ? subjectResult.max_mark_data.pp_2 : 'NA' }}</td> <td style=vertical-align:middle>{{ subjectResult.pp_2 !== undefined ? subjectResult.pp_2 : 'NA' }}</td> <td style=vertical-align:middle colspan=6>{{subjectResult.over_all_grade}}</td> </tr> <tr> </tr><tr class=row19> <td class=\"column0 style54 s style11\" colspan=6 style=text-align:center id=bold_font>Co-Scholastic Term I</td> <td class=\"column6 style55 s style9\" colspan=3 style=text-align:center id=bold_font>Grade</td> <td class=\"column12 style55 s style9\" colspan=5 style=text-align:center id=bold_font>Co-Scholastic Term II</td> <td class=\"column18 style55 s style11\" colspan=6 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveScienceCtrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=6 style=text-align:left id=bold_font>{{subject}}</td> <td class=\"column6 style7 null style9\" colspan=3 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=\"column12 style56 s style9\" colspan=5 style=text-align:left id=bold_font>{{subject}}</td> <td class=\"column18 style7 null style11\" colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr class=row22> <td style=padding:12px colspan=20></td> </tr> </tbody> </colgroup></table> <tr class=row23> <td class=\"column0 style46 s style11\" colspan=20 id=bold_font> <span ng-if=scienceComment>*Practicals in Term 1 is conducted only for Physics, Chemistry, Biology, Computer Science &amp; Informatics Practices </span> <span ng-if=commerceComment>*Practicals in Term 1 is conducted only for Informatics Practices </span> </td> </tr> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row24 ng-if=publishedTypeTwelveScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 rowspan=2 style=text-align:right id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row24 ng-if=!publishedTypeTwelveScienceCtrl.reportCardArray.discipline.Discipline.grade_1> <td class=\"column0 style58 s style9\" colspan=2 style=text-align:right rowspan=1 id=bold_font>Discipline</td> <td class=\"column2 style10 s style9\" colspan=12 id=bold_font>Term I Grade</td> <td class=\"column12 style10 s style9\" colspan=9 id=bold_font>&nbsp;Term II Grade </td> </tr> <tr class=row25 ng-repeat=\"(subject, subjectResult) in publishedTypeTwelveScienceCtrl.reportCardArray.discipline\"> <td class=\"column2 style7 null style9\" colspan=12>{{subjectResult.grade_1}}</td> <td class=\"column12 style7 null style9\" colspan=9>{{subjectResult.grade_2}}</td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:left>Result</td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.term_remarks1 style=width:100%> </td> <td class=\"column18 style61 s style9\" colspan=2 id=bold_font>Attendance</td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=16 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.promoted_to style=width:100%> </td> <td class=\"column18 style62 s\">TERM I</td> <td class=\"column19 style62 s\">TERM II</td> </tr> <tr class=row28> <td style=padding:25px colspan=2></td> <td class=\"column2 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column8 style7 null style9\" colspan=6 id=ash_box></td> <td class=\"column14 style7 null style9\" colspan=4 id=ash_box></td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> <td class=\"column18 style63 null style9\" rowspan=2> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:left>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=6 id=ash_box>Supervisor</td> <td class=\"column8 style64 s style9\" colspan=6 id=ash_box>Head of Section</td> <td class=\"column14 style64 s style9\" colspan=4 id=ash_box>Principal</td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=18>{{publishedTypeTwelveScienceCtrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row31> <td class=\"column0 style66 s style11\" colspan=18>Instructions:</td> <td class=\"column18 style67 s style21\" colspan=2><b>School Seal</b></td> </tr> <tr class=row32> <td class=\"column0 style12 s style11\" style=text-align:left colspan=18>Grading Scale for Scholastic Areas : Grades are awarded on a 8 point grading scale as follows:</td> </tr> <tr class=row33> <td class=\"column0 style69 s style11\" colspan=2>Grades</td> <td class=\"column2 style70 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style0 null style0\" colspan=13 rowspan=9></td> </tr> <tr class=row34> <td class=\"column0 style69 s style11\" colspan=2>A1</td> <td class=\"column2 style70 s style9\" colspan=3>91-100</td> </tr> <tr class=row35> <td class=\"column0 style69 s style11\" colspan=2>A2</td> <td class=\"column2 style70 s style9\" colspan=3>81-90</td> </tr> <tr class=row36> <td class=\"column0 style69 s style11\" colspan=2>B1</td> <td class=\"column2 style70 s style9\" colspan=3>71-80</td> </tr> <tr class=row37> <td class=\"column0 style69 s style11\" colspan=2>B2</td> <td class=\"column2 style70 s style9\" colspan=3>61-70</td> </tr> <tr class=row38> <td class=\"column0 style69 s style11\" colspan=2>C1</td> <td class=\"column2 style70 s style9\" colspan=3>51-60</td> </tr> <tr class=row39> <td class=\"column0 style69 s style11\" colspan=2>C2</td> <td class=\"column2 style70 s style9\" colspan=3>41-50</td> </tr> <tr class=row40> <td class=\"column0 style69 s style11\" colspan=2>D</td> <td class=\"column2 style70 s style9\" colspan=3>33-40</td> </tr> <tr class=row41> <td class=\"column0 style71 s style14\" colspan=2>E (Failed)</td> <td class=\"column2 style72 s style17\" colspan=3>&lt;=32</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

module.exports = "<div class=main_con style=padding-top:0> <div class=full_width> <table id=table-example-1 style=width:100%> <thead> <tr> <th colspan=1>SCHOLASTIC ACHIEVEMENT</th> <th colspan=1>{{typePtNoConvCtrl.reportCardArray.header.report_name}}</th> <th style=font-size:12px colspan=1></th> </tr> <tr> <td colspan=1><strong>Subject</strong></td> <td><strong>Max mark </strong> </td> <td><strong>Marks Obtained </strong> </td> </tr> <tr ng-repeat=\"(subjectResult, value) in typePtNoConvCtrl.reportCardArray.main_results\"> <td colspan=1><strong>{{subjectResult}}</strong></td> <td>{{value.max_mark_data.periodic_test.max_mark}}</td> <td colspan=1>{{value.periodic_test}}</td> </tr> </thead> </table> <br> <br> <br> <br> <div ng-repeat=\"(key, subjectKeyValue) in typePtNoConvCtrl.reportCardArray.other_sections\"> <table id=table-example-1 style=width:100%> <thead> <tr> <th>{{key}} Area</th> <th>Grade</th> <th>Remark</th> </tr> </thead> <tbody> <tr ng-repeat=\"(subjectName, subjectValue) in subjectKeyValue\"> <td><span>{{subjectName}}</span></td> <td><span>{{subjectValue.grade}}</span></td> <td><span>{{subjectValue.remarks}}</span></td> </tr> </tbody> </table> </div> <br> <br> <table id=table-example-1 style=width:100%> <tr> <td style=line-height:40px> <strong>General Remarks:</strong> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks}}</span> <input ng-if=$root.isTeachingStaff style=width:85% max=200 type=text ng-model=$root.term_remarks></td>  </tr> </table> <br> <br> <table id=table-example-1 style=width:100%> <thead> <tr> <th height=50 colspan=5><strong>Signature of Class Teacher :</strong></th> <th colspan=1>Date &amp; Place</th> <th colspan=1>School Seal</th> <th colspan=1>Attendance %</th> </tr> </thead> <tr> <td style=padding-left:5px height=50 colspan=5><strong>Signature of Principal/HOS :</strong></td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp;</td> <td colspan=1>&nbsp; <span ng-if=!$root.isTeachingStaff>{{$root.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendance></td> </tr> </table> <br> <br> </div> </div> ";

/***/ }),
/* 1213 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=20 style=text-align:center><b>TERM 1</b></td> </tr> <tr> <td class=s11 colspan=7 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=7 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=7>50</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=7>{{subjectResult.annual_exam_1}} </td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=8> {{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=19><b>TERM 1 (50 Marks)</b> </td> </tr> <tr> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Periodic Test 1</span></div> </td> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Note Book 1</span></div> </td> <td colspan=2 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Subject Enrichment 1</span></div> </td> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Multiple Assessment 1</span></div> </td> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Half Yearly Exam </span></div> </td> <td colspan=2 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Total</span></div> </td> <td colspan=5 class=\"s26 v_m\" rowspan=2> <div id=t_center><span id=mySpan>Grade(Term 1)</span></div> </td> </tr> <tr> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=2 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[5]</td> <td class=s22 colspan=2 style=font-size:10px;text-align:center>[20]</td> <td class=s22 colspan=5 style=font-size:10px;text-align:center>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=2 style=font-size:10px;text-align:center> {{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=2 style=font-size:10px;text-align:center> {{subjectResult.total_mark_1}}</td> <td class=s14 colspan=5 style=font-size:10px;text-align:center>{{subjectResult.grade_1}} </td>   </tr> <tr> <td class=s33 colspan=8 style=text-decoration:underline;text-align:center><b>Co-Scholastic Term I</b></td> <td class=s33 colspan=18 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=8><b> {{subject}}</b></td> <td class=s34 colspan=16 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveCtrl.reportCardArray.discipline\"> <td class=s27 colspan=8><b> {{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=5>Working Days <span ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input type=number oninput=validateInput(this) autofocus=\"\" value=0 ng-if=$root.isTeachingStaff maxlength=3 ng-model=$root.working_days onkeyup=calatt() style=width:65px> </td> <td class=s34 colspan=6>Present Days <span ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input ng-if=$root.isTeachingStaff type=number oninput=validateInput(this) autofocus=\"\" value=0 maxlength=3 ng-model=$root.days_attended onkeyup=calatt() style=width:65px> </td> <td class=s34 colspan=8>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px readonly=readonly> </td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=14>{{$root.published_date}} </td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=6 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Principal</b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s43 colspan=24> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> <script> function validateInput(inputElement) {\n                const inputValue = parseInt(inputElement.value) || 0;\n                const maxLength = 3;\n                if (inputValue < 0) {\n                    inputElement.value = '0';\n                } else if (inputValue.toString().length > maxLength) {\n                    inputElement.value = inputValue.toString().slice(0, maxLength);\n                } else {\n                    inputElement.value = inputValue;\n                }\n            } </script></div></div>";

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b> </td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>50</td> <td class=s12 colspan=6>{{subjectResult.annual_exam_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=12><b>TERM 1(100)</b> </td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Periodic Test I</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Note Book</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Half Yearly Exam</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> </tr> <tr> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=1>[5]</td> <td class=s22 colspan=1>[15]</td> <td class=s22 colspan=2>[10]</td> <td class=s22 colspan=1>[60]</td> <td class=s22 colspan=3>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=2>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=3>{{subjectResult.grade_1}}</td>  </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px;text-decoration:underline><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=2>Working Days <span ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input type=number oninput=validateInput(this) autofocus=\"\" value=0 ng-if=$root.isTeachingStaff maxlength=3 ng-model=$root.working_days onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=3>Present Days <span ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input ng-if=$root.isTeachingStaff type=number oninput=validateInput(this) autofocus=\"\" value=0 maxlength=3 ng-model=$root.days_attended onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=5>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px readonly=readonly> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12>{{termOneTemplatepublishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <br> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-1 style=margin-right:0> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> <br> <br> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.table-container{display:flex}.table-container table{margin-right:20px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b> </td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>50</td> <td class=s12 colspan=6>{{subjectResult.term1_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=12><b>TERM 1(100)</b> </td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Periodic Test I</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Note Book</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Half Yearly Exam</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> </tr> <tr> <td class=s22 colspan=1>[5]</td> <td class=s22 colspan=1>[5]</td> <td class=s22 colspan=1>[5]</td> <td class=s22 colspan=2>[5]</td> <td class=s22 colspan=1>[80]</td> <td class=s22 colspan=3>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=2>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=3>{{subjectResult.grade_1}}</td>  </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px;text-decoration:underline><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-show=showAdditionalSubjectRow> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory(50)</td> <td class=s13 colspan=2>Practical(50)</td> <td class=s14 colspan=4>Total(100)</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=2>Working Days <span ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input type=number oninput=validateInput(this) autofocus=\"\" value=0 ng-if=$root.isTeachingStaff maxlength=3 ng-model=$root.working_days onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=3>Present Days <span ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input ng-if=$root.isTeachingStaff type=number oninput=validateInput(this) autofocus=\"\" value=0 maxlength=3 ng-model=$root.days_attended onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=5>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px readonly=readonly> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12>{{termOneTemplatepublishedTypeEightNineCtrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-1 style=margin-right:0> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> <th class=headcolor colspan=4 style=text-align:left> SEA (Subject Enrichment Activities), <br> MA (Multiple Assessment) </th> </table> </div> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> </div> <script> function validateInput(inputElement) {\n      const inputValue = parseInt(inputElement.value) || 0;\n      const maxLength = 3;\n      if (inputValue < 0) {\n        inputElement.value = '0';\n      } else if (inputValue.toString().length > maxLength) {\n        inputElement.value = inputValue.toString().slice(0, maxLength);\n      } else {\n        inputElement.value = inputValue;\n      }\n    } </script> ";

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{--webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b> </td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>50</td> <td class=s12 colspan=6>{{subjectResult.annual_exam_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=12><b>TERM 1(50)</b> </td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Periodic Test I</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Note Book</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Half Yearly Exam</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> </tr> <tr> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=1>[5]</td> <td class=s22 colspan=1>[15]</td> <td class=s22 colspan=2>[10]</td> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=3>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=2>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1>{{subjectResult.half_yearly_exam_1}}</td> <td class=s14 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=3>{{subjectResult.grade_1}}</td>  </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px;text-decoration:underline><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-show=showAdditionalSubjectRow> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=2>Working Days <span ng-if=!$root.isTeachingStaff>{{$root.working_days}}</span> <input type=number oninput=validateInput(this) autofocus=\"\" value=0 ng-if=$root.isTeachingStaff maxlength=3 ng-model=$root.working_days onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=3>Present Days <span ng-if=!$root.isTeachingStaff>{{$root.days_attended}}</span> <input ng-if=$root.isTeachingStaff type=number oninput=validateInput(this) autofocus=\"\" value=0 maxlength=3 ng-model=$root.days_attended onkeyup=calatt() style=width:65px></td> <td class=s34 colspan=5>Attendance %: <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px readonly=readonly> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher </td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <br> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-1 style=margin-right:0> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> <br> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> </div> <script> function validateInput(inputElement) {\n      const inputValue = parseInt(inputElement.value) || 0;\n      const maxLength = 3;\n      if (inputValue < 0) {\n        inputElement.value = '0';\n      } else if (inputValue.toString().length > maxLength) {\n        inputElement.value = inputValue.toString().slice(0, maxLength);\n      } else {\n        inputElement.value = inputValue;\n      }\n    } </script></div>";

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=7 style=text-align:center><b>TERM 1</b></td> <td class=s12 colspan=7 style=text-align:center><b>TERM 2</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Overall</b></td> </tr> <tr> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s11 colspan=3 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=1><b>Grade</b></td> <td class=s12 colspan=4 style=text-align:center><div id=t_center><span><b>Annual Mark</b></span></div></td> <td class=s11 dir=ltr style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedtcsOneFiveCtrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term1_1}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=3>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=3>{{subjectResult.term2_2}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.grade_2}}</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=1>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 1 (100 Marks)</b> </td> <td class=s20 style=text-align:center colspan=7><b>TERM 2 (100 Marks)</b> </td> <td style=text-align:center colspan=8><b>Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Half Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Note Book 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Yearly Exam </span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Total</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade(Term 2)</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Annual Mark</span></div></td> <td class=\"s26 v_m\" colspan=4 rowspan=2><div id=t_center><span>Final Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[40]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[20]</td> <td class=s22 style=text-align:center colspan=1>[10]</td> <td class=s22 style=text-align:center colspan=1>[40]</td> <td class=s22 style=text-align:center colspan=1>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedtcsOneFiveCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td>  <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.periodic_test_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.half_yearly_2_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td>  <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td>  </tr> <tr> <td class=s33 colspan=7 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term I</b></td> <td class=s33 colspan=2><b>Grade</b></td> <td class=s33 colspan=11 style=text-decoration:underline;text-align:center><b>Co-Scholastic Subjects Term II</b></td> <td class=s33 colspan=2 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedtcsOneFiveCtrl.reportCardArray.other_sections\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedtcsOneFiveCtrl.reportCardArray.discipline\"> <td class=s27 colspan=7><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s27 colspan=11><b> {{subject}}</b></td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s41 colspan=5>Result</td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> <td class=s41 style=text-align:center colspan=5>Attendance</td> </tr> <tr> <td class=s41 colspan=5>Promoted to Grade </td> <td colspan=11> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> <td style=text-align:center colspan=1>Term I</td> <td style=text-align:center colspan=4>Term II</td> </tr> <tr ng-if=publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b> {{subject}}</b></td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=11>{{publishedTypeSixSixSevenCtrl.reportCardArray.header.published_date}}</td> <td class=s41 colspan=1> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=s41 colspan=4> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Head of Section</b> </td> <td class=s40 colspan=4 style=text-align:center> <b>Principal</b> </td> <td class=s40 colspan=5> <b></b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5 style=text-align:center>School Seal</td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <table id=table-example-2> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> </div> </td> </tr> </tbody> </table> <br> <br> <br> <br> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedtcsOneFiveCtrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level}}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedtcsOneFiveCtrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td> {{skill.description}} </td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedtcsOneFiveCtrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level}}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>100</td> <td class=s12 colspan=6>{{subjectResult.annual_exam_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=12><b>TERM 1</b></td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Learning Journal</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Progress Portfolio</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Endline Assessment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Grade (Term 1)</span></div></td> </tr> <tr> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=2>[20]</td> <td class=s22 colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.learning_journal_1}}</td> <td class=s13 colspan=1>{{subjectResult.progress_portfolio_1}}</td> <td class=s13 colspan=1>{{subjectResult.endline_assessment_1}}</td> <td class=s13 colspan=2>{{subjectResult.performance_evaluation_1}}</td> <td class=s14 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-show=showAdditionalSubjectRow> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26Ctrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 max=100 type=text ng-model=$root.attendancetenKb10_term1 style=\"width:89px;margin:6px 7px\"> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher</td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br><br><br> <div class=table-container style=margin-bottom:20px> <table id=table-example-2 style=width:auto;margin-right:20px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td><b>Grade</b></td><td><b>Particulars</b></td></tr> <tr><td>A</td><td>Outstanding</td></tr> <tr><td>B</td><td>Very Good</td></tr> <tr><td>C</td><td>Fair</td></tr> </table> <table id=table-example-2 style=width:auto> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr> <td><b>Grade</b></td><td><b>Marks Range</b></td> <td><b>Grade</b></td><td><b>Marks Range</b></td> </tr> <tr><td>A1</td><td>91-100</td><td>C1</td><td>51-60</td></tr> <tr><td>A2</td><td>81-90</td><td>C2</td><td>41-50</td></tr> <tr><td>B1</td><td>71-80</td><td>D</td><td>33-40</td></tr> <tr><td>B2</td><td>61-70</td><td>E(Failed)</td><td>&lt;33</td></tr> <tr><td colspan=4 style=background-color:#7280ce;font-weight:700;text-align:left;padding:4px>SEA (Subject Enrichment Activities), MA (Multiple Assessments)</td></tr> </table> </div> <br><br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr><td class=s6></td></tr> <tr><td class=s38><span style=font-size:12px>{{$root.term_remarks1}}</span></td></tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> </div> </div> <script> function validateInput(inputElement) {\n    const inputValue = parseInt(inputElement.value) || 0;\n    const maxLength = 3;\n    if (inputValue < 0) {\n      inputElement.value = '0';\n    } else if (inputValue.toString().length > maxLength) {\n      inputElement.value = inputValue.toString().slice(0, maxLength);\n    } else {\n      inputElement.value = inputValue;\n    }\n  } </script> ";

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2 rowspan=2><b>Subject</b> </td> <td class=s11 colspan=20 style=text-align:center><b>TERM 1</b></td> </tr> <tr> <td class=s11 colspan=7 style=text-align:center><b>Max Marks</b></td> <td class=s12 colspan=7 style=text-align:center><b>Marks Obt.</b></td> <td class=s11 dir=ltr style=text-align:center colspan=8><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.specific_subjects\" class=ng-scope> <td class=\"s6 ng-binding\" colspan=2> <b><b> {{subject}}</b></b> </td> <td class=s11 style=text-align:center colspan=7>100</td> <td class=\"s12 ng-binding\" style=text-align:center colspan=7>{{subjectResult.annual_exam_1}} </td> <td class=\"s11 ng-binding\" style=text-align:center dir=ltr colspan=8> {{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b> </td> <td class=s20 style=text-align:center colspan=19><b>TERM 1 (100 Marks)</b> </td> </tr> <tr> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Note Book</span></div> </td> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Subject Enrichment 1</span></div> </td> <td colspan=3 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Multiple Assessment 1</span></div> </td> <td colspan=4 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Performance Evaluation 1</span></div> </td> <td colspan=2 class=\"s26 v_m\"> <div id=t_center><span id=mySpan>Marks Obtained</span></div> </td> <td colspan=5 class=\"s26 v_m\" rowspan=2> <div id=t_center><span id=mySpan>Grade(Term 1)</span></div> </td> </tr> <tr> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[10]</td> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[25]</td> <td class=s22 colspan=3 style=font-size:10px;text-align:center>[25]</td> <td class=s22 colspan=4 style=font-size:10px;text-align:center>[40]</td> <td class=s22 colspan=2 style=font-size:10px;text-align:center>[100]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2> <b> <b> {{subject}}</b></b></td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=3 style=font-size:10px;text-align:center> {{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=4 style=font-size:10px;text-align:center> {{subjectResult.performance_evaluation_1}}</td> <td class=s14 colspan=2 style=font-size:10px;text-align:center> {{subjectResult.total_mark_1}}</td> <td class=s14 colspan=5 style=font-size:10px;text-align:center>{{subjectResult.grade_1}} </td>   </tr> <tr> <td class=s33 colspan=8 style=text-align:left><b>Co-Scholastic</b></td> <td class=s33 colspan=16 style=text-align:center><b>GRADE</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=8><b> {{subject}}</b></td> <td class=s34 colspan=16 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeFiveThreeFiveNew26Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=8><b> {{subject}}</b></td> <td class=s34 colspan=16 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=8>Attendance%</td> <td class=s34 colspan=16> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> </tr> <tr> <td class=s41 colspan=5>Date:</td> <td class=s41 colspan=14>{{$root.published_date}} </td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=6 style=text-align:center><b>Class teacher</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Supervisor</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Section</b> </td> <td class=s40 colspan=6 style=text-align:center> <b>Principal</b> </td> </tr> <tr style=height:40px> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> <td class=s43 colspan=6></td> </tr> <tr> <td class=s43 colspan=24> <div class=table-container> <table id=table-example-2 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <div style=width:50%> <table id=table-example-2 style=width:100%> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\"> SEA (Subject Enrichment Activities) </div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\"> MA (Multiple Assessments) </div> </div> </div> </td> </tr> </tbody> </table> <br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr><td class=s6></td></tr> <tr><td class=s38><span style=font-size:12px>{{$root.term_remarks1}}</span></td></tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> <script> function validateInput(inputElement) {\n                const inputValue = parseInt(inputElement.value) || 0;\n                const maxLength = 3;\n                if (inputValue < 0) {\n                    inputElement.value = '0';\n                } else if (inputValue.toString().length > maxLength) {\n                    inputElement.value = inputValue.toString().slice(0, maxLength);\n                } else {\n                    inputElement.value = inputValue;\n                }\n            } </script></div></div>";

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>100</td> <td class=s12 colspan=6>{{subjectResult.annual_exam_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=12><b>TERM 1(100)</b></td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Note Book</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=5><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> </tr> <tr> <td class=s22 colspan=1>[10]</td> <td class=s22 colspan=1>[15]</td> <td class=s22 colspan=1>[15]</td> <td class=s22 colspan=2>[60]</td> <td class=s22 colspan=1>[100]</td> <td class=s22 colspan=5></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=2>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 colspan=1>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance %</td> <td class=s34 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 max=100 type=text ng-model=$root.attendancetenKb10_term1 style=\"width:89px;margin:6px 7px\"> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12>{{termOneTemplatepublishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher</td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <br> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <div style=width:50%> <table id=table-example-2 style=width:100%> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\"> SEA (Subject Enrichment Activities) </div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\"> MA (Multiple Assessments) </div> </div> </div> <br> <br> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{width:100%;overflow:hidden;display:flex;align-items:stretch}.table-container table{float:left;margin-right:20px}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}.headwidth{width:300px;font-weight:700!important;text-align:center}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s6 colspan=2 rowspan=2><b>Subject</b></td> <td class=s11 colspan=6 style=text-align:center><b>Term I</b></td> <td class=s12 colspan=6 style=text-align:center><b>Term II</b></td> <td class=s11 colspan=2 style=text-align:center><b>Final</b></td> </tr> <tr ng-if=publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s12 style=text-align:center ng-style=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\"> <b ng-if=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall score</b> </td> <td class=s11 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 colspan=2 style=text-align:center>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_2 || subjectResult.term2_2 || subjectResult.total_mark_2 || subjectResult.performance_evaluation_2}}</td> <td class=s11 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s12 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s11 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3 style=vertical-align:middle;text-align:center><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM I</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM 2</b></td> <td style=text-align:center ng-style=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" colspan=2> <b ng-if=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Learning Journal</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Progress Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Endline Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Performance Evaluation 1</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Learning Journal</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Progress Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Endline Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Performance Evaluation 2</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span>Overall Score</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span>Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[20]</td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[10]</td> <td class=s22 style=text-align:center>[20]</td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center>[100]</td> <td class=s22 style=text-align:center></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s13 style=text-align:center>{{subjectResult.learning_journal_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.progress_portfolio_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.endline_assessment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.learning_journal_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.progress_portfolio_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.endline_assessment_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2><b>CO-SCHOLASTIC</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=2 style=text-align:center><b>Overall Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26Term2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=6 style=text-align:center>Term 1</td> <td class=s34 colspan=6 style=text-align:center>Term 2</td> <td class=s34 colspan=2 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px> </td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px> </td> <td class=s34 colspan=2 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=\"width:80%;margin:6px 7px\" maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=\"width:80%;margin:6px 7px\" maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=4 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=4 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:35px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-1 style=width:40%!important;margin-right:20px;height:204px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td style=vertical-align:middle><b>Grade</b></td><td style=vertical-align:middle><b>Particulars</b></td></tr> <tr><td style=vertical-align:middle>A</td><td style=vertical-align:middle>Outstanding</td></tr> <tr><td style=vertical-align:middle>B</td><td style=vertical-align:middle>Very Good</td></tr> <tr><td style=vertical-align:middle>C</td><td style=vertical-align:middle>Fair</td></tr> </table> <div style=width:50%;float:left> <table id=table-example-1 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <br> <div style=clear:both;width:100%> <b>General Remarks:</b> <div ng-if=!$root.isTeachingStaff style=\"border:2px solid #000;width:100%;min-height:45px;padding:5px;margin-top:4px\"> <span style=font-size:12px>{{$root.term_remarks1}}</span> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:60px;word-wrap:break-word;font-size:12px;margin-top:4px></textarea> </div> </div> </div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> ";

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{width:100%;overflow:hidden;display:flex;align-items:stretch}.table-container table{float:left;margin-right:20px}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}.headwidth{width:300px;font-weight:700!important;text-align:center}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s6 colspan=2 rowspan=2><b>SUBJECT</b></td> <td class=s11 colspan=6 style=text-align:center><b>Term I</b></td> <td class=s12 colspan=6 style=text-align:center><b>Term II</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Final</b></td> </tr> <tr ng-if=publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s12 style=text-align:center ng-style=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" ng-attr-colspan=\"{{publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\"> <b ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall Score</b> </td> <td class=s11 dir=ltr style=text-align:center ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_2 || subjectResult.term2_2 || subjectResult.total_mark_2 || subjectResult.performance_evaluation_2}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_2}}</td> <td class=s12 style=text-align:center ng-attr-colspan=\"{{publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\">{{subjectResult.aggregate_avg_total}}</td> <td class=s11 style=text-align:center dir=ltr ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>SCHOLASTIC AREA</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM I (100 Marks)</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM 2 (100 Marks)</b></td> <td style=text-align:center ng-style=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" colspan=2> <b ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" style=border-bottom:none> <div id=t_center> <span id=mySpan>Overall Score</span> </div> </td> <td class=\"s26 v_m\" style=border-bottom:none><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>25</td> <td class=s22 style=text-align:center colspan=1>25</td> <td class=s22 style=text-align:center colspan=1>40</td> <td class=s22 style=text-align:center colspan=1>100</td> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>25</td> <td class=s22 style=text-align:center colspan=1>25</td> <td class=s22 style=text-align:center colspan=1>40</td> <td class=s22 style=text-align:center colspan=1>100</td> <td class=s22 style=text-align:center;border-top:none>100</td> <td class=s22 style=border-top:none;text-align:center></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.note_book_submission_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.performance_evaluation_2}}</td> <td class=s13 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=font-size:10px;text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2><b>CO-SCHOLASTIC</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=2 style=text-align:center><b>Overall Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr ng-if=publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.additional_subjects.length> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=3>Theory</td> <td class=s13 colspan=3>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveThreeFiveNew26Term2Ctrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2><b>{{subject}}</b></td> <td class=s18 dir=ltr colspan=3>{{subjectResult.theory_1}}</td> <td class=s18 colspan=3>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=6 style=text-align:center>Term 1</td> <td class=s34 colspan=6 style=text-align:center>Term 2</td> <td class=s34 colspan=2 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px> </td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px> </td> <td class=s34 colspan=2 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=4 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=4 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:35px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-1 style=width:40%!important;margin-right:20px;height:204px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td style=vertical-align:middle><b>Grade</b></td><td style=vertical-align:middle><b>Particulars</b></td></tr> <tr><td style=vertical-align:middle>A</td><td style=vertical-align:middle>Outstanding</td></tr> <tr><td style=vertical-align:middle>B</td><td style=vertical-align:middle>Very Good</td></tr> <tr><td style=vertical-align:middle>C</td><td style=vertical-align:middle>Fair</td></tr> </table> <div style=width:50%;float:left> <table id=table-example-1 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <br> <div style=clear:both;width:100%> <b>General Remarks:</b> <div ng-if=!$root.isTeachingStaff style=\"border:2px solid #000;width:100%;min-height:45px;padding:5px;margin-top:4px\"> <span style=font-size:12px>{{$root.term_remarks1}}</span> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:60px;word-wrap:break-word;font-size:12px;margin-top:4px></textarea> </div> </div> </div> <script> function validateInput(inputElement) {\n        const inputValue = parseInt(inputElement.value) || 0;\n        const maxLength = 3;\n        if (inputValue < 0) {\n            inputElement.value = '0';\n        } else if (inputValue.toString().length > maxLength) {\n            inputElement.value = inputValue.toString().slice(0, maxLength);\n        } else {\n            inputElement.value = inputValue;\n        }\n    } </script>";

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid #000;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}.headcolor{background-color:#7280ce}#table-example-1 td,#table-example-1 th{border:solid thin #000;padding:4px}#table-example-1 td{white-space:normal!important;vertical-align:middle;text-align:left;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left;font-weight:400}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg);white-space:nowrap;display:inline-block}.grid-container{padding:10px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 td,#table-example-2 th{border:solid thin #000;padding:4px}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.teacherRemark-container{clear:both;border:1px solid #000;width:100%;min-height:50px;padding:5px;margin-top:5px;box-sizing:border-box}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=publishedTypeSixSixSevenNew26Ctrl.reportCardArray.specific_subjects> <td class=s6 colspan=2 rowspan=2><b>SUBJECT</b></td> <td class=s11 colspan=6 style=text-align:center><b>Term I</b></td> <td class=s12 colspan=6 style=text-align:center><b>Term II</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Final</b></td> </tr> <tr ng-if=publishedTypeSixSixSevenNew26Ctrl.reportCardArray.specific_subjects> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s12 style=text-align:center ng-style=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" ng-attr-colspan=\"{{publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\"> <b ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall Score</b> </td> <td class=s11 dir=ltr style=text-align:center ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenNew26Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_2 || subjectResult.term2_2 || subjectResult.total_mark_2 || subjectResult.performance_evaluation_2}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_2}}</td> <td class=s12 style=text-align:center ng-attr-colspan=\"{{publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\">{{subjectResult.aggregate_avg_total}}</td> <td class=s11 style=text-align:center dir=ltr ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3 style=vertical-align:middle;text-align:center><b>SCHOLASTIC AREA</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM I (100 Marks)</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM 2 (100 Marks)</b></td> <td style=text-align:center ng-style=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" colspan=2> <b ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 ng-style=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {} : {'border-bottom': 'none'}\"> <div id=t_center> <span id=mySpan>Overall Score</span> </div> </td> <td class=\"s26 v_m\" colspan=1 height=130 style=border-bottom:none><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>15</td> <td class=s22 style=text-align:center colspan=1>15</td> <td class=s22 style=text-align:center colspan=1>60</td> <td class=s22 style=text-align:center colspan=1>100</td> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>15</td> <td class=s22 style=text-align:center colspan=1>15</td> <td class=s22 style=text-align:center colspan=1>60</td> <td class=s22 style=text-align:center colspan=1>100</td> <td colspan=1 style=text-align:center ng-class=\"{'s22': publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'}\" ng-style=\"publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {} : {'border-top': 'none'}\">100</td> <td colspan=1 style=border-top:none></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.note_book_submission_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.performance_evaluation_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2><b>CO-SCHOLASTIC</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=2 style=text-align:center><b>Overall Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenNew26Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_1}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_2}}</b></td> <td class=s34 colspan=2 style=text-align:center><b>{{subjectResult.aggregate_avg_grade}}</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeSixSixSevenNew26Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_1}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_2}}</b></td> <td class=s34 colspan=2 style=text-align:center><b>{{subjectResult.aggregate_avg_grade}}</b></td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=6 style=text-align:center>Term 1</td> <td class=s34 colspan=6 style=text-align:center>Term 2</td> <td class=s34 colspan=2 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1 || publishedTypeSixSixSevenNew26Ctrl.reportCardArray.extra_info.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:80px;text-align:center> </td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2 || publishedTypeSixSixSevenNew26Ctrl.reportCardArray.extra_info.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:80px;text-align:center> </td> <td class=s34 colspan=2 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult || publishedTypeSixSixSevenNew26Ctrl.reportCardArray.extra_info.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade || publishedTypeSixSixSevenNew26Ctrl.reportCardArray.extra_info.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=12>{{publishedTypeSixSixSevenNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=4 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=4 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:30px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container style=display:flex> <table id=table-example-2 style=width:40%!important;height:204px;margin-right:20px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td><b>Grade</b></td><td><b>Particulars</b></td></tr> <tr><td>A</td><td>Outstanding</td></tr> <tr><td>B</td><td>Very Good</td></tr> <tr><td>C</td><td>Fair</td></tr> </table> <div style=width:50%;display:flex;flex-direction:column> <table id=table-example-2 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <div style=clear:both;width:100%;margin-top:10px><b>General Remarks:</b></div> <div class=teacherRemark-container> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1 || publishedTypeSixSixSevenNew26Ctrl.reportCardArray.extra_info.term_remarks1}}</span> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=\"width:100%;min-height:40px;border:none;outline:0;resize:none;font-size:12px;background:0 0\"></textarea> </div> </div> ";

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>100</td> <td class=s12 colspan=6>{{subjectResult.total_mark_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=12><b>TERM 1(100)</b></td> </tr> <tr> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Note Book</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=2><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=5><div id=t_center><span id=mySpan>Grade(Term 1)</span></div></td> </tr> <tr> <td class=s22 ng-repeat=\"bucket in termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.report_card_template.activity_buckets\" colspan=\"{{$last ? 2 : 1}}\">[{{bucket.max_mark}}]</td> <td class=s22 colspan=1>[{{termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.report_card_template.specific_subjects.activity_buckets[0].max_mark}}]</td> <td class=s22 colspan=5></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=1>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=2>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 colspan=1>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance %</td> <td class=s34 colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 max=100 type=text ng-model=$root.attendancetenKb10_term1 style=\"width:89px;margin:6px 7px\"> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12>{{termOneTemplatepublishedTypeEightToTenNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher</td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <br> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <div style=width:50%> <table id=table-example-2 style=width:100%> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\"> SEA (Subject Enrichment Activities) </div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\"> MA (Multiple Assessments) </div> </div> </div> <br> <br> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid #000;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}.headcolor{background-color:#7280ce}#table-example-1 td,#table-example-1 th{border:solid thin #000;padding:4px}#table-example-1 td{white-space:normal!important;vertical-align:middle;text-align:left;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left;font-weight:400}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg);white-space:nowrap;display:inline-block}.grid-container{padding:10px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 td,#table-example-2 th{border:solid thin #000;padding:4px}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.teacherRemark-container{clear:both;border:1px solid #000;width:100%;min-height:50px;padding:5px;margin-top:5px;box-sizing:border-box}</style> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s6 colspan=2 rowspan=2><b>SUBJECT</b></td> <td class=s11 colspan=6 style=text-align:center><b>Term I</b></td> <td class=s12 colspan=6 style=text-align:center><b>Term II</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Final</b></td> </tr> <tr ng-if=publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.specific_subjects> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 dir=ltr style=text-align:center colspan=2><b>Grade</b></td> <td class=s12 style=text-align:center ng-style=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" ng-attr-colspan=\"{{publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\"> <b ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall Score</b> </td> <td class=s11 dir=ltr style=text-align:center ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_2 || subjectResult.term2_2 || subjectResult.total_mark_2 || subjectResult.performance_evaluation_2}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_2}}</td> <td class=s12 style=text-align:center ng-attr-colspan=\"{{publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? 2 : 1}}\">{{subjectResult.aggregate_avg_total}}</td> <td class=s11 style=text-align:center dir=ltr ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3 style=vertical-align:middle;text-align:center><b>SCHOLASTIC AREA</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM I (100 Marks)</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM 2 (100 Marks)</b></td> <td style=text-align:center ng-style=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {'background-color': '#ffe699'} : {}\" colspan=2> <b ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\">Overall score Avg<br>[Term1 ,Term2]</b> <b ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\">Overall</b> </td> </tr> <tr> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Total Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Notebook</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Performance Evaluation</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130><div id=t_center><span id=mySpan>Total Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 rowspan=2><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" colspan=1 height=130 ng-style=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH' ? {} : {'border-bottom': 'none'}\"> <div id=t_center> <span id=mySpan>Overall Score</span> </div> </td> <td class=\"s26 v_m\" colspan=1 height=130 style=border-bottom:none><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center colspan=1>5</td> <td class=s22 style=text-align:center colspan=1>5</td> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>80</td> <td class=s22 style=text-align:center colspan=1>100</td> <td class=s22 style=text-align:center colspan=1>5</td> <td class=s22 style=text-align:center colspan=1>5</td> <td class=s22 style=text-align:center colspan=1>10</td> <td class=s22 style=text-align:center colspan=1>80</td> <td class=s22 style=text-align:center colspan=1>100</td> <td class=s22 style=text-align:center ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\" colspan=1>100</td> <td colspan=1 style=border-top:none ng-if=\"publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"></td> <td colspan=1 style=border-top:none></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.note_book_submission_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.note_book_submission_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.performance_evaluation_2}}</td> <td class=s13 colspan=1 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2><b>CO-SCHOLASTIC</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=2 style=text-align:center><b>Overall Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_1}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_2}}</b></td> <td class=s34 colspan=2 style=text-align:center><b>{{subjectResult.aggregate_avg_grade}}</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_1}}</b></td> <td class=s34 colspan=6 style=text-align:center><b>{{subjectResult.grade_2}}</b></td> <td class=s34 colspan=2 style=text-align:center><b>{{subjectResult.aggregate_avg_grade}}</b></td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=6 style=text-align:center>Term 1</td> <td class=s34 colspan=6 style=text-align:center>Term 2</td> <td class=s34 colspan=2 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1 || publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.extra_info.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:80px;text-align:center> </td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2 || publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.extra_info.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:80px;text-align:center> </td> <td class=s34 colspan=2 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult || publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.extra_info.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade || publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.extra_info.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=12>{{publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=4 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=4 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:30px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container style=display:flex> <table id=table-example-2 style=width:40%!important;height:204px;margin-right:20px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td><b>Grade</b></td><td><b>Particulars</b></td></tr> <tr><td>A</td><td>Outstanding</td></tr> <tr><td>B</td><td>Very Good</td></tr> <tr><td>C</td><td>Fair</td></tr> </table> <div style=width:50%;display:flex;flex-direction:column> <table id=table-example-2 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <div style=clear:both;width:100%;margin-top:10px><b>General Remarks:</b></div> <div class=teacherRemark-container> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1 || publishedTypeEightToTenNew26Term2Ctrl.reportCardArray.extra_info.term_remarks1}}</span> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=\"width:100%;min-height:40px;border:none;outline:0;resize:none;font-size:12px;background:0 0\"></textarea> </div> </div> ";

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle style=width:100%;table-layout:fixed cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=2><b>Max Marks</b></td> <td class=s12 colspan=3><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=2><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2>100</td> <td class=s12 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s11 dir=ltr colspan=2>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3 style=vertical-align:middle;text-align:center><b>Scholastic Area</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=7><b>TERM 1</b></td> </tr> <tr> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Half Yearly Exam</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Aggregate</span></div></td> <td class=\"s26 v_m\" style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr ng-if=\"termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects && (termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects | json) != '{}'\"> <td class=s33 colspan=2 rowspan=2 style=text-align:left;vertical-align:middle><b>Additional Subject</b></td> <td class=s33 style=text-align:center><b>Theory</b></td> <td class=s33 style=text-align:center><b>Practical</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center colspan=4><b>Grade</b></td> </tr> <tr ng-if=\"termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects && (termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects | json) != '{}'\"> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22 style=text-align:center colspan=4></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.additional_subjects\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.theory_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.practical_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=5><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=5>{{subject}}</td> <td class=s34 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=5>{{subject}}</td> <td class=s34 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=1>Attendance</td> <td class=s34 colspan=8> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> </tr> <tr> <td class=s41 colspan=1>Date:</td> <td class=s41 colspan=8>{{termOneTemplatepublishedTypeNineTermCbseNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher</td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=2>Head of Section</td> <td class=s40 colspan=3>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> </tr> </tbody> </table> <br> <br> <br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <th class=headcolor colspan=2 style=text-align:center> Grading Scale for Co-Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Particulars</b></td> </tr> <tr> <td>A</td> <td>Outstanding</td> </tr> <tr> <td>B</td> <td>Very Good</td> </tr> <tr> <td>C</td> <td>Fair</td> </tr> </table> <div style=width:50%> <table id=table-example-2 style=width:100%> <th colspan=4 class=headcolor style=text-align:center> Grading Scale for Scholastic Areas</th> <tr> <td><b>Grade</b></td> <td><b>Marks Range</b></td> <td><b>Grade</b></td> <td><b>Marks Range</b></td> </tr> <tr> <td>A1</td> <td>91-100</td> <td>C1</td> <td>51-60</td> </tr> <tr> <td>A2</td> <td>81-90</td> <td>C2</td> <td>41-50</td> </tr> <tr> <td>B1</td> <td>71-80</td> <td>D</td> <td>33-40</td> </tr> <tr> <td>B2</td> <td>61-70</td> <td>E(Failed)</td> <td>&lt;33</td> </tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\"> SEA (Subject Enrichment Activities) </div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\"> MA (Multiple Assessments) </div> </div> </div> <br> <br> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg);font-weight:400!important}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=\"publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects && publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2 rowspan=2><b>SUBJECT</b></td> <td class=s11 colspan=7 style=text-align:center><b>TERM I (100 Marks)</b></td> <td class=s12 colspan=5 style=text-align:center><b>TERM 2 (100 Marks)</b></td> <td class=s11 colspan=4 style=text-align:center><b>Overall</b></td> </tr> <tr ng-if=\"publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects && publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s11 colspan=3 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=4 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=3 style=text-align:center><b>Mark Obtained</b></td> <td class=s12 colspan=4 style=text-align:center;background-color:#ffe699><b>Overall score<br>Avg [Term1 ,Term2]-ministry</b></td> </tr> <tr ng-if=\"publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\" ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 colspan=3 style=text-align:center>100</td> <td class=s12 colspan=4 style=text-align:center>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 colspan=2 style=text-align:center>100</td> <td class=s12 colspan=3 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.annual_exam_2}}</td> <td class=s12 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr ng-if=\"publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects && publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2><b>SUBJECT</b></td> <td class=s11 colspan=2><b>Maximum Marks</b></td> <td class=s12 colspan=3><b>Mark Obtained</b></td> <td class=s11 dir=ltr colspan=2><b>Grade</b></td> <td class=s12 colspan=9 style=text-align:center!important> <b>Mark Obtained 100 TERM I + Term II</b> </td> </tr> <tr ng-if=\"publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\" ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2>50</td> <td class=s12 colspan=3>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.annual_exam_2}}</td> <td class=s11 dir=ltr colspan=2>{{subjectResult.grade_2}}</td> <td class=s12 colspan=9 style=text-align:center!important>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=4 style=vertical-align:middle;text-align:center><b>Scholastic Area</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=7><b>TERM 1</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=5><b>TERM 2</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=4><b>FINAL</b></td> </tr> <tr> <td class=s20 style=text-align:center colspan=4><b>Formative Assessments</b></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Half Yearly</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Aggregate</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=s20 style=text-align:center colspan=4><b>Formative Assessments</b></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Annual Exam</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Final Theory</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Formative Assessment</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Aggregate</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22></td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[20]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.periodic_test_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.multiple_assessment_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.subject_enrichment_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.annual_exam_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.final_theory_2 !== undefined ? subjectResult.final_theory_2 : (subjectResult.final_theory !== undefined ? subjectResult.final_theory : subjectResult.annual_exam_2)}}</td> <td class=s13 style=text-align:center>{{subjectResult['formative_assessment_2']}}</td> <td class=s14 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2 rowspan=2 style=text-align:left;vertical-align:middle><b>Additional Subject</b></td> <td class=s33 colspan=2 style=text-align:center><b>Theory</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical</b></td> <td class=s33 colspan=2 style=text-align:center><b>Total</b></td> <td class=s33 colspan=1 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=2 style=text-align:center><b>Theory</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical</b></td> <td class=s33 colspan=2 style=text-align:center><b>Total</b></td> <td class=s33 colspan=3 style=text-align:center><b>Grade</b></td> </tr> <tr> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[100]</td> <td class=s22 colspan=1 style=text-align:center></td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[100]</td> <td class=s22 colspan=3 style=text-align:center></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.additional_subjects\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.theory_1_1 || subjectResult.theory_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.practical_1_1 || subjectResult.practical_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.theory_2_2 || subjectResult.theory_2}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.practical_2_2 || subjectResult.practical_2}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=3 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2><b>Co-Scholastic</b></td> <td class=s33 colspan=16 style=text-align:center><b>GRADE</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=16 style=text-align:center><b>{{subjectResult.grade_2 || subjectResult.grade_1 || subjectResult.grade}}</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=16 style=text-align:center><b>{{subjectResult.grade_2 || subjectResult.grade_1 || subjectResult.grade}}</b></td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=7 style=text-align:center>Term 1</td> <td class=s34 colspan=5 style=text-align:center>Term 2</td> <td class=s34 colspan=4 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=7 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1 || publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.extra_info.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px;text-align:center> </td> <td class=s34 colspan=5 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term2 || publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.extra_info.attendance_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px;text-align:center> </td> <td class=s34 colspan=4 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult || publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.extra_info.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade || publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.extra_info.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin:4px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=14>{{publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=5 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=5 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:30px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5></td> <td class=s43 colspan=5></td> </tr> <tr> <td class=s43 colspan=18> <div class=table-container style=display:flex> <table id=table-example-2 style=width:40%!important;height:204px;margin-right:20px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td><b>Grade</b></td><td><b>Particulars</b></td></tr> <tr><td>A</td><td>Outstanding</td></tr> <tr><td>B</td><td>Very Good</td></tr> <tr><td>C</td><td>Fair</td></tr> </table> <div style=width:50%;display:flex;flex-direction:column> <table id=table-example-2 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff style=margin-top:15px> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <div style=clear:both;width:100%;margin-top:10px><b>General Remarks:</b></div> <div class=teacherRemark-container style=\"border:2px solid #000;padding:6px;width:100%;min-height:40px;box-sizing:border-box\"> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1 || publishedTypeNineTermCbseNew26Term2Ctrl.reportCardArray.extra_info.term_remarks1}}</span> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=\"width:100%;min-height:40px;border:none;outline:0;resize:none;font-size:12px;background:0 0\"></textarea> </div></div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div>";

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=s11 colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=s12 colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=s11 colspan=4 style=font-weight:700;text-align:center>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2 style=text-align:center>100</td> <td class=s12 colspan=3 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s11 colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=2><b>Max Marks</b></td> <td class=s12 colspan=3><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=2><b>Grade</b></td> <td class=s11 colspan=2><b>Mark Obt. (TERM I+II)</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2>50</td> <td class=s12 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s11 dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 colspan=2>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=4 style=vertical-align:middle;text-align:center><b>Scholastic Area</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=7><b>TERM 1</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=2><b>MODEL</b></td> </tr> <tr> <td class=s20 style=text-align:center colspan=4><b>Internal Assessments</b></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Half Yearly</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Aggregate</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Model Exam</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22></td> <td class=s22 style=text-align:center>[80]</td> <td class=s22></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.model_exam_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects && (termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects | json) != '{}'\"> <td class=s33 colspan=2 rowspan=2 style=text-align:left;vertical-align:middle><b>Additional Subject</b></td> <td class=s33 style=text-align:center><b>Theory</b></td> <td class=s33 style=text-align:center><b>Practical</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center><b>Grade</b></td> <td class=s33 style=text-align:center><b>Theory</b></td> <td class=s33 style=text-align:center><b>Practical</b></td> <td class=s33 style=text-align:center><b>Total</b></td> <td class=s33 style=text-align:center colspan=2><b>Grade</b></td> </tr> <tr ng-if=\"termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects && (termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects | json) != '{}'\"> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center colspan=2></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.additional_subjects\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.theory_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.practical_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.theory_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.practical_2}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 style=text-align:center colspan=2>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=9><b>Co-Scholastic</b></td> <td class=s33 colspan=2><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=2>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=2>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance %</td> <td class=s34 colspan=9> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> </td> </tr> <tr> <td class=s41 colspan=2>Result</td> <td colspan=9> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=2>Promoted to Grade</td> <td colspan=9> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=9>{{termOneTemplatepublishedTypeTenTermCbseNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=3>Class Teacher</td> <td class=s40 colspan=3>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=2>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=3></td> <td class=s43 colspan=3></td> <td class=s43 colspan=3></td> <td class=s43 colspan=2></td> </tr> </tbody> </table> <br> <br> <br> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> </div></div>";

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{--moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-rl;-webkit-writing-mode:vertical-rl;transform:rotate(180deg);-webkit-transform:rotate(180deg);white-space:nowrap;display:inline-block;text-align:center;vertical-align:middle!important;font-weight:400}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:1px solid #969696;border-collapse:collapse}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}.page-break{page-break-before:always}#table-example-2 td{white-space:normal!important}#table-example-2 thead th{font-weight:700}#table-example-2 th{font-weight:700}#table-example-2 td{vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center}#table-example-2{border:2px solid #000;padding:4px}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=\"publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=s11 colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=s12 colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=s11 colspan=11 style=font-weight:700;text-align:center;background-color:#ffe699>Overall score Avg [Term1 ,Term2]-ministry</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2 style=text-align:center>100</td> <td class=s12 colspan=3 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s11 colspan=11 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr ng-if=\"publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2><b>SUBJECT</b></td> <td class=s11 colspan=2><b>Maximum Marks</b></td> <td class=s12 colspan=3><b>Mark Obtained</b></td> <td class=s11 dir=ltr colspan=2><b>Grade</b></td> <td class=s11 colspan=9><b>Mark Obtained 100 TERM I + Term II</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=2 style=text-align:center>50</td> <td class=s12 colspan=3 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s11 dir=ltr colspan=2 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s11 colspan=9 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=4 style=vertical-align:middle;text-align:left><b>Scholastic Area</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=7><b>TERM 1</b></td> <td class=s20 style=text-align:center;font-weight:700 colspan=9><b>MODEL</b></td> </tr> <tr> <td class=s20 style=text-align:center colspan=4><b>Internal Assessments</b></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Half Yearly</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Aggregate</span></div></td> <td class=\"s26 v_m\" rowspan=2 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" rowspan=2 colspan=6 style=text-align:center><div id=t_center><span id=mySpan>Model Exam</span></div></td> <td class=\"s26 v_m\" rowspan=2 colspan=3 style=text-align:center><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Periodic Test</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Multiple Assessment</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Portfolio</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Subject Enrichment</span></div></td> </tr> <tr> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[5]</td> <td class=s22 style=text-align:center>[80]</td> <td class=s22 style=text-align:center>[100]</td> <td class=s22></td> <td class=s22 colspan=6 style=text-align:center>[80]</td> <td class=s22 colspan=3></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 style=text-align:center>{{subjectResult.periodic_test_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.multiple_assessment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.subject_enrichment_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.performance_evaluation_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.half_yearly_1}}</td> <td class=s13 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=6 style=text-align:center>{{subjectResult.model_exam_2}}</td> <td class=s14 colspan=3 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2 rowspan=2 style=text-align:left;vertical-align:middle><b>Additional Subject</b></td> <td class=s33 colspan=2 style=text-align:center><b>Theory</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical</b></td> <td class=s33 colspan=2 style=text-align:center><b>Total</b></td> <td class=s33 colspan=1 style=text-align:center><b>Grade</b></td> <td class=s33 colspan=2 style=text-align:center><b>Theory</b></td> <td class=s33 colspan=2 style=text-align:center><b>Practical</b></td> <td class=s33 colspan=2 style=text-align:center><b>Total</b></td> <td class=s33 colspan=3 style=text-align:center><b>Grade</b></td> </tr> <tr> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[100]</td> <td class=s22 colspan=1 style=text-align:center></td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[50]</td> <td class=s22 colspan=2 style=text-align:center>[100]</td> <td class=s22 colspan=3 style=text-align:center></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.additional_subjects\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.theory_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.practical_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=1 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.theory_2}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.practical_2}}</td> <td class=s13 colspan=2 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 colspan=3 style=text-align:center>{{subjectResult.grade_2}}</td> </tr> <tr> <td class=s33 colspan=2><b>Co-Scholastic</b></td> <td class=s33 colspan=16 style=text-align:center><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=16 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s34 colspan=16 style=text-align:center>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2><b>Attendance %</b></td> <td class=s34 colspan=16> <span ng-if=!$root.isTeachingStaff> Term 1: {{$root.attendance_term1}} &nbsp;&nbsp;&nbsp;&nbsp; Term 2: {{$root.attendance_term2}} </span> <div ng-if=$root.isTeachingStaff> Term 1: <input decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:65px> &nbsp;&nbsp;&nbsp;&nbsp; Term 2: <input decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term2 style=width:65px> </div> </td> </tr> <tr> <td class=s41 colspan=4><b>Result</b></td> <td class=s41 colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.StdResult style=width:250px> </td> </tr> <tr> <td class=s41 colspan=4><b>Promoted to Grade</b></td> <td class=s41 colspan=14> <span ng-if=!$root.isTeachingStaff>{{$root.Promoted_Class}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.Promoted_Class style=width:250px> </td> </tr> <tr> <td class=s41 colspan=4><b>Date</b></td> <td class=s41 colspan=14>{{publishedTypeTenTermCbseNew26Term2Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=5 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=5 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:40px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=5></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br> <div style=margin-top:15px;margin-bottom:15px> <b>General Remarks:</b> <div ng-if=!$root.isTeachingStaff style=\"border:1px solid #000;width:100%;min-height:50px;padding:5px;margin-top:5px;font-size:12px\"> <span>{{$root.term_remarks1}}</span> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=\"width:100%;height:60px;word-wrap:break-word;font-size:12px;margin-top:5px;border:1px solid #000;padding:5px\"></textarea> </div> </div> </div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> ";

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports = "<style>.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}#table-example-1{border:4px solid;border-collapse:collapse}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}div.comment{display:none}table{border-collapse:collapse;page-break-after:always}.gridlines td{border:1px dotted #000}.gridlines th{border:1px dotted #000}.b{text-align:center}.e{text-align:center}.f{text-align:right}.inlineStr{text-align:left}.n{text-align:right}.s{text-align:center}td.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style0{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style1{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style2{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style3{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style4{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style5{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style6{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style7{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style8{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style9{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style10{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style11{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style12{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style13{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style14{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}th.style15{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#d8d8d8}td.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style16{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style17{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style18{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style19{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style20{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}th.style21{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:9pt;background-color:#fff}td.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}th.style22{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:11pt;background-color:#fff}td.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}th.style23{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:8pt;background-color:#fff}td.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style24{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style25{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style26{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}th.style27{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:11pt;background-color:#fff}td.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}th.style28{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:12pt;background-color:#fff}td.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style29{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style30{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style31{vertical-align:bottom;text-align:center;border-bottom:none #000;border-top:none #000;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style32{vertical-align:bottom;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}th.style33{vertical-align:top;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;color:#000;font-size:11pt;background-color:#d8d8d8}td.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}th.style34{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:1px solid #000!important;color:#000;font-size:12pt;background-color:#fff}td.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}th.style35{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:12pt;background-color:#fff}td.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style36{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}th.style37{vertical-align:bottom;text-align:center;border-bottom:1px solid #000!important;border-top:none #000;border-left:none #000;border-right:none #000;font-weight:700;color:#000;font-size:8pt;background-color:#fff}td.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}th.style38{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:11pt;background-color:#fff}td.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style39{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}td.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}th.style40{vertical-align:bottom;border-bottom:none #000;border-top:1px solid #000!important;border-left:none #000;border-right:1px solid #000!important;color:#000;font-size:10pt;background-color:#fff}td.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}th.style41{vertical-align:bottom;border-bottom:none #000;border-top:none #000;border-left:1px solid #000!important;border-right:none #000;color:#000;font-size:10pt;background-color:#fff}table.sheet0 col.col0{width:42pt}table.sheet0 col.col1{width:42pt}table.sheet0 col.col2{width:42pt}table.sheet0 col.col3{width:42pt}table.sheet0 col.col4{width:42pt}table.sheet0 col.col5{width:42pt}table.sheet0 col.col6{width:42pt}table.sheet0 col.col7{width:42pt}table.sheet0 col.col8{width:42pt}table.sheet0 col.col9{width:42pt}table.sheet0 col.col10{width:42pt}table.sheet0 col.col11{width:42pt}table.sheet0 col.col12{width:42pt}table.sheet0 col.col13{width:42pt}table.sheet0 col.col14{width:42pt}table.sheet0 col.col15{width:42pt}table.sheet0 col.col16{width:42pt}table.sheet0 col.col17{width:42pt}table.sheet0 col.col18{width:42pt}table.sheet0 tr{height:15.75pt}.subjects_tr{text-align:center!important}</style> <table style=\"border-top:solid 1px\" border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <tbody> <tr class=row1 ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style5 s style9\" colspan=3 rowspan=2 style=font-weight:700;text-align:left;vertical-align:middle;padding-left:5px>Subject</td> <td class=\"column2 style7 s style9\" colspan=7 style=text-align:center;font-weight:700>Term I</td> <td class=\"column8 style10 s style9\" colspan=7 style=text-align:center;font-weight:700>Term II</td> <td class=\"column14 style10 s style9\" colspan=8 style=text-align:center;font-weight:700;background-color:#ffe699!important>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr class=row2 ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column2 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=5 style=text-align:center>Mark Obtained</td> <td class=\"column8 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=5 style=text-align:center>Mark Obtained</td> <td class=\"column14 style15 s style9\" colspan=4 style=text-align:center>Max Marks</td> <td class=\"column16 style16 s style9\" colspan=4 style=text-align:center>Mark Obtained</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=3 style=text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>100</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=5 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>100</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=5 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column14 style18 null style3 subjects_tr\" colspan=4 style=text-align:center>100</td> <td class=\"column16 style18 null style3 subjects_tr ng-binding\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr class=row1 ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style5 s style9\" colspan=3 rowspan=2 style=font-weight:700;text-align:left;vertical-align:middle;padding-left:5px>Subject</td> <td class=\"column2 style7 s style9\" colspan=7 style=text-align:center;font-weight:700>Term I</td> <td class=\"column8 style10 s style9\" colspan=7 style=text-align:center;font-weight:700>Term II</td> <td class=\"column14 style10 s style9\" colspan=4 rowspan=2 style=text-align:center;font-weight:700;white-space:nowrap>Total (100)</td> <td class=\"column16 style10 s style9\" colspan=4 rowspan=2 style=text-align:center;font-weight:700>Grade</td> </tr> <tr class=row2 ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column2 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column6 style15 s style9\" colspan=3 style=text-align:center>Grade</td> <td class=\"column8 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column12 style15 s style9\" colspan=3 style=text-align:center>Grade</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=3 style=text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.grade_1 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.grade_2 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column14 style18 null style3 subjects_tr ng-binding\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=\"column16 style18 null style3 subjects_tr ng-binding\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade || subjectResult.over_all_grade}}</td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=3 rowspan=2 style=vertical-align:middle;padding-left:5px>Subjects</td> <td class=\"column2 style21 s style9\" colspan=7 style=text-align:center>Term I</td> <td class=\"column8 style21 s style9\" colspan=15 style=text-align:center>Term II</td> </tr> <tr class=row5> <td class=\"column2 style23 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style23 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column6 style23 s style9\" colspan=3 style=text-align:center>Grade</td> <td class=\"column8 style23 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column10 style23 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column12 style23 s style9\" colspan=11 style=text-align:center>Grade</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType10KbGradeTerm1New26Ctrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=3 style=font-weight:unset;text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.grade_1 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.half_yearly_2}}</td> <td class=\"column12 style18 null style3 subjects_tr\" colspan=11 style=text-align:center>{{subjectResult.grade_2 || subjectResult.aggregate_avg_grade}}</td> </tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=2>Result</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style7 s style9\" colspan=11>Attendance</td> </tr> <tr class=row8> <td class=\"column0 style17 s style9\" colspan=2>Promoted to Grade</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style30 s style9\" colspan=3 rowspan=2>Term I</td> <td class=\"column16 style30 s style9\" colspan=8 rowspan=2>Term II</td> </tr> <tr class=row9> <td class=\"column0 style18 null style3\" colspan=2></td> <td class=\"column2 style18 null style3\" colspan=4></td> <td class=\"column6 style18 null style3\" colspan=4></td> <td class=\"column10 style18 null style3\" colspan=4></td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=2>Class Teacher </td> <td class=\"column2 style33 s style9\" colspan=4>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=4>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4>Principal</td> <td class=\"column14 style18 null style3\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column16 style18 null style3\" colspan=8> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr class=row11> <td class=\"column0 style34 s\" colspan=2>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column14 style7 s style9\" colspan=11>School Seal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=14>Instructions:</td> <td class=\"column14 style19 null\" colspan=11 rowspan=10></td> </tr> <tr class=row13> <td class=\"column0 style36 s style9\" colspan=2>Grade</td> <td class=\"column2 style37 s style9\" colspan=3>Marks Range</td> <td class=\"column5 style38 null style9\" colspan=9 rowspan=9></td> </tr> <tr class=row14> <td class=\"column0 style36 s style9\" colspan=2>A+</td> <td class=\"column2 style37 s style9\" colspan=3>90-100</td> </tr> <tr class=row15> <td class=\"column0 style36 s style9\" colspan=2>A</td> <td class=\"column2 style37 s style9\" colspan=3>80-89</td> </tr> <tr class=row16> <td class=\"column0 style36 s style9\" colspan=2>B+</td> <td class=\"column2 style37 s style9\" colspan=3>70-79</td> </tr> <tr class=row17> <td class=\"column0 style36 s style9\" colspan=2>B</td> <td class=\"column2 style37 s style9\" colspan=3>60-69</td> </tr> <tr class=row18> <td class=\"column0 style36 s style9\" colspan=2>C+</td> <td class=\"column2 style37 s style9\" colspan=3>50-59</td> </tr> <tr class=row19> <td class=\"column0 style36 s style9\" colspan=2>C</td> <td class=\"column2 style37 s style9\" colspan=3>40-49</td> </tr> <tr class=row20> <td class=\"column0 style36 s style9\" colspan=2>D+</td> <td class=\"column2 style37 s style9\" colspan=3>30-39</td> </tr> <tr class=row21> <td class=\"column0 style36 s style9\" colspan=2>E </td> <td class=\"column2 style37 s style9\" colspan=3>&lt;=30</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports = "<style>table.sheet0{border-collapse:collapse;width:100%;font-family:Arial,'Helvetica Neue',Helvetica,sans-serif;font-size:13px;color:#111;background-color:#fff}table.sheet0 td,table.sheet0 th{border:1px solid #000!important;padding:5px 6px;vertical-align:middle;box-sizing:border-box}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.subjects_tr{text-align:center!important}.border-right-solid{border-right:1px solid #000!important}.border-left-solid{border-left:1px solid #000!important}.gridlines td,.gridlines th{border:1px solid #000!important}td.style15,td.style33,th.style15,th.style33{background-color:#f0f2f5!important}tr.row1 td,tr.row4 td{background-color:#e9ecef!important;font-size:13px;letter-spacing:.2px}tr.row2 td,tr.row5 td{background-color:#f8f9fa!important;font-size:12px}tr.row13 td,tr.row7 td.style7{background-color:#e9ecef!important}input[type=text]{border:1px solid #bdc3c7;border-radius:3px;padding:3px 5px;font-size:12px}</style> <table style=\"border-top:solid 1px\" border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <tbody> <tr class=row1 ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style5 s style9\" colspan=3 rowspan=2 style=font-weight:700;text-align:left;vertical-align:middle;padding-left:5px>Subject</td> <td class=\"column2 style7 s style9\" colspan=7 style=text-align:center;font-weight:700>Term I</td> <td class=\"column8 style10 s style9\" colspan=7 style=text-align:center;font-weight:700>Term II</td> <td class=\"column14 style10 s style9\" colspan=8 style=text-align:center;font-weight:700;background-color:#ffe699!important>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr class=row2 ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column2 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=5 style=text-align:center>Mark Obtained</td> <td class=\"column8 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=5 style=text-align:center>Mark Obtained</td> <td class=\"column14 style15 s style9\" colspan=4 style=text-align:center>Max Marks</td> <td class=\"column16 style16 s style9\" colspan=4 style=text-align:center>Mark Obtained</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedType10KbGradeTerm2New26Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=3 style=text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>100</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=5 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>100</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=5 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column14 style18 null style3 subjects_tr\" colspan=4 style=text-align:center>100</td> <td class=\"column16 style18 null style3 subjects_tr ng-binding\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr class=row1 ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style5 s style9\" colspan=3 rowspan=2 style=font-weight:700;text-align:left;vertical-align:middle;padding-left:5px>Subject</td> <td class=\"column2 style7 s style9\" colspan=7 style=text-align:center;font-weight:700>Term I</td> <td class=\"column8 style10 s style9\" colspan=7 style=\"text-align:center;font-weight:700;border-right:1px solid #000!important\">Term II</td> <td class=\"column14 style10 s style9\" colspan=8 style=\"text-align:center;font-weight:700;border-right:1px solid #000!important;border-left:1px solid #000!important\">Final</td> </tr> <tr class=row2 ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column2 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style16 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column6 style15 s style9\" colspan=3 style=text-align:center>Grade</td> <td class=\"column8 style15 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column10 style16 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column12 style15 s style9 border-right-solid\" colspan=3 style=text-align:center>Grade</td> <td class=\"column14 style15 s style9\" colspan=4 style=text-align:center>Total (100)</td> <td class=\"column16 style16 s style9 border-right-solid\" colspan=4 style=text-align:center>Grade</td> </tr> <tr class=row3 ng-repeat=\"(subject, subjectResult) in publishedType10KbGradeTerm2New26Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedType10KbGradeTerm2New26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style17 s style9\" colspan=3 style=text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.grade_1 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column12 style18 null style3 subjects_tr border-right-solid\" colspan=3 style=text-align:center>{{subjectResult.grade_2 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column14 style18 null style3 subjects_tr ng-binding border-right-solid border-left-solid\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=\"column16 style18 null style3 subjects_tr ng-binding border-right-solid\" colspan=4 style=text-align:center>{{subjectResult.aggregate_avg_grade || subjectResult.over_all_grade}}</td> </tr> <tr class=row4> <td class=\"column0 style20 s style9\" colspan=3 rowspan=2 style=vertical-align:middle;padding-left:5px>Subjects</td> <td class=\"column2 style21 s style9\" colspan=7 style=text-align:center>Term I</td> <td class=\"column8 style21 s style9 border-right-solid\" colspan=15 style=text-align:center>Model Exam</td> </tr> <tr class=row5> <td class=\"column2 style23 s style9\" colspan=2 style=text-align:center>Max Marks</td> <td class=\"column4 style23 s style9\" colspan=2 style=text-align:center>Mark Obt</td> <td class=\"column6 style23 s style9\" colspan=3 style=text-align:center>Grade</td> <td class=\"column8 style23 s style9\" colspan=3 style=text-align:center>Max Marks</td> <td class=\"column10 style23 s style9\" colspan=6 style=text-align:center>Mark Obt</td> <td class=\"column12 style23 s style9 border-right-solid\" colspan=6 style=text-align:center>Grade</td> </tr> <tr class=row6 ng-repeat=\"(subject, subjectResult) in publishedType10KbGradeTerm2New26Ctrl.reportCardArray.main_results\"> <td class=\"column0 style28 s style9\" colspan=3 style=font-weight:unset;text-align:left;padding-left:5px>{{subject}}</td> <td class=\"column2 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.max_mark1}}</td> <td class=\"column4 style18 null style3 subjects_tr\" colspan=2 style=text-align:center>{{subjectResult.total_mark_1 || subjectResult.term1_1 || subjectResult.term1}}</td> <td class=\"column6 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.grade_1 || subjectResult.aggregate_avg_grade}}</td> <td class=\"column8 style18 null style3 subjects_tr\" colspan=3 style=text-align:center>{{subjectResult.max_mark2}}</td> <td class=\"column10 style18 null style3 subjects_tr\" colspan=6 style=text-align:center>{{subjectResult.total_mark_2 || subjectResult.half_yearly_2 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column12 style18 null style3 subjects_tr border-right-solid\" colspan=6 style=text-align:center>{{subjectResult.grade_2 || subjectResult.aggregate_avg_grade}}</td> </tr> <tr class=row7> <td class=\"column0 style17 s style9\" colspan=2>Result</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff max=1500 type=text ng-model=$root.StdResult style=width:80%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style7 s style9\" colspan=11>Attendance %</td> </tr> <tr class=row8> <td class=\"column0 style17 s style9\" colspan=2>Promoted to Grade</td> <td class=\"column2 style18 null style3\" colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff max=500 type=text ng-model=$root.StdPromotGrade style=width:20%;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column14 style30 s style9\" colspan=3 rowspan=2>Term I</td> <td class=\"column16 style30 s style9\" colspan=8 rowspan=2>Term II</td> </tr> <tr class=row9> <td class=\"column0 style18 null style3\" colspan=2></td> <td class=\"column2 style18 null style3\" colspan=4></td> <td class=\"column6 style18 null style3\" colspan=4></td> <td class=\"column10 style18 null style3\" colspan=4></td> </tr> <tr class=row10> <td class=\"column0 style32 s style9\" colspan=2>Class Teacher </td> <td class=\"column2 style33 s style9\" colspan=4>Supervisor</td> <td class=\"column6 style33 s style9\" colspan=4>Head of Section</td> <td class=\"column10 style33 s style9\" colspan=4>Principal</td> <td class=\"column14 style18 null style3\" colspan=3> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  <td class=\"column16 style18 null style3\" colspan=8> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px;margin-top:6px;margin-bottom:6px;margin-left:34px></td>  </tr> <tr class=row11> <td class=\"column0 style34 s\" colspan=2>Date: <span ng-if=!$root.isTeachingStaff>{{$root.StdReportDate}}</span> <input ng-if=$root.isTeachingStaff max=100 type=text ng-model=$root.StdReportDate style=width:85px;margin-top:6px;margin-bottom:6px;margin-left:7px> </td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column2 style27 null\" colspan=4></td> <td class=\"column14 style7 s style9\" colspan=11>School Seal</td> </tr> <tr class=row12> <td class=\"column0 style35 s style9\" colspan=14>Instructions:</td> <td class=\"column14 style19 null\" colspan=11 rowspan=10></td> </tr> <tr class=row13> <td class=\"column0 style36 s style9\" colspan=2>Grade</td> <td class=\"column2 style37 s style9\" colspan=3>Grade %</td> <td class=\"column5 style38 null style9\" colspan=9 rowspan=9></td> </tr> <tr class=row14> <td class=\"column0 style36 s style9\" colspan=2>A+</td> <td class=\"column2 style37 s style9\" colspan=3>90-100</td> </tr> <tr class=row15> <td class=\"column0 style36 s style9\" colspan=2>A</td> <td class=\"column2 style37 s style9\" colspan=3>80-89</td> </tr> <tr class=row16> <td class=\"column0 style36 s style9\" colspan=2>B+</td> <td class=\"column2 style37 s style9\" colspan=3>70-79</td> </tr> <tr class=row17> <td class=\"column0 style36 s style9\" colspan=2>B</td> <td class=\"column2 style37 s style9\" colspan=3>60-69</td> </tr> <tr class=row18> <td class=\"column0 style36 s style9\" colspan=2>C+</td> <td class=\"column2 style37 s style9\" colspan=3>50-59</td> </tr> <tr class=row19> <td class=\"column0 style36 s style9\" colspan=2>C</td> <td class=\"column2 style37 s style9\" colspan=3>40-49</td> </tr> <tr class=row20> <td class=\"column0 style36 s style9\" colspan=2>D+</td> <td class=\"column2 style37 s style9\" colspan=3>30-39</td> </tr> <tr class=row21> <td class=\"column0 style36 s style9\" colspan=2>E </td> <td class=\"column2 style37 s style9\" colspan=3>&lt;30</td> </tr> </tbody> </colgroup></table> ";

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5 ng-if=\"termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=\"column2 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column10 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column18 style23 s style17\" colspan=4 style=font-weight:700;text-align:center>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>{{subjectResult.term1_1 || subjectResult.term1 || subjectResult.total_mark_1 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle;text-align:center colspan=4>{{subjectResult.total_score}}</td> </tr> <tr class=row5 ng-if=\"termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>Subject</td> <td class=\"column2 style22 s style9\" colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column4 style27 s style9\" colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column7 style26 s style9\" colspan=3 style=font-weight:700;text-align:center>Grade</td> <td class=\"column18 style23 s style17\" colspan=12 style=font-weight:700;text-align:center><span ng-if=termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.is_best_taking>Mark Obtained 100</span> TERM I + Term II</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term1_1 || subjectResult.term1 || subjectResult.total_mark_1 || subjectResult.term2_2 || subjectResult.term2}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_1 || subjectResult.grade || subjectResult.grade_2}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle colspan=12>{{subjectResult.total_score}}</td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=8 id=bold_font>TERM I</td> <td class=\"column10 style38 s style9\" colspan=4 id=bold_font>TERM II</td> <td class=\"column18 style39 s style11\" colspan=6 id=bold_font>Overall</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Periodic Test II</td> <td class=slanted-text colspan=2>Project / Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=2>Annual Exam</td> <td class=slanted-text colspan=2>Project / Practical</td> <td class=slanted-text colspan=2 id=bold_font>Final Theory Marks </td> <td colspan=4 rowspan=2 id=bold_font style=vertical-align:middle>Grades (Final Theory)</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td id=bold_font>Max Marks</td> <td id=bold_font>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td style=vertical-align:middle>{{subjectResult.max_periodic_test_1 || subjectResult.max_periodic_test || subjectResult.max_mark_data_1.periodic_test.max_mark || subjectResult.max_mark_data.periodic_test.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test_1 || subjectResult.periodic_test}}</td> <td style=vertical-align:middle>{{subjectResult.max_periodic_test2_1 || subjectResult.max_periodic_test2_2 || subjectResult.max_periodic_test2 || subjectResult.max_mark_data_2.periodic_test2.max_mark || subjectResult.max_mark_data.periodic_test2.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test2_1 || subjectResult.periodic_test2_2 || subjectResult.periodic_test2}}</td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.max_pct_1 || (subjectResult.max_mark_data_1.pct && subjectResult.max_mark_data_1.pct.max_mark)\">{{subjectResult.max_pct_1 || subjectResult.max_mark_data_1.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_pct_1 && (!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && (subjectResult.max_pct || (subjectResult.max_mark_data.pct && subjectResult.max_mark_data.pct.max_mark))\">{{subjectResult.max_pct || subjectResult.max_mark_data.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_pct_1 && (!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && !subjectResult.max_pct && (!subjectResult.max_mark_data.pct || !subjectResult.max_mark_data.pct.max_mark)\">NA</span> </td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.pct_1 !== undefined && subjectResult.pct_1 !== null && subjectResult.pct_1 !== '' && subjectResult.pct_1 !== 'NA'\">{{subjectResult.pct_1}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && subjectResult.pct !== undefined && subjectResult.pct !== null && subjectResult.pct !== '' && subjectResult.pct !== 'NA'\">{{subjectResult.pct}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct === undefined || subjectResult.pct === null || subjectResult.pct === '' || subjectResult.pct === 'NA')\">NA</span> </td> <td style=vertical-align:middle>{{subjectResult.max_half_yearly_1 || subjectResult.max_half_yearly || subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data.half_yearly.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.half_yearly_1 || subjectResult.half_yearly}}</td> <td style=vertical-align:middle>{{subjectResult.max_ae_2 || subjectResult.max_ae || subjectResult.max_mark_data_2.ae.max_mark || subjectResult.max_mark_data.ae.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.ae_2 || subjectResult.ae}}</td> <td style=vertical-align:middle>{{subjectResult.max_pp_2 || subjectResult.max_pp || subjectResult.max_mark_data_2.pp.max_mark || subjectResult.max_mark_data.pp.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.pp_2 || subjectResult.pp}}</td> <td class=\"column8 style47 s\" style=vertical-align:middle>&nbsp;{{subjectResult.static_mark || 100}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle>{{subjectResult.total_score || subjectResult.total_mark}}</td> <td class=\"column17 style29 null\" colspan=4 style=vertical-align:middle>{{ (subjectResult.total_score === 'NA' || subjectResult.total_mark === 'NA') ? 'NA' : (subjectResult.over_all_grade.grade || subjectResult.over_all_grade || subjectResult.grade) }}</td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=2 style=text-align:left id=bold_font>Co-Scholastic</td> <td class=\"column2 style55 s style9\" colspan=18 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.discipline\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> </tr> <tr class=row26 style=\"border-top:3px solid #000\"> <td class=\"column0 style12 s style11\" colspan=2 style=\"text-align:left;border-top:3px solid #000!important\" id=bold_font>Attendance</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box style=\"border-top:3px solid #000!important\"> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:70%> </td> </tr> <tr class=row26 style=\"border-top:3px solid #000\"> <td class=\"column0 style12 s style11\" style=\"text-align:left;border-top:3px solid #000!important\" colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box style=\"border-top:3px solid #000!important\"> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff maxlength=30 type=text ng-model=$root.StdResult style=width:70%> </td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:100%> </td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=19>{{termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:center>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=5 id=ash_box style=text-align:center>Supervisor</td> <td class=\"column7 style64 s style9\" colspan=5 id=ash_box style=text-align:center>Head of Section</td> <td class=\"column12 style64 s style9\" colspan=8 id=ash_box style=text-align:center>Principal</td> </tr> </tbody> </colgroup></table> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level }}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td>{{skill.description}}</td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in termOneTemplatepublishedType02Grade11ScienceNew26Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level }}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div>";

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5 ng-if=\"publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.specific_subjects && publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=\"column2 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column10 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column18 style23 s style17\" colspan=4 style=font-weight:700;text-align:center;background-color:#ffe699>Overall score Avg [Term1 ,Term2]-ministry</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>{{subjectResult.term2_2}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle;text-align:center colspan=4>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr class=row5 ng-if=\"publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.specific_subjects && publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>Subject</td> <td class=\"column2 style22 s style9\" colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column4 style27 s style9\" colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column7 style26 s style9\" colspan=3 style=font-weight:700;text-align:center>Grade</td> <td class=\"column18 style23 s style17\" colspan=12 style=font-weight:700;text-align:center><span ng-if=publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.is_best_taking>Mark Obtained 100</span> TERM I + Term II</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term2_2 || subjectResult.term1_1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_2 || subjectResult.grade_1}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle colspan=12>{{subjectResult.total_score}}</td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=8 id=bold_font>TERM I</td> <td class=\"column10 style38 s style9\" colspan=4 id=bold_font>TERM II</td> <td class=\"column18 style39 s style11\" colspan=6 id=bold_font>Overall</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Periodic Test II</td> <td class=slanted-text colspan=2>Project / Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=2>Annual Exam</td> <td class=slanted-text colspan=2>Project / Practical</td> <td class=slanted-text colspan=2 id=bold_font>Final Theory Marks </td> <td colspan=4 rowspan=2 id=bold_font style=vertical-align:middle>Grades (Final Theory)</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td id=bold_font>Max Marks</td> <td id=bold_font>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td style=vertical-align:middle>{{subjectResult.max_periodic_test_1 || subjectResult.max_periodic_test || (subjectResult.max_mark_data_1 && subjectResult.max_mark_data_1.periodic_test && subjectResult.max_mark_data_1.periodic_test.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.periodic_test && subjectResult.max_mark_data.periodic_test.max_mark)}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test_1 || subjectResult.periodic_test}}</td> <td style=vertical-align:middle>{{subjectResult.max_periodic_test2_1 || subjectResult.max_periodic_test2_2 || subjectResult.max_periodic_test2 || (subjectResult.max_mark_data_2 && subjectResult.max_mark_data_2.periodic_test2 && subjectResult.max_mark_data_2.periodic_test2.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.periodic_test2 && subjectResult.max_mark_data.periodic_test2.max_mark)}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test2_1 || subjectResult.periodic_test2_2 || subjectResult.periodic_test2}}</td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.max_pct_1 || (subjectResult.max_mark_data_1 && subjectResult.max_mark_data_1.pct && subjectResult.max_mark_data_1.pct.max_mark)\">{{subjectResult.max_pct_1 || subjectResult.max_mark_data_1.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_pct_1 && (!subjectResult.max_mark_data_1 || !subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && (subjectResult.max_pct || (subjectResult.max_mark_data && subjectResult.max_mark_data.pct && subjectResult.max_mark_data.pct.max_mark))\">{{subjectResult.max_pct || subjectResult.max_mark_data.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_pct_1 && (!subjectResult.max_mark_data_1 || !subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && !subjectResult.max_pct && (!subjectResult.max_mark_data || !subjectResult.max_mark_data.pct || !subjectResult.max_mark_data.pct.max_mark)\">NA</span> </td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.pct_1 !== undefined && subjectResult.pct_1 !== null && subjectResult.pct_1 !== '' && subjectResult.pct_1 !== 'NA'\">{{subjectResult.pct_1}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && subjectResult.pct !== undefined && subjectResult.pct !== null && subjectResult.pct !== '' && subjectResult.pct !== 'NA'\">{{subjectResult.pct}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct === undefined || subjectResult.pct === null || subjectResult.pct === '' || subjectResult.pct === 'NA')\">NA</span> </td> <td style=vertical-align:middle>{{subjectResult.max_half_yearly_1 || subjectResult.max_half_yearly || (subjectResult.max_mark_data_1 && subjectResult.max_mark_data_1.half_yearly && subjectResult.max_mark_data_1.half_yearly.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.half_yearly && subjectResult.max_mark_data.half_yearly.max_mark)}}</td> <td style=vertical-align:middle>{{subjectResult.half_yearly_1 || subjectResult.half_yearly}}</td> <td style=vertical-align:middle>{{subjectResult.max_ae_2 || subjectResult.max_ae || (subjectResult.max_mark_data_2 && subjectResult.max_mark_data_2.ae && subjectResult.max_mark_data_2.ae.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.ae && subjectResult.max_mark_data.ae.max_mark)}}</td> <td style=vertical-align:middle>{{subjectResult.ae_2 || subjectResult.ae}}</td> <td style=vertical-align:middle>{{subjectResult.max_pp_2 || subjectResult.max_pp || (subjectResult.max_mark_data_2 && subjectResult.max_mark_data_2.pp && subjectResult.max_mark_data_2.pp.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.pp && subjectResult.max_mark_data.pp.max_mark)}}</td> <td style=vertical-align:middle>{{subjectResult.pp_2 || subjectResult.pp}}</td> <td class=\"column8 style47 s\" style=vertical-align:middle>&nbsp;{{subjectResult.static_mark || 100}}</td> <td class=\"column16 style47 null\" style=vertical-align:middle>{{subjectResult.total_score || subjectResult.total_mark}}</td> <td class=\"column17 style29 null\" colspan=4 style=vertical-align:middle>{{ (subjectResult.total_score === 'NA' || subjectResult.total_mark === 'NA') ? 'NA' : (subjectResult.over_all_grade.grade || subjectResult.over_all_grade || subjectResult.grade) }}</td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=2 style=text-align:left id=bold_font>Co-Scholastic</td> <td class=\"column2 style55 s style9\" colspan=18 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1 || subjectResult.grade_2}}</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.discipline\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1 || subjectResult.grade_2}}</td> </tr> <tr class=row26 style=\"border-top:3px solid #000\"> <td class=\"column0 style12 s style11\" colspan=2 style=\"text-align:left;border-top:3px solid #000!important\" id=bold_font>Attendance</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box style=\"border-top:3px solid #000!important\"> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.attendance_term1 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.attendance_term2 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.attendance}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 type=text ng-model=$root.attendance_term1 style=width:70%> </td> </tr> <tr class=row26 style=\"border-top:3px solid #000\"> <td class=\"column0 style12 s style11\" style=\"text-align:left;border-top:3px solid #000!important\" colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box style=\"border-top:3px solid #000!important\"> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.StdResult || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.result}}</span> <input ng-if=$root.isTeachingStaff maxlength=30 type=text ng-model=$root.StdResult style=width:70%> </td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.StdPromotGrade || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.promoted_to}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:100%> </td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=19>{{publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:center>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=5 id=ash_box style=text-align:center>Supervisor</td> <td class=\"column7 style64 s style9\" colspan=5 id=ash_box style=text-align:center>Head of Section</td> <td class=\"column12 style64 s style9\" colspan=8 id=ash_box style=text-align:center>Principal</td> </tr> </tbody> </colgroup></table> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level }}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td>{{skill.description}}</td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level }}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div style=clear:both;width:100%;margin-top:10px><b>Teacher's Remarks:</b></div> <div class=teacherRemark-container style=\"border:2px solid #000;padding:6px;width:100%;min-height:40px;box-sizing:border-box\"> <span ng-if=!$root.isTeachingStaff>{{$root.term_remarks1 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.term_remarks1 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.term_remarks2 || publishedTypeZeroTwoGradeElevenScienceNew26Term2Ctrl.reportCardArray.extra_info.remarks}}</span> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=\"width:100%;min-height:40px;border:none;outline:0;resize:none;font-size:12px;background:0 0\"></textarea> </div>";

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5 ng-if=\"termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=\"column2 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column10 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column18 style23 s style17\" colspan=4 style=font-weight:700;text-align:center>Overall score [Avg [Term1 ,Term2] -ministry subjects</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>{{subjectResult.term1_1}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle;text-align:center colspan=4><span>{{subjectResult.total_score || subjectResult.term1_1}}</span></td> </tr> <tr class=row5 ng-if=\"termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>Subject</td> <td class=\"column2 style22 s style9\" colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column4 style27 s style9\" colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column7 style26 s style9\" colspan=3 style=font-weight:700;text-align:center>Grade</td> <td class=\"column18 style23 s style17\" colspan=12 style=font-weight:700;text-align:center><span ng-if=termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.is_best_taking>Mark Obtained 100</span> TERM I + Term II</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.specific_subjects\" ng-if=\"termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>{{subjectResult.max_mark_data_1.term1.max_mark || subjectResult.max_mark_data_1.arabic.max_mark || subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data_1.periodic_test.max_mark || subjectResult.max_mark_data.term1.max_mark || '50'}}</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term1_1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_1}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle colspan=12><span>{{subjectResult.total_score || subjectResult.term1_1}}</span></td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=8 id=bold_font>TERM I</td> <td class=\"column10 style38 s style9\" colspan=10 id=bold_font>TERM II</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Periodic Test II</td> <td class=slanted-text colspan=2>Project / Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=12>Model Exam</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td colspan=6>Max Marks</td> <td colspan=6>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data_1.periodic_test.max_mark || subjectResult.max_mark_data_2.periodic_test.max_mark || subjectResult.max_mark_data.periodic_test.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test_1 || subjectResult.periodic_test_2 || subjectResult.periodic_test}}</td> <td style=vertical-align:middle>{{subjectResult.max_periodic_test2_1 || subjectResult.max_mark_data_2.periodic_test2.max_mark || subjectResult.max_mark_data_2.periodic_test.max_mark || subjectResult.max_mark_data_1.periodic_test2.max_mark || subjectResult.max_mark_data.periodic_test2.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test2_1 || subjectResult.periodic_test2_2 || subjectResult.periodic_test2 || subjectResult.periodic_test_2}}</td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.max_mark_data_1.pct && subjectResult.max_mark_data_1.pct.max_mark\">{{subjectResult.max_mark_data_1.pct.max_mark}}</span> <span ng-if=\"(!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && subjectResult.max_mark_data_2.pct && subjectResult.max_mark_data_2.pct.max_mark\">{{subjectResult.max_mark_data_2.pct.max_mark}}</span> <span ng-if=\"(!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && (!subjectResult.max_mark_data_2.pct || !subjectResult.max_mark_data_2.pct.max_mark) && subjectResult.max_mark_data.pct && subjectResult.max_mark_data.pct.max_mark\">{{subjectResult.max_mark_data.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_mark_data_1.pct.max_mark && !subjectResult.max_mark_data_2.pct.max_mark && !subjectResult.max_mark_data.pct.max_mark\">NA</span> </td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.pct_1 !== undefined && subjectResult.pct_1 !== null && subjectResult.pct_1 !== '' && subjectResult.pct_1 !== 'NA'\">{{subjectResult.pct_1}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && subjectResult.pct_2 !== undefined && subjectResult.pct_2 !== null && subjectResult.pct_2 !== '' && subjectResult.pct_2 !== 'NA'\">{{subjectResult.pct_2}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct_2 === undefined || subjectResult.pct_2 === null || subjectResult.pct_2 === '' || subjectResult.pct_2 === 'NA') && subjectResult.pct !== undefined && subjectResult.pct !== null && subjectResult.pct !== '' && subjectResult.pct !== 'NA'\">{{subjectResult.pct}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct_2 === undefined || subjectResult.pct_2 === null || subjectResult.pct_2 === '' || subjectResult.pct_2 === 'NA') && (subjectResult.pct === undefined || subjectResult.pct === null || subjectResult.pct === '' || subjectResult.pct === 'NA')\">NA</span> </td> <td style=vertical-align:middle>{{subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data_2.half_yearly.max_mark || subjectResult.max_mark_data.half_yearly.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.half_yearly_1 || subjectResult.half_yearly_2 || subjectResult.half_yearly}}</td> <td colspan=6>{{subjectResult.max_mark_data_2.Model_exam.max_mark || subjectResult.max_mark_data_1.Model_exam.max_mark || subjectResult.max_mark_data.Model_exam.max_mark}}</td> <td colspan=6>{{subjectResult.Model_exam_2 || subjectResult.Model_exam_1 || subjectResult.Model_exam}}</td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=2 style=text-align:left id=bold_font>Co-Scholastic</td> <td class=\"column2 style55 s style9\" colspan=18 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.discipline\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_1}}</td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2 id=bold_font>Attendance</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.attendance_term1 style=width:70%> </td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff maxlength=30 type=text ng-model=$root.StdResult style=width:70%> </td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:100%> </td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=19>{{termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:center>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=6 id=ash_box style=text-align:center>Supervisor</td> <td class=\"column8 style64 s style9\" colspan=12 id=ash_box style=text-align:center>Head of Section</td> </tr> </tbody> </colgroup></table> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level }}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td>{{skill.description}}</td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in termOneTemplatepublishedType02Grade12ScienceNew26Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level }}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div>";

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.slanted-text{transform:translateX(40%) rotate(-180deg);writing-mode:vertical-rl;text-align:center}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#ash_box{background-color:#e0e0e0}#table-example-1 td{white-space:normal!important}#bold_font{font-weight:700}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:top;text-align:center;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle;text-align:left}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}#table-lifeskill caption{padding-bottom:.5em}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:21px;padding-top:0;margin-right:-12px}.fixed-select{width:414px}.headcolor{background-color:#7280ce}.headwidth{width:300px;font-weight:700!important}.table-container{display:flex}.table-container table{margin-right:20px}</style> <table id=table-example-1 border=0 cellpadding=0 cellspacing=0 id=sheet0 class=\"sheet0 gridlines\"> <colgroup><col class=col0> <col class=col1> <col class=col2> <col class=col3> <col class=col4> <col class=col5> <col class=col6> <col class=col7> <col class=col8> <col class=col9> <col class=col10> <col class=col11> <col class=col12> <col class=col13> <col class=col14> <col class=col15> <col class=col16> <col class=col17> <col class=col18> <col class=col19> <col class=col20> <col class=col21> <col class=col22> <col class=col23> <col class=col24> <col class=col25> <tbody> <tr class=row5 ng-if=\"publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>SUBJECT</td> <td class=\"column2 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column10 style22 s style9\" colspan=8 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column18 style23 s style17\" colspan=4 style=font-weight:700;text-align:center;background-color:#ffe699>Overall score Avg [Term1 ,Term2]-ministry</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.header.school_id == 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>100</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle;text-align:center colspan=8>{{subjectResult.term2_2}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle;text-align:center colspan=4>{{subjectResult.aggregate_avg_total || subjectResult.total_score}}</td> </tr> <tr class=row5 ng-if=\"publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style20 s style14\" colspan=2 style=font-weight:700;text-align:center>Subject</td> <td class=\"column2 style22 s style9\" colspan=2 style=font-weight:700;text-align:center>Maximum Marks</td> <td class=\"column4 style27 s style9\" colspan=3 style=font-weight:700;text-align:center>Mark Obtained</td> <td class=\"column7 style26 s style9\" colspan=3 style=font-weight:700;text-align:center>Grade</td> <td class=\"column18 style23 s style17\" colspan=12 style=font-weight:700;text-align:center><span ng-if=publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.is_best_taking>Best of</span><span ng-if=!publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.is_best_taking>Mark Obtained 100</span> TERM I + Term II</td> </tr> <tr class=row7 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.specific_subjects\" ng-if=\"publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.header.school_id != 'ps4vyLJhQvPZjfxaH'\"> <td class=\"column0 style12 s style11\" style=text-align:left;vertical-align:middle colspan=2>{{subject}}</td> <td class=\"column2 style7 null style9\" style=vertical-align:middle colspan=2>{{(subjectResult.max_mark_data_2 && subjectResult.max_mark_data_2.term2 && subjectResult.max_mark_data_2.term2.max_mark) || (subjectResult.max_mark_data && subjectResult.max_mark_data.term2 && subjectResult.max_mark_data.term2.max_mark) || subjectResult.max_mark_data_1.term1.max_mark || subjectResult.max_mark_data_1.arabic.max_mark || subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data_1.periodic_test.max_mark || subjectResult.max_mark_data.term1.max_mark || '50'}}</td> <td class=\"column4 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.term2_2 || subjectResult.term1_1}}</td> <td class=\"column7 style7 null style9\" style=vertical-align:middle colspan=3>{{subjectResult.grade_2 || subjectResult.grade_1}}</td> <td class=\"column18 style47 null\" style=vertical-align:middle colspan=12><span>{{subjectResult.total_score || subjectResult.term1_1}}</span></td> </tr> <tr class=row9> <td class=\"column0 style37 s style14\" colspan=2 rowspan=3 id=bold_font style=vertical-align:middle;text-align:left>Scholastic Area</td> <td class=\"column2 style38 s style9\" colspan=8 id=bold_font>TERM I</td> <td class=\"column10 style38 s style9\" colspan=10 id=bold_font>TERM II</td> </tr> <tr class=row10> <td class=slanted-text colspan=2>Periodic Test I</td> <td class=slanted-text colspan=2>Periodic Test II</td> <td class=slanted-text colspan=2>Project / Practical *</td> <td class=slanted-text colspan=2>Half Yearly</td> <td class=slanted-text colspan=12>Model Exam</td> </tr> <tr class=row11> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td>Max Marks</td> <td>Marks Obt</td> <td colspan=6>Max Marks</td> <td colspan=6>Marks Obt</td> </tr> <tr class=row12 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.main_results\"> <td style=text-align:left;vertical-align:middle colspan=2 id=bold_font>{{subject}}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data_1.periodic_test.max_mark || subjectResult.max_mark_data_2.periodic_test.max_mark || subjectResult.max_mark_data.periodic_test.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test_1 || subjectResult.periodic_test_2 || subjectResult.periodic_test}}</td> <td style=vertical-align:middle>{{subjectResult.max_mark_data_2.periodic_test2.max_mark || subjectResult.max_mark_data_2.periodic_test.max_mark || subjectResult.max_mark_data_1.periodic_test2.max_mark || subjectResult.max_mark_data.periodic_test2.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.periodic_test2_2 || subjectResult.periodic_test2 || subjectResult.periodic_test_2}}</td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.max_mark_data_1.pct && subjectResult.max_mark_data_1.pct.max_mark\">{{subjectResult.max_mark_data_1.pct.max_mark}}</span> <span ng-if=\"(!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && subjectResult.max_mark_data_2.pct && subjectResult.max_mark_data_2.pct.max_mark\">{{subjectResult.max_mark_data_2.pct.max_mark}}</span> <span ng-if=\"(!subjectResult.max_mark_data_1.pct || !subjectResult.max_mark_data_1.pct.max_mark) && (!subjectResult.max_mark_data_2.pct || !subjectResult.max_mark_data_2.pct.max_mark) && subjectResult.max_mark_data.pct && subjectResult.max_mark_data.pct.max_mark\">{{subjectResult.max_mark_data.pct.max_mark}}</span> <span ng-if=\"!subjectResult.max_mark_data_1.pct.max_mark && !subjectResult.max_mark_data_2.pct.max_mark && !subjectResult.max_mark_data.pct.max_mark\">NA</span> </td> <td style=vertical-align:middle> <span ng-if=\"subjectResult.pct_1 !== undefined && subjectResult.pct_1 !== null && subjectResult.pct_1 !== '' && subjectResult.pct_1 !== 'NA'\">{{subjectResult.pct_1}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && subjectResult.pct_2 !== undefined && subjectResult.pct_2 !== null && subjectResult.pct_2 !== '' && subjectResult.pct_2 !== 'NA'\">{{subjectResult.pct_2}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct_2 === undefined || subjectResult.pct_2 === null || subjectResult.pct_2 === '' || subjectResult.pct_2 === 'NA') && subjectResult.pct !== undefined && subjectResult.pct !== null && subjectResult.pct !== '' && subjectResult.pct !== 'NA'\">{{subjectResult.pct}}</span> <span ng-if=\"(subjectResult.pct_1 === undefined || subjectResult.pct_1 === null || subjectResult.pct_1 === '' || subjectResult.pct_1 === 'NA') && (subjectResult.pct_2 === undefined || subjectResult.pct_2 === null || subjectResult.pct_2 === '' || subjectResult.pct_2 === 'NA') && (subjectResult.pct === undefined || subjectResult.pct === null || subjectResult.pct === '' || subjectResult.pct === 'NA')\">NA</span> </td> <td style=vertical-align:middle>{{subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data_2.half_yearly.max_mark || subjectResult.max_mark_data.half_yearly.max_mark}}</td> <td style=vertical-align:middle>{{subjectResult.half_yearly_1 || subjectResult.half_yearly_2 || subjectResult.half_yearly}}</td> <td colspan=6>{{subjectResult.max_mark_data_2.Model_exam.max_mark || subjectResult.max_mark_data_2.ae.max_mark || subjectResult.max_mark_data_2.annual.max_mark || subjectResult.max_mark_data_1.Model_exam.max_mark || subjectResult.max_mark_data_1.half_yearly.max_mark || subjectResult.max_mark_data.Model_exam.max_mark || subjectResult.max_ae_2 || subjectResult.static_mark || '70'}}</td> <td colspan=6>{{subjectResult.Model_exam_2 || subjectResult.Model_exam_1 || subjectResult.Model_exam}}</td> </tr> <tr class=row19> <td class=\"column0 style54 s style11\" colspan=2 style=text-align:left id=bold_font>Co-Scholastic</td> <td class=\"column2 style55 s style9\" colspan=18 style=text-align:center id=bold_font>Grade</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.other_sections\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_2 || subjectResult.grade_1}}</td> </tr> <tr class=row20 ng-repeat=\"(subject, subjectResult) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.discipline\"> <td class=\"column0 style48 s style11\" colspan=2 style=text-align:left;vertical-align:middle id=bold_font>{{subject}}</td> <td class=\"column2 style7 null style9\" colspan=18 style=text-align:center;vertical-align:middle>{{subjectResult.grade_2 || subjectResult.grade_1}}</td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2 id=bold_font>Attendance</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.attendance_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=100 type=text ng-model=$root.attendance_term1 style=width:70%> </td> </tr> <tr class=row26> <td class=\"column0 style12 s style11\" style=text-align:left colspan=2>Result</td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff maxlength=30 type=text ng-model=$root.StdResult style=width:70%> </td> </tr> <tr class=row27> <td class=\"column0 style5 s\" colspan=2 style=text-align:left>Promoted to Grade </td> <td class=\"column1 style6 null\" colspan=18 id=ash_box> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff maxlength=10 type=text ng-model=$root.StdPromotGrade style=width:100%> </td> </tr> <tr class=row30> <td class=\"column0 style65 s\" style=text-align:left>Date:</td> <td class=\"column2 style15 null style17\" colspan=19>{{publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.header.published_date}}</td> </tr> <tr class=row29> <td class=\"column0 style12 s style11\" colspan=2 style=text-align:center>Class Teacher </td> <td class=\"column2 style64 s style9\" colspan=6 id=ash_box style=text-align:center>Supervisor</td> <td class=\"column8 style64 s style9\" colspan=12 id=ash_box style=text-align:center>Head of Section</td> </tr> </tbody> </colgroup></table> <br> <table id=table-lifeskill ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.lifee | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.lifeskillselection[$index].level ng-change=saveSelectedValuesOne($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.lifeskillselection[$index].level }}</td> </tr> </table> <table id=table-lifeskill ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth style=text-align:center>Life Skills</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"(index,skill) in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.extra_info.lifeskillDataByIndex\"> <td class=centering>{{skill.dimension}}</td> <td>{{skill.description}}</td> <td class=centering>{{skill.selectedLevel}}</td> </tr> </table> <br> <table id=table-attitude ng-if=$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in publishedTypeZeroTwoGradeTwelveScienceNew26Term2Ctrl.reportCardArray.att_values | orderBy:'order'\"> <td class=centering>{{ skill.dimension }}</td> <td> <md-input-container class=md-block flex-gt-sm flex-sm> <md-select class=fixed-select ng-model=$root.attitudeselection[$index].level ng-change=saveSelectedValues($index)> <md-option value=\"{{ level.level }}\" ng-repeat=\"level in skill.levels\">{{level.description}}</md-option> </md-select> </md-input-container> </td> <td class=centering>{{ $root.attitudeselection[$index].level }}</td> </tr> </table> <table id=table-attitude ng-if=!$root.isTeachingStaff> <tr class=headcolor> <th class=headwidth>Attitude and Values</th> <th class=headwidth>Description Indicators</th> <th class=headwidth>Level</th> </tr> <tr ng-repeat=\"skill in attitudeArray | orderBy:customOrderFn track by skill.dimension\"> <td class=centering>{{ skill.dimension }}</td> <td>{{ skill.description }}</td> <td class=centering>{{ skill.selectedLevel }}</td> </tr> </table> <br> <div> <tr> <td class=s6 colspan=2><b>Teacher's Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr> <td class=s6></td> </tr> <tr> <td class=s38> <span style=font-size:12px>{{$root.term_remarks1}}</span> </td> </tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div>";

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{display:flex}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.table-container table{margin-right:20px}#table-lifeskill{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}#table-lifeskill caption{padding-bottom:.5em}.headwidth{width:300px;font-weight:700!important;text-align:center}#table-lifeskill td,#table-lifeskill th{border:solid thin;padding:4px}#table-lifeskill td{white-space:normal!important}#table-lifeskill thead th{font-weight:700}#table-lifeskill th{font-weight:400}#table-lifeskill td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-lifeskill tr{text-align:left}#table-lifeskill th{padding:.3em;vertical-align:middle}#table-attitude{border:4px solid;border-collapse:collapse;width:100%}#table-attitude caption{padding-bottom:.5em}#table-attitude td,#table-attitude th{border:solid thin;padding:4px}#table-attitude td{white-space:normal!important}#table-attitude thead th{font-weight:700}#table-attitude th{font-weight:400}#table-attitude td{border-style:1px solid;vertical-align:top;text-align:left;white-space:normal!important;font-size:12px}#table-attitude tr{text-align:left}#table-attitude th{padding:.3em;vertical-align:middle}.txt-rotate{transform:rotate(-90deg);display:inline-block;white-space:nowrap}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:12px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.3em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg)}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:4px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:4px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:12px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.3em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr> <td class=s6 colspan=2><b>Subject(s)</b></td> <td class=s11 colspan=3><b>Max Marks</b></td> <td class=s12 colspan=6><b>Marks Obt.</b></td> <td class=s11 dir=ltr colspan=3><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2>{{subject}}</td> <td class=s11 colspan=3>100</td> <td class=s12 colspan=6>{{subjectResult.annual_exam_1}}</td> <td class=s11 dir=ltr colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=12><b>TERM 1 (100)</b></td> </tr> <tr> <td class=\"s26 v_m\" ng-repeat=\"bucket in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.buckets track by $index\" colspan=\"{{bucket.max_mark / 10}}\"><div id=t_center><span id=mySpan>{{bucket.name}}</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\" colspan=3><div id=t_center><span id=mySpan>Grade (Term 1)</span></div></td> </tr> <tr> <td class=s22 ng-repeat=\"bucket in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.buckets track by $index\" colspan=\"{{bucket.max_mark / 10}}\">[{{bucket.max_mark}}]</td> <td class=s22 colspan=1>[50]</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.main_results\"> <td class=s27 colspan=2>{{subject}}</td> <td class=s13 ng-repeat=\"bucket in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.buckets track by $index\" colspan=\"{{bucket.max_mark / 10}}\">{{subjectResult[bucket.db_key + '_1']}}</td> <td class=s14 colspan=3>{{subjectResult.total_mark_1}}</td> <td class=s14 colspan=3>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=9 style=padding-right:700px><b>Co-Scholastic Subjects</b></td> <td class=s33 colspan=5><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.other_sections\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.discipline\"> <td style=padding-right:700px class=s27 colspan=9>{{subject}}</td> <td class=s34 colspan=5>{{subjectResult.grade_1}}</td> </tr> <tr ng-show=showAdditionalSubjectRow> <td class=s27 colspan=2><b>Additional Subject</b></td> <td class=s13 colspan=2>Theory</td> <td class=s13 colspan=2>Practical</td> <td class=s14 colspan=4>Total</td> <td class=s14 colspan=4><b>Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in termOneTemplatepublishedTypeOneTwoNew26ShjCtrl.reportCardArray.additional_subjects\"> <td class=s29 colspan=2>{{subject}}</td> <td class=s18 dir=ltr colspan=2>{{subjectResult.theory_1}}</td> <td class=s18 colspan=2>{{subjectResult.practical_1}}</td> <td class=s30 colspan=4>{{subjectResult.total_mark_1}}</td> <td class=s30 colspan=4>{{subjectResult.grade_1}}</td> </tr> <tr> <td class=s33 colspan=2>Attendance</td> <td class=s34 colspan=10> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff decimal-numbers-only maxlength=3 max=100 type=text ng-model=$root.attendancetenKb10_term1 style=\"width:89px;margin:6px 7px\"> </td> </tr> <tr> <td class=s41 colspan=2>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=2>Class Teacher</td> <td class=s40 colspan=2>Supervisor</td> <td class=s40 colspan=3>Head of Section</td> <td class=s40 colspan=5>Principal</td> </tr> <tr style=height:40px> <td class=s43 colspan=2></td> <td class=s43 colspan=2></td> <td class=s43 colspan=3></td> <td class=s43 colspan=5></td> </tr> </tbody> </table> <br><br><br> <div class=table-container> <table id=table-example-1 style=width:50%!important;margin-right:20px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td><b>Grade</b></td><td><b>Particulars</b></td></tr> <tr><td>A</td><td>Outstanding</td></tr> <tr><td>B</td><td>Very Good</td></tr> <tr><td>C</td><td>Fair</td></tr> </table> <div style=width:50%> <table id=table-example-2 style=width:100%> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr> <td><b>Grade</b></td><td><b>Marks Range</b></td> <td><b>Grade</b></td><td><b>Marks Range</b></td> </tr> <tr><td>A1</td><td>91-100</td><td>C1</td><td>51-60</td></tr> <tr><td>A2</td><td>81-90</td><td>C2</td><td>41-50</td></tr> <tr><td>B1</td><td>71-80</td><td>D</td><td>33-40</td></tr> <tr><td>B2</td><td>61-70</td><td>E(Failed)</td><td>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\"> SEA (Subject Enrichment Activities) </div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\"> MA (Multiple Assessments) </div> </div> </div> <br><br> <div> <tr> <td class=s6 colspan=2><b>General Remarks:</b></td> <td class=s38 colspan=17> <div ng-if=!$root.isTeachingStaff style=\"clear:both;border:2px solid #000;width:100%\"> <table style=width:100%> <tr><td class=s6></td></tr> <tr><td class=s38><span style=font-size:12px>{{$root.term_remarks1}}</span></td></tr> </table> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:15%;word-wrap:break-word;font-size:12px></textarea> </td> </tr> </div> </div> </div> <script> function validateInput(inputElement) {\n    const inputValue = parseInt(inputElement.value) || 0;\n    const maxLength = 3;\n    if (inputValue < 0) {\n      inputElement.value = '0';\n    } else if (inputValue.toString().length > maxLength) {\n      inputElement.value = inputValue.toString().slice(0, maxLength);\n    } else {\n      inputElement.value = inputValue;\n    }\n  } </script> ";

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

module.exports = "<style>input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number]{-moz-appearance:textfield}.table-container{width:100%;overflow:hidden;display:flex;align-items:stretch}.table-container table{float:left;margin-right:20px}#table-example-1{border:4px solid;border-collapse:collapse;width:100%}.fixed-select{width:414px}.headwidth{width:300px;font-weight:700!important;text-align:center}.headcolor{background-color:#7280ce}#table-example-1 caption{padding-bottom:.5em}#table-example-1 td,#table-example-1 th{border:solid thin;padding:6px 4px}#table-example-1 td{white-space:normal!important}#table-example-1 thead th{font-weight:700}#table-example-1 th{font-weight:400}#table-example-1 td{border-style:1px solid;vertical-align:middle;text-align:left;white-space:normal!important;font-size:13px}#table-example-1 tr{text-align:left}#table-example-1 th{padding:.4em;vertical-align:middle;text-align:left}.v_m{vertical-align:middle!important}#t_center{text-align:center}#mySpan{writing-mode:vertical-lr;transform:rotate(180deg);display:inline-block;white-space:nowrap!important;text-align:center;font-size:13px;font-weight:700;line-height:1.15;height:160px}.grid-container{padding:10px}.reducewidth{width:630px}#table-example-2{border:2px solid #000;border-collapse:collapse;padding:6px}#table-example-2 caption{padding-bottom:.5em}#table-example-2 td,#table-example-2 th{border:solid thin;padding:6px}#table-example-2 td{white-space:normal!important;vertical-align:top;text-align:center;font-size:13px}#table-example-2 tr{text-align:center}#table-example-2 th{padding:.4em;vertical-align:middle;text-align:center;font-weight:700}.page-break{page-break-before:always}</style> <div class=\"ritz grid-container\" dir=ltr> <div class=\"ritz grid-container\" dir=ltr> <table id=table-example-1 class=waffle cellspacing=0 cellpadding=0> <tbody> <tr ng-if=publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.specific_subjects> <td class=s6 colspan=2 rowspan=2><b>Subject</b></td> <td class=s11 colspan=6 style=text-align:center><b>Term I</b></td> <td class=s12 colspan=6 style=text-align:center><b>Term II</b></td> <td class=s11 colspan=2 style=text-align:center><b>Final</b></td> </tr> <tr ng-if=publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.specific_subjects> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s11 colspan=2 style=text-align:center><b>Maximum Marks</b></td> <td class=s12 colspan=2 style=text-align:center><b>Mark Obtained</b></td> <td class=s11 colspan=2 style=text-align:center><b>Grade</b></td> <td class=s12 style=text-align:center;background-color:#ffe699 colspan=2><b>Overall score Avg<br>[Term1 ,Term2]</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.specific_subjects\"> <td class=s6 colspan=2><b>{{subject}}</b></td> <td class=s11 colspan=2 style=text-align:center>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_1 || subjectResult.term1_1 || subjectResult.total_mark_1 || subjectResult.performance_evaluation_1}}</td> <td class=s11 style=text-align:center dir=ltr colspan=2>{{subjectResult.grade_1}}</td> <td class=s11 style=text-align:center colspan=2>100</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.annual_exam_2 || subjectResult.term2_2 || subjectResult.total_mark_2 || subjectResult.performance_evaluation_2}}</td> <td class=s11 colspan=2 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s12 style=text-align:center colspan=2>{{subjectResult.aggregate_avg_total}}</td> </tr> <tr> <td class=s6 colspan=2 rowspan=3 style=vertical-align:middle;text-align:center><b>Scholastic Area</b></td> <td class=s20 style=text-align:center colspan=6><b>TERM I </b></td> <td class=s20 style=text-align:center colspan=6><b>TERM 2</b></td> <td style=text-align:center;background-color:#ffe699 colspan=2><b>Overall score Avg<br>[Term1 ,Term2]</b></td> </tr> <tr> <td class=\"s26 v_m\" ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\"> <div id=t_center><span id=mySpan>{{bucket.name}}</span></div> </td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\" ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\"> <div id=t_center><span id=mySpan>{{bucket.name}}</span></div> </td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Marks Obtained</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Grade</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Overall<br>Score</span></div></td> <td class=\"s26 v_m\"><div id=t_center><span id=mySpan>Grade</span></div></td> </tr> <tr> <td class=s22 ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\" style=text-align:center> [{{bucket.max_mark}}] </td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center></td> <td class=s22 ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\" style=text-align:center> [{{bucket.max_mark}}] </td> <td class=s22 style=text-align:center>[50]</td> <td class=s22 style=text-align:center></td> <td class=s22 style=text-align:center>[100]</td> <td class=s22 style=text-align:center></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.main_results\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s13 ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\" style=text-align:center> {{subjectResult[bucket.db_key + '_1']}} </td> <td class=s14 style=text-align:center>{{subjectResult.total_mark_1}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s13 ng-repeat=\"bucket in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.buckets track by $index\" style=text-align:center> {{subjectResult[bucket.db_key + '_2']}} </td> <td class=s14 style=text-align:center>{{subjectResult.total_mark_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_total}}</td> <td class=s14 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s33 colspan=2><b>Co-Scholastic</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=6 style=text-align:center><b>GRADE</b></td> <td class=s33 colspan=2 style=text-align:center><b>Overall Grade</b></td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.other_sections\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr ng-repeat=\"(subject, subjectResult) in publishedTypeFiveOneTwoNew26ShjTerm2Ctrl.reportCardArray.discipline\"> <td class=s27 colspan=2><b>{{subject}}</b></td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_1}}</td> <td class=s34 colspan=6 style=text-align:center>{{subjectResult.grade_2}}</td> <td class=s34 colspan=2 style=text-align:center>{{subjectResult.aggregate_avg_grade}}</td> </tr> <tr> <td class=s41 colspan=2><b>Attendance%</b></td> <td class=s34 colspan=6 style=text-align:center>Term 1</td> <td class=s34 colspan=6 style=text-align:center>Term 2</td> <td class=s34 colspan=2 style=text-align:center>Final</td> </tr> <tr> <td class=s41 colspan=2></td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term1}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term1 style=width:89px> </td> <td class=s34 colspan=6 style=text-align:center> <span ng-if=!$root.isTeachingStaff>{{$root.attendancetenKb10_term2}}</span> <input ng-if=$root.isTeachingStaff maxlength=3 decimal-numbers-only max=100 type=text ng-model=$root.attendancetenKb10_term2 style=width:89px> </td> <td class=s34 colspan=2 style=text-align:center></td> </tr> <tr> <td class=s41 colspan=4>Result</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdResult}}</span> <input ng-if=$root.isTeachingStaff style=\"width:80%;margin:6px 7px\" maxlength=30 type=text ng-model=$root.StdResult> </td> </tr> <tr> <td class=s41 colspan=4>Promoted to Grade</td> <td colspan=12> <span ng-if=!$root.isTeachingStaff>{{$root.StdPromotGrade}}</span> <input ng-if=$root.isTeachingStaff style=\"width:80%;margin:6px 7px\" maxlength=30 type=text ng-model=$root.StdPromotGrade> </td> </tr> <tr> <td class=s41 colspan=4>Date:</td> <td class=s41 colspan=12><span>{{$root.published_date}}</span></td> </tr> <tr style=background-color:#e0e0e0> <td class=s12 colspan=4 style=text-align:center><b>Class Teacher</b></td> <td class=s40 colspan=4 style=text-align:center><b>Supervisor</b></td> <td class=s40 colspan=4 style=text-align:center><b>Head of Section</b></td> <td class=s40 colspan=4 style=text-align:center><b>Principal</b></td> </tr> <tr style=height:35px> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> <td class=s43 colspan=4></td> </tr> <tr> <td class=s43 colspan=16> <div class=table-container> <table id=table-example-1 style=width:40%!important;margin-right:20px;height:204px> <tr><th class=headcolor colspan=2 style=text-align:center>Grading Scale for Co-Scholastic Areas</th></tr> <tr><td style=vertical-align:middle><b>Grade</b></td><td style=vertical-align:middle><b>Particulars</b></td></tr> <tr><td style=vertical-align:middle>A</td><td style=vertical-align:middle>Outstanding</td></tr> <tr><td style=vertical-align:middle>B</td><td style=vertical-align:middle>Very Good</td></tr> <tr><td style=vertical-align:middle>C</td><td style=vertical-align:middle>Fair</td></tr> </table> <div style=width:50%;float:left> <table id=table-example-1 style=width:100%;background-color:#fff!important> <tr><th colspan=4 class=headcolor style=text-align:center>Grading Scale for Scholastic Areas</th></tr> <tr><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td><td style=background-color:#fff!important><b>Grade</b></td><td style=background-color:#fff!important><b>Marks Range</b></td></tr> <tr><td style=background-color:#fff!important>A1</td><td style=background-color:#fff!important>91-100</td><td style=background-color:#fff!important>C1</td><td style=background-color:#fff!important>51-60</td></tr> <tr><td style=background-color:#fff!important>A2</td><td style=background-color:#fff!important>81-90</td><td style=background-color:#fff!important>C2</td><td style=background-color:#fff!important>41-50</td></tr> <tr><td style=background-color:#fff!important>B1</td><td style=background-color:#fff!important>71-80</td><td style=background-color:#fff!important>D</td><td style=background-color:#fff!important>33-40</td></tr> <tr><td style=background-color:#fff!important>B2</td><td style=background-color:#fff!important>61-70</td><td style=background-color:#fff!important>E(Failed)</td><td style=background-color:#fff!important>&lt;33</td></tr> </table> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none;border-bottom:none\">SEA (Subject Enrichment Activities)</div> <div style=\"background-color:#7280ce;color:#000;padding:6px 8px;font-weight:700;margin-top:0;border:1px solid #000;border-top:none\">MA (Multiple Assessments)</div> </div> </div> </td> </tr> </tbody> </table> <br> <div style=clear:both;width:100%> <b>General Remarks:</b> <div ng-if=!$root.isTeachingStaff style=\"border:2px solid #000;width:100%;min-height:45px;padding:5px;margin-top:4px\"> <span style=font-size:12px>{{$root.term_remarks1}}</span> </div> <textarea ng-if=$root.isTeachingStaff maxlength=500 ng-model=$root.term_remarks1 style=width:100%;height:60px;word-wrap:break-word;font-size:12px;margin-top:4px></textarea> </div> </div> </div> <script> function validateInput(inputElement) {\n\t\tconst inputValue = parseInt(inputElement.value) || 0;\n\t\tconst maxLength = 3;\n\t\tif (inputValue < 0) {\n\t\t\tinputElement.value = '0';\n\t\t} else if (inputValue.toString().length > maxLength) {\n\t\t\tinputElement.value = inputValue.toString().slice(0, maxLength);\n\t\t} else {\n\t\t\tinputElement.value = inputValue;\n\t\t}\n\t} </script> ";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ct_reports = __webpack_require__(128);

var _ct_reports2 = _interopRequireDefault(_ct_reports);

var _classteacherController = __webpack_require__(372);

var _classteacherController2 = _interopRequireDefault(_classteacherController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/approveReportsModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:02:16 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var name = "reportCardClassTeacher";
var _module = angular.module(name, [
  //import modules
]).controller('studentListingForReports', _classteacherController2.default);

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentListingForReports', {
//             parent: 'app',
//             url: '/student-list-class-teacher',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'reportCardClassTeacherCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reportCardConsole = __webpack_require__(127);

var _reportCardConsole2 = _interopRequireDefault(_reportCardConsole);

var _reportcardController = __webpack_require__(371);

var _reportcardController2 = _interopRequireDefault(_reportcardController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('reportCardGenConsoleModule', [
    //import modules
]).controller('reportCardGenConsole', _reportcardController2.default);;

// import './manageReportsModule.scss';
// import templateProperty from './views/subject-property.html';
//import homeFctr from './services/homeFactory';
//import userSrv from './services/userService'

//module.service('homeFactory', homeFctr);
//module.service('userService', userSrv);


// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('reportCardGenConsole', {
//             parent: 'app',
//             url: '/report-card-gen-console/:cardId/:dataId/:re_generate/:fromCt',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'reportCardGenConsoleCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

__webpack_require__(1241);

var _roleHierarchy = __webpack_require__(1242);

var _roleHierarchy2 = _interopRequireDefault(_roleHierarchy);

var _roleHierarchyController = __webpack_require__(1243);

var _roleHierarchyController2 = _interopRequireDefault(_roleHierarchyController);

var _userHierarchy = __webpack_require__(1244);

var _userHierarchy2 = _interopRequireDefault(_userHierarchy);

var _userHierarchyController = __webpack_require__(1245);

var _userHierarchyController2 = _interopRequireDefault(_userHierarchyController);

var _roleSettings = __webpack_require__(1246);

var _roleSettings2 = _interopRequireDefault(_roleSettings);

var _roleSettingsController = __webpack_require__(1247);

var _roleSettingsController2 = _interopRequireDefault(_roleSettingsController);

var _userSettings = __webpack_require__(1248);

var _userSettings2 = _interopRequireDefault(_userSettings);

var _userSettingsController = __webpack_require__(1249);

var _userSettingsController2 = _interopRequireDefault(_userSettingsController);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('RoleHeirarchy', [_angularUiRouter2.default]);

_module.constant('ROLEHIERARCHYCONSTANT', {
    API_GET_ROLE_HIERARCHY: "/v0/hierarchy/build-role-hierarchy/"
    //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
    //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('roleHeirarchy', {
        parent: 'app',
        url: '/role-heirarchy',
        views: {
            '@': {
                template: _roleHierarchy2.default,
                controller: _roleHierarchyController2.default,
                controllerAs: 'roleHeirarchy'
            }
        }
    });
}]);

var _module = angular.module('UserHeirarchy', [_angularUiRouter2.default]);
_module.constant('USERHIERARCHYCONSTANT', {
    API_GET_USER_HIERARCHY: "/v0/hierarchy/build-userhierarchy/"
    //API_GET_MODULE_LIST : "/v0/privilege/get-all-modules/",
    //API_CHECK_PRIVILEGE_EXISTS:"/v0/privilege/check-if-privilege-exits",
    //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
    //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('reportingRoles', {
        parent: 'app',
        url: '/user-hierarchy',
        views: {
            '@': {
                template: _userHierarchy2.default,
                controller: _userHierarchyController2.default,
                controllerAs: 'reportingRoles'
            }
        }
    });
}]);

var _module = angular.module('RoleSettings', [_angularUiRouter2.default]);
_module.constant('ROLESETTINGSCONSTANT', {
    API_GET_ALL_ROLES: "/v0/initial-settings/user-console/roles/added/",
    API_GET_ALL_ROLE_MAPPING: "/v0/hierarchy/get-all-reporting-roles-mapping/",
    API_SAVE_ROLE_MAPPING: "/v0//hierarchy/save-role-mapping",
    API_UPDATE_ROLE_MAPPING: "/v0//hierarchy/update-role-mappings",
    API_GET_MAPPED_PARENTS: "/v0/hierarchy/get-mapped-parent-roles"
    //API_GET_USER_HIERARCHY:"/v0/hierarchy/build-userhierarchy/",
    //API_GET_MODULE_LIST : "/v0/privilege/get-all-modules/",
    //API_CHECK_PRIVILEGE_EXISTS:"/v0/privilege/check-if-privilege-exits",
    //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
    //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('roleMapping', {
        parent: 'app',
        url: '/role-mapping',
        views: {
            '@': {
                template: _roleSettings2.default,
                controller: _roleSettingsController2.default,
                controllerAs: 'roleMapping'
            }
        }
    });
}]);
var _module = angular.module('UserSettings', [_angularUiRouter2.default]);
_module.constant('USERSETTINGSCONSTANT', {
    API_GET_HEAD_ROLES: "/v0/hierarchy/get-head-roles/",
    API_GET_USERCOUNT: "/v0/hierarchy/get-count-of-users",
    API_GET_USERS: "/v0/hierarchy/get-users-with-child",
    API_UPDATE_ROLE_MAPPING: "/v0//hierarchy/update-role-mappings",
    API_GET_MAPPED_PARENTS: "/v0/hierarchy/get-mapped-parent-roles",
    API_GET_SUB_ROLES: "/v0/hierarchy/get-sub-roles",
    API_GET_SUB_USERS: "/v0//hierarchy/get-sub-users",
    API_SAVE_USER_MAPPING: "/v0/hierarchy/save-reporting-roles"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider.state('createHierarchy', {
        parent: 'app',
        url: '/user-mapping',
        views: {
            '@': {
                template: _userSettings2.default,
                controller: _userSettingsController2.default,
                controllerAs: 'createHierarchy'
            }
        }
    });
}]);

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, exports) {

module.exports = "<style>.orgchart{box-sizing:border-box;display:inline-block;min-height:202px;min-width:202px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:linear-gradient(90deg,rgba(200,0,0,.15) 10%,rgba(0,0,0,0) 10%),linear-gradient(rgba(200,0,0,.15) 10%,rgba(0,0,0,0) 10%);background-size:10px 10px;border:1px dashed transparent;padding:20px}.orgchart .hidden,.orgchart~.hidden{display:none}.orgchart.b2t{transform:rotate(180deg)}.orgchart.l2r{position:absolute;transform:rotate(-90deg) rotateY(180deg);transform-origin:left top}.orgchart .verticalNodes ul{list-style:none;margin:0;padding-left:18px;text-align:left}.orgchart .verticalNodes ul:first-child{margin-top:2px}.orgchart .verticalNodes>td::before{content:'';border:1px solid rgba(217,83,79,.8)}.orgchart .verticalNodes>td>ul>li:first-child::before{box-sizing:border-box;top:-4px;height:30px;width:calc(50% - 2px);border-width:2px 0 0 2px}.orgchart .verticalNodes ul>li{position:relative}.orgchart .verticalNodes ul>li::after,.orgchart .verticalNodes ul>li::before{box-sizing:border-box;content:'';position:absolute;left:-6px;border-color:rgba(217,83,79,.8);border-style:solid;border-width:0 0 2px 2px}.orgchart .verticalNodes ul>li::before{top:-4px;height:30px;width:11px}.orgchart .verticalNodes ul>li::after{top:1px;height:100%}.orgchart .verticalNodes ul>li:first-child::after{box-sizing:border-box;top:24px;width:11px;border-width:2px 0 0 2px}.orgchart .verticalNodes ul>li:last-child::after{box-sizing:border-box;border-width:2px 0 0}.orgchart.r2l{position:absolute;transform:rotate(90deg);transform-origin:left top}.orgchart>.spinner{font-size:100px;margin-top:30px;color:rgba(68,157,68,.8)}.orgchart table{border-spacing:0;border-collapse:separate}.orgchart>table:first-child{margin:20px auto}.orgchart td{text-align:center;vertical-align:top;padding:0}.orgchart .lines:nth-child(3) td{box-sizing:border-box;height:20px}.orgchart .lines .topLine{border-top:2px solid rgba(217,83,79,.8)}.orgchart .lines .rightLine{border-right:1px solid rgba(217,83,79,.8);float:none;border-radius:0}.orgchart .lines .leftLine{border-left:1px solid rgba(217,83,79,.8);float:none;border-radius:0}.orgchart .lines .downLine{background-color:rgba(217,83,79,.8);margin:0 auto;height:20px;width:2px;float:none}.orgchart .node{box-sizing:border-box;display:inline-block;position:relative;margin:0;padding:3px;border:2px dashed transparent;text-align:center;width:130px}.orgchart.l2r .node,.orgchart.r2l .node{width:50px;height:130px}.orgchart .node>.spinner{position:absolute;top:calc(50% - 15px);left:calc(50% - 15px);vertical-align:middle;font-size:30px;color:rgba(68,157,68,.8)}.orgchart .node:hover{background-color:rgba(238,217,54,.5);transition:.5s;cursor:default;z-index:20}.orgchart .node.focused{background-color:rgba(238,217,54,.5)}.orgchart .ghost-node{position:fixed;left:-10000px;top:-10000px}.orgchart .ghost-node rect{fill:#fff;stroke:#bf0000}.orgchart .node.allowedDrop{border-color:rgba(68,157,68,.9)}.orgchart .node .title{text-align:center;font-size:12px;font-weight:700;height:20px;line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;background-color:rgba(217,83,79,.8);color:#fff;border-radius:4px 4px 0 0}.orgchart.b2t .node .title{transform:rotate(-180deg);transform-origin:center bottom}.orgchart.l2r .node .title{transform:rotate(-90deg) translate(-40px,-40px) rotateY(180deg);transform-origin:bottom center;width:120px}.orgchart.r2l .node .title{transform:rotate(-90deg) translate(-40px,-40px);transform-origin:bottom center;width:120px}.orgchart .node .title .symbol{float:left;margin-top:4px;margin-left:2px}.orgchart .node .content{box-sizing:border-box;width:100%;height:20px;font-size:11px;line-height:18px;border:1px solid rgba(217,83,79,.8);border-radius:0 0 4px 4px;text-align:center;background-color:#fff;color:#333;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.orgchart.b2t .node .content{transform:rotate(180deg);transform-origin:center top}.orgchart.l2r .node .content{transform:rotate(-90deg) translate(-40px,-40px) rotateY(180deg);transform-origin:top center;width:120px}.orgchart.r2l .node .content{transform:rotate(-90deg) translate(-40px,-40px);transform-origin:top center;width:120px}.orgchart .node .edge{font-size:15px;position:absolute;color:rgba(68,157,68,.5);cursor:default;transition:.2s}.orgchart.noncollapsable .node .edge{display:none}.orgchart .edge:hover{color:#449d44;cursor:pointer}.orgchart .node .verticalEdge{width:calc(100% - 10px);width:-webkit-calc(100% - 10px);width:-moz-calc(100% - 10px);left:5px}.orgchart .node .topEdge{top:-4px}.orgchart .node .bottomEdge{bottom:-4px}.orgchart .node .horizontalEdge{width:15px;height:calc(100% - 10px);height:-webkit-calc(100% - 10px);height:-moz-calc(100% - 10px);top:5px}.orgchart .node .rightEdge{right:-4px}.orgchart .node .leftEdge{left:-4px}.orgchart .node .horizontalEdge::before{position:absolute;top:calc(50% - 7px)}.orgchart .node .rightEdge::before{right:3px}.orgchart .node .leftEdge::before{left:3px}.orgchart .node .toggleBtn{position:absolute;left:5px;bottom:-2px;color:rgba(68,157,68,.6)}.orgchart .node .toggleBtn:hover{color:rgba(68,157,68,.8)}.oc-export-btn{display:inline-block;position:absolute;right:5px;top:5px;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;touch-action:manipulation;cursor:pointer;user-select:none;color:#fff;background-color:#5cb85c;border:1px solid transparent;border-color:#4cae4c;border-radius:4px}.oc-export-btn[disabled]{cursor:not-allowed;box-shadow:none;opacity:.3}.oc-export-btn:active,.oc-export-btn:focus,.oc-export-btn:hover{background-color:#449d44;border-color:#347a34}.orgchart~.mask{position:absolute;top:0;right:0;bottom:0;left:0;z-index:999;text-align:center;background-color:rgba(0,0,0,.3)}.orgchart~.mask .spinner{position:absolute;top:calc(50% - 54px);left:calc(50% - 54px);color:rgba(255,255,255,.8);font-size:108px}.orgchart .node{transition:transform .3s,opacity .3s}.orgchart .slide-down{opacity:0;transform:translateY(40px)}.orgchart.l2r .node.slide-down,.orgchart.r2l .node.slide-down{transform:translateY(130px)}.orgchart .slide-up{opacity:0;transform:translateY(-40px)}.orgchart.l2r .node.slide-up,.orgchart.r2l .node.slide-up{transform:translateY(-130px)}.orgchart .slide-right{opacity:0;transform:translateX(130px)}.orgchart.l2r .node.slide-right,.orgchart.r2l .node.slide-right{transform:translateX(40px)}.orgchart .slide-left{opacity:0;transform:translateX(-130px)}.orgchart.l2r .node.slide-left,.orgchart.r2l .node.slide-left{transform:translateX(-40px)}#chart-container{position:relative;display:inline-block;top:10px;left:10px;height:420px;width:calc(100% - 24px);border:2px dashed #aaa;border-radius:5px;overflow:auto;text-align:center}</style> <div id=chart-container style=margin-top:25px;padding-top:13px></div> <footer> <md-button class=\"md-fab addFooter add-button buttonAdd fixedButton\" ng-click=create()> <i class=\"fas fa-plus\"></i> </md-button> </footer>";

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, jQuery) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleHeirarchy = function RoleHeirarchy($scope, $state, $mdDialog, localStorageService, ROLEHIERARCHYCONSTANT, authService) {
  'ngInject';

  _classCallCheck(this, RoleHeirarchy);

  this.$state = $state;
  $scope.school_id = localStorageService.get('school_id');
  $scope.chartImgData = [];

  // Meteor.call('getSchoolDetails', Session.get('school_id'), (error, result) => {
  //   if (result) {
  //     let academicYearObj = _.find(result.academic_year, function(data) {
  //       return data.status == 'active'
  //     })
  //     if (!result.logo)
  //       result.logo = DEFAULT_SCHOOL_LOGO
  //     $scope.schoolHeader = {
  //       'schoolName': result.school_name,
  //       'schoolLogo': SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.logo),
  //       'academicYear': academicYearObj.year
  //     }

  //     $scope.$apply()
  //   }
  // })


  'use strict';

  (function (factory) {
    if (( false ? 'undefined' : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
      factory(__webpack_require__(4), window, document);
    } else {
      factory(jQuery, window, document);
    }
  })(function ($, window, document, undefined) {
    var OrgChart = function OrgChart(elem, opts) {
      this.$chartContainer = $(elem);
      this.opts = opts;
      this.defaultOptions = {
        'nodeTitle': 'name',
        'nodeId': 'id',
        'toggleSiblingsResp': false,
        'visibleLevel': 999,
        'chartClass': '',
        'exportButton': false,
        'exportFilename': 'OrgChart',
        'exportFileextension': 'png',
        'parentNodeSymbol': 'fa-users',
        'draggable': false,
        'direction': 't2b',
        'pan': false,
        'zoom': false,
        'zoominLimit': 7,
        'zoomoutLimit': 0.5
      };
    };
    //
    OrgChart.prototype = {
      //
      init: function init(opts) {
        var that = this;
        this.options = $.extend({}, this.defaultOptions, this.opts, opts);
        // build the org-chart
        var $chartContainer = this.$chartContainer;
        if (this.$chart) {
          this.$chart.remove();
        }
        var data = this.options.data;
        var $chart = this.$chart = $('<div>', {
          'data': { 'options': this.options },
          'class': 'orgchart' + (this.options.chartClass !== '' ? ' ' + this.options.chartClass : '') + (this.options.direction !== 't2b' ? ' ' + this.options.direction : ''),
          'click': function click(event) {
            if (!$(event.target).closest('.node').length) {
              $chart.find('.node.focused').removeClass('focused');
            }
          }
        });
        if (typeof MutationObserver !== 'undefined') {
          this.triggerInitEvent();
        }
        if ($.type(data) === 'object') {
          if (data instanceof $) {
            // ul datasource
            this.buildHierarchy($chart, this.buildJsonDS(data.children()), 0, this.options);
          } else {
            // local json datasource
            this.buildHierarchy($chart, this.options.ajaxURL ? data : this.attachRel(data, '00'));
          }
        } else {
          $chart.append('<i class="fa fa-circle-o-notch fa-spin spinner"></i>');
          $.ajax({
            'url': data,
            'dataType': 'json'
          }).done(function (data, textStatus, jqXHR) {
            that.buildHierarchy($chart, that.options.ajaxURL ? data : that.attachRel(data, '00'), 0, that.options);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
          }).always(function () {
            $chart.children('.spinner').remove();
          });
        }
        $chartContainer.append($chart);

        // append the export button
        if (this.options.exportButton && !$chartContainer.find('.oc-export-btn').length) {
          this.attachExportButton();
        }

        if (this.options.pan) {
          this.bindPan();
        }

        if (this.options.zoom) {
          this.bindZoom();
        }

        return this;
      },
      //
      triggerInitEvent: function triggerInitEvent() {
        var that = this;
        var mo = new MutationObserver(function (mutations) {
          mo.disconnect();
          initTime: for (var i = 0; i < mutations.length; i++) {
            for (var j = 0; j < mutations[i].addedNodes.length; j++) {
              if (mutations[i].addedNodes[j].classList.contains('orgchart')) {
                if (that.options.initCompleted && typeof that.options.initCompleted === 'function') {
                  that.options.initCompleted(that.$chart);
                  var initEvent = $.Event('init.orgchart');
                  that.$chart.trigger(initEvent);
                  break initTime;
                }
              }
            }
          }
        });
        mo.observe(this.$chartContainer[0], { childList: true });
      },
      //
      attachExportButton: function attachExportButton() {
        var that = this;
        var $exportBtn = $('<button>', {
          'class': 'oc-export-btn' + (this.options.chartClass !== '' ? ' ' + this.options.chartClass : ''),
          'text': 'Export',
          'click': function click(e) {
            e.preventDefault();
            that.export();
          }
        });
        this.$chartContainer.append($exportBtn);
      },
      setOptions: function setOptions(opts, val) {
        if (typeof opts === 'string') {
          if (opts === 'pan') {
            if (val) {
              this.bindPan();
            } else {
              this.unbindPan();
            }
          }
          if (opts === 'zoom') {
            if (val) {
              this.bindZoom();
            } else {
              this.unbindZoom();
            }
          }
        }
        if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object') {
          if (opts.data) {
            this.init(opts);
          } else {
            if (typeof opts.pan !== 'undefined') {
              if (opts.pan) {
                this.bindPan();
              } else {
                this.unbindPan();
              }
            }
            if (typeof opts.zoom !== 'undefined') {
              if (opts.zoom) {
                this.bindZoom();
              } else {
                this.unbindZoom();
              }
            }
          }
        }

        return this;
      },
      //
      panStartHandler: function panStartHandler(e) {
        var $chart = $(e.delegateTarget);
        if ($(e.target).closest('.node').length || e.touches && e.touches.length > 1) {
          $chart.data('panning', false);
          return;
        } else {
          $chart.css('cursor', 'move').data('panning', true);
        }
        var lastX = 0;
        var lastY = 0;
        var lastTf = $chart.css('transform');
        if (lastTf !== 'none') {
          var temp = lastTf.split(',');
          if (lastTf.indexOf('3d') === -1) {
            lastX = parseInt(temp[4]);
            lastY = parseInt(temp[5]);
          } else {
            lastX = parseInt(temp[12]);
            lastY = parseInt(temp[13]);
          }
        }
        var startX = 0;
        var startY = 0;
        if (!e.targetTouches) {
          // pand on desktop
          startX = e.pageX - lastX;
          startY = e.pageY - lastY;
        } else if (e.targetTouches.length === 1) {
          // pan on mobile device
          startX = e.targetTouches[0].pageX - lastX;
          startY = e.targetTouches[0].pageY - lastY;
        } else if (e.targetTouches.length > 1) {
          return;
        }
        $chart.on('mousemove touchmove', function (e) {
          if (!$chart.data('panning')) {
            return;
          }
          var newX = 0;
          var newY = 0;
          if (!e.targetTouches) {
            // pand on desktop
            newX = e.pageX - startX;
            newY = e.pageY - startY;
          } else if (e.targetTouches.length === 1) {
            // pan on mobile device
            newX = e.targetTouches[0].pageX - startX;
            newY = e.targetTouches[0].pageY - startY;
          } else if (e.targetTouches.length > 1) {
            return;
          }
          var lastTf = $chart.css('transform');
          if (lastTf === 'none') {
            if (lastTf.indexOf('3d') === -1) {
              $chart.css('transform', 'matrix(1, 0, 0, 1, ' + newX + ', ' + newY + ')');
            } else {
              $chart.css('transform', 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + newX + ', ' + newY + ', 0, 1)');
            }
          } else {
            var matrix = lastTf.split(',');
            if (lastTf.indexOf('3d') === -1) {
              matrix[4] = ' ' + newX;
              matrix[5] = ' ' + newY + ')';
            } else {
              matrix[12] = ' ' + newX;
              matrix[13] = ' ' + newY;
            }
            $chart.css('transform', matrix.join(','));
          }
        });
      },
      //
      panEndHandler: function panEndHandler(e) {
        if (e.data.chart.data('panning')) {
          e.data.chart.data('panning', false).css('cursor', 'default').off('mousemove');
        }
      },
      //
      bindPan: function bindPan() {
        this.$chartContainer.css('overflow', 'hidden');
        this.$chart.on('mousedown touchstart', this.panStartHandler);
        $(document).on('mouseup touchend', { 'chart': this.$chart }, this.panEndHandler);
      },
      //
      unbindPan: function unbindPan() {
        this.$chartContainer.css('overflow', 'auto');
        this.$chart.off('mousedown touchstart', this.panStartHandler);
        $(document).off('mouseup touchend', this.panEndHandler);
      },
      //
      zoomWheelHandler: function zoomWheelHandler(e) {
        var oc = e.data.oc;
        e.preventDefault();
        var newScale = 1 + (e.originalEvent.deltaY > 0 ? -0.2 : 0.2);
        oc.setChartScale(oc.$chart, newScale);
      },
      //
      zoomStartHandler: function zoomStartHandler(e) {
        if (e.touches && e.touches.length === 2) {
          var oc = e.data.oc;
          oc.$chart.data('pinching', true);
          var dist = oc.getPinchDist(e);
          oc.$chart.data('pinchDistStart', dist);
        }
      },
      zoomingHandler: function zoomingHandler(e) {
        var oc = e.data.oc;
        if (oc.$chart.data('pinching')) {
          var dist = oc.getPinchDist(e);
          oc.$chart.data('pinchDistEnd', dist);
        }
      },
      zoomEndHandler: function zoomEndHandler(e) {
        var oc = e.data.oc;
        if (oc.$chart.data('pinching')) {
          oc.$chart.data('pinching', false);
          var diff = oc.$chart.data('pinchDistEnd') - oc.$chart.data('pinchDistStart');
          if (diff > 0) {
            oc.setChartScale(oc.$chart, 1.2);
          } else if (diff < 0) {
            oc.setChartScale(oc.$chart, 0.8);
          }
        }
      },
      //
      bindZoom: function bindZoom() {
        this.$chartContainer.on('wheel', { 'oc': this }, this.zoomWheelHandler);
        this.$chartContainer.on('touchstart', { 'oc': this }, this.zoomStartHandler);
        $(document).on('touchmove', { 'oc': this }, this.zoomingHandler);
        $(document).on('touchend', { 'oc': this }, this.zoomEndHandler);
      },
      unbindZoom: function unbindZoom() {
        this.$chartContainer.off('wheel', this.zoomWheelHandler);
        this.$chartContainer.off('touchstart', this.zoomStartHandler);
        $(document).off('touchmove', this.zoomingHandler);
        $(document).off('touchend', this.zoomEndHandler);
      },
      //
      getPinchDist: function getPinchDist(e) {
        return Math.sqrt((e.touches[0].clientX - e.touches[1].clientX) * (e.touches[0].clientX - e.touches[1].clientX) + (e.touches[0].clientY - e.touches[1].clientY) * (e.touches[0].clientY - e.touches[1].clientY));
      },
      //
      setChartScale: function setChartScale($chart, newScale) {
        var opts = $chart.data('options');
        var lastTf = $chart.css('transform');
        var matrix = '';
        var targetScale = 1;
        if (lastTf === 'none') {
          $chart.css('transform', 'scale(' + newScale + ',' + newScale + ')');
        } else {
          matrix = lastTf.split(',');
          if (lastTf.indexOf('3d') === -1) {
            targetScale = Math.abs(window.parseFloat(matrix[3]) * newScale);
            if (targetScale > opts.zoomoutLimit && targetScale < opts.zoominLimit) {
              $chart.css('transform', lastTf + ' scale(' + newScale + ',' + newScale + ')');
            }
          } else {
            targetScale = Math.abs(window.parseFloat(matrix[1]) * newScale);
            if (targetScale > opts.zoomoutLimit && targetScale < opts.zoominLimit) {
              $chart.css('transform', lastTf + ' scale3d(' + newScale + ',' + newScale + ', 1)');
            }
          }
        }
      },
      //
      buildJsonDS: function buildJsonDS($li) {
        var that = this;
        var subObj = {
          'name': $li.contents().eq(0).text().trim(),
          'relationship': ($li.parent().parent().is('li') ? '1' : '0') + ($li.siblings('li').length ? 1 : 0) + ($li.children('ul').length ? 1 : 0)
        };
        if ($li.attr('data-id')) {
          subObj.id = $li.attr('data-id');
        }
        $li.children('ul').children().each(function () {
          if (!subObj.children) {
            subObj.children = [];
          }
          subObj.children.push(that.buildJsonDS($(this)));
        });
        return subObj;
      },
      //
      attachRel: function attachRel(data, flags) {
        var that = this;
        data.relationship = flags + (data.children && data.children.length > 0 ? 1 : 0);
        if (data.children) {
          data.children.forEach(function (item) {
            that.attachRel(item, '1' + (data.children.length > 1 ? 1 : 0));
          });
        }
        return data;
      },
      //
      loopChart: function loopChart($chart) {
        var that = this;
        var $tr = $chart.find('tr:first');
        var subObj = { 'id': $tr.find('.node')[0].id };
        $tr.siblings(':last').children().each(function () {
          if (!subObj.children) {
            subObj.children = [];
          }
          subObj.children.push(that.loopChart($(this)));
        });
        return subObj;
      },
      //
      getHierarchy: function getHierarchy() {
        if (typeof this.$chart === 'undefined') {
          return 'Error: orgchart does not exist';
        } else {
          if (!this.$chart.find('.node').length) {
            return 'Error: nodes do not exist';
          } else {
            var valid = true;
            this.$chart.find('.node').each(function () {
              if (!this.id) {
                valid = false;
                return false;
              }
            });
            if (!valid) {
              return 'Error: All nodes of orghcart to be exported must have data-id attribute!';
            }
          }
        }
        return this.loopChart(this.$chart);
      },
      // detect the exist/display state of related node
      getNodeState: function getNodeState($node, relation) {
        var $target = {};
        var relation = relation || 'self';
        if (relation === 'parent') {
          $target = $node.closest('.nodes').siblings(':first');
          if ($target.length) {
            if ($target.is('.hidden') || !$target.is('.hidden') && $target.closest('.nodes').is('.hidden')) {
              return { 'exist': true, 'visible': false };
            }
            return { 'exist': true, 'visible': true };
          }
        } else if (relation === 'children') {
          $target = $node.closest('tr').siblings(':last');
          if ($target.length) {
            if (!$target.is('.hidden')) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        } else if (relation === 'siblings') {
          $target = $node.closest('table').parent().siblings();
          if ($target.length) {
            if (!$target.is('.hidden') && !$target.parent().is('.hidden')) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        } else {
          $target = $node;
          if ($target.length) {
            if (!($target.closest('.nodes').length && $target.closest('.nodes').is('.hidden') || $target.closest('table').parent().length && $target.closest('table').parent().is('.hidden') || $target.parent().is('li') && ($target.closest('ul').is('.hidden') || $target.closest('verticalNodes').is('.hidden')))) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        }
        return { 'exist': false, 'visible': false };
      },
      // find the related nodes
      getRelatedNodes: function getRelatedNodes($node, relation) {
        if (!$node || !($node instanceof $) || !$node.is('.node')) {
          return $();
        }
        if (relation === 'parent') {
          return $node.closest('.nodes').parent().children(':first').find('.node');
        } else if (relation === 'children') {
          return $node.closest('tr').siblings('.nodes').children().find('.node:first');
        } else if (relation === 'siblings') {
          return $node.closest('table').parent().siblings().find('.node:first');
        } else {
          return $();
        }
      },
      hideParentEnd: function hideParentEnd(event) {
        $(event.target).removeClass('sliding');
        event.data.upperLevel.addClass('hidden').slice(1).removeAttr('style');
      },
      // recursively hide the ancestor node and sibling nodes of the specified node
      hideParent: function hideParent($node) {
        var $upperLevel = $node.closest('.nodes').siblings();
        if ($upperLevel.eq(0).find('.spinner').length) {
          $node.closest('.orgchart').data('inAjax', false);
        }
        // hide the sibling nodes
        if (this.getNodeState($node, 'siblings').visible) {
          this.hideSiblings($node);
        }
        // hide the lines
        var $lines = $upperLevel.slice(1);
        $lines.css('visibility', 'hidden');
        // hide the superior nodes with transition
        var $parent = $upperLevel.eq(0).find('.node');
        if (this.getNodeState($parent).visible) {
          $parent.addClass('sliding slide-down').one('transitionend', { 'upperLevel': $upperLevel }, this.hideParentEnd);
        }
        // if the current node has the parent node, hide it recursively
        if (this.getNodeState($parent, 'parent').visible) {
          this.hideParent($parent);
        }
      },
      showParentEnd: function showParentEnd(event) {
        var $node = event.data.node;
        $(event.target).removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.topEdge'));
        }
      },
      // show the parent node of the specified node
      showParent: function showParent($node) {
        // just show only one superior level
        var $upperLevel = $node.closest('.nodes').siblings().removeClass('hidden');
        // just show only one line
        $upperLevel.eq(2).children().slice(1, -1).addClass('hidden');
        // show parent node with animation
        var $parent = $upperLevel.eq(0).find('.node');
        this.repaint($parent[0]);
        $parent.addClass('sliding').removeClass('slide-down').one('transitionend', { 'node': $node }, this.showParentEnd.bind(this));
      },
      stopAjax: function stopAjax($nodeLevel) {
        if ($nodeLevel.find('.spinner').length) {
          $nodeLevel.closest('.orgchart').data('inAjax', false);
        }
      },
      isVisibleNode: function isVisibleNode(index, elem) {
        return this.getNodeState($(elem)).visible;
      },
      //
      hideChildrenEnd: function hideChildrenEnd(event) {
        var $node = event.data.node;
        event.data.animatedNodes.removeClass('sliding');
        if (event.data.isVerticalDesc) {
          event.data.lowerLevel.addClass('hidden');
        } else {
          event.data.animatedNodes.closest('.nodes').prevAll('.lines').removeAttr('style').addBack().addClass('hidden');
          event.data.lowerLevel.last().find('.verticalNodes').addClass('hidden');
        }
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // recursively hide the descendant nodes of the specified node
      hideChildren: function hideChildren($node) {
        var $lowerLevel = $node.closest('tr').siblings();
        this.stopAjax($lowerLevel.last());
        var $animatedNodes = $lowerLevel.last().find('.node').filter(this.isVisibleNode.bind(this));
        var isVerticalDesc = $lowerLevel.last().is('.verticalNodes') ? true : false;
        if (!isVerticalDesc) {
          $animatedNodes.closest('table').closest('tr').prevAll('.lines').css('visibility', 'hidden');
        }
        this.repaint($animatedNodes.get(0));
        $animatedNodes.addClass('sliding slide-up').eq(0).one('transitionend', { 'animatedNodes': $animatedNodes, 'lowerLevel': $lowerLevel, 'isVerticalDesc': isVerticalDesc, 'node': $node }, this.hideChildrenEnd.bind(this));
      },
      //
      showChildrenEnd: function showChildrenEnd(event) {
        var $node = event.data.node;
        event.data.animatedNodes.removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // show the children nodes of the specified node
      showChildren: function showChildren($node) {
        var that = this;
        var $levels = $node.closest('tr').siblings();
        var isVerticalDesc = $levels.is('.verticalNodes') ? true : false;
        var $animatedNodes = isVerticalDesc ? $levels.removeClass('hidden').find('.node').filter(this.isVisibleNode.bind(this)) : $levels.removeClass('hidden').eq(2).children().find('.node:first').filter(this.isVisibleNode.bind(this));
        // the two following statements are used to enforce browser to repaint
        this.repaint($animatedNodes.get(0));
        $animatedNodes.addClass('sliding').removeClass('slide-up').eq(0).one('transitionend', { 'node': $node, 'animatedNodes': $animatedNodes }, this.showChildrenEnd.bind(this));
      },
      //
      hideSiblingsEnd: function hideSiblingsEnd(event) {
        var $node = event.data.node;
        var $nodeContainer = event.data.nodeContainer;
        var direction = event.data.direction;
        event.data.lines.removeAttr('style');
        var $siblings = direction ? direction === 'left' ? $nodeContainer.prevAll(':not(.hidden)') : $nodeContainer.nextAll(':not(.hidden)') : $nodeContainer.siblings();
        $nodeContainer.closest('.nodes').prev().children(':not(.hidden)').slice(1, direction ? $siblings.length * 2 + 1 : -1).addClass('hidden');
        event.data.animatedNodes.removeClass('sliding');
        $siblings.find('.node:gt(0)').filter(this.isVisibleNode.bind(this)).removeClass('slide-left slide-right').addClass('slide-up');
        $siblings.find('.lines, .nodes, .verticalNodes').addClass('hidden').end().addClass('hidden');

        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
        }
      },
      // hide the sibling nodes of the specified node
      hideSiblings: function hideSiblings($node, direction) {
        var that = this;
        var $nodeContainer = $node.closest('table').parent();
        if ($nodeContainer.siblings().find('.spinner').length) {
          $node.closest('.orgchart').data('inAjax', false);
        }
        if (direction) {
          if (direction === 'left') {
            $nodeContainer.prevAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-right');
          } else {
            $nodeContainer.nextAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-left');
          }
        } else {
          $nodeContainer.prevAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-right');
          $nodeContainer.nextAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-left');
        }
        var $animatedNodes = $nodeContainer.siblings().find('.sliding');
        var $lines = $animatedNodes.closest('.nodes').prevAll('.lines').css('visibility', 'hidden');
        $animatedNodes.eq(0).one('transitionend', { 'node': $node, 'nodeContainer': $nodeContainer, 'direction': direction, 'animatedNodes': $animatedNodes, 'lines': $lines }, this.hideSiblingsEnd.bind(this));
      },
      //
      showSiblingsEnd: function showSiblingsEnd(event) {
        var $node = event.data.node;
        event.data.visibleNodes.removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
          $node.children('.topEdge').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
      },
      //
      showRelatedParentEnd: function showRelatedParentEnd(event) {
        $(event.target).removeClass('sliding');
      },
      // show the sibling nodes of the specified node
      showSiblings: function showSiblings($node, direction) {
        var that = this;
        // firstly, show the sibling td tags
        var $siblings = $();
        if (direction) {
          if (direction === 'left') {
            $siblings = $node.closest('table').parent().prevAll().removeClass('hidden');
          } else {
            $siblings = $node.closest('table').parent().nextAll().removeClass('hidden');
          }
        } else {
          $siblings = $node.closest('table').parent().siblings().removeClass('hidden');
        }
        // secondly, show the lines
        var $upperLevel = $node.closest('table').closest('tr').siblings();
        if (direction) {
          $upperLevel.eq(2).children('.hidden').slice(0, $siblings.length * 2).removeClass('hidden');
        } else {
          $upperLevel.eq(2).children('.hidden').removeClass('hidden');
        }
        // thirdly, do some cleaning stuff
        if (!this.getNodeState($node, 'parent').visible) {
          $upperLevel.removeClass('hidden');
          var parent = $upperLevel.find('.node')[0];
          this.repaint(parent);
          $(parent).addClass('sliding').removeClass('slide-down').one('transitionend', this.showRelatedParentEnd);
        }
        // lastly, show the sibling nodes with animation
        var $visibleNodes = $siblings.find('.node').filter(this.isVisibleNode.bind(this));
        this.repaint($visibleNodes.get(0));
        $visibleNodes.addClass('sliding').removeClass('slide-left slide-right');
        $visibleNodes.eq(0).one('transitionend', { 'node': $node, 'visibleNodes': $visibleNodes }, this.showSiblingsEnd.bind(this));
      },
      // start up loading status for requesting new nodes
      startLoading: function startLoading($edge) {
        var $chart = this.$chart;
        if (typeof $chart.data('inAjax') !== 'undefined' && $chart.data('inAjax') === true) {
          return false;
        }

        $edge.addClass('hidden');
        $edge.parent().append('<i class="fa fa-circle-o-notch fa-spin spinner"></i>').children().not('.spinner').css('opacity', 0.2);
        $chart.data('inAjax', true);
        $('.oc-export-btn' + (this.options.chartClass !== '' ? '.' + this.options.chartClass : '')).prop('disabled', true);
        return true;
      },
      // terminate loading status for requesting new nodes
      endLoading: function endLoading($edge) {
        var $node = $edge.parent();
        $edge.removeClass('hidden');
        $node.find('.spinner').remove();
        $node.children().removeAttr('style');
        this.$chart.data('inAjax', false);
        $('.oc-export-btn' + (this.options.chartClass !== '' ? '.' + this.options.chartClass : '')).prop('disabled', false);
      },
      // whether the cursor is hovering over the node
      isInAction: function isInAction($node) {
        return $node.children('.edge').attr('class').indexOf('fa-') > -1 ? true : false;
      },
      //
      switchVerticalArrow: function switchVerticalArrow($arrow) {
        $arrow.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      },
      //
      switchHorizontalArrow: function switchHorizontalArrow($node) {
        var opts = this.options;
        if (opts.toggleSiblingsResp && (typeof opts.ajaxURL === 'undefined' || $node.closest('.nodes').data('siblingsLoaded'))) {
          var $prevSib = $node.closest('table').parent().prev();
          if ($prevSib.length) {
            if ($prevSib.is('.hidden')) {
              $node.children('.leftEdge').addClass('fa-chevron-left').removeClass('fa-chevron-right');
            } else {
              $node.children('.leftEdge').addClass('fa-chevron-right').removeClass('fa-chevron-left');
            }
          }
          var $nextSib = $node.closest('table').parent().next();
          if ($nextSib.length) {
            if ($nextSib.is('.hidden')) {
              $node.children('.rightEdge').addClass('fa-chevron-right').removeClass('fa-chevron-left');
            } else {
              $node.children('.rightEdge').addClass('fa-chevron-left').removeClass('fa-chevron-right');
            }
          }
        } else {
          var $sibs = $node.closest('table').parent().siblings();
          var sibsVisible = $sibs.length ? !$sibs.is('.hidden') : false;
          $node.children('.leftEdge').toggleClass('fa-chevron-right', sibsVisible).toggleClass('fa-chevron-left', !sibsVisible);
          $node.children('.rightEdge').toggleClass('fa-chevron-left', sibsVisible).toggleClass('fa-chevron-right', !sibsVisible);
        }
      },
      //
      repaint: function repaint(node) {
        if (node) {
          node.style.offsetWidth = node.offsetWidth;
        }
      },
      //
      nodeEnterLeaveHandler: function nodeEnterLeaveHandler(event) {
        var $node = $(event.delegateTarget),
            flag = false;
        var $topEdge = $node.children('.topEdge');
        var $rightEdge = $node.children('.rightEdge');
        var $bottomEdge = $node.children('.bottomEdge');
        var $leftEdge = $node.children('.leftEdge');
        if (event.type === 'mouseenter') {
          if ($topEdge.length) {
            flag = this.getNodeState($node, 'parent').visible;
            $topEdge.toggleClass('fa-chevron-up', !flag).toggleClass('fa-chevron-down', flag);
          }
          if ($bottomEdge.length) {
            flag = this.getNodeState($node, 'children').visible;
            $bottomEdge.toggleClass('fa-chevron-down', !flag).toggleClass('fa-chevron-up', flag);
          }
          if ($leftEdge.length) {
            this.switchHorizontalArrow($node);
          }
        } else {
          $node.children('.edge').removeClass('fa-chevron-up fa-chevron-down fa-chevron-right fa-chevron-left');
        }
      },
      //
      nodeClickHandler: function nodeClickHandler(event) {
        this.$chart.find('.focused').removeClass('focused');
        $(event.delegateTarget).addClass('focused');
      },
      // load new nodes by ajax
      loadNodes: function loadNodes(rel, url, $edge) {
        var that = this;
        var opts = this.options;
        $.ajax({ 'url': url, 'dataType': 'json' }).done(function (data) {
          if (that.$chart.data('inAjax')) {
            if (rel === 'parent') {
              if (!$.isEmptyObject(data)) {
                that.addParent($edge.parent(), data);
              }
            } else if (rel === 'children') {
              if (data.children.length) {
                that.addChildren($edge.parent(), data[rel]);
              }
            } else {
              that.addSiblings($edge.parent(), data.siblings ? data.siblings : data);
            }
          }
        }).fail(function () {
          console.log('Failed to get ' + rel + ' data');
        }).always(function () {
          that.endLoading($edge);
        });
      },
      //
      HideFirstParentEnd: function HideFirstParentEnd(event) {
        var $topEdge = event.data.topEdge;
        var $node = $topEdge.parent();
        if (this.isInAction($node)) {
          this.switchVerticalArrow($topEdge);
          this.switchHorizontalArrow($node);
        }
      },
      //
      topEdgeClickHandler: function topEdgeClickHandler(event) {
        event.stopPropagation();
        var that = this;
        var $topEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var parentState = this.getNodeState($node, 'parent');
        if (parentState.exist) {
          var $parent = $node.closest('table').closest('tr').siblings(':first').find('.node');
          if ($parent.is('.sliding')) {
            return;
          }
          // hide the ancestor nodes and sibling nodes of the specified node
          if (parentState.visible) {
            this.hideParent($node);
            $parent.one('transitionend', { 'topEdge': $topEdge }, this.HideFirstParentEnd.bind(this));
          } else {
            // show the ancestors and siblings
            this.showParent($node);
          }
        } else {
          // load the new parent node of the specified node by ajax request
          // start up loading status
          if (this.startLoading($topEdge)) {
            var opts = this.options;
            var url = $.isFunction(opts.ajaxURL.parent) ? opts.ajaxURL.parent(event.data.nodeData) : opts.ajaxURL.parent + $node[0].id;
            this.loadNodes('parent', url, $topEdge);
          }
        }
      },
      //
      bottomEdgeClickHandler: function bottomEdgeClickHandler(event) {
        event.stopPropagation();
        var $bottomEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var childrenState = this.getNodeState($node, 'children');
        if (childrenState.exist) {
          var $children = $node.closest('tr').siblings(':last');
          if ($children.find('.sliding').length) {
            return;
          }
          // hide the descendant nodes of the specified node
          if (childrenState.visible) {
            this.hideChildren($node);
          } else {
            // show the descendants
            this.showChildren($node);
          }
        } else {
          // load the new children nodes of the specified node by ajax request
          if (this.startLoading($bottomEdge)) {
            var opts = this.options;
            var url = $.isFunction(opts.ajaxURL.children) ? opts.ajaxURL.children(event.data.nodeData) : opts.ajaxURL.children + $node[0].id;
            this.loadNodes('children', url, $bottomEdge);
          }
        }
      },
      //
      hEdgeClickHandler: function hEdgeClickHandler(event) {
        event.stopPropagation();
        var $hEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var opts = this.options;
        var siblingsState = this.getNodeState($node, 'siblings');
        if (siblingsState.exist) {
          var $siblings = $node.closest('table').parent().siblings();
          if ($siblings.find('.sliding').length) {
            return;
          }
          if (opts.toggleSiblingsResp) {
            var $prevSib = $node.closest('table').parent().prev();
            var $nextSib = $node.closest('table').parent().next();
            if ($hEdge.is('.leftEdge')) {
              if ($prevSib.is('.hidden')) {
                this.showSiblings($node, 'left');
              } else {
                this.hideSiblings($node, 'left');
              }
            } else {
              if ($nextSib.is('.hidden')) {
                this.showSiblings($node, 'right');
              } else {
                this.hideSiblings($node, 'right');
              }
            }
          } else {
            if (siblingsState.visible) {
              this.hideSiblings($node);
            } else {
              this.showSiblings($node);
            }
          }
        } else {
          // load the new sibling nodes of the specified node by ajax request
          if (this.startLoading($hEdge)) {
            var nodeId = $node[0].id;
            var url = this.getNodeState($node, 'parent').exist ? $.isFunction(opts.ajaxURL.siblings) ? opts.ajaxURL.siblings(event.data.nodeData) : opts.ajaxURL.siblings + nodeId : $.isFunction(opts.ajaxURL.families) ? opts.ajaxURL.families(event.data.nodeData) : opts.ajaxURL.families + nodeId;
            this.loadNodes('siblings', url, $hEdge);
          }
        }
      },
      //
      expandVNodesEnd: function expandVNodesEnd(event) {
        event.data.vNodes.removeClass('sliding');
      },
      //
      collapseVNodesEnd: function collapseVNodesEnd(event) {
        event.data.vNodes.removeClass('sliding').closest('ul').addClass('hidden');
      },
      // event handler for toggle buttons in Hybrid(horizontal + vertical) OrgChart
      toggleVNodes: function toggleVNodes(event) {
        var $toggleBtn = $(event.target);
        var $descWrapper = $toggleBtn.parent().next();
        var $descendants = $descWrapper.find('.node');
        var $children = $descWrapper.children().children('.node');
        if ($children.is('.sliding')) {
          return;
        }
        $toggleBtn.toggleClass('fa-plus-square fa-minus-square');
        if ($descendants.eq(0).is('.slide-up')) {
          $descWrapper.removeClass('hidden');
          this.repaint($children.get(0));
          $children.addClass('sliding').removeClass('slide-up').eq(0).one('transitionend', { 'vNodes': $children }, this.expandVNodesEnd);
        } else {
          $descendants.addClass('sliding slide-up').eq(0).one('transitionend', { 'vNodes': $descendants }, this.collapseVNodesEnd);
          $descendants.find('.toggleBtn').removeClass('fa-minus-square').addClass('fa-plus-square');
        }
      },
      //
      createGhostNode: function createGhostNode(event) {
        var $nodeDiv = $(event.target);
        var opts = this.options;
        var origEvent = event.originalEvent;
        var isFirefox = /firefox/.test(window.navigator.userAgent.toLowerCase());
        if (isFirefox) {
          origEvent.dataTransfer.setData('text/html', 'hack for firefox');
        }
        var ghostNode, nodeCover;
        if (!document.querySelector('.ghost-node')) {
          ghostNode = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          ghostNode.classList.add('ghost-node');
          nodeCover = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          ghostNode.appendChild(nodeCover);
          $nodeDiv.closest('.orgchart').append(ghostNode);
        } else {
          ghostNode = $nodeDiv.closest('.orgchart').children('.ghost-node').get(0);
          nodeCover = $(ghostNode).children().get(0);
        }
        var transValues = $nodeDiv.closest('.orgchart').css('transform').split(',');
        var scale = Math.abs(window.parseFloat(opts.direction === 't2b' || opts.direction === 'b2t' ? transValues[0].slice(transValues[0].indexOf('(') + 1) : transValues[1]));
        ghostNode.setAttribute('width', $nodeDiv.outerWidth(false));
        ghostNode.setAttribute('height', $nodeDiv.outerHeight(false));
        nodeCover.setAttribute('x', 5 * scale);
        nodeCover.setAttribute('y', 5 * scale);
        nodeCover.setAttribute('width', 120 * scale);
        nodeCover.setAttribute('height', 40 * scale);
        nodeCover.setAttribute('rx', 4 * scale);
        nodeCover.setAttribute('ry', 4 * scale);
        nodeCover.setAttribute('stroke-width', 1 * scale);
        var xOffset = origEvent.offsetX * scale;
        var yOffset = origEvent.offsetY * scale;
        if (opts.direction === 'l2r') {
          xOffset = origEvent.offsetY * scale;
          yOffset = origEvent.offsetX * scale;
        } else if (opts.direction === 'r2l') {
          xOffset = $nodeDiv.outerWidth(false) - origEvent.offsetY * scale;
          yOffset = origEvent.offsetX * scale;
        } else if (opts.direction === 'b2t') {
          xOffset = $nodeDiv.outerWidth(false) - origEvent.offsetX * scale;
          yOffset = $nodeDiv.outerHeight(false) - origEvent.offsetY * scale;
        }
        if (isFirefox) {
          // hack for old version of Firefox(< 48.0)
          nodeCover.setAttribute('fill', 'rgb(255, 255, 255)');
          nodeCover.setAttribute('stroke', 'rgb(191, 0, 0)');
          var ghostNodeWrapper = document.createElement('img');
          ghostNodeWrapper.src = 'data:image/svg+xml;utf8,' + new XMLSerializer().serializeToString(ghostNode);
          origEvent.dataTransfer.setDragImage(ghostNodeWrapper, xOffset, yOffset);
        } else {
          origEvent.dataTransfer.setDragImage(ghostNode, xOffset, yOffset);
        }
      },
      //
      filterAllowedDropNodes: function filterAllowedDropNodes($dragged) {
        var opts = this.options;
        var $dragZone = $dragged.closest('.nodes').siblings().eq(0).find('.node:first');
        var $dragHier = $dragged.closest('table').find('.node');
        this.$chart.data('dragged', $dragged).find('.node').each(function (index, node) {
          if ($dragHier.index(node) === -1) {
            if (opts.dropCriteria) {
              if (opts.dropCriteria($dragged, $dragZone, $(node))) {
                $(node).addClass('allowedDrop');
              }
            } else {
              $(node).addClass('allowedDrop');
            }
          }
        });
      },
      //
      dragstartHandler: function dragstartHandler(event) {
        // if users enable zoom or direction options
        if (this.$chart.css('transform') !== 'none') {
          this.createGhostNode(event);
        }
        this.filterAllowedDropNodes($(event.target));
      },
      //
      dragoverHandler: function dragoverHandler(event) {
        event.preventDefault();
        if (!$(event.delegateTarget).is('.allowedDrop')) {
          event.originalEvent.dataTransfer.dropEffect = 'none';
        }
      },
      //
      dragendHandler: function dragendHandler(event) {
        this.$chart.find('.allowedDrop').removeClass('allowedDrop');
      },
      //
      dropHandler: function dropHandler(event) {
        var $dropZone = $(event.delegateTarget);
        var $dragged = this.$chart.data('dragged');
        var $dragZone = $dragged.closest('.nodes').siblings().eq(0).children();
        var dropEvent = $.Event('nodedrop.orgchart');
        this.$chart.trigger(dropEvent, { 'draggedNode': $dragged, 'dragZone': $dragZone.children(), 'dropZone': $dropZone });
        if (dropEvent.isDefaultPrevented()) {
          return;
        }
        // firstly, deal with the hierarchy of drop zone
        if (!$dropZone.closest('tr').siblings().length) {
          // if the drop zone is a leaf node
          $dropZone.append('<i class="edge verticalEdge bottomEdge fa"></i>').parent().attr('colspan', 2).parent().after('<tr class="lines"><td colspan="2"><div class="downLine"></div></td></tr>' + '<tr class="lines"><td class="rightLine"></td><td class="leftLine"></td></tr>' + '<tr class="nodes"></tr>').siblings(':last').append($dragged.find('.horizontalEdge').remove().end().closest('table').parent());
        } else {
          var dropColspan = parseInt($dropZone.parent().attr('colspan')) + 2;
          var horizontalEdges = '<i class="edge horizontalEdge rightEdge fa"></i><i class="edge horizontalEdge leftEdge fa"></i>';
          $dropZone.closest('tr').next().addBack().children().attr('colspan', dropColspan);
          if (!$dragged.find('.horizontalEdge').length) {
            $dragged.append(horizontalEdges);
          }
          $dropZone.closest('tr').siblings().eq(1).children(':last').before('<td class="leftLine topLine"></td><td class="rightLine topLine"></td>').end().next().append($dragged.closest('table').parent());
          var $dropSibs = $dragged.closest('table').parent().siblings().find('.node:first');
          if ($dropSibs.length === 1) {
            $dropSibs.append(horizontalEdges);
          }
        }
        // secondly, deal with the hierarchy of dragged node
        var dragColspan = parseInt($dragZone.attr('colspan'));
        if (dragColspan > 2) {
          $dragZone.attr('colspan', dragColspan - 2).parent().next().children().attr('colspan', dragColspan - 2).end().next().children().slice(1, 3).remove();
          var $dragSibs = $dragZone.parent().siblings('.nodes').children().find('.node:first');
          if ($dragSibs.length === 1) {
            $dragSibs.find('.horizontalEdge').remove();
          }
        } else {
          $dragZone.removeAttr('colspan').find('.bottomEdge').remove().end().end().siblings().remove();
        }
      },
      //
      touchstartHandler: function touchstartHandler(event) {
        console.log("orgChart: touchstart 1: touchHandled=" + this.touchHandled + ", touchMoved=" + this.touchMoved + ", target=" + event.target.innerText);
        if (this.touchHandled) return;
        this.touchHandled = true;
        this.touchMoved = false; // this is so we can work out later if this was a 'press' or a 'drag' touch
        event.preventDefault();
      },
      //
      touchmoveHandler: function touchmoveHandler(event) {
        if (!this.touchHandled) return;
        event.preventDefault();
        if (!this.touchMoved) {
          var nodeIsSelected = $(this).hasClass('focused');
          console.log("orgChart: touchmove 1: " + event.touches.length + " touches, we have not moved, so simulate a drag start", event.touches);
          // TODO: visualise the start of the drag (as would happen on desktop)
          this.simulateMouseEvent(event, 'dragstart');
        }
        this.touchMoved = true;
        var $touching = $(document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY));
        var $touchingNode = $touching.closest('div.node');

        if ($touchingNode.length > 0) {
          var touchingNodeElement = $touchingNode[0];
          // TODO: simulate the dragover visualisation
          if ($touchingNode.is('.allowedDrop')) {
            console.log("orgChart: touchmove 2: this node (" + touchingNodeElement.id + ") is allowed to be a drop target");
            this.touchTargetNode = touchingNodeElement;
          } else {
            console.log("orgChart: touchmove 3: this node (" + touchingNodeElement.id + ") is NOT allowed to be a drop target");
            this.touchTargetNode = null;
          }
        } else {
          console.log("orgchart: touchmove 4: not touching a node");
          this.touchTargetNode = null;
        }
      },
      //
      touchendHandler: function touchendHandler(event) {
        console.log("orgChart: touchend 1: touchHandled=" + this.touchHandled + ", touchMoved=" + this.touchMoved + ", " + event.target.innerText + " ");
        if (!this.touchHandled) {
          console.log("orgChart: touchend 2: not handled by us, so aborting");
          return;
        }
        if (this.touchMoved) {
          // we've had movement, so this was a 'drag' touch
          if (this.touchTargetNode) {
            console.log("orgChart: touchend 3: moved to a node, so simulating drop");
            var fakeEventForDropHandler = { delegateTarget: this.touchTargetNode };
            this.dropHandler(fakeEventForDropHandler);
            this.touchTargetNode = null;
          }
          console.log("orgChart: touchend 4: simulating dragend");
          this.simulateMouseEvent(event, 'dragend');
        } else {
          // we did not move, so assume this was a 'press' touch
          console.log("orgChart: touchend 5: moved, so simulating click");
          this.simulateMouseEvent(event, 'click');
        }
        this.touchHandled = false;
      },
      // simulate a mouse event (so we can fake them on a touch device)
      simulateMouseEvent: function simulateMouseEvent(event, simulatedType) {
        // Ignore multi-touch events
        if (event.originalEvent.touches.length > 1) {
          return;
        }
        var touch = event.originalEvent.changedTouches[0];
        var simulatedEvent = document.createEvent('MouseEvents');
        simulatedEvent.initMouseEvent(simulatedType, // type
        true, // bubbles                    
        true, // cancelable                 
        window, // view                       
        1, // detail                     
        touch.screenX, // screenX                    
        touch.screenY, // screenY                    
        touch.clientX, // clientX                    
        touch.clientY, // clientY                    
        false, // ctrlKey                    
        false, // altKey                     
        false, // shiftKey                   
        false, // metaKey                    
        0, // button                     
        null // relatedTarget              
        );
        // Dispatch the simulated event to the target element
        event.target.dispatchEvent(simulatedEvent);
      },
      //
      bindDragDrop: function bindDragDrop($node) {
        $node.on('dragstart', this.dragstartHandler.bind(this)).on('dragover', this.dragoverHandler.bind(this)).on('dragend', this.dragendHandler.bind(this)).on('drop', this.dropHandler.bind(this)).on('touchstart', this.touchstartHandler.bind(this)).on('touchmove', this.touchmoveHandler.bind(this)).on('touchend', this.touchendHandler.bind(this));
      },
      // create node
      createNode: function createNode(data) {
        var that = this;
        var opts = this.options;
        var level = data.level;
        if (data.children) {
          $.each(data.children, function (index, child) {
            child.parentId = data.id;
          });
        }
        // construct the content of node
        var $nodeDiv = $('<div' + (opts.draggable ? ' draggable="true"' : '') + (data[opts.nodeId] ? ' id="' + data[opts.nodeId] + '"' : '') + (data.parentId ? ' data-parent="' + data.parentId + '"' : '') + '>').addClass('node ' + (data.className || '') + (level > opts.visibleLevel ? ' slide-up' : ''));
        if (opts.nodeTemplate) {
          $nodeDiv.append(opts.nodeTemplate(data));
        } else {
          $nodeDiv.append('<div class="title">' + data[opts.nodeTitle] + '</div>');
          /* .append(typeof opts.nodeContent !== 'undefined' ? '<div class="content">' + (data[opts.nodeContent] || '') + '</div>' : '');*/
        }
        // append 4 direction arrows or expand/collapse buttons
        var flags = data.relationship || '';
        if (opts.verticalLevel && level >= opts.verticalLevel) {
          if (level + 1 > opts.verticalLevel && Number(flags.substr(2, 1))) {
            var icon = level + 1 > opts.visibleLevel ? 'plus' : 'minus';
            $nodeDiv.append('<i class="toggleBtn fa fa-' + icon + '-square"></i>');
          }
        } else {
          if (Number(flags.substr(0, 1))) {
            $nodeDiv.append('<i class="edge verticalEdge topEdge fa"></i>');
          }
          if (Number(flags.substr(1, 1))) {
            $nodeDiv.append('<i class="edge horizontalEdge rightEdge fa"></i>' + '<i class="edge horizontalEdge leftEdge fa"></i>');
          }
          if (Number(flags.substr(2, 1))) {
            $nodeDiv.append('<i class="edge verticalEdge bottomEdge fa"></i>').children('.title').prepend('<i class="fa ' + opts.parentNodeSymbol + ' symbol"></i>');
          }
        }

        $nodeDiv.on('mouseenter mouseleave', this.nodeEnterLeaveHandler.bind(this));
        $nodeDiv.on('click', this.nodeClickHandler.bind(this));
        $nodeDiv.on('click', '.topEdge', { 'nodeData': data }, this.topEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.bottomEdge', { 'nodeData': data }, this.bottomEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.leftEdge, .rightEdge', { 'nodeData': data }, this.hEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.toggleBtn', this.toggleVNodes.bind(this));

        if (opts.draggable) {
          this.bindDragDrop($nodeDiv);
          this.touchHandled = false;
          this.touchMoved = false;
          this.touchTargetNode = null;
        }
        // allow user to append dom modification after finishing node create of orgchart
        if (opts.createNode) {
          opts.createNode($nodeDiv, data);
        }

        return $nodeDiv;
      },
      // recursively build the tree
      buildHierarchy: function buildHierarchy($appendTo, data) {
        var that = this;
        var opts = this.options;
        var level = 0;
        if (data.level) {
          level = data.level;
        } else {
          level = data.level = $appendTo.parentsUntil('.orgchart', '.nodes').length + 1;
        }
        // Construct the node
        var childrenData = data.children;
        var hasChildren = childrenData ? childrenData.length : false;
        var $nodeWrapper;
        if (Object.keys(data).length > 2) {
          var $nodeDiv = this.createNode(data);
          if (opts.verticalLevel && level >= opts.verticalLevel) {
            $appendTo.append($nodeDiv);
          } else {
            $nodeWrapper = $('<table>');
            $appendTo.append($nodeWrapper.append($('<tr/>').append($('<td' + (hasChildren ? ' colspan="' + childrenData.length * 2 + '"' : '') + '></td>').append($nodeDiv))));
          }
        }
        // Construct the lower level(two "connectiong lines" rows and "inferior nodes" row)
        if (hasChildren) {
          var isHidden = level + 1 > opts.visibleLevel || data.collapsed ? ' hidden' : '';
          var isVerticalLayer = opts.verticalLevel && level + 1 >= opts.verticalLevel ? true : false;
          var $nodesLayer;
          if (isVerticalLayer) {
            $nodesLayer = $('<ul>');
            if (isHidden && level + 1 > opts.verticalLevel) {
              $nodesLayer.addClass(isHidden);
            }
            if (level + 1 === opts.verticalLevel) {
              $appendTo.children('table').append('<tr class="verticalNodes' + isHidden + '"><td></td></tr>').find('.verticalNodes').children().append($nodesLayer);
            } else {
              $appendTo.append($nodesLayer);
            }
          } else {
            var $upperLines = $('<tr class="lines' + isHidden + '"><td colspan="' + childrenData.length * 2 + '"><div class="downLine"></div></td></tr>');
            var lowerLines = '<tr class="lines' + isHidden + '"><td class="rightLine"></td>';
            for (var i = 1; i < childrenData.length; i++) {
              lowerLines += '<td class="leftLine topLine"></td><td class="rightLine topLine"></td>';
            }
            lowerLines += '<td class="leftLine"></td></tr>';
            $nodesLayer = $('<tr class="nodes' + isHidden + '">');
            if (Object.keys(data).length === 2) {
              $appendTo.append($upperLines).append(lowerLines).append($nodesLayer);
            } else {
              $nodeWrapper.append($upperLines).append(lowerLines).append($nodesLayer);
            }
          }
          // recurse through children nodes
          $.each(childrenData, function () {
            var $nodeCell = isVerticalLayer ? $('<li>') : $('<td colspan="2">');
            $nodesLayer.append($nodeCell);
            this.level = level + 1;
            that.buildHierarchy($nodeCell, this);
          });
        }
      },
      // build the child nodes of specific node
      buildChildNode: function buildChildNode($appendTo, data) {
        $appendTo.find('td:first').attr('colspan', data.length * 2);
        this.buildHierarchy($appendTo, { 'children': data });
      },
      // exposed method
      addChildren: function addChildren($node, data) {
        this.buildChildNode($node.closest('table'), data);
        if (!$node.children('.bottomEdge').length) {
          $node.append('<i class="edge verticalEdge bottomEdge fa"></i>');
        }
        if (!$node.find('.symbol').length) {
          $node.children('.title').prepend('<i class="fa ' + this.options.parentNodeSymbol + ' symbol"></i>');
        }
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // build the parent node of specific node
      buildParentNode: function buildParentNode($currentRoot, data) {
        data.relationship = data.relationship || '001';
        var $table = $('<table>').append($('<tr>').append($('<td colspan="2">').append(this.createNode(data)))).append('<tr class="lines"><td colspan="2"><div class="downLine"></div></td></tr>').append('<tr class="lines"><td class="rightLine"></td><td class="leftLine"></td></tr>');
        this.$chart.prepend($table).children('table:first').append('<tr class="nodes"><td colspan="2"></td></tr>').children('tr:last').children().append(this.$chart.children('table').last());
      },
      // exposed method
      addParent: function addParent($currentRoot, data) {
        this.buildParentNode($currentRoot, data);
        if (!$currentRoot.children('.topEdge').length) {
          $currentRoot.children('.title').after('<i class="edge verticalEdge topEdge fa"></i>');
        }
        if (this.isInAction($currentRoot)) {
          this.switchVerticalArrow($currentRoot.children('.topEdge'));
        }
      },
      // subsequent processing of build sibling nodes
      complementLine: function complementLine($oneSibling, siblingCount, existingSibligCount) {
        var lines = '';
        for (var i = 0; i < existingSibligCount; i++) {
          lines += '<td class="leftLine topLine"></td><td class="rightLine topLine"></td>';
        }
        $oneSibling.parent().prevAll('tr:gt(0)').children().attr('colspan', siblingCount * 2).end().next().children(':first').after(lines);
      },
      // build the sibling nodes of specific node
      buildSiblingNode: function buildSiblingNode($nodeChart, data) {
        var newSiblingCount = $.isArray(data) ? data.length : data.children.length;
        var existingSibligCount = $nodeChart.parent().is('td') ? $nodeChart.closest('tr').children().length : 1;
        var siblingCount = existingSibligCount + newSiblingCount;
        var insertPostion = siblingCount > 1 ? Math.floor(siblingCount / 2 - 1) : 0;
        // just build the sibling nodes for the specific node
        if ($nodeChart.parent().is('td')) {
          var $parent = $nodeChart.closest('tr').prevAll('tr:last');
          $nodeChart.closest('tr').prevAll('tr:lt(2)').remove();
          this.buildChildNode($nodeChart.parent().closest('table'), data);
          var $siblingTds = $nodeChart.parent().closest('table').children('tr:last').children('td');
          if (existingSibligCount > 1) {
            this.complementLine($siblingTds.eq(0).before($nodeChart.closest('td').siblings().addBack().unwrap()), siblingCount, existingSibligCount);
          } else {
            this.complementLine($siblingTds.eq(insertPostion).after($nodeChart.closest('td').unwrap()), siblingCount, 1);
          }
        } else {
          // build the sibling nodes and parent node for the specific ndoe
          this.buildHierarchy($nodeChart.closest('.orgchart'), data);
          this.complementLine($nodeChart.next().children('tr:last').children().eq(insertPostion).after($('<td colspan="2">').append($nodeChart)), siblingCount, 1);
        }
      },
      //
      addSiblings: function addSiblings($node, data) {
        this.buildSiblingNode($node.closest('table'), data);
        $node.closest('.nodes').data('siblingsLoaded', true);
        if (!$node.children('.leftEdge').length) {
          $node.children('.topEdge').after('<i class="edge horizontalEdge rightEdge fa"></i><i class="edge horizontalEdge leftEdge fa"></i>');
        }
        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
          $node.children('.topEdge').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
      },
      //
      removeNodes: function removeNodes($node) {
        var $parent = $node.closest('table').parent();
        var $sibs = $parent.parent().siblings();
        if ($parent.is('td')) {
          if (this.getNodeState($node, 'siblings').exist) {
            $sibs.eq(2).children('.topLine:lt(2)').remove();
            $sibs.slice(0, 2).children().attr('colspan', $sibs.eq(2).children().length);
            $parent.remove();
          } else {
            $sibs.eq(0).children().removeAttr('colspan').find('.bottomEdge').remove().end().end().siblings().remove();
          }
        } else {
          $parent.add($parent.siblings()).remove();
        }
      },
      //
      export: function _export(exportFilename, exportFileextension) {
        var that = this;
        exportFilename = typeof exportFilename !== 'undefined' ? exportFilename : this.options.exportFilename;
        exportFileextension = typeof exportFileextension !== 'undefined' ? exportFileextension : this.options.exportFileextension;
        if ($(this).children('.spinner').length) {
          return false;
        }
        var $chartContainer = this.$chartContainer;
        var $mask = $chartContainer.find('.mask');
        if (!$mask.length) {
          $chartContainer.append('<div class="mask"><i class="fa fa-circle-o-notch fa-spin spinner"></i></div>');
        } else {
          $mask.removeClass('hidden');
        }
        var sourceChart = $chartContainer.addClass('canvasContainer').find('.orgchart:not(".hidden")').get(0);
        var flag = that.options.direction === 'l2r' || that.options.direction === 'r2l';
        html2canvas(sourceChart, {
          'width': flag ? sourceChart.clientHeight : sourceChart.clientWidth,
          'height': flag ? sourceChart.clientWidth : sourceChart.clientHeight,
          'onclone': function onclone(cloneDoc) {
            $(cloneDoc).find('.canvasContainer').css('overflow', 'visible').find('.orgchart:not(".hidden"):first').css('transform', '');
          },
          'onrendered': function onrendered(canvas) {
            $chartContainer.find('.mask').addClass('hidden');
            if (exportFileextension.toLowerCase() === 'pdf') {
              var doc = {};
              var docWidth = Math.floor(canvas.width * 0.2646);
              var docHeight = Math.floor(canvas.height * 0.2646);
              if (docWidth > docHeight) {
                doc = new jsPDF('l', 'mm', [docWidth, docHeight]);
              } else {
                doc = new jsPDF('p', 'mm', [docHeight, docWidth]);
              }
              doc.addImage(canvas.toDataURL(), 'png', 0, 0);
              doc.save(exportFilename + '.pdf');
            } else {
              var isWebkit = 'WebkitAppearance' in document.documentElement.style;
              var isFf = !!window.sidebar;
              var isEdge = navigator.appName === 'Microsoft Internet Explorer' || navigator.appName === "Netscape" && navigator.appVersion.indexOf('Edge') > -1;

              if (!isWebkit && !isFf || isEdge) {
                window.navigator.msSaveBlob(canvas.msToBlob(), exportFilename + '.png');
              } else {
                var selector = '.oc-download-btn' + (that.options.chartClass !== '' ? '.' + that.options.chartClass : '');
                if (!$chartContainer.find(selector).length) {
                  $chartContainer.append('<a class="oc-download-btn' + (that.options.chartClass !== '' ? ' ' + that.options.chartClass : '') + '"' + ' download="' + exportFilename + '.png"></a>');
                }
                $chartContainer.find(selector).attr('href', canvas.toDataURL())[0].click();
              }
            }
          }
        }).then(function () {
          $chartContainer.removeClass('canvasContainer');
        }, function () {
          $chartContainer.removeClass('canvasContainer');
        });
      }
    };

    $.fn.orgchart = function (opts) {
      return new OrgChart(this, opts).init();
    };
    /************ API CALL TO GET ALL ROLES & THEIR PRIVILEGES ***********/
    /* Function to display roles and their module status.
     * @school_id : String - 
     * @return : List of modules 
     * @Developer : Ashitha
    */
    authService.callAPI(ROLEHIERARCHYCONSTANT.API_GET_ROLE_HIERARCHY + $scope.school_id, "GET", {}, function (response) {
      console.log(response);
      if (response && response.result && response.result.data && response.result.data.data && response.result.data.data.length > 0) {
        var result = response.result.data.data[0];
        $('#chart-container').orgchart({
          'data': result,
          'nodeContent': 'title'
        });
      }
    });
  });

  $scope.create = function () {
    $state.go("roleMapping");
  };
};
RoleHeirarchy.$inject = ["$scope", "$state", "$mdDialog", "localStorageService", "ROLEHIERARCHYCONSTANT", "authService"];

exports.default = RoleHeirarchy;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)(module), __webpack_require__(4)))

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports = "<style>.orgchart{box-sizing:border-box;display:inline-block;min-height:202px;min-width:202px;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-image:linear-gradient(90deg,rgba(200,0,0,.15) 10%,rgba(0,0,0,0) 10%),linear-gradient(rgba(200,0,0,.15) 10%,rgba(0,0,0,0) 10%);background-size:10px 10px;border:1px dashed transparent;padding:20px}.orgchart .hidden,.orgchart~.hidden{display:none}.orgchart.b2t{transform:rotate(180deg)}.orgchart.l2r{position:absolute;transform:rotate(-90deg) rotateY(180deg);transform-origin:left top}.orgchart .verticalNodes ul{list-style:none;margin:0;padding-left:18px;text-align:left}.orgchart .verticalNodes ul:first-child{margin-top:2px}.orgchart .verticalNodes>td::before{content:'';border:1px solid rgba(217,83,79,.8)}.orgchart .verticalNodes>td>ul>li:first-child::before{box-sizing:border-box;top:-4px;height:30px;width:calc(50% - 2px);border-width:2px 0 0 2px}.orgchart .verticalNodes ul>li{position:relative}.orgchart .verticalNodes ul>li::after,.orgchart .verticalNodes ul>li::before{box-sizing:border-box;content:'';position:absolute;left:-6px;border-color:rgba(217,83,79,.8);border-style:solid;border-width:0 0 2px 2px}.orgchart .verticalNodes ul>li::before{top:-4px;height:30px;width:11px}.orgchart .verticalNodes ul>li::after{top:1px;height:100%}.orgchart .verticalNodes ul>li:first-child::after{box-sizing:border-box;top:24px;width:11px;border-width:2px 0 0 2px}.orgchart .verticalNodes ul>li:last-child::after{box-sizing:border-box;border-width:2px 0 0}.orgchart.r2l{position:absolute;transform:rotate(90deg);transform-origin:left top}.orgchart>.spinner{font-size:100px;margin-top:30px;color:rgba(68,157,68,.8)}.orgchart table{border-spacing:0;border-collapse:separate}.orgchart>table:first-child{margin:20px auto}.orgchart td{text-align:center;vertical-align:top;padding:0}.orgchart .lines:nth-child(3) td{box-sizing:border-box;height:20px}.orgchart .lines .topLine{border-top:2px solid rgba(217,83,79,.8)}.orgchart .lines .rightLine{border-right:1px solid rgba(217,83,79,.8);float:none;border-radius:0}.orgchart .lines .leftLine{border-left:1px solid rgba(217,83,79,.8);float:none;border-radius:0}.orgchart .lines .downLine{background-color:rgba(217,83,79,.8);margin:0 auto;height:20px;width:2px;float:none}.orgchart .node{box-sizing:border-box;display:inline-block;position:relative;margin:0;padding:3px;border:2px dashed transparent;text-align:center;width:130px}.orgchart.l2r .node,.orgchart.r2l .node{width:50px;height:130px}.orgchart .node>.spinner{position:absolute;top:calc(50% - 15px);left:calc(50% - 15px);vertical-align:middle;font-size:30px;color:rgba(68,157,68,.8)}.orgchart .node:hover{background-color:rgba(238,217,54,.5);transition:.5s;cursor:default;z-index:20}.orgchart .node.focused{background-color:rgba(238,217,54,.5)}.orgchart .ghost-node{position:fixed;left:-10000px;top:-10000px}.orgchart .ghost-node rect{fill:#fff;stroke:#bf0000}.orgchart .node.allowedDrop{border-color:rgba(68,157,68,.9)}.orgchart .node .title{text-align:center;font-size:12px;font-weight:700;height:20px;line-height:20px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;background-color:rgba(217,83,79,.8);color:#fff;border-radius:4px 4px 0 0}.orgchart.b2t .node .title{transform:rotate(-180deg);transform-origin:center bottom}.orgchart.l2r .node .title{transform:rotate(-90deg) translate(-40px,-40px) rotateY(180deg);transform-origin:bottom center;width:120px}.orgchart.r2l .node .title{transform:rotate(-90deg) translate(-40px,-40px);transform-origin:bottom center;width:120px}.orgchart .node .title .symbol{float:left;margin-top:4px;margin-left:2px}.orgchart .node .content{box-sizing:border-box;width:100%;height:20px;font-size:11px;line-height:18px;border:1px solid rgba(217,83,79,.8);border-radius:0 0 4px 4px;text-align:center;background-color:#fff;color:#333;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.orgchart.b2t .node .content{transform:rotate(180deg);transform-origin:center top}.orgchart.l2r .node .content{transform:rotate(-90deg) translate(-40px,-40px) rotateY(180deg);transform-origin:top center;width:120px}.orgchart.r2l .node .content{transform:rotate(-90deg) translate(-40px,-40px);transform-origin:top center;width:120px}.orgchart .node .edge{font-size:15px;position:absolute;color:rgba(68,157,68,.5);cursor:default;transition:.2s}.orgchart.noncollapsable .node .edge{display:none}.orgchart .edge:hover{color:#449d44;cursor:pointer}.orgchart .node .verticalEdge{width:calc(100% - 10px);width:-webkit-calc(100% - 10px);width:-moz-calc(100% - 10px);left:5px}.orgchart .node .topEdge{top:-4px}.orgchart .node .bottomEdge{bottom:-4px}.orgchart .node .horizontalEdge{width:15px;height:calc(100% - 10px);height:-webkit-calc(100% - 10px);height:-moz-calc(100% - 10px);top:5px}.orgchart .node .rightEdge{right:-4px}.orgchart .node .leftEdge{left:-4px}.orgchart .node .horizontalEdge::before{position:absolute;top:calc(50% - 7px)}.orgchart .node .rightEdge::before{right:3px}.orgchart .node .leftEdge::before{left:3px}.orgchart .node .toggleBtn{position:absolute;left:5px;bottom:-2px;color:rgba(68,157,68,.6)}.orgchart .node .toggleBtn:hover{color:rgba(68,157,68,.8)}.oc-export-btn{display:inline-block;position:absolute;right:5px;top:5px;padding:6px 12px;margin-bottom:0;font-size:14px;font-weight:400;line-height:1.42857143;text-align:center;white-space:nowrap;vertical-align:middle;touch-action:manipulation;cursor:pointer;user-select:none;color:#fff;background-color:#5cb85c;border:1px solid transparent;border-color:#4cae4c;border-radius:4px}.oc-export-btn[disabled]{cursor:not-allowed;box-shadow:none;opacity:.3}.oc-export-btn:active,.oc-export-btn:focus,.oc-export-btn:hover{background-color:#449d44;border-color:#347a34}.orgchart~.mask{position:absolute;top:0;right:0;bottom:0;left:0;z-index:999;text-align:center;background-color:rgba(0,0,0,.3)}.orgchart~.mask .spinner{position:absolute;top:calc(50% - 54px);left:calc(50% - 54px);color:rgba(255,255,255,.8);font-size:108px}.orgchart .node{transition:transform .3s,opacity .3s}.orgchart .slide-down{opacity:0;transform:translateY(40px)}.orgchart.l2r .node.slide-down,.orgchart.r2l .node.slide-down{transform:translateY(130px)}.orgchart .slide-up{opacity:0;transform:translateY(-40px)}.orgchart.l2r .node.slide-up,.orgchart.r2l .node.slide-up{transform:translateY(-130px)}.orgchart .slide-right{opacity:0;transform:translateX(130px)}.orgchart.l2r .node.slide-right,.orgchart.r2l .node.slide-right{transform:translateX(40px)}.orgchart .slide-left{opacity:0;transform:translateX(-130px)}.orgchart.l2r .node.slide-left,.orgchart.r2l .node.slide-left{transform:translateX(-40px)}#chart-container{position:relative;display:inline-block;top:10px;left:10px;height:420px;width:calc(100% - 24px);border:2px dashed #aaa;border-radius:5px;overflow:auto;text-align:center}</style> <div layout=column class=reporting-roles> <div class=\"md-whiteframe-2dp md-margin\" style=margin-top:25px;padding-top:13px> <span layout=row layout-align=\"center center\"> User Hierarchy</span> <div layout=row layout-align=\"end end\" class=md-margin> <div ng-if=\"heirarchyList.length>0\" id=btn-Preview-Image class=report-close tooltip=\"Download PDF\" tooltip-position=left ng-click=generatePDF()> <i class=\"material-icons icons\">picture_as_pdf</i> </div> </div> <div id=chart-container></div> <div ng-if=\"heirarchyList.length==0\" class=md-margin layout=row layout-align=\"center center\"> <a ng-click=create() class=new-group-link>Click here.</a> to create hierarchy </div> </div> </div> <footer> <md-button class=\"md-fab addFooter add-button buttonAdd fixedButton\" ng-click=create()> <i class=\"fas fa-plus\"></i> </md-button> </footer> ";

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, jQuery, $) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserHierarchy = function UserHierarchy($scope, $state, $mdDialog, USERHIERARCHYCONSTANT, authService, localStorageService) {
  'ngInject';

  _classCallCheck(this, UserHierarchy);

  this.$state = $state;
  $scope.school_id = localStorageService.get('school_id');
  $scope.chartImgData = [];

  // Meteor.call('getSchoolDetails', Session.get('school_id'), (error, result) => {
  //   if (result) {
  //     let academicYearObj = _.find(result.academic_year, function(data) {
  //       return data.status == 'active'
  //     })
  //     if (!result.logo)
  //       result.logo = DEFAULT_SCHOOL_LOGO
  //     $scope.schoolHeader = {
  //       'schoolName': result.school_name,
  //       'schoolLogo': SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.logo),
  //       'academicYear': academicYearObj.year
  //     }
  //     convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function(base64Image) {
  //       $scope.imgurl1 = base64Image;
  //     })
  //     $scope.$apply()
  //   }
  // })


  'use strict';

  (function (factory) {
    if (( false ? 'undefined' : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
      factory(__webpack_require__(4), window, document);
    } else {
      factory(jQuery, window, document);
    }
  })(function ($, window, document, undefined) {
    var OrgChart = function OrgChart(elem, opts) {
      this.$chartContainer = $(elem);
      this.opts = opts;
      this.defaultOptions = {
        'nodeTitle': 'name',
        'nodeId': 'id',
        'toggleSiblingsResp': false,
        'visibleLevel': 999,
        'chartClass': '',
        'exportButton': false,
        'exportFilename': 'OrgChart',
        'exportFileextension': 'png',
        'parentNodeSymbol': 'fa-users',
        'draggable': false,
        'direction': 't2b',
        'pan': false,
        'zoom': false,
        'zoominLimit': 7,
        'zoomoutLimit': 0.5
      };
    };
    //
    OrgChart.prototype = {
      //
      init: function init(opts) {
        var that = this;
        this.options = $.extend({}, this.defaultOptions, this.opts, opts);
        // build the org-chart
        var $chartContainer = this.$chartContainer;
        if (this.$chart) {
          this.$chart.remove();
        }
        var data = this.options.data;
        var $chart = this.$chart = $('<div>', {
          'data': { 'options': this.options },
          'class': 'orgchart' + (this.options.chartClass !== '' ? ' ' + this.options.chartClass : '') + (this.options.direction !== 't2b' ? ' ' + this.options.direction : ''),
          'click': function click(event) {
            if (!$(event.target).closest('.node').length) {
              $chart.find('.node.focused').removeClass('focused');
            }
          }
        });
        if (typeof MutationObserver !== 'undefined') {
          this.triggerInitEvent();
        }
        if ($.type(data) === 'object') {
          if (data instanceof $) {
            // ul datasource
            this.buildHierarchy($chart, this.buildJsonDS(data.children()), 0, this.options);
          } else {
            // local json datasource
            this.buildHierarchy($chart, this.options.ajaxURL ? data : this.attachRel(data, '00'));
          }
        } else {
          $chart.append('<i class="fa fa-circle-o-notch fa-spin spinner"></i>');
          $.ajax({
            'url': data,
            'dataType': 'json'
          }).done(function (data, textStatus, jqXHR) {
            that.buildHierarchy($chart, that.options.ajaxURL ? data : that.attachRel(data, '00'), 0, that.options);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
          }).always(function () {
            $chart.children('.spinner').remove();
          });
        }
        $chartContainer.append($chart);

        // append the export button
        if (this.options.exportButton && !$chartContainer.find('.oc-export-btn').length) {
          this.attachExportButton();
        }

        if (this.options.pan) {
          this.bindPan();
        }

        if (this.options.zoom) {
          this.bindZoom();
        }

        return this;
      },
      //
      triggerInitEvent: function triggerInitEvent() {
        var that = this;
        var mo = new MutationObserver(function (mutations) {
          mo.disconnect();
          initTime: for (var i = 0; i < mutations.length; i++) {
            for (var j = 0; j < mutations[i].addedNodes.length; j++) {
              if (mutations[i].addedNodes[j].classList.contains('orgchart')) {
                if (that.options.initCompleted && typeof that.options.initCompleted === 'function') {
                  that.options.initCompleted(that.$chart);
                  var initEvent = $.Event('init.orgchart');
                  that.$chart.trigger(initEvent);
                  break initTime;
                }
              }
            }
          }
        });
        mo.observe(this.$chartContainer[0], { childList: true });
      },
      //
      attachExportButton: function attachExportButton() {
        var that = this;
        var $exportBtn = $('<button>', {
          'class': 'oc-export-btn' + (this.options.chartClass !== '' ? ' ' + this.options.chartClass : ''),
          'text': 'Export',
          'click': function click(e) {
            e.preventDefault();
            that.export();
          }
        });
        this.$chartContainer.append($exportBtn);
      },
      setOptions: function setOptions(opts, val) {
        if (typeof opts === 'string') {
          if (opts === 'pan') {
            if (val) {
              this.bindPan();
            } else {
              this.unbindPan();
            }
          }
          if (opts === 'zoom') {
            if (val) {
              this.bindZoom();
            } else {
              this.unbindZoom();
            }
          }
        }
        if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) === 'object') {
          if (opts.data) {
            this.init(opts);
          } else {
            if (typeof opts.pan !== 'undefined') {
              if (opts.pan) {
                this.bindPan();
              } else {
                this.unbindPan();
              }
            }
            if (typeof opts.zoom !== 'undefined') {
              if (opts.zoom) {
                this.bindZoom();
              } else {
                this.unbindZoom();
              }
            }
          }
        }

        return this;
      },
      //
      panStartHandler: function panStartHandler(e) {
        var $chart = $(e.delegateTarget);
        if ($(e.target).closest('.node').length || e.touches && e.touches.length > 1) {
          $chart.data('panning', false);
          return;
        } else {
          $chart.css('cursor', 'move').data('panning', true);
        }
        var lastX = 0;
        var lastY = 0;
        var lastTf = $chart.css('transform');
        if (lastTf !== 'none') {
          var temp = lastTf.split(',');
          if (lastTf.indexOf('3d') === -1) {
            lastX = parseInt(temp[4]);
            lastY = parseInt(temp[5]);
          } else {
            lastX = parseInt(temp[12]);
            lastY = parseInt(temp[13]);
          }
        }
        var startX = 0;
        var startY = 0;
        if (!e.targetTouches) {
          // pand on desktop
          startX = e.pageX - lastX;
          startY = e.pageY - lastY;
        } else if (e.targetTouches.length === 1) {
          // pan on mobile device
          startX = e.targetTouches[0].pageX - lastX;
          startY = e.targetTouches[0].pageY - lastY;
        } else if (e.targetTouches.length > 1) {
          return;
        }
        $chart.on('mousemove touchmove', function (e) {
          if (!$chart.data('panning')) {
            return;
          }
          var newX = 0;
          var newY = 0;
          if (!e.targetTouches) {
            // pand on desktop
            newX = e.pageX - startX;
            newY = e.pageY - startY;
          } else if (e.targetTouches.length === 1) {
            // pan on mobile device
            newX = e.targetTouches[0].pageX - startX;
            newY = e.targetTouches[0].pageY - startY;
          } else if (e.targetTouches.length > 1) {
            return;
          }
          var lastTf = $chart.css('transform');
          if (lastTf === 'none') {
            if (lastTf.indexOf('3d') === -1) {
              $chart.css('transform', 'matrix(1, 0, 0, 1, ' + newX + ', ' + newY + ')');
            } else {
              $chart.css('transform', 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + newX + ', ' + newY + ', 0, 1)');
            }
          } else {
            var matrix = lastTf.split(',');
            if (lastTf.indexOf('3d') === -1) {
              matrix[4] = ' ' + newX;
              matrix[5] = ' ' + newY + ')';
            } else {
              matrix[12] = ' ' + newX;
              matrix[13] = ' ' + newY;
            }
            $chart.css('transform', matrix.join(','));
          }
        });
      },
      //
      panEndHandler: function panEndHandler(e) {
        if (e.data.chart.data('panning')) {
          e.data.chart.data('panning', false).css('cursor', 'default').off('mousemove');
        }
      },
      //
      bindPan: function bindPan() {
        this.$chartContainer.css('overflow', 'hidden');
        this.$chart.on('mousedown touchstart', this.panStartHandler);
        $(document).on('mouseup touchend', { 'chart': this.$chart }, this.panEndHandler);
      },
      //
      unbindPan: function unbindPan() {
        this.$chartContainer.css('overflow', 'auto');
        this.$chart.off('mousedown touchstart', this.panStartHandler);
        $(document).off('mouseup touchend', this.panEndHandler);
      },
      //
      zoomWheelHandler: function zoomWheelHandler(e) {
        var oc = e.data.oc;
        e.preventDefault();
        var newScale = 1 + (e.originalEvent.deltaY > 0 ? -0.2 : 0.2);
        oc.setChartScale(oc.$chart, newScale);
      },
      //
      zoomStartHandler: function zoomStartHandler(e) {
        if (e.touches && e.touches.length === 2) {
          var oc = e.data.oc;
          oc.$chart.data('pinching', true);
          var dist = oc.getPinchDist(e);
          oc.$chart.data('pinchDistStart', dist);
        }
      },
      zoomingHandler: function zoomingHandler(e) {
        var oc = e.data.oc;
        if (oc.$chart.data('pinching')) {
          var dist = oc.getPinchDist(e);
          oc.$chart.data('pinchDistEnd', dist);
        }
      },
      zoomEndHandler: function zoomEndHandler(e) {
        var oc = e.data.oc;
        if (oc.$chart.data('pinching')) {
          oc.$chart.data('pinching', false);
          var diff = oc.$chart.data('pinchDistEnd') - oc.$chart.data('pinchDistStart');
          if (diff > 0) {
            oc.setChartScale(oc.$chart, 1.2);
          } else if (diff < 0) {
            oc.setChartScale(oc.$chart, 0.8);
          }
        }
      },
      //
      bindZoom: function bindZoom() {
        this.$chartContainer.on('wheel', { 'oc': this }, this.zoomWheelHandler);
        this.$chartContainer.on('touchstart', { 'oc': this }, this.zoomStartHandler);
        $(document).on('touchmove', { 'oc': this }, this.zoomingHandler);
        $(document).on('touchend', { 'oc': this }, this.zoomEndHandler);
      },
      unbindZoom: function unbindZoom() {
        this.$chartContainer.off('wheel', this.zoomWheelHandler);
        this.$chartContainer.off('touchstart', this.zoomStartHandler);
        $(document).off('touchmove', this.zoomingHandler);
        $(document).off('touchend', this.zoomEndHandler);
      },
      //
      getPinchDist: function getPinchDist(e) {
        return Math.sqrt((e.touches[0].clientX - e.touches[1].clientX) * (e.touches[0].clientX - e.touches[1].clientX) + (e.touches[0].clientY - e.touches[1].clientY) * (e.touches[0].clientY - e.touches[1].clientY));
      },
      //
      setChartScale: function setChartScale($chart, newScale) {
        var opts = $chart.data('options');
        var lastTf = $chart.css('transform');
        var matrix = '';
        var targetScale = 1;
        if (lastTf === 'none') {
          $chart.css('transform', 'scale(' + newScale + ',' + newScale + ')');
        } else {
          matrix = lastTf.split(',');
          if (lastTf.indexOf('3d') === -1) {
            targetScale = Math.abs(window.parseFloat(matrix[3]) * newScale);
            if (targetScale > opts.zoomoutLimit && targetScale < opts.zoominLimit) {
              $chart.css('transform', lastTf + ' scale(' + newScale + ',' + newScale + ')');
            }
          } else {
            targetScale = Math.abs(window.parseFloat(matrix[1]) * newScale);
            if (targetScale > opts.zoomoutLimit && targetScale < opts.zoominLimit) {
              $chart.css('transform', lastTf + ' scale3d(' + newScale + ',' + newScale + ', 1)');
            }
          }
        }
      },
      //
      buildJsonDS: function buildJsonDS($li) {
        var that = this;
        var subObj = {
          'name': $li.contents().eq(0).text().trim(),
          'relationship': ($li.parent().parent().is('li') ? '1' : '0') + ($li.siblings('li').length ? 1 : 0) + ($li.children('ul').length ? 1 : 0)
        };
        if ($li.attr('data-id')) {
          subObj.id = $li.attr('data-id');
        }
        $li.children('ul').children().each(function () {
          if (!subObj.children) {
            subObj.children = [];
          }
          subObj.children.push(that.buildJsonDS($(this)));
        });
        return subObj;
      },
      //
      attachRel: function attachRel(data, flags) {
        var that = this;
        data.relationship = flags + (data.children && data.children.length > 0 ? 1 : 0);
        if (data.children) {
          data.children.forEach(function (item) {
            that.attachRel(item, '1' + (data.children.length > 1 ? 1 : 0));
          });
        }
        return data;
      },
      //
      loopChart: function loopChart($chart) {
        var that = this;
        var $tr = $chart.find('tr:first');
        var subObj = { 'id': $tr.find('.node')[0].id };
        $tr.siblings(':last').children().each(function () {
          if (!subObj.children) {
            subObj.children = [];
          }
          subObj.children.push(that.loopChart($(this)));
        });
        return subObj;
      },
      //
      getHierarchy: function getHierarchy() {
        if (typeof this.$chart === 'undefined') {
          return 'Error: orgchart does not exist';
        } else {
          if (!this.$chart.find('.node').length) {
            return 'Error: nodes do not exist';
          } else {
            var valid = true;
            this.$chart.find('.node').each(function () {
              if (!this.id) {
                valid = false;
                return false;
              }
            });
            if (!valid) {
              return 'Error: All nodes of orghcart to be exported must have data-id attribute!';
            }
          }
        }
        return this.loopChart(this.$chart);
      },
      // detect the exist/display state of related node
      getNodeState: function getNodeState($node, relation) {
        var $target = {};
        var relation = relation || 'self';
        if (relation === 'parent') {
          $target = $node.closest('.nodes').siblings(':first');
          if ($target.length) {
            if ($target.is('.hidden') || !$target.is('.hidden') && $target.closest('.nodes').is('.hidden')) {
              return { 'exist': true, 'visible': false };
            }
            return { 'exist': true, 'visible': true };
          }
        } else if (relation === 'children') {
          $target = $node.closest('tr').siblings(':last');
          if ($target.length) {
            if (!$target.is('.hidden')) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        } else if (relation === 'siblings') {
          $target = $node.closest('table').parent().siblings();
          if ($target.length) {
            if (!$target.is('.hidden') && !$target.parent().is('.hidden')) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        } else {
          $target = $node;
          if ($target.length) {
            if (!($target.closest('.nodes').length && $target.closest('.nodes').is('.hidden') || $target.closest('table').parent().length && $target.closest('table').parent().is('.hidden') || $target.parent().is('li') && ($target.closest('ul').is('.hidden') || $target.closest('verticalNodes').is('.hidden')))) {
              return { 'exist': true, 'visible': true };
            }
            return { 'exist': true, 'visible': false };
          }
        }
        return { 'exist': false, 'visible': false };
      },
      // find the related nodes
      getRelatedNodes: function getRelatedNodes($node, relation) {
        if (!$node || !($node instanceof $) || !$node.is('.node')) {
          return $();
        }
        if (relation === 'parent') {
          return $node.closest('.nodes').parent().children(':first').find('.node');
        } else if (relation === 'children') {
          return $node.closest('tr').siblings('.nodes').children().find('.node:first');
        } else if (relation === 'siblings') {
          return $node.closest('table').parent().siblings().find('.node:first');
        } else {
          return $();
        }
      },
      hideParentEnd: function hideParentEnd(event) {
        $(event.target).removeClass('sliding');
        event.data.upperLevel.addClass('hidden').slice(1).removeAttr('style');
      },
      // recursively hide the ancestor node and sibling nodes of the specified node
      hideParent: function hideParent($node) {
        var $upperLevel = $node.closest('.nodes').siblings();
        if ($upperLevel.eq(0).find('.spinner').length) {
          $node.closest('.orgchart').data('inAjax', false);
        }
        // hide the sibling nodes
        if (this.getNodeState($node, 'siblings').visible) {
          this.hideSiblings($node);
        }
        // hide the lines
        var $lines = $upperLevel.slice(1);
        $lines.css('visibility', 'hidden');
        // hide the superior nodes with transition
        var $parent = $upperLevel.eq(0).find('.node');
        if (this.getNodeState($parent).visible) {
          $parent.addClass('sliding slide-down').one('transitionend', { 'upperLevel': $upperLevel }, this.hideParentEnd);
        }
        // if the current node has the parent node, hide it recursively
        if (this.getNodeState($parent, 'parent').visible) {
          this.hideParent($parent);
        }
      },
      showParentEnd: function showParentEnd(event) {
        var $node = event.data.node;
        $(event.target).removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.topEdge'));
        }
      },
      // show the parent node of the specified node
      showParent: function showParent($node) {
        // just show only one superior level
        var $upperLevel = $node.closest('.nodes').siblings().removeClass('hidden');
        // just show only one line
        $upperLevel.eq(2).children().slice(1, -1).addClass('hidden');
        // show parent node with animation
        var $parent = $upperLevel.eq(0).find('.node');
        this.repaint($parent[0]);
        $parent.addClass('sliding').removeClass('slide-down').one('transitionend', { 'node': $node }, this.showParentEnd.bind(this));
      },
      stopAjax: function stopAjax($nodeLevel) {
        if ($nodeLevel.find('.spinner').length) {
          $nodeLevel.closest('.orgchart').data('inAjax', false);
        }
      },
      isVisibleNode: function isVisibleNode(index, elem) {
        return this.getNodeState($(elem)).visible;
      },
      //
      hideChildrenEnd: function hideChildrenEnd(event) {
        var $node = event.data.node;
        event.data.animatedNodes.removeClass('sliding');
        if (event.data.isVerticalDesc) {
          event.data.lowerLevel.addClass('hidden');
        } else {
          event.data.animatedNodes.closest('.nodes').prevAll('.lines').removeAttr('style').addBack().addClass('hidden');
          event.data.lowerLevel.last().find('.verticalNodes').addClass('hidden');
        }
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // recursively hide the descendant nodes of the specified node
      hideChildren: function hideChildren($node) {
        var $lowerLevel = $node.closest('tr').siblings();
        this.stopAjax($lowerLevel.last());
        var $animatedNodes = $lowerLevel.last().find('.node').filter(this.isVisibleNode.bind(this));
        var isVerticalDesc = $lowerLevel.last().is('.verticalNodes') ? true : false;
        if (!isVerticalDesc) {
          $animatedNodes.closest('table').closest('tr').prevAll('.lines').css('visibility', 'hidden');
        }
        this.repaint($animatedNodes.get(0));
        $animatedNodes.addClass('sliding slide-up').eq(0).one('transitionend', { 'animatedNodes': $animatedNodes, 'lowerLevel': $lowerLevel, 'isVerticalDesc': isVerticalDesc, 'node': $node }, this.hideChildrenEnd.bind(this));
      },
      //
      showChildrenEnd: function showChildrenEnd(event) {
        var $node = event.data.node;
        event.data.animatedNodes.removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // show the children nodes of the specified node
      showChildren: function showChildren($node) {
        var that = this;
        var $levels = $node.closest('tr').siblings();
        var isVerticalDesc = $levels.is('.verticalNodes') ? true : false;
        var $animatedNodes = isVerticalDesc ? $levels.removeClass('hidden').find('.node').filter(this.isVisibleNode.bind(this)) : $levels.removeClass('hidden').eq(2).children().find('.node:first').filter(this.isVisibleNode.bind(this));
        // the two following statements are used to enforce browser to repaint
        this.repaint($animatedNodes.get(0));
        $animatedNodes.addClass('sliding').removeClass('slide-up').eq(0).one('transitionend', { 'node': $node, 'animatedNodes': $animatedNodes }, this.showChildrenEnd.bind(this));
      },
      //
      hideSiblingsEnd: function hideSiblingsEnd(event) {
        var $node = event.data.node;
        var $nodeContainer = event.data.nodeContainer;
        var direction = event.data.direction;
        event.data.lines.removeAttr('style');
        var $siblings = direction ? direction === 'left' ? $nodeContainer.prevAll(':not(.hidden)') : $nodeContainer.nextAll(':not(.hidden)') : $nodeContainer.siblings();
        $nodeContainer.closest('.nodes').prev().children(':not(.hidden)').slice(1, direction ? $siblings.length * 2 + 1 : -1).addClass('hidden');
        event.data.animatedNodes.removeClass('sliding');
        $siblings.find('.node:gt(0)').filter(this.isVisibleNode.bind(this)).removeClass('slide-left slide-right').addClass('slide-up');
        $siblings.find('.lines, .nodes, .verticalNodes').addClass('hidden').end().addClass('hidden');

        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
        }
      },
      // hide the sibling nodes of the specified node
      hideSiblings: function hideSiblings($node, direction) {
        var that = this;
        var $nodeContainer = $node.closest('table').parent();
        if ($nodeContainer.siblings().find('.spinner').length) {
          $node.closest('.orgchart').data('inAjax', false);
        }
        if (direction) {
          if (direction === 'left') {
            $nodeContainer.prevAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-right');
          } else {
            $nodeContainer.nextAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-left');
          }
        } else {
          $nodeContainer.prevAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-right');
          $nodeContainer.nextAll().find('.node').filter(this.isVisibleNode.bind(this)).addClass('sliding slide-left');
        }
        var $animatedNodes = $nodeContainer.siblings().find('.sliding');
        var $lines = $animatedNodes.closest('.nodes').prevAll('.lines').css('visibility', 'hidden');
        $animatedNodes.eq(0).one('transitionend', { 'node': $node, 'nodeContainer': $nodeContainer, 'direction': direction, 'animatedNodes': $animatedNodes, 'lines': $lines }, this.hideSiblingsEnd.bind(this));
      },
      //
      showSiblingsEnd: function showSiblingsEnd(event) {
        var $node = event.data.node;
        event.data.visibleNodes.removeClass('sliding');
        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
          $node.children('.topEdge').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
      },
      //
      showRelatedParentEnd: function showRelatedParentEnd(event) {
        $(event.target).removeClass('sliding');
      },
      // show the sibling nodes of the specified node
      showSiblings: function showSiblings($node, direction) {
        var that = this;
        // firstly, show the sibling td tags
        var $siblings = $();
        if (direction) {
          if (direction === 'left') {
            $siblings = $node.closest('table').parent().prevAll().removeClass('hidden');
          } else {
            $siblings = $node.closest('table').parent().nextAll().removeClass('hidden');
          }
        } else {
          $siblings = $node.closest('table').parent().siblings().removeClass('hidden');
        }
        // secondly, show the lines
        var $upperLevel = $node.closest('table').closest('tr').siblings();
        if (direction) {
          $upperLevel.eq(2).children('.hidden').slice(0, $siblings.length * 2).removeClass('hidden');
        } else {
          $upperLevel.eq(2).children('.hidden').removeClass('hidden');
        }
        // thirdly, do some cleaning stuff
        if (!this.getNodeState($node, 'parent').visible) {
          $upperLevel.removeClass('hidden');
          var parent = $upperLevel.find('.node')[0];
          this.repaint(parent);
          $(parent).addClass('sliding').removeClass('slide-down').one('transitionend', this.showRelatedParentEnd);
        }
        // lastly, show the sibling nodes with animation
        var $visibleNodes = $siblings.find('.node').filter(this.isVisibleNode.bind(this));
        this.repaint($visibleNodes.get(0));
        $visibleNodes.addClass('sliding').removeClass('slide-left slide-right');
        $visibleNodes.eq(0).one('transitionend', { 'node': $node, 'visibleNodes': $visibleNodes }, this.showSiblingsEnd.bind(this));
      },
      // start up loading status for requesting new nodes
      startLoading: function startLoading($edge) {
        var $chart = this.$chart;
        if (typeof $chart.data('inAjax') !== 'undefined' && $chart.data('inAjax') === true) {
          return false;
        }

        $edge.addClass('hidden');
        $edge.parent().append('<i class="fa fa-circle-o-notch fa-spin spinner"></i>').children().not('.spinner').css('opacity', 0.2);
        $chart.data('inAjax', true);
        $('.oc-export-btn' + (this.options.chartClass !== '' ? '.' + this.options.chartClass : '')).prop('disabled', true);
        return true;
      },
      // terminate loading status for requesting new nodes
      endLoading: function endLoading($edge) {
        var $node = $edge.parent();
        $edge.removeClass('hidden');
        $node.find('.spinner').remove();
        $node.children().removeAttr('style');
        this.$chart.data('inAjax', false);
        $('.oc-export-btn' + (this.options.chartClass !== '' ? '.' + this.options.chartClass : '')).prop('disabled', false);
      },
      // whether the cursor is hovering over the node
      isInAction: function isInAction($node) {
        return $node.children('.edge').attr('class').indexOf('fa-') > -1 ? true : false;
      },
      //
      switchVerticalArrow: function switchVerticalArrow($arrow) {
        $arrow.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
      },
      //
      switchHorizontalArrow: function switchHorizontalArrow($node) {
        var opts = this.options;
        if (opts.toggleSiblingsResp && (typeof opts.ajaxURL === 'undefined' || $node.closest('.nodes').data('siblingsLoaded'))) {
          var $prevSib = $node.closest('table').parent().prev();
          if ($prevSib.length) {
            if ($prevSib.is('.hidden')) {
              $node.children('.leftEdge').addClass('fa-chevron-left').removeClass('fa-chevron-right');
            } else {
              $node.children('.leftEdge').addClass('fa-chevron-right').removeClass('fa-chevron-left');
            }
          }
          var $nextSib = $node.closest('table').parent().next();
          if ($nextSib.length) {
            if ($nextSib.is('.hidden')) {
              $node.children('.rightEdge').addClass('fa-chevron-right').removeClass('fa-chevron-left');
            } else {
              $node.children('.rightEdge').addClass('fa-chevron-left').removeClass('fa-chevron-right');
            }
          }
        } else {
          var $sibs = $node.closest('table').parent().siblings();
          var sibsVisible = $sibs.length ? !$sibs.is('.hidden') : false;
          $node.children('.leftEdge').toggleClass('fa-chevron-right', sibsVisible).toggleClass('fa-chevron-left', !sibsVisible);
          $node.children('.rightEdge').toggleClass('fa-chevron-left', sibsVisible).toggleClass('fa-chevron-right', !sibsVisible);
        }
      },
      //
      repaint: function repaint(node) {
        if (node) {
          node.style.offsetWidth = node.offsetWidth;
        }
      },
      //
      nodeEnterLeaveHandler: function nodeEnterLeaveHandler(event) {
        var $node = $(event.delegateTarget),
            flag = false;
        var $topEdge = $node.children('.topEdge');
        var $rightEdge = $node.children('.rightEdge');
        var $bottomEdge = $node.children('.bottomEdge');
        var $leftEdge = $node.children('.leftEdge');
        if (event.type === 'mouseenter') {
          if ($topEdge.length) {
            flag = this.getNodeState($node, 'parent').visible;
            $topEdge.toggleClass('fa-chevron-up', !flag).toggleClass('fa-chevron-down', flag);
          }
          if ($bottomEdge.length) {
            flag = this.getNodeState($node, 'children').visible;
            $bottomEdge.toggleClass('fa-chevron-down', !flag).toggleClass('fa-chevron-up', flag);
          }
          if ($leftEdge.length) {
            this.switchHorizontalArrow($node);
          }
        } else {
          $node.children('.edge').removeClass('fa-chevron-up fa-chevron-down fa-chevron-right fa-chevron-left');
        }
      },
      //
      nodeClickHandler: function nodeClickHandler(event) {
        this.$chart.find('.focused').removeClass('focused');
        $(event.delegateTarget).addClass('focused');
      },
      // load new nodes by ajax
      loadNodes: function loadNodes(rel, url, $edge) {
        var that = this;
        var opts = this.options;
        $.ajax({ 'url': url, 'dataType': 'json' }).done(function (data) {
          if (that.$chart.data('inAjax')) {
            if (rel === 'parent') {
              if (!$.isEmptyObject(data)) {
                that.addParent($edge.parent(), data);
              }
            } else if (rel === 'children') {
              if (data.children.length) {
                that.addChildren($edge.parent(), data[rel]);
              }
            } else {
              that.addSiblings($edge.parent(), data.siblings ? data.siblings : data);
            }
          }
        }).fail(function () {
          console.log('Failed to get ' + rel + ' data');
        }).always(function () {
          that.endLoading($edge);
        });
      },
      //
      HideFirstParentEnd: function HideFirstParentEnd(event) {
        var $topEdge = event.data.topEdge;
        var $node = $topEdge.parent();
        if (this.isInAction($node)) {
          this.switchVerticalArrow($topEdge);
          this.switchHorizontalArrow($node);
        }
      },
      //
      topEdgeClickHandler: function topEdgeClickHandler(event) {
        event.stopPropagation();
        var that = this;
        var $topEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var parentState = this.getNodeState($node, 'parent');
        if (parentState.exist) {
          var $parent = $node.closest('table').closest('tr').siblings(':first').find('.node');
          if ($parent.is('.sliding')) {
            return;
          }
          // hide the ancestor nodes and sibling nodes of the specified node
          if (parentState.visible) {
            this.hideParent($node);
            $parent.one('transitionend', { 'topEdge': $topEdge }, this.HideFirstParentEnd.bind(this));
          } else {
            // show the ancestors and siblings
            this.showParent($node);
          }
        } else {
          // load the new parent node of the specified node by ajax request
          // start up loading status
          if (this.startLoading($topEdge)) {
            var opts = this.options;
            var url = $.isFunction(opts.ajaxURL.parent) ? opts.ajaxURL.parent(event.data.nodeData) : opts.ajaxURL.parent + $node[0].id;
            this.loadNodes('parent', url, $topEdge);
          }
        }
      },
      //
      bottomEdgeClickHandler: function bottomEdgeClickHandler(event) {
        event.stopPropagation();
        var $bottomEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var childrenState = this.getNodeState($node, 'children');
        if (childrenState.exist) {
          var $children = $node.closest('tr').siblings(':last');
          if ($children.find('.sliding').length) {
            return;
          }
          // hide the descendant nodes of the specified node
          if (childrenState.visible) {
            this.hideChildren($node);
          } else {
            // show the descendants
            this.showChildren($node);
          }
        } else {
          // load the new children nodes of the specified node by ajax request
          if (this.startLoading($bottomEdge)) {
            var opts = this.options;
            var url = $.isFunction(opts.ajaxURL.children) ? opts.ajaxURL.children(event.data.nodeData) : opts.ajaxURL.children + $node[0].id;
            this.loadNodes('children', url, $bottomEdge);
          }
        }
      },
      //
      hEdgeClickHandler: function hEdgeClickHandler(event) {
        event.stopPropagation();
        var $hEdge = $(event.target);
        var $node = $(event.delegateTarget);
        var opts = this.options;
        var siblingsState = this.getNodeState($node, 'siblings');
        if (siblingsState.exist) {
          var $siblings = $node.closest('table').parent().siblings();
          if ($siblings.find('.sliding').length) {
            return;
          }
          if (opts.toggleSiblingsResp) {
            var $prevSib = $node.closest('table').parent().prev();
            var $nextSib = $node.closest('table').parent().next();
            if ($hEdge.is('.leftEdge')) {
              if ($prevSib.is('.hidden')) {
                this.showSiblings($node, 'left');
              } else {
                this.hideSiblings($node, 'left');
              }
            } else {
              if ($nextSib.is('.hidden')) {
                this.showSiblings($node, 'right');
              } else {
                this.hideSiblings($node, 'right');
              }
            }
          } else {
            if (siblingsState.visible) {
              this.hideSiblings($node);
            } else {
              this.showSiblings($node);
            }
          }
        } else {
          // load the new sibling nodes of the specified node by ajax request
          if (this.startLoading($hEdge)) {
            var nodeId = $node[0].id;
            var url = this.getNodeState($node, 'parent').exist ? $.isFunction(opts.ajaxURL.siblings) ? opts.ajaxURL.siblings(event.data.nodeData) : opts.ajaxURL.siblings + nodeId : $.isFunction(opts.ajaxURL.families) ? opts.ajaxURL.families(event.data.nodeData) : opts.ajaxURL.families + nodeId;
            this.loadNodes('siblings', url, $hEdge);
          }
        }
      },
      //
      expandVNodesEnd: function expandVNodesEnd(event) {
        event.data.vNodes.removeClass('sliding');
      },
      //
      collapseVNodesEnd: function collapseVNodesEnd(event) {
        event.data.vNodes.removeClass('sliding').closest('ul').addClass('hidden');
      },
      // event handler for toggle buttons in Hybrid(horizontal + vertical) OrgChart
      toggleVNodes: function toggleVNodes(event) {
        var $toggleBtn = $(event.target);
        var $descWrapper = $toggleBtn.parent().next();
        var $descendants = $descWrapper.find('.node');
        var $children = $descWrapper.children().children('.node');
        if ($children.is('.sliding')) {
          return;
        }
        $toggleBtn.toggleClass('fa-plus-square fa-minus-square');
        if ($descendants.eq(0).is('.slide-up')) {
          $descWrapper.removeClass('hidden');
          this.repaint($children.get(0));
          $children.addClass('sliding').removeClass('slide-up').eq(0).one('transitionend', { 'vNodes': $children }, this.expandVNodesEnd);
        } else {
          $descendants.addClass('sliding slide-up').eq(0).one('transitionend', { 'vNodes': $descendants }, this.collapseVNodesEnd);
          $descendants.find('.toggleBtn').removeClass('fa-minus-square').addClass('fa-plus-square');
        }
      },
      //
      createGhostNode: function createGhostNode(event) {
        var $nodeDiv = $(event.target);
        var opts = this.options;
        var origEvent = event.originalEvent;
        var isFirefox = /firefox/.test(window.navigator.userAgent.toLowerCase());
        if (isFirefox) {
          origEvent.dataTransfer.setData('text/html', 'hack for firefox');
        }
        var ghostNode, nodeCover;
        if (!document.querySelector('.ghost-node')) {
          ghostNode = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          ghostNode.classList.add('ghost-node');
          nodeCover = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
          ghostNode.appendChild(nodeCover);
          $nodeDiv.closest('.orgchart').append(ghostNode);
        } else {
          ghostNode = $nodeDiv.closest('.orgchart').children('.ghost-node').get(0);
          nodeCover = $(ghostNode).children().get(0);
        }
        var transValues = $nodeDiv.closest('.orgchart').css('transform').split(',');
        var scale = Math.abs(window.parseFloat(opts.direction === 't2b' || opts.direction === 'b2t' ? transValues[0].slice(transValues[0].indexOf('(') + 1) : transValues[1]));
        ghostNode.setAttribute('width', $nodeDiv.outerWidth(false));
        ghostNode.setAttribute('height', $nodeDiv.outerHeight(false));
        nodeCover.setAttribute('x', 5 * scale);
        nodeCover.setAttribute('y', 5 * scale);
        nodeCover.setAttribute('width', 120 * scale);
        nodeCover.setAttribute('height', 40 * scale);
        nodeCover.setAttribute('rx', 4 * scale);
        nodeCover.setAttribute('ry', 4 * scale);
        nodeCover.setAttribute('stroke-width', 1 * scale);
        var xOffset = origEvent.offsetX * scale;
        var yOffset = origEvent.offsetY * scale;
        if (opts.direction === 'l2r') {
          xOffset = origEvent.offsetY * scale;
          yOffset = origEvent.offsetX * scale;
        } else if (opts.direction === 'r2l') {
          xOffset = $nodeDiv.outerWidth(false) - origEvent.offsetY * scale;
          yOffset = origEvent.offsetX * scale;
        } else if (opts.direction === 'b2t') {
          xOffset = $nodeDiv.outerWidth(false) - origEvent.offsetX * scale;
          yOffset = $nodeDiv.outerHeight(false) - origEvent.offsetY * scale;
        }
        if (isFirefox) {
          // hack for old version of Firefox(< 48.0)
          nodeCover.setAttribute('fill', 'rgb(255, 255, 255)');
          nodeCover.setAttribute('stroke', 'rgb(191, 0, 0)');
          var ghostNodeWrapper = document.createElement('img');
          ghostNodeWrapper.src = 'data:image/svg+xml;utf8,' + new XMLSerializer().serializeToString(ghostNode);
          origEvent.dataTransfer.setDragImage(ghostNodeWrapper, xOffset, yOffset);
        } else {
          origEvent.dataTransfer.setDragImage(ghostNode, xOffset, yOffset);
        }
      },
      //
      filterAllowedDropNodes: function filterAllowedDropNodes($dragged) {
        var opts = this.options;
        var $dragZone = $dragged.closest('.nodes').siblings().eq(0).find('.node:first');
        var $dragHier = $dragged.closest('table').find('.node');
        this.$chart.data('dragged', $dragged).find('.node').each(function (index, node) {
          if ($dragHier.index(node) === -1) {
            if (opts.dropCriteria) {
              if (opts.dropCriteria($dragged, $dragZone, $(node))) {
                $(node).addClass('allowedDrop');
              }
            } else {
              $(node).addClass('allowedDrop');
            }
          }
        });
      },
      //
      dragstartHandler: function dragstartHandler(event) {
        // if users enable zoom or direction options
        if (this.$chart.css('transform') !== 'none') {
          this.createGhostNode(event);
        }
        this.filterAllowedDropNodes($(event.target));
      },
      //
      dragoverHandler: function dragoverHandler(event) {
        event.preventDefault();
        if (!$(event.delegateTarget).is('.allowedDrop')) {
          event.originalEvent.dataTransfer.dropEffect = 'none';
        }
      },
      //
      dragendHandler: function dragendHandler(event) {
        this.$chart.find('.allowedDrop').removeClass('allowedDrop');
      },
      //
      dropHandler: function dropHandler(event) {
        var $dropZone = $(event.delegateTarget);
        var $dragged = this.$chart.data('dragged');
        var $dragZone = $dragged.closest('.nodes').siblings().eq(0).children();
        var dropEvent = $.Event('nodedrop.orgchart');
        this.$chart.trigger(dropEvent, { 'draggedNode': $dragged, 'dragZone': $dragZone.children(), 'dropZone': $dropZone });
        if (dropEvent.isDefaultPrevented()) {
          return;
        }
        // firstly, deal with the hierarchy of drop zone
        if (!$dropZone.closest('tr').siblings().length) {
          // if the drop zone is a leaf node
          $dropZone.append('<i class="edge verticalEdge bottomEdge fa"></i>').parent().attr('colspan', 2).parent().after('<tr class="lines"><td colspan="2"><div class="downLine"></div></td></tr>' + '<tr class="lines"><td class="rightLine"></td><td class="leftLine"></td></tr>' + '<tr class="nodes"></tr>').siblings(':last').append($dragged.find('.horizontalEdge').remove().end().closest('table').parent());
        } else {
          var dropColspan = parseInt($dropZone.parent().attr('colspan')) + 2;
          var horizontalEdges = '<i class="edge horizontalEdge rightEdge fa"></i><i class="edge horizontalEdge leftEdge fa"></i>';
          $dropZone.closest('tr').next().addBack().children().attr('colspan', dropColspan);
          if (!$dragged.find('.horizontalEdge').length) {
            $dragged.append(horizontalEdges);
          }
          $dropZone.closest('tr').siblings().eq(1).children(':last').before('<td class="leftLine topLine"></td><td class="rightLine topLine"></td>').end().next().append($dragged.closest('table').parent());
          var $dropSibs = $dragged.closest('table').parent().siblings().find('.node:first');
          if ($dropSibs.length === 1) {
            $dropSibs.append(horizontalEdges);
          }
        }
        // secondly, deal with the hierarchy of dragged node
        var dragColspan = parseInt($dragZone.attr('colspan'));
        if (dragColspan > 2) {
          $dragZone.attr('colspan', dragColspan - 2).parent().next().children().attr('colspan', dragColspan - 2).end().next().children().slice(1, 3).remove();
          var $dragSibs = $dragZone.parent().siblings('.nodes').children().find('.node:first');
          if ($dragSibs.length === 1) {
            $dragSibs.find('.horizontalEdge').remove();
          }
        } else {
          $dragZone.removeAttr('colspan').find('.bottomEdge').remove().end().end().siblings().remove();
        }
      },
      //
      touchstartHandler: function touchstartHandler(event) {
        console.log("orgChart: touchstart 1: touchHandled=" + this.touchHandled + ", touchMoved=" + this.touchMoved + ", target=" + event.target.innerText);
        if (this.touchHandled) return;
        this.touchHandled = true;
        this.touchMoved = false; // this is so we can work out later if this was a 'press' or a 'drag' touch
        event.preventDefault();
      },
      //
      touchmoveHandler: function touchmoveHandler(event) {
        if (!this.touchHandled) return;
        event.preventDefault();
        if (!this.touchMoved) {
          var nodeIsSelected = $(this).hasClass('focused');
          console.log("orgChart: touchmove 1: " + event.touches.length + " touches, we have not moved, so simulate a drag start", event.touches);
          // TODO: visualise the start of the drag (as would happen on desktop)
          this.simulateMouseEvent(event, 'dragstart');
        }
        this.touchMoved = true;
        var $touching = $(document.elementFromPoint(event.touches[0].clientX, event.touches[0].clientY));
        var $touchingNode = $touching.closest('div.node');

        if ($touchingNode.length > 0) {
          var touchingNodeElement = $touchingNode[0];
          // TODO: simulate the dragover visualisation
          if ($touchingNode.is('.allowedDrop')) {
            console.log("orgChart: touchmove 2: this node (" + touchingNodeElement.id + ") is allowed to be a drop target");
            this.touchTargetNode = touchingNodeElement;
          } else {
            console.log("orgChart: touchmove 3: this node (" + touchingNodeElement.id + ") is NOT allowed to be a drop target");
            this.touchTargetNode = null;
          }
        } else {
          console.log("orgchart: touchmove 4: not touching a node");
          this.touchTargetNode = null;
        }
      },
      //
      touchendHandler: function touchendHandler(event) {
        console.log("orgChart: touchend 1: touchHandled=" + this.touchHandled + ", touchMoved=" + this.touchMoved + ", " + event.target.innerText + " ");
        if (!this.touchHandled) {
          console.log("orgChart: touchend 2: not handled by us, so aborting");
          return;
        }
        if (this.touchMoved) {
          // we've had movement, so this was a 'drag' touch
          if (this.touchTargetNode) {
            console.log("orgChart: touchend 3: moved to a node, so simulating drop");
            var fakeEventForDropHandler = { delegateTarget: this.touchTargetNode };
            this.dropHandler(fakeEventForDropHandler);
            this.touchTargetNode = null;
          }
          console.log("orgChart: touchend 4: simulating dragend");
          this.simulateMouseEvent(event, 'dragend');
        } else {
          // we did not move, so assume this was a 'press' touch
          console.log("orgChart: touchend 5: moved, so simulating click");
          this.simulateMouseEvent(event, 'click');
        }
        this.touchHandled = false;
      },
      // simulate a mouse event (so we can fake them on a touch device)
      simulateMouseEvent: function simulateMouseEvent(event, simulatedType) {
        // Ignore multi-touch events
        if (event.originalEvent.touches.length > 1) {
          return;
        }
        var touch = event.originalEvent.changedTouches[0];
        var simulatedEvent = document.createEvent('MouseEvents');
        simulatedEvent.initMouseEvent(simulatedType, // type
        true, // bubbles                    
        true, // cancelable                 
        window, // view                       
        1, // detail                     
        touch.screenX, // screenX                    
        touch.screenY, // screenY                    
        touch.clientX, // clientX                    
        touch.clientY, // clientY                    
        false, // ctrlKey                    
        false, // altKey                     
        false, // shiftKey                   
        false, // metaKey                    
        0, // button                     
        null // relatedTarget              
        );
        // Dispatch the simulated event to the target element
        event.target.dispatchEvent(simulatedEvent);
      },
      //
      bindDragDrop: function bindDragDrop($node) {
        $node.on('dragstart', this.dragstartHandler.bind(this)).on('dragover', this.dragoverHandler.bind(this)).on('dragend', this.dragendHandler.bind(this)).on('drop', this.dropHandler.bind(this)).on('touchstart', this.touchstartHandler.bind(this)).on('touchmove', this.touchmoveHandler.bind(this)).on('touchend', this.touchendHandler.bind(this));
      },
      // create node
      createNode: function createNode(data) {
        var that = this;
        var opts = this.options;
        var level = data.level;
        if (data.children) {
          $.each(data.children, function (index, child) {
            child.parentId = data.id;
          });
        }
        // construct the content of node
        var $nodeDiv = $('<div' + (opts.draggable ? ' draggable="true"' : '') + (data[opts.nodeId] ? ' id="' + data[opts.nodeId] + '"' : '') + (data.parentId ? ' data-parent="' + data.parentId + '"' : '') + '>').addClass('node ' + (data.className || '') + (level > opts.visibleLevel ? ' slide-up' : ''));
        if (opts.nodeTemplate) {
          $nodeDiv.append(opts.nodeTemplate(data));
        } else {
          $nodeDiv.append('<div class="title">' + data[opts.nodeTitle] + '</div>').append(typeof opts.nodeContent !== 'undefined' ? '<div class="content">' + (data[opts.nodeContent] || '') + '</div>' : '');
        }
        // append 4 direction arrows or expand/collapse buttons
        var flags = data.relationship || '';
        if (opts.verticalLevel && level >= opts.verticalLevel) {
          if (level + 1 > opts.verticalLevel && Number(flags.substr(2, 1))) {
            var icon = level + 1 > opts.visibleLevel ? 'plus' : 'minus';
            $nodeDiv.append('<i class="toggleBtn fa fa-' + icon + '-square"></i>');
          }
        } else {
          if (Number(flags.substr(0, 1))) {
            $nodeDiv.append('<i class="edge verticalEdge topEdge fa"></i>');
          }
          if (Number(flags.substr(1, 1))) {
            $nodeDiv.append('<i class="edge horizontalEdge rightEdge fa"></i>' + '<i class="edge horizontalEdge leftEdge fa"></i>');
          }
          if (Number(flags.substr(2, 1))) {
            $nodeDiv.append('<i class="edge verticalEdge bottomEdge fa"></i>').children('.title').prepend('<i class="fa ' + opts.parentNodeSymbol + ' symbol"></i>');
          }
        }

        $nodeDiv.on('mouseenter mouseleave', this.nodeEnterLeaveHandler.bind(this));
        $nodeDiv.on('click', this.nodeClickHandler.bind(this));
        $nodeDiv.on('click', '.topEdge', { 'nodeData': data }, this.topEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.bottomEdge', { 'nodeData': data }, this.bottomEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.leftEdge, .rightEdge', { 'nodeData': data }, this.hEdgeClickHandler.bind(this));
        $nodeDiv.on('click', '.toggleBtn', this.toggleVNodes.bind(this));

        if (opts.draggable) {
          this.bindDragDrop($nodeDiv);
          this.touchHandled = false;
          this.touchMoved = false;
          this.touchTargetNode = null;
        }
        // allow user to append dom modification after finishing node create of orgchart
        if (opts.createNode) {
          opts.createNode($nodeDiv, data);
        }

        return $nodeDiv;
      },
      // recursively build the tree
      buildHierarchy: function buildHierarchy($appendTo, data) {
        var that = this;
        var opts = this.options;
        var level = 0;
        if (data.level) {
          level = data.level;
        } else {
          level = data.level = $appendTo.parentsUntil('.orgchart', '.nodes').length + 1;
        }
        // Construct the node
        var childrenData = data.children;
        var hasChildren = childrenData ? childrenData.length : false;
        var $nodeWrapper;
        if (Object.keys(data).length > 2) {
          var $nodeDiv = this.createNode(data);
          if (opts.verticalLevel && level >= opts.verticalLevel) {
            $appendTo.append($nodeDiv);
          } else {
            $nodeWrapper = $('<table>');
            $appendTo.append($nodeWrapper.append($('<tr/>').append($('<td' + (hasChildren ? ' colspan="' + childrenData.length * 2 + '"' : '') + '></td>').append($nodeDiv))));
          }
        }
        // Construct the lower level(two "connectiong lines" rows and "inferior nodes" row)
        if (hasChildren) {
          var isHidden = level + 1 > opts.visibleLevel || data.collapsed ? ' hidden' : '';
          var isVerticalLayer = opts.verticalLevel && level + 1 >= opts.verticalLevel ? true : false;
          var $nodesLayer;
          if (isVerticalLayer) {
            $nodesLayer = $('<ul>');
            if (isHidden && level + 1 > opts.verticalLevel) {
              $nodesLayer.addClass(isHidden);
            }
            if (level + 1 === opts.verticalLevel) {
              $appendTo.children('table').append('<tr class="verticalNodes' + isHidden + '"><td></td></tr>').find('.verticalNodes').children().append($nodesLayer);
            } else {
              $appendTo.append($nodesLayer);
            }
          } else {
            var $upperLines = $('<tr class="lines' + isHidden + '"><td colspan="' + childrenData.length * 2 + '"><div class="downLine"></div></td></tr>');
            var lowerLines = '<tr class="lines' + isHidden + '"><td class="rightLine"></td>';
            for (var i = 1; i < childrenData.length; i++) {
              lowerLines += '<td class="leftLine topLine"></td><td class="rightLine topLine"></td>';
            }
            lowerLines += '<td class="leftLine"></td></tr>';
            $nodesLayer = $('<tr class="nodes' + isHidden + '">');
            if (Object.keys(data).length === 2) {
              $appendTo.append($upperLines).append(lowerLines).append($nodesLayer);
            } else {
              $nodeWrapper.append($upperLines).append(lowerLines).append($nodesLayer);
            }
          }
          // recurse through children nodes
          $.each(childrenData, function () {
            var $nodeCell = isVerticalLayer ? $('<li>') : $('<td colspan="2">');
            $nodesLayer.append($nodeCell);
            this.level = level + 1;
            that.buildHierarchy($nodeCell, this);
          });
        }
      },
      // build the child nodes of specific node
      buildChildNode: function buildChildNode($appendTo, data) {
        $appendTo.find('td:first').attr('colspan', data.length * 2);
        this.buildHierarchy($appendTo, { 'children': data });
      },
      // exposed method
      addChildren: function addChildren($node, data) {
        this.buildChildNode($node.closest('table'), data);
        if (!$node.children('.bottomEdge').length) {
          $node.append('<i class="edge verticalEdge bottomEdge fa"></i>');
        }
        if (!$node.find('.symbol').length) {
          $node.children('.title').prepend('<i class="fa ' + this.options.parentNodeSymbol + ' symbol"></i>');
        }
        if (this.isInAction($node)) {
          this.switchVerticalArrow($node.children('.bottomEdge'));
        }
      },
      // build the parent node of specific node
      buildParentNode: function buildParentNode($currentRoot, data) {
        data.relationship = data.relationship || '001';
        var $table = $('<table>').append($('<tr>').append($('<td colspan="2">').append(this.createNode(data)))).append('<tr class="lines"><td colspan="2"><div class="downLine"></div></td></tr>').append('<tr class="lines"><td class="rightLine"></td><td class="leftLine"></td></tr>');
        this.$chart.prepend($table).children('table:first').append('<tr class="nodes"><td colspan="2"></td></tr>').children('tr:last').children().append(this.$chart.children('table').last());
      },
      // exposed method
      addParent: function addParent($currentRoot, data) {
        this.buildParentNode($currentRoot, data);
        if (!$currentRoot.children('.topEdge').length) {
          $currentRoot.children('.title').after('<i class="edge verticalEdge topEdge fa"></i>');
        }
        if (this.isInAction($currentRoot)) {
          this.switchVerticalArrow($currentRoot.children('.topEdge'));
        }
      },
      // subsequent processing of build sibling nodes
      complementLine: function complementLine($oneSibling, siblingCount, existingSibligCount) {
        var lines = '';
        for (var i = 0; i < existingSibligCount; i++) {
          lines += '<td class="leftLine topLine"></td><td class="rightLine topLine"></td>';
        }
        $oneSibling.parent().prevAll('tr:gt(0)').children().attr('colspan', siblingCount * 2).end().next().children(':first').after(lines);
      },
      // build the sibling nodes of specific node
      buildSiblingNode: function buildSiblingNode($nodeChart, data) {
        var newSiblingCount = $.isArray(data) ? data.length : data.children.length;
        var existingSibligCount = $nodeChart.parent().is('td') ? $nodeChart.closest('tr').children().length : 1;
        var siblingCount = existingSibligCount + newSiblingCount;
        var insertPostion = siblingCount > 1 ? Math.floor(siblingCount / 2 - 1) : 0;
        // just build the sibling nodes for the specific node
        if ($nodeChart.parent().is('td')) {
          var $parent = $nodeChart.closest('tr').prevAll('tr:last');
          $nodeChart.closest('tr').prevAll('tr:lt(2)').remove();
          this.buildChildNode($nodeChart.parent().closest('table'), data);
          var $siblingTds = $nodeChart.parent().closest('table').children('tr:last').children('td');
          if (existingSibligCount > 1) {
            this.complementLine($siblingTds.eq(0).before($nodeChart.closest('td').siblings().addBack().unwrap()), siblingCount, existingSibligCount);
          } else {
            this.complementLine($siblingTds.eq(insertPostion).after($nodeChart.closest('td').unwrap()), siblingCount, 1);
          }
        } else {
          // build the sibling nodes and parent node for the specific ndoe
          this.buildHierarchy($nodeChart.closest('.orgchart'), data);
          this.complementLine($nodeChart.next().children('tr:last').children().eq(insertPostion).after($('<td colspan="2">').append($nodeChart)), siblingCount, 1);
        }
      },
      //
      addSiblings: function addSiblings($node, data) {
        this.buildSiblingNode($node.closest('table'), data);
        $node.closest('.nodes').data('siblingsLoaded', true);
        if (!$node.children('.leftEdge').length) {
          $node.children('.topEdge').after('<i class="edge horizontalEdge rightEdge fa"></i><i class="edge horizontalEdge leftEdge fa"></i>');
        }
        if (this.isInAction($node)) {
          this.switchHorizontalArrow($node);
          $node.children('.topEdge').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
      },
      //
      removeNodes: function removeNodes($node) {
        var $parent = $node.closest('table').parent();
        var $sibs = $parent.parent().siblings();
        if ($parent.is('td')) {
          if (this.getNodeState($node, 'siblings').exist) {
            $sibs.eq(2).children('.topLine:lt(2)').remove();
            $sibs.slice(0, 2).children().attr('colspan', $sibs.eq(2).children().length);
            $parent.remove();
          } else {
            $sibs.eq(0).children().removeAttr('colspan').find('.bottomEdge').remove().end().end().siblings().remove();
          }
        } else {
          $parent.add($parent.siblings()).remove();
        }
      },
      //
      export: function _export(exportFilename, exportFileextension) {
        var that = this;
        exportFilename = typeof exportFilename !== 'undefined' ? exportFilename : this.options.exportFilename;
        exportFileextension = typeof exportFileextension !== 'undefined' ? exportFileextension : this.options.exportFileextension;
        if ($(this).children('.spinner').length) {
          return false;
        }
        var $chartContainer = this.$chartContainer;
        var $mask = $chartContainer.find('.mask');
        if (!$mask.length) {
          $chartContainer.append('<div class="mask"><i class="fa fa-circle-o-notch fa-spin spinner"></i></div>');
        } else {
          $mask.removeClass('hidden');
        }
        var sourceChart = $chartContainer.addClass('canvasContainer').find('.orgchart:not(".hidden")').get(0);
        var flag = that.options.direction === 'l2r' || that.options.direction === 'r2l';
        html2canvas(sourceChart, {
          'width': flag ? sourceChart.clientHeight : sourceChart.clientWidth,
          'height': flag ? sourceChart.clientWidth : sourceChart.clientHeight,
          'onclone': function onclone(cloneDoc) {
            $(cloneDoc).find('.canvasContainer').css('overflow', 'visible').find('.orgchart:not(".hidden"):first').css('transform', '');
          },
          'onrendered': function onrendered(canvas) {
            $chartContainer.find('.mask').addClass('hidden');
            if (exportFileextension.toLowerCase() === 'pdf') {
              var doc = {};
              var docWidth = Math.floor(canvas.width * 0.2646);
              var docHeight = Math.floor(canvas.height * 0.2646);
              if (docWidth > docHeight) {
                doc = new jsPDF('l', 'mm', [docWidth, docHeight]);
              } else {
                doc = new jsPDF('p', 'mm', [docHeight, docWidth]);
              }
              doc.addImage(canvas.toDataURL(), 'png', 0, 0);
              doc.save(exportFilename + '.pdf');
            } else {
              var isWebkit = 'WebkitAppearance' in document.documentElement.style;
              var isFf = !!window.sidebar;
              var isEdge = navigator.appName === 'Microsoft Internet Explorer' || navigator.appName === "Netscape" && navigator.appVersion.indexOf('Edge') > -1;

              if (!isWebkit && !isFf || isEdge) {
                window.navigator.msSaveBlob(canvas.msToBlob(), exportFilename + '.png');
              } else {
                var selector = '.oc-download-btn' + (that.options.chartClass !== '' ? '.' + that.options.chartClass : '');
                if (!$chartContainer.find(selector).length) {
                  $chartContainer.append('<a class="oc-download-btn' + (that.options.chartClass !== '' ? ' ' + that.options.chartClass : '') + '"' + ' download="' + exportFilename + '.png"></a>');
                }
                $chartContainer.find(selector).attr('href', canvas.toDataURL())[0].click();
              }
            }
          }
        }).then(function () {
          $chartContainer.removeClass('canvasContainer');
        }, function () {
          $chartContainer.removeClass('canvasContainer');
        });
      }
    };

    $.fn.orgchart = function (opts) {
      return new OrgChart(this, opts).init();
    };
    authService.callAPI(USERHIERARCHYCONSTANT.API_GET_USER_HIERARCHY + $scope.school_id, "GET", {}, function (response) {
      //console.log(response)
      if (response && response.result && response.result.data && response.result.data.data && response.result.data.data.length > 0) {
        var result = response.result.data.data;
        $('#chart-container').orgchart({
          'data': result[0],
          'nodeContent': 'title'
        });
      }
    });
  });

  $scope.create = function () {
    $state.go("createHierarchy");
  };

  function convertFileToDataURLviaFileReader(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  };

  $scope.generatePDF = function () {
    $scope.chartImgData = [];
    var element = $("#chart_div"); // global variable
    var getCanvas; // global variable
    html2canvas(element[0]).then(function (canvas) {
      getCanvas = canvas;
      var imgageData = getCanvas.toDataURL("image/png");
      exportAsPDF(imgageData);
    });
  };

  /*
   * To export chart as PDF file
   * 
   * @return : null
   */
  function exportAsPDF(image) {
    $scope.chartImgData.push({
      'image': image,
      'width': $scope.chartWidth,
      'height': $scope.chartHeight,
      'title': "User Hierarchy"
    });
    var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
    doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
    doc.setFontSize(18);
    doc.setFontType('bold');
    var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
    doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
    doc.setFontSize(12);
    doc.setFontType('normal');
    doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
    doc.setFontSize(16);
    doc.text(240, 90, 'User Hierarchy');
    doc.setFontSize(15); /* Define font size for the document */
    var yAxis = 150;

    for (var i = 0; i < $scope.chartImgData.length; i++) {
      if (i % 2 == 0 && i != 0) {
        /* I want only two images in a page */
        doc.addPage(); /* Adds a new page*/
        yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
      }

      var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
      var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

      if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
        width = doc.internal.pageSize.width;
      } else {
        width = $scope.chartImgData[i].width;
      }

      height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
      height = width * (3 / 4) - 180;

      var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
      doc.text(60, yAxis, someText); /* Add some text in the PDF */
      yAxis = yAxis + 20; /* Update yAxis */
      doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
      yAxis = yAxis + 360; /* Update yAxis */
    }
    doc.save('User_Hierarchy.pdf');
  }
};
UserHierarchy.$inject = ["$scope", "$state", "$mdDialog", "USERHIERARCHYCONSTANT", "authService", "localStorageService"];

exports.default = UserHierarchy;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)(module), __webpack_require__(4), __webpack_require__(4)))

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports = "<style>.reporting-roles .warning-label{color:red;padding:20px}.reporting-roles .alert-box{background-color:#f2dede;padding:10px;color:#b96664;border-radius:3px;border:1px solid rgba(185,102,100,.28);font-size:13px}.reporting-roles .clickable{cursor:pointer}</style> <div class=\"criteria_console reporting-roles\"> <div layout=column class=consoleBgColor layout-padding ng-cloak> <div class=alert-box>You are trying to keep a level head. You should be very careful how you are set the mapping, according to that it will shape the system hierarchy.</div> <div class=aroundBox> <div layout=row> <md-input-container class=md-block flex-gt-sm flex=55> <label>Head Role</label> <md-select ng-model=headEmployee> <md-option value={{role._id}} ng-click=changedEvaluator(role) ng-repeat=\"role in roleList track by $index\">{{role.name}}</md-option> </md-select> </md-input-container> <md-input-container class=md-block flex-gt-sm flex=55> <label>Select Roles</label> <md-select ng-disabled=disableRole ng-model=selectedRoles multiple=multiple> <md-option ng-value=role ng-if=\"role._id!=headEmployee&&!role.isHead\" ng-disabled=role.isDisable ng-repeat=\"role in roleList track by $index\">{{role.name}}</md-option> </md-select> </md-input-container> <div> <md-button class=\"custBtn md-raised md-primary\" ng-if=!showUpdateButton ng-click=saveRoleMapping()>Save</md-button> <md-button class=\"custBtn md-raised md-primary\" ng-if=showUpdateButton ng-click=updateRoleMapping()>Update</md-button> </div> </div> </div> <div layout=column flex> <div layout=row ui-sref=userConsole layout-align=\"center center\" class=\"warning-label clickable\" ng-show=!evaluatorRoles>Please set head of the institution </div> <div layout=row class=warning-label layout-align=\"center center\" ng-show=\"evaluatorRoles.length==0\">Please map roles </div> <div ng-repeat=\"data in evaluatorRoles track by $index\" layout-wrap layout-align=space-around layout=row flex> <div class=\"md-whiteframe-3dp fpi-whitebox\" layout-align=\"center center\" layout=row flex> <div flex=35><span class=head_color>Head - </span>{{data[0].parent_name}}</div> <div layout=row flex> <div ng-repeat=\"role in data track by $index\">{{role.node_name}}<span ng-if=!$last>, </span></div> </div> <div flex=10> <i ng-if=\"$index !=0\" class=\"fas fa-pen\" ng-click=setHeadRole(data[0].parent_id)></i> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RoleMapping = function RoleMapping($scope, $state, $mdDialog, localStorageService, authService, $rootScope, ROLESETTINGSCONSTANT) {
    'ngInject';

    _classCallCheck(this, RoleMapping);

    this.$state = $state;
    $scope.school_id = localStorageService.get('school_id');
    var evaluatorList = [];

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Role Settings";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $scope.loadData();
    };
    $scope.loadData = function () {
        //Evaluator Settings
        authService.callAPI(ROLESETTINGSCONSTANT.API_GET_ALL_ROLE_MAPPING + $scope.school_id, "GET", {}, function (response) {
            //console.log(response)
            if (response.result != undefined) {
                if (response.result.data && response.result.data.data) {
                    var evaluatorLst = response.result.data.data;
                    console.log(evaluatorLst);
                    //     if (evaluatorLst != undefined && evaluatorLst.length > 0) {
                    //     $scope.evaluatorList = evaluatorLst[0];
                    //     $scope.evaluatorRoles = []
                    //     if ($scope.evaluatorList != undefined) {
                    //         _.each($scope.evaluatorList.details, function(each) {
                    //             each.roleArray = [];
                    //             var role = _.find($scope.roleList, function(item) {
                    //                 return each.head_employee == item._id
                    //             })
                    //             if (role) {
                    //                 each.head_employee_name = role.name;
                    //             }

                    //             _.each(each.roles, function(obj) {
                    //                 var data = _.find($scope.roleList, function(item) {
                    //                     return obj == item._id
                    //                 })
                    //                 each.roleArray.push(data)
                    //             })
                    //             var obj = {
                    //                 "role_id": each.evaluator_role_id,
                    //                 "name": each.evaluator_role_name
                    //             }
                    //             if ($scope.evaluatorRoles.length == 0) {
                    //                 $scope.evaluatorRoles.push(obj)
                    //             } else {
                    //                 let existingObj = _.filter($scope.evaluatorRoles, function(role_obj) {
                    //                     return role_obj.role_id === obj.role_id
                    //                 })
                    //                 if (existingObj.length == 0) {
                    //                     $scope.evaluatorRoles.push(obj)
                    //                 }
                    //             }
                    //         })
                    //     }
                    // }
                    if (evaluatorLst != undefined) {
                        $scope.evaluatorList = evaluatorLst.nodes;
                        $scope.evaluatorRoles = [];
                        if ($scope.evaluatorList != undefined) {
                            $scope.evaluatorList = _.without($scope.evaluatorList, _.findWhere($scope.evaluatorList, {
                                parent_id: "" }));
                            //console.log($scope.evaluatorList)
                            $scope.evaluatorRoles = _.groupBy($scope.evaluatorList, 'parent_id');
                        }
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                }
            }
        });
    };
    //Role List
    authService.callAPI(ROLESETTINGSCONSTANT.API_GET_ALL_ROLES + $scope.school_id, "GET", {}, function (response) {
        if (response.result != undefined) {
            if (response.result.data && response.result.data.data && response.result.data.data.length > 0) {
                $scope.roleList = response.result.data.data[0].roles;
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    });

    // save details of evaluator and roles evaluated by him into 'fpi_evaluator_settings' collection
    $scope.saveRoleMapping = function () {
        var role = _.find($scope.roleList, function (item) {
            return $scope.headEmployee == item._id;
        });
        if ($scope.selectedRoles != undefined && $scope.selectedRoles.length > 0) {
            var evaluatorObj = {
                "school_id": $scope.school_id, //Session.get('school_id'),
                "details": {
                    "parent_id": $scope.headEmployee,
                    "roles": $scope.selectedRoles,
                    "parent_name": role.name
                }
            };

            authService.callAPI(ROLESETTINGSCONSTANT.API_SAVE_ROLE_MAPPING, "POST", angular.copy(evaluatorObj), function (response) {
                if (response.result.data.message === "Success") {
                    toastr.success("Successfully added");
                    $scope.selectedRoles = [];
                    $scope.headEmployee = "";
                    $scope.disableRole = true;
                    $scope.loadData();
                } else {
                    toastr.error("Try again");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            toastr.error("Select atleast one role");
        }
    };

    //Fixed bug 6303
    $scope.setHeadRole = function (item) {
        $scope.headEmployee = item;
        $scope.changedEvaluator($scope.roleList[$scope.roleList.findIndex(function (i) {
            return i._id === item;
        })]);
        $scope.$apply();
    };
    $scope.updateRoleMapping = function () {
        var role = _.find($scope.roleList, function (item) {
            return $scope.headEmployee == item._id;
        });
        var evaluatorObj = {
            parent_role: role,
            role_list: $scope.selectedRoles,
            school_id: $scope.school_id
            /* if ($scope.selectedRoles != undefined && $scope.selectedRoles.length > 0) {*/
        };authService.callAPI(ROLESETTINGSCONSTANT.API_UPDATE_ROLE_MAPPING, "POST", angular.copy(evaluatorObj), function (response) {
            if (response.result.data.message === "Success") {
                $scope.disableRole = true;
                $scope.selectedRoles = [];
                $scope.headEmployee = "";
                $scope.evaluatorList = [];
                $scope.showUpdateButton = false;
                toastr.success("Successfully updated");
                $scope.loadData();
            } else {
                toastr.error("Try again");
            }
        });
    };

    //calls on evaluator dropdrown in evaluator settings console changed
    $scope.changedEvaluator = function (role) {
        $scope.selectedRoles = [];
        $scope.showUpdateButton = false;
        $scope.disableRole = false;
        if ($scope.evaluatorList) {
            var filter = _.filter($scope.evaluatorList, function (each) {
                return role._id == each.parent_id;
            });
            _.each(filter, function (each) {
                var role = _.find($scope.roleList, function (item) {
                    return each.node_id == item._id;
                });
                if (role) {
                    $scope.selectedRoles.push(role);
                    $scope.showUpdateButton = true;
                }
            });
        }
        var reqObj = {
            school_id: $scope.school_id,
            role_id: role._id
        };
        authService.callAPI(ROLESETTINGSCONSTANT.API_GET_MAPPED_PARENTS, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) var result = response.result.data.data;
            _.each($scope.roleList, function (obj) {
                obj.isDisable = false;
            });
            console.log(result);
            //Fixed QA bug #6315 and #6314
            _.each(result.parentList, function (each) {
                var index = $scope.roleList.findIndex(function (i) {
                    return i._id === each;
                });
                if (index > -1) {

                    $scope.roleList[index].isHead = true;
                    $scope.roleList[index].isDisable = true;
                }
            });
            $scope.$apply();
        });
    };
};
RoleMapping.$inject = ["$scope", "$state", "$mdDialog", "localStorageService", "authService", "$rootScope", "ROLESETTINGSCONSTANT"];

exports.default = RoleMapping;
// const name = 'roleMapping';
// export default angular.module(name, [
//         angularMeteor, uirouter
//     ])
//     .component(name, {
//         templateUrl: 'imports/components/user-management/reporting-roles/reporting-roles-mapping.html',
//         controllerAs: name,
//         controller: RoleMapping
//     })
//     .config(config)

// function config($stateProvider) {
//     'ngInject';
//     $stateProvider.state(name, {
//         url: '/role-mapping',
//         template: '<role-mapping></role-mapping>'
//     })
// }

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = "<style>.reporting-roles #vertical-container{height:292px;width:100%;max-width:400px}.reporting-roles .repeated-item{border-bottom:1px solid #ddd;box-sizing:border-box;min-height:49px;height:auto;padding-top:10px}.reporting-roles md-content{margin:16px}.reporting-roles .md-virtual-repeat-container .md-virtual-repeat-offsetter div{padding-left:16px}.reporting-roles .selected-sub{border:1px solid #6ad8e0!important}.reporting-roles .header{background-color:#e1edfb;height:40px;color:#1665c1;font-size:14px;text-transform:uppercase;border-top:1px solid #fff}.reporting-roles .right-border{border-right:1px solid rgba(128,128,128,.45)}.reporting-roles .icons{width:20px;font-size:16px!important;float:right;bottom:1px;height:20px;text-align:center;vertical-align:middle;border-radius:15px;color:#fff;padding-top:2px}.reporting-roles .icontick{background-color:#1665c1}.reporting-roles .iconcross{background-color:#e7505a}.reporting-roles .border-bottom{border-bottom:1px solid #ddd}.reporting-roles .main-head{font-size:19px;float:left;margin-top:20px;background-color:#2eb4be;height:40px;color:#fff}.reporting-roles .boxes{background-color:#d5e5f8;padding:3px 4px 3px 4px;font-size:12px;margin:0 5px 5px 2px}.reporting-roles .bottom-margin{margin-bottom:65px!important}</style> <div class=reporting-roles> <div layout=column class=\"md-margin md-content bottom-margin\"> <span class=\"main-head md-whiteframe-2dp\" layout=row layout-align=\"center center\"> User Hierarchy</span> <div ng-if=\"roleList.length==0\" class=md-margin layout=row layout-align=\"center center\"> <a ng-click=mapRoles() class=new-group-link>Click here.</a> to map roles </div> <div class=md-whiteframe-2dp ng-show=\"roleList.length>0\"> <div layout=row> <div class=right-border layout=column flex=25> <div class=header layout=row layout-align=\"center center\">Superior Roles </div> <md-input-container class=md-block> <input ng-model=searchLead placeholder=search name=q type=text size=40> </md-input-container> <md-list-item class=border-bottom ng-class=\"role==selectedManagerRole?'selected-sub':''\" ng-repeat=\"role in roleList | filter:{name: searchLead}\" ng-click=loadMangerUsers(role)> <p> {{ role.name }} </p> </md-list-item> </div> <div class=right-border layout=column flex=25> <div class=header layout=row layout-align=\"center center\">Superior Users </div> <div layout=row> <md-input-container class=md-block> <input ng-model=searchItem placeholder=search type=text name=searchItem> </md-input-container> <div layout=row layout-align=\"center center\" style=position:relative;bottom:12px> <i class=\"fas fa-search md-whiteframe-2dp\" ng-click=searchLeadAmongResult(0) style=padding:7px;background:#fff;border-radius:2px;margin-left:4px></i> <i class=\"fas fa-times md-whiteframe-2dp\" ng-click=searchLeadAmongResult(1) style=padding:7px;background:#fff;border-radius:2px;margin-left:4px></i> </div> </div> <md-virtual-repeat-container id=vertical-container> <div layout=row ng-click=loadSubRoles(item) ng-class=\"item==selectedManagerUser?'selected-sub':''\" md-virtual-repeat=\"item in managerUsers\" md-on-demand class=repeated-item flex> <span flex=80>{{item.name}}</span> <div class=icondiv> <i class=\"fas fa-check icontick icons\" ng-if=item.isSelected></i> </div> </div> </md-virtual-repeat-container> </div> <div class=right-border layout=column flex=25> <div class=header layout=row layout-align=\"center center\">Subordinate Roles </div> <md-input-container class=md-block> <input ng-model=searchSubRole placeholder=search name=q type=text size=40> </md-input-container> <div ng-repeat=\"role in subRoleList | filter:{name: searchSubRole}\"> <md-list-item ng-click=loadSubUsers(role) ng-class=\"role==selectedSubRole?'selected-sub':''\" layout=row class=border-bottom> <span flex=80>{{ role.name }} </span> <div class=icondiv> <i class=\"fas fa-check icontick icons\" ng-if=role.isSelected></i> </div> </md-list-item> </div> </div> <div class=right-border layout=column flex=25> <div class=header layout=row layout-align=\"center center\">Subordinate Users </div> <div layout=row> <md-input-container class=md-block> <input ng-model=searchSubItem type=text placeholder=search name=searchSubItem> <div layout=row style=position:relative;right:12px> <i class=\"fas fa-search md-whiteframe-2dp\" ng-click=searchSubAmongResult(0) style=padding:7px;background:#fff;border-radius:2px;margin-left:4px></i> <i class=\"fas fa-times md-whiteframe-2dp\" ng-click=searchSubAmongResult(1) style=padding:7px;background:#fff;border-radius:2px;margin-left:4px></i> </div> </md-input-container> </div> <md-virtual-repeat-container id=vertical-container> <div md-virtual-repeat=\"item in subUsers\" md-on-demand class=repeated-item flex> <md-checkbox ng-change=addToSelectedSubRole(item) ng-model=item.isSelected aria-label=\"Checkbox 2\" ng-true-value=true ng-false-value=false class=\"md-warn md-align-top-left\" flex></md-checkbox> {{item.name}} </div> </md-virtual-repeat-container> </div> </div> <md-divider></md-divider> <div ng-repeat=\"data in reportingUsers track by $index\" layout=row flex=100> <div>{{data[0].role}}</div> <div layout=row layout-wrap> <div ng-repeat=\"each in data\" class=boxes> {{each.name}} </div> </div> </div> </div> </div> </div> <footer class=footer> <div layout=row layout-align=\"center center\"> <div layout=row layout-align=space-between-center> <md-button class=bottom_ctrl-btn aria-label=Add ng-click=addReportingRoles()>Add <i class=\"fas fa-plus\"></i> </md-button> <md-button class=bottom_ctrl-btn aria-label=Add ng-click=saveReportingRoles()>Save <i class=\"far fa-save\"></i> </md-button> <md-button class=bottom_ctrl-btn aria-label=Add ng-click=cancel()>Cancel <i class=\"fas fa-times\"></i> </md-button> </div> </div></footer> ";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateReportingHierarchy = function CreateReportingHierarchy($scope, $state, $timeout, USERSETTINGSCONSTANT, authService, localStorageService) {
  'ngInject';

  _classCallCheck(this, CreateReportingHierarchy);

  this.$state = $state;
  //to store role data
  $scope.roleList = [];
  $scope.subUsers = [];
  //to store manager roles
  $scope.manager_role;
  $scope.subRoleList;
  $scope.manager_user;
  $scope.isManager = false;
  $scope.isSubUser = false;
  $scope.school_id = localStorageService.get('school_id');
  $scope.reportingUsers = {};
  $scope.searchLeadRole = "";
  $scope.searchSubRole = "";
  $scope.searchItem = "";
  //to store userId's Bug #6241
  $scope.selectedSubUsers = [];
  //Role List
  authService.callAPI(USERSETTINGSCONSTANT.API_GET_HEAD_ROLES + $scope.school_id, "GET", {}, function (response) {
    if (response.result && response.result.data && response.result.data.data) var result = response.result.data.data;
    if (result) {
      $scope.roleList = result;
    }
    _.defer(function () {
      $scope.$apply();
    });
  });

  var HierarchyItems = function HierarchyItems() {

    this.loadedPages = {};

    this.numItems = 0;

    this.PAGE_SIZE = 50;

    this.fetchNumItems_();
  };

  HierarchyItems.prototype.getItemAtIndex = function (index) {
    var pageNumber = Math.floor(index / this.PAGE_SIZE);
    var page = this.loadedPages[pageNumber];

    if (page) {
      return page[index % this.PAGE_SIZE];
    } else if (page !== null) {
      this.fetchPage_(pageNumber);
    }
  };

  HierarchyItems.prototype.getLength = function () {
    return this.numItems;
  };

  HierarchyItems.prototype.fetchPage_ = function (pageNumber) {
    var hierarchy = this;
    hierarchy.loadedPages[pageNumber] = null;
    $timeout(angular.noop, 300).then(angular.bind(this, function () {
      hierarchy.loadedPages[pageNumber] = [];
      var pageOffset = pageNumber * this.PAGE_SIZE;
      var paginationOpts = {
        limit: parseInt(this.PAGE_SIZE),
        skip: parseInt(pageOffset)
      };
      if (!$scope.searching) {
        if ($scope.isSubUser) {
          var roleId = $scope.selectedSubRole._id;
          var _selectedList = !$scope.selectedSubUsers ? [] : $scope.selectedSubUsers;
          var reqObj = {
            selector: {
              role_ids: roleId,
              school_id: $scope.school_id,
              _id: {
                $nin: [$scope.manager_user._id]
              }
            },
            role_id: roleId,
            selected_list: _selectedList,
            head_role: $scope.manager_role.role_id,
            pagination_opts: paginationOpts,
            user_id: $scope.manager_user._id
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_USERS, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
              var result = response.result.data.data;
              if (result) {
                hierarchy.loadedPages[pageNumber] = result;
              }
              if (result && result.length > 0) {
                if (result[0].selected_list) $scope.selectedSubUsers = result[0].selected_list;
              }
            }

            $scope.$apply();
          });
        } else {
          var reqObj = {
            selector: {
              role_ids: $scope.current_role,
              school_id: $scope.school_id
            },
            role_id: $scope.current_role,
            pagination_opts: paginationOpts

          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERS, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) var result = response.result.data.data;
            if (result.length > 0) {
              hierarchy.loadedPages[pageNumber] = result;
              $scope.$apply();
            }
          });
        }
      } else {
        if ($scope.isSubUser) {
          var roleId = $scope.selectedSubRole._id;
          var selectedList = !$scope.selectedSubUsers ? [] : $scope.selectedSubUsers;
          var reqObj = {
            selector: {
              role_ids: roleId,
              school_id: $scope.school_id,
              name: $scope.searchSubItem,
              _id: {
                $nin: [$scope.manager_user._id]
              }
            },
            role_id: roleId,
            selected_list: selectedList,
            head_role: $scope.manager_role.role_id,
            pagination_opts: paginationOpts,
            user_id: $scope.manager_user._id
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_USERS, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
              var result = response.result.data.data;
              if (result) {
                hierarchy.loadedPages[pageNumber] = result;
              }
              if (result && result.legth > 0) {
                if (result[0].selected_list) $scope.selectedSubUsers = result[0].selected_list;
              }
            }

            $scope.$apply();
          });
        } else {
          var reqObj = {
            selector: {
              role_ids: $scope.current_role,
              school_id: $scope.school_id,
              name: $scope.searchItem
            },

            role_id: $scope.current_role,
            pagination_opts: paginationOpts

          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERS, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) var result = response.result.data.data;
            if (result.length > 0) {
              hierarchy.loadedPages[pageNumber] = result;
              $scope.$apply();
            }
          });
        }
      }
    }));
  };

  HierarchyItems.prototype.fetchNumItems_ = function () {
    var hierarchy = this;
    $timeout(angular.noop, 300).then(angular.bind(this, function () {
      if (!$scope.searching) {
        if ($scope.isSubUser) {
          var reqObj = {
            role_ids: $scope.current_role,
            school_id: $scope.school_id
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {
            //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, (error, result) => {
            if (response.result && response.result.data && response.result.data.data) {
              var result = response.result.data.data;
              if (result) {
                var index = $scope.selectedManagerUser.role_ids.indexOf($scope.current_role);
                if (index > -1) hierarchy.numItems = result - 1;else hierarchy.numItems = result;
                $scope.$apply();
              }
            }
          });
        } else {
          var reqObj = {
            role_ids: $scope.current_role,
            school_id: $scope.school_id
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
              var result = response.result.data.data;
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, (error, result) => {
              if (result) {
                hierarchy.numItems = result;
                $scope.$apply();
              }
            }
          });
        }
      } else {
        if ($scope.isSubUser) {
          //let regex = new RegExp( $scope.searchSubItem, 'i' );
          var reqObj = {
            role_ids: $scope.current_role,
            school_id: $scope.school_id,
            name: $scope.searchSubItem
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {
              var result = response.result.data.data;
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, $scope.searchSubItem, (error, result) => {
              if (result) {
                hierarchy.numItems = result;
                $scope.$apply();
              }
            }
          });
        } else {
          var reqObj = {
            role_ids: $scope.current_role,
            school_id: $scope.school_id,
            name: $scope.searchItem
          };
          authService.callAPI(USERSETTINGSCONSTANT.API_GET_USERCOUNT, "POST", reqObj, function (response) {
            if (response.result && response.result.data && response.result.data.data) {

              var result = response.result.data.data;
              //Meteor.call('getUsersByRoleCount', $scope.current_role, $scope.school_id, $scope.searchItem, (error, result) => {
              if (result) {
                hierarchy.numItems = result;
                $scope.$apply();
              }
            }
          });
        }
      }
    }));
  };

  $scope.loadMangerUsers = function (role) {
    $scope.isManager = true;
    $scope.isSubUser = false;
    $scope.current_role = role._id;
    $scope.manager_role = {
      "role_id": role._id,
      "role": role.name
    };
    $scope.searching = false;
    $scope.managerUsers = new HierarchyItems();
    $scope.subRoleList = [];
    $scope.subUsers = undefined;
    $scope.selectedManagerRole = role;
    $scope.reportingUsers = {};
  };
  $scope.loadSubRoles = function (user) {
    $scope.subUsers = undefined;
    $scope.manager_user = {
      "name": user.name,
      "_id": user._id
    };
    var reqObj = {
      head_id: $scope.manager_role.role_id,
      school_id: $scope.school_id,
      user_id: user._id
    };
    authService.callAPI(USERSETTINGSCONSTANT.API_GET_SUB_ROLES, "POST", reqObj, function (response) {
      if (response.result && response.result.data && response.result.data.data) var result = response.result.data.data;
      //Meteor.call("getSubRoles", $scope.manager_role.role_id, user._id, $scope.school_id, (error, result) => {
      $scope.subRoleList = result;

      $scope.$apply();
    });

    $scope.selectedManagerUser = user;
    $scope.reportingUsers = {};
  };
  $scope.loadSubUsers = function (role) {
    $scope.selectedSubUsers = [];
    $scope.isManager = false;
    $scope.isSubUser = true;
    $scope.current_role = role._id;
    $scope.sub_role = {
      "role_id": role._id,
      "role": role.name
    };
    $scope.searching = false;
    $scope.subUsers = new HierarchyItems();
    $scope.selectedSubRole = role;
  };
  $scope.saveReportingRoles = function () {
    if (Object.keys($scope.reportingUsers).length > 0) {
      //$scope.reportingUsers.parent_id=$scope.manager_user._id
      var reqObj = {
        "reporting_users": angular.copy($scope.reportingUsers),
        "school_id": $scope.school_id,
        "academic_year": localStorage.getItem('activeAcdYear'),
        "head_id": $scope.manager_user._id,
        "headrole_id": $scope.manager_role.role_id
      };
      authService.callAPI(USERSETTINGSCONSTANT.API_SAVE_USER_MAPPING, "POST", reqObj, function (response) {
        if (response.result.data.message == "Success") {
          toastr.success("Saved Successfully");
          $state.go("reportingRoles");
          $scope.$apply();
        } else toastr.success("Please try again");
      });
    } else {
      toastr.error("Please add before saving");
    }
  };
  $scope.cancel = function () {
    $state.go("reportingRoles");
  };
  $scope.mapRoles = function () {
    $state.go("roleMapping");
  };
  $scope.addReportingRoles = function () {
    var roleId = $scope.selectedSubRole._id;
    var dataArray = [];
    var data = $scope.selectedSubUsers;
    for (var i = 0; i < data.length; i++) {
      var item = {
        "role_id": roleId,
        "role": $scope.selectedSubRole.name,
        "name": data[i].name,
        "_id": data[i]._id,
        "isSelected": data[i].isSelected,
        "parent_id": $scope.selectedManagerUser._id,
        "parent_name": $scope.selectedManagerUser.name,
        "parent_role_id": $scope.selectedManagerRole._id,
        "parent_role": $scope.selectedManagerRole.name
      };
      dataArray.push(item);
    }
    var users = _.filter(dataArray, function (obj) {
      return obj.isSelected === true;
    });
    $scope.reportingUsers[roleId] = users;
  };
  $scope.addToSelectedSubRole = function (data) {
    var roleId = $scope.selectedSubRole._id;
    if (data.isSelected) {
      var item = {
        "role_id": roleId,
        "role": $scope.selectedSubRole.name,
        "name": data.name,
        "_id": data._id,
        "isSelected": data.isSelected,
        "parent_id": $scope.selectedManagerUser._id,
        "parent_name": $scope.selectedManagerUser.name,
        "parent_role_id": $scope.selectedManagerRole._id,
        "parent_role": $scope.selectedManagerRole.name
      };
      $scope.selectedSubUsers.push(item);
    } else {
      if ($scope.selectedSubUsers.length > 0) {
        //Fixed issue #6316
        var index = $scope.selectedSubUsers.findIndex(function (i) {
          return i._id == data._id;
        });
        if (index > -1) $scope.selectedSubUsers.splice(index, 1);
      }
    }
  };

  $scope.searchLeadAmongResult = function (flag) {
    if (flag == 0) $scope.searching = true;else $scope.searching = false;
    $scope.isManager = true;
    $scope.isSubUser = false;
    $scope.current_role = $scope.selectedManagerRole._id;
    $scope.managerUsers = new HierarchyItems();
    $scope.subRoleList = [];
  };
  $scope.searchSubAmongResult = function (flag) {
    if (flag == 0) $scope.searching = true;else $scope.searching = false;
    $scope.subUsers = undefined;
    $scope.isManager = false;
    $scope.isSubUser = true;
    $scope.current_role = $scope.sub_role.role_id;

    $scope.subUsers = new HierarchyItems();
  };
};
CreateReportingHierarchy.$inject = ["$scope", "$state", "$timeout", "USERSETTINGSCONSTANT", "authService", "localStorageService"];

exports.default = CreateReportingHierarchy;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _createQuestion = __webpack_require__(76);

var _createQuestion2 = _interopRequireDefault(_createQuestion);

var _createQuestionController = __webpack_require__(155);

var _createQuestionController2 = _interopRequireDefault(_createQuestionController);

var _aslAudio = __webpack_require__(1251);

var _aslAudio2 = _interopRequireDefault(_aslAudio);

var _aslAudioController = __webpack_require__(1252);

var _aslAudioController2 = _interopRequireDefault(_aslAudioController);

var _aslFib = __webpack_require__(1253);

var _aslFib2 = _interopRequireDefault(_aslFib);

var _aslFibController = __webpack_require__(1254);

var _aslFibController2 = _interopRequireDefault(_aslFibController);

var _aslListen = __webpack_require__(1255);

var _aslListen2 = _interopRequireDefault(_aslListen);

var _aslListenController = __webpack_require__(1256);

var _aslListenController2 = _interopRequireDefault(_aslListenController);

var _aslMcq = __webpack_require__(1257);

var _aslMcq2 = _interopRequireDefault(_aslMcq);

var _aslMcqController = __webpack_require__(1258);

var _aslMcqController2 = _interopRequireDefault(_aslMcqController);

var _aslSpeak = __webpack_require__(1259);

var _aslSpeak2 = _interopRequireDefault(_aslSpeak);

var _aslSpeakController = __webpack_require__(1260);

var _aslSpeakController2 = _interopRequireDefault(_aslSpeakController);

var _aslText = __webpack_require__(1261);

var _aslText2 = _interopRequireDefault(_aslText);

var _aslTextController = __webpack_require__(1262);

var _aslTextController2 = _interopRequireDefault(_aslTextController);

var _aslTf = __webpack_require__(1263);

var _aslTf2 = _interopRequireDefault(_aslTf);

var _aslTfController = __webpack_require__(1264);

var _aslTfController2 = _interopRequireDefault(_aslTfController);

var _aslVoiceRecord = __webpack_require__(1265);

var _aslVoiceRecord2 = _interopRequireDefault(_aslVoiceRecord);

var _aslVoiceRecordController = __webpack_require__(1268);

var _aslVoiceRecordController2 = _interopRequireDefault(_aslVoiceRecordController);

var _draw = __webpack_require__(1270);

var _draw2 = _interopRequireDefault(_draw);

var _drawController = __webpack_require__(1271);

var _drawController2 = _interopRequireDefault(_drawController);

var _fibBulkUpload = __webpack_require__(1272);

var _fibBulkUpload2 = _interopRequireDefault(_fibBulkUpload);

var _fibBulkUploadController = __webpack_require__(1273);

var _fibBulkUploadController2 = _interopRequireDefault(_fibBulkUploadController);

var _fib = __webpack_require__(1275);

var _fib2 = _interopRequireDefault(_fib);

var _fibController = __webpack_require__(1276);

var _fibController2 = _interopRequireDefault(_fibController);

var _longBulkUpload = __webpack_require__(1277);

var _longBulkUpload2 = _interopRequireDefault(_longBulkUpload);

var _longBulkUploadController = __webpack_require__(1278);

var _longBulkUploadController2 = _interopRequireDefault(_longBulkUploadController);

var _long = __webpack_require__(1280);

var _long2 = _interopRequireDefault(_long);

var _longController = __webpack_require__(1281);

var _longController2 = _interopRequireDefault(_longController);

var _matchBulkUpload = __webpack_require__(1282);

var _matchBulkUpload2 = _interopRequireDefault(_matchBulkUpload);

var _matchBulkUploadController = __webpack_require__(1283);

var _matchBulkUploadController2 = _interopRequireDefault(_matchBulkUploadController);

var _match = __webpack_require__(1285);

var _match2 = _interopRequireDefault(_match);

var _matchController = __webpack_require__(1286);

var _matchController2 = _interopRequireDefault(_matchController);

var _mcqBulkUpload = __webpack_require__(1288);

var _mcqBulkUpload2 = _interopRequireDefault(_mcqBulkUpload);

var _mcqBulkUploadController = __webpack_require__(1289);

var _mcqBulkUploadController2 = _interopRequireDefault(_mcqBulkUploadController);

var _mcq = __webpack_require__(1291);

var _mcq2 = _interopRequireDefault(_mcq);

var _mcqController = __webpack_require__(1292);

var _mcqController2 = _interopRequireDefault(_mcqController);

var _owqBulkUpload = __webpack_require__(1293);

var _owqBulkUpload2 = _interopRequireDefault(_owqBulkUpload);

var _owqBulkUploadController = __webpack_require__(1294);

var _owqBulkUploadController2 = _interopRequireDefault(_owqBulkUploadController);

var _owq = __webpack_require__(1296);

var _owq2 = _interopRequireDefault(_owq);

var _owqController = __webpack_require__(1297);

var _owqController2 = _interopRequireDefault(_owqController);

var _passage = __webpack_require__(1298);

var _passage2 = _interopRequireDefault(_passage);

var _passageController = __webpack_require__(1299);

var _passageController2 = _interopRequireDefault(_passageController);

var _shortBulkUpload = __webpack_require__(1300);

var _shortBulkUpload2 = _interopRequireDefault(_shortBulkUpload);

var _shortBulkUploadController = __webpack_require__(1301);

var _shortBulkUploadController2 = _interopRequireDefault(_shortBulkUploadController);

var _short = __webpack_require__(1303);

var _short2 = _interopRequireDefault(_short);

var _shortController = __webpack_require__(1304);

var _shortController2 = _interopRequireDefault(_shortController);

var _tfBulkUpload = __webpack_require__(1305);

var _tfBulkUpload2 = _interopRequireDefault(_tfBulkUpload);

var _tfBulkUploadController = __webpack_require__(1306);

var _tfBulkUploadController2 = _interopRequireDefault(_tfBulkUploadController);

var _tf = __webpack_require__(1308);

var _tf2 = _interopRequireDefault(_tf);

var _tfController = __webpack_require__(1309);

var _tfController2 = _interopRequireDefault(_tfController);

__webpack_require__(1310);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('CreateQuestionModule', [_angularUiRouter2.default
//import modules
]).component("createQuestion", {
    template: _createQuestion2.default,
    controller: _createQuestionController2.default,
    controllerAs: 'createQuestion'
}).component("aslAudio", {
    template: _aslAudio2.default,
    controller: _aslAudioController2.default,
    controllerAs: 'aslAudio'
}).component("aslListen", {
    template: _aslListen2.default,
    controller: _aslListenController2.default,
    controllerAs: 'aslListen'
}).component("aslFib", {
    template: _aslFib2.default,
    controller: _aslFibController2.default,
    controllerAs: 'aslFib'
}).component("aslMcq", {
    template: _aslMcq2.default,
    controller: _aslMcqController2.default,
    controllerAs: 'aslMcq'
}).component("aslSpeak", {
    template: _aslSpeak2.default,
    controller: _aslSpeakController2.default,
    controllerAs: 'aslSpeak'
}).component("aslText", {
    template: _aslText2.default,
    controller: _aslTextController2.default,
    controllerAs: 'aslText'
}).component("aslTf", {
    template: _aslTf2.default,
    controller: _aslTfController2.default,
    controllerAs: 'aslTf'
}).component("aslVoiceRecord", {
    template: _aslVoiceRecord2.default,
    controller: _aslVoiceRecordController2.default,
    controllerAs: 'aslVoiceRecord'
}).component("draw", {
    template: _draw2.default,
    controller: _drawController2.default,
    controllerAs: 'draw'
}).component("fibBulkUpload", {
    template: _fibBulkUpload2.default,
    controller: _fibBulkUploadController2.default,
    controllerAs: 'fibBulkUpload'
}).component("fib", {
    template: _fib2.default,
    controller: _fibController2.default,
    controllerAs: 'fib'
}).component("longBulkUpload", {
    template: _longBulkUpload2.default,
    controller: _longBulkUploadController2.default,
    controllerAs: 'longBulkUpload'
}).component("long", {
    template: _long2.default,
    controller: _longController2.default,
    controllerAs: 'long'
}).component("matchBulkUpload", {
    template: _matchBulkUpload2.default,
    controller: _matchBulkUploadController2.default,
    controllerAs: 'matchBulkUpload'
}).component("match", {
    template: _match2.default,
    controller: _matchController2.default,
    controllerAs: 'match'
}).component("mcqBulkUpload", {
    template: _mcqBulkUpload2.default,
    controller: _mcqBulkUploadController2.default,
    controllerAs: 'mcqBulkUpload'
}).component("mcq", {
    template: _mcq2.default,
    controller: _mcqController2.default,
    controllerAs: 'mcq'
}).component("owqBulkUpload", {
    template: _owqBulkUpload2.default,
    controller: _owqBulkUploadController2.default,
    controllerAs: 'owqBulkUpload'
}).component("owq", {
    template: _owq2.default,
    controller: _owqController2.default,
    controllerAs: 'owq'
}).component("passage", {
    template: _passage2.default,
    controller: _passageController2.default,
    controllerAs: 'passage'
}).component("shortBulkUpload", {
    template: _shortBulkUpload2.default,
    controller: _shortBulkUploadController2.default,
    controllerAs: 'shortBulkUpload'
}).component("short", {
    template: _short2.default,
    controller: _shortController2.default,
    controllerAs: 'short'
}).component("tfBulkUpload", {
    template: _tfBulkUpload2.default,
    controller: _tfBulkUploadController2.default,
    controllerAs: 'tfBulkUpload'
}).component("tf", {
    template: _tf2.default,
    controller: _tfController2.default,
    controllerAs: 'tf'
}).controller('createQuestionCtrl', _createQuestionController2.default);

_module.constant("CQuesConst", {
    VALUE_POINTS_LIMIT: 500,
    QUES_DESC_LIMIT: 1000,
    OPTION_LIMIT: 200,
    ANS_EXPLANATION_LIMIT: 500,
    SKILL_LIST: ["Analysing", "Applying", "Creating", "Evaluating", "Recall", "Understanding"],
    QUESTION_IMG_SUPPORT_FORMAT: ['jpg', 'jpeg', 'png'],
    API_GET_BASIC_DETAILS: "/v0/ques-create/get-basic-details",
    API_GET_ALL_PASSAGES: "/v0/ques-create/get-passage-list",
    API_GET_QUESTION: "/v0/archives/preview/question/",
    API_OWQ_SAVE: "/v0/ques-create/owq",
    QUESTION_TYPE_LIST: [{
        name: "Multiple Choice Question",
        _id: "MCQ",
        isPractice: true
    }, {
        name: "Fill in the Blanks",
        _id: "FIB",
        isPractice: true
    }, {
        name: "True or False",
        _id: "TF",
        isPractice: true
    }, {
        name: "One Word Question",
        _id: "OWQ",
        isPractice: true
    }, {
        name: "Match the Following",
        _id: "MTF",
        isPractice: true
    }, {
        name: "Short Answer",
        _id: "SA",
        isPractice: false
    }, {
        name: "Long Answer",
        _id: "LA",
        isPractice: false
    },
    /*{
        name: "Drawing",
        _id: "DRAW",
        isPractice: false
    }, {
        name: "Asl - Listening",
        _id: "ASLLISTEN",
        isPractice: false
    }, {
        name: "Asl - Speaking",
        _id: "ASLSPEAK",
        isPractice: false
    },*/
    {
        name: "Passage",
        _id: "passage",
        isPractice: false
    }],
    ASL_ANS_TYPE: {
        AUDIO: "audio",
        MCQ: "mcq",
        FIB: "fib",
        TF: "tf",
        TEXT: "text"
    },
    API_CREATE_MCQ: "/v0/ques-create/mcq",
    API_CREATE_FIB: "/v0/ques-create/fib",
    API_CREATE_TF: "/v0/ques-create/tf",
    API_CREATE_MTF: "/v0/ques-create/mtf",
    API_CREATE_SA: "/v0/ques-create/sa",
    API_CREATE_LA: "/v0/ques-create/la",
    API_CREATE_DRAW: "/v0/ques-create/draw",
    API_CREATE_ASL_LISTEN: "/v0/ques-create/asl-listen",
    API_CREATE_ASL_SPEAK: "/v0/ques-create/asl-speak",
    API_CREATE_BULK_MCQ: "/v0/ques-create/bulk/mcq",
    API_CREATE_BULK_FIB: "/v0/ques-create/bulk/fib",
    API_CREATE_BULK_LA: "/v0/ques-create/bulk/la",
    API_CREATE_BULK_OWQ: "/v0/ques-create/bulk/owq",
    API_CREATE_BULK_SA: "/v0/ques-create/bulk/sa",
    API_CREATE_BULK_TF: "/v0/ques-create/bulk/tf",
    API_CREATE_BULK_MTF: "/v0/ques-create/bulk/mtf",
    API_CREATE_PASSAGE: "/v0/ques-create/passage"

});

_module.config(["$stateProvider", function ($stateProvider) {
    "ngInject";

    /*$stateProvider
        .state('createQuestion', {
            parent: 'app',
            url: '/createQuestion',
            views: {
                '@': {
                    template: createQuestionTpl,
                    controller: createQuestionCtrl,
                    controllerAs: 'createQuestion'
                }
            }
        })*/
}]);

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <div class=md-whiteframe-3dp layout=column> <div class=asl-audio-ans-head> Audio Answer </div> <div layout=column layout-padding> <md-input-container md-select-on-focus flex=90> <div class=qn-label>Enter Question</div> <div ng-show=!isLatex> <textarea ng-model=question md-maxlength=500 md-select-on-focus></textarea> </div> <div ng-show=isLatex> <span id={{quesId}} ng-model=question style=height:auto md-select-on-focus ng-paste=paste($event)></span> </div> <div class=errorMessage>{{errors['question']}}</div> <md-checkbox ng-model=isLatex> With formula </md-checkbox> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> </md-input-container> <div layout=row layout-align=space-between class=asl-audio-ans-content> <div class=\"md-whiteframe-2dp asl-icon-div asl-pad-left-7\" flex=5> <img class=hand ngf-select ngf-change=uploadAudio($file) src=" + __webpack_require__(165) + "> </div> <asl-voice-record index=voiceIndex flex=5></asl-voice-record> <div flex=35 ng-if=playableAnswerUrl class=\"md-whiteframe-2dp asl-audio-play\" ng-init=playableAnswerUrl> <audio controls ng-src={{playableAnswerUrl}}></audio> </div> <div flex=35 ng-if=!playableAnswerUrl></div> <div flex=50></div> </div> <div ng-show=errors.ans_audio_url class=errorMessage>{{errors['ans_audio_url']}}</div> </div> </div> <div layout=column class=asl-add-list-button layout-align=\"end end\"> <md-button md-no-ink class=\"addToQues md-ink-ripple\" ng-click=addToList() layout=row>Add to list </md-button> </div> </div> ";

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslAudioController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslAudioController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "$timeout", "CQuesConst", "CONSTANTS", "Upload", "$sce", "uploadService", function AslAudioController($scope, $rootScope, authService, localStorageService, $state, $timeout, CQuesConst, CONSTANTS, Upload, $sce, uploadService) {
    var _this = this;

    _classCallCheck(this, AslAudioController);

    var MQ = MathQuill.getInterface(2);
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/asl/";
    var schoolId = localStorageService.get("school_id");
    var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_DRAW;
    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }

        $scope.index = _this.index;
        $scope.quesId = "text-question" + $scope.index;
        $scope.voiceIndex = $scope.index + 1;
        if ($scope.$parent.editQuestions[$scope.index]) {
            var currentQuestion = $scope.$parent.editQuestions[$scope.index];
            if (currentQuestion) {
                if (currentQuestion.qn_desc) {
                    $scope.question = currentQuestion.qn_desc;
                    $scope.isLatex = currentQuestion.isLatex;
                }
                if (currentQuestion.answer) {
                    $scope.ans_audio_url = currentQuestion.answer;
                    var src = PREVIEW_URL + $scope.ans_audio_url;
                    $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src);
                }
            }
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    $scope.loadLatexSelection = function () {
        $timeout(function () {
            $scope.isLatex = false;
        });
    };

    $timeout(function () {
        var MQ = MathQuill.getInterface(2);
        var textQuestion = document.getElementById("text-question" + $scope.index);
        textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
        if ($scope.question !== undefined) {
            textQuestion.textContent = $scope.question;
        }
        var mathField = MQ.MathField(textQuestion, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function edit() {
                    $scope.question = mathField.latex();
                }
            }
        });
    }, 10);

    /*
     * Function to upload audio
     *
     * @return : null
     */
    $scope.uploadAudio = function (file) {
        if (fileValidate(file)) {
            var user_id = userId;
            Upload.upload({
                url: UPLOAD_URL,
                data: {
                    file: file,
                    'userPath': USER_PATH
                }
            }).then(function (resp) {
                updateAudioUrl(resp.data);
            });
        }
    };

    /*
     * Function to upload audio
     *
     * @return : null
     */
    function updateAudioUrl(url) {
        $scope.ans_audio_url = url;
        var src = PREVIEW_URL + url;
        $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src);
        $scope.isLoading = true;
        toastr.success("Audio uploaded successfully...");
    }

    /*
     * Function to validate audio files
     *
     * @file : uploaded file
     *
     * @return : Boolean - validity of file
     */
    function fileValidate(file) {
        var supportedFrmts = ['mp3', 'wav'];
        var isValid = false;

        if (file && !file.$error && file !== undefined && file !== null) {
            var fileSize = file.size / 1048576;
            var extValue = file.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                // if (file.type === "audio/mp3" || file.type === "audio/wav") {
                if (fileSize < 6.00) {
                    if (file.name !== "") {
                        $scope.isLoading = false;
                        isValid = true;
                    } else {
                        $scope.isLoading = true;
                        toastr.error("File is not valid");
                        isValid = false;
                    }
                } else {
                    $scope.isLoading = true;
                    toastr.error("Please upload audio file size less than 6MB");
                    isValid = false;
                };
            } else {
                $scope.isLoading = true;
                toastr.error('Please select supported mp3 or wav file formats.');
                isValid = false;
            }
        }
        return isValid;
    }

    /*
     * Function to add to list
     *
     * @return : null
     */
    $scope.addToList = function () {
        $scope.errors = {};
        var errCount = 0;
        if ($scope.question === undefined || $scope.question === "") {
            $scope.errors.question = "Please Enter Question";
            errCount++;
        } else if ($scope.question.length > 500) {
            $scope.errors.question = "Question must not exceed 500 characters";
            errCount++;
        }

        // if ($scope.ans_audio_url === undefined || $scope.ans_audio_url === "") {
        //     $scope.errors.ans_audio_url = "Please Upload or record sample audio answer"
        //     errCount++;
        // }
        if (errCount == 0) {
            var obj = {
                type: ASL_ANS_TYPE.AUDIO,
                qn_desc: $scope.question,
                isLatex: $scope.isLatex,
                answer: $scope.ans_audio_url
            };
            $scope.question = "";
            $scope.isLatex = false;
            $scope.ans_audio_url = "";
            $scope.$parent.addToList(obj, $scope.index);
        }
    };

    /*
     * Function to save recorded file url
     *
     * @url : uploaded file url
     *
     * @return : null
     */
    $scope.saveRecordedUrl = function (url) {
        updateAudioUrl(url);
    };

    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };
}];

exports.default = AslAudioController;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <md-divider class=dividerBorder></md-divider> </div> <div class=contentBox> <div layout=column flex layout-align=center> <div layout=row flex layout-align=\"space-between center\"> <md-input-container flex=95> <label>Enter Question</label> <textarea ng-model=fib.qn_desc ng-keyup=fib.onQuesLoad() md-maxlength=500 txt-maxlength=500 md-select-on-focus></textarea> <p class=errorMessage>{{errors.qn_desc}}</p> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=fib.uploadImg($files,fib)> <img ng-if=fib.questionImg flex=45 ng-src=\"{{tempData + fib.questionImg}}\" style=height:100px;width:100px> <img class=hand ng-if=fib.questionImg src=" + __webpack_require__(16) + " ng-click=fib.removeImage()> </div> </div> <div layout=row ng-show=fib.qn_desc layout-wrap flex=95 id={{id}} class=fibContent> {{add_my_special_behavior}} </div> </div> </div> <md-divider class=dividerBorder></md-divider> <div class=contentBox> <div layout=row layout-wrap flex> <div layout=column flex=45 ng-repeat=\"ansHint in fib.answers\" class=\"md-whiteframe-2dp fibExpDiv\"> <div class=fibExpNoDiv flex style=background-color:{};>{{$index+1}}</div> <md-input-container> <label>Answer Explanation</label> <textarea ng-model=ansHint.explanation md-maxlength=50 txt-maxlength=50></textarea> <p class=errorMessage>{{errors[\"answers.\" + $index + \".explanation\"]}}</p> </md-input-container> </div> </div> <div layout=column class=asl-add-list-button layout-align=\"end end\"> <md-button md-no-ink class=\"addToQues md-ink-ripple\" ng-click=addToList() layout=row>Add to list </md-button> </div> </div> ";

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslFibController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslFibController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$timeout", "CONSTANTS", "CQuesConst", "uploadService", "randomColorService", function AslFibController($scope, $rootScope, localStorageService, $state, $timeout, CONSTANTS, CQuesConst, uploadService, randomColorService) {
    var _this = this;

    _classCallCheck(this, AslFibController);

    var MQ = MathQuill.getInterface(2);
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/asl/";
    var schoolId = localStorageService.get("school_id");
    var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_DRAW;
    $scope.errors = {};

    $scope.index;

    $scope.fib = {};

    $scope.fib.answers = [];

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $scope.index = _this.index;
        $scope.id = "answer" + $scope.index;
        if ($scope.$parent.editQuestions[$scope.index]) {
            $scope.questionData = $scope.$parent.editQuestions[$scope.index];
            if ($scope.questionData) {
                $scope.fib.qn_desc = $scope.questionData.qn_desc;
                $scope.fib.questionImg = $scope.questionData.questionImg;
            }
        }
    };
    //On destroy function
    this.$onDestroy = function () {};

    $timeout(function () {
        if ($scope.questionData && $scope.questionData.answer) {
            $scope.fib.onQuesLoad();
            $scope.fib.answers = _.map($scope.questionData.answer, function (ans) {
                ans["color"] = randomColorService.getRandomColor();
                return ans;
            });
        }
    }, 1000);

    $scope.fib.onQuesLoad = function () {
        if ($scope.fib.qn_desc === undefined) {
            return;
        }
        var question = $scope.fib.qn_desc;
        var fibOptions = question.split('_');
        var loadedQst = "";
        var querySl = "#" + $scope.id;
        var myEl = angular.element(document.querySelector(querySl));
        myEl.empty();
        $scope.fib.answers = [];
        _.each(fibOptions, function (option, index) {
            if (index === fibOptions.length - 1) {
                loadedQst = " " + option.trim();
                myEl.append(loadedQst);
                return;
            }
            if ($scope.questionData && $scope.questionData.answer && $scope.questionData.answer[index]) {
                $scope.fib.answers.push({
                    "color": randomColorService.getRandomColor(),
                    "desc": $scope.questionData.answer[index].desc,
                    "explanation": $scope.questionData.answer[index].explanation
                });
            } else {
                $scope.fib.answers.push({
                    "color": randomColorService.getRandomColor()
                });
            }
            loadedQst = " " + option.trim() + " ";
            myEl.append(loadedQst);
            myEl.append($compile('<md-input-container class="fibAnswer"><label>Enter Answer</label><textarea md-maxlength="50" txt-maxlength="50" type="text" ng-model="fib.answers[' + index + '].desc"></textarea><p class="errorMessage">{{errors["answers.' + index + '.desc"]}}</p></md-input-container>')($scope));
        });
    };

    //Image upload for Question
    $scope.fib.uploadImg = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                // if (fileObj.type === "image/jpg" || fileObj.type === "image/jpeg" || fileObj.type === "image/png") {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        opt.questionImg = result.url;
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    $scope.fib.removeImage = function () {
        $scope.fib.questionImg = undefined;
    };

    /*
     * Function to add to list
     *
     * @return : null
     */
    $scope.addToList = function () {
        $scope.errors = {};
        var errCount = 0;
        var answerArr = [];
        _.each($scope.fib.answers, function (ans, index) {
            var ansObj = {
                "desc": ans.desc,
                "explanation": ans.explanation
            };
            answerArr.push(ansObj);
        });
        var obj = {
            qn_desc: $scope.fib.qn_desc,
            answer: answerArr
        };
        if (obj.qn_desc == null || obj.qn_desc == undefined || obj.qn_desc == "") {
            $scope.errors.qn_desc = "Question is required";
            errCount++;
        } else if (obj.qn_desc.split('_').length < 2) {
            $scope.errors.qn_desc = "Enter a valid question";
            errCount++;
        }
        if (obj.answer) {
            _.each(obj.answer, function (answer, index) {
                if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                    $scope.errors["answers." + index + ".desc"] = "Answer is required";
                    errCount++;
                }
            });
        }
        if (errCount == 0) {
            var objtoAdd = {
                type: ASL_ANS_TYPE.FIB,
                qn_desc: $scope.fib.qn_desc,
                answer: answerArr,
                questionImg: $scope.fib.questionImg
            };
            $scope.fib.qn_desc = '';
            $scope.fib.questionImg = '';
            _.each($scope.fib.answers, function (option_val, option_key) {
                $scope.fib.answers[option_key].explanation = '';
            });
            $scope.$parent.addToList(objtoAdd, $scope.index);
        }
    };
}];

exports.default = AslFibController;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <md-divider class=dividerBorder></md-divider> <div layout=row layout-align=space-between> <md-input-container flex=50> <label>Enter Title</label> <textarea type=text name=title ng-model=asl.title maxlength=500></textarea> <div class=errorMessage>{{errors['qn_desc']}}</div> </md-input-container> <div class=\"md-whiteframe-2dp hand asl-icon-div asl-pad-left-7\" flex=5> <img ngf-select ngf-change=uploadAudio($file) src=" + __webpack_require__(165) + "> </div> <asl-voice-record index=0 flex=5></asl-voice-record> <div flex=35 ng-if=playableQuestionUrl class=\"md-whiteframe-2dp asl-audio-play\" ng-init=playableQuestionUrl> <audio controls ng-src={{playableQuestionUrl}}></audio> </div> <div flex=35 ng-if=!playableQuestionUrl></div> <div class=errorMessage>{{errors['audio_url']}}</div> </div> <md-divider class=dividerBorder></md-divider> <div class=errorMessage>{{errors['question']}}</div> <div ng-repeat=\"question in asl.questions\"> <div class=asl-list-question layout=row> <div flex=5>({{$index+1}})</div> <div class=latex_field ng-show=question.isLatex flex=80>{{question.qn_desc}}</div> <div flex=80 ng-show=!question.isLatex>{{question.qn_desc}}</div> <div flex=10 layout=row layout-align=\"end end\"> <md-menu layout flex=none> <div aria-label=Menu class=md-icon-button ng-click=\"openMenu($mdOpenMenu, $event)\"> <i class=\"fas fa-caret-square-down\"> More Options </i> </div> <md-menu-content class=menuData> <md-menu-item> <md-button> <span ng-click=editQuestion($index,question.type)> <i class=\"far fa-edit\"> Edit </i> </span> </md-button> </md-menu-item> <md-menu-item> <md-button> <span ng-click=removeQuestion($index)> <i class=\"hand far fa-trash-alt\"> Delete </i> </span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </div> <div layout=row flex class=asl-list-content> <div flex=5></div> <div ng-if=\"question.type==='audio'\"> <div flex ng-if=question.answer class=md-whiteframe-2dp ng-init=convertURLTotrustUrl(question.answer,$index)> <audio controls ng-src={{convertedURL[$index]}}></audio> </div> </div> <div ng-if=\"question.type==='text'\"> <div class=latex_field ng-show=question.isLatex> {{question.answer}} </div> <div ng-show=!question.isLatex> {{question.answer}} </div> </div> <div ng-if=\"question.type==='mcq'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.choice\"> <div flex=5>{{$index+1}}.</div> <div class=latex_field ng-show=question.isLatex flex>{{choice.desc}}</div> <div ng-show=!question.isLatex flex>{{choice.desc}}</div> </div> </div> <div ng-if=\"question.type==='fib'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.answer\"> <div flex=5>{{$index+1}}.</div> <div class=latex_field ng-show=question.isLatex flex>{{choice.desc}}</div> <div ng-show=!question.isLatex flex>{{choice.desc}}</div> </div> </div> <div ng-if=\"question.type==='tf'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.choice\"> <div flex=5>{{$index+1}}.</div> <div class=latex_field ng-show=question.isLatex flex>{{choice.tag}}</div> <div ng-show=!question.isLatex flex>{{choice.tag}}</div> </div> </div> </div> <md-divider class=dividerBorder></md-divider> </div> <div ng-if=isAddQuestionAvail ng-repeat=\"editQues in editQuestions\"> <div layout=row layout-align=\"start center\"> <md-input-container flex=30> <label>Enter Question Type</label> <md-select ng-model=editQues.type> <md-option value=audio>Audio</md-option> <md-option value=mcq>Multiple Choice Questions</md-option> <md-option value=fib>Fill in the Blanks</md-option> <md-option value=tf>True or False</md-option> <md-option value=text>Paragraph</md-option> </md-select> </md-input-container> </div> <div layout=row flex> <asl-audio index=$index ng-if=\"editQues.type=='audio'\" flex></asl-audio> <asl-mcq index=$index ng-if=\"editQues.type=='mcq'\" flex></asl-mcq> <asl-fib index=$index ng-if=\"editQues.type=='fib'\" flex></asl-fib> <asl-tf index=$index ng-if=\"editQues.type=='tf'\" flex></asl-tf> <asl-text index=$index ng-if=\"editQues.type=='text'\" flex></asl-text> </div> </div> <md-divider class=dividerBorder></md-divider> <md-button md-no-ink class=\"questionButton moreChoiceButton md-ink-ripple\" layout=row ng-click=addQuestion()>Add Question <span class=plusSymbol><i class=\"fas fa-plus\"></i></span> </md-button> </div> <md-divider class=dividerBorder> </md-divider> ";

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslListenController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslListenController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$sce", "Upload", function AslListenController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $sce, Upload) {
  _classCallCheck(this, AslListenController);

  //On init function
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    $rootScope.title = "Archives";
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, {
        reload: true
      });
    }
  };
  var MQ = MathQuill.getInterface(2);
  var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
  var userId = localStorageService.get("user_id");
  var USER_PATH = userId + "/asl/";
  var schoolId = localStorageService.get("school_id");
  var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
  var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
  var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
  var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
  var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
  var SAVE_URL = CQuesConst.API_CREATE_ASL_LISTEN;
  //Object - holds the question details
  $scope.asl = {};

  //[Object] - List of questions
  $scope.asl.questions = [];

  //String - Url to play audio
  $scope.playableQuestionUrl;

  //Boolean - Show add question section
  $scope.isAddQuestionAvail = true;

  $scope.editQuestions = [];

  $scope.convertedURL = {};
  $scope.questionImage = [];
  $scope.content_editor_id = userId;
  var question = $scope.$parent.$parent.editQuestion;
  if (question) {
    $scope.question = question.qn_desc;
    $scope.asl.title = question.qn_desc;
    $scope.asl.qn_audio_url = question.audio_url;
    if (question.audio_url) {
      var src = PREVIEW_URL + question.audio_url;
      $scope.playableQuestionUrl = $sce.trustAsResourceUrl(src);
    }
    if (question.questions && question.questions.length > 0) $scope.asl.questions = question.questions ? question.questions : [];else {
      $scope.editQuestions.push({
        type: ASL_ANS_TYPE.AUDIO
      });
    }
  } else {
    $scope.editQuestions.push({
      type: ASL_ANS_TYPE.AUDIO
    });
  }

  /*
   * Function to add questions
   *
   * @return : null
   */
  $scope.addQuestion = function () {
    $scope.editQuestions.push({
      type: ASL_ANS_TYPE.AUDIO
    });
    $scope.isAddQuestionAvail = true;
  };

  /*
   * Function to remove questions
   *
   * @return : null
   */
  $scope.removeQuestion = function (index) {
    $scope.asl.questions.splice(index, 1);
    if ($scope.asl.questions.length == 0 || $scope.editQuestions.length == 0) {
      $scope.isAddQuestionAvail = true;
    }
  };

  /*
   * Function to edit questions
   *
   * @index : String - index of the item to removed
   *
   * @return : null
   */
  $scope.editQuestion = function (index) {
    $scope.editQuestions.push($scope.asl.questions[index]);
    $scope.asl.questions.splice(index, 1);
    $scope.isAddQuestionAvail = true;
  };

  /*
   * Function to add to list
   *
   * @obj : Object - question to add
   *
   * @index : String - index
   *
   * @return : null
   */
  $scope.addToList = function (obj, index) {
    $scope.asl.questions.push(obj);
    $scope.editQuestions.splice(index, 1);
    if ($scope.editQuestions.length == 0) {
      $scope.isAddQuestionAvail = false;
    }
    $timeout(function () {
      var questionElements = document.getElementsByClassName('latex_field');
      _.each(questionElements, function (spanElement) {
        MQ.StaticMath(spanElement);
      });
    }, 10);
  };

  /*
   * Function to open menu
   *
   * @return : null
   */
  $scope.openMenu = function ($mdOpenMenu, ev) {
    //originatorEv = ev;
    $mdOpenMenu(ev);
  };

  /*
   * Function to convert to trust url
   *
   * @url : String - url to convert
   *
   * @index : String - index of the url
   *
   * @return : null
   */
  $scope.convertURLTotrustUrl = function (url, index) {
    $scope.convertedURL[index] = $sce.trustAsResourceUrl(PREVIEW_URL + url);
  };

  /*
   * Function to upload audio
   *
   * @return : null
   */
  $scope.uploadAudio = function (file) {
    if (fileValidate(file)) {
      var user_id = userId;
      Upload.upload({
        url: UPLOAD_URL,
        data: {
          file: file,
          'userPath': USER_PATH
        }
      }).then(function (resp) {
        updateAudioUrl(resp.data);
      });
    }
  };

  /*
   * Function to upload audio
   *
   * @return : null
   */
  function updateAudioUrl(url) {
    $scope.asl.qn_audio_url = url;
    var src = PREVIEW_URL + url;
    $scope.playableQuestionUrl = $sce.trustAsResourceUrl(src);
    $scope.isLoading = true;
    toastr.success("Audio uploaded successfully...");
  }

  /*
   * Function to validate audio files
   *
   * @file : uploaded file
   *
   * @return : Boolean - validity of file
   */
  function fileValidate(file) {
    var supportedFrmts = ['mp3', 'wav'];
    var isValid = false;

    if (file && !file.$error && file !== undefined && file !== null) {
      var fileSize = file.size / 1048576;
      var extValue = file.name.split('.').pop();
      if (_.contains(supportedFrmts, extValue)) {
        // if (file.type === "audio/mp3" || file.type === "audio/wav") {
        if (fileSize < 6.00) {
          if (file.name !== "") {
            $scope.isLoading = false;
            isValid = true;
          } else {
            $scope.isLoading = true;
            toastr.error("File is not valid");
            isValid = false;
          }
        } else {
          $scope.isLoading = true;
          toastr.error("Please upload audio file size less than 6MB");
          isValid = false;
        };
      } else {
        $scope.isLoading = true;
        toastr.error('Please select supported mp3 or wav file formats.');
        isValid = false;
      }
    }
    return isValid;
  }

  /*
   * Function to save recorded file url
   *
   * @url : uploaded file url
   *
   * @return : null
   */
  $scope.saveRecordedUrl = function (url) {
    updateAudioUrl(url);
  };

  //Adding asl-listening question from UI
  $scope.$on('addAslListening', function () {

    var details = localStorageService.get("questionDetails");
    var question = details.question;
    var activityErrorCount = details.errorCount;

    //Validation 
    $scope.errors = {};

    if ($scope.asl.title == undefined || $scope.asl.title == "" || $scope.asl.title == null) {
      activityErrorCount++;
      $scope.errors['qn_desc'] = "Question title is requrired";
    }
    if ($scope.asl.qn_audio_url == undefined || $scope.asl.qn_audio_url == "" || $scope.asl.qn_audio_url == null) {
      activityErrorCount++;
      $scope.errors["audio_url"] = "Upload a audio file";
    }
    if ($scope.asl.questions && $scope.asl.questions.length <= 0) {
      activityErrorCount++;
      $scope.errors['question'] = "Add atleast one question and answer for the audio";
    }

    if (activityErrorCount === 0) {
      $scope.$parent.isSaveClicked = true;
      var obj = {
        "_id": $scope._id,
        "question_theme_id": question.theme._id,
        "question_theme_name": question.theme.name,
        "desc": $scope.desc,
        "audio_url": $scope.asl.qn_audio_url,
        "questions": angular.copy($scope.asl.questions),
        "strand": question.strand,
        "tag": question.tag,
        "wave": question.wave,
        "qn_desc": '' + $scope.question,
        "isLatex": $scope.isLatex,
        "level": question.level,
        "subject_id": question.subject_id,
        "school_id": question.school_id,
        "questionImg": $scope.questionImage,
        "session_id": question.session_id,
        "batch_id": question.batch_id,
        "class_id": question.class_id,
        "curriculum_id": question.curriculum_id,
        "xlink": question.link_theme,
        "cognitive_skills": question.cognitive_skill,
        "isNotAddToQp": question.isNotAddToQp,
        "is_traditional_activity": question.is_traditional_activity,
        "qp_id": question.qp_id,
        "activity_id": question.activity_id,
        "user_id": userId,
        "created_dt": $scope.created_dt,
        "content_editor_id": $scope.content_editor_id
        //SAVE CALL
      };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
        var result = resObj.result;
        if (result && result.data && result.data.success) {
          $rootScope.setHideSaveButton(false);
          $rootScope.setLoader(false);
          $rootScope.resetValues();
          if (question.is_traditional_activity) {
            $state.go('formatQuestion', {
              qpId: question.qp_id
            });
            toastr.success("Question Saved successfully");
          } else {
            if (result.data.isExists) {
              toastr.success("Question already exists");
            } else {
              toastr.success("Question Saved successfully");
              $rootScope.setSearchFieldSession();
            }
          }
        } else {
          $rootScope.setHideSaveButton(false);
          $rootScope.setLoader(false);
          toastr.error("Network Error");
        }
        _.defer(function () {
          $scope.$apply();
        });
      });
    } else {
      $rootScope.setHideSaveButton(false);
      $rootScope.setLoader(false);
      toastr.error("Please fill all mandatory fields");
    }
  });

  //On destroy function
  this.$onDestroy = function () {};
}];

exports.default = AslListenController;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.mq-editable-field{width:100%;border:none}</style> <div class=contentBox> <md-divider class=dividerBorder></md-divider> <div layout=row flex layout-align=\"space-between center\"> <md-input-container md-select-on-focus flex=90> <div ng-show=mcq.isLatex> <div class=qn-label>Enter Question</div> <span id={{id}} ng-paste=paste($event) ng-model=mcq.question style=height:auto md-select-on-focus></span> </div> <div ng-show=!mcq.isLatex> <label>Enter Question</label> <textarea ng-model=mcq.question md-maxlength=500 txt-maxlength=500 md-select-on-focus></textarea> </div> <md-checkbox ng-model=mcq.isLatex> With formula </md-checkbox> <div class=errorMessage>{{errors['qn_desc']}}</div> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=mcq.isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=mcq.uploadImg($files,mcq)> <img ng-if=mcq.questionImg flex=45 ng-src=\"{{aslMcq.tempData + mcq.questionImg}}\" style=height:100px;width:100px> <img class=hand ng-if=mcq.questionImg src=" + __webpack_require__(16) + " ng-click=mcq.removeQuestionImg()> </div> </div> </div> <md-divider class=dividerBorder></md-divider> <div class=contentBox> <div class=md-whiteframe-2dp> <div class=optionHeading layout=row layout-align=\"space-between start\"> <div flex=5>No.</div> <div flex=35>Answers <p class=errorMessage>{{errors[\"duplicateAns\"]}}</p></div> <div flex=10>Hint</div> <div flex=20>Correct Answers <p class=errorMessage>{{errors[\"correctAnswer\"]}}</p> </div> </div> <div ng-repeat=\"option in mcq.options\"> <div layout=row layout-align=\"space-between center\"> <div flex=5 class=\"optionCaption mcqOptionDiv mcqOptionCaptionFont\" style=background-color:#2ab4bf>{{option.caption}}</div> <md-input-container flex=30> <label>Option {{option.caption}}</label> <textarea ng-model=option.value ng-show=!mcq.isLatex md-maxlength=50 txt-maxlength=50></textarea> <span class=\"option-field mathquill-editable\" ng-show=mcq.isLatex ng-model=option.value style=height:auto ng-init=mcq.optionsLoaded(option)></span> <p class=errorMessage>{{errors[\"option.\" + $index + \".desc\"]}}</p> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=mcq.optionImgUpload($files,option)> <img ng-if=option.optImage flex=45 ng-src=\"{{aslMcq.tempData + option.optImage}}\" style=height:100px;width:100px> <img class=hand ng-if=option.optImage src=" + __webpack_require__(16) + " ng-click=mcq.removeImage($index)> </div> <md-input-container flex=20> <label>Enter Hint</label> <textarea ng-model=option.hint ng-show=!mcq.isLatex md-maxlength=50 txt-maxlength=50></textarea> <span class=\"hint-field mathquill-editable\" ng-show=mcq.isLatex ng-model=option.hint style=height:auto ng-init=mcq.hintsLoaded(option)> </span> <p class=errorMessage>{{errors[\"option.\" + $index + \".hint\"]}}</p> </md-input-container> <md-input-container flex=5> <md-checkbox ng-model=option.correct ng-click=mcq.correctValueClick()> </md-checkbox> <p class=errorMessage>{{errors[\"option.\" + $index + \".correctValue\"]}}</p> </md-input-container> <div flex=5><img class=hand src=" + __webpack_require__(16) + " ng-click=mcq.removeOption($index)></div> </div> <md-divider></md-divider> </div> </div> <div layout=row> <div flex=50> <md-button md-no-ink class=\"questionButton moreChoiceButton md-ink-ripple\" layout=row ng-click=mcq.addOption()> Add more choice <span class=plusSymbol> <i class=\"material-icons md-18\">add</i> </span> </md-button> </div> <div layout=column flex=50 class=asl-add-list-button layout-align=\"end end\"> <md-button md-no-ink class=\"addToQues md-ink-ripple\" ng-click=addToList() layout=row>Add to list </md-button> </div> </div> </div> ";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslMcqController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslMcqController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$timeout", "CONSTANTS", "CQuesConst", "uploadService", function AslMcqController($scope, $rootScope, localStorageService, $state, $timeout, CONSTANTS, CQuesConst, uploadService) {
    var _this = this;

    _classCallCheck(this, AslMcqController);

    var MQ = MathQuill.getInterface(2);
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/asl/";
    var schoolId = localStorageService.get("school_id");
    var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_DRAW;
    $scope.mcq = {};

    $scope.errors = {};

    $scope.mcq.options = [];

    $scope.mcq.question = "";

    $scope.mcq.questionImg = "";

    $scope.mcq.isLatex = false;

    $scope.index;
    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $scope.index = _this.index;
        $scope.id = "math-field" + $scope.index;
        if ($scope.$parent.editQuestions[$scope.index]) {
            var question = $scope.$parent.editQuestions[$scope.index];
            if (question) {
                $scope.mcq.question = question.qn_desc;
                $scope.mcq.questionImg = question.questionImg;
                $scope.mcq.isLatex = question.isLatex;
                if (question.choice && question.choice.length > 0) {
                    $scope.mcq.options = [];
                    _.each(question.choice, function (ch) {
                        var colorIndex = calIndex($scope.mcq.options.length, 4);
                        $scope.mcq.options.push({
                            'caption': ch.tag,
                            'color': self.optionColors[colorIndex],
                            'value': ch.desc,
                            'hint': ch.hint,
                            'correct': ch.correct,
                            'optImage': ch.optImage
                        });
                    });
                }
            }
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];

    for (var i = 0; i < 4; i++) {
        var option = {
            caption: this.alphabets[i],
            color: this.optionColors[i]
        };
        $scope.mcq.options.push(option);
    }

    var calIndex = function calIndex(index, length) {
        if (index >= length) {
            if (index - length >= length) return calIndex(index - length, length);else return index - length;
        } else return index;
    };

    //Image upload for question
    $scope.mcq.uploadImg = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        opt.questionImg = result.url;
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    $scope.mcq.removeQuestionImg = function (index) {
        $scope.mcq.questionImg = undefined;
    };

    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    //Image upload for option
    $scope.mcq.optionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        _.each($scope.mcq.options, function (key, val) {
                            if ($scope.mcq.options[val].caption === opt.caption) {
                                var resultOpt = $scope.mcq.options[val];
                                resultOpt['optImage'] = result.url;
                            }
                        });
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    $scope.mcq.removeImage = function (index) {
        $scope.mcq.options[index].optImage = undefined;
    };

    $scope.mcq.addOption = function () {
        var alphaIndex = calIndex($scope.mcq.options.length, 26);
        var colorIndex = calIndex($scope.mcq.options.length, 4);
        var option = {
            'caption': this.alphabets[alphaIndex],
            'color': this.optionColors[colorIndex]
        };
        $scope.mcq.options.push(option);
    };

    $scope.mcq.removeOption = function (index) {
        if ($scope.mcq.options.length == 2) {
            return false;
        } else {
            var tempOptions = [];
            angular.copy($scope.mcq.options, tempOptions);
            for (var i = 0; i < $scope.mcq.options.length; i++) {
                if (i > index) {
                    $scope.mcq.options[i].caption = tempOptions[i - 1].caption;
                    $scope.mcq.options[i].color = tempOptions[i - 1].color;
                }
            }
            $scope.mcq.options.splice(index, 1);
        }
    };

    //Question desc with latex
    $timeout(function () {
        var mathFieldSpan = document.getElementById('math-field' + $scope.index);
        mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
        var MQ = MathQuill.getInterface(2);
        if ($scope.mcq.question) {
            mathFieldSpan.textContent = $scope.mcq.question;
        }
        var mathField = MQ.MathField(mathFieldSpan, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function edit() {
                    $scope.mcq.question = mathField.latex();
                }
            }
        });
    }, 10);

    //Invokes after the option elements loaded
    $scope.mcq.optionsLoaded = function (option) {
        var optionFieldSpan = document.getElementsByClassName('option-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.value) {
                spanElement.textContent = option.value;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.value = optionField.latex();
                    }
                }
            });
        });
    };

    //Invokes after the hint elements loaded
    $scope.mcq.hintsLoaded = function (option) {
        var hintFieldSpan = document.getElementsByClassName('hint-field');
        _.each(hintFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.hint) {
                spanElement.textContent = option.hint;
            }
            var hintField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.hint = hintField.latex();
                    }
                }
            });
        });
    };

    /*
     * Function to add to list
     *
     * @return : null
     */
    $scope.addToList = function () {
        $scope.errors = {};
        var errCount = 0;

        var answerArr = [];

        var duplicateOptCnt = 0;

        var correctAnswerCount = 0;

        var choicesData = [];

        _.each($scope.mcq.options, function (optionObj, index) {
            var option = {
                "tag": optionObj.caption,
                "desc": optionObj.value,
                "correct": optionObj.correct,
                "optImage": optionObj.optImage,
                "hintImage": ""
            };
            if (optionObj.correct) {
                option["hint"] = optionObj.hint;
                option['curr'] = 1;
            } else {
                option["correct"] = false;
                option["hint"] = optionObj.hint;
                option['curr'] = 0;
            }
            choicesData.push(option);
        });

        var objToValidate = {
            "qn_desc": $scope.mcq.question,
            "choice": choicesData

            //Validation  
        };if (objToValidate.qn_desc == null || objToValidate.qn_desc == undefined || objToValidate.qn_desc == "") {
            $scope.errors.qn_desc = "Question is required";
            errCount++;
        } else if (objToValidate.qn_desc.length > 500) {
            $scope.errors.qn_desc = "Question does not exceed 500 characters";
            errCount++;
        }
        if (objToValidate.choice) {
            _.each(objToValidate.choice, function (answer, index) {
                if ($scope.isPractice) {
                    if (answer.hint == null || answer.hint == undefined || answer.hint == "") {
                        $scope.errors["option." + index + ".hint"] = "Hint is required";
                        errCount++;
                    }
                }
                if (answer.hint && answer.hint.length > 500) {
                    $scope.errors["option." + index + ".hint"] = "Hint does not exceed 500 characters";
                    errCount++;
                }
                if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                    $scope.errors["option." + index + ".desc"] = "Answer is required";
                    errCount++;
                } else if (answer.desc.length > 500) {
                    $scope.errors["option." + index + ".desc"] = "Answer does not exceed 500 characters";
                    errCount++;
                }
                if (answer.correct) correctAnswerCount++;
                if (answer.desc) {
                    if (answerArr.indexOf(answer.desc) === -1) {
                        answerArr.push(answer.desc);
                    } else {
                        duplicateOptCnt++;
                    }
                }
            });
            if (correctAnswerCount === 0) {
                $scope.errors["correctAnswer"] = "Select a correct answer";
                errCount++;
            }
            if (objToValidate.choice.length === correctAnswerCount) {
                $scope.errors["correctAnswer"] = "Select a correct answer. You cannot select all choices as correct";
                errCount++;
            }
            if (duplicateOptCnt > 0) {
                $scope.errors['duplicateAns'] = "options are repeated.";
                errCount++;
            }
        }
        if (errCount == 0) {
            var pattern = void 0;
            if (correctAnswerCount > 1) pattern = "multiple";else pattern = "single";
            var obj = {
                type: ASL_ANS_TYPE.MCQ,
                "qn_desc": $scope.mcq.question,
                "isLatex": $scope.mcq.isLatex,
                "choice": choicesData,
                "pattern": pattern,
                questionImg: $scope.mcq.questionImg
            };
            $scope.mcq.question = '';
            _.each($scope.mcq.options, function (option_val, option_key) {
                $scope.mcq.options[option_key].value = '';
                $scope.mcq.options[option_key].hint = '';
                if ($scope.mcq.options[option_key].correct) {
                    $scope.mcq.options[option_key].correct = '';
                }
            });
            $scope.$parent.addToList(obj, $scope.index);
        }
    };
}];

exports.default = AslMcqController;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <md-divider class=dividerBorder></md-divider> <div layout=column> <md-input-container> <div ng-show=!isLatex> <label>Enter Paragraph</label> <textarea ng-model=qn_desc md-maxlength=500 txt-maxlength=500 md-select-on-focus></textarea> </div> <div ng-show=isLatex> <div class=qn-label>Enter Question</div> <span id=text-question ng-paste=paste($event) ng-model=qn_desc style=height:auto md-select-on-focus></span> </div> <md-checkbox ng-model=isLatex> With formula </md-checkbox> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex style=width:56px;margin-right:10px> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> <a class=material-icons tooltip-position=down style=cursor:pointer tooltip=\"Print Latex Code\" tooltip-position=down href=latex.pdf target=_blank>print</a> </md-menu> <div class=errorMessage>{{errors['qn_desc']}}</div> </md-input-container> <div class=md-whiteframe-3dp layout=column> <div class=asl-audio-ans-head> Sample Audio Answer </div> <div layout=column layout-padding> <div layout=row layout-align=space-between class=asl-audio-ans-content> <div class=\"md-whiteframe-2dp asl-icon-div asl-pad-left-7\" flex=5> <img ngf-select ngf-change=uploadAudio($file) src=" + __webpack_require__(165) + "> </div> <asl-voice-record flex=5></asl-voice-record> <div flex=35 ng-if=playableAnswerUrl class=\"md-whiteframe-2dp asl-audio-play\" ng-init=playableAnswerUrl> <audio controls ng-src={{playableAnswerUrl}}></audio> </div> <div flex=35 ng-if=!playableAnswerUrl></div> <div flex=50></div> </div> <div layout=row ng-if=errors.audioError> <div class=errorMessage>{{errors['audioError']}}</div> </div> </div> </div> </div> </div> <md-divider class=dividerBorder> </md-divider>";

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslSpeakController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslSpeakController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$timeout", "CONSTANTS", "CQuesConst", "Upload", "$sce", "uploadService", function AslSpeakController($scope, $rootScope, localStorageService, $state, $timeout, CONSTANTS, CQuesConst, Upload, $sce, uploadService) {
  _classCallCheck(this, AslSpeakController);

  //On init function
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    $rootScope.title = "Activity";
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, {
        reload: true
      });
    }
  };
  var MQ = MathQuill.getInterface(2);
  var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
  var userId = localStorageService.get("user_id");
  var USER_PATH = userId + "/asl/";
  var schoolId = localStorageService.get("school_id");
  var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
  var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
  var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
  var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
  var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
  var SAVE_URL = CQuesConst.API_CREATE_ASL_SPEAK;
  //Object - asl
  $scope.asl = {};

  //String - Url to play audio
  $scope.playableAnswerUrl;

  var question = $scope.$parent.$parent.editQuestion;
  if (question) {
    $scope.question = question.qn_desc;
    $scope.isLatex = question.isLatex;
    $scope.ans_audio_url = question.ans_audio_url;
    if (question.ans_audio_url) {
      var src = PREVIEW_URL + question.ans_audio_url;
      $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src);
    }
  }
  $timeout(function () {
    var MQ = MathQuill.getInterface(2);
    var textQuestion = document.getElementById('text-question');
    textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.qn_desc !== undefined) {
      textQuestion.textContent = $scope.qn_desc;
    }
    var mathField = MQ.MathField(textQuestion, {
      spaceBehavesLikeTab: false,
      restrictMismatchedBrackets: true,
      handlers: {
        edit: function edit() {
          $scope.qn_desc = mathField.latex();
        }
      }
    });
  }, 10);

  /*
   * Function to upload audio
   *
   * @return : null
   */
  $scope.uploadAudio = function (file) {
    if (fileValidate(file)) {
      var user_id = userId;
      Upload.upload({
        url: UPLOAD_URL,
        data: {
          file: file,
          'userPath': USER_PATH
        }
      }).then(function (resp) {
        updateAudioUrl(resp.data);
      });
    }
  };

  /*
   * Function to upload audio
   *
   * @return : null
   */
  function updateAudioUrl(url) {
    $scope.ans_audio_url = url;
    var src = PREVIEW_URL + url;
    $scope.playableAnswerUrl = $sce.trustAsResourceUrl(src);
    $scope.isLoading = true;
    toastr.success("Audio uploaded successfully...");
  }

  /*
   * Function to validate audio files
   *
   * @file : uploaded file
   *
   * @return : Boolean - validity of file
   */
  function fileValidate(file) {
    var supportedFrmts = ['mp3', 'wav'];
    var isValid = false;

    if (file && !file.$error && file !== undefined && file !== null) {
      var fileSize = file.size / 1048576;
      var extValue = file.name.split('.').pop();
      if (_.contains(supportedFrmts, extValue)) {
        // if (file.type === "audio/mp3" || file.type === "audio/wav") {
        if (fileSize < 6.00) {
          if (file.name !== "") {
            $scope.isLoading = false;
            isValid = true;
          } else {
            $scope.isLoading = true;
            toastr.error("File is not valid");
            isValid = false;
          }
        } else {
          $scope.isLoading = true;
          toastr.error("Please upload audio file size less than 6MB");
          isValid = false;
        };
      } else {
        $scope.isLoading = true;
        toastr.error('Please select supported mp3 or wav file formats.');
        isValid = false;
      }
    }
    return isValid;
  }

  /*
   * Function to save recorded file url
   *
   * @url : uploaded file url
   *
   * @return : null
   */
  $scope.saveRecordedUrl = function (url) {
    updateAudioUrl(url);
  };

  $scope.paste = function (e) {
    e.preventDefault();
    return false;
  };

  //Adding asl-speaking question from UI
  $scope.$on('addAslSpeaking', function () {
    var details = localStorageService.get("questionDetails");
    var question = details.question;
    var activityErrorCount = details.errorCount;
    //Validation 
    $scope.errors = {};

    if ($scope.qn_desc === undefined || $scope.qn_desc === "") {
      $scope.errors['qn_desc'] = "Paragraph is required";
      $scope.activityErrorCount++;
    } else if ($scope.qn_desc.length > 500) {
      $scope.errors['qn_desc'] = "Paragraph does not exceed 500 characters";
      $scope.activityErrorCount++;
    }
    // if ($scope.ans_audio_url === undefined || $scope.ans_audio_url === "") {
    //   $scope['qn_desc']="Paragraph is required"
    //   $scope.activityErrorCount++;
    // }
    if (activityErrorCount === 0) {
      $scope.$parent.isSaveClicked = true;
      var obj = {
        "_id": $scope._id,
        "question_theme_id": question.theme._id,
        "question_theme_name": question.theme.name,
        "desc": $scope.desc,
        "descImage": $scope.descImage,
        "explanation": $scope.explanation,
        "explanationImage": $scope.explanationImage,
        "strand": question.strand,
        "tag": question.tag,
        "wave": question.wave,
        "qn_desc": '' + $scope.question,
        "isLatex": $scope.isLatex,
        "level": question.level,
        "subject_id": question.subject_id,
        "school_id": question.school_id,
        "questionImg": $scope.questionImage,
        "session_id": question.session_id,
        "batch_id": question.batch_id,
        "class_id": question.class_id,
        "curriculum_id": question.curriculum_id,
        "xlink": question.link_theme,
        "cognitive_skills": question.cognitive_skill,
        "isNotAddToQp": question.isNotAddToQp,
        "is_traditional_activity": question.is_traditional_activity,
        "qp_id": question.qp_id,
        "activity_id": question.activity_id,
        "user_id": userId,
        "created_dt": $scope.created_dt,
        "content_editor_id": $scope.content_editor_id,
        "ans_audio_url": $scope.ans_audio_url

        //SAVE CALL
      };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
        var result = resObj.result;
        if (result && result.data && result.data.success) {
          $rootScope.setHideSaveButton(false);
          $rootScope.setLoader(false);
          $rootScope.resetValues();
          if (question.is_traditional_activity) {
            $state.go('formatQuestion', {
              qpId: question.qp_id
            });
            toastr.success("Question Saved successfully");
          } else {
            if (result.data.isExists) {
              toastr.success("Question already exists");
            } else {
              toastr.success("Question Saved successfully");
              $rootScope.setSearchFieldSession();
            }
          }
        } else {
          $rootScope.setHideSaveButton(false);
          $rootScope.setLoader(false);
          toastr.error("Network Error");
        }
        _.defer(function () {
          $scope.$apply();
        });
      });
    } else {
      $rootScope.setHideSaveButton(false);
      $rootScope.setLoader(false);
      toastr.error("Please fill all mandatory fields");
    }
  });

  //On destroy function
  this.$onDestroy = function () {};
}];

exports.default = AslSpeakController;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <div class=md-whiteframe-3dp layout=column layout-padding> <md-input-container md-select-on-focus layout=column flex=90> <div ng-show=!isLatex> <label>Enter Question</label> <textarea ng-model=question md-maxlength=500 txt-maxlength=500 md-select-on-focus></textarea> </div> <div ng-show=isLatex> <div class=qn-label>Enter Question</div> <span id={{quesId}} ng-model=question style=height:auto md-select-on-focus></span> </div> <div layout=row> <md-checkbox ng-model=isLatex> With formula </md-checkbox> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> </div> <div class=errorMessage>{{errors['question']}}</div> </md-input-container> <md-input-container flex=50> <div ng-show=!isLatex> <label>Enter Answer</label> <textarea ng-model=answer md-maxlength=500 txt-maxlength=500 md-select-on-focus></textarea> </div> <div ng-show=isLatex> <div class=qn-label>Enter Answer</div> <span id={{ansId}} ng-model=answer style=height:auto md-select-on-focus></span> </div> <div class=errorMessage>{{errors['answer']}}</div> </md-input-container> </div> <div layout=column class=asl-add-list-button layout-align=\"end end\"> <md-button md-no-ink class=\"addToQues md-ink-ripple\" ng-click=addToList() layout=row>Add to list </md-button> </div> </div> ";

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslTextController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslTextController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$timeout", "CONSTANTS", "CQuesConst", "Upload", function AslTextController($scope, $rootScope, localStorageService, $state, $timeout, CONSTANTS, CQuesConst, Upload) {
  var _this = this;

  _classCallCheck(this, AslTextController);

  var MQ = MathQuill.getInterface(2);
  var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
  var userId = localStorageService.get("user_id");
  var USER_PATH = userId + "/asl/";
  var schoolId = localStorageService.get("school_id");
  var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
  var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
  var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
  var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
  var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
  var SAVE_URL = CQuesConst.API_CREATE_DRAW;
  $scope.question;

  $scope.answer;

  $scope.errors = {};

  $scope.index;
  //On init function
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    $rootScope.title = "Archives";
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, {
        reload: true
      });
    }
    $scope.index = _this.index;
    $scope.isLatex = false;
    $scope.quesId = "text-question" + $scope.index;
    $scope.ansId = 'text-answer' + $scope.index;
    if ($scope.$parent.editQuestions[$scope.index]) {
      var currentQuestion = $scope.$parent.editQuestions[$scope.index];
      if (currentQuestion) {
        $scope.question = currentQuestion.qn_desc;
        $scope.isLatex = currentQuestion.isLatex;
        $scope.answer = currentQuestion.answer;
      }
    }
  };
  //On destroy function
  this.$onDestroy = function () {};

  $timeout(function () {
    var MQ = MathQuill.getInterface(2);
    var textQuestion = document.getElementById("text-question" + $scope.index);
    textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.question !== undefined) {
      textQuestion.textContent = $scope.question;
    }
    var mathField = MQ.MathField(textQuestion, {
      spaceBehavesLikeTab: false,
      restrictMismatchedBrackets: true,
      handlers: {
        edit: function edit() {
          $scope.question = mathField.latex();
        }
      }
    });
    var textAnswer = document.getElementById('text-answer' + $scope.index);
    textAnswer.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.answer !== undefined) {
      textAnswer.textContent = $scope.answer;
    }
    var mathFieldAnswer = MQ.MathField(textAnswer, {
      spaceBehavesLikeTab: false,
      restrictMismatchedBrackets: true,
      handlers: {
        edit: function edit() {
          $scope.answer = mathFieldAnswer.latex();
        }
      }
    });
  }, 10);

  /*
   * Function to add to list
   *
   * @return : null
   */
  $scope.addToList = function () {
    $scope.errors = {};
    var errCount = 0;
    if ($scope.question === undefined || $scope.question === "") {
      $scope.errors.question = "Please Enter Question";
      errCount++;
    } else if ($scope.question.length > 500) {
      $scope.errors.question = "Question does not exceed 500 characters";
      errCount++;
    }
    if ($scope.answer === undefined || $scope.answer === "") {
      $scope.errors.answer = "Please Enter Answer";
      errCount++;
    } else if ($scope.answer.length > 500) {
      $scope.errors.answer = "Answer does not exceed 500 characters";
      errCount++;
    }
    if (errCount == 0) {
      var obj = {
        type: ASL_ANS_TYPE.TEXT,
        qn_desc: $scope.question,
        isLatex: $scope.isLatex,
        answer: $scope.answer
      };
      $scope.question = "";
      $scope.answer = "";
      $scope.isLatex = false;
      $scope.$parent.addToList(obj, $scope.index);
    }
  };
}];

exports.default = AslTextController;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <md-divider class=dividerBorder> </md-divider> <div layout=row flex layout-align=\"space-between center\"> <md-input-container md-select-on-focus flex=90> <div class=qn-label>Enter Question</div> <textarea ng-model=tf.credentials.question ng-show=!tf.credentials.isLatex md-maxlength=500 md-select-on-focus></textarea> <span id={{id}} ng-paste=paste($event) ng-show=tf.credentials.isLatex ng-model=tf.credentials.question rows=2 md-select-on-focus style=height:auto></span> <div class=errorMessage>{{errors['question']}}</div> <md-checkbox ng-model=tf.credentials.isLatex> With formula </md-checkbox> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=tf.credentials.isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=tf.uploadImg($files,tf.credentials)> <img ng-if=tf.credentials.questionImg flex=45 ng-src=\"{{aslTf.tempData + tf.credentials.questionImg}}\" style=height:100px;width:100px> <img class=hand ng-if=tf.credentials.questionImg src=" + __webpack_require__(16) + " ng-click=tf.removeQuestionImg()> </div> </div> <div layout=row layout-align=\"space-between center\"> <md-input-container flex=20> <label>Select Answer</label> <md-select flex ng-model=tf.credentials.answer placeholder=\"Select Answer\"> <md-option value=True>True</md-option> <md-option value=False>False</md-option> </md-select> <div class=errorMessage>{{errors['answer']}}</div> </md-input-container> <md-input-container class=tfHint flex=30> <label>Answer Explanation for {{tf.credentials.answer}}</label> <textarea ng-model=tf.credentials.explanation md-maxlength=100 txt-maxlength=100></textarea> <div class=errorMessage>{{errors['explanation']}}</div> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=tf.explanationImgUpload($files,tf)> <img ng-if=tf.explanationImage flex=45 ng-src=\"{{aslTf.tempData + tf.explanationImage}}\" style=height:100px;width:100px> <img class=hand ng-if=tf.explanationImage src=" + __webpack_require__(16) + " ng-click=tf.removeExplanationImage()> </div> <md-input-container class=tfHint flex=30> <label>Explanation for False Hint</label> <textarea ng-model=tf.credentials.falseHint md-maxlength=100 txt-maxlength=100></textarea> <div class=errorMessage>{{errors['falseHint']}}</div> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(12) + " ngf-select=tf.falseHintImgUpload($files,tf)> <img ng-if=tf.falseHintImage flex=45 ng-src=\"{{aslTf.tempData + tf.falseHintImage}}\" style=height:100px;width:100px> <img class=hand ng-if=tf.falseHintImage src=" + __webpack_require__(16) + " ng-click=tf.removeFalseHintImage()> </div> </div> <div layout=column class=asl-add-list-button layout-align=\"end end\"> <md-button md-no-ink class=\"addToQues md-ink-ripple\" ng-click=addToList() layout=row>Add to list </md-button> </div> </div> ";

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: AslTfController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var AslTfController =
// @ngInject
["$scope", "$rootScope", "localStorageService", "$state", "$timeout", "CONSTANTS", "CQuesConst", "uploadService", function AslTfController($scope, $rootScope, localStorageService, $state, $timeout, CONSTANTS, CQuesConst, uploadService) {
  var _this = this;

  _classCallCheck(this, AslTfController);

  var MQ = MathQuill.getInterface(2);
  var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
  var userId = localStorageService.get("user_id");
  var USER_PATH = userId + "/asl/";
  var schoolId = localStorageService.get("school_id");
  var ASL_ANS_TYPE = CQuesConst.ASL_ANS_TYPE;
  var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
  var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
  var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
  var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
  $scope.tf = {};
  $scope.tf.credentials = {
    question: '',
    answer: '',
    explanation: '',
    falseHint: '',
    isLatex: false
  };

  $scope.errors = {};

  $scope.index;
  //On init function
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    $rootScope.title = "Archives";
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, {
        reload: true
      });
    }
    $scope.index = _this.index;
    $scope.id = 'tf-math-field' + $scope.index;
    if ($scope.$parent.editQuestions[$scope.index]) {
      var question = $scope.$parent.editQuestions[$scope.index];
      if (question && question.choice) {
        $scope.tf.credentials.question = question.qn_desc;
        $scope.tf.credentials.questionImg = question.questionImg;
        $scope.tf.credentials.isLatex = question.isLatex;
        $scope.tf.credentials.answer = _.find(question.choice, function (ch) {
          return ch.correct;
        }).tag;
        var explanation = _.find(question.choice, function (ch) {
          return ch.correct;
        });
        $scope.tf.credentials.explanation = explanation.explanation;
        $scope.tf.explanationImage = explanation.explanationImage;
        var hint = _.find(question.choice, function (ch) {
          return !ch.correct;
        });
        $scope.tf.credentials.falseHint = hint.hint;
        $scope.tf.falseHintImage = hint.falseHintImage;
      }
    }
  };
  //On destroy function
  this.$onDestroy = function () {};

  //Question desc with latex
  $timeout(function () {
    var mathFieldSpan = document.getElementById('tf-math-field' + $scope.index);
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    var MQ = MathQuill.getInterface(2);
    if ($scope.tf.credentials.question) {
      mathFieldSpan.textContent = $scope.tf.credentials.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
      spaceBehavesLikeTab: false,
      restrictMismatchedBrackets: true,
      handlers: {
        edit: function edit() {
          $scope.tf.credentials.question = mathField.latex();
        }
      }
    });
  }, 1000);

  //Image upload for question
  $scope.tf.uploadImg = function (file, opt) {
    var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
    _.each(file, function (fileObj) {
      var extValue = fileObj.name.split('.').pop().toLowerCase();
      if (_.contains(supportedFrmts, extValue)) {
        uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
          if (result.url) {
            opt.questionImg = result.url;
          }
        });
      } else {
        toastr.error("Please select the supported format jpg, jpeg, png");
        fileObj = {};
      }
    });
  };

  $scope.tf.removeQuestionImg = function () {
    $scope.tf.credentials.questionImg = undefined;
  };

  $scope.paste = function (e) {
    e.preventDefault();
    return false;
  };

  //Image upload for explanation
  $scope.tf.explanationImgUpload = function (file, opt) {
    var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
    _.each(file, function (fileObj) {
      var extValue = fileObj.name.split('.').pop().toLowerCase();
      if (_.contains(supportedFrmts, extValue)) {
        uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
          if (result.url) {
            opt.explanationImage = result.url;
          }
        });
      } else {
        toastr.error("Please select the supported format jpg, jpeg, png");
        fileObj = {};
      }
    });
  };

  $scope.tf.removeExplanationImage = function () {
    $scope.tf.explanationImage = undefined;
  };

  //Image upload for falsehint
  $scope.tf.falseHintImgUpload = function (file, opt) {
    _.each(file, function (fileObj) {
      var extValue = fileObj.name.split('.').pop().toLowerCase();
      if (_.contains(supportedFrmts, extValue)) {
        uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
          if (result.url) {
            opt.falseHintImage = result.url;
          }
        });
      } else {
        toastr.error("Please select the supported format jpg, jpeg, png");
        fileObj = {};
      }
    });
  };

  $scope.tf.removeFalseHintImage = function () {
    $scope.tf.falseHintImage = undefined;
  };

  /*
   * Function to add to list
   *
   * @return : null
   */
  $scope.addToList = function () {
    $scope.errors = {};
    var errCount = 0;
    //[Object] - to push correct and wrong answer object
    var choice = [];

    //Object - correct answer
    var correctObj = {};

    //Object - wrong answer
    var wrongObj = {};

    if ($scope.tf.credentials.answer === "True") {
      correctObj.tag = "True";
      wrongObj.tag = "False";
    } else {
      correctObj.tag = "False";
      wrongObj.tag = "True";
    }
    correctObj.explanation = $scope.tf.credentials.explanation;
    correctObj.correct = true;
    correctObj.explanationImage = $scope.tf.explanationImage;
    choice.push(correctObj);
    wrongObj.hint = $scope.tf.credentials.falseHint;
    wrongObj.correct = false;
    wrongObj.falseHintImage = $scope.tf.falseHintImage;
    choice.push(wrongObj);

    //Validation  
    if ($scope.tf.credentials.question == null || $scope.tf.credentials.question == undefined || $scope.tf.credentials.question == "") {
      $scope.errors.question = "Question is required";
      $scope.errCount++;
    } else if ($scope.tf.credentials.question.length > 500) {
      $scope.errors.question = "Question does not exceed 500 characters";
      errCount++;
    }
    if ($scope.isPractice) {
      if ($scope.tf.credentials.explanation == null || $scope.tf.credentials.explanation == undefined || $scope.tf.credentials.explanation == "") {
        $scope.errors["explanation"] = "Explanation is required";
        $scope.errCount++;
      }
      if ($scope.tf.credentials.falseHint == null || $scope.tf.credentials.falseHint == undefined || $scope.tf.credentials.falseHint == "") {
        $scope.errors["falseHint"] = "False hint is required";
        $scope.errCount++;
      }
    }
    if ($scope.tf.credentials.explanation && $scope.tf.credentials.explanation.length > 500) {
      $scope.errors["explanation"] = "Explanation does not exceed 500 characters";
      errCount++;
    }
    if ($scope.tf.credentials.falseHint && $scope.tf.credentials.falseHint.length > 500) {
      $scope.errors["falseHint"] = "False does not exceed 500 characters";
      errCount++;
    }
    if ($scope.tf.credentials.answer == null || $scope.tf.credentials.answer == undefined || $scope.tf.credentials.answer == "") {
      $scope.errors["answer"] = "Answer is required";
      $scope.errCount++;
    } else if ($scope.tf.credentials.answer.length > 500) {
      $scope.errors["answer"] = "Answer does not exceed 500 characters";
      errCount++;
    }
    if (errCount == 0) {
      var obj = {
        type: ASL_ANS_TYPE.TF,
        qn_desc: $scope.tf.credentials.question,
        isLatex: $scope.tf.credentials.isLatex,
        choice: choice,
        questionImg: $scope.tf.credentials.questionImg
      };

      $scope.tf.credentials.question = '';
      $scope.tf.credentials.answer = '';
      $scope.tf.credentials.explanation = '';
      $scope.tf.credentials.falseHint = '';
      $scope.tf.credentials.isLatex = false;
      $scope.$parent.addToList(obj, $scope.index);
    }
  };
}];

exports.default = AslTfController;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.asl-icon-div{height:40px;max-width:40px;padding-top:8px;margin-top:20px}.asl-pad-left-12{padding-left:12px}.asl-icon-div-disable{background-color:rgba(0,0,0,.2);opacity:.48}</style> <fieldset ng-show=!isRecording class=\"md-whiteframe-2dp asl-icon-div asl-pad-left-12 asl-voice-record-class\" id={{index}} ng-click=startRecording() ng-disabled=$parent.voiceRecord[index] flex> <img class=hand src=" + __webpack_require__(1266) + "> </fieldset> <div ng-show=isRecording class=\"md-whiteframe-2dp asl-icon-div asl-pad-left-12\" ng-click=stopRecording() flex> <img class=hand src=" + __webpack_require__(1267) + "> </div> ";

/***/ }),
/* 1266 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYBJREFUeNpi/P//PwM6uLCByQxILQJidSTh6UBcZhDw7wuyWhYsmlWA1AEg5kSTygRiUSAORRZkYsAEvVg0w0AI0AJXQgY4MeAHBA3gIWAADyEDSAIDbwALMFTlgHQpEFeixzE+AI0NA5ALvIE4B4htSLQcpKcL2QvMJBrADAuDX1ABWOL5SEDjRyT1H0EG3IcK6ELp3QQM2A30P8h2LZBekAHHgRgUeLFACTZQhsHjisXAgN4HDTcJIN7BBBT4DmRMAWJFIG4E8kEuMgRJojm7BogTgZaAMtQEqNenMIKyM1AQ5J8zUGf1gRRDDQbJyQHZj6BskDdXQNUVAMUnMsLKA6AkyEmrodF5E4jngoSB+B20XLAE4jRo6IPKBZBFDIzIBQo0DNqhccyGJQyeAnE0UPNBmAAjjhJJFBpQ+aDUBsQTQaEP1LgVXS1WA5AMmgYtifSAmi9jU4PuhVi0JG0DDbA10LCAgSaggU+xlYmBUIxRlCGxQdG3HhoeDAABBgAMnnx3jgA9OAAAAABJRU5ErkJggg=="

/***/ }),
/* 1267 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhEAAWAPABAPMCAgAAACH5BAkZAAEAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAEAAWAAACNIwPmceo2txbMcxXL4yatg5kHRNaI2KAppWOS6m+4Sm3U2vC22qLn5cTXSokIJF3VP1OgQIAIfkECRkAAQAsAAAAABAAFgCA////AAAAAjSMD5nHqNrcWzHMVy+MmrYOZB0TWiNigKaVjkupvuEpt1Nrwttqi5+XE10qJCCRd1T9ToECADs="

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _recordrtc = __webpack_require__(1269);

var RecordRTC = _interopRequireWildcard(_recordrtc);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: AslVoiceRecordController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var AslVoiceRecordController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "Upload", function AslVoiceRecordController($scope, $rootScope, authService, localStorageService, $state, Upload) {
  _classCallCheck(this, AslVoiceRecordController);

  //On init function
  this.$onInit = function () {
    $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
    $rootScope.title = "Archives";
    if (!$rootScope.isLoggedIn) {
      $state.go("login", {}, {
        reload: true
      });
    }
  };
  var aslVoiceRecord = this;

  var recorder = {};

  $scope.isRecording = false;

  this.$onInit = function () {
    $scope.index = this.index;
  };

  (function () {
    var params = {},
        r = /([^&=]+)=?([^&]*)/g;

    function d(s) {
      return decodeURIComponent(s.replace(/\+/g, ' '));
    }

    var match,
        search = window.location.search;
    while (match = r.exec(search.substring(1))) {
      params[d(match[1])] = d(match[2]);
      if (d(match[2]) === 'true' || d(match[2]) === 'false') {
        params[d(match[1])] = d(match[2]) === 'true' ? true : false;
      }
    }
    window.params = params;
  })();

  function addStreamStopListener(stream, callback) {
    var streamEndedEvent = 'ended';
    if ('oninactive' in stream) {
      streamEndedEvent = 'inactive';
    }
    stream.addEventListener(streamEndedEvent, function () {
      callback = function callback() {};
      callback();
    }, false);

    stream.getAudioTracks().forEach(function (track) {
      track.addEventListener(streamEndedEvent, function () {
        callback = function callback() {};
        callback();
      }, false);
    });

    stream.getVideoTracks().forEach(function (track) {
      track.addEventListener(streamEndedEvent, function () {
        callback = function callback() {};
        callback();
      }, false);
    });
  }

  //To capture media Stream
  function captureUserMedia(mediaConstraints, successCallback, errorCallback) {
    var isBlackBerry = !!/BB10|BlackBerry/i.test(navigator.userAgent || '');
    if (isBlackBerry && !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia)) {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      navigator.getUserMedia(mediaConstraints, successCallback, errorCallback);
      return;
    }
    navigator.mediaDevices.getUserMedia(mediaConstraints).then(successCallback).catch(errorCallback);
  }

  function intallFirefoxScreenCapturingExtension() {
    InstallTrigger.install({
      'Foo': {
        URL: 'https://addons.mozilla.org/firefox/downloads/file/355418/enable_screen_capturing_in_firefox-1.0.006-fx.xpi?src=cb-dl-hotness',
        toString: function toString() {
          return this.URL;
        }
      }
    });
  }

  $scope.startRecording = function () {
    var recordingElements = document.getElementsByClassName('asl-voice-record-class');
    captureUserMedia({
      audio: true
    }, function (audioStream) {
      recorder.stream = audioStream;
      recorder.recordRTC = new RecordRTC.StereoAudioRecorder(audioStream, {
        sampleRate: 44100,
        bufferSize: 4096
      });
      $scope.isRecording = true;
      addStreamStopListener(audioStream);
      recorder.recordRTC.record();
      _.each(recordingElements, function (element) {
        if (element.id != $scope.index) {
          element.disabled = true;
          $(element).addClass('asl-icon-div-disable');
        }
      });
      _.defer(function () {
        $scope.$apply();
      });
    }, function (error) {
      if (error.name === 'PermissionDeniedError' && !!navigator.mozGetUserMedia) {
        intallFirefoxScreenCapturingExtension();
      }
    });
  };

  $scope.stopRecording = function () {
    user_id = Meteor.userId();
    recorder.recordRTC.stop(function (blob) {
      recorder.stream.stop();
      recorder.stream = null;
      Upload.upload({
        url: SERVER_UPLOAD,
        data: {
          file: blob,
          userPath: user_id + "/asl/"
        }
      }).then(function (response) {
        $scope.isRecording = false;
        var recordingElements = document.getElementsByClassName('asl-voice-record-class');
        _.each(recordingElements, function (element) {
          element.disabled = false;
          $(element).removeClass('asl-icon-div-disable');
        });
        $scope.$parent.saveRecordedUrl(response.data, $scope.index);
      }, function (response) {}, function (evt) {});
    });
  };

  var isChrome = !!navigator.webkitGetUserMedia;
  var DetectRTC = {};

  (function () {

    var screenCallback;

    DetectRTC.screen = {
      chromeMediaSource: 'screen',
      getSourceId: function getSourceId(callback) {
        if (!callback) throw '"callback" parameter is mandatory.';
        screenCallback = callback;
        window.postMessage('get-sourceId', '*');
      },
      isChromeExtensionAvailable: function isChromeExtensionAvailable(callback) {
        if (!callback) return;

        if (DetectRTC.screen.chromeMediaSource == 'desktop') return callback(true);

        // ask extension if it is available
        window.postMessage('are-you-there', '*');

        setTimeout(function () {
          if (DetectRTC.screen.chromeMediaSource == 'screen') {
            callback(false);
          } else callback(true);
        }, 2000);
      },
      onMessageCallback: function onMessageCallback(data) {
        if (!(typeof data == 'string' || !!data.sourceId)) return;

        // "cancel" button is clicked
        if (data == 'PermissionDeniedError') {
          DetectRTC.screen.chromeMediaSource = 'PermissionDeniedError';
          if (screenCallback) return screenCallback('PermissionDeniedError');else throw new Error('PermissionDeniedError');
        }

        // extension notified his presence
        if (data == 'rtcmulticonnection-extension-loaded') {
          if (document.getElementById('install-button')) {
            document.getElementById('install-button').parentNode.innerHTML = '<strong>Great!</strong> <a href="https://chrome.google.com/webstore/detail/screen-capturing/ajhifddimkapgcifgcodmmfdlknahffk" target="_blank">Google chrome extension</a> is installed.';
          }
          DetectRTC.screen.chromeMediaSource = 'desktop';
        }

        // extension shared temp sourceId
        if (data.sourceId) {
          DetectRTC.screen.sourceId = data.sourceId;
          if (screenCallback) screenCallback(DetectRTC.screen.sourceId);
        }
      },
      getChromeExtensionStatus: function getChromeExtensionStatus(callback) {
        if (!!navigator.mozGetUserMedia) return callback('not-chrome');

        var extensionid = 'ajhifddimkapgcifgcodmmfdlknahffk';
      }
    };

    // check if desktop-capture extension installed.
    if (window.postMessage && isChrome) {
      DetectRTC.screen.isChromeExtensionAvailable();
    }
  })();

  DetectRTC.screen.getChromeExtensionStatus(function (status) {
    if (status == 'installed-enabled') {
      if (document.getElementById('install-button')) {
        document.getElementById('install-button').parentNode.innerHTML = '<strong>Great!</strong> <a href="https://chrome.google.com/webstore/detail/screen-capturing/ajhifddimkapgcifgcodmmfdlknahffk" target="_blank">Google chrome extension</a> is installed.';
      }
      DetectRTC.screen.chromeMediaSource = 'desktop';
    }
  });

  window.addEventListener('message', function (event) {
    if (event.origin != window.location.origin) {
      return;
    }

    DetectRTC.screen.onMessageCallback(event.data);
  });
  //On destroy function
  this.$onDestroy = function () {};
}];

exports.default = AslVoiceRecordController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

// Last time updated: 2018-12-12 7:50:08 AM UTC

// ________________
// RecordRTC v5.4.9

// Open-Sourced: https://github.com/muaz-khan/RecordRTC

// --------------------------------------------------
// Muaz Khan     - www.MuazKhan.com
// MIT License   - www.WebRTC-Experiment.com/licence
// --------------------------------------------------

// ____________
// RecordRTC.js

/**
 * {@link https://github.com/muaz-khan/RecordRTC|RecordRTC} is a WebRTC JavaScript library for audio/video as well as screen activity recording. It supports Chrome, Firefox, Opera, Android, and Microsoft Edge. Platforms: Linux, Mac and Windows. 
 * @summary Record audio, video or screen inside the browser.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTC
 * @class
 * @example
 * var recorder = RecordRTC(mediaStream or [arrayOfMediaStream], {
 *     type: 'video', // audio or video or gif or canvas
 *     recorderType: MediaStreamRecorder || CanvasRecorder || StereoAudioRecorder || Etc
 * });
 * recorder.startRecording();
 * @see For further information:
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
 * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, desiredSampRate: 16000, video: HTMLVideoElement, etc.}
 */

function RecordRTC(mediaStream, config) {
    if (!mediaStream) {
        throw 'First parameter is required.';
    }

    config = config || {
        type: 'video'
    };

    config = new RecordRTCConfiguration(mediaStream, config);

    // a reference to user's recordRTC object
    var self = this;

    function startRecording(config2) {
        if (!!config2) {
            // allow users to set options using startRecording method
            // config2 is similar to main "config" object (second parameter over RecordRTC constructor)
            config = new RecordRTCConfiguration(mediaStream, config2);
        }

        if (!config.disableLogs) {
            console.log('started recording ' + config.type + ' stream.');
        }

        if (mediaRecorder) {
            mediaRecorder.clearRecordedData();
            mediaRecorder.record();

            setState('recording');

            if (self.recordingDuration) {
                handleRecordingDuration();
            }
            return self;
        }

        initRecorder(function() {
            if (self.recordingDuration) {
                handleRecordingDuration();
            }
        });

        return self;
    }

    function initRecorder(initCallback) {
        if (initCallback) {
            config.initCallback = function() {
                initCallback();
                initCallback = config.initCallback = null; // recorder.initRecorder should be call-backed once.
            };
        }

        var Recorder = new GetRecorderType(mediaStream, config);

        mediaRecorder = new Recorder(mediaStream, config);
        mediaRecorder.record();

        setState('recording');

        if (!config.disableLogs) {
            console.log('Initialized recorderType:', mediaRecorder.constructor.name, 'for output-type:', config.type);
        }
    }

    function stopRecording(callback) {
        callback = callback || function() {};

        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state === 'paused') {
            self.resumeRecording();

            setTimeout(function() {
                stopRecording(callback);
            }, 1);
            return;
        }

        if (self.state !== 'recording' && !config.disableLogs) {
            console.warn('Recording state should be: "recording", however current state is: ', self.state);
        }

        if (!config.disableLogs) {
            console.log('Stopped recording ' + config.type + ' stream.');
        }

        if (config.type !== 'gif') {
            mediaRecorder.stop(_callback);
        } else {
            mediaRecorder.stop();
            _callback();
        }

        setState('stopped');

        function _callback(__blob) {
            if (!mediaRecorder) {
                if (typeof callback.call === 'function') {
                    callback.call(self, '');
                } else {
                    callback('');
                }
                return;
            }

            Object.keys(mediaRecorder).forEach(function(key) {
                if (typeof mediaRecorder[key] === 'function') {
                    return;
                }

                self[key] = mediaRecorder[key];
            });

            var blob = mediaRecorder.blob;

            if (!blob) {
                if (__blob) {
                    mediaRecorder.blob = blob = __blob;
                } else {
                    throw 'Recording failed.';
                }
            }

            if (blob && !config.disableLogs) {
                console.log(blob.type, '->', bytesToSize(blob.size));
            }

            if (callback) {
                var url = URL.createObjectURL(blob);

                if (typeof callback.call === 'function') {
                    callback.call(self, url);
                } else {
                    callback(url);
                }
            }

            if (!config.autoWriteToDisk) {
                return;
            }

            getDataURL(function(dataURL) {
                var parameter = {};
                parameter[config.type + 'Blob'] = dataURL;
                DiskStorage.Store(parameter);
            });
        }
    }

    function pauseRecording() {
        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state !== 'recording') {
            if (!config.disableLogs) {
                console.warn('Unable to pause the recording. Recording state: ', self.state);
            }
            return;
        }

        setState('paused');

        mediaRecorder.pause();

        if (!config.disableLogs) {
            console.log('Paused recording.');
        }
    }

    function resumeRecording() {
        if (!mediaRecorder) {
            warningLog();
            return;
        }

        if (self.state !== 'paused') {
            if (!config.disableLogs) {
                console.warn('Unable to resume the recording. Recording state: ', self.state);
            }
            return;
        }

        setState('recording');

        // not all libs have this method yet
        mediaRecorder.resume();

        if (!config.disableLogs) {
            console.log('Resumed recording.');
        }
    }

    function readFile(_blob) {
        postMessage(new FileReaderSync().readAsDataURL(_blob));
    }

    function getDataURL(callback, _mediaRecorder) {
        if (!callback) {
            throw 'Pass a callback function over getDataURL.';
        }

        var blob = _mediaRecorder ? _mediaRecorder.blob : (mediaRecorder || {}).blob;

        if (!blob) {
            if (!config.disableLogs) {
                console.warn('Blob encoder did not finish its job yet.');
            }

            setTimeout(function() {
                getDataURL(callback, _mediaRecorder);
            }, 1000);
            return;
        }

        if (typeof Worker !== 'undefined' && !navigator.mozGetUserMedia) {
            var webWorker = processInWebWorker(readFile);

            webWorker.onmessage = function(event) {
                callback(event.data);
            };

            webWorker.postMessage(blob);
        } else {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function(event) {
                callback(event.target.result);
            };
        }

        function processInWebWorker(_function) {
            var blob = URL.createObjectURL(new Blob([_function.toString(),
                'this.onmessage =  function (eee) {' + _function.name + '(eee.data);}'
            ], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            URL.revokeObjectURL(blob);
            return worker;
        }
    }

    function handleRecordingDuration(counter) {
        counter = counter || 0;

        if (self.state === 'paused') {
            setTimeout(function() {
                handleRecordingDuration(counter);
            }, 1000);
            return;
        }

        if (self.state === 'stopped') {
            return;
        }

        if (counter >= self.recordingDuration) {
            stopRecording(self.onRecordingStopped);
            return;
        }

        counter += 1000; // 1-second

        setTimeout(function() {
            handleRecordingDuration(counter);
        }, 1000);
    }

    function setState(state) {
        if (!self) {
            return;
        }

        self.state = state;

        if (typeof self.onStateChanged.call === 'function') {
            self.onStateChanged.call(self, state);
        } else {
            self.onStateChanged(state);
        }
    }

    var WARNING = 'It seems that recorder is destroyed or "startRecording" is not invoked for ' + config.type + ' recorder.';

    function warningLog() {
        if (config.disableLogs === true) {
            return;
        }

        console.warn(WARNING);
    }

    var mediaRecorder;

    var returnObject = {
        /**
         * This method starts the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var recorder = RecordRTC(mediaStream, {
         *     type: 'video'
         * });
         * recorder.startRecording();
         */
        startRecording: startRecording,

        /**
         * This method stops the recording. It is strongly recommended to get "blob" or "URI" inside the callback to make sure all recorders finished their job.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     // use either "this" or "recorder" object; both are identical
         *     video.src = this.toURL();
         *     var blob = this.getBlob();
         * });
         */
        stopRecording: stopRecording,

        /**
         * This method pauses the recording. You can resume recording using "resumeRecording" method.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Firefox is unable to pause the recording. Fix it.
         * @example
         * recorder.pauseRecording();  // pause the recording
         * recorder.resumeRecording(); // resume again
         */
        pauseRecording: pauseRecording,

        /**
         * This method resumes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.pauseRecording();  // first of all, pause the recording
         * recorder.resumeRecording(); // now resume it
         */
        resumeRecording: resumeRecording,

        /**
         * This method initializes the recording.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * recorder.initRecorder();
         */
        initRecorder: initRecorder,

        /**
         * Ask RecordRTC to auto-stop the recording after 5 minutes.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var fiveMinutes = 5 * 1000 * 60;
         * recorder.setRecordingDuration(fiveMinutes, function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         * 
         * // or otherwise
         * recorder.setRecordingDuration(fiveMinutes).onRecordingStopped(function() {
         *    var blob = this.getBlob();
         *    video.src = this.toURL();
         * });
         */
        setRecordingDuration: function(recordingDuration, callback) {
            if (typeof recordingDuration === 'undefined') {
                throw 'recordingDuration is required.';
            }

            if (typeof recordingDuration !== 'number') {
                throw 'recordingDuration must be a number.';
            }

            self.recordingDuration = recordingDuration;
            self.onRecordingStopped = callback || function() {};

            return {
                onRecordingStopped: function(callback) {
                    self.onRecordingStopped = callback;
                }
            };
        },

        /**
         * This method can be used to clear/reset all the recorded data.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo Figure out the difference between "reset" and "clearRecordedData" methods.
         * @example
         * recorder.clearRecordedData();
         */
        clearRecordedData: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            mediaRecorder.clearRecordedData();

            if (!config.disableLogs) {
                console.log('Cleared old recorded data.');
            }
        },

        /**
         * Get the recorded blob. Use this method inside the "stopRecording" callback.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.getBlob();
         *
         *     var file = new File([blob], 'filename.webm', {
         *         type: 'video/webm'
         *     });
         *
         *     var formData = new FormData();
         *     formData.append('file', file); // upload "File" object rather than a "Blob"
         *     uploadToServer(formData);
         * });
         * @returns {Blob} Returns recorded data as "Blob" object.
         */
        getBlob: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            return mediaRecorder.blob;
        },

        /**
         * Get data-URI instead of Blob.
         * @param {function} callback - Callback to get the Data-URI.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     recorder.getDataURL(function(dataURI) {
         *         video.src = dataURI;
         *     });
         * });
         */
        getDataURL: getDataURL,

        /**
         * Get virtual/temporary URL. Usage of this URL is limited to current tab.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     video.src = this.toURL();
         * });
         * @returns {String} Returns a virtual/temporary URL for the recorded "Blob".
         */
        toURL: function() {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            return URL.createObjectURL(mediaRecorder.blob);
        },

        /**
         * Get internal recording object (i.e. internal module) e.g. MutliStreamRecorder, MediaStreamRecorder, StereoAudioRecorder or WhammyRecorder etc.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * var internal = recorder.getInternalRecorder();
         * if(internal instanceof MultiStreamRecorder) {
         *     internal.addStreams([newAudioStream]);
         *     internal.resetVideoStreams([screenStream]);
         * }
         * @returns {Object} Returns internal recording object.
         */
        getInternalRecorder: function() {
            return mediaRecorder;
        },

        /**
         * Invoke save-as dialog to save the recorded blob into your disk.
         * @param {string} fileName - Set your own file name.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.stopRecording(function() {
         *     this.save('file-name');
         *
         *     // or manually:
         *     invokeSaveAsDialog(this.getBlob(), 'filename.webm');
         * });
         */
        save: function(fileName) {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            invokeSaveAsDialog(mediaRecorder.blob, fileName);
        },

        /**
         * This method gets a blob from indexed-DB storage.
         * @param {function} callback - Callback to get the recorded blob.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.getFromDisk(function(dataURL) {
         *     video.src = dataURL;
         * });
         */
        getFromDisk: function(callback) {
            if (!mediaRecorder) {
                warningLog();
                return;
            }

            RecordRTC.getFromDisk(config.type, callback);
        },

        /**
         * This method appends an array of webp images to the recorded video-blob. It takes an "array" object.
         * @type {Array.<Array>}
         * @param {Array} arrayOfWebPImages - Array of webp images.
         * @method
         * @memberof RecordRTC
         * @instance
         * @todo This method should be deprecated.
         * @example
         * var arrayOfWebPImages = [];
         * arrayOfWebPImages.push({
         *     duration: index,
         *     image: 'data:image/webp;base64,...'
         * });
         * recorder.setAdvertisementArray(arrayOfWebPImages);
         */
        setAdvertisementArray: function(arrayOfWebPImages) {
            config.advertisement = [];

            var length = arrayOfWebPImages.length;
            for (var i = 0; i < length; i++) {
                config.advertisement.push({
                    duration: i,
                    image: arrayOfWebPImages[i]
                });
            }
        },

        /**
         * It is equivalent to <code class="str">"recorder.getBlob()"</code> method. Usage of "getBlob" is recommended, though.
         * @property {Blob} blob - Recorded Blob can be accessed using this property.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var blob = this.blob;
         *
         *     // below one is recommended
         *     var blob = this.getBlob();
         * });
         */
        blob: null,

        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} bufferSize - Buffer-size used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used this buffer-size: ' + this.bufferSize);
         * });
         */
        bufferSize: 0,

        /**
         * This works only with {recorderType:StereoAudioRecorder}. Use this property on "stopRecording" to verify the encoder's sample-rates.
         * @property {number} sampleRate - Sample-rates used to encode the WAV container
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     alert('Recorder used these sample-rates: ' + this.sampleRate);
         * });
         */
        sampleRate: 0,

        /**
         * {recorderType:StereoAudioRecorder} returns ArrayBuffer object.
         * @property {ArrayBuffer} buffer - Audio ArrayBuffer, supported only in Chrome.
         * @memberof RecordRTC
         * @instance
         * @readonly
         * @example
         * recorder.stopRecording(function() {
         *     var arrayBuffer = this.buffer;
         *     alert(arrayBuffer.byteLength);
         * });
         */
        buffer: null,

        /**
         * This method resets the recorder. So that you can reuse single recorder instance many times.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.reset();
         * recorder.startRecording();
         */
        reset: function() {
            if (mediaRecorder && typeof mediaRecorder.clearRecordedData === 'function') {
                mediaRecorder.clearRecordedData();
            }
            mediaRecorder = null;
            setState('inactive');
            self.blob = null;
        },

        /**
         * This method is called whenever recorder's state changes. Use this as an "event".
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @method
         * @memberof RecordRTC
         * @instance
         * @example
         * recorder.onStateChanged = function(state) {
         *     console.log('Recorder state: ', state);
         * };
         */
        onStateChanged: function(state) {
            if (!config.disableLogs) {
                console.log('Recorder state changed:', state);
            }
        },

        /**
         * A recorder can have inactive, recording, paused or stopped states.
         * @property {String} state - A recorder's state can be: recording, paused, stopped or inactive.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * // this looper function will keep you updated about the recorder's states.
         * (function looper() {
         *     document.querySelector('h1').innerHTML = 'Recorder's state is: ' + recorder.state;
         *     if(recorder.state === 'stopped') return; // ignore+stop
         *     setTimeout(looper, 1000); // update after every 3-seconds
         * })();
         * recorder.startRecording();
         */
        state: 'inactive',

        /**
         * Get recorder's readonly state.
         * @method
         * @memberof RecordRTC
         * @example
         * var state = recorder.getState();
         * @returns {String} Returns recording state.
         */
        getState: function() {
            return self.state;
        },

        /**
         * Destroy RecordRTC instance. Clear all recorders and objects.
         * @method
         * @memberof RecordRTC
         * @example
         * recorder.destroy();
         */
        destroy: function() {
            var disableLogsCache = config.disableLogs;

            config = {
                disableLogs: true
            };
            self.reset();
            setState('destroyed');
            returnObject = self = null;

            if (Storage.AudioContextConstructor) {
                Storage.AudioContextConstructor.close();
                Storage.AudioContextConstructor = null;
            }

            config.disableLogs = disableLogsCache;

            if (!config.disableLogs) {
                console.warn('RecordRTC is destroyed.');
            }
        },

        /**
         * RecordRTC version number
         * @property {String} version - Release version number.
         * @memberof RecordRTC
         * @static
         * @readonly
         * @example
         * alert(recorder.version);
         */
        version: '5.4.9'
    };

    if (!this) {
        self = returnObject;
        return returnObject;
    }

    // if someone wants to use RecordRTC with the "new" keyword.
    for (var prop in returnObject) {
        this[prop] = returnObject[prop];
    }

    self = this;

    return returnObject;
}

RecordRTC.version = '5.4.9';

if (true /* && !!module.exports*/ ) {
    module.exports = RecordRTC;
}

if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return RecordRTC;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}

RecordRTC.getFromDisk = function(type, callback) {
    if (!callback) {
        throw 'callback is mandatory.';
    }

    console.log('Getting recorded ' + (type === 'all' ? 'blobs' : type + ' blob ') + ' from disk!');
    DiskStorage.Fetch(function(dataURL, _type) {
        if (type !== 'all' && _type === type + 'Blob' && callback) {
            callback(dataURL);
        }

        if (type === 'all' && callback) {
            callback(dataURL, _type.replace('Blob', ''));
        }
    });
};

/**
 * This method can be used to store recorded blobs into IndexedDB storage.
 * @param {object} options - {audio: Blob, video: Blob, gif: Blob}
 * @method
 * @memberof RecordRTC
 * @example
 * RecordRTC.writeToDisk({
 *     audio: audioBlob,
 *     video: videoBlob,
 *     gif  : gifBlob
 * });
 */
RecordRTC.writeToDisk = function(options) {
    console.log('Writing recorded blob(s) to disk!');
    options = options || {};
    if (options.audio && options.video && options.gif) {
        options.audio.getDataURL(function(audioDataURL) {
            options.video.getDataURL(function(videoDataURL) {
                options.gif.getDataURL(function(gifDataURL) {
                    DiskStorage.Store({
                        audioBlob: audioDataURL,
                        videoBlob: videoDataURL,
                        gifBlob: gifDataURL
                    });
                });
            });
        });
    } else if (options.audio && options.video) {
        options.audio.getDataURL(function(audioDataURL) {
            options.video.getDataURL(function(videoDataURL) {
                DiskStorage.Store({
                    audioBlob: audioDataURL,
                    videoBlob: videoDataURL
                });
            });
        });
    } else if (options.audio && options.gif) {
        options.audio.getDataURL(function(audioDataURL) {
            options.gif.getDataURL(function(gifDataURL) {
                DiskStorage.Store({
                    audioBlob: audioDataURL,
                    gifBlob: gifDataURL
                });
            });
        });
    } else if (options.video && options.gif) {
        options.video.getDataURL(function(videoDataURL) {
            options.gif.getDataURL(function(gifDataURL) {
                DiskStorage.Store({
                    videoBlob: videoDataURL,
                    gifBlob: gifDataURL
                });
            });
        });
    } else if (options.audio) {
        options.audio.getDataURL(function(audioDataURL) {
            DiskStorage.Store({
                audioBlob: audioDataURL
            });
        });
    } else if (options.video) {
        options.video.getDataURL(function(videoDataURL) {
            DiskStorage.Store({
                videoBlob: videoDataURL
            });
        });
    } else if (options.gif) {
        options.gif.getDataURL(function(gifDataURL) {
            DiskStorage.Store({
                gifBlob: gifDataURL
            });
        });
    }
};

// __________________________
// RecordRTC-Configuration.js

/**
 * {@link RecordRTCConfiguration} is an inner/private helper for {@link RecordRTC}.
 * @summary It configures the 2nd parameter passed over {@link RecordRTC} and returns a valid "config" object.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTCConfiguration
 * @class
 * @example
 * var options = RecordRTCConfiguration(mediaStream, options);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, getNativeBlob:true, etc.}
 */

function RecordRTCConfiguration(mediaStream, config) {
    if (!config.recorderType && !config.type) {
        if (!!config.audio && !!config.video) {
            config.type = 'video';
        } else if (!!config.audio && !config.video) {
            config.type = 'audio';
        }
    }

    if (config.recorderType && !config.type) {
        if (config.recorderType === WhammyRecorder || config.recorderType === CanvasRecorder) {
            config.type = 'video';
        } else if (config.recorderType === GifRecorder) {
            config.type = 'gif';
        } else if (config.recorderType === StereoAudioRecorder) {
            config.type = 'audio';
        } else if (config.recorderType === MediaStreamRecorder) {
            if (mediaStream.getAudioTracks().length && mediaStream.getVideoTracks().length) {
                config.type = 'video';
            } else if (mediaStream.getAudioTracks().length && !mediaStream.getVideoTracks().length) {
                config.type = 'audio';
            } else if (!mediaStream.getAudioTracks().length && mediaStream.getVideoTracks().length) {
                config.type = 'audio';
            } else {
                // config.type = 'UnKnown';
            }
        }
    }

    if (typeof MediaStreamRecorder !== 'undefined' && typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype) {
        if (!config.mimeType) {
            config.mimeType = 'video/webm';
        }

        if (!config.type) {
            config.type = config.mimeType.split('/')[0];
        }

        if (!config.bitsPerSecond) {
            // config.bitsPerSecond = 128000;
        }
    }

    // consider default type=audio
    if (!config.type) {
        if (config.mimeType) {
            config.type = config.mimeType.split('/')[0];
        }
        if (!config.type) {
            config.type = 'audio';
        }
    }

    return config;
}

// __________________
// GetRecorderType.js

/**
 * {@link GetRecorderType} is an inner/private helper for {@link RecordRTC}.
 * @summary It returns best recorder-type available for your browser.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef GetRecorderType
 * @class
 * @example
 * var RecorderType = GetRecorderType(options);
 * var recorder = new RecorderType(options);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {type:"video", disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
 */

function GetRecorderType(mediaStream, config) {
    var recorder;

    // StereoAudioRecorder can work with all three: Edge, Firefox and Chrome
    // todo: detect if it is Edge, then auto use: StereoAudioRecorder
    if (isChrome || isEdge || isOpera) {
        // Media Stream Recording API has not been implemented in chrome yet;
        // That's why using WebAudio API to record stereo audio in WAV format
        recorder = StereoAudioRecorder;
    }

    if (typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype && !isChrome) {
        recorder = MediaStreamRecorder;
    }

    // video recorder (in WebM format)
    if (config.type === 'video' && (isChrome || isOpera)) {
        recorder = WhammyRecorder;
    }

    // video recorder (in Gif format)
    if (config.type === 'gif') {
        recorder = GifRecorder;
    }

    // html2canvas recording!
    if (config.type === 'canvas') {
        recorder = CanvasRecorder;
    }

    if (isMediaRecorderCompatible() && recorder !== CanvasRecorder && recorder !== GifRecorder && typeof MediaRecorder !== 'undefined' && 'requestData' in MediaRecorder.prototype) {
        if ((mediaStream.getVideoTracks && mediaStream.getVideoTracks().length) || (mediaStream.getAudioTracks && mediaStream.getAudioTracks().length)) {
            // audio-only recording
            if (config.type === 'audio') {
                if (typeof MediaRecorder.isTypeSupported === 'function' && MediaRecorder.isTypeSupported('audio/webm')) {
                    recorder = MediaStreamRecorder;
                }
                // else recorder = StereoAudioRecorder;
            } else {
                // video or screen tracks
                if (typeof MediaRecorder.isTypeSupported === 'function' && MediaRecorder.isTypeSupported('video/webm')) {
                    recorder = MediaStreamRecorder;
                }
            }
        }
    }

    if (mediaStream instanceof Array && mediaStream.length) {
        recorder = MultiStreamRecorder;
    }

    if (config.recorderType) {
        recorder = config.recorderType;
    }

    if (!config.disableLogs && !!recorder && !!recorder.name) {
        console.log('Using recorderType:', recorder.name || recorder.constructor.name);
    }

    return recorder;
}

// _____________
// MRecordRTC.js

/**
 * MRecordRTC runs on top of {@link RecordRTC} to bring multiple recordings in a single place, by providing simple API.
 * @summary MRecordRTC stands for "Multiple-RecordRTC".
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef MRecordRTC
 * @class
 * @example
 * var recorder = new MRecordRTC();
 * recorder.addStream(MediaStream);
 * recorder.mediaType = {
 *     audio: true, // or StereoAudioRecorder or MediaStreamRecorder
 *     video: true, // or WhammyRecorder or MediaStreamRecorder
 *     gif: true    // or GifRecorder
 * };
 * // mimeType is optional and should be set only in advance cases.
 * recorder.mimeType = {
 *     audio: 'audio/wav',
 *     video: 'video/webm',
 *     gif:   'image/gif'
 * };
 * recorder.startRecording();
 * @see For further information:
 * @see {@link https://github.com/muaz-khan/RecordRTC/tree/master/MRecordRTC|MRecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @requires {@link RecordRTC}
 */

function MRecordRTC(mediaStream) {

    /**
     * This method attaches MediaStream object to {@link MRecordRTC}.
     * @param {MediaStream} mediaStream - A MediaStream object, either fetched using getUserMedia API, or generated using captureStreamUntilEnded or WebAudio API.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.addStream(MediaStream);
     */
    this.addStream = function(_mediaStream) {
        if (_mediaStream) {
            mediaStream = _mediaStream;
        }
    };

    /**
     * This property can be used to set the recording type e.g. audio, or video, or gif, or canvas.
     * @property {object} mediaType - {audio: true, video: true, gif: true}
     * @memberof MRecordRTC
     * @example
     * var recorder = new MRecordRTC();
     * recorder.mediaType = {
     *     audio: true, // TRUE or StereoAudioRecorder or MediaStreamRecorder
     *     video: true, // TRUE or WhammyRecorder or MediaStreamRecorder
     *     gif  : true  // TRUE or GifRecorder
     * };
     */
    this.mediaType = {
        audio: true,
        video: true
    };

    /**
     * This method starts recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.startRecording();
     */
    this.startRecording = function() {
        var mediaType = this.mediaType;
        var recorderType;
        var mimeType = this.mimeType || {
            audio: null,
            video: null,
            gif: null
        };

        if (typeof mediaType.audio !== 'function' && isMediaRecorderCompatible() && mediaStream.getAudioTracks && !mediaStream.getAudioTracks().length) {
            mediaType.audio = false;
        }

        if (typeof mediaType.video !== 'function' && isMediaRecorderCompatible() && mediaStream.getVideoTracks && !mediaStream.getVideoTracks().length) {
            mediaType.video = false;
        }

        if (typeof mediaType.gif !== 'function' && isMediaRecorderCompatible() && mediaStream.getVideoTracks && !mediaStream.getVideoTracks().length) {
            mediaType.gif = false;
        }

        if (!mediaType.audio && !mediaType.video && !mediaType.gif) {
            throw 'MediaStream must have either audio or video tracks.';
        }

        if (!!mediaType.audio) {
            recorderType = null;
            if (typeof mediaType.audio === 'function') {
                recorderType = mediaType.audio;
            }

            this.audioRecorder = new RecordRTC(mediaStream, {
                type: 'audio',
                bufferSize: this.bufferSize,
                sampleRate: this.sampleRate,
                numberOfAudioChannels: this.numberOfAudioChannels || 2,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.audio,
                timeSlice: this.timeSlice,
                onTimeStamp: this.onTimeStamp
            });

            if (!mediaType.video) {
                this.audioRecorder.startRecording();
            }
        }

        if (!!mediaType.video) {
            recorderType = null;
            if (typeof mediaType.video === 'function') {
                recorderType = mediaType.video;
            }

            var newStream = mediaStream;

            if (isMediaRecorderCompatible() && !!mediaType.audio && typeof mediaType.audio === 'function') {
                var videoTrack = mediaStream.getVideoTracks()[0];

                if (!!navigator.mozGetUserMedia) {
                    newStream = new MediaStream();
                    newStream.addTrack(videoTrack);

                    if (recorderType && recorderType === WhammyRecorder) {
                        // Firefox does NOT support webp-encoding yet
                        recorderType = MediaStreamRecorder;
                    }
                } else {
                    newStream = new MediaStream([videoTrack]);
                }
            }

            this.videoRecorder = new RecordRTC(newStream, {
                type: 'video',
                video: this.video,
                canvas: this.canvas,
                frameInterval: this.frameInterval || 10,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.video,
                timeSlice: this.timeSlice,
                onTimeStamp: this.onTimeStamp
            });

            if (!mediaType.audio) {
                this.videoRecorder.startRecording();
            }
        }

        if (!!mediaType.audio && !!mediaType.video) {
            var self = this;

            // this line prevents StereoAudioRecorder
            // todo: fix it
            if (isMediaRecorderCompatible() /* && !this.audioRecorder */ ) {
                self.audioRecorder = null;
                self.videoRecorder.startRecording();
            } else {
                self.videoRecorder.initRecorder(function() {
                    self.audioRecorder.initRecorder(function() {
                        // Both recorders are ready to record things accurately
                        self.videoRecorder.startRecording();
                        self.audioRecorder.startRecording();
                    });
                });
            }
        }

        if (!!mediaType.gif) {
            recorderType = null;
            if (typeof mediaType.gif === 'function') {
                recorderType = mediaType.gif;
            }
            this.gifRecorder = new RecordRTC(mediaStream, {
                type: 'gif',
                frameRate: this.frameRate || 200,
                quality: this.quality || 10,
                disableLogs: this.disableLogs,
                recorderType: recorderType,
                mimeType: mimeType.gif
            });
            this.gifRecorder.startRecording();
        }
    };

    /**
     * This method stops recording.
     * @param {function} callback - Callback function is invoked when all encoders finished their jobs.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.stopRecording(function(recording){
     *     var audioBlob = recording.audio;
     *     var videoBlob = recording.video;
     *     var gifBlob   = recording.gif;
     * });
     */
    this.stopRecording = function(callback) {
        callback = callback || function() {};

        if (this.audioRecorder) {
            this.audioRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'audio');
            });
        }

        if (this.videoRecorder) {
            this.videoRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'video');
            });
        }

        if (this.gifRecorder) {
            this.gifRecorder.stopRecording(function(blobURL) {
                callback(blobURL, 'gif');
            });
        }
    };

    /**
     * This method pauses recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.pauseRecording();
     */
    this.pauseRecording = function() {
        if (this.audioRecorder) {
            this.audioRecorder.pauseRecording();
        }

        if (this.videoRecorder) {
            this.videoRecorder.pauseRecording();
        }

        if (this.gifRecorder) {
            this.gifRecorder.pauseRecording();
        }
    };

    /**
     * This method resumes recording.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.resumeRecording();
     */
    this.resumeRecording = function() {
        if (this.audioRecorder) {
            this.audioRecorder.resumeRecording();
        }

        if (this.videoRecorder) {
            this.videoRecorder.resumeRecording();
        }

        if (this.gifRecorder) {
            this.gifRecorder.resumeRecording();
        }
    };

    /**
     * This method can be used to manually get all recorded blobs.
     * @param {function} callback - All recorded blobs are passed back to the "callback" function.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.getBlob(function(recording){
     *     var audioBlob = recording.audio;
     *     var videoBlob = recording.video;
     *     var gifBlob   = recording.gif;
     * });
     * // or
     * var audioBlob = recorder.getBlob().audio;
     * var videoBlob = recorder.getBlob().video;
     */
    this.getBlob = function(callback) {
        var output = {};

        if (this.audioRecorder) {
            output.audio = this.audioRecorder.getBlob();
        }

        if (this.videoRecorder) {
            output.video = this.videoRecorder.getBlob();
        }

        if (this.gifRecorder) {
            output.gif = this.gifRecorder.getBlob();
        }

        if (callback) {
            callback(output);
        }

        return output;
    };

    /**
     * Destroy all recorder instances.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.destroy();
     */
    this.destroy = function() {
        if (this.audioRecorder) {
            this.audioRecorder.destroy();
            this.audioRecorder = null;
        }

        if (this.videoRecorder) {
            this.videoRecorder.destroy();
            this.videoRecorder = null;
        }

        if (this.gifRecorder) {
            this.gifRecorder.destroy();
            this.gifRecorder = null;
        }
    };

    /**
     * This method can be used to manually get all recorded blobs' DataURLs.
     * @param {function} callback - All recorded blobs' DataURLs are passed back to the "callback" function.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.getDataURL(function(recording){
     *     var audioDataURL = recording.audio;
     *     var videoDataURL = recording.video;
     *     var gifDataURL   = recording.gif;
     * });
     */
    this.getDataURL = function(callback) {
        this.getBlob(function(blob) {
            if (blob.audio && blob.video) {
                getDataURL(blob.audio, function(_audioDataURL) {
                    getDataURL(blob.video, function(_videoDataURL) {
                        callback({
                            audio: _audioDataURL,
                            video: _videoDataURL
                        });
                    });
                });
            } else if (blob.audio) {
                getDataURL(blob.audio, function(_audioDataURL) {
                    callback({
                        audio: _audioDataURL
                    });
                });
            } else if (blob.video) {
                getDataURL(blob.video, function(_videoDataURL) {
                    callback({
                        video: _videoDataURL
                    });
                });
            }
        });

        function getDataURL(blob, callback00) {
            if (typeof Worker !== 'undefined') {
                var webWorker = processInWebWorker(function readFile(_blob) {
                    postMessage(new FileReaderSync().readAsDataURL(_blob));
                });

                webWorker.onmessage = function(event) {
                    callback00(event.data);
                };

                webWorker.postMessage(blob);
            } else {
                var reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = function(event) {
                    callback00(event.target.result);
                };
            }
        }

        function processInWebWorker(_function) {
            var blob = URL.createObjectURL(new Blob([_function.toString(),
                'this.onmessage =  function (eee) {' + _function.name + '(eee.data);}'
            ], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            var url;
            if (typeof URL !== 'undefined') {
                url = URL;
            } else if (typeof webkitURL !== 'undefined') {
                url = webkitURL;
            } else {
                throw 'Neither URL nor webkitURL detected.';
            }
            url.revokeObjectURL(blob);
            return worker;
        }
    };

    /**
     * This method can be used to ask {@link MRecordRTC} to write all recorded blobs into IndexedDB storage.
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.writeToDisk();
     */
    this.writeToDisk = function() {
        RecordRTC.writeToDisk({
            audio: this.audioRecorder,
            video: this.videoRecorder,
            gif: this.gifRecorder
        });
    };

    /**
     * This method can be used to invoke a save-as dialog for all recorded blobs.
     * @param {object} args - {audio: 'audio-name', video: 'video-name', gif: 'gif-name'}
     * @method
     * @memberof MRecordRTC
     * @example
     * recorder.save({
     *     audio: 'audio-file-name',
     *     video: 'video-file-name',
     *     gif  : 'gif-file-name'
     * });
     */
    this.save = function(args) {
        args = args || {
            audio: true,
            video: true,
            gif: true
        };

        if (!!args.audio && this.audioRecorder) {
            this.audioRecorder.save(typeof args.audio === 'string' ? args.audio : '');
        }

        if (!!args.video && this.videoRecorder) {
            this.videoRecorder.save(typeof args.video === 'string' ? args.video : '');
        }
        if (!!args.gif && this.gifRecorder) {
            this.gifRecorder.save(typeof args.gif === 'string' ? args.gif : '');
        }
    };
}

/**
 * This method can be used to get all recorded blobs from IndexedDB storage.
 * @param {string} type - 'all' or 'audio' or 'video' or 'gif'
 * @param {function} callback - Callback function to get all stored blobs.
 * @method
 * @memberof MRecordRTC
 * @example
 * MRecordRTC.getFromDisk('all', function(dataURL, type){
 *     if(type === 'audio') { }
 *     if(type === 'video') { }
 *     if(type === 'gif')   { }
 * });
 */
MRecordRTC.getFromDisk = RecordRTC.getFromDisk;

/**
 * This method can be used to store recorded blobs into IndexedDB storage.
 * @param {object} options - {audio: Blob, video: Blob, gif: Blob}
 * @method
 * @memberof MRecordRTC
 * @example
 * MRecordRTC.writeToDisk({
 *     audio: audioBlob,
 *     video: videoBlob,
 *     gif  : gifBlob
 * });
 */
MRecordRTC.writeToDisk = RecordRTC.writeToDisk;

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MRecordRTC = MRecordRTC;
}

var browserFakeUserAgent = 'Fake/5.0 (FakeOS) AppleWebKit/123 (KHTML, like Gecko) Fake/12.3.4567.89 Fake/123.45';

(function(that) {
    if (!that) {
        return;
    }

    if (typeof window !== 'undefined') {
        return;
    }

    if (typeof global === 'undefined') {
        return;
    }

    global.navigator = {
        userAgent: browserFakeUserAgent,
        getUserMedia: function() {}
    };

    if (!global.console) {
        global.console = {};
    }

    if (typeof global.console.log === 'undefined' || typeof global.console.error === 'undefined') {
        global.console.error = global.console.log = global.console.log || function() {
            console.log(arguments);
        };
    }

    if (typeof document === 'undefined') {
        /*global document:true */
        that.document = {};

        document.createElement = document.captureStream = document.mozCaptureStream = function() {
            var obj = {
                getContext: function() {
                    return obj;
                },
                play: function() {},
                pause: function() {},
                drawImage: function() {},
                toDataURL: function() {
                    return '';
                }
            };
            return obj;
        };

        that.HTMLVideoElement = function() {};
    }

    if (typeof location === 'undefined') {
        /*global location:true */
        that.location = {
            protocol: 'file:',
            href: '',
            hash: ''
        };
    }

    if (typeof screen === 'undefined') {
        /*global screen:true */
        that.screen = {
            width: 0,
            height: 0
        };
    }

    if (typeof URL === 'undefined') {
        /*global screen:true */
        that.URL = {
            createObjectURL: function() {
                return '';
            },
            revokeObjectURL: function() {
                return '';
            }
        };
    }

    /*global window:true */
    that.window = global;
})(typeof global !== 'undefined' ? global : null);

// _____________________________
// Cross-Browser-Declarations.js

// animation-frame used in WebM recording

/*jshint -W079 */
var requestAnimationFrame = window.requestAnimationFrame;
if (typeof requestAnimationFrame === 'undefined') {
    if (typeof webkitRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = webkitRequestAnimationFrame;
    } else if (typeof mozRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = mozRequestAnimationFrame;
    } else if (typeof msRequestAnimationFrame !== 'undefined') {
        /*global requestAnimationFrame:true */
        requestAnimationFrame = msRequestAnimationFrame;
    } else if (typeof requestAnimationFrame === 'undefined') {
        // via: https://gist.github.com/paulirish/1579671
        var lastTime = 0;

        /*global requestAnimationFrame:true */
        requestAnimationFrame = function(callback, element) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = setTimeout(function() {
                callback(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
    }
}

/*jshint -W079 */
var cancelAnimationFrame = window.cancelAnimationFrame;
if (typeof cancelAnimationFrame === 'undefined') {
    if (typeof webkitCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = webkitCancelAnimationFrame;
    } else if (typeof mozCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = mozCancelAnimationFrame;
    } else if (typeof msCancelAnimationFrame !== 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = msCancelAnimationFrame;
    } else if (typeof cancelAnimationFrame === 'undefined') {
        /*global cancelAnimationFrame:true */
        cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
    }
}

// WebAudio API representer
var AudioContext = window.AudioContext;

if (typeof AudioContext === 'undefined') {
    if (typeof webkitAudioContext !== 'undefined') {
        /*global AudioContext:true */
        AudioContext = webkitAudioContext;
    }

    if (typeof mozAudioContext !== 'undefined') {
        /*global AudioContext:true */
        AudioContext = mozAudioContext;
    }
}

/*jshint -W079 */
var URL = window.URL;

if (typeof URL === 'undefined' && typeof webkitURL !== 'undefined') {
    /*global URL:true */
    URL = webkitURL;
}

if (typeof navigator !== 'undefined' && typeof navigator.getUserMedia === 'undefined') { // maybe window.navigator?
    if (typeof navigator.webkitGetUserMedia !== 'undefined') {
        navigator.getUserMedia = navigator.webkitGetUserMedia;
    }

    if (typeof navigator.mozGetUserMedia !== 'undefined') {
        navigator.getUserMedia = navigator.mozGetUserMedia;
    }
}

var isEdge = navigator.userAgent.indexOf('Edge') !== -1 && (!!navigator.msSaveBlob || !!navigator.msSaveOrOpenBlob);
var isOpera = !!window.opera || navigator.userAgent.indexOf('OPR/') !== -1;
var isSafari = navigator.userAgent.toLowerCase().indexOf('safari/') !== -1 && navigator.userAgent.toLowerCase().indexOf('chrome/') === -1;
var isChrome = (!isOpera && !isEdge && !!navigator.webkitGetUserMedia) || isElectron() || navigator.userAgent.toLowerCase().indexOf('chrome/') !== -1;

var MediaStream = window.MediaStream;

if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
    MediaStream = webkitMediaStream;
}

/*global MediaStream:true */
if (typeof MediaStream !== 'undefined') {
    if (!('getVideoTracks' in MediaStream.prototype)) {
        MediaStream.prototype.getVideoTracks = function() {
            if (!this.getTracks) {
                return [];
            }

            var tracks = [];
            this.getTracks().forEach(function(track) {
                if (track.kind.toString().indexOf('video') !== -1) {
                    tracks.push(track);
                }
            });
            return tracks;
        };

        MediaStream.prototype.getAudioTracks = function() {
            if (!this.getTracks) {
                return [];
            }

            var tracks = [];
            this.getTracks().forEach(function(track) {
                if (track.kind.toString().indexOf('audio') !== -1) {
                    tracks.push(track);
                }
            });
            return tracks;
        };
    }

    // override "stop" method for all browsers
    if (typeof MediaStream.prototype.stop === 'undefined') {
        MediaStream.prototype.stop = function() {
            this.getTracks().forEach(function(track) {
                track.stop();
            });
        };
    }
}

// below function via: http://goo.gl/B3ae8c
/**
 * Return human-readable file size.
 * @param {number} bytes - Pass bytes and get formatted string.
 * @returns {string} - formatted string
 * @example
 * bytesToSize(1024*1024*5) === '5 GB'
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */
function bytesToSize(bytes) {
    var k = 1000;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Bytes';
    }
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)), 10);
    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

/**
 * @param {Blob} file - File or Blob object. This parameter is required.
 * @param {string} fileName - Optional file name e.g. "Recorded-Video.webm"
 * @example
 * invokeSaveAsDialog(blob or file, [optional] fileName);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */
function invokeSaveAsDialog(file, fileName) {
    if (!file) {
        throw 'Blob object is required.';
    }

    if (!file.type) {
        try {
            file.type = 'video/webm';
        } catch (e) {}
    }

    var fileExtension = (file.type || 'video/webm').split('/')[1];

    if (fileName && fileName.indexOf('.') !== -1) {
        var splitted = fileName.split('.');
        fileName = splitted[0];
        fileExtension = splitted[1];
    }

    var fileFullName = (fileName || (Math.round(Math.random() * 9999999999) + 888888888)) + '.' + fileExtension;

    if (typeof navigator.msSaveOrOpenBlob !== 'undefined') {
        return navigator.msSaveOrOpenBlob(file, fileFullName);
    } else if (typeof navigator.msSaveBlob !== 'undefined') {
        return navigator.msSaveBlob(file, fileFullName);
    }

    var hyperlink = document.createElement('a');
    hyperlink.href = URL.createObjectURL(file);
    hyperlink.download = fileFullName;

    hyperlink.style = 'display:none;opacity:0;color:transparent;';
    (document.body || document.documentElement).appendChild(hyperlink);

    if (typeof hyperlink.click === 'function') {
        hyperlink.click();
    } else {
        hyperlink.target = '_blank';
        hyperlink.dispatchEvent(new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true
        }));
    }

    URL.revokeObjectURL(hyperlink.href);
}

/**
 * from: https://github.com/cheton/is-electron/blob/master/index.js
 **/
function isElectron() {
    // Renderer process
    if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
        return true;
    }

    // Main process
    if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
        return true;
    }

    // Detect the user agent when the `nodeIntegration` option is set to true
    if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
        return true;
    }

    return false;
}

function setSrcObject(stream, element, ignoreCreateObjectURL) {
    if ('srcObject' in element) {
        element.srcObject = stream;
    } else if ('mozSrcObject' in element) {
        element.mozSrcObject = stream;
    } else if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
        try {
            element.src = URL.createObjectURL(stream);
        } catch (e) {
            setSrcObject(stream, element, true);
            return;
        }
    } else {
        alert('createObjectURL/srcObject both are not supported.');
    }
}

// __________ (used to handle stuff like http://goo.gl/xmE5eg) issue #129
// Storage.js

/**
 * Storage is a standalone object used by {@link RecordRTC} to store reusable objects e.g. "new AudioContext".
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @example
 * Storage.AudioContext === webkitAudioContext
 * @property {webkitAudioContext} AudioContext - Keeps a reference to AudioContext object.
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */

var Storage = {};

if (typeof AudioContext !== 'undefined') {
    Storage.AudioContext = AudioContext;
} else if (typeof webkitAudioContext !== 'undefined') {
    Storage.AudioContext = webkitAudioContext;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.Storage = Storage;
}

function isMediaRecorderCompatible() {
    var isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
    var isChrome = (!!window.chrome && !isOpera) || isElectron();
    var isFirefox = typeof window.InstallTrigger !== 'undefined';

    if (isFirefox) {
        return true;
    }

    var nVer = navigator.appVersion;
    var nAgt = navigator.userAgent;
    var fullVersion = '' + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var nameOffset, verOffset, ix;

    if (isChrome || isOpera) {
        verOffset = nAgt.indexOf('Chrome');
        fullVersion = nAgt.substring(verOffset + 7);
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
    }

    if ((ix = fullVersion.indexOf(' ')) !== -1) {
        fullVersion = fullVersion.substring(0, ix);
    }

    majorVersion = parseInt('' + fullVersion, 10);

    if (isNaN(majorVersion)) {
        fullVersion = '' + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }

    return majorVersion >= 49;
}

// ______________________
// MediaStreamRecorder.js

/**
 * MediaStreamRecorder is an abstraction layer for {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}. It is used by {@link RecordRTC} to record MediaStream(s) in both Chrome and Firefox.
 * @summary Runs top over {@link https://w3c.github.io/mediacapture-record/MediaRecorder.html|MediaRecorder API}.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link https://github.com/muaz-khan|Muaz Khan}
 * @typedef MediaStreamRecorder
 * @class
 * @example
 * var config = {
 *     mimeType: 'video/webm', // vp8, vp9, h264, mkv, opus/vorbis
 *     audioBitsPerSecond : 256 * 8 * 1024,
 *     videoBitsPerSecond : 256 * 8 * 1024,
 *     bitsPerSecond: 256 * 8 * 1024,  // if this is provided, skip above two
 *     checkForInactiveTracks: true,
 *     timeSlice: 1000, // concatenate intervals based blobs
 *     ondataavailable: function() {} // get intervals based blobs
 * }
 * var recorder = new MediaStreamRecorder(mediaStream, config);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 *
 *     // or
 *     var blob = recorder.blob;
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {disableLogs:true, initCallback: function, mimeType: "video/webm", timeSlice: 1000}
 * @throws Will throw an error if first argument "MediaStream" is missing. Also throws error if "MediaRecorder API" are not supported by the browser.
 */

function MediaStreamRecorder(mediaStream, config) {
    var self = this;

    if (typeof mediaStream === 'undefined') {
        throw 'First argument "MediaStream" is required.';
    }

    if (typeof MediaRecorder === 'undefined') {
        throw 'Your browser does not supports Media Recorder API. Please try other modules e.g. WhammyRecorder or StereoAudioRecorder.';
    }

    config = config || {
        // bitsPerSecond: 256 * 8 * 1024,
        mimeType: 'video/webm'
    };

    if (config.type === 'audio') {
        if (mediaStream.getVideoTracks().length && mediaStream.getAudioTracks().length) {
            var stream;
            if (!!navigator.mozGetUserMedia) {
                stream = new MediaStream();
                stream.addTrack(mediaStream.getAudioTracks()[0]);
            } else {
                // webkitMediaStream
                stream = new MediaStream(mediaStream.getAudioTracks());
            }
            mediaStream = stream;
        }

        if (!config.mimeType || config.mimeType.toString().toLowerCase().indexOf('audio') === -1) {
            config.mimeType = isChrome ? 'audio/webm' : 'audio/ogg';
        }

        if (config.mimeType && config.mimeType.toString().toLowerCase() !== 'audio/ogg' && !!navigator.mozGetUserMedia) {
            // forcing better codecs on Firefox (via #166)
            config.mimeType = 'audio/ogg';
        }
    }

    var arrayOfBlobs = [];

    /**
     * This method returns array of blobs. Use only with "timeSlice". Its useful to preview recording anytime, without using the "stop" method.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var arrayOfBlobs = recorder.getArrayOfBlobs();
     * @returns {Array} Returns array of recorded blobs.
     */
    this.getArrayOfBlobs = function() {
        return arrayOfBlobs;
    };

    /**
     * This method records MediaStream.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        // set defaults
        self.blob = null;
        self.clearRecordedData();
        self.timestamps = [];
        allStates = [];
        arrayOfBlobs = [];

        var recorderHints = config;

        if (!config.disableLogs) {
            console.log('Passing following config over MediaRecorder API.', recorderHints);
        }

        if (mediaRecorder) {
            // mandatory to make sure Firefox doesn't fails to record streams 3-4 times without reloading the page.
            mediaRecorder = null;
        }

        if (isChrome && !isMediaRecorderCompatible()) {
            // to support video-only recording on stable
            recorderHints = 'video/vp8';
        }

        if (typeof MediaRecorder.isTypeSupported === 'function' && recorderHints.mimeType) {
            if (!MediaRecorder.isTypeSupported(recorderHints.mimeType)) {
                if (!config.disableLogs) {
                    console.warn('MediaRecorder API seems unable to record mimeType:', recorderHints.mimeType);
                }

                recorderHints.mimeType = config.type === 'audio' ? 'audio/webm' : 'video/webm';
            }
        }

        // using MediaRecorder API here
        try {
            mediaRecorder = new MediaRecorder(mediaStream, recorderHints);

            // reset
            config.mimeType = recorderHints.mimeType;
        } catch (e) {
            // chrome-based fallback
            mediaRecorder = new MediaRecorder(mediaStream);
        }

        // old hack?
        if (recorderHints.mimeType && !MediaRecorder.isTypeSupported && 'canRecordMimeType' in mediaRecorder && mediaRecorder.canRecordMimeType(recorderHints.mimeType) === false) {
            if (!config.disableLogs) {
                console.warn('MediaRecorder API seems unable to record mimeType:', recorderHints.mimeType);
            }
        }

        // Dispatching OnDataAvailable Handler
        mediaRecorder.ondataavailable = function(e) {
            if (e.data) {
                allStates.push('ondataavailable: ' + bytesToSize(e.data.size));
            }

            if (typeof config.timeSlice === 'number') {
                if (e.data && e.data.size && e.data.size > 100) {
                    arrayOfBlobs.push(e.data);
                    updateTimeStamp();

                    if (typeof config.ondataavailable === 'function') {
                        // intervals based blobs
                        var blob = config.getNativeBlob ? e.data : new Blob([e.data], {
                            type: getMimeType(recorderHints)
                        });
                        config.ondataavailable(blob);
                    }
                }
                return;
            }

            if (!e.data || !e.data.size || e.data.size < 100 || self.blob) {
                // make sure that stopRecording always getting fired
                // even if there is invalid data
                if (self.recordingCallback) {
                    self.recordingCallback(new Blob([], {
                        type: getMimeType(recorderHints)
                    }));
                    self.recordingCallback = null;
                }
                return;
            }

            self.blob = config.getNativeBlob ? e.data : new Blob([e.data], {
                type: getMimeType(recorderHints)
            });

            if (self.recordingCallback) {
                self.recordingCallback(self.blob);
                self.recordingCallback = null;
            }
        };

        mediaRecorder.onstart = function() {
            allStates.push('started');
        };

        mediaRecorder.onpause = function() {
            allStates.push('paused');
        };

        mediaRecorder.onresume = function() {
            allStates.push('resumed');
        };

        mediaRecorder.onstop = function() {
            allStates.push('stopped');
        };

        mediaRecorder.onerror = function(error) {
            if (!error) {
                return;
            }

            if (!error.name) {
                error.name = 'UnknownError';
            }

            allStates.push('error: ' + error);

            if (!config.disableLogs) {
                // via: https://w3c.github.io/mediacapture-record/MediaRecorder.html#exception-summary
                if (error.name.toString().toLowerCase().indexOf('invalidstate') !== -1) {
                    console.error('The MediaRecorder is not in a state in which the proposed operation is allowed to be executed.', error);
                } else if (error.name.toString().toLowerCase().indexOf('notsupported') !== -1) {
                    console.error('MIME type (', recorderHints.mimeType, ') is not supported.', error);
                } else if (error.name.toString().toLowerCase().indexOf('security') !== -1) {
                    console.error('MediaRecorder security error', error);
                }

                // older code below
                else if (error.name === 'OutOfMemory') {
                    console.error('The UA has exhaused the available memory. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'IllegalStreamModification') {
                    console.error('A modification to the stream has occurred that makes it impossible to continue recording. An example would be the addition of a Track while recording is occurring. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'OtherRecordingError') {
                    console.error('Used for an fatal error other than those listed above. User agents SHOULD provide as much additional information as possible in the message attribute.', error);
                } else if (error.name === 'GenericError') {
                    console.error('The UA cannot provide the codec or recording option that has been requested.', error);
                } else {
                    console.error('MediaRecorder Error', error);
                }
            }

            (function(looper) {
                if (!self.manuallyStopped && mediaRecorder && mediaRecorder.state === 'inactive') {
                    delete config.timeslice;

                    // 10 minutes, enough?
                    mediaRecorder.start(10 * 60 * 1000);
                    return;
                }

                setTimeout(looper, 1000);
            })();

            if (mediaRecorder.state !== 'inactive' && mediaRecorder.state !== 'stopped') {
                mediaRecorder.stop();
            }
        };

        if (typeof config.timeSlice === 'number') {
            updateTimeStamp();
            mediaRecorder.start(config.timeSlice);
        } else {
            // default is 60 minutes; enough?
            // use config => {timeSlice: 1000} otherwise

            mediaRecorder.start(3.6e+6);
        }

        if (config.initCallback) {
            config.initCallback(); // old code
        }
    };

    /**
     * @property {Array} timestamps - Array of time stamps
     * @memberof MediaStreamRecorder
     * @example
     * console.log(recorder.timestamps);
     */
    this.timestamps = [];

    function updateTimeStamp() {
        self.timestamps.push(new Date().getTime());

        if (typeof config.onTimeStamp === 'function') {
            config.onTimeStamp(self.timestamps[self.timestamps.length - 1], self.timestamps);
        }
    }

    function getMimeType(secondObject) {
        if (mediaRecorder && mediaRecorder.mimeType) {
            return mediaRecorder.mimeType;
        }

        return secondObject.mimeType || 'video/webm';
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        self.manuallyStopped = true; // used inside the mediaRecorder.onerror

        if (!mediaRecorder) {
            return;
        }

        this.recordingCallback = callback;

        if (mediaRecorder.state === 'recording') {
            mediaRecorder.stop();
        }

        if (typeof config.timeSlice === 'number') {
            setTimeout(function() {
                self.blob = new Blob(arrayOfBlobs, {
                    type: getMimeType(config)
                });

                self.recordingCallback(self.blob);
            }, 100);
        }
    };

    /**
     * This method pauses the recording process.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        if (!mediaRecorder) {
            return;
        }

        if (mediaRecorder.state === 'recording') {
            mediaRecorder.pause();
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (!mediaRecorder) {
            return;
        }

        if (mediaRecorder.state === 'paused') {
            mediaRecorder.resume();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (mediaRecorder && mediaRecorder.state === 'recording') {
            self.stop(clearRecordedDataCB);
        }

        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        arrayOfBlobs = [];
        mediaRecorder = null;
        self.timestamps = [];
    }

    // Reference to "MediaRecorder" object
    var mediaRecorder;

    /**
     * Access to native MediaRecorder API
     * @method
     * @memberof MediaStreamRecorder
     * @instance
     * @example
     * var internal = recorder.getInternalRecorder();
     * internal.ondataavailable = function() {}; // override
     * internal.stream, internal.onpause, internal.onstop, etc.
     * @returns {Object} Returns internal recording object.
     */
    this.getInternalRecorder = function() {
        return mediaRecorder;
    };

    function isMediaStreamActive() {
        if ('active' in mediaStream) {
            if (!mediaStream.active) {
                return false;
            }
        } else if ('ended' in mediaStream) { // old hack
            if (mediaStream.ended) {
                return false;
            }
        }
        return true;
    }

    /**
     * @property {Blob} blob - Recorded data as "Blob" object.
     * @memberof MediaStreamRecorder
     * @example
     * recorder.stop(function() {
     *     var blob = recorder.blob;
     * });
     */
    this.blob = null;


    /**
     * Get MediaRecorder readonly state.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var state = recorder.getState();
     * @returns {String} Returns recording state.
     */
    this.getState = function() {
        if (!mediaRecorder) {
            return 'inactive';
        }

        return mediaRecorder.state || 'inactive';
    };

    // list of all recording states
    var allStates = [];

    /**
     * Get MediaRecorder all recording states.
     * @method
     * @memberof MediaStreamRecorder
     * @example
     * var state = recorder.getAllStates();
     * @returns {Array} Returns all recording states
     */
    this.getAllStates = function() {
        return allStates;
    };

    // if any Track within the MediaStream is muted or not enabled at any time, 
    // the browser will only record black frames 
    // or silence since that is the content produced by the Track
    // so we need to stopRecording as soon as any single track ends.
    if (typeof config.checkForInactiveTracks === 'undefined') {
        config.checkForInactiveTracks = false; // disable to minimize CPU usage
    }

    var self = this;

    // this method checks if media stream is stopped
    // or if any track is ended.
    (function looper() {
        if (!mediaRecorder || config.checkForInactiveTracks === false) {
            return;
        }

        if (isMediaStreamActive() === false) {
            if (!config.disableLogs) {
                console.log('MediaStream seems stopped.');
            }
            self.stop();
            return;
        }

        setTimeout(looper, 1000); // check every second
    })();

    // for debugging
    this.name = 'MediaStreamRecorder';
    this.toString = function() {
        return this.name;
    };
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MediaStreamRecorder = MediaStreamRecorder;
}

// source code from: http://typedarray.org/wp-content/projects/WebAudioRecorder/script.js
// https://github.com/mattdiamond/Recorderjs#license-mit
// ______________________
// StereoAudioRecorder.js

/**
 * StereoAudioRecorder is a standalone class used by {@link RecordRTC} to bring "stereo" audio-recording in chrome.
 * @summary JavaScript standalone object for stereo audio recording.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef StereoAudioRecorder
 * @class
 * @example
 * var recorder = new StereoAudioRecorder(MediaStream, {
 *     sampleRate: 44100,
 *     bufferSize: 4096
 * });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {sampleRate: 44100, bufferSize: 4096, numberOfAudioChannels: 1, etc.}
 */

function StereoAudioRecorder(mediaStream, config) {
    if (!mediaStream.getAudioTracks().length) {
        throw 'Your stream has no audio tracks.';
    }

    config = config || {};

    var self = this;

    // variables
    var leftchannel = [];
    var rightchannel = [];
    var recording = false;
    var recordingLength = 0;
    var jsAudioNode;

    var numberOfAudioChannels = 2;

    /**
     * Set sample rates such as 8K or 16K. Reference: http://stackoverflow.com/a/28977136/552182
     * @property {number} desiredSampRate - Desired Bits per sample * 1000
     * @memberof StereoAudioRecorder
     * @instance
     * @example
     * var recorder = StereoAudioRecorder(mediaStream, {
     *   desiredSampRate: 16 * 1000 // bits-per-sample * 1000
     * });
     */
    var desiredSampRate = config.desiredSampRate;

    // backward compatibility
    if (config.leftChannel === true) {
        numberOfAudioChannels = 1;
    }

    if (config.numberOfAudioChannels === 1) {
        numberOfAudioChannels = 1;
    }

    if (!numberOfAudioChannels || numberOfAudioChannels < 1) {
        numberOfAudioChannels = 2;
    }

    if (!config.disableLogs) {
        console.log('StereoAudioRecorder is set to record number of channels: ' + numberOfAudioChannels);
    }

    // if any Track within the MediaStream is muted or not enabled at any time, 
    // the browser will only record black frames 
    // or silence since that is the content produced by the Track
    // so we need to stopRecording as soon as any single track ends.
    if (typeof config.checkForInactiveTracks === 'undefined') {
        config.checkForInactiveTracks = true;
    }

    function isMediaStreamActive() {
        if (config.checkForInactiveTracks === false) {
            // always return "true"
            return true;
        }

        if ('active' in mediaStream) {
            if (!mediaStream.active) {
                return false;
            }
        } else if ('ended' in mediaStream) { // old hack
            if (mediaStream.ended) {
                return false;
            }
        }
        return true;
    }

    /**
     * This method records MediaStream.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (isMediaStreamActive() === false) {
            throw 'Please make sure MediaStream is active.';
        }

        resetVariables();

        isAudioProcessStarted = isPaused = false;
        recording = true;

        if (typeof config.timeSlice !== 'undefined') {
            looper();
        }
    };

    function mergeLeftRightBuffers(config, callback) {
        function mergeAudioBuffers(config, cb) {
            var numberOfAudioChannels = config.numberOfAudioChannels;

            // todo: "slice(0)" --- is it causes loop? Should be removed?
            var leftBuffers = config.leftBuffers.slice(0);
            var rightBuffers = config.rightBuffers.slice(0);
            var sampleRate = config.sampleRate;
            var internalInterleavedLength = config.internalInterleavedLength;
            var desiredSampRate = config.desiredSampRate;

            if (numberOfAudioChannels === 2) {
                leftBuffers = mergeBuffers(leftBuffers, internalInterleavedLength);
                rightBuffers = mergeBuffers(rightBuffers, internalInterleavedLength);

                if (desiredSampRate) {
                    leftBuffers = interpolateArray(leftBuffers, desiredSampRate, sampleRate);
                    rightBuffers = interpolateArray(rightBuffers, desiredSampRate, sampleRate);
                }
            }

            if (numberOfAudioChannels === 1) {
                leftBuffers = mergeBuffers(leftBuffers, internalInterleavedLength);

                if (desiredSampRate) {
                    leftBuffers = interpolateArray(leftBuffers, desiredSampRate, sampleRate);
                }
            }

            // set sample rate as desired sample rate
            if (desiredSampRate) {
                sampleRate = desiredSampRate;
            }

            // for changing the sampling rate, reference:
            // http://stackoverflow.com/a/28977136/552182
            function interpolateArray(data, newSampleRate, oldSampleRate) {
                var fitCount = Math.round(data.length * (newSampleRate / oldSampleRate));
                var newData = [];
                var springFactor = Number((data.length - 1) / (fitCount - 1));
                newData[0] = data[0];
                for (var i = 1; i < fitCount - 1; i++) {
                    var tmp = i * springFactor;
                    var before = Number(Math.floor(tmp)).toFixed();
                    var after = Number(Math.ceil(tmp)).toFixed();
                    var atPoint = tmp - before;
                    newData[i] = linearInterpolate(data[before], data[after], atPoint);
                }
                newData[fitCount - 1] = data[data.length - 1];
                return newData;
            }

            function linearInterpolate(before, after, atPoint) {
                return before + (after - before) * atPoint;
            }

            function mergeBuffers(channelBuffer, rLength) {
                var result = new Float64Array(rLength);
                var offset = 0;
                var lng = channelBuffer.length;

                for (var i = 0; i < lng; i++) {
                    var buffer = channelBuffer[i];
                    result.set(buffer, offset);
                    offset += buffer.length;
                }

                return result;
            }

            function interleave(leftChannel, rightChannel) {
                var length = leftChannel.length + rightChannel.length;

                var result = new Float64Array(length);

                var inputIndex = 0;

                for (var index = 0; index < length;) {
                    result[index++] = leftChannel[inputIndex];
                    result[index++] = rightChannel[inputIndex];
                    inputIndex++;
                }
                return result;
            }

            function writeUTFBytes(view, offset, string) {
                var lng = string.length;
                for (var i = 0; i < lng; i++) {
                    view.setUint8(offset + i, string.charCodeAt(i));
                }
            }

            // interleave both channels together
            var interleaved;

            if (numberOfAudioChannels === 2) {
                interleaved = interleave(leftBuffers, rightBuffers);
            }

            if (numberOfAudioChannels === 1) {
                interleaved = leftBuffers;
            }

            var interleavedLength = interleaved.length;

            // create wav file
            var resultingBufferLength = 44 + interleavedLength * 2;

            var buffer = new ArrayBuffer(resultingBufferLength);

            var view = new DataView(buffer);

            // RIFF chunk descriptor/identifier 
            writeUTFBytes(view, 0, 'RIFF');

            // RIFF chunk length
            view.setUint32(4, 44 + interleavedLength * 2, true);

            // RIFF type 
            writeUTFBytes(view, 8, 'WAVE');

            // format chunk identifier 
            // FMT sub-chunk
            writeUTFBytes(view, 12, 'fmt ');

            // format chunk length 
            view.setUint32(16, 16, true);

            // sample format (raw)
            view.setUint16(20, 1, true);

            // stereo (2 channels)
            view.setUint16(22, numberOfAudioChannels, true);

            // sample rate 
            view.setUint32(24, sampleRate, true);

            // byte rate (sample rate * block align)
            view.setUint32(28, sampleRate * 2, true);

            // block align (channel count * bytes per sample) 
            view.setUint16(32, numberOfAudioChannels * 2, true);

            // bits per sample 
            view.setUint16(34, 16, true);

            // data sub-chunk
            // data chunk identifier 
            writeUTFBytes(view, 36, 'data');

            // data chunk length 
            view.setUint32(40, interleavedLength * 2, true);

            // write the PCM samples
            var lng = interleavedLength;
            var index = 44;
            var volume = 1;
            for (var i = 0; i < lng; i++) {
                view.setInt16(index, interleaved[i] * (0x7FFF * volume), true);
                index += 2;
            }

            if (cb) {
                return cb({
                    buffer: buffer,
                    view: view
                });
            }

            postMessage({
                buffer: buffer,
                view: view
            });
        }

        if (config.noWorker) {
            mergeAudioBuffers(config, function(data) {
                callback(data.buffer, data.view);
            });
            return;
        }


        var webWorker = processInWebWorker(mergeAudioBuffers);

        webWorker.onmessage = function(event) {
            callback(event.data.buffer, event.data.view);

            // release memory
            URL.revokeObjectURL(webWorker.workerURL);

            // kill webworker (or Chrome will kill your page after ~25 calls)
            webWorker.terminate();
        };

        webWorker.postMessage(config);
    }

    function processInWebWorker(_function) {
        var workerURL = URL.createObjectURL(new Blob([_function.toString(),
            ';this.onmessage =  function (eee) {' + _function.name + '(eee.data);}'
        ], {
            type: 'application/javascript'
        }));

        var worker = new Worker(workerURL);
        worker.workerURL = workerURL;
        return worker;
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        // stop recording
        recording = false;

        mergeLeftRightBuffers({
            desiredSampRate: desiredSampRate,
            sampleRate: sampleRate,
            numberOfAudioChannels: numberOfAudioChannels,
            internalInterleavedLength: recordingLength,
            leftBuffers: leftchannel,
            rightBuffers: numberOfAudioChannels === 1 ? [] : rightchannel,
            noWorker: config.noWorker
        }, function(buffer, view) {
            /**
             * @property {Blob} blob - The recorded blob object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var blob = recorder.blob;
             * });
             */
            self.blob = new Blob([view], {
                type: 'audio/wav'
            });

            /**
             * @property {ArrayBuffer} buffer - The recorded buffer object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var buffer = recorder.buffer;
             * });
             */
            self.buffer = new ArrayBuffer(view.buffer.byteLength);

            /**
             * @property {DataView} view - The recorded data-view object.
             * @memberof StereoAudioRecorder
             * @example
             * recorder.stop(function(){
             *     var view = recorder.view;
             * });
             */
            self.view = view;

            self.sampleRate = desiredSampRate || sampleRate;
            self.bufferSize = bufferSize;

            // recorded audio length
            self.length = recordingLength;

            isAudioProcessStarted = false;

            if (callback) {
                callback(self.blob);
            }
        });
    };

    if (typeof Storage === 'undefined') {
        var Storage = {
            AudioContextConstructor: null,
            AudioContext: window.AudioContext || window.webkitAudioContext
        };
    }

    if (!Storage.AudioContextConstructor) {
        Storage.AudioContextConstructor = new Storage.AudioContext();
    }

    var context = Storage.AudioContextConstructor;

    // creates an audio node from the microphone incoming stream
    var audioInput = context.createMediaStreamSource(mediaStream);

    var legalBufferValues = [0, 256, 512, 1024, 2048, 4096, 8192, 16384];

    /**
     * From the spec: This value controls how frequently the audioprocess event is
     * dispatched and how many sample-frames need to be processed each call.
     * Lower values for buffer size will result in a lower (better) latency.
     * Higher values will be necessary to avoid audio breakup and glitches
     * The size of the buffer (in sample-frames) which needs to
     * be processed each time onprocessaudio is called.
     * Legal values are (256, 512, 1024, 2048, 4096, 8192, 16384).
     * @property {number} bufferSize - Buffer-size for how frequently the audioprocess event is dispatched.
     * @memberof StereoAudioRecorder
     * @example
     * recorder = new StereoAudioRecorder(mediaStream, {
     *     bufferSize: 4096
     * });
     */

    // "0" means, let chrome decide the most accurate buffer-size for current platform.
    var bufferSize = typeof config.bufferSize === 'undefined' ? 4096 : config.bufferSize;

    if (legalBufferValues.indexOf(bufferSize) === -1) {
        if (!config.disableLogs) {
            console.log('Legal values for buffer-size are ' + JSON.stringify(legalBufferValues, null, '\t'));
        }
    }

    if (context.createJavaScriptNode) {
        jsAudioNode = context.createJavaScriptNode(bufferSize, numberOfAudioChannels, numberOfAudioChannels);
    } else if (context.createScriptProcessor) {
        jsAudioNode = context.createScriptProcessor(bufferSize, numberOfAudioChannels, numberOfAudioChannels);
    } else {
        throw 'WebAudio API has no support on this browser.';
    }

    // connect the stream to the script processor
    audioInput.connect(jsAudioNode);

    if (!config.bufferSize) {
        bufferSize = jsAudioNode.bufferSize; // device buffer-size
    }

    /**
     * The sample rate (in sample-frames per second) at which the
     * AudioContext handles audio. It is assumed that all AudioNodes
     * in the context run at this rate. In making this assumption,
     * sample-rate converters or "varispeed" processors are not supported
     * in real-time processing.
     * The sampleRate parameter describes the sample-rate of the
     * linear PCM audio data in the buffer in sample-frames per second.
     * An implementation must support sample-rates in at least
     * the range 22050 to 96000.
     * @property {number} sampleRate - Buffer-size for how frequently the audioprocess event is dispatched.
     * @memberof StereoAudioRecorder
     * @example
     * recorder = new StereoAudioRecorder(mediaStream, {
     *     sampleRate: 44100
     * });
     */
    var sampleRate = typeof config.sampleRate !== 'undefined' ? config.sampleRate : context.sampleRate || 44100;

    if (sampleRate < 22050 || sampleRate > 96000) {
        // Ref: http://stackoverflow.com/a/26303918/552182
        if (!config.disableLogs) {
            console.log('sample-rate must be under range 22050 and 96000.');
        }
    }

    if (!config.disableLogs) {
        if (config.desiredSampRate) {
            console.log('Desired sample-rate: ' + config.desiredSampRate);
        }
    }

    var isPaused = false;
    /**
     * This method pauses the recording process.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPaused = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (isMediaStreamActive() === false) {
            throw 'Please make sure MediaStream is active.';
        }

        if (!recording) {
            if (!config.disableLogs) {
                console.log('Seems recording has been restarted.');
            }
            this.record();
            return;
        }

        isPaused = false;
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof StereoAudioRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        config.checkForInactiveTracks = false;

        if (recording) {
            this.stop(clearRecordedDataCB);
        }

        clearRecordedDataCB();
    };

    function resetVariables() {
        leftchannel = [];
        rightchannel = [];
        recordingLength = 0;
        isAudioProcessStarted = false;
        recording = false;
        isPaused = false;
        context = null;

        self.leftchannel = leftchannel;
        self.rightchannel = rightchannel;
        self.numberOfAudioChannels = numberOfAudioChannels;
        self.desiredSampRate = desiredSampRate;
        self.sampleRate = sampleRate;
        self.recordingLength = recordingLength;

        intervalsBasedBuffers = {
            left: [],
            right: [],
            recordingLength: 0
        };
    }

    function clearRecordedDataCB() {
        if (jsAudioNode) {
            jsAudioNode.onaudioprocess = null;
            jsAudioNode.disconnect();
            jsAudioNode = null;
        }

        if (audioInput) {
            audioInput.disconnect();
            audioInput = null;
        }

        resetVariables();
    }

    // for debugging
    this.name = 'StereoAudioRecorder';
    this.toString = function() {
        return this.name;
    };

    var isAudioProcessStarted = false;

    function onAudioProcessDataAvailable(e) {
        if (isPaused) {
            return;
        }

        if (isMediaStreamActive() === false) {
            if (!config.disableLogs) {
                console.log('MediaStream seems stopped.');
            }
            jsAudioNode.disconnect();
            recording = false;
        }

        if (!recording) {
            if (audioInput) {
                audioInput.disconnect();
                audioInput = null;
            }
            return;
        }

        /**
         * This method is called on "onaudioprocess" event's first invocation.
         * @method {function} onAudioProcessStarted
         * @memberof StereoAudioRecorder
         * @example
         * recorder.onAudioProcessStarted: function() { };
         */
        if (!isAudioProcessStarted) {
            isAudioProcessStarted = true;
            if (config.onAudioProcessStarted) {
                config.onAudioProcessStarted();
            }

            if (config.initCallback) {
                config.initCallback();
            }
        }

        var left = e.inputBuffer.getChannelData(0);

        // we clone the samples
        var chLeft = new Float32Array(left);
        leftchannel.push(chLeft);

        if (numberOfAudioChannels === 2) {
            var right = e.inputBuffer.getChannelData(1);
            var chRight = new Float32Array(right);
            rightchannel.push(chRight);
        }

        recordingLength += bufferSize;

        // export raw PCM
        self.recordingLength = recordingLength;

        if (typeof config.timeSlice !== 'undefined') {
            intervalsBasedBuffers.recordingLength += bufferSize;
            intervalsBasedBuffers.left.push(chLeft);

            if (numberOfAudioChannels === 2) {
                intervalsBasedBuffers.right.push(chRight);
            }
        }
    }

    jsAudioNode.onaudioprocess = onAudioProcessDataAvailable;

    // to prevent self audio to be connected with speakers
    if (context.createMediaStreamDestination) {
        jsAudioNode.connect(context.createMediaStreamDestination());
    } else {
        jsAudioNode.connect(context.destination);
    }

    // export raw PCM
    this.leftchannel = leftchannel;
    this.rightchannel = rightchannel;
    this.numberOfAudioChannels = numberOfAudioChannels;
    this.desiredSampRate = desiredSampRate;
    this.sampleRate = sampleRate;
    self.recordingLength = recordingLength;

    // helper for intervals based blobs
    var intervalsBasedBuffers = {
        left: [],
        right: [],
        recordingLength: 0
    };

    // this looper is used to support intervals based blobs (via timeSlice+ondataavailable)
    function looper() {
        if (!recording || typeof config.ondataavailable !== 'function' || typeof config.timeSlice === 'undefined') {
            return;
        }

        if (intervalsBasedBuffers.left.length) {
            mergeLeftRightBuffers({
                desiredSampRate: desiredSampRate,
                sampleRate: sampleRate,
                numberOfAudioChannels: numberOfAudioChannels,
                internalInterleavedLength: intervalsBasedBuffers.recordingLength,
                leftBuffers: intervalsBasedBuffers.left,
                rightBuffers: numberOfAudioChannels === 1 ? [] : intervalsBasedBuffers.right
            }, function(buffer, view) {
                var blob = new Blob([view], {
                    type: 'audio/wav'
                });
                config.ondataavailable(blob);

                setTimeout(looper, config.timeSlice);
            });

            intervalsBasedBuffers = {
                left: [],
                right: [],
                recordingLength: 0
            };
        } else {
            setTimeout(looper, config.timeSlice);
        }
    }
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.StereoAudioRecorder = StereoAudioRecorder;
}

// _________________
// CanvasRecorder.js

/**
 * CanvasRecorder is a standalone class used by {@link RecordRTC} to bring HTML5-Canvas recording into video WebM. It uses HTML2Canvas library and runs top over {@link Whammy}.
 * @summary HTML2Canvas recording into video WebM.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef CanvasRecorder
 * @class
 * @example
 * var recorder = new CanvasRecorder(htmlElement, { disableLogs: true, useWhammyRecorder: true });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {HTMLElement} htmlElement - querySelector/getElementById/getElementsByTagName[0]/etc.
 * @param {object} config - {disableLogs:true, initCallback: function}
 */

function CanvasRecorder(htmlElement, config) {
    if (typeof html2canvas === 'undefined') {
        throw 'Please link: https://cdn.webrtc-experiment.com/screenshot.js';
    }

    config = config || {};
    if (!config.frameInterval) {
        config.frameInterval = 10;
    }

    // via DetectRTC.js
    var isCanvasSupportsStreamCapturing = false;
    ['captureStream', 'mozCaptureStream', 'webkitCaptureStream'].forEach(function(item) {
        if (item in document.createElement('canvas')) {
            isCanvasSupportsStreamCapturing = true;
        }
    });

    var _isChrome = (!!window.webkitRTCPeerConnection || !!window.webkitGetUserMedia) && !!window.chrome;

    var chromeVersion = 50;
    var matchArray = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (_isChrome && matchArray && matchArray[2]) {
        chromeVersion = parseInt(matchArray[2], 10);
    }

    if (_isChrome && chromeVersion < 52) {
        isCanvasSupportsStreamCapturing = false;
    }

    if (config.useWhammyRecorder) {
        isCanvasSupportsStreamCapturing = false;
    }

    var globalCanvas, mediaStreamRecorder;

    if (isCanvasSupportsStreamCapturing) {
        if (!config.disableLogs) {
            console.log('Your browser supports both MediRecorder API and canvas.captureStream!');
        }

        if (htmlElement instanceof HTMLCanvasElement) {
            globalCanvas = htmlElement;
        } else if (htmlElement instanceof CanvasRenderingContext2D) {
            globalCanvas = htmlElement.canvas;
        } else {
            throw 'Please pass either HTMLCanvasElement or CanvasRenderingContext2D.';
        }
    } else if (!!navigator.mozGetUserMedia) {
        if (!config.disableLogs) {
            console.error('Canvas recording is NOT supported in Firefox.');
        }
    }

    var isRecording;

    /**
     * This method records Canvas.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        isRecording = true;

        if (isCanvasSupportsStreamCapturing && !config.useWhammyRecorder) {
            // CanvasCaptureMediaStream
            var canvasMediaStream;
            if ('captureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.captureStream(25); // 25 FPS
            } else if ('mozCaptureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.mozCaptureStream(25);
            } else if ('webkitCaptureStream' in globalCanvas) {
                canvasMediaStream = globalCanvas.webkitCaptureStream(25);
            }

            try {
                var mdStream = new MediaStream();
                mdStream.addTrack(canvasMediaStream.getVideoTracks()[0]);
                canvasMediaStream = mdStream;
            } catch (e) {}

            if (!canvasMediaStream) {
                throw 'captureStream API are NOT available.';
            }

            // Note: Jan 18, 2016 status is that, 
            // Firefox MediaRecorder API can't record CanvasCaptureMediaStream object.
            mediaStreamRecorder = new MediaStreamRecorder(canvasMediaStream, {
                mimeType: config.mimeType || 'video/webm'
            });
            mediaStreamRecorder.record();
        } else {
            whammy.frames = [];
            lastTime = new Date().getTime();
            drawCanvasFrame();
        }

        if (config.initCallback) {
            config.initCallback();
        }
    };

    this.getWebPImages = function(callback) {
        if (htmlElement.nodeName.toLowerCase() !== 'canvas') {
            callback();
            return;
        }

        var framesLength = whammy.frames.length;
        whammy.frames.forEach(function(frame, idx) {
            var framesRemaining = framesLength - idx;
            if (!config.disableLogs) {
                console.log(framesRemaining + '/' + framesLength + ' frames remaining');
            }

            if (config.onEncodingCallback) {
                config.onEncodingCallback(framesRemaining, framesLength);
            }

            var webp = frame.image.toDataURL('image/webp', 1);
            whammy.frames[idx].image = webp;
        });

        if (!config.disableLogs) {
            console.log('Generating WebM');
        }

        callback();
    };

    /**
     * This method stops recording Canvas.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        isRecording = false;

        var that = this;

        if (isCanvasSupportsStreamCapturing && mediaStreamRecorder) {
            mediaStreamRecorder.stop(callback);
            return;
        }

        this.getWebPImages(function() {
            /**
             * @property {Blob} blob - Recorded frames in video/webm blob.
             * @memberof CanvasRecorder
             * @example
             * recorder.stop(function() {
             *     var blob = recorder.blob;
             * });
             */
            whammy.compile(function(blob) {
                if (!config.disableLogs) {
                    console.log('Recording finished!');
                }

                that.blob = blob;

                if (that.blob.forEach) {
                    that.blob = new Blob([], {
                        type: 'video/webm'
                    });
                }

                if (callback) {
                    callback(that.blob);
                }

                whammy.frames = [];
            });
        });
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;

        if (mediaStreamRecorder instanceof MediaStreamRecorder) {
            mediaStreamRecorder.pause();
            return;
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;

        if (mediaStreamRecorder instanceof MediaStreamRecorder) {
            mediaStreamRecorder.resume();
            return;
        }

        if (!isRecording) {
            this.record();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof CanvasRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (isRecording) {
            this.stop(clearRecordedDataCB);
        }
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        whammy.frames = [];
        isRecording = false;
        isPausedRecording = false;
    }

    // for debugging
    this.name = 'CanvasRecorder';
    this.toString = function() {
        return this.name;
    };

    function cloneCanvas() {
        //create a new canvas
        var newCanvas = document.createElement('canvas');
        var context = newCanvas.getContext('2d');

        //set dimensions
        newCanvas.width = htmlElement.width;
        newCanvas.height = htmlElement.height;

        //apply the old canvas to the new one
        context.drawImage(htmlElement, 0, 0);

        //return the new canvas
        return newCanvas;
    }

    function drawCanvasFrame() {
        if (isPausedRecording) {
            lastTime = new Date().getTime();
            return setTimeout(drawCanvasFrame, 500);
        }

        if (htmlElement.nodeName.toLowerCase() === 'canvas') {
            var duration = new Date().getTime() - lastTime;
            // via #206, by Jack i.e. @Seymourr
            lastTime = new Date().getTime();

            whammy.frames.push({
                image: cloneCanvas(),
                duration: duration
            });

            if (isRecording) {
                setTimeout(drawCanvasFrame, config.frameInterval);
            }
            return;
        }

        html2canvas(htmlElement, {
            grabMouse: typeof config.showMousePointer === 'undefined' || config.showMousePointer,
            onrendered: function(canvas) {
                var duration = new Date().getTime() - lastTime;
                if (!duration) {
                    return setTimeout(drawCanvasFrame, config.frameInterval);
                }

                // via #206, by Jack i.e. @Seymourr
                lastTime = new Date().getTime();

                whammy.frames.push({
                    image: canvas.toDataURL('image/webp', 1),
                    duration: duration
                });

                if (isRecording) {
                    setTimeout(drawCanvasFrame, config.frameInterval);
                }
            }
        });
    }

    var lastTime = new Date().getTime();

    var whammy = new Whammy.Video(100);
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.CanvasRecorder = CanvasRecorder;
}

// _________________
// WhammyRecorder.js

/**
 * WhammyRecorder is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It runs top over {@link Whammy}.
 * @summary Video recording feature in Chrome.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef WhammyRecorder
 * @class
 * @example
 * var recorder = new WhammyRecorder(mediaStream);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object fetched using getUserMedia API or generated using captureStreamUntilEnded or WebAudio API.
 * @param {object} config - {disableLogs: true, initCallback: function, video: HTMLVideoElement, etc.}
 */

function WhammyRecorder(mediaStream, config) {

    config = config || {};

    if (!config.frameInterval) {
        config.frameInterval = 10;
    }

    if (!config.disableLogs) {
        console.log('Using frames-interval:', config.frameInterval);
    }

    /**
     * This method records video.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (!config.width) {
            config.width = 320;
        }

        if (!config.height) {
            config.height = 240;
        }

        if (!config.video) {
            config.video = {
                width: config.width,
                height: config.height
            };
        }

        if (!config.canvas) {
            config.canvas = {
                width: config.width,
                height: config.height
            };
        }

        canvas.width = config.canvas.width || 320;
        canvas.height = config.canvas.height || 240;

        context = canvas.getContext('2d');

        // setting defaults
        if (config.video && config.video instanceof HTMLVideoElement) {
            video = config.video.cloneNode();

            if (config.initCallback) {
                config.initCallback();
            }
        } else {
            video = document.createElement('video');

            setSrcObject(mediaStream, video);

            video.onloadedmetadata = function() { // "onloadedmetadata" may NOT work in FF?
                if (config.initCallback) {
                    config.initCallback();
                }
            };

            video.width = config.video.width;
            video.height = config.video.height;
        }

        video.muted = true;
        video.play();

        lastTime = new Date().getTime();
        whammy = new Whammy.Video();

        if (!config.disableLogs) {
            console.log('canvas resolutions', canvas.width, '*', canvas.height);
            console.log('video width/height', video.width || canvas.width, '*', video.height || canvas.height);
        }

        drawFrames(config.frameInterval);
    };

    /**
     * Draw and push frames to Whammy
     * @param {integer} frameInterval - set minimum interval (in milliseconds) between each time we push a frame to Whammy
     */
    function drawFrames(frameInterval) {
        frameInterval = typeof frameInterval !== 'undefined' ? frameInterval : 10;

        var duration = new Date().getTime() - lastTime;
        if (!duration) {
            return setTimeout(drawFrames, frameInterval, frameInterval);
        }

        if (isPausedRecording) {
            lastTime = new Date().getTime();
            return setTimeout(drawFrames, 100);
        }

        // via #206, by Jack i.e. @Seymourr
        lastTime = new Date().getTime();

        if (video.paused) {
            // via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
            // Tweak for Android Chrome
            video.play();
        }

        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        whammy.frames.push({
            duration: duration,
            image: canvas.toDataURL('image/webp')
        });

        if (!isStopDrawing) {
            setTimeout(drawFrames, frameInterval, frameInterval);
        }
    }

    function asyncLoop(o) {
        var i = -1,
            length = o.length;

        (function loop() {
            i++;
            if (i === length) {
                o.callback();
                return;
            }

            // "setTimeout" added by Jim McLeod
            setTimeout(function() {
                o.functionToLoop(loop, i);
            }, 1);
        })();
    }


    /**
     * remove black frames from the beginning to the specified frame
     * @param {Array} _frames - array of frames to be checked
     * @param {number} _framesToCheck - number of frame until check will be executed (-1 - will drop all frames until frame not matched will be found)
     * @param {number} _pixTolerance - 0 - very strict (only black pixel color) ; 1 - all
     * @param {number} _frameTolerance - 0 - very strict (only black frame color) ; 1 - all
     * @returns {Array} - array of frames
     */
    // pull#293 by @volodalexey
    function dropBlackFrames(_frames, _framesToCheck, _pixTolerance, _frameTolerance, callback) {
        var localCanvas = document.createElement('canvas');
        localCanvas.width = canvas.width;
        localCanvas.height = canvas.height;
        var context2d = localCanvas.getContext('2d');
        var resultFrames = [];

        var checkUntilNotBlack = _framesToCheck === -1;
        var endCheckFrame = (_framesToCheck && _framesToCheck > 0 && _framesToCheck <= _frames.length) ?
            _framesToCheck : _frames.length;
        var sampleColor = {
            r: 0,
            g: 0,
            b: 0
        };
        var maxColorDifference = Math.sqrt(
            Math.pow(255, 2) +
            Math.pow(255, 2) +
            Math.pow(255, 2)
        );
        var pixTolerance = _pixTolerance && _pixTolerance >= 0 && _pixTolerance <= 1 ? _pixTolerance : 0;
        var frameTolerance = _frameTolerance && _frameTolerance >= 0 && _frameTolerance <= 1 ? _frameTolerance : 0;
        var doNotCheckNext = false;

        asyncLoop({
            length: endCheckFrame,
            functionToLoop: function(loop, f) {
                var matchPixCount, endPixCheck, maxPixCount;

                var finishImage = function() {
                    if (!doNotCheckNext && maxPixCount - matchPixCount <= maxPixCount * frameTolerance) {
                        // console.log('removed black frame : ' + f + ' ; frame duration ' + _frames[f].duration);
                    } else {
                        // console.log('frame is passed : ' + f);
                        if (checkUntilNotBlack) {
                            doNotCheckNext = true;
                        }
                        resultFrames.push(_frames[f]);
                    }
                    loop();
                };

                if (!doNotCheckNext) {
                    var image = new Image();
                    image.onload = function() {
                        context2d.drawImage(image, 0, 0, canvas.width, canvas.height);
                        var imageData = context2d.getImageData(0, 0, canvas.width, canvas.height);
                        matchPixCount = 0;
                        endPixCheck = imageData.data.length;
                        maxPixCount = imageData.data.length / 4;

                        for (var pix = 0; pix < endPixCheck; pix += 4) {
                            var currentColor = {
                                r: imageData.data[pix],
                                g: imageData.data[pix + 1],
                                b: imageData.data[pix + 2]
                            };
                            var colorDifference = Math.sqrt(
                                Math.pow(currentColor.r - sampleColor.r, 2) +
                                Math.pow(currentColor.g - sampleColor.g, 2) +
                                Math.pow(currentColor.b - sampleColor.b, 2)
                            );
                            // difference in color it is difference in color vectors (r1,g1,b1) <=> (r2,g2,b2)
                            if (colorDifference <= maxColorDifference * pixTolerance) {
                                matchPixCount++;
                            }
                        }
                        finishImage();
                    };
                    image.src = _frames[f].image;
                } else {
                    finishImage();
                }
            },
            callback: function() {
                resultFrames = resultFrames.concat(_frames.slice(endCheckFrame));

                if (resultFrames.length <= 0) {
                    // at least one last frame should be available for next manipulation
                    // if total duration of all frames will be < 1000 than ffmpeg doesn't work well...
                    resultFrames.push(_frames[_frames.length - 1]);
                }
                callback(resultFrames);
            }
        });
    }

    var isStopDrawing = false;

    /**
     * This method stops recording video.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        isStopDrawing = true;

        var _this = this;
        // analyse of all frames takes some time!
        setTimeout(function() {
            // e.g. dropBlackFrames(frames, 10, 1, 1) - will cut all 10 frames
            // e.g. dropBlackFrames(frames, 10, 0.5, 0.5) - will analyse 10 frames
            // e.g. dropBlackFrames(frames, 10) === dropBlackFrames(frames, 10, 0, 0) - will analyse 10 frames with strict black color
            dropBlackFrames(whammy.frames, -1, null, null, function(frames) {
                whammy.frames = frames;

                // to display advertisement images!
                if (config.advertisement && config.advertisement.length) {
                    whammy.frames = config.advertisement.concat(whammy.frames);
                }

                /**
                 * @property {Blob} blob - Recorded frames in video/webm blob.
                 * @memberof WhammyRecorder
                 * @example
                 * recorder.stop(function() {
                 *     var blob = recorder.blob;
                 * });
                 */
                whammy.compile(function(blob) {
                    _this.blob = blob;

                    if (_this.blob.forEach) {
                        _this.blob = new Blob([], {
                            type: 'video/webm'
                        });
                    }

                    if (callback) {
                        callback(_this.blob);
                    }
                });
            });
        }, 10);
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;

        if (isStopDrawing) {
            this.record();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof WhammyRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (!isStopDrawing) {
            this.stop(clearRecordedDataCB);
        }
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        whammy.frames = [];
        isStopDrawing = true;
        isPausedRecording = false;
    }

    // for debugging
    this.name = 'WhammyRecorder';
    this.toString = function() {
        return this.name;
    };

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    var video;
    var lastTime;
    var whammy;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.WhammyRecorder = WhammyRecorder;
}

// https://github.com/antimatter15/whammy/blob/master/LICENSE
// _________
// Whammy.js

// todo: Firefox now supports webp for webm containers!
// their MediaRecorder implementation works well!
// should we provide an option to record via Whammy.js or MediaRecorder API is a better solution?

/**
 * Whammy is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It is written by {@link https://github.com/antimatter15|antimatter15}
 * @summary A real time javascript webm encoder based on a canvas hack.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef Whammy
 * @class
 * @example
 * var recorder = new Whammy().Video(15);
 * recorder.add(context || canvas || dataURL);
 * var output = recorder.compile();
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */

var Whammy = (function() {
    // a more abstract-ish API

    function WhammyVideo(duration) {
        this.frames = [];
        this.duration = duration || 1;
        this.quality = 0.8;
    }

    /**
     * Pass Canvas or Context or image/webp(string) to {@link Whammy} encoder.
     * @method
     * @memberof Whammy
     * @example
     * recorder = new Whammy().Video(0.8, 100);
     * recorder.add(canvas || context || 'image/webp');
     * @param {string} frame - Canvas || Context || image/webp
     * @param {number} duration - Stick a duration (in milliseconds)
     */
    WhammyVideo.prototype.add = function(frame, duration) {
        if ('canvas' in frame) { //CanvasRenderingContext2D
            frame = frame.canvas;
        }

        if ('toDataURL' in frame) {
            frame = frame.toDataURL('image/webp', this.quality);
        }

        if (!(/^data:image\/webp;base64,/ig).test(frame)) {
            throw 'Input must be formatted properly as a base64 encoded DataURI of type image/webp';
        }
        this.frames.push({
            image: frame,
            duration: duration || this.duration
        });
    };

    function processInWebWorker(_function) {
        var blob = URL.createObjectURL(new Blob([_function.toString(),
            'this.onmessage =  function (eee) {' + _function.name + '(eee.data);}'
        ], {
            type: 'application/javascript'
        }));

        var worker = new Worker(blob);
        URL.revokeObjectURL(blob);
        return worker;
    }

    function whammyInWebWorker(frames) {
        function ArrayToWebM(frames) {
            var info = checkFrames(frames);
            if (!info) {
                return [];
            }

            var clusterMaxDuration = 30000;

            var EBML = [{
                'id': 0x1a45dfa3, // EBML
                'data': [{
                    'data': 1,
                    'id': 0x4286 // EBMLVersion
                }, {
                    'data': 1,
                    'id': 0x42f7 // EBMLReadVersion
                }, {
                    'data': 4,
                    'id': 0x42f2 // EBMLMaxIDLength
                }, {
                    'data': 8,
                    'id': 0x42f3 // EBMLMaxSizeLength
                }, {
                    'data': 'webm',
                    'id': 0x4282 // DocType
                }, {
                    'data': 2,
                    'id': 0x4287 // DocTypeVersion
                }, {
                    'data': 2,
                    'id': 0x4285 // DocTypeReadVersion
                }]
            }, {
                'id': 0x18538067, // Segment
                'data': [{
                    'id': 0x1549a966, // Info
                    'data': [{
                        'data': 1e6, //do things in millisecs (num of nanosecs for duration scale)
                        'id': 0x2ad7b1 // TimecodeScale
                    }, {
                        'data': 'whammy',
                        'id': 0x4d80 // MuxingApp
                    }, {
                        'data': 'whammy',
                        'id': 0x5741 // WritingApp
                    }, {
                        'data': doubleToString(info.duration),
                        'id': 0x4489 // Duration
                    }]
                }, {
                    'id': 0x1654ae6b, // Tracks
                    'data': [{
                        'id': 0xae, // TrackEntry
                        'data': [{
                            'data': 1,
                            'id': 0xd7 // TrackNumber
                        }, {
                            'data': 1,
                            'id': 0x73c5 // TrackUID
                        }, {
                            'data': 0,
                            'id': 0x9c // FlagLacing
                        }, {
                            'data': 'und',
                            'id': 0x22b59c // Language
                        }, {
                            'data': 'V_VP8',
                            'id': 0x86 // CodecID
                        }, {
                            'data': 'VP8',
                            'id': 0x258688 // CodecName
                        }, {
                            'data': 1,
                            'id': 0x83 // TrackType
                        }, {
                            'id': 0xe0, // Video
                            'data': [{
                                'data': info.width,
                                'id': 0xb0 // PixelWidth
                            }, {
                                'data': info.height,
                                'id': 0xba // PixelHeight
                            }]
                        }]
                    }]
                }]
            }];

            //Generate clusters (max duration)
            var frameNumber = 0;
            var clusterTimecode = 0;
            while (frameNumber < frames.length) {

                var clusterFrames = [];
                var clusterDuration = 0;
                do {
                    clusterFrames.push(frames[frameNumber]);
                    clusterDuration += frames[frameNumber].duration;
                    frameNumber++;
                } while (frameNumber < frames.length && clusterDuration < clusterMaxDuration);

                var clusterCounter = 0;
                var cluster = {
                    'id': 0x1f43b675, // Cluster
                    'data': getClusterData(clusterTimecode, clusterCounter, clusterFrames)
                }; //Add cluster to segment
                EBML[1].data.push(cluster);
                clusterTimecode += clusterDuration;
            }

            return generateEBML(EBML);
        }

        function getClusterData(clusterTimecode, clusterCounter, clusterFrames) {
            return [{
                'data': clusterTimecode,
                'id': 0xe7 // Timecode
            }].concat(clusterFrames.map(function(webp) {
                var block = makeSimpleBlock({
                    discardable: 0,
                    frame: webp.data.slice(4),
                    invisible: 0,
                    keyframe: 1,
                    lacing: 0,
                    trackNum: 1,
                    timecode: Math.round(clusterCounter)
                });
                clusterCounter += webp.duration;
                return {
                    data: block,
                    id: 0xa3
                };
            }));
        }

        // sums the lengths of all the frames and gets the duration

        function checkFrames(frames) {
            if (!frames[0]) {
                postMessage({
                    error: 'Something went wrong. Maybe WebP format is not supported in the current browser.'
                });
                return;
            }

            var width = frames[0].width,
                height = frames[0].height,
                duration = frames[0].duration;

            for (var i = 1; i < frames.length; i++) {
                duration += frames[i].duration;
            }
            return {
                duration: duration,
                width: width,
                height: height
            };
        }

        function numToBuffer(num) {
            var parts = [];
            while (num > 0) {
                parts.push(num & 0xff);
                num = num >> 8;
            }
            return new Uint8Array(parts.reverse());
        }

        function strToBuffer(str) {
            return new Uint8Array(str.split('').map(function(e) {
                return e.charCodeAt(0);
            }));
        }

        function bitsToBuffer(bits) {
            var data = [];
            var pad = (bits.length % 8) ? (new Array(1 + 8 - (bits.length % 8))).join('0') : '';
            bits = pad + bits;
            for (var i = 0; i < bits.length; i += 8) {
                data.push(parseInt(bits.substr(i, 8), 2));
            }
            return new Uint8Array(data);
        }

        function generateEBML(json) {
            var ebml = [];
            for (var i = 0; i < json.length; i++) {
                var data = json[i].data;

                if (typeof data === 'object') {
                    data = generateEBML(data);
                }

                if (typeof data === 'number') {
                    data = bitsToBuffer(data.toString(2));
                }

                if (typeof data === 'string') {
                    data = strToBuffer(data);
                }

                var len = data.size || data.byteLength || data.length;
                var zeroes = Math.ceil(Math.ceil(Math.log(len) / Math.log(2)) / 8);
                var sizeToString = len.toString(2);
                var padded = (new Array((zeroes * 7 + 7 + 1) - sizeToString.length)).join('0') + sizeToString;
                var size = (new Array(zeroes)).join('0') + '1' + padded;

                ebml.push(numToBuffer(json[i].id));
                ebml.push(bitsToBuffer(size));
                ebml.push(data);
            }

            return new Blob(ebml, {
                type: 'video/webm'
            });
        }

        function toBinStrOld(bits) {
            var data = '';
            var pad = (bits.length % 8) ? (new Array(1 + 8 - (bits.length % 8))).join('0') : '';
            bits = pad + bits;
            for (var i = 0; i < bits.length; i += 8) {
                data += String.fromCharCode(parseInt(bits.substr(i, 8), 2));
            }
            return data;
        }

        function makeSimpleBlock(data) {
            var flags = 0;

            if (data.keyframe) {
                flags |= 128;
            }

            if (data.invisible) {
                flags |= 8;
            }

            if (data.lacing) {
                flags |= (data.lacing << 1);
            }

            if (data.discardable) {
                flags |= 1;
            }

            if (data.trackNum > 127) {
                throw 'TrackNumber > 127 not supported';
            }

            var out = [data.trackNum | 0x80, data.timecode >> 8, data.timecode & 0xff, flags].map(function(e) {
                return String.fromCharCode(e);
            }).join('') + data.frame;

            return out;
        }

        function parseWebP(riff) {
            var VP8 = riff.RIFF[0].WEBP[0];

            var frameStart = VP8.indexOf('\x9d\x01\x2a'); // A VP8 keyframe starts with the 0x9d012a header
            for (var i = 0, c = []; i < 4; i++) {
                c[i] = VP8.charCodeAt(frameStart + 3 + i);
            }

            var width, height, tmp;

            //the code below is literally copied verbatim from the bitstream spec
            tmp = (c[1] << 8) | c[0];
            width = tmp & 0x3FFF;
            tmp = (c[3] << 8) | c[2];
            height = tmp & 0x3FFF;
            return {
                width: width,
                height: height,
                data: VP8,
                riff: riff
            };
        }

        function getStrLength(string, offset) {
            return parseInt(string.substr(offset + 4, 4).split('').map(function(i) {
                var unpadded = i.charCodeAt(0).toString(2);
                return (new Array(8 - unpadded.length + 1)).join('0') + unpadded;
            }).join(''), 2);
        }

        function parseRIFF(string) {
            var offset = 0;
            var chunks = {};

            while (offset < string.length) {
                var id = string.substr(offset, 4);
                var len = getStrLength(string, offset);
                var data = string.substr(offset + 4 + 4, len);
                offset += 4 + 4 + len;
                chunks[id] = chunks[id] || [];

                if (id === 'RIFF' || id === 'LIST') {
                    chunks[id].push(parseRIFF(data));
                } else {
                    chunks[id].push(data);
                }
            }
            return chunks;
        }

        function doubleToString(num) {
            return [].slice.call(
                new Uint8Array((new Float64Array([num])).buffer), 0).map(function(e) {
                return String.fromCharCode(e);
            }).reverse().join('');
        }

        var webm = new ArrayToWebM(frames.map(function(frame) {
            var webp = parseWebP(parseRIFF(atob(frame.image.slice(23))));
            webp.duration = frame.duration;
            return webp;
        }));

        postMessage(webm);
    }

    /**
     * Encodes frames in WebM container. It uses WebWorkinvoke to invoke 'ArrayToWebM' method.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof Whammy
     * @example
     * recorder = new Whammy().Video(0.8, 100);
     * recorder.compile(function(blob) {
     *    // blob.size - blob.type
     * });
     */
    WhammyVideo.prototype.compile = function(callback) {
        var webWorker = processInWebWorker(whammyInWebWorker);

        webWorker.onmessage = function(event) {
            if (event.data.error) {
                console.error(event.data.error);
                return;
            }
            callback(event.data);
        };

        webWorker.postMessage(this.frames);
    };

    return {
        /**
         * A more abstract-ish API.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * @param {?number} speed - 0.8
         * @param {?number} quality - 100
         */
        Video: WhammyVideo
    };
})();

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.Whammy = Whammy;
}

// ______________ (indexed-db)
// DiskStorage.js

/**
 * DiskStorage is a standalone object used by {@link RecordRTC} to store recorded blobs in IndexedDB storage.
 * @summary Writing blobs into IndexedDB.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @example
 * DiskStorage.Store({
 *     audioBlob: yourAudioBlob,
 *     videoBlob: yourVideoBlob,
 *     gifBlob  : yourGifBlob
 * });
 * DiskStorage.Fetch(function(dataURL, type) {
 *     if(type === 'audioBlob') { }
 *     if(type === 'videoBlob') { }
 *     if(type === 'gifBlob')   { }
 * });
 * // DiskStorage.dataStoreName = 'recordRTC';
 * // DiskStorage.onError = function(error) { };
 * @property {function} init - This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
 * @property {function} Fetch - This method fetches stored blobs from IndexedDB.
 * @property {function} Store - This method stores blobs in IndexedDB.
 * @property {function} onError - This function is invoked for any known/unknown error.
 * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 */


var DiskStorage = {
    /**
     * This method must be called once to initialize IndexedDB ObjectStore. Though, it is auto-used internally.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.init();
     */
    init: function() {
        var self = this;

        if (typeof indexedDB === 'undefined' || typeof indexedDB.open === 'undefined') {
            console.error('IndexedDB API are not available in this browser.');
            return;
        }

        var dbVersion = 1;
        var dbName = this.dbName || location.href.replace(/\/|:|#|%|\.|\[|\]/g, ''),
            db;
        var request = indexedDB.open(dbName, dbVersion);

        function createObjectStore(dataBase) {
            dataBase.createObjectStore(self.dataStoreName);
        }

        function putInDB() {
            var transaction = db.transaction([self.dataStoreName], 'readwrite');

            if (self.videoBlob) {
                transaction.objectStore(self.dataStoreName).put(self.videoBlob, 'videoBlob');
            }

            if (self.gifBlob) {
                transaction.objectStore(self.dataStoreName).put(self.gifBlob, 'gifBlob');
            }

            if (self.audioBlob) {
                transaction.objectStore(self.dataStoreName).put(self.audioBlob, 'audioBlob');
            }

            function getFromStore(portionName) {
                transaction.objectStore(self.dataStoreName).get(portionName).onsuccess = function(event) {
                    if (self.callback) {
                        self.callback(event.target.result, portionName);
                    }
                };
            }

            getFromStore('audioBlob');
            getFromStore('videoBlob');
            getFromStore('gifBlob');
        }

        request.onerror = self.onError;

        request.onsuccess = function() {
            db = request.result;
            db.onerror = self.onError;

            if (db.setVersion) {
                if (db.version !== dbVersion) {
                    var setVersion = db.setVersion(dbVersion);
                    setVersion.onsuccess = function() {
                        createObjectStore(db);
                        putInDB();
                    };
                } else {
                    putInDB();
                }
            } else {
                putInDB();
            }
        };
        request.onupgradeneeded = function(event) {
            createObjectStore(event.target.result);
        };
    },
    /**
     * This method fetches stored blobs from IndexedDB.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.Fetch(function(dataURL, type) {
     *     if(type === 'audioBlob') { }
     *     if(type === 'videoBlob') { }
     *     if(type === 'gifBlob')   { }
     * });
     */
    Fetch: function(callback) {
        this.callback = callback;
        this.init();

        return this;
    },
    /**
     * This method stores blobs in IndexedDB.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.Store({
     *     audioBlob: yourAudioBlob,
     *     videoBlob: yourVideoBlob,
     *     gifBlob  : yourGifBlob
     * });
     */
    Store: function(config) {
        this.audioBlob = config.audioBlob;
        this.videoBlob = config.videoBlob;
        this.gifBlob = config.gifBlob;

        this.init();

        return this;
    },
    /**
     * This function is invoked for any known/unknown error.
     * @method
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.onError = function(error){
     *     alerot( JSON.stringify(error) );
     * };
     */
    onError: function(error) {
        console.error(JSON.stringify(error, null, '\t'));
    },

    /**
     * @property {string} dataStoreName - Name of the ObjectStore created in IndexedDB storage.
     * @memberof DiskStorage
     * @internal
     * @example
     * DiskStorage.dataStoreName = 'recordRTC';
     */
    dataStoreName: 'recordRTC',
    dbName: null
};

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.DiskStorage = DiskStorage;
}

// ______________
// GifRecorder.js

/**
 * GifRecorder is standalone calss used by {@link RecordRTC} to record video or canvas into animated gif.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef GifRecorder
 * @class
 * @example
 * var recorder = new GifRecorder(mediaStream || canvas || context, { onGifPreview: function, onGifRecordingStarted: function, width: 1280, height: 720, frameRate: 200, quality: 10 });
 * recorder.record();
 * recorder.stop(function(blob) {
 *     img.src = URL.createObjectURL(blob);
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - MediaStream object or HTMLCanvasElement or CanvasRenderingContext2D.
 * @param {object} config - {disableLogs:true, initCallback: function, width: 320, height: 240, frameRate: 200, quality: 10}
 */

function GifRecorder(mediaStream, config) {
    if (typeof GIFEncoder === 'undefined') {
        var script = document.createElement('script');
        script.src = 'https://cdn.webrtc-experiment.com/gif-recorder.js';
        (document.body || document.documentElement).appendChild(script);
    }

    config = config || {};

    var isHTMLObject = mediaStream instanceof CanvasRenderingContext2D || mediaStream instanceof HTMLCanvasElement;

    /**
     * This method records MediaStream.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        if (typeof GIFEncoder === 'undefined') {
            setTimeout(self.record, 1000);
            return;
        }

        if (!isLoadedMetaData) {
            setTimeout(self.record, 1000);
            return;
        }

        if (!isHTMLObject) {
            if (!config.width) {
                config.width = video.offsetWidth || 320;
            }

            if (!config.height) {
                config.height = video.offsetHeight || 240;
            }

            if (!config.video) {
                config.video = {
                    width: config.width,
                    height: config.height
                };
            }

            if (!config.canvas) {
                config.canvas = {
                    width: config.width,
                    height: config.height
                };
            }

            canvas.width = config.canvas.width || 320;
            canvas.height = config.canvas.height || 240;

            video.width = config.video.width || 320;
            video.height = config.video.height || 240;
        }

        // external library to record as GIF images
        gifEncoder = new GIFEncoder();

        // void setRepeat(int iter) 
        // Sets the number of times the set of GIF frames should be played. 
        // Default is 1; 0 means play indefinitely.
        gifEncoder.setRepeat(0);

        // void setFrameRate(Number fps) 
        // Sets frame rate in frames per second. 
        // Equivalent to setDelay(1000/fps).
        // Using "setDelay" instead of "setFrameRate"
        gifEncoder.setDelay(config.frameRate || 200);

        // void setQuality(int quality) 
        // Sets quality of color quantization (conversion of images to the 
        // maximum 256 colors allowed by the GIF specification). 
        // Lower values (minimum = 1) produce better colors, 
        // but slow processing significantly. 10 is the default, 
        // and produces good color mapping at reasonable speeds. 
        // Values greater than 20 do not yield significant improvements in speed.
        gifEncoder.setQuality(config.quality || 10);

        // Boolean start() 
        // This writes the GIF Header and returns false if it fails.
        gifEncoder.start();

        if (typeof config.onGifRecordingStarted === 'function') {
            config.onGifRecordingStarted();
        }

        startTime = Date.now();

        function drawVideoFrame(time) {
            if (self.clearedRecordedData === true) {
                return;
            }

            if (isPausedRecording) {
                return setTimeout(function() {
                    drawVideoFrame(time);
                }, 100);
            }

            lastAnimationFrame = requestAnimationFrame(drawVideoFrame);

            if (typeof lastFrameTime === undefined) {
                lastFrameTime = time;
            }

            // ~10 fps
            if (time - lastFrameTime < 90) {
                return;
            }

            if (!isHTMLObject && video.paused) {
                // via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
                // Tweak for Android Chrome
                video.play();
            }

            if (!isHTMLObject) {
                context.drawImage(video, 0, 0, canvas.width, canvas.height);
            }

            if (config.onGifPreview) {
                config.onGifPreview(canvas.toDataURL('image/png'));
            }

            gifEncoder.addFrame(context);
            lastFrameTime = time;
        }

        lastAnimationFrame = requestAnimationFrame(drawVideoFrame);

        if (config.initCallback) {
            config.initCallback();
        }
    };

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.stop(function(blob) {
     *     img.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        callback = callback || function() {};

        if (lastAnimationFrame) {
            cancelAnimationFrame(lastAnimationFrame);
        }

        endTime = Date.now();

        /**
         * @property {Blob} blob - The recorded blob object.
         * @memberof GifRecorder
         * @example
         * recorder.stop(function(){
         *     var blob = recorder.blob;
         * });
         */
        this.blob = new Blob([new Uint8Array(gifEncoder.stream().bin)], {
            type: 'image/gif'
        });

        callback(this.blob);

        // bug: find a way to clear old recorded blobs
        gifEncoder.stream().bin = [];
    };

    var isPausedRecording = false;

    /**
     * This method pauses the recording process.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        isPausedRecording = true;
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        isPausedRecording = false;
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof GifRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        self.clearedRecordedData = true;
        clearRecordedDataCB();
    };

    function clearRecordedDataCB() {
        if (gifEncoder) {
            gifEncoder.stream().bin = [];
        }
    }

    // for debugging
    this.name = 'GifRecorder';
    this.toString = function() {
        return this.name;
    };

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');

    if (isHTMLObject) {
        if (mediaStream instanceof CanvasRenderingContext2D) {
            context = mediaStream;
            canvas = context.canvas;
        } else if (mediaStream instanceof HTMLCanvasElement) {
            context = mediaStream.getContext('2d');
            canvas = mediaStream;
        }
    }

    var isLoadedMetaData = true;

    if (!isHTMLObject) {
        var video = document.createElement('video');
        video.muted = true;
        video.autoplay = true;

        isLoadedMetaData = false;
        video.onloadedmetadata = function() {
            isLoadedMetaData = true;
        };

        setSrcObject(mediaStream, video);

        video.play();
    }

    var lastAnimationFrame = null;
    var startTime, endTime, lastFrameTime;

    var gifEncoder;

    var self = this;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.GifRecorder = GifRecorder;
}

// Last time updated: 2018-03-02 2:56:28 AM UTC

// ________________________
// MultiStreamsMixer v1.0.5

// Open-Sourced: https://github.com/muaz-khan/MultiStreamsMixer

// --------------------------------------------------
// Muaz Khan     - www.MuazKhan.com
// MIT License   - www.WebRTC-Experiment.com/licence
// --------------------------------------------------

function MultiStreamsMixer(arrayOfMediaStreams) {

    // requires: chrome://flags/#enable-experimental-web-platform-features

    var videos = [];
    var isStopDrawingFrames = false;

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.style = 'opacity:0;position:absolute;z-index:-1;top: -100000000;left:-1000000000; margin-top:-1000000000;margin-left:-1000000000;';
    (document.body || document.documentElement).appendChild(canvas);

    this.disableLogs = false;
    this.frameInterval = 10;

    this.width = 360;
    this.height = 240;

    // use gain node to prevent echo
    this.useGainNode = true;

    var self = this;

    // _____________________________
    // Cross-Browser-Declarations.js

    // WebAudio API representer
    var AudioContext = window.AudioContext;

    if (typeof AudioContext === 'undefined') {
        if (typeof webkitAudioContext !== 'undefined') {
            /*global AudioContext:true */
            AudioContext = webkitAudioContext;
        }

        if (typeof mozAudioContext !== 'undefined') {
            /*global AudioContext:true */
            AudioContext = mozAudioContext;
        }
    }

    /*jshint -W079 */
    var URL = window.URL;

    if (typeof URL === 'undefined' && typeof webkitURL !== 'undefined') {
        /*global URL:true */
        URL = webkitURL;
    }

    if (typeof navigator !== 'undefined' && typeof navigator.getUserMedia === 'undefined') { // maybe window.navigator?
        if (typeof navigator.webkitGetUserMedia !== 'undefined') {
            navigator.getUserMedia = navigator.webkitGetUserMedia;
        }

        if (typeof navigator.mozGetUserMedia !== 'undefined') {
            navigator.getUserMedia = navigator.mozGetUserMedia;
        }
    }

    var MediaStream = window.MediaStream;

    if (typeof MediaStream === 'undefined' && typeof webkitMediaStream !== 'undefined') {
        MediaStream = webkitMediaStream;
    }

    /*global MediaStream:true */
    if (typeof MediaStream !== 'undefined') {
        if (!('getVideoTracks' in MediaStream.prototype)) {
            MediaStream.prototype.getVideoTracks = function() {
                if (!this.getTracks) {
                    return [];
                }

                var tracks = [];
                this.getTracks.forEach(function(track) {
                    if (track.kind.toString().indexOf('video') !== -1) {
                        tracks.push(track);
                    }
                });
                return tracks;
            };

            MediaStream.prototype.getAudioTracks = function() {
                if (!this.getTracks) {
                    return [];
                }

                var tracks = [];
                this.getTracks.forEach(function(track) {
                    if (track.kind.toString().indexOf('audio') !== -1) {
                        tracks.push(track);
                    }
                });
                return tracks;
            };
        }

        // override "stop" method for all browsers
        if (typeof MediaStream.prototype.stop === 'undefined') {
            MediaStream.prototype.stop = function() {
                this.getTracks().forEach(function(track) {
                    track.stop();
                });
            };
        }
    }

    var Storage = {};

    if (typeof AudioContext !== 'undefined') {
        Storage.AudioContext = AudioContext;
    } else if (typeof webkitAudioContext !== 'undefined') {
        Storage.AudioContext = webkitAudioContext;
    }

    function setSrcObject(stream, element, ignoreCreateObjectURL) {
        if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
            try {
                element.src = URL.createObjectURL(stream);
            } catch (e) {
                setSrcObject(stream, element, true);
                return;
            }
        } else if ('srcObject' in element) {
            element.srcObject = stream;
        } else if ('mozSrcObject' in element) {
            element.mozSrcObject = stream;
        } else {
            alert('createObjectURL/srcObject both are not supported.');
        }
    }

    this.startDrawingFrames = function() {
        drawVideosToCanvas();
    };

    function drawVideosToCanvas() {
        if (isStopDrawingFrames) {
            return;
        }

        var videosLength = videos.length;

        var fullcanvas = false;
        var remaining = [];
        videos.forEach(function(video) {
            if (!video.stream) {
                video.stream = {};
            }

            if (video.stream.fullcanvas) {
                fullcanvas = video;
            } else {
                remaining.push(video);
            }
        });

        if (fullcanvas) {
            canvas.width = fullcanvas.stream.width;
            canvas.height = fullcanvas.stream.height;
        } else if (remaining.length) {
            canvas.width = videosLength > 1 ? remaining[0].width * 2 : remaining[0].width;

            var height = 1;
            if (videosLength === 3 || videosLength === 4) {
                height = 2;
            }
            if (videosLength === 5 || videosLength === 6) {
                height = 3;
            }
            if (videosLength === 7 || videosLength === 8) {
                height = 4;
            }
            if (videosLength === 9 || videosLength === 10) {
                height = 5;
            }
            canvas.height = remaining[0].height * height;
        } else {
            canvas.width = self.width || 360;
            canvas.height = self.height || 240;
        }

        if (fullcanvas && fullcanvas instanceof HTMLVideoElement) {
            drawImage(fullcanvas);
        }

        remaining.forEach(function(video, idx) {
            drawImage(video, idx);
        });

        setTimeout(drawVideosToCanvas, self.frameInterval);
    }

    function drawImage(video, idx) {
        if (isStopDrawingFrames) {
            return;
        }

        var x = 0;
        var y = 0;
        var width = video.width;
        var height = video.height;

        if (idx === 1) {
            x = video.width;
        }

        if (idx === 2) {
            y = video.height;
        }

        if (idx === 3) {
            x = video.width;
            y = video.height;
        }

        if (idx === 4) {
            y = video.height * 2;
        }

        if (idx === 5) {
            x = video.width;
            y = video.height * 2;
        }

        if (idx === 6) {
            y = video.height * 3;
        }

        if (idx === 7) {
            x = video.width;
            y = video.height * 3;
        }

        if (typeof video.stream.left !== 'undefined') {
            x = video.stream.left;
        }

        if (typeof video.stream.top !== 'undefined') {
            y = video.stream.top;
        }

        if (typeof video.stream.width !== 'undefined') {
            width = video.stream.width;
        }

        if (typeof video.stream.height !== 'undefined') {
            height = video.stream.height;
        }

        context.drawImage(video, x, y, width, height);

        if (typeof video.stream.onRender === 'function') {
            video.stream.onRender(context, x, y, width, height, idx);
        }
    }

    function getMixedStream() {
        isStopDrawingFrames = false;
        var mixedVideoStream = getMixedVideoStream();

        var mixedAudioStream = getMixedAudioStream();
        if (mixedAudioStream) {
            mixedAudioStream.getAudioTracks().forEach(function(track) {
                mixedVideoStream.addTrack(track);
            });
        }

        var fullcanvas;
        arrayOfMediaStreams.forEach(function(stream) {
            if (stream.fullcanvas) {
                fullcanvas = true;
            }
        });

        return mixedVideoStream;
    }

    function getMixedVideoStream() {
        resetVideoStreams();

        var capturedStream;

        if ('captureStream' in canvas) {
            capturedStream = canvas.captureStream();
        } else if ('mozCaptureStream' in canvas) {
            capturedStream = canvas.mozCaptureStream();
        } else if (!self.disableLogs) {
            console.error('Upgrade to latest Chrome or otherwise enable this flag: chrome://flags/#enable-experimental-web-platform-features');
        }

        var videoStream = new MediaStream();

        capturedStream.getVideoTracks().forEach(function(track) {
            videoStream.addTrack(track);
        });

        canvas.stream = videoStream;

        return videoStream;
    }

    function getMixedAudioStream() {
        // via: @pehrsons
        if (!Storage.AudioContextConstructor) {
            Storage.AudioContextConstructor = new Storage.AudioContext();
        }

        self.audioContext = Storage.AudioContextConstructor;

        self.audioSources = [];

        if (self.useGainNode === true) {
            self.gainNode = self.audioContext.createGain();
            self.gainNode.connect(self.audioContext.destination);
            self.gainNode.gain.value = 0; // don't hear self
        }

        var audioTracksLength = 0;
        arrayOfMediaStreams.forEach(function(stream) {
            if (!stream.getAudioTracks().length) {
                return;
            }

            audioTracksLength++;

            var audioSource = self.audioContext.createMediaStreamSource(stream);

            if (self.useGainNode === true) {
                audioSource.connect(self.gainNode);
            }

            self.audioSources.push(audioSource);
        });

        if (!audioTracksLength) {
            return;
        }

        self.audioDestination = self.audioContext.createMediaStreamDestination();
        self.audioSources.forEach(function(audioSource) {
            audioSource.connect(self.audioDestination);
        });
        return self.audioDestination.stream;
    }

    function getVideo(stream) {
        var video = document.createElement('video');

        setSrcObject(stream, video);

        video.muted = true;
        video.volume = 0;

        video.width = stream.width || self.width || 360;
        video.height = stream.height || self.height || 240;

        video.play();

        return video;
    }

    this.appendStreams = function(streams) {
        if (!streams) {
            throw 'First parameter is required.';
        }

        if (!(streams instanceof Array)) {
            streams = [streams];
        }

        arrayOfMediaStreams.concat(streams);

        streams.forEach(function(stream) {
            if (stream.getVideoTracks().length) {
                var video = getVideo(stream);
                video.stream = stream;
                videos.push(video);
            }

            if (stream.getAudioTracks().length && self.audioContext) {
                var audioSource = self.audioContext.createMediaStreamSource(stream);
                audioSource.connect(self.audioDestination);
                self.audioSources.push(audioSource);
            }
        });
    };

    this.releaseStreams = function() {
        videos = [];
        isStopDrawingFrames = true;

        if (self.gainNode) {
            self.gainNode.disconnect();
            self.gainNode = null;
        }

        if (self.audioSources.length) {
            self.audioSources.forEach(function(source) {
                source.disconnect();
            });
            self.audioSources = [];
        }

        if (self.audioDestination) {
            self.audioDestination.disconnect();
            self.audioDestination = null;
        }

        if (self.audioContext) {
            self.audioContext.close();
        }

        self.audioContext = null;

        context.clearRect(0, 0, canvas.width, canvas.height);

        if (canvas.stream) {
            canvas.stream.stop();
            canvas.stream = null;
        }
    };

    this.resetVideoStreams = function(streams) {
        if (streams && !(streams instanceof Array)) {
            streams = [streams];
        }

        resetVideoStreams(streams);
    };

    function resetVideoStreams(streams) {
        videos = [];
        streams = streams || arrayOfMediaStreams;

        // via: @adrian-ber
        streams.forEach(function(stream) {
            if (!stream.getVideoTracks().length) {
                return;
            }

            var video = getVideo(stream);
            video.stream = stream;
            videos.push(video);
        });
    }

    // for debugging
    this.name = 'MultiStreamsMixer';
    this.toString = function() {
        return this.name;
    };

    this.getMixedStream = getMixedStream;

}

// ______________________
// MultiStreamRecorder.js

/*
 * Video conference recording, using captureStream API along with WebAudio and Canvas2D API.
 */

/**
 * MultiStreamRecorder can record multiple videos in single container.
 * @summary Multi-videos recorder.
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef MultiStreamRecorder
 * @class
 * @example
 * var options = {
 *     mimeType: 'video/webm'
 * }
 * var recorder = new MultiStreamRecorder(ArrayOfMediaStreams, options);
 * recorder.record();
 * recorder.stop(function(blob) {
 *     video.src = URL.createObjectURL(blob);
 *
 *     // or
 *     var blob = recorder.blob;
 * });
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStreams} mediaStreams - Array of MediaStreams.
 * @param {object} config - {disableLogs:true, frameInterval: 1, mimeType: "video/webm"}
 */

function MultiStreamRecorder(arrayOfMediaStreams, options) {
    arrayOfMediaStreams = arrayOfMediaStreams || [];
    var self = this;

    var mixer;
    var mediaRecorder;

    options = options || {
        mimeType: 'video/webm',
        video: {
            width: 360,
            height: 240
        }
    };

    if (!options.frameInterval) {
        options.frameInterval = 10;
    }

    if (!options.video) {
        options.video = {};
    }

    if (!options.video.width) {
        options.video.width = 360;
    }

    if (!options.video.height) {
        options.video.height = 240;
    }

    /**
     * This method records all MediaStreams.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.record();
     */
    this.record = function() {
        // github/muaz-khan/MultiStreamsMixer
        mixer = new MultiStreamsMixer(arrayOfMediaStreams);

        if (getVideoTracks().length) {
            mixer.frameInterval = options.frameInterval || 10;
            mixer.width = options.video.width || 360;
            mixer.height = options.video.height || 240;
            mixer.startDrawingFrames();
        }

        if (options.previewStream && typeof options.previewStream === 'function') {
            options.previewStream(mixer.getMixedStream());
        }

        // record using MediaRecorder API
        mediaRecorder = new MediaStreamRecorder(mixer.getMixedStream(), options);
        mediaRecorder.record();
    };

    function getVideoTracks() {
        var tracks = [];
        arrayOfMediaStreams.forEach(function(stream) {
            stream.getVideoTracks().forEach(function(track) {
                tracks.push(track);
            });
        });
        return tracks;
    }

    /**
     * This method stops recording MediaStream.
     * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
     */
    this.stop = function(callback) {
        if (!mediaRecorder) {
            return;
        }

        mediaRecorder.stop(function(blob) {
            self.blob = blob;

            callback(blob);

            self.clearRecordedData();
        });
    };

    /**
     * This method pauses the recording process.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.pause();
     */
    this.pause = function() {
        if (mediaRecorder) {
            mediaRecorder.pause();
        }
    };

    /**
     * This method resumes the recording process.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.resume();
     */
    this.resume = function() {
        if (mediaRecorder) {
            mediaRecorder.resume();
        }
    };

    /**
     * This method resets currently recorded data.
     * @method
     * @memberof MultiStreamRecorder
     * @example
     * recorder.clearRecordedData();
     */
    this.clearRecordedData = function() {
        if (mediaRecorder) {
            mediaRecorder.clearRecordedData();
            mediaRecorder = null;
        }

        if (mixer) {
            mixer.releaseStreams();
            mixer = null;
        }
    };

    /**
     * Add extra media-streams to existing recordings.
     * @method
     * @memberof MultiStreamRecorder
     * @param {MediaStreams} mediaStreams - Array of MediaStreams
     * @example
     * recorder.addStreams([newAudioStream, newVideoStream]);
     */
    this.addStreams = function(streams) {
        if (!streams) {
            throw 'First parameter is required.';
        }

        if (!(streams instanceof Array)) {
            streams = [streams];
        }

        arrayOfMediaStreams.concat(streams);

        if (!mediaRecorder || !mixer) {
            return;
        }

        mixer.appendStreams(streams);
    };

    /**
     * Reset videos during live recording. Replace old videos e.g. replace cameras with full-screen.
     * @method
     * @memberof MultiStreamRecorder
     * @param {MediaStreams} mediaStreams - Array of MediaStreams
     * @example
     * recorder.resetVideoStreams([newVideo1, newVideo2]);
     */
    this.resetVideoStreams = function(streams) {
        if (!mixer) {
            return;
        }

        if (streams && !(streams instanceof Array)) {
            streams = [streams];
        }

        mixer.resetVideoStreams(streams);
    };

    // for debugging
    this.name = 'MultiStreamRecorder';
    this.toString = function() {
        return this.name;
    };
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.MultiStreamRecorder = MultiStreamRecorder;
}

// _____________________
// RecordRTC.promises.js

/**
 * RecordRTCPromisesHandler adds promises support in {@link RecordRTC}. Try a {@link https://github.com/muaz-khan/RecordRTC/blob/master/simple-demos/RecordRTCPromisesHandler.html|demo here}
 * @summary Promises for {@link RecordRTC}
 * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
 * @author {@link http://www.MuazKhan.com|Muaz Khan}
 * @typedef RecordRTCPromisesHandler
 * @class
 * @example
 * var recorder = new RecordRTCPromisesHandler(mediaStream, options);
 * recorder.startRecording()
 *         .then(successCB)
 *         .catch(errorCB);
 * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
 * @param {MediaStream} mediaStream - Single media-stream object, array of media-streams, html-canvas-element, etc.
 * @param {object} config - {type:"video", recorderType: MediaStreamRecorder, disableLogs: true, numberOfAudioChannels: 1, bufferSize: 0, sampleRate: 0, video: HTMLVideoElement, etc.}
 * @throws Will throw an error if "new" keyword is not used to initiate "RecordRTCPromisesHandler". Also throws error if first argument "MediaStream" is missing.
 * @requires {@link RecordRTC}
 */

function RecordRTCPromisesHandler(mediaStream, options) {
    if (!this) {
        throw 'Use "new RecordRTCPromisesHandler()"';
    }

    if (typeof mediaStream === 'undefined') {
        throw 'First argument "MediaStream" is required.';
    }

    var self = this;

    /**
     * @property {Blob} blob - Access/reach the native {@link RecordRTC} object.
     * @memberof RecordRTCPromisesHandler
     * @example
     * var internal = recorder.recordRTC.getInternalRecorder();
     * alert(internal instanceof MediaStreamRecorder);
     */
    self.recordRTC = new RecordRTC(mediaStream, options);

    /**
     * This method records MediaStream.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.startRecording()
     *         .then(successCB)
     *         .catch(errorCB);
     */
    this.startRecording = function() {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.startRecording();
                resolve();
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method stops the recording.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.stopRecording = function() {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.stopRecording(function(url) {
                    self.blob = self.recordRTC.getBlob();
                    resolve(url);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method returns data-url for the recorded blob.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     recorder.getDataURL().then(function(dataURL) {
     *         window.open(dataURL);
     *     }).catch(errorCB);;
     * }).catch(errorCB);
     */
    this.getDataURL = function(callback) {
        return new Promise(function(resolve, reject) {
            try {
                self.recordRTC.getDataURL(function(dataURL) {
                    resolve(dataURL);
                });
            } catch (e) {
                reject(e);
            }
        });
    };

    /**
     * This method returns the recorded blob.
     * @method
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.getBlob = function() {
        return self.recordRTC.getBlob();
    };

    /**
     * @property {Blob} blob - Recorded data as "Blob" object.
     * @memberof RecordRTCPromisesHandler
     * @example
     * recorder.stopRecording().then(function() {
     *     var blob = recorder.getBlob();
     * }).catch(errorCB);
     */
    this.blob = null;
}

if (typeof RecordRTC !== 'undefined') {
    RecordRTC.RecordRTCPromisesHandler = RecordRTCPromisesHandler;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(11)))

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div layout=column flex layout-padding> <div layout=column class=\"dictationspacediv md-whiteframe-3dp\" layout-xs=row> <div layout=row flex layout-xs=column style=margin:10px;padding:20px> <div flex=60> <md-input-container style=width:100%> <label>Enter Question</label> <textarea ng-model=question maxlength=500 focus-it=true autofocus=true></textarea> <p class=errorMessage>{{short.errors.qn_desc}}</p> </md-input-container> </div> <div flex=20> </div> <div flex=10 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(22) + " ngf-select=questionImgUpload($files,owqArchive) ngf-multiple=true> <div flex=45 ng-show=\"questionImage.length > 0\" ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> </div> </div> </div> </div> ";

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: DrawController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var DrawController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "uploadService", "$mdMedia", function DrawController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, uploadService, $mdMedia) {
    _classCallCheck(this, DrawController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_DRAW;
    $scope.questionImage = [];
    $scope.content_editor_id = userId;

    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;

    //SET UI FOR EDIT QUESTIONS
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        $scope.question = editQuestion.qn_desc;
        $scope.questionImg = [];
        if (editQuestion.questionImg) {
            if (!Array.isArray(editQuestion.questionImg)) {
                $scope.questionImg = editQuestion.questionImg;
            } else {
                $scope.questionImg.push(editQuestion.questionImg);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    }

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };
    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };

    //Open dialog to view image
    $scope.openDialog = function (imageType) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "Drawing - Question Image",
                images: $scope.questionImage
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
        };

        /*
         * Function to select passage
         */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id === passage_id) {
                    if (eachPas.isSelected) $scope.selectedPassage = eachPas;else $scope.selectedPassage = null;
                } else {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };

        /*
         * Function to cancel select passage
         */
        $scope.cancelSelectedPasssage = function () {
            $scope.selectedPassage = null;
        };
    };

    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        var isPassagePresent = false;
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage && $scope.selectedPassage._id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                    $mdDialog.show({
                        locals: {
                            passages: result
                        },
                        template: _passagePopup2.default,
                        controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: useFullScreen
                    });
                }
            }
        }
        if (!isPassagePresent) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
        }
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        var authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId
        };
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);
    };

    //Adding OWQ question from UI
    $scope.$on('addDrawing', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //Validation 

        if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
            $scope.errors.qn_desc = "Question is required";
            $scope.activityErrorCount++;
        }
        if ($scope.questionImg == null || $scope.questionImg == undefined || $scope.questionImg == "") {
            $scope.errors.questionImg = "Image is required";
            $scope.activityErrorCount++;
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });
}];

exports.default = DrawController;

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fibBulkPopup = __webpack_require__(1274);

var _fibBulkPopup2 = _interopRequireDefault(_fibBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: FibBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var FibBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdMedia", "$mdDialog", function FibBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdMedia, $mdDialog) {
    _classCallCheck(this, FibBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var qp_id = $scope.$parent.tqp_id;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_FIB;
    $scope.csvDownloadLink = '../../../img/csv-samples/FIB-CSV-Sample.csv';
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    //let errorCount = 0;
    function validate(obj) {
        var errors = {};
        if (obj.question == null || obj.question == undefined || obj.question == "") {
            errors.question = "Question is required";
            //activityErrorCount++;
        } else if (obj.question.split('_').length < 2) {
            errors.question = "Enter a valid question";
            //activityErrorCount++;
        }
        if (obj.correctAnswerExpl == null || obj.correctAnswerExpl == undefined || obj.correctAnswerExpl == "") {
            errors.answer_explain = "Explanation is required";
            //activityErrorCount++;
        }
        if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
            errors.corect_answer = "Answer is required";
            //activityErrorCount++;
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
            };

            var errorCount = 0;

            //Validation  
            _.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });
            if ($scope.errors.length == 0) {
                obj.ques_list = $scope.bulkUploadData;
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else {
                return false;
            }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];
                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var xlink = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[3]) level = question[3].split('&&');
                                if (question[4]) wave = question[4].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[7]) {
                                    linkSub = question[7].split('&&');
                                }
                                if (question[8]) {
                                    xlink = question[8].split('&&');
                                }
                                if (question[10]) {
                                    cognitive_skills = question[10].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "correctAnswer": question[1],
                                    "correctAnswerExpl": question[2],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[5],
                                    "theme": question[6],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": xlink
                                    },
                                    "tags": question[9],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });

                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _fibBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity

            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = FibBulkUploadController;

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=\"makeMeWhite md-whiteframe-2dp\"> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question (For specifying Blank add Underscore)</th> <th class=\"md-body-1 bold\">Correct Answer/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Correct Answer/s explanation/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags (Use && to discriminate)</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <div class=errorMessage>{{errors[$index].question}}</div> </div> </td> <td class=md-body-1 data-title=\"Correct Answer\"> <div layout=column> <input class=md-body-1 ng-model=data.correctAnswer> <div class=errorMessage>{{errors[$index].corect_answer}}</div> </div> </td> <td class=md-body-1 data-title=\"Answer Explanations\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswerExpl></textarea> <div class=errorMessage>{{errors[$index].answer_explain}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].linkSubject}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors[$index].linkTheme}}</div> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog>";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=contentBox> <md-divider class=dividerBorder></md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=md-whiteframe-3dp ng-if=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"hand fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div layout=column flex layout-align=center> <div layout=row flex layout-align=\"space-between center\"> <md-input-container flex=95> <label>Enter Question</label> <textarea ng-model=qn_desc ng-keyup=onQuesLoad() md-maxlength={{ques_desc_limit}} txt-maxlength={{ques_desc_limit}} md-select-on-focus></textarea> <p class=errorMessage>{{errors.qn_desc}}</p> </md-input-container> <div flex=10 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(12) + " ngf-select=questionImgUpload($files,fibArchive) ngf-multiple=true> <div flex=45 ng-show=\"questionImage.length > 0\" ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> </div> </div> <div layout=row ng-show=qn_desc layout-wrap id=answer class=fibContent> </div> </div> </div> <md-divider class=dividerBorder></md-divider> <div class=contentBox> <div layout=row layout-wrap flex> <div layout=column flex=45 ng-repeat=\"ansHint in answers\" class=\"md-whiteframe-2dp fibExpDiv\"> <div class=fibExpNoDiv flex style=background-color:{};>{{$index+1}}</div> <md-input-container> <label>Answer Explanation</label> <textarea ng-model=ansHint.explanation txt-maxlength={{explain_limit}}></textarea> <p class=errorMessage>{{errors[\"answers.\" + $index + \".explanation\"]}}</p> </md-input-container> </div> </div> </div>";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: FibController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var FibController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "CONSTANTS", "$compile", "$mdDialog", "$mdMedia", "uploadService", "randomColorService", function FibController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, CONSTANTS, $compile, $mdDialog, $mdMedia, uploadService, randomColorService) {
    _classCallCheck(this, FibController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_FIB;
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.explain_limit = CQuesConst.ANS_EXPLANATION_LIMIT;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    var questionData = {};
    $scope.question = "";
    var errorCount = 0;
    $scope.answers = [];
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    // TO DELETE SELECTED PASSAGE
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };

    $scope.onQuesLoad = function () {
        if ($scope.qn_desc === undefined) {
            return;
        }
        var question = $scope.qn_desc;
        var fibArchiveOptions = question.split('_');
        var loadedQst = "";
        var querySl = "#answer";
        var myEl = angular.element(document.querySelector(querySl));
        myEl.empty();
        $scope.answers = [];
        _.each(fibArchiveOptions, function (option, index) {
            if (index === fibArchiveOptions.length - 1) {
                loadedQst = " " + option.trim();
                myEl.append(loadedQst);
                return;
            }
            if (questionData && questionData.answer && questionData.answer[index]) {
                $scope.answers.push({
                    "color": randomColorService.getRandomColor(),
                    "desc": questionData.answer[index].desc,
                    "explanation": questionData.answer[index].explanation
                });
            } else {
                $scope.answers.push({
                    "color": randomColorService.getRandomColor()
                });
            }
            loadedQst = " " + option.trim() + " ";
            myEl.append(loadedQst);
            myEl.append($compile('<md-input-container class="fibArchiveAnswer"><label>Enter Answer</label><textarea md-maxlength="{{option_limit}}" txt-maxlength="{{option_limit}}" type="text" ng-model="answers[' + index + '].desc"></textarea><p class="errorMessage">{{errors["answers.' + index + '.desc"]}}</p></md-input-container>')($scope));
        });
    };
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        console.log($scope._id);
        $scope.qn_desc = editQuestion.qn_desc;
        $scope.questionImage = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        if (editQuestion && editQuestion.answer) {
            $scope.onQuesLoad();
            $scope.answers = _.map(editQuestion.answer, function (ans) {
                ans["color"] = randomColorService.getRandomColor();
                return ans;
            });
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    }
    var imageViewType = "";
    $scope.cancelDialog = function () {
        $mdDialog.cancel();
        if (imageViewType === 'question') {
            $scope.questionImage = $scope.imageArray;
        }
        imageViewType = "";
        $scope.imageArray = [];
    };
    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };

    //Open dialog to view image
    $scope.openDialog = function (imageType, index, desc) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "FIB - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "SA - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
         * Function to select passage
         */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };

    //Adding OWQ question from UI
    $scope.$on('addFibQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //Validation  
        if ($scope.qn_desc == null || $scope.qn_desc == undefined || $scope.qn_desc == "") {
            $scope.errors.qn_desc = "Question is required";
            activityErrorCount++;
        } else if ($scope.qn_desc.split('_').length < 2) {
            $scope.errors.qn_desc = "Enter a valid question";
            activityErrorCount++;
        }
        if ($scope.answers) {
            _.each($scope.answers, function (answer, index) {
                if (answer.explanation == null || answer.explanation == undefined || answer.explanation == "") {
                    $scope.errors["answers." + index + ".explanation"] = "Explanation is required";
                    activityErrorCount++;
                } else if (answer.explanation && answer.explanation.length > $scope.explain_limit) {
                    $scope.errors["answers." + index + ".explanation"] = "Explanation does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters";
                    activityErrorCount++;
                }
                if (answer.desc == null || answer.desc == undefined || answer.desc == "") {
                    $scope.errors["answers." + index + ".desc"] = "Answer is required";
                    activityErrorCount++;
                }
            });
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var answerArr = [];
            _.each($scope.answers, function (ans, index) {
                var ansObj = {
                    "desc": ans.desc,
                    "explanation": ans.explanation
                };
                answerArr.push(ansObj);
            });
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "qn_desc": '' + $scope.qn_desc,
                "answer": answerArr,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    /************** LINK QUESTION TO PASSAGE : END ****************/

    //On destroy function
    this.$onDestroy = function () {};
}];

exports.default = FibController;

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _longBulkPopup = __webpack_require__(1279);

var _longBulkPopup2 = _interopRequireDefault(_longBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: LongBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var LongBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdDialog", "$mdMedia", function LongBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdDialog, $mdMedia) {
    _classCallCheck(this, LongBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_LA;
    $scope.csvDownloadLink = '../../../img/csv-samples/LA-CSV-Sample.csv';
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    var qp_id = $scope.$parent.tqp_id;
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    var errorCount = 0;
    function validate(obj) {
        var errors = {};
        //Validation  
        if (obj.question == null || obj.question.trim() == undefined || obj.question == "") {
            errors.question = "Question is required";
        } else if (obj.question.length > $scope.ques_desc_limit) {
            errors.question = "Question does not exceed " + $scope.ques_desc_limit + " characters";
        }
        if (obj.valuePoints.length == 0) {
            errors.value_points = "Atleast One Value point is required";
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
                //Validation  
            };_.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });
            if ($scope.errors.length == 0) {
                obj.ques_list = $scope.bulkUploadData;
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;

            //         if (errorCount > 0) {
            //             toastr.error("Please fill all mandatory fields")
            //             return false;
            //         } else {

            //             Meteor.apply('addBulkTf', [$scope.bulkUploadData, obj], (err, result) => {
            //                 if (err) {
            //                     toastr.error("errorr")
            //                 } else {
            //                     $mdDialog.hide();
            //                     toastr.success("Questions Added Successfully...")
            //                     $state.go("wizard.formatQuestion")
            //                 }
            //             })
            //         }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {

                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[2]) level = question[2].split('&&');
                                if (question[3]) wave = question[3].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[6]) {
                                    linkSub = question[6].split('&&');
                                }
                                if (question[7]) {
                                    linkTheme = question[7].split('&&');
                                }
                                if (question[9]) {
                                    cognitive_skills = question[9].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "valuePoints": question[1],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[4],
                                    "theme": question[5],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[8],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.theme.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } 
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find(linkSubject.themes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.xlink = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _longBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity

            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = LongBulkUploadController;

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=\"makeMeWhite md-whiteframe-2dp\"> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question</th> <th class=\"md-body-1 bold\">Value Points/Key points (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <p class=errorMessage>{{errors[$index].question}}</p> </div> </td> <td class=md-body-1 data-title=\"Value Points\"> <div layout=column> <textarea class=md-body-1 ng-model=data.valuePoints></textarea> <p class=errorMessage>{{errors[$index].valuePoints}}</p> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].linkSubject}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors[$index].linkTheme}}</div> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.mainDiv .action-btn-clr{background-color:#1665c1!important;color:#fff;text-transform:capitalize}.mainDiv .compose{margin-top:5px}.mainDiv .compose-icon{margin-top:3px}.mainDiv .button-style-compose{border-radius:25px;padding-left:2px;padding-right:2px}</style> <div class=\"contentBox mainDiv\"> <md-divider class=dividerBorder> </md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"hand passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=md-whiteframe-3dp ng-show=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"hand fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"hand fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"hand fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div ng-show=\"!isLatex && isNotComposed\" id=used_editor layout=column> <div> Composed Question: </div> <div class=composed_dom ng-bind-html=used_editor_html></div> </div> <div layout=row layout-align=\"space-between center\" flex> <md-input-container flex=70> <div class=qn-label ng-show=isLatex>Enter Question</div> <span id=long-math-field ng-show=isLatex ng-model=question style=height:auto md-select-on-focus ng-paste=paste($event)> ff</span> <div ng-show=!isLatex> <label ng-show=!isNotComposed>Enter Question</label> <textarea ng-show=!isNotComposed ng-model=question md-select-on-focus></textarea> </div> <md-checkbox ng-model=isLatex> With formula </md-checkbox> <p class=errorMessage>{{errors.qn_desc}}</p> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(12) + " ngf-select=questionImgUpload($files,longArchive) ngf-multiple=true> <div flex=45 ng-show=\"questionImage.length > 0\" ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=viewTextAngular()> <div>Compose/Edit</div> </md-button> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=resetQuestion()> <div>Reset</div> </md-button> </div> </div> <div layout=row layout-align=\"start center\"> <md-input-container flex=40 class=valuePoint> <div ng-show=!isLatex> <label>Value Point Name</label> <textarea md-maxlength={{val_pt_limit}} ng-model=valuePoint></textarea> </div> <div ng-show=isLatex class=qn-label>Enter Value points</div> <span id=long-valuepoint-field ng-show=isLatex ng-model=valuePoint style=height:auto md-select-on-focus ng-paste=paste($event)></span> <p class=errorMessage>{{errors.value_points}}</p> </md-input-container> <div flex=5> <i class=\"fas fa-plus-circle addIcon\" ng-click=addPoint()></i> </div> </div> <div layout=column flex=65 ng-if=\"valuePoints.length>0\"> <div layout=row flex layout-align=\"start center\" class=valuePointHeading> <div flex=60>Value Points</div> <div flex=20>Delete</div> <div flex=20>Edit</div> </div> <div layout=row flex layout-align=\"start center\" ng-repeat=\"valuePoint in valuePoints\" class=valuePointDiv> <div flex=60> <div ng-init=initformatLatex() ng-show=!isLatex ng-if=\"valuePoint.isEdit==false\">{{valuePoint.point}}</div> <div class=latex_field ng-show=isLatex ng-if=\"valuePoint.isEdit==false\">{{valuePoint.point}}</div> <md-input-container class=valuePointEdit ng-if=\"valuePoint.isEdit==true\"> <textarea ng-init=valuePointsInit(valuePoint) ng-model=valuePoint.point md-maxlength={{val_pt_limit}} txt-maxlength={{val_pt_limit}} ng-show=!isLatex></textarea> <span ng-init=valuePointsInit(valuePoint) class=long-valuepoint-edit-field ng-show=isLatex ng-model=valuePoint.point style=height:auto md-select-on-focus ng-paste=paste($event)></span> </md-input-container> </div> <div flex=20 class=valuePointImagePadding ng-click=removePoint($index)> <img class=hand src=" + __webpack_require__(16) + "> </div> <div flex=20 class=valuePointImagePadding ng-click=editPoint($index)> <i class=\"editIconColor far fa-edit fa-lg\" ng-if=\"valuePoint.isEdit==false\"></i> <img class=hand src=" + __webpack_require__(443) + " ng-click=updatePoint($index) ng-if=\"valuePoint.isEdit==true\"> </div> </div> </div> </div> <md-divider class=dividerBorder> </md-divider>";

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _editor = __webpack_require__(56);

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: LongController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var LongController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "$mdMedia", "uploadService", "$timeout", "$sce", function LongController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, $mdMedia, uploadService, $timeout, $sce) {
    _classCallCheck(this, LongController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_LA;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    $scope.isNotComposed = false;

    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.questionImage = [];
    $scope.valuePoints = [];
    $scope.errors = {};
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        $scope.question = editQuestion.qn_desc;
        $scope.isNotComposed = true;
        $scope.question = editQuestion.qn_desc;
        $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
        $scope.isLatex = editQuestion.isLatex;
        // if(!$scope.isLatex){
        //     $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
        //     $scope.question = $sce.trustAsHtml(editQuestion.qn_desc)  
        // }
        // else{
        //     $scope.used_editor_html = '';
        //     $scope.isNotComposed = true
        // }

        $scope.questionImage = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        if (editQuestion.value_points) {
            $scope.valuePoints = _.map(editQuestion.value_points, function (point) {
                point["point"] = point.name;
                point["isEdit"] = false;
                return point;
            });
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    }
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    //Question desc with latex
    var MQ = MathQuill.getInterface(2);
    var mathFieldSpan = document.getElementById('long-math-field');
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.question !== undefined) {
        mathFieldSpan.textContent = $scope.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.question = mathField.latex();
            }
        }
    });

    //Invokes after the option elements loaded
    $scope.valuePointsInit = function (option) {
        var optionFieldSpan = document.getElementsByClassName('long-valuepoint-edit-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.point) {
                spanElement.textContent = option.point;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.point = optionField.latex();
                    }
                }
            });
        });
    };

    var mathValuePointFieldSpan = document.getElementById('long-valuepoint-field');
    mathValuePointFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.valuePoint) {
        mathValuePointFieldSpan.textContent = $scope.valuePoint;
    }
    var mathValuePointField = MQ.MathField(mathValuePointFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.valuePoint = mathValuePointField.latex();
            }
        }
    });

    var formatLatex = function formatLatex() {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('latex_field');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    $scope.initformatLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('latex_field');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.addPoint = function () {
        if ($scope.valuePoint) {
            $scope.errors["value_points"] = "";
            if ($scope.valuePoint.length > CQuesConst.VALUE_POINTS_LIMIT) {
                $scope.errors["value_points"] = "value point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT;
            } else {
                var point = $scope.valuePoint;
                var mark = $scope.valuepointMark;
                var valuePoint = {
                    point: point,
                    mark: mark,
                    isEdit: false
                };
                $scope.valuePoints.push(valuePoint);
                if ($scope.isLatex) $scope.valuePoint = mathValuePointField.latex("");else $scope.valuePoint = "";
                $scope.valuepointMark = "";
            }
        } else {
            $scope.errors["value_points"] = "Value point is required";
        }
    };
    $scope.removePoint = function (index) {
        $scope.valuePoints.splice(index, 1);
    };
    $scope.editPoint = function (index) {
        $scope.valuePoints[index].isEdit = true;
    };
    $scope.updatePoint = function (index) {
        var valuePoints = [];
        if ($scope.valuePoints[index].point.length < 0) {
            $scope.errors["value_points." + index + ".point"] = "Value point is required";
        } else if ($scope.valuePoints[index].point.length > CQuesConst.VALUE_POINTS_LIMIT) {
            $scope.errors["value_points." + index + ".point"] = "Value Point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT + " characters";
        } else {
            angular.copy($scope.valuePoints, valuePoints);
            valuePoints[index].isEdit = false;
            angular.copy(valuePoints, $scope.valuePoints);
            formatLatex();
        }
    };

    $scope.cancelDialog = function () {
        $mdDialog.cancel();
        if (imageViewType === 'question') $scope.questionImg = $scope.imageArray;
        imageViewType = "";
        $scope.imageArray = [];
    };

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };
    //Open dialog to view image
    $scope.openDialog = function (imageType, index, desc) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "LA - Question Image",
                images: $scope.questionImage
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };
    //Adding OWQ question from UI
    $scope.$on('addLongQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //Validation  
        if ($scope.question == null || $scope.question.trim() == undefined || $scope.question == "") {
            $scope.errors.qn_desc = "Question is required";
            activityErrorCount++;
        } else if ($scope.question.length > $scope.ques_desc_limit) {
            // $scope.errors['qn_desc'] = "Question does not exceed " + $scope.ques_desc_limit + " characters";
            // errCount++;
        }
        if ($scope.valuePoints.length == 0) {
            $scope.errors.value_points = "Atleast One Value point is required";
            activityErrorCount++;
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "value_points": $scope.valuePoints,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    //On destroy function
    this.$onDestroy = function () {};
    $scope.viewTextAngular = function () {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
            locals: {
                parentScope: $scope
            },
            template: _editor2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    };
    $scope.setQuestionFromEditor = function (editor_value) {
        $scope.question = editor_value;
        $scope.used_editor = true;
        $scope.isNotComposed = true;
        var used_editor = document.getElementById('used_editor');
        $scope.used_editor_html = $sce.trustAsHtml(editor_value);
        // used_editor.append(editor_value)
        console.log(used_editor);
    };
    function resetFn() {
        $scope.isNotComposed = false;
        $scope.question = '';
        $scope.used_editor_html = '';
    }
    $scope.resetQuestion = function () {
        var confirm = $mdDialog.confirm().title('Remove').textContent('This will remove question from the input, If you want to edit use editor').ariaLabel('Lucky day').ok('Remove').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            resetFn();
        }, function (f, r) {});
    };
}];

var editorLACtrl = function editorLACtrl($scope, $mdDialog, parentScope) {
    _classCallCheck(this, editorLACtrl);

    Simditor.locale = 'en-US';
    var editor = undefined;
    angular.element(document).ready(function () {
        $scope.editor = {};
        editor = new Simditor({
            textarea: $('#editor'),
            placeholder: '',
            params: {},
            upload: false,
            tabIndent: true,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
            // 'image',
            'hr', 'indent', 'outdent', 'alignment'],
            toolbarFloat: true,
            toolbarFloatOffset: 0,
            toolbarHidden: false,
            pasteImage: false,
            cleanPaste: false,
            codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
            //optional options
        });
        if (parentScope.question) {
            console.log(parentScope);
            if (!parentScope.isLatex) {
                editor.setValue(parentScope.question);
            }
        }
    });
    $scope.saveContent = function (desc) {
        console.log(desc);
        console.log($scope.editor);
        var editor_value = editor.getValue();
        if (!editor_value) {
            toastr.error("Please enter question");
            return false;
        }
        parentScope.setQuestionFromEditor(editor_value);
        $mdDialog.hide();
    };
    $scope.closeEditor = function () {
        $mdDialog.hide();
    };
};

exports.default = LongController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _matchBulkPopup = __webpack_require__(1284);

var _matchBulkPopup2 = _interopRequireDefault(_matchBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                          * File: MatchBulkUploadController.js
                                                                                                                                                          * Project: educore
                                                                                                                                                          * Created Date: 2018-12-07
                                                                                                                                                          * Author: Arul Mozhi J
                                                                                                                                                          * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                          * ------------------------------------
                                                                                                                                                          */


var MatchBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdDialog", "$mdMedia", function MatchBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdDialog, $mdMedia) {
    _classCallCheck(this, MatchBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_MTF;
    var qp_id = $scope.$parent.tqp_id;
    $scope.csvDownloadLink = '../../../img/csv-samples/MTF-CSV-Sample.csv';
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    function validate(obj) {
        var errors = {};
        //Validation  
        if (obj.question == null || obj.question == undefined || obj.question == "") {
            errors.question = "Question is required";
            //activityErrorCount++;
        } else if (obj.question.split('&&').length != obj.correctAnswer.split('&&').length) {
            errors.question = "Question and option count should match";
            //activityErrorCount++;
        }
        if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
            errors.corect_answer = "Answer is required";
            //activityErrorCount++;
        } else if (obj.question.split('&&').length != obj.correctAnswer.split('&&').length) {
            errors.corect_answer = "Question and option count should match";
            //activityErrorCount++;
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
                //Validation  
            };_.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });
            if ($scope.errors.length == 0) {
                obj.ques_list = $scope.bulkUploadData;
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[3]) level = question[3].split('&&');
                                if (question[4]) wave = question[4].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[7]) {
                                    linkSub = question[7].split('&&');
                                }
                                if (question[8]) {
                                    linkTheme = question[8].split('&&');
                                }
                                if (question[10]) {
                                    cognitive_skills = question[10].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "correctAnswer": question[1],
                                    "correctAnswerExpl": question[2],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[5],
                                    "theme": question[6],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[9],
                                    "cognitive_skills": cognitive_skills
                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _matchBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity
            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = MatchBulkUploadController;

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=\"makeMeWhite md-whiteframe-2dp\"> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Correct Answer/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Correct Answer/s explanation/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <p class=errorMessage>{{errors[$index].question}}</p> </div> </td> <td class=md-body-1 data-title=\"Correct Answer\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswer></textarea> <p class=errorMessage>{{errors[$index].corect_answer}}</p> </div> </td> <td class=md-body-1 data-title=\"Answer Explanations\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswerExpl></textarea> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.latex-head{background:#1665c1;color:#fff;width:733px}.latex-close{float:right;font-size:20px;position:relative;color:#fff;right:12px;bottom:47px}</style> <div class=contentBox> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"hand passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage() style=margin-bottom:8px>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=\"md-whiteframe-3dp passage-link-btn qn_link_passage\" ng-if=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div class=\"md-whiteframe-2dp matchContainer\" flex style=padding-top:0> <div layout=row layout-align=\"space-between start\" style=\"background-color:#e0e0e0;padding:10px 0 0 0\"> <div flex=5></div> <div flex=20>Question <p class=errorMessage>{{errors[\"duplicateQues\"]}}</p></div> <div flex=10></div> <div flex=5></div> <div flex=20>Choice <p class=errorMessage>{{errors[\"duplicateAns\"]}}</p></div> <div flex=10></div> <div flex=20>Explanation</div> <div flex=5></div> </div> <div ng-repeat=\"option in options track by $index\" style=padding-left:15px> <div layout=row layout-align=\"space-between center\"> <div flex=5 class=\"matchOptionDiv optionCaption matchOptionCaptionFont\" style=background-color:#2ab4bf>{{option.caption}}</div> <md-input-container class=matchInputContainer flex=20> <div ng-show=!isLatex> <label>Enter Question</label> <textarea ng-model=option.question md-maxlength={{option_limit}} txt-maxlength={{option_limit}}></textarea> </div> <span class=\"match-question-field mathquill-editable\" ng-model=option.question ng-init=questionsLoaded(option) ng-show=isLatex style=height:auto ng-paste=paste($event)></span> <p class=errorMessage>{{errors[\"option.\" + $index + \".question\"]}}</p> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(22) + " ngf-select=uploadQuestionImg($files,option)> <img ng-if=option.questionImg flex=45 ng-src=\"{{fileUrl + option.questionImg}}\" style=width:100px> <img class=hand ng-if=option.questionImg src=" + __webpack_require__(174) + " ng-click=removeQuestionImg($index)> </div> <div flex=5 class=\"matchOptionDiv optionCaption matchOptionCaptionFont\" style=background-color:#2ab4bf>{{$index+1}}</div> <md-input-container class=matchInputContainer flex=20> <div ng-show=!isLatex> <label>Enter Choice</label> <textarea ng-model=option.answer md-maxlength={{option_limit}} txt-maxlength={{option_limit}}></textarea> </div> <span class=\"match-answer-field mathquill-editable\" ng-show=isLatex ng-model=option.answer style=height:auto ng-init=answersLoaded(option) ng-paste=paste($event)></span> <p class=errorMessage>{{errors[\"option.\" + $index + \".answer\"]}}</p> </md-input-container> <div flex=10> <img class=hand src=" + __webpack_require__(22) + " ngf-select=uploadChoiceImg($files,option)> <img class=hand ng-if=option.choiceImg flex=45 ng-src=\"{{fileUrl + option.choiceImg}}\" style=width:100px> <img class=hand ng-if=option.choiceImg src=" + __webpack_require__(16) + " ng-click=removeChoiceImg($index)> </div> <md-input-container class=matchInputContainer flex=20> <div ng-show=!isLatex> <label>Enter Explanation</label> <textarea ng-model=option.explanation txt-maxlength={{explain_limit}}></textarea> </div> <span class=\"match-explanation-field mathquill-editable\" ng-model=option.explanation style=height:auto ng-show=isLatex ng-init=explanationsLoaded(option) ng-paste=paste($event)></span> <p class=errorMessage>{{errors[\"option.\" + $index + \".explanation\"]}}</p> </md-input-container> <div flex=5><img class=hand src=" + __webpack_require__(16) + " ng-click=removeOption($index)></div> </div> </div> <md-checkbox ng-model=isLatex aria-label=Finished? style=margin-left:15px> With formula </md-checkbox> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <md-checkbox ng-model=auto_shuffle style=margin-left:15px> Auto shuffle </md-checkbox> <md-button title=\"Click here to shuffle the answers\" style=background-color:#326fdc;border-radius:15px;font-family:monospace;text-transform:none;font-weight:600 ng-if=!auto_shuffle ng-click=\"showPreview(auto_shuffle, $event)\" class=\"md-raised md-primary md-button md-ink-ripple\"> Manual Shuffle <i class=\"fas fa-random\"></i></md-button> </div> </div> <md-button md-no-ink class=\"questionButton moreChoiceButton md-ink-ripple\" layout=row ng-click=addOption()>Add more choice <span class=plusSymbol><i class=\"fas fa-plus\"></i></span> </md-button> ";

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _mtfPreview = __webpack_require__(1287);

var _mtfPreview2 = _interopRequireDefault(_mtfPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: MatchController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var MatchController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "uploadService", "$mdMedia", function MatchController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, uploadService, $mdMedia) {
    _classCallCheck(this, MatchController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};

    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_MTF;
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    var self = this;
    $scope.auto_shuffle = true;
    $scope.shuffled_options = [];
    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.explain_limit = CQuesConst.ANS_EXPLANATION_LIMIT;
    //SET UI FOR EDIT QUESTIONS
    $scope.options = [];
    this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];
    var calIndex = function calIndex(index, length) {
        if (index >= length) {
            if (index - length >= length) return calIndex(index - length, length);else return index - length;
        } else return index;
    };
    var editQuestion = $scope.$parent.$parent.editQuestion;

    if (editQuestion && editQuestion.option) {
        if (!editQuestion.auto_shuffle && editQuestion.shuffled_options && editQuestion.shuffled_options.length) {
            $scope.auto_shuffle = false;
            $scope.shuffled_options = editQuestion.shuffled_options;
        }
        //$scope.question = editQuestion.qn_desc;
        $scope._id = editQuestion._id;
        $scope.isEdit = true;
        _.each(editQuestion.option, function (opt) {
            var colorIndex = calIndex($scope.options.length, 4);
            $scope.isLatex = editQuestion.isLatex;
            $scope.options.push({
                caption: opt.question ? opt.question.tag : '',
                color: self.optionColors[colorIndex],
                questionImg: opt.question ? opt.question.questionImg : '',
                choiceImg: opt.answer.optImage,
                question: opt.question ? opt.question.desc : '',
                answer: opt.answer.desc,
                isLatex: $scope.isLatex,
                explanation: opt.explanation
            });
        });
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    } else {
        for (var i = 0; i < 4; i++) {
            var option = {
                caption: this.alphabets[i],
                color: this.optionColors[i],
                questionImg: '',
                choiceImg: '',
                'question': '',
                'answer': '',
                'hint': '',
                isLatex: false
            };
            $scope.options.push(option);
        }
    }
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    var MQ = MathQuill.getInterface(2);
    //Invokes after the question elements loaded
    $scope.questionsLoaded = function (option) {
        var optionFieldSpan = document.getElementsByClassName('match-question-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched mathquill-editable';
            if (option.question) {
                spanElement.textContent = option.question;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.question = optionField.latex();
                    }
                }
            });
        });
    };
    //Invokes after the answer elements loaded
    $scope.answersLoaded = function (option) {
        var optionFieldSpan = document.getElementsByClassName('match-answer-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.answer) {
                spanElement.textContent = option.answer;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.answer = optionField.latex();
                    }
                }
            });
        });
    };

    //Invokes after the explanation elements loaded
    $scope.explanationsLoaded = function (option) {
        var optionFieldSpan = document.getElementsByClassName('match-explanation-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.explanation) {
                spanElement.textContent = option.explanation;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.explanation = optionField.latex();
                    }
                }
            });
        });
    };

    //PREVENT PASTE FUNCTIONALITY
    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };
    //to add new options
    $scope.addOption = function (index) {
        var alphaIndex = calIndex($scope.options.length, 26);
        var colorIndex = calIndex($scope.options.length, 4);
        var option = {
            'caption': self.alphabets[alphaIndex],
            'color': self.optionColors[colorIndex],
            'questionImg': '',
            'choiceImg': '',
            'question': '',
            'answer': '',
            'hint': '',
            'isLatex': false
        };
        $scope.options.push(option);
    };
    //to remove options
    $scope.removeOption = function (index) {
        if ($scope.options.length == 1) {
            return false;
        } else {
            var tempOptions = [];
            angular.copy($scope.options, tempOptions);
            for (var i = 0; i < $scope.options.length; i++) {
                if (i > index) {
                    $scope.options[i].caption = tempOptions[i - 1].caption;
                    $scope.options[i].color = tempOptions[i - 1].color;
                }
            }
            $scope.options.splice(index, 1);
        }
    };
    //Image upload for question
    $scope.uploadQuestionImg = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        _.each($scope.options, function (key, val) {
                            if ($scope.options[val].caption === opt.caption) {
                                $scope.options[val].questionImg = result.url;
                            }
                        });
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    $scope.removeQuestionImg = function (index) {
        $scope.options[index].questionImg = undefined;
    };

    $scope.removeChoiceImg = function (index) {
        $scope.options[index].choiceImg = undefined;
    };

    //Image upload for choice
    $scope.uploadChoiceImg = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        _.each($scope.options, function (key, val) {
                            if ($scope.options[val].caption === opt.caption) {
                                $scope.options[val].choiceImg = result.url;
                            }
                        });
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };
    //Open dialog to view image
    $scope.openDialog = function (imageType) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "OWQ - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'explan') {
            imageDetails = {
                title: "OWQ - Explanation Image",
                images: $scope.explanationImage
            };
        } else if (imageType === 'answer') {
            imageDetails = {
                title: "OWQ - Answer Image",
                images: $scope.descImage
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "OWQ - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };

    //Adding OWQ question from UI
    $scope.$on('addMatchQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        var questionArr = [];
        var answerArr = [];
        var duplicateOptCnt = 0;
        var dupeAnswerCnt = 0;
        //Validation  
        if ($scope.options) {
            var noQuestion = 0;
            _.each($scope.options, function (opt, index) {
                if ($scope.isPractice) {
                    if (opt.explanation == null || opt.explanation == undefined || opt.explanation == "") {
                        $scope.errors["option." + index + ".explanation"] = "Hint is required";
                        $scope.activityErrorCount++;
                    }
                }
                if (opt.explanation && opt.explanation.length > $scope.explain_limit) {
                    $scope.errors["option." + index + ".explanation"] = "Hint does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters";
                    $scope.activityErrorCount++;
                }
                if (opt.question == null || opt.question == undefined || opt.question == "") {
                    noQuestion++;
                } else if (opt.question.length > $scope.option_limit) {
                    $scope.errors["option." + index + ".question"] = "Question does not exceed " + $scope.option_limit + " characters";
                    $scope.activityErrorCount++;
                }
                if (opt.answer == null || opt.answer == undefined || opt.answer == "") {
                    $scope.errors["option." + index + ".answer"] = "Answer is required";
                    $scope.activityErrorCount++;
                } else if (opt.answer.length > $scope.option_limit) {
                    $scope.errors["option." + index + ".answer"] = "Answer does not exceeds " + $scope.option_limit + " characters";
                    $scope.activityErrorCount++;
                }
                if (opt.question) {
                    if (questionArr.indexOf(opt.question) === -1) {
                        questionArr.push(opt.question);
                    } else {
                        duplicateOptCnt++;
                    }
                }
                if (opt.answer) {
                    if (answerArr.indexOf(opt.answer) === -1) {
                        answerArr.push(opt.answer);
                    } else {
                        dupeAnswerCnt++;
                    }
                }
            });
            if (noQuestion == $scope.options.length) {
                $scope.activityErrorCount++;
                toastr.error("Please enter atleast one question");
                return false;
            }
            if (duplicateOptCnt > 0) {
                $scope.errors['duplicateQues'] = "Qusetion is repeated.";
                $scope.activityErrorCount++;
            }
            if (dupeAnswerCnt > 0) {
                $scope.errors["duplicateAns"] = "Answer is repeated.";
                $scope.activityErrorCount++;
            }
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            if ($scope.auto_shuffle && !$scope.shuffled_options.length) {
                $scope.auto_shuffle = false;
            }
            console.log($scope.shuffled_options);
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "option": angular.copy($scope.options),
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + 'Match the following',
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id,
                "shuffled_options": $scope.shuffled_options,
                "auto_shuffle": $scope.auto_shuffle
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });
    $scope.setShuffledOPtvar = function (options) {
        $scope.shuffled_options = options;
        console.log($scope.shuffled_options);
    };
    function validateB4Shuffle() {

        var options = $scope.options,
            RHSerror = 0,
            ret_val = true,
            LHSerror = 0;
        for (var o = 0; o < options.length; o++) {
            if (!options[o].answer) {
                RHSerror++;
            }
            if (!options[o].question) {
                LHSerror++;
            }
        }
        if (RHSerror) {
            ret_val = false;
            toastr.error("Please enter all answers.!");
        }
        if (LHSerror && LHSerror == options.length) {
            ret_val = false;
            toastr.error("Please enter atleast one option!");
        }
        return ret_val;
    }
    $scope.showPreview = function (shuffle_enabled, ev) {
        if (!$scope.auto_shuffle) {
            var proceed = validateB4Shuffle();
            if (proceed) {
                $mdDialog.show({
                    controller: ['$scope', '$mdDialog', 'options', 'parentScope', 'editQuestion', 'fileUrl', 'client_shuffled_options', commonShuffleCtrl],
                    locals: {
                        options: $scope.options,
                        parentScope: $scope,
                        editQuestion: editQuestion,
                        fileUrl: $scope.fileUrl,
                        client_shuffled_options: $scope.shuffled_options
                    },
                    template: _mtfPreview2.default,
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    targetEvent: ev
                    // fullscreen: useFullScreen
                });
            } else {
                $scope.auto_shuffle = true;
            }
        }
    };
}];

exports.default = MatchController;

var commonShuffleCtrl = function commonShuffleCtrl($scope, $mdDialog, options, parentScope, editQuestion, fileUrl, client_shuffled_options) {
    _classCallCheck(this, commonShuffleCtrl);

    $scope.options = [];
    $scope.question = {
        options: [],
        shuffled_options: []
    };
    $scope.fileUrl = fileUrl;
    $scope.ret_val = [];
    function createShuffle() {
        for (var o = 0; o < options.length; o++) {
            var question = {
                tag: options[o].caption,
                desc: options[o].question,
                questionImg: options[o].questionImg
            };
            var answer = {
                tag: o + 1,
                desc: options[o].answer,
                optImage: options[o].choiceImg
            };
            var obj = {
                question: question,
                answer: answer,
                index: o
            };
            $scope.question.shuffled_options.push(obj);
            $scope.question.options.push(options[o]);
        }
    }
    function createShuffleOnEdit(editQuestion, mode) {
        var shuffled_options = editQuestion.shuffled_options;

        var _loop = function _loop(s) {
            var option_exists = _.find(options, function (one) {
                return one.caption == shuffled_options[s].mtf_question_tag;
            });
            if (option_exists) {
                var question = {
                    tag: option_exists.caption,
                    desc: option_exists.question,
                    questionImg: option_exists.questionImg
                };
                var answer = {
                    tag: s + 1,
                    desc: option_exists.answer,
                    optImage: option_exists.choiceImg
                };
                var obj = {
                    question: question,
                    answer: answer,
                    index: s
                };
                $scope.question.shuffled_options.push(obj);
            }
        };

        for (var s = 0; s < shuffled_options.length; s++) {
            _loop(s);
        }
        for (var o = 0; o < options.length; o++) {
            $scope.question.options.push(options[o]);
        }
    }
    this.$onInit = function () {
        if (editQuestion && !editQuestion.auto_shuffle && editQuestion.shuffled_options && editQuestion.shuffled_options.length) {
            if (client_shuffled_options && client_shuffled_options.length) {
                var obj = {
                    shuffled_options: client_shuffled_options
                };
                createShuffleOnEdit(obj, "editButFromClient");
            } else {
                createShuffleOnEdit(editQuestion, "db_edit_only");
            }
        } else {
            if (client_shuffled_options && client_shuffled_options.length) {
                var _obj = {
                    shuffled_options: client_shuffled_options
                };
                createShuffleOnEdit(_obj, "b4createquestion");
            } else {
                createShuffle();
            }
        }
    };
    $scope.sortableOptions = {
        containment: '#sortable-container'
    };
    function setTagNpos(isSave) {
        var shuffled_options = $scope.question.shuffled_options;
        $scope.ret_val = [];
        for (var s = 0; s < shuffled_options.length; s++) {
            var obj = {
                tag: shuffled_options[s].answer.tag,
                desc: shuffled_options[s].answer.desc,
                optImage: shuffled_options[s].answer.optImage,
                mtf_question_tag: shuffled_options[s].question.tag
            };
            $scope.ret_val.push(obj);
        }
        if (isSave) {
            return $scope.ret_val;
        }
    }
    $scope.dragControlListeners = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {
            setTagNpos();
        },
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        }
    };

    $scope.saveAction = function () {
        var array = setTagNpos(true);
        if (array && array.length) {
            toastr.success("Shuffle order saved");
            parentScope.setShuffledOPtvar(array);
            $mdDialog.hide();
        }
    };
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports = " <md-dialog aria-label=\"Not Updated Admission numbers\" flex=60> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>Shuffle Answers</h2> <span flex></span> <md-button class=md-icon-button ng-click=cancel()> </md-button> </div> </md-toolbar> <md-dialog-content> <div layout=row> <div layout=column flex=50> <div> <div ng-repeat=\"option in question.options track by $index\" class=md-whiteframe-2dp layout=row style=margin:5px> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;height:60px;font-size:14px!important>{{$index+1}}</label> <div style=display:inline-flex;width:100% flex> <label flex style=padding:5px;background:#fff;margin:0> <span style=font-size:14px!important>{{option.question}}</span> </label> <img flex ng-src=\"{{fileUrl + option.questionImg}}\" ng-if=option.questionImg class=mtf-question-img /> </div> </div> </div> </div> <div layout=column flex=50> <div as-sortable=dragControlListeners ng-model=question.shuffled_options> <div ng-repeat=\"option in question.shuffled_options\" ng-init=\"sectionIndex = $index\" as-sortable-item class=md-whiteframe-2dp layout=row style=margin:5px> <div as-sortable-item-handle style=display:inline-flex;width:100% flex> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;height:60px;font-size:14px!important>#</label> <label flex style=padding:5px;background:#fff;margin:0> <span style=font-size:14px!important>{{option.answer.desc}}</span> </label> <img flex ng-src=\"{{fileUrl + option.answer.optImage}}\" ng-if=\"option.answer && option.answer.optImage\" class=mtf-question-img /> </div> </div> </div> </div> </div> </md-dialog-content> <md-dialog-actions layout=row> <div> </div> <div> <md-button class=\"md-raised md-primary\" ng-click=saveAction()>Save</md-button> <md-button class=\"md-primary md-raised\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-actions> </form> </md-dialog>";

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mcqBulkPopup = __webpack_require__(1290);

var _mcqBulkPopup2 = _interopRequireDefault(_mcqBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: McqBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var McqBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdMedia", "$mdDialog", function McqBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdMedia, $mdDialog) {
    _classCallCheck(this, McqBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_MCQ;
    var qp_id = $scope.$parent.tqp_id;
    $scope.csvDownloadLink = '../../../img/csv-samples/MCQ-CSV-Sample.csv';
    $scope.ques_desc_limit = CQuesConst.ques_desc_limit;
    $scope.option_limit = CQuesConst.option_limit;
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    function validate(obj) {
        var errors = {};
        var answerArr = [];
        var duplicateOptCnt = 0;
        //Validation  
        if (obj.question == null || obj.question == undefined || obj.question == "") {
            errors["question"] = "Question is required";
        }
        if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
            errors.corect_answer = "Correct Answer is required";
            //activityErrorCount++;
        }
        if (obj.correctAnswerExpl && obj.correctAnswerExpl.length > CQuesConst.OPTION_LIMIT) {
            errors["correctAnswerExpl"] = "Explanation does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
        }
        if (obj.options == null || obj.options == undefined || obj.options == "") {
            errors["options"] = "Question is required";
        }
        if (obj.options) {
            var options = obj.options.split('&&');
            _.each(options, function (opt) {
                if (answerArr.indexOf(opt) === -1) {
                    answerArr.push(opt);
                } else {
                    duplicateOptCnt++;
                }
            });
        }
        if (duplicateOptCnt > 0) {
            $scope.errors['duplicateAns'] = "options are repeated.";
        }
        if (obj.hints == null || obj.hints == undefined || obj.hints == "") {
            errors["hints"] = "Hints is required";
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme, content_editor_id) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.errors = [];
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.content_editor_id = content_editor_id;
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
            };
            if ($scope.is_archive) obj.theme_id = $scope.currentTheme.theme_id;
            //Validation  
            _.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });
            if ($scope.errors.length == 0) {
                obj.ques_list = $scope.bulkUploadData;
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;
            //         if (errorCount > 0) {
            //             toastr.error("Please fill all mandatory fields")
            //             return false;
            //         } else {

            //             Meteor.apply('addBulkTf', [$scope.bulkUploadData, obj], (err, result) => {
            //                 if (err) {
            //                     toastr.error("errorr")
            //                 } else {
            //                     $mdDialog.hide();
            //                     toastr.success("Questions Added Successfully...")
            //                     $state.go("wizard.formatQuestion")
            //                 }
            //             })
            //         }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[5]) level = question[5].split('&&');
                                if (question[6]) wave = question[6].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[9]) {
                                    linkSub = question[9].split('&&');
                                }
                                if (question[10]) {
                                    linkTheme = question[10].split('&&');
                                }
                                if (question[12]) {
                                    cognitive_skills = question[12].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "options": question[1],
                                    "correctAnswer": question[2],
                                    "correctAnswerExpl": question[3],
                                    "hints": question[4],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[7],
                                    "theme": question[8],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[10],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _mcqBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity
            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = McqBulkUploadController;

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form flex> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Preview </h2> <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding flex style=overflow:visible> <md-content flex class=\"makeMeWhite md-whiteframe-2dp md-padding\"> <div class=table-responsive-vertical flex> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\" flex> <thead> <tr> <th class=\"md-body-1 bold\">Question</th> <th class=\"md-body-1 bold\">Options (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Correct Answer/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Correct Answer/s explanation/s (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Other Answer/s Hints (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <div class=errorMessage>{{errors[$index].question}}</div> </div> </td> <td class=md-body-1 data-title=Options> <div layout=column> <textarea class=md-body-1 ng-model=data.options></textarea> <div class=errorMessage>{{errors[$index].options}}</div> </div> </td> <td class=md-body-1 data-title=\"Correct Answer\"> <div layout=column> <input class=md-body-1 ng-model=data.correctAnswer> <div class=errorMessage>{{errors[$index].correctAnswer}}</div> </div> </td> <td class=md-body-1 data-title=\"Answer Explanations\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswerExpl></textarea> <div class=errorMessage>{{errors[$index].correctAnswerExpl}}</div> </div> </td> <td class=md-body-1 data-title=\"Other Answer Hints\"> <div layout=column> <input class=md-body-1 ng-model=data.hints> <div class=errorMessage>{{errors[$index].hints}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].linkSubject}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors[$index].linkTheme}}</div> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.mq-editable-field{width:100%;border:none}.mcqPatternlabelDiv{padding:10px;margin-bottom:16px;color:#3367c3;font-weight:600;border-radius:5px;background:#ddf0ff}.radioBtnInput{width:20px!important}.switchPattern{background:#ddf0ff;height:36px;padding-top:0}.patternLabelSelected{padding:5px;margin-bottom:17px;color:#fff;font-size:26px;background:#2f9479;border-radius:5px}.switchIcon{margin:-b;margin-bottom:19px;font-size:30px;margin-right:5px;color:#149014}.mainDiv .action-btn-clr{background-color:#1665c1!important;color:#fff;text-transform:capitalize}.mainDiv .compose{margin-top:5px}.mainDiv .compose-icon{margin-top:3px}.mainDiv .button-style-compose{border-radius:25px;padding-left:2px;padding-right:2px}</style> <div class=\"contentBox mainDiv\"> <md-divider class=dividerBorder> </md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=md-whiteframe-3dp ng-if=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"hand fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div id=used_editor layout=column> <div> Composed Question: </div> <div class=composed_dom ng-bind-html=used_editor_html></div> </div> <div layout=row flex layout-align=\"space-between center\"> <md-input-container md-select-on-focus flex=70> <div ng-show=isLatex class=qn-label>Enter Question</div> <span id=math-field ng-show=isLatex ng-model=question ng-paste=paste($event) style=height:auto md-select-on-focus></span> <div ng-show=!isLatex> <label ng-show=!isNotComposed>Enter Question</label> <textarea ng-show=!isNotComposed ng-model=question md-maxlength={{ques_desc_limit}} md-select-on-focus></textarea> <div class=errorMessage>{{errors['qn_desc']}}</div> </div> <md-checkbox ng-model=isLatex aria-label=Finished?>With formula</md-checkbox> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(12) + " ngf-select=questionImgUpload($files,mcqArchive) ngf-multiple=true> <div ng-show=\"questionImage.length>0\" flex=45 ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=viewTextAngular()> <div>Compose/Edit</div> </md-button> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=resetQuestion()> <div>Reset</div> </md-button> </div> </div> </div> <md-divider class=dividerBorder></md-divider> <div class=contentBox> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between end\"> <div layout=row layout-align=\"start end\" style=margin-left:3px> <div class=patternLabelSelected> <i class=\"fas fa-list-ul\"></i> </div> <div class=mcqPatternlabelDiv layout=row> <span>Answering pattern : &nbsp;</span> <span ng-if=!_MCQ.is_single_pattern>Multiple</span> <span ng-if=_MCQ.is_single_pattern>Single</span> </div> </div> <div layout=row layout-align=\"end end\" style=margin-right:3px> <div class=mcqPatternlabelDiv>Single Answer Selection:</div> <md-switch class=\"switchPattern hand\" ng-model=_MCQ.is_single_pattern aria-label=\"Switch 1\" ng-change=changeSelection()> </md-switch> </div> </div> </div> <md-divider class=dividerBorder></md-divider> <div class=contentBox> <div class=md-whiteframe-2dp> <div class=optionHeading layout=row layout-align=\"space-between start\"> <div flex=5>No.</div> <div flex=35>Answers <p class=errorMessage>{{errors[\"duplicateAns\"]}}</p> </div> <div flex=10>Hint</div> <div flex=20>Correct Answers <p class=errorMessage>{{errors[\"correctAnswer\"]}}</p> </div> </div> <div ng-repeat=\"option in options track by $index\"> <div layout=row layout-align=\"space-between center\"> <div flex=5 class=\"optionCaption mcqOptionDiv mcqOptionCaptionFont\" style=background-color:#2ab4bf>{{option.caption}}</div> <md-input-container flex=30> <div ng-show=!isLatex> <label>Option {{option.caption}}</label> <textarea ng-model=option.value md-maxlength={{option_limit}} txt-maxlength={{option_limit}}></textarea> </div> <span class=\"option-field mathquill-editable\" ng-model=option.value style=height:auto ng-show=isLatex ng-init=optionsLoaded(option) ng-paste=paste($event)></span> <p class=errorMessage>{{errors[\"option.\" + $index + \".desc\"]}}</p> </md-input-container> <div flex=5 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(12) + " ngf-select=optionImgUpload($files,option) ngf-multiple=true> <div ng-show=\"option.optImage.length>0\" flex=45 ng-click=\"openDialog('answer',$index,option.caption)\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> </div> <md-input-container flex=20> <div ng-show=!isLatex> <label>Enter Hint</label> <textarea ng-model=option.hint txt-maxlength={{explain_limit}}></textarea> </div> <span class=\"hint-field mathquill-editable\" ng-model=option.hint style=height:auto ng-init=hintsLoaded(option) ng-show=isLatex ng-paste=paste($event)> </span> <p class=errorMessage>{{errors[\"option.\" + $index + \".hint\"]}}</p> </md-input-container> <md-input-container flex=5 ng-if=!_MCQ.is_single_pattern> <md-checkbox ng-model=option.correct ng-click=correctValueClick()> </md-checkbox> <p class=errorMessage>{{errors[\"option.\" + $index + \".correctValue\"]}}</p> </md-input-container> <md-input-container flex=5 ng-if=_MCQ.is_single_pattern> <input class=\"radioBtnInput hand\" ng-if=_MCQ.is_single_pattern type=radio ng-checked=option.isChecked ng-click=\"uncheck($event, option.isChecked, $index)\"> <p class=errorMessage>{{errors[\"option.\" + $index + \".correctValue\"]}}</p> </md-input-container> <div flex=5> <img class=hand src=" + __webpack_require__(16) + " ng-click=removeOption($index)> </div> </div> <md-divider></md-divider> </div> </div> <md-button md-no-ink class=\"questionButton moreChoiceButton md-ink-ripple\" layout=row ng-click=addOption()>Add more choice <span class=plusSymbol> <i class=\"fas fa-plus\"></i> </span> </md-button> </div> ";

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _editor = __webpack_require__(56);

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: McqController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var McqController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "CONSTANTS", "$mdDialog", "$mdMedia", "uploadService", "$sce", function McqController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, CONSTANTS, $mdDialog, $mdMedia, uploadService, $sce) {
    _classCallCheck(this, McqController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var self = this;
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_MCQ;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    $scope.options = [];
    $scope.question = "";
    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.explain_limit = CQuesConst.ANS_EXPLANATION_LIMIT;
    $scope.isNotComposed = false;

    this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];
    $scope._MCQ = {};
    $scope._MCQ.is_single_pattern = true;
    var calIndex = function calIndex(index, length) {
        if (index >= length) {
            if (index - length >= length) return calIndex(index - length, length);else return index - length;
        } else return index;
    };

    var editQuestion = $scope.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        $scope.question = editQuestion.qn_desc;
        $scope.isNotComposed = true;
        $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
        $scope._MCQ.is_single_pattern = false;
        if (editQuestion.is_single_pattern) {
            $scope._MCQ.is_single_pattern = true;
        }
        $scope.isLatex = editQuestion.isLatex;
        $scope.questionImage = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        if (editQuestion.choice && editQuestion.choice.length > 0) {
            _.each(editQuestion.choice, function (ch) {
                var colorIndex = calIndex($scope.options.length, 4);
                var optionImage = [];
                if (ch.optImage) {
                    if (Array.isArray(ch.optImage)) {
                        optionImage = ch.optImage;
                    } else {
                        optionImage.push(ch.optImage);
                    }
                }
                $scope.options.push({
                    'caption': ch.tag,
                    'color': self.optionColors[colorIndex],
                    'value': ch.desc,
                    'hint': ch.hint,
                    'correct': ch.correct,
                    'optImage': optionImage
                });
            });
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    } else {
        for (var i = 0; i < 4; i++) {
            var option = {
                caption: self.alphabets[i],
                color: self.optionColors[i],
                optImage: []
            };
            $scope.options.push(option);
        }
    }
    checkCorrectOptionOnEdit();
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    var imageViewType = "";
    var optIndex = -1;

    $scope.addOption = function () {
        var alphaIndex = calIndex($scope.options.length, 26);
        var colorIndex = calIndex($scope.options.length, 4);
        var option = {
            'caption': self.alphabets[alphaIndex],
            'color': self.optionColors[colorIndex],
            'optImage': []
        };
        $scope.options.push(option);
    };
    $scope.removeOption = function (index) {
        if ($scope.options.length == 2) {
            return false;
        } else {
            var tempOptions = [];
            angular.copy($scope.options, tempOptions);
            for (var i = 0; i < $scope.options.length; i++) {
                if (i > index) {
                    $scope.options[i].caption = tempOptions[i - 1].caption;
                    $scope.options[i].color = tempOptions[i - 1].color;
                }
            }
            $scope.options.splice(index, 1);
        }
    };

    //Question desc with latex
    var mathFieldSpan = document.getElementById('math-field');
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    var MQ = MathQuill.getInterface(2);
    if ($scope.question) {
        mathFieldSpan.textContent = $scope.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.question = mathField.latex();
            }
        }
    });

    //Invokes after the option elements loaded
    $scope.optionsLoaded = function (option) {
        var optionFieldSpan = document.getElementsByClassName('option-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.value) {
                spanElement.textContent = option.value;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.value = optionField.latex();
                    }
                }
            });
        });
    };

    //Invokes after the hint elements loaded
    $scope.hintsLoaded = function (option) {
        var hintFieldSpan = document.getElementsByClassName('hint-field');
        _.each(hintFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.hint) {
                spanElement.textContent = option.hint;
            }
            var hintField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.hint = hintField.latex();
                    }
                }
            });
        });
    };

    //PREVENT PASTE FUNCTIONALITY
    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //Image upload for Desc
    $scope.optionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        var index = -1;
                        _.each($scope.options, function (key, val) {
                            if (key.caption === opt.caption) {
                                index = val;
                            }
                        });
                        $scope.options[index].optImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };
    //Open dialog to view image
    $scope.openDialog = function (imageType, index, desc) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "MCQ - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'answer') {
            $scope.imageArray = $scope.options[index].optImage;
            optIndex = index;
            imageDetails = {
                title: "MCQ - Answer Image",
                images: $scope.imageArray
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "MCQ - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };
    //Adding OWQ question from UI
    $scope.$on('addMcqQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        $scope.errors = {};
        var answerArr = [];

        var duplicateOptCnt = 0;

        var isCorrectAnswerExists = false;

        //Validation  
        if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
            $scope.errors["qn_desc"] = "Question is required";
            activityErrorCount++;
        } else if ($scope.question.length > $scope.ques_desc_limit) {
            $scope.errors["qn_desc"] = "Question does not exceed " + $scope.ques_desc_limit + " characters";
            activityErrorCount++;
        }
        if ($scope.options) {
            _.each($scope.options, function (answer, index) {
                if (answer.hint && answer.hint.length > $scope.explain_limit) {
                    $scope.errors["option." + index + ".hint"] = "Hint does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters";
                    activityErrorCount++;
                }
                if (answer.value == null || answer.value == undefined || answer.value == "") {
                    $scope.errors["option." + index + ".desc"] = "Answer is required";
                    activityErrorCount++;
                } else if (answer.value.length > $scope.option_limit) {
                    $scope.errors["option." + index + ".desc"] = "Answer does not exceed " + CQuesConst.OPTION_LIMIT + " characters";
                    activityErrorCount++;
                }
                if (answer.correct) isCorrectAnswerExists = true;
                if (answer.value) {
                    if (answerArr.indexOf(answer.value) === -1) {
                        answerArr.push(answer.value);
                    } else {
                        duplicateOptCnt++;
                    }
                }
            });
            if (!isCorrectAnswerExists) {
                var str = "Select a correct answer";
                if (!$scope._MCQ.is_single_pattern) {
                    str = "Select atleast one answer";
                }
                $scope.errors["correctAnswer"] = str;
                activityErrorCount++;
            }
            if (duplicateOptCnt > 0) {
                $scope.errors['duplicateAns'] = "options are repeated.";
                activityErrorCount++;
            }
        }
        var choicesData = [];
        _.each($scope.options, function (optionObj, index) {
            var option = {
                "tag": optionObj.caption,
                "desc": optionObj.value,
                "correct": optionObj.correct,
                "optImage": optionObj.optImage,
                "hintImage": ""
            };
            if (optionObj.correct) {
                option["hint"] = optionObj.hint;
                option['curr'] = 1;
            } else {
                option["correct"] = false;
                option["hint"] = optionObj.hint;
                option['curr'] = 0;
            }
            choicesData.push(option);
        });
        self.Cans = 0;
        self.NcAns = 0;
        _.each(choicesData, function (eachChoice) {
            if (eachChoice.curr == "1") {
                self.Cans++;
            } else {
                self.NcAns = 0;
            }
        });
        var isAllow = 1;
        if (self.Cans === 0 || choicesData.length === self.Cans) {
            isAllow = 0;
            if (choicesData.length === self.Cans) {
                isAllow = 2;
            }
        }

        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "choice": choicesData,
                "descImage": $scope.descImage,
                "explanation": $scope.explanation,
                "explanationImage": $scope.explanationImage,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "user_id": userId,
                'activity_id': question.activity_id,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id,
                is_single_pattern: $scope._MCQ.is_single_pattern
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    $scope.changeSelection = function () {
        var options = $scope.options;
        if ($scope.errors && $scope.errors["correctAnswer"]) {
            $scope.errors["correctAnswer"] = '';
        }
        for (var o = 0; o < options.length; o++) {
            options[o]['correct'] = false;
            options[o]['isChecked'] = false;
        }
        var string = "Selected multiple answer pattern";
        if ($scope._MCQ.is_single_pattern) {
            string = "Selected single answer pattern";
        }
        toastr.success(string);
    };
    $scope.uncheck = function (event, isChecked, index) {
        var options = $scope.options;
        if ($scope._MCQ.is_single_pattern) {
            for (var o = 0; o < options.length; o++) {
                options[o]['isChecked'] = false;
                if (o == index) {
                    if (options[o]['isChecked'] !== event.target.value) {
                        options[o]['isChecked'] = true;
                        options[o]['correct'] = true;
                    }
                } else {
                    options[o]['isChecked'] = false;
                    options[o]['correct'] = false;
                }
            }
        }
    };
    function checkCorrectOptionOnEdit() {
        if ($scope._MCQ.is_single_pattern) {
            var options = $scope.options;
            for (var o = 0; o < options.length; o++) {
                if (options[o]['correct']) {
                    options[o]['isChecked'] = true;
                }
            }
            console.log(options);
        }
    }

    $scope.viewTextAngular = function () {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
            locals: {
                parentScope: $scope
            },
            template: _editor2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    };
    $scope.setQuestionFromEditor = function (editor_value) {
        $scope.question = editor_value;
        $scope.used_editor = true;
        $scope.isNotComposed = true;
        var used_editor = document.getElementById('used_editor');
        $scope.used_editor_html = $sce.trustAsHtml(editor_value);
        // used_editor.append(editor_value)
        console.log(used_editor);
    };
    function resetFn() {
        $scope.isNotComposed = false;
        $scope.question = '';
        $scope.used_editor_html = '';
    }
    $scope.resetQuestion = function () {
        var confirm = $mdDialog.confirm().title('Remove').textContent('This will remove question from the input, If you want to edit use editor').ariaLabel('Lucky day').ok('Remove').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            resetFn();
        }, function (f, r) {});
    };
    // $scope.uncheck = (event, isChecked, index) => {
    //     let options = $scope.options
    //     if($scope._MCQ.is_single_pattern){
    //         for (let o = 0; o < options.length; o++) {
    //             options[o]['isChecked'] = false
    //             if(o == index){
    //                 if(options[o]['isChecked'] !== event.target.value){
    //                     options[o]['isChecked'] = true
    //                     options[o]['correct'] = true
    //                 }
    //             }else{
    //                 options[o]['isChecked'] = false
    //                 options[o]['correct'] = false
    //             }
    //         }
    //     }
    // }
}];

var editorLACtrl = function editorLACtrl($scope, $mdDialog, parentScope) {
    _classCallCheck(this, editorLACtrl);

    Simditor.locale = 'en-US';
    var editor = undefined;
    angular.element(document).ready(function () {
        $scope.editor = {};
        editor = new Simditor({
            textarea: $('#editor'),
            placeholder: '',
            params: {},
            upload: false,
            tabIndent: true,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
            // 'image',
            'hr', 'indent', 'outdent', 'alignment'],
            toolbarFloat: true,
            toolbarFloatOffset: 0,
            toolbarHidden: false,
            pasteImage: false,
            cleanPaste: false,
            codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
            //optional options
        });
        if (parentScope.question) {
            editor.setValue(parentScope.question);
        }
    });
    $scope.saveContent = function (desc) {
        console.log(desc);
        console.log($scope.editor);
        var editor_value = editor.getValue();
        if (!editor_value) {
            toastr.error("Please enter question");
            return false;
        }
        parentScope.setQuestionFromEditor(editor_value);
        $mdDialog.hide();
    };
    $scope.closeEditor = function () {
        $mdDialog.hide();
    };
};

exports.default = McqController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _owqBulkPopup = __webpack_require__(1295);

var _owqBulkPopup2 = _interopRequireDefault(_owqBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: OwqBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var OwqBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdDialog", "$mdMedia", function OwqBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdDialog, $mdMedia) {
    _classCallCheck(this, OwqBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    $scope.content_editor_id = userId;
    var qp_id = $scope.$parent.tqp_id;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_OWQ;
    $scope.csvDownloadLink = '../../../img/csv-samples/OWQ-CSV-Sample.csv';
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    function validate(obj) {
        var errors = {};
        //Validation  
        if (obj.question == null || obj.question == undefined || obj.question == "") {
            errors['question'] = "Question is required";
        } else if (obj.question.length > CQuesConst.QUES_DESC_LIMIT) {
            errors['question'] = "Question does not exceeds " + CQuesConst.QUES_DESC_LIMIT + " characters";
        }
        if (obj.correctAnswerExpl && obj.correctAnswerExpl.length > CQuesConst.OPTION_LIMIT) {
            errors["correctAnswerExpl"] = "Explanation does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
        }
        if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
            errors["correctAnswer"] = "Answer is required";
        } else if (obj.correctAnswer.length > CQuesConst.OPTION_LIMIT) {
            errors["correctAnswer"] = "Answer does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
            };
            if ($scope.is_archive) obj.theme_id = $scope.currentTheme.theme_id;
            //Validation  
            _.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });

            if ($scope.errors.length == 0) {
                obj.ques_list = $scope.bulkUploadData;
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;

            //         if (errorCount > 0) {
            //             toastr.error("Please fill all mandatory fields")
            //             return false;
            //         } else {

            //             Meteor.apply('addBulkTf', [$scope.bulkUploadData, obj], (err, result) => {
            //                 if (err) {
            //                     toastr.error("errorr")
            //                 } else {
            //                     $mdDialog.hide();
            //                     toastr.success("Questions Added Successfully...")
            //                     $state.go("wizard.formatQuestion")
            //                 }
            //             })
            //         }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[3]) level = question[3].split('&&');
                                if (question[4]) wave = question[4].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[7]) {
                                    linkSub = question[7].split('&&');
                                }
                                if (question[8]) {
                                    linkTheme = question[8].split('&&');
                                }
                                if (question[10]) {
                                    cognitive_skills = question[10].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "correctAnswer": question[1],
                                    "correctAnswerExpl": question[2],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[5],
                                    "theme": question[6],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[9],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _owqBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity
            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = OwqBulkUploadController;

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=makeMeWhitemd-whiteframe-2dp> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question</th> <th class=\"md-body-1 bold\">Correct Answer/s</th> <th class=\"md-body-1 bold\">Correct Answer/s explanation/s</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <p class=errorMessage>{{errors[$index].question}}</p> </div> </td> <td class=md-body-1 data-title=\"Correct Answer\"> <div layout=column> <input class=md-body-1 ng-model=data.correctAnswer> <p class=errorMessage>{{errors[$index].correctAnswer}}</p> </div> </td> <td class=md-body-1 data-title=\"Answer Explanations\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswerExpl></textarea> <p class=errorMessage>{{errors[$index].correctAnswerExpl}}</p> </div> </td><td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=Wave> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.label_answers{color:#555d72;font-family:auto}.mainDiv .action-btn-clr{background-color:#1665c1!important;color:#fff;text-transform:capitalize}.mainDiv .compose{margin-top:5px}.mainDiv .compose-icon{margin-top:3px}.mainDiv .button-style-compose{border-radius:25px;padding-left:2px;padding-right:2px}</style> <div class=\"contentBox mainDiv\"> <md-divider class=dividerBorder> </md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=md-whiteframe-3dp ng-if=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div id=used_editor layout=column> <div> Composed Question: </div> <div class=composed_dom ng-bind-html=used_editor_html></div> </div> <div layout=row layout-align=\"space-between center\" flex> <md-input-container flex=70> <div ng-show=!isLatex> <label ng-show=!isNotComposed>Enter Question</label> <textarea ng-show=!isNotComposed ng-model=question md-maxlength={{ques_desc_limit}} txt-maxlength={{ques_desc_limit}} md-select-on-focus></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Question</div> <span id=owq-math-field ng-model=question rows=2 md-select-on-focus style=height:auto ng-show=isLatex clean-spaces md-select-on-focus ng-paste=paste($event)></span> <md-checkbox ng-model=isLatex aria-label=Finished?> With formula </md-checkbox> <p class=errorMessage>{{errors.qn_desc}}</p> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(22) + " ngf-select=questionImgUpload($files,owqArchive) ngf-multiple=true> <div flex=45 ng-show=\"questionImage.length > 0\" ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=viewTextAngular()> <div>Compose/Edit</div> </md-button> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=resetQuestion()> <div>Reset</div> </md-button> </div> </div> <div layout=row layout-align=\"space-between center\"> <div flex=40 layout=column> <md-input-container flex=100> <div ng-show=!isLatex> <label>Enter Answer</label> <textarea ng-model=desc md-maxlength={{option_limit}} txt-maxlength={{option_limit}}></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Answer</div> <span id=owq-answer-field ng-show=isLatex ng-model=desc style=height:auto ng-paste=paste($event)></span> <p class=errorMessage>{{errors.desc}}</p> </md-input-container> <div flex=100> <label class=label_answers> Enter multiple answers separated with comma </label> </div> </div> <div flex=5 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(22) + " ngf-select=descImgUpload($files,owqArchive) ngf-multiple=true> <div flex=45 ng-show=\"descImage.length > 0\" ng-click=\"openDialog('answer')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> </div> <md-input-container flex=40> <div ng-show=!isLatex> <label>Enter Explanation</label> <textarea ng-model=explanation txt-maxlength=explain_limit></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Explanation</div> <span id=owq-explanation-field ng-show=isLatex ng-model=explanation style=height:auto ng-paste=paste($event)></span> <p class=errorMessage>{{errors.explanation}}</p> </md-input-container> <div flex=5 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(22) + " ngf-select=explanationImgUpload($files,owqArchive) ngf-multiple=true> <div flex=45 ng-show=\"explanationImage.length > 0\" ng-click=\"openDialog('explan')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> </div> </div> </div> <md-divider class=dividerBorder> </md-divider>";

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _editor = __webpack_require__(56);

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: OwqController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */

var OwqController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "CONSTANTS", "$mdDialog", "$mdMedia", "uploadService", "$sce", function OwqController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, CONSTANTS, $mdDialog, $mdMedia, uploadService, $sce) {
    _classCallCheck(this, OwqController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.use_editor = false;
    //On destroy function
    this.$onDestroy = function () {};

    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_OWQ_SAVE;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    $scope.isPassagePresent = false;
    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.explain_limit = CQuesConst.ANS_EXPLANATION_LIMIT;

    //SET UI FOR EDIT QUESTIONS
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion && editQuestion.answer) {
        $scope._id = editQuestion._id;
        $scope.desc = editQuestion.answer[0].desc;
        $scope.question = editQuestion.qn_desc;
        $scope.isNotComposed = true;
        $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
        $scope.isLatex = editQuestion.isLatex;
        $scope.questionImg = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        $scope.explanation = editQuestion.answer[0].explanation;
        $scope.descImage = [];
        if (editQuestion.descImage) {
            if (Array.isArray(editQuestion.descImage)) {
                $scope.descImage = editQuestion.descImage;
            } else {
                $scope.descImage.push(editQuestion.descImage);
            }
        }
        $scope.explanationImage = [];
        if (editQuestion.explanationImage) {
            if (Array.isArray(editQuestion.explanationImage)) {
                $scope.explanationImage = editQuestion.explanationImage;
            } else {
                $scope.explanationImage.push(editQuestion.explanationImage);
            }
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    }

    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    //BASIC DETAIL FOR LATEX
    var MQ = MathQuill.getInterface(2);
    //LATEX FOR QUESTION
    var mathFieldSpan = document.getElementById('owq-math-field');
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.question) {
        mathFieldSpan.textContent = $scope.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.question = mathField.latex();
            }
        }
    });
    //LATEX FOR ANSWER
    var answerFieldSpan = document.getElementById('owq-answer-field');
    answerFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.desc) {
        answerFieldSpan.textContent = $scope.desc;
    }
    var answerField = MQ.MathField(answerFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.desc = answerField.latex();
            }
        }
    });
    //LATEX FOR EXPLANATION
    var expFieldSpan = document.getElementById('owq-explanation-field');
    expFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.explanation) {
        expFieldSpan.textContent = $scope.explanation;
    }
    var expField = MQ.MathField(expFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.explanation = expField.latex();
            }
        }
    });

    //PREVENT PASTE FUNCTIONALITY
    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //Image upload for Desc
    $scope.descImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.descImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //Image upload for explanation
    $scope.explanationImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.explanationImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };
    //Open dialog to view image
    $scope.openDialog = function (imageType) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "OWQ - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'explan') {
            imageDetails = {
                title: "OWQ - Explanation Image",
                images: $scope.explanationImage
            };
        } else if (imageType === 'answer') {
            imageDetails = {
                title: "OWQ - Answer Image",
                images: $scope.descImage
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "OWQ - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };

    //Adding OWQ question from UI
    $scope.$on('addOwqQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //Validation  
        if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
            $scope.errors['qn_desc'] = "Question is required";
            activityErrorCount++;
        } else if ($scope.question.length > CQuesConst.QUES_DESC_LIMIT) {
            $scope.errors['qn_desc'] = "Question does not exceeds " + CQuesConst.QUES_DESC_LIMIT + " characters";
            // activityErrorCount++;
        }
        if (question.isPractice) {
            if ($scope.explanation == null || $scope.explanation == undefined || $scope.explanation == "") {
                $scope.errors["explanation"] = "Explanation is required";
                activityErrorCount++;
            }
        }
        if ($scope.explanation && $scope.explanation.length > CQuesConst.ANS_EXPLANATION_LIMIT) {
            $scope.errors["explanation"] = "Explanation does not exceeds " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters";
            activityErrorCount++;
        }
        if ($scope.desc == null || $scope.desc == undefined || $scope.desc == "") {
            $scope.errors["desc"] = "Answer is required";
            activityErrorCount++;
        } else if ($scope.desc.length > CQuesConst.OPTION_LIMIT) {
            $scope.errors["desc"] = "Answer does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
            activityErrorCount++;
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "desc": $scope.desc,
                "descImage": $scope.descImage,
                "explanation": $scope.explanation,
                "explanationImage": $scope.explanationImage,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    $scope.viewTextAngular = function () {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
            locals: {
                parentScope: $scope
            },
            template: _editor2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    };
    $scope.setQuestionFromEditor = function (editor_value) {
        $scope.question = editor_value;
        $scope.used_editor = true;
        $scope.isNotComposed = true;
        var used_editor = document.getElementById('used_editor');
        $scope.used_editor_html = $sce.trustAsHtml(editor_value);
        // used_editor.append(editor_value)
        console.log(used_editor);
    };
    function resetFn() {
        $scope.isNotComposed = false;
        $scope.question = '';
        $scope.used_editor_html = '';
    }
    $scope.resetQuestion = function () {
        var confirm = $mdDialog.confirm().title('Remove').textContent('This will remove question from the input, If you want to edit use editor').ariaLabel('Lucky day').ok('Remove').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            resetFn();
        }, function (f, r) {});
    };
}];

var editorLACtrl = function editorLACtrl($scope, $mdDialog, parentScope) {
    _classCallCheck(this, editorLACtrl);

    Simditor.locale = 'en-US';
    var editor = undefined;
    angular.element(document).ready(function () {
        $scope.editor = {};
        editor = new Simditor({
            textarea: $('#editor'),
            placeholder: '',
            params: {},
            upload: false,
            tabIndent: true,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
            // 'image',
            'hr', 'indent', 'outdent', 'alignment'],
            toolbarFloat: true,
            toolbarFloatOffset: 0,
            toolbarHidden: false,
            pasteImage: false,
            cleanPaste: false,
            codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
            //optional options
        });
        if (parentScope.question) {
            editor.setValue(parentScope.question);
        }
    });
    $scope.saveContent = function (desc) {
        console.log(desc);
        console.log($scope.editor);
        var editor_value = editor.getValue();
        if (!editor_value) {
            toastr.error("Please enter question");
            return false;
        }
        parentScope.setQuestionFromEditor(editor_value);
        $mdDialog.hide();
    };
    $scope.closeEditor = function () {
        $mdDialog.hide();
    };
};

exports.default = OwqController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.btn,.btn-large{color:#424242!important;background-color:#d6dff5!important;height:30px;width:46px;margin:0 2px}.popup-header-color{background:#00b6f2!important;color:#fff;padding:5px}.dialog-content{width:100%}</style> <div class=contentBox> <div layout=row layout-align=\"space-between center\" flex> <md-input-container flex=50> <label>Passage Name</label> <textarea ng-model=passage_name md-maxlength=50 txt-maxlength=50 md-select-on-focus></textarea> <p class=errorMessage>{{errors.passage_name}}</p> </md-input-container> <div flex=20 layout=row layout-align=\"space-between center\"> <img class=hand src=" + __webpack_require__(22) + " ngf-select=descImgUpload($files,ibt) ngf-multiple=true> <div flex=45 ng-show=\"descImage.length > 0\" ng-click=openDialog()><img class=hand src=" + __webpack_require__(20) + " /></div> </div> </div> <textarea id=editor ng-model=passage_desc value=editor.desc autofocus></textarea> </div> ";

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: PassageController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var PassageController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "$mdMedia", "uploadService", function PassageController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, $mdMedia, uploadService) {
    _classCallCheck(this, PassageController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    Simditor.locale = 'en-US';
    var editor = undefined;
    editor = new Simditor({
        textarea: $('#editor'),
        placeholder: '',
        params: {},
        upload: false,
        tabIndent: true,
        toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
        // 'image',
        'hr', 'indent', 'outdent', 'alignment'],
        toolbarFloat: true,
        toolbarFloatOffset: 0,
        toolbarHidden: false,
        pasteImage: false,
        cleanPaste: false,
        codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
        //optional options
    });
    //On destroy function
    this.$onDestroy = function () {};

    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_PASSAGE;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;

    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;

    //SET UI FOR EDIT QUESTIONS
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        $scope.passage_name = editQuestion.passage_title;
        $scope.passage_desc = editQuestion.passage_desc;
        editor.setValue(editQuestion.passage_desc);
        $scope.question_ids = [];
        if (editQuestion.question_ids) {
            $scope.question_ids = editQuestion.question_ids;
        }
        if (editQuestion.passage_image) {
            if (Array.isArray(editQuestion.passage_image)) {
                $scope.descImage = editQuestion.passage_image;
            } else {
                $scope.descImage.push(editQuestion.passage_image);
            }
        }
    }

    //PREVENT PASTE FUNCTIONALITY
    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    //Image upload for Desc
    $scope.descImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.descImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            $scope.descImage = $scope.imageArray;
            $scope.imageArray = [];
        };
    };

    //Open dialog to view image
    $scope.openDialog = function () {
        var imageDetails = void 0;
        imageDetails = {
            title: "Passage - Question Image",
            images: $scope.descImage
        };

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {

                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
        };

        /*
         * Function to select passage
         */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id === passage_id) {
                    if (eachPas.isSelected) $scope.selectedPassage = eachPas;else $scope.selectedPassage = null;
                } else {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };

        /*
         * Function to cancel select passage
         */
        $scope.cancelSelectedPasssage = function () {
            $scope.selectedPassage = null;
        };
    };

    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        var isPassagePresent = false;
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage && $scope.selectedPassage._id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                    $mdDialog.show({
                        locals: {
                            passages: result
                        },
                        template: _passagePopup2.default,
                        controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                        parent: angular.element(document.body),
                        clickOutsideToClose: true,
                        fullscreen: useFullScreen
                    });
                }
            }
        }
        if (!isPassagePresent) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
        }
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        var authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId
        };
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);
    };

    //Adding Passage question from UI
    $scope.$on('addPassage', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        var editor_value = editor.getValue();
        $scope.passage_desc = editor_value;
        //Validation 
        $scope.errors = {};

        if ($scope.passage_name == undefined || $scope.passage_name == "" || $scope.passage_name == null) {
            $scope.activityErrorCount++;
            $scope.errors['passage_name'] = "Passage title is requrired";
        }
        if (editor_value == undefined || editor_value == "" || editor_value == null) {
            $scope.activityErrorCount++;
            $scope.errors["passage_desc"] = "Passage is requrired";
        }
        $scope.passage_desc = editor_value;
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "passage_image": $scope.descImage,
                "passage_desc": editor_value,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.passage_name,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.question_type == "passage" && question.is_traditional_activity) {
                        toastr.success("Passage Saved successfully.");
                        $scope.passage_name = undefined;
                        $scope.passage_desc = undefined;
                        $scope.descImage = [];
                    } else if (question.question_type == "passage" && (question.teaching_plan_id !== undefined || question.teaching_plan_id !== null || question.teaching_plan_id !== "")) {
                        toastr.success("Passage Saved successfully. ");
                        $scope.passage_name = undefined;
                        $scope.passage_desc = undefined;
                        $scope.descImage = [];
                    } else {
                        toastr.success("Passage saved successfully.");
                        $rootScope.setSearchFieldSession();
                    }
                    // if(result.data.isExists){
                    //     toastr.success("Question already exists");
                    // }
                    // else{
                    //     toastr.success("Question Saved successfully");
                    // }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });
}];

exports.default = PassageController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _shortBulkPopup = __webpack_require__(1302);

var _shortBulkPopup2 = _interopRequireDefault(_shortBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: ShortBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var ShortBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdDialog", "$mdMedia", function ShortBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdDialog, $mdMedia) {
    _classCallCheck(this, ShortBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_SA;
    $scope.csvDownloadLink = '../../../img/csv-samples/SA-CSV-Sample.csv';
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    var qp_id = $scope.$parent.tqp_id;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    function validate(obj) {
        var errors = {};
        //Validation  
        if (obj.question == null || obj.question.trim() == undefined || obj.question == "") {
            errors.question = "Question is required";
        } else if (obj.question.length > $scope.ques_desc_limit) {
            errors.question = "Question does not exceed " + $scope.ques_desc_limit + " characters";
        }
        if (obj.valuePoints.length == 0) {
            errors.value_points = "Atleast One Value point is required";
        }
        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
            };
            var errorCount = 0;

            //Validation  
            _.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });

            if ($scope.errors.length == 0) {
                //SAVE CALL
                obj.ques_list = $scope.bulkUploadData;
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;
            //         if (errorCount > 0) {
            //             toastr.error("Please fill all mandatory fields")
            //             return false;
            //         } else {

            //             Meteor.apply('addBulkTf', [$scope.bulkUploadData, obj], (err, result) => {
            //                 if (err) {
            //                     toastr.error("errorr")
            //                 } else {
            //                     $mdDialog.hide();
            //                     toastr.success("Questions Added Successfully...")
            //                     $state.go("wizard.formatQuestion")
            //                 }
            //             })
            //         }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {

                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[2]) level = question[2].split('&&');
                                if (question[3]) wave = question[3].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[6]) {
                                    linkSub = question[6].split('&&');
                                }
                                if (question[7]) {
                                    linkTheme = question[7].split('&&');
                                }
                                if (question[9]) {
                                    cognitive_skills = question[9].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "valuePoints": question[1],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[4],
                                    "theme": question[5],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[8],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _shortBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity
            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = ShortBulkUploadController;

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content class=\"makeMeWhite md-whiteframe-2dp\"> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question</th> <th class=\"md-body-1 bold\">Value Points/Key points (Use && to discriminate)</th><th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <p class=errorMessage>{{errors[$index].question}}</p> </div> </td> <td class=md-body-1 data-title=\"Value Points\"> <div layout=column> <textarea class=md-body-1 ng-model=data.valuePoints></textarea> <p class=errorMessage>{{errors[$index].valuePoints}}</p> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].linkSubject}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors[$index].linkTheme}}</div> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.mainDiv .action-btn-clr{background-color:#1665c1!important;color:#fff;text-transform:capitalize}.mainDiv .compose{margin-top:5px}.mainDiv .compose-icon{margin-top:3px}.mainDiv .button-style-compose{border-radius:25px;padding-left:2px;padding-right:2px}</style> <div class=\"contentBox mainDiv\"> <md-divider class=dividerBorder> </md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage=false\" class=md-whiteframe-3dp ng-if=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div id=used_editor layout=column> <div> Composed Question: </div> <div class=composed_dom ng-bind-html=used_editor_html></div> </div> <div layout=row layout-align=\"space-between center\" flex> <md-input-container flex=70> <div ng-show=!isLatex> <label ng-show=!isNotComposed>Enter Question</label> <textarea ng-show=!isNotComposed ng-model=question md-maxlength={{ques_desc_limit}} md-select-on-focus></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Question</div> <span id=short-math-field ng-show=isLatex ng-model=question style=height:auto md-select-on-focus ng-paste=paste($event)></span> <md-checkbox ng-model=isLatex> With formula </md-checkbox> <p class=errorMessage>{{errors.qn_desc}}</p> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10 layout=row layout-align=\"space-between center\"> <img src=" + __webpack_require__(12) + " ngf-select=questionImgUpload($files,shortArchive) ngf-multiple=true> <div flex=45 ng-show=\"questionImage.length > 0\" ng-click=\"openDialog('question')\"> <img class=hand src=" + __webpack_require__(27) + " /> </div> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=viewTextAngular()> <div>Compose/Edit</div> </md-button> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=resetQuestion()> <div>Reset</div> </md-button> </div> </div> <div layout=row layout-align=\"start center\"> <md-input-container flex=40 class=valuePoint> <div ng-show=!isLatex> <label>Value Point Name</label> <textarea ng-model=valuePoint md-maxlength={{val_pt_limit}}></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Value Point</div> <span id=short-valuepoint-field ng-show=isLatex ng-model=valuePoint style=height:auto md-select-on-focus ng-paste=paste($event)></span> <div class=errorMessage>{{errors[\"value_points\"]}}</div> </md-input-container> <div flex=5> <i class=\"fas fa-plus-circle addIcon\" ng-click=addPoint()></i> </div> </div> <div layout=column flex=65 ng-if=\"valuePoints.length>0\"> <div layout=row flex layout-align=\"start center\" class=valuePointHeading> <div flex=60>Value Points</div> <div flex=20>Delete</div> <div flex=20>Edit</div> </div> <div layout=row flex layout-align=\"start center\" ng-repeat=\"valuePoint in valuePoints\" class=valuePointDiv> <div flex=60> <div ng-init=initformatLatex() class=latex_field ng-show=\"isLatex && valuePoint.isEdit==false\">{{valuePoint.point}}</div> <div ng-show=!isLatex ng-if=\"valuePoint.isEdit==false\">{{valuePoint.point}}</div> <md-input-container class=valuePointEdit ng-if=\"valuePoint.isEdit==true\"> <textarea ng-init=valuePointsInit(valuePoint) ng-model=valuePoint.point md-maxlength={{val_pt_limit}} txt-maxlength={{val_pt_limit}} ng-show=!isLatex></textarea> <span ng-init=valuePointsInit(valuePoint) class=short-valuepoint-edit-field ng-show=isLatex ng-model=valuePoint.point style=height:auto md-select-on-focus ng-paste=paste($event)></span> </md-input-container> <p class=errorMessage>{{errors.value_points}}</p> </div> <div flex=20 class=valuePointImagePadding ng-click=removePoint($index)> <img class=hand src=" + __webpack_require__(16) + "> </div> <div flex=20 class=valuePointImagePadding ng-click=editPoint($index) style=padding-left:0> <i class=\"fa-lg far fa-edit\" ng-if=\"valuePoint.isEdit==false\"></i> <img class=hand src=" + __webpack_require__(443) + " ng-click=updatePoint($index) ng-if=\"valuePoint.isEdit==true\"> </div> </div> </div> </div> <md-divider class=dividerBorder> </md-divider>";

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _editor = __webpack_require__(56);

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: ShortController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var ShortController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "$mdMedia", "uploadService", "$timeout", "$sce", function ShortController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, $mdMedia, uploadService, $timeout, $sce) {
    _classCallCheck(this, ShortController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    if (!$scope.shortArchive) {
        $scope.shortArchive = {};
    }
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_SA;
    $scope.questionImage = [];
    $scope.descImage = [];
    $scope.explanationImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;

    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.questionImage = [];
    $scope.valuePoints = [];
    $scope.errors = {};

    $scope.isNotComposed = false;

    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion) {
        $scope._id = editQuestion._id;
        $scope.question = editQuestion.qn_desc;
        $scope.isNotComposed = true;
        $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
        $scope.isLatex = editQuestion.isLatex;
        $scope.questionImage = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        if (editQuestion.value_points) {
            $scope.valuePoints = _.map(editQuestion.value_points, function (point) {
                point["point"] = point.name;
                point["isEdit"] = false;
                return point;
            });
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    }
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    //Question desc with latex
    var MQ = MathQuill.getInterface(2);
    var mathFieldSpan = document.getElementById('short-math-field');
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.question !== undefined) {
        mathFieldSpan.textContent = $scope.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.question = mathField.latex();
            }
        }
    });

    //Invokes after the option elements loaded
    $scope.valuePointsInit = function (option) {
        var optionFieldSpan = document.getElementsByClassName('short-valuepoint-edit-field');
        _.each(optionFieldSpan, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            if (option.point) {
                spanElement.textContent = option.point;
            }
            var optionField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        option.point = optionField.latex();
                    }
                }
            });
        });
    };

    var mathValuePointFieldSpan = document.getElementById('short-valuepoint-field');
    mathValuePointFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.valuePoint) {
        mathValuePointFieldSpan.textContent = $scope.valuePoint;
    }
    var mathValuePointField = MQ.MathField(mathValuePointFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.valuePoint = mathValuePointField.latex();
            }
        }
    });

    var formatLatex = function formatLatex() {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('latex_field');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    $scope.initformatLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('latex_field');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.addPoint = function () {
        if ($scope.valuePoint) {
            $scope.errors["value_points"] = "";
            if ($scope.valuePoint.length > CQuesConst.VALUE_POINTS_LIMIT) {
                $scope.errors["value_points"] = "value point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT;
            } else {
                var point = $scope.valuePoint;
                var mark = $scope.valuepointMark;
                var valuePoint = {
                    point: point,
                    mark: mark,
                    isEdit: false
                };
                $scope.valuePoints.push(valuePoint);
                if ($scope.isLatex) $scope.valuePoint = mathValuePointField.latex("");else $scope.valuePoint = "";
                $scope.valuepointMark = "";
            }
        } else {
            $scope.errors["value_points"] = "Value point is required";
        }
    };
    $scope.removePoint = function (index) {
        $scope.valuePoints.splice(index, 1);
    };
    $scope.editPoint = function (index) {
        $scope.valuePoints[index].isEdit = true;
    };
    $scope.updatePoint = function (index) {
        var valuePoints = [];
        if ($scope.valuePoints[index].point.length < 0) {
            $scope.errors["value_points." + index + ".point"] = "Value point is required";
        } else if ($scope.valuePoints[index].point.length > CQuesConst.VALUE_POINTS_LIMIT) {
            $scope.errors["value_points." + index + ".point"] = "Value Point does not exceed " + CQuesConst.VALUE_POINTS_LIMIT + " characters";
        } else {
            angular.copy($scope.valuePoints, valuePoints);
            valuePoints[index].isEdit = false;
            angular.copy(valuePoints, $scope.valuePoints);
            formatLatex();
        }
    };

    var imageViewType = "";
    $scope.cancelDialog = function () {
        $mdDialog.cancel();
        if (imageViewType === 'question') $scope.questionImg = $scope.imageArray;
        imageViewType = "";
        $scope.imageArray = [];
    };

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        console.log(imageDetails);
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'answer') {
                $scope.descImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };

    //Open dialog to view image
    $scope.openDialog = function (imageType, index, desc) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "SA - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "SA - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };
    //Adding OWQ question from UI
    $scope.$on('addShortQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //Validation  
        if ($scope.question == null || $scope.question.trim() == undefined || $scope.question == "") {
            $scope.errors.qn_desc = "Question is required";
            activityErrorCount++;
        } else if ($scope.question.length > $scope.ques_desc_limit) {
            $scope.errors['qn_desc'] = "Question does not exceed " + $scope.ques_desc_limit + " characters";
            errCount++;
        }
        if ($scope.valuePoints.length == 0) {
            $scope.errors.value_points = "Atleast One Value point is required";
            activityErrorCount++;
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "value_points": $scope.valuePoints,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    /************** LINK QUESTION TO PASSAGE : END ****************/

    //On destroy function
    this.$onDestroy = function () {};

    $scope.viewTextAngular = function () {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
            locals: {
                parentScope: $scope
            },
            template: _editor2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    };
    $scope.setQuestionFromEditor = function (editor_value) {
        $scope.question = editor_value;
        $scope.used_editor = true;
        $scope.isNotComposed = true;
        var used_editor = document.getElementById('used_editor');
        $scope.used_editor_html = $sce.trustAsHtml(editor_value);
        // used_editor.append(editor_value)
        console.log(used_editor);
    };
    function resetFn() {
        $scope.isNotComposed = false;
        $scope.question = '';
        $scope.used_editor_html = '';
    }
    $scope.resetQuestion = function () {
        var confirm = $mdDialog.confirm().title('Remove').textContent('This will remove question from the input, If you want to edit use editor').ariaLabel('Lucky day').ok('Remove').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            resetFn();
        }, function (f, r) {});
    };
}];

var editorLACtrl = function editorLACtrl($scope, $mdDialog, parentScope) {
    _classCallCheck(this, editorLACtrl);

    Simditor.locale = 'en-US';
    var editor = undefined;
    angular.element(document).ready(function () {
        $scope.editor = {};
        editor = new Simditor({
            textarea: $('#editor'),
            placeholder: '',
            params: {},
            upload: false,
            tabIndent: true,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
            // 'image',
            'hr', 'indent', 'outdent', 'alignment'],
            toolbarFloat: true,
            toolbarFloatOffset: 0,
            toolbarHidden: false,
            pasteImage: false,
            cleanPaste: false,
            codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
            //optional options
        });
        if (parentScope.question) {
            editor.setValue(parentScope.question);
        }
    });
    $scope.saveContent = function (desc) {
        console.log(desc);
        console.log($scope.editor);
        var editor_value = editor.getValue();
        if (!editor_value) {
            toastr.error("Please enter question");
            return false;
        }
        parentScope.setQuestionFromEditor(editor_value);
        $mdDialog.hide();
    };
    $scope.closeEditor = function () {
        $mdDialog.hide();
    };
};

exports.default = ShortController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

module.exports = "<md-input-container flex=50> <a href={{csvDownloadLink}} target=blank class=\"md-primary md-hue-1 tolowercase\"> <i class=\"fas fa-file-download\"></i> Download Sample-CSV </a> </md-input-container> <md-input-container flex=50> <i ngf-select ngf-change=upload($file) tooltip=Upload tooltip-position=down flex=50 class=\"fas fa-cloud-upload-alt\"></i> <i class=\"fas fa-search\" ng-if=showViewButton ng-click=showCsv() flex=50 tooltip=Preview tooltip-position=down></i> </md-input-container> ";

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tfBulkPopup = __webpack_require__(1307);

var _tfBulkPopup2 = _interopRequireDefault(_tfBulkPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: TfBulkUploadController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var TfBulkUploadController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CQuesConst", "$mdMedia", "$mdDialog", function TfBulkUploadController($scope, $rootScope, authService, localStorageService, $state, CQuesConst, $mdMedia, $mdDialog) {
    _classCallCheck(this, TfBulkUploadController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Archives";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    var userId = localStorageService.get("user_id");
    var schoolId = localStorageService.get("school_id");
    var sessionDetails = localStorageService.get("createQuesiton");
    $scope.is_traditional_activity = $scope.$parent.isTActivityQuestion;
    $scope.is_tp_activity = $scope.$parent.isTpActivityQuestion;
    $scope.is_archive = $scope.$parent.isArchiveQuestion;
    $scope.showViewButton = false;
    var SAVE_URL = CQuesConst.API_CREATE_BULK_TF;
    $scope.csvDownloadLink = '../../../img/csv-samples/TF-CSV-Sample.csv';
    var qp_id = $scope.$parent.tqp_id;
    $scope.currentTheme = $scope.$parent.$parent.theme.det;
    $scope.strandsArray = $scope.$parent.$parent.strandsList;
    //[Object] - Wave details
    $scope.waveDetails = $scope.$parent.$parent.waveDetails;

    //[Object] - Theme details of current subject
    $scope.themesArray = $scope.$parent.$parent.themesArray;

    //[Object] - Subject details
    $scope.linkSubjects = $scope.$parent.$parent.linkSubjects;

    //[Object] - Theme with subject details except current subject
    $scope.linkThemes = $scope.$parent.$parent.linkThemes;

    //Boolean - Whether the activity is practice or not
    //$scope.isPractice = $scope.$parent.isPractice
    $scope.skillList = CQuesConst.SKILL_LIST;
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    $scope.content_editor_id = userId;
    function validate(obj) {
        var errors = {};
        //Validation  
        if (obj.question == null || obj.question == undefined || obj.question == "") {
            errors['question'] = "Question is required";
        } else if (obj.question.length > CQuesConst.QUES_DESC_LIMIT) {
            errors['question'] = "Question does not exceeds " + CQuesConst.QUES_DESC_LIMIT + " characters";
        }
        if (obj.correctAnswerExpl && obj.correctAnswerExpl.length > CQuesConst.OPTION_LIMIT) {
            errors["correctAnswerExpl"] = "Explanation does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
        }
        if (obj.correctAnswer == null || obj.correctAnswer == undefined || obj.correctAnswer == "") {
            errors["correctAnswer"] = "Answer is required";
        } else if (obj.correctAnswer.length > CQuesConst.OPTION_LIMIT) {
            errors["correctAnswer"] = "Answer does not exceeds " + CQuesConst.OPTION_LIMIT + " characters";
        }
        if (obj.hints == null || obj.hints == undefined || obj.hints == "") {
            errors["hint"] = "False Hint is required";
        }

        if ($scope.is_archive) {} else {
            if (obj.theme) {
                if (!obj.theme.theme_id) {
                    errors.theme = "Select theme";
                    // activityErrorCount++;
                }
            } else {
                errors.theme = "Select theme";
                //activityErrorCount++;
            }
        }

        if (obj.strand) {
            if (obj.strand.length <= 0) {
                errors.strand = "Enter strand";
                //activityErrorCount++;
            }
        } else {
            errors.strand = "Enter strand";
            //activityErrorCount++;
        }
        if (obj.level) {
            if (obj.level.length <= 0) {
                errors.level = "Enter level";
                //activityErrorCount++;
            }
        } else {
            errors.level = "Enter level";
            //activityErrorCount++;
        }
        if (obj.wave) {
            if (obj.wave.length <= 0) {
                errors.wave = "Enter wave";
                //activityErrorCount++;
            }
        } else {
            errors.wave = "Enter wave";
            //activityErrorCount++;
        }
        if (obj.cognitive_skills) {
            if (obj.cognitive_skills.length <= 0) {
                errors.cognitive_skills = "Enter skill";
                //activityErrorCount++;
            }
        } else {
            errors.cognitive_skills = "Enter skill";
            //activityErrorCount++;
        }
        return errors;
    }
    var bulkUploadCtrl = function bulkUploadCtrl($scope, $mdDialog, bulkUploadData, skillList, waveDetails, linkSubjects, themesArray, is_traditional_activity, is_tp_activity, is_archive, current_theme) {
        $scope.bulkUploadData = bulkUploadData;
        $scope.skillList = skillList;
        $scope.waveDetails = waveDetails;
        $scope.linkSubjects = linkSubjects;
        $scope.themesArray = themesArray;
        $scope.is_traditional_activity = is_traditional_activity;
        $scope.is_tp_activity = is_tp_activity;
        $scope.is_archive = is_archive;
        $scope.currentTheme = current_theme;
        $scope.errors = [];
        $scope.save = function () {
            $scope.errors = [];
            var obj = {
                "subject_id": authoring.subject_id,
                "school_id": authoring.school_id,
                "xclass_id": authoring.class_id,
                "curriculum_id": authoring.curriculum_id,
                "content_manager_id": $scope.content_editor_id,
                "session_id": authoring.session_id,
                "batch_id": authoring.batch_id,
                "class_id": authoring.class_id,
                "is_traditional_activity": $scope.is_traditional_activity,
                "activity_id": sessionDetails.activity_id,
                "user_id": userId
            };
            _.each($scope.bulkUploadData, function (question_val, question_key) {
                if (question_val.theme) {
                    question_val.question_theme_name = question_val.theme.theme_name;
                    question_val.question_theme_id = question_val.theme.theme_id;
                }
                if ($scope.is_archive) {
                    question_val.question_theme_id = $scope.currentTheme.theme_id;
                }
                question_val.isLatex = false;
                question_val.content_editor_id = userId;
                question_val.subject_id = authoring.subject_id;
                question_val.school_id = authoring.school_id;
                var errors = validate(question_val);
                if (Object.keys(errors).length > 0) $scope.errors.push(errors);
            });

            if ($scope.errors.length == 0) {
                //SAVE CALL
                obj.ques_list = $scope.bulkUploadData;
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    var result = resObj.result;
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        $rootScope.resetValues();
                        if (is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: qp_id
                            });
                            toastr.success("Question Saved successfully");
                        } else if (is_tp_activity) {
                            $state.go('formatQp', {
                                resourceId: sessionDetails.activity_id
                            });
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession();
                            }
                        }
                        $scope.cancel();
                    } else {
                        if (result && result.data && result.data.existingQuesCount) {
                            toastr.error("Question already exists");
                        }
                        $rootScope.setHideSaveButton(false);
                        $rootScope.setLoader(false);
                        //toastr.error("Network Error")
                    }
                    _.defer(function () {
                        $scope.$apply();
                    });
                });
            } else return false;

            //         if (errorCount > 0) {
            //             toastr.error("Please fill all mandatory fields")
            //             return false;
            //         } else {

            //             Meteor.apply('addBulkTf', [$scope.bulkUploadData, obj], (err, result) => {
            //                 if (err) {
            //                     toastr.error("errorr")
            //                 } else {
            //                     $mdDialog.hide();
            //                     toastr.success("Questions Added Successfully...")
            //                     $state.go("wizard.formatQuestion")
            //                 }
            //             })
            //         }
        };
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    //Import CSV file
    $scope.upload = function (file) {
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'csv') {
                $scope.isSupportedFormat = true;
                if (!$scope.strandsArray) {
                    toastr.error("No strands has been added to the Subject. Contact content manager.");
                    return false;
                }
                Papa.parse(file, {
                    skipEmptyLines: true,
                    complete: function complete(results) {
                        $scope.showViewButton = true;
                        $scope.bulkUploadData = [];
                        var data = results ? results.data : [];
                        var countQ = data.length - 1;
                        if (data[countQ].length === 1) {
                            data.splice(countQ, 1);
                        }
                        data.forEach(function (question, index) {
                            if (index !== 0) {
                                //[String] - question level
                                var level = [];

                                //[String] - student wave
                                var wave = [];

                                //[String] - subject strands
                                var strands = [];

                                //[String] - Link subjects
                                var linkSub = [];

                                //[String] - Link Themes
                                var linkTheme = [];

                                //[String] - Cognitive Skills
                                var cognitive_skills = [];

                                if (question[4]) level = question[4].split('&&');
                                if (question[5]) wave = question[5].split('&&').map(function (val) {
                                    return "w00" + val;
                                });
                                if (question[8]) {
                                    linkSub = question[8].split('&&');
                                }
                                if (question[9]) {
                                    linkTheme = question[9].split('&&');
                                }
                                if (question[11]) {
                                    cognitive_skills = question[11].split('&&');
                                }
                                var qbObj = {
                                    "question": question[0],
                                    "correctAnswer": question[1],
                                    "correctAnswerExpl": question[2],
                                    "hints": question[3],
                                    "level": level,
                                    "wave": wave,
                                    "strand": question[6],
                                    "theme": question[7],
                                    "cxLinkObj": {
                                        "subject": linkSub,
                                        "theme": linkTheme
                                    },
                                    "tags": question[10],
                                    "cognitive_skills": cognitive_skills

                                };
                                $scope.bulkUploadData.push(qbObj);
                            }
                        });
                        _.defer(function () {
                            $scope.$apply();
                        });
                    }
                });
                toastr.success("Successfully uploaded");
            } else {
                $scope.isSupportedFormat = false;
                $scope.showViewButton = false;
                toastr.error("Please select .csv format");
            }
        }
    };

    //Display CSV
    $scope.showCsv = function () {
        _.each($scope.bulkUploadData, function (data) {

            //[Object] - Selected Link Subject
            var linkSubject = [];

            //[Object] - Selected Link Theme
            var linkTheme = [];

            //Object -Selected theme
            // let themeObj = _.find($scope.themesArray, function(theme) {
            //     return theme.theme_name.toLowerCase() === data.themes.toLowerCase()
            // })
            // if (themeObj) {
            //     data.theme = {
            //         theme_name: themeObj.theme_name,
            //         theme_id: themeObj.theme_id
            //     }
            // } else {
            //     data.theme = {
            //         theme_name: $scope.currentTheme.theme_name,
            //         theme_id: $scope.currentTheme.theme_id
            //     }
            // }
            var skills = [];
            data.cognitive_skills = _.map(data.cognitive_skills, function (skill) {
                return skill.toLowerCase();
            });
            _.each($scope.skillList, function (skill) {
                var skill_lc = skill.toLowerCase();
                if (_.contains(data.cognitive_skills, skill_lc)) {
                    skills.push(skill);
                }
            });
            data.cognitive_skills = skills;
            _.each(data.cxLinkObj.subject, function (subject) {
                var subjectId = _.find($scope.linkSubjects, function (sub) {
                    return sub.name === subject;
                });
                if (subjectId) linkSubject.push({
                    name: subjectId.name,
                    _id: subjectId._id
                });
            });
            data.linkSubject = linkSubject;
            // _.each(data.cxLinkObj.theme, function(theme) {
            //     let themeId = _.find($scope.linkThemes, function(themeObj) {
            //         return themeObj.theme_name === theme
            //     })
            //     if (themeId)
            //         linkTheme.push(themeId)
            // })
            // data.linkTheme = linkTheme;
        });
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            template: _tfBulkPopup2.default,
            locals: {
                bulkUploadData: $scope.bulkUploadData,
                skillList: $scope.skillList,
                waveDetails: $scope.waveDetails,
                linkSubjects: $scope.linkSubjects,
                themesArray: $scope.themesArray,
                is_traditional_activity: $scope.is_traditional_activity,
                is_archive: $scope.is_archive,
                current_theme: $scope.currentTheme,
                is_tp_activity: $scope.is_tp_activity
            },
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'skillList', 'waveDetails', 'linkSubjects', 'themesArray', 'is_traditional_activity', 'is_tp_activity', 'is_archive', 'current_theme', bulkUploadCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
}];

exports.default = TfBulkUploadController;

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

module.exports = "<style>.bulkDialog{min-width:90%}.md-body-1{padding:2px}.bold{font-weight:700!important}</style> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>CSV Upload </h2> {{msg}} <span flex></span> <i class=\"fas fa-times pointer\" style=color:#fff ng-click=cancel()></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content md-theme=makeMeWhite class=\"md-whiteframe-2dp dialogCont\"> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Question</th> <th class=\"md-body-1 bold\">Correct Answer(0 for False, 1 for True)</th> <th class=\"md-body-1 bold\">Correct Answer explanation/s</th> <th class=\"md-body-1 bold\">Other Answer Hints (Use && to discriminate)</th> <th class=\"md-body-1 bold\">Question Level</th> <th class=\"md-body-1 bold\">Wave</th> <th class=\"md-body-1 bold\">Strands</th> <th class=\"md-body-1 bold\">Cognitive Skills</th> <th class=\"md-body-1 bold\" ng-hide=is_archive>Themes</th> <th class=\"md-body-1 bold\">Link Subjects</th> <th class=\"md-body-1 bold\">Link Topic/Themes</th> <th class=\"md-body-1 bold\">Additional Tags</th> </tr> </thead> <tbody> <tr ng-repeat=\"data in bulkUploadData\"> <td class=md-body-1 data-title=Question> <div layout=column> <textarea class=md-body-1 ng-model=data.question></textarea> <p class=errorMessage>{{errors[$index].question}}</p> </div> </td> <td class=md-body-1 data-title=\"Correct Answer\"> <div layout=column> <md-select ng-model=data.correctAnswer> <md-option value=0> 0 </md-option> <md-option value=1> 1 </md-option> </md-select> <p class=errorMessage>{{errors[$index].correctAnswer}}</p> </div> </td> <td class=md-body-1 data-title=\"Answer Explanations\"> <div layout=column> <textarea class=md-body-1 ng-model=data.correctAnswerExpl></textarea> <p class=errorMessage>{{errors[$index].correctAnswerExpl}}</p> </div> </td> <td class=md-body-1 data-title=\"Other Answer Hints\"> <div layout=column> <input class=md-body-1 ng-model=data.hints> <p class=errorMessage>{{errors[$index].hints}}</p> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.level multiple=multiple> <md-option value=1> 1 </md-option> <md-option value=2> 2 </md-option> <md-option value=3> 3 </md-option> </md-select> <div class=errorMessage>{{errors[$index].level}}</div> </div> </td> <td class=md-body-1 data-title=\"Question Level\"> <div layout=column> <md-select ng-model=data.wave multiple=multiple> <md-option ng-repeat=\"wave in waveDetails\" ng-value=\"'{{wave._id}}'\"> {{wave.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].wave}}</div> </div> </td> <td class=md-body-1 data-title=Strands> <div layout=column> <input class=md-body-1 ng-model=data.strand> <div class=errorMessage>{{errors[$index].strand}}</div> </div> </td> <td class=md-body-1 data-title=\"Cognitive Skills\"> <div layout=column> <md-select ng-model=data.cognitive_skills multiple=multiple> <md-option ng-repeat=\"skill in skillList\" value={{skill}}>{{skill}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].cognitive_skills}}</div> </div> </td> <td class=md-body-1 data-title=Themes ng-hide=is_archive> <div layout=column> <md-select ng-model=data.theme ng-model-options=\"{trackBy: '$value.theme_id'}\"> <md-option ng-repeat=\"theme in themesArray\" ng-value={{theme}}>{{theme.theme_name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].theme}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Subjects\"> <div layout=column> <md-select ng-model=data.linkSubject ng-model-options=\"{trackBy: '$value._id'}\" multiple=multiple> <md-option ng-repeat=\"subject in linkSubjects\" ng-value={{subject}}>{{subject.name}} </md-option> </md-select> <div class=errorMessage>{{errors[$index].linkSubject}}</div> </div> </td> <td class=md-body-1 data-title=\"Link Theme\"> <div layout=column> <md-select ng-model=data.xlink ng-model-options=\"{trackBy: '$value.theme_id'}\" multiple=multiple> <md-optgroup ng-if=\"currentSubject!='NA'\" label={{currentSubject.name}} ng-repeat=\"currentSubject in data.linkSubject track by $index\"> <md-option ng-value={{theme}} ng-repeat=\"theme in currentSubject.themes track by theme.theme_id\">{{theme.theme_name}}</md-option> </md-optgroup> </md-select> <div class=errorMessage>{{errors[$index].linkTheme}}</div> </div> </td> <td class=md-body-1 data-title=\"Additional Tags\"> <div layout=column> <input class=md-body-1 ng-model=data.tags> <div class=errorMessage>{{errors[$index].tags}}</div> </div> </td> </tr> </tbody> </table> </div> </md-content> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save()>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel()>Cancel</md-button> </div> </md-dialog-content> </form> </md-dialog> ";

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.latex-head{background:#1665c1;color:#fff;width:733px;position:relative;right:614px;top:60px}.latex-close{float:right;position:relative;right:13px;bottom:52px;font-size:20px;left:-17px;color:#fff}.mainDiv .action-btn-clr{background-color:#1665c1!important;color:#fff;text-transform:capitalize}.mainDiv .compose{margin-top:5px}.mainDiv .compose-icon{margin-top:3px}.mainDiv .button-style-compose{border-radius:25px;padding-left:2px;padding-right:2px}</style> <div class=\"contentBox mainDiv\"> <md-divider class=dividerBorder> </md-divider> <div layout=column> <div layout=row layout-align=\"end end\"> <div class=\"hand passage-link-btn qn_link_passage md-whiteframe-2dp\" ng-click=openPassage()>Link passage</div> </div> <div layout=column ng-init=\"isShowPassage = false\" class=md-whiteframe-3dp ng-show=selectedPassage layout-padding layout-margin> <div layout=row> <div class=passage-label flex>{{selectedPassage.passage_title}}</div> <div layout=row layout-align=\"space-between center\" flex=10> <div ng-show=\"selectedPassage.passage_image.length>0\" flex ng-click=\"openDialog('passage')\"> <img class=hand src=" + __webpack_require__(20) + " /> </div> <div flex ng-click=cancelSelectedPasssage() style=color:red> <i class=\"fas fa-trash-alt\"></i> </div> <div flex ng-click=\"isShowPassage = !isShowPassage\" style=outline:0> <i class=\"fas fa-angle-down\" ng-show=!isShowPassage></i> <i class=\"fas fa-angle-up\" ng-show=isShowPassage></i> </div> </div> </div> <div class=passage-desc ng-show=isShowPassage ng-bind-html=selectedPassage.passage_desc flex></div> </div> </div> <div id=used_editor layout=column> <div> Composed Question: </div> <div class=composed_dom ng-bind-html=used_editor_html></div> </div> <div layout=row flex layout-align=\"space-between center\"> <md-input-container md-select-on-focus flex=70> <div ng-show=!isLatex> <label ng-show=!isNotComposed>Enter Question</label> <textarea ng-show=!isNotComposed ng-model=question md-maxlength={{ques_desc_limit}} txt-maxlength={{ques_desc_limit}} md-select-on-focus></textarea> </div> <div class=qn-label ng-show=isLatex>Enter Question</div> <span id=tf-math-field ng-show=isLatex ng-model=question rows=2 md-select-on-focus style=height:auto md-select-on-focus ng-paste=paste($event)></span> <md-checkbox ng-model=isLatex aria-label=Finished?> With formula </md-checkbox> <div class=errorMessage>{{errors['question']}}</div> </md-input-container> <md-menu md-position-mode=\"target-left bottom\" ng-show=isLatex> <i class=\"fas fa-lg fa-question-circle latex-help\" tooltip=Help tooltip-position=down ng-click=$mdOpenMenu($event)></i> <md-menu-content> <img class=hand src=" + __webpack_require__(19) + "> </md-menu-content> </md-menu> <div flex=10 layout=row layout-align=\"space-between center\"> <img src=" + __webpack_require__(22) + " ngf-select=questionImgUpload($files,tf.credentials) ngf-multiple=true> <div ng-show=\"questionImage.length > 0\" flex=45 ng-click=\"openDialog('question')\"><img class=hand src=" + __webpack_require__(20) + " /></div> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=viewTextAngular()> <div>Compose/Edit</div> </md-button> </div> <div flex=10> <md-button style=width:90% md-no-ink class=\"button-style-compose md-primary action-btn-clr\" ng-click=resetQuestion()> <div>Reset</div> </md-button> </div> </div> <div layout=row layout-align=\"space-between center\"> <md-input-container flex=20> <label>Select Answer</label> <md-select flex ng-model=answer placeholder=\"Select Answer\"> <md-option value=True>True</md-option> <md-option value=False>False</md-option> </md-select> <div class=errorMessage>{{errors['answer']}}</div> </md-input-container> <md-input-container class=tfHint flex=30> <label>Answer Explanation for {{answer}}</label> <textarea ng-model=explanation txt-maxlength={{explain_limit}}></textarea> <div class=errorMessage>{{errors['explanation']}}</div> </md-input-container> <div flex=5> <img class=hand src=" + __webpack_require__(22) + " ngf-select=explanationImgUpload($files,tf.credentials) ngf-multiple=true> <div class=hand ng-show=\"explanationImage.length > 0\" flex=45 ng-click=\"openDialog('explan')\"><img class=hand src=" + __webpack_require__(20) + " /></div> </div> <md-input-container class=tfHint flex=30> <label>Explanation for False Hint</label> <textarea ng-model=falseHint txt-maxlength={{explain_limit}}></textarea> <div class=errorMessage>{{errors['falseHint']}}</div> </md-input-container> <div flex=5> <img class=hand src=" + __webpack_require__(22) + " ngf-select=falseHintImgUpload($files,tf.credentials) ngf-multiple=true> <div ng-show=\"falseHintImage.length > 0\" flex=45 ng-click=\"openDialog('falseHint')\"><img class=hand src=" + __webpack_require__(20) + " /></div> </div> </div> </div> <md-divider class=dividerBorder> </md-divider> ";

/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imagePopup = __webpack_require__(25);

var _imagePopup2 = _interopRequireDefault(_imagePopup);

var _passagePopup = __webpack_require__(26);

var _passagePopup2 = _interopRequireDefault(_passagePopup);

var _editor = __webpack_require__(56);

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: TfController.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-07
                                                                                                                                                           * Author: Arul Mozhi J
                                                                                                                                                           * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                                                                                                           * ------------------------------------
                                                                                                                                                           */


var TfController =
// @ngInject
["$scope", "$rootScope", "authService", "localStorageService", "$state", "CONSTANTS", "CQuesConst", "$mdDialog", "uploadService", "$mdMedia", "$sce", function TfController($scope, $rootScope, authService, localStorageService, $state, CONSTANTS, CQuesConst, $mdDialog, uploadService, $mdMedia, $sce) {
    _classCallCheck(this, TfController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    //On destroy function
    this.$onDestroy = function () {};
    /********** BASIC DETAILS *********/
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var userId = localStorageService.get("user_id");
    var USER_PATH = userId + "/question/";
    var schoolId = localStorageService.get("school_id");
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;
    var GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES;
    var GET_PASSAGE = CQuesConst.API_GET_PASSAGE;
    var SAVE_URL = CQuesConst.API_CREATE_TF;
    $scope.questionImage = [];
    $scope.explanationImage = [];
    $scope.falseHintImage = [];
    $scope.isLatex = false;
    $scope.content_editor_id = userId;
    $scope.isNotComposed = false;

    /******* LIMIT FOR QUSTION CREATION *******/
    $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
    $scope.option_limit = CQuesConst.OPTION_LIMIT;
    $scope.explain_limit = CQuesConst.ANS_EXPLANATION_LIMIT;
    //SET UI FOR EDIT QUESTIONS
    var editQuestion = $scope.$parent.$parent.editQuestion;
    if (editQuestion && editQuestion.choice) {
        $scope._id = editQuestion._id;
        $scope.question = editQuestion.qn_desc;
        $scope.isNotComposed = true;
        $scope.questionImg = [];
        if (editQuestion.questionImg) {
            if (Array.isArray(editQuestion.questionImg)) {
                $scope.questionImage = editQuestion.questionImg;
            } else {
                $scope.questionImage.push(editQuestion.questionImg);
            }
        }
        $scope.answer = _.find(editQuestion.choice, function (ch) {
            return ch.correct;
        }).tag;
        var explanation = _.find(editQuestion.choice, function (ch) {
            return ch.correct;
        });
        $scope.explanation = explanation.explanation;
        var hint = _.find(editQuestion.choice, function (ch) {
            return !ch.correct;
        });
        $scope.falseHint = hint.hint;
        $scope.explanationImage = [];
        if (editQuestion.explanationImage) {
            if (Array.isArray(editQuestion.explanationImage)) {
                $scope.explanationImage = editQuestion.explanationImage;
            } else {
                $scope.explanationImage.push(editQuestion.explanationImage);
            }
        }
        $scope.falseHintImage = [];
        if (editQuestion.falseHintImage) {
            if (Array.isArray(editQuestion.falseHintImage)) {
                $scope.falseHintImage = editQuestion.falseHintImage;
            } else {
                $scope.falseHintImage.push(editQuestion.falseHintImage);
            }
        }
        $scope.created_dt = editQuestion.created_dt;
        $scope.content_editor_id = editQuestion.content_editor_id;
        $scope.selectedPassage_id = editQuestion.passage_id;
        if ($scope.selectedPassage_id) {
            $scope.selectedPassage = editQuestion.passage_detail;
        }
    }
    //TO SET PASSAGE LIST
    var passageCallback = function passageCallback(resultObj) {
        $scope.isPassagePresent = false;
        $scope.passages = [];
        if (resultObj && resultObj.result && resultObj.result.data) {
            var result = resultObj.result.data.passage ? resultObj.result.data.passage : [];
            if (result) {
                if (result.length > 0) {
                    $scope.isPassagePresent = true;
                    _.each(result, function (eachPas) {
                        if ($scope.selectedPassage_id === eachPas._id) {
                            eachPas["isSelected"] = true;
                        } else {
                            eachPas["isSelected"] = false;
                        }
                    });
                    $scope.passages = result;
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        }
    };
    var authoring = {
        curriculum_id: $scope.$parent.curriculum_id,
        class_id: $scope.$parent.class_id,
        subject_id: $scope.$parent.subject_id,
        school_id: schoolId,
        user_id: userId
    };
    authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback);

    //BASIC DETAIL FOR LATEX
    var MQ = MathQuill.getInterface(2);
    //LATEX FOR QUESTION
    var mathFieldSpan = document.getElementById('tf-math-field');
    mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
    if ($scope.question) {
        mathFieldSpan.textContent = $scope.question;
    }
    var mathField = MQ.MathField(mathFieldSpan, {
        spaceBehavesLikeTab: false,
        restrictMismatchedBrackets: true,
        handlers: {
            edit: function edit() {
                $scope.question = mathField.latex();
            }
        }
    });

    //PREVENT PASTE FUNCTIONALITY
    $scope.paste = function (e) {
        e.preventDefault();
        return false;
    };

    //Image upload for question
    $scope.questionImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.questionImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //Image upload for Desc
    $scope.falseHintImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.falseHintImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //Image upload for explanation
    $scope.explanationImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        $scope.explanationImage.push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };

    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageViewType, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.isPassage = false;
        $scope.title = imageDetails.title;
        $scope.imageArray = imageDetails.images;
        $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false;

        $scope.deleteImage = function (imageIndex) {
            $scope.imageArray.splice(imageIndex, 1);
        };
        $scope.cancelDialog = function () {
            $mdDialog.cancel();
            if (imageViewType === 'question') {
                $scope.questionImage = $scope.imageArray;
            } else if (imageViewType === 'explan') {
                $scope.explanationImage = $scope.imageArray;
            } else if (imageViewType === 'falseHint') {
                $scope.falseHintImage = $scope.imageArray;
            }
            $scope.imageArray = [];
        };
    };
    $scope.cancelSelectedPasssage = function () {

        $scope.selectedPassage = null;
        _.each($scope.passages, function (eachPas) {
            eachPas.isSelected = false;
        });
    };
    //Open dialog to view image
    $scope.openDialog = function (imageType) {
        var imageDetails = void 0;
        if (imageType === 'question') {
            imageDetails = {
                title: "TF - Question Image",
                images: $scope.questionImage
            };
        } else if (imageType === 'explan') {
            imageDetails = {
                title: "TF - Explanation Image",
                images: $scope.explanationImage
            };
        } else if (imageType === 'falseHint') {
            imageDetails = {
                title: "TF - False Hint Image",
                images: $scope.falseHintImage
            };
        } else if (imageType === 'passage') {
            imageDetails = {
                title: "TF - Passage Image",
                images: $scope.selectedPassage.passage_image,
                isPassage: true
            };
        }
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageViewType: imageType,
                imageDetails: imageDetails
            },
            template: _imagePopup2.default,
            controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };

    var setPassage = function setPassage() {
        $scope.selectedPassage = _.find($scope.passages, function (pas) {
            return pas.isSelected;
        });
    };

    //DIALOG CONTROLLER FOR PASSAGE
    var passageDialogCtrl = function passageDialogCtrl($scope, $mdDialog, passages) {
        $scope.passages = passages;
        $scope.fileUrl = PREVIEW_URL;
        $scope.isArray = function (obj) {
            return Array.isArray(obj);
        };
        /*
         * Function to cancel dialog to select passage
         */
        $scope.cancelPassage = function () {
            $mdDialog.cancel();
            setPassage();
        };

        /*
        * Function to select passage
        */
        $scope.selectPassage = function (passage_id) {
            _.each($scope.passages, function (eachPas) {
                if (eachPas._id != passage_id) {
                    eachPas.isSelected = false;
                }
            });
            $scope.cancelPassage();
        };
    };

    /*
     * Function to open dialog to select passage
     */
    $scope.openPassage = function () {
        if (!$scope.passages) {
            $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('Passages not loaded.Try after some time.').ariaLabel('Passage Dialog').ok('Ok'));
        } else {
            if ($scope.passages.length == 0) {
                $mdDialog.show($mdDialog.alert().clickOutsideToClose(true).title('No Passage').textContent('No passages added yet. Please add passage and link it').ariaLabel('Passage Dialog').ok('Ok'));
            } else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: _passagePopup2.default,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                });
            }
        }
    };
    //Adding OWQ question from UI
    $scope.$on('addTfQuestion', function () {
        $scope.errors = {};
        var details = localStorageService.get("questionDetails");
        var question = details.question;
        var activityErrorCount = details.errorCount;
        //[Object] - to push correct and wrong answer object
        var choice = [];

        //Object - correct answer
        var correctObj = {};

        //Object - wrong answer
        var wrongObj = {};
        if ($scope.answer === "True") {
            correctObj.tag = "True";
            wrongObj.tag = "False";
        } else {
            correctObj.tag = "False";
            wrongObj.tag = "True";
        }
        correctObj.explanation = $scope.explanation;
        correctObj.correct = true;
        correctObj.explanationImage = $scope.tf.explanationImage;
        choice.push(correctObj);
        wrongObj.hint = $scope.falseHint;
        wrongObj.correct = false;
        wrongObj.falseHintImage = $scope.tf.falseHintImage;
        choice.push(wrongObj);
        $scope.errors = {};

        //Validation  
        if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
            $scope.errors.question = "Question is required";
            activityErrorCount++;
        } else if ($scope.question.length > $scope.ques_desc_limit) {
            $scope.errors.question = "Question does not exceed " + $scope.ques_desc_limit + " characters";
            activityErrorCount++;
        }
        if ($scope.isPractice) {
            if ($scope.explanation == null || $scope.explanation == undefined || $scope.explanation == "") {
                $scope.errors["explanation"] = "Explanation is required";
                activityErrorCount++;
            }
            if ($scope.falseHint == null || $scope.falseHint == undefined || $scope.falseHint == "") {
                $scope.errors["falseHint"] = "False hint is required";
                activityErrorCount++;
            }
        }
        if ($scope.explanation && $scope.explanation.length > $scope.explain_limit) {
            $scope.errors["explanation"] = "Explanation does not exceed " + $scope.explain_limit + " characters";
            activityErrorCount++;
        }
        if ($scope.falseHint && $scope.falseHint.length > $scope.explain_limit) {
            $scope.errors["falseHint"] = "False does not exceed " + $scope.explain_limit + " characters";
            activityErrorCount++;
        }
        if ($scope.answer == null || $scope.answer == undefined || $scope.answer == "") {
            $scope.errors["answer"] = "Answer is required";
            activityErrorCount++;
        } else if ($scope.answer.length > $scope.option_limit) {
            $scope.errors["answer"] = "Answer does not exceed " + $scope.option_limit + " characters";
            activityErrorCount++;
        }
        if (activityErrorCount === 0) {
            $scope.$parent.isSaveClicked = true;
            var obj = {
                "_id": $scope._id,
                "question_theme_id": question.theme._id,
                "question_theme_name": question.theme.name,
                "choice": choice,
                "explanationImage": $scope.explanationImage,
                "falseHintImage": $scope.falseHintImage,
                "strand": question.strand,
                "tag": question.tag,
                "wave": question.wave,
                "qn_desc": '' + $scope.question,
                "isLatex": $scope.isLatex,
                "level": question.level,
                "subject_id": question.subject_id,
                "school_id": question.school_id,
                "questionImg": $scope.questionImage,
                "session_id": question.session_id,
                "batch_id": question.batch_id,
                "class_id": question.class_id,
                "curriculum_id": question.curriculum_id,
                "xlink": question.link_theme,
                "cognitive_skills": question.cognitive_skill,
                "isNotAddToQp": question.isNotAddToQp,
                "is_traditional_activity": question.is_traditional_activity,
                "qp_id": question.qp_id,
                "activity_id": question.activity_id,
                "user_id": userId,
                "created_dt": $scope.created_dt,
                "content_editor_id": $scope.content_editor_id,
                "passage": $scope.selectedPassage,
                "teaching_plan_id": question.teaching_plan_id
                //SAVE CALL
            };authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                var result = resObj.result;
                if (result && result.data && result.data.success) {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    $rootScope.resetValues();
                    if (question.is_traditional_activity) {
                        $state.go('formatQuestion', {
                            qpId: question.qp_id
                        });
                        toastr.success("Question Saved successfully");
                    } else if (question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== "") {
                        $state.go('formatQp', {
                            resourceId: question.activity_id
                        });
                        toastr.success("Question Saved successfully");
                    } else {
                        if (result.data.isExists) {
                            toastr.success("Question already exists");
                        } else {
                            toastr.success("Question Saved successfully");
                            $rootScope.setSearchFieldSession();
                        }
                    }
                } else {
                    $rootScope.setHideSaveButton(false);
                    $rootScope.setLoader(false);
                    toastr.error("Network Error");
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        } else {
            $rootScope.setHideSaveButton(false);
            $rootScope.setLoader(false);
            toastr.error("Please fill all mandatory fields");
        }
    });

    $scope.viewTextAngular = function () {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
            locals: {
                parentScope: $scope
            },
            template: _editor2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    };
    $scope.setQuestionFromEditor = function (editor_value) {
        $scope.question = editor_value;
        $scope.used_editor = true;
        $scope.isNotComposed = true;
        var used_editor = document.getElementById('used_editor');
        $scope.used_editor_html = $sce.trustAsHtml(editor_value);
        // used_editor.append(editor_value)
        console.log(used_editor);
    };
    function resetFn() {
        $scope.isNotComposed = false;
        $scope.question = '';
        $scope.used_editor_html = '';
    }
    $scope.resetQuestion = function () {
        var confirm = $mdDialog.confirm().title('Remove').textContent('This will remove question from the input, If you want to edit use editor').ariaLabel('Lucky day').ok('Remove').cancel('Dont delete');

        $mdDialog.show(confirm).then(function () {
            resetFn();
        }, function (f, r) {});
    };
}];

var editorLACtrl = function editorLACtrl($scope, $mdDialog, parentScope) {
    _classCallCheck(this, editorLACtrl);

    Simditor.locale = 'en-US';
    var editor = undefined;
    angular.element(document).ready(function () {
        $scope.editor = {};
        editor = new Simditor({
            textarea: $('#editor'),
            placeholder: '',
            params: {},
            upload: false,
            tabIndent: true,
            toolbar: ['title', 'bold', 'italic', 'underline', 'strikethrough', 'fontScale', 'color', 'ol', 'ul', 'blockquote', 'code', 'table', 'link',
            // 'image',
            'hr', 'indent', 'outdent', 'alignment'],
            toolbarFloat: true,
            toolbarFloatOffset: 0,
            toolbarHidden: false,
            pasteImage: false,
            cleanPaste: false,
            codeLanguages: [{ name: 'Erlang', value: 'erlang' }]
            //optional options
        });
        if (parentScope.question) {
            editor.setValue(parentScope.question);
        }
    });
    $scope.saveContent = function (desc) {
        console.log(desc);
        console.log($scope.editor);
        var editor_value = editor.getValue();
        if (!editor_value) {
            toastr.error("Please enter question");
            return false;
        }
        parentScope.setQuestionFromEditor(editor_value);
        $mdDialog.hide();
    };
    $scope.closeEditor = function () {
        $mdDialog.hide();
    };
};

exports.default = TfController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1312);

var _studentParentMapping = __webpack_require__(130);

var _studentParentMapping2 = _interopRequireDefault(_studentParentMapping);

var _mappingController = __webpack_require__(374);

var _mappingController2 = _interopRequireDefault(_mappingController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('studentParentMapping', [
    //import modules
]).controller('studentParentMapping', _mappingController2.default);

// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentParentMapping', {
//             parent: 'app',
//             url: '/studentParentMapping',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'studentParentMapping'
//                 }
//             }
//         })

// });

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _peopleSearch = __webpack_require__(131);

var _peopleSearch2 = _interopRequireDefault(_peopleSearch);

var _peoplelookupController = __webpack_require__(375);

var _peoplelookupController2 = _interopRequireDefault(_peoplelookupController);

__webpack_require__(1314);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('peopleSearch', [
    //import modules
]).controller('peopleSearch', _peoplelookupController2.default);

// import './manageReportsModule.scss';
// module.config(function($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('peopleSearch', {
//             parent: 'app',
//             url: '/people-search',
//             views: {
//                 '@': {
//                     template: homeTpl,
//                     controller: homeCtrl,
//                     controllerAs: 'peopleSearch'
//                 }
//             }
//         })

// });

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$constant;

var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

var _wizard = __webpack_require__(123);

var _wizard2 = _interopRequireDefault(_wizard);

var _wizard3 = __webpack_require__(364);

var _wizard4 = _interopRequireDefault(_wizard3);

var _weblinks = __webpack_require__(1316);

var _weblinks2 = _interopRequireDefault(_weblinks);

var _weblinks3 = __webpack_require__(1317);

var _weblinks4 = _interopRequireDefault(_weblinks3);

var _weblinksPreview = __webpack_require__(1318);

var _weblinksPreview2 = _interopRequireDefault(_weblinksPreview);

var _weblinksPreview3 = __webpack_require__(1319);

var _weblinksPreview4 = _interopRequireDefault(_weblinksPreview3);

var _referenceBook = __webpack_require__(1320);

var _referenceBook2 = _interopRequireDefault(_referenceBook);

var _referenceBook3 = __webpack_require__(1321);

var _referenceBook4 = _interopRequireDefault(_referenceBook3);

var _referenceBookPreview = __webpack_require__(1322);

var _referenceBookPreview2 = _interopRequireDefault(_referenceBookPreview);

var _referenceBookPreview3 = __webpack_require__(1323);

var _referenceBookPreview4 = _interopRequireDefault(_referenceBookPreview3);

var _googleDoc = __webpack_require__(1324);

var _googleDoc2 = _interopRequireDefault(_googleDoc);

var _googleDoc3 = __webpack_require__(1325);

var _googleDoc4 = _interopRequireDefault(_googleDoc3);

var _googleDocPreview = __webpack_require__(1326);

var _googleDocPreview2 = _interopRequireDefault(_googleDocPreview);

var _googleDocPreview3 = __webpack_require__(1327);

var _googleDocPreview4 = _interopRequireDefault(_googleDocPreview3);

var _utubeVideo = __webpack_require__(1328);

var _utubeVideo2 = _interopRequireDefault(_utubeVideo);

var _utubeVideo3 = __webpack_require__(1329);

var _utubeVideo4 = _interopRequireDefault(_utubeVideo3);

var _utubeVideoPreview = __webpack_require__(1330);

var _utubeVideoPreview2 = _interopRequireDefault(_utubeVideoPreview);

var _utubeVideoPreview3 = __webpack_require__(1331);

var _utubeVideoPreview4 = _interopRequireDefault(_utubeVideoPreview3);

var _khanAcademy = __webpack_require__(1332);

var _khanAcademy2 = _interopRequireDefault(_khanAcademy);

var _khanAcademy3 = __webpack_require__(1333);

var _khanAcademy4 = _interopRequireDefault(_khanAcademy3);

var _khanAcademyPreview = __webpack_require__(1334);

var _khanAcademyPreview2 = _interopRequireDefault(_khanAcademyPreview);

var _khanAcademyPreview3 = __webpack_require__(1335);

var _khanAcademyPreview4 = _interopRequireDefault(_khanAcademyPreview3);

var _createTpActivity = __webpack_require__(1336);

var _createTpActivity2 = _interopRequireDefault(_createTpActivity);

var _createTpActivity3 = __webpack_require__(1337);

var _createTpActivity4 = _interopRequireDefault(_createTpActivity3);

var _createQuestion = __webpack_require__(76);

var _createQuestion2 = _interopRequireDefault(_createQuestion);

var _createQuestionController = __webpack_require__(155);

var _createQuestionController2 = _interopRequireDefault(_createQuestionController);

var _formatQp = __webpack_require__(1338);

var _formatQp2 = _interopRequireDefault(_formatQp);

var _formatQp3 = __webpack_require__(1339);

var _formatQp4 = _interopRequireDefault(_formatQp3);

var _flash = __webpack_require__(1340);

var _flash2 = _interopRequireDefault(_flash);

var _flash3 = __webpack_require__(1341);

var _flash4 = _interopRequireDefault(_flash3);

var _flashPreview = __webpack_require__(1342);

var _flashPreview2 = _interopRequireDefault(_flashPreview);

var _flashPreview3 = __webpack_require__(1343);

var _flashPreview4 = _interopRequireDefault(_flashPreview3);

var _video = __webpack_require__(1344);

var _video2 = _interopRequireDefault(_video);

var _video3 = __webpack_require__(1345);

var _video4 = _interopRequireDefault(_video3);

var _videoPreview = __webpack_require__(1346);

var _videoPreview2 = _interopRequireDefault(_videoPreview);

var _videoPreview3 = __webpack_require__(1347);

var _videoPreview4 = _interopRequireDefault(_videoPreview3);

var _pdf = __webpack_require__(1348);

var _pdf2 = _interopRequireDefault(_pdf);

var _pdf3 = __webpack_require__(1349);

var _pdf4 = _interopRequireDefault(_pdf3);

var _pdfPreview = __webpack_require__(1350);

var _pdfPreview2 = _interopRequireDefault(_pdfPreview);

var _pdfPreview3 = __webpack_require__(1354);

var _pdfPreview4 = _interopRequireDefault(_pdfPreview3);

__webpack_require__(1355);

var _tpActivityPreview = __webpack_require__(1356);

var _tpActivityPreview2 = _interopRequireDefault(_tpActivityPreview);

var _tpActivityPreview3 = __webpack_require__(1357);

var _tpActivityPreview4 = _interopRequireDefault(_tpActivityPreview3);

var _qpSummaryPreview = __webpack_require__(1358);

var _qpSummaryPreview2 = _interopRequireDefault(_qpSummaryPreview);

var _qpSummaryPreview3 = __webpack_require__(1359);

var _qpSummaryPreview4 = _interopRequireDefault(_qpSummaryPreview3);

var _submissionList = __webpack_require__(1360);

var _submissionList2 = _interopRequireDefault(_submissionList);

var _submissionList3 = __webpack_require__(1364);

var _submissionList4 = _interopRequireDefault(_submissionList3);

var _attendExam = __webpack_require__(1365);

var _attendExam2 = _interopRequireDefault(_attendExam);

var _attendExam3 = __webpack_require__(1366);

var _attendExam4 = _interopRequireDefault(_attendExam3);

var _questionDirective = __webpack_require__(1368);

var _questionDirective2 = _interopRequireDefault(_questionDirective);

var _questionDirective3 = __webpack_require__(1369);

var _questionDirective4 = _interopRequireDefault(_questionDirective3);

var _teacherAnswerView = __webpack_require__(158);

var _teacherAnswerView2 = _interopRequireDefault(_teacherAnswerView);

var _teacherAnswerView3 = __webpack_require__(159);

var _teacherAnswerView4 = _interopRequireDefault(_teacherAnswerView3);

var _studentAnswerView = __webpack_require__(156);

var _studentAnswerView2 = _interopRequireDefault(_studentAnswerView);

var _studentAnswerView3 = __webpack_require__(157);

var _studentAnswerView4 = _interopRequireDefault(_studentAnswerView3);

var _reports = __webpack_require__(1370);

var _reports2 = _interopRequireDefault(_reports);

var _reports3 = __webpack_require__(1371);

var _reports4 = _interopRequireDefault(_reports3);

var _activityReports = __webpack_require__(1372);

var _activityReports2 = _interopRequireDefault(_activityReports);

var _activityReports3 = __webpack_require__(1373);

var _activityReports4 = _interopRequireDefault(_activityReports3);

var _singleActivityReport = __webpack_require__(1374);

var _singleActivityReport2 = _interopRequireDefault(_singleActivityReport);

var _singleActivityReport3 = __webpack_require__(1375);

var _singleActivityReport4 = _interopRequireDefault(_singleActivityReport3);

var _studentActivityReport = __webpack_require__(1376);

var _studentActivityReport2 = _interopRequireDefault(_studentActivityReport);

var _studentActivityReport3 = __webpack_require__(1377);

var _studentActivityReport4 = _interopRequireDefault(_studentActivityReport3);

var _studentViewLearningProgress = __webpack_require__(1378);

var _studentViewLearningProgress2 = _interopRequireDefault(_studentViewLearningProgress);

var _studentViewLearningProgress3 = __webpack_require__(1379);

var _studentViewLearningProgress4 = _interopRequireDefault(_studentViewLearningProgress3);

var _teacherViewLearningProgress = __webpack_require__(1380);

var _teacherViewLearningProgress2 = _interopRequireDefault(_teacherViewLearningProgress);

var _teacherViewLearningProgress3 = __webpack_require__(1381);

var _teacherViewLearningProgress4 = _interopRequireDefault(_teacherViewLearningProgress3);

var _singlePracticeActivityReport = __webpack_require__(1382);

var _singlePracticeActivityReport2 = _interopRequireDefault(_singlePracticeActivityReport);

var _singlePracticeActivityReport3 = __webpack_require__(1383);

var _singlePracticeActivityReport4 = _interopRequireDefault(_singlePracticeActivityReport3);

var _studentPracticeActivityReport = __webpack_require__(1384);

var _studentPracticeActivityReport2 = _interopRequireDefault(_studentPracticeActivityReport);

var _studentPracticeActivityReport3 = __webpack_require__(1385);

var _studentPracticeActivityReport4 = _interopRequireDefault(_studentPracticeActivityReport3);

var _practiceActivityReports = __webpack_require__(1386);

var _practiceActivityReports2 = _interopRequireDefault(_practiceActivityReports);

var _practiceActivityReports3 = __webpack_require__(1387);

var _practiceActivityReports4 = _interopRequireDefault(_practiceActivityReports3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _module = angular.module('TpWizardModule', [_angularUiRouter2.default]).component('attendExam', {
    template: _attendExam2.default,
    controllerAs: 'attendExamCtrl',
    controller: _attendExam4.default
}).component('activityReports', {
    template: _activityReports2.default,
    controllerAs: 'activityReportsCtrl',
    controller: _activityReports4.default
}).component('studentActivityReports', {
    template: _studentActivityReport2.default,
    controllerAs: 'studentActivityReportCtrl',
    controller: _studentActivityReport4.default
}).component('studentLearningProgress', {
    template: _studentViewLearningProgress2.default,
    controllerAs: 'studentLearningProgressCtrl',
    controller: _studentViewLearningProgress4.default
}).component('teacherLearningProgress', {
    template: _teacherViewLearningProgress2.default,
    controllerAs: 'teacherLearningProgressCtrl',
    controller: _teacherViewLearningProgress4.default
}).component('practiceActivityReports', {
    template: _practiceActivityReports2.default,
    controllerAs: 'practiceActivityReportsCtrl',
    controller: _practiceActivityReports4.default
}).component('singlePracticeReport', {
    template: _singlePracticeActivityReport2.default,
    controllerAs: 'singlePracticeReportCtrl',
    controller: _singlePracticeActivityReport4.default
}).component('studentPracticeReport', {
    template: _studentPracticeActivityReport2.default,
    controllerAs: 'studentPracticeReportCtrl',
    controller: _studentPracticeActivityReport4.default
}).controller('wizardController', _wizard4.default);

_module.constant('TPWIZARDCONSTANT', (_module$constant = {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
        // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs"
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
        // flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../../img/auth/pdf.png",
        // flash: "../../../../../src/img/auth/interactive_anime.png",
        video: '../../../../../img/auth/video.png',
        weblinks: '../../../../../img/auth/web.png',
        refbooks: '../../../../../img/auth/refbook.png',
        activityForm: '../../../../../img/auth/activity.png',
        khanAcademy: '../../../../../img/auth/khan_academy.png',
        utubeVideo: '../../../../../img/auth/utube.png',
        googleDocs: "../../../../../img/auth/google_docs.png"
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_SAVE_WEBLINK: "/v0/tp-resources/weblink/save",
    API_SAVE_REFBOOK: "/v0/tp-resources/refbook/save",
    API_SAVE_GOOGLEDOCS: "/v0/tp-resources/googledoc/save",
    API_SAVE_UTUBE: "/v0/tp-resources/youtube/save",
    API_SAVE_KHANACADEMY: "/v0/tp-resources/khanacademy/save",
    KHANACADEMY_URL: "https://www.khanacademy.org/api/v1/videos/",
    API_GET_FORMAT_QP: "/v0/tp-activity/format-qp",
    API_GET_TP_ACTIVITY: "/v0/tp-activity/get-activity/",
    API_SAVE_SECTION: "/v0/tp-activity/save-section",
    API_DELETE_QUESTION: "/v0/traditional/delete-question",
    API_SELECT_QUESTION: "/v0/tp-activity/add-questions",
    API_AUTO_FORMAT: "/v0/tp-activity/auto-format",
    API_SELECT_QP: "/v0/tp-activity/create-qp-from-qp",
    API_SELECT_TEMPLATE: "/v0/tp-activity/qp/template",
    API_GET_QP_SUMMARY: "/v0/tp-activity/summary/",
    API_SAVE_FLASH: "/v0/tp-resources/flash/save",
    API_SAVE_VIDEO: "/v0/tp-resources/video/save",
    API_SAVE_PDF: "/v0/tp-resources/pdf/save",
    API_ADD_PDF_ANNOTATION: '/v0/tp-resources/annotation/add-annotation',
    API_FETCH_ANNOTATION: "/v0/tp-resources/annotation/fetch",
    API_REMOVE_ANNOTATION: "/v0/tp-resources/annotation/remove-page-annotation",
    API_UPDATE_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-page-annotation",
    API_UPDATE_ALL_PAGE_ANNOTATION: "/v0/tp-resources/annotation/update-all-page-annotation",
    API_APPROVE_RESOURCE: "/v0/tp-resources/approve-resource",
    API_GET_ACTIVITY_REPORT: "/v0/tp-reports/assessment-activity-based-report/"
}, _defineProperty(_module$constant, "API_APPROVE_RESOURCE", "/v0/tp-resources/approve-resource"), _defineProperty(_module$constant, "API_GET_STUDENTS", "/v0/tp-reports/student-details"), _defineProperty(_module$constant, "API_GET_ALL_ACTIVITY", "/v0/tp-reports/activity-list/"), _defineProperty(_module$constant, "API_ADD_LEARNING_PROGRESS", "/v0/tp-resources/learning-progress/save"), _defineProperty(_module$constant, "API_ADD_NOTES", "/v0/tp-resources/add-note"), _defineProperty(_module$constant, "API_GET_PREV_NOTES", "/v0/tp-resources/get-previous-note"), _defineProperty(_module$constant, "API_GET_STUDENT_REPORT", "/v0/tp-reports/assessment-activity-student-based-report/"), _defineProperty(_module$constant, "API_GET_ASSIGNED_RESOURCES", "/v0/tp-reports/assigned-resources/"), _defineProperty(_module$constant, "API_GET_LEARNING_PROGRESS", "/v0/tp-reports/learning-progress"), _defineProperty(_module$constant, "API_GET_ALL_PRACTICE_ACTIVITY", "/v0/tp-reports/practice-activity-list/"), _defineProperty(_module$constant, "API_GET_PRACTICE_ACTIVITY_REPORT", "/v0/tp-reports/practice-activity-based-report/"), _defineProperty(_module$constant, "API_GET_STUDENT_PRACTICE_REPORT", "/v0/tp-reports/practice-activity-student-based-report/"), _defineProperty(_module$constant, "API_COMPLETE_RESOURCE", "/v0/teachingPlan/resource-complete/"), _module$constant));

_module.config(["$stateProvider", function ($stateProvider) {
    "ngInject";

    $stateProvider
    /*.state('wizard', {
        parent: 'app',
        url: '/wizard/:planId',
        views: {
            '@': {
                template: wizardTpl,
                controller: wizardController,
                controllerAs: 'wizard'
            }
        }
    })*/
    .state('weblinks', {
        parent: 'wizard',
        url: '/weblinks/:resourceId',
        views: {
            'tpWizardView': {
                template: _weblinks2.default,
                controller: _weblinks4.default,
                controllerAs: 'weblinks'
            }
        }
    }).state('weblinksPreview', {
        parent: 'wizard',
        url: '/weblinks-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _weblinksPreview2.default,
                controller: _weblinksPreview4.default,
                controllerAs: 'weblinksPreview'
            }
        }
    }).state('refbooks', {
        parent: 'wizard',
        url: '/reference-book/:resourceId',
        views: {
            'tpWizardView': {
                template: _referenceBook2.default,
                controller: _referenceBook4.default,
                controllerAs: 'referenceBook'
            }
        }
    }).state('refbooksPreview', {
        parent: 'wizard',
        url: '/reference-book-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _referenceBookPreview2.default,
                controller: _referenceBookPreview4.default,
                controllerAs: 'referenceBookPreview'
            }
        }
    }).state('googleDocs', {
        parent: 'wizard',
        url: '/google-doc/:resourceId',
        views: {
            'tpWizardView': {
                template: _googleDoc2.default,
                controller: _googleDoc4.default,
                controllerAs: 'googleDoc'
            }
        }
    }).state('googleDocsPreview', {
        parent: 'wizard',
        url: '/google-doc-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _googleDocPreview2.default,
                controller: _googleDocPreview4.default,
                controllerAs: 'googleDocPreview'
            }
        }
    }).state('utubeVideo', {
        parent: 'wizard',
        url: '/you-tube/:resourceId',
        views: {
            'tpWizardView': {
                template: _utubeVideo2.default,
                controller: _utubeVideo4.default,
                controllerAs: 'utubeVideo'
            }
        }
    }).state('utubeVideoPreview', {
        parent: 'wizard',
        url: '/you-tube-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _utubeVideoPreview2.default,
                controller: _utubeVideoPreview4.default,
                controllerAs: 'utubeVideoPreview'
            }
        }
    }).state('khanAcademy', {
        parent: 'wizard',
        url: '/khan-academy/:resourceId',
        views: {
            'tpWizardView': {
                template: _khanAcademy2.default,
                controller: _khanAcademy4.default,
                controllerAs: 'khanAcademy'
            }
        }
    }).state('khanAcademyPreview', {
        parent: 'wizard',
        url: '/khan-academy-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _khanAcademyPreview2.default,
                controller: _khanAcademyPreview4.default,
                controllerAs: 'khanAcademy'
            }
        }
    }).state('activityForm', {
        parent: 'wizard',
        url: '/create-tp-activity/:resourceId',
        views: {
            'tpWizardView': {
                template: _createTpActivity2.default,
                controller: _createTpActivity4.default,
                controllerAs: 'createTpActivity'
            }
        }
    }).state('createTpQuestion', {
        parent: 'wizard',
        url: '/create-tp-question',
        views: {
            'tpWizardView': {
                template: _createQuestion2.default,
                controller: _createQuestionController2.default,
                controllerAs: 'createTpQuestion'
            }
        }
    }).state('formatQp', {
        parent: 'wizard',
        url: '/format-qp/:resourceId',
        views: {
            'tpWizardView': {
                template: _formatQp2.default,
                controller: _formatQp4.default,
                controllerAs: 'formatQp'
            }
        }
    }).state('tpActivityPreview', {
        parent: 'wizard',
        url: '/tp-activity-preview/:qpId',
        views: {
            'tpWizardView': {
                template: _tpActivityPreview2.default,
                controller: _tpActivityPreview4.default,
                controllerAs: 'qpPreviewCtrl'
            }
        }
    }).state('activityFormPreview', {
        parent: 'wizard',
        url: '/qp-summary-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _qpSummaryPreview2.default,
                controller: _qpSummaryPreview4.default,
                controllerAs: 'qpSummaryPreviewCtrl'
            }
        }
    }).state('submissionList', {
        parent: 'wizard',
        url: '/activity-submission-list/:qpId',
        views: {
            'tpWizardView': {
                template: _submissionList2.default,
                controller: _submissionList4.default,
                controllerAs: 'submissionListCtrl'
            }
        }
    }).state('attendExam', {
        parent: 'wizard',
        url: '/attend-exam/:qpId',
        views: {
            'tpWizardView': {
                template: _attendExam2.default,
                controller: _attendExam4.default,
                controllerAs: 'attendExamCtrl'
            }
        }
    }).state('questionDirective', {
        parent: 'wizard',
        url: '/question-selection/:qpId/:activityId',
        views: {
            'tpWizardView': {
                template: _questionDirective2.default,
                controller: _questionDirective4.default,
                controllerAs: 'questionDirectiveCtrl'
            }
        }
    }).state('flash', {
        parent: 'wizard',
        url: '/flash/:resourceId',
        views: {
            'tpWizardView': {
                template: _flash2.default,
                controller: _flash4.default,
                controllerAs: 'flash'
            }
        }
    }).state('flashPreview', {
        parent: 'wizard',
        url: '/flash-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _flashPreview2.default,
                controller: _flashPreview4.default,
                controllerAs: 'flash'
            }
        }
    }).state('video', {
        parent: 'wizard',
        url: '/video/:resourceId',
        views: {
            'tpWizardView': {
                template: _video2.default,
                controller: _video4.default,
                controllerAs: 'video'
            }
        }
    }).state('videoPreview', {
        parent: 'wizard',
        url: '/video-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _videoPreview2.default,
                controller: _videoPreview4.default,
                controllerAs: 'video'
            }
        }
    }).state('pdf', {
        parent: 'wizard',
        url: '/pdf/:resourceId',
        views: {
            'tpWizardView': {
                template: _pdf2.default,
                controller: _pdf4.default,
                controllerAs: 'pdf'
            }
        }
    }).state('pdfPreview', {
        parent: 'wizard',
        url: '/pdf-preview/:resourceId',
        views: {
            'tpWizardView': {
                template: _pdfPreview2.default,
                controller: _pdfPreview4.default,
                controllerAs: 'pdf'
            }
        }
    }).state('teacherAnswerPreview', {
        parent: 'wizard',
        url: '/teacher-answer-preview/:qpId/:studentId',
        views: {
            'tpWizardView': {
                template: _teacherAnswerView2.default,
                controller: _teacherAnswerView4.default,
                controllerAs: 'teacherAnswerViewCtrl'
            }
        }
    }).state('studentAnswerPreview', {
        parent: 'wizard',
        url: '/teacher-answer-preview/:qpId',
        views: {
            'tpWizardView': {
                template: _studentAnswerView2.default,
                controller: _studentAnswerView4.default,
                controllerAs: 'studentAnswerViewCtrl'
            }
        }
    }).state('reportsPreview', {
        parent: 'wizard',
        url: '/reports-preview',
        views: {
            'tpWizardView': {
                template: _reports2.default,
                controller: _reports4.default,
                controllerAs: 'reportsPreviewCtrl'
            }
        }
    }).state('activityReports', {
        parent: 'wizard',
        url: '/activity-reports',
        views: {
            'tpWizardView': {
                template: _activityReports2.default,
                controller: _activityReports4.default,
                controllerAs: 'activityReportsCtrl'
            }
        }
    }).state('singleActivityReports', {
        parent: 'wizard',
        url: '/single-activity-reports/:qpId',
        views: {
            'tpWizardView': {
                template: _singleActivityReport2.default,
                controller: _singleActivityReport4.default,
                controllerAs: 'singleActivityReportCtrl'
            }
        }
    }).state('studentActivityReports', {
        parent: 'wizard',
        url: '/student-activity-reports/:studentId/:isShowGoBack',
        views: {
            'tpWizardView': {
                template: _studentActivityReport2.default,
                controller: _studentActivityReport4.default,
                controllerAs: 'studentActivityReportCtrl'
            }
        }
    }).state('studentLearningProgress', {
        parent: 'wizard',
        url: '/student-learning-progress/:studentId/:isShowGoBack',
        views: {
            'tpWizardView': {
                template: _studentViewLearningProgress2.default,
                controller: _studentViewLearningProgress4.default,
                controllerAs: 'studentLearningProgressCtrl'
            }
        }
    }).state('teacherLearningProgress', {
        parent: 'wizard',
        url: '/teacher-learning-progress/:studentId/:isShowGoBack',
        views: {
            'tpWizardView': {
                template: _teacherViewLearningProgress2.default,
                controller: _teacherViewLearningProgress4.default,
                controllerAs: 'teacherLearningProgressCtrl'
            }
        }
    }).state('practiceActivityReports', {
        parent: 'wizard',
        url: '/activity-reports',
        views: {
            'tpWizardView': {
                template: _practiceActivityReports2.default,
                controller: _practiceActivityReports4.default,
                controllerAs: 'practiceActivityReportsCtrl'
            }
        }
    }).state('singlePracticeReport', {
        parent: 'wizard',
        url: '/single-practice-reports/:qpId',
        views: {
            'tpWizardView': {
                template: _singlePracticeActivityReport2.default,
                controller: _singlePracticeActivityReport4.default,
                controllerAs: 'singlePracticeReportCtrl'
            }
        }
    }).state('studentPracticeReport', {
        parent: 'wizard',
        url: '/student-practice-reports/:studentId/:isShowGoBack',
        views: {
            'tpWizardView': {
                template: _studentPracticeActivityReport2.default,
                controller: _studentPracticeActivityReport4.default,
                controllerAs: 'studentPracticeReportCtrl'
            }
        }
    });
}]);

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.addWebLinks.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex=50> <md-input-container flex> <label>Web Note</label> <input type=text ng-model=resource.web_note> <div class=errorMessage>{{errors['web_note']}}</div> </md-input-container> </div> <div class=\"res-input-container md-whiteframe-3dp\" flex=50 layout=row> <md-input-container flex> <label>Web Link</label> <input type=text ng-model=resource.web_link> <div class=errorMessage> {{errors['web_link']}}</div> </md-input-container> </div> </div> <md-divider></md-divider> <md-input-container layout=row layout-align=\"end center\" flex> <div class=res-save-icon ng-click=addResource()> <i class=\"fas fa-save\"></i> </div> <div class=res-cancel-icon ng-click=resetResource()> <i class=\"fas fa-times\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var WeblinkController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function WeblinkController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, WeblinkController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_WEBLINK;

    var validate = function validate(resource) {
        var errorCount = 0;
        if (resource.web_note === null || resource.web_note === undefined || resource.web_note === "") {
            $scope.errors["web_note"] = "Please Enter book web_note";
            errorCount++;
        }
        if (resource.web_link === null || resource.web_link === undefined || resource.web_link === "") {
            $scope.errors["web_link"] = "Please Enter web link";
            errorCount++;
        } else {
            var pattern = /((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
            if (!pattern.test(resource.web_link)) {
                $scope.errors["web_link"] = "Please Enter a valid link";
                errorCount++;
            }
        }
        return errorCount;
    };

    $scope.addResource = function () {
        var resource = {
            web_note: $scope.resource.web_note.trim(),
            web_link: $scope.resource.web_link.trim()
        };
        $scope.errors = {};
        var errorCount = validate(resource);
        if (errorCount === 0) {
            authService.callAPI(save_url, "POST", {
                tp_id: planId,
                _id: resourceId,
                title: $scope.resource.title,
                web_note: $scope.resource.web_note,
                web_link: $scope.resource.web_link,
                status: $scope.resource.status,
                user_id: userId
            }, function (response) {
                if (response && response.result && response.result.data) {
                    var result = response.result.data;
                    toastr.success("Web Link added successfully");
                    localStorageService.set("currentPlan", result);
                    $rootScope.setStatus(resourceId, 'created');
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error("Network Error, please try later.");
                }
            });
        }
    };

    $scope.resetResource = function () {
        $scope.resource.web_note = "";
        $scope.resource.web_link = "";
        $scope.errors = {};
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "weblinks";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = WeblinkController;

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=\"userPrev.viewWebLinks && userPrev.viewWebLinks.read&&isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div flex layout=column layout-align=\"start end\"> <md-button ng-click=viewResource() class=\"hide-btn addToQues\" style=background-color:#1665c1!important> {{toogleResource}} <i class=\"fas fa-angle-down\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=!isShow></i> <i class=\"fas fa-angle-up\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=isShow></i> </md-button> </div> <div flex ng-show=isShow layout=column> <div layout=row layout-align=space-between class=padding-10> <div layout=row flex=50 layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" flex=100 layout=column> <label class=res-label>Web Note</label> <div class=res-text>{{resource.web_note}}</div> </div> </div> <div layout=row flex=50 layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" flex=100 layout=column> <label class=res-label>Web Link</label> <div class=\"res-text doc-link\"><a ng-click=gotoSite(resource.web_link)>{{resource.web_link}}</a></div> </div> </div> </div> </div> </div> <div class=md-whiteframe-2dp ng-show=isAvailable layout=row flex=100 layout-wrap layout-align=space-around> <object ng-if=\"src && src !== null\" data={{src}} width=930 height=600 flex allowfullscreen> <div flex class=link-error-message>Weblink is not loaded. Please click the above link to view.</div> </object> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Weblink Available... To add weblink go to Edit mode</label> </div> </div>";

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var WeblinksPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function WeblinksPreviewController($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, WeblinksPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    console.log(plan);
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }

    $scope.gotoSite = function (site) {
        if (site.indexOf("http") === -1) {
            site = "http://" + site;
        }
        window.open(site, "_blank");
    };

    //Show details of WebLinks
    $scope.viewResource = function () {
        $scope.isShow = !$scope.isShow;
        $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details";
    };

    var loadTemplate = function loadTemplate() {
        console.log(resourceId);
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.viewWebLinks && $scope.userPrev.viewWebLinks.read && ($scope.userPrev.addWebLinks == undefined || $scope.userPrev.addWebLinks && !$scope.userPrev.addWebLinks.create) && ($scope.userPrev.approveWebLinks == undefined || $scope.userPrev.approveWebLinks && !$scope.userPrev.approveWebLinks.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.web_link) {
                    $scope.isAvailable = true;
                    var site = $scope.resource.web_link;
                    if (site.indexOf("http") === -1) {
                        site = "http://" + site;
                    }
                    $scope.src = $sce.trustAsResourceUrl(site);
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "weblinks";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = WeblinksPreviewController;

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex=50> <md-input-container flex> <label>Book Name</label> <input type=text ng-model=resource.name> <div class=errorMessage>{{errors['resources.0.name']}}</div> </md-input-container> </div> <div class=\"res-input-container md-whiteframe-3dp\" flex=50 layout=row> <md-input-container flex> <label>Author</label> <input type=text ng-model=resource.author> <div class=errorMessage>{{errors['resources.0.author']}}</div> </md-input-container> </div> </div> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex=50> <md-input-container flex> <label>Publisher</label> <input type=text ng-model=resource.publisher> <div class=errorMessage>{{errors['resources.0.publisher']}}</div> </md-input-container> </div> <div class=\"res-input-container md-whiteframe-3dp\" flex=50 layout=row> <md-input-container flex> <label>ISBN</label> <input type=text maxlength=40 md-maxlength=40 ng-model=resource.isbn> <div class=errorMessage>{{errors['resources.0.isbn']}}</div> </md-input-container> </div> </div> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex> <label>Web Link</label> <input type=text ng-model=resource.web_link> <div class=errorMessage>{{errors['resources.0.web_link']}}</div> </md-input-container> </div> </div> <md-divider></md-divider> <md-input-container layout=row layout-align=\"end center\" flex> <div class=res-save-icon ng-click=addResource()> <i class=\"fas fa-save\"></i> </div> <div class=res-cancel-icon ng-click=resetResource()> <i class=\"fas fa-times\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: referenceBook.js
 * Project: educore
 * Created Date: 2019-01-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ReferenceBookController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function ReferenceBookController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, ReferenceBookController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.resource = {};

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_REFBOOK;

    var validate = function validate(resource) {
        var errorCount = 0;
        if (resource.name === null || resource.name === undefined || resource.name === "") {
            $scope.errors["name"] = "Please enter book name";
            errorCount++;
        }
        if (resource.author === null || resource.author === undefined || resource.author === "") {
            $scope.errors["author"] = "Please enter author name";
            errorCount++;
        }
        if (resource.publisher === null || resource.publisher === undefined || resource.publisher === "") {
            $scope.errors["publisher"] = "Please enter publisher name";
            errorCount++;
        }
        if (resource.isbn === null || resource.isbn === undefined || resource.isbn === "") {
            $scope.errors["isbn"] = "Please enter isbn ";
            errorCount++;
        } else {
            var pattern = /((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
            if (!pattern.test(resource.web_link)) {
                $scope.errors["web_link"] = "Please Enter a valid link";
                errorCount++;
            }
        }
        return errorCount;
    };

    $scope.addResource = function () {
        var resource = {
            name: $scope.resource.name,
            author: $scope.resource.author,
            publisher: $scope.resource.publisher,
            isbn: $scope.resource.isbn,
            web_link: $scope.resource.web_link
        };
        $scope.errors = {};
        var errorCount = validate(resource);
        if (errorCount === 0) {
            authService.callAPI(save_url, "POST", {
                tp_id: planId,
                _id: resourceId,
                title: $scope.resource.title,
                name: $scope.resource.name,
                author: $scope.resource.author,
                publisher: $scope.resource.publisher,
                isbn: $scope.resource.isbn,
                web_link: $scope.resource.web_link,
                status: $scope.resource.status,
                user_id: userId
            }, function (response) {
                if (response && response.result && response.result.data) {
                    var result = response.result.data;
                    toastr.success("Reference Book added successfully");
                    localStorageService.set("currentPlan", result);
                    $rootScope.setStatus(resourceId, result.status);
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error("Network Error, please try later.");
                }
            });
        }
    };

    $scope.resetResource = function () {
        $scope.resource.web_note = "";
        $scope.resource.web_link = "";
        $scope.errors = {};
    };

    var loadTemplate = function loadTemplate() {
        console.log(plan);
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            console.log($scope.resource);
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "refbooks";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = ReferenceBookController;

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=\"userPrev.viewReferenceBook && userPrev.viewReferenceBook.read&&isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div flex layout=column layout-align=\"start end\"> <md-button ng-click=viewResource() class=\"hide-btn addToQues\" style=background-color:#1665c1!important> {{toogleResource}} <i class=\"fas fa-angle-down\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=!isShow></i> <i class=\"fas fa-angle-up\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=isShow></i> </md-button> <div flex ng-show=isShow layout=column style=width:100%> <div layout=row layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" layout=column flex=50> <label class=res-label>Book Name</label> <div class=res-text>{{resource.name}}</div> </div> <div class=\"res-container md-whiteframe-3dp\" flex=50 layout=column> <label class=res-label>Author</label> <div class=res-text>{{resource.author}}</div> </div> </div> <div layout=row layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" layout=column flex=50> <label class=res-label>Publisher</label> <div class=res-text>{{resource.publisher}}</div> </div> <div class=\"res-container md-whiteframe-3dp\" flex=50 layout=column> <label class=res-label>ISBN</label> <div class=res-text>{{resource.isbn}}</div> </div> </div> <div layout=row layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" layout=column> <label class=res-label>Web Link</label> <div class=\"res-text doc-link\"><a ng-click=gotoSite(resource.web_link)>{{resource.web_link}}</a></div> </div> </div> </div> </div> </div> <div class=md-whiteframe-2dp ng-show=isAvailable layout=row layout-wrap layout-align=space-around> <object ng-if=\"src && src !== null\" data={{src}} width=930 height=600 flex allowfullscreen> <div flex class=link-error-message>Reference book is not loaded. Please click the above link to view.</div> </object> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Reference book Available... To add weblink go to Edit mode</label> </div> </div>";

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: referenceBookPreview.js
 * Project: educore
 * Created Date: 2019-01-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ReferenceBookPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function ReferenceBookPreviewController($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, ReferenceBookPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }

    $scope.gotoSite = function (site) {
        if (site.indexOf("http") === -1) {
            site = "http://" + site;
        }
        window.open(site, "_blank");
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            if ($scope.userPrev.viewReferenceBook && $scope.userPrev.viewReferenceBook.read && ($scope.userPrev.addReferenceBook == undefined || $scope.userPrev.addReferenceBook && !$scope.userPrev.addReferenceBook.create) && ($scope.userPrev.approveReferenceBook == undefined || $scope.userPrev.approveReferenceBook && !$scope.userPrev.approveReferenceBook.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.web_link) {
                    $scope.isAvailable = true;
                    var site = $scope.resource.web_link;
                    if (site.indexOf("http") === -1) {
                        site = "http://" + site;
                    }
                    $scope.src = $sce.trustAsResourceUrl(site);
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    //Show details of WebLinks
    $scope.viewResource = function () {
        $scope.isShow = !$scope.isShow;
        $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details";
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "refbooks";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = ReferenceBookPreviewController;

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.addGoogleDocs.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex=50> <md-input-container flex> <label>Google Doc Name</label> <input type=text ng-model=resource.doc_name> <div class=errorMessage>{{errors['doc_name']}}</div> </md-input-container> </div> <div class=\"res-input-container md-whiteframe-3dp\" flex=50 layout=row> <md-input-container flex> <label>Google Doc Link</label> <input type=text ng-model=resource.doc_link> <div class=errorMessage> {{errors['doc_link']}}</div> </md-input-container> </div> </div> <md-divider></md-divider> <md-input-container layout=row layout-align=\"end center\" flex> <div class=res-save-icon ng-click=addResource()> <i class=\"fas fa-save\"></i> </div> <div class=res-cancel-icon ng-click=resetResource()> <i class=\"fas fa-times\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: GoogleDocController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var GoogleDocController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function GoogleDocController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, GoogleDocController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_GOOGLEDOCS;

    var validate = function validate(resource) {
        var errorCount = 0;
        if (resource.doc_name === null || resource.doc_name === undefined || resource.doc_name === "") {
            $scope.errors["doc_name"] = "Please Enter doc_name";
            errorCount++;
        }
        if (resource.doc_link === null || resource.doc_link === undefined || resource.doc_link === "") {
            $scope.errors["doc_link"] = "Please Enter web link";
            errorCount++;
        } else {
            // var pattern = /((?:https?\:\/\/|www\.)(?:[-a-z0-9]+\.)*[-a-z0-9]+.*)/i;
            var pattern = /https:\/\/docs.google.com\//i; /**  Author: Sreeswathy  Description: To validate google docs  */
            if (!pattern.test(resource.doc_link)) {
                $scope.errors["doc_link"] = "Please Enter a valid link";
                errorCount++;
            }
        }
        return errorCount;
    };

    $scope.addResource = function () {
        var resource = {
            doc_name: $scope.resource.doc_name.trim(),
            doc_link: $scope.resource.doc_link.trim()
        };
        $scope.errors = {};
        var errorCount = validate(resource);
        if (errorCount === 0) {
            authService.callAPI(save_url, "POST", {
                tp_id: planId,
                _id: resourceId,
                title: $scope.resource.title,
                doc_name: $scope.resource.doc_name,
                doc_link: $scope.resource.doc_link,
                status: $scope.resource.status,
                user_id: userId
            }, function (response) {
                if (response && response.result && response.result.data) {
                    var result = response.result.data;
                    toastr.success("Google docs added successfully");
                    localStorageService.set("currentPlan", result);
                    $rootScope.setStatus(resourceId, result.status);
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error("Network Error, please try later.");
                }
            });
        }
    };

    $scope.resetResource = function () {
        $scope.resource.doc_name = "";
        $scope.resource.doc_link = "";
        $scope.errors = {};
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "googleDocs";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = GoogleDocController;

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=\"userPrev.viewGoogleDocs && userPrev.viewGoogleDocs.read&&isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div flex layout=column layout-align=\"start end\"> <md-button ng-click=viewResource() class=\"hide-btn addToQues\" style=background-color:#1665c1!important> {{toogleResource}} <i class=\"fas fa-angle-down\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=!isShow></i> <i class=\"fas fa-angle-up\" style=color:#fff;padding-top:9px;float:right;padding-left:7px ng-if=isShow></i> </md-button> </div> <div flex ng-show=isShow layout=column> <div layout=row layout-align=space-between class=padding-10> <div layout=row flex=50 layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" flex=100 layout=column> <label class=res-label>Google Doc Name</label> <div class=res-text>{{resource.doc_name}}</div> </div> </div> <div layout=row flex=50 layout-align=space-between> <div class=\"res-container md-whiteframe-3dp\" flex=100 layout=column> <label class=res-label>Google Doc Link</label> <div class=\"res-text doc-link\"><a ng-click=gotoSite(resource.doc_link)>{{resource.doc_link}}</a></div> </div> </div> </div> </div> </div> <div class=md-whiteframe-2dp ng-show=isAvailable layout=row flex=100 layout-wrap layout-align=space-around> <object ng-if=\"src && src !== null\" data={{src}} width=930 height=480 flex allowfullscreen> <div flex class=link-error-message>Google Doc is not loaded. Please click the above link to view.</div> </object> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Google Doc Available... To add Google Doc go to Edit mode</label> </div> </div>";

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var GoogleDocPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "localStorageService", "UserPrivilages", "authService", "TPWIZARDCONSTANT", function GoogleDocPreviewController($scope, $state, $rootScope, $sce, localStorageService, UserPrivilages, authService, TPWIZARDCONSTANT) {
    _classCallCheck(this, GoogleDocPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    console.log(plan);
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }

    $scope.gotoSite = function (site) {
        if (site.indexOf("http") === -1) {
            site = "http://" + site;
        }
        window.open(site, "_blank");
    };

    //Show details of WebLinks
    $scope.viewResource = function () {
        $scope.isShow = !$scope.isShow;
        $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details";
    };

    var loadTemplate = function loadTemplate() {
        console.log(resourceId);
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.viewGoogleDocs && $scope.userPrev.viewGoogleDocs.read && ($scope.userPrev.addGoogleDocs == undefined || $scope.userPrev.addGoogleDocs && !$scope.userPrev.addGoogleDocs.create) && ($scope.userPrev.approveGoogleDocs == undefined || $scope.userPrev.approveGoogleDocs && !$scope.userPrev.approveGoogleDocs.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.doc_link) {
                    $scope.isAvailable = true;
                    var site = $scope.resource.doc_link;
                    if (site.indexOf("http") === -1) {
                        site = "http://" + site;
                    }
                    $scope.src = $sce.trustAsResourceUrl(site);
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };
    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "googleDocs";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = GoogleDocPreviewController;

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.addYoutubeLinks.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" flex layout=row> <md-input-container flex> <label>Youtube Link</label> <input type=text ng-model=resource.youtube_link> <div class=errorMessage> {{errors['youtube_link']}}</div> </md-input-container> </div> </div> <md-divider></md-divider> <md-input-container layout=row layout-align=\"end center\" flex> <div class=res-save-icon ng-click=addResource()> <i class=\"fas fa-save\"></i> </div> <div class=res-cancel-icon ng-click=resetResource()> <i class=\"fas fa-times\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: youtubeController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var youtubeController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function youtubeController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, youtubeController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_UTUBE;

    var validate = function validate(resource) {
        var errorCount = 0;
        if (resource.youtube_link === null || resource.youtube_link === undefined || resource.youtube_link === "") {
            $scope.errors["youtube_link"] = "Please enter youtube link";
            errorCount++;
        } else {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
            if (!regExp.test(resource.youtube_link)) {
                $scope.errors["youtube_link"] = "Please Enter a valid link";
                errorCount++;
            }
        }
        return errorCount;
    };

    $scope.addResource = function () {
        var resource = {
            youtube_link: $scope.resource.youtube_link.trim()
        };
        $scope.errors = {};
        var errorCount = validate(resource);
        if (errorCount === 0) {
            authService.callAPI(save_url, "POST", {
                tp_id: planId,
                _id: resourceId,
                title: $scope.resource.title,
                youtube_link: $scope.resource.youtube_link,
                status: $scope.resource.status,
                user_id: userId
            }, function (response) {
                if (response && response.result && response.result.data) {
                    var result = response.result.data;
                    toastr.success("Youtube video added successfully");
                    localStorageService.set("currentPlan", result);
                    $rootScope.setStatus(resourceId, result.status);
                    _.defer(function () {
                        $scope.$apply();
                    });
                } else {
                    toastr.error("Network Error, please try later.");
                }
            });
        }
    };

    $scope.resetResource = function () {
        $scope.resource.web_note = "";
        $scope.resource.youtube_link = "";
        $scope.errors = {};
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "utubeVideo";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = youtubeController;

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp ng-show=userPrev.viewYoutubeVideos.read&&isAvailable layout=row flex=100 layout-wrap layout-align=space-around> <object ng-if=\"src && src !== null\" data={{src}} width=930 height=500 flex allowfullscreen> <div flex class=link-error-message>Youtube is not loaded. Please click the above link to view.</div> </object> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Youtube Available... To add Youtube go to Edit mode</label> </div> </div>";

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: youtubePreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var youtubesPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function youtubesPreviewController($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, youtubesPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    console.log(plan);
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }

    $scope.gotoSite = function (site) {
        if (site.indexOf("http") === -1) {
            site = "http://" + site;
        }
        window.open(site, "_blank");
    };

    //Show details of WebLinks
    $scope.viewResource = function () {
        $scope.isShow = !$scope.isShow;
        $scope.toogleResource = $scope.isShow ? "Hide Details" : "Show Details";
    };

    var loadTemplate = function loadTemplate() {
        console.log(resourceId);
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.viewYoutuVideos && $scope.userPrev.viewYoutuVideos.read && ($scope.userPrev.addYoutubeLinks == undefined || $scope.userPrev.addYoutubeLinks && !$scope.userPrev.addYoutubeLinks.create) && ($scope.userPrev.approveYoutubeLinks == undefined || $scope.userPrev.approveYoutubeLinks && !$scope.userPrev.approveYoutubeLinks.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.youtube_link) {
                    $scope.isAvailable = true;
                    $scope.src = $scope.resource.youtube_link;
                    var video_id = $scope.src.split('v=')[1] ? $scope.src.split('v=')[1].split('&')[0] : undefined;
                    if (!video_id) {
                        var splitedSrc = $scope.src.split('/');
                        video_id = splitedSrc[splitedSrc.length - 1];
                    }
                    $scope.src = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + video_id + "?modestbranding=1;&rel=0");
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "utubeVideo";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = youtubesPreviewController;

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.addKhanAcademyLinks.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex> <label>Khan Academy Title</label> <input type=text ng-model=resource.academyTitle> <div class=errorMessage>{{errors['academyTitle']}}</div> </md-input-container> </div> </div> <md-divider></md-divider> <md-input-container layout=row layout-align=\"end center\" flex> <div class=res-save-icon ng-click=addResource()> <i class=\"fas fa-save\"></i> </div> <div class=res-cancel-icon ng-click=resetResource()> <i class=\"fas fa-times\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var WeblinkController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function WeblinkController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, WeblinkController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_KHANACADEMY;

    /*
     * To Call khanacademy API
     * @title : String - khanacademy title
     * @callback : Function - To return response from server
     * @return : null
     * @Developer: Arul Mozhi J
     */
    var callKhanAcademyAPI = function callKhanAcademyAPI(title, callback) {
        try {
            var url = TPWIZARDCONSTANT.KHANACADEMY_URL + title;
            console.log(url);
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    var resultObj = {
                        "result": undefined,
                        "error": undefined
                    };
                    try {
                        resultObj.result = JSON.parse(xhttp.responseText);
                        callback(resultObj);
                    } catch (error) {
                        resultObj.error = "Bad Request - End Point is invalid";
                        callback(resultObj);
                    }
                } else {
                    if (this.readyState == 4) {
                        var _resultObj = {
                            "result": undefined,
                            "error": undefined
                        };
                        _resultObj.error = JSON.parse(xhttp.responseText);
                        callback(_resultObj);
                    }
                }
            };
            xhttp.open('GET', url, true);
            xhttp.onerror = function (e) {
                var resultObj = {
                    "result": undefined,
                    "error": undefined
                };
                resultObj.error = "Bad Request - Server is Down";
                callback(resultObj);
            };
            xhttp.send();
        } catch (ex) {
            console.log(ex);
        }
    };

    var validate = function validate() {
        var errorCount = 0;
        if ($scope.resource.academyTitle) {
            if ($scope.resource.academyTitle.trim() === "") {
                $scope.errors.academyTitle = "";
                errorCount++;
            }
        }
        if ($scope.resource.academyTitle === undefined || $scope.resource.academyTitle === null || $scope.resource.academyTitle === "") {
            $scope.errors['academyTitle'] = "Plaese enter title";
            errorCount++;
        }
        return errorCount;
    };

    $scope.addResource = function () {
        $scope.errors = {};
        var errorCount = validate();
        if (errorCount === 0) {
            callKhanAcademyAPI($scope.resource.academyTitle, function (resultObj) {
                if (resultObj.result) {
                    console.log(resultObj);
                    var result = resultObj.result;
                    if (result != undefined && result.url != undefined) {
                        var params = {
                            tp_id: planId,
                            _id: resourceId,
                            title: $scope.resource.title,
                            url: result.url,
                            readable_id: result.readable_id,
                            youtube_id: result.youtube_id,
                            thumb_url: result.thumbnail,
                            topic: result.title,
                            status: $scope.resource.status,
                            user_id: userId
                        };
                        authService.callAPI(save_url, "POST", params, function (response) {
                            if (response && response.result && response.result.data) {
                                var result = response.result.data;
                                toastr.success("Khan academy added successfully");
                                localStorageService.set("currentPlan", result);
                                $rootScope.setStatus(resourceId, result.status);
                                _.defer(function () {
                                    $scope.$apply();
                                });
                            } else {
                                toastr.error("Network Error, please try later.");
                            }
                        });
                    }
                } else {
                    toastr.error("No data against topic");
                    $scope.isSaveDisable = false;
                }
            });
        }
    };

    $scope.resetResource = function () {
        $scope.resource.academyTitle = "";
        $scope.errors = {};
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            if ($scope.resource.readable_id) {
                $scope.resource.academyTitle = $scope.resource.readable_id;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "khanAcademy";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = WeblinkController;

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp ng-show=\"userPrev.viewKhanAcademy && userPrev.viewKhanAcademy.read && isAvailable\" layout=row flex=100 layout-wrap layout-align=space-around> <object ng-if=\"src && src !== null\" data={{src}} width=930 height=500 flex allowfullscreen> <div flex class=link-error-message>Khan Academy Video is not loaded. Please click the above link to view.</div> </object> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Khan Academy Video Available... To add Khan Academy Video go to Edit mode</label> </div> </div>";

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var WeblinksPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", function WeblinksPreviewController($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
    _classCallCheck(this, WeblinksPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    console.log(plan);
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.viewKhanAcademy != undefined && $scope.userPrev.viewKhanAcademy.read && ($scope.userPrev.addKhanAcademyLinks == undefined || $scope.userPrev.addKhanAcademyLinks && !$scope.userPrev.addKhanAcademyLinks.create) && ($scope.userPrev.approveKhanAcademyLinks == undefined || $scope.userPrev.approveKhanAcademyLinks && !$scope.userPrev.approveKhanAcademyLinks.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.url) {
                    $scope.isAvailable = true;
                    $scope.src = $scope.resource.url;
                    var video_id = $scope.src.split('v=')[1].split('&')[0];
                    $scope.src = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + video_id + "?modestbranding=1;&rel=0");
                }
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };
    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "khanAcademy";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = WeblinksPreviewController;

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports = "<div class=\"md-whiteframe-3dp md-padding md-margin\" style=background:#fff> <div flex=100 layout=row layout-gt-xs=row layout-wrap layout-align=\"start stretch\"> <div style=width:250px layout=row class=\"md-whiteframe-2dp md-margin md-padding feature-div\" layout-align=\"start center\" ng-repeat=\"feature in featuresList\" ng-click=navigatePage(feature)> <md-button class=\"sub-menu-fab md-fab md-mini footer-circle-button\" aria-label=Add ng-style=\"{background: feature.color}\" ​> <img ng-src={{feature.icon}} class=\"material-icons md-hue-2\" alt=Reset> </md-button> <div> <p flex class=feature-name>{{feature.name}}</p></div> </div> </div> </div>";

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: createTpActivity.js
 * Project: educore
 * Created Date: 2018-01-17
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var createTpActivityController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "archiveService", "TPWIZARDCONSTANT", function createTpActivityController($scope, $state, $rootScope, authService, localStorageService, archiveService, TPWIZARDCONSTANT) {
    var _this = this;

    _classCallCheck(this, createTpActivityController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var resourceId = $state.params.resourceId;
    var userId = localStorageService.get('user_id');
    var authoring = localStorageService.get('authoringData');
    authService.callAPI(TPWIZARDCONSTANT.API_GET_TP_ACTIVITY + resourceId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data) {
            var resultData = response.result.data.data;
            if (resultData.temp_sections && resultData.temp_sections.length > 0 || resultData.sections && resultData.sections.length > 0) {
                $state.go('formatQp', {
                    resourceId: resourceId
                });
            }
        }
    });
    var authoringData = {
        class_id: authoring.class_id,
        curriculum_id: authoring.curriculum_id,
        batch_id: authoring.batch_id,
        subject_id: authoring.subject_id,
        session_id: authoring.session_id,
        school_id: authoring.school_id,
        batch: authoring.batch,
        class: authoring.class,
        subject: authoring.subject,
        session: authoring.session,
        curriculum: authoring.curriculum,
        academic_year: authoring.academic_year
    };
    $scope.featuresList = [{
        "_id": "createQuestion",
        "name": "Create Question",
        "state": "createQuestion",
        "icon": "../../../img/icons/create-question.png",
        "color": "#f16e02"
    }, {
        "_id": "selectQuestion",
        "name": "Select Question",
        "state": "selectQuestion",
        "icon": "../../../img/icons/select-question.png",
        "color": "#00b4bd"
    }, {
        "_id": "selectTemplate",
        "name": "Select Template",
        "state": "selectTemplate",
        "icon": "../../../img/icons/question-template.png",
        "color": "#f35966"
    }, {
        "_id": "selectQuestionPaper",
        "name": "Select Question Paper",
        "state": "selectQuestionPaper",
        "icon": "../../../img/icons/archives.png",
        "color": "#00ba9c"
    }];

    //Boolean - show/hide the format questions
    $scope.isQuestions = false;

    this.scope = $scope;
    this.state = $state;
    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activity";
    });
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    $scope.teachingPlan = localStorageService.get("currentPlan");
    var currentResource = _.find($scope.teachingPlan.resources, function (resource) {
        return resource._id == resourceId;
    });
    if (currentResource) $scope.isPractice = currentResource.isPractice;
    var theme_id = $scope.teachingPlan.theme_id;
    authoringData['theme_id'] = $scope.teachingPlan.theme_id;
    authoringData['question_paper_title'] = currentResource.title;
    authoringData['practice_qn'] = $scope.teachingPlan.isPractice;
    authoringData['user_id'] = userId;
    authoringData['activity_id'] = resourceId;
    authoringData['plan_id'] = $scope.teachingPlan._id;
    authoringData['theme_name'] = $scope.teachingPlan.theme_title;
    if (currentResource) {
        var redirectDetails = archiveService.getRedirectJson();
        archiveService.clearRedirectJson();
        if (redirectDetails && redirectDetails.returnData) {
            var details = {
                activity: currentResource,
                teachingPlanId: $scope.teachingPlan._id,
                themeId: $scope.teachingPlan.theme_id
            };
            if (redirectDetails.activeTab == "qp") {
                var archiveQpId = redirectDetails.returnData.resource._id;
                authoringData["archive_qp_id"] = archiveQpId;
                authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QP, "POST", authoringData, function (response) {
                    if (response.result && response.result && response.result.data) {
                        var qpId = response.result.data._id;
                        $state.go('tpActivityPreview', {
                            qpId: qpId
                        });
                    }
                });
            } else if (redirectDetails.activeTab == "question") {
                var ques_ids = [];
                _.each(redirectDetails.returnData, function (questionArchive) {
                    ques_ids.push(questionArchive.resource._id);
                });
                authoringData['ques_ids'] = ques_ids;
                authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QUESTION, "POST", authoringData, function (response) {
                    if (response.result && response.result && response.result.data) {
                        $state.go('formatQp', {
                            resourceId: resourceId
                        });
                    }
                });
            } else if (redirectDetails.activeTab == "qp_template") {
                var qpId = redirectDetails.returnData.resource._id;
                authoringData["archive_qp_id"] = qpId;
                authService.callAPI(TPWIZARDCONSTANT.API_SELECT_TEMPLATE, "POST", authoringData, function (response) {
                    if (response.result && response.result && response.result.data) {
                        var questioPaperId = response.result.data.data._id;
                        $state.go('tpActivityPreview', {
                            qpId: qpId
                        });
                    }
                });
            }
        }
    }

    var goToArchive = function goToArchive(type, isMultiSelect) {
        var teachingPlan = $scope.teachingPlan;
        var searchFilters = [];
        var authoring = localStorageService.get('authoringData');
        searchFilters.push({
            type: 'curriculum',
            value: {
                _id: authoring.curriculum_id,
                name: authoring.curriculum
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'class',
            value: {
                _id: authoring.class_id,
                name: authoring.class
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: 'subject',
            value: {
                _id: authoring.subject_id,
                name: authoring.subject
            },
            deletable: false,
            visible: false
        });
        searchFilters.push({
            type: "tab",
            value: {
                _id: type.tabId,
                name: type.name
            },
            deletable: false,
            visible: false
        });
        if ($scope.isPractice && type.searchFilterId == 'qp') {
            searchFilters.push({
                type: "exam_type",
                value: {
                    _id: "Practice",
                    name: "Practice Exam"
                },
                deletable: false,
                visible: true
            });
        }
        if (!$scope.isPractice && type.searchFilterId == 'qp') {
            searchFilters.push({
                type: "exam_type",
                value: {
                    _id: "Assesment",
                    name: "Assessment Exam"
                },
                deletable: false,
                visible: true
            });
        }
        var details = _defineProperty({
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            isMultiSelect: isMultiSelect,
            isPractice: $scope.isPractice,
            activeTab: type.tabId,
            resource: _this.resource,
            resourceType: {
                _id: type.searchFilterId,
                name: type.name
            }
        }, "isPractice", $scope.isPractice);
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    $scope.navigatePage = function (data) {
        $scope.selectedActivity = data;
        console.log(data);
        // $scope.showOptions = false;
        switch (data._id) {
            case 'createQuestion':
                localStorageService.set("createQuesiton", {
                    state: "tpActivity",
                    // qp_id: result._id,
                    qp_title: currentResource.title,
                    activity_id: currentResource._id,
                    theme_id: $scope.teachingPlan.theme_id,
                    teaching_plan_id: $scope.teachingPlan._id,
                    class_id: authoringData.class_id,
                    curriculum_id: authoringData.curriculum_id,
                    subject_id: authoringData.subject_id,
                    batch_id: authoringData.batch_id,
                    session_id: authoringData.session_id,
                    school_id: authoringData.school_id,
                    practice_qn: currentResource.isPractice,
                    academic_year: localStorageService.get("activeAcdYear")
                });
                _this.state.go("createTpQuestion");
                break;
            case 'selectQuestionPaper':
                goToArchive({
                    tabId: "qp",
                    searchFilterId: "qp",
                    name: 'Question Paper'
                }, false);
                break;
            case 'selectQuestion':
                goToArchive({
                    tabId: 'question',
                    searchFilterId: 'question',
                    name: "Questions"
                }, true);
                break;
            case 'selectTemplate':
                goToArchive({
                    tabId: 'qp_template',
                    searchFilterId: 'qp',
                    name: "Question Template"
                }, false);
                break;
            default:
                _this.state.go("activityForm");
                break;
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
}];

exports.default = createTpActivityController;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style type=text/css>.formatQuestion .questionTitle{background-color:#1bbc9b;color:#fff;font-size:14px;font-weight:600;padding:15px;margin-top:10px;margin-left:5px;margin-right:5px}.formatQuestion .icons-margin{margin-left:10px}.formatQuestion .icons-drag{margin-left:10px;cursor:move}.formatQuestion .mark-error{border:1px solid red}</style> <div class=\"formatQuestion padding-lr-que\"> <div layout=row class=questionsSection layout-align=space-around> <div class=md-whiteframe-2dp style=margin-right:20px;width:50%> <div class=questionsHead layout-align=space-between layout=row> <div class=left_pad_10 flex=40> <h4> All Questions</h4></div> <div flex=50 ng-click=autoformat() ng-show=\"sectionFormat.length==0&&sectionWiseQuestions.length==0\"> <md-button style=float:right md-no-ink class=\"addToQues auto-btn md-ink-ripple\">Auto Format </md-button> </div> </div> <div class=questions-content> <div class=\"md-accordion seachQues\" ng-if=\"data.questions.length!= 0\" ng-repeat=\"data in formatQuestion.allQuestions\"> <div ng-init=\"data.expanded = false\" layout-align=\"space-between center\" ng-click=toggleExpansion(formatQuestion.allQuestions,data,$index) class=accordianHeading ng-style=\"{'background-color':data.color}\" layout=row> <div layout=row> <span class=headingFont>{{questionType[data.name]}}</span> <div class=quesNo>{{data.questions.length}}</div> </div> <div class=plusMinus> <i class=\"fas fa-plus\" ng-if=\"data.expanded==false\" tooltip=Expand tooltip-position=down></i> <i class=\"fas fa-minus\" ng-if=\"data.expanded==true\" tooltip=Hide tooltip-position=down></i> </div> </div> <div class=accordianContent> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:data.expanded}\"> <div class=questionsContent> <div class=\"md-accordion bottom-border\" ng-repeat=\"item in data.questions\"> <div ng-init=\"item.expanded = false\" layout-align=\"space-between center\" layout=row class=questAccordianHead> <div flex=70 class=quest-ans layout=row ng-click=toggleExpansion(data.questions,item,$index)> <div> <i class=\"fas fa-angle-down\" ng-if=\"item.expanded==false\"></i> <i class=\"fas fa-angle-up\" ng-if=\"item.expanded==true\"></i> </div> <div ng-if=\"item.type !== 'FIB' && item.type !== 'IBT_FIB' && item.type !== 'MTF'&& item.type !== 'DRAW'\"> <span ng-show=item.isLatex class=question_desc>{{item.qn_desc|limitTo:30}}</span> <span ng-show=!item.isLatex>{{item.qn_desc|limitTo:30}}</span> <span ng-show=\"item.qn_desc.length>30\">...</span> </div> <div ng-if=\"item.type === 'FIB' || item.type === 'IBT_FIB' || item.type === 'MTF' || item.type === 'DRAW'\"> <span ng-show=item.isLatex class=question_desc>{{item.qn_desc|limitTo:30}}</span> <span ng-show=!item.isLatex>{{item.qn_desc|limitTo:30}}</span> <span ng-show=\"item.qn_desc.length>30\">...</span> </div> </div> <div flex=30 class=section-close layout-align=\"start end\" layout=row> <div flex=30 ng-click=editQuestion(item) title=\"Edit Question\" tooltip-possition=up><i class=\"fas fa-pen editIconColor\"></i></div> <div flex=30 ng-click=\"deleteQuestion(item._id, data._id)\" title=\"Remove Question\" tooltip-possition=up><img style=padding-bottom:7px src=" + __webpack_require__(16) + "></div> <div flex=30 ng-click=moveQuestion(item,$index) title=\"Add to Questions\" tooltip-possition=up><i class=\"auto-btn md-whiteframe-3dp fas fa-arrow-right sectionClose\"></i></div> </div> </div> <div class=\"\"> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:item.expanded}\"> <div ng-if=\"item.type !== 'FIB' && item.type !== 'IBT_FIB' && item.type !== 'MTF' && item.type !== 'DRAW'\"> <span class=question_desc ng-show=item.isLatex>{{item.qn_desc}}</span> <span ng-show=!item.isLatex>{{item.qn_desc}}</span> </div> <div ng-if=\"item.type === 'FIB' || item.type === 'IBT_FIB' || item.type === 'MTF'\"> <span>{{item.qn_desc}}</span> </div> <div ng-if=\"item.type =='MCQ' || item.type =='IBT_MCQ'\" ng-repeat=\"choice in item.choice\" layout=row> <p flex=10>({{choice.tag}})</p> &nbsp; <p flex=80 ng-show=!item.isLatex>{{choice.desc}}</p> <p flex=80 ng-show=item.isLatex class=choice-desc>{{choice.desc}}</p> </div> <div ng-if=\"item.type == 'MTF'\"> <div> <div layout=row ng-repeat=\"choice in item.option\"> <span class=caption flex=10>({{choice.question.tag}})</span> <span class=mtf-question ng-show=!item.isLatex flex=40>{{choice.question.desc}}</span> <span class=\"mtf-question choice-desc\" ng-show=item.isLatex flex=40>{{choice.question.desc}}</span> <span class=\"mtf-answer choice-desc\" ng-show=item.isLatex flex=40>{{choice.answer.desc}}</span> <span class=mtf-answer ng-show=!item.isLatex flex=40>{{choice.answer.desc}}</span> </div> </div> </div> <div ng-if=\"item.type == 'DRAW'\"> <div flex style=margin:10px layout-align=\"layout-row start center\"> <div ng-repeat=\"img in item.questionImg\"> <img style=width:100px;height:200px flex src={{fileUrl+img}}></div> </div> </div> <div ng-if=\"item.type==='ASLLISTEN'\"> <p ng-repeat=\"choice in item.questions\">({{$index+1}}) {{choice.qn_desc}}</p> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=md-whiteframe-2dp flex> <div class=\"questionsHead min-height-52p\"> <h4 class=left_pad_10> Added Questions </h4> </div> <div layout=row> <div class=inputDuration layout=row ng-show=!isPractice> <label class=\"pad_top_10 mar-right-10\" style=position:relative;top:18px;margin-right:4px>Time</label> <md-input-container class=hour> <label>Hour</label> <md-select ng-model=hour> <md-option ng-repeat=\"hour in hours\" value={{hour}}>{{hour}}</md-option> </md-select> </md-input-container> <md-input-container class=min> <label>Minute</label> <md-select ng-model=min> <md-option flex ng-repeat=\"min in minutes\" value={{min}}>{{min}}</md-option> </md-select> </md-input-container> <p class=errorMessage>{{errors['hour']}}</p> </div> </div> <p class=\"errorMessage space-msg\">{{errors['time']}}</p> <div layout=column class=sectionFormat> <md-input-container flex class=\"inputSection md-margin\"> <label>Enter Section Name</label> <input type=text ng-model=sectionName maxlength=100 md-maxlength=100 /> <p class=errorMessage>{{errors['sectionName']}}</p> </md-input-container> <md-input-container flex class=md-margin> <label>Enter instruction</label> <input type=text ng-model=sectionInstruction maxlength=200 md-maxlength=200 /> <p class=errorMessage>{{errors['sectionInstruction']}}</p> </md-input-container> <div class=md-margin> <md-checkbox class=\"marginTop15 checkPractice\" ng-model=checkStatus ng-change=changeStatus(checkStatus)>Individual Mark </md-checkbox> </div> <div layout=row class=md-margin> <div class=mark-space ng-show=!isIndividualMark> Marks to each question <input class=quesMark maxlength=4 decimal-numbers-only type=text ng-model=markForEach ng-change=validateMark() /> <p class=errorMessage>{{errors['markForEach']}}</p> </div> <div> <div layout=row> Set Policy <input class=policy ng-change=onSetPolicy() type=text numbers-only ng-model=attendQues ng-disabled=isIndividualMark />&nbsp; <p class=slash>/</p> &nbsp; <input class=policy ng-model=allQues numbers-only type=text ng-disabled=true /> </div> <p class=errorMessage>{{errors['attendQues']}}</p> </div> </div> <md-divider></md-divider> <div class=questionsContent> <div class=md-accordion ng-repeat=\"sectionData in sectionFormat\"> <div ng-init=\"sectionData.expanded = false\" layout-align=\"space-between center\" layout=row class=sectionAccordianHead> <div layout=row ng-click=toggleExpansion(sectionFormat,sectionData,$index) flex=80> <div> <i class=\"fas fa-angle-down\" ng-if=\"sectionData.expanded==false\"></i> <i class=\"fas fa-angle-up\" ng-if=\"sectionData.expanded==true\"></i> </div> <div ng-if=\"sectionData.type !== 'FIB' && sectionData.type !== 'IBT_FIB' && sectionData.type !== 'MTF'&& sectionData.type !== 'DRAW'\"> <span class=question_desc ng-show=sectionData.isLatex>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=!sectionData.isLatex>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=\"sectionData.qn_desc.length>50\">...</span> </div> <div ng-if=\"sectionData.type === 'FIB' || sectionData.type === 'IBT_FIB' || sectionData.type === 'MTF' || sectionData.type === 'DRAW'\"> <span>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=\"sectionData.qn_desc.length>50\">...</span> </div> </div> <div layout-align=\"start end\" flex=10 ng-show=isIndividualMark> <input class=policy maxlength=4 type=text decimal-numbers-only ng-model=sectionData.qn_mark ng-class=\"{'mark-error' : sectionData.qn_mark_error}\" ng-change=addQnMark(sectionData) /> </div> <div layout-align=\"start end\" ng-click=moveFromSection(sectionData,$index) flex=10> <i class=\"fas fa-times sectionClose\"></i></div> </div> <div class=accordianContent> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:sectionData.expanded}\"> <div ng-if=\"sectionData.type !== 'FIB' && sectionData.type !== 'IBT_FIB' && sectionData.type !== 'MTF'&& sectionData.type !== 'DRAW'\"> <span class=question_desc ng-show=sectionData.isLatex>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=!sectionData.isLatex>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=\"sectionData.qn_desc.length>50\">...</span> </div> <div ng-if=\"sectionData.type === 'FIB' || sectionData.type === 'IBT_FIB' || sectionData.type === 'MTF' || sectionData.type === 'DRAW'\"> <span>{{sectionData.qn_desc|limitTo:50}}</span> <span ng-show=\"sectionData.qn_desc.length>50\">...</span> </div> <div ng-if=\"sectionData.type =='MCQ' || sectionData.type =='IBT_MCQ'\" ng-repeat=\"choice in sectionData.choice\" layout=row> <p flex=10>({{choice.tag}})</p> &nbsp; <p flex=80 ng-show=!sectionData.isLatex>{{choice.desc}}</p> <p flex=80 ng-show=sectionData.isLatex class=choice-desc>{{choice.desc}}</p> </div> <div ng-if=\"sectionData.type == 'MTF'\"> <div> <div layout=row ng-repeat=\"choice in sectionData.option\"> <span class=caption flex=10>({{choice.question.tag}})</span> <span class=mtf-question ng-show=!sectionData.isLatex flex=40>{{choice.question.desc}}</span> <span class=\"mtf-question choice-desc\" ng-show=sectionData.isLatex flex=40>{{choice.question.desc}}</span> <span class=mtf-answer ng-show=!sectionData.isLatex flex=40>{{choice.answer.desc}}</span> <span class=\"mtf-answer choice-desc\" ng-show=sectionData.isLatex flex=40>{{choice.answer.desc}}</span> </div> </div> </div> <div ng-if=\"sectionData.type == 'DRAW'\"> <div flex style=margin:10px layout-align=\"start center\"> <img style=width:200px;height:200px flex src={{sectionData.qn_img}}></div> </div> <div ng-if=\"sectionData.type==='ASLLISTEN'\"> <p ng-repeat=\"choice in sectionData.questions\">({{$index+1}}) {{choice.qn_desc}}</p> </div> </div> </div> </div> </div> <div layout=row class=bottom-completion> <div flex=5 class=\"sectionDone mar_top_15 md-whiteframe-2dp\" ng-click=createSection() tooltip=Done tooltip-position=down><i class=\"fas fa-check icon-img\"></i></div> <div flex=5 class=\"section-reload mar_top_15 md-whiteframe-2dp\" ng-click=closeSection() tooltip=cancel tooltip-position=down><i class=\"fas fa-times icon-img\"></i></div> <p class=errorMessage>{{errors['selectQuestion']}}</p> </div> </div> <div class=questionsContent as-sortable=dragControlListeners ng-model=sectionWiseQuestions> <div class=\"md-accordion eachQues\" ng-repeat=\"questionData in sectionWiseQuestions\" as-sortable-item> <div ng-init=\"questionData.expanded = false\" layout-align=\"space-between center\" class=accordianHeading style=background-color:#00ba9c layout=row> <div layout=row> <span class=sectionFont>{{questionData.name}}</span> <div class=quesNo>{{questionData.questions.length}}</div> </div> <div class=plusMinus layout=row> <i class=\"fas fa-pen\" ng-click=moveFromCreatedSection(questionData,$index)></i> <i class=\"fas fa-angle-down icons-margin\" ng-if=\"questionData.expanded==false\" ng-click=toggleExpansion(sectionWiseQuestions,questionData,$index)></i> <i class=\"fas fa-angle-up icons-margin\" ng-if=\"questionData.expanded==true\" ng-click=toggleExpansion(sectionWiseQuestions,questionData,$index) style=padding-right:5px></i> <i class=\"fas fa-bars icons-drag\" as-sortable-item-handle></i> </div> </div> <div class=accordianContent> <div class=\"md-whiterame-2dp questAccordian\" ng-class=\"{dataContent:true, activeContent:questionData.expanded}\"> <div ng-repeat=\"eachQues in questionData.questions\" layout=column flex=100> <div ng-init=\"eachQues.expanded = false\" layout-align=\"start start\" class=accordianHeading layout=row> <div layout=row flex=85 ng-click=toggleExpansion(questionData.questions,eachQues,$index)> <div class=\"arrowIcon questIcon\" flex=5> <i class=\"fas fa-angle-down\" ng-if=\"eachQues.expanded==false\"></i> <i class=\"fas fa-angle-up\" ng-if=\"eachQues.expanded==true\"></i> </div> <div layout=row> <span class=questHead ng-if=\"eachQues.type !== 'FIB' && eachQues.type !== 'IBT_FIB' && eachQues.type !== 'MTF'&& eachQues.type !== 'DRAW'\"> <span class=questNo>{{$index+1}}.</span> <span class=question_desc ng-show=eachQues.isLatex>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=!eachQues.isLatex>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=\"eachQues.qn_desc.length>50\">...</span> </span> <span class=questHead ng-if=\"eachQues.type === 'FIB' || eachQues.type === 'IBT_FIB' || eachQues.type === 'MTF'|| eachQues.type === 'DRAW'\"> <span class=questNo>{{$index+1}}.</span> <span>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=\"eachQues.qn_desc.length>50\">...</span> </span> </div> </div> <div layout-align=\"start end\" flex=10 ng-if=eachQues.qn_mark> <input class=qn-mark type=text ng-model=eachQues.qn_mark ng-disabled=true /> </div> <div flex=10 class=moveIcon ng-click=editQuestion(eachQues)> <i class=\"fas fa-pen\"></i></div> </div> <div class=accordianContent> <div ng-class=\"{dataContent:true, activeContent:eachQues.expanded}\"> <div ng-if=\"eachQues.type !== 'FIB' && eachQues.type !== 'IBT_FIB' && eachQues.type !== 'MTF'&& eachQues.type !== 'DRAW'\"> <span class=question_desc ng-show=eachQues.isLatex>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=!eachQues.isLatex>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=\"eachQues.qn_desc.length>50\">...</span> </div> <div ng-if=\"eachQues.type === 'FIB' || eachQues.type === 'IBT_FIB' || eachQues.type === 'MTF' || eachQues.type === 'DRAW'\"> <span>{{eachQues.qn_desc|limitTo:50}}</span> <span ng-show=\"eachQues.qn_desc.length>50\">...</span> </div> <div ng-if=\"eachQues.type =='MCQ' || eachQues.type =='IBT_MCQ'\"> <div ng-repeat=\"choice in eachQues.choice\" layout=row> <p flex=10>({{choice.tag}})</p> &nbsp; <p flex=80 class=choice-desc>{{choice.desc}}</p> </div> </div> <div ng-if=\"eachQues.type == 'MTF'\"> <div> <div layout=row ng-repeat=\"choice in eachQues.optionQuestion\"> <span class=caption flex=10>({{choice.tag}})</span> <span class=mtf-question ng-show=!eachQues.isLatex flex=40>{{choice.question.desc}}</span> <span class=\"mtf-question choice-desc\" ng-show=eachQues.isLatex flex=40>{{choice.question.desc}}</span> <span class=mtf-answer ng-show=!eachQues.isLatex flex=40>{{choice.answer.desc}}</span> <span class=\"mtf-answer choice-desc\" ng-show=eachQues.isLatex flex=40>{{choice.answer.desc}}</span> </div> </div> </div> <div ng-if=\"eachQues.type == 'DRAW'\"> <div flex style=margin:10px layout-align=\"start center\"> <img style=width:200px;height:200px flex src={{eachQues.qn_img}}></div> </div> <div ng-if=\"eachQues.type==='ASLLISTEN'\"> <p ng-repeat=\"choice in eachQues.questions\">({{$index+1}}) {{choice.qn_desc}}</p> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div layout=row> <div flex=80 layout=row> <md-button md-no-ink class=\"auto-btn addToQues md-ink-ripple\" layout=row ng-click=routeToCreateQuestion()>Create Question <span class=plusSymbol><i class=\"fas fa-plus\"></i></span> </md-button> <md-button md-no-ink class=\"auto-btn addToQues md-ink-ripple\" layout=row ng-click=goToArchive()>Select Question <span class=plusSymbol><i class=\"fas fa-plus\"></i></span> </md-button> </div> <div flex=20 layout=row layout-align=\"end start\"> <md-button md-no-ink class=\"auto-btn addToQues md-ink-ripple\" ng-show=\"sectionWiseQuestions.length>0\" style=margin-right:110px ng-click=preview()>Preview <span class=plusSymbol><img style=position:relative;top:4px src=" + __webpack_require__(644) + " width=20></span> </md-button> </div> </div> ";

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: formatQuestion.js
 * Project: educore
 * Created Date: 2018-01-18
 * Author: Raziya S
 * Screen : 
 */
var FormatQpController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "archiveService", "$timeout", "CONSTANTS", "TPWIZARDCONSTANT", function FormatQpController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout, CONSTANTS, TPWIZARDCONSTANT) {
    _classCallCheck(this, FormatQpController);

    this.writeNote = false;
    this.scope = $scope;
    this.state = $state;

    var academics = localStorageService.get('authoringData');
    var userId = localStorageService.get('user_id');
    if (academics === undefined) $state.go('dashboard');
    var activityId = $state.params.resourceId;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Activity";

        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        $scope.loadData();
    };
    self = this;
    $scope.sectionName = "";
    $scope.sectionName = "";
    $scope.sectionInstruction = "";
    $scope.markForEach = 0;
    $scope.attendQues = 0;
    $scope.allQues = 0;
    $scope.time = [];
    $scope.sectionInstruction = "";
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    $scope.formatQuestion = [];
    //$scope.tempData = $location.protocol() + "://" + $location.host() + ":4000"

    //   $scope.qpTitle = ""
    $scope.sectionQuestions = [];
    $scope.sectionWiseQuestions = [];

    $scope.hours = [];
    for (var hour = 0; hour <= 12; hour++) {
        hour = hour > 9 ? hour : "0" + hour;
        $scope.hours.push(hour);
    }

    $scope.minutes = [];
    for (var min = 0; min < 60; min++) {
        min = min > 9 ? min : "0" + min;
        $scope.minutes.push(min);
    }

    var MQ = MathQuill.getInterface(2);
    var redirectDetails = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();

    if (redirectDetails && redirectDetails.returnData) {
        if (redirectDetails.activeTab == "question") {
            var questions = [];
            _.each(redirectDetails.returnData, function (questionArchive) {
                questions.push(questionArchive.resource._id);
            });
            academics['ques_ids'] = questions;
            academics['activity_id'] = activityId;
            authService.callAPI(TPWIZARDCONSTANT.API_SELECT_QUESTION, "POST", academics, function (response) {
                if (response.result && response.result && response.result.data) {
                    $scope.loadData();
                }
            });
        }
    }
    var qpDet = {
        "activity_id": activityId,
        "teacher_id": userId,
        "school_id": academics.school_id
    };
    $scope.questionType = activityCons.QUESTION_TYPE_DETAILS;
    $scope.loadData = function () {
        authService.callAPI(TPWIZARDCONSTANT.API_GET_FORMAT_QP, "POST", qpDet, function (response) {
            if (response.result && response.result.status && response.result.data.data) {
                var result = response.result.data.data[0];
                $scope.sectionFormat = [];
                $scope.practice_qn = result.basic_details[0].practice_qn;
                $scope.qpId = result.basic_details[0]._id;
                $scope.planId = result.basic_details[0].teaching_plan_id;
                if (result.temp_sections && result.temp_sections.length > 0) $scope.formatQuestion.allQuestions = result.temp_sections;
                if (result.sections && result.sections.length > 0) $scope.sectionWiseQuestions = result.sections;
                _.each($scope.formatQuestion.allQuestions, function (data, index) {
                    data.color = getColor(index);
                });
                if (result.basic_details[0].time) {
                    $scope.hour = result.basic_details[0].time.hour;
                    $scope.min = result.basic_details[0].time.min;
                } /*
                  academics['theme_id']  = result.basic_details[0].theme_id
                  academics['user_id']  = userId
                  academics['id']  = result.basic_details[0]._id
                  academics['qp_title']  = result.basic_details[0].question_paper_title*/
                localStorageService.set('theme_id', result.basic_details[0].theme_id);
                $scope.$apply();

                $scope.goToArchive = function () {

                    var searchFilters = [];
                    var authoring = academics;
                    searchFilters.push({
                        type: 'curriculum',
                        value: {
                            _id: authoring.curriculum_id,
                            name: authoring.curriculum
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: 'class',
                        value: {
                            _id: authoring.class_id,
                            name: authoring.class
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: 'subject',
                        value: {
                            _id: authoring.subject_id,
                            name: authoring.subject
                        },
                        deletable: false,
                        visible: false
                    });
                    searchFilters.push({
                        type: "tab",
                        value: {
                            _id: "question",
                            name: "Questions"
                        },
                        deletable: false,
                        visible: false
                    });
                    var details = {
                        searchFilters: searchFilters,
                        previousState: {
                            state: 'formatQp',
                            params: $state.params
                        },
                        isMultiSelect: true,
                        isPractice: $scope.practice_qn,
                        activeTab: "question",
                        resourceType: {
                            _id: "question",
                            name: "Questions"
                        }
                    };
                    archiveService.setRedirectJson(details);
                    localStorageService.set('academicDetails', academics);
                    $state.go("archives");
                };
            }
        });
    };

    //})

    /*
     * Function to delete question from qp
     * 
     * @question : Object - Details of question
     * 
     * @return : Null
     *
     */
    $scope.deleteQuestion = function (questionId, sectionId) {

        var confirm = $mdDialog.confirm().textContent('Do you want to delete this question?').ok('Yes').cancel('No');
        $mdDialog.show(confirm).then(function () {

            var obj = {
                qp_id: $scope.qpId,
                question_id: questionId,
                section_id: sectionId
            };
            authService.callAPI(TPWIZARDCONSTANT.API_DELETE_QUESTION, "POST", obj, function (response) {
                if (response.result) {
                    //Number - Count of section without questions
                    var secEmptyCount = 0;

                    _.each($scope.formatQuestion.allQuestions, function (section, index) {

                        //Number - index of question which need to be removed
                        var quesIndex = section.questions.findIndex(function (i) {
                            return i._id === questionId;
                        });
                        if (quesIndex !== -1) {
                            section.questions.splice(quesIndex, 1);
                        }
                        if (section.questions.length === 0) {
                            secEmptyCount++;
                        }
                    });
                    toastr.success("Question deleted Successfully");
                    //  if no questions, redirect to create page by varun 8-8-2018
                    if (secEmptyCount === $scope.formatQuestion.allQuestions.length) {
                        $state.go("activityForm", {
                            resourceId: activityId
                        });
                    }
                    $scope.$apply();
                } else {
                    console.log("error : " + response.error);
                    console.log(response.error);
                }
            });
        }, function () {});
    };

    /*
     * Function to edit question from qp
     * 
     * @question : Object - Details of question
     * 
     * @return : Null
     *
     */
    $scope.editQuestion = function (question) {
        localStorageService.set("createQuesiton", {
            state: "tpActivity",
            qp_id: $scope.qpId,
            question_id: question._id,
            activity_id: activityId,
            theme_id: question.theme_id,
            class_id: academics.class_id,
            curriculum_id: academics.curriculum_id,
            subject_id: academics.subject_id,
            batch_id: academics.batch_id,
            session_id: academics.session_id,
            school_id: academics.school_id,
            practice_qn: $scope.practice_qn,
            academic_year: localStorageService.get("activeAcdYear"),
            isQuestionAvailable: true,
            teaching_plan_id: $scope.planId
        });
        $state.go("createTpQuestion");
    };
    /*
     * Function to auto format qp
     * 
     * @return : Null
     *
     */
    $scope.autoformat = function () {
        //String - Name of the theme
        var obj = {
            activity_id: activityId,
            user_id: userId,
            temp_sections: angular.copy($scope.formatQuestion.allQuestions)
        };
        authService.callAPI(TPWIZARDCONSTANT.API_AUTO_FORMAT, "POST", obj, function (response) {
            if (response.result) {
                $state.go('tpActivityPreview', {
                    qpId: $scope.qpId
                });
            } else {
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
    };

    $scope.onSetPolicy = function () {
        if ($scope.attendQues > $scope.allQues) $scope.attendQues = $scope.allQues;
    };
    $scope.changeStatus = function (status) {
        if (status) {
            $scope.isIndividualMark = true;
            $scope.allQues = $scope.sectionFormat.length;
            $scope.attendQues = $scope.allQues;
            //Fixed bug #6220
            //Developer- Raziya
            if ($scope.sectionFormat) {
                _.each($scope.sectionFormat, function (eachQues) {
                    if (isNaN(eachQues.qn_mark)) eachQues.qn_mark = undefined;
                });
            }
        } else {
            $scope.isIndividualMark = false;
        }
    };

    $scope.moveQuestion = function (eachQues, index) {
        var questData = [];
        _.each($scope.formatQuestion.allQuestions, function (sections) {
            if (sections.name == eachQues.type) {
                if (index > -1) {
                    sections.questions.splice(index, 1);
                    $scope.sectionFormat.push(eachQues);
                    $timeout(function () {
                        $scope.formatToLatex();
                    });
                }
            }
        });
        $scope.allQues = $scope.sectionFormat.length;
        $scope.attendQues = $scope.allQues;
    };

    $scope.moveFromSection = function (eachQues, index) {
        var questData = $scope.sectionFormat[index];
        var isTypeExists = false;
        if (!$scope.formatQuestion.allQuestions) $scope.formatQuestion.allQuestions = [];
        if ($scope.formatQuestion.allQuestions.length > 0) {
            _.each($scope.formatQuestion.allQuestions, function (sections) {
                if (sections.name == eachQues.type) {
                    sections.questions.push(questData);
                    isTypeExists = true;
                }
            });
        }
        if (!isTypeExists) {
            var secIndex = $scope.formatQuestion.allQuestions.length;
            var newSection = {
                name: eachQues.type,
                questions: [questData],
                color: getColor(secIndex)
            };
            $scope.formatQuestion.allQuestions.push(newSection);
        }
        if (index > -1) {
            $scope.sectionFormat.splice(index, 1);
        }
        $timeout(function () {
            $scope.formatToLatex();
        });
        $scope.allQues = $scope.sectionFormat.length; // to get total question in each section
        $scope.attendQues = $scope.allQues;
        var total = 0;
        if ($scope.allQues === 0) {
            $scope.markForEach = 0;
            $scope.sectionName = "";
            $scope.sectionInstruction = "";
        }
        var obj = {
            activity_id: activityId,
            is_practice: $scope.practice_qn,
            user_id: userId,
            time: {
                hour: $scope.hour,
                min: $scope.min
            },
            total_mark: total,
            //total_questions: totalQuestions,
            sections: angular.copy($scope.sectionWiseQuestions),
            temp_sections: angular.copy($scope.formatQuestion.allQuestions)
            // authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, (response) => {
            //     if (response.result && response.result) {
            //     }
            // })

        };
    };

    $scope.moveFromCreatedSection = function (eachQues, index) {
        if ($scope.sectionFormat && $scope.sectionFormat.length > 0) toastr.error("You have already selected one section");else {
            $scope.sectionData = angular.copy($scope.sectionWiseQuestions);
            $scope.sectionFormat = eachQues.questions;
            $scope.sectionName = eachQues.name;
            $scope.sectionInstruction = eachQues.instruction;
            $scope.attendQues = eachQues.mandatory_no;
            $scope.allQues = eachQues.questions.length;
            $scope.markForEach = eachQues.mark_each_qn;
            if (eachQues.mark_each_qn > 0) $scope.checkStatus = false;else $scope.checkStatus = true;
            $scope.changeStatus($scope.checkStatus);
            $scope.sectionWiseQuestions.splice(index, 1);
            $timeout(function () {
                $scope.formatToLatex();
            });
        }
    };
    //To cancel editing section 
    $scope.closeSection = function () {
        if ($scope.sectionData.length > 0 && $scope.sectionFormat.length > 0) $scope.sectionWiseQuestions = $scope.sectionData;
        $scope.errors = {};
        $scope.sectionName = "";
        $scope.sectionInstruction = "";
        $scope.markForEach = 0;
        $scope.attendQues = 0;
        $scope.allQues = 0;
        $scope.checkStatus = false;
        $scope.changeStatus($scope.checkStatus);
        $scope.sectionFormat = [];
    };
    $scope.createSection = function () {
        $scope.errors = {};
        var error = false;
        if ($scope.sectionName === undefined || $scope.sectionName === "") {
            $scope.errors['sectionName'] = "section name is required";
            error = true;
        }
        if ($scope.sectionInstruction === undefined || $scope.sectionInstruction === "") {
            $scope.errors['sectionInstruction'] = "instruction is required";
            error = true;
        }
        if ($scope.sectionFormat.length === 0) {
            $scope.errors['selectQuestion'] = "Please select atleast one question";
            error = true;
        }
        if (!$scope.isIndividualMark) {
            if ($scope.markForEach === undefined || $scope.markForEach === "") {
                $scope.errors['markForEach'] = "Enter mark for each question";
                error = true;
            }
            if ($scope.markForEach == 0) {
                $scope.errors['markForEach'] = "Mark should be greater than 0";
                error = true;
            }
            //To save mark to each question
            if ($scope.markForEach > 0) {
                _.each($scope.sectionFormat, function (eachQues) {
                    eachQues.qn_mark = $scope.markForEach;
                });
            }
        }

        if ($scope.isIndividualMark) {
            //Bug  #6132 -start
            $scope.markForEach = 0;
            //Bug  #6132 -end

            _.each($scope.sectionFormat, function (eachQues) {
                if (eachQues.qn_mark) {
                    if (eachQues.qn_mark == 0) {
                        eachQues['qn_mark_error'] = true;
                        toastr.error("Mark should be greater than 0");
                        error = true;
                    } else eachQues['qn_mark_error'] = false;
                }
                if (!eachQues.qn_mark || eachQues.qn_mark === null || eachQues.qn_mark === undefined || eachQues.qn_mark === "") {
                    eachQues['qn_mark_error'] = true;
                    toastr.error("Please enter mark for all questions");
                    error = true;
                } else eachQues['qn_mark_error'] = false;
            });
        }
        $scope.sectionFormat['is_individual_mark'] = $scope.checkStatus;
        if ($scope.attendQues === undefined || $scope.attendQues === "") {
            $scope.errors['attendQues'] = "Enter policy";
            error = true;
        }
        if ($scope.attendQues === 0) {
            $scope.errors['markForEach'] = "Please add atleast one question";
            error = true;
        }
        _.each($scope.sectionWiseQuestions, function (section) {
            if (section.name === $scope.sectionName) {
                $scope.errors['sectionName'] = "Section name already exsits";
                error = true;
            }
        });
        if (!error) {
            $scope.sectionWiseQuestions.push({
                'name': $scope.sectionName,
                'instruction': $scope.sectionInstruction,
                'mark_each_qn': $scope.markForEach,
                'mandatory_no': $scope.attendQues,
                'qn_no': $scope.allQues,
                'questions': $scope.sectionFormat
            });
            var obj = {
                activity_id: activityId,
                is_practice: $scope.practice_qn,
                user_id: userId,
                time: {
                    hour: $scope.hour,
                    min: $scope.min
                },
                sections: angular.copy($scope.sectionWiseQuestions),
                temp_sections: angular.copy($scope.formatQuestion.allQuestions)
            };
            authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, function (response) {
                if (response.result && response.result) {}
            });
            $scope.sectionFormat = [];
            $scope.sectionName = "";
            $scope.sectionInstruction = "";
            $scope.markForEach = 0;
            $scope.attendQues = 0;
            $scope.allQues = 0;
            $scope.checkStatus = false;
            $scope.changeStatus($scope.checkStatus);
        }
    };

    var calIndex = function calIndex(index, length) {
        if (index >= length) {
            if (index - length >= length) return calIndex(index - length, length);else return index - length;
        } else return index;
    };

    var getColor = function getColor(index) {
        var colorArr = ['#2ab4c0', '#1bbc9b', '#f3c200', '#e7505a'];
        var i = calIndex(index, colorArr.length);
        return colorArr[i];
    };
    _.each($scope.formatQuestion.allQuestions, function (data, index) {
        data.color = getColor(index);
    });
    // $scope.formatQuestion.addedQuestions = [];
    $scope.toggleExpansion = function (accordianData, data, index) {
        _.each(accordianData, function (data, dataIndex) {
            if (dataIndex != index) data.expanded = false;else data.expanded = !data.expanded;
        });
        $scope.formatToLatex();
    };

    $scope.formatToLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('question_desc');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
            var choiceElements = document.getElementsByClassName('choice-desc');
            _.each(choiceElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    $scope.preview = function () {
        var obj = {
            activity_id: activityId,
            user_id: userId,
            is_practice: $scope.practice_qn,
            time: {
                hour: $scope.hour,
                min: $scope.min
            },
            sections: angular.copy($scope.sectionWiseQuestions) ? angular.copy($scope.sectionWiseQuestions) : [],
            temp_sections: $scope.formatQuestion.allQuestions ? angular.copy($scope.formatQuestion.allQuestions) : []
        };
        $scope.errors = {};
        var error = false;
        if ($scope.hour === undefined || $scope.hour === "" || $scope.min === undefined || $scope.min === "") {
            if (!$scope.practice_qn) {
                $scope.errors['time'] = "Time is required";
                error = true;
            }
        }
        if ($scope.sectionFormat && $scope.sectionFormat.length > 0) {
            toastr.warning("Please save the changes.");
            error = true;
        }
        if (!error) {
            authService.callAPI(TPWIZARDCONSTANT.API_SAVE_SECTION, "POST", obj, function (response) {
                if (response.result && response.result) {
                    $state.go('tpActivityPreview', {
                        qpId: $scope.qpId
                    });
                }
            });
        }
    };
    $scope.routeToCreateQuestion = function () {
        localStorageService.set('academicDetails', academics);
        localStorageService.set("createQuesiton", {
            state: "tpActivity",
            qp_id: $scope.qpId,
            activity_id: activityId,
            theme_id: localStorageService.get('theme_id'),
            class_id: academics.class_id,
            curriculum_id: academics.curriculum_id,
            subject_id: academics.subject_id,
            batch_id: academics.batch_id,
            session_id: academics.session_id,
            school_id: academics.school_id,
            practice_qn: $scope.practice_qn,
            academic_year: localStorageService.get("activeAcdYear"),
            isQuestionAvailable: true,
            teaching_plan_id: $scope.planId
        });
        $state.go("createTpQuestion");
    };
    $scope.validateMark = function () {
        if ($scope.markForEach && $scope.markForEach > 100) $scope.markForEach = 0;
    };
    $scope.addQnMark = function (eachQues) {
        if (eachQues.qn_mark > 0) eachQues['qn_mark_error'] = false;
    };

    //Added for dragging sections
    //developer - Raziya
    $scope.sortableOptions = {
        containment: '#sortable-container'
    };
    $scope.dragControlListeners = {
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        },
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {},
        containment: '#board', //optional param.
        containerPositioning: 'relative',
        clone: false, //optional param for clone feature.
        allowDuplicates: false //optional param allows duplicates to be dropped.
    };
}];

exports.default = FormatQpController;

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.uploadAnime.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex=10> <md-menu> <div class=res-save-icon tooltip=upload tooltip-position=right ng-click=\"openMenuAll($mdOpenMenu, $event)\" ng-show=userPrev.uploadAnime.create> <img src=" + __webpack_require__(83) + "> </div> <md-menu-content> <md-menu-item ng-show=userPrev.selectArchive.create> <md-button ng-disabled=isLoading ng-click=selectFromArchive()> Archive </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=isLoading ngf-select ng-model=myFiles ngf-change=uploadFile($file)> External </md-button> </md-menu-item> </md-menu-content> </md-menu> </md-input-container> <md-input-container flex=60> <span ng-if=\"file.name || isArchive&& archive.title\">File Name: </span> <span ng-if=!isArchive>{{file.name}}</span> <span ng-if=isArchive>{{archive.title}}</span> </md-input-container> </div> </div> <div class=loading-progress> <md-progress-linear ng-show=isLoading md-mode=determinate value={{progressPercentage}}></md-progress-linear> <span flex ng-show=isLoading>Please wait... Loading {{progressPercentage}} %</span> </div> <md-divider class=video-res-divider ng-show=isSupportedFormat></md-divider> <md-input-container layout=row layout-align=\"end center\" flex ng-show=isSupportedFormat> <div class=res-save-icon ng-click=upload(file) ng-hide=isSaveDisable> <i class=\"fas fa-save\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: FlashController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var FlashController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "archiveService", "TPWIZARDCONSTANT", "CONSTANTS", "Upload", function FlashController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, archiveService, TPWIZARDCONSTANT, CONSTANTS, Upload) {
    _classCallCheck(this, FlashController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_FLASH;
    var isEdit = false;
    var isNewFileUploaded = false;
    $scope.file = {};
    var returnedJson = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();
    if (returnedJson) {
        if (resourceId == returnedJson.resource) {
            if (returnedJson.returnData) {
                $scope.isArchive = true;
                $scope.archive = returnedJson.returnData;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
        }
    }

    $scope.selectFromArchive = function () {
        var searchFilters = [];
        searchFilters.push({
            type: "tab",
            value: {
                _id: "resources",
                name: "Resources"
            },
            deletable: false,
            visible: true
        });
        searchFilters.push({
            type: "theme",
            value: {
                _id: plan.theme_id,
                name: plan.theme_title
            },
            deletable: true,
            visible: true
        });
        searchFilters.push({
            type: "resource_type",
            value: {
                _id: "flash",
                name: "Interactive Anime"
            },
            deletable: false,
            visible: true
        });
        var details = {
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            planId: planId,
            resource: resourceId,
            isMultiSelect: false,
            activeTab: "resources",
            resourceType: {
                _id: "flash",
                name: "Interactive Anime"
            }
        };
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    $scope.openMenuAll = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    /*
     * Function to validate file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.uploadFile = function (file) {
        isNewFileUploaded = true;
        var fileSize = file.size / 1048576;
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'swf') {
                $scope.isSupportedFormat = true;
                if (fileSize > 8.00) {
                    toastr.error("Please upload flash file size less than 15 mb");
                    return false;
                } else {
                    $scope.file = file;
                }
            } else {
                $scope.isSupportedFormat = false;
                toastr.error("Please select supported .swf format");
            }
        }
    };

    /*
     * Function to upload a file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.upload = function (file) {
        if ($scope.isArchive) {
            save($scope.archive.resource.url);
        } else {
            $scope.isSaveDisable = true;
            $scope.isLoading = true;
            if (isEdit && !isNewFileUploaded) {
                save($scope.url);
                $scope.isLoading = false;
                $scope.isSaveDisable = false;
            }
            if (isNewFileUploaded) {
                Upload.upload({
                    url: CONSTANTS.SERVER_UPLOAD,
                    data: {
                        file: file,
                        'userPath': userId + "/flash/"
                    }
                }).then(function (resp) {
                    save(resp.data);
                }, function (resp) {}, function (evt) {
                    $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if ($scope.progressPercentage === 100) {
                        $scope.isLoading = false;
                    }
                });
            }
        }
    };

    /*
     * Function to save a file
     * @url : String of file to save
     * @return : null
     * @Developer: Arul Mozhi J
     */
    var save = function save(url) {
        var params = {
            tp_id: planId,
            _id: resourceId,
            title: $scope.resource.title,
            url: url,
            status: $scope.resource.status,
            user_id: userId
        };
        authService.callAPI(save_url, "POST", params, function (resultObj) {
            var result = resultObj.result.data;
            if (result) {
                localStorageService.set("currentPlan", result);
                $scope.isSaveDisable = false;
                toastr.success("Animation added successfully");
                $rootScope.setStatus(resourceId, 'created');
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                toastr.error("Network Error");
            }
        });
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            if ($scope.resource.url) {
                $scope.file['name'] = $scope.resource.url.substring($scope.resource.url.lastIndexOf("/") + 1);
                isEdit = true;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "flash";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = FlashController;

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=\"userPrev.preview && userPrev.preview.read&&isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> </div> <div class=\"md-whiteframe-2dp playVideoFrame\" ng-show=isAvailable layout=row flex=100 layout-wrap layout-align=space-around> <label ng-if=!fileAvaliable flex=50 class=no-data-msg>File not available in the server. Contact admin.</label> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Animataion Available... To add animation go to Edit mode</label> </div> </div>";

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var FlashPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "localStorageService", "UserPrivilages", "filePreviewAvailable", "$compile", "authService", "TPWIZARDCONSTANT", function FlashPreviewController($scope, $state, $rootScope, $sce, localStorageService, UserPrivilages, filePreviewAvailable, $compile, authService, TPWIZARDCONSTANT) {
    _classCallCheck(this, FlashPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }
    /*
     * Function To check flash is enabled or not
     * @developer - Arul Mozhi J
     */
    var isFlashEnabled = function isFlashEnabled() {
        var hasFlash = false;
        try {
            var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
            if (fo) hasFlash = true;
        } catch (e) {
            if (navigator.mimeTypes["application/x-shockwave-flash"] != undefined) hasFlash = true;
        }
        return hasFlash;
    };
    var loadTemplate = function loadTemplate() {
        console.log(resourceId);
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadAnime == undefined || $scope.userPrev.uploadAnime && !$scope.userPrev.uploadAnime.create) && ($scope.userPrev.approveAnime == undefined || $scope.userPrev.approveAnime && !$scope.userPrev.approveAnime.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {
                    console.log(ex);
                }
            }

            if ($scope.resource) {
                $scope.isAvailable = true;
                if ($scope.resource.url) {
                    $scope.isAvailable = true;
                    console.log($scope.resource.url);
                    filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function (response) {
                        $scope.fileAvaliable = response.fileAvaliable;
                        if (response.fileAvaliable) {
                            $scope.src = $sce.trustAsResourceUrl(response.fileUrl);
                            $scope.flashTemp = isFlashEnabled();
                            var playHtml = ' <div style="padding: 20px; height: 100%"><object data="' + $scope.src + '" width="100%" class="preview-outline"></object></div>';
                            angular.element(document.querySelector('.playVideoFrame')).append($compile(playHtml)($scope));
                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    });
                }
            }
        }
    };
    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "flash";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = FlashPreviewController;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.uploadVideo.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex=10> <md-menu> <div class=res-save-icon tooltip=upload tooltip-position=right ng-click=\"openMenuAll($mdOpenMenu, $event)\" ng-show=userPrev.uploadVideo.create> <img src=" + __webpack_require__(83) + "> </div> <md-menu-content> <md-menu-item ng-show=userPrev.selectArchive.create> <md-button ng-disabled=isLoading ng-click=selectFromArchive()> Archive </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=isLoading ngf-select ng-model=myFiles ngf-change=uploadFile($file)> External </md-button> </md-menu-item> </md-menu-content> </md-menu> </md-input-container> <md-input-container flex=60> <span ng-if=\"file.name || isArchive&& archive.title\">File Name: </span> <span ng-if=!isArchive>{{file.name}}</span> <span ng-if=isArchive>{{archive.title}}</span> </md-input-container> </div> </div> <div class=loading-progress> <md-progress-linear ng-show=isLoading md-mode=determinate value={{progressPercentage}}></md-progress-linear> <span flex ng-show=isLoading>Please wait... Loading {{progressPercentage}} %</span> </div> <md-divider class=video-res-divider ng-show=isSupportedFormat></md-divider> <md-input-container layout=row layout-align=\"end center\" flex ng-show=isSupportedFormat> <div class=res-save-icon ng-click=upload(file) ng-hide=isSaveDisable> <i class=\"fas fa-save\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: videoController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var videoController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "archiveService", "TPWIZARDCONSTANT", "CONSTANTS", "Upload", function videoController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, archiveService, TPWIZARDCONSTANT, CONSTANTS, Upload) {
    _classCallCheck(this, videoController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_VIDEO;
    var isEdit = false;
    var isNewFileUploaded = false;
    $scope.file = {};
    var returnedJson = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();
    if (returnedJson) {
        if (resourceId == returnedJson.resource) {
            if (returnedJson.returnData) {
                $scope.isArchive = true;
                $scope.archive = returnedJson.returnData;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
        }
    }

    $scope.selectFromArchive = function () {
        var searchFilters = [];
        searchFilters.push({
            type: "tab",
            value: {
                _id: "resources",
                name: "Resources"
            },
            deletable: false,
            visible: true
        });
        searchFilters.push({
            type: "theme",
            value: {
                _id: plan.theme_id,
                name: plan.theme_title
            },
            deletable: true,
            visible: true
        });
        searchFilters.push({
            type: "resource_type",
            value: {
                _id: "video",
                name: "Video"
            },
            deletable: false,
            visible: true
        });
        var details = {
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            planId: planId,
            resource: resourceId,
            isMultiSelect: false,
            activeTab: "resources",
            resourceType: {
                _id: "video",
                name: "Video"
            }
        };
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    $scope.openMenuAll = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    /*
     * Function to validate file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.uploadFile = function (file) {
        isNewFileUploaded = true;
        var fileSize = file.size / 1048576;
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'mp4') {
                $scope.isSupportedFormat = true;
                if (fileSize > 15.00) {
                    toastr.error("Please upload video file size less than 15 mb");
                    return false;
                } else {
                    $scope.file = file;
                }
            } else {
                $scope.isSupportedFormat = false;
                toastr.error("Please select supported .mp4 format");
            }
        }
    };

    /*
     * Function to upload a file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.upload = function (file) {
        if ($scope.isArchive) {
            var url = {
                video_url: $scope.archive.resource.url,
                thumbnail_url: $scope.archive.resource.thumbnail_url
            };
            save(url);
        } else {
            $scope.isSaveDisable = true;
            $scope.isLoading = true;
            if (isEdit && !isNewFileUploaded) {
                save($scope.url);
                $scope.isLoading = false;
                $scope.isSaveDisable = false;
            }
            if (isNewFileUploaded) {
                Upload.upload({
                    url: CONSTANTS.SERVER_UPLOAD,
                    data: {
                        file: file,
                        'userPath': userId + "/video/"
                    }
                }).then(function (resp) {
                    console.log(CONSTANTS.SERVER_UPLOAD);
                    console.log(resp);
                    save(resp.data);
                }, function (resp) {
                    console.log(resp);
                    toastr.error("Error while uploading");
                }, function (evt) {
                    $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if ($scope.progressPercentage === 100) {
                        $scope.isLoading = false;
                    }
                });
            }
        }
    };

    /*
     * Function to save a file
     * @url : String of file to save
     * @return : null
     * @Developer: Arul Mozhi J
     */
    var save = function save(url) {
        var params = {
            tp_id: planId,
            _id: resourceId,
            title: $scope.resource.title,
            url: url,
            status: $scope.resource.status,
            user_id: userId
        };
        authService.callAPI(save_url, "POST", params, function (resultObj) {
            var result = resultObj.result.data;
            if (result) {
                localStorageService.set("currentPlan", result);
                $scope.isSaveDisable = false;
                toastr.success("Video added Successfully");
                $rootScope.setStatus(resourceId, 'created');
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                toastr.error("Network Error");
            }
        });
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            if ($scope.resource.url) {
                $scope.file['name'] = $scope.resource.url.substring($scope.resource.url.lastIndexOf("/") + 1);
                isEdit = true;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "video";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = videoController;

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=\"userPrev.preview && userPrev.preview.read && isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> </div> <div class=md-whiteframe-2dp ng-show=isAvailable layout=row flex=100 layout-wrap layout-align=space-around> <object ng-if=fileAvaliable data={{src}} width=100% height=440px allowfullscreen></object> <label ng-if=!fileAvaliable flex=50 class=no-data-msg>File not available in the server. Contact admin.</label> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No video Available... To add video go to Edit mode</label> </div> </div>";

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var videoPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "localStorageService", "filePreviewAvailable", "authService", "TPWIZARDCONSTANT", function videoPreviewController($scope, $state, $rootScope, $sce, localStorageService, filePreviewAvailable, authService, TPWIZARDCONSTANT) {
    _classCallCheck(this, videoPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;

    $scope.toogleResource = "Show Details";
    var screenLen = screen.width;
    if (screenLen < 1281) {
        $scope.isShow = false;
    } else {
        $scope.isShow = true;
    }

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadVideo == undefined || $scope.userPrev.uploadVideo && !$scope.userPrev.uploadVideo.create) && ($scope.userPrev.approve == undefined || $scope.userPrev.approve && !$scope.userPrev.approve.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.url) {
                    $scope.isAvailable = true;
                    filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function (response) {
                        $scope.fileAvaliable = response.fileAvaliable;
                        if (response.fileAvaliable) {
                            $scope.src = $sce.trustAsResourceUrl(response.fileUrl);
                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    });
                }
            }
        }
    };
    /*UserPrivilages.getUserPrivilageInitialSetting(function() {
        let userAccess = UserPrivilages.getFeatures('video');
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(obj) {
                let user_access = {};
                _.each(obj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[obj.feature_id] = user_access;
            })
        }
        loadTemplate()
    })*/

    /*Roles and Privilege*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "video";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = videoPreviewController;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column layout-wrap layout-align=space-around ng-if=userPrev.uploadPdf.create> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> <div layout=row layout-align=space-between class=padding-10> <div class=\"res-input-container md-whiteframe-3dp\" layout=row flex> <md-input-container flex=10> <md-menu> <div class=res-save-icon tooltip=upload tooltip-position=right ng-click=\"openMenuAll($mdOpenMenu, $event)\" ng-show=userPrev.uploadPdf.create> <img src=" + __webpack_require__(83) + "> </div> <md-menu-content> <md-menu-item ng-show=userPrev.selectArchive.create> <md-button ng-disabled=isLoading ng-click=selectFromArchive()> Archive </md-button> </md-menu-item> <md-menu-item> <md-button ng-disabled=isLoading ngf-select ng-model=myFiles ngf-change=uploadFile($file)> External </md-button> </md-menu-item> </md-menu-content> </md-menu> </md-input-container> <md-input-container flex=60> <span ng-if=\"file.name || isArchive&& archive.title\">File Name: </span> <span ng-if=!isArchive>{{file.name}}</span> <span ng-if=isArchive>{{archive.title}}</span> </md-input-container> </div> </div> <div class=loading-progress> <md-progress-linear ng-show=isLoading md-mode=determinate value={{progressPercentage}}></md-progress-linear> <span flex ng-show=isLoading>Please wait... Loading {{progressPercentage}} %</span> </div> <md-divider class=video-res-divider ng-show=isSupportedFormat></md-divider> <md-input-container layout=row layout-align=\"end center\" flex ng-show=isSupportedFormat> <div class=res-save-icon ng-click=upload(file) ng-hide=isSaveDisable> <i class=\"fas fa-save\"></i> </div> </md-input-container> </div> </div>";

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: PdfController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PdfController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "archiveService", "TPWIZARDCONSTANT", "CONSTANTS", "Upload", function PdfController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, archiveService, TPWIZARDCONSTANT, CONSTANTS, Upload) {
    _classCallCheck(this, PdfController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var resourceId = $state.params.resourceId;
    var plan = localStorageService.get("currentPlan");
    var save_url = TPWIZARDCONSTANT.API_SAVE_PDF;
    var isEdit = false;
    var isNewFileUploaded = false;
    $scope.file = {};
    var returnedJson = archiveService.getRedirectJson();
    archiveService.clearRedirectJson();
    if (returnedJson) {
        if (resourceId == returnedJson.resource) {
            if (returnedJson.returnData) {
                $scope.isArchive = true;
                $scope.archive = returnedJson.returnData;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
        }
    }

    $scope.selectFromArchive = function () {
        var searchFilters = [];
        searchFilters.push({
            type: "tab",
            value: {
                _id: "resources",
                name: "Resources"
            },
            deletable: false,
            visible: true
        });
        searchFilters.push({
            type: "theme",
            value: {
                _id: plan.theme_id,
                name: plan.theme_title
            },
            deletable: true,
            visible: true
        });
        searchFilters.push({
            type: "resource_type",
            value: {
                _id: "pdf",
                name: "PDF"
            },
            deletable: false,
            visible: true
        });
        var details = {
            searchFilters: searchFilters,
            previousState: {
                state: $state.current.name,
                params: $state.params
            },
            planId: planId,
            resource: resourceId,
            isMultiSelect: false,
            activeTab: "resources",
            resourceType: {
                _id: "pdf",
                name: "PDF"
            }
        };
        archiveService.setRedirectJson(details);
        $state.go("archives");
    };

    $scope.openMenuAll = function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev);
    };

    /*
     * Function to validate file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.uploadFile = function (file) {
        isNewFileUploaded = true;
        var fileSize = file.size / 1048576;
        if (file != undefined && file.name != undefined) {
            var extValue = file.name.split('.').pop();
            if (extValue === 'pdf') {
                $scope.isSupportedFormat = true;
                if (fileSize > 8.00) {
                    toastr.error("Please upload pdf file size less than 15 mb");
                    return false;
                } else {
                    $scope.file = file;
                }
            } else {
                $scope.isSupportedFormat = false;
                toastr.error("Please select supported .pdf format");
            }
        }
    };

    /*
     * Function to upload a file
     * @file : Object - details of file which is uploaded
     * @return : null
     * @Developer: Arul Mozhi J
     */
    $scope.upload = function (file) {
        if ($scope.isArchive) {
            save($scope.archive.resource.url);
        } else {
            $scope.isSaveDisable = true;
            $scope.isLoading = true;
            if (isEdit && !isNewFileUploaded) {
                save($scope.url);
                $scope.isLoading = false;
                $scope.isSaveDisable = false;
            }
            if (isNewFileUploaded) {
                Upload.upload({
                    url: CONSTANTS.SERVER_UPLOAD,
                    data: {
                        file: file,
                        'userPath': userId + "/pdf/"
                    }
                }).then(function (resp) {
                    save(resp.data);
                }, function (resp) {}, function (evt) {
                    $scope.progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    if ($scope.progressPercentage === 100) {
                        $scope.isLoading = false;
                    }
                });
            }
        }
    };

    /*
     * Function to save a file
     * @url : String of file to save
     * @return : null
     * @Developer: Arul Mozhi J
     */
    var save = function save(url) {
        var params = {
            tp_id: planId,
            _id: resourceId,
            title: $scope.resource.title,
            url: url,
            status: $scope.resource.status,
            user_id: userId
        };
        authService.callAPI(save_url, "POST", params, function (resultObj) {
            var result = resultObj.result.data;
            if (result) {
                localStorageService.set("currentPlan", result);
                $scope.isSaveDisable = false;
                toastr.success("Pdf added Successfully");
                $rootScope.setStatus(resourceId, 'created');
                _.defer(function () {
                    $scope.$apply();
                });
            } else {
                toastr.error("Network Error");
            }
        });
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });
            if ($scope.resource.url) {
                $scope.file['name'] = $scope.resource.url.substring($scope.resource.url.lastIndexOf("/") + 1);
                isEdit = true;
                $scope.isSaveDisable = false;
                $scope.isSupportedFormat = true;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    };

    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "pdf";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = PdfController;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = " <div layout=column class=wizard> <div class=md-whiteframe-2dp layout=column ayout-wrap layout-align=space-around ng-if=\"userPrev.preview && userPrev.preview.read&&isAvailable\"> <div class=\"res-title padding-10\" flex> {{resource.title}} </div> <md-divider class=res-divider></md-divider> </div> <div id=pdf-preview-div class=md-whiteframe-2dp ng-show=isAvailable layout=column layout-wrap layout-align=space-around> <label ng-if=!fileAvaliable flex=50 class=no-data-msg>File not available in the server. Contact admin.</label> <header ng-show=fileAvaliable flex class=\"annotate-contrls md-whiteframe-5dp\" style=\"z-index:3;width:100%;border-bottom:1px solid grey\" ng-show=fileAvaliable&&!loading layout-align=\"end center\" layout=row> <div flex layout=row layout-align=\"space-between center\"> <div ng-repeat=\"toolData in tools\" layout=row layout-align=\"space-between center\"> <div flex layout=row layout-align=\"start center\" ng-click=setTool(toolData.tool,toolData) ng-class=\"{'pdfControlSelected':toolData.expanded,'pdfControls':!toolData.expanded}\"> <md-button class=\"md-fab md-mini footer-circle-button2\" aria-label=Add ng-class=\"{'pdfBtnSelected':toolData.expanded,'pdfBtn':!toolData.expanded}\" style=margin-right:10px!important;background-color:#fff tooltip={{toolData.tool}} tooltip-position=up> <img src={{toolData.icon}} class=\"footer-circle-button2 result-icon-button\" alt=Attendance style=margin-bottom:0!important> </md-button> </div> </div> <div flex layout=column layout-align=\"space-between center\" style=\"margin:0 30px\"> <label style=margin:0!important>Thickness : <span>{{lineThickness}}</span></label> <md-slider flex class=md-primary md-discrete ng-model=lineThickness step=1 min=1 max=12 aria-label=count style=padding-left:10px;min-width:150px> </md-slider> </div> <div flex layout=row layout-align=\"start center\" ng-click=undoDrawing() class=pdfControls> <md-button class=\"md-fab md-mini footer-circle-button2\" aria-label=Undo style=background-color:#fff;margin-right:10px!important;padding-bottom:0 tooltip=Undo tooltip-position=up> <img src=" + __webpack_require__(1351) + " class=result-icon-button alt=Undo style=margin-bottom:0!important> </md-button> </div> <div flex layout=row layout-align=\"start center\" ng-click=redoDrawing() class=pdfControls> <md-button class=\"md-fab md-mini footer-circle-button2\" aria-label=Redo style=background-color:#fff;margin-right:10px!important;padding-bottom:0 tooltip=Redo tooltip-position=up> <img src=" + __webpack_require__(1352) + " class=result-icon-button alt=Redo style=margin-bottom:0!important> </md-button> </div> <div flex layout=row layout-align=\"start center\" ng-click=clearPage() class=pdfControls> <md-button class=\"md-fab md-mini footer-circle-button2\" aria-label=Clear style=background-color:#fff;margin-right:10px!important;padding-bottom:0 tooltip=Delete tooltip-position=up> <img src=" + __webpack_require__(1353) + " class=result-icon-button alt=Clear style=margin-bottom:0!important;padding:4px> </md-button> </div> <div flex layout=row layout-align=\"start center\" class=pdfControls> <md-button class=\"md-fab md-mini footer-circle-button2 activebutton\" aria-label=Prev ng-class=\"{inactivebutton: pageNumber==pageStart}\" ng-disabled=\"pageNumber==pageStart\" ng-click=prevPage() style=margin-right:10px!important;padding-bottom:0> <img src=" + __webpack_require__(460) + " class=result-icon-button alt=Prev style=margin-bottom:0!important> </md-button> </div> <div flex layout=row layout-align=\"start center\" class=pdfControls> <md-button class=\"md-fab md-mini footer-circle-button2 activebutton\" ng-click=nextPage() aria-label=Next ng-class=\"{inactivebutton: pageNumber ==pageEnd}\" ng-disabled=\"pageNumber ==pageEnd \" style=margin-right:10px!important;padding-bottom:0> <img src=" + __webpack_require__(461) + " class=result-icon-button alt=Next style=margin-bottom:0!important> </md-button> </div> <div class=pdfControls layout=row layout-align=\"center center\" flex> <label>Page : <span>{{pageNumber}} / {{totalPageNumber}}</span></label> </div> </div> </header> <div> <canvas id=canvas flex width={{windowWidth}} height={{windowHeight}} toolname={{tool}} ng-style=\"{'height': windowInnerHeight,'width': windowInnerWidth}\" class=preview-outline-pdf style=border-style:none;background-color:transparent;position:absolute;left:10;z-index:1;margin-top:1px ng-show=fileAvaliable> </canvas> <canvas id=canvasTemp flex width={{windowWidth}} height={{windowHeight}} toolname={{tool}} ng-style=\"{'height': windowInnerHeight,'width': windowInnerWidth}\" class=preview-outline-pdf style=border-style:none;background-color:transparent;position:absolute;left:10;z-index:2;margin-top:1px ng-show=fileAvaliable></canvas> </div> <pdfviewer ng-show=fileAvaliable ng-src={{src}} id=pdf_viewer flex on-page-load=pageLoaded(page,total) load-progress=\"loadProgress(loaded, total, state)\" style=z-index:0;left:0;top:0;width:100%></pdfviewer> </div> <div flex class=preview-outline-others ng-show=!isAvailable layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Pdf Available... To add pdf go to Edit mode</label> </div> </div>";

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABCElEQVR42mNgGAWjYBSMglEwtIDCYHPQg0HlqOLi4v9EOkoSiDOAeDkQXwHpg2FFRcU3QLGDQNwFxE5AzESRgwg4yhyINyA7gBAWExN7CdRTDsTcZDsIi6NEgHgpKQ5Bx3p6eu+BZgST7SAkR4WCogGfZUA1l4D4MBAfZ2JiekhA7XQgZiXLQQQM7gZiUyBmxmIUKERjgHgvDr1bgJidKg4CKusAYl4SAt4aFIJYzFkFxIwUOQjqa3IAGxDPwWJeGaUOorScmoDFTA1Ko4wSR4GiaAuaeZspTtQUOkoci3l61MhllDiqGs2sNoodRKGjhID4JhD3ArElwdw2CkbBKBgFo2AUDCEAAJtyl1octM58AAAAAElFTkSuQmCC"

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABB0lEQVR42mNgGAWjYBSMglEwCggBhcHmmAeUGMAExE5A3AXEBxUVFd8UFxf/h2Gg2BUgXg7EGUAsSYxjoPpIBtxAXC4mJvYS2QGEMFDPBiA2x+cYchwUrKen954Uh2Bx2FIgFsHmGFIcxArE0/FZxMTE9BCo5jgQHwbiS/jUgqIXqCYU3THEOogdiLfg8O1eII5B8jEyYAZiUyDuJjEE8QJGIF6FRdMlILYmIap5gbiDGg4qw6JhDhCzkZkzYyhxkAYWxRMoLWcocdBmNIVboFFIM8fgc5AeFoXitHYMPge1oSmqpodj8DkIFDWWQNwLxDeBWIgejiG36hgFo2AUjIJRMAoGKwAAzVyXWivq7TEAAAAASUVORK5CYII="

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABcUlEQVR42mOQkJA4mJeX9x+EJSUlbwLxbDExMT0GIgBQnQtQ/2ogvs0AJO7CDEI2ECiehcsAUVFRG5ABULU7wRaLi4sXAAWvohsGsgCoqB2ojwVmgIiIiBRQfT+SmjJkeQZBQUE5oGAjEF/H4rrZQkJCfEC5MCA+jWSIA04/A21UA9q4GKjoPrqBSAavB3pNgpgwBIVbHLLtSK6YCpRmYyAFADV1YjEoiyRDgN5rxeY9UATgDRskwARUOB2WJIDh8RDI7gbFHkwMSB8HWiSG1xRQDKG5YD6SVxuRLFiKN0yQEydQ8W6gMBcWL99VVFR8DIoQbIZkIRsCSqC4sgnQsJlQNRdBCRTZEC1QlkAOUKDiFDwhwAZUsxYpOcANmo8WLsuJiFUxUKCDLAXlO5hBt5EMuQ6UUCEmeoG+sAMlESDeDBZAdg0oMElMtGUgVwHD040BuegAZV4G0gATqBgBGrYRZOpJaIotYSADAH2hA9IPAK8K4XYpUzatAAAAAElFTkSuQmCC"

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PDFPreviewController =
// @ngInject
["$scope", "$state", "$rootScope", "$sce", "$window", "$timeout", "localStorageService", "filePreviewAvailable", "PDFViewerService", "authService", "TPWIZARDCONSTANT", function PDFPreviewController($scope, $state, $rootScope, $sce, $window, $timeout, localStorageService, filePreviewAvailable, PDFViewerService, authService, TPWIZARDCONSTANT) {
    _classCallCheck(this, PDFPreviewController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};

    var userId = localStorageService.get("user_id");
    var planId = $state.params.planId;
    var plan = localStorageService.get("currentPlan");
    var authoring = localStorageService.get("authoringData");
    var resourceId = $state.params.resourceId;
    var themeId = plan.theme_id;
    var curriculumId = authoring.curriculum_id;
    var sessionId = authoring.session_id;
    var classId = authoring.class_id;
    var batchId = authoring.batch_id;
    var subjectId = authoring.subject_id;

    /********************************** PDF ANNOTATION *****************************************/
    var element = document.getElementById("pdf-preview-div");
    var canvas = document.getElementById('canvas');
    var canvasTemp = document.getElementById("canvasTemp");

    if (canvas) {
        var ctx = canvas.getContext('2d');
        var ctxTemp = canvasTemp ? canvasTemp.getContext("2d") : null;
    }

    $scope.normalHeight = $window.innerHeight;

    var x = $("#canvas").offset().left;
    var y = $("#canvas").offset().top;
    var top = parseInt(y);
    var left = parseInt(x);

    $("#canvasTemp").css({
        'top': -2000,
        'left': left,
        'z-index': 1
    });

    var drawing = false;
    var lastX = void 0;
    var lastY = void 0;
    ctx.lineJoin = ctx.lineCap = 'round';
    var points = [],
        fhPoints = [],
        redo_list = [];

    var undo = function undo() {
        restoreState(canvas, ctx, points, redo_list, false);
    };
    var redo = function redo() {
        restoreState(canvas, ctx, points, redo_list, true);
    };
    var restoreState = function restoreState(canvas, ctx, pop, push, isRedo) {
        if (isRedo) {
            if (push.length) {
                var restore_state = push.pop();
                restore_state['undo'] = false;
                points.push(restore_state);
                resetDrawing();
            }
        } else {
            if (pop.length) {
                var restore_state = pop.pop();
                restore_state['undo'] = true;
                redo_list.push(restore_state);
                resetDrawing();
            }
        }
    };

    var getPdfHeight = function getPdfHeight() {
        var element = document.getElementById("pdf-preview-div");
        var pdfHolder = element.getElementsByTagName('pdfviewer')[0];
        var ratio = backingScale();
        var w = pdfHolder.firstChild.clientWidth;
        var h = pdfHolder.firstChild.clientHeight;
        $scope.windowWidth = Math.floor(w * ratio);
        $scope.windowHeight = Math.floor(h * ratio);
        $scope.windowInnerWidth = Math.floor(w) + 'px';
        $scope.windowInnerHeight = Math.floor(h) + 'px';
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        resetDrawing();
        canvas.style.pointerEvents = 'auto|none';
    };
    var backingScale = function backingScale() {
        var dpr = window.devicePixelRatio || 1;
        var bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;

        return dpr / bsr;
    };
    var clearPageAnnotation = function clearPageAnnotation() {
        points = _.filter(points, function (each) {
            return each.page !== $scope.pageNumber;
        });
        resetDrawing();
    };

    var updateNewDrawing = function updateNewDrawing(pts) {
        points = _.filter(pts, function (each) {
            return !each.undo;
        });
        redo_list = _.filter(pts, function (each) {
            return each.undo;
        });
        resetDrawing();
    };

    var resetDrawing = function resetDrawing() {
        ctx.clearRect(0, 0, $scope.windowWidth, $scope.windowHeight);
        var imgs = [];
        var imgIndex = 0;
        var pointDetails = [];

        $scope.pointData = points;

        //Load previously Saved Annotation
        var pointFreeDetails = _.filter(points, function (p_data) {
            return p_data.page === $scope.pageNumber;
        });

        //Filter undo annotations
        if (redo_list != undefined && redo_list.length > 0) {

            var redoIds = _.compact(_.pluck(redo_list, '_id'));
            var pointIds = _.compact(_.pluck(pointFreeDetails, '_id'));
            var pointArray = _.difference(pointIds, redoIds);
            _.each(pointArray, function (pts) {
                var pointObj = _.find(pointFreeDetails, function (obj) {
                    return obj._id === pts && obj.undo != true;
                });
                if (pointObj != undefined) {
                    pointDetails.push(pointObj);
                }
            });
        } else {
            pointDetails = pointFreeDetails;
        }

        _.each(pointDetails, function (each_point) {
            ctx.beginPath();
            ctx.lineJoin = ctx.lineCap = 'round';
            if (each_point.tool_name == 'Pencil') {

                var scale = $scope.windowWidth / each_point.width;
                ctx.lineWidth = each_point.thickness;
                ctx.strokeStyle = '#000000';
                if (each_point.draw_points != undefined && each_point.draw_points.length > 0) {
                    ctx.moveTo(each_point.draw_points[0].x * scale, each_point.draw_points[0].y * scale);
                    for (var j = 1; j < each_point.draw_points.length; j++) {
                        ctx.lineTo(each_point.draw_points[j].x * scale, each_point.draw_points[j].y * scale);
                    }
                }
                ctx.stroke();
            } else if (each_point.tool_name == 'Line') {
                var _scale = $scope.windowWidth / each_point.width;
                ctx.lineWidth = each_point.thickness;
                ctx.strokeStyle = '#000000';
                ctx.moveTo(each_point.x1 * _scale, each_point.y1 * _scale);
                ctx.lineTo(each_point.x2 * _scale, each_point.y2 * _scale);
                ctx.stroke();
            } else if (each_point.tool_name == 'Rectangle') {
                var _scale2 = $scope.windowWidth / each_point.width;
                ctx.lineWidth = each_point.thickness;
                ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)';
                ctx.rect(each_point.x * _scale2, each_point.y * _scale2, each_point.w * _scale2, each_point.h * _scale2);
                ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                ctx.fill();
                ctx.stroke();
            } else if (each_point.tool_name == 'Marker') {
                var _scale3 = $scope.windowWidth / each_point.width;
                ctx.lineWidth = each_point.thickness;
                ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)';
                if (each_point.draw_points != undefined && each_point.draw_points.length > 0) {
                    ctx.moveTo(each_point.draw_points[0].x * _scale3, each_point.draw_points[0].y * _scale3);
                    for (var j = 1; j < each_point.draw_points.length; j++) {
                        ctx.lineTo(each_point.draw_points[j].x * _scale3, each_point.draw_points[j].y * _scale3);
                    }
                    ctx.stroke();
                }
            }
        });
    };
    var currentX = void 0,
        currentY = void 0;
    canvas.onmouseover = function (event) {
        if (event.offsetX !== undefined) {
            currentX = event.offsetX;
            currentY = event.offsetY;
        } else {
            currentX = event.layerX - event.currentTarget.offsetLeft;
            currentY = event.layerY - event.currentTarget.offsetTop;
        }
    };
    canvas.onmouseout = function (event) {
        if (event.offsetX !== undefined) {
            currentX = event.offsetX;
            currentY = event.offsetY;
        } else {
            currentX = event.layerX - event.currentTarget.offsetLeft;
            currentY = event.layerY - event.currentTarget.offsetTop;
        }
    };
    canvas.addEventListener('touchstart', onTouchStart, false);
    canvas.addEventListener('touchmove', onTouchMove, false);
    canvas.addEventListener('touchend', onTouchEnd, false);
    canvasTemp.addEventListener('touchstart', onTouchStart, false);
    canvasTemp.addEventListener('touchmove', onTouchMove, false);
    canvasTemp.addEventListener('touchend', onTouchEnd, false);
    canvas.addEventListener('mousedown', onMouseStart, false);
    canvas.addEventListener('mousemove', onMouseMove, false);
    canvas.addEventListener('mouseup', onMouseEnd, false);
    canvasTemp.addEventListener('mousedown', onMouseStart, false);
    canvasTemp.addEventListener('mousemove', onMouseMove, false);
    canvasTemp.addEventListener('mouseup', onMouseEnd, false);
    // document.addEventListener('load', resize, false);
    // document.addEventListener('resize', resize, false);

    // function resize() {

    //     /* // Our canvas must cover full height of screen
    //      // regardless of the resolution
    //      var height = window.innerHeight;
    //      // So we need to calculate the proper scaled width
    //      // that should work well with every resolution
    //      var ratio = canvas.width / canvas.height;
    //      var width = height * ratio;

    //      canvas.style.width = width + 'px';
    //      canvas.style.height = height + 'px';*/


    // }

    // Get the position of a touch relative to the canvas
    function getTouchPos(canvasDom, touchEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
            x: touchEvent.touches[0].clientX - rect.left,
            y: touchEvent.touches[0].clientY - rect.top
        };
    }
    // Get the position of the mouse relative to the canvas
    function getMousePos(canvasDom, mouseEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
            x: mouseEvent.clientX - rect.left,
            y: mouseEvent.clientY - rect.top
        };
    }

    document.body.addEventListener("touchstart", function (e) {
        if (e.target == canvas && drawing) {
            e.preventDefault();
        }
    }, false);
    document.body.addEventListener("touchend", function (e) {
        if (e.target == canvas && drawing) {
            e.preventDefault();
        }
    }, false);
    document.body.addEventListener("touchmove", function (e) {
        if (e.target == canvas && drawing) {
            e.preventDefault();
        }
    }, false);

    function onTouchStart(event) {
        mousePos = getTouchPos(canvas, event);
        var touch = event.touches[0];
        var mouseEvent = new MouseEvent("mousedown", {
            clientX: touch.clientX,
            clientY: touch.clientY
        });
        canvas.dispatchEvent(mouseEvent);
    }

    function onTouchMove(event) {
        var touch = event.touches[0];
        var mouseEvent = new MouseEvent("mousemove", {
            clientX: touch.clientX,
            clientY: touch.clientY
        });
        canvas.dispatchEvent(mouseEvent);
    }

    function onTouchEnd(event) {
        var mouseEvent = new MouseEvent("mouseup", {});
        canvas.dispatchEvent(mouseEvent);
    }

    function onMouseStart(event) {
        lastX = lastY = '';
        var lastPos = getMousePos(canvas, event);
        if (event.offsetX !== undefined) {
            lastX = event.offsetX;
            lastY = event.offsetY;
        } else {
            lastX = lastPos.x; //event.layerX - event.currentTarget.offsetLeft;
            lastY = lastPos.y; //event.layerY - event.currentTarget.offsetTop;
        }

        // begins new line
        ctx.beginPath();
        fhPoints = [];
        var isNotesOpen = false;

        if (!isNotesOpen) {
            if ($scope.tool == 'Pencil') {
                ctx.lineWidth = $scope.lineThickness;
                ctx.strokeStyle = '#000000';
                ctx.fillStyle = '#000000';
                ctx.moveTo(lastX, lastY);
                fhPoints.push({
                    x: lastX,
                    y: lastY
                });
                drawing = true;
            } else if ($scope.tool == 'Line') {
                ctx.lineWidth = $scope.lineThickness;
                ctx.strokeStyle = '#000000';
                ctx.fillStyle = '#000000';

                var x = $("#canvas").offset().left;
                var y = $("#canvas").offset().top;
                var _top = parseInt(y);
                var _left = parseInt(x) + 'px';
                $("#canvasTemp").css({
                    'top': _top,
                    'left': _left,
                    'z-index': 2
                });
                $("#canvas").css({
                    'z-index': 1
                });
                ctxTemp.lineWidth = $scope.lineThickness;
                ctxTemp.strokeStyle = '#000000';
                ctxTemp.fillStyle = '#000000';
                ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
                drawing = true;
            } else if ($scope.tool == 'Marker') {
                ctx.lineWidth = $scope.lineThickness;
                ctx.strokeStyle = 'rgba(255, 255, 0, 0.1)';
                ctx.moveTo(lastX, lastY);
                fhPoints.push({
                    x: lastX,
                    y: lastY
                });
                drawing = true;
            } else if ($scope.tool == 'Rectangle') {
                ctx.lineWidth = $scope.lineThickness;
                ctx.strokeStyle = 'rgba(255, 255, 0, 0.4)';
                ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                drawing = true;
            } else if ($scope.tool == 'Notes') {
                $scope.takeNotes();
                drawing = true;
            }
        }
    }

    function onMouseMove(event) {
        if (drawing) {
            // get current mouse position
            var currentPos = getMousePos(canvas, event);
            if (event.offsetX !== undefined) {
                currentX = event.offsetX;
                currentY = event.offsetY;
            } else {
                currentX = currentPos.x; //event.layerX - event.currentTarget.offsetLeft;
                currentY = currentPos.y; //event.layerY - event.currentTarget.offsetTop;
            }

            if ($scope.tool == 'Pencil') {
                ctx.lineTo(currentX, currentY);
                fhPoints.push({
                    x: currentX,
                    y: currentY
                });
                ctx.stroke();
            } else if ($scope.tool == 'Line') {

                ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
                ctxTemp.beginPath();
                ctxTemp.moveTo(lastX, lastY);
                ctxTemp.lineTo(currentX, currentY);
                ctxTemp.stroke();
            } else if ($scope.tool == 'Rectangle') {} else if ($scope.tool == 'Marker') {
                ctx.lineTo(currentX, currentY);
                fhPoints.push({
                    x: currentX,
                    y: currentY
                });
                ctx.stroke();
            }
        }
    }

    function onMouseEnd(event) {
        // stop drawing
        var valueObj = {};
        drawing = false;
        if ($scope.tool == 'Line') {

            var x = $("#canvas").offset().left;
            var _left2 = parseInt(x);
            $("#canvasTemp").css({
                'top': -2000,
                'left': _left2,
                'z-index': 1
            });
            $("#canvas").css({
                'z-index': 2
            });
            ctxTemp.clearRect(0, 0, canvasTemp.width, canvasTemp.height);
            ctx.beginPath();
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(currentX, currentY);
            ctx.stroke();
            valueObj = {
                page: $scope.pageNumber,
                tool_name: $scope.tool,
                x1: lastX,
                y1: lastY,
                x2: currentX,
                y2: currentY,
                undo: false,
                thickness: $scope.lineThickness,
                theme: themeId,
                user_id: userId,
                subject_id: subjectId,
                class_id: classId,
                curriculum: curriculumId,
                session_id: sessionId,
                batch_id: batchId,
                width: $scope.windowWidth,
                height: $scope.windowHeight,
                pdf_url: $scope.resource.url,
                resource_id: resourceId
            };
            updateValues(valueObj);
        } else if ($scope.tool == 'Pencil') {
            valueObj = {
                page: $scope.pageNumber,
                tool_name: $scope.tool,
                draw_points: fhPoints,
                thickness: $scope.lineThickness,
                theme: themeId,
                user_id: userId,
                subject_id: subjectId,
                class_id: classId,
                curriculum: curriculumId,
                session_id: sessionId,
                batch_id: batchId,
                width: $scope.windowWidth,
                height: $scope.windowHeight,
                undo: false,
                pdf_url: $scope.resource.url,
                resource_id: resourceId
            };
            updateValues(valueObj);
        } else if ($scope.tool == 'Rectangle') {
            ctx.rect(lastX, lastY, currentX - lastX, currentY - lastY);
            ctx.fill();
            ctx.stroke();

            valueObj = {
                page: $scope.pageNumber,
                tool_name: $scope.tool,
                x: lastX,
                y: lastY,
                w: currentX - lastX,
                h: currentY - lastY,
                thickness: $scope.lineThickness,
                theme: themeId,
                user_id: userId,
                subject_id: subjectId,
                class_id: classId,
                curriculum: curriculumId,
                session_id: sessionId,
                batch_id: batchId,
                width: $scope.windowWidth,
                height: $scope.windowHeight,
                undo: false,
                pdf_url: $scope.resource.url,
                resource_id: resourceId
            };
            updateValues(valueObj);
        } else if ($scope.tool == 'Marker') {

            valueObj = {
                page: $scope.pageNumber,
                tool_name: $scope.tool,
                draw_points: fhPoints,
                thickness: $scope.lineThickness,
                theme: themeId,
                user_id: userId,
                subject_id: subjectId,
                class_id: classId,
                session_id: sessionId,
                batch_id: batchId,
                curriculum: curriculumId,
                width: $scope.windowWidth,
                height: $scope.windowHeight,
                undo: false,
                pdf_url: $scope.resource.url,
                resource_id: resourceId
            };
            updateValues(valueObj);
        }
    }

    var changePDFPage = function changePDFPage() {
        var list = _.filter(points, function (each) {
            return each.page === $scope.pageNumber;
        });
        if (redo_list.length > 0) {
            var redoList = _.filter(redo_list, function (each) {
                return each.page === $scope.pageNumber;
            });
            list.push.apply(list, _toConsumableArray(redoList));
        }
        updatePageAnnotations(list);
    };

    var updateValues = function updateValues(pointes) {
        authService.callAPI(TPWIZARDCONSTANT.API_ADD_PDF_ANNOTATION, "POST", pointes, function (response) {
            if (response.result.data) {
                points.push(response.result.data);
            }
        });
    };

    var fetchValues = function fetchValues() {
        var detailObj = {
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": classId,
            "batch_id": batchId,
            "subject_id": subjectId,
            "resource_id": resourceId,
            "page_number": $scope.pageNumber,
            "user_id": userId
        };
        authService.callAPI(TPWIZARDCONSTANT.API_FETCH_ANNOTATION, "POST", detailObj, function (response) {
            updateNewDrawing(response.result.data);
        });
    };

    var removeAnnotateValues = function removeAnnotateValues() {
        var detailObj = {
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": classId,
            "batch_id": batchId,
            "subject_id": subjectId,
            "resource_id": resourceId,
            "page_number": $scope.pageNumber,
            "user_id": userId
        };
        authService.callAPI(TPWIZARDCONSTANT.API_REMOVE_ANNOTATION, "POST", detailObj, function (response) {});
    };

    var updatePageAnnotations = function updatePageAnnotations(list) {
        var detailObj = {
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": classId,
            "batch_id": batchId,
            "subject_id": subjectId,
            "resource_id": resourceId,
            "page_number": $scope.pageNumber,
            "user_id": userId,
            "list": list
        };
        authService.callAPI(TPWIZARDCONSTANT.API_UPDATE_PAGE_ANNOTATION, "POST", detailObj, function (response) {});
    };

    var updateAllAnnotations = function updateAllAnnotations(list) {
        var detailObj = {
            "session_id": sessionId,
            "curriculum_id": curriculumId,
            "class_id": classId,
            "batch_id": batchId,
            "subject_id": subjectId,
            "resource_id": resourceId,
            "page_number": $scope.pageNumber,
            "user_id": userId,
            "list": list
        };
        authService.callAPI(TPWIZARDCONSTANT.API_UPDATE_ALL_PAGE_ANNOTATION, "POST", detailObj, function (response) {});
    };

    // Get a regular interval for drawing to the screen
    window.requestAnimFrame = function (callback) {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimaitonFrame || function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
    }();
    /********************************** PDF ANNOTATION *****************************************/

    $rootScope.$on('$locationChangeStart', function (event, newUrl, oldUrl) {
        if (points && redo_list) {
            if (points.length > 0 || redo_list.length > 0) updateAllAnnotations(points);
        }
    });

    //Hide tool bar
    $scope.hideToolbar = true;

    //Pdf js workerjs url
    // PDFJS.workerSrc = '../../../../../../libs/pdf.worker.js';

    //Start page number
    $scope.pageNumber = 1;

    //Total pages
    $scope.totalPageNumber = 1;

    //Page start and end
    var pageStart = void 0,
        pageEnd = void 0;

    //PDF annotation tools
    $scope.tools = [{
        tool: 'Pencil',
        expanded: false,
        icon: '../../../../../../img/pdf-viewer/ic_create.png'
    }, {
        tool: 'Line',
        expanded: false,
        icon: '../../../../../../img/pdf-viewer/ic_line.png'
    }, {
        tool: 'Marker',
        expanded: false,
        icon: '../../../../../../img/pdf-viewer/ic_brush.png'
    }];

    /*
     * Function To init pdf
     * @developer - Arul Mozhi J
     */
    $scope.initpdf = function () {
        if ($scope.pdfLinks === undefined) {
            return;
        }
        $scope.isPDFExist = true;
        $scope.showLoadingFirst = true;
        $scope.instance = PDFViewerService.Instance("pdf_viewer");
        $scope.pageStart = 1;
    };

    /*
     * Function To go to next page
     * @developer - Arul Mozhi J
     */
    $scope.nextPage = function () {
        PDFViewerService.nextPage();
        if (PDFViewerService.getTotalPageNumber() != $scope.pageNumber) {
            $scope.loading = true;
            $scope.showHide = false;
        }
        if ($scope.pageNumber < $scope.pageEnd) {
            changePDFPage();
            $scope.pageNumber++;
        }
    };

    /*
     * Function To go to prev page
     * @developer - Arul Mozhi J
     */
    $scope.prevPage = function () {
        PDFViewerService.prevPage();
        if ($scope.pageNumber > 1) {
            $scope.loading = true;
            $scope.showHide = false;
            changePDFPage();
            $scope.pageNumber--;
        }
    };

    /*
     * Function To load page
     * @developer - Arul Mozhi J
     */
    $scope.pageLoaded = function (curPage, maxPage, totalPages) {
        if ($scope.instance != undefined) {
            $scope.instance = PDFViewerService.Instance("pdf_viewer");
        }
        $scope.pageNumber = PDFViewerService.getPageNumber();
        $scope.totalPageNumber = PDFViewerService.getTotalPageNumber();
        if ($scope.pdfLinks != undefined && $scope.pdfLinks.type === 'single') {
            $scope.pageStart = parseInt(pageStart);
            $scope.pageEnd = parseInt(pageEnd);
        } else {
            $scope.pageStart = 1;
            $scope.pageEnd = parseInt($scope.totalPageNumber);
        }
        $timeout(getPdfHeight(), 100);
        $scope.loading = false;
        $scope.hideToolbar = false;
        $scope.showHide = true;
        fetchValues();
    };

    /*
     * Function To calculate progress
     * @developer - Arul Mozhi J
     */
    $scope.loadProgress = function (loaded, total, state) {
        if (_.isObject(state)) {
            $scope.isPDFExist = false;
        } else {
            if (state === "finished") {
                $scope.isPDFExist = true;
                $scope.showLoadingFirst = false;
            }
        }
    };

    $scope.setTool = function (toolName, data) {
        for (var i in $scope.tools) {
            if ($scope.tools[i] != data) {
                $scope.tools[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;
        if (data.expanded) {
            $scope.tool = toolName;
        } else {
            $scope.tool = '';
        }
    };

    $scope.undoDrawing = function () {
        undo();
    };

    $scope.redoDrawing = function () {
        redo();
    };
    $scope.clearPage = function () {
        clearPageAnnotation();
        removeAnnotateValues();
    };

    var loadTemplate = function loadTemplate() {
        if (plan) {
            $scope.resource = _.find(plan.resources, function (res) {
                return res._id === resourceId;
            });

            if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadPdf == undefined || $scope.userPrev.uploadPdf && !$scope.userPrev.uploadPdf.create) && ($scope.userPrev.approvePdf == undefined || $scope.userPrev.approvePdf && !$scope.userPrev.approvePdf.create)) {
                try {
                    var data = {
                        resource: {
                            type: $scope.resource.type,
                            subject_id: authoring.subject_id,
                            class_id: authoring.class_id,
                            curriculum_id: authoring.curriculum_id,
                            batch_id: authoring.batch_id,
                            session_id: authoring.session_id,
                            school_id: authoring.school_id,
                            theme_id: plan.theme_id,
                            plan_id: planId,
                            progress_data: {
                                _id: resourceId,
                                title: $scope.resource.title
                            }
                        },
                        user_id: userId
                    };
                    authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, function () {});
                } catch (ex) {}
            }
            if ($scope.resource) {
                if ($scope.resource.url) {
                    $scope.isAvailable = true;
                    filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function (response) {
                        if (response.fileAvaliable) {
                            $scope.fileAvaliable = response.fileAvaliable;
                            $scope.src = $sce.trustAsResourceUrl(response.fileUrl);
                            _.defer(function () {
                                $scope.$apply();
                            });
                        }
                    });
                }
            }
        }
    };
    /*UserPrivilages.getUserPrivilageInitialSetting(function() {
        let userAccess = UserPrivilages.getFeatures('pdf');
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(obj) {
                let user_access = {};
                _.each(obj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[obj.feature_id] = user_access;
            })
        }
        loadTemplate()
    })*/
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "pdf";
    });
    $scope.userPrev = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.userPrev[tpObj.feature_id] = user_access;
        });
        loadTemplate();
    }
}];

exports.default = PDFPreviewController;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=qpPreview ng-show=!isLoading> <div class=md-whiteframe-2dp layout=row flex=100> <div flex=10> <div class=school-logo> <img src={{qpHeader.schoolLogo}} width=100> </div> </div> <div layout=column flex=80> <div class=schoolName> {{qpHeader.schoolName}}</div> <div class=exam>{{qpDetails.question_paper_title}}</div> <div class=subject>{{qpHeader.subject}}</div> </div> <div flex=5 layout=row layout-align=\"end start\" ng-show=activityUserPrivilege.createQuestion&&activityUserPrivilege.createQuestion.create> <div class=marTop ng-click=generatePdf()> <div class=editIcon title=PDF> <i class=\"far fa-file-pdf icon-img\"></i> </div> </div> </div> <div flex=5 layout=row layout-align=\"end start\" ng-show=\"activityUserPrivilege.createQuestion&&activityUserPrivilege.createQuestion.create&&!allQuestions.practice_qn && !isConducted && isCreator && !isViewMode\"> <div class=marTop ng-click=addPassword()> <div class=editIcon title=Security> <i class=\"fas fa-lock icon-img\"></i> </div> </div> </div> <div flex=5 layout=row layout-align=\"end start\" ng-show=\"activityUserPrivilege.createQuestion&&activityUserPrivilege.createQuestion.create && !isConducted && isCreator && !isViewMode\"> <div class=marTop ng-click=saveQuestionPaper()> <div class=editIcon title=Save> <i class=\"far fa-save icon-img\"></i> </div> </div> </div> <div flex=5 layout=row layout-align=\"end start\" ng-show=\"activityUserPrivilege.createQuestion&&activityUserPrivilege.createQuestion.create && !isConducted && isCreator && !isViewMode\"> <div class=marTop ng-click=gotoSectionPage()> <div class=editIcon title=Edit> <i class=\"fas fa-pen icon-img\"></i> </div> </div> </div> <div flex=5 layout=row layout-align=\"end start\"> <div class=marTop ng-click=gotoQpPreview()> <div class=editIcon title=Close> <i class=\"fas fa-times icon-img\"></i> </div> </div> </div> </div> <div class=\"timeClass md-whiteframe-2dp\" layout=row flex=100> <div flex=30> <span>Time: {{qpDetails.time.hour}} hour {{qpDetails.time.min}} min</span> </div> <div flex=30>Class:{{qpHeader.class}}</div> <div flex=30> <span>Maximum Marks:{{qpDetails.total_mark}}</span> </div> </div> <div class=\"instructionBorder md-whiteframe-2dp\" layout=column flex=100> <div class=instruction> <div class=instructionHead> <b>General Instructions</b> </div> <div ng-repeat=\"sectionData in allQuestions.sections\"> <div style=font-weight:700>{{sectionData.name}} </div> <div>({{$index+1}})&nbsp;&nbsp;{{sectionData.instruction}}</div> </div> </div> </div> <div class=\"questionBorder md-whiteframe-2dp\"> <div ng-repeat=\"sectionData in allQuestions.sections\"> <div class=sectionBorder> <b>{{sectionData.name}}</b> </div> <div class=eachQues ng-repeat=\"questionData in sectionData.questions\" ng-init=\"parentIndex = $index+1\"> <div> <i title=metadata ng-click=getmetadata(questionData) style=color:#56ce59;float:right;cursor:pointer class=\"fas fa-info-circle\"></i> <div flex=95 ng-show=\"questionData.type === 'passage'\">{{$index+1}}. <b> {{questionData.title}} </b> <br/> <br/> <span ng-bind-html=questionData.desc></span> </div> <br/> <br/> <div ng-show=\"questionData.image && !isArray(questionData.image)\"> <img src=\"{{file_server_url + questionData.image}}\" style=max-width:300px;max-height:150px> <br/> <br/> </div> <div layout=row flex=100 layout-wrap ng-show=\"isArray(questionData.image) && questionData.image.length>0\"> <div flex=20 ng-repeat=\"img in questionData.image track by $index\" style=margin:10px> <img src=\"{{file_server_url + img}}\" style=max-width:300px;max-height:150px> </div> <br/> <br/> </div> <div layout=column ng-show=\"questionData.type==='passage'\" ng-repeat=\"ibtQues in questionData.questions\"> <div layout=row> <div flex=95 ng-show=\"ibtQues.type === 'FIB' || ibtQues.type === 'IBT_FIB'\">{{parentIndex}}.{{$index+1}}. {{beautifyFIB(ibtQues.qn_desc)}} </div> <div flex=95 ng-show=\"ibtQues.type === 'MTF'\">{{parentIndex}}.{{$index+1}}. Match the following </div> <div flex=95 ng-show=\"ibtQues.type !== 'FIB' || ibtQues.type !== 'IBT_FIB' || ibtQues.type !== 'MTF'\">{{parentIndex}}.{{$index+1}}. <span class=question_desc ng-show=ibtQues.isLatex>{{ibtQues.qn_desc}}</span> <span ng-show=!ibtQues.isLatex>{{ibtQues.qn_desc}}</span> </div> <div flex=5 ng-show=!resource.isPractice>({{ibtQues.mark}})</div> </div> <div ng-show=\"ibtQues.questionImg && !isArray(ibtQues.questionImg)\"> <img src=\"{{file_server_url + ibtQues.questionImg}}\" style=max-width:300px;max-height:150px> </div> <div layout=row flex=100 layout-wrap ng-show=\"isArray(ibtQues.questionImg) && ibtQues.questionImg.length>0\"> <div flex=20 ng-repeat=\"img in ibtQues.questionImg track by $index\" style=margin:10px> <img src=\"{{file_server_url + img}}\" style=max-width:300px;max-height:150px> </div> </div> <br/> <br/> <div layout=row layout-wrap> <div ng-show=\"ibtQues.type=='MCQ' || ibtQues.type=='IBT_MCQ'\" class=eachAns ng-repeat=\"answerData in ibtQues.choice\" flex=45> <div layout=row> <div class=option>({{answerData.tag}})</div> <div class=optionData> <span class=question_desc ng-show=ibtQues.isLatex>{{answerData.desc}}</span> <span ng-show=!ibtQues.isLatex>{{answerData.desc}}</span> </div> </div> <div ng-show=\"answerData.optImage && !isArray(answerData.optImage)\"> <img src=\"{{file_server_url + answerData.optImage}}\" style=max-width:200px;max-height:100px> </div> <div layout=row flex=100 layout-wrap ng-show=\"isArray(answerData.optImage) && answerData.optImage.length>0\"> <div flex=40 ng-repeat=\"img in answerData.optImage track by $index\" style=margin:10px> <img src=\"{{file_server_url + img}}\" style=max-width:200px;max-height:150px> </div> </div> </div> <div ng-show=\"ibtQues.type=='TF'\" class=eachAns flex=45> <div layout=row> <div class=option>(A)</div> <div class=optionData>True</div> </div> </div> <div ng-show=\"ibtQues.type=='TF'\" class=eachAns flex=45> <div layout=row> <div class=option>(B)</div> <div class=optionData>False</div> </div> </div> <div ng-show=\"ibtQues.type=='MTF'\" ng-init=suffleOptions(ibtQues) flex=90> <div layout=row flex ng-repeat=\"choice in ibtQues.optionQuestion\"> <span class=caption style=width:50px>({{choice.tag}})</span> <span class=mtf-question flex=45 layout=column> <span class=question_desc ng-show=ibtQues.isLatex>{{choice.desc}}</span> <span ng-show=!ibtQues.isLatex>{{choice.desc}}</span> <img ng-if=choice.question.optImage ng-src=\"{{fileUrl + choice.question.optImage}}\" style=max-width:200px;max-height:100px> </span> <span class=mtf-answer flex=45 layout=column> <span class=question_desc ng-show=ibtQues.isLatex>{{ibtQues.optionAnswer[$index].desc}}</span> <span ng-show=!ibtQues.isLatex>{{ibtQues.optionAnswer[$index].desc}}</span> <img ng-if=questionData.optionAnswer[$index].optImage ng-src=\"{{fileUrl + questionData.optionAnswer[$index].optImage}}\" style=max-width:200px;max-height:100px> </span> </div> </div> </div> </div> <div layout=row> <div flex=95 ng-show=\"questionData.type === 'FIB'\"> {{$index+1}}. {{beautifyFIB(questionData.qn_desc)}} </div> <div flex=95 ng-show=\"questionData.type === 'MTF'\"> {{$index+1}}. Match the following </div> <div flex=95 ng-show=\"questionData.type !== 'FIB' && questionData.type !== 'passage' && questionData.type !== 'MTF'\">{{$index+1}}. <span class=question_desc ng-show=questionData.isLatex>{{questionData.qn_desc}}</span> <span ng-show=!questionData.isLatex>{{questionData.qn_desc}}</span> </div> <div flex=5 ng-show=\"!resource.isPractice && questionData.type !== 'passage' \">({{questionData.mark}})</div> </div> <div ng-show=\"questionData.questionImg && !isArray(questionData.questionImg)\">gggg <img src=\"{{file_server_url + questionData.questionImg}}\" style=max-width:300px;max-height:150px> </div> <div layout=row flex=100 layout-wrap ng-show=\"isArray(questionData.questionImg) && questionData.questionImg.length>0\"> <div flex=20 ng-repeat=\"img in questionData.questionImg track by $index\" style=margin:10px> <img src=\"{{file_server_url + img}}\" style=max-width:300px;max-height:150px> </div> </div> <div layout=row flex=100 layout-wrap> <div ng-show=\"questionData.type=='MCQ'\" class=eachAns ng-repeat=\"answerData in questionData.choice\" flex=45> <div layout=row> <div class=option>({{answerData.tag}})</div> <div class=optionData> <span class=question_desc ng-show=questionData.isLatex>{{answerData.desc}}</span> <span ng-show=!questionData.isLatex>{{answerData.desc}}</span> </div> </div> <div ng-show=\"answerData.optImage && !isArray(answerData.optImage)\"> <img src=\"{{file_server_url + answerData.optImage}}\" style=max-width:200px;max-height:100px> </div> <div layout=row flex=100 layout-wrap ng-show=\"isArray(answerData.optImage) && answerData.optImage.length>0\"> <div flex=40 ng-repeat=\"img in answerData.optImage track by $index\" style=margin:10px> <img src=\"{{file_server_url + img}}\" style=max-width:200px;max-height:150px> </div> </div> </div> <div ng-show=\"questionData.type=='TF'\" class=eachAns flex=45> <div layout=row> <div class=option>(A)</div> <div class=optionData>True</div> </div> </div> <div ng-show=\"questionData.type=='TF'\" class=eachAns flex=45> <div layout=row> <div class=option>(B)</div> <div class=optionData>False</div> </div> </div> <div ng-show=\"questionData.type=='MTF'\" ng-init=suffleOptions(questionData) flex=90> <div layout=row flex ng-repeat=\"choice in questionData.optionQuestion\"> <span class=caption style=width:50px>({{choice.tag}})</span> <span class=mtf-question flex=45 layout=column> <span class=question_desc ng-show=questionData.isLatex>{{choice.desc}}</span> <span ng-show=!questionData.isLatex>{{choice.desc}}</span> <img ng-if=choice.questionImg src=\"{{file_server_url + choice.questionImg}}\" style=max-width:200px;max-height:100px> </span> <span class=mtf-answer flex=45 layout=column> <span class=question_desc ng-show=questionData.isLatex>{{questionData.optionAnswer[$index].desc}}</span> <span ng-show=!questionData.isLatex>{{questionData.optionAnswer[$index].desc}}</span> <img ng-if=questionData.optionAnswer[$index].optImage src=\"{{file_server_url + questionData.optionAnswer[$index].optImage}}\" style=max-width:200px;max-height:100px> </span> </div> </div> <div ng-show=\"questionData.type=='ASLLISTEN'\" flex layout-padding> <div ng-show=questionData.audio_url class=md-whiteframe-2dp ng-init=\"convertURLTotrustUrl(questionData.audio_url,$index,'question')\" flex=30> <audio controls ng-src={{convertedURLQuestion[$index]}}></audio> </div> <div ng-repeat=\"question in questionData.questions\" flex> <div class=asl-list-question layout=row> <div flex=5>({{$index+1}})</div> <div flex=80>{{question.qn_desc}}</div> </div> <div layout=row flex class=asl-list-content> <div flex=5></div> <div ng-show=\"question.type==='audio'\"> <div flex ng-show=question.answer class=md-whiteframe-2dp ng-init=\"convertURLTotrustUrl(question.answer,$index,'answer')\"> <audio controls ng-src={{convertedURLAnswer[$index]}}></audio> </div> </div> <div ng-show=\"question.type==='mcq'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.choice\"> <div flex=5>{{$index+1}}.</div> <div flex>{{choice.desc}}</div> </div> </div> <div ng-show=\"question.type==='fib'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.answer\"> <div flex=5>{{$index+1}}.</div> <div flex>{{choice.desc}}</div> </div> </div> <div ng-show=\"question.type==='tf'\" layout=row layout-wrap flex> <div layout=row flex=50 ng-repeat=\"choice in question.choice\"> <div flex=5>{{$index+1}}.</div> <div flex>{{choice.tag}}</div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div layout=row class=activity-password layout-align=\"end end\" ng-show=isPassword> <div class=\"md-whiteframe-5dp add-activity-password\"> <div layout=row layout-align=\"end end\"> <img class=close-div src=" + __webpack_require__(90) + " ng-click=closePasswordDiv()> </div> <div layout=row layout-align=\"start start\"> <md-input-container class=\"md-block password-input\" flex-gt-sm> <label>Activity Password</label> <input type=password ng-model=activityPassword /> </md-input-container> <div class=password-save ng-click=saveActivityPassword(activityPassword)> <img src=" + __webpack_require__(536) + " /> </div> </div> </div> </div>";

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _questionMetaData = __webpack_require__(169);

var _questionMetaData2 = _interopRequireDefault(_questionMetaData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: activityPreview.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2018-12-13
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var QpPreviewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "$timeout", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$sce", function QpPreviewController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, $timeout, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
    _classCallCheck(this, QpPreviewController);

    this.writeNote = false;
    this.scope = $scope;
    this.state = $state;
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var academics = localStorageService.get('authoringData');
    if (academics === undefined) $state.go('dashboard');
    var userId = localStorageService.get('user_id');

    //String - Activity id
    //$scope.qpId = $state.params.qpId
    var qpId = $state.params.qpId;

    //Boolean - Whether to show or hide close button
    $scope.isShowClose = localStorageService.get("isViewAllQuestion");

    //localStorageService.clear("isViewAllQuestion")

    //Boolean - To make activity password field visible
    $scope.isPassword = false;

    $scope.isCreator = false;
    $scope.isConducted = false;
    $scope.isLoading = true;

    var schoolId = academics.school_id;
    $scope.class = academics.class;
    $scope.curriculum = academics.curriculum;

    $scope.convertedURLAnswer = {};
    $scope.convertedURLQuestion = {};
    $scope.file_server_url = CONSTANTS.FILE_UPLOAD_URL;

    $scope.chartUrl = 'https://chart.googleapis.com/chart?cht=tx&chf=bg,s,FFFFFF00&chl=';
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    $scope.fileUrl = PREVIEW_URL;
    $scope.isViewMode = $scope.$parent.isViewMode;
    var fieldAlignment = function fieldAlignment(eachQues) {
        if (eachQues.questionImg && eachQues.questionImg.length) {
            convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.questionImg, function (base64Image) {
                $scope.imgurl2 = base64Image;
                eachQues.qn_img_url = $scope.imgurl2;
            });
        }
        if (eachQues.qn_img_array && eachQues.qn_img_array.length) {
            eachQues.qn_img_urlarray = [];
            _.each(eachQues.qn_img_array, function (eachQnImage) {
                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function (base64Image) {
                    eachQues.qn_img_urlarray.push(base64Image);
                });
            });
        }
        if (eachQues.choice && eachQues.choice.length > 0) {
            _.each(eachQues.choice, function (eachChoice) {
                eachChoice.opt_image_url = [];
                _.each(eachChoice.optImage, function (eachOptImage) {
                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function (base64Image) {
                        eachChoice.opt_image_url.push(base64Image);
                    });
                });
                _.each(eachChoice.opt_img, function (eachOptImage) {
                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function (base64Image) {
                        eachChoice.opt_image_url.push(base64Image);
                    });
                });
            });
        }
        if (eachQues.isLatex) {
            if (eachQues.optionQuestion && eachQues.optionQuestion.length && eachQues.optionAnswer && eachQues.optionAnswer.length) {
                _.each(eachQues.optionQuestion, function (ques) {
                    var latexValue = encodeURIComponent(ques.desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        ques.latexDesc = base64Image;
                    });
                });
                _.each(eachQues.optionAnswer, function (ans) {
                    var latexValue = encodeURIComponent(ans.desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        ans.latexDesc = base64Image;
                    });
                });
            } else {
                var latexValue = encodeURIComponent(eachQues.qn_desc);
                var urlsec = $scope.chartUrl + latexValue;
                getDataUri(urlsec, function (base64Image) {
                    eachQues.latexQues = base64Image;
                });
                _.each(eachQues.choice, function (eachQnchice, index) {
                    var latexValue = encodeURIComponent(eachQues.choice[index].desc);
                    var urlsec = $scope.chartUrl + latexValue;
                    getDataUri(urlsec, function (base64Image) {
                        eachQues.choice[index].latexDesc = base64Image;
                    });
                });
            }
        }
    };

    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activityList";
    });
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    if (qpId) {
        authService.callAPI(activityCons.API_ACTIVITY_PREVIEW + qpId, "POST", {}, function (response) {
            if (response.result && response.result.status && response.result.data.details && response.result.data.details.length > 0) {
                var result = response.result.data.details[0];
                console.log(result);
                $scope.allQuestions = result;
                $scope.qpDetails = result.qp_details[0];
                $scope.activityId = result.qp_details[0].activity_id;
                if ($scope.qpDetails.status === 'conducted' || $scope.qpDetails.status === 'published') $scope.isConducted = true;
                if ($scope.qpDetails.teacher_id === userId) $scope.isCreator = true;
                _.each($scope.allQuestions.sections, function (eachSection) {
                    _.each(eachSection.questions, function (eachQues) {

                        if (eachQues.type == 'passage') {
                            _.each(eachQues.questions, function (ibtQues) {
                                fieldAlignment(ibtQues);
                            });
                        } else {
                            fieldAlignment(eachQues);
                        }

                        if (eachQues.passage_image) {
                            convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.passage_image, function (base64Image) {
                                $scope.imgurl3 = base64Image;
                                eachQues.passage_image_url = $scope.imgurl3;
                                _.defer(function () {
                                    $scope.$apply();
                                });
                            });
                        }
                        if (eachQues.image) {
                            eachQues.passage_image_arrayUrl = [];
                            _.each(eachQues.image, function (eachQnImage) {
                                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function (base64Image) {
                                    eachQues.passage_image_arrayUrl.push(base64Image);
                                    _.defer(function () {
                                        $scope.$apply();
                                    });
                                });
                            });
                        }
                        if (eachQues.optionAnswer && eachQues.optionAnswer.length > 0) {
                            _.each(eachQues.optionAnswer, function (eachChoice, index) {
                                if (eachChoice.optImage) {
                                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.optImage, function (base64Image) {
                                        eachQues.optionAnswer[index].answerimage = base64Image;
                                        _.defer(function () {
                                            $scope.$apply();
                                        });
                                    });
                                }
                            });
                        }
                        if (eachQues.optionQuestion && eachQues.optionQuestion.length > 0) {
                            _.each(eachQues.optionQuestion, function (eachChoice, index) {
                                if (eachChoice.questionImg) {
                                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.questionImg, function (base64Image) {
                                        eachQues.optionQuestion[index].questionimage = base64Image;
                                        _.defer(function () {
                                            $scope.$apply();
                                        });
                                    });
                                }
                            });
                        }
                    });
                });
                $timeout(function () {
                    $scope.loadLatex();
                });
                $scope.isLoading = false;
                $scope.$apply();
            }
        });
    }

    $scope.gotoQpPreview = function () {
        if ($scope.isViewMode) {
            $state.go('activityFormPreview', {
                resourceId: $scope.activityId
            });
        } else {
            $state.go('formatQp', {
                resourceId: $scope.activityId
            });
        }
    };

    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.qpHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'subject': academics.subject,
                'class': academics.class
            };
            convertFileToDataURLviaFileReader($scope.qpHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        } else {
            //error
        }
    });

    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };

    $scope.convertURLTotrustUrl = function (url, index, type) {
        if (type == "question") {
            $scope.convertedURLQuestion[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
        } else if (type == 'answer') {
            $scope.convertedURLAnswer[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
        }
    };

    $scope.gotoSectionPage = function () {
        $state.go('formatQp', {
            resourceId: $scope.activityId
        });
    };
    $scope.teachingPlan = localStorageService.get("currentPlan");

    $scope.saveQuestionPaper = function () {
        var _academicDetails;

        $scope.resource = _.find($scope.teachingPlan.resources, function (res) {
            return res._id === $scope.activityId;
        });
        var academicDetails = (_academicDetails = {
            session_id: academics.session_id,
            curriculum_id: academics.curriculum_id,
            batch_id: academics.batch_id,
            class_id: academics.class_id,
            subject_id: academics.subject_id,
            school_id: academics.school_id,
            class: academics.class,
            batch: academics.batch,
            curriculum: academics.curriculum,
            subject: academics.subject
        }, _defineProperty(_academicDetails, "class", academics.class), _defineProperty(_academicDetails, "session", academics.session), _defineProperty(_academicDetails, "user_id", userId), _defineProperty(_academicDetails, "qp_id", qpId), _defineProperty(_academicDetails, "plan_id", $scope.teachingPlan._id), _defineProperty(_academicDetails, "activity_id", $scope.activityId), _defineProperty(_academicDetails, "practice_qn", $scope.resource.isPractice), _academicDetails);
        authService.callAPI(activityCons.API_SAVE_QP, "POST", academicDetails, function (response) {
            if (response.result && response.result.status) {
                toastr.success("Question Paper Saved Successfully");
                $rootScope.setStatus($scope.activityId, "created");
            }
        });
    };
    /*
     * Function To suffle match
     * @eachQues - MTF
     * @developer - Arul Mozhi J
     */
    $scope.suffleOptions = function (eachQues) {
        eachQues.choiceData = eachQues.option;
        var optionQuestion = [];
        var optionAnswer = [];
        _.each(eachQues.option, function (eachOption) {
            optionQuestion.push(eachOption.question);
            optionAnswer.push(eachOption.answer);
        });

        //To shuffle match the following answers
        optionAnswer = _.shuffle(optionAnswer);
        eachQues.optionQuestion = optionQuestion;
        eachQues.optionAnswer = optionAnswer;
    };
    $scope.addPassword = function () {
        $scope.isPassword = true;
    };

    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " _______ ");
    };

    $scope.closePasswordDiv = function () {
        $scope.isPassword = false;
    };

    /*
     * To set password to an activity
     * 
     *  @data : String - activity password
     * 
     * @return : null
     */
    $scope.saveActivityPassword = function (activityPassword) {
        if (activityPassword === "" || activityPassword === null || activityPassword === undefined) toastr.error("Please enter password");else {
            authService.callAPI(activityCons.API_SAVE_PASSWORD + qpId + '/' + userId + '/' + activityPassword, "POST", {}, function (response) {
                if (response.result && response.result.status) {
                    toastr.success("Activity password saved successfully");
                }
            });
            $scope.isPassword = false;
        }
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    function getDataUri(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    $scope.generatePdf = function () {
        var content = [];
        content.push({
            table: {
                widths: [70, '*', 70],
                body: [[{
                    width: 70,
                    height: 70,
                    image: $scope.imgurl1,
                    rowSpan: '3'
                }, {
                    text: $scope.qpHeader.schoolName,
                    style: 'title'
                }, {}], [{}, {
                    alignment: 'center',
                    text: $scope.qpDetails.question_paper_title
                }, {}], [{}, {
                    alignment: 'center',
                    text: $scope.qpHeader.subject
                }, {}]]
            },
            layout: 'noBorders'
        });
        content.push({
            canvas: [{
                type: 'line',
                x1: 0,
                y1: 10,
                x2: 520,
                y2: 10,
                lineWidth: 0.5
            }]
        });
        content.push("\n");
        var hour = 0;
        var min = 0;
        if ($scope.qpDetails.time.hour) hour = $scope.qpDetails.time.hour;
        if ($scope.qpDetails.time.min) min = $scope.qpDetails.time.min;
        content.push({
            columns: [{
                text: "Time : " + "  " + hour + " hour  " + min + " min"
            }, {
                text: "Curriculum/Class : " + "  " + $scope.curriculum + "/" + $scope.class
            }, {
                text: "Maximum Marks : " + "  " + $scope.qpDetails.total_mark
            }]
        });
        content.push({
            canvas: [{
                type: 'line',
                x1: 0,
                y1: 10,
                x2: 520,
                y2: 10,
                lineWidth: 0.5
            }]
        });
        var sections = angular.copy($scope.allQuestions.sections);
        _.each(sections, function (eachSection) {
            var quesNo = 1;
            content.push("\n");
            var policy = void 0;
            if (eachSection.qn_no === eachSection.mandatory_no) policy = "(Attend All)";else policy = "(Any " + eachSection.mandatory_no + ")";
            var ob = {
                columns: [{
                    text: eachSection.name + " " + policy,
                    alignment: 'center',
                    style: 'sectionTitle'
                }]
            };
            content.push(ob);
            var sectionInsPolicy = {
                columns: [{
                    text: eachSection.instruction + ":",
                    style: 'sectionTitle'
                }]
            };
            content.push(sectionInsPolicy);
            _.each(eachSection.questions, function (eachQues) {
                content.push("\n");
                var obj = void 0;
                var para = void 0;
                if (eachQues.type === "passage") {
                    var paragraphTitle = void 0;
                    if (!eachQues.isLatex) {
                        paragraphTitle = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.title ? eachQues.title : " ",
                            style: 'boldStyle'
                        }];
                    } else {
                        paragraphTitle = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.title ? eachQues.title : " ",
                            style: 'boldStyle'
                        }];
                    }
                    content.push({
                        columns: paragraphTitle
                    });
                    content.push("\n");

                    var paragraph = pdfForElement("<p>" + eachQues.desc + "</p>");
                    para = paragraph;
                    content.push(para);
                    content.push("\n");
                    if (eachQues.passage_image_arrayUrl) {
                        _.each(eachQues.passage_image_arrayUrl, function (eachQnImage) {
                            var imgObj = {
                                columns: [{
                                    alignment: 'left',
                                    width: 300,
                                    image: eachQnImage
                                }]

                            };
                            content.push(imgObj);
                            content.push("\n");
                        });
                    }
                    if (eachQues.passage_image_url) {
                        var imgObj = {
                            columns: [{
                                alignment: 'left',
                                width: 300,
                                image: eachQues.passage_image_url
                            }]
                        };

                        content.push(imgObj);
                    }
                    content.push("\n");
                    var ibtQuesNo = 1;
                    _.each(eachQues.questions, function (ibtQues) {
                        if (!ibtQues.isLatex) {
                            if (ibtQues.type === "FIB") {
                                ibtQues.qn_desc = $scope.beautifyFIB(ibtQues.qn_desc);
                            }

                            obj = [{
                                width: '*',
                                alignment: "left",
                                text: quesNo + "." + ibtQuesNo + ". " + ibtQues.qn_desc
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + ibtQues.mark + ")"
                            }];
                        } else {
                            obj = [{
                                width: '*',
                                alignment: "left",
                                text: quesNo + "." + ibtQuesNo + ". " + ibtQues.latexQues
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + ibtQues.mark + ")"
                            }];
                        }
                        content.push(obj);
                        if (ibtQues.qn_img_url) {
                            var _imgObj = {
                                columns: [{
                                    alignment: 'left',
                                    width: 300,
                                    image: ibtQues.qn_img_url
                                }]
                            };
                            content.push(_imgObj);
                            content.push("\n");
                        }
                        if (ibtQues.qn_img_urlarray) {
                            _.each(ibtQues.qn_img_urlarray, function (eachQnImage) {
                                var imgObj = {
                                    columns: [{
                                        alignment: 'left',
                                        width: 300,
                                        image: eachQnImage
                                    }]
                                };
                                content.push(imgObj);
                                content.push("\n");
                            });
                        }
                        if (ibtQues.type === "MCQ") {
                            var ch = [];
                            _.each(ibtQues.choice, function (eachChoice) {
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + eachChoice.tag + ")  " + eachChoice.desc;
                                    content.push({
                                        text: choice
                                    });
                                    content.push("\n");
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function (eachImage) {
                                            var imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            };
                                            content.push(imgObj);
                                            content.push("\n");
                                        });
                                    }
                                } else {
                                    var _choice = "(" + eachChoice.tag + ")  ";
                                    var choiceLatex = [{
                                        text: _choice
                                    }, {
                                        image: eachChoice.latexDesc
                                    }];
                                    content.push(choiceLatex);
                                    content.push("\n");
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function (eachImage) {
                                            var imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            };
                                            content.push(imgObj);
                                            content.push("\n");
                                        });
                                    }
                                }
                            });
                        }

                        /************** LINK QUESTION TO PASSAGE : START - Added by Arul Mozhi J  ****************/
                        if (ibtQues.type === "MTF") {
                            var ch1 = [];
                            _.each(ibtQues.optionQuestion, function (optionQues) {
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + optionQues.tag + ")  " + optionQues.desc;
                                    var chContent = [];
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }]);
                                    }
                                    ch1.push(chContent);
                                } else {
                                    var _choice2 = "(" + optionQues.tag + ")  ";
                                    var _chContent = [];
                                    _chContent.push([{
                                        text: _choice2,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionQues.latexDesc) {
                                        _chContent.push([{
                                            /*text: choice,*/
                                            image: optionQues.latexDesc,
                                            border: [false, false, false, false]
                                        }]);
                                    }
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        _chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }]);
                                    }
                                    ch1.push(_chContent);
                                }
                            });
                            var ch2 = []; // answerimage   questionimage
                            _.each(ibtQues.optionAnswer, function (optionAns, ansIndex) {
                                var choicesl = ansIndex + 1;
                                if (!ibtQues.isLatex) {
                                    var choice = "(" + choicesl + ")  " + optionAns.desc;
                                    var chContent = [];
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }]);
                                    }
                                    ch2.push(chContent);
                                } else {
                                    var _choice3 = "(" + choicesl + ")  ";
                                    var _chContent2 = [];
                                    _chContent2.push([{
                                        text: _choice3,
                                        border: [false, false, false, false]
                                    }]);
                                    if (optionAns.latexDesc) {
                                        _chContent2.push([{
                                            image: optionAns.latexDesc,
                                            border: [false, false, false, false]
                                        }]);
                                    }
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        _chContent2.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }]);
                                    }
                                    ch2.push(_chContent2);
                                }
                            });
                            content.push({
                                table: {
                                    widths: ['*', '*', 90],
                                    body: [[{
                                        text: "Question"
                                    }, {
                                        text: "Option"
                                    }, {
                                        text: "Answer"
                                    }]]

                                }
                            });

                            for (i = 0; i < ch1.length; i++) {
                                var tableContent = [];
                                tableContent.push({
                                    table: {
                                        body: ch1[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({
                                    table: {
                                        body: ch2[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({});
                                content.push({
                                    table: {
                                        widths: ['*', '*', 90],
                                        body: [tableContent]
                                    }
                                });
                            }
                        }
                        if (ibtQues.type === "TF") {
                            var _ch = [];
                            _ch.push({
                                text: "(A) True"
                            });
                            _ch.push({
                                text: "(B) False"
                            });

                            content.push({
                                columns: _ch
                            });
                        }
                        /************** LINK QUESTION TO PASSAGE : END - Added by Arul Mozhi J  ****************/
                        ibtQuesNo = ibtQuesNo + 1;
                    });
                } else if (eachQues.type === "ASLLISTEN") {
                    obj = [{
                        width: 'auto',
                        alignment: "left",
                        text: quesNo + "."
                    }, {
                        width: 500,
                        text: eachQues.qn_desc + "(ASL)"
                    }, {
                        width: 'auto',
                        alignment: "right",
                        text: "(" + eachQues.mark + ")"
                    }];
                } else if (eachQues.type === "ASLSPEAK") {
                    obj = [{
                        width: 'auto',
                        alignment: "left",
                        text: quesNo + "."
                    }, {
                        width: 500,
                        text: eachQues.qn_desc + "(ASL)"
                    }, {
                        width: 'auto',
                        alignment: "right",
                        text: "(" + eachQues.mark + ")"
                    }];
                } else {
                    if (eachQues.type === "FIB") {
                        eachQues.qn_desc = $scope.beautifyFIB(eachQues.qn_desc);
                    }
                    if (!eachQues.isLatex) {
                        obj = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, {
                            width: 500,
                            text: eachQues.qn_desc ? eachQues.qn_desc : " "
                        }, {
                            width: 'auto',
                            alignment: "right",
                            text: "(" + eachQues.mark + ")"
                        }];
                    } else {
                        var headObj = eachQues.latexQues ? {
                            alignment: 'left',
                            image: eachQues.latexQues
                        } : {
                            width: 500,
                            text: eachQues.qn_desc ? eachQues.qn_desc : " "
                        };
                        obj = [{
                            width: 'auto',
                            alignment: "left",
                            text: quesNo + "."
                        }, headObj, {
                            width: 'auto',
                            alignment: "right",
                            text: "(" + eachQues.mark + ")"
                        }];
                    }
                }
                content.push({
                    columns: obj
                });
                if (eachQues.qn_img_url) {
                    var _imgObj2 = {
                        columns: [{
                            alignment: 'left',
                            width: 300,
                            image: eachQues.qn_img_url
                        }]
                    };
                    content.push(_imgObj2);
                    content.push("\n");
                }
                if (eachQues.qn_img_urlarray) {
                    _.each(eachQues.qn_img_urlarray, function (eachQnImage) {
                        var imgObj = {
                            columns: [{
                                alignment: 'left',
                                width: 300,
                                image: eachQnImage
                            }]

                        };
                        content.push(imgObj);
                        content.push("\n");
                    });
                }

                if (eachQues.type === "MCQ" || eachQues.type === "IBT_MCQ") {

                    var ch = [];
                    _.each(eachQues.choice, function (eachChoice) {
                        if (!eachQues.isLatex) {
                            var choice = "(" + eachChoice.tag + ")  " + eachChoice.desc;
                            content.push({
                                text: choice
                            });
                            content.push("\n");
                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                _.each(eachChoice.opt_image_url, function (eachImage) {
                                    var imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: eachImage
                                        }]

                                    };
                                    content.push(imgObj);
                                    content.push("\n");
                                });
                            }
                        } else {
                            var _choice4 = "(" + eachChoice.tag + ")  ";
                            var choiceLatex = [{
                                text: _choice4
                            }, {
                                image: eachChoice.latexDesc
                            }];
                            content.push(choiceLatex);
                            content.push("\n");
                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                _.each(eachChoice.opt_image_url, function (eachImage) {
                                    var imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: eachImage
                                        }]

                                    };
                                    content.push(imgObj);
                                    content.push("\n");
                                });
                            }
                        }
                    });
                }
                if (eachQues.type === "MTF") {
                    var ch1 = [];
                    _.each(eachQues.optionQuestion, function (optionQues) {
                        if (!eachQues.isLatex) {
                            var choice = "(" + optionQues.tag + ")  " + optionQues.desc;
                            // ch1.push([{ text: choice,border: [false, false, false, false] }])
                            // let imgObj = {
                            //     border: [false, false, false, false],
                            //     alignment: 'left',
                            //     width: 100,
                            //     image: optionQues.questionimage
                            // }
                            var chContent = [];
                            chContent.push([{
                                text: choice,
                                border: [false, false, false, false]
                            }]);
                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                chContent.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionQues.questionimage
                                }]);
                            }
                            ch1.push(chContent);
                        } else {
                            var _choice5 = "(" + optionQues.tag + ")  ";
                            var _chContent3 = [];
                            _chContent3.push([{
                                text: _choice5,
                                border: [false, false, false, false]
                            }]);
                            if (optionQues.latexDesc) {
                                _chContent3.push([{
                                    /*text: choice,*/
                                    image: optionQues.latexDesc,
                                    border: [false, false, false, false]
                                }]);
                            }
                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                _chContent3.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionQues.questionimage
                                }]);
                            }
                            ch1.push(_chContent3);
                        }
                    });
                    var ch2 = []; // answerimage   questionimage
                    _.each(eachQues.optionAnswer, function (optionAns, ansIndex) {
                        var choicesl = ansIndex + 1;
                        if (!eachQues.isLatex) {
                            var choice = "(" + choicesl + ")  " + optionAns.desc;
                            var chContent = [];
                            chContent.push([{
                                text: choice,
                                border: [false, false, false, false]
                            }]);
                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                chContent.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionAns.answerimage
                                }]);
                            }
                            ch2.push(chContent);
                        } else {
                            var _choice6 = "(" + choicesl + ")  ";
                            var _chContent4 = [];
                            _chContent4.push([{
                                text: _choice6,
                                border: [false, false, false, false]
                            }]);
                            if (optionAns.latexDesc) {
                                _chContent4.push([{
                                    image: optionAns.latexDesc,
                                    border: [false, false, false, false]
                                }]);
                            }
                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                _chContent4.push([{
                                    border: [false, false, false, false],
                                    alignment: 'left',
                                    width: 100,
                                    height: 100,
                                    image: optionAns.answerimage
                                }]);
                            }
                            ch2.push(_chContent4);
                        }
                    });
                    content.push({
                        table: {
                            widths: ['*', '*', 90],
                            body: [[{
                                text: "Question"
                            }, {
                                text: "Option"
                            }, {
                                text: "Answer"
                            }]]

                        }
                    });

                    for (var i = 0; i < ch1.length; i++) {
                        var tableContent = [];
                        tableContent.push({
                            table: {
                                body: ch1[i],
                                layout: 'noBorders'
                            }
                        });
                        tableContent.push({
                            table: {
                                body: ch2[i],
                                layout: 'noBorders'
                            }
                        });
                        tableContent.push({});
                        content.push({
                            table: {
                                widths: ['*', '*', 90],
                                body: [tableContent]
                            }
                        });
                    }
                }
                if (eachQues.type === "TF") {
                    var _ch2 = [];
                    _ch2.push({
                        text: "(A) True"
                    });
                    _ch2.push({
                        text: "(B) False"
                    });

                    content.push({
                        columns: _ch2
                    });
                }
                if (eachQues.type === "ASLLISTEN") {
                    _.each(eachQues.questions, function (ques, index) {
                        var quesData = [{
                            width: 10,
                            text: ""
                        }, {
                            width: "auto",
                            alignment: "left",
                            text: index + 1
                        }, {
                            width: 500,
                            text: ques.qn_desc
                        }];
                        content.push({
                            columns: quesData
                        });
                        if (ques.type === "mcq") {
                            var _ch3 = [];
                            _.each(ques.choice, function (eachChoice) {
                                if (ques.isLatex) {
                                    var choice = "(" + eachChoice.tag + ")" + eachChoice.desc;
                                    _ch3.push({
                                        text: choice
                                    });
                                } else {
                                    var _choice7 = "(" + eachChoice.tag + ")  ";
                                    _ch3.push({
                                        text: _choice7
                                    });
                                    _ch3.push({
                                        image: eachChoice.latexDesc
                                    });
                                }
                            });
                            content.push({
                                columns: _ch3
                            });
                        } else if (ques.type === "tf") {
                            var _ch4 = [];
                            _ch4.push({
                                text: "(A) True"
                            });
                            _ch4.push({
                                text: "(B) False"
                            });

                            content.push({
                                columns: _ch4
                            });
                        }
                    });
                }
                quesNo++;
            });
            content.push({
                canvas: [{
                    type: 'line',
                    x1: 0,
                    y1: 10,
                    x2: 520,
                    y2: 10,
                    lineWidth: 0.5
                }]
            });
        });

        var font = $scope.qpHeader.subject == 'Malayalam' ? 'Rachana' : $scope.qpHeader.subject == 'Hindi' ? 'Kruti' : 'Roboto';

        var docDefinition = {
            info: {
                title: $scope.allQuestions.title
            },
            content: content,
            styles: {
                title: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'center'
                },
                sectionTitle: {
                    bold: true,
                    italics: true
                },
                boldStyle: {
                    bold: true
                }
            },
            defaultStyle: {
                font: font
            }
        };
        pdfMake.createPdf(docDefinition).open();
    };
    /*
     * Function check whether it is array or not
     * @obj - Object/Array to check
     */
    $scope.isArray = function (obj) {
        return Array.isArray(obj);
    };
    function showMetadataPopUp(metadata, question) {
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'metadata', 'question', questionMetadataTpCtrl],
            locals: {
                "metadata": metadata,
                question: question

            },
            template: _questionMetaData2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: true
            // fullscreen: useFullScreen
        });
    }
    $scope.getmetadata = function (oneQuestion) {
        console.log(oneQuestion);
        var obj = {
            "args": {
                "qpId": qpId,
                "question_id": oneQuestion._id,
                "school_id": localStorageService.get('school_id'),
                "user_id": userId,
                "teacher_id": userId
            }
        };

        authService.callAPI("/v0/get-question/metadata", "POST", obj, function (response) {
            if (response.result && response.result.status) {
                try {
                    showMetadataPopUp(response.result.data, oneQuestion);
                } catch (e) {
                    console.log(e);
                }
            }
        });
    };
}];

exports.default = QpPreviewController;

var pdfForElement = function pdfForElement(htmlTextInput) {

    //Parse inner elements
    function ParseContainer(cnt, e, p, styles) {
        var elements = [];
        var children = e.childNodes;
        if (children.length != 0) {
            for (var i = 0; i < children.length; i++) {
                p = ParseElement(elements, children[i], p, styles);
            }
        }
        if (elements.length != 0) {
            for (var i = 0; i < elements.length; i++) {
                cnt.push(elements[i]);
            }
        }
        return p;
    }

    //Convert styles to pdfmake JSON
    function ComputeStyle(o, styles) {
        for (var i = 0; i < styles.length; i++) {
            styles[i] = styles[i].replace();
            var st = styles[i].trim().toLowerCase().split(":");
            if (st.length == 2) {
                st[0] = st[0].trim();
                st[1] = st[1].trim();
                switch (st[0]) {
                    case "font-size":
                        {
                            o.fontSize = parseInt(st[1]);
                            break;
                        }
                    case "text-align":
                        {
                            switch (st[1]) {
                                case "right":
                                    o.alignment = 'right';
                                    break;
                                case "center":
                                    o.alignment = 'center';
                                    break;
                            }
                            break;
                        }
                    case "font-weight":
                        {
                            switch (st[1]) {
                                case "bold":
                                    o.bold = true;
                                    break;
                            }
                            break;
                        }
                    case "text-decoration":
                        {
                            switch (st[1]) {
                                case "line-through":
                                    o.decoration = "lineThrough";
                                    break;
                                case "underline":
                                    o.decoration = "underline";
                                    break;
                            }
                            break;
                        }
                    case "font-style":
                        {
                            switch (st[1]) {
                                case "italic":
                                    o.italics = true;
                                    break;
                            }
                            break;
                        }
                }
            }
        }
    }

    //Parse each element
    function ParseElement(cnt, e, p, styles) {
        if (!styles) {
            styles = [];
        }
        //If styles in the element
        if (e.getAttribute) {
            var nodeStyle = e.getAttribute("style");
            if (nodeStyle) {
                var ns = nodeStyle.split(";");
                for (var k = 0; k < ns.length; k++) {
                    if (ns[k]) {
                        styles.push(ns[k]);
                    }
                }
            }
        }
        switch (e.nodeName.toLowerCase()) {
            case "#text":
                {
                    var t = {
                        text: e.textContent.replace(/\n/g, "")
                    };
                    if (styles) {
                        ComputeStyle(t, styles);
                    }
                    if (p.text) {
                        p.text.push(t);
                    } else if (p.ul) {
                        p.ul.push(t);
                    } else if (p.ol) {
                        p.ol.push(t);
                    }
                    break;
                }
            case "b":
            case "strong":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-weight:bold"]));
                    break;
                }
            case "strike":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:line-through"]));
                    break;
                }
            case "u":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:underline"]));
                    break;
                }
            case "i":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-style:italic"]));
                    break;
                }
            case "span":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            case "br":
                {
                    p = CreateParagraph();
                    var t = {
                        text: "\n"
                    };
                    p.text.push(t);
                    cnt.push(p);
                    break;
                }
            case "blackquote":
            case "div":
            case "p":
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p, styles);
                    cnt.push(p);
                    break;
                }
            case "ul":
                {
                    ul = createList("ul");
                    ParseContainer(cnt, e, ul, styles);
                    cnt.push(ul);
                    break;
                }
            case "ol":
                {
                    ol = createList("ol");
                    ParseContainer(cnt, e, ol, styles);
                    cnt.push(ol);
                    break;
                }
            case "li":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            default:
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p);
                    cnt.push(p);
                    break;
                }
        }
        return p;
    }

    //Create pragragh content in pdfmake
    function CreateParagraph() {
        var p = {
            text: []
        };
        return p;
    }

    //Create pragragh content in pdfmake
    function createList(type) {
        if (type === "ol") {
            var list = {
                ol: []
            };
            return list;
        }
        if (type === "ul") {
            var list = {
                ul: []
            };
            return list;
        }
    }

    //Parse HTML input and convert to JSON
    function ParseHtml(cnt, htmlText) {
        var html = $(htmlText.replace(/\t/g, "").replace(/\n/g, ""));
        var p = CreateParagraph();
        for (var i = 0; i < html.length; i++) {
            ParseElement(cnt, html.get(i), p);
        }
    }
    var content = [];
    ParseHtml(content, htmlTextInput);
    return content;
};

var questionMetadataTpCtrl = function questionMetadataTpCtrl($scope, $mdDialog, metadata, question) {
    _classCallCheck(this, questionMetadataTpCtrl);

    metadata['qn_desc'] = question.qn_desc;
    metadata['type'] = question.type;

    $scope.metadata = metadata;
    $scope.hide = function () {
        $mdDialog.hide();
    };

    $scope.cancel = function () {
        $mdDialog.cancel();
    };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports = "<style>.md-datepicker-input-mask{display:none}.tp-status{margin:5px 10px;height:30px;text-align:center;padding-top:2px;padding-right:10px;padding-left:10px;padding-bottom:24px}.wizard-add-date{width:18%;background:#fff;position:absolute;font-size:15px;top:190px;right:707px;z-index:50;padding-top:5px;padding-left:25px;padding-bottom:0}.height-full{color:#333}</style> <div class=activity-preview ng-show=activityUserPrivilege.approveQuestionPaper.create||activityUserPrivilege.createQuestion.create> <div flex class=previewOutline ng-show=!questionList.status layout-align=\"center center\"> <label flex=50 class=no-data-msg>No Activity Available... To add Activity go to Edit mode </label> </div> <div class=md-whiteframe-2dp layout=column ng-show=questionList.status> <div layout=row> <div layout=row style=margin:10px> <md-button md-no-ink class=\"md-whiteframe-3dp md-primary addToQues auto-btn action-btn-clr\" layout=row ng-click=routeToQpPreview()>View Question Paper </md-button> <md-button md-no-ink class=\"md-primary addToQues auto-btn action-btn-clr\" layout=row ng-show=\"isSchedule && activityUserPrivilege.conductingActivity && activityUserPrivilege.conductingActivity.create&&!questionList.isPractice&&isUserAssigned&&isCreator\" ng-click=setScheduleDate()>Schedule </md-button> <md-button md-no-ink class=\"md-primary addToQues auto-btn action-btn-clr\" layout=row ng-show=\"isReschedule && activityUserPrivilege.conductingActivity && activityUserPrivilege.conductingActivity.create&&!questionList.isPractice&&isUserAssigned&&isCreator\" ng-click=setScheduleDate()>Reschedule </md-button> <md-button md-no-ink ng-show=\"isStart && activityUserPrivilege.conductingActivity && activityUserPrivilege.conductingActivity.create&&!questionList.isPractice&&isUserAssigned && isCreator\" class=\"md-primary addToQues auto-btn action-btn-clr\" layout=row ng-click=conductTest()>Start Now </md-button> <md-button md-no-ink ng-show=\"activityUserPrivilege.createQuestion.create && isViewSubmission && isCreator && !isCompleted && isCreator && !questionList.isPractice\" class=\"md-primary addToQues auto-btn action-btn-clr\" layout=row ng-click=stopExam()>Stop Now </md-button> <md-button md-no-ink class=\"md-primary addToQues action-btn-clr\" ng-show=\"activityUserPrivilege.createQuestion.create && isViewSubmission && isCreator && !questionList.isPractice\" layout=row ng-click=gotoSubmissionList()>View Attendee </md-button> <md-button md-no-ink class=\"md-primary addToQues auto-btn action-btn-clr\" ng-show=\"isPublishResult && activityUserPrivilege.publishResult && activityUserPrivilege.publishResult.create &&!questionList.isPractice && isCreator && isCompleted\" layout=row ng-click=gotoPublish()>Publish Result </md-button> <md-button md-no-ink class=\"md-primary md-whiteframe-2dp\" style=cursor:auto layout=row ng-show=isPublished>Published </md-button> </div> </div> <div layout=column> <div class=qp-template-preview style=margin:10px> <div layout=column> <div class=qp-details-border> <div layout=row> <div flex=10 class=qp-details-odd>Exam Title</div> <div flex=90 class=qp-details-odd>{{qpTemplatePreview.template.title}}</div> </div> <div layout=row> <div flex=35 class=qp-details-even ng-show=\"qpTemplatePreview.template.date && !questionList.isPractice\">Date: {{qpTemplatePreview.template.date | date: \"dd.MM.y\"}}</div> <div flex=35 class=qp-details-even ng-show=\"!qpTemplatePreview.template.date && !questionList.isPractice\">Date: Not Scheduled</div> <div flex=40 class=qp-details-even ng-if=!questionList.isPractice>Duration: {{qpTemplatePreview.template.duration}}</div> <div flex class=qp-details-even>Total Marks : {{qpTemplatePreview.template.total_mark}}</div> </div> </div> <div class=qp-summary-border> <div layout=row> <div flex class=qp-summary-title>Question Pattern Summary</div> </div> <div layout=row class=qp-summary-label> <div flex=10 class=qp-summary-padding>Section</div> <div flex=10 class=qp-summary-padding>Compulsory / Total Question</div> <div flex layout=column> <div layout=row flex> <div flex class=qp-summary-padding>Theme included in this section</div> <div flex=45 class=qp-summary-padding>Strands included</div> <div flex=20 class=qp-summary-padding ng-show=!isPractice>Mark per Theme</div> </div> </div> <div flex=10 class=qp-summary-label ng-show=!isPractice>Mark per Section</div> </div> <div layout=row ng-repeat=\"section in qpTemplatePreview.template.sections\" class=qp-summary-value> <div flex=10 class=qp-summary-padding>{{section.name}}</div> <div flex=10 class=qp-summary-padding>{{section.cumpulsoryQuestion}}/{{section.totalQuestion}}</div> <div flex layout=column> <div layout=row class=height-full ng-repeat=\"theme in section.themes\"> <div flex class=qp-summary-padding>{{theme.name}}</div> <div flex=45 class=qp-summary-padding>{{theme.strands}}</div> <div flex=20 class=qp-summary-padding ng-show=!isPractice>{{theme.marks}}</div> </div> </div> <div flex=10 class=qp-summary-padding ng-show=!isPractice>{{section.totalmark}}</div> </div> </div> <div class=wave-summary-border ng-show=!qpTemplatePreview.userType.isStudent> <div layout=row> <div flex class=wave-summary-title>Wave Summary</div> </div> <div layout=row class=wave-summary-label> <div flex=10 class=wave-summary-padding>Section</div> <div layout=column flex> <div layout=row flex> <div flex=50 class=wave-summary-padding>Theme included in this section</div> <div layout=column flex> <div flex class=wave-summary-padding>Wave</div> <div layout=row> <div flex=25 class=wave-summary-padding>Wave 1</div> <div flex=25 class=wave-summary-padding>Wave 2</div> <div flex=25 class=wave-summary-padding>Wave 3</div> <div flex class=wave-summary-padding>Wave 4(G & T)</div> </div> </div> </div> </div> </div> <div layout=row ng-repeat=\"section in qpTemplatePreview.template.sections\" class=wave-summary-value> <div flex=10 class=wave-summary-padding>{{section.name}}</div> <div layout=column flex> <div layout=row class=height-full ng-repeat=\"theme in section.themes\"> <div flex=50 class=wave-summary-padding>{{theme.name}}</div> <div layout=row flex> <div flex=25 class=wave-summary-padding>{{theme.wave1Percent}}</div> <div flex=25 class=wave-summary-padding>{{theme.wave2Percent}}</div> <div flex=25 class=wave-summary-padding>{{theme.wave3Percent}}</div> <div flex class=wave-summary-padding>{{theme.wave4Percent}}</div> </div> </div> </div> </div> </div> <div class=level-summary-border> <div layout=row> <div flex class=level-summary-title>Difficulty Summary</div> </div> <div layout=row class=level-summary-label> <div flex=10 class=level-summary-padding>Section</div> <div layout=column flex> <div layout=row flex> <div flex=50 class=level-summary-padding>Theme included in this section</div> <div layout=column flex> <div flex class=level-summary-padding>Level</div> <div layout=row> <div flex=30 class=level-summary-padding>Level 1(Easy)</div> <div flex=30 class=level-summary-padding>Level 2(Medium)</div> <div flex class=level-summary-padding>Level 3(Difficult)</div> </div> </div> </div> </div> </div> <div layout=row ng-repeat=\"section in qpTemplatePreview.template.sections\" class=level-summary-value> <div flex=10 class=level-summary-padding>{{section.name}}</div> <div layout=column flex> <div layout=row class=height-full ng-repeat=\"theme in section.themes\"> <div flex=50 class=level-summary-padding>{{theme.name}}</div> <div layout=row flex> <div flex=30 class=level-summary-padding>{{theme.level1Percent}}</div> <div flex=30 class=level-summary-padding>{{theme.level2Percent}}</div> <div flex class=level-summary-padding>{{theme.level3Percent}}</div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"margin_20 student-summary\" flex layout=column ng-show=\"activityUserPrivilege.attendExam && activityUserPrivilege.attendExam.read\" ng-cloak> <div class=\"md-accordion-mark md-whiteframe-3dp\"> <div class=md-whiteframe-1dp flex layout=row layout-align-gt-xs=\"space-between center\"> <div layout-gt-xs=row layout=column flex layout-align=\"space-around start\" layout-align-gt-xs=\"space-between center\"> <div layout=row layout-align=\"space-between center\"> <div layout=row ng-show=\"isActivityPassword && studentStatus !== 'submitted' && studentStatus !== 'published' && studentStatus == 'not attended' && questionList.status == 'conducted'\"> <div class=lock-icon><i class=\"fas fa-lock\" style=padding:10px;margin-top:26px;color:#e69500></i></div> <div class=password-div layout=column> <md-input-container> <label>Enter Activity Password</label> <input type=Password ng-model=activityPassword /> <p class=errorMessage>{{errors['activityPassword']}}</p> </md-input-container> </div> </div> <md-button class=\"md-primary addToQues auto-btn action-btn-clr\" ng-show=\"studentStatus == 'attending' && !questionList.isPractice\" ng-click=startTest(questionList) style=color:#fff>Start Again</md-button> <md-button class=\"md-primary addToQues auto-btn action-btn-clr\" ng-show=\"(studentStatus == 'not attended' && !studentBackFromExam && questionList.status == 'conducted')||questionList.isPractice\" ng-click=startTest(questionList) style=color:#fff>Start Now</md-button> <md-button class=\"md-primary addToQues auto-btn action-btn-clr\" ng-show=\"(studentStatus == 'submitted' && !questionList.isPractice && questionList.status == 'published') || (activityAttended && questionList.isPractice )\" ng-click=viewMyAnswer(questionList) style=color:#fff>View My Answer</md-button> </div> </div> </div> <div layout=column flex=100 class=\"activity-preview qp-template-preview\"> <div class=qp-details-border> <div layout=row> <div flex=10 class=qp-details-odd>Exam Title</div> <div flex=90 class=qp-details-odd>{{qpTemplatePreview.template.title}}</div> </div> <div layout=row> <div flex=35 class=qp-details-even ng-show=\"qpTemplatePreview.template.date && !questionList.isPractice\">Date: {{qpTemplatePreview.template.date | date: \"dd.MM.y\"}}</div> <div flex=35 class=qp-details-even ng-hide=\"qpTemplatePreview.template.date  && !questionList.isPractice\">Date: Not Scheduled</div> <div flex=40 class=qp-details-even ng-if=!questionList.isPractice>Duration: {{qpTemplatePreview.template.duration}}</div> <div flex class=qp-details-even>Total Marks : {{qpTemplatePreview.template.total_mark}}</div> </div> </div> <div class=qp-summary-border> <div layout=row> <div flex class=qp-summary-title>Question Pattern Summary</div> </div> <div layout=row class=qp-summary-label> <div flex=10 class=qp-summary-padding>Section</div> <div flex=10 class=qp-summary-padding>Compulsory / Total Question</div> <div flex layout=column> <div layout=row flex> <div flex class=qp-summary-padding>Theme included in this section</div> <div flex=45 class=qp-summary-padding>Strands included</div> <div flex=20 class=qp-summary-padding ng-show=!isPractice>Mark per Theme</div> </div> </div> <div flex=10 class=qp-summary-label ng-show=!isPractice>Mark per Section</div> </div> <div layout=row ng-repeat=\"section in qpTemplatePreview.template.sections\" class=qp-summary-value> <div flex=10 class=qp-summary-padding>{{section.name}}</div> <div flex=10 class=qp-summary-padding>{{section.cumpulsoryQuestion}}/{{section.totalQuestion}}</div> <div flex layout=column> <div layout=row class=height-full ng-repeat=\"theme in section.themes\"> <div flex class=qp-summary-padding>{{theme.name}}</div> <div flex=45 class=qp-summary-padding>{{theme.strands}}</div> <div flex=20 class=qp-summary-padding ng-show=!isPractice>{{theme.marks}}</div> </div> </div> <div flex=10 class=qp-summary-padding ng-show=!isPractice>{{section.totalmark}}</div> </div> </div> <div class=level-summary-border> <div layout=row> <div flex class=level-summary-title>Difficulty Summary</div> </div> <div layout=row class=level-summary-label> <div flex=10 class=level-summary-padding>Section</div> <div layout=column flex> <div layout=row flex> <div flex=50 class=level-summary-padding>Theme included in this section</div> <div layout=column flex> <div flex class=level-summary-padding>Level</div> <div layout=row> <div flex=30 class=level-summary-padding>Level 1</div> <div flex=30 class=level-summary-padding>Level 2</div> <div flex class=level-summary-padding>Level 3</div> </div> </div> </div> </div> </div> <div layout=row ng-repeat=\"section in qpTemplatePreview.template.sections\" class=level-summary-value> <div flex=10 class=level-summary-padding>{{section.name}}</div> <div layout=column flex> <div layout=row class=height-full ng-repeat=\"theme in section.themes\"> <div flex=50 class=level-summary-padding>{{theme.name}}</div> <div layout=row flex> <div flex=30 class=level-summary-padding>{{theme.level1Percent}}</div> <div flex=30 class=level-summary-padding>{{theme.level2Percent}}</div> <div flex class=level-summary-padding>{{theme.level3Percent}}</div> </div> </div> </div> </div> </div> </div> </div> </div>  <side-nav-bottom layout=row layout-padding flex></side-nav-bottom>  <div layout=row class=schedule layout-align=\"end end\" ng-show=isScheduleDate> <div class=\"md-whiteframe-5dp wizard-add-date\"> <div layout=row layout-align=\"end end\"> <div flex=20 class=close-button><img height=10 ng-click=closeDiv()></div> </div> <div layout=row layout-align=\"start start\"> <md-input-container class=\"md-block bkmarkinput\" flex-gt-sm> <label>Select Due date</label> <md-datepicker md-min-date=serverDate ng-model=dueDate ng-change=scheduleExam(dueDate) md-hide-icons=calendar></md-datepicker> </md-input-container> </div> </div> </div> ";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: qpSummaryPreview.js
 * Project: educore
 * Created Date: 2019-01-23
 * Author: Raziya S
 * Screen : 
 */
var QpSummaryPreviewController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "archiveService", "$timeout", "CONSTANTS", "TPWIZARDCONSTANT", function QpSummaryPreviewController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, archiveService, $timeout, CONSTANTS, TPWIZARDCONSTANT) {
    _classCallCheck(this, QpSummaryPreviewController);

    var noActvity = true;
    $scope.array = [];
    $scope.questionList = [];
    $scope.qpStatus = false;
    $scope.questionDetails = {};
    $scope.questions = [];
    $scope.score = 0;
    this.viewSubmission = true;
    $scope.isCreator = false;
    $scope.isUserAssigned = false;
    $scope.isSubmitApproval = false;
    $scope.enableStartNow = false;
    $scope.activityAttended = false;

    //Boolean - To check whether activity password is present or not
    $scope.isActivityPassword = false;

    $scope.total_mark = 0;
    var self = this;
    var activityId = $state.params.resourceId;
    var authoring = localStorageService.get('authoringData');
    var userId = localStorageService.get("user_id");
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        authService.callAPI(TPWIZARDCONSTANT.API_GET_QP_SUMMARY + activityId, "GET", undefined, function (response) {
            if (response.result != undefined) {
                loadTemplate(response.result);
            } else {
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
    };
    if (authoring) $scope.class = authoring.class;
    $scope.isApprover = false;
    self.date = '';
    $scope.questionPaper = {};
    var qpSub = undefined;

    var qpId = void 0;
    this.$onDestroy = function () {
        if (qpSub) qpSub.stop();
    };
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "activity";
    });
    console.log("userAccess");
    console.log(userAccess);
    $scope.activityUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (tpObj) {
            var user_access = {};
            _.each(tpObj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
        });
    }
    var loadTemplate = function loadTemplate(resultObj) {
        var result = undefined;
        if (resultObj.data && resultObj.data && resultObj.data.data && resultObj.data.data.template) {
            result = resultObj.data.data.template;

            $scope.serverDate = result.server_time;
            qpId = result.qp_id;
            if (result.teacher_id === userId) $scope.isCreator = true;
            //Object - Summary details of the activity
            $scope.qpTemplatePreview = {
                template: result
            };
            getQPDetails();
            if ($scope.$parent.isViewMode && !$scope.$parent.approveMode && !$scope.isCreator) loadActivityStatus();
            $scope.$apply();
        }
    };

    var getQPDetails = function getQPDetails() {
        authService.callAPI(activityCons.API_QP_DETAILS + qpId, "GET", {}, function (response) {
            if (response.result != undefined) {
                var result = response.result.data.details;
                $scope.activityId = result.activity_id;
                _.each(result.students, function (eachStud) {
                    if (eachStud._id === userId) {
                        if (eachStud.status === "not attended") {
                            // TO get activity password
                            $scope.enableStartNow = true;
                            if (result.activity_password && result.activity_password !== null && result.activity_password !== undefined && result.activity_password !== "") {
                                $scope.activityPwd = result.activity_password;
                                $scope.isActivityPassword = true;
                            }
                        }
                        $scope.studentStatus = eachStud.status;
                        $scope.resultStatus = eachStud.result;
                    }
                });
                if (result.students && result.students.length > 0) $scope.isUserAssigned = true;

                $scope.isStart = false;
                $scope.isSchedule = false;
                $scope.isReschedule = false;
                $scope.isViewSubmission = false;
                $scope.isPublishResult = false;
                $scope.isPublished = false;
                $scope.isCompleted = false;

                if (result.status == "approved") {
                    $scope.isSchedule = true;
                    $scope.isStart = true;
                } else if (result.status == "scheduled") {
                    $scope.isStart = true;
                    $scope.isReschedule = true;
                } else if (result.status == "conducted") {
                    $scope.isViewSubmission = true;
                    $scope.isPublishResult = true;
                    $scope.isCompleted = false;
                } else if (result.status == "published") {
                    $scope.isViewSubmission = true;
                    $scope.isCompleted = true;
                    $scope.isPublished = true;
                } else if (result.status == "completed") {
                    $scope.isCompleted = true;
                    $scope.isViewSubmission = true;
                    $scope.isPublishResult = true;
                } else if (result.status == "sent_for_approval") {
                    if (result.current_approver && result.current_approver._id) {
                        if (result.current_approver._id === userId) $scope.isApprover = true;
                    }
                }

                $scope.questionList = {
                    id: result.activity_id,
                    title: result.question_paper_title,
                    status: result.status,
                    isPractice: result.practice_qn
                };
                if (result.teacher_id === userId) $scope.isCreator = true;
                if ($scope.questionList.length === 0) {
                    noActvity = true;
                } else {
                    noActvity = false;
                }
                $scope.$apply();
            } else {
                console.log(response.error);
            }
        });
    };
    $scope.routeToQpPreview = function () {
        localStorageService.set("isViewAllQuestion", true);

        $state.go('tpActivityPreview', {
            "qpId": qpId
        });
    };
    /*
            $scope.gotoAssigningPage = () => {
                if ($scope.isUserAssigned) {
                    var confirm = $mdDialog.confirm()
                        .textContent('It will reassign previously assigned students')
                        .ok('Ok')
                        .cancel('Cancel');
                    $mdDialog.show(confirm).then(function() {
                        $state.go('assignStudents', {
                            qpId: $state.params.qpId,
                            previousState: {
                                state: 'qpSummary',
                                params: $stateParams
                            }
                        })
                    }, function() {});
                } else {
                    $state.go('assignStudents', {
                        qpId: $state.params.qpId,
                        previousState: {
                            state: 'qpSummary',
                            params: $stateParams
                        }
                    })
                }
            }*/

    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };
    $scope.viewMyAnswer = function (data) {
        if (data.status !== "published" && !data.isPractice) {
            alert = $mdDialog.alert({
                textContent: 'Result is not published',
                ok: 'Ok'
            });

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
            });
        } else {
            $state.go('studentAnswerPreview', {
                qpId: qpId
            });
        }
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }

    /* Set answered choice is wrong or correct*/
    /*    function setChoice() {
            _.each($scope.questions, function(section) {
                _.each(section.answers, function(data, key) {
                    $scope.total_mark += parseInt(data.mark)
                    let score = parseFloat(data.my_score)
                    $scope.score += score;
                    if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                        _.each(data.choice, function(choice) {
                            if ($scope.checkingChoiceExists(choice.desc, data)) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                }
                            }
                        })
                    } else if (data.type == 'TF') {
                        _.each(data.choice, function(choice) {
                            if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                if (!choice.correct) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            }
                        })
                    } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                        let key = 0
                        _.each(data.answer, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'OWQ') {
                        let key = 0
                        _.each(data.answer, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    choice.wrong = true
                                } else {
                                    choice.correct = true
                                }
                            } else {
                                choice.wrong = true
                                if (data.my_answer != undefined) {
                                    data.my_answer[key] = 'Not Answered'
                                } else {
                                    data.my_answer = []
                                    data.my_answer[key] = 'Not Answered'
                                }
                            }
                            key++
                        })
                    } else if (data.type == 'MTF') {
                        data.ans_key = []
                        let key = 0
                        _.each(data.option, function(choice) {
                            let correctAnswer = removeSpecialCharacter(choice.question.desc)
                            if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                let correct = false
                                let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                if (correctAnswer !== studentAnswer) {
                                    correct = false
                                } else {
                                    correct = true
                                }
                                data.ans_key.push({
                                    desc: data.my_answer[key].desc,
                                    correct: correct,
                                    optImage: data.my_answer[key].optImage
                                })
                            }
                            key++
                        })
                    } else if (data.type == 'ASLLISTEN') {
                        _.each(data.questions, function(aslListQues) {
                            if (aslListQues.type == 'mcq') {
                                _.each(aslListQues.choice, function(choice) {
                                    if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'tf') {
                                _.each(aslListQues.choice, function(choice) {
                                    if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                        if (!choice.correct) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'fib') {
                                _.each(aslListQues.answer, function(choice, index) {
                                    let correctAnswer = removeSpecialCharacter(choice.desc)
                                    if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                        let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                        if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                            choice.wrong = true
                                        } else {
                                            choice.correct = true
                                        }
                                    } else {
                                        choice.wrong = true
                                        if (aslListQues.my_answer != undefined) {
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        } else {
                                            aslListQues.my_answer = []
                                            aslListQues.my_answer[index] = 'Not Answered'
                                        }
                                    }
                                })
                            } else if (aslListQues.type == 'text') {
                                let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                if (aslListQues.my_answer != undefined) {
                                    let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        aslListQues.wrong = true
                                    } else {
                                        aslListQues.correct = true
                                    }
                                } else {
                                    aslListQues.wrong = true
                                    aslListQues.my_answer = 'Not Answered'
                                }
                            }
                        })
                    }
                 })
            })
         }*/

    //$scope.score = $scope.score.toFixed(2)
    /*$scope.cancel = function() {
        $mdDialog.hide();
    };*/
    /*$scope.setFilePath = function(img) {
        let new_url = img ? CONSTANTS.FILE_UPLOAD_URL + img : undefined
        return new_url
    }
    $scope.beautifyFIB = function(question) {
        return question.replace(/_/g, " (_______) ")
    }
    */
    /* Formating the date value to display format*/
    $scope.getDateInFormat = function () {
        var dateFormat = $filter('date')(assignedDate, "dd-MM-yyyy");
        if (dateFormat) {
            self.date = dateFormat;
        } else {
            self.date = "";
        }
    };

    $scope.startTest = function (data) {

        // Object - Holds validation errors
        $scope.errors = {};

        if ($scope.activityPassword === "") {
            $scope.errors['activityPassword'] = "Please enter password";
        } else if ($scope.activityPassword !== $scope.activityPwd) {
            $scope.errors['activityPassword'] = "Please enter correct password";
        } else if ($scope.activityPassword === $scope.activityPwd) {
            $scope.isActivityPassword = false;
            $state.go('questionDirective', {
                qpId: qpId,
                activityId: activityId
            });
        }
    };

    $scope.scheduleExam = function (dueDate) {
        $scope.qpTemplatePreview.template.date = $scope.dueDate;
        var obj = {
            dueDate: $scope.dueDate,
            qpId: qpId,
            userId: userId
        };
        authService.callAPI(activityCons.API_SCHEDULE_EXAM, "POST", obj, function (response) {
            if (response.result) {
                toastr.success("Activity scheduled Successfully");
                getQPDetails();
            } else {
                console.log("error : " + response.error);
                console.log(response.error);
            }
        });
        $scope.isScheduleDate = false;
        $scope.isSchedule = false;
        $scope.isStart = true;
        $scope.viewSubmission = false;
    };
    $scope.conductTest = function () {

        var reqObj = {
            activity_id: $scope.activityId,
            qp_id: qpId
        };
        authService.callAPI(activityCons.API_START_EXAM, "POST", reqObj, function (response) {
            if (response.result != undefined) {
                $scope.isScheduleDate = false;
                $scope.isSchedule = false;
                $scope.isStart = false;
                $scope.isViewSubmission = true;
                $scope.isPublished = false;
                $scope.isPublishResult = false;
                toastr.success("Exam started successfully");
                getQPDetails();
            } else {
                console.log(response.error);
            }
        });
    };
    /* $scope.filterPerson = () => {
         let approverList = _.filter($scope.approverRoles, function(person) {
             return person._id.indexOf($scope.approverRole) !== -1;
         })
         if (approverList && approverList.length > 0)
             $scope.approverRolePersons = approverList[0].users
     }*/

    $scope.gotoPublish = function () {
        authService.callAPI(activityCons.API_PUBLISH_RESULT + qpId + '/' + userId, "GET", {}, function (response) {
            if (response.result != undefined) {
                toastr.success('Result Published');
                $scope.isScheduleDate = false;
                $scope.isSchedule = false;
                $scope.isStart = false;
                $scope.isViewSubmission = true;
                $scope.isPublished = true;
                $scope.isPublishResult = false;
                getQPDetails();
            } else {
                console.log("error : " + response.error);
            }
        });
    };
    $scope.gotoSubmissionList = function () {

        $state.go("submissionList", {
            qpId: qpId
        });
    };
    $scope.closeDiv = function () {
        $scope.isScheduleDate = false;
    };
    $scope.setScheduleDate = function () {
        if ($scope.isUserAssigned) {
            $scope.isScheduleDate = true;
        } else {
            var confirm = $mdDialog.confirm().textContent('Please assign users').ok('Ok');
            $mdDialog.show(confirm).then(function () {
                $scope.isAssignUsers = true;
            }, function () {
                $scope.isAssignUsers = false;
            });
            $scope.isPrompt = true;
        }
    };

    function getTime(millseconds) {
        var oneSecond = 1000;
        var oneMinute = oneSecond * 60;
        var oneHour = oneMinute * 60;
        var oneDay = oneHour * 24;

        var seconds = Math.floor(millseconds % oneMinute / oneSecond);
        var minutes = Math.floor(millseconds % oneHour / oneMinute);
        var hours = Math.floor(millseconds % oneDay / oneHour);
        var days = Math.floor(millseconds / oneDay);

        var timeString = '';
        if (days !== 0) {
            timeString += days !== 1 ? days + ' days ' : days + ' day ';
        }
        if (hours !== 0) {
            timeString += hours !== 1 ? hours + ' hours ' : hours + ' hour ';
        }
        if (minutes !== 0) {
            timeString += minutes !== 1 ? minutes + ' min ' : minutes + ' min ';
        }
        if (seconds !== 0 || millseconds < 1000) {
            timeString += seconds !== 1 ? seconds + ' sec ' : seconds + ' sec ';
        }

        return timeString;
    }

    $scope.stopExam = function () {

        var reqObj = {
            activity_id: $scope.activityId,
            qp_id: qpId
        };

        authService.callAPI(activityCons.API_STOP_EXAM, "POST", reqObj, function (response) {
            if (response.result != undefined) {
                console.log("result : " + response.result);
                getQPDetails();
            } else {
                console.log("error : " + response.error);
            }
        });
    };
    $scope.viewReport = function () {
        $state.go('submissionList', {
            qpId: qpId
        });
    };
    var loadActivityStatus = function loadActivityStatus() {
        authService.callAPI(activityCons.API_GET_ANSWER_DETAILS + qpId + '/' + userId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.details) {
                console.log(response.result.data.details);
                $scope.activityAttended = true;
            } else {
                console.log("error : " + response.error);
            }
        });
    };
}];

exports.default = QpSummaryPreviewController;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div class=submission-list ng-show=!isLoading> <div layout=row> <div style=padding-left:0!important class=activity-title flex=95><b>{{questionPaper.question_paper_title}}</b></div> <div flex=5 layout=row layout-align=\"end start\"> <div class=marTop ng-click=gotoActivityPreview()> <div class=\"editIcon md-whiteframe-2dp\" tooltip=Close tooltip-position=down><i class=\"fas fa-times icon-img\"></i></div> </div> </div> </div> <table class=\"table-format md-whiteframe-3dp\"> <thead> <th>STUDENT NAME </th> <th style=padding-left:30px> STATUS </th> </thead> <tbody> <tr ng-repeat=\"studList in assignedUsers | orderBy:'name'\"> <td>{{studList.name}}</td> <td><span ng-show=\"studList.status === 'attending'\" class=icon-space1><img src=" + __webpack_require__(1361) + " width=20>Attending</span> <span ng-show=\"studList.status === 'not attended' || studList.status === 'absent'  \" class=.icon-space2> <img src=" + __webpack_require__(1362) + " width=40></span><span ng-show=\"studList.status === 'absent'\">Absent</span> <span ng-show=\"studList.status === 'submitted'\" class=icon-space1 ng-click=answerPreview(studList._id)><img src=" + __webpack_require__(1363) + " width=20><span> submitted </span></span> </td> </tr> </tbody> </table> </div> ";

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAADzUlEQVRIS62VW4hbVRSG/7VPTiaRFrRatKBgoepD8VIZr1XbKj6IndwwaZukpSDSWjJJR0VoQYiF0VIqTjJjlZYimDMZzYBNhqLiU9UWOgoVKpaqiA/6oKDYUiWT5GQt2ampk+b0TCLdb2df1rfXXv/6D8FhpK3g6yCKC1B3WneaIyI/gV/LxSsH5q+T/thZiCwTZd/WJMOjvxUkC8EhIv60VwCLek4Bq5pEb+kz1OQGszpDaSsYBtFhANd1kJU8mNtUme0VkLGCG4To/c79cpbSk6GfAFwLwjYG/a43GCKbGfB7YOzmZt1eCGJ7PT5PU8YE9C0TPm5lIHIHAaMaoAMczyfKa9uBRkpRP9frrwrRrSBqPaPrEBEBTo/Hy6MgiN67oxRd5Gk0TmlADYTZfLz82EJx+lnPFAM3sqjjPQGy2azKZrMcLUWNpYDfCbToQu1Sptf8fO/ff95+amlPgLQV3i5KVozHyy+lJwPrCGqLWyYCEqVkT40b5z0wv+zI4IWp4C0NIu/4xvKPOkjaCu0CEBQPEnpupBBYwYoeng8QUR01ImJRpvdovWqT8sjJDsDwVGAVsbIA2g1gDSAr50wzdjA2fV4HzRQDd4moZ7oyILT6pzVY2PZ6JwaAut1ozHbVQEMUq4NCOL1k2blt2XXHLsl0ZyG0lhUlOgAiP+ST5X2XQ3eUojcZjcYXjkXOlqLebGy6yya09My5uSUdwTxUy8Vnfrsc0JeK+pFne2/PgIvPIoP5RGV/yoqsVuANbkAiEUNhf5Xtv7pU9GJx6AajSrV9z85c0EGGpyJPk/BeYtqVSx45OlIcWmmz8aQ7ACKmWeSqzd0qKgQfJaK9DNmuiB4C8DyLbJlIVr5pqciK3CfEQ44AwgAYftcMWrcuhjZBsAeEXxR44/wCDhfCd5OSkBNAMT4b21w+1lMNUu8NLTd9vl/fjE1X5wcbtiI3g+R+xwyEz44nK2d6Avwf1fTcBxf9Bs1cYubzlw8HFlf9av3139/zgTa7VqeLirpeYKFOzhTDj4jImAgdIHBUiE60fV57UZOM1e4qcvGi9sH0ZDgISBkin+STlafa87oPDGrG3ADaTT1K3nDsA30wbYWeADAK0NtQWA/m7/KJyiv6T6WfCGI4y/RfKomIbZqHrmh2qWL4cTDVJpIfntj67lbf4oFz4XYNUlOBQaNJrhmAFBNTjgaM2n9uCjqZTxxZczXU4yRTG4LZfLLsWrx+4VqBcz71NWUmQ18JMAjIOxD80W+gK+4nWg5IhFJW8E5FagKQBwCYVw0AaBf46B8+9Cbb0U7bpwAAAABJRU5ErkJggg=="

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: submissionList.js
 * Project: educore
 * Created Date: 2019-01-23
 * Author: Raziya S
 * Screen : 
 */
var SubmissionController =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", function SubmissionController($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, SubmissionController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var authoring = localStorageService.get("authoringData");
    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $state.params.qpId;
    var activityId = void 0;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    $scope.isLoading = true;
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            console.log(result);
            $scope.qpHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'subject': authoring.subject,
                'class': authoring.class
            };
            $scope.$apply();
        } else {
            //error
        }
    });

    authService.callAPI(activityCons.API_GET_QP_DETAILS + qpId, "GET", {}, function (response) {
        console.log(response);
        if (response.result && response.result.data && response.result.data.details) {
            try {
                $scope.isLoading = false;
                $scope.questionPaper = response.result.data.details;
                console.log("***************");
                console.log($scope.questionPaper);
                activityId = $scope.questionPaper.activity_id;
                if ($scope.questionPaper && $scope.questionPaper.time) {
                    $scope.hour = $scope.questionPaper.time.hour;
                    $scope.min = $scope.questionPaper.time.min;
                }
                if ($scope.questionPaper && $scope.questionPaper.due_date) {
                    $scope.date = $scope.questionPaper.due_date;
                }
                if ($scope.questionPaper && $scope.questionPaper.students) {
                    $scope.assignedUsers = $scope.questionPaper.students;
                }
            } catch (ex) {
                console.log(ex);
            }
        } else {
            toastr.error('Network Error. Please try later');
        }
        _.defer(function () {
            $scope.$apply();
        });
    });
    $scope.answerPreview = function (studentId) {
        $state.go('teacherAnswerPreview', {
            qpId: qpId,
            studentId: studentId
        });
    };

    $scope.checkingChoiceExists = function (choice, data) {
        var isChecked = false;
        if (data.my_answer != undefined) {
            return data.my_answer.indexOf(choice) > -1;
        } else {
            return isChecked;
        }
    };

    var MQ = MathQuill.getInterface(2);
    $scope.loadLatex = function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    };

    $scope.markValidation = function (questionId, sectionIndex, section, qnMark) {
        var answersMarkCount = 0;
        _.each(section.answers, function (data) {
            if (parseFloat(data.my_score) > 0) {
                answersMarkCount++;
            }
        });
        if (answersMarkCount > section.mandatory_no) {
            var _questionIndex = section.answers.findIndex(function (i) {
                return i._id === questionId;
            });
            section.answers[_questionIndex].my_score = 0;
            toastr.error(" You have already entered the marks all mandatory question");
            section.answers[sectionIndex];
        };
        var actualScore = 0;
        var totalScore = qnMark;
        var questionIndex = $scope.questions[sectionIndex].answers.findIndex(function (i) {
            return i._id === questionId;
        });
        if (questionIndex > -1) {
            actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score;
        }
        if (actualScore > totalScore) $scope.questions[sectionIndex].answers[questionIndex].my_score = 0;
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.toString().replace(/\\quad/g, "");
            value = value.toString().replace(/\\/g, "");
        }
        return value;
    }

    /* Set answered choice is wrong or correct*/
    function setChoice() {
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (data, key) {
                $scope.total_mark += parseFloat(data.mark);
                var score = parseFloat(data.my_score);
                $scope.score += score;
                if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                    _.each(data.choice, function (choice) {
                        if ($scope.checkingChoiceExists(choice.desc, data)) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            }
                        }
                    });
                } else if (data.type == 'TF') {
                    _.each(data.choice, function (choice) {
                        if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                            if (!choice.correct) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        }
                    });
                } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                    var _key = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key] = 'Not Answered';
                            }
                        }
                        _key++;
                    });
                } else if (data.type == 'OWQ') {
                    var _key2 = 0;
                    _.each(data.answer, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.desc);
                        if (data.my_answer != undefined && data.my_answer[_key2] != undefined) {
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key2]);
                            if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                choice.wrong = true;
                            } else {
                                choice.correct = true;
                            }
                        } else {
                            choice.wrong = true;
                            if (data.my_answer != undefined) {
                                data.my_answer[_key2] = 'Not Answered';
                            } else {
                                data.my_answer = [];
                                data.my_answer[_key2] = 'Not Answered';
                            }
                        }
                        _key2++;
                    });
                } else if (data.type == 'MTF') {
                    data.ans_key = [];
                    var _key3 = 0;
                    _.each(data.option, function (choice) {
                        var correctAnswer = removeSpecialCharacter(choice.answer.desc);
                        if (data.my_answer != undefined && data.my_answer[_key3] != undefined) {
                            var correct = false;
                            var studentAnswer = removeSpecialCharacter(data.my_answer[_key3].desc);
                            if (correctAnswer !== studentAnswer) {
                                correct = false;
                            } else {
                                correct = true;
                            }
                            data.ans_key.push({
                                desc: data.my_answer[_key3].desc,
                                correct: correct,
                                optImage: data.my_answer[_key3].optImage
                            });
                        }
                        _key3++;
                    });
                } else if (data.type == 'ASLLISTEN') {
                    _.each(data.questions, function (aslListQues) {
                        if (aslListQues.type == 'mcq') {
                            _.each(aslListQues.choice, function (choice) {
                                if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'tf') {
                            _.each(aslListQues.choice, function (choice) {
                                if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                    if (!choice.correct) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'fib') {
                            _.each(aslListQues.answer, function (choice, index) {
                                var correctAnswer = removeSpecialCharacter(choice.desc);
                                if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                    var studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index]);
                                    if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                        choice.wrong = true;
                                    } else {
                                        choice.correct = true;
                                    }
                                } else {
                                    choice.wrong = true;
                                    if (aslListQues.my_answer != undefined) {
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    } else {
                                        aslListQues.my_answer = [];
                                        aslListQues.my_answer[index] = 'Not Answered';
                                    }
                                }
                            });
                        } else if (aslListQues.type == 'text') {
                            var correctAnswer = removeSpecialCharacter(aslListQues.answer);
                            if (aslListQues.my_answer != undefined) {
                                var studentAnswer = removeSpecialCharacter(aslListQues.my_answer);
                                if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                    aslListQues.wrong = true;
                                } else {
                                    aslListQues.correct = true;
                                }
                            } else {
                                aslListQues.wrong = true;
                                aslListQues.my_answer = 'Not Answered';
                            }
                        }
                    });
                }
            });
        });
    }

    $scope.score = $scope.score.toFixed(2);
    $scope.cancel = function () {
        $mdDialog.hide();
    };

    $scope.gotoActivityPreview = function () {
        $state.go('activityFormPreview', {
            resourceId: activityId
        });
    };

    $scope.saveMark = function () {
        var errorCount = 0;
        _.each($scope.questions, function (section) {
            _.each(section.answers, function (quest) {
                //mark_each_qn changed to qn_mark
                //For individual mark  for each question
                //Developer-Raziya
                quest.qn_mark = parseFloat(quest.qn_mark);
                if (quest.my_score > quest.qn_mark) {
                    quest.mark_error = "Enter the mark less than total mark";
                    errorCount++;
                }
            });
        });
        if (errorCount > 0) {
            toastr.error("Check the marks");
        } else {
            var requestObj = {
                questions: $scope.questions,
                student_id: $scope.studentId,
                question_paper_id: $scope.questionPaper._id,
                user_id: userId,
                authoring_data: authoring
            };
            authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function (response) {
                console.log(response);
                if (response.result && response.result.data && response.result.data.message) {
                    try {
                        var result = response.result.data.message;
                        toastr.success(result);
                        $mdDialog.hide();
                    } catch (ex) {
                        console.log(ex);
                    }
                } else {
                    toastr.error('Network Error. Please try later');
                }
                _.defer(function () {
                    $scope.$apply();
                });
            });
        }
    };

    $scope.setFilePath = function (img) {
        var new_url = img ? FILE_UPLOAD_URL + img : undefined;
        return new_url;
    };

    $scope.beautifyFIB = function (question) {
        return question.toString().replace(/_/g, " _______ ");
    };

    function getTime(millseconds) {
        var oneSecond = 1000;
        var oneMinute = oneSecond * 60;
        var oneHour = oneMinute * 60;
        var oneDay = oneHour * 24;
        var seconds = Math.floor(millseconds % oneMinute / oneSecond);
        var minutes = Math.floor(millseconds % oneHour / oneMinute);
        var hours = Math.floor(millseconds % oneDay / oneHour);
        var days = Math.floor(millseconds / oneDay);
        var timeString = '';
        if (days !== 0) {
            timeString += days !== 1 ? days + ' days ' : days + ' day ';
        }
        if (hours !== 0) {
            timeString += hours !== 1 ? hours + ' hours ' : hours + ' hour ';
        }
        if (minutes !== 0) {
            timeString += minutes !== 1 ? minutes + ' min ' : minutes + ' min ';
        }
        if (seconds !== 0 || millseconds < 1000) {
            timeString += seconds !== 1 ? seconds + ' sec ' : seconds + ' sec ';
        }
        return timeString;
    }

    $scope.isString = function (value) {
        return typeof value == 'string';
    };
}];

exports.default = SubmissionController;

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=question-directive ng-repeat=\"question in questionsSet track by $index\" ng-cloak ng-show=\"$index == scope.indexToShow\"> <div ng-switch=question.type> <div ng-switch-when=MCQ|IBT_MCQ ng-switch-when-separator=|> <div ng-switch=question.pattern> <div ng-switch-when=multiple layout=column> <div class=pass-con ng-if=question.passage> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <p ng-if=\"question.type=='IBT_MCQ'\" style=float:left;word-break:break-all;white-space:normal>{{question.passage}}</p> </div> </div> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <div> <span ng-show=question.isLatex class=question_desc style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> </div> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div layout=row flex layout-align=\"space-between center\" ng-repeat=\"choice in question.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px ng-show=scope.isPracticeTest> <md-checkbox type=checkbox ng-value=choice ng-checked=scope.checkingChoiceExists(choice.desc) ng-click=\"scope.setSelectedAns(choice.desc,'MR')\" class=\"question-outline cntr-checkbox\"></md-checkbox> <span ng-show=question.isLatex class=question_desc style=float:left>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left>{{choice.desc}}</span> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> </div> </div> <div style=margin-bottom:10px> <p class={{scope.errorMrQues[choice.desc].answerStatus}}> </p> </div> </div> <div layout=column flex layout-align=\"space-between start\" ng-repeat=\"choice in question.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px ng-show=!scope.isPracticeTest> <md-checkbox ng-value=choice ng-checked=scope.checkingChoiceExists(choice.desc) ng-click=\"scope.setSelectedAns(choice.desc,'MR')\" class=\"question-outline cntr-checkbox\"> <span ng-show=question.isLatex class=question_desc style=float:left>{{choice.desc}}</span> <span ng-show=!question.isLatex style=float:left>{{choice.desc}}</span> </md-checkbox> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"choice.optImage && choice.optImage.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in choice.optImage track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <div style=margin-bottom:10px> <p class={{scope.errorMrQues[choice.desc].answerStatus}}> </p> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=TF> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left>{{question.qn_desc}}</span> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div flex layout=column ng-repeat=\"choice in question.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.selectedAns[scope.indexToShow] flex ng-show=scope.isPracticeTest> <md-radio-button ng-show=\"$index==0\" value=True ng-click=\"scope.setSelectedAns(True,'TF')\" name=radio class=\"question-outline cntr-checkbox\" aria-label=True>True </md-radio-button> <md-radio-button ng-show=\"$index==1\" value=False ng-click=\"scope.setSelectedAns(False,'TF')\" name=radio class=\"question-outline cntr-checkbox\" aria-label=False>False </md-radio-button> </md-radio-group> <md-radio-group ng-model=scope.selectedAns[scope.indexToShow] flex ng-show=!scope.isPracticeTest> <md-radio-button value=True ng-show=\"$index==0\" ng-click=\"scope.setSelectedAns('True','TF')\" class=question-outline aria-label=True>True </md-radio-button> <md-radio-button value=False ng-show=\"$index==1\" ng-click=\"scope.setSelectedAns('False','TF')\" class=question-outline aria-label=False>False </md-radio-button> </md-radio-group> <div style=margin-bottom:5px> <p class={{scope.errorTFQues[choice.tag].answerStatus}}> </p> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=FIB|IBT_FIB ng-switch-when-separator=|> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <p ng-if=\"question.type=='IBT_FIB'\" style=float:left;word-break:break-all;white-space:normal>{{question.passage}}</p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left>{{beautifyFIB(question.qn_desc)}}</span> <span ng-show=question.isLatex class=question_desc style=float:left>{{beautifyFIB(question.qn_desc)}}</span> <div layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div flex=30 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=width:200px;height:150px;float:left> </div> </div> </div> </div> <div> <div layout=row layout-align=\"end end\"> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:1.0, ratio: '2:2.5',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> <div ng-repeat=\"choice in question.question_answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=\"choice.desc!=undefined\"> <md-input-container class=md-block flex-gt-sm> <div> <label>Enter Answer {{$index+1}}</label> <input ng-model=scope.ansFib[scope.indexToShow].choice[$index] ng-change=\"scope.setSelectedAns('enteredAns','FIB')\" autocomplete=off> </div> </md-input-container> <div style=margin:5px> <p class={{scope.errorFib[choice.desc].answerStatus}}> </p> </div> </div> </div> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)></span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=OWQ> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left>{{question.qn_desc}}</span> <div class=width_100 layout=row layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div> <div ng-repeat=\"choice in question.question_answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px ng-if=\"choice.desc!=undefined\"> <md-input-container class=md-block flex> <div> <label>Enter One Word Answer</label> <input ng-model=scope.ansOwq[scope.indexToShow] ng-change=\"scope.setSelectedAns('enteredAns','OWQ')\" autocomplete=off> </div> </md-input-container> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:1.0, ratio: '2:2.5',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> <div style=margin:5px> <p class={{scope.errorOwq[choice.desc].answerStatus}}> </p> </div> </div> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=SA> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div layout=row flex layout-xs=column ng-repeat=\"imgItem in uploadData\" ng-show=online> <div flex=60> <md-input-container style=width:100%> <label>{{imgItem.title}}</label> <input ng-model=question.image_title autocomplete=off> </md-input-container> </div> <div flex> <md-button class=md-raised ng-click=loadPopUp(question,$index) ng-disabled=\"question.image_title==undefined\">Upload</md-button> </div> </div> <div layout=row flex layout-align=\"start center\"> <div layout=column flex> <div layout=row flex layout-align=\"start center\"> <div flex=90> <md-input-container style=width:100%> <div> <label>Enter Answer</label> <textarea md-maxlength=1000 focus-it=true name=notes ng-model=scope.ansSa[scope.indexToShow]></textarea> </div> </md-input-container> </div> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:1.0, ratio: '2:2.5',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> </div> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> <div flex ng-repeat=\"imgObj in imageData[$index].images\"> <div flex style=overflow:auto;padding:5px layout-align=\"center center\"> <img flex src={{imgObj.image_url}} style=max-width:600px;max-height:400px> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=LA> <div class=pass-con> <div class=pass-sub-con layout=column> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.questionImg && question.questionImg.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.questionImg track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} style=max-height:150px ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div layout=row flex layout-xs=column ng-repeat=\"imgItem in uploadData\" ng-show=online> <div flex=60> <md-input-container style=width:100%> <label>{{imgItem.title}}</label> <input ng-model=question.image_title autocomplete=off> </md-input-container> </div> <div flex> <md-button class=md-raised ng-click=loadPopUp(question,$index) ng-disabled=\"question.image_title==undefined\">Upload</md-button> </div> </div> <div layout=row flex layout-align=\"start center\"> <div layout=column flex> <div layout=row flex layout-align=\"start center\"> <div flex=90> <md-input-container flex style=width:100%> <div> <label>Enter Answer</label> <input class=answer-text-field md-maxlength=1000 focus-it=true txt-maxlength=1000 name=notes ng-model=scope.ansLa[scope.indexToShow]> </div> </md-input-container> </div> <div flex> <img src=" + __webpack_require__(12) + " ngf-resize=\"{quality:1.0, ratio: '2:2.5',restoreExif: false}\" ngf-multiple=true ngf-select=answerImgUpload($files)> </div> </div> <div layout=row flex=100 layout-wrap ng-if=\"scope.imageData[scope.indexToShow] && scope.imageData[scope.indexToShow].length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in scope.imageData[scope.indexToShow] track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img class=imgheight src=" + __webpack_require__(3) + "> </span> </span> <span class=removecon> <span class=removeimg> <img src=" + __webpack_require__(30) + " ng-click=removeAnswerImg($index)> </span> </span> <img class=\"imgheight imgwidth\" ng-src={{setFilePath(img)}} style=\"\" ng-click=showImage(setFilePath(img))> </div> </div> </div> </div> <div flex ng-repeat=\"imgObj in imageData[$index].images\"> <div flex style=overflow:auto;padding:5px layout-align=\"center center\"> <img flex src={{imgObj.image_url}} style=max-width:600px;max-height:400px> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=DRAW> <div class=pass-con> <div class=pass-sub-con layout=column> <span style=float:left>{{question.qn_desc}}</span> <img flex ng-src={{setFilePath(question.questionImg)}} class=question-img ng-click=showImage(setFilePath(question.questionImg)) /> </div> </div> <div layout=column class=dictationspacediv layout-xs=row> <div flex layout=row layout-align=\"space-around center\"> <div ng-repeat=\"toolData in tools\" layout=row layout-align=\"center center\"> <div layout=row layout-align=\"start center\" ng-click=setTools(toolData.tool,toolData) ng-class=\"{'pdfControlSelected':toolData.expanded,'pdfControls':!toolData.expanded}\"> <md-button class=\"md-fab md-mini footer-circle-button\" aria-label=Add ng-class=\"{'pdfBtnSelected':toolData.expanded,'pdfBtn':!toolData.expanded}\"> <img src={{toolData.icon}} class=result-icon-button alt=Attendance> </md-button> </div> </div> <ng-color-picker selected=selected></ng-color-picker> </div> </div> <md-divider></md-divider> <div flex layout=column style=background:#fff> <div> <div flex layout-align=\"center center\"> <img style=max-width:600px;max-height:400px ng-if=online flex src={{quesTypes[0].imageUrl}} ng-click=showImage(quesTypes[0].imageUrl)> </div> <div flex layout-align=\"center center\"> <canvas id={{question.canvasId}} class=canvas flex width=600 height=400 style=background-color:#000;width:600px!important;max-width:600px;height:auto!important></canvas> <div layout=row layout-align=\"start center\" ng-click=uploadDrawing($index)> <md-button class=\"md-fab md-mini footer-circle-button\" aria-label=Add style=background:#1a97ab> <img src=" + __webpack_require__(413) + " class=result-icon-button alt=Attendance> </md-button> </div> <img ng-src={{setFilePath(question.answerImg)}} ng-click=showImage(setFilePath(question.answerImg))> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLSPEAK> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> </div> <div flex layout=row layout-align=space-between> <asl-voice-record flex=5></asl-voice-record> <div flex=40 ng-if=scope.ansAslSpeak[scope.indexToShow].answer class=\"md-whiteframe-2dp asl-audio-play\"> <audio controls ng-src={{setFilePath(scope.ansAslSpeak[scope.indexToShow].answer)}}></audio> </div> <div flex=40></div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=ASLLISTEN> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{question.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{question.qn_desc}}</span> </div> <div flex=40 ng-if=question.playableQuestionUrl class=\"md-whiteframe-2dp asl-audio-play\" ng-init=playableQuestionUrl> <audio controls ng-src={{question.playableQuestionUrl}}></audio> </div> <div layout=column class=dictationspacediv layout-xs=row> <p class=asl-qn-inst> Answer the below question by listening the audio: </p> <div ng-repeat=\"answer in question.questions\" style=margin:5px> <div ng-switch=answer.type> <div ng-switch-when=mcq> <div ng-switch=answer.pattern> <div flex ng-switch-when=single> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer flex> <md-radio-button ng-value=choice.desc ng-click=\"scope.setSelectedAns(choice.desc,'ASLLISTEN','MCQ',$parent.$index)\" aria-label={{choice.desc}} class=\"question-outline cntr-checkbox\"> <span class=question_desc style=float:left>{{choice.desc}}</span> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </md-radio-button> </md-radio-group> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </div> </div> </div> </div> <div ng-switch-when=multiple layout=column> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div layout=row flex layout-align=\"space-between center\" ng-repeat=\"choice in answer.choice\" class=md-whiteframe-2dp style=margin:5px;padding:10px> <md-checkbox ng-value=choice ng-click=\"scope.setSelectedAns(choice.desc,'ASLLISTEN','MR',$parent.$index)\" class=question-outline> <span class=question_desc style=float:left>{{choice.desc}}</span> </md-checkbox> <img flex ng-src={{setFilePath(choice.optImage)}} class=option-img /> </div> </div> </div> </div> </div> <div ng-switch-when=tf> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div flex layout=column ng-repeat=\"choice in answer.choice\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-radio-group ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer flex> <md-radio-button ng-value=choice.tag ng-click=\"scope.setSelectedAns(choice.tag,'ASLLISTEN','TF',$parent.$index)\" class=\"question-outline cntr-checkbox\" aria-label={{choice.tag}}>{{choice.tag}} </md-radio-button> </md-radio-group> </div> </div> </div> </div> <div ng-switch-when=fib> <div class=qstn-con layout=column> <span style=float:left>{{beautifyFIB(answer.qn_desc)}}</span> <img flex ng-src={{setFilePath(answer.questionImg)}} class=question-img /> </div> <div> <div ng-repeat=\"choice in answer.answer\"> <div class=md-whiteframe-2dp layout=row layout-align=\"space-between center\" style=margin:5px;padding:10px> <md-input-container class=md-block flex-gt-sm> <span class=answer-field ng-model=scope.ansAslListen[scope.indexToShow].ans[$parent.$index].answer[$index] style=height:auto autocomplete=off ng-init=\"formatToLatex(question.type,$parent.$index,'fib',$index)\" style=height:auto></span> </md-input-container> </div> </div> </div> </div> <div ng-switch-when=audio> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> </div> <div flex layout=row layout-align=space-between> <asl-voice-record flex=5 index=$index></asl-voice-record> <div flex=40 ng-if=scope.ansAslListen[scope.indexToShow].ans[$index].answer class=\"md-whiteframe-2dp asl-audio-play\"> <audio controls ng-src={{setFilePath(scope.ansAslListen[scope.indexToShow].ans[$index].answer)}}></audio> </div> <div flex=40></div> </div> </div> <div ng-switch-when=text> <div class=qstn-con layout=column> <span class=question_desc ng-show=question.isLatex style=float:left>{{answer.qn_desc}}</span> <span ng-show=!question.isLatex style=float:left>{{answer.qn_desc}}</span> </div> <div> <md-input-container class=md-block flex-gt-sm> <span class=answer-field ng-model=scope.ansAslListen[scope.indexToShow].ans[$index].answer style=height:auto autocomplete=off ng-init=\"formatToLatex(question.type,$index,'text')\" style=height:auto></span> </md-input-container> </div> </div> </div> </div> </div> </div> </div> <div ng-switch=question.type> <div ng-switch-when=MTF layout=column> <div class=pass-con> <div class=pass-sub-con layout=column> <p>Match the following Questions & Answers</p> <p ng-if=question.passage style=float:left;word-break:break-all;white-space:normal ng-bind-html=question.passage></p> <div class=width_100 layout=row flex=100 layout-wrap ng-if=\"question.passage_image && question.passage_image.length>0\"> <div class=imgborder flex=20 ng-repeat=\"img in question.passage_image track by $index\" style=margin:10px> <span class=zoomcon> <span class=imgzoom ng-click=showImage(setFilePath(img))> <img src=" + __webpack_require__(3) + "> </span> </span> <img class=imgwidth ng-src={{setFilePath(img)}} ng-click=showImage(setFilePath(img)) style=max-height:150px> </div> </div> </div> </div> <div flex layout=row> <div flex=45 layout=column> <div> <div ng-repeat=\"questions in question.option\" class=md-whiteframe-2dp layout=row style=margin:5px> <div layout=row> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;height:60px;font-size:14px!important>{{questions.question.tag}}</label> <label flex style=padding:5px;background:#fff;margin:0> <span ng-show=!question.isLatex style=font-size:14px!important>{{questions.question.desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left;overflow:auto;height:50px>{{questions.question.desc}}</span> </label> <img flex ng-src={{setFilePath(questions.question.questionImg)}} ng-if=questions.question.questionImg class=mtf-question-img ng-click=showImage(setFilePath(questions.question.questionImg)) /> </div> </div> </div> </div> <div flex=45 layout=column> <div as-sortable=dragControlListeners ng-model=question.optionAnswer> <div ng-repeat=\"answer in question.optionAnswer \" ng-init=\"sectionIndex = $index\" as-sortable-item class=md-whiteframe-2dp layout=row style=margin:5px> <div as-sortable-item-handle style=display:inline-flex flex> <label style=padding:7px;width:25px;background:#00bcd4;color:#fff;margin:0;height:60px;font-size:14px!important>{{$index+1}}</label> <label flex style=padding:5px;background:#fff;margin:0> <span ng-show=!question.isLatex style=font-size:14px!important>{{answer.desc}}</span> <span ng-show=question.isLatex class=question_desc style=float:left;overflow:auto;height:50px>{{answer.desc}}</span> </label> <img flex ng-src={{setFilePath(answer.optImage)}} ng-if=answer.optImage class=mtf-question-img ng-click=showImage(setFilePath(answer.optImage)) /> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imageViewPopup = __webpack_require__(1367);

var _imageViewPopup2 = _interopRequireDefault(_imageViewPopup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * File: attendExam.js
                                                                                                                                                           * Project: educore
                                                                                                                                                           * Created Date: 2019--01-23
                                                                                                                                                           * Author: Raziya S
                                                                                                                                                           * Screen : 
                                                                                                                                                           */


var AttendExam =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$timeout", "uploadService", "CQuesConst", function AttendExam($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, uploadService, CQuesConst) {
    _classCallCheck(this, AttendExam);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var self = this;
    var authoring = localStorageService.get("authoringData");
    $scope.scope = $scope.$parent;

    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $stateParams.qpId;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    var UPLOAD_URL = CONSTANTS.SERVER_UPLOAD;
    var USER_PATH = userId + "/question/";
    var PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL;
    var QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT;

    $scope.questionsSet = $scope.$parent.questions;
    $scope.$timeout = $timeout;
    // $scope.serverUrl = CONSTANTS.FILE_UPLOAD_URL + "/server-uploads"
    // $scope.userPath = userId + "/drawing/"
    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " (_______) ");
    };
    $scope.sortableOptions = {
        containment: '#sortable-container'
    };

    $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
        //console.log(fromState.name)
        if (fromState.name === "studentQuestionPaperPreview") {
            $mdDialog.canel();
        }
    });

    this.$postLink = function () {
        if ($scope.$parent.indexToShow === 0) {
            $mdDialog.cancel();
        }
    };
    $scope.$on('showQuestion', function () {
        $scope.scope = $scope.$parent;

        console.log("&&&&&&&&&&&&&");
        console.log($scope.scope.indexToShow);
        console.log("&&&&&&&&&&&&&");
    });

    $scope.dragControlListeners = {
        accept: function accept(sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id;
        },
        itemMoved: function itemMoved(event) {
            event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
        },
        orderChanged: function orderChanged(event) {},
        dragStart: function dragStart() {},
        dragEnd: function dragEnd() {
            $scope.$parent.$parent.isOptionSelected = true;
        },
        containment: '#board', //optional param.
        clone: false, //optional param for clone feature.
        allowDuplicates: false //optional param allows duplicates to be dropped.
    };

    function moveObjWithinArray(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr; // for testing
    };
    $scope.changeValue = function (index, question, answers, key, event) {
        $scope.$parent.$parent.isOptionSelected = true;
        // event.source.itemScope.modelValue.status = event.dest.sortableScope.$parent.column.name;
    };
    $scope.removeAnswerImg = function (index) {
        $scope.$parent.imageData[$scope.$parent.indexToShow].splice(index, 1);
    };
    //Image upload for question
    $scope.answerImgUpload = function (file, opt) {
        var supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT;
        _.each(file, function (fileObj) {
            var extValue = fileObj.name.split('.').pop().toLowerCase();
            if (_.contains(supportedFrmts, extValue)) {
                uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function (result) {
                    if (result.url) {
                        if (!_.isArray($scope.$parent.imageData[$scope.$parent.indexToShow])) $scope.$parent.imageData[$scope.$parent.indexToShow] = [];
                        $scope.$parent.imageData[$scope.$parent.indexToShow].push(result.url);
                    }
                });
            } else {
                toastr.error("Please select the supported format jpg, jpeg, png");
                fileObj = {};
            }
        });
    };
    //Open dialog to view image
    $scope.showImage = function (url) {
        var imageObj = {
            image: url
        };
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            locals: {
                imageDetails: imageObj
            },
            template: _imageViewPopup2.default,
            controller: ['$scope', '$mdDialog', 'imageDetails', imageDialogCtrl],
            parent: angular.element(document.body),
            clickOutsideToClose: true,
            fullscreen: useFullScreen
        });
    };
    //DIALOG CONTROLLER FOR IMAGE
    var imageDialogCtrl = function imageDialogCtrl($scope, $mdDialog, imageDetails) {
        $scope.fileUrl = PREVIEW_URL;
        $scope.imageDetails = imageDetails;
        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    };

    var MQ = MathQuill.getInterface(2);
    $timeout(function () {
        var questionElements = document.getElementsByClassName('question_desc');
        _.each(questionElements, function (spanElement) {
            MQ.StaticMath(spanElement);
        });
    }, 1000);

    $scope.formatToLatex = function (type, index, ansType, ansIndex) {
        var answerElements = document.getElementsByClassName('answer-field');
        _.each(answerElements, function (spanElement) {
            spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched';
            var mathField = MQ.MathField(spanElement, {
                spaceBehavesLikeTab: false,
                restrictMismatchedBrackets: true,
                handlers: {
                    edit: function edit() {
                        if (type === 'SA') {
                            $scope.$parent.ansSa[$scope.$parent.indexToShow] = mathField.latex();
                        } else if (type === 'LA') {
                            $scope.$parent.ansLa[$scope.$parent.indexToShow] = mathField.latex();
                        } else if (type === 'OWQ') {
                            if (!$scope.$parent.ansOwq[$scope.$parent.indexToShow]) {
                                $scope.$parent.ansOwq[$scope.$parent.indexToShow] = {
                                    choice: []
                                };
                            }
                            $scope.$parent.ansOwq[$scope.$parent.indexToShow] = mathField.latex();
                            $scope.$parent.$parent.setSelectedAns('enteredAns', 'OWQ');
                        } else if (type === 'FIB' || type == 'IBT_FIB') {
                            if (!$scope.$parent.ansFib[$scope.$parent.indexToShow]) {
                                $scope.$parent.ansFib[$scope.$parent.indexToShow] = {
                                    choice: []
                                };
                            }
                            $scope.$parent.ansFib[$scope.$parent.indexToShow].choice[index] = mathField.latex();
                            $scope.$parent.$parent.setSelectedAns('enteredAns', 'FIB');
                        } else if (type === 'ASLLISTEN') {
                            if (ansType === 'fib') {
                                $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer[ansIndex] = mathField.latex();
                            } else if (ansType == 'text') {
                                $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = mathField.latex();
                            }
                        }
                    }
                }
            });
        });
    };

    /*
     * Function to save recorded file url
     *
     * @url : uploaded file url
     *
     * @return : null
     */
    $scope.saveRecordedUrl = function (url, index) {
        if (index >= 0) {
            $scope.$parent.ansAslListen[$scope.$parent.indexToShow].ans[index].answer = url;
        } else {
            $scope.$parent.ansAslSpeak[$scope.$parent.indexToShow].answer = url;
        }
    };

    $scope.setFilePath = function (img) {
        var new_url = img ? PREVIEW_URL + img : undefined;
        return new_url;
    };
    $scope.beautifyFIB = function (question) {
        return question.replace(/_/g, " _______ ");
    };

    //for question -drawing
    /*####################################################################################*/
    $timeout(function () {

        var canvasList = document.getElementsByClassName('canvas');

        _.each(canvasList, function (canvas) {

            if (canvas) {
                var ctx = canvas.getContext('2d');
            }

            $scope.backingScale = function () {
                //var ctx = canvas.getContext('2d');
                var dpr = window.devicePixelRatio || 1;
                /*var bsr = ctx.webkitBackingStorePixelRatio ||
                    ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio ||
                    ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;*/

                /* return dpr / bsr;*/
            };
            $scope.normalHeight = $window.innerHeight;
            var ratio = $scope.backingScale();
            var w = 600;
            var h = 400;

            $scope.windowWidth = Math.floor(w * ratio);
            $scope.windowHeight = Math.floor(h * ratio);
            $scope.windowInnerWidth = Math.floor(w) + 'px';
            $scope.windowInnerHeight = Math.floor(h) + 'px';
            ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
            //scope.resetDrawing()
            //ctx.scale(scope.scale,scope.scale);
            //scope.resetDrawing()
            canvas.style.pointerEvents = 'auto|none';

            var drawing = false;
            var lastX = void 0;
            var lastY = void 0;
            ctx.lineJoin = ctx.lineCap = 'round';
            var points = [],
                fhPoints = [];
            var rect = void 0;

            $scope.setTool = function (tool) {
                $scope.toolName = tool;
            };
            $scope.getPdfHeight = function () {
                // pdfHolder = element.find('pdfviewer')[0];

                var ratio = $scope.backingScale();
                var w = 600;
                var h = 400;
                $scope.windowWidth = Math.floor(w * ratio);
                $scope.windowHeight = Math.floor(h * ratio);
                $scope.windowInnerWidth = Math.floor(w) + 'px';
                $scope.windowInnerHeight = Math.floor(h) + 'px';
                ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
                //scope.resetDrawing()
                //ctx.scale(scope.scale,scope.scale);
                $scope.resetDrawing();
                canvas.style.pointerEvents = 'auto|none';
            };

            $scope.clearPageAnnotation = function () {
                for (var i in points) {
                    if (points[i].page == $scope.pageNumber) {
                        points.splice(i, 1);
                        //break;
                        $scope.clearPageAnnotation();
                    }
                }
                $scope.resetDrawing();
            };

            $scope.updateNewDrawing = function (pts) {
                points = [];
                points = pts;
                $scope.resetDrawing();
            };
            $scope.setTool = function (toolName, data) {

                for (var i in $scope.tools) {
                    if ($scope.tools[i] != data) {
                        $scope.tools[i].expanded = false;
                    }
                }
                data.expanded = !data.expanded;

                if (data.expanded) {
                    $scope.tool = toolName;
                } else {
                    $scope.tool = '';
                }
            };
            $scope.resetDrawing = function () {
                ctx.clearRect(0, 0, $scope.windowWidth, $scope.windowHeight);
                // Resize original canvas
                //canvas.width = window.innerWidth;
                //canvas.height = window.innerHeight;
                var imgs = [];
                var imgIndex = 0;
                //Load previously Saved Annotation
                for (var i in points) {
                    ctx.beginPath();
                    if (points[i].page == $scope.pageNumber) {
                        //ctx.lineWidth = 2;
                        ctx.lineJoin = ctx.lineCap = 'round';
                        if (points[i].tool_name == 'Pencil') {
                            ctx.lineWidth = points[i].thickness; //scope.lineThickness;
                            ctx.strokeStyle = '#FFFFFF';
                            ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                            for (var j = 1; j < points[i].draw_points.length; j++) {
                                ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                            }
                            ctx.stroke();
                        } else if (points[i].tool_name == 'Marker') {
                            ctx.lineWidth = 15; //points[i].thickness;
                            ctx.strokeStyle = '#000000';
                            if (points[i].draw_points != undefined) {
                                ctx.moveTo(points[i].draw_points[0].x, points[i].draw_points[0].y);
                                for (var j = 1; j < points[i].draw_points.length; j++) {
                                    ctx.lineTo(points[i].draw_points[j].x, points[i].draw_points[j].y);
                                }
                                ctx.stroke();
                            }
                        }
                    }
                }
            };
            canvas.onmouseover = function (event) {
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }

                for (var i in points) {
                    if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                        if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                            //alert ('Your Notes : ' + points[i].notes);
                            //isNotesOpen = true
                        }
                    }
                }
            };
            canvas.onmouseout = function (event) {
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }

                for (var i in points) {
                    if (points[i].page == $scope.pageNumber && points[i].tool_name == 'Notes') {
                        if (currentX < points[i].right && currentX > points[i].left && currentY > points[i].top && currentY < points[i].bottom) {
                            //alert ('Your Notes : ' + points[i].notes);
                            //isNotesOpen = true
                        }
                    }
                }
            };
            canvas.addEventListener('touchstart', onTouchStart, false);
            canvas.addEventListener('touchmove', onTouchMove, false);
            canvas.addEventListener('touchend', onTouchEnd, false);

            canvas.addEventListener('mousedown', onMouseStart, false);
            canvas.addEventListener('mousemove', onMouseMove, false);
            canvas.addEventListener('mouseup', onMouseEnd, false);

            $window.addEventListener('load', resize, false);
            $window.addEventListener('resize', resize, false);

            function resize() {}

            /* // Our canvas must cover full height of screen
             // regardless of the resolution
             var height = window.innerHeight;
             // So we need to calculate the proper scaled width
             // that should work well with every resolution
             var ratio = canvas.width / canvas.height;
             var width = height * ratio;
              canvas.style.width = width + 'px';
             canvas.style.height = height + 'px';*/

            // Get the position of a touch relative to the canvas
            function getTouchPos(canvasDom, touchEvent) {
                var rect = canvasDom.getBoundingClientRect();
                return {
                    x: touchEvent.touches[0].clientX - rect.left,
                    y: touchEvent.touches[0].clientY - rect.top
                };
            }
            // Get the position of the mouse relative to the canvas
            function getMousePos(canvasDom, mouseEvent) {
                var rect = canvasDom.getBoundingClientRect();
                return {
                    x: mouseEvent.clientX - rect.left,
                    y: mouseEvent.clientY - rect.top
                };
            }

            document.body.addEventListener("touchstart", function (e) {
                if (e.target == canvas && !drawing) {
                    e.preventDefault();
                }
            }, false);
            document.body.addEventListener("touchend", function (e) {
                if (e.target == canvas && drawing) {
                    e.preventDefault();
                }
            }, false);
            document.body.addEventListener("touchmove", function (e) {
                if (e.target == canvas && drawing) {
                    e.preventDefault();
                }
            }, false);

            function onTouchStart(event) {
                mousePos = getTouchPos(canvas, event);
                var touch = event.touches[0];
                var mouseEvent = new MouseEvent("mousedown", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }

            function onTouchMove(event) {
                var touch = event.touches[0];
                var mouseEvent = new MouseEvent("mousemove", {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                });
                canvas.dispatchEvent(mouseEvent);
            }

            function onTouchEnd(event) {
                var mouseEvent = new MouseEvent("mouseup", {});
                canvas.dispatchEvent(mouseEvent);
            }

            function onMouseStart(event) {
                lastX = lastY = '';
                lastPos = getMousePos(canvas, event);
                if (event.offsetX !== undefined) {
                    lastX = event.offsetX;
                    lastY = event.offsetY;
                } else {
                    lastX = lastPos.x; //event.layerX - event.currentTarget.offsetLeft;
                    lastY = lastPos.y; //event.layerY - event.currentTarget.offsetTop;
                }

                // begins new line
                ctx.beginPath();
                fhPoints = [];
                drawing = true;
                var isNotesOpen = false;

                if ($scope.tool == 'Pencil') {
                    ctx.lineWidth = $scope.lineThickness;
                    ctx.strokeStyle = '#FFFFFF'; //$scope.selected; //
                    ctx.fillStyle = '#FFFFFF'; //$scope.selected; //'#FFFFFF';
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    canvas.style.cursor = "url('/pdf/ic_create_cursor.png'), auto";
                } else if ($scope.tool == 'Marker') {
                    ctx.lineWidth = 15; //scope.lineThickness;
                    ctx.strokeStyle = '#000000';
                    //ctx.fillStyle = 'rgba(255, 255, 0, 0.3)';
                    ctx.moveTo(lastX, lastY);
                    fhPoints.push({
                        x: lastX,
                        y: lastY
                    });
                    canvas.style.cursor = "url('/pdf/ic_eraser_cursor.png'), auto";
                }
            }

            function onMouseMove(event) {
                if (drawing) {
                    // get current mouse position
                    currentPos = getMousePos(canvas, event);
                    if (event.offsetX !== undefined) {
                        currentX = event.offsetX;
                        currentY = event.offsetY;
                    } else {
                        currentX = currentPos.x; //event.layerX - event.currentTarget.offsetLeft;
                        currentY = currentPos.y; //event.layerY - event.currentTarget.offsetTop;
                    }

                    if ($scope.tool == 'Pencil') {
                        ctx.lineTo(currentX, currentY);
                        fhPoints.push({
                            x: currentX,
                            y: currentY
                        });
                        ctx.stroke();
                    } else if ($scope.tool == 'Marker') {
                        ctx.lineTo(currentX, currentY);
                        fhPoints.push({
                            x: currentX,
                            y: currentY
                        });
                        ctx.stroke();
                    }
                }
            }

            function onMouseEnd(event) {

                var valueObj = {};
                drawing = false;
                if (event.offsetX !== undefined) {
                    currentX = event.offsetX;
                    currentY = event.offsetY;
                } else {
                    currentX = event.layerX - event.currentTarget.offsetLeft;
                    currentY = event.layerY - event.currentTarget.offsetTop;
                }
                if ($scope.tool == 'Pencil') {

                    valueObj = {
                        page: $scope.pageNumber,
                        tool_name: $scope.tool,
                        draw_points: fhPoints,
                        thickness: $scope.lineThickness,
                        user_id: Meteor.userId()

                    };
                    points.push(valueObj);
                    canvas.style.cursor = "default";
                } else if ($scope.tool == 'Marker') {

                    valueObj = {
                        page: $scope.pageNumber,
                        tool_name: $scope.tool,
                        draw_points: fhPoints,
                        thickness: 15,
                        user_id: Meteor.userId()
                    };
                    points.push(valueObj);
                    $scope.resetDrawing();
                    canvas.style.cursor = "default";
                }
            }
            // Get a regular interval for drawing to the screen
            window.requestAnimFrame = function (callback) {
                return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimaitonFrame || function (callback) {
                    window.setTimeout(callback, 1000 / 60);
                };
            }();
        });
    }, 0);
    $scope.tools = [{
        tool: 'Pencil',
        expanded: true,
        icon: '/pdf/ic_create.png'
    }, {
        tool: 'Marker',
        expanded: false,
        icon: '/pdf/ic_eraser.png'
    }];
    $scope.tool = 'Pencil';
    $scope.pageNumber = 1;
    $scope.scale = 1.0;
    $scope.lineThickness = 2;
    $scope.totalPageNumber = 1;
    $scope.setTools = function (toolName, data) {

        for (var i in $scope.tools) {
            if ($scope.tools[i] != data) {
                $scope.tools[i].expanded = false;
            }
        }
        data.expanded = !data.expanded;

        if (data.expanded) {
            $scope.tool = toolName;
        } else {
            $scope.tool = '';
        }
    };
    $scope.uploadDrawing = function (index) {
        var today = new Date();
        var day = today.getDay();
        var currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible'; //might need to do this to grandparent nodes as well, possibly.
        html2canvas([document.getElementById('canvas_' + $scope.$parent.indexToShow)], {
            onrendered: function onrendered(canvas) {
                document.getElementById('canvas_' + $scope.$parent.indexToShow).style.overflow = 'visible';
                var dataUrl = canvas.toDataURL();
                var fileObj = Upload.dataUrltoBlob(dataUrl);
                uploadService.uploadCheckService(fileObj, $scope.serverUrl, $scope.userPath, function (result) {
                    if (result.url) {
                        self.questions[index].answerImg = result.url;
                        //self.questions[index].answer=result.url;
                    }
                });
            }
        });
    };
}];

exports.default = AttendExam;

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports = "<md-dialog flex> <md-toolbar> <div flex layout=row class=md-toolbar-tools layout-align=\"space-around center\"> <div flex class=preview-heading> <p style=margin-bottom:0!important;font-size:20px>Image Preview</p> </div> <i class=\"fas fa-times\" style=display:flex ng-click=cancel()></i> </div> </md-toolbar> <md-divider></md-divider> <md-dialog-content> <div class=md-dialog-content layout=column style=background:#fff;text-align:center> <div> <img src={{imageDetails.image}} style=height:300px> </div> </div> </md-dialog-content> </md-dialog>";

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div flex layout=row layout-gt-xs=row class=overFlowContainer style=width:100%;height:85vh;margin-bottom:60px> <div layout=column flex=25 style=background:#e4f0ff;margin:5px;margin-left:17px!important;margin-right:3px!important;max-height:100% class=\"margin_15 md-whiteframe-5dp md-padding\" ng-show=!fullScreen> <div class=allqstn flex=70 flex-gt-xs> <div flex ng-repeat=\"questionCount in totalQuestion track by $index\" style=display:inline-block layout-align=\"center center\"> <button style=margin:3px class=\"md-whiteframe-2dp {{questionCount.status}}\" aria-label=questionCount.count ng-click=changeQuestion($index)>{{questionCount.count}}</button> </div> </div> <div flex flex-gt-xs layout-align=\"center center\"> <div class=md-whiteframe-1dp layout=row layout-gt-xs=column layout-align=\"center start\" flex style=height:98px> <div layout=row style=padding:5px;padding-top:10px layout-align=\"start center\" flex> <div class=circleSubmit></div> <label style=margin:0!important>Attempted</label> </div> <div layout=row style=padding:5px layout-align=\"start center\" flex> <div class=circleReview></div> <label style=margin:0!important>Mark for Review</label> </div> <div layout=row style=padding:5px;padding-bottom:10px layout-align=\"start center\" flex> <div class=circleNormal></div> <label style=margin:0!important>Not Attempted</label> </div> </div> </div> </div> <div flex=75 layout=column style=background:#fff;margin:15px;margin-left:30px!important;max-height:100% class=\"md-whiteframe-5dp md-padding overFlowContainer\"> <div class=\"button assessclick assessmentbtnopen filter md-whiteframe-3dp hand-cursor\" ng-show=!fullScreen ng-click=toggleFullScreen(fullScreen) tooltip=Hide tooltip-position=left> <i class=\"fas fa-angle-left filter-arrow\" style=margin-top:2px;margin-left:-14px;font-size:35px></i> </div> <div class=\"button assessclick assessmentbtnclose filter md-whiteframe-3dp hand-cursor\" ng-show=fullScreen ng-click=toggleFullScreen(fullScreen) tooltip=Show tooltip-position=right> <i class=\"fas fa-angle-right filter-arrow\" style=margin-left:-12px;margin-top:2px;font-size:32px></i> </div> <header> <div layout=row layout-align=\"space-between start\" style=background:#fff flex> <div flex=66 layout-align=\"start center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=color:#9e9e9e;margin-bottom:0> <span style=color:#1b1b1b> Question : </span> <label style=padding-right:8px class=colorthemeColor>{{indexToShow+1}}</label> <label class=colorthemeColor> {{questions[indexToShow].section_name}} &nbsp {{questions[indexToShow].section_instruction}}</label> </p> </span> </div> <div flex=30 ng-show=isPracticeTest layout-align=\"end center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=margin-bottom:0> <span style=font-size:15px> Time Taken : </span> <label class=colorthemeColor>{{timerWithTimeout | hhmmss}}</label> </p> </span> </div> <div flex=30 ng-show=!isPracticeTest layout-align=\"end center\"> <span flex class=\"md-whiteframe-1dp examtimeonly\"> <p style=margin-bottom:0> <span style=font-size:15px> Time Remaining : </span> <label class=colorthemeColor>{{remainingTime}}</label> </p> <p style=margin-bottom:0 ng-if=\"remainingTime === '00 : 00 : 00'\"> <span style=font-size:15px> Time Elapsed </span> </p> </span> </div> </div> </header> <div flex ng-cloak> <attend-exam ng-if=loadQuestionDirective></attend-exam> </div> </div> </div> <footer> <div layout=row flex style=\"position:fixed;bottom:0;z-index:1;background:#1665c1;width:100%;border-top:2px solid #f2f2f2;box-shadow:0 0 10px 0 #f2f2f2;overflow-x:auto;padding-left:10px;padding-right:10px\" layout-align=\"space-around center\"> <div flex layout=row ng-repeat=\"questionCount in totalQuestion\" layout-align=center-center ng-show=\"$index == indexToShow\" ng-if=haveNoPassword style=\"margin:10px 0\"> <div layout-align=\"start center\"> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-show=\"indexToShow>0\" ng-click=loadPrevQues()> <img src=" + __webpack_require__(162) + "> <span class=\"footer-text student-footer-ctrl\">Prev</span> </span> </div> <div layout-align=\"start center\"> <div> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtnwidth quizbtn md-mini\" ng-click=reviewQuestion()> <span class=\"footer-text student-footer-ctrl\">{{questionCount.label}}</span> <img style=float:right;width:19px;margin-left:10px src=" + __webpack_require__(415) + "> </span> </div> </div> <div layout-align=\"start center\"> <div> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-click=submitLastQuestion(true,false) ng-disabled=isSubmitted ng-hide=\"indexToShow<(totalQuestiontoShow-1)\" ng-cloak> <span class=\"footer-text student-footer-ctrl\">Submit</span> <img src=" + __webpack_require__(86) + "> </span> </div> </div> <div layout-align=\"start center\"> <div> <span class=\"hand quizbtneffect md-whiteframe-3dp quizbtn md-mini\" ng-show=\"indexToShow<(totalQuestiontoShow-1)\" ng-click=loadNextQues()> <span class=\"footer-text student-footer-ctrl\">Next</span> <img src=" + __webpack_require__(163) + "> </span> </div> </div> <div style=height:300px!important;width:100% ng-if=showEmptyDiv></div> </div></div></footer>";

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: questionDirective.js
 * Project: educore
 * Created Date: 2019--01-23
 * Author: Raziya S
 * Screen : 
 */
var QuestionDirective =
// @ngInject
["$state", "$rootScope", "$scope", "$mdMedia", "$filter", "$mdDialog", "localStorageService", "authService", "activityCons", "$stateParams", "SchoolLogo", "CONSTANTS", "$timeout", "$interval", function QuestionDirective($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $timeout, $interval) {
    _classCallCheck(this, QuestionDirective);

    var authoring = localStorageService.get("authoringData");
    if (authoring === undefined) $state.go('dashboard');
    $scope.score = 0;
    var qpId = $state.params.qpId;
    $scope.minutes = [];
    for (var min = 5; min <= 20; min += 5) {
        $scope.minutes.push(min);
    }
    $scope.class = authoring.class;
    var userId = localStorageService.get('user_id');
    var schoolId = authoring.school_id;
    var activityId = $state.params.activityId;
    if (authoring === undefined) $state.go('dashboard');
    var subjectId = '';
    localStorage.setItem('authoringData', JSON.stringify(authoring));
    localStorage.removeItem("is_restart");
    $scope.fullScreen = false;
    $scope.totalQuestion = [];
    $scope.questions = [];
    $scope.attendedQuesObj = [];
    $scope.selectedAns = [];
    $scope.questionCollection = [];
    $scope.imageData = [];
    $scope.ansFib = [];
    $scope.ansOwq = [];
    $scope.ansSa = [];
    $scope.ansLa = [];
    $scope.ansDraw = [];
    $scope.ansAslListen = [];
    $scope.ansAslSpeak = [];
    $scope.loadQuestionDirective = false;
    $scope.isOptionSelected = false;
    $scope.actionBtnName = 'Submit';
    $scope.errorFib = {};
    $scope.errorOwq = {};
    $scope.errorMtf = {};
    $scope.errorMrQues = {};
    $scope.errorMcqQues = {};
    $scope.errorTFQues = {};
    $scope.totalQuestiontoShow = 0;
    $scope.indexToShow = 0;
    $scope.quizTotalMark = 0;
    $scope.noOfAttempts = 0;
    $scope.elapsedTime = 0;
    $scope.remainingTime = '';
    $scope.score = 0;
    // questionPaperId = '';
    $scope.isPracticeTest = false;
    $scope.timeData = "";
    $scope.haveNoPassword = true;
    $scope.accessbility = true;
    $scope.isActivity = true;
    $scope.selectedCheckAns = [];
    $scope.multipleCheckAnsData = [];

    var totalMark = 0;

    var endTime = undefined;

    //Meteor.subscribe('questionPaper')

    var tempQuestions = [];
    var currentDay = '';
    var questionPaperData = {};

    var startTime = 0,
        currentTime = null,
        offset = 0,
        interval = null,

    // self = this;
    options = {};
    if (!options.interval) {
        options.interval = 100;
    }
    localStorage.setItem('activityId', activityId);
    localStorage.setItem('backfromexam', true);
    options.elapsedTime = new Date(0);
    $scope.running = false;
    this.$onDestroy = function () {
        //submitAnsEachQuestion(false, true);
        submitAnsEachQuestion(false, false);

        clearTimer();
        toastr.success("Your answer is submitted successfully");
        $mdDialog.cancel();
    };

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        var requestObj = {};
        requestObj["activity_id"] = activityId;
        requestObj["qp_id"] = qpId;
        requestObj["student_id"] = userId;
        var academics = _.pick(authoring, 'curriculum_id', 'session_id', 'class_id', 'subject_id', 'batch_id', 'school_id', 'academic_year');
        requestObj = _.extend(requestObj, academics);
        authService.callAPI(activityCons.API_GET_EXAM_QUESTIONS, "POST", requestObj, function (response) {
            if (response) {
                if (response.result.status && response.result.status.code == 200) {
                    loadQuestions(response.result);
                } else {
                    toastr.error(response.result.data.message);
                    $state.go('activityFormPreview', {
                        resourceId: activityId
                    }, {
                        reload: true
                    });
                }
            } else {
                console.log("error : " + response.error);
                if (response.error.status && response.error.status.message) {
                    toastr.error(response.error.status.message);
                }
                if (response.error.data && response.error.data.message) {
                    toastr.error(response.error.data.message);
                }
                if (response.error.error && response.error.error.status) {
                    toastr.error(response.error.error.status);
                }
            }
        });
    };

    var initilaizeTimer = function initilaizeTimer(timeObj) {
        var deadline = void 0;
        $scope.remainingTime = '';
        if (parseInt(timeObj.hour) == 0 && parseInt(timeObj.min) == 0) {
            $scope.remainingTime = '00 : 00 : 00';
        } else {
            if (parseInt(timeObj.hour) === 0) {
                $scope.elapsedTime = parseInt(timeObj.min) * 60 * 1000 + parseInt(timeObj.sec) * 1000;
            } else {
                $scope.elapsedTime = parseInt(timeObj.hour) * 60 * 60 * 1000 + parseInt(timeObj.min) * 60 * 1000 + parseInt(timeObj.sec) * 1000;
            }

            deadline = new Date(Date.parse(new Date()) + $scope.elapsedTime);
            $scope.initializeClock(deadline);
            $scope.startTimer();
        }
    };

    var loadQuestions = function loadQuestions(questionPaperData) {
        $scope.isPracticeTest = questionPaperData.practice_qn;
        $scope.graceTime = 0;

        if (questionPaperData && questionPaperData.data && questionPaperData.data.details) {

            var responseObj = questionPaperData.data.details;
            $scope.isPracticeTest = responseObj.practice_qn;

            endTime = new Date(responseObj.endTime);
            $scope.serverDate = new Date(responseObj.serverTime);
            var timeObj = {};
            if ($scope.serverDate.getTime() > endTime.getTime()) {
                console.log("Time Expired...");

                timeObj = {
                    "hour": 0,
                    "min": 0,
                    "sec": 0
                };
                initilaizeTimer(timeObj);
            } else {
                var secondsToTime = (endTime.getTime() - $scope.serverDate.getTime()) / 1000;
                timeObj = secondsToHrMin(secondsToTime);
                initilaizeTimer(timeObj);
            }
            totalMark = responseObj.total_mark;
            if (responseObj.serverTime) {
                currentDay = new Date($scope.serverDate.getFullYear(), $scope.serverDate.getMonth(), $scope.serverDate.getDate());
            } else {
                var today = new Date();
                currentDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
            }

            var result = responseObj.questions;
            _.each(result, function (quest, key) {
                $scope.questions.push(quest);
                if (quest.isLatex) {
                    $scope.formatToLatex();
                }
                var optionAnswer = [];
                //To covert image into image array - multiple image
                if (quest) {
                    if (quest.type === "MCQ") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                        _.each(quest.choice, function (eachChoice) {
                            if (!Array.isArray(eachChoice.optImage) && eachChoice.optImage != null) eachChoice.optImage = _.flatten([eachChoice.optImage]);
                        });
                    } else if (quest.type === "FIB" || quest.type === "TF" || quest.type === "OWQ" || quest.type === "SA" || quest.type === "LA") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    } else if (quest.type === "IBT_FIB") {
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    } else if (quest.type === "IBT_MCQ") {
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                        _.each(quest.choice, function (eachChoice) {
                            if (!Array.isArray(eachChoice.optImage) && quest.questionImg != null) eachChoice.optImage = _.flatten([eachChoice.optImage]);
                        });
                        if (!Array.isArray(quest.passage_image) && quest.questionImg != null) quest.passage_image = _.flatten([quest.passage_image]);
                    } else if (quest.type === "DRAW") {
                        if (!Array.isArray(quest.questionImg) && quest.questionImg != null) quest.questionImg = _.flatten([quest.questionImg]);
                    }
                }

                if (quest.type === "MTF") {
                    quest['quesData'] = [];
                    _.each(quest.option, function (eachAns) {
                        quest.quesData.push(eachAns.question);
                        optionAnswer.push(eachAns.answer);
                    });
                    optionAnswer = _.shuffle(optionAnswer);
                    quest.optionAnswer = optionAnswer;
                }

                if (quest.type === "TF") {
                    var choices = _.shuffle(quest.choice);
                    quest.choice = choices;
                }

                if (quest.type === "DRAW") {
                    quest.canvasId = "canvas_" + key;
                    var emptyObj = {
                        'choice': ''
                    };
                    $scope.ansDraw.push(emptyObj);
                }

                if (quest.type === "ASLLISTEN") {
                    quest.playableQuestionUrl = $sce.trustAsResourceUrl(FILE_PREVIEW_URL + quest.audio_url);
                    var emptyAnsList = [];
                    _.each(quest.questions, function (question) {
                        var emptyObj = {
                            _id: question._id,
                            type: question.type
                        };
                        switch (question.type) {
                            case 'mcq':
                                if (question.pattern == 'single') emptyObj['answer'] = "";else emptyObj['answer'] = [];
                                break;
                            case 'fib':
                                emptyObj['answer'] = [];
                                break;
                            default:
                                emptyObj['answer'] = "";
                                break;
                        }
                        emptyAnsList.push(emptyObj);
                    });
                    $scope.ansAslListen[key] = {
                        ans: emptyAnsList
                    };
                }
                if (quest.type === "ASLSPEAK") {
                    $scope.ansAslSpeak[key] = {
                        answer: ''
                    };
                }

                quest.submit_status = quest.q_status;
                //Display previously Submitted answer
                if (quest.answer && quest.answer.length > 0) {

                    if (quest.type === "FIB" || quest.type === "IBT_FIB") {
                        _.each(quest.answer, function (fib_ans, c_key) {
                            if (fib_ans) {
                                if (!$scope.ansFib) {
                                    $scope.ansFib = [];
                                }

                                var choiceObj = {
                                    "choice": {}
                                };
                                choiceObj["choice"][c_key] = fib_ans;
                                $scope.ansFib.splice(key, 0, choiceObj);
                            }
                        });
                        $scope.imageData[key] = quest.answerImg;
                    } else if (quest.type === "MCQ" || quest.type === "IBT_MCQ") {

                        if (!$scope.multipleCheckAnsData) {
                            $scope.multipleCheckAnsData = [];
                        }
                        //$scope.multipleCheckAnsData.splice(key, 0, quest.answer);
                        $scope.multipleCheckAnsData[key] = quest.answer;
                    } else if (quest.type === "OWQ") {
                        if (!$scope.ansOwq) {
                            $scope.ansOwq = [];
                        }
                        $scope.ansOwq[key] = quest.answer[0];
                        $scope.imageData[key] = quest.answerImg;
                    } else if (quest.type === "MTF") {
                        _.each(quest.optionAnswer, function (opt, o_key) {
                            opt["desc"] = quest.answer[o_key].desc;
                        });
                    } else if (quest.type === "TF") {
                        if (!$scope.selectedAns) {
                            $scope.selectedAns = [];
                        }
                        //$scope.selectedAns.splice(key, 0, quest.answer[0]);
                        $scope.selectedAns[key] = quest.answer[0];
                    }
                }

                if (quest.type === "SA") {
                    if (!$scope.ansSa) {
                        $scope.ansSa = [];
                    }
                    if (!$scope.imageData) {
                        $scope.imageData = [];
                    }
                    $scope.imageData[key] = quest.answerImg;
                    $scope.ansSa[key] = quest.answer;
                } else if (quest.type === "LA") {
                    if (!$scope.ansLa) {
                        $scope.ansLa = [];
                    }
                    if (!$scope.imageData) {
                        $scope.imageData = [];
                    }
                    $scope.imageData[key] = quest.answerImg;
                    $scope.ansLa[key] = quest.answer;
                }

                if (quest.submit_status && quest.submit_status == "submit" && quest.is_attended) {
                    status = true;
                }

                $scope.totalQuestion.push({
                    question: quest,
                    count: key + 1,
                    isActive: false,
                    status: quest.submit_status ? quest.submit_status : 'normal',
                    label: quest.submit_status && quest.submit_status == 'review' ? 'Unmark' : 'Mark for review'
                });
                if ($scope.questions[key]) {
                    $scope.attendedQuesObj[key] = {
                        questionId: $scope.questions[key]._id,
                        mark: 0,
                        timeElapsed: 0,
                        section_name: $scope.questions[key].section_name
                    };
                }
            });
        }
        $scope.loadQuestionDirective = true;
        $scope.totalQuestiontoShow = $scope.questions.length;
    };

    function secondsToHrMin(secs) {
        var hours = Math.floor(secs / (60 * 60));

        var divisor_for_minutes = secs % (60 * 60);
        var minutes = Math.floor(divisor_for_minutes / 60);

        var divisor_for_seconds = divisor_for_minutes % 60;
        var seconds = Math.ceil(divisor_for_seconds);

        var obj = {
            "hour": hours,
            "min": minutes,
            "sec": seconds
        };
        return obj;
    }

    $scope.toggleFullScreen = function (fullScreen) {
        $scope.fullScreen = !fullScreen;
    };

    function clearTimer() {
        $interval.cancel(timeinterval);
        $scope.remainingTime = '00 : 00 : 00';
    }

    $scope.getTimeRemaining = function (endTime) {
        var t = Date.parse(endTime) - Date.parse(new Date());
        $scope.elapsedTimeForReset = t;
        var seconds = Math.floor(t / 1000 % 60);
        var minutes = Math.floor(t / 1000 / 60 % 60);
        var hours = Math.floor(t / (1000 * 60 * 60) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    };

    var MQ = MathQuill.getInterface(2);
    $scope.formatToLatex = function () {
        $timeout(function () {
            var questionElements = document.getElementsByClassName('question_desc');
            _.each(questionElements, function (spanElement) {
                MQ.StaticMath(spanElement);
            });
        }, 1000);
    };

    var timeinterval = void 0;
    $scope.initializeClock = function (endTime) {

        function updateClock() {
            if (!$scope.isSubmitted) {
                var t = $scope.getTimeRemaining(endTime);
                if (t) $scope.totalTimeRemaining = t.total;
                var days = t.days > 0 ? t.days + ' : ' : '';
                $scope.remainingTime = days + ('0' + t.hours).slice(-2) + " : " + ('0' + t.minutes).slice(-2) + " : " + ('0' + t.seconds).slice(-2);
                if ($scope.remainingTime == '00 : 00 : 00') {
                    $scope.remainingTime = '00 : 00 : 00';
                    $interval.cancel(timeinterval);
                    //Auto submission
                    //$scope.submitQuizQuestion()
                    submitAnsEachQuestion(false, true);
                }
            } else {
                $interval.cancel(timeinterval);
            }
        }

        updateClock();
        timeinterval = $interval(updateClock, 1000);
    };
    $scope.startTimer = function () {
        if ($scope.running === false) {
            startTime = new Date().getTime();
            interval = $interval($scope.updateTime, options.interval);
            $scope.running = true;
        }
    };

    $scope.updateTime = function () {
        currentTime = new Date().getTime();
        var timeElapsed = offset + (currentTime - startTime);
        options.elapsedTime.setTime(timeElapsed);
    };

    $scope.config = {
        autoHideScrollbar: true,
        theme: 'minimal'
    };

    $scope.stopTimer = function () {
        if ($scope.running === false) {
            return;
        }
        $scope.updateTime();
        offset = offset + currentTime - startTime;
        $scope.running = false;
        $scope.timeData = currentTime - startTime;
    };

    //timer with timeout
    $scope.timerWithTimeout = 0;
    $scope.startTimerWithTimeout = function () {
        $scope.timerWithTimeout = 0;
        if ($scope.myTimeout) {
            $timeout.cancel($scope.myTimeout);
        }
        $scope.onTimeout = function () {
            $scope.timerWithTimeout++;
            $scope.myTimeout = $timeout($scope.onTimeout, 1000);
        };
        $scope.myTimeout = $timeout($scope.onTimeout, 1000);
    };

    $scope.startTimerWithTimeout();
    $scope.resetTimerWithTimeout = function () {
        $scope.timerWithTimeout = 0;
        $timeout.cancel($scope.myTimeout);
    };

    //timer with interval
    $scope.timerWithInterval = 0;
    $scope.startTimerWithInterval = function () {
        $scope.timerWithInterval = 0;
        if ($scope.myInterval) {
            $interval.cancel($scope.myInterval);
        }
        $scope.onInterval = function () {
            $scope.timerWithInterval++;
        };
        $scope.myInterval = $interval($scope.onInterval, 1000);
    };

    $scope.resetTimerWithInterval = function () {
        $scope.timerWithInterval = 0;
        $interval.cancel($scope.myInterval);
    };

    /* Change question by clicking question number in left side*/
    $scope.changeQuestion = function (questCount) {
        if (questCount != $scope.indexToShow) {
            //Change button name for next question
            if ($scope.isPracticeTest) {
                if ($scope.totalQuestion[questCount].accessbility === true) {
                    $scope.accessbility = true;
                    $scope.disableCntrlBtn = true;
                } else {
                    if ($scope.totalQuestion.length === questCount + 1) {
                        $scope.actionBtnName = "Submit";
                    } else {
                        $scope.accessbility = false;
                        $scope.disableCntrlBtn = true;
                        $scope.actionBtnName = "Next";
                    }
                }
                if ($scope.totalQuestion[questCount].status === 'submit') {
                    $scope.resultStatus = 'Explanation';
                    var questObj = $scope.questions[questCount];
                    if (questObj.type == "MCQ") {
                        if (questObj.pattern == "single") {
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplanation = value.explanation;
                                }
                            });
                        } else {
                            $scope.ansExplantionMR = "";
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplantionMR += key + 1 + ' . ' + value.explanation;
                                }
                            });
                        }
                    } else if (questObj.type == "TF") {
                        angular.forEach(questObj.choice, function (value, key) {
                            if (value.correct) {
                                $scope.ansExplanation = value.explanation;
                            }
                        });
                    } else if (questObj.type == "FIB") {
                        $scope.ansExplantionFIB = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionFIB += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "OWQ") {
                        $scope.ansExplantionOWQ = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionOWQ += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "MTF") {
                        //for (var i = 0; i < $scope.quesData.length; i++) {
                        var optionsObj = questObj.option;
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each(optionsObj, function (option) {
                            index += 1;
                            var explanation = option.explanation === undefined ? 'NA' : option.explanation;
                            if (index === 1) {
                                $scope.ansExplantionMTF += index + ' . ' + explanation;
                            } else {
                                $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation;
                            }
                        });
                    }
                    $scope.isOptionSelected = true;
                } else {
                    $scope.isOptionSelected = false;
                }
            } else {
                $scope.evaluateQuizQuestion($scope.indexToShow);
                //To send details of each question. if student attend
                submitAnsEachQuestion(false, false);
            }
            $scope.indexToShow = questCount;
            if (!$scope.isPracticeTest) {
                $scope.startTimer();
            }
        }
    };

    /* Invoke while clicking review option*/

    $scope.reviewQuestion = function () {
        if ($scope.totalQuestion[$scope.indexToShow].label == "Mark for review") {
            $scope.totalQuestion[$scope.indexToShow].status = 'review';
            $scope.totalQuestion[$scope.indexToShow].label = 'Unmark';
        } else {
            $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            $scope.totalQuestion[$scope.indexToShow].label = 'Mark for review';
        }
    };

    /* Practice Test Starts*/

    var marks = {
        'student_id': userId,
        'type': 'PracticeTest',
        'date': currentDay,
        'result': [],
        "subject_id": authoring.subject_id,
        "session_id": authoring.session_id,
        "curriculum_id": authoring.curriculum_id,
        "batch_id": authoring.batch_id,
        "class_id": authoring.class_id,
        "theme_id": $scope.selectedThemeId,
        'activity_id': activityId,
        'qp_id': qpId
    };

    var scoreDetails = [];
    /* Submitting practice test questions*/
    $scope.submitQuestion = function () {
        if (!$scope.isOptionSelected) {
            toastr.error("Please answer the question");
            return;
        }
        if ($scope.actionBtnName == "Submit") {
            //|| $scope.actionBtnName == "Try Again") {
            $scope.noOfAttempts += 1;
            var isCorrectAns = false;
            var questObj = $scope.questions[$scope.indexToShow];
            var mark = $scope.questionCollection[$scope.indexToShow].mark_each_qn;
            if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    $scope.errorMcqQues = {};
                    angular.forEach(questObj.choice, function (value, key) {
                        if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc) {
                            $scope.stopTimer();
                            if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                                scoreDetails[$scope.indexToShow] = {
                                    mark: parseFloat(mark)
                                };
                                $scope.score += parseFloat(mark);
                            }
                            isCorrectAns = true;
                            $scope.answerType = "Correct Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "correct";
                            $scope.errorMcqQues[value.desc] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: value.hint
                            };
                            marks.result[$scope.indexToShow] = {
                                question_id: questObj._id,
                                attempt_count: $scope.noOfAttempts,
                                time_elapsed: $scope.timeData
                            };
                        } else if ($scope.selectedAns[$scope.indexToShow] == value.desc) {
                            $scope.answerType = "Wrong Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "wrong";
                            $scope.errorMcqQues[value.desc] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: value.hint
                            };
                        }
                    });
                } else {
                    var _wrongAnsCount = 0;
                    $scope.ansExplantionMR = '';
                    $scope.errorMrQues = {};
                    var _correctAns = '';
                    var choices = [];
                    var crctObj = _.filter(questObj.choice, function (det) {
                        return det.correct === true;
                    });
                    for (var i = crctObj.length - 1; i >= 0; i--) {
                        _correctAns += crctObj[i].desc + "[,]";
                    }

                    _.each(questObj.choice, function (choice) {
                        choices.push({
                            name: choice.desc,
                            "description": {
                                "en-US": choice.hint
                            }
                        });
                    });

                    angular.forEach(questObj.choice, function (value, key) {
                        if (value.correct) {
                            if ($scope.checkingChoiceExists(value.desc)) {
                                var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                $scope.errorMrQues[value.desc] = {
                                    answerType: 'Correct Answer',
                                    answerStatus: 'correct',
                                    msg: key + 1 + ' . ' + explanation
                                };
                                $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = key + 1 + ' . ' + explanation : $scope.ansExplantionMR += key + 1 + ' . ' + explanation;
                            } else {
                                _wrongAnsCount += 1;
                                //$scope.errorMrq[value.desc] = {answerType: 'Wrong Answer', answerStatus: 'wrong', msg:(key+1)+' . '+value.hint};
                            }
                            $scope.stopTimer();
                        } else if ($scope.checkingChoiceExists(value.desc)) {
                            _wrongAnsCount += 1;
                            var hint = value.hint === undefined ? 'NA' : value.hint;
                            $scope.errorMrQues[value.desc] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: key + 1 + ' . ' + hint
                            };
                            $scope.ansExplantionMR = key == 0 ? $scope.ansExplantionMR = key + 1 + ' . ' + hint : $scope.ansExplantionMR += key + 1 + ' . ' + hint;
                        }
                    });
                    if (_wrongAnsCount == 0) {
                        //$scope.score+=questObj.mark;
                        $scope.accessbility = false;
                        if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                            scoreDetails[$scope.indexToShow] = {
                                mark: parseFloat(mark)
                            };
                            $scope.score += parseFloat(mark);
                        }
                        marks.result[$scope.indexToShow] = {
                            question_id: questObj._id,
                            attempt_count: $scope.noOfAttempts,
                            time_elapsed: $scope.timeData
                        };
                        isCorrectAns = true;
                    }
                }
            } else if (questObj.type == "TF") {

                var keepGoing = false;
                $scope.errorTFQues = {};
                var correctAns;
                angular.forEach(questObj.choice, function (value, key) {
                    if (!keepGoing) {
                        if (value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag) {
                            correctAns = value.correct;
                            $scope.stopTimer();
                            //$scope.score+=questObj.mark;
                            if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                                scoreDetails[$scope.indexToShow] = {
                                    mark: parseFloat(mark)
                                };
                                $scope.score += parseFloat(mark);
                            }
                            marks.result[$scope.indexToShow] = {
                                question_id: questObj._id,
                                attempt_count: $scope.noOfAttempts,
                                time_elapsed: $scope.timeData
                                //marks.result.push(markObj)
                            };isCorrectAns = true;
                            $scope.accessbility = false;
                            keepGoing = true;
                            $scope.answerType = "Correct Answer";
                            $scope.ansExplanation = value.explanation === undefined ? 'NA' : value.explanation;
                            $scope.answerStatus = "correct";
                            $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: value.explanation
                            };
                        } else {
                            keepGoing = false;
                            $scope.answerType = "Wrong Answer";
                            $scope.ansExplanation = value.hint === undefined ? 'NA' : value.hint;
                            $scope.answerStatus = "wrong";
                            $scope.errorTFQues[$scope.selectedAns[$scope.indexToShow]] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: value.hint
                            };
                        }
                    }
                });
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var fibAnswerCount = questObj.question_answer.length;
                var wrongAnsCount = 0;
                $scope.ansExplantionFIB = '';
                var studentAnswer = '';
                var correctValue = '';
                angular.forEach(questObj.question_answer, function (value, key) {
                    if (value.desc != undefined) {
                        if ($scope.ansFib.length > 0) {
                            if ($scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                wrongAnsCount += 1;
                                $scope.stopTimer();
                                var hint = value.explanation === undefined ? 'NA' : value.explanation;
                                $scope.errorFib[value.desc] = {
                                    answerType: 'Cant be empty',
                                    answerStatus: 'info',
                                    msg: key + 1 + ' . ' + hint
                                };
                                $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + hint : $scope.ansExplantionFIB += key + 1 + ' . ' + hint;
                            } else {
                                var _correctValue = value.desc;
                                var _studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key];
                                if (_correctValue.toLowerCase().trim() == _studentAnswer.toLowerCase().trim()) {
                                    var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorFib[value.desc] = {
                                        answerType: 'Correct Answer',
                                        answerStatus: 'correct',
                                        msg: key + 1 + ' . ' + value.explanation
                                    };
                                    $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + explanation : $scope.ansExplantionFIB += key + 1 + ' . ' + explanation;
                                } else {
                                    $scope.stopTimer();
                                    var _hint = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorFib[value.desc] = {
                                        answerType: 'Wrong Answer',
                                        answerStatus: 'wrong',
                                        msg: key + 1 + ' . ' + _hint
                                    };
                                    $scope.ansExplantionFIB = key == 0 ? $scope.ansExplantionFIB = key + 1 + ' . ' + _hint : $scope.ansExplantionFIB += key + 1 + ' . ' + _hint;
                                    wrongAnsCount += 1;
                                }
                            }
                        } else {
                            wrongAnsCount += 1;
                            $scope.stopTimer();
                            var _hint2 = 'Cant be empty';
                            $scope.errorFib[value.desc] = {
                                answerType: 'Cant be empty',
                                answerStatus: 'info',
                                msg: key + 1 + ' . ' + _hint2
                            };
                        }
                    }
                });

                if (wrongAnsCount == 0) {
                    $scope.accessbility = false;
                    $scope.stopTimer();
                    //$scope.score+=questObj.mark;
                    if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                        scoreDetails[$scope.indexToShow] = {
                            mark: parseFloat(mark)
                        };
                        $scope.score += parseFloat(mark);
                    }
                    marks.result[$scope.indexToShow] = {
                        question_id: questObj._id,
                        attempt_count: $scope.noOfAttempts,
                        time_elapsed: $scope.timeData
                    };
                    isCorrectAns = true;
                }
            } else if (questObj.type == "OWQ") {
                var fibAnswerCount = questObj.answer.length;
                var wrongAnsCount = 0;
                $scope.ansExplantionOWQ = '';
                var correctans = undefined;
                angular.forEach(questObj.answer, function (value, key) {
                    if (value.desc != undefined) {
                        correctans = value.desc;
                        if ($scope.ansOwq.length > 0) {
                            if ($scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                wrongAnsCount += 1;
                                $scope.stopTimer();
                                var hint = value.hint === undefined ? 'NA' : value.hint;
                                $scope.errorOwq[value.desc] = {
                                    answerType: 'Cant be empty',
                                    answerStatus: 'info',
                                    msg: key + 1 + ' . ' + hint
                                };
                                $scope.ansExplantionOWQ = key + 1 + ' . ' + hint;
                            } else {
                                /*let correctValue = removeSpecialCharacter(value.desc)
                                let studentValue = removeSpecialCharacter($scope.ansOwq[$scope.indexToShow])*/

                                var _correctValue2 = value.desc;
                                var studentValue = $scope.ansOwq[$scope.indexToShow];
                                if (_correctValue2.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                    var explanation = value.explanation === undefined ? 'NA' : value.explanation;
                                    $scope.errorOwq[value.desc] = {
                                        answerType: 'Correct Answer',
                                        answerStatus: 'correct',
                                        msg: key + 1 + ' . ' + value.explanation
                                    };
                                    $scope.ansExplantionOWQ = key + 1 + ' . ' + explanation;
                                } else {
                                    $scope.stopTimer();
                                    var _hint3 = value.hint === undefined ? 'NA' : value.hint;
                                    $scope.errorOwq[value.desc] = {
                                        answerType: 'Wrong Answer',
                                        answerStatus: 'wrong',
                                        msg: key + 1 + ' . ' + _hint3
                                    };
                                    $scope.ansExplantionOWQ = key + 1 + ' . ' + _hint3;
                                    wrongAnsCount += 1;
                                }
                            }
                        } else {
                            wrongAnsCount += 1;
                            $scope.stopTimer();
                            var _hint4 = 'Cant be empty';
                            $scope.errorOwq[value.desc] = {
                                answerType: 'Cant be empty',
                                answerStatus: 'info',
                                msg: key + 1 + ' . ' + _hint4
                            };
                        }
                    }
                });

                if (wrongAnsCount == 0) {
                    //babin
                    $scope.accessbility = false;
                    //
                    $scope.stopTimer();
                    //$scope.score+=questObj.mark;
                    if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                        scoreDetails[$scope.indexToShow] = {
                            mark: parseFloat(mark)
                        };
                        $scope.score += parseFloat(mark);
                    }
                    marks.result[$scope.indexToShow] = {
                        question_id: questObj._id,
                        attempt_count: $scope.noOfAttempts,
                        time_elapsed: $scope.timeData
                    };
                    isCorrectAns = true;
                }
            } else if (questObj.type == "MTF") {
                $scope.ansExplantionMTF = '';
                var _wrongAnsCount2 = 0;
                var _correctans = '';
                var source = [];
                var target = [];

                for (var i = 0; i < questObj.option.length; i++) {
                    var optionsObj = questObj.option[i];

                    _correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]";

                    source.push({
                        "id": optionsObj.question.desc,
                        "description": {
                            "en-US": optionsObj.question.desc
                        }
                    });

                    target.push({
                        "id": optionsObj.answer.desc,
                        "description": {
                            "en-US": optionsObj.answer.desc
                        }
                    });

                    for (var i = 0; i < questObj.option.length; i++) {
                        var optionsObj = questObj.option[i];
                        if ($scope.questions[$scope.indexToShow].quesData[i].tag == optionsObj.question.tag && $scope.questions[$scope.indexToShow].optionAnswer[i].desc == optionsObj.answer.desc) {
                            var explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation;
                            $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                answerType: 'Correct Answer',
                                answerStatus: 'correct',
                                msg: i + 1 + ' . ' + explanation
                            };
                            $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = i + 1 + ' . ' + explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + explanation;
                        } else {
                            var _explanation = optionsObj.explanation === undefined ? 'NA' : optionsObj.explanation;
                            $scope.errorMtf[$scope.questions[$scope.indexToShow].quesData[i].tag] = {
                                answerType: 'Wrong Answer',
                                answerStatus: 'wrong',
                                msg: i + 1 + ' . ' + _explanation
                            };
                            _wrongAnsCount2 += 1;
                            $scope.ansExplantionMTF = i == 0 ? $scope.ansExplantionMTF = i + 1 + ' . ' + _explanation : $scope.ansExplantionMTF += ' , ' + (i + 1) + ' . ' + _explanation;
                        }
                    }
                    if (_wrongAnsCount2 == 0) {
                        $scope.accessbility = false;
                        $scope.stopTimer();
                        //$scope.score+=questObj.mark.total;
                        if (scoreDetails.length > 0 && scoreDetails[$scope.indexToShow] != undefined) {} else {
                            scoreDetails[$scope.indexToShow] = {
                                mark: parseFloat(mark)
                            };
                            $scope.score += parseFloat(mark); //.total;
                        }
                        isCorrectAns = true;
                        marks.result[$scope.indexToShow] = {
                            question_id: questObj._id,
                            attempt_count: $scope.noOfAttempts,
                            time_elapsed: $scope.timeData
                        };
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each($scope.errorMtf, function (obj, key) {
                            if (obj.answerStatus === 'correct') {
                                index += 1;
                                if (index === 1) {
                                    $scope.ansExplantionMTF += obj.msg;
                                } else {
                                    $scope.ansExplantionMTF += ' , ' + obj.msg;
                                }
                            }
                        });
                    } else {
                        var index = 0;
                        _.each($scope.errorMtf, function (obj, key) {
                            if (obj.answerStatus === 'wrong') {
                                index += 1;
                                if (index === 1) {
                                    $scope.ansExplantionMTF += obj.msg;
                                } else {
                                    $scope.ansExplantionMTF += ' , ' + obj.msg;
                                }
                            }
                        });
                    }
                }
            }

            if (isCorrectAns) {
                $scope.resultStatus = 'Explanation';
                $scope.totalQuestion[$scope.indexToShow].isActive = true;
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                $scope.totalQuestion[$scope.indexToShow].accessbility = false;
                if ($scope.indexToShow + 1 != $scope.questions.length) {
                    $scope.actionBtnName = "Next";
                } else {
                    marks.theme_id = $scope.selectedThemeId;
                    marks.date = currentDay;
                    var questionCount = $scope.totalQuestion.length;
                    var answeredCount = 0;
                    _.each($scope.totalQuestion, function (quest) {
                        if (quest.status === 'submit') {
                            answeredCount++;
                        }
                    });
                    if (questionCount === answeredCount) {
                        $scope.disableCntrlBtn = false;
                    } else {
                        var remainingQuestion = questionCount - answeredCount;
                        toastr.success("Still you have to practice" + remainingQuestion + "question(s)");
                    }
                }
                $scope.noOfAttempts = 0;
            } else {
                $scope.resultStatus = 'Hint';
                $scope.actionBtnName = "Try Again";
            }
        } else if ($scope.actionBtnName == "Next") {
            //$scope.startTimer()
            $scope.answerStatus = "normal";
            // load next question
            $scope.accessbility = true;
            $scope.indexToShow = ($scope.indexToShow + 1) % $scope.questions.length;
            //$scope.isOptionSelected = false;
            if ($scope.isPracticeTest) {

                $scope.resetValues();
                if ($scope.totalQuestion[$scope.indexToShow].status === 'submit') {
                    if ($scope.totalQuestion.length === $scope.indexToShow + 1) {
                        $scope.actionBtnName = "Submit";
                    } else {
                        $scope.actionBtnName = "Next";
                    }

                    $scope.accessbility = false;
                    $scope.resultStatus = 'Explanation';
                    var questObj = $scope.questions[$scope.indexToShow];
                    if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                        if (questObj.pattern == "single") {
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplanation = value.explanation;
                                }
                            });
                        } else {
                            $scope.ansExplantionMR = "";
                            angular.forEach(questObj.choice, function (value, key) {
                                if (value.correct) {
                                    $scope.ansExplantionMR += key + 1 + ' . ' + value.explanation;
                                }
                            });
                        }
                    } else if (questObj.type == "TF") {
                        angular.forEach(questObj.choice, function (value, key) {
                            if (value.correct) {
                                $scope.ansExplanation = value.explanation;
                            }
                        });
                    } else if (questObj.type == "FIB") {
                        $scope.ansExplantionFIB = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionFIB += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "OWQ") {
                        $scope.ansExplantionOWQ = "";
                        angular.forEach(questObj.answer, function (value, key) {
                            if (value.desc != undefined) {
                                $scope.ansExplantionOWQ += key + 1 + ' . ' + value.explanation;
                            }
                        });
                    } else if (questObj.type == "MTF") {
                        //for (var i = 0; i < $scope.quesData.length; i++) {
                        var optionsObj = questObj.option;
                        $scope.ansExplantionMTF = '';
                        var index = 0;
                        _.each(optionsObj, function (option) {
                            index += 1;
                            var explanation = option.explanation === undefined ? 'NA' : option.explanation;
                            if (index === 1) {
                                $scope.ansExplantionMTF += index + ' . ' + explanation;
                            } else {
                                $scope.ansExplantionMTF += ' , ' + index + ' . ' + explanation;
                            }
                        });
                    }
                    $scope.isOptionSelected = true;
                } else {
                    $scope.isOptionSelected = false;
                }
            }
        } else if ($scope.actionBtnName == "Try Again") {
            $scope.resetValues();
            $scope.isOptionSelected = false;
            var questObj = $scope.questions[$scope.indexToShow];
            if (questObj.type == "TF") {
                var idx = $scope.selectedAns[$scope.indexToShow];
                $scope.selectedDesc = "";
                if (idx != undefined) {
                    $scope.selectedAns.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var idx = $scope.ansFib[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansFib.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "OWQ") {
                var idx = $scope.ansOwq[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansOwq.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    var idx = $scope.selectedAns[$scope.indexToShow];
                    $scope.selectedDesc = "";
                    if (idx != undefined) {
                        $scope.selectedAns.splice($scope.indexToShow, 1);
                    }
                } else {
                    var emptyarry = [];
                    $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry;
                }
            }
        }
    };

    /* Practice Test Ends*/

    $scope.checkingChoiceExists = function (item) {
        var isChecked = false;
        if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
            $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow];
            return $scope.selectedCheckAns.indexOf(item) > -1;
        } else {
            return isChecked;
        }
    };

    $scope.resetValues = function () {
        //Change button name for next question
        $scope.actionBtnName = "Submit";
        //Empty the answer type and explanation
        $scope.removeErrors();
    };
    $scope.removeErrors = function () {
        //Empty the answer type and explanation
        $scope.answerType = "";
        $scope.ansExplanation = "";
        //$scope.ansFib = [];
        $scope.errorFib = {};
        $scope.errorOwq = {};
        $scope.errorMtf = {};
        $scope.errorMcqQues = {};
        $scope.errorMrQues = {};
        $scope.resultStatus = '';
        $scope.selectedDesc = '';
        $scope.errorTFQues = {};
        $scope.ansExplantionMTF = '';
        $scope.ansExplantionMR = '';
        $scope.ansExplantionFIB = '';
        $scope.ansExplantionOWQ = '';
    };

    /* Invoke while clicking Prev button*/
    $scope.loadPrevQues = function () {
        $scope.evaluateQuizQuestion($scope.indexToShow);
        //To send details of each question. if student attend
        submitAnsEachQuestion(false, false);
        $scope.indexToShow = ($scope.indexToShow - 1) % $scope.totalQuestiontoShow;
        $scope.isOptionSelected = false;
    };

    /* Invoke while clicking Next button*/
    $scope.loadNextQues = function () {
        $scope.$broadcast('showQuestion');
        if ($scope.indexToShow + 1 != $scope.totalQuestiontoShow) {
            $scope.evaluateQuizQuestion($scope.indexToShow);

            //To send details of each question. if student attend
            submitAnsEachQuestion(false, false);

            $scope.indexToShow = ($scope.indexToShow + 1) % $scope.totalQuestiontoShow;
            $scope.isOptionSelected = false;
        } else {
            //To send details of last question. if student attend
            submitAnsEachQuestion(true, false);
        }
        // $scope.startTimer()
    };

    function removeSpecialCharacter(value) {
        if (value) {
            value = value.replace(/\\quad/g, "");
            value = value.replace(/\\/g, "");
        }
        return value;
    }

    /* Evaluate selected answer*/
    $scope.evaluateQuizQuestion = function (index) {

        var isCorrectAns = false;
        var questionMark = 0;
        var selectedChoice = [];
        var imageData = [];
        var questObj = $scope.questions[index];

        //let mark = $scope.questionCollection[$scope.indexToShow].mark;
        var mark = $scope.questions[$scope.indexToShow].mark_each_qn;

        $scope.stopTimer();
        $scope.timeData = $scope.attendedQuesObj[$scope.indexToShow].timeElapsed + $scope.timeData;

        /*START - MCQ*/
        if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
            if (questObj.pattern == "single") {
                if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                    selectedChoice.push($scope.selectedAns[$scope.indexToShow]);
                    if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    }
                }

                var crctAnsObj = _.find(questObj.choice, function (value) {
                    return value.correct && $scope.selectedAns[$scope.indexToShow] == value.desc;
                });

                if (crctAnsObj != undefined) {
                    isCorrectAns = true;
                    questionMark = parseFloat(mark);
                }
            } else {
                var wrongAnsCount = 0;
                var attendedCount = 0;
                var answerChoiceLength = 0;
                var choosenCorrectCount = 0;
                var choosenWrongCount = 0;
                if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                    var mrqObj = $scope.multipleCheckAnsData[$scope.indexToShow];
                    if (mrqObj) {
                        answerChoiceLength = mrqObj.length;
                    }
                }
                if (answerChoiceLength > 0) {
                    attendedCount += 1;
                }
                //get Correct answer count
                var crctObj = _.filter(questObj.choice, function (det) {
                    return det.correct === true;
                });

                var correctAns = '';
                var choices = [];
                for (var i = crctObj.length - 1; i >= 0; i--) {
                    correctAns += crctObj[i].desc + "[,]";
                }

                _.each(questObj.choice, function (choice) {
                    choices.push({
                        name: choice.desc,
                        "description": {
                            "en-US": choice.hint
                        }
                    });
                });

                var correcrAnswerCount = crctObj ? crctObj.length : 0;
                if (answerChoiceLength === questObj.choice.length) {
                    questionMark = 0;
                    _.each(questObj.choice, function (choice) {
                        if (choice.correct) {
                            if ($scope.checkingChoiceExists(choice.desc)) {
                                //CASE : Correct Ans
                                selectedChoice.push(choice.desc);
                                choosenCorrectCount += 1;
                            } else {
                                wrongAnsCount += 1;
                            }
                        } else if ($scope.checkingChoiceExists(choice.desc)) {
                            wrongAnsCount += 1;
                            selectedChoice.push(choice.desc);
                            choosenWrongCount += 1;
                        }
                    });
                } else {
                    _.each(questObj.choice, function (choice) {
                        if (choice.correct) {
                            if ($scope.checkingChoiceExists(choice.desc)) {
                                //CASE : Correct Ans
                                selectedChoice.push(choice.desc);
                                choosenCorrectCount += 1;
                            } else {
                                wrongAnsCount += 1;
                            }
                        } else if ($scope.checkingChoiceExists(choice.desc)) {
                            wrongAnsCount += 1;
                            selectedChoice.push(choice.desc);
                            choosenWrongCount += 1;
                        }
                    });
                    if (correcrAnswerCount === choosenCorrectCount && choosenWrongCount === 0) {
                        questionMark = parseFloat(mark);
                    } else {
                        if (choosenCorrectCount >= choosenWrongCount && choosenCorrectCount > 0 && choosenWrongCount > 0) {
                            questionMark = parseFloat(parseFloat(mark) / 2);
                        } else if (choosenCorrectCount > 0 && choosenWrongCount === 0 && choosenCorrectCount >= Math.round(correcrAnswerCount / 2)) {
                            questionMark = parseFloat(parseFloat(mark) / 2);
                        }
                    }
                    if (wrongAnsCount == 0) {
                        isCorrectAns = true;
                        questionMark = parseFloat(mark);
                    }
                }
            }
        }
        /*END - MCQ*/

        /* START - TF*/
        else if (questObj.type == "TF") {
                var keepGoing = false;
                var _correctAns2 = false;
                if ($scope.selectedAns[$scope.indexToShow] != undefined) {
                    selectedChoice.push($scope.selectedAns[$scope.indexToShow]);
                }

                var tfAnsObj = _.find(questObj.choice, function (value) {
                    return value.correct && $scope.selectedAns[$scope.indexToShow] == value.tag;
                });

                if (tfAnsObj != undefined) {
                    isCorrectAns = true;
                    keepGoing = true;
                    questionMark = parseFloat(mark);
                }
            }
            /*END - TF*/

            /*START - FIB*/
            else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                    if (questObj.answerImg) imageData.push(questObj.answerImg);
                    var fibAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                    var wrongAnsCount = 0;
                    var _attendedCount = 0;
                    if (questObj.question_answer) {
                        _.each(questObj.question_answer, function (value, key) {
                            if (value != undefined && value.desc != undefined) {
                                if ($scope.ansFib.length > 0) {
                                    if ($scope.ansFib[$scope.indexToShow] == undefined || $scope.ansFib[$scope.indexToShow].choice[key] == "" || $scope.ansFib[$scope.indexToShow].choice[key] == undefined) {
                                        wrongAnsCount += 1;
                                        selectedChoice.push(undefined);
                                        //$scope.stopTimer();
                                        //Case : User doesnt't write
                                    } else {
                                        _attendedCount += 1;
                                        /*let correctValue = removeSpecialCharacter(value.desc)
                                        let studentAnswer = removeSpecialCharacter($scope.ansFib[$scope.indexToShow].choice[key])
                                        */
                                        var correctValue = value.desc;
                                        var studentAnswer = $scope.ansFib[$scope.indexToShow].choice[key];
                                        if (correctValue.toLowerCase().trim() == studentAnswer.toLowerCase().trim()) {
                                            //Case :  Correct Answer
                                            //$scope.stopTimer();                                    
                                            selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key]);
                                        } else {
                                            //Case :  Wrong Answer
                                            wrongAnsCount += 1;
                                            selectedChoice.push($scope.ansFib[$scope.indexToShow].choice[key]);
                                        }
                                    }
                                } else {
                                    wrongAnsCount += 1;
                                    selectedChoice.push(undefined);
                                }
                            }
                        });
                    }

                    if (wrongAnsCount == 0) {
                        isCorrectAns = true;
                        questionMark = parseFloat(mark);
                    }

                    /* $scope.stopTimer();*/
                }
                /*END - FIB*/

                /*START - OWQ*/
                else if (questObj.type == "OWQ") {
                        var owqAnswerCount = questObj.question_answer != undefined ? questObj.question_answer.length : 0;
                        var wrongAnsCount = 0;
                        var _attendedCount2 = 0;
                        if (questObj.answerImg) imageData.push(questObj.answerImg);
                        if (questObj.question_answer) {

                            _.each(questObj.question_answer, function (value, key) {
                                if (value != undefined && value.desc != undefined) {
                                    if ($scope.ansOwq.length > 0) {
                                        if ($scope.ansOwq[$scope.indexToShow] == undefined || $scope.ansOwq[$scope.indexToShow] == "" || $scope.ansOwq[$scope.indexToShow] == undefined) {
                                            wrongAnsCount += 1;
                                            selectedChoice.push(undefined);
                                            //$scope.stopTimer();
                                            //Case : User doesnt't write
                                        } else {
                                            _attendedCount2 += 1;
                                            var correctValue = value.desc;
                                            var studentValue = $scope.ansOwq[$scope.indexToShow];
                                            if (correctValue.toLowerCase().trim() == studentValue.toLowerCase().trim()) {
                                                //Case :  Correct Answer
                                                //$scope.stopTimer();
                                                selectedChoice.push($scope.ansOwq[$scope.indexToShow]);
                                            } else {
                                                //Case :  Wrong Answer
                                                wrongAnsCount += 1;
                                                selectedChoice.push($scope.ansOwq[$scope.indexToShow]);
                                            }
                                        }
                                    } else {
                                        wrongAnsCount += 1;
                                        selectedChoice.push(undefined);
                                    }
                                }
                            });
                        }

                        if (wrongAnsCount == 0) {
                            isCorrectAns = true;
                            questionMark = parseFloat(mark);
                        }
                        /* $scope.stopTimer();*/
                    }
                    /*END - OWQ*/

                    /*START - MTF*/
                    else if (questObj.type == "MTF") {
                            if ($scope.isOptionSelected == true) {
                                var eachOptMark = parseFloat(mark / questObj.optionAnswer.length);
                                var wrongAnsCount = 0;
                                var crctAnsCount = 0;
                                for (var i = 0; i < questObj.optionAnswer.length; i++) {

                                    var optionsObj = questObj.option[i];

                                    if (questObj.optionAnswer[i].tag == optionsObj.answer.tag) {
                                        crctAnsCount++;
                                        var desc = questObj.optionAnswer[i].desc !== undefined ? optionsObj.answer.desc : undefined;
                                        var mtfAnsObj = {
                                            "desc": desc,
                                            "optImage": optionsObj.answer.optImage
                                        };
                                        selectedChoice.push(mtfAnsObj);
                                    } else {
                                        //Case : Wrong Answer
                                        wrongAnsCount += 1;
                                        var _mtfAnsObj = {
                                            "desc": questObj.optionAnswer[i].desc,
                                            "optImage": questObj.optionAnswer[i].optImage
                                        };
                                        selectedChoice.push(_mtfAnsObj);
                                    }
                                }

                                //questionMark = parseFloat(eachOptMark * crctAnsCount) 
                                if (wrongAnsCount == 0) {

                                    isCorrectAns = true;
                                } else {
                                    isCorrectAns = false;
                                }

                                var correctans = '';
                                var source = [];
                                var target = [];

                                for (var i = 0; i < questObj.length; i++) {
                                    var optionsObj = questObj.option[i];

                                    correctans += optionsObj.question.desc + "[.]" + optionsObj.answer.desc + "[,]";

                                    source.push({
                                        "id": optionsObj.question.desc,
                                        "description": {
                                            "en-US": optionsObj.question.desc
                                        }
                                    });

                                    target.push({
                                        "id": optionsObj.answer.desc,
                                        "description": {
                                            "en-US": optionsObj.answer.desc
                                        }
                                    });
                                }
                            }

                            var isAttend = false;

                            if (questObj.answer && questObj.answer.length > 0) {
                                isAttend = true;
                                if (selectedChoice.length == 0) {
                                    selectedChoice = questObj.answer;
                                }
                            } else if ($scope.attendedQuesObj[$scope.indexToShow] && $scope.attendedQuesObj[$scope.indexToShow].answer && $scope.attendedQuesObj[$scope.indexToShow].answer.length > 0) {
                                isAttend = true;
                                //console.log(selectedChoice) 
                                selectedChoice = $scope.attendedQuesObj[$scope.indexToShow].answer;
                            } else {
                                isAttend = $scope.isOptionSelected;
                            }

                            var obj = {
                                questionId: questObj.question_id,
                                mark: 0,
                                timeElapsed: $scope.timeData,
                                q_type: questObj.type,
                                answer: selectedChoice,
                                section_name: questObj.section_name,
                                is_attended: isAttend
                            };
                            $scope.attendedQuesObj[$scope.indexToShow] = obj;

                            //console.log($scope.totalQuestion[$scope.indexToShow].label)

                            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && isAttend) {
                                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                                $scope.totalQuestion[$scope.indexToShow].status = 'review';
                            } else {
                                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
                            }

                            /* $scope.stopTimer();*/
                        }
                        /*END - MTF*/

                        /*START - SA*/
                        else if (questObj.type == "SA" || questObj.type == "LA") {
                                isCorrectAns = true;
                                questionMark = parseFloat(mark); //.total;
                            }
        /*END - SA*/

        if (questObj.type == "SA") {
            var _isAttend = false;
            if ($scope.ansSa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                if (_.compact($scope.ansSa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                    $scope.attendedQuesObj[$scope.indexToShow] = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: $scope.ansSa[$scope.indexToShow],
                        section_name: questObj.section_name,
                        is_attended: true
                    };
                    _isAttend = true;
                    /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    } */

                    //$scope.attendedQuesObj[$scope.indexToShow] = obj
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            } else {
                $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
             if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
             $scope.totalQuestion[$scope.indexToShow].status = 'submit';
             }
             }*/
        } else if (questObj.type == "LA") {
            var _isAttend2 = false;
            if ($scope.ansLa[$scope.indexToShow] || $scope.imageData[$scope.indexToShow]) {
                if (_.compact($scope.ansLa[$scope.indexToShow]).length > 0 || $scope.imageData[$scope.indexToShow].length > 0) {
                    $scope.attendedQuesObj[$scope.indexToShow] = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: $scope.ansLa[$scope.indexToShow],
                        section_name: questObj.section_name,
                        is_attended: true

                    };
                    _isAttend2 = true;
                    /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                        $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                    } */

                    //$scope.attendedQuesObj[$scope.indexToShow] = obj
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            } else {
                $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend2) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }

            /*if ($scope.imageData[$scope.indexToShow] != undefined || questObj.answer != undefined) {
             if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
             $scope.totalQuestion[$scope.indexToShow].status = 'submit';
             }
             }*/
        } else if (questObj.type == "DRAW") {
            if (questObj.answerImg !== undefined) {

                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    /* images: $scope.imageData[$scope.indexToShow],*/
                    answer: $scope.ansDraw[$scope.indexToShow],
                    answerImg: questObj.answerImg,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "ASLLISTEN") {
            if (_.compact(_.flatten(_.pluck($scope.ansAslListen[$scope.indexToShow].ans, 'answer'))).length > 0) {
                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: $scope.ansAslListen[$scope.indexToShow].ans,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "ASLSPEAK") {
            if ($scope.ansAslSpeak[$scope.indexToShow].answer != '') {

                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: 0,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: $scope.ansAslSpeak[$scope.indexToShow].answer,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected
                };
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            }
        } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB" || questObj.type == "OWQ") {
            var _isAttend3 = false;
            if (selectedChoice || $scope.imageData[$scope.indexToShow]) {

                //console.log(_.compact(selectedChoice))
                //console.log(selectedChoice)
                //console.log($scope.imageData[$scope.indexToShow])

                var ansData = _.compact(selectedChoice);
                var imgData = $scope.imageData[$scope.indexToShow];

                if (ansData && ansData.length > 0 || imgData && imgData.length > 0) {
                    var _obj = {
                        questionId: questObj.question_id,
                        mark: 0,
                        timeElapsed: $scope.timeData,
                        q_type: questObj.type,
                        imageData: $scope.imageData[$scope.indexToShow],
                        answer: selectedChoice,
                        section_name: questObj.section_name,
                        is_attended: true

                    };
                    _isAttend3 = true;
                    /*  if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                         $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                     } */
                    $scope.attendedQuesObj[$scope.indexToShow] = _obj;
                } else {
                    $scope.attendedQuesObj[$scope.indexToShow]["imageData"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["answer"] = [];
                    $scope.attendedQuesObj[$scope.indexToShow]["is_attended"] = false;
                    //$scope.totalQuestion[$scope.indexToShow].status = 'normal';
                }
            }

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend3) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }
        } else if (questObj.type != "MTF") {

            var _isAttend4 = false;
            var _mark = 0;
            var _ansData = _.compact(selectedChoice);
            if (_ansData && _ansData.length > 0) {
                if (questObj.type !== 'MTF') {
                    _mark = questionMark.toFixed(2);
                }
                /* if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                } */
            }

            /* console.log("==========================")
            console.log(ansData)
            console.log($scope.multipleCheckAnsData)
            console.log(questObj.answer)
                console.log("==========================") */

            var _obj2 = {
                questionId: questObj.question_id,
                mark: _mark,
                timeElapsed: $scope.timeData,
                q_type: questObj.type,
                answer: selectedChoice,
                section_name: questObj.section_name,
                is_attended: _ansData && _ansData.length > 0 ? true : false
            };

            _isAttend4 = _ansData && _ansData.length > 0 ? true : false;
            $scope.attendedQuesObj[$scope.indexToShow] = _obj2;
            //$scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected

            if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark' && _isAttend4) {
                $scope.totalQuestion[$scope.indexToShow].status = 'submit';
            } else if ($scope.totalQuestion[$scope.indexToShow].label == 'Unmark') {
                $scope.totalQuestion[$scope.indexToShow].status = 'review';
            } else {
                $scope.totalQuestion[$scope.indexToShow].status = 'normal';
            }
        }

        /*  else {
            if (_.compact(selectedChoice).length > 0) {
                let mark = 0
                if (questObj.type !== 'MTF')
                    mark = questionMark.toFixed(2)
                $scope.attendedQuesObj[$scope.indexToShow] = {
                    questionId: questObj.question_id,
                    mark: mark,
                    timeElapsed: $scope.timeData,
                    q_type: questObj.type,
                    answer: selectedChoice,
                    section_name: questObj.section_name,
                    is_attended: $scope.isOptionSelected,
                    imageData: imageData
                }
                if ($scope.totalQuestion[$scope.indexToShow].label != 'Unmark') {
                    $scope.totalQuestion[$scope.indexToShow].status = 'submit';
                }
            } else
                $scope.attendedQuesObj[$scope.indexToShow]['is_attended'] = $scope.isOptionSelected
        } */
    };

    /* Set selected answer for evaluation */
    $scope.setSelectedAns = function (option, quesType, ansType, index) {
        if ($scope.actionBtnName === "Try Again") {
            $scope.actionBtnName = "Submit";

            $scope.resetValues();
            $scope.isOptionSelected = false;
            var questObj = $scope.questions[$scope.indexToShow];
            if (questObj.type == "TF") {
                var idx = $scope.selectedAns[$scope.indexToShow];
                $scope.selectedDesc = "";
                if (idx != undefined) {
                    $scope.selectedAns.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "FIB" || questObj.type == "IBT_FIB") {
                var idx = $scope.ansFib[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansFib.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "OWQ") {
                var idx = $scope.ansOwq[$scope.indexToShow];
                if (idx != undefined) {
                    $scope.ansOwq.splice($scope.indexToShow, 1);
                }
            } else if (questObj.type == "MCQ" || questObj.type == "IBT_MCQ") {
                if (questObj.pattern == "single") {
                    var idx = $scope.selectedAns[$scope.indexToShow];
                    $scope.selectedDesc = "";
                    if (idx != undefined) {
                        $scope.selectedAns.splice($scope.indexToShow, 1);
                    }
                } else {

                    var emptyarry = [];
                    $scope.multipleCheckAnsData[$scope.indexToShow] = emptyarry;
                }
            }
        }

        if (quesType == "MCQ" || quesType == "TF") {
            $scope.isOptionSelected = true;
            $scope.selectedDesc = option;
            $scope.selectedAns[$scope.indexToShow] = option;
        } else if (quesType == "MR") {
            $scope.isOptionSelected = true;
            $scope.selectedCheckAns = [];
            if ($scope.multipleCheckAnsData[$scope.indexToShow] != undefined) {
                $scope.selectedCheckAns = $scope.multipleCheckAnsData[$scope.indexToShow];
                var idx = $scope.selectedCheckAns.indexOf(option);
                if (idx > -1) {
                    $scope.selectedCheckAns.splice(idx, 1);
                } else {
                    $scope.selectedCheckAns.push(option);
                }
            } else {
                $scope.selectedCheckAns.push(option);
            }
            $scope.multipleCheckAnsData[$scope.indexToShow] = $scope.selectedCheckAns;
        } else if (quesType == "FIB") {
            if ($scope.ansFib[$scope.indexToShow] != undefined) {
                $scope.isOptionSelected = true;
            }
        } else if (quesType == "OWQ") {
            if ($scope.ansOwq[$scope.indexToShow] != undefined) {
                $scope.isOptionSelected = true;
            }
        } else if (quesType == "ASLLISTEN") {
            if (ansType == "MCQ" || ansType == "TF") {
                $scope.ansAslListen[$scope.indexToShow].ans[index].answer = option;
            } else if (ansType == "MR") {
                $scope.selectedCheckAns = [];
                if ($scope.ansAslListen[$scope.indexToShow].ans[index].answer[$scope.indexToShow] != undefined) {
                    $scope.selectedCheckAns = $scope.ansAslListen[$scope.indexToShow].ans[index].answer;
                    var idx = $scope.selectedCheckAns.indexOf(option);
                    if (idx > -1) {
                        $scope.selectedCheckAns.splice(idx, 1);
                    } else {
                        $scope.selectedCheckAns.push(option);
                    }
                } else {
                    $scope.selectedCheckAns.push(option);
                }
                $scope.ansAslListen[$scope.indexToShow].ans[index].answer = $scope.selectedCheckAns;
            }
        }
    };

    var quizMarks = {
        'student_id': userId,
        'date': currentDay,
        'time_elapsed': $scope.elapsedTime,
        'score': 0,
        'total_mark': 0,
        'activity_id': activityId,
        'qp_id': qpId,
        'result': []

        /* Invoke while submitting last question */
    };$scope.submitQuizQuestion = function () {
        $scope.stopTimer();
        $scope.evaluateQuizQuestion($scope.indexToShow);
        var isReviewedQuestionCount = 0;
        _.each($scope.totalQuestion, function (question, key) {
            if (question.status == 'review') {
                isReviewedQuestionCount++;
            }
        });
        if (isReviewedQuestionCount == 0) {
            var confirm = $mdDialog.confirm().title('Do you want to submit the exam?').targetEvent(event).ariaLabel('Information').ok('YES').cancel('NO');
            $mdDialog.show(confirm).then(function () {
                $scope.submitExam();
            }, function () {
                //toastr.success("You decided to continue the exam")
            });
        } else {
            var confirm = $mdDialog.confirm().title('You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam').targetEvent(event).ariaLabel('Review Alert').ok('YES').cancel('NO');
            $mdDialog.show(confirm).then(function () {
                $scope.submitExam();
            }, function () {
                toastr.success("You decided to continue the exam");
                // ToastService.getToastbox($mdToast, 'You decided to continue the exam', 'success-toast')
                //'You decided to keep your entry.';
            });
        }
    };

    /* Submit exam data to server */
    $scope.submitExam = function () {
        $scope.isSubmitted = true;
        localStorage.removeItem("backfromexam");
        localStorage.setItem('activitySubmitted', true);
        var finalScore = 0;
        var timeSpent = 0;

        for (var i = 0; i < $scope.attendedQuesObj.length; i++) {
            if ($scope.attendedQuesObj[i] != undefined) {

                //Get Spent Time
                timeSpent += parseInt($scope.attendedQuesObj[i].timeElapsed);

                finalScore += parseFloat($scope.attendedQuesObj[i].mark);
                if ($scope.attendedQuesObj[i].q_type == "SA" || $scope.attendedQuesObj[i].q_type == "LA") {

                    if ($scope.attendedQuesObj[i].images != undefined) {
                        _.each($scope.attendedQuesObj[i].images.images, function (imgs) {
                            delete imgs.$$hashKey;
                        });
                    }

                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answerImg: $scope.attendedQuesObj[i].imageData,
                        answer: $scope.attendedQuesObj[i].answer ? $scope.attendedQuesObj[i].answer : "",
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                } else if ($scope.attendedQuesObj[i].q_type == "DRAW") {
                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answer: $scope.attendedQuesObj[i].answer,
                        answerImg: $scope.attendedQuesObj[i].answerImg,
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                } else {
                    quizMarks.result.push({
                        question_id: $scope.attendedQuesObj[i].questionId,
                        mark: $scope.attendedQuesObj[i].mark,
                        time_elapsed: $scope.attendedQuesObj[i].timeElapsed,
                        q_type: $scope.attendedQuesObj[i].q_type,
                        answer: $scope.attendedQuesObj[i].answer,
                        section_name: $scope.attendedQuesObj[i].section_name,
                        is_attended: $scope.attendedQuesObj[i].is_attended
                    });
                }
            }
        }
        quizMarks.time_elapsed = $scope.elapsedTime;
        quizMarks.score = finalScore; //.toFixed(2)
        quizMarks.total_mark = $scope.quizTotalMark;
        quizMarks.activity_id = activityId;
        quizMarks.qp_id = qpId;
        quizMarks.time_spent = timeSpent;

        if ($scope.totalTimeRemaining) quizMarks.totalTimeRemaining = $scope.totalTimeRemaining;
        $scope.isPracticeTest = false;
        $scope.isActivity = false;
    };

    /*
     * To submit attended question to server
     * 
     * @isLstQues : Boolean - Last question check
     * @isAutoSubmit : Boolean - Auto submission check
     * @return : null
     * @Developer : Jeevanantham N
     */
    var submitAnsEachQuestion = function submitAnsEachQuestion(isLstQues, isAutoSubmit) {
        if ($scope.attendedQuesObj.length && $scope.attendedQuesObj[$scope.indexToShow]) {
            var resultObj = {};
            var ansObj = $scope.attendedQuesObj[$scope.indexToShow];
            if (ansObj && ansObj.questionId != undefined || isLstQues && !isAutoSubmit) {
                var timeSpent = 0;
                _.each($scope.attendedQuesObj, function (data) {
                    if (data && data.timeElapsed) {
                        timeSpent += parseInt(data.timeElapsed);
                    }
                });

                resultObj = {
                    question_id: ansObj.questionId,
                    mark: ansObj.mark,
                    time_elapsed: ansObj.timeElapsed,
                    q_type: ansObj.q_type,
                    answerImg: "",
                    answer: "",
                    q_status: $scope.totalQuestion[$scope.indexToShow].status,
                    section_name: ansObj.section_name,
                    is_attended: ansObj.is_attended != undefined ? ansObj.is_attended : false
                    //question_index: $scope.indexToShow

                    //If theer is no answer while submitting last question
                };if (isLstQues && resultObj.question_id == undefined) {
                    var questObj = $scope.questions[$scope.indexToShow];
                    resultObj.question_id = questObj.question_id;
                    resultObj.q_type = questObj.type;
                }

                if (ansObj.q_type == "SA" || ansObj.q_type == "LA" || ansObj.q_type == "OWQ" || ansObj.q_type == "FIB" || ansObj.q_type == "MTF") {
                    if (ansObj.images != undefined) {
                        _.each(ansObj.images.images, function (imgs) {
                            delete imgs.$$hashKey;
                        });
                    }
                    resultObj.answerImg = ansObj.imageData;
                    resultObj.answer = ansObj.answer ? ansObj.answer : "";
                } else if (ansObj.q_type == "DRAW") {
                    resultObj.answer = ansObj.answer;
                    resultObj.answerImg = ansObj.answerImg;
                } else {
                    resultObj.answer = ansObj.answer;
                }

                var requestObj = {};

                //activity_id:, student_id:
                /* requestObj["activity_id"] = "KDqybKrnxrC44";
                requestObj["qp_id"] = "Gn4JwyXBAMtp9JZ2c";
                requestObj["student_id"] = "7vprkAsiMgMRESaf9"; */

                requestObj["activity_id"] = activityId;
                requestObj["time_spent"] = timeSpent;
                requestObj["qp_id"] = qpId;
                requestObj["student_id"] = userId;
                requestObj["total_mark"] = totalMark;
                requestObj["result"] = resultObj;

                if (isLstQues && !isAutoSubmit) {

                    var isReviewedQuestionCount = 0;
                    isReviewedQuestionCount = _.filter($scope.totalQuestion, function (dta) {
                        return dta.status == 'review';
                    }).length;

                    //console.log(isReviewedQuestionCount)

                    var msg = 'Do you want to submit the exam?';
                    if (isReviewedQuestionCount > 0) {
                        msg = 'You have marked ' + isReviewedQuestionCount + ' question(s) for Review, still you want to submit the exam';
                    }

                    var confirm = $mdDialog.confirm().title(msg).targetEvent(event).ariaLabel('Information').ok('YES').cancel('NO');
                    $mdDialog.show(confirm).then(function () {
                        submitAnswer(requestObj, true);
                    }, function () {});
                } else {
                    submitAnswer(requestObj, false);
                }
            }
        }
    };

    var submitAnswer = function submitAnswer(requestObj, isBack) {
        authService.callAPI(activityCons.API_SUBMIT_EXAM_QUESTION, "POST", requestObj, function (response) {
            if (response.result != undefined) {
                if (isBack) {
                    stopExam(requestObj);
                }
            } else {
                //console.log(response)
                if (response.error && response.error.error && response.error.error.status === "completedExam") {
                    toastr.success("Exam is over");
                    stopExam(requestObj);
                }
            }
        });
    };

    var stopExam = function stopExam(requestObj) {
        var res = _.pick(requestObj, "student_id", "qp_id", "activity_id");
        authService.callAPI(activityCons.API_SUBMIT_EXAM, "POST", res, function (response) {
            if (response.result != undefined) {
                clearTimer();
                toastr.success("Your answer is submitted successfully");
                $state.go('activityFormPreview', {
                    resourceId: activityId
                }, {
                    reload: true
                });
            } else {}
        });
    };

    $scope.submitLastQuestion = function (isLstQues, isAutoSubmit) {
        $scope.evaluateQuizQuestion($scope.indexToShow);
        submitAnsEachQuestion(isLstQues, isAutoSubmit);
    };

    /*
     * Function to cancel timer
     */
    $scope.$on("$destroy", function () {
        if (angular.isDefined(timeinterval)) {
            $interval.cancel(timeinterval);
        }
    });
}];

exports.default = QuestionDirective;

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports = "<md-content ng-clock> <md-tabs md-dynamic-height md-border-bottom> <md-tab label=\"Usage Report\" ng-show=(reportUserPrivilege.indivUsageReport&&reportUserPrivilege.indivUsageReport.read)||(reportUserPrivilege.allUsageReport&&reportUserPrivilege.allUsageReport.read)> <md-content class=md-padding> <student-learning-progress flex=100 ng-if=reportUserPrivilege.indivUsageReport&&reportUserPrivilege.indivUsageReport.read></student-learning-progress> <teacher-learning-progress flex=100 ng-if=reportUserPrivilege.allUsageReport&&reportUserPrivilege.allUsageReport.read></teacher-learning-progress> </md-content> </md-tab> <md-tab label=\"Assessment Activity Report\" ng-if=(reportUserPrivilege.indivActivityReport&&reportUserPrivilege.indivActivityReport.read)||(reportUserPrivilege.allActivityReport&&reportUserPrivilege.allActivityReport.read)> <md-content> <activity-reports ng-if=reportUserPrivilege.allActivityReport&&reportUserPrivilege.allActivityReport.read></activity-reports> <student-activity-reports student-id=userId ng-if=reportUserPrivilege.indivUsageReport&&reportUserPrivilege.indivUsageReport.read></student-activity-reports> </md-content> </md-tab> <md-tab label=\"Practice Activity Report\" ng-show=(reportUserPrivilege.indivActivityReport&&reportUserPrivilege.indivActivityReport.read)||(reportUserPrivilege.allActivityReport&&reportUserPrivilege.allActivityReport.read)> <md-content class=md-padding> <practice-activity-reports ng-if=reportUserPrivilege.allActivityReport&&reportUserPrivilege.allActivityReport.read></practice-activity-reports> <student-practice-report student-id=userId ng-if=reportUserPrivilege.indivUsageReport&&reportUserPrivilege.indivUsageReport.read></student-practice-report> </md-content> </md-tab> </md-tabs> </md-content> ";

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: reports.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", function ReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
    _classCallCheck(this, ReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    $scope.userId = localStorageService.get("user_id");
    //On destroy function
    this.$onDestroy = function () {};
    var userAccess = _.filter(localStorageService.get("feature_privileges"), function (feature) {
        return feature.module_state == "reports";
    });
    $scope.reportUserPrivilege = {};
    if (userAccess.length > 0) {
        _.each(userAccess, function (obj) {
            var user_access = {};
            _.each(obj.privilege, function (privObj) {
                user_access[privObj.name.toLowerCase()] = privObj.status;
            });
            $scope.reportUserPrivilege[obj.feature_id] = user_access;
        });
    }
    if ($scope.reportUserPrivilege.indivUsageReport && $scope.reportUserPrivilege.indivUsageReport.read) {
        $state.params.studentId = $scope.userId;
        $state.params.isShowGoBack = false;
    }
}];

exports.default = ReportsController;

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"md-whiteframe-2dp reports\"> <md-radio-group ng-model=reportBasedOn ng-init=\"reportBasedOn='activity'\" class=radio-btn-div layout=row> <md-radio-button value=activity ng-checked=true>Activities</md-radio-button> <md-radio-button value=student> Students </md-radio-button> </md-radio-group> <md-divider></md-divider> <div ng-show=\"activityList.length === 0\" class=\"md-whiteframe-3dp not-available\"> No activity is published </div> <div layout=row ng-show=\"isActivityCreated&&reportBasedOn==='activity'\" flex layout-padding layout-wrap> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"activity in activityList\" ng-click=gotoActivityReport(activity._id)> <div layout=row flex layout-align=space-between tooltip=\"Activity Report\" tooltip-position=down> <div flex=10><img src=" + __webpack_require__(444) + "> </div> <div flex=85> <b> {{activity.question_paper_title}}</b> </div> </div> </div> </div> <div layout=row ng-show=\"reportBasedOn==='student'\" flex layout-padding layout-wrap> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"student in studentList\" ng-click=gotoStudentReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"fas fa-user-circle\" style=font-size:25px></i> <b flex=85>{{student.name}}</b> </div> </div> </div> </div> ";

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: activityReports.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ActivityReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", function ActivityReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
    _classCallCheck(this, ActivityReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    //Object - Basic academic details
    var academicDet = localStorageService.get("authoringData");
    var academics = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year

        //String - Teaching plan id
    };var tpId = $state.params.planId;

    //Boolean - Activity created or not
    $scope.isActivityCreated = false;

    /*
     * Function to get assigned users
     * 
     */
    authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;

                $scope.studentList = response.result.data.data;
                //To sort student list
                $scope.studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    authService.callAPI(TPWIZARDCONSTANT.API_GET_ALL_ACTIVITY + tpId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;
                $scope.isActivityCreated = true;
                $scope.activityList = response.result.data.data;
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    /*
     * Function to go to single activity based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoActivityReport = function (id) {
        $state.go("singleActivityReports", {
            prevParams: $state.params,
            qpId: id
        });
    };

    /*
     * Function to go to single student based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoStudentReport = function (id) {
        $state.go("studentActivityReports", {
            prevParams: $state.params,
            studentId: id,
            isShowGoBack: true
        });
    };
}];

exports.default = ActivityReportsController;

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column class=activity-reports ng-show=!isLoading> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section\"> <div layout=row> <div flex=40> <div class=common-title> Total Number of Question : <span class=common-value>{{quesCount}}</span> </div> </div> <div flex=40> <div class=common-title> Total Number of Students : <span class=common-value>{{studCount}}</span> </div> </div> <div flex layout=row layout-align=\"end end\"> <div> <div class=report-close tooltip=\"Go Back\" tooltip-position=down ng-click=goBack()> <i class=\"fas fa-arrow-left\"></i> </div> </div> </div> </div> <div layout=row> <div flex=40> <div class=common-title> Number of Students (Attended) : <span class=common-value>{{studAttendCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Absentees : <span class=common-value>{{absentees}}</span> </div> </div> </div> <div class=report-close tooltip=\"Download PDF\" tooltip-position=down ng-click=exportAsPDF()> <i class=\"far fa-file-pdf\"></i> </div> </div> <div layout=row layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" style=margin-left:22px> <common-chart flex graph-data=chartdata.value colors=colorArray header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </common-chart> </div> </div>";

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: singleActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var ActivityReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", function ActivityReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, ActivityReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    //String - Question paper id
    var qpId = $state.params.qpId;
    var authoring = localStorageService.get('authoringData');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;
    $scope.isLoading = true;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 525;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    //[Object] - chart availability
    $scope.chartAvailability = {
        isQuesVsStudent: false
    };
    $scope.quesCount = 0;
    $scope.studCount = 0;
    $scope.studAttendCount = 0;
    $scope.absentees = 0;
    $scope.imgurl1 = undefined;
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {
        file_server: CONSTANTS.FILE_UPLOAD_URL
    }, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': result.logo,
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });
    authService.callAPI(TPWIZARDCONSTANT.API_GET_ACTIVITY_REPORT + qpId, "GET", {}, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            console.log(resultData);
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_questions) $scope.quesCount = resultData.basicDetails[0].total_questions;
                if (resultData.basicDetails[0].total_students) $scope.studCount = resultData.basicDetails[0].total_students;
                if (resultData.basicDetails[0].attendend_students) $scope.studAttendCount = resultData.basicDetails[0].attendend_students;
                if (resultData.basicDetails[0].absentees_students) $scope.absentees = resultData.basicDetails[0].absentees_students;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails[0].questionDetail) {
                        if (resultData.graphDetails[0].questionDetail.length > 0) {
                            var questionDetail = resultData.graphDetails[0].questionDetail;
                            var values = [];
                            var header = [];
                            header.push("Question");
                            header.push("No. of students Attended");
                            header.push("No. of Correct Answers");
                            values.push(header);
                            _.each(questionDetail, function (data, index) {
                                var arr = [];
                                var question = "Q" + (index + 1);
                                arr.push(question);
                                arr.push(data.attended_count);
                                arr.push(data.crct_answer_count);
                                values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Question" + '  vs  ' + "Count",
                                'value': values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            $scope.isLoading = false;
                            $scope.isChartAvailable = true;
                        }
                    }
                    if (resultData.graphDetails[0].waveDetails) {
                        if (resultData.graphDetails[0].waveDetails.length > 0) {
                            var waveDetails = resultData.graphDetails[0].waveDetails;
                            var _values = [];
                            var _header = [];
                            _header.push("Wave");
                            _header.push("Total Questions");
                            _header.push("No. of students Attended");
                            _header.push("No. of Correct Answers");
                            _values.push(_header);
                            _.each(waveDetails, function (data) {
                                var arr = [];
                                arr.push(data.wave[0].wave);
                                arr.push(data.question_count);
                                arr.push(data.attended_count);
                                arr.push(data.crct_answer_count);
                                _values.push(arr);
                            });
                            $scope.waveObj = {
                                'key': "wave",
                                'graph': "Bar",
                                'title': "Wave" + '  vs  ' + "Count",
                                'value': _values
                            };
                            $scope.chartArray.push($scope.waveObj);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].tagDetails) {
                        if (resultData.graphDetails[0].tagDetails.length > 0) {
                            var tagDetails = resultData.graphDetails[0].tagDetails;
                            var _values2 = [];
                            var _header2 = [];
                            _header2.push("Tag");
                            _header2.push("Total Questions");
                            _header2.push("No. of students Attended");
                            _header2.push("No. of Correct Answers");
                            _values2.push(_header2);
                            _.each(tagDetails, function (data) {
                                var arr = [];
                                arr.push(data._id);
                                arr.push(data.question_count);
                                arr.push(data.attended_count);
                                arr.push(data.crct_answer_count);
                                _values2.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "wave",
                                'graph': "Bar",
                                'title': "Tag" + '  vs  ' + "Count",
                                'value': _values2
                            };
                            $scope.chartArray.push($scope.tagObj);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].levelDetails) {
                        if (resultData.graphDetails[0].levelDetails.length > 0) {
                            var levelDetails = resultData.graphDetails[0].levelDetails;
                            var _values3 = [];
                            var _header3 = [];
                            _header3.push("Level");
                            _header3.push("Total Questions");
                            _header3.push("No. of students Attended");
                            _header3.push("No. of Correct Answers");
                            _values3.push(_header3);
                            _.each(levelDetails, function (data) {
                                var arr = [];
                                arr.push(data.level[0].level);
                                arr.push(data.question_count);
                                arr.push(data.attended_count);
                                arr.push(data.crct_answer_count);
                                _values3.push(arr);
                            });
                            $scope.levelObj = {
                                'key': "level",
                                'graph': "Bar",
                                'title': "Level" + '  vs  ' + "Count",
                                'value': _values3
                            };
                            $scope.chartArray.push($scope.levelObj);
                            $scope.isLoading = false;
                        }
                    }
                }
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var rankDetails = resultData.rankDetails;
                var isPresent = 0;
                var _values4 = [];
                var _header4 = [];
                _header4.push("Student");
                _header4.push("Marks Scored");
                _values4.push(_header4);
                _.each(rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.student_name);
                    arr.push(data.score);
                    _values4.push(arr);
                    if (data.score) isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Student" + '  vs  ' + "Mark",
                    'value': _values4
                };
                if (isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var _rankDetails = resultData.rankDetails;
                var _isPresent = 0;
                var _values5 = [];
                var _header5 = [];
                _header5.push("Student");
                _header5.push("Rank");
                _values5.push(_header5);
                _.each(_rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.student_name);
                    arr.push(data.rank);
                    _values5.push(arr);
                    if (data.rank) _isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Student" + '  vs  ' + "Rank",
                    'value': _values5
                };
                if (_isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }

            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
    };$scope.goBack = function () {
        $state.go("activityReports");
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    $scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        if ($scope.imgurl1) {
            doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        }

        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Activity Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // doc.save('Activity_Based_Report.pdf')
    };
}];

exports.default = ActivityReportsController;

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=activity-reports> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section\"> <div layout=row> <div flex=40> <div class=common-title> Total Number of Published Activity : <span class=common-value>{{activityCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Activity (Attended) : <span class=common-value>{{attendedCount}}</span> </div> </div> <div ng-show=isShowGoBack flex layout=row layout-align=\"end end\"> <div> <div class=report-close tooltip=\"Go Back\" tooltip-position=down ng-click=goBack()> <i class=\"fas fa-arrow-left\"></i> </div> </div> </div> </div> <div layout=row> <div flex=40> <div class=common-title> Number of Activity (Absent) : <span class=common-value>{{absentCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Activity (Not Attended) : <span class=common-value>{{notAttendedCount}}</span> </div> </div> </div> <div class=report-close tooltip=\"Download PDF\" tooltip-position=down ng-click=exportAsPDF() ng-show=isChartAvailable> <i class=\"far fa-file-pdf\"></i> </div> </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isChartAvailable&&isActivityConducted> None of the activity assigned is attended. </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isActivityConducted> None of the activity assigned is conducted. </div> <div layout=row layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" style=margin-left:22px> <common-chart flex graph-data=chartdata.value colors=colorArray header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </common-chart> </div> </div> ";

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: studentActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var StudentActivityReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", function StudentActivityReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, StudentActivityReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var studentId = $state.params.studentId;
    $scope.isShowGoBack = $state.params.isShowGoBack;
    var planId = $state.params.planId;
    var authoring = localStorageService.get('authoringData');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;
    $scope.isLoading = true;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 525;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];
    $scope.activityCount = 0;
    $scope.absentCount = 0;
    $scope.attendedCount = 0;
    $scope.notAttendedCount = 0;
    //On destroy function
    this.$onDestroy = function () {};
    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {
        file_server: CONSTANTS.FILE_UPLOAD_URL
    }, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': result.logo,
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });

    authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENT_REPORT + planId + '/' + studentId, "GET", {}, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            $scope.isLoading = false;
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_count) $scope.activityCount = resultData.basicDetails[0].total_count;
                if (resultData.basicDetails[0].absent_count) $scope.absentCount = resultData.basicDetails[0].absent_count;
                if (resultData.basicDetails[0].attended_count) $scope.attendedCount = resultData.basicDetails[0].attended_count;
                if (resultData.basicDetails[0].not_attended_count) $scope.notAttendedCount = resultData.basicDetails[0].not_attended_count;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails[0].questionDetail) {
                        if (resultData.graphDetails[0].questionDetail.length > 0) {
                            var questionDetail = resultData.graphDetails[0].questionDetail;
                            var values = [];
                            var header = [];
                            header.push("Question");
                            header.push("Total Questions");
                            header.push("No. of Questions Attended");
                            header.push("No. of Correct Answers");
                            values.push(header);
                            _.each(questionDetail, function (data) {
                                var arr = [];
                                arr.push(data.question_paper_title);
                                arr.push(data.attended_count);
                                arr.push(data.total_question);
                                arr.push(data.correct_answer);
                                values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Question" + '  vs  ' + "Count",
                                'value': values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            $scope.isLoading = false;
                            $scope.isChartAvailable = true;
                        }
                    }
                    if (resultData.graphDetails[0].waveDetails) {
                        if (resultData.graphDetails[0].waveDetails.length > 0) {
                            var waveDetails = resultData.graphDetails[0].waveDetails;
                            var _values = [];
                            var _header = [];
                            _header.push("Wave");
                            _header.push("Total Questions");
                            _values.push(_header);
                            _.each(waveDetails, function (data) {
                                var arr = [];
                                arr.push(data.wave[0].wave);
                                arr.push(data.total_questions);
                                _values.push(arr);
                            });
                            $scope.quesObj = {
                                'key': "Question",
                                'graph': "Bar",
                                'title': "Wave" + '  vs  ' + "Count",
                                'value': _values
                            };
                            $scope.chartArray.push($scope.quesObj);
                            console.log($scope.chartArray);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].tagDetails) {
                        if (resultData.graphDetails[0].tagDetails.length > 0) {
                            var tagDetails = resultData.graphDetails[0].tagDetails;
                            var _values2 = [];
                            var _header2 = [];
                            _header2.push("Tag");
                            _header2.push("Total Questions");
                            _values2.push(_header2);
                            _.each(tagDetails, function (data) {
                                var arr = [];
                                arr.push(data._id);
                                arr.push(data.total_questions);
                                _values2.push(arr);
                            });
                            $scope.tagObj = {
                                'key': "wave",
                                'graph': "Bar",
                                'title': "Tag" + '  vs  ' + "Count",
                                'value': _values2
                            };
                            $scope.chartArray.push($scope.tagObj);
                            $scope.isLoading = false;
                        }
                    }
                    if (resultData.graphDetails[0].levelDetails) {
                        if (resultData.graphDetails[0].levelDetails.length > 0) {
                            var levelDetails = resultData.graphDetails[0].levelDetails;
                            var _values3 = [];
                            var _header3 = [];
                            _header3.push("Level");
                            _header3.push("Total Questions");
                            _values3.push(_header3);
                            _.each(levelDetails, function (data) {
                                var arr = [];
                                arr.push(data.level[0].level);
                                arr.push(data.total_questions);
                                _values3.push(arr);
                            });
                            $scope.levelObj = {
                                'key': "level",
                                'graph': "Bar",
                                'title': "Level" + '  vs  ' + "Count",
                                'value': _values3
                            };
                            $scope.chartArray.push($scope.levelObj);
                            $scope.isLoading = false;
                        }
                    }
                }
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var rankDetails = resultData.rankDetails;
                var isPresent = 0;
                var _values4 = [];
                var _header4 = [];
                _header4.push("Activity");
                _header4.push("Total Mark");
                _header4.push("Marks Scored");
                _values4.push(_header4);
                _.each(rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.total_mark);
                    arr.push(data.score);
                    _values4.push(arr);
                    if (data.score) isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Mark",
                    'value': _values4
                };
                if (isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }
            if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                var _rankDetails = resultData.rankDetails;
                var _values5 = [];
                var _header5 = [];
                var _isPresent = 0;
                _header5.push("Activity");
                _header5.push("Rank");
                _values5.push(_header5);
                _.each(_rankDetails, function (data) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.rank);
                    _values5.push(arr);
                    if (data.rank) _isPresent++;
                });
                $scope.levelObj = {
                    'key': "level",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Rank",
                    'value': _values5
                };
                if (_isPresent > 0) $scope.chartArray.push($scope.levelObj);
            }

            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    $scope.goBack = function () {
        $state.go("activityReports");
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
    };$scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Student Based Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = StudentActivityReportsController;

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports = "<div class=\"md-whiteframe-2dp md-margin learning\" flex=100 layout=column> <div ng-if=\"resourcesAvailable.length<=0\"> None of resources is available </div> <div ng-if=\"resourcesAvailable.length>0\"> <md-tabs> <md-tab ng-repeat=\"resource in resourcesAvailable\" label={{resource.name}} ng-click=showProgressChart(resource)> <md-content ng-show=resource.isActive layout=row flex> <div layout=row flex ng-if=\"chartArray.length > 0\"> <div layout=row layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" flex=50> <singlechart flex graph-data=chartdata.value header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </singlechart> </div> <div class=tabData flex=50> <table class=tableClass> <tr ng-if=\"resourceData.length != 0\"> <td class=tableBorder>Resource Name</td> <td class=tableBorder>No. of times Viewed</td> </tr> <tr ng-repeat=\"data in resourceData\"> <td class=tableBorder>{{data.title}}</td> <td class=tableBorder>{{data.count}}</td> </tr> </table> </div> </div> <div layout ng-if=\"chartArray.length === 0\" layout-align=space-around layout-margin layout-padding> <label class=not-visited flex>Not yet visited the resource</label> </div> </md-content> </md-tab> </md-tabs> </div> </div> ";

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: studentViewLearningProgress.js
 * Project: educore
 * Created Date: 2019-01-31
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var StudentLearningController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "ARCHIVE_CONSTANTS", function StudentLearningController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, ARCHIVE_CONSTANTS) {
    _classCallCheck(this, StudentLearningController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    var authoring = localStorageService.get('authoringData');

    //String - teaching plan id
    var planId = $state.params.planId;
    var userId = localStorageService.get('user_id');

    //[Object] - Different resource type assigned
    $scope.resourcesAvailable = [];

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 450;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];
    authService.callAPI(TPWIZARDCONSTANT.API_GET_ASSIGNED_RESOURCES + planId + '/' + userId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                var resultData = response.result.data.data;
                if (resultData && resultData.length > 0) {
                    _.map(resultData, function (res) {
                        res["isActive"] = false;
                        return res;
                    });
                    $scope.resourcesAvailable = resultData;
                    $scope.resourcesAvailable.forEach(function (resource) {
                        ARCHIVE_CONSTANTS.ARCHIVE_RESOURCE_TYPES.forEach(function (contResourse) {
                            if (resource._id === contResourse._id) resource.name = contResourse.name;
                        });
                    });
                    console.log(ARCHIVE_CONSTANTS.ARCHIVE_RESOURCE_TYPES);
                    console.log($scope.resourcesAvailable);
                    $scope.resourcesAvailable[0].isActive = true;
                    $scope.showProgressChart($scope.resourcesAvailable[0]);
                }
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.showProgressChart = function (resource) {
        _.each($scope.resourcesAvailable, function (res) {
            if (res.isActive) res.isActive = false;
        });
        resource.isActive = true;
        var obj = {
            "type": resource.type,
            "plan_id": planId,
            "student_id": userId
        };
        $scope.chartArray = [];
        authService.callAPI(TPWIZARDCONSTANT.API_GET_LEARNING_PROGRESS, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                $scope.resourceData = response.result.data.data;
                var values = [];
                var header = [];
                header.push("Resource");
                header.push("View Count");
                values.push(header);
                _.each($scope.resourceData, function (data, index) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.count);
                    values.push(arr);
                });
                $scope.quesObj = {
                    'key': "Resource",
                    'graph': "Donut",
                    'title': "Resource" + '  vs  ' + "View Count",
                    'value': values
                };
                $scope.chartArray.push($scope.quesObj);
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData = [];
            $scope.chartImgData.push(data[0]);
        }
    };

    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    $scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(240, 90, 'Usage Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // doc.save('Usage_Report.pdf')
    };
}];

exports.default = StudentLearningController;

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports = "<div class=\"md-whiteframe-2dp md-margin learning\" layout=column> <div ng-if=!isShowStudentList flex=5 ng-click=cancel() class=\"md-whiteframe-2dp md-margin backIcon md-padding\" layout=row layout-align=\"start end\"> <i class=\"fas fa-arrow-left\" style=color:#fff;padding-top:3px;padding-left:5px></i> </div> <div layout=row ng-if=isShowStudentList flex layout-padding layout-wrap> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"student in studDetails\" ng-click=gotoProgressPage(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"fas fa-user-circle\" style=font-size:25px></i> <b flex=85>{{student.name}}</b> </div> </div> </div> <div ng-if=!isShowStudentList> <div ng-if=\"resourcesAvailable.length<=0\"> None of resources is available </div> <div ng-if=\"resourcesAvailable.length>0\"> <md-tabs> <md-tab ng-repeat=\"resource in resourcesAvailable\" label={{resource.name}} ng-click=showProgressChart(resource)> <md-content ng-show=resource.isActive layout=row flex> <div layout=row flex ng-if=\"chartArray.length>0\"> <div layout=row layout-align=space-around ng-repeat=\"chartdata in chartArray\"> <singlechart flex graph-data=chartdata.value header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </singlechart> </div> <div class=tabData> <table class=tableClass> <tr ng-if=\"resourceData.length != 0\"> <td class=tableBorder>Resource Name</td> <td class=tableBorder>No. of times Viewed</td> </tr> <tr ng-repeat=\"data in resourceData\"> <td class=tableBorder>{{data.title}}</td> <td class=tableBorder>{{data.count}}</td> </tr> </table> </div> </div> <div layout-align=space-around ng-if=\"chartArray.length === 0\" flex> <label class=not-visited flex>Not yet visited the resource</label> </div> </md-content> </md-tab> </md-tabs> </div> </div> </div> ";

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: teacherViewLearningProgress.js
 * Project: educore
 * Created Date: 2019-01-31
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var TeacherLearningController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "ARCHIVE_CONSTANTS", function TeacherLearningController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, ARCHIVE_CONSTANTS) {
    _classCallCheck(this, TeacherLearningController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    $scope.array = [];
    this.scope = $scope;
    var self = this;
    $scope.reportData = [];
    var academicDet = localStorageService.get("authoringData");
    var academics = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year
    };

    $scope.isShowStudentList = true;

    $scope.userId = null;

    //String - teaching plan id
    var planId = $state.params.planId;

    //[Object] - Different resource type assigned
    $scope.resourcesAvailable = [];

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 450;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    /*
     * Function to get assigned users
     * 
     */
    authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;

                $scope.studDetails = response.result.data.data;
                console.log($scope.studDetails);
                //To sort student list
                $scope.studDetails.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    /*
            Meteor.call('getSchoolDetails', Session.get('school_id'), (error, result) => {
                if (result) {
                    let academicYearObj = _.find(result.academic_year, function(data) {
                        return data.status == 'active'
                    })
                    if (!result.logo)
                        result.logo = 'school_dummy_logo.png'
                    $scope.schoolHeader = {
                        'schoolName': result.school_name,
                        'schoolLogo': SchoolLogo.checkLogo(FILE_UPLOAD_URL + result.logo),
                        'academicYear': academicYearObj.year
                    }
                    convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function(base64Image) {
                        $scope.imgurl1 = base64Image;
                    })
                    $scope.$apply()
                }
            })
    */
    $scope.gotoProgressPage = function (userId) {
        $scope.isShowStudentList = false;
        $scope.userId = userId;
        authService.callAPI(TPWIZARDCONSTANT.API_GET_ASSIGNED_RESOURCES + planId + '/' + userId, "GET", {}, function (response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                try {
                    console.log(response);
                    var resultData = response.result.data.data;
                    console.log(resultData);
                    if (resultData && resultData.length > 0) {
                        _.map(resultData, function (res) {
                            res["isActive"] = false;
                            return res;
                        });
                        $scope.resourcesAvailable = resultData;
                        $scope.resourcesAvailable.forEach(function (resource) {
                            ARCHIVE_CONSTANTS.ARCHIVE_RESOURCE_TYPES.forEach(function (contResourse) {
                                if (resource._id === contResourse._id) resource.name = contResourse.name;
                            });
                        });
                        $scope.resourcesAvailable[0].isActive = true;
                        $scope.showProgressChart($scope.resourcesAvailable[0]);
                    }
                } catch (ex) {
                    console.log(ex);
                }
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    $scope.cancel = function () {
        $scope.isShowStudentList = true;
    };

    $scope.showProgressChart = function (resource) {
        _.each($scope.resourcesAvailable, function (res) {
            if (res.isActive) res.isActive = false;
        });
        resource.isActive = true;
        var obj = {
            "type": resource.type,
            "plan_id": planId,
            "student_id": $scope.userId
        };
        $scope.chartArray = [];
        authService.callAPI(TPWIZARDCONSTANT.API_GET_LEARNING_PROGRESS, "POST", obj, function (response) {
            if (response.result && response.result.data && response.result.data.data.length > 0) {
                $scope.resourceData = response.result.data.data;
                var values = [];
                var header = [];
                header.push("Resource");
                header.push("View Count");
                values.push(header);
                _.each($scope.resourceData, function (data, index) {
                    var arr = [];
                    arr.push(data.title);
                    arr.push(data.count);
                    values.push(arr);
                });
                $scope.quesObj = {
                    'key': "Resource",
                    'graph': "Donut",
                    'title': "Resource" + '  vs  ' + "View Count",
                    'value': values
                };
                $scope.chartArray.push($scope.quesObj);
                _.defer(function () {
                    $scope.$apply();
                });
            }
        });
    };

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData = [];
            $scope.chartImgData.push(data[0]);
        }
    };

    /*
     * To export chart as PDF file
     * 
     * @return : null
     */
    $scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(240, 90, 'Usage Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // doc.save('Usage_Report.pdf')
    };
}];

exports.default = TeacherLearningController;

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<md-backdrop style=z-index:60!important ng-show=isLoading class=loading-opacity layout=column layout-align=\"center center\"> <img id=mySpinner src=" + __webpack_require__(2) + " layout-align=\"center center\"> <span class=loadinfTxt>Loading, please wait ...</span> </md-backdrop> <div layout=column class=activity-reports ng-show=!isLoading> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section\"> <div layout=row> <div flex=40> <div class=common-title> Total Number of Question : <span class=common-value>{{quesCount}}</span> </div> </div> <div flex=40> <div class=common-title> Total Number of Students : <span class=common-value>{{studCount}}</span> </div> </div> <div flex layout=row layout-align=\"end end\"> <div> <div class=report-close tooltip=\"Go Back\" tooltip-position=down ng-click=goBack()> <i class=\"fas fa-arrow-left\"></i> </div> </div> </div> </div> <div layout=row> <div flex=40> <div class=common-title> Number of Students (Attended) : <span class=common-value>{{studAttendCount}}</span> </div> </div> </div> <div class=report-close tooltip=\"Download PDF\" tooltip-position=down ng-click=exportAsPDF() ng-show=isChartAvailable> <i class=\"far fa-file-pdf\"></i> </div> </div> <div layout=row layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" style=margin-left:22px> <common-chart flex graph-data=chartdata.value colors=colorArray header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </common-chart> </div> </div>";

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: singleActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PracticeReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", function PracticeReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, PracticeReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    //String - Question paper id
    var qpId = $state.params.qpId;
    $scope.isLoading = true;
    var authoring = localStorageService.get('authoringData');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 1200;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    //[Object] - chart availability
    $scope.chartAvailability = {
        isQuesVsStudent: false
    };
    $scope.quesCount = 0;
    $scope.studCount = 0;
    $scope.studAttendCount = 0;
    $scope.absentees = 0;
    authService.callAPI(TPWIZARDCONSTANT.API_GET_PRACTICE_ACTIVITY_REPORT + qpId, "GET", {}, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            $scope.isLoading = false;
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_questions) $scope.quesCount = resultData.basicDetails[0].total_questions;
                if (resultData.basicDetails[0].total_students) $scope.studCount = resultData.basicDetails[0].total_students;
                if (resultData.basicDetails[0].attendend_students) $scope.studAttendCount = resultData.basicDetails[0].attendend_students;
                /*if (resultData.basicDetails[0].absentees_students)
                    $scope.absentees = resultData.basicDetails[0].absentees_students*/
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                var activityDetail = resultData.graphDetails;
                var values = [];
                var header = [];
                header.push("Student");
                header.push("Attempt Count");
                values.push(header);
                _.each(activityDetail, function (data, index) {
                    var arr = [];
                    arr.push(data.student_name);
                    arr.push(data.count);
                    values.push(arr);
                });
                $scope.quesObj = {
                    'key': "Student",
                    'graph': "Bar",
                    'title': "Student" + '  vs  ' + "Attempt Count",
                    'value': values
                };
                $scope.chartArray.push($scope.quesObj);
                $scope.isChartAvailable = true;
            }

            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    /*
     * Function to go back to activity page
     *
     * @return - null
     *
     */
    $scope.goBack = function () {
        var params = $state.params.prevParams;
        $state.go("practiceActivityReports");
    };

    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        }
    });

    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
    };$scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Practice Activity Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = PracticeReportsController;

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports = "<div layout=column class=activity-reports> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section\"> <div layout=row> <div flex=40> <div class=common-title> Total Number of Practice Activity : <span class=common-value>{{activityCount}}</span> </div> </div> <div flex=40> <div class=common-title> Number of Practice Activity (Attended) : <span class=common-value>{{attendedCount}}</span> </div> </div> <div ng-show=isShowGoBack flex layout=row layout-align=\"end end\"> <div> <div class=report-close tooltip=\"Go Back\" tooltip-position=down ng-click=goBack()> <i class=\"fas fa-arrow-left\"></i> </div> </div> </div> </div> <div class=report-close tooltip=\"Download PDF\" tooltip-position=down ng-click=exportAsPDF() ng-show=isChartAvailable> <i class=\"far fa-file-pdf\"></i> </div> </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isChartAvailable&&isActivityConducted> None of the activity assigned is attended. </div> <div layout=column layout-align=space-around flex class=\"md-whiteframe-5dp common-section chart-not-available\" ng-show=isActivityAvailable&&!isActivityConducted> None of the activity assigned is conducted. </div> <div layout=row layout-align=space-around flex ng-repeat=\"chartdata in chartArray\" style=margin-left:22px> <common-chart flex graph-data=chartdata.value colors=colorArray header=chartdata.title chart-type=chartdata.graph show-graph=true graph-width=chartWidth graph-height=chartHeight class=graph total-count=0 count=$index setimage=getChartData(data)> </common-chart> </div> </div> ";

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: studentActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var StudentPracticeReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", "activityCons", "SchoolLogo", "CONSTANTS", function StudentPracticeReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
    _classCallCheck(this, StudentPracticeReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };
    var studentId = $state.params.studentId;
    $scope.isShowGoBack = $state.params.isShowGoBack;
    var planId = $state.params.planId;
    $scope.isLoading = true;
    var authoring = localStorageService.get('authoringData');
    var schoolId = authoring.school_id;
    var academicYear = authoring.academic_year;

    //[Object] - Contains chart data
    $scope.chartArray = [];

    //Number - To set width of chart
    $scope.chartWidth = 1200;

    //Number - To set height of chart
    $scope.chartHeight = 350;

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];

    $scope.colorArray = ['#3366cc', '#f59f00', '#109618'];

    //[Object] - Holds list of chart details
    $scope.chartImgData = [];
    $scope.activityCount = 0;
    $scope.absentCount = 0;
    $scope.attendedCount = 0;
    $scope.notAttendedCount = 0;
    //On destroy function
    this.$onDestroy = function () {};
    authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENT_PRACTICE_REPORT + planId + '/' + studentId, "GET", {}, function (response) {
        if (response.result && response.result.data) {
            var resultData = response.result.data;
            $scope.isLoading = false;
            if (resultData && resultData.basicDetails && resultData.basicDetails.length > 0) {
                if (resultData.basicDetails[0].total_count) $scope.activityCount = resultData.basicDetails[0].total_count;
                if (resultData.basicDetails[0].absent_count) $scope.absentCount = resultData.basicDetails[0].absent_count;
                if (resultData.basicDetails[0].attended_count) $scope.attendedCount = resultData.basicDetails[0].attended_count;
                if (resultData.basicDetails[0].not_attended_count) $scope.notAttendedCount = resultData.basicDetails[0].not_attended_count;
            }
            if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                var activityDetail = resultData.graphDetails;
                var values = [];
                var header = [];
                header.push("Activity");
                header.push("Attempt Count");
                values.push(header);
                _.each(activityDetail, function (data, index) {
                    var arr = [];
                    arr.push(data.question_paper_title);
                    arr.push(data.count);
                    values.push(arr);
                });
                $scope.quesObj = {
                    'key': "Activity",
                    'graph': "Bar",
                    'title': "Activity" + '  vs  ' + "Attempt Count",
                    'value': values
                };
                $scope.chartArray.push($scope.quesObj);
                $scope.isChartAvailable = true;
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });
    $scope.goBack = function () {
        $state.go("practiceActivityReports");
    };
    authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, function (response) {
        if (response.result && response.result.status && response.result.data.details) {
            var result = response.result.data.details;
            $scope.schoolHeader = {
                'schoolName': result.school_name,
                'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                'academicYear': academicYear
            };
            convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function (base64Image) {
                $scope.imgurl1 = base64Image;
            });
        } else {
            //error
        }
    });
    function convertFileToDataURLviaFileReader(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    };

    /*
     * To get chart details from Child chart component
     * 
     * @data : Object - Chart details
     * 
     * @return : null
     */
    $scope.getChartData = function (data) {
        if (data != undefined && data[0] != undefined) {
            $scope.chartImgData.push(data[0]);
        }
    };

    $scope.barOptions = {
        responsive: true,
        scaleBeginAtZero: true,
        scaleShowGridLines: false,
        barValueSpacing: 1,
        barDatasetSpacing: 1,
        tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
        legend: {
            display: false
        },
        scales: {
            xAxes: [{
                barPercentage: 0.9,
                categoryPercentage: 0.5
            }],
            yAxes: [{
                ticks: {
                    stepSize: 1,
                    beginAtZero: true // minimum value will be 0.
                }
            }]
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
    };$scope.exportAsPDF = function () {
        var doc = new jsPDF('p', 'pt', 'a4', false); /* Creates a new Document*/
        doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
        doc.setFontSize(18);
        doc.setFontType('bold');
        var xOffset = doc.internal.pageSize.width / 2 - doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2;
        doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
        doc.setFontSize(12);
        doc.setFontType('normal');
        doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
        doc.setFontSize(16);
        doc.text(220, 90, 'Practice Activity Report');
        doc.setFontSize(15); /* Define font size for the document */
        var yAxis = 150;

        for (var i = 0; i < $scope.chartImgData.length; i++) {
            if (i % 2 == 0 && i != 0) {
                /* I want only two images in a page */
                doc.addPage(); /* Adds a new page*/
                yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
            }

            var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
            var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

            if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                width = doc.internal.pageSize.width;
            } else {
                width = $scope.chartImgData[i].width;
            }

            height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
            height = width * (3 / 4) - 100;

            var someText = i + 1 + ".) " + $scope.chartImgData[i].title;
            doc.text(60, yAxis, someText); /* Add some text in the PDF */
            yAxis = yAxis + 20; /* Update yAxis */
            //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
            doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
            yAxis = yAxis + 360; /* Update yAxis */
        }
        window.open(doc.output('bloburl'));
        // window.open(encodeURI('https://docs.google.com/gview?embedded=true&url='+url), '_blank', 'location=yes,EnableViewPortScale=yes');
        // doc.save('Student_Based_Report.pdf')
    };
}];

exports.default = StudentPracticeReportsController;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=\"md-whiteframe-2dp reports\"> <md-radio-group ng-model=reportBasedOn ng-init=\"reportBasedOn='activity'\" class=radio-btn-div layout=row> <md-radio-button value=activity ng-checked=true>Activities</md-radio-button> <md-radio-button value=student> Students </md-radio-button> </md-radio-group> <md-divider></md-divider> <div layout=row ng-show=\"isActivityCreated&&reportBasedOn==='activity'\" flex layout-padding layout-wrap> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"activity in activityList\" ng-click=gotoActivityReport(activity._id)> <div layout=row flex layout-align=space-between tooltip=\"Activity Report\" tooltip-position=down> <div flex=10><img src=" + __webpack_require__(444) + "> </div> <div flex=85> <b> {{activity.question_paper_title}}</b> </div> </div> </div> </div> <div layout=row ng-show=\"reportBasedOn==='student'\" flex layout-padding layout-wrap> <div layout=row class=\"md-whiteframe-3dp list-container\" flex=30 flex-xs=75 flex-sm=25 ng-repeat=\"student in studentList\" ng-click=gotoStudentReport(student.user_id)> <div layout=row flex layout-align=space-between> <i class=\"fas fa-user-circle\" style=font-size:25px></i> <b flex=85>{{student.name}}</b> </div> </div> </div> </div> ";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * File: practiceActivityReports.js
 * Project: educore
 * Created Date: 2019-02-21
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var PracticeReportsController =
// @ngInject
["$scope", "$state", "$rootScope", "authService", "localStorageService", "UserPrivilages", "TPWIZARDCONSTANT", "$stateParams", function PracticeReportsController($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams) {
    _classCallCheck(this, PracticeReportsController);

    //On init function
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
    };

    //On destroy function
    this.$onDestroy = function () {};
    //Object - Basic academic details
    var academicDet = localStorageService.get("authoringData");
    var academics = {
        school_id: academicDet.school_id,
        batch_id: academicDet.batch_id,
        curriculum_id: academicDet.curriculum_id,
        subject_id: academicDet.subject_id,
        session_id: academicDet.session_id,
        class_id: academicDet.class_id,
        academic_year: academicDet.academic_year

        //String - Teaching plan id
    };var tpId = $state.params.planId;

    //Boolean - Activity created or not
    $scope.isActivityCreated = false;

    /*
     * Function to get assigned users
     * 
     */
    authService.callAPI(TPWIZARDCONSTANT.API_GET_STUDENTS, "POST", academics, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;

                $scope.studentList = response.result.data.data;
                //To sort student list
                $scope.studentList.sort(function (a, b) {
                    var textA = a.name.toUpperCase();
                    var textB = b.name.toUpperCase();
                    return textA < textB ? -1 : textA > textB ? 1 : 0;
                });
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    authService.callAPI(TPWIZARDCONSTANT.API_GET_ALL_PRACTICE_ACTIVITY + tpId, "GET", {}, function (response) {
        if (response.result && response.result.data && response.result.data.data.length > 0) {
            try {
                $scope.isLoading = false;
                $scope.isActivityCreated = true;
                $scope.activityList = response.result.data.data;
            } catch (ex) {
                console.log(ex);
            }
            _.defer(function () {
                $scope.$apply();
            });
        }
    });

    /*
     * Function to go to single activity based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoActivityReport = function (id) {
        $state.go("singlePracticeReport", {
            prevParams: $state.params,
            qpId: id
        });
    };

    /*
     * Function to go to single student based report
     * 
     * @id : String - Id of the question paper
     * 
     * @return : null
     *
     */
    $scope.gotoStudentReport = function (id) {
        $state.go("studentPracticeReport", {
            prevParams: $state.params,
            studentId: id,
            isShowGoBack: true
        });
    };
}];

exports.default = PracticeReportsController;

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _subject_report = __webpack_require__(138);

var _subject_report2 = _interopRequireDefault(_subject_report);

var _controller = __webpack_require__(382);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('classActivityReportcard', [
    //import modules
]).controller('classActivityReportCard', _controller2.default);;

_module.constant('pulishedReportCardConstants', {
    NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG']
});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('classActivityReportCard', {
//             parent: 'app',
//             url: '/class-activity-report-card',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'classActivityReportCardCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _performance_analysis = __webpack_require__(140);

var _performance_analysis2 = _interopRequireDefault(_performance_analysis);

var _controller = __webpack_require__(384);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('educorePerformanceAnalysis', [
  //import modules
]).controller('educorePerformanceAnalysis', _controller2.default);

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('educorePerformanceAnalysis', {
//             parent: 'app',
//             url: '/educore-performance-analysis',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'educorePerformanceAnalysisCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _controller = __webpack_require__(381);

var _controller2 = _interopRequireDefault(_controller);

var _studentList = __webpack_require__(137);

var _studentList2 = _interopRequireDefault(_studentList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('studentFilteration', [
  //import modules
]).controller('studentFilteration', _controller2.default);

_module.constant('studentFilteration', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('studentFilteration', {
//             parent: 'app',
//             url: '/student-filteration',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'activityReportCardCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _class_average = __webpack_require__(132);

var _class_average2 = _interopRequireDefault(_class_average);

var _classaverageController = __webpack_require__(376);

var _classaverageController2 = _interopRequireDefault(_classaverageController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('academicPerformance', [
  //import modules
]).controller('academicPerformance', _classaverageController2.default);

_module.constant('academicPerformance', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('academicPerformance', {
//             parent: 'app',
//             url: '/academic-performance',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'academicPerformance'
//                 }
//             }
//         })

// });

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _needing_attention = __webpack_require__(134);

var _needing_attention2 = _interopRequireDefault(_needing_attention);

var _attentionneedingController = __webpack_require__(378);

var _attentionneedingController2 = _interopRequireDefault(_attentionneedingController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('attentionNeedingStudents', [
  //import modules
]).controller('attentionNeedingStudents', _attentionneedingController2.default);

_module.constant('attentionNeedingStudents', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('attentionNeedingStudents', {
//             parent: 'app',
//             url: '/attention-needing-students',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'attentionNeedingStudents'
//                 }
//             }
//         })

// });

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _performing_section = __webpack_require__(135);

var _performing_section2 = _interopRequireDefault(_performing_section);

var _performingsectionController = __webpack_require__(379);

var _performingsectionController2 = _interopRequireDefault(_performingsectionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('performingSection', [
  //import modules
]).controller('performingSection', _performingsectionController2.default);

_module.constant('performingSection', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('performingSection', {
//             parent: 'app',
//             url: '/performing-section',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'performingSection'
//                 }
//             }
//         })

// });

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _sectionwise_attention = __webpack_require__(136);

var _sectionwise_attention2 = _interopRequireDefault(_sectionwise_attention);

var _sectionwiseattentionController = __webpack_require__(380);

var _sectionwiseattentionController2 = _interopRequireDefault(_sectionwiseattentionController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('sectionWiseAttention', [
  //import modules
]).controller('sectionWiseAttention', _sectionwiseattentionController2.default);

_module.constant('sectionWiseAttention', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('sectionWiseAttention', {
//             parent: 'app',
//             url: '/section-wise-attention',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'sectionWiseAttention'
//                 }
//             }
//         })

// });

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classaveragedifferenceController = __webpack_require__(377);

var _classaveragedifferenceController2 = _interopRequireDefault(_classaveragedifferenceController);

var _classaverage_difference = __webpack_require__(133);

var _classaverage_difference2 = _interopRequireDefault(_classaverage_difference);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('termDifference', [
  //import modules
]).controller('termDifference', _classaveragedifferenceController2.default);

_module.constant('termDifference', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('termDifference', {
//             parent: 'app',
//             url: '/term-difference',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'termDifference'
//                 }
//             }
//         })

// });

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _studentList = __webpack_require__(141);

var _studentList2 = _interopRequireDefault(_studentList);

var _controller = __webpack_require__(385);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('myCumulativeReport', [
  //import modules
]).controller('myCumulativeReport', _controller2.default);

_module.constant('myCumulativeReport', {});

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _subject_report = __webpack_require__(139);

var _subject_report2 = _interopRequireDefault(_subject_report);

var _controller = __webpack_require__(383);

var _controller2 = _interopRequireDefault(_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('educoreStandardReport', [
    //import modules
]).controller('educoreStandardReport', _controller2.default);

_module.constant('pulishedReportCardConstants', {
    NO_FEESCHOOLS: ['2FwuqhgeoKt6SQiCG']
});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('educoreStandardReport', {
//             parent: 'app',
//             url: '/educore-standard-report',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'standardreportCtrl'
//                 }
//             }
//         })

// });

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _curriculumConsole = __webpack_require__(144);

var _curriculumConsole2 = _interopRequireDefault(_curriculumConsole);

var _curriculumConsoleController = __webpack_require__(394);

var _curriculumConsoleController2 = _interopRequireDefault(_curriculumConsoleController);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Thu Dec 20 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
var _module = angular.module('CurriculumConsoleModule', [_angularUiRouter2.default
//import modules
]).controller('curriculumConsole', _curriculumConsoleController2.default);

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

config.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _academicConsole = __webpack_require__(1400);

var _academicConsole2 = _interopRequireDefault(_academicConsole);

var _batchSlider = __webpack_require__(1401);

var _batchSlider2 = _interopRequireDefault(_batchSlider);

var _addSubject = __webpack_require__(1402);

var _addSubject2 = _interopRequireDefault(_addSubject);

__webpack_require__(446);

var _wizard = __webpack_require__(447);

var _wizard2 = _interopRequireDefault(_wizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var name = 'academicConsole';

var AcademicConsoleCtrl = function AcademicConsoleCtrl($scope, $stateParams, $rootScope, $state, $mdDialog, $mdMedia, localStorageService, authService) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, AcademicConsoleCtrl);

    var localSchoolId = localStorageService.get('school_id');
    var localMyUserId = localStorageService.get('user_id');
    $rootScope.title = "Academic Console";
    var self = this;
    $scope.subjecttitle = '';
    $scope.currentCurriculum = '';
    this.sessionIds = [];
    this.batchLists = {};
    self.enableNextBtn = false;
    self.enableSlider = false;
    var classArry = [];
    var batchesArry = [];
    $scope.activeBtn = [];
    $scope.showWizard = false;

    var subsAcademicPack = undefined,
        subsSetting = undefined,
        subsSession = undefined;
    self.methodAfterBatchUpdate = function () {
        var send = {
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", { args: send }, function (response) {
            try {
                if (!response.error) {
                    autorun(response.result.data.data);
                    getAcademics(response.result.data.data);
                } else {}
            } catch (e) {
                console.log(e);
            }
        });
    };
    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "Academic Console";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        // subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
        var send = {
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", { args: send }, function (response) {
            try {
                if (!response.error) {
                    autorun(response.result.data.data);
                    getAcademics(response.result.data.data);
                } else {}
            } catch (e) {
                console.log(e);
            }
            _.defer(function () {
                $scope.$apply();
            });
        });
    };

    this.$onDestroy = function () {
        if (subsAcademicPack) subsAcademicPack.stop();
        if (subsSetting) subsSetting.stop();
        if (subsSession) subsSession.stop();

        self.sessionpackage = undefined;
        self.sessionCurriArray = undefined;
        self.batchLists = undefined;
    };

    $scope.getBatchString = function (list) {
        return _.pluck(list, 'name').join(",");
    };

    $scope.btnLabel = "Save";
    var send = {
        userId: localMyUserId,
        schoolId: localSchoolId };
    authService.callAPI("/v0/initial-settings/user-console/getUserPrivilageInitialSetting", "POST", send, function (response) {
        try {
            if (!response.error) {
                self.checkintialSettingValue(response.result.data.data.initial_settings);
            } else {}
        } catch (e) {
            console.log(e);
        }
    });
    // self.call('getUserPrivilageInitialSetting', Meteor.userId(), Session.get('school_id'), (error, result) => {
    //     if (result) {
    //         self.checkintialSettingValue(result.initial_settings)
    //     }
    // })

    self.checkintialSettingValue = function (val) {
        $scope.tabStats = {};
        for (var i = 1; i <= 5; i++) {
            if (i <= val) {
                $("#prop" + i).removeClass('disabled');
            } else {
                $scope.tabStats['tab' + i] = "disabled";
            }
        };
        if (val < 5) {
            $scope.btnLabel = "Next";
            $scope.showWizard = true;
        } else {
            if (val === 5) {

                $scope.hideNextButtonAcademicConsole = true;
            }
        }
    };

    var getAcademics = function getAcademics(response) {

        /***session***/
        var settings = response.sett;
        var alreadyAddedSessions = self.sessionIds;
        self.sessionpackage = _.find(settings, function (one) {
            return one.type == "session";
        });
        if (self.sessionpackage) {
            self.sessionpackage.list = _.filter(self.sessionpackage.list, function (sess) {
                return alreadyAddedSessions.indexOf(sess._id) !== -1;
            });
        }
        self.batchPackage = _.find(settings, function (one) {
            return one.type == "batch";
        });
        self.classpackage = _.find(settings, function (one) {
            return one.type == "class";
        });
        classArry = _.pluck(self.classpackage.list, "name");
        batchesArry = _.pluck(self.batchPackage.list, "name");
        $scope.setClassSlider();
        if (self.sessionpackage.list.length <= 0) {
            toastr.error("Please add the session and curriculum");
            return false;
        }
        var firstSession = self.sessionpackage.list[0];
        _this.showThis(firstSession._id, firstSession.name);
        if (self.sessionpackage && self.sessionpackage.list) {
            var sessionArray = _.uniq(self.sessionpackage.list, function (doc) {
                return doc._id;
            });
            self.sessionpackage.list = sessionArray;
        }
    };

    $scope.setClassSlider = function () {

        var startRange = 0;
        var endRange = 0;
        if (Object.keys(self.batchLists).length > 0) {
            var currentXclassesIndex = $scope.selectedSession + "_" + $scope.currentCurriculum;

            if (self.batchLists[currentXclassesIndex] && self.batchLists[currentXclassesIndex].length > 0) {
                startRange = self.batchLists[currentXclassesIndex][0].name;
                var xclassesLen = self.batchLists[currentXclassesIndex].length;
                endRange = self.batchLists[currentXclassesIndex][xclassesLen - 1].name;
            }
        }
        $scope.range_slider_ticks_values = { //class slider
            startRange: startRange,
            endRange: endRange,
            options: {
                stepsArray: classArry,
                getSelectionBarColor: function getSelectionBarColor(v) {
                    return '#1AA762';
                },
                showTicksValues: true,
                //showSelectionBar: true,
                ticksValuesTooltip: function ticksValuesTooltip(v) {
                    var classe = classArry[v];
                    return 'Class -' + classe;
                }
            }
        };
        setTimeout(function () {
            $scope.$broadcast('reCalcViewDimensions');
        }, 500);
    };

    self.setBatchList = function (type, cid) {
        var acadCurriculum = _.find($scope.acdConsoles, function (one) {
            return one.session_id == type && one.curriculum_id == cid;
        });
        var xclasses = [];
        if (acadCurriculum) {
            var batchMap = {};
            _.each(acadCurriculum.xclass, function (xclass) {
                var obj = {};

                obj._id = xclass._id;

                obj.name = _.find(self.classpackage.list, function (clasSetting) {
                    return clasSetting._id == xclass._id;
                }).name;
                obj.xclassIndex = classArry.indexOf(obj.name);
                var myBatches = [];
                _.each(xclass.batches, function (batch) {
                    if (!batchMap[batch]) {
                        batchMap[batch] = _.find(self.batchPackage.list, function (batchSetting) {
                            return batchSetting._id == batch;
                        });
                    }
                    myBatches.push(batchMap[batch]);
                });
                obj.batches = myBatches;
                xclasses.push(obj);
            });

            if (xclasses && xclasses.length > 0) {
                self.batchLists[cid + "_" + type] = xclasses;
            }
        }
    };

    self.showCurriculum = function (curriculum, cid, tabName, index, item, type, parentIndex) {

        self.setBatchList(type, cid);

        $scope.selected = item;
        var selectedSession = $scope.currentCurriculum;

        $scope.selectedSession = cid;

        $scope.setClassSlider();
        $scope.subjecttitle = cid; //passing curriculum id to add-subject-component.js page (saveSubjectArry)
        self.enableSlider = self.enableSlider === false ? true : false;
        var sid = $scope.currentCurriculum;
        var dataArray = _.filter($scope.acdConsoles, function (one) {
            return one.session_id == sid;
        });
        var statusOfClass = false;
        _.each(dataArray, function (eachVal) {
            if (eachVal.curriculum_id === cid) {
                statusOfClass = true;
            }
        });
        if (statusOfClass === true) {
            $scope.activeBtn[index] = true;
        } else {
            $scope.activeBtn[index] = false;
        }
        for (var i = 0; i < $scope.activeBtn.length; i++) {
            if (i == index) {
                $scope.activeBtn[index] = true;
                self.enableSlider = true;
            } else {
                $scope.activeBtn[i] = false;
            }
        }
    };

    self.showThis = function (setId, tab) {
        self.enableSlider = false;

        for (var i = 0; i < $scope.activeBtn.length; i++) {
            $scope.activeBtn[i] = false; // To make all curriculum as false
        }
        $scope.currentCurriculum = setId; //passing curriculum id to add-subject-component.js page(saveSubjectArry)
        var sessionsListArry = [];
        self.sessionCurriArray = [];
        self.enableNextBtn = true;
        var curId = _.filter($scope.acdConsoles, function (one) {
            return one.session_id == setId;
        });
        _.each(curId, function (currList) {
            sessionsListArry.push(currList.curriculum_id);
        });
        self.sessionsListArry = _.uniq(sessionsListArry);
        _.each(self.sessionsListArry, function (id) {
            var cName = self.getCurName(id);

            self.sessionCurriArray.push({
                id: id,
                cName: cName
            });
        });
        var curriculumBtn = self.sessionCurriArray[0];
        self.showCurriculum(curriculumBtn.cName, curriculumBtn.id, 1, 0, curriculumBtn, setId, 0);
    };
    self.getCurName = function (id) {
        var fullName = '';
        self.curDetails = _.filter($scope.sett, function (one) {
            return one.type == "curriculum";
        });
        _.each(self.curDetails[0].list, function (lid) {
            if (lid._id === id) {
                fullName = lid.name;
            }
        });
        return fullName;
    };
    self.getSession = function () {
        var send = {
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", { args: send }, function (response) {
            try {
                if (!response.error) {
                    autorun(response.result.data.data);
                    getAcademics(response.result.data.data);
                } else {}
            } catch (e) {
                console.log(e);
            }
        });
        // subsSession = self.subscribe('getSessionPackage', () => [], {
        //     onReady: function() {
        //         self.autorun(() => {
        //             self.curriculumList = [];
        //             let sessionIds = AcademicConsole.find({ school_id: Session.get('school_id') }).fetch();

        //             if (sessionIds && sessionIds.length && sessionIds.length > 0) {
        //                 self.sessionIds = _.uniq(_.pluck(sessionIds, 'session_id'))
        //             }
        //         })
        //         getAcademics()
        //     }
        // });
    };
    // self.getSession()
    /*--------------------------------------*/

    // this.autorun(() => {
    //     var sessionsAry = [];
    //     var curiculAry = [];
    //     let sessIds = AcademicConsole.find({ school_id: Session.get('school_id') }).fetch();
    //     _.each(sessIds, function(data1) {
    //         sessionsAry.push(data1.session_id);
    //         curiculAry.push(data1.curriculum_id);
    //     })

    //     self.sessIds = _.uniq(sessionsAry);
    //     self.curiIds = curiculAry;
    // })
    function autorun(response) {
        var sessionsAry = [];
        var curiculAry = [];
        $scope.acdConsoles = response.acConsoles;
        $scope.sett = response.sett;
        var sessIds = response.acConsoles;
        _.each(sessIds, function (data1) {
            sessionsAry.push(data1.session_id);
            curiculAry.push(data1.curriculum_id);
        });

        self.sessIds = _.uniq(sessionsAry);
        self.curiIds = curiculAry;
        self.curriculumList = [];
        var sessionIds = response.acConsoles;

        if (sessionIds && sessionIds.length && sessionIds.length > 0) {
            self.sessionIds = _.uniq(_.pluck(sessionIds, 'session_id'));
        }
    }
    var alpha = [];
    var batch = [];
    for (var i = 65; i <= 90; i++) {
        alpha.push(String.fromCharCode(i));
    }
    for (var i = 65; i <= 90; i++) {
        var first = 'A';
        var next = String.fromCharCode(i);
        alpha.push(first + next);
    }
    $scope.getTotalDivision = function (s, e) {
        var s = $scope.getTotalClass(e, s, 'batchList');
        return s;
    };
    $scope.alphabetTranslate = function (value) {
        if (isNaN(value) || value == undefined) {} else {
            return alpha[value].toUpperCase();
        }
    };
    $scope.getClassName = function (value) {
        return classArry[value];
    };
    //Slider 1 for class range,listing from classArry.

    /***************************************************************/
    var startClass, endClass, batchStart, batchEnd;
    $scope.$on('slideEnded', function () {
        setRanges();
    });

    function setRanges() {
        startClass = classArry.indexOf($scope.range_slider_ticks_values.startRange);
        startClass++;
        endClass = classArry.indexOf($scope.range_slider_ticks_values.endRange);
        endClass++;
    }

    this.showClass = function (s, e) {
        setRanges();
        // s = classArry.indexOf( e )

        var st = classArry.indexOf(s);
        var eachClassID = [];
        var selectedArry = [];
        var myClasses = self.classpackage.list.slice(st, classArry.indexOf(e) + 1);
        var selectedCurriculum = $scope.currentCurriculum;
        var selectedSession = $scope.selectedSession;
        selectedArry.push($scope.currentCurriculum);
        selectedArry.push($scope.selectedSession);

        _.each(myClasses, function (classes) {
            eachClassID.push(classes._id);
            // addClasses(selectedSession, selectedCurriculum, classes._id)
        });
        var send = {
            school_id: localStorageService.get('school_id'),
            curiId: selectedSession,
            sessId: selectedCurriculum,
            classId: myClasses,
            myUserId: localStorageService.get('user_id')
        };
        authService.callAPI("/v0/initial-settings/academic-console/addClassPackage", "POST", { args: send }, function (response) {
            try {
                if (!response.error) {
                    console.log(response);
                } else {}
            } catch (e) {
                console.log(e);
            }
        });
        // return false
        var batchSlide = [{
            "startRange": startClass,
            "endRange": endClass
        }];

        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'data', 'classIds', 'selected', 'allBatches', 'addedBatches', 'parentCtrl', 'classArry', 'batchesArry', 'localStorageService', 'authService', DialogController],
            controllerAs: 'batchesCtrls',
            locals: {
                "data": batchSlide,
                "classIds": eachClassID,
                "selected": selectedArry,
                "allBatches": self.batchPackage.list,
                "addedBatches": self.batchLists,
                "parentCtrl": self,
                "classArry": classArry,
                'batchesArry': batchesArry,
                'localStorageService': localStorageService,
                'authService': authService
            },
            template: _batchSlider2.default,
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            fullscreen: useFullScreen
        });
        $scope.$watch(function () {
            return $mdMedia('xs') || $mdMedia('sm');
        }, function (wantsFullScreen) {
            $scope.customFullscreen = wantsFullScreen === true;
        });
    };

    // function addClasses(selectedSession, selectedCurriculum, cid) {
    //     Meteor.call("addClassPackage", selectedSession, selectedCurriculum, cid);
    // }

    this.goNext = function () {

        if ($scope.btnLabel === "Next") {
            Meteor.call("updateInitialSettingValue", 3, function (error, result) {
                toastr.success("Successfully saved!");
                $state.go("userConsole");
            });
        } else {
            toastr.success("Updated successfully!");
            $state.go("initialSetting");
        }
    };
};
AcademicConsoleCtrl.$inject = ["$scope", "$stateParams", "$rootScope", "$state", "$mdDialog", "$mdMedia", "localStorageService", "authService"];

var DialogController = function DialogController($scope, $mdDialog, data, classIds, selected, allBatches, addedBatches, parentCtrl, classArry, batchesArry, localStorageService, authService) {
    'ngInject';

    _classCallCheck(this, DialogController);

    $scope.loading = false;
    var addedXclasses = [];
    var batchKey = selected[1] + "_" + selected[0];
    if (addedBatches && addedBatches[batchKey] && Object.keys(addedBatches[batchKey]).length > 0) {
        addedXclasses = addedBatches[selected[1] + "_" + selected[0]];

        $scope.editMode = true;
    }
    $scope.batchSliders = data;
    $scope.batchSlidersClassid = classIds;
    $scope.selectedDetails = selected;
    $scope.allBatchesDetails = allBatches;
    var startClass = $scope.batchSliders[0].startRange;
    var endClass = $scope.batchSliders[0].endRange;

    var alpha = [];
    var batch = [];
    for (var i = 65; i <= 90; i++) {
        alpha.push(String.fromCharCode(i));
    }
    for (var i = 65; i <= 90; i++) {
        var first = 'A';
        var next = String.fromCharCode(i);
        alpha.push(first + next);
    }
    $scope.getTotalDivision = function (s, e) {
        var s = $scope.getTotalClass(e, s, 'batchList');
        return s;
    };

    $scope.alphabetTranslate = function (value) {
        if (isNaN(value) || value == undefined) {} else {
            return alpha[value].toUpperCase();
        }
    };

    $scope.$on('slideEnded', function () {});

    $scope.hide = function () {
        $mdDialog.hide();
    };
    var numberTranslate = function numberTranslate(value) {
        return alpha.indexOf(value);
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.answer = function (answer) {
        $mdDialog.hide(answer);
    };
    $scope.getTotalClass = function (highEnd, lowEnd, mode) {
        var list = [];
        for (var i = lowEnd; i <= highEnd; i++) {
            list.push(i);
        }
        if (mode === 'sliderCount') {
            return list.length;
        }
        if (mode === 'batchList') {
            return list;
        }
    };
    $scope.getBatchSliders = function (startClass, endClass) {
        endClass = parseInt(endClass);
        var totalSlider;
        if (startClass === 1 || startClass === 2) {
            startClass = startClass;
            endClass = endClass;
        }
        if (startClass >= 3) {
            startClass = startClass - 2;
            endClass = endClass - 2;
        }
        return [{
            'startClass': startClass,
            'endClass': endClass
        }];
    };

    var bslider = $scope.getBatchSliders(startClass, endClass);

    if (bslider !== {}) {
        var lastBatch = bslider[0].endClass;
        var firstBatch = bslider[0].startClass;
        $scope.totalSliders = $scope.getTotalClass(lastBatch, firstBatch, 'sliderCount');
    }

    $scope.getNumber = function (num, startClass, endClass) {
        var batch = [];
        $scope.batchNames = $scope.getTotalClass(endClass, startClass, 'batchList');
        var arrayLength = $scope.batchNames.length;
        for (var i = 0; i < arrayLength; i++) {
            var txt = $scope.batchNames[i] - 1;
            batch.push(classArry[txt]);
        }

        $scope.batch = unique(batch);

        return new Array(num);
    };

    $scope.addJs = function ($index) {
        if (!$scope.range_slider_batch_values) {
            $scope.range_slider_batch_values = [];
        }
        var startRange = 0;
        var endrange = 2;
        if ($scope.editMode) {
            var xclass = _.find(addedXclasses, function (batchIn) {
                return batchIn.name == $scope.batch[$index];
            });
            if (xclass && xclass.batches && xclass.batches.length > 0) {

                startRange = xclass.batches[0].name;
                endrange = xclass.batches[xclass.batches.length - 1].name;
            }
        }
        $scope.range_slider_batch_values[$index] = {
            startRange: startRange,
            endRange: endrange,
            options: {
                stepsArray: batchesArry,
                onEnd: function onEnd() {},
                //showTicksValues: true,
                showSelectionBar: true,
                getSelectionBarColor: function getSelectionBarColor(v) {
                    return '#1AA762';
                },
                ticksValuesTooltip: function ticksValuesTooltip(v) {
                    var bach = alpha[v];
                    return 'Division -' + bach;
                }
            }
        };
        setTimeout(function () {
            $scope.$broadcast('reCalcViewDimensions');
        }, 500);
    };

    var unique = function unique(origArr) {
        var newArr = [],
            origLen = origArr.length,
            found,
            x,
            y;
        for (x = 0; x < origLen; x++) {
            found = undefined;
            for (y = 0; y < newArr.length; y++) {
                if (origArr[x] === newArr[y]) {
                    found = true;
                    break;
                }
            }
            if (!found) newArr.push(origArr[x]);
        }
        return newArr;
    };

    function addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails) {
        var bths = be + 1;
        var send = {
            seleArrys: seleArrys,
            clsIDs: batchSlidersClassid,
            allBatchDetails: allBatchesDetails,
            starts: bs,
            ends: be,
            classArry: alpha,
            school_id: localStorageService.get('school_id'),
            myUserId: localStorageService.get('user_id')
            // console.log(send)
        };authService.callAPI("/v0/initial-settings/addBatchesArry", "POST", { args: send }, function (response) {
            try {
                console.log('sendsendsendsend');
                if (!response.error) {
                    var result = response.result.data;

                    parentCtrl.setBatchList(seleArrys[0], seleArrys[1]);
                    toastr.success("Batches added for class " + c);
                    $scope.loading = false;
                    $mdDialog.hide();

                    parentCtrl.methodAfterBatchUpdate();
                } else {
                    $scope.loading = false;
                    toastr.error("Network error");
                }
            } catch (e) {
                console.log(e);
            }
        });
    }

    $scope.addAllBatch = function (c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails) {

        // $scope.loading = true;
        if (parentCtrl.initialSettingId < 5) {
            // seleArrys, clsIDs, allBatchDetails, starts, ends, classArry, school_id

            addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails);
        } else {
            var send = {
                seleArrys: seleArrys,
                clsIDs: batchSlidersClassid,
                allBatchDetails: allBatchesDetails,
                starts: bs,
                ends: be,
                classArry: alpha,
                school_id: localStorageService.get('school_id'),
                muUserId: localStorageService.get('user_id')
            };
            authService.callAPI("/v0/initial-settings/academicConsolesWithSchool", "POST", { args: send }, function (response) {
                try {
                    console.log(response);
                    if (!response.error) {
                        var res = response.result.data.details;
                        console.log(res);
                        if (res.classAvailable != undefined) {
                            $scope.loading = false;
                            toastr.error(res.classAvailable);
                            _.defer(function () {
                                $scope.$apply();
                            });;
                            return false;
                        } else {
                            addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails);
                        }
                    } else {}
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("fetchAcademicConeForCheck", seleArrys, batchSlidersClassid, allBatchesDetails, bs, be, alpha, Session.get('school_id'), function(err, res) {
            //         if (err) {
            //             $scope.loading = false;
            //             toastr.success(err.reason);
            //         } else {

            //             if (res.classAvailable != undefined) {
            //                 $scope.loading = false;
            //                 toastr.error(res.classAvailable);
            //                 _.defer(function() { $scope.$apply(); });;
            //                 return false;
            //             } else {
            //                 addClassesAndBatch(c, bs, be, batchSlidersClassid, seleArrys, allBatchesDetails)
            //             }
            //             // if (res.totalError) { //error comes here if result is not zero
            //             //     toastr.error("Cannot delete already added classes or batches");
            //             //     return false
            //             // } 
            //         }
            //     })
            // }
        }

        // $scope.addBatch_NEW = function(a, b, c, allBatchesDetails, clsID) {

        //     let batchValues = $scope.range_slider_batch_values;
        //     _.each(batchValues, function(val) {

        //         let bths = val.endRange + 1;

        //         var myBatches = allBatchesDetails.slice(val.startRange, bths);

        //         let start = $scope.alphabetTranslate(val.startRange)
        //         let end = $scope.alphabetTranslate(val.endRange)

        //     })

        // }
        $scope.alphabetTranslate = function (value) {
            if (isNaN(value) || value == undefined) {} else {
                return alpha[value].toUpperCase();
            }
        };
    };
};
DialogController.$inject = ["$scope", "$mdDialog", "data", "classIds", "selected", "allBatches", "addedBatches", "parentCtrl", "classArry", "batchesArry", "localStorageService", "authService"];

var AddSubject = function AddSubject($scope, $stateParams, $rootScope, $state, $mdDialog, $mdMedia, localStorageService, authService) {
    _classCallCheck(this, AddSubject);

    var self = this;
    var setSubjects = function setSubjects() {

        self.selectBucket = [];
        self.packagesToAdd = [];
        self.subjectPackage = [];

        self.subjectPackage = _.filter($scope.sett, function (one) {
            return one.type == "subject";
        });
        self.packagesToAdd = _.filter(angular.copy($scope.sett), function (one) {
            return one.type == "subject";
        });

        var selectedsubjIds = _.find($scope.acdConsoles, function (one) {
            return one.session_id == $scope.sessionId && one.curriculum_id == $scope.cirriculumId;
        });

        if (!selectedsubjIds && self.subjectPackage.length <= 0) {
            return false;
        }

        var packageIds = _.pluck(selectedsubjIds.subject_package, "_id");
        var subjects = _.flatten(_.pluck(selectedsubjIds.subject_package, "subjects"));

        for (var i = 0; i < self.subjectPackage.length; i++) {

            if (packageIds.indexOf(self.subjectPackage[i]._id) != -1) {

                var subject = _.filter(self.subjectPackage[i].list, function (item) {
                    return subjects.indexOf(item._id) !== -1;
                });
                self.packagesToAdd[i].list = _.filter(self.packagesToAdd[i].list, function (item) {
                    return subjects.indexOf(item._id) === -1;
                });

                self.selectBucket.push({
                    _id: self.subjectPackage[i]._id,
                    list: subject,
                    name: self.subjectPackage[i].name,
                    type: self.subjectPackage[i].type
                });
            } else {
                self.selectBucket.push({
                    _id: self.subjectPackage[i]._id,
                    list: [],
                    name: self.subjectPackage[i].name,
                    type: self.subjectPackage[i].type
                });
            }
        }
        var finalObj = {};
    };

    // this.$onInit = function() {
    //     console.log(this)
    //     $scope.cirriculumId = this.cirriculumId;
    //     $scope.sessionId = this.sessionId;
    //     $scope.acdConsoles = this.acdConsoles;
    //     $scope.sett = this.sett;
    //     setSubjects()
    // }

    this.$onChanges = function () {
        $scope.cirriculumId = this.cirriculumId;
        $scope.sessionId = this.sessionId;
        $scope.acdConsoles = this.acdConsoles;
        $scope.sett = this.sett;
        setSubjects();
    };

    // self.selectedCurriculum = [];
    // self.allSubjectsList = []
    // let newDataArry = {};
    // let upSetArry = {};
    // this.packagesToAdd = []
    // let curriculumArry = [];
    // let sessionsArry = [];
    // let sessionsChk = [];
    // self.enableNextBtn = false;
    // self.enableNewSubjectBtn = false;
    // self.enableNewSubjectDiv = false;


    self.collapseRight = function (fileData, index) {

        for (var j = 0; j < self.selectBucket.length; j++) {
            if (j != index) {
                self.packagesToAdd[j].expanded = false;
                self.selectBucket[j].expanded = false;
            }
        }
        if (!fileData.expanded) {
            self.selectBucket[index].expanded = true;
            self.packagesToAdd[index].expanded = true;
        } else {
            self.selectBucket[index].expanded = false;
            self.packagesToAdd[index].expanded = false;
        }
    };

    self.collapseBucket = function (data, index) {

        for (var i = 0; i < self.packagesToAdd.length; i++) {
            if (i != index) {
                self.packagesToAdd[i].expanded = false;
                self.selectBucket[i].expanded = false;
            }
        }
        if (!data.expanded) {
            self.selectBucket[index].expanded = true;
            self.packagesToAdd[index].expanded = true;
        } else {
            self.selectBucket[index].expanded = false;
            self.packagesToAdd[index].expanded = false;
        }
    };

    self.clickRightBucketItems = function (index) {
        var data = _.filter($scope.sett, function (one) {
            return one.type == "subject";
        });
        self.packagesToAdd[index].list = _.clone(self.selectBucket[index].list);
        self.selectBucket[index].list = [];
        self.collapseBucket(self.selectBucket[index], index);
        toastr.success("Subjects Removed from bucket");
    };

    self.clickLeftBucketItems = function (index) {

        var data = _.filter($scope.sett, function (one) {
            return one.type == "subject";
        });

        self.collapseRight(self.packagesToAdd[index], index);
        self.selectBucket[index].list = data[index].list;
        self.packagesToAdd[index].list = [];
        toastr.success("Subjects Added to bucket");
    };

    self.saveSubjectArry = function () {
        self.enableNextBtn = false;
        self.updateAcademicConsole($scope.sessionId, $scope.cirriculumId);
    };

    self.updateAcademicConsole = function (sessId, curiId) {

        if (!self.selectBucket || self.selectBucket.length === 0) {
            toastr.error("Please add some subjects.");
        }

        var toContinue = 0;

        _.each(self.selectBucket, function (pack) {
            if (!pack.list || pack.list.length === 0) {
                toContinue += 1;
            }
        });

        if (toContinue === self.selectBucket.length) {
            toastr.error("Empty subject package not allowed.");
            return false;
        }

        var reqObj = {
            session_id: sessId,
            curriculum_id: curiId,
            subject_packages: self.selectBucket,
            school_id: localStorageService.get('school_id')
        };

        authService.callAPI("/v0/initial-settings/updateSubjectPackage", "POST", reqObj, function (response) {
            try {
                if (response.error) toastr.error("Please try after some time.");else toastr.success("Subject package added successfully!");
            } catch (e) {
                console.log(e);
            }
        });
    };

    self.dragControlListeners = {
        containment: '#blocks'

    };

    self.sortableCloneOptions1 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true,
        dragEnd: function dragEnd() {
            self.enableNewSubjectDiv = false;
            // setSubjects()
        }

        // self.getSubjectPackages();

    };
};

exports.default = angular.module(name, [
// angularMeteor,
// uiRouter,
'wizardStatus']).component("academicConsole", {
    template: _academicConsole2.default,
    controllerAs: 'setClassSliderCtrl',
    controller: ['$scope', '$stateParams', '$rootScope', '$state', '$mdDialog', '$mdMedia', 'localStorageService', 'authService', AcademicConsoleCtrl]
}).component("addSubject", {
    template: _addSubject2.default,
    controllerAs: 'addSubjectCtrl',
    bindings: {
        cirriculumId: '<',
        sessionId: '<',
        acdConsoles: '<',
        sett: '<'
    },
    controller: ['$scope', '$stateParams', '$rootScope', '$state', '$mdDialog', '$mdMedia', 'localStorageService', 'authService', AddSubject]
}).controller('academicConsole', AcademicConsoleCtrl);


function config($stateProvider) {
    'ngInject';

    $stateProvider.state('academicConsole', {
        url: '/academicConsole',
        template: '<academic-console></academic-console>'
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.classSlider md-dialog{width:100%!important}.batchSlider{width:100%!important}.active-intitial{background-color:#18a8a9;color:#fff}.add_grp{width:auto;position:relative;top:13px;right:12px}#rcorners2{height:100%;border-radius:0;background:#fff;padding:10px;margin:5px}</style> <div class=intialstupBox> <div layout-padding ng-cloak ng-hide=noToolBar class=\"md-whiteframe-2dp bgColor pageInit\" md-theme=makeMeWhite> <wizard-status ng-show=showWizard feature-data=tabStats></wizard-status> <div class=slider> <div flex layout=column> <md-content class=md-padding> <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs> <md-tab label={{session.name}} class=\"hand session_title\" ng-repeat=\"session in setClassSliderCtrl.sessionpackage.list\" ng-click=setClassSliderCtrl.showThis(session._id,session.name)> <md-content class=md-padding> <div flex layout=row class=padBt> <div ng-class=\"{'active-intitial': activeBtn[$index],'inactive':activeBtn[$index]}\" class=\"md-raised md-primary btn_cir hand\" ng-repeat=\"curriculumBtn in setClassSliderCtrl.sessionCurriArray\" ng-click=setClassSliderCtrl.showCurriculum(curriculumBtn.cName,curriculumBtn.id,$index+1,$index,curriculumBtn,session._id,$parent.$index)>{{curriculumBtn.cName}} </div> </div> <div class=onClick ng-if=setClassSliderCtrl.enableSlider> <rzslider class=wrapper rz-slider-model=range_slider_ticks_values.startRange rz-slider-high=range_slider_ticks_values.endRange rz-slider-options=range_slider_ticks_values.options></rzslider> <div class=padBt> <md-button class=\"md-primary md-raised\" ng-click=\"setClassSliderCtrl.showClass(range_slider_ticks_values.startRange, range_slider_ticks_values.endRange)\">{{setClassSliderCtrl.batchLists[selectedSession+'_'+session._id] && setClassSliderCtrl.batchLists[selectedSession+'_'+session._id].length>0 ? \"Update Batches\":\"click here to add batches\"}}</md-button> </div> <div flex=100 layout=row layout-xs=column layout-align-xs=space-between layout-align=\"space-between center\" layout-wrap> <div class=\"ng-scope md-whiteframe-3dp bottom_mar_20\" flex=100 flex-xs=100 layout-align=\"space-around center\"> <div class=\"md-hue-3 border_top_none md-makeMeWhite-theme layout-row flex\" layout=row flex=\"\"> <p class=\"md-body-1 mar_left_15 ng-binding flex-offset-5 flex boxTitle\" flex=\"\" flex-offset=5>Batches</p> </div> <div class=\"mgmtLightBox layout-column boxArea\" layout=row layout-sm=column flex layout-wrap> <div class=\"box BoxSpace\" ng-repeat=\"xclassIn in setClassSliderCtrl.batchLists[selectedSession+'_'+session._id]\" ng-init=\"batchSpan = getBatchString(xclassIn.batches)\">{{xclassIn.name +\" - [\"+batchSpan+\"]\"}}</div> </div> </div> </div> <div ng-cloak class=md-whiteframe-3dp> <md-content> <md-tabs md-dynamic-height md-border-bottom> <md-tab label=\"Add Subjects\" class=\"tab_width round\"> <add-subject sett=sett acd-consoles=acdConsoles cirriculum-id=subjecttitle session-id=currentCurriculum></add-subject> </md-tab> </md-tabs> </md-content> </div> </div> </md-content> </md-tab> </md-tabs> </md-content> <md-button class=\"md-raised md-primary btn3 md-hue-2\" ng-if=!hideNextButtonAcademicConsole ng-click=\"setClassSliderCtrl.goNext( )\"> {{btnLabel}}</md-button> </div> </div> </div> </div> ";

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports = "<style type=text/css>.bgColor{background-color:#fff!important;width:100%!important}.wrapper{color:#55637d}.btn{float:right}.division{float:right}.rz-pointer-max{left:100px}.slide_batch{margin-bottom:20px}.classSlider md-dialog{width:100%!important}.batchSlider{width:100%!important}.margin-forspinner{margin-left:500px}</style> <style>.topMargin{margin-top:20px!important}.main-head{font-weight:600;color:#0c8588;font-size:18px}.border-bottom{border-bottom:2px solid #34b4b7}.mainTeacherContainer{width:70%}.teacherFluid{margin:10px}.teacherHeader{background-color:#46b4fb!important;min-height:42px;padding-left:10px}.subjectName{color:#62ca8c;text-transform:uppercase}</style> <md-dialog class=batchSlider> <md-toolbar class=border-bottom> <div class=md-toolbar-tools> <div layout=row flex> <div flex=50 class=main_head> Set Class and Batches</div> <div flex=50 ng-if=!loading layout-align=\"end end\" layout=row> <i class=\"fas fa-times\" ng-click=cancel()></i> </div> </div> </div> </md-toolbar> <div layout-padding ng-cloak ng-hide=noToolBar class=bgColor md-theme=makeMeWhite> <div class=slider> <div flex layout=column> <div ng-cloak flex layout=column class=padTp> <div flex layout=row layout-align=\"end start\" layout-padding> <md-button class=\"md-raised btn md-primary\" ng-disabled=loading ng-click=addAllBatch(batch,range_slider_batch_values,range_slider_batch_values,batchSlidersClassid,selectedDetails,allBatchesDetails)>Save </md-button> </div> <md-progress-circular ng-if=loading class=\"md-warn md-hue-3 margin-forspinner\" md-diameter=70></md-progress-circular> <div class=slide_batch ng-repeat=\"i in getNumber(totalSliders,batchSliders[0].startRange,batchSliders[0].endRange) track by $index\" ng-init=addJs($index)> <span> Class - {{batch[$index]}} </span> <span class=division> Division - {{range_slider_batch_values[$index].startRange}} to {{range_slider_batch_values[$index].endRange}} </span> <rzslider class=wrapper rz-slider-model=range_slider_batch_values[$index].startRange rz-slider-high=range_slider_batch_values[$index].endRange rz-slider-options=range_slider_batch_values[$index].options></rzslider> </div> <md-divider></md-divider> </div> </div> </div> </div> </md-dialog> ";

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<style>.md-accordion .activeContent{min-height:25px}</style> <md-content class=\"md-padding privileges\"> <div layout=row flex layout-xs=column class=md-whiteframe> <div class=\"md-whiteframe-3dp md-padding\" layout=row style=width:49%> <div flex> <div style=margin-top:10px> <md-card-title> <h4>List of Subject Package </h4> <md-divider class=md-makeMeWhite-theme></md-divider> </md-card-title> </div> <div layout=column flex> <div flex ng-repeat=\"subjectName in addSubjectCtrl.packagesToAdd\"> <div class=\"md-accordion md-whiteframe-1dp\" flex> <img class=\"delSession add_grp\" src=" + __webpack_require__(445) + " ng-click=\"addSubjectCtrl.clickLeftBucketItems(  $index )\" ng-if=\"subjectName.list.length>0\"> <div ng-init=\"subjectName.expanded = false\" ng-click=\"addSubjectCtrl.collapseBucket(subjectName, $index )\" style=background:#dbdde0> <div layout=row flex class=\"acctoolbar sub\" layout-align=\"start center\"> <div flex layout-align=\"start center\"> {{subjectName.name}} </div> </div> </div> <div as-sortable=addSubjectCtrl.sortableCloneOptions1 ng-model=subjectName.list ng-class=\"{dataContent:true, activeContent:subjectName.expanded}\"> <div ng-repeat=\"feature in subjectName.list\" as-sortable-item flex layout=column layout-align=\"space-between start\" class=feturebox> <div style=\"margin:10px 0 10px 0;width:100%\" as-sortable-item-handle class=\"md-whiteframe-3dp acctoolbar feature\" flex=90> {{feature.name}}</div> </div> </div> </div> </div> </div> </div> </div> <div layout=row layout-sm=column class=\"md-whiteframe-3dp drag_height md-padding\" style=width:49%;margin-left:20px> <div flex> <div style=margin-top:10px> <md-card-title> <h4>List of Selected Subjects </h4> <md-button class=\"md-raised md-primary addAdd md-hue-2 manage_btn\" ng-click=addSubjectCtrl.saveSubjectArry()>Save</md-button> <md-divider class=md-makeMeWhite-theme></md-divider> </md-card-title> </div> <div style=min-height:15px layout=column flex ng-model=addSubjectCtrl.selectBucket layout-align=end> <div flex ng-repeat=\"bucketSubject in addSubjectCtrl.selectBucket\"> <div class=\"md-accordion md-whiteframe-1dp\" flex> <img class=\"delSession add_grp\" src=" + __webpack_require__(445) + " ng-click=\"addSubjectCtrl.clickRightBucketItems(  $index )\" ng-if=\"bucketSubject.list.length>0\"> <div ng-init=\"bucketSubject.expanded = false\" ng-click=\"addSubjectCtrl.collapseRight(bucketSubject , $index )\" style=background:#dbdde0> <div layout=row flex class=\"acctoolbar sub\" layout-align=\"start center\"> <div flex layout-align=\"start center\"> {{bucketSubject.name}} </div> </div> </div> <div ng-class=\"{dataContent:true, activeContent:bucketSubject.expanded}\" ng-model=bucketSubject.list as-sortable=addSubjectCtrl.sortableCloneOptions1> <div ng-repeat=\"feature in bucketSubject.list\" flex layout=column layout-align=\"space-between start\" class=feturebox as-sortable-item> <div style=\"margin:10px 0 10px 0;width:100%\" as-sortable-item-handle class=\"md-whiteframe-3dp acctoolbar feature\" flex=90> {{feature.name}}</div> </div> </div> </div> </div> </div> </div> </div> </div> </md-content> ";

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

module.exports = " <div class=row> <div class=\"x_content initialSets\"> <div id=wizard class=\"form_wizard wizard_horizontal\"> <ul class=wizard_steps> <li class=basic ng-click=\"wizardCtrl.selectedWizard('basicSettings')\"> <a id=prop1 class=disabled> <span class=step_no>1</span> <span class=\"step_descr hand selectedtab1\" ng-class-active=colorRed> BASIC <br/> </span> </a> </li> <li class=curriculum ng-click=\"wizardCtrl.selectedWizard('curriculumConsole')\"> <a id=prop2 class=disabled> <span class=step_no>2</span> <span class=\"step_descr hand selectedtab2\"> CURRICULUM CONSOLE <br/> </span> </a> </li> <li class=academic ng-click=\"wizardCtrl.selectedWizard('academicConsole')\"> <a id=prop3 class=disabled> <span class=step_no>3</span> <span class=\"step_descr hand selectedtab3\"> ACADEMIC CONSOLE <br/> </span> </a> </li> <li class=user ng-click=\"wizardCtrl.selectedWizard('userConsole')\"> <a id=prop4 class=disabled> <span class=step_no>4</span> <span class=\"step_descr hand selectedtab4\"> USER CONSOLE <br/> </span> </a> </li> <li class=check ng-click=\"wizardCtrl.selectedWizard('checkList')\"> <a id=prop5 class=disabled> <span class=step_no>5</span> <span class=\"step_descr hand selectedtab5\"> CHECK LIST <br/> </span> </a> </li> </ul> </div> </div> </div>";

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

config.$inject = ["$stateProvider"];
Object.defineProperty(exports, "__esModule", {
    value: true
});

var _userConsole = __webpack_require__(1405);

var _userConsole2 = _interopRequireDefault(_userConsole);

var _csvUpload = __webpack_require__(1406);

var _csvUpload2 = _interopRequireDefault(_csvUpload);

var _csvEntries = __webpack_require__(1407);

var _csvEntries2 = _interopRequireDefault(_csvEntries);

__webpack_require__(446);

__webpack_require__(1408);

var _ngFileUpload = __webpack_require__(448);

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _wizard = __webpack_require__(447);

var _wizard2 = _interopRequireDefault(_wizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var name = 'userConsole';

// const mongoose = require('mongoose');
var UserConsole = function UserConsole($scope, $mdDialog, $mdToast, $mdMedia, $state, $element, $attrs, $compile, $rootScope, $timeout, localStorageService, authService, CONSTANTS) {
    'ngInject';

    _classCallCheck(this, UserConsole);

    var self = this;
    $rootScope.title = "User Console";
    self.rolesToLoad = [];
    self.selectedCurriculum = [];
    self.enableRoleList = false;
    self.enableNewRoleBtn = false;
    self.enableNewRoleDiv = false;
    var localSchoolId = localStorageService.get('school_id');
    var localMyUserId = localStorageService.get('user_id');
    $scope.btnLabel = "Save";
    $scope.showWizard = false;
    $scope.isReportingObj = false;
    // $scope.subscribe('getRoleMappings')
    $scope.allRoleCounts = [];
    $scope.setCounts = function () {

        var sendObj = { schoolId: localSchoolId };
        authService.callAPI("/v0/initial-settings/user-console/user/management/" + localSchoolId, "GET", sendObj, function (response) {
            try {
                console.log(response);
                if (!response.error) {
                    $scope.allRoleCounts = response.result.data.data.rolecounts;
                    // if(!$scope.allRoleCounts.Student){
                    //     $scope.allRoleCounts.Student = {}
                    //     $scope.allRoleCounts['Student']['detailedcount'] = response.result.data.data.studentData

                    // }
                    $scope.detailedcount = response.result.data.data.studentData;
                    console.log($scope.allRoleCounts);
                } else {
                    console.log(response.error);
                }
                getUserPrivilageInitialSetting();
            } catch (e) {
                console.log(e);
            }
        });
        // Meteor.call("getAddedRolesCount", Session.get('school_id'), localStorage.getItem('activeAcdYear'), (err, res) => {
        //     if (res) {
        //         $scope.allRoleCounts = res
        //     }
        // })
    };
    var setSettings = function setSettings() {
        self.curriculumPackage = [$scope.allSettingRole];

        self.selectedRoles = _.filter(self.curriculumPackage[0].list, function (role) {
            return role.name != 'Master Admin' && role.status === true;
        });

        var ToLoad = _.filter(self.curriculumPackage[0].list, function (role) {
            return role.name != 'Master Admin' && role.status === false;
        });

        // self.rolesToLoad = _.filter(self.curriculumPackage[0].list, function(role) {
        //     return role.name != 'Admin' && role.status === false
        // })


        // let role = _.filter(self.rolesToLoad, function(role) {
        //      return _.filter(self.selectedCurriculum, function(selectedRole) {
        //          return selectedRole.name != 'Admin' && selectedRole.status === false && role._id!=selectedRole._id 
        //      })
        //  })

        if (self.selectedCurriculum === undefined || self.selectedCurriculum.length === 0) {
            self.rolesToLoad = ToLoad;
        } else {
            _.each(ToLoad, function (v) {
                _.each(self.selectedCurriculum, function (k) {
                    if (v._id != k._id) {
                        self.rolesToLoad.push(v);
                    }
                });
            });
        }
    };

    var getRoleSettings = function getRoleSettings() {
        setSettings();
    };
    var sendObj = { schoolId: localSchoolId };
    authService.callAPI("/v0/initial-settings/user-console/roles/all/" + localSchoolId, "GET", sendObj, function (response) {
        try {
            console.log(response);
            if (!response.error) {
                $scope.allSettingRole = response.result.data.data;
                self.allSettingRole = response.result.data.data;
                console.log(self.allSettingRole);

                if (response.result.data.mapping_roles) {
                    $scope.reportingObj = response.result.data.mapping_roles;
                    if ($scope.reportingObj) $scope.isReportingObj = true;else {
                        $scope.isReportingObj = false;
                        $scope.userdata = undefined;
                        $scope.headRole = undefined;
                    }
                }
                getRoleSettings();
                $scope.setCounts();
            } else {
                console.log(response.error);
            }
        } catch (e) {
            console.log(e);
        }
    });
    // $scope.autorun(() => {
    //     $scope.reportingObj = ReportingRolesMapping.findOne({
    //         school_id: localStorageService.get('school_id')
    //     })
    //     if ($scope.reportingObj)
    //         $scope.isReportingObj = true;
    //     else {
    //         $scope.isReportingObj = false;
    //         $scope.userdata = undefined
    //         $scope.headRole = undefined
    //     }

    // })
    var subsSetting = undefined;

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        $rootScope.title = "User Console";
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, {
                reload: true
            });
        }
        //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
    };

    this.$onDestroy = function () {
        if (subsSetting) subsSetting.stop();

        self.rolesToLoad = undefined;
        self.selectedRoles = undefined;
        $scope.allRoleCounts = undefined;
    };

    function getUserPrivilageInitialSetting() {
        var send = {
            userId: localMyUserId,
            schoolId: localSchoolId };
        authService.callAPI("/v0/initial-settings/user-console/getUserPrivilageInitialSetting", "POST", send, function (response) {
            try {
                if (!response.error) {
                    self.checkintialSettingValue(response.result.data.data.initial_settings);
                } else {
                    console.log(response.error);
                }
            } catch (e) {
                console.log(e);
            }
        });
    }
    // self.call('getUserPrivilageInitialSetting', Meteor.userId(), Session.get('school_id'), (error, result) => {
    //     if (result) {
    //         self.checkintialSettingValue(result.initial_settings)
    //     }
    // })

    self.checkintialSettingValue = function (val) {
        $scope.tabStats = {};
        for (var i = 1; i <= 5; i++) {
            if (i <= val) {
                $("#prop" + i).removeClass('disabled');
            } else {
                $scope.tabStats['tab' + i] = "disabled";
            }
        };
        if (val < 5) {
            $scope.showWizard = true;
            $scope.btnLabel = "Next";
        }
    };

    this.getCountFromChild = function () {
        $scope.setCounts();
    };

    self.showRoleList = function () {
        self.enableRoleList = self.enableRoleList === false ? true : false;
    };

    self.addRoleEnable = function () {
        self.enableNewRoleDiv = self.enableNewRoleDiv === false ? true : false;
        self.enableNewRoleBtn = self.enableNewRoleDiv;
    };

    self.addNewRole = function () {

        if (!self.newRoles || self.newRoles.trim() === '') {
            toastr.error("Please enter role name");
            return false;
        } else if (_.find(self.curriculumPackage[0].list, function (ex) {
            return ex.name.toLowerCase() == self.newRoles.toLowerCase();
        })) {
            toastr.error("Role already exist");
            return false;
        }
        var randId = Math.random().toString(36).substr(2, 10);
        self.selectedCurriculum.push({
            _id: randId,
            status: false,
            name: self.newRoles
        });
        // var schoolId = req.body.schoolId
        // var roleName = req.body.roleName
        var send = {
            schoolId: localSchoolId,
            roleName: self.newRoles
        };
        authService.callAPI("/v0/initial-settings/user-console/roles/new/save", "POST", send, function (response) {
            try {
                if (!response.error) {
                    self.enableNextBtn = true;
                } else {
                    console.log(response.error);
                    if (response.error) {
                        if (response.error.error === 'rolePackageError') {
                            toastr.error("Invalid Data to server.");
                        } else {
                            toastr.error("Please try after some time.");
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }
        });
        self.newRoles = '';
    };

    self.deleteRole = function (role) {

        var confirm = $mdDialog.confirm().title('Delete Role?').textContent('Are you sure you want to delete this Role?').ariaLabel('Confirm delete').ok('Yes').cancel('Cancel');
        var send = {
            school_id: localSchoolId,
            role: role
        };
        $mdDialog.show(confirm).then(function () {
            authService.callAPI("/v0/initial-settings/user-console/deleteRoleFromRolePriv", "POST", { args: send }, function (response) {
                try {
                    console.log(response);
                    if (response.error) {
                        toastr.error("Please try after some time.");
                    } else {
                        var res = response.result.data.data;
                        if (res) {
                            $scope.setCounts();
                            toastr.success("Role deleted sucessfully");
                        } else {
                            toastr.error('Cannot delete.Users are already assigned');
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("deleteRoleFromRolePriv", role, Session.get('school_id'), function(err, res) {
            //     if (err) {
            //         toastr.error("Please try after some time.");

            //     } else {

            //         if (res) {
            //             $scope.setCounts()
            //             toastr.success("Role deleted sucessfully");
            //         } else {
            //             toastr.error('Cannot delete.Users are already assigned');
            //         }
            //     }
            // })
        });
        return false;
    };

    self.remove = function (index) {
        self.selectedCurriculum.splice(index, 1);
    };

    self.addRole = function () {
        if (self.selectedCurriculum.length === 0) {
            toastr.error("Please add roles");
            return false;
        }
        var send = {
            schoolId: localSchoolId,
            roleList: self.selectedCurriculum
        };
        authService.callAPI("/v0/initial-settings/user-console/roles/assigned/update", "POST", send, function (response) {
            try {
                console.log(response);
                if (!response.error) {
                    toastr.success("New Role added sucessfully.");
                    self.enableNextBtn = true;
                    self.selectedCurriculum = [];
                    $scope.allSettingRole = response.result.data.data;
                    setSettings();
                } else {
                    console.log(response.error);
                    if (response.error) {
                        if (response.error.error === 'PrivilegeError') {
                            toastr.error("Invalid Data to server.");
                        } else {
                            toastr.error("Please try after some time.");
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }
        });
        // Meteor.call("addRolePrivilage", self.selectedCurriculum, Session.get('school_id'), function(error, result) {
        //     if (error) {
        //         if (error.error) {
        //             if (error.error === 'PrivilegeError') {
        //                 toastr.error("Invalid Data to server.");
        //             } else {
        //                 toastr.error("Please try after some time.");
        //             }
        //         }
        //     } else {
        //         toastr.success("New Role added sucessfully.");
        //         self.enableNextBtn = true;
        //         self.selectedCurriculum = [];
        //     }
        // });
    };

    self.dragControlListeners = {
        containment: '#blocks'
    };

    self.sortableCloneOptions1 = {
        containment: '#sortable-container',
        allowDuplicates: true,
        ctrlClone: true
    };

    self.goNext = function () {

        if (self.selectedRoles.length <= 0) {
            toastr.success("please add atleast one role");
            return false;
        }

        if ($scope.btnLabel === "Next") {
            Meteor.call("updateInitialSettingValue", 4, function (error, result) {
                toastr.success("Successfully saved!");
                $state.go("checkList");
            });
        } else {
            toastr.success("Updated successfully!");
            $state.go("initialSetting");
        }
    };
    var HierarchyItems = function HierarchyItems() {

        this.loadedPages = {};

        this.numItems = 0;

        this.PAGE_SIZE = 50;

        this.fetchNumItems_();
    };

    HierarchyItems.prototype.getItemAtIndex = function (index) {
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];

        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            this.fetchPage_(pageNumber);
        }
    };

    HierarchyItems.prototype.getLength = function () {
        return this.numItems;
    };

    HierarchyItems.prototype.fetchPage_ = function (pageNumber) {
        var hierarchy = this;
        if (!hierarchy.loadedPages) {
            hierarchy.loadedPages = {};
        }
        hierarchy.loadedPages[pageNumber] = null;
        $timeout(angular.noop, 300).then(angular.bind(this, function () {
            hierarchy.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * hierarchy.PAGE_SIZE;
            var paginationOpts = {
                limit: parseInt(hierarchy.PAGE_SIZE),
                skip: parseInt(pageOffset)
            };
            var match = {
                pagination_opts: paginationOpts,
                selector: {
                    $or: [{
                        role_id: $scope.current_role
                    }, {
                        role_ids: {
                            $in: [$scope.current_role]
                        }
                    }],
                    school_id: localStorageService.get('school_id')
                },
                role_id: $scope.current_role
            };
            authService.callAPI("/v0/hierarchy/get-users-with-child", "POST", match, function (response) {
                try {

                    var result = response.result.data.data;
                    console.log(result);
                    if (result.length > 0) {
                        // result = _.uniq(result, false, function(one){
                        //     return one._id
                        // })
                        hierarchy.loadedPages[pageNumber] = result;
                        $scope.$apply();
                    }
                } catch (e) {
                    console.log(e);
                }
                $scope.$apply();
            });
            // Meteor.call('getUsersByRole', $scope.current_role, Session.get('school_id'), paginationOpts, (error, result) => {
            //     if (result.length > 0) {
            //         this.loadedPages[pageNumber] = result
            //         $scope.$apply()
            //     }


            // })

        }));
    };

    HierarchyItems.prototype.fetchNumItems_ = function () {
        var hierarchy = this;
        var match = {
            // role_id : $scope.current_role,
            $or: [{
                role_id: $scope.current_role
            }, {
                role_ids: {
                    $in: [$scope.current_role]
                }
            }],
            school_id: localStorageService.get('school_id')
        };
        $timeout(angular.noop, 300).then(angular.bind(this, function () {
            authService.callAPI("/v0/hierarchy/get-count-of-users", "POST", match, function (response) {
                try {
                    var result = response.result.data.data;
                    hierarchy['numItems'] = result;
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
                $scope.$apply();
            });
        }));
    };

    self.loadMangerUsers = function (role) {
        $scope.current_role = role._id;
        $scope.managerUsers = new HierarchyItems();
        //$scope.data=undefined
        $scope.userdata = undefined;
        $scope.roleData = role;
    };
    self.deleteReportingRole = function () {
        var confirm = $mdDialog.confirm().title('Delete Role?').textContent('This will remove all concerned settings').ariaLabel('Confirm delete').ok('Yes').cancel('Cancel');
        $mdDialog.show(confirm).then(function () {

            authService.callAPI("/v0/hierarchy/delete-institution-head/" + localSchoolId, "GET", function (response) {
                try {
                    if (response.error) {
                        toastr.error("Please try after some time.");
                    } else {
                        $scope.isReportingObj = false;
                        $scope.reportingObj = {};
                        toastr.success("Deleted sucessfully");
                    }
                    $scope.$apply();
                } catch (e) {
                    console.log(e);
                }
            });
            // Meteor.call("deleteRoleMappings", Session.get('school_id'), function(err, res) {
            //     if (err) {
            //         toastr.error("Please try after some time.");

            //     } else {

            //         toastr.success("Deleted sucessfully");
            //     }
            // })
        }, function () {
            $scope.status = 'You decided to keep your debt.';
        });
    };
    /*Meteor.call("getReportingSettings",Session.get('school_id'),(error,result)=>{
        if(result && result.length>0){
             $scope.reportingObj=result[0]
             $scope.isReportingObj=true;
        }
    })*/
    self.saveHeadRole = function () {
        var data = {
            "role_name": $scope.roleData.name,
            "role_id": $scope.roleData._id,
            "_id": $scope.userdata
        };
        var match = {
            data: data,
            school_id: localStorageService.get('school_id'),
            academic_year: localStorageService.get('academic_year')
        };
        authService.callAPI("/v0/hierarchy/save-head-role", "POST", match, function (response) {
            try {
                console.log(response);
                var result = response.result.data;
                if (result) {
                    toastr.success("Saved successfully");
                } else {
                    toastr.error(response.error);
                }

                $scope.$apply();
            } catch (e) {
                console.log(e);
            }
            $scope.$apply();
        });
        // Meteor.call("saveHeadRole", data, Session.get('school_id'),  localStorage.getItem('activeAcdYear'), function(error, result) {
        //     if (!error)
        //         toastr.success("Saved successfully")
        //     else

        // })
    };
};
UserConsole.$inject = ["$scope", "$mdDialog", "$mdToast", "$mdMedia", "$state", "$element", "$attrs", "$compile", "$rootScope", "$timeout", "localStorageService", "authService", "CONSTANTS"];

var csvUploadController = function csvUploadController($scope, $stateParams, $mdMedia, $mdDialog, $state, $timeout, $q, $log, errorValidatorUtil, localStorageService, authService) {
    'ngInject';

    var _this = this;

    _classCallCheck(this, csvUploadController);

    var self = this;
    self.fullSett = undefined;
    function autorun(allData) {
        var settingsData = allData.sett;
        var acConsoles = allData.acConsoles;
        var roleData = allData.roleData;
        $scope.settingsData = allData.sett;
        $scope.acConsoles = allData.acConsoles;
        $scope.roleData = allData.roleData;
        self.rolePackage = _.find(settingsData, function (one) {
            return one.type == "role";
        });

        self.allSessions = _.filter(settingsData, function (one) {
            return one.type == "session";
        });

        self.allCurriculum = _.filter(settingsData, function (one) {
            return one.type == "curriculum";
        });

        self.allClassess = _.filter(settingsData, function (one) {
            return one.type == "class";
        });

        self.allBatchess = _.filter(settingsData, function (one) {
            return one.type == "batch";
        });

        if (self.rolePackage) {
            self.allRoles = _.filter(self.rolePackage.list, function (role) {
                return (role.name != 'Admin' || role.name === 'Teacher') && role.status === true;
            });
        } else {
            return false;
        }

        self.sessions = [];
        self.addedSessions = acConsoles;

        if (self.addedSessions === undefined || self.addedSessions.length <= 0) return false;

        _.each(self.addedSessions, function (eachSessionId) {
            addedSessionsID.push(eachSessionId.session_id);
        });
        addedSessionsID = _.uniq(addedSessionsID);
        _.each(self.allSessions[0].list, function (v) {
            _.each(addedSessionsID, function (k) {
                if (v._id === k) {
                    var item = {
                        _id: v._id,
                        name: v.name
                    };
                    self.showSessionName.push(item);
                }
            });
        });
        self.showSessionName = _.uniq(self.showSessionName, function (doc) {
            return doc._id;
        });
    }
    this.$onInit = function () {

        self.fullSett = this.parentCtrl.allSettingRole;
        console.log('sssssssss');
        console.log(self.fullSett);
        var send = {
            school_id: localStorageService.get('school_id')
        };
        authService.callAPI("/v0/initial-settings/user-console/getPacks", "POST", { args: send }, function (response) {
            console.log(response);
            try {
                if (!response.error) {

                    autorun(response.result.data.data);
                } else {
                    console.log(response.error);
                }
            } catch (e) {
                console.log(e);
            }
        });
    };
    self.fileUploadObj = {};
    $scope.showPreviewBtn = false;
    $scope.showBrowseBtn = false;
    $scope.showDownloadBtn = false;

    var subsEmail = undefined,
        subsAcdemicPck = undefined,
        subsSetting = undefined,
        subsRole = undefined;

    // this.$onInit = () => {
    //     subsEmail = self.subscribe('getAllEmailsOnly')
    //     subsAcdemicPck = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
    //     subsSetting = self.subscribe('getAllAcademicSettings', () => [Session.get('school_id')])
    //     subsRole = self.subscribe('getRolesData', () => [Session.get('school_id')])
    // }

    this.$onDestroy = function () {
        if (subsEmail) subsEmail.stop();
        if (subsAcdemicPck) subsAcdemicPck.stop();
        if (subsSetting) subsSetting.stop();
        if (subsRole) subsRole.stop();

        self.fileUploadObj = undefined;
        self.selectedsubjs = [];
        self.showSessionName = [];
        self.showCurriculumName = [];
        self.userArry = {};
    };
    var validateBulk = function validateBulk(objToVal) {
        // console.log(objToVal)
        var retVal = [];
        var errors = {};
        // objToVal = {}
        var fields = ["name", "email", "phone", "addrLine1", "addrLine2", "city", "country", "pincode", "username", "initial_settings", "joined_date", "birth_date", "sex", "admission_number", "relation", "parent_email", "role", "spouse", "use_gafe", "Password", "blood_group", "is_employee", "employee_no"];
        _.each(fields, function (o) {
            if (objToVal[o]) {
                if (objToVal[o] == "") {
                    objToVal[o] = undefined;
                }
                objToVal[o] = objToVal[o].trim();
            }
        });
        if (!objToVal.name) {
            var err = {};
            err['name'] = "name";
            err['message'] = "Name is required";
            retVal.push(err);
            // objToVal.name.errors['name'] = "Name is required"
        } else {
            if (typeof objToVal.name === 'string' || objToVal.name instanceof String) {
                var n = objToVal.name.length;
                if (n > 75) {
                    objToVal.name.errors['name'] = "Name doesnt exceed 75 chars";
                } else if (n < 3) {
                    objToVal.name.errors['name'] = "Name doesnt less than 3 chars";
                } else {
                    var patternC = /^(^\w+)[a-zA-Z.\s]*$/;
                    var spaceSingle = /^[a-zA-Z]+\s[a-zA-Z]+$/;
                    var _n = objToVal.name.search(' ');

                    if (!patternC.test(objToVal.name)) {
                        objToVal.name.errors['name'] = "Special characters and numericals are not allowed";
                    }
                    if (_n !== -1) {
                        // let datVal = patternC.test(this.value)
                        if (!patternC.test(objToVal.name)) {
                            objToVal.name.errors['name'] = "Single space is only allowed";
                        }
                    };
                }
            } else {
                var _err = {};
                _err['name'] = "name";
                _err['message'] = "Name must be string";
                retVal.push(_err);
                // objToVal.name.errors['name'] = "Name must be string"
            }
        }
        if (!objToVal.email) {
            var _err2 = {};
            // objToVal.errors.email = "Email is reqiured"
            _err2['name'] = "email";
            _err2['message'] = "Email is reqiured";
            retVal.push(_err2);
        } else {
            var n = objToVal.email.length;
            if (n < 5) {
                var _err3 = {};
                _err3['name'] = "email";
                _err3['message'] = "Name doesnt less than 5 chars";
                retVal.push(_err3);
                // objToVal.errors.email = "Name doesnt less than 5 chars"
            } else {
                var _n2 = objToVal.email.split('@');
                if (objToVal.email !== null) {
                    var pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                    var res = pattern.test(objToVal.email);
                    if (!res) {
                        var _err4 = {};
                        _err4['name'] = "email";
                        _err4['message'] = "Enter valid e-mail ID";
                        retVal.push(_err4);
                        // objToVal.errors.email = "Enter valid e-mail ID"
                    }
                }
            }
        }
        if (!objToVal.phone) {
            var _err5 = {};
            _err5['name'] = "phone";
            _err5['message'] = "Phone number is reqiured";
            // objToVal.errors.phone = "Phone number is reqiured"
            retVal.push(_err5);
        } else {
            if (objToVal.phone) {
                var number = objToVal.phone;
                var re = /^[0-9-\s]*$/;
                var _res = number.match(re);
                if (!_res) {
                    var _err6 = {};
                    _err6['name'] = "phone";
                    _err6['message'] = "Invalid phone number";
                    // objToVal.errors.phone = "Invalid phone number"
                    retVal.push(_err6);
                } else {
                    if (number.length < 8 || number.length > 15) {
                        var _err7 = {};
                        _err7['name'] = "phone";
                        _err7['message'] = "Phone number must be between 8 and 15 characters";
                        retVal.push(_err7);
                        // objToVal.errors.phone = "Phone number must be between 8 and 15 characters"
                    } else {
                        var _re = /^[0-9\s]*$/;
                        var _res2 = number.match(_re);
                        var splitCtr = number.split("0");
                        var str = number;
                        if (!_res2) {
                            var _err8 = {};
                            _err8['name'] = "phone";
                            _err8['message'] = "Invalid phone number";
                            retVal.push(_err8);
                            // objToVal.errors.phone = "Invalid phone number"
                        } else {
                            if (splitCtr.length - 1 == str.length) {
                                var _err9 = {};
                                _err9['name'] = "phone";
                                _err9['message'] = "Phone number should not be everything zero";
                                retVal.push(_err9);
                                // objToVal.errors.phone = "Phone number should not be everything zero"
                            }
                        }
                    }
                }
            }
        }
        var mandatory = ['addrLine1', 'city', 'country', 'pincode'];
        _.each(mandatory, function (one) {
            if (!objToVal[one] || objToVal[one] == "") {
                var _err10 = {};
                _err10['name'] = one;
                _err10['message'] = one + " is reqiuired";
                // objToVal.errors[one] = one +" is reqiuired"
                retVal.push(_err10);
            }
        });
        if (objToVal.joined_date) {
            if (objToVal.role == "student") {
                if (!objToVal.joined_date) {
                    var _err11 = {};
                    _err11['name'] = 'joined_date';
                    _err11['message'] = "Please enter join date  (YYYY-MM-DD)";
                    retVal.push(_err11);
                    // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                } else {
                    var dateChek = new Date(objToVal.joined_date);
                    if (dateChek == 'Invalid Date') {
                        var _err12 = {};
                        _err12['name'] = 'joined_date';
                        _err12['message'] = "Please enter join date  (YYYY-MM-DD)";
                        retVal.push(_err12);
                        // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                    }
                    var regEx = /^\d{4}-\d{2}-\d{2}$/;
                    if (objToVal.joined_date.match(regEx) == null) {
                        var _err13 = {};
                        _err13['name'] = 'joined_date';
                        _err13['message'] = "Please enter join date  (YYYY-MM-DD)";
                        retVal.push(_err13);
                        // objToVal.errors['joined_date'] = "Please enter join date  (YYYY-MM-DD)"
                    }
                }
            }
        }
        if (objToVal.birth_date) {
            if (objToVal.role == "student") {
                if (!objToVal.birth_date) {
                    var _err14 = {};
                    _err14['name'] = 'birth_date';
                    _err14['message'] = "Please enter birth date  (YYYY-MM-DD)";
                    retVal.push(_err14);
                    // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                } else {
                    var _dateChek = new Date(objToVal.birth_date);
                    if (_dateChek == 'Invalid Date') {
                        var _err15 = {};
                        _err15['name'] = 'birth_date';
                        _err15['message'] = "Please enter birth date  (YYYY-MM-DD)";
                        retVal.push(_err15);
                        // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                    } else {
                        var d = new Date(objToVal.birth_date);
                        var d1 = new Date();
                        var date1 = d.getFullYear();
                        var age = d1.getFullYear() - d.getFullYear();
                        if (age < 3) {
                            var _err16 = {};
                            _err16['name'] = 'birth_date';
                            _err16['message'] = "Invalid Birth date ";
                            retVal.push(_err16);
                            // objToVal.errors['birth_date'] = "Invalid Birth date "
                        }
                        var regEx = /^\d{4}-\d{2}-\d{2}$/;
                        if (objToVal.birth_date.match(regEx) == null) {
                            var _err17 = {};
                            _err17['name'] = 'birth_date';
                            _err17['message'] = "Please enter birth date  (YYYY-MM-DD)";
                            retVal.push(_err17);
                            // objToVal.errors['birth_date'] = "Please enter birth date  (YYYY-MM-DD)"
                        }
                    }
                }
            }
        }
        if (objToVal.sex) {
            if (objToVal.role == "student") {
                if (!objToVal.sex) {
                    var _err18 = {};
                    _err18['name'] = 'sex';
                    _err18['message'] = "Sex is reqiured";
                    retVal.push(_err18);
                    // objToVal.errors.sex = "Sex is reqiured"
                }
            }
        }
        if (objToVal.relation) {
            if (objToVal.role == "student") {
                if (!objToVal.sex) {
                    var _err19 = {};
                    _err19['name'] = 'relation';
                    _err19['message'] = "Relation is reqiured";
                    retVal.push(_err19);
                    // objToVal.errors.relation = "Relation is reqiured"
                }
            }
        }
        if (objToVal.parent_email) {
            if (objToVal.role == "student") {
                if (objToVal.parent_email) {
                    var _n3 = objToVal.parent_email.split('@');
                    if (objToVal.parent_email !== null) {
                        var _pattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                        var _res3 = _pattern.test(objToVal.parent_email);
                        if (!_res3) {
                            var _err20 = {};
                            _err20['name'] = 'parent_email';
                            _err20['message'] = "Enter valid e-mail ID";
                            retVal.push(_err20);
                        }
                    }
                    // let err = {}
                    // err['name'] = 'parent_email'
                    // err['message'] = "Enter valid e-mail sID"
                    // retVal.push(err)
                    // objToVal.errors.parent_email = "Enter valid e-mail ID"
                }
            }
        }
        if (objToVal.spouse && objToVal.role == "student") {
            var _patternC = /^(^\w+)[a-zA-Z.\s]*$/;
            var _spaceSingle = /^[a-zA-Z]+\s[a-zA-Z]+$/;
            var _n4 = objToVal.spouse.search(' ');
            if (!_patternC.test(objToVal.spouse)) {
                var _err21 = {};
                _err21['name'] = 'spouse';
                _err21['message'] = "Please enter spouse name";
                retVal.push(_err21);
                // objToVal.errors.spouse = "Please enter spouse name"
            }
            if (_n4 !== -1) {
                if (!_patternC.test(objToVal.spouse)) {
                    var _err22 = {};
                    _err22['name'] = 'spouse';
                    _err22['message'] = "Single space is only allowed";
                    retVal.push(_err22);
                    // objToVal.errors.spouse = "Single space is only allowed"
                }
            }
        }
        if (objToVal.use_gafe) {
            if (['Y', 'N', 'y', 'n'].indexOf(objToVal.use_gafe) === -1) {
                var _err23 = {};
                _err23['name'] = 'use_gafe';
                _err23['message'] = "Value is not allowed";
                retVal.push(_err23);
                // objToVal.errors.use_gafe = "Value is not allowed"
            }
        }
        if (objToVal.Password) {
            var gafeValue = objToVal.use_gafe;
            if (gafeValue) {
                if (gafeValue == "y" || gafeValue == "Y") {
                    var pwdValue = objToVal.Password;
                    if (!pwdValue) {
                        var _err24 = {};
                        _err24['name'] = 'Password';
                        _err24['message'] = "Please enter Valid password";
                        retVal.push(_err24);
                        // objToVal.errors.Password = "Please enter Valid password"
                    } else {
                        if (pwdValue.length < 8) {
                            var _err25 = {};
                            _err25['name'] = 'Password';
                            _err25['message'] = "password length should be min 8";
                            retVal.push(_err25);
                            // objToVal.errors.Password = "password length should be min 8"
                        }
                    }
                }
            }
        }
        if (!objToVal.blood_group) {
            var _err26 = {};
            _err26['name'] = 'blood_group';
            _err26['message'] = "Blood group required";
            retVal.push(_err26);
            // objToVal.errors.blood_group = "Blood group required"
        } else {
            var allowedValues = ["O+", "O-", "A+", "A-", "B+", "B-", "AB-", "AB+", "O+ve", "O-ve", "A+ve", "A-ve", "B+ve", "B-ve", "AB-ve", "AB+ve", "A", "B", "0", "AB", "a", "b", "o", "ab", "ab-ve", "ab+ve", "a+", "a-", "a+ve", "a-ve", "ab-", "ab+", "o-", "o-ve", "o+", "o+ve", "b+", "b+ve", "b-", "b-ve", "Ab-", "Ab+"];
            if (allowedValues.indexOf(objToVal.blood_group) === -1) {
                var _err27 = {};
                _err27['name'] = 'blood_group';
                _err27['message'] = "Value is not allowed";
                retVal.push(_err27);
                // objToVal.errors.blood_group = "Value is not allowed"
            }
        }
        if (objToVal.is_employee) {
            if (objToVal.role != "student") {
                var _allowedValues = ["y", "Y", "n", "N"];
                if (!objToVal.is_employee) {
                    var _err28 = {};
                    _err28['name'] = 'is_employee';
                    _err28['message'] = "Employee status required";
                    retVal.push(_err28);
                    // objToVal.errors.blood_group = "Employee status required"
                } else {
                    if (_allowedValues.indexOf(objToVal.is_employee.trim()) == -1) {
                        var _err29 = {};
                        _err29['name'] = 'is_employee';
                        _err29['message'] = "Employee status must be y or n";
                        retVal.push(_err29);
                        // objToVal.errors.blood_group = "Employee status must be y or n"
                    }
                }
            }
        }
        // let pageData = UserValidation.simpleSchema().clean(objToVal);
        // delete pageData.$$hashKey
        // UserValidation.simpleSchema().namedContext("ValidationPersonSchema").validate(pageData, {
        //     modifier: false
        // });
        // let context = UserValidation.simpleSchema().namedContext("ValidationPersonSchema");
        // let ret_val = context.invalidKeys();
        // ret_val = _.map(ret_val, function(res) {
        //     return _.extend({
        //         message: context.keyErrorMessage(res.name)
        //     }, res);
        // });
        return retVal;
    };
    this.uploadFile = function () {
        var file = _this.fileUploadObj.csvUploadFile;
        Papa.parse(file, {
            complete: function complete(results) {
                var data = results ? results.data : [];
                var countQ = data.length - 1;
                if (countQ > 300) {
                    toastr.error("There are more than 300 entries");
                    return false;
                }
                if (data[countQ].length === 1 && data[countQ][0] == '') {
                    data.splice(countQ, 1);
                }
                var headers = [];
                self.questionSet = [];
                _.each(data, function (question, index) {
                    //if (question[0] && question[1]) {
                    var qbObj = {
                        "name": question[0],
                        "email": question[1],
                        "phone": question[2],
                        "addrLine1": question[3],
                        "addrLine2": question[4],
                        "city": question[5],
                        "country": question[6],
                        "pincode": question[7],
                        "use_gafe": question[8],
                        "Password": question[9],
                        "blood_group": question[10]

                    };
                    if ($scope.role == "student") {
                        qbObj.joined_date = question[11];
                        qbObj.birth_date = question[12];
                        qbObj.sex = question[13];
                        qbObj.admission_number = question[14];
                        qbObj.role = $scope.role ? $scope.role : null;
                        qbObj.parent_email = question[15] ? question[15] : null;
                        qbObj.relation = question[16] ? question[16] : null;
                        qbObj.spouse = question[17] ? question[17] : null;
                        // qbObj.father_name = question[18] ? question[18] : null
                        // qbObj.mother_name = question[19] ? question[19] : null
                    } else {
                        qbObj.is_employee = question[11];
                        qbObj.employee_no = question[12];
                    }
                    if (index !== 0) {
                        var ret_val = validateBulk(qbObj);

                        qbObj.errors = {};
                        qbObj.errCount = 0;
                        if (ret_val && ret_val.length > 0) {

                            for (var key = 0; key < ret_val.length; key++) {
                                console.log(ret_val[key]);
                                // qbObj.errCount++
                                qbObj['errors'][ret_val[key].name] = ret_val[key].message;
                            }
                        }
                        self.questionSet.push(qbObj);
                    }
                    if (index === 0) {
                        headers.push(qbObj);
                    }
                    //}
                });
                showBulkEntries(self.questionSet);
            }
        });
    };
    /***********************DropBox**********************************/
    self.selectedsubjs = [];
    var addedSessionsID = [];
    var showSession = [];
    self.showSessionName = [];
    self.showCurriculumName = [];
    self.userArry = {};

    self.getRoleDetails = function (id, name) {
        $scope.roleType = id;
        $scope.csvRole = name;
        $scope.role = id;
    };

    self.getBrowseBtn = function () {
        var content = $scope.getHeader().join(",");
        var filename = $scope.filename + ".csv";
        download(filename, content);
        $scope.showBrowseBtn = true;
    };

    function download(filename, text) {
        var pom = document.createElement('a');
        pom.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(text));
        pom.setAttribute('download', filename);

        if (document.createEvent) {
            var event = document.createEvent('MouseEvents');
            event.initEvent('click', true, true);
            pom.dispatchEvent(event);
        } else {
            pom.click();
        }
    }
    self.getPreviewBtn = function () {
        $scope.showPreviewBtn = true;
    };
    // $scope.settingsData = allData.sett
    // $scope.acConsoles = allData.acConsoles
    // $scope.roleData = allData.roleData
    self.getCuriculum = function (cid, name) {
        $scope.csvSession = name;
        $scope.selectCuriculum = cid;
        $scope.mySession = cid;
        self.showCurriculumName = [];
        var addedCuricullumID = [];
        self.showThisSessions = _.filter($scope.acConsoles, function (one) {
            return one.session_id == cid;
        });
        _.each(self.showThisSessions, function (v) {
            addedCuricullumID.push(v.curriculum_id);
        });
        addedCuricullumID = _.uniq(addedCuricullumID);
        self.showCurriculumName = [];

        _.each(self.allCurriculum[0].list, function (v) {
            _.each(addedCuricullumID, function (k) {
                if (v._id === k) {
                    var item = {
                        _id: v._id,
                        name: v.name
                    };
                    self.showCurriculumName.push(item);
                }
            });
        });
    };

    self.getClass = function (sid, name) {
        $scope.csvCurriculum = name;
        var cid = $scope.selectCuriculum;
        $scope.classIDs = sid;
        $scope.selectClass = sid;
        $scope.myCuriculum = sid;
        var addedClass = [];
        self.showClassName = [];
        self.showThisClass = _.filter($scope.acConsoles, function (one) {
            return one.session_id == cid && one.curriculum_id == sid;
        });
        _.each(self.showThisClass[0].xclass, function (classes) {
            addedClass.push(classes._id);
        });
        addedClass = _.uniq(addedClass);
        _.each(self.allClassess[0].list, function (v) {
            _.each(addedClass, function (k) {
                if (v._id === k) {
                    var item = {
                        _id: v._id,
                        name: v.name
                    };
                    self.showClassName.push(item);
                }
            });
        });
    };
    self.getBatch = function (bid, name) {
        $scope.csvClass = name;
        var s = $scope.selectCuriculum;
        var c = $scope.selectClass;
        $scope.seleBatch = bid;
        $scope.myClass = bid;
        var addedBatchess = [];
        self.showBatchName = [];

        self.showThisBatch = _.find($scope.acConsoles, function (one) {
            return one.session_id == s && one.curriculum_id == c;
        });
        var classDet = _.find(self.showThisBatch.xclass, function (batch) {
            return batch._id === bid;
        });
        _.each(self.allBatchess[0].list, function (v) {
            _.each(classDet.batches, function (k) {
                if (v._id === k) {
                    var item = {
                        _id: v._id,
                        name: v.name
                    };
                    self.showBatchName.push(item);
                }
            });
        });
    };
    self.getCurrentBatch = function (bid, name) {
        $scope.csvBatch = name;
        $scope.selectBatchs = bid;
        $scope.myBatch = bid;
    };

    $scope.getBrowseFileDetails = function (row) {};
    var showBulkEntries = function showBulkEntries(bulkUploadData, themeObj) {
        var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
        $mdDialog.show({
            controller: ['$scope', '$mdDialog', 'bulkUploadData', 'parentScopeObj', 'themeObj', DialogController],
            template: _csvEntries2.default,
            parent: angular.element(document.body),
            locals: {
                bulkUploadData: bulkUploadData,
                parentScopeObj: $scope,
                themeObj: themeObj
            },
            clickOutsideToClose: true,
            fullscreen: true,
            onShowing: function onShowing() {
                $scope.loading = true;
            },
            onComplete: function onComplete() {
                $scope.loading = false;
            }
        }).then(function () {}, function () {
            $scope.status = 'You cancelled the dialog.';
        });
        $scope.$watch(function () {
            return $mdMedia('xs') || $mdMedia('sm');
        }, function (wantsFullScreen) {
            $scope.customFullscreen = wantsFullScreen === true;
        });
    };

    $scope.bulkUpdate = function (themeObj) {
        var eCnt = 0;
        // _.each(self.questionSet, function(question_val, question_key) {
        //     let pageData = UserValidation.simpleSchema().clean(question_val);
        //     delete pageData.$$hashKey
        //     UserValidation.simpleSchema().namedContext("ValidationPersonSchema").validate(pageData, {
        //         modifier: false
        //     });
        //     let context = UserValidation.simpleSchema().namedContext("ValidationPersonSchema");
        //     let ret_val = context.invalidKeys();
        //     ret_val = _.map(ret_val, function(res) {
        //         return _.extend({
        //             message: context.keyErrorMessage(res.name)
        //         }, res);
        //     });
        //     question_val.errors = {}
        //     question_val.errCount = 0
        //     if (ret_val.length > 0) {
        //         for (key in ret_val) {
        //             question_val.errCount++
        //                 eCnt++
        //                 question_val['errors'][ret_val[key].name] = ret_val[key].message
        //         }
        //     }
        // })

        self.userObj = function () {
            var dataArry = {
                "role_id": $scope.role,
                "session_id": $scope.mySession,
                "curriculum_id": $scope.myCuriculum,
                "class_id": $scope.myClass,
                "batch_id": $scope.myBatch
            };
            $scope.loadingSave = true;
            $mdDialog.hide();

            var obj = {
                school_id: localStorageService.get('school_id'),
                userArry: dataArry,
                academicyear: localStorageService.get('academic_year'),
                userSet: self.questionSet
            };
            authService.callAPI("/v0/initial-settings/user-console/users/bulk/upload", "POST", obj, function (response) {
                console.log(response);
                try {
                    if (!response.error) {
                        var result = response.result.data;
                        if (result.limit_over) {
                            toastr.error(" User Limit Over by :" + result.limit);
                        } else if (result.status) {
                            if (result.oks.length === 0) {
                                toastr.error(result.oks.length + " Users Added ");
                            } else {
                                toastr.success(result.oks.length + " Users Added successfully");
                            }
                            $scope.showPreviewBtn = false;
                            $scope.showBrowseBtn = false;
                            $scope.showDownloadBtn = false;
                            $scope.loading = false;
                            self.questionSet = [];
                        } else {
                            var countError = self.questionSet.length - result.oks.length;
                            toastr.success(result.oks.length + " User/s added " + countError + " User/s already exist ");
                            $scope.loading = false;
                        }
                        $scope.loadingSave = false;
                    }
                    self.parentCtrl.getCountFromChild();
                } catch (e) {
                    toastr.error(e);
                    console.log(e);
                }
            });
        };
        if (eCnt === 0) {
            self.userObj();
        }
    };

    $scope.getArray = [{}];

    $scope.getHeader = function () {
        var content = ["Name", "Email", "Phone", "Addr Line1", "Addr Line2", "City", "Country", "Pincode", "Use gafe(Y/N)", "Password", "Blood Group"];
        if ($scope.role == "student") {
            content.push("DOJ");
            content.push("DOB");
            content.push("Sex");
            content.push("Admission Number");
            content.push("Parent Email");
            content.push("Relation");
            content.push("Spouse");
        }
        if ($scope.role != "student") {
            content.push("Is Employee");
            content.push("Emp Id");
        }
        return content;
    };

    $scope.clickFn = function () {};
    $scope.isUser = false;
    $scope.addUser = function () {
        $scope.isUser = $scope.isUser ? false : true;
    };

    $scope.fileHandle = function () {
        if ($scope.role) {
            $scope.showDownloadBtn = true;
            var downloadCSVName = void 0;
            if ($scope.role === 'student') {
                downloadCSVName = $scope.csvRole + '-' + $scope.csvSession + '-' + $scope.csvCurriculum + '-' + $scope.csvClass + '-' + $scope.csvBatch;
            } else {
                downloadCSVName = $scope.csvRole;
            }
            $scope.filename = downloadCSVName;
        } else {
            toastr.success("Please select the role");
        }
    };
};
csvUploadController.$inject = ["$scope", "$stateParams", "$mdMedia", "$mdDialog", "$state", "$timeout", "$q", "$log", "errorValidatorUtil", "localStorageService", "authService"];

var DialogController = function DialogController($scope, $mdDialog, bulkUploadData, parentScopeObj, themeObj) {
    _classCallCheck(this, DialogController);

    $scope.bulkUploadData = bulkUploadData;
    $scope.parentScopeObj = parentScopeObj;
    $scope.hide = function () {
        $mdDialog.hide();
    };
    $scope.cancel = function () {
        $mdDialog.cancel();
    };
    $scope.save = function () {
        parentScopeObj.bulkUpdate(themeObj);
    };
};

var csvUploadCtrl = 'csvUploadCtrl';
exports.default = angular.module(name, ['wizardStatus']).component("userConsole", {
    template: _userConsole2.default,
    transclude: true,
    controllerAs: 'roleManageCtrl',
    controller: ['$scope', '$mdDialog', '$mdToast', '$mdMedia', '$state', '$element', '$attrs', '$compile', '$rootScope', '$timeout', 'localStorageService', 'authService', 'CONSTANTS', UserConsole]
}).component(csvUploadCtrl, {
    template: _csvUpload2.default,
    controllerAs: csvUploadCtrl,
    transclude: true,
    bindings: true,
    require: {
        parentCtrl: '^userConsole'
    },
    controller: ['$scope', '$stateParams', '$mdMedia', '$mdDialog', '$state', '$timeout', '$q', '$log', 'errorValidatorUtil', 'localStorageService', 'authService', csvUploadController]
}).controller('userConsole', UserConsole);


function config($stateProvider) {
    'ngInject';

    $stateProvider.state('userConsole', {
        url: '/userConsole',
        template: '<user-console></user-console>'
    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

module.exports = "<style>.intialstupBox #vertical-container{height:292px;width:100%;max-width:400px}.intialstupBox .repeated-item{border-bottom:1px solid #ddd;box-sizing:border-box;min-height:40px;height:auto;padding-top:10px}.intialstupBox md-content{margin:16px}.intialstupBox .role-list{height:292px;width:100%;max-width:400px;overflow-y:scroll}#rcorners7{border-radius:0;background:#fff;padding:7px;margin:3px;min-height:49px;-moz-box-shadow:0 0 2px 2px #eaeaea;-webkit-box-shadow:0 0 2px 2px#eaeaea;box-shadow:0 0 2px 2px #eaeaea}#rcorners11{border-radius:0;background:#fff;padding:2px;margin:6px;-moz-box-shadow:0 0 2px 2px #eaeaea;-webkit-box-shadow:0 0 2px 2px#eaeaea;box-shadow:0 0 2px 2px #eaeaea}.packList{margin-bottom:0!important;margin-top:10px!important;border:1px solid #e6e6e6;padding:11px 12px 10px 13px!important}.intialstupBox .label-color{color:#1665c1}.table-bordered td,.table-bordered th{border:1px solid #ddd!important;text-align:left}</style> <div class=intialstupBox> <div layout-padding ng-cloak ng-hide=noToolBar class=\"md-whiteframe-2dp bgColor pageInit\" md-theme=makeMeWhite> <wizard-status ng-show=showWizard feature-data=tabStats></wizard-status> <md-content class=\"md-whiteframe-3dp md-makeMeWhite-theme\"> <md-tabs md-dynamic-height md-border-bottom md-stretch-tabs> <md-tab label=\"Role management\"> <md-content style=margin:0> <md-content> <md-button class=md-raised ng-click=roleManageCtrl.showRoleList()>Add Role</md-button> <div layout=row layout-align=\"space-around enableNewRoleDiv\" flex layout-xs=column ng-if=roleManageCtrl.enableRoleList> <div class=md-whiteframe-3dp layout-padding layout=row flex=40> <div flex class=list-role> <div style=margin-top:10px> <md-card-title> <h4>All Roles</h4> <md-divider class=md-makeMeWhite-theme></md-divider> </md-card-title> </div> <div style=min-height:50px layout=column flex as-sortable=sortableCloneOptions1 ng-model=roleManageCtrl.rolesToLoad> <div id=rcorners7 class=\"hand packList\" flex ng-repeat=\"roleName in roleManageCtrl.rolesToLoad\" as-sortable-item> <div as-sortable-item-handle> {{roleName.name}} <i class=\"fa-lg fas fa-arrows-alt\" style=float:right></i> </div> </div> </div> </div> </div> <div class=md-whiteframe-3dp layout-padding layout=row flex=55 layout-sm=column> <div flex> <div style=margin-top:10px> <md-card-title> <h4>Selected Roles</h4> <md-divider class=md-makeMeWhite-theme></md-divider> </md-card-title> </div> <div style=min-height:225px;max-height:300px;overflow-y:scroll flex as-sortable=sortableCloneOptions1 ng-model=roleManageCtrl.selectedCurriculum> <div ng-repeat=\"curRole in roleManageCtrl.selectedCurriculum\" as-sortable-item style=\"padding:7px 0\"> <div as-sortable-item-handle id=rcorners11 class=\"hand packList\" style=\"padding:7px 0\"> <div layout-gt-xs=row class=drbTitle> <span flex=95>{{curRole.name}}</span> <span flex=5> <i class=\"fa-lg fas fa-arrows-alt\" style=float:right></i> </span> </div> </div> </div> </div> <md-divider></md-divider> <div layout-gt-xs=row style=margin-top:30px> <md-button class=\"md-raised md-primary md-hue-2\" ng-click=roleManageCtrl.addRoleEnable(curRole)>Add New Role</md-button> </div> <div layout-gt-xs=row class=newSubject ng-if=roleManageCtrl.enableNewRoleDiv> <md-input-container class=md-block flex-gt-sm> <label>New Role</label> <input ng-model=roleManageCtrl.newRoles md-maxlength=35 txt-maxlength=35> </md-input-container> <md-button class=\"md-raised md-primary\" ng-if=roleManageCtrl.enableNewRoleBtn ng-click=roleManageCtrl.addNewRole() style=height:20px;margin-top:32px>Add</md-button> </div> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=roleManageCtrl.addRole() style=padding:0>Save</md-button> </div> </div> </div> <div flex=100 layout=row layout-xs=column layout-align-xs=space-between style=margin-top:24px class=\"md-whiteframe-3dp layout-padding\" layout-wrap> <div ng-repeat=\"role in roleManageCtrl.selectedRoles\" class=box> {{role.name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <i ng-click=roleManageCtrl.deleteRole(role._id) title=\"click to remove\" ng-if=\"role.name!='Admin'\" class=\"far fa-trash-alt\"></i> </div> </div> </md-content> </md-content> </md-tab> <md-tab label=\"User management\"> <md-content class=md-padding> <csv-upload-ctrl></csv-upload-ctrl> <p class=\"md-body-1 bold\" flex>User Statistics</p> <table id=table class=\"table table-bordered table-mc-light-blue User Statistics md-whiteframe-3dp\"> <thead> <tr> <th class=bold>Role</th> <th class=bold>Count</th> </tr> </thead> <tbody> <tr ng-repeat=\"(name, count) in allRoleCounts\" md-on-demand> <td data-title=Role> {{name}} <table ng-if=\"name=='Student'\" id=table class=\"table table-bordered table-mc-light-blue\"> <thead> <tr> <th class=bold>Batch Details</th> <th class=bold>Count</th> </tr> </thead> <tbody> <tr ng-repeat=\"item in detailedcount\"> <td data-title=Role> {{item.curr_class}}</td> <td data-title=Count>{{item.numberOfStudents}}</td> </tr> </tbody> </table> </td> <td data-title=Count>{{count}}</td> </tr> </tbody> </table> </md-content> </md-tab> <md-tab label=\"Head of the Institution\"> <md-content class=\"md-padding md-whiteframe-2dp\"> <div layout=row ng-show=!isReportingObj> <div flex=50> <div class=header layout=row layout-align=\"center center\"> Roles </div> <div layout=row layout-xs=column layout-align-xs=space-between class=\"layout-padding role-list\" layout-wrap> <md-radio-group ng-model=headRole> <md-radio-button ng-click=roleManageCtrl.loadMangerUsers(role) ng-repeat=\"role in roleManageCtrl.selectedRoles\" ng-value=role._id>{{role.name}}</md-radio-button> </md-radio-group> </div> </div> <div class=right-border layout=column flex=50> <div class=header layout=row layout-align=\"center center\">Users </div> <md-radio-group ng-model=userdata> <md-virtual-repeat-container id=vertical-container> <div layout=row ng-class=\"item==selectedManagerUser?'selected-sub':''\" md-virtual-repeat=\"item in managerUsers\" md-on-demand class=repeated-item flex> <span flex=80> <md-radio-button ng-value=item._id>{{item.name}}</md-radio-button> </span> </div> </md-virtual-repeat-container> </md-radio-group> </div> </div> <div ng-show=isReportingObj layout=column> <div> <label class=label-color>Head Role :</label><span> {{reportingObj.parent_name}}</span></div> <div><label class=label-color>Head User :</label><span> {{reportingObj.user_name}}</span></div> <div layout=row layout-align=\"end end\"> <i ng-click=roleManageCtrl.deleteReportingRole(role._id) title=\"click to remove\" class=\"far fa-trash-alt\"></i> </div> </div> <div layout=row layout-align=\"end end\" ng-if=!isReportingObj> <md-button class=\"md-raised md-primary md-hue-2\" ng-click=roleManageCtrl.saveHeadRole()>{{btnLabel}}</md-button> </div> </md-content> </md-tab> </md-tabs> </md-content> <md-button class=\"md-raised md-primary md-hue-2\" ng-click=roleManageCtrl.goNext() style=padding:0>{{btnLabel}}</md-button> </div> </div> ";

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

module.exports = "<div layout=row layout-xs=column md-whiteframe=1 layout-wrap layout-padding class=littleWhiteFrameNoBorder ng-cloak> <div layout-gt-sm=row layout-sm flex=100> <md-button class=md-raised ng-click=addUser()>Add User</md-button> </div> <div layout-gt-sm=row flex=100 layout-sm ng-if=isUser> <md-input-container flex> <md-select ng-model=role placeholder=\"Select Role\"> <md-option value={{roleName._id}} ng-click=csvUploadCtrl.getRoleDetails(roleName._id,roleName.name) ng-repeat=\"roleName in csvUploadCtrl.allRoles\">{{roleName.name}}</md-option> </md-select> </md-input-container> <div flex=5 hide-xs hide-sm> </div> <md-input-container flex ng-if=\"role === 'student'\"> <label>Select Session</label> <md-select ng-model=sessions> <md-option value={{sesName._id}} ng-click=csvUploadCtrl.getCuriculum(sesName._id,sesName.name) ng-repeat=\"sesName in csvUploadCtrl.showSessionName\">{{sesName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"role === 'student'\"> <label>Select Curriculum</label> <md-select ng-model=curriculum> <md-option value={{curName._id}} ng-click=csvUploadCtrl.getClass(curName._id,curName.name) ng-repeat=\"curName in csvUploadCtrl.showCurriculumName\">{{curName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"role === 'student'\"> <label>Select Class</label> <md-select ng-model=classes> <md-option value={{clsName._id}} ng-click=csvUploadCtrl.getBatch(clsName._id,clsName.name) ng-repeat=\"clsName in csvUploadCtrl.showClassName\"> {{clsName.name}}</md-option> </md-select> </md-input-container> <md-input-container flex ng-if=\"role === 'student'\"> <label>Select Batch</label> <md-select ng-model=batch> <md-option value={{batch._id}} ng-click=csvUploadCtrl.getCurrentBatch(batch._id,batch.name) ng-repeat=\"batch in csvUploadCtrl.showBatchName\"> {{batch.name}}</md-option> </md-select> </md-input-container> <md-input-container flex> <md-button class=\"md-raised md-primary md-hue-2\" ng-click=fileHandle()>Submit</md-button> </md-input-container> </div> <div layout-gt-sm=row layout-sm layout-align=\"space-around center\" layout=row> <div> <md-input-container class=md-block flex-gt-sm flex-sm layout-padding ng-if=showDownloadBtn> <md-button class=\"md-raised md-primary md-hue-1\" ng-click=csvUploadCtrl.getBrowseBtn()> Download CSV </md-button> </md-input-container> </div> <div> <md-input-container class=md-block flex-gt-sm flex-sm layout-padding ng-if=showBrowseBtn> <md-button class=\"md-raised md-primary md-hue-1\" ngf-select ng-model=csvUploadCtrl.fileUploadObj.csvUploadFile ngf-pattern=\"'*.csv'\" accept=application/csv ng-click=csvUploadCtrl.getPreviewBtn()>Browse</md-button> </md-input-container> </div> <div ng-if=csvUploadCtrl.fileUploadObj.csvUploadFile> <md-input-container class=\"md-block margin_right\" flex-gt-sm flex-sm layout-padding ng-if=showPreviewBtn> <md-button flex-offset=5 class=\"md-primary md-hue-1 md-raised\" ng-click=csvUploadCtrl.uploadFile()>Preview/Upload</md-button> </md-input-container> <div style=z-index:99;position:absolute;top:20%;left:45% layout=column ng-if=loading> <md-progress-circular md-diameter=96 md-mode=indeterminate class=md-accent></md-progress-circular><span style=color:#fff>Please wait...</span> </div> </div> </div> </div> ";

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

module.exports = "<span class=upload-1> <md-dialog class=bulkDialog layout=column flex aria-label=\"CSV Upload\" ng-cloak> <form> <md-toolbar> <div class=md-toolbar-tools> <h2>Import details of {{parentScopeObj.csvRole}}</h2> <span flex></span> <i ng-click=cancel() class=\"fas fa-times\"></i> </div> </md-toolbar> <md-dialog-content layout-padding> <md-content md-theme=makeMeWhite class=\"md-whiteframe-2dp dialogCont\"> <div ng-if=\"bulkUploadData.length>1\" layout=row layout-align=\"end end\" style=font-weight:600>Scroll Down to view more</div> <div class=table-responsive-vertical> <table id=table class=\"table bulkTable table-hover table-mc-light-blue\"> <thead> <tr> <th class=\"md-body-1 bold\">Name</th> <th class=\"md-body-1 bold\">Email</th> <th class=\"md-body-1 bold\">Phone</th> <th class=\"md-body-1 bold\">Addr Line1</th> <th class=\"md-body-1 bold\">Addr LIne2</th> <th class=\"md-body-1 bold\">City</th> <th class=\"md-body-1 bold\">Country</th> <th class=\"md-body-1 bold\">Pincode</th> <th class=\"md-body-1 bold\">Gafe(y/N)</th> <th class=\"md-body-1 bold\">Password</th> <th class=\"md-body-1 bold\">Blood Group</th> <th ng-if=\"parentScopeObj.role!='student'\" class=\"md-body-1 bold\">Is Employee</th> <th ng-if=\"parentScopeObj.role!='student'\" class=\"md-body-1 bold\">Emp Id</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">DOJ</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">DOB</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">Sex</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">Admission Number</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">Parent Email</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">Relation</th> <th ng-if=\"parentScopeObj.role=='student'\" class=\"md-body-1 bold\">Spouse</th> </tr> </thead> <tbody class=tbody> <tr ng-repeat=\"data in bulkUploadData | orderBy:'-errCount'\" ng-class=\"data.errCount>0? 'highlightRed': ''\"> <td class=md-body-1 data-title=Name> <div layout=column> <textarea class=md-body-1 ng-model=data.name></textarea> <p class=redAlert>{{data.errors.name}}</p> </div> </td> <td class=md-body-1 data-title=Email> <div layout=column> <textarea class=md-body-1 ng-model=data.email></textarea> <p class=redAlert>{{data.errors.email}}</p> </div> </td> <td class=md-body-1 data-title=Phone> <div layout=column> <input class=md-body-1 ng-model=data.phone> <p class=redAlert>{{data.errors.phone}}</p> <p class=redAlert>{{data.phonePattern}}</p> </div> </td> <td class=md-body-1 data-title=\"Addr Line1\"> <div layout=column> <textarea class=md-body-1 ng-model=data.addrLine1></textarea> <p class=redAlert>{{data.errors.addrLine1}}</p> </div> </td> <td class=md-body-1 data-title=\"Addr Line2\"> <div layout=column> <input class=md-body-1 ng-model=data.addrLine2> <p class=redAlert>{{data.errors.addrLine2}}</p> </div> </td> <td class=md-body-1 data-title=City> <div layout=column> <input class=md-body-1 ng-model=data.city> <p class=redAlert>{{data.errors.city}}</p> </div> </td> <td class=md-body-1 data-title=Country> <div layout=column> <input class=md-body-1 ng-model=data.country> <p class=redAlert>{{data.errors.country}}</p> </div> </td> <td class=md-body-1 data-title=Pincode> <div layout=column> <input class=md-body-1 ng-model=data.pincode> <p class=redAlert>{{data.errors.pincode}}</p> </div> </td> <td class=md-body-1 data-title=use_gafe> <div layout=column> <input class=md-body-1 ng-model=data.use_gafe> <p class=redAlert>{{data.errors.use_gafe}}</p> </div> </td> <td class=md-body-1 data-title=Password> <div layout=column> <input class=md-body-1 ng-model=data.Password> <p class=redAlert>{{data.errors.Password}}</p> </div> </td> <td class=md-body-1 data-title=blood_group> <div layout=column> <input class=md-body-1 ng-model=data.blood_group> <p class=redAlert>{{data.errors.blood_group}}</p> </div> </td> <td ng-if=\"parentScopeObj.role!='student'\" class=md-body-1 data-title=is_employee> <div layout=column> <input class=md-body-1 ng-model=data.is_employee> <p class=redAlert>{{data.errors.is_employee}}</p> </div> </td> <td ng-if=\"parentScopeObj.role!='student'\" class=md-body-1 data-title=employee_no> <div layout=column> <input class=md-body-1 ng-model=data.employee_no> <p class=redAlert>{{data.errors.employee_no}}</p> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=DOJ> <div layout=column> <input class=md-body-1 ng-model=data.joined_date> <p class=redAlert>{{data.errors.joined_date}}</p> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=DOB> <div layout=column> <input class=md-body-1 ng-model=data.birth_date> <p class=redAlert>{{data.errors.birth_date}}</p> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=Sex> <div layout=column> <md-input-container flex class=p-c-relation> <md-select ng-model=data.sex> <md-option value=Male>Male</md-option> <md-option value=Female>Female</md-option> <md-option value=Other>Other</md-option> </md-select> <p class=redAlert>{{data.errors.sex}}</p> </md-input-container> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=\"Admission Number\"> <div layout=column> <input class=md-body-1 ng-model=data.admission_number> <p class=redAlert>{{data.errors.admission_number}}</p> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=\"Parent email\"> <div layout=column> <input class=md-body-1 ng-model=data.parent_email> <p class=redAlert>{{data.errors.parent_email}}</p> </div> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=Relation> <md-input-container flex class=p-c-relation> <md-select ng-model=data.relation> <md-option value=FATHER>FATHER</md-option> <md-option value=MOTHER>MOTHER</md-option> </md-select> <p class=redAlert>{{data.errors.relation}}</p> </md-input-container> </td> <td ng-if=\"parentScopeObj.role=='student'\" class=md-body-1 data-title=Spouse> <input class=md-body-1 ng-model=data.spouse> <p class=redAlert>{{data.errors.spouse}}</p> </td> </tr> </tbody> </table> </div> <div layout=row> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=save() ng-disabled=loadingSave>Save</md-button> <md-button class=\"md-primary md-raised md-button md-ink-ripple\" ng-click=cancel() ng-disabled=loadingSave>Cancel</md-button> <div ng-if=loadingSave> <md-progress-circular md-diameter=96 md-mode=indeterminate class=md-accent></md-progress-circular><span>Please wait...</span> </div> </div> </md-content> </md-dialog-content> </form> </md-dialog> </span> ";

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1409 */,
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _clubPost = __webpack_require__(142);

var _clubPost2 = _interopRequireDefault(_clubPost);

var _clubpostController = __webpack_require__(390);

var _clubpostController2 = _interopRequireDefault(_clubpostController);

__webpack_require__(1411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('clubPost', [
  //import modules
]).controller('clubPost', _clubpostController2.default); /**
                                                          * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
                                                          * Project: /home/cordova03/projects/educore_3.5
                                                          * Created Date: Monday, December 10th 2018, 5:44:10 pm
                                                          * Author: Naveen Nazimudeen N
                                                          * -----
                                                          * Last Modified: Wed Dec 12 2018
                                                          * Modified By: Naveen Nazimudeen N
                                                          * -----
                                                          * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                          * ------------------------------------
                                                          */


_module.constant('clubPost', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('clubPost', {
//             parent: 'app',
//             url: '/club-post',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'clubPost'
//                 }
//             }
//         })

// });

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClub = __webpack_require__(143);

var _createClub2 = _interopRequireDefault(_createClub);

var _createclubController = __webpack_require__(393);

var _createclubController2 = _interopRequireDefault(_createclubController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/published_reports/publishedReportModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 5:44:10 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Wed Dec 12 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */

var _module = angular.module('createClub', [
  //import modules
]).controller('createClub', _createclubController2.default);

_module.constant('createClub', {});
// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('createClub', {
//             parent: 'app',
//             url: '/create-club',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'createClub'
//                 }
//             },
//             params: {
//                 "user_privilege": null,
//                 "club_id": null,
//                 "mode": null
//             }
//         })

// });

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _curriculumSetupView = __webpack_require__(145);

var _curriculumSetupView2 = _interopRequireDefault(_curriculumSetupView);

var _curriculumSetupController = __webpack_require__(395);

var _curriculumSetupController2 = _interopRequireDefault(_curriculumSetupController);

__webpack_require__(1414);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('CurriculumSetupModule', [_angularUiRouter2.default
//import modules
]).controller('curriculumSetup', _curriculumSetupController2.default); /**
                                                                        * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
                                                                        * Project: /home/cordova03/projects/educore_3.5
                                                                        * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
                                                                        * Author: Naveen Nazimudeen N
                                                                        * -----
                                                                        * Last Modified: Tue Dec 18 2018
                                                                        * Modified By: Naveen Nazimudeen N
                                                                        * -----
                                                                        * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                        * ------------------------------------
                                                                        */

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _subjectSetup = __webpack_require__(146);

var _subjectSetup2 = _interopRequireDefault(_subjectSetup);

var _subjectSetupController = __webpack_require__(396);

var _subjectSetupController2 = _interopRequireDefault(_subjectSetupController);

__webpack_require__(1416);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('SubjectSetupModule', [_angularUiRouter2.default
//import modules
]).controller('subjectSetup', _subjectSetupController2.default); /**
                                                                  * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
                                                                  * Project: /home/cordova03/projects/educore_3.5
                                                                  * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
                                                                  * Author: Naveen Nazimudeen N
                                                                  * -----
                                                                  * Last Modified: Tue Dec 18 2018
                                                                  * Modified By: Naveen Nazimudeen N
                                                                  * -----
                                                                  * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                  * ------------------------------------
                                                                  */

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _sessionSetup = __webpack_require__(147);

var _sessionSetup2 = _interopRequireDefault(_sessionSetup);

var _sessionSetupController = __webpack_require__(397);

var _sessionSetupController2 = _interopRequireDefault(_sessionSetupController);

__webpack_require__(1418);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('SessionSetupModule', [_angularUiRouter2.default
//import modules
]).controller('sessionSetup', _sessionSetupController2.default); /**
                                                                  * File: /home/cordova03/projects/educore_3.5/src/app/utilities/utilitiesModule.js
                                                                  * Project: /home/cordova03/projects/educore_3.5
                                                                  * Created Date: Wednesday, December 5th 2018, 3:09:34 pm
                                                                  * Author: Naveen Nazimudeen N
                                                                  * -----
                                                                  * Last Modified: Tue Dec 18 2018
                                                                  * Modified By: Naveen Nazimudeen N
                                                                  * -----
                                                                  * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
                                                                  * ------------------------------------
                                                                  */

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angularUiRouter = __webpack_require__(15);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _createImmunizationForm = __webpack_require__(420);

var _createImmunizationForm2 = _interopRequireDefault(_createImmunizationForm);

var _medicalFeatureList = __webpack_require__(421);

var _medicalFeatureList2 = _interopRequireDefault(_medicalFeatureList);

var _incidents = __webpack_require__(422);

var _incidents2 = _interopRequireDefault(_incidents);

var _createFirstAidForm = __webpack_require__(423);

var _createFirstAidForm2 = _interopRequireDefault(_createFirstAidForm);

var _createReferralForm = __webpack_require__(424);

var _createReferralForm2 = _interopRequireDefault(_createReferralForm);

var _createVaccinationForm = __webpack_require__(425);

var _createVaccinationForm2 = _interopRequireDefault(_createVaccinationForm);

var _inventory = __webpack_require__(426);

var _inventory2 = _interopRequireDefault(_inventory);

var _inventoryList = __webpack_require__(427);

var _inventoryList2 = _interopRequireDefault(_inventoryList);

var _purchaseOrder = __webpack_require__(428);

var _purchaseOrder2 = _interopRequireDefault(_purchaseOrder);

var _purchaseList = __webpack_require__(429);

var _purchaseList2 = _interopRequireDefault(_purchaseList);

var _stockDetails = __webpack_require__(430);

var _stockDetails2 = _interopRequireDefault(_stockDetails);

var _userProfile = __webpack_require__(431);

var _userProfile2 = _interopRequireDefault(_userProfile);

var _userFilter = __webpack_require__(432);

var _userFilter2 = _interopRequireDefault(_userFilter);

var _myMedicalProfile = __webpack_require__(433);

var _myMedicalProfile2 = _interopRequireDefault(_myMedicalProfile);

var _createProgramme = __webpack_require__(434);

var _createProgramme2 = _interopRequireDefault(_createProgramme);

var _viewProgramme = __webpack_require__(435);

var _viewProgramme2 = _interopRequireDefault(_viewProgramme);

var _programmeConsole = __webpack_require__(436);

var _programmeConsole2 = _interopRequireDefault(_programmeConsole);

var _underscore = __webpack_require__(18);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = angular.module('MedicalModule', ['ui.router'
//import modules
]).controller('createFormCtrl', _createImmunizationForm2.default).controller('featureListCtrl', _medicalFeatureList2.default).controller('incidentsCtrl', _incidents2.default).controller('firstAidCtrl', _createFirstAidForm2.default).controller('referralCtrl', _createReferralForm2.default).controller('vaccinationCtrl', _createVaccinationForm2.default).controller('inventoryCtrl', _inventory2.default).controller('inventoryListCtrl', _inventoryList2.default).controller('purchaseOrderCtrl', _purchaseOrder2.default).controller('purchaseListCtrl', _purchaseList2.default).controller('stockDetailsCtrl', _stockDetails2.default).controller('userProfileCtrl', _userProfile2.default).controller('userFilterCtrl', _userFilter2.default).controller('medicalProfileCtrl', _myMedicalProfile2.default).controller('createProgrammeCtrl', _createProgramme2.default).controller('viewProgrammeCtrl', _viewProgramme2.default).controller('programmeConsoleCtrl', _programmeConsole2.default);

_module.constant('MEDICALCONSTANT', {
    API_CREATE_QUESTION: "/v0/medical/immunization/create",
    API_GET_QUESTION: "/v0/medical/immunization/get-question/",
    API_UPDATE_QUESTION: "/v0/medical/immunization/edit",
    API_DELETE_QUESTION: "/v0/medical/immunization/delete/",
    API_SAVE_PURCHASE_ORDER: "/v0/medical/purchase-order/save",
    API_GET_PURCHASE_ORDER: "/v0/medical/purchase-order/list",
    API_UPDATE_PURCHASE_ORDER: "/v0/medical/purchase-order/edit",
    API_GET_INVENTORY_LIST: "/v0/medical/get-inventory",
    API_GET_DELIVERED_DETAILS: "/v0/medical/get-purchase/delivered/",
    API_SAVE_MEDICINE_DETAILS: "/v0/medical/inventory/save",
    API_GET_INVENTORY_PDF: "/v0/medical/inventory/pdf",
    API_GET_SCHOOL_DETAILS: "/v0/teachingPlan/school-details/",
    API_POST_GET_ALL_USERS: "/v0/endorsement/get_all_users",
    API_GET_MEDICAL_PROFILE: "/v0/medical/profile",
    API_GET_MEDICINE_LIST: "/v0/medical/get-medicine-details/",
    API_SAVE_FIRST_AID: "/v0/medical/first-aid/save",
    API_SAVE_REFERRAL_FORM: "/v0/medical/referral-form/save",
    API_GET_VACCINATION_LIST: "/v0/medical/get-vaccine-details/",
    API_SAVE_VACCINATION_DETAILS: "/v0/medical/vaccination/save",
    API_GET_IMMUNIZATION_FORM: "/v0/medical/immunization/get-question",
    API_SEND_IMMUNIZATION_FORM: "/v0/medical/immunization/send-multiple-users",
    API_GET_USER_IMM_FORM: "/v0/medical/immunization/get-reply",
    API_SAVE_USER_REPLY: "/v0/medical/immunization/send-user-reply",
    API_SAVE_PROGRAMME: "/v0/medical/programme/save",
    API_GET_CREATED_PROGRAMME: "/v0/medical/programme/created-list",
    API_GET_CURRENT_DATE: "/v0/server/now",
    API_PUBLISH_PROGRAMME: "/v0/medical/programme/publish/",
    API_GET_ASSIGNED_PROGRAMME: "/v0/medical/programme/list",
    API_ADD_COMMENT: "/v0/medical/programme/add-comment",
    API_ADD_REPORT: "/v0/medical/programme/submit-report"
});

_module.config(["$stateProvider", "$locationProvider", function ($stateProvider, $locationProvider) {
    "ngInject";
}]);

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _commonChart = __webpack_require__(1421);

var _commonChart2 = _interopRequireDefault(_commonChart);

var _commonChartController = __webpack_require__(1422);

var _commonChartController2 = _interopRequireDefault(_commonChartController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('commonChart', []).component('commonChart', {
    template: _commonChart2.default,
    transclude: true,
    bindings: {
        graphData: '<',
        showGraph: '<',
        graphWidth: '<',
        graphHeight: '<',
        chartType: '<',
        title: '<',
        subTitle: '<',
        axis: '<',
        header: '<',
        totalCount: '<',
        count: '<',
        colors: '<',
        names: '<',
        setLocalImage: '&setimage'
    },
    scope: {
        setLocalImage: '&setimage'
    },
    controller: _commonChartController2.default
}).constant('COMMON_CHART_CONSTANTS', {
    DEFAULT_GRAPH_COLORS: ['#3366CC', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#329262', '#5574A6', '#3B3EAC']
});

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

module.exports = "<style>div .google-visualization-tooltip>ul>li>span{white-space:nowrap}</style> <div id=commonchart flex layout=row layout-align=\"start center\" layout-wrap style=overflow-x:auto></div>";

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progressLoader = __webpack_require__(462);

var _progressLoader2 = _interopRequireDefault(_progressLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
// Chart loader Component


var CommonChart = function CommonChart($scope, $mdMedia, $mdDialog, COMMON_CHART_CONSTANTS) {
  'ngInject';

  _classCallCheck(this, CommonChart);

  $scope.isLoadCompleted = true;
  $scope.dialogObj = undefined;

  $scope.getRandomString = function () {
    var letters = '0123456789ABCDEF';
    var chartId = 'id';
    for (var i = 0; i < 6; i++) {
      chartId += letters[Math.floor(Math.random() * 16)];
    }
    return chartId;
  };

  $scope.loadChartId = function () {
    return $scope.chart_id = $scope.getRandomString();
  };

  this.$onInit = function () {
    var graphHeight = this.graphHeight;
    var graphWidth = this.graphWidth;
    var graphType = this.chartType;
    var title = this.header;
    var subTitle = this.subTitle;
    var axis = this.axis;
    $scope.graphdata = this.graphData;
    var totlaItems = this.totalCount;
    var currentItem = this.count;
    var colors = this.colors;
    var names = this.names;
    var scopeObj = this;
    $scope.imageTags = [];

    if (currentItem === 0 && totlaItems > 0) {
      var msg = "Chart is loading, Please Wait for a while";
      var useFullScreen = $mdMedia('sm') || $mdMedia('xs');
      $scope.infoMsg = msg;
      $scope.dialogObj = $mdDialog.show({
        template: _progressLoader2.default,
        clickOutsideToClose: false,
        fullscreen: useFullScreen,
        scope: $scope,
        preserveScope: true
      }).then(function (response) {}, function (response) {});
    } else if (totlaItems == currentItem) {
      $mdDialog.cancel();
    }
    if ($scope.graphdata === undefined) return false;
    if (this.chartType === 'Pie' || this.chartType === 'Donut') {
      google.charts.load('current', {
        'packages': ['corechart']
      });
    } else if (this.chartType === 'table') {
      google.charts.load('current', {
        'packages': ['table']
      });
    } else if (this.chartType === 'Histogram' || this.chartType === 'Line' || this.chartType === 'Bar') {
      google.charts.load('current', {
        'packages': ['corechart', 'bar']
      });
    }

    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {
      var dynamicID = $scope.getRandomString();
      var chartdata = undefined;
      chartdata = google.visualization.arrayToDataTable($scope.graphdata);
      var chartHtml = ' </div> <div class="md-whiteframe-3dp" flex id="' + dynamicID + '" flex style="width:' + graphWidth + 'px; height:' + graphHeight + 'px;margin:8px;"></div>';
      var newEle = angular.element(chartHtml);
      var target = document.getElementById('commonchart');
      angular.element(target).append(newEle);
      var options = {
        /*chart: {
          title: 'Company Performance'
        },*/
        title: title,
        bars: 'vertical',
        legend: 'none',
        width: '100%',
        height: '100%',
        chartArea: {
          width: '80%'
        },
        tooltip: {
          isHtml: true,
          textStyle: {
            color: '#0000ff',
            bold: false
          },
          showColorCode: true
        }
      };
      if (graphType === 'Pie') {
        var optionsPie = {
          /*chart: {
            title: 'Company Performance'
          },*/
          width: '50%',
          height: '50%',
          title: title ? title : subTitle ? subTitle : undefined,
          bars: 'vertical',
          chartArea: {
            width: '60%'
          },
          is3D: true,
          /*legend: 'none',*/
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          },
          sliceVisibilityThreshold: 0,
          colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
        };
        var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
        //Generating Click event to download PDF
        google.visualization.events.addListener(chart, 'ready', function () {
          var content = '<img src="' + chart.getImageURI() + '">';
          $('#graph-images').append(content);

          if ($scope.imageTags.length === 0) {
            $scope.imageTags.push({
              '_id': dynamicID,
              'image': chart.getImageURI(),
              'width': chart.container.clientWidth,
              'height': chart.container.clientHeight,
              'title': title ? title : subTitle,
              "type": graphType
            });
            scopeObj.setLocalImage({ data: $scope.imageTags });
          } else {
            var isExist = _.find($scope.imageTags, function (img) {
              return img._id == dynamicID;
            });
            if (isExist == undefined) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              });
            }
          }
        });
        if (currentItem != totlaItems) {
          optionsPie['width'] = graphWidth;
          chart.draw(chartdata, optionsPie);
        } else {
          optionsPie['width'] = graphWidth;
          chart.draw(chartdata, optionsPie);
          window.dispatchEvent(new Event('resize'));
          window.addEventListener('resize', function (e) {
            optionsPie['width'] = graphWidth;
            chart.draw(chartdata, optionsPie);
          });
        }
      } else if (graphType === 'Bar') {
        var axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : [];
        var optionsBar = {
          title: title ? title : subTitle ? subTitle : undefined,
          hAxis: {
            title: axisTitle[0] ? axisTitle[0] : undefined,
            titleTextStyle: {
              color: 'black',
              bold: true,
              italic: false
            },
            textStyle: {
              fontSize: names ? 13 : 16
            }
          },
          vAxis: {
            title: axisTitle[1] ? axisTitle[1].replace(/\(.*\)/, '') : undefined,
            titleTextStyle: {
              color: 'black',
              bold: true,
              italic: false
            }
          },
          /*bar: {
            groupWidth: 20
          },*/
          /*legend: 'none',*/
          legend: { position: 'top', alignment: 'start' },
          width: '100%',
          height: '100%',
          chartArea: {
            top: 50,
            width: '70%'
          },
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          },
          animation: {
            duration: 1000,
            easing: 'out'
          },
          bars: 'vertical',
          axes: {
            y: {
              all: {
                range: {
                  min: 0.010
                }
              }
            }
          },
          colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
        };
        var chart = new google.visualization.ColumnChart(document.getElementById(dynamicID));
        //Generating Click event to download PDF
        google.visualization.events.addListener(chart, 'ready', function () {
          var content = '<img src="' + chart.getImageURI() + '">';
          $('#graph-images').append(content);

          if ($scope.imageTags.length === 0) {
            $scope.imageTags.push({
              '_id': dynamicID,
              'image': chart.getImageURI(),
              'width': chart.container.clientWidth,
              'height': chart.container.clientHeight,
              'title': title ? title : subTitle,
              "type": graphType
            });
            scopeObj.setLocalImage({ data: $scope.imageTags });
          } else {
            var isExist = _.find($scope.imageTags, function (img) {
              return img._id == dynamicID;
            });
            if (isExist == undefined) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              });
            }
          }
        });
        if (currentItem != totlaItems) {
          optionsBar['width'] = graphWidth;
          chart.draw(chartdata, optionsBar);
        } else {
          optionsBar['width'] = graphWidth;
          chart.draw(chartdata, optionsBar);
          window.dispatchEvent(new Event('resize'));
          window.addEventListener('resize', function (e) {
            if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
              optionsBar['width'] = graphWidth;
            }
            chart.draw(chartdata, optionsBar);
          });
        }
      } else if (graphType === 'table') {
        var chart = new google.visualization.Table(document.getElementById(dynamicID));
        chart.draw(chartdata, {
          showRowNumber: true,
          width: '100%',
          height: '100%',
          title: title
        });
      } else if (graphType === 'Histogram') {
        var optionsHist = {
          title: title,
          width: '100%',
          height: '100%',
          chartArea: {
            width: '80%'
          },
          hAxis: {
            minValue: 0
          },
          vAxis: {},
          legend: 'none',
          bar: {
            groupWidth: '10'
          },
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          }
        };
        var chart = new google.visualization.Histogram(document.getElementById(dynamicID));
        if (currentItem != totlaItems) {
          optionsHist['width'] = graphWidth;
          chart.draw(chartdata, optionsHist);
        } else {
          optionsHist['width'] = graphWidth;
          chart.draw(chartdata, optionsHist);
          window.dispatchEvent(new Event('resize'));
          window.addEventListener('resize', function (e) {
            if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
              optionsHist['width'] = graphWidth;
            }
            chart.draw(chartdata, optionsHist);
          });
        }
      } else if (graphType === 'Line') {
        var _axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : [];
        var optionsLine = {
          title: title ? title : subTitle ? subTitle : undefined,
          hAxis: {
            minValue: 0,
            title: _axisTitle[0] ? _axisTitle[0] : undefined,
            titleTextStyle: {
              color: 'black',
              bold: true,
              italic: false
            }
          },
          vAxis: {
            title: _axisTitle[1] ? _axisTitle[1].replace(/\(.*\)/, '') : undefined,
            titleTextStyle: {
              color: 'black',
              bold: true,
              italic: false
            }
          },
          width: '100%',
          height: '100%',
          chartArea: {
            width: '70%'
          },
          /*legend: 'none',*/
          legend: { position: 'top', alignment: 'start' },
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          },
          colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
        };
        var chart = new google.visualization.LineChart(document.getElementById(dynamicID));
        //Generating Click event to download PDF
        google.visualization.events.addListener(chart, 'ready', function () {
          var content = '<img src="' + chart.getImageURI() + '">';
          $('#graph-images').append(content);
          if ($scope.imageTags.length === 0) {
            $scope.imageTags.push({
              '_id': dynamicID,
              'image': chart.getImageURI(),
              'width': chart.container.clientWidth,
              'height': chart.container.clientHeight,
              'title': title ? title : subTitle,
              "type": graphType
            });
            scopeObj.setLocalImage({ data: $scope.imageTags });
          } else {
            var isExist = _.find($scope.imageTags, function (img) {
              return img._id == dynamicID;
            });
            if (isExist == undefined) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              });
            }
          }
        });
        if (currentItem != totlaItems) {
          optionsLine['width'] = graphWidth;
          chart.draw(chartdata, optionsLine);
        } else {
          optionsLine['width'] = graphWidth;
          chart.draw(chartdata, optionsLine);
          window.dispatchEvent(new Event('resize'));
          window.addEventListener('resize', function (e) {
            if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
              optionsLine['width'] = graphWidth;
            }
            chart.draw(chartdata, optionsLine);
          });
        }
      } else if (graphType === 'Donut') {
        var optionsDonut = {
          title: title ? title : subTitle ? subTitle : undefined,
          pieHole: 0.4,
          //legend: 'none',
          width: '100%',
          height: '100%',
          chartArea: {
            width: '60%'
          },
          tooltip: {
            isHtml: true,
            textStyle: {
              color: '#0000ff',
              bold: false
            },
            showColorCode: true
          },
          sliceVisibilityThreshold: 0,
          colors: colors ? colors : COMMON_CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
        };
        var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
        //Generating Click event to download PDF
        google.visualization.events.addListener(chart, 'ready', function () {
          var content = '<img src="' + chart.getImageURI() + '">';
          $('#graph-images').append(content);
          if ($scope.imageTags.length === 0) {
            $scope.imageTags.push({
              '_id': dynamicID,
              'image': chart.getImageURI(),
              'width': chart.container.clientWidth,
              'height': chart.container.clientHeight,
              'title': title ? title : subTitle,
              "type": graphType
            });
            scopeObj.setLocalImage({ data: $scope.imageTags });
          } else {
            var isExist = _.find($scope.imageTags, function (img) {
              return img._id == dynamicID;
            });
            if (isExist == undefined) {
              $scope.imageTags.push({
                '_id': dynamicID,
                'image': chart.getImageURI(),
                'width': chart.container.clientWidth,
                'height': chart.container.clientHeight,
                'title': title ? title : subTitle,
                "type": graphType
              });
            }
          }
        });
        if (currentItem != totlaItems) {
          optionsDonut['width'] = graphWidth;
          chart.draw(chartdata, optionsDonut);
        } else {
          optionsDonut['width'] = graphWidth;
          chart.draw(chartdata, optionsDonut);
          window.dispatchEvent(new Event('resize'));
          window.addEventListener('resize', function (e) {
            if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
              optionsDonut['width'] = graphWidth;
            }
            chart.draw(chartdata, optionsDonut);
          });
        }
      }
    }
  };
};
CommonChart.$inject = ["$scope", "$mdMedia", "$mdDialog", "COMMON_CHART_CONSTANTS"];

exports.default = CommonChart;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _single_chart = __webpack_require__(1424);

var _single_chart2 = _interopRequireDefault(_single_chart);

__webpack_require__(1425);

var _singleChartController = __webpack_require__(1426);

var _singleChartController2 = _interopRequireDefault(_singleChartController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var name = 'singlechart';
var _module = angular.module(name, []).component(name, {
    template: _single_chart2.default,
    controllerAs: name,
    bindings: {
        graphData: '<',
        showGraph: '<',
        graphWidth: '<',
        graphHeight: '<',
        chartType: '<',
        title: '<',
        subTitle: '<',
        axis: '<',
        header: '<',
        totalCount: '<',
        count: '<',
        colors: '<',
        setLocalImage: '&setimage'
    },
    scope: {
        setLocalImage: '&setimage'
    },
    controller: _singleChartController2.default
});

_module.constant("CHART_CONSTANTS", {
    DEFAULT_GRAPH_COLORS: ['#3366CC', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#329262', '#5574A6', '#3B3EAC']
});

_module.config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    "ngInject";

    $stateProvider.state('singlechart', {
        parent: 'app',
        url: '/singlechart',

        views: {
            '@': {
                template: _single_chart2.default,
                controller: _singleChartController2.default,
                controllerAs: 'singlechart'
            }
        }
    });
}]);

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports = "<style>div .google-visualization-tooltip>ul>li>span{white-space:nowrap}</style> <div flex layout=row layout-align=\"start center\" layout-wrap style=overflow-x:auto> <div class=md-whiteframe-3dp flex id=singlechart flex style=margin:8px;height:98%></div> </div>";

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SingleChartController =
// @ngInject
["$state", "$rootScope", "$scope", "localStorageService", "CHART_CONSTANTS", function SingleChartController($state, $rootScope, $scope, localStorageService, CHART_CONSTANTS) {
    var _this = this;

    _classCallCheck(this, SingleChartController);

    this.$onInit = function () {
        $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false;
        if (!$rootScope.isLoggedIn) {
            $state.go("login", {}, { reload: true });
        }
        console.log('CHART CHART');
        var graphHeight = _this.graphHeight;
        var graphWidth = _this.graphWidth;
        var graphType = _this.chartType;
        var title = _this.header;
        var subTitle = _this.subTitle;
        var axis = _this.axis;
        $scope.graphdata = _this.graphData;
        var totlaItems = _this.totalCount;
        var currentItem = _this.count;
        var colors = _this.colors;
        var scopeObj = _this;
        $scope.imageTags = [];
        console.log(_this.chartType);
        if ($scope.graphdata === undefined) return false;

        if (_this.chartType === 'Pie' || _this.chartType === 'Donut') {
            google.charts.load('current', {
                'packages': ['corechart']
            });
        } else if (_this.chartType === 'table') {
            google.charts.load('current', {
                'packages': ['table']
            });
        } else if (_this.chartType === 'Histogram' || _this.chartType === 'Line' || _this.chartType === 'Bar') {
            google.charts.load('current', {
                'packages': ['corechart', 'bar']
            });
        }

        google.charts.setOnLoadCallback(drawChart);

        function drawChart() {

            var dynamicID = $scope.getRandomString();
            console.log('dynamicID ' + dynamicID);
            document.getElementById('singlechart').id = dynamicID;
            document.getElementById(dynamicID).style.height = graphHeight + 'px';
            document.getElementById(dynamicID).style.width = graphWidth + 'px';
            var chartdata = undefined;
            chartdata = google.visualization.arrayToDataTable($scope.graphdata);

            var options = {
                title: title,
                bars: 'vertical',
                legend: 'none',
                width: '100%',
                height: '100%',
                chartArea: {
                    width: '80%'
                },
                tooltip: {
                    isHtml: true,
                    textStyle: {
                        color: '#0000ff',
                        bold: false
                    },
                    showColorCode: true
                }
            };
            if (graphType === 'Pie') {
                var optionsPie = {
                    width: '50%',
                    height: '50%',
                    title: title ? title : subTitle ? subTitle : undefined,
                    bars: 'vertical',
                    chartArea: {
                        width: '60%'
                    },
                    is3D: true,
                    tooltip: {
                        isHtml: true,
                        textStyle: {
                            color: '#0000ff',
                            bold: false
                        },
                        showColorCode: true
                    },
                    sliceVisibilityThreshold: 0,
                    colors: colors ? colors : CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
                };
                var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
                //Generating Click event to download PDF
                google.visualization.events.addListener(chart, 'ready', function () {
                    var content = '<img src="' + chart.getImageURI() + '">';
                    // $('#graph-images').append(content);
                    if (document.getElementById('graph-images') != null) {
                        document.getElementById('graph-images').innerHTML = content;
                    }
                    if ($scope.imageTags.length === 0) {
                        $scope.imageTags.push({
                            '_id': dynamicID,
                            'image': chart.getImageURI(),
                            'width': chart.container.clientWidth,
                            'height': chart.container.clientHeight,
                            'title': title ? title : subTitle,
                            "type": graphType
                        });
                        scopeObj.setLocalImage({
                            data: $scope.imageTags
                        });
                    } else {
                        var isExist = _.find($scope.imageTags, function (img) {
                            return img._id == dynamicID;
                        });
                        if (isExist == undefined) {
                            $scope.imageTags.push({
                                '_id': dynamicID,
                                'image': chart.getImageURI(),
                                'width': chart.container.clientWidth,
                                'height': chart.container.clientHeight,
                                'title': title ? title : subTitle,
                                "type": graphType
                            });
                        }
                    }
                });
                if (currentItem != totlaItems) {
                    optionsPie['width'] = graphWidth;
                    chart.draw(chartdata, optionsPie);
                } else {
                    optionsPie['width'] = graphWidth;
                    chart.draw(chartdata, optionsPie);
                    window.dispatchEvent(new Event('resize'));
                    window.addEventListener('resize', function (e) {
                        optionsPie['width'] = graphWidth;
                        chart.draw(chartdata, optionsPie);
                    });
                }
            } else if (graphType === 'Bar') {
                var axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : [];
                var optionsBar = {
                    title: title ? title : subTitle ? subTitle : undefined,
                    hAxis: {
                        title: axisTitle[0],
                        titleTextStyle: {
                            color: 'black',
                            bold: true,
                            italic: false
                        },
                        textStyle: {
                            fontSize: 10
                        }
                    },
                    vAxis: {
                        title: axisTitle[1].replace(/\(.*\)/, ''),
                        titleTextStyle: {
                            color: 'black',
                            bold: true,
                            italic: false
                        }
                    },
                    legend: {
                        position: 'top',
                        alignment: 'start'
                    },
                    width: '100%',
                    height: '100%',
                    chartArea: {
                        width: '70%'
                    },
                    tooltip: {
                        isHtml: true,
                        textStyle: {
                            color: '#0000ff',
                            bold: false
                        },
                        showColorCode: true
                    },
                    animation: {
                        duration: 1000,
                        easing: 'out'
                    },
                    bars: 'vertical',
                    axes: {
                        y: {
                            all: {
                                range: {
                                    min: 0.010
                                }
                            }
                        }
                    },
                    colors: colors ? colors : CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
                };
                var chart = new google.visualization.ColumnChart(document.getElementById(dynamicID));
                //Generating Click event to download PDF
                google.visualization.events.addListener(chart, 'ready', function () {
                    var content = '<img src="' + chart.getImageURI() + '">';
                    // $('#graph-images').append(content);
                    if (document.getElementById('graph-images') != null) {
                        document.getElementById('graph-images').innerHTML = content;
                    }
                    if ($scope.imageTags.length === 0) {
                        $scope.imageTags.push({
                            '_id': dynamicID,
                            'image': chart.getImageURI(),
                            'width': chart.container.clientWidth,
                            'height': chart.container.clientHeight,
                            'title': title ? title : subTitle,
                            "type": graphType
                        });
                        scopeObj.setLocalImage({
                            data: $scope.imageTags
                        });
                    } else {
                        var isExist = _.find($scope.imageTags, function (img) {
                            return img._id == dynamicID;
                        });
                        if (isExist == undefined) {
                            $scope.imageTags.push({
                                '_id': dynamicID,
                                'image': chart.getImageURI(),
                                'width': chart.container.clientWidth,
                                'height': chart.container.clientHeight,
                                'title': title ? title : subTitle,
                                "type": graphType
                            });
                        }
                    }
                });
                if (currentItem != totlaItems) {
                    optionsBar['width'] = graphWidth;
                    chart.draw(chartdata, optionsBar);
                } else {
                    optionsBar['width'] = graphWidth;
                    chart.draw(chartdata, optionsBar);
                    window.dispatchEvent(new Event('resize'));
                    window.addEventListener('resize', function (e) {
                        if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                            optionsBar['width'] = graphWidth; //e.currentTarget.screen.availWidth
                        }
                        chart.draw(chartdata, optionsBar);
                    });
                }
            } else if (graphType === 'table') {
                var chart = new google.visualization.Table(document.getElementById(dynamicID));
                chart.draw(chartdata, {
                    showRowNumber: true,
                    width: '100%',
                    height: '100%',
                    title: title
                });
            } else if (graphType === 'Histogram') {
                var optionsHist = {
                    title: title,
                    width: '100%',
                    height: '100%',
                    chartArea: {
                        width: '80%'
                    },
                    hAxis: {
                        minValue: 0
                    },
                    vAxis: {},
                    legend: 'none',
                    bar: {
                        groupWidth: '10'
                    },
                    tooltip: {
                        isHtml: true,
                        textStyle: {
                            color: '#0000ff',
                            bold: false
                        },
                        showColorCode: true
                    }
                };
                var chart = new google.visualization.Histogram(document.getElementById(dynamicID));
                if (currentItem != totlaItems) {
                    optionsHist['width'] = graphWidth;
                    chart.draw(chartdata, optionsHist);
                } else {
                    optionsHist['width'] = graphWidth;
                    chart.draw(chartdata, optionsHist);
                    window.dispatchEvent(new Event('resize'));
                    window.addEventListener('resize', function (e) {
                        if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                            optionsHist['width'] = graphWidth; //e.currentTarget.screen.availWidth
                        }
                        chart.draw(chartdata, optionsHist);
                    });
                }
            } else if (graphType === 'Line') {
                var _axisTitle = title ? title.split('vs') : axis ? axis.split('vs') : [];
                var optionsLine = {
                    title: title ? title : subTitle ? subTitle : undefined,
                    hAxis: {
                        minValue: 0,
                        title: _axisTitle[0],
                        titleTextStyle: {
                            color: 'black',
                            bold: true,
                            italic: false
                        }
                    },
                    vAxis: {
                        title: _axisTitle[1].replace(/\(.*\)/, ''),
                        titleTextStyle: {
                            color: 'black',
                            bold: true,
                            italic: false
                        }
                    },
                    legend: {
                        position: 'top',
                        alignment: 'start'
                    },
                    width: '100%',
                    height: '100%',
                    chartArea: {
                        width: '70%'
                    },
                    tooltip: {
                        isHtml: true,
                        textStyle: {
                            color: '#0000ff',
                            bold: false
                        },
                        showColorCode: true
                    },
                    colors: colors ? colors : CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
                };
                var chart = new google.visualization.LineChart(document.getElementById(dynamicID));
                //Generating Click event to download PDF
                google.visualization.events.addListener(chart, 'ready', function () {
                    var content = '<img src="' + chart.getImageURI() + '">';
                    // $('#graph-images').append(content);
                    if (document.getElementById('graph-images') != null) {
                        document.getElementById('graph-images').innerHTML = content;
                    }
                    if ($scope.imageTags.length === 0) {
                        $scope.imageTags.push({
                            '_id': dynamicID,
                            'image': chart.getImageURI(),
                            'width': chart.container.clientWidth,
                            'height': chart.container.clientHeight,
                            'title': title ? title : subTitle,
                            "type": graphType
                        });
                        scopeObj.setLocalImage({
                            data: $scope.imageTags
                        });
                    } else {
                        var isExist = _.find($scope.imageTags, function (img) {
                            return img._id == dynamicID;
                        });
                        if (isExist == undefined) {
                            $scope.imageTags.push({
                                '_id': dynamicID,
                                'image': chart.getImageURI(),
                                'width': chart.container.clientWidth,
                                'height': chart.container.clientHeight,
                                'title': title ? title : subTitle,
                                "type": graphType
                            });
                        }
                    }
                });
                if (currentItem != totlaItems) {
                    optionsLine['width'] = graphWidth;
                    chart.draw(chartdata, optionsLine);
                } else {
                    optionsLine['width'] = graphWidth;
                    chart.draw(chartdata, optionsLine);
                    window.dispatchEvent(new Event('resize'));
                    window.addEventListener('resize', function (e) {
                        if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                            optionsLine['width'] = graphWidth;
                        }
                        chart.draw(chartdata, optionsLine);
                    });
                }
            } else if (graphType === 'Donut') {
                var optionsDonut = {
                    title: title ? title : subTitle ? subTitle : undefined,
                    pieHole: 0.4,
                    width: '100%',
                    height: '100%',
                    chartArea: {
                        width: '60%'
                    },
                    tooltip: {
                        isHtml: true,
                        textStyle: {
                            color: '#0000ff',
                            bold: false
                        },
                        showColorCode: true
                    },
                    sliceVisibilityThreshold: 0,
                    colors: colors ? colors : CHART_CONSTANTS.DEFAULT_GRAPH_COLORS
                };
                var chart = new google.visualization.PieChart(document.getElementById(dynamicID));
                //Generating Click event to download PDF
                google.visualization.events.addListener(chart, 'ready', function () {
                    var content = '<img src="' + chart.getImageURI() + '">';
                    // $('#graph-images').append(content);
                    if (document.getElementById('graph-images') != null) {
                        document.getElementById('graph-images').innerHTML = content;
                    }
                    if ($scope.imageTags.length === 0) {
                        $scope.imageTags.push({
                            '_id': dynamicID,
                            'image': chart.getImageURI(),
                            'width': chart.container.clientWidth,
                            'height': chart.container.clientHeight,
                            'title': title ? title : subTitle,
                            "type": graphType
                        });
                        scopeObj.setLocalImage({
                            data: $scope.imageTags
                        });
                    } else {
                        var isExist = _.find($scope.imageTags, function (img) {
                            return img._id == dynamicID;
                        });
                        if (isExist == undefined) {
                            $scope.imageTags.push({
                                '_id': dynamicID,
                                'image': chart.getImageURI(),
                                'width': chart.container.clientWidth,
                                'height': chart.container.clientHeight,
                                'title': title ? title : subTitle,
                                "type": graphType
                            });
                        }
                    }
                });
                if (currentItem != totlaItems) {
                    optionsDonut['width'] = graphWidth;
                    chart.draw(chartdata, optionsDonut);
                } else {
                    optionsDonut['width'] = graphWidth;
                    chart.draw(chartdata, optionsDonut);
                    window.dispatchEvent(new Event('resize'));
                    window.addEventListener('resize', function (e) {
                        if (e.currentTarget && e.currentTarget.screen && e.currentTarget.screen.availWidth) {
                            optionsDonut['width'] = graphWidth; //e.currentTarget.screen.availWidth
                        }
                        chart.draw(chartdata, optionsDonut);
                    });
                }
            }
        }
    };

    $scope.getRandomString = function () {
        var letters = '0123456789ABCDEF';
        var chartId = 'id';
        for (var i = 0; i < 6; i++) {
            chartId += letters[Math.floor(Math.random() * 16)];
        }
        return chartId;
    };
}];

exports.default = SingleChartController;

/***/ }),
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ })
],[797]);


// WEBPACK FOOTER //
// libs/app.bundle.js